import { InjectionToken, Injectable, Injector, Optional, Inject, ɵɵdefineInjectable, ɵɵinject, INJECTOR, Component, Input, EventEmitter, Directive, Output, ViewContainerRef, ViewEncapsulation, ComponentFactoryResolver, ChangeDetectorRef, ViewChild, resolveForwardRef, forwardRef, ContentChild, TemplateRef, NgModule, APP_INITIALIZER, ElementRef, Renderer2, HostBinding, HostListener, ChangeDetectionStrategy, ApplicationRef, Host, SkipSelf, NgZone, Pipe } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterModule, NavigationStart } from '@angular/router';
import { HttpHeaders, HttpClient, HTTP_INTERCEPTORS, HttpClientModule, HttpEventType } from '@angular/common/http';
import { Observable, of, combineLatest, BehaviorSubject, Subject, throwError, forkJoin, merge, ReplaySubject, noop } from 'rxjs';
import { tap, filter, map, delay, catchError, timeout, distinctUntilChanged, finalize, share, mergeMap, debounceTime, flatMap, takeUntil } from 'rxjs/operators';
import { omit, isObject as isObject$1, isUndefined, isNull, isArray, findWhere, isBoolean, defaults, assign, find, filter as filter$1, where, sortBy } from 'underscore';
import * as moment_ from 'moment';
import { saveAs } from 'file-saver';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators, NG_VALUE_ACCESSOR, FormsModule, ControlContainer, NgControl, ReactiveFormsModule } from '@angular/forms';
import { ContextMenuModule } from 'primeng/contextmenu';
import { TreeDragDropService, MessageService } from 'primeng/api';
import { moveItemInArray, transferArrayItem, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import 'reflect-metadata';
import { CommonModule, DOCUMENT, DatePipe } from '@angular/common';
import { TabViewModule, TabView } from 'primeng/tabview';
import { ListboxModule } from 'primeng/listbox';
import { TreeModule } from 'primeng/tree';
import { AccordionModule } from 'primeng/accordion';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MenuModule } from 'primeng/menu';
import { DragDropModule as DragDropModule$1 } from 'primeng/dragdrop';
import { LogLevel, UserAgentApplication, Logger } from 'msal';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { NgbPopoverConfig, NgbDatepicker, NgbPopover, NgbDate, NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ToastModule } from 'primeng/toast';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CalendarModule } from 'primeng/calendar';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DropdownModule } from 'primeng/dropdown';
import { OrderListModule, OrderList } from 'primeng/orderlist';
import { DialogModule } from 'primeng/dialog';
import { ProgressBarModule } from 'primeng/progressbar';
import { DomSanitizer, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { _isNumberValue } from '@angular/cdk/coercion';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SplitterModule } from 'primeng/splitter';
import { InputTextModule } from 'primeng/inputtext';
import { CaptchaModule } from 'primeng/captcha';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AppAsideModule, AppBreadcrumbModule, AppHeaderModule, AppFooterModule, AppSidebarModule } from '@coreui/angular';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { lyl, StyleRenderer, LyTheme2, LY_THEME_NAME, LY_THEME, LyHammerGestureConfig } from '@alyle/ui';
import { LyImageCropper, LyImageCropperModule } from '@alyle/ui/image-cropper';
import { Platform } from '@angular/cdk/platform';
import { SliderModule } from 'primeng/slider';
import { MinimaLight, MinimaDark } from '@alyle/ui/themes/minima';
import { LySliderModule } from '@alyle/ui/slider';
import { GalleriaModule } from 'primeng/galleria';
import { AgGridModule } from 'ag-grid-angular';

// Values are from the table devware.UiConfigTypeId
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from 'primeng/splitter';
import * as ɵngcc6 from 'primeng/api';
import * as ɵngcc7 from 'primeng/contextmenu';
import * as ɵngcc8 from 'primeng/tree';
import * as ɵngcc9 from 'primeng/tabview';
import * as ɵngcc10 from 'primeng/inputswitch';
import * as ɵngcc11 from 'primeng/accordion';
import * as ɵngcc12 from 'primeng/multiselect';
import * as ɵngcc13 from 'primeng/toast';
import * as ɵngcc14 from 'primeng/progressbar';
import * as ɵngcc15 from 'primeng/dialog';
import * as ɵngcc16 from 'ngx-bootstrap/dropdown';
import * as ɵngcc17 from '@angular/platform-browser';
import * as ɵngcc18 from 'ngx-infinite-scroll';
import * as ɵngcc19 from 'primeng/calendar';
import * as ɵngcc20 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc21 from 'primeng/orderlist';
import * as ɵngcc22 from 'primeng/dropdown';
import * as ɵngcc23 from 'primeng/captcha';
import * as ɵngcc24 from 'primeng/colorpicker';
import * as ɵngcc25 from '@coreui/angular';
import * as ɵngcc26 from 'primeng/button';
import * as ɵngcc27 from 'primeng/menu';
import * as ɵngcc28 from '@angular/cdk/drag-drop';
import * as ɵngcc29 from 'primeng/listbox';
import * as ɵngcc30 from 'primeng/autocomplete';
import * as ɵngcc31 from 'primeng/overlaypanel';
import * as ɵngcc32 from 'primeng/radiobutton';
import * as ɵngcc33 from '@alyle/ui';
import * as ɵngcc34 from '@angular/cdk/platform';
import * as ɵngcc35 from '@alyle/ui/image-cropper';
import * as ɵngcc36 from 'primeng/slider';
import * as ɵngcc37 from 'primeng/galleria';
import * as ɵngcc38 from 'ag-grid-angular';

function DwDefaultGridPage_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dw-content-manager", 0);
    ɵngcc0.ɵɵelementStart(1, "h1");
    ɵngcc0.ɵɵelement(2, "dw-content", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "dw-content", 2);
    ɵngcc0.ɵɵelement(4, "dw-content-component", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelement(6, "dw-meta-data-grid", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("configKey", ctx_r0.contentConfigKey)("item", ctx_r0.item);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("controlType", ctx_r0.textboxControlType);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("id", ctx_r0.configKeyPart);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", ctx_r0.item)("configKeyPart", ctx_r0.configKeyPart)("preferences", ctx_r0.gridPreferences);
} }
const _c0 = ["cmSection"];
function DwMetadataSectionConfigComponent_div_0_ng_template_3_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("contextmenu", function DwMetadataSectionConfigComponent_div_0_ng_template_3_ng_template_2_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const node_r6 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.nodeMenu($event, node_r6); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r6.label, " ");
} }
function DwMetadataSectionConfigComponent_div_0_ng_template_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("contextmenu", function DwMetadataSectionConfigComponent_div_0_ng_template_3_ng_template_3_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const node_r9 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.nodeMenu($event, node_r9); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r9.label, " - Other ");
} }
const _c1 = function () { return { "height": "600px", "width": "100%", "max-height": "600px", "overflow": "auto" }; };
function DwMetadataSectionConfigComponent_div_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "p-tree", 8);
    ɵngcc0.ɵɵlistener("selectionChange", function DwMetadataSectionConfigComponent_div_0_ng_template_3_Template_p_tree_selectionChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.setCurrentSection($event); })("onNodeDrop", function DwMetadataSectionConfigComponent_div_0_ng_template_3_Template_p_tree_onNodeDrop_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.nodeDropped($event); })("onNodeExpand", function DwMetadataSectionConfigComponent_div_0_ng_template_3_Template_p_tree_onNodeExpand_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.nodeExpand($event); });
    ɵngcc0.ɵɵtemplate(2, DwMetadataSectionConfigComponent_div_0_ng_template_3_ng_template_2_Template, 2, 1, "ng-template", 9);
    ɵngcc0.ɵɵtemplate(3, DwMetadataSectionConfigComponent_div_0_ng_template_3_ng_template_3_Template, 2, 1, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(5, _c1));
    ɵngcc0.ɵɵproperty("value", ctx_r1.dwSectionConfigStateService.state.sectionTree)("selection", ctx_r1.dwSectionConfigStateService.state.currentSectionNode)("validateDrop", true);
} }
function DwMetadataSectionConfigComponent_div_0_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "dw-config-panel-host");
    ɵngcc0.ɵɵelementEnd();
} }
const _c2 = function () { return { "height": "605px" }; };
const _c3 = function () { return [30, 70]; };
function DwMetadataSectionConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "p-splitter", 3);
    ɵngcc0.ɵɵtemplate(3, DwMetadataSectionConfigComponent_div_0_ng_template_3_Template, 4, 6, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(4, DwMetadataSectionConfigComponent_div_0_ng_template_4_Template, 2, 0, "ng-template", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "p-contextMenu", 5, 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(4, _c2));
    ɵngcc0.ɵɵproperty("panelSizes", ɵngcc0.ɵɵpureFunction0(5, _c3));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("model", ctx_r0.cmSectionItems);
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Use Default Buttons");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelement(4, "p-inputSwitch", 11);
    ɵngcc0.ɵɵelementEnd();
} }
const _c4 = function () { return { standalone: true }; };
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "dw-pills", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormWorkflowConfigComponent_p_tabView_2_ng_container_9_Template_dw_pills_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.currentFormMode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("items", ctx_r2.formModes)("ngModel", ctx_r2.currentFormMode)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c4));
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r12.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r12.Display, " ");
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r13.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r13.Display, " ");
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r14.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r14.Display, " ");
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r15.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r15.Display, " ");
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 25);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r16 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r16.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r16.Display, " ");
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Workflow Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 14);
    ɵngcc0.ɵɵelement(6, "option", 15);
    ɵngcc0.ɵɵtemplate(7, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_7_Template, 2, 2, "option", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 17);
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Button Display Attr");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(12, "br");
    ɵngcc0.ɵɵelementStart(13, "select", 18);
    ɵngcc0.ɵɵelement(14, "option", 15);
    ɵngcc0.ɵɵtemplate(15, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_15_Template, 2, 2, "option", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 10);
    ɵngcc0.ɵɵelementStart(17, "label");
    ɵngcc0.ɵɵtext(18, "Button Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(19, "br");
    ɵngcc0.ɵɵelementStart(20, "select", 19);
    ɵngcc0.ɵɵelement(21, "option", 15);
    ɵngcc0.ɵɵtemplate(22, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_22_Template, 2, 2, "option", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 17);
    ɵngcc0.ɵɵelementStart(24, "div", 10);
    ɵngcc0.ɵɵelementStart(25, "label");
    ɵngcc0.ɵɵtext(26, "Tool Tip Attr");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(27, "br");
    ɵngcc0.ɵɵelementStart(28, "select", 20);
    ɵngcc0.ɵɵelement(29, "option", 15);
    ɵngcc0.ɵɵtemplate(30, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_30_Template, 2, 2, "option", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 10);
    ɵngcc0.ɵɵelementStart(32, "label");
    ɵngcc0.ɵɵtext(33, "Require Validation Attr");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "select", 21);
    ɵngcc0.ɵɵelement(35, "option", 15);
    ɵngcc0.ɵɵtemplate(36, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_option_36_Template, 2, 2, "option", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(37, "div", 4);
    ɵngcc0.ɵɵelementStart(38, "div", 10);
    ɵngcc0.ɵɵelementStart(39, "label");
    ɵngcc0.ɵɵtext(40, "Use Alternate Action");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(41, "br");
    ɵngcc0.ɵɵelement(42, "p-inputSwitch", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "div", 17);
    ɵngcc0.ɵɵelementStart(44, "div", 10);
    ɵngcc0.ɵɵelementStart(45, "label");
    ɵngcc0.ɵɵtext(46, "Override Current Status Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(47, "br");
    ɵngcc0.ɵɵelement(48, "p-inputSwitch", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(49, "div", 10);
    ɵngcc0.ɵɵelementStart(50, "label");
    ɵngcc0.ɵɵtext(51, "Override Current Status Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(52, "br");
    ɵngcc0.ɵɵelement(53, "input", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.itemAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r3.enableWorkflowFC == null ? null : ctx_r3.enableWorkflowFC.value) || !ctx_r3.workflowAttrNameFC.value);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.lookupAttributes);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.lookupAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r3.enableWorkflowFC == null ? null : ctx_r3.enableWorkflowFC.value) || !ctx_r3.workflowAttrNameFC.value);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.lookupAttributes);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.lookupAttributes);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r3.enableWorkflowFC == null ? null : ctx_r3.enableWorkflowFC.value) || !ctx_r3.workflowAttrNameFC.value);
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_11_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 26);
    ɵngcc0.ɵɵelementStart(1, "button", 27);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_11_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.resetTest(); });
    ɵngcc0.ɵɵtext(2, "Reset Test");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 10);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Current Status");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "br");
    ɵngcc0.ɵɵelementStart(8, "dw-select-lookup", 28);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_11_Template_dw_select_lookup_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.changeInitialValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "dw-button-bar", 29);
    ɵngcc0.ɵɵelementStart(10, "dw-workflow-lookup-buttons", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_11_Template_dw_workflow_lookup_buttons_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.changeInitialValue($event); })("buttonClick", function DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_11_Template_dw_workflow_lookup_buttons_buttonClick_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.workflowButtonClick($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r4.lookupId)("ngModel", ctx_r4.initialStatusValue)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(9, _c4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r4.handlingWorkflowClick);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r4.lookupId)("ngModel", ctx_r4.initialStatusValue)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(10, _c4))("workflowPreferences", ctx_r4.formGroup.value.workflowPreferences);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.initialStatusValue, " ");
} }
function DwMetadataFormWorkflowConfigComponent_p_tabView_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabView");
    ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Enable Workflow");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵelement(7, "p-inputSwitch", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwMetadataFormWorkflowConfigComponent_p_tabView_2_div_8_Template, 5, 0, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwMetadataFormWorkflowConfigComponent_p_tabView_2_ng_container_9_Template, 4, 4, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_10_Template, 54, 8, "p-tabPanel", 8);
    ɵngcc0.ɵɵtemplate(11, DwMetadataFormWorkflowConfigComponent_p_tabView_2_p_tabPanel_11_Template, 12, 11, "p-tabPanel", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.enableWorkflowFC == null ? null : ctx_r0.enableWorkflowFC.value));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.formGroup == null ? null : ctx_r0.formGroup.useButtonDefaults == null ? null : ctx_r0.formGroup.useButtonDefaults.value));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.enableWorkflowFC == null ? null : ctx_r0.enableWorkflowFC.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookupId);
} }
function DwMetadataFormConfigWidgetComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " No preferences loaded\n");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetadataFormConfigWidgetComponent_div_1_option_37_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r5.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.display, " ");
} }
function DwMetadataFormConfigWidgetComponent_div_1_option_61_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataSource_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", dataSource_r6.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataSource_r6.display, " ");
} }
function DwMetadataFormConfigWidgetComponent_div_1_div_67_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Ignore Fields");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetadataFormConfigWidgetComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3");
    ɵngcc0.ɵɵtext(2, "Form Preferences");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "form", 1);
    ɵngcc0.ɵɵlistener("ngSubmit", function DwMetadataFormConfigWidgetComponent_div_1_Template_form_ngSubmit_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onSubmit(); });
    ɵngcc0.ɵɵelementStart(4, "p-accordion");
    ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 2);
    ɵngcc0.ɵɵelementStart(6, "div", 3);
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Read Only");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div");
    ɵngcc0.ɵɵelement(11, "p-inputSwitch", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 3);
    ɵngcc0.ɵɵelementStart(13, "div", 4);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Use Long Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div");
    ɵngcc0.ɵɵelement(17, "p-inputSwitch", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 3);
    ɵngcc0.ɵɵelementStart(19, "div", 4);
    ɵngcc0.ɵɵelementStart(20, "label");
    ɵngcc0.ɵɵtext(21, "Load Display Values");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div");
    ɵngcc0.ɵɵelement(23, "p-inputSwitch", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 3);
    ɵngcc0.ɵɵelementStart(25, "div", 4);
    ɵngcc0.ɵɵelementStart(26, "label");
    ɵngcc0.ɵɵtext(27, "Validation Summary");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "div");
    ɵngcc0.ɵɵelement(29, "p-inputSwitch", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "div", 3);
    ɵngcc0.ɵɵelementStart(31, "div", 9);
    ɵngcc0.ɵɵelementStart(32, "label");
    ɵngcc0.ɵɵtext(33, "Message Location");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "select", 10);
    ɵngcc0.ɵɵelementStart(35, "option", 11);
    ɵngcc0.ɵɵtext(36, "Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(37, DwMetadataFormConfigWidgetComponent_div_1_option_37_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "div", 3);
    ɵngcc0.ɵɵelementStart(39, "div", 4);
    ɵngcc0.ɵɵelementStart(40, "label");
    ɵngcc0.ɵɵtext(41, "Suppress Unsaved changes message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "div");
    ɵngcc0.ɵɵelement(43, "p-inputSwitch", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(44, "p-accordionTab", 14);
    ɵngcc0.ɵɵelementStart(45, "div", 3);
    ɵngcc0.ɵɵelementStart(46, "div", 9);
    ɵngcc0.ɵɵelementStart(47, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFormConfigWidgetComponent_div_1_Template_button_click_47_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.configureSection(); });
    ɵngcc0.ɵɵtext(48, " Configure Sections ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(49, "div", 3);
    ɵngcc0.ɵɵelementStart(50, "div", 9);
    ɵngcc0.ɵɵelementStart(51, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFormConfigWidgetComponent_div_1_Template_button_click_51_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.editMetaDataItem(); });
    ɵngcc0.ɵɵtext(52, "Edit Meta Data Item");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(53, "p-accordionTab", 16);
    ɵngcc0.ɵɵelementStart(54, "div", 3);
    ɵngcc0.ɵɵelementStart(55, "div", 9);
    ɵngcc0.ɵɵelementStart(56, "label");
    ɵngcc0.ɵɵtext(57, "Data Source");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(58, "select", 17);
    ɵngcc0.ɵɵelementStart(59, "option", 18);
    ɵngcc0.ɵɵtext(60, "Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(61, DwMetadataFormConfigWidgetComponent_div_1_option_61_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(62, "div", 3);
    ɵngcc0.ɵɵelementStart(63, "div", 9);
    ɵngcc0.ɵɵelementStart(64, "label");
    ɵngcc0.ɵɵtext(65, "Context Data");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(66, "dw-context-def-multi-select", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(67, DwMetadataFormConfigWidgetComponent_div_1_div_67_Template, 5, 0, "div", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.configForm);
    ɵngcc0.ɵɵadvance(34);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.messageLocations);
    ɵngcc0.ɵɵadvance(22);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.dataSources);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("itemName", ctx_r1.formPreferencesHierarchy.item)("requiredContextNames", ctx_r1.formPreferences.requiredContextNames);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", false);
} }
function DwFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.lastError, " ");
} }
function DwFormComponent_ng_template_4_Template(rf, ctx) { }
function DwFormComponent_dw_button_bar_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(1, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwFormComponent_dw_button_bar_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onSubmit(); });
    ɵngcc0.ɵɵtext(2, "Saves");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 6);
    ɵngcc0.ɵɵlistener("click", function DwFormComponent_dw_button_bar_5_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.cancel(); });
    ɵngcc0.ɵɵtext(4, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c5 = ["*"];
function DwRouteActionInternalLinkConfigComponent_div_0_option_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r4.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r4.AttributeDisplay, " ");
} }
function DwRouteActionInternalLinkConfigComponent_div_0_ng_container_28_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "addSpaces");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "dw-expression-reference-control", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRouteActionInternalLinkConfigComponent_div_0_ng_container_28_div_3_Template_dw_expression_reference_control_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const paramName_r6 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return (ctx_r8.additionalParams[paramName_r6] = $event); })("ngModelChange", function DwRouteActionInternalLinkConfigComponent_div_0_ng_container_28_div_3_Template_dw_expression_reference_control_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.updateAdditionalParams(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const paramName_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("Param ", i_r7 + 1, ": ", ɵngcc0.ɵɵpipeBind1(4, 7, paramName_r6), "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.additionalParams[paramName_r6])("ngModelOptions", ɵngcc0.ɵɵpureFunction0(9, _c4))("contextNames", ctx_r5.configContext == null ? null : ctx_r5.configContext.contextNames)("item", ctx_r5.configContext == null ? null : ctx_r5.configContext.itemName)("queryMeaning", ctx_r5.configContext == null ? null : ctx_r5.configContext.metaDataQueryMeaning);
} }
function DwRouteActionInternalLinkConfigComponent_div_0_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwRouteActionInternalLinkConfigComponent_div_0_ng_container_28_div_3_Template, 6, 10, "div", 20);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r2.menuParams == null ? null : ctx_r2.menuParams.length, " Required Parameters");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.menuParams);
} }
function DwRouteActionInternalLinkConfigComponent_div_0_div_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Pass Data");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "p-multiSelect", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("options", ctx_r3.attributes)("filter", true);
} }
function DwRouteActionInternalLinkConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Url");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Internal Url");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "input", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 6);
    ɵngcc0.ɵɵelementStart(13, "div", 7);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(16, "dw-select-route", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 6);
    ɵngcc0.ɵɵelementStart(18, "div", 7);
    ɵngcc0.ɵɵelementStart(19, "label");
    ɵngcc0.ɵɵtext(20, "Selected View Key");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(21, "input", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 6);
    ɵngcc0.ɵɵelementStart(23, "div", 7);
    ɵngcc0.ɵɵelementStart(24, "label");
    ɵngcc0.ɵɵtext(25, "Key Value Param");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "select", 11);
    ɵngcc0.ɵɵtemplate(27, DwRouteActionInternalLinkConfigComponent_div_0_option_27_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(28, DwRouteActionInternalLinkConfigComponent_div_0_ng_container_28_Template, 4, 2, "ng-container", 13);
    ɵngcc0.ɵɵtemplate(29, DwRouteActionInternalLinkConfigComponent_div_0_div_29_Template, 5, 2, "div", 14);
    ɵngcc0.ɵɵelementStart(30, "div", 2);
    ɵngcc0.ɵɵelementStart(31, "div", 7);
    ɵngcc0.ɵɵelementStart(32, "label");
    ɵngcc0.ɵɵtext(33, "Additional Query String ");
    ɵngcc0.ɵɵelement(34, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(35, "input", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 2);
    ɵngcc0.ɵɵelementStart(37, "div", 3);
    ɵngcc0.ɵɵelementStart(38, "label");
    ɵngcc0.ɵɵtext(39, "Open in New Window");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "div", 4);
    ɵngcc0.ɵɵelement(41, "p-inputSwitch", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "div", 6);
    ɵngcc0.ɵɵelementStart(43, "div", 7);
    ɵngcc0.ɵɵelementStart(44, "label");
    ɵngcc0.ɵɵtext(45, "New Window Target");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(46, "input", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.useUrl));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.useUrl);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showViewKey);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showKeyValue || !ctx_r0.attributes);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.attributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showAdditionalParams && ctx_r0.additionalParams);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.attributes);
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.openInNewWindow));
} }
function DwMetadataFormDebugWidgetComponent_p_accordionTab_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 3);
    ɵngcc0.ɵɵelement(1, "dw-ui-info-display", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r0.currentSectionUiConfig)("data", ctx_r0.currentSectionData);
} }
const _c6 = ["divForm"];
const _c7 = ["printMdForm"];
const _c8 = ["divRootHidden"];
function DwMetaDataFormComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.configError, "\n");
} }
function DwMetaDataFormComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h1");
    ɵngcc0.ɵɵelement(2, "i", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.formConfig.accessErrorMessage, "");
} }
function DwMetaDataFormComponent_div_5_dw_message_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-message", 16);
    ɵngcc0.ɵɵlistener("messageChange", function DwMetaDataFormComponent_div_5_dw_message_1_Template_dw_message_messageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.formMessage = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("message", ctx_r6.formMessage);
} }
function DwMetaDataFormComponent_div_5_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17, 18);
    ɵngcc0.ɵɵelement(2, "dw-dynamic-section", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r9.dwFormContext.loadDataComplete);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r9.formConfig)("context", ctx_r9.context)("sectionConfig", ctx_r9.formConfig == null ? null : ctx_r9.formConfig.section)("formGroup", ctx_r9.formGroup)("submitted", ctx_r9.submitted);
} }
function DwMetaDataFormComponent_div_5_dw_message_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-message", 20);
    ɵngcc0.ɵɵlistener("messageChange", function DwMetaDataFormComponent_div_5_dw_message_8_Template_dw_message_messageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.formMessage = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("message", ctx_r10.formMessage);
} }
const _c9 = function (a0, a1) { return { "dw-form-print": a0, "dw-form-print-hide-buttons": a1 }; };
function DwMetaDataFormComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwMetaDataFormComponent_div_5_dw_message_1_Template, 1, 1, "dw-message", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10, 11);
    ɵngcc0.ɵɵelementStart(4, "dw-form", 12, 13);
    ɵngcc0.ɵɵlistener("formReady", function DwMetaDataFormComponent_div_5_Template_dw_form_formReady_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.formReady($event); })("formInvalid", function DwMetaDataFormComponent_div_5_Template_dw_form_formInvalid_4_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.setFormAsSubmitted(); })("dataLoaded", function DwMetaDataFormComponent_div_5_Template_dw_form_dataLoaded_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.initialDataLoad($event); })("dataChanged", function DwMetaDataFormComponent_div_5_Template_dw_form_dataChanged_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.formDataChanged($event, false, true); });
    ɵngcc0.ɵɵtemplate(6, DwMetaDataFormComponent_div_5_div_6_Template, 3, 6, "div", 14);
    ɵngcc0.ɵɵprojection(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwMetaDataFormComponent_div_5_dw_message_8_Template, 1, 1, "dw-message", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.formMessage && (ctx_r3.formConfig == null ? null : ctx_r3.formConfig.messagingConfig == null ? null : ctx_r3.formConfig.messagingConfig.showTopMessages));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c9, ctx_r3.formMode === "print", ctx_r3.showButtons == false));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("data", ctx_r3.dataSource)("context", ctx_r3.context)("addContext", ctx_r3.addContext)("keyValue", ctx_r3.keyValue);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.formSetupComplete && ctx_r3.context && ctx_r3.securityChecksComplete);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.formMessage && (ctx_r3.formConfig == null ? null : ctx_r3.formConfig.messagingConfig == null ? null : ctx_r3.formConfig.messagingConfig.showBottomMessages));
} }
function DwMetaDataFormComponent_p_contextMenu_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-contextMenu", 21);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵproperty("target", _r1)("model", ctx_r4.contextMenu);
} }
function DwMetaDataFormComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelement(1, "dw-meta-data-form", 23, 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", ctx_r5.item)("overrideData", !ctx_r5.reloadPrintData)("keyValue", ctx_r5.keyValue)("data", ctx_r5.data)("preferences", ctx_r5.formPreferences)("formMode", ctx_r5.printFormMode)("configKeyPart", ctx_r5.currentPrintConfigKey);
} }
function DwDefaultFormPage_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-content-manager", 2);
    ɵngcc0.ɵɵelementStart(2, "h1");
    ɵngcc0.ɵɵelement(3, "dw-content", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-content", 4);
    ɵngcc0.ɵɵelement(5, "dw-content-component", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "dw-meta-data-form", 6, 7);
    ɵngcc0.ɵɵlistener("returnToPrevious", function DwDefaultFormPage_ng_template_1_ng_container_0_Template_dw_meta_data_form_returnToPrevious_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.returnToPrevious($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configKey", ctx_r1.contentConfigKey)("item", ctx_r1.item);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("controlType", ctx_r1.textboxControlType);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("item", ctx_r1.item)("overrideData", ctx_r1.overrideData)("data", ctx_r1.data)("addContext", ctx_r1.addContext)("keyValue", ctx_r1.keyValue)("configKeyPart", ctx_r1.configKeyPart)("printConfigKeyPart", ctx_r1.printConfigKeyPart)("preferences", ctx_r1.formPreferences)("handleRedirect", !ctx_r1.isModal)("showButtons", !ctx_r1.isModal)("isModal", ctx_r1.isModal)("formMode", ctx_r1.formMode);
} }
function DwDefaultFormPage_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwDefaultFormPage_ng_template_1_ng_container_0_Template, 8, 15, "ng-container", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showContent && !ctx_r0.securityChanging);
} }
function DefaultMenuPageComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "dw-content-manager", 1);
    ɵngcc0.ɵɵelementStart(2, "h1");
    ɵngcc0.ɵɵelement(3, "dw-content", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-content", 3);
    ɵngcc0.ɵɵelement(5, "dw-content-component", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configKey", ctx_r0.configKey);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("controlType", ctx_r0.textboxControlType);
} }
function DwPageMenu_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwPageMenu_ng_template_1_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-menu-template", 9);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subMenu_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menu", subMenu_r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("menu-icon-large ", subMenu_r11 == null ? null : subMenu_r11.data == null ? null : subMenu_r11.data.iconCssClass, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", subMenu_r11.display, " ");
} }
function DwPageMenu_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtemplate(3, DwPageMenu_ng_template_1_ng_container_1_ng_container_3_Template, 5, 5, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.menus);
} }
function DwPageMenu_ng_template_1_ng_container_2_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c10 = function (a0) { return { $implicit: a0 }; };
function DwPageMenu_ng_template_1_ng_container_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, DwPageMenu_ng_template_1_ng_container_2_ng_container_2_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuGroup_r13 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(3);
    const _r3 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c10, menuGroup_r13));
} }
function DwPageMenu_ng_template_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵtemplate(2, DwPageMenu_ng_template_1_ng_container_2_ng_container_2_Template, 3, 4, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.menuGroups);
} }
function DwPageMenu_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwPageMenu_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(1, DwPageMenu_ng_template_1_ng_container_1_Template, 4, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, DwPageMenu_ng_template_1_ng_container_2_Template, 3, 1, "ng-container", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.menuContentTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.menus == null ? null : ctx_r0.menus.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.menuGroups == null ? null : ctx_r0.menuGroups.length) > 0);
} }
function DwPageMenu_ng_template_2_div_4_dw_menu_link_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-menu-link", 17);
} if (rf & 2) {
    const subMenu_r17 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("menu", subMenu_r17)("menuLocation", "menu-page");
} }
function DwPageMenu_ng_template_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwPageMenu_ng_template_2_div_4_dw_menu_link_1_Template, 1, 2, "dw-menu-link", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const subMenu_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !((subMenu_r17.data == null ? null : subMenu_r17.data.showInMenu) === false || (subMenu_r17.data == null ? null : subMenu_r17.data.visibleRuleResult) === false));
} }
function DwPageMenu_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 15);
    ɵngcc0.ɵɵtemplate(4, DwPageMenu_ng_template_2_div_4_Template, 2, 1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menu_r15 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", menu_r15 == null ? null : menu_r15.display, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", menu_r15 == null ? null : menu_r15.children);
} }
function DwPageMenu_ng_template_4_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-menu-template", 9);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subMenu_r22 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menu", subMenu_r22);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("menu-icon-large ", subMenu_r22 == null ? null : subMenu_r22.data == null ? null : subMenu_r22.data.iconCssClass, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", subMenu_r22.display, " ");
} }
function DwPageMenu_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dw-container", 18);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtemplate(6, DwPageMenu_ng_template_4_ng_container_6_Template, 5, 5, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menuGroup_r20 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("options", ctx_r4.containerOptions);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", menuGroup_r20 == null ? null : menuGroup_r20.groupDisplay, " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", menuGroup_r20 == null ? null : menuGroup_r20.menus);
} }
function DwPageMenu_ng_template_6_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-menu-template", 9);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subMenu_r25 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menu", subMenu_r25);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("menu-icon-large ", subMenu_r25 == null ? null : subMenu_r25.data == null ? null : subMenu_r25.data.iconCssClass, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", subMenu_r25.display, " ");
} }
function DwPageMenu_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dw-container", 18);
    ɵngcc0.ɵɵelementStart(1, "span", 19);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtemplate(6, DwPageMenu_ng_template_6_ng_container_6_Template, 5, 5, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menu_r23 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("options", ctx_r6.containerOptions);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", menu_r23 == null ? null : menu_r23.display, " ");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", menu_r23 == null ? null : menu_r23.children);
} }
const _c11 = ["cmRoutes"];
function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵlistener("contextmenu", function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_4_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const node_r16 = ctx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(3); return ctx_r17.contextMenuClick($event, node_r16); });
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r16 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(node_r16.label);
} }
function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵlistener("contextmenu", function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_5_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const node_r19 = ctx.$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.contextMenuClick($event, node_r19); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span", 26);
    ɵngcc0.ɵɵtext(3, " *");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "i", 27);
} if (rf & 2) {
    const node_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r19.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(node_r19.data == null ? null : node_r19.data.modified));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !(node_r19.data == null ? null : node_r19.data.invalid));
} }
function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 25);
    ɵngcc0.ɵɵlistener("contextmenu", function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_6_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const node_r22 = ctx.$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.contextMenuClick($event, node_r22); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r22 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r22.label, " ");
} }
function DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 28);
    ɵngcc0.ɵɵelement(1, "i", 29);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r25 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r25.label, " ");
} }
function DwRoutingAdminTreeComponent_dw_container_0_div_5_div_19_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwRoutingAdminTreeComponent_dw_container_0_div_5_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwRoutingAdminTreeComponent_dw_container_0_div_5_div_19_ng_container_1_Template, 1, 0, "ng-container", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    const _r1 = ɵngcc0.ɵɵreference(2);
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.routingState.selectedNode.data == null ? null : ctx_r15.routingState.selectedNode.data.routeId)("ngIfThen", _r1)("ngIfElse", _r3);
} }
function DwRoutingAdminTreeComponent_dw_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelementStart(3, "p-tree", 12);
    ɵngcc0.ɵɵlistener("onNodeSelect", function DwRoutingAdminTreeComponent_dw_container_0_div_5_Template_p_tree_onNodeSelect_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.setCurrentNode($event); })("onNodeDrop", function DwRoutingAdminTreeComponent_dw_container_0_div_5_Template_p_tree_onNodeDrop_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.nodeDropped($event); });
    ɵngcc0.ɵɵtemplate(4, DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_4_Template, 3, 1, "ng-template", 13);
    ɵngcc0.ɵɵtemplate(5, DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_5_Template, 5, 3, "ng-template", 14);
    ɵngcc0.ɵɵtemplate(6, DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_6_Template, 2, 1, "ng-template", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "p-contextMenu", 16, 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(10, "button", 18);
    ɵngcc0.ɵɵlistener("click", function DwRoutingAdminTreeComponent_dw_container_0_div_5_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.saveRoutes(); });
    ɵngcc0.ɵɵtext(11, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 10);
    ɵngcc0.ɵɵelementStart(13, "p-tabView", 19);
    ɵngcc0.ɵɵlistener("activeIndexChange", function DwRoutingAdminTreeComponent_dw_container_0_div_5_Template_p_tabView_activeIndexChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.selectedTabIndex = $event; });
    ɵngcc0.ɵɵelementStart(14, "p-tabPanel", 20);
    ɵngcc0.ɵɵelementStart(15, "div", 21);
    ɵngcc0.ɵɵelementStart(16, "p-tree", 22);
    ɵngcc0.ɵɵtemplate(17, DwRoutingAdminTreeComponent_dw_container_0_div_5_ng_template_17_Template, 3, 1, "ng-template", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "p-tabPanel", 24);
    ɵngcc0.ɵɵtemplate(19, DwRoutingAdminTreeComponent_dw_container_0_div_5_div_19_Template, 2, 3, "div", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("value", ctx_r9.routingState.treeData)("selection", ctx_r9.routingState.selectedNode)("validateDrop", true);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("model", ctx_r9.cmRouteItems);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", !(ctx_r9.routingState == null ? null : ctx_r9.routingState.enableSave));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("activeIndex", ctx_r9.selectedTabIndex);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("value", ctx_r9.routingState.addTreeData);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.routingState.selectedNode && ctx_r9.routingState.selectedNode.type != "category");
} }
function DwRoutingAdminTreeComponent_dw_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dw-container");
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtext(2, " Menu Admin ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵelement(4, "dw-loading", 7);
    ɵngcc0.ɵɵtemplate(5, DwRoutingAdminTreeComponent_dw_container_0_div_5_Template, 20, 8, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("show", !ctx_r0.routingState);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routingState);
} }
function DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_0_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-route-edit", 33);
    ɵngcc0.ɵɵlistener("routeChange", function DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_0_Template_dw_route_edit_routeChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.updateRoute($event); })("validChange", function DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_0_Template_dw_route_edit_validChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r36 = ɵngcc0.ɵɵnextContext(2); return ctx_r36.validChange($event); })("undoConversion", function DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_0_Template_dw_route_edit_undoConversion_0_listener() { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ctx_r37.undoConversion(ctx_r37.routingState.selectedNode); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("route", ctx_r32.routingState.selectedRoute)("treeNode", ctx_r32.routingState.selectedNode);
} }
function DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_child_1_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-route-edit-child", 34);
    ɵngcc0.ɵɵlistener("routeChange", function DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_child_1_Template_dw_route_edit_child_routeChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ctx_r38.updateChildRoute($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("route", ctx_r33.routingState.selectedRoute)("menuData", ctx_r33.routingState.selectedNode.data.routeMenuData);
} }
function DwRoutingAdminTreeComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_0_Template, 1, 2, "dw-route-edit", 31);
    ɵngcc0.ɵɵtemplate(1, DwRoutingAdminTreeComponent_ng_template_1_dw_route_edit_child_1_Template, 1, 2, "dw-route-edit-child", 32);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.routingState == null ? null : ctx_r2.routingState.selectedNode.type) !== "dbRouteChild");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.routingState == null ? null : ctx_r2.routingState.selectedNode.type) === "dbRouteChild");
} }
function DwRoutingAdminTreeComponent_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwRoutingAdminTreeComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwRoutingAdminTreeComponent_ng_template_3_ng_container_0_Template, 1, 0, "ng-container", 30);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(8);
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r4.routingState == null ? null : ctx_r4.routingState.selectedNode == null ? null : ctx_r4.routingState.selectedNode.parent.type) == "category" || (ctx_r4.routingState == null ? null : ctx_r4.routingState.selectedNode == null ? null : ctx_r4.routingState.selectedNode.parent == null ? null : ctx_r4.routingState.selectedNode.parent.data == null ? null : ctx_r4.routingState.selectedNode.parent.data.routeId))("ngIfThen", _r7)("ngIfElse", _r5);
} }
function DwRoutingAdminTreeComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 35);
    ɵngcc0.ɵɵtext(1, " Can't convert a child of a static route. Convert the parent node instead! ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwRoutingAdminTreeComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 36);
    ɵngcc0.ɵɵlistener("click", function DwRoutingAdminTreeComponent_ng_template_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.convertToDynamicRoute(ctx_r41.routingState.selectedNode); });
    ɵngcc0.ɵɵtext(1, "Convert to DB Route");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "input", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRoutingAdminTreeComponent_ng_template_7_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.convertAllChildren = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, " Convert all children ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r8.routingState.selectedNode == null ? null : ctx_r8.routingState.selectedNode.children == null ? null : ctx_r8.routingState.selectedNode.children.length) == 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.convertAllChildren);
} }
function DwProductVersionAdminComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "date");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td");
    ɵngcc0.ɵɵelement(9, "i", 2);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const version_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", version_r1.ModuleName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", version_r1.ProductVersion, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 8, version_r1.PublishDateTime), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassMap(version_r1.AdditionalInfo == null ? null : version_r1.AdditionalInfo.iconClass);
    ɵngcc0.ɵɵpropertyInterpolate("title", version_r1.AdditionalInfo == null ? null : version_r1.AdditionalInfo.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", version_r1.ModuleType, " ");
} }
function DwGridComponent_div_3_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DwGridComponent_div_3_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.applyFilters(ctx_r9.filters); });
    ɵngcc0.ɵɵtext(1, "Filter");
    ɵngcc0.ɵɵelementEnd();
} }
function DwGridComponent_div_3_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function DwGridComponent_div_3_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.clearFilters(ctx_r11.filters); });
    ɵngcc0.ɵɵtext(1, "Clear");
    ɵngcc0.ɵɵelementEnd();
} }
function DwGridComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵtext(2, " Filters ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 0);
    ɵngcc0.ɵɵelementStart(4, "form", 10);
    ɵngcc0.ɵɵlistener("onsubmit", function DwGridComponent_div_3_Template_form_onsubmit_4_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.applyFilters(ctx_r13.filters); });
    ɵngcc0.ɵɵprojection(5, 1);
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵelementStart(7, "div", 12);
    ɵngcc0.ɵɵtemplate(8, DwGridComponent_div_3_button_8_Template, 2, 0, "button", 13);
    ɵngcc0.ɵɵtemplate(9, DwGridComponent_div_3_button_9_Template, 2, 0, "button", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showFilterSection);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.styles == null ? null : ctx_r0.styles.filterHeaderClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.styles == null ? null : ctx_r0.styles.filterBodyClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.gridConfig.autoFilter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.gridConfig.showClearFilter);
} }
function DwGridComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵprojection(2, 2);
    ɵngcc0.ɵɵelementStart(3, "dw-action-bar", 18);
    ɵngcc0.ɵɵlistener("actionClick", function DwGridComponent_ng_container_6_Template_dw_action_bar_actionClick_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.actionPrefClicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 19);
    ɵngcc0.ɵɵelementStart(5, "dw-action-bar", 18);
    ɵngcc0.ɵɵlistener("actionClick", function DwGridComponent_ng_container_6_Template_dw_action_bar_actionClick_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.actionPrefClicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(6, 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r1.gridConfig == null ? null : ctx_r1.gridConfig.actionPreferences == null ? null : ctx_r1.gridConfig.actionPreferences.actionBarLeft)("actionContext", ctx_r1.configContext);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r1.gridConfig == null ? null : ctx_r1.gridConfig.actionPreferences == null ? null : ctx_r1.gridConfig.actionPreferences.actionBarRight)("actionContext", ctx_r1.configContext);
} }
function DwGridComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 17);
    ɵngcc0.ɵɵelementStart(2, "dw-action-bar", 18);
    ɵngcc0.ɵɵlistener("actionClick", function DwGridComponent_ng_container_7_Template_dw_action_bar_actionClick_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.actionPrefClicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 19);
    ɵngcc0.ɵɵelementStart(4, "dw-action-bar", 18);
    ɵngcc0.ɵɵlistener("actionClick", function DwGridComponent_ng_container_7_Template_dw_action_bar_actionClick_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.actionPrefClicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r2.gridConfig == null ? null : ctx_r2.gridConfig.actionPreferences == null ? null : ctx_r2.gridConfig.actionPreferences.actionBarLeftInlineEditing)("actionContext", ctx_r2.configContext);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r2.gridConfig == null ? null : ctx_r2.gridConfig.actionPreferences == null ? null : ctx_r2.gridConfig.actionPreferences.actionBarRightInlineEditing)("actionContext", ctx_r2.configContext);
} }
function DwGridComponent_ng_template_12_Template(rf, ctx) { }
function DwGridComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵprojection(2, 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwGridComponent_ng_content_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 5, ["*ngIf", "gridConfig!.showFooter"]);
} }
const _c12 = [[["", "filterTiles", ""]], [["", "filter", ""]], [["", "actions", ""]], [["", "actions", ""]], [["", "rightPanel", ""]], [["", "footer", ""]]];
const _c13 = function (a0) { return { "dw-grid-split-container-full": a0 }; };
const _c14 = ["[filterTiles]", "[filter]", "[actions]", "[actions]", "[rightPanel]", "[footer]"];
const _c15 = ["userNameInput"];
const _c16 = ["passwordInput"];
function DwLoginComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwLoginComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwLoginComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customLoginTemplate ? ctx_r0.customLoginTemplate : _r2);
} }
function DwLoginComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-user-password-reset", 5);
    ɵngcc0.ɵɵlistener("userNameChange", function DwLoginComponent_ng_container_4_Template_dw_user_password_reset_userNameChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.userName = $event; })("cancelled", function DwLoginComponent_ng_container_4_Template_dw_user_password_reset_cancelled_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.resetCancelled(); })("messageChange", function DwLoginComponent_ng_container_4_Template_dw_user_password_reset_messageChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.message = $event; })("complete", function DwLoginComponent_ng_container_4_Template_dw_user_password_reset_complete_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.resetComplete(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("userName", ctx_r1.userName)("message", ctx_r1.message);
} }
function DwLoginComponent_ng_template_6_ng_container_10_i_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 30);
} }
function DwLoginComponent_ng_template_6_ng_container_10_button_23_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 31);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_10_button_23_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.register(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r14.dwUIConfig.registrationConfig == null ? null : ctx_r14.dwUIConfig.registrationConfig.registerButtonText) || "Register", " ");
} }
function DwLoginComponent_ng_template_6_ng_container_10_a_24_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_10_a_24_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.register(); });
    ɵngcc0.ɵɵelementStart(1, "span", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 33);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r15.dwUIConfig.registrationConfig == null ? null : ctx_r15.dwUIConfig.registrationConfig.registrationLinkText) || "Sign up", " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r15.dwUIConfig.registrationConfig == null ? null : ctx_r15.dwUIConfig.registrationConfig.registerButtonText) || "Register", " ");
} }
function DwLoginComponent_ng_template_6_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "div", 16);
    ɵngcc0.ɵɵelement(3, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 18);
    ɵngcc0.ɵɵelementStart(5, "dw-floating-label-input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwLoginComponent_ng_template_6_ng_container_10_Template_dw_floating_label_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.userName = $event; })("ngModelChange", function DwLoginComponent_ng_template_6_ng_container_10_Template_dw_floating_label_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.userNameChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵelementStart(7, "div", 16);
    ɵngcc0.ɵɵelement(8, "i", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 18);
    ɵngcc0.ɵɵelementStart(10, "dw-floating-label-input", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwLoginComponent_ng_template_6_ng_container_10_Template_dw_floating_label_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.password = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 15);
    ɵngcc0.ɵɵelement(12, "div", 16);
    ɵngcc0.ɵɵelementStart(13, "div", 18);
    ɵngcc0.ɵɵelementStart(14, "div", 22);
    ɵngcc0.ɵɵelementStart(15, "a", 23);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_10_Template_a_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.forgotPassword(); });
    ɵngcc0.ɵɵtext(16, "Forgot your password?");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "div", 24);
    ɵngcc0.ɵɵelementStart(19, "button", 25);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_10_Template_button_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.login(); });
    ɵngcc0.ɵɵtext(20, "Login ");
    ɵngcc0.ɵɵtemplate(21, DwLoginComponent_ng_template_6_ng_container_10_i_21_Template, 1, 0, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "dw-login-sso-options", 27);
    ɵngcc0.ɵɵlistener("isProcessing", function DwLoginComponent_ng_template_6_ng_container_10_Template_dw_login_sso_options_isProcessing_22_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.setIsProcessing($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, DwLoginComponent_ng_template_6_ng_container_10_button_23_Template, 2, 1, "button", 28);
    ɵngcc0.ɵɵtemplate(24, DwLoginComponent_ng_template_6_ng_container_10_a_24_Template, 5, 2, "a", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("label", (ctx_r10.dwUIConfig.registrationConfig == null ? null : ctx_r10.dwUIConfig.registrationConfig.userNameText) || "Username/E-mail")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbUserName")("ngModel", ctx_r10.userName)("inputAutocomplete", "username")("useFloat", ctx_r10.dwUIConfig.registrationConfig == null ? null : ctx_r10.dwUIConfig.registrationConfig.useFloatLabelOnLogin);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("type", "password")("label", "Password")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbPassword")("ngModel", ctx_r10.password)("inputAutocomplete", "current-password")("useFloat", ctx_r10.dwUIConfig.registrationConfig == null ? null : ctx_r10.dwUIConfig.registrationConfig.useFloatLabelOnLogin);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("disabled", ctx_r10.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r10.dwUIConfig.registrationConfig == null ? null : ctx_r10.dwUIConfig.registrationConfig.registrationShowAsLink));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.dwUIConfig.registrationConfig == null ? null : ctx_r10.dwUIConfig.registrationConfig.registrationShowAsLink);
} }
function DwLoginComponent_ng_template_6_ng_container_11_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "a", 23);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_11_div_1_div_4_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(4); return ctx_r30.resendCode(); });
    ɵngcc0.ɵɵtext(2, "Resend Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwLoginComponent_ng_template_6_ng_container_11_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelement(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, DwLoginComponent_ng_template_6_ng_container_11_div_1_div_4_Template, 3, 0, "div", 40);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r27.twoFactorMessage, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r27.showResendCode);
} }
function DwLoginComponent_ng_template_6_ng_container_11_i_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 30);
} }
function DwLoginComponent_ng_template_6_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwLoginComponent_ng_template_6_ng_container_11_div_1_Template, 5, 2, "div", 34);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelement(4, "img", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 18);
    ɵngcc0.ɵɵelementStart(6, "label", 36);
    ɵngcc0.ɵɵtext(7, "Two Factor Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwLoginComponent_ng_template_6_ng_container_11_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.twoFactorCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 15);
    ɵngcc0.ɵɵelementStart(10, "div", 38);
    ɵngcc0.ɵɵelementStart(11, "button", 39);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_11_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.login(); });
    ɵngcc0.ɵɵtext(12, "Complete Login ");
    ɵngcc0.ɵɵtemplate(13, DwLoginComponent_ng_template_6_ng_container_11_i_13_Template, 1, 0, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.twoFactorMessage);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.twoFactorCode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r11.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.processing);
} }
function DwLoginComponent_ng_template_6_ng_container_12_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelement(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r35.changePasswordMessage, " ");
} }
function DwLoginComponent_ng_template_6_ng_container_12_i_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 30);
} }
function DwLoginComponent_ng_template_6_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwLoginComponent_ng_template_6_ng_container_12_div_1_Template, 4, 1, "div", 34);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelement(4, "img", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 18);
    ɵngcc0.ɵɵelement(6, "input", 41);
    ɵngcc0.ɵɵelementStart(7, "label", 36);
    ɵngcc0.ɵɵtext(8, "New Password");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "input", 42);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwLoginComponent_ng_template_6_ng_container_12_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ctx_r37.newPassword = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 15);
    ɵngcc0.ɵɵelementStart(11, "div", 16);
    ɵngcc0.ɵɵelement(12, "img", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 18);
    ɵngcc0.ɵɵelementStart(14, "label", 36);
    ɵngcc0.ɵɵtext(15, "Retype New Password");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "input", 43);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwLoginComponent_ng_template_6_ng_container_12_Template_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r39 = ɵngcc0.ɵɵnextContext(2); return ctx_r39.newPasswordRetype = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "div", 38);
    ɵngcc0.ɵɵelementStart(19, "button", 39);
    ɵngcc0.ɵɵlistener("click", function DwLoginComponent_ng_template_6_ng_container_12_Template_button_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.changePassword(); });
    ɵngcc0.ɵɵtext(20, "Change Password ");
    ɵngcc0.ɵɵtemplate(21, DwLoginComponent_ng_template_6_ng_container_12_i_21_Template, 1, 0, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.changePasswordMessage);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.newPassword);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r12.newPasswordRetype);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r12.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r12.processing);
} }
function DwLoginComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1, "Login");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelement(3, "dw-message", 8);
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "div", 10);
    ɵngcc0.ɵɵelement(6, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 12);
    ɵngcc0.ɵɵelementStart(8, "div", 13);
    ɵngcc0.ɵɵelementStart(9, "form", 14);
    ɵngcc0.ɵɵlistener("ngSubmit", function DwLoginComponent_ng_template_6_Template_form_ngSubmit_9_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.login(); });
    ɵngcc0.ɵɵtemplate(10, DwLoginComponent_ng_template_6_ng_container_10_Template, 25, 19, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(11, DwLoginComponent_ng_template_6_ng_container_11_Template, 14, 4, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(12, DwLoginComponent_ng_template_6_ng_container_12_Template, 22, 5, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("message", ctx_r3.message);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.showTwoFactor && !ctx_r3.showForcePasswordChange);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showTwoFactor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showForcePasswordChange);
} }
const _c17 = [[["", "top", ""]], [["", "bottom", ""]]];
const _c18 = ["[top]", "[bottom]"];
const _c19 = ["inputElement"];
function DwInputComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "span", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 9, 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwInputComponent_div_7_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.setTranslatedValue($event); })("blur", function DwInputComponent_div_7_Template_input_blur_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onBlur($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 10);
    ɵngcc0.ɵɵelementStart(7, "span", 8);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r1.options == null ? null : ctx_r1.options.prefix));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.options == null ? null : ctx_r1.options.prefix);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.inputClass)("ngModel", ctx_r1.translatedValue)("type", ctx_r1.type)("placeholder", ctx_r1.placeholder || "")("dwNumeric", ctx_r1.numeric)("decimals", ctx_r1.finalDecimals)("maxlength", ctx_r1.maxlength)("dwBrowserAutocomplete", ctx_r1.options == null ? null : ctx_r1.options.autoCompleteEnabled)("autocompleteText", ctx_r1.options == null ? null : ctx_r1.options.autoCompleteType)("allowNegative", ctx_r1.finalAllowNegative);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r1.options == null ? null : ctx_r1.options.suffix));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.options == null ? null : ctx_r1.options.suffix);
} }
function DwYesNoComponent_dw_radio_list_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-radio-list", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwYesNoComponent_dw_radio_list_0_Template_dw_radio_list_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.setTranslatedValue($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("values", ctx_r0.values)("ngModel", ctx_r0.translatedValue);
} }
function DwYesNoComponent_select_1_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const value_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", value_r5.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", value_r5.display, " ");
} }
function DwYesNoComponent_select_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwYesNoComponent_select_1_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.setTranslatedValue($event); });
    ɵngcc0.ɵɵtemplate(1, DwYesNoComponent_select_1_option_1_Template, 2, 2, "option", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.translatedValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.values);
} }
function DwSelectComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.blankText);
} }
function DwSelectComponent_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("value", item_r2[ctx_r1.idField]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2[ctx_r1.displayField], " ");
} }
function DwAppSidebarNavComponent_div_1_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "li", 5);
} }
function DwAppSidebarNavComponent_div_1_dw_app_sidebar_nav_title_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-app-sidebar-nav-title", 6);
} if (rf & 2) {
    const navitem_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("title", navitem_r1);
} }
function DwAppSidebarNavComponent_div_1_dw_app_sidebar_nav_item_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-app-sidebar-nav-item", 7);
} if (rf & 2) {
    const navitem_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("item", navitem_r1);
} }
function DwAppSidebarNavComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwAppSidebarNavComponent_div_1_li_1_Template, 1, 0, "li", 2);
    ɵngcc0.ɵɵtemplate(2, DwAppSidebarNavComponent_div_1_dw_app_sidebar_nav_title_2_Template, 1, 1, "dw-app-sidebar-nav-title", 3);
    ɵngcc0.ɵɵtemplate(3, DwAppSidebarNavComponent_div_1_dw_app_sidebar_nav_item_3_Template, 1, 1, "dw-app-sidebar-nav-item", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const navitem_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isDivider(navitem_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isTitle(navitem_r1));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isDivider(navitem_r1) && !ctx_r0.isTitle(navitem_r1));
} }
function DwAppSidebarNavItemComponent_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵelement(1, "dw-menu-link", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.hasClass() ? "nav-item " + ctx_r0.item.class : "nav-item");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menu", ctx_r0.item)("menuLocation", "side-bar");
} }
function DwAppSidebarNavItemComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵelement(1, "dw-app-sidebar-nav-dropdown", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("open", ctx_r2.isActive());
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.hasClass() ? "nav-item nav-dropdown " + ctx_r2.item.class : "nav-item nav-dropdown");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("link", ctx_r2.item);
} }
function DwAppSidebarNavDropdownComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("nav-icon ", ctx_r0.link.data.iconCssClass, "");
} }
function DwAppSidebarNavDropdownComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", "badge badge-" + ctx_r1.link.badge.variant);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.link.badge.text);
} }
function DwAppSidebarNavDropdownComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-app-sidebar-nav-item", 6);
} if (rf & 2) {
    const child_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("item", child_r3);
} }
const _c20 = function (a0) { return { "selected-handle": a0 }; };
function DwUiConfigPanelComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵlistener("click", function DwUiConfigPanelComponent_div_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.toggleSidebar("config"); });
    ɵngcc0.ɵɵelement(2, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵlistener("click", function DwUiConfigPanelComponent_div_1_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.toggleSidebar("debug"); });
    ɵngcc0.ɵɵelement(4, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c20, ctx_r0.panelMode == "config" && ctx_r0.isExpanded));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.currentWidgetConfig == null ? null : ctx_r0.currentWidgetConfig.debugComponent))("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c20, ctx_r0.panelMode == "debug" && ctx_r0.isExpanded));
} }
function DwUiConfigPanelComponent_div_5_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const widgetConfig_r11 = ctx.$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngValue", widgetConfig_r11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r10.getWidgetConfigDisplay(widgetConfig_r11), " ");
} }
function DwUiConfigPanelComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Configuration");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵelementStart(5, "select", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUiConfigPanelComponent_div_5_Template_select_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.setConfigComponent($event); });
    ɵngcc0.ɵɵtemplate(6, DwUiConfigPanelComponent_div_5_option_6_Template, 2, 2, "option", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.currentWidgetConfig)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.widgetConfigs);
} }
function DwUiConfigPanelComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵtext(2, " No Components to configure ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwUiConfigPanelComponent_ng_template_8_Template(rf, ctx) { }
function DwUiConfigPanelComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 20);
    ɵngcc0.ɵɵelementStart(1, "dw-message", 21);
    ɵngcc0.ɵɵlistener("messageChange", function DwUiConfigPanelComponent_div_13_Template_dw_message_messageChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.message = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("message", ctx_r5.message);
} }
function DwUiConfigPanelComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵelementStart(1, "button", 23);
    ɵngcc0.ɵɵlistener("click", function DwUiConfigPanelComponent_div_14_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.save(); });
    ɵngcc0.ɵɵtext(2, "Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 24);
    ɵngcc0.ɵɵlistener("click", function DwUiConfigPanelComponent_div_14_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.reset(); });
    ɵngcc0.ɵɵtext(4, "Reset");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c21 = function () { return { marginTop: "40px", marginRight: "-13px" }; };
function DwMessageBarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "p-toast");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(2, _c21));
} }
function DwMessageBarComponent_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.requestCount);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.saveRequestCount);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.realTimeRequestCount);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.realTimeSaveRequestCount);
} }
const _c22 = function (a0) { return { "green-progress": a0 }; };
const _c23 = function () { return { "height": "3px" }; };
function DwMessageBarComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelement(4, "p-progressBar", 6);
    ɵngcc0.ɵɵtext(5, "\u00A0 ");
    ɵngcc0.ɵɵtemplate(6, DwMessageBarComponent_div_2_div_6_Template, 9, 4, "div", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.showProgress)("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c22, ctx_r1.realTimeSaveRequestCount));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(8, _c23));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.showProgress);
} }
function DwModalHostComponent_dw_html_view_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-html-view", 7);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.modalConfig == null ? null : ctx_r0.modalConfig.content);
} }
function DwModalHostComponent_ng_template_7_Template(rf, ctx) { }
function DwModalHostComponent_p_footer_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-button", 9);
    ɵngcc0.ɵɵlistener("click", function DwModalHostComponent_p_footer_8_ng_container_1_Template_dw_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const button_r7 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.buttonClick(button_r7); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("buttonConfig", button_r7);
} }
function DwModalHostComponent_p_footer_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-footer");
    ɵngcc0.ɵɵtemplate(1, DwModalHostComponent_p_footer_8_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.modalConfig == null ? null : ctx_r2.modalConfig.buttons);
} }
function DwModalHostComponent_dw_html_view_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-html-view", 7);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.modalConfig == null ? null : ctx_r3.modalConfig.content);
} }
function DwModalHostComponent_ng_template_14_Template(rf, ctx) { }
function DwModalHostComponent_p_footer_15_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-button", 9);
    ɵngcc0.ɵɵlistener("click", function DwModalHostComponent_p_footer_15_ng_container_1_Template_dw_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const button_r11 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.buttonClick(button_r11); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("buttonConfig", button_r11);
} }
function DwModalHostComponent_p_footer_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-footer");
    ɵngcc0.ɵɵtemplate(1, DwModalHostComponent_p_footer_15_ng_container_1_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.modalConfig == null ? null : ctx_r5.modalConfig.buttons);
} }
const _c24 = function (a0) { return { "dw-modal-backup-show3": a0 }; };
function DwButtonComponent_button_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r4.buttonConfig == null ? null : ctx_r4.buttonConfig.iconClass);
} }
function DwButtonComponent_button_1_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r5.buttonConfig == null ? null : ctx_r5.buttonConfig.iconClass);
} }
function DwButtonComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 3);
    ɵngcc0.ɵɵlistener("middleclick", function DwButtonComponent_button_1_Template_button_middleclick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.middleClick($event); });
    ɵngcc0.ɵɵtemplate(1, DwButtonComponent_button_1_i_1_Template, 1, 2, "i", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelement(3, "i", 5);
    ɵngcc0.ɵɵtemplate(4, DwButtonComponent_button_1_i_4_Template, 1, 2, "i", 4);
    ɵngcc0.ɵɵelement(5, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.buttonClass);
    ɵngcc0.ɵɵproperty("title", (ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.buttonTitle) || "")("disabled", ctx_r0.disabled || (ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.disabled))("hidden", ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.hidden);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.iconClass) && !(ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.showIconAfterText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.buttonText, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.firing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.iconClass) && (ctx_r0.buttonConfig == null ? null : ctx_r0.buttonConfig.showIconAfterText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showCaret);
} }
const _c25 = function (a0) { return { "dw-icon-disabled": a0 }; };
function DwButtonComponent_span_2_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r8.buttonConfig == null ? null : ctx_r8.buttonConfig.iconClass);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c25, ctx_r8.disabled || (ctx_r8.buttonConfig == null ? null : ctx_r8.buttonConfig.disabled)));
} }
function DwButtonComponent_span_2_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 8);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r9.buttonConfig == null ? null : ctx_r9.buttonConfig.iconClass);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c25, ctx_r9.disabled || (ctx_r9.buttonConfig == null ? null : ctx_r9.buttonConfig.disabled)));
} }
function DwButtonComponent_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtemplate(1, DwButtonComponent_span_2_i_1_Template, 1, 5, "i", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, DwButtonComponent_span_2_i_3_Template, 1, 5, "i", 7);
    ɵngcc0.ɵɵelement(4, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r1.buttonConfig == null ? null : ctx_r1.buttonConfig.iconClass) && !(ctx_r1.buttonConfig == null ? null : ctx_r1.buttonConfig.showIconAfterText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.buttonConfig == null ? null : ctx_r1.buttonConfig.buttonText, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r1.buttonConfig == null ? null : ctx_r1.buttonConfig.iconClass) && (ctx_r1.buttonConfig == null ? null : ctx_r1.buttonConfig.showIconAfterText));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.showCaret);
} }
function DwButtonComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "i", 9);
    ɵngcc0.ɵɵelement(2, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r2.buttonConfig == null ? null : ctx_r2.buttonConfig.iconClass, " hand");
    ɵngcc0.ɵɵproperty("title", (ctx_r2.buttonConfig == null ? null : ctx_r2.buttonConfig.buttonTitle) || "")("hidden", ctx_r2.buttonConfig == null ? null : ctx_r2.buttonConfig.hidden)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c25, ctx_r2.disabled || (ctx_r2.buttonConfig == null ? null : ctx_r2.buttonConfig.disabled)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r2.showCaret);
} }
function DwButtonComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "a", 10);
    ɵngcc0.ɵɵlistener("click", function DwButtonComponent_span_4_Template_a_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); return $event.preventDefault(); });
    ɵngcc0.ɵɵelement(2, "i", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "span", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r3.buttonConfig == null ? null : ctx_r3.buttonConfig.iconClass, " hand");
    ɵngcc0.ɵɵproperty("title", (ctx_r3.buttonConfig == null ? null : ctx_r3.buttonConfig.buttonTitle) || "")("hidden", ctx_r3.buttonConfig == null ? null : ctx_r3.buttonConfig.hidden)("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c25, ctx_r3.disabled || (ctx_r3.buttonConfig == null ? null : ctx_r3.buttonConfig.disabled)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.buttonConfig == null ? null : ctx_r3.buttonConfig.buttonText, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.showCaret);
} }
function DwSecurityEmulationComponent_li_24_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 12);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵelementStart(2, "a", 14);
    ɵngcc0.ɵɵlistener("click", function DwSecurityEmulationComponent_li_24_Template_a_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r3); const user_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.emulateUser(user_r1); });
    ɵngcc0.ɵɵtext(3, "Emulate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const user_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate3(" ", user_r1.FirstName, " ", user_r1.LastName, " (", user_r1.Email, ") ");
} }
function DwSecurityInfoComponent_div_1_div_10_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵlistener("click", function DwSecurityInfoComponent_div_1_div_10_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.showEmulateSelection(); });
    ɵngcc0.ɵɵelement(1, "i", 19);
    ɵngcc0.ɵɵtext(2, " Emulate");
    ɵngcc0.ɵɵelementEnd();
} }
function DwSecurityInfoComponent_div_1_div_10_a_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵlistener("click", function DwSecurityInfoComponent_div_1_div_10_a_5_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.cancelEmulation(); });
    ɵngcc0.ɵɵelement(1, "i", 20);
    ɵngcc0.ɵɵtext(2, " Cancel Emulation");
    ɵngcc0.ɵɵelementEnd();
} }
function DwSecurityInfoComponent_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵlistener("click", function DwSecurityInfoComponent_div_1_div_10_Template_div_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.meunClick($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DwSecurityInfoComponent_div_1_div_10_a_4_Template, 3, 0, "a", 14);
    ɵngcc0.ɵɵtemplate(5, DwSecurityInfoComponent_div_1_div_10_a_5_Template, 3, 0, "a", 15);
    ɵngcc0.ɵɵelement(6, "dw-security-user-menu");
    ɵngcc0.ɵɵelement(7, "div", 16);
    ɵngcc0.ɵɵelementStart(8, "a", 17);
    ɵngcc0.ɵɵlistener("click", function DwSecurityInfoComponent_div_1_div_10_Template_a_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.logout(); });
    ɵngcc0.ɵɵelement(9, "i", 18);
    ɵngcc0.ɵɵtext(10, " Logout ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.authenticateNameDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.canEmulate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isEmulating);
} }
function DwSecurityInfoComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "ul", 3);
    ɵngcc0.ɵɵelementStart(2, "li", 4, 5);
    ɵngcc0.ɵɵelementStart(4, "a", 6);
    ɵngcc0.ɵɵlistener("click", function DwSecurityInfoComponent_div_1_Template_a_click_4_listener() { return false; });
    ɵngcc0.ɵɵelement(5, "dw-dynamic-loader", 7);
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "span");
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, DwSecurityInfoComponent_div_1_div_10_Template, 11, 3, "div", 10);
    ɵngcc0.ɵɵelementStart(11, "div", 11);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("autoClose", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("component", ctx_r0.defaultAvatar);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.fullNameDisplay);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.addionalLine);
} }
function DwSecurityInfoComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵlistener("click", function DwSecurityInfoComponent_div_2_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.login(); });
    ɵngcc0.ɵɵelement(2, "i", 22);
    ɵngcc0.ɵɵtext(3, " Login");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwActionHostComponent_ng_template_0_Template(rf, ctx) { }
function DwDataListComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.styles == null ? null : ctx_r0.styles.containerHeaderClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.config.headerTitle, " ");
} }
function DwDataListComponent_div_3_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DwDataListComponent_div_3_div_6_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.applyFilters(ctx_r7.filters); });
    ɵngcc0.ɵɵtext(3, "Filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.styles == null ? null : ctx_r6.styles.filterButtonContainer);
} }
function DwDataListComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵtext(2, " Filters ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 0);
    ɵngcc0.ɵɵelementStart(4, "form", 9);
    ɵngcc0.ɵɵlistener("onsubmit", function DwDataListComponent_div_3_Template_form_onsubmit_4_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.applyFilters(ctx_r9.filters); });
    ɵngcc0.ɵɵprojection(5, 1);
    ɵngcc0.ɵɵtemplate(6, DwDataListComponent_div_3_div_6_Template, 4, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.styles == null ? null : ctx_r1.styles.filterContainerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.styles == null ? null : ctx_r1.styles.filterHeaderClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.styles == null ? null : ctx_r1.styles.filterBodyClass);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r1.config == null ? null : ctx_r1.config.autoFilter));
} }
function DwDataListComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11.config.headerTitle, " ");
} }
function DwDataListComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 13);
    ɵngcc0.ɵɵtemplate(2, DwDataListComponent_div_4_div_2_Template, 2, 1, "div", 14);
    ɵngcc0.ɵɵelementStart(3, "dw-action-bar", 15);
    ɵngcc0.ɵɵlistener("actionClick", function DwDataListComponent_div_4_Template_dw_action_bar_actionClick_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.actionPrefClicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵelementStart(5, "dw-action-bar", 15);
    ɵngcc0.ɵɵlistener("actionClick", function DwDataListComponent_div_4_Template_dw_action_bar_actionClick_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.actionPrefClicked($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.styles == null ? null : ctx_r2.styles.actionBarClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.config == null ? null : ctx_r2.config.showHeader) && !ctx_r2.showFilterSection);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r2.config == null ? null : ctx_r2.config.actionPreferencesByMode == null ? null : ctx_r2.config.actionPreferencesByMode.actionBarLeft)("actionContext", ctx_r2.actionContext);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r2.config == null ? null : ctx_r2.config.actionPreferencesByMode == null ? null : ctx_r2.config.actionPreferencesByMode.actionBarRight)("actionContext", ctx_r2.actionContext);
} }
function DwDataListComponent_ng_container_10_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwDataListComponent_ng_container_10_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwDataListComponent_ng_container_10_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 20);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r16 = ctx.$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r15.cardItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c10, item_r16));
} }
function DwDataListComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtemplate(2, DwDataListComponent_ng_container_10_ng_container_2_Template, 2, 4, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.displayedData);
} }
function DwDataListComponent_ng_container_11_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwDataListComponent_ng_container_11_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwDataListComponent_ng_container_11_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 20);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r19 = ctx.$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r18.listItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c10, item_r19));
} }
function DwDataListComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵtemplate(2, DwDataListComponent_ng_container_11_ng_container_2_Template, 2, 4, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.displayedData);
} }
function DwDataListComponent_div_12_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "There are no items found");
    ɵngcc0.ɵɵelementEnd();
} }
function DwDataListComponent_div_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwDataListComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwDataListComponent_div_12_span_1_Template, 2, 0, "span", 6);
    ɵngcc0.ɵɵtemplate(2, DwDataListComponent_div_12_ng_container_2_Template, 1, 0, "ng-container", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.noItemsTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.noItemsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c10, ctx_r5.item));
} }
const _c26 = [[["", "filterTiles", ""]], [["", "filter", ""]]];
const _c27 = ["[filterTiles]", "[filter]"];
function DwRouterParentComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwRouterParentComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, DwRouterParentComponent_div_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", false || ctx_r0.childRouteActivated)("ngClass", ctx_r0.pageSyleNameInner);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.templateRef);
} }
function DwRouterParentComponent_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwRouterParentComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵtemplate(1, DwRouterParentComponent_div_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.pageSyleNameInner);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.templateRef);
} }
function DwRouterParentComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "router-outlet", 6, 7);
    ɵngcc0.ɵɵlistener("activate", function DwRouterParentComponent_ng_container_3_Template_router_outlet_activate_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.toggleActivate(true); })("deactivate", function DwRouterParentComponent_ng_container_3_Template_router_outlet_deactivate_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.toggleActivate(false); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c28 = function (a0) { return { "active": a0 }; };
function DwPillsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵlistener("click", function DwPillsComponent_ng_container_1_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const item_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.setTranslatedValue(item_r1); });
    ɵngcc0.ɵɵelement(2, "i", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c28, item_r1.value == ctx_r0.value))("title", item_r1.tooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", item_r1.iconClass)("hidden", !item_r1.iconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", item_r1.display, " ");
} }
function DwHtmlEditComponent_div_0_ng_container_2_dw_quill_editor_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-quill-editor", 4);
    ɵngcc0.ɵɵlistener("htmlChange", function DwHtmlEditComponent_div_0_ng_container_2_dw_quill_editor_1_Template_dw_quill_editor_htmlChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.setEditableHtml($event); })("onEditorCreated", function DwHtmlEditComponent_div_0_ng_container_2_dw_quill_editor_1_Template_dw_quill_editor_onEditorCreated_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.editorCreated($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("html", ctx_r5.editableHtml)("modules", ctx_r5.modules)("disabled", ctx_r5.disabled);
} }
function DwHtmlEditComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwHtmlEditComponent_div_0_ng_container_2_dw_quill_editor_1_Template, 1, 3, "dw-quill-editor", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.viewMarkup);
} }
const _c29 = function () { return { "min-height": "120px" }; };
function DwHtmlEditComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "span", 6);
    ɵngcc0.ɵɵlistener("click", function DwHtmlEditComponent_div_0_div_3_Template_span_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.toggleViewMarkup(); });
    ɵngcc0.ɵɵtext(3, " Return ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "textarea", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwHtmlEditComponent_div_0_div_3_Template_textarea_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.setTranslatedValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(3, _c29));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.translatedValue);
} }
function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_1_dw_quill_editor_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-quill-editor", 4);
    ɵngcc0.ɵɵlistener("htmlChange", function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_1_dw_quill_editor_1_Template_dw_quill_editor_htmlChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(4); return ctx_r15.setEditableHtml($event); })("onEditorCreated", function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_1_dw_quill_editor_1_Template_dw_quill_editor_onEditorCreated_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(4); return ctx_r17.editorCreated($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("html", ctx_r14.editableHtml)("modules", ctx_r14.modules)("disabled", ctx_r14.disabled);
} }
function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, DwHtmlEditComponent_div_0_p_splitter_4_ng_template_1_dw_quill_editor_1_Template, 1, 3, "dw-quill-editor", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r12.viewMarkup);
} }
function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_p_accordionTab_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "button", 17);
    ɵngcc0.ɵɵlistener("click", function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_p_accordionTab_2_div_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r24); const field_r22 = ctx.$implicit; const ctx_r23 = ɵngcc0.ɵɵnextContext(5); return ctx_r23.addItem(field_r22); });
    ɵngcc0.ɵɵelement(2, "i", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r22 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", field_r22.display, " ");
} }
function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_p_accordionTab_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 14);
    ɵngcc0.ɵɵtemplate(1, DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_p_accordionTab_2_div_1_Template, 4, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fieldSource_r19 = ctx.$implicit;
    const i_r20 = ctx.index;
    ɵngcc0.ɵɵproperty("header", fieldSource_r19.display)("selected", i_r20 == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", fieldSource_r19 == null ? null : fieldSource_r19.fieldItems);
} }
function DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "p-accordion", 12);
    ɵngcc0.ɵɵtemplate(2, DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_p_accordionTab_2_Template, 2, 3, "p-accordionTab", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r13.fieldSources);
} }
const _c30 = function () { return { "height": "500px" }; };
const _c31 = function () { return [70, 30]; };
function DwHtmlEditComponent_div_0_p_splitter_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-splitter", 8);
    ɵngcc0.ɵɵtemplate(1, DwHtmlEditComponent_div_0_p_splitter_4_ng_template_1_Template, 2, 1, "ng-template", 9);
    ɵngcc0.ɵɵtemplate(2, DwHtmlEditComponent_div_0_p_splitter_4_ng_template_2_Template, 3, 1, "ng-template", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(3, _c30));
    ɵngcc0.ɵɵproperty("panelSizes", ɵngcc0.ɵɵpureFunction0(4, _c31));
} }
function DwHtmlEditComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", null, 1);
    ɵngcc0.ɵɵtemplate(2, DwHtmlEditComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, DwHtmlEditComponent_div_0_div_3_Template, 5, 4, "div", 0);
    ɵngcc0.ɵɵtemplate(4, DwHtmlEditComponent_div_0_p_splitter_4_Template, 3, 5, "p-splitter", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.fieldSources || ctx_r0.fieldSources.length == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.viewMarkup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.viewMarkup && (ctx_r0.fieldSources == null ? null : ctx_r0.fieldSources.length) > 0);
} }
function DwLoadingComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 1);
    ɵngcc0.ɵɵelement(1, "i", 2);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.text);
} }
const _c32 = [[["", "col1", ""]], [["", "col2", ""]]];
const _c33 = ["[col1]", "[col2]"];
function DwDynamicLoaderComponent_ng_template_0_Template(rf, ctx) { }
function DwMessageComponent_div_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function DwMessageComponent_div_0_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.close(); });
    ɵngcc0.ɵɵelementStart(1, "span", 7);
    ɵngcc0.ɵɵtext(2, "\u00D7");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMessageComponent_div_0_h4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.message.messageHeading);
} }
function DwMessageComponent_div_0_a_4_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMap(ctx_r6.message.linkIcon);
} }
function DwMessageComponent_div_0_a_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function DwMessageComponent_div_0_a_4_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.linkClick(); });
    ɵngcc0.ɵɵtemplate(1, DwMessageComponent_div_0_a_4_i_1_Template, 1, 2, "i", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.message.linkIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.message.linkText, " ");
} }
function DwMessageComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, DwMessageComponent_div_0_button_1_Template, 3, 0, "button", 2);
    ɵngcc0.ɵɵtemplate(2, DwMessageComponent_div_0_h4_2_Template, 2, 1, "h4", 3);
    ɵngcc0.ɵɵelement(3, "dw-html-view", 4);
    ɵngcc0.ɵɵtemplate(4, DwMessageComponent_div_0_a_4_Template, 3, 2, "a", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.alertClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.message.allowClose);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.message.messageHeading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.message.messageBody);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.message.linkUrl);
} }
function DwBootstrapDateTimeInputComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DwBootstrapDateTimeInputComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(2); return _r0.toggle(); })("focus", function DwBootstrapDateTimeInputComponent_button_4_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onButtonFocus(); });
    ɵngcc0.ɵɵelement(1, "i", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disabled);
} }
function DwBootstrapDateTimeInputComponent_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DwBootstrapDateTimeInputComponent_button_5_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(2); return _r0.toggle(); })("focus", function DwBootstrapDateTimeInputComponent_button_5_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onButtonFocus(); });
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.disabled);
} }
function DwBootstrapDateTimeInputComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1, "Date is not valid. Please enter a valid date");
    ɵngcc0.ɵɵelementEnd();
} }
function DwBootstrapDateTimeInputComponent_ng_template_7_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwBootstrapDateTimeInputComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwBootstrapDateTimeInputComponent_ng_template_7_ng_container_0_Template, 1, 0, "ng-container", 13);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r8 = ɵngcc0.ɵɵreference(12);
    const _r6 = ɵngcc0.ɵɵreference(10);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.timeOnly)("ngIfThen", _r8)("ngIfElse", _r6);
} }
function DwBootstrapDateTimeInputComponent_ng_template_9_ngb_timepicker_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 17, 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwBootstrapDateTimeInputComponent_ng_template_9_ngb_timepicker_3_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onTimeChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r18.datetime)("seconds", ctx_r18.dateOptions == null ? null : ctx_r18.dateOptions.showSeconds)("hourStep", ctx_r18.dateOptions == null ? null : ctx_r18.dateOptions.hourStep)("minuteStep", ctx_r18.dateOptions == null ? null : ctx_r18.dateOptions.minuteStep)("secondStep", ctx_r18.dateOptions == null ? null : ctx_r18.dateOptions.secondStep)("meridian", !ctx_r18.use24HourTime);
} }
function DwBootstrapDateTimeInputComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "ngb-datepicker", 14, 15);
    ɵngcc0.ɵɵlistener("dateSelect", function DwBootstrapDateTimeInputComponent_ng_template_9_Template_ngb_datepicker_dateSelect_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(2); return ctx_r22.onDateSelection($event, _r0); })("select", function DwBootstrapDateTimeInputComponent_ng_template_9_Template_ngb_datepicker_select_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r24 = ɵngcc0.ɵɵnextContext(); const _r0 = ɵngcc0.ɵɵreference(2); return ctx_r24.onDateSelection($event, _r0); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwBootstrapDateTimeInputComponent_ng_template_9_ngb_timepicker_3_Template, 2, 6, "ngb-timepicker", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.datetime)("markDisabled", ctx_r7.isDisabledFunc())("firstDayOfWeek", ctx_r7.firstDayOfWeek)("displayMonths", ctx_r7.monthsToShow);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.showTime && ctx_r7.datetime);
} }
function DwBootstrapDateTimeInputComponent_ng_template_11_ngb_timepicker_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngb-timepicker", 17, 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwBootstrapDateTimeInputComponent_ng_template_11_ngb_timepicker_1_Template_ngb_timepicker_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.onTimeChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r25.datetime)("seconds", ctx_r25.dateOptions == null ? null : ctx_r25.dateOptions.showSeconds)("hourStep", ctx_r25.dateOptions == null ? null : ctx_r25.dateOptions.hourStep)("minuteStep", ctx_r25.dateOptions == null ? null : ctx_r25.dateOptions.minuteStep)("secondStep", ctx_r25.dateOptions == null ? null : ctx_r25.dateOptions.secondStep)("meridian", !ctx_r25.use24HourTime);
} }
function DwBootstrapDateTimeInputComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwBootstrapDateTimeInputComponent_ng_template_11_ngb_timepicker_1_Template, 2, 6, "ngb-timepicker", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.showTime);
} }
function DwUiConfigListComponent_ng_template_3_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 12);
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", item_r4[ctx_r5.config.iconClassField]);
} }
function DwUiConfigListComponent_ng_template_3_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", item_r4[ctx_r6.config.iconClassField])("title", item_r4[ctx_r6.config.iconTooltipField]);
} }
function DwUiConfigListComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, DwUiConfigListComponent_ng_template_3_i_2_Template, 1, 1, "i", 9);
    ɵngcc0.ɵɵtemplate(3, DwUiConfigListComponent_ng_template_3_i_3_Template, 1, 2, "i", 10);
    ɵngcc0.ɵɵelementStart(4, "i", 11);
    ɵngcc0.ɵɵlistener("click", function DwUiConfigListComponent_ng_template_3_Template_i_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r10); const item_r4 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onRemoveItem(item_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r0.config == null ? null : ctx_r0.config.displayField) ? item_r4[ctx_r0.config.displayField] : item_r4, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config.iconClassField && item_r4[ctx_r0.config.iconClassField] && (!ctx_r0.config.iconTooltipField || !item_r4[ctx_r0.config.iconTooltipField]));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config.iconClassField && item_r4[ctx_r0.config.iconClassField] && ctx_r0.config.iconTooltipField && item_r4[ctx_r0.config.iconTooltipField]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.config == null ? null : ctx_r0.config.allowRemoveItem));
} }
function DwUiConfigListComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵprojection(2, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwUiConfigListComponent_p_tabPanel_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 16);
    ɵngcc0.ɵɵprojection(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("header", (ctx_r2.config == null ? null : ctx_r2.config.configureItemHeading) || "Configure Item");
} }
function DwUiConfigListComponent_p_tabPanel_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 16);
    ɵngcc0.ɵɵprojection(1, 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("header", ctx_r3.config == null ? null : ctx_r3.config.additionalTabHeading);
} }
const _c34 = [[["", "addItemsTab", ""]], [["", "actionBar", ""]], [["", "configureItemTab", ""]], [["", "additionalTab", ""]]];
const _c35 = function (a0) { return [a0]; };
const _c36 = ["[addItemsTab]", "[actionBar]", "[configureItemTab]", "[additionalTab]"];
const _c37 = [[["", "header", ""]], [["", "body", ""]]];
const _c38 = function (a0) { return { "dw-container-collapsable": a0 }; };
const _c39 = ["[header]", "[body]"];
const _c40 = function (a0) { return { exact: a0 }; };
function DwMenuLinkComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 1);
    ɵngcc0.ɵɵlistener("click", function DwMenuLinkComponent_ng_container_0_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.hideMobile(); });
    ɵngcc0.ɵɵelement(2, "i", 2);
    ɵngcc0.ɵɵelementStart(3, "span", 3);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "a", 4);
    ɵngcc0.ɵɵlistener("click", function DwMenuLinkComponent_ng_container_0_Template_a_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.doAction(ctx_r4.menu, $event); });
    ɵngcc0.ɵɵelement(6, "i", 2);
    ɵngcc0.ɵɵelementStart(7, "span", 3);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.menu.url)("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction1(18, _c40, ctx_r0.menu == null ? null : ctx_r0.menu.data == null ? null : ctx_r0.menu.data.highlightOnExactMatch))("ngClass", ctx_r0.className)("hidden", ctx_r0.menu == null ? null : ctx_r0.menu.data == null ? null : ctx_r0.menu.data.isAction);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate2("nav-icon ", ctx_r0.additionalIconClass, " ", ctx_r0.menu.data.iconCssClass, "");
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.hideIcon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.menu.display);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.className)("hidden", !(ctx_r0.menu == null ? null : ctx_r0.menu.data == null ? null : ctx_r0.menu.data.isAction));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate2("", ctx_r0.additionalIconClass, " ", ctx_r0.menu.data.iconCssClass, "");
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.hideIcon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.menu.display);
} }
function DwMenuLinkComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 5);
    ɵngcc0.ɵɵlistener("configure", function DwMenuLinkComponent_ng_container_1_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.configureMenuComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r1.menu.data.menuComponent);
} }
function DwDateRangeInputComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "ngb-datepicker", 9, 10);
    ɵngcc0.ɵɵlistener("dateSelect", function DwDateRangeInputComponent_ng_template_6_Template_ngb_datepicker_dateSelect_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onDateSelection($event); })("select", function DwDateRangeInputComponent_ng_template_6_Template_ngb_datepicker_select_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onDateSelection($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.startDateTime)("displayMonths", 2)("dayTemplate", _r3)("firstDayOfWeek", ctx_r2.firstDayOfWeek);
} }
function DwDateRangeInputComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵlistener("mouseenter", function DwDateRangeInputComponent_ng_template_8_Template_span_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const date_r9 = ctx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.hoveredDate = date_r9; })("mouseleave", function DwDateRangeInputComponent_ng_template_8_Template_span_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.hoveredDate = null; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r9 = ctx.$implicit;
    const focused_r10 = ctx.focused;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("focused", focused_r10)("range", ctx_r4.isRange(date_r9))("faded", ctx_r4.isHovered(date_r9) || ctx_r4.isInside(date_r9));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", date_r9.day, " ");
} }
function DwSecurityUserMenuComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-menu-link", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menu_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menu", menu_r1)("menuLocation", "user");
} }
function DwActionGroupConfigComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " No buttons to preview ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwActionGroupConfigComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DwActionGroupConfigComponent_div_10_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const action_r5 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.addItem(action_r5); });
    ɵngcc0.ɵɵelement(2, "i", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", action_r5.display, " ");
} }
function DwActionGroupConfigComponent_dw_action_config_15_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-action-config", 17);
    ɵngcc0.ɵɵlistener("actionPreferenceChange", function DwActionGroupConfigComponent_dw_action_config_15_Template_dw_action_config_actionPreferenceChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectedItem = $event; })("actionPreferenceChange", function DwActionGroupConfigComponent_dw_action_config_15_Template_dw_action_config_actionPreferenceChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("actionPreference", ctx_r4.selectedItem)("actionConfigPreferences", ctx_r4.actionConfigPreferences)("actions", ctx_r4.actions)("showButtonConfig", ctx_r4.showButtonConfig)("showMenuConfig", ctx_r4.showMenuConfig)("configContext", ctx_r4.configContext)("showEnableVisibleConfig", ctx_r4.showEnableVisibleConfig);
} }
function DwActionConfigComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Action Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwActionConfigComponent_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", action_r9.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", action_r9.display, " ");
} }
function DwActionConfigComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "dw-dynamic-loader", 15);
    ɵngcc0.ɵɵlistener("configure", function DwActionConfigComponent_div_10_Template_dw_dynamic_loader_configure_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.configureModeActionConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("component", ctx_r2.actionConfigPreferences == null ? null : ctx_r2.actionConfigPreferences.additionalConfigComponent);
} }
function DwActionConfigComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "dw-dynamic-loader", 15);
    ɵngcc0.ɵɵlistener("configure", function DwActionConfigComponent_div_11_Template_dw_dynamic_loader_configure_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.configureActionConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("component", ctx_r3.currentActionItem == null ? null : ctx_r3.currentActionItem.configComponent);
} }
function DwActionConfigComponent_p_accordionTab_12_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 16);
    ɵngcc0.ɵɵelementStart(1, "dw-security-check-config", 17);
    ɵngcc0.ɵɵlistener("configChange", function DwActionConfigComponent_p_accordionTab_12_Template_dw_security_check_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.securityConfigChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r4.securityConfigFC.value)("configContext", ctx_r4.configContext);
} }
function DwActionConfigComponent_p_accordionTab_13_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 18);
    ɵngcc0.ɵɵelementStart(1, "dw-button-config", 17);
    ɵngcc0.ɵɵlistener("configChange", function DwActionConfigComponent_p_accordionTab_13_Template_dw_button_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.buttonConfigChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r5.buttonConfigFC.value)("configContext", ctx_r5.configContext);
} }
function DwActionConfigComponent_p_accordionTab_14_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 19);
    ɵngcc0.ɵɵelementStart(1, "dw-context-menu-config", 17);
    ɵngcc0.ɵɵlistener("configChange", function DwActionConfigComponent_p_accordionTab_14_Template_dw_context_menu_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.menuConfigChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r6.menuConfigFC.value)("configContext", ctx_r6.configContext);
} }
function DwActionConfigComponent_p_accordionTab_15_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 20);
    ɵngcc0.ɵɵelementStart(1, "dw-ui-child-config-host", 21);
    ɵngcc0.ɵɵlistener("configChange", function DwActionConfigComponent_p_accordionTab_15_Template_dw_ui_child_config_host_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.enableVisibleConfigFC.value = $event; })("configChange", function DwActionConfigComponent_p_accordionTab_15_Template_dw_ui_child_config_host_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.enableVisibleConfigChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r7.expressionVisibilityConfigComponent)("config", ctx_r7.enableVisibleConfigFC.value)("configContext", ctx_r7.configContext);
} }
function DwActionConfigComponent_p_accordionTab_16_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 22);
    ɵngcc0.ɵɵelementStart(1, "dw-confirm-dialog-config", 17);
    ɵngcc0.ɵɵlistener("configChange", function DwActionConfigComponent_p_accordionTab_16_Template_dw_confirm_dialog_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.confirmConfigChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r8.confirmConfigFC.value)("configContext", ctx_r8.configContext);
} }
const _c41 = ["*", [["", "right", ""]]];
const _c42 = ["*", "[right]"];
function DwButtonConfigComponent_ng_container_0_ng_container_7_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Button Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_div_7_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(3); return ctx_r4.config.buttonText = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_div_7_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config.buttonText)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c4));
} }
function DwButtonConfigComponent_ng_container_0_ng_container_7_div_31_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Button Command");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_div_31_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.config.commandName = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_div_31_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.config.commandName)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(3, _c4))("disabled", ctx_r3.config.formAction !== "custom");
} }
function DwButtonConfigComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Parent Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.config.useParentDisplay = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwButtonConfigComponent_ng_container_0_ng_container_7_div_7_Template, 5, 3, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "div", 1);
    ɵngcc0.ɵɵelementStart(9, "div", 6);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Button Tooltip");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.config.buttonTitle = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_12_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 1);
    ɵngcc0.ɵɵelementStart(14, "div", 6);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Button Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_select_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.config.buttonType = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_select_ngModelChange_17_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onChange(); });
    ɵngcc0.ɵɵelementStart(18, "option", 9);
    ɵngcc0.ɵɵtext(19, "Standard");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "option", 10);
    ɵngcc0.ɵɵtext(21, "Icon");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "option", 11);
    ɵngcc0.ɵɵtext(23, "Icon Only (No Text)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "option", 12);
    ɵngcc0.ɵɵtext(25, "Link");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 1);
    ɵngcc0.ɵɵelementStart(27, "div", 6);
    ɵngcc0.ɵɵelementStart(28, "label", 13);
    ɵngcc0.ɵɵtext(29, "Action Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_30_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.config.actionMessage = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_30_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(31, DwButtonConfigComponent_ng_container_0_ng_container_7_div_31_Template, 5, 4, "div", 5);
    ɵngcc0.ɵɵelementStart(32, "div", 1);
    ɵngcc0.ɵɵelementStart(33, "div", 6);
    ɵngcc0.ɵɵelementStart(34, "label");
    ɵngcc0.ɵɵtext(35, "Button Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_36_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.config.buttonClass = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_36_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(37, "div", 1);
    ɵngcc0.ɵɵelementStart(38, "div", 6);
    ɵngcc0.ɵɵelementStart(39, "label");
    ɵngcc0.ɵɵtext(40, "Icon Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(41, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_41_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.config.iconClass = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_input_ngModelChange_41_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "div", 1);
    ɵngcc0.ɵɵelementStart(43, "div", 2);
    ɵngcc0.ɵɵelementStart(44, "label");
    ɵngcc0.ɵɵtext(45, "Show Icon After Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(46, "div", 3);
    ɵngcc0.ɵɵelementStart(47, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_47_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.config.showIconAfterText = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_47_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(48, "div", 1);
    ɵngcc0.ɵɵelementStart(49, "div", 2);
    ɵngcc0.ɵɵelementStart(50, "label");
    ɵngcc0.ɵɵtext(51, "Include in Button Group ");
    ɵngcc0.ɵɵelement(52, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(53, "div", 3);
    ɵngcc0.ɵɵelementStart(54, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_54_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.config.includeInGroup = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_54_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(55, "div", 1);
    ɵngcc0.ɵɵelementStart(56, "div", 2);
    ɵngcc0.ɵɵelementStart(57, "label");
    ɵngcc0.ɵɵtext(58, "Show Divider before ");
    ɵngcc0.ɵɵelement(59, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(60, "div", 3);
    ɵngcc0.ɵɵelementStart(61, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_61_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.config.showDividerBefore = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_61_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.useParentDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.config.useParentDisplay);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.buttonTitle)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(16, _c4));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.buttonType)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(17, _c4));
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.actionMessage)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(18, _c4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showCommand);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.buttonClass)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(19, _c4));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.iconClass)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(20, _c4));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.showIconAfterText);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.includeInGroup);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.showDividerBefore);
} }
function DwButtonConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Defaults");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwButtonConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.config.useButtonDefaults = $event; })("ngModelChange", function DwButtonConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwButtonConfigComponent_ng_container_0_ng_container_7_Template, 62, 21, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.useButtonDefaults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.config.useButtonDefaults);
} }
function DwActionBarComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwActionBarComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtemplate(3, DwActionBarComponent_ng_container_0_ng_container_3_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.buttonContainerStyle == null ? null : ctx_r0.buttonContainerStyle.containerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.buttonContainerStyle == null ? null : ctx_r0.buttonContainerStyle.containerInnerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DwActionBarComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwActionBarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwActionBarComponent_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DwActionBarComponent_ng_template_2_ng_container_0_ng_container_2_dw_dynamic_loader_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 8);
    ɵngcc0.ɵɵlistener("configure", function DwActionBarComponent_ng_template_2_ng_container_0_ng_container_2_dw_dynamic_loader_1_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const actionPref_r7 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.configureComponent($event, actionPref_r7); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const index_r8 = ɵngcc0.ɵɵnextContext(2).index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("component", ctx_r11.actionRegistrations[index_r8] == null ? null : ctx_r11.actionRegistrations[index_r8].actionComponent);
} }
function DwActionBarComponent_ng_template_2_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwActionBarComponent_ng_template_2_ng_container_0_ng_container_2_dw_dynamic_loader_1_Template, 1, 1, "dw-dynamic-loader", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "component");
} }
function DwActionBarComponent_ng_template_2_ng_container_0_dw_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-button", 9);
    ɵngcc0.ɵɵlistener("click", function DwActionBarComponent_ng_template_2_ng_container_0_dw_button_3_Template_dw_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const actionPref_r7 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.click(actionPref_r7, false, $event); })("auxClick", function DwActionBarComponent_ng_template_2_ng_container_0_dw_button_3_Template_dw_button_auxClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const actionPref_r7 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.auxClick(actionPref_r7, $event); })("middleclick", function DwActionBarComponent_ng_template_2_ng_container_0_dw_button_3_Template_dw_button_middleclick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const actionPref_r7 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.click(actionPref_r7, true, $event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    const actionPref_r7 = ctx_r23.$implicit;
    const index_r8 = ctx_r23.index;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("buttonConfig", actionPref_r7.buttonConfig)("firing", index_r8 == ctx_r10.firingActionIndex)("hidden", actionPref_r7.buttonConfig == null ? null : actionPref_r7.buttonConfig.includeInGroup);
} }
function DwActionBarComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 5);
    ɵngcc0.ɵɵtemplate(2, DwActionBarComponent_ng_template_2_ng_container_0_ng_container_2_Template, 2, 1, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, DwActionBarComponent_ng_template_2_ng_container_0_dw_button_3_Template, 1, 3, "dw-button", 6);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const actionPref_r7 = ctx.$implicit;
    const index_r8 = ctx.index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r6.actionRegistrations[index_r8] == null ? null : ctx_r6.actionRegistrations[index_r8].decoratorType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !actionPref_r7.buttonConfig.hidden);
} }
function DwActionBarComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwActionBarComponent_ng_template_2_ng_container_0_Template, 4, 2, "ng-container", 4);
    ɵngcc0.ɵɵprojection(1);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.finalActionPreferences)("ngForTrackBy", ctx_r3.trackByMethod);
} }
function DwContextMenuConfigComponent_ng_container_0_ng_container_12_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Button Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_div_7_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(3); return ctx_r3.config.menuDisplay = $event; })("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_div_7_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(3); return ctx_r5.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config.menuDisplay)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c4));
} }
function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Parent Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.config.useParentDisplay = $event; })("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwContextMenuConfigComponent_ng_container_0_ng_container_12_div_7_Template, 5, 3, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "div", 1);
    ɵngcc0.ɵɵelementStart(9, "div", 2);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Menu Icon");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.config.menuIconClass = $event; })("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template_input_ngModelChange_12_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 1);
    ɵngcc0.ɵɵelementStart(14, "div", 2);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Item Requirement");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template_select_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.config.itemRequirement = $event; })("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template_select_ngModelChange_17_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onChange(); });
    ɵngcc0.ɵɵelementStart(18, "option", 9);
    ɵngcc0.ɵɵtext(19, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "option", 10);
    ɵngcc0.ɵɵtext(21, "Single");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "option", 11);
    ɵngcc0.ɵɵtext(23, "Multiple");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.useParentDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.config.useParentDisplay);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.menuIconClass)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c4));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.itemRequirement);
} }
function DwContextMenuConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Menu Group");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.config.menuGroupDisplay = $event; })("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_Template_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 1);
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Use Defaults");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 5);
    ɵngcc0.ɵɵelementStart(11, "p-inputSwitch", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.config.useMenuDefaults = $event; })("ngModelChange", function DwContextMenuConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_11_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, DwContextMenuConfigComponent_ng_container_0_ng_container_12_Template, 24, 6, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.menuGroupDisplay)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(4, _c4));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.useMenuDefaults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.config.useMenuDefaults);
} }
function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Permission");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-security-permission-select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_7_Template_dw_security_permission_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(3); return ctx_r5.config.permissionMeaning = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_7_Template_dw_security_permission_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config.permissionMeaning);
} }
function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Emulated Permissions");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_8_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.config.useEmulatedPermissions = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_8_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.config.useEmulatedPermissions);
} }
function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "hr");
    ɵngcc0.ɵɵelementStart(2, "b");
    ɵngcc0.ɵɵtext(3, "Item Security");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "div", 2);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Require Can Create");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template_p_inputSwitch_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.config.requireCanCreate = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template_p_inputSwitch_ngModelChange_9_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 5);
    ɵngcc0.ɵɵelementStart(11, "div", 2);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Require Can Update");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵelementStart(15, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template_p_inputSwitch_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.config.requireCanUpdate = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template_p_inputSwitch_ngModelChange_15_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 5);
    ɵngcc0.ɵɵelementStart(17, "div", 2);
    ɵngcc0.ɵɵelementStart(18, "label");
    ɵngcc0.ɵɵtext(19, "Require Can Delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 3);
    ɵngcc0.ɵɵelementStart(21, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template_p_inputSwitch_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.config.requireCanDelete = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template_p_inputSwitch_ngModelChange_21_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r17 = ɵngcc0.ɵɵnextContext(3); return ctx_r17.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.config.requireCanCreate);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.config.requireCanUpdate);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.config.requireCanDelete);
} }
function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Require Authentication");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.config.requireAuthentication = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_7_Template, 5, 1, "div", 6);
    ɵngcc0.ɵɵtemplate(8, DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_div_8_Template, 6, 1, "div", 6);
    ɵngcc0.ɵɵtemplate(9, DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_ng_container_9_Template, 22, 3, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.requireAuthentication);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.config.requireAuthentication);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.config.requireAuthentication);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.configContext.itemName);
} }
function DwSecurityCheckConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Security Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.config.useSecurityDefaults = $event; })("ngModelChange", function DwSecurityCheckConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwSecurityCheckConfigComponent_ng_container_0_ng_container_7_Template, 10, 4, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.hideSecurityDefault);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.useSecurityDefaults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.config.useSecurityDefaults || ctx_r0.hideSecurityDefault);
} }
const _c43 = function () { return { "width": "100%" }; };
function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Title");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_7_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(3); return ctx_r4.config.title = $event; })("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_7_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config.title)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c4));
} }
function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_8_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.config.message = $event; })("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_8_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.config.message)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c4));
} }
function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Show Confirm Dialog");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.config.showConfirmDialog = $event; })("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_7_Template, 5, 3, "div", 5);
    ɵngcc0.ɵɵtemplate(8, DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_div_8_Template, 5, 3, "div", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.showConfirmDialog);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.config.showConfirmDialog);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.config.showConfirmDialog);
} }
function DwConfirmDialogConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Defaults");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.config.useConfirmDefaults = $event; })("ngModelChange", function DwConfirmDialogConfigComponent_ng_container_0_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwConfirmDialogConfigComponent_ng_container_0_ng_container_7_Template, 9, 3, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.useConfirmDefaults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.config.useConfirmDefaults);
} }
const _c44 = function (a0) { return { "hide": a0 }; };
function DwActionGroupModesConfigComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "dw-pills", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwActionGroupModesConfigComponent_div_0_div_1_Template_dw_pills_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.currentModeValue = $event; })("ngModelChange", function DwActionGroupModesConfigComponent_div_0_div_1_Template_dw_pills_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.setupMode(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("items", ctx_r1.actionModes)("ngModel", ctx_r1.currentModeValue);
} }
function DwActionGroupModesConfigComponent_div_0_dw_action_group_config_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-action-group-config", 6);
    ɵngcc0.ɵɵlistener("actionPreferencesChange", function DwActionGroupModesConfigComponent_div_0_dw_action_group_config_2_Template_dw_action_group_config_actionPreferencesChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.modeActions = $event; })("actionPreferencesChange", function DwActionGroupModesConfigComponent_div_0_dw_action_group_config_2_Template_dw_action_group_config_actionPreferencesChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r2.modeActions)("actionConfigPreferences", ctx_r2.actionConfigPreferences)("size", ctx_r2.size)("actionTypes", ctx_r2.currentMode.actionTypes)("showButtonConfig", ctx_r2.currentMode.showButtonConfig)("buttonContainerStyleKey", ctx_r2.currentMode.buttonContainerStyleKey)("showMenuConfig", ctx_r2.currentMode.showMenuConfig)("configContext", ctx_r2.configContext);
} }
function DwActionGroupModesConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwActionGroupModesConfigComponent_div_0_div_1_Template, 3, 2, "div", 1);
    ɵngcc0.ɵɵtemplate(2, DwActionGroupModesConfigComponent_div_0_dw_action_group_config_2_Template, 1, 8, "dw-action-group-config", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.actionModes == null ? null : ctx_r0.actionModes.length) > 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentMode);
} }
function DwRadioListComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 2);
    ɵngcc0.ɵɵelementStart(1, "label", 3);
    ɵngcc0.ɵɵelementStart(2, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRadioListComponent_span_1_Template_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.setTranslatedValue($event); })("change", function DwRadioListComponent_span_1_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onChange($event); })("keyup", function DwRadioListComponent_span_1_Template_input_keyup_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onKeyup($event); })("blur", function DwRadioListComponent_span_1_Template_input_blur_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onBlur($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("name", ctx_r0.groupName)("value", item_r1.value)("disabled", ctx_r0.disabled)("ngModel", ctx_r0.translatedValue);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1.display);
} }
function DwValidationConfigBaseComponent_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Show after submission ");
    ɵngcc0.ɵɵelement(4, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwValidationConfigBaseComponent_ng_container_3_div_1_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.config.showAfterSubmitted = $event; })("ngModelChange", function DwValidationConfigBaseComponent_ng_container_3_div_1_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.showAfterSubmitted);
} }
function DwValidationConfigBaseComponent_ng_container_3_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Override Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwValidationConfigBaseComponent_ng_container_3_div_2_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.config.overrideMessage = $event; })("ngModelChange", function DwValidationConfigBaseComponent_ng_container_3_div_2_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config.overrideMessage);
} }
function DwValidationConfigBaseComponent_ng_container_3_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "button", 10);
    ɵngcc0.ɵɵlistener("click", function DwValidationConfigBaseComponent_ng_container_3_div_3_div_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const tag_r12 = ctx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.addTag(tag_r12); });
    ɵngcc0.ɵɵelement(2, "i", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tag_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", tag_r12.display, " ");
} }
function DwValidationConfigBaseComponent_ng_container_3_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "textarea", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwValidationConfigBaseComponent_ng_container_3_div_3_Template_textarea_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.config.message = $event; })("ngModelChange", function DwValidationConfigBaseComponent_ng_container_3_div_3_Template_textarea_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwValidationConfigBaseComponent_ng_container_3_div_3_div_5_Template, 4, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.config.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.validationRuleRegistration == null ? null : ctx_r3.validationRuleRegistration.tags);
} }
function DwValidationConfigBaseComponent_ng_container_3_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-ui-child-config-host", 12);
    ɵngcc0.ɵɵlistener("configChange", function DwValidationConfigBaseComponent_ng_container_3_ng_container_4_Template_dw_ui_child_config_host_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.config = $event; })("configChange", function DwValidationConfigBaseComponent_ng_container_3_ng_container_4_Template_dw_ui_child_config_host_configChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r4.validationRuleRegistration.configComponent)("config", ctx_r4.config)("configContext", ctx_r4.configContext);
} }
function DwValidationConfigBaseComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwValidationConfigBaseComponent_ng_container_3_div_1_Template, 7, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, DwValidationConfigBaseComponent_ng_container_3_div_2_Template, 6, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(3, DwValidationConfigBaseComponent_ng_container_3_div_3_Template, 6, 2, "div", 1);
    ɵngcc0.ɵɵtemplate(4, DwValidationConfigBaseComponent_ng_container_3_ng_container_4_Template, 2, 3, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.validationRuleRegistration.showAfterSubmittedOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.validationRuleRegistration.requireMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config.overrideMessage || ctx_r0.validationRuleRegistration.requireMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.validationRuleRegistration == null ? null : ctx_r0.validationRuleRegistration.configComponent);
} }
function DwUserPasswordResetComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwUserPasswordResetComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwUserPasswordResetComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function DwUserPasswordResetComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwUserPasswordResetComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwUserPasswordResetComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(8);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
} }
function DwUserPasswordResetComponent_ng_template_5_i_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 26);
} }
function DwUserPasswordResetComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1, "Forgot Password");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelement(3, "dw-message", 9);
    ɵngcc0.ɵɵelementStart(4, "div", 10);
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵelement(6, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 13);
    ɵngcc0.ɵɵelementStart(8, "div", 14);
    ɵngcc0.ɵɵelementStart(9, "div", 15);
    ɵngcc0.ɵɵelementStart(10, "div", 16);
    ɵngcc0.ɵɵelement(11, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 18);
    ɵngcc0.ɵɵelementStart(13, "label", 19);
    ɵngcc0.ɵɵtext(14, "Username/E-mail");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "input", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserPasswordResetComponent_ng_template_5_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.userName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "a", 21);
    ɵngcc0.ɵɵlistener("click", function DwUserPasswordResetComponent_ng_template_5_Template_a_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.showResetPassword(); });
    ɵngcc0.ɵɵtext(17, "I already have a code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 15);
    ɵngcc0.ɵɵelementStart(19, "div", 22);
    ɵngcc0.ɵɵelementStart(20, "button", 23);
    ɵngcc0.ɵɵlistener("click", function DwUserPasswordResetComponent_ng_template_5_Template_button_click_20_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.sendResetEmail(); });
    ɵngcc0.ɵɵtext(21, "Send Recovery E-mail ");
    ɵngcc0.ɵɵtemplate(22, DwUserPasswordResetComponent_ng_template_5_i_22_Template, 1, 0, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "button", 25);
    ɵngcc0.ɵɵlistener("click", function DwUserPasswordResetComponent_ng_template_5_Template_button_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.cancel(); });
    ɵngcc0.ɵɵtext(24, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("message", ctx_r3.message);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.userName);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("disabled", ctx_r3.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.processing);
} }
function DwUserPasswordResetComponent_ng_template_7_i_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 26);
} }
function DwUserPasswordResetComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1, "Reset your Password");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelement(3, "dw-message", 9);
    ɵngcc0.ɵɵelementStart(4, "div", 10);
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵelement(6, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 13);
    ɵngcc0.ɵɵelementStart(8, "div", 14);
    ɵngcc0.ɵɵelementStart(9, "div", 15);
    ɵngcc0.ɵɵelementStart(10, "div", 16);
    ɵngcc0.ɵɵelement(11, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 18);
    ɵngcc0.ɵɵelementStart(13, "label", 19);
    ɵngcc0.ɵɵtext(14, "Reset Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "input", 28);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserPasswordResetComponent_ng_template_7_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.resetCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 15);
    ɵngcc0.ɵɵelementStart(17, "div", 16);
    ɵngcc0.ɵɵelement(18, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 18);
    ɵngcc0.ɵɵelementStart(20, "label", 19);
    ɵngcc0.ɵɵtext(21, "Username/E-mail");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "input", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserPasswordResetComponent_ng_template_7_Template_input_ngModelChange_22_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.userName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "dw-password", 30);
    ɵngcc0.ɵɵlistener("passwordChange", function DwUserPasswordResetComponent_ng_template_7_Template_dw_password_passwordChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.newPassword = $event; })("isPasswordValidChange", function DwUserPasswordResetComponent_ng_template_7_Template_dw_password_isPasswordValidChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.isPasswordValid = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 15);
    ɵngcc0.ɵɵelementStart(25, "div", 22);
    ɵngcc0.ɵɵelementStart(26, "button", 23);
    ɵngcc0.ɵɵlistener("click", function DwUserPasswordResetComponent_ng_template_7_Template_button_click_26_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.resetPassword2(); });
    ɵngcc0.ɵɵtext(27, "Reset Password ");
    ɵngcc0.ɵɵtemplate(28, DwUserPasswordResetComponent_ng_template_7_i_28_Template, 1, 0, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "button", 25);
    ɵngcc0.ɵɵlistener("click", function DwUserPasswordResetComponent_ng_template_7_Template_button_click_29_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.cancel(); });
    ɵngcc0.ɵɵtext(30, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("message", ctx_r5.message);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.resetCode);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.userName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("password", ctx_r5.newPassword)("isPasswordValid", ctx_r5.isPasswordValid);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r5.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.processing);
} }
function DwUserChangePasswordComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwUserChangePasswordComponent_ng_template_3_ng_container_23_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵelementStart(1, "a", 30);
    ɵngcc0.ɵɵlistener("click", function DwUserChangePasswordComponent_ng_template_3_ng_container_23_div_1_div_4_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(4); return ctx_r7.resendCode(); });
    ɵngcc0.ɵɵtext(2, "Resend Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwUserChangePasswordComponent_ng_template_3_ng_container_23_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelement(1, "div", 13);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, DwUserChangePasswordComponent_ng_template_3_ng_container_23_div_1_div_4_Template, 3, 0, "div", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.twoFactorMessage, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.showResendCode);
} }
function DwUserChangePasswordComponent_ng_template_3_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwUserChangePasswordComponent_ng_template_3_ng_container_23_div_1_Template, 5, 2, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelement(4, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 15);
    ɵngcc0.ɵɵelementStart(6, "label", 16);
    ɵngcc0.ɵɵtext(7, "Two Factor Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserChangePasswordComponent_ng_template_3_ng_container_23_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.twoFactorCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.twoFactorMessage);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.twoFactorCode);
} }
function DwUserChangePasswordComponent_ng_template_3_i_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 31);
} }
function DwUserChangePasswordComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtext(1, "Change your Password");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelement(3, "dw-message", 6);
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "div", 8);
    ɵngcc0.ɵɵelement(6, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵelementStart(8, "div", 11);
    ɵngcc0.ɵɵelementStart(9, "div", 12);
    ɵngcc0.ɵɵelementStart(10, "div", 13);
    ɵngcc0.ɵɵelement(11, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 15);
    ɵngcc0.ɵɵelementStart(13, "label", 16);
    ɵngcc0.ɵɵtext(14, "Username/E-mail");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserChangePasswordComponent_ng_template_3_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.userName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 12);
    ɵngcc0.ɵɵelementStart(17, "div", 13);
    ɵngcc0.ɵɵelement(18, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 15);
    ɵngcc0.ɵɵelementStart(20, "label", 16);
    ɵngcc0.ɵɵtext(21, "Password");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserChangePasswordComponent_ng_template_3_Template_input_ngModelChange_22_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.oldPassword = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, DwUserChangePasswordComponent_ng_template_3_ng_container_23_Template, 9, 2, "ng-container", 20);
    ɵngcc0.ɵɵelementStart(24, "dw-password", 21);
    ɵngcc0.ɵɵlistener("passwordChange", function DwUserChangePasswordComponent_ng_template_3_Template_dw_password_passwordChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.newPassword = $event; })("isPasswordValidChange", function DwUserChangePasswordComponent_ng_template_3_Template_dw_password_isPasswordValidChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.isPasswordValid = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 12);
    ɵngcc0.ɵɵelementStart(26, "div", 22);
    ɵngcc0.ɵɵelementStart(27, "button", 23);
    ɵngcc0.ɵɵlistener("click", function DwUserChangePasswordComponent_ng_template_3_Template_button_click_27_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.changePassword2(); });
    ɵngcc0.ɵɵtext(28, " Change Password");
    ɵngcc0.ɵɵtemplate(29, DwUserChangePasswordComponent_ng_template_3_i_29_Template, 1, 0, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("message", ctx_r2.message);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.userName);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.oldPassword);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showTwoFactor);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("password", ctx_r2.newPassword)("isPasswordValid", ctx_r2.isPasswordValid);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.processing);
} }
function DwUserRegistrationComponent_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwUserRegistrationComponent_ng_template_14_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 32);
} }
function DwUserRegistrationComponent_ng_template_14_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 33);
} }
function DwUserRegistrationComponent_ng_template_14_i_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 34);
} }
function DwUserRegistrationComponent_ng_template_14_i_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 35);
} }
function DwUserRegistrationComponent_ng_template_14_i_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 36);
} }
function DwUserRegistrationComponent_ng_template_14_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵtext(1, " E-mail address is not valid ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwUserRegistrationComponent_ng_template_14_div_17_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 42);
} }
function DwUserRegistrationComponent_ng_template_14_div_17_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 43);
} }
function DwUserRegistrationComponent_ng_template_14_div_17_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtemplate(2, DwUserRegistrationComponent_ng_template_14_div_17_i_2_Template, 1, 0, "i", 38);
    ɵngcc0.ɵɵtemplate(3, DwUserRegistrationComponent_ng_template_14_div_17_i_3_Template, 1, 0, "i", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 17);
    ɵngcc0.ɵɵelementStart(5, "label", 40);
    ɵngcc0.ɵɵtext(6, "Username");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 41);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserRegistrationComponent_ng_template_14_div_17_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.userRegistration.UserName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.userRegistration.UserName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r11.userRegistration.UserName);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.userRegistration.UserName);
} }
function DwUserRegistrationComponent_ng_template_14_dw_dynamic_loader_19_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 44);
    ɵngcc0.ɵɵlistener("configure", function DwUserRegistrationComponent_ng_template_14_dw_dynamic_loader_19_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.configureRegistrationCustomComponent($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("componentName", ctx_r12.dwUIConfig.registrationConfig == null ? null : ctx_r12.dwUIConfig.registrationConfig.registrationComponentKey);
} }
function DwUserRegistrationComponent_ng_template_14_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 28);
    ɵngcc0.ɵɵelementStart(2, "p-captcha", 45);
    ɵngcc0.ɵɵlistener("onResponse", function DwUserRegistrationComponent_ng_template_14_div_20_Template_p_captcha_onResponse_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.showCapchtaResponse($event); })("onExpire", function DwUserRegistrationComponent_ng_template_14_div_20_Template_p_captcha_onExpire_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.resetCaptcha(); })("initCallback", function DwUserRegistrationComponent_ng_template_14_div_20_Template_p_captcha_initCallback_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.initCapchta($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("siteKey", ctx_r13.captchaConfiguration == null ? null : ctx_r13.captchaConfiguration.siteKey);
} }
function DwUserRegistrationComponent_ng_template_14_i_29_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 46);
} }
function DwUserRegistrationComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtemplate(2, DwUserRegistrationComponent_ng_template_14_i_2_Template, 1, 0, "i", 15);
    ɵngcc0.ɵɵtemplate(3, DwUserRegistrationComponent_ng_template_14_i_3_Template, 1, 0, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 17);
    ɵngcc0.ɵɵelementStart(5, "div", 18);
    ɵngcc0.ɵɵelementStart(6, "dw-floating-label-input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserRegistrationComponent_ng_template_14_Template_dw_floating_label_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.userRegistration.FirstName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 20);
    ɵngcc0.ɵɵelementStart(8, "dw-floating-label-input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserRegistrationComponent_ng_template_14_Template_dw_floating_label_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.userRegistration.LastName = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 13);
    ɵngcc0.ɵɵelementStart(10, "div", 14);
    ɵngcc0.ɵɵtemplate(11, DwUserRegistrationComponent_ng_template_14_i_11_Template, 1, 0, "i", 21);
    ɵngcc0.ɵɵtemplate(12, DwUserRegistrationComponent_ng_template_14_i_12_Template, 1, 0, "i", 22);
    ɵngcc0.ɵɵtemplate(13, DwUserRegistrationComponent_ng_template_14_i_13_Template, 1, 0, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 17);
    ɵngcc0.ɵɵelementStart(15, "dw-floating-label-input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserRegistrationComponent_ng_template_14_Template_dw_floating_label_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.userRegistration.Email = $event; })("ngModelChange", function DwUserRegistrationComponent_ng_template_14_Template_dw_floating_label_input_ngModelChange_15_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.changeEmail(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, DwUserRegistrationComponent_ng_template_14_div_16_Template, 2, 0, "div", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, DwUserRegistrationComponent_ng_template_14_div_17_Template, 8, 3, "div", 25);
    ɵngcc0.ɵɵelementStart(18, "dw-password", 26);
    ɵngcc0.ɵɵlistener("passwordChange", function DwUserRegistrationComponent_ng_template_14_Template_dw_password_passwordChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.userRegistration.Password = $event; })("isPasswordValidChange", function DwUserRegistrationComponent_ng_template_14_Template_dw_password_isPasswordValidChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.isPasswordValid = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(19, DwUserRegistrationComponent_ng_template_14_dw_dynamic_loader_19_Template, 1, 1, "dw-dynamic-loader", 27);
    ɵngcc0.ɵɵtemplate(20, DwUserRegistrationComponent_ng_template_14_div_20_Template, 3, 1, "div", 25);
    ɵngcc0.ɵɵelementStart(21, "div", 13);
    ɵngcc0.ɵɵelementStart(22, "div", 28);
    ɵngcc0.ɵɵelementStart(23, "a", 29);
    ɵngcc0.ɵɵlistener("click", function DwUserRegistrationComponent_ng_template_14_Template_a_click_23_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.gotoLogin(); });
    ɵngcc0.ɵɵtext(24, "I already have an account");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 13);
    ɵngcc0.ɵɵelementStart(26, "div", 28);
    ɵngcc0.ɵɵelementStart(27, "button", 30);
    ɵngcc0.ɵɵlistener("click", function DwUserRegistrationComponent_ng_template_14_Template_button_click_27_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.registerUser(); });
    ɵngcc0.ɵɵtext(28);
    ɵngcc0.ɵɵtemplate(29, DwUserRegistrationComponent_ng_template_14_i_29_Template, 1, 0, "i", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.userRegistration.FirstName && ctx_r2.userRegistration.LastName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.userRegistration.FirstName || !ctx_r2.userRegistration.LastName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("label", "First Name")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbFirstName")("ngModel", ctx_r2.userRegistration.FirstName)("autoComplete", "givenName")("useFloat", ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.useFloatLabelOnRegistration)("placeholder", "First Name");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("label", "Last Name")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbLastName")("ngModel", ctx_r2.userRegistration.LastName)("autoComplete", "familyName")("useFloat", ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.useFloatLabelOnRegistration)("placeholder", "Last Name");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isEmailValid && ctx_r2.userRegistration.Email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.userRegistration.Email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isEmailValid && ctx_r2.userRegistration.Email);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("label", (ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.registrationEmailText) || "E-mail")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbEmail")("ngModel", ctx_r2.userRegistration.Email)("autoComplete", "email")("useFloat", ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.useFloatLabelOnRegistration)("placeholder", "E-mail");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isEmailValid && ctx_r2.userRegistration.Email);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.registrationHideUserName));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("password", ctx_r2.userRegistration.Password)("isPasswordValid", ctx_r2.isPasswordValid)("useFloat", ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.useFloatLabelOnRegistration);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.registrationComponentKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.captchaConfiguration == null ? null : ctx_r2.captchaConfiguration.enableCaptcha) && (ctx_r2.captchaConfiguration == null ? null : ctx_r2.captchaConfiguration.siteKey));
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.processing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r2.dwUIConfig.registrationConfig == null ? null : ctx_r2.dwUIConfig.registrationConfig.registerButtonText) || "Register", " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.processing);
} }
function DwUserRegistrationComponent_ng_template_16_i_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 46);
} }
function DwUserRegistrationComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵtext(3, " To complete your registration, please enter the Two Factor Code that was sent to your e-mail address ");
    ɵngcc0.ɵɵelementStart(4, "div", 47);
    ɵngcc0.ɵɵelementStart(5, "a", 48);
    ɵngcc0.ɵɵlistener("click", function DwUserRegistrationComponent_ng_template_16_Template_a_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.resendCode(); });
    ɵngcc0.ɵɵtext(6, "Resend Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 13);
    ɵngcc0.ɵɵelementStart(8, "div", 14);
    ɵngcc0.ɵɵelement(9, "img", 49);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 17);
    ɵngcc0.ɵɵelementStart(11, "label", 40);
    ɵngcc0.ɵɵtext(12, "Two Factor Code");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "input", 50);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUserRegistrationComponent_ng_template_16_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.twoFactorCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 13);
    ɵngcc0.ɵɵelementStart(15, "div", 28);
    ɵngcc0.ɵɵelementStart(16, "button", 51);
    ɵngcc0.ɵɵlistener("click", function DwUserRegistrationComponent_ng_template_16_Template_button_click_16_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.loginWithTwoFactorCode(); });
    ɵngcc0.ɵɵtext(17, "Complete Registration ");
    ɵngcc0.ɵɵtemplate(18, DwUserRegistrationComponent_ng_template_16_i_18_Template, 1, 0, "i", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.twoFactorCode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.processing);
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_7_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.showStep1(); });
    ɵngcc0.ɵɵtext(1, "Enable Two-Factor Authentication");
    ɵngcc0.ɵɵelementEnd();
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_i_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "h2");
    ɵngcc0.ɵɵtext(4, "Choose your two-factor method");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "label", 6);
    ɵngcc0.ɵɵelementStart(6, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.twoFactorRequest.FactorType = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 8);
    ɵngcc0.ɵɵelementStart(8, "strong");
    ɵngcc0.ɵɵtext(9, "Setup using an app");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 9);
    ɵngcc0.ɵɵtext(11, " Use an application on your phone to get two-factor authentication codes when prompted. We recommend using cloud-based TOTP apps such as: 1Password, Authy, LastPass Authenticator, or Microsoft Authenticator. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "label", 6);
    ɵngcc0.ɵɵelementStart(13, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.twoFactorRequest.FactorType = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "span", 8);
    ɵngcc0.ɵɵelementStart(15, "strong");
    ɵngcc0.ɵɵtext(16, "Setup using E-mail");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 9);
    ɵngcc0.ɵɵtext(18, " We will send you an e-mail with a security code when prompted. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_Template_button_click_19_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.showStep2(); });
    ɵngcc0.ɵɵtext(20, "Continue ");
    ɵngcc0.ɵɵtemplate(21, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_i_21_Template, 1, 0, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_Template_button_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.cancel(); });
    ɵngcc0.ɵɵtext(23, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.twoFactorRequest.FactorType);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.twoFactorRequest.FactorType);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.processing);
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "image", 16);
    ɵngcc0.ɵɵelement(2, "image", 16);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r14.twoFactorResponse.TwoFactorSetup.QrCodeSetupImageUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r14.twoFactorResponse.TwoFactorSetup.QrCodeSetupImageUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r14.twoFactorResponse.TwoFactorSetup.QrCodeSetupImageUrl, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Account: ", ctx_r14.twoFactorResponse == null ? null : ctx_r14.twoFactorResponse.TwoFactorSetup.Account, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Manual Entry Key: ", ctx_r14.twoFactorResponse == null ? null : ctx_r14.twoFactorResponse.TwoFactorSetup.ManualEntryKey, " ");
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_span_7_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_span_7_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(4); return ctx_r18.resendCode(); });
    ɵngcc0.ɵɵtext(1, "Resend Code");
    ɵngcc0.ɵɵelementEnd();
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "( ");
    ɵngcc0.ɵɵtemplate(2, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_span_7_a_2_Template, 2, 0, "a", 17);
    ɵngcc0.ɵɵtext(3, ")");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.showResendCode);
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_i_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "h2");
    ɵngcc0.ɵɵtext(4, "Authentication Verification");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_div_5_Template, 8, 5, "div", 3);
    ɵngcc0.ɵɵtext(6, " Enter the six-digit code below: ");
    ɵngcc0.ɵɵtemplate(7, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_span_7_Template, 4, 1, "span", 3);
    ɵngcc0.ɵɵelementStart(8, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.twoFactorRequest.TwoFactorCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.complete(); });
    ɵngcc0.ɵɵtext(10, " Complete Setup ");
    ɵngcc0.ɵɵtemplate(11, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_i_11_Template, 1, 0, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.cancel(); });
    ɵngcc0.ɵɵtext(13, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.twoFactorResponse == null ? null : ctx_r5.twoFactorResponse.TwoFactorSetup);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.showResendCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.twoFactorRequest.TwoFactorCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r5.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.processing);
} }
function DwSecurityTwofactorSetupComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwSecurityTwofactorSetupComponent_ng_container_7_button_1_Template, 2, 0, "button", 4);
    ɵngcc0.ɵɵtemplate(2, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_2_Template, 24, 4, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(3, DwSecurityTwofactorSetupComponent_ng_container_7_ng_container_3_Template, 14, 5, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.step == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.step == 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.step == 2);
} }
function DwSecurityTwofactorSetupComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2, "Two-factor authentication has been setup for your account.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 19);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_8_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.startDisableTwoFactor(); });
    ɵngcc0.ɵɵtext(4, "Disable Two-factor Authentication");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwSecurityTwofactorSetupComponent_ng_container_9_span_4_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_9_span_4_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.resendCode(); });
    ɵngcc0.ɵɵtext(1, "Resend Code");
    ɵngcc0.ɵɵelementEnd();
} }
function DwSecurityTwofactorSetupComponent_ng_container_9_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "( ");
    ɵngcc0.ɵɵtemplate(2, DwSecurityTwofactorSetupComponent_ng_container_9_span_4_a_2_Template, 2, 0, "a", 17);
    ɵngcc0.ɵɵtext(3, ")");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r26.showResendCode);
} }
function DwSecurityTwofactorSetupComponent_ng_container_9_i_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
function DwSecurityTwofactorSetupComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2, "Disable your two-factor authentication");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3, " Enter the six-digit code below: ");
    ɵngcc0.ɵɵtemplate(4, DwSecurityTwofactorSetupComponent_ng_container_9_span_4_Template, 4, 1, "span", 3);
    ɵngcc0.ɵɵelementStart(5, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityTwofactorSetupComponent_ng_container_9_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.disableTwoFactorCode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 20);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_9_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.disabledTwoFactor(); });
    ɵngcc0.ɵɵtext(7, " Complete Disable Two-factor Authentication ");
    ɵngcc0.ɵɵtemplate(8, DwSecurityTwofactorSetupComponent_ng_container_9_i_8_Template, 1, 0, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwSecurityTwofactorSetupComponent_ng_container_9_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.cancel(); });
    ɵngcc0.ɵɵtext(10, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showResendCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.disableTwoFactorCode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disabled", ctx_r2.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.processing);
} }
function DwLoginSsoOptionsComponent_ng_container_0_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} }
function DwLoginSsoOptionsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 1);
    ɵngcc0.ɵɵlistener("click", function DwLoginSsoOptionsComponent_ng_container_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ssoConfig_r1 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.authenticateWithSSO(ssoConfig_r1); });
    ɵngcc0.ɵɵelement(2, "i", 2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, DwLoginSsoOptionsComponent_ng_container_0_i_4_Template, 1, 0, "i", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ssoConfig_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ssoConfig_r1.ButtonClass);
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.processing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ssoConfig_r1.ButtonIconClass);
    ɵngcc0.ɵɵproperty("hidden", !ssoConfig_r1.ButtonIconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ssoConfig_r1.ButtonText || "Login with SSO", " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.processing);
} }
function DwPasswordComponent_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} }
function DwPasswordComponent_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 14);
} }
function DwPasswordComponent_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 15);
} }
function DwPasswordComponent_div_8_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", message_r10, " ");
} }
function DwPasswordComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, " Password requires: ");
    ɵngcc0.ɵɵelementStart(2, "ul");
    ɵngcc0.ɵɵtemplate(3, DwPasswordComponent_div_8_li_3_Template, 2, 1, "li", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.passwordCheckResults.messages);
} }
function DwPasswordComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1, " Password meets complexity requirements ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwPasswordComponent_i_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 19);
} }
function DwPasswordComponent_i_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
} }
function DwPasswordComponent_i_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 21);
} }
function DwPasswordComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1, " Passwords do not match ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwDateMultiSelectComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.dateListDisplay, "\n");
} }
function DwDateMultiSelectComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "input", 5, 6);
    ɵngcc0.ɵɵlistener("shown", function DwDateMultiSelectComponent_div_1_Template_input_shown_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.popoverShown(); })("ngModelChange", function DwDateMultiSelectComponent_div_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onInputChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 7);
    ɵngcc0.ɵɵelementStart(4, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DwDateMultiSelectComponent_div_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const _r6 = ɵngcc0.ɵɵreference(2); return _r6.toggle(); });
    ɵngcc0.ɵɵelement(5, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngbPopover", _r2)("ngModel", ctx_r1.dateListDisplay)("disabled", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disabled);
} }
function DwDateMultiSelectComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "ngb-datepicker", 11, 12);
    ɵngcc0.ɵɵlistener("dateSelect", function DwDateMultiSelectComponent_ng_template_2_Template_ngb_datepicker_dateSelect_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onDateSelection($event); })("select", function DwDateMultiSelectComponent_ng_template_2_Template_ngb_datepicker_select_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onDateSelection($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.startDateTime)("displayMonths", 2)("firstDayOfWeek", ctx_r3.firstDayOfWeek)("dayTemplate", _r4);
} }
function DwDateMultiSelectComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵlistener("mouseenter", function DwDateMultiSelectComponent_ng_template_4_Template_span_mouseenter_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const date_r15 = ctx.$implicit; const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.hoveredDate = date_r15; })("mouseleave", function DwDateMultiSelectComponent_ng_template_4_Template_span_mouseleave_0_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.hoveredDate = null; });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const date_r15 = ctx.$implicit;
    const focused_r16 = ctx.focused;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("focused", focused_r16)("range", ctx_r5.isRange(date_r15))("faded", ctx_r5.isHovered(date_r15) || ctx_r5.isInside(date_r15));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", date_r15.day, " ");
} }
const _c45 = ".custom-day[_ngcontent-%COMP%]{display:inline-block;height:2rem;padding:.185rem .25rem;text-align:center;width:2rem}.custom-day.focused[_ngcontent-%COMP%]{background-color:#e6e6e6}.custom-day.range[_ngcontent-%COMP%], .custom-day[_ngcontent-%COMP%]:hover{background-color:#0275d8;color:#fff}.custom-day.faded[_ngcontent-%COMP%]{background-color:rgba(2,117,216,.5)}.date-time-icon[_ngcontent-%COMP%]{background-color:#007ad9;border:1px solid #007ad9;color:#fff;font-size:14px}.date-time-input-text[_ngcontent-%COMP%]{background:#fff;color:#333;font-size:14px}";
const _c46 = ["innerContent"];
function DwUiInfoDisplayComponent_div_0_ng_container_1_div_3_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r6.finalData[field_r5.fieldPath]);
} }
function DwUiInfoDisplayComponent_div_0_ng_container_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "label", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwUiInfoDisplayComponent_div_0_ng_container_1_div_3_div_3_Template, 2, 1, "div", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(field_r5.display);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.finalData[field_r5.fieldPath]);
} }
function DwUiInfoDisplayComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwUiInfoDisplayComponent_div_0_ng_container_1_div_3_Template, 4, 2, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(section_r1.sectionDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", section_r1 == null ? null : section_r1.fields);
} }
function DwUiInfoDisplayComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwUiInfoDisplayComponent_div_0_ng_container_1_Template, 4, 2, "ng-container", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.sectionVisible[i_r2]);
} }
function DwControlWrapperWithIconsComponent_ng_content_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 2, ["*ngIf", "!wrapControl"]);
} }
function DwControlWrapperWithIconsComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵprojection(1, 3);
    ɵngcc0.ɵɵelementEnd();
} }
const _c47 = [[["", "prefix", ""]], [["", "suffix", ""]], [["", "control", ""]], [["", "control2", ""]]];
const _c48 = ["[prefix]", "[suffix]", "[control]", "[control2]"];
function ColorSelectComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", color_r2.backgroundClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(color_r2.display);
} }
function ColorSelectComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const color_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngClass", color_r3.backgroundClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", color_r3.display, "");
} }
const _c49 = function (a0) { return { "background-color": a0 }; };
const _c50 = ["dropDownControl"];
const _c51 = [[["", "control", ""]], [["", "dropdown", ""]]];
const _c52 = ["[control]", "[dropdown]"];
const _c53 = ["menuSection"];
function DwButtonDropdownComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "li", 7);
    ɵngcc0.ɵɵelementStart(2, "li", 8);
    ɵngcc0.ɵɵlistener("click", function DwButtonDropdownComponent_ng_container_6_Template_li_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const menuItem_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onMenuClick(menuItem_r3, $event); });
    ɵngcc0.ɵɵelementStart(3, "a", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const menuItem_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !menuItem_r3.dividerBefore);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(menuItem_r3.display);
} }
function DwFloatingLabelInputComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "input", 3, 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFloatingLabelInputComponent_div_0_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.value = $event; })("ngModelChange", function DwFloatingLabelInputComponent_div_0_Template_input_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.valueChange(); })("focus", function DwFloatingLabelInputComponent_div_0_Template_input_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.focusInput; })("blur", function DwFloatingLabelInputComponent_div_0_Template_input_blur_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.blurInput(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "label", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.containerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("type", ctx_r0.type)("id", ctx_r0.name)("name", ctx_r0.name)("ngClass", ctx_r0.floatingInputClasses)("ngModel", ctx_r0.value)("autocomplete", ctx_r0.inputAutoComplete);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("for", ctx_r0.name)("ngClass", ctx_r0.floatingLabelClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
} }
function DwFloatingLabelInputComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "label", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFloatingLabelInputComponent_div_1_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.value = $event; })("ngModelChange", function DwFloatingLabelInputComponent_div_1_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.valueChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.containerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.labelClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("type", ctx_r1.type)("ngClass", ctx_r1.inputClass)("id", ctx_r1.name)("name", ctx_r1.name)("ngModel", ctx_r1.value)("placeholder", ctx_r1.placeholder)("autocomplete", ctx_r1.inputAutoComplete);
} }
function DwDefaultLayoutComponent_app_sidebar_minimizer_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "app-sidebar-minimizer");
} }
function DwDefaultLayoutComponent_ng_container_30_dw_message_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-message", 24);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("message", ctx_r5.message);
} }
function DwDefaultLayoutComponent_ng_container_30_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵelement(3, "img", 26);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.securityMessage, "");
} }
function DwDefaultLayoutComponent_ng_container_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwDefaultLayoutComponent_ng_container_30_dw_message_1_Template, 1, 1, "dw-message", 23);
    ɵngcc0.ɵɵtemplate(2, DwDefaultLayoutComponent_ng_container_30_ng_container_2_Template, 5, 1, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showError);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.showRouterOutlet);
} }
function DwDefaultLayoutComponent_ng_container_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "router-outlet");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwDefaultLayoutComponent_dw_modal_host_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-modal-host");
} }
function DwDefaultLayoutComponent_app_footer_37_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 29);
    ɵngcc0.ɵɵelement(1, "img", 30);
    ɵngcc0.ɵɵelementEnd();
} }
function DwDefaultLayoutComponent_app_footer_37_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "app-footer", 27);
    ɵngcc0.ɵɵtemplate(1, DwDefaultLayoutComponent_app_footer_37_a_1_Template, 2, 0, "a", 28);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.uiConfig.showDevwareLogo);
} }
const _c54 = [[["", "logo", ""]], [["", "topMenu", ""]], [["", "topRight", ""]], [["", "sideBarTop", ""]], [["", "sideBarBottom", ""]], [["", "breadcrumb", ""]]];
const _c55 = ["[logo]", "[topMenu]", "[topRight]", "[sideBarTop]", "[sideBarBottom]", "[breadcrumb]"];
const _c56 = function () { return ["link-active"]; };
function DwTopMenu_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "dw-menu-link", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const menu_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("routerLinkActive", ɵngcc0.ɵɵpureFunction0(3, _c56));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("menu", menu_r1)("menuLocation", "top");
} }
function DwSideMenu_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-app-sidebar-nav", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("navItems", ctx_r0.routeHierarchy);
} }
const _c57 = function (a0) { return { "nav-link": a0 }; };
function DwSideMenu_ng_container_1_ul_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 3);
    ɵngcc0.ɵɵelementStart(1, "li", 4);
    ɵngcc0.ɵɵelement(2, "dw-menu-link", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("menu", ctx_r3.backMenu)("menuLocation", "side-bar-back");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c57, !ctx_r3.replacementSideMenu.parentMenu.navigateToFirstChild))("routerLink", ctx_r3.replacementSideMenu.parentMenu.url);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.replacementSideMenu.parentMenu.display);
} }
function DwSideMenu_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwSideMenu_ng_container_1_ul_1_Template, 5, 7, "ul", 2);
    ɵngcc0.ɵɵelement(2, "dw-app-sidebar-nav", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.replacementSideMenu.hideBackMenu);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("navItems", ctx_r1.replacementSideMenu.replacementMenus);
} }
function DwSideMenu_ng_container_2_ul_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ul", 3);
    ɵngcc0.ɵɵelementStart(1, "li", 4);
    ɵngcc0.ɵɵelement(2, "dw-menu-link", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-dynamic-loader", 7);
    ɵngcc0.ɵɵlistener("configure", function DwSideMenu_ng_container_2_ul_1_Template_dw_dynamic_loader_configure_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.configureSideMenuComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("menu", ctx_r4.backMenu)("menuLocation", "side-bar-back");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("componentName", ctx_r4.replacementSideMenu.sideMenuComponent);
} }
function DwSideMenu_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwSideMenu_ng_container_2_ul_1_Template, 4, 3, "ul", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.replacementSideMenu.hideBackMenu);
} }
function DwBreadcrumbMenuComponent_li_2_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", breadcrumb_r2.finalUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(breadcrumb_r2.breadcrumbDisplay);
} }
function DwBreadcrumbMenuComponent_li_2_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", breadcrumb_r2.finalUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(breadcrumb_r2.breadcrumbDisplay);
} }
const _c58 = function (a0, a1) { return { active: a0, "hide-mobile": a1 }; };
function DwBreadcrumbMenuComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtemplate(1, DwBreadcrumbMenuComponent_li_2_a_1_Template, 2, 2, "a", 5);
    ɵngcc0.ɵɵtemplate(2, DwBreadcrumbMenuComponent_li_2_span_2_Template, 2, 2, "span", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r2 = ctx.$implicit;
    const last_r3 = ctx.last;
    const i_r4 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c58, last_r3, ctx_r0.hideMobile(breadcrumb_r2, i_r4)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !last_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", last_r3);
} }
function DwBreadcrumbMenuComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} }
const _c59 = [[["", "breadcrumb", ""]]];
const _c60 = ["[breadcrumb]"];
function DwAppHeaderComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵelement(1, "i", 6);
    ɵngcc0.ɵɵelementEnd();
} }
function DwAppHeaderComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 7);
    ɵngcc0.ɵɵelement(1, "i", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("appSidebarToggler", ctx_r1.sidebarToggler);
} }
function DwAppHeaderComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵelement(1, "i", 9);
    ɵngcc0.ɵɵelement(2, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("appAsideMenuToggler", ctx_r2.asideMenuToggler);
} }
function DwAppHeaderComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵelement(1, "i", 9);
    ɵngcc0.ɵɵelement(2, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} }
const _c61 = [[["", "navbarBrand", ""]], [["", "topMenu", ""]], [["", "topRight", ""]], [["", "securityInfo", ""]]];
const _c62 = ["[navbarBrand]", "[topMenu]", "[topRight]", "[securityInfo]"];
function DwMetadataGridConfigViewsComponent_div_0_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "i", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r6 == null ? null : item_r6.display, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(item_r6 == null ? null : item_r6.value == null ? null : item_r6.value.isDefault));
} }
function DwMetadataGridConfigViewsComponent_div_0_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "i", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r7 == null ? null : item_r7.display, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(item_r7 == null ? null : item_r7.value == null ? null : item_r7.value.isDefault));
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_1_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 44);
    ɵngcc0.ɵɵelementStart(1, "dw-metadata-grid-config-columns", 45);
    ɵngcc0.ɵɵlistener("columnsChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_1_Template_dw_metadata_grid_config_columns_columnsChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.selectedItem.columnPreferences = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r8.configContext)("columns", ctx_r8.selectedItem.columnPreferences)("gridPreferences", ctx_r8.gridPreferences)("useColumnFlex", ctx_r8.selectedItem.useColumnFlex)("inlineEditEnabled", ctx_r8.selectedItem.inlineEditEnabled);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 46);
    ɵngcc0.ɵɵelementStart(1, "dw-metadata-config-filters", 47);
    ɵngcc0.ɵɵlistener("filtersChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_dw_metadata_config_filters_filtersChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.selectedItem.filters = $event; });
    ɵngcc0.ɵɵelementStart(2, "div", 48);
    ɵngcc0.ɵɵelementStart(3, "p-accordion");
    ɵngcc0.ɵɵelementStart(4, "p-accordionTab", 49);
    ɵngcc0.ɵɵelementStart(5, "div", 1);
    ɵngcc0.ɵɵelementStart(6, "div", 25);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Use Filter Tiles");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 26);
    ɵngcc0.ɵɵelementStart(10, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_p_inputSwitch_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r24 = ɵngcc0.ɵɵnextContext(3); return ctx_r24.selectedItem.useFilterTiles = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "p-accordionTab", 50);
    ɵngcc0.ɵɵelementStart(12, "div", 1);
    ɵngcc0.ɵɵelementStart(13, "div", 25);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Show Filter On Load");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 26);
    ɵngcc0.ɵɵelementStart(17, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_p_inputSwitch_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ctx_r25.gridPreferences.showFilterOnLoad = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 1);
    ɵngcc0.ɵɵelementStart(19, "div", 25);
    ɵngcc0.ɵɵelementStart(20, "label");
    ɵngcc0.ɵɵtext(21, "Use Side Filters");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 26);
    ɵngcc0.ɵɵelementStart(23, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_p_inputSwitch_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r26 = ɵngcc0.ɵɵnextContext(3); return ctx_r26.gridPreferences.useSideFilters = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 1);
    ɵngcc0.ɵɵelementStart(25, "div", 25);
    ɵngcc0.ɵɵelementStart(26, "label");
    ɵngcc0.ɵɵtext(27, "Show Clear Filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "div", 26);
    ɵngcc0.ɵɵelementStart(29, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_p_inputSwitch_ngModelChange_29_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.gridPreferences.showClearFilter = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "div", 1);
    ɵngcc0.ɵɵelementStart(31, "div", 25);
    ɵngcc0.ɵɵelementStart(32, "label");
    ɵngcc0.ɵɵtext(33, "Auto Filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "div", 26);
    ɵngcc0.ɵɵelementStart(35, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_p_inputSwitch_ngModelChange_35_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r28 = ɵngcc0.ɵɵnextContext(3); return ctx_r28.gridPreferences.autoFilter = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 51);
    ɵngcc0.ɵɵelementStart(37, "div", 2);
    ɵngcc0.ɵɵelementStart(38, "label");
    ɵngcc0.ɵɵtext(39, "Auto Filter Delay");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "div", 2);
    ɵngcc0.ɵɵelementStart(41, "input", 52);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template_input_ngModelChange_41_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.gridPreferences.autoFilterDelay = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r9.configContext)("filters", ctx_r9.selectedItem.filters)("initialFilterKey", ctx_r9.initialFilterKey);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.selectedItem.useFilterTiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.gridPreferences.showFilterOnLoad);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.gridPreferences.useSideFilters);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.gridPreferences.showClearFilter);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.gridPreferences.autoFilter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r9.gridPreferences.autoFilter);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.gridPreferences.autoFilterDelay);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_3_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 53);
    ɵngcc0.ɵɵelementStart(1, "dw-metadata-filter-tiles-config", 54);
    ɵngcc0.ɵɵlistener("tileConfigChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_3_Template_dw_metadata_filter_tiles_config_tileConfigChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(3); return ctx_r30.selectedItem.filterTilesConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r10.configContext)("tileConfig", ctx_r10.selectedItem.filterTilesConfig)("initialFilterTileKey", ctx_r10.initialFilterTileKey);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_4_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 55);
    ɵngcc0.ɵɵelementStart(1, "dw-metadata-grid-actions-config", 56);
    ɵngcc0.ɵɵlistener("actionPreferencesByModeChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_4_Template_dw_metadata_grid_actions_config_actionPreferencesByModeChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(3); return ctx_r32.selectedItem.actionPreferences = $event; })("actionPreferenceByModeChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_4_Template_dw_metadata_grid_actions_config_actionPreferenceByModeChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r34 = ɵngcc0.ɵɵnextContext(3); return ctx_r34.updateActionPreferences($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r11.configContext)("actionPreferencesByMode", ctx_r11.selectedItem.actionPreferences)("inlineEditEnabled", ctx_r11.selectedItem.inlineEditEnabled);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_5_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 57);
    ɵngcc0.ɵɵelementStart(1, "dw-export-config", 58);
    ɵngcc0.ɵɵlistener("exportConfigChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_5_Template_dw_export_config_exportConfigChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(3); return ctx_r35.selectedItem.exportConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r12.configContext)("exportConfig", ctx_r12.selectedItem.exportConfig)("gridColumnPreferences", ctx_r12.selectedItem.columnPreferences);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_40_Template(rf, ctx) { if (rf & 1) {
    const _r38 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "div", 25);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Show Row Actions on Right");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 26);
    ɵngcc0.ɵɵelementStart(7, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_40_Template_p_inputSwitch_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r37 = ɵngcc0.ɵɵnextContext(3); return ctx_r37.selectedItem.showRowActionsOnRight = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_40_Template_p_inputSwitch_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r39 = ɵngcc0.ɵɵnextContext(3); return ctx_r39.changeUseCustomActions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "div", 1);
    ɵngcc0.ɵɵelementStart(10, "div", 22);
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵtext(12, "Action Column Header");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "input", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_40_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r38); const ctx_r40 = ɵngcc0.ɵɵnextContext(3); return ctx_r40.selectedItem.actionColumnHeader = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.selectedItem.showRowActionsOnRight);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.selectedItem.actionColumnHeader);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_option_49_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 31);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataSource_r41 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", dataSource_r41.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataSource_r41.display, " ");
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_option_57_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 31);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const query_r42 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", query_r42.QueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", query_r42.QueryName, " ");
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_8_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "option", 66);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const view_r49 = ctx.$implicit;
    const ctx_r46 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngValue", view_r49.key)("hidden", view_r49.key == ctx_r46.selectedItem.key || (view_r49.defaults == null ? null : view_r49.defaults.useDefaults));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", view_r49.display, " ");
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r51 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 60);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Primary Grid View");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "select", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_8_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r51); const ctx_r50 = ɵngcc0.ɵɵnextContext(4); return ctx_r50.selectedItem.defaults.defaultViewKey = $event; });
    ɵngcc0.ɵɵtemplate(5, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_8_ng_container_5_Template, 3, 3, "ng-container", 62);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵelementStart(7, "button", 63, 64);
    ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_8_Template_button_click_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r51); const _r48 = ɵngcc0.ɵɵreference(10); return _r48.show($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "p-menu", 10, 65);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r43 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r43.selectedItem.defaults.defaultViewKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r43.items);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("popup", true)("model", ctx_r43.copyDefaultsMenuItems);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r54 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 60);
    ɵngcc0.ɵɵelementStart(1, "div", 25);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 26);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_9_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r53 = ɵngcc0.ɵɵnextContext(4); return ctx_r53.selectedItem.defaults.useAll = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_9_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r55 = ɵngcc0.ɵɵnextContext(4); return ctx_r55.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r44 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r44.selectedItem.defaults.useAll);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r57 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 26);
    ɵngcc0.ɵɵelementStart(3, "div", 25);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Use Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 26);
    ɵngcc0.ɵɵelementStart(7, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r56 = ɵngcc0.ɵɵnextContext(4); return ctx_r56.selectedItem.defaults.useColumns = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r58 = ɵngcc0.ɵɵnextContext(4); return ctx_r58.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 26);
    ɵngcc0.ɵɵelementStart(9, "div", 25);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Use Filters");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 26);
    ɵngcc0.ɵɵelementStart(13, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r59 = ɵngcc0.ɵɵnextContext(4); return ctx_r59.selectedItem.defaults.useFilters = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_13_listener() { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r60 = ɵngcc0.ɵɵnextContext(4); return ctx_r60.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 26);
    ɵngcc0.ɵɵelementStart(15, "div", 25);
    ɵngcc0.ɵɵelementStart(16, "label");
    ɵngcc0.ɵɵtext(17, "Use Filter Tiles");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 26);
    ɵngcc0.ɵɵelementStart(19, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r61 = ɵngcc0.ɵɵnextContext(4); return ctx_r61.selectedItem.defaults.useFilterTiles = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_19_listener() { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r62 = ɵngcc0.ɵɵnextContext(4); return ctx_r62.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 26);
    ɵngcc0.ɵɵelementStart(21, "div", 25);
    ɵngcc0.ɵɵelementStart(22, "label");
    ɵngcc0.ɵɵtext(23, "Use Actions");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 26);
    ɵngcc0.ɵɵelementStart(25, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_25_listener($event) { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r63 = ɵngcc0.ɵɵnextContext(4); return ctx_r63.selectedItem.defaults.useActions = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_25_listener() { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r64 = ɵngcc0.ɵɵnextContext(4); return ctx_r64.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 26);
    ɵngcc0.ɵɵelementStart(27, "div", 25);
    ɵngcc0.ɵɵelementStart(28, "label");
    ɵngcc0.ɵɵtext(29, "Use Export Options");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "div", 26);
    ɵngcc0.ɵɵelementStart(31, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_31_listener($event) { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r65 = ɵngcc0.ɵɵnextContext(4); return ctx_r65.selectedItem.defaults.useExport = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template_p_inputSwitch_ngModelChange_31_listener() { ɵngcc0.ɵɵrestoreView(_r57); const ctx_r66 = ɵngcc0.ɵɵnextContext(4); return ctx_r66.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r45 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r45.selectedItem.defaults.useColumns);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r45.selectedItem.defaults.useFilters);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r45.selectedItem.defaults.useFilterTiles);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r45.selectedItem.defaults.useActions);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r45.selectedItem.defaults.useExport);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_Template(rf, ctx) { if (rf & 1) {
    const _r68 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 59);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 60);
    ɵngcc0.ɵɵelementStart(3, "div", 25);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Use Defaults");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 26);
    ɵngcc0.ɵɵelementStart(7, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_Template_p_inputSwitch_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r68); const ctx_r67 = ɵngcc0.ɵɵnextContext(3); return ctx_r67.selectedItem.defaults.useDefaults = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_Template_p_inputSwitch_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r68); const ctx_r69 = ɵngcc0.ɵɵnextContext(3); return ctx_r69.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_8_Template, 11, 4, "div", 61);
    ɵngcc0.ɵɵtemplate(9, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_div_9_Template, 6, 1, "div", 61);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_ng_container_10_Template, 32, 5, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r16.selectedItem.defaults.useDefaults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.selectedItem.defaults.useDefaults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.selectedItem.defaults.useDefaults && ctx_r16.selectedItem.defaults.defaultViewKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.selectedItem.defaults.useDefaults && ctx_r16.selectedItem.defaults.defaultViewKey && !ctx_r16.selectedItem.defaults.useAll);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_94_Template(rf, ctx) { if (rf & 1) {
    const _r71 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 22);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Permission");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-security-permission-select", 67);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_94_Template_dw_security_permission_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r71); const ctx_r70 = ɵngcc0.ɵɵnextContext(3); return ctx_r70.selectedItem.permissionMeaning = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_94_Template_dw_security_permission_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r71); const ctx_r72 = ɵngcc0.ɵɵnextContext(3); return ctx_r72.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r17.selectedItem.permissionMeaning);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_101_Template(rf, ctx) { if (rf & 1) {
    const _r74 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 68);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 25);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Customize Export");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 26);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_101_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r74); const ctx_r73 = ɵngcc0.ɵɵnextContext(3); return ctx_r73.selectedItem.useCustomExport = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_101_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r74); const ctx_r75 = ɵngcc0.ɵɵnextContext(3); return ctx_r75.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 51);
    ɵngcc0.ɵɵelementStart(8, "div", 25);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Export only Displayed Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 26);
    ɵngcc0.ɵɵelementStart(12, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_101_Template_p_inputSwitch_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r74); const ctx_r76 = ɵngcc0.ɵɵnextContext(3); return ctx_r76.selectedItem.exportOnlyDisplayedColumns = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_101_Template_p_inputSwitch_ngModelChange_12_listener() { ɵngcc0.ɵɵrestoreView(_r74); const ctx_r77 = ɵngcc0.ɵɵnextContext(3); return ctx_r77.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r18.selectedItem.useCustomExport);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r18.selectedItem.useCustomExport);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r18.selectedItem.exportOnlyDisplayedColumns);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_ng_container_109_Template(rf, ctx) { if (rf & 1) {
    const _r79 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 25);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Inline Editing Mode");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 26);
    ɵngcc0.ɵɵelementStart(6, "select", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_ng_container_109_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r79); const ctx_r78 = ɵngcc0.ɵɵnextContext(3); return ctx_r78.selectedItem.inlineEditMode = $event; });
    ɵngcc0.ɵɵelementStart(7, "option", 69);
    ɵngcc0.ɵɵtext(8, "Full Row");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "option", 70);
    ɵngcc0.ɵɵtext(10, "Individual Cells");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "option", 71);
    ɵngcc0.ɵɵtext(12, "All Rows");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 1);
    ɵngcc0.ɵɵelementStart(14, "div", 25);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Start in Edit Mode");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 26);
    ɵngcc0.ɵɵelementStart(18, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_ng_container_109_Template_p_inputSwitch_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r79); const ctx_r80 = ɵngcc0.ɵɵnextContext(3); return ctx_r80.selectedItem.startInEditMode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 1);
    ɵngcc0.ɵɵelementStart(20, "div", 25);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Use Pop-up editor");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 26);
    ɵngcc0.ɵɵelementStart(24, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_ng_container_109_Template_p_inputSwitch_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r79); const ctx_r81 = ɵngcc0.ɵɵnextContext(3); return ctx_r81.selectedItem.inlineEditUsePopup = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r19.selectedItem.inlineEditMode);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r19.selectedItem.startInEditMode);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r19.selectedItem.inlineEditUsePopup);
} }
function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template(rf, ctx) { if (rf & 1) {
    const _r83 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabView", 14);
    ɵngcc0.ɵɵlistener("activeIndexChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_tabView_activeIndexChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r82 = ɵngcc0.ɵɵnextContext(2); return ctx_r82.tabIndex = $event; });
    ɵngcc0.ɵɵtemplate(1, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_1_Template, 2, 5, "p-tabPanel", 15);
    ɵngcc0.ɵɵtemplate(2, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_2_Template, 42, 12, "p-tabPanel", 16);
    ɵngcc0.ɵɵtemplate(3, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_3_Template, 2, 3, "p-tabPanel", 17);
    ɵngcc0.ɵɵtemplate(4, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_4_Template, 2, 3, "p-tabPanel", 18);
    ɵngcc0.ɵɵtemplate(5, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_tabPanel_5_Template, 2, 3, "p-tabPanel", 19);
    ɵngcc0.ɵɵelementStart(6, "p-tabPanel", 20);
    ɵngcc0.ɵɵelementStart(7, "p-accordion");
    ɵngcc0.ɵɵelementStart(8, "p-accordionTab", 21);
    ɵngcc0.ɵɵelementStart(9, "div", 1);
    ɵngcc0.ɵɵelementStart(10, "div", 22);
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵtext(12, "View Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "input", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r84 = ɵngcc0.ɵɵnextContext(2); return ctx_r84.selectedItem.display = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 1);
    ɵngcc0.ɵɵelementStart(15, "div", 22);
    ɵngcc0.ɵɵelementStart(16, "label");
    ɵngcc0.ɵɵtext(17, "View Key");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "input", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_input_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r85 = ɵngcc0.ɵɵnextContext(2); return ctx_r85.selectedItem.key = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 1);
    ɵngcc0.ɵɵelementStart(20, "div", 22);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "View Icon");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "input", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_input_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r86 = ɵngcc0.ɵɵnextContext(2); return ctx_r86.selectedItem.iconCss = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "p-accordionTab", 24);
    ɵngcc0.ɵɵelementStart(25, "div", 1);
    ɵngcc0.ɵɵelementStart(26, "div", 2);
    ɵngcc0.ɵɵelementStart(27, "div", 1);
    ɵngcc0.ɵɵelementStart(28, "div", 25);
    ɵngcc0.ɵɵelementStart(29, "label");
    ɵngcc0.ɵɵtext(30, "Customize Actions");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 26);
    ɵngcc0.ɵɵelementStart(32, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_32_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r87 = ɵngcc0.ɵɵnextContext(2); return ctx_r87.selectedItem.useCustomActions = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_32_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r88 = ɵngcc0.ɵɵnextContext(2); return ctx_r88.changeUseCustomActions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "div", 2);
    ɵngcc0.ɵɵelementStart(34, "div", 1);
    ɵngcc0.ɵɵelementStart(35, "div", 25);
    ɵngcc0.ɵɵelementStart(36, "label");
    ɵngcc0.ɵɵtext(37, "Use Flex Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "div", 26);
    ɵngcc0.ɵɵelementStart(39, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_39_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r89 = ɵngcc0.ɵɵnextContext(2); return ctx_r89.selectedItem.useColumnFlex = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_39_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r90 = ɵngcc0.ɵɵnextContext(2); return ctx_r90.updateFlexColumns($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(40, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_40_Template, 14, 2, "div", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(41, "p-accordionTab", 29);
    ɵngcc0.ɵɵelementStart(42, "div", 1);
    ɵngcc0.ɵɵelementStart(43, "div", 22);
    ɵngcc0.ɵɵelementStart(44, "label");
    ɵngcc0.ɵɵtext(45, "Data Source");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(46, "select", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_select_ngModelChange_46_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r91 = ɵngcc0.ɵɵnextContext(2); return ctx_r91.selectedItem.dataSourceName = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_select_ngModelChange_46_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r92 = ɵngcc0.ɵɵnextContext(2); return ctx_r92.updateDataSourceInfo(); });
    ɵngcc0.ɵɵelementStart(47, "option", 31);
    ɵngcc0.ɵɵtext(48, "Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(49, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_option_49_Template, 2, 2, "option", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(50, "div", 1);
    ɵngcc0.ɵɵelementStart(51, "div", 22);
    ɵngcc0.ɵɵelementStart(52, "label");
    ɵngcc0.ɵɵtext(53, "Query");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(54, "select", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_select_ngModelChange_54_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r93 = ɵngcc0.ɵɵnextContext(2); return ctx_r93.selectedItem.metaDataQueryMeaning = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_select_ngModelChange_54_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r94 = ɵngcc0.ɵɵnextContext(2); return ctx_r94.updateDataSourceInfo(); });
    ɵngcc0.ɵɵelementStart(55, "option", 31);
    ɵngcc0.ɵɵtext(56, " Default ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(57, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_option_57_Template, 2, 2, "option", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(58, "div", 1);
    ɵngcc0.ɵɵelementStart(59, "div", 22);
    ɵngcc0.ɵɵelementStart(60, "label");
    ɵngcc0.ɵɵtext(61, "Additional Filter ");
    ɵngcc0.ɵɵelement(62, "i", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(63, "dw-expression-picker-control", 34);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_dw_expression_picker_control_ngModelChange_63_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r95 = ɵngcc0.ɵɵnextContext(2); return ctx_r95.selectedItem.sharedFilterExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(64, "div", 1);
    ɵngcc0.ɵɵelementStart(65, "div", 2);
    ɵngcc0.ɵɵelementStart(66, "div", 1);
    ɵngcc0.ɵɵelementStart(67, "div", 25);
    ɵngcc0.ɵɵelementStart(68, "label");
    ɵngcc0.ɵɵtext(69, "Load all fields ");
    ɵngcc0.ɵɵelement(70, "i", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(71, "div", 26);
    ɵngcc0.ɵɵelementStart(72, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_72_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r96 = ɵngcc0.ɵɵnextContext(2); return ctx_r96.selectedItem.includeAllFields = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(73, "div", 2);
    ɵngcc0.ɵɵelementStart(74, "div", 1);
    ɵngcc0.ɵɵelementStart(75, "div", 25);
    ɵngcc0.ɵɵelementStart(76, "label");
    ɵngcc0.ɵɵtext(77, "Distinct Rows Only ");
    ɵngcc0.ɵɵelement(78, "i", 36);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(79, "div", 26);
    ɵngcc0.ɵɵelementStart(80, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_80_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r97 = ɵngcc0.ɵɵnextContext(2); return ctx_r97.selectedItem.distinctRowsOnly = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(81, "div", 1);
    ɵngcc0.ɵɵelementStart(82, "div", 22);
    ɵngcc0.ɵɵelementStart(83, "label");
    ɵngcc0.ɵɵtext(84, "Context Data");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(85, "p-multiSelect", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_multiSelect_ngModelChange_85_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r98 = ɵngcc0.ɵɵnextContext(2); return ctx_r98.gridPreferences.contextNames = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_multiSelect_ngModelChange_85_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r99 = ɵngcc0.ɵɵnextContext(2); return ctx_r99.updateContextNames(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(86, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_86_Template, 11, 4, "p-accordionTab", 38);
    ɵngcc0.ɵɵelementStart(87, "p-accordionTab", 39);
    ɵngcc0.ɵɵelementStart(88, "div", 1);
    ɵngcc0.ɵɵelementStart(89, "div", 25);
    ɵngcc0.ɵɵelementStart(90, "label");
    ɵngcc0.ɵɵtext(91, "Require Authentication");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(92, "div", 26);
    ɵngcc0.ɵɵelementStart(93, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_93_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r100 = ɵngcc0.ɵɵnextContext(2); return ctx_r100.selectedItem.requireAuthentication = $event; })("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_93_listener() { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r101 = ɵngcc0.ɵɵnextContext(2); return ctx_r101.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(94, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_div_94_Template, 5, 1, "div", 28);
    ɵngcc0.ɵɵelementStart(95, "div", 1);
    ɵngcc0.ɵɵelementStart(96, "div", 22);
    ɵngcc0.ɵɵelementStart(97, "label");
    ɵngcc0.ɵɵtext(98, "Visible Expression ");
    ɵngcc0.ɵɵelement(99, "i", 40);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(100, "dw-expression-picker-control", 41);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_dw_expression_picker_control_ngModelChange_100_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r102 = ɵngcc0.ɵɵnextContext(2); return ctx_r102.selectedItem.viewVisisbleExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(101, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_p_accordionTab_101_Template, 13, 3, "p-accordionTab", 42);
    ɵngcc0.ɵɵelementStart(102, "p-accordionTab", 43);
    ɵngcc0.ɵɵelementStart(103, "div", 1);
    ɵngcc0.ɵɵelementStart(104, "div", 25);
    ɵngcc0.ɵɵelementStart(105, "label");
    ɵngcc0.ɵɵtext(106, "Allow Inline Editing");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(107, "div", 26);
    ɵngcc0.ɵɵelementStart(108, "p-inputSwitch", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template_p_inputSwitch_ngModelChange_108_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r103 = ɵngcc0.ɵɵnextContext(2); return ctx_r103.selectedItem.inlineEditEnabled = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(109, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_ng_container_109_Template, 25, 3, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("activeIndex", ctx_r5.tabIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useDefaults) && (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.defaultViewKey) && ((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useAll) || (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useColumns))));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useDefaults) && (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.defaultViewKey) && ((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useAll) || (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useFilters))));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedItem.useFilterTiles && !((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useDefaults) && (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.defaultViewKey) && ((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useAll) || (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useFilterTiles))));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedItem.useCustomActions && !((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useDefaults) && (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.defaultViewKey) && ((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useAll) || (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useActions))));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedItem.useCustomExport && !((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useDefaults) && (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.defaultViewKey) && ((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useAll) || (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useExport))));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.display);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.key);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.iconCss);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.useCustomActions);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.useColumnFlex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedItem.useCustomActions);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.dataSourceName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.dataSources);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.metaDataQueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.queries);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.sharedFilterExpression)("contextNames", ctx_r5.configContext == null ? null : ctx_r5.configContext.contextNames)("item", ctx_r5.configContext == null ? null : ctx_r5.configContext.itemName)("queryMeaning", ctx_r5.configContext == null ? null : ctx_r5.configContext.metaDataQueryMeaning);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.includeAllFields);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.distinctRowsOnly);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(37, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r5.contextDefs)("ngModel", ctx_r5.gridPreferences.contextNames);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r5.items == null ? null : ctx_r5.items.length) > 1);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.requireAuthentication);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedItem.requireAuthentication);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.viewVisisbleExpression)("contextNames", ctx_r5.configContext == null ? null : ctx_r5.configContext.contextNames);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useDefaults) && (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.defaultViewKey) && ((ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useAll) || (ctx_r5.selectedItem.defaults == null ? null : ctx_r5.selectedItem.defaults.useExport))));
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedItem.inlineEditEnabled);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedItem.inlineEditEnabled);
} }
function DwMetadataGridConfigViewsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r105 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "View");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 1);
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵelementStart(8, "p-dropdown", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigViewsComponent_div_0_Template_p_dropdown_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r105); const ctx_r104 = ɵngcc0.ɵɵnextContext(); return ctx_r104.setSelectedItem($event); });
    ɵngcc0.ɵɵtemplate(9, DwMetadataGridConfigViewsComponent_div_0_ng_template_9_Template, 3, 2, "ng-template", 5);
    ɵngcc0.ɵɵtemplate(10, DwMetadataGridConfigViewsComponent_div_0_ng_template_10_Template, 3, 2, "ng-template", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 7);
    ɵngcc0.ɵɵelementStart(12, "button", 8, 9);
    ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigViewsComponent_div_0_Template_button_click_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r105); const _r4 = ɵngcc0.ɵɵreference(15); return _r4.toggle($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(14, "p-menu", 10, 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, DwMetadataGridConfigViewsComponent_div_0_p_tabView_16_Template, 110, 38, "p-tabView", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(7, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r0.items)("ngModel", ctx_r0.selectedItem);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("popup", true)("model", ctx_r0.viewMenuItems);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedItem);
} }
function DwMetaDataGridConfigWidgetComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Load Total Row Count");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 40);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataGridConfigWidgetComponent_p_accordionTab_42_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 41);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 12);
    ɵngcc0.ɵɵelementStart(3, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwMetaDataGridConfigWidgetComponent_p_accordionTab_42_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.configColumns(); });
    ɵngcc0.ɵɵtext(4, "Configure Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataGridConfigWidgetComponent_div_74_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwMetaDataGridConfigWidgetComponent_div_74_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.configFilters(); });
    ɵngcc0.ɵɵtext(3, "Configure Filters");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataGridConfigWidgetComponent_div_75_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwMetaDataGridConfigWidgetComponent_div_75_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.configAdvancedFilters(); });
    ɵngcc0.ɵɵtext(3, "Configure Filters");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataGridConfigWidgetComponent_div_77_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵtext(1, " Selected View is overriding these settings! ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataGridConfigWidgetComponent_div_120_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Show Checkbox");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataGridConfigWidgetComponent_option_128_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 44);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r15.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r15.display, " ");
} }
function DwMetaDataGridConfigWidgetComponent_option_134_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 44);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mode_r16 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", mode_r16.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(mode_r16.display);
} }
function DwMetaDataGridConfigWidgetComponent_div_157_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Action Column Width (px)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 45);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
const _c63 = ["cmGrid"];
function DwMetaDataGridComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.errorMessage, " ");
} }
function DwMetaDataGridComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h1");
    ɵngcc0.ɵɵelement(2, "i", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.gridConfig.accessErrorMessage, "");
} }
function DwMetaDataGridComponent_div_8_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelement(1, "dw-metadata-filter-tiles", 22);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configKey", ctx_r6.gridConfig == null ? null : ctx_r6.gridConfig.configKey)("viewKey", ctx_r6.selectedViewKey)("configContext", ctx_r6.configContext)("tilesConfig", ctx_r6.gridConfig == null ? null : ctx_r6.gridConfig.filterTilesConfig)("sharedFilterExpression", ctx_r6.gridConfig.sharedFilterExpression);
} }
function DwMetaDataGridComponent_div_8_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelement(1, "dw-metadata-filters", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configKey", ctx_r7.gridConfig == null ? null : ctx_r7.gridConfig.configKey)("viewKey", ctx_r7.selectedViewKey)("configContext", ctx_r7.configContext)("configKeyPart", ctx_r7.configKeyPart)("filterConfig", ctx_r7.gridConfig.filters)("sharedFilterExpression", ctx_r7.gridConfig.sharedFilterExpression);
} }
const _c64 = function (a0) { return { "dw-grid-with-views": a0 }; };
function DwMetaDataGridComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11, 12);
    ɵngcc0.ɵɵelementStart(2, "dw-grid", 13);
    ɵngcc0.ɵɵlistener("triggerContextMenu", function DwMetaDataGridComponent_div_8_Template_dw_grid_triggerContextMenu_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onContextMenu(true, null, $event); })("gridReady", function DwMetaDataGridComponent_div_8_Template_dw_grid_gridReady_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.gridReady($event); })("filtersApplied", function DwMetaDataGridComponent_div_8_Template_dw_grid_filtersApplied_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.filtersApplied($event); })("filtersCleared", function DwMetaDataGridComponent_div_8_Template_dw_grid_filtersCleared_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.filtersCleared($event); })("gridEvent", function DwMetaDataGridComponent_div_8_Template_dw_grid_gridEvent_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onGridEvent($event); });
    ɵngcc0.ɵɵtemplate(3, DwMetaDataGridComponent_div_8_div_3_Template, 2, 5, "div", 14);
    ɵngcc0.ɵɵtemplate(4, DwMetaDataGridComponent_div_8_div_4_Template, 2, 6, "div", 15);
    ɵngcc0.ɵɵelementStart(5, "div", 16);
    ɵngcc0.ɵɵelement(6, "dw-metadata-filters-vertical", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerStart(7, 18);
    ɵngcc0.ɵɵelementStart(8, "div", 19, 18);
    ɵngcc0.ɵɵelementStart(10, "p-dropdown", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetaDataGridComponent_div_8_Template_p_dropdown_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.selectedViewKey = $event; })("ngModelChange", function DwMetaDataGridComponent_div_8_Template_p_dropdown_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.setView($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(18, _c64, (ctx_r3.gridConfig == null ? null : ctx_r3.gridConfig.views == null ? null : ctx_r3.gridConfig.views.length) > 1));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("gridConfig", ctx_r3.gridConfig)("configContext", ctx_r3.configContext)("resolvedContext", ctx_r3.gridConfig.resolvedContext)("data", ctx_r3.dataSource)("filters", ctx_r3.filters);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.gridConfig == null ? null : ctx_r3.gridConfig.selectedView == null ? null : ctx_r3.gridConfig.selectedView.gridViewPreferences == null ? null : ctx_r3.gridConfig.selectedView.gridViewPreferences.useFilterTiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.gridConfig.showFilter);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("configContext", ctx_r3.configContext)("configKeyPart", ctx_r3.configKeyPart)("filterConfig", ctx_r3.gridConfig.filters)("sharedFilterExpression", ctx_r3.gridConfig.sharedFilterExpression);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r3.gridConfig.views == null ? null : ctx_r3.gridConfig.views.length) === 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(20, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r3.gridConfig.views)("ngModel", ctx_r3.selectedViewKey)("filter", true);
} }
function DwFormControlLookupComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" Parent Field 1 : ", ctx_r0.fieldDef == null ? null : ctx_r0.fieldDef.attr == null ? null : ctx_r0.fieldDef.attr.MetaDataLookupParamAttribute1Name, " Parent Field 2 : ", ctx_r0.fieldDef == null ? null : ctx_r0.fieldDef.attr == null ? null : ctx_r0.fieldDef.attr.MetaDataLookupParamAttribute2Name, "");
} }
function DwFormControlSearchLookupComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" Parent Field 1 : ", ctx_r0.fieldDef == null ? null : ctx_r0.fieldDef.attr == null ? null : ctx_r0.fieldDef.attr.MetaDataLookupParamAttribute1Name, " Parent Field 2 : ", ctx_r0.fieldDef == null ? null : ctx_r0.fieldDef.attr == null ? null : ctx_r0.fieldDef.attr.MetaDataLookupParamAttribute2Name, "");
} }
function DwFormControlDateFieldConfigComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Valid Day");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return (ctx_r1.controlOptions.validDays[0] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(6, " Sun ");
    ɵngcc0.ɵɵelementStart(7, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return (ctx_r4.controlOptions.validDays[1] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(8, " Mon ");
    ɵngcc0.ɵɵelementStart(9, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return (ctx_r6.controlOptions.validDays[2] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, " Tues ");
    ɵngcc0.ɵɵelementStart(11, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return (ctx_r8.controlOptions.validDays[3] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(12, " Wed ");
    ɵngcc0.ɵɵelementStart(13, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return (ctx_r10.controlOptions.validDays[4] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(14, " Thurs ");
    ɵngcc0.ɵɵelementStart(15, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return (ctx_r12.controlOptions.validDays[5] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(16, " Fri ");
    ɵngcc0.ɵɵelementStart(17, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return (ctx_r14.controlOptions.validDays[6] = $event); })("ngModelChange", function DwFormControlDateFieldConfigComponent_div_5_Template_input_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(18, " Sat ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[0]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[1]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[2]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[3]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[4]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[5]);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.validDays[6]);
} }
function DwFormControlCalcFieldConfigComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Prefix");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.controlOptions.prefix = $event; })("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 0);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Suffix");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.controlOptions.suffix = $event; })("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 0);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Decimals");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.controlOptions.decimals = $event; })("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 0);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Empty field default");
    ɵngcc0.ɵɵelement(16, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.controlOptions.nullDefaultValue = $event; })("ngModelChange", function DwFormControlCalcFieldConfigComponent_ng_container_11_Template_input_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.prefix);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.suffix);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.decimals);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.nullDefaultValue);
} }
function DwFormControlCalcFieldConfigComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-fc-calc-tester", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r1.controlOptions)("itemName", ctx_r1.itemName);
} }
function DwFormControlAutoCompleteLookupConfigComponent_option_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r1.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r1.display, " ");
} }
function DwFormControlInputConfigComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtext(2, " Browser Autocomplete Type ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "input", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_div_15_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.controlOptions.autoCompleteType = $event; })("ngModelChange", function DwFormControlInputConfigComponent_div_15_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.controlOptions.autoCompleteType);
} }
function DwFormControlInputConfigComponent_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2, "Numeric Control Options");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 0);
    ɵngcc0.ɵɵelementStart(4, "div", 1);
    ɵngcc0.ɵɵtext(5, " Decimals Override ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 1);
    ɵngcc0.ɵɵelementStart(7, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_ng_container_16_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.controlOptions.decimalsOverride = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 0);
    ɵngcc0.ɵɵelementStart(9, "div", 3);
    ɵngcc0.ɵɵtext(10, " Allow negative ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 4);
    ɵngcc0.ɵɵelementStart(12, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_ng_container_16_Template_p_inputSwitch_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.controlOptions.allowNegative = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 0);
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵtext(15, " Format without place holder separator ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 4);
    ɵngcc0.ɵɵelementStart(17, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_ng_container_16_Template_p_inputSwitch_ngModelChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.controlOptions.excludeLocalNumericFormatting = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 0);
    ɵngcc0.ɵɵelementStart(19, "div", 1);
    ɵngcc0.ɵɵtext(20, " Multiplier ");
    ɵngcc0.ɵɵelement(21, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 1);
    ɵngcc0.ɵɵelementStart(23, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_ng_container_16_Template_input_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.controlOptions.multiplier = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.controlOptions.decimalsOverride)("placeholder", ctx_r1.decimalsPlaceholder);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.controlOptions.allowNegative);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.controlOptions.excludeLocalNumericFormatting);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.controlOptions.multiplier);
} }
function DwFormControlMultiSelectAdhocConfigComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r1.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r1.display, " ");
} }
function DwDefaultListPageComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dw-content-manager", 0);
    ɵngcc0.ɵɵelementStart(1, "h1");
    ɵngcc0.ɵɵelement(2, "dw-content", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "dw-content", 2);
    ɵngcc0.ɵɵelement(4, "dw-content-component", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "dw-meta-data-list", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("configKey", ctx_r0.contentConfigKey)("item", ctx_r0.item);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("controlType", ctx_r0.textboxControlType);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("item", ctx_r0.item)("configKeyPart", ctx_r0.configKeyPart);
} }
const _c65 = ["dwDynamicField", ""];
function DwDynamicFieldComponent_ng_template_10_Template(rf, ctx) { }
function DwMdSectionFormConfigComponent_ng_container_5_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r4.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r4.display, " ");
} }
function DwMdSectionFormConfigComponent_ng_container_5_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Label Width");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormConfigComponent_ng_container_5_div_7_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.section.labelWidth = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.section.labelWidth);
} }
function DwMdSectionFormConfigComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Form Style");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormConfigComponent_ng_container_5_Template_select_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.section.formStyle = $event; });
    ɵngcc0.ɵɵtemplate(6, DwMdSectionFormConfigComponent_ng_container_5_option_6_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwMdSectionFormConfigComponent_ng_container_5_div_7_Template, 4, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Is Read Only");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "dw-yesno", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormConfigComponent_ng_container_5_Template_dw_yesno_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.section.isReadOnly = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 15);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Read Only Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "dw-expression-picker-control", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormConfigComponent_ng_container_5_Template_dw_expression_picker_control_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.section.isReadOnlyExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 9);
    ɵngcc0.ɵɵelementStart(18, "div", 10);
    ɵngcc0.ɵɵelementStart(19, "label");
    ɵngcc0.ɵɵtext(20, "Label Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormConfigComponent_ng_container_5_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.section.labelClass = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 15);
    ɵngcc0.ɵɵelementStart(23, "label");
    ɵngcc0.ɵɵtext(24, "Data Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormConfigComponent_ng_container_5_Template_input_ngModelChange_25_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.section.dataClass = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.formStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formStyles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.section == null ? null : ctx_r0.section.formStyle) == ctx_r0.horizontalForm);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.isReadOnly);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.isReadOnlyExpression)("contextNames", ctx_r0.contextNames)("item", ctx_r0.itemName);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.labelClass);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.dataClass);
} }
function DwMdSectionFormConfigComponent_p_tabPanel_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 20);
    ɵngcc0.ɵɵelementStart(1, "dw-field-validation-config", 21);
    ɵngcc0.ɵɵlistener("configChange", function DwMdSectionFormConfigComponent_p_tabPanel_6_Template_dw_field_validation_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.section.validationConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r1.section.validationConfig)("configContext", ctx_r1.metaDataConfigContext);
} }
function DwFormSectionComponent_ng_container_0_div_2_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 8);
} }
function DwFormSectionComponent_ng_container_0_div_2_ng_container_2_ng_container_3_dwDynamicFieldHorizontal_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dwDynamicFieldHorizontal", 12);
} if (rf & 2) {
    const column_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("isRequired", ctx_r7.formFieldRequiredList[column_r4.item] == null ? null : ctx_r7.formFieldRequiredList[column_r4.item].isRequired)("labelWidth", ctx_r7.sectionConfig == null ? null : ctx_r7.sectionConfig.labelWidth)("fieldDef", ctx_r7.formFieldConfigList[column_r4.item])("formGroup", ctx_r7.formGroupList[column_r4.formGroupKey])("submitted", ctx_r7.submitted)("context", ctx_r7.context)("useDisplayFields", ctx_r7.formConfig.loadDisplayProperties);
} }
function DwFormSectionComponent_ng_container_0_div_2_ng_container_2_ng_container_3_dwDynamicField_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dwDynamicField", 13);
} if (rf & 2) {
    const column_r4 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("isRequired", ctx_r8.formFieldRequiredList[column_r4.item] == null ? null : ctx_r8.formFieldRequiredList[column_r4.item].isRequired)("fieldDef", ctx_r8.formFieldConfigList[column_r4.item])("formGroup", ctx_r8.formGroupList[column_r4.formGroupKey])("submitted", ctx_r8.submitted)("context", ctx_r8.context)("useDisplayFields", ctx_r8.formConfig.loadDisplayProperties);
} }
function DwFormSectionComponent_ng_container_0_div_2_ng_container_2_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementContainerStart(1, 9);
    ɵngcc0.ɵɵtemplate(2, DwFormSectionComponent_ng_container_0_div_2_ng_container_2_ng_container_3_dwDynamicFieldHorizontal_2_Template, 1, 7, "dwDynamicFieldHorizontal", 10);
    ɵngcc0.ɵɵtemplate(3, DwFormSectionComponent_ng_container_0_div_2_ng_container_2_ng_container_3_dwDynamicField_3_Template, 1, 6, "dwDynamicField", 11);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r6.sectionConfig == null ? null : ctx_r6.sectionConfig.formStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "horizontalForm");
} }
function DwFormSectionComponent_ng_container_0_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, DwFormSectionComponent_ng_container_0_div_2_ng_container_2_div_2_Template, 1, 0, "div", 7);
    ɵngcc0.ɵɵtemplate(3, DwFormSectionComponent_ng_container_0_div_2_ng_container_2_ng_container_3_Template, 4, 2, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dwCol", column_r4.columnSize)("dwColWidth", column_r4.customWidth)("dwColClass", column_r4.columnClass)("configKey", ctx_r3.formConfig == null ? null : ctx_r3.formConfig.configKey)("sectionKey", ctx_r3.sectionKey)("detailKey", column_r4.item)("additionalInfo", ctx_r3.formFieldConfigList[column_r4.item]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r4.isPlaceHolder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !column_r4.isPlaceHolder);
} }
function DwFormSectionComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, DwFormSectionComponent_ng_container_0_div_2_ng_container_2_Template, 4, 9, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const formRow_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.formSetupComplete);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", formRow_r2.columns)("ngForTrackBy", ctx_r1.trackByIndex);
} }
function DwFormSectionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-validation-info", 1);
    ɵngcc0.ɵɵtemplate(2, DwFormSectionComponent_ng_container_0_div_2_Template, 3, 3, "div", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup)("submitted", ctx_r0.submitted)("filterKey", ctx_r0.relatedSections == null ? null : ctx_r0.relatedSections.currentSectionKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formRows)("ngForTrackBy", ctx_r0.trackByIndex);
} }
function DwMdSectionComponentConfigComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.name, " ");
} }
function DwMdSectionComponentConfigComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelement(2, "hr");
    ɵngcc0.ɵɵelementStart(3, "b");
    ɵngcc0.ɵɵtext(4, "Component Configuration");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "dw-dynamic-loader", 9);
    ɵngcc0.ɵɵlistener("configure", function DwMdSectionComponentConfigComponent_div_9_Template_dw_dynamic_loader_configure_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.setupConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("component", ctx_r1.configComponent);
} }
function DwMdSectionComponentConfigComponent_p_tabPanel_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 10);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "dw-md-section-standard-config", 11);
    ɵngcc0.ɵɵlistener("sectionChange", function DwMdSectionComponentConfigComponent_p_tabPanel_10_Template_dw_md_section_standard_config_sectionChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.section = $event; })("sectionChange", function DwMdSectionComponentConfigComponent_p_tabPanel_10_Template_dw_md_section_standard_config_sectionChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r2.contextNames)("section", ctx_r2.section)("preferences", ctx_r2.preferences)("itemMetaDataList", ctx_r2.itemMetaDataList)("rootItemName", ctx_r2.rootItemName);
} }
function DwDynamicSectionComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.sectionConfig == null ? null : ctx_r0.sectionConfig.title, " ");
} }
function DwDynamicSectionComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-template-view-control", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", ctx_r1.itemName)("queryMetaData", ctx_r1.queryMetaData)("templateText", ctx_r1.currentTitleTemplate)("dataSubject", ctx_r1.dataSubjectResult == null ? null : ctx_r1.dataSubjectResult.subject)("context", ctx_r1.context)("showLookupDisplays", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.titleTemplatePreferences == null ? null : ctx_r1.sectionConfig.titleTemplatePreferences.loadLookupDisplays)("blankPlaceholder", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.title);
} }
function DwDynamicSectionComponent_ng_template_6_Template(rf, ctx) { }
function DwDynamicSectionComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "i", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Component section has an invalid configuration. (", ctx_r3.invalidConfigurationMessage, ")");
} }
function DwDynamicSectionComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "i", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.invalidConfigurationMessage);
} }
function DwDynamicSectionComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelement(3, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r5.componentName, " - ", ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.sectionType, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate4("title", "\n            isReadOnlyContainer: ", ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.isReadOnlyContainer, "   \n            isSectionReadOnly: ", ctx_r5.isSectionReadOnly(), "    \n            isReadOnlyFromParent: ", ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.isReadOnlyFromParent, "    \n            isReadOnlyParentSource: ", ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.isReadOnlyParentSource, "    \n            ");
    ɵngcc0.ɵɵproperty("hidden", !((ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.isReadOnlyContainer) || ctx_r5.isSectionReadOnly() || (ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.isReadOnlyFromParent) || (ctx_r5.sectionConfig == null ? null : ctx_r5.sectionConfig.isReadOnlyParentSource)));
} }
function DwMetadataFormConfigFieldsComponent_tr_15_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r3.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r3.Display, " ");
} }
function DwMetadataFormConfigFieldsComponent_tr_15_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵelementStart(2, "i", 4);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFormConfigFieldsComponent_tr_15_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.removeItem(item_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵelementStart(4, "select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormConfigFieldsComponent_tr_15_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; return item_r1.attrName = $event; });
    ɵngcc0.ɵɵtemplate(5, DwMetadataFormConfigFieldsComponent_tr_15_option_5_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td");
    ɵngcc0.ɵɵelementStart(7, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormConfigFieldsComponent_tr_15_Template_p_inputSwitch_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; return item_r1.columnItemPreferences.newRowBefore = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td");
    ɵngcc0.ɵɵelementStart(9, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormConfigFieldsComponent_tr_15_Template_p_inputSwitch_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; return item_r1.columnItemPreferences.spanAllColumns = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "td");
    ɵngcc0.ɵɵelementStart(11, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFormConfigFieldsComponent_tr_15_Template_p_inputSwitch_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; return item_r1.isReadOnly = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "td");
    ɵngcc0.ɵɵelementStart(13, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFormConfigFieldsComponent_tr_15_Template_i_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.moveUp(item_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFormConfigFieldsComponent_tr_15_Template_i_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r5); const item_r1 = ctx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.moveDown(item_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", item_r1.attrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.itemMetaData == null ? null : ctx_r0.itemMetaData.Attributes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", item_r1.columnItemPreferences.newRowBefore);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", item_r1.columnItemPreferences.spanAllColumns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", item_r1.isReadOnly);
} }
function DwMdSectionTabStripConfigComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r4.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r4.display, " ");
} }
function DwMdSectionTabStripConfigComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Set Tab on Variable Change ");
    ɵngcc0.ɵɵelement(3, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-yesno", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabStripConfigComponent_div_14_Template_dw_yesno_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.section.tabIndexVariableSetOnChange = $event; })("ngModelChange", function DwMdSectionTabStripConfigComponent_div_14_Template_dw_yesno_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.section.tabIndexVariableSetOnChange);
} }
function DwMdSectionTabStripConfigComponent_option_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r8.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r8.display, " ");
} }
function DwMdSectionTabStripConfigComponent_dw_ordered_list_26_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Tab Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabStripConfigComponent_dw_ordered_list_26_ng_container_1_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const section_r10 = ctx.$implicit; return section_r10.tabHeading = $event; })("ngModelChange", function DwMdSectionTabStripConfigComponent_dw_ordered_list_26_ng_container_1_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", section_r10.tabHeading);
} }
function DwMdSectionTabStripConfigComponent_dw_ordered_list_26_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ordered-list", 17);
    ɵngcc0.ɵɵlistener("itemsChange", function DwMdSectionTabStripConfigComponent_dw_ordered_list_26_Template_dw_ordered_list_itemsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.orderableSections = $event; })("itemsChange", function DwMdSectionTabStripConfigComponent_dw_ordered_list_26_Template_dw_ordered_list_itemsChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onSectionTabChange(); });
    ɵngcc0.ɵɵtemplate(1, DwMdSectionTabStripConfigComponent_dw_ordered_list_26_ng_container_1_Template, 4, 1, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r3.orderableSections);
} }
function DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_ng_container_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const i_r10 = ctx_r13.index;
    const section_r9 = ctx_r13.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("configKey", ctx_r12.formConfig == null ? null : ctx_r12.formConfig.configKey)("sectionKey", ctx_r12.visibleTabKeys[i_r10])("detailKey", i_r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(section_r9.tabHeading);
} }
function DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 10, 11);
    ɵngcc0.ɵɵtemplate(3, DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_ng_container_1_ng_template_3_Template, 2, 4, "ng-template", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("header", section_r9.tabHeading);
    ɵngcc0.ɵɵproperty("selected", i_r10 == 0);
} }
function DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabView", 8);
    ɵngcc0.ɵɵlistener("activeIndexChange", function DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_Template_p_tabView_activeIndexChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.activeTabIndex = $event; })("onChange", function DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_Template_p_tabView_onChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.handleTabChange(); });
    ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_ng_container_1_Template, 4, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("activeIndex", ctx_r6.activeTabIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.visibleTabs);
} }
function DwTabStripSectionComponent_div_0_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwTabStripSectionComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_div_0_ng_container_1_p_tabView_1_Template, 2, 2, "p-tabView", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵtemplate(4, DwTabStripSectionComponent_div_0_ng_container_1_ng_container_4_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.showPills);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function DwTabStripSectionComponent_div_0_ng_container_2_dw_pills_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-pills", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTabStripSectionComponent_div_0_ng_container_2_dw_pills_2_Template_dw_pills_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.currentPillsTab = $event; })("ngModelChange", function DwTabStripSectionComponent_div_0_ng_container_2_dw_pills_2_Template_dw_pills_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ctx_r21.setPillsTab($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("items", ctx_r17.visibleTabs)("ngModel", ctx_r17.currentPillsTab);
} }
function DwTabStripSectionComponent_div_0_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwTabStripSectionComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵtemplate(2, DwTabStripSectionComponent_div_0_ng_container_2_dw_pills_2_Template, 1, 2, "dw-pills", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵtemplate(4, DwTabStripSectionComponent_div_0_ng_container_2_ng_container_4_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.showPills);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
} }
function DwTabStripSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_div_0_ng_container_1_Template, 5, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, DwTabStripSectionComponent_div_0_ng_container_2_Template, 5, 2, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.visible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.showPills);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showPills);
} }
function DwTabStripSectionComponent_ng_template_1_dw_dynamic_section_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-dynamic-section", 18);
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r22.formConfig)("sectionConfig", ctx_r22.containerSection)("formGroup", ctx_r22.formGroup)("context", ctx_r22.context)("submitted", ctx_r22.submitted)("parentIsVisible", ctx_r22.visible);
} }
function DwTabStripSectionComponent_ng_template_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "dw-dynamic-section", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext();
    const i_r26 = ctx_r28.index;
    const section_r25 = ctx_r28.$implicit;
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", ctx_r27.currentDisplayIndex != i_r26);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r27.formConfig)("sectionConfig", section_r25)("formGroup", ctx_r27.formGroup)("context", ctx_r27.context)("submitted", ctx_r27.submitted)("parentIsVisible", ctx_r27.visible);
} }
function DwTabStripSectionComponent_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_ng_template_1_ng_container_1_div_1_Template, 2, 7, "div", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r25 = ctx.$implicit;
    const i_r26 = ctx.index;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !section_r25.loadOnClick || ctx_r23.tabsLoaded[i_r26]);
} }
function DwTabStripSectionComponent_ng_template_1_dw_dynamic_section_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-dynamic-section", 18);
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r24.formConfig)("sectionConfig", ctx_r24.containerSection)("formGroup", ctx_r24.formGroup)("context", ctx_r24.context)("submitted", ctx_r24.submitted)("parentIsVisible", ctx_r24.visible);
} }
function DwTabStripSectionComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwTabStripSectionComponent_ng_template_1_dw_dynamic_section_0_Template, 1, 6, "dw-dynamic-section", 17);
    ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_ng_template_1_ng_container_1_Template, 2, 1, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(2, DwTabStripSectionComponent_ng_template_1_dw_dynamic_section_2_Template, 1, 6, "dw-dynamic-section", 17);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.containerSection && ctx_r2.showSharedContainerAtTop);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.visibleTabs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.containerSection && !ctx_r2.showSharedContainerAtTop);
} }
function DwTabStripSectionComponent_div_3_ng_container_1_dw_dynamic_section_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-dynamic-section", 18);
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r32.formConfig)("sectionConfig", ctx_r32.containerSection)("formGroup", ctx_r32.formGroup)("context", ctx_r32.context)("submitted", ctx_r32.submitted)("parentIsVisible", ctx_r32.visible);
} }
function DwTabStripSectionComponent_div_3_ng_container_1_dw_dynamic_section_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-dynamic-section", 18);
} if (rf & 2) {
    const ctx_r33 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r33.formConfig)("sectionConfig", ctx_r33.containerSection)("formGroup", ctx_r33.formGroup)("context", ctx_r33.context)("submitted", ctx_r33.submitted)("parentIsVisible", ctx_r33.visible);
} }
function DwTabStripSectionComponent_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 20);
    ɵngcc0.ɵɵelementStart(1, "dw-container");
    ɵngcc0.ɵɵelementStart(2, "div", 21);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 22);
    ɵngcc0.ɵɵtemplate(5, DwTabStripSectionComponent_div_3_ng_container_1_dw_dynamic_section_5_Template, 1, 6, "dw-dynamic-section", 17);
    ɵngcc0.ɵɵelement(6, "dw-dynamic-section", 18);
    ɵngcc0.ɵɵtemplate(7, DwTabStripSectionComponent_div_3_ng_container_1_dw_dynamic_section_7_Template, 1, 6, "dw-dynamic-section", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r30 = ctx.$implicit;
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", section_r30.tabHeading, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.containerSection && ctx_r29.showSharedContainerAtTop);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r29.formConfig)("sectionConfig", section_r30)("formGroup", ctx_r29.formGroup)("context", ctx_r29.context)("submitted", ctx_r29.submitted)("parentIsVisible", ctx_r29.visible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r29.containerSection && !ctx_r29.showSharedContainerAtTop);
} }
function DwTabStripSectionComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_div_3_ng_container_1_Template, 8, 9, "ng-container", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r3.visible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.visibleTabs);
} }
function DwMdSectionTabConfigComponent_div_0_option_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r3.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r3.display, " ");
} }
function DwMdSectionTabConfigComponent_div_0_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Visible Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-expression-picker-control", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabConfigComponent_div_0_div_22_Template_dw_expression_picker_control_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.section.visibleExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.section.visibleExpression)("contextNames", ctx_r2.contextNames)("item", ctx_r2.itemName);
} }
function DwMdSectionTabConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p-tabView");
    ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 1);
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Tab Heading");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.section.tabHeading = $event; })("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_input_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Tab Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_input_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.section.tabClass = $event; })("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_input_ngModelChange_11_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 2);
    ɵngcc0.ɵɵelementStart(13, "div", 3);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Content Section Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_select_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.section.section.sectionType = $event; })("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_select_ngModelChange_16_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(17, DwMdSectionTabConfigComponent_div_0_option_17_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 3);
    ɵngcc0.ɵɵelementStart(19, "label");
    ɵngcc0.ɵɵtext(20, "Load On Click");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "dw-yesno", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_dw_yesno_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.section.loadOnClick = $event; })("ngModelChange", function DwMdSectionTabConfigComponent_div_0_Template_dw_yesno_ngModelChange_21_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(22, DwMdSectionTabConfigComponent_div_0_div_22_Template, 5, 3, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.tabHeading);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.tabClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.section.sectionType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.sectionDefs);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.loadOnClick);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.itemName);
} }
function DwMdSectionContainerConfigComponent_dw_ordered_list_3_ng_container_1_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r6.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r6.display, " ");
} }
function DwMdSectionContainerConfigComponent_dw_ordered_list_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Section Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionContainerConfigComponent_dw_ordered_list_3_ng_container_1_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const section_r4 = ctx.$implicit; return section_r4.sectionType = $event; })("ngModelChange", function DwMdSectionContainerConfigComponent_dw_ordered_list_3_ng_container_1_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(4, DwMdSectionContainerConfigComponent_dw_ordered_list_3_ng_container_1_option_4_Template, 2, 2, "option", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r4 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", section_r4.sectionType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.sectionDefs);
} }
function DwMdSectionContainerConfigComponent_dw_ordered_list_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ordered-list", 8);
    ɵngcc0.ɵɵlistener("itemsChange", function DwMdSectionContainerConfigComponent_dw_ordered_list_3_Template_dw_ordered_list_itemsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.section.sections = $event; })("itemsChange", function DwMdSectionContainerConfigComponent_dw_ordered_list_3_Template_dw_ordered_list_itemsChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(1, DwMdSectionContainerConfigComponent_dw_ordered_list_3_ng_container_1_Template, 5, 2, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r0.section.sections);
} }
function DwMdSectionContainerConfigComponent_div_4_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
} }
function DwMdSectionContainerConfigComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, DwMdSectionContainerConfigComponent_div_4_div_1_div_1_Template, 1, 0, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} }
function DwMdSectionContainerConfigComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function DwMdSectionContainerConfigComponent_div_4_Template_div_cdkDropListDropped_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.drop($event); });
    ɵngcc0.ɵɵtemplate(1, DwMdSectionContainerConfigComponent_div_4_div_1_Template, 2, 0, "div", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.section == null ? null : ctx_r1.section.sections);
} }
function DwMdSectionContainerConfigComponent_table_5_tr_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
} }
function DwMdSectionContainerConfigComponent_table_5_tr_8_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r23 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r23.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r23.display, " ");
} }
function DwMdSectionContainerConfigComponent_table_5_tr_8_i_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 23);
} }
function DwMdSectionContainerConfigComponent_table_5_tr_8_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 15);
    ɵngcc0.ɵɵtemplate(1, DwMdSectionContainerConfigComponent_table_5_tr_8_div_1_Template, 1, 0, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "td");
    ɵngcc0.ɵɵelementStart(3, "i", 19);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionContainerConfigComponent_table_5_tr_8_Template_i_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r25); const section_r19 = ctx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.removeItem(section_r19); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵelementStart(5, "select", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionContainerConfigComponent_table_5_tr_8_Template_select_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const section_r19 = ctx.$implicit; return section_r19.sectionType = $event; })("ngModelChange", function DwMdSectionContainerConfigComponent_table_5_tr_8_Template_select_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(6, DwMdSectionContainerConfigComponent_table_5_tr_8_option_6_Template, 2, 2, "option", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "td");
    ɵngcc0.ɵɵtemplate(8, DwMdSectionContainerConfigComponent_table_5_tr_8_i_8_Template, 1, 0, "i", 20);
    ɵngcc0.ɵɵelementStart(9, "i", 21);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionContainerConfigComponent_table_5_tr_8_Template_i_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r25); const section_r19 = ctx.$implicit; const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.moveUp(section_r19); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "i", 22);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionContainerConfigComponent_table_5_tr_8_Template_i_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r25); const section_r19 = ctx.$implicit; const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.moveDown(section_r19); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r19 = ctx.$implicit;
    const ctx_r18 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", section_r19.sectionType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r18.sectionDefs);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", true);
} }
function DwMdSectionContainerConfigComponent_table_5_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "table", 18);
    ɵngcc0.ɵɵelementStart(1, "thead");
    ɵngcc0.ɵɵelementStart(2, "tr");
    ɵngcc0.ɵɵelement(3, "td");
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵtext(5, "Section Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "td");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "tbody", 13);
    ɵngcc0.ɵɵlistener("cdkDropListDropped", function DwMdSectionContainerConfigComponent_table_5_Template_tbody_cdkDropListDropped_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.drop($event); });
    ɵngcc0.ɵɵtemplate(8, DwMdSectionContainerConfigComponent_table_5_tr_8_Template, 11, 4, "tr", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.section == null ? null : ctx_r2.section.sections);
} }
function DwContainerSectionComponent_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "dw-dynamic-section", 5);
    ɵngcc0.ɵɵlistener("visibleChange", function DwContainerSectionComponent_ng_container_1_ng_container_2_ng_container_1_Template_dw_dynamic_section_visibleChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const c_r5 = ɵngcc0.ɵɵnextContext().index; const r_r2 = ɵngcc0.ɵɵnextContext().index; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setChildVisibility(r_r2 * 10 + c_r5, $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dwCol", column_r4.columnSize)("layoutMode", ctx_r6.sectionConfig == null ? null : ctx_r6.sectionConfig.columnPreferences == null ? null : ctx_r6.sectionConfig.columnPreferences.columnLayoutMode)("dwColOptions", column_r4.columnOptions)("dwColWidth", column_r4.customWidth)("dwColClass", column_r4.columnClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r6.formConfig)("sectionConfig", column_r4.item)("formGroup", ctx_r6.formGroup)("context", ctx_r6.context)("submitted", ctx_r6.submitted)("parentIsVisible", ctx_r6.visible);
} }
function DwContainerSectionComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwContainerSectionComponent_ng_container_1_ng_container_2_ng_container_1_Template, 3, 11, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", column_r4.item);
} }
function DwContainerSectionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, DwContainerSectionComponent_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const formRow_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("layoutMode", ctx_r0.sectionConfig == null ? null : ctx_r0.sectionConfig.columnPreferences == null ? null : ctx_r0.sectionConfig.columnPreferences.columnLayoutMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", formRow_r1.columns)("ngForTrackBy", ctx_r0.trackByIndex);
} }
function DwAssociativeListComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwAssociativeListComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwAssociativeListComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r7 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r7);
} }
function DwAssociativeListComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwAssociativeListComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwAssociativeListComponent_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function DwAssociativeListComponent_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwAssociativeListComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwAssociativeListComponent_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(9);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r5);
} }
const _c66 = function (a0) { return { "multi-edit-auto-expand": a0 }; };
function DwAssociativeListComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-multiSelect", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeListComponent_ng_template_6_Template_p_multiSelect_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.selectedItems = $event; })("ngModelChange", function DwAssociativeListComponent_ng_template_6_Template_p_multiSelect_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.updateAssocativeCollection($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(10, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r4.convertedLookupValues)("group", ctx_r4.hasGrouping)("autoExpand", ctx_r4.autoExpand)("ngModel", ctx_r4.selectedItems)("filter", ctx_r4.showFilter)("virtualScroll", ctx_r4.virtualScroll)("itemSize", ctx_r4.virtualScrollItems)("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c66, ctx_r4.autoExpand));
} }
function DwAssociativeListComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "p-listbox", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeListComponent_ng_template_8_Template_p_listbox_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.updateAssocativeCollection($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.listClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r6.convertedLookupValues)("group", ctx_r6.hasGrouping)("ngModel", ctx_r6.selectedItems)("filter", ctx_r6.showFilter)("listStyle", ctx_r6.listBoxStyle);
} }
function DwAssociativeListComponent_ng_template_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "span", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 15);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    const i_r19 = ctx.index;
    const ctx_r17 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r17.finalReadOnlyItemStyle == null ? null : ctx_r17.finalReadOnlyItemStyle.chipClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r17.finalReadOnlyItemStyle == null ? null : ctx_r17.finalReadOnlyItemStyle.chipLabelClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r18);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r17.displayItems == null ? null : ctx_r17.displayItems.length) - 1 == i_r19)("ngClass", ctx_r17.finalReadOnlyItemStyle == null ? null : ctx_r17.finalReadOnlyItemStyle.chipDelimiterClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r17.finalReadOnlyItemStyle == null ? null : ctx_r17.finalReadOnlyItemStyle.chipDelimiter, " ");
} }
function DwAssociativeListComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, DwAssociativeListComponent_ng_template_10_ng_container_1_Template, 6, 6, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵtext(3, " None ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("class2", (ctx_r8.readOnlyItemStyle == null ? null : ctx_r8.readOnlyItemStyle.containerClass) || "dw-chip-container");
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r8.displayItems == null ? null : ctx_r8.displayItems.length))("ngClass", ctx_r8.finalReadOnlyItemStyle == null ? null : ctx_r8.finalReadOnlyItemStyle.containerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.displayItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r8.displayItems == null ? null : ctx_r8.displayItems.length) > 0);
} }
function DwMdSectionAssociativeListConfigComponent_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r10.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r10.FkItemName, " (By ", item_r10.FkAttributeName, ") ");
} }
function DwMdSectionAssociativeListConfigComponent_option_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r11.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r11.Display, " ");
} }
function DwMdSectionAssociativeListConfigComponent_option_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r12.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r12.display, " ");
} }
function DwMdSectionAssociativeListConfigComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Auto Expand");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-yesno", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_33_Template_dw_yesno_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.section.autoExpand = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_33_Template_dw_yesno_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.section.autoExpand);
} }
function DwMdSectionAssociativeListConfigComponent_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "List Max Height");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_34_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.section.listBoxMaxHeight = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_34_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.section.listBoxMaxHeight);
} }
function DwMdSectionAssociativeListConfigComponent_div_35_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "List Columns (Max 4)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_35_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.section.listColumns = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_35_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.section.listColumns);
} }
function DwMdSectionAssociativeListConfigComponent_div_61_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "List Display Delimiter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_61_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.section.displayVariableDelimiter = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_61_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.section.displayVariableDelimiter);
} }
function DwMdSectionAssociativeListConfigComponent_p_accordionTab_62_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 28);
    ɵngcc0.ɵɵelementStart(1, "dw-select-lookup-config", 29);
    ɵngcc0.ɵɵlistener("configChange", function DwMdSectionAssociativeListConfigComponent_p_accordionTab_62_Template_dw_select_lookup_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.section.lookupConfig = $event; })("configChange", function DwMdSectionAssociativeListConfigComponent_p_accordionTab_62_Template_dw_select_lookup_config_configChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.updateLookupSettings(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("selected", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r7.section.lookupConfig)("configContext", ctx_r7.lookupFieldContext)("hideAdditionalDisplay", true)("hideUseTransitions", true);
} }
function DwMdSectionAssociativeListConfigComponent_div_64_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r30 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r30.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r30.display, " ");
} }
function DwMdSectionAssociativeListConfigComponent_div_64_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Label Width");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 32);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_64_div_6_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.section.labelWidth = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r29.section.labelWidth);
} }
function DwMdSectionAssociativeListConfigComponent_div_64_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Form Style");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_div_64_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.section.formStyle = $event; });
    ɵngcc0.ɵɵtemplate(5, DwMdSectionAssociativeListConfigComponent_div_64_option_5_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwMdSectionAssociativeListConfigComponent_div_64_div_6_Template, 4, 1, "div", 31);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.section.formStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.formStyles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r8.section == null ? null : ctx_r8.section.formStyle) == ctx_r8.horizontalForm);
} }
function DwMdSectionAssociativeListConfigComponent_p_tabPanel_88_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 33);
    ɵngcc0.ɵɵelementStart(1, "dw-field-validation-config", 34);
    ɵngcc0.ɵɵlistener("configChange", function DwMdSectionAssociativeListConfigComponent_p_tabPanel_88_Template_dw_field_validation_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.section.validationConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r9.section.validationConfig)("configContext", ctx_r9.metaDataConfigContext);
} }
function DwAssociativeListSectionComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelement(5, "dw-associative-list", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.labelColStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("label ", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.labelClass, "");
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.label));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r1.dataColStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r1.controlName)("autoExpand", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.autoExpand)("parentItem", ctx_r1.sectionConfig.parentItem)("isReadOnly", ctx_r1.isSectionReadOnly())("useLoadedDisplayValues", ctx_r1.useLoadedDisplayValues)("associativeItem", ctx_r1.sectionConfig.associativeItem)("displayType", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.displayType)("readOnlyItemStyle", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.readOnlyItemStyle);
} }
function DwAssociativeListSectionComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "label", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-associative-list", 11);
    ɵngcc0.ɵɵlistener("displayItemsChange", function DwAssociativeListSectionComponent_ng_container_0_div_3_Template_dw_associative_list_displayItemsChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.displayItems = $event; })("displayItemsChange", function DwAssociativeListSectionComponent_ng_container_0_div_3_Template_dw_associative_list_displayItemsChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.steDisplayItemsVariable($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r2.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("label ", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.labelClass, "");
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.label));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r2.controlName)("autoExpand", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.autoExpand)("listBoxMaxHeight", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.listBoxMaxHeight)("listColumns", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.listColumns)("parentItem", ctx_r2.sectionConfig.parentItem)("associativeItem", ctx_r2.sectionConfig.associativeItem)("displayType", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.displayType)("lookupAttributeName", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.lookupAttributeName)("lookupConfig", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.lookupConfig)("isReadOnly", ctx_r2.isSectionReadOnly())("useLoadedDisplayValues", ctx_r2.useLoadedDisplayValues)("readOnlyItemStyle", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.readOnlyItemStyle)("parentFormGroup", ctx_r2.formGroup)("context", ctx_r2.context)("filterItemsThreshold", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.filterItemsThreshold)("displayItems", ctx_r2.displayItems);
} }
function DwAssociativeListSectionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, DwAssociativeListSectionComponent_ng_container_0_div_2_Template, 6, 15, "div", 2);
    ɵngcc0.ɵɵtemplate(3, DwAssociativeListSectionComponent_ng_container_0_div_3_Template, 4, 22, "div", 3);
    ɵngcc0.ɵɵelement(4, "dw-validation-info", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r0.sectionConfig == null ? null : ctx_r0.sectionConfig.formStyle)("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "horizontalForm");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.controlName)("submitted", ctx_r0.submitted);
} }
function DwMetadataListConfigComponent_p_tabPanel_35_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 18);
    ɵngcc0.ɵɵelementStart(1, "dw-metadata-filter-tiles-config", 19);
    ɵngcc0.ɵɵlistener("tileConfigChange", function DwMetadataListConfigComponent_p_tabPanel_35_Template_dw_metadata_filter_tiles_config_tileConfigChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.preferences.filterTilesConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r0.configContext)("initialFilterTileKey", ctx_r0.initialFilterTileKey)("tileConfig", ctx_r0.preferences.filterTilesConfig);
} }
function DwMetaDataListConfigWidgetComponent_option_88_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dataSource_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", dataSource_r4.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", dataSource_r4.display, " ");
} }
function DwMetaDataListConfigWidgetComponent_option_96_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const query_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", query_r5.QueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", query_r5.QueryName, " ");
} }
function DwMetaDataListConfigWidgetComponent_ng_template_102_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 42);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r9 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r7.getContextDefDisplay(val_r9));
} }
function DwMetaDataListConfigWidgetComponent_ng_template_102_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "None");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataListConfigWidgetComponent_ng_template_102_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwMetaDataListConfigWidgetComponent_ng_template_102_span_0_Template, 3, 1, "span", 40);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataListConfigWidgetComponent_ng_template_102_span_1_Template, 2, 0, "span", 41);
} if (rf & 2) {
    const value_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngForOf", value_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !value_r6 || value_r6.length === 0);
} }
function DwMetaDataListConfigWidgetComponent_option_121_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 26);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r10.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.display, " ");
} }
const _c67 = ["datalist"];
function DwMetadataListComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelement(1, "dw-metadata-filter-tiles", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r3.configContext)("tilesConfig", ctx_r3.config == null ? null : ctx_r3.config.filterTilesConfig);
} }
function DwMetadataListComponent_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 15);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataListComponent_div_0_ng_container_9_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const item_r8 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.setupCardComponent($event, item_r8); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("componentName", ctx_r4.config.cardComponentName)("ngClass", ctx_r4.config.cardItemClass);
} }
function DwMetadataListComponent_div_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 15);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataListComponent_div_0_ng_container_10_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const item_r11 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.setupListComponent($event, item_r11); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("componentName", ctx_r5.config.listComponentName)("ngClass", ctx_r5.config.listItemClass);
} }
function DwMetadataListComponent_div_0_ng_container_11_ng_container_1_dw_dynamic_loader_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 15);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataListComponent_div_0_ng_container_11_ng_container_1_dw_dynamic_loader_1_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const item_r14 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.setupNoItemsComponent($event, item_r14); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("componentName", ctx_r16.config.noItemsComponentName)("ngClass", ctx_r16.config.cardItemClass);
} }
function DwMetadataListComponent_div_0_ng_container_11_ng_container_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r17.config.noItemsMessage || "There are no items found!", "");
} }
function DwMetadataListComponent_div_0_ng_container_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataListComponent_div_0_ng_container_11_ng_container_1_dw_dynamic_loader_1_Template, 1, 2, "dw-dynamic-loader", 17);
    ɵngcc0.ɵɵtemplate(2, DwMetadataListComponent_div_0_ng_container_11_ng_container_1_span_2_Template, 2, 1, "span", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.config.noItemsComponentName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r15.config.noItemsComponentName);
} }
function DwMetadataListComponent_div_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataListComponent_div_0_ng_container_11_ng_container_1_Template, 3, 2, "ng-container", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r6.noItemsTemplate);
} }
function DwMetadataListComponent_div_0_p_contextMenu_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-contextMenu", 18);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(1);
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("target", _r1)("model", ctx_r7.contextMenu);
} }
function DwMetadataListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1, 2);
    ɵngcc0.ɵɵlistener("click", function DwMetadataListComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.contextMenu = []; });
    ɵngcc0.ɵɵelement(2, "dw-action-host");
    ɵngcc0.ɵɵelementStart(3, "dw-message", 3);
    ɵngcc0.ɵɵlistener("messageChange", function DwMetadataListComponent_div_0_Template_dw_message_messageChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.gridMessage = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-data-list", 4, 5);
    ɵngcc0.ɵɵlistener("actionClick", function DwMetadataListComponent_div_0_Template_dw_data_list_actionClick_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.actionPrefClicked($event); })("dataLoadComplete", function DwMetadataListComponent_div_0_Template_dw_data_list_dataLoadComplete_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.onDataLoadComplete($event); });
    ɵngcc0.ɵɵtemplate(6, DwMetadataListComponent_div_0_div_6_Template, 2, 2, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "dw-metadata-filters", 8);
    ɵngcc0.ɵɵlistener("filtersChange", function DwMetadataListComponent_div_0_Template_dw_metadata_filters_filtersChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.setFilters($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwMetadataListComponent_div_0_ng_container_9_Template, 2, 2, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(10, DwMetadataListComponent_div_0_ng_container_10_Template, 2, 2, "ng-container", 10);
    ɵngcc0.ɵɵtemplate(11, DwMetadataListComponent_div_0_ng_container_11_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, DwMetadataListComponent_div_0_p_contextMenu_12_Template, 1, 2, "p-contextMenu", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("message", ctx_r0.gridMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("data", ctx_r0.dataSource)("filters", ctx_r0.filters)("config", ctx_r0.config)("actionContext", ctx_r0.actionContext);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config == null ? null : ctx_r0.config.useFilterTiles);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("configContext", ctx_r0.configContext)("configKeyPart", ctx_r0.configKeyPart)("filterConfig", ctx_r0.config.filters)("filters", ctx_r0.filters);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.contextMenu && ctx_r0.contextMenu.length > 0);
} }
function DwMetadataFiltersComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMetadataFiltersComponent_ng_container_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 8);
} if (rf & 2) {
    const filterFieldConfig_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("fieldDef", filterFieldConfig_r1.fieldConfig)("formGroup", ctx_r3.formGroup);
} }
function DwMetadataFiltersComponent_ng_container_2_dw_dynamic_loader_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 9);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataFiltersComponent_ng_container_2_dw_dynamic_loader_4_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const filterFieldConfig_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.configFilterItemComponent($event, filterFieldConfig_r1); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filterFieldConfig_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("component", filterFieldConfig_r1.componentType);
} }
function DwMetadataFiltersComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataFiltersComponent_ng_container_2_ng_container_1_Template, 2, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtemplate(3, DwMetadataFiltersComponent_ng_container_2_span_3_Template, 1, 2, "span", 5);
    ɵngcc0.ɵɵtemplate(4, DwMetadataFiltersComponent_ng_container_2_dw_dynamic_loader_4_Template, 1, 1, "dw-dynamic-loader", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filterFieldConfig_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filterFieldConfig_r1 == null ? null : filterFieldConfig_r1.newRow);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dwCol", filterFieldConfig_r1.columnSize)("configKey", ctx_r0.configKey)("sectionKey", ctx_r0.viewKey)("additionalInfo", filterFieldConfig_r1.filterConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !filterFieldConfig_r1.componentType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filterFieldConfig_r1.componentType);
} }
function DwMetadataConfigFiltersComponent_div_6_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwMetadataConfigFiltersComponent_div_6_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const componentItem_r2 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.addComponentFilter(componentItem_r2); });
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const componentItem_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", componentItem_r2.name, " ");
} }
function DwMetadataConfigFiltersComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, DwMetadataConfigFiltersComponent_div_6_button_1_Template, 3, 1, "button", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const componentItem_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(componentItem_r2.configData == null ? null : componentItem_r2.configData.requireAttr));
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_option_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 33);
    ɵngcc0.ɵɵtext(1, "None");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("ngValue", null);
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 33);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r15.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r15.name, " ");
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_option_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 33);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const comparer_r16 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", comparer_r16.ComparerMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", comparer_r16.ComparerName, " ");
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵelementStart(3, "dw-default-value", 37);
    ɵngcc0.ɵɵlistener("defaultValueChange", function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_ng_container_7_Template_dw_default_value_defaultValueChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.selectedFilter.defaultValue = $event; })("defaultValueChange", function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_ng_container_7_Template_dw_default_value_defaultValueChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.updateDefaultValue($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("defaultValue", ctx_r17.selectedFilter.defaultValue)("contextNames", ctx_r17.configContext == null ? null : ctx_r17.configContext.contextNames)("queryAttribute", ctx_r17.selectedDefaultValueAttr);
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 36);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 24);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Default Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 25);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.selectedFilter.hasDefaultValue = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_ng_container_7_Template, 4, 3, "ng-container", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.selectedFilter.hasDefaultValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.selectedFilter.hasDefaultValue);
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_option_65_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 33);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const controlType_r23 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", controlType_r23.MetaDataControlTypeId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", controlType_r23.ControlTypeName, " ");
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_dw_select_lookup_config_66_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-select-lookup-config", 38);
    ɵngcc0.ɵɵlistener("configChange", function DwMetadataConfigFiltersComponent_p_accordion_11_dw_select_lookup_config_66_Template_dw_select_lookup_config_configChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.selectedFilter.lookupConfig = $event; })("configChange", function DwMetadataConfigFiltersComponent_p_accordion_11_dw_select_lookup_config_66_Template_dw_select_lookup_config_configChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.controlTypeOverrideChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("config", ctx_r13.selectedFilter.lookupConfig)("configContext", ctx_r13.dwFormFieldContext);
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_67_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 39);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 40);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_67_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.configureFieldControlOptionInstance($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", ctx_r14.selectedFilterComponent && !(ctx_r14.selectedFilterComponent == null ? null : ctx_r14.selectedFilterComponent.configData == null ? null : ctx_r14.selectedFilterComponent.configData.showControlOptions));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r14.controlOptionsComponentType);
} }
function DwMetadataConfigFiltersComponent_p_accordion_11_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵelementStart(1, "p-accordionTab", 15);
    ɵngcc0.ɵɵelementStart(2, "div", 16);
    ɵngcc0.ɵɵelementStart(3, "div", 17);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Custom Filter Component");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.selectedFilter.componentName = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_select_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.filterComponentChange($event); });
    ɵngcc0.ɵɵtemplate(7, DwMetadataConfigFiltersComponent_p_accordion_11_option_7_Template, 2, 1, "option", 19);
    ɵngcc0.ɵɵtemplate(8, DwMetadataConfigFiltersComponent_p_accordion_11_option_8_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 21);
    ɵngcc0.ɵɵelementStart(10, "div", 17);
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵtext(12, "Compare Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_select_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.selectedFilter.filterType = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_select_ngModelChange_13_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.controlTypeOverrideChange(); });
    ɵngcc0.ɵɵtemplate(14, DwMetadataConfigFiltersComponent_p_accordion_11_option_14_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 21);
    ɵngcc0.ɵɵelementStart(16, "div", 17);
    ɵngcc0.ɵɵelementStart(17, "label");
    ɵngcc0.ɵɵtext(18, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "input", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_input_ngModelChange_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.selectedFilter.label = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_input_ngModelChange_19_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.onFiltersChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 21);
    ɵngcc0.ɵɵelementStart(21, "div", 17);
    ɵngcc0.ɵɵelementStart(22, "label");
    ɵngcc0.ɵɵtext(23, "Placeholder Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "input", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_input_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36.selectedFilter.placeholderText = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_input_ngModelChange_24_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.onFiltersChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 21);
    ɵngcc0.ɵɵelementStart(26, "div", 17);
    ɵngcc0.ɵɵelementStart(27, "label");
    ɵngcc0.ɵɵtext(28, "Alt Query String Param ");
    ɵngcc0.ɵɵelement(29, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "input", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_input_ngModelChange_30_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.selectedFilter.altQueryStringParamName = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_input_ngModelChange_30_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.onFiltersChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 16);
    ɵngcc0.ɵɵelementStart(32, "div", 24);
    ɵngcc0.ɵɵelementStart(33, "label");
    ɵngcc0.ɵɵtext(34, "Show Filter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(35, "div", 25);
    ɵngcc0.ɵɵelementStart(36, "p-inputSwitch", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_p_inputSwitch_ngModelChange_36_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ctx_r40.selectedFilter.showFilter = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_p_inputSwitch_ngModelChange_36_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.onFiltersChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(37, DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_37_Template, 8, 2, "p-accordionTab", 27);
    ɵngcc0.ɵɵelementStart(38, "p-accordionTab", 28);
    ɵngcc0.ɵɵelementStart(39, "dw-ui-child-config-host", 29);
    ɵngcc0.ɵɵlistener("configChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_dw_ui_child_config_host_configChange_39_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r42 = ɵngcc0.ɵɵnextContext(); return ctx_r42.selectedFilter.additionalConfig = $event; })("configChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_dw_ui_child_config_host_configChange_39_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.setAdditionalConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "p-accordionTab", 30);
    ɵngcc0.ɵɵelementStart(41, "div", 16);
    ɵngcc0.ɵɵelementStart(42, "div", 24);
    ɵngcc0.ɵɵelementStart(43, "label");
    ɵngcc0.ɵɵtext(44, "New Row Before");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(45, "div", 25);
    ɵngcc0.ɵɵelementStart(46, "p-inputSwitch", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_p_inputSwitch_ngModelChange_46_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r44 = ɵngcc0.ɵɵnextContext(); return ctx_r44.selectedFilter.newRowBefore = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_p_inputSwitch_ngModelChange_46_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r45 = ɵngcc0.ɵɵnextContext(); return ctx_r45.onFiltersChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(47, "div", 16);
    ɵngcc0.ɵɵelementStart(48, "div", 24);
    ɵngcc0.ɵɵelementStart(49, "label");
    ɵngcc0.ɵɵtext(50, "Span All Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(51, "div", 25);
    ɵngcc0.ɵɵelementStart(52, "p-inputSwitch", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_p_inputSwitch_ngModelChange_52_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.selectedFilter.spanAllColumns = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_p_inputSwitch_ngModelChange_52_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.onFiltersChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(53, "p-accordionTab", 31);
    ɵngcc0.ɵɵelementStart(54, "div", 16);
    ɵngcc0.ɵɵelementStart(55, "div", 17);
    ɵngcc0.ɵɵelementStart(56, "label");
    ɵngcc0.ɵɵtext(57, "Show As Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(58, "dw-yesno", 32);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_dw_yesno_ngModelChange_58_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ctx_r48.selectedFilter.showAsLookup = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_dw_yesno_ngModelChange_58_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r49 = ɵngcc0.ɵɵnextContext(); return ctx_r49.onShowAsLookupChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(59, "div", 16);
    ɵngcc0.ɵɵelementStart(60, "div", 17);
    ɵngcc0.ɵɵelementStart(61, "label");
    ɵngcc0.ɵɵtext(62, "Control Type Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(63, "select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_select_ngModelChange_63_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r50 = ɵngcc0.ɵɵnextContext(); return ctx_r50.selectedFilter.controlTypeOverride = $event; })("ngModelChange", function DwMetadataConfigFiltersComponent_p_accordion_11_Template_select_ngModelChange_63_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r51 = ɵngcc0.ɵɵnextContext(); return ctx_r51.controlTypeOverrideChange(); });
    ɵngcc0.ɵɵelement(64, "option", 33);
    ɵngcc0.ɵɵtemplate(65, DwMetadataConfigFiltersComponent_p_accordion_11_option_65_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(66, DwMetadataConfigFiltersComponent_p_accordion_11_dw_select_lookup_config_66_Template, 1, 2, "dw-select-lookup-config", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(67, DwMetadataConfigFiltersComponent_p_accordion_11_p_accordionTab_67_Template, 2, 2, "p-accordionTab", 35);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.componentName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.selectedFilter == null ? null : ctx_r1.selectedFilter.attr);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.selectedFilterComponentList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.selectedFilterComponent && !(ctx_r1.selectedFilterComponent == null ? null : ctx_r1.selectedFilterComponent.configData == null ? null : ctx_r1.selectedFilterComponent.configData.showCompareType));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.filterType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.selectedComparers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.selectedFilterComponent && !(ctx_r1.selectedFilterComponent == null ? null : ctx_r1.selectedFilterComponent.configData == null ? null : ctx_r1.selectedFilterComponent.configData.showCaption));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.selectedFilterComponent && !(ctx_r1.selectedFilterComponent == null ? null : ctx_r1.selectedFilterComponent.configData == null ? null : ctx_r1.selectedFilterComponent.configData.showPlaceholderText));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.placeholderText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.selectedFilterComponent && (ctx_r1.selectedFilterComponent == null ? null : ctx_r1.selectedFilterComponent.configData == null ? null : ctx_r1.selectedFilterComponent.configData.hideQueryStringParamName));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.altQueryStringParamName);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.showFilter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.defaultValueFormGroup && ctx_r1.selectedFilterValueConfig && ctx_r1.filterRequiresValue(ctx_r1.selectedFilter.filterType) && !(ctx_r1.selectedFilterComponent && !(ctx_r1.selectedFilterComponent == null ? null : ctx_r1.selectedFilterComponent.configData == null ? null : ctx_r1.selectedFilterComponent.configData.showDefaultValue)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.selectedComponentConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r1.selectedComponentConfig)("config", ctx_r1.selectedFilter.additionalConfig)("configContext", ctx_r1.filterConfigContext);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.newRowBefore);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.spanAllColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.selectedFilterComponent && !(ctx_r1.selectedFilterComponent == null ? null : ctx_r1.selectedFilterComponent.configData == null ? null : ctx_r1.selectedFilterComponent.configData.showControlOptions));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.showAsLookup)("allowNull", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedFilter.controlTypeOverride);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.selectedControlTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showLookupConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.controlOptionsComponentType);
} }
const _c68 = [[["", "additionalTab", ""]]];
const _c69 = ["[additionalTab]"];
function DwSelectLookupComponent_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.blankOptionText);
} }
function DwSelectLookupComponent_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lookupItem_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("value", lookupItem_r3[ctx_r1.valueAttrName]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", lookupItem_r3.Display, " ");
} }
function DwSelectLookupComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.getAdditionalFieldDisplay());
} }
function DwMdSectionStandardConfigComponent_div_0_option_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r6.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r6.display, " ");
} }
function DwMdSectionStandardConfigComponent_div_0_option_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r7.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r7.display, " ");
} }
function DwMdSectionStandardConfigComponent_div_0_div_95_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 39);
    ɵngcc0.ɵɵelementStart(1, "div", 40);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Is Read Only ");
    ɵngcc0.ɵɵelement(4, "i", 41);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "dw-yesno", 42);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 5);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Read Only Expression ");
    ɵngcc0.ɵɵelement(9, "i", 43);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "dw-expression-picker-control", 44);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r3.contextNames)("item", ctx_r3.itemName);
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_96_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 45);
    ɵngcc0.ɵɵelement(1, "dw-title-templates-config", 46);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r4.contextNames)("item", ctx_r4.itemName)("parentUseContainerStyling", ctx_r4.formGroup.value == null ? null : ctx_r4.formGroup.value.useContainerStyling);
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 38);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r11.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r11.display, " ");
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "button", 53);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_div_13_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.addColumnDetail(); });
    ɵngcc0.ɵɵtext(2, "Configure columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 57);
    ɵngcc0.ɵɵtext(2, "Flex Size ");
    ɵngcc0.ɵɵelement(3, "i", 60);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 57);
    ɵngcc0.ɵɵtext(5, "Flex Grow ");
    ɵngcc0.ɵɵelement(6, "i", 61);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵtext(2, "Column Size ");
    ɵngcc0.ɵɵelement(3, "i", 62);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 57);
    ɵngcc0.ɵɵelement(2, "input", 68);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 57);
    ɵngcc0.ɵɵelement(4, "input", 69);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "input", 70);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 63);
    ɵngcc0.ɵɵelementStart(2, "div", 55);
    ɵngcc0.ɵɵelementStart(3, "i", 64);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_Template_i_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r23); const i_r19 = ctx.index; const ctx_r22 = ɵngcc0.ɵɵnextContext(4); return ctx_r22.removeColumn(i_r19); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_ng_container_4_Template, 5, 0, "ng-container", 56);
    ɵngcc0.ɵɵtemplate(5, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_ng_container_5_Template, 3, 0, "ng-container", 56);
    ɵngcc0.ɵɵelementStart(6, "div", 57);
    ɵngcc0.ɵɵelement(7, "input", 65);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 57);
    ɵngcc0.ɵɵelement(9, "input", 66);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 7);
    ɵngcc0.ɵɵelement(11, "input", 67);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r19 = ctx.index;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroupName", i_r19);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r16.isFlexLayout());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r16.isFlexLayout());
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 53);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(4); return ctx_r24.addColumnDetail(); });
    ɵngcc0.ɵɵtext(1, "Add Column");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 54);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "div", 55);
    ɵngcc0.ɵɵtemplate(3, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_3_Template, 7, 0, "ng-container", 56);
    ɵngcc0.ɵɵtemplate(4, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_4_Template, 4, 0, "ng-container", 56);
    ɵngcc0.ɵɵelementStart(5, "div", 57);
    ɵngcc0.ɵɵtext(6, "Width");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 57);
    ɵngcc0.ɵɵtext(8, "Height");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 7);
    ɵngcc0.ɵɵtext(10, "Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerStart(11);
    ɵngcc0.ɵɵtemplate(12, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_ng_container_12_Template, 12, 3, "ng-container", 58);
    ɵngcc0.ɵɵtemplate(13, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_button_13_Template, 2, 0, "button", 59);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.isFlexLayout());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r10.isFlexLayout());
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r10.columnDetails.controls);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.columnPreferences.value.columns > ctx_r10.columnDetails.controls.length);
} }
function DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 47);
    ɵngcc0.ɵɵelementContainerStart(1, 48);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "input", 49);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 16);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Column Layout Mode");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "select", 50);
    ɵngcc0.ɵɵtemplate(11, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_option_11_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 4);
    ɵngcc0.ɵɵtemplate(13, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_div_13_Template, 3, 0, "div", 51);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_ng_container_14_Template, 14, 4, "ng-container", 52);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(11);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.columnLayoutModes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r5.columnDetails || (ctx_r5.columnDetails == null ? null : ctx_r5.columnDetails.length) == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.columnDetails && ctx_r5.columnDetails.length > 0);
} }
function DwMdSectionStandardConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "p-accordion", 2);
    ɵngcc0.ɵɵelementStart(2, "p-accordionTab", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Title");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "input", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Show Title");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "dw-yesno", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 9);
    ɵngcc0.ɵɵelementStart(13, "label");
    ɵngcc0.ɵɵtext(14, "Use Title Templates");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(15, "dw-yesno", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "p-accordionTab", 11);
    ɵngcc0.ɵɵelementStart(17, "div", 4);
    ɵngcc0.ɵɵelementStart(18, "div", 5);
    ɵngcc0.ɵɵelementStart(19, "label");
    ɵngcc0.ɵɵtext(20, "Style as Container");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(21, "dw-yesno", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 5);
    ɵngcc0.ɵɵelementStart(23, "label");
    ɵngcc0.ɵɵtext(24, "Section Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "select", 13);
    ɵngcc0.ɵɵtemplate(26, DwMdSectionStandardConfigComponent_div_0_option_26_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "div", 15);
    ɵngcc0.ɵɵelementStart(28, "div", 16);
    ɵngcc0.ɵɵelementStart(29, "label");
    ɵngcc0.ɵɵtext(30, "Style Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "select", 17);
    ɵngcc0.ɵɵtemplate(32, DwMdSectionStandardConfigComponent_div_0_option_32_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "div", 16);
    ɵngcc0.ɵɵelementStart(34, "label");
    ɵngcc0.ɵɵtext(35, "Override Styles");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(36, "dw-yesno", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(37, "div", 16);
    ɵngcc0.ɵɵelementStart(38, "label");
    ɵngcc0.ɵɵtext(39, "Container Icon");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(40, "input", 19);
    ɵngcc0.ɵɵelement(41, "i", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "div", 15);
    ɵngcc0.ɵɵelementStart(43, "div", 16);
    ɵngcc0.ɵɵelementStart(44, "label");
    ɵngcc0.ɵɵtext(45, "Header Background Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(46, "dw-color-select", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(47, "div", 16);
    ɵngcc0.ɵɵelementStart(48, "label");
    ɵngcc0.ɵɵtext(49, "Header Text Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(50, "dw-color-select", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(51, "div", 16);
    ɵngcc0.ɵɵelementStart(52, "label");
    ɵngcc0.ɵɵtext(53, "Icon Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(54, "dw-color-select", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(55, "div", 15);
    ɵngcc0.ɵɵelementStart(56, "div", 16);
    ɵngcc0.ɵɵelementStart(57, "label");
    ɵngcc0.ɵɵtext(58, "Allow Collapse");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(59, "dw-yesno", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(60, "div", 25);
    ɵngcc0.ɵɵelementStart(61, "label");
    ɵngcc0.ɵɵtext(62, "Collapsed Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(63, "dw-expression-picker-control", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(64, "div", 25);
    ɵngcc0.ɵɵelementStart(65, "label");
    ɵngcc0.ɵɵtext(66, "Default to Collapsed");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(67, "dw-yesno", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(68, "div", 15);
    ɵngcc0.ɵɵelementStart(69, "div", 25);
    ɵngcc0.ɵɵelementStart(70, "label");
    ɵngcc0.ɵɵtext(71, "Container Width");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(72, "input", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(73, "div", 25);
    ɵngcc0.ɵɵelementStart(74, "label");
    ɵngcc0.ɵɵtext(75, "Container Height");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(76, "input", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(77, "div", 15);
    ɵngcc0.ɵɵelementStart(78, "div", 16);
    ɵngcc0.ɵɵelementStart(79, "label");
    ɵngcc0.ɵɵtext(80, "Container Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(81, "input", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(82, "div", 16);
    ɵngcc0.ɵɵelementStart(83, "label");
    ɵngcc0.ɵɵtext(84, "Container Inner Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(85, "input", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(86, "div", 16);
    ɵngcc0.ɵɵelementStart(87, "label");
    ɵngcc0.ɵɵtext(88, "Container Title Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(89, "input", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(90, "div", 4);
    ɵngcc0.ɵɵelementStart(91, "div", 33);
    ɵngcc0.ɵɵelementStart(92, "label");
    ɵngcc0.ɵɵtext(93, "Visible Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(94, "dw-expression-picker-control", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(95, DwMdSectionStandardConfigComponent_div_0_div_95_Template, 11, 2, "div", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(96, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_96_Template, 2, 3, "p-accordionTab", 36);
    ɵngcc0.ɵɵtemplate(97, DwMdSectionStandardConfigComponent_div_0_p_accordionTab_97_Template, 15, 3, "p-accordionTab", 37);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("multiple", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.showTitle));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.sectionDefs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.useContainerStyling));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.containerStyles);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵclassMap(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.containerHeaderIcon);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.currentIconColor == null ? null : ctx_r0.currentIconColor.foregroundClass)("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.containerHeaderIcon));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.useContainerStyling));
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.useContainerStyling));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.containerAllowCollapse));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r0.contextNames)("item", ctx_r0.itemName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.containerAllowCollapse));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.useContainerStyling));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.overrideContainerStyles));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.overrideContainerStyles));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.useContainerStyling) || !(ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.overrideContainerStyles));
    ɵngcc0.ɵɵadvance(17);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r0.contextNames)("item", ctx_r0.itemName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showReadOnlySection);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.formGroup == null ? null : ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.useTitleTemplates) && (ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.showTitle));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showColumnConfig && ctx_r0.columnConfigSetup);
} }
function DwMdSectionGridConfigComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r3.FkItemName, " (By ", item_r3.FkAttributeName, ") ");
} }
function DwMdSectionGridConfigComponent_div_29_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r5.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r5.FkItemName, " (By ", item_r5.FkAttributeName, ") ");
} }
function DwMdSectionGridConfigComponent_div_29_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Secondary Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionGridConfigComponent_div_29_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.section.secondaryRelationshipName = $event; })("ngModelChange", function DwMdSectionGridConfigComponent_div_29_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(4, DwMdSectionGridConfigComponent_div_29_option_4_Template, 2, 3, "option", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.section.secondaryRelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.secondaryRelationships);
} }
function DwMdSectionGridConfigComponent_p_tabPanel_40_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 13);
    ɵngcc0.ɵɵelementStart(1, "dw-field-validation-config", 14);
    ɵngcc0.ɵɵlistener("configChange", function DwMdSectionGridConfigComponent_p_tabPanel_40_Template_dw_field_validation_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.section.validationConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r2.section.validationConfig)("configContext", ctx_r2.metaDataConfigContext);
} }
function DwGridSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Grid/list section has an invalid configuration. (", ctx_r0.invalidConfigurationMessage, ")");
} }
function DwGridSectionComponent_ng_container_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelement(1, "dw-validation-info", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r2.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r2.childFormGroupName)("submitted", ctx_r2.submitted);
} }
function DwGridSectionComponent_ng_container_1_ng_container_3_dw_meta_data_grid_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-meta-data-grid", 11);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("dataSource", ctx_r5.dataSource)("readOnly", ctx_r5.isSectionReadOnly())("preferences", ctx_r5.gridPreferences)("item", ctx_r5.sectionConfig.itemName)("addContext", ctx_r5.addContext)("configKeyPart", ctx_r5.configKeyPart)("filters", ctx_r5.filters);
} }
function DwGridSectionComponent_ng_container_1_ng_container_3_dw_meta_data_list_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-meta-data-list", 12);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("dataSource", ctx_r6.dataSource)("item", ctx_r6.sectionConfig.itemName)("configKeyPart", ctx_r6.configKeyPart)("filters", ctx_r6.filters);
} }
function DwGridSectionComponent_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwGridSectionComponent_ng_container_1_ng_container_3_dw_meta_data_grid_1_Template, 1, 7, "dw-meta-data-grid", 9);
    ɵngcc0.ɵɵtemplate(2, DwGridSectionComponent_ng_container_1_ng_container_3_dw_meta_data_list_2_Template, 1, 4, "dw-meta-data-list", 10);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r3.sectionConfig == null ? null : ctx_r3.sectionConfig.showAsList));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.sectionConfig == null ? null : ctx_r3.sectionConfig.showAsList);
} }
function DwGridSectionComponent_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwGridSectionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtemplate(2, DwGridSectionComponent_ng_container_1_div_2_Template, 2, 3, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwGridSectionComponent_ng_container_1_ng_container_3_Template, 3, 2, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(4, DwGridSectionComponent_ng_container_1_ng_container_4_Template, 1, 0, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.childFormGroupName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.itemName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.itemName));
} }
function DwExpressionControlComponent_div_0_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const compareType_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", compareType_r2.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", compareType_r2.display, " ");
} }
function DwExpressionControlComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "dw-expression-reference-control", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionControlComponent_div_0_Template_dw_expression_reference_control_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.expr.reference1 = $event; })("ngModelChange", function DwExpressionControlComponent_div_0_Template_dw_expression_reference_control_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setReference1($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionControlComponent_div_0_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.expr.compareType = $event; })("ngModelChange", function DwExpressionControlComponent_div_0_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setValue(ctx_r7.expr); });
    ɵngcc0.ɵɵtemplate(5, DwExpressionControlComponent_div_0_option_5_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 4);
    ɵngcc0.ɵɵelementStart(7, "dw-expression-reference-control", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionControlComponent_div_0_Template_dw_expression_reference_control_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.expr.reference2 = $event; })("ngModelChange", function DwExpressionControlComponent_div_0_Template_dw_expression_reference_control_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.setValue(ctx_r9.expr); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.expr.reference1)("item", ctx_r0.item)("queryMeaning", ctx_r0.queryMeaning)("contextNames", ctx_r0.contextNames);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.compareTypes || (ctx_r0.compareTypes == null ? null : ctx_r0.compareTypes.length) == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.expr.compareType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.compareTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.compareTypes || (ctx_r0.compareTypes == null ? null : ctx_r0.compareTypes.length) == 0 || !ctx_r0.compareNeedsValue(ctx_r0.expr.compareType));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.expr.reference2)("relatedExprRef", ctx_r0.relatedExprRef)("item", ctx_r0.item)("queryMeaning", ctx_r0.queryMeaning)("contextNames", ctx_r0.contextNames)("comparerType", ctx_r0.expr.compareType);
} }
function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_div_1_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const operatorType_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", operatorType_r12.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", operatorType_r12.display, " ");
} }
function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelement(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "div", 14);
    ɵngcc0.ɵɵelementStart(3, "select", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_div_1_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(4); return ctx_r13.exprGroup.operator = $event; })("ngModelChange", function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_div_1_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(4); return ctx_r15.setValue(ctx_r15.exprGroup); });
    ɵngcc0.ɵɵtemplate(4, DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_div_1_option_4_Template, 2, 2, "option", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.exprGroup.operator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.operatorTypes);
} }
function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-expression-bracket");
    ɵngcc0.ɵɵelementStart(2, "dw-expression-group-control", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_ng_container_6_Template_dw_expression_group_control_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const expr_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.setExprValue(ctx_r16.exprGroup, expr_r4, ctx_r16.index); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const expr_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", expr_r4)("contextNames", ctx_r9.contextNames)("item", ctx_r9.item)("queryMeaning", ctx_r9.queryMeaning);
} }
function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-expression-control", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_ng_container_7_Template_dw_expression_control_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const expr_r4 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.setExprValue(ctx_r20.exprGroup, expr_r4, ctx_r20.index); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const expr_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", expr_r4)("contextNames", ctx_r10.contextNames)("item", ctx_r10.item)("queryMeaning", ctx_r10.queryMeaning);
} }
function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_div_1_Template, 5, 2, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵelementStart(4, "i", 12);
    ɵngcc0.ɵɵlistener("click", function DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_Template_i_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r25); const expr_r4 = ctx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(3); return ctx_r24.removeExpr(expr_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 13);
    ɵngcc0.ɵɵtemplate(6, DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_ng_container_6_Template, 3, 4, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(7, DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_ng_container_7_Template, 2, 4, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const expr_r4 = ctx.$implicit;
    const isFirst_r5 = ctx.first;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !isFirst_r5);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isExpressionGroup(expr_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.isExpressionGroup(expr_r4));
} }
function DwExpressionGroupControlComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, DwExpressionGroupControlComponent_div_0_div_1_ng_container_1_Template, 8, 3, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.exprGroup.expressions);
} }
function DwExpressionGroupControlComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwExpressionGroupControlComponent_div_0_div_1_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "button", 3);
    ɵngcc0.ɵɵlistener("click", function DwExpressionGroupControlComponent_div_0_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.addExpr(); });
    ɵngcc0.ɵɵelement(4, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwExpressionGroupControlComponent_div_0_Template_button_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.addExprGroup(); });
    ɵngcc0.ɵɵelement(6, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.exprGroup);
} }
function DwExpressionGroupControlComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " Expression require an Item or a Context Name\n");
    ɵngcc0.ɵɵelementEnd();
} }
function DwExpressionReferenceControlComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "json");
    ɵngcc0.ɵɵpipe(3, "json");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" No Expression Reference or reference types Expr Ref: ", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r0.exprRef), " Ref Types: ", ɵngcc0.ɵɵpipeBind1(3, 4, ctx_r0.referenceTypes), "\n");
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p-dropdown", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_4_Template_p_dropdown_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.exprRef.attrName = $event; })("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_4_Template_p_dropdown_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.setValue(ctx_r7.exprRef); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(4, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r2.itemAttributes)("ngModel", ctx_r2.exprRef.attrName);
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_5_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextDef_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", contextDef_r10.contextName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", contextDef_r10.contextDisplay, " ");
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_5_select_6_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r12.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r12.AttributeDisplay, " ");
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_5_select_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_5_select_6_Template_select_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.exprRef.attrName = $event; })("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_5_select_6_Template_select_ngModelChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.setValue(ctx_r15.exprRef); });
    ɵngcc0.ɵɵtemplate(1, DwExpressionReferenceControlComponent_div_1_ng_container_5_select_6_option_1_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.exprRef.attrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r9.currentContextAttributes);
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_5_Template_select_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.exprRef.contextName = $event; })("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_5_Template_select_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.setValue(ctx_r18.exprRef); });
    ɵngcc0.ɵɵtemplate(3, DwExpressionReferenceControlComponent_div_1_ng_container_5_option_3_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 1);
    ɵngcc0.ɵɵelementStart(5, "p-dropdown", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_5_Template_p_dropdown_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.exprRef.attrName = $event; })("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_5_Template_p_dropdown_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.setValue(ctx_r20.exprRef); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwExpressionReferenceControlComponent_div_1_ng_container_5_select_6_Template, 2, 2, "select", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.exprRef.contextName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.contextDefs);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(7, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r3.currentContextAttributes)("ngModel", ctx_r3.exprRef.attrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", false && ctx_r3.exprRef.contextName);
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_6_form_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "form", 11);
    ɵngcc0.ɵɵelement(1, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r21.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r21.valueFieldDef)("formGroup", ctx_r21.formGroup);
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "input", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_6_div_2_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.exprRef.value = $event; })("ngModelChange", function DwExpressionReferenceControlComponent_div_1_ng_container_6_div_2_Template_input_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ctx_r25.setValue(ctx_r25.exprRef); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r22.exprRef.value);
} }
function DwExpressionReferenceControlComponent_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwExpressionReferenceControlComponent_div_1_ng_container_6_form_1_Template, 2, 3, "form", 10);
    ɵngcc0.ɵɵtemplate(2, DwExpressionReferenceControlComponent_div_1_ng_container_6_div_2_Template, 2, 1, "div", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.formGroup && ctx_r4.valueFieldDef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.formGroup || !ctx_r4.valueFieldDef);
} }
function DwExpressionReferenceControlComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "dw-pills", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionReferenceControlComponent_div_1_Template_dw_pills_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.exprRef.referenceType = $event; })("ngModelChange", function DwExpressionReferenceControlComponent_div_1_Template_dw_pills_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.setRefeferenceType($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵtemplate(4, DwExpressionReferenceControlComponent_div_1_ng_container_4_Template, 2, 5, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(5, DwExpressionReferenceControlComponent_div_1_ng_container_5_Template, 7, 8, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(6, DwExpressionReferenceControlComponent_div_1_ng_container_6_Template, 3, 2, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("items", ctx_r1.availableReferenceTypes)("ngModel", ctx_r1.exprRef.referenceType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r1.exprRef.referenceType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "item");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "context");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "value");
} }
function DwMdChildDataSectionConfigComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.NamingInfo == null ? null : item_r3.NamingInfo.RelationshipDisplayName, " ");
} }
function DwMdChildDataSectionConfigComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelement(5, "br");
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.relationshipDisplay, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Property: ", ctx_r1.section.propertyName, " ");
} }
function DwMdChildDataSectionConfigComponent_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r4.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r4.display, " ");
} }
function DwChildDataSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Child Data section has an invalid configuration. (", ctx_r0.invalidConfigurationMessage, ")");
} }
function DwChildDataSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementContainerStart(1, 6);
    ɵngcc0.ɵɵelement(2, "dw-dynamic-section", 7);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroupName", ctx_r1.formGroupName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r1.formConfig)("sectionConfig", ctx_r1.sectionConfig.section)("formGroup", ctx_r1.childFormGroup)("context", ctx_r1.context)("submitted", ctx_r1.submitted)("parentIsVisible", ctx_r1.visible);
} }
function DwMdSectionPreviewComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "form", 2);
    ɵngcc0.ɵɵelement(2, "dw-dynamic-section", 3);
    ɵngcc0.ɵɵelementStart(3, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(4, "button", 4);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionPreviewComponent_div_3_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.sampleSave(); });
    ɵngcc0.ɵɵtext(5, "Sample Save");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r0.formConfig)("context", ctx_r0.context)("sectionConfig", ctx_r0.section)("formGroup", ctx_r0.formGroup)("submitted", ctx_r0.submitted);
} }
function DwMdSectionFormFieldConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label", 1);
    ɵngcc0.ɵɵtext(2, "Context: \u00A0 ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.selectedFieldContextMd == null ? null : ctx_r0.selectedFieldContextMd.contextDef == null ? null : ctx_r0.selectedFieldContextMd.contextDef.contextDisplay, "\n");
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Basic Settings ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r2.fieldConfiguredOptions == null ? null : ctx_r2.fieldConfiguredOptions.hasBasicSettings));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.selectedField.label = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Placeholder Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.selectedField.placeholderText = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_9_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 14);
    ɵngcc0.ɵɵelementStart(11, "div", 15);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Read only Missing Data Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "input", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.selectedField.readOnlyMissingDataText = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_14_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 14);
    ɵngcc0.ɵɵelementStart(16, "div", 19);
    ɵngcc0.ɵɵtext(17, " Hide Label ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 20);
    ɵngcc0.ɵɵelementStart(19, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_p_inputSwitch_ngModelChange_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.selectedField.hideLabel = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_p_inputSwitch_ngModelChange_19_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 14);
    ɵngcc0.ɵɵelementStart(21, "div", 15);
    ɵngcc0.ɵɵelementStart(22, "label");
    ɵngcc0.ɵɵtext(23, "Info Icon Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.selectedField.infoText = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template_input_ngModelChange_24_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedField.label)("placeholder", (ctx_r3.selectedAttr == null ? null : ctx_r3.selectedAttr.AttributeDisplay) || "");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedField.placeholderText);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedField.readOnlyMissingDataText);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedField.hideLabel);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedField.infoText);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Default Value ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r4.fieldConfiguredOptions == null ? null : ctx_r4.fieldConfiguredOptions.hasDefaultValue));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "dw-default-value", 22);
    ɵngcc0.ɵɵlistener("defaultValueChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_ng_container_6_Template_dw_default_value_defaultValueChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.selectedField.defaultValue = $event; })("defaultValueChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_ng_container_6_Template_dw_default_value_defaultValueChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("defaultValue", ctx_r28.selectedField.defaultValue)("contextNames", ctx_r28.contextNames)("queryAttribute", ctx_r28.selectedAttr);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Default Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 20);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.selectedField.hasDefaultValue = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_ng_container_6_Template, 4, 3, "ng-container", 0);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.selectedField.hasDefaultValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.selectedField.hasDefaultValue);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Field Layout ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r6.fieldConfiguredOptions == null ? null : ctx_r6.fieldConfiguredOptions.hasFieldLayout));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2, " New Row Before ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_p_inputSwitch_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ctx_r35.selectedField.columnItemPreferences.newRowBefore = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_p_inputSwitch_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ctx_r37.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 19);
    ɵngcc0.ɵɵtext(7, " Span All Columns ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 20);
    ɵngcc0.ɵɵelementStart(9, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_p_inputSwitch_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ctx_r38.selectedField.columnItemPreferences.spanAllColumns = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_p_inputSwitch_ngModelChange_9_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r39 = ɵngcc0.ɵɵnextContext(2); return ctx_r39.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 23);
    ɵngcc0.ɵɵelementStart(11, "div", 15);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Column Size Override ");
    ɵngcc0.ɵɵelement(14, "i", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.selectedField.columnItemPreferences.columnSizeOverride = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_input_ngModelChange_15_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r41 = ɵngcc0.ɵɵnextContext(2); return ctx_r41.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 23);
    ɵngcc0.ɵɵelementStart(17, "div", 15);
    ɵngcc0.ɵɵelementStart(18, "label");
    ɵngcc0.ɵɵtext(19, "Skip Columns ");
    ɵngcc0.ɵɵelement(20, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r42 = ɵngcc0.ɵɵnextContext(2); return ctx_r42.selectedField.columnItemPreferences.skipColumns = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template_input_ngModelChange_21_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ctx_r43.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.selectedField.columnItemPreferences.newRowBefore);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.selectedField.columnItemPreferences.spanAllColumns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r7.selectedField.columnItemPreferences.spanAllColumns);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.selectedField.columnItemPreferences.columnSizeOverride);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r7.selectedField.columnItemPreferences.spanAllColumns);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.selectedField.columnItemPreferences.skipColumns);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Classes ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r8.fieldConfiguredOptions == null ? null : ctx_r8.fieldConfiguredOptions.hasClasess));
} }
const _c70 = function () { return ["label", "data", "icon"]; };
const _c71 = function () { return ["Label Classes", "Data Classes", "Icon Classes"]; };
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Label Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r44 = ɵngcc0.ɵɵnextContext(2); return ctx_r44.selectedField.labelClass = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r46 = ɵngcc0.ɵɵnextContext(2); return ctx_r46.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Data Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r47 = ɵngcc0.ɵɵnextContext(2); return ctx_r47.selectedField.dataClass = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_input_ngModelChange_9_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r48 = ɵngcc0.ɵɵnextContext(2); return ctx_r48.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 14);
    ɵngcc0.ɵɵelementStart(11, "div", 15);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Icon Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_input_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r49 = ɵngcc0.ɵɵnextContext(2); return ctx_r49.selectedField.iconClass = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_input_ngModelChange_14_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r50 = ɵngcc0.ɵɵnextContext(2); return ctx_r50.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "b");
    ɵngcc0.ɵɵtext(16, "Conditional Classes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "dw-conditional-field-classes", 27);
    ɵngcc0.ɵɵlistener("conditionalClassesChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_dw_conditional_field_classes_conditionalClassesChange_17_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r51 = ɵngcc0.ɵɵnextContext(2); return ctx_r51.selectedField.conditionalFieldClasses = $event; })("conditionalClassesChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template_dw_conditional_field_classes_conditionalClassesChange_17_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r52 = ɵngcc0.ɵɵnextContext(2); return ctx_r52.updateField(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.selectedField.labelClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.selectedField.dataClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.selectedField.iconClass);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("conditionalClasses", ctx_r9.selectedField.conditionalFieldClasses)("contextNames", ctx_r9.contextNames)("itemName", ctx_r9.itemName)("classNames", ɵngcc0.ɵɵpureFunction0(8, _c70))("classLabels", ɵngcc0.ɵɵpureFunction0(9, _c71));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Read Only/Visibility ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r10.fieldConfiguredOptions == null ? null : ctx_r10.fieldConfiguredOptions.hasReadOnlyVisible));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    const _r54 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2, " Is Read Only ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_p_inputSwitch_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r53 = ɵngcc0.ɵɵnextContext(2); return ctx_r53.selectedField.isReadOnly = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_p_inputSwitch_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r55 = ɵngcc0.ɵɵnextContext(2); return ctx_r55.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "div", 15);
    ɵngcc0.ɵɵtext(7, " Is Read Only (Expression) ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 15);
    ɵngcc0.ɵɵelementStart(9, "div", 28);
    ɵngcc0.ɵɵelementStart(10, "dw-expression-picker-control", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_dw_expression_picker_control_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r56 = ɵngcc0.ɵɵnextContext(2); return ctx_r56.selectedField.isReadOnlyExpression = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_dw_expression_picker_control_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r57 = ɵngcc0.ɵɵnextContext(2); return ctx_r57.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 14);
    ɵngcc0.ɵɵelementStart(12, "div", 15);
    ɵngcc0.ɵɵtext(13, " Is Visible (Expression) ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 15);
    ɵngcc0.ɵɵelementStart(15, "dw-expression-picker-control", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_dw_expression_picker_control_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r58 = ɵngcc0.ɵɵnextContext(2); return ctx_r58.selectedField.isVisibleExpression = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_dw_expression_picker_control_ngModelChange_15_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r59 = ɵngcc0.ɵɵnextContext(2); return ctx_r59.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 14);
    ɵngcc0.ɵɵelementStart(17, "div", 19);
    ɵngcc0.ɵɵtext(18, " Rearrange Fields ");
    ɵngcc0.ɵɵelement(19, "i", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 20);
    ɵngcc0.ɵɵelementStart(21, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_p_inputSwitch_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r60 = ɵngcc0.ɵɵnextContext(2); return ctx_r60.selectedField.columnItemPreferences.rearrangeFieldsOnVisibleChange = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template_p_inputSwitch_ngModelChange_21_listener() { ɵngcc0.ɵɵrestoreView(_r54); const ctx_r61 = ɵngcc0.ɵɵnextContext(2); return ctx_r61.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.selectedField.isReadOnly);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.selectedField.isReadOnlyExpression)("contextNames", ctx_r11.contextNames)("item", ctx_r11.itemName);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.selectedField.isVisibleExpression)("contextNames", ctx_r11.contextNames)("item", ctx_r11.itemName);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.selectedField.columnItemPreferences.rearrangeFieldsOnVisibleChange);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Control Overrides ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r12.fieldConfiguredOptions == null ? null : ctx_r12.fieldConfiguredOptions.hasControlOverrides));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r66 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2, " Use Custom Control ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 20);
    ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_6_Template_p_inputSwitch_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r65 = ɵngcc0.ɵɵnextContext(3); return ctx_r65.selectedField.useCustomControl = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_6_Template_p_inputSwitch_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r66); const ctx_r67 = ɵngcc0.ɵɵnextContext(3); return ctx_r67.updateField(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r62.selectedField.useCustomControl);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r69 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Custom Control");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p-dropdown", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_8_Template_p_dropdown_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r69); const ctx_r68 = ɵngcc0.ɵɵnextContext(3); return ctx_r68.selectedField.customControlTypeKey = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_8_Template_p_dropdown_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r69); const ctx_r70 = ɵngcc0.ɵɵnextContext(3); return ctx_r70.setControlTypeOverride($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r63 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(5, _c43));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r63.selectedField.customControlTypeKey)("options", ctx_r63.customControlTypes)("showClear", true);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r72 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Standard Control");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-search-select-lookup", 36);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_10_Template_dw_search_select_lookup_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r71 = ɵngcc0.ɵɵnextContext(3); return ctx_r71.selectedField.controlTypeOverride = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_10_Template_dw_search_select_lookup_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r72); const ctx_r73 = ɵngcc0.ɵɵnextContext(3); return ctx_r73.setControlTypeOverride($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r64 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r64.selectedField.controlTypeOverride)("lookupId", ctx_r64.controlTypeLookupId);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template(rf, ctx) { if (rf & 1) {
    const _r75 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵtext(2, " Customize Control Type ");
    ɵngcc0.ɵɵelement(3, "i", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 20);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r75); const ctx_r74 = ɵngcc0.ɵɵnextContext(2); return ctx_r74.selectedField.useControlTypeOverride = $event; })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r75); const ctx_r76 = ɵngcc0.ɵɵnextContext(2); return ctx_r76.updateField(); })("ngModelChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r75); const ctx_r77 = ɵngcc0.ɵɵnextContext(2); return ctx_r77.setShowControlTypeOverride($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_6_Template, 5, 1, "div", 32);
    ɵngcc0.ɵɵelementStart(7, "div", 14);
    ɵngcc0.ɵɵtemplate(8, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_8_Template, 4, 6, "div", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 14);
    ɵngcc0.ɵɵtemplate(10, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_div_10_Template, 4, 2, "div", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "dw-select-lookup-config", 34);
    ɵngcc0.ɵɵlistener("configChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template_dw_select_lookup_config_configChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r75); const ctx_r78 = ɵngcc0.ɵɵnextContext(2); return ctx_r78.selectedField.lookupConfig = $event; })("configChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template_dw_select_lookup_config_configChange_11_listener() { ɵngcc0.ɵɵrestoreView(_r75); const ctx_r79 = ɵngcc0.ɵɵnextContext(2); return ctx_r79.updateField(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r13.selectedField.useControlTypeOverride);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.selectedField.useControlTypeOverride);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.selectedField.useControlTypeOverride && ctx_r13.selectedField.useCustomControl);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.selectedField.useControlTypeOverride && !ctx_r13.selectedField.useCustomControl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r13.selectedField.lookupConfig)("configContext", ctx_r13.dwFormFieldContext);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Control Settings ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r80 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r80.fieldConfiguredOptions == null ? null : ctx_r80.fieldConfiguredOptions.hasControlSettings));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r83 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 38);
    ɵngcc0.ɵɵlistener("configure", function DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_ng_template_2_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r83); const ctx_r82 = ɵngcc0.ɵɵnextContext(3); return ctx_r82.configureFieldControlOptionInstance($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r81 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("component", ctx_r81.controlOptionsComponentType);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 37);
    ɵngcc0.ɵɵtemplate(1, DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_ng_template_1_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(2, DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_ng_template_2_Template, 1, 1, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, "Validation ");
    ɵngcc0.ɵɵelement(1, "i", 13);
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r15.fieldConfiguredOptions == null ? null : ctx_r15.fieldConfiguredOptions.hasCustomValidation));
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_22_Template(rf, ctx) { if (rf & 1) {
    const _r85 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-field-validation-config", 34);
    ɵngcc0.ɵɵlistener("configChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_22_Template_dw_field_validation_config_configChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r85); const ctx_r84 = ɵngcc0.ɵɵnextContext(2); return ctx_r84.selectedField.validationConfig = $event; })("configChange", function DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_22_Template_dw_field_validation_config_configChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r85); const ctx_r86 = ɵngcc0.ɵɵnextContext(2); return ctx_r86.updateField(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("config", ctx_r16.selectedField.validationConfig)("configContext", ctx_r16.dwFormFieldContext);
} }
function DwMdSectionFormFieldConfigComponent_p_accordion_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵelementStart(1, "p-accordionTab", 3);
    ɵngcc0.ɵɵtemplate(2, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_2_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(3, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_3_Template, 25, 6, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p-accordionTab", 6);
    ɵngcc0.ɵɵtemplate(5, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_5_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(6, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_6_Template, 7, 2, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "p-accordionTab", 7);
    ɵngcc0.ɵɵtemplate(8, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_8_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(9, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_9_Template, 22, 6, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "p-accordionTab", 8);
    ɵngcc0.ɵɵtemplate(11, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_11_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(12, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_12_Template, 18, 10, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "p-accordionTab", 9);
    ɵngcc0.ɵɵtemplate(14, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_14_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(15, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_15_Template, 22, 8, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "p-accordionTab", 10);
    ɵngcc0.ɵɵtemplate(17, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_17_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(18, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_18_Template, 12, 6, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(19, DwMdSectionFormFieldConfigComponent_p_accordion_6_p_accordionTab_19_Template, 3, 0, "p-accordionTab", 11);
    ɵngcc0.ɵɵelementStart(20, "p-accordionTab", 12);
    ɵngcc0.ɵɵtemplate(21, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_21_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵtemplate(22, DwMdSectionFormFieldConfigComponent_p_accordion_6_ng_template_22_Template, 1, 2, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(18);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.controlOptionsComponentType);
} }
function DwDynamicControlComponent_ng_template_1_Template(rf, ctx) { }
function DwSearchSelectLookupComponent_p_dropdown_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-dropdown", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSearchSelectLookupComponent_p_dropdown_2_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.translatedValue = $event; })("ngModelChange", function DwSearchSelectLookupComponent_p_dropdown_2_Template_p_dropdown_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.setTranslatedValue($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(12, _c43));
    ɵngcc0.ɵɵproperty("placeholder", ctx_r0.placeholder)("options", ctx_r0.finalLookupItems)("resetFilterOnHide", true)("group", ctx_r0.useGroups)("optionValue", ctx_r0.valueAttrName)("ngModel", ctx_r0.translatedValue)("showClear", ctx_r0.showClear)("filter", ctx_r0.showFilter)("virtualScroll", ctx_r0.virtualScroll)("itemSize", ctx_r0.virtualScrollItems);
} }
function DwSearchSelectLookupComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.getAdditionalFieldDisplay());
} }
function DwAutoCompleteLookupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p-autoComplete", 1);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAutoCompleteLookupComponent_ng_container_0_Template_p_autoComplete_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.translatedValue = $event; })("ngModelChange", function DwAutoCompleteLookupComponent_ng_container_0_Template_p_autoComplete_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.setTranslatedValue($event); })("completeMethod", function DwAutoCompleteLookupComponent_ng_container_0_Template_p_autoComplete_completeMethod_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.searchStart($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(8, _c43));
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.translatedValue)("disabled", ctx_r0.disabled)("suggestions", ctx_r0.lookupItems)("placeholder", ctx_r0.placeholder || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.noResultMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.noResultMessage, " ");
} }
function DwAutoCompleteLookupComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-control-wrapper-with-icons", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵlistener("click", function DwAutoCompleteLookupComponent_ng_container_1_Template_div_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.clearItem(); });
    ɵngcc0.ɵɵelement(7, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DwAutoCompleteLookupComponent_ng_container_1_Template_i_click_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.openItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "i", 11);
    ɵngcc0.ɵɵlistener("click", function DwAutoCompleteLookupComponent_ng_container_1_Template_i_click_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.openItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("showSuffix", ctx_r1.options == null ? null : ctx_r1.options.showLink);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.translatedValue == null ? null : ctx_r1.translatedValue.Display);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMap((ctx_r1.options == null ? null : ctx_r1.options.linkIconClass) || "fa fa-external-link");
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.options == null ? null : ctx_r1.options.linkTooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap((ctx_r1.options == null ? null : ctx_r1.options.linkIconClass) || "fa fa-external-link");
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r1.options == null ? null : ctx_r1.options.linkTooltip))("title", ctx_r1.options == null ? null : ctx_r1.options.linkTooltip);
} }
function DwContentConfigEditComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "label", 10);
    ɵngcc0.ɵɵtext(3, "Show Hidden Content");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-yesno", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwContentConfigEditComponent_div_0_div_1_Template_dw_yesno_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.showMissing = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.showMissing);
} }
function DwContentConfigEditComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " There are no content items for this section ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 19);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    const i_r10 = ctx_r15.index;
    const subFormGroup_r9 = ctx_r15.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r12.itemFieldsReadOnly[i_r10])("formGroup", subFormGroup_r9);
} }
function DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 20);
    ɵngcc0.ɵɵlistener("click", function DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_14_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); const i_r10 = ɵngcc0.ɵɵnextContext(2).index; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.copyDefaultContent(i_r10); });
    ɵngcc0.ɵɵtext(2, "Copy Default Content");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelement(4, "div", 19);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵngcc0.ɵɵnextContext(2);
    const i_r10 = ctx_r19.index;
    const subFormGroup_r9 = ctx_r19.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r13.itemFields[i_r10])("formGroup", subFormGroup_r9);
} }
function DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-content-config-component", 21);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subFormGroup_r9 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("subFormGroup", subFormGroup_r9);
} }
function DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 13);
    ɵngcc0.ɵɵelementStart(1, "p-header");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelementStart(5, "div", 14);
    ɵngcc0.ɵɵelementStart(6, "label", 10);
    ɵngcc0.ɵɵtext(7, "Use Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 14);
    ɵngcc0.ɵɵelement(9, "p-inputSwitch", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 8);
    ɵngcc0.ɵɵelementStart(11, "div", 16);
    ɵngcc0.ɵɵelementStart(12, "div", 17);
    ɵngcc0.ɵɵtemplate(13, DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_13_Template, 2, 2, "ng-container", 18);
    ɵngcc0.ɵɵtemplate(14, DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_14_Template, 5, 2, "ng-container", 18);
    ɵngcc0.ɵɵtemplate(15, DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_ng_container_15_Template, 2, 1, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext();
    const i_r10 = ctx_r21.index;
    const subFormGroup_r9 = ctx_r21.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("selected", ctx_r11.activeIndex == i_r10);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", subFormGroup_r9.get("display").value, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", subFormGroup_r9);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r11.getTemplateName(subFormGroup_r9));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "defaultContent");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "editContent");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "editComponent");
} }
function DwContentConfigEditComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwContentConfigEditComponent_div_0_ng_container_5_p_accordionTab_1_Template, 16, 7, "p-accordionTab", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const subFormGroup_r9 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.showMissing || !subFormGroup_r9.get("isMissing").value);
} }
function DwContentConfigEditComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwContentConfigEditComponent_div_0_div_1_Template, 5, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(2, DwContentConfigEditComponent_div_0_div_2_Template, 2, 0, "div", 0);
    ɵngcc0.ɵɵelementStart(3, "form", 5);
    ɵngcc0.ɵɵelementStart(4, "p-accordion", 6);
    ɵngcc0.ɵɵtemplate(5, DwContentConfigEditComponent_div_0_ng_container_5_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasHiddenContent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.preferences == null ? null : ctx_r0.preferences.items == null ? null : ctx_r0.preferences.items.length) == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("multiple", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formArray.controls);
} }
function DwContentConfigEditComponent_1_ng_template_0_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 23);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r24.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r24.name, " ");
} }
function DwContentConfigEditComponent_1_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "label", 10);
    ɵngcc0.ɵɵtext(2, "Component");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 22);
    ɵngcc0.ɵɵelementStart(4, "option", 23);
    ɵngcc0.ɵɵtext(5, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwContentConfigEditComponent_1_ng_template_0_option_6_Template, 2, 2, "option", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r22.components);
} }
function DwContentConfigEditComponent_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwContentConfigEditComponent_1_ng_template_0_Template, 7, 2, "ng-template");
} }
function DwContentConfigEditComponent_2_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function DwContentConfigEditComponent_2_ng_template_0_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.copyDefaultContent(ctx_r26.i); });
    ɵngcc0.ɵɵtext(1, "Copy Default Content");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelement(3, "div", 19);
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r25.itemFields[ctx_r25.i])("formGroup", ctx_r25.formArray.controls[ctx_r25.i]);
} }
function DwContentConfigEditComponent_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwContentConfigEditComponent_2_ng_template_0_Template, 4, 2, "ng-template");
} }
function DwContentConfigEditComponent_3_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 19);
} if (rf & 2) {
    const ctx_r28 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r28.itemFieldsReadOnly[ctx_r28.i])("formGroup", ctx_r28.formArray.controls[ctx_r28.i]);
} }
function DwContentConfigEditComponent_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwContentConfigEditComponent_3_ng_template_0_Template, 1, 2, "ng-template");
} }
function DwContentConfigWidgetComponent_div_0_ng_template_16_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const val_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(val_r5);
} }
function DwContentConfigWidgetComponent_div_0_ng_template_16_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "None");
    ɵngcc0.ɵɵelementEnd();
} }
function DwContentConfigWidgetComponent_div_0_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, DwContentConfigWidgetComponent_div_0_ng_template_16_span_0_Template, 3, 1, "span", 9);
    ɵngcc0.ɵɵtemplate(1, DwContentConfigWidgetComponent_div_0_ng_template_16_span_1_Template, 2, 0, "span", 0);
} if (rf & 2) {
    const value_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngForOf", value_r2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !value_r2 || value_r2.length === 0);
} }
function DwContentConfigWidgetComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h3");
    ɵngcc0.ɵɵtext(2, "Content Preferences");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "form", 1);
    ɵngcc0.ɵɵlistener("ngSubmit", function DwContentConfigWidgetComponent_div_0_Template_form_ngSubmit_3_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onSubmit(); });
    ɵngcc0.ɵɵelementStart(4, "p-accordion");
    ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 2);
    ɵngcc0.ɵɵelementStart(6, "div", 3);
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwContentConfigWidgetComponent_div_0_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.configContent(); });
    ɵngcc0.ɵɵtext(9, " Edit Content ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "p-accordionTab", 6);
    ɵngcc0.ɵɵelementStart(11, "div", 3);
    ɵngcc0.ɵɵelementStart(12, "div", 4);
    ɵngcc0.ɵɵelementStart(13, "label");
    ɵngcc0.ɵɵtext(14, "Context Data");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "p-multiSelect", 7);
    ɵngcc0.ɵɵtemplate(16, DwContentConfigWidgetComponent_div_0_ng_template_16_Template, 2, 2, "ng-template", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.configForm);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("options", ctx_r0.contextDefList);
} }
function DwContentManagerComponent_p_contextMenu_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-contextMenu", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("target", _r0)("model", ctx_r1.contextMenu);
} }
function DwWorkflowLookupButtonsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 1);
    ɵngcc0.ɵɵlistener("click", function DwWorkflowLookupButtonsComponent_ng_container_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const button_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.click(button_r1.lookupItem); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("btn btn-success ", button_r1.buttonConfig.buttonClass, "");
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disabled)("title", button_r1.buttonConfig.buttonTitle || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", button_r1.buttonConfig.buttonText, " ");
} }
function DwEmailTemplateConfigComponent_ng_container_0_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const query_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", query_r5.QueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", query_r5.QueryName, " ");
} }
function DwEmailTemplateConfigComponent_ng_container_0_div_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label", 4);
    ɵngcc0.ɵɵtext(2, " Test Distribution List (Optional) ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "dw-select-lookup", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r2.emailDistributionListLookupId);
} }
function DwEmailTemplateConfigComponent_ng_container_0_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, " E-mail Recipients ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-email-template-recipient-config", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r3.templateConfigFormGroup)("userAttrs", ctx_r3.userAttrs)("itemMetaData", ctx_r3.itemMetaData)("templateConfig", ctx_r3.templateConfig)("queryMetaData", ctx_r3.queryMetaData);
} }
function DwEmailTemplateConfigComponent_ng_container_0_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, " E-mail Events ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-email-template-trigger-config", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r4.templateConfigFormGroup)("itemMetaData", ctx_r4.itemMetaData)("templateConfig", ctx_r4.templateConfig)("queryMetaData", ctx_r4.queryMetaData);
} }
function DwEmailTemplateConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "label", 4);
    ɵngcc0.ɵɵtext(6, " Query ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "select", 5);
    ɵngcc0.ɵɵelementStart(8, "option", 6);
    ɵngcc0.ɵɵtext(9, " Default ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, DwEmailTemplateConfigComponent_ng_container_0_option_10_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 2);
    ɵngcc0.ɵɵelementStart(12, "div", 8);
    ɵngcc0.ɵɵelementStart(13, "label", 4);
    ɵngcc0.ɵɵtext(14, " Disabled ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(15, "dw-yesno", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 8);
    ɵngcc0.ɵɵelementStart(17, "label", 4);
    ɵngcc0.ɵɵtext(18, " Test Mode ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(19, "dw-yesno", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(20, DwEmailTemplateConfigComponent_ng_container_0_div_20_Template, 4, 1, "div", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, DwEmailTemplateConfigComponent_ng_container_0_div_21_Template, 5, 5, "div", 12);
    ɵngcc0.ɵɵtemplate(22, DwEmailTemplateConfigComponent_ng_container_0_div_22_Template, 5, 4, "div", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.templateConfigFormGroup);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.queries);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.templateConfigFormGroup.value == null ? null : ctx_r0.templateConfigFormGroup.value.testMode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.queryMetaData);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.queryMetaData);
} }
function DwEmailTemplateFieldsComponent_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "button", 6);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateFieldsComponent_ng_container_6_div_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const attr_r3 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.addItemAttr(attr_r3); });
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateFieldsComponent_ng_container_6_div_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); const attr_r3 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.addItemAttr(attr_r3, true); });
    ɵngcc0.ɵɵelement(5, "i", 7);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r3.AttributeDisplay, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", attr_r3.DisplayAttributeName == attr_r3.AttributeName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r3.AttributeDisplay, " - Display ");
} }
function DwEmailTemplateFieldsComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwEmailTemplateFieldsComponent_ng_container_6_div_1_Template, 7, 3, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attr_r3 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.includeAttr(attr_r3));
} }
function DwEmailTemplateFieldsComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "button", 6);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateFieldsComponent_ng_container_9_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r13); const code_r11 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.appendToBodyTemplate(code_r11.templateCode); });
    ɵngcc0.ɵɵelement(3, "i", 7);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const code_r11 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1(" ", code_r11.display, " ");
} }
function DwEmailTemplateFieldsComponent_p_accordionTab_10_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "button", 6);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateFieldsComponent_p_accordionTab_10_ng_container_1_div_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r20); const attr_r16 = ɵngcc0.ɵɵnextContext().$implicit; const userAttr_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.addUserAttr(userAttr_r14, attr_r16); });
    ɵngcc0.ɵɵelement(2, "i", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r16 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r16.Display, " ");
} }
function DwEmailTemplateFieldsComponent_p_accordionTab_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwEmailTemplateFieldsComponent_p_accordionTab_10_ng_container_1_div_1_Template, 4, 1, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attr_r16 = ctx.$implicit;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r15.includeAttr(attr_r16));
} }
function DwEmailTemplateFieldsComponent_p_accordionTab_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 0);
    ɵngcc0.ɵɵtemplate(1, DwEmailTemplateFieldsComponent_p_accordionTab_10_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const userAttr_r14 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate1("header", "", userAttr_r14.Display, " Fields");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.userItemMetaData == null ? null : ctx_r2.userItemMetaData.Attributes);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const emailTriggerType_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", emailTriggerType_r10.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", emailTriggerType_r10.display, " ");
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_11_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r12.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r12.Display, " ");
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 19);
    ɵngcc0.ɵɵtemplate(4, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_11_option_4_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.itemMetaData == null ? null : ctx_r5.itemMetaData.Attributes);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Old Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r3 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r6.attrValueOldFieldDef[i_r3])("formGroup", ctx_r6.formArray.controls[i_r3]);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "New Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r3 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r7.attrValueNewFieldDef[i_r3])("formGroup", ctx_r7.formArray.controls[i_r3]);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const opt_r19 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", opt_r19.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", opt_r19.display, " ");
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_6_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r21 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r21.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r21.Display, " ");
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Date/Time Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 19);
    ɵngcc0.ɵɵtemplate(4, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_6_option_4_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r16.dateTimeAttributes);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_7_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r23 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r23.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r23.Display, " ");
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Date Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 19);
    ɵngcc0.ɵɵtemplate(4, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_7_option_4_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r17.dateAttributes);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Repeat Interval");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "input", 25);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 18);
    ɵngcc0.ɵɵelementStart(2, "label", 11);
    ɵngcc0.ɵɵtext(3, "Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 21);
    ɵngcc0.ɵɵtemplate(5, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_option_5_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_6_Template, 5, 1, "div", 14);
    ɵngcc0.ɵɵtemplate(7, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_div_7_Template, 5, 1, "div", 14);
    ɵngcc0.ɵɵelementStart(8, "div", 22);
    ɵngcc0.ɵɵelementStart(9, "label", 11);
    ɵngcc0.ɵɵtext(10, "Interval");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "input", 23);
    ɵngcc0.ɵɵelementStart(12, "label", 11);
    ɵngcc0.ɵɵtext(13, "Repeat");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(14, "dw-yesno", 24);
    ɵngcc0.ɵɵtemplate(15, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_ng_container_15_Template, 4, 0, "ng-container", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r3 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.emailElapsedTimeTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.showDateTimeAttr(i_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.showDateAttr(i_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r8.formArray.value[i_r3] == null ? null : ctx_r8.formArray.value[i_r3].attrName));
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r8.formArray.value[i_r3] == null ? null : ctx_r8.formArray.value[i_r3].elapsedTimeRepeat);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Condition");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-expression-picker-control", 27);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_15_Template_dw_expression_picker_control_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(3); return ctx_r25.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r9.contextNames)("item", ctx_r9.itemMetaData == null ? null : ctx_r9.itemMetaData.ItemName)("queryMeaning", ctx_r9.queryMetaData == null ? null : ctx_r9.queryMetaData.QueryMeaning);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r28); const i_r3 = ctx.index; const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.removeItem(i_r3); });
    ɵngcc0.ɵɵelement(5, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 10);
    ɵngcc0.ɵɵelementStart(7, "label", 11);
    ɵngcc0.ɵɵtext(8, "Event Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "select", 12);
    ɵngcc0.ɵɵtemplate(10, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_option_10_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_11_Template, 5, 1, "div", 14);
    ɵngcc0.ɵɵtemplate(12, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_12_Template, 4, 2, "div", 14);
    ɵngcc0.ɵɵtemplate(13, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_13_Template, 4, 2, "div", 14);
    ɵngcc0.ɵɵtemplate(14, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_ng_container_14_Template, 16, 5, "ng-container", 15);
    ɵngcc0.ɵɵtemplate(15, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_div_15_Template, 4, 3, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroupName", i_r3);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.emailTriggerTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showAttributeField(i_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showOldField(i_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showNewField(i_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showElpasedTimeField(i_r3));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.itemMetaData == null ? null : ctx_r1.itemMetaData.ItemName);
} }
function DwEmailTemplateTriggerConfigComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwEmailTemplateTriggerConfigComponent_div_1_ng_container_1_Template, 16, 7, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(2, "button", 4);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateTriggerConfigComponent_div_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.addItem(true); });
    ɵngcc0.ɵɵelement(3, "i", 5);
    ɵngcc0.ɵɵtext(4, " Add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formArrayName", ctx_r0.fieldName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formArray.controls);
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const emailSendTypes_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", emailSendTypes_r11.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", emailSendTypes_r11.display, " ");
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const receiverType_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", receiverType_r12.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", receiverType_r12.display, " ");
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const relation_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", relation_r13.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", relation_r13.NamingInfo.RelationshipDisplayName, " ");
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_35_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const query_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", query_r14.QueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", query_r14.QueryName, " ");
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_41_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r15.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r15.AttributeDisplay, " ");
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_47_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r16 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r16.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r16.AttributeDisplay, " ");
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_div_48_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "label", 11);
    ɵngcc0.ɵɵtext(2, "Condition");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-expression-picker-control", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_div_48_Template_dw_expression_picker_control_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(3); return ctx_r17.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r10.contextNames)("item", ctx_r10.itemMetaData == null ? null : ctx_r10.itemMetaData.ItemName)("queryMeaning", ctx_r10.queryMetaData == null ? null : ctx_r10.queryMetaData.QueryMeaning);
} }
function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r20); const i_r3 = ctx.index; const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.removeItem(i_r3); });
    ɵngcc0.ɵɵelement(5, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 10);
    ɵngcc0.ɵɵelementStart(7, "label", 11);
    ɵngcc0.ɵɵtext(8, "Address Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "select", 12);
    ɵngcc0.ɵɵtemplate(10, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_10_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelementStart(12, "label", 11);
    ɵngcc0.ɵɵtext(13, "Recipient Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "select", 14);
    ɵngcc0.ɵɵtemplate(15, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_15_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 15);
    ɵngcc0.ɵɵelementStart(17, "label", 11);
    ɵngcc0.ɵɵtext(18, "E-mail Address");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(19, "input", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 15);
    ɵngcc0.ɵɵelementStart(21, "label", 11);
    ɵngcc0.ɵɵtext(22, "Distribution List");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(23, "dw-select-lookup", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 15);
    ɵngcc0.ɵɵelementStart(25, "label", 11);
    ɵngcc0.ɵɵtext(26, "Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "select", 18);
    ɵngcc0.ɵɵtemplate(28, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_28_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 19);
    ɵngcc0.ɵɵelementStart(30, "label", 11);
    ɵngcc0.ɵɵtext(31, "Query");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "select", 20);
    ɵngcc0.ɵɵelementStart(33, "option", 21);
    ɵngcc0.ɵɵtext(34, " Default ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(35, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_35_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "div", 19);
    ɵngcc0.ɵɵelementStart(37, "label", 11);
    ɵngcc0.ɵɵtext(38, "E-mail Field");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(39, "select", 22);
    ɵngcc0.ɵɵelement(40, "option", 23);
    ɵngcc0.ɵɵtemplate(41, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_41_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "div", 15);
    ɵngcc0.ɵɵelementStart(43, "label", 11);
    ɵngcc0.ɵɵtext(44, "Item Field");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(45, "select", 22);
    ɵngcc0.ɵɵelement(46, "option", 23);
    ɵngcc0.ɵɵtemplate(47, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_option_47_Template, 2, 2, "option", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(48, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_div_48_Template, 4, 3, "div", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroupName", i_r3);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.emailSendTypes);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.emailRecipientTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.hideEmailAddress(i_r3));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.hideDistributionList(i_r3));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r1.emailDistributionListLookupId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.hideSubQuery(i_r3));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemMetaData == null ? null : ctx_r1.itemMetaData.Relations);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r1.itemQueries[item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.relationshipName] == null ? null : ctx_r1.itemQueries[item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.relationshipName].length));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemQueries[item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.relationshipMeaning]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.relationshipMeaning));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.additionalMetaData[ctx_r1.buildQueryKey(item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.relationshipMeaning, item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.prefetchQueryMeaning)] == null ? null : ctx_r1.additionalMetaData[ctx_r1.buildQueryKey(item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.relationshipMeaning, item_r2 == null ? null : item_r2.value == null ? null : item_r2.value.prefetchQueryMeaning)].Attributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.hideUserAttr(i_r3));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.userAttrs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.itemMetaData == null ? null : ctx_r1.itemMetaData.ItemName);
} }
function DwEmailTemplateRecipientConfigComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwEmailTemplateRecipientConfigComponent_div_1_ng_container_1_Template, 49, 16, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(2, "button", 4);
    ɵngcc0.ɵɵlistener("click", function DwEmailTemplateRecipientConfigComponent_div_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.addItem(); });
    ɵngcc0.ɵɵelement(3, "i", 5);
    ɵngcc0.ɵɵtext(4, " Add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formArrayName", ctx_r0.fieldName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formArray.controls);
} }
function DwFaqsComponent_div_7_div_4_dw_html_view_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-html-view", 8);
} if (rf & 2) {
    const item_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngModel", item_r3.Answer);
} }
function DwFaqsComponent_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵlistener("click", function DwFaqsComponent_div_7_div_4_Template_div_click_1_listener() { const item_r3 = ctx.$implicit; return item_r3.showItem = !item_r3.showItem; });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 6);
    ɵngcc0.ɵɵtemplate(4, DwFaqsComponent_div_7_div_4_dw_html_view_4_Template, 1, 1, "dw-html-view", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.pageConfig == null ? null : ctx_r2.pageConfig.questionClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.Question, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.pageConfig == null ? null : ctx_r2.pageConfig.answerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r3.showItem);
} }
function DwFaqsComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DwFaqsComponent_div_7_div_4_Template, 5, 4, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.pageConfig == null ? null : ctx_r0.pageConfig.categoryClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(category_r1.CategoryDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", category_r1.DwFaqItem);
} }
function DwRuleConfigComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, "Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-expression-picker-control", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r1.contextNamesFC == null ? null : ctx_r1.contextNamesFC.value)("item", ctx_r1.itemName);
} }
function DwRuleConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "label", 4);
    ɵngcc0.ɵɵtext(5, "Rule Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "input", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵelementStart(9, "label", 4);
    ɵngcc0.ɵɵtext(10, "Rule Description");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "textarea", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 2);
    ɵngcc0.ɵɵelementStart(13, "div", 6);
    ɵngcc0.ɵɵelementStart(14, "label", 4);
    ɵngcc0.ɵɵtext(15, "Context Names");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(16, "dw-context-def-multi-select", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, DwRuleConfigComponent_div_0_div_17_Template, 5, 2, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.ruleFG);
    ɵngcc0.ɵɵadvance(15);
    ɵngcc0.ɵɵproperty("itemName", ctx_r0.itemName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.itemNameLoaded);
} }
function DwMetadataGridConfigColumnsModalComponent_ng_container_0_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const view_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", view_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", view_r5.display, " ");
} }
function DwMetadataGridConfigColumnsModalComponent_ng_container_0_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "i", 17);
    ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigColumnsModalComponent_ng_container_0_ng_template_12_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const item_r6 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.removeItem(item_r6); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.getFieldDisplay(item_r6), " ");
} }
function DwMetadataGridConfigColumnsModalComponent_ng_container_0_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "button", 19);
    ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigColumnsModalComponent_ng_container_0_div_21_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const attr_r9 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.addItem(attr_r9); });
    ɵngcc0.ɵɵelement(2, "i", 20);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r9 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r9.AttributeDisplay, " ");
} }
function DwMetadataGridConfigColumnsModalComponent_ng_container_0_p_tabPanel_22_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 21);
    ɵngcc0.ɵɵelementStart(1, "p-accordion");
    ɵngcc0.ɵɵelementStart(2, "p-accordionTab", 22);
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "input", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnsModalComponent_ng_container_0_p_tabPanel_22_Template_input_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.selectedField.label = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.selectedField.label);
} }
function DwMetadataGridConfigColumnsModalComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "View");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnsModalComponent_ng_container_0_Template_select_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.changeView($event); });
    ɵngcc0.ɵɵtemplate(6, DwMetadataGridConfigColumnsModalComponent_ng_container_0_option_6_Template, 2, 2, "option", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 1);
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "h2", 5);
    ɵngcc0.ɵɵtext(10, "Columns");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "p-orderList", 6);
    ɵngcc0.ɵɵtemplate(12, DwMetadataGridConfigColumnsModalComponent_ng_container_0_ng_template_12_Template, 3, 1, "ng-template", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 1);
    ɵngcc0.ɵɵelementStart(14, "div", 8);
    ɵngcc0.ɵɵelementStart(15, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigColumnsModalComponent_ng_container_0_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.removeAll(); });
    ɵngcc0.ɵɵtext(16, "Remove All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 2);
    ɵngcc0.ɵɵelementStart(18, "p-tabView", 10);
    ɵngcc0.ɵɵelementStart(19, "p-tabPanel", 11);
    ɵngcc0.ɵɵelementStart(20, "div", 12);
    ɵngcc0.ɵɵtemplate(21, DwMetadataGridConfigColumnsModalComponent_ng_container_0_div_21_Template, 4, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(22, DwMetadataGridConfigColumnsModalComponent_ng_container_0_p_tabPanel_22_Template, 8, 1, "p-tabPanel", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedView);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.views);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("value", ctx_r0.selectedView.columnPreferences);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.availableAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedField);
} }
const _c72 = ["contextMenu1"];
function DwQueryEditorContainerComponent_div_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵlistener("contextmenu", function DwQueryEditorContainerComponent_div_0_ng_template_3_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const node_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.contextMenuClick($event, node_r3); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r3.label, " ");
} }
function DwQueryEditorContainerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "p-tree", 3);
    ɵngcc0.ɵɵlistener("selectionChange", function DwQueryEditorContainerComponent_div_0_Template_p_tree_selectionChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.selectNode($event); });
    ɵngcc0.ɵɵtemplate(3, DwQueryEditorContainerComponent_div_0_ng_template_3_Template, 2, 1, "ng-template", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelement(5, "dw-query-panel-factory", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "p-contextMenu", 7, 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", ctx_r0.editorState == null ? null : ctx_r0.editorState.queryTree)("selection", ctx_r0.editorState == null ? null : ctx_r0.editorState.selectedNode);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("node", ctx_r0.editorState == null ? null : ctx_r0.editorState.selectedNode);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("model", ctx_r0.contextMenuItems);
} }
function DwQueryPanelSettingsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Load All Lookup Displays");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.editorState.query.FieldSettings.LoadAllLookupDisplayFields = $event; })("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.updateState(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Load Custom Fields");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 4);
    ɵngcc0.ɵɵelementStart(12, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.editorState.query.FieldSettings.LoadCustomFields = $event; })("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_12_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.updateState(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 2);
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Aggregate Query");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 4);
    ɵngcc0.ɵɵelementStart(18, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.editorState.query.FieldSettings.AggregateQuery = $event; })("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_18_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.updateState(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 3);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Aggregate Query With Rollup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 4);
    ɵngcc0.ɵɵelementStart(24, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.editorState.query.FieldSettings.AggregateQueryWithRollup = $event; })("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_24_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.updateState(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 2);
    ɵngcc0.ɵɵelementStart(26, "div", 3);
    ɵngcc0.ɵɵelementStart(27, "label");
    ɵngcc0.ɵɵtext(28, "Return distinct records");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "div", 4);
    ɵngcc0.ɵɵelementStart(30, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryPanelSettingsComponent_div_2_Template_p_inputSwitch_ngModelChange_30_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.updateDistinct($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.editorState.query.FieldSettings.LoadAllLookupDisplayFields);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.editorState.query.FieldSettings.LoadCustomFields);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.editorState.query.FieldSettings.AggregateQuery);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.editorState.query.FieldSettings.AggregateQueryWithRollup);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.editorState.query.PagingInfo == null ? null : ctx_r0.editorState.query.PagingInfo.Distinct);
} }
function DwQueryPanelRootComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DwQueryPanelRootComponent_div_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.startAddRelation(); });
    ɵngcc0.ɵɵelement(2, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwQueryPanelRelationComponent_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "button", 14);
    ɵngcc0.ɵɵlistener("click", function DwQueryPanelRelationComponent_ng_container_1_div_6_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.startAddRelation(); });
    ɵngcc0.ɵɵelement(2, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwQueryPanelRelationComponent_ng_container_1_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 16);
    ɵngcc0.ɵɵelementStart(1, "button", 17);
    ɵngcc0.ɵɵlistener("click", function DwQueryPanelRelationComponent_ng_container_1_div_7_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.startChangeRelation(); });
    ɵngcc0.ɵɵelement(2, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_add_relation_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-query-editor-add-relation", 19);
    ɵngcc0.ɵɵlistener("completeAddRelation", function DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_add_relation_8_Template_dw_query_editor_add_relation_completeAddRelation_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.completeAddRelation($event); })("showAddRelationChange", function DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_add_relation_8_Template_dw_query_editor_add_relation_showAddRelationChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.addingRelation = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("itemMetaData", ctx_r4.fieldState.itemMd)("showAddRelation", ctx_r4.addingRelation);
} }
function DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_fix_relation_9_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-query-editor-fix-relation", 19);
    ɵngcc0.ɵɵlistener("completeAddRelation", function DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_fix_relation_9_Template_dw_query_editor_fix_relation_completeAddRelation_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.completeFixRelation($event); })("showAddRelationChange", function DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_fix_relation_9_Template_dw_query_editor_fix_relation_showAddRelationChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.changingRelation = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("itemMetaData", ctx_r5.parentItemMetaData)("showAddRelation", ctx_r5.changingRelation);
} }
function DwQueryPanelRelationComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "h2");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵtemplate(6, DwQueryPanelRelationComponent_ng_container_1_div_6_Template, 3, 0, "div", 4);
    ɵngcc0.ɵɵtemplate(7, DwQueryPanelRelationComponent_ng_container_1_div_7_Template, 3, 0, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_add_relation_8_Template, 1, 2, "dw-query-editor-add-relation", 6);
    ɵngcc0.ɵɵtemplate(9, DwQueryPanelRelationComponent_ng_container_1_dw_query_editor_fix_relation_9_Template, 1, 2, "dw-query-editor-fix-relation", 6);
    ɵngcc0.ɵɵelementStart(10, "p-tabView");
    ɵngcc0.ɵɵelementStart(11, "p-tabPanel", 7);
    ɵngcc0.ɵɵelementStart(12, "dw-query-editor-fields-advanced", 8);
    ɵngcc0.ɵɵlistener("fieldStateChange", function DwQueryPanelRelationComponent_ng_container_1_Template_dw_query_editor_fields_advanced_fieldStateChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.fieldStateChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "p-tabPanel", 9);
    ɵngcc0.ɵɵelementStart(14, "dw-query-editor-filters", 10);
    ɵngcc0.ɵɵlistener("filterStateChange", function DwQueryPanelRelationComponent_ng_container_1_Template_dw_query_editor_filters_filterStateChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.filterStateChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "p-tabPanel", 11);
    ɵngcc0.ɵɵelementStart(16, "dw-query-relation-settings", 12);
    ɵngcc0.ɵɵlistener("relationSettingStateChange", function DwQueryPanelRelationComponent_ng_container_1_Template_dw_query_relation_settings_relationSettingStateChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.relationSettingStateChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.fieldState == null ? null : ctx_r0.fieldState.itemMd == null ? null : ctx_r0.fieldState.itemMd.Display);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addingRelation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.addingRelation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.fieldState == null ? null : ctx_r0.fieldState.itemMd);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.parentItemMetaData);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldState", ctx_r0.fieldState);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("filterState", ctx_r0.filterState);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("relationSettingState", ctx_r0.relationSettingState)("relation", ctx_r0.relation);
} }
function DwQueryPanelRelationComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " Please fix the parent relation ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwQueryPanelRelationComponent_ng_container_2_div_2_ng_container_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 22);
    ɵngcc0.ɵɵlistener("click", function DwQueryPanelRelationComponent_ng_container_2_div_2_ng_container_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(4); return ctx_r25.startFixRelation(); });
    ɵngcc0.ɵɵtext(1, "Change relationship");
    ɵngcc0.ɵɵelementEnd();
} }
function DwQueryPanelRelationComponent_ng_container_2_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwQueryPanelRelationComponent_ng_container_2_div_2_ng_container_1_button_1_Template, 2, 0, "button", 20);
    ɵngcc0.ɵɵelementStart(2, "button", 21);
    ɵngcc0.ɵɵlistener("click", function DwQueryPanelRelationComponent_ng_container_2_div_2_ng_container_1_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.removeRelation(); });
    ɵngcc0.ɵɵtext(3, "Remove Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r22.parentItemMetaData);
} }
function DwQueryPanelRelationComponent_ng_container_2_div_2_dw_query_editor_fix_relation_2_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-query-editor-fix-relation", 19);
    ɵngcc0.ɵɵlistener("completeAddRelation", function DwQueryPanelRelationComponent_ng_container_2_div_2_dw_query_editor_fix_relation_2_Template_dw_query_editor_fix_relation_completeAddRelation_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(3); return ctx_r29.completeFixRelation($event); })("showAddRelationChange", function DwQueryPanelRelationComponent_ng_container_2_div_2_dw_query_editor_fix_relation_2_Template_dw_query_editor_fix_relation_showAddRelationChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(3); return ctx_r31.fixingRelation = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("itemMetaData", ctx_r23.parentItemMetaData)("showAddRelation", ctx_r23.fixingRelation);
} }
function DwQueryPanelRelationComponent_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwQueryPanelRelationComponent_ng_container_2_div_2_ng_container_1_Template, 4, 1, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(2, DwQueryPanelRelationComponent_ng_container_2_div_2_dw_query_editor_fix_relation_2_Template, 1, 2, "dw-query-editor-fix-relation", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r21.fixingRelation);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.parentItemMetaData);
} }
function DwQueryPanelRelationComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwQueryPanelRelationComponent_ng_container_2_div_1_Template, 2, 0, "div", 1);
    ɵngcc0.ɵɵtemplate(2, DwQueryPanelRelationComponent_ng_container_2_div_2_Template, 3, 2, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.queryNode.parentIsInvalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.queryNode.parentIsInvalid);
} }
function DwQueryPanelFactoryComponent_ng_template_0_Template(rf, ctx) { }
function DwQueryEditorFieldsComponent_div_0_div_5_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "i", 12);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorFieldsComponent_div_0_div_5_div_3_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r8); const field_r6 = ctx.$implicit; const ctx_r7 = ɵngcc0.ɵɵnextContext(3); return ctx_r7.removeField(field_r6); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.getFieldDisplay(field_r6), " ");
} }
function DwQueryEditorFieldsComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵtext(2, " No Fields added ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwQueryEditorFieldsComponent_div_0_div_5_div_3_Template, 3, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.fieldState.selectedFields.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.fieldState.selectedFields);
} }
function DwQueryEditorFieldsComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Include All Fields");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-yesno", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFieldsComponent_div_0_div_9_Template_dw_yesno_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.fieldState.includeRootItemFields = $event; })("ngModelChange", function DwQueryEditorFieldsComponent_div_0_div_9_Template_dw_yesno_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.rootItemFieldsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.fieldState.includeRootItemFields);
} }
function DwQueryEditorFieldsComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "dw-field-selection", 15);
    ɵngcc0.ɵɵlistener("attributeClick", function DwQueryEditorFieldsComponent_div_0_div_10_Template_dw_field_selection_attributeClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.addField($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attributes", ctx_r3.availableAttributes);
} }
function DwQueryEditorFieldsComponent_div_0_p_tabPanel_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 16);
    ɵngcc0.ɵɵelementStart(1, "p-accordion");
    ɵngcc0.ɵɵelementStart(2, "p-accordionTab", 17);
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "div", 18);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "input", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwQueryEditorFieldsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwQueryEditorFieldsComponent_div_0_div_5_Template, 4, 2, "div", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "p-tabView");
    ɵngcc0.ɵɵelementStart(8, "p-tabPanel", 6);
    ɵngcc0.ɵɵtemplate(9, DwQueryEditorFieldsComponent_div_0_div_9_Template, 4, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(10, DwQueryEditorFieldsComponent_div_0_div_10_Template, 2, 1, "div", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DwQueryEditorFieldsComponent_div_0_p_tabPanel_11_Template, 8, 0, "p-tabPanel", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.fieldState.includeRootItemFields);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" All ", ctx_r0.fieldState.itemMd == null ? null : ctx_r0.fieldState.itemMd.Display, " Fields ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.fieldState.includeRootItemFields);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.fieldState.allowIncludeRootItemFields);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.fieldState.includeRootItemFields);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedAttribute);
} }
function DwQueryEditorAddRelationComponent_div_0_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3 == null ? null : item_r3.NamingInfo == null ? null : item_r3.NamingInfo.RelationshipDisplayName, " ");
} }
function DwQueryEditorAddRelationComponent_div_0_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r4 == null ? null : item_r4.NamingInfo == null ? null : item_r4.NamingInfo.RelationshipDisplayName, " ");
} }
function DwQueryEditorAddRelationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "h5", 3);
    ɵngcc0.ɵɵtext(3, "Add Relation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "label", 7);
    ɵngcc0.ɵɵtext(8, "Relations");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "p-dropdown", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorAddRelationComponent_div_0_Template_p_dropdown_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectedRelation = $event; });
    ɵngcc0.ɵɵtemplate(10, DwQueryEditorAddRelationComponent_div_0_ng_template_10_Template, 1, 1, "ng-template", 9);
    ɵngcc0.ɵɵtemplate(11, DwQueryEditorAddRelationComponent_div_0_ng_template_11_Template, 1, 1, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(13, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorAddRelationComponent_div_0_Template_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.okClick(); });
    ɵngcc0.ɵɵtext(14, "Add relation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorAddRelationComponent_div_0_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.close(); });
    ɵngcc0.ɵɵtext(16, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(4, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r0.itemMetaData.Relations)("ngModel", ctx_r0.selectedRelation);
} }
function DwQueryRelationSettingsComponent_div_1_option_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
} }
function DwQueryRelationSettingsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "label", 5);
    ɵngcc0.ɵɵtext(4, "Field Name Prefix");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryRelationSettingsComponent_div_1_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.relationSettingState.fieldPrefix = $event; })("ngModelChange", function DwQueryRelationSettingsComponent_div_1_Template_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.relationStateChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 0);
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "label", 5);
    ɵngcc0.ɵɵtext(9, "Field Display Prefix");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryRelationSettingsComponent_div_1_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.relationSettingState.fieldDisplayPrefix = $event; })("ngModelChange", function DwQueryRelationSettingsComponent_div_1_Template_input_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.relationStateChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 0);
    ɵngcc0.ɵɵelementStart(12, "div", 4);
    ɵngcc0.ɵɵelementStart(13, "label", 5);
    ɵngcc0.ɵɵtext(14, "Join Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "select", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryRelationSettingsComponent_div_1_Template_select_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.relationSettingState.joinType = $event; })("ngModelChange", function DwQueryRelationSettingsComponent_div_1_Template_select_ngModelChange_15_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.relationStateChange(); });
    ɵngcc0.ɵɵtemplate(16, DwQueryRelationSettingsComponent_div_1_option_16_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.relationSettingState.fieldPrefix);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.relationSettingState.fieldDisplayPrefix);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.relationSettingState.joinType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.joinTypesList);
} }
function DwQueryRelationSettingsComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "label", 5);
    ɵngcc0.ɵɵtext(4, "Relation Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 0);
    ɵngcc0.ɵɵelementStart(8, "div", 4);
    ɵngcc0.ɵɵelementStart(9, "label", 5);
    ɵngcc0.ɵɵtext(10, "Relationship Deatils");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 12);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.relation == null ? null : ctx_r1.relation.RelationshipName, " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.relationDesc, " ");
} }
const _c73 = ".settings-panel[_ngcontent-%COMP%]{max-width:400px}";
function DwQuerySectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "dw-query-editor", 2);
    ɵngcc0.ɵɵlistener("itemChange", function DwQuerySectionComponent_div_0_Template_dw_query_editor_itemChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.handleItemChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", ctx_r0.itemName);
} }
function DwExpressionVisibilityConfigComponent_ng_container_0_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵelementStart(5, "dw-expression-picker-control", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionVisibilityConfigComponent_ng_container_0_div_7_Template_dw_expression_picker_control_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.config.expression = $event; })("ngModelChange", function DwExpressionVisibilityConfigComponent_ng_container_0_div_7_Template_dw_expression_picker_control_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.expression)("queryMeaning", ctx_r1.configContext.metaDataQueryMeaning)("contextNames", ctx_r1.configContext.contextNames)("item", ctx_r1.configContext.itemName);
} }
function DwExpressionVisibilityConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 2);
    ɵngcc0.ɵɵelementStart(6, "dw-radio-list", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionVisibilityConfigComponent_ng_container_0_Template_dw_radio_list_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.config.visiblilityType = $event; })("ngModelChange", function DwExpressionVisibilityConfigComponent_ng_container_0_Template_dw_radio_list_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwExpressionVisibilityConfigComponent_ng_container_0_div_7_Template, 6, 4, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.visiblilityType)("values", ctx_r0.visibiltyTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config.visiblilityType !== "none");
} }
function DwQueryEditorSortComponent_div_0_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r3.fullFieldName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r3.sortDisplay, " ");
} }
function DwQueryEditorSortComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Field");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorSortComponent_div_0_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const order_r1 = ctx.$implicit; return order_r1.Field.FullFieldName = $event; })("ngModelChange", function DwQueryEditorSortComponent_div_0_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.sortChanged(); });
    ɵngcc0.ɵɵtemplate(5, DwQueryEditorSortComponent_div_0_option_5_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Is Ascending");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "br");
    ɵngcc0.ɵɵelementStart(10, "p-inputSwitch", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorSortComponent_div_0_Template_p_inputSwitch_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const order_r1 = ctx.$implicit; return order_r1.IsAscending = $event; })("ngModelChange", function DwQueryEditorSortComponent_div_0_Template_p_inputSwitch_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.sortChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵelement(12, "br");
    ɵngcc0.ɵɵelementStart(13, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorSortComponent_div_0_Template_i_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r5); const order_r1 = ctx.$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.removeSort(order_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const order_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", order_r1.Field.FullFieldName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.availableFields);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", order_r1.IsAscending);
} }
function DwEventConfigComponent_ng_container_0_option_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const eventHandler_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", eventHandler_r3.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", eventHandler_r3.display, " ");
} }
function DwEventConfigComponent_ng_container_0_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, " Component Config ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-dynamic-loader", 11);
    ɵngcc0.ɵɵlistener("configure", function DwEventConfigComponent_ng_container_0_div_14_Template_dw_dynamic_loader_configure_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.setupConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("component", ctx_r2.configComponent);
} }
function DwEventConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "label", 4);
    ɵngcc0.ɵɵtext(6, " Event Triggers ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "dw-event-trigger-config", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "div", 6);
    ɵngcc0.ɵɵelementStart(10, "label", 4);
    ɵngcc0.ɵɵtext(11, " Event Handler ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "select", 7);
    ɵngcc0.ɵɵtemplate(13, DwEventConfigComponent_ng_container_0_option_13_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, DwEventConfigComponent_ng_container_0_div_14_Template, 5, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.eventConfigFormGroup);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.eventConfigFormGroup)("itemMetaData", ctx_r0.itemMetaData)("eventConfig", ctx_r0.eventConfig);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.eventHandlers);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.configComponent);
} }
function DwEventTriggerComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " No Trigger configured. Please add at least one trigger ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwEventTriggerComponent_div_1_ng_container_2_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const eventTriggerType_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", eventTriggerType_r9.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", eventTriggerType_r9.display, " ");
} }
function DwEventTriggerComponent_div_1_ng_container_2_div_11_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r11.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r11.Display, " ");
} }
function DwEventTriggerComponent_div_1_ng_container_2_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "label", 12);
    ɵngcc0.ɵɵtext(2, "Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 18);
    ɵngcc0.ɵɵtemplate(4, DwEventTriggerComponent_div_1_ng_container_2_div_11_option_4_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.itemMetaData == null ? null : ctx_r6.itemMetaData.Attributes);
} }
function DwEventTriggerComponent_div_1_ng_container_2_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "label", 12);
    ɵngcc0.ɵɵtext(2, "Old Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r7.attrValueOldFieldDef[i_r4])("formGroup", ctx_r7.formArray.controls[i_r4]);
} }
function DwEventTriggerComponent_div_1_ng_container_2_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "label", 12);
    ɵngcc0.ɵɵtext(2, "New Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r4 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r8.attrValueNewFieldDef[i_r4])("formGroup", ctx_r8.formArray.controls[i_r4]);
} }
function DwEventTriggerComponent_div_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "button", 9);
    ɵngcc0.ɵɵlistener("click", function DwEventTriggerComponent_div_1_ng_container_2_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r15); const i_r4 = ctx.index; const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.removeItem(i_r4); });
    ɵngcc0.ɵɵelement(5, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 11);
    ɵngcc0.ɵɵelementStart(7, "label", 12);
    ɵngcc0.ɵɵtext(8, "Event Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "select", 13);
    ɵngcc0.ɵɵtemplate(10, DwEventTriggerComponent_div_1_ng_container_2_option_10_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DwEventTriggerComponent_div_1_ng_container_2_div_11_Template, 5, 1, "div", 15);
    ɵngcc0.ɵɵtemplate(12, DwEventTriggerComponent_div_1_ng_container_2_div_12_Template, 4, 2, "div", 15);
    ɵngcc0.ɵɵtemplate(13, DwEventTriggerComponent_div_1_ng_container_2_div_13_Template, 4, 2, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r2.formArray.controls[i_r4]);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.availableTriggerTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showAttributeField(i_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showOldField(i_r4));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.showNewField(i_r4));
} }
function DwEventTriggerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwEventTriggerComponent_div_1_div_1_Template, 2, 0, "div", 3);
    ɵngcc0.ɵɵtemplate(2, DwEventTriggerComponent_div_1_ng_container_2_Template, 14, 5, "ng-container", 4);
    ɵngcc0.ɵɵelementStart(3, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwEventTriggerComponent_div_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.addItem(true); });
    ɵngcc0.ɵɵelement(4, "i", 6);
    ɵngcc0.ɵɵtext(5, " Add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formArrayName", ctx_r0.fieldName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.formArray.controls.length === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formArray.controls);
} }
function DwFormControlCalcFieldTesterComponent_ng_container_10_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(attr_r2.Display);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", attr_r2.AttributeName);
} }
function DwFormControlCalcFieldTesterComponent_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwFormControlCalcFieldTesterComponent_ng_container_10_div_1_Template, 5, 2, "div", 8);
    ɵngcc0.ɵɵelement(2, "hr");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.displayAttributes);
} }
function DwMultiSelectLookupComponent_p_multiSelect_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-multiSelect", 1);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiSelectLookupComponent_p_multiSelect_0_Template_p_multiSelect_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.translatedValue = $event; })("ngModelChange", function DwMultiSelectLookupComponent_p_multiSelect_0_Template_p_multiSelect_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.setTranslatedValue($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(10, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r0.finalLookupItems)("group", ctx_r0.useGroups)("optionValue", ctx_r0.valueAttrName)("ngModel", ctx_r0.translatedValue)("filter", ctx_r0.showFilter)("virtualScroll", ctx_r0.virtualScroll)("itemSize", ctx_r0.virtualScrollItems)("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c66, ctx_r0.autoExpand));
} }
function DwMetadataGridConfigColumnsComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigColumnsComponent_div_8_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const customColumnDef_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.addCustomColumn(customColumnDef_r1); });
    ɵngcc0.ɵɵelement(2, "i", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const customColumnDef_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", customColumnDef_r1.display, " ");
} }
function DwRouteBaseConfigComponent_div_0_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r5.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.name, " ");
} }
function DwRouteBaseConfigComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Group Display");
    ɵngcc0.ɵɵelement(4, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwRouteBaseConfigComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3, "Component Config");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr");
    ɵngcc0.ɵɵelementStart(5, "dw-ui-child-config-host", 16);
    ɵngcc0.ɵɵlistener("configChange", function DwRouteBaseConfigComponent_div_0_div_18_Template_dw_ui_child_config_host_configChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.componentConfigFC.value = $event; })("configChange", function DwRouteBaseConfigComponent_div_0_div_18_Template_dw_ui_child_config_host_configChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.updateComponentConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("component", ctx_r3.componentOverride.configComponent)("config", ctx_r3.componentConfigFC.value);
} }
function DwRouteBaseConfigComponent_div_0_option_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r9.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9.name, " ");
} }
function DwRouteBaseConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Component Page Override ");
    ɵngcc0.ɵɵelement(5, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 5);
    ɵngcc0.ɵɵelementStart(7, "option", 6);
    ɵngcc0.ɵɵtext(8, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwRouteBaseConfigComponent_div_0_option_9_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 2);
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Include In Group ");
    ɵngcc0.ɵɵelement(14, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 10);
    ɵngcc0.ɵɵelement(16, "p-inputSwitch", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, DwRouteBaseConfigComponent_div_0_div_17_Template, 6, 0, "div", 12);
    ɵngcc0.ɵɵtemplate(18, DwRouteBaseConfigComponent_div_0_div_18_Template, 6, 2, "div", 12);
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 3);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Menu Component Override 2 ");
    ɵngcc0.ɵɵelement(23, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "select", 14);
    ɵngcc0.ɵɵelementStart(25, "option", 6);
    ɵngcc0.ɵɵtext(26, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(27, DwRouteBaseConfigComponent_div_0_option_27_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.components);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.includeInGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.componentOverride == null ? null : ctx_r0.componentOverride.configComponent);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.menuComponents);
} }
function DwListRouteConfigComponent_div_0_div_12_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r7.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r7.name, " ");
} }
function DwListRouteConfigComponent_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, "Custom Component ");
    ɵngcc0.ɵɵelement(4, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 22);
    ɵngcc0.ɵɵelementStart(6, "option", 19);
    ɵngcc0.ɵɵtext(7, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwListRouteConfigComponent_div_0_div_12_option_8_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.components);
} }
function DwListRouteConfigComponent_div_0_div_25_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r9.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9.name, " ");
} }
function DwListRouteConfigComponent_div_0_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, "Side Menu Component ");
    ɵngcc0.ɵɵelement(4, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 24);
    ɵngcc0.ɵɵelementStart(6, "option", 19);
    ɵngcc0.ɵɵtext(7, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwListRouteConfigComponent_div_0_div_25_option_8_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.sideMenuComponents);
} }
function DwListRouteConfigComponent_div_0_div_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Group Display ");
    ɵngcc0.ɵɵelement(4, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwListRouteConfigComponent_div_0_div_34_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Component Config");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-ui-child-config-host", 26);
    ɵngcc0.ɵɵlistener("configChange", function DwListRouteConfigComponent_div_0_div_34_Template_dw_ui_child_config_host_configChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.componentConfigFC.value = $event; })("configChange", function DwListRouteConfigComponent_div_0_div_34_Template_dw_ui_child_config_host_configChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.updateComponentConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("component", ctx_r4.componentOverride.configComponent)("config", ctx_r4.componentConfigFC.value);
} }
function DwListRouteConfigComponent_div_0_option_43_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r13.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r13.name, " ");
} }
function DwListRouteConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Component Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 5);
    ɵngcc0.ɵɵelementStart(6, "option", 6);
    ɵngcc0.ɵɵtext(7, "Grid");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "option", 7);
    ɵngcc0.ɵɵtext(9, "List");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "option", 8);
    ɵngcc0.ɵɵtext(11, "Custom");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, DwListRouteConfigComponent_div_0_div_12_Template, 9, 2, "div", 9);
    ɵngcc0.ɵɵelementStart(13, "div", 2);
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵelementStart(15, "label", 4);
    ɵngcc0.ɵɵtext(16, "Config Key");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "input", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 2);
    ɵngcc0.ɵɵelementStart(19, "div", 11);
    ɵngcc0.ɵɵelementStart(20, "label");
    ɵngcc0.ɵɵtext(21, "Replace Side Menu ");
    ɵngcc0.ɵɵelement(22, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 13);
    ɵngcc0.ɵɵelement(24, "p-inputSwitch", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(25, DwListRouteConfigComponent_div_0_div_25_Template, 9, 2, "div", 9);
    ɵngcc0.ɵɵelementStart(26, "div", 2);
    ɵngcc0.ɵɵelementStart(27, "div", 11);
    ɵngcc0.ɵɵelementStart(28, "label");
    ɵngcc0.ɵɵtext(29, "Include In Group ");
    ɵngcc0.ɵɵelement(30, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 13);
    ɵngcc0.ɵɵelement(32, "p-inputSwitch", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(33, DwListRouteConfigComponent_div_0_div_33_Template, 6, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(34, DwListRouteConfigComponent_div_0_div_34_Template, 5, 2, "div", 9);
    ɵngcc0.ɵɵelementStart(35, "div", 2);
    ɵngcc0.ɵɵelementStart(36, "div", 3);
    ɵngcc0.ɵɵelementStart(37, "label");
    ɵngcc0.ɵɵtext(38, "Menu Component Override 4 ");
    ɵngcc0.ɵɵelement(39, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "select", 18);
    ɵngcc0.ɵɵelementStart(41, "option", 19);
    ɵngcc0.ɵɵtext(42, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(43, DwListRouteConfigComponent_div_0_option_43_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.listRouteSubType.value === "custom");
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.replaceSideMenu);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.includeInGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.componentOverride == null ? null : ctx_r0.componentOverride.configComponent);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.menuComponents);
} }
function DwMenuRouteConfigComponent_div_0_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r8.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r8.name, " ");
} }
function DwMenuRouteConfigComponent_div_0_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Hide Back Button ");
    ɵngcc0.ɵɵelement(4, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 10);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMenuRouteConfigComponent_div_0_div_18_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r10.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.name, " ");
} }
function DwMenuRouteConfigComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Side Menu Component ");
    ɵngcc0.ɵɵelement(4, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 24);
    ɵngcc0.ɵɵelementStart(6, "option", 6);
    ɵngcc0.ɵɵtext(7, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwMenuRouteConfigComponent_div_0_div_18_option_8_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.sideMenuComponents);
} }
function DwMenuRouteConfigComponent_div_0_div_40_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Group Display ");
    ɵngcc0.ɵɵelement(4, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMenuRouteConfigComponent_div_0_div_41_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Show As Group ");
    ɵngcc0.ɵɵelement(4, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 10);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMenuRouteConfigComponent_div_0_div_42_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr");
    ɵngcc0.ɵɵelementStart(5, "dw-dynamic-loader", 28);
    ɵngcc0.ɵɵlistener("configure", function DwMenuRouteConfigComponent_div_0_div_42_Template_dw_dynamic_loader_configure_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.configureChildConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r6.componentOverride.name, " Config");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("component", ctx_r6.componentOverride.configComponent);
} }
function DwMenuRouteConfigComponent_div_0_option_51_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r13.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r13.name, " ");
} }
function DwMenuRouteConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Component Override ");
    ɵngcc0.ɵɵelement(5, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 5);
    ɵngcc0.ɵɵelementStart(7, "option", 6);
    ɵngcc0.ɵɵtext(8, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwMenuRouteConfigComponent_div_0_option_9_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 2);
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Replace Side Menu ");
    ɵngcc0.ɵɵelement(14, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 10);
    ɵngcc0.ɵɵelement(16, "p-inputSwitch", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(17, DwMenuRouteConfigComponent_div_0_div_17_Template, 7, 0, "div", 12);
    ɵngcc0.ɵɵtemplate(18, DwMenuRouteConfigComponent_div_0_div_18_Template, 9, 2, "div", 12);
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 8);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Hide Children on Menu Page ");
    ɵngcc0.ɵɵelement(23, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 10);
    ɵngcc0.ɵɵelement(25, "p-inputSwitch", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 2);
    ɵngcc0.ɵɵelementStart(27, "div", 8);
    ɵngcc0.ɵɵelementStart(28, "label");
    ɵngcc0.ɵɵtext(29, "Auto Navigate to First Child ");
    ɵngcc0.ɵɵelement(30, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 10);
    ɵngcc0.ɵɵelement(32, "p-inputSwitch", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "div", 2);
    ɵngcc0.ɵɵelementStart(34, "div", 8);
    ɵngcc0.ɵɵelementStart(35, "label");
    ɵngcc0.ɵɵtext(36, "Include In Group ");
    ɵngcc0.ɵɵelement(37, "i", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "div", 10);
    ɵngcc0.ɵɵelement(39, "p-inputSwitch", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(40, DwMenuRouteConfigComponent_div_0_div_40_Template, 6, 0, "div", 12);
    ɵngcc0.ɵɵtemplate(41, DwMenuRouteConfigComponent_div_0_div_41_Template, 7, 0, "div", 12);
    ɵngcc0.ɵɵtemplate(42, DwMenuRouteConfigComponent_div_0_div_42_Template, 6, 2, "div", 12);
    ɵngcc0.ɵɵelementStart(43, "div", 2);
    ɵngcc0.ɵɵelementStart(44, "div", 3);
    ɵngcc0.ɵɵelementStart(45, "label");
    ɵngcc0.ɵɵtext(46, "Menu Component Override 5 ");
    ɵngcc0.ɵɵelement(47, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(48, "select", 20);
    ɵngcc0.ɵɵelementStart(49, "option", 6);
    ɵngcc0.ɵɵtext(50, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(51, DwMenuRouteConfigComponent_div_0_option_51_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.components);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.replaceSideMenu);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.replaceSideMenu);
    ɵngcc0.ɵɵadvance(22);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.includeInGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.includeInGroup));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.componentOverride == null ? null : ctx_r0.componentOverride.configComponent);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.menuComponents);
} }
function DwComponentRouteConfigComponent_div_0_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r4.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r4.name, " ");
} }
function DwComponentRouteConfigComponent_div_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr");
    ɵngcc0.ɵɵelementStart(5, "dw-ui-child-config-host", 12);
    ɵngcc0.ɵɵlistener("configChange", function DwComponentRouteConfigComponent_div_0_div_10_Template_dw_ui_child_config_host_configChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.componentConfigFC.value = $event; })("configChange", function DwComponentRouteConfigComponent_div_0_div_10_Template_dw_ui_child_config_host_configChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.updateComponentConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r2.componentOverride.name, " Config");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("component", ctx_r2.componentOverride.configComponent)("config", ctx_r2.componentConfigFC.value);
} }
function DwComponentRouteConfigComponent_div_0_option_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r8.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r8.name, " ");
} }
function DwComponentRouteConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Component ");
    ɵngcc0.ɵɵelement(5, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 6);
    ɵngcc0.ɵɵelementStart(7, "option", 7);
    ɵngcc0.ɵɵtext(8, "Select a Component");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwComponentRouteConfigComponent_div_0_option_9_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, DwComponentRouteConfigComponent_div_0_div_10_Template, 6, 3, "div", 9);
    ɵngcc0.ɵɵelementStart(11, "div", 2);
    ɵngcc0.ɵɵelementStart(12, "div", 3);
    ɵngcc0.ɵɵelementStart(13, "label");
    ɵngcc0.ɵɵtext(14, "Menu Component Override 6 ");
    ɵngcc0.ɵɵelement(15, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "select", 11);
    ɵngcc0.ɵɵelementStart(17, "option", 7);
    ɵngcc0.ɵɵtext(18, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(19, DwComponentRouteConfigComponent_div_0_option_19_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.components);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.componentOverride == null ? null : ctx_r0.componentOverride.configComponent);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.menuComponents);
} }
function DwContentConfigComponentComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r1.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r1.name, " ");
} }
function DwActionRouteConfigComponent_div_0_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const actionItem_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", actionItem_r3.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", actionItem_r3.display, " ");
} }
function DwActionRouteConfigComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "dw-dynamic-loader", 9);
    ɵngcc0.ɵɵlistener("configure", function DwActionRouteConfigComponent_div_0_div_9_Template_dw_dynamic_loader_configure_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.configureActionConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("component", ctx_r2.currentActionItem == null ? null : ctx_r2.currentActionItem.configComponent);
} }
function DwActionRouteConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Action");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 5);
    ɵngcc0.ɵɵelementStart(6, "option", 6);
    ɵngcc0.ɵɵtext(7, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwActionRouteConfigComponent_div_0_option_8_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwActionRouteConfigComponent_div_0_div_9_Template, 3, 1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.actionItems);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentActionItem == null ? null : ctx_r0.currentActionItem.configComponent);
} }
function DwRouteActionExternalLinkConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "External Url with Query string ");
    ɵngcc0.ɵɵelement(5, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "dw-template-config-control", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Open in Same Window");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 7);
    ɵngcc0.ɵɵelement(12, "p-inputSwitch", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 9);
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "New Window Target");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "input", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r0.configContext == null ? null : ctx_r0.configContext.contextNames)("item", ctx_r0.configContext == null ? null : ctx_r0.configContext.itemName)("queryMeaning", ctx_r0.configContext == null ? null : ctx_r0.configContext.metaDataQueryMeaning)("showDisplayAttributes", true)("excludeDataPrefix", true);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.openInSameWindow);
} }
function DwItemRouteConfigComponent_div_0_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r7.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r7.name, " ");
} }
function DwItemRouteConfigComponent_div_0_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const formType_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", formType_r8.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", formType_r8.display, " ");
} }
function DwItemRouteConfigComponent_div_0_ng_container_28_option_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r10.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.name, " ");
} }
function DwItemRouteConfigComponent_div_0_ng_container_28_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Hide Back Button ");
    ɵngcc0.ɵɵelement(5, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 13);
    ɵngcc0.ɵɵelement(7, "p-inputSwitch", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "div", 3);
    ɵngcc0.ɵɵelementStart(10, "label", 4);
    ɵngcc0.ɵɵtext(11, "Side Menu Component ");
    ɵngcc0.ɵɵelement(12, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "select", 24);
    ɵngcc0.ɵɵelementStart(14, "option", 7);
    ɵngcc0.ɵɵtext(15, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, DwItemRouteConfigComponent_div_0_ng_container_28_option_16_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(14);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.sideMenuComponents);
} }
function DwItemRouteConfigComponent_div_0_div_36_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Group Display ");
    ɵngcc0.ɵɵelement(4, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwItemRouteConfigComponent_div_0_div_37_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "h2");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "hr");
    ɵngcc0.ɵɵelementStart(5, "dw-ui-child-config-host", 26);
    ɵngcc0.ɵɵlistener("configChange", function DwItemRouteConfigComponent_div_0_div_37_Template_dw_ui_child_config_host_configChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.componentConfigFC.value = $event; })("configChange", function DwItemRouteConfigComponent_div_0_div_37_Template_dw_ui_child_config_host_configChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.updateComponentConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r5.componentOverride.name, " Config");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("component", ctx_r5.componentOverride.configComponent)("config", ctx_r5.componentConfigFC.value);
} }
function DwItemRouteConfigComponent_div_0_option_46_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r14.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r14.name, " ");
} }
function DwItemRouteConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Component Override ");
    ɵngcc0.ɵɵelement(5, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "select", 6);
    ɵngcc0.ɵɵelementStart(7, "option", 7);
    ɵngcc0.ɵɵtext(8, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwItemRouteConfigComponent_div_0_option_9_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 2);
    ɵngcc0.ɵɵelementStart(11, "div", 3);
    ɵngcc0.ɵɵelementStart(12, "label", 4);
    ɵngcc0.ɵɵtext(13, "Form Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "select", 9);
    ɵngcc0.ɵɵtemplate(15, DwItemRouteConfigComponent_div_0_option_15_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 2);
    ɵngcc0.ɵɵelementStart(17, "div", 3);
    ɵngcc0.ɵɵelementStart(18, "label", 4);
    ɵngcc0.ɵɵtext(19, "Config Key");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(20, "input", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 2);
    ɵngcc0.ɵɵelementStart(22, "div", 11);
    ɵngcc0.ɵɵelementStart(23, "label");
    ɵngcc0.ɵɵtext(24, "Replace Side Menu ");
    ɵngcc0.ɵɵelement(25, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 13);
    ɵngcc0.ɵɵelement(27, "p-inputSwitch", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(28, DwItemRouteConfigComponent_div_0_ng_container_28_Template, 17, 2, "ng-container", 15);
    ɵngcc0.ɵɵelementStart(29, "div", 2);
    ɵngcc0.ɵɵelementStart(30, "div", 11);
    ɵngcc0.ɵɵelementStart(31, "label");
    ɵngcc0.ɵɵtext(32, "Include In Group ");
    ɵngcc0.ɵɵelement(33, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(34, "div", 13);
    ɵngcc0.ɵɵelement(35, "p-inputSwitch", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(36, DwItemRouteConfigComponent_div_0_div_36_Template, 6, 0, "div", 18);
    ɵngcc0.ɵɵtemplate(37, DwItemRouteConfigComponent_div_0_div_37_Template, 6, 3, "div", 18);
    ɵngcc0.ɵɵelementStart(38, "div", 2);
    ɵngcc0.ɵɵelementStart(39, "div", 3);
    ɵngcc0.ɵɵelementStart(40, "label");
    ɵngcc0.ɵɵtext(41, "Menu Component Override 3 ");
    ɵngcc0.ɵɵelement(42, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "select", 20);
    ɵngcc0.ɵɵelementStart(44, "option", 7);
    ɵngcc0.ɵɵtext(45, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(46, DwItemRouteConfigComponent_div_0_option_46_Template, 2, 2, "option", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.components);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.formTypes);
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.replaceSideMenu);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.routeConfigFG == null ? null : ctx_r0.routeConfigFG.value == null ? null : ctx_r0.routeConfigFG.value.includeInGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.componentOverride == null ? null : ctx_r0.componentOverride.configComponent);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.menuComponents);
} }
function DwMetadataGridActionsRowConfigComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Keyboard Modifiers");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵelementStart(6, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_div_7_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.config.rowClickOptions.ctrlKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, " Control");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵelementStart(9, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_div_7_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.config.rowClickOptions.altKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, " Alt");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵelementStart(12, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_div_7_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.config.rowClickOptions.shiftKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, " Shift");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.rowClickOptions.ctrlKey);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.rowClickOptions.altKey);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.rowClickOptions.shiftKey);
} }
function DwMetadataGridActionsRowConfigComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Keyboard Modifiers");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "label", 7);
    ɵngcc0.ɵɵelementStart(6, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_div_14_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.config.rowDoubleClickOptions.ctrlKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, " Control");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "label", 7);
    ɵngcc0.ɵɵelementStart(9, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_div_14_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.config.rowDoubleClickOptions.altKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, " Alt");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "label", 7);
    ɵngcc0.ɵɵelementStart(12, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_div_14_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.config.rowDoubleClickOptions.shiftKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(13, " Shift");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.rowDoubleClickOptions.ctrlKey);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.rowDoubleClickOptions.altKey);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.rowDoubleClickOptions.shiftKey);
} }
function DwGridEditConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Open in New Window");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "New Window Target");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "input", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 2);
    ɵngcc0.ɵɵelementStart(13, "div", 3);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Hide when user can't update ");
    ɵngcc0.ɵɵelement(16, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 4);
    ɵngcc0.ɵɵelement(18, "p-inputSwitch", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.openInNewWindow));
} }
function DwGridActionNavConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Open in New Window");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "New Window Target");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "input", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.openInNewWindow));
} }
function DwGridSetValueActionConfigComponent_div_0_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r2.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r2.Display, " ");
} }
function DwGridSetValueActionConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Attribute To Update");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 5);
    ɵngcc0.ɵɵtemplate(6, DwGridSetValueActionConfigComponent_div_0_option_6_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Refresh Full Grid");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵelement(12, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.attributes);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_option_37_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r12.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r12.display, " ");
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_div_38_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Action");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_38_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.columnPreference.useAction = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_38_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.columnPreference.useAction);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Flex");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_7_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.columnPreference.flex = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_7_Template_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r16.columnPreference.flex);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Min Width");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "input", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_8_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(3); return ctx_r21.columnPreference.minWidth = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_8_Template_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r17.columnPreference.minWidth);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Flex");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_Template_p_inputSwitch_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.columnPreference.useFlex = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_Template_p_inputSwitch_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_7_Template, 6, 1, "div", 15);
    ɵngcc0.ɵɵtemplate(8, DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_div_8_Template, 6, 1, "div", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.columnPreference.useFlex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.columnPreference.useFlex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.columnPreference.useFlex);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_div_41_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Width ");
    ɵngcc0.ɵɵelement(4, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵelementStart(6, "input", 28);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_41_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.columnPreference.width = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_41_Template_input_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.columnPreference.width)("placeholder", 200);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_div_43_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Sorting");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-radio-list", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_43_Template_dw_radio_list_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(2); return ctx_r30.columnPreference.sort = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("values", ctx_r5.sortDirections)("ngModel", ctx_r5.columnPreference.sort);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_div_44_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Sort Order ");
    ɵngcc0.ɵɵelement(4, "i", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_44_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(2); return ctx_r32.columnPreference.sortOrder = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_44_Template_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.columnPreference.sortOrder);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_div_51_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Alternative Sort Field");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_51_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ctx_r35.columnPreference.useAltSortField = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_51_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r36); const ctx_r37 = ɵngcc0.ɵɵnextContext(2); return ctx_r37.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.columnPreference.useAltSortField);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_div_52_Template(rf, ctx) { if (rf & 1) {
    const _r39 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Alternative Sort Field");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p-dropdown", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_52_Template_p_dropdown_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r38 = ɵngcc0.ɵɵnextContext(2); return ctx_r38.columnPreference.Lo = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_div_52_Template_p_dropdown_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r39); const ctx_r40 = ɵngcc0.ɵɵnextContext(2); return ctx_r40.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(5, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r8.allAttributes)("ngModel", ctx_r8.columnPreference.Lo)("showClear", true);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_53_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 32);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Disable Editing ");
    ɵngcc0.ɵɵelement(5, "i", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵelementStart(7, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_53_Template_p_inputSwitch_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r41 = ɵngcc0.ɵɵnextContext(2); return ctx_r41.columnPreference.inlineEditDisabled = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_53_Template_p_inputSwitch_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r43 = ɵngcc0.ɵɵnextContext(2); return ctx_r43.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.columnPreference.inlineEditDisabled);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_58_Template(rf, ctx) { if (rf & 1) {
    const _r45 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 34);
    ɵngcc0.ɵɵelementStart(1, "dw-ui-child-config-host", 35);
    ɵngcc0.ɵɵlistener("configChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_58_Template_dw_ui_child_config_host_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r44 = ɵngcc0.ɵɵnextContext(2); return ctx_r44.columnPreference.columnRendererConfig = $event; })("configChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_58_Template_dw_ui_child_config_host_configChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r45); const ctx_r46 = ɵngcc0.ɵɵnextContext(2); return ctx_r46.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r10.currentColumnRendererRegistration == null ? null : ctx_r10.currentColumnRendererRegistration.configComponent)("config", ctx_r10.columnPreference.columnRendererConfig)("configContext", ctx_r10.configContext);
} }
function DwMetadataGridConfigColumnComponent_p_accordion_0_dw_action_config_59_Template(rf, ctx) { if (rf & 1) {
    const _r48 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-action-config", 36);
    ɵngcc0.ɵɵlistener("actionPreferenceChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_dw_action_config_59_Template_dw_action_config_actionPreferenceChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r48); const ctx_r47 = ɵngcc0.ɵɵnextContext(2); return ctx_r47.onActionPreferenceChange($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("actionPreference", ctx_r11.columnPreference.actionPreference)("actions", ctx_r11.actions)("showButtonConfig", ctx_r11.currentColumnRendererRegistration == null ? null : ctx_r11.currentColumnRendererRegistration.showActionButtonConfig)("configContext", ctx_r11.configContext);
} }
const _c74 = function () { return ["data"]; };
const _c75 = function () { return ["Data Classes"]; };
function DwMetadataGridConfigColumnComponent_p_accordion_0_Template(rf, ctx) { if (rf & 1) {
    const _r50 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵelementStart(1, "p-accordionTab", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r49 = ɵngcc0.ɵɵnextContext(); return ctx_r49.columnPreference.label = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_input_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r51 = ɵngcc0.ɵɵnextContext(); return ctx_r51.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 5);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Wrap Text ");
    ɵngcc0.ɵɵelement(11, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 7);
    ɵngcc0.ɵɵelementStart(13, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_p_inputSwitch_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r52 = ɵngcc0.ɵɵnextContext(); return ctx_r52.columnPreference.wrapText = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_p_inputSwitch_ngModelChange_13_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r53 = ɵngcc0.ɵɵnextContext(); return ctx_r53.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 2);
    ɵngcc0.ɵɵelementStart(15, "div", 3);
    ɵngcc0.ɵɵelementStart(16, "label");
    ɵngcc0.ɵɵtext(17, "Pinned");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "select", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_select_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r54 = ɵngcc0.ɵɵnextContext(); return ctx_r54.columnPreference.pinned = $event; });
    ɵngcc0.ɵɵelementStart(19, "option", 10);
    ɵngcc0.ɵɵtext(20, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "option", 11);
    ɵngcc0.ɵɵtext(22, "Left");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "option", 12);
    ɵngcc0.ɵɵtext(24, "Right");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 2);
    ɵngcc0.ɵɵelementStart(26, "div", 5);
    ɵngcc0.ɵɵelementStart(27, "label");
    ɵngcc0.ɵɵtext(28, "Hide ");
    ɵngcc0.ɵɵelement(29, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "div", 7);
    ɵngcc0.ɵɵelementStart(31, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_p_inputSwitch_ngModelChange_31_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r55 = ɵngcc0.ɵɵnextContext(); return ctx_r55.columnPreference.hide = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_p_inputSwitch_ngModelChange_31_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r56 = ɵngcc0.ɵɵnextContext(); return ctx_r56.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "div", 2);
    ɵngcc0.ɵɵelementStart(33, "div", 3);
    ɵngcc0.ɵɵelementStart(34, "label");
    ɵngcc0.ɵɵtext(35, "Column Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "select", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_select_ngModelChange_36_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r57 = ɵngcc0.ɵɵnextContext(); return ctx_r57.columnPreference.columnRendererKey = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_select_ngModelChange_36_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r58 = ɵngcc0.ɵɵnextContext(); return ctx_r58.onColumnRenderTypeChange($event); });
    ɵngcc0.ɵɵtemplate(37, DwMetadataGridConfigColumnComponent_p_accordion_0_option_37_Template, 2, 2, "option", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(38, DwMetadataGridConfigColumnComponent_p_accordion_0_div_38_Template, 6, 1, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(39, "p-accordionTab", 16);
    ɵngcc0.ɵɵtemplate(40, DwMetadataGridConfigColumnComponent_p_accordion_0_ng_container_40_Template, 9, 3, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(41, DwMetadataGridConfigColumnComponent_p_accordion_0_div_41_Template, 7, 2, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "p-accordionTab", 17);
    ɵngcc0.ɵɵtemplate(43, DwMetadataGridConfigColumnComponent_p_accordion_0_div_43_Template, 5, 2, "div", 15);
    ɵngcc0.ɵɵtemplate(44, DwMetadataGridConfigColumnComponent_p_accordion_0_div_44_Template, 6, 1, "div", 15);
    ɵngcc0.ɵɵelementStart(45, "div", 2);
    ɵngcc0.ɵɵelementStart(46, "div", 5);
    ɵngcc0.ɵɵelementStart(47, "label");
    ɵngcc0.ɵɵtext(48, "Disable Sorting");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(49, "div", 7);
    ɵngcc0.ɵɵelementStart(50, "p-inputSwitch", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_p_inputSwitch_ngModelChange_50_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r59 = ɵngcc0.ɵɵnextContext(); return ctx_r59.columnPreference.disabledSort = $event; })("ngModelChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_p_inputSwitch_ngModelChange_50_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r60 = ɵngcc0.ɵɵnextContext(); return ctx_r60.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(51, DwMetadataGridConfigColumnComponent_p_accordion_0_div_51_Template, 6, 1, "div", 15);
    ɵngcc0.ɵɵtemplate(52, DwMetadataGridConfigColumnComponent_p_accordion_0_div_52_Template, 5, 6, "div", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(53, DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_53_Template, 8, 1, "p-accordionTab", 18);
    ɵngcc0.ɵɵelementStart(54, "p-accordionTab", 19);
    ɵngcc0.ɵɵelementStart(55, "dw-security-check-config", 20);
    ɵngcc0.ɵɵlistener("configChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_dw_security_check_config_configChange_55_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r61 = ɵngcc0.ɵɵnextContext(); return ctx_r61.columnPreference.securityConfig = $event; })("configChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_dw_security_check_config_configChange_55_listener() { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r62 = ɵngcc0.ɵɵnextContext(); return ctx_r62.onColumnsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(56, "p-accordionTab", 21);
    ɵngcc0.ɵɵelementStart(57, "dw-conditional-field-classes", 22);
    ɵngcc0.ɵɵlistener("conditionalClassesChange", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_dw_conditional_field_classes_conditionalClassesChange_57_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r63 = ɵngcc0.ɵɵnextContext(); return ctx_r63.columnPreference.conditionalFieldClasses = $event; })("conditionalClassesChange2", function DwMetadataGridConfigColumnComponent_p_accordion_0_Template_dw_conditional_field_classes_conditionalClassesChange2_57_listener($event) { ɵngcc0.ɵɵrestoreView(_r50); const ctx_r64 = ɵngcc0.ɵɵnextContext(); return ctx_r64.setConditionalClasses($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(58, DwMetadataGridConfigColumnComponent_p_accordion_0_p_accordionTab_58_Template, 2, 3, "p-accordionTab", 23);
    ɵngcc0.ɵɵtemplate(59, DwMetadataGridConfigColumnComponent_p_accordion_0_dw_action_config_59_Template, 1, 4, "dw-action-config", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.columnPreference.label)("placeholder", ctx_r0.attribute == null ? null : ctx_r0.attribute.AttributeDisplay);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.columnPreference.wrapText);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.columnPreference.pinned);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.columnPreference.hide);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.columnPreference.columnRendererKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.columnRendererRegistrations);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentColumnRendererRegistration.allowAction);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.useColumnFlex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.columnPreference.useFlex || !ctx_r0.useColumnFlex);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.columnPreference.disabledSort);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.columnPreference.disabledSort && ctx_r0.columnPreference.sort);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.columnPreference.disabledSort);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.columnPreference.disabledSort);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.columnPreference.useAltSortField && !ctx_r0.columnPreference.disabledSort);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.inlineEditEnabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", ctx_r0.columnPreference.securityConfig)("configContext", ctx_r0.configContext);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("conditionalClasses", ctx_r0.columnPreference.conditionalFieldClasses)("itemName", ctx_r0.configContext.itemName)("contextNames", ctx_r0.configContext.contextNames)("queryMeaning", ctx_r0.configContext.metaDataQueryMeaning)("classNames", ɵngcc0.ɵɵpureFunction0(28, _c74))("classLabels", ɵngcc0.ɵɵpureFunction0(29, _c75));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentColumnRendererRegistration == null ? null : ctx_r0.currentColumnRendererRegistration.configComponent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.columnPreference == null ? null : ctx_r0.columnPreference.useAction);
} }
function DwGridMultiEditModalComponent_dw_message_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-message", 9);
    ɵngcc0.ɵɵlistener("messageChange", function DwGridMultiEditModalComponent_dw_message_7_Template_dw_message_messageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.message = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r0.message);
} }
function DwGridMultiEditModalComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelement(2, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attrToUpdate_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("fieldDef", attrToUpdate_r4.fieldConfig)("formGroup", ctx_r1.formGroup)("submitted", ctx_r1.submitted);
} }
function DwGridMultiEditConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Include All Attributes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 6);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelement(9, "p-multiSelect", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 2);
    ɵngcc0.ɵɵelementStart(11, "div", 3);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Refresh Full Grid");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 4);
    ɵngcc0.ɵɵelement(15, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.includeAllAttributes);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("options", ctx_r0.primeAttributes)("filter", true);
} }
function DwGridToggleValueActionConfigComponent_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r1.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r1.Display, " ");
} }
function DwFormButtonsConfigComponent_p_tabPanel_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 11);
    ɵngcc0.ɵɵelementStart(1, "dw-action-group-modes-config", 12);
    ɵngcc0.ɵɵlistener("actionPreferencesByModeChange", function DwFormButtonsConfigComponent_p_tabPanel_2_Template_dw_action_group_modes_config_actionPreferencesByModeChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.section.actionPreferencesByMode = $event; })("actionPreferenceByModeChange", function DwFormButtonsConfigComponent_p_tabPanel_2_Template_dw_action_group_modes_config_actionPreferenceByModeChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("configContext", ctx_r0.configContext)("actionModes", ctx_r0.actionModes)("actionPreferencesByMode", ctx_r0.section.actionPreferencesByMode);
} }
function DwFormButtonsConfigComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Show Form Modes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-yesno", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormButtonsConfigComponent_div_9_Template_dw_yesno_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.section.useFormModes = $event; })("ngModelChange", function DwFormButtonsConfigComponent_div_9_Template_dw_yesno_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.section.useFormModes);
} }
function DwFormButtonsConfigComponent_option_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r9.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r9.display, " ");
} }
function DwFormSaveConfigComponent_div_0_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Customize Redirect");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormSaveConfigComponent_div_0_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Redirect Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-select-route", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormSaveConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Action Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Require Validation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 6);
    ɵngcc0.ɵɵelement(11, "p-inputSwitch", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 2);
    ɵngcc0.ɵɵelementStart(13, "div", 5);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Save and Edit ");
    ɵngcc0.ɵɵelement(16, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 6);
    ɵngcc0.ɵɵelement(18, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 5);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Redirect After");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 6);
    ɵngcc0.ɵɵelement(24, "p-inputSwitch", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(25, DwFormSaveConfigComponent_div_0_div_25_Template, 6, 0, "div", 11);
    ɵngcc0.ɵɵtemplate(26, DwFormSaveConfigComponent_div_0_div_26_Template, 5, 0, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(25);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.redirectAfter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.customizeRedirect);
} }
function DwFormPrintConfigComponent_div_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 5);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Render Multiple Pages");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Export PDF File Name ");
    ɵngcc0.ɵɵelement(11, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(12, "input", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 2);
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Render Wait Time (ms) ");
    ɵngcc0.ɵɵelement(17, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(18, "input", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 5);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Reload Print Data ");
    ɵngcc0.ɵɵelement(23, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "div", 6);
    ɵngcc0.ɵɵelement(25, "p-inputSwitch", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "div", 2);
    ɵngcc0.ɵɵelementStart(27, "div", 3);
    ɵngcc0.ɵɵelementStart(28, "label");
    ɵngcc0.ɵɵtext(29, "Print Config Key Override ");
    ɵngcc0.ɵɵelement(30, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(31, "input", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwFormPrintConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Action Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Use Browser Print");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 6);
    ɵngcc0.ɵɵelement(11, "p-inputSwitch", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, DwFormPrintConfigComponent_div_0_ng_container_12_Template, 32, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(12);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.useBrowserPrint));
} }
function DwFormActionConfigDefaultComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Customize Redirect");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormActionConfigDefaultComponent_div_0_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Redirect Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-select-route", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormActionConfigDefaultComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Action Message");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "input", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Require Validation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 6);
    ɵngcc0.ɵɵelement(11, "p-inputSwitch", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 2);
    ɵngcc0.ɵɵelementStart(13, "div", 5);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Redirect After");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 6);
    ɵngcc0.ɵɵelement(17, "p-inputSwitch", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(18, DwFormActionConfigDefaultComponent_div_0_div_18_Template, 6, 0, "div", 9);
    ɵngcc0.ɵɵtemplate(19, DwFormActionConfigDefaultComponent_div_0_div_19_Template, 5, 0, "div", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(18);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.redirectAfter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.customizeRedirect);
} }
function DwFormWorkflowButtonsConfigComponent_div_0_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r7.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r7.Display, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_div_7_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r9.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r9.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Workflow Status Detail Attribute ");
    ɵngcc0.ɵɵelement(4, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 14);
    ɵngcc0.ɵɵelementStart(6, "option", 12);
    ɵngcc0.ɵɵtext(7, "none");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwFormWorkflowButtonsConfigComponent_div_0_div_7_option_8_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.lookupDefAttributeList);
} }
function DwFormWorkflowButtonsConfigComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Show Admin Action Text ");
    ɵngcc0.ɵɵelement(4, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 8);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormWorkflowButtonsConfigComponent_div_0_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Update lookup on set");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormWorkflowButtonsConfigComponent_div_0_div_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Customize Workflow Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r22 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r22.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r22.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r23 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r23.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r23.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Show Required Expression");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-expression-picker-control", 30);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_23_Template_dw_expression_picker_control_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(3); return ctx_r24.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("contextNames", ctx_r12.configContext == null ? null : ctx_r12.configContext.contextNames)("item", ctx_r12.configContext == null ? null : ctx_r12.configContext.itemName)("queryMeaning", ctx_r12.configContext == null ? null : ctx_r12.configContext.QueryMeaning);
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r26 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r26.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r26.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_39_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r27 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r27.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r27.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_47_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r28 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r28.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r28.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_55_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r29 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r29.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r29.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_63_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r30 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r30.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r30.AttributeDisplay, " ");
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_70_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Current Status Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "input", 31);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_76_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Customize Redirect");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_77_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Redirect Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-select-route", 33);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_84_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-search-select-lookup", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r21.lookupMeaning);
} }
function DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Button Display Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 19);
    ɵngcc0.ɵɵelementStart(6, "option", 12);
    ɵngcc0.ɵɵtext(7, "Default");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_8_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 2);
    ɵngcc0.ɵɵelementStart(10, "div", 3);
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵtext(12, "Validation Required Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "select", 20);
    ɵngcc0.ɵɵelementStart(14, "option", 12);
    ɵngcc0.ɵɵtext(15, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(16, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_16_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 2);
    ɵngcc0.ɵɵelementStart(18, "div", 7);
    ɵngcc0.ɵɵelementStart(19, "label");
    ɵngcc0.ɵɵtext(20, "Validate After Update");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 8);
    ɵngcc0.ɵɵelement(22, "p-inputSwitch", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(23, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_23_Template, 5, 3, "div", 6);
    ɵngcc0.ɵɵelementStart(24, "div", 2);
    ɵngcc0.ɵɵelementStart(25, "div", 3);
    ɵngcc0.ɵɵelementStart(26, "label");
    ɵngcc0.ɵɵtext(27, "Button Class Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "select", 22);
    ɵngcc0.ɵɵelementStart(29, "option", 12);
    ɵngcc0.ɵɵtext(30, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(31, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_31_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "div", 2);
    ɵngcc0.ɵɵelementStart(33, "div", 3);
    ɵngcc0.ɵɵelementStart(34, "label");
    ɵngcc0.ɵɵtext(35, "Icon Class Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "select", 23);
    ɵngcc0.ɵɵelementStart(37, "option", 12);
    ɵngcc0.ɵɵtext(38, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(39, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_39_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(40, "div", 2);
    ɵngcc0.ɵɵelementStart(41, "div", 3);
    ɵngcc0.ɵɵelementStart(42, "label");
    ɵngcc0.ɵɵtext(43, "Toolip Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(44, "select", 24);
    ɵngcc0.ɵɵelementStart(45, "option", 12);
    ɵngcc0.ɵɵtext(46, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(47, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_47_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(48, "div", 2);
    ɵngcc0.ɵɵelementStart(49, "div", 3);
    ɵngcc0.ɵɵelementStart(50, "label");
    ɵngcc0.ɵɵtext(51, "Current Status Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(52, "select", 25);
    ɵngcc0.ɵɵelementStart(53, "option", 12);
    ɵngcc0.ɵɵtext(54, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(55, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_55_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(56, "div", 2);
    ɵngcc0.ɵɵelementStart(57, "div", 3);
    ɵngcc0.ɵɵelementStart(58, "label");
    ɵngcc0.ɵɵtext(59, "Current Status Button Class Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(60, "select", 26);
    ɵngcc0.ɵɵelementStart(61, "option", 12);
    ɵngcc0.ɵɵtext(62, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(63, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_option_63_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(64, "div", 2);
    ɵngcc0.ɵɵelementStart(65, "div", 7);
    ɵngcc0.ɵɵelementStart(66, "label");
    ɵngcc0.ɵɵtext(67, "Override Current Status");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(68, "div", 8);
    ɵngcc0.ɵɵelement(69, "p-inputSwitch", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(70, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_70_Template, 5, 0, "div", 6);
    ɵngcc0.ɵɵelementStart(71, "div", 2);
    ɵngcc0.ɵɵelementStart(72, "div", 3);
    ɵngcc0.ɵɵelementStart(73, "label");
    ɵngcc0.ɵɵtext(74, "Status Prefix");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(75, "input", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(76, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_76_Template, 6, 0, "div", 6);
    ɵngcc0.ɵɵtemplate(77, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_77_Template, 5, 0, "div", 6);
    ɵngcc0.ɵɵelementStart(78, "div", 2);
    ɵngcc0.ɵɵelementStart(79, "div", 7);
    ɵngcc0.ɵɵelementStart(80, "label");
    ɵngcc0.ɵɵtext(81, "Override Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(82, "div", 8);
    ɵngcc0.ɵɵelement(83, "p-inputSwitch", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(84, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_div_84_Template, 5, 1, "div", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r6.actionConfigFG == null ? null : ctx_r6.actionConfigFG.value == null ? null : ctx_r6.actionConfigFG.value.requireValidationAttrName) || (ctx_r6.actionConfigFG.value == null ? null : ctx_r6.actionConfigFG.value.workflowStatusDetailAttrName));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.actionConfigFG == null ? null : ctx_r6.actionConfigFG.value == null ? null : ctx_r6.actionConfigFG.value.overrideCurrentStatusDisplay);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.actionConfigFG == null ? null : ctx_r6.actionConfigFG.value == null ? null : ctx_r6.actionConfigFG.value.redirectAfter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.actionConfigFG == null ? null : ctx_r6.actionConfigFG.value == null ? null : ctx_r6.actionConfigFG.value.customizeRedirect);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.actionConfigFG == null ? null : ctx_r6.actionConfigFG.value == null ? null : ctx_r6.actionConfigFG.value.useLookupOverride);
} }
function DwFormWorkflowButtonsConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Workflow Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 4);
    ɵngcc0.ɵɵtemplate(6, DwFormWorkflowButtonsConfigComponent_div_0_option_6_Template, 2, 2, "option", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwFormWorkflowButtonsConfigComponent_div_0_div_7_Template, 9, 2, "div", 6);
    ɵngcc0.ɵɵtemplate(8, DwFormWorkflowButtonsConfigComponent_div_0_div_8_Template, 7, 0, "div", 6);
    ɵngcc0.ɵɵelementStart(9, "div", 2);
    ɵngcc0.ɵɵelementStart(10, "div", 7);
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵtext(12, "Hide Current Status");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 8);
    ɵngcc0.ɵɵelement(14, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 2);
    ɵngcc0.ɵɵelementStart(16, "div", 7);
    ɵngcc0.ɵɵelementStart(17, "label");
    ɵngcc0.ɵɵtext(18, "Set Status Only (No Save)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 8);
    ɵngcc0.ɵɵelement(20, "p-inputSwitch", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, DwFormWorkflowButtonsConfigComponent_div_0_div_21_Template, 6, 0, "div", 6);
    ɵngcc0.ɵɵtemplate(22, DwFormWorkflowButtonsConfigComponent_div_0_div_22_Template, 6, 0, "div", 6);
    ɵngcc0.ɵɵtemplate(23, DwFormWorkflowButtonsConfigComponent_div_0_ng_container_23_Template, 85, 19, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.lookupAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.workflowStatusDetailAttrName);
    ɵngcc0.ɵɵadvance(13);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.setStatusOnly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.lookupDefAttributeList);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.useCustomAttributes) && ctx_r0.lookupDefAttributeList);
} }
function DwFormWorkflowButtonsActionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-button", 1);
    ɵngcc0.ɵɵlistener("click", function DwFormWorkflowButtonsActionComponent_ng_container_0_Template_dw_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const button_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.actionClick(button_r1.lookupItem); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const button_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("buttonConfig", button_r1.buttonConfig);
} }
function DwSelectLookupConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtext(2, " Customize Lookup ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSelectLookupConfigComponent_div_0_Template_p_inputSwitch_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.config.useLookupOverride = $event; })("ngModelChange", function DwSelectLookupConfigComponent_div_0_Template_p_inputSwitch_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.useLookupOverride);
} }
function DwSelectLookupConfigComponent_ng_container_1_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵtext(2, " Use Transitions ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSelectLookupConfigComponent_ng_container_1_div_11_Template_p_inputSwitch_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.config.useTransitions = $event; })("ngModelChange", function DwSelectLookupConfigComponent_ng_container_1_div_11_Template_p_inputSwitch_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", ctx_r6.hideUseTransitions);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.config.useTransitions);
} }
function DwSelectLookupConfigComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Use Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "dw-expression-reference-control", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSelectLookupConfigComponent_ng_container_1_Template_dw_expression_reference_control_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.config.lookupIdOverride = $event; })("ngModelChange", function DwSelectLookupConfigComponent_ng_container_1_Template_dw_expression_reference_control_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onLookupOverrideChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Additional Display Attr");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSelectLookupConfigComponent_ng_container_1_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.config.addittionalDisplayAttrName = $event; })("ngModelChange", function DwSelectLookupConfigComponent_ng_container_1_Template_input_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DwSelectLookupConfigComponent_ng_container_1_div_11_Template, 5, 2, "div", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.lookupIdOverride)("contextNames", ctx_r1.configContext.contextNames)("item", ctx_r1.lookupRefItem)("relatedExprRef", ctx_r1.lookupRelatedExprRef);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.hideAdditionalDisplay);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.addittionalDisplayAttrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.lookupDef == null ? null : ctx_r1.lookupDef.HasTransitions);
} }
function DwSelectLookupConfigComponent_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-expression-reference-control", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwSelectLookupConfigComponent_ng_container_2_div_5_Template_dw_expression_reference_control_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const index_r17 = ctx.index; const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return (ctx_r18.config.lookupParamAttributeOverrides[index_r17] = $event); })("ngModelChange", function DwSelectLookupConfigComponent_ng_container_2_div_5_Template_dw_expression_reference_control_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(2); return ctx_r20.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const lookupParam_r16 = ctx.$implicit;
    const index_r17 = ctx.index;
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate2("Param ", index_r17 + 1, " - ", lookupParam_r16.UseAttribute ? lookupParam_r16.AttributeName : lookupParam_r16.ParamNameOverride, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r15.config.lookupParamAttributeOverrides[index_r17])("contextNames", ctx_r15.configContext.contextNames)("item", ctx_r15.configContext.itemName)("queryMeaning", ctx_r15.configContext.metaDataQueryMeaning);
} }
function DwSelectLookupConfigComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "b");
    ɵngcc0.ɵɵtext(4, "Lookup Parameters");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwSelectLookupConfigComponent_ng_container_2_div_5_Template, 5, 6, "div", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.lookupDef.DwMetaDataLookupParam);
} }
const _c76 = ["editExpr"];
function DwExpressionPickerControlComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " Expressions require an Item or at least one Context Name\n");
    ɵngcc0.ɵɵelementEnd();
} }
function DwExpressionPickerControlComponent_ng_container_1_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 8);
    ɵngcc0.ɵɵlistener("click", function DwExpressionPickerControlComponent_ng_container_1_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.clearExpression(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.clearButtonText);
} }
function DwExpressionPickerControlComponent_ng_container_1_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "dw-expression-group-control", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExpressionPickerControlComponent_ng_container_1_ng_template_9_Template_dw_expression_group_control_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.editingExprGroup = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(4, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DwExpressionPickerControlComponent_ng_container_1_ng_template_9_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.closePopup(); });
    ɵngcc0.ɵɵtext(5, "Ok");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwExpressionPickerControlComponent_ng_container_1_ng_template_9_Template_button_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.closePopup(true); });
    ɵngcc0.ɵɵtext(7, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("item", ctx_r4.item)("contextNames", ctx_r4.contextNames)("queryMeaning", ctx_r4.queryMeaning)("ngModel", ctx_r4.editingExprGroup);
} }
const _c77 = function () { return { width: "850px" }; };
function DwExpressionPickerControlComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "dw-html-view", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 3);
    ɵngcc0.ɵɵlistener("click", function DwExpressionPickerControlComponent_ng_container_1_Template_button_click_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const _r3 = ɵngcc0.ɵɵreference(8); return _r3.show($event); });
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, "\u00A0 ");
    ɵngcc0.ɵɵtemplate(6, DwExpressionPickerControlComponent_ng_container_1_button_6_Template, 2, 1, "button", 4);
    ɵngcc0.ɵɵelementStart(7, "p-overlayPanel", 5, 6);
    ɵngcc0.ɵɵlistener("onHide", function DwExpressionPickerControlComponent_ng_container_1_Template_p_overlayPanel_onHide_7_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.closePopup(true); });
    ɵngcc0.ɵɵtemplate(9, DwExpressionPickerControlComponent_ng_container_1_ng_template_9_Template, 8, 4, "ng-template", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.exprDesc);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.buttonText);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showClear);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(7, _c77));
    ɵngcc0.ɵɵproperty("showCloseIcon", true)("dismissable", false);
} }
function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_label_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1, "Enabled Expression ");
    ɵngcc0.ɵɵelement(2, "i", 11);
    ɵngcc0.ɵɵelementEnd();
} }
function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_label_5_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const validator_r5 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r8.registrationObject[validator_r5.validatorKey].exprressionTooltip);
} }
function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_label_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_label_5_i_2_Template, 1, 1, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const validator_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r7.registrationObject[validator_r5.validatorKey].expressionLabel, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r7.registrationObject[validator_r5.validatorKey].exprressionTooltip);
} }
function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-validation-config-base", 8);
    ɵngcc0.ɵɵlistener("configChange", function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_Template_dw_validation_config_base_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const validator_r5 = ctx.$implicit; return validator_r5.config = $event; })("configChange", function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_Template_dw_validation_config_base_configChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.validatorChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 0);
    ɵngcc0.ɵɵelementStart(3, "div", 9);
    ɵngcc0.ɵɵtemplate(4, DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_label_4_Template, 3, 0, "label", 4);
    ɵngcc0.ɵɵtemplate(5, DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_label_5_Template, 3, 2, "label", 4);
    ɵngcc0.ɵɵelementStart(6, "dw-expression-picker-control", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_Template_dw_expression_picker_control_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const validator_r5 = ctx.$implicit; return validator_r5.conditionExpressionGroup = $event; })("ngModelChange", function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_Template_dw_expression_picker_control_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const validator_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", validator_r5.config)("validatorKey", validator_r5.validatorKey)("configContext", ctx_r4.contextContext);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.registrationObject[validator_r5.validatorKey] || !ctx_r4.registrationObject[validator_r5.validatorKey].expressionLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.registrationObject[validator_r5.validatorKey] && ctx_r4.registrationObject[validator_r5.validatorKey].expressionLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", validator_r5.conditionExpressionGroup)("queryMeaning", ctx_r4.configContext == null ? null : ctx_r4.configContext.metaDataQueryMeaning)("contextNames", ctx_r4.configContext == null ? null : ctx_r4.configContext.contextNames)("item", ctx_r4.configContext == null ? null : ctx_r4.configContext.itemName);
} }
function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ordered-list", 6);
    ɵngcc0.ɵɵlistener("itemsChange", function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_Template_dw_ordered_list_itemsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.config.validators = $event; })("itemsChange", function DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_Template_dw_ordered_list_itemsChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(1, DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_ng_container_1_Template, 7, 9, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("items", ctx_r2.config.validators);
} }
function DwFieldValidationConfigComponent_ng_container_6_fieldset_2_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "fieldset");
    ɵngcc0.ɵɵelementStart(1, "legend");
    ɵngcc0.ɵɵtext(2, "Add Validator");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 0);
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Validator");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "p-dropdown", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFieldValidationConfigComponent_ng_container_6_fieldset_2_Template_p_dropdown_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.selectedRegistrationKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DwFieldValidationConfigComponent_ng_container_6_fieldset_2_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.addValidator(); });
    ɵngcc0.ɵɵtext(9, "Add Validator");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("options", ctx_r3.availableRegistrations)("ngModel", ctx_r3.selectedRegistrationKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("enabled", ctx_r3.selectedRegistrationKey);
} }
function DwFieldValidationConfigComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwFieldValidationConfigComponent_ng_container_6_dw_ordered_list_1_Template, 2, 1, "dw-ordered-list", 5);
    ɵngcc0.ɵɵtemplate(2, DwFieldValidationConfigComponent_ng_container_6_fieldset_2_Template, 10, 3, "fieldset", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.config.validators == null ? null : ctx_r0.config.validators.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.availableRegistrations == null ? null : ctx_r0.availableRegistrations.length) > 0);
} }
function DwFieldValidationConfigComponent_ng_container_7_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "dw-validation-config-base", 8);
    ɵngcc0.ɵɵlistener("configChange", function DwFieldValidationConfigComponent_ng_container_7_div_6_Template_dw_validation_config_base_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const validator_r23 = ctx.$implicit; return validator_r23.config = $event; })("configChange", function DwFieldValidationConfigComponent_ng_container_7_div_6_Template_dw_validation_config_base_configChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.validatorChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 0);
    ɵngcc0.ɵɵelementStart(3, "div", 9);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Enabled Expression ");
    ɵngcc0.ɵɵelement(6, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "dw-expression-picker-control", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFieldValidationConfigComponent_ng_container_7_div_6_Template_dw_expression_picker_control_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const validator_r23 = ctx.$implicit; return validator_r23.conditionExpressionGroup = $event; })("ngModelChange", function DwFieldValidationConfigComponent_ng_container_7_div_6_Template_dw_expression_picker_control_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r28 = ɵngcc0.ɵɵnextContext(2); return ctx_r28.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const validator_r23 = ctx.$implicit;
    const ctx_r22 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", validator_r23.config)("validatorKey", validator_r23.validatorKey)("configContext", ctx_r22.contextContext);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", validator_r23.conditionExpressionGroup)("queryMeaning", ctx_r22.configContext == null ? null : ctx_r22.configContext.metaDataQueryMeaning)("contextNames", ctx_r22.configContext == null ? null : ctx_r22.configContext.contextNames)("item", ctx_r22.configContext == null ? null : ctx_r22.configContext.itemName);
} }
function DwFieldValidationConfigComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Selected Validators");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p-multiSelect", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFieldValidationConfigComponent_ng_container_7_Template_p_multiSelect_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.selectedRegistrationKeys = $event; })("ngModelChange", function DwFieldValidationConfigComponent_ng_container_7_Template_p_multiSelect_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.updateRegistrations(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwFieldValidationConfigComponent_ng_container_7_div_6_Template, 8, 7, "div", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("options", ctx_r1.allRegistrations)("ngModel", ctx_r1.selectedRegistrationKeys);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.config == null ? null : ctx_r1.config.validators);
} }
function DwMdChildDataRepeaterSectionConfigComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r6.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r6.NamingInfo == null ? null : item_r6.NamingInfo.RelationshipDisplayName, " ");
} }
function DwMdChildDataRepeaterSectionConfigComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.relationshipDisplay, " ");
} }
function DwMdChildDataRepeaterSectionConfigComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Order Attribute ");
    ɵngcc0.ɵɵelement(3, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p-dropdown", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_div_18_Template_p_dropdown_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.section.orderAttributeName = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_div_18_Template_p_dropdown_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("options", ctx_r2.availableAttributes)("ngModel", ctx_r2.section.orderAttributeName)("filter", true);
} }
function DwMdChildDataRepeaterSectionConfigComponent_div_19_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r12 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r12.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r12.display, " ");
} }
function DwMdChildDataRepeaterSectionConfigComponent_div_19_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Use Filters ");
    ɵngcc0.ɵɵelement(3, "i", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-yesno", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_div_19_div_6_Template_dw_yesno_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.section.useFilters = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_div_19_div_6_Template_dw_yesno_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r11.section.useFilters);
} }
function DwMdChildDataRepeaterSectionConfigComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Child Section Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_div_19_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.section.section.sectionType = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_div_19_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(5, DwMdChildDataRepeaterSectionConfigComponent_div_19_option_5_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwMdChildDataRepeaterSectionConfigComponent_div_19_div_6_Template, 5, 1, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.section.section.sectionType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.sectionDefs);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.section.isOrderable);
} }
function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2, " Note: Filters are used to limit repeater data and also reuse the same table with multiple child repeaters on the same form. If you need a read-only view with a query and more powerful filters, consider using a data grid/list section. ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_ng_container_7_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "div", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r23 = ctx.$implicit;
    const ctx_r22 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r22.filterFieldConfig[attr_r23.AttributeName])("formGroup", ctx_r22.filterFormGroup)("submitted", ctx_r22.submitted);
} }
function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "h2");
    ɵngcc0.ɵɵtext(4, "Filter Values");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵtemplate(6, DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_ng_container_7_div_6_Template, 2, 3, "div", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r21.selectedAttributes);
} }
function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Filter Attributes ");
    ɵngcc0.ɵɵelement(5, "i", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "p-multiSelect", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_Template_p_multiSelect_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(2); return ctx_r24.setSelectedAttributes($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_ng_container_7_Template, 7, 1, "ng-container", 30);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("options", ctx_r20.availableAttributes)("ngModel", ctx_r20.selectedAttributes)("filter", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r20.selectedAttributes == null ? null : ctx_r20.selectedAttributes.length) > 0);
} }
function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 26);
    ɵngcc0.ɵɵtemplate(1, DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_div_1_Template, 3, 0, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Set Defaults from Filter ");
    ɵngcc0.ɵɵelement(6, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "dw-yesno", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_Template_dw_yesno_ngModelChange_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.section.filterSetDefaultValues = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_Template_dw_yesno_ngModelChange_7_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "div", 4);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Filter Expression ");
    ɵngcc0.ɵɵelement(12, "i", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "dw-expression-picker-control", 29);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_Template_dw_expression_picker_control_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.section.filterExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(14, DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_ng_container_14_Template, 8, 4, "ng-container", 30);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", false);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.section.filterSetDefaultValues);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.section.filterExpression)("contextNames", ctx_r4.contextNames)("item", ctx_r4.section == null ? null : ctx_r4.section.childItem);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", false);
} }
function DwMdChildDataRepeaterSectionConfigComponent_p_tabPanel_58_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 34);
    ɵngcc0.ɵɵelementStart(1, "dw-field-validation-config", 35);
    ɵngcc0.ɵɵlistener("configChange", function DwMdChildDataRepeaterSectionConfigComponent_p_tabPanel_58_Template_dw_field_validation_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.section.validationConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r5.section.validationConfig)("configContext", ctx_r5.metaDataConfigContext);
} }
function DwMdChildDataRepeaterSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Child Data Repeater section has an invalid configuration. (", ctx_r0.invalidConfigurationMessage, ")");
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.noRowsMessage) || "There are no items to display", "");
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_div_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "button", 18);
    ɵngcc0.ɵɵlistener("click", function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_div_4_ng_container_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r15); const i_r9 = ɵngcc0.ɵɵnextContext(3).index; const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.removeItem(i_r9); });
    ɵngcc0.ɵɵelement(2, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 20);
    ɵngcc0.ɵɵlistener("click", function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_div_4_ng_container_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r15); const i_r9 = ɵngcc0.ɵɵnextContext(3).index; const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.removeItem(i_r9); });
    ɵngcc0.ɵɵelement(4, "i", 19);
    ɵngcc0.ɵɵtext(5, " Remove ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_div_4_ng_container_1_Template, 6, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r9 = ɵngcc0.ɵɵnextContext(2).index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.showDelete(i_r9));
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 14);
    ɵngcc0.ɵɵelement(3, "dw-dynamic-section", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_div_4_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r9 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r10.formConfig)("sectionConfig", ctx_r10.sectionConfig.section)("formGroup", ctx_r10.formArray.controls[i_r9])("context", ctx_r10.context)("submitted", ctx_r10.submitted)("parentIsVisible", ctx_r10.visible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r10.formConfig == null ? null : ctx_r10.formConfig.readOnly) && !(ctx_r10.sectionConfig == null ? null : ctx_r10.sectionConfig.hideRemove));
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_div_1_Template, 5, 7, "div", 12);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r9 = ctx.index;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r7.useFilterIndexes || ctx_r7.visibleIndexes[i_r9]);
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.formArray.controls);
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-dynamic-section", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r21 = ctx.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r20.formConfig)("sectionConfig", ctx_r20.sectionConfig.section)("formGroup", item_r21)("context", ctx_r20.context)("submitted", ctx_r20.submitted)("parentIsVisible", ctx_r20.visible);
} }
function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-ordered-list", 21);
    ɵngcc0.ɵɵlistener("itemsChange", function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_8_Template_dw_ordered_list_itemsChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.formArray.controls = $event; })("itemsChange", function DwMdChildDataRepeaterSectionComponent_div_1_ng_container_8_Template_dw_ordered_list_itemsChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.onReorder($event); });
    ɵngcc0.ɵɵtemplate(2, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_8_ng_container_2_Template, 2, 6, "ng-container", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("items", ctx_r5.formArray.controls)("useVisibleIndexes", false)("visibleIndexes", ctx_r5.visibleIndexes);
} }
function DwMdChildDataRepeaterSectionComponent_div_1_button_9_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function DwMdChildDataRepeaterSectionComponent_div_1_button_9_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.addItemClick(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r6.sectionConfig == null ? null : ctx_r6.sectionConfig.addTextOverride) || "Add", "");
} }
function DwMdChildDataRepeaterSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelement(2, "dw-validation-info", 7);
    ɵngcc0.ɵɵtemplate(3, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_3_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementContainerStart(5, 9);
    ɵngcc0.ɵɵtemplate(6, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_6_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(7, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_7_Template, 2, 1, "ng-container", 8);
    ɵngcc0.ɵɵtemplate(8, DwMdChildDataRepeaterSectionComponent_div_1_ng_container_8_Template, 3, 3, "ng-container", 8);
    ɵngcc0.ɵɵelementContainerEnd();
    ɵngcc0.ɵɵtemplate(9, DwMdChildDataRepeaterSectionComponent_div_1_button_9_Template, 2, 1, "button", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r1.formGroup);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r1.formArrayName)("submitted", ctx_r1.submitted)("filterKey", ctx_r1.sectionKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.visibleRowCount == 0);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formArrayName", ctx_r1.formArrayName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.showAsGrid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.isOrderable) && !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.showAsGrid));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.isOrderable) && !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.showAsGrid));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r1.formConfig == null ? null : ctx_r1.formConfig.readOnly) && !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.hideAdd) && ctx_r1.showAdd());
} }
const _c78 = ["dwDynamicFieldHorizontal", ""];
function DwDynamicFieldHorizontalComponent_ng_template_11_Template(rf, ctx) { }
function DwRadioLookupComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "p-radioButton", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRadioLookupComponent_div_1_Template_p_radioButton_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.translatedValue = $event; })("ngModelChange", function DwRadioLookupComponent_div_1_Template_p_radioButton_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const item_r2 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setTranslatedValue(item_r2.Id); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("value", item_r2.Id)("label", item_r2.Display)("ngModel", ctx_r0.translatedValue);
} }
const _c79 = function (a0) { return { active: a0 }; };
function DwRadioLookupComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "button", 7);
    ɵngcc0.ɵɵlistener("click", function DwRadioLookupComponent_ng_container_2_div_1_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const item_r7 = ctx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.setTranslatedValue(item_r7.Id); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c79, (item_r7 == null ? null : item_r7.Id) == ctx_r6.translatedValue));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r7.Display);
} }
function DwRadioLookupComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwRadioLookupComponent_ng_container_2_div_1_Template, 3, 4, "div", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.finalLookupItems);
} }
function DwViewEditSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("click", function DwViewEditSectionComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.toggleEdit(); });
    ɵngcc0.ɵɵelement(1, "i", 5);
    ɵngcc0.ɵɵelementEnd();
} }
function DwViewEditSectionComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-section", 6);
    ɵngcc0.ɵɵlistener("visibleChange", function DwViewEditSectionComponent_ng_container_3_Template_dw_dynamic_section_visibleChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setChildVisibility(ctx_r5.r * 10 + ctx_r5.c, $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r1.formConfig)("sectionConfig", ctx_r1.viewSection)("formGroup", ctx_r1.formGroup)("context", ctx_r1.context)("submitted", ctx_r1.submitted)("parentIsVisible", ctx_r1.visible);
} }
function DwViewEditSectionComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-section", 6);
    ɵngcc0.ɵɵlistener("visibleChange", function DwViewEditSectionComponent_ng_container_4_Template_dw_dynamic_section_visibleChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setChildVisibility(ctx_r7.r * 10 + ctx_r7.c, $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r2.formConfig)("sectionConfig", ctx_r2.editSection)("formGroup", ctx_r2.formGroup)("context", ctx_r2.context)("submitted", ctx_r2.submitted)("parentIsVisible", ctx_r2.visible);
} }
const _c80 = ["autocomplete"];
function DwMultiSelectAdhocComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵlistener("click", function DwMultiSelectAdhocComponent_div_5_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const item_r2 = ctx.$implicit; const i_r3 = ctx.index; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.removeItem(item_r2, i_r3); });
    ɵngcc0.ɵɵelement(5, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r2);
} }
function DwMultiSelectAdhocReadOnlyComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "span", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1);
} }
function DwFieldSelectionComponent_ng_container_0_div_1_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFieldSelectionComponent_ng_container_0_div_1_input_6_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.setSearchText($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.searchText);
} }
function DwFieldSelectionComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelementStart(3, "div", 12);
    ɵngcc0.ɵɵelementStart(4, "span", 13);
    ɵngcc0.ɵɵtext(5, "Search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwFieldSelectionComponent_ng_container_0_div_1_input_6_Template, 1, 1, "input", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showSearch);
} }
function DwFieldSelectionComponent_ng_container_0_i_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 16);
    ɵngcc0.ɵɵlistener("click", function DwFieldSelectionComponent_ng_container_0_i_7_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.showSearch = true; });
    ɵngcc0.ɵɵelementEnd();
} }
function DwFieldSelectionComponent_ng_container_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "button", 18);
    ɵngcc0.ɵɵlistener("click", function DwFieldSelectionComponent_ng_container_0_div_9_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r12); const attr_r10 = ctx.$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.itemClick(attr_r10); });
    ɵngcc0.ɵɵelement(2, "i", 19);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r10 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ctx_r3.addTooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r10.AttributeDisplay, " ");
} }
function DwFieldSelectionComponent_ng_container_0_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " No Fields found ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwFieldSelectionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwFieldSelectionComponent_ng_container_0_div_1_Template, 7, 1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "i", 4);
    ɵngcc0.ɵɵlistener("click", function DwFieldSelectionComponent_ng_container_0_Template_i_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.toggleSort(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "i", 5);
    ɵngcc0.ɵɵlistener("click", function DwFieldSelectionComponent_ng_container_0_Template_i_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.toggleSort(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "i", 6);
    ɵngcc0.ɵɵlistener("click", function DwFieldSelectionComponent_ng_container_0_Template_i_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.toggleSort(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwFieldSelectionComponent_ng_container_0_i_7_Template, 1, 0, "i", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "div", 8);
    ɵngcc0.ɵɵtemplate(9, DwFieldSelectionComponent_ng_container_0_div_9_Template, 4, 2, "div", 9);
    ɵngcc0.ɵɵtemplate(10, DwFieldSelectionComponent_ng_container_0_div_10_Template, 2, 0, "div", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showSearch);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.fieldSort != "none");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.fieldSort != "alphaAsc");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.fieldSort != "alphaDesc");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.showSearch);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.availbleAttributes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.availbleAttributes.length === 0);
} }
function DwConditionalFieldClassesComponent_div_0_ng_container_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c81 = function (a0, a1, a2) { return { fieldClass: a0, className: a1, index: a2 }; };
function DwConditionalFieldClassesComponent_div_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwConditionalFieldClassesComponent_div_0_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const fieldClass_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const className_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c81, fieldClass_r6, className_r3, i_r7));
} }
function DwConditionalFieldClassesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "b");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwConditionalFieldClassesComponent_div_0_ng_container_5_Template, 2, 6, "ng-container", 0);
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵelementStart(8, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwConditionalFieldClassesComponent_div_0_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r11); const className_r3 = ctx.$implicit; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.addItem(className_r3); });
    ɵngcc0.ɵɵtext(9, "Add");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const className_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.classLabels[i_r4]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.conditionalClasses[className_r3]);
} }
function DwConditionalFieldClassesComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DwConditionalFieldClassesComponent_ng_template_1_Template_i_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r16); const className_r13 = ctx.className; const fieldClass_r12 = ctx.fieldClass; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.removeItem(className_r13, fieldClass_r12); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwConditionalFieldClassesComponent_ng_template_1_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const fieldClass_r12 = ctx.fieldClass; return fieldClass_r12.className = $event; })("ngModelChange", function DwConditionalFieldClassesComponent_ng_template_1_Template_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵelementStart(8, "div", 9);
    ɵngcc0.ɵɵelementStart(9, "dw-expression-picker-control", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwConditionalFieldClassesComponent_ng_template_1_Template_dw_expression_picker_control_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const fieldClass_r12 = ctx.fieldClass; return fieldClass_r12.expression = $event; })("ngModelChange", function DwConditionalFieldClassesComponent_ng_template_1_Template_dw_expression_picker_control_ngModelChange_9_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "hr");
} if (rf & 2) {
    const fieldClass_r12 = ctx.fieldClass;
    const index_r14 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Conditional Class ", index_r14 + 1, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", fieldClass_r12.className);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", fieldClass_r12.expression)("contextNames", ctx_r2.contextNames)("item", ctx_r2.itemName)("queryMeaning", ctx_r2.queryMeaning);
} }
function DwGridColumnImageComponent_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.imageSrc, ɵngcc0.ɵɵsanitizeUrl)("ngStyle", ctx_r0.style)("ngClass", ctx_r0.gridColumnConfig == null ? null : ctx_r0.gridColumnConfig.imageClass);
} }
function DwAssociativeLookupFilterConfigComponent_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r3.FkItemName, " (By ", item_r3.FkAttributeName, ") ");
} }
function DwAssociativeLookupFilterConfigComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Child Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeLookupFilterConfigComponent_div_6_Template_p_inputSwitch_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.config.useChildRelationship = $event; })("ngModelChange", function DwAssociativeLookupFilterConfigComponent_div_6_Template_p_inputSwitch_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.useChildRelationship);
} }
function DwAssociativeLookupFilterConfigComponent_div_7_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r8.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r8.FkItemName, " (By ", item_r8.FkAttributeName, ") ");
} }
function DwAssociativeLookupFilterConfigComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Child Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeLookupFilterConfigComponent_div_7_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onChildRelationshipChange($event); });
    ɵngcc0.ɵɵtemplate(5, DwAssociativeLookupFilterConfigComponent_div_7_option_5_Template, 2, 3, "option", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config == null ? null : ctx_r2.config.childRelationshipInfo == null ? null : ctx_r2.config.childRelationshipInfo.relationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.childItemMetaData == null ? null : ctx_r2.childItemMetaData.Relations);
} }
function DwAssociativeLookupFilterComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-multi-select-lookup", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeLookupFilterComponent_ng_container_2_Template_dw_multi_select_lookup_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.lookupIds = $event; })("ngModelChange", function DwAssociativeLookupFilterComponent_ng_container_2_Template_dw_multi_select_lookup_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.lookupIdsChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.lookupIds)("lookupId", ctx_r0.associativeConfig == null ? null : ctx_r0.associativeConfig.lookupId)("valueAttrName", (ctx_r0.fieldDef == null ? null : ctx_r0.fieldDef.alternateLookupValueAttrName) || "Id");
} }
function DwAssociativeLookupFilterComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-search-select-lookup", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeLookupFilterComponent_ng_container_3_Template_dw_search_select_lookup_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.lookupValue = $event; })("ngModelChange", function DwAssociativeLookupFilterComponent_ng_container_3_Template_dw_search_select_lookup_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.lookupValueChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.lookupValue)("lookupId", ctx_r1.associativeConfig == null ? null : ctx_r1.associativeConfig.lookupId)("valueAttrName", (ctx_r1.fieldDef == null ? null : ctx_r1.fieldDef.alternateLookupValueAttrName) || "Id");
} }
function DwMetaDataListConfigBasicWidgetComponent_option_80_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const query_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", query_r2.QueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", query_r2.QueryName, " ");
} }
function DwMetaDataListConfigBasicWidgetComponent_option_87_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
} }
function DwMetadataListBasicComponent_div_0_ng_container_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwMetadataListBasicComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataListBasicComponent_div_0_ng_container_6_ng_container_1_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.cardItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c10, item_r6));
} }
function DwMetadataListBasicComponent_div_0_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwMetadataListBasicComponent_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataListBasicComponent_div_0_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.listItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c10, item_r8));
} }
function DwMetadataListBasicComponent_div_0_ng_container_8_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1, "There are no items found!");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetadataListBasicComponent_div_0_ng_container_8_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DwMetadataListBasicComponent_div_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataListBasicComponent_div_0_ng_container_8_span_1_Template, 2, 0, "span", 0);
    ɵngcc0.ɵɵtemplate(2, DwMetadataListBasicComponent_div_0_ng_container_8_ng_container_2_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.noItemsTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.noItemsTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c10, item_r10));
} }
function DwMetadataListBasicComponent_div_0_p_contextMenu_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p-contextMenu", 10);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(1);
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("target", _r1)("model", ctx_r5.contextMenu);
} }
function DwMetadataListBasicComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", null, 1);
    ɵngcc0.ɵɵelement(2, "dw-action-host");
    ɵngcc0.ɵɵelementStart(3, "dw-data-list", 2);
    ɵngcc0.ɵɵelementStart(4, "div", 3);
    ɵngcc0.ɵɵelementStart(5, "dw-metadata-filters", 4);
    ɵngcc0.ɵɵlistener("filtersChange", function DwMetadataListBasicComponent_div_0_Template_dw_metadata_filters_filtersChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.setFilters($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwMetadataListBasicComponent_div_0_ng_container_6_Template, 2, 4, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(7, DwMetadataListBasicComponent_div_0_ng_container_7_Template, 2, 4, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(8, DwMetadataListBasicComponent_div_0_ng_container_8_Template, 3, 5, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwMetadataListBasicComponent_div_0_p_contextMenu_9_Template, 1, 2, "p-contextMenu", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("data", ctx_r0.dataSource)("filters", ctx_r0.filters)("config", ctx_r0.config);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("configContext", ctx_r0.configContext)("configKeyPart", ctx_r0.configKeyPart)("filterConfig", ctx_r0.config.filters)("filters", ctx_r0.filters);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.contextMenu && ctx_r0.contextMenu.length > 0);
} }
function DwCardConfigComponent_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r5.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r5.name, " ");
} }
function DwCardConfigComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r6.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r6.name, " ");
} }
function DwCardConfigComponent_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2, "Card Component Configuration");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "dw-dynamic-loader", 9);
    ɵngcc0.ɵɵlistener("configure", function DwCardConfigComponent_div_11_div_1_Template_dw_dynamic_loader_configure_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.setupCardConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("component", ctx_r7.cardConfigComponent);
} }
function DwCardConfigComponent_div_11_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2, "List Component Configuration");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "dw-dynamic-loader", 9);
    ɵngcc0.ɵɵlistener("configure", function DwCardConfigComponent_div_11_div_2_Template_dw_dynamic_loader_configure_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.setupListConfigComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("component", ctx_r8.listConfigComponent);
} }
function DwCardConfigComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵtemplate(1, DwCardConfigComponent_div_11_div_1_Template, 5, 1, "div", 8);
    ɵngcc0.ɵɵtemplate(2, DwCardConfigComponent_div_11_div_2_Template, 5, 1, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.cardConfigComponent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.listConfigComponent);
} }
function DwCardConfigComponent_option_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r13.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r13.name, " ");
} }
function DwCardConfigComponent_div_23_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r15.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r15.name, " ");
} }
function DwCardConfigComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Card Action");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwCardConfigComponent_div_23_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.preferences.cardAction = $event; })("ngModelChange", function DwCardConfigComponent_div_23_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.onChange(); });
    ɵngcc0.ɵɵtemplate(5, DwCardConfigComponent_div_23_option_5_Template, 2, 2, "option", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.preferences.cardAction);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.componentList);
} }
function DwCardDefaultConfigComponent_ng_container_0_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "p-dropdown", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwCardDefaultConfigComponent_ng_container_0_div_9_Template_p_dropdown_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const i_r2 = ɵngcc0.ɵɵnextContext().index; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.config.contentItems[i_r2].attributeName = $event; })("ngModelChange", function DwCardDefaultConfigComponent_ng_container_0_div_9_Template_p_dropdown_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(5, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r3.allAttributes)("ngModel", ctx_r3.config.contentItems[i_r2].attributeName)("showClear", true);
} }
function DwCardDefaultConfigComponent_ng_container_0_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Template");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-html-edit", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwCardDefaultConfigComponent_ng_container_0_div_10_Template_dw_html_edit_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const i_r2 = ɵngcc0.ɵɵnextContext().index; const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.config.contentItems[i_r2].template = $event; })("ngModelChange", function DwCardDefaultConfigComponent_ng_container_0_div_10_Template_dw_html_edit_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.config.contentItems[i_r2].template);
} }
function DwCardDefaultConfigComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "div", 1);
    ɵngcc0.ɵɵelementStart(5, "div", 2);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Use Template");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "dw-yesno", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwCardDefaultConfigComponent_ng_container_0_Template_dw_yesno_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r16); const i_r2 = ctx.index; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.config.contentItems[i_r2].useTemplate = $event; })("ngModelChange", function DwCardDefaultConfigComponent_ng_container_0_Template_dw_yesno_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, DwCardDefaultConfigComponent_ng_container_0_div_9_Template, 4, 6, "div", 4);
    ɵngcc0.ɵɵtemplate(10, DwCardDefaultConfigComponent_ng_container_0_div_10_Template, 4, 1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const contentItemDefinition_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(contentItemDefinition_r1.display);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config.contentItems[i_r2].useTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.config == null ? null : ctx_r0.config.contentItems[i_r2].useTemplate));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.config == null ? null : ctx_r0.config.contentItems[i_r2].useTemplate);
} }
const _c82 = function (a0) { return { "dw-btn-success-active": a0 }; };
function DwRouteChildMenuConfigComponent_div_0_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Show on Parent ");
    ɵngcc0.ɵɵelement(5, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 5);
    ɵngcc0.ɵɵelement(7, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Select Children ");
    ɵngcc0.ɵɵelement(12, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 12);
    ɵngcc0.ɵɵelementStart(14, "input", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRouteChildMenuConfigComponent_div_0_div_8_Template_input_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(15, " Edit ");
    ɵngcc0.ɵɵelementStart(16, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRouteChildMenuConfigComponent_div_0_div_8_Template_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(17, " View ");
    ɵngcc0.ɵɵelementStart(18, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRouteChildMenuConfigComponent_div_0_div_8_Template_input_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.fieldChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(19, " Print ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwRouteChildMenuConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Is Child List Menu ");
    ɵngcc0.ɵɵelement(5, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 5);
    ɵngcc0.ɵɵelement(7, "p-inputSwitch", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwRouteChildMenuConfigComponent_div_0_div_8_Template, 20, 0, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.childListMenuOptionsFG);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.childListMenuOptionsFG == null ? null : ctx_r0.childListMenuOptionsFG.value == null ? null : ctx_r0.childListMenuOptionsFG.value.isChildListMenu);
} }
function DwParentFilterConfigComponent_div_6_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r4.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r4.FkItemName, " (By ", item_r4.FkAttributeName, ") ");
} }
function DwParentFilterConfigComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwParentFilterConfigComponent_div_6_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.onRelationshipChange($event); });
    ɵngcc0.ɵɵtemplate(5, DwParentFilterConfigComponent_div_6_option_5_Template, 2, 3, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.config == null ? null : ctx_r0.config.relationshipInfo == null ? null : ctx_r0.config.relationshipInfo.relationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.itemMetaData == null ? null : ctx_r0.itemMetaData.Relations);
} }
function DwParentFilterConfigComponent_div_7_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r8.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r8.Display, " ");
} }
function DwParentFilterConfigComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Filter Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwParentFilterConfigComponent_div_7_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.config.relationAttributeName = $event; })("ngModelChange", function DwParentFilterConfigComponent_div_7_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onChange(); });
    ɵngcc0.ɵɵtemplate(5, DwParentFilterConfigComponent_div_7_option_5_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.config.relationAttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.attributeList);
} }
function DwParentFilterConfigComponent_div_8_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const paramname_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", paramname_r13);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", paramname_r13, " ");
} }
function DwParentFilterConfigComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Route Parameter");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwParentFilterConfigComponent_div_8_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.config.relationParamName = $event; })("ngModelChange", function DwParentFilterConfigComponent_div_8_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onChange(); });
    ɵngcc0.ɵɵtemplate(5, DwParentFilterConfigComponent_div_8_option_5_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.config.relationParamName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.paramNames);
} }
function DwGridColumnTemplateConfigComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r1.DisplayAttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r1.AttributeDisplay, " ");
} }
function DwQuickGrid_ng_container_0_dw_meta_data_grid_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-meta-data-grid", 2);
    ɵngcc0.ɵɵlistener("gridEvent", function DwQuickGrid_ng_container_0_dw_meta_data_grid_1_Template_dw_meta_data_grid_gridEvent_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.onGridEvent($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("item", ctx_r1.item)("filters", ctx_r1.filters)("dataSource", ctx_r1.data || ctx_r1.dataSource)("preferences", ctx_r1.gridPreferences);
} }
function DwQuickGrid_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwQuickGrid_ng_container_0_dw_meta_data_grid_1_Template, 1, 4, "dw-meta-data-grid", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.gridPreferences);
} }
function DwMetadataFilterTilesConfigComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23);
    ɵngcc0.ɵɵelementStart(1, "button", 24);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFilterTilesConfigComponent_div_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r4); const tileTypeConfig_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.addTile(tileTypeConfig_r2); });
    ɵngcc0.ɵɵelement(2, "i", 25);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tileTypeConfig_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("title", "Add  ", tileTypeConfig_r2.name, " Tile");
    ɵngcc0.ɵɵproperty("ngClass", tileTypeConfig_r2 == null ? null : tileTypeConfig_r2.configData == null ? null : tileTypeConfig_r2.configData.tileIconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", tileTypeConfig_r2.name, " ");
} }
function DwMetadataFilterTilesConfigComponent_p_accordion_7_p_accordionTab_57_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 33);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 34);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataFilterTilesConfigComponent_p_accordion_7_p_accordionTab_57_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.configureCustomConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r5.selectedTileTypeConfig == null ? null : ctx_r5.selectedTileTypeConfig.configComponent);
} }
function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵelementStart(1, "p-accordionTab", 26);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "div", 10);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Tile Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.selectedItem.tileDisplay = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 9);
    ɵngcc0.ɵɵelementStart(8, "div", 10);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Tile Header Foreground Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "dw-color-select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_dw_color_select_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.selectedItem.tileHeaderForegroundColor = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 9);
    ɵngcc0.ɵɵelementStart(13, "div", 10);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Tile Header Background Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "dw-color-select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_dw_color_select_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.selectedItem.tileHeaderBackgroundColor = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 9);
    ɵngcc0.ɵɵelementStart(18, "div", 10);
    ɵngcc0.ɵɵelementStart(19, "label");
    ɵngcc0.ɵɵtext(20, "Tile Icon Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.selectedItem.tileIconClass = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 9);
    ɵngcc0.ɵɵelementStart(23, "div", 10);
    ɵngcc0.ɵɵelementStart(24, "label");
    ɵngcc0.ɵɵtext(25, "Tile Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_input_ngModelChange_26_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.selectedItem.tileClass = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(27, "div", 9);
    ɵngcc0.ɵɵelementStart(28, "div", 10);
    ɵngcc0.ɵɵelementStart(29, "label");
    ɵngcc0.ɵɵtext(30, "Tile Heading Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_input_ngModelChange_31_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.selectedItem.tileHeadingClass = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "div", 9);
    ɵngcc0.ɵɵelementStart(33, "div", 10);
    ɵngcc0.ɵɵelementStart(34, "label");
    ɵngcc0.ɵɵtext(35, "Tile Key");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(36, "input", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_input_ngModelChange_36_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.selectedItem.tileKey = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(37, "div", 9);
    ɵngcc0.ɵɵelementStart(38, "div", 15);
    ɵngcc0.ɵɵelementStart(39, "label");
    ɵngcc0.ɵɵtext(40, "Exclude from Group Query ");
    ɵngcc0.ɵɵelement(41, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "div", 17);
    ɵngcc0.ɵɵelementStart(43, "p-inputSwitch", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_p_inputSwitch_ngModelChange_43_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.selectedItem.excludeFromGroupQuery = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(44, "div", 9);
    ɵngcc0.ɵɵelementStart(45, "div", 10);
    ɵngcc0.ɵɵelementStart(46, "label");
    ɵngcc0.ɵɵtext(47, "Filter ");
    ɵngcc0.ɵɵelement(48, "i", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(49, "dw-expression-picker-control", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_dw_expression_picker_control_ngModelChange_49_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.selectedItem.filterExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(50, "p-accordionTab", 29);
    ɵngcc0.ɵɵelementStart(51, "div", 9);
    ɵngcc0.ɵɵelementStart(52, "div", 10);
    ɵngcc0.ɵɵelementStart(53, "label");
    ɵngcc0.ɵɵtext(54, "Visible Expression ");
    ɵngcc0.ɵɵelement(55, "i", 30);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(56, "dw-expression-picker-control", 31);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_p_accordion_7_Template_dw_expression_picker_control_ngModelChange_56_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.selectedItem.visibleExpression = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(57, DwMetadataFilterTilesConfigComponent_p_accordion_7_p_accordionTab_57_Template, 2, 1, "p-accordionTab", 32);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileDisplay);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileHeaderForegroundColor);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileHeaderBackgroundColor);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileIconClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileHeadingClass);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.tileKey);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.excludeFromGroupQuery);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.filterExpression)("contextNames", ctx_r1.configContext == null ? null : ctx_r1.configContext.contextNames)("item", ctx_r1.configContext == null ? null : ctx_r1.configContext.itemName)("queryMeaning", ctx_r1.configContext == null ? null : ctx_r1.configContext.metaDataQueryMeaning);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.visibleExpression)("contextNames", ctx_r1.configContext == null ? null : ctx_r1.configContext.contextNames)("queryMeaning", ctx_r1.configContext == null ? null : ctx_r1.configContext.metaDataQueryMeaning);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.selectedTileTypeConfig == null ? null : ctx_r1.selectedTileTypeConfig.configComponent);
} }
function DwBasicTileComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelement(2, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.tileIconContainerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.tileIconClass)("ngClass", ctx_r0.tileIconClass);
} }
function DwMetadataFilterTilesComponent_div_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "dw-basic-tile", 6);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFilterTilesComponent_div_0_ng_container_1_div_1_Template_dw_basic_tile_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const i_r4 = ɵngcc0.ɵɵnextContext().index; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.selectTile(i_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    const tileState_r3 = ctx_r9.$implicit;
    const i_r4 = ctx_r9.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r5.tileItemStyle)("configKey", ctx_r5.configKey)("sectionKey", ctx_r5.viewKey)("additionalInfo", tileState_r3.filterTileConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tileConfig", tileState_r3.filterTileConfig)("tilesConfig", ctx_r5.tilesConfig)("selected", i_r4 == ctx_r5.selectedIndex)("tileValue", tileState_r3.metricValue)("loading", tileState_r3.loading);
} }
function DwMetadataFilterTilesComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataFilterTilesComponent_div_0_ng_container_1_div_1_Template, 2, 9, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.tileStates.tiles.length <= ctx_r1.columns || i_r4 < ctx_r1.columns - 1);
} }
function DwMetadataFilterTilesComponent_div_0_div_2_ng_container_1_dw_basic_tile_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-basic-tile", 9);
    ɵngcc0.ɵɵlistener("click", function DwMetadataFilterTilesComponent_div_0_div_2_ng_container_1_dw_basic_tile_1_Template_dw_basic_tile_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const i_r12 = ɵngcc0.ɵɵnextContext().index; const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.selectTile(i_r12); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    const tileState_r11 = ctx_r17.$implicit;
    const i_r12 = ctx_r17.index;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("tileConfig", tileState_r11.filterTileConfig)("tilesConfig", ctx_r13.tilesConfig)("selected", i_r12 == ctx_r13.selectedIndex)("tileValue", tileState_r11.metricValue)("loading", tileState_r11.loading);
} }
function DwMetadataFilterTilesComponent_div_0_div_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataFilterTilesComponent_div_0_div_2_ng_container_1_dw_basic_tile_1_Template, 1, 5, "dw-basic-tile", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r12 = ctx.index;
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r12 >= ctx_r10.columns - 1);
} }
function DwMetadataFilterTilesComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, DwMetadataFilterTilesComponent_div_0_div_2_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r2.tileItemStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.tileStates.tiles);
} }
function DwMetadataFilterTilesComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, DwMetadataFilterTilesComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, DwMetadataFilterTilesComponent_div_0_div_2_Template, 2, 2, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.tileContainerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tileStates.tiles);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.tileStates.tiles.length > ctx_r0.columns);
} }
function DwAggregateTileComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function DwAggregateTileComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.onTileClick(); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementStart(3, "span", 3);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 4);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelement(8, "dw-loading", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.tileClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.tileHeadingClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.tileConfig == null ? null : ctx_r0.tileConfig.tileDisplay, " 25 ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.tileValue == null ? "" : ctx_r0.tileValue, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.tileCountClass)("hidden", ctx_r0.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.tileValue == null ? "None2" : ctx_r0.tileValue, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.loading);
} }
function DwAggregateTileComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function DwAggregateTileComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.onTileClick(); });
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelement(2, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementStart(5, "span", 3);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 5);
    ɵngcc0.ɵɵelement(10, "dw-loading", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.tileClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.tileIconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.tileHeadingClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.tileConfig == null ? null : ctx_r1.tileConfig.tileDisplay, " 25 ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.tileValue == null ? "" : ctx_r1.tileValue, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.tileCountClass)("hidden", ctx_r1.loading);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.tileValue == null ? "None2" : ctx_r1.tileValue, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.loading);
} }
function DwPageDesignerComponent_div_0_dw_dynamic_loader_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 18);
    ɵngcc0.ɵɵlistener("configure", function DwPageDesignerComponent_div_0_dw_dynamic_loader_13_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.configureDesigner($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("component", ctx_r1.pageDesignerConfig.rootSectionDesignComponent);
} }
function DwPageDesignerComponent_div_0_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1, "Toolbox");
    ɵngcc0.ɵɵelementEnd();
} }
function DwPageDesignerComponent_div_0_p_tabPanel_21_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵtext(1, "Configuration");
    ɵngcc0.ɵɵelementEnd();
} }
function DwPageDesignerComponent_div_0_p_tabPanel_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 20);
    ɵngcc0.ɵɵtemplate(1, DwPageDesignerComponent_div_0_p_tabPanel_21_ng_template_1_Template, 2, 0, "ng-template", 15);
    ɵngcc0.ɵɵelement(2, "dw-page-designer-config-panel");
    ɵngcc0.ɵɵelementEnd();
} }
function DwPageDesignerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵlistener("click", function DwPageDesignerComponent_div_0_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.unselect(); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(3, "button", 3);
    ɵngcc0.ɵɵtext(4, "Save Design");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "button", 4);
    ɵngcc0.ɵɵtext(6, "Reset");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵelementStart(9, "label", 7);
    ɵngcc0.ɵɵlistener("click", function DwPageDesignerComponent_div_0_Template_label_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.dwPageDesignerStateService.setShowBorders(false); });
    ɵngcc0.ɵɵelement(10, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "label", 7);
    ɵngcc0.ɵɵlistener("click", function DwPageDesignerComponent_div_0_Template_label_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.dwPageDesignerStateService.setShowBorders(true); });
    ɵngcc0.ɵɵelement(12, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, DwPageDesignerComponent_div_0_dw_dynamic_loader_13_Template, 1, 1, "dw-dynamic-loader", 10);
    ɵngcc0.ɵɵelementStart(14, "div", 11);
    ɵngcc0.ɵɵelementStart(15, "div", 12);
    ɵngcc0.ɵɵelement(16, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "p-tabView");
    ɵngcc0.ɵɵelementStart(18, "p-tabPanel", 14);
    ɵngcc0.ɵɵtemplate(19, DwPageDesignerComponent_div_0_ng_template_19_Template, 2, 0, "ng-template", 15);
    ɵngcc0.ɵɵelement(20, "dw-page-designer-toolbar", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, DwPageDesignerComponent_div_0_p_tabPanel_21_Template, 3, 0, "p-tabPanel", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c82, ctx_r0.pageDesignerState == null ? null : ctx_r0.pageDesignerState.showAllBorders));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c82, !(ctx_r0.pageDesignerState == null ? null : ctx_r0.pageDesignerState.showAllBorders)));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.pageDesignerConfig.rootSectionDesignComponent);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("pageDesignerConfig", ctx_r0.pageDesignerConfig);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.pageDesignerState.currentSectionConfigKey);
} }
function DwEmailContainerSectionComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "dw-page-designer-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const i_r2 = ctx_r4.index;
    const column_r1 = ctx_r4.$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("dwCol", ctx_r3.columnPreferences[i_r2].columnSize)("dwColWidth", ctx_r3.columnPreferences[i_r2].customWidth)("dwColClass", ctx_r3.columnPreferences[i_r2].columnClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("sections", column_r1.sections)("parentSectionConfig", ctx_r3.sectionConfig);
} }
function DwEmailContainerSectionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwEmailContainerSectionComponent_ng_container_1_div_1_Template, 2, 5, "div", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r2 < (ctx_r0.sectionConfig == null ? null : ctx_r0.sectionConfig.configData == null ? null : ctx_r0.sectionConfig.configData.columnsConfig == null ? null : ctx_r0.sectionConfig.configData.columnsConfig.columns));
} }
function DwEmailTextSectionComponent_dw_html_view_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-html-view", 1);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailTextSectionComponent_dw_html_view_0_Template_dw_html_view_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.sectionConfig.configData.html = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.sectionConfig.configData.html);
} }
function DwPageDesignerSectionWrapperComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtext(1, " Drop Section Here ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwPageDesignerSectionWrapperComponent_i_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 15);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.preventMove);
} }
function DwPageDesignerSectionWrapperComponent_dw_dynamic_loader_15_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 16);
    ɵngcc0.ɵɵlistener("configure", function DwPageDesignerSectionWrapperComponent_dw_dynamic_loader_15_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.configureCustomConfig($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("component", ctx_r2.sectionDef == null ? null : ctx_r2.sectionDef.component);
} }
const _c83 = function (a0) { return { "pd-section-selected": a0 }; };
const _c84 = function (a0) { return { "pd-section-header-selected": a0 }; };
function DwPageDesignerToolbarComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1, " Drop Section Here ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwPageDesignerToolbarComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelement(1, "i", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", sectionDef_r1.configData.toolbarIconCss);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r1.configData.toolbarDisplay, " ");
} }
function DwPageDesignerToolbarComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("cdkDragMoved", function DwPageDesignerToolbarComponent_div_2_Template_div_cdkDragMoved_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.dragMoved($event); })("cdkDragReleased", function DwPageDesignerToolbarComponent_div_2_Template_div_cdkDragReleased_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.dragReleased($event); });
    ɵngcc0.ɵɵtemplate(1, DwPageDesignerToolbarComponent_div_2_div_1_Template, 2, 0, "div", 4);
    ɵngcc0.ɵɵtemplate(2, DwPageDesignerToolbarComponent_div_2_div_2_Template, 4, 2, "div", 5);
    ɵngcc0.ɵɵelement(3, "i", 6);
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("cdkDragData", sectionDef_r1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", sectionDef_r1.configData.toolbarIconCss);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r1.configData.toolbarDisplay, " ");
} }
function DwPageDesignerConfigPanelComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-ui-child-config-host", 1);
    ɵngcc0.ɵɵlistener("configChange", function DwPageDesignerConfigPanelComponent_ng_container_1_Template_dw_ui_child_config_host_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.sectionConfig = $event; })("configChange", function DwPageDesignerConfigPanelComponent_ng_container_1_Template_dw_ui_child_config_host_configChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.onSectionConfigChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r0.sectionDef == null ? null : ctx_r0.sectionDef.configComponent)("config", ctx_r0.sectionConfig)("configContext", ctx_r0.configContext);
} }
function DwPageDesignerContainerComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "dw-page-designer-section-wrapper", 9);
    ɵngcc0.ɵɵlistener("removeSection", function DwPageDesignerContainerComponent_ng_container_2_Template_dw_page_designer_section_wrapper_removeSection_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.removeSection($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const childSection_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("sectionConfig", childSection_r4);
} }
function DwPageDesignerContainerComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " No sections ");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwPageDesignerContainerComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " Designer Toolbar ");
    ɵngcc0.ɵɵelement(1, "dw-page-designer-toolbar", 10);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("pageDesignerConfig", ctx_r3.pageDesignerConfig);
} }
const _c85 = function (a0) { return { "pd-container-section-dragging": a0 }; };
const _c86 = function () { return { width: "450px" }; };
function DwOrderedListComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} }
function DwOrderedListComponent_div_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c87 = function (a0, a1) { return { $implicit: a0, index: a1 }; };
function DwOrderedListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwOrderedListComponent_div_1_div_1_Template, 1, 0, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelement(3, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵtemplate(5, DwOrderedListComponent_div_1_ng_container_5_Template, 1, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 8);
    ɵngcc0.ɵɵelementStart(7, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DwOrderedListComponent_div_1_Template_i_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r6); const item_r1 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.removeItem(item_r1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.useVisibleIndexes && ctx_r0.visibleIndexes && !ctx_r0.visibleIndexes[i_r2]);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.listItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c87, item_r1, i_r2));
} }
function DwSectionConfigPanelComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 1);
    ɵngcc0.ɵɵlistener("configure", function DwSectionConfigPanelComponent_ng_container_0_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.configureComponent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r0.component);
} }
function DwSecurityConfigPanelComponent_option_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rule_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", rule_r3.ruleKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", rule_r3.ruleName, " ");
} }
function DwSecurityConfigPanelComponent_option_32_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rule_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", rule_r4.ruleKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", rule_r4.ruleName, " ");
} }
function DwSecurityConfigPanelComponent_option_50_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rule_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", rule_r5.ruleKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", rule_r5.ruleName, " ");
} }
function DwConfigPanelHostComponent_dw_section_config_panel_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-section-config-panel");
} }
function DwConfigPanelHostComponent_dw_dynamic_loader_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-dynamic-loader", 2);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("component", ctx_r1.otherConfigComponent);
} }
const _c88 = ["contextMenu"];
function DwDataConfigComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵlistener("contextmenu", function DwDataConfigComponent_ng_template_4_Template_span_contextmenu_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const node_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.nodeMenu($event, node_r2); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const node_r2 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", node_r2.label, " ");
} }
const _c89 = function () { return { "height": "600px", "max-height": "600px", "overflow": "auto" }; };
function DwGridSetValuesActionConfigComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-default-value", 10);
    ɵngcc0.ɵɵlistener("defaultValueChange", function DwGridSetValuesActionConfigComponent_div_0_div_6_Template_dw_default_value_defaultValueChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const attrUpdate_r2 = ctx.$implicit; return attrUpdate_r2.value = $event; })("defaultValueChange", function DwGridSetValuesActionConfigComponent_div_0_div_6_Template_dw_default_value_defaultValueChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const attrUpdate_r2 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onAttrUpdateChange(attrUpdate_r2); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attrUpdate_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.attrUpdatesAttrs[i_r3] == null ? null : ctx_r1.attrUpdatesAttrs[i_r3].AttributeDisplay, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("defaultValue", attrUpdate_r2.value)("contextNames", ctx_r1.configContext.contextNames)("queryAttribute", ctx_r1.attrUpdatesAttrs[i_r3]);
} }
function DwGridSetValuesActionConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Attributes To Update");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "p-multiSelect", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwGridSetValuesActionConfigComponent_div_0_div_6_Template, 5, 4, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵelementStart(8, "div", 7);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Refresh Full Grid");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵelement(12, "p-inputSwitch", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("options", ctx_r0.allAttributes)("filter", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.attrUpdates);
} }
function DwExportConfigComponent_dw_ui_config_list_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function DwExportConfigComponent_dw_ui_config_list_0_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.copyGridColumns(); });
    ɵngcc0.ɵɵtext(1, "Copy Grid Columns");
    ɵngcc0.ɵɵelementEnd();
} }
function DwExportConfigComponent_dw_ui_config_list_0_p_accordion_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵelementStart(1, "p-accordionTab", 16);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Attribute Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 17);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 10);
    ɵngcc0.ɵɵelementStart(9, "div", 11);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "input", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExportConfigComponent_dw_ui_config_list_0_p_accordion_8_Template_input_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.selectedItem.captionOverride = $event; })("ngModelChange", function DwExportConfigComponent_dw_ui_config_list_0_p_accordion_8_Template_input_ngModelChange_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onExportChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "p-accordionTab", 19);
    ɵngcc0.ɵɵelementStart(14, "dw-security-check-config", 20);
    ɵngcc0.ɵɵlistener("configChange", function DwExportConfigComponent_dw_ui_config_list_0_p_accordion_8_Template_dw_security_check_config_configChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.selectedItem.securityConfig = $event; })("configChange", function DwExportConfigComponent_dw_ui_config_list_0_p_accordion_8_Template_dw_security_check_config_configChange_14_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.onExportChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.selectedItem.attr);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.selectedItem.captionOverride)("placeholder", ctx_r2.selectedAttr == null ? null : ctx_r2.selectedAttr.AttributeDisplay);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("config", ctx_r2.selectedItem.securityConfig)("configContext", ctx_r2.configContext);
} }
function DwExportConfigComponent_dw_ui_config_list_0_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 1);
    ɵngcc0.ɵɵlistener("selectedItemChange", function DwExportConfigComponent_dw_ui_config_list_0_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.setSelectedItem($event); })("removeItem", function DwExportConfigComponent_dw_ui_config_list_0_Template_dw_ui_config_list_removeItem_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.removeItem($event); })("reorder", function DwExportConfigComponent_dw_ui_config_list_0_Template_dw_ui_config_list_reorder_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.reorderList(); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "dw-field-selection", 3);
    ɵngcc0.ɵɵlistener("attributeClick", function DwExportConfigComponent_dw_ui_config_list_0_Template_dw_field_selection_attributeClick_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.addItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwExportConfigComponent_dw_ui_config_list_0_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.removeAll(); });
    ɵngcc0.ɵɵtext(5, "Remove All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwExportConfigComponent_dw_ui_config_list_0_button_6_Template, 2, 0, "button", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵtemplate(8, DwExportConfigComponent_dw_ui_config_list_0_p_accordion_8_Template, 15, 6, "p-accordion", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵelementStart(10, "div", 10);
    ɵngcc0.ɵɵelementStart(11, "div", 11);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Export File Name ");
    ɵngcc0.ɵɵelement(14, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "input", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExportConfigComponent_dw_ui_config_list_0_Template_input_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.exportConfig.exportFileName = $event; })("ngModelChange", function DwExportConfigComponent_dw_ui_config_list_0_Template_input_ngModelChange_15_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onExportChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 10);
    ɵngcc0.ɵɵelementStart(17, "div", 11);
    ɵngcc0.ɵɵelementStart(18, "label");
    ɵngcc0.ɵɵtext(19, "Export Sortable Dates ");
    ɵngcc0.ɵɵelement(20, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "dw-yesno", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwExportConfigComponent_dw_ui_config_list_0_Template_dw_yesno_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.exportConfig.exportSortableDates = $event; })("ngModelChange", function DwExportConfigComponent_dw_ui_config_list_0_Template_dw_yesno_ngModelChange_21_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onExportChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r0.exportConfig.exportColumns)("config", ctx_r0.listConfig)("selectedItem", ctx_r0.selectedItem);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("attributes", ctx_r0.availableAttributes);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.gridColumnPreferences);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedItem);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.exportConfig.exportFileName);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.exportConfig.exportSortableDates);
} }
function DwGridCopyModalComponent_dw_message_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-message", 6);
    ɵngcc0.ɵɵlistener("messageChange", function DwGridCopyModalComponent_dw_message_1_Template_dw_message_messageChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.message = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("message", ctx_r0.message);
} }
function DwGridCopyModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attrToUpdate_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("fieldDef", attrToUpdate_r4.fieldConfig)("formGroup", ctx_r1.formGroup)("submitted", ctx_r1.submitted);
} }
const _c90 = ".container-style[_ngcontent-%COMP%]{max-height:500px;min-width:500px;overflow-x:hidden;overflow-y:auto;padding:3px}";
function DwGridCopyConfigComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 17);
    ɵngcc0.ɵɵtext(1, " Please select at least one attribute to replace for a copy ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwDataVariableListConfigComponent_p_accordion_9_div_32_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-search-select-lookup", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_div_32_Template_dw_search_select_lookup_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.selectedItem.metaDataLookupId = $event; })("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_div_32_Template_dw_search_select_lookup_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.onChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.selectedItem.metaDataLookupId)("lookupId", ctx_r1.lookupLookupId);
} }
function DwDataVariableListConfigComponent_p_accordion_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵelementStart(1, "p-accordionTab", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Caption");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "input", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectedItem.display = $event; })("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onCaptionChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵelementStart(8, "div", 11);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Variable Name ");
    ɵngcc0.ɵɵelement(11, "i", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "a", 14);
    ɵngcc0.ɵɵlistener("click", function DwDataVariableListConfigComponent_p_accordion_9_Template_a_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.overrideEdit = true; });
    ɵngcc0.ɵɵtext(13, "Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "input", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_input_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectedItem.name = $event; })("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_input_ngModelChange_14_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.onChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 10);
    ɵngcc0.ɵɵelementStart(16, "div", 11);
    ɵngcc0.ɵɵelementStart(17, "label");
    ɵngcc0.ɵɵtext(18, "Attribute Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "dw-search-select-lookup", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_dw_search_select_lookup_ngModelChange_19_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.selectedItem.attributeType = $event; })("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_dw_search_select_lookup_ngModelChange_19_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 10);
    ɵngcc0.ɵɵelementStart(21, "div", 11);
    ɵngcc0.ɵɵelementStart(22, "label");
    ɵngcc0.ɵɵtext(23, "Control Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "dw-search-select-lookup", 16);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_dw_search_select_lookup_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.selectedItem.controlType = $event; })("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_dw_search_select_lookup_ngModelChange_24_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 10);
    ɵngcc0.ɵɵelementStart(26, "div", 11);
    ɵngcc0.ɵɵelementStart(27, "div", 17);
    ɵngcc0.ɵɵelementStart(28, "label");
    ɵngcc0.ɵɵtext(29, "Is Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(30, "div", 18);
    ɵngcc0.ɵɵelementStart(31, "p-inputSwitch", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_p_inputSwitch_ngModelChange_31_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.selectedItem.isLookup = $event; })("ngModelChange", function DwDataVariableListConfigComponent_p_accordion_9_Template_p_inputSwitch_ngModelChange_31_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.onChanged(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(32, DwDataVariableListConfigComponent_p_accordion_9_div_32_Template, 5, 2, "div", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedItem.display)("placeholder", ctx_r0.selectedAttr == null ? null : ctx_r0.selectedAttr.AttributeDisplay);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.overrideEdit);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedItem.name)("disabled", !ctx_r0.isNewVariable && !ctx_r0.overrideEdit)("placeholder", ctx_r0.selectedAttr == null ? null : ctx_r0.selectedAttr.AttributeDisplay);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedItem.attributeType)("lookupId", ctx_r0.attributeTypeLookupId);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedItem.controlType)("lookupId", ctx_r0.controlTypeLookupId);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedItem.isLookup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedItem.isLookup);
} }
function DwContextDefMultiSelectComponent_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextDef_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(contextDef_r3.contextDisplay);
} }
function DwContextDefMultiSelectComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwContextDefMultiSelectComponent_ng_template_1_div_1_Template, 3, 1, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.selectedContextDefinitions);
} }
function DwOpenModalActionConfigComponent_div_0_option_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r3.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3.display, " ");
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Context");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 15);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextDef_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", contextDef_r9.contextName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", contextDef_r9.contextDisplay, " ");
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_div_8_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r11.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r11.AttributeDisplay, " ");
} }
const _c91 = function () { return []; };
function DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Key Value Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 20);
    ɵngcc0.ɵɵtemplate(4, DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_div_8_option_4_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", (ctx_r8.currentContextMd == null ? null : ctx_r8.currentContextMd.attributes) || ɵngcc0.ɵɵpureFunction0(1, _c91));
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 17);
    ɵngcc0.ɵɵtext(4, "Context");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 18);
    ɵngcc0.ɵɵtemplate(6, DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_option_6_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 2);
    ɵngcc0.ɵɵtemplate(8, DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_div_8_Template, 5, 2, "div", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.contextList);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r5.currentContextMd == null ? null : ctx_r5.currentContextMd.attributes == null ? null : ctx_r5.currentContextMd.attributes.length) > 0);
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_div_3_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r13 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r13.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r13.AttributeDisplay, " ");
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Key Value Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 20);
    ɵngcc0.ɵɵtemplate(5, DwOpenModalActionConfigComponent_div_0_ng_container_12_div_3_option_5_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.attributes);
} }
function DwOpenModalActionConfigComponent_div_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwOpenModalActionConfigComponent_div_0_ng_container_12_div_1_Template, 6, 0, "div", 13);
    ɵngcc0.ɵɵtemplate(2, DwOpenModalActionConfigComponent_div_0_ng_container_12_ng_container_2_Template, 9, 2, "ng-container", 7);
    ɵngcc0.ɵɵtemplate(3, DwOpenModalActionConfigComponent_div_0_ng_container_12_div_3_Template, 6, 1, "div", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.contextList == null ? null : ctx_r2.contextList.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.actionConfigFG == null ? null : ctx_r2.actionConfigFG.value == null ? null : ctx_r2.actionConfigFG.value.useContext) && (ctx_r2.contextList == null ? null : ctx_r2.contextList.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r2.actionConfigFG == null ? null : ctx_r2.actionConfigFG.value == null ? null : ctx_r2.actionConfigFG.value.useContext) || (ctx_r2.contextList == null ? null : ctx_r2.contextList.length) == 0);
} }
function DwOpenModalActionConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Item");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "dw-search-select-lookup", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "View Type 2");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "select", 5);
    ɵngcc0.ɵɵtemplate(11, DwOpenModalActionConfigComponent_div_0_option_11_Template, 2, 2, "option", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, DwOpenModalActionConfigComponent_div_0_ng_container_12_Template, 4, 3, "ng-container", 7);
    ɵngcc0.ɵɵelementStart(13, "div", 2);
    ɵngcc0.ɵɵelementStart(14, "div", 3);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Modal Title Override ");
    ɵngcc0.ɵɵelement(17, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(18, "input", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 2);
    ɵngcc0.ɵɵelementStart(20, "div", 3);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Config Key Part ");
    ɵngcc0.ɵɵelement(23, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(24, "input", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.lookupId)("overrideValues", ctx_r0.items);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.actionTypes);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showKeyValue);
} }
function DwTemplateViewControlComponent_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.templateResult, " ");
} }
function DwTemplateViewControlComponent_dw_html_view_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-html-view", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTemplateViewControlComponent_dw_html_view_1_Template_dw_html_view_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.templateResult = $event; });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.templateResult);
} }
function DwTitleTemplatesConfigComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Customize Styles ");
    ɵngcc0.ɵɵelement(3, "i", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-yesno", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_div_9_Template_dw_yesno_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.value.showContainerOptions = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.value.showContainerOptions);
} }
function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 22);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r8.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r8.display, " ");
} }
function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 17);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Container Style");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 18);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template_select_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const templateConfig_r5 = ɵngcc0.ɵɵnextContext().$implicit; return templateConfig_r5.containerStyleName = $event; });
    ɵngcc0.ɵɵtemplate(6, DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_option_6_Template, 2, 2, "option", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 17);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Container Icon");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const templateConfig_r5 = ɵngcc0.ɵɵnextContext().$implicit; return templateConfig_r5.containerHeaderIcon = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 0);
    ɵngcc0.ɵɵelementStart(13, "div", 3);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Header Background Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "dw-color-select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template_dw_color_select_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const templateConfig_r5 = ɵngcc0.ɵɵnextContext().$implicit; return templateConfig_r5.containerHeaderBackgroundColor = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 3);
    ɵngcc0.ɵɵelementStart(18, "label");
    ɵngcc0.ɵɵtext(19, "Header Text Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "dw-color-select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template_dw_color_select_ngModelChange_20_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const templateConfig_r5 = ɵngcc0.ɵɵnextContext().$implicit; return templateConfig_r5.containerHeaderForegroundColor = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "div", 3);
    ɵngcc0.ɵɵelementStart(22, "label");
    ɵngcc0.ɵɵtext(23, "Icon Color");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(24, "dw-color-select", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template_dw_color_select_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const templateConfig_r5 = ɵngcc0.ɵɵnextContext().$implicit; return templateConfig_r5.containerHeaderIconColor = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const templateConfig_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.containerStyleName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.containerStyles);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.containerHeaderIcon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(templateConfig_r5.containerHeaderIcon);
    ɵngcc0.ɵɵproperty("hidden", !templateConfig_r5.containerHeaderIcon);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.containerHeaderBackgroundColor);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.containerHeaderForegroundColor);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.containerHeaderIconColor);
} }
function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Template ");
    ɵngcc0.ɵɵelement(5, "i", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "dw-template-config-control", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_Template_dw_template_config_control_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const templateConfig_r5 = ctx.$implicit; return templateConfig_r5.template = $event; })("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_Template_dw_template_config_control_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 0);
    ɵngcc0.ɵɵelementStart(8, "div", 11);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Expression ");
    ɵngcc0.ɵɵelement(11, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "dw-expression-picker-control", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_Template_dw_expression_picker_control_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const templateConfig_r5 = ctx.$implicit; return templateConfig_r5.expression = $event; })("ngModelChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_Template_dw_expression_picker_control_ngModelChange_12_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.onChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(13, DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_ng_container_13_Template, 25, 10, "ng-container", 16);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const templateConfig_r5 = ctx.$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.template)("contextNames", ctx_r4.contextNames)("item", ctx_r4.item)("showDisplayAttributes", ctx_r4.value.loadLookupDisplays);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", templateConfig_r5.expression)("contextNames", ctx_r4.contextNames)("item", ctx_r4.item);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.parentUseContainerStyling && ctx_r4.value.showContainerOptions);
} }
function DwTitleTemplatesConfigComponent_dw_ordered_list_10_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ordered-list", 9);
    ɵngcc0.ɵɵlistener("itemsChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_Template_dw_ordered_list_itemsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.value.titleTemplates = $event; })("itemsChange", function DwTitleTemplatesConfigComponent_dw_ordered_list_10_Template_dw_ordered_list_itemsChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.onChange(); });
    ɵngcc0.ɵɵtemplate(1, DwTitleTemplatesConfigComponent_dw_ordered_list_10_ng_container_1_Template, 14, 8, "ng-container", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r1.value.titleTemplates);
} }
function DwFormMultiCreateConfigComponent_div_20_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "hr");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attributeConfig_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1("", attributeConfig_r3.attrName, " is not found");
} }
function DwFormMultiCreateConfigComponent_div_20_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-expression-reference-control", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormMultiCreateConfigComponent_div_20_ng_container_6_Template_dw_expression_reference_control_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const attributeConfig_r3 = ɵngcc0.ɵɵnextContext().$implicit; return attributeConfig_r3.valueReference = $event; })("ngModelChange", function DwFormMultiCreateConfigComponent_div_20_ng_container_6_Template_dw_expression_reference_control_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.updateAttributeConfigs(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attributeConfig_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", attributeConfig_r3.valueReference)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c4))("contextNames", ctx_r5.configContext.contextNames)("item", ctx_r5.configContext.itemName)("relatedExprRef", attributeConfig_r3.relatedReference);
} }
function DwFormMultiCreateConfigComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "i", 20);
    ɵngcc0.ɵɵlistener("click", function DwFormMultiCreateConfigComponent_div_20_Template_i_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r13); const attributeConfig_r3 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.removeAttributeConfig(attributeConfig_r3); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwFormMultiCreateConfigComponent_div_20_ng_container_5_Template, 4, 1, "ng-container", 21);
    ɵngcc0.ɵɵtemplate(6, DwFormMultiCreateConfigComponent_div_20_ng_container_6_Template, 2, 6, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attributeConfig_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(attributeConfig_r3.attrDisplay);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", attributeConfig_r3.attributeMissing);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !attributeConfig_r3.attributeMissing);
} }
function DwFormMultiCreateConfigComponent_div_50_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Customize Redirect");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 16);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormMultiCreateConfigComponent_div_51_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Redirect Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-select-route", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormSetValuesConfigComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-expression-reference-control", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormSetValuesConfigComponent_div_7_Template_dw_expression_reference_control_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const attributeConfig_r3 = ctx.$implicit; return attributeConfig_r3.valueReference = $event; })("ngModelChange", function DwFormSetValuesConfigComponent_div_7_Template_dw_expression_reference_control_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.updateAttributeConfigs(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attributeConfig_r3 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(attributeConfig_r3.attrDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", attributeConfig_r3.valueReference)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c4))("contextNames", ctx_r0.configContext.contextNames)("item", ctx_r0.configContext.itemName)("relatedExprRef", attributeConfig_r3.relatedReference);
} }
function DwFormSetValuesConfigComponent_ng_container_8_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-expression-reference-control", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormSetValuesConfigComponent_ng_container_8_div_6_Template_dw_expression_reference_control_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const contextConfig_r8 = ctx.$implicit; return contextConfig_r8.valueReference = $event; })("ngModelChange", function DwFormSetValuesConfigComponent_ng_container_8_div_6_Template_dw_expression_reference_control_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.updateAttributeConfigs(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextConfig_r8 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(contextConfig_r8.attrDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", contextConfig_r8.valueReference)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(6, _c4))("contextNames", ctx_r7.configContext.contextNames)("item", ctx_r7.configContext.itemName)("relatedExprRef", contextConfig_r8.relatedReference);
} }
function DwFormSetValuesConfigComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Context Attributes to set");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p-multiSelect", 13);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFormSetValuesConfigComponent_ng_container_8_Template_p_multiSelect_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.selectedContextAttributes = $event; })("ngModelChange", function DwFormSetValuesConfigComponent_ng_container_8_Template_p_multiSelect_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onContextAttributeChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwFormSetValuesConfigComponent_ng_container_8_div_6_Template, 5, 7, "div", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("options", ctx_r1.contextAttributes)("ngModel", ctx_r1.selectedContextAttributes)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(5, _c4))("filter", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.contextConfigs);
} }
function DwFormSetValuesConfigComponent_ng_container_26_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Customize Redirect");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 9);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormSetValuesConfigComponent_ng_container_26_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Redirect Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-select-route", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFormSetValuesConfigComponent_ng_container_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Redirect After");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 9);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, DwFormSetValuesConfigComponent_ng_container_26_div_7_Template, 6, 0, "div", 15);
    ɵngcc0.ɵɵtemplate(8, DwFormSetValuesConfigComponent_ng_container_26_div_8_Template, 5, 0, "div", 15);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.actionConfigFG == null ? null : ctx_r2.actionConfigFG.value == null ? null : ctx_r2.actionConfigFG.value.redirectAfter);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.actionConfigFG == null ? null : ctx_r2.actionConfigFG.value == null ? null : ctx_r2.actionConfigFG.value.customizeRedirect);
} }
function DwGridQuickSearchConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "dw-all-text-fields-custom-filter-config", 2);
    ɵngcc0.ɵɵlistener("configChange", function DwGridQuickSearchConfigComponent_div_0_Template_dw_all_text_fields_custom_filter_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.updateTextFilterConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Search Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "input", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Search Text Box Width (px)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 6);
    ɵngcc0.ɵɵelement(12, "input", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 3);
    ɵngcc0.ɵɵelementStart(14, "div", 6);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Filter Delay (ms)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 6);
    ɵngcc0.ɵɵelement(18, "input", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 3);
    ɵngcc0.ɵɵelementStart(20, "div", 6);
    ɵngcc0.ɵɵelementStart(21, "label");
    ɵngcc0.ɵɵtext(22, "Search Container Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 6);
    ɵngcc0.ɵɵelement(24, "input", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r0.textFilterConfigFC.value)("configContext", ctx_r0.configContext);
} }
function DwMetadataFiltersVerticalComponent_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwMetadataFiltersVerticalComponent_ng_container_2_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 12);
} if (rf & 2) {
    const filterFieldConfig_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("fieldDef", filterFieldConfig_r1.fieldConfig)("formGroup", ctx_r3.formGroup);
} }
function DwMetadataFiltersVerticalComponent_ng_container_2_dw_dynamic_loader_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 6);
    ɵngcc0.ɵɵlistener("configure", function DwMetadataFiltersVerticalComponent_ng_container_2_dw_dynamic_loader_4_Template_dw_dynamic_loader_configure_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const filterFieldConfig_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.configFilterItemComponent($event, filterFieldConfig_r1); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filterFieldConfig_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("component", filterFieldConfig_r1.componentType);
} }
function DwMetadataFiltersVerticalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetadataFiltersVerticalComponent_ng_container_2_ng_container_1_Template, 2, 0, "ng-container", 7);
    ɵngcc0.ɵɵelementStart(2, "div", 8);
    ɵngcc0.ɵɵtemplate(3, DwMetadataFiltersVerticalComponent_ng_container_2_span_3_Template, 1, 2, "span", 9);
    ɵngcc0.ɵɵtemplate(4, DwMetadataFiltersVerticalComponent_ng_container_2_dw_dynamic_loader_4_Template, 1, 1, "dw-dynamic-loader", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const filterFieldConfig_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filterFieldConfig_r1 == null ? null : filterFieldConfig_r1.newRow);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("dwCol", 12);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !filterFieldConfig_r1.componentType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filterFieldConfig_r1.componentType && filterFieldConfig_r1.componentType != ctx_r0.advancedFilterConfig.componentType);
} }
function DwStandardFilterComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("fieldDef", ctx_r1.fieldConfig)("formGroup", ctx_r1.formGroup);
} }
function DwGridCardListComponent_dw_data_list_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-dynamic-loader", 5);
    ɵngcc0.ɵɵlistener("configure", function DwGridCardListComponent_dw_data_list_0_ng_container_2_Template_dw_dynamic_loader_configure_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const item_r4 = ctx.$implicit; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.setupCardComponent($event, item_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("componentName", ctx_r2.cardListConfig.cardComponentName)("ngClass", ctx_r2.cardListConfig.cardItemClass);
} }
function DwGridCardListComponent_dw_data_list_0_ng_container_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r8.cardListConfig.noItemsMessage || "There are no items found!", "");
} }
function DwGridCardListComponent_dw_data_list_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwGridCardListComponent_dw_data_list_0_ng_container_3_span_1_Template, 2, 1, "span", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.noItemsTemplate);
} }
function DwGridCardListComponent_dw_data_list_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-data-list", 1, 2);
    ɵngcc0.ɵɵlistener("actionClick", function DwGridCardListComponent_dw_data_list_0_Template_dw_data_list_actionClick_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.actionPrefClicked($event); });
    ɵngcc0.ɵɵtemplate(2, DwGridCardListComponent_dw_data_list_0_ng_container_2_Template, 2, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(3, DwGridCardListComponent_dw_data_list_0_ng_container_3_Template, 2, 1, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("data", ctx_r0.dataSource)("filters", ctx_r0.filters)("config", ctx_r0.listConfig)("actionContext", ctx_r0.actionContext);
} }
function DwListQuickSearchConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "dw-all-text-fields-custom-filter-config", 2);
    ɵngcc0.ɵɵlistener("configChange", function DwListQuickSearchConfigComponent_div_0_Template_dw_all_text_fields_custom_filter_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.updateTextFilterConfig($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Search Text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "input", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Search Text Box Width (px)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 6);
    ɵngcc0.ɵɵelement(12, "input", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 3);
    ɵngcc0.ɵɵelementStart(14, "div", 6);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Filter Delay (ms)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 6);
    ɵngcc0.ɵɵelement(18, "input", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r0.textFilterConfigFC.value)("configContext", ctx_r0.configContext);
} }
function DwChildRollupFieldConfigComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Query");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p-dropdown", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwChildRollupFieldConfigComponent_div_5_Template_p_dropdown_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.rollupFieldConfig.QueryMeaning = $event; })("ngModelChange", function DwChildRollupFieldConfigComponent_div_5_Template_p_dropdown_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.updateConfig(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(7, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r0.childQueries)("resetFilterOnHide", true)("ngModel", ctx_r0.rollupFieldConfig.QueryMeaning)("showClear", true)("filter", true);
} }
function DwChildRollupFieldConfigComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Item Template");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-template-config-control", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwChildRollupFieldConfigComponent_div_6_Template_dw_template_config_control_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.rollupFieldConfig.ItemTemplate = $event; })("ngModelChange", function DwChildRollupFieldConfigComponent_div_6_Template_dw_template_config_control_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.updateConfig(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.rollupFieldConfig.ItemTemplate)("item", ctx_r1.childItemName)("queryMeaning", ctx_r1.rollupFieldConfig.QueryMeaning)("showDisplayAttributes", true);
} }
function DwQueryEditorFieldsAdvancedComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Include All Fields");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-yesno", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_div_4_Template_dw_yesno_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.fieldState.includeRootItemFields = $event; })("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_div_4_Template_dw_yesno_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.rootItemFieldsChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.fieldState.includeRootItemFields);
} }
function DwQueryEditorFieldsAdvancedComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementStart(1, "dw-field-selection", 14);
    ɵngcc0.ɵɵlistener("attributeClick", function DwQueryEditorFieldsAdvancedComponent_div_5_Template_dw_field_selection_attributeClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.addAttribute($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("attributes", ctx_r1.availableAttributes);
} }
function DwQueryEditorFieldsAdvancedComponent_p_accordionTab_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 15);
    ɵngcc0.ɵɵelementStart(1, "dw-aggregate-field-selection", 16);
    ɵngcc0.ɵɵlistener("addField", function DwQueryEditorFieldsAdvancedComponent_p_accordionTab_6_Template_dw_aggregate_field_selection_addField_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.addField($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("itemMetaData", ctx_r2.fieldState.itemMd);
} }
function DwQueryEditorFieldsAdvancedComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "button", 18);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorFieldsAdvancedComponent_div_8_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const customFieldType_r12 = ctx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.addCustomField(customFieldType_r12); });
    ɵngcc0.ɵɵelement(2, "i", 19);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const customFieldType_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", customFieldType_r12.display, " ");
} }
function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_dw_ui_child_config_host_19_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ui-child-config-host", 28);
    ɵngcc0.ɵɵlistener("configChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_dw_ui_child_config_host_19_Template_dw_ui_child_config_host_configChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.selectedItem.field = $event; })("configChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_dw_ui_child_config_host_19_Template_dw_ui_child_config_host_configChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.fieldChange(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("component", ctx_r15.customFieldType == null ? null : ctx_r15.customFieldType.fieldConfigComponent)("config", ctx_r15.selectedItem.field)("configContext", ctx_r15.fieldConfigContext);
} }
function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-accordion");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵelementStart(3, "p-accordionTab", 20);
    ɵngcc0.ɵɵelementStart(4, "div", 21);
    ɵngcc0.ɵɵelementStart(5, "div", 22);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Caption Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 23);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.selectedItem.field.CaptionOverride = $event; })("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template_input_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.fieldChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 21);
    ɵngcc0.ɵɵelementStart(10, "div", 22);
    ɵngcc0.ɵɵelementStart(11, "label");
    ɵngcc0.ɵɵtext(12, "Field Alias");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "input", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template_input_ngModelChange_13_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.selectedItem.field.FieldAlias = $event; })("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template_input_ngModelChange_13_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.fieldChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 25);
    ɵngcc0.ɵɵelementStart(15, "div", 22);
    ɵngcc0.ɵɵelementStart(16, "label");
    ɵngcc0.ɵɵtext(17, "Format Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "p-dropdown", 26);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template_p_dropdown_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.selectedItem.field.FormatName = $event; })("ngModelChange", function DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template_p_dropdown_ngModelChange_18_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.fieldChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(19, DwQueryEditorFieldsAdvancedComponent_p_accordion_13_dw_ui_child_config_host_19_Template, 1, 3, "dw-ui-child-config-host", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Field Name : ", ctx_r4.selectedItem.field.FullFieldName, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("selected", true);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.selectedItem.field.CaptionOverride)("placeholder", ctx_r4.selectedItem.attrDisplay);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.selectedItem.field.FieldAlias);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r4.validFieldFormatters == null ? null : ctx_r4.validFieldFormatters.length) > 0);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(13, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r4.validFieldFormatters)("resetFilterOnHide", true)("ngModel", ctx_r4.selectedItem.field.FormatName)("showClear", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.customFieldType == null ? null : ctx_r4.customFieldType.fieldConfigComponent);
} }
function DwAggregateFieldSelectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "button", 2);
    ɵngcc0.ɵɵlistener("click", function DwAggregateFieldSelectionComponent_div_0_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const aggregateField_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.addAggregate(aggregateField_r1); });
    ɵngcc0.ɵɵelement(2, "i", 3);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const aggregateField_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", aggregateField_r1.display, " ");
} }
function DwRelationSelectComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2 == null ? null : item_r2.NamingInfo == null ? null : item_r2.NamingInfo.RelationshipDisplayName, " ");
} }
function DwRelationSelectComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3 == null ? null : item_r3.NamingInfo == null ? null : item_r3.NamingInfo.RelationshipDisplayName, " ");
} }
function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_option_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fieldSource_r3 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", fieldSource_r3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", fieldSource_r3.display, " ");
} }
function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_dw_md_section_form_field_config_17_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-md-section-form-field-config", 17);
    ɵngcc0.ɵɵlistener("selectedFieldChange", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_dw_md_section_form_field_config_17_Template_dw_md_section_form_field_config_selectedFieldChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.selectedField.field = $event; })("selectedFieldChange", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_dw_md_section_form_field_config_17_Template_dw_md_section_form_field_config_selectedFieldChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.updateField($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("selectedField", ctx_r2.selectedField.field)("selectedAttr", ctx_r2.selectedAttr)("itemName", ctx_r2.itemName)("contextNames", ctx_r2.contextNames)("contextMdList", ctx_r2.contextMdList);
} }
function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 1);
    ɵngcc0.ɵɵlistener("selectedItemChange", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setSelectedField($event); })("removeItem", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_dw_ui_config_list_removeItem_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.removeItem($event); })("reorder", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_dw_ui_config_list_reorder_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.reorderList(); });
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "select", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_select_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.setFieldSource($event); });
    ɵngcc0.ɵɵtemplate(3, DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_option_3_Template, 2, 2, "option", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "dw-field-selection", 6);
    ɵngcc0.ɵɵlistener("attributeClick", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_dw_field_selection_attributeClick_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.addItem($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵtext(8, " Allow adding duplicate fields ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵelementStart(10, "p-inputSwitch", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_p_inputSwitch_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.allowDuplicateFields = $event; })("ngModelChange", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_p_inputSwitch_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.setFieldSource(ctx_r14.selectedFieldSource); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 11);
    ɵngcc0.ɵɵelementStart(12, "div", 7);
    ɵngcc0.ɵɵelementStart(13, "div", 12);
    ɵngcc0.ɵɵelementStart(14, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.removeAll(); });
    ɵngcc0.ɵɵtext(15, "Remove All");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 14);
    ɵngcc0.ɵɵtemplate(17, DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_dw_md_section_form_field_config_17_Template, 1, 5, "dw-md-section-form-field-config", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r0.listFields)("config", ctx_r0.listConfig)("selectedItem", ctx_r0.selectedField);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.selectedFieldSource);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.fieldSources);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("attributes", ctx_r0.availableAttributes);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.allowDuplicateFields);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedField);
} }
const _c92 = ".dw-field-list{max-height:500px;overflow:auto}.field-section{height:400px;overflow:auto;width:100%}.field-item{clear:left;margin-top:2px;width:200px}.field-item .btn{text-align:left;width:100%}";
function DwQueryEditorFixRelationComponent_div_0_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r3 == null ? null : item_r3.NamingInfo == null ? null : item_r3.NamingInfo.RelationshipDisplayName, " ");
} }
function DwQueryEditorFixRelationComponent_div_0_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r4 == null ? null : item_r4.NamingInfo == null ? null : item_r4.NamingInfo.RelationshipDisplayName, " ");
} }
function DwQueryEditorFixRelationComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "h5", 3);
    ɵngcc0.ɵɵtext(3, "Choose another Relation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "label", 7);
    ɵngcc0.ɵɵtext(8, "Relations");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "p-dropdown", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFixRelationComponent_div_0_Template_p_dropdown_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.selectedRelation = $event; });
    ɵngcc0.ɵɵtemplate(10, DwQueryEditorFixRelationComponent_div_0_ng_template_10_Template, 1, 1, "ng-template", 9);
    ɵngcc0.ɵɵtemplate(11, DwQueryEditorFixRelationComponent_div_0_ng_template_11_Template, 1, 1, "ng-template", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(13, "button", 11);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorFixRelationComponent_div_0_Template_button_click_13_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.okClick(); });
    ɵngcc0.ɵɵtext(14, "Fix relation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DwQueryEditorFixRelationComponent_div_0_Template_button_click_15_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.close(); });
    ɵngcc0.ɵɵtext(16, "Cancel");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(4, _c43));
    ɵngcc0.ɵɵproperty("options", ctx_r0.itemMetaData.Relations)("ngModel", ctx_r0.selectedRelation);
} }
function DwFormDebugSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "br");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵelement(7, "div");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const section_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate3(" ", section_r1.sectionId, "-", ctx_r0.sectionConfig.title, " : ", section_r1.sectionConfig.sectionType, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Visible: ", section_r1.visible, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" Read Only: ", section_r1.readonly, "");
} }
function DataImportRowGridFormSectionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-meta-data-grid", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("preferences", ctx_r0.gridPreferences)("item", ctx_r0.metadata.UniqueItemName)("configKeyPart", ctx_r0.configKeyPart)("filters", ctx_r0.filters);
} }
function ActionButtonGroupConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Hide Caret ");
    ɵngcc0.ɵɵelement(5, "i", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 5);
    ɵngcc0.ɵɵelement(7, "p-inputSwitch", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
} }
const _c93 = ["mdForm"];
function EmailSenderComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const template_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", template_r5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", template_r5.TemplateMeaning, " ");
} }
function EmailSenderComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label", 2);
    ɵngcc0.ɵɵtext(3, "Subject");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function EmailSenderComponent_div_9_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.emailInfo.subject = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.emailInfo.subject);
} }
function EmailSenderComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label", 2);
    ɵngcc0.ɵɵtext(3, "Body");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-html-edit", 12);
    ɵngcc0.ɵɵlistener("ngModelChange", function EmailSenderComponent_div_10_Template_dw_html_edit_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.emailInfo.body = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.emailInfo.body);
} }
function EmailSenderComponent_option_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const emailList_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", emailList_r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", emailList_r10.display, " ");
} }
function EmailSenderComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r4.currentUserResults.length, " E-mails to send");
} }
function DwMetaDataLookupTransitionSectionComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3, "Transition From");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-search-select-lookup", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelementStart(6, "label", 4);
    ɵngcc0.ɵɵtext(7, "Transition To");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "dw-search-select-lookup", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.context == null ? null : ctx_r0.context.data == null ? null : ctx_r0.context.data.value == null ? null : ctx_r0.context.data.value.MetaDataLookupId);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.context == null ? null : ctx_r0.context.data == null ? null : ctx_r0.context.data.value == null ? null : ctx_r0.context.data.value.MetaDataLookupId);
} }
function DwRouteConfigEditComponent_div_0_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r2.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r2.name, " ");
} }
function DwRouteConfigEditComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Component Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 5);
    ɵngcc0.ɵɵelementStart(6, "option", 6);
    ɵngcc0.ɵɵtext(7, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwRouteConfigEditComponent_div_0_option_8_Template, 2, 2, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.components);
} }
function DwRouteEditComponent_form_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "button", 31);
    ɵngcc0.ɵɵlistener("click", function DwRouteEditComponent_form_0_div_3_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.onUndoConversion(); });
    ɵngcc0.ɵɵtext(3, "Undo Conversion");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" Conversion Error: ", ctx_r1.treeNode == null ? null : ctx_r1.treeNode.data == null ? null : ctx_r1.treeNode.data.invalidMessage, " ");
} }
function DwRouteEditComponent_form_0_div_52_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "div", 7);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Permission");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "dw-security-permission-select", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwRouteEditComponent_form_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "form", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2, " Please fill in all required fields. ");
    ɵngcc0.ɵɵtemplate(3, DwRouteEditComponent_form_0_div_3_Template, 4, 1, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p-accordion", 4);
    ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 5);
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Menu Type");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "dw-search-select-lookup", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwRouteEditComponent_form_0_Template_dw_search_select_lookup_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setupRouteConfigComponent(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 9);
    ɵngcc0.ɵɵelementStart(12, "div", 7);
    ɵngcc0.ɵɵelementStart(13, "label");
    ɵngcc0.ɵɵtext(14, "Meta Data Item ");
    ɵngcc0.ɵɵelementStart(15, "span", 10);
    ɵngcc0.ɵɵtext(16, "\u00A0*");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "dw-search-select-lookup", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 6);
    ɵngcc0.ɵɵelementStart(19, "div", 7);
    ɵngcc0.ɵɵelementStart(20, "label");
    ɵngcc0.ɵɵtext(21, "Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(22, "input", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 6);
    ɵngcc0.ɵɵelementStart(24, "div", 7);
    ɵngcc0.ɵɵelementStart(25, "label");
    ɵngcc0.ɵɵtext(26, "Path");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(27, "input", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "div", 6);
    ɵngcc0.ɵɵelementStart(29, "div", 7);
    ɵngcc0.ɵɵelementStart(30, "label");
    ɵngcc0.ɵɵtext(31, "Icon Css");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(32, "input", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(33, "div", 6);
    ɵngcc0.ɵɵelementStart(34, "div", 7);
    ɵngcc0.ɵɵelementStart(35, "label");
    ɵngcc0.ɵɵtext(36, "Order");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(37, "input", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "p-accordionTab");
    ɵngcc0.ɵɵelementStart(39, "p-header");
    ɵngcc0.ɵɵtext(40);
    ɵngcc0.ɵɵelement(41, "i", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(42, "dw-dynamic-loader", 17);
    ɵngcc0.ɵɵlistener("configure", function DwRouteEditComponent_form_0_Template_dw_dynamic_loader_configure_42_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.configureRouteConfigComponentType($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(43, "p-accordionTab", 18);
    ɵngcc0.ɵɵelement(44, "dw-route-child-menu-config", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(45, "p-accordionTab", 20);
    ɵngcc0.ɵɵelementStart(46, "div", 6);
    ɵngcc0.ɵɵelementStart(47, "div", 21);
    ɵngcc0.ɵɵelementStart(48, "label");
    ɵngcc0.ɵɵtext(49, "Require Authentication");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(50, "div", 22);
    ɵngcc0.ɵɵelement(51, "p-inputSwitch", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(52, DwRouteEditComponent_form_0_div_52_Template, 5, 0, "div", 24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(53, "p-accordionTab", 25);
    ɵngcc0.ɵɵelementStart(54, "div", 6);
    ɵngcc0.ɵɵelementStart(55, "div", 21);
    ɵngcc0.ɵɵelementStart(56, "label");
    ɵngcc0.ɵɵtext(57, "Show In Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(58, "div", 22);
    ɵngcc0.ɵɵelement(59, "p-inputSwitch", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(60, "div", 6);
    ɵngcc0.ɵɵelementStart(61, "div", 21);
    ɵngcc0.ɵɵelementStart(62, "label");
    ɵngcc0.ɵɵtext(63, "Exclude From Main Menu");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(64, "div", 22);
    ɵngcc0.ɵɵelement(65, "p-inputSwitch", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(66, "div", 6);
    ɵngcc0.ɵɵelementStart(67, "div", 21);
    ɵngcc0.ɵɵelementStart(68, "label");
    ɵngcc0.ɵɵtext(69, "Highlight Sidebar on Exact Match");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(70, "div", 22);
    ɵngcc0.ɵɵelement(71, "p-inputSwitch", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(72, "dw-route-edit-security", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.formGroup.invalid);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.treeNode == null ? null : ctx_r0.treeNode.data == null ? null : ctx_r0.treeNode.data.invalidMessage);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.routeTypeLookupId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.routeTypeProcessorRegistration == null ? null : ctx_r0.routeTypeProcessorRegistration.usesMetaDataItem));
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.metaDataItemsLookupId);
    ɵngcc0.ɵɵadvance(23);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.routeTypeProcessorRegistration == null ? null : ctx_r0.routeTypeProcessorRegistration.configTabDisplay, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.routeConfigFG.invalid);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r0.routeTypeProcessorRegistration == null ? null : ctx_r0.routeTypeProcessorRegistration.configComponent);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("routeConfigFormGroup", ctx_r0.routeConfigFG);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.RequireAuthentication);
    ɵngcc0.ɵɵadvance(20);
    ɵngcc0.ɵɵproperty("routeConfigFG", ctx_r0.routeConfigFG)("route", ctx_r0.route);
} }
function DwRouteEditChildComponent_form_0_div_25_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Hide Back Button ");
    ɵngcc0.ɵɵelement(4, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 11);
    ɵngcc0.ɵɵelement(6, "p-inputSwitch", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwRouteEditChildComponent_form_0_div_33_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r4.key);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r4.name, " ");
} }
function DwRouteEditChildComponent_form_0_div_33_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label", 17);
    ɵngcc0.ɵɵtext(3, "Side Menu Component ");
    ɵngcc0.ɵɵelement(4, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 19);
    ɵngcc0.ɵɵelementStart(6, "option", 20);
    ɵngcc0.ɵɵtext(7, "None");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwRouteEditChildComponent_form_0_div_33_option_8_Template, 2, 2, "option", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngValue", null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.sideMenuComponents);
} }
function DwRouteEditChildComponent_form_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "form", 1);
    ɵngcc0.ɵɵelementStart(1, "p-accordion", 2);
    ɵngcc0.ɵɵelementStart(2, "p-accordionTab", 3);
    ɵngcc0.ɵɵelementStart(3, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "Display");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "input", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 4);
    ɵngcc0.ɵɵelementStart(9, "div", 5);
    ɵngcc0.ɵɵelementStart(10, "label");
    ɵngcc0.ɵɵtext(11, "Config Key Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(12, "input", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 4);
    ɵngcc0.ɵɵelementStart(14, "div", 5);
    ɵngcc0.ɵɵelementStart(15, "label");
    ɵngcc0.ɵɵtext(16, "Path Override");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "input", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "div", 4);
    ɵngcc0.ɵɵelementStart(19, "div", 9);
    ɵngcc0.ɵɵelementStart(20, "label");
    ɵngcc0.ɵɵtext(21, "Replace Side Menu ");
    ɵngcc0.ɵɵelement(22, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "div", 11);
    ɵngcc0.ɵɵelement(24, "p-inputSwitch", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(25, DwRouteEditChildComponent_form_0_div_25_Template, 7, 0, "div", 13);
    ɵngcc0.ɵɵelementStart(26, "div", 4);
    ɵngcc0.ɵɵelementStart(27, "div", 9);
    ɵngcc0.ɵɵelementStart(28, "label");
    ɵngcc0.ɵɵtext(29, "Menu Group Display ");
    ɵngcc0.ɵɵelement(30, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 11);
    ɵngcc0.ɵɵelement(32, "p-inputSwitch", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(33, DwRouteEditChildComponent_form_0_div_33_Template, 9, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r0.displayPlaceholder);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵproperty("placeholder", ctx_r0.pathPlaceholder);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.formGroup == null ? null : ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.replaceSideMenu);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.formGroup == null ? null : ctx_r0.formGroup.value == null ? null : ctx_r0.formGroup.value.replaceSideMenu);
} }
function DwImportMetaDataModalComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵtext(4, "Meta Data Database");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "dw-search-select-lookup", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImportMetaDataModalComponent_div_1_Template_dw_search_select_lookup_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.databaseId = $event; })("ngModelChange", function DwImportMetaDataModalComponent_div_1_Template_dw_search_select_lookup_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.updateDatabaseId(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "div", 3);
    ɵngcc0.ɵɵelementStart(8, "label", 4);
    ɵngcc0.ɵɵtext(9, "Schemas");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "dw-multi-select-adhoc-lookup", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImportMetaDataModalComponent_div_1_Template_dw_multi_select_adhoc_lookup_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.schemas = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 2);
    ɵngcc0.ɵɵelementStart(12, "div", 3);
    ɵngcc0.ɵɵelementStart(13, "label", 4);
    ɵngcc0.ɵɵtext(14, "Import Mode");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "dw-radio-list", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImportMetaDataModalComponent_div_1_Template_dw_radio_list_ngModelChange_15_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.importMode = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.databaseId)("lookupId", ctx_r0.metaDataDatabaseLookupId);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.schemas)("lookupId", ctx_r0.schemaLookupMeaning)("paramValues", ctx_r0.paramValues);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("values", ctx_r0.importModes)("ngModel", ctx_r0.importMode);
} }
function DwMetaDataLookupTesterComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Show Tester");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-yesno", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetaDataLookupTesterComponent_div_0_Template_dw_yesno_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.showTester = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.showTester)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c4));
} }
function DwMetaDataLookupTesterComponent_ng_container_1_div_6_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.errorMessage, " ");
} }
function DwMetaDataLookupTesterComponent_ng_container_1_div_6_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "dw-search-select-lookup", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lookupDef", ctx_r6.lookupDef)("overrideValues", ctx_r6.lookupItems);
} }
function DwMetaDataLookupTesterComponent_ng_container_1_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Test Results");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵtemplate(4, DwMetaDataLookupTesterComponent_ng_container_1_div_6_div_4_Template, 2, 1, "div", 7);
    ɵngcc0.ɵɵtemplate(5, DwMetaDataLookupTesterComponent_ng_container_1_div_6_div_5_Template, 2, 2, "div", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.errorMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.lookupItems);
} }
function DwMetaDataLookupTesterComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "button", 5);
    ɵngcc0.ɵɵlistener("click", function DwMetaDataLookupTesterComponent_ng_container_1_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.testLookup(); });
    ɵngcc0.ɵɵtext(4, "Test Lookup");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 2);
    ɵngcc0.ɵɵtemplate(6, DwMetaDataLookupTesterComponent_ng_container_1_div_6_Template, 6, 2, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.errorMessage || ctx_r1.lookupItems);
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_3_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "dw-input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_3_Template_dw_input_ngModelChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.scheduleDefinition.OffsetMinute = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_3_Template_dw_input_ngModelChange_2_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵtext(4, " minute");
    ɵngcc0.ɵɵtemplate(5, DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_3_ng_container_5_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵtext(6, " and ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r10.scheduleDefinition.OffsetMinute)("numeric", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.scheduleDefinition.OffsetMinute != "1");
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_7_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵtext(2, " at an offset of ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_3_Template, 7, 3, "ng-container", 13);
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵelementStart(5, "dw-input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_7_ng_container_20_Template_dw_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.scheduleDefinition.OffsetSecond = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_7_ng_container_20_Template_dw_input_ngModelChange_5_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 16);
    ɵngcc0.ɵɵtext(7, " second");
    ɵngcc0.ɵɵtemplate(8, DwProcessScheduleConfigComponent_div_7_ng_container_20_ng_container_8_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.intervalUOM == "minutes" || ctx_r9.intervalUOM == "hours");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r9.scheduleDefinition.OffsetSecond)("numeric", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.scheduleDefinition.OffsetSecond != "1");
} }
function DwProcessScheduleConfigComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label", 3);
    ɵngcc0.ɵɵtext(4, "Schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtext(6, "Run Every ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵelementStart(8, "dw-input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_7_Template_dw_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.intervalValue = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_7_Template_dw_input_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.updateInterval(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 10);
    ɵngcc0.ɵɵelementStart(10, "select", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_7_Template_select_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.intervalUOM = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_7_Template_select_ngModelChange_10_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.updateInterval(); });
    ɵngcc0.ɵɵelementStart(11, "option", 12);
    ɵngcc0.ɵɵtext(12, "Second");
    ɵngcc0.ɵɵtemplate(13, DwProcessScheduleConfigComponent_div_7_ng_container_13_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "option", 14);
    ɵngcc0.ɵɵtext(15, "Minute");
    ɵngcc0.ɵɵtemplate(16, DwProcessScheduleConfigComponent_div_7_ng_container_16_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "option", 15);
    ɵngcc0.ɵɵtext(18, "Hour");
    ɵngcc0.ɵɵtemplate(19, DwProcessScheduleConfigComponent_div_7_ng_container_19_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(20, DwProcessScheduleConfigComponent_div_7_ng_container_20_Template, 9, 4, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.intervalValue)("numeric", true);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.intervalUOM);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.intervalValue != "1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.intervalValue != "1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.intervalValue != "1");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.intervalUOM == "minutes" || ctx_r0.intervalUOM == "hours" || true);
} }
function DwProcessScheduleConfigComponent_div_8_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label", 3);
    ɵngcc0.ɵɵtext(4, "Schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtext(6, "Run Every ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵelementStart(8, "dw-input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_8_Template_dw_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.intervalValue = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_8_Template_dw_input_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.updateInterval(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 16);
    ɵngcc0.ɵɵtext(10, " Day");
    ɵngcc0.ɵɵtemplate(11, DwProcessScheduleConfigComponent_div_8_ng_container_11_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵtext(12, " at ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 10);
    ɵngcc0.ɵɵelementStart(14, "dw-date", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_8_Template_dw_date_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.scheduleDefinition.StartTime = $event; })("ngModelChanges", function DwProcessScheduleConfigComponent_div_8_Template_dw_date_ngModelChanges_14_listener() { ɵngcc0.ɵɵrestoreView(_r26); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.intervalValue)("numeric", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.intervalValue != "1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.scheduleDefinition.StartTime);
} }
function DwProcessScheduleConfigComponent_div_9_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label", 3);
    ɵngcc0.ɵɵtext(4, "Schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtext(6, "Run Every ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵelementStart(8, "dw-input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_dw_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.intervalValue = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_dw_input_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r33 = ɵngcc0.ɵɵnextContext(); return ctx_r33.updateInterval(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 16);
    ɵngcc0.ɵɵtext(10, " Week");
    ɵngcc0.ɵɵtemplate(11, DwProcessScheduleConfigComponent_div_9_ng_container_11_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵtext(12, " at ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 10);
    ɵngcc0.ɵɵelementStart(14, "dw-date", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_dw_date_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.scheduleDefinition.StartTime = $event; })("ngModelChanges", function DwProcessScheduleConfigComponent_div_9_Template_dw_date_ngModelChanges_14_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r35 = ɵngcc0.ɵɵnextContext(); return ctx_r35.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 1);
    ɵngcc0.ɵɵelementStart(16, "div", 2);
    ɵngcc0.ɵɵelementStart(17, "label", 3);
    ɵngcc0.ɵɵtext(18, "Days to Run");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div");
    ɵngcc0.ɵɵelementStart(20, "label", 18);
    ɵngcc0.ɵɵelementStart(21, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_21_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36.scheduleDefinition.RunOnMonday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_21_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r37 = ɵngcc0.ɵɵnextContext(); return ctx_r37.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(22, " Monday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "label", 18);
    ɵngcc0.ɵɵelementStart(24, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_24_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.scheduleDefinition.RunOnTuesday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_24_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(25, " Tuesday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(26, "label", 18);
    ɵngcc0.ɵɵelementStart(27, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_27_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ctx_r40.scheduleDefinition.RunOnWednesday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_27_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(28, " Wednesday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(29, "label", 18);
    ɵngcc0.ɵɵelementStart(30, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_30_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r42 = ɵngcc0.ɵɵnextContext(); return ctx_r42.scheduleDefinition.RunOnThursday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_30_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(31, " Thursday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "label", 18);
    ɵngcc0.ɵɵelementStart(33, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_33_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r44 = ɵngcc0.ɵɵnextContext(); return ctx_r44.scheduleDefinition.RunOnFriday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_33_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r45 = ɵngcc0.ɵɵnextContext(); return ctx_r45.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(34, " Friday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(35, "label", 18);
    ɵngcc0.ɵɵelementStart(36, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_36_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r46 = ɵngcc0.ɵɵnextContext(); return ctx_r46.scheduleDefinition.RunOnSaturday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_36_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r47 = ɵngcc0.ɵɵnextContext(); return ctx_r47.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(37, " Saturday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(38, "label", 18);
    ɵngcc0.ɵɵelementStart(39, "input", 19);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_39_listener($event) { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ctx_r48.scheduleDefinition.RunOnSunday = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_9_Template_input_ngModelChange_39_listener() { ɵngcc0.ɵɵrestoreView(_r32); const ctx_r49 = ɵngcc0.ɵɵnextContext(); return ctx_r49.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(40, " Sunday");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.intervalValue)("numeric", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.intervalValue != "1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.StartTime);
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnMonday);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnTuesday);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnWednesday);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnThursday);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnFriday);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnSaturday);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.scheduleDefinition.RunOnSunday);
} }
function DwProcessScheduleConfigComponent_div_10_option_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r53 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r53.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r53.display, " ");
} }
function DwProcessScheduleConfigComponent_div_10_option_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r54 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r54.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r54.display, " ");
} }
function DwProcessScheduleConfigComponent_div_10_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, "s");
    ɵngcc0.ɵɵelementContainerEnd();
} }
function DwProcessScheduleConfigComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r56 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label", 3);
    ɵngcc0.ɵɵtext(4, "Schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtext(6, "Run on the ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵelementStart(8, "select", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_select_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r55 = ɵngcc0.ɵɵnextContext(); return ctx_r55.scheduleDefinition.MonthDayInterval = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_select_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r57 = ɵngcc0.ɵɵnextContext(); return ctx_r57.onScheduleChange(); });
    ɵngcc0.ɵɵtemplate(9, DwProcessScheduleConfigComponent_div_10_option_9_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 10);
    ɵngcc0.ɵɵelementStart(11, "select", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_select_ngModelChange_11_listener($event) { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r58 = ɵngcc0.ɵɵnextContext(); return ctx_r58.scheduleDefinition.MonthDaySelection = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_select_ngModelChange_11_listener() { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r59 = ɵngcc0.ɵɵnextContext(); return ctx_r59.onScheduleChange(); });
    ɵngcc0.ɵɵtemplate(12, DwProcessScheduleConfigComponent_div_10_option_12_Template, 2, 2, "option", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 16);
    ɵngcc0.ɵɵtext(14, " of every ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 8);
    ɵngcc0.ɵɵelementStart(16, "dw-input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_dw_input_ngModelChange_16_listener($event) { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r60 = ɵngcc0.ɵɵnextContext(); return ctx_r60.intervalValue = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_dw_input_ngModelChange_16_listener() { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r61 = ɵngcc0.ɵɵnextContext(); return ctx_r61.updateInterval(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "div", 16);
    ɵngcc0.ɵɵtext(18, " Month");
    ɵngcc0.ɵɵtemplate(19, DwProcessScheduleConfigComponent_div_10_ng_container_19_Template, 2, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(20, "div", 16);
    ɵngcc0.ɵɵtext(21, " at ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 10);
    ɵngcc0.ɵɵelementStart(23, "dw-date", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_10_Template_dw_date_ngModelChange_23_listener($event) { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r62 = ɵngcc0.ɵɵnextContext(); return ctx_r62.scheduleDefinition.StartTime = $event; })("ngModelChanges", function DwProcessScheduleConfigComponent_div_10_Template_dw_date_ngModelChanges_23_listener() { ɵngcc0.ɵɵrestoreView(_r56); const ctx_r63 = ɵngcc0.ɵɵnextContext(); return ctx_r63.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.scheduleDefinition.MonthDayInterval);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.monthDayIntervals);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.scheduleDefinition.MonthDaySelection);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.monthDaySelection);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.intervalValue)("numeric", true);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.intervalValue != "1");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.scheduleDefinition.StartTime);
} }
function DwProcessScheduleConfigComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r65 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "label", 3);
    ɵngcc0.ɵɵtext(4, "Schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 7);
    ɵngcc0.ɵɵtext(6, "Run On ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 10);
    ɵngcc0.ɵɵelementStart(8, "dw-date", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_11_Template_dw_date_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r65); const ctx_r64 = ɵngcc0.ɵɵnextContext(); return ctx_r64.scheduleDefinition.StartDate = $event; })("ngModelChanges", function DwProcessScheduleConfigComponent_div_11_Template_dw_date_ngModelChanges_8_listener() { ɵngcc0.ɵɵrestoreView(_r65); const ctx_r66 = ɵngcc0.ɵɵnextContext(); return ctx_r66.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 16);
    ɵngcc0.ɵɵtext(10, "at ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 10);
    ɵngcc0.ɵɵelementStart(12, "dw-date", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_div_11_Template_dw_date_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r65); const ctx_r67 = ɵngcc0.ɵɵnextContext(); return ctx_r67.scheduleDefinition.StartTime = $event; })("ngModelChanges", function DwProcessScheduleConfigComponent_div_11_Template_dw_date_ngModelChanges_12_listener() { ɵngcc0.ɵɵrestoreView(_r65); const ctx_r68 = ɵngcc0.ɵɵnextContext(); return ctx_r68.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.scheduleDefinition.StartDate);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.scheduleDefinition.StartTime);
} }
function DwProcessScheduleConfigComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    const _r70 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "h2");
    ɵngcc0.ɵɵtext(1, "Offset");
    ɵngcc0.ɵɵelement(2, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵtext(5, " Offset Minute ");
    ɵngcc0.ɵɵelementStart(6, "input", 24);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_ng_template_12_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r70); const ctx_r69 = ɵngcc0.ɵɵnextContext(); return ctx_r69.scheduleDefinition.MinuteOffset = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_ng_template_12_Template_input_ngModelChange_6_listener() { ɵngcc0.ɵɵrestoreView(_r70); const ctx_r71 = ɵngcc0.ɵɵnextContext(); return ctx_r71.onScheduleChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 1);
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵtext(9, " Offset Second ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.scheduleDefinition.MinuteOffset);
} }
function DwProcessSchedulerStatusComponent_div_1_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "a", 15);
    ɵngcc0.ɵɵlistener("click", function DwProcessSchedulerStatusComponent_div_1_ng_container_16_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.startService(); });
    ɵngcc0.ɵɵelement(2, "i", 16);
    ɵngcc0.ɵɵtext(3, "\u00A0 Start Service");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "a", 15);
    ɵngcc0.ɵɵlistener("click", function DwProcessSchedulerStatusComponent_div_1_ng_container_16_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.stopService(); });
    ɵngcc0.ɵɵelement(5, "i", 17);
    ɵngcc0.ɵɵtext(6, "\u00A0Stop Service");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r1.serviceStatusResult == null ? null : ctx_r1.serviceStatusResult.ServiceStatus) == "Running");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", (ctx_r1.serviceStatusResult == null ? null : ctx_r1.serviceStatusResult.ServiceStatus) != "Running");
} }
function DwProcessSchedulerStatusComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "h5", 5);
    ɵngcc0.ɵɵtext(4, "Scheduler Service");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 6);
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵelement(7, "i", 8);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 9);
    ɵngcc0.ɵɵelement(10, "i", 10);
    ɵngcc0.ɵɵtext(11, " Api Online ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 9);
    ɵngcc0.ɵɵelement(13, "i", 11);
    ɵngcc0.ɵɵtext(14, " Api Offline ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(15, "br");
    ɵngcc0.ɵɵtemplate(16, DwProcessSchedulerStatusComponent_div_1_ng_container_16_Template, 7, 2, "ng-container", 12);
    ɵngcc0.ɵɵelementStart(17, "a", 13);
    ɵngcc0.ɵɵlistener("click", function DwProcessSchedulerStatusComponent_div_1_Template_a_click_17_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.checkServiceStatus(); });
    ɵngcc0.ɵɵelement(18, "i", 14);
    ɵngcc0.ɵɵtext(19, "\u00A0 Refresh Status");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("title", (ctx_r0.serviceStatusResult == null ? null : ctx_r0.serviceStatusResult.Message) || "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.serviceStatusClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.serviceStatusText, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.schedulerHeartbeat == null ? null : ctx_r0.schedulerHeartbeat.Success))("title", (ctx_r0.schedulerHeartbeat == null ? null : ctx_r0.schedulerHeartbeat.Message) || "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.schedulerHeartbeat == null ? null : ctx_r0.schedulerHeartbeat.Success)("title", (ctx_r0.schedulerHeartbeat == null ? null : ctx_r0.schedulerHeartbeat.Message) || "");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.schedulerConfig == null ? null : ctx_r0.schedulerConfig.allowServiceControl);
} }
function DwUserSetPasswordComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1, " Passwords do not match! ");
    ɵngcc0.ɵɵelementEnd();
} }
function CurrentSecurityInfoComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CurrentSecurityInfoComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CurrentSecurityInfoComponent_ng_template_5_tr_22_li_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const role_r10 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", role_r10 == null ? null : role_r10.RoleDisplay, " ");
} }
function CurrentSecurityInfoComponent_ng_template_5_tr_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 13);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td", 14);
    ɵngcc0.ɵɵelementStart(6, "ul");
    ɵngcc0.ɵɵtemplate(7, CurrentSecurityInfoComponent_ng_template_5_tr_22_li_7_Template, 2, 1, "li", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const permission_r8 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", permission_r8.PermissionDisplay, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", permission_r8.PermissionMeaning, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", permission_r8.Roles);
} }
function CurrentSecurityInfoComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_template_5_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.permissionFilterText = $event; })("ngModelChange", function CurrentSecurityInfoComponent_ng_template_5_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.filterPermissions(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 8);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Include Built In");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "dw-yesno", 10);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_template_5_Template_dw_yesno_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.includeBuiltIn = $event; })("ngModelChange", function CurrentSecurityInfoComponent_ng_template_5_Template_dw_yesno_ngModelChange_8_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.filterPermissions(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 7);
    ɵngcc0.ɵɵelementStart(10, "div", 11);
    ɵngcc0.ɵɵelementStart(11, "table", 12);
    ɵngcc0.ɵɵelementStart(12, "thead");
    ɵngcc0.ɵɵelementStart(13, "th", 13);
    ɵngcc0.ɵɵtext(14, " Permission ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "th", 13);
    ɵngcc0.ɵɵtext(16, " Permission Meaning ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(17, "th", 14);
    ɵngcc0.ɵɵtext(18, " Related Roles ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 15);
    ɵngcc0.ɵɵelementStart(20, "table", 12);
    ɵngcc0.ɵɵelementStart(21, "tbody");
    ɵngcc0.ɵɵtemplate(22, CurrentSecurityInfoComponent_ng_template_5_tr_22_Template, 8, 3, "tr", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.permissionFilterText);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.includeBuiltIn);
    ɵngcc0.ɵɵadvance(14);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.filteredPermissions);
} }
function CurrentSecurityInfoComponent_ng_template_7_div_5_tr_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 18);
    ɵngcc0.ɵɵelement(4, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td", 18);
    ɵngcc0.ɵɵelement(6, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "td", 18);
    ɵngcc0.ɵɵelement(8, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "td", 18);
    ɵngcc0.ɵɵelement(10, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r18.ItemName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r18.CanRead);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r18.CanCreate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r18.CanUpdate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r18.CanDelete);
} }
function CurrentSecurityInfoComponent_ng_template_7_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "table", 12);
    ɵngcc0.ɵɵelementStart(2, "thead");
    ɵngcc0.ɵɵelementStart(3, "th", 14);
    ɵngcc0.ɵɵtext(4, " Item ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "th", 17);
    ɵngcc0.ɵɵtext(6, " Can Read ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "th", 17);
    ɵngcc0.ɵɵtext(8, " Can Create ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "th", 17);
    ɵngcc0.ɵɵtext(10, " Can Update ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "th", 17);
    ɵngcc0.ɵɵtext(12, " Can Delete ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 15);
    ɵngcc0.ɵɵelementStart(14, "table", 12);
    ɵngcc0.ɵɵelementStart(15, "tbody");
    ɵngcc0.ɵɵelementStart(16, "tr");
    ɵngcc0.ɵɵelementStart(17, "td", 14);
    ɵngcc0.ɵɵtext(18, " Overall ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "td", 18);
    ɵngcc0.ɵɵelement(20, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "td", 18);
    ɵngcc0.ɵɵelement(22, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "td", 18);
    ɵngcc0.ɵɵelement(24, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "td", 18);
    ɵngcc0.ɵɵelement(26, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(27, CurrentSecurityInfoComponent_ng_template_7_div_5_tr_27_Template, 11, 5, "tr", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(20);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r16.metaDataSecurity.CanReadAny);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r16.metaDataSecurity.CanInsertAny);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r16.metaDataSecurity.CanUpdateAny);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r16.metaDataSecurity.CanDeleteAny);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r16.filteredItems);
} }
function CurrentSecurityInfoComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Search");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_template_7_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.itemFilterText = $event; })("ngModelChange", function CurrentSecurityInfoComponent_ng_template_7_Template_input_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.filterItems(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, CurrentSecurityInfoComponent_ng_template_7_div_5_Template, 28, 5, "div", 6);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.itemFilterText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.metaDataSecurity);
} }
function CurrentSecurityInfoComponent_ng_container_9_div_34_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 22);
    ɵngcc0.ɵɵelement(4, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 22);
    ɵngcc0.ɵɵelement(6, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 22);
    ɵngcc0.ɵɵelement(8, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 22);
    ɵngcc0.ɵɵelement(10, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r23 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r23.ItemName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r23.CanRead);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r23.CanCreate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r23.CanUpdate);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !item_r23.CanDelete);
} }
function CurrentSecurityInfoComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1, " Overall ");
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Can Read Any");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "dw-readonly", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_container_9_Template_dw_readonly_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.metaDataSecurity.CanReadAny = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 8);
    ɵngcc0.ɵɵelementStart(8, "label");
    ɵngcc0.ɵɵtext(9, "Can Create Any");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "dw-readonly", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_container_9_Template_dw_readonly_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.metaDataSecurity.CanCreateAny = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "div", 8);
    ɵngcc0.ɵɵelementStart(12, "label");
    ɵngcc0.ɵɵtext(13, "Can Update Any");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "dw-readonly", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_container_9_Template_dw_readonly_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.metaDataSecurity.CanUpdateAny = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 8);
    ɵngcc0.ɵɵelementStart(16, "label");
    ɵngcc0.ɵɵtext(17, "Can Delete Any");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "dw-readonly", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function CurrentSecurityInfoComponent_ng_container_9_Template_dw_readonly_ngModelChange_18_listener($event) { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.metaDataSecurity.CanDeleteAny = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(19, "div", 7);
    ɵngcc0.ɵɵelementStart(20, "div", 21);
    ɵngcc0.ɵɵtext(21, " Item ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(22, "div", 22);
    ɵngcc0.ɵɵelementStart(23, "label");
    ɵngcc0.ɵɵtext(24, "Can Read");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(25, "div", 22);
    ɵngcc0.ɵɵelementStart(26, "label");
    ɵngcc0.ɵɵtext(27, "Can Create");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(28, "div", 22);
    ɵngcc0.ɵɵelementStart(29, "label");
    ɵngcc0.ɵɵtext(30, "Can Update");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(31, "div", 22);
    ɵngcc0.ɵɵelementStart(32, "label");
    ɵngcc0.ɵɵtext(33, "Can Delete");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(34, CurrentSecurityInfoComponent_ng_container_9_div_34_Template, 11, 5, "div", 23);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.metaDataSecurity.CanReadAny);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.metaDataSecurity.CanCreateAny);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.metaDataSecurity.CanUpdateAny);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.metaDataSecurity.CanDeleteAny);
    ɵngcc0.ɵɵadvance(16);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.metaDataSecurity.Items);
} }
function DwMetaDataHistoryDetailComponent_dw_meta_data_history_list_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-meta-data-history-list", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("itemId", ctx_r0.metaDataHistory.MetaDataItemId)("keyValue", ctx_r0.metaDataHistory.KeyValue);
} }
function DwMetaDataHistoryListComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " These are no changes found for the given time period. ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-meta-data-history-card", 12);
    ɵngcc0.ɵɵlistener("selectCard", function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_1_ng_container_1_Template_dw_meta_data_history_card_selectCard_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(4); return ctx_r10.setSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const historyItem_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("metaDataHistory", historyItem_r9)("isSelected", historyItem_r9.MetaDataHistoryId == (ctx_r8.selectedHistory == null ? null : ctx_r8.selectedHistory.MetaDataHistoryId));
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 10);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_1_ng_container_1_Template, 2, 2, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("selected", ctx_r5.historyGroups.highlightToday);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r5.historyGroups.today);
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-meta-data-history-card", 14);
    ɵngcc0.ɵɵlistener("selectCard", function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_2_ng_container_1_Template_dw_meta_data_history_card_selectCard_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(4); return ctx_r14.setSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const historyItem_r13 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("metaDataHistory", historyItem_r13)("isSelected", historyItem_r13.MetaDataHistoryId == (ctx_r12.selectedHistory == null ? null : ctx_r12.selectedHistory.MetaDataHistoryId));
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 13);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_2_ng_container_1_Template, 2, 2, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("selected", ctx_r6.historyGroups.highlightLastThirty);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.historyGroups.lastThirty);
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-meta-data-history-card", 14);
    ɵngcc0.ɵɵlistener("selectCard", function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_3_ng_container_1_Template_dw_meta_data_history_card_selectCard_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(4); return ctx_r18.setSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const historyItem_r17 = ctx.$implicit;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("metaDataHistory", historyItem_r17)("isSelected", historyItem_r17.MetaDataHistoryId == (ctx_r16.selectedHistory == null ? null : ctx_r16.selectedHistory.MetaDataHistoryId));
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordionTab", 15);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_3_ng_container_1_Template, 2, 2, "ng-container", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("selected", ctx_r7.historyGroups.highlightOlder);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.historyGroups.older);
} }
function DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-accordion", 6);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_1_Template, 2, 2, "p-accordionTab", 7);
    ɵngcc0.ɵɵtemplate(2, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_2_Template, 2, 2, "p-accordionTab", 8);
    ɵngcc0.ɵɵtemplate(3, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_p_accordionTab_3_Template, 2, 2, "p-accordionTab", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.historyGroups.today.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.historyGroups.lastThirty.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.historyGroups.older.length > 0);
} }
function DwMetaDataHistoryListComponent_ng_container_4_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-meta-data-history-card", 14);
    ɵngcc0.ɵɵlistener("selectCard", function DwMetaDataHistoryListComponent_ng_container_4_ng_container_2_ng_container_1_Template_dw_meta_data_history_card_selectCard_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); return ctx_r22.setSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const historyItem_r21 = ctx.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("metaDataHistory", historyItem_r21)("isSelected", historyItem_r21.MetaDataHistoryId == (ctx_r20.selectedHistory == null ? null : ctx_r20.selectedHistory.MetaDataHistoryId));
} }
function DwMetaDataHistoryListComponent_ng_container_4_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryListComponent_ng_container_4_ng_container_2_ng_container_1_Template, 2, 2, "ng-container", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.historyGroups.allHistory);
} }
function DwMetaDataHistoryListComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryListComponent_ng_container_4_p_accordion_1_Template, 4, 3, "p-accordion", 5);
    ɵngcc0.ɵɵtemplate(2, DwMetaDataHistoryListComponent_ng_container_4_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.showGroups);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.showGroups);
} }
function DwMetaDataHistoryListComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelement(2, "dw-meta-data-history-attr-changes", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("metaDataHistory", ctx_r2.selectedHistory);
} }
function DwMetaDataHistoryAttrChangesComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 1);
    ɵngcc0.ɵɵtext(2, " Create ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.isInsert);
} }
function DwMetaDataHistoryAttrChangesComponent_ng_container_1_tr_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attrChange_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !attrChange_r3.NewValueDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attrChange_r3.NewValueDisplay, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !attrChange_r3.PreviousValueDisplay);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attrChange_r3.PreviousValueDisplay, " ");
} }
function DwMetaDataHistoryAttrChangesComponent_ng_container_1_tr_2_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "pre");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵelementStart(5, "pre");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const attrChange_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !attrChange_r3.NewValueDisplay);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(attrChange_r3.NewValueDisplayJSON);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !attrChange_r3.PreviousValueDisplay);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(attrChange_r3.PreviousValueDisplayJSON);
} }
function DwMetaDataHistoryAttrChangesComponent_ng_container_1_tr_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td");
    ɵngcc0.ɵɵtemplate(4, DwMetaDataHistoryAttrChangesComponent_ng_container_1_tr_2_ng_container_4_Template, 5, 4, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(5, DwMetaDataHistoryAttrChangesComponent_ng_container_1_tr_2_ng_container_5_Template, 7, 4, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attrChange_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", attrChange_r3.AttributeDisplay, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !attrChange_r3.IsJSON);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", attrChange_r3.IsJSON);
} }
function DwMetaDataHistoryAttrChangesComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "table", 2);
    ɵngcc0.ɵɵtemplate(2, DwMetaDataHistoryAttrChangesComponent_ng_container_1_tr_2_Template, 6, 3, "tr", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.attributeChanges);
} }
function DwMetaDataHistoryMainComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelement(1, "dw-meta-data-history-list", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.showRelated);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("itemId", ctx_r0.itemId)("keyValue", ctx_r0.keyValue);
} }
function DwMetaDataHistoryMainComponent_div_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " No Related Changes found ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-meta-data-history-summary-card", 17);
    ɵngcc0.ɵɵlistener("selectCard", function DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_ng_container_4_Template_dw_meta_data_history_summary_card_selectCard_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const relatedSummary_r8 = ctx.$implicit; const relatedHistory_r5 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.setSelected(relatedHistory_r5, relatedSummary_r8); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const relatedSummary_r8 = ctx.$implicit;
    const relatedHistory_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("summary", relatedSummary_r8)("isSelected", relatedSummary_r8.KeyValue == (relatedHistory_r5 == null ? null : relatedHistory_r5.selectedHistorySummary == null ? null : relatedHistory_r5.selectedHistorySummary.KeyValue));
} }
function DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelement(1, "dw-meta-data-history-list", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const relatedHistory_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("itemId", relatedHistory_r5.item.MetaDataItemId)("keyValue", relatedHistory_r5.selectedHistorySummary.KeyValue);
} }
function DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵelementStart(2, "div", 13);
    ɵngcc0.ɵɵelementStart(3, "div", 14);
    ɵngcc0.ɵɵtemplate(4, DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_ng_container_4_Template, 2, 2, "ng-container", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_div_5_Template, 2, 2, "div", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const relatedHistory_r5 = ctx.$implicit;
    ɵngcc0.ɵɵpropertyInterpolate("header", relatedHistory_r5.item == null ? null : relatedHistory_r5.item.Display);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", relatedHistory_r5.relatedHistorySummary);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", relatedHistory_r5.selectedHistorySummary);
} }
function DwMetaDataHistoryMainComponent_div_9_p_tabView_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabView");
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryMainComponent_div_9_p_tabView_2_p_tabPanel_1_Template, 6, 3, "p-tabPanel", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.relatedHistory);
} }
function DwMetaDataHistoryMainComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryMainComponent_div_9_div_1_Template, 2, 0, "div", 7);
    ɵngcc0.ɵɵtemplate(2, DwMetaDataHistoryMainComponent_div_9_p_tabView_2_Template, 2, 1, "p-tabView", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.relatedHistory.length == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.relatedHistory.length > 0);
} }
const _c94 = function (a0) { return { "history-card-selected": a0 }; };
function DwFeatureAreaDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-feature-area-grid", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("featureAreaDetails", ctx_r0.featureAreaDetails)("featureAreaDetailGroup", ctx_r0.featureAreaDetailGroup);
} }
const _c95 = function (a0) { return { "group-item-selected": a0 }; };
function DwFeatureAreaDetailGroupSelectorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("click", function DwFeatureAreaDetailGroupSelectorComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const group_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectItem(group_r1); });
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c95, group_r1.FeatureAreaDetailGroupId == ctx_r0.selectedGroupId));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", group_r1.IconClass);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", group_r1.DetailGroupDisplay, " ");
} }
function DwFeatureAreaGridComponent_p_tabView_0_p_tabPanel_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 3);
    ɵngcc0.ɵɵelement(1, "dw-meta-data-grid", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const gridTab_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("header", gridTab_r2.display);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", gridTab_r2.itemName)("configKeyPart", gridTab_r2.configKeyPart)("gridCallbacks", ctx_r1.gridCallbacks)("filters", gridTab_r2.filters);
} }
function DwFeatureAreaGridComponent_p_tabView_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabView", 1);
    ɵngcc0.ɵɵlistener("activeIndexChange", function DwFeatureAreaGridComponent_p_tabView_0_Template_p_tabView_activeIndexChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.tabIndex = $event; });
    ɵngcc0.ɵɵtemplate(1, DwFeatureAreaGridComponent_p_tabView_0_p_tabPanel_1_Template, 2, 5, "p-tabPanel", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("activeIndex", ctx_r0.tabIndex);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.gridTabs);
} }
function DwFaAddDetailModalComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-multi-select-lookup", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFaAddDetailModalComponent_div_12_Template_dw_multi_select_lookup_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.selectedItems = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Choose ", ctx_r0.selectedType == null ? null : ctx_r0.selectedType.DwMetaDataItem == null ? null : ctx_r0.selectedType.DwMetaDataItem.Display, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.lookupDef.MetaDataLookupId)("overrideValues", ctx_r0.lookupItems)("ngModel", ctx_r0.selectedItems);
} }
function DwFaAddDetailModalComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "button", 12);
    ɵngcc0.ɵɵlistener("click", function DwFaAddDetailModalComponent_div_13_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.addFeatureDetails(); });
    ɵngcc0.ɵɵtext(3, "Add Items");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.selectedItems.length == 0);
} }
function DwFaAddDetailModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.alreadyAddedList == null ? null : ctx_r2.alreadyAddedList.length, " items already existed and were not added ");
} }
function DwFaAddDetailModalComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelement(2, "hr");
    ɵngcc0.ɵɵelementStart(3, "dw-fa-detail-view", 13);
    ɵngcc0.ɵɵlistener("featureAreaDetailsChange", function DwFaAddDetailModalComponent_div_15_Template_dw_fa_detail_view_featureAreaDetailsChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.addDetailResult.newFeatureAreaDetails = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("featureAreaDetails", ctx_r3.addDetailResult.newFeatureAreaDetails);
} }
const _c96 = function (a0) { return { FeatureAreaDetailGroupId: a0 }; };
function DwFaDetailViewComponent_ng_container_3_div_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "div", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵlistener("click", function DwFaDetailViewComponent_ng_container_3_div_1_ng_container_4_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r7); const areaDetail_r5 = ctx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.removeItem(ctx_r6.displayDetails, areaDetail_r5); });
    ɵngcc0.ɵɵelement(5, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const areaDetail_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(areaDetail_r5.ReferenceDisplay);
} }
function DwFaDetailViewComponent_ng_container_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "h2");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵtemplate(4, DwFaDetailViewComponent_ng_container_3_div_1_ng_container_4_Template, 6, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const displayDetail_r3 = ctx.$implicit;
    const displayGroup_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", displayGroup_r1.group.DetailGroupDisplay, " - ", displayDetail_r3.detail.DetailTypeDisplay, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", displayDetail_r3.areaDetails);
} }
function DwFaDetailViewComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwFaDetailViewComponent_ng_container_3_div_1_Template, 5, 3, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const displayGroup_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", displayGroup_r1.details);
} }
function DwMetaDataItemControlComponent_label_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 3);
    ɵngcc0.ɵɵelementStart(1, "input", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMetaDataItemControlComponent_label_1_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.limitToFeature = $event; })("ngModelChange", function DwMetaDataItemControlComponent_label_1_Template_input_ngModelChange_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.toggleLimitToFeature(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(2, " Limit to Feature");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.limitToFeature)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(2, _c4));
} }
function DwItemTemplateControlComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwItemTemplateControlComponent_div_13_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const field_r3 = ctx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.ApendAttribute(field_r3.AttributeName); });
    ɵngcc0.ɵɵelement(2, "i", 14);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", field_r3.AttributeDisplay, " ");
} }
function DwFaPublishModalComponent_ng_container_5_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "label", 2);
    ɵngcc0.ɵɵtext(3, "Feature Areas");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-multi-select-lookup", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFaPublishModalComponent_ng_container_5_div_6_Template_dw_multi_select_lookup_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(2); return ctx_r3.publishRequest.featureAreaIds = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.publishRequest.featureAreaIds)("lookupId", ctx_r2.featureAreasLookupId);
} }
function DwFaPublishModalComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "label", 2);
    ɵngcc0.ɵɵtext(4, "Item Selection");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "dw-radio-lookup", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFaPublishModalComponent_ng_container_5_Template_dw_radio_lookup_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.publishRequest.itemSelection = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwFaPublishModalComponent_ng_container_5_div_6_Template, 5, 2, "div", 5);
    ɵngcc0.ɵɵelement(7, "dw-message", 6);
    ɵngcc0.ɵɵelementStart(8, "dw-button-bar");
    ɵngcc0.ɵɵelementStart(9, "button", 7);
    ɵngcc0.ɵɵlistener("click", function DwFaPublishModalComponent_ng_container_5_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.exportToFile(); });
    ɵngcc0.ɵɵtext(10, "Export");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "dw-loading", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.publishRequest.itemSelection)("overrideValues", ctx_r0.itemSelections);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.publishRequest.itemSelection == ctx_r0.DwFaItemSelection.featureAreas);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("message", ctx_r0.message);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("enabled", !ctx_r0.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("show", ctx_r0.processing)("text", ctx_r0.processingMessage || "Processing...");
} }
function DwFaPublishModalComponent_ng_container_6_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 0);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "label", 2);
    ɵngcc0.ɵɵtext(4, "Archive Info");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "span", 14);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "dwDate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 0);
    ɵngcc0.ɵɵelementStart(9, "div", 1);
    ɵngcc0.ɵɵelementStart(10, "label", 2);
    ɵngcc0.ɵɵtext(11, "Feature Areas");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "dw-multi-select-lookup", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwFaPublishModalComponent_ng_container_6_ng_container_6_Template_dw_multi_select_lookup_ngModelChange_12_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.publishRequest.featureAreaIds = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate2(" Created By: ", ctx_r8.exportArchiveResult.ArchiveInfo == null ? null : ctx_r8.exportArchiveResult.ArchiveInfo.CreatedByUser == null ? null : ctx_r8.exportArchiveResult.ArchiveInfo.CreatedByUser.FirstNameLastName, " @ ", ɵngcc0.ɵɵpipeBind1(7, 4, ctx_r8.exportArchiveResult.ArchiveInfo == null ? null : ctx_r8.exportArchiveResult.ArchiveInfo.CreatedDateTime), " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.publishRequest.featureAreaIds)("overrideValues", ctx_r8.exportArchiveGroupList);
} }
function DwFaPublishModalComponent_ng_container_6_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelement(3, "dw-export-compare-result-viewer", 16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r9.exportArchiveResult);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("importResults", ctx_r9.importResults);
} }
function DwFaPublishModalComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 10);
    ɵngcc0.ɵɵelementStart(2, "div", 1);
    ɵngcc0.ɵɵelementStart(3, "label", 2);
    ɵngcc0.ɵɵtext(4, "Devware Archive File");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "dw-file-upload", 11);
    ɵngcc0.ɵɵlistener("filesSelected", function DwFaPublishModalComponent_ng_container_6_Template_dw_file_upload_filesSelected_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.fileSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, DwFaPublishModalComponent_ng_container_6_ng_container_6_Template, 13, 6, "ng-container", 4);
    ɵngcc0.ɵɵtemplate(7, DwFaPublishModalComponent_ng_container_6_ng_container_7_Template, 4, 2, "ng-container", 4);
    ɵngcc0.ɵɵelement(8, "dw-message", 6);
    ɵngcc0.ɵɵelementStart(9, "dw-button-bar", 12);
    ɵngcc0.ɵɵelementStart(10, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwFaPublishModalComponent_ng_container_6_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.importFromFile(true); });
    ɵngcc0.ɵɵtext(11, "Compare ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwFaPublishModalComponent_ng_container_6_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.importFromFile(false); });
    ɵngcc0.ɵɵtext(13, "Import");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "button", 13);
    ɵngcc0.ɵɵlistener("click", function DwFaPublishModalComponent_ng_container_6_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.importFromFile(false); });
    ɵngcc0.ɵɵtext(15, "Import Changes");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(16, "dw-loading", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.exportArchiveResult);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.exportArchiveResult && !ctx_r1.importResults);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.importResults && ctx_r1.changeCount > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("message", ctx_r1.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.allComplete || ctx_r1.changeCount == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.importResults)("enabled", !ctx_r1.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.importResults)("enabled", !ctx_r1.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.importResults)("enabled", !ctx_r1.processing);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("show", ctx_r1.processing)("text", ctx_r1.processingMessage || "Processing...");
} }
function DwExportCompareResultViewerComponent_tr_23_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "tr", 6);
    ɵngcc0.ɵɵlistener("click", function DwExportCompareResultViewerComponent_tr_23_Template_tr_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const itemResult_r2 = ctx.$implicit; const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.selectRow(itemResult_r2); });
    ɵngcc0.ɵɵelementStart(1, "td", 1);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "td", 2);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "td", 2);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "td", 2);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "td", 2);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "td", 2);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "td", 2);
    ɵngcc0.ɵɵtext(14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const itemResult_r2 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !((itemResult_r2.RowChanges == null ? null : itemResult_r2.RowChanges.length) > 0) && !ctx_r0.showAllItems);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.ItemName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.RowChanges == null ? null : itemResult_r2.RowChanges.length, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.SourceRows, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.DestRows, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.Inserts, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.Updates, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", itemResult_r2.Deletes, " ");
} }
function DwExportCompareResultViewerComponent_div_24_th_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r7 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r7, " ");
} }
function DwExportCompareResultViewerComponent_div_24_tr_11_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "i", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r10 = ctx.$implicit;
    const rowChangeModel_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", rowChangeModel_r8.attrChanges[attr_r10] == null ? null : rowChangeModel_r8.attrChanges[attr_r10].PreviousValue, " -> ", rowChangeModel_r8.attrChanges[attr_r10] == null ? null : rowChangeModel_r8.attrChanges[attr_r10].NewValue, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(rowChangeModel_r8.attrChanges[attr_r10] == null ? null : rowChangeModel_r8.attrChanges[attr_r10].Errors == null ? null : rowChangeModel_r8.attrChanges[attr_r10].Errors.length) > 0)("title", rowChangeModel_r8.attrChanges[attr_r10] == null ? null : rowChangeModel_r8.attrChanges[attr_r10].Errors[0]);
} }
function DwExportCompareResultViewerComponent_div_24_tr_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, DwExportCompareResultViewerComponent_div_24_tr_11_td_3_Template, 3, 4, "td", 8);
    ɵngcc0.ɵɵelementStart(4, "td", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const rowChangeModel_r8 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(rowChangeModel_r8.keyValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r6.itemRowChanges.attributeList);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", rowChangeModel_r8.rowChange.SaveType, " ");
} }
function DwExportCompareResultViewerComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "table", 0);
    ɵngcc0.ɵɵelementStart(2, "thead");
    ɵngcc0.ɵɵelementStart(3, "th", 7);
    ɵngcc0.ɵɵtext(4, "Key Value");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, DwExportCompareResultViewerComponent_div_24_th_5_Template, 2, 1, "th", 8);
    ɵngcc0.ɵɵelementStart(6, "th", 7);
    ɵngcc0.ɵɵtext(7, " Save Type ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 3);
    ɵngcc0.ɵɵelementStart(9, "table", 0);
    ɵngcc0.ɵɵelementStart(10, "tbody");
    ɵngcc0.ɵɵtemplate(11, DwExportCompareResultViewerComponent_div_24_tr_11_Template, 6, 3, "tr", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemRowChanges.attributeList);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemRowChanges.rowChanges);
} }
const _c97 = ["fileSingle"];
const _c98 = ["fileMultiple"];
function DwImageResizerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "i", 4);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.cropper.zoomIn(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "i", 5);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.cropper.zoomOut(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "i", 6);
    ɵngcc0.ɵɵelementStart(4, "i", 7);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.rotate(-90); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.rotate(90); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "i", 6);
    ɵngcc0.ɵɵelementStart(7, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.cropper.fit(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "i", 10);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.cropper.center(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "i", 11);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.cropper.fitToScreen(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "i", 12);
    ɵngcc0.ɵɵlistener("click", function DwImageResizerComponent_div_1_Template_i_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.cropper.setScale(1); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwFileUploadModalComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.fileUploadOptions == null ? null : ctx_r0.fileUploadOptions.mediaSelectOptions == null ? null : ctx_r0.fileUploadOptions.mediaSelectOptions.uploadInstructions, "\n");
} }
function DwFileUploadModalComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "dw-file-upload", 7);
    ɵngcc0.ɵɵlistener("filesSelected", function DwFileUploadModalComponent_div_2_Template_dw_file_upload_filesSelected_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.filesSelected($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("allowedFileTypes", ctx_r1.fileUploadOptions.mediaSelectOptions.allowedFileTypes)("allowMultiple", ctx_r1.fileUploadOptions.allowMultiple);
} }
function DwFileUploadModalComponent_div_4_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fileDetail_r6 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", fileDetail_r6.errorMessage, " ");
} }
const _c99 = function () { return { "height": "4px" }; };
function DwFileUploadModalComponent_div_4_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "p-progressBar", 20);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r7 = ɵngcc0.ɵɵnextContext().index;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(3, _c99));
    ɵngcc0.ɵɵproperty("value", ctx_r9.uploadResults[i_r7] == null ? null : ctx_r9.uploadResults[i_r7].percentComplete);
} }
function DwFileUploadModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelement(2, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 12);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "filesize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 13);
    ɵngcc0.ɵɵelementStart(9, "i", 14);
    ɵngcc0.ɵɵlistener("click", function DwFileUploadModalComponent_div_4_Template_i_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r13); const fileDetail_r6 = ctx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.cancelFile(fileDetail_r6); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "i", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(11, DwFileUploadModalComponent_div_4_div_11_Template, 2, 1, "div", 16);
    ɵngcc0.ɵɵtemplate(12, DwFileUploadModalComponent_div_4_div_12_Template, 2, 4, "div", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const fileDetail_r6 = ctx.$implicit;
    const i_r7 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", fileDetail_r6.cancelled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", fileDetail_r6.fileIconCss);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("title", fileDetail_r6.file.name);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", fileDetail_r6.file.name, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(7, 9, fileDetail_r6.file.size), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", ctx_r2.uploadResults[i_r7] == null ? null : ctx_r2.uploadResults[i_r7].isComplete);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r2.uploadResults[i_r7] == null ? null : ctx_r2.uploadResults[i_r7].isComplete));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", fileDetail_r6.errorMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.uploadResults[i_r7]);
} }
function DwFileUploadModalComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 21);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵelementStart(3, "dw-image-resizer", 22);
    ɵngcc0.ɵɵlistener("imageResized", function DwFileUploadModalComponent_ng_container_5_Template_dw_image_resizer_imageResized_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.setResizedImage(ctx_r14.fileDetails[0], $event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("sourceImage", ctx_r3.fileDetails[0].file)("options", ctx_r3.fileUploadOptions == null ? null : ctx_r3.fileUploadOptions.mediaSelectOptions == null ? null : ctx_r3.fileUploadOptions.mediaSelectOptions.imageResizeOptions);
} }
function DwMediaItemComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r0.containerStyle)("ngClass", ctx_r0.mediaClass);
} }
function DwMediaItemComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "img", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r1.mediaUrl, ɵngcc0.ɵɵsanitizeUrl)("ngStyle", ctx_r1.mediaStyle);
} }
function DwAvatarBannerConfigComponent_div_12_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r5.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r5.FkItemName, " (By ", item_r5.FkAttributeName, ") ");
} }
function DwAvatarBannerConfigComponent_div_12_option_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r6.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r6.FkItemName, " (By ", item_r6.FkAttributeName, ") ");
} }
function DwAvatarBannerConfigComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Avatar Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_div_12_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.setAvatarRelationship($event); });
    ɵngcc0.ɵɵtemplate(5, DwAvatarBannerConfigComponent_div_12_option_5_Template, 2, 3, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Banner Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "select", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_div_12_Template_select_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.setBannerRelationship($event); });
    ɵngcc0.ɵɵtemplate(10, DwAvatarBannerConfigComponent_div_12_option_10_Template, 2, 3, "option", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section == null ? null : ctx_r0.section.avatarRelationshipInfo == null ? null : ctx_r0.section.avatarRelationshipInfo.relationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.availableRelations);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.bannerRelationshipInfo == null ? null : ctx_r0.section.bannerRelationshipInfo.relationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.availableRelations);
} }
function DwAvatarBannerConfigComponent_option_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r10.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r10.AttributeName, " ");
} }
function DwAvatarBannerConfigComponent_option_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r11.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r11.AttributeName, " ");
} }
function DwAvatarBannerComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵlistener("click", function DwAvatarBannerComponent_div_9_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.toggleEdit(); });
    ɵngcc0.ɵɵelement(1, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} }
function DwAvatarBannerComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵlistener("click", function DwAvatarBannerComponent_div_10_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.clearImages(); });
    ɵngcc0.ɵɵelement(1, "i", 14);
    ɵngcc0.ɵɵelementEnd();
} }
function DwAvatarBannerComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelement(1, "dw-dynamic-section", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r2.formConfig)("sectionConfig", ctx_r2.buttonBarSection)("formGroup", ctx_r2.formGroup)("context", ctx_r2.context)("submitted", ctx_r2.submitted)("parentIsVisible", ctx_r2.visible);
} }
function DwMediaSelectorComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("click", function DwMediaSelectorComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectFiles(); })("fileDrop", function DwMediaSelectorComponent_div_1_Template_div_fileDrop_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.selectFiles($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelement(2, "i", 5);
    ɵngcc0.ɵɵelement(3, "br");
    ɵngcc0.ɵɵelementStart(4, "span", 6);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.selectorClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showSelectorText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.selectorIcon);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.selectorText);
} }
function DwImageSectionConfigComponent_option_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 19);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r8.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r8.AttributeName, " ");
} }
function DwImageSectionConfigComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Show Image Only ");
    ɵngcc0.ɵɵelement(3, "i", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "dw-yesno", 7);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_div_18_Template_dw_yesno_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.section.showImageOnly = $event; })("ngModelChange", function DwImageSectionConfigComponent_div_18_Template_dw_yesno_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.section.showImageOnly);
} }
function DwImageSectionConfigComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Image Class");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_div_24_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.section.imageMediaClass = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.section.imageMediaClass);
} }
function DwImageSectionConfigComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Allowed File Types");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-multi-select-adhoc-lookup", 21);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_div_26_Template_dw_multi_select_adhoc_lookup_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.section.allowedFileTypes = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.section.allowedFileTypes)("lookupId", ctx_r3.fileExtensionsLookup);
} }
function DwImageSectionConfigComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Max Width");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "input", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_div_36_Template_input_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.section.maxWidth = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 2);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Max Height");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "input", 22);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_div_36_Template_input_ngModelChange_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.section.maxHeight = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.section.maxWidth);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.section.maxHeight);
} }
function DwImageSectionConfigComponent_div_49_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", 23);
    ɵngcc0.ɵɵelement(2, "i", 24);
    ɵngcc0.ɵɵtext(3, " Media Security Setup Complete! ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 23);
    ɵngcc0.ɵɵelement(5, "i", 25);
    ɵngcc0.ɵɵtext(6, " Secure images require a configuration record in Media Security. ");
    ɵngcc0.ɵɵelementStart(7, "a", 26);
    ɵngcc0.ɵɵtext(8, "Add Media Security");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "br");
    ɵngcc0.ɵɵelement(10, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r5.currentMediaSecurity);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", ctx_r5.currentMediaSecurity);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r5.addMediaSecurityLink, ɵngcc0.ɵɵsanitizeUrl);
} }
function DwImageSectionConfigComponent_ng_container_50_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2, "Media Security Details");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "View All Permission");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "dw-readonly", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Allow Emulation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "dw-readonly", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 1);
    ɵngcc0.ɵɵelementStart(13, "div", 2);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Check Parent Table ");
    ɵngcc0.ɵɵelement(16, "i", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "dw-readonly", 28);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.currentMediaSecurity.ViewAllPermissionMeaning);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.currentMediaSecurity.AllowEmulation);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.currentMediaSecurity.CheckParentTable);
} }
function DwImageSectionConfigComponent_p_tabPanel_51_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p-tabPanel", 30);
    ɵngcc0.ɵɵelementStart(1, "dw-field-validation-config", 31);
    ɵngcc0.ɵɵlistener("configChange", function DwImageSectionConfigComponent_p_tabPanel_51_Template_dw_field_validation_config_configChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.section.validationConfig = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("config", ctx_r7.section.validationConfig)("configContext", ctx_r7.metaDataConfigContext);
} }
function DwImageSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Image/File section has an invalid configuration. (", ctx_r0.invalidConfigurationMessage, ")");
} }
function DwImageSectionComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelement(2, "dw-media-item", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("media", ctx_r2.imageMediaExt)("sizeOptions", ctx_r2.imageMediaImageSize)("isSecure", ctx_r2.sectionConfig.isSecure)("parentItemName", ctx_r2.formConfig.rootItemName)("parentAttributeName", ctx_r2.sectionConfig.imageMediaIdAttrName)("mediaClass", ctx_r2.sectionConfig == null ? null : ctx_r2.sectionConfig.imageMediaClass);
} }
function DwImageSectionComponent_ng_container_1_ng_container_2_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "span", 12);
    ɵngcc0.ɵɵtext(3, "\u00A0*");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r4.sectionConfig.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r4.isRequired || ctx_r4.isReadOnly);
} }
function DwImageSectionComponent_ng_container_1_ng_container_2_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-media-item-card", 13);
    ɵngcc0.ɵɵlistener("removeMedia", function DwImageSectionComponent_ng_container_1_ng_container_2_ng_container_4_Template_dw_media_item_card_removeMedia_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.clearImages(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("media", ctx_r5.imageMediaExt)("isSecure", ctx_r5.sectionConfig.isSecure)("parentItemName", ctx_r5.formConfig.rootItemName)("showSize", ctx_r5.sectionConfig.showSize)("parentAttributeName", ctx_r5.sectionConfig.imageMediaIdAttrName)("disabled", ctx_r5.isReadOnly);
} }
function DwImageSectionComponent_ng_container_1_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r6.sectionConfig.noFileTextOverride || "None", " ");
} }
function DwImageSectionComponent_ng_container_1_ng_container_2_dw_media_selector_6_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-media-selector", 14);
    ɵngcc0.ɵɵlistener("mediaChange", function DwImageSectionComponent_ng_container_1_ng_container_2_dw_media_selector_6_Template_dw_media_selector_mediaChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.setImageMedia($event); });
    ɵngcc0.ɵɵelementStart(1, "div", 15);
    ɵngcc0.ɵɵelementStart(2, "div", 16);
    ɵngcc0.ɵɵlistener("click", function DwImageSectionComponent_ng_container_1_ng_container_2_dw_media_selector_6_Template_div_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(3); return ctx_r13.selectFiles(); })("fileDrop", function DwImageSectionComponent_ng_container_1_ng_container_2_dw_media_selector_6_Template_div_fileDrop_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.selectFiles($event); });
    ɵngcc0.ɵɵelementStart(3, "div");
    ɵngcc0.ɵɵelement(4, "i", 17);
    ɵngcc0.ɵɵtext(5, " Click here or drag files to upload");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r7.isReadOnly)("allowedFileTypes", ctx_r7.allowedFileTypes)("media", ctx_r7.imageMedia)("resizeOptions", ctx_r7.imageMediaImageReSize)("isSecure", ctx_r7.sectionConfig.isSecure)("parentItemName", ctx_r7.formConfig.rootItemName)("showFileSelectorFirst", ctx_r7.sectionConfig.showFileSelectorFirst)("parentAttributeName", ctx_r7.sectionConfig.imageMediaIdAttrName)("uploadInstructions", ctx_r7.sectionConfig.uploadInstructions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r7.loading || ctx_r7.isReadOnly);
} }
function DwImageSectionComponent_ng_container_1_ng_container_2_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelement(1, "dw-validation-info", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r8.formGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r8.sectionConfig == null ? null : ctx_r8.sectionConfig.imageMediaIdAttrName)("submitted", ctx_r8.submitted);
} }
function DwImageSectionComponent_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwImageSectionComponent_ng_container_1_ng_container_2_label_1_Template, 4, 2, "label", 7);
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵelement(3, "dw-loading", 8);
    ɵngcc0.ɵɵtemplate(4, DwImageSectionComponent_ng_container_1_ng_container_2_ng_container_4_Template, 2, 6, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(5, DwImageSectionComponent_ng_container_1_ng_container_2_div_5_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵtemplate(6, DwImageSectionComponent_ng_container_1_ng_container_2_dw_media_selector_6_Template, 6, 10, "dw-media-selector", 9);
    ɵngcc0.ɵɵtemplate(7, DwImageSectionComponent_ng_container_1_ng_container_2_div_7_Template, 2, 3, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.sectionConfig == null ? null : ctx_r3.sectionConfig.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("show", ctx_r3.loadingMedia);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.imageMediaExt);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.loading && !ctx_r3.imageMediaExt && ctx_r3.isReadOnly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.imageMedia && !ctx_r3.isReadOnly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.formGroup && ctx_r3.formControlSetup);
} }
function DwImageSectionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwImageSectionComponent_ng_container_1_ng_container_1_Template, 3, 6, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(2, DwImageSectionComponent_ng_container_1_ng_container_2_Template, 8, 6, "ng-container", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.showImageOnly);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.showImageOnly));
} }
function DwMultiFileSectionConfigComponent_div_8_div_1_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextName_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", contextName_r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r9.contextMdList[contextName_r10].contextDef.contextDisplay, " ");
} }
function DwMultiFileSectionConfigComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Context");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_8_div_1_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.section.contextName = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_div_8_div_1_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.setContextDef(); });
    ɵngcc0.ɵɵtemplate(4, DwMultiFileSectionConfigComponent_div_8_div_1_option_4_Template, 2, 2, "option", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.section.contextName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.contextNames);
} }
function DwMultiFileSectionConfigComponent_div_8_div_2_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r15.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r15.AttributeName, " ");
} }
function DwMultiFileSectionConfigComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Media Group Attribute (Context)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_8_div_2_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.section.imageMediaGroupIdAttrName = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_div_8_div_2_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(4, DwMultiFileSectionConfigComponent_div_8_div_2_option_4_Template, 2, 2, "option", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.section.imageMediaGroupIdAttrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.currentContextMd == null ? null : ctx_r8.currentContextMd.attributes);
} }
function DwMultiFileSectionConfigComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, DwMultiFileSectionConfigComponent_div_8_div_1_Template, 5, 2, "div", 8);
    ɵngcc0.ɵɵtemplate(2, DwMultiFileSectionConfigComponent_div_8_div_2_Template, 5, 2, "div", 8);
    ɵngcc0.ɵɵelementStart(3, "div", 2);
    ɵngcc0.ɵɵelementStart(4, "label");
    ɵngcc0.ɵɵtext(5, "Label");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "input", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_8_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.section.label = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.section.useContext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.currentContextMd);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section.label);
} }
function DwMultiFileSectionConfigComponent_div_9_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r22 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r22.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r22.AttributeName, " ");
} }
function DwMultiFileSectionConfigComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Media Group Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 14);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_9_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.section.imageMediaGroupIdAttrName = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_div_9_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(); return ctx_r25.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(5, DwMultiFileSectionConfigComponent_div_9_option_5_Template, 2, 2, "option", 15);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Label");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "input", 11);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_9_Template_input_ngModelChange_9_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.section.label = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.section.imageMediaGroupIdAttrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.itemMetaData == null ? null : ctx_r1.itemMetaData.Attributes);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.section.label);
} }
function DwMultiFileSectionConfigComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Allowed File Types");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "dw-multi-select-adhoc-lookup", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_25_Template_dw_multi_select_adhoc_lookup_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r28); const ctx_r27 = ɵngcc0.ɵɵnextContext(); return ctx_r27.section.allowedFileTypes = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.section.allowedFileTypes)("lookupId", ctx_r2.fileExtensionsLookup);
} }
function DwMultiFileSectionConfigComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Images per Row - Large ");
    ɵngcc0.ɵɵelement(4, "i", 18);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_26_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.section.multiFileOptions.imagesPerRowLarge = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 2);
    ɵngcc0.ɵɵelementStart(7, "label");
    ɵngcc0.ɵɵtext(8, "Images per Row - Medium ");
    ɵngcc0.ɵɵelement(9, "i", 19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_26_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(); return ctx_r31.section.multiFileOptions.imagesPerRowMedium = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.section.multiFileOptions.imagesPerRowLarge);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.section.multiFileOptions.imagesPerRowMedium);
} }
function DwMultiFileSectionConfigComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Image Aspect Ratio ");
    ɵngcc0.ɵɵelement(4, "i", 20);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "input", 6);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_div_27_Template_input_ngModelChange_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.section.multiFileOptions.imageAspectRatio = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.section.multiFileOptions.imageAspectRatio);
} }
function DwMultiFileSectionConfigComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "span", 21);
    ɵngcc0.ɵɵelement(2, "i", 22);
    ɵngcc0.ɵɵtext(3, " Media Security Setup Complete! ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 21);
    ɵngcc0.ɵɵelement(5, "i", 23);
    ɵngcc0.ɵɵtext(6, " Secure files require a configuration record in Media Security. ");
    ɵngcc0.ɵɵelementStart(7, "a", 24);
    ɵngcc0.ɵɵtext(8, "Add Media Security");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "br");
    ɵngcc0.ɵɵelement(10, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r5.currentMediaSecurity);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("hidden", ctx_r5.currentMediaSecurity);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r5.addMediaSecurityLink, ɵngcc0.ɵɵsanitizeUrl);
} }
function DwMultiFileSectionConfigComponent_ng_container_41_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "b");
    ɵngcc0.ɵɵtext(2, "Media Security Details");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 1);
    ɵngcc0.ɵɵelementStart(4, "div", 2);
    ɵngcc0.ɵɵelementStart(5, "label");
    ɵngcc0.ɵɵtext(6, "View All Permission");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "dw-readonly", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 2);
    ɵngcc0.ɵɵelementStart(9, "label");
    ɵngcc0.ɵɵtext(10, "Allow Emulation");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(11, "dw-readonly", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "div", 1);
    ɵngcc0.ɵɵelementStart(13, "div", 2);
    ɵngcc0.ɵɵelementStart(14, "label");
    ɵngcc0.ɵɵtext(15, "Check Parent Table ");
    ɵngcc0.ɵɵelement(16, "i", 27);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "dw-readonly", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.currentMediaSecurity.ViewAllPermissionMeaning);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.currentMediaSecurity.AllowEmulation);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r6.currentMediaSecurity.CheckParentTable);
} }
function DwMultiFileSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelement(1, "i", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("Multi-File section has an invalid configuration. (", ctx_r0.invalidConfigurationMessage, ")");
} }
function DwMultiFileSectionComponent_ng_container_1_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.sectionConfig.label);
} }
function DwMultiFileSectionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMultiFileSectionComponent_ng_container_1_label_1_Template, 2, 1, "label", 5);
    ɵngcc0.ɵɵelementStart(2, "dw-multi-file", 6);
    ɵngcc0.ɵɵlistener("mediaGroupIdChange", function DwMultiFileSectionComponent_ng_container_1_Template_dw_multi_file_mediaGroupIdChange_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.setMediaGroupId($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("mediaGroupId", ctx_r1.mediaGroupId)("disabled", ctx_r1.isReadOnly)("mediaSelectOptions", ctx_r1.mediaSelectOptions)("multiFileOptions", ctx_r1.sectionConfig == null ? null : ctx_r1.sectionConfig.multiFileOptions)("showFileSelectorFirst", ctx_r1.sectionConfig.showFileSelectorFirst);
} }
function DwMultiFileComponent_div_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_1_button_2_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.selectFiles(); });
    ɵngcc0.ɵɵtext(1, "Add Files");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMultiFileComponent_div_1_div_8_label_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 20);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_1_div_8_label_4_Template_label_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(3); return ctx_r12.setMode("gallery"); });
    ɵngcc0.ɵɵelement(1, "i", 24);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c82, ctx_r11.mode == "gallery"));
} }
function DwMultiFileComponent_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "label", 20);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_1_div_8_Template_label_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.setMode("images"); });
    ɵngcc0.ɵɵelement(3, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(4, DwMultiFileComponent_div_1_div_8_label_4_Template, 2, 3, "label", 22);
    ɵngcc0.ɵɵelementStart(5, "label", 20);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_1_div_8_Template_label_click_5_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.setMode("list"); });
    ɵngcc0.ɵɵelement(6, "i", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c82, ctx_r8.mode == "images"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c82, ctx_r8.mode == "list"));
} }
function DwMultiFileComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, DwMultiFileComponent_div_1_button_2_Template, 2, 0, "button", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵelementStart(4, "div", 14);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_1_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.selectFiles(); })("fileDrop", function DwMultiFileComponent_div_1_Template_div_fileDrop_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.selectFiles($event); });
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵelement(6, "i", 15);
    ɵngcc0.ɵɵtext(7, " Click here or drag files to upload");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, DwMultiFileComponent_div_1_div_8_Template, 7, 7, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.disabled);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showViewToggle);
} }
function DwMultiFileComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelementStart(1, "div", 14);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_2_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.selectFiles(); })("fileDrop", function DwMultiFileComponent_div_2_Template_div_fileDrop_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.selectFiles($event); });
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵelement(3, "i", 15);
    ɵngcc0.ɵɵtext(4, " Click here or drag files to upload");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.loading);
} }
function DwMultiFileComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1, " There are no files ");
    ɵngcc0.ɵɵelementEnd();
} }
function DwMultiFileComponent_div_6_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r26 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "dw-media-item-card", 28);
    ɵngcc0.ɵɵlistener("removeMedia", function DwMultiFileComponent_div_6_ng_container_1_Template_dw_media_item_card_removeMedia_1_listener() { ɵngcc0.ɵɵrestoreView(_r26); const media_r24 = ctx.$implicit; const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.removeMedia(media_r24); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const media_r24 = ctx.$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("media", media_r24)("disabled", ctx_r23.disabled)("isSecureGroup", true)("isSecure", ctx_r23.mediaSelectOptions.isSecure)("parentItemName", ctx_r23.mediaSelectOptions.parentItemName)("parentAttributeName", ctx_r23.mediaSelectOptions.parentAttributeName);
} }
function DwMultiFileComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 26);
    ɵngcc0.ɵɵtemplate(1, DwMultiFileComponent_div_6_ng_container_1_Template, 2, 6, "ng-container", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.currentMediaItems);
} }
function DwMultiFileComponent_div_7_ng_container_1_div_1_i_3_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 35);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_7_ng_container_1_div_1_i_3_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r33); const media_r28 = ɵngcc0.ɵɵnextContext(2).$implicit; const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.removeMedia(media_r28); });
    ɵngcc0.ɵɵelementEnd();
} }
function DwMultiFileComponent_div_7_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 31);
    ɵngcc0.ɵɵelementStart(1, "img", 32);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_div_7_ng_container_1_div_1_Template_img_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r36); const media_r28 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r34 = ɵngcc0.ɵɵnextContext(2); return ctx_r34.openGallery(media_r28); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "div", 33);
    ɵngcc0.ɵɵtemplate(3, DwMultiFileComponent_div_7_ng_container_1_div_1_i_3_Template, 1, 0, "i", 34);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const media_r28 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r29 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("name", media_r28 == null ? null : media_r28.MediaName)("ngStyle", ctx_r29.mediaItemStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ctx_r29.getMediaStyle(media_r28));
    ɵngcc0.ɵɵproperty("src", media_r28.MediumImageUrl, ɵngcc0.ɵɵsanitizeUrl)("alt", media_r28 == null ? null : media_r28.MediaName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r29.disabled && false);
} }
function DwMultiFileComponent_div_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwMultiFileComponent_div_7_ng_container_1_div_1_Template, 4, 7, "div", 30);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const media_r28 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", media_r28.IsImage);
} }
function DwMultiFileComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵtemplate(1, DwMultiFileComponent_div_7_ng_container_1_Template, 2, 1, "ng-container", 27);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("dwColumnManager", ctx_r4.imagesPerRow)("itemCount", ctx_r4.currentMediaItems == null ? null : ctx_r4.currentMediaItems.length)("heightPercent", ctx_r4.mediaHeightPercent);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.currentMediaItems);
} }
function DwMultiFileComponent_ng_container_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 40);
    ɵngcc0.ɵɵelement(1, "img", 41);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r41 = ctx.$implicit;
    const ctx_r38 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r38.galleryStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ctx_r38.getMediaStyle(item_r41));
    ɵngcc0.ɵɵproperty("src", item_r41.FullImageUrl, ɵngcc0.ɵɵsanitizeUrl)("alt", item_r41 == null ? null : item_r41.MediaName);
} }
function DwMultiFileComponent_ng_container_8_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 42);
    ɵngcc0.ɵɵelement(1, "img", 43);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r42 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", item_r42.ThumbnailImageUrl, ɵngcc0.ɵɵsanitizeUrl)("alt", item_r42 == null ? null : item_r42.MediaName);
} }
function DwMultiFileComponent_ng_container_8_ng_template_4_i_5_Template(rf, ctx) { if (rf & 1) {
    const _r47 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 47);
    ɵngcc0.ɵɵlistener("click", function DwMultiFileComponent_ng_container_8_ng_template_4_i_5_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r47); const item_r43 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r45 = ɵngcc0.ɵɵnextContext(2); return ctx_r45.removeMedia(item_r43); });
    ɵngcc0.ɵɵelementEnd();
} }
function DwMultiFileComponent_ng_container_8_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 44);
    ɵngcc0.ɵɵelementStart(2, "h4", 45);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 33);
    ɵngcc0.ɵɵtemplate(5, DwMultiFileComponent_ng_container_8_ng_template_4_i_5_Template, 1, 0, "i", 46);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r43 = ctx.$implicit;
    const ctx_r40 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r43.MediaName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r40.disabled);
} }
const _c100 = function () { return { "max-width": "1200px" }; };
function DwMultiFileComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r49 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "p-galleria", 36);
    ɵngcc0.ɵɵlistener("visibleChange", function DwMultiFileComponent_ng_container_8_Template_p_galleria_visibleChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r49); const ctx_r48 = ɵngcc0.ɵɵnextContext(); return ctx_r48.showGallery = $event; })("visibleChange", function DwMultiFileComponent_ng_container_8_Template_p_galleria_visibleChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r49); const ctx_r50 = ɵngcc0.ɵɵnextContext(); return ctx_r50.toggleShowGallery($event); });
    ɵngcc0.ɵɵtemplate(2, DwMultiFileComponent_ng_container_8_ng_template_2_Template, 2, 5, "ng-template", 37);
    ɵngcc0.ɵɵtemplate(3, DwMultiFileComponent_ng_container_8_ng_template_3_Template, 2, 2, "ng-template", 38);
    ɵngcc0.ɵɵtemplate(4, DwMultiFileComponent_ng_container_8_ng_template_4_Template, 6, 2, "ng-template", 39);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("value", ctx_r5.currentMediaItems)("visible", ctx_r5.showGallery)("activeIndex", ctx_r5.galleryIndex)("containerStyle", ɵngcc0.ɵɵpureFunction0(11, _c100))("numVisible", 5)("fullScreen", ctx_r5.fullScreen)("showThumbnails", true)("showIndicators", false)("circular", true)("showItemNavigators", true)("baseZIndex", 10000);
} }
function DwMediaItemCardComponent_div_0_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 17);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ctx_r4.media.ThumbnailImageUrl, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx_r4.item == null ? null : ctx_r4.item.DisplayFileName);
} }
function DwMediaItemCardComponent_div_0_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 18);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r5.media.FileIconCss);
} }
function DwMediaItemCardComponent_div_0_i_10_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 19);
    ɵngcc0.ɵɵlistener("click", function DwMediaItemCardComponent_div_0_i_10_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.onRemoveMedia(ctx_r7.media); });
    ɵngcc0.ɵɵelementEnd();
} }
function DwMediaItemCardComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵelementStart(1, "div", 12);
    ɵngcc0.ɵɵtemplate(2, DwMediaItemCardComponent_div_0_img_2_Template, 1, 2, "img", 4);
    ɵngcc0.ɵɵtemplate(3, DwMediaItemCardComponent_div_0_i_3_Template, 1, 1, "i", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 13);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementStart(6, "div", 7);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "filesize");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 14);
    ɵngcc0.ɵɵtemplate(10, DwMediaItemCardComponent_div_0_i_10_Template, 1, 0, "i", 15);
    ɵngcc0.ɵɵelementStart(11, "i", 16);
    ɵngcc0.ɵɵlistener("click", function DwMediaItemCardComponent_div_0_Template_i_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.downloadMedia(ctx_r9.media); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.media._isDeleted);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.media.IsImage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.media.IsImage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r0.media.MediaName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.media.DisplayFileName, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r0.showSize);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(8, 8, ctx_r0.media.SizeInBytes), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.disabled);
} }
function DwMediaItemCardComponent_img_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 17);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r1.media.ThumbnailImageUrl, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx_r1.item == null ? null : ctx_r1.item.DisplayFileName);
} }
function DwMediaItemCardComponent_i_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 18);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r2.media.FileIconCss);
} }
function DwMediaItemCardComponent_i_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
} }
function DwAvatarConfigComponent_div_8_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r4.RelationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", item_r4.FkItemName, " (By ", item_r4.FkAttributeName, ") ");
} }
function DwAvatarConfigComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Avatar Relationship");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_div_8_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.setAvatarRelationship($event); });
    ɵngcc0.ɵɵtemplate(5, DwAvatarConfigComponent_div_8_option_5_Template, 2, 3, "option", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.section == null ? null : ctx_r0.section.avatarRelationshipInfo == null ? null : ctx_r0.section.avatarRelationshipInfo.relationshipName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.availableRelations);
} }
function DwAvatarConfigComponent_div_14_div_1_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextName_r10 = ctx.$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngValue", contextName_r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", (ctx_r9.contextMdList[contextName_r10] == null ? null : ctx_r9.contextMdList[contextName_r10].contextDef == null ? null : ctx_r9.contextMdList[contextName_r10].contextDef.contextDisplay) || contextName_r10, " ");
} }
function DwAvatarConfigComponent_div_14_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Context");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_div_14_div_1_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.section.contextName = $event; })("ngModelChange", function DwAvatarConfigComponent_div_14_div_1_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.setContextDef(); });
    ɵngcc0.ɵɵtemplate(4, DwAvatarConfigComponent_div_14_div_1_option_4_Template, 2, 2, "option", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r7.section.contextName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.contextNames);
} }
function DwAvatarConfigComponent_div_14_div_2_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r15.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r15.AttributeName, " ");
} }
function DwAvatarConfigComponent_div_14_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Avatar Media Field (Context)");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_div_14_div_2_Template_select_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.section.avatarMediaIdAttrName = $event; })("ngModelChange", function DwAvatarConfigComponent_div_14_div_2_Template_select_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(4, DwAvatarConfigComponent_div_14_div_2_option_4_Template, 2, 2, "option", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r8.section.avatarMediaIdAttrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.currentContextMd == null ? null : ctx_r8.currentContextMd.attributes);
} }
function DwAvatarConfigComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, DwAvatarConfigComponent_div_14_div_1_Template, 5, 2, "div", 11);
    ɵngcc0.ɵɵtemplate(2, DwAvatarConfigComponent_div_14_div_2_Template, 5, 2, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.section.useContext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.currentContextMd);
} }
function DwAvatarConfigComponent_div_15_option_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r20 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", item_r20.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", item_r20.AttributeName, " ");
} }
function DwAvatarConfigComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Avatar Media Field");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "select", 8);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_div_15_Template_select_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.section.avatarMediaIdAttrName = $event; })("ngModelChange", function DwAvatarConfigComponent_div_15_Template_select_ngModelChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r22); const ctx_r23 = ɵngcc0.ɵɵnextContext(); return ctx_r23.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(5, DwAvatarConfigComponent_div_15_option_5_Template, 2, 2, "option", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.section.avatarMediaIdAttrName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.itemMetaData == null ? null : ctx_r2.itemMetaData.Attributes);
} }
function DwAvatarSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelement(1, "dw-media-item", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r0.sectionStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("media", ctx_r0.avatarMedia)("sizeOptions", ctx_r0.avatarMediaImageSize)("useImageTag", true)("defaultMediaUrl", ctx_r0.defaultAvatarMediaUrl);
} }
function DwDownloadMediaConfigComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "label");
    ɵngcc0.ɵɵtext(3, "Use Context");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵelement(5, "p-inputSwitch", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwDownloadMediaConfigComponent_div_0_ng_container_2_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const contextDef_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", contextDef_r6.contextName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", contextDef_r6.contextDisplay, " ");
} }
function DwDownloadMediaConfigComponent_div_0_ng_container_2_div_8_option_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r8.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r8.AttributeDisplay, " ");
} }
function DwDownloadMediaConfigComponent_div_0_ng_container_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "label", 10);
    ɵngcc0.ɵɵtext(2, "Context Media Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "select", 15);
    ɵngcc0.ɵɵtemplate(4, DwDownloadMediaConfigComponent_div_0_ng_container_2_div_8_option_4_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", (ctx_r5.currentContextMd == null ? null : ctx_r5.currentContextMd.attributes) || ɵngcc0.ɵɵpureFunction0(1, _c91));
} }
function DwDownloadMediaConfigComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "label", 10);
    ɵngcc0.ɵɵtext(4, "Context");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 11);
    ɵngcc0.ɵɵtemplate(6, DwDownloadMediaConfigComponent_div_0_ng_container_2_option_6_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 4);
    ɵngcc0.ɵɵtemplate(8, DwDownloadMediaConfigComponent_div_0_ng_container_2_div_8_Template, 5, 2, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r2.contextList);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.currentContextMd == null ? null : ctx_r2.currentContextMd.attributes == null ? null : ctx_r2.currentContextMd.attributes.length) > 0);
} }
function DwDownloadMediaConfigComponent_div_0_ng_container_3_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attr_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", attr_r10.AttributeName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", attr_r10.AttributeDisplay, " ");
} }
function DwDownloadMediaConfigComponent_div_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵelementStart(2, "div", 9);
    ɵngcc0.ɵɵelementStart(3, "label", 10);
    ɵngcc0.ɵɵtext(4, "Media Attribute");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "select", 15);
    ɵngcc0.ɵɵtemplate(6, DwDownloadMediaConfigComponent_div_0_ng_container_3_option_6_Template, 2, 2, "option", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.attributes);
} }
function DwDownloadMediaConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, DwDownloadMediaConfigComponent_div_0_div_1_Template, 6, 0, "div", 2);
    ɵngcc0.ɵɵtemplate(2, DwDownloadMediaConfigComponent_div_0_ng_container_2_Template, 9, 2, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(3, DwDownloadMediaConfigComponent_div_0_ng_container_3_Template, 7, 1, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵelementStart(6, "label");
    ɵngcc0.ɵɵtext(7, "Is Secure Download");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 6);
    ɵngcc0.ɵɵelement(9, "p-inputSwitch", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.contextList == null ? null : ctx_r0.contextList.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.useContext) && (ctx_r0.contextList == null ? null : ctx_r0.contextList.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r0.actionConfigFG == null ? null : ctx_r0.actionConfigFG.value == null ? null : ctx_r0.actionConfigFG.value.useContext) || (ctx_r0.contextList == null ? null : ctx_r0.contextList.length) == 0);
} }
function ThemePropertyEditControlComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "dw-color-picker", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.fieldDef == null ? null : ctx_r0.fieldDef.attrName);
} }
function ThemePropertyEditControlComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "dw-input", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r1.fieldDef == null ? null : ctx_r1.fieldDef.attrName);
} }
function ThemePropertyEditControlComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "dw-input", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r2.fieldDef == null ? null : ctx_r2.fieldDef.attrName);
} }
function StartProcessConfigComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "label");
    ɵngcc0.ɵɵtext(4, "Process Schedule");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 3);
    ɵngcc0.ɵɵelement(6, "dw-search-select-lookup", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.actionConfigFG);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("lookupId", ctx_r0.processScheudleLookupId);
} }
function DwAgActionButtonsComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "dw-action-bar", 2);
    ɵngcc0.ɵɵlistener("actionClick", function DwAgActionButtonsComponent_div_1_Template_dw_action_bar_actionClick_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.triggerAction($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("actionPreferences", ctx_r0.actionPreferences)("actionContext", ctx_r0.configContext);
} }
function DwAgGridStatusBarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.countText, " ");
} }
const _c101 = ["input"];
function DwAgGridComponent_dw_ag_grid_status_bar_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "dw-ag-grid-status-bar", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("agGridDataSource", ctx_r0.agGridDataSource);
} }
const _c102 = function (a0) { return { "dw-grid-no-footer": a0 }; };
function DwChartTileComponent_dw_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementStart(1, "i", 8);
    ɵngcc0.ɵɵlistener("click", function DwChartTileComponent_dw_container_0_div_3_Template_i_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.toggleShowChart(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "i", 9);
    ɵngcc0.ɵɵlistener("click", function DwChartTileComponent_dw_container_0_div_3_Template_i_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.toggleShowChart(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.showChart);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r1.showChart);
} }
function DwChartTileComponent_dw_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtext(2, "No Data");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function DwChartTileComponent_dw_container_0_ng_container_6_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "p-chart", 15);
    ɵngcc0.ɵɵlistener("onDataSelect", function DwChartTileComponent_dw_container_0_ng_container_6_div_1_Template_p_chart_onDataSelect_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.onDataSelect($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("type", ctx_r7.chartConfig == null ? null : ctx_r7.chartConfig.chartType)("data", ctx_r7.chartConfig == null ? null : ctx_r7.chartConfig.chartData)("query", ctx_r7.query)("options", ctx_r7.chartConfig == null ? null : ctx_r7.chartConfig.chartOptions);
} }
function DwChartTileComponent_dw_container_0_ng_container_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "dw-quick-grid", 16);
    ɵngcc0.ɵɵlistener("gridEvent", function DwChartTileComponent_dw_container_0_ng_container_6_div_2_Template_dw_quick_grid_gridEvent_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.onGridEvent($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("item", ctx_r8.query.RootTable)("query", ctx_r8.query)("columnPreferences", ctx_r8.columnPreferences)("loadCount", ctx_r8.loadCount)("customizeActions", true);
} }
function DwChartTileComponent_dw_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwChartTileComponent_dw_container_0_ng_container_6_div_1_Template, 2, 4, "div", 12);
    ɵngcc0.ɵɵtemplate(2, DwChartTileComponent_dw_container_0_ng_container_6_div_2_Template, 2, 5, "div", 6);
    ɵngcc0.ɵɵelementStart(3, "div", 13);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.chartConfig && ctx_r3.showChart);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.showChart);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.additionalText);
} }
function DwChartTileComponent_dw_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "dw-container", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵtemplate(3, DwChartTileComponent_dw_container_0_div_3_Template, 3, 2, "div", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtemplate(5, DwChartTileComponent_dw_container_0_div_5_Template, 3, 0, "div", 5);
    ɵngcc0.ɵɵtemplate(6, DwChartTileComponent_dw_container_0_ng_container_6_Template, 6, 3, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("options", ctx_r0.finalContainerOptions);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.chartPreferences == null ? null : ctx_r0.chartPreferences.containerTitle, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.chartPreferences.gridPreferences == null ? null : ctx_r0.chartPreferences.gridPreferences.showGrid) && !ctx_r0.hideToggle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.data == null ? null : ctx_r0.data.length) == 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.data == null ? null : ctx_r0.data.length) > 0);
} }
function DwMiniTileComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.tileConfig == null ? null : ctx_r0.tileConfig.additionalText);
} }
function DwUiWizardSectionConfigComponent_dw_ordered_list_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "label");
    ɵngcc0.ɵɵtext(2, "Step Name");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "input", 34);
    ɵngcc0.ɵɵlistener("ngModelChange", function DwUiWizardSectionConfigComponent_dw_ordered_list_3_ng_container_1_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const section_r3 = ctx.$implicit; return section_r3.stepName = $event; })("ngModelChange", function DwUiWizardSectionConfigComponent_dw_ordered_list_3_ng_container_1_Template_input_ngModelChange_3_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.onSectionChange(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const section_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", section_r3.stepName);
} }
function DwUiWizardSectionConfigComponent_dw_ordered_list_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "dw-ordered-list", 32);
    ɵngcc0.ɵɵlistener("itemsChange", function DwUiWizardSectionConfigComponent_dw_ordered_list_3_Template_dw_ordered_list_itemsChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.section.steps = $event; })("itemsChange", function DwUiWizardSectionConfigComponent_dw_ordered_list_3_Template_dw_ordered_list_itemsChange_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onSectionChange(); });
    ɵngcc0.ɵɵtemplate(1, DwUiWizardSectionConfigComponent_dw_ordered_list_3_ng_container_1_Template, 4, 1, "ng-container", 33);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("items", ctx_r0.section.steps);
} }
function DwUiWizardSectionConfigComponent_option_51_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 35);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const stepStyle_r10 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", stepStyle_r10.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", stepStyle_r10.display, " ");
} }
function DwUiWizardSectionComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "dw-dynamic-loader", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("component", ctx_r2.state == null ? null : ctx_r2.state.stepStyle == null ? null : ctx_r2.state.stepStyle.stepListComponent);
} }
function DwUiWizardSectionComponent_div_0_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelement(2, "dw-dynamic-section", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    const i_r5 = ctx_r7.index;
    const step_r4 = ctx_r7.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", i_r5 != (ctx_r6.state == null ? null : ctx_r6.state.currentIndex));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r6.formConfig)("sectionConfig", step_r4)("formGroup", ctx_r6.formGroup)("context", ctx_r6.context)("submitted", ctx_r6.submitted);
} }
function DwUiWizardSectionComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, DwUiWizardSectionComponent_div_0_ng_container_2_ng_container_1_Template, 3, 6, "ng-container", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const i_r5 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r5 <= (ctx_r3.state == null ? null : ctx_r3.state.currentIndex));
} }
function DwUiWizardSectionComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, DwUiWizardSectionComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(2, DwUiWizardSectionComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.wizardStyle.wizardContainerClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.preferences == null ? null : ctx_r0.preferences.showStepProgressBar) && (ctx_r0.state == null ? null : ctx_r0.state.stepStyle == null ? null : ctx_r0.state.stepStyle.stepListComponent));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.state == null ? null : ctx_r0.state.visibleSteps)("ngForTrackBy", ctx_r0.trackByFunc);
} }
function DwUiWizardSectionComponent_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 9);
    ɵngcc0.ɵɵelementStart(1, "dw-container");
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 11);
    ɵngcc0.ɵɵelement(5, "dw-dynamic-section", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const step_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", step_r9.stepName, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formConfig", ctx_r8.formConfig)("sectionConfig", ctx_r8.section)("formGroup", ctx_r8.formGroup)("context", ctx_r8.context)("submitted", ctx_r8.submitted)("parentIsVisible", ctx_r8.visible);
} }
function DwUiWizardSectionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0, 6);
    ɵngcc0.ɵɵtemplate(1, DwUiWizardSectionComponent_ng_container_1_ng_container_1_Template, 6, 7, "ng-container", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("hidden", !ctx_r1.visible);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.state == null ? null : ctx_r1.state.visibleSteps)("ngForTrackBy", ctx_r1.trackByFunc);
} }
function DwUiWizardStepConfigComponent_option_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const sectionDef_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngValue", sectionDef_r1.keyName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", sectionDef_r1.display, " ");
} }
function DwWizardStepListComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 3);
    ɵngcc0.ɵɵelementStart(1, "div", 4);
    ɵngcc0.ɵɵlistener("click", function DwWizardStepListComponent_li_2_Template_div_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const stepItem_r1 = ctx.$implicit; const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.gotoStep(stepItem_r1); });
    ɵngcc0.ɵɵelement(2, "i", 5);
    ɵngcc0.ɵɵelementStart(3, "span", 6);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "p", 7);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "p", 8);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const stepItem_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", stepItem_r1.stepClass)("ngStyle", ctx_r0.itemStyle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", stepItem_r1.stepIconClass)("hidden", ctx_r0.preferences == null ? null : ctx_r0.preferences.showStepNumberInProgressBar);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", !(ctx_r0.preferences == null ? null : ctx_r0.preferences.showStepNumberInProgressBar));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(stepItem_r1.stepNumber);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(stepItem_r1.step.stepName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(stepItem_r1.step.stepDescription);
} }
class DwUiPreferencesBase {
    constructor(configType) {
        this.UiConfigType = configType;
    }
}

// Values are from the table devware.UiConfigTypeId
// Values are from the table devware.UiConfigTypeId
var DwUiConfigType;
(function (DwUiConfigType) {
    DwUiConfigType[DwUiConfigType["grid"] = 1] = "grid";
    DwUiConfigType[DwUiConfigType["form"] = 2] = "form";
    DwUiConfigType[DwUiConfigType["content"] = 3] = "content";
    DwUiConfigType[DwUiConfigType["list"] = 4] = "list";
    DwUiConfigType[DwUiConfigType["gridView"] = 5] = "gridView";
})(DwUiConfigType || (DwUiConfigType = {}));

class DwEnumItemBase {
}
class DwEnumItem extends DwEnumItemBase {
}
class DwEnumItemExt {
}
class DwEnumListBase {
    constructor() {
        this.ignoreBlankDisplayItems = false;
    }
    getEnumList() {
        const list = [];
        this.getKeys().map(value => {
            let enumValue = this.getEnumValue(value);
            let item = this.getEnumItem(enumValue);
            if (item) {
                list.push(item);
            }
        });
        return list;
    }
    getLookupList() {
        const list = [];
        const enumList = this.getEnumList();
        for (const item of enumList) {
            list.push({
                Id: item.value,
                Display: item.display
            });
        }
        return list;
    }
    getEnumItem(value) {
        const item = {};
        const display = this.getEnumDisplay(value);
        if (!display && this.ignoreBlankDisplayItems) {
            return null;
        }
        item.value = value;
        item.display = this.getEnumDisplay(value) || " None " + value;
        item.data = this.getEnumData(value);
        return item;
    }
    getEnumData(value) {
        return null;
    }
    getEnumDisplay(value) {
        if (value) {
            return "" && value;
        }
        return "";
    }
}

var DwGridHeightMode;
(function (DwGridHeightMode) {
    DwGridHeightMode["fixedHeight"] = "fixed";
    DwGridHeightMode["autoFitToScreen"] = "auto";
    DwGridHeightMode["fullScreen"] = "fullScreen";
    DwGridHeightMode["rowBased"] = "rowBased";
    DwGridHeightMode["printFriendly"] = "printFriendly";
})(DwGridHeightMode || (DwGridHeightMode = {}));
class DwGridHeightModeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwGridHeightMode[propertyName];
    }
    getKeys() {
        return Object.keys(DwGridHeightMode);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwGridHeightMode.fixedHeight:
                return 'Fixed Height';
            case DwGridHeightMode.autoFitToScreen:
                return 'Auto Fit';
            case DwGridHeightMode.fullScreen:
                return 'Full Screen';
            case DwGridHeightMode.rowBased:
                return 'Row Based';
            case DwGridHeightMode.printFriendly:
                return 'Printer Friendly';
        }
    }
}

class DwGridPreferences extends DwUiPreferencesBase {
    constructor() {
        super(DwUiConfigType.grid);
        this.showFilterOnLoad = false;
        this.hideAdd = false;
        this.hideRefresh = false;
        this.hideExport = false;
        this.columnPreferences = [];
        this.gridStyle = {
            gridHeightMode: DwGridHeightMode.autoFitToScreen
        };
    }
}

class DwMetaDataGridPreferences extends DwGridPreferences {
    constructor() {
        super();
        this.showFooter = false;
        this.useSideFilters = false;
        this.loadTotalRowCount = true;
        this.useModal = true;
        this.autoFilter = true;
        this.filters = [];
        this.views = [];
    }
}

class DwMenuData {
    constructor() {
        this.showInMenu = true;
        this.hideChildMenus = false;
        this.useEmulatedPermissions = true;
    }
}

var DwControlType;
(function (DwControlType) {
    DwControlType[DwControlType["Textbox"] = 1] = "Textbox";
    DwControlType[DwControlType["RadioButtonList"] = 2] = "RadioButtonList";
    DwControlType[DwControlType["DropDownList"] = 3] = "DropDownList";
    DwControlType[DwControlType["AutoComplete"] = 4] = "AutoComplete";
    DwControlType[DwControlType["NumericTextBox"] = 5] = "NumericTextBox";
    DwControlType[DwControlType["TextArea"] = 6] = "TextArea";
    DwControlType[DwControlType["HTMLEditor"] = 7] = "HTMLEditor";
    DwControlType[DwControlType["YesNoDropDown"] = 8] = "YesNoDropDown";
    DwControlType[DwControlType["Checkbox"] = 9] = "Checkbox";
    DwControlType[DwControlType["DatePicker"] = 10] = "DatePicker";
    DwControlType[DwControlType["DateTimePicker"] = 11] = "DateTimePicker";
    DwControlType[DwControlType["CurrencyTextBox"] = 12] = "CurrencyTextBox";
    DwControlType[DwControlType["PercentageTextBox"] = 13] = "PercentageTextBox";
    DwControlType[DwControlType["DropDownListwSearch"] = 14] = "DropDownListwSearch";
    DwControlType[DwControlType["PasswordTextBox"] = 15] = "PasswordTextBox";
    DwControlType[DwControlType["UrlTextBox"] = 16] = "UrlTextBox";
    DwControlType[DwControlType["TimePicker"] = 17] = "TimePicker";
    DwControlType[DwControlType["AutoCompleteServer"] = 18] = "AutoCompleteServer";
    DwControlType[DwControlType["CalcultedField"] = 19] = "CalcultedField";
    DwControlType[DwControlType["MultiSelect"] = 20] = "MultiSelect";
    DwControlType[DwControlType["MultiSelectAdhoc"] = 21] = "MultiSelectAdhoc";
})(DwControlType || (DwControlType = {}));

var DwFilterType;
(function (DwFilterType) {
    DwFilterType["Group"] = "Group";
    DwFilterType["Equal"] = "EQUAL";
    DwFilterType["GreaterThan"] = "GREATER_THAN";
    DwFilterType["GreaterThanEqual"] = "GREATER_EQUAL";
    DwFilterType["LessThan"] = "LESS_THAN";
    DwFilterType["LessThanEqual"] = "LESS_EQUAL";
    DwFilterType["Contains"] = "CONTAINS";
    DwFilterType["NotContains"] = "NOT_CONTAINS";
    DwFilterType["StartsWith"] = "STARTS_WITH";
    DwFilterType["EndsWith"] = "ENDS_WITH";
    DwFilterType["NotEqual"] = "NOT_EQUAL";
    DwFilterType["IsBlank"] = "IS_BLANK";
    DwFilterType["IsNotBlank"] = "IS_NOT_BLANK";
    DwFilterType["IsTrue"] = "IS_TRUE";
    DwFilterType["IsFalse"] = "IS_FALSE";
    DwFilterType["InSql"] = "IN_SQL";
    DwFilterType["In"] = "IN_LIST";
    DwFilterType["NotIn"] = "NOT_IN_LIST";
    DwFilterType["GreaterThanHours"] = "GREATER_THAN_HOURS";
    DwFilterType["GreaterThanEqualHours"] = "GREATER_THAN_EQUAL_HOURS";
    DwFilterType["LessThanHours"] = "LESS_THAN_HOURS";
    DwFilterType["LessThanEqualHours"] = "LESS_THAN_EQUAL_HOURS";
    DwFilterType["GreaterThanDays"] = "GREATER_THAN_DAYS";
    DwFilterType["GreaterThanEqualDays"] = "GREATER_THAN_EQUAL_DAYS";
    DwFilterType["LessThanDays"] = "LESS_THAN_DAYS";
    DwFilterType["LessThanEqualDays"] = "LESS_THAN_EQUAL_DAYS";
    DwFilterType["CurrentUser"] = "IS_CURRENT_USER";
})(DwFilterType || (DwFilterType = {}));

var DwOperator;
(function (DwOperator) {
    DwOperator["And"] = "AND";
    DwOperator["Or"] = "Or";
})(DwOperator || (DwOperator = {}));

class DwQueryFilter {
    constructor() {
        this.Op = DwOperator.And;
        this.Type = DwFilterType.Equal;
    }
}

class DwQueryFilterGroup extends DwQueryFilter {
    constructor() {
        super();
        this.Filters = [];
        this.Type = DwFilterType.Group;
    }
    AddFilterAnd(filter) {
        return this.AddFilter(filter, DwOperator.And);
    }
    AddFilterOr(filter) {
        return this.AddFilter(filter, DwOperator.Or);
    }
    AddFilter(filter, op = null) {
        this.ValidateFilter(filter);
        // Modified on 2/7/22, but may cause problems on existing complex queries, but don't know of any.  This is more logical going forward
        //  and again on 4/11/24 to preserve the operator for groups, otherwise it is overwritten for an OR group which doesn't make sense.
        if (filter.Type != DwFilterType.Group && op) {
            this.Op = op;
        }
        this.Filters.push(filter);
        return this;
    }
    ValidateFilter(filter) {
        if (!filter)
            throw new Error("Filter Expr cannot be null and must be a valid Filter type.  Use Filters helper classes to create your filters.");
        if (!filter.Type)
            throw new Error("Filter Expr.Type cannot be null");
    }
}
function isQueryFilterGroup(filter) {
    return (filter.Type == DwFilterType.Group);
}

class DwQueryPrefetchPath {
}

class DwQueryOrder {
    constructor() {
        this.Field = new DwQueryFieldInfo();
        this.IsAscending = true;
    }
}
class DwQueryFieldInfo {
}

var DwJoinType;
(function (DwJoinType) {
    DwJoinType["InnerJoin"] = "INNER_JOIN";
    DwJoinType["LeftOuterJoin"] = "LEFT_OUTER_JOIN";
    DwJoinType["RightOuterJoin"] = "RIGHT_OUTER_JOIN";
    DwJoinType["FullOuterJoin"] = "FULL_OUTER_JOIN";
    DwJoinType["CrossJoin"] = "CROSS_JOIN";
})(DwJoinType || (DwJoinType = {}));

class DwQueryRelation {
    constructor() {
        this.SubRelations = [];
        this.RelationFields = [];
        this.JoinType = DwJoinType.InnerJoin;
    }
}

class DwQuerySettings {
    constructor() {
        // Inclue/Exclude fields
        this.IncludeFields = [];
        this.ExcludeFields = [];
        /*  SetValues(loadCustomAttributes?: boolean, loadAllLookupDisplayFields?: boolean) {
             if (!loadCustomAttributes === null)
                 this.LoadCustomAttributes = loadCustomAttributes;
     
             if (!loadAllLookupDisplayFields === null)
                 this.LoadAllLookupDisplayFields = loadAllLookupDisplayFields;
         }
     
         SetupAggregateQuery(aggregateQueryWithRollup?: boolean) {
             this.AggregateQuery = true;
             this.AggregateQueryWithRollup = aggregateQueryWithRollup ? true : false;
         }
     
         AddIncludeField(field: DwField | string) {
             this.IncludeRootItemFields = false;
     
             if (typeof field == "string") {
                 var newField = new DwField();
     
                 newField.FullFieldName = field;
     
                 this.IncludeFields.push(newField);
             } else {
                 this.IncludeFields.push(field);
             }
         }
     
         AddIncludeFields(fields: DwField[] | string[]) {
             for (let field of fields) {
                 this.AddIncludeField(field)
             }
         }
     
         AddExcludeField(field: DwField | string) {
             if (typeof field == "string") {
                 var newField = new DwField();
     
                 newField.FullFieldName = field;
     
                 this.IncludeFields.push(newField);
             } else {
                 this.IncludeFields.push(field);
             }
         } */
    }
}

class DwQueryPaging {
    constructor() {
        this.PageNo = 1;
        this.PageSize = 50;
        this.ReturnCount = false;
    }
}

class DwField {
}

class DwQuery {
    constructor(rootTable) {
        if (typeof (rootTable) == "string")
            this.RootTable = rootTable;
        this.FieldSettings = new DwQuerySettings();
    }
    getFieldSettings() {
        if (!this.FieldSettings) {
            this.FieldSettings = new DwQuerySettings();
        }
        return this.FieldSettings;
    }
    getSafeRootFilter() {
        if (!this.Filter) {
            this.Filter = new DwQueryFilterGroup();
        }
        if (this.Filter.Op == DwOperator.And) {
            if (this.Filter.AddFilter) {
                return this.Filter;
            }
        }
        const newFilterGroup = new DwQueryFilterGroup();
        newFilterGroup.AddFilterAnd(this.Filter);
        this.Filter = newFilterGroup;
        return newFilterGroup;
    }
    AddFilterAnd(expr) {
        if (!this.Filter) {
            this.Filter = new DwQueryFilterGroup();
        }
        this.AddFilter(this.Filter, expr, DwOperator.And);
        return this;
    }
    AddFilterOr(expr) {
        if (!this.Filter) {
            this.Filter = new DwQueryFilterGroup();
        }
        this.AddFilter(this.Filter, expr, DwOperator.Or);
        return this;
    }
    AddFilter(filters, filter, op) {
        this.validateFilter(filter);
        if (filter.Type != DwFilterType.Group) {
            filter.Op = op;
        }
        if (!this.Filter) {
            this.Filter = new DwQueryFilterGroup();
        }
        filters.Filters.push(filter);
    }
    validateFilter(filter) {
        if (!filter)
            throw new Error("Filter Expr cannot be null and must be a valid Filter type.  Use Filters helper classes to create your filters.");
        if (!filter.Type)
            throw new Error("Filter Expr.Type cannot be null");
    }
    AddPrefetchPath(relation, subQuery) {
        var prefetch = new DwQueryPrefetchPath();
        if (typeof relation === "string") {
            prefetch.RelationName = relation;
        }
        else {
            prefetch.RelationName = relation.RelationName;
        }
        prefetch.Query = subQuery;
        this.Prefetch = this.Prefetch || [];
        this.Prefetch.push(prefetch);
        return this;
    }
    SetFieldSettings(loadCustomAttributes, loadAllLookupDisplayFields) {
        if (loadCustomAttributes !== null)
            this.getFieldSettings().LoadCustomAttributes = loadCustomAttributes;
        if (loadAllLookupDisplayFields !== null)
            this.getFieldSettings().LoadAllLookupDisplayFields = loadAllLookupDisplayFields;
        return this;
    }
    SetupAggregateQuery(withRollup) {
        this.getFieldSettings().AggregateQuery = true;
        this.getFieldSettings().AggregateQueryWithRollup = withRollup ? true : false;
        return this;
    }
    SetupPaging(pageNo, pageSize, returnCount, top) {
        if (!this.PagingInfo)
            this.PagingInfo = new DwQueryPaging();
        this.PagingInfo.PageNo = pageNo;
        this.PagingInfo.PageSize = pageSize;
        this.PagingInfo.ReturnCount = returnCount ? true : false;
        this.PagingInfo.Top = top;
        return this;
    }
    AddRelation(relation, fieldPrefix = "") {
        let newRelation;
        if (typeof relation == "string") {
            newRelation = new DwQueryRelation();
            newRelation.RelationName = relation;
            newRelation.FieldPrefix = fieldPrefix;
        }
        else {
            newRelation = relation;
        }
        this.Relations = this.Relations || [];
        this.Relations.push(newRelation);
        return this;
    }
    getField(field) {
        if (typeof field == "string") {
            var newField = new DwField();
            newField.FullFieldName = field;
            return newField;
        }
        return field;
    }
    AddField(field) {
        var finalField = this.getField(field);
        this.getFieldSettings().IncludeRootItemFields = false;
        this.getFieldSettings().IncludeFields = this.getFieldSettings().IncludeFields || [];
        this.getFieldSettings().IncludeFields.push(finalField);
        return this;
    }
    AddFields(fields) {
        for (const field of fields) {
            this.AddField(field);
        }
        return this;
    }
    AddExcludeField(field) {
        var finalField = this.getField(field);
        this.getFieldSettings().ExcludeFields = this.getFieldSettings().ExcludeFields || [];
        this.getFieldSettings().ExcludeFields.push(finalField);
        return this;
    }
    AddRelatedField(field, fieldAlias) {
        this.RelationFields = this.RelationFields || [];
        if (typeof field == "string") {
            let newField = new DwField();
            newField.FullFieldName = field;
            newField.FieldAlias = fieldAlias;
            this.RelationFields.push(newField);
        }
        else {
            this.RelationFields.push(field);
        }
        return this;
    }
    OrderBy(field, isAscending = true) {
        this.Order = this.Order || [];
        if (typeof field == "string") {
            let newField = new DwQueryOrder();
            newField.Field.FullFieldName = field;
            newField.IsAscending = isAscending ? true : false;
            this.Order.push(newField);
        }
        else {
            this.Order.push(field);
        }
        return this;
    }
}
function isQuery(item) {
    if (item && item.RootTable)
        return true;
    return false;
}

class DwQueryDateFilterHelper {
    GreaterThanDays(attr, value) {
        return this.buildFilter(attr, DwFilterType.GreaterThanDays, value);
    }
    GreaterThanEqualDays(attr, value) {
        return this.buildFilter(attr, DwFilterType.GreaterThanEqualDays, value);
    }
    LessThanDays(attr, value) {
        return this.buildFilter(attr, DwFilterType.LessThanDays, value);
    }
    LessThanEqualDays(attr, value) {
        return this.buildFilter(attr, DwFilterType.LessThanEqualDays, value);
    }
    GreaterThanHours(attr, value) {
        return this.buildFilter(attr, DwFilterType.GreaterThanHours, value);
    }
    GreaterThanEqualHours(attr, value) {
        return this.buildFilter(attr, DwFilterType.GreaterThanEqualHours, value);
    }
    LessThanHours(attr, value) {
        return this.buildFilter(attr, DwFilterType.LessThanHours, value);
    }
    LessThanEqualHours(attr, value) {
        return this.buildFilter(attr, DwFilterType.LessThanEqualHours, value);
    }
    buildFilter(attr, type, value) {
        var filter = new DwQueryFilter();
        filter.Attr = attr;
        filter.Type = type;
        filter.Value = value;
        return filter;
    }
}

class DwQueryFilterHelper {
    Equal(attr, value) {
        return this.buildFilter(attr, DwFilterType.Equal, value);
    }
    NotEqual(attr, value) {
        return this.buildFilter(attr, DwFilterType.NotEqual, value);
    }
    StartsWith(attr, value) {
        return this.buildFilter(attr, DwFilterType.StartsWith, value);
    }
    EndsWith(attr, value) {
        return this.buildFilter(attr, DwFilterType.EndsWith, value);
    }
    Contains(attr, value) {
        return this.buildFilter(attr, DwFilterType.Contains, value);
    }
    GreaterThan(attr, value) {
        return this.buildFilter(attr, DwFilterType.GreaterThan, value);
    }
    GreaterThanEqual(attr, value) {
        return this.buildFilter(attr, DwFilterType.GreaterThanEqual, value);
    }
    LessThan(attr, value) {
        return this.buildFilter(attr, DwFilterType.LessThan, value);
    }
    LessThanEqual(attr, value) {
        return this.buildFilter(attr, DwFilterType.LessThanEqual, value);
    }
    IsBlank(attr) {
        return this.buildFilter(attr, DwFilterType.IsBlank);
    }
    IsNotBlank(attr) {
        return this.buildFilter(attr, DwFilterType.IsNotBlank);
    }
    IsTrue(attr) {
        return this.buildFilter(attr, DwFilterType.IsTrue);
    }
    IsFalse(attr) {
        return this.buildFilter(attr, DwFilterType.IsFalse);
    }
    InList(attr, list) {
        const arrayValue = DwQueryFilterHelper.convertToArray(list);
        return this.buildFilter(attr, DwFilterType.In, arrayValue);
    }
    NotInList(attr, list) {
        const arrayValue = DwQueryFilterHelper.convertToArray(list);
        return this.buildFilter(attr, DwFilterType.NotIn, arrayValue);
    }
    static convertToArray(filterValues) {
        if (Array.isArray(filterValues)) {
            let list = "";
            for (let filterValue of filterValues) {
                if (filterValue !== undefined && filterValue !== null) {
                    if (list)
                        list += ",";
                    list += filterValue.toString();
                }
            }
            if (list)
                return list;
            return null;
        }
        return filterValues;
    }
    Group() {
        return new DwQueryFilterGroup();
    }
    GroupOr() {
        const filterGroup = new DwQueryFilterGroup();
        filterGroup.Op = DwOperator.Or;
        return filterGroup;
    }
    DateFilters() {
        return new DwQueryDateFilterHelper();
    }
    buildFilter(attr, type, value) {
        var filter = new DwQueryFilter();
        filter.Attr = attr;
        filter.Type = type;
        filter.Value = value;
        return filter;
    }
}

var DwFieldType;
(function (DwFieldType) {
    DwFieldType["Standard"] = "Standard";
    DwFieldType["Aggregate"] = "Aggregate";
    DwFieldType["Expression"] = "Expression";
    DwFieldType["Custom"] = "Custom";
    DwFieldType["Template"] = "Template";
})(DwFieldType || (DwFieldType = {}));

class DwQueryFieldsHelper {
    Standard(fullFieldName, fieldAlias) {
        var field = new DwField();
        field.FullFieldName = fullFieldName;
        field.FieldAlias = fieldAlias;
        return field;
    }
    Expression(expression, fieldAlias) {
        var field = new DwField();
        field.FieldType = DwFieldType.Expression;
        field.FieldAlias = fieldAlias;
        field.Expression = expression;
        return field;
    }
    Aggregate(fieldAlias, aggregate, fullFieldName, expression, havingFilter) {
        var field = new DwField();
        field.FieldType = DwFieldType.Aggregate;
        field.AggregateFunction = aggregate;
        field.FieldAlias = fieldAlias;
        field.FullFieldName = fullFieldName;
        field.Expression = expression;
        field.HavingFilter = havingFilter;
        return field;
    }
    /**
     * Parses a full field name to an item and field
     * @param fieldName Full field name
     * @param itemName  optional item name if field name doesn't contain an item
     */
    parseFullFieldName(fieldName, itemName) {
        const index = fieldName.indexOf('.');
        if (index >= 0) {
            return {
                ItemName: fieldName.substring(0, index),
                FieldName: fieldName.substring(index + 1, fieldName.length)
            };
        }
        return {
            ItemName: itemName,
            FieldName: fieldName,
        };
    }
    /**
     * Builds a full field name by combining the itemname and field name
     * @param fieldName
     * @param itemName
     */
    buildFullFieldName(fieldName, itemName) {
        return `${itemName}.${fieldName}`;
    }
}

class DwDataPageResults {
    constructor() {
        this.data = [];
    }
}
function isDwDataPageResults(results) {
    if (results && results.data) {
        return true;
    }
    return false;
}

class DwDataPageReturnInfo {
    constructor() {
        this.currentPageNo = 1;
        this.currentPageSize = 50;
    }
}

var DwFieldAggregate;
(function (DwFieldAggregate) {
    DwFieldAggregate["None"] = "None";
    DwFieldAggregate["Count"] = "Count";
    DwFieldAggregate["Sum"] = "Sum";
    DwFieldAggregate["Min"] = "Min";
    DwFieldAggregate["Max"] = "Max";
    DwFieldAggregate["CountBig"] = "CountBig";
    DwFieldAggregate["StDev"] = "StDev";
    DwFieldAggregate["StDevP"] = "StDevP";
    DwFieldAggregate["Var"] = "Var";
    DwFieldAggregate["VarP"] = "VarP";
    DwFieldAggregate["Avg"] = "Avg";
    DwFieldAggregate["Grouping"] = "Grouping";
    DwFieldAggregate["CountDistinct"] = "CountDistinct";
    DwFieldAggregate["CountAll"] = "CountAll";
    DwFieldAggregate["CountAllDistinct"] = "CountAllDistinct";
})(DwFieldAggregate || (DwFieldAggregate = {}));
// export class DwFieldAggregateList extends DwEnumListBase<DwFieldAggregate, DwEnumItem<DwFieldAggregate>> {
//     ignoreBlankDisplayItems = true;
//     getEnumValue(propertyName: string): DwFieldAggregate {
//         return DwFieldAggregate[propertyName];
//     }
//     getKeys(): string[] {
//         return Object.keys(DwFieldAggregate);
//     }
//     public getEnumDisplay(item: DwFieldAggregate) {
//         return item;
//     }
// }
class DwFieldAggregateList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwFieldAggregate[propertyName];
    }
    getKeys() {
        return Object.keys(DwFieldAggregate);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwFieldAggregate.None:
                return null;
            case DwFieldAggregate.Count:
                return 'Count';
            case DwFieldAggregate.CountDistinct:
                return 'Count Distinct';
            case DwFieldAggregate.CountAll:
                return 'Count All';
            case DwFieldAggregate.CountAllDistinct:
                return 'Count All Distinct';
            case DwFieldAggregate.Sum:
                return 'Sum';
            case DwFieldAggregate.Avg:
                return 'Average';
            case DwFieldAggregate.Min:
                return 'Min';
            case DwFieldAggregate.Max:
                return 'Max';
            case DwFieldAggregate.CountBig:
                return 'Count Big';
            case DwFieldAggregate.StDev:
                return 'Standard Deviation';
            case DwFieldAggregate.StDevP:
                return 'Standard Deviation (P)';
            case DwFieldAggregate.Var:
                return 'Variance';
            case DwFieldAggregate.VarP:
                return 'Variance (P)';
            case DwFieldAggregate.Grouping:
                return null;
        }
    }
}

class DwQueryFilterHaving extends DwQueryFilter {
    constructor(aggregateFunction, type, value, attr) {
        super();
        this.AggregateFunction = DwFieldAggregate.None;
        this.AggregateFunction = aggregateFunction;
        this.Type = type;
        this.Attr = attr;
        this.Value = value;
    }
}

class DwQueryHavingFilterHelper {
    Equal(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.Equal, value);
    }
    NotEqual(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.NotEqual, value);
    }
    StartsWith(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.StartsWith, value);
    }
    EndsWith(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.EndsWith, value);
    }
    Contains(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.Contains, value);
    }
    GreaterThan(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.GreaterThan, value);
    }
    GreaterThanEqual(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.GreaterThanEqual, value);
    }
    LessThan(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.LessThan, value);
    }
    LessThanEqual(aggrFunc, value) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.LessThanEqual, value);
    }
    IsBlank(aggrFunc) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.IsBlank);
    }
    IsNotBlank(aggrFunc) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.IsNotBlank);
    }
    IsTrue(aggrFunc) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.IsTrue);
    }
    IsFalse(aggrFunc) {
        return this.buildAggrFilter(aggrFunc, DwFilterType.IsFalse);
    }
    buildAggrFilter(aggrFunc, type, value) {
        var filter = new DwQueryFilterHaving(aggrFunc, type, value);
        return filter;
    }
}

function deepCopy(object, throwExceptionOnError = true, ...excludeProperties) {
    if (!object) {
        return object;
    }
    let excludedValues = null;
    if (excludeProperties && excludeProperties.length > 0) {
        excludedValues = {};
        for (const prop of excludeProperties) {
            excludedValues[prop] = object[prop];
            object[prop] = null;
        }
    }
    try {
        const copyResult = JSON.parse(JSON.stringify(object));
        // Never change an array to an object
        if (Array.isArray(object)) {
            return copyResult;
        }
        if (!excludedValues) {
            return copyResult;
        }
        return Object.assign(Object.assign({}, copyResult), excludedValues);
    }
    catch (e) {
        if (throwExceptionOnError) {
            throw e;
        }
        else {
            //console.log('Error performing deep copy on object', object, e);
        }
        // If no error, then just return the object
        return object;
    }
}
function deepCopyToObject(object, copyToObject, throwExceptionOnError = true) {
    if (!object) {
        return object;
    }
    try {
        const result = JSON.parse(JSON.stringify(object));
        return Object.assign(copyToObject, result);
    }
    catch (e) {
        if (throwExceptionOnError) {
            throw e;
        }
        else {
            //console.log('"Error performing deep copy on object', object, e);
        }
        // If no error, then just return the object
        return object;
    }
}
function deepCopyFullObject(source) {
    return Array.isArray(source)
        ? source.map(item => deepCopyFullObject(item))
        : source instanceof Date
            ? new Date(source.getTime())
            : source && typeof source === 'object'
                ? Object.getOwnPropertyNames(source).reduce((o, prop) => {
                    Object.defineProperty(o, prop, Object.getOwnPropertyDescriptor(source, prop));
                    o[prop] = deepCopyFullObject(source[prop]);
                    return o;
                }, Object.create(Object.getPrototypeOf(source)))
                : source;
}
function removeNullProperties(obj, removeEmpyString = false, removeEmptyObjects = false) {
    if (obj == null || obj == undefined) {
        return;
    }
    const validKeys = Object.keys(obj).filter(item => (obj[item] != undefined || obj[item] != null)
        && (!removeEmpyString || obj[item] !== '')
        && (!removeEmptyObjects));
    const finalObject = {};
    validKeys.forEach(key => {
        finalObject[key] = obj[key];
    });
    return finalObject;
}
function deepDefaults(obj, defaults, depth = 0, overrideValues = false, addMissingArrayDefaults = false) {
    if (depth > 20) {
        throw new Error('deepDefaults: Max depth exceeded');
    }
    let isArray = false;
    if (obj == null || obj == undefined) {
        if (Array.isArray(defaults)) {
            obj = [];
            isArray = true;
        }
        else {
            obj = {};
        }
    }
    if (defaults == null || defaults == undefined) {
        return obj;
    }
    let index = 0;
    for (const prop in defaults) {
        if (defaults.hasOwnProperty(prop)) {
            const defaultValue = defaults[prop];
            if (defaultValue !== null && typeof defaultValue === 'object') {
                let currentValue = obj[prop] || {};
                if (!addMissingArrayDefaults && Array.isArray(obj)) {
                    if (obj.length <= index) {
                        continue;
                    }
                }
                // Modified 2/24/22 to handle arrays (this was converting nested arrays to an object)
                if (Array.isArray(defaultValue)) {
                    currentValue = obj[prop] || [];
                    // Note: 8/1/23 - wasn't copying child array defaults
                    if (currentValue.length == 0 || addMissingArrayDefaults) {
                        for (let nextValue of defaultValue) {
                            let nextValueFinal = nextValue;
                            if (typeof nextValue === 'object') {
                                // if it's an object, copy it first
                                nextValueFinal = deepCopy(nextValue);
                            }
                            currentValue.push(deepCopy(nextValueFinal));
                        }
                    }
                    // // update prop with final value
                    // obj[prop] = currentValue;
                    // Have to copy the defaults, otherwise it loses fields from the original value
                    obj[prop] = deepDefaults(currentValue, defaultValue, depth + 1, overrideValues);
                }
                else {
                    obj[prop] = deepDefaults(currentValue, defaultValue, depth + 1, overrideValues);
                }
            }
            else {
                if (obj[prop] === undefined || overrideValues) {
                    obj[prop] = defaultValue;
                }
            }
        }
        index++;
    }
    return obj;
}
function setDefaults(item, defaultValue, ...properties) {
    for (let prop of properties) {
        if (item[prop] == null || item[prop] == undefined) {
            const value = item[prop];
            item[prop] = false;
            //item[prop]=false;
        }
    }
}

class DwQueryHelper {
    constructor() {
        this.fields = new DwQueryFieldsHelper();
        this.filters = new DwQueryFilterHelper();
        this.havingFilters = new DwQueryHavingFilterHelper();
        this.sampledFilterSimple = {
            FirstName: "Anthony",
            LastName: {
                Contains: "Mon",
                Prefix: "tableName",
            }
        };
        this.advancedFilter = {
            FirstName: "Anthony",
            Group1: {
                Op: "OR",
                LastName: {
                    Contains: "Mon"
                }
            },
            Group2: {
                OP: "OR",
                LastName: {
                    Contains: "Vau"
                }
            }
        };
    }
    convertToQuery(item, filters = null, sortOrder = [], pageInfo = null) {
        let query = new DwQuery(item);
        query.Order = this.buildOrder(item, sortOrder);
        query.getFieldSettings().LoadCustomAttributes = true;
        if (filters)
            query.Filter = this.buildFilters(item, filters);
        if (pageInfo) {
            // Used to always default this to true for the first page of paged queries, but the performance hit was too big
            //   Modified to check if the page result was the same as the page size (and if so, we have more pages).  This way, we don't need a total count of the data which could be costly
            /*  let includeCount = false;
            if (pageInfo.pageNo == 1)
                includeCount = true;
            */
            query.SetupPaging(pageInfo.pageNo, pageInfo.pageSize, pageInfo.returnCount, pageInfo.top);
        }
        return query;
    }
    convertExistingQuery(query, filters = null, sortOrder = [], pageInfo = null) {
        let item = query.RootTable;
        // Make a copy of the query so we don't modify the original
        query = Object.assign(new DwQuery(query.RootTable), query);
        const newOrder = this.buildOrder(item, sortOrder);
        if (newOrder && newOrder.length > 0) {
            query.Order = this.buildOrder(item, sortOrder);
        }
        query.getFieldSettings().LoadCustomAttributes = true;
        if (filters) {
            var newFilters = this.buildFilters(item, filters);
            if (!query.Filter || query.Filter.Filters.length == 0)
                query.Filter = newFilters;
            else {
                // Build a new filter group to combine both filters
                let newFilterGroup = new DwQueryFilterGroup();
                newFilterGroup.AddFilterAnd(query.Filter);
                newFilterGroup.AddFilterAnd(this.buildFilters(item, filters));
                query.Filter = newFilterGroup;
            }
        }
        if (pageInfo) {
            // Used to always default this to true for the first page of paged queries, but the performance hit was too big
            //   Modified to check if the page result was the same as the page size (and if so, we have more pages).  This way, we don't need a total count of the data which could be costly
            /*  let includeCount = false;
            if (pageInfo.pageNo == 1)
                includeCount = true;
            */
            query.SetupPaging(pageInfo.pageNo, pageInfo.pageSize, pageInfo.returnCount, pageInfo.top);
        }
        return query;
    }
    isSameQuery(query1, query2) {
        if (query1.RootTable != query2.RootTable)
            return false;
        try {
            const query1Json = JSON.stringify(query1);
            const query2Json = JSON.stringify(query2);
            if (query1Json == query2Json)
                return true;
        }
        catch (e) {
        }
        return false;
    }
    convertToPageResults(queryResults) {
        let results = new DwDataPageResults();
        if (queryResults.PageInfo) {
            results.pageInfo = new DwDataPageReturnInfo();
            results.pageInfo.currentPageNo = queryResults.PageInfo.CurrentPageNo;
            results.pageInfo.currentPageSize = queryResults.PageInfo.CurrentPageSize;
            results.pageInfo.totalPageCount = queryResults.PageInfo.TotalPageCount;
            results.pageInfo.totalRecordCount = queryResults.PageInfo.TotalRecordCount;
        }
        results.data = queryResults.Data;
        return results;
    }
    convertFilterType(filterType) {
        for (var filterItem in DwFilterType) {
            var value = DwFilterType[filterItem];
            if (value == filterType)
                return filterItem;
        }
    }
    filterTypeRequiresValue(filterType) {
        switch (filterType) {
            case DwFilterType.IsBlank:
            case DwFilterType.IsTrue:
            case DwFilterType.IsNotBlank:
            case DwFilterType.IsFalse:
            case DwFilterType.CurrentUser:
                return false;
        }
        return true;
    }
    buildFilters(item, filters) {
        if (!filters)
            return new DwQueryFilterGroup();
        // if the filters are already a filter group, we just return them as is
        if (filters instanceof DwQueryFilterGroup)
            return filters;
        let dwFilterGroup = new DwQueryFilterGroup();
        if (filters.Op)
            dwFilterGroup.Op = (filters.Op === DwOperator.Or) ? DwOperator.Or : DwOperator.And;
        for (let filterName in filters) {
            if (filterName === 'null') {
                continue;
            }
            let filterValue = filters[filterName];
            // Handle nested groups
            if (this.isGroup(filterName, filterValue)) {
                // If it is a real filter group, then just return it
                if (filterValue instanceof DwQueryFilterGroup || filterValue.Type === 'Group') {
                    dwFilterGroup.AddFilterAnd(filterValue);
                    continue;
                }
                // Remove the Op so it doesn't get added as a filter
                let filtersOnly = omit(filterValue, "Op");
                var groupFilter = this.buildFilters(item, filtersOnly);
                groupFilter.Op = filterValue.Op;
                // if (groupFilter.Op === DwOperator.Or)
                //     dwFilterGroup.AddFilterOr(groupFilter);
                // else
                //     dwFilterGroup.AddFilterAnd(groupFilter);
                dwFilterGroup.AddFilter(groupFilter);
            }
            else {
                // Add standard filters
                this.buildFilterItem(item, dwFilterGroup, filterName, filterValue);
            }
        }
        return dwFilterGroup;
    }
    buildFilterItem(item, dwFilterGroup, filterName, filter) {
        // if the filter isn't complex, then add it as an equal compare
        if (!isObject$1(filter)) {
            let dwFilter = this.createFilter(item, filterName, filter, DwFilterType.Equal);
            if (dwFilter)
                dwFilterGroup.AddFilterAnd(dwFilter);
        }
        else {
            // Check if this filter has a prefix (this is used to filter on relation fields)
            const prefix = filter.Prefix;
            // iterate over complex filter and add each piece
            for (let rawFilterType in filter) {
                if (filter.hasOwnProperty(rawFilterType) && rawFilterType !== 'Prefix') {
                    let filterValue = filter[rawFilterType];
                    let filterType = this.determineFilterType(rawFilterType);
                    if (filterType) {
                        if (filterType === DwFilterType.In)
                            filterValue = DwQueryFilterHelper.convertToArray(filterValue);
                        let dwFilter = this.createFilter(item, filterName, filterValue, filterType, prefix);
                        if (dwFilter) {
                            if (filter.Op === DwOperator.Or)
                                dwFilterGroup.AddFilterOr(dwFilter);
                            else
                                dwFilterGroup.AddFilterAnd(dwFilter);
                        }
                    }
                }
            }
        }
    }
    createFilter(item, fieldName, filterValue, filterType = DwFilterType.Equal, prefix = '') {
        let dwFilter = new DwQueryFilter();
        // Don't pass filters with null or undefined values or blank strings
        if (isUndefined(filterValue) || isNull(filterValue) || (typeof (filterValue) === "string" && filterValue.length === 0))
            return null;
        dwFilter.Type = filterType;
        dwFilter.Attr = this.buildField(item, fieldName, prefix);
        dwFilter.Value = filterValue;
        return dwFilter;
    }
    isGroup(propertyName, value) {
        if (!propertyName)
            return false;
        if (!value)
            return false;
        // It's a group if the property name starts with Group and it's an object
        if (propertyName.toUpperCase().indexOf("GROUP") === 0) {
            return value.Op;
        }
        return false;
    }
    determineFilterType(rawFilterType) {
        rawFilterType = rawFilterType.toUpperCase();
        var newFilterType;
        // Iterate over all possible filters (this will automatically handle any new filters)
        const validFilters = [];
        for (var filterType in DwFilterType) {
            if (filterType.toUpperCase() === rawFilterType)
                return DwFilterType[filterType];
            validFilters.push(filterType.toUpperCase());
        }
        console.warn(`Query - Invalid filter type '${rawFilterType}'.  Filter is being exluded from the query.  Valid filters are ${validFilters.join(', ')}`);
        return null;
    }
    buildOrder(item, sortOrder) {
        let order = [];
        for (let sortItem of sortOrder) {
            let orderBy = new DwQueryOrder();
            const finalItem = sortItem.tableName || item;
            orderBy.Field.FullFieldName = this.buildField(finalItem, sortItem.fieldName);
            orderBy.Field.RelationName = sortItem.relationPrefix;
            orderBy.IsAscending = sortItem.ascending;
            order.push(orderBy);
        }
        return order;
    }
    clearAllFields(query) {
        var _a;
        if (!query) {
            return;
        }
        let fieldList = [];
        if (query === null || query === void 0 ? void 0 : query.FieldSettings) {
            fieldList = query.FieldSettings.IncludeFields;
            query.FieldSettings.IncludeFields = [];
        }
        if (query.Relations) {
            if (((_a = query.RelationFields) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                fieldList = fieldList.concat(query.RelationFields);
                query.RelationFields = [];
            }
            fieldList = fieldList.concat(this.clearRelationFields(query.Relations));
        }
        return fieldList;
    }
    cloneQuery(query) {
        const newQuery = new DwQuery(query.RootTable);
        const clonedQuery = deepCopy(query);
        return Object.assign(newQuery, clonedQuery);
    }
    clearRelationFields(relations) {
        var _a;
        if (!relations) {
            return;
        }
        let fieldList = [];
        for (const relation of relations) {
            //relation.RelationFields = [];
            if (((_a = relation.RelationFields) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                fieldList = fieldList.concat(relation.RelationFields);
                relation.RelationFields = [];
            }
            if (relation.SubRelations) {
                fieldList = fieldList.concat(this.clearRelationFields(relation.SubRelations));
            }
        }
        return fieldList;
    }
    buildField(item, fieldName, prefix = '') {
        if (fieldName.indexOf(".") > 0)
            return fieldName;
        if (prefix) {
            return `${prefix}.${fieldName}`;
        }
        return `${this.getItemName(item)}.${fieldName}`;
    }
    getItemName(item) {
        let itemName;
        if (typeof (item) == "string")
            itemName = item;
        else
            itemName = item;
        return itemName;
    }
}

function sortArrayByField(array, fieldName, fieldName2, descending = false) {
    const field1Selector = (field) => {
        if (!field)
            return '';
        return field[fieldName];
    };
    let field2Selector = null;
    if (fieldName2) {
        const field2Selector = (field) => {
            if (!field)
                return '';
            return field[fieldName2];
        };
    }
    const result = sortArray(array, field1Selector, field2Selector);
    if (descending) {
        result.reverse();
    }
    return result;
}
function sortArray(array, fieldSelector, fieldSelector2) {
    if (!Array.isArray(array)) {
        return array;
    }
    if (!fieldSelector) {
        fieldSelector = (v) => v;
    }
    const log = false;
    logArrayMessage(log, 'Start Sort', array);
    const result = array.sort((a, b) => {
        var _a, _b;
        try {
            const compareResult = compareObjects(a, b, fieldSelector, fieldSelector2);
            logArrayMessage(log, `Compare ${(_a = a) === null || _a === void 0 ? void 0 : _a.display} (${fieldSelector(a)})  ${(_b = b) === null || _b === void 0 ? void 0 : _b.display} (${fieldSelector(b)}) = ${compareResult}`);
            return compareResult;
        }
        catch (e) {
            console.log('Error sorting', e);
            return 0;
        }
        // return -1;
    });
    logArrayMessage(log, 'Sort Complete', { source: array, result: result });
    return result;
}
function compareObjects(a, b, fieldSelector, fieldSelector2) {
    let aValue = fieldSelector(a);
    let bValue = fieldSelector(b);
    if (fieldSelector2) {
        aValue += fieldSelector2(a);
        bValue += fieldSelector2(b);
    }
    // Do a numeric compare
    if (!isNaN(aValue) && !isNaN(bValue)) {
        let result;
        //return aValue - bValue;
        if (aValue == bValue) {
            result = 0;
        }
        if (aValue > bValue) {
            result = 1;
        }
        if (bValue > aValue) {
            result = -1;
        }
        return result;
    }
    if (aValue == bValue) {
        return 0; // Equal
    }
    if (typeof (aValue) !== typeof (bValue)) {
        if (!aValue) {
            return -1; // less than
        }
        if (!bValue) {
            return 1; // greater than
        }
        aValue = aValue.toString();
        bValue = bValue.toString();
    }
    if (aValue == bValue) {
        return 0;
    }
    if (aValue > bValue) {
        return 1;
    }
    if (bValue > aValue) {
        return -1;
    }
    return -1;
}
function logArrayMessage(log, message, data) {
    if (log) {
        console.log(message, data);
    }
}
function groupBy(data, keySelector) {
    // reduce runs this anonymous function on each element of `data` (the `item` parameter,
    // returning the `storage` parameter at the end
    return data.reduce(function (storage, item) {
        // get the first instance of the key by which we're grouping
        var group = keySelector(item); // item[key];
        // set `storage` for this instance of group to the outer scope (if not empty) or initialize it
        storage[group] = storage[group] || [];
        // add this item to its group within `storage`
        storage[group].push(item);
        // return the updated storage to the reduce function, which will then loop through the next 
        return storage;
    }, {}); // {} is the initial value of the storage
}
;

function isEmptyObject(obj, valueIfNull = false) {
    if (!obj) {
        return valueIfNull;
    }
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}
function getBooleanDefault(currentValue, defaultValue) {
    if (currentValue === true || currentValue === false) {
        return currentValue;
    }
    return defaultValue;
}
/**
 * Ensurs that an items is an array.  If it's not as array, it returns an array with the item
 * @param arrayOrItem
 * @returns
 */
function ensureArray(arrayOrItem, removeNulls) {
    if (!Array.isArray(arrayOrItem)) {
        if (!arrayOrItem) {
            return [];
        }
        if (!arrayOrItem) {
            return [];
        }
        return [arrayOrItem];
    }
    arrayOrItem = arrayOrItem.filter(item => item != null && item != undefined);
    return arrayOrItem || [];
}
/**
 * Ensures taht the value is an observable
 * @param value value or observable
 * @returns
 */
function ensureObservable(value) {
    if (value instanceof Observable) {
        return value;
    }
    return of(value);
}
/**
 * Converts a comma delimited string to an array
 * @param value string (if it's already an array, it just returns it)
 * @param trimValues Trims all values in array to remove spaces
 * @param removeBlanks Removes any blank values from the array
 * @returns
 */
function convertToArray(value, trimValues = false, removeBlanks = false) {
    if (!value) {
        return [];
    }
    if (Array.isArray(value)) {
        return value;
    }
    // Split values, trim spaces and filter out blanks
    let cleanedValues = value.toString().split(',');
    if (trimValues) {
        cleanedValues = cleanedValues.map(value => value.trim());
    }
    if (removeBlanks) {
        cleanedValues = cleanedValues.filter(value => !!value);
    }
    return cleanedValues;
}
function flattenArray(array, fieldName) {
    const result = {};
    for (const item of array) {
        let key = item + '';
        if (fieldName) {
            key = item[fieldName] + '';
        }
        if (key) {
            result[key] = item;
        }
    }
    return result;
}
//export function groupByArray<T>(array: T[], fieldName?: keyof T): { [prop: string]: T[] } {
function groupByArray(array, fieldName) {
    return array
        .reduce((hash, obj) => {
        if (obj[fieldName] === undefined)
            return hash;
        return Object.assign(hash, { [obj[fieldName]]: (hash[obj[fieldName]] || []).concat(obj) });
    }, {});
}
function unflattenArray(flattenedArray) {
    const result = [];
    for (const prop in flattenedArray) {
        if (flattenedArray.hasOwnProperty(prop)) {
            const item = flattenedArray[prop];
            result.push(item);
        }
    }
    return result;
}
function getOrSetItem(flatObject, keyName, newObject) {
    if (!flatObject[keyName]) {
        flatObject[keyName] = newObject;
    }
    return flatObject[keyName];
}

function getParameterByName(router, name) {
    let url = router.url;
    const browserUrl = location.href.split('?')[1];
    if (browserUrl && router.url != browserUrl) {
        url = '/?' + browserUrl;
    }
    const urlTree = router.parseUrl(url);
    if (!urlTree || !urlTree.queryParams) {
        return;
    }
    for (let prop in urlTree.queryParams) {
        if (prop.toLowerCase() === name.toLowerCase()) {
            return urlTree.queryParams[prop];
        }
    }
}
function getUrlParameters(router) {
    let url = router.url;
    const browserUrl = location.href.split('?')[1];
    if (browserUrl && router.url != browserUrl) {
        url = '/?' + browserUrl;
    }
    const urlTree = router.parseUrl(url);
    return urlTree === null || urlTree === void 0 ? void 0 : urlTree.queryParams;
}
function isPathMatch(path) {
    const paths = ensureArray(path);
    const currentPath = location.pathname;
    for (let path of paths) {
        // do a starts with so children paths are automatically included
        if ((currentPath === null || currentPath === void 0 ? void 0 : currentPath.indexOf(path)) == 0) {
            return true;
        }
    }
    return false;
}
function hasParameters(router) {
    let url = router.url;
    const browserUrl = location.href.split('?')[1];
    return (!!browserUrl);
}
function removeParamFromurl(router, name) {
    const url = router.parseUrl(router.url);
    if (url.queryParams && url.queryParams[name]) {
        delete url.queryParams[name];
    }
    return url.toString();
}
function removeFragementFromurl(url) {
    const start = url.indexOf('#');
    return url.substring(0, start);
}
function getFragmentToken(url, fragmentName) {
    const start = url.indexOf('#');
    const hashUrl = url.substring(start + 1, url.length);
    const fragments = hashUrl.split('&');
    for (const fragment of fragments) {
        const paramParts = fragment.split('=');
        if (paramParts.length > 0) {
            const name = paramParts[0];
            const value = paramParts[1];
            if (name === fragmentName) {
                return value;
            }
        }
    }
}
function ensureEndingSlash(url) {
    if (!url.endsWith('/')) {
        url += '/';
    }
    return url;
}
function removeEndingSlash(url) {
    if (url.endsWith('/')) {
        url = url.substring(0, url.length - 1);
    }
    return url;
}
function getErrorDetails(errorResponse, existinErrorDetails) {
    const errorDetails = existinErrorDetails || {
        title: 'Unknown Error',
        message: 'An http error occured',
        status: 0,
        url: errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.url,
    };
    let error = {};
    if (errorResponse) {
        errorDetails.status = errorResponse.status;
        errorDetails.message = errorResponse.message;
        if (errorResponse.error) {
            error = existinErrorDetails || errorResponse.error;
        }
        if (error.message) {
            errorDetails.message = error.message;
        }
        if (error.detail) {
            errorDetails.message = error.detail;
        }
        if (error.instance) {
            errorDetails.logId = parseInt(error.instance);
        }
        if (error.type) {
            errorDetails.type = error.type;
        }
        if (error.errors) {
            errorDetails.title = error.title;
            errorDetails.message = convertErrorsToMessage(error.errors);
        }
        if ((errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.message) && errorDetails.message.indexOf(errorResponse.url) >= 0) {
            errorDetails.message = 'Unknown Server Error';
        }
    }
    switch (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.status) {
        case 0:
            errorDetails.message = 'Api is not responding';
            errorDetails.title = errorDetails.title || 'Server Error';
            break;
        case 400:
            errorDetails.title = errorDetails.title || 'Invalid Request';
            break;
        case 401:
            errorDetails.title = errorDetails.title || 'Unauthorized Request';
            break;
        case 405:
            errorDetails.title = errorDetails.title || 'Development Error';
            errorDetails.message = 'An invalid API call was made';
            let detailedMessage = `Invalid api call to url: ${errorResponse.url} - Method not allowed`;
            // console.log(`Invalid api call to url: ${errorResponse.url} - Method not allowed`, errorResponse.message)
            break;
        case 500:
        default:
            errorDetails.title = 'Server Error';
    }
    return errorDetails;
}
function convertErrorsToMessage(errors) {
    if (!errors) {
        return;
    }
    let messages = [];
    for (let prop in errors) {
        if (errors.hasOwnProperty(prop)) {
            const error = errors[prop];
            messages.push(error);
        }
    }
    return messages.join(',');
}

const DwConfigLoaderToken = new InjectionToken('DwConfigLoader');

const DwConfigServiceToken = new InjectionToken('DwConfigService');
class DwConfigService {
    constructor(injector, configLoaders) {
        this.injector = injector;
        this.configLoaders = configLoaders;
    }
    static addConfigProvider(configProvider) {
        DwConfigService._configProviders.push(configProvider);
    }
    static addConfigProviderType(type) {
        DwConfigService._configProvidersTypes.push(type);
    }
    get coreConfig() {
        if (!DwConfigService._coreConfig) {
            DwConfigService._coreConfig = {};
        }
        return DwConfigService._coreConfig;
    }
    get configProviders() {
        return DwConfigService._configProviders;
    }
    getApiRoot(module) {
        var _a;
        var alternateRoot = (_a = this.coreConfig.alternateApiRoots) === null || _a === void 0 ? void 0 : _a[module];
        if (alternateRoot) {
            return alternateRoot;
        }
        return this.coreConfig.apiRoot;
    }
    waitForConfigLoader() {
        if (!this.configLoaders) {
            this.configLoaders = [{ loadConfig: () => of(null) }];
        }
        if (!Array.isArray(this.configLoaders)) {
            this.configLoaders = [this.configLoaders];
        }
        const obs = [];
        for (const loader of this.configLoaders) {
            obs.push(loader.loadConfig());
        }
        return combineLatest(obs)
            .pipe(tap(() => {
            this.createCoreProviders();
            this.processCoreConfigs();
        }));
    }
    createCoreProviders() {
        for (const configProviderType of DwConfigService._configProvidersTypes) {
            const configProvider = this.injector.get(configProviderType);
            this.configProviders.push(configProvider);
        }
        DwConfigService._configProvidersTypes.length = 0;
    }
    processCoreConfigs() {
        const configProviders = sortArrayByField(this.configProviders, 'priority');
        for (const configProvider of configProviders) {
            configProvider.configureCoreConfig(this.coreConfig);
        }
        this.coreConfig.apiRoot = removeEndingSlash(this.coreConfig.apiRoot);
    }
    getConfig(configName, defaultConfig = null) {
        var _a, _b;
        let configItem = null;
        // Check for an existing config item first
        if ((_a = this.coreConfig) === null || _a === void 0 ? void 0 : _a.childConfigs) {
            configItem = (_b = this.coreConfig) === null || _b === void 0 ? void 0 : _b.childConfigs[configName];
        }
        if (configItem) {
            return configItem;
        }
        // Ensure all core providers are created
        this.createCoreProviders();
        if (!configItem && defaultConfig) {
            configItem = defaultConfig;
            for (const configProvider of this.configProviders) {
                configProvider.configureCoreConfig(this.coreConfig);
                configProvider.configureAdditionalConfig(configName, configItem, this.coreConfig);
            }
            this.coreConfig.childConfigs = this.coreConfig.childConfigs || {};
            this.coreConfig.childConfigs[configName] = configItem;
        }
        if (configItem)
            return configItem;
        throw new Error(`${configName} was not found and no default was presented`);
    }
}
DwConfigService.ɵfac = function DwConfigService_Factory(t) { return new (t || DwConfigService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwConfigLoaderToken, 8)); };
DwConfigService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwConfigService, factory: DwConfigService.ɵfac });
// Store the config as static so it's a true singleton 
//    This is required since lazy loaded modules create new instances of singleton services
DwConfigService._coreConfig = null; // {} as any as DwCoreConfig; // Have to initialize due to the template compiler
DwConfigService._configProviders = [];
DwConfigService._configProvidersTypes = [];
DwConfigService.ctorParameters = () => [
    { type: Injector },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [DwConfigLoaderToken,] }] }
];

class DwEvent {
}
class DwBroadcastEvent {
}
function isBroadcastEvent(event) {
    if (event.originId) {
        return true;
    }
    return false;
}

const ALL_TOPICS = '*';
class DwEventService {
    constructor() {
        this.setupBroadcastMessages();
    }
    publishBroadcastMessage(topic, data) {
        if (!DwEventService.broadcastChannel) {
            return;
        }
        const event = {
            topic: topic,
            data: data,
            originId: DwEventService.eventServiceId.toString()
        };
        DwEventService.broadcastChannel.postMessage(event);
        //console.log('publish broadcast message', event);
    }
    setupBroadcastMessages() {
        try {
            if (DwEventService.broadcastChannel == null) {
                DwEventService.broadcastChannel = new BroadcastChannel('devware-metadata');
            }
        }
        catch (e) {
            console.warn('Could not configure Meta Data Broadcast channel for inter browswer messaging');
            return;
        }
        DwEventService.broadcastChannel.addEventListener('message', (e) => {
            const event = e.data;
            if (event && event.originId != DwEventService.eventServiceId) {
                this.republishEvent(event);
            }
            console.log('Broadcast event', event);
        });
    }
    getTopic(topic, useBehaviorSubject = true) {
        let subject = DwEventService.eventSubjects.get(topic);
        if (!subject) {
            subject = useBehaviorSubject ? new BehaviorSubject(null) : new Subject();
            DwEventService.eventSubjects.set(topic, subject);
        }
        return subject;
    }
    getTopicLastEvent(topic) {
        let subject = DwEventService.eventSubjects.get(topic);
        if (subject && subject instanceof BehaviorSubject) {
            return subject.value;
        }
        return null;
    }
    getEvent(topic = null, excludeBlankMessages = true, useBehaviorSubject = true) {
        var ob = this.getTopic(topic, useBehaviorSubject).asObservable();
        // Filter out blank messages
        if (excludeBlankMessages) {
            ob = ob.pipe(filter(e => e != null));
        }
        return ob;
    }
    getEventData(topic, useBehaviorSubject = true) {
        return this.getEvent(topic, useBehaviorSubject)
            .pipe(map((event) => {
            return event.data;
        }));
    }
    isTopicMatch(topicPattern, topic) {
        if (topicPattern == topic)
            return true;
        if (topicPattern.indexOf('*') >= 0)
            return this.isTopicPatternMatch(topicPattern, topic);
        return false;
    }
    isTopicPatternMatch(topicPattern, topic) {
        return DwEventService.isTopicPatternMatch(topicPattern, topic);
    }
    // Matches topic patterns such as topic.* or topic.sub* or topic.subtopic.*  (Not ok to*pic)
    static isTopicPatternMatch(topicPattern, topic) {
        var patternParts = topicPattern.split('.');
        var topicParts = topic.split('.');
        //for (var i = 0; i < patternParts.length; i++) {
        //}
        let index = 0;
        for (let patternPart of patternParts) {
            // Check if there are more parts to match that exists in normal topic
            if (index > topicParts.length)
                return false;
            var topicPart = topicParts[index];
            let wildCardIndex = patternPart.indexOf(ALL_TOPICS);
            if (wildCardIndex < 0) {
                if (patternPart != topicPart)
                    return false;
            }
            else {
                let searchPart = patternPart.substring(0, wildCardIndex);
                if (searchPart.length > 0 && topicPart.indexOf(searchPart) != 0)
                    return false;
            }
            index++;
        }
        return true;
    }
    publishEvent(topic, data, useBehaviorSubject = true) {
        let event = new DwEvent();
        event.topic = topic;
        event.data = data;
        ////console.log('Published Message: ' + topic, data);
        var eventSubject = this.getTopic(topic, useBehaviorSubject);
        eventSubject.next(event);
    }
    republishEvent(event, useBehaviorSubject = true) {
        var eventSubject = this.getTopic(event.topic, useBehaviorSubject);
        eventSubject.next(event);
    }
}
DwEventService.ɵfac = function DwEventService_Factory(t) { return new (t || DwEventService)(); };
DwEventService.eventSubjects = new Map();
DwEventService.broadcastChannel = null;
DwEventService.eventServiceId = Math.random().toString();
DwEventService.ɵprov = ɵɵdefineInjectable({ factory: function DwEventService_Factory() { return new DwEventService(); }, token: DwEventService, providedIn: "root" });
DwEventService.ctorParameters = () => [];

var DwCacheStorageLocation;
(function (DwCacheStorageLocation) {
    DwCacheStorageLocation[DwCacheStorageLocation["memory"] = 0] = "memory";
    DwCacheStorageLocation[DwCacheStorageLocation["sessionStorage"] = 1] = "sessionStorage";
    DwCacheStorageLocation[DwCacheStorageLocation["localStorage"] = 2] = "localStorage";
})(DwCacheStorageLocation || (DwCacheStorageLocation = {}));

var DwLogSeverity;
(function (DwLogSeverity) {
    DwLogSeverity["info"] = "Info";
    DwLogSeverity["error"] = "Error";
    DwLogSeverity["critical"] = "Critical";
    DwLogSeverity["warning"] = "Warning";
    DwLogSeverity["verbose"] = "Verbose";
    DwLogSeverity["start"] = "Start";
    DwLogSeverity["end"] = "End";
})(DwLogSeverity || (DwLogSeverity = {}));

var DwErrorHeaders;
(function (DwErrorHeaders) {
    DwErrorHeaders["suppressErrorMessagesHeader"] = "supppresssErrorMessagesHeader";
    DwErrorHeaders["suppressErrorMessagesLogHeader"] = "supppresssErrorMessagesLogHeader";
})(DwErrorHeaders || (DwErrorHeaders = {}));

class DwSecurityStateCurrent {
}
DwSecurityStateCurrent.securityState = null;
var DwAuthenticationType;
(function (DwAuthenticationType) {
    DwAuthenticationType["login"] = "login";
    DwAuthenticationType["loginSSO"] = "loginSSO";
    DwAuthenticationType["emulation"] = "emulation";
    DwAuthenticationType["cancelEmulation"] = "cancelEmulation";
    DwAuthenticationType["logout"] = "logout";
    DwAuthenticationType["reauthenticate"] = "reauthenticate";
    DwAuthenticationType["reauthenticateSSO"] = "reauthenticateSSO";
    DwAuthenticationType["init"] = "init";
})(DwAuthenticationType || (DwAuthenticationType = {}));

class DwLoggingService {
    constructor(http, router, configService, injector) {
        this.http = http;
        this.router = router;
        this.configService = configService;
        this.injector = injector;
        this.processingStoredErrors = false;
        this.relogAttempts = 3;
        this.relogDelayOverride = null;
        this.logStoredErrorsInterval = (60 * 1000); // log stored errors every 60 seconds
        this.setupStoredErrorLogging();
    }
    // private loggingApi: string;
    get dwLoggingConfig() {
        return this.configService.coreConfig.loggingConfig;
    }
    get securityState() {
        // Access the static version of security state (This prevents a circular dependency between security and logging)
        return DwSecurityStateCurrent.securityState;
    }
    setupStoredErrorLogging() {
        setInterval(() => {
            this.logStoredErrors();
        }, this.logStoredErrorsInterval);
    }
    logStoredErrors() {
        var _a;
        if (this.processingStoredErrors) {
            return;
        }
        this.processingStoredErrors = true;
        try {
            let storedErrors = this.getStoredErrors();
            if (storedErrors.length == 0) {
                this.processingStoredErrors = false;
                return;
            }
            // Wait until the user is authenticated to relog errors
            if (!((_a = this.securityState) === null || _a === void 0 ? void 0 : _a.isAuthenticated)) {
                this.processingStoredErrors = false;
                return;
            }
            this.logToConsole(`Logging stored errors: ${storedErrors.length} errors found`);
            const logItem = {
                Message: `Logging stored errors: ${storedErrors.length} errors found`,
                Severity: DwLogSeverity.warning
            };
            this.logToServer(logItem, 0, true)
                .subscribe(result => {
                if (!result) {
                    this.processingStoredErrors = false;
                    return;
                }
                storedErrors = this.getStoredErrors();
                localStorage.removeItem('dwStoredErrors');
                for (let storedError of storedErrors) {
                    const newLogItem = Object.assign({}, storedError.logItem);
                    if (newLogItem.Message.indexOf('Stored Error at') == -1) {
                        newLogItem.Message = `Stored Error at ${storedError.originalLogDateTime}: ${storedError.logItem.Message}`;
                    }
                    this.logToServer(newLogItem, storedError.attempts);
                }
                this.processingStoredErrors = false;
            });
        }
        catch (e) {
            this.logToConsole("Failed to log stored errors", e, DwLogSeverity.error);
            this.processingStoredErrors = false;
        }
    }
    logWarning(message, data, forceLogToServer = false) {
        const logItem = {
            Message: message,
            Severity: DwLogSeverity.warning
        };
        this.log(logItem, data, forceLogToServer);
    }
    logVerbose(message, data, forceLogToServer = false) {
        const logItem = {
            Message: message,
            Severity: DwLogSeverity.verbose
        };
        this.log(logItem, data, forceLogToServer);
    }
    logInfo(message, data, forceLogToServer = false) {
        const logItem = {
            Message: message,
            Severity: DwLogSeverity.info
        };
        this.log(logItem, data, forceLogToServer);
    }
    logError(message, error, data, forceLogToServer = false, errorDetails = null) {
        const logItem = {
            Message: message,
            Severity: DwLogSeverity.error,
            ErrorDetails: errorDetails
        };
        if (errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.url) {
            logItem.Url = errorDetails.url;
        }
        else {
            logItem.Url = this.router.url;
        }
        logItem.Exception = {
            Message: error.message || message,
            StackTrace: error.stack,
        };
        this.log(logItem, data, forceLogToServer);
    }
    log(logItem, data, forceLogToServer = false) {
        const logOptions = this.getLogToOptions(logItem.Severity);
        if (logOptions.logToConsole) {
            this.logToConsole(logItem.Message, data, logItem.Severity);
        }
        if (logOptions.logToServer || forceLogToServer) {
            this.logToServer(logItem);
        }
    }
    logToConsole(message, data = null, severity = DwLogSeverity.verbose) {
        const logOptions = this.getLogToOptions(severity);
        if (!logOptions.logToConsole) {
            return;
        }
        switch (severity) {
            case DwLogSeverity.warning:
                if (data) {
                    console.warn(`${message}`, data);
                }
                else {
                    console.warn(`${message}`);
                }
                break;
            case DwLogSeverity.error:
                if (data) {
                    console.error(`${message}`, data);
                }
                else {
                    console.error(`${message}`);
                }
                break;
            default:
                if (data) {
                    console.log(`${message}`, data);
                }
                else {
                    console.log(`${message}`);
                }
        }
    }
    logToServer(logItem, attempt = 1, preventRetry = false) {
        var _a, _b;
        var subject = new Subject();
        if (!((_a = this.securityState) === null || _a === void 0 ? void 0 : _a.isAuthenticated)) {
            this.storeErrorForLater(logItem, attempt);
            return of(false);
        }
        const originalLogItem = Object.assign({}, logItem);
        if ((_b = this.dwLoggingConfig) === null || _b === void 0 ? void 0 : _b.serverMessagePrefix) {
            if (!logItem.Message.startsWith(this.dwLoggingConfig.serverMessagePrefix)) {
                logItem.Message = `${this.dwLoggingConfig.serverMessagePrefix}${logItem.Message}`;
            }
        }
        const loggingApi = `${this.configService.coreConfig.apiRoot}/general/logging`;
        // logItem.Url = this.router.url;
        let url = `${loggingApi}`;
        let headers = new HttpHeaders();
        headers = headers.append(DwErrorHeaders.suppressErrorMessagesHeader, 'true');
        headers = headers.append(DwErrorHeaders.suppressErrorMessagesLogHeader, 'true');
        if (attempt > 1) {
            this.logToConsole(`LogToServer Attempt ${attempt}`);
        }
        let result = this.http.post(url, logItem, { headers: headers });
        result.pipe(delay(50), catchError(errorResponse => {
            if (!preventRetry) {
                this.RetryLogError(originalLogItem, errorResponse, attempt + 1);
            }
            subject.next(false);
            return of(null);
        }))
            .subscribe(result => {
            // Nothing to do with the result, just subscribing so the api will be called
            subject.next(!!result);
        });
        return subject.asObservable();
    }
    RetryLogError(logItem, errorResponse, attempt) {
        if (attempt > this.relogAttempts) {
            this.logToConsole("Failed to log to server after 5 attempts", errorResponse, DwLogSeverity.error);
            this.storeErrorForLater(logItem, attempt);
            return;
        }
        let delay = this.relogDelayOverride || ((attempt * attempt) * 1000);
        setTimeout(() => {
            this.logToServer(logItem, attempt);
        }, delay);
    }
    storeErrorForLater(logItem, attempts) {
        var _a, _b;
        try {
            let storedErrors = this.getStoredErrors();
            console.log('Stored Errors', storedErrors);
            //const user = this.dwSecurityUserService.securityState?.securityContext?.AuthenticatedUser;
            const storedError = {
                logItem: logItem,
                user: (_b = (_a = this.securityState) === null || _a === void 0 ? void 0 : _a.securityContext) === null || _b === void 0 ? void 0 : _b.AuthenticatedUser,
                originalLogDateTime: new Date().toISOString(),
                attempts: attempts
            };
            storedErrors.push(storedError);
            localStorage.setItem('dwStoredErrors', JSON.stringify(storedErrors));
        }
        catch (e) {
            this.logToConsole("Failed to store error for later", e, DwLogSeverity.error);
        }
    }
    getStoredErrors() {
        try {
            let storedErrorsJson = localStorage.getItem('dwStoredErrors');
            let storedErrors = [];
            if (storedErrorsJson) {
                storedErrors = JSON.parse(storedErrorsJson);
            }
            return storedErrors;
        }
        catch (e) {
            this.logToConsole("Failed to store error for later", e, DwLogSeverity.error);
        }
    }
    getLogToOptions(severity) {
        const results = {
            logToConsole: false,
            logToServer: false
        };
        if (this.dwLoggingConfig) {
            results.logToConsole = (this.dwLoggingConfig.writeAllToConsole || (this.dwLoggingConfig.writeToConsoleLevels && this.dwLoggingConfig.writeToConsoleLevels.indexOf(severity) >= 0));
            results.logToServer = (this.dwLoggingConfig.writeAllToServer || (this.dwLoggingConfig.writeToServerLevels && this.dwLoggingConfig.writeToServerLevels.indexOf(severity) >= 0));
        }
        return results;
    }
}
DwLoggingService.ɵfac = function DwLoggingService_Factory(t) { return new (t || DwLoggingService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwLoggingService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwLoggingService, factory: DwLoggingService.ɵfac });
DwLoggingService.ctorParameters = () => [
    { type: HttpClient },
    { type: Router },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: Injector }
];
class DwLogToOptions {
}

class DwCacheItem {
    constructor() {
        this.expirationDateTime = null;
    }
}

const moment = moment_;
class DwStorageUtil {
    constructor(loggingUtil) {
        this.loggingUtil = loggingUtil;
        this.useLocalStorage = false;
    }
    getStorage() {
        if (this.useLocalStorage) {
            return localStorage;
        }
        return sessionStorage;
    }
    local() {
        const storage = new DwStorageUtil(this.loggingUtil);
        storage.useLocalStorage = true;
        return storage;
    }
    session() {
        return new DwStorageUtil(this.loggingUtil);
    }
    setValue(key, value, options = null) {
        const storage = this.getStorage();
        try {
            const item = new DwCacheItem();
            item.value = value;
            item.expirationDateTime = this.getExpirationDate(options);
            storage.setItem(key, JSON.stringify(item));
        }
        catch (e) {
            // Ignore errors (but log them)
            this.loggingUtil.logError(`DwStorageUtil - Error setting storage value ${key}`, e);
        }
    }
    getValue(key) {
        const storage = this.getStorage();
        try {
            const rawStoregeItem = storage.getItem(key);
            if (rawStoregeItem && rawStoregeItem !== 'null') {
                const item = JSON.parse(rawStoregeItem);
                if (this.isExpired(item)) {
                    this.loggingUtil.logToConsole(`DwStorageUtil - Key ${key} has expired`);
                    return null;
                }
                return item.value;
            }
        }
        catch (e) {
            // Ignore errors
            // Ignore errors (but log them)
            this.loggingUtil.logError(`DwStorageUtil - Error getting storage value ${key}`, e);
        }
        return null;
    }
    getExpirationDate(options) {
        if (options == null) {
            return null;
        }
        if (options.expirationDateTime) {
            return options.expirationDateTime;
        }
        if (options.expirationInMinutes) {
            return moment().add(options.expirationInMinutes, 'minutes').toDate();
        }
        return null;
    }
    isExpired(item) {
        // No expiration currently
        return false;
    }
}
DwStorageUtil.ɵfac = function DwStorageUtil_Factory(t) { return new (t || DwStorageUtil)(ɵngcc0.ɵɵinject(DwLoggingService)); };
DwStorageUtil.ɵprov = ɵɵdefineInjectable({ factory: function DwStorageUtil_Factory() { return new DwStorageUtil(ɵɵinject(DwLoggingService)); }, token: DwStorageUtil, providedIn: "root" });
DwStorageUtil.ctorParameters = () => [
    { type: DwLoggingService }
];

/**
 * Cache Service is an observables based in-memory cache implementation
 * Keeps track of in-flight observables and sets a default expiration for cached values
 */
class DwCacheService {
    constructor(dwEventService, configService, dwStorageUtil) {
        this.dwEventService = dwEventService;
        this.configService = configService;
        this.dwStorageUtil = dwStorageUtil;
        this.DEFAULT_MAX_AGE = 300000;
        this.DEFAULT_MAX_FALLBACK_TIMEOUT = 30000;
        this.MINUTES_TO_MILLESECONDS = 1000 * 60;
        this.DEFAULT_MAX_FALLBACK_TIMEOUT = configService.coreConfig.cacheLoadTimeoutMs || this.DEFAULT_MAX_FALLBACK_TIMEOUT;
    }
    isEventMatch(event, item) {
        const cacheInvalidationTopics = item.cacheOptions.cacheInvalidationsTopics;
        if (!cacheInvalidationTopics || !cacheInvalidationTopics.length)
            return false;
        for (let cacheInvalidationTopic of cacheInvalidationTopics) {
            let invalidationTopic;
            if (typeof (cacheInvalidationTopic) === 'string') {
                invalidationTopic = cacheInvalidationTopic;
            }
            else {
                invalidationTopic = cacheInvalidationTopic.eventTopic;
            }
            if (DwEventService.isTopicPatternMatch(invalidationTopic, event.topic)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Gets the value from cache with the key and automatically tracks in-flight observables if another request for the same cache item has been made
     * @param key unique key accros the application for the cache item
     * @param fallback an observable that loads the data (for first time load or after cache expiration)
     * @param maxAge time in millisecond when the cache item will expire - Defaults to 5 minutes (300,000ms)
     * @param cacheInvalidationsTopics event topics that causes the cache item to be cleared
     * @param cacheClearSubject subject users to notify called when the cache expires (can be used to proactively repopulate the cache)
     * @param fallbackTimeout timeout for the fallback obserabled - default is 30 seconds
     * @returns
     */
    get(key, fallback, maxAge, cacheInvalidationsTopics, cacheClearSubject, fallbackTimeout) {
        const cacheOptions = {};
        cacheOptions.expirationInMinutes = maxAge;
        cacheOptions.cacheClearSubject = cacheClearSubject;
        cacheOptions.fallbackTimeout = fallbackTimeout;
        cacheOptions.cacheInvalidationsTopics = cacheInvalidationsTopics;
        return this.getWithOptions(key, fallback, cacheOptions);
    }
    /**
     *
     * @param cacheOptions
     * @returns
     */
    applyCacheOptionDefaults(cacheOptions) {
        cacheOptions = cacheOptions || {};
        cacheOptions.fallbackTimeout = cacheOptions.fallbackTimeout || this.DEFAULT_MAX_FALLBACK_TIMEOUT;
        if (!cacheOptions.expirationInMinutes && !cacheOptions.expirationInMinutes) {
            cacheOptions.expirationInMinutes = this.DEFAULT_MAX_AGE;
        }
        return cacheOptions;
    }
    /**
      * Gets the value from cache if the key is provided.
      * If no value exists in cache, then check if the same call exists
      * in flight, if so return the subject. If not create a new
      * Subject inFlightObservable and return the source observable.
      */
    getWithOptions(key, fallback, cacheOptions) {
        cacheOptions = this.applyCacheOptionDefaults(cacheOptions);
        if (this.hasValidCachedValue(key)) {
            return of(DwCacheService.cache.get(key).value);
        }
        const storageValue = this.getStoredValue(key, cacheOptions);
        if (storageValue) {
            this.setWithOptions(key, storageValue, cacheOptions);
            return of(storageValue);
        }
        let finalCacheInvalidationTopics;
        if (DwCacheService.inFlightObservables.has(key)) {
            return DwCacheService.inFlightObservables.get(key);
        }
        else if (fallback && fallback instanceof Observable) {
            DwCacheService.inFlightObservables.set(key, new Subject());
            // Conditionally add a timeout for the fallback to complete in
            if (cacheOptions.fallbackTimeout > 0) {
                fallback = fallback
                    .pipe(
                // Add a timeout to ensure that all cache items eventually return
                timeout(cacheOptions.fallbackTimeout));
            }
            fallback.subscribe(value => {
                this.setWithOptions(key, value, cacheOptions);
            }, error => {
                // This can something be synchronous and fail before the method has returned
                this.handleFallbackError(key, error);
            });
            // Double check that the value hasn't been loaded (if the fallback is synchronous, then this value would already be set and there wouldn't be an inFlight Observable)
            if (this.hasValidCachedValue(key)) {
                return of(DwCacheService.cache.get(key).value);
            }
            const inFlight = DwCacheService.inFlightObservables.get(key);
            if (inFlight) {
                return inFlight;
                // Not sure if we should throw an error, return the fallback, or re-call the entire method
                return throwError(`Can't find cache inFlightObservable for key ${key}`);
                // return fallback;
            }
        }
        else {
            return Observable.throw('Requested key is not available in Cache');
        }
    }
    /**
     * Sets the value with key in the cache
     * Notifies all observers of the new value
     */
    set(key, value, maxAge = this.DEFAULT_MAX_AGE, cacheInvalidationsTopics, cacheClearSubject) {
        const cacheOptions = {};
        cacheOptions.expirationInMinutes = maxAge;
        cacheOptions.cacheClearSubject = cacheClearSubject;
        cacheOptions.cacheInvalidationsTopics = cacheInvalidationsTopics;
        return this.setWithOptions(key, value, cacheOptions);
    }
    /**
    * Sets the value with key in the cache
    * Notifies all observers of the new value
    */
    setWithOptions(key, value, cacheOptions) {
        cacheOptions = this.applyCacheOptionDefaults(cacheOptions);
        DwCacheService.cache.set(key, {
            value: value,
            expirationDateTime: cacheOptions.expirationDateTime || Date.now() + cacheOptions.expirationInMinutes * this.MINUTES_TO_MILLESECONDS,
            cacheOptions: cacheOptions
        });
        this.setStoredValue(key, value, cacheOptions);
        this.setupCacheInvalidationSubscriptions(key, cacheOptions.cacheInvalidationsTopics);
        this.notifyInFlightObservers(key, value);
    }
    handleFallbackError(key, error) {
        error = this.translateError(key, error);
        // Pass error on to all inFlight observables (otherwise they will be stuck indefinitely)
        if (DwCacheService.inFlightObservables.has(key)) {
            // Delay throwing the error since this can cause the in flight observable to be missing at the end of the getWithOptions method
            setTimeout(() => {
                const inFlight = DwCacheService.inFlightObservables.get(key);
                const observersCount = inFlight.observers.length;
                if (observersCount) {
                    inFlight.error(error);
                }
                inFlight.complete();
                DwCacheService.inFlightObservables.delete(key);
            });
        }
        return error;
    }
    translateError(key, error) {
        if (error && error.name == 'TimeoutError') {
            return {
                name: 'CacheLoadedTimeoutError',
                message: `Loading for cache item ${key} has timed out.`
            };
        }
        return error;
    }
    setupCacheInvalidationSubscriptions(key, cacheInvalidationsTopics) {
        if (!cacheInvalidationsTopics) {
            return;
        }
        for (let topic of cacheInvalidationsTopics) {
            if (typeof topic === 'string') {
                this.setupCacheInvalidationSubscription(key, topic);
            }
        }
    }
    setupCacheInvalidationSubscription(key, topic) {
        let subscription = DwCacheService.cacheInvalidationEventSubscriptions.get(topic);
        if (!subscription) {
            subscription = this.dwEventService.getEvent(topic)
                .subscribe(event => {
                this.processEvent(event);
            });
            DwCacheService.cacheInvalidationEventSubscriptions.set(topic, subscription);
        }
    }
    processEvent(event) {
        DwCacheService.cache.forEach((item, key) => {
            if (this.isEventMatch(event, item)) {
                // expire cache immediately
                item.expirationDateTime = Date.now();
                item.value = null;
                if (item.cacheOptions.cacheClearSubject) {
                    item.cacheOptions.cacheClearSubject.next(key);
                }
            }
        });
    }
    /**
     * Checks if the a key exists in cache
     */
    has(key) {
        return DwCacheService.cache.has(key);
    }
    /**
     * Publishes the value to all observers of the given
     * in progress observables if observers exist.
     */
    notifyInFlightObservers(key, value) {
        if (DwCacheService.inFlightObservables.has(key)) {
            const inFlight = DwCacheService.inFlightObservables.get(key);
            const observersCount = inFlight.observers.length;
            if (observersCount) {
                ////console.log(`%cNotifying ${inFlight.observers.length} flight subscribers for ${key}`, 'color: blue');
                inFlight.next(value);
            }
            inFlight.complete();
            DwCacheService.inFlightObservables.delete(key);
        }
    }
    /**
     * Checks if the key exists and   has not expired.
     */
    hasValidCachedValue(key) {
        if (DwCacheService.cache.has(key)) {
            if (DwCacheService.cache.get(key).expirationDateTime < Date.now()) {
                DwCacheService.cache.delete(key);
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    }
    getStoredValue(key, cacheOptions) {
        const storageUtil = this.getStorageLocation(cacheOptions);
        if (!storageUtil) {
            return;
        }
        const storageKey = `Cache_${key}`;
        storageUtil.getValue(storageKey);
    }
    setStoredValue(key, value, cacheOptions) {
        const storageUtil = this.getStorageLocation(cacheOptions);
        if (!storageUtil) {
            return;
        }
        const storageKey = `Cache_${key}`;
        storageUtil.setValue(storageKey, value, {
            expirationDateTime: cacheOptions.expirationDateTime,
            expirationInMinutes: cacheOptions.expirationInMinutes
        });
    }
    getStorageLocation(cacheOptions) {
        switch (cacheOptions.storageLocation) {
            case DwCacheStorageLocation.sessionStorage:
                return this.dwStorageUtil.session();
            case DwCacheStorageLocation.localStorage:
                return this.dwStorageUtil.local();
        }
        return null;
    }
    clearAllClientCaches() {
        DwCacheService.cache.clear();
    }
}
DwCacheService.ɵfac = function DwCacheService_Factory(t) { return new (t || DwCacheService)(ɵngcc0.ɵɵinject(DwEventService), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwStorageUtil)); };
DwCacheService.cache = new Map();
DwCacheService.inFlightObservables = new Map();
DwCacheService.cacheInvalidationEventSubscriptions = new Map();
DwCacheService.ɵprov = ɵɵdefineInjectable({ factory: function DwCacheService_Factory() { return new DwCacheService(ɵɵinject(DwEventService), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwStorageUtil)); }, token: DwCacheService, providedIn: "root" });
DwCacheService.ctorParameters = () => [
    { type: DwEventService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwStorageUtil }
];

class DwOrmData {
}
function isOrmData(item) {
    if (item && item._itemName)
        return true;
    return false;
}

var DwSaveType;
(function (DwSaveType) {
    DwSaveType["insert"] = "insert";
    DwSaveType["update"] = "update";
    DwSaveType["delete"] = "delete";
    DwSaveType["updateCollection"] = "updateCollection";
})(DwSaveType || (DwSaveType = {}));

var DwMdEventType;
(function (DwMdEventType) {
    DwMdEventType["load"] = "load";
    DwMdEventType["create"] = "create";
    DwMdEventType["update"] = "update";
    DwMdEventType["delete"] = "delete";
    DwMdEventType["query"] = "query";
})(DwMdEventType || (DwMdEventType = {}));

function areEqual(value1, value2, ...excludeProperties) {
    if (value1 == null && value2 == null)
        return true;
    if (value1 == null || value2 == null)
        return false;
    try {
        if (!isObject(value1) && !isObject(value2)) {
            return value1 === value2;
        }
        if (typeof (value1) == 'string' && typeof (value2) == 'string') {
            return value1.toUpperCase() === value2.toUpperCase();
        }
        if (excludeProperties && excludeProperties.length > 0) {
            var value1Copy = Object.assign({}, value1);
        }
        const newValue1 = excludeObjectProperties(value1, excludeProperties);
        const newValue2 = excludeObjectProperties(value2, excludeProperties);
        const json1 = JSON.stringify(newValue1);
        const json2 = JSON.stringify(newValue2);
        if (json1 === json2)
            return true;
        return false;
    }
    catch (ex) {
        console.error("areEqual failure", ex);
    }
    return value1 == value2;
}
function areEqualDeepCompare(value1, value2, depth = 0, ...excludeProperties) {
    const changeDetails = {
        pathParts: [],
    };
    const result = areEqualDeepCompareWithChangeDetail(value1, value2, depth, changeDetails, excludeProperties);
    if (!result) {
        // toggle at runtime to build and show difference
        let showMessage = false;
        if (showMessage) {
            let message = '';
            if (changeDetails.pathParts.length == 0) {
                changeDetails.oldValue = value1;
                changeDetails.newValue = value2;
                message = `Deep Compare Result - value changed from "${changeDetails.oldValue}"  to "${changeDetails.newValue}"}`;
            }
            else {
                const pathDesc = buildPropertyPath(changeDetails.pathParts);
                message = `Deep Compare Result - Property ${pathDesc} changed from "${changeDetails.oldValue}"  to "${changeDetails.newValue}"}`;
            }
            console.log(message);
        }
    }
    return result;
}
function areEqualDeepCompareWithChangeDetail(value1, value2, depth = 0, changeDetails, excludeProperties) {
    if (value1 == null && value2 == null)
        return true;
    if (value1 == null || value2 == null)
        return false;
    try {
        if (!isObject(value1) && !isObject(value2)) {
            let result1 = (value1 === value2);
            // handle by call below
            // if (!result1) {
            //     changeDetails.oldValue = value1;
            //     changeDetails.oldValue = value2;
            // }
            return result1;
        }
        if (typeof (value1) == 'string' && typeof (value2) == 'string') {
            let resultStringCompare = (value1.toUpperCase() === value2.toUpperCase());
            // handle by call below
            // if (!resultStringCompare) {
            //     changeDetails.oldValue = value1;
            //     changeDetails.oldValue = value2;
            // }
            return resultStringCompare;
        }
        const keys1 = Object.keys(value1);
        const keys2 = Object.keys(value2);
        if (keys1.length != keys2.length) {
            changeDetails.oldValue = keys1.length;
            changeDetails.newValue = keys2.length;
            changeDetails.pathParts.unshift('length');
            return false;
        }
        // prevent infinite loops for recursive objects
        depth++;
        if (depth > 25) {
            console.warn('areEqualDeepCompare - Hit max stack depth of 25.  This can happen if the object has circular references');
            return false;
        }
        for (const key of keys1.sort()) {
            if (excludeProperties === null || excludeProperties === void 0 ? void 0 : excludeProperties.find(prop => prop == key)) {
                continue;
            }
            const childValue1 = value1[key];
            const childValue2 = value2[key];
            if (!areEqualDeepCompareWithChangeDetail(childValue1, childValue2, depth, changeDetails)) {
                if (changeDetails.pathParts.length == 0) {
                    changeDetails.oldValue = childValue1;
                    changeDetails.newValue = childValue2;
                }
                // Add to start of array
                changeDetails.pathParts.unshift(key); // = [key, ...changeDetails.pathParts];
                return false;
            }
        }
        return true;
    }
    catch (ex) {
        console.error("areEqual failure", ex);
    }
    return value1 == value2;
}
function excludeObjectProperties(obj, excludeProperties) {
    if (!isObject(obj) || !excludeProperties || excludeProperties.length == 0) {
        return obj;
    }
    const newObj = Object.assign({}, obj);
    for (var excludeProperty of excludeProperties) {
        newObj[excludeProperty] = undefined;
    }
    return newObj;
}
function isObject(value) {
    if (typeof value === 'object' && value != null) {
        return true;
    }
    return false;
}
function buildPropertyPath(path) {
    var finalParts = [];
    for (let pathPart of path) {
        let adjustedPart = pathPart;
        // integer key means it's an array so show with brackets, otherwise it's a property and needs to period perfix  (e.g. Example Result = $.views[2].columnDefs[2].width)
        if (!isNaN(parseInt(pathPart))) {
            adjustedPart = `[${pathPart}]`;
        }
        else {
            adjustedPart = `.${pathPart}`;
        }
        finalParts.push(adjustedPart);
    }
    return `$${finalParts.join('')}`;
}

class DwMdEventService {
    constructor(dwEventService) {
        this.dwEventService = dwEventService;
        this.setup();
    }
    setup() {
        DwMdEventService.events.subscribe(event => {
            //console.log(`Event ${event.eventType} for ${event.itemName}`, event);
        });
    }
    getAllEvents() {
        return DwMdEventService.events.asObservable();
    }
    getEvents(itemNames, eventType) {
        itemNames = itemNames || [];
        return this.getAllEvents()
            .pipe(filter(event => {
            if (itemNames.indexOf(event.itemName) >= 0 && (!eventType || event.eventType == eventType)) {
                return true;
            }
            return false;
        }), map(event => {
            return event;
        }));
    }
    getCreateEvents(...itemName) {
        return this.getEvents(itemName, DwMdEventType.create);
    }
    getUpdateEvents(...itemName) {
        return this.getEvents(itemName, DwMdEventType.update);
    }
    getLoadEvents(...itemName) {
        return this.getEvents(itemName, DwMdEventType.load);
    }
    getQueryEvents(...itemName) {
        return this.getEvents(itemName, DwMdEventType.query);
    }
    getDeleteEvents(...itemName) {
        return this.getEvents(itemName, DwMdEventType.delete);
    }
    publishLoad(itemName, originalItem) {
        const eventData = {
            eventType: DwMdEventType.load,
            itemName: itemName,
            originalItem: originalItem
        };
        DwMdEventService.events.next(eventData);
    }
    publishQuery(itemName, query, results, pageInfo = null) {
        const eventData = {
            eventType: DwMdEventType.query,
            itemName: itemName,
            query: query,
            results: results,
            pageInfo: pageInfo,
        };
        DwMdEventService.events.next(eventData);
    }
    publishCreate(itemName, newItem) {
        const eventData = {
            eventType: DwMdEventType.create,
            itemName: itemName,
            newItem: newItem
        };
        DwMdEventService.events.next(eventData);
    }
    publishUpdate(itemName, originalItem, newItem) {
        const eventData = {
            eventType: DwMdEventType.update,
            itemName: itemName,
            originalItem: originalItem,
            newItem: newItem,
            changes: this.buildDwMdChanges(originalItem, newItem)
        };
        DwMdEventService.events.next(eventData);
    }
    publishDelete(itemName, originalItem) {
        const eventData = {
            eventType: DwMdEventType.delete,
            itemName: itemName,
            originalItem: originalItem,
        };
        DwMdEventService.events.next(eventData);
    }
    buildDwMdChanges(originalItem, newItem) {
        const changes = {};
        if (!originalItem || !newItem) {
            return changes;
        }
        for (var attrName in originalItem) {
            let change = changes[attrName] || { attrName: attrName };
            change.originalValue = originalItem[attrName];
            change.newValue = newItem[attrName];
            if (!areEqual(change.originalValue, change.newValue)) {
                changes[attrName] = change;
            }
        }
        return changes;
    }
}
DwMdEventService.ɵfac = function DwMdEventService_Factory(t) { return new (t || DwMdEventService)(ɵngcc0.ɵɵinject(DwEventService)); };
DwMdEventService.events = new Subject();
DwMdEventService.ɵprov = ɵɵdefineInjectable({ factory: function DwMdEventService_Factory() { return new DwMdEventService(ɵɵinject(DwEventService)); }, token: DwMdEventService, providedIn: "root" });
DwMdEventService.ctorParameters = () => [
    { type: DwEventService }
];

class DwStorageOptions {
}

const DwSecurityContants = {
    securityTokenKey: "SecurityToken",
    securityContextKey: "SecurityContext"
};

class DwSecurityTopics {
}
DwSecurityTopics.SECURITY_CHANGED = "SecurityChanged";

const moment$1 = moment_;
class DwSecurityStateService {
    constructor(loggingService, configService, storageUtil, dwEventService) {
        this.loggingService = loggingService;
        this.configService = configService;
        this.storageUtil = storageUtil;
        this.dwEventService = dwEventService;
        this.initSecurityState();
    }
    get securityState() {
        return DwSecurityStateService._securityState.value;
    }
    get securityStateObservable() {
        return DwSecurityStateService._securityState.asObservable();
    }
    securityContextChanged() {
        return this.securityStateObservable
            .pipe(map(state => state.securityContext), distinctUntilChanged());
    }
    initSecurityState() {
        const initialState = {
            isAuthenticated: false,
            isAuthenticating: false,
            isRefreshing: false,
            showError: false,
            setupComplete: false
        };
        this.setSecurityState(initialState);
    }
    setSecurityState(updatedState) {
        const newState = Object.assign(Object.assign({}, this.securityState), updatedState);
        if (updatedState.securityContext) {
            this.publishedSecurityChangedEvent();
        }
        DwSecurityStateService._securityState.next(newState);
        this.storeLastState(newState);
    }
    setInitialUrl(initialUrl) {
        this.setSecurityState({ initialUrl: initialUrl });
    }
    startRefresh() {
        this.setSecurityState({ isRefreshing: true });
    }
    setSecuritySetupComplete(value) {
        this.setSecurityState({ setupComplete: value });
    }
    startAuthenticating(securityMessage, authenticationType) {
        this.setSecurityState({ isAuthenticating: true, authenticationType: authenticationType, securityMessage: securityMessage, showError: false });
    }
    setSSOToken(ssoToken) {
        this.loggingService.logToConsole(`SSO Token set`, ssoToken);
        const state = this.securityState;
        const newSSOToken = Object.assign(Object.assign({}, state), removeNullProperties(ssoToken));
        this.setSecurityState({
            ssoToken: newSSOToken,
        });
    }
    setTenantSSOConfigId(tenantSSOConfigId) {
        const state = this.securityState;
        this.setSecurityState({
            tenantSSOConfigId: tenantSSOConfigId
        });
    }
    completeAuthenticating(securityMessage) {
        const currentDateTime = moment$1().format();
        const newState = {
            isAuthenticating: false,
            isRefreshing: false,
            showError: false,
            setupComplete: true,
            lastUserInteractionDateTime: currentDateTime,
            inactivityWarningMessageSent: false,
            inactivityLogoutComplete: false,
            inactivityLogoutMessage: null,
        };
        if (securityMessage) {
            newState.securityMessage = securityMessage;
        }
        this.setSecurityState(newState);
    }
    setLastUserInteraction() {
        const currentDateTime = moment$1().format();
        this.setSecurityState({ lastUserInteractionDateTime: currentDateTime, inactivityWarningMessageSent: false });
    }
    storeLastUrl(url) {
        this.storageUtil.setValue('lastUrl', url);
    }
    storeLastState(state) {
        DwSecurityStateCurrent.securityState = state;
    }
    getLastUrl() {
        const url = this.storageUtil.getValue('lastUrl');
        return url;
    }
    setSecurityContext(securityContext) {
        // Store the security context in more browser storage
        this.setSecurityContextInStorage(securityContext);
        const securityToken = securityContext ? securityContext.SecurityToken : null;
        const newState = {
            isAuthenticated: securityToken ? true : false,
            isAuthenticating: false,
            isRefreshing: false,
            securityContext: securityContext,
            showError: false
        };
        if (newState.isAuthenticated) {
            this.setInactivityDetails(false, false, null);
        }
        this.setSecurityState(newState);
    }
    clearSecurityContext(securityMessage = null, suppressErrorMessage = false) {
        // Clear 
        this.clearSecurityContextInStorage();
        const newState = {
            isAuthenticated: false,
            isAuthenticating: false,
            //authenticationType: null,
            securityContext: null,
            inactivityWarningMessageSent: false,
            showError: false,
        };
        if (securityMessage && !suppressErrorMessage) {
            newState.securityMessage = securityMessage;
            newState.showError = true;
        }
        this.setSecurityState(newState);
    }
    setSecurityMessage(securityMessage) {
        this.setSecurityState({ securityMessage: securityMessage });
    }
    clearSecurityMessage() {
        this.setSecurityState({ securityMessage: '' });
    }
    setInactivityDetails(inactivityWarningMessageSent, inactivityLogoutComplete, inactivityLogoutMessage) {
        this.setSecurityState({ inactivityWarningMessageSent: inactivityWarningMessageSent, inactivityLogoutComplete: inactivityLogoutComplete, inactivityLogoutMessage: inactivityLogoutMessage });
    }
    processSecurityResult(securityResult, clearAuthentication = true) {
        this.loggingService.logToConsole("Security Operation Result ", securityResult, DwLogSeverity.verbose);
        if (!securityResult.success) {
            this.clearSecurityContext(securityResult.message, securityResult.suppressErrorMessage);
            return;
        }
        if (securityResult && securityResult.result) {
            this.setLastUserInteraction();
            if (securityResult.success) {
                this.setSecurityContext(securityResult.result);
                return;
            }
            else {
                this.clearSecurityContext(securityResult.message, securityResult.suppressErrorMessage);
                return;
            }
        }
        if (clearAuthentication) {
            this.clearSecurityContext();
        }
    }
    publishedSecurityChangedEvent() {
        this.dwEventService.publishEvent(DwSecurityTopics.SECURITY_CHANGED, null);
    }
    setSecurityContextInStorage(securityContext) {
        // Always store with the API root so it can be cleared if that changes
        securityContext.ApiRoot = this.configService.coreConfig.apiRoot;
        let storageOptions = new DwStorageOptions();
        storageOptions.expirationInMinutes = this.configService.coreConfig.securityConfig.securityTokenTimeoutMinutes;
        this.storageUtil.setValue(DwSecurityContants.securityContextKey, securityContext, storageOptions);
        this.storageUtil.setValue(DwSecurityContants.securityTokenKey, securityContext.SecurityToken, storageOptions);
    }
    getSecurityContextFromStorage() {
        return this.storageUtil.getValue(DwSecurityContants.securityContextKey);
    }
    getSecurityTokenFromStorage() {
        return this.storageUtil.getValue(DwSecurityContants.securityTokenKey);
    }
    clearSecurityContextInStorage() {
        this.storageUtil.setValue(DwSecurityContants.securityContextKey, null);
        this.storageUtil.setValue(DwSecurityContants.securityTokenKey, null);
    }
}
DwSecurityStateService.ɵfac = function DwSecurityStateService_Factory(t) { return new (t || DwSecurityStateService)(ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwStorageUtil), ɵngcc0.ɵɵinject(DwEventService)); };
DwSecurityStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSecurityStateService, factory: DwSecurityStateService.ɵfac });
DwSecurityStateService._securityState = new BehaviorSubject(null);
DwSecurityStateService.ctorParameters = () => [
    { type: DwLoggingService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwStorageUtil },
    { type: DwEventService }
];

class DwMessagingService {
    constructor(loggingService, router, configService, dwSecurityStateService, injector) {
        this.loggingService = loggingService;
        this.router = router;
        this.configService = configService;
        this.dwSecurityStateService = dwSecurityStateService;
        this.injector = injector;
        this.messagesSubject = new BehaviorSubject(null);
        this.requestCountSubject = new BehaviorSubject(0);
        this.saveRequestCountSubject = new BehaviorSubject(0);
        this.currentRequestCount = 0;
        this.currentSaveCount = 0;
        this.increaseRequestList = [];
        this.decreaseRequestList = [];
        this.checkThreshold = 5000;
        this.messagingConfig = configService.coreConfig.messagingConfig;
        this.setupMissingRequestCheckInterval();
    }
    showMessage(message) {
        this.messagesSubject.next(message);
    }
    getMessages(locationKey) {
        return this.messagesSubject.asObservable()
            .pipe(
        // Disregard duplicate messages
        /*  distinctUntilChanged((x,y) => {
             return x.messageBody == y.messageBody && !x.showDuplicates;
         }),  */
        filter(m => !locationKey || m.locationKey == locationKey));
    }
    showNextMessage(previous, newMessage) {
    }
    getRequestCount() {
        return this.requestCountSubject.asObservable();
    }
    getSaveRequestCount() {
        return this.saveRequestCountSubject.asObservable();
    }
    getRequestCountValue() {
        return this.requestCountSubject.value;
    }
    getSaveRequestCountValue() {
        return this.saveRequestCountSubject.value;
    }
    setupMissingRequestCheckInterval() {
        setInterval(() => {
            this.checkForMissingRequest();
        }, 1000);
    }
    checkForMissingRequest() {
        if (!this.lastIncreaseDateTime)
            return;
        const elapsedTime = Date.now() - this.lastIncreaseDateTime;
        if (elapsedTime > this.checkThreshold) {
            this.loggingService.logInfo(`Missing Request Increase - ${elapsedTime} - ${this.increaseRequestList.length}`, {
                increateRequestList: [...this.increaseRequestList],
                decreaseRequestList: [...this.decreaseRequestList]
            });
        }
    }
    // Increases the http request count (for showing request progress bar)
    increaseRequestCount(url) {
        this.lastIncreaseDateTime = Date.now();
        this.increaseRequestList.push(url);
        if (this.isSaveRequest(url)) {
            this.currentSaveCount++;
            this.saveRequestCountSubject.next(this.currentSaveCount);
        }
        else {
            this.currentRequestCount++;
            this.requestCountSubject.next(this.currentRequestCount);
        }
        if (this.messagingConfig.logToConsole) {
            this.loggingService.logToConsole(`Increase Request Count - ${url} - Requests - ${this.currentRequestCount}   Saves - ${this.currentSaveCount}`);
        }
        this.dwSecurityStateService.setLastUserInteraction();
    }
    // Decreases the http request count  (for showing request progress bar)
    decreaseRequestCount(url) {
        this.lastDecreaseDateTime = Date.now();
        this.decreaseRequestList.push(url);
        if (this.isSaveRequest(url)) {
            this.currentSaveCount--;
            this.saveRequestCountSubject.next(this.currentSaveCount);
        }
        else {
            this.currentRequestCount--;
            this.requestCountSubject.next(this.currentRequestCount);
        }
        // Clean up list if back to 0
        if (this.currentSaveCount == 0 && this.currentRequestCount == 0) {
            this.lastIncreaseDateTime = null;
            this.lastDecreaseDateTime = null;
            this.increaseRequestList = [];
            this.decreaseRequestList = [];
        }
        if (this.messagingConfig.logToConsole) {
            this.loggingService.logToConsole(`Decrease Request Count - ${url} - Requests - ${this.currentRequestCount}   Saves - ${this.currentSaveCount}`);
        }
        this.dwSecurityStateService.setLastUserInteraction();
    }
    isSaveRequest(url) {
        url = url.toLowerCase();
        if (typeof (this.messagingConfig.saveHttpVerbs) == 'string')
            return url.indexOf(this.messagingConfig.saveHttpVerbs.toLowerCase()) >= 0;
        if (isArray(this.messagingConfig.saveHttpVerbs)) {
            for (let verb of this.messagingConfig.saveHttpVerbs) {
                if (url.indexOf(verb.toLowerCase()) >= 0)
                    return true;
            }
            return false;
        }
        if (this.isVerbCheck(this.messagingConfig.saveHttpVerbs))
            return this.messagingConfig.saveHttpVerbs(url);
        return false;
    }
    isVerbCheck(verbs) {
        if (verbs instanceof Function)
            return true;
        return false;
    }
}
DwMessagingService.ɵfac = function DwMessagingService_Factory(t) { return new (t || DwMessagingService)(ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwMessagingService.ɵprov = ɵɵdefineInjectable({ factory: function DwMessagingService_Factory() { return new DwMessagingService(ɵɵinject(DwLoggingService), ɵɵinject(Router), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwSecurityStateService), ɵɵinject(INJECTOR)); }, token: DwMessagingService, providedIn: "root" });
DwMessagingService.ctorParameters = () => [
    { type: DwLoggingService },
    { type: Router },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityStateService },
    { type: Injector }
];

var DwMessageSeverity;
(function (DwMessageSeverity) {
    DwMessageSeverity["success"] = "success";
    DwMessageSeverity["info"] = "info";
    DwMessageSeverity["warning"] = "warning";
    DwMessageSeverity["error"] = "error";
})(DwMessageSeverity || (DwMessageSeverity = {}));

const SuppressErrorMessagesHeader = DwErrorHeaders.suppressErrorMessagesHeader;
const SuppressErrorMessagesLogHeader = DwErrorHeaders.suppressErrorMessagesLogHeader;
class DwMessagingInterceptor {
    constructor(dwMessagingService, dwLoggingSerice, configService) {
        this.dwMessagingService = dwMessagingService;
        this.dwLoggingSerice = dwLoggingSerice;
        this.configService = configService;
    }
    increaseRequests(request) {
        this.dwMessagingService.increaseRequestCount(request.url);
    }
    decreaseRequests(request) {
        this.dwMessagingService.decreaseRequestCount(request.url);
    }
    intercept(request, next) {
        // Only apply to requests that are going to the API
        if (request.url.indexOf(this.configService.coreConfig.apiRoot) == -1) {
            return next.handle(request);
        }
        this.increaseRequests(request);
        const suppressErrorMessages = request.headers.get(SuppressErrorMessagesHeader) === 'true' ? true : false;
        const suppressErrorLog = request.headers.get(SuppressErrorMessagesLogHeader) === 'true' ? true : false;
        // Add the headers to the request
        request = request.clone({
            // Clear these special headers
            headers: request.headers
                .delete(SuppressErrorMessagesHeader)
                .delete(SuppressErrorMessagesLogHeader)
        });
        return next.handle(request)
            .pipe(
        /*  tap(
             res => {
                 if (res instanceof HttpResponse) {
                 }
             })
         , */
        catchError(errorResponse => {
            // if (suppressErrorMessages) {
            //     return throwError(errorResponse);
            // }
            return this.handleHttpError2(errorResponse, suppressErrorMessages, suppressErrorLog);
        }), finalize(() => {
            this.decreaseRequests(request);
        }));
    }
    handleHttpError2(errorResponse, suppressErrorMessages, suppressErrorLog) {
        if (errorResponse.error instanceof Blob) {
            return this.parseErrorBlobDetails(errorResponse, suppressErrorMessages, suppressErrorLog);
        }
        const errorDetails = getErrorDetails(errorResponse);
        const errorDetail = this.handleHttpError(errorResponse, errorDetails, suppressErrorMessages, suppressErrorLog);
        return throwError(errorDetail);
    }
    parseErrorBlobDetails(errorResponse, suppressErrorMessages, suppressErrorLog) {
        const reader = new FileReader();
        const obs = new Observable((observer) => {
            reader.onloadend = (e) => {
                const blobErrorDetails = JSON.parse(reader.result);
                const errorDetails = getErrorDetails(errorResponse, blobErrorDetails);
                let errorDetail = this.handleHttpError(errorResponse, errorDetails, suppressErrorMessages, suppressErrorLog);
                observer.error(errorDetail);
                observer.complete();
            };
        });
        reader.readAsText(errorResponse.error);
        return obs;
    }
    handleHttpError(errorResponse, errorDetails, suppressMessage, suppressErrorLog) {
        if (!suppressErrorLog) {
            switch (errorDetails.status) {
                case 405:
                    let detailedMessage = `Invalid api call to url, Method not allowed`;
                    this.dwLoggingSerice.logError(detailedMessage, new Error(errorResponse.message), null, false, errorDetails);
                    break;
                case 0:
                    // API Not Responding error
                    if (!errorDetails.logId) {
                        let detailedMessage = `Api not responding`;
                        this.dwLoggingSerice.logError(detailedMessage, new Error(errorResponse.message), null, false, errorDetails);
                    }
                    break;
                default:
                    // If we don't have a log id, then log the error
                    if (!errorDetails.logId) {
                        let detailedMessage = `Api call error`;
                        this.dwLoggingSerice.logError(detailedMessage, new Error(errorResponse.message), null, false, errorDetails);
                    }
            }
        }
        if (!suppressMessage) {
            this.dwMessagingService.showMessage({ messageHeading: errorDetails.title, messageBody: errorDetails.message, severity: DwMessageSeverity.error, forceClose: true, showDuplicates: false });
        }
        return errorDetails;
    }
}
DwMessagingInterceptor.ɵfac = function DwMessagingInterceptor_Factory(t) { return new (t || DwMessagingInterceptor)(ɵngcc0.ɵɵinject(DwMessagingService), ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwConfigServiceToken)); };
DwMessagingInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMessagingInterceptor, factory: DwMessagingInterceptor.ɵfac });
DwMessagingInterceptor.ctorParameters = () => [
    { type: DwMessagingService },
    { type: DwLoggingService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];

const DwOrmDataServiceToken = new InjectionToken("DwOrmDataService");
class DwOrmDataService {
    constructor(http, configService, eventsService, dwMdEventService) {
        this.http = http;
        this.eventsService = eventsService;
        this.dwMdEventService = dwMdEventService;
        this.apiRoot = `${configService.coreConfig.apiRoot}`;
        this.setupMetaDataBroadcastEvents();
    }
    setupMetaDataBroadcastEvents() {
        this.eventsService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedBroadcastTopic())
            .subscribe(ormChangeEvent => {
            // This should refresh any items associated with this data item
            //console.log('publishEvent from a Broadcast event', ormChangeEvent);
            this.eventsService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(ormChangeEvent.data.itemName), ormChangeEvent.data);
        });
    }
    get QueryHelper() {
        return new DwQueryHelper();
    }
    buildUrl(item, pathParam) {
        let itemName;
        if (typeof item == 'string') {
            itemName = item;
        }
        if (isQuery(item)) {
            itemName = item.RootTable;
        }
        if (isOrmData(item)) {
            itemName = item._itemName;
        }
        if (!itemName) {
            throw new Error('Could not determine item name!');
        }
        let url = `${this.apiRoot}/data/${itemName}`;
        if (pathParam) {
            url = `${url}/${pathParam}`;
        }
        return url;
    }
    /// Shared method to execute advanced queries
    executeAdvancedQuery(query, firstOnly = false, returngPagingResult = false) {
        let url = this.buildUrl(query, 'advanced-query');
        let body = query;
        // Add optional params
        let params = [];
        if (firstOnly) {
            params.push(`firstOnly=${firstOnly}`);
        }
        if (returngPagingResult) {
            params.push(`returnPagingResults=${returngPagingResult}`);
        }
        url = `${url}?${params.join('&')}`;
        return this.http.post(url, body);
    }
    /// Execute Standard queries
    executeQuery(queryOrBuilder) {
        const query = this.getQuery(queryOrBuilder);
        return this.executeAdvancedQuery(query)
            .pipe(map((data) => {
            this.dwMdEventService.publishQuery(query.RootTable, query, data);
            return data;
        }), share());
    }
    executeQuerySingle(queryOrBuilder) {
        const query = this.getQuery(queryOrBuilder);
        return this.executeAdvancedQuery(query, true)
            .pipe(map((data) => {
            // Force casting this is an Orm Data item since it was told to only return one
            //const ormData: DwOrmData = (result as any) as DwOrmData;
            // Publish the event
            this.dwMdEventService.publishLoad(query.RootTable, data);
            return data;
        }));
    }
    getQuery(query) {
        if ("query" in query) {
            return query.query;
        }
        return query;
    }
    executePagedQuery(queryOrBuilder) {
        const query = this.getQuery(queryOrBuilder);
        return this.executeAdvancedQuery(query, false, true)
            .pipe(map((results) => {
            //const results = <DwQueryResult>JSON.parse(httpResult);
            this.dwMdEventService.publishQuery(query.RootTable, query, results.Data, results.PageInfo);
            return results;
        }), share());
    }
    exportQuery(query, fileName, columnOptions, exportSortableDates) {
        let url = `${this.apiRoot}/reporting/export`;
        let exportRequest = {
            Query: query,
            ExportFileName: fileName,
            ColumnOptions: columnOptions,
            UserTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            ExportSortableDates: exportSortableDates
        };
        return this.http.post(url, exportRequest)
            .pipe(map((httpResult) => {
            this.handleExportResult(httpResult, fileName);
        }));
    }
    handleExportResult(exportResult, fileName) {
        // Convert string to Base64 Data
        var binaryData = this.convertBase64(exportResult.Base64Data);
        var mimeType = exportResult.MimeType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        // Create a new blob with the binary data
        var file = new Blob([binaryData], { type: mimeType });
        fileName = fileName || exportResult.FileName || "Export.xls";
        saveAs(file, fileName);
    }
    convertBase64(base64Data) {
        var byteCharacters = atob(base64Data);
        // Each character's code point (charCode) will be the value of the byte. We can create an array of byte values by applying this using the .charCodeAt method for each character in the string.
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        // You can convert this array of byte values into a real typed byte array by passing it to the Uint8Array constructor.
        var byteArray = new Uint8Array(byteNumbers);
        return byteArray;
    }
    createDummyEntity(item, defaults) {
        let entity = {};
        entity._itemName = item;
        // Set default attributes
        if (defaults) {
            //_.defaults(entity, defaults);
            entity = Object.assign(Object.assign({}, defaults), entity);
        }
        return entity;
    }
    loadEntity(itemName, keyValue) {
        let url = this.buildUrl(itemName, keyValue.toString());
        /*   let body = {
              itemName: itemName,
              keyValue: keyValue,
              fieldSettings: fieldSettings
          }; */
        return this.http.get(url)
            .pipe(map((httpResult) => {
            const ormData = httpResult;
            // Publish the event
            this.dwMdEventService.publishLoad(itemName, ormData);
            return ormData;
        }), share());
    }
    saveEntity(entity, recurse, itemQuery, originalEntity, suppressErrorMessages = true, ormDataHierarchy) {
        let keyValue = null;
        // ensure recurse is a boolean (null will cause an api validation error)
        recurse = recurse ? true : false;
        if (entity._keyName) {
            // Use an update with he key value for Updates
            let keyValue = entity[entity._keyName];
        }
        let url = this.buildUrl(entity, keyValue);
        url = `${url}?recurse=${recurse}&hideInternalFields=false&hasItemQuery=${!!itemQuery}`;
        let headers = new HttpHeaders();
        if (suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        const body = {
            entity: entity,
            itemQuery: itemQuery
        };
        // Use a post for Creates
        let ob = this.http.post(url, body, { headers: headers });
        if (keyValue) {
            ob = this.http.put(url, body, { headers: headers });
        }
        return ob
            .pipe(map((newEntity) => {
            const saveType = this.determineSaveType(entity);
            this.publishUpdatedItemEvents(newEntity, originalEntity || entity, saveType, ormDataHierarchy);
            return newEntity;
        }), share());
    }
    publishUpdatedItemEvents(newEntity, originalEntity, saveType, ormDataHierarchy) {
        const itemName = originalEntity._itemName;
        const eventData = {
            itemName: itemName,
            saveType: saveType,
            newEntity: newEntity,
            originalEntity: originalEntity,
        };
        // Publish all save events
        this.eventsService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(itemName), eventData);
        // Publish broadcast message to other tabs
        this.eventsService.publishBroadcastMessage(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedBroadcastTopic(), eventData);
        switch (saveType) {
            case DwSaveType.insert:
                this.dwMdEventService.publishCreate(itemName, newEntity);
                break;
            case DwSaveType.update:
                this.dwMdEventService.publishUpdate(itemName, originalEntity, newEntity);
                break;
            case DwSaveType.delete:
                this.dwMdEventService.publishDelete(itemName, originalEntity);
                break;
        }
        if (ormDataHierarchy) {
            this.publishOrmDataHierarchyEvents(newEntity, originalEntity, saveType, ormDataHierarchy);
        }
    }
    publishOrmDataHierarchyEvents(newEntity, originalEntity, saveType, ormDataHierarchy) {
        for (const ormDataHierarchyItem of ormDataHierarchy || []) {
            if (ormDataHierarchyItem.excludeFromSave) {
                continue;
            }
            const originalChildEntity = originalEntity == null ? null : originalEntity[ormDataHierarchyItem.propertyName];
            const newChildEntity = newEntity == null ? null : newEntity[ormDataHierarchyItem.propertyName];
            if (originalEntity) {
                const eventData = {
                    itemName: ormDataHierarchyItem.itemName,
                    saveType: saveType,
                    isChildEvent: true,
                    parentItemName: originalEntity === null || originalEntity === void 0 ? void 0 : originalEntity._itemName,
                    newEntity: newChildEntity,
                    originalEntity: originalChildEntity
                };
                // Publish all save events
                this.eventsService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(ormDataHierarchyItem.itemName), eventData);
            }
            // run same process for any child items
            this.publishOrmDataHierarchyEvents(newChildEntity, originalChildEntity, saveType, ormDataHierarchyItem.children);
        }
    }
    determineSaveType(entity) {
        if (entity._isDeleted) {
            return DwSaveType.delete;
        }
        if (entity._keyName) {
            if (entity[entity._keyName]) {
                return DwSaveType.update;
            }
        }
        else {
            if (entity._itemName) {
                if (entity[entity._itemName]) {
                    return DwSaveType.update;
                }
            }
        }
        return DwSaveType.insert;
    }
    deleteEntity(entity, recurse = false, itemQuery) {
        this.markItemAsDeleted(entity);
        return this.saveEntity(entity, recurse, itemQuery);
    }
    saveEntityCollection(entityCollection, recurse = false, reload = false) {
        if (!entityCollection || entityCollection.length == 0) {
            return of(entityCollection);
        }
        let itemName = entityCollection[0]._itemName;
        let url = this.buildUrl(itemName, "multi");
        url = `${url}?recurse=${recurse}&hideInternalFields=false`;
        /*  let params = {
             entityListJSON: JSON.stringify(entityCollection),
             recurse: recurse,
             reload: reload
         }; */
        return this.http.post(url, entityCollection)
            .pipe(map((updatedEntities) => {
            const eventData = {
                saveType: DwSaveType.updateCollection,
                newEntity: updatedEntities,
                originalEntity: entityCollection,
            };
            this.eventsService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(itemName), eventData);
            return updatedEntities;
        }), share());
    }
    updateAttributeValue(dataItems, attrName, newValue, reload) {
        return this.updateAttributeValues(dataItems, [{ attrName: attrName, newValue: newValue }], reload);
    }
    updateAttributeValues(dataItems, attrUpdates, reload) {
        const finalDataItems = [];
        if (!Array.isArray(dataItems)) {
            dataItems = [dataItems];
        }
        for (const dataItem of dataItems) {
            const finalDataItem = {
                _itemName: dataItem._itemName,
                _keyName: dataItem._keyName
            };
            finalDataItem[dataItem._keyName] = dataItem[dataItem._keyName];
            for (const attrUpdate of attrUpdates) {
                finalDataItem[attrUpdate.attrName] = attrUpdate.newValue;
            }
            finalDataItems.push(finalDataItem);
        }
        return this.saveEntityCollection(finalDataItems, false, reload);
    }
    //#region Utility Methods
    markItemAsDeleted(entity, deleteState = true) {
        if (!entity)
            return;
        let ormDataItem = entity;
        ormDataItem._isDeleted = deleteState;
    }
    static getItemNameFromQuery(item) {
        if (!item) {
            return '';
        }
        if (typeof (item) === "string") {
            return item;
        }
        return item.RootTable;
    }
    clearEntityKeys(entity) {
        if (!entity) {
            return entity;
        }
        if (entity._keyName) {
            entity[entity._keyName] = null;
        }
        for (let attrName in entity) {
            if (entity.hasOwnProperty(attrName)) {
                const value = entity[attrName];
                if (value && Array.isArray(value)) {
                    this.clearEntityCollectionKeys(value);
                }
            }
        }
    }
    clearEntityCollectionKeys(entities) {
        if (!entities || !Array.isArray(entities)) {
            return entities;
        }
        for (let entity of entities) {
            this.clearEntityKeys(entity);
        }
    }
    getKeyValue(entity) {
        if (!entity)
            return null;
        let ormDataItem = entity;
        if (!isNaN(parseInt(entity))) {
            return parseInt(entity);
        }
        if (!ormDataItem._keyName) {
            throw new Error(`Item ${ormDataItem._itemName} is missing a primary key`);
        }
        // Get the items key value
        const keyValue = ormDataItem[ormDataItem._keyName];
        return keyValue;
    }
}
DwOrmDataService.ɵfac = function DwOrmDataService_Factory(t) { return new (t || DwOrmDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwEventService), ɵngcc0.ɵɵinject(DwMdEventService)); };
DwOrmDataService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwOrmDataService, factory: DwOrmDataService.ɵfac });
DwOrmDataService.ORM_EVENT_TOPICS = {
    ItemChangedTopic(item) {
        return `OrmEvent.${item}`;
    },
    ItemChangedBroadcastTopic() {
        return `OrmEvent.Broadcast`;
    }
    // ,
    // LookupChangedBroadcast(lookupId: number | string) {
    //     return `MetaDataEvent.LookupChanged.Broadcast.${lookupId}`;
    // },
};
DwOrmDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwEventService },
    { type: DwMdEventService }
];

class DwAssocativeRelationConfig {
}

class DwItemAttribute {
    constructor(itemName, fieldName) {
        this.fieldName = fieldName;
        this.fieldNameWithItemPrefix = `${itemName}.${fieldName}`;
    }
}
class DwItemRelationship {
    constructor(relationName, fieldPrefix, propertyName) {
        this.relationName = relationName;
        this.fieldPrefix = fieldPrefix;
        this.propertyName = propertyName;
    }
}
function isDwItemAttribute(item) {
    var _a;
    return ((_a = item) === null || _a === void 0 ? void 0 : _a.fieldNameWithItemPrefix) != undefined;
}
function isDwItemRelationship(item) {
    const relation = item;
    if ((relation === null || relation === void 0 ? void 0 : relation.relationName) && (relation === null || relation === void 0 ? void 0 : relation.fieldPrefix) && (relation === null || relation === void 0 ? void 0 : relation.propertyName)) {
        return true;
    }
}

class DwItemDetail {
}
class DwItemDetail2 {
}

class DwQueryDateFilterBuilderGen {
    constructor(fields) {
        this.fields = fields;
        this.fh = new DwQueryDateFilterHelper();
    }
    GreaterThanDays(fieldSelector, value) {
        return this.fh.GreaterThanDays(this.getFieldName(fieldSelector), value);
    }
    GreaterThanEqualDays(fieldSelector, value) {
        return this.fh.GreaterThanEqualDays(this.getFieldName(fieldSelector), value);
    }
    LessThanDays(fieldSelector, value) {
        return this.fh.LessThanDays(this.getFieldName(fieldSelector), value);
    }
    LessThanEqualDays(fieldSelector, value) {
        return this.fh.LessThanEqualDays(this.getFieldName(fieldSelector), value);
    }
    GreaterThanHours(fieldSelector, value) {
        return this.fh.GreaterThanHours(this.getFieldName(fieldSelector), value);
    }
    GreaterThanEqualHours(fieldSelector, value) {
        return this.fh.GreaterThanEqualHours(this.getFieldName(fieldSelector), value);
    }
    LessThanHours(fieldSelector, value) {
        return this.fh.LessThanHours(this.getFieldName(fieldSelector), value);
    }
    LessThanEqualHours(fieldSelector, value) {
        return this.fh.LessThanEqualHours(this.getFieldName(fieldSelector), value);
    }
    getFieldName(fieldSelector) {
        const field = fieldSelector(this.fields);
        if (typeof (field) == 'string') {
            return field;
        }
        return field.fieldNameWithItemPrefix;
    }
}

class DwQueryFilterBuilderGen {
    constructor(fields) {
        this.fields = fields;
        this.fh = new DwQueryFilterHelper();
    }
    Equal(fieldSelector, value) {
        return this.fh.Equal(this.getFieldName(fieldSelector), value);
    }
    NotEqual(fieldSelector, value) {
        return this.fh.NotEqual(this.getFieldName(fieldSelector), value);
    }
    StartsWith(fieldSelector, value) {
        return this.fh.StartsWith(this.getFieldName(fieldSelector), value);
    }
    EndsWith(fieldSelector, value) {
        return this.fh.EndsWith(this.getFieldName(fieldSelector), value);
    }
    Contains(fieldSelector, value) {
        return this.fh.Contains(this.getFieldName(fieldSelector), value);
    }
    GreaterThan(fieldSelector, value) {
        return this.fh.GreaterThan(this.getFieldName(fieldSelector), value);
    }
    GreaterThanEqual(fieldSelector, value) {
        return this.fh.GreaterThanEqual(this.getFieldName(fieldSelector), value);
    }
    LessThan(fieldSelector, value) {
        return this.fh.LessThan(this.getFieldName(fieldSelector), value);
    }
    LessThanEqual(fieldSelector, value) {
        return this.fh.LessThanEqual(this.getFieldName(fieldSelector), value);
    }
    IsBlank(fieldSelector, value) {
        return this.fh.IsBlank(this.getFieldName(fieldSelector));
    }
    IsNotBlank(fieldSelector, value) {
        return this.fh.IsNotBlank(this.getFieldName(fieldSelector));
    }
    IsTrue(fieldSelector, value) {
        return this.fh.IsTrue(this.getFieldName(fieldSelector));
    }
    IsFalse(fieldSelector, value) {
        return this.fh.IsFalse(this.getFieldName(fieldSelector));
    }
    InList(fieldSelector, value) {
        return this.fh.InList(this.getFieldName(fieldSelector), value);
    }
    NotInList(fieldSelector, value) {
        return this.fh.NotInList(this.getFieldName(fieldSelector), value);
    }
    GroupAnd(...filterBuilderSelectors) {
        return this.buildGroupBy(filterBuilderSelectors, DwOperator.And);
        // var filterGroup = this.fh.Group();
        // const filterBuilder = new DwQueryFilterBuilderGen<Fields>(this.fields);
        // for(const filterBuilderSelector of filterBuilderSelectors) {
        //     const filter = filterBuilderSelector(filterBuilder);
        //     filterGroup.AddFilterAnd(filter);
        // }
        // return filterGroup;
    }
    GroupOr(...filterBuilderSelectors) {
        return this.buildGroupBy(filterBuilderSelectors, DwOperator.Or);
    }
    buildGroupBy(filterBuilderSelectors, op) {
        var filterGroup = this.fh.Group();
        const filterBuilder = new DwQueryFilterBuilderGen(this.fields);
        for (const filterBuilderSelector of filterBuilderSelectors) {
            const filter = filterBuilderSelector(filterBuilder);
            filterGroup.AddFilterAnd(filter);
        }
        filterGroup.Op = op;
        return filterGroup;
    }
    GroupAnd2(filterBuilderSelectors) {
        throw new Error('Method not implemented.');
    }
    get DateFilters() {
        const filterBuilder = new DwQueryDateFilterBuilderGen(this.fields);
        return filterBuilder;
    }
    DateFilters2(dateFilterBuilder) {
        const filterBuilder = new DwQueryDateFilterBuilderGen(this.fields);
        const filter = dateFilterBuilder(filterBuilder);
        return filter;
    }
    getFieldName(fieldSelector) {
        const field = fieldSelector(this.fields);
        if (typeof (field) == 'string') {
            return field;
        }
        return field.fieldNameWithItemPrefix;
    }
}

class DwQueryBuilderGen {
    constructor(query, instance) {
        this.instance = instance;
        this.query = query;
        this.instance = instance;
    }
    /**
     * Add field
     * @param fieldSelector - - uses a lamba (arrow Function) to get fields  e.g. f => f.fieldName
     * @returns QueryBuilder
     */
    addField(fieldSelector) {
        const field = fieldSelector(this.instance.Attributes);
        this.addFieldInternal(field);
        return this;
    }
    /**
    * Add fields - adds an array of fields
    * @param fieldSelector - uses a lamba (arrow Function) to get fields  e.g. f => [  f.fieldName1, f.fieldName2 ]
    * @returns QueryBuilder
    */
    addFields(fieldSelectors) {
        const fields = fieldSelectors(this.instance.Attributes);
        for (const field of fields) {
            this.addFieldInternal(field);
        }
        return this;
    }
    /**
     * Add a order by ascending:  use addOrderByDesc for a descending order by
     * @param orderSelector uses a lamba (arrow Function) to get fields  e.g. f => [  f.fieldName1, f.fieldName2 ]
     * @returns
     */
    addOrderBy(orderSelector) {
        const orderBy = orderSelector(this.instance.Attributes);
        this.orderByInternal(orderBy, true);
        return this;
    }
    /**
     * Add a order by descending
     * @param orderSelector uses a lamba (arrow Function) to get values  e.g. f => [  f.fieldName1, f.fieldName2 ]
     * @returns
     */
    addOrderByDesc(orderSelector) {
        const orderBy = orderSelector(this.instance.Attributes);
        this.orderByInternal(orderBy, false);
        return this;
    }
    /**
     * Adds a relation (table join) - defaults to INNER JOIN - pass a Relation (or retrieve after) to set additional properties
     * @param relationSelector  uses a lamba (arrow Function) to get values
     * @returns
     */
    addRelation(relationSelector) {
        const relation = relationSelector(this.instance.Relations);
        if (isDwItemRelationship(relation)) {
            this.addRelationInteral(relation.relationName, relation.fieldPrefix);
            return;
        }
        this.addRelationInteral(relation);
        return this;
    }
    /**
    * Adds a prefetch (child data - represented as an entity or an array of entities)
    * @param relationSelector  uses a lamba (arrow Function) to get values
    * @description If relation is missing, the related table must be included in the code generation
    * @returns
    */
    addPrefetch(relationSelector, subQuuery) {
        const relation = relationSelector(this.instance.Relations);
        if (isDwItemRelationship(relation)) {
            this.addPrefetchPathInternal(relation.relationName, subQuuery);
            return;
        }
        this.addPrefetchPathInternal(relation);
        return this;
    }
    /**
     * Add an add filter
     * @param filterBuilderSelector - uses a lamba (arrow function) with 2 levels - 1 level selected filter function, 2nd level selects attribute  (e.g.  qb.addFilterAnd(filters => filters.Equal(fields => fields.ApplicationId, 12));)
     * @returns
     */
    addFilterAnd(filterBuilderSelector) {
        const filterBuilder = new DwQueryFilterBuilderGen(this.instance.Attributes);
        const filter = filterBuilderSelector(filterBuilder);
        this.addFilterAndInternal(filter);
        return this;
    }
    /**
     * Add an OR filter - Note Best option for adding OR Filters is to use the the GroupOr() method and provide an array or filters
     * @param filterBuilderSelector - uses a lamba (arrow function) with 2 levels - 1 level selected filter function, 2nd level selects attribute  (e.g.  qb.addFilterAnd(filters => filters.Equal(fields => fields.ApplicationId, 12));)
     * @returns
     */
    addFilterOr(filterBuilderSelector) {
        const filterBuilder = new DwQueryFilterBuilderGen(this.instance.Attributes);
        const filter = filterBuilderSelector(filterBuilder);
        this.addFilterOrInternal(filter);
        return this;
    }
    /**
     * Get the field settings
     * @returns Field Settings - chaining not supports
     */
    getFieldSettings() {
        if (!this.query.FieldSettings) {
            this.query.FieldSettings = new DwQuerySettings();
        }
        return this.query.FieldSettings;
    }
    /**
     * Sets field settings using a lambda - this allows changing
     * @param func
     * @returns
     */
    setFieldSettings(func) {
        if (!this.query.FieldSettings) {
            this.query.FieldSettings = new DwQuerySettings();
        }
        func(this.query.FieldSettings);
        return this;
    }
    /**
     * Sets up query as an aggregate query - Note: Fields should be added along with any aggregate field types
     * @param withRollup
     * @returns
     */
    setupAggregateQuery(withRollup) {
        this.getFieldSettings().AggregateQuery = true;
        this.getFieldSettings().AggregateQueryWithRollup = withRollup ? true : false;
        return this;
    }
    /**
     * Sets up paging for the query
     * @param pageNo - page to retrieve
     * @param pageSize - records per page
     * @param returnCount - if the total record count should be returned (note: this may affect performance)
     * @param top - Return only the top n rows - slightly more optimized that paging
     * @returns
     */
    setupPaging(pageNo, pageSize, returnCount, top) {
        if (!this.query.PagingInfo)
            this.query.PagingInfo = new DwQueryPaging();
        this.query.PagingInfo.PageNo = pageNo;
        this.query.PagingInfo.PageSize = pageSize;
        this.query.PagingInfo.ReturnCount = returnCount ? true : false;
        this.query.PagingInfo.Top = top;
        return this;
    }
    /**
     * Sets query to return distinct rows only (eliminated duplicates)
     * @param distinct
     * @returns
     */
    setDistinct(distinct) {
        if (!this.query.PagingInfo)
            this.query.PagingInfo = new DwQueryPaging();
        this.query.PagingInfo.Distinct = distinct;
        return this;
    }
    addFilterAndInternal(expr) {
        if (!this.query.Filter) {
            this.query.Filter = new DwQueryFilterGroup();
        }
        this.addFilterInternal(this.query.Filter, expr, DwOperator.And);
        return this;
    }
    addFilterOrInternal(expr) {
        if (!this.query.Filter) {
            this.query.Filter = new DwQueryFilterGroup();
        }
        this.addFilterInternal(this.query.Filter, expr, DwOperator.Or);
        return this;
    }
    addFilterInternal(filters, filter, op) {
        this.validateFilter(filter);
        if (filter.Type != DwFilterType.Group) {
            filter.Op = op;
        }
        if (!this.query.Filter) {
            this.query.Filter = new DwQueryFilterGroup();
        }
        filters.Filters.push(filter);
    }
    validateFilter(filter) {
        if (!filter)
            throw new Error("Filter Expr cannot be null and must be a valid Filter type.  Use Filters helper classes to create your filters.");
        if (!filter.Type)
            throw new Error("Filter Expr.Type cannot be null");
    }
    addPrefetchPathInternal(relation, subQuery) {
        var prefetch = new DwQueryPrefetchPath();
        if (typeof relation === "string") {
            prefetch.RelationName = relation;
        }
        else {
            prefetch.RelationName = relation.RelationName;
        }
        prefetch.Query = subQuery;
        this.query.Prefetch = this.query.Prefetch || [];
        this.query.Prefetch.push(prefetch);
        return this;
    }
    addRelationInteral(relation, fieldPrefix = "") {
        let newRelation;
        if (typeof relation == "string") {
            newRelation = new DwQueryRelation();
            newRelation.RelationName = relation;
            newRelation.FieldPrefix = fieldPrefix;
        }
        else {
            newRelation = relation;
        }
        this.query.Relations = this.query.Relations || [];
        this.query.Relations.push(newRelation);
        return this;
    }
    getField(field) {
        if (isDwItemAttribute(field)) {
            var newField = new DwField();
            newField.FullFieldName = field.fieldNameWithItemPrefix;
            return newField;
        }
        if (typeof field == "string") {
            var newField = new DwField();
            newField.FullFieldName = field;
            return newField;
        }
        return field;
    }
    addFieldInternal(field) {
        var finalField = this.getField(field);
        this.getFieldSettings().IncludeRootItemFields = false;
        this.getFieldSettings().IncludeFields = this.getFieldSettings().IncludeFields || [];
        this.getFieldSettings().IncludeFields.push(finalField);
        return this;
    }
    addFieldsInternal(fields) {
        for (const field of fields) {
            this.addFieldInternal(field);
        }
        return this;
    }
    addExcludeFieldInternal(field) {
        var finalField = this.getField(field);
        this.getFieldSettings().ExcludeFields = this.getFieldSettings().ExcludeFields || [];
        this.getFieldSettings().ExcludeFields.push(finalField);
        return this;
    }
    orderByInternal(field, isAscending = true) {
        this.query.Order = this.query.Order || [];
        let fieldName;
        if (isDwItemAttribute(field)) {
            fieldName = field.fieldNameWithItemPrefix;
        }
        if (typeof field == "string") {
            fieldName = field;
        }
        if (fieldName) {
            let newField = new DwQueryOrder();
            newField.Field.FullFieldName = fieldName;
            newField.IsAscending = isAscending ? true : false;
            this.query.Order.push(newField);
        }
        else {
            this.query.Order.push(field);
        }
        return this;
    }
}

// tslint:disable
/************************************************
   Generated with the Devware CAP CLI 4.4.47
   Code Gen Name   Devware
   API Url         https://localhost:44368

   Generated By    DEVWARE/Anthony.Monsees
   Generate On     2/12/2025 4:45:10 PM
************************************************/
class DevwareMetaDataService {
    constructor() {
        this.DwAppPermission = new DwAppPermissionMetaData();
        this.DwAppPermissionRole = new DwAppPermissionRoleMetaData();
        this.DwContextDataDefinition = new DwContextDataDefinitionMetaData();
        this.DwDataImport = new DwDataImportMetaData();
        this.DwDataImportLog = new DwDataImportLogMetaData();
        this.DwDataImportRow = new DwDataImportRowMetaData();
        this.DwEmailTemplate = new DwEmailTemplateMetaData();
        this.DwEmailTemplateElapsedHistory = new DwEmailTemplateElapsedHistoryMetaData();
        this.DwEmailTemplateGroup = new DwEmailTemplateGroupMetaData();
        this.DwExceptionDetail = new DwExceptionDetailMetaData();
        this.DwFeatureArea = new DwFeatureAreaMetaData();
        this.DwFeatureAreaDetail = new DwFeatureAreaDetailMetaData();
        this.DwFeatureAreaDetailGroup = new DwFeatureAreaDetailGroupMetaData();
        this.DwFeatureAreaDetailType = new DwFeatureAreaDetailTypeMetaData();
        this.DwLog = new DwLogMetaData();
        this.DwLogData = new DwLogDataMetaData();
        this.DwLogPattern = new DwLogPatternMetaData();
        this.DwLogPatternDetail = new DwLogPatternDetailMetaData();
        this.DwLogPatternStatus = new DwLogPatternStatusMetaData();
        this.DwLogSqlTrace = new DwLogSqlTraceMetaData();
        this.DwMetaDataAttribute = new DwMetaDataAttributeMetaData();
        this.DwMetaDataAttributeFormat = new DwMetaDataAttributeFormatMetaData();
        this.DwMetaDataAttributeType = new DwMetaDataAttributeTypeMetaData();
        this.DwMetaDataAttributeTypeComparerMap = new DwMetaDataAttributeTypeComparerMapMetaData();
        this.DwMetaDataAttributeTypeControlTypeMap = new DwMetaDataAttributeTypeControlTypeMapMetaData();
        this.DwMetaDataAttributeTypeSqlTypeMap = new DwMetaDataAttributeTypeSqlTypeMapMetaData();
        this.DwMetaDataCollection = new DwMetaDataCollectionMetaData();
        this.DwMetaDataComparer = new DwMetaDataComparerMetaData();
        this.DwMetaDataControlType = new DwMetaDataControlTypeMetaData();
        this.DwMetaDataDatabase = new DwMetaDataDatabaseMetaData();
        this.DwMetaDataDatabaseSystem = new DwMetaDataDatabaseSystemMetaData();
        this.DwMetaDataDotNetType = new DwMetaDataDotNetTypeMetaData();
        this.DwMetaDataEnvironmentOfRecordType = new DwMetaDataEnvironmentOfRecordTypeMetaData();
        this.DwMetaDataEvent = new DwMetaDataEventMetaData();
        this.DwMetaDataGroup = new DwMetaDataGroupMetaData();
        this.DwMetaDataHistory = new DwMetaDataHistoryMetaData();
        this.DwMetaDataHistoryDetail = new DwMetaDataHistoryDetailMetaData();
        this.DwMetaDataHistoryType = new DwMetaDataHistoryTypeMetaData();
        this.DwMetaDataImport = new DwMetaDataImportMetaData();
        this.DwMetaDataImportLog = new DwMetaDataImportLogMetaData();
        this.DwMetaDataItem = new DwMetaDataItemMetaData();
        this.DwMetaDataItemRelationship = new DwMetaDataItemRelationshipMetaData();
        this.DwMetaDataItemRelationshipType = new DwMetaDataItemRelationshipTypeMetaData();
        this.DwMetaDataItemStatus = new DwMetaDataItemStatusMetaData();
        this.DwMetaDataItemType = new DwMetaDataItemTypeMetaData();
        this.DwMetaDataLookup = new DwMetaDataLookupMetaData();
        this.DwMetaDataLookupParam = new DwMetaDataLookupParamMetaData();
        this.DwMetaDataLookupTransition = new DwMetaDataLookupTransitionMetaData();
        this.DwMetaDataOperation = new DwMetaDataOperationMetaData();
        this.DwMetaDataOperationType = new DwMetaDataOperationTypeMetaData();
        this.DwMetaDataQuery = new DwMetaDataQueryMetaData();
        this.DwMetaDataSecurityGroup = new DwMetaDataSecurityGroupMetaData();
        this.DwMetaDataSecurityGroupAttribute = new DwMetaDataSecurityGroupAttributeMetaData();
        this.DwMetaDataSecurityGroupItem = new DwMetaDataSecurityGroupItemMetaData();
        this.DwMetaDataSecurityItemRule = new DwMetaDataSecurityItemRuleMetaData();
        this.DwMetaDataSqlType = new DwMetaDataSqlTypeMetaData();
        this.DwMetaDataSystem = new DwMetaDataSystemMetaData();
        this.DwMetaDataSystemType = new DwMetaDataSystemTypeMetaData();
        this.DwProcessDefinition = new DwProcessDefinitionMetaData();
        this.DwProcessSchedule = new DwProcessScheduleMetaData();
        this.DwProcessScheduleHistory = new DwProcessScheduleHistoryMetaData();
        this.DwProcessSchedulerServiceHistory = new DwProcessSchedulerServiceHistoryMetaData();
        this.DwProcessScheduleSummary = new DwProcessScheduleSummaryMetaData();
        this.DwProcessType = new DwProcessTypeMetaData();
        this.DwRole = new DwRoleMetaData();
        this.DwRoute = new DwRouteMetaData();
        this.DwRouteCategory = new DwRouteCategoryMetaData();
        this.DwRouteType = new DwRouteTypeMetaData();
        this.DwRuleDefinition = new DwRuleDefinitionMetaData();
        this.DwSecurityAudit = new DwSecurityAuditMetaData();
        this.DwSecurityAuditType = new DwSecurityAuditTypeMetaData();
        this.DwSecurityEmulationHistory = new DwSecurityEmulationHistoryMetaData();
        this.DwSecurityFactorType = new DwSecurityFactorTypeMetaData();
        this.DwSecurityPersonalAccessToken = new DwSecurityPersonalAccessTokenMetaData();
        this.DwSecurityToken = new DwSecurityTokenMetaData();
        this.DwTermsOfService = new DwTermsOfServiceMetaData();
        this.DwTermsOfServiceUser = new DwTermsOfServiceUserMetaData();
        this.DwUiConfig = new DwUiConfigMetaData();
        this.DwUiConfigType = new DwUiConfigTypeMetaData();
        this.DwUser = new DwUserMetaData();
        this.DwUserCommunicationPreferenceDetail = new DwUserCommunicationPreferenceDetailMetaData();
        this.DwUserCommunucationPreference = new DwUserCommunucationPreferenceMetaData();
        this.DwUserRole = new DwUserRoleMetaData();
        this.DwUserType = new DwUserTypeMetaData();
        this.DwWorkflowStatusDetail = new DwWorkflowStatusDetailMetaData();
    }
}
DevwareMetaDataService.ɵfac = function DevwareMetaDataService_Factory(t) { return new (t || DevwareMetaDataService)(); };
DevwareMetaDataService.ɵprov = ɵɵdefineInjectable({ factory: function DevwareMetaDataService_Factory() { return new DevwareMetaDataService(); }, token: DevwareMetaDataService, providedIn: "root" });
// Generated Classes for MetaData service
class DwAppPermissionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_AppPermission.';
        // Attributes
        this.AppPermissionId = this.i + 'AppPermissionId';
        this.ApplicationId = this.i + 'ApplicationId';
        this.PermissionDisplay = this.i + 'PermissionDisplay';
        this.PermissionMeaning = this.i + 'PermissionMeaning';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.RequiresTwoFactorAuthentication = this.i + 'RequiresTwoFactorAuthentication';
        this.Relations = {
            /** Relation: App Permission Role */
            DwAppPermissionRole: {
                RelationName: 'dw_AppPermission|dw_AppPermissionRole|AppPermissionId',
                FieldPrefix: 'DwAppPermissionRole',
                PropertyName: 'DwAppPermissionRole'
            },
        };
        this.ItemDetail.ItemId = 44;
        this.ItemDetail.ItemName = 'dw_AppPermission';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwAppPermissionRoleMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_AppPermissionRole.';
        // Attributes
        this.AppPermissionRoleId = this.i + 'AppPermissionRoleId';
        this.AppPermissionId = this.i + 'AppPermissionId';
        this.RoleId = this.i + 'RoleId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.Relations = {
            /** Relation: App Permission */
            DwAppPermission: {
                RelationName: 'dw_AppPermission|dw_AppPermissionRole|AppPermissionId',
                FieldPrefix: 'DwAppPermission',
                PropertyName: 'DwAppPermission'
            },
            /** Relation: Role */
            DwRole: {
                RelationName: 'dw_Role|dw_AppPermissionRole|RoleId',
                FieldPrefix: 'DwRole',
                PropertyName: 'DwRole'
            },
        };
        this.ItemDetail.ItemId = 46;
        this.ItemDetail.ItemName = 'dw_AppPermissionRole';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwContextDataDefinitionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ContextDataDefinition.';
        // Attributes
        this.ContextDataDefinitionId = this.i + 'ContextDataDefinitionId';
        this.ContextKey = this.i + 'ContextKey';
        this.ContextDisplay = this.i + 'ContextDisplay';
        this.IsGlobal = this.i + 'IsGlobal';
        this.LoadAllData = this.i + 'LoadAllData';
        this.ParentMetaDataItemId = this.i + 'ParentMetaDataItemId';
        this.MainMetaDataItemId = this.i + 'MainMetaDataItemId';
        this.MetaDataQueryId = this.i + 'MetaDataQueryId';
        this.MetaDataRelationshipId = this.i + 'MetaDataRelationshipId';
        this.Relations = {
            /** Relation: Meta Data Item - Parent Meta Data Item */
            DwMetaDataItemByParentMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_ContextDataDefinition|ParentMetaDataItemId',
                FieldPrefix: 'ParentDwMetaDataItem',
                PropertyName: 'ParentDwMetaDataItem'
            },
            /** Relation: Meta Data Item - Main Meta Data Item */
            DwMetaDataItemByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_ContextDataDefinition|MainMetaDataItemId',
                FieldPrefix: 'MainDwMetaDataItem',
                PropertyName: 'MainDwMetaDataItem'
            },
            /** Relation: Relationships - Meta Data Relationship */
            DwMetaDataItemRelationshipByMetaDataRelationshipId: {
                RelationName: 'dw_MetaDataItemRelationship|dw_ContextDataDefinition|MetaDataRelationshipId',
                FieldPrefix: 'MetaDataRelationshipIdDwMetaDataItemRelationship',
                PropertyName: 'MetaDataRelationshipIdDwMetaDataItemRelationship'
            },
            /** Relation: Meta Data Query */
            DwMetaDataQuery: {
                RelationName: 'dw_MetaDataQuery|dw_ContextDataDefinition|MetaDataQueryId',
                FieldPrefix: 'DwMetaDataQuery',
                PropertyName: 'DwMetaDataQuery'
            },
        };
        this.ItemDetail.ItemId = 2503;
        this.ItemDetail.ItemName = 'dw_ContextDataDefinition';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwDataImportMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_DataImport.';
        // Attributes
        this.DataImportId = this.i + 'DataImportId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.ImportFileMediaId = this.i + 'ImportFileMediaId';
        this.ImportRequestJSON = this.i + 'ImportRequestJSON';
        this.ImportResultJSON = this.i + 'ImportResultJSON';
        this.ImportStartDateTime = this.i + 'ImportStartDateTime';
        this.ImportCompletionDateTime = this.i + 'ImportCompletionDateTime';
        this.IsSuccess = this.i + 'IsSuccess';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_DataImport|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Data Import Log */
            DwDataImportLog: {
                RelationName: 'dw_DataImport|dw_DataImportLog|DataImportId',
                FieldPrefix: 'DwDataImportLog',
                PropertyName: 'DwDataImportLog'
            },
            /** Relation: Data Import Row */
            DwDataImportRow: {
                RelationName: 'dw_DataImport|dw_DataImportRow|DataImportId',
                FieldPrefix: 'DwDataImportRow',
                PropertyName: 'DwDataImportRow'
            },
        };
        this.ItemDetail.ItemId = 4083;
        this.ItemDetail.ItemName = 'dw_DataImport';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwDataImportLogMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_DataImportLog.';
        // Attributes
        this.DataImportLogId = this.i + 'DataImportLogId';
        this.DataImportId = this.i + 'DataImportId';
        this.LogId = this.i + 'LogId';
        this.Relations = {
            /** Relation: Data Import */
            DwDataImport: {
                RelationName: 'dw_DataImport|dw_DataImportLog|DataImportId',
                FieldPrefix: 'DwDataImport',
                PropertyName: 'DwDataImport'
            },
            /** Relation: Log */
            DwLog: {
                RelationName: 'dw_Log|dw_DataImportLog|LogId',
                FieldPrefix: 'DwLog',
                PropertyName: 'DwLog'
            },
        };
        this.ItemDetail.ItemId = 4084;
        this.ItemDetail.ItemName = 'dw_DataImportLog';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwDataImportRowMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_DataImportRow.';
        // Attributes
        this.DataImportRowId = this.i + 'DataImportRowId';
        this.DataImportId = this.i + 'DataImportId';
        this.ReferenceKeyValue = this.i + 'ReferenceKeyValue';
        this.Relations = {
            /** Relation: Data Import */
            DwDataImport: {
                RelationName: 'dw_DataImport|dw_DataImportRow|DataImportId',
                FieldPrefix: 'DwDataImport',
                PropertyName: 'DwDataImport'
            },
        };
        this.ItemDetail.ItemId = 4085;
        this.ItemDetail.ItemName = 'dw_DataImportRow';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwEmailTemplateMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_EmailTemplate.';
        // Attributes
        this.EmailTemplateId = this.i + 'EmailTemplateId';
        this.TemplateMeaning = this.i + 'TemplateMeaning';
        this.EmailTemplateGroupId = this.i + 'EmailTemplateGroupId';
        this.CommunicationGroupId = this.i + 'CommunicationGroupId';
        this.SubjectTemplate = this.i + 'SubjectTemplate';
        this.BodyTemplate = this.i + 'BodyTemplate';
        this.FromEmail = this.i + 'FromEmail';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.AllowFromEmailSender = this.i + 'AllowFromEmailSender';
        this.MainMetaDataItemId = this.i + 'MainMetaDataItemId';
        this.TemplateConfigJson = this.i + 'TemplateConfigJson';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.Relations = {
            /** Relation: Email Template Group */
            DwEmailTemplateGroup: {
                RelationName: 'dw_EmailTemplateGroup|dw_EmailTemplate|EmailTemplateGroupId',
                FieldPrefix: 'DwEmailTemplateGroup',
                PropertyName: 'DwEmailTemplateGroup'
            },
            /** Relation: Meta Data Item - Main Item */
            DwMetaDataItemByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_EmailTemplate|MainMetaDataItemId',
                FieldPrefix: 'MainDwMetaDataItem',
                PropertyName: 'MainDwMetaDataItem'
            },
            /** Relation: Email Template Elapsed History */
            DwEmailTemplateElapsedHistory: {
                RelationName: 'dw_EmailTemplate|dw_EmailTemplateElapsedHistory|EmailTemplateId',
                FieldPrefix: 'DwEmailTemplateElapsedHistory',
                PropertyName: 'DwEmailTemplateElapsedHistory'
            },
        };
        this.ItemDetail.ItemId = 196;
        this.ItemDetail.ItemName = 'dw_EmailTemplate';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwEmailTemplateElapsedHistoryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_EmailTemplateElapsedHistory.';
        // Attributes
        this.EmailTemplateElapsedHistoryId = this.i + 'EmailTemplateElapsedHistoryId';
        this.EmailTemplateId = this.i + 'EmailTemplateId';
        this.ItemKeyValue = this.i + 'ItemKeyValue';
        this.DateTimeValue = this.i + 'DateTimeValue';
        this.TriggerKey = this.i + 'TriggerKey';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.CreatedBy = this.i + 'CreatedBy';
        this.Relations = {
            /** Relation: Email Template */
            DwEmailTemplate: {
                RelationName: 'dw_EmailTemplate|dw_EmailTemplateElapsedHistory|EmailTemplateId',
                FieldPrefix: 'DwEmailTemplate',
                PropertyName: 'DwEmailTemplate'
            },
        };
        this.ItemDetail.ItemId = 3750;
        this.ItemDetail.ItemName = 'dw_EmailTemplateElapsedHistory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwEmailTemplateGroupMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_EmailTemplateGroup.';
        // Attributes
        this.EmailTemplateGroupId = this.i + 'EmailTemplateGroupId';
        this.GroupName = this.i + 'GroupName';
        this.HeaderTemplate = this.i + 'HeaderTemplate';
        this.FooterTemplate = this.i + 'FooterTemplate';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Email Template */
            DwEmailTemplate: {
                RelationName: 'dw_EmailTemplateGroup|dw_EmailTemplate|EmailTemplateGroupId',
                FieldPrefix: 'DwEmailTemplate',
                PropertyName: 'DwEmailTemplate'
            },
        };
        this.ItemDetail.ItemId = 205;
        this.ItemDetail.ItemName = 'dw_EmailTemplateGroup';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwExceptionDetailMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ExceptionDetail.';
        // Attributes
        this.ExceptionDetailId = this.i + 'ExceptionDetailId';
        this.LogId = this.i + 'LogId';
        this.ExceptionLevel = this.i + 'ExceptionLevel';
        this.Message = this.i + 'Message';
        this.Details = this.i + 'Details';
        this.StackTrace = this.i + 'StackTrace';
        this.Source = this.i + 'Source';
        this.ExceptionType = this.i + 'ExceptionType';
        this.TargetSite = this.i + 'TargetSite';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Log */
            DwLog: {
                RelationName: 'dw_Log|dw_ExceptionDetail|LogId',
                FieldPrefix: 'DwLog',
                PropertyName: 'DwLog'
            },
        };
        this.ItemDetail.ItemId = 59;
        this.ItemDetail.ItemName = 'dw_ExceptionDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwFeatureAreaMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureArea.';
        // Attributes
        this.FeatureAreaId = this.i + 'FeatureAreaId';
        this.FeatureAreaName = this.i + 'FeatureAreaName';
        this.FeatureAreaMeaning = this.i + 'FeatureAreaMeaning';
        this.FeatureAreaDescription = this.i + 'FeatureAreaDescription';
        this.FeatureAreaConfig = this.i + 'FeatureAreaConfig';
        this.MetaDataDatabaseId = this.i + 'MetaDataDatabaseId';
        this.SchemaList = this.i + 'SchemaList';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.UniqueId = this.i + 'UniqueId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Database */
            DwMetaDataDatabase: {
                RelationName: 'dw_MetaDataDatabase|dw_FeatureArea|MetaDataDatabaseId',
                FieldPrefix: 'DwMetaDataDatabase',
                PropertyName: 'DwMetaDataDatabase'
            },
            /** Relation: Feature Area Detail */
            DwFeatureAreaDetail: {
                RelationName: 'dw_FeatureArea|dw_FeatureAreaDetail|FeatureAreaId',
                FieldPrefix: 'DwFeatureAreaDetail',
                PropertyName: 'DwFeatureAreaDetail'
            },
        };
        this.ItemDetail.ItemId = 3772;
        this.ItemDetail.ItemName = 'dw_FeatureArea';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwFeatureAreaDetailMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureAreaDetail.';
        // Attributes
        this.FeatureAreaDetailId = this.i + 'FeatureAreaDetailId';
        this.FeatureAreaId = this.i + 'FeatureAreaId';
        this.FeatureAreaDetailTypeId = this.i + 'FeatureAreaDetailTypeId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.ReferenceKeyValue = this.i + 'ReferenceKeyValue';
        this.ReferenceDisplay = this.i + 'ReferenceDisplay';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Feature Area */
            DwFeatureArea: {
                RelationName: 'dw_FeatureArea|dw_FeatureAreaDetail|FeatureAreaId',
                FieldPrefix: 'DwFeatureArea',
                PropertyName: 'DwFeatureArea'
            },
            /** Relation: Feature Area Detail Type */
            DwFeatureAreaDetailType: {
                RelationName: 'dw_FeatureAreaDetailType|dw_FeatureAreaDetail|FeatureAreaDetailTypeId',
                FieldPrefix: 'DwFeatureAreaDetailType',
                PropertyName: 'DwFeatureAreaDetailType'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_FeatureAreaDetail|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 3767;
        this.ItemDetail.ItemName = 'dw_FeatureAreaDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwFeatureAreaDetailGroupMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureAreaDetailGroup.';
        // Attributes
        this.FeatureAreaDetailGroupId = this.i + 'FeatureAreaDetailGroupId';
        this.DetailGroupDisplay = this.i + 'DetailGroupDisplay';
        this.DetailGroupMeaning = this.i + 'DetailGroupMeaning';
        this.IconClass = this.i + 'IconClass';
        this.DetailGroupOrder = this.i + 'DetailGroupOrder';
        this.Relations = {
            /** Relation: Feature Area Detail Type */
            DwFeatureAreaDetailType: {
                RelationName: 'dw_FeatureAreaDetailGroup|dw_FeatureAreaDetailType|FeatureAreaDetailGroupId',
                FieldPrefix: 'DwFeatureAreaDetailType',
                PropertyName: 'DwFeatureAreaDetailType'
            },
        };
        this.ItemDetail.ItemId = 3798;
        this.ItemDetail.ItemName = 'dw_FeatureAreaDetailGroup';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwFeatureAreaDetailTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureAreaDetailType.';
        // Attributes
        this.FeatureAreaDetailTypeId = this.i + 'FeatureAreaDetailTypeId';
        this.DetailTypeDisplay = this.i + 'DetailTypeDisplay';
        this.DetailTypeMeaning = this.i + 'DetailTypeMeaning';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.FeatureAreaDetailGroupId = this.i + 'FeatureAreaDetailGroupId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.ItemReferenceOnly = this.i + 'ItemReferenceOnly';
        this.DetailTypeOrder = this.i + 'DetailTypeOrder';
        this.Relations = {
            /** Relation: Feature Area Detail Group */
            DwFeatureAreaDetailGroup: {
                RelationName: 'dw_FeatureAreaDetailGroup|dw_FeatureAreaDetailType|FeatureAreaDetailGroupId',
                FieldPrefix: 'DwFeatureAreaDetailGroup',
                PropertyName: 'DwFeatureAreaDetailGroup'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_FeatureAreaDetailType|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Feature Area Detail */
            DwFeatureAreaDetail: {
                RelationName: 'dw_FeatureAreaDetailType|dw_FeatureAreaDetail|FeatureAreaDetailTypeId',
                FieldPrefix: 'DwFeatureAreaDetail',
                PropertyName: 'DwFeatureAreaDetail'
            },
        };
        this.ItemDetail.ItemId = 3766;
        this.ItemDetail.ItemName = 'dw_FeatureAreaDetailType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwLogMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_Log.';
        // Attributes
        this.LogId = this.i + 'LogId';
        this.ApplicationId = this.i + 'ApplicationId';
        this.EventId = this.i + 'EventId';
        this.Message = this.i + 'Message';
        this.Priority = this.i + 'Priority';
        this.Severity = this.i + 'Severity';
        this.MachineName = this.i + 'MachineName';
        this.AppDomainName = this.i + 'AppDomainName';
        this.ProcessId = this.i + 'ProcessId';
        this.ProcessName = this.i + 'ProcessName';
        this.ThreadName = this.i + 'ThreadName';
        this.Win32ThreadId = this.i + 'Win32ThreadId';
        this.Title = this.i + 'Title';
        this.TimeStamp = this.i + 'TimeStamp';
        this.AuthenticatedUser = this.i + 'AuthenticatedUser';
        this.IsException = this.i + 'IsException';
        this.RequestUrl = this.i + 'RequestUrl';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.ApplicationUrl = this.i + 'ApplicationUrl';
        this.SqlTraceUniqueId = this.i + 'SqlTraceUniqueId';
        this.Relations = {
            /** Relation: Data Import Log */
            DwDataImportLog: {
                RelationName: 'dw_Log|dw_DataImportLog|LogId',
                FieldPrefix: 'DwDataImportLog',
                PropertyName: 'DwDataImportLog'
            },
            /** Relation: Exception Detail */
            DwExceptionDetail: {
                RelationName: 'dw_Log|dw_ExceptionDetail|LogId',
                FieldPrefix: 'DwExceptionDetail',
                PropertyName: 'DwExceptionDetail'
            },
            /** Relation: Log Data */
            DwLogData: {
                RelationName: 'dw_Log|dw_LogData|LogId',
                FieldPrefix: 'DwLogData',
                PropertyName: 'DwLogData'
            },
            /** Relation: Meta Data Import Log */
            DwMetaDataImportLog: {
                RelationName: 'dw_Log|dw_MetaDataImportLog|LogId',
                FieldPrefix: 'DwMetaDataImportLog',
                PropertyName: 'DwMetaDataImportLog'
            },
            /** Relation: Process Schedule History - Error - Many */
            DwProcessScheduleHistoryByErrorLogId: {
                RelationName: 'dw_Log|dw_ProcessScheduleHistory|ErrorLogId',
                FieldPrefix: 'ErrorDwProcessScheduleHistory',
                PropertyName: 'ErrorDwProcessScheduleHistory'
            },
        };
        this.ItemDetail.ItemId = 60;
        this.ItemDetail.ItemName = 'dw_Log';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwLogDataMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_LogData.';
        // Attributes
        this.LogDataId = this.i + 'LogDataId';
        this.LogId = this.i + 'LogId';
        this.DataName = this.i + 'DataName';
        this.Data = this.i + 'Data';
        this.Relations = {
            /** Relation: Log */
            DwLog: {
                RelationName: 'dw_Log|dw_LogData|LogId',
                FieldPrefix: 'DwLog',
                PropertyName: 'DwLog'
            },
        };
        this.ItemDetail.ItemId = 3802;
        this.ItemDetail.ItemName = 'dw_LogData';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwLogPatternMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_LogPattern.';
        // Attributes
        this.LogPatternId = this.i + 'LogPatternId';
        this.LogPatternName = this.i + 'LogPatternName';
        this.LogPatternStatusId = this.i + 'LogPatternStatusId';
        this.Relations = {
            /** Relation: Log Pattern Status */
            DwLogPatternStatus: {
                RelationName: 'dw_LogPatternStatus|dw_LogPattern|LogPatternStatusId',
                FieldPrefix: 'DwLogPatternStatus',
                PropertyName: 'DwLogPatternStatus'
            },
            /** Relation: Log Pattern Detail */
            DwLogPatternDetail: {
                RelationName: 'dw_LogPattern|dw_LogPatternDetail|LogPatternId',
                FieldPrefix: 'DwLogPatternDetail',
                PropertyName: 'DwLogPatternDetail'
            },
        };
        this.ItemDetail.ItemId = 3825;
        this.ItemDetail.ItemName = 'dw_LogPattern';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwLogPatternDetailMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_LogPatternDetail.';
        // Attributes
        this.LogPatternDetailId = this.i + 'LogPatternDetailId';
        this.LogPatternId = this.i + 'LogPatternId';
        this.LogPatternExpressionJSON = this.i + 'LogPatternExpressionJSON';
        this.Relations = {
            /** Relation: Log Pattern */
            DwLogPattern: {
                RelationName: 'dw_LogPattern|dw_LogPatternDetail|LogPatternId',
                FieldPrefix: 'DwLogPattern',
                PropertyName: 'DwLogPattern'
            },
        };
        this.ItemDetail.ItemId = 3826;
        this.ItemDetail.ItemName = 'dw_LogPatternDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwLogPatternStatusMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_LogPatternStatus.';
        // Attributes
        this.LogPatternStatusId = this.i + 'LogPatternStatusId';
        this.LogPatternStatus = this.i + 'LogPatternStatus';
        this.Relations = {
            /** Relation: Log Pattern */
            DwLogPattern: {
                RelationName: 'dw_LogPatternStatus|dw_LogPattern|LogPatternStatusId',
                FieldPrefix: 'DwLogPattern',
                PropertyName: 'DwLogPattern'
            },
        };
        this.ItemDetail.ItemId = 3824;
        this.ItemDetail.ItemName = 'dw_LogPatternStatus';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwLogSqlTraceMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_LogSqlTrace.';
        // Attributes
        this.LogSqlTraceId = this.i + 'LogSqlTraceId';
        this.SqlTraceUniqueId = this.i + 'SqlTraceUniqueId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.QueryMeaning = this.i + 'QueryMeaning';
        this.FullSql = this.i + 'FullSql';
        this.Relations = {};
        this.ItemDetail.ItemId = 3801;
        this.ItemDetail.ItemName = 'dw_LogSqlTrace';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataAttributeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttribute.';
        // Attributes
        this.MetaDataAttributeId = this.i + 'MetaDataAttributeId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.AttributeName = this.i + 'AttributeName';
        this.AttributeLength = this.i + 'AttributeLength';
        this.Display = this.i + 'Display';
        this.MetaDataAttributeTypeId = this.i + 'MetaDataAttributeTypeId';
        this.MetaDataAttributeDefinitionId = this.i + 'MetaDataAttributeDefinitionId';
        this.MetaDataSqlTypeId = this.i + 'MetaDataSqlTypeId';
        this.AllowNull = this.i + 'AllowNull';
        this.AttributeIndex = this.i + 'AttributeIndex';
        this.IsKey = this.i + 'IsKey';
        this.ReferenceMetaDataItemId = this.i + 'ReferenceMetaDataItemId';
        this.IsActive = this.i + 'IsActive';
        this.Layer = this.i + 'Layer';
        this.IsCustomAttribute = this.i + 'IsCustomAttribute';
        this.CustomAttributeIndex = this.i + 'CustomAttributeIndex';
        this.MetaDataControlTypeId = this.i + 'MetaDataControlTypeId';
        this.MaxLength = this.i + 'MaxLength';
        this.MinValue = this.i + 'MinValue';
        this.MaxValue = this.i + 'MaxValue';
        this.Decimals = this.i + 'Decimals';
        this.AlwaysRequired = this.i + 'AlwaysRequired';
        this.CodeSetId = this.i + 'CodeSetId';
        this.MetaDataLookupId = this.i + 'MetaDataLookupId';
        this.MetaDataAttributeFormatId = this.i + 'MetaDataAttributeFormatId';
        this.DefaultValue = this.i + 'DefaultValue';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.LongDisplay = this.i + 'LongDisplay';
        this.MetaDataLookupParamAttribute1Id = this.i + 'MetaDataLookupParamAttribute1Id';
        this.MetaDatalookupParamAttribute2Id = this.i + 'MetaDatalookupParamAttribute2Id';
        this.UseGmtDateTime = this.i + 'UseGmtDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.IsLookup = this.i + 'IsLookup';
        this.ReferenceIsParent = this.i + 'ReferenceIsParent';
        this.ExcludeFromHistory = this.i + 'ExcludeFromHistory';
        this.Relations = {
            /** Relation: Meta Data Attribute Format - Format */
            DwMetaDataAttributeFormatByMetaDataAttributeFormatId: {
                RelationName: 'dw_MetaDataAttributeFormat|dw_MetaDataAttribute|MetaDataAttributeFormatId',
                FieldPrefix: 'MetaDataAttributeFormatIdDwMetaDataAttributeFormat',
                PropertyName: 'MetaDataAttributeFormatIdDwMetaDataAttributeFormat'
            },
            /** Relation: Meta Data Attribute Type */
            DwMetaDataAttributeType: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttribute|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeType',
                PropertyName: 'DwMetaDataAttributeType'
            },
            /** Relation: Meta Data Control Type */
            DwMetaDataControlType: {
                RelationName: 'dw_MetaDataControlType|dw_MetaDataAttribute|MetaDataControlTypeId',
                FieldPrefix: 'DwMetaDataControlType',
                PropertyName: 'DwMetaDataControlType'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataAttribute|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Meta Data Item - Reference Item */
            DwMetaDataItemByReferenceMetaDataItemId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataItem|ReferenceMetaDataItemId',
                FieldPrefix: 'ReferenceDwMetaDataItem',
                PropertyName: 'ReferenceDwMetaDataItem'
            },
            /** Relation: Meta Data Lookup */
            DwMetaDataLookup: {
                RelationName: 'dw_MetaDataLookup|dw_MetaDataAttribute|MetaDataLookupId',
                FieldPrefix: 'DwMetaDataLookup',
                PropertyName: 'DwMetaDataLookup'
            },
            /** Relation: Meta Data Attribute - Lookup Param 1 - One */
            DwMetaDataAttributeByMetaDataLookupParamAttribute1Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataAttribute|MetaDataLookupParamAttribute1Id',
                FieldPrefix: 'MetaDataLookupParamAttribute1IdDwMetaDataAttribute',
                PropertyName: 'MetaDataLookupParamAttribute1IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Lookup Param 2 - One */
            DwMetaDataAttributeByMetaDatalookupParamAttribute2Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataAttribute|MetaDatalookupParamAttribute2Id',
                FieldPrefix: 'MetaDatalookupParamAttribute2IdDwMetaDataAttribute',
                PropertyName: 'MetaDatalookupParamAttribute2IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Sql Type */
            DwMetaDataSqlType: {
                RelationName: 'dw_MetaDataSqlType|dw_MetaDataAttribute|MetaDataSqlTypeId',
                FieldPrefix: 'DwMetaDataSqlType',
                PropertyName: 'DwMetaDataSqlType'
            },
            /** Relation: Relationships - Pk - Many */
            DwMetaDataItemRelationshipByPkMetaDataAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataItemRelationship|PkMetaDataAttributeId',
                FieldPrefix: 'PkDwMetaDataItemRelationship',
                PropertyName: 'PkDwMetaDataItemRelationship'
            },
            /** Relation: Relationships - Fk - Many */
            DwMetaDataItemRelationshipByFkMetaDataAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataItemRelationship|FkMetaDataAttributeId',
                FieldPrefix: 'FkDwMetaDataItemRelationship',
                PropertyName: 'FkDwMetaDataItemRelationship'
            },
            /** Relation: Meta Data Lookup - Additional Attribute1 - Many */
            DwMetaDataLookupByAdditionalAttribute1Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute1Id',
                FieldPrefix: 'AdditionalAttribute1IdDwMetaDataLookup',
                PropertyName: 'AdditionalAttribute1IdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Additional Attribute2 - Many */
            DwMetaDataLookupByAdditionalAttribute2Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute2Id',
                FieldPrefix: 'AdditionalAttribute2IdDwMetaDataLookup',
                PropertyName: 'AdditionalAttribute2IdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Additional Attribute3 - Many */
            DwMetaDataLookupByAdditionalAttribute3Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute3Id',
                FieldPrefix: 'AdditionalAttribute3IdDwMetaDataLookup',
                PropertyName: 'AdditionalAttribute3IdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Additional Attribute4 - Many */
            DwMetaDataLookupByAdditionalAttribute4Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute4Id',
                FieldPrefix: 'AdditionalAttribute4IdDwMetaDataLookup',
                PropertyName: 'AdditionalAttribute4IdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Transition Reference Attribute1 - Many */
            DwMetaDataLookupByTransitionReferenceAttribute1Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute1Id',
                FieldPrefix: 'TransitionReferenceAttribute1IdDwMetaDataLookup',
                PropertyName: 'TransitionReferenceAttribute1IdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Transition Reference Attribute2 - Many */
            DwMetaDataLookupByTransitionReferenceAttribute2Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute2Id',
                FieldPrefix: 'TransitionReferenceAttribute2IdDwMetaDataLookup',
                PropertyName: 'TransitionReferenceAttribute2IdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Key Attribute - Many */
            DwMetaDataLookupByKeyAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|KeyAttributeId',
                FieldPrefix: 'KeyAttributeIdDwMetaDataLookup',
                PropertyName: 'KeyAttributeIdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup - Group By Attribute - Many */
            DwMetaDataLookupByGroupByAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|GroupByAttributeId',
                FieldPrefix: 'GroupByAttributeIdDwMetaDataLookup',
                PropertyName: 'GroupByAttributeIdDwMetaDataLookup'
            },
            /** Relation: Meta Data Lookup Param */
            DwMetaDataLookupParam: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookupParam|MetaDataAttributeId',
                FieldPrefix: 'DwMetaDataLookupParam',
                PropertyName: 'DwMetaDataLookupParam'
            },
            /** Relation: Security Group Attribute */
            DwMetaDataSecurityGroupAttribute: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataSecurityGroupAttribute|MetaDataAttributeId',
                FieldPrefix: 'DwMetaDataSecurityGroupAttribute',
                PropertyName: 'DwMetaDataSecurityGroupAttribute'
            },
        };
        this.ItemDetail.ItemId = 25;
        this.ItemDetail.ItemName = 'dw_MetaDataAttribute';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataAttributeFormatMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeFormat.';
        // Attributes
        this.MetaDataAttributeFormatid = this.i + 'MetaDataAttributeFormatid';
        this.FormatDisplay = this.i + 'FormatDisplay';
        this.FormatCode = this.i + 'FormatCode';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Attribute - Many */
            DwMetaDataAttributeByMetaDataAttributeFormatId: {
                RelationName: 'dw_MetaDataAttributeFormat|dw_MetaDataAttribute|MetaDataAttributeFormatId',
                FieldPrefix: 'MetaDataAttributeFormatIdDwMetaDataAttribute',
                PropertyName: 'MetaDataAttributeFormatIdDwMetaDataAttribute'
            },
        };
        this.ItemDetail.ItemId = 78;
        this.ItemDetail.ItemName = 'dw_MetaDataAttributeFormat';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataAttributeTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeType.';
        // Attributes
        this.MetaDataAttributeTypeId = this.i + 'MetaDataAttributeTypeId';
        this.AttributeTypeName = this.i + 'AttributeTypeName';
        this.MetaDataDotNetTypeId = this.i + 'MetaDataDotNetTypeId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Dot Net Type */
            DwMetaDataDotNetType: {
                RelationName: 'dw_MetaDataDotNetType|dw_MetaDataAttributeType|MetaDataDotNetTypeId',
                FieldPrefix: 'DwMetaDataDotNetType',
                PropertyName: 'DwMetaDataDotNetType'
            },
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttribute|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute Type Comparer Map */
            DwMetaDataAttributeTypeComparerMap: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttributeTypeComparerMap|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeTypeComparerMap',
                PropertyName: 'DwMetaDataAttributeTypeComparerMap'
            },
            /** Relation: Meta Data Attribute Type Control Type Map */
            DwMetaDataAttributeTypeControlTypeMap: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeTypeControlTypeMap',
                PropertyName: 'DwMetaDataAttributeTypeControlTypeMap'
            },
            /** Relation: Meta Data Attribute Type Sql Type Map */
            DwMetaDataAttributeTypeSqlTypeMap: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeTypeSqlTypeMap',
                PropertyName: 'DwMetaDataAttributeTypeSqlTypeMap'
            },
            /** Relation: Meta Data Comparer - Alt First Value Attribute Type - Many */
            DwMetaDataComparerByAltFirstValueAttributeTypeId: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataComparer|AltFirstValueAttributeTypeId',
                FieldPrefix: 'AltFirstValueAttributeTypeIdDwMetaDataComparer',
                PropertyName: 'AltFirstValueAttributeTypeIdDwMetaDataComparer'
            },
        };
        this.ItemDetail.ItemId = 87;
        this.ItemDetail.ItemName = 'dw_MetaDataAttributeType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataAttributeTypeComparerMapMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeTypeComparerMap.';
        // Attributes
        this.MetaDataAttributeTypeComparerMapId = this.i + 'MetaDataAttributeTypeComparerMapId';
        this.MetaDataAttributeTypeId = this.i + 'MetaDataAttributeTypeId';
        this.MetaDataComparerId = this.i + 'MetaDataComparerId';
        this.IsDefault = this.i + 'IsDefault';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Attribute Type */
            DwMetaDataAttributeType: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttributeTypeComparerMap|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeType',
                PropertyName: 'DwMetaDataAttributeType'
            },
            /** Relation: Meta Data Comparer */
            DwMetaDataComparer: {
                RelationName: 'dw_MetaDataComparer|dw_MetaDataAttributeTypeComparerMap|MetaDataComparerId',
                FieldPrefix: 'DwMetaDataComparer',
                PropertyName: 'DwMetaDataComparer'
            },
        };
        this.ItemDetail.ItemId = 2;
        this.ItemDetail.ItemName = 'dw_MetaDataAttributeTypeComparerMap';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataAttributeTypeControlTypeMapMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeTypeControlTypeMap.';
        // Attributes
        this.MetaDataAttributeTypeControlTypeMapId = this.i + 'MetaDataAttributeTypeControlTypeMapId';
        this.MetaDataAttributeTypeId = this.i + 'MetaDataAttributeTypeId';
        this.MetaDataControlTypeId = this.i + 'MetaDataControlTypeId';
        this.IsDefault = this.i + 'IsDefault';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.IsLookup = this.i + 'IsLookup';
        this.Relations = {
            /** Relation: Meta Data Attribute Type */
            DwMetaDataAttributeType: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeType',
                PropertyName: 'DwMetaDataAttributeType'
            },
            /** Relation: Meta Data Control Type */
            DwMetaDataControlType: {
                RelationName: 'dw_MetaDataControlType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataControlTypeId',
                FieldPrefix: 'DwMetaDataControlType',
                PropertyName: 'DwMetaDataControlType'
            },
        };
        this.ItemDetail.ItemId = 3;
        this.ItemDetail.ItemName = 'dw_MetaDataAttributeTypeControlTypeMap';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataAttributeTypeSqlTypeMapMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeTypeSqlTypeMap.';
        // Attributes
        this.MetaDataAttributeTypeSqlTypeMapId = this.i + 'MetaDataAttributeTypeSqlTypeMapId';
        this.MetaDataAttributeTypeId = this.i + 'MetaDataAttributeTypeId';
        this.MetaDataSqlTypeId = this.i + 'MetaDataSqlTypeId';
        this.IsDefault = this.i + 'IsDefault';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Attribute Type */
            DwMetaDataAttributeType: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataAttributeTypeId',
                FieldPrefix: 'DwMetaDataAttributeType',
                PropertyName: 'DwMetaDataAttributeType'
            },
            /** Relation: Meta Data Sql Type */
            DwMetaDataSqlType: {
                RelationName: 'dw_MetaDataSqlType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataSqlTypeId',
                FieldPrefix: 'DwMetaDataSqlType',
                PropertyName: 'DwMetaDataSqlType'
            },
        };
        this.ItemDetail.ItemId = 5;
        this.ItemDetail.ItemName = 'dw_MetaDataAttributeTypeSqlTypeMap';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataCollectionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataCollection.';
        // Attributes
        this.MetaDataCollectionId = this.i + 'MetaDataCollectionId';
        this.MetaDataSystemId = this.i + 'MetaDataSystemId';
        this.CollectionDisplay = this.i + 'CollectionDisplay';
        this.CollectionMeaning = this.i + 'CollectionMeaning';
        this.DefaultMetaDataItemId = this.i + 'DefaultMetaDataItemId';
        this.Relations = {
            /** Relation: Meta Data Item - Default Meta Data Item */
            DwMetaDataItemByDefaultMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataCollection|DefaultMetaDataItemId',
                FieldPrefix: 'DefaultDwMetaDataItem',
                PropertyName: 'DefaultDwMetaDataItem'
            },
            /** Relation: Meta Data System */
            DwMetaDataSystem: {
                RelationName: 'dw_MetaDataSystem|dw_MetaDataCollection|MetaDataSystemId',
                FieldPrefix: 'DwMetaDataSystem',
                PropertyName: 'DwMetaDataSystem'
            },
            /** Relation: Meta Data Operation */
            DwMetaDataOperation: {
                RelationName: 'dw_MetaDataCollection|dw_MetaDataOperation|MetaDataCollectionId',
                FieldPrefix: 'DwMetaDataOperation',
                PropertyName: 'DwMetaDataOperation'
            },
        };
        this.ItemDetail.ItemId = 2733;
        this.ItemDetail.ItemName = 'dw_MetaDataCollection';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataComparerMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataComparer.';
        // Attributes
        this.MetaDataComparerId = this.i + 'MetaDataComparerId';
        this.ComparerName = this.i + 'ComparerName';
        this.ComparerDisplay = this.i + 'ComparerDisplay';
        this.ComparerMeaning = this.i + 'ComparerMeaning';
        this.RequiresFirstValue = this.i + 'RequiresFirstValue';
        this.RequiresSecondValue = this.i + 'RequiresSecondValue';
        this.AllowUseOfFields = this.i + 'AllowUseOfFields';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.AltFirstValueAttributeTypeId = this.i + 'AltFirstValueAttributeTypeId';
        this.Relations = {
            /** Relation: Meta Data Attribute Type - Alternate First Value Type */
            DwMetaDataAttributeTypeByAltFirstValueAttributeTypeId: {
                RelationName: 'dw_MetaDataAttributeType|dw_MetaDataComparer|AltFirstValueAttributeTypeId',
                FieldPrefix: 'AltFirstValueAttributeTypeIdDwMetaDataAttributeType',
                PropertyName: 'AltFirstValueAttributeTypeIdDwMetaDataAttributeType'
            },
            /** Relation: Meta Data Attribute Type Comparer Map */
            DwMetaDataAttributeTypeComparerMap: {
                RelationName: 'dw_MetaDataComparer|dw_MetaDataAttributeTypeComparerMap|MetaDataComparerId',
                FieldPrefix: 'DwMetaDataAttributeTypeComparerMap',
                PropertyName: 'DwMetaDataAttributeTypeComparerMap'
            },
        };
        this.ItemDetail.ItemId = 6;
        this.ItemDetail.ItemName = 'dw_MetaDataComparer';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataControlTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataControlType.';
        // Attributes
        this.MetaDataControlTypeId = this.i + 'MetaDataControlTypeId';
        this.ControlTypeName = this.i + 'ControlTypeName';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataControlType|dw_MetaDataAttribute|MetaDataControlTypeId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute Type Control Type Map */
            DwMetaDataAttributeTypeControlTypeMap: {
                RelationName: 'dw_MetaDataControlType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataControlTypeId',
                FieldPrefix: 'DwMetaDataAttributeTypeControlTypeMap',
                PropertyName: 'DwMetaDataAttributeTypeControlTypeMap'
            },
        };
        this.ItemDetail.ItemId = 9;
        this.ItemDetail.ItemName = 'dw_MetaDataControlType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataDatabaseMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataDatabase.';
        // Attributes
        this.MetaDataDatabaseId = this.i + 'MetaDataDatabaseId';
        this.DatabaseDisplayName = this.i + 'DatabaseDisplayName';
        this.DatabaseMeaning = this.i + 'DatabaseMeaning';
        this.MetaDataDatabaseSystemId = this.i + 'MetaDataDatabaseSystemId';
        this.DatabaseConnectionString = this.i + 'DatabaseConnectionString';
        this.DatabaseCatalogName = this.i + 'DatabaseCatalogName';
        this.DatabaseConnectionStringSetting = this.i + 'DatabaseConnectionStringSetting';
        this.DatabaseCatalogNameSetting = this.i + 'DatabaseCatalogNameSetting';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Database System */
            DwMetaDataDatabaseSystem: {
                RelationName: 'dw_MetaDataDatabaseSystem|dw_MetaDataDatabase|MetaDataDatabaseSystemId',
                FieldPrefix: 'DwMetaDataDatabaseSystem',
                PropertyName: 'DwMetaDataDatabaseSystem'
            },
            /** Relation: Feature Area */
            DwFeatureArea: {
                RelationName: 'dw_MetaDataDatabase|dw_FeatureArea|MetaDataDatabaseId',
                FieldPrefix: 'DwFeatureArea',
                PropertyName: 'DwFeatureArea'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataDatabase|dw_MetaDataItem|MetaDataDatabaseId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 86;
        this.ItemDetail.ItemName = 'dw_MetaDataDatabase';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataDatabaseSystemMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataDatabaseSystem.';
        // Attributes
        this.MetaDataDatabaseSystemId = this.i + 'MetaDataDatabaseSystemId';
        this.DatabaseType = this.i + 'DatabaseType';
        this.DataUtilTypeName = this.i + 'DataUtilTypeName';
        this.QueryEngineTypeName = this.i + 'QueryEngineTypeName';
        this.SchemaServiceTypeName = this.i + 'SchemaServiceTypeName';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.DatabaseSystemKey = this.i + 'DatabaseSystemKey';
        this.Relations = {
            /** Relation: Meta Data Database */
            DwMetaDataDatabase: {
                RelationName: 'dw_MetaDataDatabaseSystem|dw_MetaDataDatabase|MetaDataDatabaseSystemId',
                FieldPrefix: 'DwMetaDataDatabase',
                PropertyName: 'DwMetaDataDatabase'
            },
            /** Relation: Meta Data Sql Type */
            DwMetaDataSqlType: {
                RelationName: 'dw_MetaDataDatabaseSystem|dw_MetaDataSqlType|MetaDataDatabaseSystemId',
                FieldPrefix: 'DwMetaDataSqlType',
                PropertyName: 'DwMetaDataSqlType'
            },
        };
        this.ItemDetail.ItemId = 10;
        this.ItemDetail.ItemName = 'dw_MetaDataDatabaseSystem';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataDotNetTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataDotNetType.';
        // Attributes
        this.MetaDataDotNetTypeId = this.i + 'MetaDataDotNetTypeId';
        this.DotNetType = this.i + 'DotNetType';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Attribute Type */
            DwMetaDataAttributeType: {
                RelationName: 'dw_MetaDataDotNetType|dw_MetaDataAttributeType|MetaDataDotNetTypeId',
                FieldPrefix: 'DwMetaDataAttributeType',
                PropertyName: 'DwMetaDataAttributeType'
            },
        };
        this.ItemDetail.ItemId = 12;
        this.ItemDetail.ItemName = 'dw_MetaDataDotNetType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataEnvironmentOfRecordTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataEnvironmentOfRecordType.';
        // Attributes
        this.MetaDataEnvironmentOfRecordTypeId = this.i + 'MetaDataEnvironmentOfRecordTypeId';
        this.EnvironmentOfRecordType = this.i + 'EnvironmentOfRecordType';
        this.EnvironmentOfRecordDescription = this.i + 'EnvironmentOfRecordDescription';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataEnvironmentOfRecordType|dw_MetaDataItem|MetaDataEnvironmentOfRecordTypeId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 3774;
        this.ItemDetail.ItemName = 'dw_MetaDataEnvironmentOfRecordType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataEventMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataEvent.';
        // Attributes
        this.MetaDataEventId = this.i + 'MetaDataEventId';
        this.EventName = this.i + 'EventName';
        this.MainMetaDataItemId = this.i + 'MainMetaDataItemId';
        this.EventConfigJson = this.i + 'EventConfigJson';
        this.Relations = {
            /** Relation: Meta Data Item - Main Meta Data Item */
            DwMetaDataItemByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataEvent|MainMetaDataItemId',
                FieldPrefix: 'MainDwMetaDataItem',
                PropertyName: 'MainDwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 2460;
        this.ItemDetail.ItemName = 'dw_MetaDataEvent';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataGroupMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataGroup.';
        // Attributes
        this.MetaDataGroupId = this.i + 'MetaDataGroupId';
        this.GroupName = this.i + 'GroupName';
        this.IsSystemGroup = this.i + 'IsSystemGroup';
        this.UniqueId = this.i + 'UniqueId';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataGroup|dw_MetaDataItem|MetaDataGroupId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Security Group */
            DwMetaDataSecurityGroup: {
                RelationName: 'dw_MetaDataGroup|dw_MetaDataSecurityGroup|MetaDataGroupId',
                FieldPrefix: 'DwMetaDataSecurityGroup',
                PropertyName: 'DwMetaDataSecurityGroup'
            },
        };
        this.ItemDetail.ItemId = 2512;
        this.ItemDetail.ItemName = 'dw_MetaDataGroup';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataHistoryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataHistory.';
        // Attributes
        this.MetaDataHistoryId = this.i + 'MetaDataHistoryId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.KeyValue = this.i + 'KeyValue';
        this.MetaDataHistoryTypeId = this.i + 'MetaDataHistoryTypeId';
        this.RecordDescription = this.i + 'RecordDescription';
        this.ChangeSummary = this.i + 'ChangeSummary';
        this.AttributeChangeJSON = this.i + 'AttributeChangeJSON';
        this.ChangedByApplicationUserId = this.i + 'ChangedByApplicationUserId';
        this.ChangedByAuthenticatedUserId = this.i + 'ChangedByAuthenticatedUserId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ParentMetaDataItemId = this.i + 'ParentMetaDataItemId';
        this.ParentKeyValue = this.i + 'ParentKeyValue';
        this.MetaDataImportId = this.i + 'MetaDataImportId';
        this.Relations = {
            /** Relation: Meta Data History Type */
            DwMetaDataHistoryType: {
                RelationName: 'dw_MetaDataHistoryType|dw_MetaDataHistory|MetaDataHistoryTypeId',
                FieldPrefix: 'DwMetaDataHistoryType',
                PropertyName: 'DwMetaDataHistoryType'
            },
            /** Relation: Meta Data Import */
            DwMetaDataImport: {
                RelationName: 'dw_MetaDataImport|dw_MetaDataHistory|MetaDataImportId',
                FieldPrefix: 'DwMetaDataImport',
                PropertyName: 'DwMetaDataImport'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataHistory|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Meta Data Item - Parent Meta Data Item */
            DwMetaDataItemByParentMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataHistory|ParentMetaDataItemId',
                FieldPrefix: 'ParentDwMetaDataItem',
                PropertyName: 'ParentDwMetaDataItem'
            },
            /** Relation: User - Changed By Application User */
            DwUserByChangedByApplicationUserId: {
                RelationName: 'dw_User|dw_MetaDataHistory|ChangedByApplicationUserId',
                FieldPrefix: 'ChangedByApplicationDwUser',
                PropertyName: 'ChangedByApplicationDwUser'
            },
            /** Relation: User - Changed By Authenticated User */
            DwUserByChangedByAuthenticatedUserId: {
                RelationName: 'dw_User|dw_MetaDataHistory|ChangedByAuthenticatedUserId',
                FieldPrefix: 'ChangedByAuthenticatedDwUser',
                PropertyName: 'ChangedByAuthenticatedDwUser'
            },
            /** Relation: User - Created By */
            DwUserByCreatedBy: {
                RelationName: 'dw_User|dw_MetaDataHistory|CreatedBy',
                FieldPrefix: 'CreatedByDwUser',
                PropertyName: 'CreatedByDwUser'
            },
            /** Relation: Meta Data History Detail */
            DwMetaDataHistoryDetail: {
                RelationName: 'dw_MetaDataHistory|dw_MetaDataHistoryDetail|MetaDataHistoryId',
                FieldPrefix: 'DwMetaDataHistoryDetail',
                PropertyName: 'DwMetaDataHistoryDetail'
            },
        };
        this.ItemDetail.ItemId = 3765;
        this.ItemDetail.ItemName = 'dw_MetaDataHistory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataHistoryDetailMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataHistoryDetail.';
        // Attributes
        this.MetaDataHistoryDetailId = this.i + 'MetaDataHistoryDetailId';
        this.MetaDataHistoryId = this.i + 'MetaDataHistoryId';
        this.PreviousEntityJSON = this.i + 'PreviousEntityJSON';
        this.NewEntityJSON = this.i + 'NewEntityJSON';
        this.AttributeChangesJSON = this.i + 'AttributeChangesJSON';
        this.Relations = {
            /** Relation: Meta Data History */
            DwMetaDataHistory: {
                RelationName: 'dw_MetaDataHistory|dw_MetaDataHistoryDetail|MetaDataHistoryId',
                FieldPrefix: 'DwMetaDataHistory',
                PropertyName: 'DwMetaDataHistory'
            },
        };
        this.ItemDetail.ItemId = 3764;
        this.ItemDetail.ItemName = 'dw_MetaDataHistoryDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataHistoryTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataHistoryType.';
        // Attributes
        this.MetaDataHistoryTypeId = this.i + 'MetaDataHistoryTypeId';
        this.MetaDataHistoryType = this.i + 'MetaDataHistoryType';
        this.IconCss = this.i + 'IconCss';
        this.Relations = {
            /** Relation: Meta Data History */
            DwMetaDataHistory: {
                RelationName: 'dw_MetaDataHistoryType|dw_MetaDataHistory|MetaDataHistoryTypeId',
                FieldPrefix: 'DwMetaDataHistory',
                PropertyName: 'DwMetaDataHistory'
            },
        };
        this.ItemDetail.ItemId = 3763;
        this.ItemDetail.ItemName = 'dw_MetaDataHistoryType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataImportMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataImport.';
        // Attributes
        this.MetaDataImportId = this.i + 'MetaDataImportId';
        this.DesignSessionId = this.i + 'DesignSessionId';
        this.ImportRequestJSON = this.i + 'ImportRequestJSON';
        this.ImportResultJSON = this.i + 'ImportResultJSON';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.ImportDescription = this.i + 'ImportDescription';
        this.ImportResultDescription = this.i + 'ImportResultDescription';
        this.ImportStartDateTime = this.i + 'ImportStartDateTime';
        this.ImportCompletionDateTime = this.i + 'ImportCompletionDateTime';
        this.IsSuccess = this.i + 'IsSuccess';
        this.Relations = {
            /** Relation: User - Created By */
            DwUserByCreatedBy: {
                RelationName: 'dw_User|dw_MetaDataImport|CreatedBy',
                FieldPrefix: 'CreatedByDwUser',
                PropertyName: 'CreatedByDwUser'
            },
            /** Relation: Meta Data History */
            DwMetaDataHistory: {
                RelationName: 'dw_MetaDataImport|dw_MetaDataHistory|MetaDataImportId',
                FieldPrefix: 'DwMetaDataHistory',
                PropertyName: 'DwMetaDataHistory'
            },
            /** Relation: Meta Data Import Log */
            DwMetaDataImportLog: {
                RelationName: 'dw_MetaDataImport|dw_MetaDataImportLog|MetaDataImportId',
                FieldPrefix: 'DwMetaDataImportLog',
                PropertyName: 'DwMetaDataImportLog'
            },
        };
        this.ItemDetail.ItemId = 3771;
        this.ItemDetail.ItemName = 'dw_MetaDataImport';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataImportLogMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataImportLog.';
        // Attributes
        this.MetaDataImportLogId = this.i + 'MetaDataImportLogId';
        this.MetaDataImportId = this.i + 'MetaDataImportId';
        this.LogId = this.i + 'LogId';
        this.Relations = {
            /** Relation: Log */
            DwLog: {
                RelationName: 'dw_Log|dw_MetaDataImportLog|LogId',
                FieldPrefix: 'DwLog',
                PropertyName: 'DwLog'
            },
            /** Relation: Meta Data Import */
            DwMetaDataImport: {
                RelationName: 'dw_MetaDataImport|dw_MetaDataImportLog|MetaDataImportId',
                FieldPrefix: 'DwMetaDataImport',
                PropertyName: 'DwMetaDataImport'
            },
        };
        this.ItemDetail.ItemId = 3777;
        this.ItemDetail.ItemName = 'dw_MetaDataImportLog';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataItemMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItem.';
        // Attributes
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.MetaDataDatabaseId = this.i + 'MetaDataDatabaseId';
        this.SchemaName = this.i + 'SchemaName';
        this.ItemName = this.i + 'ItemName';
        this.Display = this.i + 'Display';
        this.MetaDataItemTypeId = this.i + 'MetaDataItemTypeId';
        this.MetaDataItemStatusId = this.i + 'MetaDataItemStatusId';
        this.GenerateClientCode = this.i + 'GenerateClientCode';
        this.Layer = this.i + 'Layer';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.IsView = this.i + 'IsView';
        this.UniqueItemName = this.i + 'UniqueItemName';
        this.MetaDataGroupId = this.i + 'MetaDataGroupId';
        this.MetaDataSystemId = this.i + 'MetaDataSystemId';
        this.UniqueId = this.i + 'UniqueId';
        this.MetaDataEnvironmentOfRecordTypeId = this.i + 'MetaDataEnvironmentOfRecordTypeId';
        this.EnableHistory = this.i + 'EnableHistory';
        this.Relations = {
            /** Relation: Meta Data Database */
            DwMetaDataDatabase: {
                RelationName: 'dw_MetaDataDatabase|dw_MetaDataItem|MetaDataDatabaseId',
                FieldPrefix: 'DwMetaDataDatabase',
                PropertyName: 'DwMetaDataDatabase'
            },
            /** Relation: Meta Data Environment Of Record Type */
            DwMetaDataEnvironmentOfRecordType: {
                RelationName: 'dw_MetaDataEnvironmentOfRecordType|dw_MetaDataItem|MetaDataEnvironmentOfRecordTypeId',
                FieldPrefix: 'DwMetaDataEnvironmentOfRecordType',
                PropertyName: 'DwMetaDataEnvironmentOfRecordType'
            },
            /** Relation: Meta Data Group */
            DwMetaDataGroup: {
                RelationName: 'dw_MetaDataGroup|dw_MetaDataItem|MetaDataGroupId',
                FieldPrefix: 'DwMetaDataGroup',
                PropertyName: 'DwMetaDataGroup'
            },
            /** Relation: Meta Data Item Status */
            DwMetaDataItemStatus: {
                RelationName: 'dw_MetaDataItemStatus|dw_MetaDataItem|MetaDataItemStatusId',
                FieldPrefix: 'DwMetaDataItemStatus',
                PropertyName: 'DwMetaDataItemStatus'
            },
            /** Relation: Meta Data Item Type */
            DwMetaDataItemType: {
                RelationName: 'dw_MetaDataItemType|dw_MetaDataItem|MetaDataItemTypeId',
                FieldPrefix: 'DwMetaDataItemType',
                PropertyName: 'DwMetaDataItemType'
            },
            /** Relation: Meta Data System */
            DwMetaDataSystem: {
                RelationName: 'dw_MetaDataSystem|dw_MetaDataItem|MetaDataSystemId',
                FieldPrefix: 'DwMetaDataSystem',
                PropertyName: 'DwMetaDataSystem'
            },
            /** Relation: Context Data Definition - Parent - Many */
            DwContextDataDefinitionByParentMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_ContextDataDefinition|ParentMetaDataItemId',
                FieldPrefix: 'ParentDwContextDataDefinition',
                PropertyName: 'ParentDwContextDataDefinition'
            },
            /** Relation: Context Data Definition - Main - Many */
            DwContextDataDefinitionByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_ContextDataDefinition|MainMetaDataItemId',
                FieldPrefix: 'MainDwContextDataDefinition',
                PropertyName: 'MainDwContextDataDefinition'
            },
            /** Relation: Data Import */
            DwDataImport: {
                RelationName: 'dw_MetaDataItem|dw_DataImport|MetaDataItemId',
                FieldPrefix: 'DwDataImport',
                PropertyName: 'DwDataImport'
            },
            /** Relation: Email Template - Main - Many */
            DwEmailTemplateByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_EmailTemplate|MainMetaDataItemId',
                FieldPrefix: 'MainDwEmailTemplate',
                PropertyName: 'MainDwEmailTemplate'
            },
            /** Relation: Feature Area Detail */
            DwFeatureAreaDetail: {
                RelationName: 'dw_MetaDataItem|dw_FeatureAreaDetail|MetaDataItemId',
                FieldPrefix: 'DwFeatureAreaDetail',
                PropertyName: 'DwFeatureAreaDetail'
            },
            /** Relation: Feature Area Detail Type */
            DwFeatureAreaDetailType: {
                RelationName: 'dw_MetaDataItem|dw_FeatureAreaDetailType|MetaDataItemId',
                FieldPrefix: 'DwFeatureAreaDetailType',
                PropertyName: 'DwFeatureAreaDetailType'
            },
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataAttribute|MetaDataItemId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Reference - Many */
            DwMetaDataAttributeByReferenceMetaDataItemId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataItem|ReferenceMetaDataItemId',
                FieldPrefix: 'ReferenceDwMetaDataAttribute',
                PropertyName: 'ReferenceDwMetaDataAttribute'
            },
            /** Relation: Meta Data Collection - Default - Many */
            DwMetaDataCollectionByDefaultMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataCollection|DefaultMetaDataItemId',
                FieldPrefix: 'DefaultDwMetaDataCollection',
                PropertyName: 'DefaultDwMetaDataCollection'
            },
            /** Relation: Meta Data Event - Main - Many */
            DwMetaDataEventByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataEvent|MainMetaDataItemId',
                FieldPrefix: 'MainDwMetaDataEvent',
                PropertyName: 'MainDwMetaDataEvent'
            },
            /** Relation: Meta Data History */
            DwMetaDataHistory: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataHistory|MetaDataItemId',
                FieldPrefix: 'DwMetaDataHistory',
                PropertyName: 'DwMetaDataHistory'
            },
            /** Relation: Meta Data History - Parent - Many */
            DwMetaDataHistoryByParentMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataHistory|ParentMetaDataItemId',
                FieldPrefix: 'ParentDwMetaDataHistory',
                PropertyName: 'ParentDwMetaDataHistory'
            },
            /** Relation: Relationships - Pk - Many */
            DwMetaDataItemRelationshipByPkMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataItemRelationship|PkMetaDataItemId',
                FieldPrefix: 'PkDwMetaDataItemRelationship',
                PropertyName: 'PkDwMetaDataItemRelationship'
            },
            /** Relation: Relationships - Fk - Many */
            DwMetaDataItemRelationshipByFkMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataItemRelationship|FkMetaDataItemId',
                FieldPrefix: 'FkDwMetaDataItemRelationship',
                PropertyName: 'FkDwMetaDataItemRelationship'
            },
            /** Relation: Meta Data Lookup */
            DwMetaDataLookup: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataLookup|MetaDataItemId',
                FieldPrefix: 'DwMetaDataLookup',
                PropertyName: 'DwMetaDataLookup'
            },
            /** Relation: Meta Data Query */
            DwMetaDataQuery: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataQuery|MetaDataItemId',
                FieldPrefix: 'DwMetaDataQuery',
                PropertyName: 'DwMetaDataQuery'
            },
            /** Relation: Security Group Item */
            DwMetaDataSecurityGroupItem: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataSecurityGroupItem|MetaDataItemId',
                FieldPrefix: 'DwMetaDataSecurityGroupItem',
                PropertyName: 'DwMetaDataSecurityGroupItem'
            },
            /** Relation: Meta Data Security Item Rule */
            DwMetaDataSecurityItemRule: {
                RelationName: 'dw_MetaDataItem|MetaDataSecurityItemRule|MetaDataItemId',
                FieldPrefix: 'DwMetaDataSecurityItemRule',
                PropertyName: 'DwMetaDataSecurityItemRule'
            },
            /** Relation: Route */
            DwRoute: {
                RelationName: 'dw_MetaDataItem|dw_Route|MetaDataItemId',
                FieldPrefix: 'DwRoute',
                PropertyName: 'DwRoute'
            },
            /** Relation: Rule Definition - Main - Many */
            DwRuleDefinitionByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_RuleDefinition|MainMetaDataItemId',
                FieldPrefix: 'MainDwRuleDefinition',
                PropertyName: 'MainDwRuleDefinition'
            },
            /** Relation: Ui Config */
            DwUiConfig: {
                RelationName: 'dw_MetaDataItem|dw_UiConfig|MetaDataItemId',
                FieldPrefix: 'DwUiConfig',
                PropertyName: 'DwUiConfig'
            },
        };
        this.ItemDetail.ItemId = 69;
        this.ItemDetail.ItemName = 'dw_MetaDataItem';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataItemRelationshipMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemRelationship.';
        // Attributes
        this.MetaDataItemRelationshipId = this.i + 'MetaDataItemRelationshipId';
        this.RelationshipName = this.i + 'RelationshipName';
        this.PkMetaDataItemId = this.i + 'PkMetaDataItemId';
        this.PkMetaDataAttributeId = this.i + 'PkMetaDataAttributeId';
        this.FkMetaDataItemId = this.i + 'FkMetaDataItemId';
        this.FkMetaDataAttributeId = this.i + 'FkMetaDataAttributeId';
        this.RelationshipTypeId = this.i + 'RelationshipTypeId';
        this.IsActive = this.i + 'IsActive';
        this.GenerateCode = this.i + 'GenerateCode';
        this.PkItemPropertyOverride = this.i + 'PkItemPropertyOverride';
        this.FkItemPropertyOverride = this.i + 'FkItemPropertyOverride';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.IsCustomRelationship = this.i + 'IsCustomRelationship';
        this.PhyiscalRelationshipName = this.i + 'PhyiscalRelationshipName';
        this.CascadeDelete = this.i + 'CascadeDelete';
        this.UniqueId = this.i + 'UniqueId';
        this.PkMetaDataAttribute2Id = this.i + 'PkMetaDataAttribute2Id';
        this.PkMetaDataAttribute3Id = this.i + 'PkMetaDataAttribute3Id';
        this.FkMetaDataAttribute2Id = this.i + 'FkMetaDataAttribute2Id';
        this.FkMetaDataAttribute3Id = this.i + 'FkMetaDataAttribute3Id';
        this.Relations = {
            /** Relation: Meta Data Attribute - Pk Meta Data Attribute */
            DwMetaDataAttributeByPkMetaDataAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataItemRelationship|PkMetaDataAttributeId',
                FieldPrefix: 'PkDwMetaDataAttribute',
                PropertyName: 'PkDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Fk Meta Data Attribute */
            DwMetaDataAttributeByFkMetaDataAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataItemRelationship|FkMetaDataAttributeId',
                FieldPrefix: 'FkDwMetaDataAttribute',
                PropertyName: 'FkDwMetaDataAttribute'
            },
            /** Relation: Meta Data Item - Pk Meta Data Item */
            DwMetaDataItemByPkMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataItemRelationship|PkMetaDataItemId',
                FieldPrefix: 'PkDwMetaDataItem',
                PropertyName: 'PkDwMetaDataItem'
            },
            /** Relation: Meta Data Item - Fk Meta Data Item */
            DwMetaDataItemByFkMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataItemRelationship|FkMetaDataItemId',
                FieldPrefix: 'FkDwMetaDataItem',
                PropertyName: 'FkDwMetaDataItem'
            },
            /** Relation: Meta Data Item Relationship Type */
            DwMetaDataItemRelationshipType: {
                RelationName: 'dw_MetaDataItemRelationshipType|dw_MetaDataItemRelationship|RelationshipTypeId',
                FieldPrefix: 'DwMetaDataItemRelationshipType',
                PropertyName: 'DwMetaDataItemRelationshipType'
            },
            /** Relation: Context Data Definition - Meta Data Relationship - Many */
            DwContextDataDefinitionByMetaDataRelationshipId: {
                RelationName: 'dw_MetaDataItemRelationship|dw_ContextDataDefinition|MetaDataRelationshipId',
                FieldPrefix: 'MetaDataRelationshipIdDwContextDataDefinition',
                PropertyName: 'MetaDataRelationshipIdDwContextDataDefinition'
            },
        };
        this.ItemDetail.ItemId = 28;
        this.ItemDetail.ItemName = 'dw_MetaDataItemRelationship';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataItemRelationshipTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemRelationshipType.';
        // Attributes
        this.RelationshipTypeId = this.i + 'RelationshipTypeId';
        this.RelationshipTypeName = this.i + 'RelationshipTypeName';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Relationships */
            DwMetaDataItemRelationship: {
                RelationName: 'dw_MetaDataItemRelationshipType|dw_MetaDataItemRelationship|RelationshipTypeId',
                FieldPrefix: 'DwMetaDataItemRelationship',
                PropertyName: 'DwMetaDataItemRelationship'
            },
        };
        this.ItemDetail.ItemId = 26;
        this.ItemDetail.ItemName = 'dw_MetaDataItemRelationshipType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataItemStatusMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemStatus.';
        // Attributes
        this.MetaDataItemStatusId = this.i + 'MetaDataItemStatusId';
        this.ItemStatus = this.i + 'ItemStatus';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItemStatus|dw_MetaDataItem|MetaDataItemStatusId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 14;
        this.ItemDetail.ItemName = 'dw_MetaDataItemStatus';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataItemTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemType.';
        // Attributes
        this.MetaDataItemTypeId = this.i + 'MetaDataItemTypeId';
        this.ItemTypeDisplay = this.i + 'ItemTypeDisplay';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItemType|dw_MetaDataItem|MetaDataItemTypeId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 16;
        this.ItemDetail.ItemName = 'dw_MetaDataItemType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataLookupMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataLookup.';
        // Attributes
        this.MetaDataLookupId = this.i + 'MetaDataLookupId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.LookupName = this.i + 'LookupName';
        this.IsDefault = this.i + 'IsDefault';
        this.MetaDataQueryId = this.i + 'MetaDataQueryId';
        this.DisplayTemplate = this.i + 'DisplayTemplate';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.AdditionalAttribute1Id = this.i + 'AdditionalAttribute1Id';
        this.AdditionalAttribute2Id = this.i + 'AdditionalAttribute2Id';
        this.AdditionalAttribute3Id = this.i + 'AdditionalAttribute3Id';
        this.AdditionalAttribute4Id = this.i + 'AdditionalAttribute4Id';
        this.AdditionalAttribute5Id = this.i + 'AdditionalAttribute5Id';
        this.HasTransitions = this.i + 'HasTransitions';
        this.TransitionReferenceAttribute1Id = this.i + 'TransitionReferenceAttribute1Id';
        this.TransitionReferenceAttribute2Id = this.i + 'TransitionReferenceAttribute2Id';
        this.UniqueId = this.i + 'UniqueId';
        this.LookupMeaning = this.i + 'LookupMeaning';
        this.KeyAttributeId = this.i + 'KeyAttributeId';
        this.CacheLookup = this.i + 'CacheLookup';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.GroupByAttributeId = this.i + 'GroupByAttributeId';
        this.GroupByTemplate = this.i + 'GroupByTemplate';
        this.IsLargeLookup = this.i + 'IsLargeLookup';
        this.LookupConfigJSON = this.i + 'LookupConfigJSON';
        this.Relations = {
            /** Relation: Meta Data Attribute - Additional Attribute 1 */
            DwMetaDataAttributeByAdditionalAttribute1Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute1Id',
                FieldPrefix: 'AdditionalAttribute1IdDwMetaDataAttribute',
                PropertyName: 'AdditionalAttribute1IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Additional Attribute 2 */
            DwMetaDataAttributeByAdditionalAttribute2Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute2Id',
                FieldPrefix: 'AdditionalAttribute2IdDwMetaDataAttribute',
                PropertyName: 'AdditionalAttribute2IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Additional Attribute 3 */
            DwMetaDataAttributeByAdditionalAttribute3Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute3Id',
                FieldPrefix: 'AdditionalAttribute3IdDwMetaDataAttribute',
                PropertyName: 'AdditionalAttribute3IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Additional Attribute 4 */
            DwMetaDataAttributeByAdditionalAttribute4Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute4Id',
                FieldPrefix: 'AdditionalAttribute4IdDwMetaDataAttribute',
                PropertyName: 'AdditionalAttribute4IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Transition Reference Attribute1 */
            DwMetaDataAttributeByTransitionReferenceAttribute1Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute1Id',
                FieldPrefix: 'TransitionReferenceAttribute1IdDwMetaDataAttribute',
                PropertyName: 'TransitionReferenceAttribute1IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Transition Reference Attribute2 */
            DwMetaDataAttributeByTransitionReferenceAttribute2Id: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute2Id',
                FieldPrefix: 'TransitionReferenceAttribute2IdDwMetaDataAttribute',
                PropertyName: 'TransitionReferenceAttribute2IdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Alternate Key Attribute */
            DwMetaDataAttributeByKeyAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|KeyAttributeId',
                FieldPrefix: 'KeyAttributeIdDwMetaDataAttribute',
                PropertyName: 'KeyAttributeIdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute - Group By Attribute */
            DwMetaDataAttributeByGroupByAttributeId: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookup|GroupByAttributeId',
                FieldPrefix: 'GroupByAttributeIdDwMetaDataAttribute',
                PropertyName: 'GroupByAttributeIdDwMetaDataAttribute'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataLookup|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Meta Data Query */
            DwMetaDataQuery: {
                RelationName: 'dw_MetaDataQuery|dw_MetaDataLookup|MetaDataQueryId',
                FieldPrefix: 'DwMetaDataQuery',
                PropertyName: 'DwMetaDataQuery'
            },
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataLookup|dw_MetaDataAttribute|MetaDataLookupId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Meta Data Lookup Param */
            DwMetaDataLookupParam: {
                RelationName: 'dw_MetaDataLookup|dw_MetaDataLookupParam|MetaDataLookupId',
                FieldPrefix: 'DwMetaDataLookupParam',
                PropertyName: 'DwMetaDataLookupParam'
            },
            /** Relation: Meta Data Lookup Transition */
            DwMetaDataLookupTransition: {
                RelationName: 'dw_MetaDataLookup|dw_MetaDataLookupTransition|MetaDataLookupId',
                FieldPrefix: 'DwMetaDataLookupTransition',
                PropertyName: 'DwMetaDataLookupTransition'
            },
        };
        this.ItemDetail.ItemId = 17;
        this.ItemDetail.ItemName = 'dw_MetaDataLookup';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataLookupParamMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataLookupParam.';
        // Attributes
        this.MetaDataLookupParamId = this.i + 'MetaDataLookupParamId';
        this.MetaDataLookupId = this.i + 'MetaDataLookupId';
        this.MetaDataAttributeId = this.i + 'MetaDataAttributeId';
        this.DefaultValue = this.i + 'DefaultValue';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.UseAttribute = this.i + 'UseAttribute';
        this.ParamNameOverride = this.i + 'ParamNameOverride';
        this.IsRequired = this.i + 'IsRequired';
        this.Relations = {
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataLookupParam|MetaDataAttributeId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Meta Data Lookup */
            DwMetaDataLookup: {
                RelationName: 'dw_MetaDataLookup|dw_MetaDataLookupParam|MetaDataLookupId',
                FieldPrefix: 'DwMetaDataLookup',
                PropertyName: 'DwMetaDataLookup'
            },
        };
        this.ItemDetail.ItemId = 18;
        this.ItemDetail.ItemName = 'dw_MetaDataLookupParam';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataLookupTransitionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataLookupTransition.';
        // Attributes
        this.MetaDataLookupTransitionId = this.i + 'MetaDataLookupTransitionId';
        this.MetaDataLookupId = this.i + 'MetaDataLookupId';
        this.TransitionFromValue = this.i + 'TransitionFromValue';
        this.TransitionToValue = this.i + 'TransitionToValue';
        this.CanTransitionPermission = this.i + 'CanTransitionPermission';
        this.TransitionReferenceValue1 = this.i + 'TransitionReferenceValue1';
        this.TransitionReferenceValue2 = this.i + 'TransitionReferenceValue2';
        this.IsDefault = this.i + 'IsDefault';
        this.AlternateActionDisplay = this.i + 'AlternateActionDisplay';
        this.TransitionFromValueDisplay = this.i + 'TransitionFromValueDisplay';
        this.TransitionToValueDisplay = this.i + 'TransitionToValueDisplay';
        this.UniqueId = this.i + 'UniqueId';
        this.Relations = {
            /** Relation: Meta Data Lookup */
            DwMetaDataLookup: {
                RelationName: 'dw_MetaDataLookup|dw_MetaDataLookupTransition|MetaDataLookupId',
                FieldPrefix: 'DwMetaDataLookup',
                PropertyName: 'DwMetaDataLookup'
            },
        };
        this.ItemDetail.ItemId = 370;
        this.ItemDetail.ItemName = 'dw_MetaDataLookupTransition';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataOperationMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataOperation.';
        // Attributes
        this.MetaDataOperationId = this.i + 'MetaDataOperationId';
        this.MetaDataSystemId = this.i + 'MetaDataSystemId';
        this.MetaDataOperationTypeId = this.i + 'MetaDataOperationTypeId';
        this.MetaDataCollectionId = this.i + 'MetaDataCollectionId';
        this.OperationDisplay = this.i + 'OperationDisplay';
        this.ApiConfigJSON = this.i + 'ApiConfigJSON';
        this.UniqueId = this.i + 'UniqueId';
        this.Relations = {
            /** Relation: Meta Data Collection */
            DwMetaDataCollection: {
                RelationName: 'dw_MetaDataCollection|dw_MetaDataOperation|MetaDataCollectionId',
                FieldPrefix: 'DwMetaDataCollection',
                PropertyName: 'DwMetaDataCollection'
            },
            /** Relation: Meta Data Operation Type */
            DwMetaDataOperationType: {
                RelationName: 'dw_MetaDataOperationType|dw_MetaDataOperation|MetaDataOperationTypeId',
                FieldPrefix: 'DwMetaDataOperationType',
                PropertyName: 'DwMetaDataOperationType'
            },
            /** Relation: Meta Data System */
            DwMetaDataSystem: {
                RelationName: 'dw_MetaDataSystem|dw_MetaDataOperation|MetaDataSystemId',
                FieldPrefix: 'DwMetaDataSystem',
                PropertyName: 'DwMetaDataSystem'
            },
        };
        this.ItemDetail.ItemId = 2734;
        this.ItemDetail.ItemName = 'dw_MetaDataOperation';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataOperationTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataOperationType.';
        // Attributes
        this.MetaDataOperationTypeId = this.i + 'MetaDataOperationTypeId';
        this.OperationTypeDisplay = this.i + 'OperationTypeDisplay';
        this.Relations = {
            /** Relation: Meta Data Operation */
            DwMetaDataOperation: {
                RelationName: 'dw_MetaDataOperationType|dw_MetaDataOperation|MetaDataOperationTypeId',
                FieldPrefix: 'DwMetaDataOperation',
                PropertyName: 'DwMetaDataOperation'
            },
        };
        this.ItemDetail.ItemId = 2732;
        this.ItemDetail.ItemName = 'dw_MetaDataOperationType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataQueryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataQuery.';
        // Attributes
        this.MetaDataQueryId = this.i + 'MetaDataQueryId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.QueryName = this.i + 'QueryName';
        this.QueryDesc = this.i + 'QueryDesc';
        this.Query = this.i + 'Query';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.QueryMeaning = this.i + 'QueryMeaning';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataQuery|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Context Data Definition */
            DwContextDataDefinition: {
                RelationName: 'dw_MetaDataQuery|dw_ContextDataDefinition|MetaDataQueryId',
                FieldPrefix: 'DwContextDataDefinition',
                PropertyName: 'DwContextDataDefinition'
            },
            /** Relation: Meta Data Lookup */
            DwMetaDataLookup: {
                RelationName: 'dw_MetaDataQuery|dw_MetaDataLookup|MetaDataQueryId',
                FieldPrefix: 'DwMetaDataLookup',
                PropertyName: 'DwMetaDataLookup'
            },
        };
        this.ItemDetail.ItemId = 19;
        this.ItemDetail.ItemName = 'dw_MetaDataQuery';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSecurityGroupMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityGroup.';
        // Attributes
        this.MetaDataSecurityGroupId = this.i + 'MetaDataSecurityGroupId';
        this.SecurityGroupName = this.i + 'SecurityGroupName';
        this.PermissionMeaning = this.i + 'PermissionMeaning';
        this.CanCreateAny = this.i + 'CanCreateAny';
        this.CanReadAny = this.i + 'CanReadAny';
        this.CanUpdateAny = this.i + 'CanUpdateAny';
        this.CanDeletedAny = this.i + 'CanDeletedAny';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.MetaDataGroupId = this.i + 'MetaDataGroupId';
        this.UniqueId = this.i + 'UniqueId';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.Relations = {
            /** Relation: Meta Data Group */
            DwMetaDataGroup: {
                RelationName: 'dw_MetaDataGroup|dw_MetaDataSecurityGroup|MetaDataGroupId',
                FieldPrefix: 'DwMetaDataGroup',
                PropertyName: 'DwMetaDataGroup'
            },
            /** Relation: Security Group Item */
            DwMetaDataSecurityGroupItem: {
                RelationName: 'dw_MetaDataSecurityGroup|dw_MetaDataSecurityGroupItem|MetaDataSecurityGroupId',
                FieldPrefix: 'DwMetaDataSecurityGroupItem',
                PropertyName: 'DwMetaDataSecurityGroupItem'
            },
        };
        this.ItemDetail.ItemId = 4;
        this.ItemDetail.ItemName = 'dw_MetaDataSecurityGroup';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSecurityGroupAttributeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityGroupAttribute.';
        // Attributes
        this.MetaDataSecurityGroupAttributeId = this.i + 'MetaDataSecurityGroupAttributeId';
        this.MetaDataSecurityGroupItemId = this.i + 'MetaDataSecurityGroupItemId';
        this.MetaDataAttributeId = this.i + 'MetaDataAttributeId';
        this.CanRead = this.i + 'CanRead';
        this.CanUpdate = this.i + 'CanUpdate';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.Relations = {
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataAttribute|dw_MetaDataSecurityGroupAttribute|MetaDataAttributeId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Security Group Item */
            DwMetaDataSecurityGroupItem: {
                RelationName: 'dw_MetaDataSecurityGroupItem|dw_MetaDataSecurityGroupAttribute|MetaDataSecurityGroupItemId',
                FieldPrefix: 'DwMetaDataSecurityGroupItem',
                PropertyName: 'DwMetaDataSecurityGroupItem'
            },
        };
        this.ItemDetail.ItemId = 88;
        this.ItemDetail.ItemName = 'dw_MetaDataSecurityGroupAttribute';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSecurityGroupItemMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityGroupItem.';
        // Attributes
        this.MetaDataSecurityGroupItemId = this.i + 'MetaDataSecurityGroupItemId';
        this.MetaDataSecurityGroupId = this.i + 'MetaDataSecurityGroupId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.CanCreate = this.i + 'CanCreate';
        this.CanRead = this.i + 'CanRead';
        this.CanUpdate = this.i + 'CanUpdate';
        this.CanDelete = this.i + 'CanDelete';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.UseFieldLevelSecurity = this.i + 'UseFieldLevelSecurity';
        this.FieldCanReadDefault = this.i + 'FieldCanReadDefault';
        this.FieldCanUpdateDefault = this.i + 'FieldCanUpdateDefault';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_MetaDataSecurityGroupItem|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Security Group */
            DwMetaDataSecurityGroup: {
                RelationName: 'dw_MetaDataSecurityGroup|dw_MetaDataSecurityGroupItem|MetaDataSecurityGroupId',
                FieldPrefix: 'DwMetaDataSecurityGroup',
                PropertyName: 'DwMetaDataSecurityGroup'
            },
            /** Relation: Security Group Attribute */
            DwMetaDataSecurityGroupAttribute: {
                RelationName: 'dw_MetaDataSecurityGroupItem|dw_MetaDataSecurityGroupAttribute|MetaDataSecurityGroupItemId',
                FieldPrefix: 'DwMetaDataSecurityGroupAttribute',
                PropertyName: 'DwMetaDataSecurityGroupAttribute'
            },
        };
        this.ItemDetail.ItemId = 85;
        this.ItemDetail.ItemName = 'dw_MetaDataSecurityGroupItem';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSecurityItemRuleMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityItemRule.';
        // Attributes
        this.MetaDataSecurityItemRuleId = this.i + 'MetaDataSecurityItemRuleId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.RuleName = this.i + 'RuleName';
        this.RuleOrder = this.i + 'RuleOrder';
        this.PermissionMeaning = this.i + 'PermissionMeaning';
        this.MetaDataQueryId = this.i + 'MetaDataQueryId';
        this.RuleFilterJSON = this.i + 'RuleFilterJSON';
        this.ClearPreviousRules = this.i + 'ClearPreviousRules';
        this.CanCreate = this.i + 'CanCreate';
        this.CanRead = this.i + 'CanRead';
        this.CanUpdate = this.i + 'CanUpdate';
        this.CanDelete = this.i + 'CanDelete';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|MetaDataSecurityItemRule|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 2486;
        this.ItemDetail.ItemName = 'dw_MetaDataSecurityItemRule';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSqlTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSqlType.';
        // Attributes
        this.MetaDataSqlTypeId = this.i + 'MetaDataSqlTypeId';
        this.MetaDataDatabaseSystemId = this.i + 'MetaDataDatabaseSystemId';
        this.SqlTypeName = this.i + 'SqlTypeName';
        this.HasLength = this.i + 'HasLength';
        this.MinValue = this.i + 'MinValue';
        this.MaxValue = this.i + 'MaxValue';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Meta Data Database System */
            DwMetaDataDatabaseSystem: {
                RelationName: 'dw_MetaDataDatabaseSystem|dw_MetaDataSqlType|MetaDataDatabaseSystemId',
                FieldPrefix: 'DwMetaDataDatabaseSystem',
                PropertyName: 'DwMetaDataDatabaseSystem'
            },
            /** Relation: Meta Data Attribute */
            DwMetaDataAttribute: {
                RelationName: 'dw_MetaDataSqlType|dw_MetaDataAttribute|MetaDataSqlTypeId',
                FieldPrefix: 'DwMetaDataAttribute',
                PropertyName: 'DwMetaDataAttribute'
            },
            /** Relation: Meta Data Attribute Type Sql Type Map */
            DwMetaDataAttributeTypeSqlTypeMap: {
                RelationName: 'dw_MetaDataSqlType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataSqlTypeId',
                FieldPrefix: 'DwMetaDataAttributeTypeSqlTypeMap',
                PropertyName: 'DwMetaDataAttributeTypeSqlTypeMap'
            },
        };
        this.ItemDetail.ItemId = 23;
        this.ItemDetail.ItemName = 'dw_MetaDataSqlType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSystemMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSystem.';
        // Attributes
        this.MetaDataSystemId = this.i + 'MetaDataSystemId';
        this.SystemDisplay = this.i + 'SystemDisplay';
        this.SystemMeaning = this.i + 'SystemMeaning';
        this.SystemCode = this.i + 'SystemCode';
        this.MetaDataSystemTypeId = this.i + 'MetaDataSystemTypeId';
        this.SystemConfigJSON = this.i + 'SystemConfigJSON';
        this.UniqueId = this.i + 'UniqueId';
        this.Relations = {
            /** Relation: Meta Data System Type */
            DwMetaDataSystemType: {
                RelationName: 'dw_MetaDataSystemType|dw_MetaDataSystem|MetaDataSystemTypeId',
                FieldPrefix: 'DwMetaDataSystemType',
                PropertyName: 'DwMetaDataSystemType'
            },
            /** Relation: Meta Data Collection */
            DwMetaDataCollection: {
                RelationName: 'dw_MetaDataSystem|dw_MetaDataCollection|MetaDataSystemId',
                FieldPrefix: 'DwMetaDataCollection',
                PropertyName: 'DwMetaDataCollection'
            },
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataSystem|dw_MetaDataItem|MetaDataSystemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Meta Data Operation */
            DwMetaDataOperation: {
                RelationName: 'dw_MetaDataSystem|dw_MetaDataOperation|MetaDataSystemId',
                FieldPrefix: 'DwMetaDataOperation',
                PropertyName: 'DwMetaDataOperation'
            },
        };
        this.ItemDetail.ItemId = 2735;
        this.ItemDetail.ItemName = 'dw_MetaDataSystem';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMetaDataSystemTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSystemType.';
        // Attributes
        this.MetaDataSystemTypeId = this.i + 'MetaDataSystemTypeId';
        this.SystemTypeDisplay = this.i + 'SystemTypeDisplay';
        this.SystemMeaning = this.i + 'SystemMeaning';
        this.IconClass = this.i + 'IconClass';
        this.FeaturesJSON = this.i + 'FeaturesJSON';
        this.Relations = {
            /** Relation: Meta Data System */
            DwMetaDataSystem: {
                RelationName: 'dw_MetaDataSystemType|dw_MetaDataSystem|MetaDataSystemTypeId',
                FieldPrefix: 'DwMetaDataSystem',
                PropertyName: 'DwMetaDataSystem'
            },
        };
        this.ItemDetail.ItemId = 2731;
        this.ItemDetail.ItemName = 'dw_MetaDataSystemType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwProcessDefinitionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ProcessDefinition.';
        // Attributes
        this.ProcessDefinitionId = this.i + 'ProcessDefinitionId';
        this.ProcessDisplay = this.i + 'ProcessDisplay';
        this.ProcessMeaning = this.i + 'ProcessMeaning';
        this.ProcessDescription = this.i + 'ProcessDescription';
        this.ProcessTypeId = this.i + 'ProcessTypeId';
        this.ConfigJSON = this.i + 'ConfigJSON';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Process Type */
            DwProcessType: {
                RelationName: 'dw_ProcessType|dw_ProcessDefinition|ProcessTypeId',
                FieldPrefix: 'DwProcessType',
                PropertyName: 'DwProcessType'
            },
            /** Relation: Process Schedule */
            DwProcessSchedule: {
                RelationName: 'dw_ProcessDefinition|dw_ProcessSchedule|ProcessDefinitionId',
                FieldPrefix: 'DwProcessSchedule',
                PropertyName: 'DwProcessSchedule'
            },
        };
        this.ItemDetail.ItemId = 3748;
        this.ItemDetail.ItemName = 'dw_ProcessDefinition';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwProcessScheduleMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ProcessSchedule.';
        // Attributes
        this.ProcessScheduleId = this.i + 'ProcessScheduleId';
        this.ProcessDefinitionId = this.i + 'ProcessDefinitionId';
        this.ScheduleDescription = this.i + 'ScheduleDescription';
        this.ScheduleJSON = this.i + 'ScheduleJSON';
        this.ConfigJSON = this.i + 'ConfigJSON';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Process Definition */
            DwProcessDefinition: {
                RelationName: 'dw_ProcessDefinition|dw_ProcessSchedule|ProcessDefinitionId',
                FieldPrefix: 'DwProcessDefinition',
                PropertyName: 'DwProcessDefinition'
            },
            /** Relation: Process Schedule History */
            DwProcessScheduleHistory: {
                RelationName: 'dw_ProcessSchedule|dw_ProcessScheduleHistory|ProcessScheduleId',
                FieldPrefix: 'DwProcessScheduleHistory',
                PropertyName: 'DwProcessScheduleHistory'
            },
            /** Relation: Process Schedule Summary */
            DwProcessScheduleSummary: {
                RelationName: 'dw_ProcessSchedule|dw_ProcessScheduleSummary|ProcessScheduleId',
                FieldPrefix: 'DwProcessScheduleSummary',
                PropertyName: 'DwProcessScheduleSummary'
            },
        };
        this.ItemDetail.ItemId = 3744;
        this.ItemDetail.ItemName = 'dw_ProcessSchedule';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwProcessScheduleHistoryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ProcessScheduleHistory.';
        // Attributes
        this.ProcessScheduleHistoryId = this.i + 'ProcessScheduleHistoryId';
        this.ProcessScheduleId = this.i + 'ProcessScheduleId';
        this.StartDateTime = this.i + 'StartDateTime';
        this.EndDateTime = this.i + 'EndDateTime';
        this.Success = this.i + 'Success';
        this.ErrorLogId = this.i + 'ErrorLogId';
        this.ProcessResultJSON = this.i + 'ProcessResultJSON';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Log - Error Log */
            DwLogByErrorLogId: {
                RelationName: 'dw_Log|dw_ProcessScheduleHistory|ErrorLogId',
                FieldPrefix: 'ErrorDwLog',
                PropertyName: 'ErrorDwLog'
            },
            /** Relation: Process Schedule */
            DwProcessSchedule: {
                RelationName: 'dw_ProcessSchedule|dw_ProcessScheduleHistory|ProcessScheduleId',
                FieldPrefix: 'DwProcessSchedule',
                PropertyName: 'DwProcessSchedule'
            },
        };
        this.ItemDetail.ItemId = 3745;
        this.ItemDetail.ItemName = 'dw_ProcessScheduleHistory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwProcessSchedulerServiceHistoryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ProcessSchedulerServiceHistory.';
        // Attributes
        this.ProcessSchedulerServiceHistoryId = this.i + 'ProcessSchedulerServiceHistoryId';
        this.StartedDateTime = this.i + 'StartedDateTime';
        this.LastHeartbeatDateTime = this.i + 'LastHeartbeatDateTime';
        this.StoppedDateTime = this.i + 'StoppedDateTime';
        this.LastStatusMessage = this.i + 'LastStatusMessage';
        this.IsCurrent = this.i + 'IsCurrent';
        this.LastLogId = this.i + 'LastLogId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.MachineName = this.i + 'MachineName';
        this.Relations = {};
        this.ItemDetail.ItemId = 4089;
        this.ItemDetail.ItemName = 'dw_ProcessSchedulerServiceHistory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwProcessScheduleSummaryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ProcessScheduleSummary.';
        // Attributes
        this.ProcessScheduleSummaryId = this.i + 'ProcessScheduleSummaryId';
        this.ProcessScheduleId = this.i + 'ProcessScheduleId';
        this.IsRunning = this.i + 'IsRunning';
        this.LastRanDateTime = this.i + 'LastRanDateTime';
        this.NextScheduleDateTime = this.i + 'NextScheduleDateTime';
        this.LastSuccessfulRunDateTime = this.i + 'LastSuccessfulRunDateTime';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Process Schedule */
            DwProcessSchedule: {
                RelationName: 'dw_ProcessSchedule|dw_ProcessScheduleSummary|ProcessScheduleId',
                FieldPrefix: 'DwProcessSchedule',
                PropertyName: 'DwProcessSchedule'
            },
        };
        this.ItemDetail.ItemId = 3746;
        this.ItemDetail.ItemName = 'dw_ProcessScheduleSummary';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwProcessTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_ProcessType.';
        // Attributes
        this.ProcessTypeId = this.i + 'ProcessTypeId';
        this.ProcessType = this.i + 'ProcessType';
        this.Relations = {
            /** Relation: Process Definition */
            DwProcessDefinition: {
                RelationName: 'dw_ProcessType|dw_ProcessDefinition|ProcessTypeId',
                FieldPrefix: 'DwProcessDefinition',
                PropertyName: 'DwProcessDefinition'
            },
        };
        this.ItemDetail.ItemId = 3747;
        this.ItemDetail.ItemName = 'dw_ProcessType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwRoleMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_Role.';
        // Attributes
        this.RoleId = this.i + 'RoleId';
        this.ApplicationId = this.i + 'ApplicationId';
        this.RoleDisplay = this.i + 'RoleDisplay';
        this.RoleMeaning = this.i + 'RoleMeaning';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.Relations = {
            /** Relation: App Permission Role */
            DwAppPermissionRole: {
                RelationName: 'dw_Role|dw_AppPermissionRole|RoleId',
                FieldPrefix: 'DwAppPermissionRole',
                PropertyName: 'DwAppPermissionRole'
            },
            /** Relation: User Role */
            DwUserRole: {
                RelationName: 'dw_Role|dw_UserRole|RoleId',
                FieldPrefix: 'DwUserRole',
                PropertyName: 'DwUserRole'
            },
        };
        this.ItemDetail.ItemId = 65;
        this.ItemDetail.ItemName = 'dw_Role';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwRouteMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_Route.';
        // Attributes
        this.RouteId = this.i + 'RouteId';
        this.ParentRouteId = this.i + 'ParentRouteId';
        this.RouteTypeId = this.i + 'RouteTypeId';
        this.RouteOrder = this.i + 'RouteOrder';
        this.Display = this.i + 'Display';
        this.Path = this.i + 'Path';
        this.RouteConfigJSON = this.i + 'RouteConfigJSON';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.RequireAuthentication = this.i + 'RequireAuthentication';
        this.CanAccessPermissionMeaning = this.i + 'CanAccessPermissionMeaning';
        this.ShowInMenu = this.i + 'ShowInMenu';
        this.IconCssClass = this.i + 'IconCssClass';
        this.ExcludeFromMainMenu = this.i + 'ExcludeFromMainMenu';
        this.RouteCategoryId = this.i + 'RouteCategoryId';
        this.RouteReferenceKey = this.i + 'RouteReferenceKey';
        this.HighlightOnExactMatch = this.i + 'HighlightOnExactMatch';
        this.UniqueId = this.i + 'UniqueId';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_Route|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Route - Parent Route - One */
            DwRouteByParentRouteId: {
                RelationName: 'dw_Route|dw_Route|ParentRouteId',
                FieldPrefix: 'ParentDwRoute',
                PropertyName: 'ParentDwRoute'
            },
            /** Relation: Route Category */
            DwRouteCategory: {
                RelationName: 'dw_RouteCategory|dw_Route|RouteCategoryId',
                FieldPrefix: 'DwRouteCategory',
                PropertyName: 'DwRouteCategory'
            },
            /** Relation: Route Type */
            DwRouteType: {
                RelationName: 'dw_RouteType|dw_Route|RouteTypeId',
                FieldPrefix: 'DwRouteType',
                PropertyName: 'DwRouteType'
            },
        };
        this.ItemDetail.ItemId = 2505;
        this.ItemDetail.ItemName = 'dw_Route';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwRouteCategoryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_RouteCategory.';
        // Attributes
        this.RouteCategoryId = this.i + 'RouteCategoryId';
        this.CategoryDisplay = this.i + 'CategoryDisplay';
        this.CategoryMeaning = this.i + 'CategoryMeaning';
        this.CategoryOrder = this.i + 'CategoryOrder';
        this.Relations = {
            /** Relation: Route */
            DwRoute: {
                RelationName: 'dw_RouteCategory|dw_Route|RouteCategoryId',
                FieldPrefix: 'DwRoute',
                PropertyName: 'DwRoute'
            },
        };
        this.ItemDetail.ItemId = 2506;
        this.ItemDetail.ItemName = 'dw_RouteCategory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwRouteTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_RouteType.';
        // Attributes
        this.RouteTypeId = this.i + 'RouteTypeId';
        this.RouteTypeDisplay = this.i + 'RouteTypeDisplay';
        this.RouteTypeOrder = this.i + 'RouteTypeOrder';
        this.Relations = {
            /** Relation: Route */
            DwRoute: {
                RelationName: 'dw_RouteType|dw_Route|RouteTypeId',
                FieldPrefix: 'DwRoute',
                PropertyName: 'DwRoute'
            },
        };
        this.ItemDetail.ItemId = 2504;
        this.ItemDetail.ItemName = 'dw_RouteType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwRuleDefinitionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_RuleDefinition.';
        // Attributes
        this.RuleDefinitionId = this.i + 'RuleDefinitionId';
        this.RuleKey = this.i + 'RuleKey';
        this.RuleJson = this.i + 'RuleJson';
        this.MainMetaDataItemId = this.i + 'MainMetaDataItemId';
        this.UniqueId = this.i + 'UniqueId';
        this.RuleDisplay = this.i + 'RuleDisplay';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.Relations = {
            /** Relation: Meta Data Item - Main Meta Data Item */
            DwMetaDataItemByMainMetaDataItemId: {
                RelationName: 'dw_MetaDataItem|dw_RuleDefinition|MainMetaDataItemId',
                FieldPrefix: 'MainDwMetaDataItem',
                PropertyName: 'MainDwMetaDataItem'
            },
        };
        this.ItemDetail.ItemId = 381;
        this.ItemDetail.ItemName = 'dw_RuleDefinition';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwSecurityAuditMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_SecurityAudit.';
        // Attributes
        this.SecurityAuditId = this.i + 'SecurityAuditId';
        this.UserId = this.i + 'UserId';
        this.SecurityAuditTypeId = this.i + 'SecurityAuditTypeId';
        this.TimeStamp = this.i + 'TimeStamp';
        this.AuditDetailJSON = this.i + 'AuditDetailJSON';
        this.UserName = this.i + 'UserName';
        this.AuditMesage = this.i + 'AuditMesage';
        this.IPAddress = this.i + 'IPAddress';
        this.Relations = {
            /** Relation: Security Audit Type */
            DwSecurityAuditType: {
                RelationName: 'dw_SecurityAuditType|dw_SecurityAudit|SecurityAuditTypeId',
                FieldPrefix: 'DwSecurityAuditType',
                PropertyName: 'DwSecurityAuditType'
            },
            /** Relation: User */
            DwUser: {
                RelationName: 'dw_User|dw_SecurityAudit|UserId',
                FieldPrefix: 'DwUser',
                PropertyName: 'DwUser'
            },
        };
        this.ItemDetail.ItemId = 3743;
        this.ItemDetail.ItemName = 'dw_SecurityAudit';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwSecurityAuditTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_SecurityAuditType.';
        // Attributes
        this.SecurityAuditTypeId = this.i + 'SecurityAuditTypeId';
        this.SecurityAuditType = this.i + 'SecurityAuditType';
        this.IsFailure = this.i + 'IsFailure';
        this.Relations = {
            /** Relation: Security Audit */
            DwSecurityAudit: {
                RelationName: 'dw_SecurityAuditType|dw_SecurityAudit|SecurityAuditTypeId',
                FieldPrefix: 'DwSecurityAudit',
                PropertyName: 'DwSecurityAudit'
            },
        };
        this.ItemDetail.ItemId = 3742;
        this.ItemDetail.ItemName = 'dw_SecurityAuditType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwSecurityEmulationHistoryMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_SecurityEmulationHistory.';
        // Attributes
        this.SecurityEmulationHistoryId = this.i + 'SecurityEmulationHistoryId';
        this.AuthenticatedUserId = this.i + 'AuthenticatedUserId';
        this.EmulationUserId = this.i + 'EmulationUserId';
        this.EmulationStartDateTime = this.i + 'EmulationStartDateTime';
        this.EmulationEndDateTime = this.i + 'EmulationEndDateTime';
        this.Relations = {
            /** Relation: User - Authenticated User */
            DwUserByAuthenticatedUserId: {
                RelationName: 'dw_User|dw_SecurityEmulationHistory|AuthenticatedUserId',
                FieldPrefix: 'AuthenticatedDwUser',
                PropertyName: 'AuthenticatedDwUser'
            },
            /** Relation: User - Emulation User */
            DwUserByEmulationUserId: {
                RelationName: 'dw_User|dw_SecurityEmulationHistory|EmulationUserId',
                FieldPrefix: 'EmulationDwUser',
                PropertyName: 'EmulationDwUser'
            },
        };
        this.ItemDetail.ItemId = 3800;
        this.ItemDetail.ItemName = 'dw_SecurityEmulationHistory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwSecurityFactorTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_SecurityFactorType.';
        // Attributes
        this.SecurityFactorTypeId = this.i + 'SecurityFactorTypeId';
        this.SecurityFactorTypeDisplay = this.i + 'SecurityFactorTypeDisplay';
        this.SecurityFactorTypeMeaning = this.i + 'SecurityFactorTypeMeaning';
        this.Relations = {
            /** Relation: User - Two Factor Authentication Type - Many */
            DwUserByTwoFactorAuthenticationTypeId: {
                RelationName: 'dw_SecurityFactorType|dw_User|TwoFactorAuthenticationTypeId',
                FieldPrefix: 'TwoFactorAuthenticationTypeIdDwUser',
                PropertyName: 'TwoFactorAuthenticationTypeIdDwUser'
            },
        };
        this.ItemDetail.ItemId = 3741;
        this.ItemDetail.ItemName = 'dw_SecurityFactorType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwSecurityPersonalAccessTokenMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_SecurityPersonalAccessToken.';
        // Attributes
        this.SecurityPersonalAccessTokenId = this.i + 'SecurityPersonalAccessTokenId';
        this.Name = this.i + 'Name';
        this.ExpirationDateTime = this.i + 'ExpirationDateTime';
        this.LinkedUserId = this.i + 'LinkedUserId';
        this.IsActive = this.i + 'IsActive';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.AccessToken = this.i + 'AccessToken';
        this.Relations = {
            /** Relation: User - Linked User */
            DwUserByLinkedUserId: {
                RelationName: 'dw_User|SecurityPersonalAccessToken|LinkedUserId',
                FieldPrefix: 'LinkedDwUser',
                PropertyName: 'LinkedDwUser'
            },
        };
        this.ItemDetail.ItemId = 2487;
        this.ItemDetail.ItemName = 'dw_SecurityPersonalAccessToken';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwSecurityTokenMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_SecurityToken.';
        // Attributes
        this.SecurityTokenId = this.i + 'SecurityTokenId';
        this.UserName = this.i + 'UserName';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ExpirationDateTime = this.i + 'ExpirationDateTime';
        this.LastUsedDateTime = this.i + 'LastUsedDateTime';
        this.UserIPAddress = this.i + 'UserIPAddress';
        this.CreatedBy = this.i + 'CreatedBy';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Token = this.i + 'Token';
        this.Relations = {};
        this.ItemDetail.ItemId = 35;
        this.ItemDetail.ItemName = 'dw_SecurityToken';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwTermsOfServiceMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_TermsOfService.';
        // Attributes
        this.TermsOfServiceId = this.i + 'TermsOfServiceId';
        this.TermsOfServiceText = this.i + 'TermsOfServiceText';
        this.TermsOfServiceLinkUrl = this.i + 'TermsOfServiceLinkUrl';
        this.TermsOfServiceMediaId = this.i + 'TermsOfServiceMediaId';
        this.EffectiveStartDate = this.i + 'EffectiveStartDate';
        this.EffectiveEndDate = this.i + 'EffectiveEndDate';
        this.TermsUpdatedDate = this.i + 'TermsUpdatedDate';
        this.Relations = {
            /** Relation: Terms Of Service User */
            DwTermsOfServiceUser: {
                RelationName: 'dw_TermsOfService|dw_TermsOfServiceUser|TermsOfServiceId',
                FieldPrefix: 'DwTermsOfServiceUser',
                PropertyName: 'DwTermsOfServiceUser'
            },
        };
        this.ItemDetail.ItemId = 4087;
        this.ItemDetail.ItemName = 'dw_TermsOfService';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwTermsOfServiceUserMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_TermsOfServiceUser.';
        // Attributes
        this.TermsOfServiceUserId = this.i + 'TermsOfServiceUserId';
        this.TermsOfServiceId = this.i + 'TermsOfServiceId';
        this.UserId = this.i + 'UserId';
        this.AcceptedDateTime = this.i + 'AcceptedDateTime';
        this.Relations = {
            /** Relation: Terms Of Service */
            DwTermsOfService: {
                RelationName: 'dw_TermsOfService|dw_TermsOfServiceUser|TermsOfServiceId',
                FieldPrefix: 'DwTermsOfService',
                PropertyName: 'DwTermsOfService'
            },
            /** Relation: User */
            DwUser: {
                RelationName: 'dw_User|dw_TermsOfServiceUser|UserId',
                FieldPrefix: 'DwUser',
                PropertyName: 'DwUser'
            },
        };
        this.ItemDetail.ItemId = 4088;
        this.ItemDetail.ItemName = 'dw_TermsOfServiceUser';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUiConfigMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_UiConfig.';
        // Attributes
        this.UiConfigId = this.i + 'UiConfigId';
        this.ConfigKey = this.i + 'ConfigKey';
        this.UiConfigTypeId = this.i + 'UiConfigTypeId';
        this.ConfigJson = this.i + 'ConfigJson';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.UniqueId = this.i + 'UniqueId';
        this.IsBuiltIn = this.i + 'IsBuiltIn';
        this.ConfigDisplay = this.i + 'ConfigDisplay';
        this.Relations = {
            /** Relation: Meta Data Item */
            DwMetaDataItem: {
                RelationName: 'dw_MetaDataItem|dw_UiConfig|MetaDataItemId',
                FieldPrefix: 'DwMetaDataItem',
                PropertyName: 'DwMetaDataItem'
            },
            /** Relation: Ui Config Type */
            DwUiConfigType: {
                RelationName: 'dw_UiConfigType|dw_UiConfig|UiConfigTypeId',
                FieldPrefix: 'DwUiConfigType',
                PropertyName: 'DwUiConfigType'
            },
        };
        this.ItemDetail.ItemId = 168;
        this.ItemDetail.ItemName = 'dw_UiConfig';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUiConfigTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_UiConfigType.';
        // Attributes
        this.UiConfigTypeId = this.i + 'UiConfigTypeId';
        this.ConfigTypeDisplay = this.i + 'ConfigTypeDisplay';
        this.Relations = {
            /** Relation: Ui Config */
            DwUiConfig: {
                RelationName: 'dw_UiConfigType|dw_UiConfig|UiConfigTypeId',
                FieldPrefix: 'DwUiConfig',
                PropertyName: 'DwUiConfig'
            },
        };
        this.ItemDetail.ItemId = 170;
        this.ItemDetail.ItemName = 'dw_UiConfigType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUserMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_User.';
        // Attributes
        this.UserId = this.i + 'UserId';
        this.UserName = this.i + 'UserName';
        this.Email = this.i + 'Email';
        this.LastLoginDateTime = this.i + 'LastLoginDateTime';
        this.ForcePasswordChange = this.i + 'ForcePasswordChange';
        this.FirstName = this.i + 'FirstName';
        this.LastName = this.i + 'LastName';
        this.OrganizationId = this.i + 'OrganizationId';
        this.UserKey = this.i + 'UserKey';
        this.PartyReferenceId = this.i + 'PartyReferenceId';
        this.UserPictureMediaId = this.i + 'UserPictureMediaId';
        this.UserBackgroundMediaId = this.i + 'UserBackgroundMediaId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.AlternateName = this.i + 'AlternateName';
        this.IsWachterUser = this.i + 'IsWachterUser';
        this.TrustUserId = this.i + 'TrustUserId';
        this.IsTwoFactorAuthenticationEnabled = this.i + 'IsTwoFactorAuthenticationEnabled';
        this.TwoFactorAuthenticationTypeId = this.i + 'TwoFactorAuthenticationTypeId';
        this.IsEmailVerified = this.i + 'IsEmailVerified';
        this.MobilePhone = this.i + 'MobilePhone';
        this.IsActive = this.i + 'IsActive';
        this.LastPasswordChangeDateTime = this.i + 'LastPasswordChangeDateTime';
        this.UserTypeId = this.i + 'UserTypeId';
        this.Password = this.i + 'Password';
        this.Relations = {
            /** Relation: Security Factor Type - Two Factor Authentication Type */
            DwSecurityFactorTypeByTwoFactorAuthenticationTypeId: {
                RelationName: 'dw_SecurityFactorType|dw_User|TwoFactorAuthenticationTypeId',
                FieldPrefix: 'TwoFactorAuthenticationTypeIdDwSecurityFactorType',
                PropertyName: 'TwoFactorAuthenticationTypeIdDwSecurityFactorType'
            },
            /** Relation: User Type */
            DwUserType: {
                RelationName: 'dw_UserType|dw_User|UserTypeId',
                FieldPrefix: 'DwUserType',
                PropertyName: 'DwUserType'
            },
            /** Relation: Meta Data History - Changed By Application - Many */
            DwMetaDataHistoryByChangedByApplicationUserId: {
                RelationName: 'dw_User|dw_MetaDataHistory|ChangedByApplicationUserId',
                FieldPrefix: 'ChangedByApplicationDwMetaDataHistory',
                PropertyName: 'ChangedByApplicationDwMetaDataHistory'
            },
            /** Relation: Meta Data History - Changed By Authenticated - Many */
            DwMetaDataHistoryByChangedByAuthenticatedUserId: {
                RelationName: 'dw_User|dw_MetaDataHistory|ChangedByAuthenticatedUserId',
                FieldPrefix: 'ChangedByAuthenticatedDwMetaDataHistory',
                PropertyName: 'ChangedByAuthenticatedDwMetaDataHistory'
            },
            /** Relation: Meta Data History - Created By - Many */
            DwMetaDataHistoryByCreatedBy: {
                RelationName: 'dw_User|dw_MetaDataHistory|CreatedBy',
                FieldPrefix: 'CreatedByDwMetaDataHistory',
                PropertyName: 'CreatedByDwMetaDataHistory'
            },
            /** Relation: Meta Data Import - Created By - Many */
            DwMetaDataImportByCreatedBy: {
                RelationName: 'dw_User|dw_MetaDataImport|CreatedBy',
                FieldPrefix: 'CreatedByDwMetaDataImport',
                PropertyName: 'CreatedByDwMetaDataImport'
            },
            /** Relation: Security Audit */
            DwSecurityAudit: {
                RelationName: 'dw_User|dw_SecurityAudit|UserId',
                FieldPrefix: 'DwSecurityAudit',
                PropertyName: 'DwSecurityAudit'
            },
            /** Relation: Security Emulation History - Authenticated - Many */
            DwSecurityEmulationHistoryByAuthenticatedUserId: {
                RelationName: 'dw_User|dw_SecurityEmulationHistory|AuthenticatedUserId',
                FieldPrefix: 'AuthenticatedDwSecurityEmulationHistory',
                PropertyName: 'AuthenticatedDwSecurityEmulationHistory'
            },
            /** Relation: Security Emulation History - Emulation - Many */
            DwSecurityEmulationHistoryByEmulationUserId: {
                RelationName: 'dw_User|dw_SecurityEmulationHistory|EmulationUserId',
                FieldPrefix: 'EmulationDwSecurityEmulationHistory',
                PropertyName: 'EmulationDwSecurityEmulationHistory'
            },
            /** Relation: Security Personal Access Token - Linked - Many */
            DwSecurityPersonalAccessTokenByLinkedUserId: {
                RelationName: 'dw_User|SecurityPersonalAccessToken|LinkedUserId',
                FieldPrefix: 'LinkedDwSecurityPersonalAccessToken',
                PropertyName: 'LinkedDwSecurityPersonalAccessToken'
            },
            /** Relation: Terms Of Service User */
            DwTermsOfServiceUser: {
                RelationName: 'dw_User|dw_TermsOfServiceUser|UserId',
                FieldPrefix: 'DwTermsOfServiceUser',
                PropertyName: 'DwTermsOfServiceUser'
            },
            /** Relation: User Communucation Preference */
            DwUserCommunucationPreference: {
                RelationName: 'dw_User|dw_UserCommunucationPreference|UserId',
                FieldPrefix: 'DwUserCommunucationPreference',
                PropertyName: 'DwUserCommunucationPreference'
            },
            /** Relation: User Role */
            DwUserRole: {
                RelationName: 'dw_User|dw_UserRole|UserId',
                FieldPrefix: 'DwUserRole',
                PropertyName: 'DwUserRole'
            },
        };
        this.ItemDetail.ItemId = 81;
        this.ItemDetail.ItemName = 'dw_User';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUserCommunicationPreferenceDetailMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_UserCommunicationPreferenceDetail.';
        // Attributes
        this.UserCommunicationPreferenceDetailId = this.i + 'UserCommunicationPreferenceDetailId';
        this.UserCommunicationPreferenceId = this.i + 'UserCommunicationPreferenceId';
        this.CommunicationGroupId = this.i + 'CommunicationGroupId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: User Communucation Preference */
            DwUserCommunucationPreference: {
                RelationName: 'dw_UserCommunucationPreference|dw_UserCommunicationPreferenceDetail|UserCommunicationPreferenceId',
                FieldPrefix: 'DwUserCommunucationPreference',
                PropertyName: 'DwUserCommunucationPreference'
            },
        };
        this.ItemDetail.ItemId = 164;
        this.ItemDetail.ItemName = 'dw_UserCommunicationPreferenceDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUserCommunucationPreferenceMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_UserCommunucationPreference.';
        // Attributes
        this.UserCommunicationPreferenceId = this.i + 'UserCommunicationPreferenceId';
        this.UserId = this.i + 'UserId';
        this.OptOutToAll = this.i + 'OptOutToAll';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: User */
            DwUser: {
                RelationName: 'dw_User|dw_UserCommunucationPreference|UserId',
                FieldPrefix: 'DwUser',
                PropertyName: 'DwUser'
            },
            /** Relation: User Communication Preference Detail */
            DwUserCommunicationPreferenceDetail: {
                RelationName: 'dw_UserCommunucationPreference|dw_UserCommunicationPreferenceDetail|UserCommunicationPreferenceId',
                FieldPrefix: 'DwUserCommunicationPreferenceDetail',
                PropertyName: 'DwUserCommunicationPreferenceDetail'
            },
        };
        this.ItemDetail.ItemId = 177;
        this.ItemDetail.ItemName = 'dw_UserCommunucationPreference';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUserRoleMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_UserRole.';
        // Attributes
        this.UserRoleId = this.i + 'UserRoleId';
        this.UserId = this.i + 'UserId';
        this.RoleId = this.i + 'RoleId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Role */
            DwRole: {
                RelationName: 'dw_Role|dw_UserRole|RoleId',
                FieldPrefix: 'DwRole',
                PropertyName: 'DwRole'
            },
            /** Relation: User */
            DwUser: {
                RelationName: 'dw_User|dw_UserRole|UserId',
                FieldPrefix: 'DwUser',
                PropertyName: 'DwUser'
            },
        };
        this.ItemDetail.ItemId = 70;
        this.ItemDetail.ItemName = 'dw_UserRole';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwUserTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_UserType.';
        // Attributes
        this.UserTypeId = this.i + 'UserTypeId';
        this.UserTypeDisplay = this.i + 'UserTypeDisplay';
        this.UserTypeDescription = this.i + 'UserTypeDescription';
        this.UserTypeClasses = this.i + 'UserTypeClasses';
        this.ShowOnRegistration = this.i + 'ShowOnRegistration';
        this.UserTypeOrder = this.i + 'UserTypeOrder';
        this.Relations = {
            /** Relation: User */
            DwUser: {
                RelationName: 'dw_UserType|dw_User|UserTypeId',
                FieldPrefix: 'DwUser',
                PropertyName: 'DwUser'
            },
        };
        this.ItemDetail.ItemId = 3805;
        this.ItemDetail.ItemName = 'dw_UserType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwWorkflowStatusDetailMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_WorkflowStatusDetail.';
        // Attributes
        this.WorkflowStatusDetailId = this.i + 'WorkflowStatusDetailId';
        this.ActionText = this.i + 'ActionText';
        this.AdminActionText = this.i + 'AdminActionText';
        this.CurrentStatusActionText = this.i + 'CurrentStatusActionText';
        this.ValidationRequired = this.i + 'ValidationRequired';
        this.ButtonClasses = this.i + 'ButtonClasses';
        this.CurrentStatusButtonClasses = this.i + 'CurrentStatusButtonClasses';
        this.IconClasses = this.i + 'IconClasses';
        this.TooltipText = this.i + 'TooltipText';
        this.StatusOrder = this.i + 'StatusOrder';
        this.Relations = {};
        this.ItemDetail.ItemId = 3804;
        this.ItemDetail.ItemName = 'dw_WorkflowStatusDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DevwareMetaData {
}
DevwareMetaData.DwAppPermission = new DwAppPermissionMetaData();
DevwareMetaData.DwAppPermissionRole = new DwAppPermissionRoleMetaData();
DevwareMetaData.DwContextDataDefinition = new DwContextDataDefinitionMetaData();
DevwareMetaData.DwDataImport = new DwDataImportMetaData();
DevwareMetaData.DwDataImportLog = new DwDataImportLogMetaData();
DevwareMetaData.DwDataImportRow = new DwDataImportRowMetaData();
DevwareMetaData.DwEmailTemplate = new DwEmailTemplateMetaData();
DevwareMetaData.DwEmailTemplateElapsedHistory = new DwEmailTemplateElapsedHistoryMetaData();
DevwareMetaData.DwEmailTemplateGroup = new DwEmailTemplateGroupMetaData();
DevwareMetaData.DwExceptionDetail = new DwExceptionDetailMetaData();
DevwareMetaData.DwFeatureArea = new DwFeatureAreaMetaData();
DevwareMetaData.DwFeatureAreaDetail = new DwFeatureAreaDetailMetaData();
DevwareMetaData.DwFeatureAreaDetailGroup = new DwFeatureAreaDetailGroupMetaData();
DevwareMetaData.DwFeatureAreaDetailType = new DwFeatureAreaDetailTypeMetaData();
DevwareMetaData.DwLog = new DwLogMetaData();
DevwareMetaData.DwLogData = new DwLogDataMetaData();
DevwareMetaData.DwLogPattern = new DwLogPatternMetaData();
DevwareMetaData.DwLogPatternDetail = new DwLogPatternDetailMetaData();
DevwareMetaData.DwLogPatternStatus = new DwLogPatternStatusMetaData();
DevwareMetaData.DwLogSqlTrace = new DwLogSqlTraceMetaData();
DevwareMetaData.DwMetaDataAttribute = new DwMetaDataAttributeMetaData();
DevwareMetaData.DwMetaDataAttributeFormat = new DwMetaDataAttributeFormatMetaData();
DevwareMetaData.DwMetaDataAttributeType = new DwMetaDataAttributeTypeMetaData();
DevwareMetaData.DwMetaDataAttributeTypeComparerMap = new DwMetaDataAttributeTypeComparerMapMetaData();
DevwareMetaData.DwMetaDataAttributeTypeControlTypeMap = new DwMetaDataAttributeTypeControlTypeMapMetaData();
DevwareMetaData.DwMetaDataAttributeTypeSqlTypeMap = new DwMetaDataAttributeTypeSqlTypeMapMetaData();
DevwareMetaData.DwMetaDataCollection = new DwMetaDataCollectionMetaData();
DevwareMetaData.DwMetaDataComparer = new DwMetaDataComparerMetaData();
DevwareMetaData.DwMetaDataControlType = new DwMetaDataControlTypeMetaData();
DevwareMetaData.DwMetaDataDatabase = new DwMetaDataDatabaseMetaData();
DevwareMetaData.DwMetaDataDatabaseSystem = new DwMetaDataDatabaseSystemMetaData();
DevwareMetaData.DwMetaDataDotNetType = new DwMetaDataDotNetTypeMetaData();
DevwareMetaData.DwMetaDataEnvironmentOfRecordType = new DwMetaDataEnvironmentOfRecordTypeMetaData();
DevwareMetaData.DwMetaDataEvent = new DwMetaDataEventMetaData();
DevwareMetaData.DwMetaDataGroup = new DwMetaDataGroupMetaData();
DevwareMetaData.DwMetaDataHistory = new DwMetaDataHistoryMetaData();
DevwareMetaData.DwMetaDataHistoryDetail = new DwMetaDataHistoryDetailMetaData();
DevwareMetaData.DwMetaDataHistoryType = new DwMetaDataHistoryTypeMetaData();
DevwareMetaData.DwMetaDataImport = new DwMetaDataImportMetaData();
DevwareMetaData.DwMetaDataImportLog = new DwMetaDataImportLogMetaData();
DevwareMetaData.DwMetaDataItem = new DwMetaDataItemMetaData();
DevwareMetaData.DwMetaDataItemRelationship = new DwMetaDataItemRelationshipMetaData();
DevwareMetaData.DwMetaDataItemRelationshipType = new DwMetaDataItemRelationshipTypeMetaData();
DevwareMetaData.DwMetaDataItemStatus = new DwMetaDataItemStatusMetaData();
DevwareMetaData.DwMetaDataItemType = new DwMetaDataItemTypeMetaData();
DevwareMetaData.DwMetaDataLookup = new DwMetaDataLookupMetaData();
DevwareMetaData.DwMetaDataLookupParam = new DwMetaDataLookupParamMetaData();
DevwareMetaData.DwMetaDataLookupTransition = new DwMetaDataLookupTransitionMetaData();
DevwareMetaData.DwMetaDataOperation = new DwMetaDataOperationMetaData();
DevwareMetaData.DwMetaDataOperationType = new DwMetaDataOperationTypeMetaData();
DevwareMetaData.DwMetaDataQuery = new DwMetaDataQueryMetaData();
DevwareMetaData.DwMetaDataSecurityGroup = new DwMetaDataSecurityGroupMetaData();
DevwareMetaData.DwMetaDataSecurityGroupAttribute = new DwMetaDataSecurityGroupAttributeMetaData();
DevwareMetaData.DwMetaDataSecurityGroupItem = new DwMetaDataSecurityGroupItemMetaData();
DevwareMetaData.DwMetaDataSecurityItemRule = new DwMetaDataSecurityItemRuleMetaData();
DevwareMetaData.DwMetaDataSqlType = new DwMetaDataSqlTypeMetaData();
DevwareMetaData.DwMetaDataSystem = new DwMetaDataSystemMetaData();
DevwareMetaData.DwMetaDataSystemType = new DwMetaDataSystemTypeMetaData();
DevwareMetaData.DwProcessDefinition = new DwProcessDefinitionMetaData();
DevwareMetaData.DwProcessSchedule = new DwProcessScheduleMetaData();
DevwareMetaData.DwProcessScheduleHistory = new DwProcessScheduleHistoryMetaData();
DevwareMetaData.DwProcessSchedulerServiceHistory = new DwProcessSchedulerServiceHistoryMetaData();
DevwareMetaData.DwProcessScheduleSummary = new DwProcessScheduleSummaryMetaData();
DevwareMetaData.DwProcessType = new DwProcessTypeMetaData();
DevwareMetaData.DwRole = new DwRoleMetaData();
DevwareMetaData.DwRoute = new DwRouteMetaData();
DevwareMetaData.DwRouteCategory = new DwRouteCategoryMetaData();
DevwareMetaData.DwRouteType = new DwRouteTypeMetaData();
DevwareMetaData.DwRuleDefinition = new DwRuleDefinitionMetaData();
DevwareMetaData.DwSecurityAudit = new DwSecurityAuditMetaData();
DevwareMetaData.DwSecurityAuditType = new DwSecurityAuditTypeMetaData();
DevwareMetaData.DwSecurityEmulationHistory = new DwSecurityEmulationHistoryMetaData();
DevwareMetaData.DwSecurityFactorType = new DwSecurityFactorTypeMetaData();
DevwareMetaData.DwSecurityPersonalAccessToken = new DwSecurityPersonalAccessTokenMetaData();
DevwareMetaData.DwSecurityToken = new DwSecurityTokenMetaData();
DevwareMetaData.DwTermsOfService = new DwTermsOfServiceMetaData();
DevwareMetaData.DwTermsOfServiceUser = new DwTermsOfServiceUserMetaData();
DevwareMetaData.DwUiConfig = new DwUiConfigMetaData();
DevwareMetaData.DwUiConfigType = new DwUiConfigTypeMetaData();
DevwareMetaData.DwUser = new DwUserMetaData();
DevwareMetaData.DwUserCommunicationPreferenceDetail = new DwUserCommunicationPreferenceDetailMetaData();
DevwareMetaData.DwUserCommunucationPreference = new DwUserCommunucationPreferenceMetaData();
DevwareMetaData.DwUserRole = new DwUserRoleMetaData();
DevwareMetaData.DwUserType = new DwUserTypeMetaData();
DevwareMetaData.DwWorkflowStatusDetail = new DwWorkflowStatusDetailMetaData();
// Lookup Value Enums  {
var MetaDataItemStatusAllItems;
(function (MetaDataItemStatusAllItems) {
    MetaDataItemStatusAllItems[MetaDataItemStatusAllItems["Active"] = 1] = "Active";
    MetaDataItemStatusAllItems[MetaDataItemStatusAllItems["Inactive"] = 2] = "Inactive";
    MetaDataItemStatusAllItems[MetaDataItemStatusAllItems["Deleted"] = 3] = "Deleted";
})(MetaDataItemStatusAllItems || (MetaDataItemStatusAllItems = {}));
var WorkflowStatusDetailAllItems;
(function (WorkflowStatusDetailAllItems) {
})(WorkflowStatusDetailAllItems || (WorkflowStatusDetailAllItems = {}));
var LogPatternStatusAllItems;
(function (LogPatternStatusAllItems) {
})(LogPatternStatusAllItems || (LogPatternStatusAllItems = {}));
var MetaDataHistoryTypeAllItems;
(function (MetaDataHistoryTypeAllItems) {
    MetaDataHistoryTypeAllItems[MetaDataHistoryTypeAllItems["Insert"] = 1] = "Insert";
    MetaDataHistoryTypeAllItems[MetaDataHistoryTypeAllItems["Update"] = 2] = "Update";
    MetaDataHistoryTypeAllItems[MetaDataHistoryTypeAllItems["Delete"] = 3] = "Delete";
    MetaDataHistoryTypeAllItems[MetaDataHistoryTypeAllItems["NoChange"] = 4] = "NoChange";
})(MetaDataHistoryTypeAllItems || (MetaDataHistoryTypeAllItems = {}));

var DwAttributeType;
(function (DwAttributeType) {
    DwAttributeType["Text"] = "Text";
    DwAttributeType["Integer"] = "Integer";
    DwAttributeType["Money"] = "Money";
    /*  Picklist = 'Picklist',
     Lookup = 'Lookup', */
    DwAttributeType["Date"] = "Date";
    DwAttributeType["DateTime"] = "DateTime";
    DwAttributeType["YesNo"] = "YesNo";
    DwAttributeType["File"] = "File";
    DwAttributeType["Memo"] = "Memo";
    DwAttributeType["Decimal"] = "Decimal";
    DwAttributeType["LargeInteger"] = "LargeInteger";
    DwAttributeType["UniqueIdentifier"] = "UniqueIdentifier";
    DwAttributeType["HTML"] = "HTML";
    DwAttributeType["Percentage"] = "Percentage";
    DwAttributeType["JSON"] = "JSON";
})(DwAttributeType || (DwAttributeType = {}));
var DwAttributeTypeNumber;
(function (DwAttributeTypeNumber) {
    DwAttributeTypeNumber[DwAttributeTypeNumber["Text"] = 1] = "Text";
    DwAttributeTypeNumber[DwAttributeTypeNumber["Integer"] = 2] = "Integer";
    DwAttributeTypeNumber[DwAttributeTypeNumber["Money"] = 3] = "Money";
    /*   Picklist = 4,
      Lookup = 5, */
    DwAttributeTypeNumber[DwAttributeTypeNumber["Date"] = 6] = "Date";
    DwAttributeTypeNumber[DwAttributeTypeNumber["DateTime"] = 7] = "DateTime";
    DwAttributeTypeNumber[DwAttributeTypeNumber["YesNo"] = 8] = "YesNo";
    DwAttributeTypeNumber[DwAttributeTypeNumber["File"] = 10] = "File";
    DwAttributeTypeNumber[DwAttributeTypeNumber["Memo"] = 11] = "Memo";
    DwAttributeTypeNumber[DwAttributeTypeNumber["Decimal"] = 12] = "Decimal";
    DwAttributeTypeNumber[DwAttributeTypeNumber["LargeInteger"] = 13] = "LargeInteger";
    DwAttributeTypeNumber[DwAttributeTypeNumber["UniqueIdentifier"] = 14] = "UniqueIdentifier";
    DwAttributeTypeNumber[DwAttributeTypeNumber["HTML"] = 15] = "HTML";
    DwAttributeTypeNumber[DwAttributeTypeNumber["Percentage"] = 16] = "Percentage";
})(DwAttributeTypeNumber || (DwAttributeTypeNumber = {}));
function convertToAttributeType(attributeTypeNumber) {
    switch (attributeTypeNumber) {
        case DwAttributeTypeNumber.Text:
            return DwAttributeType.Text;
        case DwAttributeTypeNumber.Integer:
            return DwAttributeType.Integer;
        case DwAttributeTypeNumber.Money:
            return DwAttributeType.Money;
        case DwAttributeTypeNumber.Date:
            return DwAttributeType.Date;
        case DwAttributeTypeNumber.DateTime:
            return DwAttributeType.DateTime;
        case DwAttributeTypeNumber.YesNo:
            return DwAttributeType.YesNo;
        case DwAttributeTypeNumber.Memo:
            return DwAttributeType.Memo;
        case DwAttributeTypeNumber.Decimal:
            return DwAttributeType.Decimal;
        case DwAttributeTypeNumber.LargeInteger:
            return DwAttributeType.LargeInteger;
        case DwAttributeTypeNumber.UniqueIdentifier:
            return DwAttributeType.UniqueIdentifier;
        case DwAttributeTypeNumber.HTML:
            return DwAttributeType.HTML;
        case DwAttributeTypeNumber.Percentage:
            return DwAttributeType.Percentage;
    }
    return DwAttributeType.Text;
}

/************************************************
   Generated with the Devware CAP CLI 4.4.20
   Code Gen Name   DevwareEnums
   API Url         https://localhost:44368

   Generated By    DEVWARE/anthony.monsees
   Generate On     1/10/2023 1:29:24 PM
************************************************/
var DevwareMetaDataItemNames;
(function (DevwareMetaDataItemNames) {
    DevwareMetaDataItemNames["DwApplication"] = "dw_Application";
    DevwareMetaDataItemNames["DwApplicationConfig"] = "dw_ApplicationConfig";
    DevwareMetaDataItemNames["DwApplicationConfigValue"] = "dw_ApplicationConfigValue";
    DevwareMetaDataItemNames["DwApplicationDatabase"] = "dw_ApplicationDatabase";
    DevwareMetaDataItemNames["DwAppPermission"] = "dw_AppPermission";
    DevwareMetaDataItemNames["DwAppPermissionRole"] = "dw_AppPermissionRole";
    DevwareMetaDataItemNames["DwCommunicationGroup"] = "dw_CommunicationGroup";
    DevwareMetaDataItemNames["DwContextDataDefinition"] = "dw_ContextDataDefinition";
    DevwareMetaDataItemNames["DwCustomAttributeValue"] = "dw_CustomAttributeValue";
    DevwareMetaDataItemNames["DwCustomFilterComparer"] = "dw_CustomFilterComparer";
    DevwareMetaDataItemNames["DwDatabaseRole"] = "dw_DatabaseRole";
    DevwareMetaDataItemNames["DwDatabaseVersion"] = "dw_DatabaseVersion";
    DevwareMetaDataItemNames["DwDesignSession"] = "dw_DesignSession";
    DevwareMetaDataItemNames["DwDesignSessionDetail"] = "dw_DesignSessionDetail";
    DevwareMetaDataItemNames["DwDesignSessionDetailHistory"] = "dw_DesignSessionDetailHistory";
    DevwareMetaDataItemNames["DwDesignSessionStatus"] = "dw_DesignSessionStatus";
    DevwareMetaDataItemNames["DwDesignSessionUser"] = "dw_DesignSessionUser";
    DevwareMetaDataItemNames["DwEmailDistributionList"] = "dw_EmailDistributionList";
    DevwareMetaDataItemNames["DwEmailDistributionListAddress"] = "dw_EmailDistributionListAddress";
    DevwareMetaDataItemNames["DwEmailDistributionListUser"] = "dw_EmailDistributionListUser";
    DevwareMetaDataItemNames["DwEmailHistory"] = "dw_EmailHistory";
    DevwareMetaDataItemNames["DwEmailHistoryRecipient"] = "dw_EmailHistoryRecipient";
    DevwareMetaDataItemNames["DwEmailTemplate"] = "dw_EmailTemplate";
    DevwareMetaDataItemNames["DwEmailTemplateElapsedHistory"] = "dw_EmailTemplateElapsedHistory";
    DevwareMetaDataItemNames["DwEmailTemplateGroup"] = "dw_EmailTemplateGroup";
    DevwareMetaDataItemNames["DwExceptionDetail"] = "dw_ExceptionDetail";
    DevwareMetaDataItemNames["DwFeatureArea"] = "dw_FeatureArea";
    DevwareMetaDataItemNames["DwFeatureAreaDetail"] = "dw_FeatureAreaDetail";
    DevwareMetaDataItemNames["DwFeatureAreaDetailGroup"] = "dw_FeatureAreaDetailGroup";
    DevwareMetaDataItemNames["DwFeatureAreaDetailType"] = "dw_FeatureAreaDetailType";
    DevwareMetaDataItemNames["DwLog"] = "dw_Log";
    DevwareMetaDataItemNames["DwMedia"] = "dw_Media";
    DevwareMetaDataItemNames["DwMediaDetail"] = "dw_MediaDetail";
    DevwareMetaDataItemNames["DwMediaFileExtension"] = "dw_MediaFileExtension";
    DevwareMetaDataItemNames["DwMediaFolder"] = "dw_MediaFolder";
    DevwareMetaDataItemNames["DwMediaGroup"] = "dw_MediaGroup";
    DevwareMetaDataItemNames["DwMediaSecurity"] = "dw_MediaSecurity";
    DevwareMetaDataItemNames["DwMediaSizeType"] = "dw_MediaSizeType";
    DevwareMetaDataItemNames["DwMediaStorageType"] = "dw_MediaStorageType";
    DevwareMetaDataItemNames["DwMediaType"] = "dw_MediaType";
    DevwareMetaDataItemNames["DwMediaTypeExtension"] = "dw_MediaTypeExtension";
    DevwareMetaDataItemNames["DwMetaDataAttribute"] = "dw_MetaDataAttribute";
    DevwareMetaDataItemNames["DwMetaDataAttributeFormat"] = "dw_MetaDataAttributeFormat";
    DevwareMetaDataItemNames["DwMetaDataAttributeType"] = "dw_MetaDataAttributeType";
    DevwareMetaDataItemNames["DwMetaDataAttributeTypeComparerMap"] = "dw_MetaDataAttributeTypeComparerMap";
    DevwareMetaDataItemNames["DwMetaDataAttributeTypeControlTypeMap"] = "dw_MetaDataAttributeTypeControlTypeMap";
    DevwareMetaDataItemNames["DwMetaDataAttributeTypeSqlTypeMap"] = "dw_MetaDataAttributeTypeSqlTypeMap";
    DevwareMetaDataItemNames["DwMetaDataCollection"] = "dw_MetaDataCollection";
    DevwareMetaDataItemNames["DwMetaDataComparer"] = "dw_MetaDataComparer";
    DevwareMetaDataItemNames["DwMetaDataControlType"] = "dw_MetaDataControlType";
    DevwareMetaDataItemNames["DwMetaDataDatabase"] = "dw_MetaDataDatabase";
    DevwareMetaDataItemNames["DwMetaDataDatabaseSystem"] = "dw_MetaDataDatabaseSystem";
    DevwareMetaDataItemNames["DwMetaDataDotNetType"] = "dw_MetaDataDotNetType";
    DevwareMetaDataItemNames["DwMetaDataEnvironmentOfRecordType"] = "dw_MetaDataEnvironmentOfRecordType";
    DevwareMetaDataItemNames["DwMetaDataEvent"] = "dw_MetaDataEvent";
    DevwareMetaDataItemNames["DwMetaDataGroup"] = "dw_MetaDataGroup";
    DevwareMetaDataItemNames["DwMetaDataHistory"] = "dw_MetaDataHistory";
    DevwareMetaDataItemNames["DwMetaDataHistoryDetail"] = "dw_MetaDataHistoryDetail";
    DevwareMetaDataItemNames["DwMetaDataHistoryType"] = "dw_MetaDataHistoryType";
    DevwareMetaDataItemNames["DwMetaDataImport"] = "dw_MetaDataImport";
    DevwareMetaDataItemNames["DwMetaDataImportLog"] = "dw_MetaDataImportLog";
    DevwareMetaDataItemNames["DwMetaDataItem"] = "dw_MetaDataItem";
    DevwareMetaDataItemNames["DwMetaDataItemRelationship"] = "dw_MetaDataItemRelationship";
    DevwareMetaDataItemNames["DwMetaDataItemRelationshipType"] = "dw_MetaDataItemRelationshipType";
    DevwareMetaDataItemNames["DwMetaDataItemStatus"] = "dw_MetaDataItemStatus";
    DevwareMetaDataItemNames["DwMetaDataItemType"] = "dw_MetaDataItemType";
    DevwareMetaDataItemNames["DwMetaDataLookup"] = "dw_MetaDataLookup";
    DevwareMetaDataItemNames["DwMetaDataLookupParam"] = "dw_MetaDataLookupParam";
    DevwareMetaDataItemNames["DwMetaDataLookupTransition"] = "dw_MetaDataLookupTransition";
    DevwareMetaDataItemNames["DwMetaDataOperation"] = "dw_MetaDataOperation";
    DevwareMetaDataItemNames["DwMetaDataOperationType"] = "dw_MetaDataOperationType";
    DevwareMetaDataItemNames["DwMetaDataQuery"] = "dw_MetaDataQuery";
    DevwareMetaDataItemNames["DwMetaDataSecurityGroup"] = "dw_MetaDataSecurityGroup";
    DevwareMetaDataItemNames["DwMetaDataSecurityGroupAttribute"] = "dw_MetaDataSecurityGroupAttribute";
    DevwareMetaDataItemNames["DwMetaDataSecurityGroupItem"] = "dw_MetaDataSecurityGroupItem";
    DevwareMetaDataItemNames["DwMetaDataSecurityItemRule"] = "dw_MetaDataSecurityItemRule";
    DevwareMetaDataItemNames["DwMetaDataSqlType"] = "dw_MetaDataSqlType";
    DevwareMetaDataItemNames["DwMetaDataSystem"] = "dw_MetaDataSystem";
    DevwareMetaDataItemNames["DwMetaDataSystemType"] = "dw_MetaDataSystemType";
    DevwareMetaDataItemNames["DwOrganization"] = "dw_Organization";
    DevwareMetaDataItemNames["DwPartyReference"] = "dw_PartyReference";
    DevwareMetaDataItemNames["DwPdfTemplate"] = "dw_PdfTemplate";
    DevwareMetaDataItemNames["DwProcessDefinition"] = "dw_ProcessDefinition";
    DevwareMetaDataItemNames["DwProcessSchedule"] = "dw_ProcessSchedule";
    DevwareMetaDataItemNames["DwProcessScheduleHistory"] = "dw_ProcessScheduleHistory";
    DevwareMetaDataItemNames["DwProcessScheduleSummary"] = "dw_ProcessScheduleSummary";
    DevwareMetaDataItemNames["DwProcessType"] = "dw_ProcessType";
    DevwareMetaDataItemNames["DwProviderExtension"] = "dw_ProviderExtension";
    DevwareMetaDataItemNames["DwReport"] = "dw_Report";
    DevwareMetaDataItemNames["DwReportCategory"] = "dw_ReportCategory";
    DevwareMetaDataItemNames["DwReportParameter"] = "dw_ReportParameter";
    DevwareMetaDataItemNames["DwRoAllDates"] = "dw_roAllDates";
    DevwareMetaDataItemNames["DwRoEmailDistributionListEmail"] = "dw_roEmailDistributionListEmail";
    DevwareMetaDataItemNames["DwRole"] = "dw_Role";
    DevwareMetaDataItemNames["DwRoMedia"] = "dw_roMedia";
    DevwareMetaDataItemNames["DwRoMetaDataAttribute"] = "dw_roMetaDataAttribute";
    DevwareMetaDataItemNames["DwRoMetaDataItemRelationship"] = "dw_roMetaDataItemRelationship";
    DevwareMetaDataItemNames["DwRoMetaDataItemRelationshipHelper"] = "dw_roMetaDataItemRelationshipHelper";
    DevwareMetaDataItemNames["DwRoTableIndexes"] = "dw_roTableIndexes";
    DevwareMetaDataItemNames["DwRoute"] = "dw_Route";
    DevwareMetaDataItemNames["DwRouteCategory"] = "dw_RouteCategory";
    DevwareMetaDataItemNames["DwRouteType"] = "dw_RouteType";
    DevwareMetaDataItemNames["DwRuleDefinition"] = "dw_RuleDefinition";
    DevwareMetaDataItemNames["DwSecurityAudit"] = "dw_SecurityAudit";
    DevwareMetaDataItemNames["DwSecurityAuditType"] = "dw_SecurityAuditType";
    DevwareMetaDataItemNames["DwSecurityFactorType"] = "dw_SecurityFactorType";
    DevwareMetaDataItemNames["DwSecurityPersonalAccessToken"] = "dw_SecurityPersonalAccessToken";
    DevwareMetaDataItemNames["DwSecurityToken"] = "dw_SecurityToken";
    DevwareMetaDataItemNames["DwSingleSignOnToken"] = "dw_SingleSignOnToken";
    DevwareMetaDataItemNames["DwTenant"] = "dw_Tenant";
    DevwareMetaDataItemNames["DwTenantApplication"] = "dw_TenantApplication";
    DevwareMetaDataItemNames["DwTenantConfig"] = "dw_TenantConfig";
    DevwareMetaDataItemNames["DwTenantCorsOrigin"] = "dw_TenantCorsOrigin";
    DevwareMetaDataItemNames["DwTenantExtension"] = "dw_TenantExtension";
    DevwareMetaDataItemNames["DwTenantExtensionAssembly"] = "dw_TenantExtensionAssembly";
    DevwareMetaDataItemNames["DwTenantExtensionTypeId"] = "dw_TenantExtensionTypeId";
    DevwareMetaDataItemNames["DwTenantRoutingType"] = "dw_TenantRoutingType";
    DevwareMetaDataItemNames["DwTenantSSOConfig"] = "dw_TenantSSOConfig";
    DevwareMetaDataItemNames["DwTenantSSOConfigRole"] = "dw_TenantSSOConfigRole";
    DevwareMetaDataItemNames["DwTenantSSOType"] = "dw_TenantSSOType";
    DevwareMetaDataItemNames["DwUiConfig"] = "dw_UiConfig";
    DevwareMetaDataItemNames["DwUiConfigType"] = "dw_UiConfigType";
    DevwareMetaDataItemNames["DwUser"] = "dw_User";
    DevwareMetaDataItemNames["DwUserCommunicationPreferenceDetail"] = "dw_UserCommunicationPreferenceDetail";
    DevwareMetaDataItemNames["DwUserCommunucationPreference"] = "dw_UserCommunucationPreference";
    DevwareMetaDataItemNames["DwUserRole"] = "dw_UserRole";
})(DevwareMetaDataItemNames || (DevwareMetaDataItemNames = {}));
var DevwareMetaDataLookups;
(function (DevwareMetaDataLookups) {
    DevwareMetaDataLookups["AppPermissionByMeaning"] = "APP_PERMISSION_BY_MEANING";
    DevwareMetaDataLookups["ApplicationAllItems"] = "dw_Application_All_Items";
    DevwareMetaDataLookups["ApplicationConfigAllItems"] = "dw_ApplicationConfig_All_Items";
    DevwareMetaDataLookups["ApplicationConfigValueAllItems"] = "dw_ApplicationConfigValue_All_Items";
    DevwareMetaDataLookups["ApplicationDatabaseAllItems"] = "dw_ApplicationDatabase_All_Items";
    DevwareMetaDataLookups["AppPermissionAllItems"] = "dw_AppPermission_All_Items";
    DevwareMetaDataLookups["AppPermissionRoleAllItems"] = "dw_AppPermissionRole_All_Items";
    DevwareMetaDataLookups["AttributeByMetaDataItem"] = "Attribute_by_MetaDataItem";
    DevwareMetaDataLookups["CommunicationGroupAllItems"] = "dw_CommunicationGroup_All_Items";
    DevwareMetaDataLookups["ContextDataDefinitionAllItems"] = "dw_ContextDataDefinition_All_Items";
    DevwareMetaDataLookups["CustomAttributeValueAllItems"] = "dw_CustomAttributeValue_All_Items";
    DevwareMetaDataLookups["CustomFilterComparerAllItems"] = "dw_CustomFilterComparer_All_Items";
    DevwareMetaDataLookups["DatabaseRoleAllItems"] = "dw_DatabaseRole_All_Items";
    DevwareMetaDataLookups["DatabaseVersionAllItems"] = "dw_DatabaseVersion_All_Items";
    DevwareMetaDataLookups["DesignSessionAllItems"] = "DesignSession_All_Items";
    DevwareMetaDataLookups["DesignSessionDetailAllItems"] = "DesignSessionDetail_All_Items";
    DevwareMetaDataLookups["DesignSessionDetailHistoryAllItems"] = "DesignSessionDetailHistory_All_Items";
    DevwareMetaDataLookups["DesignSessionStatusAllItems"] = "DesignSessionStatus_All_Items";
    DevwareMetaDataLookups["DesignSessionUserAllItems"] = "DesignSessionUser_All_Items";
    DevwareMetaDataLookups["EmailDistributionListAllItems"] = "dw_EmailDistributionList_All_Items";
    DevwareMetaDataLookups["EmailDistributionListAddressAllItems"] = "dw_EmailDistributionListAddress_All_Items";
    DevwareMetaDataLookups["EmailDistributionListUserAllItems"] = "dw_EmailDistributionListUser_All_Items";
    DevwareMetaDataLookups["EmailHistoryAllItems"] = "dw_EmailHistory_All_Items";
    DevwareMetaDataLookups["EmailHistoryRecipientAllItems"] = "dw_EmailHistoryRecipient_All_Items";
    DevwareMetaDataLookups["EmailTemplateAllItems"] = "dw_EmailTemplate_All_Items";
    DevwareMetaDataLookups["EmailTemplateElapsedHistoryAllItems"] = "EmailTemplateElapsedHistory_All_Items";
    DevwareMetaDataLookups["EmailTemplateGroupAllItems"] = "dw_EmailTemplateGroup_All_Items";
    DevwareMetaDataLookups["ExceptionDetailAllItems"] = "dw_ExceptionDetail_All_Items";
    DevwareMetaDataLookups["FeatureAreaAllItems"] = "FeatureArea_All_Items";
    DevwareMetaDataLookups["FeatureAreaDetailAllItems"] = "FeatureAreaDetail_All_Items";
    DevwareMetaDataLookups["FeatureAreaDetailGroupAllItems"] = "FeatureAreaDetailGroup_All_Items";
    DevwareMetaDataLookups["FeatureAreaDetailTypeAllItems"] = "FeatureAreaDetailType_All_Items";
    DevwareMetaDataLookups["FeatureAreaDetailTypesByGroup"] = "Feature_Area_Detail_Types_by_Group";
    DevwareMetaDataLookups["LogAllItems"] = "dw_Log_All_Items";
    DevwareMetaDataLookups["LogSeverity"] = "LOG_SEVERITY";
    DevwareMetaDataLookups["MediaAllItems"] = "dw_Media_All_Items";
    DevwareMetaDataLookups["MediaDetailAllItems"] = "dw_MediaDetail_All_Items";
    DevwareMetaDataLookups["MediaFileExtensionAllItems"] = "dw_MediaFileExtension_All_Items";
    DevwareMetaDataLookups["MediaFolderAllItems"] = "dw_MediaFolder_All_Items";
    DevwareMetaDataLookups["MediaGroupAllItems"] = "dw_MediaGroup_All_Items";
    DevwareMetaDataLookups["MediaSecurityAllItems"] = "MediaSecurity_All_Items";
    DevwareMetaDataLookups["MediaSizeTypeAllItems"] = "dw_MediaSizeType_All_Items";
    DevwareMetaDataLookups["MediaStorageTypeAllItems"] = "dw_MediaStorageType_All_Items";
    DevwareMetaDataLookups["MediaTypeAllItems"] = "dw_MediaType_All_Items";
    DevwareMetaDataLookups["MediaTypeExtensionAllItems"] = "dw_MediaTypeExtension_All_Items";
    DevwareMetaDataLookups["MetaDataItemGroupByDatabase"] = "META_DATA_ITEM_GROUP_BY_DB";
    DevwareMetaDataLookups["MetaDataQueryByItem"] = "Meta_Data_Query_by_Item";
    DevwareMetaDataLookups["MetaDataSchemasByDatabase"] = "Meta_Data_Schemas_by_Database";
    DevwareMetaDataLookups["MetaDataAttributeWithItemName"] = "MetaDataAttribute_-_With_Item_Name";
    DevwareMetaDataLookups["MetaDataAttributeAllItems"] = "dw_MetaDataAttribute_All_Items";
    DevwareMetaDataLookups["MetaDataAttributeFormatAllItems"] = "dw_MetaDataAttributeFormat_All_Items";
    DevwareMetaDataLookups["MetaDataAttributeTypeAllItems"] = "dw_MetaDataAttributeType_All_Items";
    DevwareMetaDataLookups["MetaDataAttributeTypeComparerMapAllItems"] = "dw_MetaDataAttributeTypeComparerMap_All_Items";
    DevwareMetaDataLookups["MetaDataAttributeTypeControlTypeMapAllItems"] = "dw_MetaDataAttributeTypeControlTypeMap_All_Items";
    DevwareMetaDataLookups["MetaDataAttributeTypeSqlTypeMapAllItems"] = "dw_MetaDataAttributeTypeSqlTypeMap_All_Items";
    DevwareMetaDataLookups["MetaDataCollectionAllItems"] = "dw_MetaDataCollection_All_Items";
    DevwareMetaDataLookups["MetaDataComparerAllItems"] = "dw_MetaDataComparer_All_Items";
    DevwareMetaDataLookups["MetaDataControlTypeAllItems"] = "dw_MetaDataControlType_All_Items";
    DevwareMetaDataLookups["MetaDataDatabaseAllItems"] = "dw_MetaDataDatabase_All_Items";
    DevwareMetaDataLookups["MetaDataDatabaseSystemAllItems"] = "dw_MetaDataDatabaseSystem_All_Items";
    DevwareMetaDataLookups["MetaDataDotNetTypeAllItems"] = "dw_MetaDataDotNetType_All_Items";
    DevwareMetaDataLookups["MetaDataEnvironmentOfRecordTypeAllItems"] = "MetaDataEnvironmentOfRecordType_All_Items";
    DevwareMetaDataLookups["MetaDataEventAllItems"] = "dw_MetaDataEvent_All_Items";
    DevwareMetaDataLookups["MetaDataGroupAllItems"] = "dw_MetaDataGroup_All_Items";
    DevwareMetaDataLookups["MetaDataHistoryAllItems"] = "MetaDataHistory_All_Items";
    DevwareMetaDataLookups["MetaDataHistoryDetailAllItems"] = "MetaDataHistoryDetail_All_Items";
    DevwareMetaDataLookups["MetaDataHistoryTypeAllItems"] = "MetaDataHistoryType_All_Items";
    DevwareMetaDataLookups["MetaDataImportAllItems"] = "MetaDataImport_All_Items";
    DevwareMetaDataLookups["MetaDataImportLogAllItems"] = "MetaDataImportLog_All_Items";
    DevwareMetaDataLookups["MetaDataItemAllItems"] = "dw_MetaDataItem_All_Items";
    DevwareMetaDataLookups["MetaDataItemRelationshipAllItems"] = "dw_MetaDataItemRelationship_All_Items";
    DevwareMetaDataLookups["MetaDataItemRelationshipTypeAllItems"] = "dw_MetaDataItemRelationshipType_All_Items";
    DevwareMetaDataLookups["MetaDataItemStatusAllItems"] = "dw_MetaDataItemStatus_All_Items";
    DevwareMetaDataLookups["MetaDataItemTypeAllItems"] = "dw_MetaDataItemType_All_Items";
    DevwareMetaDataLookups["MetaDataLookupAllItems"] = "dw_MetaDataLookup_All_Items";
    DevwareMetaDataLookups["MetaDataLookupParamAllItems"] = "dw_MetaDataLookupParam_All_Items";
    DevwareMetaDataLookups["MetaDataLookupTransitionAllItems"] = "dw_MetaDataLookupTransition_All_Items";
    DevwareMetaDataLookups["MetaDataOperationAllItems"] = "dw_MetaDataOperation_All_Items";
    DevwareMetaDataLookups["MetaDataOperationTypeAllItems"] = "dw_MetaDataOperationType_All_Items";
    DevwareMetaDataLookups["MetaDataQueryAllItems"] = "dw_MetaDataQuery_All_Items";
    DevwareMetaDataLookups["MetaDataSecurityGroupAllItems"] = "dw_MetaDataSecurityGroup_All_Items";
    DevwareMetaDataLookups["MetaDataSecurityGroupAttributeAllItems"] = "dw_MetaDataSecurityGroupAttribute_All_Items";
    DevwareMetaDataLookups["MetaDataSecurityGroupItemAllItems"] = "dw_MetaDataSecurityGroupItem_All_Items";
    DevwareMetaDataLookups["MetaDataSecurityItemRuleAllItems"] = "dw_MetaDataSecurityItemRule_All_Items";
    DevwareMetaDataLookups["MetaDataSqlTypeAllItems"] = "dw_MetaDataSqlType_All_Items";
    DevwareMetaDataLookups["MetaDataSystemAllItems"] = "dw_MetaDataSystem_All_Items";
    DevwareMetaDataLookups["MetaDataSystemTypeAllItems"] = "dw_MetaDataSystemType_All_Items";
    DevwareMetaDataLookups["OrganizationAllItems"] = "dw_Organization_All_Items";
    DevwareMetaDataLookups["PartyReferenceAllItems"] = "dw_PartyReference_All_Items";
    DevwareMetaDataLookups["PdfTemplateAllItems"] = "dw_PdfTemplate_All_Items";
    DevwareMetaDataLookups["ProcessDefinitionAllItems"] = "ProcessDefinition_All_Items";
    DevwareMetaDataLookups["ProcessScheduleAllItems"] = "ProcessSchedule_All_Items";
    DevwareMetaDataLookups["ProcessScheduleHistoryAllItems"] = "ProcessScheduleHistory_All_Items";
    DevwareMetaDataLookups["ProcessScheduleSummaryAllItems"] = "ProcessScheduleSummary_All_Items";
    DevwareMetaDataLookups["ProcessTypeAllItems"] = "ProcessType_All_Items";
    DevwareMetaDataLookups["ProviderExtensionAllItems"] = "dw_ProviderExtension_All_Items";
    DevwareMetaDataLookups["ReportAllItems"] = "dw_Report_All_Items";
    DevwareMetaDataLookups["ReportCategoryAllItems"] = "dw_ReportCategory_All_Items";
    DevwareMetaDataLookups["ReportParameterAllItems"] = "dw_ReportParameter_All_Items";
    DevwareMetaDataLookups["RoAllDatesAllItems"] = "dw_roAllDates_All_Items";
    DevwareMetaDataLookups["RoEmailDistributionListEmailAllItems"] = "dw_roEmailDistributionListEmail_All_Items";
    DevwareMetaDataLookups["RoleAllItems"] = "dw_Role_All_Items";
    DevwareMetaDataLookups["RoMediaAllItems"] = "dw_roMedia_All_Items";
    DevwareMetaDataLookups["RoMetaDataAttributeAllItems"] = "dw_roMetaDataAttribute_All_Items";
    DevwareMetaDataLookups["RoMetaDataItemRelationshipAllItems"] = "dw_roMetaDataItemRelationship_All_Items";
    DevwareMetaDataLookups["RoMetaDataItemRelationshipHelperAllItems"] = "dw_roMetaDataItemRelationshipHelper_All_Items";
    DevwareMetaDataLookups["RoMetaDataReltationshipByItemName"] = "roMetaDataReltationship_-_By_Item_Name";
    DevwareMetaDataLookups["RoTableIndexesAllItems"] = "dw_roTableIndexes_All_Items";
    DevwareMetaDataLookups["RouteAllItems"] = "dw_Route_All_Items";
    DevwareMetaDataLookups["RouteCategoryAllItems"] = "dw_RouteCategory_All_Items";
    DevwareMetaDataLookups["RouteTypeAllItems"] = "dw_RouteType_All_Items";
    DevwareMetaDataLookups["RuleDefinitionAllItems"] = "dw_RuleDefinition_All_Items";
    DevwareMetaDataLookups["SecurityAuditAllItems"] = "SecurityAudit_All_Items";
    DevwareMetaDataLookups["SecurityAuditTypeAllItems"] = "SecurityAuditType_All_Items";
    DevwareMetaDataLookups["SecurityFactorTypeAllItems"] = "SecurityFactorType_All_Items";
    DevwareMetaDataLookups["SecurityPersonalAccessTokenAllItems"] = "dw_SecurityPersonalAccessToken_All_Items";
    DevwareMetaDataLookups["SecurityTokenAllItems"] = "dw_SecurityToken_All_Items";
    DevwareMetaDataLookups["SingleSignOnTokenAllItems"] = "dw_SingleSignOnToken_All_Items";
    DevwareMetaDataLookups["TenantAllItems"] = "dw_Tenant_All_Items";
    DevwareMetaDataLookups["TenantApplicationAllItems"] = "dw_TenantApplication_All_Items";
    DevwareMetaDataLookups["TenantConfigAllItems"] = "dw_TenantConfig_All_Items";
    DevwareMetaDataLookups["TenantCorsOriginAllItems"] = "dw_TenantCorsOrigin_All_Items";
    DevwareMetaDataLookups["TenantExtensionAllItems"] = "dw_TenantExtension_All_Items";
    DevwareMetaDataLookups["TenantExtensionAssemblyAllItems"] = "dw_TenantExtensionAssembly_All_Items";
    DevwareMetaDataLookups["TenantExtensionTypeIdAllItems"] = "dw_TenantExtensionTypeId_All_Items";
    DevwareMetaDataLookups["TenantRoutingTypeAllItems"] = "dw_TenantRoutingType_All_Items";
    DevwareMetaDataLookups["TenantSSOConfigAllItems"] = "dw_TenantSSOConfig_All_Items";
    DevwareMetaDataLookups["TenantSSOConfigRoleAllItems"] = "dw_TenantSSOConfigRole_All_Items";
    DevwareMetaDataLookups["TenantSSOTypeAllItems"] = "dw_TenantSSOType_All_Items";
    DevwareMetaDataLookups["UiConfigAllItems"] = "dw_UiConfig_All_Items";
    DevwareMetaDataLookups["UiConfigTypeAllItems"] = "dw_UiConfigType_All_Items";
    DevwareMetaDataLookups["UserAllItems"] = "dw_User_All_Items";
    DevwareMetaDataLookups["UserCommunicationPreferenceDetailAllItems"] = "dw_UserCommunicationPreferenceDetail_All_Items";
    DevwareMetaDataLookups["UserCommunucationPreferenceAllItems"] = "dw_UserCommunucationPreference_All_Items";
    DevwareMetaDataLookups["UserRoleAllItems"] = "dw_UserRole_All_Items";
})(DevwareMetaDataLookups || (DevwareMetaDataLookups = {}));

var DwFormatTypes;
(function (DwFormatTypes) {
    DwFormatTypes["date"] = "date";
    DwFormatTypes["datetime"] = "datetime";
    DwFormatTypes["yesNo"] = "yesno";
    DwFormatTypes["number"] = "number";
    DwFormatTypes["currency"] = "currency";
    DwFormatTypes["percent"] = "percent";
    DwFormatTypes["text"] = "text";
})(DwFormatTypes || (DwFormatTypes = {}));

const DwAppInitHandlerToken = new InjectionToken('DwAppInitHandler');

class DwAppInitService {
    constructor(http, storageUtil, cacheService, configService, appInitHandlers) {
        this.http = http;
        this.storageUtil = storageUtil;
        this.cacheService = cacheService;
        this.configService = configService;
        this.appInitHandlers = appInitHandlers;
        this.cachItemInfo = {};
        // Setup storage to use
        this.storageUtil = storageUtil.session();
        this.apiRoot = configService.coreConfig.apiRoot;
    }
    ;
    startupApp() {
        //console.log('Starting up app');
        return this.configService.waitForConfigLoader()
            .pipe(mergeMap(() => {
            this.apiRoot = this.configService.coreConfig.apiRoot;
            //console.log('Starting up app - Config Loaded');
            return this.getAppInitResult()
                .pipe(mergeMap(appInitResult => {
                //console.log('Starting up app - app Init Loaded', appInitResult);
                if (this.appInitHandlers) {
                    const obs = [];
                    this.appInitHandlers.forEach(handler => {
                        //console.log('Init App Hanlder');
                        let ob = handler.handleAppInit(appInitResult, this.configService.coreConfig);
                        if (ob) {
                            obs.push(ob);
                        }
                    });
                    return combineLatest(obs);
                }
                return of(null);
            }));
        }));
    }
    /** Get the full App Init result */
    getAppInitResult() {
        const cacheOptions = {
            storageLocation: DwCacheStorageLocation.memory,
        };
        return this.cacheService.getWithOptions('AppInit', this.loadAppInitResult(), cacheOptions);
    }
    /**
     * Get a named property of the app init result with an optional backup load method and cache options
     * @param propName Prop name of app init result to return (Required)
     * @param loadBackup Back observable to load the data (Optional)
     *      Used to refresh the cache of one item independently of the entire app init result and to reload the items if its cache is invalidated
     * @param cacheOptions Cache options used to invalidate item
     */
    getApiInitItem(propName, loadBackup, cacheOptions) {
        const cacheKey = `AppInit_${propName}`;
        cacheOptions = cacheOptions || {};
        this.setupCacheInvalidateSubject(propName, cacheOptions);
        return this.cacheService.getWithOptions(cacheKey, this.loadApiInitItem(propName, loadBackup, cacheOptions), cacheOptions);
    }
    setupCacheInvalidateSubject(propName, cacheOptions) {
        if (this.cachItemInfo[propName]) {
            cacheOptions.cacheClearSubject = this.cachItemInfo[propName].subject;
            return cacheOptions;
        }
        let subject = cacheOptions.cacheClearSubject;
        if (!subject) {
            subject = new Subject();
        }
        this.cachItemInfo[propName] = {
            subject,
            loadFromBackup: false
        };
        subject.subscribe((result) => {
            this.cachItemInfo[propName].loadFromBackup = true;
        });
        cacheOptions.cacheClearSubject = subject;
    }
    loadApiInitItem(propName, loadBackup, cacheOptions) {
        const cacheKey = `AppInit_${propName}`;
        return this.getAppInitResult()
            .pipe(mergeMap(appInitResult => {
            const value = appInitResult[propName];
            if (value && !this.cachItemInfo[propName].loadFromBackup) {
                return of(value);
            }
            if (!loadBackup) {
                return of(value);
            }
            return loadBackup
                .pipe(tap(newValue => {
                appInitResult[propName] = newValue;
                this.cacheService.setWithOptions(cacheKey, appInitResult, cacheOptions);
                this.cachItemInfo[propName].loadFromBackup = false;
            }));
        }));
    }
    loadAppInitResult() {
        //const url = `${thisapiRootOld}EnterpriseService.svc//GetAppInitResult`;
        const url = `${this.apiRoot}/general/config/app`;
        const body = {};
        const result = this.http.get(url);
        return result.pipe(map((result) => {
            // return result.d;
            return result;
        }));
    }
    getProductVersions() {
        //const url = `${thisapiRootOld}EnterpriseService.svc//GetAppInitResult`;
        const url = `${this.apiRoot}/general/config/app/versions`;
        const body = {};
        const result = this.http.get(url);
        return result.pipe(map((results) => {
            if (this.configService.coreConfig.platformVersion) {
                results.push(this.configService.coreConfig.platformVersion);
            }
            if (this.configService.coreConfig.applicationVersion) {
                results.push(this.configService.coreConfig.applicationVersion);
            }
            return results;
        }));
    }
    /**
     * Use to update various pieces of the app init state (if they change independently)
     * @param result
     */
    updateAppInitResult(updatedAppInitResult) {
        const cacheOptions = {
            storageLocation: DwCacheStorageLocation.sessionStorage,
        };
        this.getAppInitResult()
            .subscribe(appInitResult => {
            const newAppInitResult = Object.assign(Object.assign({}, updatedAppInitResult), appInitResult);
            this.cacheService.setWithOptions('AppInit', newAppInitResult, cacheOptions);
        });
    }
}
DwAppInitService.ɵfac = function DwAppInitService_Factory(t) { return new (t || DwAppInitService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwStorageUtil), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwAppInitHandlerToken, 8)); };
DwAppInitService.ɵprov = ɵɵdefineInjectable({ factory: function DwAppInitService_Factory() { return new DwAppInitService(ɵɵinject(HttpClient), ɵɵinject(DwStorageUtil), ɵɵinject(DwCacheService), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwAppInitHandlerToken, 8)); }, token: DwAppInitService, providedIn: "root" });
DwAppInitService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwStorageUtil },
    { type: DwCacheService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [DwAppInitHandlerToken,] }] }
];

const DwMetaDataServiceToken = new InjectionToken("DwMetaDataService");
class DwMetaDataService {
    // Note: Changing the constructor also requires changing the DI in the module
    constructor(http, configService, ormDataService, eventService, cacheService, appInitService) {
        this.http = http;
        this.ormDataService = ormDataService;
        this.eventService = eventService;
        this.cacheService = cacheService;
        this.appInitService = appInitService;
        this.QueryHelper = new DwQueryHelper();
        this.serverCacheClearDelay = 100;
        this.META_DATA_STATUS_DELETED = 3;
        this.apiRoot = configService.coreConfig.apiRoot;
        this.setupMetaDataServerCacheClearEvents();
    }
    getDatabaseDetails() {
        return this.appInitService.getApiInitItem("AppDatabaseDetails", null, null);
    }
    setupMetaDataServerCacheClearEvents() {
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItem));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttribute));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItemRelationship));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataLookup));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataQuery));
        for (let cacheInvalidationTopic of cacheInvalidationTopics) {
            this.eventService.getEvent(cacheInvalidationTopic)
                // Wait x ms before clear cache so we don't get multiple events at once and clear it several times
                .pipe(debounceTime(this.serverCacheClearDelay))
                .subscribe(event => {
                // Switched to handle on server and just publish a client event
                this.eventService.publishEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.MetaDataUpdated, null);
                if (!isBroadcastEvent(event)) {
                    this.eventService.publishBroadcastMessage(event.topic, event.data);
                }
            });
        }
    }
    processCacheClearEvent(event) {
        this.clearMetaDataCache()
            .subscribe(r => { });
    }
    /**
     * Import MetaData with options
     * @param importOptions import options
     */
    importMetaDataWithOptions(importOptions) {
        let url = `${this.apiRoot}/metadata/import`;
        return this.http.post(url, importOptions)
            .pipe(tap(result => {
            this.clearCacheAfterImport(result);
        }));
    }
    clearCacheAfterImport(result) {
        var _a;
        if (!result.ImportResult || !result.IsSuccess || ((_a = result.ImportResult) === null || _a === void 0 ? void 0 : _a.ShowChangesOnly)) {
            return;
        }
        const importResult = result.ImportResult;
        let hasChanges = false;
        if (importResult.Items.AddedCount > 0 || importResult.Items.UpdatedCount > 0 || importResult.Items.DeletedCount > 0) {
            hasChanges = true;
            this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwMetaDataItem.UniqueItemName), {});
        }
        if (importResult.Lookups.AddedCount > 0 || importResult.Lookups.UpdatedCount > 0 || importResult.Lookups.DeletedCount > 0) {
            hasChanges = true;
            this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwMetaDataLookup.ItemDetail.ItemName), {});
        }
        if (importResult.Relationships.AddedCount > 0 || importResult.Relationships.UpdatedCount > 0 || importResult.Relationships.DeletedCount > 0) {
            hasChanges = true;
            this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwMetaDataItemRelationship.ItemDetail.ItemName), {});
        }
        let attributesModified = false;
        importResult.Items.ItemStats.forEach(itemStat => {
            if (itemStat.Attributes.AddedCount > 0 || itemStat.Attributes.UpdatedCount > 0 || itemStat.Attributes.DeletedCount > 0) {
                attributesModified = true;
                this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(itemStat.UniqueItemName), {});
            }
        });
        if (attributesModified) {
            hasChanges = true;
            this.eventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwMetaDataAttribute.ItemDetail.ItemName), {});
        }
        if (hasChanges) {
            // if we have changes, then let's publish a Meta Data Updated event
            this.eventService.publishEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.MetaDataUpdated, null);
        }
    }
    /**
     * Clear MetaData Cache
     */
    clearMetaDataCache() {
        let url = `${this.apiRoot}/general/cache/metadata`;
        return this.http.delete(url);
    }
    getQueries(itemId) {
        const cacheOptions = {
            cacheInvalidationsTopics: [DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataQuery)]
        };
        const key = `DwMetaDataQuery_${itemId}`;
        return this.cacheService.getWithOptions(key, this.loadQueries(itemId), cacheOptions);
    }
    loadQueries(itemId) {
        const dwMd = new DevwareMetaDataService();
        const qh = new DwQueryHelper();
        const query = dwMd.DwMetaDataQuery.CreateQuery()
            .AddFilterAnd(qh.filters.Equal(dwMd.DwMetaDataQuery.MetaDataItemId, itemId));
        query.IncludeSharedData = true;
        return this.ormDataService.executeQuery(query);
    }
    /**
     * Get the metadata for a query
     * @param query query
     */
    getQueryMetaData(query) {
        let url = `${this.apiRoot}/metadata/advanced`;
        return this.http.post(url, query)
            .pipe(map((r) => {
            return r;
        }));
    }
    getSavedQueryMetaData(item, metaDataQueryId, metaDataQueryMeaning, includeRootDisplayFields = true) {
        if (!item) {
            return of(null);
        }
        const request = {
            ItemName: this.getDwItemName(item),
            MetaDataQueryIds: [],
            MetaDataQueryMeanings: [],
            IncludeRootDisplayFields: includeRootDisplayFields
        };
        if (metaDataQueryId) {
            request.MetaDataQueryIds.push(metaDataQueryId);
        }
        if (metaDataQueryMeaning) {
            request.MetaDataQueryMeanings.push(metaDataQueryMeaning);
        }
        if (request.MetaDataQueryIds.length == 0 && request.MetaDataQueryMeanings.length == 0) {
            request.MetaDataQueryIds.push(0);
        }
        return this.getSavedQueryMetaDataMulti([request])
            .pipe(map(results => {
            const queryMetaData = results[0]; //DwQueryMetaData
            this.fixQueryMetaData(queryMetaData);
            return queryMetaData;
        }));
    }
    getSavedQueryMetaDataMulti(requests) {
        if (!requests || requests.length === 0) {
            return of([]);
        }
        // const itemName = this.getDwItemName(item);
        const cacheKey = `queryMetaData.All`; // `queryMetaData.${itemName}`;
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataQuery));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItem));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttribute));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataLookup));
        // Get the cache queries for this item
        return this.cacheService.get(cacheKey, this.createQueryCacheItems(), null, cacheInvalidationTopics)
            .pipe(mergeMap((queryCacheItems) => {
            const missingRequestItems = [];
            const missingItemObservables = [];
            // Check to see which queries we already have cached
            const results = [];
            for (const requestItem of requests) {
                const missingQueryIds = [];
                const missingQueryMeanings = [];
                const missingQueries = [];
                requestItem.MetaDataQueryIds = requestItem.MetaDataQueryIds || [];
                requestItem.MetaDataQueryMeanings = requestItem.MetaDataQueryMeanings || [];
                requestItem.Queries = requestItem.Queries || [];
                if (requestItem.MetaDataQueryIds.length == 0 && requestItem.Queries.length == 0 && requestItem.MetaDataQueryMeanings.length == 0) {
                    requestItem.MetaDataQueryIds.push(0);
                }
                // const itemName = this.getDwItemName(requestItem.ItemName)
                let queryCacheItem = queryCacheItems.find(ci => ci.itemName === requestItem.ItemName);
                if (!queryCacheItem) {
                    queryCacheItem = {
                        itemName: requestItem.ItemName,
                        queryMetaData: []
                    };
                    queryCacheItems.push(queryCacheItem);
                }
                for (const queryId of requestItem.MetaDataQueryIds || []) {
                    let queryMetaData = queryCacheItem.queryMetaData.find(qi => qi.MetaDataQueryId == queryId);
                    if (queryMetaData) {
                        queryMetaData = this.fixQueryMetaData(queryMetaData);
                        results.push(queryMetaData);
                    }
                    else {
                        if (queryCacheItem.inFlightObservable) {
                            missingItemObservables.push(queryCacheItem.inFlightObservable);
                        }
                        missingQueryIds.push(queryId);
                    }
                }
                for (const queryMeaning of requestItem.MetaDataQueryMeanings || []) {
                    let queryMetaData = queryCacheItem.queryMetaData.find(qi => qi.QueryMeaning == queryMeaning);
                    if (queryMetaData) {
                        queryMetaData = this.fixQueryMetaData(queryMetaData);
                        results.push(queryMetaData);
                    }
                    else {
                        if (queryCacheItem.inFlightObservable) {
                            missingItemObservables.push(queryCacheItem.inFlightObservable);
                        }
                        missingQueryMeanings.push(queryMeaning);
                    }
                }
                for (const query of requestItem.Queries || []) {
                    // Never cache query metadata, since it could be a dynamic query
                    let queryMetaData = queryCacheItem.queryMetaData.find(qi => qi.UniqueIdentifier == query.UniqueIdentifier);
                    if (queryMetaData) {
                        if (!areEqual(queryMetaData.DataQuery, query.Query)) {
                            missingQueries.push(query);
                        }
                        else {
                            queryMetaData = this.fixQueryMetaData(queryMetaData);
                            results.push(queryMetaData);
                        }
                    }
                    else {
                        missingQueries.push(query);
                    }
                }
                if (missingQueryIds.length > 0 || missingQueryMeanings.length > 0 || missingQueries.length > 0) {
                    missingRequestItems.push({
                        ItemName: requestItem.ItemName,
                        MetaDataQueryIds: missingQueryIds,
                        MetaDataQueryMeanings: missingQueryMeanings,
                        Queries: missingQueries
                    });
                }
            }
            if (missingRequestItems.length === 0) {
                return of(results);
            }
            // If we're already loading some of these items, wait for them for finish, then try again
            //  if the existing api calls didn't include the specific item needed, it will then make another api call
            if (missingItemObservables.length != 0) {
                return combineLatest(missingItemObservables)
                    .pipe(mergeMap(allResults => {
                    return this.getSavedQueryMetaDataMulti(requests);
                }));
            }
            const subject = new Subject();
            // Add Subject to all items with missing requests
            for (const missingRequest of missingRequestItems) {
                let queryCacheItem = queryCacheItems.find(ci => ci.itemName === missingRequest.ItemName);
                if (queryCacheItem) {
                    queryCacheItem.inFlightObservable = subject.asObservable();
                }
            }
            this.cacheService.set(cacheKey, queryCacheItems, null, cacheInvalidationTopics);
            // Loads only the missing query ids
            this.loadSavedQueryMetaDataMulti(missingRequestItems)
                .subscribe(loadedQueryMetaData => {
                loadedQueryMetaData.forEach(queryMetaData => {
                    queryMetaData = this.fixQueryMetaData(queryMetaData);
                    const queryCacheItem = queryCacheItems.find(ci => ci.itemName === queryMetaData.RootItem);
                    if (queryCacheItem) {
                        queryCacheItem.inFlightObservable = null;
                        queryCacheItem.queryMetaData.push(queryMetaData);
                    }
                    else {
                        console.warn(`DwMeatDataService.getSavedQueryMetaDataMulti - can't locate cache item for table queryMetaData ${queryMetaData.RootItem}.  Make sure the query is for the same table as the grid`);
                    }
                    results.push(queryMetaData);
                });
                this.cacheService.set(cacheKey, queryCacheItems, null, cacheInvalidationTopics);
                subject.next(results);
            });
            return subject.asObservable();
        }));
    }
    /**
     * Fixes the Query returned to be a DwQuery class instance instead of just a plain object (also clones it so changes to it aren't cached)
     * @param queryMetaData
     * @returns
     */
    fixQueryMetaData(queryMetaData) {
        if (!queryMetaData) {
            return;
        }
        const qh = new DwQueryHelper();
        const newQueryMetaData = Object.assign({}, queryMetaData);
        // this only cloned the lower level properties, not the entire query so filters would be saved in cache (very bad!)
        //queryMetaData.DataQuery = Object.assign(new DwQuery(queryMetaData.DataQuery.RootTable), queryMetaData.DataQuery);
        newQueryMetaData.DataQuery = qh.cloneQuery(queryMetaData.DataQuery);
        return newQueryMetaData;
    }
    /// Get a key value from an entity
    /**
     * Get the key value for any entity even if it doesn't have a _keyName value
     * @param data data item
     * @param itemName item name
     * @returns Observable with the key value
     */
    getKeyValue(data, itemName) {
        if (!data || !itemName) {
            return of(null);
        }
        if (data._keyName) {
            const ormData = data;
            return of(ormData[ormData._keyName]);
        }
        return this.getMetaData(itemName)
            .pipe(map(item => {
            if (!item) {
                return null;
            }
            let keyName = item.Attributes.find(a => a.IsKey).AttributeName;
            return data[keyName];
        }));
    }
    createQueryCacheItems() {
        return of([]);
    }
    // private loadMetaDataQueries() {
    //     const dwMd = new DevwareMetaDataService();
    //     const qh = new DwQueryHelper();
    //     const query = dwMd.DwMetaDataQuery.CreateQuery()
    //     query.IncludeSharedData = true;
    //     return this.ormDataService.executeQuery(query);
    // }
    // private loadSavedQueryMetaData(itemName: DwItemType, metaDataQueryId: number): Observable<DwQueryMetaData> {
    //     let url = `${this.apiRoot}/metadata/${itemName}/${metaDataQueryId}`;
    //     return this.http.get<DwQueryMetaData>(url)
    //         .pipe(map((r: any) => {
    //             return r;
    //         }));
    // }
    loadSavedQueryMetaDataMulti(requests) {
        let url = `${this.apiRoot}/metadata/advanced/multi`;
        return this.http.post(url, requests)
            .pipe(map((r) => {
            return r;
        }));
    }
    /**
     * Get Security for the given item
     */
    getUserMetaDataItemSecurity(item) {
        const itemName = item;
        if (!item) {
            return of({
                CanCreate: false,
                CanDelete: false,
                CanRead: false,
                CanUpdate: false,
                ItemName: 'Missing Item',
                MetaDataItemId: -1
            });
        }
        return this.getUserMetaDataSecurity()
            .pipe(map(userMdSecurity => {
            let itemRec = userMdSecurity.Items.find(i => i.ItemName.toLowerCase() === itemName.toLowerCase());
            if (!itemRec) {
                itemRec = {
                    ItemName: itemName,
                    MetaDataItemId: -1,
                    CanCreate: userMdSecurity.CanCreateAny,
                    CanRead: userMdSecurity.CanReadAny,
                    CanUpdate: userMdSecurity.CanUpdateAny,
                    CanDelete: userMdSecurity.CanDeleteAny
                };
            }
            return itemRec;
        }));
    }
    /**
     * Get a user's security for all MD Items
     */
    getUserMetaDataSecurity() {
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwSecurityTopics.SECURITY_CHANGED);
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataSecurityGroup));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataSecurityGroupAttribute));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwUserRole));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwRole));
        return this.cacheService.get("userMetaDataSecurity", this.loadUserMetaDataSecurity(), null, cacheInvalidationTopics);
        // return this.loadUserMetaDataSecurity();
    }
    loadUserMetaDataSecurity() {
        let url = `${this.apiRoot}/security/metadata`;
        return this.http.get(url, {})
            .pipe(map((r) => {
            return r;
        }));
    }
    /**
     * Returns all attributes available for a lookup
     */
    getLookupDefAttributes(lookupIdOrMeaning) {
        return this.getLookupDefinition(lookupIdOrMeaning)
            .pipe(mergeMap((lookupDef) => {
            return this.getMetaData(lookupDef.UniqueItemName)
                .pipe(map((lookupItemMetaData) => {
                lookupItemMetaData;
                const lookupAttrs = [];
                lookupAttrs.push({
                    AttributeName: "Id",
                    AttributeType: DwAttributeType.Integer,
                    Display: "Id"
                });
                lookupAttrs.push({
                    AttributeName: "Display",
                    AttributeType: DwAttributeType.Text,
                    Display: "Display"
                });
                // Add only the attributes that are available
                this.addLookupAttr(lookupAttrs, lookupItemMetaData, lookupDef.AdditionalAttribute1Id);
                this.addLookupAttr(lookupAttrs, lookupItemMetaData, lookupDef.AdditionalAttribute2Id);
                this.addLookupAttr(lookupAttrs, lookupItemMetaData, lookupDef.AdditionalAttribute3Id);
                this.addLookupAttr(lookupAttrs, lookupItemMetaData, lookupDef.AdditionalAttribute4Id);
                this.addLookupAttr(lookupAttrs, lookupItemMetaData, lookupDef.AdditionalAttribute5Id);
                this.addLookupAttr(lookupAttrs, lookupItemMetaData, lookupDef.GroupByAttributeId);
                return lookupAttrs;
            }));
        }));
    }
    addLookupAttr(lookupAttrs, lookupItemMetaData, attrId) {
        if (!attrId) {
            return;
        }
        var attr = findWhere(lookupItemMetaData.Attributes, { MetaDataAttributeId: attrId });
        if (attr) {
            lookupAttrs.push(attr);
        }
    }
    getLookupDefinitions() {
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataLookup));
        return this.cacheService.get("lookupDefinitions", this.loadLookupDefinitions(), null, cacheInvalidationTopics);
    }
    getWorkflowStatuses() {
        const query = DevwareMetaData.DwWorkflowStatusDetail.CreateQuery();
        return this.ormDataService.executeQuery(query);
    }
    loadLookupDefinitions() {
        const md = new DevwareMetaDataService();
        const qh = new DwQueryHelper();
        var query = md.DwMetaDataLookup.CreateQuery();
        query.IncludeSharedData = true;
        query.getFieldSettings().IncludeRootItemFields = false;
        query.getFieldSettings().LoadAllLookupDisplayFields = false;
        query.AddField(md.DwMetaDataLookup.MetaDataLookupId);
        query.AddField(md.DwMetaDataLookup.LookupMeaning);
        query.AddField(md.DwMetaDataLookup.MetaDataItemId);
        query.AddField(md.DwMetaDataItem.UniqueItemName);
        query.AddField(md.DwMetaDataLookup.HasTransitions);
        query.AddField(md.DwMetaDataLookup.TransitionReferenceAttribute1Id);
        query.AddField(md.DwMetaDataLookup.TransitionReferenceAttribute2Id);
        query.AddField(md.DwMetaDataLookup.IsDefault);
        query.AddField(md.DwMetaDataLookup.AdditionalAttribute1Id);
        query.AddField(md.DwMetaDataLookup.AdditionalAttribute2Id);
        query.AddField(md.DwMetaDataLookup.AdditionalAttribute3Id);
        query.AddField(md.DwMetaDataLookup.AdditionalAttribute4Id);
        query.AddField(md.DwMetaDataLookup.AdditionalAttribute5Id);
        query.AddField(md.DwMetaDataLookup.GroupByAttributeId);
        query.AddField(md.DwMetaDataLookup.GroupByTemplate);
        query.AddField(md.DwMetaDataLookup.MetaDataQueryId);
        query.AddPrefetchPath(md.DwMetaDataLookup.Relations.DwMetaDataLookupTransition);
        var relation = new DwQueryRelation();
        relation.RelationName = md.DwMetaDataLookup.Relations.DwMetaDataAttributeByGroupByAttributeId.RelationName;
        relation.JoinType = DwJoinType.LeftOuterJoin;
        const groupByAttributeNameField = new DwField();
        groupByAttributeNameField.FullFieldName = md.DwMetaDataAttribute.AttributeName;
        groupByAttributeNameField.FieldAlias = 'GroupByAttributeName';
        relation.RelationFields.push(groupByAttributeNameField);
        query.AddRelation(relation);
        let paramQuery = md.DwMetaDataLookupParam.CreateQuery();
        paramQuery.getFieldSettings().IncludeRootItemFields = false;
        paramQuery.AddField(md.DwMetaDataLookupParam.MetaDataLookupId);
        paramQuery.AddField(md.DwMetaDataLookupParam.DefaultValue);
        paramQuery.AddField(md.DwMetaDataLookupParam.IsRequired);
        paramQuery.AddField(md.DwMetaDataLookupParam.UseAttribute);
        paramQuery.AddField(md.DwMetaDataLookupParam.ParamNameOverride);
        paramQuery.AddField(md.DwMetaDataAttribute.AttributeName);
        query.AddPrefetchPath(md.DwMetaDataLookup.Relations.DwMetaDataLookupParam, paramQuery);
        //query.AddPrefetchPath(md.DwMetaDataLookup.Relations.)
        query.AddFilterAnd(qh.filters.NotEqual(md.DwMetaDataItem.MetaDataItemStatusId, this.META_DATA_STATUS_DELETED));
        return this.ormDataService.executeQuery(query);
    }
    getLookupDefinition(lookupIdOrMeaning) {
        let lookupId = -1;
        if (typeof (lookupIdOrMeaning) === 'string') {
            lookupId = parseInt(lookupIdOrMeaning);
        }
        else {
            lookupId = lookupIdOrMeaning;
        }
        return this.getLookupDefinitions()
            .pipe(map(lookupDefs => {
            // let lookupDef = _.findWhere(lookupDefs, { MetaDataLookupId: lookupId });
            let lookupDef;
            if (lookupId > 0) {
                lookupDef = lookupDefs.find(ld => ld.MetaDataLookupId == lookupId);
            }
            else {
                lookupDef = lookupDefs.find(ld => ld.LookupMeaning == lookupIdOrMeaning);
            }
            return lookupDef;
        }));
    }
    getLookupCacheInvalidators(lookupId) {
        return this.getLookupDefinition(lookupId)
            .pipe(map(lookupDef => {
            const md = new DevwareMetaDataService();
            var cacheInvalidationTopics = [];
            cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataLookup));
            cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(lookupDef.UniqueItemName));
            cacheInvalidationTopics.push(DwSecurityTopics.SECURITY_CHANGED);
            return cacheInvalidationTopics;
        }));
    }
    getLookupDisplay(lookupId, value, params) {
        return this.getLookupItem(lookupId, value, params)
            .pipe(map((lookupItem) => {
            if (lookupItem) {
                return lookupItem.Display;
            }
            return '';
        }));
    }
    getItemLookupDisplay(itemId, value, params) {
        return this.getLookupDefinitions()
            .pipe(mergeMap(lookupDefs => {
            const lookupDefsForItem = lookupDefs.filter(ld => ld.MetaDataItemId == itemId);
            const lookupDef = lookupDefsForItem.find(ld => ld.IsDefault);
            if (!lookupDef) {
                console.warn(`Default Lookup Definition not found for item ${itemId}`);
                return of('');
            }
            return this.getLookupItem(lookupDef.MetaDataLookupId, value, params)
                .pipe(map((lookupItem) => {
                if (lookupItem) {
                    return lookupItem.Display;
                }
                return '';
            }));
        }));
    }
    getLookupItem(lookupId, value, params) {
        return this.getLookup(lookupId, params)
            .pipe(map((lookupItems) => {
            if (typeof (value) == 'number') {
                value = value.toString();
            }
            const lookupItem = lookupItems.find(li => li.Id === value);
            return lookupItem;
        }));
    }
    getSingleLookupItem(lookupId, keyValue, useParametersOnSingleLookup, queryParams) {
        let cacheKey = `lookup.${lookupId}`;
        if (queryParams) {
            var paramKeys = "";
            for (let param of queryParams) {
                paramKeys += `${param.ParamName}_${param.ParamValue}`;
            }
            cacheKey += "." + paramKeys;
        }
        cacheKey += ".keyValue_" + keyValue;
        let returnSubject = new Subject();
        let lookupClearedSubject = new Subject();
        lookupClearedSubject.asObservable()
            .subscribe(() => {
            this.publishLookupChangedEvent(lookupId);
        });
        // Get the cache invalidators for this lookup before caching it
        //   This adds the related table and the MetaDataLookup table as cache dependencies
        //   so a change in either table will clear the cache
        this.getLookupCacheInvalidators(lookupId)
            .subscribe((cacheInvalidations) => {
            this.cacheService.get(cacheKey, this.loadSingleLookupItem(lookupId, keyValue, useParametersOnSingleLookup, queryParams), null, cacheInvalidations, lookupClearedSubject)
                .subscribe(r => {
                setTimeout(() => {
                    returnSubject.next(r);
                });
            });
        });
        return returnSubject.asObservable();
    }
    getLookup(lookupId, queryParams) {
        let cacheKey = `lookup.${lookupId}`;
        if ((queryParams === null || queryParams === void 0 ? void 0 : queryParams.length) > 0) {
            var paramKeys = "";
            for (let param of queryParams) {
                paramKeys += `${param.ParamName}_${param.ParamValue}`;
            }
            cacheKey += "." + paramKeys;
        }
        let returnSubject = new Subject();
        let lookupClearedSubject = new Subject();
        lookupClearedSubject.asObservable()
            .subscribe(() => {
            this.publishLookupChangedEvent(lookupId);
        });
        // Get the cache invalidators for this lookup before caching it
        //   This adds the related table and the MetaDataLookup table as cache dependencies
        //   so a change in either table will clear the cache
        this.getLookupCacheInvalidators(lookupId)
            .subscribe((cacheInvalidations) => {
            this.cacheService.get(cacheKey, this.loadLookup(lookupId, queryParams), null, cacheInvalidations, lookupClearedSubject)
                .subscribe(r => {
                setTimeout(() => {
                    returnSubject.next(r);
                });
            });
        });
        return returnSubject.asObservable();
    }
    searchLookup(lookupId, searchParams, queryParams) {
        let url = `${this.apiRoot}/lookups/${lookupId}`;
        let params = [];
        this.convertQueryParams(params, queryParams);
        this.convertSearchParams(params, searchParams);
        url = `${url}?${params.join('&')}`;
        return this.http.get(url)
            .pipe(map((httpResult) => {
            let lookupItems = httpResult;
            this.mapLookupAttributes(lookupItems);
            return lookupItems;
        }), share());
    }
    testLookup(lookup, maxResults = 5, queryParams) {
        let url = `${this.apiRoot}/lookups/test`;
        let params = queryParams === null || queryParams === void 0 ? void 0 : queryParams.map(qp => `${qp.ParamName}=${qp.ParamValue}`);
        const testlookupOptions = {
            LookupDTO: lookup,
            MaxResults: maxResults,
            LookupOptions: {
                Params: params
            }
        };
        let headers = new HttpHeaders();
        headers = headers.append(SuppressErrorMessagesHeader, 'true');
        return this.http.post(url, testlookupOptions, { headers: headers }).pipe(map((httpResult) => {
            let lookupItems = httpResult;
            this.mapLookupAttributes(lookupItems);
            return lookupItems;
        }));
    }
    publishLookupChangedEvent(lookupId) {
        this.eventService.publishEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.LookupChanged(lookupId), lookupId);
        this.eventService.publishBroadcastMessage(DwMetaDataService.META_DATA_EVENT_TOPICS.LookupChanged(lookupId), lookupId);
    }
    convertQueryParams(params, queryParams) {
        if (!queryParams) {
            return;
        }
        for (let queryParam of queryParams) {
            params.push(`Params=${queryParam.ParamName}=${queryParam.ParamValue}`);
        }
    }
    convertSearchParams(params, searchParams) {
        if (!searchParams) {
            return;
        }
        if (searchParams.SearchString) {
            params.push(`searchString=${searchParams.SearchString}`);
        }
        if (searchParams.AlternateSearchField) {
            params.push(`alternateSearchField=${searchParams.AlternateSearchField}`);
        }
        if (searchParams.SearchType) {
            params.push(`searchType=${searchParams.SearchType}`);
        }
        if (searchParams.PagingInfo) {
            params.push(`page=${searchParams.PagingInfo.PageNo || 1}`);
            params.push(`pageSize=${searchParams.PagingInfo.PageSize || 50}`);
        }
    }
    loadLookup(lookupId, queryParams) {
        let url = `${this.apiRoot}/lookups/${lookupId}`;
        let params = [];
        this.convertQueryParams(params, queryParams);
        url = `${url}?${params.join('&')}`;
        return this.http.get(url)
            .pipe(map((httpResult) => {
            let lookupItems = httpResult;
            this.mapLookupAttributes(lookupItems);
            return lookupItems;
        }), share());
    }
    loadSingleLookupItem(lookupId, keyValue, useParametersOnSingleLookup, queryParams) {
        let url = `${this.apiRoot}/lookups/${lookupId}/${keyValue}`;
        let params = [];
        this.convertQueryParams(params, queryParams);
        if (useParametersOnSingleLookup) {
            params.push(`useParametersOnSingleLookup=true`);
        }
        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }
        return this.http.get(url)
            .pipe(map((httpResult) => {
            let lookupItem = httpResult;
            this.mapSingleLookupAttributes(lookupItem);
            return lookupItem;
        }), share());
    }
    mapLookupAttributes(lookupItems) {
        if (lookupItems.length == 0 || !lookupItems[0].Attributes || lookupItems[0].Attributes.length == 0) {
            return;
        }
        for (let lookupItem of lookupItems) {
            this.mapSingleLookupAttributes(lookupItem);
        }
    }
    mapSingleLookupAttributes(lookupItem) {
        if (!lookupItem) {
            return;
        }
        if (lookupItem.Attributes && lookupItem.Attributes.length > 0) {
            for (let attr of lookupItem.Attributes) {
                lookupItem[attr.AttrName] = this.getLookupAttrValue(attr);
            }
        }
    }
    getLookupAttrValue(attr) {
        switch (attr.AttrType) {
            case DwAttributeType.Integer:
            case DwAttributeType.LargeInteger:
            case DwAttributeType.Percentage:
            case DwAttributeType.Money:
                return parseFloat(attr.Value);
            case DwAttributeType.YesNo:
                if (attr.Value == '1' || attr.Value.toUpperCase() == 'TRUE')
                    return true;
                return false;
            default:
                return attr.Value;
        }
    }
    getDwItemName(item) {
        if (typeof (item) == "string")
            return item;
        if (!item) {
            return "";
        }
        return item.ItemDetail.ItemName;
    }
    getMetaData(item) {
        if (!item) {
            return of(null);
        }
        const cacheKey = `metaDeta.${this.getDwItemName(item)}`;
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItem));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttribute));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItemRelationship));
        return this.cacheService.get(cacheKey, this.loadMetaData(item), null, cacheInvalidationTopics);
    }
    getMetaDataItemName(itemId) {
        if (!itemId) {
            return of(null);
        }
        // Force the value to be a number
        var itemKey = itemId.toString();
        return this.getLookup(DevwareMetaDataLookups.MetaDataItemAllItems)
            .pipe(map((lookupItems) => {
            const item = lookupItems.find(li => li.Id === itemKey);
            if (item) {
                return item.UniqueItemName;
            }
            return "Not Found";
        }));
    }
    getMetaDataByItemId(itemId) {
        return this.getMetaDataItemName(itemId)
            .pipe(mergeMap(itemName => {
            if (!itemName || itemName == "Not Found") {
                return of(null);
            }
            return this.getMetaData(itemName);
        }));
    }
    getMetaDataItemId(itemName) {
        if (!itemName) {
            return of(null);
        }
        return this.getLookup(DevwareMetaDataLookups.MetaDataItemAllItems)
            .pipe(map((lookupItems) => {
            const item = lookupItems.find(li => li.UniqueItemName === itemName);
            if (item) {
                return parseInt(item.Id);
            }
            return null;
        }));
    }
    getMetaDataList(itemNames) {
        let obs = [];
        if (!itemNames || itemNames.length === 0) {
            return of({});
        }
        for (let itemName of itemNames) {
            if (itemName) {
                obs.push(this.getMetaData(itemName));
            }
        }
        if (obs.length === 0) {
            return of({});
        }
        // Combine thes all into one function
        var combined = forkJoin(obs);
        return combined.pipe(map((mdItems) => {
            let metaDataItems = {};
            for (let mdItem of mdItems) {
                if (mdItem) {
                    metaDataItems[mdItem.UniqueItemName] = mdItem;
                }
            }
            return metaDataItems;
        }));
    }
    loadMetaData(item) {
        let itemName = this.getDwItemName(item);
        let url = `${this.apiRoot}/metadata/item/${itemName}`;
        return this.http.get(url)
            .pipe(map((httpResult) => {
            return httpResult;
        }), share());
    }
    getMetaDataComparers() {
        return this.cacheService.get("metaDataComparer", this.loadMetaDataComparers());
    }
    loadMetaDataComparers() {
        let metaData = new DevwareMetaDataService();
        var query = new DwQuery(DevwareMetaDataItemNames.DwMetaDataComparer);
        query.IncludeSharedData = true;
        // Turn this own to help debuging since it will include the attribute type name and comparer name in the map
        query.getFieldSettings().LoadAllLookupDisplayFields = true;
        query.AddPrefetchPath(metaData.DwMetaDataComparer.Relations.DwMetaDataAttributeTypeComparerMap);
        return this.ormDataService.executeQuery(query);
    }
    getAttributeTypes() {
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttributeType));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttributeTypeControlTypeMap));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttributeTypeComparerMap));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataComparer));
        return this.cacheService.get("metaDataAttributeTypes", this.loadAttributeTypes(), null, cacheInvalidationTopics);
    }
    loadAttributeTypes() {
        let dwMd = new DevwareMetaDataService();
        var query = new DwQuery(DevwareMetaDataItemNames.DwMetaDataAttributeType);
        query.IncludeSharedData = true;
        const controlMapQuery = dwMd.DwMetaDataAttributeTypeControlTypeMap.CreateQuery();
        controlMapQuery.getFieldSettings().LoadAllLookupDisplayFields = true;
        controlMapQuery.AddPrefetchPath(dwMd.DwMetaDataAttributeTypeControlTypeMap.Relations.DwMetaDataControlType);
        query.AddPrefetchPath(dwMd.DwMetaDataAttributeType.Relations.DwMetaDataAttributeTypeControlTypeMap, controlMapQuery);
        const comparerMapQuery = dwMd.DwMetaDataAttributeTypeComparerMap.CreateQuery();
        comparerMapQuery.getFieldSettings().LoadAllLookupDisplayFields = true;
        const comparerQuery = dwMd.DwMetaDataComparer.CreateQuery();
        comparerQuery.getFieldSettings().LoadAllLookupDisplayFields = true;
        comparerMapQuery.AddPrefetchPath(dwMd.DwMetaDataAttributeTypeComparerMap.Relations.DwMetaDataComparer, comparerQuery);
        query.AddPrefetchPath(dwMd.DwMetaDataAttributeType.Relations.DwMetaDataAttributeTypeComparerMap, comparerMapQuery);
        return this.ormDataService.executeQuery(query);
    }
    getAssociativeRelationConfig(associativeItem, parentItem, lookupAttributeName, lookupConfig, loadLookupValues = true) {
        const cacheKey = `associativeRelationConfig.${this.getDwItemName(associativeItem)}_${this.getDwItemName(parentItem)}_${loadLookupValues}`;
        const md = new DevwareMetaDataService();
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItem));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttribute));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItemRelationship));
        // Cache config but load lookup values each time since they have a different cache invalidation cycle (this caused permissions to remain cached even after they were updated)
        return this.cacheService.get(cacheKey, this.buildAssociativeRelationConfig(associativeItem, parentItem, lookupAttributeName, lookupConfig), null, cacheInvalidationTopics)
            .pipe(mergeMap(config => {
            var _a, _b;
            // Check if it has parameters and if it does, don't load the lookup values
            config.hasLookupParameters = ((_b = (_a = config.lookupDefinition) === null || _a === void 0 ? void 0 : _a.DwMetaDataLookupParam) === null || _b === void 0 ? void 0 : _b.length) > 0;
            if (loadLookupValues && config.lookupId && !config.hasLookupParameters) {
                return this.loadLookup(config.lookupId)
                    .pipe(map(lookupValues => {
                    config.lookupValues = lookupValues;
                    return config;
                }));
            }
            return of(config);
        }));
    }
    buildAssociativeRelationConfig(associativeItem, parentItem, lookupAttributeName, lookupConfig) {
        if (!associativeItem || !parentItem) {
            console.warn(`Can't load Associative Relation config because associativeItem or parent item were missing.  Please check the configuration!`, { associtiveItem: associativeItem, parentItem: parentItem });
            return of(null);
        }
        //let returnSubject = new Subject<DwAssocativeRelationConfig>();
        return this.getMetaData(associativeItem)
            .pipe(mergeMap(aiMetaData => {
            var _a;
            let config = new DwAssocativeRelationConfig();
            // Determine PK Name
            let pkAttr = aiMetaData.Attributes.find(a => a.IsKey); //_.findWhere(aiMetaData.Attributes, { IsKey: true });
            if (pkAttr)
                config.pkAttributeName = pkAttr.AttributeName;
            // If an attribute is provided, then check if the field exists
            config.associativeFkAttributeName = lookupAttributeName;
            if (!config.associativeFkAttributeName) {
                // if we don't have an attribute, then we guess by using the first lookup that's not an FK back to the parent
                let associativeRelation = this.findAssociativeRelation(aiMetaData, parentItem);
                if (associativeRelation == null) {
                    const message = `No Associative Relation found for item ${aiMetaData.UniqueItemName} using a parent of ${this.getDwItemName(parentItem)}`;
                    config.errorMessage = message;
                    return of(config);
                }
                config.associativeFkAttributeName = associativeRelation.FkAttributeName;
            }
            // Find lookup field name attribute to obtain the lookupId
            let lookupAttr = aiMetaData.Attributes.find(a => a.AttributeName == config.associativeFkAttributeName); // _.findWhere(aiMetaData.Attributes, { AttributeName: config.associativeFkAttributeName });
            if (lookupAttr == null || lookupAttr.MetaDataLookupId == null) {
                const message = `No lookup attribute found for item ${aiMetaData.UniqueItemName} and field ${config.associativeFkAttributeName} using a parent of ${this.getDwItemName(parentItem)}`;
                config.errorMessage = message;
                return of(config);
            }
            config.lookupId = lookupAttr.MetaDataLookupId;
            if ((lookupConfig === null || lookupConfig === void 0 ? void 0 : lookupConfig.useLookupOverride) && ((_a = lookupConfig.lookupIdOverride) === null || _a === void 0 ? void 0 : _a.value)) {
                config.lookupId = parseInt(lookupConfig.lookupIdOverride.value);
            }
            return this.getLookupDefinition(config.lookupId)
                .pipe(map((lookupDefinition) => {
                config.lookupDefinition = lookupDefinition;
                return config;
            }));
        }));
    }
    findAssociativeRelation(associativeItemMetaData, parentItemName) {
        for (let relation of associativeItemMetaData.Relations) {
            if (relation.PkUniqueItemName != this.getDwItemName(parentItemName) && relation.PkUniqueItemName != "dw_Tenant") {
                return relation;
            }
        }
        return null;
    }
    getAttributeFormatOptions(attribute, use24HourTimeDefault, useGmtDateTimeDefault) {
        let formatOptions = {
            formatType: this.getFormatType(attribute),
            use24HourTime: use24HourTimeDefault,
        };
        if ((attribute === null || attribute === void 0 ? void 0 : attribute.UseGmtDateTime) === true || (attribute === null || attribute === void 0 ? void 0 : attribute.UseGmtDateTime) === false) {
            formatOptions.useGmtDateTime = attribute === null || attribute === void 0 ? void 0 : attribute.UseGmtDateTime;
        }
        else {
            formatOptions.useGmtDateTime = useGmtDateTimeDefault;
        }
        return formatOptions;
    }
    getFormatType(attribute) {
        switch (attribute === null || attribute === void 0 ? void 0 : attribute.AttributeType) {
            case DwAttributeType.Date:
                return DwFormatTypes.date;
            case DwAttributeType.DateTime:
                return DwFormatTypes.datetime;
            case DwAttributeType.YesNo:
                return DwFormatTypes.yesNo;
            case DwAttributeType.Integer:
            case DwAttributeType.LargeInteger:
                return DwFormatTypes.number;
            case DwAttributeType.Percentage:
                return DwFormatTypes.percent;
            case DwAttributeType.Money:
                return DwFormatTypes.currency;
            case DwAttributeType.Text:
            case DwAttributeType.Memo:
            default:
                return DwFormatTypes.text;
        }
    }
}
DwMetaDataService.ɵfac = function DwMetaDataService_Factory(t) { return new (t || DwMetaDataService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwEventService), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwAppInitService)); };
DwMetaDataService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataService, factory: DwMetaDataService.ɵfac });
DwMetaDataService.META_DATA_EVENT_TOPICS = {
    LookupChanged(lookupId) {
        return `MetaDataEvent.LookupChanged.${lookupId}`;
    },
    MetaDataUpdated: "MetaDataEvent.MetaDataUpdated"
};
DwMetaDataService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwEventService },
    { type: DwCacheService },
    { type: DwAppInitService }
];

class DwDefaultGridPage {
    constructor(route, router, dwMetaDataService) {
        this.route = route;
        this.router = router;
        this.dwMetaDataService = dwMetaDataService;
        this.textboxControlType = DwControlType.Textbox;
    }
    get configKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}`;
        return `${itemName}-${this.configKeyPart}-defaultGrid`;
    }
    get contentConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}-grid`;
        return `${itemName}-${this.configKeyPart}-defaultGrid`;
    }
    ngOnInit() {
        this.routeMenuData = this.getRouteMenueData(this.route);
        this.configKeyPart = this.routeMenuData.configKeyPart;
        // Setup item name parameter
        this.route.paramMap.subscribe((params) => {
            let itemName = params.get('itemName');
            if (!itemName) {
                itemName = this.routeMenuData.metaDataItem;
            }
            if (itemName)
                this.item = itemName;
        });
    }
    getRouteMenueData(route) {
        if (route.snapshot.routeConfig) {
            var routeConfig = route.snapshot.routeConfig;
            const dwMenuData = this.route.snapshot.data;
            if (dwMenuData) {
                return dwMenuData;
            }
        }
        return new DwMenuData;
    }
}
DwDefaultGridPage.ɵfac = function DwDefaultGridPage_Factory(t) { return new (t || DwDefaultGridPage)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwDefaultGridPage.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDefaultGridPage, selectors: [["dw-default-grid"]], inputs: { item: "item", gridPreferences: "gridPreferences" }, decls: 2, vars: 0, consts: [[3, "configKey", "item"], ["name", "title", "display", "Page Title", 3, "controlType"], ["name", "detail", "display", "Header Details"], ["name", "component", "display", "Custom Component"], [3, "id"], [3, "item", "configKeyPart", "preferences"]], template: function DwDefaultGridPage_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-router-parent");
        ɵngcc0.ɵɵtemplate(1, DwDefaultGridPage_ng_template_1_Template, 7, 7, "ng-template");
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DwRouterParentComponent, DwContentManagerComponent, DwContentDirective, DwContentComponent, DwMetaDataGridComponent]; }, encapsulation: 2 });
DwDefaultGridPage.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwDefaultGridPage.propDecorators = {
    item: [{ type: Input }],
    gridPreferences: [{ type: Input }]
};

class DwMetaDataFormPreferences extends DwUiPreferencesBase {
    constructor() {
        super(DwUiConfigType.form);
        this.useValidationSummary = true;
    }
}

class DwModalResult {
}

// Values are from the table devware.UiConfigTypeId
class DwModalConfig {
    constructor() {
        this.cloneData = true;
    }
}
// export type Omit<DwModalConfig, 'data'>;
// //actionDef: Omit<DwActionHandlerRegistration<ActionConfigType>, 'actionComponent'>

var DwButtonType;
(function (DwButtonType) {
    DwButtonType["standard"] = "standard";
    DwButtonType["iconOnly"] = "iconOnly";
    DwButtonType["iconOnlyNoText"] = "iconOnlyNoText";
    DwButtonType["link"] = "link";
})(DwButtonType || (DwButtonType = {}));

// Values are from the table devware.UiConfigTypeId
class DwButtonConfig {
    constructor() {
        this.buttonType = DwButtonType.standard;
        this.isCancel = false;
        this.disabled = false;
        this.hidden = false;
    }
}

// Values are from the table devware.UiConfigTypeId
// Values are from the table devware.UiConfigTypeId
var DwButtonCommand;
(function (DwButtonCommand) {
    DwButtonCommand["save"] = "save";
    DwButtonCommand["saveAndClose"] = "saveAndClose";
    DwButtonCommand["cancel"] = "cancel";
    DwButtonCommand["other"] = "other";
    DwButtonCommand["ok"] = "ok";
    DwButtonCommand["edit"] = "edit";
    DwButtonCommand["delete"] = "delete";
    DwButtonCommand["add"] = "add";
    DwButtonCommand["yes"] = "yes";
    DwButtonCommand["no"] = "no";
    DwButtonCommand["view"] = "view";
})(DwButtonCommand || (DwButtonCommand = {}));

class DwModalButtonStandardConfigs {
    constructor() {
    }
    get saveButton() {
        var buttonConfig = new DwButtonConfig();
        buttonConfig.buttonClass = "btn btn-success";
        buttonConfig.buttonText = "Save";
        buttonConfig.command = DwButtonCommand.saveAndClose;
        return buttonConfig;
    }
    get cancelButton() {
        var buttonConfig = new DwButtonConfig();
        buttonConfig.buttonClass = "btn btn-danger";
        buttonConfig.buttonText = "Cancel";
        buttonConfig.command = DwButtonCommand.cancel;
        buttonConfig.isCancel = true;
        return buttonConfig;
    }
    get closeButton() {
        var buttonConfig = new DwButtonConfig();
        buttonConfig.buttonClass = "btn btn-danger";
        buttonConfig.buttonText = "Close";
        buttonConfig.command = DwButtonCommand.cancel;
        buttonConfig.isCancel = true;
        return buttonConfig;
    }
    get okButton() {
        var buttonConfig = new DwButtonConfig();
        buttonConfig.buttonClass = "btn btn-success";
        buttonConfig.buttonText = "Ok";
        buttonConfig.command = DwButtonCommand.saveAndClose;
        return buttonConfig;
    }
    get yesButton() {
        var buttonConfig = new DwButtonConfig();
        buttonConfig.buttonClass = "btn btn-success";
        buttonConfig.buttonText = "Yes";
        buttonConfig.command = DwButtonCommand.yes;
        return buttonConfig;
    }
    get noButton() {
        var buttonConfig = new DwButtonConfig();
        buttonConfig.buttonClass = "btn btn-danger";
        buttonConfig.buttonText = "No";
        buttonConfig.command = DwButtonCommand.no;
        buttonConfig.isCancel = true;
        return buttonConfig;
    }
    get SaveAndCancel() {
        return [this.saveButton, this.cancelButton];
    }
    get SaveAndClose() {
        return [this.saveButton, this.closeButton];
    }
    get okAndClose() {
        return [this.okButton, this.closeButton];
    }
    get YesOrNo() {
        return [this.yesButton, this.noButton];
    }
}
// Had to do it this way for AOT and creating a module
DwModalButtonStandardConfigs.instance = new DwModalButtonStandardConfigs();

var DwModalSize;
(function (DwModalSize) {
    DwModalSize["small"] = "small";
    DwModalSize["medium"] = "medium";
    DwModalSize["large"] = "large";
    DwModalSize["extraLarge"] = "extraLarge";
    DwModalSize["fullScreen"] = "fullScreen";
    DwModalSize["responsive"] = "responsive";
    DwModalSize["custom"] = "custom";
})(DwModalSize || (DwModalSize = {}));
/**
 * Returns a style for the modal dialog based on the given DwModalSize
 * **/
function getModalStyle(modalSize, customWidth, customHeight) {
    var returnSize = {
        width: "",
        height: ""
    };
    switch (modalSize) {
        case DwModalSize.small:
            returnSize.width = "400px";
            returnSize.height = "200px";
            break;
        case DwModalSize.medium:
            returnSize.width = "600px";
            returnSize.height = "400px";
            break;
        case DwModalSize.large:
            returnSize.width = "1000px";
            returnSize.height = "600px";
            break;
        case DwModalSize.extraLarge:
            returnSize.width = "1200px";
            returnSize.height = "800px";
            break;
        case DwModalSize.fullScreen:
            returnSize.width = "100%";
            returnSize.height = "100%";
            break;
        case DwModalSize.responsive:
            break;
        case DwModalSize.custom:
            returnSize.width = customWidth;
            returnSize.height = customHeight;
            break;
    }
    return returnSize;
}
function getModalBodyStyle(modalSize, customWidth, customHeight) {
    var bodyStyle = getModalStyle(modalSize, customWidth, customHeight);
    let height = parseInt(bodyStyle.height.replace('px', ''));
    if (height) {
        height -= 155;
        return {
            height: `${height}px`
        };
    }
}

const MODAL_EVENT_OPEN = 'modal-open';
const MODAL_EVENT_CLOSE = 'modal-close';
class DwModalService {
    constructor(dwEventService) {
        this.dwEventService = dwEventService;
        this.modalConfigs = [];
        this.modalConfigsSubject = new BehaviorSubject([]);
    }
    showModal(modalConfig) {
        modalConfig.closeSubject = new Subject();
        if (modalConfig.cloneData && modalConfig.data) {
            try {
                modalConfig.data = deepCopy(modalConfig.data, true);
            }
            catch (e) {
                throw new Error("Data cannot be cloned, consider setting modalConfig.cloneData to false. " + e.message);
            }
        }
        this.modalConfigs.push(modalConfig);
        this.modalConfigsSubject.next(this.modalConfigs);
        this.dwEventService.publishEvent(MODAL_EVENT_OPEN, this.modalConfigs);
        return modalConfig.closeSubject.asObservable();
    }
    closeModal(modalConfig, result) {
        let index = this.modalConfigs.indexOf(modalConfig);
        this.modalConfigs.splice(index, 1);
        this.dwEventService.publishEvent(MODAL_EVENT_CLOSE, modalConfig);
        modalConfig.closeSubject.next(result);
    }
    getModalConfigs() {
        return this.modalConfigsSubject.asObservable();
    }
    showDialog(title, message, buttonConfig) {
        let modalConfig = new DwModalConfig();
        modalConfig.title = title;
        modalConfig.content = message;
        modalConfig.modalSize = DwModalSize.responsive;
        if (buttonConfig)
            modalConfig.buttons = buttonConfig;
        else
            modalConfig.buttons = DwModalButtonStandardConfigs.instance.YesOrNo;
        return this.showModal(modalConfig);
    }
    showConfirmDialog(configDialogConfig) {
        if (!configDialogConfig || !configDialogConfig.showConfirmDialog) {
            return of(true);
        }
        return this.showDialog(configDialogConfig.title, configDialogConfig.message, DwModalButtonStandardConfigs.instance.YesOrNo)
            .pipe(map(modalResult => {
            return modalResult.buttonCommand == DwButtonCommand.yes;
        }));
    }
}
DwModalService.ɵfac = function DwModalService_Factory(t) { return new (t || DwModalService)(ɵngcc0.ɵɵinject(DwEventService)); };
DwModalService.ɵprov = ɵɵdefineInjectable({ factory: function DwModalService_Factory() { return new DwModalService(ɵɵinject(DwEventService)); }, token: DwModalService, providedIn: "root" });
DwModalService.ctorParameters = () => [
    { type: DwEventService }
];

// Values are from the table devware.UiConfigTypeId
class DwUiConfigData {
}

class DwUiPreferencesHierarchyBase {
}
class DwUiPreferencesHierarchy extends DwUiPreferencesHierarchyBase {
}

class DwUiConfigRegistryService {
    constructor() {
    }
    static addUiConfigInit(decoratorInfo) {
        DwUiConfigRegistryService.initSources.push(decoratorInfo);
    }
    static logRegistrations() {
        // console.log('General Registration', DwUiConfigRegistryService.generalRegistry);
        // console.log('Components', DwUiConfigRegistryService.components);
        // console.log('Datasources', DwUiConfigRegistryService.datasources);
    }
    getGeneralRegistryMap(name) {
        let map = DwUiConfigRegistryService.generalRegistry.get(name);
        if (!map) {
            map = new Map();
            DwUiConfigRegistryService.generalRegistry.set(name, map);
        }
        return map;
    }
    registerItem(itemType, item) {
        if (!item) {
            return;
        }
        const map = this.getGeneralRegistryMap(itemType);
        map.set(item.keyName, item);
    }
    getRegisteredItems(itemType, order = true) {
        const map = this.getGeneralRegistryMap(itemType);
        const items = [];
        map.forEach(item => {
            items.push(item);
        });
        if (order) {
            return sortArrayByField(items, 'order', 'display');
        }
        return items;
    }
    getRegisteredItem(itemType, keyName) {
        const map = this.getGeneralRegistryMap(itemType);
        if (!keyName) {
            keyName = '';
        }
        return map.get(keyName);
    }
    getMdRegisteredItems(itemType, itemName, isMatch, order = true) {
        const allItems = this.getRegisteredItems(itemType, order);
        const filteredItems = allItems.filter(item => this.isMdRegistryItemMatch(item, itemName, isMatch));
        return filteredItems;
    }
    isMdRegistryItemMatch(item, itemName, isMatch) {
        if (!item.isGlobal && item.parentItemName && itemName) {
            if (typeof (item.parentItemName) == 'string' || Array.isArray(item.parentItemName)) {
                const parentItems = Array.isArray(item.parentItemName) ? item.parentItemName : [item.parentItemName || ''];
                if (parentItems.indexOf(itemName) == -1) {
                    return false;
                }
            }
            else {
                // parentItemName is a function, so call it with a try/catch
                if (item.parentItemName) {
                    try {
                        if (!item.parentItemName(itemName)) {
                            return false;
                        }
                    }
                    catch (e) {
                        console.error(`Error running parentItemName function for registry item ${item.keyName}`);
                        return false;
                    }
                }
            }
        }
        if (isMatch) {
            return isMatch(item);
        }
        return true;
    }
    registerConfig(configKey, preferences) {
        const finalKey = this.buildKey(configKey, preferences.UiConfigType);
        DwUiConfigRegistryService.registrations.set(finalKey, preferences);
    }
    getRegisteredConfig(configKey, configType) {
        const finalKey = this.buildKey(configKey, configType);
        return DwUiConfigRegistryService.registrations.get(finalKey);
    }
    buildKey(configKey, configType) {
        const finalKey = `${configKey}_${configType}`;
        return finalKey.toLowerCase();
    }
    registerDataSource(dataSourceReference) {
        if (!dataSourceReference) {
            return;
        }
        DwUiConfigRegistryService.datasources.set(dataSourceReference.keyName, dataSourceReference);
    }
    getRegisteredDataSources(itemName, includeDefault = false) {
        const results = [];
        if (includeDefault) {
            results.push({
                display: 'Default',
                dataSourceService: null,
                itemName: '',
                keyName: null,
            });
        }
        DwUiConfigRegistryService.datasources.forEach(dataSourceReference => {
            if (!itemName || dataSourceReference.itemName == itemName) {
                results.push(dataSourceReference);
            }
        });
        return results;
    }
    getDataSourceRegistration(keyName) {
        const dataSourceRegistration = DwUiConfigRegistryService.datasources.get(keyName);
        return dataSourceRegistration;
        /*    if (dataSourceRegistration && dataSourceRegistration.dataSourceService) {
               return this.
               return dataSourceRegistration.dataSource;
           }
   
           return null; */
    }
    registerComponent(componentReference) {
        if (!componentReference) {
            return;
        }
        DwUiConfigRegistryService.components.set(componentReference.key, componentReference);
    }
    getRegisteredComponents(componentTypes, itemName) {
        const components = [];
        DwUiConfigRegistryService.components.forEach(componentRef => {
            if (this.isComponentTypeMatch(componentRef.componentType, componentTypes)) {
                let addComponent = false;
                if (!itemName || componentRef.isGlobal) {
                    addComponent = true;
                }
                else {
                    if (typeof (componentRef.parentItemName) === 'string' && componentRef.parentItemName === itemName) {
                        addComponent = true;
                    }
                    else {
                        addComponent = (componentRef.parentItemName || []).indexOf(itemName) >= 0;
                    }
                }
                if (addComponent) {
                    components.push(componentRef);
                }
            }
        });
        return components;
    }
    getRegisteredComponent(name, componentTypes, ignoreIfMissing = false) {
        const componentRef = DwUiConfigRegistryService.components.get(name);
        if (!componentRef) {
            if (!ignoreIfMissing) {
                console.warn(`Component ${name} was not found in the component registry`);
            }
            return null;
        }
        if (!this.isComponentTypeMatch(componentRef.componentType, componentTypes)) {
            let componentTypesText = typeof (componentTypes) === 'string' ? componentTypes : componentTypes.join(', ');
            console.warn(`Component ${name} was found, but is of type ${componentRef.componentType}, expecting ${componentTypesText}`);
            return null;
        }
        return componentRef;
    }
    isComponentTypeMatch(currentType, componentTypes) {
        if (Array.isArray(componentTypes)) {
            return componentTypes.find(ct => ct === currentType) != null;
        }
        return currentType == componentTypes;
    }
    getInitSources() {
        return DwUiConfigRegistryService.initSources;
    }
}
DwUiConfigRegistryService.ɵfac = function DwUiConfigRegistryService_Factory(t) { return new (t || DwUiConfigRegistryService)(); };
DwUiConfigRegistryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwUiConfigRegistryService, factory: DwUiConfigRegistryService.ɵfac });
DwUiConfigRegistryService.registrations = new Map();
DwUiConfigRegistryService.actionHandlers = new Map();
DwUiConfigRegistryService.components = new Map();
DwUiConfigRegistryService.datasources = new Map();
DwUiConfigRegistryService.initSources = [];
DwUiConfigRegistryService.generalRegistry = new Map();
DwUiConfigRegistryService.ctorParameters = () => [];

const DwUIConfigToken = new InjectionToken("DwUIConfig");
class DwSideMenuParentConfig {
}
class DwResponsizeColumnConfig {
}
class DwSecurityInfoConfig {
}
class DwRegistrationConfig {
}
class DwCaptchaConfig {
}

class DwMenu {
}

function limitLength(str, length) {
    if ((str === null || str === void 0 ? void 0 : str.length) > length) {
        return str.substring(0, length);
    }
    return str;
}
function addSpaces(str) {
    str = str.replace('dw_', '');
    str = str.replace('_', ' ');
    let result = str.replace(/([A-Z])/g, ' $1').trim();
    result = result.replace('  ', ' ');
    return result;
}
function makeTitleCase(str) {
    str = str.replace("-", " ").replace("-", " ").replace("-", " ").replace("-", " ").replace("-", " ").replace("-", " ");
    str = str.replace("_", " ").replace("_", " ").replace("_", " ").replace("_", " ").replace("_", " ").replace("_", " ");
    str = str.toLowerCase();
    let words = str.split(' ');
    words =
        words.map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        });
    return words.join(" ");
}
function convertToBool(value) {
    if (isBoolean(value)) {
        return value;
    }
    else {
        return (value === 'true');
    }
}
function insertText(mainText, textToInsert, position) {
    mainText = mainText || '';
    if (mainText.length < position) {
        mainText = mainText + textToInsert;
    }
    else {
        const startText = mainText.substring(0, position);
        const endText = mainText.substring(position, mainText.length);
        mainText = `${startText}${textToInsert}${endText}`;
    }
    return mainText;
}
function processTemplate(templateText, tagMap) {
    let finalTemplate = templateText;
    if (!finalTemplate) {
        return '';
    }
    for (const tagName in tagMap) {
        if (tagMap.hasOwnProperty(tagName)) {
            finalTemplate = finalTemplate.replace(`[${tagName}]`, tagMap[tagName]);
        }
    }
    return finalTemplate;
}
function processTemplateTags(templateText, tags, getValue) {
    let finalTemplate = templateText;
    if (!finalTemplate) {
        return '';
    }
    for (const tag of tags) {
        finalTemplate = finalTemplate.replace(tag.tagName, getValue(tag));
    }
    return finalTemplate;
}
function parseTemplate(templateText) {
    let index = 0;
    const tags = [];
    while (index >= 0) {
        const parseResult = parseNextTag(templateText, index);
        if (parseResult.tag) {
            tags.push(parseResult.tag);
        }
        index = parseResult.nextIndex;
    }
    return tags;
}
class TemplateTag {
}
class ParseResult {
}
function parseNextTag(templateText, startingIndex) {
    const nextIndex = templateText.indexOf('[', startingIndex);
    if (nextIndex == -1) {
        return { nextIndex: -1 };
    }
    const endingIndex = templateText.indexOf(']', nextIndex);
    if (endingIndex == -1) {
        return { nextIndex: -1 };
    }
    // Parse full tage name
    const tagName = templateText.substring(nextIndex, endingIndex + 1);
    const tagText = tagName.substring(1, tagName.length - 1);
    return {
        nextIndex: endingIndex,
        tag: {
            tagName: tagName,
            tagText: tagText
        }
    };
}

class DwSecurityResult {
    constructor() {
        this.message = null;
        this.result = null;
    }
}
var SecurityFactorTypes;
(function (SecurityFactorTypes) {
    SecurityFactorTypes["email"] = "Email";
    SecurityFactorTypes["authenticatorApp"] = "AuthenticatorApp";
    SecurityFactorTypes["text"] = "SMS";
})(SecurityFactorTypes || (SecurityFactorTypes = {}));

const moment$2 = moment_;
// Example Date/Time = '2020-01-07 23:05:13';
const momentDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const momentDateFormat = 'MM/DD/YYYY';
const momentDateTimeFormat2 = 'MM/DD/YYYY hh:mm A';
const momentDateTimeFormat3 = 'MM/DD/YYYY HH:mm';
function getMomentValue(value, inclueTime, timeIsUtc) {
    let format = momentDateTimeFormat;
    value = fixMomentDateOnly(value);
    if (!inclueTime && value && value.length === 10) {
        format = momentDateFormat;
    }
    else {
        // If using date/time, determine the format that is being used
        format = momentDateTimeFormat2;
        const hasDash = (value.substring(4, 5) === '-');
        if (hasDash) {
            format = momentDateTimeFormat;
        }
    }
    if (timeIsUtc) {
        return moment$2.utc(value, format);
    }
    return moment$2(value, format);
}
function formatDateTime(value, includeTime, showAmPm) {
    if (!value) {
        return value;
    }
    const momentValue = getMomentValue(value, includeTime, false);
    if (includeTime) {
        if (showAmPm) {
            return momentValue.format("MM/DD/YYYY hh:mm A");
        }
        else {
            return momentValue.format("MM/DD/YYYY HH:mm");
        }
    }
    else {
        return momentValue.format("MM/DD/YYYY");
    }
}
function dateTimeAddDays(value, daysToAdd, includeTime, showAmPm) {
    if (!value) {
        return value;
    }
    let momentValue = getMomentValue(value, includeTime, false);
    momentValue = momentValue.add(daysToAdd, "days");
    return formatDateTime(momentValue.format("MM/DD/YYYY hh:mm A"), includeTime, showAmPm);
}
function convertToIsoDateTime(value, includeTime) {
    const momentValue = getMomentValue(value, includeTime, false);
    return momentValue.toISOString();
}
function formatDateTimeToLocal(value, includeTime, showAmPm) {
    if (!value) {
        return value;
    }
    const momentValue = getMomentValue(value, includeTime, true);
    let convertedDateTime = momentValue.local().format(momentDateTimeFormat);
    return formatDateTime(convertedDateTime, includeTime, showAmPm);
}
function formatDateTimeFromLocal(value, includeTime, showAmPm) {
    if (!value) {
        return value;
    }
    const momentValue = getMomentValue(value, includeTime, false);
    let convertedDateTime = momentValue.utc().format(momentDateTimeFormat);
    return formatDateTime(convertedDateTime, includeTime, showAmPm);
}
function formatTime(value, showAmPm) {
    if (!value) {
        return value;
    }
    let addHours = 0;
    var is12 = value.startsWith('12');
    if (value.indexOf(' AM') >= 0) {
        value = value.replace(' AM', '');
        if (is12) {
            addHours = 12;
        }
    }
    if (value.indexOf(' PM') >= 0) {
        value = value.replace(' PM', '');
        if (!is12) {
            addHours = 12;
        }
    }
    const duration = moment$2.duration(value).add(addHours, 'h').as('milliseconds');
    let format = "HH:mm";
    if (showAmPm) {
        format = 'hh:mm A';
    }
    const timeFormatted = moment$2.utc(duration).format(format);
    return timeFormatted;
}
function fixMomentDateOnly(value) {
    if (value && value.endsWith && value.endsWith("Z")) {
        value = value.substring(0, value.length - 1);
    }
    return value;
}
function getDayOfWeek(date, useGmtDateTime) {
    const dateMoment = getMomentValue(date, false, useGmtDateTime);
    return dateMoment.day();
}
function getDayOfWeekDisplay(dayOfWeek) {
    const dateMoment = moment$2();
    return dateMoment.day(dayOfWeek).format('dddd');
}
function isWithinDateRange(startDate, endDate) {
    if (!startDate || !endDate) {
        return false;
    }
    let today = moment$2();
    let startDateMoment = getMomentValue(startDate, true, false); // moment(fixMomentDateOnly(startDate), momentFormat);
    let endDateMoment = getMomentValue(endDate, true, false);
    if (startDateMoment.isAfter(today)) {
        return false;
    }
    if (endDateMoment.isBefore(today)) {
        return false;
    }
    return true;
}
function isBeforeDate(date, compareDate) {
    if (!date) {
        return false;
    }
    let compareDateMoment = moment$2();
    if (compareDate) {
        compareDateMoment = getMomentValue(compareDate, true, false);
    }
    var dateMoment = getMomentValue(date, true, false);
    // This logic has to be reversed for we now that the event is after todays date(meaning it is before the event)
    if (dateMoment.isAfter(compareDateMoment)) {
        return true;
    }
    return false;
}
function isAfterDate(date) {
    if (!date) {
        return false;
    }
    var today = moment$2();
    var dateMoment = getMomentValue(date, true, false);
    // This logic has to be reversed for we now that the event is after todays date(meaning it is before the event)
    if (dateMoment.isBefore(today)) {
        return true;
    }
    return false;
}
function getDateRangeInfo(startDate, endDate) {
    return {
        isDuring: isWithinDateRange(startDate, endDate),
        beforeStart: isBeforeDate(startDate),
        afterEnd: isAfterDate(endDate),
    };
}
function getBlankDateRangeInfo(isDuring = false, beforeStart = true, afterEnd = false) {
    return {
        isDuring: isDuring,
        beforeStart: beforeStart,
        afterEnd: afterEnd,
    };
}

const DwSecurityRepositoryServiceToken = new InjectionToken("DwSecurityRepositoryService");
class DwSecurityRepositoryService {
    constructor(http, storageUtil, configService, appInitService, cacheService) {
        this.http = http;
        this.storageUtil = storageUtil;
        this.configService = configService;
        this.appInitService = appInitService;
        this.cacheService = cacheService;
        // Returns that emulation is allowed with this repository
        this.emulateSupported = true;
        this.suppressErrorMessages = true;
        // Setup storage to use
        this.storageUtil = storageUtil.local();
        this.securityApi = `${configService.coreConfig.apiRoot}/security`;
        this.securityConfig = this.configService.coreConfig.securityConfig;
    }
    authenticate(userName, password, twoFactorCode, suppressErrorMessages = false) {
        let url = `${this.securityApi}/authentication/user`;
        let body = {
            userName: userName,
            password: password,
            includeSecurityContext: true,
            twoFactorCode: twoFactorCode
        };
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages || suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        let result = this.http.post(url, body, { headers: headers, observe: 'response' })
            .pipe(map((response => {
            return response.body;
        })));
        return this.handleSecurityContextResult(result, suppressErrorMessages);
    }
    logout(logoutResason) {
        let url = `${this.securityApi}/authentication/user/logout?logoutReason=${logoutResason}`;
        let headers = new HttpHeaders();
        headers = headers.append(SuppressErrorMessagesHeader, 'true');
        let result = this.http.post(url, null, { headers: headers });
        return result;
    }
    reAuthenticate(securityToken) {
        let url = `${this.securityApi}/authentication/user`;
        let result = this.http.put(url, JSON.stringify(securityToken));
        return this.handleSecurityContextResult(result);
    }
    authenticateSSO(ssoToken, tenantSSOConfigId) {
        let url = `${this.securityApi}/authentication/sso`;
        if (tenantSSOConfigId) {
            url += `?tenantSSOConfigId=${tenantSSOConfigId}`;
        }
        let result = this.http.post(url, JSON.stringify(ssoToken));
        return this.handleSecurityContextResult(result);
    }
    reAuthenticateSSO(ssoToken, tenantSSOConfigId) {
        let url = `${this.securityApi}/authentication/sso`;
        if (tenantSSOConfigId) {
            url += `?tenantSSOConfigId=${tenantSSOConfigId}`;
        }
        let result = this.http.put(url, ssoToken);
        return this.handleSecurityContextResult(result);
    }
    findUsers(firstName, lastName, email, maxResults = -1) {
        let url = `${this.securityApi}/emulation`;
        let params = [];
        if (firstName)
            params.push(`firstName=${firstName}`);
        if (lastName)
            params.push(`lastName=${lastName}`);
        if (email)
            params.push(`email=${email}`);
        if (maxResults != -1)
            params.push(`maxResults=${maxResults}`);
        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers })
            .pipe(map((r) => {
            return r;
        }));
    }
    getSSOConfig(ssoTenantConfigId) {
        // Use the App Init info to get to sso config.  This includes other data items requires for the initial load of the application
        return this.getSSOConfigs()
            .pipe(map(ssoConfigs => {
            if (ssoTenantConfigId) {
                var result = ssoConfigs.find(sso => sso.TenantSsoConfigId == ssoTenantConfigId);
                if (result) {
                    return result;
                }
            }
            return ssoConfigs[0];
        }));
    }
    getSSOConfigForLoginButton() {
        // Use the App Init info to get to sso config.  This includes other data items requires for the initial load of the application
        return this.getSSOConfigs()
            .pipe(map(ssoConfigs => {
            var result = ssoConfigs.find(sso => sso.LoginButtonUsesSSO);
            return result;
        }));
    }
    getSSOConfigForAutoLogin() {
        // Use the App Init info to get to sso config.  This includes other data items requires for the initial load of the application
        return this.getSSOConfigs()
            .pipe(map(ssoConfigs => {
            var result = ssoConfigs.find(sso => sso.AutoLoginWithSSO);
            return result;
        }));
    }
    getSSOConfigs() {
        // Use the App Init info to get to sso config.  This includes other data items requires for the initial load of the application
        return this.appInitService.getAppInitResult()
            .pipe(map(appInitResult => {
            return appInitResult.SsoConfigs;
        }));
    }
    emulatUser(userName) {
        let url = `${this.securityApi}/emulation`;
        let params = [];
        if (userName)
            params.push(`userName=${userName}`);
        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        let result = this.http.post(url, {}, { headers: headers });
        return this.handleSecurityContextResult(result);
    }
    cancelEmulation() {
        let url = `${this.securityApi}/emulation`;
        let result = this.http.delete(url);
        return this.handleSecurityContextResult(result);
    }
    createPersonalAccessToken(patData) {
        const url = `${this.securityApi}/authentication/pat/generate`;
        patData.ExpirationDateTime = convertToIsoDateTime(patData.ExpirationDateTime, true);
        patData.LinkedUserId = parseInt(patData.LinkedUserId.toString());
        const result = this.http.post(url, patData);
        return result.pipe(map((r) => {
            return r;
        }));
    }
    getPermissions() {
        // Can't directly reference ORM, but want to clear the cache if permissions are modified
        const cacheOptions = {
            cacheInvalidationsTopics: [`OrmEventw_AppPermission`],
        };
        return this.cacheService.getWithOptions('permissions', this.loadPermissions(), cacheOptions);
    }
    loadPermissions() {
        const url = `${this.securityApi}/permission`;
        return this.http.get(url)
            .pipe(map((r) => {
            return r;
        }));
    }
    /**
     * Resets a user password
     * @param userName username
     * @param newPassword new password
     * @param resetCode reset code send in e-mail or text
     */
    resetUserPassword(userName, newPassword, resetCode) {
        let url = `${this.securityApi}/self-service/${userName}/password/reset`;
        const body = {
            NewPassword: newPassword,
            ResetCode: resetCode,
        };
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, body, { headers: headers });
    }
    /**
     * Admin function to set a user password
     * @param userName username
     * @param newPassword new password
     * @param resetCode reset code send in e-mail or text
     */
    setUserPassword(userName, newPassword) {
        let url = `${this.securityApi}/self-service/${userName}/password/set`;
        const body = {
            NewPassword: newPassword
        };
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, body, { headers: headers });
    }
    /**
     * Allows a user to change their password
     * @param userName username
     * @param oldPassword existing password
     * @param newPassword new password
     */
    changeUserPassword(userName, oldPassword, newPassword, twoFactorCode) {
        let url = `${this.securityApi}/self-service/${userName}/password/change`;
        const body = {
            OldPassword: oldPassword,
            NewPassword: newPassword,
            twoFactorCode: twoFactorCode
        };
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, body, { headers: headers });
    }
    /**
    * Send a reset e-mail
    * @param userName username
    */
    sendPasswordResetEmail(userName) {
        let url = `${this.securityApi}/self-service/${userName}/password/reset-email`;
        const body = {};
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, body, { headers: headers });
    }
    handleSecurityContextResult(observable, suppressErrorMessages = false) {
        let resultSubject = new Subject();
        //this.isAuthenticating = true;
        observable
            .subscribe((httpResult) => {
            var result = new DwSecurityResult();
            result.success = true;
            result.result = httpResult.SecurityContext;
            if (httpResult.PromptForTwoFactorCode) {
                result.PromptForTwoFactorCode = httpResult.PromptForTwoFactorCode;
                result.TwoFactorAuthenticationType = httpResult.TwoFactorAuthenticationType;
                result.message = httpResult.FailedReason;
                result.suppressErrorMessage = true;
                result.success = false;
            }
            if (httpResult.ForcePasswordChange) {
                result.ForcePasswordChange = httpResult.ForcePasswordChange;
                result.message = httpResult.FailedReason;
                result.suppressErrorMessage = true;
                result.success = false;
            }
            // set Security Token
            if (result.result) {
                result.result.SecurityToken = httpResult.SecurityToken;
                result.result.SecurityTokenExpirationDateTime = httpResult.SecurityTokenExpirationDateTime;
            }
            resultSubject.next(result);
        }, errorResponse => {
            var result = new DwSecurityResult();
            result.success = false;
            result.suppressErrorMessage = suppressErrorMessages;
            const errorDetail = getErrorDetails(errorResponse);
            result.message = errorDetail.message;
            resultSubject.next(result);
        });
        return resultSubject.asObservable();
    }
}
DwSecurityRepositoryService.ɵfac = function DwSecurityRepositoryService_Factory(t) { return new (t || DwSecurityRepositoryService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwStorageUtil), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwAppInitService), ɵngcc0.ɵɵinject(DwCacheService)); };
DwSecurityRepositoryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSecurityRepositoryService, factory: DwSecurityRepositoryService.ɵfac });
DwSecurityRepositoryService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwStorageUtil },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwAppInitService },
    { type: DwCacheService }
];

class DwSecurityUserService {
    constructor(dwSecurityStateService, securityRepository, configService) {
        this.dwSecurityStateService = dwSecurityStateService;
        this.securityRepository = securityRepository;
        this.configService = configService;
        this.securityConfig = this.configService.coreConfig.securityConfig;
    }
    securityContextChanged() {
        return this.dwSecurityStateService.securityContextChanged();
    }
    get securityState() {
        return this.dwSecurityStateService.securityState;
    }
    get securityContext() {
        return this.securityState.securityContext;
    }
    getUserInactivityConfig(securityState) {
        let userActivityConfig = this.securityConfig.userInactivitiy;
        if (this.securityConfig.userInactivtyFunc) {
            userActivityConfig = this.securityConfig.userInactivtyFunc(securityState);
            if (userActivityConfig) {
                return userActivityConfig;
            }
        }
        if (this.securityConfig.userInactivitiyPermissionOveride) {
            let currentPriority = 1000000;
            for (let permission in this.securityConfig.userInactivitiyPermissionOveride) {
                if (this.securityConfig.userInactivitiyPermissionOveride.hasOwnProperty(permission)) {
                    let currentUserActivityConfig = this.securityConfig.userInactivitiyPermissionOveride[permission];
                    const priority = currentUserActivityConfig.priority || 999999;
                    if (priority < currentPriority && this.hasPermission(permission, false)) {
                        userActivityConfig = currentUserActivityConfig;
                        currentPriority = priority;
                    }
                }
            }
        }
        return userActivityConfig;
    }
    hasPermission(permissionMeaning, useEmulatedPermission = true) {
        const securityState = this.dwSecurityStateService.securityState;
        const securityContext = securityState.securityContext;
        if (!securityState.isAuthenticated || !securityContext)
            return false;
        const user = useEmulatedPermission ? securityContext.ApplicationUser : securityContext.AuthenticatedUser;
        return this.hasPermissionUser(user, permissionMeaning);
    }
    hasPermissionUser(user, permissionMeaning) {
        if (!permissionMeaning)
            return true;
        permissionMeaning = permissionMeaning.toUpperCase();
        // Check if the permission is found
        for (const permission of user.Permissions) {
            if (permission.toUpperCase() == permissionMeaning)
                return true;
        }
        return false;
    }
}
DwSecurityUserService.ɵfac = function DwSecurityUserService_Factory(t) { return new (t || DwSecurityUserService)(ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken)); };
DwSecurityUserService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecurityUserService_Factory() { return new DwSecurityUserService(ɵɵinject(DwSecurityStateService), ɵɵinject(DwSecurityRepositoryServiceToken), ɵɵinject(DwConfigServiceToken)); }, token: DwSecurityUserService, providedIn: "root" });
DwSecurityUserService.ctorParameters = () => [
    { type: DwSecurityStateService },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];

const DwMenuProcessorToken = new InjectionToken('DwMenuProcessorToken');

var DwMenuActionType;
(function (DwMenuActionType) {
    // grid = 'grid',
    DwMenuActionType["add"] = "add";
    DwMenuActionType["edit"] = "edit";
    DwMenuActionType["view"] = "view";
    DwMenuActionType["print"] = "print";
    DwMenuActionType["addEdit"] = "addEdit";
    DwMenuActionType["list"] = "list";
})(DwMenuActionType || (DwMenuActionType = {}));
class DwMenuActionTypeList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwMenuActionType[propertyName];
    }
    getKeys() {
        return Object.keys(DwMenuActionType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwMenuActionType.add:
                return 'Add';
            case DwMenuActionType.edit:
                return 'Edit';
            case DwMenuActionType.view:
                return 'View';
            case DwMenuActionType.print:
                return 'Print';
            default:
                return null;
        }
    }
}
function getMenuActionTypeDisplay(actionType) {
    switch (actionType) {
        /*  case DwMenuActionType.grid:
             return 'Grid'; */
        case DwMenuActionType.edit:
            return 'Edit';
        case DwMenuActionType.add:
            return 'Add';
        case DwMenuActionType.view:
            return 'View';
        case DwMenuActionType.print:
            return 'Print';
        case DwMenuActionType.addEdit:
            return 'Add/Edit';
        case DwMenuActionType.list:
            return 'List';
    }
}
function getMenuActionTypePath(itemName, actionType, prefixOverride) {
    const paramName = getMenuActionParamName(itemName);
    switch (actionType) {
        case DwMenuActionType.edit:
            const editPrefix = prefixOverride || 'edit';
            return `${editPrefix}/${paramName}`;
        case DwMenuActionType.add:
            return prefixOverride || 'add';
        case DwMenuActionType.view:
            const viewPrefix = prefixOverride || 'view';
            return `${viewPrefix}/${paramName}`;
        case DwMenuActionType.print:
            const printPrefix = prefixOverride || 'print';
            return `${printPrefix}/${paramName}`;
    }
}
function getMenuActionParamName(itemName) {
    return `:${itemName}Id`;
}

var DwActionType;
(function (DwActionType) {
    DwActionType["gridAction"] = "gridAction";
    DwActionType["gridRowAction"] = "gridRowAction";
    DwActionType["gridContextMenuAction"] = "gridContextMenuAction";
    // Added 12/1/2023 
    DwActionType["gridActionInlineEdit"] = "gridActionInlineEdit";
    DwActionType["gridRowActionInlineEdit"] = "gridRowActionInlineEdit";
    DwActionType["formAction"] = "formAction";
    DwActionType["listAction"] = "listAction";
    DwActionType["listItemAction"] = "listItemAction";
    DwActionType["menuAction"] = "menuAction";
})(DwActionType || (DwActionType = {}));
/*
export enum DwGridActionLocation {
    actionBarLeft = 'actionBarLeft',
    actionBarRight = 'actionBarRight',
    rowButton = 'rowButton',
    rowContextMenu = 'contextMenuAction'
}



export class DwActionLocationList extends DwEnumListBase<DwGridActionLocation, DwEnumItem<DwGridActionLocation>> {
    getEnumValue(propertyName: string): DwGridActionLocation {
        return DwGridActionLocation[propertyName];
    }
    getKeys(): string[] {
        return Object.keys(DwGridActionLocation);
    }
    
    public getEnumDisplay(item: DwGridActionLocation) {
        switch (item) {
            case DwGridActionLocation.actionBarLeft:
                return 'Action Bar Left';
            case DwGridActionLocation.actionBarRight :
                return 'Action Bar Right';
            case DwGridActionLocation.rowButton:
                return 'Row Button';
            case DwGridActionLocation.rowContextMenu:
                return 'Row Context Menu';
        }
    }
}

export function getGridActionModes(): DwActionMode[] {
    const actionLocations = new DwActionLocationList().getEnumList();

    const actionModes = actionLocations.map(action => {
        const actionMode: DwActionMode= {
            modeValue: action.value,
            modeDisplay: action.display,
            showButtonConfig: action.value !== DwGridActionLocation.rowContextMenu,
            showMenuConfig: action.value === DwGridActionLocation.rowContextMenu,
        };

        return actionMode;
    });

    return actionModes;
}


function getActionTypes()
 */

var DwFormContextMode;
(function (DwFormContextMode) {
    DwFormContextMode["addEdit"] = "addEdit";
    DwFormContextMode["add"] = "add";
    DwFormContextMode["edit"] = "edit";
    DwFormContextMode["view"] = "view";
    DwFormContextMode["print"] = "print";
})(DwFormContextMode || (DwFormContextMode = {}));
const formModeNone = 'none';
class DwFormContextModeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwFormContextMode[propertyName];
    }
    getKeys() {
        return Object.keys(DwFormContextMode);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwFormContextMode.addEdit:
                return 'Add/Edit';
            case DwFormContextMode.add:
                return 'Add';
            case DwFormContextMode.edit:
                return 'Edit';
            case DwFormContextMode.view:
                return 'View';
            case DwFormContextMode.print:
                return 'Print';
        }
    }
}
function getEnumDisplay(item) {
    switch (item) {
        case DwFormContextMode.addEdit:
            return 'Add/Edit';
        case DwFormContextMode.add:
            return 'Add';
        case DwFormContextMode.edit:
            return 'Edit';
        case DwFormContextMode.view:
            return 'View';
        case DwFormContextMode.print:
            return 'Print';
    }
}
function getFormActionModes(useFormModes, buttonContainerStyleKey) {
    const actionModes = [];
    const defaultFormMode = {
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.formAction, DwActionType.menuAction],
        buttonContainerStyleKey: buttonContainerStyleKey
    };
    if (!useFormModes) {
        actionModes.push(Object.assign({ modeValue: formModeNone, modeDisplay: 'None' }, defaultFormMode));
        return actionModes;
    }
    actionModes.push(Object.assign({ modeValue: DwFormContextMode.addEdit, modeDisplay: getEnumDisplay(DwFormContextMode.addEdit) }, defaultFormMode));
    actionModes.push(Object.assign({ modeValue: DwFormContextMode.add, modeDisplay: getEnumDisplay(DwFormContextMode.add) }, defaultFormMode));
    actionModes.push(Object.assign({ modeValue: DwFormContextMode.edit, modeDisplay: getEnumDisplay(DwFormContextMode.edit) }, defaultFormMode));
    actionModes.push(Object.assign({ modeValue: DwFormContextMode.view, modeDisplay: getEnumDisplay(DwFormContextMode.view) }, defaultFormMode));
    actionModes.push(Object.assign({ modeValue: DwFormContextMode.print, modeDisplay: getEnumDisplay(DwFormContextMode.print) }, defaultFormMode));
    return actionModes;
}

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class DwMenuHelperService {
    constructor(dwSecurityUserService, dwMenuProcessors) {
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwMenuProcessors = dwMenuProcessors;
    }
    canAccessMenu(menu) {
        if (!this.canAccessMenuFromProcessors(menu)) {
            return false;
        }
        if (!menu.data.requireAuthentication)
            return true;
        if (!this.dwSecurityUserService.securityState.isAuthenticated)
            return false;
        if (menu.data.canAccessPermission) {
            const useEmulatedPermissions = (menu.data.useEmulatedPermissions !== false);
            // Check the route specific permission
            return this.dwSecurityUserService.hasPermission(menu.data.canAccessPermission, useEmulatedPermissions);
        }
        return true;
    }
    canAccessMenuFromProcessors(menu) {
        for (const menuProcessor of this.dwMenuProcessors || []) {
            if (menuProcessor === null || menuProcessor === void 0 ? void 0 : menuProcessor.canAccessMenu) {
                if (!(menuProcessor === null || menuProcessor === void 0 ? void 0 : menuProcessor.canAccessMenu(menu))) {
                    return false;
                }
            }
        }
        return true;
    }
    canViewMenuFromProcessors(menu) {
        for (const menuProcessor of this.dwMenuProcessors || []) {
            if (menuProcessor === null || menuProcessor === void 0 ? void 0 : menuProcessor.canViewMenu) {
                if (!(menuProcessor === null || menuProcessor === void 0 ? void 0 : menuProcessor.canViewMenu(menu))) {
                    return false;
                }
            }
        }
        return true;
    }
    isMenuMatch(menu1, menu2, includeDisplayMatch = false, includePathMatch = false) {
        if (!menu1 || !menu2) {
            return false;
        }
        if (menu1.data.routeId && menu2.data.routeId) {
            if (menu1.data.routeId !== menu2.data.routeId) {
                return false;
            }
            if (!menu1.data.isChild && !menu2.data.isChild) {
                return true;
            }
            if (menu1.data.isChild && menu2.data.isChild) {
                if (menu1.data.metaDataActionType == menu2.data.metaDataActionType) {
                    return true;
                }
            }
            return false;
        }
        if (menu1.data.referenceKey && menu2.data.referenceKey) {
            if (menu1.data.referenceKey === menu2.data.referenceKey) {
                return true;
            }
        }
        if (menu1.path == menu2.path && includePathMatch) {
            return true;
        }
        if (menu1.display == menu2.display && includeDisplayMatch) {
            return true;
        }
        return false;
    }
    findMenuByKey(menuKey, menus) {
        return this.findMenu((menu) => {
            return menu.menuKey == menuKey;
        }, menus);
    }
    findMenuByData(menuData, menus) {
        if (!menuData)
            return null;
        const matchMenuByDisplayFunc = (menu) => {
            const currentMenuData = menu.data || {};
            // If we have a route id, use that since it unique
            if (menuData.routeId) {
                if (menuData.routeId == currentMenuData.routeId) {
                    return (menuData.metaDataActionType == currentMenuData.metaDataActionType);
                }
                return false;
            }
            // Same with reference key (these are unique ids for static routes declared in code)
            if (menuData.referenceKey) {
                if (menuData.referenceKey == currentMenuData.referenceKey
                    && menuData.metaDataActionType == currentMenuData.metaDataActionType
                    && menuData.metaDataItem == currentMenuData.metaDataItem) {
                    // If we have duplicate menus for the same item (e.g. Users), we need to check the route id (if it's a saved route) or the config key.  Each represents a unique route
                    if (menuData.routeId != currentMenuData.routeId) {
                        return false;
                    }
                    if (menuData.configKeyPart != currentMenuData.configKeyPart) {
                        return false;
                    }
                    return true;
                }
                return false;
            }
            // Fallback to display
            if (!menu || !menu.display || !menuData.display)
                return false;
            return currentMenuData.display.toLowerCase() == menuData.display.toLowerCase();
        };
        return this.findMenu(matchMenuByDisplayFunc, menus);
    }
    findMenu(findFunc, menus) {
        if (!menus) {
            return null;
        }
        for (const menu of menus) {
            if (findFunc(menu)) {
                return menu;
            }
            if (menu.children) {
                const foundMenu = this.findMenu(findFunc, menu.children);
                if (foundMenu)
                    return foundMenu;
            }
        }
        return null;
    }
    getMenuDirectParent(menu, allMenus) {
        const findFunc = (currentMenu) => {
            return this.isMenuMatch(menu, currentMenu);
        };
        return this.findParentMenu(findFunc, allMenus);
    }
    findParentMenu(findFunc, menus, parentMenu) {
        if (!menus) {
            return null;
        }
        for (const menu of menus) {
            if (findFunc(menu)) {
                return parentMenu;
            }
            if (menu.children) {
                const foundMenu = this.findParentMenu(findFunc, menu.children, menu);
                if (foundMenu)
                    return foundMenu;
            }
        }
        return null;
    }
    findMenus(findFunc, menus, includeParentMenus = true) {
        if (!menus) {
            return null;
        }
        const foundMenus = [];
        for (const menu of menus) {
            if (findFunc(menu)) {
                const newMenu = Object.assign({}, menu);
                if (menu.children)
                    newMenu.children = this.findMenus(findFunc, menu.children, includeParentMenus);
                foundMenus.push(newMenu);
                return foundMenus;
            }
            if (menu.children) {
                const childMenus = this.findMenus(findFunc, menu.children, includeParentMenus);
                if (childMenus && childMenus.length > 0) {
                    if (!includeParentMenus) {
                        // stopped returning since this only returns the first child menu, not other child menus 8/1/2023
                        //return childMenus;
                        for (let childMenu of childMenus) {
                            foundMenus.push(childMenu);
                        }
                    }
                    else {
                        const newMenu = Object.assign({}, menu);
                        newMenu.children = childMenus;
                        foundMenus.push(newMenu);
                    }
                }
            }
        }
        return foundMenus;
    }
    filterMenuHierarchy(findFunc, menus, maxLevels = -1, level = 0) {
        if (!menus) {
            return null;
        }
        // limit items to the chosen depth
        if (maxLevels > 0 && level >= maxLevels) {
            return null;
        }
        const foundMenus = [];
        for (const menu of menus) {
            if (!findFunc(menu)) {
                continue;
            }
            const { children } = menu, menuMinusChildren = __rest(menu, ["children"]);
            const newMenu = Object.assign(Object.assign({}, menuMinusChildren), { children: this.filterMenuHierarchy(findFunc, children, maxLevels, level + 1) });
            foundMenus.push(newMenu);
        }
        return foundMenus;
    }
    sortMenus(menus) {
        return sortArray(menus, this.getSortByField);
    }
    getRouteDetail(route) {
        const routeDetail = {
            menuData: this.getRouteMenueData(route)
        };
        if (routeDetail.menuData.configKeyPart) {
            routeDetail.configKeyPart = routeDetail.menuData.configKeyPart;
        }
        if (routeDetail.menuData.printConfigKeyPart) {
            routeDetail.printConfigKeyPart = routeDetail.menuData.printConfigKeyPart;
        }
        this.populateParams(route, routeDetail);
        routeDetail.contextMode = this.getFormContxtMode(routeDetail.menuData.metaDataActionType);
        return routeDetail;
    }
    getFormContxtMode(actionType) {
        if (!actionType) {
            return;
        }
        // Translate from the menu action type to a form mode
        switch (actionType) {
            case DwMenuActionType.add:
                return DwFormContextMode.add;
            case DwMenuActionType.edit:
                return DwFormContextMode.edit;
            case DwMenuActionType.view:
                return DwFormContextMode.view;
            case DwMenuActionType.print:
                return DwFormContextMode.print;
            case DwMenuActionType.addEdit:
                return DwFormContextMode.addEdit;
        }
    }
    populateParams(route, routeDetail, force = false) {
        if (!route) {
            return;
        }
        if (!routeDetail.itemName || !routeDetail.keyValue || force) {
            const params = route.snapshot.paramMap;
            //route.paramMap.subscribe((params: ParamMap) => {
            let itemName = params.get('itemName');
            if (!itemName) {
                itemName = routeDetail.menuData.metaDataItem;
            }
            if (itemName && (!routeDetail.itemName || routeDetail.itemName !== itemName)) {
                routeDetail.itemName = itemName;
            }
            const paramName = getMenuActionParamName(itemName);
            let keyValue = params.get(paramName.replace(':', ''));
            // Check if the key value is null, if so, use the keyValue property - this is needed to meta data admin to work with generic item keys
            if (!keyValue) {
                keyValue = params.get('keyValue');
            }
            if (keyValue && routeDetail.keyValue !== keyValue) {
                routeDetail.keyValue = keyValue;
            }
            // Continue up hierarchy until all params are populated
            this.populateParams(route.parent, routeDetail, force);
        }
    }
    getRouteMenueData(route) {
        if (route.snapshot.routeConfig) {
            var routeConfig = route.snapshot.routeConfig;
            const dwMenuData = route.snapshot.data;
            if (dwMenuData) {
                return dwMenuData;
            }
        }
        return new DwMenuData;
    }
    /**
     * Replace logic to be more definitive for undefined values of display (now they should always be at the end)
     * @param menu
     * @returns
     */
    getSortByField(menu) {
        var _a, _b;
        if ((_a = menu === null || menu === void 0 ? void 0 : menu.data) === null || _a === void 0 ? void 0 : _a.routeOrder)
            return menu.data.routeOrder;
        if ((_b = menu === null || menu === void 0 ? void 0 : menu.data) === null || _b === void 0 ? void 0 : _b.display) {
            return menu.data.display;
        }
        return 10000000000000;
    }
}
DwMenuHelperService.ɵfac = function DwMenuHelperService_Factory(t) { return new (t || DwMenuHelperService)(ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwMenuProcessorToken, 8)); };
DwMenuHelperService.ɵprov = ɵɵdefineInjectable({ factory: function DwMenuHelperService_Factory() { return new DwMenuHelperService(ɵɵinject(DwSecurityUserService), ɵɵinject(DwMenuProcessorToken, 8)); }, token: DwMenuHelperService, providedIn: "root" });
DwMenuHelperService.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [DwMenuProcessorToken,] }] }
];

var DwMenuCategory;
(function (DwMenuCategory) {
    DwMenuCategory["sideMenu"] = "sideMenu";
    DwMenuCategory["topMenu"] = "topMenu";
    DwMenuCategory["userMenu"] = "userMenu";
})(DwMenuCategory || (DwMenuCategory = {}));
const defaultMenuCategory = DwMenuCategory.sideMenu;

class DwGoogleAnalyticsService {
    constructor(configService, router, route) {
        this.configService = configService;
        this.router = router;
        this.route = route;
        this.routingConfig = configService.coreConfig.routingConfig;
        this.setupAnalytics();
    }
    setupAnalytics() {
        // Only allow setup one time
        if (DwGoogleAnalyticsService.setupComplete) {
            return;
        }
        DwGoogleAnalyticsService.setupComplete = true;
        if (this.routingConfig.googleAnalyticsTrackingToken) {
            if (!ga) {
                console.warn('Google analytics is not loaded.  This needs to be added to the index.html page');
                return;
            }
            ga('create', this.routingConfig.googleAnalyticsTrackingToken, 'auto');
        }
    }
    sendPageView(url) {
        if (!this.routingConfig.googleAnalyticsTrackingToken || !ga) {
            return;
        }
        if (DwGoogleAnalyticsService.lastUrl == url) {
            return;
        }
        DwGoogleAnalyticsService.lastUrl = url;
        ga('set', 'page', url);
        ga('send', 'pageview');
    }
}
DwGoogleAnalyticsService.ɵfac = function DwGoogleAnalyticsService_Factory(t) { return new (t || DwGoogleAnalyticsService)(ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute)); };
DwGoogleAnalyticsService.setupComplete = false;
DwGoogleAnalyticsService.lastUrl = '';
DwGoogleAnalyticsService.ɵprov = ɵɵdefineInjectable({ factory: function DwGoogleAnalyticsService_Factory() { return new DwGoogleAnalyticsService(ɵɵinject(DwConfigServiceToken), ɵɵinject(Router), ɵɵinject(ActivatedRoute)); }, token: DwGoogleAnalyticsService, providedIn: "root" });
DwGoogleAnalyticsService.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: Router },
    { type: ActivatedRoute }
];

const DwRoutingServiceToken = new InjectionToken("DwRoutingServiceToken");
class DwRoutingService {
    constructor(configService, securityUserService, router, route, analytics) {
        this.configService = configService;
        this.securityUserService = securityUserService;
        this.router = router;
        this.route = route;
        this.analytics = analytics;
        this.subscriptions = [];
        this.routingConfig = configService.coreConfig.routingConfig;
        // Setup route and security subscriptions
        this.setupSubscriptions();
    }
    get currentPageUrl() {
        return DwRoutingService._currentPageUrl;
    }
    set currentPageUrl(pageUrl) {
        if (pageUrl == DwRoutingService._currentPageUrl)
            return;
        DwRoutingService._lastPageUrl = DwRoutingService._currentPageUrl;
        DwRoutingService._currentPageUrl = pageUrl;
    }
    get lastPageUrl() {
        return DwRoutingService._lastPageUrl;
    }
    getRoutesChanges() {
        return DwRoutingService._routesChangedSubject.asObservable();
    }
    OnRouteChanges() {
        DwRoutingService._routesChangedSubject.next(null);
    }
    findRoute(findFunc, routes) {
        if (!routes)
            routes = this.router.config;
        let foundMenus = [];
        for (var route of routes) {
            if (findFunc(route)) {
                return route;
            }
            if (route.children) {
                var foundMenu = this.findRoute(findFunc, route.children);
                if (foundMenu)
                    return foundMenu;
            }
        }
        return null;
    }
    buildUrl(route) {
        let url = "";
        if (route.parent) {
            url = this.buildUrl(route.parent);
        }
        if (route.url && route.url.length > 0) {
            url += '/' + route.url.map(segment => {
                return segment.path;
            }).join('/');
        }
        return url;
    }
    // Check if the current user has permission to access the route
    canAccessRoute(route) {
        if (!route.data)
            return true;
        let routeData = route.data;
        if (!routeData.requireAuthentication)
            return true;
        if (!this.securityUserService.securityState.isAuthenticated)
            return false;
        if (routeData.canAccessPermission) {
            // Check the route specific permission
            return this.securityUserService.hasPermission(routeData.canAccessPermission, routeData.useEmulatedPermissions);
        }
        return true;
    }
    setupSubscriptions() {
        this.subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            this.handleRouteChange();
        }));
    }
    getCurrentRouteParams() {
        var snapshot = this.route.root.snapshot;
        return this.getChildSnapshotParams(snapshot);
    }
    getChildSnapshotParams(routeSnapshot, paramsResult) {
        if (!paramsResult) {
            paramsResult = {};
        }
        for (let paramName in routeSnapshot.params) {
            paramsResult[paramName] = routeSnapshot.params[paramName];
        }
        if (routeSnapshot.children) {
            for (let child of routeSnapshot.children) {
                this.getChildSnapshotParams(child, paramsResult);
            }
        }
        return paramsResult;
    }
    ngOnDestroy() {
        // Clean up subscriptions
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    handleRouteChange() {
        this.analytics.sendPageView(this.router.url);
        this.OnRouteChanges();
    }
    returnToPrevious() {
        this.router.navigateByUrl(this.lastPageUrl);
    }
    /**
     * Navigates to a url with options to open in new window
     * @param url
     * @param windowOpenOptions
     * @returns
     */
    navigateToUrl(url, windowOpenOptions) {
        if (windowOpenOptions === null || windowOpenOptions === void 0 ? void 0 : windowOpenOptions.openInNewWindow) {
            const target = windowOpenOptions.newWindowTarget || "_blank";
            window.open(url, target, windowOpenOptions.features);
            return;
        }
        const navigationParams = {};
        navigationParams.state = { fulUrl: url };
        this.router.navigateByUrl(url, navigationParams);
    }
}
DwRoutingService.ɵfac = function DwRoutingService_Factory(t) { return new (t || DwRoutingService)(ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(DwGoogleAnalyticsService)); };
DwRoutingService._currentPageUrl = "";
DwRoutingService._lastPageUrl = "";
DwRoutingService._routesChangedSubject = new BehaviorSubject(null);
DwRoutingService.ɵprov = ɵɵdefineInjectable({ factory: function DwRoutingService_Factory() { return new DwRoutingService(ɵɵinject(DwConfigServiceToken), ɵɵinject(DwSecurityUserService), ɵɵinject(Router), ɵɵinject(ActivatedRoute), ɵɵinject(DwGoogleAnalyticsService)); }, token: DwRoutingService, providedIn: "root" });
DwRoutingService.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityUserService },
    { type: Router },
    { type: ActivatedRoute },
    { type: DwGoogleAnalyticsService }
];

function dwSecuritySsoHanlderFactory(injector, securityConfig, ssoConfig, loggingService) {
    let serviceType;
    if (securityConfig && securityConfig.ssoHandlers) {
        serviceType = securityConfig.ssoHandlers[ssoConfig.TenantSSOType];
    }
    if (!serviceType) {
        loggingService.logWarning(`No Single Sign On Hanlder for Tenant SSO Type Id ${ssoConfig.TenantSSOType}. These are configured in DwSecurityConfig`);
        return null;
    }
    return injector.get(serviceType);
}

class DwSecuritySSOService {
    constructor(storageUtil, loggingUtil, securityRepository, configService, cacheService, injector, router, dwSecurityStateService) {
        this.storageUtil = storageUtil;
        this.loggingUtil = loggingUtil;
        this.securityRepository = securityRepository;
        this.configService = configService;
        this.cacheService = cacheService;
        this.injector = injector;
        this.router = router;
        this.dwSecurityStateService = dwSecurityStateService;
        this.securityConfig = configService.coreConfig.securityConfig;
        this.routingConfig = configService.coreConfig.routingConfig;
    }
    /**
     * Create a params wrapper that call instance methods within this class
     * @param ssoConfig
     */
    createSSOParams(ssoConfig) {
        return {
            ssoConfig: ssoConfig,
            completeSSOAuthentication: (token) => this.completeSSOAuthentication(token, ssoConfig),
            completeSSOReAuthentication: (token) => this.completeSSOReAuthentication(token, ssoConfig),
            completeSSOWithFailure: (error) => this.completeSSOWithFailure(error, ssoConfig),
            completeSSONoAction: () => this.completeSSONoAction(),
            redirectedToSSO: () => this.redirectedToSSO(),
            setAuthenticationStatusMessage: (message) => this.setAuthenticationStatusMessage(message),
            initialUrl: this.dwSecurityStateService.securityState.initialUrl,
        };
    }
    completeSSOAuthentication(token, ssoConfig) {
        this.dwSecurityStateService.setSSOToken(token);
        this.securityRepository.authenticateSSO(token.idToken, ssoConfig.TenantSsoConfigId)
            .subscribe(result => {
            this.dwSecurityStateService.processSecurityResult(result);
            this.returnToPreviousUrl();
        });
    }
    completeSSOReAuthentication(token, ssoConfig) {
        this.dwSecurityStateService.setSSOToken(token);
        this.securityRepository.reAuthenticateSSO(token.idToken, ssoConfig.TenantSsoConfigId)
            .subscribe(result => {
            this.dwSecurityStateService.processSecurityResult(result);
            this.cleanUpUrl();
        });
    }
    completeSSOWithFailure(error, ssoConfig) {
        this.dwSecurityStateService.processSecurityResult({ success: false, message: error.errorMessage, result: null, suppressErrorMessage: true });
    }
    completeSSONoAction() {
        this.dwSecurityStateService.completeAuthenticating();
    }
    redirectedToSSO() {
        // Store the url here
        this.dwSecurityStateService.storeLastUrl(this.router.url);
        this.dwSecurityStateService.completeAuthenticating();
    }
    setAuthenticationStatusMessage(message) {
        this.dwSecurityStateService.setSecurityMessage(message);
    }
    callSSOHandleMethod(callBack) {
        const subject = new Subject();
        const ob = subject.asObservable();
        return this.getSSOConfig()
            .pipe(mergeMap(ssoConfig => {
            const ssoParams = this.createSSOParams(ssoConfig);
            const ssoHandler = this.createHandler(ssoConfig);
            if (!ssoHandler || !ssoConfig.EnableSSO) {
                ssoParams.completeSSONoAction();
                // subject.next({usedSSO: false});
                return of({ usedSSO: false });
            }
            const result = callBack(ssoHandler, ssoParams);
            if (result instanceof Observable) {
                return result.pipe(map(result => {
                    return { usedSSO: true, result: result };
                }));
            }
            return of({ usedSSO: true, result: result });
        }));
    }
    returnToPreviousUrl() {
        const url = this.dwSecurityStateService.getLastUrl();
        const isLoginPath = url === null || url === void 0 ? void 0 : url.endsWith('/' + this.routingConfig.loginRouteUrl);
        if (url && !isLoginPath) {
            this.router.navigateByUrl(url);
            return;
        }
        this.cleanUpUrl();
    }
    cleanUpUrl() {
        this.callSSOHandleMethod((handler, ssoParams) => {
            const cleanUrl = handler.getCleanUrl(ssoParams);
            if (cleanUrl && this.router.url != cleanUrl) {
                this.router.navigateByUrl(cleanUrl);
            }
            return of({ usedSSO: true, result: cleanUrl });
        });
    }
    authenticateSSO() {
        return this.callSSOHandleMethod((ssoHandler, ssoParams) => {
            this.dwSecurityStateService.startAuthenticating('Authenticating with Single Sign On', DwAuthenticationType.loginSSO);
            ssoHandler.authenticateSSO(ssoParams);
        });
    }
    reAuthenticateSSO() {
        return this.callSSOHandleMethod((ssoHandler, ssoParams) => {
            this.dwSecurityStateService.startRefresh();
            ssoHandler.reauthenticateSSO(ssoParams);
        });
    }
    getAccessToken() {
        return this.callSSOHandleMethod((ssoHandler, ssoParams) => ssoHandler.getAccessToken(ssoParams)).pipe(map(r => (r.result)));
    }
    logout() {
        return this.callSSOHandleMethod((ssoHandler, ssoParams) => {
            this.dwSecurityStateService.setSecurityMessage('Logging out of Single Sign On');
            ssoHandler.logout(ssoParams);
        });
    }
    redirectToSSOLogin(isLoginPath, tenantSSOConfigId) {
        let ob = this.securityRepository.getSSOConfig(tenantSSOConfigId);
        if (!tenantSSOConfigId) {
            ob = this.securityRepository.getSSOConfigForLoginButton();
        }
        return ob
            .pipe(mergeMap(ssoConfig => {
            if (!ssoConfig) {
                var result = {
                    usedSSO: false,
                };
                this.completeSSONoAction();
                return of(result);
            }
            this.dwSecurityStateService.setTenantSSOConfigId(ssoConfig.TenantSsoConfigId);
            return this.callSSOHandleMethod((ssoHandler, ssoParams) => {
                if (ssoParams.ssoConfig.EnableSSO) {
                    this.dwSecurityStateService.startAuthenticating('Redirecting to Single Sign On', DwAuthenticationType.loginSSO);
                }
                ssoHandler.redirectToSSOLogin(ssoParams);
            });
        }));
        return this.callSSOHandleMethod((ssoHandler, ssoParams) => {
            if (ssoParams.ssoConfig.EnableSSO) {
                this.dwSecurityStateService.startAuthenticating('Redirecting to Single Sign On', DwAuthenticationType.loginSSO);
            }
            ssoHandler.redirectToSSOLogin(ssoParams);
        });
    }
    createHandler(ssoConfig) {
        if (this.ssoHandler) {
            return this.ssoHandler;
        }
        this.ssoHandler = dwSecuritySsoHanlderFactory(this.injector, this.securityConfig, ssoConfig, this.loggingUtil);
        if (this.ssoHandler) {
            this.ssoHandler.init(ssoConfig);
        }
        return this.ssoHandler;
    }
    getSSOConfig() {
        return this.securityRepository.getSSOConfig(this.dwSecurityStateService.securityState.tenantSSOConfigId);
    }
}
DwSecuritySSOService.ɵfac = function DwSecuritySSOService_Factory(t) { return new (t || DwSecuritySSOService)(ɵngcc0.ɵɵinject(DwStorageUtil), ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwSecurityStateService)); };
DwSecuritySSOService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecuritySSOService_Factory() { return new DwSecuritySSOService(ɵɵinject(DwStorageUtil), ɵɵinject(DwLoggingService), ɵɵinject(DwSecurityRepositoryServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwCacheService), ɵɵinject(INJECTOR), ɵɵinject(Router), ɵɵinject(DwSecurityStateService)); }, token: DwSecuritySSOService, providedIn: "root" });
DwSecuritySSOService.ctorParameters = () => [
    { type: DwStorageUtil },
    { type: DwLoggingService },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwCacheService },
    { type: Injector },
    { type: Router },
    { type: DwSecurityStateService }
];

var DwSecurityTimeoutActions;
(function (DwSecurityTimeoutActions) {
    DwSecurityTimeoutActions[DwSecurityTimeoutActions["redirectToSSOLogin"] = 1] = "redirectToSSOLogin";
    DwSecurityTimeoutActions[DwSecurityTimeoutActions["logoutUserWithMessage"] = 2] = "logoutUserWithMessage";
    DwSecurityTimeoutActions[DwSecurityTimeoutActions["silentRefresh"] = 3] = "silentRefresh";
})(DwSecurityTimeoutActions || (DwSecurityTimeoutActions = {}));

const moment$3 = moment_;
class DwSecurityOrchestrationService {
    constructor(dwSecurityStateService, securityRepository, configService, securityUserService, dwEventService, dwMessagingService, router, ssoSecurityService, dwLoggingService) {
        this.dwSecurityStateService = dwSecurityStateService;
        this.securityRepository = securityRepository;
        this.configService = configService;
        this.securityUserService = securityUserService;
        this.dwEventService = dwEventService;
        this.dwMessagingService = dwMessagingService;
        this.router = router;
        this.ssoSecurityService = ssoSecurityService;
        this.dwLoggingService = dwLoggingService;
        this.securityConfig = configService.coreConfig.securityConfig;
        this.routingConfig = configService.coreConfig.routingConfig;
        this.initSecurity();
    }
    gotoLogin(message = 'Checking Authentication') {
        const isLoginPath = ('/' + this.routingConfig.loginRouteUrl == this.router.url);
        if (this.dwSecurityStateService.securityState.isAuthenticating) {
            return;
        }
        // let this get set within SSO so the login page doesn't flicker
        //this.dwSecurityStateService.startAuthenticating(message);
        // First try SSO, if that returns false, then if its not used we can go to the login route
        this.ssoSecurityService.redirectToSSOLogin(isLoginPath)
            .subscribe(result => {
            if (!result.usedSSO) {
                this.router.navigateByUrl(this.routingConfig.loginRouteUrl);
            }
        });
    }
    gotoSSOLogin(tenantSSOConfigId, message = 'Authenticating with SSO') {
        if (this.dwSecurityStateService.securityState.isAuthenticating) {
            const noResult = {
                usedSSO: false
            };
            return of(noResult);
        }
        //this.dwSecurityStateService.startAuthenticating(message);
        // First try SSO, if that returns false, then if its not used we can go to the login route
        return this.ssoSecurityService.redirectToSSOLogin(false, tenantSSOConfigId);
    }
    gotoUserProfile() {
        this.router.navigateByUrl(this.routingConfig.userProfileRouteUrl);
    }
    gotoUserRegistration() {
        this.router.navigateByUrl(this.routingConfig.userRegistrationRouteUrl);
    }
    redirectAfterLogin() {
        const securityState = this.dwSecurityStateService.securityState;
        const redirectUrl = this.dwSecurityStateService.getLastUrl();
        const isLoginPath = redirectUrl === null || redirectUrl === void 0 ? void 0 : redirectUrl.endsWith('/' + this.routingConfig.loginRouteUrl);
        if (redirectUrl && !isLoginPath) {
            console.log(`Redirectign to last ur of ${redirectUrl}`);
            this.router.navigateByUrl(redirectUrl);
            this.dwSecurityStateService.storeLastUrl(null);
        }
        else {
            this.router.navigateByUrl(this.routingConfig.defaultRouteUrl);
        }
    }
    handleAuthOperation(operationOb, message = null, authenticationType, isRefresh = false) {
        if (isRefresh) {
            this.dwSecurityStateService.startRefresh();
        }
        else {
            this.dwSecurityStateService.startAuthenticating(message, authenticationType);
        }
        try {
            return operationOb().pipe(tap(securityResult => this.dwSecurityStateService.processSecurityResult(securityResult)));
        }
        catch (e) {
            this.dwSecurityStateService.completeAuthenticating();
            return this.handleExceptionResult(e);
        }
    }
    authenticate(userName, password, twoFactorCode, suppressErrorMessages = false) {
        return this.handleAuthOperation(() => this.securityRepository.authenticate(userName, password, twoFactorCode, suppressErrorMessages), 'Logging In', DwAuthenticationType.login).pipe(tap(result => {
            if (result.success) {
                this.redirectAfterLogin();
            }
        }));
    }
    logout(message = 'Logging you out', logoutReason) {
        this.dwSecurityStateService.startAuthenticating(message, DwAuthenticationType.logout);
        this.securityRepository.logout(logoutReason)
            .subscribe(result => {
            this.finalizeLogout();
        }, error => {
            this.finalizeLogout();
        });
    }
    finalizeLogout() {
        setTimeout(() => {
            this.dwSecurityStateService.clearSecurityContext();
            this.router.navigateByUrl(this.routingConfig.defaultRouteUrl);
        }, 100);
    }
    reAuthenticate(securityToken, authenticationType, isRefresh = false) {
        return this.handleAuthOperation(() => this.securityRepository.reAuthenticate(securityToken), 'Authenticating', authenticationType, isRefresh);
    }
    authenticateSSO(tenantSSOConfigId) {
        this.dwSecurityStateService.setTenantSSOConfigId(tenantSSOConfigId);
        this.ssoSecurityService.authenticateSSO()
            .subscribe(result => {
            // if SSO isn't being used, go to the login route
            if (!result.usedSSO && false) { // turning off so you can navigate to the home page without getting redirected to the login page
                this.gotoLogin();
            }
        });
    }
    reAuthenticateSSO() {
        // Nothing to do here but call the method (it will preform callbacks to update state)
        this.ssoSecurityService.reAuthenticateSSO()
            .subscribe(result => {
            if (!result.usedSSO) {
                this.reAuthenticate(this.dwSecurityStateService.securityState.securityContext.SecurityToken, DwAuthenticationType.reauthenticateSSO, true)
                    .subscribe(result => {
                    this.dwLoggingService.logToConsole(`Refresh token successful`, result.result);
                });
            }
        });
    }
    handleExceptionResult(e) {
        let resultSubject = new Subject();
        let result = new DwSecurityResult();
        result.success = false;
        result.message = `Error - ${e.message}`;
        this.dwSecurityStateService.completeAuthenticating(result.message);
        return of(result);
    }
    initSecurity() {
        this.dwLoggingService.logToConsole(`Init Security - Url ${location.href}`);
        this.dwSecurityStateService.setInitialUrl(location.href);
        // Always set this when the app starts
        this.dwSecurityStateService.setLastUserInteraction();
        this.dwSecurityStateService.startAuthenticating('Initializing Security', DwAuthenticationType.init);
        let context = this.dwSecurityStateService.getSecurityContextFromStorage();
        this.dwLoggingService.logToConsole("Loading security context", context, DwLogSeverity.verbose);
        // Validate the security context
        context = this.validateContext(context);
        this.dwSecurityStateService.setSecuritySetupComplete(true);
        // Setup Authentication
        if (context != null) {
            // If the context exists, then go ahead and set it
            this.dwSecurityStateService.setSecurityContext(context);
        }
        else {
            // If there's no context, check for a security token, if it exists, reAuthenticate with the token
            let token = this.dwSecurityStateService.getSecurityTokenFromStorage();
            if (token) {
                this.reAuthenticate(token, DwAuthenticationType.reauthenticate)
                    .subscribe(r => {
                    this.dwLoggingService.logToConsole("Reauthenticate complete");
                });
            }
            else {
                // Otherwise, check if we have an sso config with auto login configured
                if (this.skipAutoSSOLogin()) {
                    this.dwSecurityStateService.completeAuthenticating();
                    return;
                }
                this.securityRepository.getSSOConfigForAutoLogin()
                    .subscribe((ssoConfig) => {
                    this.authenticateSSO(ssoConfig === null || ssoConfig === void 0 ? void 0 : ssoConfig.TenantSsoConfigId);
                });
            }
        }
        setInterval(() => this.checkSecurityContextTimeout(), this.securityConfig.securityTimeoutCheckInterval);
    }
    skipAutoSSOLogin() {
        if (!this.securityConfig.ssoSkipAutoLoginPaths) {
            return false;
        }
        const ssoAllowAnnynousPaths = ensureArray(this.securityConfig.ssoSkipAutoLoginPaths);
        const currentPath = location.pathname;
        for (let path of ssoAllowAnnynousPaths) {
            // do a starts with so children paths are automatically included
            if ((currentPath === null || currentPath === void 0 ? void 0 : currentPath.indexOf(path)) == 0) {
                return true;
            }
        }
        return false;
    }
    checkSecurityContextTimeout() {
        const securityState = this.dwSecurityStateService.securityState;
        if (securityState.isAuthenticating || securityState.isRefreshing || !securityState.isAuthenticated) {
            return;
        }
        // Check security token expiration
        if (this.isExpired(securityState.securityContext.SecurityTokenExpirationDateTime, this.securityConfig.securityRefresh.marginSeconds)) {
            this.dwLoggingService.logToConsole('Security token expired, starting refresh');
            // console.log('checkSecurityContextTimeout - Context expired!!!, lastUrl', this.router.url);
            switch (this.securityConfig.securityRefresh.action) {
                case DwSecurityTimeoutActions.logoutUserWithMessage:
                    this.logout(this.securityConfig.securityRefresh.logoutMessage, "Token expiration logout");
                    break;
                case DwSecurityTimeoutActions.redirectToSSOLogin:
                    this.gotoLogin('Re-authenticating with Single Sign On');
                    break;
                case DwSecurityTimeoutActions.silentRefresh:
                default:
                    this.reAuthenticateSSO();
            }
            return;
        }
        // Since our session is valid, not we check for inactivity
        this.checkSecurityInactivityTimeout();
    }
    checkSecurityInactivityTimeout() {
        const securityState = this.dwSecurityStateService.securityState;
        if (securityState.isAuthenticating || !securityState.isAuthenticated) {
            return;
        }
        const userInactivitiyConfig = this.securityUserService.getUserInactivityConfig(securityState);
        // Check if feature is enabeld
        if (!userInactivitiyConfig || !userInactivitiyConfig.logoutTimeoutMinutes) {
            return;
        }
        if (!securityState.lastUserInteractionDateTime) {
            this.dwSecurityStateService.setLastUserInteraction();
            return;
        }
        const timeoutDateTime = moment$3.utc(securityState.lastUserInteractionDateTime).add(userInactivitiyConfig.logoutTimeoutMinutes, "m").format();
        const warningDateTime = moment$3.utc(securityState.lastUserInteractionDateTime).add(userInactivitiyConfig.warningTimeoutMinutes, "m").format();
        //this.dwLoggingService.logToConsole(`Checking inactivity  Timeout:${timeoutDateTime}  Warning:${warningDateTime}`);
        if (this.isExpired(timeoutDateTime)) {
            this.dwLoggingService.logWarning(`User Inactivity - Logging out to to inactivity`);
            this.logout(userInactivitiyConfig.logoutMessage, "Inactivity logout");
            this.dwSecurityStateService.setInactivityDetails(false, true, userInactivitiyConfig.logoutMessage);
            // this.dwMessagingService.showMessage({
            //     messageHeading: userInactivitiyConfig.logoutMessage,
            //     severity: DwMessageSeverity.warning,
            //     forceClose: true,
            // });
            return;
        }
        if (this.isExpired(warningDateTime) && !this.dwSecurityStateService.securityState.inactivityWarningMessageSent) {
            this.dwLoggingService.logWarning(`User Inactivity - Displaying warning message`);
            this.dwSecurityStateService.setInactivityDetails(true, false, '');
            this.dwMessagingService.showMessage({
                messageHeading: userInactivitiyConfig.warningMessage,
                severity: DwMessageSeverity.warning
            });
            return;
        }
    }
    /**
     * Validates a security context to ensure it is valid for the api endpoint and hasn't expired
     * @param context
     */
    validateContext(context) {
        if (!context) {
            return null;
        }
        // Validate context was for same api end-point 
        if (this.configService.coreConfig.apiRoot !== context.ApiRoot) {
            console.warn('Security context does not match the original api.  Clearing out security context');
            this.dwSecurityStateService.clearSecurityContext();
            return null;
        }
        // Validate that the context isn't expired
        if (this.isExpired(context.SecurityTokenExpirationDateTime)) {
            console.warn('Security context has expired!  Clearing out security context');
            this.dwSecurityStateService.clearSecurityContext();
            return null;
        }
        return context;
    }
    isExpired(expirationDateTime, marginSeconds = 0) {
        if (!expirationDateTime) {
            return true;
        }
        let momentDate = moment$3.utc(expirationDateTime);
        momentDate = momentDate.add(-marginSeconds, 'seconds');
        if (momentDate.isSameOrAfter(moment$3())) {
            return false;
        }
        return true;
    }
}
DwSecurityOrchestrationService.ɵfac = function DwSecurityOrchestrationService_Factory(t) { return new (t || DwSecurityOrchestrationService)(ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwEventService), ɵngcc0.ɵɵinject(DwMessagingService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwSecuritySSOService), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwSecurityOrchestrationService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecurityOrchestrationService_Factory() { return new DwSecurityOrchestrationService(ɵɵinject(DwSecurityStateService), ɵɵinject(DwSecurityRepositoryServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwSecurityUserService), ɵɵinject(DwEventService), ɵɵinject(DwMessagingService), ɵɵinject(Router), ɵɵinject(DwSecuritySSOService), ɵɵinject(DwLoggingService)); }, token: DwSecurityOrchestrationService, providedIn: "root" });
DwSecurityOrchestrationService.ctorParameters = () => [
    { type: DwSecurityStateService },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityUserService },
    { type: DwEventService },
    { type: DwMessagingService },
    { type: Router },
    { type: DwSecuritySSOService },
    { type: DwLoggingService }
];

class DwAuthGuardService {
    constructor(routingService, securityStateService, securityOrchestrationService, logutil) {
        this.routingService = routingService;
        this.securityStateService = securityStateService;
        this.securityOrchestrationService = securityOrchestrationService;
        this.logutil = logutil;
    }
    canActivate(routeSnapshot, state) {
        let route = routeSnapshot.routeConfig;
        routeSnapshot.component;
        let menuData = route.data;
        if (!this.routingService.canAccessRoute(route)) {
            this.logutil.logVerbose(`Route - invalid permission for route ${menuData.display}`);
            this.securityStateService.storeLastUrl(state.url);
            if (!this.securityStateService.securityState.isAuthenticated) {
                this.securityOrchestrationService.gotoLogin();
            }
            return false;
        }
        this.securityStateService.setLastUserInteraction();
        this.routingService.currentPageUrl = state.url;
        return true;
    }
}
DwAuthGuardService.ɵfac = function DwAuthGuardService_Factory(t) { return new (t || DwAuthGuardService)(ɵngcc0.ɵɵinject(DwRoutingServiceToken), ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(DwSecurityOrchestrationService), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwAuthGuardService.ɵprov = ɵɵdefineInjectable({ factory: function DwAuthGuardService_Factory() { return new DwAuthGuardService(ɵɵinject(DwRoutingServiceToken), ɵɵinject(DwSecurityStateService), ɵɵinject(DwSecurityOrchestrationService), ɵɵinject(DwLoggingService)); }, token: DwAuthGuardService, providedIn: "root" });
DwAuthGuardService.ctorParameters = () => [
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] },
    { type: DwSecurityStateService },
    { type: DwSecurityOrchestrationService },
    { type: DwLoggingService }
];

var DwUiRegistryType;
(function (DwUiRegistryType) {
    DwUiRegistryType["containerStyles"] = "containerStyles";
    DwUiRegistryType["gridStyles"] = "gridStyles";
    DwUiRegistryType["listStyles"] = "listStyles";
    DwUiRegistryType["buttonContainerStyles"] = "buttonContainerStyles";
    DwUiRegistryType["gridColumn"] = "gridColumn";
    DwUiRegistryType["emailLists"] = "emailLists";
    DwUiRegistryType["formSections"] = "formSections";
    DwUiRegistryType["action"] = "action";
    DwUiRegistryType["routeTypeProcessor"] = "routeTypeProcessor";
    DwUiRegistryType["validationRule"] = "validationRule";
    DwUiRegistryType["customContext"] = "customContext";
    DwUiRegistryType["breadCrumbCustomizationProcessor"] = "breadCrumbCustomizationProcessor";
})(DwUiRegistryType || (DwUiRegistryType = {}));

class DwBreadcrumbMenu extends DwMenu {
    constructor() {
        super();
        this.data = {};
    }
}

class DwServiceExecutionUtil {
    constructor(injector, loggingService) {
        this.injector = injector;
        this.loggingService = loggingService;
    }
    createService(serviceType) {
        const instance = this.injector.get(serviceType);
        return instance;
    }
    executeServiceMethod(serviceType, methodName, ignoreMissing = false, ...params) {
        const instance = this.createService(serviceType);
        if (!instance) {
            return null;
        }
        // Get a reference to the function
        const func = instance[methodName];
        if (!func) {
            if (ignoreMissing) {
                return;
            }
            const errorMsg = `Could not execute method ${methodName} on serviceType ${serviceType}`;
            this.loggingService.logWarning(errorMsg);
            this.loggingService.logToConsole(errorMsg, serviceType);
            return null;
        }
        // Bind the function to the instance (so the bound function can reference this - otherwise it's null)
        const boundFunc = func.bind(instance);
        // Call the bound function
        return boundFunc(params);
    }
}
DwServiceExecutionUtil.ɵfac = function DwServiceExecutionUtil_Factory(t) { return new (t || DwServiceExecutionUtil)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwServiceExecutionUtil.ɵprov = ɵɵdefineInjectable({ factory: function DwServiceExecutionUtil_Factory() { return new DwServiceExecutionUtil(ɵɵinject(INJECTOR), ɵɵinject(DwLoggingService)); }, token: DwServiceExecutionUtil, providedIn: "root" });
DwServiceExecutionUtil.ctorParameters = () => [
    { type: Injector },
    { type: DwLoggingService }
];

class DwCanDeactivateGuard {
    canDeactivate(component, currentRoute, currentState, nextState) {
        const hasChildren = currentRoute.children.length > 0;
        if ((component === null || component === void 0 ? void 0 : component.canNavigate) && !hasChildren) {
            const result = component.canNavigate();
            if (!result) {
                return of(true);
            }
            return result;
        }
        return of(true);
    }
}
DwCanDeactivateGuard.ɵfac = function DwCanDeactivateGuard_Factory(t) { return new (t || DwCanDeactivateGuard)(); };
DwCanDeactivateGuard.ɵprov = ɵɵdefineInjectable({ factory: function DwCanDeactivateGuard_Factory() { return new DwCanDeactivateGuard(); }, token: DwCanDeactivateGuard, providedIn: "root" });

var __rest$1 = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class DwMenuBuilderService {
    constructor(dwMenuHelperService, dwSecurityUserService, dwUiConfigRegistryService, dwConfigService, dwServiceExecutionUtil, dwLoggingService) {
        this.dwMenuHelperService = dwMenuHelperService;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwConfigService = dwConfigService;
        this.dwServiceExecutionUtil = dwServiceExecutionUtil;
        this.dwLoggingService = dwLoggingService;
        this.rootKey = 'root';
        this.breadcrumbProcessors = [];
        this.createBreadcrumbProcessors();
    }
    createBreadcrumbProcessors() {
        const items = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.breadCrumbCustomizationProcessor);
        this.breadcrumbProcessors = [];
        for (const item of items) {
            if (item.service) {
                const service = this.dwServiceExecutionUtil.createService(item.service);
                if (service) {
                    this.breadcrumbProcessors.push(service);
                }
            }
        }
    }
    buildMenuHierarchy(allMenus, parentId) {
        let menuHierarchy = [];
        // Add all static routes first
        const topLevelStaticMenus = allMenus.filter(m => m.data.hasStaticRoute && ((!m.data.parentRouteId && !m.data.parentReferenceKey) || m.data.parentReferenceKey === this.rootKey));
        // Add top level static menus first so all other menus will have a place to tie to
        for (const topMenu of topLevelStaticMenus) {
            this.addHierarchyRoute(topMenu, menuHierarchy);
        }
        const topLevelMenus = allMenus.filter(m => !m.data.hasStaticRoute && ((!m.data.parentRouteId && !m.data.parentReferenceKey) || m.data.parentReferenceKey === this.rootKey));
        // Add top level menus next so other menus will have a place to tie to
        for (const topMenu of topLevelMenus) {
            this.addHierarchyRoute(topMenu, menuHierarchy);
        }
        const childMenus = allMenus.filter(m => (m.data.parentRouteId || m.data.parentReferenceKey) && m.data.parentReferenceKey !== this.rootKey);
        for (const childMenu of childMenus) {
            this.addHierarchyRoute(childMenu, menuHierarchy);
        }
        const menuKeys = {};
        menuHierarchy = this.updateHierarchyValues(menuHierarchy, menuKeys, null, null);
        this.checkDuplicateMenus(menuKeys);
        return menuHierarchy;
    }
    buildSideMenuReplacement(breadcrumbs, allMenuItems, params) {
        // Reverse so we get the deepest item first (otherwise the high menu always wins)
        const reversedBreadcrumbs = [...breadcrumbs].reverse();
        const parentMenu = reversedBreadcrumbs.find(bc => { var _a; return (_a = bc.data) === null || _a === void 0 ? void 0 : _a.replaceSideMenu; });
        if (!parentMenu) {
            return null;
        }
        const sideMenuReplacement = {
            parentMenu: parentMenu,
            replacementMenus: this.getParentMenus(parentMenu.children, true),
            backMenu: this.dwMenuHelperService.getMenuDirectParent(parentMenu, allMenuItems),
            hideBackMenu: false
        };
        // Replace any parameters in the child menus
        if (params.hasParams) {
            sideMenuReplacement.replacementMenus = this.replaceMenuParams(sideMenuReplacement.replacementMenus, params);
            sideMenuReplacement.backMenu = this.replaceMenuParam(sideMenuReplacement.backMenu, params);
            sideMenuReplacement.parentMenu = this.replaceMenuParam(sideMenuReplacement.parentMenu, params);
        }
        sideMenuReplacement.sideMenuComponent = parentMenu.data.sideMenuComponent;
        sideMenuReplacement.hideBackMenu = !!parentMenu.data.hideReplaceSideMenuBackButton;
        return sideMenuReplacement;
    }
    replaceMenuParams(menus, params) {
        if (params === null || params === void 0 ? void 0 : params.hasParams) {
            menus = menus || [];
            const finalMenus = [];
            for (const menu of menus) {
                const newMenu = this.replaceMenuParam(menu, params);
                finalMenus.push(newMenu);
            }
            return finalMenus;
        }
        return menus;
    }
    replaceMenuParam(menu, params) {
        if (!menu) {
            return menu;
        }
        const newUrl = this.replaceUrlParams(menu.url, params);
        if (menu.url != newUrl) {
            const newMenu = deepCopy(menu);
            newMenu.url = newUrl;
            return newMenu;
        }
        return menu;
    }
    replaceUrlParams(url, params) {
        if (!url || url.indexOf(':') >= 0 || !params.hasParams) {
            let newUrl = url;
            for (const paramName of (params === null || params === void 0 ? void 0 : params.keys) || []) {
                const paramValue = params.get(paramName);
                newUrl = newUrl.replace(`:${paramName}`, paramValue);
            }
            return newUrl;
        }
        return url;
    }
    getUrlParams(url) {
        const params = [];
        if (!url || url.indexOf(':') < 0) {
            return params;
        }
        let index = url.indexOf(':');
        let count = 0;
        while (index >= 0) {
            let stopIndex = url.indexOf('/', index + 1);
            if (stopIndex == -1) {
                stopIndex = url.length;
            }
            const paramName = url.substring(index + 1, stopIndex);
            params.push(paramName);
            index = url.indexOf(':', stopIndex);
            count++;
            if (count > 10) {
                return params;
            }
        }
        return params;
    }
    updateHierarchyValues(menus, menuKeys, baseUrl = '', parentMenu) {
        var _a, _b;
        if (!menus) {
            return;
        }
        menuKeys = menuKeys || {};
        for (const menu of menus) {
            let url = '/' + menu.path;
            if (baseUrl && baseUrl.length > 0 && baseUrl != '/') {
                url = baseUrl + url;
            }
            menu.isActionChild = menu.data.isChild;
            if (!menu.isActionChild) {
                const parentId = parentMenu ? parentMenu.data.routeId : 0;
                menu.isActionChild = (parentId && parentId == menu.data.routeId);
            }
            menu.url = url;
            menu.menuKey = this.buildMenuKey(menu, menu.isActionChild, parentMenu);
            this.trackDuplicateMenus(menu, menuKeys);
            menu.children = this.updateHierarchyValues(menu.children, menuKeys, url, menu);
            // Check special navigation options after updating children since now they will be sorted
            if (((_a = menu.data) === null || _a === void 0 ? void 0 : _a.navigateToFirstChild) && ((_b = menu.children) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                const childUrl = menu.children[0].path;
                menu.url = menu.url + '/' + childUrl;
            }
        }
        // sort hierarchy
        menus = this.dwMenuHelperService.sortMenus(menus);
        return menus;
    }
    trackDuplicateMenus(menu, menuKeys) {
        let menuKey = menuKeys[menu.menuKey];
        if (!menuKey) {
            menuKey = {
                menus: []
            };
            menuKeys[menu.menuKey] = menuKey;
        }
        else {
            const dup = true;
        }
        menuKey.menus.push(menu);
    }
    checkDuplicateMenus(menuKeys) {
        var _a, _b;
        for (const key in menuKeys) {
            if (menuKeys.hasOwnProperty(key)) {
                const menuKey = menuKeys[key];
                if (menuKey.menus.length > 1) {
                    if ((_b = (_a = menuKey.menus[0].data) === null || _a === void 0 ? void 0 : _a.childListMenuOptions) === null || _b === void 0 ? void 0 : _b.isChildListMenu) {
                        continue;
                    }
                    //TODO: make these menus unique
                    // this.dwLoggingService.logWarning(`Menu key ${key} is being used for ${menuKey.menus.length} menus and should be unique!`, menuKey.menus);
                }
            }
        }
    }
    buildMenuKey(menu, isChild, parentMenu) {
        let baseKey = menu.data.routeId || menu.data.referenceKey;
        if (isChild) {
            baseKey = parentMenu.data.routeId || parentMenu.data.referenceKey;
            return `${baseKey}-${menu.data.metaDataActionType}`;
        }
        return `${baseKey}`;
    }
    addHierarchyRoute(menu, menuHierarchy) {
        var _a, _b, _c, _d;
        const parentRouteId = menu.data.parentRouteId;
        let siblingMenus;
        if ((!parentRouteId && !menu.data.parentReferenceKey) || menu.data.parentReferenceKey == this.rootKey) {
            siblingMenus = menuHierarchy;
        }
        else {
            const parent = this.dwMenuHelperService.findMenu(r => this.matchParent(menu, r), menuHierarchy);
            if (!parent) {
                console.warn(`Could not find parent of ${parentRouteId || menu.data.parentReferenceKey} for menu ${menu.display}`);
                return;
            }
            siblingMenus = parent.children = parent.children || [];
            ;
        }
        const routeId = menu.data.routeId ? menu.data.routeId.toString() : null;
        const existingMenu = siblingMenus.find(r => this.dwMenuHelperService.isMenuMatch(r, menu, true, true));
        if ((_b = (_a = menu.data) === null || _a === void 0 ? void 0 : _a.childListMenuOptions) === null || _b === void 0 ? void 0 : _b.isChildListMenu) {
            const childListMenuOptions = menu.data.childListMenuOptions;
            siblingMenus.forEach(sibling => {
                var _a, _b, _c, _d;
                if (((_a = sibling.data) === null || _a === void 0 ? void 0 : _a.isChild) && (((_b = sibling.data) === null || _b === void 0 ? void 0 : _b.metaDataActionType) == 'edit' && childListMenuOptions.showOnEditChild
                    || ((_c = sibling.data) === null || _c === void 0 ? void 0 : _c.metaDataActionType) == 'view' && childListMenuOptions.showOnViewChild
                    || ((_d = sibling.data) === null || _d === void 0 ? void 0 : _d.metaDataActionType) == 'print' && childListMenuOptions.showOnPrintChild)) {
                    sibling.children = sibling.children || [];
                    const newChildMenu = deepCopyFullObject(menu);
                    sibling.children.push(newChildMenu);
                }
            });
            if (childListMenuOptions.showOnParent) {
                siblingMenus.push(menu);
            }
            return;
        }
        if (!existingMenu) {
            siblingMenus.push(menu);
            return;
        }
        let newChildren = menu.children;
        const existingChildren = existingMenu.children;
        let useExistingChildren = false;
        if (menu.data.extInfo && menu.data.extInfo.routeItemId) {
            Object.assign(existingMenu, menu);
        }
        else {
            existingMenu.data = Object.assign(Object.assign({}, menu.data), existingMenu.data);
            if ((_d = (_c = existingMenu === null || existingMenu === void 0 ? void 0 : existingMenu.data) === null || _c === void 0 ? void 0 : _c.extInfo) === null || _d === void 0 ? void 0 : _d.routeItemId) {
                // if the current menu
                useExistingChildren = true;
            }
        }
        existingMenu.data.hasStaticRoute = existingMenu.data.hasStaticRoute || menu.data.hasStaticRoute;
        existingMenu.children = this.mergeChildren(existingChildren, newChildren, useExistingChildren);
    }
    mergeChildren(children, newChildren, useExistingChildren) {
        // Update to use existing children based on paramter - this fixes a bug where the child config path from menu admin was being overriden for built in routes (e.g. /security/users/edit/1 - alwasys used a blank configKeyPart instead of what was configured in Menu Admin)
        var mainList = (useExistingChildren ? children : newChildren) || [];
        var secondList = (!useExistingChildren ? children : newChildren) || [];
        const returnChildren = secondList || [];
        for (const newChild of mainList || []) {
            const matchingChild = secondList.find(child => this.dwMenuHelperService.isMenuMatch(child, newChild, true, true));
            if (matchingChild) {
                matchingChild.data = Object.assign(Object.assign({}, matchingChild.data), newChild.data);
                // If either has a static route, then the new one should
                matchingChild.data.hasStaticRoute = matchingChild.data.hasStaticRoute || newChild.data.hasStaticRoute;
                // Only if both children are a static child should the final menu be a static  child
                matchingChild.data.isChild = matchingChild.data.isChild || newChild.data.isChild;
                if (newChild.children) {
                    // Children match, so now we need to merge their children
                    matchingChild.children = this.mergeChildren(matchingChild.children, newChild.children, useExistingChildren);
                }
            }
            else {
                if (!(newChild.data.isChild && newChild.data.hasStaticRoute)) {
                    returnChildren.push(newChild);
                }
            }
        }
        return returnChildren;
    }
    matchParent(currentMenu, referenceMenu) {
        if (currentMenu.data.parentRouteId) {
            if (currentMenu.data.parentRouteId === referenceMenu.data.routeId) {
                return true;
            }
            return false;
        }
        if (currentMenu.data.parentReferenceKey && referenceMenu.data.referenceKey) {
            if (currentMenu.data.parentReferenceKey === referenceMenu.data.referenceKey) {
                return true;
            }
        }
        return false;
    }
    buildMenusFromRoutes(routeHierarchy, baseUrl) {
        const routes = [];
        for (const route of routeHierarchy) {
            const convertedRoute = this.convertRouteToMenu(route, baseUrl);
            if (convertedRoute) {
                if (Array.isArray(convertedRoute)) {
                    for (var childRoute of convertedRoute) {
                        routes.push(childRoute);
                    }
                }
                else {
                    routes.push(convertedRoute);
                }
            }
        }
        return routes;
    }
    buildRoutesFromMenus(menus) {
        const finalRoutes = [];
        if (!menus) {
            return finalRoutes;
        }
        for (const menu of menus) {
            const route = this.buildRouteFromMenu(menu, menus);
            finalRoutes.push(route);
        }
        // Check if a menu with ** exists and if so, move it to the end since it will supersede anything after it
        const catchAllPath = finalRoutes.find(r => r.path == '**');
        if (catchAllPath) {
            const index = finalRoutes.indexOf(catchAllPath);
            finalRoutes.splice(index, 1);
            finalRoutes.push(catchAllPath);
        }
        return finalRoutes;
    }
    buildRouteFromMenu(menu, siblingMenus) {
        let canActivateGuards = this.dwConfigService.coreConfig.routingConfig.defaultCanActivateGuards || [];
        if (canActivateGuards.length == 0) {
            canActivateGuards = [DwAuthGuardService];
        }
        let canDeactivateGuards = this.dwConfigService.coreConfig.routingConfig.defaultCanDeactivateGuards || [];
        if (canDeactivateGuards.length == 0) {
            canDeactivateGuards = [DwCanDeactivateGuard];
        }
        const route = {
            path: menu.path,
            component: menu.component,
            canActivate: canActivateGuards,
            canDeactivate: canDeactivateGuards,
            children: [],
            data: menu.data,
        };
        route.children = this.buildRoutesFromMenus(menu.children);
        return route;
    }
    buildMenusCategories(categories, allMenus) {
        const securityTrimmedMenus = this.securityTrimMenus(allMenus);
        const categoryMap = new Map();
        for (const category of categories) {
            const categoryMenus = this.buildMenusByCategory(category, securityTrimmedMenus);
            categoryMap.set(category, categoryMenus);
        }
        return categoryMap;
    }
    buildMenusByCategory(category, allMenus, removeHiddenItems = true) {
        if (!category) {
            category = defaultMenuCategory;
        }
        category = category.toLowerCase();
        const findCategoryMenuFunc = (menu) => {
            const menuCategory = (menu.data.category || defaultMenuCategory).toLowerCase();
            if (category !== menuCategory) {
                return false;
            }
            if ((menu.data.showInMenu === false || menu.data.visibleRuleResult === false) && removeHiddenItems) {
                return false;
            }
            if (menu.data.excludeFromMainMenu && removeHiddenItems) {
                return false;
            }
            return true;
        };
        const hierarchy = this.dwMenuHelperService.filterMenuHierarchy(findCategoryMenuFunc, allMenus);
        return hierarchy;
    }
    getParentMenus(menus, removeHiddenItems = true, maxLevels = 1) {
        const findCategoryMenuFunc = (menu) => {
            if ((menu.data.showInMenu === false || menu.data.visibleRuleResult === false) && removeHiddenItems) {
                return false;
            }
            return true;
        };
        const hierarchy = this.dwMenuHelperService.filterMenuHierarchy(findCategoryMenuFunc, menus, maxLevels);
        return hierarchy;
    }
    securityTrimMenus(menus) {
        const finalMenus = [];
        if (!menus) {
            return finalMenus;
        }
        for (const menu of menus) {
            if (this.dwMenuHelperService.canAccessMenu(menu)) {
                const { children } = menu, menuNoChildren = __rest$1(menu, ["children"]);
                const newMenu = Object.assign(Object.assign({}, menuNoChildren), { children: this.securityTrimMenus(menu.children) });
                menu.data.visibleRuleResult = this.dwMenuHelperService.canViewMenuFromProcessors(menu);
                finalMenus.push(newMenu);
            }
        }
        return finalMenus;
    }
    buildBreadcrumbMenus(routeSnapshot, url, allMenus, breadcrumbs) {
        breadcrumbs = breadcrumbs || [];
        if (!routeSnapshot) {
            return breadcrumbs;
        }
        url += '/' + routeSnapshot.url.map(segment => {
            return segment.path;
        }).join('/');
        const breadcrumb = this.buildBreadCrumbMenu(routeSnapshot, url, allMenus);
        if (this.shouldAddBreadcrumb(breadcrumbs, breadcrumb)) {
            breadcrumbs.push(breadcrumb);
        }
        return this.buildBreadcrumbMenus(routeSnapshot.firstChild, url, allMenus, breadcrumbs);
    }
    buildBreadCrumbMenu(routeSnapshot, url, allMenus) {
        let menuData = routeSnapshot.data || {};
        let breadcrumbMenu;
        const menu = this.dwMenuHelperService.findMenuByData(menuData, allMenus);
        if (!menu) {
            return this.buildBreadCrumbMenuMissing(routeSnapshot, url);
        }
        return this.buildBreadCrumbMenuFromMenu(routeSnapshot, url, menu, menuData);
    }
    buildBreadCrumbMenuMissing(routeSnapshot, url) {
        const breadcrumbMenu = new DwBreadcrumbMenu();
        breadcrumbMenu.breadcrumbDisplay = 'Page not Found';
        breadcrumbMenu.finalUrl = url;
        breadcrumbMenu.url = url;
        if (url == '/') {
            breadcrumbMenu.breadcrumbDisplay = 'Home';
        }
        return breadcrumbMenu;
    }
    buildBreadCrumbMenuFromMenu(routeSnapshot, url, menu, menuData) {
        const breadcrumbMenu = Object.assign(Object.assign({}, deepCopy(menu)), { finalUrl: url, breadcrumbDisplay: menu.display, metaDataItem: menuData.metaDataItem });
        /*
            This logic was moved in to breadcrumb customizers to add additional flexibility

            if (routeSnapshot.params.itemName && breadcrumbMenu.data) {
           breadcrumbMenu.metaDataItem = routeSnapshot.params.itemName;

            breadcrumbMenu.breadcrumbDisplay =  addSpaces(routeSnapshot.params.itemName);
        } else if (menuData.breadCrumbDisplayParam) {
            breadcrumbMenu.breadcrumbDisplay = this.getParamDisplay(routeSnapshot, menuData.breadCrumbDisplayParam);
        }*/
        this.executeBreadcrumbProcessors(breadcrumbMenu, routeSnapshot, url, menu, menuData);
        return breadcrumbMenu;
    }
    executeBreadcrumbProcessors(breadcrumbMenu, routeSnapshot, url, menu, menuData) {
        for (const bcProcessor of this.breadcrumbProcessors) {
            //if (bcProcessor && bcProcessor.)
            if (bcProcessor === null || bcProcessor === void 0 ? void 0 : bcProcessor.processBreadcrumb) {
                try {
                    bcProcessor.processBreadcrumb(breadcrumbMenu, routeSnapshot, url, menu, menuData);
                }
                catch (error) {
                    console.warn(`Breadcrumb processor failed on menu ${breadcrumbMenu.display} with error`, error);
                }
            }
        }
    }
    convertRouteToMenu(route, baseUrl) {
        let url = '/' + route.path;
        if (baseUrl && baseUrl.length > 0 && baseUrl != '/') {
            url = baseUrl + url;
        }
        baseUrl = url;
        const menu = new DwMenu();
        let routeData = route.data || {};
        menu.url = url;
        menu.display = route.path;
        menu.data = routeData;
        menu.path = route.path;
        menu.component = route.component;
        //menu.menuComponent = route.menuComponent;
        menu.data.referenceKey = menu.data.referenceKey || menu.path;
        if (!routeData.routeId) {
            routeData.hasStaticRoute = true;
        }
        if (route.parentName) {
            menu.data.parentReferenceKey = route.parentName;
        }
        let { children } = route, routeWithoutChildren = __rest$1(route, ["children"]);
        const routeCopy = Object.assign(Object.assign({}, routeWithoutChildren), { children: [] });
        menu.routeRef = routeCopy;
        children = this.getRouteChildren(route);
        if (routeData && !routeData.skipMenu) {
            menu.display = routeData.display;
        }
        else {
            // Skip adding node and continue with it's children (This removes items in the hierarchy that you don't want displayed in menus)
            if (children.length > 0) {
                var convertedRoutes = [];
                return this.buildMenusFromRoutes(children, baseUrl);
            }
            return null;
        }
        if (children.length > 0) {
            menu.children = [];
            menu.children = this.buildMenusFromRoutes(children, baseUrl);
            // If no routes were added, then make children null so they're render in the menu correctly
            if (menu.children.length == 0)
                menu.children = null;
        }
        return menu;
    }
    getRouteChildren(route) {
        // Handle standard children
        if (route.children && route.children.length > 0) {
            return route.children;
        }
        // Handle lazy loaded children
        if (route._loadedConfig) {
            const lazyChildren = route._loadedConfig.routes || [];
            return lazyChildren;
        }
        return [];
    }
    getParamDisplay(route, paramName) {
        let params = route.params;
        paramName = paramName.replace(':', '');
        let display = params[paramName];
        display = makeTitleCase(display);
        return display;
    }
    shouldAddBreadcrumb(breadcrumbs, breadcrumb) {
        if (breadcrumbs.length == 0) {
            return true;
        }
        if (!breadcrumb.display)
            return false;
        for (let currentBreadcrumb of breadcrumbs) {
            if (currentBreadcrumb.breadcrumbDisplay == breadcrumb.breadcrumbDisplay)
                return false;
        }
        if (breadcrumb.data.hideBreadcrumbParent && breadcrumbs.length > 0) {
            // Remove previous item
            breadcrumbs.splice(breadcrumbs.length - 1, 1);
        }
        return true;
    }
}
DwMenuBuilderService.ɵfac = function DwMenuBuilderService_Factory(t) { return new (t || DwMenuBuilderService)(ɵngcc0.ɵɵinject(DwMenuHelperService), ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwServiceExecutionUtil), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwMenuBuilderService.ɵprov = ɵɵdefineInjectable({ factory: function DwMenuBuilderService_Factory() { return new DwMenuBuilderService(ɵɵinject(DwMenuHelperService), ɵɵinject(DwSecurityUserService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwServiceExecutionUtil), ɵɵinject(DwLoggingService)); }, token: DwMenuBuilderService, providedIn: "root" });
DwMenuBuilderService.ctorParameters = () => [
    { type: DwMenuHelperService },
    { type: DwSecurityUserService },
    { type: DwUiConfigRegistryService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwServiceExecutionUtil },
    { type: DwLoggingService }
];

const dwDefaultStandardColors = [
    {
        name: 'blue',
        display: 'Blue',
        foregroundClass: 'dw-blue',
        backgroundClass: 'dw-blue-bg'
    },
    {
        name: 'green',
        display: 'Green',
        foregroundClass: 'dw-green',
        backgroundClass: 'dw-green-bg'
    },
    {
        name: 'yellow',
        display: 'Yellow',
        foregroundClass: 'dw-yellow',
        backgroundClass: 'dw-yellow-bg'
    },
    {
        name: 'orange',
        display: 'Orange',
        foregroundClass: 'dw-orange',
        backgroundClass: 'dw-orange-bg'
    },
    {
        name: 'red',
        display: 'Red',
        foregroundClass: 'dw-red',
        backgroundClass: 'dw-red-bg'
    }, {
        name: 'purple',
        display: 'Purple',
        foregroundClass: 'dw-purple',
        backgroundClass: 'dw-purple-bg'
    },
    {
        name: 'brown',
        display: 'Brown',
        foregroundClass: 'dw-brown',
        backgroundClass: 'dw-brown-bg'
    },
    {
        name: 'agua',
        display: 'Agua',
        foregroundClass: 'dw-agua',
        backgroundClass: 'dw-agua-bg'
    },
    {
        name: 'gray',
        display: 'Gray',
        foregroundClass: 'dw-gray',
        backgroundClass: 'dw-gray-bg'
    },
    {
        name: 'white',
        display: 'White',
        foregroundClass: 'dw-white',
        backgroundClass: 'dw-white-bg'
    },
    {
        name: 'black',
        display: 'Black',
        foregroundClass: 'dw-black',
        backgroundClass: 'dw-black-bg'
    },
];

const DwUiConfigName = 'DwUiConfig';
class DwUIConfigDefaults {
    constructor() {
        this.messagingHideDelay = 1000; // In Milliseconds
        this.showContactUs = false;
        this.readonlyControlMissingDataText = 'None';
        // Default page setup
        this.pageFooterHeight = 0;
        this.pageHeaderHeight = 90;
        this.gridFooterHeight = 25;
        this.pageMargin = 35;
        this.showFooter = true;
        this.showDevwareLogo = true;
        this.alwaysShowConfigIcon = false;
        this.defaultAvatarImageUrl = '/assets/img/user-avatar.png';
        this.defaultBackgroundImageUrl = '/assets/img/user-banner.png';
        this.uiConfigTimeout = 15000;
        this.enableThemes = false;
        this.menuCategories = [
            'sideMenu',
            'topMenu',
            'userMenu',
            'bottomMenu'
        ];
        this.sideMenuParents = [
            {
                routeReferenceKey: 'data',
                childLevels: 1
            }
        ];
        this.defaultButtonConfig = {
            useButtonDefaults: true,
            useParentDisplay: true,
            buttonType: DwButtonType.standard,
            buttonClass: 'btn btn-success',
        };
        this.responsizeColumns = [
            {
                columns: 1
            },
            {
                minSizePx: 768,
                columns: 4
            },
            {
                minSizePx: 922,
                columns: 6
            },
            {
                minSizePx: 1200,
                columns: 8
            },
        ];
        this.styleConfig = {
            standardColors: dwDefaultStandardColors,
            standardStyles: [],
            standardClasses: [],
            iconSets: []
        };
        // emailValidationRegEx = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        this.emailValidationRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        this.calcDebounceTime = 50;
        this.calcInitialDelay = 250;
        this.securityInfoConfig = {
            showWelcome: true,
        };
    }
}

class DwMenuParams {
    constructor(menuParams) {
        //private map = new Map<string, string>();
        this.map = {};
        this.menus = [];
        this._hasParams = false;
        if (menuParams) {
            this.map = menuParams.map;
            this.menus = menuParams.menus;
            this._hasParams = menuParams._hasParams;
        }
    }
    ;
    addParams(paramMap, menuData) {
        const menuParamData = {
            itemName: menuData.metaDataItem,
            menuData: menuData,
            map: new Map()
        };
        this.menus.push(menuParamData);
        for (const paramName of (paramMap === null || paramMap === void 0 ? void 0 : paramMap.keys) || []) {
            const paramValue = paramMap.get(paramName);
            menuParamData.map.set(paramName, paramValue);
            this.map[paramName] = paramValue;
            this._hasParams = true;
        }
    }
    getAllParams() {
        const params = [];
        for (const paramName in this.map) {
            if (this.map.hasOwnProperty(paramName)) {
                const paramValue = this.map[paramName];
                params.push({
                    paramName: paramName, paramValue: this.map[paramName]
                });
            }
        }
        return params;
    }
    hasKey(keyName) {
        return this.hasKey(keyName);
    }
    get(keyName) {
        if (!keyName) {
            return null;
        }
        if (keyName.indexOf(':') >= 0) {
            keyName = keyName.replace(':', '');
        }
        return this.map[keyName];
    }
    getAllMenuData() {
        return this.menus;
    }
    getParamValue(paramName) {
    }
    // getMenuDataParamValue(itemName: string): any {
    //     if (!itemName) {
    //         return null;
    //     }
    //     const menu = this.menus.find(m => m.itemName?.toUpperCase() == itemName.toUpperCase());
    //     if (menu) {
    //         const paramName = getMenuActionParamName(itemName);
    //         return this.get(paramName);
    //     }
    //     return this.menus;
    // }
    get hasParams() {
        return this._hasParams;
    }
    get keys() {
        return this.getAllParams().map(p => p.paramName);
        //return Array.from(this.map.keys());
    }
}

const DW_REFRESH_MENU_EVENT = 'DW_REFRESH_MENU_EVENT';
class DwMenuService {
    constructor(dwMenuBuilderService, dwMenuHelperService, router, activatedRoute, securityUserService, dwEventService, configService, uiConfig, dwMenuProcessors) {
        this.dwMenuBuilderService = dwMenuBuilderService;
        this.dwMenuHelperService = dwMenuHelperService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.securityUserService = securityUserService;
        this.dwEventService = dwEventService;
        this.configService = configService;
        this.uiConfig = uiConfig;
        this.dwMenuProcessors = dwMenuProcessors;
        this.subscriptions = [];
        this.routingConfig = configService.coreConfig.routingConfig;
        if (!this.uiConfig) {
            this.uiConfig = configService.getConfig(DwUiConfigName, new DwUIConfigDefaults());
        }
        this.initMenuState();
        this.setupSubscriptions();
    }
    get menuState() {
        return DwMenuService._menuServiceState.value;
    }
    get menuStateObservable() {
        return DwMenuService._menuServiceState.asObservable();
    }
    /**
     * Gets a url parameter (not query string) from the current menu and it's hierarchy (used to get values from the url)
     * @param parameterName
     * @returns
     */
    getMenuParam(parameterName) {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.menuState) === null || _a === void 0 ? void 0 : _a.currentParams) === null || _b === void 0 ? void 0 : _b.get)) {
            return null;
        }
        return (_d = (_c = this.menuState) === null || _c === void 0 ? void 0 : _c.currentParams) === null || _d === void 0 ? void 0 : _d.get('dw_FeatureAreaId');
    }
    setAllMenuItems(allMenuItems) {
        const newState = Object.assign({}, this.menuState);
        newState.allMenuItems = allMenuItems;
        newState.currentParams = this.getCurrentRouteParams();
        // this.setupMenuProcessorSubscriptions(allMenuItems);
        this.setupFinalMenuState(newState, newState.allMenuItems);
        const routes = this.dwMenuBuilderService.buildRoutesFromMenus(allMenuItems);
        this.router.resetConfig(routes);
        this.processMenus(newState.allMenuItems);
    }
    setupFinalMenuState(newState, finalMenus) {
        // If we don't have any menus, we're finished
        newState.allMenuItems = finalMenus;
        newState.securedMenus = this.dwMenuBuilderService.securityTrimMenus(finalMenus);
        newState.breadcrumbs = this.dwMenuBuilderService.buildBreadcrumbMenus(this.activatedRoute.root.snapshot, '', finalMenus);
        newState.menusByCategory = this.dwMenuBuilderService.buildMenusCategories(this.uiConfig.menuCategories, finalMenus);
        newState.replacementSideMenu = this.dwMenuBuilderService.buildSideMenuReplacement(newState.breadcrumbs, finalMenus, newState.currentParams);
        newState.currentMenu = this.getCurrentMenu(newState);
        this.setMenuState(newState);
    }
    processMenus(allMenuItems) {
        // If we don't have any menus, we're finished
        if (!allMenuItems) {
            return;
        }
        this.processAllMenus(allMenuItems)
            .subscribe(finalMenus => {
            const newState = deepCopy(this.menuState);
            this.setupFinalMenuState(newState, finalMenus);
        });
    }
    processAllMenus(allMenus) {
        const obs = [];
        ;
        if (!this.dwMenuProcessors || this.dwMenuProcessors.length == 0) {
            return of(allMenus);
        }
        if (this.menuSubscription) {
            this.menuSubscription.unsubscribe();
            this.refreshSubject.complete();
        }
        this.refreshSubject = new Subject();
        // Init all Menus
        for (const menuProcessor of this.dwMenuProcessors) {
            if (menuProcessor.initProcessor) {
                const ob = menuProcessor.initProcessor(allMenus, this.refreshSubject);
                if (ob === null || ob === void 0 ? void 0 : ob.subscribe) {
                    obs.push(ob);
                }
            }
        }
        if (obs.length == 0) {
            obs.push(of(null));
        }
        this.menuSubscription = this.refreshSubject
            .pipe(debounceTime(10)) // Wait 200ms for any duplicate changes
            .subscribe(() => {
            //console.log('Updated menu state from menu processor invalidations');
            this.processAllMenus(this.menuState.allMenuItems)
                .subscribe(finalMenus => {
                const newState = deepCopy(this.menuState);
                this.setupFinalMenuState(newState, finalMenus);
            });
        });
        return combineLatest(obs)
            .pipe(map(() => {
            let currentMenus = [...allMenus];
            for (const menuProcessor of this.dwMenuProcessors || []) {
                currentMenus = menuProcessor.processAllMenus(currentMenus);
            }
            return currentMenus;
        }));
    }
    getMenuHierarchy(category) {
        if (!category) {
            category = defaultMenuCategory;
        }
        return this.menuState.menusByCategory.get(category) || [];
    }
    getMenuByKey(menuKey) {
        return this.dwMenuHelperService.findMenuByKey(menuKey, this.menuState.allMenuItems);
    }
    getParentMenuItem(currentMenu) {
        if (!currentMenu) {
            const currentMenu = this.menuState.currentMenu;
        }
        if (!currentMenu) {
            return null;
        }
        const findMenu = (menu) => {
            return this.dwMenuHelperService.isMenuMatch(menu, currentMenu);
        };
        return this.dwMenuHelperService.findParentMenu(findMenu, this.menuState.allMenuItems);
    }
    isMenuInBreadcrumb(item) {
        const breadcrumbs = this.menuState.breadcrumbs;
        const found = breadcrumbs.find(i => this.dwMenuHelperService.isMenuMatch(i, item));
        return !!found;
    }
    handleRoutingChange(isSecurityChange) {
        var _a, _b;
        const newState = Object.assign({}, this.menuState);
        newState.securedMenus = this.dwMenuBuilderService.securityTrimMenus(newState.allMenuItems);
        if (isSecurityChange) {
            newState.menusByCategory = this.dwMenuBuilderService.buildMenusCategories(this.uiConfig.menuCategories, newState.securedMenus);
        }
        newState.currentParams = this.getCurrentRouteParams();
        newState.breadcrumbs = this.dwMenuBuilderService.buildBreadcrumbMenus(this.activatedRoute.root.snapshot, '', newState.securedMenus);
        newState.replacementSideMenu = this.dwMenuBuilderService.buildSideMenuReplacement(newState.breadcrumbs, newState.securedMenus, newState.currentParams);
        const currentMenu = this.getCurrentMenu(newState);
        if (isSecurityChange && ((_a = newState.currentMenu) === null || _a === void 0 ? void 0 : _a.url) != (currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.url)) {
            if ((_b = newState.currentMenu) === null || _b === void 0 ? void 0 : _b.url) {
                if (currentMenu === null || currentMenu === void 0 ? void 0 : currentMenu.url) {
                    this.router.navigateByUrl(currentMenu.url);
                }
            }
        }
        newState.currentMenu = this.getCurrentMenu(newState);
        this.setMenuState(newState);
    }
    getCurrentRouteParams() {
        let child = this.activatedRoute.firstChild;
        let paramMap;
        const menuParams = new DwMenuParams();
        while (child) {
            const menuData = child.snapshot.data;
            menuParams.addParams(child.snapshot.paramMap, menuData);
            child = child.firstChild;
        }
        return menuParams;
    }
    getCurrentMenu(state) {
        const currentMenu = state.breadcrumbs[state.breadcrumbs.length - 1];
        if (!currentMenu) {
            return null;
        }
        let menu = this.dwMenuHelperService.findMenuByData(currentMenu.data, state.securedMenus);
        if (!menu) {
            menu = this.dwMenuHelperService.findMenu(m => m.url == currentMenu.url, state.securedMenus);
        }
        return menu;
    }
    ensureCurrentRouteIsValid() {
        const isValid = this.isCurrentRouteValid();
        // If the current route is no longer valid, then redirect to the default route
        if (!isValid) {
            this.router.navigateByUrl(this.routingConfig.defaultRouteUrl);
        }
    }
    isCurrentRouteValid() {
        const currentMenu = this.menuState.currentMenu;
        if (!currentMenu) {
            return false;
        }
        return this.dwMenuHelperService.canAccessMenu(currentMenu);
    }
    initMenuState() {
        const allMenuItems = this.dwMenuBuilderService.buildMenusFromRoutes(this.router.config);
        this.setAllMenuItems(allMenuItems);
    }
    setMenuState(updatedState) {
        const newState = Object.assign(Object.assign({}, this.menuState), updatedState);
        DwMenuService._menuServiceState.next(newState);
    }
    setupSubscriptions() {
        this.subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
            this.handleRoutingChange(false);
        }));
        this.subscriptions.push(this.securityUserService.securityContextChanged().subscribe(() => {
            const securityState = this.securityUserService.securityState;
            //console.log('Security State', securityState);
            // if we're authenticating, wait until that is complete
            if (!securityState.setupComplete || securityState.isAuthenticating) {
                return;
            }
            this.handleRoutingChange(true);
        }));
        this.subscriptions.push(this.dwEventService.getEvent(DW_REFRESH_MENU_EVENT)
            .subscribe((eventData) => {
            // Force a routing change
            this.handleRoutingChange(true);
        }));
    }
    /**
     * Get the route details for the current activated route
     * Note: This is different from the current menu, as it will return the details for each child route, not just the end route
     * @param route
     * @returns
     */
    getRouteDetail(route) {
        return this.dwMenuHelperService.getRouteDetail(route);
    }
}
DwMenuService.ɵfac = function DwMenuService_Factory(t) { return new (t || DwMenuService)(ɵngcc0.ɵɵinject(DwMenuBuilderService), ɵngcc0.ɵɵinject(DwMenuHelperService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwEventService), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwUIConfigToken), ɵngcc0.ɵɵinject(DwMenuProcessorToken, 8)); };
DwMenuService._menuServiceState = new BehaviorSubject(null);
DwMenuService.ɵprov = ɵɵdefineInjectable({ factory: function DwMenuService_Factory() { return new DwMenuService(ɵɵinject(DwMenuBuilderService), ɵɵinject(DwMenuHelperService), ɵɵinject(Router), ɵɵinject(ActivatedRoute), ɵɵinject(DwSecurityUserService), ɵɵinject(DwEventService), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwUIConfigToken), ɵɵinject(DwMenuProcessorToken, 8)); }, token: DwMenuService, providedIn: "root" });
DwMenuService.ctorParameters = () => [
    { type: DwMenuBuilderService },
    { type: DwMenuHelperService },
    { type: Router },
    { type: ActivatedRoute },
    { type: DwSecurityUserService },
    { type: DwEventService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: Array, decorators: [{ type: Optional }, { type: Inject, args: [DwMenuProcessorToken,] }] }
];

const DwUiConfigServiceToken = new InjectionToken("DwUiConfigService");
class DwUiConfigService {
    constructor(http, cacheService, configService, configRegistryService, injector, dwLoggingService, dwUIConfig, dwMenuService) {
        this.http = http;
        this.cacheService = cacheService;
        this.configService = configService;
        this.configRegistryService = configRegistryService;
        this.injector = injector;
        this.dwLoggingService = dwLoggingService;
        this.dwUIConfig = dwUIConfig;
        this.dwMenuService = dwMenuService;
        this.configServiceApiRoot = `${this.configService.coreConfig.apiRoot}/general/config`;
        this.initConfigSources();
        this.dwMenuService.menuStateObservable.subscribe(state => {
            this.refreshPanelConfigs();
        });
    }
    initConfigSources() {
        const initSources = this.configRegistryService.getInitSources();
        for (const source of initSources) {
            try {
                if (source.useDI) {
                    // Create the service using DI
                    const instance = this.injector.get(source.target.constructor);
                    // Get a reference to the function
                    const func = instance[source.propertyKey];
                    // Bind the function to the instance (so the bound function can reference this - otherwise it's null)
                    const boundFunc = func.bind(instance);
                    // Call the bound function
                    boundFunc();
                }
                else {
                    source.target[source.propertyKey]();
                }
            }
            catch (error) {
                console.warn(`Error running UI Config Service Init for ${source.name}`, error);
            }
        }
    }
    buildUrl(methodName) {
        let url = `${this.configServiceApiRoot}/${methodName}`;
        return url;
    }
    getConfigData(keyName, configTypeId, itemId) {
        return this.getAllUiConfigs()
            .pipe(map((configData) => {
            var configItem = findWhere(configData, { ConfigKey: keyName, UiConfigTypeId: configTypeId });
            if (configItem == null) {
                // Not sure what to do here
            }
            return configItem;
        }));
    }
    getConfigDataList(configTypeId, itemId) {
        return this.getAllUiConfigs()
            .pipe(map((configData) => {
            const configList = configData.filter(configItem => configItem.UiConfigTypeId === configTypeId && (!itemId || configItem.MetaDataItemId === itemId));
            return configList;
        }));
    }
    saveConfigData(configItem) {
        let url = this.buildUrl("ui");
        let ob;
        // Determine if we're creating or updating so we can use the right verb
        if (configItem.UiConfigId) {
            ob = this.http.put(url, configItem);
        }
        else {
            ob = this.http.post(url, configItem);
        }
        return ob
            .pipe(map((httpResult) => {
            let result = httpResult;
            // Need to update the item in the cache
            this.updateUiConfigItem(result);
            return result;
        }));
    }
    updateUiConfigItem(configItem) {
        this.getAllUiConfigs()
            .subscribe((configData) => {
            var foundconfigItem = findWhere(configData, { ConfigKey: configItem.ConfigKey, UiConfigTypeId: configItem.UiConfigTypeId });
            if (foundconfigItem == null) {
                // Add item if it's missing
                configData.push(configItem);
            }
            else {
                // Update existing object
                Object.assign(foundconfigItem, configItem);
            }
            return configItem;
        });
    }
    getAllUiConfigs() {
        let cacheInvalidationTopics = [];
        var md = new DevwareMetaDataService();
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwUiConfig));
        return this.cacheService.get("UiConfigs", this.loadAllUiConfigs(), null, cacheInvalidationTopics);
    }
    loadAllUiConfigs() {
        let url = this.buildUrl("ui");
        let uiConfigs = this.getUiConfigsFromLocalStorage();
        if (uiConfigs.length > 0) {
            const sortedUiConfig = sortArray(uiConfigs, f => f.ModifiedDateTime).reverse();
            const lastModifiedItem = sortedUiConfig[0];
            url += '?modifiedAfter=' + lastModifiedItem.ModifiedDateTime;
        }
        return this.http.get(url)
            .pipe(map((updatedUiConfigs) => {
            uiConfigs = this.updateUiConfigs(uiConfigs, updatedUiConfigs);
            return uiConfigs;
        }));
    }
    updateUiConfigs(uiConfigs, updatedUiConfigs) {
        if (uiConfigs.length == 0) {
            uiConfigs = updatedUiConfigs;
            this.setUiConfigsToLocalStorage(uiConfigs);
            return uiConfigs;
        }
        if (updatedUiConfigs.length == 0) {
            return uiConfigs;
        }
        if (uiConfigs.length == updatedUiConfigs.length) {
            return updatedUiConfigs;
        }
        // Update uiConfigs that have been modified since the last date
        for (let updatedUiConfig of updatedUiConfigs) {
            const indexOf = uiConfigs.findIndex(uiConfig => uiConfig.UiConfigId == updatedUiConfig.UiConfigId);
            if (indexOf == -1) {
                uiConfigs.push(updatedUiConfig);
            }
            else {
                // console.log(`Updating UiConfig Id ${updatedUiConfig.UiConfigId} found in local storage`, uiConfigs[indexOf], updatedUiConfig);
                uiConfigs[indexOf] = updatedUiConfig;
            }
        }
        // Store newly updated configs
        this.setUiConfigsToLocalStorage(uiConfigs);
        return uiConfigs;
    }
    getFullStorageKey(keyBaseName) {
        let env = 'dev';
        if (this.configService.coreConfig.currentEnvironmentConfig) {
            env = `{this.configService.coreConfig.currentEnvironmentConfig.envKey || 'dev'}`;
        }
        let key = `${this.configService.coreConfig.baseTitle}-${env}_${keyBaseName}`;
        return key;
    }
    getUiConfigsFromLocalStorage() {
        try {
            if (this.configService.coreConfig.disableLocalStorageCaching) {
                return [];
            }
            const fullKey = this.getFullStorageKey('UiConfigJSON');
            const uiConfigJSON = localStorage.getItem(fullKey);
            if (uiConfigJSON) {
                return JSON.parse(uiConfigJSON);
            }
        }
        catch (e) {
            console.error("Error getting UiConfig from local storage", e);
        }
        return [];
    }
    setUiConfigsToLocalStorage(uiConfigs) {
        try {
            if (this.configService.coreConfig.disableLocalStorageCaching) {
                return;
            }
            const fullKey = this.getFullStorageKey('UiConfigJSON');
            localStorage.setItem(fullKey, JSON.stringify(uiConfigs));
        }
        catch (e) {
            console.error("Error settings UiConfig on local storage", e);
        }
    }
    mergePreferences(prefs, defaultPrefs, defaultPref2, defaultPref3) {
        var finalPrefs = defaults(this.clearBlankProperties(prefs), this.clearBlankProperties(defaultPrefs), this.clearBlankProperties(defaultPref2), this.clearBlankProperties(defaultPref3));
        return finalPrefs;
    }
    clearBlankProperties(obj) {
        if (!obj)
            return obj;
        var copy = assign({}, obj);
        for (let propName in copy) {
            let propValue = copy[propName];
            if (isUndefined(propValue) || isNull(propValue)) {
                delete copy[propName];
            }
            if (isArray(propValue) && propValue.length == 0)
                delete copy[propName];
        }
        return copy;
    }
    getPreferencesHierarchy(configKey, configType, globalPreferences, componentSetPreferences, useLoadedPreferences = true) {
        return this.getConfigData(configKey, configType)
            .pipe(map((configItem) => {
            var prefsHierarchy = new DwUiPreferencesHierarchyBase();
            prefsHierarchy.configKey = configKey;
            prefsHierarchy.configType = configType;
            prefsHierarchy.globalPreferences = globalPreferences;
            prefsHierarchy.componentSetPreferences = componentSetPreferences;
            if (configItem) {
                prefsHierarchy.metaDataItemId = configItem.MetaDataItemId;
                prefsHierarchy.ConfigDisplay = configItem.ConfigDisplay;
            }
            const itemName = this.getItemPart(configKey);
            // prefsHierarchy.actionHandlers = this.configRegistryService.getActionHandlers(itemName, configType);
            // Only use registered config when using loaded preference (this turns it off on grids)
            if (useLoadedPreferences) {
                prefsHierarchy.registeredPreferences = this.configRegistryService.getRegisteredConfig(configKey, configType);
            }
            // Check if a config item was found
            if (configItem && useLoadedPreferences) {
                prefsHierarchy.configData = configItem;
                try {
                    let loadedPreferences = JSON.parse(configItem.ConfigJson);
                    prefsHierarchy.loadedPreferences = loadedPreferences;
                }
                catch (e) {
                    console.error("Error converting ConfigJSON", e);
                }
            }
            return prefsHierarchy;
        }));
    }
    getItemPart(configKey) {
        if (!configKey) {
            return configKey;
        }
        const parts = configKey.split('-');
        return parts[0];
    }
    getDataSource(keyName) {
        const registration = this.configRegistryService.getDataSourceRegistration(keyName);
        if (!registration) {
            return null;
        }
        const dataSource = this.injector.get(registration.dataSourceService);
        return dataSource;
    }
    savePreferencesHierarchy(prefsHierarchy) {
        // need to remove any defauts set in the loadedPreferences and also clear any null properties
        var configData = prefsHierarchy.configData;
        if (!configData) {
            configData = new DwUiConfigData();
            configData.ConfigKey = prefsHierarchy.configKey;
            configData.UiConfigTypeId = prefsHierarchy.configType;
        }
        //configData.MetaDataItemId = metaDataItemId;
        configData.ConfigJson = JSON.stringify(prefsHierarchy.loadedPreferences);
        if (!configData.ConfigDisplay) {
            configData.ConfigDisplay = 'Default';
        }
        if (prefsHierarchy.metaDataItemId) {
            configData.MetaDataItemId = prefsHierarchy.metaDataItemId;
        }
        return this.saveConfigData(configData)
            .pipe(map((configData) => {
            prefsHierarchy.configData = configData;
            this.updateUiConfigItem(configData);
            return prefsHierarchy;
        }));
    }
    getFinalPreferences(prefsHierarchy, excludeLoadedPrefs) {
        if (!prefsHierarchy) {
            return null;
        }
        return this.mergePreferences(excludeLoadedPrefs ? null : prefsHierarchy.loadedPreferences, prefsHierarchy.registeredPreferences, prefsHierarchy.componentSetPreferences, prefsHierarchy.globalPreferences);
    }
    determineLoadedPreferences(prefsHierarchy, loadedPrefs) {
        if (!loadedPrefs || !prefsHierarchy)
            return null;
        // Get Final preferences minus any loaded settings
        let finalPrefs = this.getFinalPreferences(prefsHierarchy, true);
        let loadedPrefsCopy = deepCopy(loadedPrefs);
        let keptProperties = 0;
        // Only save settings for something that is different (this will preserve defaults)
        for (let propName in loadedPrefsCopy) {
            if (areEqual(finalPrefs[propName], loadedPrefsCopy[propName])) {
                delete loadedPrefsCopy[propName];
            }
            else {
                keptProperties++;
            }
        }
        // If no properties are kept, then return null
        if (keptProperties === 0) {
            return null;
        }
        return loadedPrefsCopy;
    }
    getUiPanelWidgetConfigs() {
        return DwUiConfigService.uiPanelWidgetConfigsSubject.asObservable()
            .pipe(map(results => {
            const currentResult = results.filter(result => { var _a, _b; return result.path == ((_b = (_a = this.dwMenuService.menuState) === null || _a === void 0 ? void 0 : _a.currentMenu) === null || _b === void 0 ? void 0 : _b.url); });
            // console.log('Get Ui Panels', currentResult);
            return currentResult;
        }));
    }
    registerUiPanelWidget(uiConfigComponent) {
        var _a, _b;
        uiConfigComponent.path = (_b = (_a = this.dwMenuService.menuState) === null || _a === void 0 ? void 0 : _a.currentMenu) === null || _b === void 0 ? void 0 : _b.url;
        // console.log('Register Ui Panel', uiConfigComponent);
        // If an item is getting registered again, have it replace the previous item
        const existingItem = DwUiConfigService.uiPanelWidgetConfigs.find(item => item.configKey == uiConfigComponent.configKey && item.uiConfigTypeId == uiConfigComponent.uiConfigTypeId);
        if (existingItem) {
            const index = DwUiConfigService.uiPanelWidgetConfigs.indexOf(existingItem);
            DwUiConfigService.uiPanelWidgetConfigs.splice(index, 1);
        }
        DwUiConfigService.uiPanelWidgetConfigs.push(uiConfigComponent);
        DwUiConfigService.uiPanelWidgetConfigsSubject.next(DwUiConfigService.uiPanelWidgetConfigs);
    }
    removeUiPanelWidget(configKey, configType) {
        // console.log('Remove Ui Panel', { configKey: configKey, configType: configType });
        var foundConfig = findWhere(DwUiConfigService.uiPanelWidgetConfigs, { configKey: configKey, uiConfigTypeId: configType });
        if (foundConfig) {
            var index = DwUiConfigService.uiPanelWidgetConfigs.indexOf(foundConfig);
            DwUiConfigService.uiPanelWidgetConfigs.splice(index, 1);
            DwUiConfigService.uiPanelWidgetConfigsSubject.next(DwUiConfigService.uiPanelWidgetConfigs);
        }
    }
    refreshPanelConfigs() {
        DwUiConfigService.uiPanelWidgetConfigsSubject.next(DwUiConfigService.uiPanelWidgetConfigs);
    }
}
DwUiConfigService.ɵfac = function DwUiConfigService_Factory(t) { return new (t || DwUiConfigService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwUIConfigToken), ɵngcc0.ɵɵinject(DwMenuService)); };
DwUiConfigService.UICONFIG_EVENT_TOPIC_BASE = "UIConfig";
DwUiConfigService.UICONFIG_EVENT_TOPIC = {
    PreferencesFinalizedEvent(configKey, type) { return `${DwUiConfigService.UICONFIG_EVENT_TOPIC_BASE}.${configKey}_${type}.UIPreferencesFinalized`; },
    PreferencesUpdateEvent(configKey, type) { return `${DwUiConfigService.UICONFIG_EVENT_TOPIC_BASE}.${configKey}_${type}.UIPreferencesUpdate`; },
    AdditionalDataEvent(configKey, type) { return `${DwUiConfigService.UICONFIG_EVENT_TOPIC_BASE}.${configKey}_${type}.AdditionalData`; },
    AllUiConfigEvents() { return `${DwUiConfigService.UICONFIG_EVENT_TOPIC_BASE}.*`; },
    // Not used rigth now, could delete, but check first
    RefreshConfig(configKey, type) { return `${DwUiConfigService.UICONFIG_EVENT_TOPIC_BASE}.${configKey}_${type}.Clear`; },
};
DwUiConfigService.uiPanelWidgetConfigs = [];
DwUiConfigService.uiPanelWidgetConfigsSubject = new BehaviorSubject([]);
DwUiConfigService.ɵprov = ɵɵdefineInjectable({ factory: function DwUiConfigService_Factory() { return new DwUiConfigService(ɵɵinject(HttpClient), ɵɵinject(DwCacheService), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(INJECTOR), ɵɵinject(DwLoggingService), ɵɵinject(DwUIConfigToken), ɵɵinject(DwMenuService)); }, token: DwUiConfigService, providedIn: "root" });
DwUiConfigService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwCacheService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: Injector },
    { type: DwLoggingService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwMenuService }
];

class DwDataSourceBase {
    constructor() {
        this.allowsPaging = false;
    }
    requestData(request) {
        throw new Error('Not Implemented');
    }
    // exportData(fileName: string): void {
    //     throw new Error('Not Implemented');
    // }
    loadItem(keyValues, loadOptions) {
        throw new Error('Not Implemented');
    }
    saveItem(item, saveOptions) {
        throw new Error('Not Implemented');
    }
    saveAllItems(items, saveOptions) {
        throw new Error('Not Implemented');
    }
    deleteItem(item, deleteOptions) {
        throw new Error('Not Implemented');
    }
    deleteItems(items, deleteOptions) {
        throw new Error('Not Implemented');
    }
    createBlankItem(defaults$1, addContext) {
        let newItem = {};
        if (addContext) {
            newItem = defaults(newItem, addContext);
        }
        if (defaults$1) {
            newItem = defaults(newItem, defaults$1);
        }
        return of(newItem);
    }
    updateExistingDataItem(existingData, updatedDate) {
        existingData = existingData || {};
        return Object.assign(existingData, updatedDate);
    }
    initDataSource() {
    }
}

class DwDataItemKeyValue {
}
class DwDataItemKeyValues {
    constructor() {
        this.keyValues = [];
    }
}

class DwOrmDataHierarchyUtil {
    updateExistingDataItem(existingData, updatedData, hierarchyLevels, queryMetaDatlist) {
        if (!updatedData || !existingData) {
            return;
        }
        if (!hierarchyLevels || hierarchyLevels.length == 0) {
            return Object.assign(existingData, updatedData);
        }
        return this.updateExistingDataItemWithHierarchy(existingData, updatedData, hierarchyLevels, queryMetaDatlist);
    }
    updateExistingDataItemWithHierarchy(existingData, updatedData, hierarchyLevels, queryMetaDatlist) {
        if (!hierarchyLevels || hierarchyLevels.length == 0) {
            return this.updateExistingDataItem(existingData, updatedData, null, queryMetaDatlist);
        }
        for (let propName in updatedData) {
            const propHierarchy = findWhere(hierarchyLevels, { propertyName: propName });
            const updatedPropData = updatedData[propName];
            if (!propHierarchy) {
                existingData[propName] = updatedPropData;
            }
            else {
                if (isArray(updatedPropData)) {
                    var existingArray = existingData[propName];
                    // If the arrays are the same we have a problem, this results in a infinite loop because we might add items to an array we're doing a for loop on.  In that case, it starts over when the array is modified and will continue forever
                    if (existingArray == updatedPropData) {
                        console.warn("DwOrmDataHierarchyUtil existingArray is the same object as the updatedArray");
                        // Solution: Set the existing array to nothing and let the updated items get added
                        existingArray = null;
                        // throw new Error("Can't continue since arrays are the same object!");
                    }
                    if (!existingArray || !isArray(existingArray)) {
                        existingData[propName] = [];
                        existingArray = existingData[propName];
                    }
                    existingData[propName] = this.updateExistingDataItemArrayWithHierarchy(existingArray, updatedPropData, propHierarchy.children, propHierarchy.itemName, queryMetaDatlist);
                }
                else {
                    if (!existingData[propName]) {
                        existingData[propName] = updatedPropData;
                    }
                    else {
                        existingData[propName] = this.updateExistingDataItemWithHierarchy(existingData[propName], updatedPropData, propHierarchy.children, queryMetaDatlist);
                    }
                }
            }
        }
        return existingData;
    }
    updateExistingDataItemArrayWithHierarchy(existingData, updatedData, hierarchyLevels, itemName, queryMetaDatlist) {
        // TODO: Implement this when the case comes up : Right now we don't have it so it would be difficult to test
        // use the key names from the existing date since it has to have at least one item to get here
        // This is basically a sync collection
        let keyName = "";
        if (existingData && existingData.length > 0) {
            keyName = existingData[0]._keyName;
        }
        if (!keyName) {
            if (!queryMetaDatlist || !queryMetaDatlist[itemName]) {
                // TODO: Not sure of the raminifcation of this, but we need to have a key name to do this (this will at least keep any existing data)
                return updatedData;
            }
            var itemMetaData = queryMetaDatlist[itemName];
            var keyAttr = itemMetaData.Attributes.find(attr => { var _a; return (_a = attr === null || attr === void 0 ? void 0 : attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey; });
            if (!keyAttr) {
                return updatedData;
            }
            keyName = keyAttr.AttributeName;
        }
        // mark all existing items as deleted (they will be mark undeleted when matched to updated data)
        for (let existingDataItem of existingData) {
            existingDataItem._isDeleted = true;
        }
        // match updatedDate to existing data
        for (let updatedDataItem of updatedData) {
            let foundDataItem = null;
            if (keyName) {
                const key = updatedDataItem[keyName];
                if (key) {
                    let filter = {};
                    filter[keyName] = key;
                    foundDataItem = findWhere(existingData, filter);
                }
            }
            if (foundDataItem) {
                foundDataItem._isDeleted = false;
                const existingItemIndex = existingData.indexOf(foundDataItem);
                existingData[existingItemIndex] = this.updateExistingDataItemWithHierarchy(foundDataItem, updatedDataItem, hierarchyLevels, queryMetaDatlist);
            }
            else {
                const ormData = {
                    _itemName: itemName,
                    _keyName: keyName
                };
                // Adding new data
                existingData.push(this.updateExistingDataItemWithHierarchy(ormData, updatedDataItem, hierarchyLevels, queryMetaDatlist));
            }
        }
        //console.log(`Existing items - Before removal`, existingData);
        // iterate over existing data in reverse order so we can delete items
        for (let i = existingData.length - 1; i >= 0; i--) {
            let existingDataItem = existingData[i];
            if (keyName) {
                const key = existingDataItem[keyName];
                // Remove items that don't have a key (meaning they aren't saved in the Db yet) and are marked deleted
                if (!key && existingDataItem._isDeleted) {
                    //console.log(`Before Removing existing item at index ${i}`, existingDataItem, existingData);
                    existingData.splice(i, 1);
                    //console.log(`After Removing existing item`, existingDataItem, existingData);
                }
            }
        }
        //console.log(`Existing items - After removal`, existingData);
        return existingData;
    }
    ensureItemHierarchy(dataItem, hierarchyLevels) {
        /*    if (!hierarchyLevels) {
               hierarchyLevels = this.ormDataHierarchy;
           } */
        if (!hierarchyLevels) {
            return dataItem;
        }
        for (let hierarchyLevel of hierarchyLevels) {
            this.updateHiearchyLevel(dataItem, hierarchyLevel);
        }
    }
    updateHiearchyLevel(dataItem, hierarchyLevel) {
        if (!dataItem) {
            return;
        }
        let hierarchyData = dataItem[hierarchyLevel.propertyName];
        if (!hierarchyData) {
            return;
        }
        // If we are excluding this item, we just remove it from the hierarchy
        if (hierarchyLevel.excludeFromSave) {
            // Remove data level
            delete dataItem[hierarchyLevel.propertyName];
            return;
        }
        if (isArray(hierarchyData)) {
            for (let hierarchyDataItem of hierarchyData) {
                let ormDataItem = hierarchyDataItem;
                // Populate the item name
                ormDataItem._itemName = hierarchyLevel.itemName;
                this.ensureItemHierarchy(ormDataItem, hierarchyLevel.children);
            }
        }
        else {
            let ormDataItem = hierarchyData;
            // Populate the item name
            ormDataItem._itemName = hierarchyLevel.itemName;
            this.ensureItemHierarchy(ormDataItem, hierarchyLevel.children);
        }
    }
}

class DwOrmDataSource extends DwDataSourceBase {
    constructor(ormDataService, metaDataService, item, ormDataHierarchy) {
        super();
        this.ormDataService = ormDataService;
        this.metaDataService = metaDataService;
        this.item = item;
        this.ormDataHierarchy = ormDataHierarchy;
        this.allowsPaging = true;
        this.queryHelper = new DwQueryHelper();
        if (!ormDataService || !metaDataService) {
            throw new Error('Inherited Data sources must pass in all constructor parameters by overriding the constructor');
        }
        this.ormDataHierarchyUtil = new DwOrmDataHierarchyUtil();
    }
    setupOrmDataSource(item, ormDataHierarchy) {
        this.item = item;
        this.ormDataHierarchy = ormDataHierarchy;
    }
    getDwItem() {
        if (this.item instanceof DwQuery)
            return this.item.RootTable;
        return this.item;
    }
    getDwItemName() {
        let item = this.getDwItem();
        if (typeof (item) == "string")
            return item;
        return item;
    }
    prepareRequestQuery(request) {
        let query;
        if (this.item instanceof DwQuery) {
            query = this.queryHelper.convertExistingQuery(this.item, request.filters, request.sorting, request.pageInfo);
        }
        else {
            query = this.queryHelper.convertToQuery(this.item, request.filters, request.sorting, request.pageInfo);
        }
        return query;
    }
    requestData(request) {
        const query = this.prepareRequestQuery(request);
        this.previousQuery = query;
        return this.ormDataService.executePagedQuery(query)
            .pipe(map((queryResult) => {
            // Convert the ORM QueryResults to the generic DwDataPageResults from DwCore
            return this.queryHelper.convertToPageResults(queryResult);
        }));
    }
    getCurrentQuery(replacementQuery) {
        let query = this.previousQuery;
        if (!query) {
            if (this.item instanceof DwQuery) {
                query = this.queryHelper.convertExistingQuery(this.item);
            }
            else {
                query = this.queryHelper.convertToQuery(this.item);
            }
        }
        if (replacementQuery) {
            replacementQuery.Filter = query.Filter;
            replacementQuery.Order = query.Order;
            // Turn off paging
            if (replacementQuery.PagingInfo) {
                replacementQuery.PagingInfo.PageNo = 1;
                replacementQuery.PagingInfo.PageSize = 10000;
                replacementQuery.PagingInfo.ReturnCount = false;
            }
            return replacementQuery;
        }
        // Turn of paging
        query.PagingInfo = null;
        return query;
    }
    isQuery(item) {
        if (item && item.RootTable)
            return true;
        return false;
    }
    loadItem(keyValues, loadOptions) {
        if (keyValues instanceof DwDataItemKeyValues)
            throw new Error("DwDataItemKeyValues aren't supported at this time");
        if (this.isQuery(this.item)) {
            return this.loadItemFromQuery(this.item, keyValues);
        }
        let querySettings;
        if (loadOptions && loadOptions.querySettings) {
            throw new Error('Query Settings are no longer supported!');
            //querySettings = <DwQuerySettings>loadOptions.querySettings;
        }
        return this.ormDataService.loadEntity(this.getDwItem(), keyValues)
            .pipe(tap(item => {
            // Store the previous item
            this.previousItemLoaded = deepCopy(item);
        }));
    }
    loadItemFromQuery(query, keyValues) {
        // Make a copy of the query so we don't modify the original
        var newQuery = new DwQuery(query.RootTable);
        deepCopyToObject(query, newQuery, true);
        var qh = this.ormDataService.QueryHelper;
        return this.metaDataService.getMetaData(query.RootTable)
            .pipe(mergeMap(itemMd => {
            var keyField = itemMd.KeyName;
            newQuery.AddFilterAnd(qh.filters.Equal(keyField, keyValues));
            return this.ormDataService.executeQuerySingle(newQuery)
                .pipe(tap(item => {
                // Store the previous item
                this.previousItemLoaded = deepCopy(item);
            }));
        }));
    }
    saveItem(entity, saveOptions, suppressErrorMessage = true, useRootItemQuery = true) {
        let recurse = false;
        let itemQuery;
        if (!entity) {
            throw new Error("entity is required");
        }
        if (saveOptions && saveOptions.recurse) {
            recurse = true;
        }
        if (saveOptions && saveOptions.itemQuery && saveOptions.itemQuery instanceof DwQuery) {
            itemQuery = saveOptions.itemQuery;
        }
        // If we using a query to load data, use the same one for reloading an entity
        if (!itemQuery && this.isQuery(this.item) && useRootItemQuery) {
            itemQuery = this.item;
        }
        // For new items, ensure that the item name field is populated, otherwise it will fail to save
        if (!entity._itemName) {
            entity._itemName = this.getDwItemName();
        }
        // This ensures that all levels of the hierarchy also have the item name property set
        this.ormDataHierarchyUtil.ensureItemHierarchy(entity, this.ormDataHierarchy);
        return this.ormDataService.saveEntity(entity, recurse, itemQuery, this.getOriginalItem(entity), suppressErrorMessage, this.ormDataHierarchy);
    }
    saveAllItems(items, saveOptions) {
        let recurse = (saveOptions === null || saveOptions === void 0 ? void 0 : saveOptions.recurse) || false;
        let reload = (saveOptions === null || saveOptions === void 0 ? void 0 : saveOptions.reload) || false;
        let itemQuery;
        if (!items || items.length == 0) {
            return of([]);
        }
        // This ensures that all levels of the hierarchy also have the item name property set
        this.ormDataHierarchyUtil.ensureItemHierarchy(items, this.ormDataHierarchy);
        return this.ormDataService.saveEntityCollection(items, recurse, reload);
    }
    deleteItem(item, deleteOptions, suppressErrorMessage = true) {
        this.ormDataService.markItemAsDeleted(item);
        return this.saveItem(item, deleteOptions);
    }
    deleteItems(items, deleteOptions, suppressErrorMessage = true) {
        if (!items || items.length == 0) {
            return of(null);
        }
        for (let item of items) {
            this.ormDataService.markItemAsDeleted(item);
        }
        let recurse = false;
        if (deleteOptions && deleteOptions.recurse) {
            recurse = true;
        }
        return this.ormDataService.saveEntityCollection(items, recurse, false);
    }
    getOriginalItem(item) {
        if (this.previousItemLoaded && this.previousItemLoaded._keyName) {
            const keyName = this.previousItemLoaded._keyName;
            const previousKey = this.previousItemLoaded[keyName];
            const currenyKey = item[keyName];
            if (previousKey !== currenyKey) {
                this.previousItemLoaded = null;
            }
        }
        return this.previousItemLoaded;
    }
    updateCachedItem(dataItem) {
    }
    createBlankItem(defaults$1, addContext) {
        var newItem = {
            _itemName: this.getDwItemName()
        };
        if (addContext) {
            newItem = defaults(newItem, addContext);
        }
        if (defaults$1) {
            newItem = defaults(newItem, defaults$1);
        }
        return of(newItem);
    }
    updateExistingDataItem(existingData, updatedData) {
        existingData = existingData || {};
        if (!updatedData) {
            return existingData;
        }
        if (!this.ormDataHierarchy) {
            return super.updateExistingDataItem(existingData, updatedData);
        }
        return this.ormDataHierarchyUtil.updateExistingDataItem(existingData, updatedData, this.ormDataHierarchy, this.queryMetaDataList);
    }
}
DwOrmDataSource.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined },
    { type: Array }
];

const DwUIMetaDataConfigToken = new InjectionToken("DwUIMetaDataConfig");

class DwMetaDataFormPreferenceHierarchy extends DwUiPreferencesHierarchyBase {
    constructor() {
        super();
    }
}

class DwMetaDataFormConfig {
}

class DwSectionBasePreference {
    constructor() {
        this.showTitle = false;
    }
}

var DwSectionType;
(function (DwSectionType) {
    DwSectionType["container"] = "container";
    DwSectionType["form"] = "form";
    DwSectionType["tabStrip"] = "tabStrip";
    DwSectionType["tab"] = "tab";
    DwSectionType["component"] = "component";
    DwSectionType["associativeList"] = "associativeList";
    DwSectionType["grid"] = "grid";
    DwSectionType["childData"] = "childData";
    DwSectionType["childDataRepeater"] = "childDataRepeater";
    DwSectionType["text"] = "text";
    DwSectionType["buttonBar"] = "buttonBar";
    DwSectionType["viewEdit"] = "viewEdit";
})(DwSectionType || (DwSectionType = {}));

var DwFormStyle;
(function (DwFormStyle) {
    DwFormStyle["verticleForm"] = "verticleForm";
    DwFormStyle["horizontalForm"] = "horizontalForm";
})(DwFormStyle || (DwFormStyle = {}));
class DwFormStyleList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwFormStyle[propertyName];
        // return DwFormMessageLocation['topOnly'];
    }
    getKeys() {
        return Object.keys(DwFormStyle);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwFormStyle.verticleForm:
                return 'Verticle Form';
            case DwFormStyle.horizontalForm:
                return 'Horizontal Form';
        }
    }
}

class DwFormSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.fields = [];
        this.formStyle = DwFormStyle.verticleForm;
        this.sectionType = DwSectionType.form;
    }
}

class DwFormFieldPreference {
}

class DwFormColumnItemPreference {
}
var DwFormColumnSpanType;
(function (DwFormColumnSpanType) {
    DwFormColumnSpanType["full"] = "full";
    DwFormColumnSpanType["half"] = "half";
})(DwFormColumnSpanType || (DwFormColumnSpanType = {}));

class DwSectionColumnPreferences {
}

class DwMdFormContextInfo {
    constructor() {
        this.loadDataComplete = false;
    }
}
DwMdFormContextInfo.FORM_CONTEXT_NAME = 'mdFormContext';
DwMdFormContextInfo.CONTEXT_FORM_GROUP = 'contextFG';
DwMdFormContextInfo.DATA_CONTEXT_NAME = 'data';

class DwFormGroup extends FormGroup {
    constructor(controls, validatorOrOpts, asyncValidator) {
        super(controls || {}, validatorOrOpts, asyncValidator);
    }
    patchValue(value, options) {
        if (value == undefined || value == null) {
            value = {};
        }
        super.patchValue(value, options);
    }
}

class DwMetadataFormUtilService {
    constructor(uiConfigRegistryService) {
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.sectionDefinitions = uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
        this.sectionsMap = {};
        this.sectionDefinitions.forEach(sectionDef => this.sectionsMap[sectionDef.keyName] = sectionDef);
    }
    isChildDataSection(section, includeGridWithParentData = true) {
        if (section.sectionType == DwSectionType.childData || section.sectionType == DwSectionType.childDataRepeater) {
            return true;
        }
        if (this.isGridSection(section) && includeGridWithParentData) {
            return section.useParentData;
        }
        return false;
    }
    getDataSubject(section, context, formGroup, rootSection, queryMetaDataList) {
        // Use context data instead since the above only returns values for controls for child data areas
        const dataContext = context[DwMdFormContextInfo.DATA_CONTEXT_NAME];
        const rootData = dataContext.value;
        // Gets all data for this section
        const initialData = this.getChildSectionData(section, rootData, formGroup, rootSection, queryMetaDataList);
        const subject = new BehaviorSubject(initialData);
        const subscription = dataContext.subscribe(value => {
            const rootData = dataContext.value;
            // Gets all data for this section
            const currentData = this.getChildSectionData(section, rootData, formGroup, rootSection, queryMetaDataList);
            subject.next(currentData);
        });
        return { subject: subject, subscription: subscription };
    }
    getSectionDataPath(section, rootSection, queryMetaDataList) {
        var _a, _b, _c, _d;
        const parents = this.getSectionParents(rootSection, section);
        parents.reverse();
        const relations = [];
        for (const parentSectionItem of parents) {
            if (this.isChildDataSection(parentSectionItem, false)) {
                const childMetaData = queryMetaDataList[parentSectionItem.childItem];
                const childKeyAttr = (_a = childMetaData === null || childMetaData === void 0 ? void 0 : childMetaData.Attributes) === null || _a === void 0 ? void 0 : _a.find(attr => { var _a; return (_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey; });
                const parentMetaData = queryMetaDataList[parentSectionItem.parentItem];
                const parentKeyAttr = (_b = parentMetaData === null || parentMetaData === void 0 ? void 0 : parentMetaData.Attributes) === null || _b === void 0 ? void 0 : _b.find(attr => { var _a; return (_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey; });
                relations.push({
                    childItem: parentSectionItem.childItem,
                    childKeyName: (_c = childKeyAttr === null || childKeyAttr === void 0 ? void 0 : childKeyAttr.Attribute) === null || _c === void 0 ? void 0 : _c.AttributeName,
                    parentItem: parentSectionItem.parentItem,
                    parentKeyName: (_d = parentKeyAttr === null || parentKeyAttr === void 0 ? void 0 : parentKeyAttr.Attribute) === null || _d === void 0 ? void 0 : _d.AttributeName,
                    propertyName: parentSectionItem.propertyName,
                    relationshipName: parentSectionItem.relationshipName,
                });
            }
        }
        return relations;
    }
    /**
     * Navigates the data hierarchy for section child data repeaters and child data to return all data for the given section
     * @param rootData
     * @param currentFormGroup
     * @param section
     * @param rootSection
     * @returns
     */
    getChildSectionData(section, rootData, currentFormGroup, rootSection, queryMetaDataList) {
        const dataRelations = this.getSectionDataPath(section, rootSection, queryMetaDataList);
        if (!rootData) {
            return;
        }
        let parentFormGroup = null;
        if (currentFormGroup instanceof DwFormGroup) {
            // If the parent is a repeater, we ned to get the parent form group
            parentFormGroup = currentFormGroup.parentFormGroup;
        }
        let parentDataItem = rootData;
        // If we are a child data section, then we need to skip the last section since we want the parent data item
        if (this.isChildDataSection(section)) {
            dataRelations.length = dataRelations.length - 1;
        }
        for (const dataRelation of dataRelations) {
            if (parentDataItem) {
                parentDataItem = parentDataItem[dataRelation.propertyName];
                // If it is an array, we need to get the correct item
                if (Array.isArray(parentDataItem)) {
                    if (parentDataItem.length == 0) {
                        parentDataItem = null;
                    }
                    else {
                        const keyName = parentDataItem[0]._keyName || dataRelation.childKeyName;
                        let keyValueControl = this.findKeyValueInFormGroupHierarych(currentFormGroup, keyName);
                        if (!keyValueControl) {
                            keyValueControl = this.findKeyValueInFormGroupHierarych(parentFormGroup, keyName);
                        }
                        if (keyValueControl) {
                            const keyValue = keyValueControl.value;
                            parentDataItem = parentDataItem.find(da => da[keyName] == keyValue);
                        }
                        else {
                            // Note: Bug found on 11/20/2023 on feature for Feature Areas - root cause was a deepDefaults call which was removing the _keyName property for the child data item
                            console.warn(`Unable to find key value control for ${keyName}. Using first item which can cause issues with templates in repeaters that have more than one row`);
                            parentDataItem = parentDataItem[0];
                        }
                    }
                }
            }
        }
        return parentDataItem;
    }
    /**
   * Walks up the hierarchy until it find the key value it needs
   * @param formGroup
   * @param keyName
   */
    findKeyValueInFormGroupHierarych(parentGroup, keyName) {
        if (parentGroup == null) {
            return null;
        }
        const keyValueControl = parentGroup.get(keyName);
        if (keyValueControl) {
            return keyValueControl;
        }
        return this.findKeyValueInFormGroupHierarych(parentGroup.parent, keyName);
    }
    shouldCreateChildFormGroup(section) {
        if (section.sectionType == DwSectionType.childData || section.sectionType == DwSectionType.grid) {
            return true;
        }
        return false;
    }
    hasChildSections(section) {
        const sectionDef = this.getSectionDef(section.sectionType);
        return sectionDef.hasChildren;
        /*         if ((<DwContainerSectionPreference>section).sections)
                    return true;
        
                return false; */
    }
    hasChildSection(section) {
        const sectionDef = this.getSectionDef(section.sectionType);
        return sectionDef.hasChild;
        /* if ((<DwTabSectionPreference>section).section)
            return true;

        return false; */
    }
    isFormSection(section) {
        if (section.fields) {
            return true;
        }
        return false;
    }
    isGridSection(section) {
        if (section.sectionType == DwSectionType.grid) {
            return true;
        }
        return false;
    }
    findSections(section, findFunc, returnAll = false) {
        let sections = [];
        if (findFunc(section)) {
            sections.push(section);
            if (!returnAll) {
                return sections;
            }
        }
        const sectionDef = this.getSectionDef(section.sectionType);
        if (sectionDef.hasChildren) {
            let containerSection = section;
            const sectionDef = this.getSectionDef(section.sectionType);
            const childSections = section[sectionDef.childrenPropertyName || 'sections'] || [];
            for (var subSection of childSections) {
                let childSections = this.findSections(subSection, findFunc, returnAll);
                Array.prototype.push.apply(sections, childSections);
            }
        }
        if (sectionDef.hasChild) {
            let subSection = section[sectionDef.childrenPropertyName || 'section'];
            if (subSection) {
                let childSections = this.findSections(subSection, findFunc, returnAll);
                Array.prototype.push.apply(sections, childSections);
            }
        }
        return sections;
    }
    findRelatedSections(rootSection, currentSection, sectionType, currentSectionKey, findFunc) {
        var _a;
        // Get related sections
        const relatedSections = this.findSections(rootSection, (section) => {
            if (section.sectionType !== sectionType) {
                return false;
            }
            if (findFunc) {
                return findFunc(section);
            }
            return true;
        });
        const result = {
            hasRelatedSections: relatedSections.length > 0,
            isPrimarySection: ((_a = relatedSections[0]) === null || _a === void 0 ? void 0 : _a.sectionKey) == currentSection.sectionKey,
            currentSectionKey: this.getSectionConfigUniqueId(currentSection, rootSection),
            relatedSections: {},
            currentSection: currentSection
        };
        if ((relatedSections === null || relatedSections === void 0 ? void 0 : relatedSections.length) == 1) {
            result.isPrimarySection = true;
            result.hasRelatedSections = false;
        }
        if (result.isPrimarySection && result.hasRelatedSections) {
            for (const section of relatedSections) {
                const sectionKey = this.getSectionConfigUniqueId(section, rootSection);
                result.relatedSections[sectionKey] = section;
            }
        }
        return result;
    }
    // findSectionbyKey(rootSection: DwSectionBasePreference, sectionKey: string) {
    //     const results = this.findSections(rootSection, (section)=> section.sectionKey == sectionKey);
    //     if (results.length>0) {
    //         return results[0];
    //     }
    //     return null;
    // }
    // setAllSectionKeys(rootSection: DwSectionBasePreference) {
    //     const allSections = this.findSections(rootSection, (section) => true, true);
    //     let sectionNo = 0;
    //     for(let section of allSections) {
    //         sectionNo++;
    //         section.sectionKey = `Section_${sectionNo}`;
    //     }
    // }
    getSectionDef(sectionType) {
        let item = this.sectionsMap[sectionType];
        if (item == null) {
            item = {
                component: null,
                configComponent: null,
                display: `${sectionType}(Missing)`,
                omitInConfigTree: true,
                keyName: sectionType,
                sectionIcon: '',
            };
        }
        return item;
    }
    /*
    
        private getSectionDef(sectionType: string): DwFormSectionDefinition {
            let item: DwFormSectionDefinition = this.getAllSectionDefs().find(sd => sd.keyName == sectionType);
    
            if (item == null) {
                item = {
                    component : null,
                    configComponent : null,
                    display: `${sectionType}(Missing)`,
                    omitInConfigTree : true,
                    keyName: sectionType,
                    sectionIcon: '',
                };
            }
            
            return item;
        } */
    getSectionChildren(section, sectionDef = null) {
        const childSections = [];
        if (!sectionDef) {
            sectionDef = this.getSectionDef(section.sectionType);
        }
        if (sectionDef.hasChild) {
            const childSection = section.section;
            if (childSection) {
                childSections.push(childSection);
            }
        }
        if (sectionDef.hasChildren) {
            const children = section[sectionDef.childrenPropertyName] || [];
            for (let childSection of children) {
                childSections.push(childSection);
            }
        }
        return childSections;
    }
    setSectionReadOnly(section, readOnly, setAsSource = true) {
        const sectionDef = this.getSectionDef(section.sectionType);
        // Stop propogation if something else is overriding the read only (could be another read only setting this is propagating so we don't mess with it - e.g. Child Repeater that is set as exclude from save)
        if (!setAsSource && section.isReadOnlyParentSource) {
            return;
        }
        //if (sectionDef?.hasReadOnlyMode) {
        const readOnlySection = section;
        readOnlySection.isReadOnlyFromParent = readOnly;
        //} 
        if (setAsSource) {
            section.isReadOnlyParentSource = true;
        }
        const childSections = this.getSectionChildren(section, sectionDef);
        for (const childSection of childSections) {
            this.setSectionReadOnly(childSection, readOnly, false);
        }
    }
    getUsedSectionDefs(section) {
        const sectionDefs = [];
        this.processSection(section, (section, sectionDef) => {
            if (sectionDefs.indexOf(sectionDef) === -1) {
                sectionDefs.push(sectionDef);
            }
        });
        return sectionDefs;
    }
    getAllContextNames(formPreferences) {
        let contextNames = [];
        if ((formPreferences === null || formPreferences === void 0 ? void 0 : formPreferences.contextNames) && formPreferences.contextNames.length > 0) {
            contextNames = [...formPreferences.contextNames]; // Always start with the form context
        }
        this.processSection(formPreferences.section, (section, sectionDef) => {
            if (sectionDef.contextDefNames && sectionDef.contextDefNames.length > 0) {
                for (const contextDefName of sectionDef.contextDefNames) {
                    if (contextNames.indexOf(contextDefName) === -1) {
                        contextNames.push(contextDefName);
                    }
                }
            }
        });
        return contextNames;
    }
    getSectionContextNames(formPreferences) {
        let contextNames = [];
        this.processSection(formPreferences.section, (section, sectionDef) => {
            if (sectionDef.contextDefNames && sectionDef.contextDefNames.length > 0) {
                for (const contextDefName of sectionDef.contextDefNames) {
                    if (contextNames.indexOf(contextDefName) === -1) {
                        contextNames.push(contextDefName);
                    }
                }
            }
        });
        return contextNames;
    }
    processSection(section, func) {
        // if there is not section, then we're finished
        if (!section) {
            return;
        }
        const sectionDef = this.getSectionDef(section.sectionType);
        func(section, sectionDef);
        const childSections = this.getSectionChildren(section, sectionDef);
        for (let childSection of childSections) {
            this.processSection(childSection, func);
        }
    }
    getChildDataSections(section) {
        return this.findSections(section, (section) => {
            return this.isChildDataSection(section);
        });
    }
    getSectionParents(rootSection, currentSection) {
        const sections = [];
        if (rootSection == currentSection || (rootSection.sectionKey && currentSection.sectionKey && rootSection.sectionKey == currentSection.sectionKey)) {
            sections.push(rootSection);
            return sections;
        }
        const sectionChildren = this.getSectionChildren(rootSection);
        for (let childSection of sectionChildren) {
            let foundSections = this.getSectionParents(childSection, currentSection);
            if (foundSections.length > 0) {
                for (let foundSection of foundSections) {
                    sections.push(foundSection);
                }
                sections.push(rootSection);
                return sections;
            }
        }
        return sections;
    }
    findParentChildData(rootSection, section) {
        let sectionParents = this.getSectionParents(rootSection, section);
        let i = 0;
        for (let sectionParent of sectionParents) {
            if (this.isChildDataSection(sectionParent, false) && i > 0)
                return sectionParent;
            i++;
        }
        return null;
    }
    getParentItemName(rootSection, section, rootItemName) {
        if (rootSection && section) {
            var childDataSection = this.findParentChildData(rootSection, section);
            if (childDataSection && childDataSection.childItem) {
                return childDataSection.childItem;
            }
        }
        return rootItemName;
    }
    setupContainerOptions(sectionConfig, previousCollapsedDefault, titleTemplate) {
        const containerOptions = {
            useContainerStyling: sectionConfig.useContainerStyling,
            showTitle: sectionConfig.showTitle,
            containerClass: sectionConfig.containerClass,
            containerInnerClass: sectionConfig.containerInnerClass,
            containerTitleClass: sectionConfig.containerTitleClass,
            styleName: sectionConfig.containerStyleName,
            containerHeight: sectionConfig.containerHeight,
            containerWidth: sectionConfig.containerWidth,
            containerHeaderIcon: sectionConfig.containerHeaderIcon,
            containerAllowCollapse: sectionConfig.containerAllowCollapse,
            containerCollapseDefault: sectionConfig.containerCollapseDefault,
            // Added standard color selection
            containerHeaderBackgroundColor: sectionConfig.containerHeaderBackgroundColor,
            containerHeaderForegroundColor: sectionConfig.containerHeaderForegroundColor,
            containerHeaderIconColor: sectionConfig.containerHeaderIconColor,
        };
        if (sectionConfig.containerCollapseDefaultExpression) {
            if (previousCollapsedDefault == null || previousCollapsedDefault == undefined) {
                containerOptions.containerCollapseDefault = true;
            }
            else {
                containerOptions.containerCollapseDefault = previousCollapsedDefault;
            }
        }
        if (titleTemplate) {
            containerOptions.styleName = titleTemplate.containerStyleName || sectionConfig.containerStyleName;
            containerOptions.containerHeaderIcon = titleTemplate.containerHeaderIcon || sectionConfig.containerHeaderIcon;
            containerOptions.containerHeaderBackgroundColor = titleTemplate.containerHeaderBackgroundColor || sectionConfig.containerHeaderBackgroundColor;
            containerOptions.containerHeaderForegroundColor = titleTemplate.containerHeaderForegroundColor || sectionConfig.containerHeaderForegroundColor;
            containerOptions.containerHeaderIconColor = titleTemplate.containerHeaderIconColor || sectionConfig.containerHeaderIconColor;
        }
        return containerOptions;
    }
    getSectionConfigUniqueId(currentSection, rootSection) {
        var _a;
        // New more efficient logic using section key
        if (currentSection.sectionKey) {
            return currentSection.sectionKey;
        }
        if (!rootSection) {
            return 'Unknown';
        }
        if (currentSection == rootSection) {
            return 'Root';
        }
        const parents = this.getSectionParents(rootSection, currentSection).reverse();
        const nameParts = [];
        let previousParent;
        for (const parent of parents) {
            if (previousParent) {
                let index = 0;
                if (previousParent.sections) {
                    index = (_a = previousParent.sections) === null || _a === void 0 ? void 0 : _a.indexOf(parent);
                }
                nameParts.push(index);
            }
            previousParent = parent;
        }
        if (nameParts.length == 0) {
            return 'Root';
        }
        return `Section:${nameParts.join('-')}`;
    }
    findSectionbyKey(rootSection, sectionKey) {
        const results = this.findSections(rootSection, (section) => section.sectionKey == sectionKey);
        if (results.length > 0) {
            return results[0];
        }
        return null;
    }
    setAllSectionKeys(rootSection) {
        const allSections = this.findSections(rootSection, (section) => true, true);
        let sectionNo = 0;
        for (let section of allSections) {
            sectionNo++;
            section.sectionKey = `Section_${sectionNo}`;
        }
    }
    buildFieldConfig(attr, itemName) {
        const fieldConfig = {
            itemName: itemName,
            attrName: attr.AttributeName,
            attr: attr,
            controlType: attr.MetaDataControlTypeId,
            label: attr.Display,
            formGroupKey: ''
        };
        return fieldConfig;
    }
}
DwMetadataFormUtilService.ɵfac = function DwMetadataFormUtilService_Factory(t) { return new (t || DwMetadataFormUtilService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService)); };
DwMetadataFormUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetadataFormUtilService_Factory() { return new DwMetadataFormUtilService(ɵɵinject(DwUiConfigRegistryService)); }, token: DwMetadataFormUtilService, providedIn: "root" });
DwMetadataFormUtilService.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];

class DwSecurityMessages {
    get NoReadAccess() {
        return 'You do not have permission to view this data';
    }
    get NoCreateAccess() {
        return 'You do not have permission to create this data';
    }
    get NoUpdateAccess() {
        return 'You do not have permission to update this data';
    }
    get NoAccessToViews() {
        return 'You do not have permission to see any of the views for this grid.';
    }
}

var DwFormMessageLocation;
(function (DwFormMessageLocation) {
    DwFormMessageLocation["topOnly"] = "topOnly";
    DwFormMessageLocation["bottomOnly"] = "bottomOnly";
    DwFormMessageLocation["topAndBottom"] = "topAndBottom";
})(DwFormMessageLocation || (DwFormMessageLocation = {}));
class DwFormMessageLocationList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwFormMessageLocation[propertyName];
        // return DwFormMessageLocation['topOnly'];
    }
    getKeys() {
        return Object.keys(DwFormMessageLocation);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwFormMessageLocation.topOnly:
                return 'Top Only';
            case DwFormMessageLocation.bottomOnly:
                return 'Bottom Only';
            case DwFormMessageLocation.topAndBottom:
                return 'Top and Bottom';
        }
    }
    getEnumDisplays() {
        return [
            { value: DwFormMessageLocation.topOnly, display: 'Top Only' }
        ];
    }
}

var DwExpressionCompareType;
(function (DwExpressionCompareType) {
    DwExpressionCompareType["equal"] = "EQUAL";
    DwExpressionCompareType["greaterThan"] = "GREATER_THAN";
    DwExpressionCompareType["greaterThanEqual"] = "GREATER_EQUAL";
    DwExpressionCompareType["lessThan"] = "LESS_THAN";
    DwExpressionCompareType["lessThanEqual"] = "LESS_EQUAL";
    DwExpressionCompareType["contains"] = "CONTAINS";
    DwExpressionCompareType["startsWith"] = "STARTS_WITH";
    DwExpressionCompareType["endsWith"] = "ENDS_WITH";
    DwExpressionCompareType["notEqual"] = "NOT_EQUAL";
    DwExpressionCompareType["isBlank"] = "IS_BLANK";
    DwExpressionCompareType["isNotBlank"] = "IS_NOT_BLANK";
    DwExpressionCompareType["isTrue"] = "IS_TRUE";
    DwExpressionCompareType["isFalse"] = "IS_FALSE";
    //in = "IN",
    DwExpressionCompareType["notContains"] = "NOT_CONTAINS";
    DwExpressionCompareType["greaterThanHours"] = "GREATER_THAN_HOURS";
    DwExpressionCompareType["greaterThanEqualHours"] = "GREATER_THAN_EQUAL_HOURS";
    DwExpressionCompareType["lessThanHours"] = "LESS_THAN_HOURS";
    DwExpressionCompareType["lessThanEqualHours"] = "LESS_THAN_EQUAL_HOURS";
    DwExpressionCompareType["greaterThanDays"] = "GREATER_THAN_DAYS";
    DwExpressionCompareType["greaterThanEqualDays"] = "GREATER_THAN_EQUAL_DAYS";
    DwExpressionCompareType["lessThanDays"] = "LESS_THAN_DAYS";
    DwExpressionCompareType["lessThanEqualDays"] = "LESS_THAN_EQUAL_DAYS";
    DwExpressionCompareType["isCurrentUser"] = "Is_Current_User";
    DwExpressionCompareType["inList"] = "IN_LIST";
    DwExpressionCompareType["notInList"] = "NOT_IN_LIST";
})(DwExpressionCompareType || (DwExpressionCompareType = {}));
class DwExpressionCompareTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwExpressionCompareType[propertyName];
    }
    getKeys() {
        return Object.keys(DwExpressionCompareType);
    }
    getEnumDisplay(value) {
        switch (value) {
            case DwExpressionCompareType.equal:
                return "Equals";
            case DwExpressionCompareType.notEqual:
                return "Not Equal";
            case DwExpressionCompareType.greaterThan:
                return ">";
            case DwExpressionCompareType.greaterThanEqual:
                return ">=";
            case DwExpressionCompareType.lessThan:
                return "<";
            case DwExpressionCompareType.lessThanEqual:
                return "<=";
            case DwExpressionCompareType.isBlank:
                return "Is Blank";
            case DwExpressionCompareType.isNotBlank:
                return "Is not Blank";
            case DwExpressionCompareType.isTrue:
                return "Is True";
            case DwExpressionCompareType.isFalse:
                return "Is False";
            case DwExpressionCompareType.contains:
                return "Contains";
            case DwExpressionCompareType.endsWith:
                return "Ends Wtih";
            case DwExpressionCompareType.notContains:
                return "Not Contains";
            case DwExpressionCompareType.startsWith:
                return "Starts With";
            case DwExpressionCompareType.greaterThanHours:
                return '> Hours';
            case DwExpressionCompareType.greaterThanEqualHours:
                return '>= Hours';
            case DwExpressionCompareType.lessThanHours:
                return '< Hours';
            case DwExpressionCompareType.lessThanEqualHours:
                return '<= Hours';
            case DwExpressionCompareType.greaterThanDays:
                return '> Days';
            case DwExpressionCompareType.greaterThanEqualDays:
                return '>= Days';
            case DwExpressionCompareType.lessThanDays:
                return '< Days';
            case DwExpressionCompareType.lessThanEqualDays:
                return '<= Days';
            case DwExpressionCompareType.isCurrentUser:
                return 'Is Current User';
            case DwExpressionCompareType.inList:
                return "In List";
            case DwExpressionCompareType.notInList:
                return "Not In List";
        }
        return null;
    }
}

class DwContextDefaultsService {
    constructor(dwSecurityUserService, metadataConfig) {
        this.dwSecurityUserService = dwSecurityUserService;
        this.metadataConfig = metadataConfig;
    }
    getDefaultContextDefinitions() {
        const contextDefs = [];
        /*  contextDefs.push(this.getCurrentUserContextDef());
         contextDefs.push(this.getMdFormContextDef()); */
        return contextDefs;
    }
    getCurrentUserContextDef2() {
        const userContextDef = {
            contextName: 'currentUser',
            contextDisplay: 'Current User',
            cacheInvalidationTopics: [DwSecurityTopics.SECURITY_CHANGED],
            isGlobal: true,
        };
        userContextDef.getCustomContextFunction = (context, contextData) => {
            const appUser = deepCopy(this.dwSecurityUserService.securityState.securityContext.ApplicationUser);
            // Convert extended attributes to properties (This allows extended attribute to be accessed just like the other properties)
            for (const extAttr of appUser.ExtendedAttributes || []) {
                appUser[extAttr.AttrName] = extAttr.AttrValue;
            }
            return appUser;
        };
        // Set data to an empty object and then run the getCustomContextFunction with that data
        userContextDef.data = {};
        userContextDef.attributes = [];
        this.addProperty(userContextDef.attributes, 'UserId', 'User Id', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(userContextDef.attributes, 'FirstName', 'First Name');
        this.addProperty(userContextDef.attributes, 'LastName', 'Last Name');
        this.addProperty(userContextDef.attributes, 'FirstNameLastName', 'First/Last Name');
        this.addProperty(userContextDef.attributes, 'LastNameFirstName', 'Last/First Name');
        this.addProperty(userContextDef.attributes, 'Email', 'E-mail');
        this.addProperty(userContextDef.attributes, 'UserName', 'User Name');
        this.addProperty(userContextDef.attributes, 'MobilePhone', 'Mobile Phone');
        for (const extAttr of this.metadataConfig.userContextExtendedAttributes || []) {
            this.addProperty(userContextDef.attributes, extAttr.name, extAttr.display, extAttr.attrType, extAttr.controlType);
        }
        var hasPermissionAttr = this.addProperty(userContextDef.attributes, 'Permissions', 'Has Permission', DwAttributeType.Text, DwControlType.DropDownList);
        hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains];
        var dwMd = new DevwareMetaDataService();
        // Use the permission lookup, but use the Permission meaning instead of the id
        //   (This change is made in conjunction with adding the PermissionMeaning as an additional attribtue to the Permission lookup)
        hasPermissionAttr.Attribute.MetaDataLookupId = DevwareMetaDataLookups.AppPermissionAllItems;
        hasPermissionAttr.alternateLookupValueAttrName = 'PermissionMeaning';
        return userContextDef;
    }
    addProperty(attributes, name, display, attrType, controlType) {
        let attr = {
            AttributeName: name,
            Display: display,
            AttributeType: attrType || DwAttributeType.Text,
            MetaDataControlTypeId: controlType || DwControlType.Textbox,
        };
        let mdQueryAttr = {
            Attribute: attr,
            FieldType: DwFieldType.Standard,
            AttributeDisplay: attr.Display,
            AttributeType: attr.AttributeType,
            AttributeName: attr.AttributeName,
            HasDisplayField: false,
            DisplayAttributeName: attr.AttributeName,
        };
        attributes.push(mdQueryAttr);
        return mdQueryAttr;
    }
    addListValue(listValues, id, display) {
        let lookupItem = {
            Id: id,
            Display: display
        };
        listValues.push(lookupItem);
    }
}
DwContextDefaultsService.ɵfac = function DwContextDefaultsService_Factory(t) { return new (t || DwContextDefaultsService)(ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwContextDefaultsService.ɵprov = ɵɵdefineInjectable({ factory: function DwContextDefaultsService_Factory() { return new DwContextDefaultsService(ɵɵinject(DwSecurityUserService), ɵɵinject(DwUIMetaDataConfigToken)); }, token: DwContextDefaultsService, providedIn: "root" });
DwContextDefaultsService.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];

function isDwMetaDataAppInitResult(appInitResult) {
    if (appInitResult.ContextDataDefinitions) {
        return true;
    }
    return false;
}

class DwContextRepositoryService {
    constructor(http, configService, ormDataService, dwCacheService, appInitService) {
        this.http = http;
        this.ormDataService = ormDataService;
        this.dwCacheService = dwCacheService;
        this.appInitService = appInitService;
        this.contextDefCacheSubject = new Subject();
        this.reloadContextData = false;
        this.apiRoot = `${configService.coreConfig.apiRoot}metadata`;
        this.contextDefCacheSubject.subscribe(() => {
            this.reloadContextData = true;
        });
    }
    getContextDataDefinitionEntities() {
        const cacheOptions = {
            cacheInvalidationsTopics: [DevwareMetaDataItemNames.DwContextDataDefinition, DevwareMetaDataItemNames.DwMetaDataAttribute, DevwareMetaDataItemNames.DwMetaDataItem, DevwareMetaDataItemNames.DwMetaDataQuery]
        };
        return this.appInitService.getApiInitItem('ContextDataDefinitions', this.loadContextDataDefinitionEntities(), cacheOptions);
    }
    getUserAttributeData() {
        return this.appInitService.getApiInitItem('UserExtendedData', null)
            .pipe(map(userExtendedData => {
            return userExtendedData;
        }));
    }
    getContextDataDefinitionEntitiesManual() {
        const cacheOptions = {
            cacheInvalidationsTopics: [DevwareMetaDataItemNames.DwContextDataDefinition, DevwareMetaDataItemNames.DwMetaDataAttribute, DevwareMetaDataItemNames.DwMetaDataItem, DevwareMetaDataItemNames.DwMetaDataQuery]
        };
        // Initially we want to use the app init, however, if context data gets updating in the app, we will just re-load the context data
        const loadOb = this.reloadContextData ? this.loadContextDataDefinitionEntities() : this.loadContextDataFromAppInit();
        return this.dwCacheService.getWithOptions('contextDataDefinitionEntities', loadOb, cacheOptions);
    }
    loadContextDataFromAppInit() {
        return this.appInitService.getAppInitResult()
            .pipe(mergeMap((result) => {
            if (isDwMetaDataAppInitResult(result)) {
                return of(result.ContextDataDefinitions);
            }
            return this.loadContextDataDefinitionEntities();
        }));
    }
    loadContextDataDefinitionEntities() {
        let url = this.buildUrl("contextdata");
        return this.http.get(url)
            .pipe(map((r) => {
            this.updateAppInitState(r);
            return r;
        }));
    }
    updateAppInitState(contextDataDefinitions) {
        const newState = {
            ContextDataDefinitions: contextDataDefinitions
        };
        this.appInitService.updateAppInitResult(newState);
    }
    buildUrl(methodName) {
        let url = `${this.apiRoot}/${methodName}`;
        return url;
    }
}
DwContextRepositoryService.ɵfac = function DwContextRepositoryService_Factory(t) { return new (t || DwContextRepositoryService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwAppInitService)); };
DwContextRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwContextRepositoryService_Factory() { return new DwContextRepositoryService(ɵɵinject(HttpClient), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwCacheService), ɵɵinject(DwAppInitService)); }, token: DwContextRepositoryService, providedIn: "root" });
DwContextRepositoryService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwCacheService },
    { type: DwAppInitService }
];

class DwDefaultContextDef {
    constructor() {
        this.updateOnDataChange = true;
    }
    buildQueryFunction(resolvedContext) {
        if (!this.query) {
            this.query = new DwQuery(this.item);
        }
        if (this.query && !this.contextDefinitionServer.LoadAllData) {
            const parentValue = this.getParentAttributeValue(resolvedContext);
            if (parentValue === null || parentValue === undefined) {
                return null;
            }
            const query = deepCopyToObject(this.query, new DwQuery(this.item));
            const qh = new DwQueryHelper();
            query.AddFilterAnd(qh.filters.Equal(this.childAttributeName, parentValue));
            return query;
        }
        return this.query;
    }
    getCustomContextKey(resolvedContext) {
        let parentValue = this.getParentAttributeValue(resolvedContext);
        if (parentValue == null || parentValue == undefined) {
            parentValue = 'null';
        }
        return `${this.contextName}_${parentValue}`;
    }
    getCustomContextFunction(resolvedContext, contextData) {
        if (!this.contextDefinitionServer.LoadAllData || !contextData) {
            return contextData;
        }
        // We need to filter the entire data set to get just the desired row
        if (contextData instanceof Array && contextData.length > 0) {
            const parentValue = this.getParentAttributeValue(resolvedContext);
            // If there isn't a parent value, then just return the first item in the array
            if (!parentValue) {
                return contextData[0];
            }
            const item = contextData.find(cd => cd && cd[this.childAttributeName] === parentValue);
            return item;
        }
        return contextData;
    }
    getParentAttributeValue(resolvedContext) {
        if (resolvedContext.data) {
            return resolvedContext.data[this.parentAttributeName];
        }
        return null;
    }
}

class DwContextService {
    constructor(dwOrmDataService, dwCacheService, dwContextDefaultsService, dwMetaDataService, dwContextRepositoy, dwUiConfigRegistry, dwServiceExecutionUtil, dwLoggingService, dwEventService) {
        // Register all of the default context definitions
        this.dwOrmDataService = dwOrmDataService;
        this.dwCacheService = dwCacheService;
        this.dwContextDefaultsService = dwContextDefaultsService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextRepositoy = dwContextRepositoy;
        this.dwUiConfigRegistry = dwUiConfigRegistry;
        this.dwServiceExecutionUtil = dwServiceExecutionUtil;
        this.dwLoggingService = dwLoggingService;
        this.dwEventService = dwEventService;
        // Delay registration to prevent circular references between context service and expressions that are used in wizards (and other future scenarios)
        const contextService = this;
        setTimeout(() => {
            contextService.registerContextDefinitions();
        }, 100);
    }
    static registerContextDefinition(contextDefinition) {
        const contextDef = findWhere(DwContextService._contextDefinitions, { contextName: contextDefinition.contextName });
        if (contextDef) {
            let index = DwContextService._contextDefinitions.indexOf(contextDef);
            // Remove the existing one if it exists
            DwContextService._contextDefinitions.splice(index, 1);
        }
        DwContextService._contextDefinitions.push(contextDefinition);
    }
    logMissingContext(contextName) {
        // Log a warning only once
        if (DwContextService.missingSecurityContexts.indexOf(contextName) == -1) {
            DwContextService.missingSecurityContexts.push(contextName);
            this.dwLoggingService.logWarning(`Context Definition for ${contextName} was not found`);
        }
    }
    waitForContextDefLoad() {
        if (DwContextService._contextDefsLoadedSubject.value) {
            return of(true);
        }
        return DwContextService._contextDefsLoadedSubject.asObservable().pipe(filter(loaded => loaded));
        // if (DwContextService._contextDefinitionsLoaded) {
        //     return of(true);
        // }
        // const subject = new Subject<any>();
        // setTimeout(() => {
        //     if (DwContextService._contextDefinitionsLoaded) {
        //         subject.next(true);
        //         return;
        //     }
        //     this.waitForContextDefLoad()
        //         .subscribe(() => {
        //             subject.next(true);
        //         });
        // }, 100);
        // return subject.asObservable();
    }
    get contextDefinitions() {
        return DwContextService._contextDefinitions;
    }
    registerDynamicContextDefinition(dynamicContextDef) {
        const existingContextDef = findWhere(this.contextDefinitions, { contextName: dynamicContextDef.contextName });
        if (existingContextDef) {
            let index = this.contextDefinitions.indexOf(existingContextDef);
            // Remove the existing one
            this.contextDefinitions.splice(index, 1);
        }
        this.contextDefinitions.push(dynamicContextDef);
    }
    removeDynamicContextDefinition(contextName) {
        const existingContextDef = findWhere(this.contextDefinitions, { contextName: contextName });
        if (existingContextDef) {
            let index = this.contextDefinitions.indexOf(existingContextDef);
            // Remove the existing one
            this.contextDefinitions.splice(index, 1);
        }
    }
    getContextDefinitions(contextNames) {
        let items = [];
        if (!contextNames) {
            return items;
        }
        for (let contextName of contextNames) {
            const contextDef = findWhere(this.contextDefinitions, { contextName: contextName });
            if (contextDef) {
                items.push(contextDef);
            }
        }
        return items;
    }
    getValidContextDefinitions(item, additionalContexts, existingContexts = [], includeCustomContexts = false) {
        additionalContexts = additionalContexts || [];
        existingContexts = existingContexts || [];
        // Start with additional context (so those show up first)
        const contextDefList = this.contextDefinitions.filter(contextDef => additionalContexts.find(contextName => contextName == contextDef.contextName));
        this.contextDefinitions.filter(contextDef => (contextDef.isGlobal || (contextDef.isCustomUiContext && includeCustomContexts)) || ((item && contextDef.parentItem == item))).forEach(contextDef => {
            if (!contextDefList.find(cd => cd.contextName == contextDef.contextName)) {
                contextDefList.push(contextDef);
            }
        });
        for (let contextName of existingContexts) {
            if (!contextDefList.find(cd => cd.contextName == contextName)) {
                contextDefList.push({
                    contextDisplay: `${contextName} - Missing`,
                    contextName: contextName,
                    isGlobal: false,
                    isMissing: true
                });
            }
        }
        return contextDefList;
    }
    getContextMetaData(contextName) {
        return this.getContextMetaDataList(contextName)
            .pipe(map(results => {
            return results[contextName];
        }));
    }
    getContextMetaDataList(contextNames) {
        if (!contextNames || contextNames.length == 0) {
            return of({});
        }
        ;
        if (typeof contextNames === 'string') {
            contextNames = [contextNames];
        }
        // Get all context defs from the context names
        const contextDefs = contextNames
            .map(contextName => {
            return this.getContextDef(contextName);
        }).filter(cd => cd);
        const itemRequests = this.buildContextQueryItemRequests(contextDefs);
        return this.dwMetaDataService.getSavedQueryMetaDataMulti(itemRequests)
            .pipe(map(queryMetaDataItems => {
            const results = {};
            for (const contextDef of contextDefs) {
                const contextMetaData = {
                    contextDef: contextDef,
                    attributes: contextDef.attributes
                };
                if (!contextMetaData.attributes) {
                    const queryMetaData = this.findQueryMetaData(contextDef, queryMetaDataItems);
                    if (queryMetaData) {
                        contextMetaData.queryMetaData = queryMetaData;
                        contextMetaData.attributes = queryMetaData.Attributes;
                    }
                }
                results[contextDef.contextName] = contextMetaData;
            }
            return results;
        }));
    }
    findQueryMetaData(contextDef, queryMetaDataItems) {
        if (!contextDef || !contextDef.item) {
            return null;
        }
        const itemName = contextDef.item;
        // Note: this caused items using a query to not load any additional meta data - commentted out for now - 1/30/2023
        // if (!contextDef.useItemMetaData) {
        let foundQuery;
        if (contextDef.metaDataQueryId) {
            foundQuery = queryMetaDataItems.find(qmd => qmd.RootItem === itemName && qmd.MetaDataQueryId === contextDef.metaDataQueryId);
        }
        // If it's not found with a query id, used the context name identifier
        if (!foundQuery) {
            foundQuery = queryMetaDataItems.find(qmd => qmd.RootItem === itemName && qmd.UniqueIdentifier === contextDef.contextName);
        }
        if (foundQuery) {
            return foundQuery;
        }
        // }
        // Default to returning just the item metadata
        return queryMetaDataItems.find(qmd => qmd.RootItem === itemName && qmd.MetaDataQueryId === 0);
    }
    buildContextQueryItemRequests(contextDefs) {
        // get unique item requests
        const itemRequests = contextDefs.reduce((list, contextDef) => {
            if (!contextDef.item || contextDef.attributes && contextDef.attributes.length > 0) {
                return list;
            }
            const itemName = contextDef.item;
            let itemRequest = list.find(ir => ir.ItemName === contextDef.item);
            if (!itemRequest) {
                itemRequest = {
                    ItemName: itemName,
                    MetaDataQueryIds: [],
                    MetaDataQueryMeanings: [],
                    Queries: []
                };
                list.push(itemRequest);
            }
            this.setupContextQueryItemRequest(itemRequest, contextDef);
            // if (!contextDef.useItemMetaData) {
            //     if (contextDef.metaDataQueryId) {
            //         if (itemRequest.MetaDataQueryIds.indexOf(contextDef.metaDataQueryId) > 0) {
            //             itemRequest.MetaDataQueryIds.push(contextDef.metaDataQueryId);
            //         }
            //     } else {
            //         if (contextDef.buildQueryFunction) {
            //             const query = contextDef.buildQueryFunction({});
            //             itemRequest.Queries.push({
            //                 UniqueIdentifier: contextDef.contextName,
            //                 Query: contextDef.query
            //             });
            //         } else {
            //             if (contextDef.query) {
            //                 itemRequest.Queries.push({
            //                     UniqueIdentifier: contextDef.contextName,
            //                     Query: contextDef.query
            //                 });
            //             }
            //         }
            //     }
            // }
            return list;
        }, []);
        return itemRequests;
    }
    setupContextQueryItemRequest(itemRequest, contextDef) {
        // Use a query id first
        if (contextDef.metaDataQueryId) {
            if (itemRequest.MetaDataQueryIds.indexOf(contextDef.metaDataQueryId) > 0) {
                itemRequest.MetaDataQueryIds.push(contextDef.metaDataQueryId);
            }
            return;
        }
        // Check if a query is defined
        if (contextDef.query) {
            itemRequest.Queries.push({
                UniqueIdentifier: contextDef.contextName,
                Query: contextDef.query
            });
            return;
        }
        // if no query, it might have a build query function (if this returns null, it won't work so in these cases they will need to set the query on the contextDef)
        if (contextDef.buildQueryFunction) {
            try {
                const query = contextDef.buildQueryFunction({});
                if (query) {
                    itemRequest.Queries.push({
                        UniqueIdentifier: contextDef.contextName,
                        Query: query
                    });
                }
            }
            catch (e) {
            }
        }
    }
    getMetaDataAttributes(item) {
        return this.dwMetaDataService.getMetaData(item)
            .pipe(map(md => {
            if (!md)
                return [];
            return md.Attributes;
        }));
    }
    registerContextDefinitions() {
        const obs = [];
        this.registerDefaultContextDefinition();
        obs.push(this.registerRepositoryContextDefinitions());
        obs.push(this.registerCustomContextDefinitions());
        combineLatest(obs)
            .subscribe(() => {
            DwContextService._contextDefsLoadedSubject.next(true);
        });
    }
    registerCustomContextDefinitions() {
        const registrations = this.dwUiConfigRegistry.getRegisteredItems(DwUiRegistryType.customContext);
        const contextDefObs = [];
        for (const contextReg of registrations) {
            const registrationInstance = this.dwServiceExecutionUtil.createService(contextReg.type);
            if (!registrationInstance) {
                this.dwLoggingService.logWarning(`Context Registration ${contextReg.display} could not be created!`);
                continue;
            }
            const contextDef = registrationInstance.getContextDefinition(contextReg);
            if (contextDef instanceof Observable) {
                contextDefObs.push(contextDef);
            }
            else {
                DwContextService.registerContextDefinition(contextDef);
            }
        }
        if (contextDefObs.length == 0) {
            return of(null);
        }
        return combineLatest(contextDefObs)
            .pipe(tap(contextDefs => {
            for (const contextDef of contextDefs) {
                DwContextService.registerContextDefinition(contextDef);
            }
        }));
    }
    registerDefaultContextDefinition() {
        let contextDefs = this.dwContextDefaultsService.getDefaultContextDefinitions();
        for (let contextDef of contextDefs) {
            DwContextService.registerContextDefinition(contextDef);
        }
    }
    registerRepositoryContextDefinitions() {
        return this.dwContextRepositoy.getContextDataDefinitionEntities()
            .pipe(tap(contextDefServerItems => {
            for (const contextDefServer of contextDefServerItems) {
                this.registerContextDefServer(contextDefServer);
            }
        }));
    }
    registerContextDefServer(contextDefServer) {
        const contextDef = new DwDefaultContextDef();
        contextDef.item = contextDefServer.MainItemName;
        contextDef.parentItem = contextDefServer.ParentItemName;
        contextDef.contextName = contextDefServer.ContextKey;
        contextDef.contextDisplay = contextDefServer.ContextDisplay;
        contextDef.contextDefinitionServer = contextDefServer;
        contextDef.updateOnDataChange = true;
        contextDef.firstOnly = !contextDefServer.LoadAllData;
        contextDef.isGlobal = contextDefServer.IsGlobal;
        contextDef.query = contextDefServer.Query;
        contextDef.attributes = contextDefServer.Attributes;
        contextDef.parentAttributeName = contextDefServer.RelationshipParentAttributeName;
        contextDef.childAttributeName = contextDefServer.RelationshipChildAttributeName;
        contextDef.isServerDef = true;
        if (contextDefServer.LoadAllData) {
            contextDef.returnMultiple = true;
        }
        const cacheInvaliationItems = contextDefServer.CacheInvalidationItems || [contextDefServer.MainItemName];
        // Map the cache invalidation items to ORM Event topics
        contextDef.cacheInvalidationTopics = cacheInvaliationItems
            .map(item => DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(item));
        DwContextService.registerContextDefinition(contextDef);
    }
    getContextDef(contextName) {
        const contextDef = findWhere(this.contextDefinitions, { contextName: contextName });
        if (!contextDef) {
            this.logMissingContext(contextName);
        }
        return contextDef;
    }
    getContextWtihResolve(contextName, contextSubjects) {
        const resolvedContext = this.getResolvedContext(contextSubjects);
        return this.getContext(contextName, resolvedContext);
    }
    getContextsAndResolve(contextNames, resolvedContext) {
        const obs = [];
        contextNames = contextNames || [];
        if (contextNames.length == 0) {
            return of({});
        }
        for (const contextName of contextNames) {
            obs.push(this.getContext(contextName, resolvedContext));
        }
        return combineLatest(obs)
            .pipe(map(results => {
            const resolvedContext = {};
            let index = 0;
            for (let contextName of contextNames) {
                const value = results[index];
                resolvedContext[contextName] = value;
                index++;
            }
            return resolvedContext;
        }));
    }
    getContext(contextName, resolvedContext) {
        const contextDef = this.getContextDef(contextName);
        if (!contextDef) {
            return of(null);
        }
        const loadOb = this.loadContext(contextName, resolvedContext);
        const cacheKey = contextDef.getCustomContextKey ? contextDef.getCustomContextKey(resolvedContext) : contextName;
        // Allow turning off caching (used for in memory contexts suchs as wizard, date/time and user info)
        let finalLoadOb = loadOb;
        if (!contextDef.noCache && loadOb) {
            finalLoadOb = this.dwCacheService.get(cacheKey || contextName, loadOb, null, contextDef.cacheInvalidationTopics);
        }
        if (finalLoadOb == null) {
            finalLoadOb = of(null);
        }
        return finalLoadOb
            .pipe(mergeMap(contextData => {
            if (contextDef.getCustomContextFunction) {
                // Allow custom contexts to return an observable
                const result = contextDef.getCustomContextFunction(resolvedContext, contextData || {});
                if (result instanceof Observable || result instanceof Subject) {
                    return result;
                }
                return of(result);
            }
            if (!contextData) {
                return of(null);
            }
            return of(contextData);
        }));
    }
    getContextTopics(contextNames) {
        const cacheInvalidationTopics = [];
        for (const contextName of contextNames) {
            const contextDef = findWhere(this.contextDefinitions, { contextName: contextName });
            for (const topic of (contextDef === null || contextDef === void 0 ? void 0 : contextDef.cacheInvalidationTopics) || []) {
                if (cacheInvalidationTopics.indexOf(topic) == -1) {
                    cacheInvalidationTopics.push(topic);
                }
            }
        }
        return cacheInvalidationTopics;
    }
    getContextRefreshObservable(contextNames) {
        const topicNames = this.getContextTopics(contextNames);
        if (topicNames.length == 0) {
            return of(null);
        }
        // flatten topic names (put each value as a properties on the object for quick reference (no loops))
        const flatTopicNames = flattenArray(topicNames);
        const subject = new Subject();
        for (const topicName of topicNames) {
            this.dwEventService.getEvent(topicName, true)
                .subscribe(event => {
                const currentContextNames = this.getContextNamesForTopic(event.topic, contextNames);
                //console.log(`getContextRefresh -  {event.topic}`, contextNames);
                subject.next(currentContextNames);
            });
        }
        return subject.asObservable();
    }
    getContextNamesForTopic(topic, allContextNames) {
        var _a;
        const contextNames = [];
        for (const contextName of allContextNames) {
            const contextDef = findWhere(this.contextDefinitions, { contextName: contextName });
            if (((_a = contextDef === null || contextDef === void 0 ? void 0 : contextDef.cacheInvalidationTopics) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                if (contextDef.cacheInvalidationTopics.indexOf(topic) >= 0) {
                    contextNames.push(contextName);
                }
            }
        }
        return contextNames;
    }
    getUpdateContextOnDataChange(contextName) {
        const contextDef = findWhere(this.contextDefinitions, { contextName: contextName });
        if (!contextDef) {
            return false;
        }
        return contextDef.updateOnDataChange;
    }
    loadContext(contextName, context) {
        const contextDef = findWhere(this.contextDefinitions, { contextName: contextName });
        if (!contextDef) {
            return of(null);
        }
        if (contextDef.loadContext) {
            return contextDef.loadContext(context);
        }
        if (contextDef.data) {
            if (contextDef.getCustomContextFunction) {
                // Allow custom contexts to return an observable
                const result = contextDef.getCustomContextFunction(context, contextDef.data);
                if (result instanceof Observable || result instanceof Subject) {
                    return result;
                }
                return of(result);
            }
            return of(contextDef.data);
        }
        let query = contextDef.query;
        if (contextDef.buildQueryFunction) {
            query = contextDef.buildQueryFunction(context);
        }
        if (!query) {
            return of(null);
        }
        if (contextDef.returnMultiple) {
            return this.dwOrmDataService.executeQuery(query);
        }
        return this.dwOrmDataService.executeQuerySingle(query);
    }
    getResolvedContext(contextSubject) {
        var resolvedContext = {};
        for (let contextKeyName in contextSubject) {
            let obs = contextSubject[contextKeyName];
            resolvedContext[contextKeyName] = obs.value;
        }
        return resolvedContext;
    }
}
DwContextService.ɵfac = function DwContextService_Factory(t) { return new (t || DwContextService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwContextDefaultsService), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwContextRepositoryService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwServiceExecutionUtil), ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwEventService)); };
DwContextService.missingSecurityContexts = [];
DwContextService._contextDefinitions = [];
//static _contextDefinitionsLoaded = false;
DwContextService._contextDefsLoadedSubject = new BehaviorSubject(false);
DwContextService.ɵprov = ɵɵdefineInjectable({ factory: function DwContextService_Factory() { return new DwContextService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwCacheService), ɵɵinject(DwContextDefaultsService), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwContextRepositoryService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwServiceExecutionUtil), ɵɵinject(DwLoggingService), ɵɵinject(DwEventService)); }, token: DwContextService, providedIn: "root" });
DwContextService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwCacheService },
    { type: DwContextDefaultsService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextRepositoryService },
    { type: DwUiConfigRegistryService },
    { type: DwServiceExecutionUtil },
    { type: DwLoggingService },
    { type: DwEventService }
];

class DwContainerSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sections = [];
        this.sectionType = DwSectionType.container;
    }
}

var DwMetaDataFormActions;
(function (DwMetaDataFormActions) {
    DwMetaDataFormActions["save"] = "save";
    DwMetaDataFormActions["print"] = "print";
    DwMetaDataFormActions["cancel"] = "cancel";
    DwMetaDataFormActions["custom"] = "custom";
})(DwMetaDataFormActions || (DwMetaDataFormActions = {}));

var DwFormActionKeys;
(function (DwFormActionKeys) {
    DwFormActionKeys["formSave"] = "formSave";
    DwFormActionKeys["formPrint"] = "formPrint";
    DwFormActionKeys["formClose"] = "formClose";
    DwFormActionKeys["formCancel"] = "formCancel";
    DwFormActionKeys["formWorkflow"] = "formWorkflow";
    DwFormActionKeys["formMultiCreate"] = "formMultiCreate";
    DwFormActionKeys["formSetValues"] = "formSetValues";
})(DwFormActionKeys || (DwFormActionKeys = {}));

class DwMetaDataFormActionService {
    constructor(uiConfigRegistryService, uiConfig, uiMetaDataConfig) {
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.uiConfig = uiConfig;
        this.uiMetaDataConfig = uiMetaDataConfig;
    }
    getDefaultFormActionPreferencesByMode(defaultFormButtons) {
        const actionPreferencesByMode = {};
        const actionConfigs = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action, false);
        defaultFormButtons = defaultFormButtons || this.uiMetaDataConfig.formButtonDefaults || {};
        for (const mode in defaultFormButtons) {
            if (defaultFormButtons.hasOwnProperty(mode)) {
                const actionKeys = defaultFormButtons[mode];
                actionPreferencesByMode[mode] = this.buildActionPrefs(actionConfigs, actionKeys, true);
            }
        }
        return actionPreferencesByMode;
    }
    buildActionPrefs(actionConfigs, actionKeys, setDefaults = false) {
        const actionPrefs = [];
        actionKeys = actionKeys || [];
        for (const actionKey of actionKeys) {
            const actionPref = this.buildActionPref(actionConfigs, actionKey);
            actionPrefs.push(actionPref);
        }
        return actionPrefs;
    }
    buildActionPref(actionConfigs, actionKey, setDefaults = false) {
        const actionConfig = actionConfigs.find(a => a.keyName == actionKey);
        if (!actionConfig) {
            console.warn(`Could not find form button action with key ${actionKey}.  Excluding actions`);
            return;
        }
        const actionPref = {
            actionKey: actionKey,
            actionConfig: actionConfig.configData,
            actionDisplay: actionConfig.display,
            buttonConfig: actionConfig.defaultButtonConfig,
            confirmConfig: actionConfig.defaultConfirmConfig,
            menuConfig: actionConfig.defaultMenuConfig,
            securityConfig: actionConfig.defaultSecurityConfig
        };
        if (setDefaults) {
            actionPref.buttonConfig = Object.assign(Object.assign({}, actionPref.buttonConfig), { useButtonDefaults: true });
            actionPref.securityConfig = Object.assign(Object.assign({}, actionPref.securityConfig), { useSecurityDefaults: true });
        }
        return actionPref;
    }
}
DwMetaDataFormActionService.ɵfac = function DwMetaDataFormActionService_Factory(t) { return new (t || DwMetaDataFormActionService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwUIConfigToken), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwMetaDataFormActionService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataFormActionService_Factory() { return new DwMetaDataFormActionService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwUIConfigToken), ɵɵinject(DwUIMetaDataConfigToken)); }, token: DwMetaDataFormActionService, providedIn: "root" });
DwMetaDataFormActionService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];

const FORM_VARIABLE_CONTEXT_PREFIX = 'variable_contex';
class DwDataVariableService {
    constructor(dwContextService) {
        this.dwContextService = dwContextService;
    }
    registerVariableDataContext(dataVariableListConfig, item, uniqueKey) {
        const dataContext = this.convertToDataDefinition(dataVariableListConfig, item, uniqueKey);
        if (dataContext.attributes.length > 0) {
            this.dwContextService.registerDynamicContextDefinition(dataContext);
        }
        else {
            this.dwContextService.removeDynamicContextDefinition(dataContext.contextName);
        }
        return dataContext;
    }
    convertToDataDefinition(dataVariableListConfig, item, uniqueKey) {
        const contextDefinition = {
            contextDisplay: `Variable Context`,
            contextName: `${FORM_VARIABLE_CONTEXT_PREFIX}_-${uniqueKey}`,
            parentItem: item,
            isGlobal: false,
            isEditable: true,
            attributes: [],
            data: {}
        };
        for (let variable of (dataVariableListConfig === null || dataVariableListConfig === void 0 ? void 0 : dataVariableListConfig.variables) || []) {
            const attr = this.buildVariableAttribute(variable);
            contextDefinition.attributes.push(attr);
        }
        return contextDefinition;
    }
    buildVariableAttribute(variable) {
        const queryAttr = {
            AttributeName: variable.name,
            AttributeDisplay: variable.display,
            AttributeType: convertToAttributeType(variable.attributeType),
            FieldType: DwFieldType.Standard,
            DisplayAttributeName: variable.name,
            HasDisplayField: false,
            Attribute: {
                AttributeName: variable.name,
                AttributeType: convertToAttributeType(variable.attributeType),
                Display: variable.display,
                AlwaysRequired: variable.required,
                IsActive: true,
                IsLookup: variable.isLookup,
                MetaDataControlTypeId: variable.controlType,
                MetaDataLookupId: variable.metaDataLookupId,
                CustomListValues: variable.CustomListValues
            }
        };
        return queryAttr;
    }
}
DwDataVariableService.ɵfac = function DwDataVariableService_Factory(t) { return new (t || DwDataVariableService)(ɵngcc0.ɵɵinject(DwContextService)); };
DwDataVariableService.ɵprov = ɵɵdefineInjectable({ factory: function DwDataVariableService_Factory() { return new DwDataVariableService(ɵɵinject(DwContextService)); }, token: DwDataVariableService, providedIn: "root" });
DwDataVariableService.ctorParameters = () => [
    { type: DwContextService }
];

class DwMetaDataFormService {
    constructor(dwOrmDataService, dwMetaDataService, uiMetaDataConfig, uiConfigService, uiConfigRegistryService, dwFormUtilService, dwContextService, dwServiceExecutionUtil, dwMetaDataFormActionService, dwLoggingService, dwDataVariableService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.uiConfigService = uiConfigService;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.dwFormUtilService = dwFormUtilService;
        this.dwContextService = dwContextService;
        this.dwServiceExecutionUtil = dwServiceExecutionUtil;
        this.dwMetaDataFormActionService = dwMetaDataFormActionService;
        this.dwLoggingService = dwLoggingService;
        this.dwDataVariableService = dwDataVariableService;
        this.formGlobalPreferences = new DwMetaDataFormPreferences();
        // this.uiMetaDataConfig = configService.coreConfig.getConfig<DwUIMetaDataConfig>(DwUIMetaDataConfig.configName);
        this.formGlobalPreferences = this.uiMetaDataConfig.formDefaultPreferences;
    }
    getFormDataSource(formPrefHiearchy) {
        var _a;
        let finalPreferences = this.uiConfigService.getFinalPreferences(formPrefHiearchy);
        const result = {
            dataSource: null,
            ormDataHierarchy: []
        };
        let query = finalPreferences.query;
        if (!query) {
            query = new DwQuery(formPrefHiearchy.item);
            this.addPrefetchPaths(query, [finalPreferences.section], result.ormDataHierarchy, finalPreferences);
            query.getFieldSettings().LoadAllLookupDisplayFields = finalPreferences.loadDisplayProperties;
        }
        if (finalPreferences.dataSourceName) {
            result.dataSource = this.uiConfigService.getDataSource(finalPreferences.dataSourceName);
            if (!result.dataSource) {
                console.warn(`DwMetaDataFormService.getFormDataSource -  Could not find data source ${finalPreferences.dataSourceName} - using default`);
            }
        }
        if (!result.dataSource) {
            result.dataSource = new DwOrmDataSource(this.dwOrmDataService, this.dwMetaDataService, query, result.ormDataHierarchy);
        }
        if ((_a = result.dataSource) === null || _a === void 0 ? void 0 : _a.setupOrmDataSource) {
            result.dataSource.setupOrmDataSource(query, result.ormDataHierarchy);
        }
        result.dataSource.initDataSource();
        //result.dataSource = new DwOrmDataSource(this.dwOrmDataService, this.dwMetaDataService, query, result.ormDataHierarchy);
        return result;
    }
    addPrefetchPaths(query, sections, ormDataHierarchy, finalPreferences) {
        for (const section of sections) {
            this.addPrefetchPath(query, section, ormDataHierarchy, finalPreferences);
        }
    }
    addPrefetchPath(query, section, ormDataHierarchy, finalPreferences) {
        if (!section) {
            return;
        }
        var sectionDef = this.dwFormUtilService.getSectionDef(section.sectionType);
        const childSections = this.dwFormUtilService.getSectionChildren(section, sectionDef);
        if (sectionDef.getPrefetchPathInfo) {
            var prefetchPathInfoList = sectionDef.getPrefetchPathInfo(section) || [];
            // Convert to an array
            if (!Array.isArray(prefetchPathInfoList)) {
                prefetchPathInfoList = [prefetchPathInfoList];
            }
            for (const prefetchPathInfo of prefetchPathInfoList) {
                if (prefetchPathInfo) {
                    // Check if this prefetch has already been added
                    let prefetch = (query.Prefetch || []).find(prefetch => prefetch.RelationName == prefetchPathInfo.relationshipName);
                    let childDataHierarchy = ormDataHierarchy.find(hier => hier.itemName == prefetchPathInfo.itemName && hier.propertyName == prefetchPathInfo.propertyName);
                    let subQuery;
                    if (prefetch) {
                        subQuery = prefetch.Query;
                    }
                    else {
                        subQuery = new DwQuery(prefetchPathInfo.itemName);
                        const loadLookupDisplayProperties = prefetchPathInfo.loadLookupFields == null ? finalPreferences.loadDisplayProperties : prefetchPathInfo.loadLookupFields;
                        subQuery.getFieldSettings().LoadAllLookupDisplayFields = loadLookupDisplayProperties;
                        query.AddPrefetchPath(prefetchPathInfo.relationshipName, subQuery);
                        childDataHierarchy = {
                            itemName: prefetchPathInfo.itemName,
                            propertyName: prefetchPathInfo.propertyName,
                            excludeFromSave: prefetchPathInfo.excludeFromSave,
                            children: []
                        };
                        ormDataHierarchy.push(childDataHierarchy);
                    }
                    if (childDataHierarchy) {
                        // Add any child paths onto this subquery
                        this.addPrefetchPaths(subQuery, childSections, childDataHierarchy.children, finalPreferences);
                    }
                }
            }
            if (prefetchPathInfoList.length > 0) {
                // Exit since any child prefetch paths would have been added above
                return;
            }
        }
        this.addPrefetchPaths(query, childSections, ormDataHierarchy, finalPreferences);
    }
    getPreferencesHierarchy(item, configKey, useLoadedPreferences, componentSetPreferences) {
        let metaDataOb = this.dwMetaDataService.getMetaData(item);
        let prefsOb = this.uiConfigService.getPreferencesHierarchy(configKey, DwUiConfigType.form, this.formGlobalPreferences, componentSetPreferences, useLoadedPreferences);
        let itemSecurityOb = this.dwMetaDataService.getUserMetaDataItemSecurity(item);
        // Load context def attributes for any context fields here and assign to a new prop on formConfig
        //  This will allow the form builder and form section get the attributes synchronously
        return combineLatest([metaDataOb, prefsOb, itemSecurityOb])
            .pipe(mergeMap(results => {
            const [metaData, prefHierarchy, itemSecurity] = results;
            let formPrefsHierarchy = new DwMetaDataFormPreferenceHierarchy();
            formPrefsHierarchy = Object.assign(formPrefsHierarchy, prefHierarchy);
            formPrefsHierarchy.item = item;
            formPrefsHierarchy.itemMetaData = metaData;
            formPrefsHierarchy.itemSecurity = itemSecurity;
            formPrefsHierarchy.metaDataItemId = metaData === null || metaData === void 0 ? void 0 : metaData.MetaDataItemId;
            const finalPreferences = this.uiConfigService.getFinalPreferences(formPrefsHierarchy);
            // We need to register the variable context prior to getting the context meta data
            const variableContextData = this.dwDataVariableService.registerVariableDataContext(finalPreferences.variableConfig, item, configKey);
            if (variableContextData.attributes.length > 0) {
                formPrefsHierarchy.variableContextDataKey = variableContextData.contextName;
            }
            return this.dwContextService.getContextMetaDataList(finalPreferences.contextNames)
                .pipe(map(contextMetaDataList => {
                formPrefsHierarchy.contextMetaDataList = contextMetaDataList;
                return formPrefsHierarchy;
            }));
        }));
    }
    getMetaDataItemNames(section, rootItem) {
        var sectionList = this.getSectionList(section);
        const itemNames = [];
        itemNames.push(rootItem);
        for (let section of sectionList) {
            if (section.sectionType == DwSectionType.childData || section.sectionType == DwSectionType.childDataRepeater) {
                let childDataSection = section;
                if (childDataSection.childItem) {
                    itemNames.push(childDataSection.childItem);
                }
            }
        }
        return itemNames;
    }
    buildFormConfig(formPrefHiearchy, useLoadedPreferences, formMode, route, keyValue, ormDataHierarchy) {
        // Combines all the perferences into a final version to build the form with
        let finalPreferences = this.uiConfigService.getFinalPreferences(formPrefHiearchy, !useLoadedPreferences);
        let formConfig = new DwMetaDataFormConfig();
        formConfig.variableContextDataKey = formPrefHiearchy.variableContextDataKey;
        formConfig.readOnly = finalPreferences.readOnly;
        formConfig.readOnlyPreference = finalPreferences.readOnly;
        formConfig.suppressUnsavedChangesMessage = finalPreferences.suppressUnsavedChangesMessage;
        formConfig.formMode = formMode;
        formConfig.useLongDisplay = finalPreferences.useLongDisplay;
        formConfig.workflowPreferences = finalPreferences.workflowPreferences;
        formConfig.canEditRuleKey = finalPreferences.canEditRuleKey;
        formConfig.canAddRuleKey = finalPreferences.canAddRuleKey;
        formConfig.canViewRuleKey = finalPreferences.canViewRuleKey;
        formConfig.loadDisplayProperties = finalPreferences.loadDisplayProperties;
        // Force not loading display properties when added - this causes issues for lookups with defaults - they try to display a blank value
        if (formMode == DwFormContextMode.add) {
            formConfig.loadDisplayProperties = false;
        }
        formConfig.contextMetaDataList = formPrefHiearchy.contextMetaDataList;
        formConfig.rootItemName = formPrefHiearchy.item;
        formConfig.ormDataHierarchy = ormDataHierarchy;
        formConfig.configKey = formPrefHiearchy.configKey;
        formConfig.contextNames = this.dwFormUtilService.getAllContextNames(finalPreferences);
        formConfig.keyName = formPrefHiearchy.itemMetaData.KeyName;
        formConfig.useValidationSummary = finalPreferences.useValidationSummary;
        formConfig.messagingConfig = this.setupMessageConfig(finalPreferences);
        if (!this.applySecurity(formConfig, formPrefHiearchy, route, keyValue)) {
            return of(formConfig);
        }
        if (formConfig.formMode == DwFormContextMode.view || formConfig.formMode === DwFormContextMode.print) {
            formConfig.readOnly = true;
        }
        let section = finalPreferences.section;
        if (!section) {
            section = this.buildDefaultFormSection(formPrefHiearchy.itemMetaData, finalPreferences);
        }
        section = this.addButtonSection(formConfig, finalPreferences, section);
        finalPreferences.section = section;
        formConfig.section = section;
        // We need to set all of the section keys (This generates a unique section key to identify the section)
        this.dwFormUtilService.setAllSectionKeys(formConfig.section);
        // Update form hierarchy preferences so we'll see the new button section in config
        formPrefHiearchy.loadedPreferences = finalPreferences;
        finalPreferences.itemSecurity = formPrefHiearchy.itemSecurity;
        // Add a check to remove buttons if the form is read only by using the item security option
        if (formConfig.readOnly) {
            finalPreferences.itemSecurity = Object.assign(Object.assign({}, formPrefHiearchy.itemSecurity), { CanUpdate: false, CanCreate: false, CanDelete: false });
        }
        formConfig.itemSecurity = finalPreferences.itemSecurity;
        formConfig.section = this.processSection(section, finalPreferences.itemSecurity, formConfig, finalPreferences);
        // We need to set all of the section keys (This generates a unique section key to identify the section)
        this.dwFormUtilService.setAllSectionKeys(formConfig.section);
        /*
        this.buildButtonConfig(formConfig, finalPreferences, formConfig.formMode); */
        // Copy the form config to ensure that we don't modify anything directly at run-time
        formConfig = deepCopy(formConfig, true, 'contextValueFCDefaults');
        return this.getQueryMetaDataList(formConfig, formPrefHiearchy.item)
            .pipe(map(queryMetaDataList => {
            //finalPreferences.queryMetaDataList = queryMetaDataList;
            formConfig.queryMetaDataList = queryMetaDataList;
            return formConfig;
        }));
    }
    processSection(section, itemSecurity, formConfig, finalPreferences, sectionLevel = 0, sectionIndex = 0) {
        if (!section) {
            return;
        }
        const sectionConfig = this.uiConfigRegistryService.getRegisteredItem(DwUiRegistryType.formSections, section.sectionType);
        if (!sectionConfig) {
            return section;
        }
        sectionLevel++;
        if (sectionConfig === null || sectionConfig === void 0 ? void 0 : sectionConfig.sectionConfigInitService) {
            section = this.processSectionConfigInit(sectionConfig, section, itemSecurity, formConfig, finalPreferences);
        }
        const children = this.getSectionChildren(sectionConfig, section);
        if (children) {
            const newChildren = [];
            let index = 0;
            for (const childSection of children) {
                index++;
                const newChildSection = this.processSection(childSection, itemSecurity, formConfig, finalPreferences, sectionLevel, index);
                newChildren.push(newChildSection);
            }
            this.setSectionChildren(sectionConfig, section, newChildren);
        }
        return section;
    }
    processSectionConfigInit(sectionConfig, section, itemSecurity, formConfig, finalPreferences) {
        if (!sectionConfig.sectionConfigInitService) {
            return section;
        }
        const configInitService = this.dwServiceExecutionUtil.createService(sectionConfig.sectionConfigInitService);
        if (configInitService && configInitService.initSectionConfig) {
            // Clear and reset children so they don't get copied over and over
            const children = this.getSectionChildren(sectionConfig, section);
            const sectionInitParams = {
                sectionPreference: section,
                itemSecurity: itemSecurity,
                formConfig: formConfig,
            };
            const newSection = configInitService.initSectionConfig(sectionInitParams);
            this.setSectionChildren(sectionConfig, newSection, children);
            // console.log('Add/Edit buttons', (section as any)?.actionPreferencesByMode?.addEdit.length, (newSection as any)?.finalActionPreferencesByMode?.addEdit.length);
            return newSection;
        }
        return section;
    }
    getSectionChildren(sectionConfig, section) {
        if (sectionConfig.childrenPropertyName) {
            let children = section[sectionConfig.childrenPropertyName];
            if (children) {
                children = Array.isArray(children) ? children : [children];
            }
            return children;
        }
        return null;
    }
    setSectionChildren(sectionConfig, section, children) {
        if (sectionConfig.childrenPropertyName) {
            if (sectionConfig.hasChildren) {
                children = Array.isArray(children) ? children : [children];
            }
            else {
                if (Array.isArray(children)) {
                    children = children.length == 1 ? children[0] : null;
                }
                children = Array.isArray(children) && children.length == 1 ? children[0] : children;
            }
            section[sectionConfig.childrenPropertyName] = children;
        }
    }
    getQueryMetaDataList(formConfig, item) {
        // Define the form metadata
        const metaDataItemNames = this.getMetaDataItemNames(formConfig.section, item);
        const requestItems = metaDataItemNames.map(itemName => {
            return { ItemName: itemName };
        });
        return this.dwMetaDataService.getSavedQueryMetaDataMulti(requestItems)
            .pipe(map(queryMetaDataItems => {
            const queryMdList = {};
            for (const queryMd of queryMetaDataItems) {
                queryMdList[queryMd.RootItem] = queryMd;
            }
            return queryMdList;
        }));
    }
    setupMessageConfig(finalPreferences) {
        const messagingConfig = {};
        switch (finalPreferences.messageLocation) {
            case DwFormMessageLocation.bottomOnly:
                messagingConfig.showBottomMessages = true;
                messagingConfig.showTopMessages = false;
                break;
            case DwFormMessageLocation.topAndBottom:
                messagingConfig.showBottomMessages = true;
                messagingConfig.showTopMessages = true;
                break;
            case DwFormMessageLocation.topOnly:
            default:
                messagingConfig.showBottomMessages = false;
                messagingConfig.showTopMessages = true;
                break;
        }
        return messagingConfig;
    }
    applySecurity(formConfig, formPrefHiearchy, route, keyValue) {
        formConfig.canAccess = true;
        const securityMessages = new DwSecurityMessages();
        if (!formPrefHiearchy.itemSecurity.CanRead) {
            // No Access to the page at all, need to redirect to error page
            formConfig.canAccess = false;
            formConfig.accessErrorMessage = securityMessages.NoReadAccess;
            return false;
        }
        if (formPrefHiearchy.itemMetaData.IsView) {
            formConfig.readOnly = true;
        }
        switch (formConfig.formMode) {
            case DwFormContextMode.view:
            case DwFormContextMode.print:
                // No Checks sine we already checked for read access
                break;
            case DwFormContextMode.add:
                if (formPrefHiearchy.itemMetaData.IsView) {
                    formConfig.accessErrorMessage = 'Views are read only and adds are not allowed';
                    // Change form mode to a view
                    formConfig.formMode = DwFormContextMode.view;
                    return true;
                }
                if (!formPrefHiearchy.itemSecurity.CanCreate) {
                    formConfig.canAccess = false;
                    formConfig.accessErrorMessage = securityMessages.NoCreateAccess;
                    return false;
                }
                break;
            case DwFormContextMode.edit:
                if (formPrefHiearchy.itemMetaData.IsView) {
                    formConfig.accessErrorMessage = 'Views are read only and edits are not allowed';
                    // Change form mode to a view
                    formConfig.formMode = DwFormContextMode.view;
                    return true;
                }
                if (!formPrefHiearchy.itemSecurity.CanUpdate) {
                    formConfig.canAccess = false;
                    formConfig.accessErrorMessage = securityMessages.NoUpdateAccess;
                    // Change form mode to a view
                    formConfig.formMode = DwFormContextMode.view;
                }
                break;
        }
        return true;
    }
    buildButtonSection(formConfig, finalPreferences) {
        const buttonSection = {
            sectionType: DwSectionType.buttonBar,
            actionPreferencesByMode: {},
            showActionMessages: true,
            level: 0,
            sectionNo: -1,
            sectionKey: 'Section-button' // will be re-populated later
        };
        if (finalPreferences.useButtonDefaults || !finalPreferences.buttons) {
            buttonSection.useFormButtonDefaults = true;
            buttonSection.useFormModes = true;
            return buttonSection;
        }
        // Convert button preferences
        this.dwLoggingService.logWarning(`Form config ${formConfig.configKey} contains custom buttons in an old format. These will need to be manually setup using a button section!`);
        buttonSection.actionPreferencesByMode = this.convertButtons(finalPreferences.buttons);
        buttonSection.useFormButtonDefaults = false;
        buttonSection.useFormModes = true;
        return buttonSection;
    }
    convertButtons(buttons) {
        const actionPreferencesByMode = {};
        const actionConfigs = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action, false);
        const formModes = new DwFormContextModeList().getEnumList();
        for (const mode of formModes) {
            const buttonPreferences = buttons[mode.value] || [];
            actionPreferencesByMode[mode.value] = [];
            // if no button preferences, then still use the defaults (This follows the older logic)
            if (buttonPreferences.length == 0) {
                actionPreferencesByMode[mode.value] = this.dwMetaDataFormActionService.buildActionPrefs(actionConfigs, this.uiMetaDataConfig.formButtonDefaults[mode.value]);
                continue;
            }
            for (const buttonPreference of buttonPreferences) {
                const actionPref = this.convertButtonToActionPref(buttonPreference, actionConfigs);
                if (actionPref) {
                    actionPreferencesByMode[mode.value].push(actionPref);
                }
            }
        }
        return actionPreferencesByMode;
    }
    convertButtonToActionPref(buttonPref, actionConfigs) {
        if (buttonPref.formAction && buttonPref.formAction != DwMetaDataFormActions.custom) {
            return this.convertFormAction(buttonPref.formAction, buttonPref, actionConfigs);
        }
        const actionPreference = {
            actionDisplay: buttonPref.buttonConfig.buttonText,
            actionKey: buttonPref.customActionKey,
            buttonConfig: Object.assign(Object.assign({}, buttonPref.buttonConfig), { useParentDisplay: true, useButtonDefaults: true }),
            actionConfig: {
                redirectAfter: buttonPref.redirectAfter,
                requireValidation: buttonPref.requireValidation,
                actionMessage: buttonPref.actionMessage,
            },
            securityConfig: {
                useSecurityDefaults: true
            }
        };
        return actionPreference;
    }
    convertFormAction(formAction, buttonPref, actionConfigs) {
        let actionKey = '';
        switch (formAction) {
            case DwMetaDataFormActions.save:
                actionKey = DwFormActionKeys.formSave;
                break;
            case DwMetaDataFormActions.cancel:
                actionKey = DwFormActionKeys.formCancel;
                break;
            case DwMetaDataFormActions.print:
                actionKey = DwFormActionKeys.formPrint;
                break;
            default:
                return;
        }
        const actionPref = this.dwMetaDataFormActionService.buildActionPref(actionConfigs, actionKey, true);
        if (!actionPref) {
            this.dwLoggingService.logWarning(`Could not build action preference for button config with key ${actionKey}`);
            return;
        }
        // Note: Not sure if we should use the buttonConfig here, we might just want to use the default since this requires manual class customization going forward
        // actionPref.buttonConfig = buttonPref.buttonConfig || actionPref.buttonConfig;
        actionPref.actionConfig = actionPref.actionConfig || {};
        actionPref.actionConfig = {
            redirectAfter: buttonPref.redirectAfter,
            requireValidation: buttonPref.requireValidation,
            actionMessage: buttonPref.actionMessage
        };
        return actionPref;
    }
    /* private buildButtonConfig(formConfig: DwMetaDataFormConfig, finalPreferences: DwMetaDataFormPreferences, formMode: DwFormContextMode) {
        let modeButtons = [];

        if (!finalPreferences.useButtonDefaults) {
            modeButtons = this.getFormModeButtons(formMode, finalPreferences.buttons);
        }

        if (modeButtons.length === 0) {
            modeButtons = this.getFormModeButtons(formMode, this.uiMetaDataConfig.buttonDefaults);
        }


        formConfig.buttons = modeButtons;
    }

    private getFormModeButtons(formMode: DwFormContextMode, buttons: DwModeButtonsType): DwFormButtonPreference[] {
        let modeButtons = [];

        if (buttons) {
            modeButtons = buttons[formMode] || [];

            if ((modeButtons.length === 0) && (formMode === DwFormContextMode.add || formMode === DwFormContextMode.edit)) {
                modeButtons = this.getFormModeButtons(DwFormContextMode.addEdit, buttons);
            }
        }

        return modeButtons;
    } */
    // public getAllRules(formConfig: DwMetaDataFormConfig): string[] {
    //     let ruleKeys: string[] = [];
    //     this.addRule(formConfig.canAddRuleKey, ruleKeys);
    //     this.addRule(formConfig.canEditRuleKey, ruleKeys);
    //     this.addRule(formConfig.canViewRuleKey, ruleKeys);
    //     var sections = this.getSectionList(formConfig.section);
    //     for (let section of sections) {
    //         this.addSectionRules(section, ruleKeys);
    //     }
    //     return ruleKeys;
    // }
    // private addRule(ruleKey: string, ruleKeys: string[]) {
    //     if (ruleKey) {
    //         ruleKeys.push(ruleKey);
    //     }
    // }
    // private addSectionRules(section: DwSectionBasePreference, ruleKeys: string[]) {
    //     this.addRule(section.visibleRuleKey, ruleKeys);
    //     if (this.dwFormUtilService.isFormSection(section)) {
    //         for (let fieldConfig of section.fields) {
    //             this.addRule(fieldConfig.visibleRuleName, ruleKeys);
    //             this.addRule(fieldConfig.readOnlyRuleName, ruleKeys);
    //         }
    //     }
    // }
    addButtonSection(formConfig, preferences, rootSection) {
        // Check if any button sections exist, if no, don't add it
        // This should be a one-time add for new forms that haven't been saved yet
        if (preferences.useButtonDefaults === false) {
            return rootSection;
        }
        preferences.useButtonDefaults = false;
        const buttonSection = this.buildButtonSection(formConfig, preferences);
        if (rootSection.sectionType == DwSectionType.container) {
            rootSection.sections.push(buttonSection);
            return rootSection;
        }
        // Build a new container section and return that as the new root section
        const containerSection = new DwContainerSectionPreference();
        containerSection.title = 'Root';
        containerSection.columnPreferences = {
            columns: 1,
            columnDetails: []
        };
        containerSection.sections = [
            rootSection,
            buttonSection
        ];
        return containerSection;
    }
    buildDefaultFormSection(itemMetaData, preferences) {
        // Build default section
        let section = new DwFormSectionPreference();
        section.columnPreferences = new DwSectionColumnPreferences();
        section.columnPreferences.columns = 2;
        section.useContainerStyling = true;
        section.title = itemMetaData.Display;
        section.showTitle = true;
        section.fields = [];
        for (let attr of itemMetaData.Attributes) {
            var fieldPreference = this.buildFieldPreference(attr, preferences);
            if (fieldPreference)
                section.fields.push(fieldPreference);
        }
        return section;
    }
    udpateSection(currentSection, section) {
        if (currentSection.sectionNo == section.sectionNo) {
            Object.assign(currentSection, section);
            return;
        }
        if (currentSection.section) {
            this.udpateSection(currentSection.section, section);
        }
        if (currentSection.sections) {
            for (let subSection of currentSection.sections) {
                this.udpateSection(subSection, section);
            }
        }
    }
    getSectionList(section, excludeFunc) {
        const sections = [];
        this.addSection(section, sections, 0, 0, excludeFunc);
        return sections;
    }
    addSection(currentSection, sections, level, sectionNo, excludeFunc) {
        if (!currentSection)
            return;
        if (excludeFunc && excludeFunc(currentSection, level))
            return;
        sectionNo++;
        /*
                currentSection.level=level;
                currentSection.sectionNo = sectionNo; */
        sections.push(currentSection);
        var childSections = this.dwFormUtilService.getSectionChildren(currentSection);
        for (var childSection of childSections) {
            this.addSection(childSection, sections, level + 1, sectionNo);
        }
    }
    buildFieldPreference(attr, formPreferences) {
        if (this.ignoreAttr(attr, formPreferences))
            return null;
        var field = new DwFormFieldPreference();
        field.attrName = attr.AttributeName;
        field.columnItemPreferences = new DwFormColumnItemPreference();
        var controlType = attr.MetaDataControlTypeId;
        if (controlType == DwControlType.HTMLEditor || controlType == DwControlType.TextArea) {
            field.columnItemPreferences.spanAllColumns = true;
            field.columnItemPreferences.newRowBefore = true;
        }
        return field;
    }
    ignoreAttr(attr, formPreferences) {
        if (formPreferences.hidePrimaryKey && attr.IsKey)
            return true;
        if (formPreferences.ignoreAttributes && formPreferences.ignoreAttributes.length > 0) {
            return formPreferences.ignoreAttributes.indexOf(attr.AttributeName) >= 0;
        }
        return false;
    }
}
DwMetaDataFormService.ɵfac = function DwMetaDataFormService_Factory(t) { return new (t || DwMetaDataFormService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwUiConfigService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwMetadataFormUtilService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwServiceExecutionUtil), ɵngcc0.ɵɵinject(DwMetaDataFormActionService), ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwDataVariableService)); };
DwMetaDataFormService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataFormService_Factory() { return new DwMetaDataFormService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwUiConfigService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwMetadataFormUtilService), ɵɵinject(DwContextService), ɵɵinject(DwServiceExecutionUtil), ɵɵinject(DwMetaDataFormActionService), ɵɵinject(DwLoggingService), ɵɵinject(DwDataVariableService)); }, token: DwMetaDataFormService, providedIn: "root" });
DwMetaDataFormService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigService },
    { type: DwUiConfigRegistryService },
    { type: DwMetadataFormUtilService },
    { type: DwContextService },
    { type: DwServiceExecutionUtil },
    { type: DwMetaDataFormActionService },
    { type: DwLoggingService },
    { type: DwDataVariableService }
];

class DwStateBaseService {
    constructor() {
        this.stateSubject = new BehaviorSubject(null);
        this.clearState();
    }
    /**
     * Returns the current immutable state
     */
    get state() {
        return this.stateSubject.value;
    }
    /**
     * Returns an observable when the state changes
     */
    get stateChanged() {
        return this.stateSubject.asObservable();
    }
    get deepCopyState() { return false; }
    ;
    setState(newState) {
        if (!newState) {
            return;
        }
        const copiedState = this.copyState(newState);
        this.stateSubject.next(copiedState);
    }
    clearState() {
        this.setState(this.getInitialState());
    }
    copyState(state) {
        const currentState = this.stateSubject.value;
        let newState = Object.assign(Object.assign({}, currentState), state);
        if (this.deepCopyState) {
            newState = deepCopy(newState, true);
        }
        return newState;
    }
}

class DwDesignerStateService extends DwStateBaseService {
    constructor() {
        super(...arguments);
        this.configureSectionSubject = new Subject();
    }
    getInitialState() {
        return {};
    }
    setSection(sectionKey, detailKey, configKey, additionalInfo) {
        this.setState({
            configKey: configKey,
            sectionKey: sectionKey,
            detailKey: detailKey,
            additionalInfo: additionalInfo
        });
        // console.log(`${sectionKey} - ${detailKey}`, additionalInfo);
    }
    configureSection(sectionKey, detailKey, configKey, additionalInfo) {
        this.setSection(sectionKey, detailKey, configKey, additionalInfo);
        this.configureSectionSubject.next(this.state);
    }
    hoverSection(section, sectionId, elementDetail) {
        let sectionDesc = section.title ? `${section.title} (${section.sectionType})` : `${sectionId} (${section.sectionType})`;
        if (elementDetail === null || elementDetail === void 0 ? void 0 : elementDetail.attrName) {
            const fieldInfo = elementDetail;
            let fieldDesc = fieldInfo.contextName ? `${fieldInfo.contextName}.${fieldInfo.attrName}` : fieldInfo.attrName;
            //console.log(`Hover info for section ${sectionDesc} and field ${fieldDesc}`, elementDetail);
            return;
        }
        //console.log(`Hover info for section ${sectionDesc}`, section);
    }
}
DwDesignerStateService.ɵfac = function DwDesignerStateService_Factory(t) { return ɵDwDesignerStateService_BaseFactory(t || DwDesignerStateService); };
DwDesignerStateService.ɵprov = ɵɵdefineInjectable({ factory: function DwDesignerStateService_Factory() { return new DwDesignerStateService(); }, token: DwDesignerStateService, providedIn: "root" });

//@Component({
//    selector: 'dw-ui-config-widget-base',
//    template: 'Base Template does not have a UI',
//})
class DwUiPanelWidgetBaseComponent {
    constructor(fb, dwDesignerStateService) {
        this.fb = fb;
        this.dwDesignerStateService = dwDesignerStateService;
        this.subscriptions = [];
        this.ignoreFormUpdate = false;
        this.preferencesChange = new EventEmitter();
        this.preferenceChangeWithSave = new EventEmitter();
        this.messageChange = new EventEmitter();
        this.configForm = this.createForm(fb);
        this.setFormValue();
        this.subscriptions.push(this.dwDesignerStateService.stateChanged.subscribe(state => {
            this.updateDesignerState(state);
        }));
        this.subscriptions.push(this.dwDesignerStateService.configureSectionSubject.subscribe(state => {
            this.handleConfigureSection(state);
        }));
    }
    get preferences() {
        return this.preferencesValue;
    }
    set preferences(value) {
        if (areEqual(value, this.preferencesValue)) {
            this.ignoreFormUpdate = false;
            return;
        }
        this.setPreferenceDefaults(value);
        let callConfigSet = false;
        if (!this.preferencesValue) {
            callConfigSet = true;
            this.originalPreferences = value;
        }
        this.preferencesValue = value;
        if (!this.ignoreFormUpdate)
            this.setFormValue();
        this.ignoreFormUpdate = false;
        this.preferencesChange.emit(this.preferencesValue);
        // Ensure we only call config set when the preferences have gone from null to set
        if (callConfigSet) {
            this.configSet();
        }
        if (this.openConfigAfter) {
            this.openConfigAfter = false;
            this.startConfigureSection(this.designerState);
        }
    }
    setPreferenceDefaults(value) {
    }
    setMessage(message) {
        if (typeof (message) == 'string') {
            message = {
                messageBody: message
            };
        }
        this.message = message;
        this.messageChange.emit(this.message);
    }
    setFormValue() {
        if (!this.configForm || !this.preferencesValue)
            return;
        this.ignoreFormUpdate = true;
        this.configForm.reset();
        this.configForm.patchValue(this.preferencesValue);
        this.ignoreFormUpdate = false;
    }
    updateDesignerState(state) {
        this.designerState = state;
    }
    handleConfigureSection(state) {
        if (this.preferences) {
            this.startConfigureSection(state);
            return;
        }
        this.openConfigAfter = true;
    }
    configSet() {
    }
    ngOnInit() {
        this.subscriptions.push(this.configForm.valueChanges.subscribe(() => {
            if (!this.ignoreFormUpdate)
                this.onFormChange();
        }));
    }
    onFormChange() {
        // This will contain the form values, but might not include everything in the preferences that is needed,
        //    therefore we will copy these over to the original object
        var formValue = this.configForm.value;
        var newPrefs = Object.assign(Object.assign({}, this.preferences), formValue);
        //// Only update if values have indeed changed
        //if (!areEqual(newPrefs,this.preferences))
        this.ignoreFormUpdate = true;
        this.preferences = newPrefs;
    }
    ngOnDestroy() {
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwUiPanelWidgetBaseComponent.ɵfac = function DwUiPanelWidgetBaseComponent_Factory(t) { return new (t || DwUiPanelWidgetBaseComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService)); };
DwUiPanelWidgetBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwUiPanelWidgetBaseComponent, inputs: { preferences: "preferences", message: "message", preferencesHierarchy: "preferencesHierarchy" }, outputs: { preferencesChange: "preferencesChange", preferenceChangeWithSave: "preferenceChangeWithSave", messageChange: "messageChange" } });
DwUiPanelWidgetBaseComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwDesignerStateService }
];
DwUiPanelWidgetBaseComponent.propDecorators = {
    preferencesHierarchy: [{ type: Input }],
    preferencesChange: [{ type: Output }],
    preferenceChangeWithSave: [{ type: Output }],
    preferences: [{ type: Input }],
    message: [{ type: Input }],
    messageChange: [{ type: Output }]
};

class DwMetaDataRoutingService {
    constructor(dwOrmDataService, dwRoutingService, uiMetaDataConfig, metaDataService, menuService, menuHelperService, DwMenuBuilderService, dwModalService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwRoutingService = dwRoutingService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.metaDataService = metaDataService;
        this.menuService = menuService;
        this.menuHelperService = menuHelperService;
        this.DwMenuBuilderService = DwMenuBuilderService;
        this.dwModalService = dwModalService;
        this.gridGlobalPreferences = new DwMetaDataGridPreferences();
    }
    returnToPrevious() {
        this.dwRoutingService.returnToPrevious();
    }
    routeToNoAccess(item, formContextMode) {
        alert(`No Access to item ${item}`);
    }
    routeToEditView(route, item, dataEntity, actionType = DwMenuActionType.edit, windowOpenOptions) {
        const keyValue = this.dwOrmDataService.getKeyValue(dataEntity);
        return this.routeToEditOrViewWithKey(route, item, keyValue, actionType, windowOpenOptions);
    }
    openAddEditViewModal(actionType, item, keyValue, addContext, dataSource, configKeyPart, modalOptions, forceConfigKeyPart) {
        // Default the action type if it is not set - default to add if no key and edit if there is a key
        actionType = actionType || (keyValue ? DwMenuActionType.edit : DwMenuActionType.add);
        let modalConfig = modalOptions || new DwModalConfig();
        if (modalConfig.allowFullScreen == undefined) {
            modalConfig.allowFullScreen = true;
        }
        modalConfig.modalSize = modalConfig.modalSize || DwModalSize.large;
        modalConfig.cloneData = false;
        modalConfig.data = {
            keyValue: keyValue,
            item: item,
            addContext: addContext,
            dataSource: dataSource,
            actionType: actionType,
            configKeyPart: configKeyPart,
            forceConfigKeyPart: forceConfigKeyPart
        };
        modalConfig.component = this.uiMetaDataConfig.formPageComponent;
        return this.metaDataService.getMetaData(item)
            .pipe(mergeMap(itemDTO => {
            const displayName = itemDTO.Display;
            let title;
            switch (actionType) {
                case DwMenuActionType.add:
                    title = `Add ${displayName}`;
                    modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel;
                    break;
                case DwMenuActionType.edit:
                    title = `Edit ${displayName}`;
                    modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel;
                    break;
                case DwMenuActionType.view:
                    title = `View ${displayName}`;
                    modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];
                    break;
                case DwMenuActionType.print:
                    title = `Print ${displayName}`;
                    modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];
                    break;
            }
            modalConfig.title = modalConfig.title || title;
            return this.dwModalService.showModal(modalConfig);
        }));
    }
    routeToEditOrViewWithKey(route, item, keyValue, actionType = DwMenuActionType.edit, windowOpenOptions) {
        let url = this.buildEditOrViewUrlWithKey(route, item, keyValue, actionType);
        this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
    }
    buildEditOrViewUrlWithKey(route, item, keyValue, actionType = DwMenuActionType.edit) {
        let childMenu = this.findClosetChildMenu(item, actionType, null, route);
        if (childMenu) {
            let url = childMenu.url;
            let finalRouteUrl = this.populateUrlParams(url, item, keyValue);
            return finalRouteUrl;
        }
        const url = this.buildMetaDataRouteUrl(actionType, this.uiMetaDataConfig, item, keyValue);
        return url;
    }
    routeToAdd(route, item, windowOpenOptions) {
        return this.routeToEditOrViewWithKey(route, item, null, DwMenuActionType.add, windowOpenOptions);
    }
    routeToGrid(item, windowOpenOptions) {
        const url = this.buildMetaDataRouteUrl(DwMenuActionType.list, this.uiMetaDataConfig, item);
        this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
    }
    routeToParent(route, item, actionType = null, keyValue, isSave = false, windowOpenOptions) {
        let routeSnapshot = route.snapshot;
        if (isSave && routeSnapshot.data) {
            const menuData = routeSnapshot.data;
            if (menuData.onSavePath) {
                let url = menuData.onSavePath;
                let finalRouteUrl = this.populateUrlParams(url, item, keyValue);
                this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
                return;
            }
        }
        let parentRoute = this.findParentRoute(routeSnapshot, item, actionType);
        if (!parentRoute) {
            return this.routeToGrid(item);
        }
        else {
            const url = this.dwRoutingService.buildUrl(parentRoute);
            this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
        }
    }
    routeToSibling(route, item, actionType = null, keyValue, windowOpenOptions) {
        let routeSnapshot = route.snapshot;
        let parentRoute = this.findParentRoute(routeSnapshot, item, DwMenuActionType.list);
        if (!parentRoute) {
            return this.routeToGrid(item);
        }
        else {
            var childRoute = parentRoute.children.find(child => {
                let menuData = child.data;
                if (!actionType || menuData.metaDataActionType == actionType) {
                    return true;
                }
                return false;
            });
            if (childRoute) {
                let url = this.dwRoutingService.buildUrl(childRoute);
                url = this.DwMenuBuilderService.replaceUrlParams(url, this.menuService.menuState.currentParams);
                this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
            }
        }
    }
    findParentRoute(activatedRoute, itemName, actionType) {
        var _a;
        var parent = activatedRoute.parent;
        const menuData = activatedRoute.data;
        if ((_a = menuData.childListMenuOptions) === null || _a === void 0 ? void 0 : _a.isChildListMenu) {
            return parent;
        }
        while (parent) {
            let menuData = parent.data;
            if (menuData && ((!menuData.metaDataItem && menuData.metaDataActionType) || menuData.metaDataItem == itemName)) {
                // optionally use the action type
                if (!actionType || menuData.metaDataActionType == actionType) {
                    return parent;
                }
            }
            parent = parent.parent;
        }
        return null;
    }
    findFirstChildMenu(itemName, actionType, menu, useParentMenu = true) {
        let isCurrentMenu = false;
        if (!menu) {
            menu = this.menuService.menuState.currentMenu;
            isCurrentMenu = true;
        }
        if (!menu.children) {
            menu = this.menuService.getParentMenuItem();
            isCurrentMenu = false;
            if (!menu || !useParentMenu) {
                return null;
            }
        }
        for (let childMenu of menu.children) {
            const menuData = childMenu.data;
            if (menuData.metaDataActionType == actionType) {
                // Removing isCurrentMenu check
                // if (menuData && menuData.metaDataItem==itemName || isCurrentMenu) {
                if (menuData && menuData.metaDataItem == itemName) {
                    return childMenu;
                }
            }
            var foundSubChild = this.findFirstChildMenu(itemName, actionType, childMenu, false);
            if (foundSubChild) {
                return foundSubChild;
            }
        }
        return null;
    }
    findClosetChildMenu(itemName, actionType, menu, route) {
        const allMenus = this.findChildMenus(itemName, actionType, menu);
        if (allMenus.length == 0) {
            return null;
        }
        let sortedMenus = sortArrayByField(allMenus, "level");
        // console.log(`Closest menu  item: ${itemName}   actionTyep : ${actionType}`, sortedMenus);
        return sortedMenus[0].menu;
    }
    findChildMenus(itemName, actionType, menu, useParentMenu = true, level = 0) {
        let isCurrentMenu = false;
        let menusResult = [];
        if (!menu) {
            menu = this.menuService.menuState.currentMenu;
            isCurrentMenu = true;
        }
        if (!menu.children) {
            menu = this.menuService.getParentMenuItem();
            isCurrentMenu = false;
            if (!menu || !useParentMenu) {
                return null;
            }
        }
        for (let childMenu of menu.children) {
            const menuData = childMenu.data;
            if (menuData.metaDataActionType == actionType) {
                // Removing isCurrentMenu check
                // if (menuData && menuData.metaDataItem==itemName || isCurrentMenu) {
                if (menuData && menuData.metaDataItem == itemName) {
                    menusResult.push({ level: level, menu: childMenu });
                }
            }
            var foundSubChildren = this.findChildMenus(itemName, actionType, childMenu, false, level + 1);
            if (foundSubChildren && foundSubChildren.length > 0) {
                menusResult = [...menusResult, ...foundSubChildren];
            }
        }
        return menusResult;
    }
    editMetaDataItem(route, item) {
        this.metaDataService.getMetaData(item)
            .subscribe((r) => {
            this.routeToEditOrViewWithKey(route, DevwareMetaDataItemNames.DwMetaDataItem, r.MetaDataItemId);
        });
    }
    findExistingRoute(actionType, itemName, keyValue) {
        const menuMatch = this.matchMenu(actionType, itemName, keyValue);
        return this.menuHelperService.findMenu(menuMatch, this.menuService.menuState.securedMenus);
    }
    findExistingRoutes(actionType, itemName, keyValue, includeParentMenus = true) {
        const menuMatch = this.matchMenu(actionType, itemName, keyValue);
        return this.menuHelperService.findMenus(menuMatch, this.menuService.menuState.securedMenus, includeParentMenus);
    }
    matchMenu(actionType, itemName, keyValue) {
        return (menu) => {
            if (menu && menu.data && menu.data.metaDataItem && menu.data.metaDataItem.toLowerCase() == itemName.toLowerCase()) {
                if (menu.data.metaDataActionType) {
                    const sameActionType = (actionType == menu.data.metaDataActionType);
                    switch (actionType) {
                        case DwMenuActionType.add:
                        case DwMenuActionType.edit:
                        case DwMenuActionType.view:
                        case DwMenuActionType.list:
                            if (sameActionType) {
                                return true;
                            }
                            return false;
                        case DwMenuActionType.addEdit:
                            if (sameActionType) {
                                return true;
                            }
                            if (menu.data.metaDataActionType == DwMenuActionType.edit && keyValue) {
                                return true;
                            }
                            if (menu.data.metaDataActionType == DwMenuActionType.add && !keyValue) {
                                return true;
                            }
                            return false;
                            break;
                    }
                }
                return false;
            }
        };
    }
    buildMetaDataRouteUrl(actionType, uiMetaDataConfig, itemName, keyValue = null) {
        var routeBaseUrl;
        // Get all menus for this item
        var existingMenus = this.findExistingRoutes(actionType, itemName, keyValue, false);
        let existingMenu = null;
        // Use first menu that has all of the parameters
        for (let menu of existingMenus) {
            if (this.hasAllMenuParams(menu, itemName, keyValue)) {
                existingMenu = menu;
                break;
            }
        }
        if (existingMenu && existingMenu.url) {
            routeBaseUrl = existingMenu.url;
        }
        else {
            switch (actionType) {
                case DwMenuActionType.list:
                    routeBaseUrl = uiMetaDataConfig.defaultMetaDataGridRouteUrl;
                    break;
                case DwMenuActionType.add:
                case DwMenuActionType.addEdit:
                case DwMenuActionType.edit:
                    if (keyValue)
                        routeBaseUrl = uiMetaDataConfig.defaultMetaDataFormEditRouteUrl;
                    else
                        routeBaseUrl = uiMetaDataConfig.defaultMetaDataFormAddRouteUrl;
                    break;
                case DwMenuActionType.view:
                    routeBaseUrl = uiMetaDataConfig.defaultMetaDataFormViewRouteUrl;
                    break;
            }
        }
        //let finalRouteUrl = routeBaseUrl.replace(":itemName", itemName);
        let finalRouteUrl = this.populateUrlParams(routeBaseUrl, itemName, keyValue);
        return finalRouteUrl;
    }
    hasAllMenuParams(menu, itemName, keyValue) {
        let url = this.populateUrlParams(menu.url, itemName, keyValue);
        // remove http and https 
        url = url.replace('http://', '').replace('https://', '');
        if (url.indexOf(':') > 0) {
            return false;
        }
        return true;
    }
    populateUrlParams(url, itemName, keyValue) {
        let finalRouteUrl = url.replace(":itemName", itemName);
        const paramName = getMenuActionParamName(itemName);
        finalRouteUrl = finalRouteUrl.replace(paramName, keyValue);
        finalRouteUrl = this.DwMenuBuilderService.replaceUrlParams(finalRouteUrl, this.menuService.menuState.currentParams);
        finalRouteUrl = finalRouteUrl.replace(":keyValue", keyValue);
        return finalRouteUrl;
    }
}
DwMetaDataRoutingService.ɵfac = function DwMetaDataRoutingService_Factory(t) { return new (t || DwMetaDataRoutingService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwRoutingServiceToken), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwMenuService), ɵngcc0.ɵɵinject(DwMenuHelperService), ɵngcc0.ɵɵinject(DwMenuBuilderService), ɵngcc0.ɵɵinject(DwModalService)); };
DwMetaDataRoutingService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataRoutingService_Factory() { return new DwMetaDataRoutingService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwRoutingServiceToken), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwMenuService), ɵɵinject(DwMenuHelperService), ɵɵinject(DwMenuBuilderService), ɵɵinject(DwModalService)); }, token: DwMetaDataRoutingService, providedIn: "root" });
DwMetaDataRoutingService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMenuService },
    { type: DwMenuHelperService },
    { type: DwMenuBuilderService },
    { type: DwModalService }
];

// This directive is used to dynamically load the config implementation component with in the DwUiConfigBaseComponent
class DwComponentHost {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
DwComponentHost.ɵfac = function DwComponentHost_Factory(t) { return new (t || DwComponentHost)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DwComponentHost.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwComponentHost, selectors: [["", "dw-component-host", ""]] });
DwComponentHost.ctorParameters = () => [
    { type: ViewContainerRef }
];

var DwSectionConfigNodeType;
(function (DwSectionConfigNodeType) {
    DwSectionConfigNodeType["section"] = "section";
    DwSectionConfigNodeType["data"] = "data";
    DwSectionConfigNodeType["events"] = "events";
    DwSectionConfigNodeType["security"] = "security";
})(DwSectionConfigNodeType || (DwSectionConfigNodeType = {}));

class DwSectionConfigTreeService {
    constructor(dwMetadataFormUtilService, uiConfigRegistryService) {
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.sectionDefinitions = [];
        this.sectionDefinitions = uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
    }
    getSectionDef(sectionType) {
        let item = this.sectionDefinitions.find(sd => sd.keyName == sectionType);
        if (item == null) {
            item = {
                component: null,
                configComponent: null,
                display: `${sectionType}(Missing)`,
                omitInConfigTree: true,
                keyName: sectionType,
                sectionIcon: '',
            };
        }
        return item;
    }
    buildTree(rootSection) {
        let newTree = [];
        this.buildTreeInternal(rootSection, newTree, null);
        return newTree;
    }
    syncTree(rootSection, sectionTree) {
        let newTree = [];
        this.buildTreeInternal(rootSection, newTree, null);
        // if (this.componentInstance) {
        //     this.componentInstance.contextNames = this.dwMetadataFormUtilService.getAllContextNames(this.preferences);
        // }
        // newTree.push(this.buildButtonNode());
        if (sectionTree.length == 0) {
            // Initial Tree
            sectionTree = newTree;
            if (sectionTree.length > 0 && sectionTree[2].children.length > 0) {
                // Expand the first node
                sectionTree[2].expanded = true;
            }
            return;
        }
        this.syncNodes(sectionTree, newTree);
    }
    syncNodes(existingNodes, newNodes) {
        for (let i = existingNodes.length - 1; i >= 0; i--) {
            const existingNode = existingNodes[i];
            if (existingNode.type != DwSectionConfigNodeType.section) {
                continue;
            }
            // var newNode = _.find(newNodes, (item) => item.data == existingNode.data);
            const newNode = newNodes.find(item => item.data == existingNode.data);
            if (newNode) {
                const newNodeIndex = newNodes.indexOf(newNode);
                if (i != newNodeIndex) {
                    console.log('Node changed index');
                    moveItemInArray(existingNodes, i, newNodeIndex);
                }
                this.syncNode(existingNode, newNode);
            }
            else {
                existingNodes.splice(i, 1);
            }
        }
        for (let newNode of newNodes) {
            if (newNode.type != DwSectionConfigNodeType.section) {
                continue;
            }
            //var existingNode = _.find(existingNodes, (item) => item.data == newNode.data);
            const existingNode = existingNodes.find(item => item.data == newNode.data);
            if (!existingNode) {
                newNode.expanded = true;
                existingNodes.push(newNode);
            }
        }
    }
    syncNode(existingNode, newNode) {
        existingNode.label = newNode.label;
        existingNode.icon = newNode.icon;
        this.syncNodes(existingNode.children, newNode.children);
    }
    buildTreeInternal(section, parentNodes, parentSection) {
        // If we're working with the root, add data and event nodes
        if (!parentSection) {
            this.addAdditionalConfigNodes(parentNodes);
        }
        const node = this.buildSectionNode(section, parentSection);
        if (!parentSection) {
            // Override first note
            node.label = 'Form Layout';
            node.icon = 'fa fa-th-large dw-orange';
        }
        const sectionDef = this.getSectionDef(section.sectionType);
        let childNodes = node.children;
        ;
        if (!sectionDef.omitInConfigTree) {
            parentNodes.push(node);
        }
        else {
            childNodes = parentNodes;
        }
        const childSections = this.dwMetadataFormUtilService.getSectionChildren(section, sectionDef);
        for (let childSection of childSections) {
            const sectionToUse = sectionDef.hasChild ? parentSection : section;
            this.buildTreeInternal(childSection, childNodes, sectionToUse);
        }
    }
    addAdditionalConfigNodes(parentNodes) {
        const dataNode = this.buildAdditionalConfigNode('Data', 'fa fa-database dw-blue', DwSectionConfigNodeType.data);
        parentNodes.push(dataNode);
        // const eventsNode = this.buildAdditionalConfigNode('Events','fa fa-bolt dw-orange', DwSectionConfigNodeType.events);
        // parentNodes.push(eventsNode);
        const securityNode = this.buildAdditionalConfigNode('Security', 'fa fa-user-lock dw-red', DwSectionConfigNodeType.security);
        parentNodes.push(securityNode);
    }
    buildAdditionalConfigNode(label, icon, nodeType) {
        let node = {};
        node.label = label;
        node.icon = icon;
        node.type = nodeType;
        // node.leaf = false;
        node.draggable = false;
        node.droppable = false;
        return node;
    }
    buildSectionNode(section, parentSection) {
        var _a, _b, _c;
        let node = {};
        const sectionDef = this.getSectionDef(section.sectionType);
        const parentDef = parentSection ? this.getSectionDef(parentSection.sectionType) : null;
        node.label = this.getSectionDisplay(section, sectionDef, parentSection, parentDef);
        node.icon = `${sectionDef.sectionIcon} tree-icon`;
        node.data = section;
        node.type = DwSectionConfigNodeType.section;
        node.children = [];
        if (((_a = sectionDef === null || sectionDef === void 0 ? void 0 : sectionDef.dragDropConfig) === null || _a === void 0 ? void 0 : _a.preventDrag) || ((_b = parentDef === null || parentDef === void 0 ? void 0 : parentDef.dragDropConfig) === null || _b === void 0 ? void 0 : _b.preventChildDrag)) {
            node.draggable = false;
        }
        node.droppable = !!((_c = sectionDef.dragDropConfig) === null || _c === void 0 ? void 0 : _c.allowChildDrop);
        return node;
    }
    findNode(nodes, section) {
        for (let node of nodes) {
            if (node.type == DwSectionConfigNodeType.section && areEqual(node.data, section)) {
                return node;
            }
            if (node.children) {
                let result = this.findNode(node.children, section);
                if (result)
                    return result;
            }
        }
        return null;
    }
    getSectionDisplay(section, sectionDef, parentSection, parentSectionDef) {
        const sectionTypeDisplay = sectionDef.display;
        let prefix = '';
        let title = section.title;
        if (sectionDef.getCustomConfigDisplay) {
            return sectionDef.getCustomConfigDisplay(section, sectionDef, parentSection, parentSectionDef);
        }
        if (parentSectionDef) {
            prefix = parentSectionDef.childDisplayPrefix ? parentSectionDef.childDisplayPrefix + ': ' : '';
            if (parentSectionDef.childDisplayProperty) {
                title = parentSection[parentSectionDef.childDisplayProperty];
            }
        }
        if (title) {
            return `${prefix}${title} (${sectionTypeDisplay})`;
        }
        return `${prefix}${sectionTypeDisplay}`;
    }
}
DwSectionConfigTreeService.ɵfac = function DwSectionConfigTreeService_Factory(t) { return new (t || DwSectionConfigTreeService)(ɵngcc0.ɵɵinject(DwMetadataFormUtilService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService)); };
DwSectionConfigTreeService.ɵprov = ɵɵdefineInjectable({ factory: function DwSectionConfigTreeService_Factory() { return new DwSectionConfigTreeService(ɵɵinject(DwMetadataFormUtilService), ɵɵinject(DwUiConfigRegistryService)); }, token: DwSectionConfigTreeService, providedIn: "root" });
DwSectionConfigTreeService.ctorParameters = () => [
    { type: DwMetadataFormUtilService },
    { type: DwUiConfigRegistryService }
];

class DwSectionConfigStateService {
    constructor(dwSectionConfigTreeService, dwMetaDataService, dwMetadataFormUtilService, metaDataFormService, loggingService) {
        this.dwSectionConfigTreeService = dwSectionConfigTreeService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.metaDataFormService = metaDataFormService;
        this.loggingService = loggingService;
        this.treeRoot = [];
        this.stateChangeSubject = new Subject();
    }
    stateChanged() {
        return this.stateChangeSubject.asObservable();
    }
    setDesignerDetailUsed() {
        const state = this.state;
        state.designerDetailUsed = true;
        this.setState(state);
    }
    initializeState(preferences, itemName, configKey, designerState) {
        this.originalPreferences = deepCopy(preferences);
        return this.getItemMetaData(itemName)
            .pipe(map(itemMetaData => {
            const mdItemList = {};
            mdItemList[itemName] = itemMetaData;
            // If no section, build a default form section
            if (!preferences.section) {
                preferences.section = this.metaDataFormService.buildDefaultFormSection(itemMetaData, preferences);
            }
            const sectionTree = this.dwSectionConfigTreeService.buildTree(preferences.section);
            // Set the tree root one time because we can't replace it and keep the tree state
            this.treeRoot = sectionTree;
            const formLayoutNode = sectionTree[2];
            formLayoutNode.expanded = true;
            let selectedNode = formLayoutNode;
            if (designerState === null || designerState === void 0 ? void 0 : designerState.sectionKey) {
                selectedNode = this.determineSelectedNode(preferences, formLayoutNode, designerState);
            }
            if (!selectedNode) {
                selectedNode = formLayoutNode;
            }
            this.setupRequiredContextNames(preferences);
            const state = {
                itemName: itemName,
                configKey: configKey,
                preferences: preferences,
                sectionTree: sectionTree,
                itemMetaDataList: mdItemList,
                currentSectionNode: selectedNode,
                currentSection: selectedNode.data,
                designerState: designerState,
                treeMenus: this.buildMenu(),
            };
            this.setState(state);
            return state;
        }));
    }
    determineSelectedNode(preferences, currentNode, designerState) {
        const currentSectionKey = this.dwMetadataFormUtilService.getSectionConfigUniqueId(currentNode.data, preferences.section);
        if (currentSectionKey == designerState.sectionKey) {
            return currentNode;
        }
        for (let node of currentNode.children || []) {
            const foundNode = this.determineSelectedNode(preferences, node, designerState);
            if (foundNode) {
                node.expanded = true;
                return foundNode;
            }
        }
        return null;
    }
    /**
     * Required Contexts are setup when the form preferences are initially created in the dw-metadata-form-config-widget
     *   then then are automatically added when a new section requiring context data is added or a variable data context is added
     * @param preferences
     */
    setupRequiredContextNames(preferences) {
        // Get context names from the preference list
        const sectionRequestContextNames = this.dwMetadataFormUtilService.getSectionContextNames(preferences);
        // should already be initialized, but just in case
        preferences.requiredContextNames = preferences.requiredContextNames || [];
        // add any missing required context names
        for (let contextName of sectionRequestContextNames) {
            if (preferences.requiredContextNames.indexOf(contextName) == -1) {
                preferences.requiredContextNames.push(contextName);
            }
        }
        // add these contexts to the list of context names
        for (let contextName of preferences.requiredContextNames) {
            if (preferences.contextNames.indexOf(contextName) == -1) {
                preferences.contextNames.push(contextName);
            }
        }
        this.dwMetadataFormUtilService.getAllContextNames(preferences);
    }
    getSectionDef(sectionType) {
        return this.dwSectionConfigTreeService.getSectionDef(sectionType);
    }
    getItemMetaData(itemName) {
        var _a;
        if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.itemMetaDataList[itemName]) {
            return of(this.state.itemMetaDataList[itemName]);
        }
        return this.dwMetaDataService.getMetaData(itemName)
            .pipe(tap(itemMd => {
            var _a;
            if ((_a = this.state) === null || _a === void 0 ? void 0 : _a.itemMetaDataList) {
                this.state.itemMetaDataList[itemName] = itemMd;
                this.setState(this.state);
            }
        }));
    }
    setState(state) {
        this.state = state;
        this.stateChangeSubject.next(state);
    }
    updateSection(sectionChange) {
        Object.assign(this.state.currentSection, sectionChange);
        this.dwSectionConfigTreeService.syncTree(this.state.preferences.section, this.treeRoot);
        // Reassign the selected node (since it was recreated)
        this.state.currentSectionNode = this.dwSectionConfigTreeService.findNode(this.treeRoot, this.state.currentSection);
        this.setupRequiredContextNames(this.state.preferences);
        //this.state.contextNames = this.dwMetadataFormUtilService.getAllContextNames(this.state.preferences);
        this.setState(this.state);
    }
    canDropSection(dragNode, dropNode, index) {
        var _a, _b, _c, _d, _e;
        let parentDropNode = dropNode.parent;
        let parentDragNode = dragNode.parent;
        // If a dropIndex is set, then item was dropped onto the drop node, so it should be the parent
        if (index !== undefined) {
            parentDropNode = dropNode;
        }
        const dropSection = dropNode.data;
        const dragSection = dragNode.data;
        if (!parentDropNode || !parentDragNode || !dropSection || !dragSection) {
            return false;
        }
        const dragSectionDef = this.dwSectionConfigTreeService.getSectionDef(dragSection.sectionType);
        const dropSectionDef = this.dwSectionConfigTreeService.getSectionDef(dropSection.sectionType);
        const parentDropSectionDef = this.dwSectionConfigTreeService.getSectionDef(parentDropNode.data.sectionType);
        const parentDragSectionDef = this.dwSectionConfigTreeService.getSectionDef(parentDragNode.data.sectionType);
        if (!((_a = parentDropSectionDef.dragDropConfig) === null || _a === void 0 ? void 0 : _a.allowChildDrop)) {
            return false;
        }
        if (((_b = dragSectionDef.dragDropConfig) === null || _b === void 0 ? void 0 : _b.dropParentSectionType) && ((_c = dragSectionDef.dragDropConfig) === null || _c === void 0 ? void 0 : _c.dropParentSectionType) != parentDropNode.data.sectionType) {
            console.log(`Prevent drop (by Child) for section type ${dragSection.sectionType} in parent section type ${parentDropNode.data.sectionType}`);
            return false;
        }
        if (((_d = parentDropSectionDef.dragDropConfig) === null || _d === void 0 ? void 0 : _d.dropChildSectionType) && ((_e = parentDropSectionDef.dragDropConfig) === null || _e === void 0 ? void 0 : _e.dropChildSectionType) != dragSection.sectionType) {
            console.log(`Prevent drop (by Parent) for section type ${dragSection.sectionType} in parent section type ${parentDropNode.data.sectionType}`);
            return false;
        }
        // Trigger a state change
        this.setState(this.state);
        return true;
    }
    moveSection(dragNode, dropNode, dropIndex, index) {
        let parentDropNode = dropNode.parent;
        let parentDragNode = dragNode.parent;
        // If a dropIndex is set, then item was dropped onto the drop node, so it should be the parent
        if (index !== undefined) {
            parentDropNode = dropNode;
        }
        const parentDropSectionDef = this.dwSectionConfigTreeService.getSectionDef(parentDropNode.data.sectionType);
        const parentDragSectionDef = this.dwSectionConfigTreeService.getSectionDef(parentDragNode.data.sectionType);
        const dropChildren = parentDropNode.data[parentDropSectionDef.childrenPropertyName];
        const dragChildren = parentDragNode.data[parentDragSectionDef.childrenPropertyName];
        if (parentDropNode.data == parentDragNode.data) {
            // Move within the same parent
            const currentIndex = dropChildren.indexOf(dragNode.data);
            console.log(`order section within parent ${dragNode.label} to ${parentDropNode.label} Current Index: ${currentIndex} Drop index: ${dropIndex}`);
            moveItemInArray(dropChildren, currentIndex, dropIndex);
        }
        else {
            // Move to a different parent
            console.log(`Move section to new parent ${dragNode.label} to ${parentDropNode.label} Drop index: ${dropIndex}`);
            dropChildren.splice(dropIndex, 0, dragNode.data);
            const currentIndex = dragChildren.indexOf(dragNode.data);
            dragChildren.splice(currentIndex, 1);
        }
        this.setState(this.state);
    }
    addParentSection(node, sectionDef) {
        const existingSection = node.data;
        if (!sectionDef.wrapOptions.createWrapSection) {
            this.loggingService.logWarning(`MetaData Section Configuration - Can't wrap section because sectionDef is missing createWrapSection`);
            return;
        }
        const newSection = sectionDef.wrapOptions.createWrapSection(existingSection);
        this.replaceSection(node, existingSection, newSection);
    }
    removeSection(node) {
        const section = node.data;
        this.replaceSection(node, section, null);
    }
    duplicateSection(node) {
        var _a;
        const parentSection = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.data;
        const newChildSection = deepCopy(node.data);
        const parentSectionDef = this.getSectionDef(parentSection.sectionType);
        const children = parentSection[parentSectionDef.childrenPropertyName];
        if (Array.isArray(children)) {
            children.push(newChildSection);
        }
        this.dwSectionConfigTreeService.syncTree(this.state.preferences.section, this.treeRoot);
    }
    replaceSection(node, section, newSection) {
        if (!node.parent) {
            if (newSection) {
                this.state.preferences.section = newSection;
                // this.preferences.section = newSection;
            }
            else {
                // Build default form as the root element
                const currentMetaData = this.state.itemMetaDataList[this.state.itemName];
                this.state.preferences.section = this.metaDataFormService.buildDefaultFormSection(currentMetaData, this.state.preferences);
            }
        }
        else {
            const parentSection = node.parent.data;
            const sectionDef = this.dwSectionConfigTreeService.getSectionDef(parentSection.sectionType);
            if (sectionDef.hasChildren) {
                const children = parentSection[sectionDef.childrenPropertyName] || [];
                const sectionIndex = children.indexOf(section);
                if (sectionIndex >= 0) {
                    if (newSection) {
                        children[sectionIndex] = newSection;
                    }
                }
            }
            if (sectionDef.hasChild) {
                parentSection[sectionDef.childrenPropertyName || 'section'] = newSection;
            }
        }
        this.dwSectionConfigTreeService.syncTree(this.state.preferences.section, this.treeRoot);
        this.setupRequiredContextNames(this.state.preferences);
        var selectedNode = this.dwSectionConfigTreeService.findNode(this.treeRoot, newSection);
        if (!selectedNode)
            selectedNode = this.treeRoot[0];
        this.setCurrentSection(selectedNode);
        this.setState(this.state);
    }
    buildMenu() {
        var _a;
        const menuItems = [];
        const sectionDefs = this.dwSectionConfigTreeService.sectionDefinitions;
        for (const sectionDef of sectionDefs) {
            if ((_a = sectionDef.wrapOptions) === null || _a === void 0 ? void 0 : _a.allowWrap) {
                menuItems.push({
                    label: `Wrap with ${sectionDef.display}`,
                    command: (event) => {
                        this.addParentSection(this.state.currentSectionNode, sectionDef);
                    }
                });
            }
        }
        menuItems.push({
            label: 'Remove',
            command: (event) => {
                this.removeSection(this.state.currentSectionNode);
            }
        });
        return menuItems;
    }
    buildSectionMenu(node) {
        var _a;
        const menus = this.buildMenu();
        let showCopy = false;
        let sectionDef;
        // Get parent section
        const section = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.data;
        if (section === null || section === void 0 ? void 0 : section.sectionType) {
            sectionDef = this.getSectionDef(section === null || section === void 0 ? void 0 : section.sectionType);
            if (sectionDef.hasChildren) {
                showCopy = true;
            }
        }
        menus.push({
            label: 'Duplicate',
            title: 'Creates a duplicate section including all children',
            command: (event) => {
                this.duplicateSection(node);
            }
        });
        return menus;
    }
    showCopy(node) {
        var _a;
        // Get parent section
        const section = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.data;
        if (section === null || section === void 0 ? void 0 : section.sectionType) {
            const sectionDef = this.getSectionDef(section === null || section === void 0 ? void 0 : section.sectionType);
            if (sectionDef.hasChildren) {
                return true;
            }
        }
        return false;
    }
    setCurrentSection(selectedNode) {
        const state = this.state;
        state.currentSectionNode = selectedNode;
        state.currentSection = selectedNode.data;
        this.setState(state);
    }
}
DwSectionConfigStateService.ɵfac = function DwSectionConfigStateService_Factory(t) { return new (t || DwSectionConfigStateService)(ɵngcc0.ɵɵinject(DwSectionConfigTreeService), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwMetadataFormUtilService), ɵngcc0.ɵɵinject(DwMetaDataFormService), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwSectionConfigStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSectionConfigStateService, factory: DwSectionConfigStateService.ɵfac });
DwSectionConfigStateService.ctorParameters = () => [
    { type: DwSectionConfigTreeService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormService },
    { type: DwLoggingService }
];

class DwMetadataSectionConfigComponent {
    constructor(dwMetaDataService, metaDataFormService, fb, resolver, uiMetaDataConfig, uiConfigRegistryService, loggingService, cdr, dwMetadataFormUtilService, dwSectionConfigTreeService, dwSectionConfigStateService) {
        this.dwMetaDataService = dwMetaDataService;
        this.metaDataFormService = metaDataFormService;
        this.fb = fb;
        this.resolver = resolver;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.loggingService = loggingService;
        this.cdr = cdr;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwSectionConfigTreeService = dwSectionConfigTreeService;
        this.dwSectionConfigStateService = dwSectionConfigStateService;
        this.closeModal = new EventEmitter();
        this.cmSectionItems = [];
        // uiMetaDataConfig: DwUIMetaDataConfig;  
        this.setupComplete = false;
        // this.uiMetaDataConfig = configService.getConfig<DwUIMetaDataConfig>(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        const preferences = this.modalConfig.data.preferences;
        this.itemName = this.modalConfig.data.itemName;
        this.configKey = this.modalConfig.data.configKey;
        this.dwSectionConfigStateService.initializeState(preferences, this.modalConfig.data.itemName, this.modalConfig.data.configKey, this.modalConfig.data.designerState)
            .subscribe(state => {
            this.cmSectionItems = state.treeMenus;
            setTimeout(() => {
                this.setupComplete = true;
            });
        });
    }
    // Modal button click
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        result.closeModal = true;
        result.cancelled = false;
        result.data = {
            preferences: this.dwSectionConfigStateService.state.preferences,
        };
        switch (buttonConfig.command) {
            case DwButtonCommand.cancel:
                result.cancelled = true;
        }
        return of(result);
    }
    setCurrentSection(node) {
        this.dwSectionConfigStateService.setCurrentSection(node);
    }
    nodeMenu(event, node) {
        const menus = this.dwSectionConfigStateService.buildSectionMenu(node);
        this.cmSectionItems = menus;
        this.cmSection.show(event);
        return false;
    }
    nodeDropped(event) {
        // Check if the drag/drop is valid
        if (!this.dwSectionConfigStateService.canDropSection(event.dragNode, event.dropNode, event.index)) {
            return;
        }
        // Move the section in the section hierarchy (which is parellet to the tree hierarchy)
        this.dwSectionConfigStateService.moveSection(event.dragNode, event.dropNode, event.dropIndex, event.index);
        // Accept the drop
        event.accept();
    }
    nodeExpand(event) {
        //  this.dwSectionConfigStateService.expandNode(event.node);
    }
    onButtonChange() {
    }
}
DwMetadataSectionConfigComponent.ɵfac = function DwMetadataSectionConfigComponent_Factory(t) { return new (t || DwMetadataSectionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwLoggingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwSectionConfigTreeService), ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService)); };
DwMetadataSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataSectionConfigComponent, selectors: [["dw-metadata-section-config"]], viewQuery: function DwMetadataSectionConfigComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DwComponentHost, true);
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cmSection = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TreeDragDropService, DwSectionConfigStateService])], decls: 1, vars: 1, consts: [["class", "p-tab-no-borders", 4, "ngIf"], [1, "p-tab-no-borders"], [1, "main-container"], [3, "panelSizes"], ["pTemplate", ""], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "model"], ["cmSection", ""], [1, "dw-panel"], ["selectionMode", "single", "draggableNodes", "true", "droppableNodes", "true", 3, "value", "selection", "validateDrop", "selectionChange", "onNodeDrop", "onNodeExpand"], ["pTemplate", "section"], ["pTemplate", "other"], [3, "contextmenu"]], template: function DwMetadataSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataSectionConfigComponent_div_0_Template, 7, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.setupComplete);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc5.Splitter, ɵngcc6.PrimeTemplate, ɵngcc7.ContextMenu, ɵngcc8.Tree, DwConfigPanelHostComponent]; }, styles: [".move-arrow-down{display:block;margin-top:-25px}.main-container{min-width:800px;width:100%}.dw-panel{height:100%;width:100%}.dw-panel .dw-panel-left{float:left;height:100%;width:320px}.dw-panel .dw-panel-right{float:left;height:100%;min-width:800px;padding-left:5px;width:calc(100% - 390px)}.dw-panel-flex{background-color:#000;display:flex;flex-flow:row;height:100%;padding:5px}.dw-panel-flex .dw-panel-left{background-color:#add8e6;display:flex;flex-direction:row;padding:5px;width:300px}.dw-panel-flex .dw-panel-right{background-color:#90ee90;display:flex;flex:3;flex-basis:100%;flex-direction:row;min-width:500px;padding:5px}.ui-tree{width:100%}.tree-icon{color:#4dbd74!important}.button-icon{color:#00f!important}"], encapsulation: 2 });
DwMetadataSectionConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormService },
    { type: FormBuilder },
    { type: ComponentFactoryResolver },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: DwLoggingService },
    { type: ChangeDetectorRef },
    { type: DwMetadataFormUtilService },
    { type: DwSectionConfigTreeService },
    { type: DwSectionConfigStateService }
];
DwMetadataSectionConfigComponent.propDecorators = {
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost,] }],
    cmSection: [{ type: ViewChild, args: ["cmSection",] }]
};

class DwMetadataFormWorkflowConfigComponent {
    constructor(dwMetaDataService, metaDataFormService, fb) {
        this.dwMetaDataService = dwMetaDataService;
        this.metaDataFormService = metaDataFormService;
        this.fb = fb;
        this.closeModal = new EventEmitter();
        this.formModes = [DwFormContextMode.add, DwFormContextMode.edit, DwFormContextMode.view, DwFormContextMode.print];
        this.currentFormMode = DwFormContextMode.add;
    }
    ngOnInit() {
        //console.log("DwMetaDataFormWorkflowConfig.ngOnInit");
        this.preferences = this.modalConfig.data.preferences;
        this.item = this.modalConfig.data.itemName;
        if (!this.preferences.workflowPreferences) {
            this.preferences.workflowPreferences = {
                enableWorkflow: false,
            };
        }
        if (this.preferences.useButtonDefaults === undefined) {
            this.preferences.useButtonDefaults = true;
        }
        this.setupForm();
        this.dwMetaDataService.getMetaData(this.item)
            .subscribe((itemMetaData) => {
            this.itemMetaData = itemMetaData;
            this.itemAttributes = itemMetaData.Attributes.filter(a => a.IsLookup);
            this.setupLookup(this.preferences.workflowPreferences.lookupId);
        });
    }
    setupForm() {
        //console.log("DwContentConfigEdit.setupForm");
        this.workflowFG = this.fb.group({
            enableWorkflow: [null],
            workflowAttrName: [null],
            lookupId: [null],
            buttonDisplayAttrName: [null],
            requireValidationAttrName: [null],
            toolTipAttrName: [null],
            useAlternateActionDisplay: [null],
            overrideCurrentStatusDisplay: [null],
            currentStatusDisplay: [null],
            buttonClassAttrName: [null]
        });
        this.formGroup = this.fb.group({
            workflowPreferences: this.workflowFG,
            useButtonDefaults: [null],
        });
        this.enableWorkflowFC = this.workflowFG.get("enableWorkflow");
        this.workflowAttrNameFC = this.workflowFG.get("workflowAttrName");
        this.lookupIdFC = this.workflowFG.get("lookupId");
        this.workflowAttrNameFC.valueChanges
            .subscribe((value) => {
            if (value) {
                if (this.itemAttributes) {
                    let workflowAttribute = findWhere(this.itemAttributes, { AttributeName: value });
                    if (workflowAttribute) {
                        this.lookupIdFC.setValue(workflowAttribute.MetaDataLookupId);
                    }
                    this.setupLookup(workflowAttribute.MetaDataLookupId);
                }
            }
        });
        this.formGroup.patchValue(this.preferences);
    }
    setupLookup(lookupId) {
        if (!lookupId) {
            return;
        }
        if (this.lookupId == lookupId) {
            return;
        }
        this.lookupId = lookupId;
        this.dwMetaDataService.getLookupDefAttributes(lookupId)
            .subscribe((lookupAttrs) => {
            this.lookupAttributes = lookupAttrs;
        });
    }
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        this.updatePreferences();
        result.closeModal = true;
        result.cancelled = false;
        result.data = {
            preferences: this.preferences
        };
        switch (buttonConfig.command) {
            case DwButtonCommand.cancel:
                result.cancelled = true;
        }
        return of(result);
    }
    resetTest() {
        this.initialStatusValue = null;
    }
    changeInitialValue(value) {
        this.initialStatusValue = value;
    }
    workflowButtonClick(validationRequired) {
        const value = this.initialStatusValue;
        this.handlingWorkflowClick = true;
        this.initialStatusValue = null;
        setTimeout(() => {
            this.initialStatusValue = value;
            this.handlingWorkflowClick = false;
        });
    }
    updatePreferences() {
        var prefs = this.formGroup.value;
        this.preferences.workflowPreferences = prefs.workflowPreferences;
        this.preferences.useButtonDefaults = prefs.useButtonDefaults;
    }
}
DwMetadataFormWorkflowConfigComponent.ɵfac = function DwMetadataFormWorkflowConfigComponent_Factory(t) { return new (t || DwMetadataFormWorkflowConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DwMetadataFormWorkflowConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFormWorkflowConfigComponent, selectors: [["dw-metadata-form-workflow-config"]], decls: 3, vars: 2, consts: [[2, "max-width2", "500px"], [3, "formGroup"], [4, "ngIf"], ["header", "Buttons"], ["dwRow", ""], ["dwCol", "6", "formGroupName", "workflowPreferences"], ["formControlName", "enableWorkflow"], ["dwCol", "6", 4, "ngIf"], ["header", "Workflow", "formGroupName", "workflowPreferences", 4, "ngIf"], ["header", "Test Workflow", 4, "ngIf"], ["dwCol", "6"], ["formControlName", "useButtonDefaults"], [3, "items", "ngModel", "ngModelOptions", "ngModelChange"], ["header", "Workflow", "formGroupName", "workflowPreferences"], ["formControlName", "workflowAttrName", 1, "form-control"], ["value", ""], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 3, "hidden"], ["formControlName", "buttonDisplayAttrName", 1, "form-control"], ["formControlName", "buttonClassAttrName", 1, "form-control"], ["formControlName", "toolTipAttrName", 1, "form-control"], ["formControlName", "requireValidationAttrName", 1, "form-control"], ["formControlName", "useAlternateActionDisplay"], ["formControlName", "overrideCurrentStatusDisplay"], ["type", "text", "formControlName", "currentStatusDisplay", 1, "form-control"], [3, "ngValue"], ["header", "Test Workflow"], [1, "btn", "btn-success", 3, "click"], ["useTransitions", "false", 3, "lookupId", "ngModel", "ngModelOptions", "ngModelChange"], [3, "hidden"], [3, "lookupId", "ngModel", "ngModelOptions", "workflowPreferences", "ngModelChange", "buttonClick"]], template: function DwMetadataFormWorkflowConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "form", 1);
        ɵngcc0.ɵɵtemplate(2, DwMetadataFormWorkflowConfigComponent_p_tabView_2_Template, 12, 4, "p-tabView", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup);
    } }, directives: function () { return [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.FormGroupName, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwPillsComponent, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, DwSelectLookupComponent, DwButtonBarComponent, DwWorkflowLookupButtonsComponent]; }, styles: [""] });
DwMetadataFormWorkflowConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormService },
    { type: FormBuilder }
];

class DwMetaDataFormConfigService {
    constructor(dwOrmDataService, dwMetaDataService, uiMetaDataConfig, dwModalService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwModalService = dwModalService;
        this.formGlobalPreferences = new DwMetaDataFormPreferences();
        this.inMemoryUpdateCommand = 'inMemoryUpdate';
        this.formGlobalPreferences = this.uiMetaDataConfig.formDefaultPreferences;
    }
    showSectionConfigModal(preferences, configKey, item, savePreferences = false, designerState) {
        return this.showModal(preferences, item, configKey, "Configure Section", DwMetadataSectionConfigComponent, savePreferences, designerState);
    }
    showWorkflowConfigModal(preferences, configKey, item, savePreferences = false) {
        return this.showModal(preferences, item, configKey, "Configure Buttons", DwMetadataFormWorkflowConfigComponent, savePreferences);
    }
    showModal(preferences, item, configKey, title, component, savePreferences = false, designerState) {
        let modalConfig = new DwModalConfig();
        const inMemoryButton = {
            buttonText: 'In Memory update',
            buttonTitle: 'Use this to test settings',
            buttonClass: 'btn btn-warning',
            command: this.inMemoryUpdateCommand,
            buttonType: DwButtonType.standard,
            isCancel: false
        };
        // Find form section(s) - Using the first one right now
        modalConfig.title = title;
        modalConfig.component = component;
        modalConfig.modalSize = DwModalSize.extraLarge;
        modalConfig.buttons = [
            DwModalButtonStandardConfigs.instance.saveButton,
            inMemoryButton,
            DwModalButtonStandardConfigs.instance.cancelButton
        ];
        modalConfig.allowFullScreen = true;
        modalConfig.data = {
            preferences: preferences,
            itemName: item,
            configKey: configKey,
            designerState: designerState,
        };
        return this.dwModalService.showModal(modalConfig); /*
            .pipe(map(r => {

                r.buttonCommand
                if (!r.cancelled) {
                    return r.data.preferences;
                }

                return null;
            })); */
    }
}
DwMetaDataFormConfigService.ɵfac = function DwMetaDataFormConfigService_Factory(t) { return new (t || DwMetaDataFormConfigService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwModalService)); };
DwMetaDataFormConfigService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataFormConfigService_Factory() { return new DwMetaDataFormConfigService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwModalService)); }, token: DwMetaDataFormConfigService, providedIn: "root" });
DwMetaDataFormConfigService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwModalService }
];

/**
 * Register rules in code that are marked by a decorator
 */
class DwRulesRegistry {
    registerRule(rule) {
        DwRulesRegistry.rules.set(rule.ruleName, rule);
    }
    getRule(ruleName) {
        return DwRulesRegistry.rules.get(ruleName);
    }
    getRules() {
        let rules = [];
        DwRulesRegistry.rules.forEach((rule) => {
            rules.push(rule);
        });
        return rules;
    }
}
DwRulesRegistry.ɵfac = function DwRulesRegistry_Factory(t) { return new (t || DwRulesRegistry)(); };
DwRulesRegistry.rules = new Map();
DwRulesRegistry.ɵprov = ɵɵdefineInjectable({ factory: function DwRulesRegistry_Factory() { return new DwRulesRegistry(); }, token: DwRulesRegistry, providedIn: "root" });

function isExpressionReference(expr) {
    return expr.referenceType !== undefined;
}

var DwExpressionReferenceType;
(function (DwExpressionReferenceType) {
    DwExpressionReferenceType["item"] = "item";
    DwExpressionReferenceType["context"] = "context";
    DwExpressionReferenceType["value"] = "value";
})(DwExpressionReferenceType || (DwExpressionReferenceType = {}));
class DwExpressionReferenceTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwExpressionReferenceType[propertyName];
    }
    getKeys() {
        return Object.keys(DwExpressionReferenceType);
    }
    getEnumDisplay(value) {
        switch (value) {
            case DwExpressionReferenceType.item:
                return "Item";
            case DwExpressionReferenceType.context:
                return "Context";
            case DwExpressionReferenceType.value:
                return "Value";
        }
    }
    getEnumData(value) {
        switch (value) {
            case DwExpressionReferenceType.item:
                return {
                    icon: 'fa fa-database'
                };
            case DwExpressionReferenceType.context:
                return {
                    icon: 'fa fa-books'
                };
            case DwExpressionReferenceType.value:
                return {
                    icon: 'fa fa-keyboard'
                };
        }
    }
}
/*
export class DwExpressionReferenceTypeList {
    public static getDisplay(value: DwExpressionReferenceType) {

        switch (value) {
           case DwExpressionReferenceType.item:
                return "Item";
            case DwExpressionReferenceType.context:
                return "Context";
            case DwExpressionReferenceType.value:
                return "Value";
        }
    }

    public static getDisplayList() {
        const list=[];
        Object.keys(DwExpressionReferenceType).map(k=> {
            list.push({
                value : k,
                display : DwExpressionReferenceTypeList.getDisplay(<DwExpressionReferenceType>k),
            })
        });

        return list;
    }
} */

var DwExpressionOperator;
(function (DwExpressionOperator) {
    DwExpressionOperator["and"] = "AND";
    DwExpressionOperator["or"] = "OR";
})(DwExpressionOperator || (DwExpressionOperator = {}));
class DwExpressionOperatorList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwExpressionOperator[propertyName];
    }
    getKeys() {
        return Object.keys(DwExpressionOperator);
    }
    getEnumDisplay(operator) {
        switch (operator) {
            case DwExpressionOperator.and:
                return "And";
            case DwExpressionOperator.or:
                return "Or";
        }
    }
}

class DwFormFieldConfig {
}

class DwLookupFieldConfig {
}

const moment$4 = moment_;
class DwExpressionComparersService {
    constructor(dwContextService, dwMetaDataService) {
        this.dwContextService = dwContextService;
        this.dwMetaDataService = dwMetaDataService;
        this.allCompareTypes = [];
        this.ALLOW_GREATER_LESS_THAN_ON_KEYS = true;
        this.allCompareTypes = new DwExpressionCompareTypeList().getEnumList();
    }
    getCompareTypesFromExprRef(item, exprRef, queryMeaning) {
        return this.getAttribute(item, exprRef, queryMeaning)
            .pipe(map(attr => {
            return this.getComparerTypes(attr);
        }));
    }
    getComparerTypes(attr) {
        const compareTypes = [];
        if (!attr) {
            return compareTypes;
        }
        if (attr.compareTypes) {
            for (let value of attr.compareTypes) {
                this.addCompareType(compareTypes, value);
            }
            return compareTypes;
        }
        return this.getAttributeCompareTypes(attr);
    }
    getAttributeCompareTypes(attr) {
        var _a;
        const compareTypes = [];
        if (!attr) {
            return compareTypes;
        }
        switch (attr.AttributeType) {
            case DwAttributeType.Text:
            case DwAttributeType.Memo:
            case DwAttributeType.HTML:
                this.addTextCompareTypes(compareTypes);
                break;
            case DwAttributeType.Integer:
            case DwAttributeType.LargeInteger:
            case DwAttributeType.Percentage:
            case DwAttributeType.Decimal:
            case DwAttributeType.Money:
                this.addNumberCompareTypes(compareTypes, attr.Attribute.IsKey);
                break;
            case DwAttributeType.Date:
                this.addDateCompareTypes(compareTypes);
                break;
            case DwAttributeType.DateTime:
                this.addDateTimeCompareTypes(compareTypes);
                break;
            case DwAttributeType.YesNo:
                this.addYesNoCompareTypes(compareTypes);
                break;
            default:
                this.addOtherCompareTypes(compareTypes);
                break;
        }
        if ((_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsLookup) {
            compareTypes.length = 0;
            this.addLookupCompareTypes(compareTypes);
        }
        // if (attr.Attribute.ReferenceMetaDataItemId == )
        return compareTypes;
    }
    compareNeedsValue(compareType) {
        if (!compareType) {
            return false;
        }
        switch (compareType) {
            case DwExpressionCompareType.isBlank:
            case DwExpressionCompareType.isNotBlank:
            case DwExpressionCompareType.isTrue:
            case DwExpressionCompareType.isFalse:
                return false;
        }
        return true;
    }
    buildValueFieldDef(exprAttr, comparerType) {
        let valueFieldDef = new DwFormFieldConfig();
        const attr = exprAttr.Attribute;
        valueFieldDef.controlType = attr.MetaDataControlTypeId;
        valueFieldDef.attr = exprAttr.Attribute;
        valueFieldDef.lookupConfig = new DwLookupFieldConfig();
        valueFieldDef.lookupConfig.alternateValueAttrName = exprAttr.alternateLookupValueAttrName;
        this.adjustDateTimeComparerFieldDef(valueFieldDef, exprAttr, comparerType);
        return valueFieldDef;
    }
    adjustDateTimeComparerFieldDef(valueFieldDef, exprAttr, compareType) {
        switch (compareType) {
            case DwExpressionCompareType.greaterThanDays:
            case DwExpressionCompareType.greaterThanEqualDays:
            case DwExpressionCompareType.lessThanDays:
            case DwExpressionCompareType.lessThanEqualDays:
                this.setupDateTimeFieldDef(valueFieldDef, 'Today plus', 'Days');
                break;
            case DwExpressionCompareType.greaterThanHours:
            case DwExpressionCompareType.greaterThanEqualHours:
            case DwExpressionCompareType.lessThanHours:
            case DwExpressionCompareType.lessThanEqualHours:
                this.setupDateTimeFieldDef(valueFieldDef, 'Now plus', 'Hours');
                return;
            case DwExpressionCompareType.inList:
            case DwExpressionCompareType.notInList:
                this.setupListCompareType(valueFieldDef);
                return;
        }
    }
    setupListCompareType(valueFieldDef) {
        valueFieldDef.controlType = DwControlType.MultiSelect;
    }
    setupDateTimeFieldDef(valueFieldDef, prefix, suffix) {
        valueFieldDef.controlType = DwControlType.NumericTextBox;
        const inputOptions = {
            allowNegative: true,
            excludeLocalNumericFormatting: true,
            prefix: prefix,
            suffix: suffix
        };
        valueFieldDef.controlOptions = inputOptions;
    }
    getAttribute(item, exprRef, queryMeaning) {
        if (exprRef.referenceType == DwExpressionReferenceType.item && item) {
            return this.getItemAttribute(item, exprRef.attrName, queryMeaning);
        }
        if (exprRef.referenceType == DwExpressionReferenceType.context) {
            if (!exprRef.contextName) {
                return of(null);
            }
            return this.dwContextService.getContextMetaData(exprRef.contextName)
                .pipe(map(result => {
                if (!result) {
                    console.error(`Context ${exprRef.contextName} had no result!`);
                    return null;
                }
                const attr = result.attributes.find(attr => attr.AttributeName == exprRef.attrName);
                return attr;
            }));
        }
        return of(null);
    }
    getItemAttribute(item, attrName, queryMeaning) {
        return this.dwMetaDataService.getSavedQueryMetaData(item, null, queryMeaning)
            .pipe(map(itemMetaData => {
            const attr = findWhere(itemMetaData === null || itemMetaData === void 0 ? void 0 : itemMetaData.Attributes, { AttributeName: attrName });
            return attr;
        }));
    }
    addTextCompareTypes(compareTypes) {
        this.addCompareType(compareTypes, DwExpressionCompareType.equal);
        this.addCompareType(compareTypes, DwExpressionCompareType.notEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.startsWith);
        this.addCompareType(compareTypes, DwExpressionCompareType.endsWith);
        this.addCompareType(compareTypes, DwExpressionCompareType.contains);
        this.addCompareType(compareTypes, DwExpressionCompareType.notContains);
        this.addCompareType(compareTypes, DwExpressionCompareType.isBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.isNotBlank);
    }
    addNumberCompareTypes(compareTypes, isKey) {
        this.addCompareType(compareTypes, DwExpressionCompareType.equal);
        this.addCompareType(compareTypes, DwExpressionCompareType.notEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.isBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.isNotBlank);
        if (!isKey || this.ALLOW_GREATER_LESS_THAN_ON_KEYS) {
            this.addCompareType(compareTypes, DwExpressionCompareType.greaterThan);
            this.addCompareType(compareTypes, DwExpressionCompareType.greaterThanEqual);
            this.addCompareType(compareTypes, DwExpressionCompareType.lessThan);
            this.addCompareType(compareTypes, DwExpressionCompareType.lessThanEqual);
        }
    }
    addDateCompareTypes(compareTypes) {
        this.addCompareType(compareTypes, DwExpressionCompareType.equal);
        this.addCompareType(compareTypes, DwExpressionCompareType.notEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.greaterThan);
        this.addCompareType(compareTypes, DwExpressionCompareType.greaterThanEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.lessThan);
        this.addCompareType(compareTypes, DwExpressionCompareType.lessThanEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.isBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.isNotBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.greaterThanDays);
        this.addCompareType(compareTypes, DwExpressionCompareType.greaterThanEqualDays);
        this.addCompareType(compareTypes, DwExpressionCompareType.lessThanDays);
        this.addCompareType(compareTypes, DwExpressionCompareType.lessThanEqualDays);
    }
    addDateTimeCompareTypes(compareTypes) {
        this.addDateCompareTypes(compareTypes);
        this.addCompareType(compareTypes, DwExpressionCompareType.greaterThanHours);
        this.addCompareType(compareTypes, DwExpressionCompareType.greaterThanEqualHours);
        this.addCompareType(compareTypes, DwExpressionCompareType.lessThanHours);
        this.addCompareType(compareTypes, DwExpressionCompareType.lessThanEqualHours);
    }
    addLookupCompareTypes(compareTypes) {
        this.addCompareType(compareTypes, DwExpressionCompareType.equal);
        this.addCompareType(compareTypes, DwExpressionCompareType.notEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.isBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.isNotBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.inList);
        this.addCompareType(compareTypes, DwExpressionCompareType.notInList);
    }
    addYesNoCompareTypes(compareTypes) {
        this.addCompareType(compareTypes, DwExpressionCompareType.isTrue);
        this.addCompareType(compareTypes, DwExpressionCompareType.isFalse);
        this.addCompareType(compareTypes, DwExpressionCompareType.equal);
        this.addCompareType(compareTypes, DwExpressionCompareType.notEqual);
        this.addCompareType(compareTypes, DwExpressionCompareType.isBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.isNotBlank);
    }
    addOtherCompareTypes(compareTypes) {
        this.addCompareType(compareTypes, DwExpressionCompareType.isBlank);
        this.addCompareType(compareTypes, DwExpressionCompareType.isNotBlank);
    }
    addCompareType(compareTypes, compareType) {
        let compareItem = find(this.allCompareTypes, (item) => item.value == compareType);
        compareTypes.push(compareItem);
    }
    convertToString(value) {
        if (value == undefined || value == null) {
            return '';
        }
        return String(value);
    }
    convertToFloat(value) {
        if (value == undefined || value == null) {
            return null;
        }
        return parseFloat(value);
    }
    compareValues(compareType, value1, value2, skipDataCompares = false) {
        const strValue1 = this.convertToString(value1);
        const strValue2 = this.convertToString(value2);
        const numValue1 = this.convertToFloat(value1);
        const numValue2 = this.convertToFloat(value2);
        if (!skipDataCompares && this.attemptDateTimeCompare(compareType, strValue1, strValue2)) {
            return this.compareDateValues(compareType, value1, value2);
        }
        let daysCompareType;
        let hoursCompareType;
        switch (compareType) {
            case DwExpressionCompareType.equal:
                return areEqual(strValue1, strValue2);
            case DwExpressionCompareType.notEqual:
                return !areEqual(strValue1, strValue2);
            case DwExpressionCompareType.greaterThan:
                return numValue1 > numValue2;
            case DwExpressionCompareType.greaterThanEqual:
                return numValue1 >= numValue2;
            case DwExpressionCompareType.lessThan:
                return numValue1 < numValue2;
            case DwExpressionCompareType.lessThanEqual:
                return numValue1 <= numValue2;
            case DwExpressionCompareType.isBlank:
                if (isUndefined(value1) || isNull(value1) || (value1 === ''))
                    return true;
                else
                    return false;
            case DwExpressionCompareType.isNotBlank:
                if (isUndefined(value1) || isNull(value1) || (value1 === ''))
                    return false;
                else
                    return true;
            case DwExpressionCompareType.isTrue:
                return value1;
            case DwExpressionCompareType.isFalse:
                return !value1;
            case DwExpressionCompareType.contains:
            case DwExpressionCompareType.notContains:
                // move to a method so we can handle arrays properly
                return this.handleContainsCompare(compareType, value1, value2, strValue1, strValue2);
            case DwExpressionCompareType.startsWith:
                if (strValue1 && strValue2) {
                    return strValue1.indexOf(strValue2) == 0;
                }
                else {
                    return false;
                }
            case DwExpressionCompareType.endsWith:
                if (strValue1 && strValue2) {
                    return strValue1.endsWith(strValue2);
                }
                else {
                    return false;
                }
            case DwExpressionCompareType.inList:
            case DwExpressionCompareType.notInList:
                return this.handleListCompare(compareType, value1, value2);
            case DwExpressionCompareType.greaterThanDays:
                daysCompareType = DwExpressionCompareType.greaterThan;
                break;
            case DwExpressionCompareType.greaterThanEqualDays:
                daysCompareType = DwExpressionCompareType.greaterThanEqual;
                break;
            case DwExpressionCompareType.lessThanDays:
                daysCompareType = DwExpressionCompareType.lessThan;
                break;
            case DwExpressionCompareType.lessThanEqualDays:
                daysCompareType = DwExpressionCompareType.lessThanEqual;
                break;
            case DwExpressionCompareType.greaterThanHours:
                hoursCompareType = DwExpressionCompareType.greaterThan;
                break;
            case DwExpressionCompareType.greaterThanEqualHours:
                hoursCompareType = DwExpressionCompareType.greaterThanEqual;
                break;
            case DwExpressionCompareType.lessThanHours:
                hoursCompareType = DwExpressionCompareType.lessThan;
                break;
            case DwExpressionCompareType.lessThanEqualHours:
                hoursCompareType = DwExpressionCompareType.lessThanEqual;
                break;
        }
        if (daysCompareType) {
            return this.compareDays(strValue1, numValue2, daysCompareType);
        }
        if (hoursCompareType) {
            return this.compareHours(strValue1, numValue2, hoursCompareType);
        }
        return false;
    }
    attemptDateTimeCompare(compareType, strValue1, strValue2) {
        if (!this.isPossibleDate(strValue1) || !this.isPossibleDate(strValue2)) {
            return false;
        }
        switch (compareType) {
            case DwExpressionCompareType.equal:
            case DwExpressionCompareType.notEqual:
            case DwExpressionCompareType.greaterThan:
            case DwExpressionCompareType.greaterThanEqual:
            case DwExpressionCompareType.lessThan:
            case DwExpressionCompareType.lessThanEqual:
                return true;
        }
        return false;
    }
    isPossibleDate(strValue) {
        if ((strValue === null || strValue === void 0 ? void 0 : strValue.indexOf) && strValue.indexOf('-') >= 0) {
            return true;
        }
        if ((strValue === null || strValue === void 0 ? void 0 : strValue.indexOf) && strValue.indexOf('/') >= 0) {
            return true;
        }
        return false;
    }
    compareDateValues(compareType, value1, value2) {
        let dateTimeValue1 = null;
        let dateTimeValue2 = null;
        try {
            dateTimeValue1 = getMomentValue(value1, true, true);
            dateTimeValue2 = getMomentValue(value2, true, true);
            if ((dateTimeValue1 === null || dateTimeValue1 === void 0 ? void 0 : dateTimeValue1.isValid) && (dateTimeValue2 === null || dateTimeValue2 === void 0 ? void 0 : dateTimeValue2.isValid)) {
                switch (compareType) {
                    case DwExpressionCompareType.equal:
                        return dateTimeValue1.isSame(dateTimeValue2);
                    case DwExpressionCompareType.notEqual:
                        return !dateTimeValue1.isSame(dateTimeValue2);
                    case DwExpressionCompareType.greaterThan:
                        return dateTimeValue1.isAfter(dateTimeValue2);
                    case DwExpressionCompareType.greaterThanEqual:
                        return dateTimeValue1.isSameOrAfter(dateTimeValue2);
                    case DwExpressionCompareType.lessThan:
                        return dateTimeValue1.isBefore(dateTimeValue2);
                    case DwExpressionCompareType.lessThanEqual:
                        return dateTimeValue1.isSameOrBefore(dateTimeValue2);
                }
            }
        }
        catch (e) {
        }
        // If any other compare, then we use the original logic
        return this.compareValues(compareType, value1, value2, true);
    }
    handleContainsCompare(compareType, value1, value2, strValue1, strValue2) {
        const returnValue = compareType == DwExpressionCompareType.contains ? true : false;
        if (Array.isArray(value1)) {
            const found = value1.find(v1 => v1 == value2);
            if (found) {
                return returnValue;
            }
        }
        else {
            if (strValue1 && strValue2) {
                if (strValue1.indexOf(strValue2) >= 0) {
                    return returnValue;
                }
            }
        }
        return !returnValue;
    }
    handleListCompare(compareType, value1, value2) {
        const returnValue = compareType == DwExpressionCompareType.inList ? true : false;
        if (!value2) {
            return false;
        }
        const valueList = value2.toString().split(',');
        for (const value of valueList) {
            if (Array.isArray(value1)) {
                if (value1.find(v1 => v1 == value)) {
                    return returnValue;
                }
            }
            else {
                if (value == value1) {
                    return returnValue;
                }
            }
        }
        return !returnValue;
    }
    getValueDescriptionByCompareType(value, comparerType) {
        const result = {
            handled: false,
            result: null,
        };
        const intValue = parseInt(value);
        switch (comparerType) {
            case DwExpressionCompareType.greaterThanDays:
            case DwExpressionCompareType.greaterThanEqualDays:
            case DwExpressionCompareType.lessThanDays:
            case DwExpressionCompareType.lessThanEqualDays:
                result.handled = true;
                if (intValue >= 0) {
                    result.result = `Today plus ${value} days`;
                }
                else {
                    result.result = `Today minus ${-value} days`;
                }
                return result;
            case DwExpressionCompareType.greaterThanHours:
            case DwExpressionCompareType.greaterThanEqualHours:
            case DwExpressionCompareType.lessThanHours:
            case DwExpressionCompareType.lessThanEqualHours:
                result.handled = true;
                if (intValue >= 0) {
                    result.result = `Now plus ${value} hours`;
                }
                else {
                    result.result = `Now minus ${-value} hours`;
                }
                return result;
        }
        return result;
    }
    compareDays(dateString, compareValue, compareType) {
        if (!dateString) {
            return false;
        }
        const referenceDate = getMomentValue(dateString, false, true);
        if (!referenceDate) {
            return false;
        }
        const daysDiff = referenceDate.diff(moment$4.utc(), 'days');
        return this.compareValues(compareType, daysDiff, compareValue);
    }
    compareHours(dateString, compareValue, compareType) {
        if (!dateString) {
            return false;
        }
        const referenceDate = getMomentValue(dateString, true, true);
        if (!referenceDate) {
            return false;
        }
        const hoursDiff = referenceDate.diff(moment$4.utc(), 'hours');
        return this.compareValues(compareType, hoursDiff, compareValue);
    }
}
DwExpressionComparersService.ɵfac = function DwExpressionComparersService_Factory(t) { return new (t || DwExpressionComparersService)(ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwMetaDataServiceToken)); };
DwExpressionComparersService.ɵprov = ɵɵdefineInjectable({ factory: function DwExpressionComparersService_Factory() { return new DwExpressionComparersService(ɵɵinject(DwContextService), ɵɵinject(DwMetaDataServiceToken)); }, token: DwExpressionComparersService, providedIn: "root" });
DwExpressionComparersService.ctorParameters = () => [
    { type: DwContextService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

class DwExpressionService {
    constructor(dwLoggingService, dwExpressionComparersService) {
        this.dwLoggingService = dwLoggingService;
        this.dwExpressionComparersService = dwExpressionComparersService;
        this.enabledLogging = false;
        this.FORM_INPUT_DELAY = 5;
        this.compareTypeList = new DwExpressionCompareTypeList();
        this.operatorList = new DwExpressionOperatorList();
    }
    /** One place to add debug logic to look for a specific expression */
    logExprDesc(exprDesc) {
        return true;
        // return ((exprDesc.indexOf('edit') >= 0));
        //return ((exprDesc.indexOf('edit') >= 0) && (exprDesc.indexOf('status') >= 0));
    }
    evaluateExpressionAsObservable(exprGroupItem, formGroup, context) {
        let subject = new BehaviorSubject(false);
        // if no expression, then ways return truee
        if (this.isEmptyExpressionGroupItem(exprGroupItem)) {
            subject.next(true);
            return subject;
        }
        const exprDesc = this.buildExpressionGroupItemDesc(exprGroupItem);
        if (this.enabledLogging) {
            //console.log(`dwExpressionService - setup watch ${exprDesc}`);
        }
        // Build a watch expression that gets executed any time one of the underlying observables change
        this.buildExpressionWatch(exprGroupItem, formGroup, context)
            .pipe(distinctUntilChanged()) // Only return when the return value changed
            .subscribe(dependecyResults => {
            let exprResult = this.evaluateExpressionGroupItemWithResolvedData(exprGroupItem, dependecyResults.data, dependecyResults.context);
            if (this.enabledLogging) {
                if (this.logExprDesc(exprDesc)) {
                    const dependencyResultsDesc = JSON.stringify(dependecyResults);
                    const logData = {
                        result: exprResult,
                        exprDesc: exprDesc,
                        dependencies: dependencyResultsDesc,
                        data: formGroup.getRawValue()
                    };
                    //console.log(`dwExpressionService - evaluate result ${exprDesc} ${exprResult} ${dependencyResultsDesc}`);
                    console.log(`dwExpressionService - evaluate result`, logData);
                }
            }
            if (subject.value != exprResult) {
                subject.next(exprResult);
            }
            return exprResult;
        });
        return subject;
    }
    evaluateExpressionReference(exprReference, formGroup, context) {
        const dependencies = this.getExpressionReferenceDependencies(exprReference);
        const dependecyResults = this.getDependcyResults(dependencies, formGroup, context);
        let result = this.evaluateExpressionReferenceWithResolvedData(exprReference, dependecyResults.data, dependecyResults.context);
        return result;
    }
    evaluateExpressionReferenceAsObservable(exprReference, formGroup, context) {
        const dependencies = this.getExpressionReferenceDependencies(exprReference);
        const initialValue = this.evaluateExpressionReference(exprReference, formGroup, context);
        let subject = new BehaviorSubject(initialValue);
        // Build a watch expression that gets executed any time one of the underlying observables change
        this.buildExpressionWatch(exprReference, formGroup, context)
            .pipe(distinctUntilChanged()) // Only return when the return value changed
            .subscribe(dependecyResults => {
            let exprResult = this.evaluateExpressionReferenceWithResolvedData(exprReference, dependecyResults.data, dependecyResults.context);
            subject.next(exprResult);
            return exprResult;
        });
        return subject;
    }
    buildExpressionWatch(exprGroupItem, formGroup, context) {
        let dependencies;
        let exprDesc = '';
        if (isExpressionReference(exprGroupItem)) {
            dependencies = this.getExpressionReferenceDependencies(exprGroupItem);
        }
        else {
            dependencies = this.getExpressionGroupItemDependencies(exprGroupItem);
            if (this.enabledLogging) {
                exprDesc = this.buildExpressionGroupItemDesc(exprGroupItem);
                if (this.logExprDesc(exprDesc)) {
                    // console.log(`Build Expression Watch - Setup ${exprDesc}`);
                }
            }
        }
        let obsList = [];
        for (let dependancy of dependencies) {
            obsList.push(this.buildDepdencyObservable(dependancy, formGroup, context));
        }
        const combined = combineLatest(obsList)
            .pipe(map(values => {
            if (this.logExprDesc(exprDesc)) {
                //console.log(`Build Expression Watch - Process Dependency Result ${exprDesc}`);
            }
            const results = this.processDependencyResults(values, dependencies);
            return results;
        }));
        return combined;
    }
    processDependencyResults(values, dependencies) {
        var dependencyResult = {};
        let index = 0;
        for (let dependancy of dependencies) {
            let value = values[index];
            this.processDependencyResult(value, dependancy, dependencyResult);
            index++;
        }
        return dependencyResult;
    }
    processDependencyResult(value, dependancy, dependencyResult) {
        if (dependancy.referenceType == DwExpressionReferenceType.item) {
            if (!dependencyResult.data) {
                dependencyResult.data = {};
            }
            dependencyResult.data[dependancy.attrName] = value;
        }
        if (dependancy.referenceType == DwExpressionReferenceType.context) {
            if (!dependencyResult.context) {
                dependencyResult.context = {};
            }
            if (!dependencyResult.context[dependancy.contextName]) {
                dependencyResult.context[dependancy.contextName] = {};
            }
            if (value) {
                dependencyResult.context[dependancy.contextName][dependancy.attrName] = value[dependancy.attrName];
            }
        }
    }
    getAttrValue(attrName, formGroup, context) {
        var _a;
        const data = ((_a = context === null || context === void 0 ? void 0 : context.data) === null || _a === void 0 ? void 0 : _a.value) || {};
        const formData = (formGroup === null || formGroup === void 0 ? void 0 : formGroup.getRawValue()) || {};
        // Fixed issue with not triggering a change when a field was cleared since it would fall back to the previously set value on form data
        //   Solution:  if the formData has the property, then use that data, otherwise default to the context data
        if (formData === null || formData === void 0 ? void 0 : formData.hasOwnProperty(attrName)) {
            return formData[attrName];
        }
        return data[attrName];
    }
    buildDepdencyObservable(dependancy, formGroup, context) {
        if (dependancy.referenceType == DwExpressionReferenceType.item) {
            if (formGroup) {
                if (dependancy.attrName) {
                    // Refactor - Changing to wach formGroup value change
                    const initialValue = this.getAttrValue(dependancy.attrName, formGroup, context);
                    let behaviorSubject = new BehaviorSubject(initialValue);
                    let controlObservable = formGroup.valueChanges.pipe(debounceTime(this.FORM_INPUT_DELAY), map(value => {
                        return this.getAttrValue(dependancy.attrName, formGroup, context);
                    }), distinctUntilChanged());
                    return merge(behaviorSubject.asObservable(), controlObservable);
                }
            }
        }
        if (dependancy.referenceType == DwExpressionReferenceType.context) {
            if (context) {
                var contextObservable = context[dependancy.contextName];
                if (contextObservable) {
                    return contextObservable;
                }
            }
        }
        return of(null);
    }
    getDependcyResults(dependencies, formGroup, context) {
        const values = [];
        for (const dependency of dependencies) {
            values.push(this.getDepedencyValue(dependency, formGroup, context));
        }
        return this.processDependencyResults(values, dependencies);
    }
    getDepedencyValue(dependency, formGroup, context) {
        switch (dependency.referenceType) {
            case DwExpressionReferenceType.value:
                return null;
            case DwExpressionReferenceType.context:
                context = context || {};
                let contextItem = context[dependency.contextName];
                if (!contextItem) {
                    this.dwLoggingService.logWarning(`Context ${dependency.contextName} has not been included.  A blank context will be used`);
                    contextItem = new BehaviorSubject({});
                }
                // Changed to use .value of 4/4/2023 (This was causing the initial eval to be incorrect and caused screen flicker)
                return contextItem.value;
            case DwExpressionReferenceType.item:
                return (formGroup.getRawValue() || {})[dependency.attrName];
        }
    }
    isEmptyExpressionGroupItem(exprGroupItem) {
        let evalResult;
        if (!exprGroupItem) {
            return true;
        }
        if ('expressions' in exprGroupItem) {
            if (!exprGroupItem.expressions || exprGroupItem.expressions.length == 0) {
                return true;
            }
        }
        else {
            if (exprGroupItem.reference1 == null && exprGroupItem.reference2 == null) {
                return true;
            }
        }
        return false;
    }
    /**
     * Gets all attributes that are used in equal comparisions within the first level of the expression (nested and/ors will not be included)
     * @param exprGroupItem
     * @returns Object with attribute properties representing the equal value
     */
    getExpressionValues(exprGroupItem, compareTypesFunc) {
        var _a, _b;
        const values = {};
        if ('expressions' in exprGroupItem) {
            for (const expr of exprGroupItem.expressions) {
                if (!('expressions' in expr)) {
                    if (((_a = expr.reference1) === null || _a === void 0 ? void 0 : _a.referenceType) == DwExpressionReferenceType.item &&
                        ((_b = expr.reference2) === null || _b === void 0 ? void 0 : _b.referenceType) == DwExpressionReferenceType.value) {
                        if (compareTypesFunc(expr.compareType)) {
                            values[expr.reference1.attrName] = expr.reference2.value;
                        }
                    }
                }
            }
        }
        return values;
    }
    isEmpyExpressionReference(exprRef) {
        if (!exprRef) {
            return true;
        }
        switch (exprRef.referenceType) {
            case DwExpressionReferenceType.value:
                return (exprRef.value !== false && !exprRef.value);
            case DwExpressionReferenceType.item:
                return !exprRef.attrName;
            case DwExpressionReferenceType.context:
                return !exprRef.contextName || !exprRef.attrName;
        }
        return true;
    }
    buildExpressionGroupItemDesc(exprGroupItem) {
        let evalResult;
        if (this.isEmptyExpressionGroupItem(exprGroupItem)) {
            return "Empty";
        }
        if ('expressions' in exprGroupItem) {
            // Expression Group
            return this.buildExpressionGroupDesc(exprGroupItem);
        }
        else {
            // Expression
            return this.buildExpressionDesc(exprGroupItem);
        }
    }
    buildExpressionDesc(expr) {
        let ref1Desc = this.buildExprReferenceDesc(expr.reference1);
        let ref2Desc = this.buildExprReferenceDesc(expr.reference2);
        let compareType = this.compareTypeList.getEnumDisplay(expr.compareType);
        return `${ref1Desc} ${compareType} ${ref2Desc}`;
    }
    buildExpressionGroupDesc(exprGroup) {
        let expressionDescArray = [];
        for (let expr of exprGroup.expressions) {
            expressionDescArray.push('(' + this.buildExpressionGroupItemDesc(expr) + ')');
        }
        return expressionDescArray.join(` ${exprGroup.operator} `);
    }
    buildExprReferenceDesc(exprRef) {
        switch (exprRef.referenceType) {
            case DwExpressionReferenceType.item:
                return `item.${exprRef.attrName}`;
            case DwExpressionReferenceType.context:
                return `${exprRef.contextName}.${exprRef.attrName}`;
            case DwExpressionReferenceType.value:
                if (exprRef.displayValue) {
                    return exprRef.displayValue;
                }
                return exprRef.value;
        }
    }
    evaluateExpressionGroupItem(exprGroupItem, formGroup, context) {
        let dependencies;
        if (isExpressionReference(exprGroupItem)) {
            dependencies = this.getExpressionReferenceDependencies(exprGroupItem);
        }
        else {
            dependencies = this.getExpressionGroupItemDependencies(exprGroupItem);
        }
        var dependencyResults = this.getDependcyResults(dependencies, formGroup, context);
        let result = this.evaluateExpressionGroupItemWithResolvedData(exprGroupItem, dependencyResults.data, dependencyResults.context);
        return result;
    }
    evaluateExpressionGroupItemWithResolvedData(exprGroupItem, resolvedData, resolvedContext) {
        let evalResult;
        if (this.isEmptyExpressionGroupItem(exprGroupItem)) {
            return true;
        }
        if ('expressions' in exprGroupItem) {
            // Expression Group
            evalResult = this.evaulateExpressionGroup(exprGroupItem, resolvedData, resolvedContext);
        }
        else {
            // Expression
            evalResult = this.evaulateExpression(exprGroupItem, resolvedData, resolvedContext);
        }
        return evalResult;
    }
    evaulateExpression(expr, resolvedData, resolvedContext) {
        const value1 = this.evaluateExpressionReferenceWithResolvedData(expr.reference1, resolvedData, resolvedContext);
        const value2 = this.evaluateExpressionReferenceWithResolvedData(expr.reference2, resolvedData, resolvedContext);
        const result = this.dwExpressionComparersService.compareValues(expr.compareType, value1, value2);
        // //console.log(`evaluateExpression Value 1: ${value1} Value 2: ${value2}  Compare: ${expr.compareType}   Result: ${result}`, expr);
        return result;
    }
    evaulateExpressionGroup(exprGroup, resolvedData, resolvedContext) {
        for (let expr of exprGroup.expressions) {
            let evalResult = this.evaluateExpressionGroupItemWithResolvedData(expr, resolvedData, resolvedContext);
            // For OR operators, the first true result means the entire expression is true
            if (evalResult && exprGroup.operator == DwExpressionOperator.or)
                return true;
            // For OR operators, the first true result means the entire expression is true
            if (!evalResult && exprGroup.operator == DwExpressionOperator.and)
                return false;
        }
        let finalResult = exprGroup.operator == DwExpressionOperator.or ? false : true;
        return finalResult;
    }
    /*  private compareValues(compareType: DwExpressionCompareType, value1: any, value2: any): boolean {
         const strValue1: string = value1 ? String(value1) : null;
         const strValue2: string = value2 ? String(value2) : null;
         const numValue1: number = value1 ? parseFloat(value1) : null;
         const numValue2: number = value2 ? parseFloat(value2) : null;
 
         switch (compareType) {
             case DwExpressionCompareType.equal:
                 return areEqual(strValue1, strValue2);
             case DwExpressionCompareType.notEqual:
                 return !areEqual(strValue1, strValue2);
 
             case DwExpressionCompareType.greaterThan:
                 return numValue1 > numValue2;
             case DwExpressionCompareType.greaterThanEqual:
                 return numValue1 >= numValue2;
 
             case DwExpressionCompareType.lessThan:
                 return numValue1 < numValue2;
             case DwExpressionCompareType.lessThanEqual:
                 return numValue1 <= numValue2;
 
             case DwExpressionCompareType.isBlank:
                 if (_.isUndefined(value1) || _.isNull(value1) || (value1 === ''))
                     return true;
                 else
                     return false;
             case DwExpressionCompareType.isNotBlank:
                 if (_.isUndefined(value1) || _.isNull(value1) || (value1 === ''))
                     return false;
                 else
                     return true;
 
             case DwExpressionCompareType.isTrue:
                 return value1;
             case DwExpressionCompareType.isFalse:
                 return !value1;
             case DwExpressionCompareType.contains:
                 if (strValue1 && strValue2) {
                     return strValue1.indexOf(strValue2) >= 0;
                 } else {
                     return false;
                 }
             case DwExpressionCompareType.notContains:
                 if (strValue1 && strValue2) {
                     return strValue1.indexOf(strValue2) < 0;
                 } else {
                     return true;
                 }
 
             case DwExpressionCompareType.startsWith:
                 if (strValue1 && strValue2) {
                     return strValue1.indexOf(strValue2) == 0;
                 } else {
                     return false;
                 }
         }
 
         return false;
     }
  */
    evaluateExpressionReferenceWithResolvedData(exprRef, resolvedData, resolvedContext) {
        if (!exprRef)
            return null;
        switch (exprRef.referenceType) {
            case DwExpressionReferenceType.item:
                if (!exprRef.attrName) {
                    return null;
                    //throw new Error("attrName is required for an expression of type Item");
                }
                if (!resolvedData)
                    return null;
                return resolvedData[exprRef.attrName];
            case DwExpressionReferenceType.context:
                if (!exprRef.contextName || !exprRef.attrName) {
                    return null;
                    throw new Error("resolvedContextName and attrName are required for an expression of type resolvedContext");
                }
                if (!resolvedContext || !resolvedContext[exprRef.contextName])
                    return null;
                return resolvedContext[exprRef.contextName][exprRef.attrName];
            case DwExpressionReferenceType.value:
                return exprRef.value;
        }
        return null;
    }
    getExpresionDependencies(expression) {
        const dwExpressionDependecies = [];
        this.getExpressionGroupItemDependencies(expression, dwExpressionDependecies);
        return dwExpressionDependecies;
    }
    // Returns a summarized list of all context and item dependencies (So we know what to watch for)
    getExpressionGroupItemDependencies(exprGroupItem, dwExpressionDependecies = []) {
        if ('expressions' in exprGroupItem) {
            // Expression Group
            this.getExpressionGroupDependencies(exprGroupItem, dwExpressionDependecies);
        }
        else {
            // Expression
            this.getExpressionDependencies(exprGroupItem, dwExpressionDependecies);
        }
        return dwExpressionDependecies;
    }
    getExpressionGroupDependencies(exprGroup, dwExpressionDependecies) {
        for (let expr of exprGroup.expressions) {
            this.getExpressionGroupItemDependencies(expr, dwExpressionDependecies);
        }
    }
    getExpressionDependencies(expr, dwExpressionDependecies) {
        this.addExpressionReferenceDependency(expr.reference1, dwExpressionDependecies);
        this.addExpressionReferenceDependency(expr.reference2, dwExpressionDependecies);
    }
    getExpressionReferenceDependencies(exprReference) {
        const dependencies = [];
        this.addExpressionReferenceDependency(exprReference, dependencies);
        return dependencies;
    }
    addExpressionReferenceDependency(exprRef, dwExpressionDependecies) {
        if (!exprRef) {
            return;
        }
        this.addExpressionDependency(dwExpressionDependecies, exprRef.referenceType, exprRef.contextName, exprRef.attrName);
    }
    addExpressionDependency(dwExpressionDependecies, referenceType, contextName, attrName) {
        if (referenceType == DwExpressionReferenceType.value) {
            return;
        }
        var existingDependency = find(dwExpressionDependecies, (dependancy) => {
            if (dependancy.referenceType != referenceType) {
                return false;
            }
            if (dependancy.referenceType == DwExpressionReferenceType.context) {
                return dependancy.contextName == contextName && dependancy.attrName == attrName;
            }
            if (dependancy.referenceType == DwExpressionReferenceType.item) {
                return dependancy.attrName == attrName;
            }
        });
        // If we already found this depdency, then we're done
        if (existingDependency) {
            return;
        }
        existingDependency = {
            referenceType: referenceType,
            contextName: contextName,
            attrName: attrName
        };
        dwExpressionDependecies.push(existingDependency);
    }
}
DwExpressionService.ɵfac = function DwExpressionService_Factory(t) { return new (t || DwExpressionService)(ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(DwExpressionComparersService)); };
DwExpressionService.ɵprov = ɵɵdefineInjectable({ factory: function DwExpressionService_Factory() { return new DwExpressionService(ɵɵinject(DwLoggingService), ɵɵinject(DwExpressionComparersService)); }, token: DwExpressionService, providedIn: "root" });
DwExpressionService.ctorParameters = () => [
    { type: DwLoggingService },
    { type: DwExpressionComparersService }
];

class DwRuleService {
    constructor(dwOrmDataService, dwRuleRegistry, dwExpressionService, dwCacheService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwRuleRegistry = dwRuleRegistry;
        this.dwExpressionService = dwExpressionService;
        this.dwCacheService = dwCacheService;
    }
    getRule(ruleName) {
        return this.getAllRules()
            .pipe(map(rules => {
            let rule = findWhere(rules, { ruleKey: ruleName });
            return rule;
        }));
    }
    getRules(item) {
        return this.getAllRules()
            .pipe(map(rules => {
            let itemName = item;
            let matchingRules = filter$1(rules, (rule) => {
                return !rule.itemName || rule.itemName == itemName;
            });
            return matchingRules;
        }));
    }
    getAllRules() {
        return this.getStoredRules()
            .pipe(map(storedRules => {
            var rules = [];
            for (let storedRule of storedRules) {
                let rule = storedRule.RuleJson;
                if (rule) {
                    rule.ruleKey = storedRule.RuleKey;
                    // Uses to custom field added to the RuleDefinition query
                    rule.itemName = storedRule.UniqueItemName;
                    rules.push(rule);
                }
            }
            for (let rule of this.dwRuleRegistry.getRules()) {
                rules.push(rule);
            }
            return rules;
        }));
    }
    getStoredRules() {
        var cacheInvalidationTopics = [];
        var md = new DevwareMetaDataService();
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwRuleDefinition));
        return this.dwCacheService.get("StoredRules", this.loadStoredRules(), null, cacheInvalidationTopics);
    }
    loadStoredRules() {
        var md = new DevwareMetaDataService();
        var query = md.DwRuleDefinition.CreateQuery();
        query.AddField(md.DwMetaDataItem.ItemName);
        query.AddField(md.DwMetaDataItem.UniqueItemName);
        query.getFieldSettings().IncludeRootItemFields = true;
        return this.dwOrmDataService.executeQuery(query);
    }
    evalulateRuleByKey(ruleKey, context, formGroup) {
        let rule = this.dwRuleRegistry.getRule(ruleKey);
        return this.evaluateRule(rule, context, formGroup);
    }
    evaluateRule(rule, context, formGroup) {
        if (!rule) {
            console.warn("Rule is null");
            return of(false);
        }
        if (rule.ruleFn) {
            return rule.ruleFn(context, formGroup);
        }
        if (rule.expression) {
            return this.dwExpressionService.evaluateExpressionAsObservable(rule.expression, formGroup, context);
        }
        return of(false);
    }
}
DwRuleService.ɵfac = function DwRuleService_Factory(t) { return new (t || DwRuleService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwRulesRegistry), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwCacheService)); };
DwRuleService.ɵprov = ɵɵdefineInjectable({ factory: function DwRuleService_Factory() { return new DwRuleService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwRulesRegistry), ɵɵinject(DwExpressionService), ɵɵinject(DwCacheService)); }, token: DwRuleService, providedIn: "root" });
DwRuleService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwRulesRegistry },
    { type: DwExpressionService },
    { type: DwCacheService }
];

const moment$5 = moment_;
class DwMetadataFormConfigWidgetComponent extends DwUiPanelWidgetBaseComponent {
    constructor(fb, dwEventService, dwModalService, metaDataFormService, metaDataRoutingService, dwContextService, route, uiConfigRegistry, metaDataFormConfigService, dwRulesService, dwDataVariableService, dwDesignerStateService, uiConfigService) {
        super(fb, dwDesignerStateService);
        this.dwEventService = dwEventService;
        this.dwModalService = dwModalService;
        this.metaDataFormService = metaDataFormService;
        this.metaDataRoutingService = metaDataRoutingService;
        this.dwContextService = dwContextService;
        this.route = route;
        this.uiConfigRegistry = uiConfigRegistry;
        this.metaDataFormConfigService = metaDataFormConfigService;
        this.dwRulesService = dwRulesService;
        this.dwDataVariableService = dwDataVariableService;
        this.uiConfigService = uiConfigService;
    }
    //rules: DwRule[];
    get formPreferences() {
        return this.preferences;
    }
    get formPreferencesHierarchy() {
        return this.preferencesHierarchy;
    }
    startConfigureSection(state) {
        this.configureSection(state);
    }
    ;
    ngOnInit() {
        super.ngOnInit();
        this.messageLocations = new DwFormMessageLocationList().getEnumList();
    }
    configSet() {
        super.configSet();
        this.setupConfig();
    }
    setupConfig() {
        if (this.formPreferencesHierarchy) {
            this.dataSources = this.uiConfigRegistry.getRegisteredDataSources(this.formPreferencesHierarchy.item);
        }
    }
    areSameItem(item1, item2) {
        if (!item1 || !item2) {
            return false;
        }
        const itemName1 = item1.toUpperCase();
        const itemName2 = item2.toUpperCase();
        return itemName1 === itemName2;
    }
    removeContextName(item) {
        const contextNamesFC = this.configForm.get('contextNames');
        const namesArray = contextNamesFC.value;
        if (namesArray && namesArray.length > 0) {
            const index = namesArray.indexOf(item);
            if (index >= 0) {
                namesArray.splice(index, 1);
                contextNamesFC.setValue(namesArray);
            }
        }
    }
    setFormValue() {
        this.setupDefaultContexts();
        super.setFormValue();
        if (!this.configKey || !this.preferences)
            return;
    }
    setupDefaultContexts() {
        if (!this.formPreferences) {
            return;
        }
        this.formPreferences.contextNames = this.formPreferences.contextNames || [];
        this.formPreferences.requiredContextNames = this.formPreferences.requiredContextNames || [];
        if (this.formPreferences.contextNames.indexOf(DwMdFormContextInfo.FORM_CONTEXT_NAME) < 0) {
            this.formPreferences.contextNames.push(DwMdFormContextInfo.FORM_CONTEXT_NAME);
        }
        if (this.formPreferences.requiredContextNames.indexOf(DwMdFormContextInfo.FORM_CONTEXT_NAME) < 0) {
            this.formPreferences.requiredContextNames.push(DwMdFormContextInfo.FORM_CONTEXT_NAME);
        }
    }
    createForm(fb) {
        const formGroup = this.fb.group({
            hidePrimaryKey: [null],
            loadDisplayProperties: [null],
            ignoreAttributes: [null],
            suppressUnsavedChangesMessage: [null],
            readOnly: [null],
            useLongDisplay: [null],
            contextNames: [null],
            dataSourceName: [null],
            canEditRuleKey: [null],
            canViewRuleKey: [null],
            canAddRuleKey: [null],
            messageLocation: [null],
            useValidationSummary: [null],
            buttonDefaults: this.fb.group({
                defaults: [true],
                save: [null],
                print: [null],
                cancel: [null],
                close: [null],
            })
        });
        return formGroup;
    }
    onSubmit() {
    }
    configureSection(state) {
        const formPreferencesHierarchy = deepCopy(this.formPreferencesHierarchy);
        this.metaDataFormConfigService.showSectionConfigModal(this.preferences, formPreferencesHierarchy.configKey, this.formPreferencesHierarchy.item, false, state)
            .subscribe((modalResult) => {
            if (modalResult.cancelled) {
                return;
            }
            const preferencesResult = modalResult.data.preferences;
            if (areEqual(this.preferences, preferencesResult)) {
                return;
            }
            this.preferencesValue = preferencesResult;
            // Can't update item directory
            //this.preferences = r.data.preferences;
            if (modalResult.buttonCommand == this.metaDataFormConfigService.inMemoryUpdateCommand) {
                this.preferencesChange.emit(preferencesResult);
            }
            else {
                this.preferenceChangeWithSave.emit(preferencesResult);
                if (this.preferenceChangeWithSave.observers.length == 0) {
                    this.forcePreferenceSave(formPreferencesHierarchy, preferencesResult);
                }
            }
        });
    }
    forcePreferenceSave(formPreferencesHierarchy, preferences) {
        formPreferencesHierarchy.loadedPreferences = preferences;
        // Just save the preferences
        this.uiConfigService.savePreferencesHierarchy(formPreferencesHierarchy)
            .subscribe((result) => {
        });
    }
    editMetaDataItem() {
        this.metaDataRoutingService.editMetaDataItem(this.route, this.formPreferencesHierarchy.item);
    }
}
DwMetadataFormConfigWidgetComponent.ɵfac = function DwMetadataFormConfigWidgetComponent_Factory(t) { return new (t || DwMetadataFormConfigWidgetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormConfigService), ɵngcc0.ɵɵdirectiveInject(DwRuleService), ɵngcc0.ɵɵdirectiveInject(DwDataVariableService), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService)); };
DwMetadataFormConfigWidgetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFormConfigWidgetComponent, selectors: [["dw-metadata-form-config-widget"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "formGroup", "ngSubmit"], ["header", "Basic Settings"], ["dwRow", ""], ["dwCol", "9"], ["formControlName", "readOnly"], ["formControlName", "useLongDisplay"], ["formControlName", "loadDisplayProperties"], ["formControlName", "useValidationSummary"], ["dwCol", "12"], ["formControlName", "messageLocation", 1, "form-control"], ["ngValue", "null"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "suppressUnsavedChangesMessage"], ["header", "Sections"], [1, "btn-sm", "btn-success", 3, "click"], ["header", "Data Setup"], ["formControlName", "dataSourceName", 1, "form-control"], [3, "ngValue"], ["formControlName", "contextNames", 3, "itemName", "requiredContextNames"], ["dwRow", "", 4, "ngIf"], ["type", "text", "formControlName", "ignoreAttributes"]], template: function DwMetadataFormConfigWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataFormConfigWidgetComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMetadataFormConfigWidgetComponent_div_1_Template, 68, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.preferences);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.preferences);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwContextDefMultiSelectComponent, ɵngcc3.DefaultValueAccessor]; }, encapsulation: 2 });
DwMetadataFormConfigWidgetComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwEventService },
    { type: DwModalService },
    { type: DwMetaDataFormService },
    { type: DwMetaDataRoutingService },
    { type: DwContextService },
    { type: ActivatedRoute },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataFormConfigService },
    { type: DwRuleService },
    { type: DwDataVariableService },
    { type: DwDesignerStateService },
    { type: DwUiConfigService }
];

class DwValidationResult {
}
class DwValidationResults extends DwValidationResult {
    constructor() {
        super(...arguments);
        this.childResults = [];
    }
}
function isDwValidationResults(result) {
    if (result.childResults) {
        return true;
    }
    return false;
}

function getFormControlDisplayFuncDefault(formGroup, controlName) {
    return controlName;
}

class DwValidationService {
    constructor(uiConfigRegistryService, injector) {
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.injector = injector;
        this.messageSeparator = ", ";
    }
    buildFormGroupError(formGroup, getFormControlDisplayFunc, name = "root", hierarchy = []) {
        // Use default func if it's not passed
        if (!getFormControlDisplayFunc) {
            getFormControlDisplayFunc = getFormControlDisplayFuncDefault;
        }
        if (!formGroup.invalid) {
            return null;
        }
        let result = new DwValidationResults();
        result.parentName = name;
        hierarchy.push(name);
        result.message = this.buildControlError(formGroup, name, true, this.messageSeparator);
        result.hasRootError = !!result.message;
        for (let controlKey in formGroup.controls) {
            const formControl = formGroup.controls[controlKey];
            let controlResult = this.buildAbstractControlErrors(formControl, name, controlKey, getFormControlDisplayFunc, hierarchy);
            if (controlResult)
                result.childResults.push(controlResult);
        }
        hierarchy.pop();
        return result;
    }
    buildFormArrayError(formArray, getFormControlDisplayFunc, name, hierarchy = []) {
        // Use default func if it's not passed
        if (!getFormControlDisplayFunc) {
            getFormControlDisplayFunc = getFormControlDisplayFuncDefault;
        }
        if (!formArray.invalid) {
            return null;
        }
        let result = new DwValidationResults();
        result.parentName = name;
        // Don't push this since it gets pushed as part of the form group and creates a duplicate
        //hierarchy.push(name);
        result.message = this.buildControlError(formArray, name, true, this.messageSeparator);
        for (let controlKey in formArray.controls) {
            const formControl = formArray.controls[controlKey];
            let controlResult;
            if (formControl instanceof FormGroup) {
                controlResult = this.buildFormGroupError(formControl, getFormControlDisplayFunc, name, hierarchy);
            }
            else {
                // Note: this case isn't truly supported since this should always be a FormGroup, but for custom implementations it is allowed
                controlResult = this.buildAbstractControlErrors(formControl, name, controlKey, getFormControlDisplayFunc, hierarchy);
            }
            if (controlResult)
                result.childResults.push(controlResult);
        }
        hierarchy.pop();
        return result;
    }
    buildAbstractControlErrors(formControl, parentName, controlName, getFormControlDisplayFunc, hierarchy) {
        if (!formControl.invalid) {
            return null;
        }
        if (formControl instanceof FormGroup) {
            return this.buildFormGroupError(formControl, getFormControlDisplayFunc, controlName, hierarchy);
        }
        if (formControl instanceof FormArray) {
            return this.buildFormArrayError(formControl, getFormControlDisplayFunc, controlName, hierarchy);
        }
        let result = new DwValidationResult();
        const display = getFormControlDisplayFunc(parentName, controlName, hierarchy);
        result.fieldName = controlName;
        result.message = this.buildControlError(formControl, display, true, this.messageSeparator);
        return result;
    }
    buildControlError(formControl, displayName, isSubmitted, messageSeparator, filterKey) {
        if (!formControl || !formControl.invalid) {
            return "";
        }
        const messageParts = [];
        for (let errorType in formControl.errors) {
            let error = formControl.errors[errorType];
            if (!error) {
                continue;
            }
            // Give the ability to filter by a key
            if (filterKey && error.filterKey != filterKey) {
                continue;
            }
            const validationRuleReg = this.getValidatorRegistration(errorType);
            let message;
            if (!validationRuleReg) {
                message = `Validation Rule not found for error type ${errorType}`;
            }
            else {
                const errorBuilder = this.createValidationRule(validationRuleReg);
                if (errorBuilder) {
                    message = errorBuilder.buildError(error, displayName, isSubmitted, validationRuleReg.messageTemplate);
                }
                else {
                    message = `No Error builder found for error type ${errorType}`;
                }
            }
            if (message) {
                messageParts.push(message);
            }
        }
        return messageParts.join(messageSeparator);
    }
    createValidator(keyName, config, validationContext) {
        const validationReg = this.getValidatorRegistration(keyName);
        if (!validationReg) {
            return null;
        }
        const errorBuilder = this.createValidationRule(validationReg);
        return errorBuilder.createValidator(config, validationContext);
    }
    getValidatorRegistration(errorPropertryName) {
        const validationRegs = this.getValidationRegs();
        let validationReg = validationRegs[errorPropertryName];
        // If not found by key, then we need to use the isErrorTypeMatch function on the registration
        //   this allows a single type of validation to emit multiple errors for a single object (originally added for multiple child repeaters)
        if (!validationReg) {
            for (let validationRegKey in validationRegs) {
                if (validationRegs.hasOwnProperty(validationRegKey)) {
                    const currentValidationReg = validationRegs[validationRegKey];
                    if (currentValidationReg === null || currentValidationReg === void 0 ? void 0 : currentValidationReg.isErrorTypeMatch) {
                        if (currentValidationReg.isErrorTypeMatch(errorPropertryName)) {
                            validationReg = currentValidationReg;
                        }
                    }
                }
            }
        }
        if (!validationReg) {
            console.warn(`Validator registration not found for ${errorPropertryName}`);
            return null;
        }
        return validationReg;
    }
    getValidationRegs() {
        if (!this.validationRegs) {
            this.validationRegs = this.buildValidationRegs();
        }
        return this.validationRegs;
    }
    buildValidationRegs() {
        const validationBuildersRegs = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.validationRule);
        const allValidadorRegs = {};
        for (const validationBuilderReg of validationBuildersRegs) {
            allValidadorRegs[validationBuilderReg.errorType] = validationBuilderReg;
            allValidadorRegs[validationBuilderReg.keyName] = validationBuilderReg;
            /*  let validationBuilder: DwValidationRule<any> = null;
             try {
                 validationBuilder = this.injector.get(validationBuilderReg.component) as DwValidationRule<any>;
             } catch (e) {
                 validationBuilder = new validationBuilderReg.component() as DwValidationRule<any>;
             } */
        }
        return allValidadorRegs;
    }
    createValidationRule(validationReg) {
        let validationBuilder = null;
        try {
            validationBuilder = this.injector.get(validationReg.component);
        }
        catch (e) {
            try {
                validationBuilder = new validationReg.component();
            }
            catch (e2) {
                console.warn(`Could create validation error builder for error type : ${validationReg.errorType}`, e, e2);
                return null;
            }
        }
        return validationBuilder;
    }
}
DwValidationService.ɵfac = function DwValidationService_Factory(t) { return new (t || DwValidationService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwValidationService.ɵprov = ɵɵdefineInjectable({ factory: function DwValidationService_Factory() { return new DwValidationService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(INJECTOR)); }, token: DwValidationService, providedIn: "root" });
DwValidationService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: Injector }
];

class DwDefaultFormValidator {
    validateForm(formGroup, dwValidationService) {
        // In some cases, form validation isn't triggered when the form is pristine or not-touched.  A workaround is to patch the form with its current value.
        if (formGroup.valid) {
            formGroup.patchValue(formGroup.value);
        }
        let formValidationResult = {
            isValid: !formGroup.invalid,
            errorCount: 0
        };
        if (!formValidationResult.isValid) {
            formValidationResult.displayMessage = "One or more fields are invalid. Please correct and try again.";
            formValidationResult.results = dwValidationService.buildFormGroupError(formGroup, (formGroup, controlName, hierarchy) => {
                return this.getFormControlDisplayFuncDefault(formGroup, controlName, hierarchy);
            });
            //result.errorCount = result.results.childResults.length;
            formValidationResult.errorCount = this.getTotalErrorCount(formValidationResult.results);
            if (formValidationResult.results.hasRootError) {
                formValidationResult.errorCount += 1;
            }
            const errorText = formValidationResult.errorCount == 1 ? 'error' : 'errors';
            formValidationResult.summaryHeading = `Please fix the following ${errorText}:`;
            formValidationResult.summaryBodyHtml = this.buildFieldErrorMessages(formValidationResult.results); // .childResults  as DwValidationResults[]);
        }
        return formValidationResult;
    }
    buildFieldErrorMessages(validationResults) {
        const messagesHtml = [];
        if (validationResults.hasRootError) {
            messagesHtml.push(`<li>${validationResults.message}</li>`);
        }
        // Get flattened list of error messages...
        const messages = this.getErrorMessageList(validationResults.childResults);
        for (const message of messages) {
            messagesHtml.push(`<li>${message}</li>`);
        }
        return `<ul>${messagesHtml.join('')}</ul>`;
    }
    getTotalErrorCount(validationResults) {
        let count = 0;
        for (const childResult of validationResults.childResults) {
            if (isDwValidationResults(childResult)) {
                let childCount = this.getTotalErrorCount(childResult);
                count += childCount;
            }
            else {
                count += 1;
            }
        }
        return count;
    }
    getErrorMessageList(validationResults) {
        var _a;
        let messages = [];
        for (const result of validationResults) {
            if (result.message) {
                messages.push(result.message);
            }
            if (((_a = result.childResults) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const childMessages = this.getErrorMessageList(result.childResults);
                messages = [...messages, ...childMessages];
            }
        }
        return messages;
    }
    getFormControlDisplayFuncDefault(formGroup, controlName, hierarchy) {
        return controlName;
    }
}

function stringConverter(value) {
    if (value === null || value === undefined || typeof value === 'string') {
        return value;
    }
    return value.toString();
}
function booleanConverter(value) {
    if (value === null || value === undefined || typeof value === 'boolean') {
        return value;
    }
    return value.toString() === 'true';
}
function floatConverter(value, returnNullOnNan = true) {
    if (value === null || value === undefined || typeof value === 'boolean') {
        return value;
    }
    const floatValue = parseFloat(value.toString());
    if (isNaN(floatValue) && returnNullOnNan) {
        return null;
    }
    return floatValue;
}
function intConverter(value, returnNullOnNan = true) {
    if (value === null || value === undefined || typeof value === 'boolean') {
        return value;
    }
    const intValue = parseInt(value.toString(), 10);
    if (isNaN(intValue) && returnNullOnNan) {
        return null;
    }
    return intValue;
}

function DwInputConverter(converter, afterSetFunc) {
    return (target, key) => {
        if (converter === undefined) {
            let metadata = null;
            try {
                metadata = Reflect.getMetadata('design:type', target, key);
            }
            catch (_a) { }
            if (metadata === undefined || metadata === null) {
                throw new Error('The reflection metadata could not be found.');
            }
            if (metadata.name === 'String') {
                converter = stringConverter;
            }
            else if (metadata.name === 'Boolean') {
                converter = booleanConverter;
            }
            else if (metadata.name === 'Number') {
                converter = intConverter;
            }
            else {
                throw new Error(`There is no converter for the given property type ${metadata.name} '' + metadata.name + ''.`);
            }
        }
        const definition = Object.getOwnPropertyDescriptor(target, key);
        if (definition) {
            Object.defineProperty(target, key, {
                get: definition.get,
                set: newValue => {
                    const convertedValue = converter(newValue);
                    definition.set(convertedValue);
                    // Call an optional method after value is set
                    if (afterSetFunc) {
                        const boundFunc = afterSetFunc.bind(target);
                        boundFunc(convertedValue);
                    }
                },
                enumerable: true,
                configurable: true
            });
        }
        else {
            Object.defineProperty(target, key, {
                get: function () {
                    return this['__' + key];
                },
                set: function (newValue) {
                    const convertedValue = converter(newValue);
                    this['__' + key] = convertedValue;
                    if (afterSetFunc) {
                        const boundFunc = afterSetFunc.bind(target);
                        boundFunc(convertedValue);
                    }
                    //afterSetFunc(convertedValue);
                },
                enumerable: true,
                configurable: true
            });
        }
    };
}

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const DwFormValidationServiceToken = new InjectionToken("DwFormValidationServiceToken");
class DwFormComponent {
    constructor(configService, fb, uiConfig, dwEventService, componentFactoryResolver, dwValidationService, dwLoggingUtil, formValidator) {
        this.configService = configService;
        this.fb = fb;
        this.uiConfig = uiConfig;
        this.dwEventService = dwEventService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.dwValidationService = dwValidationService;
        this.dwLoggingUtil = dwLoggingUtil;
        this.hideErrorMessage = false;
        this._showButtons = true;
        this.formReady = new EventEmitter();
        this.dataLoaded = new EventEmitter();
        this.saveStarted = new EventEmitter();
        this.saveComplete = new EventEmitter();
        this.saveFailed = new EventEmitter();
        this.cancelComplete = new EventEmitter();
        this.formInvalid = new EventEmitter();
        this.dataChanged = new EventEmitter();
        this.formValidator = new DwDefaultFormValidator();
        /**
         * Prevents the form group from being updated here, instead, it will get updated in the parent form control (DwMetaDataFormControl)
         */
        this.overrideFormDataSet = false;
        this.subscriptions = [];
        if (formValidator) {
            this.formValidator = formValidator;
        }
        // this.uiConfig = configService.coreConfig.getConfig<DwUIConfig>(DwUIConfig.configName);
    }
    get showButtons() {
        return this._showButtons;
    }
    set showButtons(value) {
        this._showButtons = convertToBool(value);
    }
    get formData() {
        return this._formData;
    }
    set formData(value) {
        this._formData = value;
    }
    setupForm() {
        this.formGroup = new DwFormGroup();
        this.formReady.emit(this.formGroup);
        if (this.subFormInstance) {
            this.subFormInstance.setupForm(this.formGroup);
        }
        this.subscriptions.push(this.formGroup.valueChanges
            .pipe(
        // Don't update the form on every keystroke, instead, wait x ms before updating
        debounceTime(50))
            .subscribe(r => {
            this.dataChanged.emit(this.formGroup.getRawValue());
        }));
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        if (changes.data && !changes.data.firstChange && changes.data.currentValue) {
            this.setupDataSource();
            this.loadData();
        }
        if (changes.keyValue && !changes.keyValue.firstChange && changes.keyValue.currentValue) {
            this.setupDataSource();
            this.loadData();
        }
    }
    ngAfterContentInit() {
        this.loadComponent();
        this.setupForm();
        this.setupDataSource();
        this.loadData();
    }
    loadComponent() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        if (!this.subFormComponent) {
            return;
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.subFormComponent);
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        viewContainerRef.clear();
        let componentRef = viewContainerRef.createComponent(componentFactory);
        this.subFormInstance = componentRef.instance;
    }
    setupDataSource() {
        if (!this.data)
            return;
        if (this.data.requestData) {
            this.dataSource = this.data;
        }
    }
    loadData(forceRefresh = false) {
        if (!this.data)
            return of(null);
        if (this.dataSource) {
            let loadOb;
            // Check if we're loading data
            if (this.keyValue) {
                if (this.keyValue == this.currentLoadedKey && !forceRefresh)
                    return of(this.formData);
                this.currentLoadedKey = this.keyValue;
                loadOb = this.dataSource.loadItem(this.keyValue);
            }
            else {
                loadOb = this.dataSource.createBlankItem(this.newItemDefaults, this.addContext);
            }
            this.subscriptions.push(loadOb.subscribe((data) => {
                this.setFormData(data);
            }));
            return loadOb;
        }
        else {
            this.setFormData(this.data);
            return of(this.data);
        }
    }
    setFormData(formData) {
        this.formData = deepCopy(formData);
        this.dataLoaded.emit(formData);
        if (!this.overrideFormDataSet) {
            this.formGroup.patchValue(formData);
        }
    }
    patchFormData(partialFormData, preventCopy = true) {
        if (!preventCopy) {
            partialFormData = deepCopy(partialFormData);
        }
        const formData = this.getFormData();
        const data = Object.assign(Object.assign({}, formData), partialFormData);
        this.setFormData(data);
    }
    getFormData() {
        if (this.dataSource) {
            this.formData = this.dataSource.updateExistingDataItem(this.formData, this.formGroup.getRawValue());
        }
        else {
            this.formData = Object.assign(this.formData, this.formGroup.getRawValue());
        }
        if (this.formData && this.formData['contextFG'] !== undefined) {
            delete this.formData['contextFG'];
        }
        return this.formData;
    }
    onSubmit() {
        this.saveData();
    }
    validateForm() {
        let formValidationResult = this.formValidator.validateForm(this.formGroup, this.dwValidationService);
        if (!formValidationResult.isValid) {
            this.dwLoggingUtil.logToConsole(`DWForm.validateForm - Failed`, formValidationResult);
            this.lastError = formValidationResult.displayMessage;
            return formValidationResult;
        }
        return formValidationResult;
    }
    saveData(requireValidation = true) {
        this.lastError = null;
        if (requireValidation) {
            const validationResult = this.validateForm();
            if (!validationResult.isValid) {
                // Event to parent form
                this.formInvalid.emit();
                return of({ validationFailed: true, validationResult: validationResult, errorMessage: validationResult.displayMessage });
            }
        }
        if (this.dataSource) {
            const formData = this.getFormData();
            this.saveStarted.emit(formData);
            let resultOb = new Subject();
            // Need a timeout so next doesn't occur before returning the object
            setTimeout(() => {
                let saveOb = this.dataSource.saveItem(formData, { recurse: true });
                saveOb.subscribe(result => {
                    //console.log('Save result', result);
                    this.setFormData(result);
                    this.formGroup.markAsPristine();
                    //console.log('Save result - after set form data', result);
                    this.saveComplete.emit(result);
                    resultOb.next({ validationFailed: false, savedFailed: false, saveResult: result });
                }, errorResponse => {
                    const errorDetails = getErrorDetails(errorResponse);
                    if (errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.message) {
                        this.lastError = errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.message;
                    }
                    this.saveFailed.emit(this.formData);
                    resultOb.next({ validationFailed: false, savedFailed: true, errorMessage: this.lastError });
                });
            });
            return resultOb;
        }
        else {
            this.saveStarted.emit(this.formData);
            this.formData = Object.assign(this.formData, this.formGroup.getRawValue());
            this.saveComplete.emit(this.formData);
            return of({ validationFailed: false, savedFailed: false, saveResult: this.formData });
        }
    }
    cancel() {
        this.cancelComplete.emit();
    }
}
DwFormComponent.ɵfac = function DwFormComponent_Factory(t) { return new (t || DwFormComponent)(ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwValidationService), ɵngcc0.ɵɵdirectiveInject(DwLoggingService), ɵngcc0.ɵɵdirectiveInject(DwFormValidationServiceToken, 8)); };
DwFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormComponent, selectors: [["dw-form"]], viewQuery: function DwFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, inputs: { hideErrorMessage: "hideErrorMessage", formValidator: "formValidator", overrideFormDataSet: "overrideFormDataSet", showButtons: "showButtons", data: "data", keyValue: "keyValue", newItemDefaults: "newItemDefaults", subFormComponent: "subFormComponent", context: "context", addContext: "addContext" }, outputs: { formReady: "formReady", dataLoaded: "dataLoaded", saveStarted: "saveStarted", saveComplete: "saveComplete", saveFailed: "saveFailed", cancelComplete: "cancelComplete", formInvalid: "formInvalid", dataChanged: "dataChanged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 6, vars: 3, consts: [["class", "alert alert-danger", 4, "ngIf"], ["autocomplete", "off", 3, "formGroup"], ["dw-component-host", ""], [4, "ngIf"], [1, "alert", "alert-danger"], [1, "btn", "btn-success", 3, "click"], [1, "btn", "btn-danger", 3, "click"]], template: function DwFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, DwFormComponent_div_1_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "form", 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵtemplate(4, DwFormComponent_ng_template_4_Template, 0, 0, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(5, DwFormComponent_dw_button_bar_5_Template, 5, 0, "dw-button-bar", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lastError && !ctx.hideErrorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showButtons);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwComponentHost, DwButtonBarComponent]; }, encapsulation: 2 });
DwFormComponent.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: FormBuilder },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwEventService },
    { type: ComponentFactoryResolver },
    { type: DwValidationService },
    { type: DwLoggingService },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DwFormValidationServiceToken,] }] }
];
DwFormComponent.propDecorators = {
    data: [{ type: Input }],
    keyValue: [{ type: Input }],
    hideErrorMessage: [{ type: Input }],
    showButtons: [{ type: Input }],
    newItemDefaults: [{ type: Input }],
    formReady: [{ type: Output }],
    dataLoaded: [{ type: Output }],
    saveStarted: [{ type: Output }],
    saveComplete: [{ type: Output }],
    saveFailed: [{ type: Output }],
    cancelComplete: [{ type: Output }],
    formInvalid: [{ type: Output }],
    dataChanged: [{ type: Output }],
    subFormComponent: [{ type: Input }],
    context: [{ type: Input }],
    addContext: [{ type: Input }],
    formValidator: [{ type: Input }],
    overrideFormDataSet: [{ type: Input }],
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }]
};
__decorate([
    DwInputConverter(booleanConverter),
    __metadata("design:type", Object)
], DwFormComponent.prototype, "hideErrorMessage", void 0);

var DwFormValidators;
(function (DwFormValidators) {
    DwFormValidators["count"] = "DwCountValidator";
    DwFormValidators["custom"] = "DwCustomValidator";
    DwFormValidators["customField"] = "DwCustomValidatorField";
    DwFormValidators["date"] = "DwDateValidator";
    DwFormValidators["email"] = "DwEmailValidator";
    DwFormValidators["min"] = "DwMinValidator";
    DwFormValidators["max"] = "DwMaxValidator";
    DwFormValidators["maxLength"] = "DwMaxLengthValidator";
    DwFormValidators["pattern"] = "DwPatternValidator";
    DwFormValidators["required"] = "DwRequiredValidator";
    DwFormValidators["url"] = "DwUrlValidator";
    DwFormValidators["requiredTrue"] = "DwRequiredTrueValidator";
})(DwFormValidators || (DwFormValidators = {}));

class DwExpressionStateService {
    constructor(dwExpressionService) {
        this.dwExpressionService = dwExpressionService;
    }
    convertToExpressionSet(items, expressionFunc, defaultResult = true, delayMs = 0) {
        const expressionSet = {
            isArray: true,
            expressions: {},
            defaultResult: defaultResult,
            delayMs: delayMs
        };
        let index = 0;
        for (let item of items) {
            expressionSet.expressions[index] = expressionFunc(item);
            index++;
        }
        return expressionSet;
    }
    convertFromExpressionSet(items, expressionResults, cloneItems = false) {
        const resultItems = [];
        let index = 0;
        for (let item of items) {
            const expressionResult = expressionResults[index];
            if (expressionResult === null || expressionResult === void 0 ? void 0 : expressionResult.result) {
                if (cloneItems) {
                    resultItems.push(deepCopy(item));
                }
                else {
                    resultItems.push(item);
                }
            }
            index++;
        }
        return resultItems;
    }
    convertToResultArray(expressionResults) {
        const results = [];
        for (let prop in expressionResults) {
            if (expressionResults.hasOwnProperty(prop)) {
                const expressionResult = expressionResults[prop];
                results[parseInt(prop)] = expressionResult.result;
            }
        }
        return results;
    }
    initExpressionSetArray(items, expressionFunc, formGroup, context, defaultResult = true, delayMs = 0) {
        const expressionSet = this.convertToExpressionSet(items, expressionFunc, defaultResult, delayMs);
        const result = this.initExpressionSet(expressionSet, formGroup, context);
        const typedResult = {
            initialResults: this.convertFromExpressionSet(items, result.initialResults),
            observable: result.observable.pipe(map(expressionResults => {
                return this.convertFromExpressionSet(items, expressionResults);
            }))
        };
        return typedResult;
    }
    initExpressionSet(expressionSet, formGroup, context) {
        const setResult = {
            initialResults: {},
            observable: null
        };
        let obs = [];
        for (let prop in expressionSet.expressions) {
            if (!expressionSet.expressions.hasOwnProperty(prop)) {
                continue;
            }
            let expression = expressionSet.expressions[prop];
            let expressionResult = {
                expressionKey: prop,
                result: expressionSet.defaultResult,
                hasExpression: !this.dwExpressionService.isEmptyExpressionGroupItem(expression)
            };
            if (expressionResult.hasExpression) {
                // Immediately evaluate the expressions for the initial result
                expressionResult.result = this.dwExpressionService.evaluateExpressionGroupItem(expression, formGroup, context);
                // Capture changes to this result
                obs.push(this.dwExpressionService.evaluateExpressionAsObservable(expression, formGroup, context)
                    .pipe(map(result => {
                    // Convert to an expression result
                    return {
                        expressionKey: expressionResult.expressionKey,
                        result: result,
                        hasExpression: true
                    };
                })));
            }
            setResult.initialResults[expressionResult.expressionKey] = expressionResult;
        }
        if (obs.length === 0) {
            setResult.observable = of(setResult.initialResults);
        }
        else {
            let ob = combineLatest(obs)
                .pipe(map(results => {
                let newResults = deepCopy(setResult.initialResults);
                for (let expressionResult of results) {
                    newResults[expressionResult.expressionKey] = expressionResult;
                }
                return newResults;
            }));
            if (expressionSet.delayMs > 0) {
                ob = ob.pipe(debounceTime(expressionSet.delayMs));
            }
            ob = ob.pipe(distinctUntilChanged());
            setResult.observable = ob;
        }
        return setResult;
    }
    executeExpressionSet(expressionSet, data, context) {
        const setResult = {
            initialResults: {},
            observable: null
        };
        let obs = [];
        for (let prop in expressionSet.expressions) {
            if (!expressionSet.expressions.hasOwnProperty(prop)) {
                continue;
            }
            let expression = expressionSet.expressions[prop];
            let expressionResult = {
                expressionKey: prop,
                result: expressionSet.defaultResult,
                hasExpression: !this.dwExpressionService.isEmptyExpressionGroupItem(expression)
            };
            if (expressionResult.hasExpression) {
                // Immediately evaluate the expressions for the initial result
                expressionResult.result = this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(expression, data, context);
            }
            setResult.initialResults[expressionResult.expressionKey] = expressionResult;
        }
        return setResult;
    }
    evaluateExpressionWithResolvedData(expression, resolvedData, resolvedContext = null) {
        return this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(expression, resolvedData, resolvedContext);
    }
    /**  Add new support for Expression References used to determine a value **/
    /**
     * Sets a group of expressions references, evaluates an initial value and returns an observable that will emit changes to the results
     * @param expressionReferenceSet
     * @param formGroup
     * @param context
     * @returns  DwExpressionReferenceSetResult which has initialResults and an observable
     */
    initExpressionReferenceSet(expressionReferenceSet, formGroup, context) {
        const setResult = {
            initialResults: {},
            observable: null
        };
        let obs = [];
        for (let prop in expressionReferenceSet.expressionReferences) {
            if (!expressionReferenceSet.expressionReferences.hasOwnProperty(prop)) {
                continue;
            }
            let expressionReference = expressionReferenceSet.expressionReferences[prop];
            let expressionResult = {
                expressionKey: prop,
                result: expressionReferenceSet.defaultResult,
                hasExpression: !this.dwExpressionService.isEmpyExpressionReference(expressionReference)
            };
            if (expressionResult.hasExpression) {
                // Immediately evaluate the expressions for the initial result
                expressionResult.result = this.dwExpressionService.evaluateExpressionReference(expressionReference, formGroup, context);
                // Capture changes to this result
                obs.push(this.dwExpressionService.evaluateExpressionReferenceAsObservable(expressionReference, formGroup, context)
                    .pipe(map(result => {
                    // Convert to an expression result
                    return {
                        expressionKey: expressionResult.expressionKey,
                        result: result,
                        hasExpression: true
                    };
                })));
            }
            setResult.initialResults[expressionResult.expressionKey] = expressionResult;
        }
        if (obs.length === 0) {
            setResult.observable = of(setResult.initialResults);
        }
        else {
            let ob = combineLatest(obs)
                .pipe(map(results => {
                let newResults = deepCopy(setResult.initialResults);
                for (let expressionResult of results) {
                    newResults[expressionResult.expressionKey] = expressionResult;
                }
                return newResults;
            }));
            if (expressionReferenceSet.delayMs > 0) {
                ob = ob.pipe(debounceTime(expressionReferenceSet.delayMs));
            }
            ob = ob.pipe(distinctUntilChanged());
            setResult.observable = ob;
        }
        return setResult;
    }
    executeExpressionReferenceSet(expressionReferenceSet, data, context) {
        const setResult = {
            initialResults: {},
            observable: null
        };
        let obs = [];
        for (let prop in expressionReferenceSet.expressionReferences) {
            if (!expressionReferenceSet.expressionReferences.hasOwnProperty(prop)) {
                continue;
            }
            let expressionReference = expressionReferenceSet.expressionReferences[prop];
            let expressionResult = {
                expressionKey: prop,
                result: expressionReferenceSet.defaultResult,
                hasExpression: !this.dwExpressionService.isEmpyExpressionReference(expressionReference)
            };
            if (expressionResult.hasExpression) {
                // Immediately evaluate the expressions for the initial result
                expressionResult.result = this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(expressionReference, data, context);
            }
            setResult.initialResults[expressionResult.expressionKey] = expressionResult;
        }
        return setResult;
    }
}
DwExpressionStateService.ɵfac = function DwExpressionStateService_Factory(t) { return new (t || DwExpressionStateService)(ɵngcc0.ɵɵinject(DwExpressionService)); };
DwExpressionStateService.ɵprov = ɵɵdefineInjectable({ factory: function DwExpressionStateService_Factory() { return new DwExpressionStateService(ɵɵinject(DwExpressionService)); }, token: DwExpressionStateService, providedIn: "root" });
DwExpressionStateService.ctorParameters = () => [
    { type: DwExpressionService }
];

class DwMetadataFormValidationBuilderService {
    constructor(
    //  private dwFormUtilService: DwMetadataFormUtilService,
    dwValidationService, dwExpressionService, dwExpressionStateService) {
        this.dwValidationService = dwValidationService;
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionStateService = dwExpressionStateService;
    }
    buildValidators(fc, fieldValidationCofig, conditionalValidationKeyPart, expressionResults, validationContext) {
        var _a;
        const result = {
            validators: [],
            validatorKeys: []
        };
        //Removed since the the control should be enabled elsewhere
        //fc.enable();
        if (!fieldValidationCofig || ((_a = fieldValidationCofig.validators) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            return result;
        }
        let index = 0;
        expressionResults = expressionResults || {};
        for (const fieldValidator of fieldValidationCofig.validators) {
            if (!this.dwExpressionService.isEmptyExpressionGroupItem(fieldValidator === null || fieldValidator === void 0 ? void 0 : fieldValidator.conditionExpressionGroup)) {
                const finalKey = `${conditionalValidationKeyPart}_${index}`;
                const exprResult = expressionResults[finalKey];
                index++;
                if (!(exprResult === null || exprResult === void 0 ? void 0 : exprResult.result)) {
                    continue;
                }
            }
            const validator = this.dwValidationService.createValidator(fieldValidator.validatorKey, fieldValidator.config, validationContext);
            if (validator) {
                result.validators.push(validator);
                result.validatorKeys.push(fieldValidator.validatorKey);
            }
        }
        return result;
    }
    buildValidationExpressionSet(expressionSet, conditionalValidationKeyPart, fieldValidationConfig) {
        const conditionalValidationItems = this.getConditionalValidation(fieldValidationConfig);
        let index = 0;
        for (let validationItem of conditionalValidationItems) {
            const finalKey = `${conditionalValidationKeyPart}_${index}`;
            expressionSet.expressions[finalKey] = validationItem.conditionExpressionGroup;
            index++;
        }
    }
    hasConditionalValidation(fieldValidationCofig) {
        return this.getConditionalValidation(fieldValidationCofig).length > 0;
    }
    getConditionalValidation(fieldValidationCofig) {
        var _a;
        const conditionalValidationItems = [];
        if (!fieldValidationCofig || ((_a = fieldValidationCofig.validators) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            return conditionalValidationItems;
        }
        for (const fieldValidator of fieldValidationCofig.validators) {
            if (!this.dwExpressionService.isEmptyExpressionGroupItem(fieldValidator.conditionExpressionGroup)) {
                conditionalValidationItems.push(fieldValidator);
            }
        }
        return conditionalValidationItems;
    }
    getDefaultFieldValidatorConfig(attr, ignoreRequiredValidation) {
        const fieldValidationConfig = {
            overrideDefaults: false,
            validators: []
        };
        if (attr.MaxLength > 0) {
            const maxLengthConfig = {
                maxLength: attr.MaxLength
            };
            fieldValidationConfig.validators.push({
                validatorKey: DwFormValidators.maxLength,
                config: maxLengthConfig
            });
        }
        if (!ignoreRequiredValidation) {
            let isRequired = this.isRequiredAttr(attr);
            if (isRequired) {
                fieldValidationConfig.validators.push({
                    validatorKey: DwFormValidators.required,
                    config: {}
                });
            }
        }
        if (attr.MetaDataControlTypeId == DwControlType.UrlTextBox) {
            fieldValidationConfig.validators.push({
                validatorKey: DwFormValidators.url,
                config: {}
            });
        }
        if (attr.AttributeName.toLowerCase().indexOf("email") >= 0 && attr.AttributeType == DwAttributeType.Text) {
            const emailValidationConfig = {
                emailValidationRegEx: null
            };
            fieldValidationConfig.validators.push({
                validatorKey: DwFormValidators.email,
                config: emailValidationConfig
            });
        }
        return fieldValidationConfig;
    }
    isRequiredAttr(attr) {
        if (attr.AlwaysRequired) {
            return true;
        }
        if (attr.AllowNull)
            return false;
        switch (attr.AttributeType) {
            case DwAttributeType.Text:
            case DwAttributeType.HTML:
            case DwAttributeType.Memo:
            case DwAttributeType.YesNo:
                return false;
        }
        return true;
    }
    initConditionalExpressionState(key, validationConfig, formGroup, context, stateUpdateCallback) {
        const state = {
            conditionalExpressionsSetup: true,
            conditionalExpressionResult: null,
            conditionalExpressionSetResult: null,
            conditionalExpressionSubscription: null,
            validationKey: key
        };
        // if (state.conditionalExpressionSubscription) {
        //     state.conditionalExpressionSubscription.unsubscribe();
        // }
        state.conditionalExpressionSetResult = this.createValidationExpressionSet(validationConfig, state.validationKey, formGroup, context);
        state.conditionalExpressionResult = state.conditionalExpressionSetResult.initialResults;
        state.conditionalExpressionSubscription = state.conditionalExpressionSetResult.observable.subscribe(result => {
            state.conditionalExpressionResult = result;
            stateUpdateCallback(state);
        });
        return state;
    }
    initMultiSectionValidation(relatedSectionResults, abstractControl, context) {
        const validationConfigItems = this.setupValidationConfigItems(relatedSectionResults);
        let conditionalExpressionState;
        if (validationConfigItems.length > 0) {
            conditionalExpressionState = this.initConditionalExpressionStateList(relatedSectionResults.currentSectionKey, validationConfigItems, abstractControl.root, context, (state) => {
                this.buildFinalValidators(abstractControl, validationConfigItems, state);
            });
        }
        this.buildFinalValidators(abstractControl, validationConfigItems, conditionalExpressionState);
        return conditionalExpressionState;
    }
    buildFinalValidators(abstractControl, validationConfigItems, conditionalExpressionState) {
        let allValidators = [];
        for (let validationConfigItem of validationConfigItems) {
            // Pass in a context which contains what property to check for the validation count
            //  This is used to suppport multiple repeaters for the same form array
            const validationContext = {
                validationKey: validationConfigItem.key
            };
            const validatorResults = this.buildValidators(abstractControl, validationConfigItem.validationConfig, validationConfigItem.key, conditionalExpressionState === null || conditionalExpressionState === void 0 ? void 0 : conditionalExpressionState.conditionalExpressionResult, validationContext);
            allValidators = [...allValidators, ...validatorResults.validators];
        }
        abstractControl.setValidators(allValidators);
        abstractControl.updateValueAndValidity();
    }
    setupValidationConfigItems(relatedSectionResults) {
        const validationConfigItems = [];
        validationConfigItems.push({
            key: relatedSectionResults.currentSectionKey,
            validationConfig: relatedSectionResults.currentSection.validationConfig
        });
        let index = 0;
        for (const sectionKey in relatedSectionResults.relatedSections) {
            if (relatedSectionResults.relatedSections.hasOwnProperty(sectionKey)) {
                const relatedChildRepeater = relatedSectionResults.relatedSections[sectionKey];
                validationConfigItems.push({
                    key: sectionKey,
                    validationConfig: relatedChildRepeater.validationConfig
                });
                index++;
            }
        }
        return validationConfigItems;
    }
    initConditionalExpressionStateList(mainKey, validationConfigs, formGroup, context, stateUpdateCallback) {
        var _a;
        const state = {
            conditionalExpressionsSetup: true,
            conditionalExpressionResult: null,
            conditionalExpressionSetResult: null,
            conditionalExpressionSubscription: null,
            validationKey: mainKey
        };
        const expressionSet = {
            defaultResult: false,
            delayMs: 100,
            isArray: false,
            expressions: {}
        };
        let hasConditionalValidation = false;
        for (let validationConfigInfo of validationConfigs) {
            if (((_a = validationConfigInfo.validationConfig) === null || _a === void 0 ? void 0 : _a.overrideDefaults) && this.hasConditionalValidation(validationConfigInfo.validationConfig)) {
                hasConditionalValidation = true;
                this.buildValidationExpressionSet(expressionSet, validationConfigInfo.key, validationConfigInfo.validationConfig);
            }
        }
        // if there isn't any conditional valiadtions, don't return a result
        if (!hasConditionalValidation) {
            return null;
        }
        state.conditionalExpressionSetResult = this.dwExpressionStateService.initExpressionSet(expressionSet, formGroup, context);
        state.conditionalExpressionResult = state.conditionalExpressionSetResult.initialResults;
        state.conditionalExpressionSubscription = state.conditionalExpressionSetResult.observable.subscribe(result => {
            state.conditionalExpressionResult = result;
            stateUpdateCallback(state);
        });
        return state;
    }
    createValidationExpressionSet(validationConfig, key, formGroup, context) {
        const expressionSet = {
            defaultResult: false,
            delayMs: 100,
            isArray: false,
            expressions: {}
        };
        // Add expressions for conditional validation
        this.buildValidationExpressionSet(expressionSet, key, validationConfig);
        const expressionSetResult = this.dwExpressionStateService.initExpressionSet(expressionSet, formGroup, context);
        return expressionSetResult;
    }
}
DwMetadataFormValidationBuilderService.ɵfac = function DwMetadataFormValidationBuilderService_Factory(t) { return new (t || DwMetadataFormValidationBuilderService)(ɵngcc0.ɵɵinject(DwValidationService), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwExpressionStateService)); };
DwMetadataFormValidationBuilderService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetadataFormValidationBuilderService_Factory() { return new DwMetadataFormValidationBuilderService(ɵɵinject(DwValidationService), ɵɵinject(DwExpressionService), ɵɵinject(DwExpressionStateService)); }, token: DwMetadataFormValidationBuilderService, providedIn: "root" });
DwMetadataFormValidationBuilderService.ctorParameters = () => [
    { type: DwValidationService },
    { type: DwExpressionService },
    { type: DwExpressionStateService }
];

var DwMetaDataSecurityResultType;
(function (DwMetaDataSecurityResultType) {
    DwMetaDataSecurityResultType["add"] = "add";
    DwMetaDataSecurityResultType["edit"] = "edit";
    DwMetaDataSecurityResultType["view"] = "view";
})(DwMetaDataSecurityResultType || (DwMetaDataSecurityResultType = {}));

class DwRuleManagerService {
    constructor(injector, dwRuleService, dwExpressionService, dwExpressionStateService, dwContextSerivce) {
        //injector.get()
        this.injector = injector;
        this.dwRuleService = dwRuleService;
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwContextSerivce = dwContextSerivce;
        this.ruleResults = {};
        this.FORM_INPUT_DELAY = 50;
        DwRuleManagerService.count++;
    }
    getResultResult2(ruleKey, formGroup, context) {
        return false;
    }
    getRuleSetResult(ruleKeys, context, formGroup) {
        const expressionSet = {
            defaultResult: false,
            isArray: false,
            expressions: {},
            delayMs: 50
        };
        return this.dwRuleService.getAllRules()
            .pipe(map(allRules => {
            for (const key of ruleKeys) {
                const rule = allRules.find(r => r.ruleKey == key);
                if (!rule) {
                    console.warn(`Rule ${key} not found in setup Rules!  Rules will always return false for security reasons`);
                }
                expressionSet.expressions[key] = rule === null || rule === void 0 ? void 0 : rule.expression;
            }
            return this.dwExpressionStateService.initExpressionSet(expressionSet, formGroup, context);
        }));
    }
    getRulesExpressionSet(ruleKeys) {
        const expressionSet = {
            defaultResult: false,
            isArray: false,
            expressions: {},
            delayMs: 50
        };
        return this.dwRuleService.getAllRules()
            .pipe(map(allRules => {
            for (const key of ruleKeys) {
                const rule = allRules.find(r => r.ruleKey == key);
                if (!rule) {
                    console.warn(`Rule ${key} not found in setup Rules!  Rules will always return false for security reasons`);
                }
                expressionSet.expressions[key] = rule === null || rule === void 0 ? void 0 : rule.expression;
            }
            return expressionSet;
        }));
    }
    executeRuleSetResult(ruleKeys, context, data) {
        return this.getRulesExpressionSet(ruleKeys)
            .pipe(map(expressionSet => {
            const resolvedContext = this.dwContextSerivce.getResolvedContext(context);
            return this.dwExpressionStateService.executeExpressionSet(expressionSet, data, resolvedContext);
        }));
    }
    executeExpressionSetResult(expressionSet, context, data) {
        const resolvedContext = this.dwContextSerivce.getResolvedContext(context);
        return this.dwExpressionStateService.executeExpressionSet(expressionSet, data, resolvedContext);
    }
    getRuleResult(ruleKey) {
        if (!this.ruleResults) {
            throw new Error("DwRuleService.getRuleSubject - setupRules has not been called!");
        }
        var ruleData = this.ruleResults[ruleKey];
        if (ruleData) {
            return ruleData.subject;
        }
        throw new Error(`DwRuleService.getRuleSubject - Rule ${ruleKey} not found in setup Rules!`);
    }
    setupRules(ruleKeys, context, formGroup) {
        for (let ruleKey of ruleKeys) {
            this.setupRule(ruleKey, context, formGroup);
        }
    }
    setupRule(ruleKey, context, formGroup) {
        let ruleData = this.ruleResults[ruleKey];
        // Check if rule is already setup
        if (ruleData) {
            return of(ruleData);
        }
        let subject = new Subject();
        this.dwRuleService.getRule(ruleKey)
            .subscribe(rule => {
            if (rule) {
                ruleData = {
                    rule: rule,
                    subject: new BehaviorSubject(false)
                };
                if (rule.expression) {
                    ruleData.subject = this.dwExpressionService.evaluateExpressionAsObservable(rule.expression, formGroup, context);
                }
                else {
                    if (rule.ruleFn) {
                        ruleData.subject = this.buildRuleFunctionSubject(rule, formGroup, context);
                    }
                }
                this.ruleResults[ruleKey] = ruleData;
                setTimeout(() => {
                    subject.next(ruleData);
                });
            }
        });
        return subject;
    }
    buildRuleFunctionSubject(rule, formGroup, context) {
        let obsList = [];
        if (rule.useFormGroup) {
            let behaviorSubject = new BehaviorSubject(formGroup.value);
            let controlObservable = formGroup.valueChanges.pipe(debounceTime(this.FORM_INPUT_DELAY));
            obsList.push(merge(behaviorSubject.asObservable(), controlObservable));
        }
        if (rule.contextNames) {
            for (let contextName in rule.contextNames) {
                if (context[contextName]) {
                    obsList.push(context[contextName]);
                }
            }
        }
        let subject = new BehaviorSubject(false);
        if (obsList.length > 0) {
            const subscription = combineLatest(obsList)
                .subscribe(changes => {
                this.dwRuleService.evaluateRule(rule, context, formGroup)
                    .subscribe(ruleResult => {
                    subject.next(ruleResult);
                });
            });
        }
        // Evaluate the rule once
        this.dwRuleService.evaluateRule(rule, context, formGroup)
            .subscribe(ruleResult => {
            subject.next(ruleResult);
        });
        return subject;
    }
}
DwRuleManagerService.ɵfac = function DwRuleManagerService_Factory(t) { return new (t || DwRuleManagerService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwRuleService), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwExpressionStateService), ɵngcc0.ɵɵinject(DwContextService)); };
DwRuleManagerService.count = 0;
DwRuleManagerService.ɵprov = ɵɵdefineInjectable({ factory: function DwRuleManagerService_Factory() { return new DwRuleManagerService(ɵɵinject(INJECTOR), ɵɵinject(DwRuleService), ɵɵinject(DwExpressionService), ɵɵinject(DwExpressionStateService), ɵɵinject(DwContextService)); }, token: DwRuleManagerService, providedIn: "root" });
DwRuleManagerService.ctorParameters = () => [
    { type: Injector },
    { type: DwRuleService },
    { type: DwExpressionService },
    { type: DwExpressionStateService },
    { type: DwContextService }
];

class DwDataFormatService {
    formatValue(value, options) {
        let formattedValue;
        options = Object.assign(Object.assign({}, this.getDefaultOptions()), options);
        switch (options.formatType) {
            case DwFormatTypes.date:
                formattedValue = formatDateTime(value, false, false);
                break;
            case DwFormatTypes.datetime:
                if (options === null || options === void 0 ? void 0 : options.useGmtDateTime) {
                    formattedValue = formatDateTimeToLocal(value, true, !(options === null || options === void 0 ? void 0 : options.use24HourTime));
                }
                else {
                    formattedValue = formatDateTime(value, true, !(options === null || options === void 0 ? void 0 : options.use24HourTime));
                }
                break;
            case DwFormatTypes.yesNo:
                if (value) {
                    formattedValue = 'Yes';
                }
                else {
                    formattedValue = 'No';
                }
                break;
            case DwFormatTypes.text:
                if (options.textSurroundChar) {
                    formattedValue = `${options.textSurroundChar}${value}${options.textSurroundChar}`;
                }
            default:
                formattedValue = value;
        }
        return formattedValue;
    }
    cleanExternalValue(value, options, reverseGmt) {
        let formattedValue = value;
        options = Object.assign(Object.assign({}, this.getDefaultOptions()), options);
        switch (options.formatType) {
            case DwFormatTypes.date:
                formattedValue = formatDateTime(value, false, false);
                break;
            case DwFormatTypes.datetime:
                if ((options === null || options === void 0 ? void 0 : options.useGmtDateTime) && reverseGmt) {
                    formattedValue = formatDateTimeFromLocal(value, true, !(options === null || options === void 0 ? void 0 : options.use24HourTime));
                }
                else {
                    formattedValue = formatDateTime(value, true, !(options === null || options === void 0 ? void 0 : options.use24HourTime));
                }
                break;
            case DwFormatTypes.yesNo:
                formattedValue = false;
                if (value == true || value == 'true' || value == '1' || value == 'yes') {
                    formattedValue = true;
                }
                break;
            case DwFormatTypes.number:
            case DwFormatTypes.currency:
            case DwFormatTypes.percent:
                const floatValue = parseFloat(value);
                const intValue = parseFloat(value);
                if (isNaN(floatValue)) {
                    formattedValue = null;
                }
                else {
                    formattedValue = floatValue;
                    if (floatValue == intValue) {
                        formattedValue = intValue;
                    }
                }
                break;
            case DwFormatTypes.text:
                formattedValue = value;
                break;
            default:
                formattedValue = value;
        }
        return formattedValue;
    }
    getDefaultOptions() {
        return {
            formatType: DwFormatTypes.text,
            missingDataText: 'None',
            use24HourTime: false,
            useGmtDateTime: true,
        };
    }
}
DwDataFormatService.ɵfac = function DwDataFormatService_Factory(t) { return new (t || DwDataFormatService)(); };
DwDataFormatService.ɵprov = ɵɵdefineInjectable({ factory: function DwDataFormatService_Factory() { return new DwDataFormatService(); }, token: DwDataFormatService, providedIn: "root" });

class DwFormDebugService {
    static addWatchFields(fields) {
        for (const field of fields) {
            DwFormDebugService.watchFields.push(field);
        }
    }
    static addWatchField(field) {
        DwFormDebugService.watchFields.push(field);
    }
    static getFieldDebug(fieldName) {
        let fieldDebug = DwFormDebugService.fieldDebug.get(fieldName);
        if (!fieldDebug) {
            fieldDebug = {
                fieldName: fieldName,
                stateHistory: []
            };
            DwFormDebugService.fieldDebug.set(fieldName, fieldDebug);
        }
        return fieldDebug;
    }
    static isComponentNameMatch(componentName) {
        for (const nameMatch of this.componentNameList) {
            if ((componentName === null || componentName === void 0 ? void 0 : componentName.indexOf(nameMatch)) >= 0) {
                return true;
            }
        }
        return false;
    }
    static isMessageMatch(message) {
        for (const nameMatch of this.messageFilters) {
            if ((message === null || message === void 0 ? void 0 : message.indexOf(nameMatch)) >= 0) {
                return true;
            }
        }
        return false;
    }
    static debugMessage(instanceId, componentName, message, data, severity = DwMessageSeverity.info) {
        if (this.disableLogging) {
            return false;
        }
        if (this.showAllMessages || this.isComponentNameMatch(componentName) || this.isMessageMatch(message)) {
            const elapsedTime = Date.now() - this.startTime;
            if (this.timeThreshold && elapsedTime < this.timeThreshold) {
                return;
            }
            // reset value
            this.startTime = Date.now();
            const finalMessage = `DwFormDebugService - ${componentName}(${instanceId}) - ${message} - ${elapsedTime}ms`;
            let log = console.log;
            switch (severity) {
                case DwMessageSeverity.warning:
                    log = console.warn;
                    break;
                case DwMessageSeverity.error:
                    log = console.error;
                    break;
                case DwMessageSeverity.success:
                    log = console.trace;
            }
            if (data) {
                log(finalMessage, data);
            }
            else {
                log(finalMessage);
            }
            return true;
        }
        return false;
    }
    static debugEvent(formGroup, stateMessage) {
        for (const fieldName of DwFormDebugService.watchFields) {
            const control = DwFormDebugService.findField(formGroup, fieldName);
            if (!control) {
                if (DwFormDebugService.showMissingFieldsError) {
                    console.log(`DwFormDebugService - Field ${fieldName} not found in form group`);
                }
                continue;
            }
            DwFormDebugService.processFieldDebug(fieldName, control, stateMessage);
        }
    }
    static processFieldDebug(fieldName, control, stateMessage) {
        const fieldDebug = DwFormDebugService.getFieldDebug(fieldName);
        let hasChange = false;
        if (!fieldDebug.lastState) {
            hasChange = true;
        }
        else {
            if (fieldDebug.lastState.status !== control.status) {
                hasChange = true;
            }
        }
        if (!hasChange) {
            return;
        }
        fieldDebug.lastState = {
            status: control.status,
            value: control.value,
            stateMessage: stateMessage
        };
        fieldDebug.stateHistory.push(fieldDebug.lastState);
        console.log(`DwFormDebugService - State Change for Field ${fieldName}`, fieldDebug);
    }
    static findField(formGroup, fieldName) {
        if (formGroup.controls[fieldName]) {
            return formGroup.controls[fieldName];
        }
        for (const controlName in formGroup.controls) {
            const control = formGroup.controls[controlName];
            if (control instanceof FormGroup) {
                const foundResult = DwFormDebugService.findField(control, fieldName);
                if (foundResult) {
                    return foundResult;
                }
            }
        }
        return null;
    }
}
DwFormDebugService.watchFields = [];
DwFormDebugService.fieldDebug = new Map();
DwFormDebugService.showMissingFieldsError = false;
DwFormDebugService.componentNameList = []; // ['Wachter - Edit'];
DwFormDebugService.messageFilters = []; // ['Wachter - Edit'];
DwFormDebugService.showAllMessages = false;
DwFormDebugService.startTime = Date.now();
DwFormDebugService.timeThreshold = 0;
DwFormDebugService.disableLogging = false;

class DwMetadataFormBuilderService {
    constructor(dwFormUtilService, uiMetaDataConfig, dwMetaDataService, dwMetadataFormValidationBuilderService, DwRuleManagerService, dwRuleService, router, dwExpressionService, dwUiConfigRegistryService, dwDataFormatService) {
        this.dwFormUtilService = dwFormUtilService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetadataFormValidationBuilderService = dwMetadataFormValidationBuilderService;
        this.DwRuleManagerService = DwRuleManagerService;
        this.dwRuleService = dwRuleService;
        this.router = router;
        this.dwExpressionService = dwExpressionService;
        this.dwDataFormatService = dwDataFormatService;
        this.sectionDefinitions = [];
        this.formControlDisableTogglingEnabled = true;
        this.sectionDefinitions = dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
    }
    setupFormControls(formGroup, formConfig) {
        const contextFormGroup = new DwFormGroup({});
        formGroup.addControl(DwMdFormContextInfo.CONTEXT_FORM_GROUP, contextFormGroup);
        // Call recursive method to setup form controls starting with the root section
        this.addSectionFormControls(formGroup, contextFormGroup, formConfig.section, formConfig, formConfig.rootItemName);
        contextFormGroup.disable();
        // If it's read only, disable the parent form group
        if (formConfig.readOnly) {
            formGroup.disable();
        }
    }
    addFormGroupControlsBySection(formGroup, section, formConfig, itemName) {
        const sectionDef = this.dwFormUtilService.getSectionDef(section.sectionType);
        if (sectionDef && sectionDef.addFormGroupControls) {
            sectionDef.addFormGroupControls(section, formGroup, formConfig, itemName);
        }
        const childSections = this.dwFormUtilService.getSectionChildren(section, sectionDef);
        for (const childSection of childSections) {
            if (!this.dwFormUtilService.isChildDataSection(childSection, true)) {
                this.addFormGroupControlsBySection(formGroup, childSection, formConfig, itemName);
            }
        }
    }
    clearForm(formGroup) {
        for (const controlKey in formGroup.controls) {
            const control = formGroup.controls[controlKey];
            if (control instanceof FormGroup) {
                this.clearForm(control);
            }
            else if (control instanceof FormArray) {
                control.clear();
            }
            else {
                control.setValue(null);
            }
        }
    }
    addSectionFormControls(formGroup, contextFormGroup, section, formConfig, itemName, initialKeyValue) {
        // Get used fields for this sections (and it's children - existing child Data sections)
        let usedFields = this.getUsedFields(section);
        // Determine MetaDataItem
        let itemMetaData = formConfig.queryMetaDataList[itemName];
        if (!itemMetaData) {
            console.warn(`Item Meta Data is missing for item name ${itemName}.`);
            return;
        }
        let isNewFormGroup = (Object.keys(formGroup.controls).length == 0);
        // Always add PK as a control
        this.addPrimaryKeyControl(formGroup, itemMetaData, initialKeyValue);
        for (var field of usedFields) {
            this.addFormControl(formGroup, contextFormGroup, field, formConfig, itemMetaData);
        }
        this.addFormGroupControlsBySection(formGroup, section, formConfig, itemName);
        // Get a list of child data sections
        let childDataSections = this.dwFormUtilService.getChildDataSections(section);
        for (let childDataSection of childDataSections) {
            let addGroup = false;
            let forceAddChildDataSection = true;
            if (childDataSection != section || forceAddChildDataSection) {
                let childFormGroup = formGroup.get(childDataSection.propertyName);
                // Check if the form group already exists (This can happen if two containers use the same child data)
                addGroup = !childFormGroup;
                if (!this.dwFormUtilService.shouldCreateChildFormGroup(childDataSection)) {
                    continue;
                }
                if (this.dwFormUtilService.isGridSection(childDataSection)) {
                    // Use a form control for grids so we don't have to specific the fields
                    if (!childFormGroup) {
                        childFormGroup = new FormControl();
                    }
                }
                else {
                    if (!childFormGroup) {
                        if (childDataSection.excludeChildControls) {
                            // Create child Form group
                            childFormGroup = new FormControl();
                        }
                        else {
                            // Create child Form group
                            childFormGroup = new DwFormGroup({});
                        }
                    }
                    if (!childDataSection.excludeChildControls || !childDataSection.section) {
                        this.addSectionFormControls(childFormGroup, contextFormGroup, childDataSection.section, formConfig, childDataSection.childItem);
                        if (!addGroup) {
                            // Add this just like the initial section so we can handle any level
                            this.addSectionFormControls(childFormGroup, contextFormGroup, childDataSection.section, formConfig, childDataSection.childItem);
                            // Enable and redisable so any new fields are also disabled (otherwise cases a validation issue)
                            for (const controlKey in childFormGroup.controls) {
                                const control = childFormGroup.controls[controlKey];
                                if (control.enabled && control.controls == null) {
                                    control.disable();
                                }
                            }
                        }
                    }
                }
                if (addGroup) {
                    formGroup.addControl(childDataSection.propertyName, childFormGroup);
                }
            }
        }
        // Disable child form groups by default (this forces validation to only look at enabled sections)
        //   sections that are displayed automatically enabled
        if (this.formControlDisableTogglingEnabled) {
            formGroup.disable();
        }
    }
    addPrimaryKeyControl(formGroup, itemMetaData, initialKeyValue) {
        let keyAttr = itemMetaData.Attributes.find(a => a.Attribute && a.Attribute.IsKey);
        if (!keyAttr) {
            return;
        }
        var fc = formGroup.get(keyAttr.AttributeName);
        if (!fc) {
            fc = new FormControl(initialKeyValue);
            formGroup.addControl(keyAttr.AttributeName, fc);
        }
    }
    getPrimaryKeyValue(formGroup, itemMetaData) {
        let keyAttr = itemMetaData.Attributes.find(a => a.Attribute && a.Attribute.IsKey);
        if (!keyAttr) {
            return;
        }
        var fc = formGroup.get(keyAttr.AttributeName);
        if (fc) {
            return fc.value;
        }
        return null;
    }
    addFormControl(formGroup, contextFormGroup, field, formConfig, itemMetaData) {
        var _a;
        let attrName = field.attrName;
        if (!itemMetaData) {
            console.warn(`Item Meta Data is missing for attribute name ${attrName}.`);
            return;
        }
        let attr;
        if (field.contextName) {
            const contextMetaData = formConfig.contextMetaDataList[field.contextName];
            if (!contextMetaData) {
                console.warn(`Context Def not found for context ${field.contextName}. Can't add field name ${attrName}.`);
                return;
            }
            attr = (_a = contextMetaData.attributes) === null || _a === void 0 ? void 0 : _a.find(a => a.AttributeName.toUpperCase() == attrName.toUpperCase());
            if (!attr) {
                console.warn(`Attribute name ${attrName} was not found on context ${contextMetaData.contextDef.contextDisplay}.`);
                return;
            }
            formGroup = this.getContextFormGroup(contextFormGroup, field.contextName);
        }
        else {
            attr = itemMetaData.Attributes.find(a => a.AttributeName.toUpperCase() == attrName.toUpperCase());
            if (!attr) {
                console.warn(`Attribute name ${attrName} was not found on item ${itemMetaData.RootItem}.`);
                return;
            }
        }
        let fc = formGroup.get(attr.AttributeName);
        if (!fc) {
            fc = new FormControl();
        }
        this.setDefaultValue(fc, field, formConfig, attr);
        if (field.isReadOnly || formConfig.readOnly) {
            fc.disable();
        }
        else {
            fc.enable();
            let validationConfig = field.validationConfig;
            if (!validationConfig || !validationConfig.overrideDefaults) {
                validationConfig = this.dwMetadataFormValidationBuilderService.getDefaultFieldValidatorConfig(attr.Attribute, formConfig.ignoreRequiredValidation);
            }
            // TODO: Re-evaluate if setting up validation can be moved to the dw-form-section where conditional validation is setup
            //  We don't have the context required to setup conditional validation items so they will not be set initially and then added in the form section
            let validatorsResult = this.dwMetadataFormValidationBuilderService.buildValidators(fc, validationConfig, "none", {});
            fc.setValidators(validatorsResult.validators);
        }
        var existingControl = formGroup.get(attr.AttributeName);
        if (!existingControl) {
            formGroup.addControl(attr.AttributeName, fc);
        }
        // Determine if we should add a display field
        if (formConfig.loadDisplayProperties && attr.DisplayAttributeName != attr.AttributeName) {
            this.addDisplayFormControl(formGroup, attr);
        }
    }
    getContextFormGroup(contextFormGroup, contextName) {
        let formGroup = contextFormGroup.get(contextName);
        if (!formGroup) {
            formGroup = new FormGroup({});
            contextFormGroup.addControl(contextName, formGroup);
        }
        return formGroup;
    }
    setDefaultValue(fc, field, formConfig, attr) {
        if (field.hasDefaultValue && field.defaultValue !== null && field.defaultValue !== undefined) {
            let value = field.defaultValue;
            if (field.defaultValue.reference) {
                switch (field.defaultValue.reference.referenceType) {
                    case DwExpressionReferenceType.value:
                        value = field.defaultValue.reference.value;
                        break;
                    case DwExpressionReferenceType.context:
                        // Set to null for now because we need to wait to evaluate context when its ready
                        value = null;
                        // Add this to a collection to populate once context data is initialized
                        formConfig.contextValueFCDefaults = formConfig.contextValueFCDefaults || [];
                        formConfig.contextValueFCDefaults.push({
                            abstractControl: fc,
                            defaultValue: field.defaultValue,
                            processed: false
                        });
                }
            }
            else if (field.defaultValue.value) {
                value = field.defaultValue.value;
            }
            fc.setValue(value);
        }
        const queryStringDefaultValue = getParameterByName(this.router, field.attrName);
        if (queryStringDefaultValue) {
            // We don't want to use the options for GMT date/time since we want to preserve what they passed
            // NOTE: we might need to handle a date/time that is in local time (not sure the best way)
            const formatOptions = this.dwMetaDataService.getAttributeFormatOptions(attr === null || attr === void 0 ? void 0 : attr.Attribute, false, false);
            const cleanValue = this.dwDataFormatService.cleanExternalValue(queryStringDefaultValue, formatOptions);
            if (queryStringDefaultValue !== cleanValue) {
                console.info(`${field.attrName} default value from query string was modified from '${queryStringDefaultValue}' to '${cleanValue}'`);
            }
            // fc.setValue(queryStringDefaultValue);
            fc.setValue(cleanValue);
        }
    }
    /**
     * Add a Form Control for the Display value of lookups
     */
    addDisplayFormControl(formGroup, attr) {
        let fc = formGroup.get(attr.DisplayAttributeName);
        if (!fc) {
            fc = new FormControl();
            formGroup.addControl(attr.DisplayAttributeName, fc);
        }
    }
    getUsedFields(section, fields) {
        section = section;
        fields = fields || [];
        if (!section) {
            return fields;
        }
        const sectionDef = this.dwFormUtilService.getSectionDef(section.sectionType);
        // If the section has prefetch paths, then don't add child since they are for a different table
        if (sectionDef.getPrefetchPathInfo) {
            return fields;
        }
        if (section.sectionType == DwSectionType.form) {
            let formSection = section;
            const formFields = formSection.fields || [];
            for (var field of formFields) {
                fields.push(field);
            }
        }
        var childSections = this.dwFormUtilService.getSectionChildren(section);
        for (const childSection of childSections) {
            // If the section has prefetch paths, then don't add child since they are for a different table
            if (sectionDef.getPrefetchPathInfo) {
                continue;
            }
            this.getUsedFields(childSection, fields);
        }
        return fields;
    }
    getFormSecurityResultsOld(formConfig, formGroup, context, dataLoadComplete, originalData, contextStateInfo) {
        const ruleKeys = [];
        this.addRule(formConfig.canAddRuleKey, ruleKeys);
        this.addRule(formConfig.canEditRuleKey, ruleKeys);
        this.addRule(formConfig.canViewRuleKey, ruleKeys);
        const securityResult = {
            canAdd: true,
            hasAddExpression: false,
            canEdit: true,
            hasEditExpression: false,
            canView: true,
            hasViewExpression: false,
            isComplete: { allInitialized: false, allPopulated: false }
        };
        if (ruleKeys.length == 0) {
            securityResult.isComplete = { allInitialized: false, allPopulated: false };
            return of(securityResult);
        }
        const subject = new Subject();
        setTimeout(() => {
            this.DwRuleManagerService.getRulesExpressionSet(ruleKeys)
                .subscribe(expressionSet => {
                expressionSet.expressions['sdf'];
            });
            this.DwRuleManagerService.executeRuleSetResult(ruleKeys, context, originalData)
                .subscribe(results => {
                const initialSecurity = this.convertSecurityResult(results.initialResults, formConfig);
                initialSecurity.isComplete = { allInitialized: true, allPopulated: false }; //this.isEverythingLoaded(dataLoadComplete, contextStateInfo, context);
                subject.next(initialSecurity);
                subject.complete();
            });
        });
        return subject.asObservable();
    }
    /** Check if everything is loaded
     * Note: An enhancement would be to look at the rules to determine which data is needed and return accordingly
     */
    isEverythingLoaded(dataLoadComplete, contextStateInfo, context) {
        if (!dataLoadComplete) {
            return false;
        }
        for (let contextName in contextStateInfo) {
            if (contextStateInfo.hasOwnProperty(contextName)) {
                // Ignore the data context
                if (contextName == DwMdFormContextInfo.DATA_CONTEXT_NAME) {
                    continue;
                }
                const contextValue = context[contextName].value;
                var contextState = contextStateInfo[contextName];
                // console.warn(`isEverythingLoaded  ${contextName} - load complete: ${contextState?.loadComplete}`, contextValue);
                if (!contextState.loadComplete || !contextValue) {
                    return false;
                }
            }
        }
        return true;
    }
    getFormSecurityResultsReallyOld(formConfig, formGroup, context) {
        const ruleKeys = [];
        this.addRule(formConfig.canAddRuleKey, ruleKeys);
        this.addRule(formConfig.canEditRuleKey, ruleKeys);
        this.addRule(formConfig.canViewRuleKey, ruleKeys);
        const securityResult = {
            canAdd: true,
            hasAddExpression: false,
            canEdit: true,
            hasEditExpression: false,
            canView: true,
            hasViewExpression: false,
            isComplete: { allInitialized: false, allPopulated: false }
        };
        if (ruleKeys.length == 0) {
            securityResult.isComplete = { allInitialized: true, allPopulated: false };
            return of(securityResult);
        }
        const subject = new Subject();
        setTimeout(() => {
            this.DwRuleManagerService.getRuleSetResult(ruleKeys, context, formGroup)
                .subscribe(results => {
                const initialSecurity = this.convertSecurityResult(results.initialResults, formConfig);
                subject.next(initialSecurity);
                results.observable.subscribe(newResults => {
                    const updatedResults = this.convertSecurityResult(newResults, formConfig);
                    subject.next(updatedResults);
                });
            });
        });
        return subject.asObservable();
    }
    getFormSecurityResults(formConfig, formContextMode, formGroup, context, dataLoadComplete, originalData, contextStateInfo) {
        const securityResult = {
            canAdd: true,
            canEdit: true,
            canView: true,
            isComplete: { allInitialized: true, allPopulated: true }
        };
        const subject = new Subject();
        contextStateInfo = Object.assign({}, contextStateInfo);
        DwFormDebugService.debugMessage(null, 'DwMetadataFormBuilderService', `Start check`, { contextStateInfo: Object.assign({}, contextStateInfo) });
        setTimeout(() => {
            this.getSecurityExpressionSet(formConfig)
                .subscribe(expressionSet => {
                // If no expressions, then we're finished
                if (isEmptyObject(expressionSet.expressions)) {
                    securityResult.isComplete = { allInitialized: true, allPopulated: true };
                    subject.next(securityResult);
                    subject.complete();
                    return;
                }
                const originalIsComplete = this.isEverythingLoaded2(expressionSet, formContextMode, dataLoadComplete, contextStateInfo, context);
                const results = this.DwRuleManagerService.executeExpressionSetResult(expressionSet, context, originalData);
                const initialSecurity = this.convertSecurityResult2(expressionSet, results.initialResults, formConfig);
                initialSecurity.isComplete = this.isEverythingLoaded2(expressionSet, formContextMode, dataLoadComplete, contextStateInfo, context);
                if (initialSecurity.isComplete.allInitialized && initialSecurity.isComplete.allPopulated) {
                    DwFormDebugService.debugMessage(null, 'DwMetadataFormBuilderService', `Form Security: ${JSON.stringify(initialSecurity)}  Original IsComplete.allInitialized : ${originalIsComplete.allInitialized}`, Object.assign({}, contextStateInfo));
                }
                subject.next(initialSecurity);
                subject.complete();
            });
        });
        return subject.asObservable();
    }
    /** Check if everything is loaded
   * Note: An enhancement would be to look at the rules to determine which data is needed and return accordingly
   */
    isEverythingLoaded2(expressionSet, formContextMode, dataLoadComplete, contextStateInfo, context) {
        // For adds, only check the add expression
        if (formContextMode == DwFormContextMode.add) {
            return this.isExpressionDataLoaded(expressionSet.expressions[DwMetaDataSecurityResultType.add], dataLoadComplete, contextStateInfo, context);
        }
        const viewExpressionLoaded = this.isExpressionDataLoaded(expressionSet.expressions[DwMetaDataSecurityResultType.view], dataLoadComplete, contextStateInfo, context);
        if (!viewExpressionLoaded) {
            return { allInitialized: true, allPopulated: true };
        }
        const editExpressionLoaded = this.isExpressionDataLoaded(expressionSet.expressions[DwMetaDataSecurityResultType.edit], dataLoadComplete, contextStateInfo, context);
        return editExpressionLoaded;
    }
    isExpressionDataLoaded(expr, dataLoadComplete, contextStateInfo, context) {
        if (this.dwExpressionService.isEmptyExpressionGroupItem(expr)) {
            return { allInitialized: true, allPopulated: true };
        }
        const dependencies = this.dwExpressionService.getExpresionDependencies(expr);
        let hasEmptyContext = false;
        for (const dependency of dependencies) {
            switch (dependency.referenceType) {
                case DwExpressionReferenceType.value:
                    continue;
                case DwExpressionReferenceType.item:
                    if (!dataLoadComplete) {
                        return { allInitialized: false, allPopulated: false };
                    }
                    continue;
                case DwExpressionReferenceType.context:
                    const contextState = contextStateInfo[dependency.contextName];
                    const contextData = context[dependency.contextName].value;
                    if (!contextState.loadComplete || !contextData || contextState.isLoading) {
                        return { allInitialized: false, allPopulated: false };
                    }
                    const isEmptyContext = isEmptyObject(contextData);
                    if (isEmptyContext) {
                        hasEmptyContext = true;
                    }
                    DwFormDebugService.debugMessage(null, 'DwMetadataFormBuilderService', `isExpressionDataLoaded: ${dependency.contextName}  Empty=${isEmptyContext}`, contextData);
                    continue;
            }
        }
        return { allInitialized: true, allPopulated: !hasEmptyContext };
    }
    getSecurityExpressionSet(formConfig) {
        const expressionSet = {
            defaultResult: false,
            isArray: false,
            expressions: {},
            delayMs: 50
        };
        return this.dwRuleService.getAllRules()
            .pipe(map(allRules => {
            this.addSecurityExpression(expressionSet, DwMetaDataSecurityResultType.add, allRules, formConfig.canAddRuleKey, formConfig.useCanAddExpression, formConfig.canAddExpression);
            this.addSecurityExpression(expressionSet, DwMetaDataSecurityResultType.edit, allRules, formConfig.canEditRuleKey, formConfig.useCanEditExpression, formConfig.canEditExpression);
            this.addSecurityExpression(expressionSet, DwMetaDataSecurityResultType.add, allRules, formConfig.canViewRuleKey, formConfig.useCanViewExpression, formConfig.canViewExpression);
            return expressionSet;
        }));
    }
    addSecurityExpression(expressionSet, securityType, allRules, ruleKey, useExpression, expression) {
        let expr = expression;
        if (!useExpression && ruleKey) {
            const rule = allRules.find(r => r.ruleKey == ruleKey);
            if (!rule) {
                console.warn(`Rule ${ruleKey} not found in setup Rules!  Rules will always return false for security reasons`);
            }
            expr = rule === null || rule === void 0 ? void 0 : rule.expression;
        }
        if (expr) {
            expressionSet.expressions[securityType] = expr;
        }
    }
    convertSecurityResult(results, formConfig) {
        const securityResult = {
            canAdd: this.getRuleResult(results, formConfig.canAddRuleKey),
            canEdit: this.getRuleResult(results, formConfig.canEditRuleKey),
            canView: this.getRuleResult(results, formConfig.canViewRuleKey),
            isComplete: { allInitialized: false, allPopulated: false }
        };
        return securityResult;
    }
    convertSecurityResult2(expressionSet, results, formConfig) {
        const securityResult = {
            canAdd: this.getRuleResult(results, DwMetaDataSecurityResultType.add),
            canEdit: this.getRuleResult(results, DwMetaDataSecurityResultType.edit),
            canView: this.getRuleResult(results, DwMetaDataSecurityResultType.view),
            isComplete: { allInitialized: false, allPopulated: false }
        };
        return securityResult;
    }
    getRuleResult(results, key) {
        if (!key) {
            // If no key, the we always allow it
            return true;
        }
        const result = results[key];
        if (result) {
            return result.result;
        }
        // return true if there is not expression
        return true;
    }
    addRule(ruleKey, ruleKeys) {
        if (ruleKey) {
            if (!ruleKeys.find(r => r == ruleKey)) {
                ruleKeys.push(ruleKey);
            }
        }
    }
}
DwMetadataFormBuilderService.ɵfac = function DwMetadataFormBuilderService_Factory(t) { return new (t || DwMetadataFormBuilderService)(ɵngcc0.ɵɵinject(DwMetadataFormUtilService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵinject(DwRuleManagerService), ɵngcc0.ɵɵinject(DwRuleService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwDataFormatService)); };
DwMetadataFormBuilderService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetadataFormBuilderService_Factory() { return new DwMetadataFormBuilderService(ɵɵinject(DwMetadataFormUtilService), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwMetadataFormValidationBuilderService), ɵɵinject(DwRuleManagerService), ɵɵinject(DwRuleService), ɵɵinject(Router), ɵɵinject(DwExpressionService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwDataFormatService)); }, token: DwMetadataFormBuilderService, providedIn: "root" });
DwMetadataFormBuilderService.ctorParameters = () => [
    { type: DwMetadataFormUtilService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwRuleManagerService },
    { type: DwRuleService },
    { type: Router },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwDataFormatService }
];

class DwUiPanelWidgetConfig {
}

class DwUiConfigurableControlBase {
    constructor(uiConfigService, dwEventService, dwSecurityUserService, dwConfigService) {
        this.uiConfigService = uiConfigService;
        this.dwEventService = dwEventService;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwConfigService = dwConfigService;
        this.allowConfiguration = true;
        this.configSequenceComplete = false;
        this.autoStartConfigSessions = true;
        this.subscriptions = [];
        this.initAfterContentInit = false;
        this.uiConfig = dwConfigService.getConfig(DwUiConfigName, new DwUIConfigDefaults());
        this.canConfigure = this.uiConfig.allowConfiguration && this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canConfigureUIPermission, false);
        this.canEditContent = this.uiConfig.allowConfiguration && this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canEditContentPermision, false);
    }
    ngOnInit() {
        this.buildContextMenu();
        // Commentting out since the security change also triggers this
        // if (!this.initAfterContentInit) {
        //     this.loadPreferencesInternal();
        // }
        this.subscriptions.push(this.dwSecurityUserService.securityContextChanged()
            .subscribe(sc => {
            this.configSequenceComplete = false;
            this.isSecurityChange = true;
            // Determine if the authenticate user can configure the UI
            this.canConfigure = this.uiConfig.allowConfiguration && this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canConfigureUIPermission, false);
            this.canEditContent = this.uiConfig.allowConfiguration && this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canEditContentPermision, false);
            this.buildContextMenu();
            // Reload preferences (since this is where secrutiy is checked)
            this.loadPreferencesInternal();
            setTimeout(() => {
                this.isSecurityChange = false;
            }, 100);
        }));
    }
    loadPreferencesInternal() {
        this.subscriptions.push(this.loadPreferences()
            .subscribe(p => {
            this.applyPreferences(p);
            this.isSecurityChange = false;
        }, error => {
            this.handlePreferenceError(error);
            this.isSecurityChange = false;
        }));
    }
    handlePreferenceError(error) {
        console.error(`Could load preferences `, error);
        this.configComplete();
    }
    ngAfterContentInit() {
        if (this.initAfterContentInit) {
            this.loadPreferencesInternal();
        }
    }
    ngOnDestroy() {
        // console.log(`DwUiConfigurable Base - On Destroy`, this.getConfigKey());
        if (this.configSessionActive) {
            this.endConfigSession();
        }
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        if (!this.configSequenceComplete)
            return;
        if (changes.configKey && !changes.configKey.firstChange) {
            if (!changes.configKey.currentValue) {
                console.log('config key is null');
            }
            //console.log(`DwUiConfigurable Base - Config key Change`, changes.configKey);
            this.configSequenceComplete = false;
            // Need to deregister the previous config key
            this.endConfigSession(changes.configKey.previousValue);
            this.loadPreferencesInternal();
        }
        if (changes.preferences && !changes.preferences.firstChange && changes.preferences.currentValue) {
            // Ensure the preferences are different that what's already loaded
            if (!areEqual(this.preferenceHierarchy.componentSetPreferences, this.preferences)) {
                // Reset the component set preferences and the force an apply
                // Update preferences
                this.preferenceHierarchy.componentSetPreferences = this.preferences;
                this.applyPreferences(this.preferenceHierarchy, true);
            }
        }
    }
    applyPreferences(prefHierarchy, forceApply) {
        var _a;
        prefHierarchy = deepCopy(prefHierarchy);
        // Ensure that this is the same or newer version
        if (((_a = this.preferenceHierarchy) === null || _a === void 0 ? void 0 : _a.configData) && (prefHierarchy === null || prefHierarchy === void 0 ? void 0 : prefHierarchy.configData)) {
            if (isBeforeDate(this.preferenceHierarchy.configData.ModifiedDateTime, prefHierarchy.configData.ModifiedDateTime)) {
                console.warn(`The preferences are older than the current preferences.  Ignoring the preferences update.`);
                return;
            }
        }
        this.preferenceHierarchy = prefHierarchy;
        var finalPreferences = this.uiConfigService.getFinalPreferences(this.preferenceHierarchy, !this.allowConfiguration);
        if (this.configSequenceComplete && areEqualDeepCompare(this.finalPreferences, finalPreferences) && !forceApply) {
            return;
        }
        this.finalPreferences = finalPreferences;
        var configResult = this.setupConfig();
        if (configResult instanceof Observable) {
            configResult.subscribe(r => {
                this.configComplete();
            });
        }
        else {
            this.configComplete();
        }
        this.buildContextMenu();
    }
    configComplete() {
        if (this.configSequenceComplete)
            return;
        if (isEmptyObject(this.finalPreferences))
            return;
        this.configSequenceComplete = true;
        if (this.autoStartConfigSessions)
            this.startConfigSession();
    }
    startConfigSession() {
        if (this.configSessionActive || !this.allowConfiguration) {
            return;
        }
        this.contextMenu.length = 0;
        this.configSessionActive = true;
        this.buildContextMenu();
        let panelWidgetComponent = this.getPanelWidgetComponent();
        if (!panelWidgetComponent) {
            throw new Error("Can't start config session since there isn't a panelWidgetComponent configured!");
        }
        const panelWidgetConfig = new DwUiPanelWidgetConfig();
        panelWidgetConfig.configKey = this.getConfigKey();
        panelWidgetConfig.uiConfigTypeId = this.configType;
        panelWidgetConfig.widgetComponent = panelWidgetComponent;
        panelWidgetConfig.debugComponent = this.getPanelDebugComponent();
        panelWidgetConfig.data = this.preferenceHierarchy;
        this.uiConfigService.registerUiPanelWidget(panelWidgetConfig);
        // Listen for events on this topic so we can update the control configuration
        this.subscriptions.push(this.dwEventService.getEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.PreferencesUpdateEvent(this.getConfigKey(), this.configType))
            .subscribe((event) => {
            // Need to use a delay so that Angular can view the change (otherwise change events ran on bound components)
            setTimeout(() => {
                this.applyPreferences(event.data);
            }, 5);
        }));
        this.dwEventService.publishEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.PreferencesFinalizedEvent(this.getConfigKey(), this.configType), this.preferenceHierarchy);
    }
    endConfigSession(configKey) {
        configKey = configKey || this.getConfigKey();
        this.configSessionActive = false;
        this.uiConfigService.removeUiPanelWidget(configKey, this.configType);
        this.buildContextMenu();
    }
    buildContextMenu() {
        var items = [];
        if (this.allowConfiguration && this.canConfigure) {
            if (!this.configSessionActive) {
                items.push({
                    label: 'Configure',
                    command: (event) => { this.startConfigSession(); }
                });
            }
            // else {
            //     items.push({
            //         label: 'Cancel Configure',
            //         command: (event) => { this.endConfigSession() }
            //     })
            // }
        }
        this.contextMenu = items;
    }
    getPanelDebugComponent() {
        return null;
    }
}
DwUiConfigurableControlBase.ɵfac = function DwUiConfigurableControlBase_Factory(t) { return new (t || DwUiConfigurableControlBase)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken)); };
DwUiConfigurableControlBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwUiConfigurableControlBase, inputs: { allowConfiguration: "allowConfiguration", preferences: "preferences" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwUiConfigurableControlBase.ctorParameters = () => [
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];
DwUiConfigurableControlBase.propDecorators = {
    preferences: [{ type: Input }],
    allowConfiguration: [{ type: Input }]
};

class DwContextConfigurableBaseComponent extends DwUiConfigurableControlBase {
    constructor(uiConfigService, dwEventService, dwContextService, dwSecurityUserService, dwConfigService) {
        super(uiConfigService, dwEventService, dwSecurityUserService, dwConfigService);
        this.uiConfigService = uiConfigService;
        this.dwEventService = dwEventService;
        this.dwContextService = dwContextService;
        this.context = {};
        this.contextStateInfo = {};
        this.contextStateInfoSubject = new Subject();
        this.contextDebounceSubjects = {};
        this.contextUpdateDelay = 100;
        this.dataContextName = 'data';
    }
    // Setup context by creating the initial subjects and observables
    setupContext(contextNames) {
        contextNames = contextNames || [];
        for (let contextName of contextNames) {
            let subject = this.getContextSubject(contextName);
        }
        this.getContextSubject("data");
        this.setupContextWatch(contextNames);
    }
    setupContextWatch(contextNames) {
        const cacheInvalidationTopics = this.dwContextService.getContextTopics(contextNames);
        for (const topic of cacheInvalidationTopics) {
            this.subscriptions.push(this.dwEventService.getEvent(topic)
                .subscribe(event => {
                const resultContextNames = this.dwContextService.getContextNamesForTopic(topic, contextNames);
                this.updateContext(resultContextNames, true);
            }));
        }
    }
    setData(data) {
    }
    updateContextValue(keyName, value, isComplete) {
        let subject = this.getContextSubject(keyName);
        const contextStateInfo = this.contextStateInfo[keyName] || {};
        let isCompleteChanged = contextStateInfo.loadComplete != isComplete;
        if (contextStateInfo) {
            contextStateInfo.setManually = true;
            contextStateInfo.loadComplete = isComplete;
            this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
        }
        // Moved to over loadComplete is set so the contexts don't need to be reloaded (or checked) another time
        subject.next(value);
        // Check other contexts that depend on this context
        if (isCompleteChanged && isComplete && keyName == this.dataContextName) {
            this.updateDataRelatedContexts(value);
        }
    }
    updateDataRelatedContexts(dataContextValue) {
        const resolvedContext = this.dwContextService.getResolvedContext(this.context);
        DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `updateDataRelatedContexts - Checking other contexts`, resolvedContext);
        for (const contextName in this.contextStateInfo) {
            const contextStateInfo = this.contextStateInfo[contextName];
            if (this.dwContextService.getUpdateContextOnDataChange(contextName)) {
                // if (contextStateInfo.isLoading) {
                //     if (!contextStateInfo.loadComplete) {
                //         DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Update Data value - Context ${contextName} - Context Key = ${contextKey} (Loaded Key: ${loadedContextKey}, Latest Key ${latestContextKey}) - needs to be updated`, { ...contextStateInfo }, DwMessageSeverity.warning);
                //         // we need to trigger a refresh after the load is complete
                //         contextStateInfo.refreshAfterLoadComplete = true;
                //     }
                // }
                if (!contextStateInfo.refreshAfterLoadComplete) {
                    const contextDef = this.dwContextService.getContextDef(contextName);
                    // Check
                    const contextKey = contextDef.getCustomContextKey(resolvedContext);
                    const latestResolveContext = Object.assign(Object.assign({}, resolvedContext), { data: dataContextValue });
                    const latestContextKey = contextDef.getCustomContextKey(latestResolveContext);
                    const loadedContextKey = this.contextKeys[contextName];
                    if (contextName.indexOf('Status_Details') >= 0) {
                        DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Update Data value - Context ${contextName} - Context Key = ${contextKey} (Loaded Key: ${loadedContextKey}, Latest Key ${latestContextKey}) - needs to be updated`, Object.assign({}, contextStateInfo), DwMessageSeverity.warning);
                    }
                    // we need to trigger a refresh after the load is complete
                    if (contextStateInfo.isLoading) {
                        contextStateInfo.refreshAfterLoadComplete = true;
                    }
                    else {
                        // update context
                        this.queueContextUpdate(contextName, resolvedContext);
                    }
                    if (contextKey && (loadedContextKey != contextKey || latestContextKey != contextKey)) {
                        DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Update Data value - Context ${contextName} needs to be updated - after context key check - New Context Key = ${contextKey}`, Object.assign({}, contextStateInfo));
                        // // we need to trigger a refresh after the load is complete
                        // if (contextStateInfo.isLoading) {
                        //     contextStateInfo.refreshAfterLoadComplete = true;
                        // } else {
                        //     // update context
                        //     this.queueContextUpdate(contextName, resolvedContext);
                        // }
                        // clear the load complete so it will reload and cause security to wait until it's down to mark everything as loaded
                        //contextStateInfo.loadComplete = false;
                    }
                }
            }
        }
    }
    getContextSubject(keyName) {
        let contextSubject = this.context[keyName];
        if (!contextSubject) {
            contextSubject = new BehaviorSubject(null);
            this.context[keyName] = contextSubject;
            this.contextStateInfo[keyName] = {
                setManually: false,
                loadComplete: false,
                loadStarted: false
            };
            const contextDef = this.dwContextService.getContextDef(keyName);
            const subject = this.createdContextDefDebounceSubject(contextDef);
            if (subject) {
                this.contextDebounceSubjects[keyName] = subject;
            }
            this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
        }
        return contextSubject;
    }
    createdContextDefDebounceSubject(contextDef) {
        // Only use a subject if we have a debounce time (this was it doesn't affect the original flow so reduces risk)
        if (!(contextDef === null || contextDef === void 0 ? void 0 : contextDef.debounceTimeMs)) {
            return null;
        }
        const debounceSubject = {
            addedCount: 0,
            processedCount: 0,
            subject: new Subject()
        };
        const ob = debounceSubject.subject.asObservable()
            .pipe(debounceTime(contextDef.debounceTimeMs))
            .subscribe(resolvedContext => {
            debounceSubject.processedCount += 1;
            this.processContextUpdate(contextDef, resolvedContext);
        });
        return debounceSubject;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        // try {
        //     // Unsubscribe from all context observables
        //     for(let contextName in this.contextDebounceSubjects) {
        //         const subject = this.contextDebounceSubjects[contextName];
        //         subject.subject.unsubscribe();
        //     }
        //     for(let contextName in this.context) {
        //         const subject = this.context[contextName];
        //         subject.unsubscribe();
        //     }
        // } catch(e) {
        // }
    }
    updateContext(contextNames, forceUpdate = false) {
        contextNames = contextNames || [];
        if (contextNames.length == 0) {
            return;
        }
        // Resolve the existing Context
        const resolvedContext = this.dwContextService.getResolvedContext(this.context);
        const previousResolvedContext = deepCopy(this.lastResolvedContext);
        try {
            if (this.lastResolvedContext && areEqual(this.lastResolvedContext, resolvedContext) && !forceUpdate) {
                //console.log('Skipping duplicate resolved context');
                return;
            }
            this.lastResolvedContext = resolvedContext;
        }
        catch (e) {
        }
        for (let contextName of contextNames) {
            this.queueContextUpdate(contextName, resolvedContext, previousResolvedContext, forceUpdate);
        }
    }
    queueContextUpdate(contextName, resolvedContext, previousResolvedContext, forceUpdate = false) {
        const contextDef = this.dwContextService.getContextDef(contextName);
        if (!contextDef) {
            this.dwContextService.logMissingContext(contextName);
            // Still need to say the context is loaded, otherwise the form load will never complete if it has security
            const contextStateInfo = this.contextStateInfo[contextName] = this.contextStateInfo[contextName] || {};
            const contextSubject = this.getContextSubject(contextName);
            contextStateInfo.loadComplete = true;
            contextSubject.next({});
            this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
            return;
        }
        // prevent a context reloading based on it's own change
        if (!forceUpdate && previousResolvedContext && areEqual(previousResolvedContext, resolvedContext, contextName)) {
            return;
        }
        const contextDebounceSubject = this.contextDebounceSubjects[contextName];
        if (contextDebounceSubject) {
            contextDebounceSubject.addedCount += 1;
            //console.log(`Added ${contextDebounceSubject.addedCount}`);
            contextDebounceSubject.subject.next(resolvedContext);
        }
        else {
            this.processContextUpdate(contextDef, resolvedContext);
        }
    }
    processContextUpdate(contextDef, resolvedContext) {
        const contextName = contextDef.contextName;
        const contextStateInfo = this.contextStateInfo[contextName] || {};
        const contextSubject = this.getContextSubject(contextName);
        // Check if context keys have been modified
        var contextKey = "";
        let parentLoadComplete = true;
        if (this.dwContextService.getUpdateContextOnDataChange(contextName)) {
            const contextStateInfo = this.contextStateInfo[this.dataContextName];
            if (!(contextStateInfo === null || contextStateInfo === void 0 ? void 0 : contextStateInfo.loadComplete)) {
                parentLoadComplete = false;
            }
        }
        let loadContextData = false;
        let forceReload = false;
        if (contextDef.getCustomContextKey) {
            contextKey = contextDef.getCustomContextKey(resolvedContext);
            if (contextKey && this.contextKeys[contextName] != contextKey) {
                loadContextData = true;
                this.contextKeys[contextName] = contextKey;
            }
            else {
                if (parentLoadComplete && !contextStateInfo.loadComplete && !contextStateInfo.isLoading) {
                    if (contextKey != contextStateInfo.loadedContextKey) {
                        console.warn(`Context ${contextName} is loaded for previous value, but isLoading = false - this can caused invalid security results since the context data won't be loaded - triggering a reload`, {
                            contextKey: contextKey,
                            contextValue: Object.assign({}, contextSubject.value),
                            contextState: Object.assign({}, contextStateInfo)
                        });
                        loadContextData = true;
                        forceReload = true;
                    }
                    else {
                        contextStateInfo.loadComplete = true;
                        this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
                        return;
                    }
                }
            }
        }
        else if (contextDef.getCustomContextFunction) {
            loadContextData = true;
        }
        else if (!contextSubject.value) {
            loadContextData = true;
        }
        if (!loadContextData) {
            return;
        }
        if (contextName.indexOf('Status_Details') >= 0) {
            DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Reloading Context ${contextName} - Context Key = ${contextKey}`, Object.assign({}, contextStateInfo));
        }
        // Check if we're already loading
        if (contextStateInfo.isLoading && false) {
            contextStateInfo.refreshAfterLoadComplete = true;
            contextStateInfo.refreshResolvedContext = resolvedContext;
            return;
        }
        contextStateInfo.refreshResolvedContext = resolvedContext;
        contextStateInfo.loadStarted = true;
        contextStateInfo.isLoading = true;
        contextStateInfo.loadingStartedCount = (contextStateInfo.loadingStartedCount || 0) + 1;
        this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
        this.subscriptions.push(this.dwContextService.getContext(contextName, resolvedContext)
            .subscribe(resultContext => {
            contextStateInfo.isLoading = false;
            contextStateInfo.loadingCompletedCount = (contextStateInfo.loadingCompletedCount || 0) + 1;
            if (contextName.indexOf('Status_Details') >= 0) {
                DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Loaded Context ${contextName} - Context Key = ${contextKey} (loading context key : ${contextStateInfo.loadedContextKey} - parent load complete = ${parentLoadComplete}  Load complete = ${contextStateInfo.loadComplete}`, Object.assign({}, contextStateInfo), DwMessageSeverity.warning);
            }
            if (!contextStateInfo.loadComplete && contextSubject.value && areEqual(contextSubject.value, resultContext)) {
                this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
                if (forceReload) {
                    // If the reload was forced, then let's use this value
                }
                else {
                    // Load error, but then allow it to complete
                    DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Loaded Context (forced) but not result ${contextName} - Context Key = ${contextKey} (loading context key : ${contextStateInfo.loadedContextKey} - parent load complete = ${parentLoadComplete}  Load complete = ${contextStateInfo.loadComplete}`, {
                        contextKey: contextKey,
                        contextValue: Object.assign({}, contextSubject.value),
                        contextState: Object.assign({}, contextStateInfo),
                        resolvedContext: resolvedContext
                    }, DwMessageSeverity.warning);
                    return;
                }
            }
            contextStateInfo.loadedContextKey = contextKey;
            contextSubject.next(resultContext);
            this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
            // reload context again
            if (contextStateInfo.refreshAfterLoadComplete) {
                contextStateInfo.refreshAfterLoadComplete = false;
                this.queueContextUpdate(contextName, contextStateInfo.refreshResolvedContext);
                return;
            }
            // Wait until after the refresh to set the load complete
            contextStateInfo.loadComplete = parentLoadComplete;
            this.contextStateInfoSubject.next(Object.assign({}, this.contextStateInfo));
            if (contextName.indexOf('Status_Details') >= 0 && parentLoadComplete) {
                DwFormDebugService.debugMessage(null, 'DwContextConfigurationBase', `Loaded Context ${contextName} COMPLETE!!! - Context Key = ${contextKey} - parent load complete = ${parentLoadComplete}  Load complete = ${contextStateInfo.loadComplete}`, Object.assign({}, contextStateInfo));
            }
        }));
    }
}
DwContextConfigurableBaseComponent.ɵfac = function DwContextConfigurableBaseComponent_Factory(t) { return new (t || DwContextConfigurableBaseComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken)); };
DwContextConfigurableBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwContextConfigurableBaseComponent, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
DwContextConfigurableBaseComponent.ctorParameters = () => [
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwContextService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];

const DwReportingServiceToken = new InjectionToken("DwReportingService");
class DwReportingService {
    constructor(http, configService, eventsService) {
        //this.apiRoot = configService.coreConfig.apiRoot;
        this.http = http;
        this.eventsService = eventsService;
        this.QueryHelper = new DwQueryHelper();
        this.apiRoot = configService.getApiRoot('reporting');
    }
    buildUrl(methodName) {
        let url = `${this.apiRoot}${methodName}`;
        return url;
    }
    convertHtmlToPdf(partialHtml, pdfTemplateId, fileName, renderMultiplePages, styleSheetUrlOverride) {
        let url = `${this.apiRoot}/reporting/pdf`;
        let pdfRequest = {
            PartialHtml: partialHtml,
            PdfTempalteId: pdfTemplateId | 1,
            PdfFileName: fileName,
            RenderMultiplePages: renderMultiplePages,
            StyleSheetUrl: styleSheetUrlOverride || this.determineStylesheetUrl()
        };
        return this.http.post(url, pdfRequest)
            .pipe(map((httpResult) => {
            return httpResult;
        }));
    }
    determineStylesheetUrl() {
        var _a;
        const stylesheetLinks = document.getElementsByTagName('link');
        let stylesheetUrl = '';
        for (let link of stylesheetLinks) {
            if (link.rel == 'stylesheet') {
                if (((_a = link.href) === null || _a === void 0 ? void 0 : _a.indexOf('styles.')) >= 0) {
                    stylesheetUrl = link.href;
                }
            }
        }
        return stylesheetUrl;
    }
    saveHtmlToPdf(partialHtml, pdfTemplateId, fileName) {
        return this.convertHtmlToPdf(partialHtml, pdfTemplateId, fileName)
            .pipe(map((result => {
            this.saveExportAsFile(result, fileName);
        })));
    }
    saveExportAsFile(exportResult, fileName) {
        // Convert string to Base64 Data
        var binaryData = this.convertBase64(exportResult.Base64Data);
        // Create a new blob with the binary data
        var file = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        fileName = exportResult.FileName || fileName || "Export.xls";
        saveAs(file, fileName);
    }
    convertBase64(base64Data) {
        var byteCharacters = atob(base64Data);
        // Each character's code point (charCode) will be the value of the byte. We can create an array of byte values by applying this using the .charCodeAt method for each character in the string.
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        // You can convert this array of byte values into a real typed byte array by passing it to the Uint8Array constructor.
        var byteArray = new Uint8Array(byteNumbers);
        return byteArray;
    }
}
DwReportingService.ɵfac = function DwReportingService_Factory(t) { return new (t || DwReportingService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwEventService)); };
DwReportingService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwReportingService, factory: DwReportingService.ɵfac });
DwReportingService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwEventService }
];

class DwActionExecutionService {
    constructor(injector, configRegistryService, modalService, serviceExecutionUtil) {
        this.injector = injector;
        this.configRegistryService = configRegistryService;
        this.modalService = modalService;
        this.serviceExecutionUtil = serviceExecutionUtil;
    }
    executeActionBase(actionKey, actionState, actionMethodName = 'handleAction', ignoreMissing = false) {
        const handler = this.getCommandHandler(actionKey);
        if (!handler) {
            const errorMsg = `Action hanlder not found for Action Key : ${actionKey}`;
            console.error(errorMsg);
            return throwError(errorMsg);
        }
        return this.fireAction(handler, actionState, actionMethodName, ignoreMissing);
    }
    executeActionDirectBase(actionKey, actionState, actionMethodName, ignoreMissing = true) {
        const handler = this.getCommandHandler(actionKey);
        if (!handler) {
            const errorMsg = `Action hanlder not found for Action Key : ${actionKey}`;
            console.error(errorMsg);
            throw new Error(errorMsg);
        }
        return this.fireMethodDirect(handler, actionState, actionMethodName, ignoreMissing);
    }
    executeAction(actionKey, actionState) {
        return this.executeActionBase(actionKey, actionState);
    }
    executeActionPreference(actionPreference, actionState) {
        const confirmConfig = this.getActionConfirmConfig(actionPreference, actionState);
        return this.modalService.showConfirmDialog(confirmConfig)
            .pipe(flatMap(confirmResult => {
            if (!confirmResult) {
                return of({
                    success: false
                });
            }
            return this.executeActionBase(actionPreference.actionKey, actionState);
        }));
    }
    initAction(actionKey, actionState) {
        return this.executeActionBase(actionKey, actionState, 'initAction', true);
    }
    callActionMethod(actionKey, actionState, actionMethodName) {
        return this.executeActionBase(actionKey, actionState, actionMethodName, true);
    }
    getActionConfirmConfig(actionPreference, actionState) {
        const result = this.executeActionDirectBase(actionPreference.actionKey, actionState, 'showConfirmDialog', true);
        if (result === null || result === void 0 ? void 0 : result.overrideConfig) {
            return result.resultConfig;
        }
        return actionPreference.confirmConfig;
    }
    fireAction(handlerRegistration, actionState, actionMethodName = 'handleAction', ignoreMissing = false) {
        // Create the service using DI
        const instance = this.injector.get(handlerRegistration.actionComponent);
        if (!instance) {
            const errorMsg = `Error creating instance of Action Handler item ${handlerRegistration.parentItemName} and Action Key : ${handlerRegistration.keyName}`;
            console.error(errorMsg);
            return throwError(errorMsg);
        }
        // Get a reference to the function
        const func = instance[actionMethodName];
        if (!func) {
            if (ignoreMissing) {
                return of(null);
            }
            const errorMsg = `Action Hanlder missing ${actionMethodName} method item ${handlerRegistration.parentItemName} and Action Key : ${handlerRegistration.keyName}`;
            console.error(errorMsg);
            return throwError(errorMsg);
        }
        // Bind the function to the instance (so the bound function can reference this - otherwise it's null)
        const boundFunc = func.bind(instance);
        // Call the bound function
        try {
            const result = boundFunc(actionState, handlerRegistration.configData);
            if (!result || !result.subscribe) {
                return of(result);
            }
            return result;
        }
        catch (error) {
            return throwError(error);
        }
    }
    fireMethodDirect(handlerRegistration, actionState, actionMethodName = 'handleAction', ignoreMissing = false) {
        // Create the service using DI
        const instance = this.injector.get(handlerRegistration.actionComponent);
        if (!instance) {
            const errorMsg = `Error creating instance of Action Handler item ${handlerRegistration.parentItemName} and Action Key : ${handlerRegistration.keyName}`;
            console.error(errorMsg);
            throw new Error(errorMsg);
        }
        // Get a reference to the function
        const func = instance[actionMethodName];
        if (!func) {
            if (ignoreMissing) {
                return null;
            }
            const errorMsg = `Action Hanlder missing ${actionMethodName} method item ${handlerRegistration.parentItemName} and Action Key : ${handlerRegistration.keyName}`;
            console.error(errorMsg);
            throw new Error(errorMsg);
        }
        // Bind the function to the instance (so the bound function can reference this - otherwise it's null)
        const boundFunc = func.bind(instance);
        // Call the bound function
        const result = boundFunc(actionState, handlerRegistration.configData);
        return result;
    }
    getCommandHandler(actionKey) {
        return this.configRegistryService.getRegisteredItem(DwUiRegistryType.action, actionKey);
    }
}
DwActionExecutionService.ɵfac = function DwActionExecutionService_Factory(t) { return new (t || DwActionExecutionService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwServiceExecutionUtil)); };
DwActionExecutionService.ɵprov = ɵɵdefineInjectable({ factory: function DwActionExecutionService_Factory() { return new DwActionExecutionService(ɵɵinject(INJECTOR), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwModalService), ɵɵinject(DwServiceExecutionUtil)); }, token: DwActionExecutionService, providedIn: "root" });
DwActionExecutionService.ctorParameters = () => [
    { type: Injector },
    { type: DwUiConfigRegistryService },
    { type: DwModalService },
    { type: DwServiceExecutionUtil }
];

class DwInMemoryDataSource extends DwDataSourceBase {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.allowsPaging = false;
        this.loadItemLookupItemsOnSave = true;
        this.isSingleItem = false;
        this.nextKey = -1;
        this.dataSubject = new BehaviorSubject([]);
    }
    get currentData() {
        return this.dataSubject.value;
    }
    dataChanged() {
        return this.dataSubject.asObservable();
    }
    setupDataSource(data, item) {
        if (!Array.isArray(data)) {
            data = [data];
        }
        this.dataSubject.next(data);
        this.item = item;
        this.metaDataService.getMetaData(item)
            .subscribe((itemMetaData) => this.itemMetaData = itemMetaData);
    }
    requestData(request) {
        const nonDeletedItems = this.getNonDeletedItems();
        const results = {
            pageInfo: {
                currentPageNo: 1,
                totalPageCount: 1,
                currentPageSize: nonDeletedItems.length | 50,
                totalRecordCount: nonDeletedItems.length
            },
            data: nonDeletedItems
        };
        return of(results);
    }
    exportData(fileName) {
        throw new Error("Not Implemented");
    }
    loadItem(keyValues, loadOptions) {
        if (typeof keyValues === 'string' && keyValues) {
            keyValues = parseInt(keyValues);
        }
        if (typeof keyValues === 'number') {
            return of(this.findItem(keyValues));
        }
        return of(null);
    }
    saveItem(item, saveOptions) {
        if (!this.itemMetaData) {
            console.error('MetaData was not initialized so can identify key');
            return of(null);
        }
        let ob = of(item);
        if (this.loadItemLookupItemsOnSave) {
            ob = this.updateItemLookupValues(item);
        }
        return ob
            .pipe(map((item) => {
            this.updateItemInternal(item);
            return item;
        }));
    }
    saveAllItems(items, saveOptions) {
        const obs = [];
        for (const item of items) {
            obs.push(this.saveItem(item));
        }
        return combineLatest(obs);
    }
    updateItemInternal(item) {
        const data = this.dataSubject.value;
        const keyValue = item[this.itemMetaData.KeyName];
        if (!keyValue) {
            // If we don't have a key, use a unique negative value so we identify it going forward
            //    When this is actually saved, it will be populated with the correct PK
            item[this.itemMetaData.KeyName] = this.getNextKeyValue();
        }
        let existingItem = this.findItem(item[this.itemMetaData.KeyName]);
        if (existingItem) {
            // Replace the existing item
            const index = data.indexOf(existingItem);
            data[index] = item;
        }
        else {
            data.push(item);
        }
        this.dataSubject.next(data);
    }
    getNextKeyValue() {
        let nextKey = 0;
        for (const item of this.dataSubject.value) {
            const keyValue = item[this.itemMetaData.KeyName];
            if (keyValue < nextKey) {
                nextKey = keyValue;
            }
        }
        this.nextKey = nextKey - 1;
        return this.nextKey;
    }
    updateCachedItem(dataItem) {
    }
    deleteItem(item, deleteOptions) {
        let existingItem = this.findItem(item[this.itemMetaData.KeyName]);
        const data = this.dataSubject.value;
        if (existingItem) {
            // Replace the existing item
            const index = data.indexOf(existingItem);
            existingItem._isDeleted = true;
        }
        this.dataSubject.next(data);
        return of(null);
    }
    findItem(keyValue) {
        const data = this.dataSubject.value;
        if (!data || data.length === 0) {
            return null;
        }
        if (!this.itemMetaData) {
            console.error('MetaData was not initialized so can identify key');
            return null;
        }
        const keyName = this.itemMetaData.KeyName;
        if (!keyName) {
            console.error('Item does not contain a key name');
        }
        return data.find(d => d[keyName] === keyValue);
    }
    getNonDeletedItems() {
        const data = this.dataSubject.value;
        return data.filter(item => !item._isDeleted);
    }
    updateItemLookupValues(item) {
        const obs = [];
        // Find all lookup properties
        for (const attr of this.itemMetaData.Attributes.filter(a => a.IsLookup && a.MetaDataLookupId)) {
            const lookupValue = item[attr.AttributeName];
            if (lookupValue) {
                obs.push(this.metaDataService.getLookupDisplay(attr.MetaDataLookupId, lookupValue)
                    .pipe(tap((display) => {
                    if (display) {
                        item[`${attr.AttributeName}Display`] = display;
                    }
                })));
            }
        }
        if (obs.length === 0) {
            return of(item);
        }
        return combineLatest(obs, () => {
            return item;
        });
    }
    createBlankItem(defaults, addContext) {
        let newItem = {
            _itemName: this.itemMetaData.UniqueItemName,
            _keyName: this.itemMetaData.KeyName
        };
        if (addContext) {
            newItem = Object.assign(Object.assign({}, newItem), addContext);
        }
        if (defaults) {
            newItem = Object.assign(Object.assign({}, newItem), defaults);
        }
        return of(newItem);
    }
}

var DwDecoratorType;
(function (DwDecoratorType) {
    DwDecoratorType["component"] = "component";
    DwDecoratorType["service"] = "service";
})(DwDecoratorType || (DwDecoratorType = {}));

const actionRegList = [];
class DwActionRegistration {
    RegisterAction(actionDef, actionComponent, forwardRef) {
        let actionRef = Object.assign(Object.assign({}, actionDef), { keyName: actionDef.keyName || actionDef.display, isGlobal: actionDef.isGlobal || false, actionComponent: actionComponent, decoratorType: actionDef.decoratorType || DwDecoratorType.service });
        //console.log(`Registering Action ${actionDef.keyName}`);
        if (actionComponent == null && forwardRef) {
            //console.log(`Using Forward Ref for action ${actionDef.keyName}`);
            const type = resolveForwardRef(forwardRef);
            if (type) {
                actionRef.actionComponent = type;
            }
        }
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerItem(DwUiRegistryType.action, actionRef);
        return actionRef;
    }
}
function DwAction(actionDef) {
    return function (constructor) {
        const registra = new DwActionRegistration();
        registra.RegisterAction(actionDef, constructor);
        // DwActionRegistration.
        // let actionRef: DwActionHandlerRegistration<ActionConfigType> = {
        //     ...actionDef,
        //     keyName: actionDef.keyName || actionDef.display,
        //     isGlobal: actionDef.isGlobal || false,
        //     actionComponent: <Type<any>>constructor,
        //     decoratorType: actionDef.decoratorType || DwDecoratorType.service
        // };
        // let uiConfigRegistyService = new DwUiConfigRegistryService();
        // uiConfigRegistyService.registerItem(DwUiRegistryType.action, actionRef);
    };
}
function DwActionFunc(actionDef, actionComponent, forwardRef) {
    const registration = new DwActionRegistration();
    return registration.RegisterAction(actionDef, actionComponent, forwardRef);
    // let actionRef: DwActionHandlerRegistration<ActionConfigType> = {
    //     ...actionDef,
    //     keyName: actionDef.keyName || actionDef.display,
    //     isGlobal: actionDef.isGlobal || false,
    //     actionComponent: actionComponent,
    //     decoratorType: actionDef.decoratorType || DwDecoratorType.service
    // };
    // if (actionComponent == null && forwardRef) {
    //     console.log(`Using Forward Ref for action ${actionDef.keyName}`);
    //     const type = resolveForwardRef(forwardRef);
    //     if (type) {
    //         actionRef.actionComponent = type;
    //     }
    // }
    // let uiConfigRegistyService = new DwUiConfigRegistryService();
    // uiConfigRegistyService.registerItem(DwUiRegistryType.action, actionRef);
}

class DwActionConfigBaseComponent {
    constructor() {
        this.subscriptions = [];
        this.actionConfigFG = new FormGroup({});
    }
    ngOnInit() {
    }
    setupComplete() {
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        if (this.actionConfigFG) {
            for (const controlName in this.actionConfigFG.controls) {
                const fc = this.actionConfigFG.controls[controlName];
                fc.disable({ emitEvent: false });
            }
        }
    }
    setupForm() {
        this.clearAllFormValidators();
        this.actionConfigFG.reset({});
        this.addControls();
    }
    addControl(controlName, validatorVn = null, initialValue) {
        let control = this.actionConfigFG.get(controlName);
        if (!control) {
            control = new FormControl();
            this.actionConfigFG.addControl(controlName, control);
        }
        if (initialValue) {
            control.setValue(initialValue);
        }
        control.validator = validatorVn;
        control.enable();
        return control;
    }
    clearAllFormValidators() {
        for (const controlName in this.actionConfigFG.controls) {
            const fc = this.actionConfigFG.controls[controlName];
            if (fc.validator) {
                fc.validator = null;
                fc.updateValueAndValidity();
            }
        }
    }
}
DwActionConfigBaseComponent.ɵfac = function DwActionConfigBaseComponent_Factory(t) { return new (t || DwActionConfigBaseComponent)(); };
DwActionConfigBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwActionConfigBaseComponent, inputs: { actionConfigFG: ["actionConfigFormGroup", "actionConfigFG"], actionConfig: "actionConfig", configContext: "configContext" } });
DwActionConfigBaseComponent.ctorParameters = () => [];
DwActionConfigBaseComponent.propDecorators = {
    actionConfigFG: [{ type: Input, args: ['actionConfigFormGroup',] }],
    actionConfig: [{ type: Input }],
    configContext: [{ type: Input }]
};

function convertAdditionalParams(additionalParams) {
    const returnParams = {};
    additionalParams = additionalParams || {};
    // Convert menu params to a DwExpressionReference if they are not
    for (const paramName in additionalParams) {
        if (!additionalParams.hasOwnProperty(paramName)) {
            continue;
        }
        const param = additionalParams[paramName];
        let paramRef;
        paramRef = param;
        if (typeof param == 'string') {
            paramRef = {
                referenceType: DwExpressionReferenceType.item,
                attrName: param,
            };
        }
        else {
            if (!paramRef) {
                paramRef = {
                    referenceType: DwExpressionReferenceType.item,
                    attrName: '',
                };
            }
        }
        returnParams[paramName] = paramRef;
    }
    return returnParams;
}

class DwRouteActionInternalLinkConfigComponent extends DwActionConfigBaseComponent {
    constructor(dwMenuService, dwMenuBuilderService, dwMetaDataService) {
        super();
        this.dwMenuService = dwMenuService;
        this.dwMenuBuilderService = dwMenuBuilderService;
        this.dwMetaDataService = dwMetaDataService;
        this.showViewKey = false;
        this.additionalParams = {};
    }
    setupComplete() {
        var _a;
        this.internalLinkConfig = this.actionConfigFG.getRawValue();
        this.setupMetaData();
        // Setup menu
        if (((_a = this.menu) === null || _a === void 0 ? void 0 : _a.menuKey) != this.internalLinkConfig.menuKey) {
            this.menu = this.dwMenuService.getMenuByKey(this.internalLinkConfig.menuKey);
            this.setupMenuParams();
        }
        this.subscriptions.push(this.actionConfigFG.valueChanges.pipe(debounceTime(50))
            .subscribe(internalLinkConfig => {
            var _a;
            this.internalLinkConfig = internalLinkConfig;
            if (((_a = this.menu) === null || _a === void 0 ? void 0 : _a.menuKey) != this.internalLinkConfig.menuKey) {
                this.menu = this.dwMenuService.getMenuByKey(this.internalLinkConfig.menuKey);
                this.internalLinkConfig.additionalParams = {};
                this.setupMenuParams();
            }
            this.setupValidation();
        }));
    }
    addControls() {
        var _a;
        this.useUrlFC = this.addControl('useUrl', null, false);
        this.urlFC = this.addControl('url', Validators.required);
        this.menuKeyFC = this.addControl('menuKey', Validators.required);
        this.keyValueAttrNameFC = this.addControl('keyValueAttrName');
        this.addControl('itemName', null, (_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName);
        this.addControl('viewKey');
        this.addControl('passDataAttributes');
        this.addControl('additionalQueryString');
        this.addControl('openInNewWindow');
        this.addControl('newWindowTarget');
        this.additionalParamsFC = this.addControl('additionalParams');
        // this.actionConfigFG.setValidators(this.customValidation())
        this.setupValidation();
    }
    setupMetaData() {
        var _a;
        if (!((_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName)) {
            this.showKeyValue = false;
            return;
        }
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes;
            this.setDefaultMenuParams();
        });
    }
    setupValidation() {
        const useUrl = this.useUrlFC.value === true;
        if (useUrl) {
            if (this.urlFC.disabled)
                this.urlFC.enable();
            if (this.urlFC.enabled)
                this.menuKeyFC.disable();
        }
        else {
            if (this.urlFC.enabled)
                this.urlFC.disable();
            if (this.urlFC.disabled)
                this.menuKeyFC.enable();
        }
        if (!useUrl && this.showKeyValue && this.attributes) {
            this.keyValueAttrNameFC.setValidators(Validators.required);
        }
        else {
            this.keyValueAttrNameFC.clearValidators();
        }
    }
    conditionalRequired(requireIfUseUrl) {
        const useUrlFC = this.useUrlFC;
        return (control) => {
            const useUrl = this.useUrlFC.value === true;
            if (requireIfUseUrl !== useUrl) {
                return;
            }
            if (control.value) {
                return;
            }
            return {
                required: true
            };
        };
    }
    updateAdditionalParams() {
        this.additionalParamsFC.setValue(this.additionalParams);
    }
    setupMenuParams() {
        var _a, _b, _c, _d, _e, _f;
        this.showAdditionalParams = false;
        if ((_a = this.menu) === null || _a === void 0 ? void 0 : _a.url) {
            // No longer showing since using the additional params
            this.showKeyValue = false; // (this.menu?.url?.indexOf(':') >= 0);
            this.menuParams = this.dwMenuBuilderService.getUrlParams(this.menu.url);
            this.showAdditionalParams = this.menuParams.length > 0;
            if (this.showAdditionalParams) {
                // Convert params from string to expression references (so we can allow context values)
                // One time conversion for additionalParams that were just strings
                this.additionalParams = convertAdditionalParams((_b = this.internalLinkConfig) === null || _b === void 0 ? void 0 : _b.additionalParams);
                const areParamsBlank = !this.additionalParams || isEmptyObject(this.additionalParams);
                if (areParamsBlank) {
                    for (const paramName of this.menuParams) {
                        this.additionalParams[paramName] = this.additionalParams[paramName] || { referenceType: DwExpressionReferenceType.item };
                    }
                    if ((_c = this.internalLinkConfig) === null || _c === void 0 ? void 0 : _c.keyValueAttrName) {
                        // Set last param to this value
                        const lastParamName = this.menuParams[this.menuParams.length - 1];
                        // Only set if it is not set currently
                        const lastExprRef = this.additionalParams[lastParamName];
                        if (!lastExprRef.attrName) {
                            const paramRef = {
                                referenceType: DwExpressionReferenceType.item,
                                attrName: (_d = this.internalLinkConfig) === null || _d === void 0 ? void 0 : _d.keyValueAttrName,
                            };
                            this.additionalParams[lastParamName] = paramRef;
                        }
                    }
                    this.setDefaultMenuParams();
                }
                this.updateAdditionalParams();
            }
        }
        if (((_f = (_e = this.menu) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.metaDataActionType) == DwMenuActionType.list) {
            this.showViewKey = true;
        }
        else {
            this.showViewKey = false;
        }
    }
    setDefaultMenuParams() {
        if (!this.additionalParams || !this.attributes || !this.menuParams) {
            return;
        }
        for (const paramName of this.menuParams) {
            const exprRef = this.additionalParams[paramName];
            if (!(exprRef === null || exprRef === void 0 ? void 0 : exprRef.attrName)) {
                const matchingAttr = this.attributes.find(a => a.AttributeName == paramName);
                if (matchingAttr) {
                    const paramRef = {
                        referenceType: DwExpressionReferenceType.item,
                        attrName: matchingAttr.AttributeName,
                    };
                    this.additionalParams[paramName] = paramRef;
                }
            }
        }
    }
}
DwRouteActionInternalLinkConfigComponent.ɵfac = function DwRouteActionInternalLinkConfigComponent_Factory(t) { return new (t || DwRouteActionInternalLinkConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMenuService), ɵngcc0.ɵɵdirectiveInject(DwMenuBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwRouteActionInternalLinkConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteActionInternalLinkConfigComponent, selectors: [["dw-route-action-internal-link-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "useUrl"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["type", "text", "formControlName", "url", 1, "form-control"], ["formControlName", "menuKey"], ["type", "text", "formControlName", "viewKey", 1, "form-control"], ["formControlName", "keyValueAttrName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["dwRow", "", 4, "ngIf"], ["title", "Add any additional query string parameters seperated by &.  Use fields like [FieldName] or [globals.name]", 1, "fa", "fa-info-circle"], ["type", "text", "formControlName", "additionalQueryString", 1, "form-control"], ["formControlName", "openInNewWindow"], ["type", "text", "formControlName", "newWindowTarget", 1, "form-control"], [3, "ngValue"], ["dwRow", "", 4, "ngFor", "ngForOf"], ["dwCol", "12", 1, "expr-column-full"], [3, "ngModel", "ngModelOptions", "contextNames", "item", "queryMeaning", "ngModelChange"], ["optionLabel", "AttributeDisplay", "optionValue", "AttributeName", "formControlName", "passDataAttributes", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"]], template: function DwRouteActionInternalLinkConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteActionInternalLinkConfigComponent_div_0_Template, 47, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor, DwSelectRouteComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwExpressionReferenceControlComponent, ɵngcc3.NgModel, ɵngcc12.MultiSelect]; }, pipes: function () { return [DwAddSpacesPipe]; }, encapsulation: 2 });
DwRouteActionInternalLinkConfigComponent.ctorParameters = () => [
    { type: DwMenuService },
    { type: DwMenuBuilderService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

class DwTemplateUtilService {
    constructor(dwDataFormatService, uiMetaDataConfig) {
        this.dwDataFormatService = dwDataFormatService;
        this.uiMetaDataConfig = uiMetaDataConfig;
    }
    processTemplate(template, data, context, global, options) {
        if (!template) {
            return '';
        }
        if (!options) {
            options = {
                blankReplacementValue: 'None'
            };
        }
        if (typeof (template) == 'string') {
            template = this.parseTemplate(template);
        }
        let processedTemplate = `${template.template}`;
        for (let placeHolder of template.placeHolders) {
            const finalValue = this.getFormattedValue(placeHolder, data, context, global, options);
            processedTemplate = processedTemplate.replace(placeHolder.tagName, finalValue);
        }
        return processedTemplate;
    }
    getFormattedValue(placeHolder, data, context, global, options) {
        const value = this.getDataValue(placeHolder, data, context, global);
        if (!value && value !== false && value !== 0) {
            return options.blankReplacementValue;
        }
        // If we don't have metadata, then we can't format the value
        if (!options.queryMetaData) {
            return value;
        }
        const formatType = this.getFormatType(placeHolder, options.queryMetaData);
        if (formatType == DwFormatTypes.text) {
            return value;
        }
        const attr = options.queryMetaData.Attributes.find(a => a.AttributeName == placeHolder.attrName || a.DisplayAttributeName == placeHolder.attrName);
        const formatOptions = {
            formatType: formatType,
            missingDataText: options.blankReplacementValue,
            use24HourTime: this.use24HourTime(),
            useGmtDateTime: this.useGmtDateTime(attr)
        };
        return this.dwDataFormatService.formatValue(value, formatOptions);
    }
    useGmtDateTime(attr) {
        var _a;
        return ((_a = attr === null || attr === void 0 ? void 0 : attr.Attribute) === null || _a === void 0 ? void 0 : _a.UseGmtDateTime) || this.uiMetaDataConfig.useGmtDateTime;
    }
    use24HourTime() {
        return this.uiMetaDataConfig.use24HourTime;
    }
    getFormatType(placeHolder, queryMetaData) {
        if (placeHolder.tagType == DwTagType.data) {
            const attr = queryMetaData.Attributes.find(a => a.AttributeName == placeHolder.attrName || a.DisplayAttributeName == placeHolder.attrName);
            if (attr) {
                switch (attr.AttributeType) {
                    case DwAttributeType.Date:
                        return DwFormatTypes.date;
                    case DwAttributeType.DateTime:
                        return DwFormatTypes.datetime;
                    case DwAttributeType.Money:
                        return DwFormatTypes.currency;
                    case DwAttributeType.YesNo:
                        return DwFormatTypes.yesNo;
                    case DwAttributeType.Percentage:
                        return DwFormatTypes.percent;
                }
            }
            return DwFormatTypes.text;
        }
    }
    getDataValue(placeHolder, data, context, global) {
        let parentData = null;
        switch (placeHolder.tagType) {
            case DwTagType.data:
                parentData = data;
                break;
            case DwTagType.global:
                parentData = global;
                break;
            case DwTagType.context:
                if (!context) {
                    context = {};
                }
                parentData = context[placeHolder.path];
                break;
        }
        if (!parentData) {
            return null;
        }
        const value = parentData[placeHolder.attrName];
        return value;
    }
    parseTemplate(templateText) {
        let index = 0;
        const template = {
            template: templateText,
            placeHolders: []
        };
        if (!templateText) {
            return template;
        }
        while (index >= 0) {
            const parseResult = this.parseNextField(templateText, index);
            if (parseResult.placeHolder) {
                template.placeHolders.push(parseResult.placeHolder);
            }
            index = parseResult.nextIndex;
        }
        return template;
    }
    parseNextField(template, startingIndex) {
        template = template || '';
        const nextIndex = template.indexOf('[', startingIndex);
        if (nextIndex == -1) {
            return { nextIndex: -1 };
        }
        const endingIndex = template.indexOf(']', nextIndex);
        if (endingIndex == -1) {
            return { nextIndex: -1 };
        }
        // Parse full tage name
        const tagName = template.substring(nextIndex, endingIndex + 1);
        const tagContent = tagName.substring(1, tagName.length - 1);
        const parts = tagContent.split('.');
        if (parts[0] === 'data' && parts.length === 2) {
            return {
                nextIndex: endingIndex,
                placeHolder: {
                    tagType: DwTagType.data,
                    tagName: tagName,
                    attrName: parts[1]
                }
            };
        }
        if (parts[0] === 'context' && parts.length === 3) {
            return {
                nextIndex: endingIndex,
                placeHolder: {
                    tagType: DwTagType.context,
                    tagName: tagName,
                    path: parts[1],
                    attrName: parts[2]
                }
            };
        }
        if ((parts[0] === 'global' || parts[0] === 'globals') && parts.length === 2) {
            return {
                nextIndex: endingIndex,
                placeHolder: {
                    tagType: DwTagType.global,
                    tagName: tagName,
                    attrName: parts[1]
                }
            };
        }
        return {
            nextIndex: endingIndex,
            placeHolder: {
                tagType: DwTagType.data,
                tagName: tagName,
                attrName: parts[0]
            }
        };
    }
}
DwTemplateUtilService.ɵfac = function DwTemplateUtilService_Factory(t) { return new (t || DwTemplateUtilService)(ɵngcc0.ɵɵinject(DwDataFormatService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwTemplateUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwTemplateUtilService_Factory() { return new DwTemplateUtilService(ɵɵinject(DwDataFormatService), ɵɵinject(DwUIMetaDataConfigToken)); }, token: DwTemplateUtilService, providedIn: "root" });
DwTemplateUtilService.ctorParameters = () => [
    { type: DwDataFormatService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
class DwTemplate {
}
class DwParseResult {
}
class DwFieldPlaceholder {
}
var DwTagType;
(function (DwTagType) {
    DwTagType["data"] = "data";
    DwTagType["context"] = "context";
    DwTagType["global"] = "global";
})(DwTagType || (DwTagType = {}));
class DwTemplateOptions {
    constructor() {
        this.blankReplacementValue = 'None';
    }
}

class DwRouteActionHelperService {
    constructor(configService, dwExpressionService, dwTemplateUtil) {
        this.configService = configService;
        this.dwExpressionService = dwExpressionService;
        this.dwTemplateUtil = dwTemplateUtil;
    }
    processUrlParameters(url, actionState, keyValueAttrName, itemName = "", currentMenuParams, additionalParams) {
        // Find any data items to replace
        const data = actionState.data;
        if (data) {
            // Deprecated -  Keeping to preserve existing menu configuration
            if (keyValueAttrName && !additionalParams) {
                const urlKeyValue = data[keyValueAttrName];
                const paramName = getMenuActionParamName(itemName);
                url = url.replace(paramName, urlKeyValue);
            }
            // New method of passing any number of url parameteres
            if (additionalParams) {
                for (const paramName in additionalParams) {
                    const paramData = additionalParams[paramName];
                    let paramValue;
                    if (typeof (paramData) == 'string') {
                        paramValue = data[paramData];
                    }
                    else {
                        const exprRef = paramData;
                        paramValue = this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(exprRef, data, actionState.context);
                    }
                    if (paramValue) {
                        url = url.replace(`:${paramName}`, paramValue);
                    }
                }
            }
            for (const attr in actionState.data) {
                if (data.hasOwnProperty(attr)) {
                    const value = data[attr];
                    const key = `[${attr}]`;
                    url = url.replace(key, value);
                    url = url.replace(key.toLocaleLowerCase(), value);
                }
            }
            // for (const attr in actionState.data) {
            //     if (data.hasOwnProperty(attr)) {
            //         const value = data[attr];
            //         const key = `[${attr}]`;
            //         url = url.replace(key, value);
            //         url = url.replace(key.toLocaleLowerCase(), value);
            //     }
            // }
        }
        // Always replace menu parameters
        if (currentMenuParams === null || currentMenuParams === void 0 ? void 0 : currentMenuParams.hasParams) {
            for (const paramData of currentMenuParams.getAllParams()) {
                url = url.replace(`:${paramData.paramName}`, paramData.paramValue);
            }
        }
        // Alwasys replace global attributes
        // for (const globalAttr in this.configService.coreConfig.globals) {
        //     const paramName = `[globals.${globalAttr}]`;
        //     const paramValue = this.configService.coreConfig.globals[globalAttr];
        //     url = url.replace(paramName, paramValue);
        // }
        // if we have context, then we need to replace them
        if (url.indexOf('[') >= 0) {
            const template = this.dwTemplateUtil.parseTemplate(url);
            const options = {
                performLookup: false,
                blankReplacementValue: '[Missing]',
            };
            url = this.dwTemplateUtil.processTemplate(template, data, actionState.context, this.configService.coreConfig.globals, options);
        }
        return url;
    }
}
DwRouteActionHelperService.ɵfac = function DwRouteActionHelperService_Factory(t) { return new (t || DwRouteActionHelperService)(ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwTemplateUtilService)); };
DwRouteActionHelperService.ɵprov = ɵɵdefineInjectable({ factory: function DwRouteActionHelperService_Factory() { return new DwRouteActionHelperService(ɵɵinject(DwConfigServiceToken), ɵɵinject(DwExpressionService), ɵɵinject(DwTemplateUtilService)); }, token: DwRouteActionHelperService, providedIn: "root" });
DwRouteActionHelperService.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwExpressionService },
    { type: DwTemplateUtilService }
];

var DwRouteActionKeys;
(function (DwRouteActionKeys) {
    DwRouteActionKeys["internal"] = "dwInternalLinkAction";
    DwRouteActionKeys["external"] = "dwExternalLinkAction";
    DwRouteActionKeys["openItemModal"] = "dwOpenItemModal";
})(DwRouteActionKeys || (DwRouteActionKeys = {}));

function getDwBrowserEvent(event) {
    const dwBrowserEvent = {
        event: event,
        isClickEvent: false
    };
    if (event instanceof MouseEvent) {
        dwBrowserEvent.isClickEvent = true;
        dwBrowserEvent.buttonType = getButtonClickType(event.button);
    }
    if (event instanceof KeyboardEvent || event instanceof MouseEvent) {
        dwBrowserEvent.altKey = event.altKey;
        dwBrowserEvent.ctrlKey = event.ctrlKey;
        dwBrowserEvent.shiftKey = event.shiftKey;
        dwBrowserEvent.metaKey = event.metaKey;
    }
    return dwBrowserEvent;
}
var DwButtonClickType;
(function (DwButtonClickType) {
    DwButtonClickType[DwButtonClickType["leftButton"] = 0] = "leftButton";
    DwButtonClickType[DwButtonClickType["middleButton"] = 1] = "middleButton";
    DwButtonClickType[DwButtonClickType["rightButton"] = 2] = "rightButton";
})(DwButtonClickType || (DwButtonClickType = {}));
function getButtonClickType(eventButton) {
    switch (eventButton) {
        case 0:
            return DwButtonClickType.leftButton;
            break;
        case 1:
            return DwButtonClickType.middleButton;
            break;
        case 2:
            return DwButtonClickType.rightButton;
            break;
    }
    return null;
}

function getWindowOpenOptions(browserEvent, windowOpenOptions) {
    const options = {
        openInNewWindow: false
    };
    // middle click or ctrl + click reverses logic
    const swapDestination = ((browserEvent === null || browserEvent === void 0 ? void 0 : browserEvent.buttonType) == DwButtonClickType.middleButton || (browserEvent === null || browserEvent === void 0 ? void 0 : browserEvent.ctrlKey));
    if (windowOpenOptions === null || windowOpenOptions === void 0 ? void 0 : windowOpenOptions.openInNewWindow) {
        options.openInNewWindow = true;
        options.newWindowTarget = windowOpenOptions.newWindowTarget;
        if (swapDestination) {
            options.openInNewWindow = false;
        }
        return options;
    }
    if (swapDestination) {
        options.openInNewWindow = true;
    }
    return options;
}

function getActionWindowOpenOptions(actionState) {
    return getWindowOpenOptions(actionState.dwBrowserEvent, actionState.actionConfig);
}

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwRouteActionInternalLinkService = class DwRouteActionInternalLinkService {
    constructor(router, dwRoutingService, dwMenuService, dwRouteActionHelperService) {
        this.router = router;
        this.dwRoutingService = dwRoutingService;
        this.dwMenuService = dwMenuService;
        this.dwRouteActionHelperService = dwRouteActionHelperService;
    }
    handleAction(actionState) {
        if (!actionState.actionConfig || (actionState.actionConfig.useUrl && !actionState.actionConfig.url) || (!actionState.actionConfig.useUrl && !actionState.actionConfig.menuKey)) {
            const result = {
                success: false,
                message: `Internal Link is missing a configuration url or menu`
            };
            return of(result);
        }
        const windowOpenOptions = getActionWindowOpenOptions(actionState);
        if (actionState.actionConfig.useUrl) {
            return this.navigateToInternalUrl(actionState, windowOpenOptions);
        }
        return this.navigateToMenu(actionState, windowOpenOptions);
    }
    navigateToInternalUrl(actionState, windowOpenOptions) {
        const url = this.buildFinalUrl(actionState.actionConfig.url, actionState);
        this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
        return of({ success: true });
    }
    navigateToMenu(actionState, windowOpenOptions) {
        var _a, _b, _c, _d, _e;
        const menuKey = actionState.actionConfig.menuKey;
        const menu = this.dwMenuService.getMenuByKey(menuKey);
        const parentMenu = this.dwMenuService.getParentMenuItem(menu);
        if (!menu) {
            return of({ success: false, message: `Could not navigation to menu ${menuKey} because it was not found` });
        }
        // determine the meta data item to use
        let metaDataItem = (_a = parentMenu === null || parentMenu === void 0 ? void 0 : parentMenu.data) === null || _a === void 0 ? void 0 : _a.metaDataItem;
        if (((_c = (_b = menu === null || menu === void 0 ? void 0 : menu.data) === null || _b === void 0 ? void 0 : _b.childListMenuOptions) === null || _c === void 0 ? void 0 : _c.isChildListMenu) && ((_d = menu === null || menu === void 0 ? void 0 : menu.data) === null || _d === void 0 ? void 0 : _d.metaDataItem)) {
            metaDataItem = (_e = menu === null || menu === void 0 ? void 0 : menu.data) === null || _e === void 0 ? void 0 : _e.metaDataItem;
        }
        if (!metaDataItem) {
            metaDataItem = actionState.actionConfig.itemName;
        }
        const url = this.buildFinalUrl(menu.url, actionState, metaDataItem, this.dwMenuService.menuState.currentParams);
        // const navigationParams: NavigationExtras = {};
        // navigationParams.state = {fulUrl: url};
        if (url) {
            this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
            // if (actionState.actionPreference.isMiddleClick) {
            //     console.log('Open url in new window');
            //     window.open(url, '_blank');
            // } else {
            //     this.router.navigateByUrl(url, navigationParams);
            // }
        }
        return of({ success: true });
    }
    buildFinalUrl(url, actionState, itemName = "", currentMenuParams) {
        const params = [];
        if (actionState.actionConfig.viewKey) {
            params.push(`view=${actionState.actionConfig.viewKey}`);
        }
        if (actionState.actionConfig.passDataAttributes) {
            for (const attr of actionState.actionConfig.passDataAttributes) {
                params.push(`${attr}=[${attr}]`);
            }
        }
        if (params.length) {
            if (url.indexOf('?') < 0) {
                url += "?";
            }
            url += params.join("&");
        }
        if (actionState.actionConfig.additionalQueryString) {
            if (url.indexOf('?') < 0) {
                url += "?";
            }
            url += actionState.actionConfig.additionalQueryString;
        }
        // const menuParams = currentMenuParams.getAllParams().map(p => p.paramName);
        const additionalParams = convertAdditionalParams(actionState.actionConfig.additionalParams);
        url = this.dwRouteActionHelperService.processUrlParameters(url, actionState, actionState.actionConfig.keyValueAttrName, itemName, currentMenuParams, additionalParams);
        return url;
    }
};
DwRouteActionInternalLinkService.ɵfac = function DwRouteActionInternalLinkService_Factory(t) { return new (t || DwRouteActionInternalLinkService)(ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwRoutingServiceToken), ɵngcc0.ɵɵinject(DwMenuService), ɵngcc0.ɵɵinject(DwRouteActionHelperService)); };
DwRouteActionInternalLinkService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRouteActionInternalLinkService, factory: function (t) { return DwRouteActionInternalLinkService.ɵfac(t); } });
DwRouteActionInternalLinkService.ctorParameters = () => [
    { type: Router },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] },
    { type: DwMenuService },
    { type: DwRouteActionHelperService }
];
DwRouteActionInternalLinkService = __decorate$1([
    DwAction({
        keyName: DwRouteActionKeys.internal,
        display: 'Internal Link',
        actionType: DwActionType.menuAction,
        configComponent: DwRouteActionInternalLinkConfigComponent,
        configData: {
            // Use this for grid row actions since this could be used in multiple contexts
            singleRowAction: true
        }
    }),
    __metadata$1("design:paramtypes", [Router,
        DwRoutingService,
        DwMenuService,
        DwRouteActionHelperService])
], DwRouteActionInternalLinkService);

class DwMetaDataFormStateService extends DwStateBaseService {
    constructor() {
        super(...arguments);
        this.formActionInterceptors = [];
    }
    getInitialState() {
        return {
            context: {},
        };
    }
    setFormState(state) {
        this.setState(state);
    }
    addActionInterceptor(formActionInterceptor) {
        this.formActionInterceptors.push(formActionInterceptor);
        // Always resort by order
        this.formActionInterceptors = sortArray(this.formActionInterceptors, i => i.order);
    }
    removeActionInterceptor(formActionInterceptor) {
        if (formActionInterceptor) {
            const index = this.formActionInterceptors.indexOf(formActionInterceptor);
            if (index >= 0) {
                this.formActionInterceptors.splice(index, 1);
            }
        }
    }
    runBeforeActionIntercepters(actionPref, actionConfig) {
        const actionInterceptors = [];
        // Get all interceptors that need to wait on results
        for (var interceptor of this.formActionInterceptors) {
            if (interceptor.onBeforeAction) {
                actionInterceptors.push({
                    actionType: InterceptorActionType.beforeAction,
                    actionPreference: actionPref,
                    actionConfig: actionConfig,
                    wait: interceptor.onBeforeActionWait,
                    interceptor: interceptor
                });
            }
        }
        return this.processActionInterceptors(actionInterceptors);
    }
    processActionInterceptors(actionInterceptors) {
        const waitActionInterceptors = actionInterceptors.filter(i => i.wait);
        return this.processActionInterceptorWithWait(waitActionInterceptors)
            .pipe(mergeMap(result => {
            if (result.abort) {
                return of(result);
            }
            const obs = actionInterceptors.filter(i => !i.wait).map(i => this.processActionInterceptor(i));
            return this.combineInterceptorResult(obs);
        }));
    }
    runAfterActionIntercepters(actionPref, actionConfig, actionResult) {
        const actionInterceptors = [];
        // Get all interceptors that need to wait on results
        for (var interceptor of this.formActionInterceptors) {
            if (interceptor.onAfterAction) {
                actionInterceptors.push({
                    actionType: InterceptorActionType.afterAction,
                    actionPreference: actionPref,
                    actionConfig: actionConfig,
                    actionResult: actionResult,
                    wait: interceptor.onAfterActionWait,
                    interceptor: interceptor
                });
            }
        }
        return this.processActionInterceptors(actionInterceptors);
    }
    processActionInterceptorWithWait(actionInterceptors) {
        const result = { abort: false };
        if (actionInterceptors.length == 0) {
            return of(result);
        }
        const current = actionInterceptors[0];
        var remainingActionInterceptors = actionInterceptors.slice(1);
        var resultOb = this.processActionInterceptor(current);
        return resultOb.pipe(mergeMap(interceptResult => {
            if (interceptResult.abort) {
                result.abort = true;
                result.message = interceptResult.message;
                return of(result);
            }
            if (remainingActionInterceptors.length == 0) {
                return of(result);
            }
            return this.processActionInterceptorWithWait(remainingActionInterceptors);
        }));
    }
    processActionInterceptor(actionInterceptor) {
        const result = { abort: false };
        let ob;
        if (actionInterceptor.actionType == InterceptorActionType.beforeAction) {
            ob = actionInterceptor.interceptor.onBeforeAction(actionInterceptor.actionPreference, actionInterceptor.actionConfig);
        }
        else {
            ob = actionInterceptor.interceptor.onAfterAction(actionInterceptor.actionPreference, actionInterceptor.actionConfig, actionInterceptor.actionResult);
        }
        if (ob) {
            if (ob.pipe) {
                return ob;
            }
        }
        return of(result);
    }
    combineInterceptorResult(obs) {
        const result = { abort: false };
        if (obs.length == 0) {
            return of(result);
        }
        return combineLatest(obs)
            .pipe(map(results => {
            const combinedResult = { abort: false };
            for (var result of results) {
                if (result.abort) {
                    combinedResult.abort = true;
                    // Only turn one message
                    combinedResult.message = combinedResult.message || result.message;
                }
            }
            return combinedResult;
        }));
    }
}
DwMetaDataFormStateService.ɵfac = function DwMetaDataFormStateService_Factory(t) { return ɵDwMetaDataFormStateService_BaseFactory(t || DwMetaDataFormStateService); };
DwMetaDataFormStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataFormStateService, factory: DwMetaDataFormStateService.ɵfac });
var InterceptorActionType;
(function (InterceptorActionType) {
    InterceptorActionType[InterceptorActionType["beforeAction"] = 0] = "beforeAction";
    InterceptorActionType[InterceptorActionType["afterAction"] = 1] = "afterAction";
})(InterceptorActionType || (InterceptorActionType = {}));

class DwMetaDataFormValidatorService extends DwDefaultFormValidator {
    setupValidatorMetaData(formConfig) {
        this.formConfig = formConfig;
    }
    getFormControlDisplayFuncDefault(itemName, controlName, hierarchy) {
        if (!this.formConfig) {
            return controlName;
        }
        const attr = this.getAttribute(itemName, controlName, hierarchy);
        if (attr) {
            return attr.AttributeDisplay;
        }
        return controlName + '23';
    }
    getAttribute(itemName, controlName, hierarchy) {
        const itemMd = this.getItem(itemName, hierarchy);
        if (itemMd) {
            const attr = itemMd.Attributes.find(a => a.AttributeName == controlName);
            return attr;
        }
        return null;
    }
    getItem(itemName, hierarchy) {
        if (!this.formConfig) {
            return;
        }
        if (itemName == 'root') {
            return this.formConfig.queryMetaDataList[this.formConfig.rootItemName];
        }
        let currentHierarchyChildren = this.formConfig.ormDataHierarchy;
        let currentHierarchy = null;
        for (const hierarchyItem of hierarchy) {
            if (itemName == 'root') {
                continue;
            }
            currentHierarchy = currentHierarchyChildren.find(h => h.propertyName == hierarchyItem);
            if (currentHierarchy) {
                currentHierarchyChildren = currentHierarchy.children;
            }
        }
        if (currentHierarchy) {
            return this.formConfig.queryMetaDataList[currentHierarchy.itemName];
        }
        return null;
    }
}
DwMetaDataFormValidatorService.ɵfac = function DwMetaDataFormValidatorService_Factory(t) { return ɵDwMetaDataFormValidatorService_BaseFactory(t || DwMetaDataFormValidatorService); };
DwMetaDataFormValidatorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataFormValidatorService, factory: DwMetaDataFormValidatorService.ɵfac });

const DW_FORM_DATA_UPDATE = "DW_FORM_DATA_UPDATE";
class DwFormEventService {
    constructor(dwEventService) {
        this.dwEventService = dwEventService;
    }
    publishFormDataUpdate(item, data) {
        const topic = this.getForMDataUpdateTopic(item);
        const eventData = {
            formData: data
        };
        this.dwEventService.publishEvent(topic, eventData);
    }
    subscribeToFormDataUpdate(item) {
        const topic = this.getForMDataUpdateTopic(item);
        return this.dwEventService.getEventData(topic)
            .pipe(map(eventData => {
            return eventData.formData;
        }));
    }
    getFormDataValue(item) {
        var _a;
        const topic = this.getForMDataUpdateTopic(item);
        const value = this.dwEventService.getTopicLastEvent(topic);
        if ((_a = value === null || value === void 0 ? void 0 : value.data) === null || _a === void 0 ? void 0 : _a.formData) {
            return value.data.formData;
        }
        return null;
    }
    getForMDataUpdateTopic(item) {
        const topic = `${DW_FORM_DATA_UPDATE}_${item}`;
        return topic;
    }
}
DwFormEventService.ɵfac = function DwFormEventService_Factory(t) { return new (t || DwFormEventService)(ɵngcc0.ɵɵinject(DwEventService)); };
DwFormEventService.ɵprov = ɵɵdefineInjectable({ factory: function DwFormEventService_Factory() { return new DwFormEventService(ɵɵinject(DwEventService)); }, token: DwFormEventService, providedIn: "root" });
DwFormEventService.ctorParameters = () => [
    { type: DwEventService }
];

class DwMetaDataFormSectionStateService extends DwStateBaseService {
    constructor() {
        super(...arguments);
        this.readOnlyChangedSubject = new Subject();
    }
    getInitialState() {
        return {
            formSections: {},
            formGroupState: {}
        };
    }
    getReadOnlyChangedObservable() {
        return this.readOnlyChangedSubject.asObservable();
    }
    updateReadOnlyChanged(sectionId) {
        this.readOnlyChangedSubject.next(sectionId);
    }
    updateSectionState(sectionState) {
        const state = this.state;
        state.formSections[sectionState.sectionId] = sectionState;
        state.formGroupState = this.buildFormGroupState(state);
        this.setState(state);
    }
    getFormFieldState(formGroupKey, attrName) {
        const formGroupFieldStates = getOrSetItem(this.state.formGroupState, formGroupKey, { fieldStates: {} });
        const groupFieldState = getOrSetItem(formGroupFieldStates.fieldStates, attrName, {
            finalState: {
                formGroupKey: formGroupKey,
                attrName: attrName,
                readonly: true,
                visible: false
            },
            individualStates: []
        });
        return groupFieldState.finalState;
    }
    buildFormGroupState(state) {
        const formGroupState = {};
        for (let sectionId in state.formSections) {
            if (this.state.formSections.hasOwnProperty(sectionId)) {
                const sectionState = this.state.formSections[sectionId];
                for (let fieldKey in sectionState.fieldStates) {
                    if (sectionState.fieldStates.hasOwnProperty(fieldKey)) {
                        const fieldState = sectionState.fieldStates[fieldKey];
                        this.updateFieldState(formGroupState, sectionState, fieldState);
                    }
                }
            }
        }
        return formGroupState;
    }
    updateFieldState(formGroupState, sectionState, fieldState) {
        const formGroupFieldStates = getOrSetItem(formGroupState, fieldState.formGroupKey, { fieldStates: {} });
        fieldState = Object.assign({}, fieldState);
        if (!sectionState.visible) {
            fieldState.visible = false;
            fieldState.readonly = true;
        }
        if (sectionState.readonly) {
            fieldState.readonly = true;
        }
        const groupFieldState = getOrSetItem(formGroupFieldStates.fieldStates, fieldState.attrName, {
            finalState: Object.assign({}, fieldState),
            individualStates: []
        });
        //  Keep track of all field states (this represents where a field is shown more than once)
        groupFieldState.individualStates.push(fieldState);
        // Update the final states 
        // - if field is visible in any case, then its visible
        // - if field is NOT readonly in any case, then its not read-only
        groupFieldState.finalState.visible = false;
        groupFieldState.finalState.readonly = true;
        for (let currentFieldState of groupFieldState.individualStates) {
            if (currentFieldState.visible) {
                groupFieldState.finalState.visible = true;
            }
            if (!currentFieldState.readonly) {
                groupFieldState.finalState.readonly = false;
            }
        }
    }
}
DwMetaDataFormSectionStateService.ɵfac = function DwMetaDataFormSectionStateService_Factory(t) { return ɵDwMetaDataFormSectionStateService_BaseFactory(t || DwMetaDataFormSectionStateService); };
DwMetaDataFormSectionStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataFormSectionStateService, factory: DwMetaDataFormSectionStateService.ɵfac });

function getFieldConfiguredOptions(fieldPref, attr) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const options = {};
    if (!fieldPref) {
        return options;
    }
    if (!attr) {
        options.hasErrors = true;
        let fieldDesc = fieldPref.contextName ? `Context Field ${fieldPref.contextName}.${fieldPref.attrName}` : `Data Field ${fieldPref.attrName}`;
        options.errorDesc = `${fieldDesc} does not exist`;
    }
    const overrides = [];
    if (fieldPref.label ||
        fieldPref.placeholderText ||
        fieldPref.readOnlyMissingDataText ||
        fieldPref.hideLabel ||
        fieldPref.infoText) {
        options.hasBasicSettings = true;
        overrides.push('Basic Settings');
    }
    if (fieldPref.hasDefaultValue) {
        options.hasDefaultValue = true;
        overrides.push('Default Value');
    }
    if (((_a = fieldPref.columnItemPreferences) === null || _a === void 0 ? void 0 : _a.newRowBefore) || ((_b = fieldPref.columnItemPreferences) === null || _b === void 0 ? void 0 : _b.spanAllColumns) || ((_c = fieldPref.columnItemPreferences) === null || _c === void 0 ? void 0 : _c.columnSizeOverride) || ((_d = fieldPref.columnItemPreferences) === null || _d === void 0 ? void 0 : _d.skipColumns)) {
        options.hasFieldLayout = true;
        overrides.push('Field Layout');
    }
    if (fieldPref.labelClass ||
        fieldPref.dataClass ||
        fieldPref.iconClass ||
        ((_f = (_e = fieldPref.conditionalFieldClasses) === null || _e === void 0 ? void 0 : _e.label) === null || _f === void 0 ? void 0 : _f.length) > 0 ||
        ((_h = (_g = fieldPref.conditionalFieldClasses) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.length) > 0 ||
        ((_k = (_j = fieldPref.conditionalFieldClasses) === null || _j === void 0 ? void 0 : _j.icon) === null || _k === void 0 ? void 0 : _k.length) > 0) {
        options.hasClasess = true;
        overrides.push('Classes');
    }
    if (fieldPref.isReadOnly ||
        fieldPref.isVisible ||
        fieldPref.isVisibleExpression ||
        fieldPref.isReadOnlyExpression) {
        options.hasReadOnlyVisible = true;
        overrides.push('Read Only/Visibility');
    }
    if (fieldPref.useCustomControl ||
        fieldPref.useControlTypeOverride || ((_l = fieldPref.lookupConfig) === null || _l === void 0 ? void 0 : _l.useLookupOverride)) {
        options.hasControlOverrides = true;
        overrides.push('Control Overrrides');
    }
    if ((_m = fieldPref.validationConfig) === null || _m === void 0 ? void 0 : _m.overrideDefaults) {
        options.hasCustomValidation = true;
        overrides.push('Validation');
    }
    if (!isEmptyObject(fieldPref.controlOptions, true)) {
        options.hasControlSettings = true;
        overrides.push('Control Settings');
    }
    if (overrides.length > 0) {
        options.hasAnyOverrides = true;
        options.overrideDesc = `Has Configurations for ${overrides.join(', ')}`;
    }
    return options;
}

const moment$6 = moment_;
class DwMetadataFormDebugWidgetComponent extends DwUiPanelWidgetBaseComponent {
    constructor(fb, dwMetaDataFormUtilService, 
    // private dwEventService: DwEventService,
    // private dwModalService: DwModalService,
    // private metaDataFormService: DwMetaDataFormService,
    // private metaDataRoutingService: DwMetaDataRoutingService,
    // private dwContextService: DwContextService,
    // private route: ActivatedRoute,
    // private uiConfigRegistry: DwUiConfigRegistryService,
    // private metaDataFormConfigService: DwMetaDataFormConfigService,
    // private dwRulesService: DwRuleService,
    // private dwDataVariableService: DwDataVariableService,
    dwDesignerStateService) {
        super(fb, dwDesignerStateService);
        this.dwMetaDataFormUtilService = dwMetaDataFormUtilService;
    }
    get formPreferences() {
        return this.preferences;
    }
    get formPreferencesHierarchy() {
        return this.preferencesHierarchy;
    }
    startConfigureSection(state) {
        // Ignore it here
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupCurrentSectionUiConfig();
    }
    //currentFieldInfo: DwFieldBase
    updateDesignerState(state) {
        var _a, _b, _c, _d, _e;
        if (!this.dwMetaDataFormUtilService) {
            return;
        }
        super.updateDesignerState(state);
        if (!state.sectionKey) {
            return;
        }
        this.currentSectionData = null;
        this.currentSectionInfo = this.dwMetaDataFormUtilService.findSectionbyKey(this.preferences.section, state.sectionKey);
        if (!this.currentSectionInfo) {
            return;
        }
        this.parentSections = this.dwMetaDataFormUtilService.getSectionParents(this.preferences.section, this.currentSectionInfo);
        this.parentTitle = (_a = this.parentSections.find(p => p.showTitle && p.title)) === null || _a === void 0 ? void 0 : _a.title;
        this.currentSectionData = {
            sectionInfo: this.currentSectionInfo,
            parentTitle: this.parentTitle,
        };
        this.fieldConfiguredOptions = null;
        this.fieldInfo = null;
        if (((_b = state.additionalInfo) === null || _b === void 0 ? void 0 : _b.attrName) && state.additionalInfo) {
            this.fieldInfo = state.additionalInfo;
            this.currentSectionData.fieldInfo = this.fieldInfo;
            let lookupId = (_c = this.fieldInfo.attr) === null || _c === void 0 ? void 0 : _c.MetaDataLookupId;
            let isLookupOverride = false;
            if (((_d = this.fieldInfo.lookupConfig) === null || _d === void 0 ? void 0 : _d.useLookupOverride) && ((_e = this.fieldInfo.lookupConfig) === null || _e === void 0 ? void 0 : _e.lookupIdOverride)) {
                isLookupOverride = true;
                lookupId = parseInt(this.fieldInfo.lookupConfig.lookupIdOverride.value);
            }
            if (lookupId) {
                this.currentSectionData.fieldInfo.finalLookupId = lookupId;
            }
            this.currentSectionData.fieldConfiguredOptions = getFieldConfiguredOptions(this.fieldInfo, null);
        }
    }
    setupCurrentSectionUiConfig() {
        this.currentSectionUiConfig = {
            sections: [{
                    sectionDisplay: 'Section Info',
                    fields: [
                        { display: 'Section Key', fieldPath: 'sectionInfo.sectionKey' },
                        { display: 'Parent', fieldPath: 'parentTitle' },
                    ]
                }, {
                    sectionDisplay: 'Field Info',
                    hideFunc: (data) => !(data === null || data === void 0 ? void 0 : data.fieldInfo),
                    fields: [
                        { display: 'Display', fieldPath: 'fieldInfo.fieldDisplay' },
                        { display: 'Field', fieldPath: 'fieldInfo.attrName', dataFunc: (data) => this.getFieldName(data === null || data === void 0 ? void 0 : data.fieldInfo), },
                        { display: 'Lookup', fieldPath: 'fieldInfo.finalLookupId', hideFunc: (data) => { var _a; return !((_a = data === null || data === void 0 ? void 0 : data.fieldInfo) === null || _a === void 0 ? void 0 : _a.finalLookupId); }, isLookup: true, lookupId: DevwareMetaDataLookups.MetaDataLookupAllItems,
                            showLink: true, openLink: (data) => { var _a; return this.openLookup((_a = data === null || data === void 0 ? void 0 : data.fieldInfo) === null || _a === void 0 ? void 0 : _a.finalLookupId); }
                        },
                    ]
                }]
        };
    }
    openLookup(finalLookupId) {
        throw new Error('Method not implemented.');
    }
    getFieldName(fieldInfo) {
        if (!fieldInfo)
            return null;
        if (fieldInfo.contextName) {
            return `${fieldInfo.contextName}.${fieldInfo.attrName}`;
        }
        return fieldInfo.attrName;
    }
    configSet() {
        super.configSet();
    }
    createForm(fb) {
        const formGroup = this.fb.group({});
        return formGroup;
    }
}
DwMetadataFormDebugWidgetComponent.ɵfac = function DwMetadataFormDebugWidgetComponent_Factory(t) { return new (t || DwMetadataFormDebugWidgetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService)); };
DwMetadataFormDebugWidgetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFormDebugWidgetComponent, selectors: [["dw-metadata-form-debug-widget"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [["header", "Current Section", 3, "selected", 4, "ngIf"], ["header", "Data"], ["header", "Expressions"], ["header", "Current Section", 3, "selected"], [3, "config", "data"]], template: function DwMetadataFormDebugWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-accordion");
        ɵngcc0.ɵɵtemplate(1, DwMetadataFormDebugWidgetComponent_p_accordionTab_1_Template, 2, 3, "p-accordionTab", 0);
        ɵngcc0.ɵɵelement(2, "p-accordionTab", 1);
        ɵngcc0.ɵɵelement(3, "p-accordionTab", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentSectionInfo);
    } }, directives: function () { return [ɵngcc11.Accordion, ɵngcc4.NgIf, ɵngcc11.AccordionTab, DwUiInfoDisplayComponent]; }, styles: [""] });
DwMetadataFormDebugWidgetComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwMetadataFormUtilService },
    { type: DwDesignerStateService }
];

var __decorate$2 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$2 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMetaDataFormComponent extends DwContextConfigurableBaseComponent {
    constructor(router, uiConfigService, dwEventService, metaDataFormService, metaDataFormBuilderService, metaDataRoutingService, route, dwContextService, dwSecurityUserService, dwConfigService, dwRuleManagerService, dwReportingService, dwLoggingUtil, dwActionExecutionService, metaDataService, uiMetaDataConfig, uiConfigRegistryService, dwRouteActionInternalLinkService, dwMetaDataFormStateService, dwMetaDataFormSectionStateService, formValidatorService, dwFormEventService) {
        super(uiConfigService, dwEventService, dwContextService, dwSecurityUserService, dwConfigService);
        this.router = router;
        this.metaDataFormService = metaDataFormService;
        this.metaDataFormBuilderService = metaDataFormBuilderService;
        this.metaDataRoutingService = metaDataRoutingService;
        this.route = route;
        this.dwRuleManagerService = dwRuleManagerService;
        this.dwReportingService = dwReportingService;
        this.dwLoggingUtil = dwLoggingUtil;
        this.dwActionExecutionService = dwActionExecutionService;
        this.metaDataService = metaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.dwRouteActionInternalLinkService = dwRouteActionInternalLinkService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataFormSectionStateService = dwMetaDataFormSectionStateService;
        this.formValidatorService = formValidatorService;
        this.dwFormEventService = dwFormEventService;
        this.overrideData = false;
        this.dataChanged = new EventEmitter();
        this.handleRedirect = true;
        this.showButtons = true;
        this.isModal = false;
        this.configKeyPart = "";
        this.formMode = DwFormContextMode.addEdit;
        this.contextKeys = {};
        this.allFormSetupComplete = new EventEmitter();
        this.returnToPrevious = new EventEmitter();
        this.dwFormContext = new DwMdFormContextInfo();
        this.printFormMode = DwFormContextMode.print;
        /**
        * Triggers when data has been loaded and stores previous value
        */
        this.isDataLoadComplete = new BehaviorSubject(false);
        this.reloadPrintData = false;
        this.enableLogging = false;
        this.submitted = false;
        this.securityCheckRepeat = true;
        this.securityRecheckCount = 0;
        this.reSetupForm = false;
        this.securityChecksComplete = false;
        this.ignoreformDataChanged = false;
        this.loadSecurityResultCount = 0;
        this.loadSecurityResultCompleteCount = 0;
        this.loggedMessages = 0;
        this.showPrintingForm = false;
        this.printDataSource = new DwInMemoryDataSource(this.metaDataService);
    }
    hasChanges() {
        var _a, _b;
        // Non-edit pages should never have changes so let's ignore them
        if (((_a = this.dwFormContext) === null || _a === void 0 ? void 0 : _a.contextMode) == DwFormContextMode.view || ((_b = this.dwFormContext) === null || _b === void 0 ? void 0 : _b.contextMode) == DwFormContextMode.print) {
            return false;
        }
        if (!this.formGroup) {
            return;
        }
        if (this.formConfig.suppressUnsavedChangesMessage) {
            return false;
        }
        if (this.formGroup.pristine) {
            return false;
        }
        if (this.allowRedirect) {
            return false;
        }
        return true;
    }
    ngOnInit() {
        super.ngOnInit();
        this.subscriptions.push(this.dwEventService.getEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.MetaDataUpdated)
            .subscribe((event) => {
            this.setupConfig();
        }));
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (!this.configSequenceComplete)
            return;
        if (changes.data && !changes.data.firstChange) {
            if (this.overrideData) {
                this.setFormData(this.data);
            }
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.dwFormEventService.publishFormDataUpdate(this.item, null);
    }
    setFormMessage(message) {
        this.formMessage = message;
    }
    clearFormMessage() {
        this.formMessage = null;
    }
    getFormConfig() {
        return deepCopy(this.formConfig, true, 'contextValueFCDefaults');
    }
    setFormConfig(updatedConfig, rebuildForm) {
        var _a;
        this.formConfig = deepCopy(Object.assign(Object.assign({}, this.formConfig), updatedConfig), true, 'contextValueFCDefaults');
        this.setupContext(this.formConfig.contextNames);
        this.updateContext(this.formConfig.contextNames);
        this.updateFormState();
        this.formValidatorService.setupValidatorMetaData(this.formConfig);
        // Clear context data processing since we need to do it again
        (_a = this.formConfig.contextValueFCDefaults) === null || _a === void 0 ? void 0 : _a.forEach(d => d.processed = false);
        this.dwFormContext.defaultsProcessed = false;
        this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
        if (rebuildForm && this.formSetupComplete) {
            this.formSetupComplete = false;
            setTimeout(() => {
                this.formSetupComplete = true;
            });
        }
    }
    updateFormState() {
        var _a;
        this.dwMetaDataFormStateService.setFormState({
            context: this.context,
            formConfig: this.formConfig,
            rootFormGroup: this.formGroup,
            formApi: this,
            formContext: this.dwFormContext,
            submitted: this.submitted,
            showButtons: this.showButtons,
            itemSecurity: (_a = this.preferenceHierarchy) === null || _a === void 0 ? void 0 : _a.itemSecurity
        });
    }
    formDataChanged(data, initialLoad, fromFormGroup = false) {
        if (this.ignoreformDataChanged) {
            //console.log("ignore form data changed");
            return;
        }
        if (!initialLoad) {
            //console.log("dwMetaDataForm.formDataChanged", this.data, data, this.dwFormContext);
        }
        if (this.data) {
            // Assign was removing load values that are not added as field controls.  We need to preserve any child data values
            //this.data = Object.assign(this.data, data);
            this.data = deepDefaults(deepCopy(data), this.data);
        }
        else {
            this.data = data;
        }
        // Remove the Context Form Group
        if (fromFormGroup && this.data && this.data[DwMdFormContextInfo.CONTEXT_FORM_GROUP]) {
            this.data[DwMdFormContextInfo.CONTEXT_FORM_GROUP] = null;
        }
        this.dataChanged.emit(data);
        this.dwFormEventService.publishFormDataUpdate(this.item, data);
        if (initialLoad) {
            setTimeout(() => {
                this.originalData = data;
                this.dwFormContext.loadDataComplete = true;
                this.isDataLoadComplete.next(true);
                this.dwFormContext.originalData = data;
                // patch the form data again after the timeout in case the controls have now been added
                DwFormDebugService.debugMessage(0, 'form-conponent', 'patching data', data);
                this.patchFormDataInternal(data);
                this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
                // update data context value
                this.updateContextValue(DwMdFormContextInfo.DATA_CONTEXT_NAME, this.data, this.isDataLoadComplete.value);
                // Update context in case it depends on this data (TODO: this might need to be in initialLoad as well)
                this.updateContext(this.formConfig.contextNames);
                this.setupWorkflowStatus();
                ;
                this.checkAllSetupComplete();
                this.setupFormGroupContextData();
                this.setContextValueFormDefaults();
                this.updateFormState();
                this.loadSecurityResults('formDataChanged');
            }, 50);
        }
        else {
            // update data context value
            this.updateContextValue(DwMdFormContextInfo.DATA_CONTEXT_NAME, this.data, this.isDataLoadComplete.value);
            // Update context in case it depends on this data (TODO: this might need to be in initialLoad as well)
            this.updateContext(this.formConfig.contextNames);
        }
    }
    securityNotLoadedSafeGuard() {
        if (this.intervalRef) {
            return;
        }
        this.intervalRef = setInterval(() => {
            if (this.formConfig.canAccess || this.loggedMessages > 5) {
                clearInterval(this.intervalRef);
                this.intervalRef = null;
                return;
            }
            this.loggedMessages++;
            const detailInfo = `Form Item: ${this.item} - Security Checks Complete: ${this.securityChecksComplete} - Security Check Repeat: ${this.securityCheckRepeat} - Security Result: ${JSON.stringify(this.securityResult || {})} Security Recheck Count: ${this.securityRecheckCount} - Load Security Result Count: ${this.loadSecurityResultCount} - Load Security Result Complete Count: ${this.loadSecurityResultCompleteCount}`;
            if (this.securityChecksComplete) {
                clearInterval(this.intervalRef);
                this.intervalRef = null;
                return;
            }
            // We'll continue to check until the security checks are complete
            this.loadSecurityResults();
        }, 10000);
    }
    loadSecurityResults(contextNameTrigger) {
        var _a, _b;
        this.securityNotLoadedSafeGuard();
        if ((_b = (_a = this.securityResult) === null || _a === void 0 ? void 0 : _a.isComplete) === null || _b === void 0 ? void 0 : _b.allPopulated) {
            this.checkPermissions();
            return;
        }
        this.loadSecurityResultCount++;
        DwFormDebugService.debugMessage(1, 'form', `loadSecurityResults - contextNameTrigger = ${contextNameTrigger}`, Object.assign({}, this.contextStateInfo));
        this.subscriptions.push(this.metaDataFormBuilderService.getFormSecurityResults(this.formConfig, this.formMode, this.formGroup, this.context, this.dwFormContext.loadDataComplete, this.originalData, this.contextStateInfo)
            .subscribe(securityResults => {
            this.loadSecurityResultCompleteCount++;
            this.securityResult = securityResults;
            this.checkPermissions();
        }));
    }
    setupFormGroupContextData() {
        const contextFG = this.formGroup.get(DwMdFormContextInfo.CONTEXT_FORM_GROUP);
        // Iterate all form groups
        for (let contextName in contextFG.controls) {
            if (contextFG.controls.hasOwnProperty(contextName)) {
                const contextItemFg = contextFG.controls[contextName];
                const contextItem = this.context[contextName];
                if (contextItem.value) {
                    contextItemFg.patchValue(contextItem.value);
                }
                // Check if this is the variable context, if you, update the context when the value changes
                if (contextName == this.formConfig.variableContextDataKey) {
                    const initialVariableValues = contextItemFg.getRawValue();
                    contextItem.next(initialVariableValues);
                    this.subscriptions.push(contextItemFg.valueChanges.subscribe(() => {
                        const variableContextData = contextItemFg.getRawValue();
                        if (!areEqual(contextItem.value, variableContextData)) {
                            contextItem.next(variableContextData);
                        }
                    }));
                }
                this.subscriptions.push(contextItem
                    .pipe(debounceTime(10))
                    .subscribe(value => {
                    // Fix for bug to clear out context if it returns an empty object
                    if (value && !isEmptyObject(value)) {
                        contextItemFg.patchValue(value);
                    }
                    else {
                        //this.dwLoggingUtil.logVerbose(`dwForm - Clearing context for ${contextName}`);
                        // If there isn't a value (or its an empty object), then we need to reset it, otherwise the former values will be displayed
                        contextItemFg.reset();
                    }
                    this.loadSecurityResults(contextName);
                }));
            }
        }
        this.contextStateInfoSubscription =
            this.contextStateInfoSubject
                .pipe(debounceTime(5))
                .subscribe(result => {
                DwFormDebugService.debugMessage(null, 'form', `setupFormGroupContextData - contextStateInfoSubject`, result);
                this.loadSecurityResults('contextStateInfo');
            });
    }
    //private formDefaultsProcessed: boolean = false;
    setContextValueFormDefaults() {
        var _a;
        let allprocessed = true;
        if (this.dwFormContext.defaultsProcessed || (this.dwFormContext.loadDataComplete == false && this.dwFormContext.contextMode != DwFormContextMode.add)) {
            return;
        }
        // Only set default values when loading
        if (this.dwFormContext.contextMode != DwFormContextMode.add && this.dwFormContext.contextMode != DwFormContextMode.addEdit) {
            this.dwFormContext.defaultsProcessed = true;
            this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
            //this.formDefaultsProcessed = true;
            return;
        }
        const contextDefaults = this.formConfig.contextValueFCDefaults || [];
        DwFormDebugService.debugMessage(1, "DwMetaDataForm", "setupContextValueFormDefaults", contextDefaults);
        for (const contextValueDefault of contextDefaults) {
            if (contextValueDefault.processed) {
                continue;
            }
            const contextItem = this.context[contextValueDefault.defaultValue.reference.contextName];
            if (!(contextItem === null || contextItem === void 0 ? void 0 : contextItem.value)) {
                DwFormDebugService.debugMessage(1, "DwMetaDataForm", `setupContextValueFormDefaults - Context ${contextValueDefault.defaultValue.reference.contextName} has no value.  Field ${contextValueDefault.defaultValue.reference.attrName} will remain blank`, this.contextStateInfo[contextValueDefault.defaultValue.reference.contextName]);
                // Check if the context is still loading, if so, defaults will be processed once it is complete
                if (!((_a = this.contextStateInfo[contextValueDefault.defaultValue.reference.contextName]) === null || _a === void 0 ? void 0 : _a.loadComplete)) {
                    allprocessed = false;
                }
                continue;
            }
            const fieldValue = contextItem.value[contextValueDefault.defaultValue.reference.attrName];
            DwFormDebugService.debugMessage(1, "DwMetaDataForm", `setupContextValueFormDefaults - ${contextValueDefault.defaultValue.reference.attrName} = ${fieldValue}}`, contextItem.value);
            contextValueDefault.processed = true;
            if (fieldValue) {
                // console.log(`Setting default ${contextValueDefault.defaultValue.reference.attrName} to ${fieldValue} `);
                contextValueDefault.abstractControl.setValue(fieldValue);
            }
        }
        if (allprocessed) {
            DwFormDebugService.debugMessage(1, "DwMetaDataForm", `setupContextValueFormDefaults - All defaults processed`);
            this.dwFormContext.defaultsProcessed = true;
            this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
            this.checkPermissions();
        }
        if (!this.dwFormContext.defaultsProcessed) {
            setTimeout(() => {
                this.setContextValueFormDefaults();
            }, 50);
        }
    }
    checkPermissions() {
        // Need to wait until the data load is complete and any references context data is loaded
        //  if ((this.dwFormContext.loadDataComplete == false && this.dwFormContext.contextMode != DwFormContextMode.add) || !this.formDefaultsProcessed || !this.securityResult) {
        if ((this.dwFormContext.loadDataComplete == false && this.dwFormContext.contextMode != DwFormContextMode.add) || !this.securityResult) {
            return;
        }
        // Let's only check security once (unless a security change happens, which should clear this and recheck)
        if (!this.securityCheckRepeat) {
            // We can't return here because of some edge cases around context data not loading - this was causing the page to hand, so instead, if the context changes, we will reevaluate the security
            //in the case where context data can't be loaded based on a dependencies so IsComplete = true
            return;
        }
        // Check if no data was loaded, we need to show an error that the user doesn't have access to the data
        if (this.dwFormContext.contextMode != DwFormContextMode.add && !this.originalData) {
            this.formConfig.canAccess = false;
            this.formConfig.accessErrorMessage = `You don't have permission to view this data or it does not exist`;
            return;
        }
        this.securityChecksComplete = this.securityResult.isComplete.allInitialized;
        this.securityCheckRepeat = !this.securityResult.isComplete.allPopulated;
        switch (this.dwFormContext.initialContextMode) {
            case DwFormContextMode.edit:
                const newReadOnly = !this.securityResult.canEdit;
                if (this.formConfig.readOnly != newReadOnly) {
                    this.dwFormContext.isReadOnly = newReadOnly;
                    if (this.formConfig.readOnlyPreference != true) {
                        this.formConfig.readOnly = newReadOnly;
                    }
                    // this.dwFormContext.isReadOnly = this.formConfig.readOnly;
                    this.formConfig.canAccess = this.securityResult.canView;
                    // If they can't edit, switch to view mode
                    if (!this.securityResult.canEdit) {
                        this.dwFormContext.contextMode = DwFormContextMode.view;
                    }
                    else {
                        this.dwFormContext.contextMode = this.dwFormContext.initialContextMode;
                    }
                    this.dwMetaDataFormSectionStateService.updateReadOnlyChanged('Form');
                    this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
                    const itemSecurity = Object.assign(Object.assign({}, this.finalPreferences.itemSecurity), { CanUpdate: this.securityResult.canEdit, CanCreate: this.securityResult.canAdd, CanRead: this.securityResult.canView });
                    setTimeout(() => {
                        this.formConfig.section = this.metaDataFormService.processSection(this.formConfig.section, itemSecurity, this.formConfig, this.finalPreferences);
                        this.updateFormState();
                    });
                }
                break;
            case DwFormContextMode.add:
                this.formConfig.canAccess = this.securityResult.canAdd;
                if (!this.formConfig.canAccess) {
                    this.formConfig.accessErrorMessage = `You don't have permission to view this data or it does not exist`;
                }
                break;
            case DwFormContextMode.view:
                this.formConfig.canAccess = this.securityResult.canView;
                if (!this.formConfig.canAccess) {
                    this.formConfig.accessErrorMessage = `You don't have permission to view this data or it does not exist`;
                }
        }
        if (!this.securityChecksComplete && !this.securityRecheckStarted) {
            this.securityRecheckStarted = true;
            setTimeout(() => {
                this.securityRecheckStarted = false;
                if (!this.securityChecksComplete) {
                    this.securityRecheckCount++;
                    DwFormDebugService.debugMessage(null, 'form', `checkPermissions - rechecking security - Count : ${this.securityRecheckCount}`, this.securityResult);
                    this.loadSecurityResults('checkPermissions');
                }
            }, 1000);
        }
        if (this.securityChecksComplete) {
            if (!this.formConfig.canAccess && !this.formConfig.accessErrorMessage) {
                this.formConfig.accessErrorMessage = `You don't have permission to view this data or it does not exist.  Please refresh and try again.`;
                this.dwLoggingUtil.logError(`Form ${this.item} - ${this.formConfig.formMode} - Can't access form but no error message set`, new Error(this.formConfig.accessErrorMessage), this.securityResult);
            }
        }
    }
    setFormData(data) {
        // Exclude new contextFg group
        if (data[DwMdFormContextInfo.CONTEXT_FORM_GROUP] !== undefined)
            delete data[DwMdFormContextInfo.CONTEXT_FORM_GROUP];
        this.dwForm.setFormData(data);
        // Update the key value when the data is updated
        if (this.formConfig.keyName) {
            const keyValue = data[this.formConfig.keyName];
            if (keyValue && keyValue != this.dwFormContext.keyValue) {
                this.keyValue = keyValue;
                this.dwFormContext.keyValue = keyValue;
                this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
            }
        }
    }
    initialDataLoad(data) {
        // console.log(`DwMetaDataForm.setFormData`, data, this.dwFormContext);
        this.ignoreformDataChanged = true;
        // console.log('InitialDataLoad', data);
        if (this.formGroup && data) {
            this.patchFormDataInternal(data);
        }
        this.ignoreformDataChanged = false;
        this.formDataChanged(data, true);
    }
    patchFormDataInternal(data) {
        // clear blank hierachy data
        const finalData = this.clearBlankChildHierarchyData(deepCopy(data));
        this.formGroup.patchValue(finalData);
    }
    /**
     * Need to determine why this was needed, I've slept since then
     * @param data
     * @param isRoot
     * @returns
     */
    clearBlankChildHierarchyData(data, isRoot = true) {
        if (!isRoot) {
            if ((data === null || data === void 0 ? void 0 : data._itemName) && (data === null || data === void 0 ? void 0 : data._keyName)) {
                const key = data[data._keyName];
                if (!key) {
                    return null;
                }
            }
            else {
                return data;
            }
        }
        for (let propName in data) {
            if (data.hasOwnProperty(propName)) {
                let childValue = data[propName];
                if (typeof childValue === 'object') {
                    childValue = this.clearBlankChildHierarchyData(childValue, false);
                    data[propName] = childValue;
                }
            }
        }
        return data;
    }
    setFormAsSubmitted() {
        this.submitted = true;
        this.updateFormState();
    }
    clearFormSubmitted() {
        this.submitted = false;
        this.updateFormState();
    }
    // #region Abstract Method implementation
    get configType() {
        return DwUiConfigType.form;
    }
    getConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}`;
        return `${itemName}-${this.configKeyPart}`;
    }
    loadPreferences() {
        return this.metaDataFormService.getPreferencesHierarchy(this.item, this.getConfigKey(), this.allowConfiguration, this.preferences);
    }
    getPanelWidgetComponent() {
        return DwMetadataFormConfigWidgetComponent;
    }
    getPanelDebugComponent() {
        if (this.uiMetaDataConfig.enableFormDesignerDebugPanel) {
            return DwMetadataFormDebugWidgetComponent;
        }
    }
    resetForm() {
        this.metaDataFormBuilderService.clearForm(this.formGroup);
        this.data = {};
        this.loadData(true);
        // this.configSequenceComplete = false;
        // this.formSetupComplete = false;
        // this.reSetupForm = true;
        // this.applyPreferences(this.preferenceHierarchy, true);
        // this.loadData(true);
        // // Reset form on dwFormControl
        // this.dwForm.setupForm();
    }
    setupConfig() {
        if (!this.item || !this.preferenceHierarchy)
            return;
        let ormDataHierarchy = [];
        if (this.overrideData) {
            // Update - only set data source once (was getting overwritten when data was updated) - 12/19/23
            if (!this.dataSource) {
                this.dataSource = this.data;
            }
            // Clear the data - this represents the raw form data going forward
            this.data = {};
        }
        else {
            const result = this.metaDataFormService.getFormDataSource(this.preferenceHierarchy);
            this.dataSource = result.dataSource;
            ormDataHierarchy = result.ormDataHierarchy;
        }
        // Clear the data - this represents the raw form data going forward
        this.data = {};
        if (this.formMode == DwFormContextMode.addEdit) {
            if (this.keyValue) {
                this.formMode = DwFormContextMode.edit;
            }
            else {
                this.formMode = DwFormContextMode.add;
            }
        }
        this.metaDataFormService.buildFormConfig(this.preferenceHierarchy, this.allowConfiguration, this.formMode, this.route, this.keyValue, ormDataHierarchy)
            .subscribe(formConfig => {
            this.setFormConfig(formConfig, true);
            // this.formConfig = formConfig;
            if (!formConfig || !formConfig.canAccess) {
                this.formSetupComplete = true;
                this.checkAllSetupComplete();
                return;
            }
            this.formMode = this.formConfig.formMode;
            this.setupForm();
            super.updateContext(this.formConfig.contextNames);
            this.dwFormContext.keyValue = this.keyValue;
            this.dwFormContext.initialContextMode = this.formMode;
            this.dwFormContext.contextMode = this.formMode;
            this.dwFormContext.rootItemName = this.formConfig.rootItemName;
            this.dwFormContext.isReadOnly = this.formConfig.readOnly;
            this.dwFormContext.isModal = this.isModal;
            if (this.dataSource.ormDataHierarchy) {
                this.dwFormContext.ormHierarchy = this.dataSource.ormDataHierarchy;
            }
            if (formConfig.queryMetaDataList) {
                this.dataSource.queryMetaDataList = formConfig.queryMetaDataList;
            }
            this.updateContextValue(DwMdFormContextInfo.FORM_CONTEXT_NAME, this.dwFormContext, this.isDataLoadComplete.value);
            this.updateFormState();
        });
    }
    handlePreferenceError(error) {
        const prefError = (error && error.message) ? error.message : error;
        this.configError = `Form Configuration Error: ${prefError}`;
        this.configComplete();
    }
    // #endregion
    formReady(formGroup) {
        if (!formGroup)
            return;
        this.formGroup = formGroup;
        this.setupForm();
    }
    setupForm() {
        if (!this.formGroup || !this.formConfig)
            return;
        if (this.reSetupForm) {
            this.reSetupForm = false;
        }
        setTimeout(() => {
            // console.log(`DwMetaDataFormComponent.setupForm - before setupFormControls`);
            // Setup all of the controls
            this.metaDataFormBuilderService.setupFormControls(this.formGroup, this.formConfig);
            this.formControlsSetup = true;
            this.dwFormContext.defaultsProcessed = false;
            this.setContextValueFormDefaults();
            DwFormDebugService.debugEvent(this.formGroup, 'Initial State');
            setTimeout(() => {
                this.formSetupComplete = true;
                // console.log(`DwMetaDataFormComponent.setupForm - formSetupComplete - setting data`, this.originalData, this.formGroup.value);
                if (this.originalData) {
                    // console.log('`DwMetaDataFormComponent.setupForm - patching original data', this.originalData);
                    this.formGroup.patchValue(this.originalData);
                    this.setupWorkflowStatus();
                }
                this.loadSecurityResults();
                // Setup all rules for the form config
                // let rules = this.metaDataFormService.getAllRules(this.formConfig);
                // this.dwRuleManagerService.setupRules(rules, this.context, this.formGroup);
                this.checkAllSetupComplete();
            }, 0);
        });
    }
    checkAllSetupComplete() {
        if (this.allSetupComplete) {
            return;
        }
        if (this.formSetupComplete && (this.dwFormContext.loadDataComplete || this.dwFormContext.contextMode == DwFormContextMode.add)) {
            this.allSetupComplete = true;
            this.allFormSetupComplete.emit();
        }
    }
    setupWorkflowStatus() {
        if (!this.formConfig || !this.originalData || !this.formConfig.workflowPreferences || !this.formConfig.workflowPreferences.enableWorkflow || !this.formConfig.workflowPreferences.workflowAttrName) {
            return;
        }
        this.workflowInitialStatusValue = this.originalData[this.formConfig.workflowPreferences.workflowAttrName];
    }
    /* saveComplete(cancelled: boolean, data?: any) {
        // Don't do anything here since save is now an observable
        return;
    } */
    redirectToPrevious(cancelled, data) {
        this.returnToPrevious.emit(cancelled);
        if (!this.handleRedirect)
            return;
        let keyValue;
        if (data && data._keyName) {
            keyValue = data[data._keyName];
        }
        this.metaDataRoutingService.routeToParent(this.route, this.item, null, keyValue, !cancelled);
    }
    /*
        Sets up the print form and returns the html
    */
    getPrintableHtml(formPrintConfig) {
        const printSetupSubject = new Subject();
        this.reloadPrintData = formPrintConfig === null || formPrintConfig === void 0 ? void 0 : formPrintConfig.reloadPrintData;
        this.currentPrintConfigKey = this.printConfigKeyPart || this.configKeyPart;
        if (formPrintConfig.printConfigKeyOverride) {
            this.currentPrintConfigKey = formPrintConfig.printConfigKeyOverride;
        }
        this.showPrintingForm = true;
        this.printDataSource.setupDataSource(this.data, this.item);
        let count = 0;
        const intervalKey = setInterval(() => {
            count++;
            // 10 second timeout
            if (count > 200) {
                clearInterval(intervalKey);
                printSetupSubject.next(null);
            }
            if (this.printMdForm) {
                // console.log(`DwMetaDataForm.setupPrintForm - form exists - ${count}`);
                // Check if everything is complete
                if (this.printMdForm.allSetupComplete && this.printFormVisible()) {
                    // console.log(`DwMetaDataForm.setupPrintForm - All Setup Complete - no subcribe - ${count}`);
                    if (!this.printMdForm.divForm) {
                        return;
                    }
                    clearInterval(intervalKey);
                    setTimeout(() => {
                        const html = this.printMdForm.divForm.nativeElement.innerHTML;
                        printSetupSubject.next(html);
                        this.showPrintingForm = false;
                    }, (formPrintConfig === null || formPrintConfig === void 0 ? void 0 : formPrintConfig.pdfRenderWaitTimeMs) | this.uiMetaDataConfig.pdfRenderWaitTimeMs | 500);
                    return;
                }
            }
        }, 50);
        return printSetupSubject.asObservable();
    }
    printFormVisible() {
        if (!this.printMdForm || !this.printMdForm.divForm) {
            return false;
        }
        const html = this.printMdForm.divForm.nativeElement.innerHTML;
        const rootDivIndex = html.indexOf('<div id="divRootHidden"');
        if (rootDivIndex > 0) {
            return true;
        }
        return false;
    }
    convertHtmlToPdf(formPrintConfig) {
        const pdfSubject = new Subject();
        this.getPrintableHtml(formPrintConfig)
            .subscribe((printFormHtml) => {
            if (!printFormHtml) {
                pdfSubject.next(null);
                return;
            }
            const defaultPdfFileName = 'Form.pdf';
            this.dwReportingService.convertHtmlToPdf(printFormHtml, 1, (formPrintConfig === null || formPrintConfig === void 0 ? void 0 : formPrintConfig.exportPDFFileName) || defaultPdfFileName, (formPrintConfig === null || formPrintConfig === void 0 ? void 0 : formPrintConfig.renderMultiplePage) || false)
                .subscribe(result => {
                const newResult = {
                    Base64Data: result.Base64Data,
                    FileName: result.FileName,
                    Html: printFormHtml
                };
                pdfSubject.next(newResult);
            });
        });
        return pdfSubject.asObservable();
    }
    print(formPrintConfig) {
        return this.convertHtmlToPdf(formPrintConfig)
            .pipe(map(result => {
            this.dwReportingService.saveExportAsFile(result, 'form.pdf');
            return {
                success: true
            };
        }));
    }
    validateForm() {
        return this.dwForm.validateForm();
    }
    saveData(requireValidation = true) {
        if (!this.dwForm)
            return of(null);
        this.dwLoggingUtil.logToConsole(`DwMetaDataForm.saveData`);
        return this.dwForm.saveData(requireValidation)
            .pipe(map(result => {
            return this.convertSaveResult(result);
        }));
    }
    convertSaveResult(result) {
        let message;
        const success = !result.savedFailed && !result.validationFailed;
        message = result.errorMessage;
        if (result.validationFailed) {
            this.setFormAsSubmitted();
            message = this.createValidationMessage(result.validationResult);
        }
        if (success) {
            message = 'Save Successful';
        }
        return {
            success: success,
            message: message,
            hideMessage: false,
            validationResult: result.validationResult,
            validationFailed: result.validationFailed,
            saveResult: result.saveResult
        };
    }
    cancel() {
        this.dwLoggingUtil.logToConsole(`DwMetaDataForm.cancel`);
        this.redirectToPrevious(true);
        return of({
            success: true,
            returnAfter: true
        });
    }
    loadData(forceRefresh) {
        if (!this.dwForm)
            return of(null);
        return this.dwForm.loadData(forceRefresh);
    }
    patchFormData(partialFormData) {
        this.dwForm.patchFormData(partialFormData);
    }
    getFormData() {
        return this.dwForm.getFormData();
    }
    getFormDataChanges(delayMs = 50, onlyUniqueChanges = true) {
        let previousData = '';
        return this.formGroup.valueChanges
            .pipe(debounceTime(delayMs), map(result => {
            return this.getFormData();
        }), filter(formData => {
            try {
                const currentData = JSON.stringify(formData);
                if (previousData === currentData) {
                    return false;
                }
                previousData = currentData;
            }
            catch (e) {
            }
            return true;
        }));
    }
    patchContextData(contextName, partialContextData) {
        var _a;
        const existingContextData = (_a = this.context[contextName]) === null || _a === void 0 ? void 0 : _a.value;
        const data = Object.assign(Object.assign({}, existingContextData), partialContextData);
        this.updateContextValue(contextName, data, true);
    }
    /**
     * Variable Context Methods
     * @returns
     */
    getVariableContext() {
        const variableContext = this.context[this.formConfig.variableContextDataKey];
        return variableContext;
    }
    getVariableContextValue() {
        return this.getVariableContext().value;
    }
    patchVariableContext(partialData) {
        const existingData = this.getVariableContextValue();
        const data = Object.assign(Object.assign({}, existingData), partialData);
        this.updateContextValue(this.formConfig.variableContextDataKey, data, true);
    }
    getVariableValue(variableName) {
        const varialbleContextValue = this.getVariableContextValue() || {};
        return varialbleContextValue[variableName];
    }
    setVariableValue(variableName, value) {
        const partialUpdate = {};
        partialUpdate[variableName] = value;
        this.patchVariableContext(partialUpdate);
    }
    createValidationMessage(validationResult) {
        const validationMessage = {
            severity: DwMessageSeverity.warning,
            allowClose: true,
        };
        if (this.formConfig.useValidationSummary) {
            validationMessage.messageHeading = validationResult.summaryHeading;
            validationMessage.messageBody = validationResult.summaryBodyHtml;
        }
        else {
            validationMessage.messageBody = validationResult.displayMessage;
        }
        return validationMessage;
    }
    triggerAction(actionEvent) {
        const actionPref = actionEvent.actionPreference;
        const onCompleteSubject = new Subject();
        const actionRegistration = this.uiConfigRegistryService.getRegisteredItem(DwUiRegistryType.action, actionPref.actionKey);
        this.subscriptions.push(this.dwMetaDataFormStateService.runBeforeActionIntercepters(actionEvent.actionPreference, actionRegistration)
            .pipe(delay(1))
            .subscribe(result => {
            if (result.abort) {
                this.showAbortMessage(result.message);
                onCompleteSubject.next({ success: false, message: result.message, cancelled: true });
                return;
            }
            this.continueAction(actionEvent, actionRegistration, onCompleteSubject);
        }));
        return onCompleteSubject.asObservable();
    }
    showAbortMessage(message) {
        let messageToShow;
        if (!message) {
            return;
        }
        if (typeof (message) === "string") {
            messageToShow = {
                messageBody: message,
                severity: DwMessageSeverity.error,
                allowClose: true,
            };
        }
        else {
            messageToShow = message;
        }
        ;
        this.setFormMessage(messageToShow);
    }
    continueAction(actionEvent, actionRegistration, onCompleteSubject) {
        var _a;
        const actionPref = actionEvent.actionPreference;
        if (this.dwMetaDataFormStateService.state.actionFiring) {
            onCompleteSubject.next({ success: false, message: 'Action already in progress' });
            return;
        }
        this.dwMetaDataFormStateService.setFormState({
            actionFiring: true,
            actionMessage: actionPref.actionConfig ? actionPref.actionConfig.actionMessage : '',
            actionContext: actionEvent.actionContext,
            actionPreference: actionEvent.actionPreference
        });
        ;
        const actionState = {
            command: actionPref.actionKey,
            config: this.formConfig,
            actionConfig: actionPref.actionConfig,
            actionPreference: actionPref,
            formApi: this,
            data: ((_a = actionEvent === null || actionEvent === void 0 ? void 0 : actionEvent.actionContext) === null || _a === void 0 ? void 0 : _a.levelData) || this.getFormData(),
            context: this.dwContextService.getResolvedContext(this.context),
            dwBrowserEvent: actionEvent.dwBrowserEvent,
            additionalActionContext: actionEvent.actionContext
        };
        if (actionPref.actionConfig && actionPref.actionConfig.requireValidation) {
            const validationResult = this.dwForm.validateForm();
            if (!validationResult.isValid) {
                this.setFormAsSubmitted();
                this.dwMetaDataFormStateService.setFormState({
                    actionFiring: false,
                    actionMessage: ''
                });
                ;
                const validationMessage = this.createValidationMessage(validationResult);
                this.setFormMessage(validationMessage);
                onCompleteSubject.next({ success: false, message: validationMessage });
                return;
            }
            if (actionPref.actionConfig.clearSubmittedAfterSucessfulValidation) {
                this.clearFormSubmitted();
            }
        }
        const ob = this.dwActionExecutionService.executeActionPreference(actionPref, actionState);
        ob.subscribe((actionResult) => {
            this.handleActionResult(actionEvent, actionRegistration, actionResult, onCompleteSubject);
        }, (error) => {
            let message = typeof (error) === 'string' ? error : error.message;
            this.handleActionResult(actionEvent, actionRegistration, {
                success: false,
                message: message,
            }, onCompleteSubject);
        });
    }
    handleActionResult(actionEvent, actionConfig, actionResult, onCompleteSubject) {
        this.dwMetaDataFormStateService.setFormState({
            actionFiring: false,
            actionMessage: null
        });
        // Fire all action interceptors
        this.subscriptions.push(this.dwMetaDataFormStateService.runAfterActionIntercepters(actionEvent.actionPreference, actionConfig, actionResult)
            .subscribe(result => {
            onCompleteSubject.next(actionResult);
            if (result.abort) {
                this.showAbortMessage(result.message);
                return;
            }
            this.continueHandleActionResult(actionEvent, actionConfig, actionResult);
        }));
    }
    continueHandleActionResult(actionEvent, actionConfig, actionResult) {
        if (!actionResult) {
            return;
        }
        const actionPref = actionEvent.actionPreference;
        const redirectAfter = (actionResult.rediectAfterOverride === true || actionResult.rediectAfterOverride === false) ? actionResult.rediectAfterOverride : actionPref.actionConfig.redirectAfter;
        // Go ahead and redirect without showing a message, otherwise it will just flash
        if ((actionResult.returnAfter === true || (actionResult.returnAfter !== false && redirectAfter)) && actionResult.success !== false) {
            this.allowRedirect = true;
            if (actionResult.redirectOverrideMenuKey) {
                this.navigationToMenuKey(actionEvent);
                return;
            }
            if (actionResult.redirectOverrideInternalUrl) {
                this.router.navigateByUrl(actionResult.redirectOverrideInternalUrl);
                return;
            }
            if (actionPref.actionConfig.customizeRedirect) {
                this.navigationToMenuKey(actionEvent);
                return;
            }
            this.redirectToPrevious(false, this.dwForm.formData);
            return;
        }
        let message = actionResult.message;
        if (!message && actionPref.actionConfig.showSuccessMessage) {
            message = actionPref.actionConfig.successMessage || `${actionPref.buttonConfig.buttonText || actionPref.actionDisplay} Successful`;
        }
        let messageToShow;
        if (typeof (message) === "string") {
            messageToShow = {
                messageBody: message,
                severity: actionResult.success ? DwMessageSeverity.success : DwMessageSeverity.error,
                allowClose: !actionResult.success,
                timeToShow: actionResult.success ? 5000 : null,
            };
        }
        else {
            messageToShow = message;
        }
        ;
        if (!actionResult.hideMessage) {
            this.setFormMessage(messageToShow);
        }
        else {
            this.clearFormMessage();
        }
    }
    navigationToMenuKey(actionEvent) {
        const actionPreference = actionEvent.actionPreference;
        const actionState = {
            actionConfig: {
                useUrl: false,
                menuKey: actionPreference.actionConfig.redirectMenuKey,
            },
            actionPreference: actionPreference,
            data: this.getFormData(),
            context: this.dwContextService.getResolvedContext(this.context),
            dwBrowserEvent: actionEvent.dwBrowserEvent
        };
        // passing null here since we don't want the standard behavior of a ctrl + click or middle click to open in a new window
        const windowOpenOptions = getWindowOpenOptions(null, actionState.actionConfig);
        this.dwRouteActionInternalLinkService.navigateToMenu(actionState, windowOpenOptions);
    }
    updateButtonPreference(button, buttonPreferences) {
        const index = this.formConfig.buttons.indexOf(button);
        if (index >= 0) {
            this.formConfig.buttons[index] = buttonPreferences;
        }
    }
}
DwMetaDataFormComponent.ɵfac = function DwMetaDataFormComponent_Factory(t) { return new (t || DwMetaDataFormComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwRuleManagerService), ɵngcc0.ɵɵdirectiveInject(DwReportingServiceToken), ɵngcc0.ɵɵdirectiveInject(DwLoggingService), ɵngcc0.ɵɵdirectiveInject(DwActionExecutionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwRouteActionInternalLinkService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwFormValidationServiceToken), ɵngcc0.ɵɵdirectiveInject(DwFormEventService)); };
DwMetaDataFormComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataFormComponent, selectors: [["dw-meta-data-form"]], viewQuery: function DwMetaDataFormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DwFormComponent, true);
        ɵngcc0.ɵɵviewQuery(_c6, true);
        ɵngcc0.ɵɵviewQuery(_c7, true);
        ɵngcc0.ɵɵviewQuery(_c8, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwForm = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.divForm = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.printMdForm = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.divRootHidden = _t.first);
    } }, inputs: { overrideData: "overrideData", handleRedirect: "handleRedirect", showButtons: "showButtons", isModal: "isModal", configKeyPart: "configKeyPart", formMode: "formMode", contextKeys: "contextKeys", allFormSetupComplete: "allFormSetupComplete", printFormMode: "printFormMode", data: "data", keyValue: "keyValue", item: "item", addContext: "addContext", printConfigKeyPart: "printConfigKeyPart" }, outputs: { dataChanged: "dataChanged", returnToPrevious: "returnToPrevious", dwFormContext: "dwFormContext" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DwMetaDataFormStateService,
            DwMetaDataFormSectionStateService,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwMetaDataFormComponent),
                multi: true
            },
            {
                provide: DwFormValidationServiceToken,
                useClass: DwMetaDataFormValidatorService
            }
        ], [DwMetaDataFormComponent]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 8, vars: 6, consts: [["text", "Loading", 3, "show"], ["class", "alert alert-danger", 4, "ngIf"], [1, "dw-form"], ["container", ""], [4, "ngIf"], [3, "target", "model", 4, "ngIf"], ["class", "dw-form-print-container", 4, "ngIf"], [1, "alert", "alert-danger"], [1, "fad", "fa-user-lock", "fa-2x", 2, "--fa-secondary-color", "red"], [3, "message", "messageChange", 4, "ngIf"], ["id", "divForm", 3, "ngClass"], ["divForm", ""], ["showButtons", "false", "hideErrorMessage", "true", "overrideFormDataSet", "true", 3, "data", "context", "addContext", "keyValue", "formReady", "formInvalid", "dataLoaded", "dataChanged"], ["dwForm", ""], ["id", "divRootHidden", 3, "hidden", 4, "ngIf"], ["classes", "dw-alert-top-margin", 3, "message", "messageChange", 4, "ngIf"], [3, "message", "messageChange"], ["id", "divRootHidden", 3, "hidden"], ["divRootHidden", ""], [3, "formConfig", "context", "sectionConfig", "formGroup", "submitted"], ["classes", "dw-alert-top-margin", 3, "message", "messageChange"], [3, "target", "model"], [1, "dw-form-print-container"], ["showButtons", "false", 3, "item", "overrideData", "keyValue", "data", "preferences", "formMode", "configKeyPart"], ["printMdForm", ""]], template: function DwMetaDataFormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "dw-loading", 0);
        ɵngcc0.ɵɵtemplate(1, DwMetaDataFormComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵtemplate(4, DwMetaDataFormComponent_div_4_Template, 4, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(5, DwMetaDataFormComponent_div_5_Template, 9, 11, "div", 4);
        ɵngcc0.ɵɵtemplate(6, DwMetaDataFormComponent_p_contextMenu_6_Template, 1, 2, "p-contextMenu", 5);
        ɵngcc0.ɵɵtemplate(7, DwMetaDataFormComponent_div_7_Template, 3, 7, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("show", !ctx.formSetupComplete && !ctx.configError);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configError);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configSequenceComplete && ctx.formConfig && ctx.formConfig.accessErrorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configSequenceComplete && ctx.formConfig && ctx.formConfig.canAccess);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contextMenu && ctx.contextMenu.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPrintingForm && ctx.data);
    } }, directives: function () { return [DwLoadingComponent, ɵngcc4.NgIf, ɵngcc4.NgClass, DwFormComponent, DwMessageComponent, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc7.ContextMenu, DwMetaDataFormComponent]; }, encapsulation: 2 });
DwMetaDataFormComponent.ctorParameters = () => [
    { type: Router },
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwMetaDataFormService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataRoutingService },
    { type: ActivatedRoute },
    { type: DwContextService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwRuleManagerService },
    { type: DwReportingService, decorators: [{ type: Inject, args: [DwReportingServiceToken,] }] },
    { type: DwLoggingService },
    { type: DwActionExecutionService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: DwRouteActionInternalLinkService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormValidatorService, decorators: [{ type: Inject, args: [DwFormValidationServiceToken,] }] },
    { type: DwFormEventService }
];
DwMetaDataFormComponent.propDecorators = {
    item: [{ type: Input }],
    keyValue: [{ type: Input }],
    overrideData: [{ type: Input }],
    data: [{ type: Input }],
    dataChanged: [{ type: Output }],
    handleRedirect: [{ type: Input }],
    showButtons: [{ type: Input }],
    isModal: [{ type: Input }],
    configKeyPart: [{ type: Input }],
    addContext: [{ type: Input }],
    formMode: [{ type: Input }],
    printConfigKeyPart: [{ type: Input }],
    contextKeys: [{ type: Input }],
    allFormSetupComplete: [{ type: Input }],
    returnToPrevious: [{ type: Output }],
    dwFormContext: [{ type: Output }],
    printFormMode: [{ type: Input }],
    dwForm: [{ type: ViewChild, args: [DwFormComponent,] }],
    divForm: [{ type: ViewChild, args: ['divForm', { static: false },] }],
    printMdForm: [{ type: ViewChild, args: ['printMdForm', { static: false },] }],
    divRootHidden: [{ type: ViewChild, args: ['divRootHidden', { static: false },] }]
};
__decorate$2([
    DwInputConverter(),
    __metadata$2("design:type", Boolean)
], DwMetaDataFormComponent.prototype, "overrideData", void 0);
__decorate$2([
    DwInputConverter(),
    __metadata$2("design:type", Boolean)
], DwMetaDataFormComponent.prototype, "handleRedirect", void 0);
__decorate$2([
    DwInputConverter(),
    __metadata$2("design:type", Boolean)
], DwMetaDataFormComponent.prototype, "showButtons", void 0);
__decorate$2([
    DwInputConverter(),
    __metadata$2("design:type", Boolean)
], DwMetaDataFormComponent.prototype, "isModal", void 0);

var __decorate$3 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$3 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwDefaultFormPage {
    constructor(route, router, dwModalService, dwMetaDataService, uiConfigService, metaDataConfig, dwRoutingService, dwMenuService, dwSecurityUserService) {
        this.route = route;
        this.router = router;
        this.dwModalService = dwModalService;
        this.dwMetaDataService = dwMetaDataService;
        this.uiConfigService = uiConfigService;
        this.metaDataConfig = metaDataConfig;
        this.dwRoutingService = dwRoutingService;
        this.dwMenuService = dwMenuService;
        this.dwSecurityUserService = dwSecurityUserService;
        this.closeModal = new EventEmitter();
        this.formMode = DwFormContextMode.addEdit;
        this.showContent = true;
        this.subscriptions = [];
        this.textboxControlType = DwControlType.Textbox;
        this.overrideData = false;
        this.outletName = 'Form';
        this.isModal = false;
        this.securityChanging = false;
        DwDefaultFormPage.formCount++;
    }
    get contentConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}-form`;
        return `${itemName}-${this.configKeyPart}-defaultForm`;
    }
    canNavigate() {
        var _a, _b;
        if (!this.mdForm || !this.mdForm.hasChanges()) {
            return of(true);
        }
        const config = {
            title: ((_a = this.metaDataConfig) === null || _a === void 0 ? void 0 : _a.formUnsavedChangesInfo.title) || 'Leave page?',
            message: ((_b = this.metaDataConfig) === null || _b === void 0 ? void 0 : _b.formUnsavedChangesInfo.message) || 'You have unsaved changes. Are you sure you wish to leave?',
            useConfirmDefaults: true,
            showConfirmDialog: true
        };
        return this.dwModalService.showConfirmDialog(config)
            .pipe(map(dialogResult => {
            return dialogResult;
        }));
    }
    ngOnInit() {
        this.setupPageFromMenu();
        this.dwMenuService.menuStateObservable.subscribe(() => {
            this.setupPageFromMenu();
        });
        this.dwSecurityUserService.securityContextChanged().subscribe(() => {
            this.securityChanging = true;
            setTimeout(() => {
                this.securityChanging = false;
            }, 250);
        });
    }
    setupPageFromMenu() {
        var _a, _b, _c, _d, _e, _f, _g;
        // Don't configure stuff on modals
        if (this.isModal) {
            return;
        }
        this.routeDetail = this.dwMenuService.getRouteDetail(this.route);
        if (this.routeDetail) {
            this.outletName = `Form-${this.routeDetail.itemName}`;
            if (this.routeDetail.configKeyPart) {
                this.configKeyPart = this.routeDetail.configKeyPart;
            }
            if (this.routeDetail.printConfigKeyPart) {
                this.printConfigKeyPart = this.routeDetail.printConfigKeyPart;
            }
            if (!this.routeDetail.itemName) {
                return;
            }
            if ((!this.item || this.item !== this.routeDetail.itemName) || (!this.keyValue || this.keyValue !== this.routeDetail.keyValue)) {
                this.item = this.routeDetail.itemName;
                if (this.item || this.keyValue != this.routeDetail.keyValue) {
                    this.toggleContent();
                }
                if (this.routeDetail.keyValue) {
                    this.keyValue = this.routeDetail.keyValue;
                }
                this.toggleContent();
            }
            this.formMode = this.routeDetail.contextMode;
        }
        this.menu = this.dwMenuService.menuState.currentMenu;
        this.currentParams = this.dwMenuService.menuState.currentParams;
        if (!this.menu || !this.currentParams) {
            return;
        }
        return;
        // Ensure that current Params is an instance of DwMenuParams
        if (this.currentParams instanceof DwMenuParams === false) {
            this.currentParams = new DwMenuParams(this.currentParams);
        }
        if ((_a = this.menu.data) === null || _a === void 0 ? void 0 : _a.configKeyPart) {
            this.configKeyPart = this.menu.data.configKeyPart;
        }
        if ((_b = this.menu.data) === null || _b === void 0 ? void 0 : _b.printConfigKeyPart) {
            this.printConfigKeyPart = this.menu.data.printConfigKeyPart;
        }
        const itemName = ((_c = this.currentParams) === null || _c === void 0 ? void 0 : _c.get('itemName')) || ((_d = this.menu.data) === null || _d === void 0 ? void 0 : _d.metaDataItem);
        const keyValueParamName = getMenuActionParamName(itemName);
        let keyValue = (_e = this.currentParams) === null || _e === void 0 ? void 0 : _e.get(keyValueParamName);
        if (!keyValue) {
            keyValue = (_f = this.currentParams) === null || _f === void 0 ? void 0 : _f.get('keyValue');
        }
        if (!itemName) {
            return;
        }
        if (!this.item || (this.item && this.item !== itemName) || this.keyValue !== keyValue) {
            if (this.item || this.keyValue != keyValue) {
                this.toggleContent();
            }
            this.item = itemName;
            this.keyValue = keyValue;
        }
        this.setupFormContxtMode((_g = this.menu.data) === null || _g === void 0 ? void 0 : _g.metaDataActionType);
    }
    setupFormContxtMode(actionType) {
        // Translate from the menu action type to a form mode
        switch (actionType) {
            case DwMenuActionType.add:
                this.formMode = DwFormContextMode.add;
                break;
            case DwMenuActionType.edit:
                this.formMode = DwFormContextMode.edit;
                break;
            case DwMenuActionType.view:
                this.formMode = DwFormContextMode.view;
                break;
            case DwMenuActionType.print:
                this.formMode = DwFormContextMode.print;
                break;
            case DwMenuActionType.addEdit:
                this.formMode = DwFormContextMode.addEdit;
                break;
        }
    }
    // private setupPage(force: boolean = false) {
    //     this.routeMenuData = this.getRouteMenueData(this.route);
    //     if (this.routeMenuData.configKeyPart) {
    //         this.configKeyPart = this.routeMenuData.configKeyPart;
    //     }
    //     if (this.routeMenuData.printConfigKeyPart) {
    //         this.printConfigKeyPart = this.routeMenuData.printConfigKeyPart;
    //     }
    //     this.populateParams(this.route, force);
    //     if (this.routeMenuData  && this.routeMenuData.metaDataActionType) {
    //         this.setupFormContxtMode(this.routeMenuData.metaDataActionType);
    //     }
    // }
    // private populateParams(route: ActivatedRoute, force: boolean = false) {
    //     if (!route) {
    //         return;
    //     }
    //     if (!this.item || !this.keyValue || force) {
    //         const params = route.snapshot.paramMap;
    //         //route.paramMap.subscribe((params: ParamMap) => {
    //             let itemName = params.get('itemName');
    //             if (!itemName) {
    //                 itemName = this.routeMenuData.metaDataItem;
    //             }
    //             if (itemName && (!this.item || this.item !== itemName)) {
    //                 // console.log(`DefaultFormPage ${DwDefaultFormPage.formCount} - setting Item name ${itemName}`);
    //                 this.toggleContent();
    //                 this.item = itemName;
    //             }
    //             const paramName = getMenuActionParamName(itemName);
    //             let keyValue = params.get(paramName.replace(':',''));
    //             // Check if the key value is null, if so, use the keyValue property - this is needed to meta data admin to work with generic item keys
    //             if (!keyValue) {
    //                 keyValue = params.get('keyValue');
    //             }
    //             if (keyValue && this.keyValue !== keyValue) {
    //                 this.keyValue = keyValue;
    //                 this.toggleContent();
    //             }
    //             // Continue up hierarchy until all params are populated
    //             this.populateParams(route.parent, force);
    //     }
    // }
    toggleContent() {
        this.showContent = false;
        setTimeout(() => {
            this.showContent = true;
        }, 50);
    }
    // getRouteMenueData(route: ActivatedRoute) : DwMenuData {
    //     if (route.snapshot.routeConfig) {
    //         var routeConfig = route.snapshot.routeConfig;            
    //         const dwMenuData: DwMenuData = <DwMenuData>this.route.snapshot.data;
    //         if (dwMenuData) {
    //             return dwMenuData;
    //         }
    //     }
    //     return new DwMenuData;
    // }
    returnToPrevious(cancelled) {
    }
    get modalConfig() {
        return this._modalConfig;
    }
    set modalConfig(value) {
        if (!value || !value.data)
            return;
        this._modalConfig = value;
        this.isModal = true;
        // console.log(`DefaultFormPage ${DwDefaultFormPage.formCount} - Modal Setup - item : ${value?.data?.item}`);
        if (value.data.item)
            this.item = value.data.item;
        if (value.data.keyValue)
            this.keyValue = value.data.keyValue;
        if (value.data.formPreferences)
            this.formPreferences = value.data.formPreference;
        if (value.data.addContext)
            this.addContext = value.data.addContext;
        if (value.data.configKeyPart && value.data.forceConfigKeyPart) {
            this.configKeyPart = value.data.configKeyPart;
        }
        // This causes problems with previous configured UIs (granted this may cause issues with more recent apps like Vendor Portal, but not using many modals)
        /*  if(value.data.configKeyPart) {
             this.configKeyPart = value.data.configKeyPart;
         } */
        if (value.data.dataSource) {
            this.data = value.data.dataSource;
            this.overrideData = true;
        }
        this.setupFormContxtMode(value.data.actionType);
    }
    buttonClick(buttonConfig) {
        switch (buttonConfig.command) {
            case DwButtonCommand.save:
            case DwButtonCommand.saveAndClose:
                return this.modalSave(buttonConfig);
            case DwButtonCommand.cancel:
                let modalResult = new DwModalResult();
                modalResult.cancelled = true;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
                return of(modalResult);
            case DwButtonCommand.delete:
                throw new Error("Delete not implemented");
        }
        throw new Error("No buttons to handle this event!");
    }
    modalSave(buttonConfig) {
        const actionEvent = {
            actionPreference: {
                actionKey: DwFormActionKeys.formSave,
                actionDisplay: 'Save',
                actionConfig: {
                    redirectAfter: false,
                    requireValidation: true
                }
            },
            dwBrowserEvent: null,
        };
        return this.mdForm.triggerAction(actionEvent)
            .pipe(map((actionResultRaw) => {
            // Since we're only handling saves, we can assume the result is a save result
            const actionResult = actionResultRaw;
            let modalResult = new DwModalResult();
            modalResult.cancelled = false;
            modalResult.data = actionResult === null || actionResult === void 0 ? void 0 : actionResult.saveResult;
            modalResult.closeModal = false;
            modalResult.buttonCommand = buttonConfig.command;
            modalResult.cancelled = actionResult.cancelled;
            if (actionResult.success && buttonConfig.command === DwButtonCommand.saveAndClose) {
                modalResult.closeModal = true;
            }
            return modalResult;
        }));
    }
    // modalSaveDirect(): Observable<DwModalResult<any>> {
    //     return this.mdForm.saveData()
    //         .pipe(map(data => {
    //             let modalResult = new DwModalResult();
    //             modalResult.cancelled = false;
    //             modalResult.data = data;
    //             modalResult.closeModal = false;
    //             modalResult.buttonCommand = buttonConfig.command;
    //             if (data.success && buttonConfig.command === DwButtonCommand.saveAndClose) {
    //                 modalResult.closeModal = true;
    //             }
    //             return modalResult;
    //         }));
    // }
    onCloseModal(cancelled, data = null) {
        let result = new DwModalResult();
        result.cancelled = cancelled;
        result.data = data;
        this.closeModal.emit(result);
        //this.dwModalService.closeModal(this.modalConfig, result);    
    }
    ngOnDestroy() {
    }
}
DwDefaultFormPage.ɵfac = function DwDefaultFormPage_Factory(t) { return new (t || DwDefaultFormPage)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwRoutingService), ɵngcc0.ɵɵdirectiveInject(DwMenuService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService)); };
DwDefaultFormPage.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDefaultFormPage, selectors: [["dw-default-form"]], viewQuery: function DwDefaultFormPage_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DwMetaDataFormComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mdForm = _t.first);
    } }, inputs: { formMode: "formMode", overrideData: "overrideData", configKeyPart: "configKeyPart", item: "item", keyValue: "keyValue", formPreferences: "formPreferences", addContext: "addContext", data: "data" }, outputs: { closeModal: "closeModal" }, decls: 2, vars: 2, consts: [["useIf", "false", 3, "useModalOutlet", "outletName"], [4, "ngIf"], [3, "configKey", "item"], ["name", "title", "display", "Page Title", 3, "controlType"], ["name", "detail", "display", "Header Details"], ["name", "component", "display", "Custom Component"], [3, "item", "overrideData", "data", "addContext", "keyValue", "configKeyPart", "printConfigKeyPart", "preferences", "handleRedirect", "showButtons", "isModal", "formMode", "returnToPrevious"], ["mdForm", ""]], template: function DwDefaultFormPage_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-router-parent", 0);
        ɵngcc0.ɵɵtemplate(1, DwDefaultFormPage_ng_template_1_Template, 1, 1, "ng-template");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("useModalOutlet", ctx.isModal)("outletName", ctx.outletName);
    } }, directives: function () { return [DwRouterParentComponent, ɵngcc4.NgIf, DwContentManagerComponent, DwContentDirective, DwContentComponent, DwMetaDataFormComponent]; }, encapsulation: 2 });
DwDefaultFormPage.formCount = 0;
DwDefaultFormPage.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: DwModalService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwUiConfigService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwRoutingService },
    { type: DwMenuService },
    { type: DwSecurityUserService }
];
DwDefaultFormPage.propDecorators = {
    item: [{ type: Input }],
    keyValue: [{ type: Input }],
    formPreferences: [{ type: Input }],
    closeModal: [{ type: Output }],
    addContext: [{ type: Input }],
    formMode: [{ type: Input }],
    configKeyPart: [{ type: Input }],
    overrideData: [{ type: Input }],
    data: [{ type: Input }],
    mdForm: [{ type: ViewChild, args: [DwMetaDataFormComponent, { static: false },] }]
};
__decorate$3([
    DwInputConverter(booleanConverter),
    __metadata$3("design:type", Object)
], DwDefaultFormPage.prototype, "overrideData", void 0);

class DwServerCacheService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        // Returns that emulation is allowed with this repository
        this.emulateSupported = true;
        this.apiRoot = configService.coreConfig.apiRoot;
    }
    clearAllCaches() {
        let url = `${this.apiRoot}/general/cache`;
        return this.http.delete(url);
    }
    clearCache(cacheName) {
        let url = `${this.apiRoot}/general/cache?cacheName=${cacheName}`;
        return this.http.delete(url);
    }
}
DwServerCacheService.ɵfac = function DwServerCacheService_Factory(t) { return new (t || DwServerCacheService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken)); };
DwServerCacheService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwServerCacheService, factory: DwServerCacheService.ɵfac });
DwServerCacheService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];

class CacheAdminComponent {
    constructor(cacheService, serverCacheService, dwMessageService) {
        this.cacheService = cacheService;
        this.serverCacheService = serverCacheService;
        this.dwMessageService = dwMessageService;
    }
    clearAllCaches() {
        this.clearServerCache();
        this.clearClientCache();
    }
    clearServerCache() {
        this.serverCacheService.clearAllCaches()
            .subscribe(r => {
            this.dwMessageService.showMessage({ messageHeading: 'Server Cache Clear Complete' });
        });
    }
    clearClientCache() {
        this.cacheService.clearAllClientCaches();
        this.dwMessageService.showMessage({ messageHeading: 'Client Cache Clear Complete', messageBody: 'Please press F5 to refresh your browser!' });
    }
}
CacheAdminComponent.ɵfac = function CacheAdminComponent_Factory(t) { return new (t || CacheAdminComponent)(ɵngcc0.ɵɵdirectiveInject(DwCacheService), ɵngcc0.ɵɵdirectiveInject(DwServerCacheService), ɵngcc0.ɵɵdirectiveInject(DwMessagingService)); };
CacheAdminComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CacheAdminComponent, selectors: [["cache-admin"]], decls: 10, vars: 0, consts: [[1, "hand", "link", 3, "click"], [1, "hand", 3, "click"]], template: function CacheAdminComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "a", 0);
        ɵngcc0.ɵɵlistener("click", function CacheAdminComponent_Template_a_click_1_listener() { return ctx.clearAllCaches(); });
        ɵngcc0.ɵɵtext(2, "Clear All Caches");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "br");
        ɵngcc0.ɵɵelementStart(4, "a", 1);
        ɵngcc0.ɵɵlistener("click", function CacheAdminComponent_Template_a_click_4_listener() { return ctx.clearServerCache(); });
        ɵngcc0.ɵɵtext(5, "Clear Server Caches");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "br");
        ɵngcc0.ɵɵelementStart(7, "a", 1);
        ɵngcc0.ɵɵlistener("click", function CacheAdminComponent_Template_a_click_7_listener() { return ctx.clearClientCache(); });
        ɵngcc0.ɵɵtext(8, "Clear Client Caches");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "br");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
CacheAdminComponent.ctorParameters = () => [
    { type: DwCacheService },
    { type: DwServerCacheService },
    { type: DwMessagingService }
];

var __rest$2 = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// @dynamic
class DwMetaDataRoutingRegistryService {
    constructor(dwRoutingService, router, dwMenuService, dwMenuBuilderService
    //private routingRepositoryService: DwMetaDataRoutingRepositoryService
    ) {
        this.dwRoutingService = dwRoutingService;
        this.router = router;
        this.dwMenuService = dwMenuService;
        this.dwMenuBuilderService = dwMenuBuilderService;
    }
    static get dynamicRoutes() {
        return DwMetaDataRoutingRegistryService._dynamicRoutes;
    }
    static addRoute(dynamicRoute) {
        DwMetaDataRoutingRegistryService._dynamicRoutes.push(dynamicRoute);
    }
    static addRoutes(dynamicRoutes) {
        for (const route of dynamicRoutes) {
            DwMetaDataRoutingRegistryService._dynamicRoutes.push(route);
        }
    }
    static addDynamicMenu(dynamicMenu) {
        DwMetaDataRoutingRegistryService._dynamicMenus.push(dynamicMenu);
    }
    static addDynamicMenus(dynamicMenus) {
        for (const dynamicMenu of dynamicMenus) {
            DwMetaDataRoutingRegistryService._dynamicMenus.push(dynamicMenu);
        }
    }
    static addMetaDataRoute(metaDataRoute) {
        DwMetaDataRoutingRegistryService._dynamicRoutes.push(metaDataRoute);
    }
    static addMetaDataRoutes(metaDataRoutes) {
        for (let metaDataRoute of metaDataRoutes) {
            DwMetaDataRoutingRegistryService._dynamicRoutes.push(metaDataRoute);
        }
    }
    static addRoutingInit(routingInitFunc) {
        this._routingInitFunctions.push(routingInitFunc);
    }
    resetDynamicRoutes() {
        DwMetaDataRoutingRegistryService._dynamicRoutes = [];
        DwMetaDataRoutingRegistryService._dynamicMenus = [];
    }
    registreDynamicMenus(reRegistering = false) {
        if (!reRegistering) {
            DwMetaDataRoutingRegistryService.originalRoutes = this.copyRoutes(this.router.config, true);
        }
        this.processRouteInitFunctions();
        const originalMenus = this.dwMenuBuilderService.buildMenusFromRoutes(DwMetaDataRoutingRegistryService.originalRoutes);
        const convertedDynamicMenus = this.convertDynamicRoutesToMenus();
        const dynamicMenus = DwMetaDataRoutingRegistryService._dynamicMenus;
        // Put all the menus into one array (some will be flat, others will contain a hierarchy);
        const allMenus = [...dynamicMenus, ...convertedDynamicMenus, ...originalMenus];
        const menuHierarchy = this.dwMenuBuilderService.buildMenuHierarchy(allMenus);
        this.dwMenuService.setAllMenuItems(menuHierarchy);
        return;
    }
    convertDynamicRoutesToMenus() {
        const routes = [];
        for (let dynamicRoute of DwMetaDataRoutingRegistryService.dynamicRoutes) {
            let route;
            if (dynamicRoute.metaDataItem) {
                route = this.createMetaDataRoute(dynamicRoute);
            }
            else {
                route = dynamicRoute;
            }
            routes.push(route);
        }
        const menus = this.dwMenuBuilderService.buildMenusFromRoutes(routes);
        return menus;
    }
    registerDynamicRoutes(reRegistering = false) {
        return this.registreDynamicMenus(reRegistering);
    }
    /**
     * Recursively copy all routes while preserving references to types/functions
     * @param routes
     */
    copyRoutes(routes, markAsStaticRoute) {
        const newRoutes = [];
        routes = routes || [];
        for (const route of routes) {
            const { children, component, canActivate, canActivateChild, canDeactivate } = route, other = __rest$2(route, ["children", "component", "canActivate", "canActivateChild", "canDeactivate"]);
            const newRoute = Object.assign(Object.assign({}, route), { component: component, canActivate: canActivate, canActivateChild: canActivateChild, canDeactivate: canDeactivate });
            if (markAsStaticRoute) {
                newRoute.data = newRoute.data || {};
                const routeData = newRoute.data;
                routeData.hasStaticRoute = true;
            }
            if (children) {
                newRoute.children = this.copyRoutes(children, markAsStaticRoute);
            }
            newRoutes.push(newRoute);
        }
        return newRoutes;
    }
    processRouteInitFunctions() {
        const obs = [];
        for (const routeInitFunc of DwMetaDataRoutingRegistryService._routingInitFunctions) {
            routeInitFunc();
        }
    }
    createMetaDataRoute(metaDataRoute) {
        let itemname = metaDataRoute.metaDataItem;
        let editItemname = itemname;
        if (metaDataRoute.editMetaDataItem) {
            editItemname = metaDataRoute.editMetaDataItem;
        }
        var editConfigKeyPart = metaDataRoute.editConfigKeyPart || metaDataRoute.data.configKeyPart;
        var addConfigKeyPart = metaDataRoute.addConfigKeyPart || metaDataRoute.editConfigKeyPart || metaDataRoute.data.configKeyPart;
        var viewConfigKeyPart = metaDataRoute.viewConfigKeyPart || metaDataRoute.editConfigKeyPart || metaDataRoute.data.configKeyPart;
        var printConfigKeyPart = metaDataRoute.printConfigKeyPart || metaDataRoute.viewConfigKeyPart || metaDataRoute.editConfigKeyPart || metaDataRoute.data.configKeyPart;
        var route = {
            path: metaDataRoute.path,
            component: metaDataRoute.component || DwDefaultGridPage,
            data: this.setMenuData({
                metaDataItem: itemname,
                metaDataActionType: DwMenuActionType.list,
                parentReferenceKey: metaDataRoute.parentName || metaDataRoute.path,
                hasStaticRoute: true,
            }, metaDataRoute.data),
            children: [
                {
                    path: getMenuActionTypePath(editItemname, DwMenuActionType.add),
                    component: DwDefaultFormPage,
                    data: this.setMenuData({
                        display: 'Add',
                        //iconCssClass: 'fa fa-address-card',
                        excludeFromMainMenu: true,
                        metaDataItem: editItemname,
                        metaDataActionType: DwMenuActionType.add,
                        showInMenu: false,
                        configKeyPart: addConfigKeyPart,
                        printConfigKeyPart: printConfigKeyPart,
                        isChild: true,
                        hasStaticRoute: true,
                    }, metaDataRoute.data),
                },
                {
                    path: getMenuActionTypePath(editItemname, DwMenuActionType.edit),
                    component: DwDefaultFormPage,
                    data: this.setMenuData({
                        display: 'Edit',
                        excludeFromMainMenu: true,
                        metaDataItem: editItemname,
                        metaDataActionType: DwMenuActionType.edit,
                        showInMenu: false,
                        configKeyPart: editConfigKeyPart,
                        printConfigKeyPart: printConfigKeyPart,
                        isChild: true,
                        hasStaticRoute: true,
                    }, metaDataRoute.data),
                },
                {
                    path: getMenuActionTypePath(editItemname, DwMenuActionType.view),
                    component: DwDefaultFormPage,
                    data: this.setMenuData({
                        display: 'View',
                        excludeFromMainMenu: true,
                        metaDataItem: editItemname,
                        metaDataActionType: DwMenuActionType.view,
                        showInMenu: false,
                        configKeyPart: viewConfigKeyPart,
                        printConfigKeyPart: printConfigKeyPart,
                        isChild: true,
                        hasStaticRoute: true,
                    }, metaDataRoute.data),
                },
                {
                    path: getMenuActionTypePath(editItemname, DwMenuActionType.print),
                    component: DwDefaultFormPage,
                    data: this.setMenuData({
                        display: 'Print',
                        excludeFromMainMenu: true,
                        metaDataItem: editItemname,
                        metaDataActionType: DwMenuActionType.print,
                        showInMenu: false,
                        configKeyPart: printConfigKeyPart,
                        isChild: true,
                        hasStaticRoute: true,
                    }, metaDataRoute.data),
                },
            ]
        };
        return route;
    }
    // private addRouteGuards(route: Route) {
    //     route.canActivate = route.canActivate || [];
    //     route.canActivate.push(DwAuthGuardService);
    //     if (route.children) {
    //         for (const childRoute of route.children) {
    //             this.addRouteGuards(childRoute);
    //         }
    //     }
    // }
    setMenuData(menuData, defaultMenuData) {
        return defaults(menuData, defaultMenuData, {
            // Security defaults
            requireAuthentication: true,
            useEmulatedPermissions: true,
        });
    }
}
DwMetaDataRoutingRegistryService.ɵfac = function DwMetaDataRoutingRegistryService_Factory(t) { return new (t || DwMetaDataRoutingRegistryService)(ɵngcc0.ɵɵinject(DwRoutingService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwMenuService), ɵngcc0.ɵɵinject(DwMenuBuilderService)); };
DwMetaDataRoutingRegistryService._dynamicRoutes = [];
DwMetaDataRoutingRegistryService._dynamicRoutesLoaded = false;
DwMetaDataRoutingRegistryService._dynamicMenus = [];
DwMetaDataRoutingRegistryService._routingInitFunctions = [];
DwMetaDataRoutingRegistryService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataRoutingRegistryService_Factory() { return new DwMetaDataRoutingRegistryService(ɵɵinject(DwRoutingService), ɵɵinject(Router), ɵɵinject(DwMenuService), ɵɵinject(DwMenuBuilderService)); }, token: DwMetaDataRoutingRegistryService, providedIn: "root" });
DwMetaDataRoutingRegistryService.ctorParameters = () => [
    { type: DwRoutingService },
    { type: Router },
    { type: DwMenuService },
    { type: DwMenuBuilderService }
];

class DwSecurityPermissions {
}
DwSecurityPermissions.AdminCanAccess = "Ent_AdminCanAccess";
DwSecurityPermissions.SecurityCanEmulate = "Ent_Security_CanEmulate";
DwSecurityPermissions.SecurityCanLogin = "Ent_Security_CanLogin";
DwSecurityPermissions.AdminSecurityCanAccess = "Ent_Admin_SecurityCanAccess";
DwSecurityPermissions.AdminSecurityCanAdminUsers = "Ent_Admin_SecurityCanAdminUsers";
DwSecurityPermissions.AdminSecurityCanAdminAdvanced = "Ent_Admin_SecurityCanAdminAdvanced";
DwSecurityPermissions.AdminOtherCanAccess = "Ent_Admin_OtherCanAccess";
DwSecurityPermissions.Ent_Admin_MetaDataCanAdmin = "Ent_Admin_MetaDataCanAdmin";

function DwRoutingInitDecorator() {
    //console.log("DwRoutingInitDecorator");
    return function (target, propertyKey, descriptor) {
        let func = target[propertyKey];
        DwMetaDataRoutingRegistryService.addRoutingInit(func);
    };
}

function DwComponent(compDef) {
    return function (constructor) {
        DwComponentFunc(compDef, constructor);
    };
}
function DwComponentFunc(compDef, component) {
    let componentRef = Object.assign(Object.assign({}, compDef), { key: compDef.key || compDef.name, component: component });
    let uiConfigRegistyService = new DwUiConfigRegistryService();
    uiConfigRegistyService.registerComponent(componentRef);
}
// export function DwComponent<T>(compDef : {
//     name : string,
//     key?: string,
//     componentType : DwComponentType,
//     parentItemName? : string | string[],
//     isGlobal?: boolean,
//     configComponent?: Type<any>,
//     configData?: T;
// }) {
//     return function (constructor: Function) {
//         let componentRef : DwUiComponentReference<T> = {
//              name : compDef.name,
//              key: compDef.key || compDef.name,
//              componentType : compDef.componentType,
//              parentItemName : compDef.parentItemName,
//              isGlobal : compDef.isGlobal,
//              configComponent: compDef.configComponent,
//              component: null,
//              configData: compDef.configData
//         }
//         componentRef.component = <Type<any>>constructor;
//         let uiConfigRegistyService = new DwUiConfigRegistryService();
//         uiConfigRegistyService.registerComponent(componentRef);
//     }
// }
// export function DwComponentFunc<ActionConfigType = any>(actionDef : Omit<DwUiComponentReference<ActionConfigType>,'component'>, actionComponent: Type<any>) {
//     let actionRef : DwActionHandlerRegistration<ActionConfigType> = {
//         ...actionDef,
//         keyName: actionDef.keyName || actionDef.display,
//         isGlobal: actionDef.isGlobal || false,
//         actionComponent : actionComponent,
//         decoratorType : actionDef.decoratorType || DwDecoratorType.service
//     };
//     let uiConfigRegistyService = new DwUiConfigRegistryService();
//     uiConfigRegistyService.registerItem(DwUiRegistryType.action, actionRef);
// }

var DwComponentType;
(function (DwComponentType) {
    DwComponentType["formControl"] = "Form Control";
    DwComponentType["formSection"] = "Form Section";
    DwComponentType["filterItem"] = "Filter Item";
    DwComponentType["filterTile"] = "Filter Tile";
    DwComponentType["pageComponent"] = "Page Component";
    DwComponentType["card"] = "Card";
    DwComponentType["emailDesignSection"] = "Email Design Section";
    DwComponentType["pageDesignSection"] = "Page Design Section";
    DwComponentType["sideMenuReplacement"] = "Side Menu Replacement";
    DwComponentType["menuComponent"] = "Menu Component";
})(DwComponentType || (DwComponentType = {}));

class DwRoutingAdminRepositoryService {
    constructor(ormDataService) {
        this.ormDataService = ormDataService;
    }
    loadRoutes() {
        const query = this.buildRouteQuery();
        return this.ormDataService.executeQuery(query);
    }
    loadRouteCategories() {
        const query = new DwQuery(DevwareMetaDataItemNames.DwRouteCategory);
        return this.ormDataService.executeQuery(query);
    }
    loadRouteTypes() {
        const query = new DwQuery(DevwareMetaDataItemNames.DwRouteType);
        return this.ormDataService.executeQuery(query);
    }
    saveRoutes(routeEntities) {
        const parentMap = this.buildParentMapping(routeEntities);
        // Just save these direct for now, but will more likely need to resave with parent ids
        return this.ormDataService.saveEntityCollection(routeEntities)
            .pipe(mergeMap((savedRouteEntities) => {
            // Map any new route ids to use as a translation
            const keyMapping = this.buildKeyMapping(routeEntities, savedRouteEntities);
            // Use the key mapping to fix any parent ids (theses couldn't have been saved the first time due to referential integrity)
            const resave = this.updateParentIds(routeEntities, savedRouteEntities, parentMap, keyMapping);
            if (resave) {
                return this.ormDataService.saveEntityCollection(savedRouteEntities)
                    .pipe(mergeMap((savedRouteEntities) => {
                    return this.loadRoutes()
                        .pipe(map(reloadedEntities => {
                        return { routeEntities: reloadedEntities, keyMap: keyMapping };
                    }));
                }));
            }
            return this.loadRoutes()
                .pipe(map(reloadedEntities => {
                return { routeEntities: reloadedEntities, keyMap: keyMapping };
            }));
        }));
    }
    buildRouteQuery() {
        const dwMd = new DevwareMetaDataService();
        const query = new DwQuery(DevwareMetaDataItemNames.DwRoute);
        query.AddField(dwMd.DwMetaDataItem.UniqueItemName);
        query.AddField(dwMd.DwRouteCategory.CategoryMeaning);
        query.FieldSettings.IncludeRootItemFields = true;
        return query;
    }
    buildParentMapping(routeEntities) {
        const parentMapping = new Map();
        for (let index = 0; index < routeEntities.length; index++) {
            const routeEntity = routeEntities[index];
            if (routeEntity.ParentRouteId < 0) {
                parentMapping.set(routeEntity.RouteId, routeEntity.ParentRouteId);
                // Clear the parent route since this will cause an FK error.  We'll re-map it after saved when we can get the parents Pk
                routeEntity.ParentRouteId = null;
            }
        }
        return parentMapping;
    }
    buildKeyMapping(routeEntities, savedRouteEntities) {
        const keyMapping = new Map();
        for (let index = 0; index < savedRouteEntities.length; index++) {
            const routeEntity = routeEntities[index];
            const savedRouteEntity = savedRouteEntities[index];
            if (routeEntity.RouteId !== savedRouteEntity.RouteId) {
                keyMapping.set(routeEntity.RouteId, savedRouteEntity.RouteId);
            }
        }
        return keyMapping;
    }
    updateParentIds(routeEntities, savedRouteEntities, parentMap, keyMap) {
        let resaveEntities = false;
        for (let index = 0; index < savedRouteEntities.length; index++) {
            const routeEntity = routeEntities[index];
            const savedRouteEntity = savedRouteEntities[index];
            // Get original Parent route Id
            const parentRouteId = parentMap.get(routeEntity.RouteId);
            if (parentRouteId) {
                const newParentRouteId = keyMap.get(parentRouteId);
                savedRouteEntity.ParentRouteId = newParentRouteId;
                resaveEntities = true;
            }
            if (routeEntity.RouteId !== savedRouteEntity.RouteId) {
                keyMap.set(routeEntity.RouteId, savedRouteEntity.RouteId);
            }
        }
        return resaveEntities;
    }
}
DwRoutingAdminRepositoryService.ɵfac = function DwRoutingAdminRepositoryService_Factory(t) { return new (t || DwRoutingAdminRepositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken)); };
DwRoutingAdminRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwRoutingAdminRepositoryService_Factory() { return new DwRoutingAdminRepositoryService(ɵɵinject(DwOrmDataServiceToken)); }, token: DwRoutingAdminRepositoryService, providedIn: "root" });
DwRoutingAdminRepositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] }
];

var DwRouteTreeNodeType;
(function (DwRouteTreeNodeType) {
    DwRouteTreeNodeType["category"] = "category";
    DwRouteTreeNodeType["staticRoute"] = "staticRoute";
    DwRouteTreeNodeType["staticChild"] = "staticChild";
    DwRouteTreeNodeType["dbRoute"] = "dbRoute";
    DwRouteTreeNodeType["dbRouteChild"] = "dbRouteChild";
    DwRouteTreeNodeType["addMenu"] = "addMenu";
})(DwRouteTreeNodeType || (DwRouteTreeNodeType = {}));

class DwRoutingAdminTreeService {
    constructor(dwMenuBuilderService) {
        this.dwMenuBuilderService = dwMenuBuilderService;
    }
    findNodeByRouteId(nodes, routeId) {
        return this.findNode(nodes, (node, routeData) => {
            return (routeData && routeData.routeId === routeId);
        });
    }
    findNode(nodes, matchFunc) {
        if (!nodes) {
            return null;
        }
        for (const node of nodes) {
            const routeData = node.data;
            if (matchFunc(node, routeData)) {
                return node;
            }
            const foundNode = this.findNode(node.children, matchFunc);
            if (foundNode) {
                return foundNode;
            }
        }
        return null;
    }
    updateAllNodes(nodes, updateFunc) {
        if (!nodes) {
            return null;
        }
        for (const node of nodes) {
            updateFunc(node);
            this.updateAllNodes(node.children, updateFunc);
        }
        return null;
    }
    fixUncategorizedNodes(nodes) {
        const badNodes = nodes.filter(node => node.type != DwRouteTreeNodeType.category);
        for (const badNode of badNodes) {
            const nodeIndex = nodes.indexOf(badNode);
            const targetIndex = nodeIndex > 0 ? nodeIndex - 1 : 0;
            nodes.splice(nodeIndex, 1);
            const newParentNode = nodes[targetIndex];
            newParentNode.children.push(badNode);
        }
    }
    syncEntitiesFromNodes(nodes, routeEntities, categoryEntities, parentNode) {
        if (!nodes || !nodes.length) {
            return;
        }
        // Check if this is the root by checking if there is no parent node
        if (!parentNode) {
            this.fixUncategorizedNodes(nodes);
        }
        const parentRouteData = parentNode ? parentNode.data : null;
        if (parentRouteData && parentNode.type == DwRouteTreeNodeType.staticRoute) {
            return;
        }
        let parentRouteId = null;
        if (parentRouteData) {
            if (parentNode.type == DwRouteTreeNodeType.staticRoute) {
                return;
            }
            parentRouteId = parentRouteData.routeId || null;
        }
        let lastRouteOrder = 0;
        let routeOrder = 0;
        for (const node of nodes) {
            const routeData = node.data;
            switch (node.type) {
                case DwRouteTreeNodeType.category:
                    this.syncEntitiesFromNodes(node.children, routeEntities, categoryEntities, node);
                    continue;
                case DwRouteTreeNodeType.staticRoute:
                    lastRouteOrder = routeData.routeMenuData.routeOrder;
                    continue;
            }
            routeData.modified;
            routeOrder++;
            const route = routeEntities.find(re => re.RouteId == routeData.routeId);
            if (!route) {
                lastRouteOrder = routeData.routeMenuData.routeOrder;
                continue;
            }
            // Exclude fake routes that are generated for lists/grids
            if (route.RouteId == parentRouteId) {
                continue;
            }
            if (route.ParentRouteId != parentRouteId) {
                route.ParentRouteId = parentRouteId;
                // routeData.routeMenuData.parentReferenceKey = parentReferenceKey;
                routeData.modified = true;
            }
            // Add Route Category
            if (parentNode) {
                switch (parentNode.type) {
                    case DwRouteTreeNodeType.category:
                        // Apply categories to this route
                        const category = categoryEntities.find(c => c.CategoryMeaning === parentRouteData.categoryMeaning);
                        const categoryId = category ? category.RouteCategoryId : null;
                        if (route.RouteCategoryId !== categoryId) {
                            route.RouteCategoryId = categoryId;
                            routeData.modified = true;
                        }
                        break;
                    case DwRouteTreeNodeType.staticRoute:
                    case DwRouteTreeNodeType.dbRoute:
                        // Update the route to the parent route if its different
                        const parentRouteEntity = routeEntities.find(re => re.RouteId == parentRouteData.routeId);
                        if (route.RouteCategoryId != parentRouteEntity.RouteCategoryId) {
                            route.RouteCategoryId = parentRouteEntity.RouteCategoryId;
                            routeData.modified = true;
                        }
                }
            }
            if (routeOrder < lastRouteOrder) {
                routeOrder = lastRouteOrder += 1;
            }
            if (route.RouteOrder != routeOrder) {
                route.RouteOrder = routeOrder;
                lastRouteOrder = routeOrder;
                routeData.modified = true;
            }
            lastRouteOrder = routeOrder;
            this.syncEntitiesFromNodes(node.children, routeEntities, categoryEntities, node);
        }
    }
    buildMenuCategories(categoriesEntities, menus) {
        const treeNodes = [];
        for (const category of categoriesEntities) {
            treeNodes.push(this.buildCategoryNode(category, menus));
        }
        return treeNodes;
    }
    buildAddMenuTree(typeEntities) {
        const treeNodes = [];
        for (const routeType of typeEntities) {
            treeNodes.push(this.buildRouteTypeNode(routeType));
        }
        return treeNodes;
    }
    buildRouteTypeNode(routeType) {
        const menuRouteData = {
            routeType: routeType
        };
        const routeTypeNode = {
            label: routeType.RouteTypeDisplay,
            type: DwRouteTreeNodeType.addMenu,
            data: menuRouteData,
            selectable: false
        };
        return routeTypeNode;
    }
    buildCategoryNode(category, menus) {
        const categoryData = {
            categoryMeaning: category.CategoryMeaning,
            categoryId: category.RouteCategoryId,
            routeMenuData: null,
        };
        const categoryNode = {
            label: category.CategoryDisplay,
            expanded: true,
            selectable: false,
            draggable: false,
            droppable: true,
            type: DwRouteTreeNodeType.category,
            styleClass: 'category-node',
            icon: 'fas fa-bars',
            data: categoryData
        };
        const categoryMeaning = category.CategoryMeaning.toLowerCase();
        const categoryMenus = menus.filter(m => {
            const menuData = m.data;
            if (!menuData || !menuData.display) {
                return false;
            }
            if (!menuData.category) {
                // Only include if it's the default category
                return (categoryMeaning === defaultMenuCategory.toLowerCase());
            }
            return (menuData.category.toLowerCase() === categoryMeaning);
        });
        categoryNode.children = this.buildMenuTree(categoryMenus);
        return categoryNode;
    }
    buildMenuTree(menus, parentMenu) {
        let treeNodes = [];
        if (!menus) {
            return treeNodes;
        }
        for (const menu of menus) {
            const treeNode = this.buildMenuTreeItem(menu, parentMenu, menus);
            const childNodes = this.buildMenuTree(menu.children, menu);
            if (treeNode) {
                treeNodes.push(treeNode);
                treeNode.children = childNodes;
            }
            else {
                // Just add the children in this case
                treeNodes = [...treeNodes, ...childNodes];
            }
        }
        return treeNodes;
    }
    buildMenuTreeItem(menu, parentMenu, sublingMenus) {
        const menuData = menu.data;
        if (!menuData || menuData.skipMenu) {
            return null;
        }
        let isChild = false;
        const treeData = {
            routeMenuData: menuData,
            path: menu.path,
            component: menu.component,
        };
        if (menuData.extInfo) {
            const extInfo = menuData.extInfo;
            treeData.routeId = extInfo.routeItemId;
            if (parentMenu && parentMenu.data && parentMenu.data.extInfo) {
                const parentExtInfo = parentMenu.data.extInfo;
                if (extInfo.routeItemId == parentExtInfo.routeItemId) {
                    isChild = true;
                }
            }
        }
        const nodeType = this.determineNodeType(menuData, treeData, isChild);
        const treeNode = {
            label: menu.display,
            icon: `${treeData.routeMenuData.iconCssClass}`,
            data: treeData,
            styleClass: this.determineTreeNodeClass(nodeType),
            type: nodeType
        };
        /*    if (nodeType == DwRouteTreeNodeType.dbRouteChild) {
               const childMenus = sublingMenus.filter(menu => {
                   const menuData: DwRouteBaseConfig = menu.data;
   
                   if (menuData.childListMenuOptions?.isChildListMenu) {
                       return true;
                   }
                   return false;
               });
               treeNode.children = this.buildMenuTree(childMenus, menu);
           }
    */
        // Only items from the DB are draggable/droppable
        if (!treeData.routeId) {
            treeNode.draggable = false;
            treeNode.droppable = false;
            // treeNode.selectable = false;
        }
        if (menuData.isChild) {
            treeNode.selectable = true;
        }
        return treeNode;
    }
    determineNodeType2(node, isChild) {
        const treeData = node.data;
        const menuData = treeData.routeMenuData;
        return this.determineNodeType(menuData, treeData, isChild);
    }
    determineNodeType(menuData, treeData, isChild) {
        if (isChild) {
            return DwRouteTreeNodeType.dbRouteChild;
        }
        if (treeData.routeMenuData.isChild) {
            return DwRouteTreeNodeType.staticChild;
        }
        if (treeData.routeId) {
            return DwRouteTreeNodeType.dbRoute;
        }
        return DwRouteTreeNodeType.staticRoute;
    }
    determineTreeNodeClass(nodeType) {
        switch (nodeType) {
            case DwRouteTreeNodeType.category:
                break;
            case DwRouteTreeNodeType.dbRoute:
            case DwRouteTreeNodeType.dbRouteChild:
                return 'db-route';
            case DwRouteTreeNodeType.staticRoute:
            case DwRouteTreeNodeType.staticChild:
                return 'static-route';
        }
    }
    buildRouteTreeNode(route) {
        const menuData = {
            display: route.Display,
            routeOrder: route.RouteOrder || 1
        };
        const treeData = {
            routeMenuData: menuData,
            path: route.Path,
            component: null,
        };
        treeData.routeId = route.RouteId;
        const itemClass = treeData.routeId ? 'db-route' : 'static-route';
        const treeNode = {
            label: route.Display,
            icon: `${route.IconCssClass}`,
            data: treeData,
            type: DwRouteTreeNodeType.dbRoute,
            styleClass: itemClass,
        };
        return treeNode;
    }
}
DwRoutingAdminTreeService.ɵfac = function DwRoutingAdminTreeService_Factory(t) { return new (t || DwRoutingAdminTreeService)(ɵngcc0.ɵɵinject(DwMenuBuilderService)); };
DwRoutingAdminTreeService.ɵprov = ɵɵdefineInjectable({ factory: function DwRoutingAdminTreeService_Factory() { return new DwRoutingAdminTreeService(ɵɵinject(DwMenuBuilderService)); }, token: DwRoutingAdminTreeService, providedIn: "root" });
DwRoutingAdminTreeService.ctorParameters = () => [
    { type: DwMenuBuilderService }
];

class DwRouteTypeFactory {
    constructor(uiConfigRegistry, injector) {
        this.uiConfigRegistry = uiConfigRegistry;
        this.injector = injector;
    }
    createRouteProcessor(routeTypeId) {
        const processor = this.getRouteProcessorRegistration(routeTypeId);
        if (!processor) {
            return null;
        }
        try {
            const service = this.injector.get(processor.service);
            return service;
        }
        catch (ex) {
            console.warn(`Error creating route processor for type ${routeTypeId} and processor ${processor.display}`);
            return null;
        }
    }
    getRouteProcessorRegistration(routeTypeId, returnDefaultIfNotFound = true) {
        const allProcessors = this.uiConfigRegistry.getRegisteredItems(DwUiRegistryType.routeTypeProcessor);
        if (typeof (routeTypeId) == 'string') {
            routeTypeId = parseInt(routeTypeId);
        }
        let processor = allProcessors.find(r => r.routeTypeId === routeTypeId);
        if (!processor) {
            if (returnDefaultIfNotFound) {
                processor = allProcessors.find(r => r.isDefault);
            }
            if (!processor) {
                console.warn(`No route type processor found for type ${routeTypeId}`);
            }
        }
        return processor;
    }
}
DwRouteTypeFactory.ɵfac = function DwRouteTypeFactory_Factory(t) { return new (t || DwRouteTypeFactory)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwRouteTypeFactory.ɵprov = ɵɵdefineInjectable({ factory: function DwRouteTypeFactory_Factory() { return new DwRouteTypeFactory(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(INJECTOR)); }, token: DwRouteTypeFactory, providedIn: "root" });
DwRouteTypeFactory.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: Injector }
];

class DwMetaDataRoutingRepositoryService {
    constructor(appInitService, http, uiMetaDataConfig, metaDataService, configService, ormDataService, uiConfigRegistryService, dwRouteTypeFactory, cacheService) {
        this.appInitService = appInitService;
        this.http = http;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.metaDataService = metaDataService;
        this.ormDataService = ormDataService;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.dwRouteTypeFactory = dwRouteTypeFactory;
        this.cacheService = cacheService;
        this.apiRoot = `${configService.coreConfig.apiRoot}`;
    }
    getRouteItems() {
        const cacheOptions = {
            cacheInvalidationsTopics: [DevwareMetaDataItemNames.DwRoute, DevwareMetaDataItemNames.DwRouteType]
        };
        return this.appInitService.getApiInitItem('RouteItems', this.loadRouteItems(), cacheOptions)
            .pipe(map(routesJSON => {
            const routes = JSON.parse(routesJSON);
            // DwMetaDataRoutingRepositoryService._loadedRoutes = routes;
            return routes;
        }));
    }
    getRouteCategories() {
        const cacheOptions = {
            cacheInvalidationsTopics: [DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwRouteCategory)]
        };
        return this.cacheService.getWithOptions('routeCategories', this.loadRouteCategories(), cacheOptions);
    }
    loadRouteCategories() {
        const query = new DwQuery(DevwareMetaDataItemNames.DwRouteCategory);
        return this.ormDataService.executeQuery(query);
    }
    loadRouteItems() {
        let url = `${this.apiRoot}config/routes`;
        return this.http.get(url)
            .pipe(map((r) => {
            return r;
        }));
    }
    setupRepositoryRoutes() {
        return this.getRouteItems()
            .pipe(tap(routeItems => {
            this.registerRouteItems(routeItems);
        }));
    }
    registerRouteItems(routeItems, parentRoute) {
        const currentRoutes = routeItems.filter(ri => (!parentRoute && !ri.ParentRouteId) || (parentRoute && ri.ParentRouteId === parentRoute.RouteId));
        for (let routeItem of currentRoutes) {
            const route = this.registerRouteItem(routeItem, parentRoute);
            // Only register children if parent was registered
            if (route) {
                // recursively call this for the next level in the tree
                this.registerRouteItems(routeItems, routeItem);
            }
        }
    }
    registerRouteItem(routeItem, parentRoute) {
        const parentName = parentRoute ? parentRoute.Path : 'root';
        const routeProcessor = this.dwRouteTypeFactory.createRouteProcessor(routeItem.RouteTypeId);
        if (!routeProcessor) {
            return;
        }
        const route = routeProcessor.buildRoute(routeItem);
        if (!route) {
            return;
        }
        // Set parent so we don't have to pass to build route and can change implementation later
        route.parentName = parentName;
        DwMetaDataRoutingRegistryService.addRoute(route);
        return route;
    }
}
DwMetaDataRoutingRepositoryService.ɵfac = function DwMetaDataRoutingRepositoryService_Factory(t) { return new (t || DwMetaDataRoutingRepositoryService)(ɵngcc0.ɵɵinject(DwAppInitService), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwRouteTypeFactory), ɵngcc0.ɵɵinject(DwCacheService)); };
DwMetaDataRoutingRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataRoutingRepositoryService_Factory() { return new DwMetaDataRoutingRepositoryService(ɵɵinject(DwAppInitService), ɵɵinject(HttpClient), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwRouteTypeFactory), ɵɵinject(DwCacheService)); }, token: DwMetaDataRoutingRepositoryService, providedIn: "root" });
DwMetaDataRoutingRepositoryService.ctorParameters = () => [
    { type: DwAppInitService },
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: DwRouteTypeFactory },
    { type: DwCacheService }
];

var DwDynamicRouteType;
(function (DwDynamicRouteType) {
    DwDynamicRouteType[DwDynamicRouteType["listPage"] = 1] = "listPage";
    DwDynamicRouteType[DwDynamicRouteType["formPage"] = 2] = "formPage";
    DwDynamicRouteType[DwDynamicRouteType["menuPage"] = 3] = "menuPage";
    DwDynamicRouteType[DwDynamicRouteType["componentPage"] = 4] = "componentPage";
    DwDynamicRouteType[DwDynamicRouteType["actionLink"] = 5] = "actionLink";
})(DwDynamicRouteType || (DwDynamicRouteType = {}));

/* @Component({
    // tslint:disable-next-line:component-selector
    selector: 'dw-menu-base',
    templateUrl: './dw-menu.component.html'
}) */
class DwMenuComponent {
    constructor(routingService, route, actionExecutionService, dwMenuService, uiConfig) {
        this.routingService = routingService;
        this.route = route;
        this.actionExecutionService = actionExecutionService;
        this.dwMenuService = dwMenuService;
        this.uiConfig = uiConfig;
        this.category = "";
        this.performSecurityTrimming = true;
        this.routeHierarchy = [];
        this.breadCrumbs = [];
        this.metaData = { Display: 'Testing' };
        this.item = "Test item 1.2.3";
        this.subscriptions = [];
    }
    ngOnInit() {
        this.dwMenuService.menuStateObservable.subscribe(() => {
            const menuState = this.dwMenuService.menuState;
            this.currentMenu = menuState.currentMenu;
            this.breadCrumbs = menuState.breadcrumbs;
            this.replacementSideMenu = menuState.replacementSideMenu;
            this.loadRoutes();
        });
        this.initComplete();
    }
    initComplete() {
    }
    loadRoutes() {
        this.routeHierarchy = this.dwMenuService.getMenuHierarchy(this.category);
        //this.routeHierarchy = this.routingService.getMenuHierarchy(this.category);
        this.routesLoaded();
    }
    // Method to be overwritten in child classes
    routesLoaded() {
    }
    ngOnDestroy() {
        // Clean up all subscriptions
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwMenuComponent.ɵfac = function DwMenuComponent_Factory(t) { return new (t || DwMenuComponent)(ɵngcc0.ɵɵdirectiveInject(DwRoutingServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DwActionExecutionService), ɵngcc0.ɵɵdirectiveInject(DwMenuService), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken)); };
DwMenuComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMenuComponent, inputs: { category: "category", performSecurityTrimming: "performSecurityTrimming" } });
DwMenuComponent.ctorParameters = () => [
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] },
    { type: ActivatedRoute },
    { type: DwActionExecutionService },
    { type: DwMenuService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];
DwMenuComponent.propDecorators = {
    category: [{ type: Input }],
    performSecurityTrimming: [{ type: Input }]
};

class DefaultMenuPageComponent {
    constructor(dwMenuService) {
        this.dwMenuService = dwMenuService;
        this.configKey = 'default';
    }
    ngOnInit() {
        var _a, _b, _c;
        this.dwMenuService.menuStateObservable.subscribe(meunState => {
            var _a, _b, _c;
            this.configKey = (_c = (_b = (_a = this.dwMenuService.menuState) === null || _a === void 0 ? void 0 : _a.currentMenu) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.referenceKey;
        });
        this.configKey = (_c = (_b = (_a = this.dwMenuService.menuState) === null || _a === void 0 ? void 0 : _a.currentMenu) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.referenceKey;
    }
}
DefaultMenuPageComponent.ɵfac = function DefaultMenuPageComponent_Factory(t) { return new (t || DefaultMenuPageComponent)(ɵngcc0.ɵɵdirectiveInject(DwMenuService)); };
DefaultMenuPageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DefaultMenuPageComponent, selectors: [["dw-default-menu-page"]], decls: 2, vars: 0, consts: [[4, "dwMenuContent"], [3, "configKey"], ["name", "title", "display", "Page Title", 3, "controlType"], ["name", "detail", "display", "Header Details"], ["name", "component", "display", "Custom Component"]], template: function DefaultMenuPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-page-menu");
        ɵngcc0.ɵɵtemplate(1, DefaultMenuPageComponent_div_1_Template, 6, 2, "div", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DwPageMenu, DwMenuContentTemplateDirective, DwContentManagerComponent, DwContentDirective, DwContentComponent]; }, styles: [""] });
DefaultMenuPageComponent.ctorParameters = () => [
    { type: DwMenuService }
];

class DwMenuContentTemplateDirective {
}
DwMenuContentTemplateDirective.ɵfac = function DwMenuContentTemplateDirective_Factory(t) { return new (t || DwMenuContentTemplateDirective)(); };
DwMenuContentTemplateDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMenuContentTemplateDirective, selectors: [["", "dwMenuContent", ""]] });

var DwExpandCollapseStyle;
(function (DwExpandCollapseStyle) {
    DwExpandCollapseStyle["plusMinus"] = "plusMinus";
    DwExpandCollapseStyle["chevron"] = "chevron";
})(DwExpandCollapseStyle || (DwExpandCollapseStyle = {}));
var DwExpandCollapseLocation;
(function (DwExpandCollapseLocation) {
    DwExpandCollapseLocation["left"] = "left";
    DwExpandCollapseLocation["right"] = "right";
})(DwExpandCollapseLocation || (DwExpandCollapseLocation = {}));

class DwPageMenu extends DwMenuComponent {
    constructor() {
        super(...arguments);
        this.category = "";
        this.performSecurityTrimming = true;
        this.menuGroups = [];
        this.useLargeIconView = false;
        this.routeActivated = false;
        this.containerOptions = {
            useContainerStyling: true,
            containerAllowCollapse: true,
            containerCollapseDefault: false,
            showTitle: true,
            //containerHeaderForegroundColor: 'blue',
            styleName: 'TITLE_ONLY',
            expandCollapseStyle: DwExpandCollapseStyle.chevron,
            expandCollpaseLocation: DwExpandCollapseLocation.left
        };
        this.useGroups = true;
        this.menus = [];
    }
    routesLoaded() {
        //console.log("DwPageMenu.routesLoaded");
        if (!this.currentMenu)
            return;
        this.buildMenuGroups();
    }
    buildMenuGroups() {
        var _a, _b;
        const childMenus = this.currentMenu.children || [];
        this.menuGroups = [];
        this.menus = [];
        for (let childMenu of childMenus) {
            if (!this.showMenu(childMenu)) {
                continue;
            }
            const groupName = this.getGroupName(childMenu);
            if (!groupName) {
                this.menus.push(childMenu);
                continue;
            }
            const groupDisplay = childMenu.data.groupDisplay || childMenu.data.display;
            let group = this.menuGroups.find(g => g.groupDisplay == groupDisplay);
            if (!group) {
                group = { groupDisplay: groupDisplay, menus: [] };
                this.menuGroups.push(group);
            }
            if (((_a = childMenu === null || childMenu === void 0 ? void 0 : childMenu.data) === null || _a === void 0 ? void 0 : _a.showAsGroup) && !((_b = childMenu === null || childMenu === void 0 ? void 0 : childMenu.data) === null || _b === void 0 ? void 0 : _b.includeInGroup)) {
                group.menus = [...group.menus, ...childMenu.children.filter(m => this.showMenu(m))];
            }
            else {
                group.menus.push(childMenu);
            }
        }
    }
    getGroupName(childMenu) {
        var _a, _b;
        if ((_a = childMenu.data) === null || _a === void 0 ? void 0 : _a.includeInGroup) {
            return childMenu.data.groupDisplay || '';
        }
        if ((_b = childMenu.data) === null || _b === void 0 ? void 0 : _b.showAsGroup) {
            return childMenu.display;
        }
        return '';
    }
    toggleActivate(activated) {
        setTimeout(() => {
            this.routeActivated = activated;
        });
    }
    getMenus(menus, hasVisibleChildren) {
        var resultMenus = [];
        if (!menus)
            return [];
        for (let menu of menus) {
            if (this.showMenu(menu)) {
                let hasChildMenus = this.hasChildMenus(menu);
                if (hasChildMenus && menu.data.hideChildMenus) {
                    hasChildMenus = !hasChildMenus;
                }
                if (hasChildMenus === hasVisibleChildren) {
                    resultMenus.push(menu);
                }
            }
        }
        return resultMenus;
    }
    OldBuildMenus() {
        this.useLargeIconView = !(this.currentMenu.data.useLargeIconView === false);
        const childMenus = this.currentMenu.children || [];
        if (!this.useLargeIconView) {
            this.menus = this.getMenus(childMenus, true);
            const childlessMenus = this.getMenus(childMenus, false);
            if (childlessMenus.length > 0) {
                const firstMenu = {
                    display: this.currentMenu.display,
                    children: childlessMenus
                };
                this.menus.unshift(firstMenu);
            }
        }
        else {
            this.menus = childMenus.filter(menu => !(menu.data.showInMenu === false || menu.data.visibleRuleResult === false));
        }
    }
    showMenu(menu, excludeChildless = false) {
        if (menu.data && (menu.data.showInMenu === false || menu.data.visibleRuleResult === false))
            return false;
        if (excludeChildless && !this.hasChildMenus(menu))
            return false;
        return true;
    }
    hasChildlessMenus(menus) {
        for (let menu of menus) {
            if (this.hasChildMenus(menu))
                return true;
        }
        return false;
    }
    hasChildMenus(menu) {
        var _a, _b, _c;
        if ((_a = menu.data) === null || _a === void 0 ? void 0 : _a.isAction) {
            return false;
        }
        if (menu.component == DwPageMenu && !((_b = menu.data) === null || _b === void 0 ? void 0 : _b.hideChildOnMenuPage)) {
            return true;
        }
        if (menu.component == DefaultMenuPageComponent && !((_c = menu.data) === null || _c === void 0 ? void 0 : _c.hideChildOnMenuPage)) {
            return true;
        }
        return false;
        if (!menu.children || menu.children.length == 0)
            return false;
        for (var childMenu of menu.children) {
            if (this.showMenu(childMenu)) {
                return true;
            }
        }
        return false;
    }
}
DwPageMenu.ɵfac = function DwPageMenu_Factory(t) { return ɵDwPageMenu_BaseFactory(t || DwPageMenu); };
DwPageMenu.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPageMenu, selectors: [["dw-page-menu"]], contentQueries: function DwPageMenu_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, DwMenuContentTemplateDirective, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuContentTemplate = _t.first);
    } }, inputs: { category: "category", performSecurityTrimming: "performSecurityTrimming" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 0, consts: [["useIf", "true"], ["menuSection", ""], ["menuSectionGroup", ""], ["menuSectionGroupOld", ""], [4, "ngTemplateOutlet"], [4, "ngIf"], [1, "dw-menu-cards"], ["dwCol2", "12"], [4, "ngFor", "ngForOf"], ["className", "dw-menu-card", 3, "menu"], ["dwRow", ""], ["dwCol", "12"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "dw-section-container"], [1, "dw-section-container-header"], [1, "dw-section-container-inner", "dw-page-menu"], ["className", "nav-link2", 3, "menu", "menuLocation", 4, "ngIf"], ["className", "nav-link2", 3, "menu", "menuLocation"], [3, "options"], ["header", ""], ["body", ""]], template: function DwPageMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-router-parent", 0);
        ɵngcc0.ɵɵtemplate(1, DwPageMenu_ng_template_1_Template, 3, 3, "ng-template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, DwPageMenu_ng_template_2_Template, 5, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, DwPageMenu_ng_template_4_Template, 7, 3, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, DwPageMenu_ng_template_6_Template, 7, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, directives: function () { return [DwRouterParentComponent, ɵngcc4.NgTemplateOutlet, ɵngcc4.NgIf, ɵngcc4.NgForOf, DwMenuTemplateComponent, DwRowDirective, DwColDirective, DwMenuLinkComponent, DwContainerComponent]; }, encapsulation: 2 });
DwPageMenu.propDecorators = {
    category: [{ type: Input }],
    performSecurityTrimming: [{ type: Input }],
    menuContentTemplate: [{ type: ContentChild, args: [DwMenuContentTemplateDirective, { static: false, read: TemplateRef },] }]
};

var DwListRouteSubType;
(function (DwListRouteSubType) {
    DwListRouteSubType["grid"] = "grid";
    DwListRouteSubType["list"] = "list";
    DwListRouteSubType["custom"] = "custom";
})(DwListRouteSubType || (DwListRouteSubType = {}));

class DwRoutingAdminConversionService {
    constructor(dwMetaDataService, dwOrmDataService, dwUiConfigRegistryService, routingTreeService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.routingTreeService = routingTreeService;
    }
    convertRoute(node, parentNode) {
        const routeData = node.data;
        if (!routeData || (routeData.routeId && routeData.routeId > 0)) {
            return;
        }
        const routeType = this.determineRouteType(routeData);
        const routeEntity = this.dwOrmDataService.createDummyEntity(DevwareMetaDataItemNames.DwRoute);
        // Map core properties
        routeEntity.RouteId = routeData.routeId; // This needs to be assigned from the parent since we don't have access to state here
        routeEntity.RouteTypeId = routeType;
        routeEntity.Display = routeData.routeMenuData.display;
        routeEntity.RouteOrder = routeData.routeMenuData.routeOrder;
        routeEntity.Path = routeData.path;
        routeEntity.RequireAuthentication = routeData.routeMenuData.requireAuthentication;
        routeEntity.CanAccessPermissionMeaning = routeData.routeMenuData.canAccessPermission;
        routeEntity.ShowInMenu = routeData.routeMenuData.showInMenu;
        routeEntity.ExcludeFromMainMenu = routeData.routeMenuData.excludeFromMainMenu;
        routeEntity.IconCssClass = routeData.routeMenuData.iconCssClass;
        routeEntity.RouteReferenceKey = routeData.routeMenuData.referenceKey;
        routeEntity.HighlightOnExactMatch = routeData.routeMenuData.highlightOnExactMatch;
        if (parentNode && parentNode.type != DwRouteTreeNodeType.category) {
            const parentRouteData = parentNode.data;
            if (!parentRouteData.routeId) {
                // This is handle in the UI prior to this call, so just showing a warning
                console.warn(`Can't convert ${routeData.routeMenuData.display}!  Converted routes must be tied to a parent DB route.`);
            }
            routeEntity.ParentRouteId = parentRouteData.routeId;
        }
        // Update Tree Node
        routeData.routeId = routeEntity.RouteId;
        routeData.modified = true;
        node.type = this.routingTreeService.determineNodeType(routeData.routeMenuData, routeData, false);
        node.styleClass = this.routingTreeService.determineTreeNodeClass(node.type);
        let obMetaDataUpdate = of(null);
        if (routeData.routeMenuData.metaDataItem) {
            obMetaDataUpdate = this.dwMetaDataService.getMetaDataItemId(routeData.routeMenuData.metaDataItem);
        }
        return obMetaDataUpdate
            .pipe(map(itemId => {
            routeEntity.RouteConfigJSON = this.convertRouteConfig(node, routeType, routeEntity, routeData, itemId);
            return routeEntity;
        }));
    }
    convertRouteConfig(node, routeType, routeEntity, routeData, itemId) {
        var _a, _b, _c, _d, _e;
        const routeBaseConfig = {};
        let useComponentConversion = false;
        let requireComponentConversion = false;
        switch (routeType) {
            case DwDynamicRouteType.componentPage:
                useComponentConversion = true;
                requireComponentConversion = true;
                break;
            case DwDynamicRouteType.menuPage:
                const menuRouteConfig = routeBaseConfig;
                menuRouteConfig.hideChildOnMenuPage = (_a = routeData.routeMenuData) === null || _a === void 0 ? void 0 : _a.hideChildOnMenuPage;
                menuRouteConfig.navigateToFirstChild = (_b = routeData.routeMenuData) === null || _b === void 0 ? void 0 : _b.navigateToFirstChild;
                menuRouteConfig.useLargeIconView = (_c = routeData.routeMenuData) === null || _c === void 0 ? void 0 : _c.useLargeIconView;
                menuRouteConfig.replaceSideMenu = (_d = routeData.routeMenuData) === null || _d === void 0 ? void 0 : _d.replaceSideMenu;
                menuRouteConfig.sideMenuComponent = (_e = routeData.routeMenuData) === null || _e === void 0 ? void 0 : _e.sideMenuComponent;
                if (routeData.component != DwPageMenu) {
                    useComponentConversion = true;
                }
                break;
            case DwDynamicRouteType.formPage:
            case DwDynamicRouteType.listPage:
                if (!itemId) {
                    routeData.invalid = true;
                    routeData.invalidMessage = `Could not find meta data item ${routeData.routeMenuData.metaDataItem} and could not convert route.`;
                    return;
                }
                routeEntity.MetaDataItemId = itemId;
                const routeConfig = routeBaseConfig;
                routeConfig.listRouteSubType = DwListRouteSubType.grid;
                routeConfig.configKeyPart = routeData.routeMenuData.configKeyPart;
                routeConfig.printConfigKeyPart = routeData.routeMenuData.printConfigKeyPart;
                if (routeData.component != DwDefaultGridPage) {
                    useComponentConversion = true;
                }
                this.mapListRouteFormChildren(node, routeData, routeEntity);
        }
        if (useComponentConversion) {
            routeBaseConfig.componentOverride = this.determineComponentName(routeData.component);
            if (!routeBaseConfig.componentOverride && (routeData.component || requireComponentConversion)) {
                routeData.invalid = true;
                routeData.invalidMessage = `Could not find component.  Ensure that the component has the DwComponent decorator and is marked as Page component`;
                return routeBaseConfig;
            }
        }
        return routeBaseConfig;
    }
    determineComponentName(component) {
        const allComponents = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.pageComponent);
        const foundComponent = allComponents.find(c => c.component == component);
        if (foundComponent) {
            return foundComponent.key;
        }
        return null;
    }
    mapListRouteFormChildren(node, routeData, routeEntity) {
        for (const childNode of node.children || []) {
            const childRouteData = childNode.data;
            // If the route uses the same metadataitem, then its a child route
            if (childRouteData.routeMenuData.metaDataItem === routeData.routeMenuData.metaDataItem) {
                // Assign parent key
                childRouteData.routeId = routeEntity.RouteId;
                childNode.styleClass = this.routingTreeService.determineTreeNodeClass(childNode.type);
                const formConfigInfo = {
                    formType: childRouteData.routeMenuData.metaDataActionType
                };
                formConfigInfo.configKeyPart = childRouteData.routeMenuData.configKeyPart || routeData.routeMenuData.configKeyPart;
                // formConfigInfo.printConfigKeyPart = childRouteData.routeMenuData.printConfigKeyPart || routeData.routeMenuData.printConfigKeyPart;
                formConfigInfo.displayOverride = childRouteData.routeMenuData.display;
            }
        }
    }
    determineRouteType(routeData) {
        switch (routeData.routeMenuData.metaDataActionType) {
            case DwMenuActionType.list:
                return DwDynamicRouteType.listPage;
            case DwMenuActionType.add:
            case DwMenuActionType.edit:
            case DwMenuActionType.print:
            case DwMenuActionType.view:
            case DwMenuActionType.addEdit:
                return DwDynamicRouteType.formPage;
        }
        if (routeData.component == DwPageMenu) {
            return DwDynamicRouteType.menuPage;
        }
        return DwDynamicRouteType.componentPage;
    }
}
DwRoutingAdminConversionService.ɵfac = function DwRoutingAdminConversionService_Factory(t) { return new (t || DwRoutingAdminConversionService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwRoutingAdminTreeService)); };
DwRoutingAdminConversionService.ɵprov = ɵɵdefineInjectable({ factory: function DwRoutingAdminConversionService_Factory() { return new DwRoutingAdminConversionService(ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwRoutingAdminTreeService)); }, token: DwRoutingAdminConversionService, providedIn: "root" });
DwRoutingAdminConversionService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: DwRoutingAdminTreeService }
];

class DwRoutingAdminStateService {
    constructor(routingAdminRepository, menuService, routingTreeService, router, dwMdRoutingRegistryService, dwMdRoutingRepositoryService, routingConversionService) {
        this.routingAdminRepository = routingAdminRepository;
        this.menuService = menuService;
        this.routingTreeService = routingTreeService;
        this.router = router;
        this.dwMdRoutingRegistryService = dwMdRoutingRegistryService;
        this.dwMdRoutingRepositoryService = dwMdRoutingRepositoryService;
        this.routingConversionService = routingConversionService;
        this._routingState = new BehaviorSubject(null);
    }
    get routingState() {
        return this._routingState.value;
    }
    stateChanged() {
        return this._routingState.asObservable();
    }
    initState() {
        this._routingState.next(null);
        const categoriesOb = this.routingAdminRepository.loadRouteCategories();
        const routesOb = this.routingAdminRepository.loadRoutes();
        const typesOb = this.routingAdminRepository.loadRouteTypes();
        combineLatest([categoriesOb, routesOb, typesOb])
            .subscribe(([categoryEntities, routeEntities, typeEntities]) => {
            const menuHierarchy = this.menuService.menuState.allMenuItems;
            const treeData = this.routingTreeService.buildMenuCategories(categoryEntities, menuHierarchy);
            const addTreeData = this.routingTreeService.buildAddMenuTree(typeEntities);
            this.setState({
                routeEntities: routeEntities,
                categoryEntities: categoryEntities,
                typeEntities: typeEntities,
                treeData: treeData,
                menuHierarchy: menuHierarchy,
                nextRouteId: -1,
                addTreeData: addTreeData,
            });
        });
    }
    setState(updatedState) {
        const newState = Object.assign(Object.assign({}, this.routingState), updatedState);
        this._routingState.next(newState);
    }
    setSelectedNode(node) {
        const treeData = node.data;
        const newState = {
            selectedNode: node
        };
        if (treeData.routeId) {
            newState.selectedRoute = this.routingState.routeEntities.find(e => e.RouteId == treeData.routeId);
        }
        else {
            newState.selectedRoute = null;
        }
        this.setState(newState);
    }
    setNodeValid(isValid) {
        const selectedNode = this.routingState.selectedNode;
        const treeNodeData = selectedNode.data;
        treeNodeData.invalid = !isValid;
        /*  if (isValid) {
             treeNodeData.invalidMessage = 'Invalid cleared';
         }  */
        const newState = Object.assign({}, this.routingState);
        this.setEnableSave(newState);
        this.setState(newState);
    }
    setEnableSave(state) {
        const enabledSaving = false;
        const modified = !!this.routingTreeService.findNode(state.treeData, (node, nodeData) => {
            return nodeData.modified;
        })
            ||
                state.routeEntities.filter(route => route.RouteId < 0 || route._isDeleted).length > 0;
        const valid = !this.routingTreeService.findNode(state.treeData, (node, nodeData) => {
            return nodeData.invalid;
        });
        state.routesModified = modified;
        state.routesValid = valid;
        state.enableSave = modified && valid;
    }
    addRoute(newRoute, parentNode, addRouteData, addAtIndex) {
        const newState = Object.assign({}, this.routingState);
        const parentRouteData = parentNode.data;
        const parentRouteEntity = newState.routeEntities.find(r => r.RouteId == parentRouteData.routeId);
        const categoryId = parentRouteData.categoryId || parentRouteEntity.RouteCategoryId;
        const routeId = newState.nextRouteId;
        const routeType = addRouteData ? addRouteData.routeType.RouteTypeId : DwDynamicRouteType.menuPage;
        const displayPart = addRouteData ? addRouteData.routeType.RouteTypeDisplay : 'Menu';
        const pathPart = addRouteData ? this.buildPath(addRouteData.routeType.RouteTypeDisplay) : 'menu';
        if (!newRoute) {
            newRoute = {
                _itemName: DevwareMetaDataItemNames.DwRoute,
                RouteTypeId: routeType,
                Display: `New ${displayPart} ${-routeId}`,
                Path: `new-${pathPart}-${-routeId}`,
                ExcludeFromMainMenu: !parentRouteData.routeId ? false : true,
                ShowInMenu: true,
                RequireAuthentication: true,
            };
        }
        // Assign all properties that should be overriden for a passed in item
        newRoute.RouteCategoryId = categoryId,
            newRoute.ParentRouteId = parentRouteData.routeId,
            newRoute.RouteId = routeId;
        newRoute.RouteOrder = 1;
        // Decrement this for the next item
        newState.nextRouteId--;
        // Rebuild add tree data if we dragged a node (it is automatically removed from the original tree)
        if (addRouteData) {
            newState.addTreeData = this.routingTreeService.buildAddMenuTree(newState.typeEntities);
        }
        const newRouteNode = this.routingTreeService.buildRouteTreeNode(newRoute);
        const newRouteData = newRouteNode.data;
        // Ensure children array exists
        parentNode.children = parentNode.children || [];
        // Adjust the route order if there are children
        if (parentNode.children.length > 0) {
            const lastChildData = parentNode.children[parentNode.children.length - 1].data;
            let lastChildOrder = lastChildData.routeMenuData.routeOrder;
            if (lastChildData.routeId) {
                const lastChildRoute = newState.routeEntities.find(r => r.RouteId === lastChildData.routeId);
                lastChildOrder = lastChildRoute.RouteOrder;
            }
            newRoute.RouteOrder = lastChildOrder;
        }
        newRouteData.modified = true;
        if (addAtIndex >= 0) {
            parentNode.children.splice(addAtIndex, 0, newRouteNode);
        }
        else {
            parentNode.children.push(newRouteNode);
        }
        parentNode.expanded = true;
        newState.routeEntities.push(newRoute);
        newState.selectedNode = newRouteNode;
        newState.selectedRoute = newRoute;
        this.setEnableSave(newState);
        this.setState(newState);
    }
    buildPath(display) {
        display = display.replace(/ /g, '-');
        display = encodeURI(display);
        return display.toLowerCase();
    }
    updateRoute(route, isChildRoute, childActionType) {
        const routes = this.routingState.routeEntities;
        const existingRoute = routes.find(e => e.RouteId == route.RouteId);
        if (existingRoute) {
            Object.assign(existingRoute, route);
        }
        const newState = Object.assign({}, this.routingState);
        newState.routeEntities = routes;
        if (this.routingState.selectedRoute && this.routingState.selectedRoute.RouteId == route.RouteId) {
            newState.selectedRoute = existingRoute;
        }
        // Update node
        let routeNode = this.routingTreeService.findNodeByRouteId(this.routingState.treeData, route.RouteId);
        if (isChildRoute) {
            routeNode = routeNode.children.find(cn => cn.data.routeMenuData.metaDataActionType == childActionType);
            const listRouteConfig = route.RouteConfigJSON;
            listRouteConfig.formRouteOptions = listRouteConfig.formRouteOptions || [];
            const listRouteFormConfig = listRouteConfig.formRouteOptions.find(ro => ro.formType == childActionType) || {};
            routeNode.label = listRouteFormConfig.displayOverride || getMenuActionTypeDisplay(childActionType);
        }
        else {
            routeNode.label = route.Display;
            routeNode.icon = route.IconCssClass;
        }
        newState.selectedNode = routeNode;
        routeNode.data.modified = true;
        if (isChildRoute) {
            routeNode.parent.data.modified = true;
        }
        this.setEnableSave(newState);
        this.setState(newState);
    }
    deleteRoute(node, includeChildren, updateState = true) {
        const nodeRouteData = node.data;
        const newState = Object.assign({}, this.routingState);
        if (node.type !== DwRouteTreeNodeType.dbRoute) {
            return;
        }
        const routeEntity = newState.routeEntities.find(r => r.RouteId === nodeRouteData.routeId);
        if (!routeEntity) {
            return;
        }
        if (includeChildren) {
            for (const childNode of node.children || []) {
                this.deleteRoute(childNode, includeChildren, false);
            }
        }
        if (routeEntity.RouteId < 0) {
            this.undoConvertRoute(node);
            return;
        }
        else {
            // Mark item as delete
            routeEntity._isDeleted = true;
        }
        // Unselect node after deletion
        if (newState.selectedRoute && newState.selectedRoute.RouteId == nodeRouteData.routeId) {
            newState.selectedNode = null;
            newState.selectedRoute = null;
        }
        nodeRouteData.routeId = null;
        node.type = this.routingTreeService.determineNodeType2(node, false);
        // Should always have a parent, but just in case
        if (node.parent) {
            // Only remove database routes that aren't tied to a static route
            if (!nodeRouteData.routeMenuData.hasStaticRoute) {
                const nodeIndex = node.parent.children.indexOf(node);
                node.parent.children.splice(nodeIndex, 1);
            }
        }
        this.setEnableSave(newState);
        this.setState(newState);
    }
    convertRoute(node, convertChildren, parentNode) {
        const newState = Object.assign({}, this.routingState);
        const nodeRouteData = node.data;
        // Assign the new route id
        nodeRouteData.routeId = newState.nextRouteId;
        // Decrement this for the next item
        newState.nextRouteId--;
        this.setState(newState);
        if (!parentNode) {
            parentNode = node.parent;
        }
        this.routingConversionService.convertRoute(node, parentNode)
            .subscribe(routeEntity => {
            newState.routeEntities.push(routeEntity);
            if (newState.selectedNode.data.routeId == routeEntity.RouteId) {
                newState.selectedRoute = routeEntity;
            }
            this.setEnableSave(newState);
            this.setState(newState);
            if (convertChildren) {
                const routeData = node.data;
                for (var childNode of node.children || []) {
                    const childRouteData = childNode.data;
                    if (childRouteData.routeId != routeData.routeId) {
                        this.convertRoute(childNode, convertChildren, node);
                    }
                    else {
                        childNode.type = DwRouteTreeNodeType.dbRouteChild;
                        childNode.styleClass = this.routingTreeService.determineTreeNodeClass(childNode.type);
                    }
                }
            }
        });
    }
    undoConvertRoute(node, includeChildren = false, updateState = true) {
        const nodeRouteData = node.data;
        const newState = Object.assign({}, this.routingState);
        if (!nodeRouteData.routeId) {
            return;
        }
        const routeEntity = newState.routeEntities.find(r => r.RouteId === nodeRouteData.routeId);
        if (routeEntity.RouteId < 0) {
            this.removeRoute(newState.routeEntities, nodeRouteData.routeId);
        }
        else {
            // Mark item as delete
            routeEntity._isDeleted = true;
        }
        nodeRouteData.routeId = null;
        nodeRouteData.invalid = false;
        nodeRouteData.invalidMessage = null;
        nodeRouteData.modified = false;
        nodeRouteData.routeMenuData.routeId = null;
        node.type = this.routingTreeService.determineNodeType2(node, false);
        node.styleClass = this.routingTreeService.determineTreeNodeClass(node.type);
        if (includeChildren) {
            for (const childNode of node.children) {
                this.undoConvertRoute(childNode, includeChildren, false);
            }
        }
        if (updateState) {
            this.setEnableSave(newState);
            this.setState(newState);
        }
    }
    removeRoute(routeEntities, routeId) {
        let foundIndex;
        const route = routeEntities.find((r, index) => {
            if (r.RouteId == routeId) {
                foundIndex = index;
                return true;
            }
            return false;
        });
        if (foundIndex >= 0) {
            routeEntities.splice(foundIndex, 1);
        }
    }
    syncEntityTree() {
        const newState = Object.assign({}, this.routingState);
        // Sync all entities from the tree nodes
        // This will set any changed parents and the route order
        this.routingTreeService.syncEntitiesFromNodes(newState.treeData, newState.routeEntities, newState.categoryEntities, null);
        // Update the selected route
        if (newState.selectedRoute) {
            newState.selectedRoute = newState.routeEntities.find(r => r.RouteId == newState.selectedRoute.RouteId);
        }
        this.setEnableSave(newState);
        this.setState(newState);
    }
    saveRoutes() {
        const entitiesToSave = this.getModifiedEntities(this.routingState.treeData);
        this.routingAdminRepository.saveRoutes(entitiesToSave)
            .subscribe(({ routeEntities, keyMap }) => {
            this.applySavedRoutes(routeEntities);
            // Just reinitialize state, simplier and ensures a full reload
            this.initState();
            /* const newState = { ...this.routingState };

            newState.routeEntities = routeEntities;

            if (newState.selectedRoute) {
                newState.selectedRoute = routeEntities.find(r => r.RouteId == newState.selectedRoute.RouteId);
            }

            // Update all nodes to not modified and update any routeIds that were updated during the save
            this.routingTreeService.updateAllNodes(newState.treeData, (node) => {
                const routeData: DwRouteTreeData = node.data;

                routeData.modified = false;
                routeData.invalid = false;
                routeData.invalidMessage = null;

                // Map new key value
                if (routeData.routeId && routeData.routeId < 0) {
                    routeData.routeId = keyMap.get(routeData.routeId);
                }
            });

            this.applySavedRoutes(newState.routeEntities);

            this.setEnableSave(newState);

            this.setState(newState);           */
        });
    }
    applySavedRoutes(newRoutes) {
        // Clear all dynamic rouets that were previous added (they will get re-added)
        this.dwMdRoutingRegistryService.resetDynamicRoutes();
        // Register the new routing entities
        this.dwMdRoutingRepositoryService.registerRouteItems(newRoutes);
        // Register the new dynamic routes
        this.dwMdRoutingRegistryService.registerDynamicRoutes(true);
    }
    getModifiedEntities(nodes, includeDeleted = true) {
        let routes = [];
        for (const node of nodes) {
            // Process children first, so if we're deleted, it will delete the child before the parent
            if (node.children) {
                routes = [...routes, ...this.getModifiedEntities(node.children, false)];
            }
            const routeData = node.data;
            if (routeData.modified && routeData.routeId) {
                routes.push(this.routingState.routeEntities.find(r => r.RouteId == routeData.routeId));
            }
        }
        if (includeDeleted) {
            // Add any deleted routes (since these won't exist in the tree)
            const deletedRoutes = this.routingState.routeEntities.filter(r => r._isDeleted === true);
            const finalDeletedRoutes = [];
            while (deletedRoutes.length > 0) {
                const deletedRoute = deletedRoutes[0];
                this.addDeletedRoute(deletedRoute, deletedRoutes, finalDeletedRoutes);
            }
            routes = [...routes, ...finalDeletedRoutes];
        }
        return routes;
    }
    addDeletedRoute(deletedRoute, remainingDeletedRoutes, finalRoutesToDelete) {
        const parentDeletedRoute = remainingDeletedRoutes.find(dr => dr.RouteId == deletedRoute.ParentRouteId);
        if (parentDeletedRoute) {
            this.addDeletedRoute(parentDeletedRoute, remainingDeletedRoutes, finalRoutesToDelete);
        }
        // Always add to the top of the array so we deleted children, then the parents
        finalRoutesToDelete.splice(0, 0, deletedRoute);
        const index = remainingDeletedRoutes.indexOf(deletedRoute);
        remainingDeletedRoutes.splice(index, 1);
    }
}
DwRoutingAdminStateService.ɵfac = function DwRoutingAdminStateService_Factory(t) { return new (t || DwRoutingAdminStateService)(ɵngcc0.ɵɵinject(DwRoutingAdminRepositoryService), ɵngcc0.ɵɵinject(DwMenuService), ɵngcc0.ɵɵinject(DwRoutingAdminTreeService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwMetaDataRoutingRegistryService), ɵngcc0.ɵɵinject(DwMetaDataRoutingRepositoryService), ɵngcc0.ɵɵinject(DwRoutingAdminConversionService)); };
DwRoutingAdminStateService.ɵprov = ɵɵdefineInjectable({ factory: function DwRoutingAdminStateService_Factory() { return new DwRoutingAdminStateService(ɵɵinject(DwRoutingAdminRepositoryService), ɵɵinject(DwMenuService), ɵɵinject(DwRoutingAdminTreeService), ɵɵinject(Router), ɵɵinject(DwMetaDataRoutingRegistryService), ɵɵinject(DwMetaDataRoutingRepositoryService), ɵɵinject(DwRoutingAdminConversionService)); }, token: DwRoutingAdminStateService, providedIn: "root" });
DwRoutingAdminStateService.ctorParameters = () => [
    { type: DwRoutingAdminRepositoryService },
    { type: DwMenuService },
    { type: DwRoutingAdminTreeService },
    { type: Router },
    { type: DwMetaDataRoutingRegistryService },
    { type: DwMetaDataRoutingRepositoryService },
    { type: DwRoutingAdminConversionService }
];

class DwRoutingAdminMenuService {
    constructor(routingAdminStateService) {
        this.routingAdminStateService = routingAdminStateService;
    }
    buildContextMenu(node) {
        let menuItems = [];
        const routeNodeData = node.data;
        switch (node.type) {
            case DwRouteTreeNodeType.category:
                menuItems = this.buildCategoryMenus(node, routeNodeData);
                break;
            case DwRouteTreeNodeType.staticRoute:
                menuItems = [...this.buildStaticOnlyMenus(node, routeNodeData)];
                break;
            case DwRouteTreeNodeType.dbRoute:
                menuItems = [...this.buildDBRouteMenus(node, routeNodeData)];
                break;
            case DwRouteTreeNodeType.dbRouteChild:
                // No menus for route children
                break;
        }
        return menuItems;
    }
    buildCategoryMenus(node, routeNodeData) {
        const menuItems = [];
        menuItems.push({
            label: `Add Menu`,
            command: (event) => {
                this.routingAdminStateService.addRoute(null, node);
            }
        });
        return menuItems;
    }
    buildDBRouteMenus(node, routeNodeData) {
        let menuItems = [];
        const hasChildren = this.hasChildren(node, false);
        const hasDbChildren = this.hasChildren(node, true);
        // Always show an add menu
        menuItems.push({
            label: `Add Menu`,
            command: (event) => {
                this.routingAdminStateService.addRoute(null, node);
            }
        });
        const hasStaticRoute = routeNodeData.routeMenuData.hasStaticRoute;
        if (hasStaticRoute) {
            menuItems = [...menuItems, ...this.buildDBWithStaticMenus(node, routeNodeData)];
            return menuItems;
        }
        // Now we have dynamic only menus
        if (!hasDbChildren) {
            if (!hasStaticRoute) {
                menuItems.push({
                    label: `Delete`,
                    command: (event) => {
                        this.routingAdminStateService.deleteRoute(node, false);
                    }
                });
            }
        }
        else {
            menuItems.push({
                label: `Delete With Children`,
                command: (event) => {
                    this.routingAdminStateService.deleteRoute(node, true);
                }
            });
        }
        return menuItems;
    }
    buildStaticOnlyMenus(node, routeNodeData) {
        const menus = [];
        if (!node.parent.data.routeId && node.parent.type != DwRouteTreeNodeType.category) {
            return [];
        }
        menus.push({
            label: `Convert to DB Route`,
            command: (event) => {
                this.routingAdminStateService.convertRoute(node, false);
            }
        });
        if (node.children && node.children.length > 0) {
            menus.push({
                label: `Convert to DB Route Including Children`,
                command: (event) => {
                    this.routingAdminStateService.convertRoute(node, true);
                }
            });
        }
        return menus;
    }
    buildDBWithStaticMenus(node, routeNodeData) {
        const menuItems = [];
        const hasChildren = this.hasChildren(node, false);
        const hasDbChildren = this.hasChildren(node, true);
        if (!hasDbChildren) {
            menuItems.push({
                label: `Convert back to Static Route`,
                command: (event) => {
                    this.routingAdminStateService.undoConvertRoute(node);
                }
            });
            if (routeNodeData.routeId < 0) {
                menuItems.push({
                    label: `Undo Conversion`,
                    command: (event) => {
                        this.routingAdminStateService.undoConvertRoute(node);
                    }
                });
            }
        }
        else {
            menuItems.push({
                label: `Convert back to Static Route and delete children`,
                command: (event) => {
                    this.routingAdminStateService.deleteRoute(node, true);
                }
            });
        }
        return menuItems;
    }
    hasChildren(node, onlyDBChildren) {
        if (!node.children) {
            return false;
        }
        for (const childNode of node.children) {
            const childRouteData = childNode.data;
            if (childNode.type !== DwRouteTreeNodeType.dbRouteChild) {
                if (!onlyDBChildren) {
                    return true;
                }
                if (childRouteData.routeId) {
                    return true;
                }
            }
        }
        return false;
    }
}
DwRoutingAdminMenuService.ɵfac = function DwRoutingAdminMenuService_Factory(t) { return new (t || DwRoutingAdminMenuService)(ɵngcc0.ɵɵinject(DwRoutingAdminStateService)); };
DwRoutingAdminMenuService.ɵprov = ɵɵdefineInjectable({ factory: function DwRoutingAdminMenuService_Factory() { return new DwRoutingAdminMenuService(ɵɵinject(DwRoutingAdminStateService)); }, token: DwRoutingAdminMenuService, providedIn: "root" });
DwRoutingAdminMenuService.ctorParameters = () => [
    { type: DwRoutingAdminStateService }
];

var __decorate$4 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$4 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwRoutingAdminTreeComponent = class DwRoutingAdminTreeComponent {
    constructor(ormDataService, metaDataService, routingAdminStateService, routingAdminMenuService) {
        this.ormDataService = ormDataService;
        this.metaDataService = metaDataService;
        this.routingAdminStateService = routingAdminStateService;
        this.routingAdminMenuService = routingAdminMenuService;
        this.selectedTabIndex = 0;
        this.nodeJustSelected = false;
        this.convertAllChildren = false;
        this.cmRouteItems = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.routingAdminStateService.initState();
        this.subscriptions.push(this.routingAdminStateService.stateChanged()
            .subscribe(routingState => {
            setTimeout(() => {
                // If we just selected a route, then select the configure tab
                if (this.routingState && this.routingState.selectedNode && (routingState === null || routingState === void 0 ? void 0 : routingState.selectedRoute)) {
                    this.selectedTabIndex = 1;
                }
                this.routingState = routingState;
            });
        }));
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setCurrentNode(event) {
        this.routingAdminStateService.setSelectedNode(event.node);
    }
    saveRoutes() {
        this.routingAdminStateService.saveRoutes();
    }
    nodeDropped(event) {
        let parentNode = event.dropNode.parent;
        // If a dropIndex is set, then item was dropped onto the drop node, so it should be the parent
        if (event.index !== undefined) {
            parentNode = event.dropNode;
        }
        if (event.dropNode.type == DwRouteTreeNodeType.category) {
            parentNode = event.dropNode;
        }
        if (!parentNode) {
            return;
        }
        if (event.dragNode && event.dragNode.type == DwRouteTreeNodeType.addMenu) {
            const addRouteData = event.dragNode.data;
            this.routingAdminStateService.addRoute(null, parentNode, addRouteData, event.dropIndex);
        }
        else {
            event.accept();
        }
        this.routingAdminStateService.syncEntityTree();
    }
    addRoute(route) {
        this.routingAdminStateService.addRoute(route, this.routingState.selectedNode);
    }
    updateRoute(route) {
        this.routingAdminStateService.updateRoute(route, false);
    }
    deleteRoute(node) {
        this.routingAdminStateService.deleteRoute(node, false);
    }
    updateChildRoute(route) {
        const routeTreeData = this.routingState.selectedNode.data;
        this.routingAdminStateService.updateRoute(route, true, routeTreeData.routeMenuData.metaDataActionType);
    }
    validChange(isValid) {
        this.routingAdminStateService.setNodeValid(isValid);
    }
    convertToDynamicRoute(node) {
        this.routingAdminStateService.convertRoute(node, this.convertAllChildren);
    }
    undoConversion(node) {
        this.routingAdminStateService.undoConvertRoute(node);
    }
    contextMenuClick(event, node) {
        this.cmRouteItems = this.routingAdminMenuService.buildContextMenu(node);
        if (this.cmRouteItems.length > 0) {
            this.cmRoutes.show(event);
        }
        return false;
    }
};
DwRoutingAdminTreeComponent.ɵfac = function DwRoutingAdminTreeComponent_Factory(t) { return new (t || DwRoutingAdminTreeComponent)(ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwRoutingAdminStateService), ɵngcc0.ɵɵdirectiveInject(DwRoutingAdminMenuService)); };
DwRoutingAdminTreeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRoutingAdminTreeComponent, selectors: [["dw-dw-routing-admin-tree"]], viewQuery: function DwRoutingAdminTreeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c11, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cmRoutes = _t.first);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([TreeDragDropService])], decls: 9, vars: 1, consts: [[4, "ngIf"], ["dynamicMenuEdit", ""], ["staticMenuEdit", ""], ["missingValidParent", ""], ["convertStaticRoute", ""], ["header", ""], ["body", ""], [3, "show"], ["dwRow", "", 4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], [1, "tree-container"], ["draggableNodes", "true", "droppableNodes", "true", "selectionMode", "single", 3, "value", "selection", "validateDrop", "onNodeSelect", "onNodeDrop"], ["pTemplate", "category"], ["pTemplate", "dbRoute"], ["pTemplate", "staticRoute"], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "model"], ["cmRoutes", ""], [1, "btn", "btn-success", 3, "disabled", "click"], [3, "activeIndex", "activeIndexChange"], ["header", "Add Menus"], [1, "dw-minimal-tree"], ["draggableNodes", "true", 3, "value"], ["pTemplate", "addMenu"], ["header", "Configure Menu"], [3, "contextmenu"], [3, "hidden"], [1, "fa", "fa-exclamation-triangle", "text-danger", "ml-4", 3, "hidden"], [2, "font-size", "1.5em"], [1, "far", "fa-layer-plus", "fa-border"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "route", "treeNode", "routeChange", "validChange", "undoConversion", 4, "ngIf"], [3, "route", "menuData", "routeChange", 4, "ngIf"], [3, "route", "treeNode", "routeChange", "validChange", "undoConversion"], [3, "route", "menuData", "routeChange"], [1, "alert", "alert-warning"], [1, "btn", "btn-warning", 3, "click"], ["type", "checkbox", 3, "ngModel", "ngModelChange"]], template: function DwRoutingAdminTreeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRoutingAdminTreeComponent_dw_container_0_Template, 6, 2, "dw-container", 0);
        ɵngcc0.ɵɵtemplate(1, DwRoutingAdminTreeComponent_ng_template_1_Template, 2, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, DwRoutingAdminTreeComponent_ng_template_3_Template, 1, 3, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(5, DwRoutingAdminTreeComponent_ng_template_5_Template, 2, 0, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, DwRoutingAdminTreeComponent_ng_template_7_Template, 6, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routingState);
    } }, directives: function () { return [ɵngcc4.NgIf, DwContainerComponent, DwLoadingComponent, DwRowDirective, DwColDirective, ɵngcc8.Tree, ɵngcc6.PrimeTemplate, ɵngcc7.ContextMenu, DwButtonBarComponent, ɵngcc9.TabView, ɵngcc9.TabPanel, DwRouteEditComponent, DwRouteEditChildComponent, ɵngcc3.CheckboxControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel]; }, styles: [".db-route{color:green!important}.static-route{color:#00f!important}.category-node{color:#000;font-size:larger}.tree-container{max-height:700px;overflow:auto}"], encapsulation: 2 });
DwRoutingAdminTreeComponent.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwRoutingAdminStateService },
    { type: DwRoutingAdminMenuService }
];
DwRoutingAdminTreeComponent.propDecorators = {
    cmRoutes: [{ type: ViewChild, args: ['cmRoutes',] }]
};
DwRoutingAdminTreeComponent = __decorate$4([
    DwComponent({
        name: 'Route Config Admin',
        componentType: DwComponentType.pageComponent,
        isGlobal: false,
        parentItemName: DevwareMetaDataItemNames.DwRoute,
    }),
    __metadata$4("design:paramtypes", [DwOrmDataService,
        DwMetaDataService,
        DwRoutingAdminStateService,
        DwRoutingAdminMenuService])
], DwRoutingAdminTreeComponent);

var DwModuleType;
(function (DwModuleType) {
    DwModuleType["database"] = "Database";
    DwModuleType["instantAPI"] = "InstantAPI";
    DwModuleType["instantUI"] = "InstantUI";
    DwModuleType["scheduler"] = "Scheduler";
    DwModuleType["application"] = "Application";
})(DwModuleType || (DwModuleType = {}));

class DwSchedulerService {
    constructor(http, configService, dwOrmDataService) {
        this.http = http;
        this.configService = configService;
        this.dwOrmDataService = dwOrmDataService;
        this.suppressErrorMessages = true;
        // Setup storage to use
        this.schedulerApi = `${configService.coreConfig.apiRoot}/scheduler`;
    }
    getServiceStatus() {
        const url = `${this.schedulerApi}/services/status`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    getVersion() {
        const url = `${this.schedulerApi}/version`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    startService() {
        const url = `${this.schedulerApi}/services/start`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    stopService() {
        const url = `${this.schedulerApi}/services/stop`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    checkHeartbeat() {
        const url = `${this.schedulerApi}/heartbeat`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    refreshSchedules() {
        const url = `${this.schedulerApi}/refresh`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    startProcess(processScheduleId) {
        const url = `${this.schedulerApi}/start-process?processScheduleId=${processScheduleId}`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    stopProcess(processScheduleId) {
        const url = `${this.schedulerApi}/stop-process?processScheduleId=${processScheduleId}`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.get(url, { headers: headers });
    }
    getLastModifiedSchedule() {
        var query = DevwareMetaData.DwProcessSchedule.CreateQuery();
        var attr = DevwareMetaData.DwProcessSchedule;
        query.OrderBy(attr.ModifiedDateTime, false);
        query.AddPrefetchPath(attr.Relations.DwProcessScheduleSummary);
        return this.dwOrmDataService.executeQuerySingle(query);
    }
}
DwSchedulerService.ɵfac = function DwSchedulerService_Factory(t) { return new (t || DwSchedulerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken)); };
DwSchedulerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSchedulerService, factory: DwSchedulerService.ɵfac });
DwSchedulerService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] }
];

var __decorate$5 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$5 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwProductVersionAdminComponent = class DwProductVersionAdminComponent {
    constructor(dwAppInitService, dwSchedulerService) {
        this.dwAppInitService = dwAppInitService;
        this.dwSchedulerService = dwSchedulerService;
        this.productVersions = [];
    }
    ngOnInit() {
        this.dwAppInitService.getProductVersions()
            .subscribe(versions => {
            this.productVersions = [...versions, ...this.productVersions];
            this.processVersions();
        });
        this.dwSchedulerService.getVersion()
            .subscribe(schedulerVersion => {
            if (!schedulerVersion) {
                return;
            }
            this.productVersions = [...this.productVersions, schedulerVersion];
            this.processVersions();
        });
    }
    processVersions() {
        const dbModule = this.findProductModule(DwModuleType.database);
        const apiModule = this.findProductModule(DwModuleType.instantAPI);
        const uiModule = this.findProductModule(DwModuleType.instantUI);
        const scheduleModule = this.findProductModule(DwModuleType.scheduler);
        const dbVersion = this.getMajorMinorVersion(dbModule === null || dbModule === void 0 ? void 0 : dbModule.ProductVersion);
        const apiVersion = this.getMajorMinorVersion(apiModule === null || apiModule === void 0 ? void 0 : apiModule.ProductVersion);
        const uiVersion = this.getMajorMinorVersion(uiModule === null || uiModule === void 0 ? void 0 : uiModule.ProductVersion);
        const success = {
            iconClass: 'fa fa-check dw-green',
            title: 'Good to go'
        };
        dbModule.AdditionalInfo = apiModule.AdditionalInfo = uiModule.AdditionalInfo = success;
        if (dbVersion < apiVersion) {
            dbModule.AdditionalInfo = {
                iconClass: 'fa fa-exclamation-triangle dw-red',
                title: 'Error: Database version is older that api which can cause database errors.  Upgrade the database to the latest version'
            };
        }
        if (apiVersion < dbVersion) {
            apiModule.AdditionalInfo = {
                iconClass: 'fa fa-traffic-light-slow dw-orange',
                title: 'Warning: Api version is older than database so there are new features available in the latest version'
            };
        }
        if (apiVersion < uiVersion) {
            apiModule.AdditionalInfo = {
                iconClass: 'fa fa-exclamation-triangle dw-red',
                title: 'Error: API version is older that UI which can cause API errors.  Upgrade the Api & database to the latest version'
            };
        }
        if (uiVersion < apiVersion) {
            uiModule.AdditionalInfo = {
                iconClass: 'fa fa-traffic-light-slow dw-orange',
                title: 'Warning: UI version is older than the Api so there are new features available in the latest version'
            };
        }
        if (scheduleModule) {
            const scheduleVersion = this.getMajorMinorVersion(scheduleModule === null || scheduleModule === void 0 ? void 0 : scheduleModule.ProductVersion);
            // Default to success if we have a scheduler
            scheduleModule.AdditionalInfo = success;
            if (scheduleVersion > apiVersion) {
                scheduleModule.AdditionalInfo = {
                    iconClass: 'fa fa-exclamation-triangle dw-red',
                    title: 'Error: API version is older than the Scheduler which can cause scheduler errors.  Upgrade the Api & database to the latest version'
                };
            }
            if (apiVersion > scheduleVersion) {
                scheduleModule.AdditionalInfo = {
                    iconClass: 'fa fa-traffic-light-slow dw-orange',
                    title: 'Warning: Scheduler version is older than the Api so there might be new features available in the latest version'
                };
            }
        }
    }
    isNewerVersion(productVersion1, productVersion2) {
        if (!productVersion1 || !productVersion2) {
            return;
        }
        const version1 = this.getMajorMinorVersion(productVersion1.ProductVersion);
        const version2 = this.getMajorMinorVersion(productVersion2.ProductVersion);
        return version1 > version2;
    }
    findProductModule(moduleType) {
        return this.productVersions.find(p => p.ModuleType == moduleType);
    }
    getMajorMinorVersion(version) {
        if (!version) {
            return '';
        }
        const parts = version.split('.');
        parts.length = 2;
        return parts.join('.');
    }
};
DwProductVersionAdminComponent.ɵfac = function DwProductVersionAdminComponent_Factory(t) { return new (t || DwProductVersionAdminComponent)(ɵngcc0.ɵɵdirectiveInject(DwAppInitService), ɵngcc0.ɵɵdirectiveInject(DwSchedulerService)); };
DwProductVersionAdminComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwProductVersionAdminComponent, selectors: [["dw-product-version-admin"]], decls: 15, vars: 1, consts: [[1, "product-table"], [4, "ngFor", "ngForOf"], [3, "title"]], template: function DwProductVersionAdminComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1");
        ɵngcc0.ɵɵtext(1, "CAP Product Version");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "table", 0);
        ɵngcc0.ɵɵelementStart(3, "thead");
        ɵngcc0.ɵɵelementStart(4, "tr");
        ɵngcc0.ɵɵelementStart(5, "th");
        ɵngcc0.ɵɵtext(6, " Module ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "th");
        ɵngcc0.ɵɵtext(8, " Version ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "th");
        ɵngcc0.ɵɵtext(10, " Date ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "th");
        ɵngcc0.ɵɵtext(12, " Status ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "tbody");
        ɵngcc0.ɵɵtemplate(14, DwProductVersionAdminComponent_tr_14_Template, 11, 10, "tr", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(14);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.productVersions);
    } }, directives: [ɵngcc4.NgForOf], pipes: [ɵngcc4.DatePipe], styles: [".product-table[_ngcontent-%COMP%]{max-width:800px;width:100%}.product-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%], .product-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .product-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid #000}.product-table[_ngcontent-%COMP%]   table[_ngcontent-%COMP%]{border-collapse:collapse;font-family:Arial,Helvetica,sans-serif;max-width:800px;width:100%}.product-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:green;color:#fff;padding-bottom:12px;padding-top:12px;text-align:left}.product-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .product-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid #000;padding:8px}.product-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background-color:#ddd}.product-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(2n){background-color:#f2f2f2}"] });
DwProductVersionAdminComponent.ctorParameters = () => [
    { type: DwAppInitService },
    { type: DwSchedulerService }
];
DwProductVersionAdminComponent = __decorate$5([
    DwComponent({
        key: 'dwProductVersion',
        name: 'CAP Product Version Info',
        isGlobal: true,
        componentType: DwComponentType.pageComponent,
    }),
    __metadata$5("design:paramtypes", [DwAppInitService, DwSchedulerService])
], DwProductVersionAdminComponent);

class DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService) {
        this.dwExpressionService = dwExpressionService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.destroyed = false;
        this.subscriptions = [];
        this._visible = false;
        this.visibleChange = new EventEmitter();
        DwSectionBaseComponent.componentCount++;
        this.buildComponentName();
    }
    buildComponentName() {
        let name = `Section-${DwSectionBaseComponent.componentCount}`;
        if (this.sectionConfig) {
            name = `${this.sectionConfig.title}(${this.sectionConfig.sectionType})-${DwSectionBaseComponent.componentCount}`;
        }
        this.componentName = name;
    }
    setupComponentComplete() {
        this.buildComponentName();
    }
    // Overridable methods triggered when their value changes
    //    OnChanges doesn't fire in all cases, so have to use the get/set method which is method
    //    Therefore, put all this in the base class and call these change methods
    sectionConfigChanged() { }
    formConfigChanged() { }
    fromGroupChanged() { }
    submittedChanged() { }
    contextChanged() { }
    visibleChanged() { }
    ngOnDestroy() {
        ////console.log("DwSectionBaseComponent - destroyed", this.sectionConfig);
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        this.destroyed = true;
    }
    get visible() {
        return this._visible;
    }
    set visible(value) {
        if (this._visible == value) {
            return;
        }
        this._visible = value;
        this.visibleChange.emit(value);
        this.visibleChanged();
        DwFormDebugService.debugMessage(null, this.componentName, `DwFormSection.visible set to ${value}`);
    }
    get formGroup() {
        return this._formGroup;
    }
    set formGroup(value) {
        this._formGroup = value;
        this.fromGroupChanged();
    }
    get context() {
        return this._context;
    }
    set context(value) {
        this._context = value;
        ////console.log("DwSectionBaseComponent - contextChanged", this._context);
        this.contextChanged();
    }
    get submitted() {
        return this._submitted;
    }
    set submitted(value) {
        this._submitted = value;
        this.submittedChanged();
    }
    get sectionConfig() {
        return this._sectionConfig;
    }
    set sectionConfig(value) {
        let previousValue = this._sectionConfig;
        this._sectionConfig = value;
        this.buildComponentName();
        if (!areEqual(previousValue, value)) {
            this.sectionConfigChanged();
        }
    }
    get formConfig() {
        return this._formConfig;
    }
    set formConfig(value) {
        let previousValue = this._formConfig;
        this._formConfig = value;
        if (!areEqual(previousValue, value))
            this.formConfigChanged();
    }
    ngOnInit() {
    }
    getOrCreateFormControl(fieldName, formGroup) {
        const qh = new DwQueryHelper();
        fieldName = qh.fields.parseFullFieldName(fieldName).FieldName;
        if (!formGroup) {
            formGroup = this.formGroup;
        }
        let formControl = formGroup.get(fieldName);
        if (!formControl) {
            formControl = new FormControl();
            formGroup.addControl(fieldName, formControl);
            // If data has been loaded, populate the attachment File Id, otherwise it will be blank
            if (this.context.data && this.context.data.value && this.context.data.value[fieldName]) {
                formControl.setValue(this.context.data.value[fieldName]);
            }
        }
        return formControl;
    }
    ngOnChanges(changes) {
    }
    runAfterFormDataLoaded(func) {
        var _a;
        // Wait for form to load data
        const formContext = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        if (!formContext) {
            return;
        }
        if (formContext && !((_a = formContext.value) === null || _a === void 0 ? void 0 : _a.loadDataComplete)) {
            this.subscriptions.push(formContext.subscribe((formContext) => {
                if (formContext.loadDataComplete) {
                    func();
                }
            }));
            return;
        }
        if (!this.sectionConfig || !this.formConfig) {
            // Try again in 50 ms
            setTimeout(() => {
                func();
            }, 500);
            return;
        }
        func();
    }
    runAfterContextDataLoaded(contextName, excludeEmptyObject, contextLoaded) {
        // Retry when the context exists
        if (!this.context || !this.context[contextName]) {
            setTimeout(() => {
                this.runAfterContextDataLoaded(contextName, excludeEmptyObject, contextLoaded);
            }, 100);
            return;
        }
        const contextItem = this.context[contextName];
        const contextValue = contextItem === null || contextItem === void 0 ? void 0 : contextItem.value;
        // If we have the value, return it immediately
        if (contextValue) {
            if (!excludeEmptyObject || !isEmptyObject(contextValue)) {
                contextLoaded(contextValue);
                return;
            }
        }
        // otherwise, subscribe to the context changes and return the context value
        const subscription = contextItem.subscribe(newContextValue => {
            if (contextValue && (!excludeEmptyObject || !isEmptyObject(newContextValue))) {
                contextLoaded(newContextValue);
                subscription.unsubscribe();
            }
        });
    }
}
DwSectionBaseComponent.ɵfac = function DwSectionBaseComponent_Factory(t) { return new (t || DwSectionBaseComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwSectionBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwSectionBaseComponent, inputs: { visible: "visible", formGroup: "formGroup", context: "context", submitted: "submitted", sectionConfig: "sectionConfig", formConfig: "formConfig" }, outputs: { visibleChange: "visibleChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwSectionBaseComponent.componentCount = 0;
DwSectionBaseComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwSectionBaseComponent.propDecorators = {
    visible: [{ type: Input }],
    visibleChange: [{ type: Output }],
    formGroup: [{ type: Input }],
    context: [{ type: Input }],
    submitted: [{ type: Input }],
    sectionConfig: [{ type: Input }],
    formConfig: [{ type: Input }]
};

class AdminMeaningDefaultComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataFormStateService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
    }
    setupComponentComplete() {
        this.runAfterFormDataLoaded(() => {
            this.setupWatches();
        });
    }
    setupWatches() {
        // Only update the meaning when we are in Add mode
        if (this.dwMetaDataFormStateService.state.formContext.contextMode != DwFormContextMode.add && this.dwMetaDataFormStateService.state.formContext.contextMode != DwFormContextMode.edit) {
            return;
        }
        for (const controlName in this.formGroup.controls) {
            if (controlName.endsWith('Display') || controlName.endsWith('Name')) {
                const displayControl = this.formGroup.controls[controlName];
                this.subscriptions.push(displayControl.valueChanges
                    .pipe(debounceTime(50))
                    .subscribe(rawValue => {
                    this.updateMeaning(controlName);
                }));
            }
        }
    }
    processDataChange(controlName, formValue) {
        for (const controlName in this.formGroup.controls) {
            if (controlName.endsWith('Display')) {
                this.updateMeaning(controlName);
            }
        }
    }
    updateMeaning(controlName) {
        const displayControl = this.formGroup.controls[controlName];
        let meaningControlName = controlName.replace('Display', 'Meaning');
        meaningControlName = meaningControlName.replace('Name', 'Meaning');
        let meaningControl = this.formGroup.controls[meaningControlName];
        if (!meaningControl) {
            // Check if field ending in Key is found
            meaningControlName = controlName.replace('Display', 'Key');
            meaningControlName = meaningControlName.replace('Name', 'Key');
            meaningControl = this.formGroup.controls[meaningControlName];
        }
        if (!displayControl || !meaningControl) {
            console.warn(`No meaning control found for display field ${controlName}`);
            return;
        }
        if (meaningControl.disabled) {
            return;
        }
        // Only update on edit if the meaning is cleared out
        if (this.dwMetaDataFormStateService.state.formContext.contextMode == DwFormContextMode.edit && meaningControl.value) {
            return;
        }
        const displayValue = displayControl.value;
        if (!displayValue) {
            return;
        }
        const newMeaningValue = buildMeaningValue(displayValue);
        const currentMeaningValue = meaningControl.value;
        if (newMeaningValue == currentMeaningValue) {
            return;
        }
        meaningControl.setValue(newMeaningValue);
    }
}
AdminMeaningDefaultComponent.ɵfac = function AdminMeaningDefaultComponent_Factory(t) { return new (t || AdminMeaningDefaultComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
AdminMeaningDefaultComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AdminMeaningDefaultComponent, selectors: [["dw-admin-meaning-default"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 0, vars: 0, template: function AdminMeaningDefaultComponent_Template(rf, ctx) { }, encapsulation: 2 });
AdminMeaningDefaultComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormStateService }
];
function buildMeaningValue(displayValue) {
    let newValue = displayValue.replaceAll('  ', ' ');
    newValue = newValue.replaceAll('  ', ' ');
    newValue = newValue.replaceAll('  ', ' ');
    newValue = newValue.replaceAll(' - ', '-');
    newValue = newValue.replaceAll(' ', '_');
    return newValue;
}
DwComponentFunc({
    key: 'dwAdminMeaningDefault',
    name: 'Admin Meaning Defaults',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: [DevwareMetaDataItemNames.DwAppPermission, DevwareMetaDataItemNames.DwRole, DevwareMetaDataItemNames.DwMetaDataQuery, DevwareMetaDataItemNames.DwMetaDataLookup, DevwareMetaDataItemNames.DwRuleDefinition, DevwareMetaDataItemNames.DwContextDataDefinition, DevwareMetaDataItemNames.DwFeatureArea]
}, AdminMeaningDefaultComponent);

var __decorate$6 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$6 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const ɵ0 = {
    display: 'Grid View',
    iconCssClass: 'fa fa-list',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataActionType: 'grid',
    referenceKey: 'mdGridView',
    breadCrumbDisplayParam: 'itemName',
}, ɵ1 = {
    display: 'Edit',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'mdGridView-edit'
}, ɵ2 = {
    display: 'View',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataActionType: 'view',
    isChild: true,
    referenceKey: 'mdGridView-view'
}, ɵ3 = {
    display: 'Print',
    iconCssClass: 'fa fa-print',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataActionType: 'print',
    isChild: true,
    referenceKey: 'mdGridView-print'
}, ɵ4 = {
    display: 'Add',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'mdGridView-add'
};
const genericItemRoute = {
    path: ':itemName',
    component: DwDefaultGridPage,
    data: ɵ0,
    children: [
        {
            path: 'edit/:keyValue',
            component: DwDefaultFormPage,
            data: ɵ1
        },
        {
            path: 'view/:keyValue',
            component: DwDefaultFormPage,
            data: ɵ2
        },
        {
            path: 'print/:keyValue',
            component: DwDefaultFormPage,
            data: ɵ3
        },
        {
            path: 'add',
            component: DwDefaultFormPage,
            data: ɵ4
        }
    ]
};
const ɵ5 = {
    display: 'Add Lookup',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataLookup,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'metaDataLookup-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ6 = {
    display: 'Edit Lookup',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataLookup,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataLookup-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ7 = {
    display: 'Add Query',
    iconCssClass: 'fa fa-add',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataQuery,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'metaDataQuery-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ8 = {
    display: 'Edit Query',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataQuery,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataQuery-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ9 = {
    display: 'Add Relationship',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataItemRelationship,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'metaDataRelationship-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ10 = {
    display: 'Edit Relationship',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataItemRelationship,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataRelationship-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ11 = {
    display: 'Add Rule',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwRuleDefinition,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'ruleDefinition-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ12 = {
    display: 'Edit Rule',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwRuleDefinition,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'ruleDefinition-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ13 = {
    display: 'Add Event',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataEvent,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'metaDataEvent-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ14 = {
    display: 'Edit Event',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataEvent,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataEvent-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
};
const itemChildRoutes = [
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataLookup, DwMenuActionType.add, 'add-lookup'),
        component: DwDefaultFormPage,
        data: ɵ5
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataLookup, DwMenuActionType.edit, 'edit-lookup'),
        component: DwDefaultFormPage,
        data: ɵ6
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataQuery, DwMenuActionType.add, 'add-query'),
        component: DwDefaultFormPage,
        data: ɵ7
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataQuery, DwMenuActionType.edit, 'edit-query'),
        component: DwDefaultFormPage,
        data: ɵ8
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItemRelationship, DwMenuActionType.add, 'add-relationship'),
        component: DwDefaultFormPage,
        data: ɵ9
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItemRelationship, DwMenuActionType.edit, 'edit-relationship'),
        component: DwDefaultFormPage,
        data: ɵ10
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwRuleDefinition, DwMenuActionType.add, 'add-rule'),
        component: DwDefaultFormPage,
        data: ɵ11
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwRuleDefinition, DwMenuActionType.edit, 'edit-rule'),
        component: DwDefaultFormPage,
        data: ɵ12
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataEvent, DwMenuActionType.add, 'add-event'),
        component: DwDefaultFormPage,
        data: ɵ13
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataEvent, DwMenuActionType.edit, 'edit-event'),
        component: DwDefaultFormPage,
        data: ɵ14
    },
    genericItemRoute
];
const ɵ15 = {
    display: 'Add',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwFeatureArea,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: `${DevwareMetaDataItemNames.DwFeatureArea}-add`
}, ɵ16 = {
    display: 'Edit Feature',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwFeatureArea,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: `${DevwareMetaDataItemNames.DwFeatureArea}-edit`
}, ɵ17 = {
    display: 'Add Context Data',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwContextDataDefinition,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'metaDataContextData-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ18 = {
    display: 'Edit Context Data',
    iconCssClass: 'fa fa-plus',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwContextDataDefinition,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataContextData-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ19 = {
    display: 'Edit Item',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwMetaDataItem,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataItem-edit2',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ20 = {
    display: 'Add Permission',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwAppPermission,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'DwAppPermission-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ21 = {
    display: 'Edit Permission',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwAppPermission,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'DwAppPermission-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ22 = {
    display: 'Add Role',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwRole,
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'DwRole-add',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
}, ɵ23 = {
    display: 'Edit Role',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwRole,
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'DwRole-edit',
    childListMenuOptions: {
        isChildListMenu: true,
        showOnEditChild: true,
        showOnParent: false
    }
};
const featureAreaChildRoutes = [
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwFeatureArea, DwMenuActionType.add),
        component: DwDefaultFormPage,
        data: ɵ15,
    },
    {
        path: getMenuActionTypePath(DevwareMetaDataItemNames.DwFeatureArea, DwMenuActionType.edit),
        component: DwDefaultFormPage,
        data: ɵ16,
        children: [
            ...itemChildRoutes,
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwContextDataDefinition, DwMenuActionType.add, 'add-context-data'),
                component: DwDefaultFormPage,
                data: ɵ17
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwContextDataDefinition, DwMenuActionType.edit, 'edit-context-data'),
                component: DwDefaultFormPage,
                data: ɵ18
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItem, DwMenuActionType.edit, 'edit-item'),
                component: DwDefaultFormPage,
                data: ɵ19,
                children: itemChildRoutes
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwAppPermission, DwMenuActionType.add, 'add-permission'),
                component: DwDefaultFormPage,
                data: ɵ20
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwAppPermission, DwMenuActionType.edit, 'edit-permission'),
                component: DwDefaultFormPage,
                data: ɵ21
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwRole, DwMenuActionType.add, 'add-role'),
                component: DwDefaultFormPage,
                data: ɵ22
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwRole, DwMenuActionType.edit, 'edit-role'),
                component: DwDefaultFormPage,
                data: ɵ23
            },
            buildAddEditRoutes(DevwareMetaDataItemNames.DwUiConfig, DwMenuActionType.add, 'Add UI Config', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwUiConfig, DwMenuActionType.edit, 'Edit UI Config', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwMetaDataSecurityGroup, DwMenuActionType.add, 'Add Security Group', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwMetaDataSecurityGroup, DwMenuActionType.edit, 'Edit Security Group', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem, DwMenuActionType.add, 'Add Security Item', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem, DwMenuActionType.edit, 'Edit Security Item', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwEmailTemplate, DwMenuActionType.add, 'Add E-mail Template', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwEmailTemplate, DwMenuActionType.edit, 'Edit E-mail Template', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwProcessDefinition, DwMenuActionType.add, 'Add Process Definition', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwProcessDefinition, DwMenuActionType.edit, 'Edit Process Definition 2', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwProcessSchedule, DwMenuActionType.add, 'Add Process Schedule', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            buildAddEditRoutes(DevwareMetaDataItemNames.DwProcessSchedule, DwMenuActionType.edit, 'Edit Process Schedule', { isChildListMenu: true, showOnEditChild: true, showOnParent: false }),
            genericItemRoute
        ]
    }
];
const ɵ24 = {
    display: 'Admin',
    iconCssClass: 'fa fa-cog',
    requireAuthentication: true,
    highlightOnExactMatch: false,
    showInMenu: true,
    routeOrder: 200,
    hasStaticRoute: true,
    referenceKey: 'full-admin',
    canAccessPermission: DwSecurityPermissions.AdminCanAccess,
    replaceSideMenu: true,
}, ɵ25 = {
    display: 'Other Admin',
    iconCssClass: 'fa fa-list',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 1000,
    canAccessPermission: DwSecurityPermissions.AdminOtherCanAccess
}, ɵ26 = {
    display: 'Caching Admin',
    iconCssClass: 'fa fa-truck-plow',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: true
}, ɵ27 = {
    display: 'Product Version',
    iconCssClass: 'fa fa-code-branch',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: true
}, ɵ28 = {
    referenceKey: 'routing',
    display: 'Menu Admin',
    iconCssClass: 'fa fa-globe',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 110,
    canAccessPermission: DwSecurityPermissions.AdminOtherCanAccess,
    replaceSideMenu: true,
    navigateToFirstChild: true,
    showInMenu: true,
}, ɵ29 = {
    referenceKey: 'routes',
    display: 'Menus',
    iconCssClass: 'fa fa-route',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: true,
    routeOrder: 10,
    metaDataActionType: DwMenuActionType.list,
    metaDataItem: DevwareMetaDataItemNames.DwRoute
}, ɵ30 = {
    display: 'E-mail Admin',
    iconCssClass: 'fa fa-mail-bulk',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 200,
    replaceSideMenu: true,
    navigateToFirstChild: true
}, ɵ31 = {
    referenceKey: 'process-scheduling',
    display: 'Process Scheduling',
    iconCssClass: 'fa fa-calendar-alt',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 300,
    canAccessPermission: DwSecurityPermissions.AdminOtherCanAccess,
    replaceSideMenu: true,
    navigateToFirstChild: true,
}, ɵ32 = {
    display: 'Feature Areas',
    iconCssClass: 'fa fa-puzzle-piece dw-orange',
    excludeFromMainMenu: true,
    metaDataItem: DevwareMetaDataItemNames.DwFeatureArea,
    metaDataActionType: 'grid',
    routeOrder: 1,
    hasStaticRoute: true,
    referenceKey: DevwareMetaDataItemNames.DwFeatureArea
}, ɵ33 = {
    display: 'View',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwFeatureArea,
    metaDataActionType: 'view',
    isChild: true,
    referenceKey: `${DevwareMetaDataItemNames.DwFeatureArea}-view`
}, ɵ34 = {
    display: 'Print',
    iconCssClass: 'fa fa-print',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: DevwareMetaDataItemNames.DwFeatureArea,
    metaDataActionType: 'print',
    isChild: true,
    referenceKey: `${DevwareMetaDataItemNames.DwFeatureArea}-print`
}, ɵ35 = {
    display: 'Data Admin',
    iconCssClass: 'fa fa-list',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 50,
    referenceKey: 'data',
    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
    hasStaticRoute: true,
    replaceSideMenu: true,
    navigateToFirstChild: true
}, ɵ36 = {
    display: 'Data Configuration',
    iconCssClass: 'fa fa-cog',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 50,
    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
}, ɵ37 = {
    display: 'Meta Data items',
    iconCssClass: 'fa fa-database',
    excludeFromMainMenu: true,
    metaDataItem: 'dw_MetaDataItem',
    metaDataActionType: 'grid',
    routeOrder: 2,
    hasStaticRoute: true,
    referenceKey: 'metaDataItems'
}, ɵ38 = {
    display: 'Edit',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: 'dw_MetaDataItem',
    metaDataActionType: 'edit',
    isChild: true,
    referenceKey: 'metaDataItems-edit'
}, ɵ39 = {
    display: 'View',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: 'dw_MetaDataItem',
    metaDataActionType: 'view',
    isChild: true,
    referenceKey: 'metaDataItems-view',
}, ɵ40 = {
    display: 'Print',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: 'dw_MetaDataItem',
    metaDataActionType: 'print',
    isChild: true,
    referenceKey: 'metaDataItems-print'
}, ɵ41 = {
    display: 'Add',
    iconCssClass: 'fa fa-edit',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    showInMenu: false,
    metaDataItem: 'dw_MetaDataItem',
    metaDataActionType: 'add',
    isChild: true,
    referenceKey: 'metaDataItems-add'
}, ɵ42 = {
    display: 'Security',
    iconCssClass: 'fa fa-user',
    excludeFromMainMenu: true,
    requireAuthentication: true,
    routeOrder: 60,
    replaceSideMenu: true,
    navigateToFirstChild: true
    //canAccessPermission : DwSecurityPermissions.AdminSecurityCanAccess
};
var routes = [
    {
        path: 'admin',
        component: DefaultMenuPageComponent,
        parentName: 'root',
        data: ɵ24,
        children: [
            {
                path: 'other',
                component: DefaultMenuPageComponent,
                data: ɵ25,
                children: [
                    {
                        path: 'caching',
                        component: CacheAdminComponent,
                        data: ɵ26,
                    },
                    {
                        path: 'version',
                        component: DwProductVersionAdminComponent,
                        data: ɵ27,
                    }
                ]
            },
            {
                path: 'routing',
                component: DefaultMenuPageComponent,
                data: ɵ28,
                children: [
                    {
                        path: 'routes',
                        component: DwRoutingAdminTreeComponent,
                        data: ɵ29,
                    }
                ]
            },
            {
                path: 'e-mail',
                component: DefaultMenuPageComponent,
                data: ɵ30
            },
            {
                path: 'process-scheduling',
                component: DefaultMenuPageComponent,
                data: ɵ31
            },
            {
                path: 'features',
                component: DwDefaultGridPage,
                data: ɵ32,
                children: featureAreaChildRoutes
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwFeatureArea, DwMenuActionType.view),
                component: DwDefaultFormPage,
                data: ɵ33,
            },
            {
                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwFeatureArea, DwMenuActionType.print),
                component: DwDefaultFormPage,
                data: ɵ34,
            },
            //     ]
            // },
            {
                path: 'data',
                component: DefaultMenuPageComponent,
                data: ɵ35,
                children: [
                    {
                        path: 'data-setup',
                        component: DefaultMenuPageComponent,
                        data: ɵ36,
                    },
                    {
                        path: 'items',
                        component: DwDefaultGridPage,
                        data: ɵ37,
                        children: [
                            {
                                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItem, DwMenuActionType.edit),
                                component: DwDefaultFormPage,
                                data: ɵ38,
                                children: [
                                    ...itemChildRoutes,
                                ]
                            },
                            {
                                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItem, DwMenuActionType.view),
                                component: DwDefaultFormPage,
                                data: ɵ39,
                                children: [
                                    ...itemChildRoutes,
                                ]
                            },
                            {
                                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItem, DwMenuActionType.print),
                                component: DwDefaultFormPage,
                                data: ɵ40,
                                children: [
                                    ...itemChildRoutes,
                                ]
                            },
                            {
                                path: getMenuActionTypePath(DevwareMetaDataItemNames.DwMetaDataItem, DwMenuActionType.add),
                                component: DwDefaultFormPage,
                                data: ɵ41,
                            },
                            genericItemRoute
                        ]
                    },
                ]
            },
            {
                path: 'security',
                component: DefaultMenuPageComponent,
                data: ɵ42
            }
        ]
    },
];
class DevwareAdminRouteSetup {
    setupAllAdminRoutes() {
        // Add Dw Auth Guard to all routes (uses the requireAuthentication and CanAcessPremission data properties)
        // Need to move this to the routing service on init
        //DwRouteGuardUtil.secureRoutes(routes, DwAuthGuardService);  
        //console.log('Setting up admin routes');
        DwMetaDataRoutingRegistryService.addRoutes(routes);
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'users',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwUser,
            data: {
                display: 'Users',
                iconCssClass: 'fa fa-users',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                routeOrder: 1,
            }
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoutes([
            {
                path: 'route-types',
                parentName: 'routing',
                metaDataItem: DevwareMetaDataItemNames.DwRouteType,
                data: {
                    display: 'Menu Types',
                    iconCssClass: 'fa fa-road',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                    routeOrder: 20,
                }
            },
            {
                path: 'route-category',
                parentName: 'routing',
                metaDataItem: DevwareMetaDataItemNames.DwRouteCategory,
                data: {
                    display: 'Menu Categories',
                    iconCssClass: 'fa fa-cat',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                    routeOrder: 30,
                }
            }
        ]);
        DwMetaDataRoutingRegistryService.addMetaDataRoutes([
            {
                path: 'lookups',
                parentName: 'data',
                metaDataItem: DevwareMetaDataItemNames.DwMetaDataLookup,
                data: {
                    display: 'Lookups',
                    iconCssClass: 'fa fa-eye',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                    routeOrder: 2,
                }
            },
            {
                path: 'queries',
                parentName: 'data',
                metaDataItem: DevwareMetaDataItemNames.DwMetaDataQuery,
                data: {
                    display: 'Queries',
                    iconCssClass: 'fa fa-question-circle',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                    routeOrder: 2,
                }
            },
            {
                path: 'rules',
                parentName: 'data',
                metaDataItem: DevwareMetaDataItemNames.DwRuleDefinition,
                data: {
                    display: 'Rules',
                    iconCssClass: 'fa fa-greater-than-equal',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                    routeOrder: 3,
                }
            },
            {
                path: 'events',
                parentName: 'data',
                metaDataItem: DevwareMetaDataItemNames.DwMetaDataEvent,
                data: {
                    display: 'Events',
                    iconCssClass: 'fa fa-calendar',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                    routeOrder: 4,
                }
            },
            {
                path: 'context-data',
                parentName: 'data',
                metaDataItem: DevwareMetaDataItemNames.DwContextDataDefinition,
                data: {
                    display: 'Context Data',
                    iconCssClass: 'fa fa-pencil-ruler',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                    routeOrder: 5,
                }
            },
            {
                path: 'database-setup',
                parentName: 'data-setup',
                metaDataItem: DevwareMetaDataItemNames.DwMetaDataDatabase,
                data: {
                    display: 'Database Setup',
                    iconCssClass: 'fa fa-question-circle',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                    routeOrder: 2,
                }
            },
            {
                path: 'app-setup',
                parentName: 'data-setup',
                metaDataItem: DevwareMetaDataItemNames.DwApplication,
                data: {
                    display: 'Application Setup',
                    iconCssClass: 'fa fa-question-circle',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminUsers,
                    routeOrder: 2,
                }
            },
        ]);
        DwMetaDataRoutingRegistryService.addMetaDataRoutes([
            {
                path: 'templates',
                parentName: 'e-mail',
                metaDataItem: DevwareMetaDataItemNames.DwEmailTemplate,
                data: {
                    display: 'E-mail Templates',
                    iconCssClass: 'fa fa-envelope',
                    routeOrder: 1,
                    showInMenu: true,
                    excludeFromMainMenu: true,
                }
            },
            {
                path: 'history',
                parentName: 'e-mail',
                metaDataItem: DevwareMetaDataItemNames.DwEmailHistory,
                data: {
                    display: 'E-mail History',
                    iconCssClass: 'fa fa-history',
                    routeOrder: 2,
                    showInMenu: true,
                    excludeFromMainMenu: true,
                }
            },
            {
                path: 'branding',
                parentName: 'e-mail',
                metaDataItem: DevwareMetaDataItemNames.DwEmailTemplateGroup,
                data: {
                    display: 'E-mail Branding',
                    iconCssClass: 'fa fa-drafting-compass',
                    routeOrder: 3,
                    showInMenu: true,
                    excludeFromMainMenu: true,
                }
            },
            {
                path: 'dist-list',
                parentName: 'e-mail',
                metaDataItem: DevwareMetaDataItemNames.DwEmailDistributionList,
                data: {
                    display: 'Distribution Lists',
                    iconCssClass: 'fa fa-mail-bulk',
                    routeOrder: 4,
                    showInMenu: true,
                    excludeFromMainMenu: true,
                }
            },
        ]);
        // DwMetaDataRoutingRegistryService.addRoute({
        //     path: 'sender',
        //     parentName: 'e-mail',
        //     component: EmailSenderComponent,
        //     data: {
        //         display: 'E-mail Sender',
        //         iconCssClass: 'fa fa-paper-plane',
        //         routeOrder: 4,
        //         showInMenu: true,
        //         excludeFromMainMenu: true,
        //     }
        // });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'roles',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwRole,
            data: {
                display: 'Roles',
                iconCssClass: 'fa fa-user-lock',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 2,
            }
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'permissions',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwAppPermission,
            data: {
                display: 'Permissions',
                iconCssClass: 'fa fa-lock-alt',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 3,
            }
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'security-groups',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwMetaDataSecurityGroup,
            data: {
                display: 'Security Groups',
                iconCssClass: 'fa fa-shield-alt',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                referenceKey: 'security-groups',
                routeOrder: 4,
            },
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'security-group-items',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem,
            data: {
                display: 'Security Group Items',
                iconCssClass: 'fa fa-shield-alt',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                showInMenu: false,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 5,
                referenceKey: 'security-group-items',
            },
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'security-pat',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwSecurityPersonalAccessToken,
            data: {
                display: 'Security PATs',
                iconCssClass: 'fa fa-shield-alt',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 6,
            }
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'sso-config',
            parentName: 'security',
            metaDataItem: DevwareMetaDataItemNames.DwTenantSSOConfig,
            data: {
                display: 'SSO Config',
                iconCssClass: 'fa fa-shield',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 7,
            }
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'media',
            parentName: 'security',
            metaDataItem: 'dw_MediaSecurity',
            data: {
                display: 'Media Security',
                iconCssClass: 'fa fa-photo-video',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 8,
            }
        });
        DwMetaDataRoutingRegistryService.addMetaDataRoutes([
            {
                path: 'schedules',
                parentName: 'process-scheduling',
                metaDataItem: DevwareMetaDataItemNames.DwProcessSchedule,
                data: {
                    display: 'Schedules',
                    iconCssClass: 'fa fa-clock',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                    routeOrder: 1,
                }
            },
            {
                path: 'schedule-history',
                parentName: 'process-scheduling',
                metaDataItem: DevwareMetaDataItemNames.DwProcessScheduleHistory,
                data: {
                    display: 'Schedule History',
                    iconCssClass: 'fa fa-history',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                    routeOrder: 1,
                }
            },
            {
                path: 'processes',
                parentName: 'process-scheduling',
                metaDataItem: DevwareMetaDataItemNames.DwProcessDefinition,
                data: {
                    display: 'Process Definitions',
                    iconCssClass: 'fa fa-project-diagram',
                    excludeFromMainMenu: true,
                    requireAuthentication: true,
                    canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                    routeOrder: 3,
                }
            }
        ]);
        DwMetaDataRoutingRegistryService.addMetaDataRoute({
            path: 'logging',
            parentName: 'other',
            metaDataItem: DevwareMetaDataItemNames.DwLog,
            data: {
                display: 'Logging',
                iconCssClass: 'fa fa-exclamation-triangle',
                excludeFromMainMenu: true,
                requireAuthentication: true,
                canAccessPermission: DwSecurityPermissions.AdminSecurityCanAdminAdvanced,
                routeOrder: 1,
            }
        });
    }
}
DevwareAdminRouteSetup.ɵfac = function DevwareAdminRouteSetup_Factory(t) { return new (t || DevwareAdminRouteSetup)(); };
DevwareAdminRouteSetup.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DevwareAdminRouteSetup, selectors: [["devware-admin-route-setup"]], decls: 0, vars: 0, template: function DevwareAdminRouteSetup_Template(rf, ctx) { }, encapsulation: 2 });
__decorate$6([
    DwRoutingInitDecorator(),
    __metadata$6("design:type", Function),
    __metadata$6("design:paramtypes", []),
    __metadata$6("design:returntype", void 0)
], DevwareAdminRouteSetup.prototype, "setupAllAdminRoutes", null);
function buildAddEditRoutes(itemName, actionType, displayName, childListMenuOptions) {
    const routePath = buildMeaningValue(displayName).toLowerCase();
    const route = {
        path: getMenuActionTypePath(itemName, actionType, routePath),
        component: DwDefaultFormPage,
        data: {
            display: displayName,
            iconCssClass: 'fa fa-edit',
            excludeFromMainMenu: true,
            requireAuthentication: true,
            showInMenu: false,
            metaDataItem: itemName,
            metaDataActionType: actionType,
            isChild: true,
            referenceKey: routePath,
            childListMenuOptions: childListMenuOptions
        }
    };
    return route;
}
class DevareAdminRoutingModule {
}
DevareAdminRoutingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevareAdminRoutingModule });
DevareAdminRoutingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevareAdminRoutingModule_Factory(t) { return new (t || DevareAdminRoutingModule)(); }, imports: [[RouterModule], RouterModule] });

class DwSecurityInterceptor {
    constructor(storageUtil, configService, securityStateService, router) {
        this.storageUtil = storageUtil;
        this.configService = configService;
        this.securityStateService = securityStateService;
        this.router = router;
    }
    // Ignore Auth/tenant headers
    // {headers: {omitCapHeaders: 'true'}}
    intercept(request, next) {
        var _a, _b, _c;
        // Only apply to requests that are going to the API
        if (request.url.indexOf(this.configService.coreConfig.apiRoot) == -1) {
            return next.handle(request);
        }
        let token = this.getToken();
        let msalAccessToken = this.getMsalAccessToken();
        const omitCapHeaders = request.headers.get('omitCapHeaders') === 'true' ? true : false;
        let omitAuthHeaders = omitCapHeaders || request.headers.get('omitAuthHeaders') === 'true' ? true : false;
        let omitTenantHeaders = omitCapHeaders || request.headers.get('omitTenantHeaders') === 'true' ? true : false;
        const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let headers = {
            'Content-Type': 'application/json',
            'Dw-Client-Time-Zone': browserTimeZone,
            'Dw-Client-Path': (_a = this.router) === null || _a === void 0 ? void 0 : _a.url
        };
        if ((_b = this.configService.coreConfig.platformVersion) === null || _b === void 0 ? void 0 : _b.ProductVersion) {
            headers['Dw-Client-Platform-Version'] = this.configService.coreConfig.platformVersion.ProductVersion;
        }
        if ((_c = this.configService.coreConfig.applicationVersion) === null || _c === void 0 ? void 0 : _c.ProductVersion) {
            headers['Dw-Client-Version'] = this.configService.coreConfig.applicationVersion.ProductVersion;
        }
        // Added to allow the content type of multipart/formdata which is set automatically by the httpClient, but was getting overriden above
        //  The http client adds more to the content type so the client knows when the form data starts/ends
        if (request.headers.get('contentTypeOverride')) {
            headers = {};
        }
        if (!omitAuthHeaders) {
            if (token) {
                headers.Authorization = `Bearer ${token}`;
            }
            if (msalAccessToken) {
                headers.MsalAccessToken = msalAccessToken;
            }
        }
        ;
        if (!omitTenantHeaders && this.configService.coreConfig.tenantKey) {
            headers.TenantKey = this.configService.coreConfig.tenantKey;
        }
        // Add the headers to the request
        request = request.clone({
            // Clear these special headers
            headers: request.headers
                .delete('omitCapHeaders')
                .delete('omitAuthHeaders')
                .delete('omitTenantHeaders'),
            setHeaders: headers,
        });
        return next.handle(request);
    }
    intercept2(request, next) {
        let headers = {
            'APIM-key': 'Add_KEY',
        };
        // Add the headers to the request
        request = request.clone({
            setHeaders: headers,
        });
        return next.handle(request);
    }
    getToken() {
        const securityContext = this.securityStateService.securityState.securityContext;
        if (securityContext) {
            return securityContext.SecurityToken;
        }
        return null;
    }
    getMsalAccessToken() {
        const securityContext = this.securityStateService.securityState.securityContext;
        if (securityContext && securityContext.ExternalTokens && securityContext.ExternalTokens.msal) {
            return securityContext.ExternalTokens.msal.AccessToken;
        }
        return null;
    }
}
DwSecurityInterceptor.ɵfac = function DwSecurityInterceptor_Factory(t) { return new (t || DwSecurityInterceptor)(ɵngcc0.ɵɵinject(DwStorageUtil), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
DwSecurityInterceptor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSecurityInterceptor, factory: DwSecurityInterceptor.ɵfac });
DwSecurityInterceptor.ctorParameters = () => [
    { type: DwStorageUtil },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityStateService },
    { type: Router }
];

class DwConfigProviderBase {
    constructor() {
        this.priority = 10;
    }
    initConfigProvider() {
        return of();
    }
    configureCoreConfig(coreConfig) {
    }
    configureAdditionalConfig(configName, config, coreConfig) {
    }
    setEnvironmentConfig(environmentConfig, overrideConfig) {
    }
}

class DwRoutingConfigDefaults {
    constructor() {
        this.userProfileRouteUrl = 'user-profile';
        this.userRegistrationRouteUrl = 'register';
        this.loginRouteUrl = "login";
        this.defaultRouteUrl = "home";
    }
}

class DwMessagingConfigDefaults {
    constructor() {
        this.saveHttpVerbs = 'save';
        this.logToConsole = false;
    }
}

class DwLoggingConfigDefaults {
    constructor() {
        this.writeAllToConsole = false;
        this.writeAllToServer = false;
        this.writeToConsoleLevels = [DwLogSeverity.error];
        this.writeToServerLevels = [DwLogSeverity.error];
        this.serverMessagePrefix = 'Client - ';
    }
}

var DwSecuritySSOType;
(function (DwSecuritySSOType) {
    DwSecuritySSOType["OAuth2"] = "OAuth";
    DwSecuritySSOType["Custom"] = "Custom";
})(DwSecuritySSOType || (DwSecuritySSOType = {}));

class DwSecuritySSOCustomHandlerService {
    constructor(securityRepository, configService, cacheService, router, dwStorageUtil) {
        this.securityRepository = securityRepository;
        this.configService = configService;
        this.cacheService = cacheService;
        this.router = router;
        this.dwStorageUtil = dwStorageUtil;
        this.ssoAttempKey = 'ssoAttempKey';
        this.maxAttempts = 3;
        this.securityConfig = configService.coreConfig.securityConfig;
    }
    reauthenticateSSO(ssoParams) {
        this.authenticateSSO(ssoParams);
    }
    getAccessToken(ssoParams) {
        return of(null);
    }
    authenticateSSO(ssoParams) {
        const ssoConfig = ssoParams.ssoConfig;
        const ssoToken = getParameterByName(this.router, ssoConfig.AuthenticationTokenParamName);
        const cleanUrl = removeParamFromurl(this.router, ssoConfig.AuthenticationTokenParamName);
        if (ssoToken) {
            ssoParams.completeSSOAuthentication({ idToken: ssoToken });
            // On success, clear the attemp count
            this.setAttempCount(0);
            return;
        }
        const attemptCount = this.getAttemptCount();
        if (attemptCount > this.maxAttempts) {
            ssoParams.completeSSOWithFailure({ errorMessage: 'Error logging in with Single Sign On.  Please try again at a later time!' });
            return;
        }
        this.setAttempCount(attemptCount + 1);
        // Check if we should always log the user in
        /*  if (this.securityConfig.allowAnonymousAccess === false) {
             this.redirectToSSOLogin(ssoParams);
             return;
         } */
        if (ssoParams.ssoConfig.AutoLoginWithSSO) {
            this.redirectToSSOLogin(ssoParams);
            return;
        }
        // Since there is no auth token, nothing to do here
        ssoParams.completeSSONoAction();
    }
    getAttemptCount() {
        let value = this.dwStorageUtil.getValue(this.ssoAttempKey);
        if (value) {
            return parseInt(value);
        }
        this.setAttempCount(0);
        return 0;
    }
    setAttempCount(attemptCount) {
        const options = {
            expirationInMinutes: 2
        };
        this.dwStorageUtil.setValue(this.ssoAttempKey, attemptCount, options);
    }
    redirectToSSOLogin(ssoParams) {
        const ssoConfig = ssoParams.ssoConfig;
        if (!ssoConfig || !ssoConfig.EnableSSO) {
            return;
        }
        const returnUrl = location.href;
        const redirectUrl = ssoConfig.AuthenticateRedirectUrl.replace('[redirectURL]', returnUrl);
        ssoParams.redirectedToSSO();
        location.href = redirectUrl;
    }
    getCleanUrl(ssoParams) {
        const cleanUrl = removeParamFromurl(this.router, ssoParams.ssoConfig.AuthenticationTokenParamName);
        return cleanUrl;
    }
    init(ssoConfig) { }
    logout() {
        // Nothing to do here, we'll keep them logged in to the real system, just log them out of CAP
    }
}
DwSecuritySSOCustomHandlerService.ɵfac = function DwSecuritySSOCustomHandlerService_Factory(t) { return new (t || DwSecuritySSOCustomHandlerService)(ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwStorageUtil)); };
DwSecuritySSOCustomHandlerService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecuritySSOCustomHandlerService_Factory() { return new DwSecuritySSOCustomHandlerService(ɵɵinject(DwSecurityRepositoryServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwCacheService), ɵɵinject(Router), ɵɵinject(DwStorageUtil)); }, token: DwSecuritySSOCustomHandlerService, providedIn: "root" });
DwSecuritySSOCustomHandlerService.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwCacheService },
    { type: Router },
    { type: DwStorageUtil }
];

class DwSecuritySSOMSALHandlerService {
    constructor(securityRepository, configService, messagingService, dwLoggingService, router) {
        this.securityRepository = securityRepository;
        this.configService = configService;
        this.messagingService = messagingService;
        this.dwLoggingService = dwLoggingService;
        this.router = router;
        this._logMSALOutput = true;
        this._logMSALOutputLevel = LogLevel.Verbose;
        this.securityConfig = configService.coreConfig.securityConfig;
    }
    get userAgentApplication() {
        return DwSecuritySSOMSALHandlerService._userAgentApplication;
    }
    set userAgentApplication(value) {
        DwSecuritySSOMSALHandlerService._userAgentApplication = value;
    }
    init(ssoConfig) {
        this.configureMsal(ssoConfig);
    }
    /**
     * Authenticate from an SSO Token
     * @param ssoConfig SSO Configuration
     */
    authenticateSSO(ssoParams) {
        const ssoConfig = ssoParams.ssoConfig;
        const ssoToken = this.getSSOTokenFromUrl(ssoParams);
        if (ssoToken) {
            this.setupHandleAuthResponse(ssoParams);
            return;
        }
        // Auto redirect if anonymous access isn't allowed
        /* if (this.securityConfig.allowAnonymousAccess === false) {
            this.performSilentLogin(ssoParams, false);
            return;
        } */
        if (ssoParams.ssoConfig.AutoLoginWithSSO) {
            this.performSilentLogin(ssoParams, false);
            return;
        }
        // Stop authenticating because no action was needed
        ssoParams.completeSSONoAction();
    }
    getSSOTokenFromUrl(ssoParams) {
        let ssoToken = getFragmentToken(ssoParams.initialUrl, 'id_token');
        if (!ssoToken) {
            ssoToken = getFragmentToken(location.href, 'id_token');
        }
        return ssoToken;
    }
    reauthenticateSSO(ssoParams) {
        this.performSilentLogin(ssoParams, true);
    }
    getCleanUrl(ssoParams) {
        return null;
    }
    getAccessToken(ssoParams) {
        const ssoConfig = ssoParams.ssoConfig;
        return this.getSilentToken(ssoConfig, false, false)
            .pipe(map(authResponse => {
            return authResponse.accessToken;
        }));
    }
    performSilentLogin(ssoParams, reauthenticating) {
        ssoParams.setAuthenticationStatusMessage('Authenticating with Single Sign On - Silent Refresh');
        this.handleAuthResponse(ssoParams, null, this.getSilentToken(ssoParams.ssoConfig), true, reauthenticating);
    }
    handleAuthResponse(ssoParams, authError, authReponseObservable, redirectOnFailure, reauthenticating) {
        const method = reauthenticating ? ssoParams.completeSSOReAuthentication : ssoParams.completeSSOAuthentication;
        if (authError) {
            console.warn('MSAL Authentication Error', authError);
            const ssoname = `${ssoParams.ssoConfig.ButtonText || 'Single Sign On'}`;
            let errorMessage = authError.errorMessage;
            switch (authError.errorCode) {
                case 'endpoints_resolution_error':
                    errorMessage = `Cannot contact Server.  Please check your network connection`;
                    break;
            }
            ssoParams.completeSSOWithFailure({
                errorMessage: `Error logging in with ${ssoname} - ${errorMessage}`
            });
            return;
        }
        authReponseObservable.subscribe(authResponse => {
            if (authResponse.idToken) {
                method({
                    idToken: authResponse.idToken.rawIdToken,
                    expirationDateTime: authResponse.expiresOn.toISOString(),
                    accessToken: authResponse.accessToken,
                });
            }
            else {
                ssoParams.completeSSOWithFailure({
                    errorMessage: 'No Id Token retuned from getSilentToken',
                });
            }
        }, (error) => {
            if ((error === null || error === void 0 ? void 0 : error.errorCode) != 'user_login_error') {
                ssoParams.completeSSOWithFailure({
                    rawError: error,
                    errorMessage: error ? error.message : error,
                });
            }
            else {
                console.warn('SSO login error suppressed due to a login failure.  Redirecting to SSO Login');
            }
            // Hanlde redirect to the OAuth Login
            if (redirectOnFailure) {
                this.redirectToSSOLogin(ssoParams);
            }
        });
    }
    getSilentToken(ssoConfig, refreshIdToken = true, forceRefresh = false) {
        const subject = new Subject();
        const scopes = this.securityConfig.ssoScopes || ssoConfig.Scopes || "openid, profile";
        const loginRequest = {
            scopes: scopes.split(','),
        };
        if (refreshIdToken) {
            loginRequest.scopes = [ssoConfig.OAuthAudience];
        }
        loginRequest.forceRefresh = forceRefresh;
        this.userAgentApplication.acquireTokenSilent(loginRequest).then(function (accessTokenResponse) {
            subject.next(accessTokenResponse);
        }).catch(function (error) {
            subject.error(error);
        });
        return subject.asObservable(); // .pipe(timeout(this.securityConfig.acquireSecurityTokenTimeout));
    }
    logout() {
        this.userAgentApplication.logout();
    }
    /**
     * Redirect to the OAuth 2 Authorize page
     * @param ssoConfig SSO Configuration
     */
    redirectToSSOLogin(ssoParams) {
        const ssoConfig = ssoParams.ssoConfig;
        const scopes = this.securityConfig.ssoScopes || ssoConfig.Scopes || "openid, profile";
        ssoParams.setAuthenticationStatusMessage('Redirecting to Single Sign On');
        const loginRequest = {
            scopes: scopes.split(',')
        };
        // add handle for callback - just in case token is already present
        this.setupHandleAuthResponse(ssoParams);
        setTimeout(() => {
            this.userAgentApplication.loginRedirect(loginRequest);
            ssoParams.redirectedToSSO();
        }, 200);
    }
    setupHandleAuthResponse(ssoParams) {
        this.userAgentApplication.handleRedirectCallback((authError, authReponse) => {
            const subject = new Subject();
            this.handleAuthResponse(ssoParams, authError, subject.asObservable(), false, false);
            subject.next(authReponse);
        });
    }
    configureMsal(ssoConfig) {
        const authorityFullUrl = ssoConfig.OAuthAuthorityUrl.replace('{0}', ssoConfig.OAuthAuthority);
        const config = {
            auth: {
                authority: authorityFullUrl,
                clientId: ssoConfig.OAuthAudience,
                redirectUri: this.getRedirectLocation(),
                navigateToLoginRequestUrl: false,
            },
            system: {
                loadFrameTimeout: this.securityConfig.acquireSecurityTokenTimeout,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: false,
            },
            framework: {
                isAngular: true,
            },
        };
        // create UserAgentApplication instance
        this.userAgentApplication = new UserAgentApplication(config);
        if (this._logMSALOutput) {
            var logger = new Logger((level, message, containsPii) => {
                this.dwLoggingService.logVerbose(`MSAL:${message}`);
            }, 
            // Options (This isn't coded in the MSLA provider, but keeping it for future version)
            {
                level: this._logMSALOutputLevel
            });
            // Settign this direct since the options above aren't coded in the MSAL provider
            logger.level = this._logMSALOutputLevel;
            this.userAgentApplication.setLogger(logger);
        }
    }
    getRedirectLocation() {
        var newURL = location.protocol + "//" + location.host + "/";
        return newURL;
    }
}
DwSecuritySSOMSALHandlerService.ɵfac = function DwSecuritySSOMSALHandlerService_Factory(t) { return new (t || DwSecuritySSOMSALHandlerService)(ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwMessagingService), ɵngcc0.ɵɵinject(DwLoggingService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
DwSecuritySSOMSALHandlerService._userAgentApplication = null;
DwSecuritySSOMSALHandlerService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecuritySSOMSALHandlerService_Factory() { return new DwSecuritySSOMSALHandlerService(ɵɵinject(DwSecurityRepositoryServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwMessagingService), ɵɵinject(DwLoggingService), ɵɵinject(Router)); }, token: DwSecuritySSOMSALHandlerService, providedIn: "root" });
DwSecuritySSOMSALHandlerService.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwMessagingService },
    { type: DwLoggingService },
    { type: Router }
];

class DwSecurityConfigDefaults {
    constructor() {
        this.securityTokenTimeoutMinutes = 60;
        this.canEmulatePermission = 'Ent_Security_CanEmulate';
        this.canConfigureUIPermission = "Ent_UI_CanConfigure";
        this.canEditContentPermision = 'Ent_Ui_Content_CanEdit';
        this.pageSecurityRefreshTimeout = 300;
        this.useSingleSignOn = true;
        this.ssoScopes = 'openid, profile, Mail.Send';
        this.securityTimeoutAction = DwSecurityTimeoutActions.silentRefresh;
        this.securityRefreshMarginSeconds = 120; // Try to refresh the token 2 minutes before it expires
        this.securityTimeoutMessage = 'Your session has timed out.  Please log back in';
        this.allowAnonymousAccess = true;
        this.useSilentSSO = true;
        this.acquireSecurityTokenTimeout = 2000;
        this.securityTimeoutCheckInterval = 30000; // Every 30 seconds
        this.ssoHandlers = {};
        this.setDefaults();
    }
    setDefaults() {
        this.ssoHandlers[DwSecuritySSOType.Custom] = DwSecuritySSOCustomHandlerService;
        this.ssoHandlers[DwSecuritySSOType.OAuth2] = DwSecuritySSOMSALHandlerService;
        this.securityRefresh = {
            action: DwSecurityTimeoutActions.silentRefresh,
            marginSeconds: 60,
            timeoutMessage: 'Your session has timed out.  Please login back in'
        };
        this.alwaysShowRouterOnLoginPaths = '/login';
        this.showAuthenticationMessage = (path, securityState) => {
            return securityState.isAuthenticated;
        };
    }
}

class DwAutoUpdateConfigDefaults {
    constructor() {
        /**
        * If true, the app will load the index.html from the server and check if any script tags have been modified, then it will show a message in the dw-default-layout component
        *
        * Defaults to true
        */
        this.checkforAngularUpdates = true;
        /**
        * Determining the rolling frequency of the auto check for angular updates.  Default is 1 minute
        */
        this.checkFrequencyMinutes = 1;
        /**
        * Overide the default message that is displayed when an update is available.  Default is "App Update Available"
        */
        this.updateMessage = 'App Update Available - Refresh page';
        /**
        * Overide the default message tooltip that is displayed when an update is available.  Default is "App Update Available"
        */
        this.updateMessageTooltip = 'Refresh yor browser to get the latest version of the app';
        /**
        * Allows clicking to refresh - this doesn't work accross all browsers, so it's off by default
        */
        this.allowRefreshOnClick = false;
    }
}

const devwareInstantUiVersion = {
    ModuleName: 'CAP Instant UI (Angular)',
    ModuleType: 'InstantUI',
    ProductVersion: '4.8.7-maint.40',
    PublishDateTime: '05/21/2025 04:54:39 PM'
};
function getAngularCapVersion() {
    const moduleType = DwModuleType.instantUI;
    return devwareInstantUiVersion;
}

class DwCoreConfigDefaults {
    constructor() {
        this.apiRoot = '';
        this.apiRootOld = '';
        this.alternateApiRoots = {};
        this.securityConfig = new DwSecurityConfigDefaults();
        this.routingConfig = new DwRoutingConfigDefaults();
        this.messagingConfig = new DwMessagingConfigDefaults();
        this.loggingConfig = new DwLoggingConfigDefaults();
        this.autoUpdateConfig = new DwAutoUpdateConfigDefaults();
        this.platformVersion = getAngularCapVersion();
        this.disableLocalStorageCaching = true;
        this.childConfigs = {};
        this.globals = {};
    }
}

function DwConfig() {
    return function (constructor) {
        DwConfigService.addConfigProviderType(constructor);
    };
}

var __decorate$7 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwCoreConfigProvider = class DwCoreConfigProvider extends DwConfigProviderBase {
    constructor() {
        super(...arguments);
        this.priority = 1;
    }
    getCoreConfig() {
        //this.configureCoreConfig()
    }
    configureCoreConfig(coreConfig) {
        // Only set the core config the first time
        if (isEmptyObject(coreConfig)) {
            const coreConfigDefaults = new DwCoreConfigDefaults();
            Object.assign(coreConfig, coreConfigDefaults);
        }
        coreConfig.globals = coreConfig.globals = {};
    }
};
DwCoreConfigProvider.ɵfac = function DwCoreConfigProvider_Factory(t) { return ɵDwCoreConfigProvider_BaseFactory(t || DwCoreConfigProvider); };
DwCoreConfigProvider.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwCoreConfigProvider, factory: function (t) { return DwCoreConfigProvider.ɵfac(t); } });
DwCoreConfigProvider = __decorate$7([
    DwConfig()
], DwCoreConfigProvider);

class DwSecurityTwoFactorRepositoryService {
    constructor(http, configService, appInitService) {
        this.http = http;
        this.configService = configService;
        this.appInitService = appInitService;
        this.suppressErrorMessages = false;
        this.securityApi = `${configService.coreConfig.apiRoot}/security`;
    }
    /**
     * Send a two factor code to the logged in user
     * @param userRegistration
     * @returns
     */
    sendTwoFactorCode() {
        let url = `${this.securityApi}/self-service/twofactor/sendcode`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, null, { headers: headers });
    }
    /**
     * Starts setup for two-factor authentication
     * @param twoFactorSetupRequest all options for two-factor
     * @returns two factor response
     */
    startTwoFactorSetup(twoFactorSetupRequest) {
        let url = `${this.securityApi}/self-service/twofactor/setup`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, twoFactorSetupRequest, { headers: headers });
    }
    /**
    * Complete setup for two-factor authentication
    * @param twoFactorSetupRequest all options for two-factor
    * @returns two factor response
    */
    completeTwoFactorSetup(twoFactorSetupRequest) {
        let url = `${this.securityApi}/self-service/twofactor/complete`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, twoFactorSetupRequest, { headers: headers });
    }
    /**
    * Disables two-factor authentication
    * @param twoFactorSetupRequest all options for two-factor
    * @returns two factor response
    */
    disableTwoFactorAuthentication(twoFactorCode) {
        let url = `${this.securityApi}/self-service/twofactor/disable?twoFactorCode=${twoFactorCode}`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, null, { headers: headers });
    }
    /**
     * Send an e-mail verification code
     * @returns
     */
    sendEmailVerificationCode() {
        let url = `${this.securityApi}/self-service/e-mail-verification/send`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, null, { headers: headers });
    }
    /**
     * Completes e-mail verification
     * @param verificationCode code e-mailed to user
     * @returns
     */
    completEmailVerification(verificationCode) {
        let url = `${this.securityApi}/self-service/e-mail-verification/complete`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, verificationCode, { headers: headers });
    }
}
DwSecurityTwoFactorRepositoryService.ɵfac = function DwSecurityTwoFactorRepositoryService_Factory(t) { return new (t || DwSecurityTwoFactorRepositoryService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwAppInitService)); };
DwSecurityTwoFactorRepositoryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSecurityTwoFactorRepositoryService, factory: DwSecurityTwoFactorRepositoryService.ɵfac });
DwSecurityTwoFactorRepositoryService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwAppInitService }
];

class DwSecurityRegistrationRepositoryService {
    constructor(http, configService, appInitService) {
        this.http = http;
        this.configService = configService;
        this.appInitService = appInitService;
        this.suppressErrorMessages = false;
        this.securityApi = `${configService.coreConfig.apiRoot}/security`;
    }
    /**
     * Registers a new user
     * @param userRegistration
     * @returns
     */
    registerUser(userRegistration) {
        let url = `${this.securityApi}/self-service/register`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, userRegistration, { headers: headers, observe: 'response' })
            .pipe(map(response => {
            return response.body;
        }));
    }
    /**
     * Send an e-mail verification code
     * @returns
     */
    sendEmailVerificationCode() {
        let url = `${this.securityApi}/self-service/e-mail-verification/send`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, null, { headers: headers });
    }
    /**
     * Completes e-mail verification
     * @param verificationCode code e-mailed to user
     * @returns
     */
    completEmailVerification(verificationCode) {
        let url = `${this.securityApi}/self-service/e-mail-verification/complete`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        return this.http.post(url, verificationCode, { headers: headers });
    }
}
DwSecurityRegistrationRepositoryService.ɵfac = function DwSecurityRegistrationRepositoryService_Factory(t) { return new (t || DwSecurityRegistrationRepositoryService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwAppInitService)); };
DwSecurityRegistrationRepositoryService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSecurityRegistrationRepositoryService, factory: DwSecurityRegistrationRepositoryService.ɵfac });
DwSecurityRegistrationRepositoryService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwAppInitService }
];

function DwAppStartup(injector) {
    const appInitService = injector.get(DwAppInitService);
    if (appInitService) {
        const promise = new Promise((resolve) => {
            appInitService.startupApp()
                .subscribe(result => {
                resolve(null);
            }, error => {
                resolve(null);
            });
        });
        return promise;
    }
    else {
        console.warn('Could not run app Startup');
    }
}

class DevwareCoreModule {
}
DevwareCoreModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareCoreModule });
DevwareCoreModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareCoreModule_Factory(t) { return new (t || DevwareCoreModule)(); }, providers: [
        DwStorageUtil,
        DwCacheService,
        DwServerCacheService,
        DwCoreConfigProvider,
        DwSecurityStateService,
        DwSecurityTwoFactorRepositoryService,
        DwSecurityRegistrationRepositoryService,
        DwLoggingService,
        /*   {
              provide: ErrorHandler,
              useClass: DwGlobalErrorHandler
            }, */
        {
            // Define provider here as well so they can just reference the module directly if they don't have an configProviders
            provide: DwConfigServiceToken,
            useClass: DwConfigService
        },
        {
            provide: DwRoutingServiceToken,
            useClass: DwRoutingService
            /*   useFactory(securityService: DwSecurityUserService, configService: DwConfigService, router: Router, route: ActivatedRoute, analytics : DwGoogleAnalyticsService) {
                  return new DwRoutingService(configService, securityService, router, route, analytics);
              },
              deps: [DwSecurityUserService, DwConfigServiceToken,  Router, ActivatedRoute, DwGoogleAnalyticsService] */
        },
        {
            provide: DwSecurityRepositoryServiceToken,
            useClass: DwSecurityRepositoryService
        },
        DwAuthGuardService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DwSecurityInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: DwMessagingInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory(injector) {
                return () => {
                    try {
                        var promise = DwAppStartup(injector);
                        return promise;
                    }
                    catch (e) {
                        console.log('App Start - Error', e);
                    }
                };
            },
            deps: [Injector],
            multi: true
        }
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            RouterModule,
        ]] });

class DwGridConfig {
    constructor() {
        this.enableFiltering = false;
        this.enableSorting = true;
        this.showFilter = false;
        this.useSideFilters = false;
        this.showFilterOnLoad = false;
        this.showFooter = false;
        this.loadTotalRowCount = false;
        this.showActions = false;
        this.autoFilter = true;
        this.autoFilterDelay = 200;
        this.showClearFilter = false;
        this.enableColResize = true;
        this.showDelete = false;
        this.hideAdd = false;
        this.hideRefresh = false;
        this.hideExport = false;
        //rowHeight: number;
        this.columnDefs = [];
        this.actionPreferences = {};
    }
}

// This directive is used to dynamically load the grid implementation component with in the dwGridComponent
class DwGridHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
DwGridHostDirective.ɵfac = function DwGridHostDirective_Factory(t) { return new (t || DwGridHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DwGridHostDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwGridHostDirective, selectors: [["", "dw-grid-host", ""]] });
DwGridHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];

class DwGridEvent {
}

class DwGridConfigComponent {
    constructor(fb) {
        this.fb = fb;
        this.gridPreferencesChange = new EventEmitter();
        this.apply = new EventEmitter();
        this.configForm = this.fb.group({
            showFilter: [null],
            hidePrimaryKey: [null],
            showDisplayProperties: [null],
            ignoreAttributes: [null],
        });
    }
    get gridPreferences() {
        return this.gridPreferencesValue;
    }
    set gridPreferences(value) {
        this.gridPreferencesValue = value;
        this.gridPreferencesChange.emit(this.gridPreferencesValue);
        this.apply.emit(this.gridPreferencesValue);
    }
    onSubmit() {
        //console.log(this.configForm.value);
    }
    ngOnInit() {
        //this.configForm.setValue(this.gridPreferences);
        this.configForm.valueChanges.subscribe(() => {
            // This will contain the form values, but might not include everything in the preferences that is needed,
            //    therefore we will copy these over to the original object
            var formValue = this.configForm.value;
            var newPrefs = defaults(formValue, this.gridPreferences);
            this.gridPreferences = newPrefs;
        });
    }
    ngOnChanges(changes) {
        if (changes.gridPreferences) {
            this.configForm.setValue(this.gridPreferences);
        }
    }
}
DwGridConfigComponent.ɵfac = function DwGridConfigComponent_Factory(t) { return new (t || DwGridConfigComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DwGridConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridConfigComponent, selectors: [["dw-grid-config"]], inputs: { gridPreferences: "gridPreferences" }, outputs: { gridPreferencesChange: "gridPreferencesChange", apply: "apply" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 33, vars: 1, consts: [[3, "formGroup", "ngSubmit"], ["dwRow", ""], ["dwCol", "9"], ["formControlName", "showFilter"], ["dwCol", "3"], ["formControlName", "showFilterOnLoad"], ["formControlName", "hidePrimaryKey"], ["dwCol", "6"], ["formControlName", "showDisplayProperties"], ["dwCol", "12"], ["type", "text", "formControlName", "ignoreAttributes"]], template: function DwGridConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h2");
        ɵngcc0.ɵɵtext(2, "Grid Preferences");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function DwGridConfigComponent_Template_form_ngSubmit_3_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "label");
        ɵngcc0.ɵɵtext(7, "Show Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelement(9, "p-inputSwitch", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 1);
        ɵngcc0.ɵɵelementStart(11, "div", 2);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Show Filter On Load");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 4);
        ɵngcc0.ɵɵelement(15, "p-inputSwitch", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 1);
        ɵngcc0.ɵɵelementStart(17, "div", 2);
        ɵngcc0.ɵɵelementStart(18, "label");
        ɵngcc0.ɵɵtext(19, "Hide Key");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 4);
        ɵngcc0.ɵɵelement(21, "p-inputSwitch", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 1);
        ɵngcc0.ɵɵelementStart(23, "div", 2);
        ɵngcc0.ɵɵelementStart(24, "label");
        ɵngcc0.ɵɵtext(25, "Show Display value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 7);
        ɵngcc0.ɵɵelement(27, "p-inputSwitch", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 1);
        ɵngcc0.ɵɵelementStart(29, "div", 9);
        ɵngcc0.ɵɵelementStart(30, "label");
        ɵngcc0.ɵɵtext(31, "Ignore Fields");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(32, "input", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formGroup", ctx.configForm);
    } }, directives: function () { return [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor]; }, encapsulation: 2 });
DwGridConfigComponent.ctorParameters = () => [
    { type: FormBuilder }
];
DwGridConfigComponent.propDecorators = {
    gridPreferencesChange: [{ type: Output }],
    apply: [{ type: Output }],
    gridPreferences: [{ type: Input }]
};

var DwGridEventType;
(function (DwGridEventType) {
    DwGridEventType["rowActionButton"] = "rowActionButton";
    DwGridEventType["gridActionButton"] = "gridActionButton";
    DwGridEventType["rowContextMenu"] = "rowContextMenu";
    DwGridEventType["gridStateChanges"] = "gridStateChanges";
    DwGridEventType["editModeChange"] = "editModeChange";
    DwGridEventType["gridDataLoad"] = "gridDataLoad";
    DwGridEventType["refresh"] = "refresh";
    DwGridEventType["rowSelectionChange"] = "rowSelectionChange";
    DwGridEventType["gridCellClick"] = "gridCellClick";
    DwGridEventType["gridRowClick"] = "gridRowClick";
    DwGridEventType["gridRowDoubleClick"] = "gridRowDoubleClick";
})(DwGridEventType || (DwGridEventType = {}));

class DwGridComponent {
    constructor(uiConfig, componentFactoryResolver, uiConfigService, dwEventService, dwUiConfigRegistryService) {
        this.uiConfig = uiConfig;
        this.componentFactoryResolver = componentFactoryResolver;
        this.uiConfigService = uiConfigService;
        this.dwEventService = dwEventService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.triggerContextMenu = new EventEmitter();
        this.onGridActionEvent = new EventEmitter();
        this.filtersApplied = new EventEmitter();
        this.filtersCleared = new EventEmitter();
        this.configKey = "";
        this.usePrefs = false;
        this._filterSetupComplete = false;
        this.gridReady = new EventEmitter();
        this.gridEvent = new EventEmitter();
        this.bindableDataSubject = new Subject();
        this.bindableData = this.bindableDataSubject.asObservable();
        this.subscriptions = [];
        this.autoFilterSubject = new Subject();
    }
    get gridConfig() {
        return this._gridConfig;
    }
    set gridConfig(value) {
        // console.log('Dw Grid - grid config set directly - update grid config');
        this.updateGridConfig(value, this.dataSource, this.filters);
    }
    get filters() {
        return this._filters;
    }
    set filters(value) {
        this._filters = value;
        this.autoFilterSubject.next(value);
    }
    get filterSetupComplete() {
        return this._filterSetupComplete;
    }
    set filterSetupComplete(value) {
        this._filterSetupComplete = value;
        if (value && this.gridInstance) {
            // console.log('dw-grid - Filter Setup Complete', this.filters);
            this.gridInstance.filters = this.filters;
            this.gridInstance.filterSetupComplete = value;
        }
    }
    ngOnInit() {
        //this.setupDynamicConfig();
        this.subscriptions.push(this.dwEventService.getEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.PreferencesUpdateEvent(this.configKey, DwUiConfigType.grid))
            .subscribe((event) => {
            this.applyPreferences(event.data);
        }));
        this.autoFilterSubject.asObservable()
            .pipe(debounceTime(this.gridConfig.autoFilterDelay))
            .subscribe(filters => {
            if (this.gridConfig && this.gridConfig.autoFilter)
                this.applyFilters(filters);
            this.filtersApplied.emit(filters);
        });
    }
    updateGridConfig(gridConfig, dataSource, filters) {
        let loadPreferences = false;
        if (this._gridConfig && this._gridConfig.configKey != gridConfig.configKey) {
            loadPreferences = true;
        }
        this._gridConfig = gridConfig;
        this.dataSource = dataSource;
        if (this.gridConfig) {
            if (this.gridConfig.showFilter) {
                this.showFilterSection = this.gridConfig.showFilterOnLoad;
            }
            else {
                this.showFilterSection = false;
            }
            this.setupStyling();
        }
        if (this.gridInstance) {
            this.gridInstance.updateGridConfig(gridConfig, this.dataSource, filters);
        }
        // Reload preferences
        if (loadPreferences) {
            this.loadPreferences();
        }
    }
    // Apply preferences
    applyPreferences(preferences) {
        this.applyColumnState(preferences.columnPreferences);
        if (preferences.showFilter) {
            this.showFilterSection = preferences.showFilterOnLoad;
        }
        else {
            this.showFilterSection = false;
        }
        this.setupStyling();
    }
    setupStyling() {
        if (!this.gridConfig) {
            return;
        }
        let styleName = '';
        if (this.gridConfig.gridStyle && this.gridConfig.gridStyle.gridStyleName) {
            styleName = this.gridConfig.gridStyle.gridStyleName;
        }
        this.styles = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.gridStyles, styleName);
    }
    registerPanelWidget() {
        if (this.usePrefs) {
            if (this.configKey == "") {
                console.warn("Can't use grid preferences if the property name isn't populated.  This is used as a preferences key");
                return;
            }
            // Register Configuration Component
            let uiConfigComponent = new DwUiPanelWidgetConfig();
            uiConfigComponent.configKey = this.configKey;
            uiConfigComponent.widgetComponent = DwGridConfigComponent;
            uiConfigComponent.uiConfigTypeId = DwUiConfigType.grid;
            this.uiConfigService.registerUiPanelWidget(uiConfigComponent);
            this.loadPreferences();
        }
    }
    loadPreferences() {
        if (this.configKey == "") {
            return;
        }
        this.subscriptions.push(this.uiConfigService.getPreferencesHierarchy(this.configKey, DwUiConfigType.grid)
            .subscribe((prefs) => {
            if (prefs) {
                this.applyPreferences(prefs.loadedPreferences);
            }
        }));
    }
    ngAfterContentInit() {
        this.registerPanelWidget();
        this.loadComponent();
    }
    ngOnDestroy() {
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        // Remove Configuration component
        if (this.usePrefs && this.configKey)
            this.uiConfigService.removeUiPanelWidget(this.configKey, DwUiConfigType.grid);
    }
    loadComponent() {
        if (!this.dwGridHost || !this.dwGridHost.viewContainerRef)
            return;
        if (!this.uiConfig.gridComponent) {
            throw new Error("ui Config does not define a grid component!");
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.uiConfig.gridComponent);
        let viewContainerRef = this.dwGridHost.viewContainerRef;
        viewContainerRef.clear();
        let componentRef = viewContainerRef.createComponent(componentFactory);
        this.gridInstance = componentRef.instance;
        this.gridInstance.gridConfig = this.gridConfig;
        this.gridInstance.data = this.data;
        this.gridInstance.filters = deepCopy(this.filters);
        this.gridInstance.filterSetupComplete = this.filterSetupComplete;
        this.gridInstance.resolvedContext = this.resolvedContext;
        this.gridInstance.configContext = this.configContext;
        const gridImplementation = this.gridInstance;
        if (gridImplementation.setupComplete) {
            gridImplementation.setupComplete();
        }
        // Subscribe
        this.subscriptions.push(this.gridInstance.events.subscribe((gridEvent) => {
            this.gridEvent.emit(gridEvent);
        }));
        // Emit an event to give the parent access to the grid instance
        this.gridReady.emit(this.gridInstance);
    }
    // addButtonClick() {
    //     this.onGridActionButton(DwGridEventCommands.add);
    // }
    // exportButtonClick() {
    //     this.onGridActionButton(DwGridEventCommands.export);
    // }
    // refreshButtonClick() {
    //     this.gridInstance.refreshDataSource(true);
    // }
    // toggleFilterButtonClick() {
    //     this.showFilterSection = !this.showFilterSection;
    // }
    toggleFilters() {
        this.showFilterSection = !this.showFilterSection;
    }
    // actionButtonClick(actionButton : DwButtonConfig) {
    // 	this.onGridActionButton(actionButton.command);
    // }
    actionPrefClicked(actionEvent) {
        const actionPref = actionEvent.actionPreference;
        let command = actionPref.actionKey;
        if (actionPref.actionConfig && actionPref.buttonConfig && actionPref.buttonConfig.command) {
            command = actionPref.buttonConfig.command;
        }
        this.onGridActionButton(command, actionPref, actionEvent.dwBrowserEvent);
    }
    onGridActionButton(eventCommand, actionPref, dwBrowserEvent) {
        let gridEvent = new DwGridEvent();
        gridEvent.eventType = DwGridEventType.gridActionButton;
        gridEvent.eventCommand = eventCommand;
        gridEvent.actionPreference = actionPref;
        gridEvent.dwBrowserEvent = dwBrowserEvent;
        this.gridEvent.emit(gridEvent);
    }
    applyFilters(filters) {
        if (this.gridInstance) {
            //console.log("DwGrid.applyFilters - filters", filters, this.gridInstance.filters);
            this.gridInstance.applyFilters(filters);
        }
    }
    clearFilters() {
        this.filtersCleared.emit();
    }
    applyColumnState(columnStates) {
        if (!this.gridInstance == null || !this.gridConfig || !columnStates)
            return;
        var newGridConfig = Object.assign({}, this.gridConfig);
        newGridConfig.columnDefs = [];
        for (let columnState of columnStates) {
            var foundColumn = findWhere(this.gridConfig.columnDefs, { field: columnState.field });
            if (!foundColumn) {
                // try finding column by key (should be set on custom columns and always be unique)
                foundColumn = findWhere(this.gridConfig.columnDefs, { key: columnState.field });
            }
            if (foundColumn) {
                var newColumn = Object.assign({}, foundColumn);
                newColumn.hide = columnState.hide;
                newColumn.pinned = columnState.pinned;
                newColumn.width = columnState.width;
                newColumn.sort = columnState.sort;
                newColumn.sortOrder = columnState.sortOrder;
                newGridConfig.columnDefs.push(newColumn);
            }
        }
        this.gridInstance.updateGridConfig(newGridConfig, this.dataSource, this.filters);
    }
    setGridData(data) {
        if (this.gridInstance) {
            // this.gridInstance.data = data;
            this.gridInstance.setData(data);
            this.gridInstance.refreshDataSource(false);
        }
    }
    ngOnChanges(changes) {
        if (!this.gridInstance)
            return;
        // propogate changes to the grid instance
        if (changes.gridConfig && changes.gridConfig.currentValue) {
            this.gridInstance.updateGridConfig(changes.gridConfig.currentValue, this.gridConfig, this.filters);
            if (this.gridConfig.showFilter) {
                this.showFilterSection = this.gridConfig.showFilterOnLoad;
            }
            else {
                this.showFilterSection = false;
            }
            // Reload preferences
            this.loadPreferences();
        }
        if (changes.data && changes.data.currentValue) {
            this.setGridData(changes.data.currentValue);
        }
    }
    configUpdated() {
    }
}
DwGridComponent.ɵfac = function DwGridComponent_Factory(t) { return new (t || DwGridComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwGridComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridComponent, selectors: [["dw-grid"]], viewQuery: function DwGridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwGridHostDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwGridHost = _t.first);
    } }, inputs: { configKey: "configKey", usePrefs: "usePrefs", gridConfig: "gridConfig", filters: "filters", filterSetupComplete: "filterSetupComplete", gridContextMenu: "gridContextMenu", configContext: "configContext", resolvedContext: "resolvedContext", data: "data" }, outputs: { triggerContextMenu: "triggerContextMenu", onGridActionEvent: "onGridActionEvent", filtersApplied: "filtersApplied", filtersCleared: "filtersCleared", gridReady: "gridReady", gridEvent: "gridEvent" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c14, decls: 15, vars: 12, consts: [[3, "ngClass"], ["class", "dw-grid-filter2", 3, "hidden", 4, "ngIf"], [4, "ngIf"], [3, "contextmenu"], ["gridContainer", ""], [1, "dw-grid-split-container", 3, "ngClass"], [1, "dw-grid-split-left"], ["dw-grid-host", ""], ["class", "dw-grid-split-right", 4, "ngIf"], [1, "dw-grid-filter2", 3, "hidden"], [3, "onsubmit"], [1, "row2"], [1, "pull-right"], ["type", "submit", "class", "btn btn-success", 3, "click", 4, "ngIf"], ["type", "button", "class", "btn btn-warning ml-2", "title", "Clear all set filters", 3, "click", 4, "ngIf"], ["type", "submit", 1, "btn", "btn-success", 3, "click"], ["type", "button", "title", "Clear all set filters", 1, "btn", "btn-warning", "ml-2", 3, "click"], [1, "dw-grid-buttons-left"], ["useContainerStyle", "false", 3, "actionPreferences", "actionContext", "actionClick"], [1, "dw-grid-buttons-right"], [1, "dw-grid-split-right"], [1, "dw-grid-split-right-inner"]], template: function DwGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c12);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵtemplate(3, DwGridComponent_div_3_Template, 10, 5, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 0);
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵtemplate(6, DwGridComponent_ng_container_6_Template, 7, 4, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(7, DwGridComponent_ng_container_7_Template, 5, 4, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 3, 4);
        ɵngcc0.ɵɵlistener("contextmenu", function DwGridComponent_Template_div_contextmenu_8_listener($event) { return ctx.triggerContextMenu.emit($event); });
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵtemplate(12, DwGridComponent_ng_template_12_Template, 0, 0, "ng-template", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, DwGridComponent_div_13_Template, 3, 0, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DwGridComponent_ng_content_14_Template, 1, 0, "ng-content", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.gridConfig == null ? null : ctx.gridConfig.gridStyle == null ? null : ctx.gridConfig.gridStyle.gridClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styles == null ? null : ctx.styles.containerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.gridConfig.showFilter && !ctx.gridConfig.useSideFilters);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styles == null ? null : ctx.styles.actionBarContainerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styles == null ? null : ctx.styles.actionBarClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.resolvedContext == null ? null : ctx.resolvedContext.mdGridContext == null ? null : ctx.resolvedContext.mdGridContext.inEditMode));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.resolvedContext == null ? null : ctx.resolvedContext.mdGridContext == null ? null : ctx.resolvedContext.mdGridContext.inEditMode);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c13, !ctx.showFilterSection || !ctx.gridConfig.useSideFilters));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.gridConfig == null ? null : ctx.gridConfig.showFilter) && (ctx.gridConfig == null ? null : ctx.gridConfig.useSideFilters));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.gridConfig.showFooter);
    } }, directives: function () { return [ɵngcc4.NgClass, ɵngcc4.NgIf, DwGridHostDirective, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm, DwActionBarComponent]; }, styles: [""] });
DwGridComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: ComponentFactoryResolver },
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwUiConfigRegistryService }
];
DwGridComponent.propDecorators = {
    gridConfig: [{ type: Input }],
    gridContextMenu: [{ type: Input }],
    configContext: [{ type: Input }],
    resolvedContext: [{ type: Input }],
    triggerContextMenu: [{ type: Output }],
    onGridActionEvent: [{ type: Output }],
    filtersApplied: [{ type: Output }],
    filtersCleared: [{ type: Output }],
    data: [{ type: Input }],
    filters: [{ type: Input }],
    configKey: [{ type: Input }],
    usePrefs: [{ type: Input }],
    filterSetupComplete: [{ type: Input }],
    gridReady: [{ type: Output }],
    gridEvent: [{ type: Output }],
    dwGridHost: [{ type: ViewChild, args: [DwGridHostDirective, { static: true },] }]
};

class DwLoginComponent {
    constructor(securityOrchestrationService, dwSecurityRepositoryService, dwUIConfig, router, cdr) {
        this.securityOrchestrationService = securityOrchestrationService;
        this.dwSecurityRepositoryService = dwSecurityRepositoryService;
        this.dwUIConfig = dwUIConfig;
        this.router = router;
        this.cdr = cdr;
        this.userName = '';
        this.password = '';
        this.showTwoFactor = false;
        this.showResendCode = false;
        this.showForcePasswordChange = false;
        this.headerTextChange = new EventEmitter();
        this.showRegister = false;
        this.showReset = false;
        this.subscriptions = [];
        this.processing = false;
        this.focusSetCount = 0;
        this.checkCount = 0;
        this.hasUserNameAutoFillValue = false;
        this.hasPasswordAutoFillValue = false;
        this.hasUserNameFocus = false;
        this.hasPasswordFocus = false;
    }
    ngOnInit() {
        const resetCode = getParameterByName(this.router, 'resetCode');
        if (resetCode) {
            this.showReset = true;
        }
    }
    focusUserName(source) {
        if (this.hasUserNameFocus) {
            return;
        }
        this.hasUserNameFocus = true;
        this.focusSetCount++;
        if (this.focusSetCount > 1) {
            return;
        }
        setTimeout(() => {
            var _a, _b;
            //console.log('Setting user name focus', source);
            (_b = (_a = this.userNameInput) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus();
        }, 50);
    }
    blurUserName() {
        this.hasUserNameFocus = false;
        //console.log('Clearing user name focus');
    }
    focusPassword(source) {
        if (this.hasPasswordFocus) {
            return;
        }
        this.hasPasswordFocus = true;
        this.focusSetCount++;
        if (this.focusSetCount > 1) {
            return;
        }
        setTimeout(() => {
            var _a, _b;
            // console.log('Setting password focus', source);
            (_b = (_a = this.passwordInput) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus();
        }, 50);
    }
    blurPassword() {
        this.hasPasswordFocus = false;
        //console.log('Clearing password focus');
    }
    ngAfterViewInit() {
        this.setupAutofillHack();
    }
    ngOnDestroy() {
        for (let sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }
    setupAutofillHack() {
        this.checkForAutofill();
    }
    /**
     * Chrome password autofill hack
     * @remarks This is a hack to detect when Chrome autofills the password field since the value isn't populated until human interaction with the page.  With float labels, this causes the label to overlap the text which looks bad
     * @returns
     */
    checkForAutofill() {
        if (!this.dwUIConfig.registrationConfig.useFloatLabelOnLogin) {
            // No need to check since this only applies to float label 
            return;
        }
        this.intervalHandle = setInterval(() => {
            this.checkCount++;
            if (this.checkCount > 20 || this.hasUserNameAutoFillValue || this.hasPasswordAutoFillValue) {
                clearInterval(this.intervalHandle);
                return;
            }
            this.hasAutofillClass('tbUserName', (found) => {
                this.hasUserNameAutoFillValue = found;
            });
            this.hasAutofillClass('tbPassword', (found) => {
                this.hasPasswordAutoFillValue = found;
            });
        }, 50);
    }
    hasAutofillClass(inputName, func) {
        const input = document.getElementById(inputName);
        if (!input) {
            return;
        }
        if (input.matches(':autofill')) {
            func(true);
        }
    }
    userNameChange() {
        if (this.userName) {
            this.hasUserNameAutoFillValue = false;
        }
    }
    passwordChange() {
        if (this.password) {
            this.hasPasswordAutoFillValue = false;
        }
    }
    setIsProcessing(processing) {
        this.processing = processing;
    }
    login() {
        if (!this.validateForm()) {
            return;
        }
        if (this.processing) {
            return;
        }
        this.message = null;
        this.processing = true;
        this.securityOrchestrationService.authenticate(this.userName, this.password, this.twoFactorCode, true)
            .subscribe((result) => {
            // This is actually handled by the layout since the login is hidden during authentication
            if (!result.success) {
                if (result.PromptForTwoFactorCode) {
                    this.setupTwoFactor(result);
                    setTimeout(() => {
                        this.processing = false;
                    }, 500);
                    return;
                }
                if (result.ForcePasswordChange) {
                    this.setupForcePasswordChange(result);
                }
                if (typeof result.message == 'string')
                    this.message = {
                        messageBody: result.message,
                        severity: DwMessageSeverity.error
                    };
            }
            setTimeout(() => {
                this.processing = false;
            }, 500);
        }, (error) => {
            this.processing = false;
            //console.log("Log Error", error);
            this.message = {
                messageBody: 'Error logging in.  Please try again later',
                severity: DwMessageSeverity.error
            };
        });
    }
    setupForcePasswordChange(result) {
        this.showForcePasswordChange = true;
        this.changePasswordMessage = result.message;
        this.showTwoFactor = false;
    }
    setupTwoFactor(result) {
        this.showTwoFactor = true;
        if (this.codeResent) {
            this.message = {
                messageBody: 'Security code has been sent!',
                severity: DwMessageSeverity.success
            };
        }
        switch (result.TwoFactorAuthenticationType) {
            case SecurityFactorTypes.authenticatorApp:
                this.twoFactorMessage = "Enter code from Authenticator App";
                this.showResendCode = false;
                break;
            case SecurityFactorTypes.email:
                this.twoFactorMessage = "Enter code sent to your e-mail";
                this.showResendCode = true;
                break;
            case SecurityFactorTypes.text:
                this.twoFactorMessage = "Enter code sent to your phone";
                this.showResendCode = true;
                break;
        }
    }
    resendCode() {
        this.twoFactorCode = null;
        this.codeResent = true;
        this.login();
    }
    changePassword() {
        if (!this.validateForm()) {
            return;
        }
        this.processing = true;
        this.message = null;
        this.dwSecurityRepositoryService.changeUserPassword(this.userName, this.password, this.newPassword, this.twoFactorCode)
            .subscribe(result => {
            this.processing = false;
            this.message = {
                messageBody: 'Your password has been changed',
                severity: DwMessageSeverity.success
            };
            this.password = this.newPassword;
            this.showForcePasswordChange = false;
            this.newPassword = null;
            this.newPasswordRetype = null;
            this.login();
        }, error => {
            this.processing = false;
            var errorDetail = getErrorDetails(error);
            this.message = {
                messageBody: errorDetail.message,
                severity: DwMessageSeverity.error
            };
        });
    }
    forgotPassword() {
        this.clearMessage();
        this.showReset = true;
    }
    register() {
        this.clearMessage();
        this.securityOrchestrationService.gotoUserRegistration();
    }
    resetCancelled() {
        this.clearMessage();
        this.showReset = false;
    }
    resetComplete() {
        this.showReset = false;
        this.message = {
            messageBody: `Password succesfully reset`,
            severity: DwMessageSeverity.success
        };
    }
    setMessage(messageBody, severity = DwMessageSeverity.info) {
        this.message = {
            messageBody: messageBody,
            severity: severity
        };
    }
    clearMessage() {
        this.message = null;
    }
    validateForm() {
        const errors = [];
        if (!this.userName) {
            errors.push('Please enter a username');
        }
        if (!this.password) {
            errors.push('Password is required');
        }
        if (this.showForcePasswordChange) {
            if (!this.newPassword) {
                errors.push('Password is required');
            }
            if (this.newPassword != this.newPasswordRetype) {
                errors.push('Passwords do not match');
            }
            if (this.newPassword == this.password) {
                errors.push('Password must be different than current password');
            }
        }
        if (errors.length > 0) {
            this.setMessage(errors.join(", "), DwMessageSeverity.error);
            return false;
        }
        this.message = null;
        return true;
    }
}
DwLoginComponent.ɵfac = function DwLoginComponent_Factory(t) { return new (t || DwLoginComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService), ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwLoginComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLoginComponent, selectors: [["dw-login"]], viewQuery: function DwLoginComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c15, true);
        ɵngcc0.ɵɵviewQuery(_c16, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.userNameInput = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.passwordInput = _t.first);
    } }, inputs: { showRegister: "showRegister", customLoginTemplate: "customLoginTemplate" }, outputs: { headerTextChange: "headerTextChange" }, ngContentSelectors: _c18, decls: 8, vars: 2, consts: [[1, "login"], [1, "card"], [4, "ngIf"], ["basicLogin", ""], [4, "ngTemplateOutlet"], [3, "userName", "message", "userNameChange", "cancelled", "messageChange", "complete"], [1, "card-header"], [1, "card-body"], [3, "message"], [1, "body-left"], [1, "body-left-content"], [1, "dw-logo-login"], [1, "body-right"], [1, "body-right-content"], [3, "ngSubmit"], [1, "row"], [1, "login-image"], [1, "fa", "fa-user-circle", "login-icon"], [1, "login-input"], [3, "label", "inputClass", "containerClass", "name", "ngModel", "inputAutocomplete", "useFloat", "ngModelChange"], [1, "fa", "fa-user-lock", "login-icon"], [3, "type", "label", "inputClass", "containerClass", "name", "ngModel", "inputAutocomplete", "useFloat", "ngModelChange"], [1, "input-additional-message"], [3, "click"], [1, "col-md-12", "dw-button-bar-full"], ["type", "submit", 1, "btn", "btn-success", "btn-login", 3, "disabled", "click"], ["class", "fa fa-spinner fa-pulse fa-fw", 4, "ngIf"], [3, "isProcessing"], ["type", "button", "class", "btn btn-primary", 3, "click", 4, "ngIf"], [3, "click", 4, "ngIf"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [1, "login-not-registered-text"], [1, "login-signup-text"], ["class", "row", 4, "ngIf"], ["src", "/assets/img/user-password.png"], [1, "label"], ["type", "text", "id", "tbTwoFactorCode", "name", "tbTwoFactorCode", "placeholder", "two factor code", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "col-md-12"], ["type", "submit", 1, "form-control", "btn", "btn-success", 3, "disabled", "click"], ["class", "input-additional-message", 4, "ngIf"], ["type", "text", "name", "fakeusernameremembered", 2, "display", "none"], ["type", "password", "id", "tbPasswordNew", "name", "tbPasswordNew", "placeholder", "new password", "autocomplete", "chrome-off", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "password", "id", "tbPasswordNew2", "name", "tbPasswordNew2", "placeholder", "retype new password", "autocomplete", "chrome-off", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c17);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DwLoginComponent_ng_container_3_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(4, DwLoginComponent_ng_container_4_Template, 2, 2, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwLoginComponent_ng_template_6_Template, 13, 4, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showReset);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showReset);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgTemplateOutlet, DwUserPasswordResetComponent, DwMessageComponent, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm, DwFloatingLabelInputComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwLoginSsoOptionsComponent, DwMissingImageDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.RequiredValidator]; }, styles: [""] });
DwLoginComponent.ctorParameters = () => [
    { type: DwSecurityOrchestrationService },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: Router },
    { type: ChangeDetectorRef }
];
DwLoginComponent.propDecorators = {
    headerTextChange: [{ type: Output }],
    customLoginTemplate: [{ type: Input }],
    showRegister: [{ type: Input }],
    userNameInput: [{ type: ViewChild, args: ['userNameInput',] }],
    passwordInput: [{ type: ViewChild, args: ['passwordInput',] }]
};

class DwLoginPageComponent {
}
DwLoginPageComponent.ɵfac = function DwLoginPageComponent_Factory(t) { return new (t || DwLoginPageComponent)(); };
DwLoginPageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLoginPageComponent, selectors: [["dw-login-page"]], decls: 4, vars: 0, consts: [["dwRow", ""], ["dwCol", "5"]], template: function DwLoginPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelement(3, "dw-login");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DwRowDirective, DwColDirective, DwLoginComponent]; }, encapsulation: 2 });

/**
 * Abstract base class to handle the details of implementing ControlValueAccessor and building form controls that are
 * compatible with Tempalte (ngModel) and Reactive forms
 */
class DwControlBaseComponent {
    constructor() {
        this.disabled = false;
        this._onChange = (_) => { };
        this._onTouched = () => { };
        this.subscriptions = [];
        this.destroyed = false;
        this.ignoreDuplicateSetValues = false;
    }
    /**
     * Handle values writen from the bound ngModel
     * @param obj
     */
    writeValue(obj) {
        this.value = obj;
        this.initialValue = this.value;
        this.translatedValue = this.translateTo(obj);
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    /**
     * Set the value to update ngModel
     * @param value
     */
    setValue(value) {
        if (this.value == value && this.ignoreDuplicateSetValues) {
            return;
        }
        this.value = value;
        this.onChange();
    }
    /**
     * Set the translated value which will be converted then call setValue
     * @param value
     */
    setTranslatedValue(translatedValue) {
        this.translatedValue = translatedValue;
        this.setValue(this.translateFrom(translatedValue));
    }
    /**
    * Handle any conversions TO the translated value from the ngModel value
    * @param value
    */
    translateTo(value) {
        return value;
    }
    /**
     * Handle any conversions FROM the translated value to the value back to ngModel
     * @param value
     */
    translateFrom(value) {
        return value;
    }
    /**
     * Handles a change event
     */
    onChange() {
        if (this._onChange)
            this._onChange(this.value);
    }
    /**
    * Handles an onTouch event from touch screens
    */
    onTouch() {
        if (this._onTouched)
            this._onTouched();
    }
    /**
     * Sets the control as disables
     * @param disabled
     */
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
    /**
     * Handle any cleanup plus set the destroyed value just in case we have a final event fire before it is destroyed
     */
    ngOnDestroy() {
        this.destroyed = true;
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwControlBaseComponent.ɵfac = function DwControlBaseComponent_Factory(t) { return new (t || DwControlBaseComponent)(); };
DwControlBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwControlBaseComponent, inputs: { id: "id", formControlName: "formControlName" } });
DwControlBaseComponent.propDecorators = {
    id: [{ type: Input }],
    formControlName: [{ type: Input }]
};

var __decorate$8 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$7 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwInputComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.type = 'text';
        this.blur = new EventEmitter();
        // (blur)="onBlur($event)
        this.autoCompleteText = 'new-password'; // Found that this turns off autocomplete in most cases
    }
    ngOnInit() {
        this.finalDecimals = this.getDecimals();
        this.finalAllowNegative = this.getAllowNegative();
        this.autoCompleteText = this.getAutocompleteText();
    }
    onBlur(event) {
        this.blur.emit(event);
    }
    getDecimals() {
        if (this.options && (this.options.decimalsOverride || this.options.decimalsOverride === 0)) {
            return this.options.decimalsOverride;
        }
        return this.decimals || 0;
    }
    getAllowNegative() {
        if (this.options && (this.options.allowNegative === true || this.options.allowNegative === false)) {
            return this.options.allowNegative;
        }
        return this.allowNegative === true;
    }
    getAutocompleteText() {
        if (this.options && this.options.autoCompleteEnabled) {
            return this.options.autoCompleteType || '';
        }
        return 'new-password';
    }
    translateTo(value) {
        var _a;
        if (this.numeric) {
            let float = parseFloat(value);
            if (!isNaN(float)) {
                if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.multiplier) {
                    float = float * parseFloat(this.options.multiplier.toString());
                    return float;
                }
                // Removing this since it caused the field to be re-formatted while typing
                // if (this.options?.decimalsOverride) {
                //     return float.toFixed(this.options.decimalsOverride);
                // }
            }
            // if (!isNaN(float) && float?.toFixed) {
            //     return float.toFixed(this.options.decimalsOverride);
            // }
        }
        return value;
    }
    translateFrom(value) {
        var _a, _b, _c;
        if (this.numeric && ((_a = this.options) === null || _a === void 0 ? void 0 : _a.multiplier)) {
            const float = parseFloat(value);
            if (!isNaN(float)) {
                return float / parseFloat(this.options.multiplier.toString());
            }
            if (value != float) {
                console.log('dwInputComponent: translateFrom', value, float, (_b = this.options) === null || _b === void 0 ? void 0 : _b.multiplier, (_c = this.options) === null || _c === void 0 ? void 0 : _c.decimalsOverride);
            }
        }
        return value;
    }
}
DwInputComponent.ɵfac = function DwInputComponent_Factory(t) { return ɵDwInputComponent_BaseFactory(t || DwInputComponent); };
DwInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwInputComponent, selectors: [["dw-input"]], viewQuery: function DwInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c19, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.inputElement = _t.first);
    } }, inputs: { type: "type", placeholder: "placeholder", inputClass: "inputClass", maxlength: "maxlength", numeric: "numeric", decimals: "decimals", allowNegative: "allowNegative", options: "options" }, outputs: { blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwInputComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 15, consts: [["wrapControl", "false", 3, "showPrefix", "showSuffix"], ["prefix", "", 1, "input-group-text"], ["control", "", 3, "ngClass", "ngModel", "type", "placeholder", "dwNumeric", "decimals", "maxlength", "dwBrowserAutocomplete", "autocompleteText", "allowNegative", "ngModelChange"], ["inputElement", ""], ["suffix", "", 1, "input-group-text"], ["class", "input-group mb-3", 4, "ngIf"], [1, "input-group", "mb-3"], [1, "input-group-prepend", 3, "hidden"], [1, "input-group-text"], [3, "ngClass", "ngModel", "type", "placeholder", "dwNumeric", "decimals", "maxlength", "dwBrowserAutocomplete", "autocompleteText", "allowNegative", "ngModelChange", "blur"], [1, "input-group-append", 3, "hidden"]], template: function DwInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-control-wrapper-with-icons", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "input", 2, 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwInputComponent_Template_input_ngModelChange_3_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DwInputComponent_div_7_Template, 9, 14, "div", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("showPrefix", !!(ctx.options == null ? null : ctx.options.prefix))("showSuffix", !!(ctx.options == null ? null : ctx.options.suffix));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.options == null ? null : ctx.options.prefix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.inputClass)("ngModel", ctx.translatedValue)("type", ctx.type)("placeholder", ctx.placeholder || "")("dwNumeric", ctx.numeric)("decimals", ctx.finalDecimals)("maxlength", ctx.maxlength)("dwBrowserAutocomplete", ctx.options == null ? null : ctx.options.autoCompleteEnabled)("autocompleteText", ctx.options == null ? null : ctx.options.autoCompleteType)("allowNegative", ctx.finalAllowNegative);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.options == null ? null : ctx.options.suffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: function () { return [DwControlWrapperWithIconsComponent, ɵngcc3.DefaultValueAccessor, DwNumericDirective, DwBrowserAutocomplete, ɵngcc4.NgClass, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.MaxLengthValidator, ɵngcc4.NgIf]; }, encapsulation: 2 });
DwInputComponent.propDecorators = {
    placeholder: [{ type: Input }],
    type: [{ type: Input }],
    inputClass: [{ type: Input }],
    maxlength: [{ type: Input }],
    numeric: [{ type: Input }],
    decimals: [{ type: Input }],
    allowNegative: [{ type: Input }],
    options: [{ type: Input }],
    inputElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    blur: [{ type: Output }]
};
__decorate$8([
    DwInputConverter(booleanConverter),
    __metadata$7("design:type", Boolean)
], DwInputComponent.prototype, "numeric", void 0);
__decorate$8([
    DwInputConverter(intConverter),
    __metadata$7("design:type", Number)
], DwInputComponent.prototype, "decimals", void 0);
__decorate$8([
    DwInputConverter(booleanConverter),
    __metadata$7("design:type", Boolean)
], DwInputComponent.prototype, "allowNegative", void 0);

var __decorate$9 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$8 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwYesNoComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.groupName = "YesNoGroup";
        this.allowNull = false;
        this.nullDisplay = 'Blank';
        this.showAsDropdown = false;
        this.values = [{ display: 'Yes', value: true }, { display: 'No', value: false }];
    }
    ngOnInit() {
        this.setupValues();
    }
    ngOnChanges(changes) {
        this.setupValues();
    }
    setupValues() {
        this.values = [{ display: 'Yes', value: true }, { display: 'No', value: false }];
        if (this.allowNull) {
            const nullItem = { display: this.nullDisplay == 'Blank' ? '' : this.nullDisplay, value: null };
            if (this.showAsDropdown) {
                this.values.splice(0, 0, nullItem);
            }
            else {
                this.values.push(nullItem);
            }
        }
    }
    translateTo(value) {
        return this.convertBool(value);
    }
    convertBool(value) {
        // if (_.isUndefined(value)) return undefined;
        // if (!value) {
        //     return value;
        // }
        if (value == null || value == undefined) {
            if (!this.allowNull) {
                return null;
            }
            return null;
        }
        if (value === "false" || value === false || value === "no") {
            return false;
        }
        if (value === "true" || value === true || value === "yes") {
            return true;
        }
        return false;
    }
}
DwYesNoComponent.ɵfac = function DwYesNoComponent_Factory(t) { return ɵDwYesNoComponent_BaseFactory(t || DwYesNoComponent); };
DwYesNoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwYesNoComponent, selectors: [["dw-yesno"]], inputs: { groupName: "groupName", allowNull: "allowNull", nullDisplay: "nullDisplay", showAsDropdown: "showAsDropdown" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwYesNoComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "values", "ngModel", "ngModelChange", 4, "ngIf"], ["class", "form-control", 3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "values", "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function DwYesNoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwYesNoComponent_dw_radio_list_0_Template, 1, 2, "dw-radio-list", 0);
        ɵngcc0.ɵɵtemplate(1, DwYesNoComponent_select_1_Template, 2, 2, "select", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showAsDropdown);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAsDropdown);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRadioListComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x]; }, styles: [".radio-container[_ngcontent-%COMP%]{margin:5px}.radio-item[_ngcontent-%COMP%]{margin-left:5px;margin-top:-6px}.container[_ngcontent-%COMP%]{-moz-user-select:none;-webkit-user-select:none;cursor:pointer;display:block;font-size:22px;margin-bottom:12px;padding-left:35px;position:relative;user-select:none}.container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{cursor:pointer;height:0;opacity:0;position:absolute;width:0}.checkmark[_ngcontent-%COMP%]{background-color:#eee;border-radius:50%;height:25px;left:0;position:absolute;top:0;width:25px}.container[_ngcontent-%COMP%]:hover   input[_ngcontent-%COMP%] ~ .checkmark[_ngcontent-%COMP%]{background-color:#ccc}.container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]{background-color:#2196f3}.checkmark[_ngcontent-%COMP%]:after{content:\"\";display:none;position:absolute}.container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:checked ~ .checkmark[_ngcontent-%COMP%]:after{display:block}.container[_ngcontent-%COMP%]   .checkmark[_ngcontent-%COMP%]:after{background:#fff;border-radius:50%;height:8px;left:9px;top:9px;width:8px}"] });
DwYesNoComponent.propDecorators = {
    groupName: [{ type: Input }],
    allowNull: [{ type: Input }],
    nullDisplay: [{ type: Input }],
    showAsDropdown: [{ type: Input }]
};
__decorate$9([
    DwInputConverter(booleanConverter),
    __metadata$8("design:type", Object)
], DwYesNoComponent.prototype, "allowNull", void 0);
__decorate$9([
    DwInputConverter(booleanConverter),
    __metadata$8("design:type", Object)
], DwYesNoComponent.prototype, "showAsDropdown", void 0);

class DwSelectComponent {
    constructor() {
        this.options = [];
        this.showBlank = false;
        this.blankText = "";
        this.displayField = "label";
        this.idField = "value";
        this.blankOptions = [];
        this._onChange = (_) => { };
        this._onTouched = () => { };
    }
    get inputElement() {
        return this._inputElement;
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    onChange(event) {
        let value = this.getCurrentValue(event);
        this.value = value;
        this._onChange(value);
    }
    onKeyup(event) {
        //this._onChange(event.target.value);
        this._onChange(this.value);
    }
    onBlur(event) {
        this._onTouched();
    }
    onTouched() {
        this._onTouched();
    }
    getCurrentValue(event) {
        let index = event.target.selectedIndex;
        if (this.showBlank === true || this.showBlank.toString() === "true") {
            if (index == 0)
                return undefined;
            index--;
        }
        var item = this.options[index];
        if (item && this.idField)
            return item[this.idField];
        return item;
    }
}
DwSelectComponent.ɵfac = function DwSelectComponent_Factory(t) { return new (t || DwSelectComponent)(); };
DwSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSelectComponent, selectors: [["dw-select"]], viewQuery: function DwSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c19, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
    } }, inputs: { options: "options", showBlank: "showBlank", blankText: "blankText", displayField: "displayField", idField: "idField", id: "id", disabled: "disabled" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwSelectComponent),
                multi: true
            }])], decls: 3, vars: 4, consts: [[3, "id", "disabled", "change", "keyup", "blur", "[ngModel]"], [4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function DwSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵlistener("change", function DwSelectComponent_Template_select_change_0_listener($event) { return ctx.onChange($event); })("keyup", function DwSelectComponent_Template_select_keyup_0_listener($event) { return ctx.onKeyup($event); })("blur", function DwSelectComponent_Template_select_blur_0_listener($event) { return ctx.onBlur($event); })("[ngModel]", function DwSelectComponent_Template_select__ngModel__0_listener() { return ctx.value; });
        ɵngcc0.ɵɵtemplate(1, DwSelectComponent_option_1_Template, 2, 1, "option", 1);
        ɵngcc0.ɵɵtemplate(2, DwSelectComponent_option_2_Template, 2, 2, "option", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showBlank);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwSelectComponent.propDecorators = {
    id: [{ type: Input }],
    options: [{ type: Input }],
    showBlank: [{ type: Input }],
    blankText: [{ type: Input }],
    displayField: [{ type: Input }],
    idField: [{ type: Input }],
    disabled: [{ type: Input }],
    _inputElement: [{ type: ViewChild, args: ['inputElement',] }]
};

var DwColumnLayoutMode;
(function (DwColumnLayoutMode) {
    DwColumnLayoutMode["grid12"] = "grid12";
    DwColumnLayoutMode["flex"] = "flex";
})(DwColumnLayoutMode || (DwColumnLayoutMode = {}));
class DwColumnLayoutModeEmumList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwColumnLayoutMode[propertyName];
    }
    getKeys() {
        return Object.keys(DwColumnLayoutMode);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwColumnLayoutMode.grid12:
                return 'Standard - 12 Column grid';
            case DwColumnLayoutMode.flex:
                return 'Flex grid (beta)';
            default:
                return '';
        }
    }
}

class DwColDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        //@HostBinding('class')
        //elementClass = 'ui-g-12';
        this.colSize = 6;
        this.sizeType = 'md';
        this.layoutMode = DwColumnLayoutMode.grid12;
        this.renderClasses();
    }
    get elementClass() {
        return this.classes.join(' ');
    }
    renderClasses() {
        if (!this.colSize)
            return;
        this.classes = [];
        this.style = null;
        switch (this.layoutMode) {
            case DwColumnLayoutMode.flex:
                this.setupFlex();
                break;
            case DwColumnLayoutMode.grid12:
            default:
                this.setupGrid12();
                break;
        }
        // this.renderer.removeClass(this.el.nativeElement, "col-md-6");
        // if (this.colClass) {
        //     this.classes.push(this.colClass);
        //     // this.renderer.addClass(this.el.nativeElement, this.colClass);
        // }
        // if (this.colWidth) {
        //     this.style = { 'width': this.colWidth };
        //     // this.renderer.setStyle(this.el.nativeElement, 'width', this.colWidth);
        // } else {
        //     if (!this.colClass) {
        //         this.classes.push('col-md-' + this.colSize);
        //         // this.renderer.addClass(this.el.nativeElement, "col-md-" + this.colSize);
        //     }
        // }
    }
    setupFlex() {
        var _a, _b, _c, _d, _e;
        this.style = {};
        const flexSize = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.flexSize) == 0 ? 0 : ((_b = this.options) === null || _b === void 0 ? void 0 : _b.flexSize) || 1;
        if (flexSize > 0) {
            this.style['flex'] = flexSize.toString();
        }
        if ((_c = this.options) === null || _c === void 0 ? void 0 : _c.flexGrow) {
            this.style['flex-grow'] = this.options.flexGrow.toString();
        }
        const colClass = this.colClass || ((_d = this.options) === null || _d === void 0 ? void 0 : _d.columnClass);
        this.classes.push(colClass);
        const colWidth = this.colWidth || ((_e = this.options) === null || _e === void 0 ? void 0 : _e.customWidth);
        if (colWidth) {
            this.style['width'] = colWidth;
        }
    }
    setupGrid12() {
        var _a, _b, _c;
        const colClass = this.colClass || ((_a = this.options) === null || _a === void 0 ? void 0 : _a.columnClass);
        if (colClass) {
            this.classes.push(colClass);
        }
        const colWidth = this.colWidth || ((_b = this.options) === null || _b === void 0 ? void 0 : _b.customWidth);
        if (colWidth) {
            this.style = { 'width': colWidth };
        }
        else {
            if (!colClass) {
                const colSize = this.colSize || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.columnSize) || 6;
                this.classes.push(`col-${this.sizeType}-${colSize}`);
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.colSize)
            this.renderClasses();
    }
}
DwColDirective.ɵfac = function DwColDirective_Factory(t) { return new (t || DwColDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DwColDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwColDirective, selectors: [["", "dwCol", ""]], hostVars: 4, hostBindings: function DwColDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.style);
        ɵngcc0.ɵɵclassMap(ctx.elementClass);
    } }, inputs: { colSize: ["dwCol", "colSize"], sizeType: ["dwSizeType", "sizeType"], layoutMode: "layoutMode", colWidth: ["dwColWidth", "colWidth"], colClass: ["dwColClass", "colClass"], options: ["dwColOptions", "options"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwColDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DwColDirective.propDecorators = {
    colSize: [{ type: Input, args: ['dwCol',] }],
    colWidth: [{ type: Input, args: ['dwColWidth',] }],
    colClass: [{ type: Input, args: ['dwColClass',] }],
    sizeType: [{ type: Input, args: ['dwSizeType',] }],
    options: [{ type: Input, args: ['dwColOptions',] }],
    layoutMode: [{ type: Input, args: ['layoutMode',] }],
    style: [{ type: HostBinding, args: ['style',] }],
    elementClass: [{ type: HostBinding, args: ['class',] }]
};

class DwRowDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.elementClass = 'row ui-g p-fluid';
        this.elementStyle = {};
        this.layoutMode = DwColumnLayoutMode.grid12;
    }
    ngOnChanges(changes) {
        this.setupClasses();
    }
    ngOnInit() {
        this.setupClasses();
    }
    setupClasses() {
        switch (this.layoutMode) {
            case DwColumnLayoutMode.flex:
                this.elementClass = '';
                this.elementStyle = { 'display': 'flex', 'flex-wrap': 'wrap' };
                break;
            case DwColumnLayoutMode.grid12:
            default:
                this.elementClass = 'row ui-g p-fluid';
                break;
        }
    }
}
DwRowDirective.ɵfac = function DwRowDirective_Factory(t) { return new (t || DwRowDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DwRowDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwRowDirective, selectors: [["", "dwRow", ""]], hostVars: 4, hostBindings: function DwRowDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.elementStyle);
        ɵngcc0.ɵɵclassMap(ctx.elementClass);
    } }, inputs: { layoutMode: "layoutMode" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwRowDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DwRowDirective.propDecorators = {
    elementClass: [{ type: HostBinding, args: ['class',] }],
    elementStyle: [{ type: HostBinding, args: ['style',] }],
    layoutMode: [{ type: Input, args: ['layoutMode',] }]
};

function Replace(el) {
    const nativeElement = el.nativeElement;
    const parentElement = nativeElement.parentElement;
    // move all children out of the element
    while (nativeElement.firstChild) {
        parentElement.insertBefore(nativeElement.firstChild, nativeElement);
    }
    // remove the empty element(the host)
    parentElement.removeChild(nativeElement);
}

class DwNavDropdownDirective {
    constructor(el) {
        this.el = el;
    }
    toggle() {
        this.el.nativeElement.classList.toggle('open');
    }
}
DwNavDropdownDirective.ɵfac = function DwNavDropdownDirective_Factory(t) { return new (t || DwNavDropdownDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwNavDropdownDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwNavDropdownDirective, selectors: [["", "dwAppNavDropdown", ""]] });
DwNavDropdownDirective.ctorParameters = () => [
    { type: ElementRef }
];
/**
* Allows the dropdown to be toggled via click.
*/
class DwNavDropdownToggleDirective {
    constructor(dropdown) {
        this.dropdown = dropdown;
    }
    toggleOpen($event) {
        $event.preventDefault();
        this.dropdown.toggle();
    }
}
DwNavDropdownToggleDirective.ɵfac = function DwNavDropdownToggleDirective_Factory(t) { return new (t || DwNavDropdownToggleDirective)(ɵngcc0.ɵɵdirectiveInject(DwNavDropdownDirective)); };
DwNavDropdownToggleDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwNavDropdownToggleDirective, selectors: [["", "dwAppNavDropdownToggle", ""]], hostBindings: function DwNavDropdownToggleDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DwNavDropdownToggleDirective_click_HostBindingHandler($event) { return ctx.toggleOpen($event); });
    } } });
DwNavDropdownToggleDirective.ctorParameters = () => [
    { type: DwNavDropdownDirective }
];
DwNavDropdownToggleDirective.propDecorators = {
    toggleOpen: [{ type: HostListener, args: ['click', ['$event'],] }]
};
class DwAppSidebarNavComponent {
    constructor() {
        /* @HostBinding('class.sidebar-nav') true; */
        this.role = 'nav';
    }
    isDivider(item) {
        return item.isDivider ? true : false;
    }
    isTitle(item) {
        return item.isTitle ? true : false;
    }
}
DwAppSidebarNavComponent.ɵfac = function DwAppSidebarNavComponent_Factory(t) { return new (t || DwAppSidebarNavComponent)(); };
DwAppSidebarNavComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAppSidebarNavComponent, selectors: [["dw-app-sidebar-nav"]], hostVars: 1, hostBindings: function DwAppSidebarNavComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role);
    } }, inputs: { navItems: "navItems" }, decls: 2, vars: 1, consts: [[1, "nav"], [4, "ngFor", "ngForOf"], ["class", "nav-divider", 4, "ngIf"], [3, "title", 4, "ngIf"], [3, "item", 4, "ngIf"], [1, "nav-divider"], [3, "title"], [3, "item"]], template: function DwAppSidebarNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, DwAppSidebarNavComponent_div_1_Template, 4, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.navItems);
    } }, directives: function () { return [ɵngcc4.NgForOf, ɵngcc4.NgIf, DwAppSidebarNavTitleComponent, DwAppSidebarNavItemComponent]; }, encapsulation: 2 });
DwAppSidebarNavComponent.ctorParameters = () => [];
DwAppSidebarNavComponent.propDecorators = {
    navItems: [{ type: Input }],
    role: [{ type: HostBinding, args: ['attr.role',] }]
};
class DwAppSidebarNavItemComponent {
    constructor(router, el, 
    // @Inject(DwRoutingServiceToken) private routingService : DwRoutingService
    menuService) {
        this.router = router;
        this.el = el;
        this.menuService = menuService;
    }
    hasClass() {
        return this.item.data.cssClass ? true : false;
    }
    isDropdown() {
        if (this.item.children && this.item.children.length > 0) {
            return true;
        }
        return false;
    }
    thisUrl() {
        return this.item.url;
    }
    isActive() {
        if (this.menuService.isMenuInBreadcrumb(this.item)) {
            return true;
        }
        return this.router.isActive(this.thisUrl(), false);
    }
    ngOnInit() {
        Replace(this.el);
    }
}
DwAppSidebarNavItemComponent.ɵfac = function DwAppSidebarNavItemComponent_Factory(t) { return new (t || DwAppSidebarNavItemComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DwMenuService)); };
DwAppSidebarNavItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAppSidebarNavItemComponent, selectors: [["dw-app-sidebar-nav-item"]], inputs: { item: "item" }, decls: 3, vars: 2, consts: [[3, "ngClass", 4, "ngIf", "ngIfElse"], ["dropdown", ""], [3, "ngClass"], [3, "menu", "menuLocation"], ["routerLinkActive", "open", "dwAppNavDropdown", "", 3, "ngClass"], [3, "link"]], template: function DwAppSidebarNavItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwAppSidebarNavItemComponent_li_0_Template, 2, 3, "li", 0);
        ɵngcc0.ɵɵtemplate(1, DwAppSidebarNavItemComponent_ng_template_1_Template, 2, 4, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isDropdown())("ngIfElse", _r1);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgClass, DwMenuLinkComponent, ɵngcc2.RouterLinkActive, DwNavDropdownDirective, DwAppSidebarNavDropdownComponent]; }, encapsulation: 2 });
DwAppSidebarNavItemComponent.ctorParameters = () => [
    { type: Router },
    { type: ElementRef },
    { type: DwMenuService }
];
DwAppSidebarNavItemComponent.propDecorators = {
    item: [{ type: Input }]
};
class DwAppSidebarNavLinkComponent {
    constructor(router, el) {
        this.router = router;
        this.el = el;
        this.exactMatch = false;
    }
    hasVariant() {
        return this.link.variant ? true : false;
    }
    isBadge() {
        return this.link.badge ? true : false;
    }
    isExternalLink() {
        return this.link.url.substring(0, 4) === 'http' ? true : false;
    }
    isActionLink() {
        return this.link.data.isAction;
    }
    isIcon() {
        return this.link.data.iconCssClass ? true : false;
    }
    hideMobile() {
        if (document.body.classList.contains('sidebar-show')) {
            document.body.classList.toggle('sidebar-show');
        }
    }
    ngOnInit() {
        Replace(this.el);
    }
}
DwAppSidebarNavLinkComponent.ɵfac = function DwAppSidebarNavLinkComponent_Factory(t) { return new (t || DwAppSidebarNavLinkComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwAppSidebarNavLinkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAppSidebarNavLinkComponent, selectors: [["dw-app-sidebar-nav-link"]], inputs: { exactMatch: "exactMatch", link: "link" }, decls: 1, vars: 1, consts: [[3, "menu"]], template: function DwAppSidebarNavLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-menu-link", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("menu", ctx.link);
    } }, directives: function () { return [DwMenuLinkComponent]; }, encapsulation: 2 });
DwAppSidebarNavLinkComponent.ctorParameters = () => [
    { type: Router },
    { type: ElementRef }
];
DwAppSidebarNavLinkComponent.propDecorators = {
    link: [{ type: Input }],
    exactMatch: [{ type: Input }]
};
class DwAppSidebarNavDropdownComponent {
    constructor(router, el) {
        this.router = router;
        this.el = el;
    }
    isBadge() {
        return this.link.badge ? true : false;
    }
    isIcon() {
        if (!this.link.data)
            return false;
        return this.link.data.iconCssClass ? true : false;
    }
    ngOnInit() {
        Replace(this.el);
    }
}
DwAppSidebarNavDropdownComponent.ɵfac = function DwAppSidebarNavDropdownComponent_Factory(t) { return new (t || DwAppSidebarNavDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwAppSidebarNavDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAppSidebarNavDropdownComponent, selectors: [["dw-app-sidebar-nav-dropdown"]], inputs: { link: "link" }, decls: 6, vars: 4, consts: [["dwAppNavDropdownToggle", "", 1, "nav-link", "nav-dropdown-toggle"], [3, "class", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "nav-dropdown-items"], ["ngFor", "", 3, "ngForOf"], [3, "ngClass"], [3, "item"]], template: function DwAppSidebarNavDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵtemplate(1, DwAppSidebarNavDropdownComponent_i_1_Template, 1, 3, "i", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵtemplate(3, DwAppSidebarNavDropdownComponent_span_3_Template, 2, 2, "span", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "ul", 3);
        ɵngcc0.ɵɵtemplate(5, DwAppSidebarNavDropdownComponent_ng_template_5_Template, 1, 1, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isIcon());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.link.display, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isBadge());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.link.children);
    } }, directives: [DwNavDropdownToggleDirective, ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc4.NgClass, DwAppSidebarNavItemComponent], styles: [".nav-dropdown-toggle[_ngcontent-%COMP%] { cursor: pointer; }"] });
DwAppSidebarNavDropdownComponent.ctorParameters = () => [
    { type: Router },
    { type: ElementRef }
];
DwAppSidebarNavDropdownComponent.propDecorators = {
    link: [{ type: Input }]
};
class DwAppSidebarNavTitleComponent {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngOnInit() {
        const nativeElement = this.el.nativeElement;
        const li = this.renderer.createElement('li');
        const name = this.renderer.createText(this.title.name);
        this.renderer.addClass(li, 'nav-title');
        if (this.title.class) {
            const classes = this.title.class;
            this.renderer.addClass(li, classes);
        }
        if (this.title.wrapper) {
            const wrapper = this.renderer.createElement(this.title.wrapper.element);
            this.renderer.appendChild(wrapper, name);
            this.renderer.appendChild(li, wrapper);
        }
        else {
            this.renderer.appendChild(li, name);
        }
        this.renderer.appendChild(nativeElement, li);
        Replace(this.el);
    }
}
DwAppSidebarNavTitleComponent.ɵfac = function DwAppSidebarNavTitleComponent_Factory(t) { return new (t || DwAppSidebarNavTitleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DwAppSidebarNavTitleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAppSidebarNavTitleComponent, selectors: [["dw-app-sidebar-nav-title"]], inputs: { title: "title" }, decls: 0, vars: 0, template: function DwAppSidebarNavTitleComponent_Template(rf, ctx) { }, encapsulation: 2 });
DwAppSidebarNavTitleComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DwAppSidebarNavTitleComponent.propDecorators = {
    title: [{ type: Input }]
};

// This directive is used to dynamically load the config implementation component with in the DwUiConfigBaseComponent
class DwUiConfigHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
DwUiConfigHostDirective.ɵfac = function DwUiConfigHostDirective_Factory(t) { return new (t || DwUiConfigHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DwUiConfigHostDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwUiConfigHostDirective, selectors: [["", "dw-ui-config-host", ""]] });
DwUiConfigHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];

class DwUiConfigPanelComponent {
    constructor(uiConfig, componentFactoryResolver, uiConfigService, dwEventService, dwSecurityUserService, dwConfigService, dwDesignerStateService, document, renderer) {
        this.uiConfig = uiConfig;
        this.componentFactoryResolver = componentFactoryResolver;
        this.uiConfigService = uiConfigService;
        this.dwEventService = dwEventService;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwConfigService = dwConfigService;
        this.dwDesignerStateService = dwDesignerStateService;
        this.renderer = renderer;
        this.noConfigComponent = true;
        this.currentWidgetSubscriptions = [];
        this.subscriptions = [];
        this.panelMode = 'config';
        this.canConfigure = false;
        this.widgetConfigs = [];
        this.hasConfigurations = false;
        this.isExpanded = false;
        this.forceEvents = true;
        this.body = document.body;
        this.subscriptions.push(this.dwDesignerStateService.stateChanged.subscribe(state => {
            this.updateDesignerState(state);
        }));
        this.subscriptions.push(this.dwDesignerStateService.configureSectionSubject.subscribe(state => {
            this.updateDesignerState(state, true);
        }));
    }
    updateDesignerState(state, startConfigSession = false) {
        if (!this.isExpanded) {
            if (!startConfigSession) {
                return;
            }
            this.initalSelectedState = state;
            // Toggle side bar, but skip width config
            this.toggleSidebar("config");
        }
        for (let widgetConfig of this.widgetConfigs) {
            if (widgetConfig.configKey == state.configKey) {
                this.setConfigComponent(widgetConfig, startConfigSession);
                if (startConfigSession) {
                    this.currentWidgetInstance.handleConfigureSection(state);
                }
                break;
            }
        }
    }
    ngOnInit() {
        this.dwSecurityUserService.securityContextChanged()
            .subscribe(sc => {
            // Determine if the authenticate user can configure the UI
            this.canConfigure = this.uiConfig.allowConfiguration && this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canConfigureUIPermission, false);
        });
        this.canConfigure = this.uiConfig.allowConfiguration && this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canConfigureUIPermission, false);
    }
    toggleSidebar(panelMode, forceClosed = false, skipWidgetConfig = false) {
        if (this.panelMode != panelMode) {
            this.panelMode = panelMode;
            this.isExpanded = true;
        }
        else {
            this.isExpanded = !this.isExpanded;
        }
        if (forceClosed) {
            this.isExpanded = false;
        }
        this.renderer.removeClass(this.body, 'aside-menu-lg-show');
        if (this.isExpanded) {
            this.renderer.addClass(this.body, 'aside-menu-lg-show');
        }
        if (!this.isExpanded) {
            this.clearWidgetComponent();
        }
        else {
            if (!skipWidgetConfig) {
                this.determineWidgetConfig();
            }
        }
    }
    ngAfterContentInit() {
        this.subscriptions.push(this.uiConfigService.getUiPanelWidgetConfigs()
            .pipe(debounceTime(100))
            .subscribe((widgetConfigs) => {
            setTimeout(() => {
                this.widgetConfigs = sortArray(widgetConfigs, (widgetConfig) => this.getUiConfigTypeOrder(widgetConfig === null || widgetConfig === void 0 ? void 0 : widgetConfig.uiConfigTypeId));
                this.determineWidgetConfig();
            }, 5);
        }));
    }
    determineWidgetConfig() {
        //this.widgetConfigs =  sortArray(widgetConfigs, (widgetConfig) => this.getUiConfigTypeOrder(widgetConfig?.uiConfigTypeId));
        var _a;
        let currentWidgetConfig = null;
        this.hasConfigurations = false;
        if (this.widgetConfigs && this.widgetConfigs.length > 0) {
            const currentWidthExists = this.widgetConfigs.indexOf(this.currentWidgetConfig) >= 0;
            // If the current config widget is ok, then let's keep it
            if (currentWidthExists) {
                // currentWidgetConfig = this.currentWidgetConfig;
            }
            this.hasConfigurations = true;
        }
        currentWidgetConfig = this.widgetConfigs[0];
        if ((_a = this.initalSelectedState) === null || _a === void 0 ? void 0 : _a.configKey) {
            currentWidgetConfig = this.widgetConfigs.find(wc => wc.configKey == this.initalSelectedState.configKey);
            if (!currentWidgetConfig) {
                currentWidgetConfig = this.widgetConfigs[0];
            }
        }
        if (this.isExpanded) {
            this.setConfigComponent(currentWidgetConfig);
        }
        if (!this.hasConfigurations && this.isExpanded) {
            this.toggleSidebar('config');
        }
    }
    getUiConfigTypeOrder(uiConfigType) {
        switch (uiConfigType) {
            case DwUiConfigType.form:
                return 1;
            case DwUiConfigType.grid:
                return 2;
            case DwUiConfigType.list:
                return 3;
            case DwUiConfigType.content:
                return 10;
            default:
                return 5;
        }
    }
    getWidgetConfigDisplay(widgetConfig) {
        if (!widgetConfig) {
            return "None";
        }
        return `${widgetConfig.configKey} (${this.getUiConfigTypeDisplay(widgetConfig.uiConfigTypeId)})`;
    }
    getUiConfigTypeDisplay(uiConfigTypeId) {
        switch (uiConfigTypeId) {
            case 1: return "Grid";
            case 2: return "Form";
            case 3: return "Content";
            case 4: return "List";
        }
        return "Unknown";
    }
    setConfigComponent(configComponent, startConfigSession = false) {
        if (this.currentWidgetConfig) {
            // Ensure the key is actually changing
            if (configComponent && this.currentWidgetConfig.configKey == configComponent.configKey && this.currentWidgetConfig.uiConfigTypeId == configComponent.uiConfigTypeId) {
                return;
            }
            this.clearWidgetComponent();
        }
        this.currentWidgetConfig = configComponent;
        if (configComponent && this.isExpanded)
            this.loadWidgetComponent(startConfigSession);
    }
    ngOnDestroy() {
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        this.clearWidgetComponent();
    }
    loadWidgetComponent(startConfigSession) {
        if (!this.dwUiConfigHost || !this.dwUiConfigHost.viewContainerRef)
            return;
        if (!this.currentWidgetConfig.widgetComponent) {
            throw new Error("Ui Panel Widget Component does not define a WidgetComponent!");
        }
        if (!this.currentWidgetConfig.debugComponent && this.panelMode == 'debug') {
            this.panelMode = 'config';
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.currentWidgetConfig.widgetComponent);
        let viewContainerRef = this.dwUiConfigHost.viewContainerRef;
        viewContainerRef.clear();
        let componentRef = viewContainerRef.createComponent(componentFactory);
        this.currentWidgetInstance = componentRef.instance;
        this.setupConfigWidget();
        if (startConfigSession) {
            this.currentWidgetInstance.handleConfigureSection(this.dwDesignerStateService.state);
        }
    }
    configureDebugComponent(debugComponentInstance) {
        console.log('Debug component setup!');
        this.debugComponentInstance = debugComponentInstance;
        this.debugComponentInstance.configKey = this.currentWidgetConfig.configKey;
        // Nothing more to set since the preferences will be set as part of the config widget
    }
    setupConfigWidget(resetOnly = false) {
        this.currentWidgetInstance.configKey = this.currentWidgetConfig.configKey;
        // clear messasge when config changes
        this.message = null;
        this.currentWidgetSubscriptions.push(this.currentWidgetInstance.messageChange.subscribe(message => {
            this.message = message;
        }));
        // Listen for preference changes from the widget and pass to the Api
        if (!resetOnly) {
            this.currentWidgetSubscriptions.push(this.currentWidgetInstance.preferencesChange.asObservable().subscribe((prefs) => {
                this.handlePreferenceUpdate(prefs, false);
            }));
            this.currentWidgetSubscriptions.push(this.currentWidgetInstance.preferenceChangeWithSave.subscribe((prefs) => {
                this.handlePreferenceUpdate(prefs, true);
            }));
        }
        // Get the initial preferences from the api and pass to the widget
        this.currentWidgetSubscriptions.push(this.dwEventService.getEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.PreferencesFinalizedEvent(this.currentWidgetConfig.configKey, this.currentWidgetConfig.uiConfigTypeId))
            //.subscribe((prefs: DwUiPreferencesBase) => {
            .subscribe((event) => {
            if (event.data.configKey != this.currentWidgetConfig.configKey) {
                console.warn(`Config keys don't match - set from event - Expected ${this.currentWidgetConfig.configKey} but got ${event.data.configKey}`);
                return;
            }
            setTimeout(() => {
                //console.log("SetupConfigWidget - set preferences ", this.currentWidgetConfig, event);
                if (this.currentPreferenceHierarchy && this.currentPreferenceHierarchy.configKey != event.data.configKey) {
                    //console.log("Config keys dont' match - set from event");
                    return;
                }
                this.currentPreferenceHierarchy = deepCopy(event.data);
                var finalPrefs = this.uiConfigService.getFinalPreferences(this.currentPreferenceHierarchy);
                if (this.currentWidgetInstance) {
                    this.currentWidgetInstance.preferencesHierarchy = this.currentPreferenceHierarchy;
                    this.currentWidgetInstance.preferences = finalPrefs;
                }
                if (this.debugComponentInstance) {
                    this.debugComponentInstance.preferencesHierarchy = this.currentPreferenceHierarchy;
                    this.debugComponentInstance.preferences = finalPrefs;
                }
            }, 5);
        }));
    }
    handlePreferenceUpdate(prefs, savePreferences) {
        let newLoadedPrefs = this.uiConfigService.determineLoadedPreferences(this.currentPreferenceHierarchy, prefs);
        if (!areEqual(this.currentPreferenceHierarchy.loadedPreferences, newLoadedPrefs)) {
            if (this.currentPreferenceHierarchy.configKey != this.currentWidgetInstance.configKey) {
                //console.log("Config keys dont' match - set from component");
                return;
            }
            this.currentPreferenceHierarchy.loadedPreferences = newLoadedPrefs;
            // Update current widget in case it didn't get the update
            this.currentWidgetInstance.preferences = newLoadedPrefs;
            if (!savePreferences) {
                this.onPreferenceChange(this.currentPreferenceHierarchy);
            }
        }
        // If save was selected, always save it (they could have made previous in-memory changes that need to be saved)
        if (savePreferences) {
            this.save(newLoadedPrefs);
        }
    }
    onPreferenceChange(prefs) {
        if (prefs.configType !== this.currentWidgetConfig.uiConfigTypeId || prefs.configKey != this.currentWidgetConfig.configKey) {
            return;
        }
        // console.log('OnPreferenceChange');
        this.dwEventService.publishEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.PreferencesUpdateEvent(this.currentWidgetConfig.configKey, this.currentWidgetConfig.uiConfigTypeId), prefs);
    }
    clearWidgetComponent() {
        if (!this.dwUiConfigHost || !this.dwUiConfigHost.viewContainerRef)
            return;
        if (!this.currentWidgetInstance)
            return;
        let viewContainerRef = this.dwUiConfigHost.viewContainerRef;
        viewContainerRef.clear();
        // Clear out all widgets
        for (var subscription of this.currentWidgetSubscriptions) {
            subscription.unsubscribe();
        }
        this.currentWidgetSubscriptions = [];
        this.currentPreferenceHierarchy = null;
        // Destroy widget to clear any events
        this.currentWidgetInstance.ngOnDestroy();
        this.currentWidgetInstance = null;
        this.currentWidgetConfig = null;
    }
    save(preferences) {
        if (!preferences) {
            preferences = this.currentWidgetInstance.preferences;
        }
        this.uiConfigService.savePreferencesHierarchy(this.currentPreferenceHierarchy)
            .subscribe((result) => {
            this.currentPreferenceHierarchy = result;
            // update original preferences since they are now saved
            this.currentWidgetInstance.originalPreferences = deepCopy(this.currentWidgetInstance.preferences);
            this.onPreferenceChange(this.currentPreferenceHierarchy);
            this.message = {
                messageBody: 'Save Complete',
                severity: DwMessageSeverity.success,
                timeToShow: 1000
            };
        });
    }
    reset() {
        this.currentPreferenceHierarchy.loadedPreferences = null;
        this.onPreferenceChange(this.currentPreferenceHierarchy);
    }
}
DwUiConfigPanelComponent.ɵfac = function DwUiConfigPanelComponent_Factory(t) { return new (t || DwUiConfigPanelComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DwUiConfigPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiConfigPanelComponent, selectors: [["dw-ui-config-panel"]], viewQuery: function DwUiConfigPanelComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwUiConfigHostDirective, true);
        ɵngcc0.ɵɵviewQuery(DwGridHostDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwUiConfigHost = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwGridHost = _t.first);
    } }, decls: 15, vars: 9, consts: [[1, "config-bar", 3, "hidden"], ["class", "config-bar-left-panel", 4, "ngIf"], [1, "config-bar-body"], ["dwRow", "", 4, "ngIf"], [3, "hidden"], ["dw-ui-config-host", ""], ["config", ""], [3, "component", "configure"], ["class", "config-bar-message", 4, "ngIf"], ["class", "config-bar-footer", 4, "ngIf"], [1, "config-bar-left-panel"], [1, "config-handle", 3, "ngClass", "click"], [1, "fa", "fa-cog"], [1, "config-handle2", 3, "hidden", "ngClass", "click"], [1, "fa", "fa-bug"], ["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "config-bar-message"], [3, "message", "messageChange"], [1, "config-bar-footer"], ["title", "Save Prefences", 1, "btn-sm", "btn-success", 3, "click"], ["title", "Reset to Defaults", 1, "btn-sm", "btn-success", 3, "click"]], template: function DwUiConfigPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwUiConfigPanelComponent_div_1_Template, 5, 7, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "h3");
        ɵngcc0.ɵɵtext(4, "Configuration");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwUiConfigPanelComponent_div_5_Template, 7, 4, "div", 3);
        ɵngcc0.ɵɵtemplate(6, DwUiConfigPanelComponent_div_6_Template, 3, 0, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵtemplate(8, DwUiConfigPanelComponent_ng_template_8_Template, 0, 0, "ng-template", 5, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵtext(11, " DEBUG PANEL ");
        ɵngcc0.ɵɵelementStart(12, "dw-dynamic-loader", 7);
        ɵngcc0.ɵɵlistener("configure", function DwUiConfigPanelComponent_Template_dw_dynamic_loader_configure_12_listener($event) { return ctx.configureDebugComponent($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, DwUiConfigPanelComponent_div_13_Template, 2, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(14, DwUiConfigPanelComponent_div_14_Template, 5, 0, "div", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.canConfigure);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasConfigurations);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.widgetConfigs && ctx.widgetConfigs.length > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.widgetConfigs || ctx.widgetConfigs.length == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.panelMode != "config");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", ctx.panelMode != "debug");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("component", ctx.currentWidgetConfig == null ? null : ctx.currentWidgetConfig.debugComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentWidgetInstance && ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentWidgetInstance);
    } }, directives: function () { return [ɵngcc4.NgIf, DwUiConfigHostDirective, DwDynamicLoaderComponent, ɵngcc4.NgClass, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwMessageComponent]; }, styles: [".config-bar[_ngcontent-%COMP%]{display:flex;flex:0 0 200px;flex-direction:column;height:calc(100vh - var(--dw-navbar-height,55px));order:-1;position:fixed;width:250px}.config-bar-body[_ngcontent-%COMP%]{height:100%;padding:5px}.config-bar-footer[_ngcontent-%COMP%]{background-color:grey;height:55px;padding:5px;width:100%}.config-bar-message[_ngcontent-%COMP%]{overflow:hidden;padding:5px;width:100%}.config-bar-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{float:right;margin-left:8px}.config-bar-left-panel[_ngcontent-%COMP%]{background-color:#f08080;height:0}.config-bar-left-panel[_ngcontent-%COMP%]   .config-handle[_ngcontent-%COMP%]{margin-top:200px}.config-bar-left-panel[_ngcontent-%COMP%]   .config-handle[_ngcontent-%COMP%], .config-bar-left-panel[_ngcontent-%COMP%]   .config-handle2[_ngcontent-%COMP%]{background:rgba(0,0,0,.1);border-bottom-left-radius:15px;border-top-left-radius:15px;cursor:pointer;font-size:1.5em;height:37px;line-height:37px;margin-left:-37px;padding-left:7px;width:37px}.config-bar-left-panel[_ngcontent-%COMP%]   .config-handle2[_ngcontent-%COMP%]{margin-top:2px}.config-bar-left-panel[_ngcontent-%COMP%]   .selected-handle[_ngcontent-%COMP%]{background-color:#add8e6!important}@media (max-width:1000px){.config-handle[_ngcontent-%COMP%]{display:none}}"] });
DwUiConfigPanelComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: ComponentFactoryResolver },
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwDesignerStateService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 }
];
DwUiConfigPanelComponent.propDecorators = {
    dwUiConfigHost: [{ type: ViewChild, args: [DwUiConfigHostDirective, { static: true },] }],
    dwGridHost: [{ type: ViewChild, args: [DwGridHostDirective,] }]
};

const moment$7 = moment_;
class DwMessageBarComponent {
    constructor(configService, dwMessageService, uiConfig, messageService, cdr, appref) {
        this.configService = configService;
        this.dwMessageService = dwMessageService;
        this.uiConfig = uiConfig;
        this.messageService = messageService;
        this.cdr = cdr;
        this.appref = appref;
        this.showToasts = false;
        this.showRequestCounts = false;
        this.showProgress = false;
        this.progressMinimumDisplayTime = 500; // ms as a minimum display time
        this.realTimeRequestCount = 0;
        this.realTimeSaveRequestCount = 0;
        this.subscriptions = [];
        this.messageCheckThreshold = 2000;
        this._changeDetectionCount = 0;
        this._changeDetectionDisplayValue = 0;
        this.showDebugInfo = false;
        this.lastMesasge = null;
        this.lastMessageShownDateTime = null;
        //this.uiConfig = configService.coreConfig.getConfig<DwUIConfig>(DwUIConfig.configName);
        this.subscriptions.push(combineLatest([
            this.dwMessageService.getRequestCount(),
            this.dwMessageService.getSaveRequestCount()
        ])
            .pipe(debounceTime(5), delay(5))
            .subscribe(result => {
            setTimeout(() => {
                this.setRequestCounts(result[0], result[1]);
            }, 0);
        }));
        // Check for any request counts that are not being cleared
        setInterval(() => {
            this.doubleCheckRequestCounts();
        }, 1000);
    }
    doubleCheckRequestCounts() {
        if (this.realTimeRequestCount > 0 || this.realTimeSaveRequestCount > 0) {
            const elpasedTime = Date.now() - this.lastSetRequestCountsDateTime;
            if (elpasedTime > this.messageCheckThreshold) {
                if (this.dwMessageService.getRequestCountValue() == 0 && this.dwMessageService.getSaveRequestCountValue() == 0) {
                    this.setRequestCounts(0, 0);
                }
            }
        }
    }
    get ChangeDetectionCount() {
        this._changeDetectionCount++;
        return this._changeDetectionDisplayValue;
    }
    ngDoCheck() {
        this._changeDetectionDisplayValue = this._changeDetectionCount;
    }
    logDebugInfo(message, data) {
        if (this.showDebugInfo) {
            if (data) {
                console.log(message, data);
            }
            else {
                console.log(message);
            }
        }
    }
    setRequestCounts(requestCount, saveRequestCount) {
        this.lastSetRequestCountsDateTime = Date.now();
        let reduceCount = false;
        this.realTimeRequestCount = requestCount;
        this.realTimeSaveRequestCount = saveRequestCount;
        if (this.showRequestCounts) {
            this.setProgressBarVisibility();
        }
    }
    setProgressBarVisibility() {
        if (this.realTimeRequestCount > 0 || this.realTimeSaveRequestCount > 0) {
            if (!this.showProgress) {
                this.logDebugInfo('Set Show Progress = true');
                this.showProgress = true;
                this.hideProgressAfterDateTime = moment$7().add(this.progressMinimumDisplayTime, 'ms');
                this.cdr.detectChanges();
            }
        }
        this.hideProgressBarCheck();
    }
    hideProgressBarCheck() {
        this.logDebugInfo('hideProgressBarCheck', { requestCount: this.realTimeRequestCount, saveCount: this.realTimeSaveRequestCount });
        // Check if we should even hide it
        if (this.realTimeRequestCount > 0 || this.realTimeSaveRequestCount > 0) {
            this.setupInterval();
            return;
        }
        if (!this.showProgress) {
            return;
        }
        if (this.hideProgressAfterDateTime && this.hideProgressAfterDateTime.isBefore()) {
            if (this.intervalHandle) {
                this.logDebugInfo('Clear Interval', { requestCount: this.realTimeRequestCount, saveCount: this.realTimeSaveRequestCount });
                clearInterval(this.intervalHandle);
                this.intervalHandle = null;
            }
            this.logDebugInfo('Set Show Progress = false', { requestCount: this.realTimeRequestCount, saveCount: this.realTimeSaveRequestCount });
            this.showProgress = false;
            this.hideProgressAfterDateTime = null;
            this.cdr.detectChanges();
            return;
        }
    }
    setupInterval() {
        this.logDebugInfo('setupInterval - check if exists', { requestCount: this.realTimeRequestCount, saveCount: this.realTimeSaveRequestCount, intervalHandle: this.intervalHandle });
        if (!this.intervalHandle) {
            this.logDebugInfo('setupInterval - creating set Interval', { requestCount: this.realTimeRequestCount, saveCount: this.realTimeSaveRequestCount, intervalHandle: this.intervalHandle });
            this.intervalHandle = setInterval(() => {
                this.logDebugInfo('Interval Check', { requestCount: this.realTimeRequestCount, saveCount: this.realTimeSaveRequestCount });
                this.hideProgressBarCheck();
            }, 100);
        }
    }
    ngOnInit() {
        if (this.showToasts) {
            this.subscriptions.push(this.dwMessageService.getMessages(this.locationKey)
                .subscribe(dwMessage => {
                if (dwMessage) {
                    if (this.isDuplicateMessage(dwMessage)) {
                        console.log('Suppressing Duplicate Message ', dwMessage.messageBody);
                        return;
                    }
                    setTimeout(() => {
                        this.displayMessage(dwMessage);
                    }, 5);
                }
                this.lastMesasge = dwMessage;
            }));
        }
    }
    isDuplicateMessage(dwMessage) {
        var _a;
        if (dwMessage.messageBody != ((_a = this.lastMesasge) === null || _a === void 0 ? void 0 : _a.messageBody)) {
            this.lastMesasge = Object.assign({}, dwMessage);
            return false;
        }
        if (!this.lastMessageShownDateTime) {
            this.lastMessageShownDateTime = moment$7();
            return false;
        }
        const timeoutDateTime = moment$7(this.lastMessageShownDateTime).add(1, "s");
        if (timeoutDateTime.isBefore(moment$7())) {
            this.lastMessageShownDateTime = moment$7();
            //this.lastMesasge = null;
            return false;
        }
        return true;
    }
    isExpired(expirationDateTime, marginSeconds = 0) {
        if (!expirationDateTime) {
            return true;
        }
        let momentDate = moment$7.utc(expirationDateTime);
        momentDate = momentDate.add(-marginSeconds, 'seconds');
        if (momentDate.isSameOrAfter(moment$7())) {
            return false;
        }
        return true;
    }
    displayMessage(dwMessage) {
        let message = this.mapMessage(dwMessage);
        this.messageService.add(message);
        this.cdr.detectChanges();
    }
    mapMessage(dwMessage) {
        return {
            severity: this.mapSeverity(dwMessage.severity),
            summary: dwMessage.messageHeading,
            detail: dwMessage.messageBody,
            key: dwMessage.locationKey,
            life: dwMessage.timeToShow,
            sticky: dwMessage.forceClose,
            closable: dwMessage.forceClose || dwMessage.allowClose,
        };
    }
    mapSeverity(severity) {
        if (!severity)
            return "success";
        switch (severity) {
            case DwMessageSeverity.error: return "error";
            case DwMessageSeverity.info: return "info";
            case DwMessageSeverity.warning: return "warn";
            case DwMessageSeverity.success: return "success";
        }
        return "success";
    }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwMessageBarComponent.ɵfac = function DwMessageBarComponent_Factory(t) { return new (t || DwMessageBarComponent)(ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMessagingService), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.MessageService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ApplicationRef)); };
DwMessageBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMessageBarComponent, selectors: [["dw-message-bar"]], inputs: { showToasts: "showToasts", showRequestCounts: "showRequestCounts", locationKey: "locationKey" }, decls: 3, vars: 2, consts: [[4, "ngIf"], ["style2", "height:8px;overflow:auto;background-color:aqua", 4, "ngIf"], ["style2", "height:8px;overflow:auto;background-color:aqua"], [2, "margin-top", "-25px", "height", "10px"], [2, "margin-top", "-25px"], [3, "hidden", "ngClass"], ["mode", "indeterminate"], [2, "height", "3px", 3, "hidden"], [2, "margin-top", "25px"], [1, "badge", "badge-light"]], template: function DwMessageBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, DwMessageBarComponent_div_1_Template, 2, 3, "div", 0);
        ɵngcc0.ɵɵtemplate(2, DwMessageBarComponent_div_2_Template, 9, 9, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showToasts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRequestCounts);
    } }, directives: [ɵngcc4.NgIf, ɵngcc13.Toast, ɵngcc4.NgClass, ɵngcc14.ProgressBar], styles: [".blueProgress[_ngcontent-%COMP%]   .ui-progressbar[_ngcontent-%COMP%]   .ui-progressbar-label[_ngcontent-%COMP%]{color:#ff0}.greenProgress[_ngcontent-%COMP%], .greenProgress[_ngcontent-%COMP%]   .ui-progressbar[_ngcontent-%COMP%]   .ui-progressbar-value[_ngcontent-%COMP%]{background-color:#90ee90}.greenProgress[_ngcontent-%COMP%]{color:red}.customProgress[_ngcontent-%COMP%]   .ui-progressbar[_ngcontent-%COMP%]   .ui-progressbar-label[_ngcontent-%COMP%]{color:#ff0}.customProgress[_ngcontent-%COMP%]   .ui-progressbar[_ngcontent-%COMP%]   .ui-progressbar-value[_ngcontent-%COMP%]{background:red}.green[_ngcontent-%COMP%]{color:#90ee90}"], changeDetection: 0 });
DwMessageBarComponent.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwMessagingService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: MessageService },
    { type: ChangeDetectorRef },
    { type: ApplicationRef }
];
DwMessageBarComponent.propDecorators = {
    locationKey: [{ type: Input }],
    showToasts: [{ type: Input }],
    showRequestCounts: [{ type: Input }]
};

class DwModalHostComponent {
    constructor(dwModalService, componentFactoryResolver, dwSecurityService) {
        this.dwModalService = dwModalService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.dwSecurityService = dwSecurityService;
        this.processing = false;
        this.instanceNo = "1";
        this.showModal = false;
        this.baseZIndex = 1300;
        this.showModal2 = false;
        this.baseZIndex2 = 1500;
        this.closable = true;
        this.closeOnEscape = true;
        this.subscriptions = [];
        this.authenticated = false;
    }
    ngOnInit() {
        this.dwSecurityService.securityContextChanged().subscribe((context) => {
            if (this.authenticated && !this.dwSecurityService.securityState.isAuthenticated) {
                if (this.showModal) {
                    const result = new DwModalResult();
                    result.cancelled = true;
                    console.log('User Logged Out - Closing Modal');
                    this.closeModal(result);
                }
            }
            this.authenticated = this.dwSecurityService.securityState.isAuthenticated;
        });
    }
    ngAfterContentInit() {
        this.subscriptions.push(this.dwModalService.getModalConfigs()
            .subscribe(mc => {
            if (mc.length > 0) {
                this.modalConfig = mc[mc.length - 1];
                this.modalStyle = getModalStyle(this.modalConfig.modalSize, this.modalConfig.customModalWidth, this.modalConfig.customModalHeight);
                this.bodyStyle = getModalBodyStyle(this.modalConfig.modalSize, this.modalConfig.customModalWidth, this.modalConfig.customModalHeight);
                if (this.modalConfig.preventClose) {
                    this.closable = false;
                    this.closeOnEscape = false;
                }
                this.loadComponent();
                this.showModal = true;
            }
        }));
    }
    displayModal2() {
        this.showModal2 = true;
    }
    loadComponent() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        if (this.modalHandlerInstance) {
            this.unloadComponent();
        }
        this.clearViewContainerRef();
        // Ensure there is a component to create
        if (!this.modalConfig || !this.modalConfig.component) {
            return;
        }
        let componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.modalConfig.component);
        let componentRef = viewContainerRef.createComponent(componentFactory);
        this.modalHandlerInstance = componentRef.instance;
        this.modalHandlerInstance.modalConfig = this.modalConfig;
        if (this.modalHandlerInstance.closeModal) {
            this.subscriptions.push(this.modalHandlerInstance.closeModal.subscribe(result => {
                this.closeModal(result);
            }));
        }
        this.processing = false;
    }
    clearViewContainerRef() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        try {
            viewContainerRef.clear();
        }
        catch (e) {
            //console.error(e);
        }
    }
    unloadComponent() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        this.clearViewContainerRef();
        if (!this.modalHandlerInstance)
            return;
        if (this.modalHandlerInstance.ngOnDestroy) {
            this.modalHandlerInstance.ngOnDestroy();
        }
        this.modalHandlerInstance = null;
    }
    closeModal(result) {
        this.showModal = false;
        this.unloadComponent();
        this.dwModalService.closeModal(this.modalConfig, result);
    }
    changeVisible(visible) {
        if (!visible) {
            let result = new DwModalResult();
            result.cancelled = true;
            result.buttonCommand = DwButtonCommand.cancel;
            this.closeModal(result);
        }
    }
    buttonClick(buttonConfig) {
        // If a modal instance exists, delegate the button click to it
        if (this.modalHandlerInstance && this.modalHandlerInstance.buttonClick) {
            if (this.processing)
                return;
            this.processing = true;
            this.modalHandlerInstance.buttonClick(buttonConfig)
                .subscribe(r => {
                r.buttonCommand = r.buttonCommand || buttonConfig.command;
                if (r && r.closeModal) {
                    this.closeModal(r);
                }
                this.processing = false;
            }, e => {
                this.processing = false;
            });
        }
        else {
            //if no modalHanderInstance, handle the button click
            //  which always closes the modal
            let result = new DwModalResult();
            result.cancelled = buttonConfig.isCancel;
            result.buttonCommand = buttonConfig.command;
            this.closeModal(result);
        }
    }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwModalHostComponent.ɵfac = function DwModalHostComponent_Factory(t) { return new (t || DwModalHostComponent)(ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwSecurityStateService)); };
DwModalHostComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwModalHostComponent, selectors: [["dw-modal-host"]], viewQuery: function DwModalHostComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, inputs: { instanceNo: "instanceNo" }, decls: 16, vars: 29, consts: [[1, "dw-modal-backdrop2", 3, "ngClass"], ["autoZIndex", "false", "transitionOptions", "250ms cubic-bezier(0.25, 0.8, 0.25, 1)", "transitionOptions2", "0ms ease-in", "contentStyle2", "{'min-width':'50vw','max-height': '78vh'}", 1, "dw-modal", 3, "visible", "baseZIndex", "closable", "closeOnEscape", "keepInViewport", "blockScroll", "modal", "maximizable", "visibleChange"], [1, "dw-modal-content", 3, "ngStyle"], [3, "ngModel", 4, "ngIf"], ["dw-component-host", ""], [4, "ngIf"], ["autoZIndex", "false", "transitionOptions", "250ms cubic-bezier(0.25, 0.8, 0.25, 1)", "transitionOptions2", "0ms ease-in", "contentStyle2", "{'min-width':'50vw','max-height': '78vh'}", 1, "dw-modal", 3, "visible", "baseZIndex", "keepInViewport", "blockScroll", "modal", "maximizable", "visibleChange"], [3, "ngModel"], [4, "ngFor", "ngForOf"], [3, "buttonConfig", "click"]], template: function DwModalHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "p-dialog", 1);
        ɵngcc0.ɵɵlistener("visibleChange", function DwModalHostComponent_Template_p_dialog_visibleChange_2_listener($event) { return ctx.showModal = $event; })("visibleChange", function DwModalHostComponent_Template_p_dialog_visibleChange_2_listener($event) { return ctx.changeVisible($event); });
        ɵngcc0.ɵɵelementStart(3, "p-header");
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵtemplate(6, DwModalHostComponent_dw_html_view_6_Template, 1, 1, "dw-html-view", 3);
        ɵngcc0.ɵɵtemplate(7, DwModalHostComponent_ng_template_7_Template, 0, 0, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwModalHostComponent_p_footer_8_Template, 2, 1, "p-footer", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "p-dialog", 6);
        ɵngcc0.ɵɵlistener("visibleChange", function DwModalHostComponent_Template_p_dialog_visibleChange_9_listener($event) { return ctx.showModal2 = $event; })("visibleChange", function DwModalHostComponent_Template_p_dialog_visibleChange_9_listener($event) { return ctx.changeVisible($event); });
        ɵngcc0.ɵɵelementStart(10, "p-header");
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵtemplate(13, DwModalHostComponent_dw_html_view_13_Template, 1, 1, "dw-html-view", 3);
        ɵngcc0.ɵɵtemplate(14, DwModalHostComponent_ng_template_14_Template, 0, 0, "ng-template", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, DwModalHostComponent_p_footer_15_Template, 2, 1, "p-footer", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(27, _c24, ctx.showModal));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.modalStyle);
        ɵngcc0.ɵɵproperty("visible", ctx.showModal)("baseZIndex", ctx.baseZIndex)("closable", ctx.closable)("closeOnEscape", ctx.closeOnEscape)("keepInViewport", false)("blockScroll", true)("modal", true)("maximizable", ctx.modalConfig == null ? null : ctx.modalConfig.allowFullScreen);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.modalConfig == null ? null : ctx.modalConfig.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.bodyStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.modalConfig == null ? null : ctx.modalConfig.content);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.modalConfig == null ? null : ctx.modalConfig.hideFooter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ctx.modalStyle);
        ɵngcc0.ɵɵproperty("visible", ctx.showModal2)("baseZIndex", ctx.baseZIndex2)("keepInViewport", false)("blockScroll", true)("modal", true)("maximizable", ctx.modalConfig == null ? null : ctx.modalConfig.allowFullScreen);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.modalConfig == null ? null : ctx.modalConfig.title, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.bodyStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.modalConfig == null ? null : ctx.modalConfig.content);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.modalConfig == null ? null : ctx.modalConfig.hideFooter));
    } }, directives: function () { return [ɵngcc4.NgClass, ɵngcc15.Dialog, ɵngcc6.Header, ɵngcc4.NgStyle, ɵngcc4.NgIf, DwComponentHost, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.Footer, ɵngcc4.NgForOf, DwButtonComponent]; }, styles: [".dw-modal-backdrop[_ngcontent-%COMP%]{bottom:0;display:none;left:0;opacity:0;position:fixed;right:0;top:0;z-index:1020}.dw-modal-backup-show[_ngcontent-%COMP%]{display:block;opacity:1}.dw-modal-content[_ngcontent-%COMP%]{max-height:80vh;padding:3px}"] });
DwModalHostComponent.ctorParameters = () => [
    { type: DwModalService },
    { type: ComponentFactoryResolver },
    { type: DwSecurityStateService }
];
DwModalHostComponent.propDecorators = {
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }],
    instanceNo: [{ type: Input }]
};

var __decorate$a = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$9 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwButtonComponent {
    constructor() {
        this.disabled = false;
        this.middleclick = new EventEmitter();
        this.firing = false;
        this.showCaret = false;
    }
}
DwButtonComponent.ɵfac = function DwButtonComponent_Factory(t) { return new (t || DwButtonComponent)(); };
DwButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwButtonComponent, selectors: [["dw-button"]], inputs: { disabled: "disabled", firing: "firing", showCaret: "showCaret", buttonConfig: "buttonConfig" }, outputs: { middleclick: "middleclick" }, decls: 5, vars: 4, consts: [[3, "ngSwitch"], ["type", "button", 3, "class", "title", "disabled", "hidden", "middleclick", 4, "ngSwitchDefault"], [4, "ngSwitchCase"], ["type", "button", 3, "title", "disabled", "hidden", "middleclick"], [3, "class", 4, "ngIf"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw", 3, "hidden"], [1, "fa", "fa-caret-down", 3, "hidden"], [3, "class", "ngClass", 4, "ngIf"], [3, "ngClass"], [3, "title", "hidden", "ngClass"], ["href", "#", 3, "click"]], template: function DwButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0, 0);
        ɵngcc0.ɵɵtemplate(1, DwButtonComponent_button_1_Template, 6, 10, "button", 1);
        ɵngcc0.ɵɵtemplate(2, DwButtonComponent_span_2_Template, 5, 4, "span", 2);
        ɵngcc0.ɵɵtemplate(3, DwButtonComponent_span_3_Template, 3, 9, "span", 2);
        ɵngcc0.ɵɵtemplate(4, DwButtonComponent_span_4_Template, 5, 10, "span", 2);
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.buttonConfig == null ? null : ctx.buttonConfig.buttonType);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "iconOnly");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "iconOnlyNoText");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "link");
    } }, directives: function () { return [ɵngcc4.NgSwitch, ɵngcc4.NgSwitchDefault, ɵngcc4.NgSwitchCase, DwMiddleClickDirective, ɵngcc4.NgIf, ɵngcc4.NgClass]; }, encapsulation: 2 });
DwButtonComponent.propDecorators = {
    buttonConfig: [{ type: Input }],
    disabled: [{ type: Input }],
    middleclick: [{ type: Output, args: ['middleclick',] }],
    firing: [{ type: Input }],
    showCaret: [{ type: Input }]
};
__decorate$a([
    DwInputConverter(booleanConverter),
    __metadata$9("design:type", Object)
], DwButtonComponent.prototype, "showCaret", void 0);

class DwSecurityEmulationService {
    constructor(dwSecurityStateService, securityRepository, configService, securityUserService) {
        this.dwSecurityStateService = dwSecurityStateService;
        this.securityRepository = securityRepository;
        this.configService = configService;
        this.securityUserService = securityUserService;
    }
    emulateUser(userName, fullName) {
        this.dwSecurityStateService.startAuthenticating(`Emulating ${fullName}`, DwAuthenticationType.emulation);
        try {
            return this.securityRepository.emulatUser(userName)
                .pipe(tap(r => this.dwSecurityStateService.processSecurityResult(r)));
        }
        catch (e) {
            return this.handleExceptionResult(e);
        }
    }
    cancelEmulation() {
        this.dwSecurityStateService.startAuthenticating(`Cancelling Emulation`, DwAuthenticationType.cancelEmulation);
        try {
            return this.securityRepository.cancelEmulation()
                .pipe(tap(r => this.dwSecurityStateService.processSecurityResult(r)));
        }
        catch (e) {
            return this.handleExceptionResult(e);
        }
    }
    handleExceptionResult(e) {
        let resultSubject = new Subject();
        let result = new DwSecurityResult();
        result.success = false;
        result.message = `Emulation Error - ${e.message}`;
        return of(result);
    }
    isEmulating() {
        const securityState = this.dwSecurityStateService.securityState;
        const securityContext = securityState.securityContext;
        if (securityState.isAuthenticated && securityState.securityContext) {
            return securityContext.ApplicationUser.UserName != securityContext.AuthenticatedUser.UserName;
        }
        return false;
    }
    canEmulate() {
        return this.securityUserService.hasPermission(this.configService.coreConfig.securityConfig.canEmulatePermission);
    }
    findUsers(firstName, lastName, email, maxResults) {
        var searchCriteria = {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            MaxResults: maxResults
        };
        return this.securityRepository.findUsers(firstName, lastName, email, maxResults);
    }
}
DwSecurityEmulationService.ɵfac = function DwSecurityEmulationService_Factory(t) { return new (t || DwSecurityEmulationService)(ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwSecurityEmulationService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecurityEmulationService_Factory() { return new DwSecurityEmulationService(ɵɵinject(DwSecurityStateService), ɵɵinject(DwSecurityRepositoryServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwSecurityUserService)); }, token: DwSecurityEmulationService, providedIn: "root" });
DwSecurityEmulationService.ctorParameters = () => [
    { type: DwSecurityStateService },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityUserService }
];

class DwSecurityEmulationComponent {
    constructor(securityEmulationService, fb) {
        this.securityEmulationService = securityEmulationService;
        this.fb = fb;
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
        this.formGroup = this.fb.group({
            firstName: [null],
            lastName: [null],
            email: [null],
        });
    }
    buttonClick(buttonConfig) {
        // No button handling
        return of(null);
    }
    findUsers() {
        var filters = this.formGroup.value;
        this.securityEmulationService.findUsers(filters.firstName, filters.lastName, filters.email, 10)
            .subscribe(r => {
            this.users = r;
            this.message = null;
            if (this.users.length == 0) {
                this.message = {
                    messageBody: `No users found that you can emulate`,
                    severity: DwMessageSeverity.warning
                };
            }
        });
    }
    emulateUser(user) {
        this.securityEmulationService.emulateUser(user.UserName, `${user.FirstName} ${user.LastName}`)
            .subscribe(r => {
            if (r.success) {
                let result = new DwModalResult();
                result.cancelled = false;
                this.message = null;
                this.closeModal.emit(result);
            }
            else {
                this.message = {
                    messageBody: `Error emulating user ${user.FirstName} ${user.LastName}.  Error: ${r.message || 'Unknown'}`,
                    severity: DwMessageSeverity.error
                };
            }
        });
    }
}
DwSecurityEmulationComponent.ɵfac = function DwSecurityEmulationComponent_Factory(t) { return new (t || DwSecurityEmulationComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityEmulationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DwSecurityEmulationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityEmulationComponent, selectors: [["dw-security-emulation"]], decls: 25, vars: 3, consts: [[1, "emulation-box"], [3, "formGroup", "ngSubmit"], ["dwRow", ""], ["dwCol", "12"], ["formControlName", "firstName", "autofocus", "", 1, "form-control"], ["formControlName", "lastName", 1, "form-control"], ["formControlName", "email", 1, "form-control"], [1, "btn", "btn-success"], [3, "message"], [1, "search-results"], [1, "list-group"], ["class", "list-group-item", 4, "ngFor", "ngForOf"], [1, "list-group-item"], [1, "pull-right", "hand"], [3, "click"]], template: function DwSecurityEmulationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "form", 1);
        ɵngcc0.ɵɵlistener("ngSubmit", function DwSecurityEmulationComponent_Template_form_ngSubmit_1_listener() { return ctx.findUsers(); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵtext(5, "First Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelementStart(8, "div", 3);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Last Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "input", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "E-mail");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(16, "input", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 2);
        ɵngcc0.ɵɵelementStart(18, "div", 3);
        ɵngcc0.ɵɵelementStart(19, "button", 7);
        ɵngcc0.ɵɵtext(20, "Search");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(21, "dw-message", 8);
        ɵngcc0.ɵɵelementStart(22, "div", 9);
        ɵngcc0.ɵɵelementStart(23, "ul", 10);
        ɵngcc0.ɵɵtemplate(24, DwSecurityEmulationComponent_li_24_Template, 5, 3, "li", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.users);
    } }, directives: function () { return [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwMessageComponent, ɵngcc4.NgForOf]; }, styles: [".emulation-box[_ngcontent-%COMP%]{background:#fff;box-shadow:0 0 5px #ccc;margin:10px;max-width:690px;min-width:350px;padding:23px}.search-results[_ngcontent-%COMP%]{clear:left;margin-top:10px;max-height:200px;overflow:auto;width:100%}"] });
DwSecurityEmulationComponent.ctorParameters = () => [
    { type: DwSecurityEmulationService },
    { type: FormBuilder }
];

class DwSecurityAvatarComponent {
    constructor(dwUiConfig) {
        this.dwUiConfig = dwUiConfig;
        this.avatarUrl = dwUiConfig.defaultAvatarImageUrl || '/assets/img/user-loging.png';
    }
    ngOnInit() {
    }
}
DwSecurityAvatarComponent.ɵfac = function DwSecurityAvatarComponent_Factory(t) { return new (t || DwSecurityAvatarComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken)); };
DwSecurityAvatarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityAvatarComponent, selectors: [["dw-security-avatar"]], decls: 1, vars: 1, consts: [["alt", "Avatar", 1, "security-avatar", 3, "src"]], template: function DwSecurityAvatarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "img", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.avatarUrl, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: function () { return [DwMissingImageDirective]; }, encapsulation: 2 });
DwSecurityAvatarComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];

class DwSecurityInfoComponent {
    constructor(configService, securityService, securityEmulationService, securityOrchestrationService, uiConfig, dwModalSevice, _renderer, _element) {
        this.configService = configService;
        this.securityService = securityService;
        this.securityEmulationService = securityEmulationService;
        this.securityOrchestrationService = securityOrchestrationService;
        this.uiConfig = uiConfig;
        this.dwModalSevice = dwModalSevice;
        this._renderer = _renderer;
        this._element = _element;
        this.isAuthenticated = false;
        this.authenticatedUser = null;
        this.applicationUser = null;
        this.isEmulating = false;
        this.canEmulate = false;
        this.defaultAvatar = DwSecurityAvatarComponent;
        this.count = 1;
        this.securityInfoConfig = uiConfig.securityInfoConfig || {};
        this.securityInfoConfig.getNameDisplay = this.securityInfoConfig.getNameDisplay || this.getDefaultNameDisplay;
        this.securityInfoConfig.getAdditionalLine = this.securityInfoConfig.getAdditionalLine || (() => '');
    }
    ngAfterViewInit() {
        this.setupMenuClose();
    }
    setupMenuClose() {
        if (!this.dropDown) {
            return;
        }
        this.dropDown.isOpenChange.subscribe(isOpen => {
            setTimeout(() => {
                this.setupMenuEvents(isOpen);
            }, 100);
        });
    }
    setupMenuEvents(isOpen) {
        if (isOpen) {
            //console.log("Menu Opened");
            this.documentClickListener = this._renderer.listen('document', 'click', (e) => {
                if (e.dwPreventMenuClose) {
                    // e?.preventDefault();
                    return;
                }
                this.closeMenu(e);
            });
            this.documentEscListener = this._renderer.listen(this._element.nativeElement, 'keyup.esc', (e) => {
                this.closeMenu(e);
            });
        }
        else {
            //console.log("Menu Closed");
            if (this.documentClickListener) {
                this.documentClickListener();
            }
            if (this.documentEscListener) {
                this.documentEscListener();
            }
        }
    }
    meunClick(e) {
        // console.log("Menu Click", e);
    }
    closeMenu(e) {
        var _a, _b;
        //console.log("Close Menu", this.dropDown, e);
        if ((_a = this.dropDown) === null || _a === void 0 ? void 0 : _a.isOpen) {
            (_b = this.dropDown) === null || _b === void 0 ? void 0 : _b.toggle(false);
        }
    }
    getDefaultNameDisplay(authUser, emulating, config, nameOnly) {
        const currentUserDisplay = (authUser === null || authUser === void 0 ? void 0 : authUser.FirstNameLastName) || 'Anonymous';
        if (!nameOnly) {
            if (config.showWelcome) {
                return 'Welcome ' + currentUserDisplay;
            }
            if (emulating) {
                return 'Emulating ' + currentUserDisplay;
            }
        }
        return currentUserDisplay;
    }
    ngOnInit() {
        this.securityService.securityContextChanged()
            .subscribe(result => {
            this.setupSecurityInfo();
        });
        this.setupMenuClose();
    }
    setupSecurityInfo() {
        this.isAuthenticated = this.securityService.securityState.isAuthenticated;
        if (this.securityService.securityState.securityContext) {
            this.authenticatedUser = this.securityService.securityState.securityContext.AuthenticatedUser;
            this.applicationUser = this.securityService.securityState.securityContext.ApplicationUser;
        }
        else {
            this.authenticatedUser = null;
            this.applicationUser = null;
        }
        this.canEmulate = this.securityEmulationService.canEmulate();
        this.isEmulating = this.securityEmulationService.isEmulating();
        let obNameOnly = ensureObservable(this.securityInfoConfig.getNameDisplay(this.applicationUser, this.isEmulating, this.securityInfoConfig, false));
        let obFullName = ensureObservable(this.securityInfoConfig.getNameDisplay(this.applicationUser, this.isEmulating, this.securityInfoConfig, true));
        let obAdditionalLine = ensureObservable(this.securityInfoConfig.getAdditionalLine(this.applicationUser, this.isEmulating, this.securityInfoConfig));
        combineLatest([obNameOnly, obFullName, obAdditionalLine])
            .subscribe(([nameOnly, fullNameDsiplay, additionalLine]) => {
            this.fullNameDisplay = nameOnly;
            this.addionalLine = additionalLine;
            this.authenticateNameDisplay = fullNameDsiplay;
        });
        // ob.subscribe(fullNameDisplay => {
        //     this.fullNameDisplay = fullNameDisplay;
        // });
        // let ob2 = this.securityInfoConfig.getNameDisplay(this.authenticatedUser, this.isEmulating, this.securityInfoConfig, true);
        // if (!(ob2 instanceof Observable)) {
        //     ob2 = of(ob2);
        // }
        // ob2.subscribe(fullNameDisplay => {
        // });
    }
    logout() {
        this.securityOrchestrationService.logout("Logging you out", "User initiated Logout");
    }
    login() {
        this.securityOrchestrationService.gotoLogin();
    }
    showEmulateSelection() {
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Emulation Search";
        modalConfig.component = DwSecurityEmulationComponent;
        /* modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = '600px';
        modalConfig.customModalHeight = '900px'; */
        this.dwModalSevice.showModal(modalConfig)
            .subscribe(r => {
            if (!r.cancelled) {
                // Need to refresh security since Emulation has started
            }
        });
    }
    cancelEmulation() {
        this.securityEmulationService.cancelEmulation()
            .subscribe(r => {
            // Emulation has been cancelled
        });
    }
    gotoUserProfile() {
        this.securityOrchestrationService.gotoUserProfile();
    }
}
DwSecurityInfoComponent.ɵfac = function DwSecurityInfoComponent_Factory(t) { return new (t || DwSecurityInfoComponent)(ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwSecurityEmulationService), ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwSecurityInfoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityInfoComponent, selectors: [["dw-security-info"]], viewQuery: function DwSecurityInfoComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BsDropdownDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropDown = _t.first);
    } }, decls: 3, vars: 2, consts: [[1, "security-info"], ["class2", "security-info", 4, "ngIf"], ["class2", "security-info"], [1, "nav", "navbar-nav", "ml-auto"], ["dropdown", "", "placement", "bottom right", 1, "nav-item", "dropdown", 3, "autoClose"], ["dropDown", ""], ["data-toggle", "dropdown", "href", "#", "role", "button", "aria-haspopup", "true", "aria-expanded", "false", "dropdownToggle", "", 1, "nav-link", 3, "click"], ["componentName", "securityAvatar", 3, "component"], [1, "user-info-detail"], [1, "fa", "fa-chevron-down", "pull-right"], ["class", "dropdown-menu dropdown-menu-right", "aria-labelledby", "simple-dropdown", 3, "click", 4, "dropdownMenu"], [1, "user-info-additional-detail"], ["aria-labelledby", "simple-dropdown", 1, "dropdown-menu", "dropdown-menu-right", 3, "click"], [1, "dropdown-header"], ["class", "dropdown-item  hand", 3, "click", 4, "ngIf"], ["class", "dropdown-item hand", 3, "click", 4, "ngIf"], [1, "divider"], [1, "dropdown-item", "hand", 3, "click"], [1, "fa", "fa-sign-out"], [1, "fa", "fa-user-friends"], [1, "fa", "fa-user-slash"], [1, "security-login-link", 3, "click"], [1, "fa", "fa-power-off"]], template: function DwSecurityInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwSecurityInfoComponent_div_1_Template, 13, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwSecurityInfoComponent_div_2_Template, 4, 0, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAuthenticated);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAuthenticated);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc16.BsDropdownDirective, ɵngcc16.BsDropdownToggleDirective, DwDynamicLoaderComponent, ɵngcc16.BsDropdownMenuDirective, DwSecurityUserMenuComponent]; }, encapsulation: 2 });
DwSecurityInfoComponent.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityUserService },
    { type: DwSecurityEmulationService },
    { type: DwSecurityOrchestrationService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwModalService },
    { type: Renderer2 },
    { type: ElementRef }
];
DwSecurityInfoComponent.propDecorators = {
    dropDown: [{ type: ViewChild, args: [BsDropdownDirective,] }]
};

class DwActionHostComponent {
    constructor(resolver) {
        this.resolver = resolver;
    }
    executeAction(actionHandler, actionState) {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        if (!actionHandler || !actionHandler.actionComponent) {
            throw new Error("Action handler must have a compoent defined");
        }
        const componentFactory = this.resolver.resolveComponentFactory(actionHandler.actionComponent);
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        let componentRef = viewContainerRef.createComponent(componentFactory);
        let componentInstance = componentRef.instance;
        if (!componentInstance || !componentInstance.handleAction) {
            throw new Error("Action handler component must implement the DwActionHandler interface and have an executeAction method defined");
        }
        let actionSubject = new Subject();
        componentInstance.handleAction(actionState)
            .subscribe(r => {
            actionSubject.next(r);
            viewContainerRef.clear();
            if (componentInstance.destroy) {
                componentInstance.destroy();
            }
            componentRef.destroy();
        });
        return actionSubject.asObservable();
    }
}
DwActionHostComponent.ɵfac = function DwActionHostComponent_Factory(t) { return new (t || DwActionHostComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
DwActionHostComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwActionHostComponent, selectors: [["dw-action-host"]], viewQuery: function DwActionHostComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, decls: 1, vars: 0, consts: [["dw-component-host", ""]], template: function DwActionHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwActionHostComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [DwComponentHost], encapsulation: 2 });
DwActionHostComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver }
];
DwActionHostComponent.propDecorators = {
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }]
};

class DwModal {
    constructor() {
        this.subscriptions = [];
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwModal.ɵfac = function DwModal_Factory(t) { return new (t || DwModal)(); };
DwModal.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwModal, selectors: [["dw-modal"]], decls: 26, vars: 0, consts: [["id", "myModal", "tabindex", "-1", "role", "dialog", "aria-labelledby", "myModalLabel", 1, "modal"], ["role", "document", 1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], ["id", "myModalLabel", 1, "modal-title"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", 1, "close"], ["aria-hidden", "true"], [1, "modal-body"], [1, "form-group"], ["for", "recipient-name", 1, "control-label"], ["type", "text", "id", "recipient-name", 1, "form-control"], ["for", "message-text", 1, "control-label"], ["id", "message-text", 1, "form-control"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-default"], ["type", "button", 1, "btn", "btn-primary"]], template: function DwModal_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtext(1, " Modal content: ");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "h4", 4);
        ɵngcc0.ɵɵtext(7, "Modal title");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "button", 5);
        ɵngcc0.ɵɵelementStart(9, "span", 6);
        ɵngcc0.ɵɵtext(10, "\u00D7");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "form");
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelementStart(14, "label", 9);
        ɵngcc0.ɵɵtext(15, "Recipient:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(16, "input", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 8);
        ɵngcc0.ɵɵelementStart(18, "label", 11);
        ɵngcc0.ɵɵtext(19, "Message:");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(20, "textarea", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 13);
        ɵngcc0.ɵɵelementStart(22, "button", 14);
        ɵngcc0.ɵɵtext(23, "Close");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "button", 15);
        ɵngcc0.ɵɵtext(25, "Save changes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm], styles: [".modal[_ngcontent-%COMP%] {\n            display:unset;\n            top:unset;\n            bottom:unset;\n        }\n        .close[_ngcontent-%COMP%] {\n            margin-top:-30px;\n            margin-right:-25px;\n        }"] });
DwModal.ctorParameters = () => [];

class DwHtmlViewComponent extends DwControlBaseComponent {
    constructor(sanitizer, cdr) {
        super();
        this.sanitizer = sanitizer;
        this.cdr = cdr;
        this.missingDataText = '';
    }
    getSanitizedHtml() {
        if (this.value) {
            return this.sanitizer.bypassSecurityTrustHtml(this.value);
        }
        return this.missingDataText;
    }
    translateTo(value) {
        setTimeout(() => {
            this.cdr.detectChanges();
        });
        return this.getSanitizedHtml();
    }
    ngOnChanges(changes) {
        // if (!changes.html.firstChange) {
        //   this.html = this.getSanitizedHtml();
        //   this.cdr.detectChanges();
        // }
    }
    ngOnInit() {
        this.html = this.getSanitizedHtml();
    }
}
DwHtmlViewComponent.ɵfac = function DwHtmlViewComponent_Factory(t) { return new (t || DwHtmlViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc17.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwHtmlViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwHtmlViewComponent, selectors: [["dw-html-view"]], inputs: { missingDataText: "missingDataText" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwHtmlViewComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[1, "htmlContainer", 3, "innerHTML"]], template: function DwHtmlViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHTML", ctx.translatedValue, ɵngcc0.ɵɵsanitizeHtml);
    } }, styles: [".htmlContainer p{margin-bottom:0}"], encapsulation: 2 });
DwHtmlViewComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: ChangeDetectorRef }
];
DwHtmlViewComponent.propDecorators = {
    missingDataText: [{ type: Input }]
};

class DwDataPageInfo {
    constructor() {
        this.pageNo = 1;
        this.pageSize = 50;
    }
}

class DwDataRequest {
    constructor() {
        this.pageInfo = new DwDataPageInfo();
        this.sorting = [];
    }
}

class DwCardItemDirective {
}
DwCardItemDirective.ɵfac = function DwCardItemDirective_Factory(t) { return new (t || DwCardItemDirective)(); };
DwCardItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwCardItemDirective, selectors: [["", "dwCardItem", ""]] });

class DwListItemDirective {
}
DwListItemDirective.ɵfac = function DwListItemDirective_Factory(t) { return new (t || DwListItemDirective)(); };
DwListItemDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwListItemDirective, selectors: [["", "dwListItem", ""]] });

class DwDataListConfig {
    constructor() {
        this.showActions = false;
        this.autoFilter = true;
        this.autoFilterDelay = 200;
        this.hideRefresh = false;
        this.hideViewToggle = false;
    }
}

class DwNoItemsDirective {
}
DwNoItemsDirective.ɵfac = function DwNoItemsDirective_Factory(t) { return new (t || DwNoItemsDirective)(); };
DwNoItemsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwNoItemsDirective, selectors: [["", "dwNoItems", ""]] });

var DwListViewMode;
(function (DwListViewMode) {
    DwListViewMode["card"] = "card";
    DwListViewMode["list"] = "list";
})(DwListViewMode || (DwListViewMode = {}));

class DwDataListComponent {
    constructor(dwUiConfigRegistryService) {
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.config = new DwDataListConfig();
        this.actionClick = new EventEmitter();
        this.dataLoadComplete = new EventEmitter();
        this.mode = DwListViewMode.list;
        this.displayCount = 5;
        this.showNoItemsMessage = true;
        this.isLoading = true;
        this.initialLoadComplete = false;
        this.showFilterSection = false;
        this.displayedData = [];
        this.loadedData = [];
        this.defaultPageSize = 100;
        this.defaultDisplayPageSize = 50;
        this.pageInfo = new DwDataPageReturnInfo();
        this.autoFilterSubject = new Subject();
        this.modes = [];
        this.modes.push({ value: 'card', icon: 'fa fa-th' });
        this.modes.push({ value: 'list', icon: 'fa fa-bars' });
    }
    actionPrefClicked(actionEvent) {
        this.actionClick.emit(actionEvent);
    }
    get filters() {
        return this._filters;
    }
    set filters(value) {
        this._filters = value;
        this.autoFilterSubject.next(value);
    }
    ngOnInit() {
        // this.loadData();
        this.initDataList();
        this.autoFilterSubject.asObservable()
            .pipe(debounceTime(this.config.autoFilterDelay))
            .subscribe(filters => {
            //console.log("Filters", filters);
            if (this.config && this.config.autoFilter)
                this.applyFilters(filters);
        });
    }
    setupStyling() {
        if (!this.config) {
            return;
        }
        let styleName = this.config.listStyleName || '';
        this.styles = Object.assign({}, this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.listStyles, styleName));
        if (this.config.listClass) {
            this.styles.containerClass = this.config.listClass + ' ' + this.styles.containerClass;
        }
    }
    ngAfterContentInit() {
        /*   if (!this.noItemsTemplate) {
              this.showNoItemsMessage = true;
          } */
    }
    initDataList() {
        if (!this.config)
            return;
        if (this.config.showFilter) {
            this.showFilterSection = this.config.showFilterOnLoad;
        }
        else {
            this.showFilterSection = false;
        }
        this.setupStyling();
    }
    toggleFilter() {
        this.showFilterSection = !this.showFilterSection;
    }
    refreshData() {
        /* this.loadedData=[];
        this.displayedData=[]; */
        this.pageInfo = new DwDataPageReturnInfo();
        this.pageInfo.currentPageNo = 1;
        this.loadData(true);
    }
    getMode() {
        return this.mode;
    }
    setMode(mode) {
        this.mode = mode;
    }
    applyFilters(filters) {
        this.pageInfo.currentPageNo = 1;
        this.loadData();
    }
    getFilters() {
        return this.filters;
    }
    ngOnChanges(changes) {
        if (changes.data && !changes.data.firstChange) {
            this.pageInfo.currentPageNo = 1;
            this.loadData(true);
        }
        if (changes.config && !changes.config.firstChange) {
            this.initDataList();
        }
    }
    onScroll() {
        if (this.displayedData.length < this.loadedData.length) {
            Array.prototype.push.apply(this.displayedData, this.getArrayPage(this.loadedData, this.displayedData.length, this.config.displayPageSize || this.defaultDisplayPageSize));
        }
        else {
            // If we have the exact number of records for the current pages, then we might have more rows (only causes 1 more fetch when count is a multiple of 50, but saves overhead on all queries since we don't need to load the record count)
            // if (this.loadedData.length % this.pageSize == 0) {
            //     this.pageInfo.currentPageNo += 1;
            //     this.loadData();
            // }
            if (this.pageInfo.totalPageCount > this.pageInfo.currentPageNo) {
                this.pageInfo.currentPageNo += 1;
                this.loadData(true);
            }
        }
    }
    getArrayPage(data, startIndex, pageSize) {
        return [...data].splice(startIndex, pageSize);
    }
    loadData(forceRefresh = false) {
        // Check if filters have truly changes
        if (!forceRefresh && areEqual(this.lastLoadedFilters, this.filters)) {
            return;
        }
        this.lastLoadedFilters = deepCopy(this.filters);
        if (this.isDataSource(this.data)) {
            const dataRequest = new DwDataRequest();
            dataRequest.filters = this.filters;
            dataRequest.pageInfo = new DwDataPageInfo();
            dataRequest.pageInfo.pageNo = this.pageInfo.currentPageNo || 1;
            dataRequest.pageInfo.pageSize = this.config.loadPageSize || this.defaultPageSize;
            this.isLoading = true;
            this.data.requestData(dataRequest)
                .subscribe(r => {
                this.handleLoadedData(r);
                this.onScroll();
                this.isLoading = false;
            });
        }
        else {
            this.loadedData = this.data || [];
            this.dataLoadComplete.emit(this.data);
            this.initialLoadComplete = true;
        }
    }
    handleLoadedData(pageResults) {
        if (pageResults.pageInfo.currentPageNo == 1) {
            // Clear data when re-loading page 1 (for a filter more likely)
            this.loadedData.length = 0;
            this.displayedData.length = 0;
            this.pageInfo.totalPageCount = 1;
        }
        Array.prototype.push.apply(this.loadedData, pageResults.data);
        if (pageResults instanceof DwDataPageResults) {
            if (pageResults.pageInfo) {
                if (pageResults.pageInfo.totalPageCount) {
                    this.pageInfo.totalPageCount = pageResults.pageInfo.totalPageCount;
                    this.pageInfo.totalRecordCount = pageResults.pageInfo.totalRecordCount;
                }
                if (pageResults.pageInfo.currentPageNo == this.pageInfo.totalPageCount) {
                    this.lastRow = this.pageInfo.totalRecordCount;
                }
                // If we have the exact number of records for the current pages, then we might have more rows (only causes 1 more fetch when count is a multiple of 50, but saves overhead on all queries since we don't need to load the record count)
                if (pageResults.data.length > 0 && pageResults.data.length % pageResults.pageInfo.currentPageSize == 0) {
                    this.pageInfo.totalPageCount = pageResults.pageInfo.currentPageNo + 1;
                }
            }
        }
        else {
            this.lastRow = this.loadedData.length;
        }
        this.dataLoadComplete.emit(this.loadedData);
        this.initialLoadComplete = true;
    }
    // Type gaurd for data source
    isDataSource(data) {
        if (data && data.requestData)
            return true;
        return false;
    }
}
DwDataListComponent.ɵfac = function DwDataListComponent_Factory(t) { return new (t || DwDataListComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwDataListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDataListComponent, selectors: [["dw-data-list"]], contentQueries: function DwDataListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwCardItemDirective, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwListItemDirective, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwNoItemsDirective, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cardItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.noItemsTemplate = _t.first);
    } }, inputs: { config: "config", mode: "mode", displayCount: "displayCount", defaultPageSize: "defaultPageSize", defaultDisplayPageSize: "defaultDisplayPageSize", filters: "filters", data: "data", cardContext: "cardContext", actionContext: "actionContext" }, outputs: { actionClick: "actionClick", dataLoadComplete: "dataLoadComplete" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c27, decls: 15, vars: 14, consts: [[3, "ngClass"], [3, "ngClass", 4, "ngIf"], ["infiniteScroll", "", 3, "infiniteScrollDistance", "infiniteScrollThrottle", "scrolled"], [2, "width", "100%"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngIf"], ["text", "Loading", 3, "show"], ["useContainerStyle", "true", 3, "actionPreferences", "actionContext", "actionClick"], [3, "onsubmit"], ["class", "row2", 4, "ngIf"], [1, "row2"], ["type", "submit", 1, "btn", "btn-success", 3, "click"], [1, "dw-grid-buttons-left"], ["class", "dw-section-container-header", 4, "ngIf"], ["useContainerStyle", "false", 3, "actionPreferences", "actionContext", "actionClick"], [1, "dw-grid-buttons-right"], [1, "dw-section-container-header"], [1, "row"], [4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function DwDataListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c26);
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtemplate(2, DwDataListComponent_div_2_Template, 2, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DwDataListComponent_div_3_Template, 7, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(4, DwDataListComponent_div_4_Template, 6, 6, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵlistener("scrolled", function DwDataListComponent_Template_div_scrolled_6_listener() { return ctx.onScroll(); });
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵelement(8, "div", 3);
        ɵngcc0.ɵɵelementContainerStart(9, 4);
        ɵngcc0.ɵɵtemplate(10, DwDataListComponent_ng_container_10_Template, 3, 1, "ng-container", 5);
        ɵngcc0.ɵɵtemplate(11, DwDataListComponent_ng_container_11_Template, 3, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DwDataListComponent_div_12_Template, 3, 5, "div", 6);
        ɵngcc0.ɵɵelement(13, "dw-loading", 7);
        ɵngcc0.ɵɵelementStart(14, "dw-action-bar", 8);
        ɵngcc0.ɵɵlistener("actionClick", function DwDataListComponent_Template_dw_action_bar_actionClick_14_listener($event) { return ctx.actionPrefClicked($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styles == null ? null : ctx.styles.containerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.config == null ? null : ctx.config.showHeader) && (!(ctx.config == null ? null : ctx.config.showActions) || ctx.showFilterSection));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showFilterSection);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.showActions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.styles == null ? null : ctx.styles.bodyClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("infiniteScrollDistance", 2)("infiniteScrollThrottle", 50);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.mode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "card");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "list");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isLoading && (!ctx.displayedData || ctx.displayedData.length == 0));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("show", ctx.isLoading && !(ctx.config == null ? null : ctx.config.hideLoading));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("actionPreferences", ctx.config == null ? null : ctx.config.actionPreferencesByMode == null ? null : ctx.config.actionPreferencesByMode.actionBarBottom)("actionContext", ctx.actionContext);
    } }, directives: function () { return [ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc18.InfiniteScrollDirective, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, DwLoadingComponent, DwActionBarComponent, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm, ɵngcc4.NgForOf, ɵngcc4.NgTemplateOutlet]; }, styles: [".row[_ngcontent-%COMP%]{margin-left:0;margin-right:0}"] });
DwDataListComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
DwDataListComponent.propDecorators = {
    data: [{ type: Input }],
    config: [{ type: Input }],
    cardContext: [{ type: Input }],
    actionContext: [{ type: Input }],
    actionClick: [{ type: Output }],
    dataLoadComplete: [{ type: Output }],
    mode: [{ type: Input }],
    displayCount: [{ type: Input }],
    filters: [{ type: Input }],
    cardItemTemplate: [{ type: ContentChild, args: [DwCardItemDirective, { static: true, read: TemplateRef },] }],
    listItemTemplate: [{ type: ContentChild, args: [DwListItemDirective, { static: true, read: TemplateRef },] }],
    noItemsTemplate: [{ type: ContentChild, args: [DwNoItemsDirective, { static: true, read: TemplateRef },] }],
    defaultPageSize: [{ type: Input }],
    defaultDisplayPageSize: [{ type: Input }]
};

var __decorate$b = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$a = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const moment$8 = moment_;
class DwReadOnlyControlComponent extends DwControlBaseComponent {
    constructor(sanitizer) {
        super();
        this.sanitizer = sanitizer;
        this.missingDataText = 'None';
        this.use24HourTime = true;
    }
    getSanitizedHtml() {
        if (this.value) {
            return this.sanitizer.bypassSecurityTrustHtml(this.value);
        }
        return "";
    }
    translateTo(value) {
        let tempValue = value;
        if (this.formatType) {
            switch (this.formatType) {
                case DwFormatTypes.date:
                    tempValue = this.formatDate(this.value, 'MM/DD/YYYY');
                    break;
                case DwFormatTypes.datetime:
                    if (this.useGmtDateTime) {
                        tempValue = formatDateTimeToLocal(this.value, true, !this.use24HourTime);
                    }
                    else {
                        tempValue = formatDateTime(this.value, true, !this.use24HourTime);
                    }
                    break;
                case DwFormatTypes.yesNo:
                    if (this.value) {
                        tempValue = 'Yes';
                    }
                    else {
                        tempValue = 'No';
                    }
                    break;
            }
        }
        if (!tempValue && tempValue !== false) {
            return this.missingDataText;
        }
        if (typeof tempValue === 'string') {
            tempValue = tempValue.replace(new RegExp('\n', 'g'), "<br />");
        }
        return tempValue;
    }
    formatDate(value, format) {
        if (!value)
            return "";
        return moment$8(value).format(format);
    }
}
DwReadOnlyControlComponent.ɵfac = function DwReadOnlyControlComponent_Factory(t) { return new (t || DwReadOnlyControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc17.DomSanitizer)); };
DwReadOnlyControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwReadOnlyControlComponent, selectors: [["dw-readonly"]], inputs: { missingDataText: "missingDataText", use24HourTime: "use24HourTime", formatType: "formatType", useGmtDateTime: "useGmtDateTime" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwReadOnlyControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[1, "read-only", 3, "innerHtml"]], template: function DwReadOnlyControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHtml", ctx.translatedValue, ɵngcc0.ɵɵsanitizeHtml);
    } }, encapsulation: 2 });
DwReadOnlyControlComponent.ctorParameters = () => [
    { type: DomSanitizer }
];
DwReadOnlyControlComponent.propDecorators = {
    formatType: [{ type: Input }],
    missingDataText: [{ type: Input }],
    useGmtDateTime: [{ type: Input }],
    use24HourTime: [{ type: Input }]
};
__decorate$b([
    DwInputConverter(booleanConverter),
    __metadata$a("design:type", Boolean)
], DwReadOnlyControlComponent.prototype, "useGmtDateTime", void 0);
__decorate$b([
    DwInputConverter(booleanConverter),
    __metadata$a("design:type", Boolean)
], DwReadOnlyControlComponent.prototype, "use24HourTime", void 0);

var __decorate$c = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$b = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwRouterParentComponent {
    constructor(activatedRoute) {
        this.activatedRoute = activatedRoute;
        this.useIf = false;
        this.useModalOutlet = false;
        this.outletName = 'UnnamedOutlet';
        this.activated = new EventEmitter();
        this.reactivated = new EventEmitter();
        this.hasBeenLoaded = false;
        this.childRouteActivated = false;
        this.loadContent = false;
        let styleParts = '';
        activatedRoute.snapshot.pathFromRoot.forEach((snapshot) => {
            if (snapshot.url.length >= 1) {
                styleParts = styleParts + '-' + snapshot.url[0].path; //(u => u.path).join('-');
            }
        });
        this.pageStyleName = "dw-page" + styleParts;
        this.pageSyleNameInner = "dw-page-inner" + styleParts;
        // activatedRoute.snapshot.url.forEach((url) => {
        //     this.pageStyleName = this.pageStyleName + '-' + url.path;
        // });            
    }
    ngOnInit() {
        this.childRouteActivated = this.isChildRouteActivated();
        this.loadContent = this.getloadContent();
    }
    toggleActivate(activated) {
        this.childRouteActivated = activated;
        this.loadContent = this.getloadContent();
    }
    // Determine if content should be loaded based on if the router is not active (meaning there are no child routes)
    //   Or if the control has already been loaded once (this keeps a component loaded with it's state while in a parent route)
    getloadContent() {
        if (!this.childRouteActivated) {
            if (!this.hasBeenLoaded) {
                this.hasBeenLoaded = true;
                // Only call activate once
                setTimeout(() => this.activated.emit(null));
            }
            else {
                setTimeout(() => this.reactivated.emit(null));
            }
        }
        return this.hasBeenLoaded;
    }
    isChildRouteActivated() {
        if (this.useModalOutlet) {
            return false;
        }
        return this.activatedRoute.snapshot.children.length > 0;
    }
}
DwRouterParentComponent.ɵfac = function DwRouterParentComponent_Factory(t) { return new (t || DwRouterParentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute)); };
DwRouterParentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouterParentComponent, selectors: [["dw-router-parent"]], contentQueries: function DwRouterParentComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, TemplateRef, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
    } }, inputs: { useIf: "useIf", useModalOutlet: "useModalOutlet", outletName: "outletName" }, outputs: { activated: "activated", reactivated: "reactivated" }, decls: 4, vars: 4, consts: [[3, "ngClass"], [3, "hidden", "ngClass", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [4, "ngIf"], [3, "hidden", "ngClass"], [4, "ngTemplateOutlet"], [3, "activate", "deactivate"], ["myOutlet", "outlet"]], template: function DwRouterParentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwRouterParentComponent_div_1_Template, 2, 3, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwRouterParentComponent_div_2_Template, 2, 2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DwRouterParentComponent_ng_container_3_Template, 3, 0, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.pageStyleName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadContent && !ctx.useIf);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadContent && ctx.useIf && !ctx.childRouteActivated);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.useModalOutlet);
    } }, directives: [ɵngcc4.NgClass, ɵngcc4.NgIf, ɵngcc4.NgTemplateOutlet, ɵngcc2.RouterOutlet], encapsulation: 2 });
DwRouterParentComponent.ctorParameters = () => [
    { type: ActivatedRoute }
];
DwRouterParentComponent.propDecorators = {
    useIf: [{ type: Input }],
    useModalOutlet: [{ type: Input }],
    outletName: [{ type: Input }],
    activated: [{ type: Output }],
    reactivated: [{ type: Output }],
    templateRef: [{ type: ContentChild, args: [TemplateRef, { static: true },] }]
};
__decorate$c([
    DwInputConverter(booleanConverter),
    __metadata$b("design:type", Object)
], DwRouterParentComponent.prototype, "useIf", void 0);
__decorate$c([
    DwInputConverter(booleanConverter),
    __metadata$b("design:type", Object)
], DwRouterParentComponent.prototype, "useModalOutlet", void 0);

function DwValidationRule(validationRuleDef) {
    return function (component) {
        let validationRuleRegistration = Object.assign(Object.assign({}, validationRuleDef), { component: component });
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerItem(DwUiRegistryType.validationRule, validationRuleRegistration);
    };
}

function CreateTag(tagName, display) {
    return {
        tag: tagName,
        display: display
    };
}
var DwValidationStandardTagNames;
(function (DwValidationStandardTagNames) {
    DwValidationStandardTagNames["displayName"] = "displayName";
    DwValidationStandardTagNames["value"] = "value";
})(DwValidationStandardTagNames || (DwValidationStandardTagNames = {}));
const DwValidationStandardTags = [
    {
        tag: DwValidationStandardTagNames.displayName,
        display: 'Field Display'
    },
    {
        tag: DwValidationStandardTagNames.value,
        display: 'Value'
    }
];

var DwValidationItemType;
(function (DwValidationItemType) {
    DwValidationItemType["formControl"] = "formControl";
    DwValidationItemType["formGroup"] = "formGroup";
    DwValidationItemType["formArray"] = "formArray";
    DwValidationItemType["childGrid"] = "childGrid";
})(DwValidationItemType || (DwValidationItemType = {}));

class DwValidationRuleBase {
    buildError(error, displayName, isSubmitted, messageTemplate) {
        const tagValues = this.buildTagsValues(error, displayName);
        messageTemplate = this.getMessageTemplate(error, displayName, isSubmitted, messageTemplate);
        const config = error.config || {};
        // if (config.overrideMessage) {
        //     messageTemplate = config.message;
        // }
        const finalMessage = processTemplate(messageTemplate, tagValues);
        return finalMessage;
    }
    buildTagsValues(error, displayName) {
        const tagValues = new Map();
        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;
        return tagValues;
    }
    getMessageTemplate(error, displayName, isSubmitted, messageTemplate) {
        const config = (error === null || error === void 0 ? void 0 : error.config) || {};
        if (config.overrideMessage) {
            return config.message;
        }
        return messageTemplate;
    }
}

var __decorate$d = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const errorProperty = 'invalidDate';
var DwDateTags;
(function (DwDateTags) {
    DwDateTags["daysOfWeek"] = "daysOfWeek";
})(DwDateTags || (DwDateTags = {}));
let DwDateValidationRule = class DwDateValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidateDate(config);
    }
    buildTagsValues(error, displayName) {
        var _a, _b;
        const tagValues = super.buildTagsValues(error, displayName);
        tagValues[DwDateTags.daysOfWeek] = this.getDaysOfWeekDisplay((_b = (_a = error.config) === null || _a === void 0 ? void 0 : _a.dateOptions) === null || _b === void 0 ? void 0 : _b.validDays);
        return tagValues;
    }
    getDaysOfWeekDisplay(days) {
        const dayValues = [];
        for (let dayIndex = 0; dayIndex < days.length; dayIndex++) {
            if (days[dayIndex]) {
                dayValues.push(getDayOfWeekDisplay(dayIndex));
            }
        }
        if (dayValues.length == 1) {
            return `Day of week must be a ${dayValues[0]}`;
        }
        return `Valid days are ${dayValues.join(',')}`;
    }
};
DwDateValidationRule.ɵfac = function DwDateValidationRule_Factory(t) { return ɵDwDateValidationRule_BaseFactory(t || DwDateValidationRule); };
DwDateValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwDateValidationRule, factory: function (t) { return DwDateValidationRule.ɵfac(t); } });
DwDateValidationRule = __decorate$d([
    DwValidationRule({
        keyName: DwFormValidators.date,
        display: 'Date Validator',
        errorType: errorProperty,
        validationItemType: DwValidationItemType.formControl,
        messageTemplate: `Invalid day of week selected.  [${DwDateTags.daysOfWeek}]`,
        tags: [
            ...DwValidationStandardTags,
            { tag: DwDateTags.daysOfWeek, display: 'Days of week' },
        ]
    })
], DwDateValidationRule);
/* export class DwDateValidationErrorBuilder implements DwValidationErrorBuilder<DwDateValidationConfig> {
    buildError(error: DwValidationError<DwDateValidationConfig>, displayName: string, isSubmitted: boolean,) {
        const tagValues = new Map<string, string>();

        error.config = error.config || {} as any;

        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;
        tagValues[DwDateTags.daysOfWeek] = this.getDaysOfWeekDisplay(error.config?.dateOptions?.validDays);

        let messageTemplate= `Invalid day of week selected.  [daysOfWeek]`;

        if (error.config.overrideMessage) {
            messageTemplate = error.config.message;
        }
        
        const finalMessage = processTemplate(messageTemplate, tagValues)

        return finalMessage;
    }

    createValidator(config?: DwDateValidationConfig) {
        return DwValidateDate(config);
    }
   
} */
function DwValidateDate(dateValidationConfig) {
    return (control) => {
        if (!control.value || !dateValidationConfig.dateOptions) {
            return;
        }
        if (dateValidationConfig.dateOptions.validDaysSet) {
            const dayOfWeek = getDayOfWeek(control.value, dateValidationConfig.useGmtDateTime);
            if (!dateValidationConfig.dateOptions.validDays[dayOfWeek]) {
                const result = {};
                result[errorProperty] = {
                    value: control.value,
                    config: dateValidationConfig
                };
                return result;
            }
        }
        return null;
    };
}

var __decorate$e = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$c = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwDateInputControlComponent extends DwControlBaseComponent {
    constructor(controlContainer) {
        super();
        this.controlContainer = controlContainer;
        this.useGmtDateTime = false;
        this.todayStyle = '';
        this.hourFormat = '12';
        this.showTime = false;
        this.timeOnly = false;
        this.use24HourTime = false;
        this.monthsToShow = 1;
    }
    ngOnChanges(changes) {
        if (changes.use24HourTime) {
            this.setup24HourTime(this.use24HourTime);
        }
        if (changes.timeOnly) {
            this.setupTimeStyle(this.timeOnly);
        }
        if (changes.dateOptions) {
            this.setupDateOptions();
        }
    }
    setupDateOptions() {
        if (!this.dateOptions) {
            return;
        }
        if (this.dateOptions.validDaysSet && this.dateOptions.validDays) {
            this.disabledDays = [];
            for (let i = 0; i < 7; i++) {
                if (this.dateOptions.validDays[i] === false) {
                    this.disabledDays.push(i);
                }
            }
        }
        this.monthsToShow = 1;
        if (this.dateOptions.monthsToShow > 0) {
            this.monthsToShow = this.dateOptions.monthsToShow;
        }
        this.setupDateValidators();
    }
    // Always setup a date/time validator if it doesn't already exist
    setupDateValidators() {
        if (!this.controlContainer) {
            return;
        }
        const formControl = this.controlContainer.control.get(this.formControlName);
        if (formControl) {
            let validators = [];
            // Esnure existing validators is an array
            if (formControl.validator) {
                validators = Array.isArray(formControl.validator) ? formControl.validator : [formControl.validator];
            }
            const dateValidationConfig = {
                dateOptions: this.dateOptions,
                useGmtDateTime: this.useGmtDateTime
            };
            let dateTimeValidator = validators.find(v => v === DwValidateDate(dateValidationConfig));
            if (!dateTimeValidator) {
                dateTimeValidator = DwValidateDate(dateValidationConfig);
                validators.push(dateTimeValidator);
                formControl.setValidators(validators);
            }
        }
    }
    setupTimeStyle(timeOnly) {
        this.todayStyle = timeOnly ? 'today-hidden' : '';
    }
    setup24HourTime(use24HourTime) {
        if (use24HourTime) {
            this.hourFormat = '24';
        }
        else {
            this.hourFormat = '12';
        }
    }
    translateTo(value) {
        if (!value) {
            return value;
        }
        let returnValue = value;
        if (this.timeOnly) {
            returnValue = formatTime(value, !this.use24HourTime);
            return returnValue;
        }
        if (this.useGmtDateTime) {
            returnValue = formatDateTimeToLocal(value, this.showTime, !this.use24HourTime);
        }
        else {
            returnValue = formatDateTime(value, this.showTime, !this.use24HourTime);
        }
        return new Date(returnValue);
    }
    translateFrom(value) {
        let returnValue = value;
        if (this.timeOnly) {
            returnValue = formatTime(value, false);
            return value;
        }
        if (this.useGmtDateTime) {
            returnValue = formatDateTimeFromLocal(value, this.showTime, !this.use24HourTime);
            return returnValue;
        }
        returnValue = formatDateTime(value, this.showTime, !this.use24HourTime);
        return returnValue;
    }
}
DwDateInputControlComponent.ɵfac = function DwDateInputControlComponent_Factory(t) { return new (t || DwDateInputControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ControlContainer, 8)); };
DwDateInputControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDateInputControlComponent, selectors: [["dw-date"]], inputs: { useGmtDateTime: "useGmtDateTime", showTime: "showTime", timeOnly: "timeOnly", use24HourTime: "use24HourTime", formControlName: "formControlName", dateOptions: "dateOptions" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwDateInputControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 10, consts: [["dataType", "string", "appendTo", "body", "baseZIndex", "1100", "autoZIndex", "false", 3, "ngModel", "showIcon", "hourFormat", "showTime", "timeOnly", "todayButtonStyleClass", "showButtonBar", "disabledDays", "numberOfMonths", "disabled", "ngModelChange"]], template: function DwDateInputControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-calendar", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwDateInputControlComponent_Template_p_calendar_ngModelChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.translatedValue)("showIcon", true)("hourFormat", ctx.hourFormat)("showTime", ctx.showTime)("timeOnly", ctx.timeOnly)("todayButtonStyleClass", ctx.todayStyle)("showButtonBar", true)("disabledDays", ctx.disabledDays)("numberOfMonths", ctx.monthsToShow)("disabled", ctx.disabled);
    } }, directives: [ɵngcc19.Calendar, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwDateInputControlComponent.ctorParameters = () => [
    { type: ControlContainer, decorators: [{ type: Optional }] }
];
DwDateInputControlComponent.propDecorators = {
    useGmtDateTime: [{ type: Input }],
    showTime: [{ type: Input }],
    timeOnly: [{ type: Input }],
    formControlName: [{ type: Input }],
    use24HourTime: [{ type: Input }],
    dateOptions: [{ type: Input }]
};
__decorate$e([
    DwInputConverter(booleanConverter),
    __metadata$c("design:type", Boolean)
], DwDateInputControlComponent.prototype, "useGmtDateTime", void 0);
__decorate$e([
    DwInputConverter(booleanConverter),
    __metadata$c("design:type", Boolean)
], DwDateInputControlComponent.prototype, "showTime", void 0);
__decorate$e([
    DwInputConverter(booleanConverter),
    __metadata$c("design:type", Boolean)
], DwDateInputControlComponent.prototype, "timeOnly", void 0);
__decorate$e([
    DwInputConverter(booleanConverter),
    __metadata$c("design:type", Boolean)
], DwDateInputControlComponent.prototype, "use24HourTime", void 0);

class DwPillsDisplayDirective {
}
DwPillsDisplayDirective.ɵfac = function DwPillsDisplayDirective_Factory(t) { return new (t || DwPillsDisplayDirective)(); };
DwPillsDisplayDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwPillsDisplayDirective, selectors: [["", "dwDisplay", ""]] });

class DwPillsComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.iconField = 'iconClass';
        this.pillItems = [];
    }
    ngOnChanges(changes) {
        this.setupPillItems();
    }
    setupPillItems() {
        this.pillItems = this.items.map(item => this.convertPillItem(item));
    }
    convertPillItem(item) {
        return {
            display: this.getDisplay(item),
            value: this.getValue(item),
            iconClass: this.getIconClass(item),
            tooltip: this.getTooltip(item)
        };
    }
    translateTo(value) {
        //return this.getValue(value);
        if (this.valueField) {
            let filter = {};
            filter[this.valueField] = value;
            return findWhere(this.items, filter);
        }
        else {
            return value;
        }
    }
    translateFrom(value) {
        return this.getValue(value);
        /* if (value && this.valueField) {
            return value[this.valueField];
        }

        return value; */
    }
    getDisplay(item) {
        if (!item) {
            return '';
        }
        if (item.display !== undefined) {
            return item.display;
        }
        if (!this.displayField) {
            return item;
        }
        return item[this.displayField];
    }
    getValue(item) {
        if (!item) {
            return '';
        }
        if (item.value !== undefined) {
            return item.value;
        }
        if (!this.valueField) {
            return item;
        }
        return item[this.valueField];
    }
    getIconClass(item) {
        if (!item) {
            return '';
        }
        if (item.iconClass !== undefined) {
            return item.iconClass;
        }
        if (!this.iconField) {
            return item;
        }
        return item[this.iconField];
    }
    getTooltip(item) {
        if (!item) {
            return '';
        }
        if (item.tooltip !== undefined) {
            return item.tooltip;
        }
        if (!this.iconField) {
            return item;
        }
        return item[this.iconField];
    }
    setCurrentValue(item) {
        this.setTranslatedValue(item);
        /*
        const value = this.getValue(item);

        this.setTranslatedValue(value); */
    }
}
DwPillsComponent.ɵfac = function DwPillsComponent_Factory(t) { return ɵDwPillsComponent_BaseFactory(t || DwPillsComponent); };
DwPillsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPillsComponent, selectors: [["dw-pills"]], contentQueries: function DwPillsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwPillsDisplayDirective, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pillsDisplayTemplate = _t.first);
    } }, inputs: { iconField: "iconField", items: "items", valueField: "valueField", displayField: "displayField", tooltipField: "tooltipField" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwPillsComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "dw-pills"], [4, "ngFor", "ngForOf"], [1, "dw-pill", 3, "ngClass", "title", "click"], [3, "ngClass", "hidden"]], template: function DwPillsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwPillsComponent_ng_container_1_Template, 4, 7, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.pillItems);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgClass], styles: [".dw-pill[_ngcontent-%COMP%]{cursor:pointer;margin-right:5px;padding:5px}"] });
DwPillsComponent.propDecorators = {
    items: [{ type: Input }],
    valueField: [{ type: Input }],
    displayField: [{ type: Input }],
    iconField: [{ type: Input }],
    tooltipField: [{ type: Input }],
    pillsDisplayTemplate: [{ type: ContentChild, args: [DwPillsDisplayDirective, { static: true, read: TemplateRef },] }]
};

class DwValidationInfo extends DwControlBaseComponent {
    constructor(controlContainer, dwValidationService) {
        super();
        this.controlContainer = controlContainer;
        this.dwValidationService = dwValidationService;
        this.messageSeparator = ", ";
    }
    ngOnInit() {
        try {
            this.setupFormControl();
            if (!this.formControl) {
                return;
            }
            this.buildErrors();
            this.formControl.valueChanges
                .subscribe((value) => {
                var _a;
                if ((_a = this.formControl) === null || _a === void 0 ? void 0 : _a.errors) {
                    this.buildErrors();
                }
                else {
                    this.errorMessage = '';
                }
            });
        }
        catch (e) {
            console.warn("DwValidationInfo.ngOnInit - Error", e);
        }
    }
    setupFormControl() {
        if (this.controlContainer && this.formControlName) {
            this.formControl = this.controlContainer.control.get(this.formControlName);
            if (!this.formControl) {
                console.warn(`DwValidationInfo.setupFormControl - formControlname ${this.formControlName} not found`);
            }
        }
        else if (this.formGroup) {
            this.formControl = this.formGroup;
        }
        if (this.formControl) {
            this.ensureFunc(this.formControl, "registerOnChange");
            this.ensureFunc(this.formControl, "registerOnDisabledChange");
        }
    }
    ngOnChanges(changes) {
        if (changes.submitted) {
            this.buildErrors();
        }
    }
    buildErrors() {
        this.errorMessage = this.dwValidationService.buildControlError(this.formControl, this.displayName, this.submitted, this.messageSeparator, this.filterKey);
    }
    ensureFunc(control, funcName) {
        if (!control[funcName]) {
            control[funcName] = (fn) => {
                // //console.log(`Hack for error ${funcName} (etc) doesn't exist on control!`);
            };
        }
    }
}
DwValidationInfo.ɵfac = function DwValidationInfo_Factory(t) { return new (t || DwValidationInfo)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ControlContainer, 13), ɵngcc0.ɵɵdirectiveInject(DwValidationService)); };
DwValidationInfo.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwValidationInfo, selectors: [["dw-validation-info"]], inputs: { messageSeparator: "messageSeparator", formControlName: "formControlName", displayName: "displayName", submitted: "submitted", filterKey: "filterKey", formGroup: "formGroup" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwValidationInfo),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "invalid-feedback"]], template: function DwValidationInfo_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.errorMessage);
    } }, encapsulation: 2 });
DwValidationInfo.ctorParameters = () => [
    { type: ControlContainer, decorators: [{ type: Optional }, { type: Host }, { type: SkipSelf }] },
    { type: DwValidationService }
];
DwValidationInfo.propDecorators = {
    formControlName: [{ type: Input }],
    displayName: [{ type: Input }],
    submitted: [{ type: Input }],
    messageSeparator: [{ type: Input }],
    filterKey: [{ type: Input }],
    formGroup: [{ type: Input }]
};

class DwHtmlEditComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.fieldSources = [];
        this.apiReady = new EventEmitter();
        this.editorChangesSubject = new Subject();
        this.writeValueChangesSubject = new Subject();
        this.viewMarkup = false;
        this.modules = {
            syntax: false,
            toolbar: [
                [{ 'header': [1, 2, 3, , 4, 5, false] }],
                [{ 'font': ['Arial', 'Times New Roman'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'align': [] }],
                [{ 'indent': '-1' }, { 'indent': '+1' }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                [{ 'color': [] }, { 'background': [] }],
                ['link'],
                ['code-block'],
            ],
        };
        this.showDebugLog = false;
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.fieldSources) {
            if (((_a = this.fieldSources) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.selectedFieldSource = this.fieldSources[0];
            }
        }
    }
    ngAfterContentInit() {
        this.buildContextMenu();
    }
    ngOnInit() {
        var _a;
        this.ignoreDuplicateSetValues = true;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.useDelayedSetValue) {
            this.editorChangesSubject
                .pipe(debounceTime(100))
                .subscribe((value) => {
                if (this.showDebugLog)
                    console.log('editorChangesSubject = ' + value);
                this.setTranslatedValue(value);
            });
            this.writeValueChangesSubject
                .subscribe((value) => {
                setTimeout(() => {
                    if (this.showDebugLog)
                        console.log('Setting Editable Html = newValue = ' + value.newValue + ' editableValue= ' + value.editableHtmLValue);
                    // If the editableHtml has changed since it was set, then we don't want to set it again
                    if (value.editableHtmLValue !== this.editableHtml) {
                        if (this.showDebugLog)
                            console.log('Setting Editable Html - Ignoring value   = ' + value.newValue + ' editableValue= ' + value.editableHtmLValue);
                        return;
                    }
                    this.editableHtml = value.newValue;
                });
            });
        }
    }
    setEditableHtml(editableHtml) {
        var _a;
        this.editableHtml = editableHtml;
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.useDelayedSetValue) {
            this.editorChangesSubject.next(editableHtml);
        }
        else {
            this.setTranslatedValue(editableHtml);
        }
    }
    translateTo(value) {
        var _a;
        if (this.showDebugLog)
            console.log('translateTo = ' + value);
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.useDelayedSetValue) {
            this.writeValueChangesSubject.next({ newValue: value, editableHtmLValue: this.editableHtml });
        }
        else {
            this.editableHtml = value;
        }
        return super.translateTo(value);
    }
    editorCreated(editor) {
        this.quill = editor;
        //console.log("editor created", this.quill);
        var toolbar = this.quill.getModule('toolbar');
        this.apiReady.emit(this);
        const textChangeEvent = this.quill.on('selection-change', () => {
            setTimeout(() => {
                this.selection = this.quill.getSelection();
            });
        });
        toolbar.addHandler('code-block', (value) => {
            this.toggleViewMarkup();
        });
    }
    insertText(text, linkUrl) {
        text = text || 'Hello';
        setTimeout(() => {
            var _a;
            if (this.selection) {
                if (linkUrl) {
                    this.insertLink(text, linkUrl);
                }
                else {
                    this.quill.insertText((_a = this.selection) === null || _a === void 0 ? void 0 : _a.index, text, 'user');
                }
            }
            else {
                this.translatedValue = this.translatedValue || '';
                this.translatedValue += text;
            }
        });
    }
    insertLink(text, linkUrl) {
        var _a;
        var delta = {
            ops: [
                { retain: ((_a = this.selection) === null || _a === void 0 ? void 0 : _a.index) || 0 },
                { insert: text, attributes: { link: linkUrl } }
            ]
        };
        this.quill.updateContents(delta, 'user');
    }
    insertTextAtPosition(text, position) {
        this.quill.insertText(position, text, 'user');
    }
    addItem(fieldItem) {
        if (fieldItem === null || fieldItem === void 0 ? void 0 : fieldItem.insertCode) {
            this.insertText(fieldItem === null || fieldItem === void 0 ? void 0 : fieldItem.insertCode, fieldItem === null || fieldItem === void 0 ? void 0 : fieldItem.linkUrl);
        }
    }
    buildContextMenu() {
        var _a;
        var items = [];
        if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.allowViewSource) !== false) {
            if (!this.viewMarkup) {
                items.push({
                    label: 'View Markup',
                    command: (event) => { this.toggleViewMarkup(); }
                });
            }
            else {
                items.push({
                    label: 'Hide View Markup',
                    command: (event) => { this.toggleViewMarkup(); }
                });
            }
        }
        this.contextMenu = items;
    }
    toggleViewMarkup() {
        this.viewMarkup = !this.viewMarkup;
        this.buildContextMenu();
    }
}
DwHtmlEditComponent.ɵfac = function DwHtmlEditComponent_Factory(t) { return ɵDwHtmlEditComponent_BaseFactory(t || DwHtmlEditComponent); };
DwHtmlEditComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwHtmlEditComponent, selectors: [["dw-html-edit"]], inputs: { fieldSources: "fieldSources", options: "options" }, outputs: { apiReady: "apiReady" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwHtmlEditComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["container", ""], [3, "style", "panelSizes", 4, "ngIf"], [3, "html", "modules", "disabled", "htmlChange", "onEditorCreated", 4, "ngIf"], [3, "html", "modules", "disabled", "htmlChange", "onEditorCreated"], [1, "ql-toolbar", "ql-snow"], [1, "ql-formats", "hand", 3, "click"], [3, "ngModel", "ngModelChange"], [3, "panelSizes"], ["pTemplate", ""], [1, "left-panel"], [1, "right-panel"], ["multiple", "true"], [3, "header", "selected", 4, "ngFor", "ngForOf"], [3, "header", "selected"], ["class", "field-item", 4, "ngFor", "ngForOf"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add", 1, "fa", "fa-plus-circle", "hand"]], template: function DwHtmlEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwHtmlEditComponent_div_0_Template, 5, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", true);
    } }, directives: function () { return [ɵngcc4.NgIf, QuillEditorComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc5.Splitter, ɵngcc6.PrimeTemplate, ɵngcc11.Accordion, ɵngcc4.NgForOf, ɵngcc11.AccordionTab]; }, styles: [".ql-viewhtml{background-color:red}.ql-viewhtml:before{content:\"View\"}.ql-editor{background-color:#fff;color:#333}.ql-toolbar{background-color:#f4f4f4;border:1px solid #c8c8c8}.ql-tooltip{left:50px!important;top:15px!important;width:500px!important}.ql-tooltip input[type=text]{width:365px!important}.left-panel .ql-container{height:424px}.right-panel{height:500px;overflow:auto;padding:4px;width:100%}.right-panel .field-item{width:100%}"], encapsulation: 2 });
DwHtmlEditComponent.propDecorators = {
    fieldSources: [{ type: Input }],
    apiReady: [{ type: Output }],
    options: [{ type: Input }]
};

class DwUrlReadOnlyControlComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.missingDataText = "None";
    }
}
DwUrlReadOnlyControlComponent.ɵfac = function DwUrlReadOnlyControlComponent_Factory(t) { return ɵDwUrlReadOnlyControlComponent_BaseFactory(t || DwUrlReadOnlyControlComponent); };
DwUrlReadOnlyControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUrlReadOnlyControlComponent, selectors: [["dw-url-readonly"]], inputs: { missingDataText: "missingDataText" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwUrlReadOnlyControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 5, consts: [["target", "_blank", 1, "read-only", 3, "hidden", "href"], [3, "hidden"]], template: function DwUrlReadOnlyControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.translatedValue, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵproperty("hidden", !ctx.translatedValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.translatedValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.translatedValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.missingDataText);
    } }, encapsulation: 2 });
DwUrlReadOnlyControlComponent.propDecorators = {
    missingDataText: [{ type: Input }]
};

class DwLoadingComponent {
    constructor() {
        this.show = false;
        this.text = "Loading...";
    }
}
DwLoadingComponent.ɵfac = function DwLoadingComponent_Factory(t) { return new (t || DwLoadingComponent)(); };
DwLoadingComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLoadingComponent, selectors: [["dw-loading"]], inputs: { show: "show", text: "text" }, decls: 1, vars: 1, consts: [["class", "loading-panel", 4, "ngIf"], [1, "loading-panel"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"]], template: function DwLoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwLoadingComponent_span_0_Template, 4, 1, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.show);
    } }, directives: [ɵngcc4.NgIf], styles: [".loading-panel[_ngcontent-%COMP%]{font-size:2em}"] });
DwLoadingComponent.propDecorators = {
    show: [{ type: Input }],
    text: [{ type: Input }]
};

class DwEvenColumnRowComponent {
    constructor() {
        this.columns = 2;
        this.column1Width = "50%";
        this.column2Width = "50%";
        this.column3Width = "50%";
    }
    ngOnInit() {
    }
}
DwEvenColumnRowComponent.ɵfac = function DwEvenColumnRowComponent_Factory(t) { return new (t || DwEvenColumnRowComponent)(); };
DwEvenColumnRowComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEvenColumnRowComponent, selectors: [["dw-even-column-row"]], inputs: { columns: "columns", column1Width: "column1Width", column2Width: "column2Width", column3Width: "column3Width" }, ngContentSelectors: _c33, decls: 14, vars: 0, consts: [[2, "margin-left", "200px"], [1, "group-box-outer-container"], [1, "group-box-container"], [1, "group-box-sub-container"], [1, "group-box-col1"], [1, "group-box-inner-container"], [1, "group-box-col2"]], template: function DwEvenColumnRowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c32);
        ɵngcc0.ɵɵtext(0, "Even Row Col - Start");
        ɵngcc0.ɵɵelement(1, "br");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵprojection(11, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "br");
        ɵngcc0.ɵɵtext(13, "Even Row Col - End");
    } }, styles: [".group-box-outer-container[_ngcontent-%COMP%]{overflow:auto}.group-box-container[_ngcontent-%COMP%]{float:left;width:100%}.group-box-sub-container[_ngcontent-%COMP%]{float:left;position:relative;right:50%;width:100%}.group-box-col1[_ngcontent-%COMP%], .group-box-col2[_ngcontent-%COMP%]{float:left;left:50%;position:relative;width:50%}.group-box-inner-container[_ngcontent-%COMP%]{width:100%}"] });
DwEvenColumnRowComponent.ctorParameters = () => [];
DwEvenColumnRowComponent.propDecorators = {
    columns: [{ type: Input }],
    column1Width: [{ type: Input }],
    column2Width: [{ type: Input }],
    column3Width: [{ type: Input }]
};

class DwSsoLoginComponent {
    constructor(dwSecurityService, dwSecurityOrchestartionService, dwSecurityRepositoryService) {
        this.dwSecurityService = dwSecurityService;
        this.dwSecurityOrchestartionService = dwSecurityOrchestartionService;
        this.dwSecurityRepositoryService = dwSecurityRepositoryService;
        this.redirecting = false;
    }
    ngOnInit() {
        this.redirectSSO();
        this.dwSecurityService.securityContextChanged()
            .subscribe(r => {
            this.redirectSSO();
        });
    }
    redirectSSO() {
        if (this.dwSecurityService.securityState.isAuthenticating) {
            return;
        }
        if (!this.dwSecurityService.securityState.isAuthenticated) {
            if (this.redirecting) {
                return;
            }
            this.redirecting = true;
            this.dwSecurityRepositoryService.getSSOConfig()
                .subscribe(ssoConfig => {
                this.dwSecurityOrchestartionService.gotoSSOLogin(ssoConfig === null || ssoConfig === void 0 ? void 0 : ssoConfig.TenantSsoConfigId)
                    .subscribe(result => {
                    this.redirecting = false;
                    //this.processing = false;
                });
            });
        }
        else {
            this.dwSecurityOrchestartionService.redirectAfterLogin();
        }
    }
}
DwSsoLoginComponent.ɵfac = function DwSsoLoginComponent_Factory(t) { return new (t || DwSsoLoginComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService), ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken)); };
DwSsoLoginComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSsoLoginComponent, selectors: [["dw-sso-login"]], decls: 1, vars: 0, template: function DwSsoLoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div");
    } }, encapsulation: 2 });
DwSsoLoginComponent.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: DwSecurityOrchestrationService },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] }
];

class DwDynamicHostDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
}
DwDynamicHostDirective.ɵfac = function DwDynamicHostDirective_Factory(t) { return new (t || DwDynamicHostDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DwDynamicHostDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwDynamicHostDirective, selectors: [["", "dwDynamicHost", ""]] });
DwDynamicHostDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];

class DwDynamicLoaderComponent {
    constructor(componentFactoryResolver, uiConfigRegistryService) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.configure = new EventEmitter();
    }
    ngAfterContentInit() {
        this.initComponentConfig();
        this.loadComponent(this.component);
    }
    ngOnChanges(changes) {
        if (changes.component && !changes.component.isFirstChange()) {
            this.loadComponent(this.component);
        }
        if (changes.componentName && !changes.componentName.isFirstChange()) {
            this.initComponentConfig();
        }
    }
    initComponentConfig() {
        const componentName = this.componentName || this.defaultComponentName;
        if (componentName) {
            this.componentRegistration = this.uiConfigRegistryService.getRegisteredComponent(componentName, [DwComponentType.pageComponent, DwComponentType.card, DwComponentType.sideMenuReplacement], true);
            this.loadComponent(this.component);
        }
    }
    loadComponent(component) {
        // Use
        if (this.componentRegistration) {
            component = this.componentRegistration.component;
        }
        // Ensure everything is setup before loading component
        if (!this.dynamicHost || !this.dynamicHost.viewContainerRef) {
            return;
        }
        // Get a reference to the directives view Container ref (See DynamicHost directive for more info)
        const viewContainerRef = this.dynamicHost.viewContainerRef;
        // If we already have a component instance, let clean this up here
        if (this.componentInstance && this.componentInstance.ngOnDestroy) {
            this.componentInstance.ngOnDestroy();
        }
        // Clear any existing components
        viewContainerRef.clear();
        if (!component) {
            return;
        }
        // Create the component factory
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        // Create the component itself
        const componentRef = viewContainerRef.createComponent(componentFactory);
        // set the component instance (so we can reference it later for clean up)
        this.componentInstance = componentRef.instance;
        // Emit event so the host can configure the dynamic component
        this.configure.emit(this.componentInstance);
    }
    ngOnDestroy() {
        if (this.componentInstance && this.componentInstance.ngOnDestroy) {
            this.componentInstance.ngOnDestroy();
        }
    }
}
DwDynamicLoaderComponent.ɵfac = function DwDynamicLoaderComponent_Factory(t) { return new (t || DwDynamicLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwDynamicLoaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDynamicLoaderComponent, selectors: [["dw-dynamic-loader"], ["", "dwDynamicLoader", ""]], viewQuery: function DwDynamicLoaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwDynamicHostDirective, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dynamicHost = _t.first);
    } }, inputs: { component: "component", componentName: "componentName", defaultComponentName: "defaultComponentName" }, outputs: { configure: "configure" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["dwDynamicHost", ""]], template: function DwDynamicLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwDynamicLoaderComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [DwDynamicHostDirective], encapsulation: 2 });
DwDynamicLoaderComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: DwUiConfigRegistryService }
];
DwDynamicLoaderComponent.propDecorators = {
    component: [{ type: Input }],
    configure: [{ type: Output }],
    componentName: [{ type: Input }],
    defaultComponentName: [{ type: Input }],
    dynamicHost: [{ type: ViewChild, args: [DwDynamicHostDirective, { static: true },] }]
};

class DwSecurityErrorPageComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwSecurityErrorPageComponent.ɵfac = function DwSecurityErrorPageComponent_Factory(t) { return new (t || DwSecurityErrorPageComponent)(); };
DwSecurityErrorPageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityErrorPageComponent, selectors: [["dw-dw-security-error-page"]], decls: 5, vars: 0, template: function DwSecurityErrorPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1");
        ɵngcc0.ɵɵtext(1, "Security Error");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(2, "> ");
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵtext(4, " You don't have access to this area!\n");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwSecurityErrorPageComponent.ctorParameters = () => [];

var __decorate$f = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$d = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwNumericDirective {
    constructor(elementRef, sanitizer) {
        this.elementRef = elementRef;
        this.sanitizer = sanitizer;
        this.isActive = true;
        this.invalidKeyStyle = 'border: 4px solid #dc3545;';
        this.validKeys = ['Delete', 'Backspace', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'Del', 'Home', 'End', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12'];
    }
    onPaste(e) {
        if (!this.isActive) {
            return;
        }
        const newData = e.clipboardData.getData('text');
        let isNumber = _isNumberValue(newData);
        if (!isNumber) {
            // If they paste non-numeric data, we ignore it
            e.preventDefault();
            return;
        }
        const position = this.elementRef.nativeElement.selectionStart;
        const positionEnd = this.elementRef.nativeElement.selectionEnd;
        const finalData = this.getInputValue().substring(0, position) + newData + this.getInputValue().substring(positionEnd, this.getInputValue().length);
        isNumber = _isNumberValue(finalData);
        if (!isNumber) {
            // If they paste non-numeric data, we ignore it
            e.preventDefault();
            return;
        }
        const finalDecimalIndex = finalData.indexOf('.');
        if (finalDecimalIndex >= 0) {
            const decmialPlacesEntered = (finalData.length - finalDecimalIndex) - 1;
            if (decmialPlacesEntered > this.decimals) {
                e.preventDefault();
                return;
            }
        }
    }
    onKeyDown(e) {
        if (!this.isActive) {
            return;
        }
        this.clearStlye();
        if (this.isValidControlKey(e)) {
            return; // let it happen, don't do anything
        }
        // Allow negative sign only if the current position is the first element in the text box
        if (this.allowNegative && e.key === '-') {
            if (this.getCurrentPosition() === 0) {
                return;
            }
        }
        if (this.decimals && e.key === '.') {
            // Ensure that decimal hasn't already been added
            if (this.getInputValue().indexOf('.') === -1) {
                return;
            }
        }
        if (!this.isNumberKey(e)) {
            // stop the keypress
            e.preventDefault();
            this.highlightElement();
        }
        // Check if past number of decimal places
        if (this.decimals) {
            const decimalindex = this.getInputValue().indexOf('.');
            const position = this.elementRef.nativeElement.selectionStart;
            if (decimalindex >= 0 && position > decimalindex) {
                const decmialPlacesEntered = (this.getInputValue().length - decimalindex) - 1;
                if (decmialPlacesEntered >= this.decimals) {
                    e.preventDefault();
                    return;
                }
            }
        }
    }
    clearStlye() {
        this.elementStyle = null;
    }
    highlightElement() {
        // highlight the input border after invalid input
        if (!this.elementStyle) {
            this.elementStyle = this.sanitizer.bypassSecurityTrustStyle(this.invalidKeyStyle);
            setTimeout(() => {
                this.elementStyle = null;
            }, 750);
        }
    }
    isValidControlKey(ke) {
        return this.validKeys.indexOf(ke.key) !== -1 ||
            ke.ctrlKey === true ||
            ke.altKey === true;
    }
    isNumberKey(ke) {
        return (parseInt(ke.key, 10).toString() === ke.key);
    }
    getInputValue() {
        return this.elementRef.nativeElement.value;
    }
    getCurrentPosition() {
        return this.elementRef.nativeElement.selectionStart;
    }
}
DwNumericDirective.ɵfac = function DwNumericDirective_Factory(t) { return new (t || DwNumericDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc17.DomSanitizer)); };
DwNumericDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwNumericDirective, selectors: [["input", "dwNumeric", ""]], hostVars: 2, hostBindings: function DwNumericDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("paste", function DwNumericDirective_paste_HostBindingHandler($event) { return ctx.onPaste($event); })("keydown", function DwNumericDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.elementStyle);
    } }, inputs: { isActive: ["dwNumeric", "isActive"], invalidKeyStyle: "invalidKeyStyle", decimals: "decimals", allowNegative: "allowNegative" } });
DwNumericDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: DomSanitizer }
];
DwNumericDirective.propDecorators = {
    isActive: [{ type: Input, args: ['dwNumeric',] }],
    decimals: [{ type: Input }],
    allowNegative: [{ type: Input }],
    invalidKeyStyle: [{ type: Input }],
    elementStyle: [{ type: HostBinding, args: ['style',] }],
    onPaste: [{ type: HostListener, args: ['paste', ['$event'],] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
__decorate$f([
    DwInputConverter(booleanConverter),
    __metadata$d("design:type", Boolean)
], DwNumericDirective.prototype, "isActive", void 0);
__decorate$f([
    DwInputConverter(intConverter),
    __metadata$d("design:type", Number)
], DwNumericDirective.prototype, "decimals", void 0);
__decorate$f([
    DwInputConverter(booleanConverter),
    __metadata$d("design:type", Boolean)
], DwNumericDirective.prototype, "allowNegative", void 0);

class LazyLoadScriptService {
    constructor(document) {
        this.loadedLibraries = {};
        this.document = document;
    }
    loadScript(url) {
        if (this.loadedLibraries[url]) {
            return this.loadedLibraries[url].asObservable();
        }
        this.loadedLibraries[url] = new ReplaySubject();
        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.onload = () => {
            this.loadedLibraries[url].next();
            this.loadedLibraries[url].complete();
        };
        this.document.body.appendChild(script);
        return this.loadedLibraries[url].asObservable();
    }
    loadStyle(url) {
        if (this.loadedLibraries[url]) {
            return this.loadedLibraries[url].asObservable();
        }
        this.loadedLibraries[url] = new ReplaySubject();
        const style = this.document.createElement('link');
        style.type = 'text/css';
        style.href = url;
        style.rel = 'stylesheet';
        style.onload = () => {
            this.loadedLibraries[url].next();
            this.loadedLibraries[url].complete();
        };
        const head = document.getElementsByTagName('head')[0];
        head.appendChild(style);
    }
}
LazyLoadScriptService.ɵfac = function LazyLoadScriptService_Factory(t) { return new (t || LazyLoadScriptService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
LazyLoadScriptService.ɵprov = ɵɵdefineInjectable({ factory: function LazyLoadScriptService_Factory() { return new LazyLoadScriptService(ɵɵinject(DOCUMENT)); }, token: LazyLoadScriptService, providedIn: "root" });
LazyLoadScriptService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];

//const evaluate = function(param1, params) {};
class DwCalcService {
    constructor(lazyLoadScriptService) {
        this.lazyLoadScriptService = lazyLoadScriptService;
        this.loading = false;
        this.loaded = true;
        this.loadMathJs();
    }
    /*
        loadMathJs() {
            this.loading = true;
            this.loadedOb =this.lazyLoadScriptService.loadScript('/assets/scripts.math.js');
    
            this.loadedOb.subscribe(loaded => {
                    this.loading = false;
                    this.loaded = true;
                })
        } */
    loadMathJs() {
        if (this.loadedOb) {
            return this.loadedOb;
        }
        this.loading = true;
        this.loadedOb = this.lazyLoadScriptService.loadScript('/assets/scripts/math.js')
            .pipe(tap(() => {
            // console.log('math js loaded');
            this.loading = false;
            this.loaded = true;
        }));
    }
    calculateValueOb(calcOptions, values, context) {
        return this.loadMathJs()
            .pipe(map(() => {
            return this.calculateValue(calcOptions, values, context);
        }));
    }
    // private math = create(all);
    calculateValue(calcOptions, values, context) {
        if (!this.loaded) {
            return null;
        }
        const scope = this.buildExpressionScope(calcOptions, values, context);
        if (!calcOptions || !calcOptions.formula) {
            return {
                success: false,
                errorMessage: 'Formula is required',
            };
        }
        try {
            const result = {
                success: true,
            };
            const finalFormula = this.buildFinalFormula(calcOptions);
            if (!math || !math.evaluate) {
                throw Error('math js did not load correctly!');
            }
            const calcResult = math.evaluate(finalFormula, scope);
            const displayValue = `${this.cleanValue(calcOptions.prefix)}${calcResult}${this.cleanValue(calcOptions.suffix)}`;
            result.value = calcResult;
            result.displayValue = displayValue;
            return result;
        }
        catch (e) {
            return {
                success: false,
                errorMessage: e.message
            };
        }
    }
    buildFinalFormula(calcOptions) {
        let formula = calcOptions.formula;
        const decimals = parseInt(calcOptions.decimals);
        if (formula && decimals >= 0) {
            formula = `round(${formula}, ${decimals})`;
        }
        return formula;
    }
    cleanValue(value) {
        if (!value) {
            return '';
        }
        return value;
    }
    buildExpressionScope(calcOptions, values, context) {
        const translatedValues = {};
        const defaultValue = parseFloat(calcOptions.nullDefaultValue);
        // Merge the data context values into the form values
        //   this is so any disabled fields (or fields not on the form) can still be used
        if (context && context.data && context.data.value) {
            const mergedValues = Object.assign(Object.assign({}, context.data.value), values);
            values = mergedValues;
        }
        for (const prop in values) {
            let value = values[prop];
            if (value === null || (typeof value === 'string' && value.length === 0)) {
                value = defaultValue;
            }
            translatedValues[prop] = value;
        }
        return {
            data: translatedValues,
            context: context
        };
    }
}
DwCalcService.ɵfac = function DwCalcService_Factory(t) { return new (t || DwCalcService)(ɵngcc0.ɵɵinject(LazyLoadScriptService)); };
DwCalcService.ɵprov = ɵɵdefineInjectable({ factory: function DwCalcService_Factory() { return new DwCalcService(ɵɵinject(LazyLoadScriptService)); }, token: DwCalcService, providedIn: "root" });
DwCalcService.ctorParameters = () => [
    { type: LazyLoadScriptService }
];

class DwCalcComponent extends DwControlBaseComponent {
    constructor(controlContainer, dwCalcService, cdr, dwUIConfig) {
        super();
        this.controlContainer = controlContainer;
        this.dwCalcService = dwCalcService;
        this.cdr = cdr;
        this.dwUIConfig = dwUIConfig;
        this.nullDefaultValue = 0;
        this.calcValue = 'None';
        this.displayValue = '';
        this.optionDefaults = {
            decimals: 2,
            nullDefaultValue: 0,
        };
        DwCalcComponent.instance++;
    }
    ngOnChanges(changes) {
        if (changes.options && this.formGroup && !changes.options.firstChange) {
            this.calculateValue(this.formGroup.value);
        }
    }
    ngOnInit() {
        try {
            //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
            if (this.controlContainer && this.formControlName) {
                this.formControl = this.controlContainer.control.get(this.formControlName);
                if (!this.formControl) {
                    console.warn(`DwCalc.ngOnInit - formControlname ${this.formControlName} not found`);
                    return;
                }
                this.formGroup = this.formControl.parent;
                // Hack for error that it's missing these functions in form.js at run-time
                // TODO : determine why these are called as they aren't part of AbstractControl
                this.ensureFunc(this.formControl, "registerOnChange");
                this.ensureFunc(this.formControl, "registerOnDisabledChange");
                this.ensureFunc(this.formGroup, "registerOnChange");
                this.ensureFunc(this.formGroup, "registerOnDisabledChange");
                this.subscriptions.push(this.formGroup.valueChanges
                    .pipe(map(value => this.removeCalcField(value)), debounceTime(this.dwUIConfig.calcDebounceTime || 50), distinctUntilChanged((a, b) => this.checkAreEqual(a, b)))
                    .subscribe((value) => {
                    this.calculateValue(value);
                }));
                setTimeout(() => {
                    this.calculateValue(this.formGroup.value);
                }, this.dwUIConfig.calcInitialDelay || 0);
            }
            ;
        }
        catch (e) {
            console.warn("DwCalc.ngOnInit - Error", e);
        }
    }
    checkAreEqual(a, b) {
        const result = areEqual(a, b);
        return result;
    }
    /**
     * Removes the calculate field value from the form data so a calc change won't trigger another calc change
     * @param value
     */
    removeCalcField(value) {
        delete value[this.formControlName];
        return value;
    }
    calculateValue(values) {
        // Combine the formula override, defaults and options
        const finalCalcOptions = Object.assign(Object.assign({ formulat: this.formula }, this.optionDefaults), this.options);
        if (!finalCalcOptions.formula) {
            console.warn(`DwCalc.calculateValue - no formula for control ${this.formControlName}`);
            return;
        }
        this.subscriptions.push(this.dwCalcService.calculateValueOb(finalCalcOptions, values, this.context)
            .subscribe(calcResult => {
            if (calcResult.success) {
                this.errorMessage = '';
                // Ignore is results didn't change
                if (this.calcValue == calcResult.value) {
                    return;
                }
                this.calcValue = calcResult.value;
                this.displayValue = calcResult.displayValue;
                // Only set the calculate value when it changes - otherwise this can trigger an un-needed update and trigger valueChanges events
                if (this.value != calcResult.value) {
                    this.setTranslatedValue(this.calcValue);
                }
                this.cdr.markForCheck();
                return;
            }
            this.errorMessage = calcResult.errorMessage;
            console.error(`DwCalc - Error evaluating formula for control ${this.formControlName} - ${calcResult.errorMessage}`, finalCalcOptions.formula, values);
        }));
    }
    setValue(value) {
        super.setValue(value);
    }
    ensureFunc(control, funcName) {
        if (!control[funcName]) {
            control[funcName] = (fn) => {
                // //console.log(`Hack for error ${funcName} (etc) doesn't exist on control!`);
            };
        }
    }
}
DwCalcComponent.ɵfac = function DwCalcComponent_Factory(t) { return new (t || DwCalcComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ControlContainer), ɵngcc0.ɵɵdirectiveInject(DwCalcService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken)); };
DwCalcComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCalcComponent, selectors: [["dw-calc"]], inputs: { nullDefaultValue: "nullDefaultValue", formula: "formula", options: "options", formControlName: "formControlName", context: "context" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwCalcComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[1, "read-only", 3, "innerHtml"], [1, "error-text", 3, "hidden"], [1, "fa", "fa-info-circle", 3, "title"]], template: function DwCalcComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "span", 0);
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3, " Error ");
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.displayValue, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.errorMessage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.errorMessage);
    } }, styles: [".error-text[_ngcontent-%COMP%] {\n      color: red;\n      font-weight: bold;\n    }"] });
DwCalcComponent.instance = 0;
DwCalcComponent.ctorParameters = () => [
    { type: ControlContainer },
    { type: DwCalcService },
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];
DwCalcComponent.propDecorators = {
    formula: [{ type: Input }],
    options: [{ type: Input }],
    formControlName: [{ type: Input }],
    context: [{ type: Input }],
    nullDefaultValue: [{ type: Input }]
};

class DwMessageComponent {
    constructor(dwRoutingService) {
        this.dwRoutingService = dwRoutingService;
        this.messageChange = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.message) {
            this.setupMessage();
        }
    }
    setupMessage() {
        if (!this.message) {
            return;
        }
        this.alertClasses = [];
        this.alertClasses.push(`alert-${this.mapSeverity(this.message.severity)}`);
        if (this.message.allowClose) {
            this.alertClasses.push('alert-dismissaable');
        }
        if (this.classes) {
            for (let className of this.classes.split(',')) {
                this.alertClasses.push(className);
            }
        }
        if (!this.message.forceClose && this.message.timeToShow) {
            const messageBody = this.message.messageBody;
            setTimeout(() => {
                if (this.message && this.message.messageBody === messageBody) {
                    this.close();
                }
            }, this.message.timeToShow);
        }
    }
    linkClick() {
        const windowOptions = {
            openInNewWindow: this.message.linkOpenInNewWindow,
            newWindowTarget: this.message.linkNewWindowTarget
        };
        this.dwRoutingService.navigateToUrl(this.message.linkUrl, windowOptions);
    }
    close() {
        this.message = null;
        this.messageChange.emit(null);
    }
    mapSeverity(severity) {
        if (!severity)
            return "success";
        switch (severity) {
            case DwMessageSeverity.error: return "danger";
            case DwMessageSeverity.info: return "info";
            case DwMessageSeverity.warning: return "warning";
            case DwMessageSeverity.success: return "success";
        }
        return "success";
    }
}
DwMessageComponent.ɵfac = function DwMessageComponent_Factory(t) { return new (t || DwMessageComponent)(ɵngcc0.ɵɵdirectiveInject(DwRoutingService)); };
DwMessageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMessageComponent, selectors: [["dw-message"]], inputs: { message: "message", classes: "classes" }, outputs: { messageChange: "messageChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "dw-alert alert", 3, "ngClass", 4, "ngIf"], [1, "dw-alert", "alert", 3, "ngClass"], ["type", "button", "class", "close", "aria-label", "Close", 3, "click", 4, "ngIf"], [4, "ngIf"], [3, "ngModel"], [3, "click", 4, "ngIf"], ["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true"], [3, "click"], [3, "class", 4, "ngIf"]], template: function DwMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMessageComponent_div_0_Template, 5, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgClass, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwMessageComponent.ctorParameters = () => [
    { type: DwRoutingService }
];
DwMessageComponent.propDecorators = {
    message: [{ type: Input }],
    messageChange: [{ type: Output }],
    classes: [{ type: Input }]
};

class DateTimeModel {
    constructor(init) {
        Object.assign(this, init);
    }
    static fromLocalString(dateString, timeOnly) {
        if (timeOnly) {
            dateString = '1/1/2020 ' + dateString;
        }
        const date = new Date(dateString);
        const isValidDate = !isNaN(date.valueOf());
        if (!dateString || !isValidDate) {
            return null;
        }
        let year = date.getFullYear();
        if (year == 2001) {
            year = 2023;
        }
        return new DateTimeModel({
            year: year,
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: date.getHours(),
            minute: date.getMinutes(),
            second: date.getSeconds(),
            timeZoneOffset: date.getTimezoneOffset()
        });
    }
    static fromNgcDate(date, timeOnly) {
        if (!date) {
            return null;
        }
        return new DateTimeModel({
            year: date.year,
            month: date.month,
            day: date.day,
        });
    }
    isInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    }
    toString(timeOnly) {
        if (timeOnly) {
            return this.toTimeString();
        }
        if (this.isInteger(this.year) && this.isInteger(this.month) && this.isInteger(this.day)) {
            const year = this.year.toString().padStart(2, '0');
            const month = this.month.toString().padStart(2, '0');
            const day = this.day.toString().padStart(2, '0');
            if (!this.hour) {
                this.hour = 0;
            }
            if (!this.minute) {
                this.minute = 0;
            }
            if (!this.second) {
                this.second = 0;
            }
            if (!this.timeZoneOffset) {
                this.timeZoneOffset = new Date().getTimezoneOffset();
            }
            const hour = this.hour.toString().padStart(2, '0');
            const minute = this.minute.toString().padStart(2, '0');
            const second = this.second.toString().padStart(2, '0');
            const tzo = -this.timeZoneOffset;
            const dif = tzo >= 0 ? '+' : '-';
            const timeString = this.toTimeString();
            //let isoString = `${this.pad(year)}-${this.pad(month)}-${this.pad(day)}T${pad(hour)}:${pad(minute)}:${pad(second)}${dif}${pad(tzo / 60)}:${pad(tzo % 60)}`;
            let isoString = `${this.pad(year)}-${this.pad(month)}-${this.pad(day)}T${timeString}${dif}${this.pad(tzo / 60)}:${this.pad(tzo % 60)}`;
            return isoString;
        }
        return null;
    }
    toTimeString() {
        if (!this.hour) {
            this.hour = 0;
        }
        if (!this.minute) {
            this.minute = 0;
        }
        if (!this.second) {
            this.second = 0;
        }
        const hour = this.hour.toString().padStart(2, '0');
        const minute = this.minute.toString().padStart(2, '0');
        const second = this.second.toString().padStart(2, '0');
        const timeString = `${this.pad(hour)}:${this.pad(minute)}:${this.pad(second)}`;
        return timeString;
    }
    pad(num) {
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    }
}

var __decorate$g = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$e = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const moment$9 = moment_;
class DwBootstrapDateTimeInputComponent {
    constructor(config, inj) {
        this.config = config;
        this.inj = inj;
        this.inputDatetimeFormat = 'M/d/yyyy H:mm:ss';
        this.seconds = false;
        this.showTime = true;
        this.timeOnly = false;
        this.use24HourTime = false;
        this.log = new EventEmitter();
        this.disabled = false;
        this.keyedInValue = new Subject();
        this.showTimePickerToggle = false;
        this.datetime = new DateTimeModel();
        this.firstTimeAssign = true;
        this.onTouched = noop;
        this.onChange = noop;
        this.defaultDateOptions = {
            hourStep: 1,
            minuteStep: 5,
            secondStep: 30,
            showSeconds: false
        };
        this.monthsToShow = 1;
        this.firstDayOfWeek = 7; // Sunday in ISO 8601
        config.autoClose = 'outside';
        config.placement = 'bottom';
    }
    ngOnChanges(changes) {
        if (changes.dateOptions && !changes.dateOptions.firstChange) {
            this.setupDateTimeOptions();
        }
    }
    ngOnInit() {
        this.ngControl = this.inj.get(NgControl);
        this.setupDateTimeOptions();
        this.keyedInValue.asObservable().pipe(debounceTime(1000))
            .subscribe(value => {
            this.translatedKeyedInValue(value);
        });
    }
    popoverShown() {
        if (this.dp) {
            this.dp.navigateTo(this.datetime);
            return;
        }
        // keep running until the datePickerControl exists
        setTimeout(() => {
            this.popoverShown();
        });
    }
    setupDateTimeOptions() {
        if (!this.dateOptions) {
            this.dateOptions = {};
        }
        this.dateOptions = Object.assign(Object.assign({}, this.defaultDateOptions), this.dateOptions);
        this.monthsToShow = 1;
        if (this.dateOptions.monthsToShow > 0) {
            this.monthsToShow = this.dateOptions.monthsToShow;
        }
    }
    ngAfterViewInit() {
        this.popover.hidden.subscribe($event => {
            this.showTimePickerToggle = false;
        });
    }
    writeValue(newModel) {
        if (newModel) {
            const newDateTime = DateTimeModel.fromLocalString(newModel, this.timeOnly);
            if (this.datetime && areEqual(this.datetime, newDateTime)) {
                return;
            }
            this.datetime = newDateTime;
            this.dateString = newModel;
            this.setDateStringModel(false);
        }
        else {
            this.datetime = new DateTimeModel();
            this.datetime.hour = 12;
            this.datetime.minute = 0;
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    toggleDateTimeState($event) {
        this.showTimePickerToggle = !this.showTimePickerToggle;
        $event.stopPropagation();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    onInputChange(value) {
        this.keyedInValue.next(value);
    }
    translatedKeyedInValue(value) {
        // console.log('translatedKeyedInValue', value);
        try {
            this.isInvalidDate = false;
            if (!value || value.trim() === '') {
                this.datetime = new DateTimeModel();
                this.dateString = '';
                this.onChange(this.dateString);
                return;
            }
            //const value = $event.target.value;
            if (value && value.indexOf('-') == -1 && value.indexOf('/') == -1) {
                this.isInvalidDate = true;
                this.onChange(null);
                return;
            }
            const dt = DateTimeModel.fromLocalString(value, this.timeOnly);
            if (!dt) {
                this.isInvalidDate = true;
                this.onChange(null);
                return;
            }
            this.datetime = dt;
            this.setDateStringModel(true, true);
            if (this.popover) {
                this.popover.close();
            }
        }
        catch (e) {
            console.log('Error setting translated value', value);
        }
        // if (dt) {
        //     this.datetime = dt;
        //     this.setDateStringModel(true, false);
        // } else if (value.trim() === '') {
        //     this.datetime = new DateTimeModel();
        //     this.dateString = '';
        //     this.onChange(this.dateString);
        // } else {
        //     this.onChange(value);
        // }
    }
    onDateSelection(date, popover) {
        /*  if (!this.startDateTime && !this.endDateTime) {
           this.startDateTime = date;
         } else if (this.startDateTime && !this.endDateTime && date.after(this.startDateTime)) {
           this.endDateTime = date;
         } else {
           this.endDateTime = null;
           this.startDateTime = date;
         } */
        this.log.emit(`onDateSelection ${date === null || date === void 0 ? void 0 : date.month}-${date === null || date === void 0 ? void 0 : date.day}-${date === null || date === void 0 ? void 0 : date.year}`);
        this.isInvalidDate = false;
        const dateModel = DateTimeModel.fromNgcDate(date, this.timeOnly);
        this.onDateChange(dateModel, popover);
    }
    onDateChange(date, popover) {
        try {
            /*   if (!$event) {
                  return;
              }
  
              if (typeof $event !== 'string') {
                  $event = `${$event.year}-${$event.month}-${$event.day}`
              }
  
              const date = DateTimeModel.fromLocalString($event, this.timeOnly);
   */
            this.log.emit(`onDateChange - ${date === null || date === void 0 ? void 0 : date.month}-${date === null || date === void 0 ? void 0 : date.day}-${date === null || date === void 0 ? void 0 : date.year}`);
            if (!date) {
                this.dateString = this.dateString;
                return;
            }
            if (!this.datetime) {
                this.datetime = date;
            }
            this.datetime.year = date.year;
            this.datetime.month = date.month;
            this.datetime.day = date.day;
            if (this.datetime.hour === undefined) {
                this.datetime.hour = 12;
                this.datetime.minute = 0;
                this.datetime.second = 0;
            }
            this.dp.navigateTo({ year: this.datetime.year, month: this.datetime.month });
            this.setDateStringModel();
            if (!this.showTime) {
                popover.close();
            }
        }
        catch (e) {
            this.log.emit(`onDateChange Error - ${e}`);
        }
    }
    onTimeChange(event) {
        if (!event) {
            return;
        }
        this.datetime.hour = event.hour;
        this.datetime.minute = event.minute;
        this.datetime.second = event.second;
        this.isInvalidDate = false;
        this.setDateStringModel();
    }
    setDateStringModel(fireChange = true, setDateString = true) {
        let dateString = '';
        if (this.datetime) {
            dateString = formatDateTime(this.datetime.toString(false), this.showTime, !this.use24HourTime);
        }
        if (this.timeOnly) {
            dateString = formatTime(this.datetime.toString(this.timeOnly), !this.use24HourTime);
        }
        if (setDateString) {
            this.dateString = dateString;
        }
        const outputDateString = this.datetime.toString(this.timeOnly);
        this.log.emit(`setDateStringModel ${outputDateString}`);
        if (fireChange) {
            this.onChange(outputDateString);
        }
    }
    isDisabledFunc() {
        const getCompareDate = this.getCompareDate;
        return (date, current) => {
            const adjustedDate = new Date(date.year, date.month - 1, date.day);
            const momentDate = moment$9(adjustedDate);
            if (!this.dateOptions) {
                return false;
            }
            // Check valid days
            if (this.dateOptions.validDays && !this.dateOptions.validDays[momentDate.day()]) {
                return true;
            }
            // Check min dates
            const minDate = this.getCompareDate(this.dateOptions.minDate);
            if (minDate) {
                // Always all current date
                if (!momentDate.startOf('day').isSame(minDate.startOf('day'))) {
                    if (momentDate.isBefore(minDate)) {
                        return true;
                    }
                }
            }
            // Check max dates
            const maxDate = this.getCompareDate(this.dateOptions.maxDate);
            if (maxDate) {
                // Always all current date
                if (!momentDate.startOf('day').isSame(maxDate.startOf('day'))) {
                    if (momentDate.isAfter(maxDate)) {
                        return true;
                    }
                }
            }
            if (this.dateOptions.isValidDateFunc) {
                return this.dateOptions.isValidDateFunc(adjustedDate);
            }
            return false;
        };
    }
    getCompareDate(options) {
        if (options === null || options === void 0 ? void 0 : options.isToday) {
            return moment$9();
        }
        if (options === null || options === void 0 ? void 0 : options.dateValue) {
            return moment$9(options.dateValue);
        }
        return null;
    }
    onButtonFocus() {
        if (this.popover) {
            this.popover.close();
        }
    }
    inputBlur($event) {
        // setTimeout(() =>{
        //     if (this.popover) {
        //         this.popover.close();
        //     }
        // }, 2000);
        this.onTouched();
    }
}
DwBootstrapDateTimeInputComponent.ɵfac = function DwBootstrapDateTimeInputComponent_Factory(t) { return new (t || DwBootstrapDateTimeInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc20.NgbPopoverConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector)); };
DwBootstrapDateTimeInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwBootstrapDateTimeInputComponent, selectors: [["dw-bootstrap-date-time-input"]], viewQuery: function DwBootstrapDateTimeInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDatepicker, true);
        ɵngcc0.ɵɵviewQuery(NgbPopover, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dp = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { inputDatetimeFormat: "inputDatetimeFormat", seconds: "seconds", showTime: "showTime", timeOnly: "timeOnly", use24HourTime: "use24HourTime", disabled: "disabled", dateOptions: "dateOptions", dateString: "dateString" }, outputs: { log: "log" }, features: [ɵngcc0.ɵɵProvidersFeature([
            DatePipe,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwBootstrapDateTimeInputComponent),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 7, consts: [[1, "input-group", "mr-2"], ["popoverClass", "dw-date-time-picker", "container", "body", "placement", "bottom-left", 1, "form-control", "date-time-input-text", 3, "ngClass", "ngbPopover", "ngModel", "disabled", "shown", "blur", "ngModelChange"], ["popover", "ngbPopover"], [1, "input-group-append"], ["class", "btn date-time-icon", "type", "button", 3, "disabled", "click", "focus", 4, "ngIf"], ["class", "dw-red", 4, "ngIf"], ["popoverContent", ""], ["calendarContent2", ""], ["timeContent", ""], ["type", "button", 1, "btn", "date-time-icon", 3, "disabled", "click", "focus"], [1, "far", "fa-calendar"], [1, "far", "fa-clock"], [1, "dw-red"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["name", "datepicker", 3, "ngModel", "markDisabled", "firstDayOfWeek", "displayMonths", "dateSelect", "select"], ["dp", ""], ["name", "timepicker", 3, "ngModel", "seconds", "hourStep", "minuteStep", "secondStep", "meridian", "ngModelChange", 4, "ngIf"], ["name", "timepicker", 3, "ngModel", "seconds", "hourStep", "minuteStep", "secondStep", "meridian", "ngModelChange"], ["tp", ""]], template: function DwBootstrapDateTimeInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("shown", function DwBootstrapDateTimeInputComponent_Template_input_shown_1_listener() { return ctx.popoverShown(); })("blur", function DwBootstrapDateTimeInputComponent_Template_input_blur_1_listener($event) { return ctx.inputBlur($event); })("ngModelChange", function DwBootstrapDateTimeInputComponent_Template_input_ngModelChange_1_listener($event) { return ctx.onInputChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DwBootstrapDateTimeInputComponent_button_4_Template, 2, 1, "button", 4);
        ɵngcc0.ɵɵtemplate(5, DwBootstrapDateTimeInputComponent_button_5_Template, 2, 1, "button", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwBootstrapDateTimeInputComponent_div_6_Template, 2, 0, "div", 5);
        ɵngcc0.ɵɵtemplate(7, DwBootstrapDateTimeInputComponent_ng_template_7_Template, 1, 3, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, DwBootstrapDateTimeInputComponent_ng_template_9_Template, 4, 5, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, DwBootstrapDateTimeInputComponent_ng_template_11_Template, 2, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r4 = ɵngcc0.ɵɵreference(8);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", (ctx.ngControl == null ? null : ctx.ngControl.valid) ? "ng-valid" : "ng-invalid")("ngbPopover", _r4)("ngModel", ctx.dateString)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.timeOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.timeOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isInvalidDate);
    } }, directives: [ɵngcc3.DefaultValueAccessor, ɵngcc4.NgClass, ɵngcc20.NgbPopover, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc20.NgbDatepicker, ɵngcc20.NgbTimepicker], styles: [".date-time-icon[_ngcontent-%COMP%]{background-color:#007ad9;border:1px solid #007ad9;color:#fff;font-size:14px}.date-time-input-text[_ngcontent-%COMP%]{background:#fff;color:#333;font-size:14px}"] });
DwBootstrapDateTimeInputComponent.ctorParameters = () => [
    { type: NgbPopoverConfig },
    { type: Injector }
];
DwBootstrapDateTimeInputComponent.propDecorators = {
    dateString: [{ type: Input }],
    inputDatetimeFormat: [{ type: Input }],
    seconds: [{ type: Input }],
    showTime: [{ type: Input }],
    timeOnly: [{ type: Input }],
    use24HourTime: [{ type: Input }],
    log: [{ type: Output }],
    dateOptions: [{ type: Input }],
    disabled: [{ type: Input }],
    dp: [{ type: ViewChild, args: [NgbDatepicker, { static: false },] }],
    popover: [{ type: ViewChild, args: [NgbPopover, { static: false },] }]
};
__decorate$g([
    DwInputConverter(booleanConverter),
    __metadata$e("design:type", Boolean)
], DwBootstrapDateTimeInputComponent.prototype, "showTime", void 0);
__decorate$g([
    DwInputConverter(booleanConverter),
    __metadata$e("design:type", Boolean)
], DwBootstrapDateTimeInputComponent.prototype, "timeOnly", void 0);
__decorate$g([
    DwInputConverter(booleanConverter),
    __metadata$e("design:type", Boolean)
], DwBootstrapDateTimeInputComponent.prototype, "use24HourTime", void 0);

class DwDateInputControl2Component extends DwDateInputControlComponent {
    constructor() {
        super(...arguments);
        this.dateFormat = 'MM/dd/yyyy hh:mm a';
        this.log = new EventEmitter();
    }
    ngOnInit() {
        this.setupDateFormat();
    }
    logMessage(message) {
        this.log.emit(message);
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        this.setupDateFormat();
    }
    setupDateFormat() {
        if (this.showTime) {
            if (this.timeOnly) {
                if (this.use24HourTime) {
                    this.dateFormat = 'HH:mm';
                    return;
                }
                this.dateFormat = 'hh:mm a';
                return;
            }
            if (this.use24HourTime) {
                this.dateFormat = 'MM/dd/yyyy HH:mm';
                return;
            }
            this.dateFormat = 'MM/dd/yyyy hh:mm a';
            return;
        }
        this.dateFormat = 'MM/dd/yyyy';
    }
}
DwDateInputControl2Component.ɵfac = function DwDateInputControl2Component_Factory(t) { return ɵDwDateInputControl2Component_BaseFactory(t || DwDateInputControl2Component); };
DwDateInputControl2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDateInputControl2Component, selectors: [["dw-date2"]], outputs: { log: "log" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwDateInputControl2Component),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 6, consts: [[3, "ngModel", "dateOptions", "showTime", "timeOnly", "use24HourTime", "inputDatetimeFormat", "log", "ngModelChange"]], template: function DwDateInputControl2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-bootstrap-date-time-input", 0);
        ɵngcc0.ɵɵlistener("log", function DwDateInputControl2Component_Template_dw_bootstrap_date_time_input_log_0_listener($event) { return ctx.logMessage($event); })("ngModelChange", function DwDateInputControl2Component_Template_dw_bootstrap_date_time_input_ngModelChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.translatedValue)("dateOptions", ctx.dateOptions)("showTime", ctx.showTime)("timeOnly", ctx.timeOnly)("use24HourTime", ctx.use24HourTime)("inputDatetimeFormat", ctx.dateFormat);
    } }, directives: [DwBootstrapDateTimeInputComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwDateInputControl2Component.propDecorators = {
    log: [{ type: Output }]
};

var __decorate$h = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$f = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwInputReadOnlyComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.missingDataText = 'None';
    }
    translateTo(value) {
        let result = value;
        if (this.numeric) {
            result = this.formatNumeric(value, this.finalDecimals);
            if (!result) {
                return this.missingDataText;
            }
        }
        if (this.options && this.options.prefix) {
            result = `${this.options.prefix}${result}`;
        }
        if (this.options && this.options.suffix) {
            result = `${result}${this.options.suffix}`;
        }
        if (result === null || result === undefined || result === '') {
            result = this.missingDataText;
        }
        return result;
    }
    formatNumeric(value, decimals) {
        var _a;
        let numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
            return null;
        }
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.multiplier) {
            numberValue = numberValue * parseFloat(this.options.multiplier.toString());
        }
        if (this.options && this.options.excludeLocalNumericFormatting) {
            return numberValue.toFixed(decimals);
        }
        return numberValue.toLocaleString('en-us', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    }
    get finalDecimals() {
        if (this.options && (this.options.decimalsOverride || this.options.decimalsOverride === 0)) {
            return this.options.decimalsOverride;
        }
        return this.decimals || 0;
    }
}
DwInputReadOnlyComponent.ɵfac = function DwInputReadOnlyComponent_Factory(t) { return ɵDwInputReadOnlyComponent_BaseFactory(t || DwInputReadOnlyComponent); };
DwInputReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwInputReadOnlyComponent, selectors: [["dw-input-readonly"]], inputs: { missingDataText: "missingDataText", class: "class", numeric: "numeric", allowDecimal: "allowDecimal", decimals: "decimals", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwInputReadOnlyComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[1, "read-only", 3, "innerHtml"]], template: function DwInputReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHtml", ctx.translatedValue, ɵngcc0.ɵɵsanitizeHtml);
    } }, encapsulation: 2 });
DwInputReadOnlyComponent.propDecorators = {
    class: [{ type: Input }],
    numeric: [{ type: Input }],
    allowDecimal: [{ type: Input }],
    decimals: [{ type: Input }],
    options: [{ type: Input }],
    missingDataText: [{ type: Input }]
};
__decorate$h([
    DwInputConverter(booleanConverter),
    __metadata$f("design:type", Boolean)
], DwInputReadOnlyComponent.prototype, "numeric", void 0);
__decorate$h([
    DwInputConverter(booleanConverter),
    __metadata$f("design:type", Boolean)
], DwInputReadOnlyComponent.prototype, "allowDecimal", void 0);
__decorate$h([
    DwInputConverter(intConverter),
    __metadata$f("design:type", Number)
], DwInputReadOnlyComponent.prototype, "decimals", void 0);

var DwConfigListSize;
(function (DwConfigListSize) {
    DwConfigListSize["small"] = "small";
    DwConfigListSize["medium"] = "medium";
    DwConfigListSize["large"] = "large";
})(DwConfigListSize || (DwConfigListSize = {}));

class DwUiConfigListComponent {
    constructor() {
        this.selectedItemChange = new EventEmitter();
        this.reorder = new EventEmitter();
        this.removeItem = new EventEmitter();
        this.size = DwConfigListSize.medium;
        this.selectedTabIndex = 0;
    }
    ngOnInit() {
        if (this.config.defaultConfigureTab) {
            this.selectedTabIndex = 1;
        }
    }
    onSelectItem(eventArgs) {
        let item = null;
        if (eventArgs && eventArgs.value && eventArgs.value.length > 0) {
            item = eventArgs.value[0];
        }
        this.selectedItem = item;
        this.selectedItemChange.emit(item);
    }
    ngOnChanges(changes) {
        if (changes.items && !changes.items.firstChange) {
            //console.log('dw-ui-config-list  Items changed');
        }
        switch (this.size) {
            case DwConfigListSize.small:
                this.listClass = 'dw-config-list-small';
                break;
            case DwConfigListSize.large:
                this.listClass = 'dw-config-list-large';
                break;
            default:
                this.listClass = 'dw-config-list';
        }
    }
    onReorder() {
        this.reorder.emit();
    }
    onRemoveItem(item) {
        this.removeItem.emit(item);
    }
}
DwUiConfigListComponent.ɵfac = function DwUiConfigListComponent_Factory(t) { return new (t || DwUiConfigListComponent)(); };
DwUiConfigListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiConfigListComponent, selectors: [["dw-ui-config-list"]], inputs: { size: "size", selectedItem: "selectedItem", config: "config", items: "items" }, outputs: { selectedItemChange: "selectedItemChange", reorder: "reorder", removeItem: "removeItem" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c36, decls: 11, vars: 10, consts: [["dwRow", "", 3, "ngClass"], ["dwCol", "6"], ["dragdrop", "true", "controlsPosition", "right", 3, "value", "selection", "onSelectionChange", "onReorder"], ["pTemplate", "item"], ["dwRow", "", 4, "ngIf"], ["styleClass", "dw-config-tabs", 3, "activeIndex", "activeIndexChange"], ["styleClass", "dw-field-list", 3, "header"], [3, "header", 4, "ngIf"], [1, "order-item"], ["class", "fa ml-1", 3, "ngClass", 4, "ngIf"], ["class", "fa ml-1", 3, "ngClass", "title", 4, "ngIf"], ["title", "Remove", 1, "fa", "fa-times", "hand", "pull-right", 3, "hidden", "click"], [1, "fa", "ml-1", 3, "ngClass"], [1, "fa", "ml-1", 3, "ngClass", "title"], ["dwRow", ""], ["dwCol", "12"], [3, "header"]], template: function DwUiConfigListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c34);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p-orderList", 2);
        ɵngcc0.ɵɵlistener("onSelectionChange", function DwUiConfigListComponent_Template_p_orderList_onSelectionChange_2_listener($event) { return ctx.onSelectItem($event); })("onReorder", function DwUiConfigListComponent_Template_p_orderList_onReorder_2_listener() { return ctx.onReorder(); });
        ɵngcc0.ɵɵtemplate(3, DwUiConfigListComponent_ng_template_3_Template, 5, 4, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, DwUiConfigListComponent_div_4_Template, 3, 0, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵelementStart(6, "p-tabView", 5);
        ɵngcc0.ɵɵlistener("activeIndexChange", function DwUiConfigListComponent_Template_p_tabView_activeIndexChange_6_listener($event) { return ctx.selectedTabIndex = $event; });
        ɵngcc0.ɵɵelementStart(7, "p-tabPanel", 6);
        ɵngcc0.ɵɵprojection(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DwUiConfigListComponent_p_tabPanel_9_Template, 2, 1, "p-tabPanel", 7);
        ɵngcc0.ɵɵtemplate(10, DwUiConfigListComponent_p_tabPanel_10_Template, 2, 1, "p-tabPanel", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.listClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("value", ctx.items)("selection", ɵngcc0.ɵɵpureFunction1(8, _c35, ctx.selectedItem));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.showListActionBar);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("activeIndex", ctx.selectedTabIndex);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", (ctx.config == null ? null : ctx.config.addItemsHeading) || "Add Items");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItem && (ctx.config == null ? null : ctx.config.allowConfigureItem));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.showAdditionalTab);
    } }, directives: [DwRowDirective, ɵngcc4.NgClass, DwColDirective, ɵngcc21.OrderList, ɵngcc6.PrimeTemplate, ɵngcc4.NgIf, ɵngcc9.TabView, ɵngcc9.TabPanel], encapsulation: 2 });
DwUiConfigListComponent.propDecorators = {
    config: [{ type: Input }],
    items: [{ type: Input }],
    selectedItem: [{ type: Input }],
    selectedItemChange: [{ type: Output }],
    reorder: [{ type: Output }],
    removeItem: [{ type: Output }],
    size: [{ type: Input }]
};

var __decorate$i = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$g = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwBrowserAutocomplete {
    // Auto-complete list of attributes - https://developers.google.com/web/fundamentals/design-and-ux/input/forms#recommended_input_name_and_autocomplete_attribute_values
    constructor(elementRef, renderer2) {
        this.elementRef = elementRef;
        this.renderer2 = renderer2;
        this.autocompleteEnabled = false;
        this.autocompleteText = '';
        this.defaultAutocompleteText = 'on';
    }
    ngOnChanges(changes) {
        this.writeAttributes();
    }
    writeAttributes() {
        this.renderer2.removeAttribute(this.elementRef.nativeElement, 'autocomplete');
        if (!this.autocompleteEnabled) {
            this.renderer2.setAttribute(this.elementRef.nativeElement, 'autocomplete', 'new-password');
            return;
        }
        const autocompleteText = this.autocompleteText || this.defaultAutocompleteText;
        this.renderer2.setAttribute(this.elementRef.nativeElement, 'autocomplete', autocompleteText);
    }
}
DwBrowserAutocomplete.ɵfac = function DwBrowserAutocomplete_Factory(t) { return new (t || DwBrowserAutocomplete)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DwBrowserAutocomplete.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwBrowserAutocomplete, selectors: [["input", "dwBrowserAutocomplete", ""]], inputs: { autocompleteEnabled: ["dwBrowserAutocomplete", "autocompleteEnabled"], autocompleteText: "autocompleteText", defaultAutocompleteText: "defaultAutocompleteText" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwBrowserAutocomplete.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DwBrowserAutocomplete.propDecorators = {
    autocompleteEnabled: [{ type: Input, args: ['dwBrowserAutocomplete',] }],
    autocompleteText: [{ type: Input }],
    defaultAutocompleteText: [{ type: Input }]
};
__decorate$i([
    DwInputConverter(booleanConverter),
    __metadata$g("design:type", Boolean)
], DwBrowserAutocomplete.prototype, "autocompleteEnabled", void 0);

class DwStyleManagerService {
    constructor(uiConfig) {
        this.uiConfig = uiConfig;
        this.styleConfig = this.uiConfig.styleConfig;
    }
    getStandardColors() {
        return this.styleConfig.standardColors || [];
    }
    getColorConfig(colorName) {
        const color = this.getStandardColors().find(c => c.name == colorName);
        return color;
    }
    getForegroundColorClass(colorName) {
        const color = this.getColorConfig(colorName);
        return color === null || color === void 0 ? void 0 : color.foregroundClass;
    }
    getBackgroundColorClass(colorName) {
        const color = this.getColorConfig(colorName);
        return color === null || color === void 0 ? void 0 : color.backgroundClass;
    }
}
DwStyleManagerService.ɵfac = function DwStyleManagerService_Factory(t) { return new (t || DwStyleManagerService)(ɵngcc0.ɵɵinject(DwUIConfigToken)); };
DwStyleManagerService.ɵprov = ɵɵdefineInjectable({ factory: function DwStyleManagerService_Factory() { return new DwStyleManagerService(ɵɵinject(DwUIConfigToken)); }, token: DwStyleManagerService, providedIn: "root" });
DwStyleManagerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];

class DwContainerComponent {
    constructor(dwUiConfigRegistryService, cdr, dwStyleManagerService) {
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.cdr = cdr;
        this.dwStyleManagerService = dwStyleManagerService;
        this.collapsed = false;
        this.collapsedChange = new EventEmitter();
        this.expandCollapseLocationClass = 'pull-right';
        this.expandIconClass = 'fa fa-plus';
        this.collapseIconClass = 'fa fa-minus';
        this.styles = {};
    }
    ngOnInit() {
        this.setupStyling();
    }
    ngOnChanges(changes) {
        var _a;
        if (!((_a = changes.options) === null || _a === void 0 ? void 0 : _a.firstChange)) {
            this.setupStyling();
        }
    }
    setupStyling() {
        this.styles = {};
        this.options = this.options || this.getDefaultOptions();
        if (this.options.useContainerStyling) {
            let containerStyle = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.containerStyles, this.options.styleName);
            if (!containerStyle) {
                // Load default container styler
                containerStyle = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.containerStyles, null);
            }
            if (this.options.containerAllowCollapse) {
                if (this.options.containerCollapseDefault == true || this.options.containerCollapseDefault == false) {
                    this.setCollapsed(this.options.containerCollapseDefault);
                }
                switch (this.options.expandCollapseStyle) {
                    case DwExpandCollapseStyle.chevron:
                        this.expandIconClass = 'fa fa-chevron-right';
                        this.collapseIconClass = 'fa fa-chevron-down';
                        break;
                    case DwExpandCollapseStyle.plusMinus:
                    default:
                        this.expandIconClass = 'fa fa-plus';
                        this.collapseIconClass = 'fa fa-minus';
                }
                switch (this.options.expandCollpaseLocation) {
                    case DwExpandCollapseLocation.left:
                        this.expandCollapseLocationClass = 'pull-left';
                        break;
                    case DwExpandCollapseLocation.right:
                    default:
                        this.expandCollapseLocationClass = 'pull-right';
                        break;
                }
            }
            const titleClasses = [];
            titleClasses.push(this.options.containerTitleClass || containerStyle.containerTitleClass);
            if (this.options.containerHeaderBackgroundColor) {
                titleClasses.push(this.dwStyleManagerService.getBackgroundColorClass(this.options.containerHeaderBackgroundColor));
            }
            if (this.options.containerHeaderForegroundColor) {
                titleClasses.push(this.dwStyleManagerService.getForegroundColorClass(this.options.containerHeaderForegroundColor));
            }
            this.styles.containerClass = this.options.containerClass || containerStyle.containerClass;
            this.styles.containerInnerClass = this.options.containerInnerClass || containerStyle.containerInnerClass;
            this.styles.containerTitleClass = titleClasses.join(' ');
            const iconClasses = [];
            if (this.options.containerHeaderIcon) {
                iconClasses.push(this.options.containerHeaderIcon);
            }
            if (this.options.containerHeaderIconColor) {
                iconClasses.push(this.dwStyleManagerService.getForegroundColorClass(this.options.containerHeaderIconColor));
            }
            this.styles.iconClass = iconClasses.join(' ');
            this.styles.containerInnerPaddingClass = `${this.styles.containerInnerClass}-padding`;
            if (this.options.containerHeight || this.options.containerWidth) {
                this.styles.containerStyle = Object.assign(Object.assign({}, this.getStyleDimension('height', this.options.containerHeight)), this.getStyleDimension('width', this.options.containerWidth));
            }
        }
    }
    getDefaultOptions() {
        return {
            useContainerStyling: true,
            showTitle: true
        };
    }
    getStyleDimension(prop, dimensionValue) {
        const style = {};
        if (dimensionValue) {
            style[prop] = this.buildDimensionValue(dimensionValue);
        }
        return style;
    }
    buildDimensionValue(value) {
        const intValue = parseInt(value);
        if (intValue.toString() == value) {
            return `${intValue}px`;
        }
        return value;
    }
    expand() {
        this.setCollapsed(false);
    }
    collapse() {
        this.setCollapsed(true);
    }
    toggle() {
        if (!this.options.containerAllowCollapse) {
            return;
        }
        this.setCollapsed(!this.collapsed);
    }
    setCollapsed(collapsed) {
        this.collapsed = collapsed;
        this.collapsedChange.emit(this.collapsed);
    }
}
DwContainerComponent.ɵfac = function DwContainerComponent_Factory(t) { return new (t || DwContainerComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
DwContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContainerComponent, selectors: [["dw-container"]], inputs: { collapsed: "collapsed", options: "options" }, outputs: { collapsedChange: "collapsedChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c39, decls: 10, vars: 23, consts: [[3, "ngClass"], ["id", "header", 3, "hidden", "ngClass", "click"], [1, "mr-1", 3, "ngClass", "hidden"], ["title", "Expand", 3, "ngClass", "hidden"], ["title", "Collapse", 3, "ngClass", "hidden"], ["id", "headerIcon", 3, "hidden"], ["id", "inner", 3, "dwExpandable", "collapsed"]], template: function DwContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c37);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵlistener("click", function DwContainerComponent_Template_div_click_1_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelement(4, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "i", 5);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵprojection(9, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.styles.containerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.styles.containerTitleClass);
        ɵngcc0.ɵɵproperty("hidden", !ctx.options.showTitle)("ngClass", ɵngcc0.ɵɵpureFunction1(21, _c38, ctx.options == null ? null : ctx.options.containerAllowCollapse));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.expandCollapseLocationClass)("hidden", !(ctx.options == null ? null : ctx.options.containerAllowCollapse));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.expandIconClass)("hidden", !ctx.collapsed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.collapseIconClass)("hidden", ctx.collapsed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("", ctx.styles.iconClass, " mr-2");
        ɵngcc0.ɵɵproperty("hidden", !ctx.options.containerHeaderIcon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.styles.containerInnerClass);
        ɵngcc0.ɵɵproperty("dwExpandable", ctx.options == null ? null : ctx.options.containerAllowCollapse)("collapsed", ctx.collapsed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.styles.containerInnerPaddingClass);
    } }, directives: function () { return [ɵngcc4.NgClass, DwExpandableDirective]; }, encapsulation: 2 });
DwContainerComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: ChangeDetectorRef },
    { type: DwStyleManagerService }
];
DwContainerComponent.propDecorators = {
    options: [{ type: Input }],
    collapsed: [{ type: Input }],
    collapsedChange: [{ type: Output }]
};

var DwMenuLocation;
(function (DwMenuLocation) {
    DwMenuLocation["top"] = "top";
    DwMenuLocation["side"] = "side";
    DwMenuLocation["user"] = "user";
    DwMenuLocation["menuPage"] = "menuPage";
})(DwMenuLocation || (DwMenuLocation = {}));

var __decorate$j = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$h = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMenuLinkComponent {
    constructor(actionExecutionService, router, activatedRoute, menuBuilderSerivce) {
        this.actionExecutionService = actionExecutionService;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.menuBuilderSerivce = menuBuilderSerivce;
        this.className = 'nav-link';
        this.additionalIconClass = '';
        this.hideIcon = false;
    }
    ngOnInit() {
        this.activatedRoute.paramMap.subscribe(params => {
            this.paramMap = params;
            this.setupFinalUrl();
        });
        this.menu.data.menuComponent;
        this.setupFinalUrl();
    }
    ngOnChanges(changes) {
        if (changes.menu && !changes.menu.firstChange) {
            this.setupFinalUrl();
        }
    }
    setupFinalUrl() {
        var _a;
        this.finalUrl = (_a = this.menu) === null || _a === void 0 ? void 0 : _a.url;
    }
    configureMenuComponent(componentInstance) {
        componentInstance.menu = this.menu;
        componentInstance.menuLocation = this.menuLocation;
        if (componentInstance.setupMenu) {
            componentInstance.setupMenu();
        }
        if (componentInstance.menuClick) {
            componentInstance.menuClick.subscribe((event) => {
                this.customMenuComponentClick(event);
            });
        }
    }
    customMenuComponentClick(event) {
        var _a;
        if ((_a = this.menu.data) === null || _a === void 0 ? void 0 : _a.isAction) {
            this.doAction(this.menu, null);
            return;
        }
        if (this.menu.url) {
            this.router.navigateByUrl(this.menu.url);
        }
    }
    doAction(menu, event) {
        var _a;
        const actionState = {
            command: '',
            actionConfig: menu.data.actionConfig,
            actionPreference: {
                actionDisplay: menu.display,
                actionKey: menu.data.actionKey,
            },
            // TODO: Determine how to provide menu context since this only exists in DevwareUiMetaData
            context: {},
            dwBrowserEvent: getDwBrowserEvent(event)
        };
        if (!((_a = menu === null || menu === void 0 ? void 0 : menu.data) === null || _a === void 0 ? void 0 : _a.isAction)) {
            this.router.navigateByUrl(menu.url);
            return;
        }
        const action = this.actionExecutionService.executeAction(menu.data.actionKey, actionState);
        if (action && action.subscribe) {
            const subscription = action.subscribe(result => {
                setTimeout(() => {
                    subscription.unsubscribe();
                });
            });
        }
        // Hide the side nav bar if we're in mobile
        //this.hideMobile();
    }
    hideMobile() {
        if (document.body.classList.contains('sidebar-show')) {
            document.body.classList.toggle('sidebar-show');
        }
    }
}
DwMenuLinkComponent.ɵfac = function DwMenuLinkComponent_Factory(t) { return new (t || DwMenuLinkComponent)(ɵngcc0.ɵɵdirectiveInject(DwActionExecutionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DwMenuBuilderService)); };
DwMenuLinkComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMenuLinkComponent, selectors: [["dw-menu-link"]], inputs: { className: "className", additionalIconClass: "additionalIconClass", hideIcon: "hideIcon", menu: "menu", menuLocation: "menuLocation" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], ["routerLinkActive", "active", 3, "routerLink", "routerLinkActiveOptions", "ngClass", "hidden", "click"], [3, "hidden"], [1, "dw-menu-display"], [1, "hand", 3, "ngClass", "hidden", "click"], [3, "component", "configure"]], template: function DwMenuLinkComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMenuLinkComponent_ng_container_0_Template, 9, 20, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, DwMenuLinkComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.menu == null ? null : ctx.menu.data == null ? null : ctx.menu.data.menuComponent));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.menu == null ? null : ctx.menu.data == null ? null : ctx.menu.data.menuComponent);
    } }, directives: [ɵngcc4.NgIf, ɵngcc2.RouterLinkWithHref, ɵngcc2.RouterLinkActive, ɵngcc4.NgClass, DwDynamicLoaderComponent], encapsulation: 2 });
DwMenuLinkComponent.ctorParameters = () => [
    { type: DwActionExecutionService },
    { type: Router },
    { type: ActivatedRoute },
    { type: DwMenuBuilderService }
];
DwMenuLinkComponent.propDecorators = {
    menu: [{ type: Input }],
    className: [{ type: Input }],
    additionalIconClass: [{ type: Input }],
    menuLocation: [{ type: Input }],
    hideIcon: [{ type: Input }]
};
__decorate$j([
    DwInputConverter(booleanConverter),
    __metadata$h("design:type", Boolean)
], DwMenuLinkComponent.prototype, "hideIcon", void 0);

const moment$a = moment_;
class DwDateRangeInputComponent {
    constructor(config, cdr) {
        this.config = config;
        this.cdr = cdr;
        this.startDateChange = new EventEmitter();
        this.endDateChange = new EventEmitter();
        this.dateRangeDisplay = null;
        this.hoveredDate = null;
        this.endDateTime = null;
        this.firstDayOfWeek = 7; // Sunday in ISO 8601
        config.autoClose = 'outside';
        config.placement = 'bottom';
    }
    ngOnInit() {
    }
    updateFromText(value) {
        if (!value) {
            this.startDateTime = null;
            this.endDateTime = null;
        }
        else {
            const parts = value.split('-');
            const startDateTime = this.parseToNgbDate(parts[0]);
            if (!startDateTime) {
                return;
            }
            let endDateTime;
            if (parts.length == 2 && parts[1].trim().length > 0) {
                endDateTime = this.parseToNgbDate(parts[1]);
                if (!endDateTime) {
                    return;
                }
            }
            if (areEqual(this.startDateTime, startDateTime) && areEqual(this.endDateTime, endDateTime)) {
                return;
            }
            this.startDateTime = startDateTime;
            this.endDateTime = endDateTime;
            this.hoveredDate = endDateTime;
        }
        this.updateDates();
    }
    ngOnChanges(changes) { }
    onDateSelection(date) {
        if (!this.startDateTime && !this.endDateTime) {
            this.startDateTime = date;
        }
        else if (this.startDateTime && !this.endDateTime && date.after(this.startDateTime)) {
            this.endDateTime = date;
        }
        else {
            this.endDateTime = null;
            this.startDateTime = date;
        }
        this.updateDates();
    }
    popoverShown() {
        if (this.datePickerControl) {
            this.datePickerControl.navigateTo(this.startDateTime);
            return;
        }
        // keep running until the datePickerControl exists
        setTimeout(() => {
            this.popoverShown();
        });
    }
    onInputChange(dateRange) {
        this.updateFromText(dateRange);
        //this.inputChangeSubject.next(dateRange);
    }
    updateDates() {
        let closePopup = false;
        const newStartDate = this.formatNgbDate(this.startDateTime);
        const newEndDate = this.formatNgbDate(this.endDateTime);
        if (newStartDate == this.startDate && this.endDate == this.startDate) {
            closePopup = true;
        }
        this.startDate = newStartDate;
        this.endDate = newEndDate;
        if (!this.endDate) {
            this.endDate = this.startDate;
        }
        else {
            closePopup = true;
        }
        this.startDateChange.emit(this.startDate);
        this.endDateChange.emit(this.endDate);
        // Set date range display
        if (this.startDate == this.endDate) {
            this.dateRangeDisplay = this.startDate;
        }
        else {
            this.dateRangeDisplay = `${this.startDate} - ${this.endDate}`;
        }
        this.startDateTimeModel = new DateTimeModel(this.startDateTime);
        if (closePopup) {
            this.popover.close();
        }
        this.cdr.detectChanges();
    }
    formatNgbDate(dateValue) {
        if (!dateValue) {
            return null;
        }
        const stringDate = `${dateValue.month}/${dateValue.day}/${dateValue.year}`;
        return formatDateTime(stringDate, false);
    }
    parseToNgbDate(dateValue) {
        if (!dateValue) {
            return null;
        }
        const dateParts = dateValue.trim().split('/');
        if (dateParts.length != 3) {
            return null;
        }
        const month = parseInt(dateParts[0]);
        const day = parseInt(dateParts[1]);
        let year = parseInt(dateParts[2]);
        if (year < 1000) {
            return null;
        }
        if (isNaN(month) || isNaN(day)) {
            return null;
        }
        // If no year, set year
        if (isNaN(year)) {
            year = moment$a().year();
        }
        return new NgbDate(year, month, day);
    }
    isHovered(date) {
        const result = this.startDateTime && !this.endDateTime && this.hoveredDate && date.after(this.startDateTime) && date.before(this.hoveredDate);
        if (!this.endDateTime) {
        }
        return result;
    }
    isInside(date) {
        const result = this.endDateTime && date.after(this.startDateTime) && date.before(this.endDateTime);
        return result;
    }
    isRange(date) {
        const result = date.equals(this.startDateTime) || (this.endDateTime && date.equals(this.endDateTime)) || this.isInside(date) || this.isHovered(date);
        return result;
    }
}
DwDateRangeInputComponent.ɵfac = function DwDateRangeInputComponent_Factory(t) { return new (t || DwDateRangeInputComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc20.NgbPopoverConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwDateRangeInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDateRangeInputComponent, selectors: [["dw-date-range-input"]], viewQuery: function DwDateRangeInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDatepicker, true);
        ɵngcc0.ɵɵstaticViewQuery(NgbPopover, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePickerControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { startDate: "startDate", endDate: "endDate", disabled: "disabled" }, outputs: { startDateChange: "startDateChange", endDateChange: "endDateChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 4, consts: [[1, "input-group", "mr-2"], ["popoverClass", "dw-date-time-picker", "container", "body", "placement", "bottom-left", "dwBrowserAutocomplete", "false", 1, "form-control", "date-time-input-text", 3, "ngbPopover", "ngModel", "disabled", "shown", "ngModelChange"], ["popover", "ngbPopover"], [1, "input-group-append"], ["type", "button", 1, "btn", "date-time-icon", 3, "disabled", "click"], [1, "far", "fa-calendar"], ["popoverContent", ""], ["dayTemplate", ""], [1, "date-range-picker"], ["outsideDays", "hidden", 3, "ngModel", "displayMonths", "dayTemplate", "firstDayOfWeek", "dateSelect", "select"], ["dp", ""], [1, "custom-day", 3, "mouseenter", "mouseleave"]], template: function DwDateRangeInputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r14 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("shown", function DwDateRangeInputComponent_Template_input_shown_1_listener() { return ctx.popoverShown(); })("ngModelChange", function DwDateRangeInputComponent_Template_input_ngModelChange_1_listener($event) { return ctx.onInputChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function DwDateRangeInputComponent_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r14); const _r0 = ɵngcc0.ɵɵreference(2); return _r0.toggle(); });
        ɵngcc0.ɵɵelement(5, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwDateRangeInputComponent_ng_template_6_Template, 3, 4, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, DwDateRangeInputComponent_ng_template_8_Template, 2, 7, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngbPopover", _r1)("ngModel", ctx.dateRangeDisplay)("disabled", false);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
    } }, directives: [DwBrowserAutocomplete, ɵngcc3.DefaultValueAccessor, ɵngcc20.NgbPopover, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc20.NgbDatepicker], styles: [_c45] });
DwDateRangeInputComponent.ctorParameters = () => [
    { type: NgbPopoverConfig },
    { type: ChangeDetectorRef }
];
DwDateRangeInputComponent.propDecorators = {
    startDate: [{ type: Input }],
    startDateChange: [{ type: Output }],
    endDate: [{ type: Input }],
    endDateChange: [{ type: Output }],
    disabled: [{ type: Input }],
    datePickerControl: [{ type: ViewChild, args: [NgbDatepicker, { static: false },] }],
    popover: [{ type: ViewChild, args: [NgbPopover, { static: true },] }]
};

class DwSecurityUserMenuComponent extends DwMenuComponent {
    constructor() {
        super(...arguments);
        this.category = DwMenuCategory.userMenu;
    }
    ngOnInit() {
        this.category = DwMenuCategory.userMenu;
        super.ngOnInit();
    }
}
DwSecurityUserMenuComponent.ɵfac = function DwSecurityUserMenuComponent_Factory(t) { return ɵDwSecurityUserMenuComponent_BaseFactory(t || DwSecurityUserMenuComponent); };
DwSecurityUserMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityUserMenuComponent, selectors: [["dw-security-user-menu"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["className", "dropdown-item  hand", 3, "menu", "menuLocation"]], template: function DwSecurityUserMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwSecurityUserMenuComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.routeHierarchy);
    } }, directives: [ɵngcc4.NgForOf, DwMenuLinkComponent], encapsulation: 2 });

class DwActionConfigService {
    constructor(uiConfigRegistryService, uiConfig) {
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.uiConfig = uiConfig;
    }
    getActionHandlers(itemName, actionTypes, returnAll) {
        const itemMatch = (item) => this.isActionMatch(item, actionTypes, returnAll);
        let actions = this.uiConfigRegistryService.getMdRegisteredItems(DwUiRegistryType.action, itemName, itemMatch);
        // actions = actions.filter(action => this.isActionMatch(action, actionTypes));
        return actions;
    }
    isActionMatch(action, actionTypes, returnAll) {
        if (!returnAll && actionTypes) {
            actionTypes = Array.isArray(actionTypes) ? actionTypes : [actionTypes];
            if (!actionTypes.find(at => at === action.actionType)) {
                return false;
            }
        }
        return true;
    }
    getFinalActionPreferences(actionPrefs, buttonDefaultsOverride) {
        if (!actionPrefs || !Array.isArray(actionPrefs)) {
            return [];
        }
        const finalActionPrefs = [];
        buttonDefaultsOverride = buttonDefaultsOverride || this.uiConfig.defaultButtonConfig;
        const actions = this.getActionHandlers();
        for (const actionPref of actionPrefs || []) {
            const newActionPref = deepCopy(actionPref);
            this.setActionDefaults(actions, newActionPref, buttonDefaultsOverride);
            finalActionPrefs.push(newActionPref);
        }
        return finalActionPrefs;
    }
    setActionDefaults(actions, actionPref, buttonDefaultsOverride) {
        actionPref.actionConfig = actionPref.actionConfig || {};
        const action = actions.find(a => a.keyName == actionPref.actionKey);
        if (action) {
            actionPref.buttonConfig = this.getFinalButtonConfig(actionPref, action, buttonDefaultsOverride);
            actionPref.menuConfig = this.getFinalMenuConfig(actionPref, action);
            actionPref.securityConfig = this.getFinalSecurityConfig(actionPref, action);
        }
    }
    getFinalButtonConfig(actionPref, action, buttonDefaultsOverride) {
        let buttonConfig = actionPref.buttonConfig || { useButtonDefaults: true };
        buttonConfig = Object.assign({}, buttonConfig);
        if (buttonConfig.useButtonDefaults) {
            buttonConfig = action.defaultButtonConfig || Object.assign({ useParentDisplay: true, buttonClass: 'btn btn-success', buttonType: DwButtonType.standard }, buttonDefaultsOverride);
        }
        buttonConfig = Object.assign({}, buttonConfig);
        if (buttonConfig.useParentDisplay) {
            buttonConfig.buttonText = actionPref.actionDisplay;
        }
        return buttonConfig;
    }
    getFinalMenuConfig(actionPref, action) {
        let menuConfig = actionPref.menuConfig || { useMenuDefaults: true };
        menuConfig = Object.assign({}, menuConfig);
        if (menuConfig.useMenuDefaults) {
            const menuGroupDisplay = menuConfig.menuGroupDisplay;
            menuConfig = Object.assign({}, action.defaultMenuConfig) || {
                useParentDisplay: true
            };
            menuConfig.menuGroupDisplay = menuGroupDisplay;
        }
        menuConfig = Object.assign({}, menuConfig);
        if (menuConfig.useParentDisplay) {
            menuConfig.menuDisplay = actionPref.actionDisplay;
        }
        return menuConfig;
    }
    getFinalSecurityConfig(actionPref, action) {
        let securityConfig = actionPref.securityConfig || { useSecurityDefaults: true };
        securityConfig = Object.assign({}, securityConfig);
        if (securityConfig.useSecurityDefaults) {
            securityConfig = Object.assign({}, action.defaultSecurityConfig);
        }
        securityConfig = Object.assign({}, securityConfig);
        return securityConfig;
    }
}
DwActionConfigService.ɵfac = function DwActionConfigService_Factory(t) { return new (t || DwActionConfigService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwUIConfigToken)); };
DwActionConfigService.ɵprov = ɵɵdefineInjectable({ factory: function DwActionConfigService_Factory() { return new DwActionConfigService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwUIConfigToken)); }, token: DwActionConfigService, providedIn: "root" });
DwActionConfigService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];

class DwActionMenuBuilderService {
    constructor(dwMenuHelperService, dwSecurityUserService, dwUiConfigRegistryService, dwActionExecutionService) {
        this.dwMenuHelperService = dwMenuHelperService;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwActionExecutionService = dwActionExecutionService;
        this.rootKey = 'root';
    }
    buildActionMenus(actionPrefs, actionFunc) {
        const actions = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action);
        const obs = [];
        for (const actionPref of actionPrefs) {
            const action = actions.find(a => a.keyName == actionPref.actionKey);
            obs.push(this.buildActionMenu(actionPref, action, actionFunc));
        }
        return combineLatest(obs)
            .pipe(map(menuBuilderResults => {
            return this.buildMenuHierarchy(menuBuilderResults);
        }));
    }
    buildMenuHierarchy(menuBuilderResults) {
        const menus = [];
        for (const menuBuilderResult of menuBuilderResults) {
            if (!menuBuilderResult.menu) {
                continue;
            }
            const menuGroup = this.getMenuGroup(menuBuilderResult.actionPreference, menus);
            const items = menuGroup ? menuGroup.items : menus;
            items.push(menuBuilderResult.menu);
        }
        return menus;
    }
    getMenuGroup(actionPref, menus) {
        if (actionPref.menuConfig && actionPref.menuConfig.menuGroupDisplay) {
            let menuGroup = menus.find(m => m.label == actionPref.menuConfig.menuGroupDisplay);
            if (!menuGroup) {
                menuGroup = {
                    label: actionPref.menuConfig.menuGroupDisplay,
                    items: []
                };
                menus.push(menuGroup);
            }
            return menuGroup;
        }
        return null;
    }
    buildActionMenu(actionPref, action, actionFunc) {
        const menuConfig = actionPref.menuConfig || {};
        if (!action) {
            const menuResult = {
                success: false,
                message: `Could not find action '${actionPref.actionKey} in registered actions.  Excluding menu ${actionPref.actionDisplay}`,
                actionPreference: actionPref
            };
            return of(menuResult);
        }
        if (action.defaultMenuConfig && action.defaultMenuConfig.useCustomMenus) {
            return this.buildCustomActionMenu(actionPref, action, actionFunc);
        }
        return this.buildBasicActionMenu(actionPref, action, actionFunc);
    }
    buildBasicActionMenu(actionPref, action, actionFunc) {
        const menuConfig = actionPref.menuConfig || {};
        const menu = {
            label: menuConfig.menuDisplay || actionPref.actionDisplay,
            icon: menuConfig.menuIconClass,
            styleClass: menuConfig.menuClass,
            command: (event) => { actionFunc(actionPref, event); },
        };
        const result = {
            success: true,
            actionPreference: actionPref,
            menu: menu
        };
        return of(result);
    }
    buildCustomActionMenu(actionPref, action, actionFunc) {
        const menuBuilderState = {
            actionFunc: actionFunc,
            actionPreference: actionPref,
            command: actionPref.actionKey,
            context: {},
            dwBrowserEvent: null
        };
        return this.dwActionExecutionService.callActionMethod(action.keyName, menuBuilderState, 'buildContextMenu');
    }
}
DwActionMenuBuilderService.ɵfac = function DwActionMenuBuilderService_Factory(t) { return new (t || DwActionMenuBuilderService)(ɵngcc0.ɵɵinject(DwMenuHelperService), ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwActionExecutionService)); };
DwActionMenuBuilderService.ɵprov = ɵɵdefineInjectable({ factory: function DwActionMenuBuilderService_Factory() { return new DwActionMenuBuilderService(ɵɵinject(DwMenuHelperService), ɵɵinject(DwSecurityUserService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwActionExecutionService)); }, token: DwActionMenuBuilderService, providedIn: "root" });
DwActionMenuBuilderService.ctorParameters = () => [
    { type: DwMenuHelperService },
    { type: DwSecurityUserService },
    { type: DwUiConfigRegistryService },
    { type: DwActionExecutionService }
];

function isFirstChange(changes) {
    for (const propName in changes) {
        if (changes.hasOwnProperty(propName)) {
            const change = changes[propName];
            if (change && change.firstChange) {
                return true;
            }
        }
    }
    return false;
}

var __decorate$k = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$i = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwActionGroupConfigComponent {
    constructor(uiConfigRegistryService, actionConfigService, actionMenuBuilderService, uiConfig, cdr) {
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.actionConfigService = actionConfigService;
        this.actionMenuBuilderService = actionMenuBuilderService;
        this.uiConfig = uiConfig;
        this.cdr = cdr;
        this.actionPreferences = [];
        this.actionPreferencesChange = new EventEmitter();
        this.displayActionPreferences = [];
        this.showButtonConfig = true;
        this.showMenuConfig = false;
        this.showEnableVisibleConfig = false;
        // @DwInputConverter(booleanConverter)
        // @Input() useSmallList: boolean = false;
        this.size = DwConfigListSize.medium;
        this.actions = [];
        this.availableActions = [];
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Action',
            displayField: 'actionDisplay',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Action',
            showListActionBar: true,
        };
        this.setupControl();
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.setupControl();
        }
    }
    setupControl() {
        this.configContext = this.configContext || {};
        this.actions = this.actionConfigService.getActionHandlers(this.configContext.itemName, this.actionTypes);
        this.setupAvailableActions();
        if (this.actionPreferences.length > 0) {
            this.setSelectedItem(this.actionPreferences[0]);
        }
        else {
            this.selectedItem = null;
        }
        // this.finalButtonContainer = this.buttonContainerClass || 'dw-section-container-buttons-left';
        // this.buttonContainerStyle = this.uiConfigRegistryService.getRegisteredItem<DwUiButtonContainerStyleReference>(DwUiRegistryType.buttonContainerStyles, this.buttonContainerStyleKey || '');
        this.buildDisplayActionPreferences();
    }
    setSelectedItem(item) {
        this.selectedItem = item;
    }
    reorderList() {
        this.onChange(null);
    }
    buildDisplayActionPreferences() {
        this.displayActionPreferences = this.actionConfigService.getFinalActionPreferences(this.actionPreferences);
        this.actionMenuBuilderService.buildActionMenus(this.displayActionPreferences, () => { })
            .subscribe(menus => {
            this.testMenus = menus;
        });
    }
    addItem(action) {
        const actionPref = {
            actionKey: action.keyName,
            actionDisplay: action.display,
            actionConfig: Object.assign({}, action.configData) || {},
            buttonConfig: Object.assign(Object.assign({}, action.defaultButtonConfig || this.uiConfig.defaultButtonConfig), { useButtonDefaults: true }),
            menuConfig: Object.assign(Object.assign({}, action.defaultMenuConfig), { useMenuDefaults: true }),
            securityConfig: Object.assign(Object.assign({}, action.defaultSecurityConfig), { useSecurityDefaults: true }),
            confirmConfig: Object.assign(Object.assign({}, action.defaultConfirmConfig), { useConfirmDefaults: true })
        };
        this.actionPreferences = [...this.actionPreferences, actionPref];
        // this.actionPreferences.push(actionPref);
        this.onChange(actionPref);
        this.cdr.detectChanges();
    }
    removeItem(actionRef) {
        const index = this.actionPreferences.indexOf(actionRef);
        this.actionPreferences.splice(index, 1);
        this.onChange(null);
        if (this.selectedItem == actionRef) {
            this.selectedItem = null;
        }
    }
    removeAll() {
        this.actionPreferences.length = 0;
        this.selectedItem = null;
        this.onChange(null);
    }
    onChange(selectedItemChanged) {
        this.setupAvailableActions();
        this.actionPreferencesChange.emit(this.actionPreferences);
        this.buildDisplayActionPreferences();
    }
    setupAvailableActions() {
        this.availableActions = [];
        for (const action of this.actions) {
            let add = true;
            if (action.allowOnce) {
                add = !this.actionPreferences.find(ap => ap.actionKey == action.keyName);
            }
            if (add) {
                this.availableActions.push(action);
            }
        }
    }
}
DwActionGroupConfigComponent.ɵfac = function DwActionGroupConfigComponent_Factory(t) { return new (t || DwActionGroupConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwActionMenuBuilderService), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwActionGroupConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwActionGroupConfigComponent, selectors: [["dw-action-group-config"]], inputs: { actionPreferences: "actionPreferences", showButtonConfig: "showButtonConfig", showMenuConfig: "showMenuConfig", showEnableVisibleConfig: "showEnableVisibleConfig", size: "size", configContext: "configContext", actionConfigPreferences: "actionConfigPreferences", actionTypes: "actionTypes", buttonContainerStyleKey: "buttonContainerStyleKey" }, outputs: { actionPreferencesChange: "actionPreferencesChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 16, vars: 13, consts: [[1, "action-container"], ["convertPreferences", "false", 3, "hidden", "actionPreferences", "buttonContainerStyleKey"], [3, "hidden", "click"], ["sampleMenu", ""], [4, "ngIf"], ["appendTo", "body", "baseZIndex", "10000", 3, "target", "model"], ["contextMenu", ""], [3, "items", "config", "selectedItem", "size", "selectedItemChange", "reorder", "removeItem"], ["addItemsTab", ""], ["class", "dw-field-item", 4, "ngFor", "ngForOf"], ["actionBar", ""], [1, "btn-sm", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], [3, "actionPreference", "actionConfigPreferences", "actions", "showButtonConfig", "showMenuConfig", "configContext", "showEnableVisibleConfig", "actionPreferenceChange", 4, "ngIf"], [1, "dw-field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add Action", 1, "fa", "fa-plus-circle", "hand"], [3, "actionPreference", "actionConfigPreferences", "actions", "showButtonConfig", "showMenuConfig", "configContext", "showEnableVisibleConfig", "actionPreferenceChange"]], template: function DwActionGroupConfigComponent_Template(rf, ctx) { if (rf & 1) {
        const _r11 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-action-bar", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2, 3);
        ɵngcc0.ɵɵlistener("click", function DwActionGroupConfigComponent_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r11); const _r2 = ɵngcc0.ɵɵreference(7); return _r2.show(); });
        ɵngcc0.ɵɵtext(4, "Sample Context Menu");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwActionGroupConfigComponent_div_5_Template, 2, 0, "div", 4);
        ɵngcc0.ɵɵelement(6, "p-contextMenu", 5, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "dw-ui-config-list", 7);
        ɵngcc0.ɵɵlistener("selectedItemChange", function DwActionGroupConfigComponent_Template_dw_ui_config_list_selectedItemChange_8_listener($event) { return ctx.setSelectedItem($event); })("reorder", function DwActionGroupConfigComponent_Template_dw_ui_config_list_reorder_8_listener() { return ctx.reorderList(); })("removeItem", function DwActionGroupConfigComponent_Template_dw_ui_config_list_removeItem_8_listener($event) { return ctx.removeItem($event); });
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtemplate(10, DwActionGroupConfigComponent_div_10_Template, 4, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "button", 11);
        ɵngcc0.ɵɵlistener("click", function DwActionGroupConfigComponent_Template_button_click_12_listener() { return ctx.removeAll(); });
        ɵngcc0.ɵɵtext(13, "Remove All");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵtemplate(15, DwActionGroupConfigComponent_dw_action_config_15_Template, 1, 7, "dw-action-config", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showButtonConfig)("actionPreferences", ctx.displayActionPreferences)("buttonContainerStyleKey", ctx.buttonContainerStyleKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showMenuConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showButtonConfig && ctx.displayActionPreferences.length == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("target", _r0)("model", ctx.testMenus);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("items", ctx.actionPreferences)("config", ctx.listConfig)("selectedItem", ctx.selectedItem)("size", ctx.size);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availableActions);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItem);
    } }, directives: function () { return [DwActionBarComponent, ɵngcc4.NgIf, ɵngcc7.ContextMenu, DwUiConfigListComponent, ɵngcc4.NgForOf, DwActionConfigComponent]; }, styles: [".action-container[_ngcontent-%COMP%]{margin:4px;min-height:51px;overflow:auto}"] });
DwActionGroupConfigComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwActionConfigService },
    { type: DwActionMenuBuilderService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: ChangeDetectorRef }
];
DwActionGroupConfigComponent.propDecorators = {
    actionPreferences: [{ type: Input }],
    actionPreferencesChange: [{ type: Output }],
    actionConfigPreferences: [{ type: Input }],
    showButtonConfig: [{ type: Input }],
    showMenuConfig: [{ type: Input }],
    showEnableVisibleConfig: [{ type: Input }],
    actionTypes: [{ type: Input }],
    configContext: [{ type: Input }],
    buttonContainerStyleKey: [{ type: Input }],
    size: [{ type: Input }]
};
__decorate$k([
    DwInputConverter(booleanConverter),
    __metadata$i("design:type", Boolean)
], DwActionGroupConfigComponent.prototype, "showButtonConfig", void 0);
__decorate$k([
    DwInputConverter(booleanConverter),
    __metadata$i("design:type", Boolean)
], DwActionGroupConfigComponent.prototype, "showMenuConfig", void 0);
__decorate$k([
    DwInputConverter(booleanConverter),
    __metadata$i("design:type", Boolean)
], DwActionGroupConfigComponent.prototype, "showEnableVisibleConfig", void 0);

class DwChildConfigBaseComponent {
    constructor() {
        this.configChange = new EventEmitter();
        this.isValidChange = new EventEmitter();
        this.destroyed = false;
        this.subscriptions = [];
    }
    ngOnChanges(changes) {
        /*  if (changes.config && !changes.config.firstChange) {
           this.initConfig();
         } */
        this.initConfig();
    }
    ngOnDestroy() {
        this.destroyed = true;
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setupComponent() {
        this.initConfig();
    }
    initConfig() {
        if (isEmptyObject(this.config) || !this.config) {
            this.config = this.getDefaultConfig();
            this.onChange();
        }
    }
    onChange() {
        this.configChange.emit(this.config);
    }
    setValid(isValid) {
        this.isValid = isValid;
        this.isValidChange.emit(isValid);
    }
}
DwChildConfigBaseComponent.ɵfac = function DwChildConfigBaseComponent_Factory(t) { return new (t || DwChildConfigBaseComponent)(); };
DwChildConfigBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwChildConfigBaseComponent, inputs: { config: "config", isValid: "isValid", configContext: "configContext" }, outputs: { configChange: "configChange", isValidChange: "isValidChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwChildConfigBaseComponent.propDecorators = {
    config: [{ type: Input }],
    configChange: [{ type: Output }],
    configContext: [{ type: Input }],
    isValid: [{ type: Input }],
    isValidChange: [{ type: Output }]
};

var __decorate$l = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$j = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwActionConfigComponent {
    constructor(cdr, uiConfig) {
        this.cdr = cdr;
        this.uiConfig = uiConfig;
        this.actionPreferenceChange = new EventEmitter();
        this.actions = [];
        this.basicSettingsDisplay = 'Basic Settings';
        this.showActionDisplay = true;
        this.showEnableVisibleConfig = false;
        this.showSecurityConfig = true;
        this.selectFirstTab = true;
        this.permissionLookupId = DevwareMetaDataLookups.AppPermissionAllItems;
        this.ignoreFormChange = false;
        this.subscriptions = [];
        this.expressionVisibilityConfigComponent = uiConfig.expressionVisibilityConfigComponent;
    }
    ngOnInit() {
        this.configContext = this.configContext || {};
        this.buildForm();
        this.setFormData();
    }
    ngOnChanges(changes) {
        if (changes.actionPreference && !changes.actionPreference.firstChange) {
            if (!this.actionPreference) {
                this.actionPreference = {};
            }
            this.setFormData();
        }
    }
    onChange() {
        this.actionPreferenceChange.emit(this.actionPreference);
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setFormData() {
        this.ignoreFormChange = true;
        this.formGroup.reset({}, { emitEvent: false });
        var finalActionPref = Object.assign({
            buttonConfig: {},
            menuConfig: {},
            securityConfig: {},
            confirmConfig: {},
            enableVisibleConfig: {},
        }, this.actionPreference);
        this.formGroup.patchValue(finalActionPref);
        this.actionChanged(this.actionPreference.actionKey);
        this.ignoreFormChange = false;
        this.cdr.detectChanges();
    }
    buildForm() {
        this.actionTypeFC = new FormControl();
        this.actionConfigFC = new FormControl();
        this.additionalActionConfigFC = new FormControl();
        this.buttonConfigFC = new FormControl();
        this.menuConfigFC = new FormControl();
        this.securityConfigFC = new FormControl();
        this.confirmConfigFC = new FormControl();
        this.enableVisibleConfigFC = new FormControl();
        this.formGroup = new FormGroup({
            actionKey: this.actionTypeFC,
            actionConfig: this.actionConfigFC,
            additionalActionConfig: this.additionalActionConfigFC,
            actionDisplay: new FormControl(),
            buttonConfig: this.buttonConfigFC,
            menuConfig: this.menuConfigFC,
            securityConfig: this.securityConfigFC,
            confirmConfig: this.confirmConfigFC,
            enableVisibleConfig: this.enableVisibleConfigFC
        });
        this.subscriptions.push(this.actionTypeFC.valueChanges.subscribe(actionKey => {
            if (this.ignoreFormChange) {
                return;
            }
            this.actionChanged(actionKey);
        }));
        this.subscriptions.push(this.formGroup.valueChanges.subscribe(value => {
            if (this.ignoreFormChange) {
                return;
            }
            // Copy all new properties to existing object
            this.actionPreference = Object.assign(this.actionPreference, value);
            this.actionPreferenceChange.emit(this.actionPreference);
            this.cdr.detectChanges();
        }));
    }
    buttonConfigChange(buttonConfig) {
        this.buttonConfigFC.setValue(buttonConfig);
    }
    menuConfigChange(menuConfig) {
        this.menuConfigFC.setValue(menuConfig);
    }
    securityConfigChange(securityConfig) {
        this.securityConfigFC.setValue(securityConfig);
    }
    confirmConfigChange(configConfig) {
        this.confirmConfigFC.setValue(configConfig);
    }
    enableVisibleConfigChange(config) {
        this.enableVisibleConfigFC.setValue(config);
    }
    actionChanged(actionKey) {
        const newActionItem = this.actions.find(ai => ai.keyName == actionKey);
        if (this.modeActionConfigInstance) {
            this.configureModeActionConfigComponent(this.modeActionConfigInstance);
        }
        if (newActionItem && this.currentActionItem && this.currentActionItem.keyName == newActionItem.keyName) {
            if (this.actionConfigInstance) {
                this.configureActionConfigComponent(this.actionConfigInstance);
            }
            return;
        }
        this.currentActionItem = this.actions.find(ai => ai.keyName == actionKey);
        if (this.ignoreFormChange) {
            return;
        }
        this.setActionConfigDefaults();
        this.cdr.markForCheck();
    }
    setActionConfigDefaults() {
        if (!this.currentActionItem) {
            return;
        }
        const existingActionPreference = this.formGroup.getRawValue();
        const newActionPreference = Object.assign(Object.assign({}, existingActionPreference), { buttonConfig: Object.assign(Object.assign({}, this.currentActionItem.defaultButtonConfig), { useButtonDefaults: true }), menuConfig: Object.assign(Object.assign({}, this.currentActionItem.defaultMenuConfig), { useMenuDefaults: true }), securityConfig: Object.assign(Object.assign({}, this.currentActionItem.defaultSecurityConfig), { useSecurityDefaults: true }), confirmConfig: Object.assign(Object.assign({}, this.currentActionItem.defaultConfirmConfig), { useConfirmDefaults: true }) });
        this.formGroup.patchValue(newActionPreference);
    }
    configureActionConfigComponent(instance) {
        this.actionConfigInstance = instance;
        if (this.actionConfigSubscription) {
            this.actionConfigSubscription.unsubscribe();
        }
        if (instance) {
            // Determine which config type is being used
            if (instance instanceof DwChildConfigBaseComponent) {
                // Prefered config type going forward
                this.setupConfigBaseComponent(instance);
            }
            else {
                // backward compatible config setup
                this.setupActionConfig(instance);
            }
        }
    }
    configureModeActionConfigComponent(instance) {
        this.modeActionConfigInstance = instance;
        if (this.actionModeConfigSubscription) {
            this.actionModeConfigSubscription.unsubscribe();
        }
        if (instance) {
            // Determine which config type is being used
            if (instance instanceof DwChildConfigBaseComponent) {
                // Prefered config type going forward
                this.setupModeConfigBaseComponent(instance);
            }
            // else {
            //   // backward compatible config setup
            //   this.setupActionConfig(instance);
            // }
        }
    }
    setupConfigBaseComponent(configBase) {
        configBase.config = this.actionConfigFC.value;
        configBase.configContext = this.configContext,
            configBase.setupComponent();
        this.actionConfigSubscription = configBase.configChange.subscribe(value => {
            this.actionConfigFC.setValue(value);
            this.cdr.markForCheck();
        });
    }
    setupModeConfigBaseComponent(configBase) {
        configBase.config = this.additionalActionConfigFC.value;
        configBase.configContext = this.configContext,
            configBase.setupComponent();
        this.actionModeConfigSubscription = configBase.configChange.subscribe(value => {
            this.additionalActionConfigFC.setValue(value);
            this.cdr.markForCheck();
        });
    }
    setupActionConfig(instance) {
        this.actionConfigInstance.configContext = this.configContext;
        this.actionConfigInstance.setupForm();
        this.actionConfigSubscription = this.actionConfigInstance.actionConfigFG.valueChanges
            .subscribe(value => {
            this.actionConfigFC.setValue(value);
            this.cdr.markForCheck();
        });
        this.actionConfigInstance.actionConfigFG.patchValue(this.actionConfigFC.value || {});
        this.actionConfigInstance.setupComplete();
        this.actionConfigFC.updateValueAndValidity();
        this.cdr.markForCheck();
    }
}
DwActionConfigComponent.ɵfac = function DwActionConfigComponent_Factory(t) { return new (t || DwActionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken)); };
DwActionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwActionConfigComponent, selectors: [["dw-action-config"]], inputs: { actions: "actions", basicSettingsDisplay: "basicSettingsDisplay", showActionDisplay: "showActionDisplay", showEnableVisibleConfig: "showEnableVisibleConfig", showSecurityConfig: "showSecurityConfig", selectFirstTab: "selectFirstTab", configContext: "configContext", actionPreference: "actionPreference", actionConfigPreferences: "actionConfigPreferences", showButtonConfig: "showButtonConfig", showMenuConfig: "showMenuConfig" }, outputs: { actionPreferenceChange: "actionPreferenceChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 17, vars: 13, consts: [[3, "formGroup"], [3, "multiple"], [3, "header", "selected"], ["dwRow", "", 4, "ngIf"], ["dwRow", ""], ["dwCol", "12"], ["formControlName", "actionKey", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["header", "Action Security", 4, "ngIf"], ["header", "Button Configuration", 4, "ngIf"], ["header", "Context Menu Configuration", 4, "ngIf"], ["header", "Visible/Enabled Configuration", 4, "ngIf"], ["header", "Confirm Dialog Configuration", 4, "ngIf"], ["formControlName", "actionDisplay", 1, "form-control"], [3, "ngValue"], [3, "component", "configure"], ["header", "Action Security"], [3, "config", "configContext", "configChange"], ["header", "Button Configuration"], ["header", "Context Menu Configuration"], ["header", "Visible/Enabled Configuration"], [3, "component", "config", "configContext", "configChange"], ["header", "Confirm Dialog Configuration"]], template: function DwActionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p-accordion", 1);
        ɵngcc0.ɵɵelementStart(2, "p-accordionTab", 2);
        ɵngcc0.ɵɵtemplate(3, DwActionConfigComponent_div_3_Template, 5, 0, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "label");
        ɵngcc0.ɵɵtext(7, "Action");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "select", 6);
        ɵngcc0.ɵɵtemplate(9, DwActionConfigComponent_option_9_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, DwActionConfigComponent_div_10_Template, 3, 1, "div", 3);
        ɵngcc0.ɵɵtemplate(11, DwActionConfigComponent_div_11_Template, 3, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DwActionConfigComponent_p_accordionTab_12_Template, 2, 2, "p-accordionTab", 8);
        ɵngcc0.ɵɵtemplate(13, DwActionConfigComponent_p_accordionTab_13_Template, 2, 2, "p-accordionTab", 9);
        ɵngcc0.ɵɵtemplate(14, DwActionConfigComponent_p_accordionTab_14_Template, 2, 2, "p-accordionTab", 10);
        ɵngcc0.ɵɵtemplate(15, DwActionConfigComponent_p_accordionTab_15_Template, 2, 3, "p-accordionTab", 11);
        ɵngcc0.ɵɵtemplate(16, DwActionConfigComponent_p_accordionTab_16_Template, 2, 2, "p-accordionTab", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("multiple", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", ctx.basicSettingsDisplay)("selected", ctx.selectFirstTab);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showActionDisplay);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.actions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigPreferences == null ? null : ctx.actionConfigPreferences.additionalConfigComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentActionItem == null ? null : ctx.currentActionItem.configComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSecurityConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showButtonConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMenuConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", true || ctx.showEnableVisibleConfig && ctx.expressionVisibilityConfigComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentActionItem == null ? null : ctx.currentActionItem.defaultConfirmConfig == null ? null : ctx.currentActionItem.defaultConfirmConfig.showDialogConfig);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDynamicLoaderComponent, DwSecurityCheckConfigComponent, DwButtonConfigComponent, DwContextMenuConfigComponent, DwUiChildConfigHostComponent, DwConfirmDialogConfigComponent]; }, styles: [""] });
DwActionConfigComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];
DwActionConfigComponent.propDecorators = {
    actionPreference: [{ type: Input }],
    actionPreferenceChange: [{ type: Output }],
    actionConfigPreferences: [{ type: Input }],
    actions: [{ type: Input }],
    configContext: [{ type: Input }],
    basicSettingsDisplay: [{ type: Input }],
    showActionDisplay: [{ type: Input }],
    showButtonConfig: [{ type: Input }],
    showMenuConfig: [{ type: Input }],
    showEnableVisibleConfig: [{ type: Input }],
    showSecurityConfig: [{ type: Input }],
    selectFirstTab: [{ type: Input }]
};
__decorate$l([
    DwInputConverter(booleanConverter),
    __metadata$j("design:type", Boolean)
], DwActionConfigComponent.prototype, "showActionDisplay", void 0);
__decorate$l([
    DwInputConverter(booleanConverter),
    __metadata$j("design:type", Boolean)
], DwActionConfigComponent.prototype, "showButtonConfig", void 0);
__decorate$l([
    DwInputConverter(booleanConverter),
    __metadata$j("design:type", Boolean)
], DwActionConfigComponent.prototype, "showMenuConfig", void 0);
__decorate$l([
    DwInputConverter(booleanConverter),
    __metadata$j("design:type", Boolean)
], DwActionConfigComponent.prototype, "showEnableVisibleConfig", void 0);
__decorate$l([
    DwInputConverter(booleanConverter),
    __metadata$j("design:type", Boolean)
], DwActionConfigComponent.prototype, "showSecurityConfig", void 0);
__decorate$l([
    DwInputConverter(booleanConverter),
    __metadata$j("design:type", Boolean)
], DwActionConfigComponent.prototype, "selectFirstTab", void 0);

class DwButtonBarComponent {
}
DwButtonBarComponent.ɵfac = function DwButtonBarComponent_Factory(t) { return new (t || DwButtonBarComponent)(); };
DwButtonBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwButtonBarComponent, selectors: [["dw-button-bar"]], ngContentSelectors: _c42, decls: 5, vars: 0, consts: [[1, "dw-button-bar-container"], [1, "pull-left"], [1, "pull-right"]], template: function DwButtonBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c41);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""], encapsulation: 2 });

class DwButtonConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {
            useButtonDefaults: true,
        };
    }
}
DwButtonConfigComponent.ɵfac = function DwButtonConfigComponent_Factory(t) { return ɵDwButtonConfigComponent_BaseFactory(t || DwButtonConfigComponent); };
DwButtonConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwButtonConfigComponent, selectors: [["dw-button-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["value", "standard"], ["value", "iconOnly"], ["value", "iconOnlyNoText"], ["value", "link"], ["title", "Displays when the action is executing"], ["title", "Includes in a button group (requires a button group action before this action)", 1, "fa", "fa-info-circle"], ["title", "Adds a divider before this action in the button group drop down", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "disabled", "ngModelChange"]], template: function DwButtonConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwButtonConfigComponent_ng_container_0_Template, 8, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });

var __decorate$m = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$k = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwActionBarComponent {
    constructor(actionConfigService, uiConfigRegistryService) {
        this.actionConfigService = actionConfigService;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.actionClick = new EventEmitter();
        this.useContainerStyle = true;
        this.convertPreferences = true;
        this.subscriptions = [];
        this.firingActionIndex = -1;
        this.instances = [];
    }
    ngOnDestroy() {
        for (const sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }
    ngOnInit() {
        this.buildFinalActionPreferences();
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.buildFinalActionPreferences();
        }
        if (changes.firingActionPreference) {
            this.setupActionFiring();
        }
    }
    setupActionFiring() {
        this.firingActionIndex = -1;
        if (this.firingActionPreference) {
            this.firingActionIndex = this.finalActionPreferences.findIndex(ap => ap.actionDisplay == this.firingActionPreference.actionDisplay);
        }
    }
    trackByMethod(index, el) {
        return index;
    }
    click(actionPref, isMiddleClick = false, event) {
        const actionEvent = {
            actionPreference: actionPref,
            dwBrowserEvent: getDwBrowserEvent(event),
            actionContext: this.actionContext
        };
        this.actionClick.emit(actionEvent);
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    }
    auxClick(actionPref, event) {
        const actionEvent = {
            actionPreference: actionPref,
            dwBrowserEvent: getDwBrowserEvent(event),
            actionContext: this.actionContext
        };
        this.actionClick.emit(actionEvent);
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
    }
    buildFinalActionPreferences() {
        if (this.convertPreferences) {
            this.finalActionPreferences = this.actionConfigService.getFinalActionPreferences(this.actionPreferences);
        }
        else {
            this.finalActionPreferences = this.actionPreferences;
        }
        this.buttonContainerStyle = this.uiConfigRegistryService.getRegisteredItem(DwUiRegistryType.buttonContainerStyles, this.buttonContainerStyleKey || '');
        const actionRegistrations = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action, false);
        this.actionRegistrations = [];
        for (const actionPref of this.finalActionPreferences) {
            const actionReg = actionRegistrations.find(ar => ar.keyName == actionPref.actionKey);
            if (actionReg) {
                this.actionRegistrations.push(actionReg);
            }
            else {
                console.warn(`Action registration ${actionPref.actionKey} - omitting from Action bar`);
            }
        }
        this.updateComponentActionPref();
    }
    configureComponent(componentInstance, actionPreference) {
        if (!componentInstance) {
            return;
        }
        this.instances.push({ actionPreference: actionPreference, componentInstance: componentInstance });
        componentInstance.actionPreference = actionPreference;
        componentInstance.actionContext = this.actionContext;
        componentInstance.allActionPreferences = this.finalActionPreferences;
        componentInstance;
        if (componentInstance.setupComponent) {
            componentInstance.setupComponent();
        }
        if (componentInstance.executeAction) {
            this.subscriptions.push(componentInstance.executeAction.subscribe((event) => {
                this.click(event.actionPreference, false, event.event);
            }));
        }
    }
    updateComponentActionPref() {
        for (const instance of this.instances) {
            for (const actionPref of this.finalActionPreferences) {
                if (actionPref.actionKey == instance.actionPreference.actionKey) {
                    const actionKeyCount = this.finalActionPreferences.filter(ap => ap.actionKey == actionPref.actionKey).length;
                    // TODO: This is probablematic since the action key could be used more than once in the action bar (This might however cause a bug)
                    if (actionKeyCount == 1) {
                        instance.componentInstance.actionPreference = actionPref;
                    }
                    else {
                        console.warn(`Action key ${actionPref.actionKey} used more than once in action bar - not updating component preference`);
                    }
                }
            }
        }
    }
}
DwActionBarComponent.ɵfac = function DwActionBarComponent_Factory(t) { return new (t || DwActionBarComponent)(ɵngcc0.ɵɵdirectiveInject(DwActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwActionBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwActionBarComponent, selectors: [["dw-action-bar"]], inputs: { useContainerStyle: "useContainerStyle", convertPreferences: "convertPreferences", actionPreferences: "actionPreferences", firingActionPreference: "firingActionPreference", actionContext: "actionContext", buttonContainerStyleKey: "buttonContainerStyleKey" }, outputs: { actionClick: "actionClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 4, vars: 2, consts: [[4, "ngIf"], ["actionButtons", ""], [3, "ngClass"], [4, "ngTemplateOutlet"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "ngSwitch"], [3, "buttonConfig", "firing", "hidden", "click", "auxClick", "middleclick", 4, "ngSwitchDefault"], [3, "component", "configure", 4, "ngSwitchCase"], [3, "component", "configure"], [3, "buttonConfig", "firing", "hidden", "click", "auxClick", "middleclick"]], template: function DwActionBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DwActionBarComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, DwActionBarComponent_ng_container_1_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, DwActionBarComponent_ng_template_2_Template, 2, 2, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.useContainerStyle && (ctx.finalActionPreferences == null ? null : ctx.finalActionPreferences.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.useContainerStyle);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc4.NgTemplateOutlet, ɵngcc4.NgForOf, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchDefault, ɵngcc4.NgSwitchCase, DwDynamicLoaderComponent, DwButtonComponent, DwMiddleClickDirective]; }, encapsulation: 2 });
DwActionBarComponent.ctorParameters = () => [
    { type: DwActionConfigService },
    { type: DwUiConfigRegistryService }
];
DwActionBarComponent.propDecorators = {
    actionPreferences: [{ type: Input }],
    actionClick: [{ type: Output }],
    firingActionPreference: [{ type: Input }],
    actionContext: [{ type: Input }],
    useContainerStyle: [{ type: Input }],
    buttonContainerStyleKey: [{ type: Input }],
    convertPreferences: [{ type: Input }]
};
__decorate$m([
    DwInputConverter(booleanConverter),
    __metadata$k("design:type", Boolean)
], DwActionBarComponent.prototype, "useContainerStyle", void 0);
__decorate$m([
    DwInputConverter(booleanConverter),
    __metadata$k("design:type", Boolean)
], DwActionBarComponent.prototype, "convertPreferences", void 0);

class DwContextMenuConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {
            useMenuDefaults: true,
        };
    }
}
DwContextMenuConfigComponent.ɵfac = function DwContextMenuConfigComponent_Factory(t) { return ɵDwContextMenuConfigComponent_BaseFactory(t || DwContextMenuConfigComponent); };
DwContextMenuConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContextMenuConfigComponent, selectors: [["dw-context-menu-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], [1, "form-control", 3, "ngModel", "ngModelChange"], ["value", "none"], ["value", "single"], ["value", "multiple"]], template: function DwContextMenuConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwContextMenuConfigComponent_ng_container_0_Template, 13, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc10.InputSwitch, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });

var __decorate$n = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$l = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwSecurityCheckConfigComponent extends DwChildConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.hideSecurityDefault = false;
    }
    ;
    getDefaultConfig() {
        return {
            useSecurityDefaults: true,
        };
    }
}
DwSecurityCheckConfigComponent.ɵfac = function DwSecurityCheckConfigComponent_Factory(t) { return ɵDwSecurityCheckConfigComponent_BaseFactory(t || DwSecurityCheckConfigComponent); };
DwSecurityCheckConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityCheckConfigComponent, selectors: [["dw-security-check-config"]], inputs: { hideSecurityDefault: "hideSecurityDefault" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", "", 3, "hidden"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", ""], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["name", "permission", 3, "ngModel", "ngModelChange"]], template: function DwSecurityCheckConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwSecurityCheckConfigComponent_ng_container_0_Template, 8, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwSecurityPermissionSelectComponent]; }, encapsulation: 2 });
DwSecurityCheckConfigComponent.propDecorators = {
    hideSecurityDefault: [{ type: Input }]
};
__decorate$n([
    DwInputConverter(booleanConverter),
    __metadata$l("design:type", Boolean)
], DwSecurityCheckConfigComponent.prototype, "hideSecurityDefault", void 0);

var __decorate$o = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$m = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* import { booleanConverter } from '../../../../devware-core/utils/dw-input-converters.function';
import { DwInputConverter } from '../../../../devware-core/utils/dw-input.converter.decorator'; */
class DwSecurityPermissionSelectComponent extends DwControlBaseComponent {
    constructor(securityRepository) {
        super();
        this.securityRepository = securityRepository;
        this.showBlank = true;
        this.blankOptionText = 'None';
        this.usePermissionMeaning = true;
        this.showFilter = true;
        this.permissionGroups = [];
    }
    ngOnInit() {
        this.setupPermissionOptions();
    }
    setupPermissionOptions() {
        this.securityRepository.getPermissions()
            .subscribe(permissions => {
            this.permissionGroups = this.buildPermissionGrops(permissions);
            // this.permissionGroups = this.convertPermissions(permissions);
        });
    }
    buildPermissionGrops(permissions) {
        const appPermissions = permissions.filter(p => !p.PermissionMeaning || p.PermissionMeaning.indexOf('Ent_') != 0);
        const entPermissions = permissions.filter(p => p.PermissionMeaning && p.PermissionMeaning.indexOf('Ent_') == 0);
        return [
            {
                label: 'App',
                items: this.convertPermissions(appPermissions)
            },
            {
                label: 'CAP',
                items: this.convertPermissions(entPermissions)
            },
        ];
    }
    convertPermissions(permissions) {
        return permissions.map(permission => {
            return {
                label: permission.PermissionDisplay,
                value: this.usePermissionMeaning ? permission.PermissionMeaning : permission.AppPermissionId,
            };
        });
    }
}
DwSecurityPermissionSelectComponent.ɵfac = function DwSecurityPermissionSelectComponent_Factory(t) { return new (t || DwSecurityPermissionSelectComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken)); };
DwSecurityPermissionSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityPermissionSelectComponent, selectors: [["dw-security-permission-select"]], inputs: { showBlank: "showBlank", blankOptionText: "blankOptionText", usePermissionMeaning: "usePermissionMeaning", showFilter: "showFilter" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwSecurityPermissionSelectComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "mb-3"], ["appendTo", "body", 3, "id", "options", "group", "showClear", "ngModel", "filter", "placeholder", "ngModelChange"]], template: function DwSecurityPermissionSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p-dropdown", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityPermissionSelectComponent_Template_p_dropdown_ngModelChange_1_listener($event) { return ctx.value = $event; })("ngModelChange", function DwSecurityPermissionSelectComponent_Template_p_dropdown_ngModelChange_1_listener($event) { return ctx.setValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(9, _c43));
        ɵngcc0.ɵɵproperty("id", ctx.id)("options", ctx.permissionGroups)("group", true)("showClear", true)("ngModel", ctx.value)("filter", ctx.showFilter)("placeholder", ctx.showBlank ? ctx.blankOptionText : "");
    } }, directives: [ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwSecurityPermissionSelectComponent.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] }
];
DwSecurityPermissionSelectComponent.propDecorators = {
    showBlank: [{ type: Input }],
    blankOptionText: [{ type: Input }],
    usePermissionMeaning: [{ type: Input }],
    showFilter: [{ type: Input }]
};
__decorate$o([
    DwInputConverter(booleanConverter),
    __metadata$m("design:type", Boolean)
], DwSecurityPermissionSelectComponent.prototype, "showBlank", void 0);
__decorate$o([
    DwInputConverter(booleanConverter),
    __metadata$m("design:type", Boolean)
], DwSecurityPermissionSelectComponent.prototype, "usePermissionMeaning", void 0);
__decorate$o([
    DwInputConverter(booleanConverter),
    __metadata$m("design:type", Boolean)
], DwSecurityPermissionSelectComponent.prototype, "showFilter", void 0);

class DwConfirmDialogConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {
            useConfirmDefaults: true,
        };
    }
}
DwConfirmDialogConfigComponent.ɵfac = function DwConfirmDialogConfigComponent_Factory(t) { return ɵDwConfirmDialogConfigComponent_BaseFactory(t || DwConfirmDialogConfigComponent); };
DwConfirmDialogConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwConfirmDialogConfigComponent, selectors: [["dw-confirm-dialog-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelOptions", "ngModelChange"]], template: function DwConfirmDialogConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwConfirmDialogConfigComponent_ng_container_0_Template, 8, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor], encapsulation: 2 });

var __decorate$p = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$n = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwTreeSelect {
    constructor() {
        this.dropDownHeight = 300;
        this.selectionChange = new EventEmitter();
        this.visible = false;
        this.id = Math.floor(Math.random() * 1000);
        this.firstTimeLoad = true;
        this.ignoreNext = false;
    }
    click(event) {
        if (this.firstTimeLoad) {
            this.dropDownEl = document.getElementById(this.id);
            document.body.appendChild(this.dropDownEl);
            this.firstTimeLoad = false;
        }
        this.showDropDown();
    }
    setPosition() {
        const el = this.targetElement.nativeElement;
        const position = el.getBoundingClientRect();
        this.dropDownEl.style.top = position.height + position.top - 2 + 'px';
        this.dropDownEl.style.left = position.left + 'px';
        this.dropDownEl.style.width = position.width + 'px';
        this.dropDownEl.style.height = this.dropDownHeight + 'px';
    }
    showDropDown() {
        this.visible = !this.visible;
        this.setPosition();
        this.targetElement.nativeElement.focus();
        if (this.visible) {
            this.ignoreNext = true;
        }
    }
    nodeSelect(event) {
        this.closeDropDown();
        this.selection = event.node;
        this.selectionChange.emit(event.node);
    }
    closeDropDown() {
        this.visible = false;
    }
    outsideClick() {
        if (this.ignoreNext) {
            this.ignoreNext = false;
            return;
        }
        this.closeDropDown();
    }
    reset(event) {
        // re-configure the grid style upon browser resize
        this.closeDropDown();
    }
    onKeyDown(e) {
        if (e.key == 'Escape') {
            this.closeDropDown();
        }
    }
}
DwTreeSelect.ɵfac = function DwTreeSelect_Factory(t) { return new (t || DwTreeSelect)(); };
DwTreeSelect.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTreeSelect, selectors: [["dw-tree-select"]], viewQuery: function DwTreeSelect_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c19, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.targetElement = _t.first);
    } }, hostBindings: function DwTreeSelect_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwTreeSelect_resize_HostBindingHandler($event) { return ctx.reset($event); }, false, ɵngcc0.ɵɵresolveWindow)("keydown", function DwTreeSelect_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { dropDownHeight: "dropDownHeight", selection: "selection", treeData: "treeData" }, outputs: { selectionChange: "selectionChange" }, decls: 7, vars: 8, consts: [[1, "drop-down-tree-field"], ["type", "text", "readonly", "", 1, "form-control", "hand", 3, "value", "click"], ["inputElement", ""], [1, "pi", "pi-fw", "pi-caret-down", "drop-down-icon", "hand", "ui-dropdown-trigger", 3, "click"], [1, "dropdown-section", 3, "ngClass", "clickOutside"], ["selectionMode", "single", 3, "value", "selection", "styleClass", "selectionChange", "onNodeSelect"]], template: function DwTreeSelect_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "input", 1, 2);
        ɵngcc0.ɵɵlistener("click", function DwTreeSelect_Template_input_click_2_listener($event) { return ctx.click($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵlistener("click", function DwTreeSelect_Template_span_click_4_listener($event) { return ctx.click($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵlistener("clickOutside", function DwTreeSelect_Template_div_clickOutside_5_listener() { return ctx.outsideClick(); });
        ɵngcc0.ɵɵelementStart(6, "p-tree", 5);
        ɵngcc0.ɵɵlistener("selectionChange", function DwTreeSelect_Template_p_tree_selectionChange_6_listener($event) { return ctx.selection = $event; })("onNodeSelect", function DwTreeSelect_Template_p_tree_onNodeSelect_6_listener($event) { return ctx.nodeSelect($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("value", ctx.selection == null ? null : ctx.selection.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c44, ctx.visible == false));
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.treeData)("selection", ctx.selection)("styleClass", "custom-ui-tree");
    } }, directives: function () { return [ɵngcc4.NgClass, DwClickOutsideDirective, ɵngcc8.Tree]; }, styles: ["@charset \"UTF-8\";.drop-down-tree-field{position:relative}.drop-down-tree-field .form-control:disabled,.drop-down-tree-field .form-control[readonly],.dropdown-section{background-color:#fff}.dropdown-section{background-clip:padding-box;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;min-width:10rem;overflow-x:none;overflow-y:auto;padding:0;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section .ui-treenode-content-selected{background-color:#007ad9;border:1px;color:#fff}.hide{display:none}.drop-down-icon{color:#848484;position:absolute;right:3px;text-align:center;top:20%;width:2.357em}.custom-ui-tree{height:100%;width:100%!important}.custom-ui-tree,.custom-ui-tree .ui-tree-container{padding:0!important}.pi-caret-down:before{content:\"\uE902\"!important}"], encapsulation: 2 });
DwTreeSelect.propDecorators = {
    targetElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    dropDownHeight: [{ type: Input }],
    treeData: [{ type: Input }],
    selection: [{ type: Input }],
    selectionChange: [{ type: Output }],
    reset: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
__decorate$p([
    DwInputConverter(booleanConverter),
    __metadata$n("design:type", Boolean)
], DwTreeSelect.prototype, "visible", void 0);

var __decorate$q = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$o = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwClickOutsideDirective {
    constructor(elementRef, router) {
        this.elementRef = elementRef;
        this.router = router;
        this.clickOutside = new EventEmitter();
        this.includeKeys = 'Escape,Tab';
        this.includeNavigationevents = true;
        this.includeKeyMap = {};
    }
    ngOnInit() {
        this.setupKeyMap();
        this.router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e) => {
            if (this.includeNavigationevents) {
                this.clickOutside.emit();
            }
        });
    }
    onClick(target) {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
    setupKeyMap() {
        const list = this.includeKeys.split(',');
        for (let item of list) {
            if (item && item.trim()) {
                this.includeKeyMap[item] = true;
            }
        }
    }
    keydown(e) {
        if (this.includeKeyMap[e.key]) {
            this.clickOutside.emit();
        }
    }
}
DwClickOutsideDirective.ɵfac = function DwClickOutsideDirective_Factory(t) { return new (t || DwClickOutsideDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
DwClickOutsideDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwClickOutsideDirective, selectors: [["", "clickOutside", ""]], hostBindings: function DwClickOutsideDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DwClickOutsideDirective_click_HostBindingHandler($event) { return ctx.onClick($event.target); }, false, ɵngcc0.ɵɵresolveDocument)("keydown", function DwClickOutsideDirective_keydown_HostBindingHandler($event) { return ctx.keydown($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { includeKeys: "includeKeys", includeNavigationevents: "includeNavigationevents" }, outputs: { clickOutside: "clickOutside" } });
DwClickOutsideDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Router }
];
DwClickOutsideDirective.propDecorators = {
    clickOutside: [{ type: Output }],
    includeKeys: [{ type: Input }],
    includeNavigationevents: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['document:click', ['$event.target'],] }],
    keydown: [{ type: HostListener, args: ['document:keydown', ['$event'],] }]
};
__decorate$q([
    DwInputConverter(),
    __metadata$o("design:type", Boolean)
], DwClickOutsideDirective.prototype, "includeNavigationevents", void 0);

class DwUiChildConfigHostComponent {
    constructor() {
        this.configChange = new EventEmitter();
        this.isValidChange = new EventEmitter();
        this.subscriptions = [];
    }
    ngOnInit() {
    }
    ngOnDestroy() {
        this.clearSubscriptions();
    }
    ngOnChanges(changes) {
        this.configureComponent();
    }
    setComponentInstance(componentInstance) {
        this.clearSubscriptions();
        this.componentInstance = componentInstance;
        this.configureComponent();
    }
    configureComponent() {
        if (!this.componentInstance) {
            return;
        }
        this.componentInstance.config = this.config;
        this.componentInstance.configContext = this.configContext;
        this.componentInstance.setupComponent();
        this.subscriptions.push(this.componentInstance.configChange.subscribe(config => {
            this.config = config;
            this.configChange.emit(this.config);
        }));
        this.subscriptions.push(this.componentInstance.isValidChange.subscribe(isValid => {
            this.isValid = isValid;
            this.isValidChange.emit(this.isValid);
        }));
    }
    clearSubscriptions() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        this.subscriptions.length = 0;
    }
}
DwUiChildConfigHostComponent.ɵfac = function DwUiChildConfigHostComponent_Factory(t) { return new (t || DwUiChildConfigHostComponent)(); };
DwUiChildConfigHostComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiChildConfigHostComponent, selectors: [["dw-ui-child-config-host"]], inputs: { config: "config", isValid: "isValid", configContext: "configContext", component: "component" }, outputs: { configChange: "configChange", isValidChange: "isValidChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "component", "configure"]], template: function DwUiChildConfigHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 0);
        ɵngcc0.ɵɵlistener("configure", function DwUiChildConfigHostComponent_Template_dw_dynamic_loader_configure_0_listener($event) { return ctx.setComponentInstance($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("component", ctx.component);
    } }, directives: [DwDynamicLoaderComponent], encapsulation: 2 });
DwUiChildConfigHostComponent.propDecorators = {
    config: [{ type: Input }],
    configChange: [{ type: Output }],
    configContext: [{ type: Input }],
    isValid: [{ type: Input }],
    isValidChange: [{ type: Output }],
    component: [{ type: Input }]
};

class DwActionGroupModesConfigComponent {
    constructor() {
        this.actionPreferenceByModeChange = new EventEmitter();
        this.modeChange = new EventEmitter();
        this.size = DwConfigListSize.medium;
    }
    ngOnInit() {
        this.setDefaultMode();
        this.setupMode();
    }
    ngOnChanges(simpleChanges) {
        if (!isFirstChange(simpleChanges)) {
            if (simpleChanges.actionModes) {
                this.setDefaultMode();
            }
            this.setupMode();
        }
    }
    setDefaultMode() {
        this.currentModeValue = null;
        if (this.actionModes && this.actionModes.length > 0) {
            this.currentModeValue = this.actionModes[0].modeValue;
        }
    }
    setupMode() {
        var _a;
        if (!this.currentModeValue) {
            return;
        }
        this.currentMode = this.actionModes.find(am => am.modeValue == this.currentModeValue);
        this.actionPreferencesByMode = this.actionPreferencesByMode || {};
        this.actionConfigPreferencesByMode = this.actionConfigPreferencesByMode || {};
        this.modeActions = this.actionPreferencesByMode[this.currentModeValue] || [];
        this.actionConfigPreferences = this.actionConfigPreferencesByMode[this.currentModeValue] || {};
        this.size = ((_a = this.actionModes) === null || _a === void 0 ? void 0 : _a.length) > 1 ? DwConfigListSize.small : DwConfigListSize.medium;
        this.onModeChange();
    }
    onChange() {
        if (!this.currentModeValue) {
            return;
        }
        this.actionPreferencesByMode = this.actionPreferencesByMode || {};
        this.actionPreferencesByMode[this.currentModeValue] = this.modeActions || [];
    }
    onModeChange() {
        this.modeChange.emit(this.currentModeValue);
    }
}
DwActionGroupModesConfigComponent.ɵfac = function DwActionGroupModesConfigComponent_Factory(t) { return new (t || DwActionGroupModesConfigComponent)(); };
DwActionGroupModesConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwActionGroupModesConfigComponent, selectors: [["dw-action-group-modes-config"]], inputs: { actionPreferencesByMode: "actionPreferencesByMode", actionConfigPreferencesByMode: "actionConfigPreferencesByMode", configContext: "configContext", actionModes: "actionModes" }, outputs: { actionPreferenceByModeChange: "actionPreferenceByModeChange", modeChange: "modeChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", "", 4, "ngIf"], [3, "actionPreferences", "actionConfigPreferences", "size", "actionTypes", "showButtonConfig", "buttonContainerStyleKey", "showMenuConfig", "configContext", "actionPreferencesChange", 4, "ngIf"], ["dwRow", ""], ["dwCol", "12"], ["valueField", "modeValue", "displayField", "modeDisplay", 3, "items", "ngModel", "ngModelChange"], [3, "actionPreferences", "actionConfigPreferences", "size", "actionTypes", "showButtonConfig", "buttonContainerStyleKey", "showMenuConfig", "configContext", "actionPreferencesChange"]], template: function DwActionGroupModesConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwActionGroupModesConfigComponent_div_0_Template, 3, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionModes);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, DwPillsComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwActionGroupConfigComponent], encapsulation: 2 });
DwActionGroupModesConfigComponent.ctorParameters = () => [];
DwActionGroupModesConfigComponent.propDecorators = {
    configContext: [{ type: Input }],
    actionModes: [{ type: Input }],
    actionPreferencesByMode: [{ type: Input }],
    actionPreferenceByModeChange: [{ type: Output }],
    modeChange: [{ type: Output }],
    actionConfigPreferencesByMode: [{ type: Input }]
};

class DwRadioListComponent extends DwControlBaseComponent {
    constructor() {
        super();
        this.groupName = "DwRadioGroup";
        this.values = [];
        DwRadioListComponent.groupNumber++;
        this.groupName += DwRadioListComponent.groupNumber;
    }
    onKeyup(event) {
        this.onChange();
    }
    onBlur(event) {
        this.onTouch();
    }
}
DwRadioListComponent.ɵfac = function DwRadioListComponent_Factory(t) { return new (t || DwRadioListComponent)(); };
DwRadioListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRadioListComponent, selectors: [["dw-radio-list"]], inputs: { groupName: "groupName", values: "values" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwRadioListComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["id", "radio-list-control"], ["id", "radio-item", 4, "ngFor", "ngForOf"], ["id", "radio-item"], [1, "radio-container"], ["type", "radio", 3, "name", "value", "disabled", "ngModel", "ngModelChange", "change", "keyup", "blur"], [1, "radio-item"]], template: function DwRadioListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwRadioListComponent_span_1_Template, 5, 5, "span", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.values);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc3.RadioControlValueAccessor, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [".radio-container[_ngcontent-%COMP%]{margin:5px}.radio-item[_ngcontent-%COMP%]{margin-left:5px;margin-top:-6px}"] });
DwRadioListComponent.groupNumber = 1;
DwRadioListComponent.ctorParameters = () => [];
DwRadioListComponent.propDecorators = {
    groupName: [{ type: Input }],
    values: [{ type: Input }]
};

class DwCountValidatorConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
        this.config.minCount;
    }
}
DwCountValidatorConfigComponent.ɵfac = function DwCountValidatorConfigComponent_Factory(t) { return ɵDwCountValidatorConfigComponent_BaseFactory(t || DwCountValidatorConfigComponent); };
DwCountValidatorConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCountValidatorConfigComponent, selectors: [["dw-count-validator-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 2, consts: [["dwRow", ""], ["dwCol", "12"], ["dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwCountValidatorConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Min Count");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwCountValidatorConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.config.minCount = $event; })("ngModelChange", function DwCountValidatorConfigComponent_Template_input_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Max Count");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwCountValidatorConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.config.maxCount = $event; })("ngModelChange", function DwCountValidatorConfigComponent_Template_input_ngModelChange_9_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.minCount);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.maxCount);
    } }, directives: [DwRowDirective, DwColDirective, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$r = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const defaultUrlValidationUrl = /^(ftp|http|https):\/\/[^ "]+$/;
var DwCountTags;
(function (DwCountTags) {
    DwCountTags["minCount"] = "minCount";
    DwCountTags["maxCount"] = "maxCount";
})(DwCountTags || (DwCountTags = {}));
const errorProperty$1 = 'invalidCount';
let DwCountValidationRule = class DwCountValidationRule extends DwValidationRuleBase {
    createValidator(config, context) {
        return DwValidateCount(config, context);
    }
    buildTagsValues(error, displayName) {
        const tagValues = super.buildTagsValues(error, displayName);
        tagValues[DwCountTags.minCount] = error.config.minCount;
        tagValues[DwCountTags.maxCount] = error.config.maxCount;
        return tagValues;
    }
    getMessageTemplate(error, displayName, isSubmitted, messageTemplate) {
        if (!isSubmitted) {
            return;
        }
        if (error.config.minCount > 0 && !error.config.maxCount) {
            messageTemplate = `Please enter at least [minCount] item`;
        }
        if (error.config.minCount > 0 && error.config.maxCount > 0) {
            messageTemplate = `Please enter at least [minCount] and no more than [maxCount]`;
        }
        if (!error.config.minCount && error.config.maxCount > 0) {
            messageTemplate = `Please enter no more than [maxCount]`;
        }
        if (error.config.overrideMessage) {
            return error.config.message;
        }
        return messageTemplate;
    }
};
DwCountValidationRule.ɵfac = function DwCountValidationRule_Factory(t) { return ɵDwCountValidationRule_BaseFactory(t || DwCountValidationRule); };
DwCountValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwCountValidationRule, factory: function (t) { return DwCountValidationRule.ɵfac(t); } });
DwCountValidationRule = __decorate$r([
    DwValidationRule({
        keyName: DwFormValidators.count,
        display: 'Count Validator',
        errorType: errorProperty$1,
        isErrorTypeMatch: isCountErrorType,
        validationItemType: DwValidationItemType.formArray,
        configComponent: DwCountValidatorConfigComponent,
        messageTemplate: '',
        tags: [
            { tag: DwValidationStandardTagNames.value, display: 'Value' },
            { tag: DwCountTags.minCount, display: 'Min Count' },
            { tag: DwCountTags.maxCount, display: 'Max Count' }
        ]
    })
], DwCountValidationRule);
function DwValidateCount(config, context) {
    return (control) => {
        let itemCount = 0;
        if (control instanceof FormArray) {
            const formArray = control;
            itemCount = formArray.controls.length;
            // if we need to use a count property name, use that value instead of the form array length
            if (context === null || context === void 0 ? void 0 : context.validationKey) {
                const countBykey = formArray.countByKey || {};
                itemCount = countBykey[context === null || context === void 0 ? void 0 : context.validationKey] || 0;
            }
        }
        else {
            // Handle a standard control using the value
            if (Array.isArray(control === null || control === void 0 ? void 0 : control.value)) {
                const ormItems = control.value;
                itemCount = ormItems.filter(item => !item._isDeleted).length;
            }
        }
        if ((config.minCount && itemCount < config.minCount) || (config.maxCount && itemCount > config.maxCount)) {
            const result = {};
            let finalErrorProperty = errorProperty$1;
            if (context === null || context === void 0 ? void 0 : context.validationKey) {
                finalErrorProperty = `${errorProperty$1}_${context === null || context === void 0 ? void 0 : context.validationKey}`;
            }
            result[finalErrorProperty] = {
                value: itemCount,
                config: config,
                filterKey: context === null || context === void 0 ? void 0 : context.validationKey
            };
            return result;
        }
    };
}
function isCountErrorType(errorPropertyName) {
    return (errorPropertyName === null || errorPropertyName === void 0 ? void 0 : errorPropertyName.indexOf(errorProperty$1)) == 0;
}

var __decorate$s = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$p = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
// No longer hard code a default that still gets used in some cases
// export const defaultEmailValidationRegEx: RegExp = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
const errorProperty$2 = 'email';
let DwEmailValidationRule = class DwEmailValidationRule extends DwValidationRuleBase {
    constructor(dwUiConfig) {
        super();
        this.dwUiConfig = dwUiConfig;
    }
    createValidator(config) {
        config = config || {};
        // if (!config.emailValidationRegEx || !config.emailValidationRegEx.test) {
        //     config.emailValidationRegEx = this.dwUiConfig.emailValidationRegEx;
        // }
        // Always use the configured default - otherwise it uses some saved old default that stuck in UI Config
        config.emailValidationRegEx = this.dwUiConfig.emailValidationRegEx;
        return DwValidateEmail(config);
    }
};
DwEmailValidationRule.ɵfac = function DwEmailValidationRule_Factory(t) { return new (t || DwEmailValidationRule)(ɵngcc0.ɵɵinject(DwUIConfigToken)); };
DwEmailValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwEmailValidationRule, factory: function (t) { return DwEmailValidationRule.ɵfac(t); } });
DwEmailValidationRule.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];
DwEmailValidationRule = __decorate$s([
    DwValidationRule({
        keyName: DwFormValidators.email,
        display: 'E-mail Validator',
        errorType: errorProperty$2,
        validationItemType: DwValidationItemType.formControl,
        tags: [
            ...DwValidationStandardTags,
        ],
        messageTemplate: `Please enter a valid e-mail address`,
    }),
    __metadata$p("design:paramtypes", [Object])
], DwEmailValidationRule);
function DwValidateEmail(config) {
    return (control) => {
        if (control.value) {
            if (!config.emailValidationRegEx.test(control.value)) {
                const result = {};
                result[errorProperty$2] = {
                    value: control.value,
                    config: config
                };
                return result;
            }
        }
        return null;
    };
}
function IsEmailValid(email, regEx) {
    return regEx.test(email);
}

class DwMinValidationConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
DwMinValidationConfigComponent.ɵfac = function DwMinValidationConfigComponent_Factory(t) { return ɵDwMinValidationConfigComponent_BaseFactory(t || DwMinValidationConfigComponent); };
DwMinValidationConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMinValidationConfigComponent, selectors: [["dw-min-validator-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [["dwRow", ""], ["dwCol", "12"], ["dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwMinValidationConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Min Value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMinValidationConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.config.min = $event; })("ngModelChange", function DwMinValidationConfigComponent_Template_input_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.min);
    } }, directives: [DwRowDirective, DwColDirective, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$t = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DwTags;
(function (DwTags) {
    DwTags["min"] = "min";
})(DwTags || (DwTags = {}));
const errorType = 'min';
;
let DwMinValidationRule = class DwMinValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidateMin(config);
    }
    buildTagsValues(error, displayName) {
        var _a;
        const tagValues = super.buildTagsValues(error, displayName);
        tagValues[DwTags.min] = ((_a = error.config) === null || _a === void 0 ? void 0 : _a.min) || error.min;
        return tagValues;
    }
};
DwMinValidationRule.ɵfac = function DwMinValidationRule_Factory(t) { return ɵDwMinValidationRule_BaseFactory(t || DwMinValidationRule); };
DwMinValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMinValidationRule, factory: function (t) { return DwMinValidationRule.ɵfac(t); } });
DwMinValidationRule = __decorate$t([
    DwValidationRule({
        keyName: DwFormValidators.min,
        display: 'Min Validator',
        errorType: errorType,
        validationItemType: DwValidationItemType.formControl,
        configComponent: DwMinValidationConfigComponent,
        messageTemplate: `Must be greater than [min]`,
        tags: [
            ...DwValidationStandardTags,
            { tag: DwTags.min, display: 'Min' },
        ]
    })
], DwMinValidationRule);
/* export class DwMinValidationErrorBuilder implements DwValidationErrorBuilder<DwMinValidationConfig> {
    buildError(error: MinError, displayName: string, isSubmitted: Boolean) {
        const tagValues = new Map<string, string>();

        error.config = error.config || {} as any;

        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;
        tagValues[DwTags.min] = error.config?.min || error.min;

        let messageTemplate = `Must be greater than [min]`;

        if (error.config.overrideMessage) {
            messageTemplate = error.config.message;
        }

        const finalMessage = processTemplate(messageTemplate, tagValues)

        return finalMessage;
    }

    createValidator(config: DwMinValidationConfig ) {
        return DwValidateMin(config);
    }
} */
function DwValidateMin(config) {
    return (control) => {
        var result = Validators.min(config.min)(control);
        if (result && result[errorType]) {
            result[errorType].config = config;
        }
        return result;
        /*  if (!control.value || control.value >= config.min) {
             return;
         }
         const maxError: MinError = {
             value: control.value,
             config: config,
             min: config.min // Need to keep max property
         }
 
         result[errorType] = maxError;
 
         return result; */
    };
}

class DwMaxValidatorConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
DwMaxValidatorConfigComponent.ɵfac = function DwMaxValidatorConfigComponent_Factory(t) { return ɵDwMaxValidatorConfigComponent_BaseFactory(t || DwMaxValidatorConfigComponent); };
DwMaxValidatorConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMaxValidatorConfigComponent, selectors: [["dw-max-validator-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [["dwRow", ""], ["dwCol", "12"], ["dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwMaxValidatorConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Max Value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMaxValidatorConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.config.max = $event; })("ngModelChange", function DwMaxValidatorConfigComponent_Template_input_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.max);
    } }, directives: [DwRowDirective, DwColDirective, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$u = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DwTags$1;
(function (DwTags) {
    DwTags["max"] = "max";
})(DwTags$1 || (DwTags$1 = {}));
const errorType$1 = 'max';
;
let DwMaxValidationRule = class DwMaxValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidateMax(config);
    }
    buildTagsValues(error, displayName) {
        var _a;
        const tagValues = super.buildTagsValues(error, displayName);
        tagValues[DwTags$1.max] = ((_a = error.config) === null || _a === void 0 ? void 0 : _a.max) || error.max;
        return tagValues;
    }
};
DwMaxValidationRule.ɵfac = function DwMaxValidationRule_Factory(t) { return ɵDwMaxValidationRule_BaseFactory(t || DwMaxValidationRule); };
DwMaxValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMaxValidationRule, factory: function (t) { return DwMaxValidationRule.ɵfac(t); } });
DwMaxValidationRule = __decorate$u([
    DwValidationRule({
        keyName: DwFormValidators.max,
        display: 'Max Validator',
        errorType: errorType$1,
        validationItemType: DwValidationItemType.formControl,
        configComponent: DwMaxValidatorConfigComponent,
        messageTemplate: `Must be less than [max]`,
        tags: [
            ...DwValidationStandardTags,
            { tag: DwTags$1.max, display: 'Max' },
        ]
    })
], DwMaxValidationRule);
/*
export class DwMaxValidationErrorBuilder implements DwValidationErrorBuilder<DwMaxValidationConfig> {
    buildError(error: MaxError, displayName: string, isSubmitted: boolean) {
        const tagValues = new Map<string, string>();

        error.config = error.config || {} as any;

        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;
        tagValues[DwTags.max] = error.config?.max || error.max;

        let messageTemplate = `Must be less than [max]`;

        if (error.config.overrideMessage) {
            messageTemplate = error.config.message;
        }

        const finalMessage = processTemplate(messageTemplate, tagValues)

        return finalMessage;
    }

    createValidator(config: DwMaxValidationConfig) {
        return DwValidateMax(config);
    }
} */
function DwValidateMax(config) {
    return (control) => {
        const result = Validators.max(config.max)(control);
        if (result && result[errorType$1]) {
            result[errorType$1].config = config;
        }
        return result;
    };
}

class DwMaxLengthValidatorConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
DwMaxLengthValidatorConfigComponent.ɵfac = function DwMaxLengthValidatorConfigComponent_Factory(t) { return ɵDwMaxLengthValidatorConfigComponent_BaseFactory(t || DwMaxLengthValidatorConfigComponent); };
DwMaxLengthValidatorConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMaxLengthValidatorConfigComponent, selectors: [["dw-max-length-validator-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [["dwRow", ""], ["dwCol", "12"], ["dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwMaxLengthValidatorConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Max Length");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMaxLengthValidatorConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.config.maxLength = $event; })("ngModelChange", function DwMaxLengthValidatorConfigComponent_Template_input_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.maxLength);
    } }, directives: [DwRowDirective, DwColDirective, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$v = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var DwTags$2;
(function (DwTags) {
    DwTags["requiredLength"] = "requiredLength";
    DwTags["actualLength"] = "actualLength";
})(DwTags$2 || (DwTags$2 = {}));
const errorType$2 = 'maxlength';
;
let DwMaxLengthValidationRule = class DwMaxLengthValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidateMaxLength(config);
    }
    buildTagsValues(error, displayName) {
        const tagValues = super.buildTagsValues(error, displayName);
        tagValues[DwTags$2.requiredLength] = error.config.maxLength || error.requiredLength;
        tagValues[DwTags$2.actualLength] = error.actualLength;
        return tagValues;
    }
};
DwMaxLengthValidationRule.ɵfac = function DwMaxLengthValidationRule_Factory(t) { return ɵDwMaxLengthValidationRule_BaseFactory(t || DwMaxLengthValidationRule); };
DwMaxLengthValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMaxLengthValidationRule, factory: function (t) { return DwMaxLengthValidationRule.ɵfac(t); } });
DwMaxLengthValidationRule = __decorate$v([
    DwValidationRule({
        keyName: DwFormValidators.maxLength,
        display: 'Max Length Validator',
        errorType: errorType$2,
        validationItemType: DwValidationItemType.formControl,
        configComponent: DwMaxLengthValidatorConfigComponent,
        messageTemplate: `[displayName] exceeds the maximum length of [requiredLength] (Actual length: [actualLength])`,
        tags: [
            ...DwValidationStandardTags,
            { tag: DwTags$2.requiredLength, display: 'Required Length' },
            { tag: DwTags$2.actualLength, display: 'Actual Length' },
        ]
    })
], DwMaxLengthValidationRule);
/* export class DwMaxLengthValidationErrorBuilder implements DwValidationErrorBuilder<DwMaxLengthValidationConfig> {
    buildError(error: MaxLengthError, displayName: string, isSubmitted: boolean, config?:DwMaxLengthValidationConfig) {
        const tagValues = new Map<string, string>();

        error.config = error.config || {} as any;

        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;
        tagValues[DwTags.requiredLength] = error.config.maxLength  || error.requiredLength;
        tagValues[DwTags.actualLength] = error.actualLength;

        let messageTemplate =  `[displayName] exceeds the maximum length of [requiredLength] (Actual length: [actualLength])`;

        if (error.config.overrideMessage) {
            messageTemplate = error.config.message;
        }

        const finalMessage = processTemplate(messageTemplate, tagValues)

        return finalMessage;
    }

    createValidator(config: DwMaxLengthValidationConfig ) {
        return Validators.maxLength(config.maxLength);
    }
} */
function DwValidateMaxLength(config) {
    return (control) => {
        var _a, _b;
        const result = Validators.maxLength(config.maxLength)(control);
        if (result && result[errorType$2]) {
            result[errorType$2] = {
                config: config,
                value: control.value,
                actualLength: (_a = control.value) === null || _a === void 0 ? void 0 : _a.length,
                requiredLength: config.maxLength
            };
        }
        return result;
        if (((_b = control.value) === null || _b === void 0 ? void 0 : _b.length) <= config.maxLength || config.maxLength === 0) {
            return;
        }
        /*  const result: DwValidationErrorResult<DwMaxLengthValidationConfig> = {};
 
         const error: MaxLengthError = {
             value: control.value,
             config: config,
             actualLength: control.value?.length,
             requiredLength: config.maxLength
         }
 
         result[errorType] = error;
 
         return result; */
    };
}

class DwPatternValidatorConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
DwPatternValidatorConfigComponent.ɵfac = function DwPatternValidatorConfigComponent_Factory(t) { return ɵDwPatternValidatorConfigComponent_BaseFactory(t || DwPatternValidatorConfigComponent); };
DwPatternValidatorConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPatternValidatorConfigComponent, selectors: [["dw-pattern-validator-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwPatternValidatorConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "RegEx Pattern");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwPatternValidatorConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.config.pattern = $event; })("ngModelChange", function DwPatternValidatorConfigComponent_Template_input_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.pattern);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$w = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const errorType$3 = 'pattern';
let DwPatternValidationRule = class DwPatternValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidatePattern(config);
    }
};
DwPatternValidationRule.ɵfac = function DwPatternValidationRule_Factory(t) { return ɵDwPatternValidationRule_BaseFactory(t || DwPatternValidationRule); };
DwPatternValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwPatternValidationRule, factory: function (t) { return DwPatternValidationRule.ɵfac(t); } });
DwPatternValidationRule = __decorate$w([
    DwValidationRule({
        keyName: DwFormValidators.pattern,
        display: 'Pattern Validator',
        errorType: errorType$3,
        validationItemType: DwValidationItemType.formControl,
        configComponent: DwPatternValidatorConfigComponent,
        messageTemplate: `[displayName] is not valid`,
        tags: [
            ...DwValidationStandardTags,
        ]
    })
], DwPatternValidationRule);
/*
export class DwPatternValidationErrorBuilder implements DwValidationErrorBuilder<DwPatternValidationConfig> {
    
    buildError(error: DwValidationError<DwPatternValidationConfig>, displayName: string, isSubmitted: boolean) {
        const tagValues = new Map<string, string>();

        error.config = error.config || {} as any;

        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;

        let messageTemplate = `[displayName] is not valid`;

        if (error.config.overrideMessage) {
            messageTemplate = error.config.message;
        }

        const finalMessage = processTemplate(messageTemplate, tagValues)

        return finalMessage;
    }

    createValidator(config: DwPatternValidationConfig ) {
        return Validators.pattern(config.pattern)
    }
} */
function DwValidatePattern(config) {
    return (control) => {
        const result = Validators.pattern(config.pattern)(control);
        if (result && result[errorType$3]) {
            result[errorType$3] = { config: config };
        }
        return result;
    };
}

var __decorate$x = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const errorType$4 = 'required';
let DwRequiredValidationRule = class DwRequiredValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidationRequired(config);
    }
    getMessageTemplate(error, displayName, isSubmitted, messageTemplate) {
        var _a;
        // Add check to see if message should be displayed before submit
        if (!((_a = error === null || error === void 0 ? void 0 : error.config) === null || _a === void 0 ? void 0 : _a.showErrorBeforeSubmit) && !isSubmitted) {
            return "";
        }
        return super.getMessageTemplate(error, displayName, isSubmitted, messageTemplate);
    }
};
DwRequiredValidationRule.ɵfac = function DwRequiredValidationRule_Factory(t) { return ɵDwRequiredValidationRule_BaseFactory(t || DwRequiredValidationRule); };
DwRequiredValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRequiredValidationRule, factory: function (t) { return DwRequiredValidationRule.ɵfac(t); } });
DwRequiredValidationRule = __decorate$x([
    DwValidationRule({
        keyName: DwFormValidators.required,
        display: 'Required Validator',
        errorType: errorType$4,
        validationItemType: DwValidationItemType.formControl,
        tags: [
            ...DwValidationStandardTags,
        ],
        messageTemplate: '[displayName] is required'
    })
], DwRequiredValidationRule);
function DwValidationRequired(config) {
    config = config || {};
    return (control) => {
        const result = Validators.required(control);
        if (result && result[errorType$4]) {
            result[errorType$4] = {
                config: config
            };
        }
        return result;
    };
}

var __decorate$y = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const defaultUrlValidationUrl$1 = /^(ftp|http|https):\/\/[^ "]+$/;
const errorType$5 = 'invalidUrl';
let DwUrlValidationRule = class DwUrlValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        config = config || {};
        if (!(config === null || config === void 0 ? void 0 : config.urlValidationRegEx)) {
            config.urlValidationRegEx = defaultUrlValidationUrl$1;
        }
        return DwValidateUrl(config);
    }
};
DwUrlValidationRule.ɵfac = function DwUrlValidationRule_Factory(t) { return ɵDwUrlValidationRule_BaseFactory(t || DwUrlValidationRule); };
DwUrlValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwUrlValidationRule, factory: function (t) { return DwUrlValidationRule.ɵfac(t); } });
DwUrlValidationRule = __decorate$y([
    DwValidationRule({
        keyName: DwFormValidators.url,
        display: 'Url Validator',
        errorType: errorType$5,
        validationItemType: DwValidationItemType.formControl,
        messageTemplate: `[${DwValidationStandardTagNames.displayName}] is not a valid url.  (Url should start with http:// or https://)`,
        tags: [
            ...DwValidationStandardTags,
        ]
    })
], DwUrlValidationRule);
function DwValidateUrl(config) {
    const patternRegEx = (config === null || config === void 0 ? void 0 : config.urlValidationRegEx) || defaultUrlValidationUrl$1;
    // Went with a simple validation since more complex versions didn't work in all cases
    return (control) => {
        if (control.value) {
            let result = Validators.pattern(patternRegEx)(control);
            if (result === null || result === void 0 ? void 0 : result.pattern) {
                result = {};
                result[errorType$5] = { config: config };
            }
            return result;
        }
        return null;
    };
}

var __decorate$z = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const errorType$6 = 'requiredTrue';
let DwRequiredTrueValidationRule = class DwRequiredTrueValidationRule extends DwValidationRuleBase {
    createValidator(config) {
        return DwValidationRequiredTrue(config);
    }
};
DwRequiredTrueValidationRule.ɵfac = function DwRequiredTrueValidationRule_Factory(t) { return ɵDwRequiredTrueValidationRule_BaseFactory(t || DwRequiredTrueValidationRule); };
DwRequiredTrueValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRequiredTrueValidationRule, factory: function (t) { return DwRequiredTrueValidationRule.ɵfac(t); } });
DwRequiredTrueValidationRule = __decorate$z([
    DwValidationRule({
        keyName: DwFormValidators.requiredTrue,
        display: 'Required True Validator',
        errorType: errorType$6,
        validationItemType: DwValidationItemType.formControl,
        tags: [
            ...DwValidationStandardTags,
        ],
        messageTemplate: `[displayName] must be set to Yes`
    })
], DwRequiredTrueValidationRule);
/*
export class DwRequiredTrueValidationErrorBuilder implements DwValidationErrorBuilder<DwRequiredTrueValidationConfig> {
    buildError(error: DwValidationError<DwRequiredTrueValidationConfig>, displayName: string, isSubmitted: boolean) {
        const tagValues = new Map<string, string>();

        error.config = error.config || {} as any;

        tagValues[DwValidationStandardTagNames.displayName] = displayName;
        tagValues[DwValidationStandardTagNames.value] = error.value;

        let messageTemplate = `[displayName] must be set to Yes`;

        if (error.config.overrideMessage) {
            messageTemplate = error.config.message;
        }

        const finalMessage = processTemplate(messageTemplate, tagValues)

        return finalMessage;
    }

    createValidator(config: DwRequiredTrueValidationConfig) {
        return DwValidationRequiredTrue(config);
    }
}  */
function DwValidationRequiredTrue(config) {
    return (control) => {
        const result = Validators.requiredTrue(control);
        if (result === null || result === void 0 ? void 0 : result.required) {
            result[errorType$6] = {
                config: config
            };
            delete result.required;
        }
        return result;
    };
}

class DwValidationConfigBaseComponent extends DwChildConfigBaseComponent {
    constructor(dwValidationService) {
        super();
        this.dwValidationService = dwValidationService;
    }
    getDefaultConfig() {
        return {};
    }
    initConfig() {
        super.initConfig();
        this.setupChildConfig();
    }
    addTag(tag) {
        this.config.message = this.config.message || '';
        this.config.message += `[${tag.tag}]`;
    }
    setupChildConfig() {
        var _a, _b;
        this.validationRuleRegistration = null;
        if (!this.validatorKey) {
            return;
        }
        this.validationRuleRegistration = this.dwValidationService.getValidatorRegistration(this.validatorKey);
        if (((_a = this.validationRuleRegistration) === null || _a === void 0 ? void 0 : _a.showAfterSubmittedDefault) && this.config.showAfterSubmitted != false) {
            this.config.showAfterSubmitted = (_b = this.validationRuleRegistration) === null || _b === void 0 ? void 0 : _b.showAfterSubmittedDefault;
        }
    }
}
DwValidationConfigBaseComponent.ɵfac = function DwValidationConfigBaseComponent_Factory(t) { return new (t || DwValidationConfigBaseComponent)(ɵngcc0.ɵɵdirectiveInject(DwValidationService)); };
DwValidationConfigBaseComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwValidationConfigBaseComponent, selectors: [["dw-validation-config-base"]], inputs: { validatorKey: "validatorKey" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[4, "ngIf"], ["dwRow", "", 4, "ngIf"], ["dwRow", ""], ["dwCol", "9"], ["title", "Message will be hidden and only display after they click save (or next)", 1, "fa", "fa-info-circle"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwCol", "12"], ["rows", "1", 1, "form-control", 3, "ngModel", "ngModelChange"], [4, "ngFor", "ngForOf"], [1, "btn", "btn-sm", "btn-success", "float-left", "mr-2", 3, "click"], ["title", "Add Field", 1, "fa", "fa-plus-circle", "hand"], [3, "component", "config", "configContext", "configChange"]], template: function DwValidationConfigBaseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "b");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwValidationConfigBaseComponent_ng_container_3_Template, 5, 4, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate((ctx.validationRuleRegistration == null ? null : ctx.validationRuleRegistration.display) || "Validation Rule Not Found");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config && ctx.validationRuleRegistration);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, ɵngcc4.NgForOf, DwUiChildConfigHostComponent], encapsulation: 2 });
DwValidationConfigBaseComponent.ctorParameters = () => [
    { type: DwValidationService }
];
DwValidationConfigBaseComponent.propDecorators = {
    validatorKey: [{ type: Input }]
};

class DwUserPasswordResetComponent {
    constructor(dwSecurityRepositoryService, router, dwSecurityUserService, dwSecurityTwoFactorRepositoryService, dwAppInitService) {
        this.dwSecurityRepositoryService = dwSecurityRepositoryService;
        this.router = router;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwSecurityTwoFactorRepositoryService = dwSecurityTwoFactorRepositoryService;
        this.dwAppInitService = dwAppInitService;
        this.userNameChange = new EventEmitter();
        this.complete = new EventEmitter();
        this.cancelled = new EventEmitter();
        this.messageChange = new EventEmitter();
        this.showReset = false;
        this.processing = false;
    }
    ngOnInit() {
        this.resetCode = getParameterByName(this.router, 'resetCode');
        this.userName = getParameterByName(this.router, 'userName');
        if (this.resetCode) {
            this.showReset = true;
        }
    }
    setMessage(messageBody, severity = DwMessageSeverity.info) {
        this.message = {
            messageBody: messageBody,
            severity: severity
        };
        this.messageChange.emit(this.message);
    }
    clearMessage() {
        this.message = null;
        this.messageChange.emit(this.message);
    }
    resetPassword2() {
        this.resetPassword();
    }
    sendResetEmail() {
        this.clearMessage();
        if (!this.validateForm()) {
            return;
        }
        if (this.processing) {
            return;
        }
        this.processing = true;
        this.dwSecurityRepositoryService.sendPasswordResetEmail(this.userName)
            .subscribe(result => {
            this.processing = false;
            this.setMessage('Password E-mail has been sent!');
            this.showResetPassword();
        }, error => {
            this.processing = false;
            var errorDetail = getErrorDetails(error);
            this.setMessage(errorDetail.message, DwMessageSeverity.error);
        });
    }
    showResetPassword() {
        this.message = null;
        this.showReset = true;
    }
    cancel() {
        this.message = null;
        this.cancelled.emit();
    }
    resetPassword() {
        this.clearMessage();
        if (!this.validateForm()) {
            return;
        }
        if (this.processing) {
            return;
        }
        this.processing = true;
        this.dwSecurityRepositoryService.resetUserPassword(this.userName, this.newPassword, this.resetCode)
            .subscribe(result => {
            this.processing = false;
            this.complete.emit();
        }, error => {
            this.processing = false;
            var errorDetail = getErrorDetails(error);
            this.setMessage(errorDetail.message, DwMessageSeverity.error);
        });
    }
    validateForm() {
        const errors = [];
        if (!this.userName) {
            errors.push('Please enter a username');
        }
        if (this.showReset) {
            if (!this.resetCode) {
                errors.push('Reset Code is required');
            }
            if (!this.newPassword) {
                errors.push('Password is required');
            }
            else {
                if (!this.isPasswordValid) {
                    errors.push("Password is not valid");
                }
            }
        }
        if (errors.length > 0) {
            this.setMessage(errors.join(", "), DwMessageSeverity.error);
            return false;
        }
        this.message = null;
        return true;
    }
}
DwUserPasswordResetComponent.ɵfac = function DwUserPasswordResetComponent_Factory(t) { return new (t || DwUserPasswordResetComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwSecurityTwoFactorRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwAppInitService)); };
DwUserPasswordResetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUserPasswordResetComponent, selectors: [["dw-user-password-reset"]], inputs: { userName: "userName", message: "message" }, outputs: { userNameChange: "userNameChange", complete: "complete", cancelled: "cancelled", messageChange: "messageChange" }, decls: 9, vars: 2, consts: [["type", "text", "name", "fakeusernameremembered", 2, "display", "none"], ["type", "password", "name", "fakepasswordremembered", 2, "display", "none"], ["name", "loginForm", "autocomplete", "off"], [4, "ngIf"], ["forgotPassword", ""], ["resetPassword", ""], [4, "ngTemplateOutlet"], [1, "card-header"], [1, "card-body"], [3, "message"], [1, "body-left"], [1, "body-left-content"], [1, "dw-logo-login"], [1, "body-right"], [1, "body-right-content"], [1, "row"], [1, "login-image"], [1, "fa", "fa-user-circle", "login-icon"], [1, "login-input"], [1, "label"], ["type", "text", "id", "tbUserName", "name", "tbUserName", "placeholder", "username/e-mail", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "hand", 3, "click"], [1, "col-md-12"], ["type", "button", 1, "form-control", "btn", "btn-primary", 3, "disabled", "click"], ["class", "fa fa-spinner fa-pulse fa-fw", 4, "ngIf"], ["type", "button", 1, "form-control", "btn", "btn-danger", 3, "click"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"], [1, "fa", "fa-barcode-alt", "login-icon"], ["type", "text", "id", "tbResetCode", "name", "tbResetCode", "placeholder", "reset code", "autocomplete", "new-password", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", "id", "tbUserName", "name", "tbUserName", "placeholder", "username/e-mail", "autocomplete", "chrome-off", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "password", "isPasswordValid", "passwordChange", "isPasswordValidChange"]], template: function DwUserPasswordResetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "input", 0);
        ɵngcc0.ɵɵelement(1, "input", 1);
        ɵngcc0.ɵɵelementStart(2, "form", 2);
        ɵngcc0.ɵɵtemplate(3, DwUserPasswordResetComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, DwUserPasswordResetComponent_ng_container_4_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwUserPasswordResetComponent_ng_template_5_Template, 25, 4, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, DwUserPasswordResetComponent_ng_template_7_Template, 31, 7, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showReset);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showReset);
    } }, directives: function () { return [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.NgForm, ɵngcc4.NgIf, ɵngcc4.NgTemplateOutlet, DwMessageComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.RequiredValidator, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwPasswordComponent]; }, styles: [""] });
DwUserPasswordResetComponent.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: Router },
    { type: DwSecurityUserService },
    { type: DwSecurityTwoFactorRepositoryService },
    { type: DwAppInitService }
];
DwUserPasswordResetComponent.propDecorators = {
    userName: [{ type: Input }],
    userNameChange: [{ type: Output }],
    complete: [{ type: Output }],
    cancelled: [{ type: Output }],
    message: [{ type: Input }],
    messageChange: [{ type: Output }]
};

var __decorate$A = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwUserChangePasswordComponent = class DwUserChangePasswordComponent extends DwUserPasswordResetComponent {
    constructor() {
        super(...arguments);
        this.showReset = true;
        this.resetCode = 'NotUsed';
        this.showTwoFactor = false;
        this.showResendCode = false;
    }
    ngOnInit() {
        this.setupTwoFactor();
    }
    changePassword2() {
        this.changePassword();
    }
    setupTwoFactor() {
        var _a;
        const user = (_a = this.dwSecurityUserService.securityState.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
        if (user === null || user === void 0 ? void 0 : user.IsTwoFactorAuthenticationEnabled) {
            this.showTwoFactor = true;
            this.twoFactorMessage = "Enter your security code";
            if ((user === null || user === void 0 ? void 0 : user.TwoFactorAuthenticationType) != SecurityFactorTypes.authenticatorApp) {
                this.showResendCode = true;
            }
        }
    }
    changePassword() {
        if (!this.validateForm()) {
            return;
        }
        if (this.processing) {
            return;
        }
        this.message = null;
        this.processing = true;
        this.dwSecurityRepositoryService.changeUserPassword(this.userName, this.oldPassword, this.newPassword, this.twoFactorCode)
            .subscribe(result => {
            this.processing = false;
            this.message = {
                messageBody: 'Your password has been changed',
                severity: DwMessageSeverity.success
            };
            this.showReset = false;
        }, error => {
            this.processing = false;
            var errorDetail = getErrorDetails(error);
            this.message = {
                messageBody: errorDetail.message,
                severity: DwMessageSeverity.error
            };
        });
    }
    resendCode() {
        this.processing = true;
        this.message = null;
        this.twoFactorCode = '';
        this.dwSecurityTwoFactorRepositoryService.sendTwoFactorCode()
            .subscribe(result => {
            this.processing = false;
            this.message = {
                messageBody: 'Two factor code sent',
                severity: DwMessageSeverity.success
            };
        });
    }
};
DwUserChangePasswordComponent.ɵfac = function DwUserChangePasswordComponent_Factory(t) { return ɵDwUserChangePasswordComponent_BaseFactory(t || DwUserChangePasswordComponent); };
DwUserChangePasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUserChangePasswordComponent, selectors: [["dw-user-change-password"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 1, consts: [[1, "login"], [1, "card"], [4, "ngTemplateOutlet"], ["changePassword", ""], [1, "card-header"], [1, "card-body"], [3, "message"], [1, "body-left"], [1, "body-left-content"], [1, "dw-logo-login"], [1, "body-right"], [1, "body-right-content"], [1, "row"], [1, "login-image"], [1, "fa", "fa-user-circle", "login-icon"], [1, "login-input"], [1, "label"], ["type", "text", "id", "tbUserName", "name", "tbUserName", "placeholder", "username/e-mail", "autocomplete", "chrome-off", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "fa", "fa-user-lock", "login-icon"], ["type", "password", "id", "tbPassword", "name", "tbPassword", "placeholder", "old password", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [4, "ngIf"], [3, "password", "isPasswordValid", "passwordChange", "isPasswordValidChange"], [1, "col-md-12"], [1, "form-control", "btn", "btn-primary", 3, "disabled", "click"], ["class", "fa fa-spinner fa-pulse fa-fw", 4, "ngIf"], ["class", "row", 4, "ngIf"], [1, "fa", "fa-barcode-alt", "login-icon"], ["type", "text", "id", "tbTwoFactorCode", "name", "tbTwoFactorCode", "placeholder", "two factor code", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["style", "margin-top:3px;margin-bottom:3px;height:10px;", 4, "ngIf"], [2, "margin-top", "3px", "margin-bottom", "3px", "height", "10px"], [3, "click"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"]], template: function DwUserChangePasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwUserChangePasswordComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwUserChangePasswordComponent_ng_template_3_Template, 30, 8, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r1);
    } }, directives: function () { return [ɵngcc4.NgTemplateOutlet, DwMessageComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.RequiredValidator, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwPasswordComponent]; }, styles: [""] });
DwUserChangePasswordComponent = __decorate$A([
    DwComponent({
        key: 'changeUserPassword',
        name: 'Change Password',
        componentType: DwComponentType.pageComponent,
        isGlobal: true
    })
], DwUserChangePasswordComponent);

class DwMenuTemplateComponent extends DwMenuLinkComponent {
}
DwMenuTemplateComponent.ɵfac = function DwMenuTemplateComponent_Factory(t) { return ɵDwMenuTemplateComponent_BaseFactory(t || DwMenuTemplateComponent); };
DwMenuTemplateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMenuTemplateComponent, selectors: [["dw-menu-template"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c5, decls: 2, vars: 1, consts: [[3, "ngClass", "click"]], template: function DwMenuTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwMenuTemplateComponent_Template_div_click_0_listener($event) { return ctx.doAction(ctx.menu, $event); });
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.className);
    } }, directives: [ɵngcc4.NgClass], encapsulation: 2 });

var DwUserRegistrationResultType;
(function (DwUserRegistrationResultType) {
    DwUserRegistrationResultType["success"] = "Success";
    DwUserRegistrationResultType["userAlreadyExists"] = "UserAlreadyExist";
    DwUserRegistrationResultType["emailAlreadyExists"] = "EmailAlreadyExists";
    DwUserRegistrationResultType["invalidSecurityCode"] = "InvalidSecurityCode";
    DwUserRegistrationResultType["unknown"] = "Unknown";
})(DwUserRegistrationResultType || (DwUserRegistrationResultType = {}));

class DwUserRegistrationComponent {
    constructor(dwSecurityRepositoryService, dwSecurityRegistrationRepositoryService, dwConfigService, dwUIConfig, dwSecurityOrchestrationService, dwSecurityStateService, dwAppInitService, dwUiConfig) {
        this.dwSecurityRepositoryService = dwSecurityRepositoryService;
        this.dwSecurityRegistrationRepositoryService = dwSecurityRegistrationRepositoryService;
        this.dwConfigService = dwConfigService;
        this.dwUIConfig = dwUIConfig;
        this.dwSecurityOrchestrationService = dwSecurityOrchestrationService;
        this.dwSecurityStateService = dwSecurityStateService;
        this.dwAppInitService = dwAppInitService;
        this.dwUiConfig = dwUiConfig;
        this.userRegistration = {
            FirstName: '',
            LastName: '',
            Email: '',
        };
        this.showTwoFactor = false;
        this.captchaComplete = false;
        this.processing = false;
        this.registrationExtenededData = {
            additionalData: [],
            additionalUserFields: []
        };
        dwSecurityRegistrationRepositoryService.suppressErrorMessages = true;
    }
    ngOnInit() {
        if (this.dwSecurityStateService.securityState.isAuthenticated) {
            // this.dwSecurityOrchestrationService.gotoUserProfile();
        }
        this.setupCaptcha();
    }
    setupCaptcha() {
        var _a;
        if ((_a = this.dwUiConfig.registrationConfig) === null || _a === void 0 ? void 0 : _a.capchtaConfig) {
            const captchaConfiguration = this.dwUiConfig.registrationConfig.capchtaConfig;
            if (captchaConfiguration.getCapchaSettings) {
                const result = captchaConfiguration.getCapchaSettings(this.dwUIConfig.registrationConfig);
                if (result instanceof Observable) {
                    result.subscribe(captchaConfig => {
                        this.captchaConfiguration = captchaConfig;
                    });
                    return;
                }
                this.captchaConfiguration = result;
                return;
            }
            this.captchaConfiguration = captchaConfiguration;
        }
    }
    initCapchta(e) {
        //console.log("Init Captcha", e);
    }
    resetCaptcha() {
        this.captchaComplete = false;
    }
    showCapchtaResponse(event) {
        this.captchaComplete = true;
        this.userRegistration.CaptchaResponse = event === null || event === void 0 ? void 0 : event.response;
        //console.log(`Captcha Response`, event);
    }
    registerUser() {
        if (!this.validateUserInfo()) {
            return;
        }
        if (this.processing) {
            return;
        }
        this.processing = true;
        // Populate any custom fields
        this.userRegistration.AdditionalData = this.registrationExtenededData.additionalData;
        this.userRegistration.AdditionalUserFields = this.registrationExtenededData.additionalUserFields;
        this.dwSecurityRegistrationRepositoryService.registerUser(this.userRegistration)
            .subscribe(userRegistrationResult => {
            this.processing = false;
            this.handleRegistrationResult(userRegistrationResult);
        }, errorResponse => {
            this.processing = false;
            this.handleRegistrationError(errorResponse);
        });
    }
    gotoLogin() {
        this.dwSecurityOrchestrationService.gotoLogin();
    }
    changeEmail() {
        this.userRegistration.UserName = this.userRegistration.Email;
        this.validateEmail();
    }
    handleRegistrationResult(userRegistrationResult) {
        switch (userRegistrationResult.Result) {
            case DwUserRegistrationResultType.success:
                this.handleSuccessRegistration();
                return;
            case DwUserRegistrationResultType.userAlreadyExists:
                this.setMessage('This username is already taken.  If you already have account, please just login', DwMessageSeverity.warning);
                return;
            case DwUserRegistrationResultType.emailAlreadyExists:
                this.setMessage('This e-mail is already in use.  If you have forgotten your user name or password, click on "I already have an account" and then the "Forgot your password?" link', DwMessageSeverity.warning);
                return;
            case DwUserRegistrationResultType.invalidSecurityCode:
                this.setMessage('The registration code you entered was not valid.', DwMessageSeverity.warning);
                return;
            default:
            case DwUserRegistrationResultType.unknown:
                this.setMessage('An unknown error occured during registration.  Please contact support or try again in a little while.', DwMessageSeverity.warning);
                return;
        }
    }
    loginWithTwoFactorCode() {
        this.handleSuccessRegistration(this.twoFactorCode);
    }
    handleSuccessRegistration(twoFactorCode) {
        if (this.dwConfigService.coreConfig.securityConfig.autoLoginAfterRegistration) {
            // Authenticate without two-factor code since this couldn't be setup yet
            this.dwSecurityOrchestrationService.authenticate(this.userRegistration.UserName, this.userRegistration.Password, twoFactorCode, true)
                .subscribe(result => {
                if (result.PromptForTwoFactorCode) {
                    this.showTwoFactor = true;
                    return;
                }
                if (!result.success) {
                    this.setMessage(result.message, DwMessageSeverity.error);
                }
            });
        }
        else {
            this.gotoLogin();
        }
    }
    handleRegistrationError(errorResponse) {
        const errorDetail = getErrorDetails(errorResponse);
        let message = "An unknown error occured during registration, please try again later!";
        if (errorDetail) {
            message = errorDetail.message;
        }
        this.setMessage(message, DwMessageSeverity.error);
    }
    setMessage(messageBody, severity = DwMessageSeverity.info) {
        this.message = {
            messageBody: messageBody,
            severity: severity
        };
    }
    clearMessage() {
        this.message = null;
    }
    validateUserInfo() {
        var _a, _b;
        let valid = true;
        const errors = [];
        const missingFields = [];
        if (!this.userRegistration.FirstName) {
            missingFields.push('First Name');
        }
        if (!this.userRegistration.LastName) {
            missingFields.push('Last Name');
        }
        if (!this.userRegistration.Email) {
            missingFields.push('E-mail');
        }
        if (!this.userRegistration.UserName) {
            missingFields.push('Username');
        }
        if (!this.userRegistration.Password) {
            missingFields.push('Password');
        }
        if (missingFields.length > 0) {
            missingFields[missingFields.length - 1] = ' and ' + missingFields[missingFields.length - 1];
            errors.push(`Please enter ${missingFields.join(", ")}`);
        }
        if (!this.validateEmail()) {
            errors.push("E-mail is not valid");
        }
        if (!this.isPasswordValid) {
            errors.push("Password is not valid");
        }
        // Handle custom validation when using a user registration extension component
        if ((_a = this.userRegistrationExtension) === null || _a === void 0 ? void 0 : _a.customValalidation) {
            this.userRegistrationExtension.customValalidation(this.userRegistration, errors);
        }
        if (((_b = this.captchaConfiguration) === null || _b === void 0 ? void 0 : _b.enableCaptcha) && !this.captchaComplete) {
            // Captcha is required
            errors.push("Please confirm that you're not a robot");
        }
        if (errors.length > 0) {
            this.setMessage(errors.join("; "), DwMessageSeverity.error);
            valid = false;
        }
        else {
            this.message = null;
        }
        return valid;
    }
    validateEmail() {
        this.isEmailValid = IsEmailValid(this.userRegistration.Email, this.dwUiConfig.emailValidationRegEx);
        return this.isEmailValid;
    }
    configureRegistrationCustomComponent(componentInstance) {
        this.userRegistrationExtension = componentInstance;
        componentInstance.data = this.registrationExtenededData;
        if (!componentInstance.dataChange || !componentInstance.setupComponent) {
            throw new Error('Registration components must inherit from the DwUserRegistrationExtensionBase class');
        }
        componentInstance.dataChange.subscribe(data => {
            setTimeout(() => {
                this.registrationExtenededData = Object.assign(Object.assign({}, this.registrationExtenededData), data);
            }, 50);
        });
        if (componentInstance.userRegistrationDataChange) {
            componentInstance.userRegistrationDataChange.subscribe(userRegistration => {
                setTimeout(() => {
                    this.userRegistration = Object.assign(Object.assign({}, this.userRegistration), userRegistration);
                    // trigger this to update username and validate e-mail
                    this.changeEmail();
                });
            });
        }
        componentInstance.setupComponent();
    }
}
DwUserRegistrationComponent.ɵfac = function DwUserRegistrationComponent_Factory(t) { return new (t || DwUserRegistrationComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityRegistrationRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService), ɵngcc0.ɵɵdirectiveInject(DwSecurityStateService), ɵngcc0.ɵɵdirectiveInject(DwAppInitService), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken)); };
DwUserRegistrationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUserRegistrationComponent, selectors: [["dw-user-registration"]], ngContentSelectors: _c18, decls: 18, vars: 5, consts: [[1, "login"], [1, "card"], [1, "card-header"], [1, "card-body"], [3, "message"], [1, "body-left"], [1, "body-left-content"], [1, "dw-logo-login"], [1, "body-right"], [1, "body-right-content"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["userRegistrationTemplate", ""], ["twoFactorTemplate", ""], [1, "row"], [1, "login-image"], ["class", "fa fa-id-card login-icon", 4, "ngIf"], ["class", "fa fa-id-card login-icon dw-orange", 4, "ngIf"], [1, "login-input"], [1, "pull-left", 2, "width", "50%"], [3, "label", "inputClass", "containerClass", "name", "ngModel", "autoComplete", "useFloat", "placeholder", "ngModelChange"], [1, "pull-left", 2, "width", "calc(50% - 3px)", "margin-left", "2px"], ["class", "fa fa-envelope login-icon", 4, "ngIf"], ["class", "fa fa-envelope login-icon dw-orange", 4, "ngIf"], ["class", "fa fa-envelope login-icon dw-red", 4, "ngIf"], ["class", "dw-red", 4, "ngIf"], ["class", "row", 4, "ngIf"], [3, "password", "isPasswordValid", "useFloat", "passwordChange", "isPasswordValidChange"], [3, "componentName", "configure", 4, "ngIf"], [1, "col-md-12"], [1, "hand", 3, "click"], [1, "form-control", "btn", "btn-primary", "btn-register", 3, "disabled", "click"], ["class", "fa fa-spinner fa-pulse fa-fw", 4, "ngIf"], [1, "fa", "fa-id-card", "login-icon"], [1, "fa", "fa-id-card", "login-icon", "dw-orange"], [1, "fa", "fa-envelope", "login-icon"], [1, "fa", "fa-envelope", "login-icon", "dw-orange"], [1, "fa", "fa-envelope", "login-icon", "dw-red"], [1, "dw-red"], ["class", "fa fa-user-circle login-icon", 4, "ngIf"], ["class", "fa fa-user-circle login-icon dw-orange", 4, "ngIf"], [1, "label"], ["type", "text", "id", "tbUserName", "name", "tbUserName", "placeholder", "Username", "autocomplete", "chrome-off", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "fa", "fa-user-circle", "login-icon"], [1, "fa", "fa-user-circle", "login-icon", "dw-orange"], [3, "componentName", "configure"], [3, "siteKey", "onResponse", "onExpire", "initCallback"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"], [2, "margin-top", "3px", "margin-bottom", "3px", "height", "10px"], [3, "click"], ["src", "/assets/img/user-password.png"], ["type", "text", "id", "tbTwoFactorCode", "name", "tbTwoFactorCode", "placeholder", "two factor code", "required", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "submit", 1, "form-control", "btn", "btn-success", 3, "disabled", "click"]], template: function DwUserRegistrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c17);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelement(6, "dw-message", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelement(9, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵtemplate(12, DwUserRegistrationComponent_ng_container_12_Template, 1, 0, "ng-container", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(13, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DwUserRegistrationComponent_ng_template_14_Template, 30, 39, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(16, DwUserRegistrationComponent_ng_template_16_Template, 19, 3, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(15);
        const _r3 = ɵngcc0.ɵɵreference(17);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate((ctx.dwUIConfig.registrationConfig == null ? null : ctx.dwUIConfig.registrationConfig.registerTitle) || "Register");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showTwoFactor)("ngIfThen", _r3)("ngIfElse", _r1);
    } }, directives: function () { return [DwMessageComponent, ɵngcc4.NgIf, DwFloatingLabelInputComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwPasswordComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.RequiredValidator, DwDynamicLoaderComponent, ɵngcc23.Captcha, DwMissingImageDirective]; }, styles: [""] });
DwUserRegistrationComponent.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwSecurityRegistrationRepositoryService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwSecurityOrchestrationService },
    { type: DwSecurityStateService },
    { type: DwAppInitService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];

var __decorate$B = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$q = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class QuillEditorComponent {
    constructor(elementRef, zone, document, lazyLoadScriptService) {
        this.elementRef = elementRef;
        this.zone = zone;
        this.document = document;
        this.lazyLoadScriptService = lazyLoadScriptService;
        this.html = '';
        this.htmlChange = new EventEmitter();
        this.previousHtml = '';
        this.onEditorCreated = new EventEmitter();
        this.showEditor = false;
    }
    ngOnChanges(changes) {
        if (changes.disabled && !changes.disabled.firstChange) {
            this.setDisabled();
        }
        if (changes.html && this.html !== this.previousHtml) {
            if (this.quillEditor) {
                const contents = this.quillEditor.clipboard.convert(this.html);
                this.quillEditor.setContents(contents, 'user');
            }
        }
    }
    ngOnInit() {
        const ob1 = this.lazyLoadScriptService.loadStyle('/assets/scripts/quill.core.css');
        const ob2 = this.lazyLoadScriptService.loadStyle('/assets/scripts/quill.snow.css');
        this.lazyLoadScriptService.loadScript('/assets/scripts/quill.min.js')
            .subscribe(() => {
            if (!Quill) {
                Quill = this.document.defaultView.Quill;
            }
            this.setupQuill();
        });
        /*   this.svc.lazyLoadQuill().subscribe(_ => {
            if (!Quill) {
              Quill = this.document.defaultView.Quill;
            }
            this.setupQuill();
          }); */
    }
    setupQuill() {
        if (!Quill) {
            return;
        }
        //HACK: the import command below gets identified by the IVY compiler and errors when it can't find the dependency.  By building it dynamically, it solves this issue.
        /*    let prefix = 'attributes';
           let name = `${prefix}/style/align`
           const align = Quill.import(name); */
        // use generic align styles
        /*   align.whitelist = ['right', 'center', 'justify'];
          Quill.register(align, true);
       */
        const toolbarElem = this.elementRef.nativeElement.querySelector('[quill-editor-toolbar]');
        const editorElem = this.elementRef.nativeElement.querySelector('[quill-editor-container]');
        this.quillEditor = new Quill(editorElem, {
            format: 'html',
            theme: 'snow',
            modules: this.modules || {
                toolbar: toolbarElem
            }
        });
        const contents = this.quillEditor.clipboard.convert(this.html);
        this.quillEditor.setContents(contents, 'silent');
        this.quillEditor.history.clear();
        this.setDisabled();
        this.onEditorCreated.emit(this.quillEditor);
        this.textChangeEvent = this.quillEditor.on('text-change', (delta, oldDelta, source) => {
            if (source === 'user') {
                let html = this.quillEditor.root.innerHTML || '';
                if (html === '<p><br></p>' || html === '<div><br><div>') {
                    html = '';
                }
                this.html = html;
                this.previousHtml = html;
                this.zone.run(() => {
                    this.htmlChange.emit(html);
                });
            }
        });
    }
    setDisabled() {
        if (!this.quillEditor) {
            return;
        }
        // this.quillEditor?.enable(this.disabled);
    }
    ngOnDestroy() {
        if (this.textChangeEvent) {
            this.textChangeEvent.removeListener('text-change');
        }
    }
}
QuillEditorComponent.ɵfac = function QuillEditorComponent_Factory(t) { return new (t || QuillEditorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(LazyLoadScriptService)); };
QuillEditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: QuillEditorComponent, selectors: [["dw-quill-editor"]], inputs: { html: "html", disabled: "disabled", modules: "modules" }, outputs: { htmlChange: "htmlChange", onEditorCreated: "onEditorCreated" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 58, vars: 0, consts: [["quill-editor-toolbar", "", 2, "display", "none"], [1, "ql-formats"], ["title", "Heading", 1, "ql-header"], ["value", "1"], ["value", "2"], ["value", "3"], ["value", "4"], ["value", "5"], ["selected", "selected"], ["title", "Bold", 1, "ql-bold"], ["title", "Italic", 1, "ql-italic"], ["title", "Underline", 1, "ql-underline"], ["title", "Strike", 1, "ql-strike"], ["title", "Link", 1, "ql-link"], ["title", "Block Quote", 1, "ql-blockquote"], ["title", "Code Block", 1, "ql-code-block"], ["value", "sub", "title", "Subscript", 1, "ql-script"], ["value", "super", "title", "Superscript", 1, "ql-script"], ["value", "ordered", "title", "Ordered List", 1, "ql-list"], ["value", "bullet", "title", "Bullet List", 1, "ql-list"], ["value", "-1", "title", "Increase Indent", 1, "ql-indent"], ["value", "+1", "title", "Decrease Indent", 1, "ql-indent"], ["title", "Font Color", 1, "ql-color"], ["selected", ""], ["value", "#ffffff"], ["value", "#eeeeee"], ["value", "#808080"], ["value", "#ff0000"], ["value", "#00ff00"], ["value", "#0000ff"], ["title", "Background Color", 1, "ql-background"], ["value", "#000000"], ["title", "Aligment", 1, "ql-align"], ["value", "center"], ["value", "right"], ["value", "justify"], ["id", "custom-fields", "title", "Fields", 1, "ql-script"], ["value", "field1"], ["value", "field2"], ["value", "field3"], ["quill-editor-container", ""]], template: function QuillEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "select", 2);
        ɵngcc0.ɵɵelement(3, "option", 3);
        ɵngcc0.ɵɵelement(4, "option", 4);
        ɵngcc0.ɵɵelement(5, "option", 5);
        ɵngcc0.ɵɵelement(6, "option", 6);
        ɵngcc0.ɵɵelement(7, "option", 7);
        ɵngcc0.ɵɵelement(8, "option", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 1);
        ɵngcc0.ɵɵelement(10, "button", 9);
        ɵngcc0.ɵɵelement(11, "button", 10);
        ɵngcc0.ɵɵelement(12, "button", 11);
        ɵngcc0.ɵɵelement(13, "button", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span", 1);
        ɵngcc0.ɵɵelement(15, "button", 13);
        ɵngcc0.ɵɵelement(16, "button", 14);
        ɵngcc0.ɵɵelement(17, "button", 15);
        ɵngcc0.ɵɵelement(18, "button", 16);
        ɵngcc0.ɵɵelement(19, "button", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "span", 1);
        ɵngcc0.ɵɵelement(21, "button", 18);
        ɵngcc0.ɵɵelement(22, "button", 19);
        ɵngcc0.ɵɵelement(23, "button", 20);
        ɵngcc0.ɵɵelement(24, "button", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "span", 1);
        ɵngcc0.ɵɵelementStart(26, "select", 22);
        ɵngcc0.ɵɵelement(27, "option", 23);
        ɵngcc0.ɵɵelement(28, "option", 24);
        ɵngcc0.ɵɵelement(29, "option", 25);
        ɵngcc0.ɵɵelement(30, "option", 26);
        ɵngcc0.ɵɵelement(31, "option", 27);
        ɵngcc0.ɵɵelement(32, "option", 28);
        ɵngcc0.ɵɵelement(33, "option", 29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "select", 30);
        ɵngcc0.ɵɵelement(35, "option", 23);
        ɵngcc0.ɵɵelement(36, "option", 25);
        ɵngcc0.ɵɵelement(37, "option", 26);
        ɵngcc0.ɵɵelement(38, "option", 31);
        ɵngcc0.ɵɵelement(39, "option", 27);
        ɵngcc0.ɵɵelement(40, "option", 28);
        ɵngcc0.ɵɵelement(41, "option", 29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "span", 1);
        ɵngcc0.ɵɵelementStart(43, "select", 32);
        ɵngcc0.ɵɵelement(44, "option", 23);
        ɵngcc0.ɵɵelement(45, "option", 33);
        ɵngcc0.ɵɵelement(46, "option", 34);
        ɵngcc0.ɵɵelement(47, "option", 35);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "span", 1);
        ɵngcc0.ɵɵelementStart(49, "select", 36);
        ɵngcc0.ɵɵelement(50, "option", 23);
        ɵngcc0.ɵɵelementStart(51, "option", 37);
        ɵngcc0.ɵɵtext(52, "Field 1");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "option", 38);
        ɵngcc0.ɵɵtext(54, "Field 2");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "option", 39);
        ɵngcc0.ɵɵtext(56, "Field 3");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(57, "div", 40);
    } }, directives: [ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
QuillEditorComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: LazyLoadScriptService }
];
QuillEditorComponent.propDecorators = {
    html: [{ type: Input }],
    htmlChange: [{ type: Output }],
    disabled: [{ type: Input }],
    modules: [{ type: Input }],
    onEditorCreated: [{ type: Output }]
};
__decorate$B([
    DwInputConverter(booleanConverter),
    __metadata$q("design:type", Boolean)
], QuillEditorComponent.prototype, "disabled", void 0);

var __decorate$C = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$r = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwSecurityTwofactorSetupComponent = class DwSecurityTwofactorSetupComponent {
    constructor(dwSecurityUserService, dwSecurityOrchestrationService, dwSecurityTwoFactorRepositoryService) {
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwSecurityOrchestrationService = dwSecurityOrchestrationService;
        this.dwSecurityTwoFactorRepositoryService = dwSecurityTwoFactorRepositoryService;
        this.twoFactorEnabled = false;
        this.step = 0;
        this.processing = false;
        this.disableTwoFactorCode = "";
        this.showDisableTwoFactor = false;
        this.message = null;
    }
    ngOnInit() {
        var _a;
        const user = (_a = this.dwSecurityUserService.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
        this.twoFactorEnabled = user === null || user === void 0 ? void 0 : user.IsTwoFactorAuthenticationEnabled;
        this.twoFactorRequest = {
            FactorType: SecurityFactorTypes.authenticatorApp,
            TwoFactorCode: null
        };
    }
    showStep1() {
        this.step = 1;
        this.message = null;
    }
    showStep2() {
        if (!this.twoFactorRequest.FactorType || this.processing) {
            this.message = {
                messageBody: 'Please select a factor type',
                severity: DwMessageSeverity.success
            };
            return;
        }
        this.message = null;
        this.processing = true;
        this.dwSecurityTwoFactorRepositoryService.startTwoFactorSetup(this.twoFactorRequest)
            .subscribe(response => {
            this.twoFactorResponse = response;
            this.showResendCode = (this.twoFactorRequest.FactorType != SecurityFactorTypes.authenticatorApp);
            this.step = 2;
            this.processing = false;
        });
    }
    complete() {
        if (!this.twoFactorRequest.TwoFactorCode || this.processing) {
            this.message = {
                messageBody: 'Please enter a two-factor code',
                severity: DwMessageSeverity.success
            };
            return;
        }
        this.message = null;
        this.processing = true;
        this.dwSecurityTwoFactorRepositoryService.completeTwoFactorSetup(this.twoFactorRequest)
            .subscribe(response => {
            this.processing = false;
            if (response.SetupComplete) {
                this.twoFactorEnabled = true;
                this.refreshUserInfo();
                this.message = {
                    messageBody: 'Two-factor authentication has been configured',
                    severity: DwMessageSeverity.success
                };
                this.step = 0;
            }
            else {
                this.message = {
                    messageBody: response.Message,
                    severity: response.Success ? DwMessageSeverity.success : DwMessageSeverity.error
                };
            }
        });
    }
    startDisableTwoFactor() {
        var _a;
        this.message = null;
        this.showDisableTwoFactor = true;
        const user = (_a = this.dwSecurityUserService.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
        this.showResendCode = ((user === null || user === void 0 ? void 0 : user.TwoFactorAuthenticationType) != SecurityFactorTypes.authenticatorApp);
        if (this.showResendCode) {
            this.resendCode();
        }
    }
    disabledTwoFactor() {
        this.processing = true;
        this.message = null;
        this.dwSecurityTwoFactorRepositoryService.disableTwoFactorAuthentication(this.disableTwoFactorCode)
            .subscribe(response => {
            this.twoFactorEnabled = false;
            this.showDisableTwoFactor = false;
            this.processing = false;
            this.refreshUserInfo();
            this.message = {
                messageBody: 'Two-factor authentication has been disabled',
                severity: DwMessageSeverity.success
            };
        });
    }
    resendCode() {
        this.processing = true;
        this.message = null;
        this.dwSecurityTwoFactorRepositoryService.sendTwoFactorCode()
            .subscribe(result => {
            this.processing = false;
            this.message = {
                messageBody: 'Two-factor code sent',
                severity: DwMessageSeverity.success
            };
        });
    }
    cancel() {
        this.step = 0;
        this.showDisableTwoFactor = false;
    }
    refreshUserInfo() {
        this.dwSecurityOrchestrationService.reAuthenticate(this.dwSecurityUserService.securityState.securityContext.SecurityToken, DwAuthenticationType.reauthenticate)
            .subscribe(result => {
            var _a;
            const user = (_a = this.dwSecurityUserService.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
            this.twoFactorEnabled = user === null || user === void 0 ? void 0 : user.IsTwoFactorAuthenticationEnabled;
        });
    }
};
DwSecurityTwofactorSetupComponent.ɵfac = function DwSecurityTwofactorSetupComponent_Factory(t) { return new (t || DwSecurityTwofactorSetupComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService), ɵngcc0.ɵɵdirectiveInject(DwSecurityTwoFactorRepositoryService)); };
DwSecurityTwofactorSetupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityTwofactorSetupComponent, selectors: [["dw-dw-security-twofactor-setup"]], decls: 10, vars: 4, consts: [["dwRow", ""], ["dwCol", "6"], [3, "message"], [4, "ngIf"], ["class", "btn btn-success", 3, "click", 4, "ngIf"], [1, "btn", "btn-success", 3, "click"], [1, "radio-container"], ["type", "radio", "name", "factorType", "value", "AuthenticatorApp", 3, "ngModel", "ngModelChange"], [1, "radio-item"], [1, "radio-desc"], ["type", "radio", "name", "factorType", "value", "Email", 3, "ngModel", "ngModelChange"], [1, "btn", "btn-success", 3, "disabled", "click"], ["class", "fa fa-spinner fa-pulse fa-fw", 4, "ngIf"], [1, "btn", "btn-secondary", "ml-2", 3, "click"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"], ["type", "text", 1, "form-control", "code-input", 3, "ngModel", "ngModelChange"], [3, "src"], ["class", "dw-blue", 3, "click", 4, "ngIf"], [1, "dw-blue", 3, "click"], [1, "btn", "btn-danger", 3, "click"], [1, "btn", "btn-danger", 3, "disabled", "click"]], template: function DwSecurityTwofactorSetupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "H1");
        ɵngcc0.ɵɵtext(1, "Two-factor Authentication");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "p");
        ɵngcc0.ɵɵtext(3, " Two-factor authentication (2FA) is an extra layer of security used when logging into websites or apps.\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 0);
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵelement(6, "dw-message", 2);
        ɵngcc0.ɵɵtemplate(7, DwSecurityTwofactorSetupComponent_ng_container_7_Template, 4, 3, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(8, DwSecurityTwofactorSetupComponent_ng_container_8_Template, 5, 0, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(9, DwSecurityTwofactorSetupComponent_ng_container_9_Template, 11, 4, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.twoFactorEnabled && !ctx.showDisableTwoFactor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.twoFactorEnabled && !ctx.showDisableTwoFactor);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDisableTwoFactor);
    } }, directives: [DwRowDirective, DwColDirective, DwMessageComponent, ɵngcc4.NgIf, ɵngcc3.RadioControlValueAccessor, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [".radio-container[_ngcontent-%COMP%]{margin:5px}.radio-item[_ngcontent-%COMP%]{margin-left:5px;margin-top:-6px}.radio-desc[_ngcontent-%COMP%]{margin-bottom:4px;margin-left:15px;margin-top:4px}.code-input[_ngcontent-%COMP%]{max-width:150px}"] });
DwSecurityTwofactorSetupComponent.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: DwSecurityOrchestrationService },
    { type: DwSecurityTwoFactorRepositoryService }
];
DwSecurityTwofactorSetupComponent = __decorate$C([
    DwComponent({
        key: 'twoFactorSetup',
        name: 'Two Factor Setup',
        componentType: DwComponentType.pageComponent,
        isGlobal: true
    }),
    __metadata$r("design:paramtypes", [DwSecurityUserService,
        DwSecurityOrchestrationService,
        DwSecurityTwoFactorRepositoryService])
], DwSecurityTwofactorSetupComponent);

class DwLoginSsoOptionsComponent {
    constructor(dwSecurityRespositoryService, dwSecurityOrchestrationService) {
        this.dwSecurityRespositoryService = dwSecurityRespositoryService;
        this.dwSecurityOrchestrationService = dwSecurityOrchestrationService;
        this.isProcessing = new EventEmitter();
        this.processing = false;
    }
    ngOnInit() {
        this.dwSecurityRespositoryService.getSSOConfigs()
            .subscribe(ssoConfigs => {
            this.ssoConfigs = ssoConfigs.filter(c => c.EnableSSO);
        });
    }
    authenticateWithSSO(ssoConfig) {
        this.processing = true;
        this.isProcessing.emit(this.processing);
        this.dwSecurityOrchestrationService.gotoSSOLogin(ssoConfig.TenantSsoConfigId)
            .subscribe(result => {
            this.processing = false;
            // this.isProcessing.emit(this.processing);
        });
    }
}
DwLoginSsoOptionsComponent.ɵfac = function DwLoginSsoOptionsComponent_Factory(t) { return new (t || DwLoginSsoOptionsComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService)); };
DwLoginSsoOptionsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLoginSsoOptionsComponent, selectors: [["dw-login-sso-options"]], outputs: { isProcessing: "isProcessing" }, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["type", "button", 3, "disabled", "click"], [3, "hidden"], ["class", "fa fa-spinner fa-pulse fa-fw", 4, "ngIf"], [1, "fa", "fa-spinner", "fa-pulse", "fa-fw"]], template: function DwLoginSsoOptionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwLoginSsoOptionsComponent_ng_container_0_Template, 5, 10, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.ssoConfigs);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgIf], encapsulation: 2 });
DwLoginSsoOptionsComponent.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwSecurityOrchestrationService }
];
DwLoginSsoOptionsComponent.propDecorators = {
    isProcessing: [{ type: Output }]
};

class DwFileSizePipe {
    constructor() {
        this.kbConversion = 1024;
        this.mbConversion = 1024 * this.kbConversion;
        this.gbConversion = 1024 * this.mbConversion;
    }
    transform(size) {
        if (size == null || size == undefined) {
            return null;
        }
        if (size > this.gbConversion) {
            return (size / this.gbConversion).toFixed(2) + 'GB';
        }
        if (size > this.mbConversion) {
            return (size / this.mbConversion).toFixed(2) + 'MB';
        }
        if (size > this.kbConversion) {
            return (size / this.kbConversion).toFixed(0) + 'KB';
        }
        return (size / this.kbConversion).toFixed(2) + 'B';
    }
}
DwFileSizePipe.ɵfac = function DwFileSizePipe_Factory(t) { return new (t || DwFileSizePipe)(); };
DwFileSizePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "filesize", type: DwFileSizePipe, pure: true });

class DwDivHeightDirective {
    constructor(elementRef, sanitizer) {
        var _a, _b;
        this.elementRef = elementRef;
        this.sanitizer = sanitizer;
        this.heightPercent = 100;
        this.name = 'Default';
        this.recalcHeight = new Subject();
        this.recalcHeight.asObservable()
            .pipe(distinctUntilChanged(), debounceTime(50))
            .subscribe((width) => {
            if (this.heightPercent == 75) {
                // console.log(`Div Recalc Observable change  ${this.heightPercent}% - ${this.name} -- new width ${width}`);
            }
            this.setDivHeight(width);
        });
        this.setDivHeight((_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth);
        if (this.heightPercent > 75) {
            // console.log('DwDivheight created - ' + this.heightPercent, elementRef);
        }
    }
    ngDoCheck() {
        var _a, _b;
        const width = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        // if (this.heightPercent>75) {
        //   console.log(`Div Do Check  ${this.heightPercent}% - ${this.name} - width: ${width}  div height: ${this.divHeight}`);
        // }
        this.recalcHeight.next(width);
    }
    onResize(target) {
        var _a, _b;
        // if (this.heightPercent>75) {
        //   console.log(`Div Window Resize  ${this.heightPercent}% - ${this.name}`);
        // }
        const width = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        this.recalcHeight.next(width);
    }
    setDivHeight(width) {
        if (width) {
            const newDivHeight = Math.round((width * this.heightPercent) / 100);
            if (this.divHeight != newDivHeight) {
                // console.log(`Div Resize  ${this.heightPercent}% - ${this.name} - ${width} x ${newDivHeight}   Old Height: ${this.divHeight}`);
                this.divHeight = newDivHeight;
            }
        }
        else {
            //console.log(`Div - no width ${this.heightPercent}% - ${this.name}`);
        }
    }
}
DwDivHeightDirective.ɵfac = function DwDivHeightDirective_Factory(t) { return new (t || DwDivHeightDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc17.DomSanitizer)); };
DwDivHeightDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwDivHeightDirective, selectors: [["", "dwHeight", ""]], hostVars: 2, hostBindings: function DwDivHeightDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwDivHeightDirective_resize_HostBindingHandler($event) { return ctx.onResize($event.target); }, false, ɵngcc0.ɵɵresolveWindow);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("height", ctx.divHeight, "px");
    } }, inputs: { heightPercent: ["dwHeight", "heightPercent"], name: "name" } });
DwDivHeightDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: DomSanitizer }
];
DwDivHeightDirective.propDecorators = {
    heightPercent: [{ type: Input, args: ['dwHeight',] }],
    name: [{ type: Input, args: ['name',] }],
    divHeight: [{ type: HostBinding, args: ['style.height.px',] }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event.target'],] }]
};

class DwMissingImageDirective {
    constructor(el) {
        this.el = el;
        this.defaultSrc = 'assets/img/no-image-available.png';
    }
    onError() {
        const currentSrc = this.el.nativeElement.src;
        if (this.lastSrc == currentSrc) {
            // Sometimes this prevents loading the 
            //  return;
        }
        this.lastSrc = currentSrc;
        if (this.defaultSrc && currentSrc.indexOf(this.defaultSrc) < 0) {
            console.warn('Error loading image - replacing src', currentSrc, this.defaultSrc);
            this.el.nativeElement.src = this.defaultSrc;
            this.color = 'red';
        }
        else {
            console.warn('Error loading image - Hiding', currentSrc);
            this.el.nativeElement.style.display = "none";
        }
    }
}
DwMissingImageDirective.ɵfac = function DwMissingImageDirective_Factory(t) { return new (t || DwMissingImageDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwMissingImageDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMissingImageDirective, selectors: [["img"], ["", "dwMissingImage", ""]], hostBindings: function DwMissingImageDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("error", function DwMissingImageDirective_error_HostBindingHandler() { return ctx.onError(); });
    } }, inputs: { defaultSrc: "defaultSrc" } });
DwMissingImageDirective.ctorParameters = () => [
    { type: ElementRef }
];
DwMissingImageDirective.propDecorators = {
    defaultSrc: [{ type: Input }],
    onError: [{ type: HostListener, args: ["error",] }]
};

class DwFileExtPipe {
    transform(fileName) {
        if (fileName) {
            const index = fileName.lastIndexOf('.');
            if (index >= 0) {
                return fileName.substring(index + 1, fileName.length);
            }
        }
        return '';
    }
}
DwFileExtPipe.ɵfac = function DwFileExtPipe_Factory(t) { return new (t || DwFileExtPipe)(); };
DwFileExtPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "fileext", type: DwFileExtPipe, pure: true });

class DwDivColumnManagerDirective {
    constructor(elementRef, sanitizer) {
        this.elementRef = elementRef;
        this.sanitizer = sanitizer;
        this.heightPercent = 100;
        this.columns = 5;
        this.name = 'Default';
        this.itemCount = 0;
        this.recalcHeight = new Subject();
        this.recalcHeight.asObservable()
            .pipe(distinctUntilChanged(), debounceTime(50))
            .subscribe((width) => {
            this.setDivHeights(width);
        });
        this.setDivHeights(window.innerWidth);
    }
    ngOnChanges(changes) {
        var _a, _b;
        const width = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        // if (this.heightPercent>75) {
        //   console.log(`Div Do Check  ${this.heightPercent}% - ${this.name} - width: ${width}  div height: ${this.divHeight}`);
        // }
        this.recalcHeight.next(width + this.itemCount);
    }
    ngDoCheck() {
        var _a, _b;
        const width = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        // if (this.heightPercent>75) {
        //   console.log(`Div Do Check  ${this.heightPercent}% - ${this.name} - width: ${width}  div height: ${this.divHeight}`);
        // }
        this.recalcHeight.next(width);
    }
    onResize(target) {
        var _a, _b;
        const width = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        this.recalcHeight.next(width);
    }
    setDivHeights(width) {
        var _a, _b;
        width = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        if (!width) {
            return;
        }
        const widthPercentage = 100 / this.columns;
        const columnWidth = width / this.columns;
        const columnHeight = Math.round((columnWidth * this.heightPercent) / 100);
        var children = this.elementRef.nativeElement.children;
        if (children.length == 0) {
            // If there are no children, try again on next cycle
            this.recalcHeight.next(width + 1);
        }
        for (const child of children) {
            child.style = children.style || {};
            child.style.width = `${widthPercentage}%`;
            child.style.height = `${columnHeight}px`;
        }
    }
}
DwDivColumnManagerDirective.ɵfac = function DwDivColumnManagerDirective_Factory(t) { return new (t || DwDivColumnManagerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc17.DomSanitizer)); };
DwDivColumnManagerDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwDivColumnManagerDirective, selectors: [["", "dwColumnManager", ""]], hostVars: 2, hostBindings: function DwDivColumnManagerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwDivColumnManagerDirective_resize_HostBindingHandler($event) { return ctx.onResize($event.target); }, false, ɵngcc0.ɵɵresolveWindow);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.divWidth);
    } }, inputs: { heightPercent: "heightPercent", columns: ["dwColumnManager", "columns"], name: "name", itemCount: "itemCount" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwDivColumnManagerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: DomSanitizer }
];
DwDivColumnManagerDirective.propDecorators = {
    heightPercent: [{ type: Input, args: ['heightPercent',] }],
    columns: [{ type: Input, args: ['dwColumnManager',] }],
    name: [{ type: Input, args: ['name',] }],
    itemCount: [{ type: Input, args: ['itemCount',] }],
    divWidth: [{ type: HostBinding, args: ['style.width',] }],
    onResize: [{ type: HostListener, args: ['window:resize', ['$event.target'],] }]
};

class DwStyleBuilderComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwStyleBuilderComponent.ɵfac = function DwStyleBuilderComponent_Factory(t) { return new (t || DwStyleBuilderComponent)(); };
DwStyleBuilderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwStyleBuilderComponent, selectors: [["dw-dw-style-builder"]], decls: 2, vars: 0, template: function DwStyleBuilderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-style-builder works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwStyleBuilderComponent.ctorParameters = () => [];

class DwAddSpacesPipe {
    transform(text) {
        if (text) {
            return addSpaces(text);
        }
        return '';
    }
}
DwAddSpacesPipe.ɵfac = function DwAddSpacesPipe_Factory(t) { return new (t || DwAddSpacesPipe)(); };
DwAddSpacesPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "addSpaces", type: DwAddSpacesPipe, pure: true });

class DwMiddleClickDirective {
    constructor() {
        this.middleclick = new EventEmitter();
    }
    middleclickEvent(event) {
        if (event.button === 1) {
            this.middleclick.emit(event);
        }
    }
}
DwMiddleClickDirective.ɵfac = function DwMiddleClickDirective_Factory(t) { return new (t || DwMiddleClickDirective)(); };
DwMiddleClickDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMiddleClickDirective, selectors: [["", "middleclick", ""]], hostBindings: function DwMiddleClickDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseup", function DwMiddleClickDirective_mouseup_HostBindingHandler($event) { return ctx.middleclickEvent($event); });
    } }, outputs: { middleclick: "middleclick" } });
DwMiddleClickDirective.ctorParameters = () => [];
DwMiddleClickDirective.propDecorators = {
    middleclick: [{ type: Output, args: ['middleclick',] }],
    middleclickEvent: [{ type: HostListener, args: ['mouseup', ['$event'],] }]
};

class DwPasswordUtilService {
    checkPasswordComplexity(password, passwordRequirements) {
        var uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var lowercase = "abcdefghijklmnopqrstuvwxyz";
        var digits = "0123456789";
        var splChars = "!@#$%&*()";
        var result = {};
        if (passwordRequirements.RequireUppercase) {
            result.needsUpper = !this.contains(password, uppercase);
        }
        if (passwordRequirements.RequireLowercase) {
            result.needsLower = !this.contains(password, lowercase);
        }
        if (passwordRequirements.RequireDigit) {
            result.needsNumeric = !this.contains(password, digits);
        }
        if (passwordRequirements.RequireNonAlphanumeric) {
            result.needsSpecialChar = !this.contains(password, splChars);
        }
        if (passwordRequirements.RequiredLength && password.length < passwordRequirements.RequiredLength) {
            result.invalidLength = true;
        }
        if (result.needsUpper || result.needsLower || result.needsNumeric || result.needsSpecialChar || result.invalidLength) {
            result.isValid = false;
            result.messages = this.getPasswordComplexityText(result, passwordRequirements);
        }
        else {
            result.isValid = true;
        }
        return result;
        /*  var lcaseFlag = this.contains(password, lowercase);
 
         var digitsFlag = this.contains(password, digits);
 
         var splCharsFlag = this.contains(password, splChars);
 
         if (password.length >= 8 && ucaseFlag && lcaseFlag && digitsFlag && splCharsFlag)
             return true;
         else
             return false; */
    }
    getPasswordComplexityText(complexityResult, passwordRequirements) {
        let passwordComplexity = [];
        if (passwordRequirements && !complexityResult.isValid) {
            if (complexityResult.needsUpper) {
                passwordComplexity.push("At least one uppercase");
            }
            if (complexityResult.needsLower) {
                passwordComplexity.push("At least one lowercase");
            }
            if (complexityResult.needsNumeric) {
                passwordComplexity.push("At least one numeric");
            }
            if (complexityResult.needsSpecialChar) {
                passwordComplexity.push("At least one special character - !@#$%&*()");
            }
            if (complexityResult.invalidLength) {
                passwordComplexity.push(`A minimum length of ${passwordRequirements.RequiredLength} characters`);
            }
        }
        return passwordComplexity;
    }
    getPasswordComplexityRequirementsText(passwordRequirements) {
        let passwordComplexity = [];
        if (passwordRequirements) {
            if (passwordRequirements.RequireUppercase) {
                passwordComplexity.push("At least one uppercase");
            }
            if (passwordRequirements.RequireLowercase) {
                passwordComplexity.push("At least one lowercase");
            }
            if (passwordRequirements.RequireDigit) {
                passwordComplexity.push("At least one numeric");
            }
            if (passwordRequirements.RequireNonAlphanumeric) {
                passwordComplexity.push("At least one special character - !@#$%&*()");
            }
            if (passwordRequirements.RequiredLength) {
                passwordComplexity.push(`Has a minimum length of ${passwordRequirements.RequiredLength}`);
            }
        }
        return passwordComplexity;
    }
    contains(password, allowedChars) {
        for (let i = 0; i < password.length; i++) {
            var char = password.charAt(i);
            if (allowedChars.indexOf(char) >= 0) {
                return true;
            }
        }
        return false;
    }
}
DwPasswordUtilService.ɵfac = function DwPasswordUtilService_Factory(t) { return new (t || DwPasswordUtilService)(); };
DwPasswordUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwPasswordUtilService_Factory() { return new DwPasswordUtilService(); }, token: DwPasswordUtilService, providedIn: "root" });

class DwPasswordComponent {
    constructor(dwSecurityRepositoryService, dwSecurityRegistrationRepositoryService, dwConfigService, dwUIConfig, dwSecurityOrchestrationService, dwSecurityStateService, dwAppInitService, dwPasswordUtil) {
        this.dwSecurityRepositoryService = dwSecurityRepositoryService;
        this.dwSecurityRegistrationRepositoryService = dwSecurityRegistrationRepositoryService;
        this.dwConfigService = dwConfigService;
        this.dwUIConfig = dwUIConfig;
        this.dwSecurityOrchestrationService = dwSecurityOrchestrationService;
        this.dwSecurityStateService = dwSecurityStateService;
        this.dwAppInitService = dwAppInitService;
        this.dwPasswordUtil = dwPasswordUtil;
        this.passwordChange = new EventEmitter();
        this.isPasswordValidChange = new EventEmitter();
        this.useFloat = false;
        dwSecurityRegistrationRepositoryService.suppressErrorMessages = true;
    }
    ngOnInit() {
        this.dwAppInitService.getAppInitResult()
            .subscribe(appInitResult => {
            this.passwordRequirements = appInitResult.SecurityConfig.PasswordRequirements;
            this.passwordRequirementList = this.dwPasswordUtil.getPasswordComplexityRequirementsText(this.passwordRequirements);
        });
    }
    onChange() {
        const passwordMeetsComplexity = this.validatePassword();
        if (passwordMeetsComplexity && this.password == this.passwordRetype) {
            this.isPasswordValid = true;
        }
        else {
            this.isPasswordValid = false;
        }
        this.isPasswordValidChange.emit(this.isPasswordValid);
        this.passwordChange.emit(this.password);
    }
    validatePassword() {
        if (!this.passwordRequirements) {
            return false;
        }
        var passwordUtil = new DwPasswordUtilService();
        this.passwordCheckResults = passwordUtil.checkPasswordComplexity(this.password, this.passwordRequirements);
        return this.passwordCheckResults.isValid;
    }
}
DwPasswordComponent.ɵfac = function DwPasswordComponent_Factory(t) { return new (t || DwPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityRegistrationRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityOrchestrationService), ɵngcc0.ɵɵdirectiveInject(DwSecurityStateService), ɵngcc0.ɵɵdirectiveInject(DwAppInitService), ɵngcc0.ɵɵdirectiveInject(DwPasswordUtilService)); };
DwPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPasswordComponent, selectors: [["dw-password"]], inputs: { useFloat: "useFloat", isPasswordValid: "isPasswordValid", password: "password" }, outputs: { passwordChange: "passwordChange", isPasswordValidChange: "isPasswordValidChange" }, decls: 19, vars: 27, consts: [[1, "row"], [1, "login-image"], ["class", "fa fa-lock login-icon dw-orange", 4, "ngIf"], ["class", "fa fa-lock login-icon dw-red", 4, "ngIf"], ["class", "fa fa-lock login-icon", 4, "ngIf"], [1, "login-input"], ["type", "text", "name", "fakeusernameremembered", 2, "display", "none"], [3, "type", "label", "inputClass", "containerClass", "name", "ngModel", "inputAutocomplete", "useFloat", "placeholder", "ngModelChange"], ["class", "dw-red", 4, "ngIf"], ["class", "dw-green", 4, "ngIf"], ["class", "fa fa-lock-open-alt login-icon dw-orange", 4, "ngIf"], ["class", "fa fa-lock-open-alt login-icon dw-red", 4, "ngIf"], ["class", "fa fa-lock-alt login-icon", 4, "ngIf"], [1, "fa", "fa-lock", "login-icon", "dw-orange"], [1, "fa", "fa-lock", "login-icon", "dw-red"], [1, "fa", "fa-lock", "login-icon"], [1, "dw-red"], [4, "ngFor", "ngForOf"], [1, "dw-green"], [1, "fa", "fa-lock-open-alt", "login-icon", "dw-orange"], [1, "fa", "fa-lock-open-alt", "login-icon", "dw-red"], [1, "fa", "fa-lock-alt", "login-icon"]], template: function DwPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwPasswordComponent_i_2_Template, 1, 0, "i", 2);
        ɵngcc0.ɵɵtemplate(3, DwPasswordComponent_i_3_Template, 1, 0, "i", 3);
        ɵngcc0.ɵɵtemplate(4, DwPasswordComponent_i_4_Template, 1, 0, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelement(6, "input", 6);
        ɵngcc0.ɵɵelementStart(7, "dw-floating-label-input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwPasswordComponent_Template_dw_floating_label_input_ngModelChange_7_listener($event) { return ctx.password = $event; })("ngModelChange", function DwPasswordComponent_Template_dw_floating_label_input_ngModelChange_7_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwPasswordComponent_div_8_Template, 4, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(9, DwPasswordComponent_div_9_Template, 2, 0, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 0);
        ɵngcc0.ɵɵelementStart(11, "div", 1);
        ɵngcc0.ɵɵtemplate(12, DwPasswordComponent_i_12_Template, 1, 0, "i", 10);
        ɵngcc0.ɵɵtemplate(13, DwPasswordComponent_i_13_Template, 1, 0, "i", 11);
        ɵngcc0.ɵɵtemplate(14, DwPasswordComponent_i_14_Template, 1, 0, "i", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 5);
        ɵngcc0.ɵɵelement(16, "input", 6);
        ɵngcc0.ɵɵelementStart(17, "dw-floating-label-input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwPasswordComponent_Template_dw_floating_label_input_ngModelChange_17_listener($event) { return ctx.passwordRetype = $event; })("ngModelChange", function DwPasswordComponent_Template_dw_floating_label_input_ngModelChange_17_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, DwPasswordComponent_div_18_Template, 2, 0, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.password);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.password && (ctx.passwordCheckResults == null ? null : ctx.passwordCheckResults.messages));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.password && !(ctx.passwordCheckResults == null ? null : ctx.passwordCheckResults.messages));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("type", "password")("label", "New Password")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbPasswordNew")("ngModel", ctx.password)("inputAutocomplete", "new-password")("useFloat", ctx.useFloat)("placeholder", "Password");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.passwordCheckResults == null ? null : ctx.passwordCheckResults.messages);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.passwordCheckResults == null ? null : ctx.passwordCheckResults.messages) && ctx.password);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.passwordRetype);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.passwordRetype && ctx.password != ctx.passwordRetype);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.passwordRetype && ctx.password == ctx.passwordRetype);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("type", "password")("label", "Retype New Password")("inputClass", "form-control")("containerClass", "login-input-container")("name", "tbPasswordRetype")("ngModel", ctx.passwordRetype)("inputAutocomplete", "new-password")("useFloat", ctx.useFloat)("placeholder", "Retype Password");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.passwordRetype && ctx.password != ctx.passwordRetype);
    } }, directives: function () { return [ɵngcc4.NgIf, DwFloatingLabelInputComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf]; }, styles: [""] });
DwPasswordComponent.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwSecurityRegistrationRepositoryService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwSecurityOrchestrationService },
    { type: DwSecurityStateService },
    { type: DwAppInitService },
    { type: DwPasswordUtilService }
];
DwPasswordComponent.propDecorators = {
    password: [{ type: Input }],
    passwordChange: [{ type: Output }],
    isPasswordValid: [{ type: Input }],
    isPasswordValidChange: [{ type: Output }],
    useFloat: [{ type: Input }]
};

const moment$b = moment_;
class DwDateMultiSelectComponent extends DwControlBaseComponent {
    constructor(config, cdr) {
        super();
        this.config = config;
        this.cdr = cdr;
        this.dateList = [];
        this.dateListChange = new EventEmitter();
        this.dateListDisplay = null;
        this.hoveredDate = null;
        this.endDateTime = null;
        this.internalDateList = [];
        this.firstDayOfWeek = 7; // Sunday in ISO 8601
        config.autoClose = 'outside';
        config.placement = 'bottom';
    }
    ngOnInit() {
    }
    translateFrom(value) {
        if (!value) {
            return value;
        }
        if (Array.isArray(value)) {
            return value.map(d => this.formatNgbDate(d)).join(',');
        }
        return value;
    }
    translateTo(value) {
        if (!value) {
            this.internalDateList = [];
            return;
        }
        const dates = value.split(',');
        this.internalDateList = dates.map(d => this.parseToNgbDate(d)).filter(d => !!d);
        this.updateDates(false);
        return this.internalDateList;
    }
    updateFromText(value) {
        if (!value) {
            this.startDateTime = null;
            this.endDateTime = null;
        }
        else {
            const parts = value.split('-');
            const startDateTime = this.parseToNgbDate(parts[0]);
            if (!startDateTime) {
                return;
            }
            let endDateTime;
            if (parts.length == 2 && parts[1].trim().length > 0) {
                endDateTime = this.parseToNgbDate(parts[1]);
                if (!endDateTime) {
                    return;
                }
            }
            if (areEqual(this.startDateTime, startDateTime) && areEqual(this.endDateTime, endDateTime)) {
                return;
            }
            this.startDateTime = startDateTime;
            this.endDateTime = endDateTime;
            this.hoveredDate = endDateTime;
        }
        this.updateDates();
    }
    ngOnChanges(changes) { }
    onDateSelection(date) {
        const existingMatch = this.internalDateList.find(d => this.isMatch(d, date));
        if (existingMatch) {
            const index = this.internalDateList.indexOf(existingMatch);
            this.internalDateList.splice(index, 1);
        }
        else {
            this.internalDateList.push(date);
        }
        this.updateDates();
    }
    popoverShown() {
        if (this.datePickerControl) {
            this.datePickerControl.navigateTo(this.startDateTime);
            return;
        }
        // keep running until the datePickerControl exists
        setTimeout(() => {
            this.popoverShown();
        });
    }
    onInputChange(dateRange) {
        this.updateFromText(dateRange);
        //this.inputChangeSubject.next(dateRange);
    }
    updateDates(updateValue = true) {
        let closePopup = false;
        const formattedDates = this.internalDateList.map(d => this.formatNgbDate(d)).join(', ');
        this.dateListDisplay = formattedDates;
        if (updateValue) {
            this.setTranslatedValue(this.internalDateList);
        }
        this.startDateTimeModel = new DateTimeModel(this.startDateTime);
        if (closePopup) {
            this.popover.close();
        }
        this.cdr.detectChanges();
    }
    formatNgbDate(dateValue) {
        if (!dateValue) {
            return null;
        }
        const stringDate = `${dateValue.month}/${dateValue.day}/${dateValue.year}`;
        return formatDateTime(stringDate, false);
    }
    parseToNgbDate(dateValue) {
        if (!dateValue) {
            return null;
        }
        const dateParts = dateValue.trim().split('/');
        if (dateParts.length != 3) {
            return null;
        }
        const month = parseInt(dateParts[0]);
        const day = parseInt(dateParts[1]);
        let year = parseInt(dateParts[2]);
        if (year < 1000) {
            return null;
        }
        if (isNaN(month) || isNaN(day)) {
            return null;
        }
        // If no year, set year
        if (isNaN(year)) {
            year = moment$b().year();
        }
        return new NgbDate(year, month, day);
    }
    isHovered(date) {
        if (this.hoveredDate && this.isMatch(date, this.hoveredDate)) {
            return true;
        }
        return false;
        // const result = this.startDateTime && !this.endDateTime && this.hoveredDate && date.after(this.startDateTime) && date.before(this.hoveredDate);
        // if (!this.endDateTime) {
        // }
        // return result;
    }
    isInside(date) {
        return false;
        const result = this.internalDateList.find(d => this.isMatch(d, date));
        // const result = this.endDateTime && date.after(this.startDateTime) && date.before(this.endDateTime);
        return result;
    }
    isRange(date) {
        const result = this.internalDateList.find(d => this.isMatch(d, date));
        // const result = this.endDateTime && date.after(this.startDateTime) && date.before(this.endDateTime);
        return result;
        // return false;
        // const result = date.equals(this.startDateTime) || (this.endDateTime && date.equals(this.endDateTime)) || this.isInside(date) || this.isHovered(date);
        // return result;
    }
    isMatch(date1, date2) {
        if (!date1 || !date2) {
            return false;
        }
        if (date1.year == date2.year && date1.month == date2.month && date1.day == date2.day) {
            return true;
        }
        return false;
    }
}
DwDateMultiSelectComponent.ɵfac = function DwDateMultiSelectComponent_Factory(t) { return new (t || DwDateMultiSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc20.NgbPopoverConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwDateMultiSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDateMultiSelectComponent, selectors: [["dw-date-multi-select"]], viewQuery: function DwDateMultiSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(NgbDatepicker, true);
        ɵngcc0.ɵɵstaticViewQuery(NgbPopover, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePickerControl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.popover = _t.first);
    } }, inputs: { dateList: "dateList", disabled: "disabled" }, outputs: { dateListChange: "dateListChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwDateMultiSelectComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 2, consts: [[4, "ngIf"], ["class", "input-group mr-2", 4, "ngIf"], ["popoverContent", ""], ["dayTemplate", ""], [1, "input-group", "mr-2"], ["popoverClass", "dw-date-time-picker", "container", "body", "placement", "bottom-left", "dwBrowserAutocomplete", "false", 1, "form-control", "date-time-input-text", 3, "ngbPopover", "ngModel", "disabled", "shown", "ngModelChange"], ["popover", "ngbPopover"], [1, "input-group-append"], ["type", "button", 1, "btn", "date-time-icon", 3, "disabled", "click"], [1, "far", "fa-calendar"], [1, "date-range-picker"], ["outsideDays", "hidden", 3, "ngModel", "displayMonths", "firstDayOfWeek", "dayTemplate", "dateSelect", "select"], ["dp", ""], [1, "custom-day", 3, "mouseenter", "mouseleave"]], template: function DwDateMultiSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwDateMultiSelectComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwDateMultiSelectComponent_div_1_Template, 6, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwDateMultiSelectComponent_ng_template_2_Template, 3, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, DwDateMultiSelectComponent_ng_template_4_Template, 2, 7, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disabled);
    } }, directives: [ɵngcc4.NgIf, DwBrowserAutocomplete, ɵngcc3.DefaultValueAccessor, ɵngcc20.NgbPopover, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc20.NgbDatepicker], styles: [_c45] });
DwDateMultiSelectComponent.ctorParameters = () => [
    { type: NgbPopoverConfig },
    { type: ChangeDetectorRef }
];
DwDateMultiSelectComponent.propDecorators = {
    dateList: [{ type: Input }],
    dateListChange: [{ type: Output }],
    disabled: [{ type: Input }],
    datePickerControl: [{ type: ViewChild, args: [NgbDatepicker, { static: false },] }],
    popover: [{ type: ViewChild, args: [NgbPopover, { static: true },] }]
};

var __decorate$D = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$s = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwExpandableSectionComponent {
    constructor(element) {
        this.element = element;
        this.initialStyleSet = false;
        this.computedStyle = {
            'display': 'block',
            'overflow': 'hidden'
        };
    }
    ;
    // ngAfterViewInit(): void {
    //   this.setupStyles();
    // }
    ngOnInit() {
        this.setupStyles();
    }
    ngOnChanges() {
        this.setupStyles();
        // 
    }
    setupStyles() {
        var _a;
        if (!this.innerContent) {
            return;
        }
        this.innerHeight = (_a = this.innerContent.nativeElement) === null || _a === void 0 ? void 0 : _a.offsetHeight;
        if (!this.initialStyleSet) {
            this.initialStyleSet = true;
            this.setStyleHeight(`${this.innerHeight}px`);
            setTimeout(() => {
                this.setupStyles();
            });
            return;
        }
        if (this.collapsed) {
            this.setStyleHeight('0px');
        }
        else {
            setTimeout(() => {
                this.setStyleHeight(`${this.innerHeight}px`);
            });
            // Once the animation is complete, set the height back to auto (so it will adjust as needed when not in an animation)
            // setTimeout(() => {
            //   if (!this.collapsed) {
            //     this.setStyleHeight(`auto`);
            //   }
            // },550);
        }
    }
    setStyleHeight(height) {
        this.computedStyle = {
            'height': height,
            'transition': 'all 500ms',
            'display': 'block',
            'overflow': 'hidden'
        };
    }
}
DwExpandableSectionComponent.ɵfac = function DwExpandableSectionComponent_Factory(t) { return new (t || DwExpandableSectionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwExpandableSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpandableSectionComponent, selectors: [["dw-expandable-section"]], viewQuery: function DwExpandableSectionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c46, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.innerContent = _t.first);
    } }, inputs: { collapsed: "collapsed" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 4, vars: 1, consts: [[1, "dw-container-transitions", 3, "ngStyle"], ["innerContent", ""]], template: function DwExpandableSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", null, 1);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.computedStyle);
    } }, directives: [ɵngcc4.NgStyle], encapsulation: 2 });
DwExpandableSectionComponent.ctorParameters = () => [
    { type: ElementRef }
];
DwExpandableSectionComponent.propDecorators = {
    collapsed: [{ type: Input }],
    innerContent: [{ type: ViewChild, args: ['innerContent',] }]
};
__decorate$D([
    DwInputConverter(booleanConverter),
    __metadata$s("design:type", Boolean)
], DwExpandableSectionComponent.prototype, "collapsed", void 0);
// @Component({
//   selector: 'dw-expandable-section',
//   template: `
//     {{ startHeight }}
//     <ng-content></ng-content>
//   `,
//   styles: [`
//     :host {
//       display: block;
//       overflow: hidden;
//     }
//   `],
//   animations: [
//     trigger('grow', [
//       transition('void <=> *', []),
//       transition('* <=> *', [
//         style({height: '{{startHeight}}px', opacity: 0}),
//         animate('.5s ease'),
//       ], {params: {startHeight: 0}})
//     ])
//   ]
// })
// export class DwExpandableSectionComponent implements OnChanges {
//   @DwInputConverter(booleanConverter)
//   @Input()
//   collapsed: boolean;
//   startHeight: number;
//   @HostBinding('@grow') grow: any;
//   constructor(private element: ElementRef) {}  
//   ngOnChanges(){
//     this.startHeight = this.element.nativeElement.clientHeight;
//     if (this.collapsed) {
//       this.startHeight = 0;
//     }
//     this.grow = {
//       value: this.collapsed,
//       params: {startHeight: this.startHeight}
//     };
//   }
// }

var __decorate$E = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$t = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwExpandableDirective {
    constructor(element, cdr) {
        this.element = element;
        this.cdr = cdr;
        this.enabled = true;
        this.initialStyleSet = false;
        this.isCollapsed = false;
    }
    ngOnInit() {
        this.setupStyles();
    }
    ngOnChanges() {
        this.setupStyles();
    }
    setupStyles() {
        var _a, _b, _c;
        // don't make any changes when enabled
        if (!this.enabled) {
            return;
        }
        if (!this.element) {
            return;
        }
        // only do something when we're collapsing
        if (!this.collapsed && !this.isCollapsed) {
            return;
        }
        // Only capture the height when we collapse, otherwise we'll restore the new height which will be 0
        if (this.collapsed || !this.innerHeight) {
            this.innerHeight = ((_a = this.element.nativeElement) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
            if (!this.innerHeight) {
                this.innerHeight = (_c = (_b = this.element.nativeElement) === null || _b === void 0 ? void 0 : _b.firstChild) === null || _c === void 0 ? void 0 : _c.offsetHeight;
            }
        }
        if (!this.initialStyleSet) {
            this.initialStyleSet = true;
            this.setStyleHeight(`${this.innerHeight}px`);
            setTimeout(() => {
                this.setupStyles();
            });
            return;
        }
        this.isCollapsed = this.collapsed;
        if (this.collapsed) {
            this.setStyleHeight('0px');
            return;
        }
        this.setStyleHeight(`${this.innerHeight}px`);
        setTimeout(() => {
            if (!this.collapsed) {
                this.computedStyle = null;
                this.initialStyleSet = false;
            }
            this.cdr.detectChanges();
        }, 550);
        // Once the animation is complete, set the height back to auto (so it will adjust as needed when not in an animation)
        // setTimeout(() => {
        //   if (!this.collapsed) {
        //     this.setStyleHeight(`auto`);
        //   }
        // },550);
        //}
    }
    setStyleHeight(height) {
        this.computedStyle = {
            'height': height,
            'transition': 'all 500ms',
            'display': 'block',
            'overflow': 'hidden'
        };
    }
}
DwExpandableDirective.ɵfac = function DwExpandableDirective_Factory(t) { return new (t || DwExpandableDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwExpandableDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwExpandableDirective, selectors: [["", "dwExpandable", ""]], hostVars: 2, hostBindings: function DwExpandableDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ctx.computedStyle);
    } }, inputs: { enabled: ["dwExpandable", "enabled"], collapsed: "collapsed" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwExpandableDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
DwExpandableDirective.propDecorators = {
    enabled: [{ type: Input, args: ['dwExpandable',] }],
    collapsed: [{ type: Input }],
    computedStyle: [{ type: HostBinding, args: ["style",] }]
};
__decorate$E([
    DwInputConverter(booleanConverter),
    __metadata$t("design:type", Boolean)
], DwExpandableDirective.prototype, "collapsed", void 0);

var __decorate$F = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const defaultUrlValidationUrl$2 = /^(ftp|http|https):\/\/[^ "]+$/;
const customProperty = 'invalidCustom';
let DwCustomValidationRule = class DwCustomValidationRule extends DwValidationRuleBase {
    createValidator(config, context) {
        return DwValidateCustom(config, context);
    }
    buildError(error, displayName, isSubmitted, messageTemplate) {
        if (error.config.showAfterSubmitted && !isSubmitted) {
            return;
        }
        return error.config.message;
    }
    buildTagsValues(error, displayName) {
        const tagValues = super.buildTagsValues(error, displayName);
        return tagValues;
    }
};
DwCustomValidationRule.ɵfac = function DwCustomValidationRule_Factory(t) { return ɵDwCustomValidationRule_BaseFactory(t || DwCustomValidationRule); };
DwCustomValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwCustomValidationRule, factory: function (t) { return DwCustomValidationRule.ɵfac(t); } });
DwCustomValidationRule = __decorate$F([
    DwValidationRule({
        keyName: DwFormValidators.custom,
        display: 'Custom Validator',
        errorType: customProperty,
        isErrorTypeMatch: isCustomErrorType,
        validationItemType: [DwValidationItemType.formGroup, DwValidationItemType.formControl],
        //configComponent: DwCountValidatorConfigComponent,
        messageTemplate: '',
        requireMessage: true,
        allowMultiple: true,
        expressionLabel: 'Validation Expression',
        exprressionTooltip: 'Enter an expression for the validator.  If result is true, validator will show error',
        showAfterSubmittedOptions: true,
        showAfterSubmittedDefault: false,
        tags: [
        // { tag: DwValidationStandardTagNames.value, display: 'Value' },
        // { tag: DwCountTags.minCount, display: 'Min Count' },
        // { tag: DwCountTags.maxCount, display: 'Max Count' }
        ]
    })
], DwCustomValidationRule);
function DwValidateCustom(config, context) {
    return (control) => {
        const result = {};
        let finalErrorProperty = customProperty;
        if (context === null || context === void 0 ? void 0 : context.validationKey) {
            finalErrorProperty = `${customProperty}_${context === null || context === void 0 ? void 0 : context.validationKey}`;
        }
        result[finalErrorProperty] = {
            config: config,
            filterKey: context === null || context === void 0 ? void 0 : context.validationKey
        };
        return result;
    };
}
function isCustomErrorType(customPropertyName) {
    return (customPropertyName === null || customPropertyName === void 0 ? void 0 : customPropertyName.indexOf(customProperty)) == 0;
}

class DwDatePipe {
    transform(dateString, dateTimeOptions = { showTime: true, showAmPm: true, isGmt: true }) {
        if (dateString) {
            if (dateTimeOptions === null || dateTimeOptions === void 0 ? void 0 : dateTimeOptions.isGmt) {
                return formatDateTimeToLocal(dateString, dateTimeOptions === null || dateTimeOptions === void 0 ? void 0 : dateTimeOptions.showTime, dateTimeOptions.showAmPm);
            }
            return formatDateTime(dateString, dateTimeOptions === null || dateTimeOptions === void 0 ? void 0 : dateTimeOptions.showTime, dateTimeOptions.showAmPm);
        }
        return '';
    }
}
DwDatePipe.ɵfac = function DwDatePipe_Factory(t) { return new (t || DwDatePipe)(); };
DwDatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "dwDate", type: DwDatePipe, pure: true });

class DwUiInfoDisplayComponent {
    constructor() {
        this.finalData = {};
        this.sectionVisible = [];
    }
    ngOnInit() {
        this.setupFinalData();
    }
    ngOnChanges(changes) {
        this.setupFinalData();
    }
    setupFinalData() {
        this.finalData = {};
        this.sectionVisible = [];
        let index = 0;
        for (let section of this.config.sections) {
            let sectionVisible = true;
            if (section.hideFunc && section.hideFunc(this.data)) {
                sectionVisible = false;
            }
            this.sectionVisible[index] = sectionVisible;
            index++;
            for (let field of section.fields) {
                const data = this.getFieldData(field) || '';
                if (data) {
                    this.finalData[field.fieldPath] = data.toString();
                }
            }
        }
    }
    getFieldData(field) {
        if (field.dataFunc) {
            return field.dataFunc(this.data);
        }
        if (!field.fieldPath) {
            return;
        }
        return this.getDataFromPath(this.data, field.fieldPath);
    }
    getDataFromPath(data, path) {
        if (!data) {
            return;
        }
        if (!path) {
            return data;
        }
        const parts = path.split('.');
        let currentData = data;
        let index = 0;
        while (currentData && index < parts.length) {
            const part = parts[index];
            if (part) {
                currentData = currentData[part];
            }
            index++;
        }
        return currentData;
    }
}
DwUiInfoDisplayComponent.ɵfac = function DwUiInfoDisplayComponent_Factory(t) { return new (t || DwUiInfoDisplayComponent)(); };
DwUiInfoDisplayComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiInfoDisplayComponent, selectors: [["dw-ui-info-display"]], inputs: { config: "config", data: "data" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "section-title"], ["class", "data-row", 4, "ngFor", "ngForOf"], [1, "data-row"], [1, "label"], ["class", "data", 4, "ngIf"], [1, "data"]], template: function DwUiInfoDisplayComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwUiInfoDisplayComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.config == null ? null : ctx.config.sections);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgIf], styles: [".section-title[_ngcontent-%COMP%]{font-size:14px;font-weight:700}.data-row[_ngcontent-%COMP%]{border:1px solid #000;clear:left;margin-left:3px;margin-right:3px;overflow:auto;width:100%}.label[_ngcontent-%COMP%]{border-right:1px dashed #000;float:left;font-size:10px;width:40%}.data[_ngcontent-%COMP%]{font-size:11px;text-overflow:ellipsis;width:60%}"] });
DwUiInfoDisplayComponent.ctorParameters = () => [];
DwUiInfoDisplayComponent.propDecorators = {
    config: [{ type: Input }],
    data: [{ type: Input }]
};

var __decorate$G = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$u = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwControlWrapperWithIconsComponent {
    constructor() {
        this.wrapControl = true;
    }
    ngOnInit() {
        const wrapValue = this.wrapControl;
    }
}
DwControlWrapperWithIconsComponent.ɵfac = function DwControlWrapperWithIconsComponent_Factory(t) { return new (t || DwControlWrapperWithIconsComponent)(); };
DwControlWrapperWithIconsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwControlWrapperWithIconsComponent, selectors: [["dw-control-wrapper-with-icons"]], inputs: { wrapControl: "wrapControl", showPrefix: "showPrefix", showSuffix: "showSuffix" }, ngContentSelectors: _c48, decls: 7, vars: 4, consts: [[1, "input-group"], [1, "input-group-prepend", 3, "hidden"], [4, "ngIf"], ["class", "input-group-middle", 4, "ngIf"], [1, "input-group-append", 3, "hidden"], [1, "input-group-middle"]], template: function DwControlWrapperWithIconsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c47);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwControlWrapperWithIconsComponent_ng_content_3_Template, 1, 0, "ng-content", 2);
        ɵngcc0.ɵɵtemplate(4, DwControlWrapperWithIconsComponent_div_4_Template, 2, 0, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showPrefix);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.wrapControl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.wrapControl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showSuffix);
    } }, directives: [ɵngcc4.NgIf], styles: [".input-group-middle[_ngcontent-%COMP%]{flex:1 1 auto;margin-bottom:0;position:relative;width:1%}"] });
DwControlWrapperWithIconsComponent.ctorParameters = () => [];
DwControlWrapperWithIconsComponent.propDecorators = {
    showPrefix: [{ type: Input }],
    showSuffix: [{ type: Input }],
    wrapControl: [{ type: Input }]
};
__decorate$G([
    DwInputConverter(booleanConverter),
    __metadata$u("design:type", Boolean)
], DwControlWrapperWithIconsComponent.prototype, "showPrefix", void 0);
__decorate$G([
    DwInputConverter(booleanConverter),
    __metadata$u("design:type", Boolean)
], DwControlWrapperWithIconsComponent.prototype, "showSuffix", void 0);
__decorate$G([
    DwInputConverter(booleanConverter),
    __metadata$u("design:type", Boolean)
], DwControlWrapperWithIconsComponent.prototype, "wrapControl", void 0);

class ColorSelectComponent extends DwControlBaseComponent {
    constructor(dwStyleManager) {
        super();
        this.dwStyleManager = dwStyleManager;
        this.placeholder = 'Select Color';
        this.showFilter = true;
    }
    ngOnChanges(changes) {
    }
    // Breaks the control for some reason (don't have time to troubleshoot)
    // translateFrom(value: any) {
    //   //this.setCurrentColor(value);
    //   super.translateFrom(value);
    // }
    // translateTo(value: any) {
    //   //this.setCurrentColor(value);
    //   super.translateTo(value);
    // }
    // private setCurrentColor(colorName: string) {
    //   this.currentColor = this.dwStyleManager.getColorConfig(colorName);
    //   setTimeout(() => {
    //     this.currentColorChange.emit(this.currentColor);
    //   });
    // }
    ngOnInit() {
        this.colors = this.dwStyleManager.getStandardColors();
    }
}
ColorSelectComponent.ɵfac = function ColorSelectComponent_Factory(t) { return new (t || ColorSelectComponent)(ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
ColorSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ColorSelectComponent, selectors: [["dw-color-select"]], inputs: { placeholder: "placeholder", showFilter: "showFilter" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => ColorSelectComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 8, consts: [["optionLabel", "display", "display", "chip", "optionValue", "name", "scrollHeight", "300px", "appendTo", "body", 3, "placeholder", "options", "ngModel", "showClear", "filter", "ngModelChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], [1, "color-patch", 3, "ngClass"]], template: function ColorSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dropdown", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function ColorSelectComponent_Template_p_dropdown_ngModelChange_0_listener($event) { return ctx.translatedValue = $event; })("ngModelChange", function ColorSelectComponent_Template_p_dropdown_ngModelChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵtemplate(1, ColorSelectComponent_ng_template_1_Template, 2, 2, "ng-template", 1);
        ɵngcc0.ɵɵtemplate(2, ColorSelectComponent_ng_template_2_Template, 2, 2, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(7, _c43));
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder)("options", ctx.colors)("ngModel", ctx.translatedValue)("showClear", true)("filter", ctx.showFilter);
    } }, directives: [ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.PrimeTemplate, ɵngcc4.NgClass], styles: [".color-patch[_ngcontent-%COMP%]{border:1px solid #000;float:left;text-align:center;width:100%}"] });
ColorSelectComponent.ctorParameters = () => [
    { type: DwStyleManagerService }
];
ColorSelectComponent.propDecorators = {
    placeholder: [{ type: Input }],
    showFilter: [{ type: Input }]
};

class DwButtonClassSelectComponent extends DwControlBaseComponent {
    constructor(dwStyleManager) {
        super();
        this.dwStyleManager = dwStyleManager;
        this.placeholder = 'Select Color';
        this.showFilter = true;
    }
    ngOnInit() {
        this.colors = this.dwStyleManager.getStandardColors();
    }
}
DwButtonClassSelectComponent.ɵfac = function DwButtonClassSelectComponent_Factory(t) { return new (t || DwButtonClassSelectComponent)(ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
DwButtonClassSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwButtonClassSelectComponent, selectors: [["dw-button-class-select"]], inputs: { placeholder: "placeholder", showFilter: "showFilter" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, template: function DwButtonClassSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-button-class-select works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwButtonClassSelectComponent.ctorParameters = () => [
    { type: DwStyleManagerService }
];
DwButtonClassSelectComponent.propDecorators = {
    placeholder: [{ type: Input }],
    showFilter: [{ type: Input }]
};

class DwColorPickerComponent extends DwControlBaseComponent {
    constructor(dwStyleManager) {
        super();
        this.dwStyleManager = dwStyleManager;
    }
    clearValue() {
        this.setTranslatedValue(null);
    }
    ngOnInit() {
        this.colors = this.dwStyleManager.getStandardColors();
        //this.colors[0].backgroundClass
    }
    ngOnChanges(changes) {
    }
    setColor(color) {
    }
}
DwColorPickerComponent.ɵfac = function DwColorPickerComponent_Factory(t) { return new (t || DwColorPickerComponent)(ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
DwColorPickerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwColorPickerComponent, selectors: [["dw-color-picker"]], features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwColorPickerComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 10, consts: [["dropDownHeight", "257px", 3, "allowClear", "clearValue"], ["control", ""], [1, "color-select", 3, "hidden"], [1, "color-patch", 3, "hidden", "ngStyle", "title"], ["dropdown", "", 1, "picker-container"], ["dwRow", ""], ["dwCol", ""], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngModel", "inline", "ngModelChange"]], template: function DwColorPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-custom-dropdown", 0);
        ɵngcc0.ɵɵlistener("clearValue", function DwColorPickerComponent_Template_dw_custom_dropdown_clearValue_0_listener() { return ctx.clearValue(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3, "Select Color");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtext(8, " Hex: ");
        ɵngcc0.ɵɵelementStart(9, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwColorPickerComponent_Template_input_ngModelChange_9_listener($event) { return ctx.translatedValue = $event; })("ngModelChange", function DwColorPickerComponent_Template_input_ngModelChange_9_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "p-colorPicker", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwColorPickerComponent_Template_p_colorPicker_ngModelChange_12_listener($event) { return ctx.translatedValue = $event; })("ngModelChange", function DwColorPickerComponent_Template_p_colorPicker_ngModelChange_12_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("allowClear", !!ctx.translatedValue);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.translatedValue);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.translatedValue);
        ɵngcc0.ɵɵproperty("hidden", !ctx.translatedValue)("ngStyle", ɵngcc0.ɵɵpureFunction1(8, _c49, ctx.translatedValue));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.translatedValue);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.translatedValue)("inline", true);
    } }, directives: function () { return [DwCustomDropdownComponent, ɵngcc4.NgStyle, ɵngcc16.BsDropdownDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc24.ColorPicker]; }, styles: [".picker-container[_ngcontent-%COMP%]{overflow:hidden;padding:5px}.color-patch[_ngcontent-%COMP%]{border:1px solid #000;color:#fff;text-align:center}.color-patch[_ngcontent-%COMP%], .color-select[_ngcontent-%COMP%]{float:left;height:24px;width:100%}"] });
DwColorPickerComponent.ctorParameters = () => [
    { type: DwStyleManagerService }
];

var __decorate$H = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$v = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwCustomDropdownComponent {
    constructor() {
        this.dropDownHeight = 300;
        this.visible = false;
        this.allowClear = true;
        this.clearValue = new EventEmitter();
        this.id = Math.floor(Math.random() * 1000);
        this.firstTimeLoad = true;
        this.ignoreNext = false;
    }
    ngOnInit() {
    }
    click(event) {
        if (this.firstTimeLoad) {
            this.dropDownEl = document.getElementById(this.id);
            document.body.appendChild(this.dropDownEl);
            this.firstTimeLoad = false;
        }
        this.showDropDown();
    }
    setPosition() {
        const el = this.targetElement.nativeElement;
        const position = el.getBoundingClientRect();
        this.dropDownEl.style.top = position.height + position.top - 2 + 'px';
        this.dropDownEl.style.left = position.left + 'px';
        this.dropDownEl.style.width = position.width + 'px';
        this.dropDownEl.style.height = this.dropDownHeight + 'px';
    }
    showDropDown() {
        this.visible = !this.visible;
        this.setPosition();
        this.targetElement.nativeElement.focus();
        if (this.visible) {
            this.ignoreNext = true;
        }
    }
    closeDropDown() {
        this.visible = false;
    }
    outsideClick() {
        if (this.ignoreNext) {
            this.ignoreNext = false;
            return;
        }
        this.closeDropDown();
    }
    reset(event) {
        // re-configure the grid style upon browser resize
        this.closeDropDown();
    }
    onKeyDown(e) {
        if (e.key == 'Escape') {
            this.closeDropDown();
        }
    }
}
DwCustomDropdownComponent.ɵfac = function DwCustomDropdownComponent_Factory(t) { return new (t || DwCustomDropdownComponent)(); };
DwCustomDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCustomDropdownComponent, selectors: [["dw-custom-dropdown"]], viewQuery: function DwCustomDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c50, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.targetElement = _t.first);
    } }, hostBindings: function DwCustomDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwCustomDropdownComponent_resize_HostBindingHandler($event) { return ctx.reset($event); }, false, ɵngcc0.ɵɵresolveWindow)("keydown", function DwCustomDropdownComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { dropDownHeight: "dropDownHeight", visible: "visible", allowClear: "allowClear" }, outputs: { clearValue: "clearValue" }, ngContentSelectors: _c52, decls: 9, vars: 5, consts: [[1, "drop-down-field", "form-control", "hand"], ["dropDownControl", ""], [1, "drop-down-control", "hand", 3, "click"], [1, "p-dropdown-clear-icon", "pi", "pi-times", "ng-tns-c110-4", "ng-star-inserted", "hand", 3, "hidden", "click"], [1, "pi", "pi-fw", "pi-caret-down", "drop-down-icon", "hand", "ui-dropdown-trigger", 3, "click"], [1, "dropdown-section", "p-dropdown-panel", 3, "ngClass", "clickOutside"]], template: function DwCustomDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c51);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0, 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵlistener("click", function DwCustomDropdownComponent_Template_div_click_3_listener($event) { return ctx.click($event); });
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "i", 3);
        ɵngcc0.ɵɵlistener("click", function DwCustomDropdownComponent_Template_i_click_5_listener() { return ctx.clearValue.emit(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵlistener("click", function DwCustomDropdownComponent_Template_span_click_6_listener($event) { return ctx.click($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵlistener("clickOutside", function DwCustomDropdownComponent_Template_div_clickOutside_7_listener() { return ctx.outsideClick(); });
        ɵngcc0.ɵɵprojection(8, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", !ctx.allowClear);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c44, ctx.visible == false));
        ɵngcc0.ɵɵattribute("id", ctx.id);
    } }, directives: [ɵngcc4.NgClass, DwClickOutsideDirective], styles: ["@charset \"UTF-8\";.drop-down-field[_ngcontent-%COMP%]{position:relative}.drop-down-field[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:disabled, .drop-down-field[_ngcontent-%COMP%]   .form-control[readonly][_ngcontent-%COMP%]{background-color:#fff}.drop-down-control[_ngcontent-%COMP%]{width:calc(100% - 40px)}.dropdown-section[_ngcontent-%COMP%]{background-clip:padding-box;background-color:#fff;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;min-width:10rem;overflow-x:none;overflow-y:auto;padding:0;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section[_ngcontent-%COMP%]   .ui-treenode-content-selected[_ngcontent-%COMP%]{background-color:#007ad9;border:1px;color:#fff}.hide[_ngcontent-%COMP%]{display:none}.drop-down-icon[_ngcontent-%COMP%]{color:#848484;position:absolute;right:3px;text-align:center;top:20%;width:2.357em}.custom-ui-tree[_ngcontent-%COMP%]{height:100%;width:100%!important}.custom-ui-tree[_ngcontent-%COMP%], .custom-ui-tree[_ngcontent-%COMP%]   .ui-tree-container[_ngcontent-%COMP%]{padding:0!important}.pi-caret-down[_ngcontent-%COMP%]:before{content:\"\uE902\"!important}"] });
DwCustomDropdownComponent.propDecorators = {
    targetElement: [{ type: ViewChild, args: ['dropDownControl', { static: true },] }],
    dropDownHeight: [{ type: Input }],
    visible: [{ type: Input }],
    allowClear: [{ type: Input }],
    clearValue: [{ type: Output }],
    reset: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};
__decorate$H([
    DwInputConverter(booleanConverter),
    __metadata$v("design:type", Boolean)
], DwCustomDropdownComponent.prototype, "visible", void 0);
__decorate$H([
    DwInputConverter(booleanConverter),
    __metadata$v("design:type", Boolean)
], DwCustomDropdownComponent.prototype, "allowClear", void 0);

class DwButtonDropdownComponent {
    constructor() {
        this.disabled = false;
        this.showCaret = true;
        this.menuClick = new EventEmitter();
        this.menuItems = [];
        this.visible = false;
        this.id = Math.floor(Math.random() * 1000);
        //firstTimeLoad = true;
        this.elementAdded = false;
        this.dropDownHeight = 200;
        this.ignoreNext = false;
    }
    ngOnDestroy() {
        this.closeDropDown();
    }
    onMenuClick(menuItem, event) {
        const eventData = {
            menuItem: menuItem,
            event: event
        };
        this.menuClick.emit(eventData);
        this.closeDropDown();
    }
    ngOnInit() {
    }
    click(event) {
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (event.stopPropagation) {
            event.stopPropagation();
        }
        if (!this.elementAdded) {
            if (!this.dropDownEl) {
                this.dropDownEl = document.getElementById(this.id);
            }
            document.body.appendChild(this.dropDownEl);
            this.elementAdded = true;
        }
        this.showDropDown();
    }
    setPosition() {
        const el = this.targetElement.nativeElement;
        const position = el.getBoundingClientRect();
        const scrollTop = this.getParentScrollTop(el);
        this.dropDownEl.style.top = scrollTop + position.height + position.top - 2 + 'px';
        const rightScreenMargin = window.innerWidth - position.right - position.width;
        if (rightScreenMargin < 150) {
            this.dropDownEl.style.right = rightScreenMargin + 'px';
            this.dropDownEl.style.left = 'auto';
            //this.dropDownEl.style.left = position.right - (150 - rightScreenMargin) + 'px';
        }
        else {
            this.dropDownEl.style.left = position.left + 'px';
        }
    }
    getParentScrollTop(el) {
        let currentEl = el;
        let scrollTop = 0;
        while (currentEl) {
            if (currentEl.scrollTop) {
                scrollTop += currentEl.scrollTop;
            }
            currentEl = currentEl.parentElement;
        }
        return scrollTop;
    }
    showDropDown() {
        this.visible = !this.visible;
        this.setPosition();
        this.targetElement.nativeElement.focus();
        if (this.visible) {
            this.ignoreNext = true;
        }
    }
    closeDropDown() {
        this.visible = false;
        if (this.elementAdded && this.dropDownEl) {
            document.body.removeChild(this.dropDownEl);
            this.elementAdded = false;
        }
    }
    outsideClick() {
        if (this.ignoreNext) {
            this.ignoreNext = false;
            return;
        }
        this.closeDropDown();
    }
    reset(event) {
        // re-configure the grid style upon browser resize
        this.closeDropDown();
    }
    onKeyDown(e) {
        if (e.key == 'Escape') {
            this.closeDropDown();
        }
    }
}
DwButtonDropdownComponent.ɵfac = function DwButtonDropdownComponent_Factory(t) { return new (t || DwButtonDropdownComponent)(); };
DwButtonDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwButtonDropdownComponent, selectors: [["dw-button-dropdown"]], viewQuery: function DwButtonDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c19, true);
        ɵngcc0.ɵɵstaticViewQuery(_c53, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.targetElement = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.menuSectionElement = _t.first);
    } }, hostBindings: function DwButtonDropdownComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwButtonDropdownComponent_resize_HostBindingHandler($event) { return ctx.reset($event); }, false, ɵngcc0.ɵɵresolveWindow)("keydown", function DwButtonDropdownComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } }, inputs: { disabled: "disabled", showCaret: "showCaret", menuItems: "menuItems", buttonConfig: "buttonConfig" }, outputs: { menuClick: "menuClick" }, decls: 7, vars: 7, consts: [["dropdown", "", 1, "btn-group"], [1, "dropdown-button"], ["inputElement", ""], [3, "buttonConfig", "showCaret", "click"], [1, "dropdown-section", 3, "ngClass", "clickOutside"], ["menuSection", ""], [4, "ngFor", "ngForOf"], [1, "divider", "dropdown-divider", 3, "hidden"], ["role", "menuitem", 1, "dropdown-menu-item", 3, "click"], [1, "dropdown-item"]], template: function DwButtonDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
        ɵngcc0.ɵɵelementStart(3, "dw-button", 3);
        ɵngcc0.ɵɵlistener("click", function DwButtonDropdownComponent_Template_dw_button_click_3_listener($event) { return ctx.click($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4, 5);
        ɵngcc0.ɵɵlistener("clickOutside", function DwButtonDropdownComponent_Template_div_clickOutside_4_listener() { return ctx.outsideClick(); });
        ɵngcc0.ɵɵtemplate(6, DwButtonDropdownComponent_ng_container_6_Template, 5, 2, "ng-container", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("buttonConfig", ctx.buttonConfig)("showCaret", ctx.showCaret);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c44, ctx.visible == false));
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.menuItems);
    } }, directives: [ɵngcc16.BsDropdownDirective, DwButtonComponent, ɵngcc4.NgClass, DwClickOutsideDirective, ɵngcc4.NgForOf], styles: ["@charset \"UTF-8\";.drop-down-tree-field[_ngcontent-%COMP%]{position:relative}.drop-down-tree-field[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:disabled, .drop-down-tree-field[_ngcontent-%COMP%]   .form-control[readonly][_ngcontent-%COMP%], .dropdown-section[_ngcontent-%COMP%]{background-color:#fff}.dropdown-section[_ngcontent-%COMP%]{background-clip:padding-box;border:1px solid #e9ecef;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;max-width:80vw;min-width:100px;overflow-x:none;overflow-y:auto;padding:5px;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section[_ngcontent-%COMP%]   .ui-treenode-content-selected[_ngcontent-%COMP%]{background-color:#007ad9;border:1px;color:#fff}.hide[_ngcontent-%COMP%]{display:none}.dropdown-button[_ngcontent-%COMP%]{margin-left:3px}.drop-down-icon[_ngcontent-%COMP%]{color:#848484;position:absolute;right:3px;text-align:center;top:20%;width:2.357em}.custom-ui-tree[_ngcontent-%COMP%]{height:100%;width:100%!important}.custom-ui-tree[_ngcontent-%COMP%], .custom-ui-tree[_ngcontent-%COMP%]   .ui-tree-container[_ngcontent-%COMP%]{padding:0!important}.pi-caret-down[_ngcontent-%COMP%]:before{content:\"\uE902\"!important}.dropdown-item[_ngcontent-%COMP%]{padding:5px!important}.dropdown-menu-item[_ngcontent-%COMP%]{cursor:pointer;padding-left:10px!important;padding-right:10px!important}"] });
DwButtonDropdownComponent.ctorParameters = () => [];
DwButtonDropdownComponent.propDecorators = {
    buttonConfig: [{ type: Input }],
    disabled: [{ type: Input }],
    showCaret: [{ type: Input }],
    menuClick: [{ type: Output }],
    targetElement: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    menuSectionElement: [{ type: ViewChild, args: ['menuSection', { static: true },] }],
    menuItems: [{ type: Input }],
    reset: [{ type: HostListener, args: ['window:resize', ['$event'],] }],
    onKeyDown: [{ type: HostListener, args: ['keydown', ['$event'],] }]
};

class DwTermsOfServiceModalComponent {
    constructor() { }
    ngOnInit() {
        this.modalConfig.data.TermsOfService.TermsOfServiceText;
    }
    buttonClick(buttonConfig) {
        const modalResult = new DwModalResult();
        switch (buttonConfig.command) {
            case DwButtonCommand.ok:
            case DwButtonCommand.saveAndClose:
                modalResult.closeModal = true;
                modalResult.cancelled = false;
                break;
            default:
                modalResult.cancelled = true;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
        }
        return of(modalResult);
    }
}
DwTermsOfServiceModalComponent.ɵfac = function DwTermsOfServiceModalComponent_Factory(t) { return new (t || DwTermsOfServiceModalComponent)(); };
DwTermsOfServiceModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTermsOfServiceModalComponent, selectors: [["dw-dw-terms-of-service-modal"]], decls: 6, vars: 3, consts: [[1, "dw-terms-of-service-container"], [3, "ngModel"], ["target", "_blank", 3, "href"], [3, "message", "messageChange"]], template: function DwTermsOfServiceModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-html-view", 1);
        ɵngcc0.ɵɵelement(2, "br");
        ɵngcc0.ɵɵelementStart(3, "a", 2);
        ɵngcc0.ɵɵtext(4, "Terms of Service");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "dw-message", 3);
        ɵngcc0.ɵɵlistener("messageChange", function DwTermsOfServiceModalComponent_Template_dw_message_messageChange_5_listener($event) { return ctx.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.modalConfig.data.TermsOfService.TermsOfServiceText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("href", ctx.modalConfig.data.TermsOfService.TermsOfServiceLinkUrl, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("message", ctx.message);
    } }, directives: [DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwMessageComponent], styles: [""] });
DwTermsOfServiceModalComponent.ctorParameters = () => [];

var __decorate$I = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$w = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwFloatingLabelInputComponent extends DwControlBaseComponent {
    constructor() {
        super();
        this.useFloat = false;
        this.type = 'text';
        this.placeholder = '';
        this.inputClass = 'form-control';
        this.labelClass = 'label';
        this.containerClass = 'login-input';
        this.name = 'floatingInput';
        this.inputAutocomplete = 'chrome-off';
        this.focusSetCount = 0;
        this.hasFocus = false;
        this.hasAutoFillValue = false;
        this.checkCount = 0;
    }
    ngOnInit() {
        this.setupClasses();
    }
    ngAfterViewInit() {
        this.setupAutofillHack();
    }
    ngOnChanges(changes) {
    }
    setupAutofillHack() {
        this.checkForAutofill();
    }
    focusInput(source) {
        if (this.hasFocus) {
            return;
        }
        this.hasFocus = true;
        this.focusSetCount++;
        this.setupClasses();
        if (this.focusSetCount > 1) {
            return;
        }
        setTimeout(() => {
            var _a, _b;
            //console.log('Setting user name focus', source);
            (_b = (_a = this.userNameInput) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.focus();
        }, 50);
    }
    blurInput() {
        this.hasFocus = false;
        this.setupClasses();
    }
    valueChange() {
        this.setValue(this.value);
        this.setupClasses();
    }
    writeValue(obj) {
        super.writeValue(obj);
        this.setupClasses();
    }
    setupClasses() {
        this.floatingInputClasses = [];
        this.floatingLabelClasses = [];
        if (this.inputClass) {
            this.floatingInputClasses.push(this.inputClass);
        }
        if (this.value || this.hasFocus || this.hasAutoFillValue) {
            this.floatingInputClasses.push('p-filled');
            this.floatingLabelClasses.push('p-filled-label');
        }
    }
    /**
     * Chrome password autofill hack
     * @remarks This is a hack to detect when Chrome autofills the password field since the value isn't populated until human interaction with the page.  With float labels, this causes the label to overlap the text which looks bad
     * @returns
     */
    checkForAutofill() {
        if (!this.useFloat) {
            // No need to check since this only applies to float label 
            return;
        }
        this.intervalHandle = setInterval(() => {
            this.checkCount++;
            if (this.checkCount > 20 || this.hasAutoFillValue) {
                clearInterval(this.intervalHandle);
                return;
            }
            this.hasAutofillClass(this.name, (found) => {
                this.hasAutoFillValue = found;
                this.setupClasses();
            });
        }, 50);
    }
    hasAutofillClass(inputName, func) {
        const input = document.getElementById(inputName);
        if (!input) {
            return;
        }
        if (input.matches(':autofill')) {
            func(true);
        }
    }
}
DwFloatingLabelInputComponent.ɵfac = function DwFloatingLabelInputComponent_Factory(t) { return new (t || DwFloatingLabelInputComponent)(); };
DwFloatingLabelInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFloatingLabelInputComponent, selectors: [["dw-floating-label-input"]], viewQuery: function DwFloatingLabelInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c19, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.userNameInput = _t.first);
    } }, inputs: { useFloat: "useFloat", type: "type", placeholder: "placeholder", inputClass: "inputClass", labelClass: "labelClass", containerClass: "containerClass", name: "name", inputAutocomplete: "inputAutocomplete", label: "label", maxlength: "maxlength" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwFloatingLabelInputComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["class", "p-float-label", 3, "ngClass", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "p-float-label", 3, "ngClass"], [3, "type", "id", "name", "ngClass", "ngModel", "autocomplete", "ngModelChange", "focus", "blur"], ["inputElement", ""], ["class2", "label", 3, "for", "ngClass"], [3, "ngClass"], [3, "type", "ngClass", "id", "name", "ngModel", "placeholder", "autocomplete", "ngModelChange"]], template: function DwFloatingLabelInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFloatingLabelInputComponent_div_0_Template, 5, 10, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwFloatingLabelInputComponent_div_1_Template, 4, 10, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.useFloat);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.useFloat);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [""] });
DwFloatingLabelInputComponent.ctorParameters = () => [];
DwFloatingLabelInputComponent.propDecorators = {
    useFloat: [{ type: Input }],
    label: [{ type: Input }],
    type: [{ type: Input }],
    placeholder: [{ type: Input }],
    inputClass: [{ type: Input }],
    labelClass: [{ type: Input }],
    containerClass: [{ type: Input }],
    maxlength: [{ type: Input }],
    name: [{ type: Input }],
    inputAutocomplete: [{ type: Input }],
    userNameInput: [{ type: ViewChild, args: ['inputElement',] }]
};
__decorate$I([
    DwInputConverter(booleanConverter),
    __metadata$w("design:type", Object)
], DwFloatingLabelInputComponent.prototype, "useFloat", void 0);

class DevwareUIModule {
}
DevwareUIModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareUIModule });
DevwareUIModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareUIModule_Factory(t) { return new (t || DevwareUIModule)(); }, providers: [
        DwUiConfigService,
        /*  DwGridColumnDefaultRendererService,
         DwGridColumnBooleanRendererService,
         DwGridColumnLinkRendererService, */
        DwUiConfigRegistryService,
        // Add the primeng message service (you would think this would be a provider in the ToastModule, but it's not - maybe a highlevel service used in other components)
        MessageService,
        {
            provide: DwUIConfigToken,
            useFactory(configService) {
                const uiConfig = configService.getConfig(DwUiConfigName, new DwUIConfigDefaults());
                return uiConfig;
            },
            deps: [DwConfigServiceToken]
        },
        DwCountValidationRule,
        DwEmailValidationRule,
        DwMinValidationRule,
        DwMaxValidationRule,
        DwMaxLengthValidationRule,
        DwPatternValidationRule,
        DwRequiredValidationRule,
        DwRequiredTrueValidationRule,
        DwUrlValidationRule,
        DwCustomValidationRule,
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            ReactiveFormsModule,
            DevwareCoreModule,
            RouterModule,
            OrderListModule,
            TabViewModule,
            MenuModule,
            DropdownModule,
            BsDropdownModule,
            NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule,
            TriStateCheckboxModule,
            SelectButtonModule,
            InputSwitchModule,
            CalendarModule,
            ToastModule,
            ProgressBarModule,
            DialogModule,
            ButtonsModule,
            //EditorModule,
            //PasswordModule,
            ContextMenuModule,
            TreeModule,
            // QuillModule,
            AccordionModule,
            InfiniteScrollModule,
            SplitterModule,
            InputTextModule,
            ColorPickerModule,
            CaptchaModule
        ]] });

class DevwareOrmModule {
}
DevwareOrmModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareOrmModule });
DevwareOrmModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareOrmModule_Factory(t) { return new (t || DevwareOrmModule)(); }, providers: [
        // DevwareMetaDataService,
        {
            provide: DwOrmDataServiceToken,
            useClass: DwOrmDataService
        },
        {
            provide: DwMetaDataServiceToken,
            useClass: DwMetaDataService
        },
        {
            provide: DwReportingServiceToken,
            useClass: DwReportingService
        },
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            DevwareCoreModule,
        ]] });

class DwTermsOfServiceManagerService {
    constructor(http, configService, dwSecurityStateService, modalService) {
        this.http = http;
        this.configService = configService;
        this.dwSecurityStateService = dwSecurityStateService;
        this.modalService = modalService;
        this.termsOfServiceAccepted = false;
        this.checkingTermsOfService = false;
        // Setup storage to use
        this.securityApi = `${configService.coreConfig.apiRoot}/security`;
    }
    setupTermsOfServiceEvents() {
        this.dwSecurityStateService.securityStateObservable
            .subscribe((state) => {
            if (state.isAuthenticated && !this.termsOfServiceAccepted) {
                if (this.checkingTermsOfService) {
                    return;
                }
                this.checkingTermsOfService = true;
                this.handleTermsOfService()
                    .subscribe(() => {
                    this.checkingTermsOfService = false;
                    // We don't need to do anything here
                });
            }
        });
    }
    handleTermsOfService() {
        if (this.termsOfServiceAccepted) {
            return of(null);
        }
        return this.checkTermsOfService()
            .pipe(mergeMap((result) => {
            if (!result.RequiresTermsOfService) {
                this.termsOfServiceAccepted = true;
                return of(null);
            }
            if (result.HasAcceptedTerms) {
                this.termsOfServiceAccepted = true;
                return of(true);
            }
            return this.showTermsOfServiceModal(result)
                .pipe(mergeMap((modalResult) => {
                if (modalResult.cancelled) {
                    return this.handleTermsOfService();
                }
                return this.acceptTermsOfService()
                    .pipe(tap((acceptResult) => {
                    // We'll already re-check the service result to ensure they have accepted the agreement
                    return this.handleTermsOfService();
                }));
            }));
        }));
    }
    showTermsOfServiceModal(termsOfServiceCheckResult) {
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = [DwModalButtonStandardConfigs.instance.okButton];
        modalConfig.buttons[0].buttonText = 'Accept';
        modalConfig.title = 'Terms of Service';
        modalConfig.modalSize = DwModalSize.responsive;
        modalConfig.customModalWidth = '500px';
        modalConfig.customModalHeight = '430px';
        modalConfig.data = termsOfServiceCheckResult;
        modalConfig.component = DwTermsOfServiceModalComponent;
        modalConfig.preventClose = true;
        return this.modalService.showModal(modalConfig);
    }
    checkTermsOfService() {
        const url = `${this.securityApi}/terms/check`;
        return this.http.get(url);
    }
    acceptTermsOfService() {
        const url = `${this.securityApi}/terms/accept`;
        return this.http.post(url, {});
    }
}
DwTermsOfServiceManagerService.ɵfac = function DwTermsOfServiceManagerService_Factory(t) { return new (t || DwTermsOfServiceManagerService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(DwModalService)); };
DwTermsOfServiceManagerService.ɵprov = ɵɵdefineInjectable({ factory: function DwTermsOfServiceManagerService_Factory() { return new DwTermsOfServiceManagerService(ɵɵinject(HttpClient), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwSecurityStateService), ɵɵinject(DwModalService)); }, token: DwTermsOfServiceManagerService, providedIn: "root" });
DwTermsOfServiceManagerService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwSecurityStateService },
    { type: DwModalService }
];

var __decorate$J = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$x = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const TOGGLE_ROUTER_OUTLET_EVENT = 'toggleRouterOutlet';
class DwDefaultLayoutComponent {
    constructor(uiConfig, dwSecurityStateService, document, renderer, dwMessagingService, dwConfigService, dwEventService, dwModalService, dwTermsOfServiceManagerService) {
        this.uiConfig = uiConfig;
        this.dwSecurityStateService = dwSecurityStateService;
        this.renderer = renderer;
        this.dwMessagingService = dwMessagingService;
        this.dwConfigService = dwConfigService;
        this.dwEventService = dwEventService;
        this.dwModalService = dwModalService;
        this.dwTermsOfServiceManagerService = dwTermsOfServiceManagerService;
        this.showLoginProcess = true;
        this.hideRouterOutletOnLogin = true;
        this.sidebarMinimized = false;
        this.hideSideBarMinimizer = false;
        this.bodyClasses = '';
        this.showLogoutMessageDialog = false;
        this.showLogoutMessage = false;
        this.showRouterOutlet = false;
        this.alwaysShowRouterRoutlet = false;
        this.showModalHost = true;
        this.logoutMessageShown = false;
        this.body = document.body;
    }
    ngOnInit() {
        // this.appSidebar?..display
        this.dwSecurityStateService.securityStateObservable
            .subscribe(value => {
            this.handleSecurityChange(value);
        });
        this.dwTermsOfServiceManagerService.setupTermsOfServiceEvents();
        this.changes = new MutationObserver((mutations) => {
            this.sidebarMinimized = this.body.classList.contains('sidebar-minimized');
        });
        this.changes.observe(this.body, {
            attributes: true
        });
        this.dwEventService.getEvent(TOGGLE_ROUTER_OUTLET_EVENT)
            .subscribe((toggleEvent) => {
            this.toggleRouterVisibility(toggleEvent.data);
        });
    }
    ngOnChanges(changes) {
        if (changes.bodyClasses) {
            this.setBodyClass(changes.bodyClasses.currentValue, changes.bodyClasses.previousValue);
        }
    }
    setBodyClass(addClasses, removeClasses) {
        if (removeClasses) {
            removeClasses.split(',').forEach(removeClass => {
                this.renderer.removeClass(this.body, removeClass);
            });
        }
        if (addClasses) {
            addClasses.split(',').forEach(addClass => {
                this.renderer.addClass(this.body, addClass);
            });
        }
    }
    handleSecurityChange(securityState) {
        var _a;
        const shortState = {
            isAuthenticating: securityState.isAuthenticating,
            isAuthenticated: securityState.isAuthenticated,
            isRefreshing: securityState.isRefreshing,
            lastInteraction: securityState.lastUserInteractionDateTime,
            showError: securityState.showError,
            inactivityLogoutComplete: securityState.inactivityLogoutComplete
        };
        if (this.dwConfigService.coreConfig.securityConfig.alwaysShowRouterOnPathsFunc) {
            this.alwaysShowRouterRoutlet = this.dwConfigService.coreConfig.securityConfig.alwaysShowRouterOnPathsFunc(location.pathname, securityState);
        }
        else {
            this.alwaysShowRouterRoutlet = isPathMatch(this.dwConfigService.coreConfig.securityConfig.alwaysShowRouterOnLoginPaths);
        }
        if (this.dwConfigService.coreConfig.securityConfig.showAuthenticationMessage) {
            this.showLoginProcess = this.dwConfigService.coreConfig.securityConfig.showAuthenticationMessage(location.pathname, securityState);
        }
        if (!this.showRouterOutlet && !securityState.isAuthenticating) {
            this.toggleRouterVisibility();
        }
        else {
            this.showRouterOutlet = !securityState.isAuthenticating;
        }
        this.showError = !!(securityState.showError && securityState.securityMessage);
        this.securityMessage = securityState.securityMessage;
        if (securityState.inactivityLogoutComplete && !this.logoutMessageShown) {
            //this.dwSecurityStateService.setInactivityDetails(false, false, null);
            this.logoutMessageShown = true;
            if (this.showLogoutMessageDialog) {
                this.dwModalService.showDialog("Logout", securityState.inactivityLogoutMessage, [DwModalButtonStandardConfigs.instance.okButton])
                    .subscribe((result) => {
                });
            }
            if (this.showLogoutMessage) {
                this.logoutMessage = {
                    severity: DwMessageSeverity.warning,
                    messageBody: securityState.inactivityLogoutMessage,
                    allowClose: true,
                };
            }
        }
        if (this.logoutMessageShown && securityState.isAuthenticated) {
            this.logoutMessageShown = false;
            this.logoutMessage = null;
        }
        // this.logoutMessage = {
        //   messageBody:'Test message to see if it is dispalyed',
        // }
        if (this.showError) {
            const message = {
                messageBody: securityState.securityMessage,
                allowClose: true,
                timeToShow: 5000,
                severity: DwMessageSeverity.error
            };
            if (((_a = this.message) === null || _a === void 0 ? void 0 : _a.messageBody) != message.messageBody && !this.showLoginProcess) {
                this.message = message;
                this.dwMessagingService.showMessage(this.message);
            }
        }
        else {
            this.message = null;
        }
        if (!securityState.isAuthenticated) {
            return;
        }
        if (this.lastAppUser && this.lastAppUser.UserId !== securityState.securityContext.ApplicationUser.UserId) {
            this.toggleRouterVisibility();
        }
        this.lastAppUser = securityState.securityContext.ApplicationUser;
    }
    toggleRouterVisibility(toggleEventData = null) {
        this.showRouterOutlet = false;
        this.securityMessage = (toggleEventData === null || toggleEventData === void 0 ? void 0 : toggleEventData.message) || 'Updating Security';
        setTimeout(() => {
            this.showRouterOutlet = !this.dwSecurityStateService.securityState.isAuthenticating;
        }, (toggleEventData === null || toggleEventData === void 0 ? void 0 : toggleEventData.toggleTimeMs) | 500);
    }
}
DwDefaultLayoutComponent.ɵfac = function DwDefaultLayoutComponent_Factory(t) { return new (t || DwDefaultLayoutComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityStateService), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(DwMessagingService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwTermsOfServiceManagerService)); };
DwDefaultLayoutComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDefaultLayoutComponent, selectors: [["dw-layout"]], inputs: { showLoginProcess: "showLoginProcess", hideRouterOutletOnLogin: "hideRouterOutletOnLogin", sidebarMinimized: "sidebarMinimized", hideSideBarMinimizer: "hideSideBarMinimizer", bodyClasses: "bodyClasses", showLogoutMessageDialog: "showLogoutMessageDialog", showLogoutMessage: "showLogoutMessage" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c55, decls: 38, vars: 18, consts: [[3, "fixed", "sidebarToggler", "mobileAsideMenuToggler", "asideMenuToggler"], ["navbarBrand", "", 2, "display", "inline-flex"], [1, "pull-left"], ["class2", "navbar-brand", 3, "routerLink"], [1, "dw-logo"], ["topMenu", "", 2, "display", "inline-flex"], [2, "display", "inline-flex"], ["category", "top-menu"], ["topRight", "", 2, "display", "inline-flex"], ["securityInfo", "", 2, "display", "inline-flex"], ["showToasts", "true"], [1, "app-body"], [3, "fixed", "display", "minimized"], ["perfectScrollbar", "", "disabled", "sidebarMinimized"], [4, "ngIf"], [1, "main"], ["breadcrumb", ""], ["showRequestCounts", "true"], [1, "container-fluid"], [1, "logout-message-container", 3, "hidden"], [3, "message", "messageChange"], ["display2", "'lg'", 3, "fixed", "display"], ["fixed", "false", 4, "ngIf"], [3, "message", 4, "ngIf"], [3, "message"], [1, "security-message-box"], ["src", "/assets/img/loader2.gif"], ["fixed", "false"], ["href", "https://www.devwareapps.com", "target", "_blank", "ral", "noopener", 4, "ngIf"], ["href", "https://www.devwareapps.com", "target", "_blank", "ral", "noopener"], ["src", "/assets/img/brand/footer-logo.png", 1, "logo-footer"]], template: function DwDefaultLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c54);
        ɵngcc0.ɵɵelementStart(0, "dw-app-header", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵelement(4, "div", 4);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵprojection(8, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelement(10, "dw-top-menu", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵprojection(12, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 9);
        ɵngcc0.ɵɵelement(14, "dw-security-info");
        ɵngcc0.ɵɵelement(15, "dw-message-bar", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 11);
        ɵngcc0.ɵɵelementStart(17, "app-sidebar", 12);
        ɵngcc0.ɵɵprojection(18, 3);
        ɵngcc0.ɵɵelement(19, "dw-side-menu");
        ɵngcc0.ɵɵelement(20, "app-sidebar-nav", 13);
        ɵngcc0.ɵɵprojection(21, 4);
        ɵngcc0.ɵɵtemplate(22, DwDefaultLayoutComponent_app_sidebar_minimizer_22_Template, 1, 0, "app-sidebar-minimizer", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "main", 15);
        ɵngcc0.ɵɵelementStart(24, "dw-breadcrumb");
        ɵngcc0.ɵɵelementStart(25, "div", 16);
        ɵngcc0.ɵɵprojection(26, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(27, "dw-message-bar", 17);
        ɵngcc0.ɵɵelement(28, "dw-angular-version-checker");
        ɵngcc0.ɵɵelementStart(29, "div", 18);
        ɵngcc0.ɵɵtemplate(30, DwDefaultLayoutComponent_ng_container_30_Template, 3, 2, "ng-container", 14);
        ɵngcc0.ɵɵelementStart(31, "div", 19);
        ɵngcc0.ɵɵelementStart(32, "dw-message", 20);
        ɵngcc0.ɵɵlistener("messageChange", function DwDefaultLayoutComponent_Template_dw_message_messageChange_32_listener($event) { return ctx.logoutMessage = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(33, DwDefaultLayoutComponent_ng_container_33_Template, 2, 0, "ng-container", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "app-aside", 21);
        ɵngcc0.ɵɵelement(35, "dw-ui-config-panel");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(36, DwDefaultLayoutComponent_dw_modal_host_36_Template, 1, 0, "dw-modal-host", 14);
        ɵngcc0.ɵɵtemplate(37, DwDefaultLayoutComponent_app_footer_37_Template, 2, 1, "app-footer", 22);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("fixed", true)("sidebarToggler", "lg")("mobileAsideMenuToggler", "sm")("asideMenuToggler", "lg");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("routerLink", "/");
        ɵngcc0.ɵɵadvance(14);
        ɵngcc0.ɵɵproperty("fixed", true)("display", false)("display", "lg")("minimized", ctx.sidebarMinimized);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideSideBarMinimizer);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showLoginProcess);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.logoutMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.logoutMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRouterOutlet || !ctx.hideRouterOutletOnLogin || ctx.alwaysShowRouterRoutlet);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fixed", true)("display", false);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showModalHost);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.uiConfig.showFooter);
    } }, directives: function () { return [DwAppHeaderComponent, ɵngcc2.RouterLinkWithHref, DwTopMenu, DwSecurityInfoComponent, DwMessageBarComponent, ɵngcc25.AppSidebarComponent, DwSideMenu, ɵngcc25.AppSidebarNavComponent, ɵngcc4.NgIf, DwBreadcrumbMenuComponent, AutoUpdateCheckerComponent, DwMessageComponent, ɵngcc25.AppAsideComponent, DwUiConfigPanelComponent, ɵngcc25.AppSidebarMinimizerComponent, DwMissingImageDirective, ɵngcc2.RouterOutlet, DwModalHostComponent, ɵngcc25.AppFooterComponent]; }, encapsulation: 2 });
DwDefaultLayoutComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwSecurityStateService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 },
    { type: DwMessagingService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwEventService },
    { type: DwModalService },
    { type: DwTermsOfServiceManagerService }
];
DwDefaultLayoutComponent.propDecorators = {
    showLoginProcess: [{ type: Input }],
    hideRouterOutletOnLogin: [{ type: Input }],
    sidebarMinimized: [{ type: Input }],
    hideSideBarMinimizer: [{ type: Input }],
    bodyClasses: [{ type: Input }],
    showLogoutMessageDialog: [{ type: Input }],
    showLogoutMessage: [{ type: Input }]
};
__decorate$J([
    DwInputConverter(booleanConverter),
    __metadata$x("design:type", Boolean)
], DwDefaultLayoutComponent.prototype, "showLoginProcess", void 0);
__decorate$J([
    DwInputConverter(booleanConverter),
    __metadata$x("design:type", Boolean)
], DwDefaultLayoutComponent.prototype, "hideRouterOutletOnLogin", void 0);
__decorate$J([
    DwInputConverter(booleanConverter),
    __metadata$x("design:type", Object)
], DwDefaultLayoutComponent.prototype, "sidebarMinimized", void 0);
__decorate$J([
    DwInputConverter(booleanConverter),
    __metadata$x("design:type", Object)
], DwDefaultLayoutComponent.prototype, "hideSideBarMinimizer", void 0);

class DwTopMenu extends DwMenuComponent {
    ngOnInit() {
        super.ngOnInit();
        this.category = DwMenuCategory.topMenu;
    }
}
DwTopMenu.ɵfac = function DwTopMenu_Factory(t) { return ɵDwTopMenu_BaseFactory(t || DwTopMenu); };
DwTopMenu.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTopMenu, selectors: [["dw-top-menu"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [["id", "topMenu", 1, "top-menu-container"], ["class", "nav-item pull-left", 3, "routerLinkActive", 4, "ngFor", "ngForOf"], [1, "nav-item", "pull-left", 3, "routerLinkActive"], ["className", "nav-link", 3, "menu", "menuLocation"]], template: function DwTopMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwTopMenu_div_1_Template, 2, 4, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.routeHierarchy);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc2.RouterLinkActive, DwMenuLinkComponent], encapsulation: 2 });

class DwSideMenu extends DwMenuComponent {
    constructor() {
        super(...arguments);
        this.hasSideComponent = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.category = DwMenuCategory.sideMenu;
    }
    routesLoaded() {
        var _a;
        super.routesLoaded();
        if (!this.replacementSideMenu) {
            return;
        }
        this.hasSideComponent = !!this.replacementSideMenu.sideMenuComponent;
        const display = `Back to ${((_a = this.replacementSideMenu.backMenu) === null || _a === void 0 ? void 0 : _a.display) || 'Home'}`;
        if (this.replacementSideMenu.backMenu) {
            this.backMenu = deepCopyFullObject(this.replacementSideMenu.backMenu);
        }
        else {
            this.backMenu = {
                url: '/',
                display: display,
                data: {}
            };
        }
        this.backMenu.display = display;
        this.backMenu.data.display = display;
        this.backMenu.data.iconCssClass = 'fa fa-arrow-circle-left';
        this.backMenu.data.highlightOnExactMatch = true;
    }
    configureSideMenuComponent(instance) {
        this.sideMenuComponentInstance = instance;
    }
}
DwSideMenu.ɵfac = function DwSideMenu_Factory(t) { return ɵDwSideMenu_BaseFactory(t || DwSideMenu); };
DwSideMenu.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSideMenu, selectors: [["dw-side-menu"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[4, "ngIf"], ["perfectScrollbar", "", "disabled", "sidebarMinimized", 3, "navItems"], ["class", "replacement-nav", 4, "ngIf"], [1, "replacement-nav"], [1, "nav-item"], [3, "menu", "menuLocation"], [1, "menu-parent-header", 3, "ngClass", "routerLink"], [3, "componentName", "configure"]], template: function DwSideMenu_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwSideMenu_ng_container_0_Template, 2, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, DwSideMenu_ng_container_1_Template, 3, 2, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(2, DwSideMenu_ng_container_2_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.replacementSideMenu);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.replacementSideMenu && !ctx.hasSideComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.replacementSideMenu && ctx.hasSideComponent);
    } }, directives: [ɵngcc4.NgIf, DwAppSidebarNavComponent, DwMenuLinkComponent, ɵngcc4.NgClass, ɵngcc2.RouterLink, DwDynamicLoaderComponent], encapsulation: 2 });

class DwBreadcrumbMenuComponent extends DwMenuComponent {
    constructor() {
        super(...arguments);
        // Use the breadcrumbs property that was set in the DwMenuComponent
        this.breadCrumb = true;
        this.maxMobileItemsToShow = 3;
    }
    initComplete() {
    }
    hideMobile(breadcrumb, index) {
        var _a;
        if ((_a = this.uiConfig.breadcrumbConfig) === null || _a === void 0 ? void 0 : _a.hideMobile) {
            let hideMobile = this.uiConfig.breadcrumbConfig.hideMobile(this.breadCrumbs, breadcrumb, index);
            // Return value if it's not null (this allows an easy to return default functionality)
            if (hideMobile === true || hideMobile === false) {
                return hideMobile;
            }
        }
        if (index == 0) {
            return false;
        }
        const numberToHide = this.breadCrumbs.length - this.maxMobileItemsToShow;
        if (index - numberToHide <= 0) {
            return true;
        }
        return false;
    }
    getBreadcrumbDisplay(menu) {
        if (menu && menu.metaDataItem && menu.data.breadCrumbDisplayParam) {
            return addSpaces(menu.metaDataItem);
        }
        return menu.breadcrumbDisplay || menu.display;
    }
}
DwBreadcrumbMenuComponent.ɵfac = function DwBreadcrumbMenuComponent_Factory(t) { return ɵDwBreadcrumbMenuComponent_BaseFactory(t || DwBreadcrumbMenuComponent); };
DwBreadcrumbMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwBreadcrumbMenuComponent, selectors: [["dw-breadcrumb"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c60, decls: 4, vars: 2, consts: [["style2", "display:flex;flex-wrap:wrap;background-color:white;border-bottom:1px solid #c8ced3;height:45px;margin-bottom:1.5rem", 1, "breadcrumb-container", "hide-print-item"], [1, "breadcrumb"], ["class", "breadcrumb-item", 3, "ngClass", 4, "ngFor", "ngForOf"], ["style", "float:left;width:20%", 4, "ngIf"], [1, "breadcrumb-item", 3, "ngClass"], [3, "routerLink", 4, "ngIf"], [3, "routerLink"], [2, "float", "left", "width", "20%"]], template: function DwBreadcrumbMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c59);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ol", 1);
        ɵngcc0.ɵɵtemplate(2, DwBreadcrumbMenuComponent_li_2_Template, 3, 6, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwBreadcrumbMenuComponent_div_3_Template, 2, 0, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.breadCrumbs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc2.RouterLinkWithHref, ɵngcc2.RouterLink], encapsulation: 2 });

class DwPage404Component {
}
DwPage404Component.ɵfac = function DwPage404Component_Factory(t) { return new (t || DwPage404Component)(); };
DwPage404Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPage404Component, selectors: [["dw-page-404"]], decls: 8, vars: 0, consts: [["dwRow", ""], ["dwCol", "5"], [1, "alert", "alert-danger", 2, "overflow", "auto"], [1, "fas", "fa-exclamation-triangle", "fa-4x", "red", "float-left"], [1, "float-left", "ml-5", "fa-2x"], ["routerLink", "/", 1, "btn", "btn-success", "mt-2"]], template: function DwPage404Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5, "We couldn't find the page you were looking for!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵtext(7, "Return to Home");
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc2.RouterLink], encapsulation: 2 });

class DwAppHeaderComponent {
    constructor(el, dwSecurityUserService, dwConfigService, dwUiConfigService) {
        this.el = el;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwConfigService = dwConfigService;
        this.dwUiConfigService = dwUiConfigService;
        this.canConfigure = false;
        this.hasConfigurations = false;
        this.canConfigure = this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canConfigureUIPermission, false);
        const uiConfig = dwConfigService.getConfig(DwUiConfigName, new DwUIConfigDefaults());
        this.alwaysShowConfigIcon = uiConfig.alwaysShowConfigIcon;
    }
    ngOnInit() {
        Replace(this.el);
        this.isFixed(this.fixed);
        this.dwSecurityUserService.securityContextChanged()
            .subscribe(sc => {
            // Determine if the authenticate user can configure the UI
            this.canConfigure = this.dwSecurityUserService.hasPermission(this.dwConfigService.coreConfig.securityConfig.canConfigureUIPermission, false);
        });
        // Changed to use config handle
        /*  this.dwUiConfigService.getUiPanelWidgetConfigs()
             .subscribe(panels=> {
                 this.hasConfigurations = (panels.length>0);
 
                 this.setupConfigPanelDisplay();
             }); */
    }
    /*  setupConfigPanelDisplay() {
         document.body.classList.remove('aside-menu-lg-show');
 
         if (this.hasConfigurations) {
             document.body.classList.add('aside-menu-lg-show');
         }
     } */
    isFixed(fixed) {
        if (this.fixed) {
            document.querySelector('body').classList.add('header-fixed');
        }
    }
    imgSrc(brand) {
        return brand.src ? brand.src : '';
    }
    imgWidth(brand) {
        return brand.width ? brand.width : 'auto';
    }
    imgHeight(brand) {
        return brand.height ? brand.height : 'auto';
    }
    imgAlt(brand) {
        return brand.alt ? brand.alt : '';
    }
    breakpoint(breakpoint) {
        ////console.log(breakpoint);
        return breakpoint ? breakpoint : '';
    }
}
DwAppHeaderComponent.ɵfac = function DwAppHeaderComponent_Factory(t) { return new (t || DwAppHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService)); };
DwAppHeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAppHeaderComponent, selectors: [["dw-app-header"]], inputs: { fixed: "fixed", navbarBrand: "navbarBrand", navbarBrandFull: "navbarBrandFull", navbarBrandMinimized: "navbarBrandMinimized", sidebarToggler: "sidebarToggler", mobileSidebarToggler: "mobileSidebarToggler", asideMenuToggler: "asideMenuToggler", mobileAsideMenuToggler: "mobileAsideMenuToggler" }, ngContentSelectors: _c62, decls: 16, vars: 4, consts: [[1, "app-header", "navbar"], [2, "display", "inline-flex"], [3, "ngIf"], [1, "top-menu-section"], [1, "top-right-section"], ["type", "button", "appSidebarToggler", "", 1, "navbar-toggler", "d-lg-none", "dw-navbar-toggler"], [1, "fal", "fa-bars"], ["type", "button", 1, "navbar-toggler", "d-md-down-none", "dw-navbar-toggler", 3, "appSidebarToggler"], ["type", "button", 1, "navbar-toggler", "d-md-down-none", "dw-toggler", 3, "appAsideMenuToggler"], [1, "dw-admin-icon", "fa-2x"], ["title", "Customize", 1, "dw-admin-image"], ["type", "button", "appAsideMenuToggler", "", 1, "navbar-toggler", "d-lg-none"]], template: function DwAppHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c61);
        ɵngcc0.ɵɵelementStart(0, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DwAppHeaderComponent_ng_template_3_Template, 2, 0, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(4, DwAppHeaderComponent_ng_template_4_Template, 2, 1, "ng-template", 2);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵprojection(8, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵprojection(11, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵprojection(13, 3);
        ɵngcc0.ɵɵtemplate(14, DwAppHeaderComponent_ng_template_14_Template, 3, 1, "ng-template", 2);
        ɵngcc0.ɵɵtemplate(15, DwAppHeaderComponent_ng_template_15_Template, 3, 0, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mobileSidebarToggler != false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sidebarToggler != false);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("ngIf", false && ctx.canConfigure && (ctx.hasConfigurations || ctx.alwaysShowConfigIcon) && ctx.asideMenuToggler != false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false && ctx.canConfigure && (ctx.hasConfigurations || ctx.alwaysShowConfigIcon) && ctx.mobileAsideMenuToggler != false);
    } }, directives: [ɵngcc4.NgIf, ɵngcc25.ɵb, ɵngcc25.ɵg], encapsulation: 2 });
DwAppHeaderComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwUiConfigService }
];
DwAppHeaderComponent.propDecorators = {
    fixed: [{ type: Input }],
    navbarBrand: [{ type: Input }],
    navbarBrandFull: [{ type: Input }],
    navbarBrandMinimized: [{ type: Input }],
    sidebarToggler: [{ type: Input }],
    mobileSidebarToggler: [{ type: Input }],
    asideMenuToggler: [{ type: Input }],
    mobileAsideMenuToggler: [{ type: Input }]
};

class DwAutoUpdateCheckerService {
    constructor(configService, http) {
        this.configService = configService;
        this.http = http;
        this.autoUpdateChangeSubject = new BehaviorSubject(false);
        this.timerRunning = false;
        this.autoUpdateConfig = configService.coreConfig.autoUpdateConfig;
        if (this.autoUpdateConfig.checkforAngularUpdates) {
            this.startTimer();
        }
    }
    autoUpdateChanged() {
        if (!this.autoUpdateConfig.checkforAngularUpdates) {
            console.warn('Auto check for angular updates is disabled. You will not be notified of changes to the server html');
        }
        return this.autoUpdateChangeSubject.asObservable();
    }
    startTimer() {
        if (this.timerRunning) {
            return;
        }
        this.timerRunning = true;
        this.intervalHandle = setInterval(() => {
            this.checkServerHtmlVersionHasChanged();
        }, (this.autoUpdateConfig.checkFrequencyMinutes || 1) * 60000);
        // Check first time so we have an initial value
        this.checkServerHtmlVersionHasChanged();
    }
    checkServerHtmlVersionHasChanged() {
        const currentArtifacts = this.getCurrentArtifacts();
        this.getServerArtifacts(currentArtifacts)
            .subscribe(serverArtifacts => {
            const changes = [];
            for (let serverArtifact of serverArtifacts) {
                const currentArtifact = currentArtifacts.find(a => a.type == serverArtifact.type && a.relativeUrl == serverArtifact.relativeUrl);
                if (!currentArtifact) {
                    changes.push(serverArtifact.type);
                }
            }
            // for(let type in ArtifactType) {
            //     const server = serverArtifacts.find(a => a.type == type);
            //     if (!server) {
            //         continue;
            //     }
            //     const current = currentArtifacts.find(a => a.type == type && a.relativeUrl == current.relativeUrl);
            //     if (!current) {
            //         changes.push(type as ArtifactType);
            //     }
            //     // if ((current || server) && current?.relativeUrl != server?.relativeUrl) {
            //     //     changes.push(type as ArtifactType);
            //     //     //console.log(`serverHtmlVersionChanged - ${type} has changed`);
            //     // }
            // }
            const hasChanges = changes.length > 0;
            if (hasChanges) {
                this.autoUpdateChangeSubject.next(true);
                this.handleAutoRefresh();
                // Clear handle to stop the timer
                clearInterval(this.intervalHandle);
            }
        });
    }
    handleAutoRefresh() {
        if (!this.autoUpdateConfig.forceRefreshTimeMinutes) {
            return;
            ;
        }
        setTimeout(() => {
            this.refreshApp();
        }, this.autoUpdateConfig.forceRefreshTimeMinutes * 60000);
    }
    refreshApp() {
        if (!this.autoUpdateConfig.allowRefreshOnClick) {
            return;
        }
        try {
            window.location.reload(true);
        }
        catch (_a) {
            window.location.reload();
            ;
        }
    }
    getServerArtifacts(currentArtifacts) {
        var _a;
        const serverUrl = this.getRootUrl((_a = currentArtifacts.find(a => a.type == ArtifactType.styles)) === null || _a === void 0 ? void 0 : _a.fullUrl);
        const fullUrl = `${serverUrl}/index.html?timestamp=${Date.now()}`;
        let headers = new HttpHeaders();
        headers = headers.append(SuppressErrorMessagesHeader, 'true');
        return this.http.get(fullUrl, { responseType: 'text', headers: headers })
            .pipe(map(html => this.getHtmlArtifacts(html)), catchError(err => {
            console.error('Error checking for server html changes.  Will stop checking since previous attempt failed', err);
            clearInterval(this.intervalHandle);
            return [];
        }));
    }
    getHtmlArtifacts(html) {
        const artifacts = [];
        this.parseHtmlArtifacts(html, '<link rel="stylesheet" href="', '"', artifacts);
        this.parseHtmlArtifacts(html, '<script src="', '"', artifacts);
        return artifacts.filter(a => a.type != ArtifactType.none);
    }
    parseHtmlArtifacts(html, fragment1, fragment2, artifacts = [], startingPoint = 0) {
        const startingIndex = html.indexOf(fragment1, startingPoint);
        if (startingIndex >= 0) {
            const endingIndex = html.indexOf(fragment2, startingIndex + fragment1.length);
            const url = html.substring(startingIndex + fragment1.length, endingIndex);
            artifacts.push({
                type: this.determineArtifactType(url),
                fullUrl: url,
                relativeUrl: url
            });
            return this.parseHtmlArtifacts(html, fragment1, fragment2, artifacts, endingIndex);
        }
        return artifacts;
    }
    getCurrentArtifacts() {
        const artifacts = [this.getStylesheetArtifact()];
        const scripts = document.getElementsByTagName('script');
        for (let script of scripts) {
            artifacts.push({
                type: this.determineArtifactType(script.src),
                fullUrl: script.src,
                relativeUrl: this.getRelativeUrl(script.src)
            });
        }
        return artifacts.filter(a => a.type != ArtifactType.none);
    }
    getStylesheetArtifact() {
        var _a;
        const stylesheetLinks = document.getElementsByTagName('link');
        let stylesheetUrl = '';
        for (let link of stylesheetLinks) {
            if (link.rel == 'stylesheet') {
                if (((_a = link.href) === null || _a === void 0 ? void 0 : _a.indexOf('styles.')) >= 0) {
                    stylesheetUrl = link.href;
                }
            }
        }
        if (stylesheetUrl == '') {
            return {
                type: ArtifactType.none,
            };
        }
        return {
            type: ArtifactType.styles,
            fullUrl: stylesheetUrl,
            relativeUrl: this.getRelativeUrl(stylesheetUrl)
        };
    }
    getRelativeUrl(fullUrl) {
        return fullUrl.split('/').pop();
    }
    getRootUrl(fullUrl) {
        return fullUrl.split('/').slice(0, -1).join('/');
    }
    determineArtifactType(scriptUrl) {
        if (scriptUrl.indexOf('runtime.') >= 0) {
            return ArtifactType.runtime;
        }
        if (scriptUrl.indexOf('main.') >= 0) {
            return ArtifactType.main;
        }
        if (scriptUrl.indexOf('vendor.') >= 0) {
            return ArtifactType.vendor;
        }
        if (scriptUrl.indexOf('styles.') >= 0) {
            return ArtifactType.styles;
        }
        if (scriptUrl.indexOf('scripts.') >= 0) {
            return ArtifactType.scripts;
        }
        return ArtifactType.none;
    }
}
DwAutoUpdateCheckerService.ɵfac = function DwAutoUpdateCheckerService_Factory(t) { return new (t || DwAutoUpdateCheckerService)(ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
DwAutoUpdateCheckerService.ɵprov = ɵɵdefineInjectable({ factory: function DwAutoUpdateCheckerService_Factory() { return new DwAutoUpdateCheckerService(ɵɵinject(DwConfigServiceToken), ɵɵinject(HttpClient)); }, token: DwAutoUpdateCheckerService, providedIn: "root" });
DwAutoUpdateCheckerService.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: HttpClient }
];
var ArtifactType;
(function (ArtifactType) {
    ArtifactType["none"] = "none";
    ArtifactType["styles"] = "styles";
    ArtifactType["scripts"] = "scripts";
    ArtifactType["runtime"] = "runtime";
    ArtifactType["main"] = "main";
    ArtifactType["vendor"] = "vendor";
})(ArtifactType || (ArtifactType = {}));

class AutoUpdateCheckerComponent {
    constructor(dwAngularVersionChecker, configService) {
        this.dwAngularVersionChecker = dwAngularVersionChecker;
        this.configService = configService;
        this.angularVersionHasChanges = true;
        this.message = "App Update Available";
        this.tooltip = "Refresh yor browser to get the latest version of the app";
        this.autoUpdateConfig = configService.coreConfig.autoUpdateConfig;
    }
    ngOnInit() {
        this.message = this.autoUpdateConfig.updateMessage;
        this.tooltip = this.autoUpdateConfig.updateMessageTooltip;
        this.dwAngularVersionChecker.autoUpdateChanged().subscribe((hasChanged) => {
            this.angularVersionHasChanges = hasChanged;
            ;
        });
    }
    refreshApp() {
        this.dwAngularVersionChecker.refreshApp();
    }
}
AutoUpdateCheckerComponent.ɵfac = function AutoUpdateCheckerComponent_Factory(t) { return new (t || AutoUpdateCheckerComponent)(ɵngcc0.ɵɵdirectiveInject(DwAutoUpdateCheckerService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken)); };
AutoUpdateCheckerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AutoUpdateCheckerComponent, selectors: [["dw-angular-version-checker"]], decls: 3, vars: 3, consts: [[1, "alert", "alert-danger", "dw-app-update-container", 3, "hidden", "title", "click"], [1, "fa", "fa-cloud-download-alt"]], template: function AutoUpdateCheckerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function AutoUpdateCheckerComponent_Template_div_click_0_listener() { return ctx.refreshApp(); });
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.angularVersionHasChanges)("title", ctx.tooltip);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.message, " ");
    } }, encapsulation: 2 });
AutoUpdateCheckerComponent.ctorParameters = () => [
    { type: DwAutoUpdateCheckerService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];

class DevwareUILayoutModule {
    static forRoot(coreConfig) {
        //if (coreConfig) {
        //    let uiConfig = coreConfig.getConfig(DwUIConfig.configName, new DwUIConfig());
        //}
        //return this.createModule();
        return {
            ngModule: DevwareUILayoutModule,
            providers: []
        };
    }
    static forChild() {
        // Nothing to do here, but want to keep things consistent
        //return this.createModule();
        return {
            ngModule: DevwareUILayoutModule,
            providers: []
        };
    }
}
DevwareUILayoutModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareUILayoutModule });
DevwareUILayoutModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareUILayoutModule_Factory(t) { return new (t || DevwareUILayoutModule)(); }, providers: [], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            DevwareCoreModule,
            DevwareUIModule,
            AppAsideModule,
            AppBreadcrumbModule,
            AppHeaderModule,
            AppFooterModule,
            AppSidebarModule,
            RouterModule,
            BsDropdownModule,
            TabsModule,
            DialogModule,
        ]] });

var DwColumnFormatType;
(function (DwColumnFormatType) {
    DwColumnFormatType["standard"] = "standard";
    DwColumnFormatType["yesNo"] = "yesno";
    DwColumnFormatType["checkmark"] = "checkmark";
    DwColumnFormatType["date"] = "date";
    DwColumnFormatType["datetime"] = "datetime";
    DwColumnFormatType["datetimeLocal"] = "datetimeLocal";
    DwColumnFormatType["actionButton"] = "actionButton";
    DwColumnFormatType["money"] = "money";
    DwColumnFormatType["decimal"] = "decimal";
})(DwColumnFormatType || (DwColumnFormatType = {}));

class DwMetaDataGridPreferenceHierarchy extends DwUiPreferencesHierarchyBase {
}

class DwMetaDataGridConfig extends DwGridConfig {
    constructor() {
        super(...arguments);
        this.filters = [];
        this.views = [];
    }
}

function hasDefaultColumns(defaults) {
    if ((defaults === null || defaults === void 0 ? void 0 : defaults.useDefaults) && (defaults === null || defaults === void 0 ? void 0 : defaults.defaultViewKey) && ((defaults === null || defaults === void 0 ? void 0 : defaults.useAll) || (defaults === null || defaults === void 0 ? void 0 : defaults.useColumns))) {
        return true;
    }
    return false;
}
var DwGridInlineEditingModes;
(function (DwGridInlineEditingModes) {
    DwGridInlineEditingModes["fullRow"] = "fullRow";
    DwGridInlineEditingModes["individualCell"] = "individualCell";
    DwGridInlineEditingModes["allRows"] = "allRows";
})(DwGridInlineEditingModes || (DwGridInlineEditingModes = {}));

var DwGridActionKeys;
(function (DwGridActionKeys) {
    DwGridActionKeys["gridAdd"] = "gridAdd";
    DwGridActionKeys["gridEdit"] = "gridEdit";
    DwGridActionKeys["gridView"] = "gridView";
    DwGridActionKeys["gridPrint"] = "gridPrint";
    DwGridActionKeys["gridDelete"] = "gridDelete";
    DwGridActionKeys["gridDeleteMulti"] = "gridDeleteMulti";
    DwGridActionKeys["gridExport"] = "gridExport";
    DwGridActionKeys["gridRefresh"] = "gridRefresh";
    DwGridActionKeys["gridFilterToggle"] = "gridFilterToggle";
    DwGridActionKeys["gridSetValue"] = "gridSetValue";
    DwGridActionKeys["gridSetValues"] = "gridSetValues";
    DwGridActionKeys["gridMultiEdit"] = "gridMultiEdit";
    DwGridActionKeys["gridCopy"] = "gridCopy";
    DwGridActionKeys["gridToggleValue"] = "gridToggleValue";
    DwGridActionKeys["gridQuickSearch"] = "gridQuickSearch";
    DwGridActionKeys["gridPassthrough"] = "gridPassthrough";
    DwGridActionKeys["gridPassthroughRow"] = "gridPassthroughRow";
    // In-line Editing Actions
    // Grid Actions
    DwGridActionKeys["gridEdit_CancelInlineEdits"] = "gridCancelInlineEdits";
    DwGridActionKeys["gridEdit_SaveInLineEdits"] = "gridSaveInlineEdits";
    DwGridActionKeys["gridEdit_StartInlineEdit"] = "gridStartInlineEdit";
    // Row Actions
    // Not editing actions
    DwGridActionKeys["gridEdit_StartEditInlineRowEdit"] = "gridStartEditInlineRowEdit";
    // Editing actions
    DwGridActionKeys["gridEdit_CompleteInlineRowEdit"] = "gridCompleteInlineRowEdit";
    DwGridActionKeys["gridEdit_CancelInlineRowEdit"] = "gridCancelInlineRowEdit";
    // Edited row actions
    DwGridActionKeys["gridEdit_UndoInlineRowEdit"] = "gridUndoInlineRowEdit";
    DwGridActionKeys["gridEdit_UndoDeleteInlineRowEdit"] = "gridUndoDeleteInlineRowEdit";
    DwGridActionKeys["gridEdit_StatusInlineRowEdit"] = "gridStatusInlineRowEdit";
    DwGridActionKeys["gridEdit_DeleteInlineRowEdit"] = "gridDeleteInlineRowEdit";
})(DwGridActionKeys || (DwGridActionKeys = {}));

var DwActionItemRequirement;
(function (DwActionItemRequirement) {
    DwActionItemRequirement["none"] = "none";
    DwActionItemRequirement["single"] = "single";
    DwActionItemRequirement["multiple"] = "multiple";
})(DwActionItemRequirement || (DwActionItemRequirement = {}));

function convertItemSecurity(itemSecurity) {
    if (!itemSecurity) {
        return null;
    }
    const simpleItemSecurity = {
        canCreate: itemSecurity.CanCreate,
        canRead: itemSecurity.CanRead,
        canUpdate: itemSecurity.CanUpdate,
        canDelete: itemSecurity.CanDelete
    };
    return simpleItemSecurity;
}

class DwSecurityCheckService {
    constructor(securityUserService) {
        this.securityUserService = securityUserService;
    }
    hasPermissions(securityConfig, itemSecurity) {
        itemSecurity = itemSecurity || { canCreate: false, canRead: false, canUpdate: false, canDelete: false };
        if (!securityConfig) {
            return true;
        }
        if (securityConfig.requireCanCreate && !itemSecurity.canCreate) {
            return false;
        }
        if (securityConfig.requireCanUpdate && !itemSecurity.canUpdate) {
            return false;
        }
        if (securityConfig.requireCanDelete && !itemSecurity.canDelete) {
            return false;
        }
        if (securityConfig.requireAuthentication) {
            if (!this.securityUserService.securityState.isAuthenticated) {
                return false;
            }
            if (securityConfig.permissionMeaning) {
                return this.securityUserService.hasPermission(securityConfig.permissionMeaning, securityConfig.useEmulatedPermissions);
            }
        }
        return true;
    }
}
DwSecurityCheckService.ɵfac = function DwSecurityCheckService_Factory(t) { return new (t || DwSecurityCheckService)(ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwSecurityCheckService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecurityCheckService_Factory() { return new DwSecurityCheckService(ɵɵinject(DwSecurityUserService)); }, token: DwSecurityCheckService, providedIn: "root" });
DwSecurityCheckService.ctorParameters = () => [
    { type: DwSecurityUserService }
];

class DwMetaDataActionConfigService extends DwActionConfigService {
    constructor(uiConfigRegistryService, uiConfig, securityCheckService) {
        super(uiConfigRegistryService, uiConfig);
        this.securityCheckService = securityCheckService;
    }
    buildFinalActionPreferencesByMode(actionPreferencesByMode, itemSecurity, defaults) {
        const finalActionPreferencesByMode = {};
        defaults = defaults || {};
        // Iterate over each area
        for (const areaName in actionPreferencesByMode) {
            if (actionPreferencesByMode.hasOwnProperty(areaName)) {
                // search actions for that area
                const areaPrefs = actionPreferencesByMode[areaName];
                const areaDefaults = defaults[areaName] || [];
                finalActionPreferencesByMode[areaName] = this.buildFinalActionPreferences(areaPrefs, itemSecurity, areaDefaults);
            }
        }
        return finalActionPreferencesByMode;
    }
    buildFinalActionPreferences(actionPreferences, itemSecurity, actionDefaults) {
        if (!actionPreferences) {
            actionPreferences = this.buildDefaultActionPreferences(actionDefaults);
        }
        // Set any missing defaults for buttons, menus or security
        actionPreferences = this.getFinalActionPreferences(actionPreferences, null);
        // Handle security trimming of actions based on item security
        actionPreferences = this.securityTrimActions(actionPreferences, itemSecurity);
        return actionPreferences;
    }
    buildDefaultActionPreferences(actionKeyDefaults) {
        const actionPrefs = [];
        actionKeyDefaults = actionKeyDefaults || [];
        const actionConfigs = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action, false);
        for (const actionKey of actionKeyDefaults) {
            const actionPref = this.buildDefaultActionPref(actionConfigs, actionKey);
            actionPrefs.push(actionPref);
        }
        return actionPrefs;
    }
    buildDefaultActionPref(actionConfigs, actionKey, setDefaults = false) {
        const actionConfig = actionConfigs.find(a => a.keyName == actionKey);
        if (!actionConfig) {
            console.warn(`Could not find form button action with key ${actionKey}.  Excluding actions`);
            return;
        }
        const actionPref = {
            actionKey: actionKey,
            actionConfig: actionConfig.configData,
            actionDisplay: actionConfig.display,
            buttonConfig: actionConfig.defaultButtonConfig,
            confirmConfig: actionConfig.defaultConfirmConfig,
            menuConfig: actionConfig.defaultMenuConfig,
            securityConfig: actionConfig.defaultSecurityConfig
        };
        if (setDefaults) {
            actionPref.buttonConfig = Object.assign(Object.assign({}, actionPref.buttonConfig), { useButtonDefaults: true });
            actionPref.securityConfig = Object.assign(Object.assign({}, actionPref.securityConfig), { useSecurityDefaults: true });
        }
        return actionPref;
    }
    securityTrimActions(actionPreferences, itemSecurity) {
        const secureActions = [];
        const actions = this.uiConfigRegistryService.getMdRegisteredItems(DwUiRegistryType.action);
        for (const actionPref of actionPreferences) {
            const action = actions.find(ah => ah.keyName == actionPref.actionKey);
            if (this.canAccessMetaDataAction(actionPref, itemSecurity)) {
                secureActions.push(actionPref);
            }
        }
        return secureActions;
    }
    canAccessMetaDataAction(actionPref, itemSecurity) {
        const simpleItemSecurity = convertItemSecurity(itemSecurity);
        return this.securityCheckService.hasPermissions(actionPref.securityConfig, simpleItemSecurity);
    }
}
DwMetaDataActionConfigService.ɵfac = function DwMetaDataActionConfigService_Factory(t) { return new (t || DwMetaDataActionConfigService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwUIConfigToken), ɵngcc0.ɵɵinject(DwSecurityCheckService)); };
DwMetaDataActionConfigService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataActionConfigService_Factory() { return new DwMetaDataActionConfigService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwUIConfigToken), ɵɵinject(DwSecurityCheckService)); }, token: DwMetaDataActionConfigService, providedIn: "root" });
DwMetaDataActionConfigService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwSecurityCheckService }
];

var DwGridSectionStyleKeys;
(function (DwGridSectionStyleKeys) {
    DwGridSectionStyleKeys["gridActionBarLeft"] = "grid-action-bar-left";
    DwGridSectionStyleKeys["gridActionBarRight"] = "grid-action-bar-right";
    DwGridSectionStyleKeys["basicButtonBar"] = "basic-button-bar";
    DwGridSectionStyleKeys["gridActionRow"] = "gridActionRow";
})(DwGridSectionStyleKeys || (DwGridSectionStyleKeys = {}));

var DwGridActionLocation;
(function (DwGridActionLocation) {
    DwGridActionLocation["actionBarLeft"] = "actionBarLeft";
    DwGridActionLocation["actionBarRight"] = "actionBarRight";
    DwGridActionLocation["rowButton"] = "rowButton";
    DwGridActionLocation["rowContextMenu"] = "contextMenuAction";
    DwGridActionLocation["actionBarLeftInlineEditing"] = "actionBarLeftInlineEditing";
    DwGridActionLocation["actionBarRightInlineEditing"] = "actionBarRightInlineEditing";
    DwGridActionLocation["rowButtonInlineEditing"] = "rowButtonInlineEditing";
})(DwGridActionLocation || (DwGridActionLocation = {}));
class DwGridActionLocationList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwGridActionLocation[propertyName];
    }
    getKeys() {
        return Object.keys(DwGridActionLocation);
    }
    getEnumDisplay(item) {
        return getGridActionLocationDisplay(item);
    }
}
function getGridActionLocationDisplay(actionLocation) {
    switch (actionLocation) {
        case DwGridActionLocation.actionBarLeft:
            return 'Action Bar Left';
        case DwGridActionLocation.actionBarRight:
            return 'Action Bar Right';
        case DwGridActionLocation.rowButton:
            return 'Row Button';
        case DwGridActionLocation.rowContextMenu:
            return 'Row Context Menu';
        case DwGridActionLocation.actionBarLeftInlineEditing:
            return 'Action Bar Left - inline editing';
        case DwGridActionLocation.actionBarRightInlineEditing:
            return 'Action Bar Right - inline editing';
        case DwGridActionLocation.rowButtonInlineEditing:
            return 'Row Button - inline editing';
    }
}
function getGridActionModes(showInlineEditOptions) {
    const gridActionModes = [];
    gridActionModes.push({
        modeValue: DwGridActionLocation.actionBarLeft,
        modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.actionBarLeft),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.gridAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionBarLeft
        // buttonContainerClass: 'dw-grid-action-bar-preview-container dw-grid-action-bar-preview-left'
    });
    gridActionModes.push({
        modeValue: DwGridActionLocation.actionBarRight,
        modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.actionBarRight),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.gridAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionBarRight
        // buttonContainerClass: 'dw-grid-action-bar-preview-container dw-grid-action-bar-preview-right'
    });
    gridActionModes.push({
        modeValue: DwGridActionLocation.rowButton,
        modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.rowButton),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.gridRowAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionRow
        // buttonContainerClass: 'dw-grid-action-row-preview-container'
    });
    gridActionModes.push({
        modeValue: DwGridActionLocation.rowContextMenu,
        modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.rowContextMenu),
        showButtonConfig: false,
        showMenuConfig: true,
        actionTypes: [DwActionType.gridRowAction, DwActionType.menuAction, DwActionType.gridContextMenuAction]
    });
    if (showInlineEditOptions) {
        gridActionModes.push({
            modeValue: DwGridActionLocation.actionBarLeftInlineEditing,
            modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.actionBarLeftInlineEditing),
            showButtonConfig: true,
            showMenuConfig: false,
            actionTypes: [DwActionType.gridActionInlineEdit],
            buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionBarLeft
            // buttonContainerClass: 'dw-grid-action-bar-preview-container dw-grid-action-bar-preview-left'
        });
        gridActionModes.push({
            modeValue: DwGridActionLocation.actionBarRightInlineEditing,
            modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.actionBarRightInlineEditing),
            showButtonConfig: true,
            showMenuConfig: false,
            actionTypes: [DwActionType.gridActionInlineEdit],
            buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionBarRight
            // buttonContainerClass: 'dw-grid-action-bar-preview-container dw-grid-action-bar-preview-right'
        });
        gridActionModes.push({
            modeValue: DwGridActionLocation.rowButtonInlineEditing,
            modeDisplay: getGridActionLocationDisplay(DwGridActionLocation.rowButtonInlineEditing),
            showButtonConfig: true,
            showMenuConfig: false,
            actionTypes: [DwActionType.gridRowActionInlineEdit],
            buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionRow
            // buttonContainerClass: 'dw-grid-action-row-preview-container'
        });
    }
    return gridActionModes;
}

function isMetaDataActionPreference(pref) {
    if (pref && pref.enableVisibleConfig) {
        return true;
    }
    return false;
}

var DwExprVisibilityType;
(function (DwExprVisibilityType) {
    DwExprVisibilityType["none"] = "none";
    DwExprVisibilityType["enabled"] = "enabled";
    DwExprVisibilityType["visible"] = "visible";
})(DwExprVisibilityType || (DwExprVisibilityType = {}));
class DwExprVisibilityTypeList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwExprVisibilityType[propertyName];
    }
    getKeys() {
        return Object.keys(DwExprVisibilityType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwExprVisibilityType.none:
                return 'None';
            case DwExprVisibilityType.enabled:
                return 'Enabled';
            case DwExprVisibilityType.visible:
                return 'Visible';
        }
    }
}

class DwMetaDataActionExpressionService {
    constructor(dwExpressionStateService, dwUiConfigRegistryService) {
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
    }
    /**
     * Processes the enabled/visibility rules and returns the initial actions and an observable for any changes
     * @param actionPreferences Action Preferences
     * @param rootFormGroup Root form group (optional)
     * @param context Context (optional)
     */
    initActionEnabledVisibleRules(actionPreferencesFunc, rootFormGroup, context) {
        // convert to an expression set so all expressions can be processed in a group
        const expressionSet = this.dwExpressionStateService.convertToExpressionSet(actionPreferencesFunc(), this.determineActionExpression, true);
        // initialize the expression set, this give you the inital results and an observable for any changes
        const expressionSetResult = this.dwExpressionStateService.initExpressionSet(expressionSet, rootFormGroup, context);
        // convert the set results to the final action preferences to the used
        const finalResults = {
            initialResults: this.convertActionResults(actionPreferencesFunc(), expressionSetResult.initialResults),
            observable: expressionSetResult.observable.pipe(map(expressionResults => {
                return this.convertActionResults(actionPreferencesFunc(), expressionResults);
            }))
        };
        return finalResults;
    }
    /**
    * Processes the enabled/visibility rules and returns the initial actions and an observable for any changes
    * @param actionPreferences Action Preferences
    * @param rootFormGroup Root form group (optional)
    * @param context Context (optional)
    */
    executeActionEnabledVisibleRules(actionPreferences, resolvedData, resolvedContext, additionalRule) {
        // convert to an expression set so all expressions can be processed in a group
        const expressionSet = this.dwExpressionStateService.convertToExpressionSet(actionPreferences, this.determineActionExpression, true);
        // initialize the expression set, this give you the inital results and an observable for any changes
        const expressionSetResult = this.dwExpressionStateService.executeExpressionSet(expressionSet, resolvedData, resolvedContext);
        const finalResults = {
            initialResults: this.convertActionResults(actionPreferences, expressionSetResult.initialResults, additionalRule),
            observable: null
        };
        return finalResults;
    }
    /**
    * Determines if an action is disabled or invisible (so it won't be executed)
    * @param actionPreferences Action Preferences
    * @param resolvedData Resolved Data
    * @param context Resolved Context (Optional)
    */
    isActionDisabledOrInvisible(actionPreference, resolvedData, resolvedContext) {
        if (!isMetaDataActionPreference(actionPreference)) {
            return false;
        }
        var expr = this.determineActionExpression(actionPreference);
        if (!expr) {
            return false;
        }
        let result = this.dwExpressionStateService.evaluateExpressionWithResolvedData(expr, resolvedData, resolvedContext);
        // when working with an array of data, all data rows must pass the check
        if (resolvedData && Array.isArray(resolvedData)) {
            result = true;
            for (const dataItem of resolvedData) {
                if (!this.dwExpressionStateService.evaluateExpressionWithResolvedData(expr, dataItem, resolvedContext)) {
                    result = false;
                }
            }
        }
        switch (this.getVisibilityType(actionPreference)) {
            case DwExprVisibilityType.visible:
                if (!result) {
                    return true;
                }
                break;
            case DwExprVisibilityType.enabled:
                if (!result) {
                    return true;
                }
                break;
        }
        return false;
    }
    /** Converts the expression results into a final action preferences array with hidden/disabled set accordingly
     */
    convertActionResults(actionPreferences, expressionResults, additionalRule) {
        const finalActionPrefs = [];
        let index = 0;
        for (let actionPreference of actionPreferences) {
            const expressionResult = expressionResults[index];
            const finalActionPreference = deepCopy(actionPreference);
            if (expressionResult === null || expressionResult === void 0 ? void 0 : expressionResult.hasExpression) {
                const visibilityType = this.getVisibilityType(actionPreference);
                finalActionPreference.buttonConfig = finalActionPreference.buttonConfig || {};
                switch (this.getVisibilityType(actionPreference)) {
                    case DwExprVisibilityType.visible:
                        finalActionPreference.buttonConfig.hidden = !expressionResult.result;
                        break;
                    case DwExprVisibilityType.enabled:
                        finalActionPreference.buttonConfig.disabled = !expressionResult.result;
                        break;
                }
            }
            if (this.executeAdditionalRule(finalActionPreference, additionalRule)) {
                finalActionPrefs.push(finalActionPreference);
            }
            index++;
        }
        return finalActionPrefs;
    }
    executeAdditionalRule(actionPreference, additionalRule) {
        if (additionalRule) {
            const actionHandlerRegistration = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.action, actionPreference.actionKey);
            return additionalRule(actionPreference, actionHandlerRegistration);
        }
        return true;
    }
    determineActionExpression(actionPreference) {
        var _a, _b;
        if (isMetaDataActionPreference(actionPreference)) {
            if (((_a = actionPreference.enableVisibleConfig) === null || _a === void 0 ? void 0 : _a.visiblilityType) == DwExprVisibilityType.enabled ||
                ((_b = actionPreference.enableVisibleConfig) === null || _b === void 0 ? void 0 : _b.visiblilityType) == DwExprVisibilityType.visible) {
                return actionPreference.enableVisibleConfig.expression;
            }
        }
        return null;
    }
    getVisibilityType(actionPreference) {
        var _a, _b;
        return (_b = (_a = actionPreference) === null || _a === void 0 ? void 0 : _a.enableVisibleConfig) === null || _b === void 0 ? void 0 : _b.visiblilityType;
    }
}
DwMetaDataActionExpressionService.ɵfac = function DwMetaDataActionExpressionService_Factory(t) { return new (t || DwMetaDataActionExpressionService)(ɵngcc0.ɵɵinject(DwExpressionStateService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService)); };
DwMetaDataActionExpressionService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataActionExpressionService_Factory() { return new DwMetaDataActionExpressionService(ɵɵinject(DwExpressionStateService), ɵɵinject(DwUiConfigRegistryService)); }, token: DwMetaDataActionExpressionService, providedIn: "root" });
DwMetaDataActionExpressionService.ctorParameters = () => [
    { type: DwExpressionStateService },
    { type: DwUiConfigRegistryService }
];

class DwMetaDataGridActionService {
    constructor(uiConfigRegistryService, actionConfigService, actionMenuBuilderService, metaDataActionConfigService, uiMetaDataConfig, mdActionExpressionService) {
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.actionConfigService = actionConfigService;
        this.actionMenuBuilderService = actionMenuBuilderService;
        this.metaDataActionConfigService = metaDataActionConfigService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.mdActionExpressionService = mdActionExpressionService;
    }
    buildFinalActionPreferences(gridViewPref, gridPreferences, itemSecurity, resolvedContext) {
        let actionPreferencesByMode = gridViewPref.actionPreferences;
        if (gridPreferences.isReadOnly) {
            itemSecurity = Object.assign(Object.assign({}, itemSecurity), { CanCreate: false, CanUpdate: false, CanDelete: false });
        }
        if (!actionPreferencesByMode || !gridViewPref.useCustomActions) {
            actionPreferencesByMode = this.getDefaultGridActionPreferencesByMode(gridPreferences);
        }
        const actions = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action);
        gridViewPref.filters = gridViewPref.filters || [];
        const showFilters = !!gridViewPref.filters.find(f => f.showFilter);
        // Set any missing defaults for buttons, menus or security
        actionPreferencesByMode = this.getFinalGridActionPreferences(actions, actionPreferencesByMode, showFilters);
        // Handle security trimming of actions based on item security
        actionPreferencesByMode = this.securityTrimGridActions(actions, actionPreferencesByMode, itemSecurity);
        // Apply any visibility rules
        actionPreferencesByMode = this.executeEnabledDisabledRules(actions, actionPreferencesByMode, itemSecurity, resolvedContext);
        return actionPreferencesByMode;
    }
    buildFinalActionPreference(actionPref, itemSecurity) {
        const actions = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action);
        if (!actionPref) {
            return null;
        }
        const action = actions.find(a => a.keyName == actionPref.actionKey);
        if (!action) {
            return null;
        }
        if (!this.metaDataActionConfigService.canAccessMetaDataAction(actionPref, itemSecurity)) {
            return null;
        }
        const finalActionPref = deepCopy(actionPref);
        this.actionConfigService.setActionDefaults(actions, finalActionPref);
        return finalActionPref;
    }
    buildActionMenus(actionPreferences, actionFunc, rowData, resolvedContext) {
        const menuActionPrefs = actionPreferences[DwGridActionLocation.rowContextMenu] || [];
        rowData = rowData || [];
        const finalActions = menuActionPrefs.filter(action => this.showActionMenu(action, rowData.length, rowData, resolvedContext));
        return this.actionMenuBuilderService.buildActionMenus(finalActions, actionFunc);
    }
    showActionMenu(actionPref, itemCount, rowData, resolvedContext) {
        const actionConfig = actionPref.actionConfig || {};
        const menuConfig = actionPref.menuConfig || {};
        switch (menuConfig.itemRequirement) {
            case DwActionItemRequirement.single:
                if (itemCount != 1) {
                    return false;
                }
                return !this.mdActionExpressionService.isActionDisabledOrInvisible(actionPref, rowData[0], resolvedContext);
            case DwActionItemRequirement.multiple:
                if (itemCount == 0) {
                    return false;
                }
                return !this.mdActionExpressionService.isActionDisabledOrInvisible(actionPref, rowData, resolvedContext);
        }
        return true;
    }
    securityTrimGridActions(actions, actionPreferencesByMode, itemSecurity) {
        actionPreferencesByMode = deepCopy(actionPreferencesByMode);
        const finalPreferences = {};
        for (const area in actionPreferencesByMode) {
            if (actionPreferencesByMode.hasOwnProperty(area)) {
                // search actions for that area
                const subActionPrefs = actionPreferencesByMode[area];
                finalPreferences[area] = this.securityTrimActions(actions, subActionPrefs, itemSecurity);
            }
        }
        return finalPreferences;
    }
    securityTrimActions(actions, actionPreferences, itemSecurity) {
        var _a;
        // Custom implemtation so it can replace an edit buttons with a view button
        const secureActions = [];
        for (const actionPref of actionPreferences) {
            const action = actions.find(ah => ah.keyName == actionPref.actionKey);
            if (this.metaDataActionConfigService.canAccessMetaDataAction(actionPref, itemSecurity)) {
                secureActions.push(actionPref);
            }
            else {
                // If we are hiding the edit, then replace it with view
                if (actionPref.actionKey == DwGridActionKeys.gridEdit) {
                    const editAction = actionPref;
                    const viewAction = actionPreferences.find(ah => ah.actionKey == DwGridActionKeys.gridView);
                    if (!viewAction && !((_a = editAction.actionConfig) === null || _a === void 0 ? void 0 : _a.hideViewButton)) {
                        this.addGridActionPref(actions, DwGridActionKeys.gridView, secureActions, actionPref);
                    }
                }
            }
        }
        return secureActions;
    }
    // Handle all visibility rules
    executeEnabledDisabledRules(actions, actionPreferencesByMode, itemSecurity, resolvedContext) {
        actionPreferencesByMode = deepCopy(actionPreferencesByMode);
        const finalPreferences = {};
        for (const area in actionPreferencesByMode) {
            if (actionPreferencesByMode.hasOwnProperty(area)) {
                // search actions for that area
                const subActionPrefs = actionPreferencesByMode[area];
                const visibleRuleResults = this.mdActionExpressionService.executeActionEnabledVisibleRules(subActionPrefs, {}, resolvedContext);
                finalPreferences[area] = visibleRuleResults.initialResults;
            }
        }
        return finalPreferences;
        ;
    }
    getDefaultGridActionPreferencesByMode(gridPreferences) {
        const actionPreferencesByMode = {};
        const actionConfigs = this.uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action);
        const defaultGridButtons = this.uiMetaDataConfig.gridButtonDefaults || {};
        for (const mode in defaultGridButtons) {
            if (defaultGridButtons.hasOwnProperty(mode)) {
                let actionKeys = defaultGridButtons[mode] || [];
                actionKeys = actionKeys.filter(actionKey => this.showActionKey(gridPreferences, actionKey));
                actionPreferencesByMode[mode] = this.buildActionPrefs(actionConfigs, actionKeys);
            }
        }
        return actionPreferencesByMode;
    }
    showActionKey(gridPreferences, actionKey) {
        let show = true;
        let hide = false;
        if (!gridPreferences) {
            return;
        }
        switch (actionKey) {
            case DwGridActionKeys.gridEdit:
                show = true;
                hide = gridPreferences.hideEditButton;
                break;
            case DwGridActionKeys.gridDelete:
                show = true;
                hide = gridPreferences.hideDeleteButton;
                break;
            case DwGridActionKeys.gridView:
                show = gridPreferences.showViewButton == true;
                break;
            case DwGridActionKeys.gridAdd:
                show = true;
                hide = gridPreferences.hideAdd;
                break;
            case DwGridActionKeys.gridRefresh:
                show = true;
                hide = gridPreferences.hideRefresh;
                break;
            case DwGridActionKeys.gridExport:
                show = true;
                hide = gridPreferences.hideExport;
                break;
        }
        if (show && !hide) {
            return true;
        }
    }
    buildActionPrefs(actionConfigs, actionKeys) {
        const actionPrefs = [];
        actionKeys = actionKeys || [];
        for (const actionKey of actionKeys) {
            const actionConfig = actionConfigs.find(a => a.keyName == actionKey);
            const actionPref = {
                actionKey: actionKey,
                actionConfig: actionConfig.configData,
                actionDisplay: actionConfig.display,
                buttonConfig: actionConfig.defaultButtonConfig,
                confirmConfig: actionConfig.defaultConfirmConfig,
                menuConfig: actionConfig.defaultMenuConfig,
                securityConfig: actionConfig.defaultSecurityConfig
            };
            actionPrefs.push(actionPref);
        }
        return actionPrefs;
    }
    addGridActionPref(actions, gridActionKey, actionPrefs, editActionPref, show = true, hide = false, index) {
        if (!show || hide) {
            return;
        }
        const action = actions.find(ah => ah.keyName == gridActionKey);
        if (!action) {
            console.warn(`Could not find grid action handler for type ${gridActionKey}`);
            return;
        }
        const actionPref = {
            actionKey: gridActionKey,
            actionDisplay: action.display,
            actionConfig: action.configData,
            buttonConfig: action.defaultButtonConfig,
            menuConfig: action.defaultMenuConfig,
            securityConfig: action.defaultSecurityConfig,
            confirmConfig: action.defaultConfirmConfig,
            enableVisibleConfig: {}
        };
        if (isMetaDataActionPreference(editActionPref)) {
            actionPref.enableVisibleConfig = editActionPref.enableVisibleConfig;
        }
        if (index) {
            actionPrefs.splice(index, 0, actionPref);
        }
        else {
            actionPrefs.push(actionPref);
        }
    }
    getFinalGridActionPreferences(actions, actionPreferencesByMode, showFilters) {
        const finalActionPreferencesByMode = {};
        // Iterate over each area
        for (const areaName in actionPreferencesByMode) {
            if (actionPreferencesByMode.hasOwnProperty(areaName)) {
                // search actions for that area
                const areaPrefs = actionPreferencesByMode[areaName];
                if (!Array.isArray(areaPrefs)) {
                    continue;
                }
                // Remove filter if it should be hidden
                if (!showFilters) {
                    const filterActionPref = areaPrefs.find(ap => ap.actionKey == DwGridActionKeys.gridFilterToggle);
                    if (filterActionPref) {
                        const index = areaPrefs.indexOf(filterActionPref);
                        areaPrefs.splice(index, 1);
                    }
                }
                finalActionPreferencesByMode[areaName] = this.actionConfigService.getFinalActionPreferences(areaPrefs);
            }
        }
        return finalActionPreferencesByMode;
    }
}
DwMetaDataGridActionService.ɵfac = function DwMetaDataGridActionService_Factory(t) { return new (t || DwMetaDataGridActionService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwActionConfigService), ɵngcc0.ɵɵinject(DwActionMenuBuilderService), ɵngcc0.ɵɵinject(DwMetaDataActionConfigService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwMetaDataActionExpressionService)); };
DwMetaDataGridActionService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataGridActionService_Factory() { return new DwMetaDataGridActionService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwActionConfigService), ɵɵinject(DwActionMenuBuilderService), ɵɵinject(DwMetaDataActionConfigService), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwMetaDataActionExpressionService)); }, token: DwMetaDataGridActionService, providedIn: "root" });
DwMetaDataGridActionService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwActionConfigService },
    { type: DwActionMenuBuilderService },
    { type: DwMetaDataActionConfigService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataActionExpressionService }
];

class DwGridColumnBooleanConfigDefaults {
}

class DwGridColumnBooleanConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return new DwGridColumnBooleanConfigDefaults();
    }
}
DwGridColumnBooleanConfigComponent.ɵfac = function DwGridColumnBooleanConfigComponent_Factory(t) { return ɵDwGridColumnBooleanConfigComponent_BaseFactory(t || DwGridColumnBooleanConfigComponent); };
DwGridColumnBooleanConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridColumnBooleanConfigComponent, selectors: [["dw-grid-column-boolean-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 22, vars: 4, consts: [["dwRow", ""], ["dwCol", "12"], [1, "label"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwGridColumnBooleanConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3, "Yes Icon Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.config.yesIconClass = $event; })("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label", 2);
        ɵngcc0.ɵɵtext(8, "Yes Display Value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.config.yesDisplayValue = $event; })("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_9_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "hr");
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵelementStart(13, "label", 2);
        ɵngcc0.ɵɵtext(14, "No Icon Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_15_listener($event) { return ctx.config.noIconClass = $event; })("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_15_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 0);
        ɵngcc0.ɵɵelementStart(17, "div", 1);
        ɵngcc0.ɵɵelementStart(18, "label", 2);
        ɵngcc0.ɵɵtext(19, "No Display Value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_20_listener($event) { return ctx.config.noDisplayValue = $event; })("ngModelChange", function DwGridColumnBooleanConfigComponent_Template_input_ngModelChange_20_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(21, "hr");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.yesIconClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.yesDisplayValue);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.noIconClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.noDisplayValue);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

function DwGridColumn(gridColumnRegistration) {
    return function (constructor) {
        let gridColumnRef = Object.assign(Object.assign({}, gridColumnRegistration), { keyName: gridColumnRegistration.keyName || gridColumnRegistration.display, isGlobal: gridColumnRegistration.isGlobal || false, rendererType: constructor });
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerItem(DwUiRegistryType.gridColumn, gridColumnRef);
    };
}

var __decorate$K = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwGridColumnBooleanRendererService = class DwGridColumnBooleanRendererService {
    renderColumn(columnConfig) {
        const config = columnConfig.columnRendererConfig;
        return booleanRendererFromConfig(config);
    }
};
DwGridColumnBooleanRendererService.ɵfac = function DwGridColumnBooleanRendererService_Factory(t) { return new (t || DwGridColumnBooleanRendererService)(); };
DwGridColumnBooleanRendererService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridColumnBooleanRendererService, factory: function (t) { return DwGridColumnBooleanRendererService.ɵfac(t); } });
DwGridColumnBooleanRendererService = __decorate$K([
    DwGridColumn({
        keyName: 'dw-grid-column-boolean',
        display: 'Boolean Column',
        decoratorType: DwDecoratorType.service,
        configComponent: DwGridColumnBooleanConfigComponent,
        isGlobal: true,
        allowAction: true,
        showActionButtonConfig: false,
        requireAction: false,
        allowAttr: true,
        requireAttr: true,
        configData: new DwGridColumnBooleanConfigDefaults(),
        columnStyleFunc: getCheckMarkColumnStyle,
    })
], DwGridColumnBooleanRendererService);
function booleanRenderer(columnDef) {
    const config = columnDef.columnRendererConfig;
    return booleanRendererFromConfig(config);
}
const defaultBooleanConfig = {
    yesIconClass: 'fa fa-check fa-2x'
};
function booleanRendererFromConfig(config) {
    config = config || defaultBooleanConfig;
    const yesTemplate = buildCheckMarkTemplate(config.yesIconClass, config.yesDisplayValue);
    const noTemplate = buildCheckMarkTemplate(config.noIconClass, config.noDisplayValue);
    return (params) => {
        const value = params.getValue();
        if (value) {
            return yesTemplate;
        }
        return noTemplate;
    };
}
function buildCheckMarkTemplate(iconClass, displayValue) {
    if (!iconClass && !displayValue) {
        return '';
    }
    return `<span class="${iconClass || ''}">${displayValue || ''}</span>`;
}
function getCheckMarkColumnStyle(columnDef) {
    return { textAlign: 'center' };
}

var __decorate$L = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const defaultGridColumnRenderer = 'dw-grid-column-default';
let DwGridColumnDefaultRendererService = class DwGridColumnDefaultRendererService {
    renderColumn(columnConfig) {
        return standardRenderer(columnConfig);
    }
};
DwGridColumnDefaultRendererService.ɵfac = function DwGridColumnDefaultRendererService_Factory(t) { return new (t || DwGridColumnDefaultRendererService)(); };
DwGridColumnDefaultRendererService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridColumnDefaultRendererService, factory: function (t) { return DwGridColumnDefaultRendererService.ɵfac(t); } });
DwGridColumnDefaultRendererService = __decorate$L([
    DwGridColumn({
        keyName: defaultGridColumnRenderer,
        display: 'Standard',
        decoratorType: DwDecoratorType.service,
        isGlobal: true,
        allowAttr: true,
        requireAttr: true,
        allowAction: true,
        order: 1,
        columnStyleFunc: getDefaultColumnStyle,
    })
], DwGridColumnDefaultRendererService);
function standardRenderer(columnDef) {
    switch (columnDef.columnFormatType) {
        case DwColumnFormatType.yesNo:
        case DwColumnFormatType.checkmark:
            // Reuse the boolean config
            return booleanRendererFromConfig();
        case DwColumnFormatType.money:
            return formatNumeric(columnDef.decimals | 2, true, false);
        case DwColumnFormatType.decimal:
            return formatNumeric(columnDef.decimals | 2, false, false);
        case DwColumnFormatType.date:
        case DwColumnFormatType.datetime:
        case DwColumnFormatType.datetimeLocal:
            return formatDateTimeColumn(columnDef.columnFormatType, columnDef.use24HourTime);
            break;
    }
    return (params) => params.getValue();
}
function formatNumeric(decimals, money, excludeLocalNumericFormatting) {
    return (params) => {
        const value = params.getValue();
        const numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
            return null;
        }
        let formattedValue = numberValue.toFixed(decimals);
        if (!excludeLocalNumericFormatting) {
            formattedValue = numberValue.toLocaleString('en-us', { maximumFractionDigits: decimals, minimumFractionDigits: decimals });
        }
        if (money) {
            formattedValue = `$${formattedValue}`;
        }
        return formattedValue;
    };
}
function formatDateTimeColumn(columnType, use24HourTime) {
    return (params) => {
        var value = params.getValue();
        switch (columnType) {
            case DwColumnFormatType.date:
                return formatDateTime(value, false, !use24HourTime);
            case DwColumnFormatType.datetime:
                return formatDateTime(value, true, !use24HourTime);
            case DwColumnFormatType.datetimeLocal:
                return formatDateTimeToLocal(value, true, !use24HourTime);
        }
    };
}
function getDefaultColumnStyle(columnDef) {
    switch (columnDef.columnFormatType) {
        case DwColumnFormatType.yesNo:
        case DwColumnFormatType.checkmark:
            // Reuse the boolean config
            return getCheckMarkColumnStyle(columnDef);
    }
}

class DwQueryBuilder {
    constructor(query) {
        this.query = query;
    }
    getFieldSettings() {
        if (!this.query.FieldSettings) {
            this.query.FieldSettings = new DwQuerySettings();
        }
        return this.query.FieldSettings;
    }
    clearAllFields() {
        const qh = new DwQueryHelper();
        // Clear all the fields including relations
        return qh.clearAllFields(this.query);
    }
    AddFilterAnd(expr) {
        if (!this.query.Filter) {
            this.query.Filter = new DwQueryFilterGroup();
        }
        this.AddFilter(this.query.Filter, expr, DwOperator.And);
        return this;
    }
    AddFilterOr(expr) {
        if (!this.query.Filter) {
            this.query.Filter = new DwQueryFilterGroup();
        }
        this.AddFilter(this.query.Filter, expr, DwOperator.Or);
        return this;
    }
    AddFilter(filters, filter, op) {
        this.validateFilter(filter);
        if (filter.Type != DwFilterType.Group) {
            filter.Op = op;
        }
        if (!this.query.Filter) {
            this.query.Filter = new DwQueryFilterGroup();
        }
        filters.Filters.push(filter);
    }
    validateFilter(filter) {
        if (!filter)
            throw new Error("Filter Expr cannot be null and must be a valid Filter type.  Use Filters helper classes to create your filters.");
        if (!filter.Type)
            throw new Error("Filter Expr.Type cannot be null");
    }
    AddPrefetchPath(relation, subQuery) {
        var prefetch = new DwQueryPrefetchPath();
        if (typeof relation === "string") {
            prefetch.RelationName = relation;
        }
        else {
            prefetch.RelationName = relation.RelationName;
        }
        prefetch.Query = subQuery;
        this.query.Prefetch = this.query.Prefetch || [];
        this.query.Prefetch.push(prefetch);
        return this;
    }
    SetFieldSettings(loadCustomAttributes, loadAllLookupDisplayFields) {
        if (!loadCustomAttributes === null)
            this.getFieldSettings().LoadCustomAttributes = loadCustomAttributes;
        if (!loadAllLookupDisplayFields === null)
            this.getFieldSettings().LoadAllLookupDisplayFields = loadAllLookupDisplayFields;
        return this;
    }
    SetupAggregateQuery(withRollup) {
        this.getFieldSettings().AggregateQuery = true;
        this.getFieldSettings().AggregateQueryWithRollup = withRollup ? true : false;
        return this;
    }
    SetupPaging(pageNo, pageSize, returnCount, top) {
        if (!this.query.PagingInfo)
            this.query.PagingInfo = new DwQueryPaging();
        this.query.PagingInfo.PageNo = pageNo;
        this.query.PagingInfo.PageSize = pageSize;
        this.query.PagingInfo.ReturnCount = returnCount ? true : false;
        this.query.PagingInfo.Top = top;
        return this;
    }
    setDistinct(distinct) {
        if (!this.query.PagingInfo)
            this.query.PagingInfo = new DwQueryPaging();
        this.query.PagingInfo.Distinct = distinct;
    }
    AddRelation(relation, fieldPrefix = "") {
        let newRelation;
        if (typeof relation == "string") {
            newRelation = new DwQueryRelation();
            newRelation.RelationName = relation;
            newRelation.FieldPrefix = fieldPrefix;
        }
        else {
            newRelation = relation;
        }
        this.query.Relations = this.query.Relations || [];
        this.query.Relations.push(newRelation);
        return this;
    }
    getField(field) {
        if (typeof field == "string") {
            var newField = new DwField();
            newField.FullFieldName = field;
            return newField;
        }
        return field;
    }
    AddField(field) {
        var finalField = this.getField(field);
        this.getFieldSettings().IncludeRootItemFields = false;
        this.getFieldSettings().IncludeFields = this.getFieldSettings().IncludeFields || [];
        this.getFieldSettings().IncludeFields.push(finalField);
        return this;
    }
    AddFields(fields) {
        for (const field of fields) {
            this.AddField(field);
        }
        return this;
    }
    AddExcludeField(field) {
        var finalField = this.getField(field);
        this.getFieldSettings().ExcludeFields = this.getFieldSettings().ExcludeFields || [];
        this.getFieldSettings().ExcludeFields.push(finalField);
        return this;
    }
    AddRelatedField(field, fieldAlias) {
        var finalField = this.getField(field);
        this.query.RelationFields = this.query.RelationFields || [];
        this.query.RelationFields.push(finalField);
        return this;
    }
    OrderBy(field, isAscending = true) {
        this.query.Order = this.query.Order || [];
        if (typeof field == "string") {
            let newField = new DwQueryOrder();
            newField.Field.FullFieldName = field;
            newField.IsAscending = isAscending ? true : false;
            this.query.Order.push(newField);
        }
        else {
            this.query.Order.push(field);
        }
        return this;
    }
}

class DwGridColumnDef {
    constructor() {
        this.columnFormatType = DwColumnFormatType.standard;
    }
}

class DwMetaDataGridColumnDef extends DwGridColumnDef {
}

class DwMetaDataGridService {
    constructor(dwOrmDataService, dwMetaDataService, uiMetaDataConfig, dwMetaDataRouting, uiConfigService, dwCacheService, dwMessagingService, dwMetaDataGridActionService, dwActionConfigService, dwSecurityCheckService, dwUiConfigRegistryService, dwSecurityUserService, dwContextService, dwExpressionService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataRouting = dwMetaDataRouting;
        this.uiConfigService = uiConfigService;
        this.dwCacheService = dwCacheService;
        this.dwMessagingService = dwMessagingService;
        this.dwMetaDataGridActionService = dwMetaDataGridActionService;
        this.dwActionConfigService = dwActionConfigService;
        this.dwSecurityCheckService = dwSecurityCheckService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwContextService = dwContextService;
        this.dwExpressionService = dwExpressionService;
        this.gridGlobalPreferences = new DwMetaDataGridPreferences();
        this.retryCount = 0;
        this.EDIT_COLUMN = 'editColumn';
        this.gridGlobalPreferences = this.uiMetaDataConfig.gridDefaultPreferences;
    }
    /**
     * Removes the in line editing validation and original Data
     * @param rows
     * @returns
     */
    cleanupEditableData(rows) {
        const newRows = deepCopy(rows);
        for (const row of newRows) {
            row._originalData = null;
            row._validation = null;
        }
        return newRows;
    }
    getDataSource(gridPrefHiearchy, view) {
        var _a, _b;
        let finalPreferences = this.uiConfigService.getFinalPreferences(gridPrefHiearchy);
        let dataSource = new DwOrmDataSource(this.dwOrmDataService, this.dwMetaDataService, view.query);
        if ((_a = view.gridViewPreferences) === null || _a === void 0 ? void 0 : _a.dataSourceName) {
            let customDataSource = this.uiConfigService.getDataSource((_b = view.gridViewPreferences) === null || _b === void 0 ? void 0 : _b.dataSourceName);
            if (customDataSource) {
                dataSource = customDataSource;
            }
        }
        dataSource.initDataSource();
        dataSource.uniqueIdentifier = `${view.gridViewPreferences.metaDataQueryMeaning}_${view.key}`;
        if (dataSource instanceof DwOrmDataSource) {
            dataSource.item = view.query;
        }
        return dataSource;
    }
    getPreferenceHierarchy(item, configKey, useLoadedPreferences, componentSetPreferences) {
        let metaDataOb = this.dwMetaDataService.getMetaData(item);
        let prefsOb = this.uiConfigService.getPreferencesHierarchy(configKey, DwUiConfigType.grid, this.gridGlobalPreferences, componentSetPreferences, useLoadedPreferences);
        let itemSecurityOb = this.dwMetaDataService.getUserMetaDataItemSecurity(item);
        return combineLatest([metaDataOb, prefsOb, itemSecurityOb])
            .pipe(mergeMap(([itemMetaData, prefHierarchy, itemSecurity]) => {
            // This shouldn't be possible, but during a refresh it happens when the cache is cleared while refreshing
            if (!itemMetaData) {
                console.error(`getPreferenceHierarchy - No metadata found for ${item} - Retry Count: ${this.retryCount}`);
                if (this.retryCount < 3) {
                    this.retryCount++;
                    return this.getPreferenceHierarchy(item, configKey, useLoadedPreferences, componentSetPreferences);
                }
                // After 3 retries, just continue which will use the previous data
            }
            let gridPrefsHierarchy = new DwMetaDataGridPreferenceHierarchy();
            gridPrefsHierarchy = Object.assign(gridPrefsHierarchy, prefHierarchy);
            gridPrefsHierarchy.itemMetaData = itemMetaData;
            gridPrefsHierarchy.item = item;
            gridPrefsHierarchy.itemSecurity = itemSecurity;
            gridPrefsHierarchy.metaDataItemId = itemMetaData === null || itemMetaData === void 0 ? void 0 : itemMetaData.MetaDataItemId;
            // Get a list of all metadata that is needed for all views
            const finalPreferences = this.uiConfigService.getFinalPreferences(gridPrefsHierarchy);
            const queryMetaDataOb = this.getViewQueryMetaData(gridPrefsHierarchy.item, finalPreferences.views);
            const contextOb = this.dwContextService.getContextsAndResolve(finalPreferences.contextNames, {});
            return combineLatest([queryMetaDataOb, contextOb])
                //return this.getViewQueryMetaData(gridPrefsHierarchy.item, finalPreferences.views)
                .pipe(map(([queryMetaData, resolvedContext]) => {
                gridPrefsHierarchy.queryMetaData = queryMetaData;
                gridPrefsHierarchy.resolvedContext = resolvedContext;
                return gridPrefsHierarchy;
            }));
        }));
    }
    getViewQueryMetaData(item, views) {
        // Get a list of all metadata that is needed for all views
        const itemRequest = {
            ItemName: item,
            MetaDataQueryIds: [],
            MetaDataQueryMeanings: [],
            Queries: []
        };
        if (views) {
            views
                // .map(v => v.metaDataQueryMeaning)
                .forEach(view => {
                if (view.metaDataQueryMeaning && itemRequest.MetaDataQueryMeanings.indexOf(view.metaDataQueryMeaning) === -1) {
                    itemRequest.MetaDataQueryMeanings.push(view.metaDataQueryMeaning);
                }
                if (view.query) {
                    const viewKey = view.key || views.indexOf(view).toString();
                    itemRequest.Queries.push({
                        Query: view.query,
                        // Omiting this since it was caching the columns and never updating - so once a permit grid was loaded, the columns would never change (Also caused issue in query tester since it always uses the same view key)
                        //  Note: this issue began to be a problem when the unique identifier not being passed back to the client was fixed
                        UniqueIdentifier: viewKey
                    });
                }
            });
        }
        if (itemRequest.MetaDataQueryMeanings.length === 0 && itemRequest.MetaDataQueryMeanings.length === 0 && itemRequest.Queries.length === 0) {
            itemRequest.MetaDataQueryIds.push(0);
        }
        return this.dwMetaDataService.getSavedQueryMetaDataMulti([itemRequest]);
    }
    buildDefaultGridConfig(gridPrefHiearchy, initialViewKey = null, readOnly) {
        // Allow this to be overriden at the component level (just in case it gets set in the ui config)
        if (gridPrefHiearchy === null || gridPrefHiearchy === void 0 ? void 0 : gridPrefHiearchy.loadedPreferences) {
            gridPrefHiearchy.loadedPreferences.passCurrentDataSource = null;
        }
        // Combines all the perferences into a final version to build the grid with
        let finalPreferences = this.uiConfigService.getFinalPreferences(gridPrefHiearchy);
        let gridConfig = new DwMetaDataGridConfig();
        gridConfig.itemName = gridPrefHiearchy.item;
        gridConfig.canAccess = true;
        if (!gridPrefHiearchy.itemSecurity.CanRead) {
            const securityMessages = new DwSecurityMessages();
            gridConfig.canAccess = false;
            gridConfig.accessErrorMessage = securityMessages.NoReadAccess;
            return gridConfig;
        }
        if (!gridPrefHiearchy.itemMetaData) {
            console.warn(`buildDefaultGridConfig - No metadata found for ${gridPrefHiearchy.item}`);
            return null;
        }
        // Check if table has a FK
        const pkAttr = gridPrefHiearchy.itemMetaData.Attributes.find(a => a.IsKey);
        if (!pkAttr) {
            this.showMissingPkWarning(gridPrefHiearchy.itemMetaData.UniqueItemName);
            finalPreferences.hideEditButton = true;
            finalPreferences.showViewButton = false;
        }
        // Set default options
        gridConfig.contextNames = finalPreferences.contextNames;
        gridConfig.resolvedContext = gridPrefHiearchy.resolvedContext;
        gridConfig.configKey = gridPrefHiearchy.configKey;
        gridConfig.enableSorting = finalPreferences.enableSorting;
        gridConfig.showFilter = finalPreferences.showFilter;
        gridConfig.useSideFilters = finalPreferences.useSideFilters;
        gridConfig.showFilterOnLoad = finalPreferences.showFilterOnLoad;
        gridConfig.autoFilter = finalPreferences.autoFilter;
        gridConfig.showClearFilter = finalPreferences.showClearFilter;
        gridConfig.autoFilterDelay = finalPreferences.autoFilterDelay;
        gridConfig.enableColResize = finalPreferences.enableColResize;
        gridConfig.useModal = finalPreferences.useModal;
        gridConfig.passCurrentDataSource = finalPreferences.passCurrentDataSource;
        gridConfig.itemDisplayName = gridPrefHiearchy.itemMetaData.Display;
        gridConfig.deleteConfirmTitle = finalPreferences.deleteConfirmTitle;
        gridConfig.deleteConfirmMessage = finalPreferences.deleteConfigMessage;
        //gridConfig.rowHeight = finalPreferences.gridStyle?.rowHeight || finalPreferences.rowHeight;
        gridConfig.showFooter = finalPreferences.showFooter;
        gridConfig.loadTotalRowCount = finalPreferences.loadTotalRowCount;
        // Add security to the add button
        gridConfig.hideAdd = finalPreferences.hideAdd || !gridPrefHiearchy.itemSecurity.CanCreate;
        gridConfig.hideRefresh = finalPreferences.hideRefresh;
        gridConfig.hideExport = finalPreferences.hideExport;
        gridConfig.allowRowSelect = finalPreferences.allowRowSelect;
        gridConfig.useCheckboxSelection = finalPreferences.useCheckboxSelection;
        gridConfig.gridStyle = finalPreferences.gridStyle;
        finalPreferences.isReadOnly = readOnly;
        if (gridPrefHiearchy.itemMetaData.IsView) {
            finalPreferences.isReadOnly = true;
        }
        if (finalPreferences.isReadOnly) {
            gridConfig.hideAdd = true;
        }
        this.setupGridViews(gridConfig, gridPrefHiearchy, finalPreferences, gridPrefHiearchy.resolvedContext, initialViewKey);
        if (gridConfig.selectedView) {
            gridConfig.columnDefs = gridConfig.selectedView.columnDefs;
            gridConfig.filters = gridConfig.selectedView.gridViewPreferences.filters;
            gridConfig.filterTilesConfig = gridConfig.selectedView.gridViewPreferences.filterTilesConfig;
        }
        return gridConfig;
    }
    showMissingPkWarning(itemName) {
        this.dwMessagingService.showMessage({
            messageHeading: `Warning ${itemName} missing Primary Key`,
            messageBody: `${itemName} is missing a Primary Key Attribute so records cannot be viewed.`,
            allowClose: true,
            severity: DwMessageSeverity.warning,
            forceClose: true,
        });
    }
    updateColumnDefs(gridColumnDefs, gridPreferences) {
        const newGridColumnDefs = [];
        for (const columnDef of gridColumnDefs) {
            const columnPref = gridPreferences.find(cp => cp.field == columnDef.key);
            if (columnPref) {
                columnDef.columnIndex = columnPref.columnIndex;
                columnDef.hide = columnPref.hide;
                columnDef.width = columnPref.width;
                columnDef.pinned = columnPref.pinned;
                columnDef.wrapText = columnPref.wrapText;
                columnDef.sort = columnPref.sort;
                columnDef.sortOrder = columnPref.sortOrder;
                columnDef.useFlex = columnPref.useFlex;
                columnDef.flex = columnPref.flex;
                columnDef.minWidth = columnPref.minWidth;
                if (columnPref.label) {
                    columnDef.headerName = columnPref.label;
                }
                newGridColumnDefs.push(columnDef);
            }
        }
        return newGridColumnDefs;
    }
    setupGridViews(gridConfig, gridPrefHierarchy, gridPreferences, resolvedContext, initialViewKey = null) {
        gridConfig.views = [];
        const { itemMetaData, queryMetaData } = gridPrefHierarchy;
        // Setup a default view if no views exist
        if (!gridPreferences.views || gridPreferences.views.length === 0) {
            // Create a default view
            gridConfig.showViews = false;
            const defaultQueryMetadata = queryMetaData.find(qmd => qmd.MetaDataQueryId == 0);
            gridPreferences.columnPreferences = gridPreferences.columnPreferences || this.buildDefaultColumnPreferences(defaultQueryMetadata, gridPreferences);
            const defaultGridViewPref = this.buildDefaultGridViewPreferene(itemMetaData, gridPreferences, gridPreferences.columnPreferences);
            // Add default view to the array
            gridPreferences.views = [defaultGridViewPref];
        }
        // Process existing views
        for (const gridViewPref of gridPreferences.views) {
            let viewQueryMetaData;
            if (gridViewPref.metaDataQueryMeaning) {
                viewQueryMetaData = queryMetaData.find(qmd => qmd.QueryMeaning == gridViewPref.metaDataQueryMeaning);
            }
            else {
                if (gridViewPref.query) {
                    const viewKey = gridViewPref.key || gridPreferences.views.indexOf(gridViewPref).toString();
                    const allMatches = queryMetaData.filter(qmd => qmd.UniqueIdentifier == viewKey);
                    if (allMatches.length == 1) {
                        viewQueryMetaData = allMatches[0];
                    }
                    else {
                        // if we have more than one match, then we need to match our specific query
                        for (var qmd of queryMetaData) {
                            if (areEqual(qmd.DataQuery, gridViewPref.query)) {
                                viewQueryMetaData = qmd;
                                break;
                            }
                        }
                    }
                    if (!viewQueryMetaData) {
                        viewQueryMetaData = allMatches[0];
                    }
                }
                else {
                    viewQueryMetaData = queryMetaData.find(qmd => qmd.MetaDataQueryId === 0);
                }
            }
            if (!viewQueryMetaData) {
                console.warn(`SetupGridViews - can't find query meta data for query meaning ${gridViewPref.metaDataQueryMeaning}`);
                viewQueryMetaData = queryMetaData[0];
            }
            const gridViewConfig = this.addGridViewConfig(gridConfig.views, gridPreferences, viewQueryMetaData, gridViewPref, gridPrefHierarchy, gridViewPref.order, resolvedContext);
            if (gridViewPref === null || gridViewPref === void 0 ? void 0 : gridViewPref.isDefault) {
                gridConfig.selectedView = gridViewConfig;
            }
        }
        if (gridConfig.views.length == 0) {
            gridConfig.canAccess = false;
            const securityMessages = new DwSecurityMessages();
            gridConfig.accessErrorMessage = securityMessages.NoAccessToViews;
            return;
        }
        if (initialViewKey) {
            const initialView = gridConfig.views.find(v => v.key === initialViewKey);
            if (initialView) {
                gridConfig.selectedView = initialView;
            }
        }
        if (!gridConfig.selectedView) {
            // Use the first view is the selected view doesn't exists
            gridConfig.selectedView = gridConfig.views[0];
        }
    }
    addGridViewConfig(views, gridPreferences, queryMetaData, gridViewPref, gridPrefHierarchy, order, resolvedContext) {
        var _a;
        let query;
        if (gridViewPref.requireAuthentication && gridViewPref.permissionMeaning) {
            // Check if user has permission to see this view
            if (!this.dwSecurityUserService.securityState.isAuthenticated) {
                return null;
            }
            if (!this.dwSecurityUserService.hasPermission(gridViewPref.permissionMeaning)) {
                return null;
            }
        }
        // Add new visible expression to hide views (Added 1-20-2023)
        if (!this.dwExpressionService.isEmptyExpressionGroupItem(gridViewPref.viewVisisbleExpression)) {
            const visibleResult = this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(gridViewPref.viewVisisbleExpression, null, resolvedContext);
            if (!visibleResult) {
                return null;
            }
        }
        if ((_a = gridViewPref.defaults) === null || _a === void 0 ? void 0 : _a.useDefaults) {
            // Fix: Change to pass in view preferences instead of views[], since a view might use defaults from a grid that the current user doesn't have access to see
            gridViewPref = this.setGridViewDefaults(gridViewPref, gridPreferences.views);
        }
        if (!gridViewPref.metaDataQueryMeaning) {
            if (gridViewPref.query) {
                query = this.cloneQuery(gridViewPref.query);
            }
            else {
                query = gridViewPref.query || new DwQuery(queryMetaData.RootItem);
            }
            if (gridPreferences.showDisplayProperties) {
                query.getFieldSettings().LoadAllLookupDisplayFields = true;
            }
        }
        else {
            query = this.cloneQuery(queryMetaData.DataQuery);
        }
        var queryBuilder = new DwQueryBuilder(query);
        if (gridViewPref.distinctRowsOnly) {
            queryBuilder.setDistinct(true);
        }
        const includeFieldList = [];
        const columnDefs = this.buildColumnDefs(queryMetaData, gridPreferences, gridViewPref, gridPrefHierarchy.itemSecurity, includeFieldList);
        // Default export query to null (so it will just use the regular query) _NO LONGER USED
        // TODO: Clean up since export query now is retrieved from the data source so it can include the current filters
        let exportQuery;
        if (!gridViewPref.includeAllFields) { // } && !gridViewPref.metaDataQueryMeaning) {
            // Create an export query prior to limiting the fields
            exportQuery = this.cloneQuery(query);
            queryBuilder.getFieldSettings().IncludeRootItemFields = false;
            queryBuilder.clearAllFields();
            // Moved to query builder
            // const qh = new DwQueryHelper();
            // // Clear all the fields including relations
            // qh.clearAllFields(queryBuilder.query);
            queryBuilder.AddFields(includeFieldList);
        }
        if (!gridViewPref.exportOnlyDisplayedColumns && gridViewPref.exportOnlyDisplayedColumns !== false) {
            gridViewPref.exportOnlyDisplayedColumns = true;
        }
        const gridViewConfig = {
            display: gridViewPref.display,
            order: order,
            key: gridViewPref.key,
            columnDefs: columnDefs,
            gridViewPreferences: gridViewPref,
            query: query,
            queryMetaData: queryMetaData,
            exportQuery: exportQuery,
            exportOnlyDisplayedColumns: gridViewPref.exportOnlyDisplayedColumns,
            actionPreferences: this.dwMetaDataGridActionService.buildFinalActionPreferences(gridViewPref, gridPreferences, gridPrefHierarchy.itemSecurity, gridPrefHierarchy.resolvedContext)
        };
        views.push(gridViewConfig);
        return gridViewConfig;
    }
    setGridViewDefaults(gridViewPref, views) {
        const defaultOptions = gridViewPref.defaults || {};
        const defaultsView = views.find(v => v.key == defaultOptions.defaultViewKey);
        if (!defaultOptions.useDefaults || !defaultsView) {
            return gridViewPref;
        }
        const newGridViewPref = deepCopy(gridViewPref);
        // Copy corresponding items
        if (defaultOptions.useAll || defaultOptions.useColumns) {
            newGridViewPref.columnPreferences = deepCopy(defaultsView.columnPreferences);
        }
        if (defaultOptions.useAll || defaultOptions.useFilters) {
            newGridViewPref.filters = deepCopy(defaultsView.filters);
        }
        if (defaultOptions.useAll || defaultOptions.useFilterTiles) {
            newGridViewPref.useFilterTiles = defaultsView.useFilterTiles;
            newGridViewPref.filterTilesConfig = deepCopy(defaultsView.filterTilesConfig);
        }
        if (defaultOptions.useAll || defaultOptions.useActions) {
            newGridViewPref.actionPreferences = deepCopy(defaultsView.actionPreferences);
            newGridViewPref.useCustomActions = defaultsView.useCustomActions;
        }
        if (defaultOptions.useAll || defaultOptions.useExport) {
            newGridViewPref.useCustomExport = defaultsView.useCustomExport;
            newGridViewPref.exportOnlyDisplayedColumns = defaultsView.exportOnlyDisplayedColumns;
            newGridViewPref.exportConfig = deepCopy(defaultsView.exportConfig);
        }
        return newGridViewPref;
    }
    cloneQuery(query) {
        const newQuery = new DwQuery(query.RootTable);
        const clonedQuery = deepCopy(query);
        return Object.assign(newQuery, clonedQuery);
    }
    buildDefaultGridViewPreferene(itemMetaData, gridPreferences, columnPreferences) {
        const gridViewPreferences = {
            display: 'Default',
            key: 'default',
            columnPreferences: gridPreferences.columnPreferences,
            filters: null,
            item: itemMetaData.UniqueItemName,
            actionPreferences: {},
            dataSourceName: null,
            iconCss: null,
            metaDataQueryMeaning: null,
            useDefaultColumns: true,
            order: 1,
            isDefault: true
        };
        return gridViewPreferences;
    }
    convertColumnDefsToColumnPrefs(columnDefs) {
        const columnPrefs = [];
        for (let columnDef of columnDefs) {
            const columnPref = {
                columnIndex: columnDef.columnIndex,
                field: columnDef.field
            };
            // Change lookups back to the core field
            if (columnDef.field && columnDef.field != columnDef.key) {
                columnPref.field = columnDef.key;
            }
            columnPrefs.push(columnPref);
        }
        return columnPrefs;
    }
    updateColumnPrefs(existingColumnPreferences, updatedColumnPrefereces) {
        const newColumnPrefs = [];
        existingColumnPreferences = existingColumnPreferences || [];
        const excludedColumns = [];
        let hasChanges = false;
        for (const updatedColumnPref of updatedColumnPrefereces) {
            const key = this.getColumnKey(updatedColumnPref);
            const existingColumnPref = existingColumnPreferences.find(cp => cp.field == updatedColumnPref.field || `${cp.field}Display` == updatedColumnPref.field || this.getColumnKey(cp) == key);
            if (existingColumnPref) {
                const newColumnPref = Object.assign(Object.assign({}, existingColumnPref), updatedColumnPref);
                newColumnPref.field = existingColumnPref.field;
                newColumnPref.sort = updatedColumnPref.sort;
                newColumnPref.pinned = updatedColumnPref.pinned;
                //console.log(`Updating column preference for ${key} - ${updatedColumnPref.field}`);
                // Turn off flex if the width is updated (allows easy override for sized columns)
                // if (newColumnPref.width != existingColumnPref.width) {
                //     newColumnPref.useFlex = false;
                // }
                if (updatedColumnPref.sort) {
                    newColumnPref.sortOrder = newColumnPref.sortOrder || 0;
                }
                else {
                    newColumnPref.sortOrder = null;
                }
                // Don't update it because the updateColumnPref might be null which overrides the previous setting
                if (updatedColumnPref.wrapText === true || updatedColumnPref.wrapText === false) {
                    newColumnPref.wrapText = updatedColumnPref.wrapText;
                }
                if (areEqual(existingColumnPref, newColumnPref)) {
                    newColumnPrefs.push(Object.assign({}, existingColumnPref));
                }
                else {
                    hasChanges = true;
                    newColumnPrefs.push(newColumnPref);
                }
            }
            else {
                if ((updatedColumnPref === null || updatedColumnPref === void 0 ? void 0 : updatedColumnPref.field) !== 'editColumn') {
                    excludedColumns.push(updatedColumnPref);
                    console.log(`Column with key ${key} not found when updating column preferences`);
                }
            }
        }
        return {
            hasChanges: hasChanges,
            columns: newColumnPrefs
        };
    }
    updateViewDefaultColumns(gridConfig, selectedView, updatedColumnPreferences, updatedColumnDefs) {
        if (!hasDefaultColumns(selectedView.gridViewPreferences.defaults)) {
            return;
        }
        const defaultView = gridConfig.views.find(v => v.key == selectedView.gridViewPreferences.defaults.defaultViewKey);
        if (!defaultView) {
            return;
        }
        // update default view columns
        //defaultView.gridViewPreferences.columnPreferences = updatedColumnPreferences;
        defaultView.columnDefs = updatedColumnDefs;
        for (let view of gridConfig.views) {
            if (hasDefaultColumns(view.gridViewPreferences.defaults) && view.gridViewPreferences.defaults.defaultViewKey == defaultView.key) {
                //view.gridViewPreferences.columnPreferences = updatedColumnPreferences;
                view.columnDefs = updatedColumnDefs;
            }
        }
    }
    getGridViewPreference(gridViewConfigs, viewConfigKey) {
        const gridViewUiConfig = gridViewConfigs.find(r => r.ConfigKey === viewConfigKey);
        if (gridViewUiConfig) {
            const gridViewPref = JSON.parse(gridViewUiConfig.ConfigJson);
            return gridViewPref;
        }
    }
    buildColumnDefs(queryMetaData, gridPreferences, viewPreferences, itemSecurity, includeFieldList) {
        var _a, _b, _c, _d;
        let gridColumns = [];
        let columnPreferences = viewPreferences === null || viewPreferences === void 0 ? void 0 : viewPreferences.columnPreferences;
        let hasColumns = true;
        if (!columnPreferences || columnPreferences.length === 0) {
            hasColumns = false;
            columnPreferences = this.buildDefaultColumnPreferences(queryMetaData, gridPreferences);
        }
        const customColumnDefs = this.dwUiConfigRegistryService.getMdRegisteredItems(DwUiRegistryType.gridColumn, queryMetaData.RootItem, 
        // Only include column types that don't require an attribute
        item => !item.requireAttr);
        const excludedColumns = [];
        for (let columnPref of columnPreferences) {
            const queryAttr = (_a = queryMetaData === null || queryMetaData === void 0 ? void 0 : queryMetaData.Attributes) === null || _a === void 0 ? void 0 : _a.find(a => { var _a, _b, _c, _d; return ((_a = a.AttributeName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = columnPref === null || columnPref === void 0 ? void 0 : columnPref.field) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = a.DisplayAttributeName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == ((_d = columnPref.field) === null || _d === void 0 ? void 0 : _d.toUpperCase()); });
            const altSortQueryAttr = (_b = queryMetaData === null || queryMetaData === void 0 ? void 0 : queryMetaData.Attributes) === null || _b === void 0 ? void 0 : _b.find(a => { var _a, _b, _c, _d; return ((_a = a.AttributeName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = columnPref === null || columnPref === void 0 ? void 0 : columnPref.alternateSortField) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = a.DisplayAttributeName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == ((_d = columnPref === null || columnPref === void 0 ? void 0 : columnPref.alternateSortField) === null || _d === void 0 ? void 0 : _d.toUpperCase()); });
            if (altSortQueryAttr) {
                // We need to include any alt sorting fields in the include fields, otherwise distinct queries will fail
                const altSortField = new DwField();
                altSortField.FullFieldName = altSortQueryAttr.AttributeName;
                altSortField.RelationName = altSortQueryAttr.RelationPrefix;
                includeFieldList.push(altSortField);
            }
            if (queryAttr) {
                const altSortQueryAttr = (_c = queryMetaData === null || queryMetaData === void 0 ? void 0 : queryMetaData.Attributes) === null || _c === void 0 ? void 0 : _c.find(a => { var _a, _b, _c, _d; return ((_a = a.AttributeName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = columnPref === null || columnPref === void 0 ? void 0 : columnPref.alternateSortField) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = a.DisplayAttributeName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == ((_d = columnPref === null || columnPref === void 0 ? void 0 : columnPref.alternateSortField) === null || _d === void 0 ? void 0 : _d.toUpperCase()); });
                let columnDef = this.buildColumnDef(queryAttr, altSortQueryAttr, gridPreferences, columnPref, hasColumns, itemSecurity, viewPreferences === null || viewPreferences === void 0 ? void 0 : viewPreferences.inlineEditEnabled);
                if (columnDef) {
                    const field = new DwField();
                    field.FullFieldName = queryAttr.AttributeName;
                    field.RelationName = queryAttr.RelationPrefix;
                    includeFieldList.push(field);
                    gridColumns.push(columnDef);
                    continue;
                }
                /* else {
                    excludedColumns.push(columnPref);
                } */
            }
            else {
                // Add custom column types (since these won't always have a query attribute)
                if (columnPref.columnRendererKey) {
                    const customColumnDef = customColumnDefs.find(cd => cd.keyName == columnPref.columnRendererKey);
                    if (customColumnDef) {
                        let columnDef = this.buildCustomColumnDef(gridPreferences, columnPref, hasColumns, itemSecurity, altSortQueryAttr);
                        if (columnDef) {
                            gridColumns.push(columnDef);
                            continue;
                        }
                    }
                }
            }
            // If we're here, the column wasn't added
            excludedColumns.push(columnPref);
        }
        // Add the key field if it isn't included in the field list
        const keyAttr = (_d = queryMetaData === null || queryMetaData === void 0 ? void 0 : queryMetaData.Attributes) === null || _d === void 0 ? void 0 : _d.find(a => { var _a; return (_a = a.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey; });
        if (keyAttr) {
            const existingKeyField = includeFieldList.find(a => a.FieldName == keyAttr.AttributeName);
            if (!existingKeyField) {
                const field = new DwField();
                field.FullFieldName = keyAttr.AttributeName;
                field.RelationName = keyAttr.RelationPrefix;
                includeFieldList.push(field);
            }
        }
        // Sort by columnIndex
        gridColumns = gridColumns.sort((a, b) => { return a.columnIndex - b.columnIndex; });
        return gridColumns;
    }
    buildDefaultColumnPreferences(queryMetaData, gridPreferences) {
        const columnPrefs = [];
        let index = 0;
        for (const queryAttr of queryMetaData.Attributes) {
            index++;
            if (!this.ignoreAttr(queryAttr.Attribute, gridPreferences)) {
                columnPrefs.push({
                    columnIndex: index,
                    field: queryAttr.AttributeName
                });
            }
        }
        return columnPrefs;
    }
    buildColumnDef(queryAttr, altSortQueryAttr, gridPreferences, gridColumnPref, hasColumns, itemSecurity, inlineEditEnabled) {
        // First, let's check security to make sure the column should be displayed
        if (!this.canAccessColumn(gridColumnPref.securityConfig, itemSecurity)) {
            return null;
        }
        let gridColumnDef = new DwMetaDataGridColumnDef();
        let attr = queryAttr.Attribute;
        if (!attr) {
            // If no attribute, this means it's an special field type (expression, template, aggregate or custom)
            attr = {
                AttributeName: queryAttr.AttributeName,
                AttributeType: queryAttr.AttributeType,
                Display: queryAttr.AttributeDisplay
            };
        }
        // Exclude JSON columns
        if (attr.AttributeType == DwAttributeType.JSON) {
            return null;
        }
        gridColumnDef.headerName = queryAttr.AttributeDisplay;
        // Override the header based on configuration
        if (gridColumnPref && gridColumnPref.label) {
            gridColumnDef.headerName = gridColumnPref.label;
        }
        gridColumnDef.field = queryAttr.AttributeName;
        // Determine if the display properties should be displayed
        if (gridPreferences.showDisplayProperties && (!gridColumnPref || !gridColumnPref.showRawValue)) {
            gridColumnDef.field = queryAttr.DisplayAttributeName;
        }
        gridColumnDef.key = this.getColumnKey(gridColumnPref);
        gridColumnDef.columnFormatType = this.convertColumnFormatType(queryAttr, attr, gridPreferences);
        gridColumnDef.columnRendererKey = gridColumnPref.columnRendererKey || defaultGridColumnRenderer;
        gridColumnDef.columnRendererConfig = gridColumnPref.columnRendererConfig;
        gridColumnDef.use24HourTime = this.uiMetaDataConfig.use24HourTime;
        gridColumnDef.decimals = attr === null || attr === void 0 ? void 0 : attr.Decimals;
        gridColumnDef.conditionalFieldClasses = gridColumnPref.conditionalFieldClasses;
        // Perform security checks and set action defaults - will return null if actions are not valid
        if (gridColumnPref.useAction) {
            gridColumnDef.actionPreference = this.dwMetaDataGridActionService.buildFinalActionPreference(gridColumnPref.actionPreference, itemSecurity);
        }
        if (gridColumnPref) {
            gridColumnDef.columnIndex = gridColumnPref.columnIndex;
            gridColumnDef.hide = gridColumnPref.hide;
            gridColumnDef.pinned = gridColumnPref.pinned;
            gridColumnDef.wrapText = gridColumnPref.wrapText;
            gridColumnDef.sort = gridColumnPref.sort;
            gridColumnDef.sortOrder = gridColumnPref.sortOrder;
            gridColumnDef.disabledSort = gridColumnPref.disabledSort;
            gridColumnDef.width = gridColumnPref.width;
            gridColumnDef.useFlex = gridColumnPref.useFlex;
            gridColumnDef.flex = gridColumnPref.flex;
            gridColumnDef.minWidth = gridColumnPref.minWidth;
            const sortAttr = altSortQueryAttr || queryAttr;
            gridColumnDef.fullSortField = sortAttr.DisplayAttributeName;
            // Use relation prefix to use in sort field (otherwise we don't know which relation the sorting is for)
            if (sortAttr.RelationPrefix) {
                gridColumnDef.fullSortField = `${sortAttr.RelationPrefix}.${sortAttr.DisplayAttributeName}`;
                gridColumnDef.relationPrefix = sortAttr.RelationPrefix;
            }
        }
        else {
            if (hasColumns) {
                gridColumnDef.hide = true;
                gridColumnDef.columnIndex = 99;
            }
        }
        gridColumnDef.isEditable = inlineEditEnabled && !(gridColumnPref === null || gridColumnPref === void 0 ? void 0 : gridColumnPref.inlineEditDisabled) && !attr.IsKey;
        if (gridColumnDef.isEditable) {
            gridColumnDef.editableFieldDef = this.buildEditableColumnFieldDef(queryAttr, attr, gridPreferences, gridColumnPref);
        }
        return gridColumnDef;
    }
    buildEditableColumnFieldDef(queryAttr, attr, gridPreferences, gridColumnPref) {
        if (!queryAttr || !attr)
            return;
        const field = new DwFormFieldConfig();
        field.attr = attr;
        field.attrName = queryAttr.AttributeName;
        field.hideLabel = true;
        field.label = '';
        field.controlType = attr.MetaDataControlTypeId;
        return field;
    }
    //private buildColumnEditableFieldDef()
    buildCustomColumnDef(gridPreferences, gridColumnPref, hasColumns, itemSecurity, altSortQueryAttr) {
        // First, let's check security to make sure the column should be displayed
        if (!this.canAccessColumn(gridColumnPref.securityConfig, itemSecurity)) {
            return null;
        }
        let gridColumnDef = new DwMetaDataGridColumnDef();
        // Override the header based on configuration
        if (gridColumnPref && gridColumnPref.label) {
            gridColumnDef.headerName = gridColumnPref.label;
        }
        gridColumnDef.columnRendererKey = gridColumnPref.columnRendererKey || defaultGridColumnRenderer;
        gridColumnDef.columnRendererConfig = gridColumnPref.columnRendererConfig;
        gridColumnDef.use24HourTime = this.uiMetaDataConfig.use24HourTime;
        gridColumnDef.key = this.getColumnKey(gridColumnPref);
        gridColumnDef.conditionalFieldClasses = gridColumnPref.conditionalFieldClasses;
        // Perform security checks and set action defaults - will return null if actions are not valid
        if (gridColumnPref.useAction) {
            gridColumnDef.actionPreference = this.dwMetaDataGridActionService.buildFinalActionPreference(gridColumnPref.actionPreference, itemSecurity);
        }
        if (gridColumnPref) {
            gridColumnDef.columnIndex = gridColumnPref.columnIndex;
            gridColumnDef.hide = gridColumnPref.hide;
            gridColumnDef.width = gridColumnPref.width;
            gridColumnDef.pinned = gridColumnPref.pinned;
            gridColumnDef.wrapText = gridColumnPref.wrapText;
            gridColumnDef.sort = gridColumnPref.sort;
            gridColumnDef.sortOrder = gridColumnPref.sortOrder;
            gridColumnDef.disabledSort = gridColumnPref.disabledSort;
        }
        else {
            if (hasColumns) {
                gridColumnDef.hide = true;
                gridColumnDef.columnIndex = 99;
            }
        }
        if (altSortQueryAttr) {
            gridColumnDef.fullSortField = altSortQueryAttr.DisplayAttributeName;
        }
        return gridColumnDef;
    }
    getColumnKey(columnPref) {
        if (columnPref === null || columnPref === void 0 ? void 0 : columnPref.field) {
            return columnPref.field;
        }
        if (columnPref === null || columnPref === void 0 ? void 0 : columnPref.columnRendererKey) {
            return `${columnPref.columnRendererKey}_${columnPref.label}`;
        }
        return 'unknown';
    }
    canAccessColumn(securityConfig, itemSecurity) {
        const simpleItemSecurity = convertItemSecurity(itemSecurity);
        return this.dwSecurityCheckService.hasPermissions(securityConfig, simpleItemSecurity);
    }
    isDisplayField(gridPreferences, attr, fieldName) {
        if (gridPreferences.showDisplayProperties && (attr.MetaDataLookupId || attr.CodeSetId)) {
            if (fieldName.indexOf('Display')) {
                return true;
            }
        }
        return false;
    }
    getDisplayFieldAttrName(fieldName) {
        return fieldName.replace('Display', '');
    }
    ignoreAttr(attr, gridPreferences) {
        if (!attr) {
            return false;
        }
        if (!gridPreferences) {
            return false;
        }
        if (gridPreferences.hidePrimaryKey && attr.IsKey) {
            return true;
        }
        if (gridPreferences.ignoreAttributes && gridPreferences.ignoreAttributes.length > 0) {
            return gridPreferences.ignoreAttributes.indexOf(attr.AttributeName) >= 0;
        }
        if (attr.AttributeType == DwAttributeType.JSON) {
            return true;
        }
        return false;
    }
    convertColumnFormatType(queryAttribute, attr, gridPreferences) {
        const attrType = queryAttribute.AttributeType;
        let useGmtDateTime = this.uiMetaDataConfig.useGmtDateTime;
        if (attr.UseGmtDateTime !== null && attr.UseGmtDateTime !== undefined) {
            useGmtDateTime = attr.UseGmtDateTime;
        }
        switch (attrType) {
            case (DwAttributeType.Date):
                return DwColumnFormatType.date;
            case (DwAttributeType.DateTime):
                if (useGmtDateTime)
                    return DwColumnFormatType.datetimeLocal;
                return DwColumnFormatType.datetime;
            case (DwAttributeType.YesNo):
                // Use a default overridable value (since this could be Yes/No, True/False or a checkmark column type)
                return gridPreferences.boolColumnType;
        }
        if (attr.MetaDataControlTypeId == DwControlType.CurrencyTextBox) {
            return DwColumnFormatType.money;
        }
        if (attr.MetaDataControlTypeId == DwControlType.NumericTextBox && attr.Decimals > 0) {
            return DwColumnFormatType.decimal;
        }
        return DwColumnFormatType.standard;
    }
}
DwMetaDataGridService.ɵfac = function DwMetaDataGridService_Factory(t) { return new (t || DwMetaDataGridService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwMetaDataRoutingService), ɵngcc0.ɵɵinject(DwUiConfigService), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwMessagingService), ɵngcc0.ɵɵinject(DwMetaDataGridActionService), ɵngcc0.ɵɵinject(DwActionConfigService), ɵngcc0.ɵɵinject(DwSecurityCheckService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwExpressionService)); };
DwMetaDataGridService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataGridService, factory: DwMetaDataGridService.ɵfac });
DwMetaDataGridService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataRoutingService },
    { type: DwUiConfigService },
    { type: DwCacheService },
    { type: DwMessagingService },
    { type: DwMetaDataGridActionService },
    { type: DwActionConfigService },
    { type: DwSecurityCheckService },
    { type: DwUiConfigRegistryService },
    { type: DwSecurityUserService },
    { type: DwContextService },
    { type: DwExpressionService }
];

class DwMdGridContextInfo {
}
DwMdGridContextInfo.GRID_CONTEXT_NAME = 'mdGridContext';

class DwMetadataGridConfigViewsComponent {
    constructor(dwMetaDataService, dwMetaDataGridService, dwOrmDataService, dwMetaDataGridActionService, dwUiConfigRegistryService, dwContextService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetaDataGridService = dwMetaDataGridService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataGridActionService = dwMetaDataGridActionService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwContextService = dwContextService;
        this.itemMetaDataList = {};
        this.tabIndex = 0;
        this.setupComplete = false;
        this.queries = [];
    }
    buttonClick(buttonConfig) {
        // Update preferences to use final column index
        for (let i = 0; i < this.items.length; i++) {
            let viewPref = this.items[i];
            viewPref.order = i;
        }
        let result = new DwModalResult();
        result.closeModal = true;
        result.cancelled = buttonConfig.isCancel;
        result.data = {
            views: this.items,
            gridPreferences: this.gridPreferences
        };
        return of(result);
    }
    ngOnInit() {
        this.items = this.modalConfig.data.views || [];
        this.gridPreferences = this.modalConfig.data.gridPreferences;
        this.contextDefs = this.getContextDefinitions();
        this.designerState = this.modalConfig.data.designerState;
        this.buildCopyMenuActions();
        this.configContext = {
            itemName: this.modalConfig.data.itemName,
            contextNames: this.gridPreferences.contextNames
        };
        this.dataSources = this.dwUiConfigRegistryService.getRegisteredDataSources(this.modalConfig.data.itemName);
        this.dwMetaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMetaData => {
            this.itemMetaDataList[this.itemName] = itemMetaData;
            this.loadQueries(itemMetaData);
            this.setupControl();
            this.setupInitialState(this.modalConfig.data.designerState);
        });
    }
    setupInitialState(designerState) {
        var _a, _b, _c, _d;
        if (!designerState) {
            return;
        }
        // Set default View
        if (designerState.sectionKey) {
            const selectedItem = this.items.find(i => i.key == designerState.sectionKey);
            if (selectedItem) {
                this.selectedItem = selectedItem;
            }
        }
        this.tabIndex = 0;
        let setToDefaultsView = false;
        switch (designerState.detailKey) {
            case 'filter':
                this.tabIndex = 1;
                setToDefaultsView = ((_a = this.selectedItem.defaults) === null || _a === void 0 ? void 0 : _a.useDefaults) && ((_b = this.selectedItem.defaults) === null || _b === void 0 ? void 0 : _b.useFilters);
                const filterConfig = designerState.additionalInfo;
                this.initialFilterKey = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.filterDisplay;
                break;
            case 'filterTile':
                this.tabIndex = 2;
                setToDefaultsView = ((_c = this.selectedItem.defaults) === null || _c === void 0 ? void 0 : _c.useDefaults) && ((_d = this.selectedItem.defaults) === null || _d === void 0 ? void 0 : _d.useFilterTiles);
                const filterTileConfig = designerState.additionalInfo;
                this.initialFilterTileKey = filterTileConfig === null || filterTileConfig === void 0 ? void 0 : filterTileConfig.tileKey;
                break;
        }
        // if using defaults, switch to the view which contains the defaults
        if (setToDefaultsView) {
            const defaultView = this.items.find(i => i.key == this.selectedItem.defaults.defaultViewKey);
            if (defaultView) {
                this.selectedItem = defaultView;
            }
        }
    }
    getContextDefinitions() {
        const contextDefinitions = this.dwContextService.contextDefinitions.filter(contextDef => (contextDef.isGlobal || contextDef.contextName == DwMdGridContextInfo.GRID_CONTEXT_NAME) && contextDef.contextName != DwMdFormContextInfo.FORM_CONTEXT_NAME);
        return contextDefinitions;
    }
    updateContextNames() {
        this.configContext.contextNames = this.gridPreferences.contextNames;
    }
    buildMenuActions() {
        const menuItems = [{
                label: 'New View',
                icon: 'fa fa-plus',
                command: (event) => {
                    this.addItem(false, false);
                },
            },
            {
                label: 'Copy with Defaults',
                icon: 'far fa-copy',
                title: 'Sets the defaults to use all, then you can change just what needs to be different',
                command: (event) => {
                    this.addItem(true, true);
                },
            },
            {
                label: 'Copy',
                icon: 'fa fa-copy',
                title: 'Copy exact settings of source view',
                command: (event) => {
                    this.addItem(true, false);
                },
            },
        ];
        if (this.selectedItem && this.items.length > 1) {
            menuItems.push({
                label: 'Delete View',
                icon: 'fa fa-trash',
                command: (event) => {
                    this.removeItem(this.selectedItem);
                },
            });
        }
        if (this.selectedItem && !this.selectedItem.isDefault) {
            menuItems.push({
                label: 'Make Initial View',
                icon: 'fa fa-star yellow',
                command: (event) => {
                    this.setDefault(this.selectedItem);
                },
            });
        }
        if (this.selectedItem && this.items.length > 0) {
            const selectedIndex = this.items.indexOf(this.selectedItem);
            // Add a divider
            menuItems.push({ separator: true });
            if (selectedIndex > 0) {
                menuItems.push({
                    label: 'Move Up',
                    icon: 'fa fa-arrow-up',
                    command: (event) => {
                        this.moveUp(this.selectedItem);
                    },
                });
            }
            if (selectedIndex < this.items.length - 1) {
                menuItems.push({
                    label: 'Move Down',
                    icon: 'fa fa-arrow-down',
                    command: (event) => {
                        this.moveDown(this.selectedItem);
                    },
                });
            }
        }
        this.viewMenuItems = menuItems;
    }
    buildCopyMenuActions() {
        const menuItems = [
            {
                label: 'Copy All',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ all: true });
                },
            },
            {
                label: 'Copy Non Defaults',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ nonDefaults: true });
                },
            },
            {
                label: 'Copy Columns',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ columns: true });
                },
            },
            {
                label: 'Copy Filters',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ filters: true });
                },
            },
            {
                label: 'Copy Filter Tiles',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ filterTiles: true });
                },
            },
            {
                label: 'Copy Actions',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ actions: true });
                },
            },
            {
                label: 'Copy Export',
                //icon: 'fa fa-plus',
                command: (event) => {
                    this.copyFrom({ export: true });
                },
            },
        ];
        this.copyDefaultsMenuItems = menuItems;
    }
    copyFrom(options) {
        const defaultsView = this.items.find(v => v.key == this.selectedItem.defaults.defaultViewKey);
        if (!defaultsView) {
            return;
        }
        if (options.nonDefaults) {
            if (this.selectedItem.defaults.useActions) {
                return;
            }
            options.columns = !this.selectedItem.defaults.useColumns;
            options.filters = !this.selectedItem.defaults.useFilters;
            options.filterTiles = !this.selectedItem.defaults.useFilterTiles;
            options.actions = !this.selectedItem.defaults.useActions;
            options.export = !this.selectedItem.defaults.useExport;
        }
        // Copy corresponding items
        if (options.all || options.columns) {
            this.selectedItem.columnPreferences = deepCopy(defaultsView.columnPreferences);
        }
        if (options.all || options.filters) {
            this.selectedItem.filters = deepCopy(defaultsView.filters);
            this.selectedItem.useFilterTiles = defaultsView.useFilterTiles;
        }
        if (options.all || options.filterTiles) {
            this.selectedItem.filterTilesConfig = deepCopy(defaultsView.filterTilesConfig);
        }
        if (options.all || options.actions) {
            this.selectedItem.actionPreferences = deepCopy(defaultsView.actionPreferences);
            this.selectedItem.useCustomActions = defaultsView.useCustomActions;
        }
        if (options.all || options.export) {
            this.selectedItem.exportConfig = deepCopy(defaultsView.exportConfig);
            this.selectedItem.useCustomExport = defaultsView.useCustomExport;
            this.selectedItem.exportOnlyDisplayedColumns = defaultsView.exportOnlyDisplayedColumns;
        }
    }
    setupControl() {
        const itemMetaData = this.itemMetaDataList[this.itemName];
        if (this.items.length == 0) {
            const defaultGridViewPref = this.dwMetaDataGridService.buildDefaultGridViewPreferene(itemMetaData, this.gridPreferences, this.gridPreferences.columnPreferences);
            this.items.push(defaultGridViewPref);
        }
        let initialView = this.items.find(v => v.key === this.modalConfig.data.selectedViewKey);
        if (!initialView) {
            initialView = this.items[0];
        }
        this.setSelectedItem(initialView);
        this.setupComplete = true;
    }
    loadQueries(itemMetaData) {
        this.dwMetaDataService.getQueries(itemMetaData.MetaDataItemId)
            .subscribe(queries => this.queries = queries);
    }
    updateDataSourceInfo() {
        // Reset the selected item so it will refresh the columns and config context
        this.setSelectedItem(this.selectedItem);
    }
    setSelectedItem(view) {
        this.selectedItem = view;
        view.columnPreferences = view.columnPreferences || [];
        view.actionPreferences = view.actionPreferences || {};
        view.defaults = view.defaults || { useDefaults: false, useAll: true, useActions: true, useColumns: true, useFilters: true, useFilterTiles: true, useExport: true };
        this.configContext = Object.assign(Object.assign({}, this.configContext), { metaDataQueryMeaning: view.metaDataQueryMeaning });
        this.buildMenuActions();
    }
    addItem(copySelected, useAllDefaults) {
        var _a;
        let configToCopy = this.selectedItem;
        if (!copySelected || !this.selectedItem) {
            configToCopy = this.items.find(v => v.isDefault);
        }
        const viewPreference = Object.assign(Object.assign({}, configToCopy), { key: this.getUniqueViewKey(), order: this.items.length, isDefault: false });
        if (!copySelected) {
            viewPreference.display = this.getUniqueViewDisplay();
        }
        else {
            viewPreference.display += ' - Copy';
        }
        if (this.items.length === 0) {
            viewPreference.isDefault = true;
        }
        else {
            if (useAllDefaults) {
                viewPreference.defaults = { defaultViewKey: configToCopy.key, useDefaults: true, useAll: true, useActions: true, useColumns: true, useFilters: true, useFilterTiles: true, useExport: true };
                // If no default key, then use the current views key
                if (((_a = configToCopy.defaults) === null || _a === void 0 ? void 0 : _a.useDefaults) && configToCopy.defaults.defaultViewKey) {
                    viewPreference.defaults.defaultViewKey = configToCopy.defaults.defaultViewKey;
                }
            }
        }
        this.items = [...this.items, deepCopy(viewPreference)];
        this.setSelectedItem(this.items[this.items.length - 1]);
        this.buildMenuActions();
    }
    getUniqueViewDisplay() {
        let index = 1;
        let display = `New View ${this.items.length + index}`;
        let existingView = this.items.find(v => v.display.toLowerCase() === display.toLowerCase());
        while (existingView != null) {
            index++;
            display = `New View ${this.items.length + index}`;
            existingView = this.items.find(v => v.display.toLowerCase() === display.toLowerCase());
        }
        return display;
    }
    getUniqueViewKey() {
        let index = 1;
        let key = `view_${this.items.length + index}`;
        let existingView = this.items.find(v => v.key.toLowerCase() === key.toLowerCase());
        while (existingView != null) {
            index++;
            key = `view_${this.items.length + index}`;
            existingView = this.items.find(v => v.key.toLowerCase() === key.toLowerCase());
        }
        return key;
    }
    removeItem(item) {
        var index = this.items.indexOf(item);
        if (index >= 0)
            this.items.splice(index, 1);
        if (this.items.length === 1) {
            this.items[0].isDefault = true;
        }
        // Make copy to update p-dropdown
        this.items = [...this.items];
        this.setSelectedItem(this.items[0]);
        this.buildMenuActions();
    }
    setDefault(item) {
        for (const view of this.items) {
            view.isDefault = false;
        }
        item.isDefault = true;
        this.buildMenuActions();
    }
    moveUp(item) {
        var index = this.items.indexOf(item);
        if (index == 0)
            return;
        let newIndex = index--;
        this.items.splice(newIndex, 0, this.items.splice(index, 1)[0]);
        // Make copy to update p-dropdown
        this.items = [...this.items];
        this.buildMenuActions();
    }
    moveDown(item) {
        var index = this.items.indexOf(item);
        if (index == this.items.length - 1)
            return;
        let newIndex = index++;
        this.items.splice(newIndex, 0, this.items.splice(index, 1)[0]);
        // Make copy to update p-dropdown
        this.items = [...this.items];
        this.buildMenuActions();
    }
    changeUseCustomActions(customValue) {
        // Any time we toggle this, we ensure that we have the default actions
        if (customValue) {
            if (!this.selectedItem.actionPreferences || isEmptyObject(this.selectedItem.actionPreferences)) {
                this.selectedItem.actionPreferences = this.dwMetaDataGridActionService.getDefaultGridActionPreferencesByMode(this.gridPreferences);
            }
        }
    }
    updateFlexColumns() {
    }
    updateActionPreferences(actionPreferences) {
        this.selectedItem.actionPreferences = actionPreferences;
    }
}
DwMetadataGridConfigViewsComponent.ɵfac = function DwMetadataGridConfigViewsComponent_Factory(t) { return new (t || DwMetadataGridConfigViewsComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridService), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridActionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwMetadataGridConfigViewsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataGridConfigViewsComponent, selectors: [["dw-dw-metadata-grid-config-views"]], viewQuery: function DwMetadataGridConfigViewsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(OrderList, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.orderList = _t.first);
    } }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], [1, "view-dropdown-container"], ["optionLabel", "display", "appendTo", "body", 3, "options", "ngModel", "ngModelChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], [1, "view-actions"], ["type", "button", "pButton", "", "icon", "fa fa-cog", 3, "click"], ["menuContainer", ""], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "popup", "model"], ["menu", ""], ["styleClass", "dw-fixed-tabs", 3, "activeIndex", "activeIndexChange", 4, "ngIf"], ["title", "Initial View", 1, "fas", "fa-star", "yellow", "hand", 3, "hidden"], ["styleClass", "dw-fixed-tabs", 3, "activeIndex", "activeIndexChange"], ["header", "Columns", 4, "ngIf"], ["header", "Filters", 4, "ngIf"], ["header", "Filter Tiles", 4, "ngIf"], ["header", "Actions", 4, "ngIf"], ["header", "Export", 4, "ngIf"], ["header", "View Properties"], ["header", "Basic Settings", 3, "selected"], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Customizations"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["header", "Data Source"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["title", "Use this to apply a filter to all filter tiles and the grid", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "item", "queryMeaning", "ngModelChange"], ["title", "Loads all fields in the table even if they aren't displayed.", 1, "fa", "fa-info-circle"], ["title", "Only include distinct rows", 1, "fa", "fa-info-circle"], ["optionLabel", "contextDisplay", "optionValue", "contextName", "display", "chip", "appendTo", "body", "baseZIndex", "2000", 3, "options", "ngModel", "ngModelChange"], ["header", "Defaults", 4, "ngIf"], ["header", "Security/Visibility"], ["title", "Use this to apply additional rules for when this view should be displayed", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "ngModelChange"], ["header", "Export Options", 4, "ngIf"], ["header", "Inline Editing Options"], ["header", "Columns"], [3, "configContext", "columns", "gridPreferences", "useColumnFlex", "inlineEditEnabled", "columnsChange"], ["header", "Filters"], ["showAdditionalTab", "true", 3, "configContext", "filters", "initialFilterKey", "filtersChange"], ["additionalTab", ""], ["header", "View Options", 3, "selected"], ["header", "Grid Filter Options", 3, "selected"], ["dwRow", "", 3, "hidden"], ["type", "number", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Filter Tiles"], [3, "configContext", "tileConfig", "initialFilterTileKey", "tileConfigChange"], ["header", "Actions"], [3, "configContext", "actionPreferencesByMode", "inlineEditEnabled", "actionPreferencesByModeChange", "actionPreferenceByModeChange"], ["header", "Export"], [3, "configContext", "exportConfig", "gridColumnPreferences", "exportConfigChange"], ["header", "Defaults"], ["dwCol", "4"], ["dwCol", "4", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["type", "button", "pButton", "", "icon", "fa fa-copy", "title", "Copy from view", 3, "click"], ["menuContainer2", ""], ["menu2", ""], [3, "ngValue", "hidden"], ["name", "permission", 3, "ngModel", "ngModelChange"], ["header", "Export Options"], ["value", "fullRow"], ["value", "individualCell"], ["value", "allRows"]], template: function DwMetadataGridConfigViewsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataGridConfigViewsComponent_div_0_Template, 17, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.setupComplete);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.PrimeTemplate, ɵngcc26.ButtonDirective, ɵngcc27.Menu, ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwExpressionPickerControlComponent, ɵngcc12.MultiSelect, DwMetadataGridConfigColumnsComponent, DwMetadataConfigFiltersComponent, ɵngcc3.NumberValueAccessor, DwMetadataFilterTilesConfigComponent, DwMetadataGridActionsConfigComponent, DwExportConfigComponent, DwSecurityPermissionSelectComponent]; }, styles: [".view-dropdown-container[_ngcontent-%COMP%]{float:left;width:calc(100% - 50px)}.view-actions[_ngcontent-%COMP%]{float:left;padding-left:4px;width:50px}"] });
DwMetadataGridConfigViewsComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataGridService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataGridActionService },
    { type: DwUiConfigRegistryService },
    { type: DwContextService }
];
DwMetadataGridConfigViewsComponent.propDecorators = {
    orderList: [{ type: ViewChild, args: [OrderList,] }]
};

function isDwGridColumnChangeEvent(event) {
    if (event && event.columnPreferences) {
        return true;
    }
    return false;
}

function isDwGridSelectedViewEvent(event) {
    if (event && event.selectedViewKey) {
        return true;
    }
    return false;
}

class DwMetaDataGridConfigWidgetComponent extends DwUiPanelWidgetBaseComponent {
    constructor(fb, dwEventService, dwModalService, dwUiConfigRegistryService, dwMetaDataService, dwMetaDataGridService, dwDesignerStateService, uiConfigService) {
        super(fb, dwDesignerStateService);
        this.dwEventService = dwEventService;
        this.dwModalService = dwModalService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetaDataGridService = dwMetaDataGridService;
        this.uiConfigService = uiConfigService;
        this.setupComplete = false;
        this.hasCustomActions = false;
        this.inMemoryUpdateCommand = 'inMemoryUpdate';
        this.setupDropdowns();
    }
    get gridPreferences() {
        return this.preferences;
    }
    get originalGridPreferences() {
        return this.originalPreferences;
    }
    get gridPreferencesHierarchy() {
        return this.preferencesHierarchy;
    }
    startConfigureSection(state) {
        if (!this.setupComplete) {
            this.initialDesignState = state;
            return;
        }
        this.configViews(state);
    }
    configSet() {
        if (!this.configKey)
            return;
        this.gridHeightModes = new DwGridHeightModeList().getEnumList();
        this.ensureViews();
        this.setupViewActions();
        const obs = [];
        this.loadMetaData().subscribe(() => {
            this.setupComplete = true;
            if (this.initialDesignState) {
                this.configViews(this.initialDesignState);
                this.initialDesignState = null;
            }
            return;
        });
        this.subscriptions.push(this.dwEventService.getEventData(DwUiConfigService.UICONFIG_EVENT_TOPIC.AdditionalDataEvent(this.configKey, DwUiConfigType.grid))
            .subscribe(eventData => {
            setTimeout(() => {
                if (isDwGridColumnChangeEvent(eventData)) {
                    this.handleGridColumnUpdate(eventData);
                }
                if (isDwGridSelectedViewEvent(eventData)) {
                    this.selectedViewKey = eventData.selectedViewKey;
                    this.setupViewActions();
                }
            }, 5);
        }));
    }
    handleGridColumnUpdate(eventData) {
        // check if these are the same as the original, if so, then we can ignore then
        var _a, _b, _c, _d;
        if (eventData.viewKey && eventData.viewKey != this.selectedViewKey) {
            this.selectedViewKey = eventData.viewKey;
        }
        // Check if the columns have changed based on the original
        if (this.originalGridPreferences) {
            const currentView = this.originalGridPreferences.views.find(v => v.key == this.selectedViewKey);
            let viewToUpdate = currentView;
            if ((currentView === null || currentView === void 0 ? void 0 : currentView.defaults) && currentView.defaults.useDefaults && currentView.defaults.defaultViewKey && (currentView.defaults.useAll || currentView.defaults.useColumns)) {
                viewToUpdate = this.originalGridPreferences.views.find(v => v.key == currentView.defaults.defaultViewKey);
                if (!viewToUpdate) {
                    viewToUpdate = currentView;
                }
            }
            if (viewToUpdate && areEqual(viewToUpdate.columnPreferences, eventData.columnPreferences)) {
                return;
            }
        }
        // Now make the change on the current view (might not be necessary since we're updating it in the grid component, but it could be a copy
        const currentView = this.gridPreferences.views.find(v => v.key == this.selectedViewKey);
        let viewToUpdate = currentView;
        if (((_a = currentView.defaults) === null || _a === void 0 ? void 0 : _a.useDefaults) && ((_b = currentView.defaults) === null || _b === void 0 ? void 0 : _b.defaultViewKey) && (((_c = currentView.defaults) === null || _c === void 0 ? void 0 : _c.useAll) || ((_d = currentView.defaults) === null || _d === void 0 ? void 0 : _d.useColumns))) {
            viewToUpdate = this.gridPreferences.views.find(v => v.key == currentView.defaults.defaultViewKey);
            if (!viewToUpdate) {
                viewToUpdate = currentView;
            }
        }
        viewToUpdate.columnPreferences = eventData.columnPreferences;
        this.gridPreferences.columnPreferences = eventData.columnPreferences;
        this.setMessage({
            messageBody: `Columns have been updated, but haven't been saved`,
            severity: DwMessageSeverity.warning
        });
    }
    loadMetaData() {
        //console.log('Loading Meta Data', this.gridPreferencesHierarchy.item);
        return this.dwMetaDataService.getMetaData(this.gridPreferencesHierarchy.item)
            .pipe(tap(itemMetaData => {
            //console.log('Loaded Meta Data', this.gridPreferencesHierarchy.item);
            this.itemMetaData = itemMetaData;
        }));
    }
    ensureViews() {
        if (!this.gridPreferences || !this.itemMetaData) {
            return;
        }
        if (!this.gridPreferences.views || this.gridPreferences.views.length == 0) {
            const defaultGridViewPref = this.dwMetaDataGridService.buildDefaultGridViewPreferene(this.itemMetaData, this.gridPreferences, this.gridPreferences.columnPreferences);
            this.gridPreferences.views = [defaultGridViewPref];
        }
        if (!this.selectedViewKey) {
            let defaultView = this.gridPreferences.views.find(v => v.isDefault);
            if (!defaultView) {
                defaultView = this.gridPreferences.views[0];
            }
            this.selectedViewKey = defaultView.key;
        }
        this.setupViewActions();
    }
    setupViewActions() {
        const selectedView = this.gridPreferences.views.find(v => v.key == this.selectedViewKey);
        this.hasCustomActions = false;
        if (selectedView && selectedView.useCustomActions) {
            this.hasCustomActions = selectedView.useCustomActions;
        }
    }
    setupEvents() {
    }
    createForm(fb) {
        const defaultValue = [null];
        return this.fb.group({
            showFilter: defaultValue,
            autoFilter: defaultValue,
            useSideFilters: defaultValue,
            showFilterOnLoad: defaultValue,
            showClearFilter: defaultValue,
            autoFilterDelay: defaultValue,
            hidePrimaryKey: defaultValue,
            showDisplayProperties: defaultValue,
            ignoreAttributes: defaultValue,
            enableSorting: true,
            useModal: defaultValue,
            hideEditButton: defaultValue,
            showViewButton: defaultValue,
            hideDeleteButton: defaultValue,
            hideAdd: defaultValue,
            hideRefresh: defaultValue,
            hideExport: defaultValue,
            allowRowSelect: defaultValue,
            useCheckboxSelection: defaultValue,
            showFooter: defaultValue,
            loadTotalRowCount: defaultValue,
            gridStyle: fb.group({
                gridStyleName: '',
                gridClass: defaultValue,
                gridStyleOverride: defaultValue,
                gridHeightMode: 'auto',
                gridHeight: defaultValue,
                gridWidth: defaultValue,
                rowHeight: defaultValue,
                headerHeight: defaultValue,
                actionColumnUseCustomWidth: false,
                actionColumnWidth: defaultValue,
            })
        });
    }
    setPreferenceDefaults(preferences) {
        if (!preferences) {
            //console.log('Grid Config - No preferences');
            return;
        }
        if (!preferences.gridStyle) {
            //console.log('Grid Config - gridStyle not set');
            preferences.gridStyle = preferences.gridStyle || {};
        }
        preferences.gridStyle.gridStyleName = preferences.gridStyle.gridStyleName || '';
        preferences.gridStyle.gridHeightMode = preferences.gridStyle.gridHeightMode || DwGridHeightMode.autoFitToScreen;
    }
    onSubmit() {
        //console.log(this.configForm.value);
    }
    setupDropdowns() {
        this.gridStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.gridStyles);
    }
    configViews(state) {
        var _a, _b;
        if ((state === null || state === void 0 ? void 0 : state.configKey) && (this.configKey != state.configKey || ((_a = this.preferencesHierarchy) === null || _a === void 0 ? void 0 : _a.configKey) != state.configKey)) {
            console.warn(`Config key ${(_b = this.preferencesHierarchy) === null || _b === void 0 ? void 0 : _b.configKey} does not match state config key ${state.configKey}`);
            return;
        }
        //let modalConfig = new DwModalConfig<DwmetaDataGridConfigModalOptions>();
        let modalConfig = new DwModalConfig();
        this.ensureViews();
        modalConfig.title = "Configure Views";
        if (this.itemMetaData) {
            modalConfig.title = `Configure Views - ${this.itemMetaData.Display}`;
        }
        modalConfig.component = DwMetadataGridConfigViewsComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalHeight = '860px';
        modalConfig.customModalWidth = '1100px';
        const inMemoryButton = {
            buttonText: 'In Memory update',
            buttonTitle: 'Use this to test settings',
            buttonClass: 'btn btn-warning',
            command: this.inMemoryUpdateCommand,
            buttonType: DwButtonType.standard,
            isCancel: false
        };
        modalConfig.buttons = [
            DwModalButtonStandardConfigs.instance.saveButton,
            inMemoryButton,
            DwModalButtonStandardConfigs.instance.cancelButton
        ];
        modalConfig.data = {
            views: this.gridPreferences.views,
            gridPreferences: this.gridPreferences,
            itemName: this.gridPreferencesHierarchy.item,
            designerState: state
        };
        const preferenceHierarchy = deepCopy(this.preferencesHierarchy);
        this.dwModalService.showModal(modalConfig)
            .subscribe(r => {
            if (!r.cancelled) {
                const gridPreferences = r.data.gridPreferences;
                // Ensure there is a change before updating
                if (areEqual(this.preferences.views, r.data.views)) {
                    // Check if any of the grid preference items changed
                    if (areEqual(this.gridPreferences.contextNames, gridPreferences.contextNames) &&
                        this.gridPreferences.showFilterOnLoad == gridPreferences.showFilterOnLoad &&
                        this.gridPreferences.autoFilter == gridPreferences.autoFilter &&
                        this.gridPreferences.showClearFilter == gridPreferences.showClearFilter &&
                        this.gridPreferences.useSideFilters == gridPreferences.useSideFilters &&
                        this.gridPreferences.autoFilterDelay == gridPreferences.autoFilterDelay) {
                        return;
                    }
                }
                this.gridPreferences.views = r.data.views;
                this.gridPreferences.contextNames = gridPreferences.contextNames;
                this.gridPreferences.showFilterOnLoad = gridPreferences.showFilterOnLoad;
                this.gridPreferences.useSideFilters = gridPreferences.useSideFilters;
                this.gridPreferences.autoFilter = gridPreferences.autoFilter;
                this.gridPreferences.showClearFilter = gridPreferences.showClearFilter;
                this.gridPreferences.autoFilterDelay = gridPreferences.autoFilterDelay;
                if (r.buttonCommand == this.inMemoryUpdateCommand) {
                    this.preferencesChange.emit(this.preferences);
                }
                else {
                    this.preferenceChangeWithSave.emit(this.preferences);
                    if (this.preferenceChangeWithSave.observers.length == 0) {
                        this.forcePreferenceSave2(preferenceHierarchy, this.preferences);
                    }
                }
                setTimeout(() => {
                    this.configForm.patchValue(this.gridPreferences, { emitEvent: false });
                });
            }
        });
    }
    forcePreferenceSave2(preferenceHierarchy, preferences) {
        preferenceHierarchy.loadedPreferences = preferences;
        // Just save the preferences
        this.uiConfigService.savePreferencesHierarchy(preferenceHierarchy)
            .subscribe((result) => {
        });
    }
    updateFilters() {
        this.onFormChange();
    }
}
DwMetaDataGridConfigWidgetComponent.ɵfac = function DwMetaDataGridConfigWidgetComponent_Factory(t) { return new (t || DwMetaDataGridConfigWidgetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridService), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService)); };
DwMetaDataGridConfigWidgetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataGridConfigWidgetComponent, selectors: [["dw-metadata-grid-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 158, vars: 10, consts: [[3, "formGroup", "ngSubmit"], ["header", "Basic Settings"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "enableSorting"], ["formControlName", "useModal"], ["formControlName", "hidePrimaryKey"], ["formControlName", "showDisplayProperties"], ["formControlName", "showFooter"], ["dwRow", "", 4, "ngIf"], ["header", "Views"], ["dwCol", "12"], [1, "btn", "btn-success", 3, "click"], ["header", "Columns", 4, "ngIf"], ["header", "Filtering Options"], ["formControlName", "showFilterOnLoad"], ["formControlName", "useSideFilters"], ["formControlName", "showClearFilter"], ["formControlName", "autoFilter"], ["dwCol", "6"], ["type", "number", "formControlName", "autoFilterDelay", 1, "form-control"], ["header", "Action Defaults"], ["class", "alert alert-warning", 4, "ngIf"], ["formControlName", "hideEditButton"], ["formControlName", "showViewButton"], ["formControlName", "hideDeleteButton"], ["formControlName", "hideAdd"], ["formControlName", "hideRefresh"], ["formControlName", "hideExport"], ["formControlName", "allowRowSelect"], ["header", "Styling"], ["formGroupName", "gridStyle"], ["formControlName", "gridStyleName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "gridHeightMode", 1, "form-control"], ["type", "text", "formControlName", "gridHeight", 1, "form-control"], ["type", "text", "formControlName", "rowHeight", "dwNumeric", "", 1, "form-control"], ["type", "text", "formControlName", "headerHeight", "dwNumeric", "", 1, "form-control"], ["formControlName", "actionColumnUseCustomWidth"], ["formControlName", "loadTotalRowCount"], ["header", "Columns"], [1, "alert", "alert-warning"], ["formControlName", "useCheckboxSelection"], [3, "ngValue"], ["type", "text", "formControlName", "actionColumnWidth", "dwNumeric", "", 1, "form-control"]], template: function DwMetaDataGridConfigWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h3");
        ɵngcc0.ɵɵtext(2, "Grid Preferences");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function DwMetaDataGridConfigWidgetComponent_Template_form_ngSubmit_3_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(4, "p-accordion");
        ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 1);
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "label");
        ɵngcc0.ɵɵtext(9, "Enable Sorting");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵelement(11, "p-inputSwitch", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelementStart(13, "div", 3);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "use Modal");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 4);
        ɵngcc0.ɵɵelement(17, "p-inputSwitch", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 2);
        ɵngcc0.ɵɵelementStart(19, "div", 3);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Hide Key");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 4);
        ɵngcc0.ɵɵelement(23, "p-inputSwitch", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 2);
        ɵngcc0.ɵɵelementStart(25, "div", 3);
        ɵngcc0.ɵɵelementStart(26, "label");
        ɵngcc0.ɵɵtext(27, "Show Display value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 4);
        ɵngcc0.ɵɵelement(29, "p-inputSwitch", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 2);
        ɵngcc0.ɵɵelementStart(31, "div", 3);
        ɵngcc0.ɵɵelementStart(32, "label");
        ɵngcc0.ɵɵtext(33, "Show Footer");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "div", 4);
        ɵngcc0.ɵɵelement(35, "p-inputSwitch", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(36, DwMetaDataGridConfigWidgetComponent_div_36_Template, 6, 0, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "p-accordionTab", 11);
        ɵngcc0.ɵɵelementStart(38, "div", 2);
        ɵngcc0.ɵɵelementStart(39, "div", 12);
        ɵngcc0.ɵɵelementStart(40, "button", 13);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataGridConfigWidgetComponent_Template_button_click_40_listener() { return ctx.configViews(); });
        ɵngcc0.ɵɵtext(41, "Configure Views");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(42, DwMetaDataGridConfigWidgetComponent_p_accordionTab_42_Template, 5, 0, "p-accordionTab", 14);
        ɵngcc0.ɵɵelementStart(43, "p-accordionTab", 15);
        ɵngcc0.ɵɵelementStart(44, "div", 2);
        ɵngcc0.ɵɵelementStart(45, "div", 3);
        ɵngcc0.ɵɵelementStart(46, "label");
        ɵngcc0.ɵɵtext(47, "Show Filter On Load");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "div", 4);
        ɵngcc0.ɵɵelement(49, "p-inputSwitch", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "div", 2);
        ɵngcc0.ɵɵelementStart(51, "div", 3);
        ɵngcc0.ɵɵelementStart(52, "label");
        ɵngcc0.ɵɵtext(53, "Use Side Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "div", 4);
        ɵngcc0.ɵɵelement(55, "p-inputSwitch", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(56, "div", 2);
        ɵngcc0.ɵɵelementStart(57, "div", 3);
        ɵngcc0.ɵɵelementStart(58, "label");
        ɵngcc0.ɵɵtext(59, "Show Clear Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(60, "div", 4);
        ɵngcc0.ɵɵelement(61, "p-inputSwitch", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(62, "div", 2);
        ɵngcc0.ɵɵelementStart(63, "div", 3);
        ɵngcc0.ɵɵelementStart(64, "label");
        ɵngcc0.ɵɵtext(65, "Auto Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(66, "div", 4);
        ɵngcc0.ɵɵelement(67, "p-inputSwitch", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(68, "div", 2);
        ɵngcc0.ɵɵelementStart(69, "div", 20);
        ɵngcc0.ɵɵelementStart(70, "label");
        ɵngcc0.ɵɵtext(71, "Filter Delay");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(72, "div", 20);
        ɵngcc0.ɵɵelement(73, "input", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(74, DwMetaDataGridConfigWidgetComponent_div_74_Template, 4, 0, "div", 10);
        ɵngcc0.ɵɵtemplate(75, DwMetaDataGridConfigWidgetComponent_div_75_Template, 4, 0, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(76, "p-accordionTab", 22);
        ɵngcc0.ɵɵtemplate(77, DwMetaDataGridConfigWidgetComponent_div_77_Template, 2, 0, "div", 23);
        ɵngcc0.ɵɵelementStart(78, "div", 2);
        ɵngcc0.ɵɵelementStart(79, "div", 3);
        ɵngcc0.ɵɵelementStart(80, "label");
        ɵngcc0.ɵɵtext(81, "Hide Edit Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(82, "div", 4);
        ɵngcc0.ɵɵelement(83, "p-inputSwitch", 24);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(84, "div", 2);
        ɵngcc0.ɵɵelementStart(85, "div", 3);
        ɵngcc0.ɵɵelementStart(86, "label");
        ɵngcc0.ɵɵtext(87, "Show View Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(88, "div", 4);
        ɵngcc0.ɵɵelement(89, "p-inputSwitch", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(90, "div", 2);
        ɵngcc0.ɵɵelementStart(91, "div", 3);
        ɵngcc0.ɵɵelementStart(92, "label");
        ɵngcc0.ɵɵtext(93, "Hide Delete Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(94, "div", 4);
        ɵngcc0.ɵɵelement(95, "p-inputSwitch", 26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(96, "div", 2);
        ɵngcc0.ɵɵelementStart(97, "div", 3);
        ɵngcc0.ɵɵelementStart(98, "label");
        ɵngcc0.ɵɵtext(99, "Hide Add Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(100, "div", 4);
        ɵngcc0.ɵɵelement(101, "p-inputSwitch", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(102, "div", 2);
        ɵngcc0.ɵɵelementStart(103, "div", 3);
        ɵngcc0.ɵɵelementStart(104, "label");
        ɵngcc0.ɵɵtext(105, "Hide Refresh Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(106, "div", 4);
        ɵngcc0.ɵɵelement(107, "p-inputSwitch", 28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(108, "div", 2);
        ɵngcc0.ɵɵelementStart(109, "div", 3);
        ɵngcc0.ɵɵelementStart(110, "label");
        ɵngcc0.ɵɵtext(111, "Hide Export Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(112, "div", 4);
        ɵngcc0.ɵɵelement(113, "p-inputSwitch", 29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(114, "div", 2);
        ɵngcc0.ɵɵelementStart(115, "div", 3);
        ɵngcc0.ɵɵelementStart(116, "label");
        ɵngcc0.ɵɵtext(117, "Allow Row Select");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(118, "div", 4);
        ɵngcc0.ɵɵelement(119, "p-inputSwitch", 30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(120, DwMetaDataGridConfigWidgetComponent_div_120_Template, 6, 0, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(121, "p-accordionTab", 31);
        ɵngcc0.ɵɵelementStart(122, "div", 32);
        ɵngcc0.ɵɵelementStart(123, "div", 2);
        ɵngcc0.ɵɵelementStart(124, "div", 12);
        ɵngcc0.ɵɵelementStart(125, "label");
        ɵngcc0.ɵɵtext(126, "Grid Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(127, "select", 33);
        ɵngcc0.ɵɵtemplate(128, DwMetaDataGridConfigWidgetComponent_option_128_Template, 2, 2, "option", 34);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(129, "div", 2);
        ɵngcc0.ɵɵelementStart(130, "div", 12);
        ɵngcc0.ɵɵelementStart(131, "label");
        ɵngcc0.ɵɵtext(132, "Grid Height Mode");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(133, "select", 35);
        ɵngcc0.ɵɵtemplate(134, DwMetaDataGridConfigWidgetComponent_option_134_Template, 2, 2, "option", 34);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(135, "div", 2);
        ɵngcc0.ɵɵelementStart(136, "div", 12);
        ɵngcc0.ɵɵelementStart(137, "label");
        ɵngcc0.ɵɵtext(138, "Grid Height");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(139, "input", 36);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(140, "div", 2);
        ɵngcc0.ɵɵelementStart(141, "div", 12);
        ɵngcc0.ɵɵelementStart(142, "label");
        ɵngcc0.ɵɵtext(143, "Row Height");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(144, "input", 37);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(145, "div", 2);
        ɵngcc0.ɵɵelementStart(146, "div", 12);
        ɵngcc0.ɵɵelementStart(147, "label");
        ɵngcc0.ɵɵtext(148, "Header Height");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(149, "input", 38);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(150, "div", 2);
        ɵngcc0.ɵɵelementStart(151, "div", 12);
        ɵngcc0.ɵɵelementStart(152, "div", 3);
        ɵngcc0.ɵɵelementStart(153, "label");
        ɵngcc0.ɵɵtext(154, "Customize Action Column");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(155, "div", 4);
        ɵngcc0.ɵɵelement(156, "p-inputSwitch", 39);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(157, DwMetaDataGridConfigWidgetComponent_div_157_Template, 5, 0, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formGroup", ctx.configForm);
        ɵngcc0.ɵɵadvance(33);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configForm == null ? null : ctx.configForm.value == null ? null : ctx.configForm.value.showFooter);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(32);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasCustomActions);
        ɵngcc0.ɵɵadvance(43);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configForm == null ? null : ctx.configForm.value == null ? null : ctx.configForm.value.allowRowSelect);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.gridStyles);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.gridHeightModes);
        ɵngcc0.ɵɵadvance(23);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configForm == null ? null : ctx.configForm.value == null ? null : ctx.configForm.value.gridStyle == null ? null : ctx.configForm.value.gridStyle.actionColumnUseCustomWidth);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgIf, ɵngcc3.NumberValueAccessor, ɵngcc3.DefaultValueAccessor, ɵngcc3.FormGroupName, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, DwNumericDirective, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwMetaDataGridConfigWidgetComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwEventService },
    { type: DwModalService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataGridService },
    { type: DwDesignerStateService },
    { type: DwUiConfigService }
];

;
function isExpressionGroup(expr) {
    return expr.expressions !== undefined;
}
function isExpression(expr) {
    return expr.expressions === undefined;
}

class DwQueryFilterConverterService {
    constructor(dwExpressionSevice) {
        this.dwExpressionSevice = dwExpressionSevice;
    }
    convertFilterToExpression(filter) {
        if (!filter) {
            return null;
        }
        if (isQueryFilterGroup(filter)) {
            return this.convertFilterGroupToExpressionGroup(filter);
        }
        const parsedAttr = this.parseAttr(filter.Attr);
        const expression = {
            reference1: {
                attrName: parsedAttr.attrName,
                referenceType: DwExpressionReferenceType.item
            },
            compareType: this.convertQueryCompareType(filter.Type),
            reference2: {
                referenceType: DwExpressionReferenceType.value,
                value: filter.Value,
            },
        };
        return expression;
    }
    convertFilterGroupToExpressionGroup(filterGroup) {
        const exprGroup = {
            expressions: [],
            operator: this.convertQueryOperator(filterGroup.Op),
            id: 1,
        };
        for (const filter of filterGroup.Filters) {
            const filterExpr = this.convertFilterToExpression(filter);
            exprGroup.expressions.push(filterExpr);
        }
        return exprGroup;
    }
    convertExpressionToFilter(expression, resolvedContext, parentOp = DwOperator.And) {
        if (!expression) {
            return null;
        }
        if (isExpressionGroup(expression)) {
            return this.convertExpressionGroupToFilterGroup(expression, resolvedContext);
        }
        if (!expression || !expression.reference1 || !expression.reference2 || !expression.reference1.attrName) {
            return null;
        }
        if (expression.reference1.referenceType == DwExpressionReferenceType.context) {
            const contextExpressionResult = this.dwExpressionSevice.evaluateExpressionGroupItemWithResolvedData(expression, {}, resolvedContext);
            console.error('Filter expressions cannot currently use a Context as the first field in an expression.  This behavior can be modified if needed', contextExpressionResult);
            return null;
        }
        let value = this.dwExpressionSevice.evaluateExpressionReferenceWithResolvedData(expression.reference2, {}, resolvedContext);
        if (Array.isArray(value)) {
            value = value.join(',');
        }
        const filter = {
            Attr: expression.reference1.attrName,
            Value: value,
            Type: this.convertExpressionCompareType(expression.compareType),
            Op: parentOp
        };
        return filter;
    }
    convertExpressionGroupToFilterGroup(exprGroup, resolvedContext) {
        const filterGroup = new DwQueryFilterGroup();
        filterGroup.Op = this.convertExpressionOperator(exprGroup.operator);
        for (const expr of exprGroup.expressions) {
            const filter = this.convertExpressionToFilter(expr, resolvedContext, filterGroup.Op);
            if (filter) {
                filterGroup.Filters.push(filter);
            }
        }
        return filterGroup;
    }
    convertQueryOperator(operator) {
        if (operator == DwOperator.Or) {
            return DwExpressionOperator.or;
        }
        return DwExpressionOperator.and;
    }
    convertExpressionOperator(operator) {
        if (operator == DwExpressionOperator.or) {
            return DwOperator.Or;
        }
        return DwOperator.And;
    }
    convertQueryCompareType(filterType) {
        switch (filterType) {
            case DwFilterType.Equal: return DwExpressionCompareType.equal;
            case DwFilterType.GreaterThan: return DwExpressionCompareType.greaterThan;
            case DwFilterType.GreaterThanEqual: return DwExpressionCompareType.greaterThanEqual;
            case DwFilterType.LessThan: return DwExpressionCompareType.lessThan;
            case DwFilterType.LessThanEqual: return DwExpressionCompareType.lessThanEqual;
            case DwFilterType.Contains: return DwExpressionCompareType.contains;
            case DwFilterType.StartsWith: return DwExpressionCompareType.startsWith;
            case DwFilterType.EndsWith: return DwExpressionCompareType.endsWith;
            case DwFilterType.NotEqual: return DwExpressionCompareType.notEqual;
            case DwFilterType.IsBlank: return DwExpressionCompareType.isBlank;
            case DwFilterType.IsNotBlank: return DwExpressionCompareType.isNotBlank;
            case DwFilterType.IsTrue: return DwExpressionCompareType.isTrue;
            case DwFilterType.IsFalse: return DwExpressionCompareType.isFalse;
            case DwFilterType.GreaterThanDays: return DwExpressionCompareType.greaterThanDays;
            case DwFilterType.GreaterThanEqualDays: return DwExpressionCompareType.greaterThanEqualDays;
            case DwFilterType.LessThanDays: return DwExpressionCompareType.lessThanDays;
            case DwFilterType.LessThanEqualDays: return DwExpressionCompareType.lessThanEqualDays;
            case DwFilterType.GreaterThanHours: return DwExpressionCompareType.greaterThanHours;
            case DwFilterType.GreaterThanEqualHours: return DwExpressionCompareType.greaterThanEqualHours;
            case DwFilterType.LessThanHours: return DwExpressionCompareType.lessThanHours;
            case DwFilterType.LessThanEqualHours: return DwExpressionCompareType.lessThanEqualHours;
            case DwFilterType.In: return DwExpressionCompareType.inList;
            case DwFilterType.NotIn: return DwExpressionCompareType.notInList;
        }
    }
    convertExpressionCompareType(compareType) {
        switch (compareType) {
            case DwExpressionCompareType.equal: return DwFilterType.Equal;
            case DwExpressionCompareType.greaterThan: return DwFilterType.GreaterThan;
            case DwExpressionCompareType.greaterThanEqual: return DwFilterType.GreaterThanEqual;
            case DwExpressionCompareType.lessThan: return DwFilterType.LessThan;
            case DwExpressionCompareType.lessThanEqual: return DwFilterType.LessThanEqual;
            case DwExpressionCompareType.contains: return DwFilterType.Contains;
            case DwExpressionCompareType.notContains: return DwFilterType.NotContains;
            case DwExpressionCompareType.startsWith: return DwFilterType.StartsWith;
            case DwExpressionCompareType.endsWith: return DwFilterType.EndsWith;
            case DwExpressionCompareType.notEqual: return DwFilterType.NotEqual;
            case DwExpressionCompareType.isBlank: return DwFilterType.IsBlank;
            case DwExpressionCompareType.isNotBlank: return DwFilterType.IsNotBlank;
            case DwExpressionCompareType.isTrue: return DwFilterType.IsTrue;
            case DwExpressionCompareType.isFalse: return DwFilterType.IsFalse;
            case DwExpressionCompareType.greaterThanDays: return DwFilterType.GreaterThanDays;
            case DwExpressionCompareType.greaterThanEqualDays: return DwFilterType.GreaterThanEqualDays;
            case DwExpressionCompareType.lessThanDays: return DwFilterType.LessThanDays;
            case DwExpressionCompareType.lessThanEqualDays: return DwFilterType.LessThanEqualDays;
            case DwExpressionCompareType.greaterThanHours: return DwFilterType.GreaterThanHours;
            case DwExpressionCompareType.greaterThanEqualHours: return DwFilterType.GreaterThanEqualHours;
            case DwExpressionCompareType.lessThanHours: return DwFilterType.LessThanHours;
            case DwExpressionCompareType.lessThanEqualHours: return DwFilterType.LessThanEqualHours;
            case DwExpressionCompareType.inList: return DwFilterType.In;
            case DwExpressionCompareType.notInList: return DwFilterType.NotIn;
        }
    }
    parseAttr(attrName) {
        const index = attrName.indexOf('.');
        if (index >= 0) {
            return {
                item: attrName.substring(0, index),
                attrName: attrName.substring(index + 1, attrName.length)
            };
        }
        return { attrName: attrName };
    }
}
DwQueryFilterConverterService.ɵfac = function DwQueryFilterConverterService_Factory(t) { return new (t || DwQueryFilterConverterService)(ɵngcc0.ɵɵinject(DwExpressionService)); };
DwQueryFilterConverterService.ɵprov = ɵɵdefineInjectable({ factory: function DwQueryFilterConverterService_Factory() { return new DwQueryFilterConverterService(ɵɵinject(DwExpressionService)); }, token: DwQueryFilterConverterService, providedIn: "root" });
DwQueryFilterConverterService.ctorParameters = () => [
    { type: DwExpressionService }
];

class DwFilterTileService {
    constructor(injector, uiConfigRegistryService, dwMetaDataService, dwQueryFilterConverterService, dwContextService, dwExpressionService, router) {
        this.injector = injector;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
        this.dwContextService = dwContextService;
        this.dwExpressionService = dwExpressionService;
        this.router = router;
    }
    loadFilterTileStates(configContext, tilesConfig, dwSharedFilterExpression) {
        var _a;
        const tileStates = [];
        if (!tilesConfig || ((_a = tilesConfig === null || tilesConfig === void 0 ? void 0 : tilesConfig.tiles) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            return of({ tiles: [], resolvedContext: {} });
        }
        for (const tileConfig of tilesConfig.tiles) {
            const tileState = {
                filterTileConfig: tileConfig,
                loading: true,
                selected: false,
                metricValue: null
            };
            tileStates.push(tileState);
        }
        return this.loadFilterTiles(configContext, tilesConfig, tileStates, dwSharedFilterExpression);
    }
    loadFilterTiles(configContext, tilesConfig, states, dwSharedFilterExpression) {
        const subject = new BehaviorSubject({ tiles: states, resolvedContext: null });
        const loaders = this.getFilterTileLoaders(tilesConfig);
        const contextOb = this.dwContextService.getContextsAndResolve(configContext.contextNames, {});
        const metaDataOb = this.dwMetaDataService.getSavedQueryMetaData(configContext.itemName, null, configContext.metaDataQueryMeaning);
        combineLatest([contextOb, metaDataOb])
            .subscribe(([resolvedContext, queryMetaData]) => {
            states = this.getVisibleTileStates(states, resolvedContext);
            subject.next({ tiles: states, resolvedContext: resolvedContext });
            for (const loader of loaders) {
                loader.loadFilterCounts(queryMetaData, tilesConfig, states, resolvedContext, dwSharedFilterExpression)
                    .subscribe(results => {
                    // merge results into a new state
                    let newState = deepCopy(subject.value);
                    newState.resolvedContext = resolvedContext;
                    for (const result of results) {
                        const existingState = newState.tiles.find(s => s.filterTileConfig.tileKey == result.filterTileConfig.tileKey);
                        existingState.loading = result.loading;
                        existingState.metricValue = result.metricValue;
                    }
                    subject.next(newState);
                    // update state as filter counts load
                    //subject.next(states);
                });
            }
        });
        return subject.asObservable();
    }
    /**
     * Determines which states should be visible
     * @param states
     * @param resolvedContext
     */
    getVisibleTileStates(states, resolvedContext) {
        const visibleStates = [];
        for (const state of states) {
            let visibleResult = true;
            // Ignore empty expressions
            if (!this.dwExpressionService.isEmptyExpressionGroupItem(state.filterTileConfig.visibleExpression)) {
                visibleResult = this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(state.filterTileConfig.visibleExpression, {}, resolvedContext);
            }
            if (visibleResult) {
                visibleStates.push(state);
            }
        }
        return visibleStates;
    }
    getFilterTileLoaders(tilesConfig) {
        var _a;
        const filterTileLoaders = [];
        const existingKeys = [];
        const tileTypeConfigs = this.uiConfigRegistryService.getRegisteredComponents(DwComponentType.filterTile);
        for (const tileConfig of tilesConfig.tiles) {
            let tileTypeConfig = tileTypeConfigs.find(c => c.key == tileConfig.filterTypeKey);
            if (!tileTypeConfig) {
                tileTypeConfig = tileTypeConfigs[0];
            }
            if ((_a = tileTypeConfig === null || tileTypeConfig === void 0 ? void 0 : tileTypeConfig.configData) === null || _a === void 0 ? void 0 : _a.buildFilterService) {
                if (existingKeys.indexOf(tileTypeConfig.key) != -1) {
                    continue;
                }
                existingKeys.push(tileTypeConfig.key);
                const filterLoader = this.injector.get(tileTypeConfig.configData.buildFilterService);
                filterTileLoaders.push(filterLoader);
            }
        }
        return filterTileLoaders;
    }
    buildTileFilter(tilesConfig, selectedTile, resolvedContext) {
        const filterGroup = new DwQueryFilterGroup();
        if (tilesConfig.sharedFilterExpression) {
            filterGroup.AddFilterAnd(this.dwQueryFilterConverterService.convertExpressionToFilter(tilesConfig.sharedFilterExpression, resolvedContext));
        }
        if (selectedTile.filterExpression) {
            filterGroup.AddFilterAnd(this.dwQueryFilterConverterService.convertExpressionToFilter(selectedTile.filterExpression, resolvedContext));
        }
        return filterGroup;
    }
}
DwFilterTileService.ɵfac = function DwFilterTileService_Factory(t) { return new (t || DwFilterTileService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwQueryFilterConverterService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
DwFilterTileService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFilterTileService, factory: DwFilterTileService.ɵfac });
DwFilterTileService.ctorParameters = () => [
    { type: Injector },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwQueryFilterConverterService },
    { type: DwContextService },
    { type: DwExpressionService },
    { type: Router }
];

class DwMetaDataFilterService {
    constructor(dwMetaDataService, dwUiConfigRegistryService, dwFilterTileService, router, inject, dwContextService, dwExpressionService, dwQueryFilterConverterService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwFilterTileService = dwFilterTileService;
        this.router = router;
        this.inject = inject;
        this.dwContextService = dwContextService;
        this.dwExpressionService = dwExpressionService;
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
    }
    getFilterTileQueryParam() {
        const selectedTileParam = getParameterByName(this.router, 'tile');
        return selectedTileParam;
    }
    buildFilterFormConfig(filterConfig, filters, formData) {
        let formPreferences = new DwMetaDataFormPreferences();
        let section = new DwFormSectionPreference();
        formPreferences.section = section;
        section.title = "";
        section.showTitle = true;
        section.columnPreferences = new DwSectionColumnPreferences();
        section.columnPreferences.columns = 3;
        if (!formData) {
            formData = {};
        }
        if (filterConfig) {
            for (var filter of filterConfig) {
                if (filter.defaultValue)
                    formData[filter.attr] = filter.defaultValue;
                var existingFilterValue = this.getFilterValue(filters, filter);
                if (existingFilterValue) {
                    formData[filter.attr] = existingFilterValue;
                }
                if (filter.showFilter) {
                    var fieldPreference = new DwFormFieldPreference();
                    fieldPreference.attrName = filter.attr;
                    fieldPreference.label = filter.label;
                    fieldPreference.controlTypeOverride = filter.controlTypeOverride;
                    section.fields.push(fieldPreference);
                }
            }
        }
        return formPreferences;
    }
    buildInitialFilters(filterConfigs, filterTilesConfig, selectedFilterTileKey, sharedFilterExpression, originalFilters, item, queryMetaData, resolvedContext) {
        var _a;
        //console.log("dwMetaDataFilterService - Build filters - Initial", filters);
        const filters = deepCopy(originalFilters || {});
        let qh = new DwQueryHelper();
        let index = 0;
        if (filterConfigs) {
            for (const filter of filterConfigs) {
                if (filter.componentName) {
                    index++;
                    this.buildInitialComponentFilter(filter, originalFilters, item, filters, index, queryMetaData, resolvedContext);
                    continue;
                }
                let existingFilterValue = this.getFilterValue(filters, filter);
                const defaultValue = this.getDefaultValue(filter.hasDefaultValue, filter.defaultValue, resolvedContext);
                this.buildStandardFilter(queryMetaData, filter, defaultValue, filters);
            }
        }
        // Add a shared filter
        if (sharedFilterExpression) {
            filters.GroupSharedFilter = this.dwQueryFilterConverterService.convertExpressionToFilter(sharedFilterExpression, resolvedContext);
        }
        // Build Initial Tile Filter
        if (((_a = filterTilesConfig === null || filterTilesConfig === void 0 ? void 0 : filterTilesConfig.tiles) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const filterTile = filterTilesConfig === null || filterTilesConfig === void 0 ? void 0 : filterTilesConfig.tiles.find(t => t.tileKey == selectedFilterTileKey);
            filters.GroupTileFilter = this.dwFilterTileService.buildTileFilter(filterTilesConfig, filterTile, resolvedContext);
        }
        return filters;
    }
    executeInitialFilterService(filterConfig, originalFilters, item, queryMetaData, resolvedContext) {
        var _a;
        const filterDef = this.dwUiConfigRegistryService.getRegisteredComponent(filterConfig.componentName, DwComponentType.filterItem);
        if (!((_a = filterDef === null || filterDef === void 0 ? void 0 : filterDef.configData) === null || _a === void 0 ? void 0 : _a.initialFilterService)) {
            return null;
        }
        const service = this.inject.get(filterDef.configData.initialFilterService);
        if (!service) {
            return null;
        }
        const paramName = filterConfig.altQueryStringParamName || filterConfig.attr;
        let paramValue = null;
        if (paramName) {
            paramValue = getParameterByName(this.router, paramName);
        }
        const compFilters = service.buildInitialFilter(filterConfig, item, queryMetaData, originalFilters, resolvedContext, paramValue);
        return compFilters;
    }
    buildInitialComponentFilter(filterConfig, originalFilters, item, filters, index, queryMetaData, resolvedContext) {
        const compFilters = this.executeInitialFilterService(filterConfig, originalFilters, item, queryMetaData, resolvedContext);
        if (!compFilters) {
            return;
        }
        const groupName = `Group${index}`;
        // if filterValue is an object or null (Otherwise it gets used a normal filter, but will be added to a new group)
        if (typeof compFilters == 'object') {
            filters[groupName] = compFilters;
            if (compFilters && !compFilters.Op) {
                compFilters.Op = DwOperator.And;
            }
            return;
        }
        if (!filterConfig.attr) {
            return;
        }
        const queryAttr = queryMetaData.Attributes.find(a => a.AttributeName == filterConfig.attr);
        // Ensure group exists
        let group = filters[groupName];
        if (!group) {
            group = {
                Op: DwOperator.And
            };
            filters[groupName] = group;
        }
        // Ensure attr filter exists
        let attrFilter = group[filterConfig.attr];
        if (!attrFilter) {
            attrFilter = {};
            group[filterConfig.attr] = attrFilter;
        }
        if (queryAttr && queryAttr.RelationPrefix) {
            attrFilter.Prefix = queryAttr.RelationPrefix;
        }
        return null;
    }
    hasVisibleFilters(filterConfig) {
        if (!filterConfig) {
            return false;
        }
        const filter = filterConfig.find(f => f.showFilter === true);
        if (filter) {
            return true;
        }
        return false;
    }
    getFilterValue(filters, filter) {
        if (!filters) {
            return;
        }
        var attrFilter = filters[filter.attr];
        if (!attrFilter) {
            return;
        }
        let qh = new DwQueryHelper();
        const filterTypeKey = qh.convertFilterType(filter.filterType);
        if (attrFilter[filterTypeKey] || attrFilter[filterTypeKey] === false)
            return attrFilter[filterTypeKey];
        return null;
    }
    // Could move to a new filter service
    convertToFilters(queryMetaData, data, customFilterValues, filterConfig, filters, resolvedContext, sharedFilterExpression) {
        if (!filterConfig || (!data && customFilterValues.length == 0) || !queryMetaData)
            return;
        let qh = new DwQueryHelper();
        filters = filters || {};
        if (sharedFilterExpression) {
            filters.GroupSharedFilter = this.dwQueryFilterConverterService.convertExpressionToFilter(sharedFilterExpression, resolvedContext);
        }
        let index = 0;
        for (const filter of filterConfig) {
            let filterValue = data[filter.attr];
            let group = null;
            let queryAttr = queryMetaData.Attributes.find(a => a.AttributeName == filter.attr);
            let attrFilter = filters[filter.attr];
            if (!attrFilter && filter.attr) {
                attrFilter = {};
                filters[filter.attr] = attrFilter;
            }
            if (filter.componentName) {
                index++;
                const groupName = `Group${index}`;
                // Delete the group if it exists (it will get readded if valid)
                if (filters[groupName]) {
                    delete filters[groupName];
                }
                let customFilterValue = customFilterValues.find(cfv => cfv.filterConfig == filter);
                if (!customFilterValue) {
                    continue;
                }
                filterValue = customFilterValue.filterValue;
                // if filterValue is an object or null (Otherwise it gets used a normal filter, but will be added to a new group)
                if (typeof filterValue == 'object') {
                    filters[groupName] = filterValue;
                    if (filterValue && !filterValue.Op) {
                        filterValue.Op = DwOperator.And;
                    }
                    continue;
                }
                if (!filter.attr) {
                    continue;
                }
                // Ensure group exists
                let group = filters[groupName];
                if (!group) {
                    group = {
                        Op: DwOperator.And
                    };
                    filters[groupName] = group;
                }
                // Ensure attr filter exists
                attrFilter = group[filter.attr];
                if (!attrFilter) {
                    attrFilter = {};
                    group[filter.attr] = attrFilter;
                }
            }
            if (!filter.showFilter) {
                filterValue = this.getDefaultValue(filter.hasDefaultValue, filter.defaultValue, resolvedContext);
            }
            const filterTypeKey = qh.convertFilterType(filter.filterType);
            const filterTypeRequiresValue = qh.filterTypeRequiresValue(filter.filterType);
            if (!filterTypeRequiresValue) {
                // Dummy this to true so the filter will be in the correct format
                filterValue = "true";
            }
            // Ensuring that we have a filter value and it's not an empty object
            if (this.valueExists(filterValue)) {
                attrFilter[filterTypeKey] = filterValue;
            }
            else {
                delete attrFilter[filterTypeKey];
                delete attrFilter.Prefix;
                if (isEmptyObject(attrFilter)) {
                    delete filters[filter.attr];
                    attrFilter = null;
                }
            }
            if (attrFilter) {
                attrFilter.Prefix = queryAttr.RelationPrefix;
            }
        }
        return filters;
    }
    buildStandardFilter(queryMetaData, filter, filterValue, filters) {
        let group = null;
        let queryAttr = queryMetaData.Attributes.find(a => a.AttributeName == filter.attr);
        let attrFilter = filters[filter.attr];
        if (!attrFilter && filter.attr) {
            attrFilter = {};
            filters[filter.attr] = attrFilter;
        }
        let qh = new DwQueryHelper();
        const filterTypeKey = qh.convertFilterType(filter.filterType);
        const filterTypeRequiresValue = qh.filterTypeRequiresValue(filter.filterType);
        if (!filterTypeRequiresValue) {
            // Dummy this to true so the filter will be in the correct format
            filterValue = "true";
        }
        // Ensuring that we have a filter value and it's not an empty object
        if (this.valueExists(filterValue)) {
            attrFilter[filterTypeKey] = filterValue;
        }
        else {
            delete attrFilter[filterTypeKey];
            delete attrFilter.Prefix;
            if (isEmptyObject(attrFilter)) {
                delete filters[filter.attr];
                attrFilter = null;
            }
        }
        if (attrFilter) {
            attrFilter.Prefix = queryAttr.RelationPrefix;
        }
    }
    valueExists(value) {
        if (value === undefined || value === null || (typeof (value) === "string" && value.length === 0)) {
            return false;
        }
        return true;
    }
    //buildFormFieldConfigs(this.item, this.metaDataQueryId, this.filterConfig, this.filters, this.formGroup)
    buildFormFieldConfigs(configContext, filterConfigs, filters, formGroup) {
        const filterFieldConfigs = [];
        const contextOb = this.dwContextService.getContextsAndResolve(configContext.contextNames, {});
        const queryMetaDataOb = this.dwMetaDataService.getSavedQueryMetaData(configContext.itemName, null, configContext.metaDataQueryMeaning);
        return combineLatest([contextOb, queryMetaDataOb])
            .pipe(map(([resolvedContext, queryMetaData]) => {
            const customFilterValues = [];
            for (const filterConfig of filterConfigs) {
                const filterFieldConfig = this.buildFilterFieldConfig(queryMetaData, filterConfig, filters, customFilterValues, formGroup, resolvedContext);
                if (filterFieldConfig) {
                    filterFieldConfigs.push(filterFieldConfig);
                }
            }
            return {
                queryMetaData: queryMetaData,
                fields: filterFieldConfigs,
                customFilterValues: customFilterValues,
                resolvedContext: resolvedContext
            };
        }));
    }
    buildFilterFieldConfig(queryMetaData, filterConfig, filters, customFilterValues, formGroup, resolvedContext) {
        if (!filterConfig.showFilter) {
            return null;
        }
        const defaultColumnSize = 3;
        const filterFormConfig = {
            filterConfig: filterConfig,
            newRow: filterConfig.newRowBefore,
            columnSize: filterConfig.spanAllColumns ? 12 : defaultColumnSize
        };
        if (filterConfig.componentName) {
            const componentRef = this.dwUiConfigRegistryService.getRegisteredComponent(filterConfig.componentName, DwComponentType.filterItem);
            if (!componentRef) {
                console.warn(`Filter Item Component ${filterConfig.componentName} was not found in the registry`);
                return null;
            }
            filterFormConfig.componentType = componentRef.component;
            var customFilterValue = {
                filterConfig: filterConfig,
                filterValue: this.executeInitialFilterService(filterConfig, filters, queryMetaData.RootItem, queryMetaData, resolvedContext)
            };
            customFilterValues.push(customFilterValue);
            return filterFormConfig;
        }
        if (!filterConfig.attr) {
            return null;
        }
        const queryAttr = queryMetaData.Attributes.find(attr => attr.AttributeName.toUpperCase() == filterConfig.attr.toUpperCase());
        if (!queryAttr) {
            return null;
        }
        const fieldConfig = this.buildFieldConfig(filterConfig, queryAttr);
        let formControl = formGroup.get(fieldConfig.attrName);
        if (!formControl) {
            formControl = new FormControl(null);
            formGroup.addControl(fieldConfig.attrName, formControl);
        }
        // Change to always set initial value (since this only runs at the begining)
        this.setInitialValue(formControl, filterConfig, filters, resolvedContext);
        filterFormConfig.fieldConfig = fieldConfig;
        return filterFormConfig;
    }
    buildFieldConfig(filterConfig, queryAttr) {
        if (!queryAttr) {
            return null;
        }
        var attr = queryAttr.Attribute;
        const fieldConfig = new DwFormFieldConfig();
        fieldConfig.attr = attr;
        fieldConfig.attrName = queryAttr.AttributeName;
        fieldConfig.controlType = filterConfig.controlTypeOverride || attr.MetaDataControlTypeId;
        fieldConfig.label = filterConfig.label || attr.Display;
        fieldConfig.controlOptions = filterConfig.controlOptions;
        fieldConfig.placeholderText = filterConfig.placeholderText;
        fieldConfig.lookupConfig = filterConfig.lookupConfig;
        if (fieldConfig.controlType == DwControlType.Checkbox) {
            //fieldConfig.label += '(Checkbox)'
            fieldConfig.controlType = DwControlType.YesNoDropDown;
        }
        return fieldConfig;
    }
    setInitialValue(fc, filterConfig, filters, resolvedContext) {
        const paramValue = getParameterByName(this.router, filterConfig.altQueryStringParamName || filterConfig.attr);
        const filterValue = this.getFilterValue(filters, filterConfig);
        const defaultValue = this.getDefaultValue(filterConfig.hasDefaultValue, filterConfig.defaultValue, resolvedContext);
        const initialValue = paramValue || filterValue || defaultValue;
        if (initialValue || initialValue === false) {
            fc.setValue(initialValue);
        }
    }
    getDefaultValue(hasDefaultValue, defaultValue, resolvedContext) {
        if (hasDefaultValue === false || !defaultValue) {
            return defaultValue;
        }
        if (!defaultValue.reference) {
            return defaultValue;
        }
        // Handle context references
        return this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(defaultValue.reference, {}, resolvedContext);
    }
}
DwMetaDataFilterService.ɵfac = function DwMetaDataFilterService_Factory(t) { return new (t || DwMetaDataFilterService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwFilterTileService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwQueryFilterConverterService)); };
DwMetaDataFilterService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataFilterService_Factory() { return new DwMetaDataFilterService(ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwFilterTileService), ɵɵinject(Router), ɵɵinject(INJECTOR), ɵɵinject(DwContextService), ɵɵinject(DwExpressionService), ɵɵinject(DwQueryFilterConverterService)); }, token: DwMetaDataFilterService, providedIn: "root" });
DwMetaDataFilterService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: DwFilterTileService },
    { type: Router },
    { type: Injector },
    { type: DwContextService },
    { type: DwExpressionService },
    { type: DwQueryFilterConverterService }
];

var DwGridEvents;
(function (DwGridEvents) {
    DwGridEvents["selectedViewChange"] = "selectedViewChange";
    DwGridEvents["filterChange"] = "filterChange";
    DwGridEvents["refreshData"] = "refreshData";
    DwGridEvents["gridDataLoad"] = "gridDataLoad";
    DwGridEvents["setQuickSearchText"] = "setQuickSearchText";
    DwGridEvents["rowSelectionChange"] = "rowSelectionChange";
})(DwGridEvents || (DwGridEvents = {}));

class DwMetaDataFilterStateService extends DwStateBaseService {
    constructor() {
        super();
        this.instanceCount = 0;
        this.onClearFilters = new Subject();
        this.instanceCount += 1;
    }
    getInitialState() {
        return {
            initComplete: false,
            filters: {},
        };
    }
    setFilters(filters, selectedFilterTileKey, initComplete, applyImmediately, preserveFilters) {
        const state = deepCopy(this.state);
        if (preserveFilters) {
            state.preserveFilters = preserveFilters;
        }
        if (state.preserveFilters) {
            filters = deepCopy(filters);
            filters = Object.assign(Object.assign({}, filters), state.preserveFilters);
        }
        state.filters = filters;
        if (selectedFilterTileKey) {
            state.selectedFilterTileKey = selectedFilterTileKey;
        }
        if (initComplete === false || initComplete === true) {
            state.initComplete = initComplete;
        }
        state.applyImmediately = applyImmediately;
        // console.log(`FilterStateService - Set Filters - Instance ${this.instanceCount}`, this.state.filters, filters,)
        this.setState(state);
    }
    clearFilters() {
        this.onClearFilters.next();
    }
    clearState() {
        this.setState(this.getInitialState());
        // console.log(`FilterStateService - ClearState - Instance ${this.instanceCount}`)
    }
}
DwMetaDataFilterStateService.ɵfac = function DwMetaDataFilterStateService_Factory(t) { return new (t || DwMetaDataFilterStateService)(); };
DwMetaDataFilterStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataFilterStateService, factory: DwMetaDataFilterStateService.ɵfac });
DwMetaDataFilterStateService.ctorParameters = () => [];

class DwMetaDataGridComponent extends DwUiConfigurableControlBase {
    constructor(dwOrmDataService, metaDataGridService, uiConfigService, dwEventService, dwSecurityUserService, dwConfigService, dwMetaDataFilterService, dwActionExecutionService, dwMetaDataGridActionService, dwMetaDataActionExpressionService, router, dwRoutingService, dwMetaDataFilterStateService, dwContextService) {
        super(uiConfigService, dwEventService, dwSecurityUserService, dwConfigService);
        this.dwOrmDataService = dwOrmDataService;
        this.metaDataGridService = metaDataGridService;
        this.dwMetaDataFilterService = dwMetaDataFilterService;
        this.dwActionExecutionService = dwActionExecutionService;
        this.dwMetaDataGridActionService = dwMetaDataGridActionService;
        this.dwMetaDataActionExpressionService = dwMetaDataActionExpressionService;
        this.router = router;
        this.dwRoutingService = dwRoutingService;
        this.dwMetaDataFilterStateService = dwMetaDataFilterStateService;
        this.dwContextService = dwContextService;
        this.ignoreAddEditEvents = false;
        this.gridEvent = new EventEmitter();
        this.configKeyPart = "";
        this.readOnly = false;
        this.gridContext = {};
        this.externalFilters = {};
        this.filterSetupComplete = false;
        this.filters = {};
        this._changeDetectionCount = 0;
        this._changeDetectionDisplayValue = 0;
        this.configType = DwUiConfigType.grid;
        this.gridContextMenu = [];
        this.ignoreNextMenu = false;
        this.dwRoutingService.getRoutesChanges().subscribe(() => {
            this.handleRouteParamChange();
        });
    }
    toggleFilterButtonClick() {
        this.dwGrid.toggleFilters();
    }
    setGridMessage(message) {
        this.gridMessage = message;
    }
    clearGridMessage() {
        this.gridMessage = null;
    }
    get metaDatagridApi() {
        if (!this.gridApi) {
            return {};
        }
        const partialApi = this.gridApi;
        partialApi.addContext = this.addContext;
        partialApi.item = this.item;
        partialApi.toggleFilters = () => {
            this.dwGrid.toggleFilters();
        };
        partialApi.data = this.dataSource;
        partialApi.inlineEditApi = {
            cancelRowEdit: (cancelRowEditParams) => {
                //this.dwGrid.cancelRowEdit(cancelRowEditParams);
                console.log('Cancel row edit not implemented', cancelRowEditParams);
                alert('Cancel row edit not implemented');
            },
            startInlineEdits: (updatedCount, refreshGrid) => {
                if (this.gridContext.inEditMode) {
                    return;
                }
                this.gridContext.inEditMode = true;
                this.gridContext.updatedCount = updatedCount;
                this.updateGridContext();
                if (refreshGrid) {
                    this.gridApi.refreshDataSource(true);
                }
                else {
                    //this.gridApi
                }
            },
            addNewRow: () => {
            },
            cancelInLineEdits: (refreshGrid) => {
                if (!this.gridContext.inEditMode) {
                    return;
                }
                this.gridContext.inEditMode = false;
                this.gridContext.updatedCount = 0;
                this.updateGridContext();
                if (refreshGrid) {
                    this.gridApi.refreshDataSource(true);
                }
            },
            saveAllEdits: () => {
                const rows = this.gridApi.getEditedRows();
                if (rows.length > 0) {
                    const invalidRows = rows.filter(r => { var _a; return ((_a = r._validation) === null || _a === void 0 ? void 0 : _a.isValid) == false; });
                    if (invalidRows.length > 0) {
                        const plural = invalidRows.length > 1 ? 's' : '';
                        this.gridMessage = {
                            messageBody: `There are ${invalidRows.length} invalid row${plural}.  Please correct the errors and try again.`,
                            severity: DwMessageSeverity.warning,
                            allowClose: true,
                            timeToShow: 3000
                        };
                        return;
                    }
                    const dataSource = this.dataSource;
                    if (dataSource.saveAllItems) {
                        const finalRows = this.metaDataGridService.cleanupEditableData(rows);
                        dataSource.saveAllItems(finalRows).subscribe((results) => {
                            this.gridContext.inEditMode = false;
                            this.gridContext.updatedCount = 0;
                            this.updateGridContext();
                            this.gridApi.refreshDataSource(true);
                        });
                    }
                    return;
                }
                this.gridContext.inEditMode = false;
                this.gridContext.updatedCount = 0;
                this.updateGridContext();
                this.gridApi.refreshDataSource(true);
            }
        };
        return partialApi;
    }
    get ChangeDetectionCount() {
        this._changeDetectionCount++;
        return this._changeDetectionDisplayValue;
    }
    ngDoCheck() {
        this._changeDetectionDisplayValue = this._changeDetectionCount;
    }
    gridReady(gridApi) {
        this.gridApi = gridApi;
        this.configContext.metaDataGridApi = this.metaDatagridApi;
    }
    handleRouteParamChange() {
        const viewKey = getParameterByName(this.router, "view");
        if (viewKey && this.selectedViewKey != viewKey) {
            this.selectedViewKey = viewKey;
            this.setupConfig();
        }
    }
    ngOnInit() {
        // Always call the base class init (or bad things will happen)
        super.ngOnInit();
        // Watch for a data change event and update the grid data automatically
        this.subscriptions.push(this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(this.item))
            .subscribe((event) => {
            // Need to use a delay so that Angular can view the change (otherwise change events don't run on bound components)
            setTimeout(() => {
                if (this.gridApi && !this.ignoreNextRefreshEvent)
                    this.gridApi.refreshDataSource(true);
            }, 5);
        }));
        this.subscriptions.push(this.dwEventService.getEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.MetaDataUpdated)
            .subscribe((event) => {
            this.configSequenceComplete = false;
            // Clear out the preferences so they will be reloaded
            this.gridConfig = null;
            this.originalPreferences = null;
            this.preferences = null;
            this.preferenceHierarchy = null;
            this.loadPreferencesInternal();
            // OLD NOTE: This didn't reload metadata
            //this.setupConfig();
        }));
        this.dwMetaDataFilterStateService.stateChanged.subscribe(filterState => {
            // Set filters on the grid once init is complete
            if (filterState.initComplete && this.dwGrid) {
                this.gridContext.filterTileKey = filterState.selectedFilterTileKey;
                this.updateGridContext();
                this.filters = filterState.filters;
                if (filterState.applyImmediately) {
                    this.dwGrid.applyFilters(this.filters);
                }
                else {
                    this.dwGrid.filters = this.filters;
                }
            }
        });
    }
    ngOnChanges(changes) {
        var _a, _b, _c;
        super.ngOnChanges(changes);
        if (((_a = changes.externalFilters) === null || _a === void 0 ? void 0 : _a.firstChange) == false) {
            // Apply filter change
            const filters = Object.assign(Object.assign({}, this.filters), this.externalFilters);
            this.filters = filters;
            (_b = this.dwGrid) === null || _b === void 0 ? void 0 : _b.applyFilters(filters);
        }
        // Data source has changed
        if (((_c = changes.dataSource) === null || _c === void 0 ? void 0 : _c.firstChange) == false) {
            this.setupConfig();
            setTimeout(() => {
                var _a;
                (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.refreshDataSource(true);
            });
        }
    }
    getConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}`;
        return `${itemName}-${this.configKeyPart}`;
    }
    setupConfig() {
        var _a;
        if (!this.item || !this.preferenceHierarchy)
            return;
        if (!this.preferenceHierarchy.itemMetaData) {
            console.warn('DwGrid - Preference Hierarchy missed item meta data, using existing config');
            return;
        }
        const viewKey = getParameterByName(this.router, "view");
        const updatedPreferences = this.uiConfigService.getFinalPreferences(this.preferenceHierarchy);
        // Only update if the preferences have actually changed (Do a deep compare so the property order doesn't matter)
        if (!this.isSecurityChange && areEqualDeepCompare(this.originalPreferences, updatedPreferences)) {
            return;
        }
        this.preferences = updatedPreferences;
        this.originalPreferences = deepCopy(this.preferences);
        const updatedGridConfig = this.metaDataGridService.buildDefaultGridConfig(this.preferenceHierarchy, this.selectedViewKey || viewKey, this.readOnly);
        if (!updatedGridConfig) {
            return;
        }
        this.gridConfig = updatedGridConfig;
        this.gridConfig.configKeyPart = this.configKeyPart;
        // Wire up callbacks
        if ((_a = this.gridCallbacks) === null || _a === void 0 ? void 0 : _a.getRowClass) {
            this.gridConfig.getRowClass = this.gridCallbacks.getRowClass;
        }
        this.configContext = {
            contextNames: this.gridConfig.contextNames,
            itemName: this.item,
            metaDataGridApi: this.metaDatagridApi
        };
        if (!this.gridConfig.canAccess) {
            return;
        }
        this.selectedViewKey = this.gridConfig.selectedView.key;
        // Clear unique identifier on datasource so it will be refreshed on config change
        if (this.dataSource) {
            this.dataSource.uniqueIdentifier = null;
        }
        this.setView(this.gridConfig.selectedView.key, true);
        // this.gridApi.updateGridConfig(this.gridConfig);
        if (this.dwGrid) {
            this.dwGrid.gridConfig = this.gridConfig;
            this.dwGrid.setupStyling();
        }
    }
    handlePreferenceError(error) {
        const prefError = (error && error.message) ? error.message : error;
        this.errorMessage = `Error loading configuration: ${prefError}`;
        this.configComplete();
    }
    loadPreferences() {
        return this.metaDataGridService.getPreferenceHierarchy(this.item, this.getConfigKey(), this.allowConfiguration, this.preferences);
    }
    getPanelWidgetComponent() {
        return DwMetaDataGridConfigWidgetComponent;
    }
    ngOnDestroy() {
        this.uiConfigService.removeUiPanelWidget(this.item, DwUiConfigType.grid);
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    registerPanelWidget() {
        // Register Configuration Component
        let uiConfigComponent = new DwUiPanelWidgetConfig();
        uiConfigComponent.configKey = this.item;
        uiConfigComponent.widgetComponent = DwMetaDataGridConfigWidgetComponent;
        uiConfigComponent.uiConfigTypeId = DwUiConfigType.grid;
        this.uiConfigService.registerUiPanelWidget(uiConfigComponent);
    }
    /**
     * Fired after the grid actually applies the filter - after debounce time
     * @param filters
     */
    filtersApplied(filters) {
        const view = this.gridConfig.views.find(v => v.key == this.selectedViewKey);
        const eventData = deepCopy({
            itemName: this.item,
            gridConfig: this.gridConfig,
            filters: filters,
            view: view
        });
        this.dwEventService.publishEvent(DwGridEvents.filterChange, eventData);
    }
    filtersCleared() {
        this.dwMetaDataFilterStateService.clearFilters();
    }
    onGridEvent(event) {
        if (event.eventType == DwGridEventType.gridStateChanges) {
            this.handleGridStateChange(event);
        }
        if (event.eventType == DwGridEventType.rowContextMenu) {
            this.onContextMenu(true, event, event.browserEvent);
            return;
        }
        if (event.eventType == DwGridEventType.gridCellClick) {
            this.gridEvent.emit(event);
        }
        if (event.eventType == DwGridEventType.gridRowClick || event.eventType == DwGridEventType.gridRowDoubleClick) {
            this.gridEvent.emit(event);
            this.handleRowClick(event);
            return;
        }
        if (event.eventType == DwGridEventType.rowSelectionChange) {
            const view = this.gridConfig.views.find(v => v.key == this.selectedViewKey);
            const eventData = {
                itemName: this.item,
                gridConfig: this.gridConfig,
                view: view,
                selectedRows: event.eventData
            };
            this.dwEventService.publishEvent(DwGridEvents.rowSelectionChange, eventData);
            this.gridEvent.emit(event);
            return;
        }
        if (event.eventType == DwGridEventType.gridDataLoad) {
            const datasourceState = event.eventData;
            const view = this.gridConfig.views.find(v => v.key == this.selectedViewKey);
            const eventData = {
                itemName: this.item,
                gridConfig: this.gridConfig,
                view: view,
                loadedRowCount: datasourceState.loadedRowCount,
                totalRowCount: datasourceState.totalRowCount == -1 ? null : datasourceState.totalRowCount,
                allResults: datasourceState.allResults
            };
            //console.log('Grid Data Loaded Event', eventData);
            this.dwEventService.publishEvent(DwGridEvents.gridDataLoad, eventData);
            return;
        }
        if (event.eventType == DwGridEventType.editModeChange) {
            const editEventData = event.eventData;
            if (editEventData.isInEditMode) {
                this.metaDatagridApi.inlineEditApi.startInlineEdits(editEventData.updatedCount, false);
            }
            else {
                this.metaDatagridApi.inlineEditApi.cancelInLineEdits(editEventData.refreshGrid);
            }
            // this.gridContext.updatedCount = editEventData.updatedCount;
            // this.updateGridContext();
            return;
        }
        if (event.eventType == DwGridEventType.refresh) {
            const refreshEventData = {
                itemName: this.item,
                configKey: this.getConfigKey()
            };
            this.dwEventService.publishEvent(DwGridEvents.refreshData, refreshEventData);
        }
        if (event.actionPreference) {
            this.triggerActionPreference(event);
        }
        this.gridEvent.emit(event);
    }
    handleRowClick(event) {
        var _a;
        const preferences = this.gridConfig.actionPreferences[DwGridActionLocation.rowButton];
        // Ignore row click in edit mode
        if ((_a = this.gridContext) === null || _a === void 0 ? void 0 : _a.inEditMode) {
            return;
        }
        const clickActionPreference = preferences.find(pref => this.isRowClickMatch(event, pref));
        if (clickActionPreference) {
            event.actionPreference = clickActionPreference;
            this.triggerActionPreference(event);
        }
    }
    isRowClickMatch(event, pref) {
        var _a, _b;
        const rowClickConfig = event.eventType == DwGridEventType.gridRowClick ? (_a = pref.additionalActionConfig) === null || _a === void 0 ? void 0 : _a.rowClickOptions : (_b = pref.additionalActionConfig) === null || _b === void 0 ? void 0 : _b.rowDoubleClickOptions;
        if (rowClickConfig === null || rowClickConfig === void 0 ? void 0 : rowClickConfig.triggerOnClick) {
            return true;
        }
    }
    handleGridStateChange(event) {
        const eventColumnPrefereces = event.eventData;
        let existingColumnPreferences = this.gridConfig.selectedView.gridViewPreferences.columnPreferences;
        const selectedView = this.gridConfig.selectedView;
        // if we don't have any columns, conver the current view columnDefs to preferences
        if (!existingColumnPreferences || existingColumnPreferences.length == 0) {
            existingColumnPreferences = this.metaDataGridService.convertColumnDefsToColumnPrefs(selectedView.columnDefs);
        }
        // Update column preferences
        const updatedColumnPreferencesResult = this.metaDataGridService.updateColumnPrefs(existingColumnPreferences, eventColumnPrefereces);
        if (!updatedColumnPreferencesResult.hasChanges) {
            return;
        }
        const updatedColumnPreferences = updatedColumnPreferencesResult.columns;
        // selectedView.gridViewPreferences.columnPreferences = updatedColumnPreferences;
        // update columns defs
        const updatedColumnDefs = this.metaDataGridService.updateColumnDefs(selectedView.columnDefs, selectedView.gridViewPreferences.columnPreferences);
        selectedView.columnDefs = updatedColumnDefs;
        const selectedViewDefaults = selectedView.gridViewPreferences.defaults;
        // Update any other related default views
        this.metaDataGridService.updateViewDefaultColumns(this.gridConfig, selectedView, updatedColumnPreferences, updatedColumnDefs);
        const eventData = {
            itemName: this.item,
            columnPreferences: updatedColumnPreferences,
            viewKey: selectedView.key,
        };
        // Raise event for the grid State changes for the config panel
        this.dwEventService.publishEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.AdditionalDataEvent(this.getConfigKey(), DwUiConfigType.grid), eventData);
    }
    updateGridContext() {
        var _a;
        if (!((_a = this.gridConfig) === null || _a === void 0 ? void 0 : _a.resolvedContext)) {
            return;
        }
        this.gridContext = Object.assign({}, this.gridContext);
        this.gridConfig.resolvedContext[DwMdGridContextInfo.GRID_CONTEXT_NAME] = this.gridContext;
        this.gridConfig.actionPreferences = this.dwMetaDataGridActionService.buildFinalActionPreferences(this.gridConfig.selectedView.gridViewPreferences, this.preferences, this.preferenceHierarchy.itemSecurity, this.gridConfig.resolvedContext);
    }
    setView(viewKey, suppressGridSetup = false) {
        var _a, _b, _c, _d, _e;
        const newView = this.gridConfig.views.find(v => v.key === viewKey);
        if (!newView) {
            return;
        }
        this.gridConfig.selectedView = newView;
        //  this.gridConfig.selectedView.gridViewPreferences.sharedFilterExpression
        if (!this.preferences || !this.preferences.passCurrentDataSource) {
            const newDataSource = this.metaDataGridService.getDataSource(this.preferenceHierarchy, newView);
            if (this.isNewDataSource(newDataSource)) {
                if (this.originalDataSource) {
                    this.originalDataSource = this.dataSource;
                }
                this.dataSource = newDataSource;
            }
        }
        // Assign the query based on the current view
        this.configContext.metaDataQueryMeaning = this.gridConfig.selectedView.gridViewPreferences.metaDataQueryMeaning;
        let viewQueryMetaData = this.preferenceHierarchy.queryMetaData.find(qmd => qmd.QueryMeaning == newView.gridViewPreferences.metaDataQueryMeaning);
        if (!viewQueryMetaData) {
            viewQueryMetaData = this.preferenceHierarchy.queryMetaData.find(qmd => !qmd.MetaDataQueryId);
        }
        this.gridConfig.columnDefs = this.gridConfig.selectedView.columnDefs;
        this.gridConfig.filters = deepCopy(this.gridConfig.selectedView.gridViewPreferences.filters);
        this.gridConfig.filterTilesConfig = this.gridConfig.selectedView.gridViewPreferences.filterTilesConfig;
        this.gridConfig.sharedFilterExpression = this.gridConfig.selectedView.gridViewPreferences.sharedFilterExpression;
        this.gridConfig.actionPreferences = this.gridConfig.selectedView.actionPreferences;
        this.gridConfig.queryMetaData = this.gridConfig.selectedView.queryMetaData;
        this.gridConfig.useColumnFlex = this.gridConfig.selectedView.gridViewPreferences.useColumnFlex;
        this.gridConfig.showRowActionsOnRight = this.gridConfig.selectedView.gridViewPreferences.showRowActionsOnRight;
        this.gridConfig.actionColumnHeader = this.gridConfig.selectedView.gridViewPreferences.actionColumnHeader;
        let filterTileKey = '';
        if (((_c = (_b = (_a = this.gridConfig) === null || _a === void 0 ? void 0 : _a.filterTilesConfig) === null || _b === void 0 ? void 0 : _b.tiles) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            filterTileKey = (_e = (_d = this.gridConfig) === null || _d === void 0 ? void 0 : _d.filterTilesConfig) === null || _e === void 0 ? void 0 : _e.tiles[0].tileKey;
            // Only default the filter tile once
            if (!this.defaultFilerTile) {
                this.defaultFilerTile = this.dwMetaDataFilterService.getFilterTileQueryParam();
                if (this.defaultFilerTile) {
                    filterTileKey = this.defaultFilerTile;
                }
            }
            // TODO: check if we have a query string to selected a different tile
        }
        const initFilters = this.dwMetaDataFilterService.buildInitialFilters(this.gridConfig.filters, this.gridConfig.filterTilesConfig, filterTileKey, newView.gridViewPreferences.sharedFilterExpression, this.externalFilters, this.item, viewQueryMetaData, this.gridConfig.resolvedContext);
        //console.log('Grid initial filters', initFilters);
        this.filters = initFilters;
        const filterInitComplete = (this.gridConfig.filters.length == 0); // if there are no filters, then we are finished
        this.dwMetaDataFilterStateService.setFilters(initFilters, filterTileKey, filterInitComplete, true);
        this.gridContext.filterTileKey = filterTileKey;
        this.gridContext.viewKey = viewKey;
        this.gridContext.inEditMode = false;
        this.gridContext.updatedCount = 0;
        if (newView.gridViewPreferences.startInEditMode) {
            this.gridContext.inEditMode = true;
        }
        this.updateGridContext();
        this.gridConfig.showFilter = this.dwMetaDataFilterService.hasVisibleFilters(this.gridConfig.filters);
        if (this.dwGrid && this.dwGrid.gridInstance) {
            //console.log('Md Grid - set View - Update grid config', this.filters);
            this.dwGrid.updateGridConfig(this.gridConfig, this.dataSource, this.filters);
            // console.log('Md Grid - set View - Apply filters', this.filters);
            // // apply the filters immediately (otherwise they get set from the filter form after a configured delay)
            // this.dwGrid.applyFilters(this.filters);
        }
        // Raise event of any third party components to reflect the state of the grid
        const eventData = {
            itemName: this.item,
            gridConfig: this.gridConfig,
            view: newView,
            selectedViewKey: viewKey
        };
        this.dwEventService.publishEvent(DwGridEvents.selectedViewChange, eventData);
        // Raise event for the grid State changes for the config panel
        if (!suppressGridSetup) {
            this.dwEventService.publishEvent(DwUiConfigService.UICONFIG_EVENT_TOPIC.AdditionalDataEvent(this.getConfigKey(), DwUiConfigType.grid), eventData);
        }
    }
    isNewDataSource(newDataSource) {
        if (!this.dataSource) {
            return true;
        }
        if (this.dataSource.length !== undefined) {
            return false;
        }
        if (!areEqual(this.dataSource.item, newDataSource.item)) {
            return true;
        }
        if (this.dataSource.uniqueIdentifier != newDataSource.uniqueIdentifier) {
            return true;
        }
        return false;
    }
    onContextMenu(fromGrid = false, gridEvent, browserEvent) {
        if (!this.cmGrid) {
            return;
        }
        if (browserEvent && browserEvent.stopPropagation) {
            browserEvent.cancelBubble = true;
            browserEvent.returnValue = false;
            browserEvent.stopPropagation();
            browserEvent.preventDefault;
        }
        let gridMenus = [];
        if (fromGrid && this.gridApi) {
            let rowData = this.gridApi.getSelectedRows() || [];
            if (rowData.length == 0 && gridEvent && gridEvent.eventData) {
                rowData = [gridEvent.eventData];
            }
            this.currentRowData = rowData;
            const menuAction = (actionPref, event, additionalData) => {
                this.fireContextMenuGridEvent(actionPref, rowData, additionalData, browserEvent);
            };
            this.dwMetaDataGridActionService.buildActionMenus(this.gridConfig.selectedView.actionPreferences, menuAction, rowData, this.gridConfig.resolvedContext)
                .subscribe(gridMenus => {
                this.gridContextMenu = [...this.contextMenu, ...gridMenus];
                if (this.gridContextMenu.length > 0) {
                    this.cmGrid.show(browserEvent);
                }
            });
            return;
        }
        this.gridContextMenu = [...this.contextMenu, ...gridMenus];
        if (this.gridContextMenu.length > 0) {
            this.cmGrid.show(browserEvent);
        }
    }
    fireContextMenuGridEvent(actionPref, rowData, additionalData, event) {
        const gridEvent = {
            actionPreference: actionPref,
            eventCommand: actionPref.actionKey,
            eventData: rowData,
            eventType: DwGridEventType.gridActionButton,
            additionalData: additionalData,
            dwBrowserEvent: getDwBrowserEvent(event)
        };
        if (rowData && rowData.length == 1 && actionPref.actionConfig) {
            const gridActionConfig = actionPref.actionConfig;
            const menuConfig = actionPref.menuConfig || {};
            if (menuConfig.itemRequirement !== DwActionItemRequirement.multiple) {
                gridEvent.eventData = rowData[0];
            }
        }
        this.onGridEvent(gridEvent);
    }
    triggerActionPreference(event) {
        const actionPref = event.actionPreference;
        let actionState = {
            metaDataGridApi: this.metaDatagridApi,
            actionConfig: actionPref.actionConfig,
            gridConfigContext: this.configContext,
            actionPreference: actionPref,
            gridConfig: this.gridConfig,
            command: event.eventCommand,
            event: event,
            data: event.eventData,
            context: this.gridConfig.resolvedContext,
            dwBrowserEvent: event.dwBrowserEvent
        };
        // Check if action should be hidden or invisible (these shouldn't be executed)
        if (this.dwMetaDataActionExpressionService.isActionDisabledOrInvisible(actionPref, event.eventData, this.gridConfig.resolvedContext)) {
            return;
        }
        this.dwActionExecutionService.executeActionPreference(actionPref, actionState)
            .subscribe((actionResult) => {
            this.handleActionResult(actionResult);
        }, (error) => {
            this.handleActionError(actionPref, error);
        });
    }
    handleActionError(actionPref, error) {
        const message = error.message ? error.message : error.toString();
        this.setGridMessage({
            messageHeading: `Error executing action: ${actionPref.actionDisplay || actionPref.actionKey}`,
            messageBody: message,
            allowClose: true,
            timeToShow: 4000,
            severity: DwMessageSeverity.error
        });
    }
    handleActionResult(actionResult) {
        if (!actionResult || actionResult.cancelled) {
            return;
        }
        this.processDataResults(actionResult);
        if (!actionResult.message) {
            actionResult.hideMessage = true;
            actionResult.message = '';
        }
        // Failure with Message
        let messageToShow;
        if (typeof (actionResult.message) === "string") {
            messageToShow = {
                messageBody: actionResult.message,
                severity: actionResult.success ? DwMessageSeverity.success : DwMessageSeverity.error,
                allowClose: !actionResult.success,
                timeToShow: actionResult.success ? 5000 : null,
            };
        }
        else {
            messageToShow = actionResult.message;
        }
        ;
        if (!actionResult.hideMessage) {
            this.setGridMessage(messageToShow);
        }
        else {
            this.clearGridMessage();
        }
    }
    processDataResults(actionResult) {
        if (actionResult.refreshData) {
            this.gridApi.refreshDataSource(true);
        }
        if (!actionResult.dataActionResult) {
            return;
        }
        // Ignore next refresh until we process data action results
        this.ignoreNextRefreshEvent = true;
        setTimeout(() => {
            this.ignoreNextRefreshEvent = false;
        }, 20);
        this.gridApi.processDataActionResult(actionResult.dataActionResult);
    }
}
DwMetaDataGridComponent.ɵfac = function DwMetaDataGridComponent_Factory(t) { return new (t || DwMetaDataGridComponent)(ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwActionExecutionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridActionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionExpressionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwRoutingServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwMetaDataGridComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataGridComponent, selectors: [["dw-meta-data-grid"]], viewQuery: function DwMetaDataGridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DwGridComponent, true);
        ɵngcc0.ɵɵstaticViewQuery(_c63, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwGrid = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cmGrid = _t.first);
    } }, inputs: { ignoreAddEditEvents: "ignoreAddEditEvents", configKeyPart: "configKeyPart", readOnly: "readOnly", externalFilters: ["filters", "externalFilters"], dataSource: "dataSource", item: "item", addContext: "addContext", gridCallbacks: "gridCallbacks" }, outputs: { gridEvent: "gridEvent" }, features: [ɵngcc0.ɵɵProvidersFeature([DwMetaDataFilterStateService]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 9, consts: [["dwPageDesignerSelector", "", 1, "dw-grid", 3, "configKey", "sectionKey", "contextmenu"], ["container2", ""], ["text", "Configuring Grid", 3, "show"], ["class", "alert alert-danger", 4, "ngIf"], [3, "message", "messageChange"], [4, "ngIf"], [3, "ngClass", 4, "ngIf"], ["appendTo", "body", 3, "target", "model"], ["cmGrid", ""], [1, "alert", "alert-danger"], [1, "fa", "fa-lock", "fa-2x"], [3, "ngClass"], ["gridContainer", ""], [3, "gridConfig", "configContext", "resolvedContext", "data", "filters", "triggerContextMenu", "gridReady", "filtersApplied", "filtersCleared", "gridEvent"], ["filterTiles", "", 4, "ngIf"], ["filter", "", 4, "ngIf"], ["rightPanel", ""], [3, "configContext", "configKeyPart", "filterConfig", "sharedFilterExpression"], ["actions", ""], [1, "dw-grid-view", 3, "hidden"], ["optionLabel", "display", "optionValue", "key", "appendTo", "body", 3, "options", "ngModel", "filter", "ngModelChange"], ["filterTiles", ""], [3, "configKey", "viewKey", "configContext", "tilesConfig", "sharedFilterExpression"], ["filter", ""], [3, "configKey", "viewKey", "configContext", "configKeyPart", "filterConfig", "sharedFilterExpression"]], template: function DwMetaDataGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("contextmenu", function DwMetaDataGridComponent_Template_div_contextmenu_0_listener($event) { return ctx.onContextMenu(false, null, $event); });
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelement(3, "dw-loading", 2);
        ɵngcc0.ɵɵtemplate(4, DwMetaDataGridComponent_div_4_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "dw-message", 4);
        ɵngcc0.ɵɵlistener("messageChange", function DwMetaDataGridComponent_Template_dw_message_messageChange_5_listener($event) { return ctx.gridMessage = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "dw-action-host");
        ɵngcc0.ɵɵtemplate(7, DwMetaDataGridComponent_div_7_Template, 4, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(8, DwMetaDataGridComponent_div_8_Template, 11, 21, "div", 6);
        ɵngcc0.ɵɵelement(9, "p-contextMenu", 7, 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        ɵngcc0.ɵɵproperty("configKey", ctx.gridConfig == null ? null : ctx.gridConfig.configKey)("sectionKey", ctx.selectedViewKey);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("show", !ctx.gridConfig && !ctx.errorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.gridMessage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.gridConfig && ctx.gridConfig.accessErrorMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.gridConfig && ctx.gridConfig.canAccess);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("target", _r0)("model", ctx.gridContextMenu);
    } }, directives: function () { return [DwDesignerSelector, DwLoadingComponent, ɵngcc4.NgIf, DwMessageComponent, DwActionHostComponent, ɵngcc7.ContextMenu, ɵngcc4.NgClass, DwGridComponent, DwMetadataFiltersVerticalComponent, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwMetadataFilterTilesComponent, DwMetadataFiltersComponent]; }, encapsulation: 2 });
DwMetaDataGridComponent.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataGridService },
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwMetaDataFilterService },
    { type: DwActionExecutionService },
    { type: DwMetaDataGridActionService },
    { type: DwMetaDataActionExpressionService },
    { type: Router },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] },
    { type: DwMetaDataFilterStateService },
    { type: DwContextService }
];
DwMetaDataGridComponent.propDecorators = {
    item: [{ type: Input }],
    ignoreAddEditEvents: [{ type: Input }],
    gridEvent: [{ type: Output }],
    configKeyPart: [{ type: Input }],
    addContext: [{ type: Input }],
    readOnly: [{ type: Input }],
    gridCallbacks: [{ type: Input }],
    dwGrid: [{ type: ViewChild, args: [DwGridComponent, { static: false },] }],
    dataSource: [{ type: Input }],
    externalFilters: [{ type: Input, args: ['filters',] }],
    cmGrid: [{ type: ViewChild, args: ['cmGrid', { static: true },] }]
};

class DwFormControlInputComponent {
    constructor() {
        this.inputClass = "form-control";
        // @Output() blur = new EventEmitter<any>();
        // (blur)="onBlur($event)
        // onBlur(event) {
        //   this.blur.emit(event);
        // }
    }
}
DwFormControlInputComponent.ɵfac = function DwFormControlInputComponent_Factory(t) { return new (t || DwFormControlInputComponent)(); };
DwFormControlInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlInputComponent, selectors: [["dw-fc-input"]], inputs: { context: "context" }, decls: 2, vars: 6, consts: [[3, "formGroup"], [3, "formControlName", "id", "placeholder", "inputClass", "options"]], template: function DwFormControlInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-input", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("id", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "")("inputClass", ctx.inputClass)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwInputComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlInputComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwQueryParam {
}

class DwLookupParameterUtilService {
    constructor(dwExpressionService, dwExpressionStateService) {
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionStateService = dwExpressionStateService;
    }
    getQueryParams(lookupDef, paramValues) {
        let params = [];
        if (lookupDef.DwMetaDataLookupParam && lookupDef.DwMetaDataLookupParam.length > 0) {
            if (!paramValues) {
                // console.warn(`dwSelectLookup - loadLookup ${lookupDef.LookupId} - paramValues not set.  Waiting to re-load when we do!`);
                //this.setupLookupItems([]);
                return null;
            }
            let index = 0;
            for (let lookupParamDef of lookupDef.DwMetaDataLookupParam) {
                const lookupParam = new DwQueryParam();
                lookupParam.ParamName = lookupParamDef.UseAttribute ? lookupParamDef.AttributeName : lookupParamDef.ParamNameOverride;
                if (Array.isArray(paramValues)) {
                    lookupParam.ParamValue = paramValues[index];
                }
                else {
                    lookupParam.ParamValue = paramValues[lookupParamDef.AttributeName];
                }
                if (!lookupParam.ParamValue && !lookupParamDef.DefaultValue && lookupParamDef.IsRequired) {
                    //console.warn(`dwSelectLookup - loadLookup ${lookupDef.MetaDataLookupId} - Param Value ${lookupParamDef.AttributeName} doesn't have a passed in value.  Waiting to re-load when we do!`);
                    //this.setupLookupItems([]);
                    return null;
                }
                params.push(lookupParam);
                index++;
            }
        }
        return params;
    }
    setupLookupParameterExpressionSetWithQueryParams(lookupDef, fieldDef, paramReferences, formGroup, context) {
        const expressionReferenceSet = this.buildLookupParameterExpressionReferenceSet(fieldDef, paramReferences);
        const expressionReferenceSetResult = this.dwExpressionStateService.initExpressionReferenceSet(expressionReferenceSet, formGroup, context);
        // map generics results to a parameter value array
        const typedResult = {
            initialResults: this.buildQueryParamArray(lookupDef, expressionReferenceSetResult.initialResults),
            observable: expressionReferenceSetResult.observable
                .pipe(map(results => this.buildQueryParamArray(lookupDef, results)))
        };
        return typedResult;
    }
    setupLookupParameterExpressionSet(fieldDef, paramReferences, formGroup, context) {
        const expressionReferenceSet = this.buildLookupParameterExpressionReferenceSet(fieldDef, paramReferences);
        const expressionReferenceSetResult = this.dwExpressionStateService.initExpressionReferenceSet(expressionReferenceSet, formGroup, context);
        // map generics results to a parameter value array
        const typedResult = {
            initialResults: this.buildParameterValueArray(expressionReferenceSetResult.initialResults),
            observable: expressionReferenceSetResult.observable
                .pipe(map(results => this.buildParameterValueArray(results)))
        };
        return typedResult;
    }
    buildParameterValueArray(initialResults) {
        const paramValues = [];
        for (const key in initialResults) {
            const result = initialResults[key];
            paramValues.push(result.result);
        }
        return paramValues;
    }
    buildQueryParamArray(lookupDef, initialResults) {
        const paramValues = [];
        for (const key in initialResults) {
            const result = initialResults[key];
            paramValues.push(result.result);
        }
        return this.getQueryParams(lookupDef, paramValues);
        return paramValues;
    }
    buildLookupParameterExpressionReferenceSet(fieldDef, paramReferences) {
        var _a, _b;
        paramReferences = paramReferences || [];
        if ((_a = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.attr) === null || _a === void 0 ? void 0 : _a.MetaDataLookupParamAttribute1Name) {
            if (this.dwExpressionService.isEmpyExpressionReference(paramReferences[0])) {
                paramReferences[0] = {
                    referenceType: DwExpressionReferenceType.item,
                    attrName: fieldDef.attr.MetaDataLookupParamAttribute1Name
                };
            }
        }
        if ((_b = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.attr) === null || _b === void 0 ? void 0 : _b.MetaDataLookupParamAttribute2Name) {
            if (this.dwExpressionService.isEmpyExpressionReference(paramReferences[1])) {
                paramReferences[1] = {
                    referenceType: DwExpressionReferenceType.item,
                    attrName: fieldDef.attr.MetaDataLookupParamAttribute2Name
                };
            }
        }
        const expressionReferenceSet = {
            defaultResult: null,
            delayMs: 100,
            isArray: false,
            expressionReferences: {}
        };
        let index = 0;
        for (const paramReference of paramReferences) {
            expressionReferenceSet.expressionReferences[index] = paramReference;
            //this.setupParamReferenceSubscription(paramReference, index, formGroup, context);
            index++;
        }
        return expressionReferenceSet;
    }
}
DwLookupParameterUtilService.ɵfac = function DwLookupParameterUtilService_Factory(t) { return new (t || DwLookupParameterUtilService)(ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwExpressionStateService)); };
DwLookupParameterUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwLookupParameterUtilService_Factory() { return new DwLookupParameterUtilService(ɵɵinject(DwExpressionService), ɵɵinject(DwExpressionStateService)); }, token: DwLookupParameterUtilService, providedIn: "root" });
DwLookupParameterUtilService.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwExpressionStateService }
];

class DwFormControlLookupComponent {
    constructor(dwMetaDataService, dwExpressionService, dwLookupParameterUtilService, cdr) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwExpressionService = dwExpressionService;
        this.dwLookupParameterUtilService = dwLookupParameterUtilService;
        this.cdr = cdr;
        this.paramValues = [];
        this.subscriptions = [];
        this.hasParameters = false;
        this.isContextControl = false;
    }
    initControl() {
        this.loadLookupDef();
    }
    ngOnDestroy() {
        if (this.fieldDef && this.fieldDef.attr && this.fieldDef.attr.MetaDataLookupParamAttribute1Name)
            //console.log(`DwFormControlLookupComponent - OnDestrory ${this.fieldDef.attr.MetaDataLookupId}`);
            for (let subscription of this.subscriptions) {
                subscription.unsubscribe();
            }
    }
    loadLookupDef() {
        if (!this.fieldDef || !this.formGroup)
            return;
        this.lookupId = this.fieldDef.attr.MetaDataLookupId;
        // Check if lookup is overriden
        if (this.fieldDef.lookupConfig && this.fieldDef.lookupConfig.useLookupOverride) {
            if (this.fieldDef.lookupConfig && this.fieldDef.lookupConfig.lookupIdOverride && this.fieldDef.lookupConfig.lookupIdOverride.value) {
                this.lookupId = parseInt(this.fieldDef.lookupConfig.lookupIdOverride.value);
            }
        }
        if (!this.lookupId) {
            return;
        }
        this.dwMetaDataService.getLookupDefinition(this.lookupId).subscribe((lookupDef) => {
            this.lookupDef = lookupDef;
            this.setupLookup();
        });
    }
    setupLookup() {
        var _a, _b, _c, _d;
        if (!this.lookupDef || !this.fieldDef)
            return;
        // Check if we have parameters first
        if (((_b = (_a = this.lookupDef) === null || _a === void 0 ? void 0 : _a.DwMetaDataLookupParam) === null || _b === void 0 ? void 0 : _b.length) == 0) {
            return;
        }
        this.hasParameters = true;
        if (this.fieldDef.contextName) {
            this.isContextControl = true;
        }
        this.paramReferences = [];
        if (((_d = (_c = this.fieldDef.lookupConfig) === null || _c === void 0 ? void 0 : _c.lookupParamAttributeOverrides) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            const hasReferences = this.fieldDef.lookupConfig.lookupParamAttributeOverrides.filter(ref => !this.dwExpressionService.isEmpyExpressionReference(ref)).length > 0;
            if (hasReferences) {
                this.paramReferences = this.fieldDef.lookupConfig.lookupParamAttributeOverrides;
            }
        }
        this.setupLookupParameters(this.paramReferences);
        //this.setupAlternativeSubscription();
    }
    setupLookupParameters(paramReferences, performInitialOnly = false) {
        const formGroup = this.isContextControl ? this.formGroup.root : this.formGroup;
        this.parameterExpressionSetResult = this.dwLookupParameterUtilService.setupLookupParameterExpressionSet(this.fieldDef, paramReferences, formGroup, this.context);
        this.paramValues = this.parameterExpressionSetResult.initialResults;
        if (!performInitialOnly) {
            this.parameterExpressionSetResult.observable.subscribe(results => {
                this.paramValues = results;
                this.cdr.detectChanges();
            });
        }
    }
    setupAlternativeSubscription() {
        const formGroup = this.isContextControl ? this.formGroup.root : this.formGroup;
        formGroup.valueChanges.subscribe((rootFormValue) => {
            if (rootFormValue.CustomerId) {
                this.setupLookupParameters(this.paramReferences, true);
            }
        });
    }
}
DwFormControlLookupComponent.ɵfac = function DwFormControlLookupComponent_Factory(t) { return new (t || DwFormControlLookupComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwLookupParameterUtilService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwFormControlLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlLookupComponent, selectors: [["dw-fc-dropdown"]], inputs: { context: "context" }, decls: 3, vars: 10, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], [4, "ngIf"], [3, "formControlName", "options", "lookupId", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField"]], template: function DwFormControlLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwFormControlLookupComponent_span_1_Template, 3, 2, "span", 1);
        ɵngcc0.ɵɵelement(2, "dw-select-lookup", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false && (ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.MetaDataLookupParamAttribute1Name));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("lookupId", ctx.lookupId)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.alternateValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, DwSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });
DwFormControlLookupComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionService },
    { type: DwLookupParameterUtilService },
    { type: ChangeDetectorRef }
];
DwFormControlLookupComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwDynamicFieldDirective {
    constructor(resolver, container) {
        this.resolver = resolver;
        this.container = container;
        this.subscriptions = [];
    }
    ngOnInit() {
        let component = DwFormControlInputComponent;
        if (this.fieldDef.attr.MetaDataLookupId)
            component = DwFormControlLookupComponent;
        const componentFactory = this.resolver.resolveComponentFactory(component);
        this.componentRef = this.container.createComponent(componentFactory);
        this.componentInstance = this.componentRef.instance;
        this.componentInstance.fieldDef = this.fieldDef;
        this.componentInstance.formGroup = this.formGroup;
    }
    ngOnChanges(changes) {
        if (!this.componentInstance)
            return;
        if (changes.fieldDef && changes.fieldDef.currentValue) {
            this.componentInstance.fieldDef = this.fieldDef;
        }
        if (changes.formGroup && changes.formGroup.currentValue) {
            this.componentInstance.formGroup = this.formGroup;
        }
    }
}
DwDynamicFieldDirective.ɵfac = function DwDynamicFieldDirective_Factory(t) { return new (t || DwDynamicFieldDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
DwDynamicFieldDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwDynamicFieldDirective, selectors: [["", "dwDynamicField2", ""]], inputs: { fieldDef: "fieldDef", formGroup: "formGroup" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwDynamicFieldDirective.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: ViewContainerRef }
];
DwDynamicFieldDirective.propDecorators = {
    fieldDef: [{ type: Input }],
    formGroup: [{ type: Input }]
};

class DwFormControlNumericInputComponent {
    constructor() {
        this.inputClass = "form-control";
    }
    initControl() {
        this.controlOptions = Object.assign({}, this.fieldDef.controlOptions) || {};
        if (this.fieldDef.controlType == DwControlType.CurrencyTextBox) {
            if (!this.controlOptions.prefix) {
                this.controlOptions.prefix = '$';
            }
            if (!this.controlOptions.decimalsOverride && this.controlOptions.decimalsOverride !== 0) {
                this.controlOptions.decimalsOverride = 2;
            }
            this.fieldDef.controlOptions = this.controlOptions;
        }
    }
}
DwFormControlNumericInputComponent.ɵfac = function DwFormControlNumericInputComponent_Factory(t) { return new (t || DwFormControlNumericInputComponent)(); };
DwFormControlNumericInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlNumericInputComponent, selectors: [["dw-fc-numeric-input"]], inputs: { context: "context" }, decls: 2, vars: 8, consts: [[3, "formGroup"], [3, "formControlName", "placeholder", "maxlength", "inputClass", "numeric", "decimals", "options"]], template: function DwFormControlNumericInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-input", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "")("maxlength", (ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.MaxLength) || 10)("inputClass", ctx.inputClass)("numeric", true)("decimals", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.Decimals)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwInputComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.MaxLengthValidator], encapsulation: 2 });
DwFormControlNumericInputComponent.ctorParameters = () => [];
DwFormControlNumericInputComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlTextAreaComponent {
    constructor() {
        this.inputClass = "form-control";
    }
    initControl() {
        if (!this.fieldDef || !this.fieldDef.controlOptions) {
            return;
        }
        const textAreaOptions = this.fieldDef.controlOptions;
        if (textAreaOptions.height) {
            this.style = {
                height: textAreaOptions.height
            };
        }
    }
}
DwFormControlTextAreaComponent.ɵfac = function DwFormControlTextAreaComponent_Factory(t) { return new (t || DwFormControlTextAreaComponent)(); };
DwFormControlTextAreaComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlTextAreaComponent, selectors: [["dw-fc-textarea"]], inputs: { context: "context" }, decls: 2, vars: 7, consts: [[3, "formGroup"], [3, "formControlName", "placeholder", "rows", "ngStyle"]], template: function DwFormControlTextAreaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "textarea", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.inputClass);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "")("rows", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions == null ? null : ctx.fieldDef.controlOptions.rows)("ngStyle", ctx.style);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgStyle], encapsulation: 2 });
DwFormControlTextAreaComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlHtmlEditorComponent {
    constructor() {
        this.inputClass = "";
    }
}
DwFormControlHtmlEditorComponent.ɵfac = function DwFormControlHtmlEditorComponent_Factory(t) { return new (t || DwFormControlHtmlEditorComponent)(); };
DwFormControlHtmlEditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlHtmlEditorComponent, selectors: [["dw-fc-html-editor"]], inputs: { context: "context" }, decls: 3, vars: 2, consts: [[3, "formGroup"], ["container", ""], [3, "formControlName"]], template: function DwFormControlHtmlEditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelement(2, "dw-html-edit", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwHtmlEditComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlHtmlEditorComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwDataListPreferences extends DwUiPreferencesBase {
    constructor() {
        super(DwUiConfigType.list);
        this.showActions = false;
        this.autoFilter = true;
        this.autoFilterDelay = 200;
        this.hideRefresh = false;
        this.hideViewToggle = false;
    }
}

class DwMetaDataListPreferences extends DwDataListPreferences {
    constructor() {
        super(...arguments);
        this.filters = [];
    }
}

class DwFormControlReadOnlyComponent {
    constructor(uiMetaDataConfig) {
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.useDisplayField = false;
    }
    ngOnInit() {
        this.setupDisplayField();
    }
    setupDisplayField() {
        if (!this.fieldDef) {
            return;
        }
        this.fieldControlName = this.fieldDef.attrName;
        if (this.useDisplayField) {
            const displayControlName = `${this.fieldDef.attrName}Display`;
            const displayControl = this.formGroup.get(displayControlName);
            if (displayControl) {
                this.fieldControlName = displayControlName;
            }
        }
    }
    useGmtDateTime() {
        if (this.fieldDef && this.fieldDef.attr) {
            if (this.fieldDef.attr.UseGmtDateTime === true || this.fieldDef.attr.UseGmtDateTime === false) {
                return this.fieldDef.attr.UseGmtDateTime;
            }
        }
        return this.uiMetaDataConfig.useGmtDateTime;
    }
    use24HourTime() {
        return this.uiMetaDataConfig.use24HourTime;
    }
    getFormatType() {
        if (!this.fieldDef || !this.fieldDef.attr)
            return;
        switch (this.fieldDef.attr.AttributeType) {
            case DwAttributeType.Date:
                return DwFormatTypes.date;
            case DwAttributeType.DateTime:
                return DwFormatTypes.datetime;
            case DwAttributeType.YesNo:
                return DwFormatTypes.yesNo;
        }
    }
}
DwFormControlReadOnlyComponent.ɵfac = function DwFormControlReadOnlyComponent_Factory(t) { return new (t || DwFormControlReadOnlyComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken)); };
DwFormControlReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlReadOnlyComponent, selectors: [["dw-fc-readonly"]], inputs: { useDisplayField: "useDisplayField", context: "context" }, decls: 2, vars: 6, consts: [[3, "formGroup"], [3, "formControlName", "formatType", "missingDataText", "useGmtDateTime", "use24HourTime"]], template: function DwFormControlReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldControlName)("formatType", ctx.getFormatType())("missingDataText", (ctx.fieldDef == null ? null : ctx.fieldDef.readOnlyMissingDataText) || "None")("useGmtDateTime", ctx.useGmtDateTime())("use24HourTime", ctx.use24HourTime());
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwReadOnlyControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlReadOnlyComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwFormControlReadOnlyComponent.propDecorators = {
    useDisplayField: [{ type: Input }],
    context: [{ type: Input }]
};

class DwFormControlLookupReadOnlyComponent extends DwFormControlLookupComponent {
    constructor(dwMetaDataService, dwExpressionService, dwLookupParamterUtilService, cdr) {
        super(dwMetaDataService, dwExpressionService, dwLookupParamterUtilService, cdr);
    }
}
DwFormControlLookupReadOnlyComponent.ɵfac = function DwFormControlLookupReadOnlyComponent_Factory(t) { return new (t || DwFormControlLookupReadOnlyComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwLookupParameterUtilService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwFormControlLookupReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlLookupReadOnlyComponent, selectors: [["dw-fc-lookup-readonly"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 9, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], [3, "formControlName", "lookupId", "missingDataText", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField"]], template: function DwFormControlLookupReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-lookup-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("missingDataText", (ctx.fieldDef == null ? null : ctx.fieldDef.readOnlyMissingDataText) || "None")("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.alternateValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwLookupReadonlyComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });
DwFormControlLookupReadOnlyComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionService },
    { type: DwLookupParameterUtilService },
    { type: ChangeDetectorRef }
];

class DwFormControlHtmlReadOnlyComponent {
    constructor() {
        this.inputClass = "";
    }
}
DwFormControlHtmlReadOnlyComponent.ɵfac = function DwFormControlHtmlReadOnlyComponent_Factory(t) { return new (t || DwFormControlHtmlReadOnlyComponent)(); };
DwFormControlHtmlReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlHtmlReadOnlyComponent, selectors: [["dw-fc-html-readonly"]], inputs: { context: "context" }, decls: 2, vars: 3, consts: [[3, "formGroup"], [3, "formControlName", "missingDataText"]], template: function DwFormControlHtmlReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-html-view", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("missingDataText", (ctx.fieldDef == null ? null : ctx.fieldDef.readOnlyMissingDataText) || "");
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlHtmlReadOnlyComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlInputYesNoDropdownComponent {
}
DwFormControlInputYesNoDropdownComponent.ɵfac = function DwFormControlInputYesNoDropdownComponent_Factory(t) { return new (t || DwFormControlInputYesNoDropdownComponent)(); };
DwFormControlInputYesNoDropdownComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlInputYesNoDropdownComponent, selectors: [["dw-fc-input-yesno-dropdown"]], inputs: { context: "context" }, decls: 2, vars: 3, consts: [[3, "formGroup"], ["allowNull", "true", "showAsDropdown", "true", 3, "formControlName"]], template: function DwFormControlInputYesNoDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-yesno", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
        ɵngcc0.ɵɵattribute("id", (ctx.fieldDef == null ? null : ctx.fieldDef.attrName) || "");
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlInputYesNoDropdownComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlUrlReadOnlyComponent {
}
DwFormControlUrlReadOnlyComponent.ɵfac = function DwFormControlUrlReadOnlyComponent_Factory(t) { return new (t || DwFormControlUrlReadOnlyComponent)(); };
DwFormControlUrlReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlUrlReadOnlyComponent, selectors: [["dw-fc-url-readonly"]], inputs: { context: "context" }, decls: 2, vars: 3, consts: [[3, "formGroup"], [3, "formControlName", "missingDataText"]], template: function DwFormControlUrlReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-url-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("missingDataText", (ctx.fieldDef == null ? null : ctx.fieldDef.readOnlyMissingDataText) || "None");
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwUrlReadOnlyControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlUrlReadOnlyComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlSearchLookupComponent extends DwFormControlLookupComponent {
}
DwFormControlSearchLookupComponent.ɵfac = function DwFormControlSearchLookupComponent_Factory(t) { return ɵDwFormControlSearchLookupComponent_BaseFactory(t || DwFormControlSearchLookupComponent); };
DwFormControlSearchLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlSearchLookupComponent, selectors: [["dw-fc-dropdown"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 11, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], [4, "ngIf"], [3, "formControlName", "options", "lookupId", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField", "placeholder"]], template: function DwFormControlSearchLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwFormControlSearchLookupComponent_span_1_Template, 3, 2, "span", 1);
        ɵngcc0.ɵɵelement(2, "dw-search-select-lookup", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false && (ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.MetaDataLookupParamAttribute1Name));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("lookupId", ctx.lookupId)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "");
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

class DwFormControlAutoCompleteLookupComponent extends DwFormControlLookupComponent {
}
DwFormControlAutoCompleteLookupComponent.ɵfac = function DwFormControlAutoCompleteLookupComponent_Factory(t) { return ɵDwFormControlAutoCompleteLookupComponent_BaseFactory(t || DwFormControlAutoCompleteLookupComponent); };
DwFormControlAutoCompleteLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlAutoCompleteLookupComponent, selectors: [["dw-fc-autocomplete"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], ["useServerSearch", "false", 3, "formControlName", "lookupId", "options", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField", "placeholder"]], template: function DwFormControlAutoCompleteLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-auto-complete-lookup", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "");
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwAutoCompleteLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

class DwFormControlAutoCompleteServerLookupComponent extends DwFormControlLookupComponent {
}
DwFormControlAutoCompleteServerLookupComponent.ɵfac = function DwFormControlAutoCompleteServerLookupComponent_Factory(t) { return ɵDwFormControlAutoCompleteServerLookupComponent_BaseFactory(t || DwFormControlAutoCompleteServerLookupComponent); };
DwFormControlAutoCompleteServerLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlAutoCompleteServerLookupComponent, selectors: [["dw-fc-autocomplete-server"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], ["useServerSearch", "true", 3, "formControlName", "lookupId", "options", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField", "placeholder"]], template: function DwFormControlAutoCompleteServerLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-auto-complete-lookup", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "");
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwAutoCompleteLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

class DwFormControlCalcFieldComponent {
}
DwFormControlCalcFieldComponent.ɵfac = function DwFormControlCalcFieldComponent_Factory(t) { return new (t || DwFormControlCalcFieldComponent)(); };
DwFormControlCalcFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlCalcFieldComponent, selectors: [["dw-fc-calc-field"]], inputs: { context: "context" }, decls: 2, vars: 5, consts: [[3, "formGroup"], [3, "formControlName", "id", "context", "options"]], template: function DwFormControlCalcFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-calc", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("id", (ctx.fieldDef == null ? null : ctx.fieldDef.attrName) || "")("context", ctx.context)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwCalcComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlCalcFieldComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlDateFieldConfigComponent {
    constructor() {
        this.controlOptions = {};
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    setupControl() {
        if (!this.controlOptions) {
            this.controlOptions = {};
        }
        this.controlOptions.validDays = this.controlOptions.validDays || [true, true, true, true, true, true, true];
        this.controlOptions.minDate = this.controlOptions.minDate || {};
        this.controlOptions.maxDate = this.controlOptions.maxDate || {};
    }
}
DwFormControlDateFieldConfigComponent.ɵfac = function DwFormControlDateFieldConfigComponent_Factory(t) { return new (t || DwFormControlDateFieldConfigComponent)(); };
DwFormControlDateFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlDateFieldConfigComponent, selectors: [["dw-fc-date-field-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 21, vars: 5, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 2, "overflow", "auto", "min-height", "50px"], ["type", "checkbox", 3, "ngModel", "ngModelChange"]], template: function DwFormControlDateFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2, " Set Valid Days ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_p_inputSwitch_ngModelChange_4_listener($event) { return ctx.controlOptions.validDaysSet = $event; })("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_p_inputSwitch_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwFormControlDateFieldConfigComponent_div_5_Template, 19, 7, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 0);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtext(8, " Months to show ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_input_ngModelChange_10_listener($event) { return ctx.controlOptions.monthsToShow = $event; })("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_input_ngModelChange_10_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵtext(13, " Min Date of today ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 2);
        ɵngcc0.ɵɵelementStart(15, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_p_inputSwitch_ngModelChange_15_listener($event) { return ctx.controlOptions.minDate.isToday = $event; })("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_p_inputSwitch_ngModelChange_15_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 0);
        ɵngcc0.ɵɵelementStart(17, "div", 1);
        ɵngcc0.ɵɵtext(18, " Max Date of today ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 2);
        ɵngcc0.ɵɵelementStart(20, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_p_inputSwitch_ngModelChange_20_listener($event) { return ctx.controlOptions.maxDate.isToday = $event; })("ngModelChange", function DwFormControlDateFieldConfigComponent_Template_p_inputSwitch_ngModelChange_20_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.validDaysSet);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.controlOptions.validDaysSet);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.monthsToShow);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.minDate.isToday);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.maxDate.isToday);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.CheckboxControlValueAccessor], encapsulation: 2 });
DwFormControlDateFieldConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwFormControlCalcFieldConfigComponent {
    constructor() {
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    setupControl() {
        if (!this.controlOptions) {
            this.controlOptions = { formula: '' };
        }
    }
}
DwFormControlCalcFieldConfigComponent.ɵfac = function DwFormControlCalcFieldConfigComponent_Factory(t) { return new (t || DwFormControlCalcFieldConfigComponent)(); };
DwFormControlCalcFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlCalcFieldConfigComponent, selectors: [["dw-fc-calc-field-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 19, vars: 5, consts: [["dwCol", "12"], ["title", "Add data fields to the formula using data.FieldName.  Uses Math.js", 1, "fas", "fa-info-circle", "info-spacer"], [1, "form-control", "formula-text", 3, "ngModel", "ngModelChange"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [4, "ngIf"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Replacement value for blank fields (these will error in math.js)", 1, "fas", "fa-info-circle", "info-spacer"], [3, "options", "itemName"]], template: function DwFormControlCalcFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label");
        ɵngcc0.ɵɵtext(2, "Formula");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "i", 1);
        ɵngcc0.ɵɵelementStart(4, "textarea", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_Template_textarea_ngModelChange_4_listener($event) { return ctx.controlOptions.formula = $event; })("ngModelChange", function DwFormControlCalcFieldConfigComponent_Template_textarea_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "More Options");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "p-inputSwitch", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_Template_p_inputSwitch_ngModelChange_10_listener($event) { return ctx.showMoreOptions = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, DwFormControlCalcFieldConfigComponent_ng_container_11_Template, 18, 4, "ng-container", 7);
        ɵngcc0.ɵɵelementStart(12, "div", 3);
        ɵngcc0.ɵɵelementStart(13, "div", 4);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Show Tester");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 5);
        ɵngcc0.ɵɵelementStart(17, "p-inputSwitch", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldConfigComponent_Template_p_inputSwitch_ngModelChange_17_listener($event) { return ctx.showTester = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, DwFormControlCalcFieldConfigComponent_ng_container_18_Template, 2, 2, "ng-container", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.formula);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.showMoreOptions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMoreOptions);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.showTester);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showTester);
    } }, directives: function () { return [DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwRowDirective, ɵngcc10.InputSwitch, ɵngcc4.NgIf, DwFormControlCalcFieldTesterComponent]; }, styles: [".formula-text[_ngcontent-%COMP%] {\n        height:150px !important;\n    }\n\n    .info-spacer[_ngcontent-%COMP%] {\n        margin-left:5px;\n    }"] });
DwFormControlCalcFieldConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwFormControlAutoCompleteLookupReadOnlyComponent extends DwFormControlLookupComponent {
}
DwFormControlAutoCompleteLookupReadOnlyComponent.ɵfac = function DwFormControlAutoCompleteLookupReadOnlyComponent_Factory(t) { return ɵDwFormControlAutoCompleteLookupReadOnlyComponent_BaseFactory(t || DwFormControlAutoCompleteLookupReadOnlyComponent); };
DwFormControlAutoCompleteLookupReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlAutoCompleteLookupReadOnlyComponent, selectors: [["dw-fc-lookup-server-readonly"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], ["useServerSearch", "true", 3, "formControlName", "missingDataText", "options", "lookupId", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField"]], template: function DwFormControlAutoCompleteLookupReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-autocomplete-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("missingDataText", (ctx.fieldDef == null ? null : ctx.fieldDef.readOnlyMissingDataText) || "None")("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("lookupId", ctx.lookupId)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.alternateValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwAutoCompleteLookupReadOnlyComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

class DwFormControlMultiSelectLookupComponent extends DwFormControlLookupComponent {
}
DwFormControlMultiSelectLookupComponent.ɵfac = function DwFormControlMultiSelectLookupComponent_Factory(t) { return ɵDwFormControlMultiSelectLookupComponent_BaseFactory(t || DwFormControlMultiSelectLookupComponent); };
DwFormControlMultiSelectLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlMultiSelectLookupComponent, selectors: [["dw-fc-multiselect"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 8, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], [3, "formControlName", "lookupId", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField"]], template: function DwFormControlMultiSelectLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-multi-select-lookup", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwMultiSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

var DwLookupSearchType;
(function (DwLookupSearchType) {
    DwLookupSearchType["startsWith"] = "StartsWith";
    DwLookupSearchType["contains"] = "Contains";
    DwLookupSearchType["endsWith"] = "EndsWith";
})(DwLookupSearchType || (DwLookupSearchType = {}));
class DwLookupSearchTypeList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwLookupSearchType[propertyName];
    }
    getKeys() {
        return Object.keys(DwLookupSearchType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwLookupSearchType.startsWith:
                return 'Starts With';
            case DwLookupSearchType.contains:
                return 'Contains';
            case DwLookupSearchType.endsWith:
                return 'Ends With';
        }
    }
}

class DwFormControlAutoCompleteLookupConfigComponent {
    constructor(uiMetaDataConfig) {
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.controlOptions = this.defaults;
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    ;
    setupControl() {
        // Use defaults if there not are specified
        this.controlOptions = Object.assign(Object.assign({}, this.defaults), this.controlOptions);
        this.searchTypes = new DwLookupSearchTypeList().getEnumList();
        this.controlOptions.windowOpenOptions = this.controlOptions.windowOpenOptions || {};
    }
    get defaults() {
        return this.uiMetaDataConfig.autoCompleteLookupOptionDefaults;
        //return { maxResults: null, searchType: DwLookupSearchType.contains, waitTimeMs: null,  showChipWhenSelected: true, windowOpenOptions:{} };
    }
}
DwFormControlAutoCompleteLookupConfigComponent.ɵfac = function DwFormControlAutoCompleteLookupConfigComponent_Factory(t) { return new (t || DwFormControlAutoCompleteLookupConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken)); };
DwFormControlAutoCompleteLookupConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlAutoCompleteLookupConfigComponent, selectors: [["dw-fc-autocomplete-lookup-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 48, vars: 17, consts: [["dwRow", ""], ["dwCol", "12"], ["type", "text", "dwNumeric", "", "placeholder", "Default", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["type", "text", "placeholder", "_blank", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"]], template: function DwFormControlAutoCompleteLookupConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
        ɵngcc0.ɵɵpipe(1, "json");
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵtext(5, "Max Search Results");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_6_listener($event) { return ctx.controlOptions.maxResults = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_6_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Search Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_select_ngModelChange_11_listener($event) { return ctx.controlOptions.searchType = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_select_ngModelChange_11_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵtemplate(12, DwFormControlAutoCompleteLookupConfigComponent_option_12_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 0);
        ɵngcc0.ɵɵelementStart(14, "div", 1);
        ɵngcc0.ɵɵelementStart(15, "label");
        ɵngcc0.ɵɵtext(16, "Search Wait Time");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_17_listener($event) { return ctx.controlOptions.waitTimeMs = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_17_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 0);
        ɵngcc0.ɵɵelementStart(19, "div", 1);
        ɵngcc0.ɵɵtext(20, " Show chip when selected ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 1);
        ɵngcc0.ɵɵelementStart(22, "dw-yesno", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_dw_yesno_ngModelChange_22_listener($event) { return ctx.controlOptions.showChipWhenSelected = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_dw_yesno_ngModelChange_22_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 0);
        ɵngcc0.ɵɵelementStart(24, "div", 1);
        ɵngcc0.ɵɵtext(25, " Show link ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 1);
        ɵngcc0.ɵɵelementStart(27, "dw-yesno", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_dw_yesno_ngModelChange_27_listener($event) { return ctx.controlOptions.showLink = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_dw_yesno_ngModelChange_27_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 6);
        ɵngcc0.ɵɵelementStart(29, "div", 1);
        ɵngcc0.ɵɵtext(30, " Open in new window ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 1);
        ɵngcc0.ɵɵelementStart(32, "dw-yesno", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_dw_yesno_ngModelChange_32_listener($event) { return ctx.controlOptions.windowOpenOptions.openInNewWindow = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_dw_yesno_ngModelChange_32_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "div", 6);
        ɵngcc0.ɵɵelementStart(34, "div", 1);
        ɵngcc0.ɵɵtext(35, " New Window Target ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "div", 1);
        ɵngcc0.ɵɵelementStart(37, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_37_listener($event) { return ctx.controlOptions.windowOpenOptions.newWindowTarget = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_37_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 6);
        ɵngcc0.ɵɵelementStart(39, "div", 1);
        ɵngcc0.ɵɵelementStart(40, "label");
        ɵngcc0.ɵɵtext(41, "Link Toolip");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_42_listener($event) { return ctx.controlOptions.linkTooltip = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_42_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "div", 6);
        ɵngcc0.ɵɵelementStart(44, "div", 1);
        ɵngcc0.ɵɵelementStart(45, "label");
        ɵngcc0.ɵɵtext(46, "Link Icon");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_47_listener($event) { return ctx.controlOptions.linkIconClass = $event; })("ngModelChange", function DwFormControlAutoCompleteLookupConfigComponent_Template_input_ngModelChange_47_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate1(" Options: ", ɵngcc0.ɵɵpipeBind1(1, 15, ctx.controlOptions), " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.maxResults);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.searchType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.searchTypes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.waitTimeMs);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.showChipWhenSelected);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.windowOpenOptions.openInNewWindow);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.windowOpenOptions.newWindowTarget);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.linkTooltip);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.linkIconClass);
    } }, directives: [DwRowDirective, DwColDirective, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, DwYesNoComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], pipes: [ɵngcc4.JsonPipe], encapsulation: 2 });
DwFormControlAutoCompleteLookupConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwFormControlAutoCompleteLookupConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwFormControlDateComponent {
    constructor() {
        this.inputClass = "";
    }
}
DwFormControlDateComponent.ɵfac = function DwFormControlDateComponent_Factory(t) { return new (t || DwFormControlDateComponent)(); };
DwFormControlDateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlDateComponent, selectors: [["dw-fc-date"]], inputs: { context: "context" }, decls: 2, vars: 3, consts: [[3, "formGroup"], ["showTime", "false", 3, "formControlName", "dateOptions"]], template: function DwFormControlDateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("dateOptions", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateInputControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlDateComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlDate2Component extends DwFormControlDateComponent {
}
DwFormControlDate2Component.ɵfac = function DwFormControlDate2Component_Factory(t) { return ɵDwFormControlDate2Component_BaseFactory(t || DwFormControlDate2Component); };
DwFormControlDate2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlDate2Component, selectors: [["dw-fc-date2"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 3, consts: [[3, "formGroup"], ["showTime", "false", 3, "formControlName", "dateOptions"]], template: function DwFormControlDate2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date2", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("dateOptions", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateInputControl2Component, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });

class DwFormControlDateTimeComponent {
    constructor(uiMetaDataConfig) {
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.inputClass = "";
    }
    useGmtDateTime() {
        if (this.fieldDef && this.fieldDef.attr) {
            if (this.fieldDef.attr.UseGmtDateTime === true || this.fieldDef.attr.UseGmtDateTime === false) {
                return this.fieldDef.attr.UseGmtDateTime;
            }
        }
        return this.uiMetaDataConfig.useGmtDateTime;
    }
    use24HourTime() {
        return this.uiMetaDataConfig.use24HourTime;
    }
}
DwFormControlDateTimeComponent.ɵfac = function DwFormControlDateTimeComponent_Factory(t) { return new (t || DwFormControlDateTimeComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken)); };
DwFormControlDateTimeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlDateTimeComponent, selectors: [["dw-fc-date-time"]], inputs: { context: "context" }, decls: 2, vars: 4, consts: [[3, "formGroup"], ["showTime", "true", 3, "formControlName", "useGmtDateTime", "use24HourTime"]], template: function DwFormControlDateTimeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("useGmtDateTime", ctx.useGmtDateTime())("use24HourTime", ctx.use24HourTime());
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateInputControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlDateTimeComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwFormControlDateTimeComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlDateTime2Component extends DwFormControlDateTimeComponent {
}
DwFormControlDateTime2Component.ɵfac = function DwFormControlDateTime2Component_Factory(t) { return ɵDwFormControlDateTime2Component_BaseFactory(t || DwFormControlDateTime2Component); };
DwFormControlDateTime2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlDateTime2Component, selectors: [["dw-fc-date-time2"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [[3, "formGroup"], ["showTime", "true", 3, "formControlName", "useGmtDateTime", "use24HourTime", "dateOptions"]], template: function DwFormControlDateTime2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date2", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("useGmtDateTime", ctx.useGmtDateTime())("use24HourTime", ctx.use24HourTime())("dateOptions", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateInputControl2Component, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });

class DwFormControlTimeComponent {
    constructor() {
        this.inputClass = "";
    }
}
DwFormControlTimeComponent.ɵfac = function DwFormControlTimeComponent_Factory(t) { return new (t || DwFormControlTimeComponent)(); };
DwFormControlTimeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlTimeComponent, selectors: [["dw-fc-time"]], inputs: { context: "context" }, decls: 2, vars: 3, consts: [[3, "formGroup"], ["showTime", "true", "timeOnly", "true", 3, "formControlName", "dateOptions"]], template: function DwFormControlTimeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("dateOptions", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateInputControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlTimeComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlTime2Component extends DwFormControlTimeComponent {
}
DwFormControlTime2Component.ɵfac = function DwFormControlTime2Component_Factory(t) { return ɵDwFormControlTime2Component_BaseFactory(t || DwFormControlTime2Component); };
DwFormControlTime2Component.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlTime2Component, selectors: [["dw-fc-time2"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 3, consts: [[3, "formGroup"], ["showTime", "true", "timeOnly", "true", 3, "formControlName", "dateOptions"]], template: function DwFormControlTime2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date2", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("dateOptions", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateInputControl2Component, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });

class DwFormControlInputConfigComponent {
    constructor() {
        this.controlOptions = {};
        this.controlOptionsChange = new EventEmitter();
        this.decimalsPlaceholder = '0';
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    setupControl() {
        if (!this.controlOptions) {
            this.controlOptions = {};
        }
        if (this.attribute.Decimals) {
            this.decimalsPlaceholder = this.attribute.Decimals.toString();
        }
        this.showNumericOptions = this.usingControlType(DwControlType.NumericTextBox) || this.usingControlType(DwControlType.CurrencyTextBox);
    }
    usingControlType(controlType) {
        return (this.attribute && (this.attribute.MetaDataControlTypeId == controlType
            || this.fieldConfig.controlTypeOverride == controlType));
    }
}
DwFormControlInputConfigComponent.ɵfac = function DwFormControlInputConfigComponent_Factory(t) { return new (t || DwFormControlInputConfigComponent)(); };
DwFormControlInputConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlInputConfigComponent, selectors: [["dw-fc-input-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 17, vars: 5, consts: [["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], [4, "ngIf"], ["dwNumeric", "", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["title", "Converts the underlying values using this multiplier.  Use for percentages stored as decimals or converting unit of meatures", 1, "fa", "fa-info-circle"], ["dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwFormControlInputConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2, " Prefix ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.controlOptions.prefix = $event; })("ngModelChange", function DwFormControlInputConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵtext(7, " Suffix ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.controlOptions.suffix = $event; })("ngModelChange", function DwFormControlInputConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 0);
        ɵngcc0.ɵɵelementStart(11, "div", 3);
        ɵngcc0.ɵɵtext(12, " Browser Autocomplete Enabled ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 4);
        ɵngcc0.ɵɵelementStart(14, "p-inputSwitch", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlInputConfigComponent_Template_p_inputSwitch_ngModelChange_14_listener($event) { return ctx.controlOptions.autoCompleteEnabled = $event; })("ngModelChange", function DwFormControlInputConfigComponent_Template_p_inputSwitch_ngModelChange_14_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(15, DwFormControlInputConfigComponent_div_15_Template, 5, 1, "div", 6);
        ɵngcc0.ɵɵtemplate(16, DwFormControlInputConfigComponent_ng_container_16_Template, 24, 5, "ng-container", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.prefix);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.suffix);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.autoCompleteEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.controlOptions == null ? null : ctx.controlOptions.autoCompleteEnabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNumericOptions);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc10.InputSwitch, ɵngcc4.NgIf, DwNumericDirective], encapsulation: 2 });
DwFormControlInputConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwFormControlInputReadOnlyComponent {
}
DwFormControlInputReadOnlyComponent.ɵfac = function DwFormControlInputReadOnlyComponent_Factory(t) { return new (t || DwFormControlInputReadOnlyComponent)(); };
DwFormControlInputReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlInputReadOnlyComponent, selectors: [["dw-fc-input-readonly"]], inputs: { context: "context" }, decls: 2, vars: 4, consts: [[3, "formGroup"], [3, "formControlName", "options", "missingDataText"]], template: function DwFormControlInputReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-input-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("missingDataText", (ctx.fieldDef == null ? null : ctx.fieldDef.readOnlyMissingDataText) || "None");
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwInputReadOnlyComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlInputReadOnlyComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlNumericInputReadOnlyComponent extends DwFormControlNumericInputComponent {
}
DwFormControlNumericInputReadOnlyComponent.ɵfac = function DwFormControlNumericInputReadOnlyComponent_Factory(t) { return ɵDwFormControlNumericInputReadOnlyComponent_BaseFactory(t || DwFormControlNumericInputReadOnlyComponent); };
DwFormControlNumericInputReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlNumericInputReadOnlyComponent, selectors: [["dw-fc-numeric-readonly"]], inputs: { context: "context" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 5, consts: [[3, "formGroup"], [3, "formControlName", "options", "numeric", "decimals"]], template: function DwFormControlNumericInputReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-input-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("numeric", true)("decimals", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.Decimals);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwInputReadOnlyComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlNumericInputReadOnlyComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlTextAreaConfigComponent {
    constructor() {
        this.controlOptions = {};
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    setupControl() {
        if (!this.controlOptions) {
            this.controlOptions = {};
        }
    }
}
DwFormControlTextAreaConfigComponent.ɵfac = function DwFormControlTextAreaConfigComponent_Factory(t) { return new (t || DwFormControlTextAreaConfigComponent)(); };
DwFormControlTextAreaConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlTextAreaConfigComponent, selectors: [["dw-fc-textarea-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 10, vars: 2, consts: [["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwFormControlTextAreaConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2, " Rows ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlTextAreaConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.controlOptions.rows = $event; })("ngModelChange", function DwFormControlTextAreaConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵtext(7, " Height ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlTextAreaConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.controlOptions.height = $event; })("ngModelChange", function DwFormControlTextAreaConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.rows);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.height);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwFormControlTextAreaConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwFormControlRadioLookupComponent extends DwFormControlLookupComponent {
}
DwFormControlRadioLookupComponent.ɵfac = function DwFormControlRadioLookupComponent_Factory(t) { return ɵDwFormControlRadioLookupComponent_BaseFactory(t || DwFormControlRadioLookupComponent); };
DwFormControlRadioLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlRadioLookupComponent, selectors: [["dw-fc-radio-lookup"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 9, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], [3, "formControlName", "lookupId", "options", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField"]], template: function DwFormControlRadioLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-radio-lookup", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRadioLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

class DwFormControlMulitSelectAdhocComponent extends DwFormControlLookupComponent {
}
DwFormControlMulitSelectAdhocComponent.ɵfac = function DwFormControlMulitSelectAdhocComponent_Factory(t) { return ɵDwFormControlMulitSelectAdhocComponent_BaseFactory(t || DwFormControlMulitSelectAdhocComponent); };
DwFormControlMulitSelectAdhocComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlMulitSelectAdhocComponent, selectors: [["dw-fc-multi-select-adhoc"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], ["useServerSearch", "false", 3, "formControlName", "lookupId", "options", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField", "placeholder"]], template: function DwFormControlMulitSelectAdhocComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-multi-select-adhoc-lookup", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "");
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwMultiSelectAdhocComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

class DwFormControlMulitSelectAdhocReadOnlyComponent extends DwFormControlLookupComponent {
}
DwFormControlMulitSelectAdhocReadOnlyComponent.ɵfac = function DwFormControlMulitSelectAdhocReadOnlyComponent_Factory(t) { return ɵDwFormControlMulitSelectAdhocReadOnlyComponent_BaseFactory(t || DwFormControlMulitSelectAdhocReadOnlyComponent); };
DwFormControlMulitSelectAdhocReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlMulitSelectAdhocReadOnlyComponent, selectors: [["dw-fc-multi-select-adhoc"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 10, consts: [[1, "dynamic-field", "form-input", 3, "formGroup"], ["useServerSearch", "false", 3, "formControlName", "lookupId", "options", "paramValues", "overrideValues", "valueAttrName", "useTransitions", "additionalDataField", "placeholder"]], template: function DwFormControlMulitSelectAdhocReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-multi-select-adhoc-readonly", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("lookupId", ctx.lookupId)("options", ctx.fieldDef == null ? null : ctx.fieldDef.controlOptions)("paramValues", ctx.paramValues)("overrideValues", ctx.fieldDef == null ? null : ctx.fieldDef.attr == null ? null : ctx.fieldDef.attr.CustomListValues)("valueAttrName", (ctx.fieldDef == null ? null : ctx.fieldDef.alternateLookupValueAttrName) || "Id")("useTransitions", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.useTransitions)("additionalDataField", ctx.fieldDef == null ? null : ctx.fieldDef.lookupConfig == null ? null : ctx.fieldDef.lookupConfig.addittionalDisplayAttrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "");
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwMultiSelectAdhocReadOnlyComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, encapsulation: 2 });

var DwListActionLocation;
(function (DwListActionLocation) {
    DwListActionLocation["actionBarLeft"] = "actionBarLeft";
    DwListActionLocation["actionBarRight"] = "actionBarRight";
    DwListActionLocation["cardButton"] = "cardButton";
    DwListActionLocation["actionBarBottom"] = "actionBarBottom";
})(DwListActionLocation || (DwListActionLocation = {}));
class DwListActionLocationList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwListActionLocation[propertyName];
    }
    getKeys() {
        return Object.keys(DwListActionLocation);
    }
    getEnumDisplay(item) {
        return getListActionLocationDisplay(item);
    }
}
function getListActionLocationDisplay(actionLocation) {
    switch (actionLocation) {
        case DwListActionLocation.actionBarLeft:
            return 'Action Bar Left';
        case DwListActionLocation.actionBarRight:
            return 'Action Bar Right';
        case DwListActionLocation.cardButton:
            return 'Card Button';
        case DwListActionLocation.actionBarBottom:
            return 'Action Bar Bottom';
    }
}
function getListActionModes() {
    const gridActionModes = [];
    gridActionModes.push({
        modeValue: DwListActionLocation.actionBarLeft,
        modeDisplay: getListActionLocationDisplay(DwListActionLocation.actionBarLeft),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.listAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionBarLeft
        // buttonContainerClass: 'dw-grid-action-bar-preview-container dw-grid-action-bar-preview-left'
    });
    gridActionModes.push({
        modeValue: DwListActionLocation.actionBarRight,
        modeDisplay: getListActionLocationDisplay(DwListActionLocation.actionBarRight),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.listAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.gridActionBarRight
        // buttonContainerClass: 'dw-grid-action-bar-preview-container dw-grid-action-bar-preview-right'
    });
    gridActionModes.push({
        modeValue: DwListActionLocation.cardButton,
        modeDisplay: getListActionLocationDisplay(DwListActionLocation.cardButton),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.listItemAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.basicButtonBar
        // buttonContainerClass: 'dw-grid-action-row-preview-container'
    });
    gridActionModes.push({
        modeValue: DwListActionLocation.actionBarBottom,
        modeDisplay: getListActionLocationDisplay(DwListActionLocation.actionBarBottom),
        showButtonConfig: true,
        showMenuConfig: false,
        actionTypes: [DwActionType.listAction, DwActionType.menuAction],
        buttonContainerStyleKey: DwGridSectionStyleKeys.basicButtonBar
    });
    return gridActionModes;
}

var DwListActionKeys;
(function (DwListActionKeys) {
    DwListActionKeys["listAdd"] = "listAdd";
    DwListActionKeys["listEdit"] = "listEdit";
    DwListActionKeys["listView"] = "listView";
    DwListActionKeys["listPrint"] = "listPrint";
    DwListActionKeys["listDelete"] = "listDelete";
    DwListActionKeys["listRefresh"] = "listRefresh";
    DwListActionKeys["listFilterToggle"] = "listFilterToggle";
    DwListActionKeys["listToggleView"] = "listToggleView";
    DwListActionKeys["listQuickSearch"] = "listQuickSearch";
})(DwListActionKeys || (DwListActionKeys = {}));

class DwFormControlInputYesNoComponent {
}
DwFormControlInputYesNoComponent.ɵfac = function DwFormControlInputYesNoComponent_Factory(t) { return new (t || DwFormControlInputYesNoComponent)(); };
DwFormControlInputYesNoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlInputYesNoComponent, selectors: [["dw-fc-input-yesno"]], inputs: { context: "context" }, decls: 2, vars: 3, consts: [[3, "formGroup"], [3, "formControlName"]], template: function DwFormControlInputYesNoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-yesno", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
        ɵngcc0.ɵɵattribute("id", (ctx.fieldDef == null ? null : ctx.fieldDef.attrName) || "");
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlInputYesNoComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwFormControlMultiSelectAdhocConfigComponent {
    constructor() {
        this.controlOptions = this.defaults;
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    ;
    setupControl() {
        // Use defaults if there not are specified
        this.controlOptions = Object.assign(Object.assign({}, this.defaults), this.controlOptions);
        this.searchTypes = new DwLookupSearchTypeList().getEnumList();
    }
    get defaults() {
        return { maxResults: 20, searchType: DwLookupSearchType.startsWith, waitTimeMs: 300, showChipWhenSelected: true, };
    }
}
DwFormControlMultiSelectAdhocConfigComponent.ɵfac = function DwFormControlMultiSelectAdhocConfigComponent_Factory(t) { return new (t || DwFormControlMultiSelectAdhocConfigComponent)(); };
DwFormControlMultiSelectAdhocConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlMultiSelectAdhocConfigComponent, selectors: [["dw-fc-autocomplete-lookup-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 21, vars: 5, consts: [["dwRow", ""], ["dwCol", "12"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [3, "ngValue"]], template: function DwFormControlMultiSelectAdhocConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Max Search Results");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.controlOptions.maxResults = $event; })("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_input_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Search Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_select_ngModelChange_9_listener($event) { return ctx.controlOptions.searchType = $event; })("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_select_ngModelChange_9_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵtemplate(10, DwFormControlMultiSelectAdhocConfigComponent_option_10_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵelementStart(13, "label");
        ɵngcc0.ɵɵtext(14, "Search Wait Time");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_input_ngModelChange_15_listener($event) { return ctx.controlOptions.waitTimeMs = $event; })("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_input_ngModelChange_15_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 0);
        ɵngcc0.ɵɵelementStart(17, "div", 5);
        ɵngcc0.ɵɵtext(18, " Prevent Custom Add ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 6);
        ɵngcc0.ɵɵelementStart(20, "p-inputSwitch", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_p_inputSwitch_ngModelChange_20_listener($event) { return ctx.controlOptions.preventCustomAdd = $event; })("ngModelChange", function DwFormControlMultiSelectAdhocConfigComponent_Template_p_inputSwitch_ngModelChange_20_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.maxResults);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.searchType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.searchTypes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.waitTimeMs);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.preventCustomAdd);
    } }, directives: [DwRowDirective, DwColDirective, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwFormControlMultiSelectAdhocConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwDefaultListPageComponent extends DwDefaultGridPage {
    get configKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}`;
        return `${itemName}-${this.configKeyPart}-defaultList`;
    }
    get contentConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}-list`;
        return `${itemName}-${this.configKeyPart}-defaultList`;
    }
}
DwDefaultListPageComponent.ɵfac = function DwDefaultListPageComponent_Factory(t) { return ɵDwDefaultListPageComponent_BaseFactory(t || DwDefaultListPageComponent); };
DwDefaultListPageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDefaultListPageComponent, selectors: [["dw-default-list-page"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 0, consts: [[3, "configKey", "item"], ["name", "title", "display", "Page Title", 3, "controlType"], ["name", "detail", "display", "Header Details"], ["name", "component", "display", "Custom Component"], [3, "item", "configKeyPart"]], template: function DwDefaultListPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-router-parent");
        ɵngcc0.ɵɵtemplate(1, DwDefaultListPageComponent_ng_template_1_Template, 6, 5, "ng-template");
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [DwRouterParentComponent, DwContentManagerComponent, DwContentDirective, DwContentComponent, DwMetadataListComponent]; }, encapsulation: 2 });

class DwFormControlLookupConfigComponent {
    constructor() {
        this.controlOptions = this.defaults;
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    ;
    setupControl() {
        // Use defaults if there not are specified
        this.controlOptions = Object.assign(Object.assign({}, this.defaults), this.controlOptions);
        this.searchTypes = new DwLookupSearchTypeList().getEnumList();
        this.controlOptions.windowOpenOptions = this.controlOptions.windowOpenOptions || {};
    }
    get defaults() {
        return {
            windowOpenOptions: {}
        };
    }
}
DwFormControlLookupConfigComponent.ɵfac = function DwFormControlLookupConfigComponent_Factory(t) { return new (t || DwFormControlLookupConfigComponent)(); };
DwFormControlLookupConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlLookupConfigComponent, selectors: [["dw-fc-lookup-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 25, vars: 9, consts: [["dwRow", ""], ["dwCol", "12"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["type", "text", "placeholder", "_blank", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwFormControlLookupConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2, " Show link ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "dw-yesno", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlLookupConfigComponent_Template_dw_yesno_ngModelChange_4_listener($event) { return ctx.controlOptions.showLink = $event; })("ngModelChange", function DwFormControlLookupConfigComponent_Template_dw_yesno_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵtext(7, " Open in new window ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "dw-yesno", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlLookupConfigComponent_Template_dw_yesno_ngModelChange_9_listener($event) { return ctx.controlOptions.windowOpenOptions.openInNewWindow = $event; })("ngModelChange", function DwFormControlLookupConfigComponent_Template_dw_yesno_ngModelChange_9_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 3);
        ɵngcc0.ɵɵelementStart(11, "div", 1);
        ɵngcc0.ɵɵtext(12, " New Window Target ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlLookupConfigComponent_Template_input_ngModelChange_14_listener($event) { return ctx.controlOptions.windowOpenOptions.newWindowTarget = $event; })("ngModelChange", function DwFormControlLookupConfigComponent_Template_input_ngModelChange_14_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 3);
        ɵngcc0.ɵɵelementStart(16, "div", 1);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Link Toolip");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlLookupConfigComponent_Template_input_ngModelChange_19_listener($event) { return ctx.controlOptions.linkTooltip = $event; })("ngModelChange", function DwFormControlLookupConfigComponent_Template_input_ngModelChange_19_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 3);
        ɵngcc0.ɵɵelementStart(21, "div", 1);
        ɵngcc0.ɵɵelementStart(22, "label");
        ɵngcc0.ɵɵtext(23, "Link Icon");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlLookupConfigComponent_Template_input_ngModelChange_24_listener($event) { return ctx.controlOptions.linkIconClass = $event; })("ngModelChange", function DwFormControlLookupConfigComponent_Template_input_ngModelChange_24_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.windowOpenOptions.openInNewWindow);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.windowOpenOptions.newWindowTarget);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.linkTooltip);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.controlOptions.showLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.linkIconClass);
    } }, directives: [DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor], encapsulation: 2 });
DwFormControlLookupConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwHtmlEditControlConfigComponent {
    constructor() {
        this.controlOptions = {};
        this.controlOptionsChange = new EventEmitter();
    }
    fieldChange(value) {
        this.controlOptionsChange.emit(this.controlOptions);
    }
    setupControl() {
        if (!this.controlOptions) {
            this.controlOptions = {
                allowViewSource: true,
                useDelayedSetValue: false
            };
        }
    }
}
DwHtmlEditControlConfigComponent.ɵfac = function DwHtmlEditControlConfigComponent_Factory(t) { return new (t || DwHtmlEditControlConfigComponent)(); };
DwHtmlEditControlConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwHtmlEditControlConfigComponent, selectors: [["dw-html-edit-control-config"]], inputs: { controlOptions: "controlOptions", itemName: "itemName", fieldConfig: "fieldConfig", attribute: "attribute" }, outputs: { controlOptionsChange: "controlOptionsChange" }, decls: 11, vars: 2, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["title", "Work around for quill error when setting the form control directly.  Only set to true if you run into an error", 1, "fa", "fa-info-circle"]], template: function DwHtmlEditControlConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2, " Allow View Source ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwHtmlEditControlConfigComponent_Template_p_inputSwitch_ngModelChange_4_listener($event) { return ctx.controlOptions.allowViewSource = $event; })("ngModelChange", function DwHtmlEditControlConfigComponent_Template_p_inputSwitch_ngModelChange_4_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵtext(7, " Use Delayed Set Value ");
        ɵngcc0.ɵɵelement(8, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 2);
        ɵngcc0.ɵɵelementStart(10, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwHtmlEditControlConfigComponent_Template_p_inputSwitch_ngModelChange_10_listener($event) { return ctx.controlOptions.useDelayedSetValue = $event; })("ngModelChange", function DwHtmlEditControlConfigComponent_Template_p_inputSwitch_ngModelChange_10_listener($event) { return ctx.fieldChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.allowViewSource);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.controlOptions.useDelayedSetValue);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwHtmlEditControlConfigComponent.propDecorators = {
    controlOptions: [{ type: Input }],
    controlOptionsChange: [{ type: Output }],
    itemName: [{ type: Input }],
    fieldConfig: [{ type: Input }],
    attribute: [{ type: Input }]
};

class DwUIMetaDataConfigDefaults {
    constructor() {
        this.controlComponents = {};
        this.controlConfigComponents = {};
        // Allows setting control defaults for a control type
        this.controlOptionDefaults = {};
        // Allows setting control defaults for an attribute or any pattern of specific controls
        this.attributeControlDefaults = [];
        this.readOnlyControlComponents = {};
        this.defaultControlOnlyComponents = {};
        this.userContextExtendedAttributes = [];
        this.autoCompleteLookupOptionDefaults = { maxResults: null, searchType: DwLookupSearchType.contains, waitTimeMs: null, showChipWhenSelected: true, windowOpenOptions: {} };
        this.gridGlobalDefaults = {
            allowColumnRemove: true,
            allowColumnReorder: true,
            allowColumnRemovePermission: 'Ent_Ui_CanConfigure',
            allowColumnReorderPermission: 'Ent_Ui_CanConfigure'
        };
        this.setDefaults();
    }
    setDefaults() {
        this.defaultMetaDataGridRouteUrl = '/admin/data/items/:itemName';
        this.defaultMetaDataFormEditRouteUrl = '/admin/data/items/:itemName/edit/:keyValue';
        this.defaultMetaDataFormAddRouteUrl = '/admin/data/items/:itemName/add';
        this.defaultMetaDataFormViewRouteUrl = '/admin/data/items/:itemName/view/:keyValue';
        this.gridDefaultPreferences = new DwMetaDataGridPreferences();
        this.formDefaultPreferences = new DwMetaDataFormPreferences();
        this.listDefaultPreferences = new DwMetaDataListPreferences();
        this.formPageComponent = DwDefaultFormPage;
        this.gridPageComponent = DwDefaultGridPage;
        this.listPageComponent = DwDefaultListPageComponent;
        this.menuPageComponent = DefaultMenuPageComponent;
        this.gridDefaultPreferences.boolColumnType = DwColumnFormatType.yesNo;
        this.gridDefaultPreferences.ignoreAttributes = ['TenantId', 'CreatedBy', 'CreatedDateTime', 'ModifiedBy', 'ModifiedDateTime'];
        this.gridDefaultPreferences.showDisplayProperties = true;
        this.gridDefaultPreferences.hidePrimaryKey = true;
        this.gridDefaultPreferences.showFilter = false;
        this.gridDefaultPreferences.enableColResize = true;
        this.gridDefaultPreferences.enableSorting = true;
        this.gridDefaultPreferences.autoFilterDelay = 1000;
        this.gridDefaultPreferences.useModal = false;
        //this.emailValidationRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;
        this.pdfRenderWaitTimeMs = 500;
        this.gridDefaultPreferences.deleteConfirmTitle = "Delete Item?";
        this.gridDefaultPreferences.deleteConfigMessage = "Deleting an item cannot be undone.  Are you sure you want to delete it?";
        this.formDefaultPreferences.hidePrimaryKey = true;
        this.formDefaultPreferences.ignoreAttributes = ['TenantId', 'CreatedBy', 'CreatedDateTime', 'ModifiedBy', 'ModifiedDateTime'];
        this.formDefaultPreferences.messageLocation = DwFormMessageLocation.topOnly;
        this.defaultControlComponent = DwFormControlInputComponent;
        this.controlComponents[DwControlType.Textbox] = DwFormControlInputComponent;
        this.controlConfigComponents[DwControlType.Textbox] = DwFormControlInputConfigComponent;
        this.controlComponents[DwControlType.TextArea] = DwFormControlTextAreaComponent;
        this.controlConfigComponents[DwControlType.TextArea] = DwFormControlTextAreaConfigComponent;
        this.controlComponents[DwControlType.DatePicker] = DwFormControlDate2Component;
        this.controlConfigComponents[DwControlType.DatePicker] = DwFormControlDateFieldConfigComponent;
        this.controlComponents[DwControlType.DateTimePicker] = DwFormControlDateTime2Component;
        this.controlComponents[DwControlType.TimePicker] = DwFormControlTime2Component;
        // this.controlComponents[DwControlType.DropDownList] = DwFormControlLookupComponent;
        // Trying out using the search lookup for all drop-down lists
        this.controlComponents[DwControlType.DropDownList] = DwFormControlSearchLookupComponent;
        this.controlComponents[DwControlType.NumericTextBox] = DwFormControlNumericInputComponent;
        this.controlConfigComponents[DwControlType.NumericTextBox] = DwFormControlInputConfigComponent;
        this.controlComponents[DwControlType.CurrencyTextBox] = DwFormControlNumericInputComponent;
        this.controlConfigComponents[DwControlType.CurrencyTextBox] = DwFormControlInputConfigComponent;
        this.controlComponents[DwControlType.PercentageTextBox] = DwFormControlNumericInputComponent;
        this.controlConfigComponents[DwControlType.PercentageTextBox] = DwFormControlInputConfigComponent;
        this.controlComponents[DwControlType.YesNoDropDown] = DwFormControlInputYesNoDropdownComponent;
        this.controlComponents[DwControlType.Checkbox] = DwFormControlInputYesNoComponent;
        this.controlComponents[DwControlType.HTMLEditor] = DwFormControlHtmlEditorComponent;
        this.controlConfigComponents[DwControlType.HTMLEditor] = DwHtmlEditControlConfigComponent;
        this.controlComponents[DwControlType.DropDownListwSearch] = DwFormControlSearchLookupComponent;
        this.controlConfigComponents[DwControlType.DropDownListwSearch] = DwFormControlLookupConfigComponent;
        this.controlConfigComponents[DwControlType.DropDownList] = DwFormControlLookupConfigComponent;
        this.controlComponents[DwControlType.AutoComplete] = DwFormControlAutoCompleteLookupComponent;
        this.controlComponents[DwControlType.AutoCompleteServer] = DwFormControlAutoCompleteServerLookupComponent;
        this.controlConfigComponents[DwControlType.AutoComplete] = DwFormControlAutoCompleteLookupConfigComponent;
        this.controlConfigComponents[DwControlType.AutoCompleteServer] = DwFormControlAutoCompleteLookupConfigComponent;
        this.controlOptionDefaults[DwControlType.AutoCompleteServer] = this.defaultAutoCompleteOptions;
        this.controlComponents[DwControlType.RadioButtonList] = DwFormControlRadioLookupComponent;
        this.readOnlyControlComponents[DwControlType.RadioButtonList] = DwFormControlLookupReadOnlyComponent;
        this.controlComponents[DwControlType.MultiSelect] = DwFormControlMultiSelectLookupComponent;
        this.controlComponents[DwControlType.CalcultedField] = DwFormControlCalcFieldComponent;
        this.controlConfigComponents[DwControlType.CalcultedField] = DwFormControlCalcFieldConfigComponent;
        this.defaultReadOnlyControlComponent = DwFormControlReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.Textbox] = DwFormControlInputReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.NumericTextBox] = DwFormControlNumericInputReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.CurrencyTextBox] = DwFormControlNumericInputReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.DropDownList] = DwFormControlLookupReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.DropDownListwSearch] = DwFormControlLookupReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.AutoComplete] = DwFormControlAutoCompleteLookupReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.AutoCompleteServer] = DwFormControlAutoCompleteLookupReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.CalcultedField] = DwFormControlCalcFieldComponent;
        this.readOnlyControlComponents[DwControlType.HTMLEditor] = DwFormControlHtmlReadOnlyComponent;
        this.readOnlyControlComponents[DwControlType.UrlTextBox] = DwFormControlUrlReadOnlyComponent;
        this.controlComponents[DwControlType.MultiSelectAdhoc] = DwFormControlMulitSelectAdhocComponent;
        this.readOnlyControlComponents[DwControlType.MultiSelectAdhoc] = DwFormControlMulitSelectAdhocReadOnlyComponent;
        this.controlConfigComponents[DwControlType.MultiSelectAdhoc] = DwFormControlMultiSelectAdhocConfigComponent;
        this.defaultContainerStyle = {
            keyName: '',
            display: 'Default',
            containerClass: 'dw-form-section-container',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'dw-form-section-container-header'
        };
        this.formButtonDefaults = {};
        this.formButtonDefaults[DwFormContextMode.addEdit] = [DwFormActionKeys.formSave, DwFormActionKeys.formCancel];
        this.formButtonDefaults[DwFormContextMode.view] = [DwFormActionKeys.formClose];
        this.formButtonDefaults[DwFormContextMode.print] = [DwFormActionKeys.formPrint, DwFormActionKeys.formClose];
        this.gridButtonDefaults = {};
        this.gridButtonDefaults[DwGridActionLocation.actionBarLeft] = [DwGridActionKeys.gridAdd];
        this.gridButtonDefaults[DwGridActionLocation.actionBarRight] = [DwGridActionKeys.gridQuickSearch, DwGridActionKeys.gridFilterToggle, DwGridActionKeys.gridRefresh, DwGridActionKeys.gridExport];
        this.gridButtonDefaults[DwGridActionLocation.rowButton] = [DwGridActionKeys.gridEdit, DwGridActionKeys.gridDelete, DwGridActionKeys.gridView];
        this.gridButtonDefaults[DwGridActionLocation.rowButtonInlineEditing] = [
            DwGridActionKeys.gridEdit_CancelInlineRowEdit,
            DwGridActionKeys.gridEdit_StartEditInlineRowEdit,
            DwGridActionKeys.gridEdit_CompleteInlineRowEdit,
            DwGridActionKeys.gridEdit_DeleteInlineRowEdit
        ];
        this.gridButtonDefaults[DwGridActionLocation.actionBarLeftInlineEditing] = [DwGridActionKeys.gridEdit_CancelInlineEdits, DwGridActionKeys.gridEdit_SaveInLineEdits];
        this.gridButtonDefaults[DwGridActionLocation.actionBarRightInlineEditing] = [];
        this.listButtonDefaults = {};
        this.listButtonDefaults[DwListActionLocation.actionBarRight] = [DwListActionKeys.listFilterToggle, DwListActionKeys.listRefresh, DwListActionKeys.listToggleView];
        this.formUnsavedChangesInfo = {
            title: 'Are you sure?',
            message: 'You are about to leave the page and lose any unsaved changes'
        };
    }
    get defaultAutoCompleteOptions() {
        return {
            placeholderText: 'START TYPING TO SEARCH',
            controlOptions: {
                maxResults: 30,
                searchType: DwLookupSearchType.startsWith,
                waitTimeMs: 300,
                showChipWhenSelected: true,
            }
        };
    }
}
DwUIMetaDataConfigDefaults.configName = "UIMetaDataConfig";

var __decorate$M = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$y = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwDynamicFieldComponent {
    // hasRequiredField(abstractControl: AbstractControl): boolean {
    //     if (!abstractControl) return false;
    //     if (abstractControl.validator) {
    //         const validator = abstractControl.validator({} as AbstractControl);
    //         if (validator && validator.required) {
    //             return true;
    //         }
    //     }
    //     if (abstractControl['controls']) {
    //         for (const controlName in abstractControl['controls']) {
    //             if (abstractControl['controls'][controlName]) {
    //                 if (this.hasRequiredField(abstractControl['controls'][controlName])) {
    //                     return true;
    //                 }
    //             }
    //         }
    //     }
    //     return false;
    // };
    constructor(resolver, configService, dwExpressionService, cdr, dwConfigRegistryService) {
        this.resolver = resolver;
        this.dwExpressionService = dwExpressionService;
        this.cdr = cdr;
        this.dwConfigRegistryService = dwConfigRegistryService;
        this.colSize = 6;
        this.submitted = false;
        this.useDisplayFields = false;
        this.isRequired = false;
        this.recreateControlOnChange = true;
        this.labelClasses = [];
        this.dataClasses = [];
        //isRequired = false;
        this.isVisible = false;
        this.subscriptions = [];
        this.lastReadOnlyValue = false;
        this.uiMetaDataConfig = configService.getConfig(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
    }
    get formControl() {
        if (!this.formGroup || !this.fieldDef) {
            return null;
        }
        return this.formGroup.controls[this.fieldDef.attrName];
    }
    ngOnInit() {
        this.fieldDef = this.getFieldDefWithDefaults(this.initialFieldDef);
        this.setupClasses();
    }
    ngOnDestroy() {
        if (this.componentInstance) {
            // call dispose of existing control
            if (this.componentInstance.dispose) {
                this.componentInstance.dispose();
            }
            this.componentInstance = null;
        }
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        if (this.fieldChangeSubscription) {
            this.fieldChangeSubscription.unsubscribe();
        }
    }
    setupClasses() {
        this.labelClasses = this.getFinalClassArray(this.fieldDef.labelClass, 'label');
        this.dataClasses = this.getFinalClassArray(this.fieldDef.dataClass);
    }
    getFinalClassArray(classes, additionalClass) {
        const classArray = [];
        if (additionalClass) {
            classArray.push(additionalClass);
        }
        classes = classes || '';
        const classList = classes.split(' ');
        for (const className of classList) {
            if (className.trim()) {
                classArray.push(className);
            }
        }
        return classArray;
    }
    ngAfterContentInit() {
        this.loadComponent();
    }
    loadComponent() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        if (!this.fieldDef)
            return;
        this.setupClasses();
        let component = this.determineComponent(this.fieldDef);
        if (this.existingComponent != component || this.recreateControlOnChange) {
            this.existingComponent = component;
            if (this.componentInstance) {
                // call dispose of existing control
                if (this.componentInstance.dispose) {
                    this.componentInstance.dispose();
                }
            }
            const componentFactory = this.resolver.resolveComponentFactory(component);
            let viewContainerRef = this.dwComponentHost.viewContainerRef;
            viewContainerRef.clear();
            this.componentRef = viewContainerRef.createComponent(componentFactory);
            this.componentInstance = this.componentRef.instance;
        }
        this.componentInstance.fieldDef = this.fieldDef; // this.fieldDef;
        this.componentInstance.formGroup = this.formGroup;
        this.componentInstance.context = this.context;
        // Optinally call an init method
        const initControlInstance = this.componentInstance;
        if (initControlInstance.initControl) {
            initControlInstance.initControl();
        }
        if (this.useLookupConfigDisplayFields()) {
            this.componentInstance.useDisplayField = true;
        }
        //this.formControl = this.formGroup.controls[this.fieldDef.attr.AttributeName]
        // this.isRequired = this.hasRequiredField(this.formControl);
        this.handleDuplicateControls();
        this.cdr.markForCheck();
    }
    handleDuplicateControls() {
        if (this.fieldChangeSubscription) {
            this.fieldChangeSubscription.unsubscribe();
            this.fieldChangeSubscription = null;
        }
        this.lastSetValue = null;
        // HACK - If a control exists more than once on a form, the other control doesn't get updated, this hack fixes the issue for all form controls
        this.fieldChangeSubscription =
            this.formControl.valueChanges
                .subscribe(value => {
                // Only set the last value once (prevents 2 controls from bouncing back and forth)
                if (this.lastSetValue == value) {
                    return;
                }
                this.lastSetValue = value;
                //this.isRequired = this.hasRequiredField(this.formControl);
                this.formControl.setValue(value, { onlySelf: true, emitEvent: false, emitModelToViewChange: true, emitViewToModelChange: false });
            });
    }
    useLookupConfigDisplayFields() {
        return this.fieldDef.useDisplayField;
    }
    determineComponent(fieldDef) {
        this.usingReadOnlyControl = fieldDef.isReadOnly;
        // if (fieldDef.isReadOnly) {
        //     this.usingReadOnlyControl = true;
        // }
        // if (this.formControl && this.formControl.disabled) {
        //     this.usingReadOnlyControl = true;
        // }
        if (fieldDef.useCustomControl && fieldDef.customControlTypeKey) {
            const customComponent = this.getCustomControlComponent(fieldDef, this.usingReadOnlyControl);
            if (customComponent) {
                return customComponent;
            }
        }
        // Get the configured component (these can be overriden in config)
        var component = this.uiMetaDataConfig.controlComponents[fieldDef.controlType];
        if (this.usingReadOnlyControl) {
            // Clear out standard component
            component = null;
            // Change to use new property set by query meta data - Previous logic would logic display fields for context where the display wasn't loaded (and error)
            if (!this.useLookupConfigDisplayFields()) {
                component = this.uiMetaDataConfig.readOnlyControlComponents[fieldDef.controlType];
            }
            if (!component)
                component = this.uiMetaDataConfig.defaultReadOnlyControlComponent;
        }
        if (!component)
            return this.uiMetaDataConfig.defaultControlComponent;
        return component;
    }
    getCustomControlComponent(fieldDef, useReadOnlyControl) {
        var _a, _b;
        const formControlComponent = this.dwConfigRegistryService.getRegisteredComponent(fieldDef.customControlTypeKey, DwComponentType.formControl);
        if (!formControlComponent) {
            console.warn(`Custom form control with key ${fieldDef.customControlTypeKey} is not found. Using defaults`);
            return null;
        }
        if (useReadOnlyControl && ((_a = formControlComponent.configData) === null || _a === void 0 ? void 0 : _a.readOnlyComponent)) {
            return (_b = formControlComponent.configData) === null || _b === void 0 ? void 0 : _b.readOnlyComponent;
        }
        return formControlComponent.component;
    }
    ngOnChanges(changes) {
        if (!this.componentInstance)
            return;
        if (changes.initialFieldDef && changes.initialFieldDef.currentValue) {
            const noChangesMade = areEqual(changes.initialFieldDef.currentValue, changes.initialFieldDef.previousValue);
            if (noChangesMade) {
                return;
            }
            this.fieldDef = this.getFieldDefWithDefaults(this.initialFieldDef);
            this.componentInstance.fieldDef = this.fieldDef; // this.fieldDef;
            this.loadComponent();
        }
        if (changes.formGroup && changes.formGroup.currentValue) {
            this.componentInstance.formGroup = this.formGroup;
            this.loadComponent();
        }
    }
    getFieldDefWithDefaults(originalFieldDef) {
        var _a;
        if (!originalFieldDef) {
            return;
        }
        const defaults = (_a = this.uiMetaDataConfig.attributeControlDefaults) === null || _a === void 0 ? void 0 : _a.find(d => d.matchFunc && d.matchFunc(originalFieldDef));
        if ((defaults === null || defaults === void 0 ? void 0 : defaults.fieldConfig) || (defaults === null || defaults === void 0 ? void 0 : defaults.overrideFieldConfig)) {
            let newFieldConfig = deepCopy(originalFieldDef);
            if (defaults.fieldConfig) {
                newFieldConfig = deepDefaults(newFieldConfig, defaults.fieldConfig, null, null, true);
            }
            if (defaults.overrideFieldConfig) {
                newFieldConfig = deepDefaults(deepCopy(defaults.overrideFieldConfig), newFieldConfig, null, null, true);
            }
            // console.log(`Using defaults for field ${originalFieldDef.attrName}`, { fieldConfig: defaults.fieldConfig, overrideFieldConfig: defaults.overrideFieldConfig }, newFieldConfig);
            return newFieldConfig;
        }
        return originalFieldDef;
    }
}
DwDynamicFieldComponent.ɵfac = function DwDynamicFieldComponent_Factory(t) { return new (t || DwDynamicFieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwDynamicFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDynamicFieldComponent, selectors: [["", "dwDynamicField", ""], ["dwDynamicField"]], viewQuery: function DwDynamicFieldComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, inputs: { colSize: "colSize", submitted: "submitted", useDisplayFields: "useDisplayFields", isRequired: "isRequired", recreateControlOnChange: "recreateControlOnChange", initialFieldDef: ["fieldDef", "initialFieldDef"], formGroup: "formGroup", context: "context" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], attrs: _c65, decls: 13, vars: 14, consts: [[3, "hidden"], [3, "ngClass"], [3, "ngClass", "hidden"], ["title", "Required", 1, "required-label", 3, "hidden"], [1, "fa", "fa-info-circle", "ml-1", 3, "hidden", "title"], ["dw-component-host", ""], [3, "formGroup"], [3, "formControlName", "displayName", "submitted"]], template: function DwDynamicFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 0);
        ɵngcc0.ɵɵelement(2, "i", 1);
        ɵngcc0.ɵɵtext(3, "\u00A0\u00A0 ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "label", 2);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementStart(6, "span", 3);
        ɵngcc0.ɵɵtext(7, "\u00A0*");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "span", 1);
        ɵngcc0.ɵɵtemplate(10, DwDynamicFieldComponent_ng_template_10_Template, 0, 0, "ng-template", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(11, 6);
        ɵngcc0.ɵɵelement(12, "dw-validation-info", 7);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", (ctx.fieldDef == null ? null : ctx.fieldDef.isVisible) == false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.fieldDef == null ? null : ctx.fieldDef.iconClass));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.fieldDef == null ? null : ctx.fieldDef.iconClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.labelClasses)("hidden", ctx.fieldDef == null ? null : ctx.fieldDef.hideLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.fieldDef == null ? null : ctx.fieldDef.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.isRequired || (ctx.fieldDef == null ? null : ctx.fieldDef.hideLabel) || ctx.usingReadOnlyControl);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.fieldDef == null ? null : ctx.fieldDef.infoText))("title", ctx.fieldDef == null ? null : ctx.fieldDef.infoText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.dataClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("displayName", ctx.fieldDef == null ? null : ctx.fieldDef.label)("submitted", ctx.submitted);
    } }, directives: [ɵngcc4.NgClass, DwComponentHost, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwValidationInfo, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwDynamicFieldComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwExpressionService },
    { type: ChangeDetectorRef },
    { type: DwUiConfigRegistryService }
];
DwDynamicFieldComponent.propDecorators = {
    initialFieldDef: [{ type: Input, args: ['fieldDef',] }],
    formGroup: [{ type: Input }],
    colSize: [{ type: Input }],
    submitted: [{ type: Input }],
    context: [{ type: Input }],
    useDisplayFields: [{ type: Input }],
    isRequired: [{ type: Input }],
    recreateControlOnChange: [{ type: Input }],
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }]
};
__decorate$M([
    DwInputConverter(booleanConverter),
    __metadata$y("design:type", Boolean)
], DwDynamicFieldComponent.prototype, "recreateControlOnChange", void 0);

class DwFormControlInputSwitchComponent {
    constructor() {
        this.inputClass = "";
    }
}
DwFormControlInputSwitchComponent.ɵfac = function DwFormControlInputSwitchComponent_Factory(t) { return new (t || DwFormControlInputSwitchComponent)(); };
DwFormControlInputSwitchComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlInputSwitchComponent, selectors: [["dw-fc-input-switch"]], inputs: { context: "context" }, decls: 2, vars: 2, consts: [[3, "formGroup"], [3, "formControlName"]], template: function DwFormControlInputSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "p-inputSwitch", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwFormControlInputSwitchComponent.propDecorators = {
    context: [{ type: Input }]
};

class DwSectionRowConfig {
    constructor() {
        this.columns = [];
    }
}
class DwSectionRowConfigTyped {
    constructor() {
        this.columns = [];
    }
}

class DwSectionColumnConfig {
}
class DwSectionColumnConfigTyped extends DwSectionColumnConfig {
}

class DwSectionLayoutBuilder {
    constructor() {
        this.excludeBlankItems = false;
        this.defaultColumns = 1;
        this.ROOT_FORM_GROUP_KEY = 'root';
        this.FULL_LAYOUT_COLUMNS = 12;
    }
    buildRows(sectionColumnItems, sectionConfig, formGroup, buildItem, getContextName, isItemVisible, formGroupList) {
        var _a, _b;
        if (!sectionConfig)
            return;
        var sectionColumnPrefs = this.getDefaultColumnPreferences(sectionConfig.columnPreferences);
        var rows = [];
        let contextFormGroup = this.getContextFormGroup(formGroup);
        let row = this.createRow(rows);
        formGroupList[this.ROOT_FORM_GROUP_KEY] = formGroup;
        for (let sectionColumnItem of sectionColumnItems || []) {
            const contextName = getContextName(sectionColumnItem);
            let columnFormGroupKey = "root";
            let columnFormGroup = formGroup;
            if (contextName) {
                columnFormGroupKey = contextName;
                columnFormGroup = this.getContextItemFormGroup(contextFormGroup, contextName);
                if (!formGroupList[columnFormGroupKey]) {
                    formGroupList[columnFormGroupKey] = columnFormGroup;
                }
            }
            let item = buildItem(sectionColumnItem, columnFormGroupKey);
            if (this.excludeBlankItems && !item)
                continue;
            let columnItemPreferences = sectionColumnItem.columnItemPreferences || this.getDefaultColumnItemPreferences();
            let createNewRow = false;
            if (columnItemPreferences.rearrangeFieldsOnVisibleChange) {
                const isColumnVisible = isItemVisible(sectionColumnItem, item);
                if (!isColumnVisible) {
                    continue;
                }
            }
            // Handle skip columns - added 5-5-2023
            if (((_a = sectionColumnItem.columnItemPreferences) === null || _a === void 0 ? void 0 : _a.skipColumns) > 0) {
                for (let i = 0; i < parseInt((_b = sectionColumnItem.columnItemPreferences) === null || _b === void 0 ? void 0 : _b.skipColumns.toString()); i++) {
                    const placeHolderColumn = this.createPlaecholderColumn(sectionColumnPrefs, columnItemPreferences, row.columns.length);
                    if (this.needsNewRow(row, placeHolderColumn, columnItemPreferences, sectionColumnPrefs)) {
                        row = this.createRow(rows);
                    }
                    row.columns.push(placeHolderColumn);
                }
            }
            let column = this.createColumn(sectionColumnPrefs, columnItemPreferences, row.columns.length);
            if (this.needsNewRow(row, column, columnItemPreferences, sectionColumnPrefs)) {
                row = this.createRow(rows);
                // Create column again since now it's in the first column
                column = this.createColumn(sectionColumnPrefs, columnItemPreferences, row.columns.length);
            }
            column.item = item;
            column.formGroupKey = columnFormGroupKey;
            row.columns.push(column);
            if (columnItemPreferences && columnItemPreferences.newRowAfter) {
                row = this.createRow(rows);
            }
        }
        return rows;
    }
    getContextFormGroup(formGroup) {
        if (!formGroup) {
            return null;
        }
        if (!formGroup.parent) {
            return formGroup.get(DwMdFormContextInfo.CONTEXT_FORM_GROUP);
        }
        return this.getContextFormGroup(formGroup.parent);
    }
    getContextItemFormGroup(contextFormGroup, contextName) {
        return contextFormGroup.get(contextName);
    }
    needsNewRow(row, column, columnItemPreferences, sectionColumnPrefs) {
        if (!row)
            return true;
        let columns = sectionColumnPrefs.columns || this.defaultColumns;
        if (row.columns.length >= columns) {
            if (!columnItemPreferences.columnSizeOverride) {
                return true;
            }
        }
        if (row.columns.length > 0 && columnItemPreferences.newRowBefore)
            return true;
        let usedSize = 0;
        for (let col of row.columns) {
            usedSize += col.columnSize;
        }
        if (usedSize + column.columnSize > this.FULL_LAYOUT_COLUMNS)
            return true;
        return false;
    }
    createRow(rows) {
        var row = new DwSectionRowConfig();
        rows.push(row);
        return row;
    }
    createColumn(sectionColumnPrefs, columnItemPreferences, columnNumber) {
        let column = new DwSectionColumnConfig();
        column.isPlaceHolder = false;
        let columns = sectionColumnPrefs.columns || this.defaultColumns;
        // default size
        let regularColumnSize = this.FULL_LAYOUT_COLUMNS / columns;
        if (sectionColumnPrefs.columnDetails && sectionColumnPrefs.columnDetails[columnNumber]) {
            let columnPref = sectionColumnPrefs.columnDetails[columnNumber];
            if (columnPref.columnSize)
                regularColumnSize = columnPref.columnSize;
            column.columnOptions = columnPref;
            // column.customWidth = columnPref.customWidth;
            // column.customHeight = columnPref.customHeight;
            // column.columnClass = columnPref.columnClass;
        }
        column.columnSize = regularColumnSize;
        if (columnItemPreferences.columnSizeOverride) {
            column.columnSize = parseInt(columnItemPreferences.columnSizeOverride.toString());
        }
        if (columnItemPreferences) {
            if (columnItemPreferences.spanAllColumns)
                column.columnSize = this.FULL_LAYOUT_COLUMNS;
            switch (columnItemPreferences.colSpan) {
                case DwFormColumnSpanType.full:
                    column.columnSize = this.FULL_LAYOUT_COLUMNS;
                    break;
                case DwFormColumnSpanType.half:
                    column.columnSize = this.FULL_LAYOUT_COLUMNS / 2;
                    break;
                default:
                    if (columnItemPreferences.colSpan)
                        column.columnSize = regularColumnSize * columnItemPreferences.colSpan;
            }
        }
        return column;
    }
    createPlaecholderColumn(sectionColumnPrefs, columnItemPreferences, columnNumber) {
        let column = new DwSectionColumnConfig();
        column.isPlaceHolder = true;
        let columns = sectionColumnPrefs.columns || this.defaultColumns;
        // default size
        let regularColumnSize = this.FULL_LAYOUT_COLUMNS / columns;
        column.columnSize = regularColumnSize;
        return column;
    }
    getDefaultColumnItemPreferences() {
        let columnItemPreferences = new DwFormColumnItemPreference();
        return columnItemPreferences;
    }
    getDefaultColumnPreferences(prefs) {
        if (prefs)
            return prefs;
        let columnPreferences = new DwSectionColumnPreferences();
        columnPreferences.columns = 1;
        return columnPreferences;
    }
}

function DwSectionComponent(compDef) {
    return function (constructor) {
        DwSectionComponentFunc(compDef, constructor);
        // let componentRef : DwFormSectionDefinition = {
        //      ...compDef,
        //      component: null
        // }
        // componentRef.component = <Type<any>>constructor;
        // let uiConfigRegistyService = new DwUiConfigRegistryService();
        // uiConfigRegistyService.registerItem(DwUiRegistryType.formSections, componentRef);
    };
}
function DwSectionComponentFunc(compDef, component) {
    let componentRef = Object.assign(Object.assign({}, compDef), { component: null });
    componentRef.component = component;
    let uiConfigRegistyService = new DwUiConfigRegistryService();
    uiConfigRegistyService.registerItem(DwUiRegistryType.formSections, componentRef);
}

class DwMdSectionConfigBaseComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb) {
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.dwFormUtilService = dwFormUtilService;
        this.dwFormBuilderService = dwFormBuilderService;
        this.dwFormService = dwFormService;
        this.dwContextService = dwContextService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.fb = fb;
        this.contextNames = [];
        this.sectionChange = new EventEmitter();
        const allSectionDefs = dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
        this.sectionDefs = allSectionDefs.filter(sd => !sd.requiresParent);
    }
    get rootSection() {
        return this.preferences.section;
    }
    setupComplete() {
        // override when needed to handle once all properties have been set
    }
    getItemMetaData(itemName) {
        if (this.itemMetaDataList[itemName])
            return of(this.itemMetaDataList[itemName]);
        return this.dwMetaDataService.getMetaData(itemName)
            .pipe(tap(itemMetaData => {
            this.itemMetaDataList[itemName] = itemMetaData;
        }));
    }
    getParentItemName() {
        return this.dwFormUtilService.getParentItemName(this.rootSection, this._section, this.rootItemName);
    }
    get section() {
        return this._section;
    }
    set section(section) {
        this._section = section;
        if (!this.preferences) {
            return;
        }
        this.itemName = this.getParentItemName();
        this.metaDataConfigContext = {
            itemName: this.itemName,
            contextNames: this.contextNames
        };
        this.getItemMetaData(this.itemName)
            .subscribe(itemMetaData => {
            setTimeout(() => {
                this.itemMetaData = itemMetaData;
                this.sectionChanged();
            });
        });
        this.sectionChanged();
    }
    sectionChanged() {
    }
    onSectionChange() {
        this.sectionChange.emit(this.section);
    }
}
DwMdSectionConfigBaseComponent.ɵfac = function DwMdSectionConfigBaseComponent_Factory(t) { return new (t || DwMdSectionConfigBaseComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DwMdSectionConfigBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMdSectionConfigBaseComponent, inputs: { contextNames: "contextNames", section: "section", itemName: "itemName", rootItemName: "rootItemName", itemMetaDataList: "itemMetaDataList", preferences: "preferences" }, outputs: { sectionChange: "sectionChange" } });
DwMdSectionConfigBaseComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder }
];
DwMdSectionConfigBaseComponent.propDecorators = {
    rootItemName: [{ type: Input }],
    itemMetaDataList: [{ type: Input }],
    preferences: [{ type: Input }],
    contextNames: [{ type: Input }],
    itemName: [{ type: Input }],
    section: [{ type: Input }],
    sectionChange: [{ type: Output }]
};

class DwMdSectionFormConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.horizontalForm = DwFormStyle.horizontalForm;
        //   addItem() {
        //       let field = new DwFormFieldPreference();
        //       field.columnItemPreferences = new DwFormColumnItemPreference();
        //       this.section.fields.push(field);
        //   }
        //   removeItem(item) {
        //       var index = this.section.fields.indexOf(item);
        //       if (index >= 0)
        //       this.section.fields.splice(index, 1);
        //   }
        //   moveUp(item) {
        //       var index = this.section.fields.indexOf(item);
        //       if (index==0)
        //           return;
        //       let newIndex = index--;
        //       this.section.fields.splice(newIndex, 0, this.section.fields.splice(index,1)[0]);
        //   }
        //   moveDown(item) {
        //       var index = this.section.fields.indexOf(item);
        //       if (index==this.section.fields.length-1)
        //           return;
        //       let newIndex = index++;
        //       this.section.fields.splice(newIndex, 0, this.section.fields.splice(index,1)[0]);
        //   }
    }
    ngOnInit() {
        this.setFieldColumnItemPreference();
        this.formStyles = new DwFormStyleList().getEnumList();
    }
    sectionChanged() {
        this.setFieldColumnItemPreference();
        if (!this.section.validationConfig) {
            this.section.validationConfig = {
                overrideDefaults: false,
                validators: [],
            };
        }
        let itemName = this.getParentItemName();
        this.getItemMetaData(itemName)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
        });
    }
    setFieldColumnItemPreference() {
        if (!this.section) {
            return;
        }
        if (!this.section.fields) {
            this.section.fields = [];
        }
        for (let field of this.section.fields) {
            if (!field.columnItemPreferences)
                field.columnItemPreferences = new DwFormColumnItemPreference();
        }
    }
}
DwMdSectionFormConfigComponent.ɵfac = function DwMdSectionFormConfigComponent_Factory(t) { return ɵDwMdSectionFormConfigComponent_BaseFactory(t || DwMdSectionFormConfigComponent); };
DwMdSectionFormConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionFormConfigComponent, selectors: [["dw-md-section-form-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 19, consts: [[2, "width", "100%"], ["header", "Fields"], [3, "contextNames", "preferences", "itemMetaDataList", "rootItemName", "section"], ["header", "Form Settings"], [4, "ngIf"], ["header", "Validation", 4, "ngIf"], ["header", "Section Configuration"], [3, "contextNames", "preferences", "itemMetaDataList", "rootItemName", "showColumnConfig", "showReadOnlySection", "section"], ["header", "Section Preview"], [1, "row"], [1, "col-md-6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["class", "col-md-6", 4, "ngIf"], ["allowNull", "true", "nullDisplay", "Automatic", 3, "ngModel", "ngModelChange"], ["dwCol", "6"], [3, "ngModel", "contextNames", "item", "ngModelChange"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Validation"], ["validationItemType", "formGroup", 3, "config", "configContext", "configChange"]], template: function DwMdSectionFormConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 1);
        ɵngcc0.ɵɵelement(3, "dw-md-section-form-fields-config", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p-tabPanel", 3);
        ɵngcc0.ɵɵtemplate(5, DwMdSectionFormConfigComponent_ng_container_5_Template, 26, 9, "ng-container", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwMdSectionFormConfigComponent_p_tabPanel_6_Template, 2, 2, "p-tabPanel", 5);
        ɵngcc0.ɵɵelementStart(7, "p-tabPanel", 6);
        ɵngcc0.ɵɵelementStart(8, "div");
        ɵngcc0.ɵɵelement(9, "dw-md-section-standard-config", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p-tabPanel", 8);
        ɵngcc0.ɵɵelement(11, "dw-md-section-preview", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName)("section", ctx.section);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section == null ? null : ctx.section.validationConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName)("showColumnConfig", true)("showReadOnlySection", false)("section", ctx.section);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName)("section", ctx.section);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, DwMdSectionFormFieldsConfigComponent, ɵngcc4.NgIf, DwMdSectionStandardConfigComponent, DwMdSectionPreviewComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, DwYesNoComponent, DwColDirective, DwExpressionPickerControlComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwNumericDirective, DwFieldValidationConfigComponent]; }, styles: [""] });

class DwSectionReadonlyBaseComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionService = dwExpressionService;
        this.dwFormSectionStateService = dwFormSectionStateService;
        this.dwFormStateService = dwFormStateService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.setupReadOnlySubscription();
    }
    setupReadOnlySubscription() {
        this.subscriptions.push(this.dwFormSectionStateService.getReadOnlyChangedObservable()
            .pipe(delay(5))
            .subscribe(readOnlyChangedSection => {
            // Read only has changed somewhere
            const newReadOnly = this.isSectionReadOnly();
            if (this.lastReadOnly != newReadOnly) {
                this.lastReadOnly = newReadOnly;
                this.sectionReadOnlyChanged(newReadOnly);
            }
        }));
    }
    isSectionReadOnly(includeFormReadOnly = true) {
        if ((this.formConfig.readOnly && includeFormReadOnly) || this.sectionConfig.isReadOnlyFromParent) {
            return true;
        }
    }
}
DwSectionReadonlyBaseComponent.ɵfac = function DwSectionReadonlyBaseComponent_Factory(t) { return new (t || DwSectionReadonlyBaseComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwSectionReadonlyBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwSectionReadonlyBaseComponent, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
DwSectionReadonlyBaseComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$N = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$z = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var DwFormSectionComponent_1;
let DwFormSectionComponent = DwFormSectionComponent_1 = class DwFormSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwConfigService, uiMetaDataConfig, dwExpressionService, dwUiConfigRegistryService, dwMetaDataService, dwMdFormUtilService, dwContextService, cdr, dwFormValidationBuilderService, dwExpressionStateService, dwFormSectionStateService, dwFormStateService) {
        super(dwExpressionService, dwFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMdFormUtilService = dwMdFormUtilService;
        this.dwContextService = dwContextService;
        this.cdr = cdr;
        this.dwFormValidationBuilderService = dwFormValidationBuilderService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.formRows = [];
        this.formGroupList = {};
        this.formFieldRequiredList = {};
        this.formFieldConfigList = {};
        this.fieldStates = {};
        this.formControlDisableTogglingEnabled = true;
        this.formSetupComplete = true;
        this.showDebugMessage = true;
        this.hasConditionalValidation = false;
        this.settingVisibility = false;
        this.conditionalExpressionsSetup = false;
        DwFormSectionComponent_1.instanceCount++;
        this.instanceId = DwFormSectionComponent_1.instanceCount;
    }
    ngOnInit() {
        this.setupSubscriptions();
        super.ngOnInit();
    }
    trackByIndex(index, formRow) {
        return index;
    }
    trackByFieldName(index, field) {
        return field.attrName;
    }
    // Pass input changes up the chain
    sectionConfigChanged() {
        this.buildFormRows('sectionConfigChanged');
    }
    formConfigChanged() {
        this.buildFormRows('formConfigChanged');
    }
    fromGroupChanged() {
        if (this.formGroup) {
            // //console.log(`DwFormSectionComponent - fromGroupChanged - enabledDisplayFields `);
            // this.enableDisplayedFields();
        }
    }
    setupComponentComplete() {
        this.contextDefinitions = this.dwContextService.getContextDefinitions(this.formConfig.contextNames);
    }
    setupSubscriptions() {
        this.subscriptions.push(this.visibleChange
            .pipe(delay(5))
            //.pipe(debounceTime(5))
            .subscribe(value => {
            // this.formSetupComplete = false;
            const additionalMessage = (this.visible !== value) ? `Visibility mismatch - controls won't be enabled/disabled - Section visible :${this.visible} Change value : ${value}` : ``;
            DwFormDebugService.debugMessage(this.instanceId, this.componentName, `visible change  - ${value} - ${additionalMessage}`);
            if (!this.destroyed) {
                if (value) {
                    this.enableDisplayedFields();
                }
                else {
                    this.disableDisplayedFields();
                }
            }
        }));
    }
    // Override parent
    isSectionReadOnly(includeFormReadOnly = true) {
        if (this.formConfig.readOnly && includeFormReadOnly) {
            return true;
        }
        if (this.sectionConfig.isReadOnly == true || this.sectionConfig.isReadOnly == false) {
            return this.sectionConfig.isReadOnly;
        }
        if (this.sectionConfig.isReadOnlyFromParent) {
            return true;
        }
        return false;
    }
    sectionReadOnlyChanged(readOnly) {
        if (readOnly) {
            this.disableDisplayedFields();
        }
        else {
            this.enableDisplayedFields();
        }
    }
    visibleChanged() {
        ////console.log(`${this.componentName} - visibleChanged ${this.visible}`);
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
        return;
    }
    enableDisplayedFields() {
        ////console.log(`${this.componentName} - enableDisplayedFields`);
        if (!this.formControlDisableTogglingEnabled) {
            DwFormDebugService.debugMessage(this.instanceId, this.componentName, `DwFormSection.enableDisplayedFields - return - formControlDisableTogglingEnabled = false`);
            return;
        }
        if (!this.sectionConfig || !this.formGroup) {
            DwFormDebugService.debugMessage(this.instanceId, this.componentName, `DwFormSection.enableDisplayedFields - return - missing sectionConfig or formGroup`);
            return;
        }
        // Only enable fields when the form is visible
        if (!this.visible) {
            DwFormDebugService.debugMessage(this.instanceId, this.componentName, `DwFormSection.enableDisplayedFields - return - control is not visible`);
            return;
        }
        if (this.isSectionReadOnly(false)) {
            return;
        }
        let formReadOnly = this.getFormExpressionResult(this.sectionConfig.isReadOnlyExpression, DwFormFieldExpressionType.formReadOnly, this.sectionConfig.isReadOnly);
        this.updateFormSectionState(formReadOnly);
        DwFormDebugService.debugMessage(this.instanceId, this.componentName, `DwFormSection.enableDisplayedFields - before`);
        let hasChanges = false;
        /**
         * Update on 1/25/2023 - Added support for editable contexts (variable context) so refactored to base off of fields rather than the form group controls
         */
        for (let fieldKey in this.formFieldConfigList) {
            if (!this.formFieldConfigList.hasOwnProperty(fieldKey)) {
                continue;
            }
            const fieldConfig = this.formFieldConfigList[fieldKey];
            const currentFormGroup = this.formGroupList[fieldConfig.formGroupKey];
            let formControl = currentFormGroup.get(fieldConfig.attrName);
            if (!formControl) {
                continue;
            }
            // Find all matching preferences (we could have more than one now)
            const fieldPrefs = this.sectionConfig.fields.filter(f => f.attrName == fieldConfig.attrName && f.contextName == fieldConfig.contextName);
            const fieldState = this.dwFormSectionStateService.getFormFieldState(fieldConfig.formGroupKey, fieldConfig.attrName);
            //const isReadOnly = this.evalFieldReadOnly(fieldPrefs);
            const isReadOnly = (fieldState === null || fieldState === void 0 ? void 0 : fieldState.readonly) == false ? false : true;
            if (isReadOnly && !formControl.disabled) {
                DwFormDebugService.debugMessage(this.instanceId, this.componentName, `enableDisplayedFields - Disabling field ${fieldConfig.attrName} - Control State ${formControl.status} Read Only ${isReadOnly}`, fieldState);
                hasChanges = true;
                formControl.disable({ onlySelf: true });
            }
            if (!isReadOnly) {
                if (!this.formGroup.enabled) {
                    hasChanges = true;
                    this.enableFormGroup(currentFormGroup, fieldPrefs[0].attrName);
                }
                if (formControl.disabled) {
                    //console.log(`DwFormSectionComponent ${this.componentName} -  Enabling field ${fieldName} - Disbled State ${formControl.status}`);
                    DwFormDebugService.debugMessage(this.instanceId, this.componentName, `enableDisplayedFields - Enabling field ${fieldConfig.attrName} - Control State ${formControl.status} Read Only ${isReadOnly}`, fieldState);
                    hasChanges = true;
                    formControl.enable();
                }
            }
        }
        this.formSetupComplete = true;
        if (!hasChanges && !this.formSetupComplete) {
            return;
        }
        DwFormDebugService.debugMessage(this.instanceId, this.componentName, `DwFormSection.enableDisplayedFields - after - changes made`);
        this.formGroup.updateValueAndValidity();
        this.buildFormRows('enabledDisplayedFields');
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
        ;
    }
    // private evalFieldReadOnly(fieldPrefs: DwFormFieldPreference[]): boolean {
    //     let isReadOnly = true;
    //     // Check if the form is read only first, if so, then all fields would be read only (also happens in a higher level check, but keeping it here just in case)
    //     //const formReadOnly = this.getFormExpressionResult(this.sectionConfig.isReadOnlyExpression, DwFormFieldExpressionType.formReadOnly, this.isSectionReadOnly());
    //     if (this.isSectionReadOnly(false)) {
    //         return true;
    //     }
    //     // We can now have more than one field preference
    //     for (let fieldPref of fieldPrefs) {
    //         const expressionReadOnly = this.getFieldExpressionResult(fieldPref, fieldPref.isReadOnlyExpression, DwFormFieldExpressionType.readonly, false);
    //         const expressionVisible = this.getFieldExpressionResult(fieldPref, fieldPref.isVisibleExpression, DwFormFieldExpressionType.visible, null);
    //         let isReadOnlyContext = false;
    //         if (fieldPref.contextName) {
    //             isReadOnlyContext = true;
    //             const contextDef = this.contextDefinitions?.find(cd => cd.contextName == fieldPref.contextName);
    //             if (contextDef?.isEditable) {
    //                 isReadOnlyContext = false;
    //             }
    //         }
    //         let fieldIsReadOnly = expressionReadOnly || fieldPref.isReadOnly || this.sectionConfig.isReadOnly || isReadOnlyContext;
    //         // Set all fields to read only if the form is read only (and it's not a context field)
    //         if (this.formConfig.readOnly && !fieldPref.contextName) {
    //             fieldIsReadOnly = true;
    //         }
    //         if (expressionVisible == false) {
    //             // If the control is not visible, it should always be readonly (otherwise it will fail validation)
    //             fieldIsReadOnly = true;
    //         }
    //         // If any field is not read-only, then we clear that value
    //         if (isReadOnly && !fieldIsReadOnly) {
    //             isReadOnly = false;
    //         }
    //     }
    //     return isReadOnly;
    // }
    /*
        disable display fields when this section is not visible or destroyed
    */
    disableDisplayedFields() {
        DwFormDebugService.debugMessage(this.instanceId, this.componentName, `disableDisplayedFields - before`);
        // console.log(`DwFormSectionComponent ${this.componentName} - disableDisplayedFields`);
        if (!this.formControlDisableTogglingEnabled) {
            return;
        }
        if (!this.sectionConfig || !this.formGroup) {
            ////console.log(`${this.componentName} - enableDisplayedFields - SectionConfig or formGroup aren't initiallized`);
            return;
        }
        let formReadOnly = this.getFormExpressionResult(this.sectionConfig.isReadOnlyExpression, DwFormFieldExpressionType.formReadOnly, this.sectionConfig.isReadOnly, this.formConfig.readOnly);
        this.updateFormSectionState(formReadOnly);
        this.updateFormSectionState(formReadOnly);
        let hasChanges = false;
        for (let fieldKey in this.formFieldConfigList) {
            if (!this.formFieldConfigList.hasOwnProperty(fieldKey)) {
                continue;
            }
            const fieldConfig = this.formFieldConfigList[fieldKey];
            const currentFormGroup = this.formGroupList[fieldConfig.formGroupKey];
            let formControl = currentFormGroup.get(fieldConfig.attrName);
            if (!formControl) {
                continue;
            }
            const fieldState = this.dwFormSectionStateService.getFormFieldState(fieldConfig.formGroupKey, fieldConfig.attrName);
            // Find all matching preferences (we could have more than one now)
            //const fieldPrefs = this.sectionConfig.fields.filter(f => f.attrName == fieldConfig.attrName && f.contextName == fieldConfig.contextName);
            const isReadOnly = (fieldState === null || fieldState === void 0 ? void 0 : fieldState.readonly) == false ? false : true;
            if (isReadOnly && !formControl.disabled) {
                DwFormDebugService.debugMessage(this.instanceId, this.componentName, `disableDisplayedFields - Disabling field ${fieldConfig.attrName} - Control State ${formControl.status} Is Read Only: ${isReadOnly}`, fieldState);
                hasChanges = true;
                formControl.disable({ onlySelf: true });
            }
        }
        if (!hasChanges && !this.formSetupComplete) {
            return;
        }
        DwFormDebugService.debugMessage(this.instanceId, this.componentName, `disableDisplayedFields made changes`);
        this.formGroup.updateValueAndValidity();
    }
    // If the form group isn't enabled, then enable it, but mark all children as disabled
    //   This allows the forms to enable the correct controls
    enableFormGroup(formGroup, exclueFieldNameFromDisable) {
        //DwFormDebugService.debugMessage(this.instanceId, this.componentName, `enableFormGroup - before`);
        //console.log(`DwFormSectionComponent ${this.componentName} -  Enabling form group - Disbled State ${this.formGroup.status}`);
        formGroup.enable({ emitEvent: false, onlySelf: true });
        // Changed on 2/22/23 to fix an issue where the form group wouldn't get updated
        //formGroup.enable();
        for (let fieldName in formGroup.controls) {
            let formControl = formGroup.get(fieldName);
            if (formControl.disabled || fieldName == exclueFieldNameFromDisable) {
                continue;
            }
            // Changed on 2/22/23 to fix an issue where the form group wouldn't get updated
            if (formControl instanceof FormControl) {
                if (!formControl.disabled) {
                    //    DwFormDebugService.debugMessage(this.instanceId, this.componentName, `Enable Form group, disabling field ${fieldName} - current sate ${formControl.status}`);
                    formControl.disable({ emitEvent: false });
                }
            }
            else {
                //DwFormDebugService.debugMessage(this.instanceId, this.componentName, `Enable Form group, skipping non FieldContorl ${fieldName}`);
                formControl.disable({ emitEvent: false });
            }
        }
        //DwFormDebugService.debugMessage(this.instanceId, this.componentName, `enableFormGroup - after - Enabled = ${formGroup.enabled} - ${formGroup.status}`);
    }
    ngOnChanges(changes) {
        let buildForm = false;
        if (changes.sectionConfig && changes.sectionConfig.currentValue && !changes.sectionConfig.firstChange) {
            buildForm = true;
        }
        if (changes.formConfig && changes.formConfig.currentValue && !changes.formConfig.firstChange) {
            buildForm = true;
        }
        if (buildForm) {
            this.conditionalExpressionsSetup = false;
            this.buildFormRows('ngOnChanges');
        }
    }
    ngOnDestroy() {
        var _a, _b;
        super.ngOnDestroy();
        // Disable the fields that were previously displayed
        setTimeout(() => {
            this.disableDisplayedFields();
        }, 0);
        // Unsubscribe from any expressions
        (_a = this.conditionalExpressionSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.conditionalExpressionSubscription = null;
        (_b = this.formValidationExpressionSet) === null || _b === void 0 ? void 0 : _b.conditionalExpressionSubscription.unsubscribe();
        this.formValidationExpressionSet = null;
    }
    // Move to Form layout service
    buildFormRows(source) {
        if (!this.sectionConfig || !this.formConfig || !this.sectionConfig.fields)
            return;
        this.initConditionalExpressions();
        const layoutBuilder = new DwSectionLayoutBuilder();
        // Exclude blank fields
        layoutBuilder.excludeBlankItems = true;
        layoutBuilder.defaultColumns = 1;
        let itemName = this.dwMdFormUtilService.getParentItemName(this.formConfig.section, this.sectionConfig, this.formConfig.rootItemName);
        let itemMetaData = this.formConfig.queryMetaDataList[itemName];
        let formReadOnly = this.getFormExpressionResult(this.sectionConfig.isReadOnlyExpression, DwFormFieldExpressionType.formReadOnly, this.isSectionReadOnly(false)
        //,this.formConfig.readOnly
        );
        const rows = layoutBuilder.buildRows(this.sectionConfig.fields, this.sectionConfig, this.formGroup, (fieldPref, formGroupKey) => {
            return this.buildFieldConfig(fieldPref, itemMetaData, formGroupKey, formReadOnly);
        }, (fieldPref) => fieldPref.contextName, (fieldPref, fieldkey) => this.formFieldConfigList[fieldkey].isVisible, this.formGroupList);
        if (this.formRows.length == rows.length && areEqual(this.formRows, rows)) {
            return;
        }
        let debug = false;
        if (DwFormDebugService.debugMessage(this.instanceId, this.componentName, `buildFormRows - updated - source ${source}`)) {
            debug = true;
            const rowData = {
                currentRows: this.formRows,
                newRows: rows,
                conditionalExpressionResult: this.conditionalExpressionResult,
                currentRowsJson: JSON.stringify(this.formRows),
                newRowsJson: JSON.stringify(rows)
            };
            DwFormDebugService.debugMessage(this.instanceId, this.componentName, `buildFormRows - updated - source ${source} - Row JSON`, rowData);
        }
        if (!areEqual(this.formRows, rows)) {
            this.formRows = rows;
            this.updateFormSectionState(formReadOnly);
        }
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
        ;
    }
    updateFormSectionState(formReadOnly) {
        const sectionId = this.dwMdFormUtilService.getSectionConfigUniqueId(this.sectionConfig, this.formConfig.section);
        const formSectionState = {
            sectionId: sectionId,
            formGroup: this.formGroup,
            itemName: null,
            sectionConfig: this.sectionConfig,
            fieldStates: this.fieldStates,
            visible: this.visible,
            readonly: formReadOnly,
        };
        this.dwFormSectionStateService.updateSectionState(formSectionState);
    }
    initConditionalExpressions() {
        if (this.conditionalExpressionsSetup) {
            return;
        }
        this.conditionalExpressionsSetup = true;
        if (this.conditionalExpressionSubscription) {
            this.conditionalExpressionSubscription.unsubscribe();
        }
        this.conditionalExpressionSetResult = this.buildConditionalExpressionSet();
        this.conditionalExpressionResult = this.conditionalExpressionSetResult.initialResults;
        this.setupConditionalFieldValidation();
        this.initFormValidation();
        this.conditionalExpressionSubscription = this.conditionalExpressionSetResult.observable.subscribe(result => {
            setTimeout(() => {
                this.conditionalExpressionResult = result;
                this.setupConditionalFieldValidation();
                // Need to rebuild form rows
                this.buildFormRows('initConditionalExpressions - subscription');
                // Re-trigger display fields since they might need to be updated
                this.enableDisplayedFields();
            }, 5);
        });
    }
    initFormValidation() {
        var _a;
        this.relatedSections = this.dwMdFormUtilService.findRelatedSections(this.formConfig.section, this.sectionConfig, this.sectionConfig.sectionType);
        if (!this.relatedSections.isPrimarySection) {
            return;
        }
        if (!((_a = this.formValidationExpressionSet) === null || _a === void 0 ? void 0 : _a.conditionalExpressionResult)) {
            this.formValidationExpressionSet = this.dwFormValidationBuilderService.initMultiSectionValidation(this.relatedSections, this.formGroup, this.context);
        }
    }
    buildFieldConfig(fieldPref, itemMetaData, formGroupKey, formReadOnly) {
        var _a;
        const field = new DwFormFieldConfig();
        const formGroup = this.formGroupList[formGroupKey];
        field.formGroupKey = formGroupKey;
        field.itemName = itemMetaData.RootItem;
        field.contextName = fieldPref.contextName;
        const queryAttr = this.getQueryAttribute(fieldPref, itemMetaData);
        if (!queryAttr)
            return;
        const formControl = formGroup.get(fieldPref.attrName);
        if (!formControl) {
            console.warn(`Form control not found for attr '${fieldPref.attrName}.  Hiding control`);
            return;
        }
        const fieldIndex = this.sectionConfig.fields.indexOf(fieldPref);
        let formConfigKey = `data.${fieldPref.attrName}_${fieldIndex}`;
        if (fieldPref.contextName) {
            formConfigKey = `context.${fieldPref.contextName}.${fieldPref.attrName}_${fieldIndex}`;
        }
        this.formFieldConfigList[formConfigKey] = field;
        const attr = queryAttr.Attribute;
        field.attr = attr;
        field.attrName = fieldPref.attrName;
        field.label = fieldPref.label || attr.Display;
        field.validationConfig = fieldPref.validationConfig;
        field.fieldPreference = fieldPref;
        // set default value for control type override (useControlTypeOverride is a new field and might not be set.  Previously, it only used the control type override)
        if (fieldPref.useControlTypeOverride == undefined) {
            if (!fieldPref.controlTypeOverride) {
                fieldPref.useControlTypeOverride = false;
            }
            else {
                fieldPref.useControlTypeOverride = true;
            }
        }
        field.controlType = attr.MetaDataControlTypeId;
        // Handle control type overrides
        if (fieldPref.useControlTypeOverride) {
            if (fieldPref.useCustomControl) {
                field.useCustomControl = true;
                field.customControlTypeKey = fieldPref.customControlTypeKey;
            }
            else {
                field.controlType = fieldPref.controlTypeOverride;
            }
        }
        field.controlOptions = fieldPref.controlOptions;
        const isRequired = this.isRequired(fieldPref, attr);
        if (isRequired) {
            this.formFieldRequiredList[formConfigKey] = {
                attrName: fieldPref.attrName,
                isRequired: isRequired
            };
        }
        // Update the rest of the property from the field pref to the field config
        defaults(field, fieldPref);
        field.lookupConfig = fieldPref.lookupConfig;
        if (this.formConfig.useLongDisplay && attr && attr.LongDisplay) {
            field.label = attr.LongDisplay;
        }
        if (queryAttr.HasDisplayField) {
            if (fieldPref.contextName || this.formConfig.loadDisplayProperties) {
                const displayFormControl = formGroup.get(queryAttr.DisplayAttributeName);
                if (displayFormControl) {
                    field.useDisplayField = true;
                }
            }
        }
        const expressionReadOnly = this.getFieldExpressionResult(fieldPref, fieldPref.isReadOnlyExpression, DwFormFieldExpressionType.readonly, fieldPref.isReadOnly);
        const expressionVisible = this.getFieldExpressionResult(fieldPref, fieldPref.isVisibleExpression, DwFormFieldExpressionType.visible, null);
        // evaluated and passed in
        //const formReadOnly = this.getFormExpressionResult(this.sectionConfig.isReadOnlyExpression, DwFormFieldExpressionType.formReadOnly, this.isSectionReadOnly());
        let isReadOnlyContext = false;
        let isEditableContext = false;
        if (fieldPref.contextName) {
            isReadOnlyContext = true;
            const contextDef = (_a = this.contextDefinitions) === null || _a === void 0 ? void 0 : _a.find(cd => cd.contextName == fieldPref.contextName);
            if (contextDef === null || contextDef === void 0 ? void 0 : contextDef.isEditable) {
                isEditableContext = true;
                isReadOnlyContext = false;
            }
        }
        if (expressionReadOnly || formReadOnly || isReadOnlyContext) {
            field.isReadOnly = true;
        }
        else {
            field.isReadOnly = false;
        }
        if (this.formConfig.readOnly && !isEditableContext) {
            field.isReadOnly = true;
        }
        field.isVisible = true;
        if (expressionVisible == false) {
            field.isVisible = false;
            field.isReadOnly = true;
        }
        field.labelClass = this.getConditionalClasses(fieldPref, 'label', fieldPref.labelClass, this.sectionConfig.labelClass);
        field.dataClass = this.getConditionalClasses(fieldPref, 'data', fieldPref.dataClass, this.sectionConfig.dataClass);
        field.iconClass = this.getConditionalClasses(fieldPref, 'icon', fieldPref.iconClass);
        // const fieldIndex = this.sectionConfig.fields.indexOf(fieldPref);
        // let formConfigKey = `data.${fieldPref.attrName}_${fieldIndex}`;
        // if (fieldPref.contextName) {
        //     formConfigKey = `context.${fieldPref.contextName}.${fieldPref.attrName}_${fieldIndex}`;
        // }
        // this.formFieldConfigList[formConfigKey] = field;
        // Update form field state
        const fieldState = {
            formGroupKey: formGroupKey,
            attrName: field.attrName,
            visible: field.isVisible,
            readonly: field.isReadOnly
        };
        this.fieldStates[formConfigKey] = fieldState;
        return formConfigKey;
    }
    isRequired(fieldPref, attr) {
        var _a, _b;
        const requiredValidatorConfig = (_b = (_a = fieldPref === null || fieldPref === void 0 ? void 0 : fieldPref.validationConfig) === null || _a === void 0 ? void 0 : _a.validators) === null || _b === void 0 ? void 0 : _b.find(vc => vc.validatorKey == DwFormValidators.required);
        if (!requiredValidatorConfig) {
            if (attr.AlwaysRequired) {
                return true;
            }
            return false;
        }
        // Check if there is conditional validation (if so, it will be managed by the conditional validation)
        if (this.dwFormValidationBuilderService.hasConditionalValidation(fieldPref.validationConfig)) {
            return null;
        }
        return true;
    }
    getConditionalClasses(fieldPref, classCategory, className, formClassName = '') {
        let finalClasses = [];
        if (formClassName) {
            finalClasses.push(formClassName);
        }
        if (className) {
            finalClasses.push(className);
        }
        if (fieldPref.conditionalFieldClasses && this.conditionalExpressionResult) {
            const fieldClasses = fieldPref.conditionalFieldClasses[classCategory] || [];
            let index = 0;
            for (const fieldClass of fieldClasses) {
                const expressionKey = this.buildClassExpressionKey(fieldPref, classCategory, index);
                index++;
                const expressionResult = this.conditionalExpressionResult[expressionKey];
                if (expressionResult === null || expressionResult === void 0 ? void 0 : expressionResult.result) {
                    finalClasses.push(fieldClass.className);
                    expressionResult.classes = finalClasses;
                }
            }
        }
        return finalClasses.join(' ');
    }
    getFieldExpressionResult(fieldPref, expr, exprType, defaultvalue) {
        // Ensure we have a result before evaulating
        if (!this.conditionalExpressionResult) {
            return defaultvalue;
        }
        if (!expr) {
            return defaultvalue;
        }
        const expressionKey = this.buildExpressionKey(fieldPref, exprType);
        const expressionResult = this.conditionalExpressionResult[expressionKey];
        if (expressionResult) {
            return expressionResult.result;
        }
        return defaultvalue;
    }
    getFormExpressionResult(expr, exprType, defaultvalue, forcedTrue) {
        if (forcedTrue) {
            return forcedTrue;
        }
        // Ensure we have a result before evaulating
        if (!this.conditionalExpressionResult) {
            return defaultvalue;
        }
        if (!expr) {
            return defaultvalue;
        }
        const expressionKey = this.buildFormKey(exprType);
        const expressionResult = this.conditionalExpressionResult[expressionKey];
        if (expressionResult) {
            return expressionResult.result;
        }
        return defaultvalue;
    }
    getQueryAttribute(fieldPref, queryMetaData) {
        var _a;
        if (!fieldPref.attrName) {
            return null;
        }
        const attrName = fieldPref.attrName.toUpperCase();
        if (fieldPref.contextName) {
            const contextMetaData = this.formConfig.contextMetaDataList[fieldPref.contextName];
            if (!contextMetaData) {
                console.warn(`Field ${fieldPref.attrName} could load required context ${fieldPref.contextName}.  Please add this context to the form or remove these items`);
                return null;
            }
            return (_a = contextMetaData.attributes) === null || _a === void 0 ? void 0 : _a.find(a => a.AttributeName.toUpperCase() === attrName);
        }
        return queryMetaData.Attributes.find(a => a.AttributeName.toUpperCase() === attrName);
    }
    setupConditionalFieldValidation() {
        if (!this.hasConditionalValidation) {
            return;
        }
        for (let fieldKey in this.formFieldConfigList) {
            if (!this.formFieldConfigList.hasOwnProperty(fieldKey)) {
                continue;
            }
            const fieldConfig = this.formFieldConfigList[fieldKey];
            if (!this.dwFormValidationBuilderService.hasConditionalValidation(fieldConfig.validationConfig)) {
                continue;
            }
            const currentFormGroup = this.formGroupList[fieldConfig.formGroupKey];
            let formControl = currentFormGroup.get(fieldConfig.attrName);
            if (!formControl) {
                continue;
            }
            const conditionalValidationKeyPart = this.buildExpressionKey(fieldConfig.fieldPreference, DwFormFieldExpressionType.validation);
            const validatorsResult = this.dwFormValidationBuilderService.buildValidators(formControl, fieldConfig.validationConfig, conditionalValidationKeyPart, this.conditionalExpressionResult);
            if (!this.formFieldRequiredList[fieldKey]) {
                this.formFieldRequiredList[fieldKey] = {
                    attrName: fieldConfig.attrName,
                    isRequired: false
                };
            }
            const isRequired = !!validatorsResult.validatorKeys.find(validatorKey => validatorKey == DwFormValidators.required);
            this.formFieldRequiredList[fieldKey].isRequired = isRequired;
            this.logMessage("setupConditionalValiadtion - before");
            formControl.setValidators(validatorsResult.validators);
            formControl.updateValueAndValidity({ onlySelf: true, emitEvent: true });
            this.logMessage("setupConditionalValiadtion - after");
        }
    }
    buildConditionalExpressionSet() {
        const expressionSet = {
            defaultResult: false,
            delayMs: 100,
            isArray: false,
            expressions: {}
        };
        // Add Form read only expression
        if (!this.dwExpressionService.isEmptyExpressionGroupItem(this.sectionConfig.isReadOnlyExpression)) {
            const formKey = this.buildFormKey(DwFormFieldExpressionType.formReadOnly);
            expressionSet.expressions[formKey] = this.sectionConfig.isReadOnlyExpression;
        }
        for (const field of this.sectionConfig.fields) {
            if (!field) {
                continue;
            }
            for (const classCategory in field.conditionalFieldClasses || []) {
                if (field.conditionalFieldClasses.hasOwnProperty(classCategory)) {
                    const areaFieldClasses = field.conditionalFieldClasses[classCategory] || [];
                    let index = 0;
                    for (const fieldClass of areaFieldClasses) {
                        if (this.dwExpressionService.isEmptyExpressionGroupItem(fieldClass.expression) || !fieldClass.className) {
                            continue;
                        }
                        const expressionKey = this.buildClassExpressionKey(field, classCategory, index);
                        expressionSet.expressions[expressionKey] = fieldClass.expression;
                        index++;
                    }
                }
            }
            if (!this.dwExpressionService.isEmptyExpressionGroupItem(field.isReadOnlyExpression)) {
                const readOnlyExpressionKey = this.buildExpressionKey(field, DwFormFieldExpressionType.readonly);
                expressionSet.expressions[readOnlyExpressionKey] = field.isReadOnlyExpression;
            }
            if (!this.dwExpressionService.isEmptyExpressionGroupItem(field.isVisibleExpression)) {
                const visibleExpressionKey = this.buildExpressionKey(field, DwFormFieldExpressionType.visible);
                expressionSet.expressions[visibleExpressionKey] = field.isVisibleExpression;
            }
            if (this.dwFormValidationBuilderService.hasConditionalValidation(field.validationConfig)) {
                this.hasConditionalValidation = true;
                const conditionalValidationKeyPart = this.buildExpressionKey(field, DwFormFieldExpressionType.validation);
                this.dwFormValidationBuilderService.buildValidationExpressionSet(expressionSet, conditionalValidationKeyPart, field.validationConfig);
            }
        }
        // if (this.dwFormValidationBuilderService.hasConditionalValidation(this.sectionConfig.validationConfig)) {
        //     this.hasConditionalValidation = true;
        //     const conditionalValidationKeyPart = 'form_validation'this.buildExpressionKey(field, DwFormFieldExpressionType.validation);
        //     this.dwFormValidationBuilderService.buildValidationExpressionSet(expressionSet, conditionalValidationKeyPart, field.validationConfig);
        // }
        const expressionSetResult = this.dwExpressionStateService.initExpressionSet(expressionSet, this.formGroup, this.context);
        return expressionSetResult;
    }
    buildClassExpressionKey(field, classCategory, index) {
        const expressionKey = `${field.attrName}.${classCategory}.${index}`;
        return expressionKey;
    }
    buildExpressionKey(field, exprType) {
        const index = this.sectionConfig.fields.indexOf(field);
        const expressionKey = `${field.attrName}.${exprType}.${index}`;
        return expressionKey;
    }
    buildFormKey(exprType) {
        return `form-field-${exprType}`;
    }
    logMessage(message) {
        DwFormDebugService.debugMessage(this.instanceId, this.componentName, message);
    }
};
DwFormSectionComponent.ɵfac = function DwFormSectionComponent_Factory(t) { return new (t || DwFormSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwFormSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormSectionComponent, selectors: [["dw-form-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "formGroup", "submitted", "filterKey"], [3, "hidden", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "hidden"], ["dwRow", ""], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["dwPageDesignerSelector", "", 3, "dwCol", "dwColWidth", "dwColClass", "configKey", "sectionKey", "detailKey", "additionalInfo"], ["class", "dw-placeholder", 4, "ngIf"], [1, "dw-placeholder"], [3, "ngSwitch"], [3, "isRequired", "labelWidth", "fieldDef", "formGroup", "submitted", "context", "useDisplayFields", 4, "ngSwitchCase"], [3, "isRequired", "fieldDef", "formGroup", "submitted", "context", "useDisplayFields", 4, "ngSwitchDefault"], [3, "isRequired", "labelWidth", "fieldDef", "formGroup", "submitted", "context", "useDisplayFields"], [3, "isRequired", "fieldDef", "formGroup", "submitted", "context", "useDisplayFields"]], template: function DwFormSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFormSectionComponent_ng_container_0_Template, 3, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.visible);
    } }, directives: function () { return [ɵngcc4.NgIf, DwValidationInfo, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgForOf, DwRowDirective, DwDesignerSelector, DwColDirective, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault, DwDynamicFieldHorizontalComponent, DwDynamicFieldComponent]; }, encapsulation: 2 });
DwFormSectionComponent.instanceCount = 0;
DwFormSectionComponent.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwContextService },
    { type: ChangeDetectorRef },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwExpressionStateService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService }
];
DwFormSectionComponent = DwFormSectionComponent_1 = __decorate$N([
    DwSectionComponent({
        keyName: DwSectionType.form,
        display: 'Form',
        sectionIcon: 'fa fa-line-columns',
        configComponent: DwMdSectionFormConfigComponent,
        hasChildren: false,
        hasReadOnlyMode: true
    }),
    __metadata$z("design:paramtypes", [DwConfigService, Object, DwExpressionService,
        DwUiConfigRegistryService,
        DwMetaDataService,
        DwMetadataFormUtilService,
        DwContextService,
        ChangeDetectorRef,
        DwMetadataFormValidationBuilderService,
        DwExpressionStateService,
        DwMetaDataFormSectionStateService,
        DwMetaDataFormStateService])
], DwFormSectionComponent);
var DwFormFieldExpressionType;
(function (DwFormFieldExpressionType) {
    DwFormFieldExpressionType["readonly"] = "readonly";
    DwFormFieldExpressionType["visible"] = "visible";
    DwFormFieldExpressionType["formReadOnly"] = "formReadOnly";
    DwFormFieldExpressionType["validation"] = "validation";
})(DwFormFieldExpressionType || (DwFormFieldExpressionType = {}));

class DwMdSectionComponentConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.pageComponentType = DwComponentType.pageComponent;
    }
    ngOnInit() {
        const parentItem = this.getParentItemName();
        this.componentList = this.dwUiConfigRegistryService.getRegisteredComponents([DwComponentType.formSection, DwComponentType.pageComponent], parentItem);
        this.changeComponent();
    }
    changeComponent() {
        this.currentComponent = this.componentList.find(cl => cl.key === this.section.componentName);
        if (!this.currentComponent) {
            this.currentComponent = this.componentList.find(cl => cl.name == this.section.componentName);
        }
        this.clearSubscription();
        this.configComponent = null;
        if (this.currentComponent) {
            this.configComponent = this.currentComponent.configComponent;
        }
    }
    setupConfigComponent(componentInstance) {
        if (this.currentComponent.componentType == DwComponentType.formSection) {
            this.setupFormSectionConfig(componentInstance);
            return;
        }
        this.setupPageConfig(componentInstance);
    }
    setupPageConfig(componentInstance) {
        this.componentInstance = componentInstance;
        if (this.componentInstance.setupForm) {
            this.componentInstance.setupForm();
            this.componentInstance.setConfigValue(this.section.config);
            // TODO: store subscriptions and add ngDestroy logic
            this.componentInstance.configFormGroup.valueChanges
                .subscribe(configValue => {
                this.section.config = configValue;
                this.sectionChange.emit(this.section);
            });
        }
    }
    setupFormSectionConfig(componentInstance) {
        this.componentInstance = componentInstance;
        if (this.currentComponent.componentType == DwComponentType.formSection) {
        }
        //this.componentInstance.formGroup = this.formGroup;
        this.componentInstance.itemMetaDataList = this.itemMetaDataList;
        this.componentInstance.rootItemName = this.itemName;
        //this.componentInstance.formGroup = this.formGroup;
        this.componentInstance.preferences = this.preferences;
        this.componentInstance.section = this.section;
        this.componentInstance.contextNames = this.contextNames;
        this.componentInstance.setupComplete();
        if (this.componentInstance.section) {
            this.componentInstance.sectionChange
                .subscribe(sectionChange => {
                this.sectionChange.emit(sectionChange);
            });
        }
    }
    clearSubscription() {
        if (this.configSubscription) {
            this.configSubscription.unsubscribe();
            this.configSubscription = null;
        }
    }
    ngOnDestroy() {
        this.clearSubscription();
    }
}
DwMdSectionComponentConfigComponent.ɵfac = function DwMdSectionComponentConfigComponent_Factory(t) { return ɵDwMdSectionComponentConfigComponent_BaseFactory(t || DwMdSectionComponentConfigComponent); };
DwMdSectionComponentConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionComponentConfigComponent, selectors: [["dw-md-section-component-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 4, consts: [["header", "Component Configuration"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["header", "Section Configuration", 4, "ngIf"], [3, "ngValue"], ["dwCol", "12"], [3, "component", "configure"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"]], template: function DwMdSectionComponentConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Component Item");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionComponentConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.section.componentName = $event; })("ngModelChange", function DwMdSectionComponentConfigComponent_Template_select_ngModelChange_7_listener() { return ctx.changeComponent(); });
        ɵngcc0.ɵɵtemplate(8, DwMdSectionComponentConfigComponent_option_8_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DwMdSectionComponentConfigComponent_div_9_Template, 6, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, DwMdSectionComponentConfigComponent_p_tabPanel_10_Template, 3, 5, "p-tabPanel", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.componentName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.componentList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.configComponent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.currentComponent == null ? null : ctx.currentComponent.componentType) != ctx.pageComponentType);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDynamicLoaderComponent, DwMdSectionStandardConfigComponent]; }, styles: [""] });

class DwDynamicSectionSetupService {
    constructor(dwExpressionStateService, dwExpressionService) {
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwExpressionService = dwExpressionService;
    }
    initSectionExpressionSet(sectionConfig, formGroup, context) {
        const expressionSet = {
            defaultResult: false,
            delayMs: 100,
            isArray: false,
            expressions: {}
        };
        let expressionCount = 0;
        // Handle visibility
        if (!this.dwExpressionService.isEmptyExpressionGroupItem(sectionConfig.visibleExpression)) {
            expressionCount++;
            expressionSet.expressions[DwDynamicSectionExpressionType.visible] = sectionConfig.visibleExpression;
        }
        // Handle read-only
        if (!this.dwExpressionService.isEmptyExpressionGroupItem(sectionConfig.readOnlyContainerExpression)) {
            expressionCount++;
            expressionSet.expressions[DwDynamicSectionExpressionType.readonly] = sectionConfig.readOnlyContainerExpression;
        }
        // Handle default container collapsed state
        if (sectionConfig.useContainerStyling && sectionConfig.containerAllowCollapse) {
            if (!this.dwExpressionService.isEmptyExpressionGroupItem(sectionConfig.containerCollapseDefaultExpression)) {
                expressionCount++;
                expressionSet.expressions[DwDynamicSectionExpressionType.collapsed] = sectionConfig.containerCollapseDefaultExpression;
            }
        }
        const titleExpressionSetResult = this.setupTitleTemplates(sectionConfig, formGroup, context);
        // if nothing to evaluate, then just return null
        if (!titleExpressionSetResult && expressionCount == 0) {
            return null;
        }
        const mainExpressionSetResult = this.dwExpressionStateService.initExpressionSet(expressionSet, formGroup, context);
        const formContext = context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;
        const finalResults = {
            initialResults: this.convertExpressionResults(mainExpressionSetResult.initialResults, titleExpressionSetResult === null || titleExpressionSetResult === void 0 ? void 0 : titleExpressionSetResult.initialResults, context),
            observable: null
        };
        const templateObservable = (titleExpressionSetResult === null || titleExpressionSetResult === void 0 ? void 0 : titleExpressionSetResult.observable) || of(null);
        finalResults.observable = combineLatest([mainExpressionSetResult.observable, templateObservable])
            .pipe(map(([mainResults, templateResult]) => {
            const updatedResult = this.convertExpressionResults(mainResults, templateResult, context);
            return updatedResult;
        }));
        return finalResults;
    }
    convertExpressionResults(mainExpressionResults, titleExpressionResults, context) {
        const formContext = context[DwMdFormContextInfo.FORM_CONTEXT_NAME].value;
        const result = {
            dataLoadComplete: (formContext === null || formContext === void 0 ? void 0 : formContext.loadDataComplete) || false,
            visibleResult: this.getExpressionResult(mainExpressionResults, DwDynamicSectionExpressionType.visible),
            readOnlyResult: this.getExpressionResult(mainExpressionResults, DwDynamicSectionExpressionType.readonly),
            collapsedDefaultResult: this.getExpressionResult(mainExpressionResults, DwDynamicSectionExpressionType.collapsed),
        };
        if (titleExpressionResults && titleExpressionResults.length > 0) {
            result.templateTitleResult = { result: titleExpressionResults[0] };
        }
        return result;
    }
    getExpressionResult(mainExpressionResults, expressionType) {
        const expressResult = mainExpressionResults[expressionType];
        if (expressResult) {
            return { result: expressResult.result };
        }
    }
    setupTitleTemplates(sectionConfig, formGroup, context) {
        var _a, _b;
        if (!sectionConfig.useTitleTemplates || !sectionConfig.showTitle || !sectionConfig.titleTemplatePreferences) {
            return;
        }
        const templates = ((_a = sectionConfig.titleTemplatePreferences) === null || _a === void 0 ? void 0 : _a.titleTemplates) || [];
        if (templates.length == 0) {
            return;
        }
        const titleExpressionSetResult = this.dwExpressionStateService.initExpressionSetArray(((_b = sectionConfig.titleTemplatePreferences) === null || _b === void 0 ? void 0 : _b.titleTemplates) || [], t => t.expression, formGroup, context, true, 100);
        return titleExpressionSetResult;
    }
}
DwDynamicSectionSetupService.ɵfac = function DwDynamicSectionSetupService_Factory(t) { return new (t || DwDynamicSectionSetupService)(ɵngcc0.ɵɵinject(DwExpressionStateService), ɵngcc0.ɵɵinject(DwExpressionService)); };
DwDynamicSectionSetupService.ɵprov = ɵɵdefineInjectable({ factory: function DwDynamicSectionSetupService_Factory() { return new DwDynamicSectionSetupService(ɵɵinject(DwExpressionStateService), ɵɵinject(DwExpressionService)); }, token: DwDynamicSectionSetupService, providedIn: "root" });
DwDynamicSectionSetupService.ctorParameters = () => [
    { type: DwExpressionStateService },
    { type: DwExpressionService }
];
var DwDynamicSectionExpressionType;
(function (DwDynamicSectionExpressionType) {
    DwDynamicSectionExpressionType["visible"] = "visible";
    DwDynamicSectionExpressionType["readonly"] = "readonly";
    DwDynamicSectionExpressionType["collapsed"] = "collapsed";
})(DwDynamicSectionExpressionType || (DwDynamicSectionExpressionType = {}));

var __decorate$O = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$A = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwDynamicSectionComponent = class DwDynamicSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(resolver, dwConfigService, uiMetaDataConfig, dwExpressionService, dwUiConfigRegistryService, dwMetaDataService, dwExpressionStateService, dwMdFormUtilService, dwDynamicSectionSetupSerivce, dwMetaDataFormSectionStateService, dwFormStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.resolver = resolver;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwMdFormUtilService = dwMdFormUtilService;
        this.dwDynamicSectionSetupSerivce = dwDynamicSectionSetupSerivce;
        this.dwMetaDataFormSectionStateService = dwMetaDataFormSectionStateService;
        this.excludeStyling = false;
        this.reloadComponentOnChange = false;
        this.parentIsVisible = true;
        this.isComponentMissing = false;
        this.invalidConfiguration = false;
        this.classes = {};
        this.sectionDefinitions = [];
        this.useTitleTemplate = false;
        this.sectionDefinitions = dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
    }
    // Pass input changes up the chain
    sectionConfigChanged() {
        // //console.log("DwDynamicSectionComponent - sectionConfigChanged");
        if (this.componentInstance) {
            this.componentInstance.sectionConfig = this.sectionConfig;
        }
    }
    formConfigChanged() {
        ////console.log("DwDynamicSectionComponent - formConfigChanged");
        if (this.componentInstance) {
            this.componentInstance.formConfig = this.formConfig;
        }
    }
    fromGroupChanged() {
        if (this.componentInstance) {
            this.componentInstance.formGroup = this.formGroup;
        }
    }
    submittedChanged() {
        if (this.componentInstance) {
            this.componentInstance.submitted = this.submitted;
        }
    }
    contextChanged() {
        if (this.componentInstance) {
            this.componentInstance.context = this.context;
        }
    }
    sectionReadOnlyChanged(readOnly) {
    }
    setupVisibleChecks() {
        // override this so it doesn't get ran more than once
    }
    ngOnInit() {
        ////console.log("dw-dynamic-section - ngOnInit", this.sectionConfig);
        super.ngOnInit();
    }
    ngAfterContentInit() {
        this.loadComponent();
    }
    ngOnChanges(changes) {
        if (changes.sectionConfig && changes.sectionConfig.currentValue && !changes.sectionConfig.firstChange) {
            this.loadComponent();
        }
        if (changes.parentIsVisible && this.componentInstance) {
            this.componentInstance.parentIsVisible = this.parentIsVisible;
            this.componentInstance.visible = this.containerVisible && this.parentIsVisible;
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.cleanupSubscriptions();
    }
    loadComponent() {
        var _a;
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        if (!this.sectionConfig)
            return;
        this.sectionKey = this.dwMdFormUtilService.getSectionConfigUniqueId(this.sectionConfig, this.formConfig.section);
        // section styling
        // if (!this.excludeStyling) {
        //     this.setupStyling(this.sectionConfig);
        // }
        if (!this.excludeStyling) {
            this.containerOptions = this.dwMdFormUtilService.setupContainerOptions(this.sectionConfig, (_a = this.containerOptions) === null || _a === void 0 ? void 0 : _a.containerCollapseDefault, this.titleTemplateResult);
        }
        else {
            this.containerOptions = {
                useContainerStyling: false,
            };
        }
        this.showDebug = DwFormDebugService.showAllMessages || DwFormDebugService.isComponentNameMatch(this.componentName);
        //if (this.dwFormDebugService.isComponentNameMatch) {
        this.setupSectionExpressions();
        let component = this.determineComponent(this.sectionConfig);
        if (!component)
            return;
        // Only reload the component if it changes
        if (this.loadedComponent == component && !this.reloadComponentOnChange)
            return;
        // If we already have a component instance, let clean this up here
        if (this.componentInstance && this.componentInstance.ngOnDestroy) {
            this.componentInstance.ngOnDestroy();
        }
        this.loadedComponent = component;
        const componentFactory = this.resolver.resolveComponentFactory(component);
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(componentFactory);
        this.componentInstance = this.componentRef.instance;
        this.configureComponent();
    }
    configureComponent() {
        if (!this.componentInstance)
            return;
        if (this.componentDefinitionRef && this.componentDefinitionRef.componentType == DwComponentType.pageComponent) {
            // Since we know this is a page component, cast types appropriately, then set the config
            const pageComponentInstance = this.componentInstance;
            const componentSectionConfig = this.sectionConfig;
            pageComponentInstance.pageConfig = componentSectionConfig.config;
            this.containerVisible = true;
            return;
        }
        this.componentInstance.sectionKey = this.sectionKey;
        this.componentInstance.formGroup = this.formGroup;
        this.componentInstance.context = this.context;
        this.componentInstance.sectionConfig = this.sectionConfig;
        this.componentInstance.formConfig = this.formConfig;
        this.componentInstance.submitted = this.submitted;
        this.componentInstance.parentIsVisible = this.parentIsVisible;
        if (this.componentInstance.setupComponentComplete) {
            this.componentInstance.setupComponentComplete();
        }
        this.componentRef.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.componentInstance.visible = this.containerVisible && this.parentIsVisible;
            //  this.componentInstance.sectionVisible = this.containerVisible;
        });
    }
    setupSectionExpressions() {
        const expressionResults = this.dwDynamicSectionSetupSerivce.initSectionExpressionSet(this.sectionConfig, this.formGroup, this.context);
        // Exit if not results (this means there were no expressions to evaluate)
        if (!expressionResults) {
            setTimeout(() => {
                // Set to visible by default
                this.containerVisible = true;
                if (this.componentInstance) {
                    this.componentInstance.visible = this.containerVisible && this.parentIsVisible;
                }
            });
            // Add so the read only logic would be evaluated
            this.handleExpressionResults(null);
            return;
        }
        setTimeout(() => {
            this.handleExpressionResults(expressionResults.initialResults);
        });
        this.cleanupSubscriptions();
        this.expressionSetSubscription = expressionResults.observable.subscribe(expressionResults => {
            setTimeout(() => {
                this.handleExpressionResults(expressionResults);
            }, 20);
        });
    }
    handleExpressionResults(initialResults) {
        var _a;
        // Setup Visibliity
        if (initialResults === null || initialResults === void 0 ? void 0 : initialResults.visibleResult) {
            this.containerVisible = initialResults.visibleResult.result;
        }
        else {
            this.containerVisible = true;
        }
        // Setup Read-only - added 8-15-2023
        let containerReadOnly = this.sectionConfig.isReadOnlyContainer;
        if (initialResults === null || initialResults === void 0 ? void 0 : initialResults.readOnlyResult) {
            containerReadOnly = initialResults.readOnlyResult.result;
        }
        // Only set on children if it has a true/false - nulls should be ignored
        if (containerReadOnly == true || containerReadOnly == false) {
            const sectionConfig = deepCopy(this.sectionConfig);
            this.dwMdFormUtilService.setSectionReadOnly(sectionConfig, containerReadOnly);
            DwFormDebugService.debugMessage(null, this.componentName, `Setting section read-only to ${containerReadOnly}`, sectionConfig);
            this.sectionConfig = sectionConfig;
            setTimeout(() => {
                this.dwMetaDataFormSectionStateService.updateReadOnlyChanged(this.sectionKey);
            });
        }
        // Update current components visibility
        if (this.componentInstance) {
            this.componentInstance.visible = this.containerVisible;
        }
        // Setup collapsed default
        if (initialResults === null || initialResults === void 0 ? void 0 : initialResults.collapsedDefaultResult) {
            if (initialResults.dataLoadComplete && !this.containerCollapsedDefaultSet) {
                this.containerCollapsedDefaultSet = true;
                this.containerOptions.containerCollapseDefault = initialResults.collapsedDefaultResult.result;
                // reset object so change detection picks up and updates dw-container
                this.containerOptions = Object.assign({}, this.containerOptions);
            }
        }
        // Handle conditional container options - title/style/icon
        this.currentTitleTemplate = this.sectionConfig.title;
        if (initialResults === null || initialResults === void 0 ? void 0 : initialResults.templateTitleResult) {
            //this.dataSubjectResult = this.dwMdFormUtilService.getDataSubject(this.sectionConfig, this.context, this.formGroup, this.formConfig.section);
            this.titleTemplateResult = initialResults.templateTitleResult.result;
            if (this.titleTemplateResult.template) {
                this.useTitleTemplate = true;
                this.currentTitleTemplate = this.titleTemplateResult.template;
                this.setupTitleTemplateDataElements();
            }
            else {
                this.useTitleTemplate = false;
            }
            if (this.sectionConfig.useContainerStyling && this.sectionConfig.titleTemplatePreferences.showContainerOptions) {
                this.containerOptions = this.dwMdFormUtilService.setupContainerOptions(this.sectionConfig, (_a = this.containerOptions) === null || _a === void 0 ? void 0 : _a.containerCollapseDefault, this.titleTemplateResult);
            }
        }
    }
    setupTitleTemplateDataElements() {
        if (this.titleTemplateDataSetupComplete) {
            return;
        }
        this.titleTemplateDataSetupComplete = true;
        // setup reference data for templates (Yes, this is the simple version)
        this.itemName = this.dwMdFormUtilService.getParentItemName(this.formConfig.section, this.sectionConfig, this.formConfig.rootItemName);
        this.queryMetaData = this.formConfig.queryMetaDataList[this.itemName];
        this.dataSubjectResult = this.dwMdFormUtilService.getDataSubject(this.sectionConfig, this.context, this.formGroup, this.formConfig.section, this.formConfig.queryMetaDataList);
    }
    cleanupSubscriptions() {
        var _a;
        if ((_a = this.dataSubjectResult) === null || _a === void 0 ? void 0 : _a.subscription) {
            this.dataSubjectResult.subscription.unsubscribe();
            this.dataSubjectResult = null;
        }
        if (this.expressionSetSubscription) {
            this.expressionSetSubscription.unsubscribe();
            this.expressionSetSubscription = null;
        }
    }
    determineComponent(sectionConfig) {
        switch (sectionConfig.sectionType) {
            case DwSectionType.component:
                // Allows using any type of component as a section (recommend it inherits from DwComponentSectionBase)
                const componentSectionPref = sectionConfig;
                this.componentDefinitionRef = this.dwUiConfigRegistryService.getRegisteredComponent(componentSectionPref.componentName, [DwComponentType.formSection, DwComponentType.pageComponent]);
                if (this.componentDefinitionRef) {
                    return this.componentDefinitionRef.component;
                }
                this.invalidConfiguration = true;
                this.invalidConfigurationMessage = `Component '${componentSectionPref.componentName}' is not found`;
                if (!componentSectionPref.componentName) {
                    this.invalidConfigurationMessage = `Component is not set`;
                }
                else {
                    this.isComponentMissing = true;
                    this.missingComponentName = componentSectionPref.componentName;
                }
                return null;
            default:
        }
        // Determine the component which is set in the section Definition (Registered with the @DwSectionComponent decorator)
        const sectionDef = this.sectionDefinitions.find(sd => sd.keyName == sectionConfig.sectionType);
        if (!sectionDef) {
            console.warn(`Section Definition not found for section type ${sectionConfig.sectionType}`);
            return null;
        }
        return sectionDef.component;
    }
};
DwDynamicSectionComponent.ɵfac = function DwDynamicSectionComponent_Factory(t) { return new (t || DwDynamicSectionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwDynamicSectionSetupService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwDynamicSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDynamicSectionComponent, selectors: [["dw-dynamic-section"]], viewQuery: function DwDynamicSectionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, inputs: { excludeStyling: "excludeStyling", reloadComponentOnChange: "reloadComponentOnChange", parentIsVisible: "parentIsVisible" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 10, vars: 10, consts: [["dwPageDesignerSelector", "", 3, "hidden", "configKey", "sectionKey", "additionalInfo"], [3, "options"], ["header", ""], [4, "ngIf"], ["body", ""], ["dw-component-host", ""], ["class", "hide-print dw-invalid-section", 4, "ngIf"], ["isHtml", "false", 3, "item", "queryMetaData", "templateText", "dataSubject", "context", "showLookupDisplays", "blankPlaceholder"], [1, "hide-print", "dw-invalid-section"], ["id", "icon", 1, "fas", "fa-cog"], ["id", "message"], ["id", "icon", 1, "fas", "fa-exclamation-triangle"], [1, "fa", "fa-eye", 3, "hidden", "title"]], template: function DwDynamicSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dw-container", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵtemplate(3, DwDynamicSectionComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, DwDynamicSectionComponent_ng_container_4_Template, 2, 7, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtemplate(6, DwDynamicSectionComponent_ng_template_6_Template, 0, 0, "ng-template", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DwDynamicSectionComponent_div_7_Template, 4, 1, "div", 6);
        ɵngcc0.ɵɵtemplate(8, DwDynamicSectionComponent_div_8_Template, 4, 1, "div", 6);
        ɵngcc0.ɵɵtemplate(9, DwDynamicSectionComponent_div_9_Template, 4, 7, "div", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.containerVisible)("configKey", ctx.formConfig == null ? null : ctx.formConfig.configKey)("sectionKey", ctx.sectionKey)("additionalInfo", ctx.sectionConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("options", ctx.containerOptions);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.useTitleTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useTitleTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidConfiguration && !ctx.isComponentMissing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isComponentMissing);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: function () { return [DwDesignerSelector, DwContainerComponent, ɵngcc4.NgIf, DwComponentHost, DwTemplateViewControlComponent]; }, encapsulation: 2 });
DwDynamicSectionComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionStateService },
    { type: DwMetadataFormUtilService },
    { type: DwDynamicSectionSetupService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService }
];
DwDynamicSectionComponent.propDecorators = {
    excludeStyling: [{ type: Input }],
    reloadComponentOnChange: [{ type: Input }],
    parentIsVisible: [{ type: Input }],
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }]
};
__decorate$O([
    DwInputConverter(booleanConverter),
    __metadata$A("design:type", Boolean)
], DwDynamicSectionComponent.prototype, "excludeStyling", void 0);
__decorate$O([
    DwInputConverter(booleanConverter),
    __metadata$A("design:type", Boolean)
], DwDynamicSectionComponent.prototype, "reloadComponentOnChange", void 0);
__decorate$O([
    DwInputConverter(booleanConverter),
    __metadata$A("design:type", Boolean)
], DwDynamicSectionComponent.prototype, "parentIsVisible", void 0);
DwDynamicSectionComponent = __decorate$O([
    DwSectionComponent({
        keyName: DwSectionType.component,
        display: 'Component',
        sectionIcon: 'fa fa-computer-speaker',
        configComponent: DwMdSectionComponentConfigComponent,
        hasChildren: false,
    }),
    __metadata$A("design:paramtypes", [ComponentFactoryResolver,
        DwConfigService, Object, DwExpressionService,
        DwUiConfigRegistryService,
        DwMetaDataService,
        DwExpressionStateService,
        DwMetadataFormUtilService,
        DwDynamicSectionSetupService,
        DwMetaDataFormSectionStateService,
        DwMetaDataFormStateService])
], DwDynamicSectionComponent);

class DwMetadataFormConfigFieldsComponent {
    constructor(dwMetaDataService, metaDataFormService) {
        this.dwMetaDataService = dwMetaDataService;
        this.metaDataFormService = metaDataFormService;
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
        this.preferences = this.modalConfig.data.preferences;
        this.formSection = this.modalConfig.data.section;
        this.itemName = this.modalConfig.data.itemName;
        this.dwMetaDataService.getMetaData(this.itemName)
            .subscribe(md => {
            this.itemMetaData = md;
            if (!this.formSection) {
                this.formSection = this.metaDataFormService.buildDefaultFormSection(this.itemMetaData, this.preferences);
            }
        });
    }
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        result.closeModal = true;
        result.cancelled = false;
        this.preferences.section = this.formSection;
        result.data = {
            preferences: this.preferences,
            section: this.formSection
        };
        switch (buttonConfig.command) {
            case DwButtonCommand.cancel:
                result.cancelled = true;
        }
        return of(result);
    }
    addItem() {
        let field = new DwFormFieldPreference();
        field.columnItemPreferences = new DwFormColumnItemPreference();
        this.formSection.fields.push(field);
    }
    removeItem(item) {
        var index = this.formSection.fields.indexOf(item);
        if (index >= 0)
            this.formSection.fields.splice(index, 1);
    }
    moveUp(item) {
        var index = this.formSection.fields.indexOf(item);
        if (index == 0)
            return;
        let newIndex = index--;
        this.formSection.fields.splice(newIndex, 0, this.formSection.fields.splice(index, 1)[0]);
    }
    moveDown(item) {
        var index = this.formSection.fields.indexOf(item);
        if (index == this.formSection.fields.length - 1)
            return;
        let newIndex = index++;
        this.formSection.fields.splice(newIndex, 0, this.formSection.fields.splice(index, 1)[0]);
    }
}
DwMetadataFormConfigFieldsComponent.ɵfac = function DwMetadataFormConfigFieldsComponent_Factory(t) { return new (t || DwMetadataFormConfigFieldsComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService)); };
DwMetadataFormConfigFieldsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFormConfigFieldsComponent, selectors: [["app-dw-metadata-form-config-fields"]], decls: 19, vars: 1, consts: [[1, "table", "table-striped"], [4, "ngFor", "ngForOf"], [3, "click"], [1, "fa", "fa-plus", "hand"], ["title", "Remove Field", 1, "fa", "fa-times", "hand", 3, "click"], [3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "fa", "fa-sort-up", "hand", "pull-left", "clear-left", 3, "click"], [1, "fa", "fa-sort-down", "hand", "pull-left", "clear-left", 3, "click"], [3, "ngValue"]], template: function DwMetadataFormConfigFieldsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "table", 0);
        ɵngcc0.ɵɵelementStart(2, "thead");
        ɵngcc0.ɵɵelementStart(3, "tr");
        ɵngcc0.ɵɵelement(4, "td");
        ɵngcc0.ɵɵelementStart(5, "td");
        ɵngcc0.ɵɵtext(6, "Field");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "td");
        ɵngcc0.ɵɵtext(8, "New Row");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "td");
        ɵngcc0.ɵɵtext(10, "Span Columns");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "td");
        ɵngcc0.ɵɵtext(12, "Read Only");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(13, "td");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "tbody");
        ɵngcc0.ɵɵtemplate(15, DwMetadataFormConfigFieldsComponent_tr_15_Template, 15, 5, "tr", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "button", 2);
        ɵngcc0.ɵɵlistener("click", function DwMetadataFormConfigFieldsComponent_Template_button_click_16_listener() { return ctx.addItem(); });
        ɵngcc0.ɵɵelement(17, "i", 3);
        ɵngcc0.ɵɵtext(18, " Add Field ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(15);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.formSection == null ? null : ctx.formSection.fields);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwMetadataFormConfigFieldsComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormService }
];

class DwTabStripSectionPreference extends DwContainerSectionPreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.tabStrip;
    }
}
var DwTabStripStyle;
(function (DwTabStripStyle) {
    DwTabStripStyle["tabs"] = "tabs";
    DwTabStripStyle["pills"] = "pills";
})(DwTabStripStyle || (DwTabStripStyle = {}));
class DwTabStripStyleList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwTabStripStyle[propertyName];
    }
    getKeys() {
        return Object.keys(DwTabStripStyle);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwTabStripStyle.tabs:
                return 'Tabs';
            case DwTabStripStyle.pills:
                return 'Pills';
            default:
                return item;
        }
    }
}
var DwTabSharedContainerPosition;
(function (DwTabSharedContainerPosition) {
    DwTabSharedContainerPosition["top"] = "top";
    DwTabSharedContainerPosition["bottom"] = "bottom";
})(DwTabSharedContainerPosition || (DwTabSharedContainerPosition = {}));
class DwTabSharedContainerPositionList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwTabSharedContainerPosition[propertyName];
    }
    getKeys() {
        return Object.keys(DwTabSharedContainerPosition);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwTabSharedContainerPosition.top:
                return 'Top';
            case DwTabSharedContainerPosition.bottom:
                return 'Bottom';
            default:
                return item;
        }
    }
}

class DwTabSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.tab;
    }
}

class DwMdSectionTabStripConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.containerSectionType = DwSectionType.container;
        this.orderableSections = [];
        // moveUp(item) {
        //     var index = this.section.sections.indexOf(item);
        //     if (index==0)
        //         return;
        //     let newIndex = index--;
        //     this.section.sections.splice(newIndex, 0, this.section.sections.splice(index,1)[0]);
        //     this.onSectionChange();
        // }
        // moveDown(item) {
        //     var index = this.section.sections.indexOf(item);
        //     if (index==this.section.sections.length-1)
        //         return;
        //     let newIndex = index++;
        //     this.section.sections.splice(newIndex, 0, this.section.sections.splice(index,1)[0]);
        //     this.onSectionChange();
        // }
    }
    ngOnInit() {
        this.tabStripStyleList = new DwTabStripStyleList().getEnumList();
        this.tabSharedContainerPositionList = new DwTabSharedContainerPositionList().getEnumList();
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        if (!this.section.sections) {
            this.section.sections = [];
        }
        if (!this.section.useSharedContainer) {
            this.section.useSharedContainer = false;
        }
        if (!this.section.tabStripStyle) {
            this.section.tabStripStyle = DwTabStripStyle.tabs;
        }
        this.orderableSections = this.section.sections.filter(s => s.sectionType == DwSectionType.tab);
        this.sharedTabSection = this.section.sections.find(s => (s.sectionType == DwSectionType.container));
    }
    onSharedContainerChange() {
        // Check if shared Tab section exists
        // if (this.section.useSharedContainer) {
        //     if (!this.sharedTabSection) {
        //         this.sharedTabSection = new DwContainerSectionPreference();
        //         this.sharedTabSection.title = "Shared Container";
        //         this.sharedTabSection.sections = [];
        //     }
        // }
        this.onSectionTabChange();
        //     this.section.sections = [sharedTabSection,...this.section.sections];
        // } else {
        //     if (!sharedTabSection) return; // Shared section does not exist
        //     const index = this.section.sections.indexOf(sharedTabSection);
        //     // remove section
        //     this.section.sections.splice(index, 1);
        //     this.sharedTabSection = sharedTabSection;
        // }
    }
    onSectionTabChange() {
        let allSections = this.orderableSections;
        if (this.section.useSharedContainer) {
            if (!this.sharedTabSection) {
                this.sharedTabSection = new DwContainerSectionPreference();
                this.sharedTabSection.title = "Shared Container";
                this.sharedTabSection.sections = [];
            }
            allSections = [this.sharedTabSection, ...allSections];
        }
        this.section.sections = allSections;
        this.onSectionChange();
    }
    addItem() {
        let tabSection = new DwTabSectionPreference();
        tabSection.tabHeading = "New Tab";
        tabSection.section = new DwContainerSectionPreference();
        this.orderableSections.push(tabSection);
        this.onSectionTabChange();
    }
    removeItem(item) {
        var index = this.orderableSections.indexOf(item);
        if (index >= 0)
            this.orderableSections.splice(index, 1);
        this.onSectionTabChange();
    }
}
DwMdSectionTabStripConfigComponent.ɵfac = function DwMdSectionTabStripConfigComponent_Factory(t) { return ɵDwMdSectionTabStripConfigComponent_BaseFactory(t || DwMdSectionTabStripConfigComponent); };
DwMdSectionTabStripConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionTabStripConfigComponent, selectors: [["app-dw-md-section-tab-strip-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 34, vars: 14, consts: [["header", "Tab Strip Configuration"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["title", "Assigns the current tab index to this variable so it can be used in expressions", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "6", 4, "ngIf"], ["title", "Creates a shared container that is displayed for every tab", 1, "fa", "fa-info-circle"], ["dwCol", "6", 3, "hidden"], [3, "items", "itemsChange", 4, "ngIf"], [3, "click"], [1, "fa", "fa-plus", "hand"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"], [3, "ngValue"], ["title", "Sets the tab when the variable is updated", 1, "fa", "fa-info-circle"], [3, "items", "itemsChange"], [4, "dwListItem"]], template: function DwMdSectionTabStripConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Tab Strip Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.section.tabStripStyle = $event; })("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_select_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(8, DwMdSectionTabStripConfigComponent_option_8_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 2);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Tab Index Variable ");
        ɵngcc0.ɵɵelement(12, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_input_ngModelChange_13_listener($event) { return ctx.section.tabIndexVariableName = $event; })("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_input_ngModelChange_13_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DwMdSectionTabStripConfigComponent_div_14_Template, 5, 1, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 1);
        ɵngcc0.ɵɵelementStart(16, "div", 2);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Use Shared Container ");
        ɵngcc0.ɵɵelement(19, "i", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_dw_yesno_ngModelChange_20_listener($event) { return ctx.section.useSharedContainer = $event; })("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_dw_yesno_ngModelChange_20_listener() { return ctx.onSharedContainerChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 9);
        ɵngcc0.ɵɵelementStart(22, "label");
        ɵngcc0.ɵɵtext(23, "Shared Container Position");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_select_ngModelChange_24_listener($event) { return ctx.section.sharedContainerPosition = $event; })("ngModelChange", function DwMdSectionTabStripConfigComponent_Template_select_ngModelChange_24_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(25, DwMdSectionTabStripConfigComponent_option_25_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(26, DwMdSectionTabStripConfigComponent_dw_ordered_list_26_Template, 2, 1, "dw-ordered-list", 10);
        ɵngcc0.ɵɵelement(27, "br");
        ɵngcc0.ɵɵelementStart(28, "button", 11);
        ɵngcc0.ɵɵlistener("click", function DwMdSectionTabStripConfigComponent_Template_button_click_28_listener() { return ctx.addItem(); });
        ɵngcc0.ɵɵelement(29, "i", 12);
        ɵngcc0.ɵɵtext(30, " Add Tab ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "p-tabPanel", 13);
        ɵngcc0.ɵɵelementStart(32, "div");
        ɵngcc0.ɵɵelementStart(33, "dw-md-section-standard-config", 14);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdSectionTabStripConfigComponent_Template_dw_md_section_standard_config_sectionChange_33_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdSectionTabStripConfigComponent_Template_dw_md_section_standard_config_sectionChange_33_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.tabStripStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabStripStyleList);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.tabIndexVariableName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.tabIndexVariableName);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useSharedContainer);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.section.useSharedContainer);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.sharedContainerPosition);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabSharedContainerPositionList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ɵngcc4.NgIf, DwYesNoComponent, DwMdSectionStandardConfigComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwOrderedListComponent, DwListItemDirective]; }, styles: [""] });

var __decorate$P = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$B = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwTabStripSectionComponent = class DwTabStripSectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwExpressionStateService, dwMetaDataFormStateService, dwMetadataFormUtilService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.visibleTabs = [];
        this.visibleTabKeys = [];
        this.tabsLoaded = {};
        this.activeTabIndex = 0;
        this.currentDisplayIndex = 0;
        this.showPills = false;
        this.showSharedContainerAtTop = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupSections();
        if (this.dwMetaDataFormStateService.state.formConfig.formMode == DwFormContextMode.print) {
            this.inPrintMode = true;
        }
    }
    sectionConfigChanged() {
        //this.setupSections();
    }
    contextChanged() {
    }
    setupComponentComplete() {
        this.setupSections();
    }
    setupSections() {
        this.showPills = this.sectionConfig.tabStripStyle == DwTabStripStyle.pills;
        this.showSharedContainerAtTop = this.sectionConfig.sharedContainerPosition == DwTabSharedContainerPosition.top;
        this.setTabIndexVariable();
        this.setupTabIndexVariableEvent();
        this.setupTabVisibleExpressions();
    }
    handleTabChange() {
        // Set variable
        this.currentDisplayIndex = this.activeTabIndex;
        this.setTabIndexVariable();
    }
    setPillsTab(sectionKey) {
        const tab = this.visibleTabs.find(t => t.sectionKey == sectionKey);
        this.currentDisplayIndex = this.visibleTabs.indexOf(tab);
        this.setTabIndexVariable();
    }
    setTabIndexVariable() {
        this.tabsLoaded[this.currentDisplayIndex] = true;
        if (!this.sectionConfig.tabIndexVariableName) {
            return;
        }
        this.dwMetaDataFormStateService.state.formApi.setVariableValue(this.sectionConfig.tabIndexVariableName, this.currentDisplayIndex + 1);
    }
    setupTabIndexVariableEvent() {
        var _a, _b;
        if (!((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.tabIndexVariableName) || !((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.tabIndexVariableSetOnChange)) {
            return;
        }
        const variableContext = this.dwMetaDataFormStateService.state.formApi.getVariableContext();
        if (!variableContext && !this.dwMetaDataFormStateService.state.formApi.isDataLoadComplete) {
            this.runAfterFormDataLoaded(() => {
                this.setupTabIndexVariableEvent();
            });
            return;
        }
        this.subscriptions.push(variableContext.subscribe(variableContext => {
            const newTabIndex = variableContext[this.sectionConfig.tabIndexVariableName];
            if (newTabIndex && this.currentDisplayIndex != newTabIndex - 1) {
                this.currentDisplayIndex = newTabIndex - 1;
                this.activeTabIndex = this.currentDisplayIndex;
                this.setTabIndexVariable();
            }
        }));
        if (!this.sectionConfig.tabIndexVariableName) {
            return;
        }
        this.dwMetaDataFormStateService.state.formApi.setVariableValue(this.sectionConfig.tabIndexVariableName, this.currentDisplayIndex + 1);
        DwTabStripSectionPreference;
    }
    setupTabVisibleExpressions() {
        var _a;
        if (!((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.sections)) {
            return;
        }
        if (this.sectionConfig.useSharedContainer) {
            this.containerSection = this.sectionConfig.sections.find(s => s.sectionType == DwSectionType.container);
        }
        this.sectionConfig.tabStripStyle;
        const tabSections = this.sectionConfig.sections.filter(s => s.sectionType == DwSectionType.tab);
        // Get a result that returns which items are visible
        const result = this.dwExpressionStateService.initExpressionSetArray(tabSections, (tab) => tab.visibleExpression, this.formGroup, this.context, true);
        this.visibleTabs = result.initialResults;
        this.setVisibleTabKeys();
        this.subscriptions.push(result.observable.subscribe(visibleTabs => {
            this.visibleTabs = visibleTabs;
            this.setVisibleTabKeys();
        }));
    }
    setVisibleTabKeys() {
        var _a;
        const keys = [];
        for (let visibleTab of this.visibleTabs) {
            const key = this.dwMetadataFormUtilService.getSectionConfigUniqueId(visibleTab, (_a = this.formConfig) === null || _a === void 0 ? void 0 : _a.section);
            keys.push(key);
        }
        this.visibleTabKeys = keys;
        if (!this.currentPillsTab) {
            this.currentPillsTab = this.visibleTabKeys[0];
        }
        if (this.visibleTabKeys.indexOf(this.currentPillsTab) == -1) {
            this.currentPillsTab = this.visibleTabKeys[0];
        }
        this.currentDisplayIndex = 0;
        this.setTabIndexVariable();
    }
};
DwTabStripSectionComponent.ɵfac = function DwTabStripSectionComponent_Factory(t) { return new (t || DwTabStripSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService)); };
DwTabStripSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTabStripSectionComponent, selectors: [["dw-tab-strip-section"]], viewQuery: function DwTabStripSectionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(TabView, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabView = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[3, "hidden", 4, "ngIf"], ["tabContent", ""], [3, "hidden"], [4, "ngIf"], ["class", "p-tabview-panels-hidden", 3, "activeIndex", "activeIndexChange", "onChange", 4, "ngIf"], [1, "p-tabview"], [1, "p-tabview-panels"], [4, "ngTemplateOutlet"], [1, "p-tabview-panels-hidden", 3, "activeIndex", "activeIndexChange", "onChange"], [4, "ngFor", "ngForOf"], [3, "header", "selected"], ["tabPanel2", ""], ["pTemplate", "header"], ["dwPageDesignerSelector", "", "highlight", "false", "stopPropagation", "false", 3, "configKey", "sectionKey", "detailKey", "additionalInfo"], [2, "overflow", "auto"], ["valueField", "sectionKey", "displayField", "tabHeading", 3, "items", "ngModel", "ngModelChange", 4, "ngIf"], ["valueField", "sectionKey", "displayField", "tabHeading", 3, "items", "ngModel", "ngModelChange"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible", 4, "ngIf"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"], ["class", "dw-tab-print-container", 4, "ngFor", "ngForOf"], [1, "dw-tab-print-container"], ["header", ""], ["body", ""]], template: function DwTabStripSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwTabStripSectionComponent_div_0_Template, 3, 3, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwTabStripSectionComponent_ng_template_1_Template, 3, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, DwTabStripSectionComponent_div_3_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.inPrintMode);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.inPrintMode);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgTemplateOutlet, ɵngcc9.TabView, ɵngcc4.NgForOf, ɵngcc9.TabPanel, ɵngcc6.PrimeTemplate, DwDesignerSelector, DwPillsComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwContainerComponent]; }, encapsulation: 2 });
DwTabStripSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionStateService },
    { type: DwMetaDataFormStateService },
    { type: DwMetadataFormUtilService }
];
DwTabStripSectionComponent.propDecorators = {
    tabView: [{ type: ViewChild, args: [TabView, { static: true },] }]
};
DwTabStripSectionComponent = __decorate$P([
    DwSectionComponent({
        keyName: DwSectionType.tabStrip,
        display: 'Tab Strip',
        sectionIcon: 'fa fa-film-alt',
        childrenPropertyName: 'sections',
        configComponent: DwMdSectionTabStripConfigComponent,
        hasChildren: true,
        dragDropConfig: {
            allowChildDrop: true,
            dropChildSectionType: DwSectionType.tab
        },
        wrapOptions: {
            allowWrap: true,
            createWrapSection: wrapTabstrip
        }
    }),
    __metadata$B("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwExpressionStateService,
        DwMetaDataFormStateService,
        DwMetadataFormUtilService])
], DwTabStripSectionComponent);
function wrapTabstrip(section) {
    var tabStripSection = new DwTabStripSectionPreference();
    var firstTab = new DwTabSectionPreference();
    firstTab.tabHeading = "Tab 1";
    firstTab.section = section;
    // Change these so it's styled correctly
    firstTab.section.useContainerStyling = false;
    firstTab.section.showTitle = false;
    tabStripSection.sections = [
        firstTab
    ];
    return tabStripSection;
}

class DwMdSectionTabConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.loading = true;
    }
    setupComplete() {
        this.loading = false;
    }
}
DwMdSectionTabConfigComponent.ɵfac = function DwMdSectionTabConfigComponent_Factory(t) { return ɵDwMdSectionTabConfigComponent_BaseFactory(t || DwMdSectionTabConfigComponent); };
DwMdSectionTabConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionTabConfigComponent, selectors: [["dw-md-section-tab-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["header", "Tab Configuration"], ["dwRow", ""], ["dwCol", "6"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], [3, "ngValue"], ["dwCol", "12"], [3, "ngModel", "contextNames", "item", "ngModelChange"]], template: function DwMdSectionTabConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMdSectionTabConfigComponent_div_0_Template, 23, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, DwYesNoComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwExpressionPickerControlComponent]; }, styles: [""] });

var __decorate$Q = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwTabSectionComponent = class DwTabSectionComponent extends DwSectionBaseComponent {
};
DwTabSectionComponent.ɵfac = function DwTabSectionComponent_Factory(t) { return ɵDwTabSectionComponent_BaseFactory(t || DwTabSectionComponent); };
DwTabSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTabSectionComponent, selectors: [["dw-tab-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 6, consts: [[3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"]], template: function DwTabSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-dynamic-section", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formConfig", ctx.formConfig)("sectionConfig", ctx.sectionConfig.section)("formGroup", ctx.formGroup)("context", ctx.context)("submitted", ctx.submitted)("parentIsVisible", ctx.visible);
    } }, directives: [DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective], encapsulation: 2 });
DwTabSectionComponent = __decorate$Q([
    DwSectionComponent({
        keyName: DwSectionType.tab,
        display: 'Tab',
        sectionIcon: 'fa fa-film-alt',
        configComponent: DwMdSectionTabConfigComponent,
        childDisplayPrefix: 'Tab',
        childDisplayProperty: 'tabHeading',
        hasChildren: false,
        hasChild: true,
        omitInConfigTree: false,
        requiresParent: true,
        dragDropConfig: {
            dropParentSectionType: DwSectionType.tabStrip
        },
        getCustomConfigDisplay: getTabConfigDisplay
    })
], DwTabSectionComponent);
function getTabConfigDisplay(section, sectionDef, parentSection, parentSectionDef) {
    const tabSection = section;
    return `Tab: ${tabSection.tabHeading}`;
}

class DwMdSectionContainerConfigComponent extends DwMdSectionConfigBaseComponent {
    sectionChanged() {
        if (!this.section) {
            return;
        }
        if (!this.section.sections) {
            this.section.sections = [];
        }
        // if (this.section.sections.length==0)
        //     this.addItem();
    }
    addItem() {
        let newSection = new DwFormSectionPreference();
        this.section.sections.push(newSection);
        this.onSectionChange();
    }
    removeItem(item) {
        var index = this.section.sections.indexOf(item);
        if (index >= 0)
            this.section.sections.splice(index, 1);
        this.onSectionChange();
    }
    moveUp(item) {
        var index = this.section.sections.indexOf(item);
        if (index == 0)
            return;
        let newIndex = index--;
        this.section.sections.splice(newIndex, 0, this.section.sections.splice(index, 1)[0]);
        this.onSectionChange();
    }
    moveDown(item) {
        var index = this.section.sections.indexOf(item);
        if (index == this.section.sections.length - 1)
            return;
        let newIndex = index++;
        this.section.sections.splice(newIndex, 0, this.section.sections.splice(index, 1)[0]);
        this.onSectionChange();
    }
    drop(event) {
        moveItemInArray(this.section.sections, event.previousIndex, event.currentIndex);
        this.onSectionChange();
    }
}
DwMdSectionContainerConfigComponent.ɵfac = function DwMdSectionContainerConfigComponent_Factory(t) { return ɵDwMdSectionContainerConfigComponent_BaseFactory(t || DwMdSectionContainerConfigComponent); };
DwMdSectionContainerConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionContainerConfigComponent, selectors: [["dw-md-section-container-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 8, consts: [["header", "Container Configuration"], [3, "items", "itemsChange", 4, "ngIf"], ["cdkDropList", "", "class", "example-list", 3, "cdkDropListDropped", 4, "ngIf"], ["class", "table table-striped", 4, "ngIf"], [3, "click"], [1, "fa", "fa-plus", "hand"], ["header", "Section Configuration"], ["showColumnConfig", "true", 3, "section", "contextNames", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"], [3, "items", "itemsChange"], [4, "dwListItem"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["cdkDropList", "", 1, "example-list", 3, "cdkDropListDropped"], ["class", "example-box", "cdkDrag", "", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "example-box"], ["class", "example-custom-placeholder", 4, "cdkDragPlaceholder"], [1, "example-custom-placeholder"], [1, "table", "table-striped"], ["title", "Remove Tab", 1, "fa", "fa-times", "hand", 3, "click"], ["class", "fa fa-grip-verticle fa-3x", 4, "cdkDragHandle"], [1, "fa", "fa-2x", "fa-sort-up", "hand", "pull-left", "clear-left", 3, "hidden", "click"], [1, "fa", "fa-2x", "fa-sort-down", "hand", "move-arrow-down", 3, "hidden", "click"], [1, "fa", "fa-grip-verticle", "fa-3x"]], template: function DwMdSectionContainerConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵtemplate(3, DwMdSectionContainerConfigComponent_dw_ordered_list_3_Template, 2, 1, "dw-ordered-list", 1);
        ɵngcc0.ɵɵtemplate(4, DwMdSectionContainerConfigComponent_div_4_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(5, DwMdSectionContainerConfigComponent_table_5_Template, 9, 1, "table", 3);
        ɵngcc0.ɵɵelement(6, "br");
        ɵngcc0.ɵɵelementStart(7, "button", 4);
        ɵngcc0.ɵɵlistener("click", function DwMdSectionContainerConfigComponent_Template_button_click_7_listener() { return ctx.addItem(); });
        ɵngcc0.ɵɵelement(8, "i", 5);
        ɵngcc0.ɵɵtext(9, " Add Section ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p-tabPanel", 6);
        ɵngcc0.ɵɵelementStart(11, "div");
        ɵngcc0.ɵɵelementStart(12, "dw-md-section-standard-config", 7);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdSectionContainerConfigComponent_Template_dw_md_section_standard_config_sectionChange_12_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdSectionContainerConfigComponent_Template_dw_md_section_standard_config_sectionChange_12_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("section", ctx.section)("contextNames", ctx.contextNames)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc4.NgIf, DwMdSectionStandardConfigComponent, DwOrderedListComponent, DwListItemDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc28.CdkDropList, ɵngcc28.CdkDrag, ɵngcc28.CdkDragPlaceholder, ɵngcc28.CdkDragHandle]; }, styles: [".example-list[_ngcontent-%COMP%]{background:#fff;border:1px solid #ccc;border-radius:4px;display:block;max-width:100%;min-height:60px;overflow:hidden;width:100%}.example-box[_ngcontent-%COMP%]{align-items:center;background:#fff;border-bottom:1px solid #ccc;box-sizing:border-box;color:rgba(0,0,0,.87);cursor:move;display:flex;flex-direction:row;font-size:14px;justify-content:space-between;padding:20px 10px}.cdk-drag-preview[_ngcontent-%COMP%]{border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box[_ngcontent-%COMP%]:last-child{border:none}.example-custom-placeholder[_ngcontent-%COMP%], .example-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   .example-box[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.example-custom-placeholder[_ngcontent-%COMP%]{background:#ccc;border:3px dotted #999;min-height:60px}"] });

function wrapContainer(section) {
    const newSection = new DwContainerSectionPreference();
    // move styles to the new container parent
    newSection.useContainerStyling = section.useContainerStyling;
    newSection.showTitle = section.showTitle;
    newSection.containerStyleName = section.containerStyleName;
    newSection.containerStyleName = section.containerStyleName;
    newSection.containerTitleClass = section.containerTitleClass;
    newSection.containerInnerClass = section.containerInnerClass;
    newSection.containerClass = section.containerClass;
    newSection.title = section.title;
    section.containerStyleName = section.containerTitleClass = section.containerInnerClass = section.containerClass = section.title = null;
    section.showTitle = false;
    section.useContainerStyling = false;
    newSection.sections = [section];
    return newSection;
}

var __decorate$R = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwContainerSectionComponent = class DwContainerSectionComponent extends DwSectionBaseComponent {
    constructor() {
        super(...arguments);
        this.formGroupList = {};
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupSections();
        this.subscriptions.push(this.visibleChange.subscribe(value => {
            setTimeout(() => {
                this.containerSectionVisible = value;
            }, 10);
        }));
        this.containerSectionVisible = this.visible;
    }
    sectionConfigChanged() {
        this.setupSections();
    }
    contextChanged() {
        this.setupSections();
    }
    setupSections() {
        if (!this.formConfig || !this.sectionConfig || !this.context) {
            return;
        }
        const layoutBuilder = new DwSectionLayoutBuilder();
        layoutBuilder.excludeBlankItems = false;
        /* this.sectionRows[0].columns[0].customWidth
        this.sectionRows[0].columns[0].customHeight
        this.sectionRows[0].columns[0].columnClass */
        this.sectionRows = layoutBuilder.buildRows(this.sectionConfig.sections, this.sectionConfig, this.formGroup, (section) => {
            return section;
        }, 
        // context isn't valid here
        () => null, 
        // 3-3-2023 - I'm not sure this does anything.  If it is false, the container itself wouldn't display so it doesn't matter that it's children are hidden
        //  You would think the original intent here is to move the sections around if hidden, but we wouldn't want that
        //    This is in reference to moving the visible expression stuff into the Dynamic Section
        () => true, 
        //() => this.visible,
        this.formGroupList);
    }
    trackByIndex(index, formRow) {
        return index;
    }
};
DwContainerSectionComponent.ɵfac = function DwContainerSectionComponent_Factory(t) { return ɵDwContainerSectionComponent_BaseFactory(t || DwContainerSectionComponent); };
DwContainerSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContainerSectionComponent, selectors: [["dw-container-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 3, consts: [[3, "hidden"], [4, "ngFor", "ngForOf", "ngForTrackBy"], ["dwRow", "", 3, "layoutMode"], [4, "ngIf"], [3, "dwCol", "layoutMode", "dwColOptions", "dwColWidth", "dwColClass"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible", "visibleChange"]], template: function DwContainerSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwContainerSectionComponent_ng_container_1_Template, 3, 3, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.containerSectionVisible);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sectionRows)("ngForTrackBy", ctx.trackByIndex);
    } }, directives: [ɵngcc4.NgForOf, DwRowDirective, ɵngcc4.NgIf, DwColDirective, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective], encapsulation: 2 });
DwContainerSectionComponent = __decorate$R([
    DwSectionComponent({
        keyName: DwSectionType.container,
        display: 'Container',
        sectionIcon: 'fa fa-box',
        configComponent: DwMdSectionContainerConfigComponent,
        hasChildren: true,
        childrenPropertyName: 'sections',
        dragDropConfig: {
            allowChildDrop: true
        },
        wrapOptions: {
            allowWrap: true,
            createWrapSection: wrapContainer
        }
    })
], DwContainerSectionComponent);

function convertLookupValues(lookupValues, valueAttrName = 'Id') {
    let newItems = [];
    for (let lookupValue of lookupValues || []) {
        newItems.push({
            label: lookupValue.Display,
            value: lookupValue[valueAttrName]
        });
    }
    return newItems;
}
function hasGroupingInfo(lookupItems) {
    if (lookupItems === null || lookupItems === void 0 ? void 0 : lookupItems.find(li => li.GroupName)) {
        return true;
    }
    return false;
}
function convertGroupLookupValues(lookupItems, valueAttrName = 'Id') {
    const itemGroups = [];
    let currentGroup;
    for (const item of lookupItems || []) {
        if ((currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.label) !== item.GroupName) {
            currentGroup = {
                label: item.GroupName,
                value: item.GroupName,
                items: []
            };
            itemGroups.push(currentGroup);
        }
        currentGroup.items.push({
            label: item.Display,
            value: item[valueAttrName]
        });
    }
    return itemGroups;
}

class DwAssociativeListSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.formStyle = DwFormStyle.verticleForm;
        this.sectionType = DwSectionType.associativeList;
    }
}
var AssociativeListDisplayType;
(function (AssociativeListDisplayType) {
    AssociativeListDisplayType["dropdown"] = "dropdown";
    AssociativeListDisplayType["list"] = "list";
    AssociativeListDisplayType["duallistbox"] = "duallistbox";
})(AssociativeListDisplayType || (AssociativeListDisplayType = {}));
class AssociativeListDisplayTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return AssociativeListDisplayType[propertyName];
    }
    getKeys() {
        return Object.keys(AssociativeListDisplayType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case AssociativeListDisplayType.list:
                return 'Multi-Select List';
            case AssociativeListDisplayType.dropdown:
                return 'Multi-Select Dropdown';
            case AssociativeListDisplayType.duallistbox:
                return 'Dual List box';
        }
    }
}

var __decorate$S = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$C = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwAssociativeListComponent {
    constructor(dwMetaDataService, dwLookupParameterUtilService, dwEventService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwLookupParameterUtilService = dwLookupParameterUtilService;
        this.dwEventService = dwEventService;
        this.isReadOnly = false;
        this.useLoadedDisplayValues = false;
        this.virtualScrollThreshold = 50;
        this.virtualScrollItems = 30;
        this.displayType = AssociativeListDisplayType.list;
        this.autoExpand = false;
        this.listBoxMaxHeight = '450px';
        this.showFilter = false;
        this.filterItemsThreshold = 1;
        this.listBoxStyle = {};
        this.disabled = false;
        this.displayItems = [];
        this.displayItemsChange = new EventEmitter();
        this.virtualScroll = false;
        this.subscriptions = [];
        // //console.log("dw-assoc-list setupLists - created")
    }
    ngOnChanges(changes) {
        if (changes.parentItem && changes.parentItem.currentValue && !changes.parentItem.firstChange) {
            // //console.log("dw-assoc-list ngOnChanges - parentItem", this.parentItem);
            this.setupLists();
        }
        if (changes.associativeItem && changes.associativeItem.currentValue && !changes.associativeItem.firstChange) {
            // //console.log("dw-assoc-list ngOnChanges - associativeItem", this.associativeItem);
            this.setupLists();
        }
        if (this.isReadOnly) {
            this.finalDisplayType = 'readonly';
            this.setupReadOnlyStyle();
        }
        else {
            this.finalDisplayType = this.displayType;
        }
    }
    ngOnInit() {
        this.setupLists();
        this.setupReadOnlyStyle();
    }
    initControl() {
        this.setupLists();
    }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setupReadOnlyStyle() {
        var _a, _b, _c, _d, _e;
        this.finalReadOnlyItemStyle = {
            containerClass: ((_a = this.readOnlyItemStyle) === null || _a === void 0 ? void 0 : _a.containerClass) || 'dw-chip-container',
            chipClass: ((_b = this.readOnlyItemStyle) === null || _b === void 0 ? void 0 : _b.chipClass) || 'dw-chip',
            chipLabelClass: ((_c = this.readOnlyItemStyle) === null || _c === void 0 ? void 0 : _c.chipLabelClass) || 'dw-chip-label',
            chipDelimiter: (_d = this.readOnlyItemStyle) === null || _d === void 0 ? void 0 : _d.chipDelimiter,
            chipDelimiterClass: (_e = this.readOnlyItemStyle) === null || _e === void 0 ? void 0 : _e.chipDelimiterClass
        };
    }
    setupLists() {
        if (!this.associativeItem && !this.parentItem) {
            return;
        }
        if (this.setupListStarted) {
            return;
        }
        this.setupListStyles();
        this.setupListStarted = true;
        const loadLookupValues = (!this.isReadOnly || !this.useLoadedDisplayValues);
        const ob = this.dwMetaDataService.getAssociativeRelationConfig(this.associativeItem, this.parentItem, this.lookupAttributeName, this.lookupConfig, loadLookupValues);
        this.subscriptions.push(ob.subscribe(associativeConfig => {
            var _a;
            this.associativeConfig = associativeConfig;
            if (!associativeConfig) {
                return;
            }
            this.setupEvents();
            if (this.associativeConfig.hasLookupParameters) {
                associativeConfig.lookupValues = [];
                this.setupLookupParameters((_a = this.lookupConfig) === null || _a === void 0 ? void 0 : _a.lookupParamAttributeOverrides);
                return;
            }
            this.setupLookupItems(associativeConfig.lookupValues);
            this.setupListStarted = false;
        }));
    }
    setupListStyles() {
        this.listBoxStyle['max-height'] = this.listBoxMaxHeight || '450px';
        if (this.listColumns) {
            const columns = parseInt(this.listColumns.toString());
            switch (columns) {
                case 1:
                default:
                    this.listClass = 'dw-list-columns-1';
                case 2:
                    this.listClass = 'dw-list-columns-2';
                    break;
                case 3:
                    this.listClass = 'dw-list-columns-3';
                    break;
                case 4:
                    this.listClass = 'dw-list-columns-4';
                    break;
            }
        }
    }
    setupEvents() {
        if (this.eventSubscription) {
            return;
        }
        this.eventSubscription = this.dwEventService.getEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.LookupChanged(this.associativeConfig.lookupId))
            .subscribe(() => {
            this.setupLists();
        });
        this.subscriptions.push(this.eventSubscription);
    }
    setupLookupItems(lookupValues) {
        this.lookupValues = lookupValues;
        this.hasGrouping = hasGroupingInfo(this.lookupValues);
        if (this.hasGrouping) {
            this.convertedLookupValues = convertGroupLookupValues(this.lookupValues);
        }
        else {
            this.convertedLookupValues = convertLookupValues(this.lookupValues);
        }
        this.buildSelectedValues();
        this.evalShowFilter();
    }
    loadLookupWithParameters() {
        this.subscriptions.push(this.dwMetaDataService.getLookup(this.associativeConfig.lookupId, this.paramValues)
            .subscribe((lookupItems) => {
            this.setupLookupItems(lookupItems);
        }));
    }
    setupLookupParameters(paramReferences) {
        this.parameterExpressionSetResult = this.dwLookupParameterUtilService.setupLookupParameterExpressionSetWithQueryParams(this.associativeConfig.lookupDefinition, null, paramReferences, this.parentFormGroup, this.context);
        this.paramValues = this.parameterExpressionSetResult.initialResults;
        this.loadLookupWithParameters();
        this.parameterExpressionSetResult.observable.subscribe(results => {
            this.loadLookupWithParameters();
            this.paramValues = results;
        });
    }
    buildSelectedValues(setDisplayValuesOnly) {
        if (!this.value || !this.associativeConfig || !this.lookupValues)
            return;
        const selectedItems = [];
        const displayItems = [];
        for (let rawDataItem of this.value) {
            let dataItem = rawDataItem;
            if (!dataItem._isDeleted) {
                const itemValue = dataItem[this.associativeConfig.associativeFkAttributeName];
                if (itemValue) {
                    selectedItems.push(itemValue.toString());
                    let displayValue = dataItem[`${this.associativeConfig.associativeFkAttributeName}Display`];
                    if (!this.useLoadedDisplayValues) {
                        // Find display value
                        const lookupItem = this.lookupValues.find(lookup => lookup.Id == itemValue);
                        displayValue = lookupItem === null || lookupItem === void 0 ? void 0 : lookupItem.Display;
                    }
                    displayItems.push(displayValue);
                }
            }
        }
        this.displayItems = displayItems;
        this.displayItemsChange.emit(displayItems);
        if (setDisplayValuesOnly) {
            return;
        }
        this.selectedItems = selectedItems;
        this.evalShowFilter();
    }
    evalShowFilter() {
        const itemCount = this.lookupValues.length;
        let filterItemsThreshbold = 5;
        if (this.filterItemsThreshold != null && this.filterItemsThreshold != undefined) {
            filterItemsThreshbold = this.filterItemsThreshold;
        }
        this.showFilter = (itemCount > filterItemsThreshbold);
        this.virtualScroll = (itemCount > this.virtualScrollThreshold);
    }
    updateAssocativeCollection(selectedValues) {
        const selectedItems = [];
        if (!this.value)
            this.value = [];
        // 		
        for (let rawDataItem of this.value) {
            let dataItem = rawDataItem;
            dataItem._isDeleted = true;
        }
        for (let currentValue of selectedValues) {
            // let filter = {};
            // filter[this.associativeConfig.associativeFkAttributeName] = value;
            // let dataItem: DwOrmData = _.findWhere(this.value, filter);
            let dataItem = null;
            if (Array.isArray(this.value)) {
                dataItem = this.value.find(i => i[this.associativeConfig.associativeFkAttributeName] == currentValue);
            }
            if (!dataItem) {
                dataItem = {
                    _itemName: this.dwMetaDataService.getDwItemName(this.associativeItem),
                    _keyName: this.associativeConfig.pkAttributeName,
                    _isDeleted: false,
                };
                dataItem[this.associativeConfig.associativeFkAttributeName] = currentValue;
                this.value.push(dataItem);
            }
            dataItem._isDeleted = false;
        }
        this.onChange(this.value);
        this.buildSelectedValues(true);
    }
    writeValue(value) {
        this.value = value;
        this.buildSelectedValues();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
    }
    setDisabledState(disabled) {
        this.disabled = disabled;
    }
}
DwAssociativeListComponent.ɵfac = function DwAssociativeListComponent_Factory(t) { return new (t || DwAssociativeListComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwLookupParameterUtilService), ɵngcc0.ɵɵdirectiveInject(DwEventService)); };
DwAssociativeListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAssociativeListComponent, selectors: [["dw-associative-list"]], inputs: { isReadOnly: "isReadOnly", useLoadedDisplayValues: "useLoadedDisplayValues", virtualScrollThreshold: "virtualScrollThreshold", virtualScrollItems: "virtualScrollItems", displayType: "displayType", autoExpand: "autoExpand", listBoxMaxHeight: "listBoxMaxHeight", filterItemsThreshold: "filterItemsThreshold", displayItems: "displayItems", parentItem: "parentItem", associativeItem: "associativeItem", lookupAttributeName: "lookupAttributeName", lookupConfig: "lookupConfig", listColumns: "listColumns", readOnlyItemStyle: "readOnlyItemStyle", parentFormGroup: "parentFormGroup", context: "context" }, outputs: { displayItemsChange: "displayItemsChange" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: DwAssociativeListComponent,
                multi: true
            }]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 12, vars: 4, consts: [["dwRow", ""], [3, "dwCol", "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], ["dropdown", ""], ["list", ""], ["readonly", ""], [4, "ngTemplateOutlet"], ["display", "chip", "display", "chip", "appendTo", "body", 3, "options", "group", "autoExpand", "ngModel", "filter", "virtualScroll", "itemSize", "ngClass", "ngModelChange"], [3, "ngClass"], ["filter", "filter", "multiple", "true", "checkbox", "true", 3, "options", "group", "ngModel", "filter", "listStyle", "ngModelChange"], [3, "hidden", "ngClass", "class2"], [4, "ngFor", "ngForOf"], [3, "hidden"], ["class2", "readOnlyItemStyle?.chipLabelClass dw-chip-label", 3, "ngClass"], [3, "hidden", "ngClass"]], template: function DwAssociativeListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, DwAssociativeListComponent_ng_container_3_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(4, DwAssociativeListComponent_ng_container_4_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtemplate(5, DwAssociativeListComponent_ng_container_5_Template, 2, 1, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwAssociativeListComponent_ng_template_6_Template, 1, 13, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(8, DwAssociativeListComponent_ng_template_8_Template, 2, 6, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, DwAssociativeListComponent_ng_template_10_Template, 4, 5, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("dwCol", 12)("ngSwitch", ctx.finalDisplayType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "readonly");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "dropdown");
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault, ɵngcc4.NgTemplateOutlet, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgClass, ɵngcc29.Listbox, ɵngcc4.NgForOf], encapsulation: 2 });
DwAssociativeListComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwLookupParameterUtilService },
    { type: DwEventService }
];
DwAssociativeListComponent.propDecorators = {
    parentItem: [{ type: Input }],
    associativeItem: [{ type: Input }],
    lookupAttributeName: [{ type: Input }],
    lookupConfig: [{ type: Input }],
    isReadOnly: [{ type: Input }],
    useLoadedDisplayValues: [{ type: Input }],
    virtualScrollThreshold: [{ type: Input }],
    virtualScrollItems: [{ type: Input }],
    displayType: [{ type: Input }],
    autoExpand: [{ type: Input }],
    listBoxMaxHeight: [{ type: Input }],
    listColumns: [{ type: Input }],
    readOnlyItemStyle: [{ type: Input }],
    parentFormGroup: [{ type: Input }],
    context: [{ type: Input }],
    filterItemsThreshold: [{ type: Input }],
    displayItems: [{ type: Input }],
    displayItemsChange: [{ type: Output }]
};
__decorate$S([
    DwInputConverter(booleanConverter),
    __metadata$C("design:type", Boolean)
], DwAssociativeListComponent.prototype, "isReadOnly", void 0);
__decorate$S([
    DwInputConverter(booleanConverter),
    __metadata$C("design:type", Boolean)
], DwAssociativeListComponent.prototype, "useLoadedDisplayValues", void 0);
__decorate$S([
    DwInputConverter(intConverter),
    __metadata$C("design:type", Number)
], DwAssociativeListComponent.prototype, "virtualScrollThreshold", void 0);
__decorate$S([
    DwInputConverter(intConverter),
    __metadata$C("design:type", Number)
], DwAssociativeListComponent.prototype, "virtualScrollItems", void 0);
__decorate$S([
    DwInputConverter(booleanConverter),
    __metadata$C("design:type", Boolean)
], DwAssociativeListComponent.prototype, "autoExpand", void 0);

class DwMdSectionAssociativeListConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.horizontalForm = DwFormStyle.horizontalForm;
    }
    ngOnInit() {
        this.displayTypes = new AssociativeListDisplayTypeList().getEnumList();
        this.formStyles = new DwFormStyleList().getEnumList();
    }
    onRelationshipChange(relationshipName) {
        const relationship = this.itemMetaData.Relations.find(r => r.RelationshipName === relationshipName);
        if (relationship) {
            if (relationship.PkUniqueItemName == this.getParentItemName()) {
                this.section.associativeItem = relationship.FkUniqueItemName;
            }
            else {
                this.section.associativeItem = relationship.PkUniqueItemName;
            }
            this.section.relationshipName = relationship.RelationshipName;
            this.section.propertyName = relationship.NamingInfo.RelationshipPropertyName;
        }
        this.loadAssociativeItemMetaData();
        this.onSectionChange();
    }
    loadAssociativeItemMetaData() {
        var _a;
        if (!this.section.associativeItem || ((_a = this.associativeItemMetaData) === null || _a === void 0 ? void 0 : _a.UniqueItemName) == this.section.associativeItem) {
            return;
        }
        this.dwMetaDataService.getMetaData(this.section.associativeItem)
            .subscribe(associativeItemMetaData => {
            this.associativeItemMetaData = associativeItemMetaData;
            this.associativeItemMetaData.Display;
            this.setupLookupAttribute();
        });
    }
    setupLookupAttribute() {
        var _a;
        if (!this.associativeItemMetaData) {
            return;
        }
        this.lookupAttributes = this.associativeItemMetaData.Attributes.filter(a => a.IsLookup && !a.IsKey);
        this.lookupAttribute = this.lookupAttributes.find(a => a.AttributeName == this.section.lookupAttributeName);
        if (!this.lookupAttribute) {
            this.lookupAttribute = this.lookupAttributes.find(a => a.IsLookup && !a.IsKey);
            this.section.lookupAttributeName = ((_a = this.lookupAttribute) === null || _a === void 0 ? void 0 : _a.AttributeName) || this.section.lookupAttributeName;
        }
        if (!this.lookupAttribute) {
            this.lookupFieldContext = null;
        }
        this.lookupFieldContext = {
            formFieldPreference: {
                attrName: this.lookupAttribute.AttributeName
            },
            itemName: this.itemName,
            contextNames: this.contextNames,
            queryAttr: {
                AttributeName: this.lookupAttribute.AttributeName,
                DisplayAttributeName: this.lookupAttribute.AttributeName,
                HasDisplayField: true,
                AttributeDisplay: this.lookupAttribute.Display,
                AttributeType: this.lookupAttribute.AttributeType,
                Attribute: this.lookupAttribute,
                FieldType: DwFieldType.Standard
            }
        };
        this.onSectionChange();
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        this.section.displayType = this.section.displayType || AssociativeListDisplayType.list;
        this.section.formStyle = this.section.formStyle || DwFormStyle.verticleForm;
        this.section.autoExpand = this.section.autoExpand == false ? false : true; // default to true
        this.section.readOnlyItemStyle = this.section.readOnlyItemStyle || {};
        this.section.parentItem = this.getParentItemName();
        if (!this.section.validationConfig) {
            this.section.validationConfig = {};
        }
        this.getItemMetaData(this.section.parentItem)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
        });
        this.loadAssociativeItemMetaData();
    }
}
DwMdSectionAssociativeListConfigComponent.ɵfac = function DwMdSectionAssociativeListConfigComponent_Factory(t) { return ɵDwMdSectionAssociativeListConfigComponent_BaseFactory(t || DwMdSectionAssociativeListConfigComponent); };
DwMdSectionAssociativeListConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionAssociativeListConfigComponent, selectors: [["dw-md-section-associative-list-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 92, vars: 36, consts: [["header", "Associative List Configuration"], [3, "multiple"], ["header", "List Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "4"], ["dwCol", "4", 4, "ngIf"], [1, "col-md-6"], ["allowNull", "true", "nullDisplay", "Automatic", 3, "ngModel", "ngModelChange"], ["title", "Minimum number of items in the list before the filter is dispalyed", 1, "fa", "fa-info-circle"], ["type", "text", "dwNumeric", "", "placeholder", "15", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Assigns the string display value of the selected items to a variable", 1, "fa", "fa-info-circle"], ["dwCol", "6", 4, "ngIf"], ["header", "Lookup Settings", 3, "selected", 4, "ngIf"], ["header", "Style Settings", 3, "selected"], ["class", "row", 4, "ngIf"], ["header", "Validation", 4, "ngIf"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "showReadOnlySection", "sectionChange"], [3, "ngValue"], ["allowNull", "false", 3, "ngModel", "ngModelChange"], ["type", "text", "placeholder", "450px", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "numeric", "maxlength", "1", "placeholder", "1", 1, "form-control", 3, "dwNumeric", "ngModel", "ngModelChange"], ["type", "text", "placeholder", ", ", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Lookup Settings", 3, "selected"], [3, "config", "configContext", "hideAdditionalDisplay", "hideUseTransitions", "configChange"], [1, "row"], ["class", "col-md-6", 4, "ngIf"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Validation"], ["validationItemType", "formArray", 3, "config", "configContext", "configChange"]], template: function DwMdSectionAssociativeListConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "p-accordion", 1);
        ɵngcc0.ɵɵelementStart(4, "p-accordionTab", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Parent Item");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 4);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_select_ngModelChange_14_listener($event) { return ctx.section.relationshipName = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_select_ngModelChange_14_listener($event) { return ctx.onRelationshipChange($event); });
        ɵngcc0.ɵɵtemplate(15, DwMdSectionAssociativeListConfigComponent_option_15_Template, 2, 3, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 3);
        ɵngcc0.ɵɵelementStart(17, "div", 4);
        ɵngcc0.ɵɵelementStart(18, "label");
        ɵngcc0.ɵɵtext(19, "Related Item");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 5);
        ɵngcc0.ɵɵtext(21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 4);
        ɵngcc0.ɵɵelementStart(23, "label");
        ɵngcc0.ɵɵtext(24, "Lookup Field Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_select_ngModelChange_25_listener($event) { return ctx.section.lookupAttributeName = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_select_ngModelChange_25_listener() { return ctx.setupLookupAttribute(); });
        ɵngcc0.ɵɵtemplate(26, DwMdSectionAssociativeListConfigComponent_option_26_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div", 3);
        ɵngcc0.ɵɵelementStart(28, "div", 8);
        ɵngcc0.ɵɵelementStart(29, "label");
        ɵngcc0.ɵɵtext(30, "Display Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_select_ngModelChange_31_listener($event) { return ctx.section.displayType = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_select_ngModelChange_31_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(32, DwMdSectionAssociativeListConfigComponent_option_32_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(33, DwMdSectionAssociativeListConfigComponent_div_33_Template, 4, 1, "div", 9);
        ɵngcc0.ɵɵtemplate(34, DwMdSectionAssociativeListConfigComponent_div_34_Template, 4, 1, "div", 9);
        ɵngcc0.ɵɵtemplate(35, DwMdSectionAssociativeListConfigComponent_div_35_Template, 4, 1, "div", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "div", 3);
        ɵngcc0.ɵɵelementStart(37, "div", 10);
        ɵngcc0.ɵɵelementStart(38, "label");
        ɵngcc0.ɵɵtext(39, "Is Read Only");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "dw-yesno", 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_dw_yesno_ngModelChange_40_listener($event) { return ctx.section.isReadOnly = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_dw_yesno_ngModelChange_40_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "div", 4);
        ɵngcc0.ɵɵelementStart(42, "label");
        ɵngcc0.ɵɵtext(43, "Show Filter Threshold ");
        ɵngcc0.ɵɵelement(44, "i", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "input", 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_45_listener($event) { return ctx.section.filterItemsThreshold = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_45_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(46, "div", 3);
        ɵngcc0.ɵɵelementStart(47, "div", 4);
        ɵngcc0.ɵɵelementStart(48, "label");
        ɵngcc0.ɵɵtext(49, "Label");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_50_listener($event) { return ctx.section.label = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_50_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "div", 4);
        ɵngcc0.ɵɵelementStart(52, "label");
        ɵngcc0.ɵɵtext(53, "Label Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_54_listener($event) { return ctx.section.labelClass = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_54_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "div", 3);
        ɵngcc0.ɵɵelementStart(56, "div", 4);
        ɵngcc0.ɵɵelementStart(57, "label");
        ɵngcc0.ɵɵtext(58, "List Display Variable Name ");
        ɵngcc0.ɵɵelement(59, "i", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(60, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_60_listener($event) { return ctx.section.displayVariableName = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_60_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(61, DwMdSectionAssociativeListConfigComponent_div_61_Template, 4, 1, "div", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(62, DwMdSectionAssociativeListConfigComponent_p_accordionTab_62_Template, 2, 5, "p-accordionTab", 17);
        ɵngcc0.ɵɵelementStart(63, "p-accordionTab", 18);
        ɵngcc0.ɵɵtemplate(64, DwMdSectionAssociativeListConfigComponent_div_64_Template, 7, 3, "div", 19);
        ɵngcc0.ɵɵelementStart(65, "div", 3);
        ɵngcc0.ɵɵelementStart(66, "div", 4);
        ɵngcc0.ɵɵelementStart(67, "label");
        ɵngcc0.ɵɵtext(68, "Read-only Container Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(69, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_69_listener($event) { return ctx.section.readOnlyItemStyle.containerClass = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_69_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(70, "div", 4);
        ɵngcc0.ɵɵelementStart(71, "label");
        ɵngcc0.ɵɵtext(72, "Chip Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(73, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_73_listener($event) { return ctx.section.readOnlyItemStyle.chipClass = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_73_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(74, "div", 3);
        ɵngcc0.ɵɵelementStart(75, "div", 4);
        ɵngcc0.ɵɵelementStart(76, "label");
        ɵngcc0.ɵɵtext(77, "Chip Label Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(78, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_78_listener($event) { return ctx.section.readOnlyItemStyle.chipLabelClass = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_78_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(79, "div", 3);
        ɵngcc0.ɵɵelementStart(80, "div", 4);
        ɵngcc0.ɵɵelementStart(81, "label");
        ɵngcc0.ɵɵtext(82, "Chip Delimiter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(83, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_83_listener($event) { return ctx.section.readOnlyItemStyle.chipDelimiter = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_83_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(84, "div", 4);
        ɵngcc0.ɵɵelementStart(85, "label");
        ɵngcc0.ɵɵtext(86, "Chip Delimiter Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(87, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_87_listener($event) { return ctx.section.readOnlyItemStyle.chipDelimiterClass = $event; })("ngModelChange", function DwMdSectionAssociativeListConfigComponent_Template_input_ngModelChange_87_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(88, DwMdSectionAssociativeListConfigComponent_p_tabPanel_88_Template, 2, 2, "p-tabPanel", 20);
        ɵngcc0.ɵɵelementStart(89, "p-tabPanel", 21);
        ɵngcc0.ɵɵelementStart(90, "div");
        ɵngcc0.ɵɵelementStart(91, "dw-md-section-standard-config", 22);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdSectionAssociativeListConfigComponent_Template_dw_md_section_standard_config_sectionChange_91_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdSectionAssociativeListConfigComponent_Template_dw_md_section_standard_config_sectionChange_91_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("multiple", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.itemMetaData == null ? null : ctx.itemMetaData.Display, " (", ctx.itemMetaData == null ? null : ctx.itemMetaData.UniqueItemName, ")");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.relationshipName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.itemMetaData == null ? null : ctx.itemMetaData.Relations);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.associativeItemMetaData == null ? null : ctx.associativeItemMetaData.Display, " (", ctx.section.associativeItem, ")");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.lookupAttributeName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.lookupAttributes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.displayType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.displayTypes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.displayType == "dropdown");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.displayType != "dropdown");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.displayType != "dropdown");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.isReadOnly);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.filterItemsThreshold);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.label);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.labelClass);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.displayVariableName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.displayVariableName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lookupFieldContext);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.readOnlyItemStyle.containerClass);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.readOnlyItemStyle.chipClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.readOnlyItemStyle.chipLabelClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.readOnlyItemStyle.chipDelimiter);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.readOnlyItemStyle.chipDelimiterClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section == null ? null : ctx.section.validationConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName)("showReadOnlySection", false);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwYesNoComponent, DwNumericDirective, ɵngcc3.DefaultValueAccessor, DwMdSectionStandardConfigComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.MaxLengthValidator, DwSelectLookupConfigComponent, DwFieldValidationConfigComponent]; }, styles: [""] });

var __decorate$T = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$D = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwAssociativeListSectionComponent = class DwAssociativeListSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, 
    // private dwExpressionStateService: DwExpressionStateService,
    dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, 
    //private dwFormBuilderService: DwMetadataFormBuilderService,
    dwFormValidationService, 
    //private dwMetadataFormUtilService: DwMetadataFormUtilService,
    //private dwContextService: DwContextService,
    dwFormSectionStateService, dwFormStateService) {
        super(dwExpressionService, dwFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwFormValidationService = dwFormValidationService;
        this.formGroupSetup = false;
        this.useLoadedDisplayValues = false;
    }
    // Override parent method
    isSectionReadOnly() {
        if (this.sectionConfig.isReadOnly == true || this.sectionConfig.isReadOnly == false) {
            return this.sectionConfig.isReadOnly;
        }
        return super.isSectionReadOnly();
    }
    sectionReadOnlyChanged(readOnly) {
        this.enabledDisableControls();
    }
    enabledDisableControls() {
        const readOnly = this.isSectionReadOnly() || !this.visible;
        if (this.associativeList) {
            if (readOnly && this.associativeList.enabled) {
                this.associativeList.disable();
            }
            if (!readOnly && this.associativeList.disabled) {
                this.associativeList.enable();
            }
        }
    }
    ngOnInit() {
        var _a, _b;
        super.ngOnInit();
        if (!this.formGroup || !this.sectionConfig) {
            return;
        }
        this.useLoadedDisplayValues = this.formConfig.loadDisplayProperties;
        this.controlName = this.sectionConfig.propertyName;
        this.associativeList = this.formGroup.get(this.controlName);
        this.labelColStyle = {
            width: `${((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.labelWidth) || 100}px`,
            flex: 'none',
            'max-width': 'none'
        };
        this.dataColStyle = {
            width: `calc(100% - ${((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.labelWidth) || 100}px)`,
            flex: 'none',
            'max-width': 'none'
        };
        this.subscriptions.push(this.visibleChange.subscribe(visible => {
            this.enabledDisableControls();
        }));
        this.formGroupSetup = true;
        this.setupValidation();
    }
    setupValidation() {
        var _a, _b, _c;
        this.logMessage(`setupValidation - Before`);
        if (!this.associativeList) {
            this.logMessage(`setupValidation - After`);
            return;
        }
        if (this.isSectionReadOnly()) {
            this.logMessage(`setupValidation - After`);
            return;
        }
        this.sectionReadOnlyChanged(this.isSectionReadOnly());
        if ((_b = (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.validationConfig) === null || _b === void 0 ? void 0 : _b.overrideDefaults) {
            if (this.dwFormValidationService.hasConditionalValidation(this.sectionConfig.validationConfig) && !((_c = this.conditionalExpressionState) === null || _c === void 0 ? void 0 : _c.conditionalExpressionsSetup)) {
                this.conditionalExpressionState = this.dwFormValidationService.initConditionalExpressionState(this.controlName, this.sectionConfig.validationConfig, this.formGroup, this.context, (state => {
                    this.conditionalExpressionState = state;
                    this.checkValidation();
                }));
            }
            // Perform initial valiadtion check
            this.checkValidation();
            // // Run in timeout to prevent change after checked error
            // setTimeout(() => {
            // 	const validatorBuildResult = this.dwFormValidationService.buildValidators(this.associativeList, this.sectionConfig?.validationConfig, this.controlName, this.conditionalExpressionState?.conditionalExpressionResult);
            // 	if (validatorBuildResult.validators) {
            // 		this.associativeList.setValidators(validatorBuildResult.validators);
            // 	}
            // });
        }
        this.logMessage(`setupValidation - After`);
    }
    checkValidation() {
        // Run in timeout to prevent change after checked error
        setTimeout(() => {
            var _a, _b;
            const validatorBuildResult = this.dwFormValidationService.buildValidators(this.associativeList, (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.validationConfig, this.controlName, (_b = this.conditionalExpressionState) === null || _b === void 0 ? void 0 : _b.conditionalExpressionResult);
            if (validatorBuildResult.validators) {
                this.associativeList.setValidators(validatorBuildResult.validators);
            }
        });
    }
    logMessage(message, data) {
        DwFormDebugService.debugMessage(0, this.componentName, message, data);
    }
    steDisplayItemsVariable(items) {
        this.displayItemsList = items.join(this.sectionConfig.displayVariableDelimiter || ', ');
        if (this.sectionConfig.displayVariableName) {
            this.dwFormStateService.state.formApi.setVariableValue(this.sectionConfig.displayVariableName, this.displayItemsList);
        }
    }
};
DwAssociativeListSectionComponent.ɵfac = function DwAssociativeListSectionComponent_Factory(t) { return new (t || DwAssociativeListSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwAssociativeListSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAssociativeListSectionComponent, selectors: [["dw-associative-list-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "ngSwitch", "formGroup"], ["class", "row", 4, "ngSwitchCase"], [3, "formGroup", 4, "ngSwitchDefault"], [3, "formControlName", "submitted"], [1, "row"], [1, "col-sm-2", 3, "ngStyle"], [3, "hidden"], [1, "col-sm-10", 3, "ngStyle"], [3, "formControlName", "autoExpand", "parentItem", "isReadOnly", "useLoadedDisplayValues", "associativeItem", "displayType", "readOnlyItemStyle"], [3, "formGroup"], [3, "formControlName", "autoExpand", "listBoxMaxHeight", "listColumns", "parentItem", "associativeItem", "displayType", "lookupAttributeName", "lookupConfig", "isReadOnly", "useLoadedDisplayValues", "readOnlyItemStyle", "parentFormGroup", "context", "filterItemsThreshold", "displayItems", "displayItemsChange"]], template: function DwAssociativeListSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwAssociativeListSectionComponent_ng_container_0_Template, 5, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroupSetup && ctx.sectionConfig);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgSwitch, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault, DwValidationInfo, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgStyle, DwAssociativeListComponent], encapsulation: 2 });
DwAssociativeListSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService }
];
DwAssociativeListSectionComponent = __decorate$T([
    DwSectionComponent({
        keyName: DwSectionType.associativeList,
        display: 'Related List',
        sectionIcon: 'fa fa-list',
        configComponent: DwMdSectionAssociativeListConfigComponent,
        hasChildren: false,
        getPrefetchPathInfo: getAssociativeListPrefetchPath,
        addFormGroupControls: addAssociativeListFields,
        hasReadOnlyMode: true
    }),
    __metadata$D("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetadataFormValidationBuilderService,
        DwMetaDataFormSectionStateService,
        DwMetaDataFormStateService])
], DwAssociativeListSectionComponent);
function getAssociativeListPrefetchPath(section) {
    const assocListSection = section;
    ;
    if (assocListSection.relationshipName) {
        return {
            itemName: assocListSection.associativeItem,
            propertyName: assocListSection.associativeItem,
            relationshipName: assocListSection.relationshipName
        };
    }
    else {
        console.warn('Associative Item section is missing an associative Item - Prefetch paths could not be added!');
    }
    return null;
}
function addAssociativeListFields(sectionConfig, formGroup, formConfig, itemName) {
    const assocListSection = sectionConfig;
    ;
    const controlName = assocListSection.propertyName;
    const associativeListFC = new FormControl();
    formGroup.addControl(controlName, associativeListFC);
}

class DynamicRoutingInitComponent {
    constructor(dwMetaDataRoutingRegistryService) {
        dwMetaDataRoutingRegistryService.registerDynamicRoutes();
    }
    ngOnInit() {
    }
}
DynamicRoutingInitComponent.ɵfac = function DynamicRoutingInitComponent_Factory(t) { return new (t || DynamicRoutingInitComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingRegistryService)); };
DynamicRoutingInitComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DynamicRoutingInitComponent, selectors: [["dw-dynamic-routing-init"]], decls: 0, vars: 0, template: function DynamicRoutingInitComponent_Template(rf, ctx) { }, encapsulation: 2 });
DynamicRoutingInitComponent.ctorParameters = () => [
    { type: DwMetaDataRoutingRegistryService }
];

class DwMetaDataListPreferenceHierarchy extends DwUiPreferencesHierarchyBase {
}

class DwMetaDataListConfig extends DwDataListConfig {
    constructor() {
        super(...arguments);
        this.filters = [];
    }
}

class DwMetaDataListService {
    constructor(dwOrmDataService, 
    // @Inject(DwConfigServiceToken) configService: DwConfigService,
    dwMetaDataService, uiMetaDataConfig, uiConfigService, dwCacheService, dwMetaDataActionConfigService, dwContextService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.uiConfigService = uiConfigService;
        this.dwCacheService = dwCacheService;
        this.dwMetaDataActionConfigService = dwMetaDataActionConfigService;
        this.dwContextService = dwContextService;
        //private uiMetaDataConfig: DwUIMetaDataConfig;
        this.listGlobalPreferences = new DwMetaDataListPreferences();
        //this.uiMetaDataConfig = configService.getConfig<DwUIMetaDataConfig>(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
        this.listGlobalPreferences = this.uiMetaDataConfig.listDefaultPreferences;
    }
    getDataSourceOld(listPrefHiearchy) {
        const qh = this.dwOrmDataService.QueryHelper;
        const finalPreferences = this.uiConfigService.getFinalPreferences(listPrefHiearchy);
        let query = null;
        if (!finalPreferences.metaDataQueryMeaning) {
            query = new DwQuery(listPrefHiearchy.item);
            if (finalPreferences.showDisplayProperties) {
                query.getFieldSettings().LoadAllLookupDisplayFields = true;
            }
        }
        else {
            query = qh.cloneQuery(listPrefHiearchy.queryMetaData[0].DataQuery);
        }
        query.getFieldSettings().LoadAllLookupDisplayFields = finalPreferences.showDisplayProperties;
        return new DwOrmDataSource(this.dwOrmDataService, this.dwMetaDataService, query);
    }
    getDataSource(listPrefHiearchy) {
        const finalPreferences = this.uiConfigService.getFinalPreferences(listPrefHiearchy);
        let query = this.buildQuery(listPrefHiearchy, finalPreferences);
        let dataSource = new DwOrmDataSource(this.dwOrmDataService, this.dwMetaDataService, query);
        if (finalPreferences === null || finalPreferences === void 0 ? void 0 : finalPreferences.dataSourceName) {
            let customDataSource = this.uiConfigService.getDataSource(finalPreferences === null || finalPreferences === void 0 ? void 0 : finalPreferences.dataSourceName);
            if (customDataSource) {
                dataSource = customDataSource;
            }
        }
        dataSource.initDataSource();
        if (dataSource instanceof DwOrmDataSource) {
            dataSource.item = query;
        }
        return dataSource;
    }
    buildQuery(listPrefHiearchy, finalPreferences) {
        let query = null;
        const qh = this.dwOrmDataService.QueryHelper;
        if (!finalPreferences.metaDataQueryMeaning) {
            query = new DwQuery(listPrefHiearchy.item);
            if (finalPreferences.showDisplayProperties) {
                query.getFieldSettings().LoadAllLookupDisplayFields = true;
            }
        }
        else {
            query = qh.cloneQuery(listPrefHiearchy.queryMetaData[0].DataQuery);
        }
        query.getFieldSettings().LoadAllLookupDisplayFields = finalPreferences.showDisplayProperties;
        return query;
    }
    // private cloneQuery(query: DwQuery): DwQuery {
    //     const newQuery = new DwQuery(query.RootTable);
    //     return Object.assign(newQuery, query); 
    // }
    getPreferencesHierarchy(item, configKey, useLoadedPreferences, componentSetPreferences) {
        let metaDataOb = this.dwMetaDataService.getMetaData(item);
        let prefsOb = this.uiConfigService.getPreferencesHierarchy(configKey, DwUiConfigType.list, this.listGlobalPreferences, componentSetPreferences, useLoadedPreferences);
        let itemSecurityOb = this.dwMetaDataService.getUserMetaDataItemSecurity(item);
        return combineLatest([metaDataOb, prefsOb, itemSecurityOb])
            .pipe(mergeMap(([metaData, prefHierarchy, itemSecurity]) => {
            if (prefHierarchy.configType != DwUiConfigType.list) {
                console.warn('getPreferenceHierarchy returned wrong type');
            }
            let listPrefsHierarchy = new DwMetaDataListPreferenceHierarchy();
            listPrefsHierarchy = Object.assign(listPrefsHierarchy, prefHierarchy);
            listPrefsHierarchy.item = item;
            listPrefsHierarchy.itemMetaData = metaData;
            listPrefsHierarchy.itemSecurity = itemSecurity;
            listPrefsHierarchy.metaDataItemId = metaData === null || metaData === void 0 ? void 0 : metaData.MetaDataItemId;
            const finalPreferences = this.uiConfigService.getFinalPreferences(listPrefsHierarchy);
            const contextOb = this.dwContextService.getContextsAndResolve(finalPreferences.contextNames, {});
            const queryMetaDataOb = this.getQueryMetaData(listPrefsHierarchy.item, null, finalPreferences.metaDataQueryMeaning);
            return combineLatest([queryMetaDataOb, contextOb])
                .pipe(map(([queryMetaData, resolvedContext]) => {
                listPrefsHierarchy.queryMetaData = queryMetaData;
                listPrefsHierarchy.resolvedContext = resolvedContext;
                return listPrefsHierarchy;
            }));
        }));
    }
    getQueryMetaData(item, metaDataQueryId, metaDataQueryMeaning) {
        // Get a list of all metadata that is needed for all views
        const itemRequest = {
            ItemName: item,
            MetaDataQueryIds: [],
            MetaDataQueryMeanings: [],
        };
        if (metaDataQueryId) {
            itemRequest.MetaDataQueryIds.push(metaDataQueryId);
        }
        if (metaDataQueryMeaning) {
            itemRequest.MetaDataQueryMeanings.push(metaDataQueryMeaning);
        }
        if (itemRequest.MetaDataQueryIds.length === 0 && itemRequest.MetaDataQueryMeanings.length === 0) {
            itemRequest.MetaDataQueryIds.push(0);
        }
        return this.dwMetaDataService.getSavedQueryMetaDataMulti([itemRequest]);
    }
    buildConfig(listPreferenceHierarchy) {
        let config = new DwMetaDataListConfig();
        const finalPreferences = this.uiConfigService.getFinalPreferences(listPreferenceHierarchy);
        Object.assign(config, finalPreferences);
        config.item = listPreferenceHierarchy.item;
        config.itemDisplayName = listPreferenceHierarchy.itemMetaData.Display;
        config.contextNames = finalPreferences.contextNames;
        config.resolvedContext = listPreferenceHierarchy.resolvedContext;
        config.hideLoading = finalPreferences.hideLoading;
        this.buildFinalActionPreferences(config, listPreferenceHierarchy.itemSecurity);
        return config;
    }
    buildFinalActionPreferences(config, itemSecurity) {
        let actionPreferencesByMode = config.actionPreferencesByMode || {};
        config.actionPreferencesByMode = this.dwMetaDataActionConfigService.buildFinalActionPreferencesByMode(actionPreferencesByMode, itemSecurity, this.uiMetaDataConfig.listButtonDefaults);
    }
}
DwMetaDataListService.ɵfac = function DwMetaDataListService_Factory(t) { return new (t || DwMetaDataListService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwUiConfigService), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwMetaDataActionConfigService), ɵngcc0.ɵɵinject(DwContextService)); };
DwMetaDataListService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataListService_Factory() { return new DwMetaDataListService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwUiConfigService), ɵɵinject(DwCacheService), ɵɵinject(DwMetaDataActionConfigService), ɵɵinject(DwContextService)); }, token: DwMetaDataListService, providedIn: "root" });
DwMetaDataListService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigService },
    { type: DwCacheService },
    { type: DwMetaDataActionConfigService },
    { type: DwContextService }
];

class DwMetadataConfigFiltersModalComponent {
    constructor(dwMetaDataService) {
        this.dwMetaDataService = dwMetaDataService;
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
        this.filters = this.modalConfig.data.filters || [];
        this.configContext = {
            itemName: this.modalConfig.data.itemName
        };
    }
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        result.closeModal = true;
        result.cancelled = false;
        result.data = {
            filters: this.filters
        };
        switch (buttonConfig.command) {
            case DwButtonCommand.cancel:
                result.cancelled = true;
        }
        return of(result);
    }
}
DwMetadataConfigFiltersModalComponent.ɵfac = function DwMetadataConfigFiltersModalComponent_Factory(t) { return new (t || DwMetadataConfigFiltersModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwMetadataConfigFiltersModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataConfigFiltersModalComponent, selectors: [["dw-dw-metadata-config-filters-modal"]], decls: 1, vars: 2, consts: [[3, "configContext", "filters", "filtersChange"]], template: function DwMetadataConfigFiltersModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-metadata-config-filters", 0);
        ɵngcc0.ɵɵlistener("filtersChange", function DwMetadataConfigFiltersModalComponent_Template_dw_metadata_config_filters_filtersChange_0_listener($event) { return ctx.filters = $event; });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("configContext", ctx.configContext)("filters", ctx.filters);
    } }, directives: function () { return [DwMetadataConfigFiltersComponent]; }, encapsulation: 2 });
DwMetadataConfigFiltersModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

class DwMetadataListConfigComponent {
    constructor() {
        this.setupComplete = false;
        this.tabIndex = 0;
    }
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        result.closeModal = true;
        result.cancelled = false;
        result.data = {
            preferences: this.preferences
        };
        switch (buttonConfig.command) {
            case DwButtonCommand.cancel:
                result.cancelled = true;
        }
        return of(result);
    }
    updatePreferences(preferences) {
        Object.assign(this.preferences, preferences);
    }
    updateActionPreferences(actionPreferencesByMode) {
        this.preferences.actionPreferencesByMode = actionPreferencesByMode;
    }
    ngOnInit() {
        this.preferences = this.modalConfig.data.preferences;
        this.itemName = this.modalConfig.data.itemName;
        this.designerState = this.modalConfig.data.designerState;
        this.preferences.actionPreferencesByMode = this.preferences.actionPreferencesByMode || {};
        this.configContext = {
            contextNames: this.preferences.contextNames,
            itemName: this.itemName,
            metaDataQueryMeaning: this.preferences.metaDataQueryMeaning
        };
        this.setupInitialState(this.designerState);
    }
    setupInitialState(designerState) {
        if (!designerState) {
            return;
        }
        this.tabIndex = 0;
        switch (designerState.detailKey) {
            case 'filter':
                this.tabIndex = 2;
                const filterConfig = designerState.additionalInfo;
                this.initialFilterKey = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.filterDisplay;
                break;
            case 'filterTile':
                this.tabIndex = 3;
                const filterTileConfig = designerState.additionalInfo;
                this.initialFilterTileKey = filterTileConfig === null || filterTileConfig === void 0 ? void 0 : filterTileConfig.tileKey;
                break;
        }
    }
}
DwMetadataListConfigComponent.ɵfac = function DwMetadataListConfigComponent_Factory(t) { return new (t || DwMetadataListConfigComponent)(); };
DwMetadataListConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataListConfigComponent, selectors: [["dw-metadata-list-config"]], decls: 36, vars: 16, consts: [["styleClass", "dw-fixed-tabs", 3, "activeIndex", "activeIndexChange"], ["header", "Card"], [3, "preferences", "configContext", "preferencesChange"], ["header", "Actions"], [3, "configContext", "actionPreferencesByMode", "actionPreferencesByModeChange", "actionPreferenceByModeChange"], ["header", "Filters"], ["showAdditionalTab", "true", 3, "configContext", "filters", "initialFilterKey", "filtersChange"], ["additionalTab", ""], ["header", "View Options", 3, "selected"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["header", "Grid Filter Options", 3, "selected"], ["dwRow", "", 3, "hidden"], ["dwCol", "6"], ["type", "number", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Filter Tiles", 4, "ngIf"], ["header", "Filter Tiles"], [3, "configContext", "initialFilterTileKey", "tileConfig", "tileConfigChange"]], template: function DwMetadataListConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-tabView", 0);
        ɵngcc0.ɵɵlistener("activeIndexChange", function DwMetadataListConfigComponent_Template_p_tabView_activeIndexChange_0_listener($event) { return ctx.tabIndex = $event; });
        ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 1);
        ɵngcc0.ɵɵelementStart(2, "dw-card-config", 2);
        ɵngcc0.ɵɵlistener("preferencesChange", function DwMetadataListConfigComponent_Template_dw_card_config_preferencesChange_2_listener($event) { return ctx.updatePreferences($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p-tabPanel", 3);
        ɵngcc0.ɵɵelementStart(4, "dw-metadata-list-actions-config", 4);
        ɵngcc0.ɵɵlistener("actionPreferencesByModeChange", function DwMetadataListConfigComponent_Template_dw_metadata_list_actions_config_actionPreferencesByModeChange_4_listener($event) { return ctx.preferences.actionPreferencesByMode = $event; })("actionPreferenceByModeChange", function DwMetadataListConfigComponent_Template_dw_metadata_list_actions_config_actionPreferenceByModeChange_4_listener($event) { return ctx.updateActionPreferences($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p-tabPanel", 5);
        ɵngcc0.ɵɵelementStart(6, "dw-metadata-config-filters", 6);
        ɵngcc0.ɵɵlistener("filtersChange", function DwMetadataListConfigComponent_Template_dw_metadata_config_filters_filtersChange_6_listener($event) { return ctx.preferences.filters = $event; });
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵelementStart(8, "p-accordion");
        ɵngcc0.ɵɵelementStart(9, "p-accordionTab", 8);
        ɵngcc0.ɵɵelementStart(10, "div", 9);
        ɵngcc0.ɵɵelementStart(11, "div", 10);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Use Filter Tiles");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 11);
        ɵngcc0.ɵɵelementStart(15, "p-inputSwitch", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataListConfigComponent_Template_p_inputSwitch_ngModelChange_15_listener($event) { return ctx.preferences.useFilterTiles = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "p-accordionTab", 13);
        ɵngcc0.ɵɵelementStart(17, "div", 9);
        ɵngcc0.ɵɵelementStart(18, "div", 10);
        ɵngcc0.ɵɵelementStart(19, "label");
        ɵngcc0.ɵɵtext(20, "Show Filter On Load");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 11);
        ɵngcc0.ɵɵelementStart(22, "p-inputSwitch", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataListConfigComponent_Template_p_inputSwitch_ngModelChange_22_listener($event) { return ctx.preferences.showFilterOnLoad = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 9);
        ɵngcc0.ɵɵelementStart(24, "div", 10);
        ɵngcc0.ɵɵelementStart(25, "label");
        ɵngcc0.ɵɵtext(26, "Auto Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div", 11);
        ɵngcc0.ɵɵelementStart(28, "p-inputSwitch", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataListConfigComponent_Template_p_inputSwitch_ngModelChange_28_listener($event) { return ctx.preferences.autoFilter = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 14);
        ɵngcc0.ɵɵelementStart(30, "div", 15);
        ɵngcc0.ɵɵelementStart(31, "label");
        ɵngcc0.ɵɵtext(32, "Auto Filter Delay");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "div", 15);
        ɵngcc0.ɵɵelementStart(34, "input", 16);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataListConfigComponent_Template_input_ngModelChange_34_listener($event) { return ctx.preferences.autoFilterDelay = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(35, DwMetadataListConfigComponent_p_tabPanel_35_Template, 2, 3, "p-tabPanel", 17);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("activeIndex", ctx.tabIndex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("preferences", ctx.preferences)("configContext", ctx.configContext);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("configContext", ctx.configContext)("actionPreferencesByMode", ctx.preferences.actionPreferencesByMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("configContext", ctx.configContext)("filters", ctx.preferences.filters)("initialFilterKey", ctx.initialFilterKey);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.useFilterTiles);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.showFilterOnLoad);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.autoFilter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.preferences.autoFilter);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.autoFilterDelay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.preferences.useFilterTiles);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, DwCardConfigComponent, DwMetadataListActionsConfigComponent, DwMetadataConfigFiltersComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.NumberValueAccessor, ɵngcc3.DefaultValueAccessor, ɵngcc4.NgIf, DwMetadataFilterTilesConfigComponent]; }, styles: [""] });

class DwMetaDataListConfigWidgetComponent extends DwUiPanelWidgetBaseComponent {
    constructor(fb, dwEventService, dwModalService, dwUiConfigRegistryService, dwMetaDataService, dwContextService, dwDesignerStateService) {
        super(fb, dwDesignerStateService);
        this.dwEventService = dwEventService;
        this.dwModalService = dwModalService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextService = dwContextService;
        this.queries = [];
        this.dataSources = [];
        this.contextDefList = [];
        this.contextDefListWithMissing = [];
        this.setupDropdowns();
    }
    get listPreferences() {
        return this.preferences;
    }
    get listPreferencesHierarchy() {
        return this.preferencesHierarchy;
    }
    startConfigureSection(state) {
        this.configList(state);
    }
    setupDropdowns() {
        this.listStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.listStyles);
    }
    loadQueries() {
        var _a, _b;
        if (!((_b = (_a = this.listPreferencesHierarchy) === null || _a === void 0 ? void 0 : _a.itemMetaData) === null || _b === void 0 ? void 0 : _b.MetaDataItemId)) {
            return;
        }
        this.dwMetaDataService.getQueries(this.listPreferencesHierarchy.itemMetaData.MetaDataItemId)
            .subscribe(queries => this.queries = queries);
    }
    configSet() {
        if (!this.configKey)
            return;
        this.loadQueries();
        if (this.listPreferencesHierarchy) {
            this.dataSources = this.dwUiConfigRegistryService.getRegisteredDataSources(this.listPreferencesHierarchy.item);
        }
        this.setupContextNames();
    }
    setupContextNames() {
        var _a;
        this.contextDefinitions = this.dwContextService.contextDefinitions;
        for (let contextDef of this.contextDefinitions) {
            // Only add global item or one whose parent item matches
            if (contextDef.isGlobal) {
                this.contextDefList.push({
                    label: contextDef.contextDisplay,
                    value: contextDef.contextName
                });
            }
        }
        this.contextDefListWithMissing = [...this.contextDefList];
        if (!((_a = this.listPreferences) === null || _a === void 0 ? void 0 : _a.contextNames)) {
            return;
        }
        for (let contextName of this.listPreferences.contextNames) {
            if (!this.contextDefList.find(cd => cd.value == contextName)) {
                this.contextDefListWithMissing.push({
                    label: `${contextName} - Missing`,
                    value: contextName
                });
            }
        }
    }
    getContextDefDisplay(contextName) {
        const contextDef = this.contextDefinitions.find(cd => cd.contextName === contextName);
        if (contextDef) {
            return contextDef.contextDisplay;
        }
        return contextName;
    }
    setupEvents() {
    }
    createForm(fb) {
        return this.fb.group({
            showFilter: [null],
            showFilterOnLoad: [null],
            showHeader: [null],
            headerTitle: [null],
            autoFilter: [null],
            autoFilterDelay: [null],
            showDisplayProperties: [null],
            ignoreAttributes: [null],
            enableSorting: [null],
            useModal: [null],
            showActions: [null],
            hideRefresh: [null],
            hideViewToggle: [null],
            metaDataQueryMeaning: [null],
            listStyleName: [null],
            listClass: [null],
            cardItemClass: [null],
            listItemClass: [null],
            dataSourceName: [null],
            contextNames: [null],
            displayPageSize: [null],
            loadPageSize: [null],
            hideLoading: [null],
        });
    }
    onSubmit() {
        //console.log(this.configForm.value);
    }
    configFilters() {
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Configure Filters";
        modalConfig.component = DwMetadataConfigFiltersModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = '1200px';
        modalConfig.customModalHeight = '700px';
        modalConfig.data = {
            filters: this.preferences.filters,
            itemName: this.listPreferencesHierarchy.item
        };
        const inMemoryButton = {
            buttonText: 'In Memory update',
            buttonTitle: 'Use this to test settings',
            buttonClass: 'btn btn-warning',
            command: this.inMemoryUpdateCommand,
            buttonType: DwButtonType.standard,
            isCancel: false
        };
        modalConfig.buttons = [
            DwModalButtonStandardConfigs.instance.saveButton,
            inMemoryButton,
            DwModalButtonStandardConfigs.instance.cancelButton
        ];
        this.dwModalService.showModal(modalConfig)
            .subscribe(r => {
            if (!r.cancelled) {
                // Ensure there is a change befor updating
                if (areEqual(this.preferences.filters, r.data.filters))
                    return;
                this.preferences.filters = r.data.filters;
                if (r.buttonCommand == this.inMemoryUpdateCommand) {
                    this.preferencesChange.emit(this.preferences);
                }
                else {
                    this.preferenceChangeWithSave.emit(this.preferences);
                }
            }
        });
    }
    configList(state) {
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Configure List";
        modalConfig.component = DwMetadataListConfigComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = '1200px';
        modalConfig.customModalHeight = '700px';
        modalConfig.data = {
            preferences: this.preferences,
            itemName: this.listPreferencesHierarchy.item,
            designerState: state
        };
        const inMemoryButton = {
            buttonText: 'In Memory update',
            buttonTitle: 'Use this to test settings',
            buttonClass: 'btn btn-warning',
            command: this.inMemoryUpdateCommand,
            buttonType: DwButtonType.standard,
            isCancel: false
        };
        modalConfig.buttons = [
            DwModalButtonStandardConfigs.instance.saveButton,
            inMemoryButton,
            DwModalButtonStandardConfigs.instance.cancelButton
        ];
        this.dwModalService.showModal(modalConfig)
            .subscribe(r => {
            if (!r.cancelled) {
                // Ensure there is a change befor updating
                if (areEqual(this.preferences, r.data.preferences))
                    return;
                this.preferences = r.data.preferences;
                if (r.buttonCommand == this.inMemoryUpdateCommand) {
                    this.preferencesChange.emit(this.preferences);
                }
                else {
                    this.preferenceChangeWithSave.emit(this.preferences);
                }
            }
        });
    }
    updateFilters() {
        this.onFormChange();
    }
}
DwMetaDataListConfigWidgetComponent.ɵfac = function DwMetaDataListConfigWidgetComponent_Factory(t) { return new (t || DwMetaDataListConfigWidgetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService)); };
DwMetaDataListConfigWidgetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataListConfigWidgetComponent, selectors: [["dw-metadata-list-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 137, vars: 8, consts: [[3, "formGroup", "ngSubmit"], ["header", "Basic Settings"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "showHeader"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["formControlName", "headerTitle", 1, "form-control"], ["formControlName", "showDisplayProperties"], ["title", "Hides the loading icon", 1, "fa", "fa-info-circle"], ["formControlName", "hideLoading"], ["header", "Cards"], [1, "btn", "btn-success", 3, "click"], ["header", "Filtering"], ["formControlName", "showFilter"], ["formControlName", "showFilterOnLoad"], ["formControlName", "autoFilter"], ["dwCol", "6"], ["type", "number", "formControlName", "autoFilterDelay", 1, "form-control"], ["header", "Actions"], ["formControlName", "showActions"], ["formControlName", "hideRefresh"], ["formControlName", "hideViewToggle"], ["header", "Data Setup"], ["formControlName", "dataSourceName", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "metaDataQueryMeaning", 1, "form-control"], ["formControlName", "contextNames", "display", "chip", 3, "options"], ["pTemplate", "selectedItems"], ["title", "Number of cards dispalyed in each scroll attempt.  (This will vary depending on how many cards per row).", 1, "fa", "fa-info-circle"], ["type", "number", "dwNumeric", "", "formControlName", "displayPageSize", "placeholder", "50", 1, "form-control"], ["title", "Number of records loaded at a time.  Should be more than the display count.", 1, "fa", "fa-info-circle"], ["type", "number", "dwNumeric", "", "formControlName", "loadPageSize", "placeholder", "100", 1, "form-control"], ["header", "List Style"], ["formControlName", "listStyleName", 1, "form-control"], ["type", "text", "formControlName", "listClass", 1, "form-control"], ["type", "text", "formControlName", "cardItemClass", 1, "form-control"], ["type", "text", "formControlName", "listItemClass", 1, "form-control"], ["class", "btn btn-success btn-xs tag", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "btn", "btn-success", "btn-xs", "tag"]], template: function DwMetaDataListConfigWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h3");
        ɵngcc0.ɵɵtext(2, "List Preferences");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function DwMetaDataListConfigWidgetComponent_Template_form_ngSubmit_3_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(4, "p-accordion");
        ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 1);
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "label");
        ɵngcc0.ɵɵtext(9, "Show Header");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵelement(11, "p-inputSwitch", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 6);
        ɵngcc0.ɵɵelementStart(13, "div", 7);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Header Title");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 7);
        ɵngcc0.ɵɵelement(17, "input", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 2);
        ɵngcc0.ɵɵelementStart(19, "div", 3);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Show Display value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 4);
        ɵngcc0.ɵɵelement(23, "p-inputSwitch", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 2);
        ɵngcc0.ɵɵelementStart(25, "div", 3);
        ɵngcc0.ɵɵelementStart(26, "label");
        ɵngcc0.ɵɵtext(27, "Hide Loading ");
        ɵngcc0.ɵɵelement(28, "i", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 4);
        ɵngcc0.ɵɵelement(30, "p-inputSwitch", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "p-accordionTab", 12);
        ɵngcc0.ɵɵelementStart(32, "div", 2);
        ɵngcc0.ɵɵelementStart(33, "div", 7);
        ɵngcc0.ɵɵelementStart(34, "button", 13);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataListConfigWidgetComponent_Template_button_click_34_listener() { return ctx.configList(); });
        ɵngcc0.ɵɵtext(35, "Configure List");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "p-accordionTab", 14);
        ɵngcc0.ɵɵelementStart(37, "div", 2);
        ɵngcc0.ɵɵelementStart(38, "div", 3);
        ɵngcc0.ɵɵelementStart(39, "label");
        ɵngcc0.ɵɵtext(40, "Allow Filtering");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "div", 4);
        ɵngcc0.ɵɵelement(42, "p-inputSwitch", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "div", 2);
        ɵngcc0.ɵɵelementStart(44, "div", 3);
        ɵngcc0.ɵɵelementStart(45, "label");
        ɵngcc0.ɵɵtext(46, "Show Filter On Load");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "div", 4);
        ɵngcc0.ɵɵelement(48, "p-inputSwitch", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "div", 2);
        ɵngcc0.ɵɵelementStart(50, "div", 3);
        ɵngcc0.ɵɵelementStart(51, "label");
        ɵngcc0.ɵɵtext(52, "Auto Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "div", 4);
        ɵngcc0.ɵɵelement(54, "p-inputSwitch", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(55, "div", 2);
        ɵngcc0.ɵɵelementStart(56, "div", 18);
        ɵngcc0.ɵɵelementStart(57, "label");
        ɵngcc0.ɵɵtext(58, "Filter Delay");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(59, "div", 18);
        ɵngcc0.ɵɵelement(60, "input", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(61, "p-accordionTab", 20);
        ɵngcc0.ɵɵelementStart(62, "div", 2);
        ɵngcc0.ɵɵelementStart(63, "div", 3);
        ɵngcc0.ɵɵelementStart(64, "label");
        ɵngcc0.ɵɵtext(65, "Show Action bar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(66, "div", 4);
        ɵngcc0.ɵɵelement(67, "p-inputSwitch", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(68, "div", 2);
        ɵngcc0.ɵɵelementStart(69, "div", 3);
        ɵngcc0.ɵɵelementStart(70, "label");
        ɵngcc0.ɵɵtext(71, "Hide Refresh Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(72, "div", 4);
        ɵngcc0.ɵɵelement(73, "p-inputSwitch", 22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(74, "div", 2);
        ɵngcc0.ɵɵelementStart(75, "div", 3);
        ɵngcc0.ɵɵelementStart(76, "label");
        ɵngcc0.ɵɵtext(77, "Hide View Toggle");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(78, "div", 4);
        ɵngcc0.ɵɵelement(79, "p-inputSwitch", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(80, "p-accordionTab", 24);
        ɵngcc0.ɵɵelementStart(81, "div", 2);
        ɵngcc0.ɵɵelementStart(82, "div", 7);
        ɵngcc0.ɵɵelementStart(83, "label");
        ɵngcc0.ɵɵtext(84, "Data Source");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(85, "select", 25);
        ɵngcc0.ɵɵelementStart(86, "option", 26);
        ɵngcc0.ɵɵtext(87, "Default");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(88, DwMetaDataListConfigWidgetComponent_option_88_Template, 2, 2, "option", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(89, "div", 2);
        ɵngcc0.ɵɵelementStart(90, "div", 7);
        ɵngcc0.ɵɵelementStart(91, "label");
        ɵngcc0.ɵɵtext(92, "Query");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(93, "select", 28);
        ɵngcc0.ɵɵelementStart(94, "option", 26);
        ɵngcc0.ɵɵtext(95, " Default ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(96, DwMetaDataListConfigWidgetComponent_option_96_Template, 2, 2, "option", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(97, "div", 2);
        ɵngcc0.ɵɵelementStart(98, "div", 7);
        ɵngcc0.ɵɵelementStart(99, "label");
        ɵngcc0.ɵɵtext(100, "Context Data");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(101, "p-multiSelect", 29);
        ɵngcc0.ɵɵtemplate(102, DwMetaDataListConfigWidgetComponent_ng_template_102_Template, 2, 2, "ng-template", 30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(103, "div", 2);
        ɵngcc0.ɵɵelementStart(104, "div", 7);
        ɵngcc0.ɵɵelementStart(105, "label");
        ɵngcc0.ɵɵtext(106, "Display Page Size ");
        ɵngcc0.ɵɵelement(107, "i", 31);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(108, "input", 32);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(109, "div", 2);
        ɵngcc0.ɵɵelementStart(110, "div", 7);
        ɵngcc0.ɵɵelementStart(111, "label");
        ɵngcc0.ɵɵtext(112, "Load Page Size ");
        ɵngcc0.ɵɵelement(113, "i", 33);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(114, "input", 34);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(115, "p-accordionTab", 35);
        ɵngcc0.ɵɵelementStart(116, "div", 2);
        ɵngcc0.ɵɵelementStart(117, "div", 7);
        ɵngcc0.ɵɵelementStart(118, "label");
        ɵngcc0.ɵɵtext(119, "List Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(120, "select", 36);
        ɵngcc0.ɵɵtemplate(121, DwMetaDataListConfigWidgetComponent_option_121_Template, 2, 2, "option", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(122, "div", 2);
        ɵngcc0.ɵɵelementStart(123, "div", 7);
        ɵngcc0.ɵɵelementStart(124, "label");
        ɵngcc0.ɵɵtext(125, "List Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(126, "input", 37);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(127, "div", 2);
        ɵngcc0.ɵɵelementStart(128, "div", 7);
        ɵngcc0.ɵɵelementStart(129, "label");
        ɵngcc0.ɵɵtext(130, "Card Item Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(131, "input", 38);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(132, "div", 2);
        ɵngcc0.ɵɵelementStart(133, "div", 7);
        ɵngcc0.ɵɵelementStart(134, "label");
        ɵngcc0.ɵɵtext(135, "List Item Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(136, "input", 39);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formGroup", ctx.configForm);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("hidden", (ctx.configForm == null ? null : ctx.configForm.value == null ? null : ctx.configForm.value.showHeader) !== true);
        ɵngcc0.ɵɵadvance(74);
        ɵngcc0.ɵɵproperty("ngValue", null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dataSources);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngValue", null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.queries);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("options", ctx.contextDefListWithMissing);
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listStyles);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor, ɵngcc3.NumberValueAccessor, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, ɵngcc12.MultiSelect, ɵngcc6.PrimeTemplate, DwNumericDirective, ɵngcc4.NgIf], encapsulation: 2 });
DwMetaDataListConfigWidgetComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwEventService },
    { type: DwModalService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService },
    { type: DwDesignerStateService }
];

class DwMetadataListComponent extends DwUiConfigurableControlBase {
    constructor(metaDataListService, uiConfigService, dwEventService, dwMetaDataFilterService, dwMetaDataFilterStateService, dwSecurityService, dwActionExecutionService, dwConfigService) {
        super(uiConfigService, dwEventService, dwSecurityService, dwConfigService);
        this.metaDataListService = metaDataListService;
        this.dwMetaDataFilterService = dwMetaDataFilterService;
        this.dwMetaDataFilterStateService = dwMetaDataFilterStateService;
        this.dwSecurityService = dwSecurityService;
        this.dwActionExecutionService = dwActionExecutionService;
        this.configKeyPart = "";
        this.dataLoadComplete = new EventEmitter();
        this.cardClick = new EventEmitter();
    }
    setMessage(message) {
        this.message = message;
    }
    clearMessage() {
        this.message = null;
    }
    onDataLoadComplete(data) {
        this.dataLoadComplete.emit(data);
    }
    ngOnInit() {
        //console.log("DwMetaDataListComponent - Initial filters", this.filters);
        super.ngOnInit();
        // Watch for a data change event and update the grid data automatically
        this.subscriptions.push(this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(this.getItemName()))
            .subscribe((event) => {
            // Need to use a delay so that Angular can view the change (otherwise change events don't run on bound components)
            setTimeout(() => {
                this.refreshData();
            }, 5);
        }));
        this.subscriptions.push(this.dwMetaDataFilterStateService.stateChanged.subscribe(filterState => {
            // Set filters on the list once init is complete
            if (filterState.initComplete) {
                this.setFilters(filterState.filters);
                if (filterState.applyImmediately) {
                    this.setFilters(filterState.filters);
                }
            }
        }));
    }
    getItemName() {
        return this.item;
    }
    setFilters(filters) {
        this.filters = filters;
        setTimeout(() => {
            if (this.dwDataList) {
                this.dwDataList.filters = this.filters;
            }
        }, 5);
    }
    // #region Abstract Method implementation
    get configType() {
        return DwUiConfigType.list;
    }
    getConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}`;
        return `${itemName}-${this.configKeyPart}`;
    }
    setupConfig() {
        if (!this.item || !this.preferenceHierarchy)
            return;
        if (this.preferenceHierarchy.configType != DwUiConfigType.list) {
            // This should no longer happen, but keeping it here just in case
            return;
        }
        const newDataSource = this.metaDataListService.getDataSource(this.preferenceHierarchy);
        //if (!this.dataSource || !areEqual(this.getDataSourceItemName(this.dataSource.item), this.getDataSourceItemName(newDataSource.item)))
        if (this.isNewDataSource(newDataSource)) {
            this.dataSource = newDataSource;
        }
        this.config = this.metaDataListService.buildConfig(this.preferenceHierarchy);
        this.filters = this.dwMetaDataFilterService.buildInitialFilters(this.config.filters, null, null, null, this.filters, this.item, this.preferenceHierarchy.queryMetaData[0], this.config.resolvedContext);
        this.dwMetaDataFilterStateService.setFilters(this.filters, null, false, true);
        //this.dwMetaDataFilterStateService.setFilters(initFilters, filterTileKey, filterInitComplete, true);
        this.configContext = {
            itemName: this.item,
            contextNames: this.config.contextNames,
            metaDataQueryMeaning: this.config.metaDataQueryMeaning
        };
        this.actionContext = {
            itemName: this.item,
            metaDataQueryMeaning: this.config.metaDataQueryMeaning,
            metaDataListApi: this.getMetaDataListApi(),
        };
    }
    isNewDataSource(newDataSource) {
        if (!this.dataSource) {
            return true;
        }
        if (this.dataSource.length !== undefined) {
            return false;
        }
        if (!areEqual(this.dataSource.item, newDataSource.item)) {
            return true;
        }
        if (this.dataSource.uniqueIdentifier != newDataSource.uniqueIdentifier) {
            return true;
        }
        return false;
    }
    getMetaDataListApi() {
        return {
            getFilters: () => { var _a; return (_a = this.dwDataList) === null || _a === void 0 ? void 0 : _a.getFilters(); },
            applyFilters: (filters) => { var _a; return (_a = this.dwDataList) === null || _a === void 0 ? void 0 : _a.applyFilters(filters); },
            getMode: () => { var _a; return (_a = this.dwDataList) === null || _a === void 0 ? void 0 : _a.getMode(); },
            setMode: (mode) => { var _a; return (_a = this.dwDataList) === null || _a === void 0 ? void 0 : _a.setMode(mode); },
            refreshData: () => this.refreshData(),
            config: this.config,
            toggleFilter: () => this.dwDataList.toggleFilter(),
            item: this.item,
            cardContext: {},
        };
    }
    refreshData() {
        if (this.dwDataList) {
            this.dwDataList.refreshData();
        }
        const refreshEventData = {
            itemName: this.item,
            configKey: this.getConfigKey()
        };
        this.dwEventService.publishEvent(DwGridEvents.refreshData, refreshEventData);
    }
    setupCardComponent(componentInstance, data) {
        if (!componentInstance) {
            return;
        }
        componentInstance.cardConfig = this.config.cardComponentConfig;
        componentInstance.data = data;
        componentInstance.queryMetaData = this.preferenceHierarchy.queryMetaData[0];
        componentInstance.setupCard();
        componentInstance.cardClick.subscribe(data => {
            this.fireCardClickDefaultAction(data);
        });
    }
    setupNoItemsComponent(componentInstance, data) {
        if (!componentInstance) {
            return;
        }
        componentInstance.cardConfig = this.config.cardComponentConfig;
        componentInstance.data = data;
        componentInstance.queryMetaData = this.preferenceHierarchy.queryMetaData[0];
        if (componentInstance.setupCard) {
            componentInstance.setupCard();
        }
        if (componentInstance.cardClick) {
            componentInstance.cardClick.subscribe(data => {
                this.fireCardClickDefaultAction(data);
            });
        }
    }
    setupListComponent(componentInstance, data) {
        if (!componentInstance) {
            return;
        }
        componentInstance.cardConfig = this.config.listComponentConfig;
        componentInstance.data = data;
        componentInstance.setupCard();
        componentInstance.cardClick.subscribe(data => {
            this.fireCardClickDefaultAction(data);
        });
    }
    fireCardClickDefaultAction(data, event) {
        const cardActionPrefs = this.config.actionPreferencesByMode[DwListActionLocation.cardButton] || [];
        const cardActionPref = cardActionPrefs[0] || this.getDefaultAction();
        const actionEvent = {
            actionPreference: cardActionPref,
            dwBrowserEvent: getDwBrowserEvent(event),
            actionContext: this.actionContext,
        };
        if (cardActionPref) {
            this.actionPrefClicked(actionEvent, data);
        }
        this.cardClick.emit(data);
    }
    getDefaultAction() {
        return null;
    }
    loadPreferences() {
        return this.metaDataListService.getPreferencesHierarchy(this.item, this.getConfigKey(), this.allowConfiguration, this.preferences);
    }
    getPanelWidgetComponent() {
        return DwMetaDataListConfigWidgetComponent;
    }
    getDataSourceItemName(item) {
        if (typeof (item) === 'string') {
            return item;
        }
        if (('ItemDetail' in item)) {
            return item.ItemDetail.ItemName;
        }
        return item.RootTable;
    }
    actionPrefClicked(actionEvent, data) {
        const actionPref = actionEvent.actionPreference;
        let actionState = {
            actionConfig: actionPref.actionConfig,
            actionPreference: actionPref,
            item: this.item,
            listConfig: this.config,
            metaDataListApi: this.getMetaDataListApi(),
            data: data,
            context: this.config.resolvedContext,
            dwBrowserEvent: actionEvent.dwBrowserEvent
        };
        this.dwActionExecutionService.executeActionPreference(actionPref, actionState)
            .subscribe((actionResult) => {
            this.handleActionResult(actionResult);
        }, (error) => {
            this.handleActionError(actionPref, error);
        });
    }
    handleActionError(actionPref, error) {
        const message = error.message ? error.message : error.toString();
        this.setMessage({
            messageHeading: `Error executing action: ${actionPref.actionDisplay || actionPref.actionKey}`,
            messageBody: message,
            allowClose: true,
            timeToShow: 4000,
            severity: DwMessageSeverity.error
        });
    }
    handleActionResult(actionResult) {
        if (!actionResult || actionResult.cancelled) {
            return;
        }
        if (!actionResult.message) {
            actionResult.hideMessage = true;
            actionResult.message = '';
        }
        if (actionResult.refreshData) {
            this.refreshData();
        }
        // Failure with Message
        let messageToShow;
        if (typeof (actionResult.message) === "string") {
            messageToShow = {
                messageBody: actionResult.message,
                severity: actionResult.success ? DwMessageSeverity.success : DwMessageSeverity.error,
                allowClose: !actionResult.success,
                timeToShow: actionResult.success ? 5000 : null,
            };
        }
        else {
            messageToShow = actionResult.message;
        }
        ;
        if (!actionResult.hideMessage) {
            this.setMessage(messageToShow);
        }
        else {
            this.clearMessage();
        }
    }
}
DwMetadataListComponent.ɵfac = function DwMetadataListComponent_Factory(t) { return new (t || DwMetadataListComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataListService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwActionExecutionService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken)); };
DwMetadataListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataListComponent, selectors: [["dw-meta-data-list"]], viewQuery: function DwMetadataListComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c67, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwDataList = _t.first);
    } }, inputs: { configKeyPart: "configKeyPart", filters: "filters", dataSource: "dataSource", config: "config", item: "item" }, outputs: { dataLoadComplete: "dataLoadComplete", cardClick: "cardClick" }, features: [ɵngcc0.ɵɵProvidersFeature([DwMetaDataFilterStateService]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "click", 4, "ngIf"], [3, "click"], ["containerList", ""], [3, "message", "messageChange"], ["mode", "card", 3, "data", "filters", "config", "actionContext", "actionClick", "dataLoadComplete"], ["datalist", ""], ["filterTiles", "", 4, "ngIf"], ["filter", ""], [3, "configContext", "configKeyPart", "filterConfig", "filters", "filtersChange"], [4, "dwCardItem"], [4, "dwListItem"], [4, "dwNoItems"], [3, "target", "model", 4, "ngIf"], ["filterTiles", ""], [3, "configContext", "tilesConfig"], ["defaultComponentName", "dwCardDefault", 3, "componentName", "ngClass", "configure"], [4, "ngIf"], ["defaultComponentName", "dwCardDefault", 3, "componentName", "ngClass", "configure", 4, "ngIf"], [3, "target", "model"]], template: function DwMetadataListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataListComponent_div_0_Template, 13, 11, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.configSequenceComplete);
    } }, directives: function () { return [ɵngcc4.NgIf, DwActionHostComponent, DwMessageComponent, DwDataListComponent, DwMetadataFiltersComponent, DwCardItemDirective, DwListItemDirective, DwNoItemsDirective, DwMetadataFilterTilesComponent, DwDynamicLoaderComponent, ɵngcc4.NgClass, ɵngcc7.ContextMenu]; }, styles: [""] });
DwMetadataListComponent.ctorParameters = () => [
    { type: DwMetaDataListService },
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwMetaDataFilterService },
    { type: DwMetaDataFilterStateService },
    { type: DwSecurityUserService },
    { type: DwActionExecutionService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];
DwMetadataListComponent.propDecorators = {
    item: [{ type: Input }],
    filters: [{ type: Input }],
    configKeyPart: [{ type: Input }],
    dwDataList: [{ type: ViewChild, args: ['datalist',] }],
    dataLoadComplete: [{ type: Output }],
    config: [{ type: Input }],
    dataSource: [{ type: Input }],
    cardClick: [{ type: Output }]
};

class DwMetadataFiltersComponent {
    constructor(dwFilterService, dwFilterStateService, cdr, router, dwRoutingService) {
        this.dwFilterService = dwFilterService;
        this.dwFilterStateService = dwFilterStateService;
        this.cdr = cdr;
        this.router = router;
        this.dwRoutingService = dwRoutingService;
        this.componentInstances = [];
        // getConfigKeyPart() {
        //     if (this.configKeyPart)
        //         return `${this.configKeyPart}-filter`;
        //     return "filter";
        // }
        this.subscriptions = [];
        this.formData = {};
        this.previousParams = '';
        this.customFilterValues = [];
        this.dwRoutingService.getRoutesChanges().subscribe(() => {
            this.handleRouteParamChange();
        });
    }
    handleRouteParamChange() {
        const params = getUrlParameters(this.router);
        if (params) {
            const currentParams = JSON.stringify(params);
            if (currentParams == '{}') {
                return;
            }
            if (this.previousParams != currentParams) {
                this.previousParams = currentParams;
                // this._filters = {};
                this.formGroup = null;
                this.setupConfig();
            }
        }
    }
    ngOnInit() {
        this.setupConfig();
        this.subscriptions.push(this.dwFilterStateService.onClearFilters.subscribe(() => {
            this.clearFilters();
        }));
    }
    ngOnChanges(changes) {
        if (isFirstChange(changes)) {
            return;
        }
        if (changes.filterConfig || changes.sharedFilterExpression) {
            this.setupConfig(true);
        }
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    clearFilters() {
        // Clear custom filter values
        this.customFilterValues = [];
        // Reset the form group
        this.formGroup.reset();
        // Setup the form again (to reset up any defaults)
        this.setupConfig(true);
    }
    setupConfig(forceImmediate) {
        // this.configComplete = false;
        //this.dwFilterStateService.clearState();
        var _a;
        if (!((_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName) || !this.filterConfig) {
            return;
        }
        if (!this.formGroup) {
            this.createFormGroup();
        }
        // this.dwFilterStateService.state.filters;
        this.dwFilterService.buildFormFieldConfigs(this.configContext, this.filterConfig, this.dwFilterStateService.state.filters, this.formGroup)
            .subscribe(result => {
            this.customizeFormFieldConfig(result.fields);
            this.queryMetaData = result.queryMetaData;
            this.resolvedContext = result.resolvedContext;
            this.filterFieldConfigs = result.fields;
            this.customFilterValues = result.customFilterValues;
            //this.configComplete = true;
            const filters = this.dwFilterService.convertToFilters(this.queryMetaData, this.formGroup.value, this.customFilterValues, this.filterConfig, this.dwFilterStateService.state.filters, result.resolvedContext, this.sharedFilterExpression);
            this.dwFilterStateService.setFilters(filters, null, true, forceImmediate);
            // Clear force immediate after first time
            if (forceImmediate) {
                forceImmediate = false;
            }
            this.cdr.detectChanges();
            //this.filterSetupComplete.emit(this.filters);
        });
    }
    customizeFormFieldConfig(fields) {
        // Just leave this as an override (used in the verticle filter)
    }
    configFilterItemComponent(componentInstance, filterFieldConfig) {
        var _a;
        componentInstance.filterConfig = filterFieldConfig.filterConfig;
        componentInstance.item = (_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName;
        componentInstance.queryMetaData = this.queryMetaData;
        componentInstance.resolvedContext = this.resolvedContext;
        if (this.componentInstances.indexOf(componentInstance) < 0) {
            this.componentInstances.push(componentInstance);
        }
        this.subscriptions.push(componentInstance.filterChange.subscribe(filterValue => {
            let customFilterValue = this.customFilterValues.find(cfv => cfv.filterConfig == filterFieldConfig.filterConfig);
            if (!customFilterValue) {
                customFilterValue = {
                    filterConfig: filterFieldConfig.filterConfig,
                    filterValue: null
                };
                this.customFilterValues.push(customFilterValue);
            }
            customFilterValue.filterValue = filterValue;
            this.formDataChanged(this.formGroup.value);
        }));
        componentInstance.setupFilter();
    }
    createFormGroup() {
        this.formGroup = new FormGroup({});
        this.formGroup.valueChanges
            .subscribe(data => {
            if (!this.dwFilterStateService.state.initComplete) {
                return;
            }
            const filters = this.dwFilterService.convertToFilters(this.queryMetaData, this.formGroup.value, this.customFilterValues, this.filterConfig, this.dwFilterStateService.state.filters, this.resolvedContext, this.sharedFilterExpression);
            if (filters) {
                this.dwFilterStateService.setFilters(filters, null);
            }
            //this.filters = this.dwFilterService.convertToFilters(this.queryMetaData, data, this.customFilterValues, this.filterConfig, this.dwFilterStateService.state.filters);
        });
    }
    formDataChanged(data) {
        this.formData = data;
        setTimeout(() => {
            const filters = this.dwFilterService.convertToFilters(this.queryMetaData, data, this.customFilterValues, this.filterConfig, this.dwFilterStateService.state.filters, this.resolvedContext, this.sharedFilterExpression);
            if (filters) {
                this.dwFilterStateService.setFilters(filters, null);
            }
            //const filters = this.dwFilterService.convertToFilters(this.queryMetaData, this.formGroup.value, this.customFilterValues, this.filterConfig, this.dwFilterStateService.state.filters);
        }, 5);
    }
}
DwMetadataFiltersComponent.ɵfac = function DwMetadataFiltersComponent_Factory(t) { return new (t || DwMetadataFiltersComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwRoutingServiceToken)); };
DwMetadataFiltersComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFiltersComponent, selectors: [["dw-metadata-filters"]], inputs: { configKey: "configKey", viewKey: "viewKey", configContext: "configContext", filterConfig: "filterConfig", sharedFilterExpression: "sharedFilterExpression" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [["autocomplete", "off"], ["dwRow", "", 1, "filters"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["dwPageDesignerSelector", "", "detailKey", "filter", 3, "dwCol", "configKey", "sectionKey", "additionalInfo"], ["dwDynamicField", "", 3, "fieldDef", "formGroup", 4, "ngIf"], [3, "component", "configure", 4, "ngIf"], [1, "new-row"], ["dwDynamicField", "", 3, "fieldDef", "formGroup"], [3, "component", "configure"]], template: function DwMetadataFiltersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwMetadataFiltersComponent_ng_container_2_Template, 5, 7, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filterFieldConfigs);
    } }, directives: function () { return [DwRowDirective, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwDesignerSelector, DwColDirective, DwDynamicFieldComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDynamicLoaderComponent]; }, encapsulation: 2, changeDetection: 0 });
DwMetadataFiltersComponent.ctorParameters = () => [
    { type: DwMetaDataFilterService },
    { type: DwMetaDataFilterStateService },
    { type: ChangeDetectorRef },
    { type: Router },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] }
];
DwMetadataFiltersComponent.propDecorators = {
    configKey: [{ type: Input }],
    viewKey: [{ type: Input }],
    configContext: [{ type: Input }],
    filterConfig: [{ type: Input }],
    sharedFilterExpression: [{ type: Input }]
};

var __decorate$U = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$E = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMetadataConfigFiltersComponent {
    constructor(dwMetaDataService, uiMetaDataConfig, dwUiConfigRegistryService, cdr) {
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.cdr = cdr;
        this.filtersChange = new EventEmitter();
        this.showAdditionalTab = false;
        this.additionalTabHeading = 'Filter Settings';
        this.controlTypeLookupId = DevwareMetaDataLookups.MetaDataControlTypeAllItems;
        this.qh = new DwQueryHelper();
        this.defaultValueFormGroup = new FormGroup({});
        this.DEFAULT_VALUE_FIELD_NAME = 'defaultValue';
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Filter',
            displayField: 'filterDisplay',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Filter',
            showListActionBar: true,
            showAdditionalTab: this.showAdditionalTab,
            additionalTabHeading: this.additionalTabHeading
        };
        this.setupQueryMetaData();
        this.dwMetaDataService.getAttributeTypes()
            .subscribe(attributeTypes => {
            this.attributeTypes = attributeTypes;
        });
        this.componentList = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.filterItem, this.configContext.itemName);
        if (this.initialFilterKey) {
            this.selectedFilter = this.filters.find(f => f.filterDisplay == this.initialFilterKey);
            if (this.selectFilter) {
                this.listConfig.defaultConfigureTab = true;
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.itemName && !changes.itemName.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.configContext && !changes.configContext.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.filters && !changes.filters.firstChange) {
            this.setupQueryMetaData();
        }
    }
    setupQueryMetaData() {
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
            this.setupControl();
        });
    }
    setupControl() {
        this.selectedFilter = null;
        this.filters = this.filters || [];
        this.setAllFilterDisplays();
    }
    setAllFilterDisplays() {
        for (const filter of this.filters) {
            this.setFilterDisplay(filter);
        }
    }
    setFilterDisplay(filter) {
        filter.filterDisplay = this.getFilterDisplay(filter);
    }
    getFilterDisplay(filter) {
        if (filter.label) {
            return filter.label;
        }
        let queryAttr = this.getQueryAttribute(filter.attr);
        if (queryAttr) {
            return queryAttr.AttributeDisplay;
        }
        return filter.attr || filter.componentName || 'Unknown';
    }
    setSelectedFilter(filter) {
        this.selectedFilter = filter;
        if (this.selectedFilter.hasDefaultValue !== false && this.selectedFilter.defaultValue) {
            this.selectedFilter.hasDefaultValue = true;
        }
        this.filterConfigContext = Object.assign(Object.assign({}, this.configContext), { filterConfig: filter });
        if (!this.selectedFilter.componentName) {
            this.selectedFilter.componentName = null;
        }
        this.filterComponentChange(this.selectedFilter.componentName);
        this.setupSelectedFilterComponents();
        this.selectedFilterValueConfig = this.createFilterFieldConfig(this.selectedFilter);
        this.cdr.detectChanges();
    }
    onShowAsLookupChange() {
        this.setSelectedFilter(this.selectedFilter);
    }
    updateDefaultValue(value) {
        //console.log(`Updated default from ${this.selectedFilter.defaultValue} to ${value}`);
        this.selectedFilter.defaultValue = value;
    }
    setAdditionalConfig(additionalConfig) {
        this.selectedFilter.additionalConfig = additionalConfig;
        this.onFiltersChange();
    }
    selectFilter(eventArgs) {
        this.setSelectedFilter(eventArgs.value[0]);
    }
    onFiltersChange() {
        this.setAllFilterDisplays();
        this.filtersChange.emit(this.filters);
    }
    controlTypeOverrideChange() {
        this.selectedFilterValueConfig = this.createFilterFieldConfig(this.selectedFilter);
        this.onFiltersChange();
    }
    filterComponentChange(filterComponentKey, ignoreChange = false) {
        var _a, _b, _c, _d;
        const filterComponent = this.componentList.find(c => c.key === filterComponentKey);
        if (((_b = (_a = this.selectedFilterComponent) === null || _a === void 0 ? void 0 : _a.configData) === null || _b === void 0 ? void 0 : _b.defaultValueControlType) != ((_c = filterComponent === null || filterComponent === void 0 ? void 0 : filterComponent.configData) === null || _c === void 0 ? void 0 : _c.defaultValueControlType)) {
            // this.selectedFilter.defaultValue = null;
        }
        this.selectedFilterComponent = filterComponent;
        this.selectedComponentConfig = (_d = this.selectedFilterComponent) === null || _d === void 0 ? void 0 : _d.configComponent;
        // Clear the default value (since it is not relavant now)
        if (!ignoreChange) {
            this.selectedFilterValueConfig = this.createFilterFieldConfig(this.selectedFilter);
        }
    }
    filterRequiresValue(filterType) {
        return this.qh.filterTypeRequiresValue(filterType);
    }
    createFilterFieldConfig(filter) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!filter || (!filter.attr && !filter.componentName)) {
            return null;
        }
        this.filterComponentChange(filter.componentName, true);
        let queryAttr = this.getQueryAttribute(filter.attr);
        let attr;
        let attrControlType;
        let attrType;
        let controlAttrType;
        // Do a deep copy so the attribute is copied as well
        this.selectedAttr = deepCopy(queryAttr);
        if (!queryAttr) {
            if (!filter.componentName) {
                return null;
            }
            const compRef = this.componentList.find(cl => cl.key === filter.componentName);
            const configData = compRef.configData || {};
            // Just assume its a text type if not specified
            if (Array.isArray(configData.attrType)) {
                // Just use the first attribute type in this case
                attrType = configData.attrType[0] || DwAttributeType.Text;
            }
            else {
                attrType = configData.attrType || DwAttributeType.Text;
            }
            attrControlType = this.getDefaultControlType(attrType, false);
        }
        else {
            attr = queryAttr.Attribute;
            attrControlType = attr.MetaDataControlTypeId;
            attrType = queryAttr.AttributeType;
        }
        this.dwFormFieldContext = {
            formFieldPreference: {
                attrName: queryAttr === null || queryAttr === void 0 ? void 0 : queryAttr.AttributeName
            },
            itemName: (_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName,
            metaDataQueryMeaning: (_b = this.configContext) === null || _b === void 0 ? void 0 : _b.metaDataQueryMeaning,
            contextNames: (_c = this.configContext) === null || _c === void 0 ? void 0 : _c.contextNames,
            queryAttr: queryAttr
        };
        let isLookup = attr === null || attr === void 0 ? void 0 : attr.IsLookup;
        if (filter.showAsLookup === false || filter.showAsLookup === true) {
            isLookup = filter.showAsLookup;
        }
        this.showLookupConfig = isLookup;
        // find comparer since this can also modify the type of control used
        const comparerType = this.getComparerType(attrType, filter.filterType, isLookup);
        controlAttrType = attrType;
        if (comparerType && comparerType.AltFirstValueAttributeTypeId) {
            controlAttrType = convertToAttributeType(comparerType.AltFirstValueAttributeTypeId);
            attrControlType = this.getDefaultControlType(controlAttrType, isLookup);
        }
        // Build compares on the true attribute type
        this.selectedComparers = this.getValidComparers(attrType, isLookup);
        // Build control types based on the modified attribute type 
        //  Note: This is because some filters, such as greater than days are for a date/time type, but require an integer value
        this.selectedControlTypes = this.getValidControlTypes(controlAttrType, isLookup);
        if (attr) {
            const fieldConfig = new DwFormFieldConfig();
            fieldConfig.attr = attr;
            fieldConfig.attrName = filter.attr;
            fieldConfig.controlType = filter.controlTypeOverride || attrControlType;
            fieldConfig.hideLabel = true;
            fieldConfig.controlOptions = filter.controlOptions;
            // Ensure that the control type is valid for the attribute type
            if (!this.selectedControlTypes.find(ct => ct.MetaDataControlTypeId == fieldConfig.controlType)) {
                fieldConfig.controlType = attrControlType;
            }
            if ((_e = (_d = this.selectedFilterComponent) === null || _d === void 0 ? void 0 : _d.configData) === null || _e === void 0 ? void 0 : _e.defaultValueControlType) {
                fieldConfig.controlType = this.selectedFilterComponent.configData.defaultValueControlType;
            }
            if (fieldConfig.controlType == DwControlType.Checkbox) {
                fieldConfig.controlType = DwControlType.YesNoDropDown;
            }
            this.selectedAttr.AttributeType = controlAttrType;
            this.selectedAttr.Attribute.MetaDataControlTypeId = fieldConfig.controlType;
            // Create default lookup value attribute
            this.selectedDefaultValueAttr = deepCopy(this.selectedAttr);
            // Override the attribute lookup info so it's the same as the final filter
            if (isLookup && this.selectedDefaultValueAttr.Attribute) {
                this.selectedDefaultValueAttr.Attribute.IsLookup = true;
                this.selectedDefaultValueAttr.Attribute.MetaDataLookupId = ((_g = (_f = this.selectedFilter.lookupConfig) === null || _f === void 0 ? void 0 : _f.lookupIdOverride) === null || _g === void 0 ? void 0 : _g.value) || ((_j = (_h = this.selectedAttr) === null || _h === void 0 ? void 0 : _h.Attribute) === null || _j === void 0 ? void 0 : _j.MetaDataLookupId);
            }
            this.setupCurrentDefaultValueCV(filter);
            // Setup field control options
            this.setupFieldControlOptions(attrControlType);
            return fieldConfig;
        }
    }
    setupCurrentDefaultValueCV(filter) {
        if (this.defaultValueSubscription) {
            this.defaultValueSubscription.unsubscribe();
        }
        let fc = this.defaultValueFormGroup.get(filter.attr);
        if (fc == null) {
            fc = new FormControl();
            this.defaultValueFormGroup.addControl(filter.attr, fc);
        }
        fc.setValue(filter.defaultValue);
        this.defaultValueSubscription = fc.valueChanges.subscribe(value => {
            filter.defaultValue = value;
            this.onFiltersChange();
        });
    }
    setupFieldControlOptions(controlType) {
        /*  if (!queryAttr) {
             return;
         } */
        this.controlOptionsControlType = controlType;
        this.controlOptionsComponentType = this.uiMetaDataConfig.controlConfigComponents[controlType];
        if (this.controlOptionsComponentInstance) {
            this.configureFieldControlOptionInstance(this.controlOptionsComponentInstance);
        }
    }
    setupSelectedFilterComponents() {
        this.selectedFilterComponentList = [];
        if (!this.selectedFilter) {
            return;
        }
        this.selectedFilterComponentList = this.componentList.filter(comp => {
            const configData = comp.configData || {};
            return (this.selectedFilter.attr && configData.allowAttr) || (!this.selectedFilter.attr && !configData.allowAttr);
        });
    }
    getQueryAttribute(attrName) {
        if (!attrName) {
            return;
        }
        return this.queryMetaData.Attributes.find(attr => attr.AttributeName.toUpperCase() == attrName.toUpperCase());
    }
    getAttributeType(attributeType, isLookup) {
        // Enum string value code change - This used to be a pure numeric compare
        let attrType = this.attributeTypes.find(at => convertToAttributeType(at.MetaDataAttributeTypeId) == attributeType);
        // If it's a lookup, we override the attr type so we list valid compare types and control types
        if (isLookup) {
            attrType = this.attributeTypes.find(at => at.AttributeTypeName == 'Lookup');
        }
        if (!attrType) {
            throw new Error(`Attribute Type Id ${attributeType} not found!`);
        }
        return attrType;
    }
    getComparerType(attributeType, comparerType, isLookup) {
        const attrType = this.getAttributeType(attributeType, isLookup);
        return attrType.DwMetaDataAttributeTypeComparerMap.map(cm => cm.DwMetaDataComparer).find(comparer => comparer.ComparerMeaning == comparerType);
    }
    getDefaultControlType(attributeType, isLookup) {
        const attrType = this.getAttributeType(attributeType, isLookup);
        const controlTypeMap = attrType.DwMetaDataAttributeTypeControlTypeMap.find(attrMap => attrMap.IsDefault);
        if (controlTypeMap) {
            return controlTypeMap.MetaDataControlTypeId;
        }
    }
    getValidComparers(attributeType, isLookup) {
        const attrType = this.getAttributeType(attributeType, isLookup);
        const comparers = attrType.DwMetaDataAttributeTypeComparerMap.map(cm => cm.DwMetaDataComparer);
        return comparers;
    }
    getValidControlTypes(attributeType, isLookup) {
        const attrType = this.getAttributeType(attributeType, isLookup);
        return attrType.DwMetaDataAttributeTypeControlTypeMap.map(cm => cm.DwMetaDataControlType);
    }
    configureFieldControlOptionInstance(componentInstance) {
        this.controlOptionsComponentInstance = componentInstance;
        // unsubscribe to the previous compnoent instance
        if (this.controlOptionsComponentSubscription) {
            this.controlOptionsComponentSubscription.unsubscribe();
        }
        let queryAttr = this.getQueryAttribute(this.selectedFilter.attr);
        if (this.controlOptionsComponentInstance) {
            this.controlOptionsComponentInstance.controlOptions = this.selectedFilter.controlOptions;
            this.controlOptionsComponentInstance.itemName = this.configContext.itemName;
            // Need to convert out filter config to a field config instance (this is only used to determine the final control type and is not modified)
            const fieldConfig = {};
            fieldConfig.controlTypeOverride = this.controlOptionsControlType;
            this.controlOptionsComponentInstance.fieldConfig = fieldConfig;
            if (queryAttr) {
                this.controlOptionsComponentInstance.attribute = queryAttr.Attribute;
            }
            this.controlOptionsComponentInstance.setupControl();
            this.controlOptionsComponentSubscription =
                this.controlOptionsComponentInstance.controlOptionsChange.subscribe(controlOptions => {
                    this.selectedFilter.controlOptions = controlOptions;
                    this.onFiltersChange();
                });
        }
    }
    addItem(queryAttr) {
        const newFilter = {
            attr: queryAttr.AttributeName,
            filterType: DwFilterType.Equal,
            showFilter: true,
        };
        this.filters = [...this.filters, newFilter];
        this.onFiltersChange();
    }
    reorderList() {
        this.onFiltersChange();
    }
    addComponentFilter(componentItem) {
        const newFilter = {
            attr: null,
            filterType: DwFilterType.Equal,
            showFilter: true,
            componentName: componentItem.key,
            label: componentItem.name
        };
        this.filters = [...this.filters, newFilter];
        this.onFiltersChange();
    }
    removeItem(item) {
        const index = this.filters.indexOf(item);
        if (this.selectedFilter) {
            if (this.filters.indexOf(this.selectedFilter) == index) {
                this.selectedFilter = null;
            }
        }
        if (index >= 0)
            this.filters.splice(index, 1);
        this.onFiltersChange();
    }
    removeAll() {
        this.filters = [];
        this.onFiltersChange();
    }
}
DwMetadataConfigFiltersComponent.ɵfac = function DwMetadataConfigFiltersComponent_Factory(t) { return new (t || DwMetadataConfigFiltersComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwMetadataConfigFiltersComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataConfigFiltersComponent, selectors: [["dw-metadata-config-filters"]], inputs: { showAdditionalTab: "showAdditionalTab", additionalTabHeading: "additionalTabHeading", filters: "filters", configContext: "configContext", initialFilterKey: "initialFilterKey" }, outputs: { filtersChange: "filtersChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c69, decls: 14, vars: 7, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], ["header", "Field Filters", 3, "selected"], ["addTooltip", "Add Filter", 3, "attributes", "attributeClick"], ["header", "Other Filters"], ["class", "dw-field-item", 4, "ngFor", "ngForOf"], ["actionBar", ""], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], [4, "ngIf"], ["additionalTab", ""], [1, "dw-field-item"], ["class", "btn btn-sm btn-success", 3, "click", 4, "ngIf"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add Filter", 1, "fa", "fa-plus-circle", "hand"], ["header", "Basic Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 3, "hidden"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Overrides using the attribute name to populate default values", 1, "fa", "fa-info-circle"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["header", "Default Value", 4, "ngIf"], ["header", "Filter Settings", 3, "hidden"], [3, "component", "config", "configContext", "configChange"], ["header", "Filter Layout"], ["header", "Control Overrides", 3, "hidden"], ["nullDisplay", "From Attribute", 3, "ngModel", "allowNull", "ngModelChange"], [3, "ngValue"], [3, "config", "configContext", "configChange", 4, "ngIf"], ["header", "Control Settings", 3, "hidden", 4, "ngIf"], ["header", "Default Value"], [3, "defaultValue", "contextNames", "queryAttribute", "defaultValueChange"], [3, "config", "configContext", "configChange"], ["header", "Control Settings", 3, "hidden"], [3, "component", "configure"]], template: function DwMetadataConfigFiltersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c68);
        ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 0);
        ɵngcc0.ɵɵlistener("selectedItemChange", function DwMetadataConfigFiltersComponent_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { return ctx.setSelectedFilter($event); })("removeItem", function DwMetadataConfigFiltersComponent_Template_dw_ui_config_list_removeItem_0_listener($event) { return ctx.removeItem($event); })("reorder", function DwMetadataConfigFiltersComponent_Template_dw_ui_config_list_reorder_0_listener() { return ctx.reorderList(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p-accordion");
        ɵngcc0.ɵɵelementStart(3, "p-accordionTab", 2);
        ɵngcc0.ɵɵelementStart(4, "dw-field-selection", 3);
        ɵngcc0.ɵɵlistener("attributeClick", function DwMetadataConfigFiltersComponent_Template_dw_field_selection_attributeClick_4_listener($event) { return ctx.addItem($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 4);
        ɵngcc0.ɵɵtemplate(6, DwMetadataConfigFiltersComponent_div_6_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵelementStart(8, "button", 7);
        ɵngcc0.ɵɵlistener("click", function DwMetadataConfigFiltersComponent_Template_button_click_8_listener() { return ctx.removeAll(); });
        ɵngcc0.ɵɵtext(9, "Remove All");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 8);
        ɵngcc0.ɵɵtemplate(11, DwMetadataConfigFiltersComponent_p_accordion_11_Template, 68, 29, "p-accordion", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵprojection(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.filters)("config", ctx.listConfig)("selectedItem", ctx.selectedFilter);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("attributes", ctx.queryMetaData == null ? null : ctx.queryMetaData.Attributes);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.componentList);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedFilter);
    } }, directives: function () { return [DwUiConfigListComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwFieldSelectionComponent, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, DwUiChildConfigHostComponent, DwYesNoComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDefaultValueComponent, DwSelectLookupConfigComponent, DwDynamicLoaderComponent]; }, encapsulation: 2 });
DwMetadataConfigFiltersComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: ChangeDetectorRef }
];
DwMetadataConfigFiltersComponent.propDecorators = {
    configContext: [{ type: Input }],
    filters: [{ type: Input }],
    filtersChange: [{ type: Output }],
    showAdditionalTab: [{ type: Input }],
    additionalTabHeading: [{ type: Input }],
    initialFilterKey: [{ type: Input }]
};
__decorate$U([
    DwInputConverter(booleanConverter),
    __metadata$E("design:type", Boolean)
], DwMetadataConfigFiltersComponent.prototype, "showAdditionalTab", void 0);

var __decorate$V = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$F = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwSelectLookupComponent extends DwControlBaseComponent {
    constructor(dwMetaDataService, dwEventService, dwSecurityService, cdr, dwMetaDataRoutingService, dwLookupParameterUtilService, route, uiMetaDataConfig) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.dwEventService = dwEventService;
        this.dwSecurityService = dwSecurityService;
        this.cdr = cdr;
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
        this.dwLookupParameterUtilService = dwLookupParameterUtilService;
        this.route = route;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.showBlankOption = true;
        this.blankOptionText = "";
        this.valueAttrName = "Id";
        this.useTransitions = true;
        this.useServerSearch = false;
        this.useServerSearchParams = true;
        this.additionalDataField = "";
        this.lookupDefMissing = false;
        DwSelectLookupComponent.instance_count += 1;
        this.instanceId = DwSelectLookupComponent.instance_count;
    }
    get paramValues() {
        return this._paramValues;
    }
    set paramValues(value) {
        this._paramValues = value;
        this.loadLookup();
    }
    getLookupItemKeyFuntion(lookupDefinition) {
        return (item) => {
            return this.getLookupItemKey(item, lookupDefinition);
        };
    }
    getLookupItemKey(item, lookupDefinition) {
        return item.Id;
    }
    ngOnInit() {
        this.setupLookup();
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.paramValues) {
            // Re-load the lookup anytime the param values change
            this.loadLookup();
        }
        if (simpleChanges.lookupId && !simpleChanges.lookupId.firstChange) {
            this.lookupDef = null;
            this.lastParams = null;
            this.setupLookup();
        }
        if (simpleChanges.overrideValues) {
            this.setupLookup();
        }
    }
    openItem(event) {
        var _a;
        if (!this.value) {
            return;
        }
        const keyValue = this.value;
        const browserEvent = getDwBrowserEvent(event);
        const windowOptions = getWindowOpenOptions(browserEvent, (_a = this.options) === null || _a === void 0 ? void 0 : _a.windowOpenOptions);
        if (this.lookupDef) {
            this.dwMetaDataRoutingService.routeToEditOrViewWithKey(this.route, this.lookupDef.UniqueItemName, keyValue, DwMenuActionType.edit, windowOptions);
            return;
        }
        this.subscriptions.push(this.dwMetaDataService.getLookupDefinition(this.lookupId)
            .subscribe(lookupDef => {
            this.lookupDef = lookupDef;
            this.dwMetaDataRoutingService.routeToEditOrViewWithKey(this.route, this.lookupDef.UniqueItemName, keyValue, DwMenuActionType.edit, windowOptions);
        }));
    }
    writeValue(value) {
        super.writeValue(value);
        // When this value is written, update the transition items
        this.setupTransitions();
    }
    getAdditionalFieldDisplay() {
        if (!this.lookupItems || !this.value || !this.additionalDataField) {
            return "";
        }
        var lookupItem = findWhere(this.lookupItems, { Id: this.value.toString() });
        if (lookupItem) {
            return lookupItem[this.additionalDataField];
        }
    }
    setupLookup() {
        if (!this.lookupId && !this.overrideValues)
            return;
        if (this.lookupDef || this.overrideValues) {
            this.loadLookup();
            return;
        }
        this.subscriptions.push(this.dwMetaDataService.getLookupDefinition(this.lookupId)
            .subscribe(lookupDef => {
            this.lookupErorMessage = '';
            if (!lookupDef) {
                this.lookupDefMissing = true;
                this.lookupErorMessage = `Lookup Def ${this.lookupId} not found`;
            }
            this.lookupDef = lookupDef;
            this.loadLookup();
        }));
        // Listen for events that this lookup has changed
        this.subscriptions.push(this.dwEventService.getEvent(DwMetaDataService.META_DATA_EVENT_TOPICS.LookupChanged(this.lookupId))
            .subscribe(e => {
            this.loadLookup(true);
        }));
    }
    lookupParamsChanged() {
    }
    loadLookup(forceReload = false) {
        if (this.overrideValues) {
            this.setupLookupItems(this.overrideValues);
            return;
        }
        if (!this.lookupDef) {
            return;
        }
        //let params = this.getQueryParams();
        let params = this.dwLookupParameterUtilService.getQueryParams(this.lookupDef, this.paramValues);
        if (!params) {
            // Attempting to clear out the lookup items if its not found - 8-15-2023
            this.setupLookupItems([]);
            this.setCurrentLookup(null);
            return;
        }
        if (areEqual(this.lastParams, params) && !forceReload) {
            return;
        }
        // TODO: Remove - added in feature areas branch, but was a blank function
        //this.parametersChanged();
        this.lastParams = deepCopy(params);
        this.lookupParamsChanged();
        if (this.useServerSearch) {
            if (this.value) {
                // Only load the selected value
                this.subscriptions.push(this.dwMetaDataService.getSingleLookupItem(this.lookupId, this.value, this.useServerSearchParams, params)
                    .subscribe(item => {
                    var items = item ? [item] : [];
                    this.setupLookupItems(items);
                }));
            }
            return;
        }
        this.subscriptions.push(this.dwMetaDataService.getLookup(this.lookupId, params)
            .subscribe((lookupItems) => {
            this.setupLookupItems(lookupItems);
        }));
    }
    /* Moved toe DwLookupUtilService */
    // protected getQueryParams(): DwQueryParam[] {
    //     let params: DwQueryParam[] = [];
    //     if (!this.lookupDef) {
    //         return;
    //     }
    //     if (this.lookupDef.DwMetaDataLookupParam && this.lookupDef.DwMetaDataLookupParam.length > 0) {
    //         if (!this.paramValues) {
    //             // console.warn(`dwSelectLookup - loadLookup ${this.lookupDef.LookupId} - paramValues not set.  Waiting to re-load when we do!`);
    //             this.setupLookupItems([]);
    //             return null;
    //         }
    //         let index = 0;
    //         for (let lookupParamDef of this.lookupDef.DwMetaDataLookupParam) {
    //             const lookupParam = new DwQueryParam();
    //             lookupParam.ParamName = lookupParamDef.UseAttribute ? lookupParamDef.AttributeName : lookupParamDef.ParamNameOverride;
    //             if (Array.isArray(this.paramValues)) {
    //                 lookupParam.ParamValue = this.paramValues[index];
    //             } else {
    //                 lookupParam.ParamValue = this.paramValues[lookupParamDef.AttributeName];
    //             }
    //             if (!lookupParam.ParamValue && !lookupParamDef.DefaultValue && lookupParamDef.IsRequired) {
    //                 //console.warn(`dwSelectLookup - loadLookup ${this.lookupDef.MetaDataLookupId} - Param Value ${lookupParamDef.AttributeName} doesn't have a passed in value.  Waiting to re-load when we do!`);
    //                 this.setupLookupItems([]);
    //                 return null;
    //             }
    //             params.push(lookupParam);
    //             index++;
    //         }
    //     }
    //     return params;
    // }
    setupLookupItems(lookupItems) {
        this.allLookupItems = lookupItems;
        if (this.lookupDef && this.lookupDef.HasTransitions && this.useTransitions && this.lookupDef.DwMetaDataLookupTransition && this.lookupDef.DwMetaDataLookupTransition.length > 0) {
            this.setupTransitions();
        }
        else {
            this.lookupItems = lookupItems;
        }
        this.lookupLoadComplete();
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
    }
    setupTransitions() {
        if (!this.lookupDef || !this.allLookupItems) {
            return;
        }
        if (this.lookupDef.HasTransitions && this.useTransitions && this.lookupDef.DwMetaDataLookupTransition && this.lookupDef.DwMetaDataLookupTransition.length > 0) {
            const limitedLookupItems = [];
            let defaultLookupItem;
            for (let transition of this.lookupDef.DwMetaDataLookupTransition) {
                if (this.areLookupValuesEqual(transition.TransitionFromValue, this.value)) {
                    // From value matches
                    if (!transition.CanTransitionPermission || this.dwSecurityService.hasPermission(transition.CanTransitionPermission, true)) {
                        // Add lookup
                        const lookupItem = this.addLookupValue(limitedLookupItems, transition.TransitionToValue);
                        if (lookupItem) {
                            // Add transition as a reference
                            lookupItem.Transition = transition;
                        }
                        if (transition.IsDefault) {
                            defaultLookupItem = lookupItem;
                        }
                    }
                }
            }
            if (this.value) {
                this.addLookupValue(limitedLookupItems, this.value, true);
            }
            else {
                if (defaultLookupItem) {
                    // Set the default transition value
                    const currentValue = defaultLookupItem[this.valueAttrName];
                    this.setTranslatedValue(currentValue);
                }
            }
            this.lookupItems = limitedLookupItems;
            // Update this after updating transition items
            this.lookupLoadComplete();
        }
    }
    setTranslatedValue(newValue) {
        super.setTranslatedValue(newValue);
        // this.setCurrentLookup(newValue);
    }
    setValue(value) {
        super.setValue(value);
        this.setCurrentLookup(value);
    }
    setCurrentLookup(value) {
        if (!this.lookupItems || !value) {
            this.currentLookup = null;
            return false;
        }
        this.currentLookup = findWhere(this.lookupItems, { Id: value.toString() });
        if (!this.currentLookup && this.allLookupItems) {
            this.currentLookup = findWhere(this.allLookupItems, { Id: value.toString() });
        }
        if (this.currentLookup) {
            return true;
        }
        return false;
    }
    addLookupValue(list, value, addAtStart = false) {
        if (!value) {
            return;
        }
        var lookupItem = this.allLookupItems.find(li => li.Id == value.toString());
        if (lookupItem) {
            // Only add items once (even if the workflow transitions have it multiple times)
            if (list.indexOf(lookupItem) < 0) {
                if (addAtStart) {
                    list.splice(0, 0, lookupItem);
                }
                else {
                    list.push(lookupItem);
                }
            }
        }
        return lookupItem;
    }
    areLookupValuesEqual(value1, value2) {
        if (!value2) {
            if (!value1 || value1 === '') {
                return true;
            }
        }
        if (value1 == value2) {
            return true;
        }
        if (parseInt(value1) == parseInt(value2)) {
            return true;
        }
        return false;
    }
    lookupLoadComplete() {
        this.setCurrentLookup(this.value);
    }
    // Just set the current lookup
    translateTo(value) {
        if (value) {
            this.setCurrentLookup(value);
        }
        else {
            this.currentLookup = null;
        }
        return value;
    }
    translateFrom(value) {
        let finalValue = parseInt(value);
        if (isNaN(finalValue)) {
            finalValue = value;
        }
        return super.translateFrom(finalValue);
    }
}
DwSelectLookupComponent.ɵfac = function DwSelectLookupComponent_Factory(t) { return new (t || DwSelectLookupComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService), ɵngcc0.ɵɵdirectiveInject(DwLookupParameterUtilService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken)); };
DwSelectLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSelectLookupComponent, selectors: [["dw-select-lookup"]], inputs: { showBlankOption: "showBlankOption", blankOptionText: "blankOptionText", valueAttrName: "valueAttrName", useTransitions: "useTransitions", useServerSearch: "useServerSearch", useServerSearchParams: "useServerSearchParams", additionalDataField: "additionalDataField", paramValues: "paramValues", lookupDef: "lookupDef", lookupId: "lookupId", overrideValues: "overrideValues", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwSelectLookupComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 5, vars: 7, consts: [[1, "form-control", 3, "ngModel", "disabled", "ngModelChange"], ["value", "", 4, "ngIf"], [3, "value", 4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], ["value", ""], [3, "value"]], template: function DwSelectLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "select", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSelectLookupComponent_Template_select_ngModelChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵtemplate(1, DwSelectLookupComponent_option_1_Template, 2, 1, "option", 1);
        ɵngcc0.ɵɵtemplate(2, DwSelectLookupComponent_option_2_Template, 2, 2, "option", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwSelectLookupComponent_span_3_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵtext(4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.translatedValue)("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showBlankOption);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.lookupItems)("ngForTrackBy", ctx.getLookupItemKeyFuntion(ctx.lookupDef));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.additionalDataField);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, directives: [ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2, changeDetection: 0 });
DwSelectLookupComponent.instance_count = 0;
DwSelectLookupComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwEventService },
    { type: DwSecurityUserService },
    { type: ChangeDetectorRef },
    { type: DwMetaDataRoutingService },
    { type: DwLookupParameterUtilService },
    { type: ActivatedRoute },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwSelectLookupComponent.propDecorators = {
    lookupId: [{ type: Input }],
    showBlankOption: [{ type: Input }],
    blankOptionText: [{ type: Input }],
    overrideValues: [{ type: Input }],
    valueAttrName: [{ type: Input }],
    useTransitions: [{ type: Input }],
    useServerSearch: [{ type: Input }],
    useServerSearchParams: [{ type: Input }],
    additionalDataField: [{ type: Input }],
    options: [{ type: Input }],
    paramValues: [{ type: Input }],
    lookupDef: [{ type: Input }]
};
__decorate$V([
    DwInputConverter(booleanConverter),
    __metadata$F("design:type", Boolean)
], DwSelectLookupComponent.prototype, "showBlankOption", void 0);
__decorate$V([
    DwInputConverter(booleanConverter),
    __metadata$F("design:type", Boolean)
], DwSelectLookupComponent.prototype, "useTransitions", void 0);
__decorate$V([
    DwInputConverter(booleanConverter),
    __metadata$F("design:type", Boolean)
], DwSelectLookupComponent.prototype, "useServerSearch", void 0);
__decorate$V([
    DwInputConverter(booleanConverter),
    __metadata$F("design:type", Boolean)
], DwSelectLookupComponent.prototype, "useServerSearchParams", void 0);

var __decorate$W = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$G = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMdSectionStandardConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb, dwStyleManagerService) {
        super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
        this.dwStyleManagerService = dwStyleManagerService;
        this.formSetup = false;
        this.columnConfigSetup = false;
        this.formGroup = new FormGroup({});
        this.showReadOnlySection = true;
        this.showColumnConfig = true;
    }
    ngOnInit() {
        this.setupForm();
        this.itemName = this.getParentItemName();
        this.setupDropdowns();
    }
    get columnPreferences() {
        return this.formGroup.get("columnPreferences");
    }
    get columnDetails() {
        if (this.columnPreferences) {
            let columnDetailsFG = this.columnPreferences.get("columnDetails");
            return columnDetailsFG;
        }
        return null;
    }
    get columnsFormControl() {
        if (this.columnPreferences) {
            return this.columnPreferences.get("columns");
        }
        return null;
    }
    setupForm() {
        this.formGroup = new FormGroup({});
        if (!this.formGroup) {
            return;
        }
        this.addControl("title");
        this.addControl("useTitleTemplates");
        this.addControl("titleTemplatePreferences");
        this.addControl("showTitle");
        this.addControl("useContainerStyling");
        this.addControl("containerStyleName");
        this.addControl("containerClass");
        this.addControl("containerInnerClass");
        this.addControl("containerTitleClass");
        this.addControl("containerWidth");
        this.addControl("containerHeight");
        this.addControl("containerHeaderIcon");
        this.addControl("overrideContainerStyles");
        this.addControl("visibleExpression");
        this.addControl("isReadOnlyContainer");
        this.addControl("readOnlyContainerExpression");
        this.addControl("containerAllowCollapse");
        this.addControl("containerCollapseDefault");
        this.addControl("containerCollapseDefaultExpression");
        this.addControl("containerHeaderBackgroundColor");
        this.addControl("containerHeaderForegroundColor");
        this.containerHeaderIconColorFc = this.addControl("containerHeaderIconColor");
        this.addControl("sectionType", true, true);
        if (this.section) {
            if (this.section.overrideContainerStyles == null || this.section.overrideContainerStyles == undefined) {
                this.section.overrideContainerStyles = !!(this.section.containerInnerClass || this.section.containerClass || this.section.containerInnerClass);
                this.formGroup["overrideContainerStyles"] = this.section.overrideContainerStyles;
            }
        }
        this.containerHeaderIconColorFc.valueChanges.subscribe(() => {
            this.setupIconColor();
        });
        this.setupIconColor();
        if (this.showColumnConfig) {
            var subFormGroup = new FormGroup({});
            if (!this.columnPreferences)
                this.formGroup.addControl("columnPreferences", subFormGroup);
            if (!this.columnsFormControl) {
                this.columnPreferences.addControl('columns', new FormControl("", [Validators.min(1), Validators.max(12)]));
                this.columnPreferences.addControl('columnLayoutMode', new FormControl("grid12"));
            }
            if (!this.columnDetails) {
                let columnDetailsFormArray = new FormArray([]);
                subFormGroup.addControl('columnDetails', columnDetailsFormArray);
            }
            this.columnConfigSetup = true;
            this.populateColumnDetailData();
            this.columnsFormControl.valueChanges
                .pipe(debounceTime(10))
                .subscribe(vc => {
                let columnCount = parseInt(vc);
                if (columnCount <= 0 || isNaN(columnCount)) {
                    this.columnsFormControl.setValue(1);
                    return;
                }
                this.handleColumnCountChange(columnCount);
            });
        }
        if (!this.section.containerStyleName) {
            this.section.containerStyleName = null;
        }
        if (!this.section.containerStyleName) {
            this.section.containerStyleName = '';
        }
        // Initialize title tempaltes
        this.section.titleTemplatePreferences = this.section.titleTemplatePreferences || { loadLookupDisplays: false };
        if (!this.section.useTitleTemplates) {
            this.section.useTitleTemplates = false;
        }
        if (!this.section.useContainerStyling) {
            this.section.useContainerStyling = false;
        }
        if (!this.section.columnPreferences) {
            this.section.columnPreferences = {
                columns: 1,
                columnLayoutMode: DwColumnLayoutMode.grid12,
                columnDetails: []
            };
        }
        if (!this.section.columnPreferences.columnLayoutMode) {
            this.section.columnPreferences.columnLayoutMode = DwColumnLayoutMode.grid12;
        }
        this.formGroup.patchValue(this.section);
        this.formSetup = true;
        this.formGroup.valueChanges.pipe(debounceTime(100))
            .subscribe(() => {
            // console.log('Updating container section', this.section, this.formGroup.value);
            this.section = Object.assign(this.section, this.formGroup.value);
            this.onSectionChange();
        });
    }
    isFlexLayout() {
        var _a;
        return ((_a = this.section) === null || _a === void 0 ? void 0 : _a.columnPreferences.columnLayoutMode) == DwColumnLayoutMode.flex;
    }
    setupIconColor() {
        var _a;
        this.currentIconColor = this.dwStyleManagerService.getColorConfig((_a = this.containerHeaderIconColorFc) === null || _a === void 0 ? void 0 : _a.value);
    }
    setupDropdowns() {
        this.containerStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.containerStyles);
        this.columnLayoutModes = new DwColumnLayoutModeEmumList().getEnumList();
    }
    populateColumnDetailData() {
        if (!this.columnDetails) {
            return;
        }
        if (this.section.columnPreferences && this.section.columnPreferences.columnDetails) {
            if (!this.dataAdded) {
                this.dataAdded = true;
                for (let columnDetail of this.section.columnPreferences.columnDetails) {
                    this.addColumnDetail();
                }
                if (!this.section.columnPreferences.columns || this.section.columnPreferences.columns < this.section.columnPreferences.columnDetails.length) {
                    this.section.columnPreferences.columns = this.section.columnPreferences.columnDetails.length;
                    this.columnsFormControl.setValue(this.columnDetails.controls.length);
                }
            }
            /*
                        if (this.columnsFormControl.value < this.columnDetails.controls.length) {
                            if (this.columnDetails.controls.length)
                            this.columnsFormControl.setValue(this.columnDetails.controls.length);
                        } */
        }
    }
    addColumnDetail() {
        if (this.columnDetails) {
            let newFG = this.createColumnPreferenceFormGroup();
            this.columnDetails.push(newFG);
        }
    }
    removeColumn(i) {
        this.columnDetails.removeAt(i);
    }
    handleColumnCountChange(count) {
        if (!CountQueuingStrategy) {
            return;
        }
        if (count < this.columnDetails.controls.length) {
            for (let i = this.columnDetails.controls.length; i > count; i--) {
                this.columnDetails.removeAt(i - 1);
            }
        }
    }
    updateFormArray() {
        // Find actual Form Array (must be adding it to a copy)
        let columnPrefsFG = this.formGroup.get("columnPreferences");
        let newFG = this.createColumnPreferenceFormGroup();
        if (columnPrefsFG) {
            let columnDetailsFG = columnPrefsFG.get("columnDetails");
            let detailValues = columnDetailsFG.value;
            let columnprefsInitial = columnPrefsFG.value;
            columnPrefsFG.patchValue({
                columnDetails: detailValues
            });
            let columnprefsAfter = columnPrefsFG.value;
        }
        else {
        }
    }
    createColumnPreferenceFormGroup() {
        var subFormGroup = new FormGroup({});
        subFormGroup.addControl('columnSize', new FormControl());
        subFormGroup.addControl('customWidth', new FormControl());
        subFormGroup.addControl('customHeight', new FormControl());
        subFormGroup.addControl('columnClass', new FormControl());
        subFormGroup.addControl('flexSize', new FormControl());
        subFormGroup.addControl('flexGrow', new FormControl());
        return subFormGroup;
    }
    addControl(name, isRequired, isReadOnly) {
        const fc = new FormControl();
        if (isRequired) {
            fc.setValidators(Validators.required);
        }
        if (isReadOnly) {
            fc.disable();
        }
        this.formGroup.addControl(name, fc);
        return fc;
    }
}
DwMdSectionStandardConfigComponent.ɵfac = function DwMdSectionStandardConfigComponent_Factory(t) { return new (t || DwMdSectionStandardConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
DwMdSectionStandardConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionStandardConfigComponent, selectors: [["dw-md-section-standard-config"]], inputs: { showReadOnlySection: "showReadOnlySection", showColumnConfig: "showColumnConfig" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "multiple"], ["header", "Title Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "6"], ["type", "text", "formControlName", "title", 1, "form-control"], ["dwCol", "3"], ["formControlName", "showTitle", 1, "form-control"], ["dwCol", "3", 3, "hidden"], ["formControlName", "useTitleTemplates", 1, "form-control"], ["header", "Container Settings", 3, "selected"], ["formControlName", "useContainerStyling", 1, "form-control"], ["formControlName", "sectionType", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 3, "hidden"], ["dwCol", "4"], ["formControlName", "containerStyleName", 1, "form-control"], ["formControlName", "overrideContainerStyles", 1, "form-control"], ["type", "text", "formControlName", "containerHeaderIcon", 1, "form-control"], [3, "ngClass", "hidden"], ["formControlName", "containerHeaderBackgroundColor"], ["formControlName", "containerHeaderForegroundColor"], ["formControlName", "containerHeaderIconColor"], ["formControlName", "containerAllowCollapse", 1, "form-control"], ["dwCol", "4", 3, "hidden"], ["formControlName", "containerCollapseDefaultExpression", 3, "contextNames", "item"], ["formControlName", "containerCollapseDefault", 1, "form-control"], ["type", "text", "formControlName", "containerWidth", 1, "form-control"], ["type", "text", "formControlName", "containerHeight", 1, "form-control"], ["type", "text", "formControlName", "containerClass", 1, "form-control"], ["type", "text", "formControlName", "containerInnerClass", 1, "form-control"], ["type", "text", "formControlName", "containerTitleClass", 1, "form-control"], ["dwCol", "12"], ["formControlName", "visibleExpression", 3, "contextNames", "item"], ["class", "row", 4, "ngIf"], ["header", "Title Templates", 4, "ngIf"], ["header", "Column Settings", 4, "ngIf"], [3, "ngValue"], [1, "row"], [1, "col-md-6"], ["title", "Propogates to all child sections unless overridden", 1, "fa", "fa-info-circle"], ["formControlName", "isReadOnlyContainer", "allowNull", "true", "nullDisplay", "Automatic"], ["title", "Overrides the Is Read Only value when set", 1, "fa", "fa-info-circle"], ["formControlName", "readOnlyContainerExpression", 3, "contextNames", "item"], ["header", "Title Templates"], ["formControlName", "titleTemplatePreferences", 3, "contextNames", "item", "parentUseContainerStyling"], ["header", "Column Settings"], ["formGroupName", "columnPreferences"], ["type", "number", "dwNumeric", "", "formControlName", "columns", 1, "form-control"], ["formControlName", "columnLayoutMode", 1, "form-control"], ["dwCol", "4", 4, "ngIf"], ["formArrayName", "columnDetails", 4, "ngIf"], [1, "btn", "btn-success", 3, "click"], ["formArrayName", "columnDetails"], ["dwCol", "1"], [4, "ngIf"], ["dwCol", "2"], [4, "ngFor", "ngForOf"], ["class", "btn btn-success", 3, "click", 4, "ngIf"], ["title", "column flex weight, defaults to 1 - equal size", 1, "fa", "fa-info-circle"], ["title", "column expands to consume extra space", 1, "fa", "fa-info-circle"], ["title", "Column size in a 12 column grid (6 = 50% or 2 columns, 4 = 33% or 3 columns, 3 = 25% or 4 columns, 2 = 16% or 6 columns, 1 = 8% or 12 columns)", 1, "fa", "fa-info-circle"], ["dwRow", "", 3, "formGroupName"], ["title", "Remove Column", 1, "fa", "fa-times", "hand", 3, "click"], ["type", "text", "formControlName", "customWidth", 1, "form-control"], ["type", "text", "formControlName", "customHeight", 1, "form-control"], ["type", "text", "formControlName", "columnClass", 1, "form-control"], ["type", "number", "dwNumeric", "", "formControlName", "flexSize", "placeholder", "1", 1, "form-control"], ["type", "number", "dwNumeric", "", "formControlName", "flexGrow", 1, "form-control"], ["type", "number", "dwNumeric", "", "formControlName", "columnSize", 1, "form-control"]], template: function DwMdSectionStandardConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMdSectionStandardConfigComponent_div_0_Template, 98, 28, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formSetup);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwYesNoComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc4.NgClass, ColorSelectComponent, DwExpressionPickerControlComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwTitleTemplatesConfigComponent, ɵngcc3.FormGroupName, ɵngcc3.NumberValueAccessor, DwNumericDirective, ɵngcc3.FormArrayName]; }, styles: [""] });
DwMdSectionStandardConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder },
    { type: DwStyleManagerService }
];
DwMdSectionStandardConfigComponent.propDecorators = {
    showReadOnlySection: [{ type: Input }],
    showColumnConfig: [{ type: Input }]
};
__decorate$W([
    DwInputConverter(),
    __metadata$G("design:type", Boolean)
], DwMdSectionStandardConfigComponent.prototype, "showReadOnlySection", void 0);
__decorate$W([
    DwInputConverter(),
    __metadata$G("design:type", Boolean)
], DwMdSectionStandardConfigComponent.prototype, "showColumnConfig", void 0);

class DwMdSectionGridConfigComponent extends DwMdSectionConfigBaseComponent {
    sectionChanged() {
        if (!this.section) {
            return;
        }
        //if (!this.section.parentItemName)
        this.section.parentItemName = this.getParentItemName();
        if (!this.section.validationConfig) {
            this.section.validationConfig = {
                overrideDefaults: false,
                validators: [],
            };
        }
        this.getItemMetaData(this.section.parentItemName)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
            this.getSecondaryRelatedItems();
        });
    }
    setSectionRelationshipItems(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        const relationship = findWhere(this.itemMetaData.Relations, { RelationshipName: relationshipName });
        if (relationship) {
            this.section.propertyName = relationship.NamingInfo.RelationshipPropertyName;
            if (relationship.IsPrimaryItem) {
                this.section.itemName = relationship.FkUniqueItemName;
            }
            else {
                this.section.itemName = relationship.PkUniqueItemName;
            }
        }
        this.getSecondaryRelatedItems();
        this.onSectionChange();
    }
    getSecondaryRelatedItems() {
        const relationship = findWhere(this.itemMetaData.Relations, { RelationshipName: this.section.relationshipName });
        let relationships = [];
        if (relationship) {
            if (relationship.IsPrimaryItem) {
                this.section.itemName = relationship.FkUniqueItemName;
                relationships = where(this.itemMetaData.Relations, { FkUniqueItemName: this.section.itemName });
            }
            else {
                this.section.itemName = relationship.PkUniqueItemName;
                relationships = where(this.itemMetaData.Relations, { PkUniqueItemName: this.section.itemName });
            }
        }
        let finalRelationships = [];
        for (let relationship of relationships) {
            if (relationship.RelationshipName != this.section.relationshipName) {
                finalRelationships.push(relationship);
            }
        }
        this.secondaryRelationships = finalRelationships;
    }
}
DwMdSectionGridConfigComponent.ɵfac = function DwMdSectionGridConfigComponent_Factory(t) { return ɵDwMdSectionGridConfigComponent_BaseFactory(t || DwMdSectionGridConfigComponent); };
DwMdSectionGridConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionGridConfigComponent, selectors: [["dw-md-section-grid-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 44, vars: 15, consts: [["header", "Grid Configuration"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "form-control"], ["dwCol", "6", 4, "ngIf"], ["title", "Allows using a shared grid config by omiting the form config prefix for the grid", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Validation", 4, "ngIf"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"], [3, "ngValue"], ["header", "Validation"], ["validationItemType", "childGrid", 3, "config", "configContext", "configChange"]], template: function DwMdSectionGridConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionGridConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.section.relationshipName = $event; })("ngModelChange", function DwMdSectionGridConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.setSectionRelationshipItems($event); });
        ɵngcc0.ɵɵtemplate(8, DwMdSectionGridConfigComponent_option_8_Template, 2, 3, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 2);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Show as Data List");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionGridConfigComponent_Template_dw_yesno_ngModelChange_12_listener($event) { return ctx.section.showAsList = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "div", 2);
        ɵngcc0.ɵɵelementStart(15, "label");
        ɵngcc0.ɵɵtext(16, "Item Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 5);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 2);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Property Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 5);
        ɵngcc0.ɵɵtext(23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 1);
        ɵngcc0.ɵɵelementStart(25, "div", 2);
        ɵngcc0.ɵɵelementStart(26, "label");
        ɵngcc0.ɵɵtext(27, "Use Parent Data");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionGridConfigComponent_Template_dw_yesno_ngModelChange_28_listener($event) { return ctx.section.useParentData = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(29, DwMdSectionGridConfigComponent_div_29_Template, 5, 2, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 1);
        ɵngcc0.ɵɵelementStart(31, "div", 2);
        ɵngcc0.ɵɵelementStart(32, "label");
        ɵngcc0.ɵɵtext(33, "Use Shared Config ");
        ɵngcc0.ɵɵelement(34, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionGridConfigComponent_Template_dw_yesno_ngModelChange_35_listener($event) { return ctx.section.useSharedConfig = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "div", 2);
        ɵngcc0.ɵɵelementStart(37, "label");
        ɵngcc0.ɵɵtext(38, "Config Key Suffix (Optional)");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionGridConfigComponent_Template_input_ngModelChange_39_listener($event) { return ctx.section.configKeySuffix = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(40, DwMdSectionGridConfigComponent_p_tabPanel_40_Template, 2, 2, "p-tabPanel", 9);
        ɵngcc0.ɵɵelementStart(41, "p-tabPanel", 10);
        ɵngcc0.ɵɵelementStart(42, "div");
        ɵngcc0.ɵɵelementStart(43, "dw-md-section-standard-config", 11);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdSectionGridConfigComponent_Template_dw_md_section_standard_config_sectionChange_43_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdSectionGridConfigComponent_Template_dw_md_section_standard_config_sectionChange_43_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.relationshipName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.itemMetaData == null ? null : ctx.itemMetaData.Relations);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.showAsList);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate(ctx.section == null ? null : ctx.section.itemName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ctx.section.propertyName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useParentData);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.secondaryRelationships && ctx.secondaryRelationships.length > 0);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useSharedConfig);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.configKeySuffix);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.section == null ? null : ctx.section.validationConfig) && ctx.section.useParentData);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, DwYesNoComponent, ɵngcc4.NgIf, ɵngcc3.DefaultValueAccessor, DwMdSectionStandardConfigComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwFieldValidationConfigComponent]; }, styles: [""] });

function getGridPrefetchInfo(section) {
    const gridSection = section;
    ;
    if (gridSection.useParentData) {
        return {
            itemName: gridSection.itemName,
            propertyName: gridSection.propertyName,
            relationshipName: gridSection.relationshipName,
            loadLookupFields: true
        };
    }
    return null;
}

var __decorate$X = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$H = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridSectionComponent = class DwGridSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwExpressionStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataFormStateService, dwFormValidationService, dwMetaDataFormSectionStateService, dwFormStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwFormValidationService = dwFormValidationService;
        this.filters = null;
        this.configKeyPart = "grid";
        this.setupComplete = false;
        this.ignoreChange = false;
        this.invalidConfiguration = false;
        this.GridValidationKey = 'gridValidation';
    }
    sectionReadOnlyChanged(readOnly) {
        this.setupControl();
    }
    ngOnInit() {
        super.ngOnInit();
        //console.log('DwGridSection.ngOnInit - setupControl');
        this.setupControl();
    }
    ngOnDestroy() {
        var _a;
        super.ngOnDestroy();
        // Disable the form group when it is destroyed (it will get reenabled when it is visible)
        //  Note: this disables validation when this section is hidden
        if ((_a = this.childFormGroup) === null || _a === void 0 ? void 0 : _a.enabled) {
            this.childFormGroup.disable();
        }
    }
    setupComponentComplete() {
        if (this.context && this.context.mdFormContext) {
            this.mdFormContext = this.context.mdFormContext.value;
            this.context.mdFormContext.subscribe(newMdFormContext => {
                this.mdFormContext = newMdFormContext;
                if (!this.ignoreChange) {
                    //console.log('DwGridSection.contextChanged (subscription) - setupControl', newMdFormContext);
                    this.setupControl();
                }
            });
            if (this.mdFormContext.loadDataComplete) {
                //console.log('DwGridSection.contextChanged (no subscription) - setupControl');
                this.setupControl();
            }
        }
        if (this.formGroup) {
            this.subscriptions.push(this.formGroup.valueChanges
                .pipe(distinctUntilChanged())
                .subscribe(vc => {
                if (this.mdFormContext && this.mdFormContext.loadDataComplete && !this.ignoreChange) {
                    // console.log('DwGridSection.fromGroupChanged (subscription) - setupControl', vc);
                    this.setupControl();
                }
            }));
        }
    }
    setupControl() {
        if (!this.context || !this.sectionConfig || !this.formConfig) {
            return;
        }
        if (!this.sectionConfig.relationshipName) {
            this.invalidConfiguration = true;
            this.invalidConfigurationMessage = 'Relationship not set';
            return;
        }
        // setup preferences
        this.gridPreferences = {
            passCurrentDataSource: false,
            gridStyle: {
                gridStyleName: 'Simple',
                gridHeightMode: DwGridHeightMode.fixedHeight,
                gridHeight: '300',
            }
        };
        const formContext = this.dwMetaDataFormStateService.state.formContext;
        if (formContext.contextMode == DwFormContextMode.view || formContext.contextMode == DwFormContextMode.print || formContext.isReadOnly || this.isSectionReadOnly()) {
            this.gridPreferences.isReadOnly = true;
        }
        else {
            this.gridPreferences.isReadOnly = false;
        }
        if (this.sectionConfig.useParentData) {
            this.childFormGroupName = this.sectionConfig.propertyName;
            this.childFormGroup = this.formGroup.get(this.childFormGroupName);
            // setup preferences
            this.gridPreferences.passCurrentDataSource = true;
            if (this.childFormGroup) {
                // We need to enable the form group since it isn't specified on the form
                if (this.childFormGroup.disabled) {
                    setTimeout(() => {
                        this.childFormGroup.enable();
                    });
                }
                this.setupValidation();
                this.createInMemoryDataSource(this.childFormGroup);
            }
        }
        this.dwMetaDataService.getMetaData(this.sectionConfig.parentItemName)
            .subscribe(itemMetaData => {
            this.gridItemMd = itemMetaData;
            // Setup filers so the FKs will be passed to the add/edit window
            this.setupRelationFilter();
        });
        // Change on 6/8/22 to allow using a shared grid config between different form configs
        if (this.sectionConfig.useSharedConfig) {
            this.configKeyPart = this.sectionConfig.configKeySuffix;
        }
        else {
            if (!this.sectionConfig.configKeySuffix) {
                this.configKeyPart = `${this.formConfig.configKey}`;
            }
            else {
                this.configKeyPart = `${this.formConfig.configKey}-${this.sectionConfig.configKeySuffix}`;
            }
        }
    }
    setupValidation() {
        var _a, _b;
        if (!this.childFormGroupName || !this.childFormGroup) {
            return;
        }
        if (this.isSectionReadOnly()) {
            return;
        }
        if ((_b = (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.validationConfig) === null || _b === void 0 ? void 0 : _b.overrideDefaults) {
            if (this.dwFormValidationService.hasConditionalValidation(this.sectionConfig.validationConfig) && !this.conditionalExpressionState) {
                this.conditionalExpressionState = this.dwFormValidationService.initConditionalExpressionState(this.GridValidationKey, this.sectionConfig.validationConfig, this.childFormGroup, this.context, (state => {
                    this.conditionalExpressionState = state;
                    this.setupValidation();
                }));
            }
            // Run in timeout to prevent change after checked error
            setTimeout(() => {
                var _a, _b;
                const validatorsResult = this.dwFormValidationService.buildValidators(this.childFormGroup, (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.validationConfig, this.GridValidationKey, (_b = this.conditionalExpressionState) === null || _b === void 0 ? void 0 : _b.conditionalExpressionResult);
                this.childFormGroup.setValidators(validatorsResult.validators);
            });
        }
    }
    createInMemoryDataSource(childFormGroup) {
        // Check if child data has been modified
        if (this.dataSource && areEqual(childFormGroup.value, this.dataSource.currentData)) {
            return;
        }
        if (this.dataSourceSubscription) {
            this.dataSourceSubscription.unsubscribe();
            this.dataSourceSubscription = null;
        }
        this.dataSource = new DwInMemoryDataSource(this.dwMetaDataService);
        this.dataSource.setupDataSource(childFormGroup.value || [], this.sectionConfig.itemName);
        this.dataSourceSubscription = this.dataSource.dataChanged()
            .subscribe(data => {
            this.updateChildFormGroupValue(childFormGroup, data);
        });
    }
    updateChildFormGroupValue(childFormGroup, data) {
        if (this.ignoreChange) {
            return;
        }
        setTimeout(() => {
            this.ignoreChange = true;
            // Ignore errors (otherwise future updates will be ignored)
            try {
                if (childFormGroup instanceof FormArray) {
                    throw new Error(`Grid ${this.componentName} might have a correspodning Child Data Repeater section which should be removed.  Either use a grid or a child data repeater, not both!`);
                }
                childFormGroup.patchValue(data);
            }
            finally {
                // Also reset flag
                this.ignoreChange = false;
            }
        });
    }
    setupRelationFilter() {
        if (!this.context || !this.formGroup) {
            return;
        }
        if (!this.mdFormContext || !this.mdFormContext.loadDataComplete) {
            return;
        }
        // Find the metadata for the parent so we can get the relation configuration
        const itemMetaData = this.gridItemMd;
        if (!itemMetaData) {
            return;
        }
        let relationship = findWhere(itemMetaData.Relations, { RelationshipName: this.sectionConfig.relationshipName });
        let secondaryRelationship = findWhere(itemMetaData.Relations, { RelationshipName: this.sectionConfig.secondaryRelationshipName });
        if (!relationship) {
            console.warn(`Relationship ${this.sectionConfig.relationshipName} not found for item ${itemMetaData.UniqueItemName}`);
            return;
        }
        let parentAttrName = relationship.PkAttributeName;
        let childAttrName = relationship.FkAttributeName;
        if (relationship.PkUniqueItemName != itemMetaData.UniqueItemName) {
            let parentAttrName = relationship.FkAttributeName;
            let childAttrName = relationship.PkAttributeName;
        }
        const pkAttrFormControl = this.formGroup.get(parentAttrName);
        if (!pkAttrFormControl) {
            if (this.sectionConfig.useParentData) {
                this.setupComplete = true;
            }
            console.warn(`DwGridSection - Parent Attr ${parentAttrName} is not a form control`);
            return;
        }
        if (!this.pkSubscribtion) {
            this.pkSubscribtion = pkAttrFormControl.valueChanges.subscribe((value) => {
                // console.log('DwGridSection - FK changed', value);
                this.setupRelationFilter();
            });
        }
        var pkValue = pkAttrFormControl.value;
        if (!pkValue) {
            if (this.sectionConfig.useParentData) {
                this.setupComplete = true;
            }
            return;
        }
        this.filters = this.filters || {};
        if (!secondaryRelationship) {
            this.filters[childAttrName] = {
                Equal: pkValue
            };
        }
        else {
            let secondChildAttrName = secondaryRelationship.FkAttributeName;
            if (relationship.PkUniqueItemName != itemMetaData.UniqueItemName) {
                secondChildAttrName = secondaryRelationship.PkAttributeName;
            }
            let filterGroup = {};
            filterGroup.Op = DwOperator.Or;
            let filterGroup1 = {};
            filterGroup1.Op = DwOperator.Or;
            filterGroup1[childAttrName] = {
                Equal: pkValue
            };
            let filterGroup2 = {};
            filterGroup2.Op = DwOperator.Or;
            filterGroup2[secondChildAttrName] = {
                Equal: pkValue
            };
            filterGroup["Group1"] = filterGroup1;
            filterGroup["Group2"] = filterGroup2;
            this.filters["GroupParent"] = filterGroup;
        }
        // The add context is used to populate any FK from the parent item
        this.addContext = {};
        this.addContext[childAttrName] = pkValue;
        this.setupComplete = true;
    }
};
DwGridSectionComponent.ɵfac = function DwGridSectionComponent_Factory(t) { return new (t || DwGridSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwGridSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridSectionComponent, selectors: [["dw-grid-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "hide-print dw-invalid-section", 4, "ngIf"], [4, "ngIf"], [1, "hide-print", "dw-invalid-section"], ["id", "icon", 1, "fas", "fa-cog"], ["id", "message"], ["dwRow", ""], ["dwCol", "12", 3, "formGroup", 4, "ngIf"], ["dwCol", "12", 3, "formGroup"], [3, "formControlName", "submitted"], [3, "dataSource", "readOnly", "preferences", "item", "addContext", "configKeyPart", "filters", 4, "ngIf"], [3, "dataSource", "item", "configKeyPart", "filters", 4, "ngIf"], [3, "dataSource", "readOnly", "preferences", "item", "addContext", "configKeyPart", "filters"], [3, "dataSource", "item", "configKeyPart", "filters"]], template: function DwGridSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridSectionComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwGridSectionComponent_ng_container_1_Template, 5, 3, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidConfiguration);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.setupComplete);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwValidationInfo, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwMetaDataGridComponent, DwMetadataListComponent], encapsulation: 2 });
DwGridSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwExpressionStateService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormStateService },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService }
];
DwGridSectionComponent = __decorate$X([
    DwSectionComponent({
        keyName: DwSectionType.grid,
        display: 'Grid/List',
        sectionIcon: 'fa fa-th',
        configComponent: DwMdSectionGridConfigComponent,
        hasChildren: false,
        getPrefetchPathInfo: getGridPrefetchInfo
    }),
    __metadata$H("design:paramtypes", [DwExpressionService,
        DwExpressionStateService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetaDataFormStateService,
        DwMetadataFormValidationBuilderService,
        DwMetaDataFormSectionStateService,
        DwMetaDataFormStateService])
], DwGridSectionComponent);

class DwExpressionControlComponent extends DwControlBaseComponent {
    constructor(dwExpressionComparerService) {
        super();
        this.dwExpressionComparerService = dwExpressionComparerService;
        this.contextNames = [];
    }
    ngOnInit() {
    }
    compareNeedsValue(comparerType) {
        return this.dwExpressionComparerService.compareNeedsValue(comparerType);
    }
    setReference1(reference1) {
        this.expr.reference1 = reference1;
        this.setValue(this.expr);
        this.dwExpressionComparerService.getCompareTypesFromExprRef(this.item, this.expr.reference1, this.queryMeaning)
            .subscribe(comparerTypes => {
            this.compareTypes = comparerTypes;
        });
        this.relatedExprRef = deepCopy(reference1);
    }
    writeValue(obj) {
        super.writeValue(obj);
        this.expr = this.value;
        this.initExpression();
    }
    initExpression() {
        //this.expr = this.value;
        let exprChanged = false;
        if (!this.expr) {
            return;
        }
        if (!this.expr.reference1) {
            this.expr.reference1 = {
                referenceType: DwExpressionReferenceType.item
            };
            exprChanged = true;
        }
        if (!this.expr.reference2) {
            this.expr.reference2 = {
                referenceType: DwExpressionReferenceType.value
            };
            exprChanged = true;
        }
        if (!this.expr.compareType) {
            this.expr.compareType = DwExpressionCompareType.equal;
            exprChanged = true;
        }
        this.relatedExprRef = this.expr.reference1;
        // Always set the compare types (even when we don't have an item since we could have context)
        this.dwExpressionComparerService.getCompareTypesFromExprRef(this.item, this.expr.reference1, this.queryMeaning)
            .subscribe(comparerTypes => {
            this.compareTypes = comparerTypes;
        });
        if (exprChanged) {
            this.setValue(this.expr);
        }
    }
}
DwExpressionControlComponent.ɵfac = function DwExpressionControlComponent_Factory(t) { return new (t || DwExpressionControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionComparersService)); };
DwExpressionControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpressionControlComponent, selectors: [["dw-expression-control"]], inputs: { contextNames: "contextNames", item: "item", queryMeaning: "queryMeaning" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwExpressionControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["dwRow", "", 4, "ngIf"], ["dwRow", ""], [1, "expr-column"], [3, "ngModel", "item", "queryMeaning", "contextNames", "ngModelChange"], [1, "expr-column", 3, "hidden"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngModel", "relatedExprRef", "item", "queryMeaning", "contextNames", "comparerType", "ngModelChange"], [3, "ngValue"]], template: function DwExpressionControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwExpressionControlComponent_div_0_Template, 8, 14, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.expr);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRowDirective, DwExpressionReferenceControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x]; }, styles: [""] });
DwExpressionControlComponent.ctorParameters = () => [
    { type: DwExpressionComparersService }
];
DwExpressionControlComponent.propDecorators = {
    item: [{ type: Input }],
    contextNames: [{ type: Input }],
    queryMeaning: [{ type: Input }]
};

class DwExpressionGroupControlComponent extends DwControlBaseComponent {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        this.contextNames = [];
    }
    ngOnInit() {
        // Set up lists for enums
        this.operatorTypes = new DwExpressionOperatorList().getEnumList();
    }
    writeValue(value) {
        super.writeValue(value);
        this.exprGroup = value;
    }
    setValue(exprGroup) {
        super.setValue(exprGroup);
    }
    setExprValue(exprGroup, expr, index) {
        // Update the modified expression
        exprGroup.expressions[index] = expr;
        this.setValue(exprGroup);
    }
    exprGroupChange(expr, index) {
        //console.log("ExprGroupChanged", this.exprGroup, expr,index);
        setTimeout(() => {
            this.exprGroup.expressions[index] = expr;
            this.setValue(this.exprGroup);
        });
    }
    removeExpr(expr) {
        const index = this.exprGroup.expressions.indexOf(expr);
        this.exprGroup.expressions.splice(index, 1);
        this.setValue(this.exprGroup);
    }
    addExpr() {
        if (!this.exprGroup) {
            this.exprGroup = this.createExpressionGroup();
        }
        const expr = this.createExpressionItem();
        this.exprGroup.expressions.push(expr);
        this.setValue(this.exprGroup);
        this.cdr.detectChanges();
    }
    addExprGroup() {
        if (!this.exprGroup) {
            this.exprGroup = this.createExpressionGroup();
        }
        const expr = this.createExpressionGroup();
        this.exprGroup.expressions.push(expr);
        this.setValue(this.exprGroup);
        this.cdr.detectChanges();
    }
    isExpressionGroup(expr) {
        if (expr.expressions) {
            return true;
        }
        return false;
    }
    initExpressionGroup() {
        this.exprGroup = this.value;
        let exprGroupChanged = false;
        if (!this.exprGroup) {
            this.exprGroup = this.createExpressionGroup();
            exprGroupChanged = true;
        }
        if (exprGroupChanged) {
            this.setValue(this.exprGroup);
        }
    }
    createExpressionItem() {
        return {
            reference1: {
                referenceType: DwExpressionReferenceType.item
            },
            reference2: {
                referenceType: DwExpressionReferenceType.value
            },
            compareType: DwExpressionCompareType.equal
        };
    }
    createExpressionGroup() {
        DwExpressionGroupControlComponent.count++;
        return {
            expressions: [],
            operator: DwExpressionOperator.and,
            id: DwExpressionGroupControlComponent.count,
        };
    }
}
DwExpressionGroupControlComponent.ɵfac = function DwExpressionGroupControlComponent_Factory(t) { return new (t || DwExpressionGroupControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwExpressionGroupControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpressionGroupControlComponent, selectors: [["dw-expression-group-control"]], inputs: { contextNames: "contextNames", item: "item", queryMeaning: "queryMeaning" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwExpressionGroupControlComponent),
                multi: true
            }], [DwExpressionGroupControlComponent]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], ["class", "expression-group-box", 4, "ngIf"], [1, "expression-button-bar"], ["title", "Add Expression", 1, "btn", "btn-sm", "btn-primary", 3, "click"], [1, "fa", "fa-plus", "hand"], ["title", "Add Group", 1, "btn", "btn-sm", "btn-primary", 3, "click"], [1, "fa", "fa-layer-plus", "hand"], [1, "expression-group-box"], [4, "ngFor", "ngForOf"], ["class", "expression-row", 4, "ngIf"], [1, "expression-row"], [1, "expression-remove-col"], ["title", "Remove Field", 1, "fa", "fa-times", "hand", 3, "click"], [1, "expression-col"], [1, "expression-col-operator"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [3, "ngModel", "contextNames", "item", "queryMeaning", "ngModelChange"]], template: function DwExpressionGroupControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwExpressionGroupControlComponent_div_0_Template, 7, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwExpressionGroupControlComponent_div_1_Template, 2, 0, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.item || (ctx.contextNames == null ? null : ctx.contextNames.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.item && (!ctx.contextNames || (ctx.contextNames == null ? null : ctx.contextNames.length) == 0));
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwExpressionBracketComponent, DwExpressionGroupControlComponent, DwExpressionControlComponent]; }, styles: [".expression-group-box[_ngcontent-%COMP%]{margin:5px;width:100%}.expression-row[_ngcontent-%COMP%]{clear:left;display:flex;flex-wrap:wrap}.expression-group-box-column[_ngcontent-%COMP%]{float:left;padding:5px;width:5px}.expression-remove-col[_ngcontent-%COMP%]{float:left;padding:5px;width:20px}.expression-group-box-column-first[_ngcontent-%COMP%]{border-top:1px solid #000}.expression-group-box-column-last[_ngcontent-%COMP%]{border-bottom:1px solid #000}.expression-col[_ngcontent-%COMP%]{float:left;margin-left:15px}.expression-col-operator[_ngcontent-%COMP%]{float:left;margin-left:25px;width:100px}.expression-button-bar[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:5px}"] });
DwExpressionGroupControlComponent.count = 0;
DwExpressionGroupControlComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
DwExpressionGroupControlComponent.propDecorators = {
    item: [{ type: Input }],
    contextNames: [{ type: Input }],
    queryMeaning: [{ type: Input }]
};

var __decorate$Y = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$I = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwExpressionReferenceControlComponent extends DwControlBaseComponent {
    constructor(dwContextService, dwMetaDataService, dwExpressionComparerService, cdr, fb) {
        super();
        this.dwContextService = dwContextService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwExpressionComparerService = dwExpressionComparerService;
        this.cdr = cdr;
        this.fb = fb;
        this.contextNames = [];
        this.showDisplayAttributes = false;
        this.itemMetaData = {};
        this.currentContextAttributesOb = new Observable();
        this.contextAttributesOb = {};
        this.ignoreFieldChange = false;
        this.availableReferenceTypes = [];
    }
    get relatedExprRef() {
        return this._relatedExprRef;
    }
    set relatedExprRef(value) {
        this._relatedExprRef = value;
        //console.log("DwExpressionReferenceControlComponent RelatedExprSet", value);
        this.buildValueFieldDef();
    }
    ngOnInit() {
        this.formGroup = new FormGroup({});
        this.valueFormControl = new FormControl();
        this.formGroup.addControl("value", this.valueFormControl);
        this.initExprRef();
        this.setupContextDefs();
        this.setupReferenceTypes();
        this.buildValueFieldDef();
        if (this.item) {
            this.getMetaDataAttributes(this.item)
                .subscribe(attributes => {
                this.itemAttributes = this.setupAttributes(attributes, true, this.showDisplayAttributes);
            });
        }
        this.valueFormControl.valueChanges
            .subscribe(value => {
            if (this.ignoreFieldChange || this.exprRef.value === value) {
                return;
            }
            this.exprRef.value = value;
            this.setValue(this.exprRef);
        });
    }
    initExprRef() {
        if (!this.exprRef) {
            this.exprRef = { referenceType: DwExpressionReferenceType.item };
        }
    }
    setupAttributes(attributes, includeBlank, showDisplayAttributes) {
        var _a;
        const finalAttrs = [];
        for (let attr of attributes) {
            finalAttrs.push(attr);
            if (showDisplayAttributes && (attr.DisplayAttributeName != attr.AttributeName || ((_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsLookup))) {
                const displayAttr = Object.assign({}, attr);
                displayAttr.AttributeDisplay = `${attr.AttributeDisplay} (Display)`;
                if (attr.DisplayAttributeName != attr.AttributeName) {
                    displayAttr.AttributeName = attr.DisplayAttributeName;
                }
                else {
                    displayAttr.AttributeName = `${attr.AttributeName}Display`;
                }
                finalAttrs.push(displayAttr);
            }
        }
        if (includeBlank) {
            return [
                // Add a blank attribute so it doesn't default to the first item
                { AttributeName: null, AttributeDisplay: 'Select...' },
                ...finalAttrs
            ];
        }
        return finalAttrs;
    }
    setupReferenceTypes() {
        // Set up lists for drop-downs
        this.referenceTypes = new DwExpressionReferenceTypeList().getEnumList();
        this.availableReferenceTypes = [];
        if (this.item) {
            this.addPillRef(this.availableReferenceTypes, DwExpressionReferenceType.item);
        }
        if (this.contextNames && this.contextNames.length > 0) {
            this.addPillRef(this.availableReferenceTypes, DwExpressionReferenceType.context);
        }
        if (this.relatedExprRef || this.valueFieldConfig) {
            this.addPillRef(this.availableReferenceTypes, DwExpressionReferenceType.value);
        }
        if (this.exprRef && this.exprRef.referenceType) {
            let refTypeMatch = findWhere(this.availableReferenceTypes, { value: this.exprRef.referenceType });
            if (!refTypeMatch) {
                this.exprRef.referenceType = this.availableReferenceTypes[0].value;
            }
        }
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
    }
    addPillRef(items, refType) {
        const refTypeEnum = this.referenceTypes.find(ref => ref.value == refType);
        if (!refTypeEnum) {
            return null;
        }
        const pillRefType = {
            display: '',
            value: refTypeEnum.value,
            iconClass: refTypeEnum.data.icon,
            tooltip: refTypeEnum.display
        };
        items.push(pillRefType);
    }
    setValue(value) {
        super.setValue(value);
        this.onContextNameChange();
    }
    writeValue(value) {
        super.writeValue(value);
        this.exprRef = value;
        this.initExprRef();
        if (this.exprRef) {
            // Trigger setup of context and the value field
            this.onContextNameChange();
            this.setupReferenceTypes();
            this.buildValueFieldDef();
        }
    }
    onContextNameChange() {
        if (this.exprRef.contextName) {
            this.getContextAttributes(this.exprRef.contextName)
                .subscribe(contextAttrs => {
                this.currentContextAttributes = this.setupAttributes(contextAttrs, true, false);
                if (!this.destroyed) {
                    this.cdr.detectChanges();
                }
            });
        }
    }
    ngOnChanges(simpleChanges) {
        // ignore first changes (since this is handled in ngOnInit)
        if (isFirstChange(simpleChanges)) {
            return;
        }
        this.initExprRef();
        if (simpleChanges.contextNames && this.contextNames) {
            this.setupContextDefs();
            this.setupReferenceTypes();
        }
        let updateAttributes = false;
        if (simpleChanges.item || simpleChanges.queryMeaning || simpleChanges.showDisplayAttributes) {
            updateAttributes = true;
        }
        if (updateAttributes) {
            this.getMetaDataAttributes(this.item)
                .subscribe(attributes => {
                this.itemAttributes = this.setupAttributes(attributes, true, this.showDisplayAttributes);
            });
        }
        if (simpleChanges.relatedExprRef && this.relatedExprRef) {
            this.buildValueFieldDef(true);
            this.setupReferenceTypes();
        }
        if (simpleChanges.valueFieldConfig) {
            this.ignoreFieldChange = true;
            this.buildValueFieldDef(true);
            setTimeout(() => {
                this.ignoreFieldChange = false;
            });
        }
        if (simpleChanges.comparerType) {
            this.buildValueFieldDef(true);
        }
    }
    setRefeferenceType(refType) {
        if (!this.exprRef)
            return;
        this.exprRef.referenceType = refType;
        this.setValue(this.exprRef);
    }
    buildValueFieldDef(clearValue = false) {
        if (!this.relatedExprRef) {
            if (this.valueFieldConfig) {
                this.setValueFieldDef(Object.assign({}, this.valueFieldConfig), clearValue);
            }
            return;
        }
        let attrObservable;
        switch (this.relatedExprRef.referenceType) {
            case DwExpressionReferenceType.item:
                attrObservable = this.getMetaDataAttributes(this.item);
                break;
            case DwExpressionReferenceType.context:
                attrObservable = this.getContextAttributes(this.relatedExprRef.contextName);
                break;
            case DwExpressionReferenceType.value:
                this.valueFieldDef = null;
                return;
        }
        attrObservable.subscribe(mdAttributes => {
            const queryAttr = findWhere(mdAttributes, { AttributeName: this.relatedExprRef.attrName });
            if (queryAttr) {
                const attr = queryAttr.Attribute;
                const valueFieldDef = this.dwExpressionComparerService.buildValueFieldDef(queryAttr, this.comparerType);
                this.setValueFieldDef(valueFieldDef);
            }
        });
    }
    setValueFieldDef(valueFieldDef, clearValue = false) {
        valueFieldDef.attrName = 'value';
        valueFieldDef.hideLabel = true;
        if (this.valueFormControl) {
            if (this.exprRef) {
                if (clearValue && this.valueFieldDef) {
                    this.valueFormControl.setValue(null);
                }
                else {
                    this.valueFormControl.setValue(this.exprRef.value);
                }
            }
            else {
                this.valueFormControl.setValue(null);
            }
        }
        setTimeout(() => {
            this.valueFieldDef = valueFieldDef;
            if (!this.destroyed) {
                this.cdr.detectChanges();
            }
        });
    }
    getContextAttributes(contextName) {
        //console.log(`getContextAttributes ${contextName}`);
        return this.dwContextService.getContextMetaData(contextName)
            .pipe(map(queryMetaData => {
            if (queryMetaData) {
                return queryMetaData.attributes;
            }
            return [];
        }));
    }
    getMetaDataAttributes(item) {
        if (!item) {
            return of([]);
        }
        return this.dwMetaDataService.getSavedQueryMetaData(item, null, this.queryMeaning)
            .pipe(map(md => {
            if (!md)
                return [];
            return md.Attributes;
        }));
    }
    getMetaData(item) {
        if (!item) {
            //console.log("getMetaData - return null");
            return of(null)
                .pipe(share());
            ;
        }
        const itemName = item;
        if (this.itemMetaData[itemName]) {
            //console.log(`getMetaData - return cached ${itemName}`);
            return of(this.itemMetaData[itemName])
                .pipe(share());
        }
        return this.loadMetaData(item)
            .pipe(share());
    }
    setupContextDefs() {
        this.contextDefs = this.dwContextService.getContextDefinitions(this.contextNames);
        for (let contextDef of this.contextDefs) {
            this.contextAttributesOb[contextDef.contextName] = this.getContextAttributes(contextDef.contextName);
        }
    }
    loadMetaData(item) {
        const subject = new Subject();
        this.dwMetaDataService.getMetaData(item)
            .subscribe(m => {
            this.itemMetaData[m.UniqueItemName] = m;
            setTimeout(() => {
                subject.next(m);
            });
        });
        return subject;
    }
}
DwExpressionReferenceControlComponent.ɵfac = function DwExpressionReferenceControlComponent_Factory(t) { return new (t || DwExpressionReferenceControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionComparersService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DwExpressionReferenceControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpressionReferenceControlComponent, selectors: [["dw-expression-reference-control"]], inputs: { contextNames: "contextNames", showDisplayAttributes: "showDisplayAttributes", relatedExprRef: "relatedExprRef", item: "item", queryMeaning: "queryMeaning", valueFieldConfig: "valueFieldConfig", comparerType: "comparerType" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwExpressionReferenceControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "expr-column"], [3, "items", "ngModel", "ngModelChange"], [1, "expr-column", 3, "ngSwitch"], [4, "ngSwitchCase"], ["optionLabel", "AttributeDisplay", "display", "chip", "optionValue", "AttributeName", "filter", "true", "appendTo", "body", 3, "options", "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["class", "form-control", 3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "ngValue"], [3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwDynamicField", "", 3, "fieldDef", "formGroup"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwExpressionReferenceControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwExpressionReferenceControlComponent_div_0_Template, 4, 6, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwExpressionReferenceControlComponent_div_1_Template, 7, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.exprRef || !(ctx.referenceTypes == null ? null : ctx.referenceTypes.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.exprRef && (ctx.referenceTypes == null ? null : ctx.referenceTypes.length) > 0);
    } }, directives: [ɵngcc4.NgIf, DwPillsComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc22.Dropdown, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDynamicFieldComponent, ɵngcc3.DefaultValueAccessor], pipes: [ɵngcc4.JsonPipe], encapsulation: 2 });
DwExpressionReferenceControlComponent.ctorParameters = () => [
    { type: DwContextService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionComparersService },
    { type: ChangeDetectorRef },
    { type: FormBuilder }
];
DwExpressionReferenceControlComponent.propDecorators = {
    item: [{ type: Input }],
    contextNames: [{ type: Input }],
    queryMeaning: [{ type: Input }],
    valueFieldConfig: [{ type: Input }],
    showDisplayAttributes: [{ type: Input }],
    comparerType: [{ type: Input }],
    relatedExprRef: [{ type: Input }]
};
__decorate$Y([
    DwInputConverter(booleanConverter),
    __metadata$I("design:type", Boolean)
], DwExpressionReferenceControlComponent.prototype, "showDisplayAttributes", void 0);

var DwRelationshipType;
(function (DwRelationshipType) {
    DwRelationshipType[DwRelationshipType["zeroToOne"] = 1] = "zeroToOne";
    DwRelationshipType[DwRelationshipType["OneToOne"] = 2] = "OneToOne";
    DwRelationshipType[DwRelationshipType["OneToMany"] = 3] = "OneToMany";
    DwRelationshipType[DwRelationshipType["ManyToOne"] = 4] = "ManyToOne";
})(DwRelationshipType || (DwRelationshipType = {}));

class DwMdChildDataSectionConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.availableRelations = [];
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        if (!this.section.parentItem)
            this.section.parentItem = this.getParentItemName();
        if (!this.section.section) {
            this.section.section = new DwFormSectionPreference();
            this.onSectionChange();
        }
        this.setupRelationship(this.section.relationshipName);
        this.setupAvailableRelationships();
    }
    setupAvailableRelationships() {
        const parentName = this.getParentItemName();
        if (!parentName) {
            return;
        }
        this.getItemMetaData(parentName)
            .subscribe(parentMetaData => {
            this.availableRelations = parentMetaData === null || parentMetaData === void 0 ? void 0 : parentMetaData.Relations.filter(relation => {
                return !relation.IsPrimaryItem || relation.RelationshipTypeId == DwRelationshipType.OneToOne;
            });
        });
    }
    // setupValidRelationships() {
    //     this.getItemMetaData(this.itemName)
    //     .subscribe(itemMetaData =>{
    //         this.itemMetaData = itemMetaData;
    //         this.validRelationships = this.itemMetaData.Relations.filter(r => r.IsPrimaryItem);
    //     });
    // }
    setupRelationship(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        this.relationship = findWhere(this.availableRelations, { RelationshipName: relationshipName });
        // this.relationship.NamingInfo.RelationshipDisplayName
        this.relationshipDisplay = null;
        if (this.relationship) {
            this.relationshipDisplay = `${this.relationship.PkUniqueItemName}.${this.relationship.PkAttributeName} (PK) = ${this.relationship.FkUniqueItemName}.${this.relationship.FkAttributeName} (FK)`;
        }
    }
    setSectionRelationshipItems(relationshipName) {
        this.setupRelationship(relationshipName);
        if (this.relationship) {
            this.section.relationshipName = this.relationship.RelationshipName;
            this.section.propertyName = this.relationship.NamingInfo.RelationshipPropertyName;
            if (this.relationship.IsPrimaryItem) {
                this.section.childItem = this.relationship.FkUniqueItemName;
            }
            else {
                this.section.childItem = this.relationship.PkUniqueItemName;
            }
            this.getItemMetaData(this.section.childItem)
                .subscribe(childSectionItemMetaData => {
                if (childSectionItemMetaData.IsView) {
                    this.section.excludeFromSave = true;
                }
            });
        }
        this.onSectionChange();
    }
}
DwMdChildDataSectionConfigComponent.ɵfac = function DwMdChildDataSectionConfigComponent_Factory(t) { return ɵDwMdChildDataSectionConfigComponent_BaseFactory(t || DwMdChildDataSectionConfigComponent); };
DwMdChildDataSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdChildDataSectionConfigComponent, selectors: [["dw-md-child-data-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 33, vars: 12, consts: [["header", "Child Data Configuration"], ["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["dwCol", "4"], ["title", "Excludes this child and any children from being saved.  Also makes any forms read-only", 1, "fa", "fa-info-circle"], [3, "ngModel", "ngModelChange"], ["dwCol", "9"], ["dwCol", "3"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"], [3, "ngValue"]], template: function DwMdChildDataSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.section.relationshipName = $event; })("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.setSectionRelationshipItems($event); });
        ɵngcc0.ɵɵtemplate(8, DwMdChildDataSectionConfigComponent_option_8_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DwMdChildDataSectionConfigComponent_div_9_Template, 7, 2, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "div", 1);
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Child Section Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_select_ngModelChange_14_listener($event) { return ctx.section.section.sectionType = $event; })("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_select_ngModelChange_14_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(15, DwMdChildDataSectionConfigComponent_option_15_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 6);
        ɵngcc0.ɵɵelementStart(17, "div", 1);
        ɵngcc0.ɵɵelementStart(18, "div", 2);
        ɵngcc0.ɵɵelementStart(19, "label");
        ɵngcc0.ɵɵtext(20, "Exclude From Save ");
        ɵngcc0.ɵɵelement(21, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "dw-yesno", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_dw_yesno_ngModelChange_22_listener($event) { return ctx.section.excludeFromSave = $event; })("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_dw_yesno_ngModelChange_22_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 6);
        ɵngcc0.ɵɵelementStart(24, "div", 1);
        ɵngcc0.ɵɵelementStart(25, "div", 9);
        ɵngcc0.ɵɵelementStart(26, "label");
        ɵngcc0.ɵɵtext(27, "Exclude Child Controls");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 10);
        ɵngcc0.ɵɵelementStart(29, "p-inputSwitch", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_p_inputSwitch_ngModelChange_29_listener($event) { return ctx.section.excludeChildControls = $event; })("ngModelChange", function DwMdChildDataSectionConfigComponent_Template_p_inputSwitch_ngModelChange_29_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "p-tabPanel", 11);
        ɵngcc0.ɵɵelementStart(31, "div");
        ɵngcc0.ɵɵelementStart(32, "dw-md-section-standard-config", 12);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdChildDataSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_32_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdChildDataSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_32_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.relationshipName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availableRelations);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relationshipDisplay);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.section.sectionType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sectionDefs);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.excludeFromSave);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.excludeChildControls);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwYesNoComponent, ɵngcc10.InputSwitch, DwMdSectionStandardConfigComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });

function getChildDataPrefetchInfo(section) {
    const childDataSection = section;
    ;
    if (childDataSection.childItem) {
        return {
            itemName: childDataSection.childItem,
            propertyName: childDataSection.propertyName,
            relationshipName: childDataSection.relationshipName,
            excludeFromSave: childDataSection.excludeFromSave
        };
    }
    return null;
}

var __decorate$Z = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$J = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwChildDataSectionComponent = class DwChildDataSectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetadataFormUtilService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.formGroupSetup = false;
        this.invalidConfiguration = false;
    }
    formConfigChanged() {
        this.setupChildData();
    }
    sectionConfigChanged() {
        this.setupChildData();
    }
    setupChildData() {
        var _a;
        if (!this.formGroup || !this.sectionConfig || !this.formConfig)
            return;
        if (!this.sectionConfig.childItem) {
            this.invalidConfiguration = true;
            this.invalidConfigurationMessage = 'Relationship not set';
            return;
        }
        this.formGroupName = this.sectionConfig.propertyName;
        this.childFormGroup = this.formGroup.get(this.formGroupName);
        DwFormDebugService.debugEvent(this.formGroup, `DwChildDataSectionComponent.formGroupChanged ${this.formGroupName}`);
        if (this.childFormGroup) {
            this.formGroupSetup = true;
        }
        // If we're excluding the section from save, make all child sections read only
        if ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.excludeFromSave) {
            this.dwMetadataFormUtilService.setSectionReadOnly(this.sectionConfig.section, true);
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.childFormGroup) {
            this.childFormGroup.disable();
        }
    }
};
DwChildDataSectionComponent.ɵfac = function DwChildDataSectionComponent_Factory(t) { return new (t || DwChildDataSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService)); };
DwChildDataSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwChildDataSectionComponent, selectors: [["dw-child-data-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "hide-print dw-invalid-section", 4, "ngIf"], [3, "formGroup", 4, "ngIf"], [1, "hide-print", "dw-invalid-section"], ["id", "icon", 1, "fas", "fa-cog"], ["id", "message"], [3, "formGroup"], [3, "formGroupName"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"]], template: function DwChildDataSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwChildDataSectionComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwChildDataSectionComponent_div_1_Template, 3, 8, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidConfiguration);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroupSetup && ctx.sectionConfig);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc3.FormGroupName, DwDynamicSectionComponent], encapsulation: 2 });
DwChildDataSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService }
];
DwChildDataSectionComponent = __decorate$Z([
    DwSectionComponent({
        keyName: DwSectionType.childData,
        display: 'Child Data',
        sectionIcon: 'fa fa-child',
        configComponent: DwMdChildDataSectionConfigComponent,
        hasChildren: false,
        hasChild: true,
        getPrefetchPathInfo: getChildDataPrefetchInfo,
        childrenPropertyName: 'section'
    }),
    __metadata$J("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetadataFormUtilService])
], DwChildDataSectionComponent);

class DwExpressionBracketComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwExpressionBracketComponent.ɵfac = function DwExpressionBracketComponent_Factory(t) { return new (t || DwExpressionBracketComponent)(); };
DwExpressionBracketComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpressionBracketComponent, selectors: [["dw-expression-bracket"]], ngContentSelectors: _c5, decls: 7, vars: 0, consts: [[1, "group-box-outer-container"], [1, "group-box-container"], [1, "group-box-sub-container"], [1, "group-box-col1"], [1, "group-box-col2"]], template: function DwExpressionBracketComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".group-box-outer-container[_ngcontent-%COMP%]{border-left:1px solid #000;overflow:auto;overflow-x:hidden}.group-box-container[_ngcontent-%COMP%]{float:left;margin-right:20px;overflow:hidden;width:100%}.group-box-sub-container[_ngcontent-%COMP%]{border-bottom:1px solid #000;border-left:1px solid #000;border-top:1px solid #000;float:left;position:relative;right:calc(100% - 10px);width:100%}.group-box-col1[_ngcontent-%COMP%]{width:10px}.group-box-col1[_ngcontent-%COMP%], .group-box-col2[_ngcontent-%COMP%]{float:left;left:calc(100% - 10px)}.group-box-col2[_ngcontent-%COMP%]{position:relative;width:calc(100% - 10px)}.group-box-inner-container[_ngcontent-%COMP%]{width:100%}"] });
DwExpressionBracketComponent.ctorParameters = () => [];

class DwMdSectionPreviewComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.showPreview = false;
        this.context = {};
        this.submitted = false;
    }
    ngOnInit() {
        this.formGroup = this.fb.group({});
        this.setupForm();
    }
    sampleSave() {
        this.submitted = true;
    }
    refreshPreview() {
        this.showPreview = false;
        this.setupForm();
        setTimeout(() => {
            this.showPreview = true;
        }, 500);
    }
    setupForm() {
        this.dwFormService.getPreferencesHierarchy(this.rootItemName, null, false, null)
            .subscribe(formPrefHierarchy => {
            formPrefHierarchy.loadedPreferences = this.preferences;
            this.dwFormService.buildFormConfig(formPrefHierarchy, true, DwFormContextMode.edit, null, null, null)
                .subscribe(formConfig => {
                this.formConfig = formConfig;
                this.dwFormBuilderService.setupFormControls(this.formGroup, this.formConfig);
            });
        });
    }
}
DwMdSectionPreviewComponent.ɵfac = function DwMdSectionPreviewComponent_Factory(t) { return ɵDwMdSectionPreviewComponent_BaseFactory(t || DwMdSectionPreviewComponent); };
DwMdSectionPreviewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionPreviewComponent, selectors: [["dw-md-section-preview"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 1, consts: [[3, "click"], [4, "ngIf"], [3, "formGroup"], [3, "formConfig", "context", "sectionConfig", "formGroup", "submitted"], [1, "btn", "btn-success", 3, "click"]], template: function DwMdSectionPreviewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "button", 0);
        ɵngcc0.ɵɵlistener("click", function DwMdSectionPreviewComponent_Template_button_click_1_listener() { return ctx.refreshPreview(); });
        ɵngcc0.ɵɵtext(2, "Refresh Preview");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwMdSectionPreviewComponent_div_3_Template, 6, 6, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPreview);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDynamicSectionComponent, DwButtonBarComponent], styles: [""] });

class DwMdSectionFormFieldConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb, dwFormValiadtionService, dwSectionConfigStateService) {
        var _a;
        super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
        this.fb = fb;
        this.dwFormValiadtionService = dwFormValiadtionService;
        this.dwSectionConfigStateService = dwSectionConfigStateService;
        this.selectedFieldChange = new EventEmitter();
        this.controlTypeLookupId = DevwareMetaDataLookups.MetaDataControlTypeAllItems;
        // Moved here since this initSelectedField get called prior to ngOnInit and causes a null reference error
        this.customControlTypes = [{ key: '', name: ' ', componentType: null, component: null }, ...this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.formControl, (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.UniqueItemName)];
    }
    ngOnInit() {
    }
    updateField() {
        this.selectedFieldChange.emit(this.selectedField);
        this.setFieldConfiguredOptions();
    }
    ngOnChanges(changes) {
        if (changes.selectedField) {
            this.initSelectedField();
        }
    }
    initSelectedField() {
        const field = this.selectedField;
        //this.selectedField = field;
        const queryAttr = this.selectedAttr;
        this.selectedFieldContextMd = null;
        if (field.contextName) {
            this.selectedFieldContextMd = this.contextMdList[field.contextName];
        }
        this.dwFormFieldContext = {
            formFieldPreference: field,
            itemName: this.itemName,
            contextNames: this.contextNames,
            queryAttr: queryAttr
        };
        this.selectedField.lookupConfig;
        if (!this.selectedField.controlOptions) {
            this.selectedField.controlOptions = {};
        }
        // Init validation config
        if (!this.selectedField.validationConfig) {
            this.selectedField.validationConfig = this.dwFormValiadtionService.getDefaultFieldValidatorConfig(queryAttr.Attribute, false);
        }
        if (!this.selectedField.lookupConfig || !this.selectedField.lookupConfig.lookupIdOverride) {
            this.showLookupOverride = false;
        }
        else {
            this.showLookupOverride = true;
        }
        // set default value
        if (this.selectedField.useControlTypeOverride == undefined) {
            if (!this.selectedField.controlTypeOverride) {
                this.selectedField.useControlTypeOverride = false;
            }
            else {
                this.selectedField.useControlTypeOverride = true;
            }
        }
        this.setupDefaultFieldConfig();
        this.setupFieldControlOptions();
        this.setFieldConfiguredOptions();
    }
    setupFieldControlOptions() {
        if (!this.selectedField || !this.dwFormFieldContext) {
            return;
        }
        const queryAttr = this.dwFormFieldContext.queryAttr;
        if (!queryAttr) {
            return;
        }
        this.controlOptionsComponentType = this.getFieldConfigComponent(queryAttr.Attribute, this.selectedField);
        if (this.controlOptionsComponentInstance) {
            this.configureFieldControlOptionInstance(this.controlOptionsComponentInstance);
        }
    }
    getFieldConfigComponent(attr, selectedField) {
        var _a;
        let controlOptionsComponentType = null;
        let controlTypeId = attr.MetaDataControlTypeId;
        if (this.selectedField.useControlTypeOverride) {
            if (this.selectedField.useCustomControl && this.selectedField.customControlTypeKey) {
                this.selectedFieldCustomControlDef = this.customControlTypes.find(ct => ct.key == this.selectedField.customControlTypeKey);
                return (_a = this.selectedFieldCustomControlDef) === null || _a === void 0 ? void 0 : _a.configComponent;
            }
            else {
                controlTypeId = this.selectedField.controlTypeOverride;
            }
        }
        return this.uiMetaDataConfig.controlConfigComponents[controlTypeId];
    }
    //private getFieldConfigComponent()
    configureFieldControlOptionInstance(componentInstance) {
        this.controlOptionsComponentInstance = componentInstance;
        // unsubscribe to the previous compnoent instance
        if (this.controlOptionsComponentSubscription) {
            this.controlOptionsComponentSubscription.unsubscribe();
        }
        if (this.controlOptionsComponentInstance) {
            this.controlOptionsComponentInstance.controlOptions = this.selectedField.controlOptions;
            this.controlOptionsComponentInstance.itemName = this.itemName;
            this.controlOptionsComponentInstance.fieldConfig = this.selectedField;
            //const queryAttr = this.getAttribute(this.selectedField);
            const queryAttr = this.selectedAttr;
            if (queryAttr) {
                this.controlOptionsComponentInstance.attribute = queryAttr.Attribute;
            }
            this.controlOptionsComponentInstance.setupControl();
            this.controlOptionsComponentSubscription =
                this.controlOptionsComponentInstance.controlOptionsChange.subscribe(controlOptions => {
                    this.selectedField.controlOptions = controlOptions;
                    this.updateField();
                });
        }
    }
    setupDefaultFieldConfig() {
        this.defaultValueFieldConfig = null;
    }
    setShowControlTypeOverride(value) {
        if (!value && this.selectedField) {
            this.selectedField.useCustomControl = false;
            this.selectedField.controlTypeOverride = null;
        }
    }
    setControlTypeOverride(value) {
        this.setupDefaultFieldConfig();
        this.setupFieldControlOptions();
        this.updateField();
    }
    setFieldConfiguredOptions() {
        this.fieldConfiguredOptions = getFieldConfiguredOptions(this.selectedField, this.selectedAttr);
        this.message = null;
        if (this.fieldConfiguredOptions.hasErrors) {
            this.message = {
                severity: DwMessageSeverity.error,
                messageBody: `<i class="fa fa-exclamation-triangle dw-red"></i> ${this.fieldConfiguredOptions.errorDesc}`,
            };
        }
    }
}
DwMdSectionFormFieldConfigComponent.ɵfac = function DwMdSectionFormFieldConfigComponent_Factory(t) { return new (t || DwMdSectionFormFieldConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService)); };
DwMdSectionFormFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionFormFieldConfigComponent, selectors: [["dw-md-section-form-field-config"]], inputs: { selectedField: "selectedField", selectedAttr: "selectedAttr", itemName: "itemName", contextNames: "contextNames", contextMdList: "contextMdList" }, outputs: { selectedFieldChange: "selectedFieldChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 7, vars: 4, consts: [[4, "ngIf"], [1, "label"], [3, "message"], [3, "selected"], ["pTemplate", "header"], ["pTemplate", "content"], ["headerOld", "Default Value"], ["headerOld", "Field Layout"], ["headerOld", "Classes"], ["headerOld", "Read Only/Visibility"], ["headerOld", "Control Overrides"], ["headerOld", "Control Settings", 4, "ngIf"], ["headerOld", "Validation"], ["title", "Has Configurations", 1, "fas", "fa-wrench", "dw-orange", "ml-1", 3, "hidden"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", "placeholder", "None", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [3, "defaultValue", "contextNames", "queryAttribute", "defaultValueChange"], ["dwRow", "", 3, "hidden"], ["title", "Column size using a 12 column layout", 1, "fa", "fa-info-circle"], ["dwNumeric", "", "type", "number", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Skips columns before placing this field", 1, "fa", "fa-info-circle"], [3, "conditionalClasses", "contextNames", "itemName", "classNames", "classLabels", "conditionalClassesChange"], [1, "expr-column-full"], [3, "ngModel", "contextNames", "item", "ngModelChange"], ["title", "Causes fields to move when the visiblity changes", 1, "fa", "fa-info-circle"], ["title", "Change the control type from the default (Attribute Control Type) or use a custom control", 1, "fa", "fa-info-circle"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12", 4, "ngIf"], [3, "config", "configContext", "configChange"], ["optionLabel", "name", "optionValue", "key", "display", "chip", "filter", "true", "scrollHeight", "300px", "appendTo", "body", 3, "ngModel", "options", "showClear", "ngModelChange"], [3, "ngModel", "lookupId", "ngModelChange"], ["headerOld", "Control Settings"], [3, "component", "configure"]], template: function DwMdSectionFormFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMdSectionFormFieldConfigComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "label", 1);
        ɵngcc0.ɵɵtext(3, "Field:\u00A0 ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "dw-message", 2);
        ɵngcc0.ɵɵtemplate(6, DwMdSectionFormFieldConfigComponent_p_accordion_6_Template, 23, 2, "p-accordion", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedFieldContextMd);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.selectedField == null ? null : ctx.selectedField.attrName, "\n");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedField);
    } }, directives: function () { return [ɵngcc4.NgIf, DwMessageComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc6.PrimeTemplate, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc10.InputSwitch, DwDefaultValueComponent, DwNumericDirective, ɵngcc3.NumberValueAccessor, DwConditionalFieldClassesComponent, DwExpressionPickerControlComponent, DwSelectLookupConfigComponent, ɵngcc22.Dropdown, DwSearchSelectLookupComponent, DwDynamicLoaderComponent, DwFieldValidationConfigComponent]; }, styles: [_c92], encapsulation: 2 });
DwMdSectionFormFieldConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwSectionConfigStateService }
];
DwMdSectionFormFieldConfigComponent.propDecorators = {
    selectedField: [{ type: Input }],
    selectedFieldChange: [{ type: Output }],
    selectedAttr: [{ type: Input }],
    itemName: [{ type: Input }],
    contextNames: [{ type: Input }],
    contextMdList: [{ type: Input }]
};

class DwDynamicControlComponent extends DwControlBaseComponent {
    constructor(resolver, configService) {
        super();
        this.resolver = resolver;
        this.colSize = 6;
        this.submitted = false;
        this.isRequired = false;
        this.uiMetaDataConfig = configService.getConfig(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        this.loadComponent();
    }
    loadComponent() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef)
            return;
        if (!this.fieldDef)
            return;
        //console.log("dw-dynamic-control -  loadComonent - ", this.fieldDef);
        let component = this.determineComponent(this.fieldDef);
        const componentFactory = this.resolver.resolveComponentFactory(component);
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent(componentFactory);
        this.componentInstance = this.componentRef.instance;
        this.componentInstance.fieldDef = this.fieldDef;
        this.componentInstance.formGroup = this.formGroup;
    }
    determineComponent(fieldDef) {
        // Get the configured component (these can be overriden in config)
        var component = this.uiMetaDataConfig.controlComponents[fieldDef.controlType];
        if (!component)
            return this.uiMetaDataConfig.defaultControlComponent;
        return component;
    }
    ngOnChanges(changes) {
        if (!this.componentInstance)
            return;
        if (changes.fieldDef && changes.fieldDef.currentValue) {
            this.componentInstance.fieldDef = this.fieldDef;
            this.loadComponent();
        }
        if (changes.formGroup && changes.formGroup.currentValue) {
            this.componentInstance.formGroup = this.formGroup;
            this.loadComponent();
        }
    }
}
DwDynamicControlComponent.ɵfac = function DwDynamicControlComponent_Factory(t) { return new (t || DwDynamicControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken)); };
DwDynamicControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDynamicControlComponent, selectors: [["dw-dynamic-control"]], viewQuery: function DwDynamicControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, inputs: { colSize: "colSize", submitted: "submitted", fieldDef: "fieldDef", formGroup: "formGroup" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 0, consts: [["dw-component-host", ""]], template: function DwDynamicControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, DwDynamicControlComponent_ng_template_1_Template, 0, 0, "ng-template", 0);
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [DwComponentHost], encapsulation: 2 });
DwDynamicControlComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];
DwDynamicControlComponent.propDecorators = {
    fieldDef: [{ type: Input }],
    formGroup: [{ type: Input }],
    colSize: [{ type: Input }],
    submitted: [{ type: Input }],
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }]
};

var __decorate$_ = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$K = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwSearchSelectLookupComponent extends DwSelectLookupComponent {
    constructor() {
        super(...arguments);
        this.placeholder = "";
        this.filterShowThreshold = 10;
        this.alwaysShowFilter = false;
        this.showClear = true;
        this.lookupItemsPrime = [];
        this.showFilter = false;
        this.finalLookupItems = [];
        this.setupComplete = false;
        this.useGroups = false;
        //FILTER_SHOW_THRESHOLD = 15;
        this.virtualScroll = false;
        this.virtualScrollThreshold = 50;
        this.virtualScrollItems = 30;
    }
    ngOnInit() {
        this.addBlankItem();
        super.ngOnInit();
    }
    lookupLoadComplete() {
        var _a, _b, _c, _d;
        if (((_a = this.lookupDef) === null || _a === void 0 ? void 0 : _a.GroupByAttributeId) || ((_b = this.lookupDef) === null || _b === void 0 ? void 0 : _b.GroupByTemplate)) {
            this.useGroups = true;
            this.finalLookupItems = this.groupLookups(this.lookupItems);
        }
        else {
            this.useGroups = false;
            // ensure we're working with an array, otherwise a runtime error will occur
            this.finalLookupItems = Array.isArray(this.lookupItems) ? [...this.lookupItems] : [];
            this.addBlankItem();
        }
        if (this.alwaysShowFilter || ((_c = this.lookupItems) === null || _c === void 0 ? void 0 : _c.length) > this.filterShowThreshold) {
            this.showFilter = true;
        }
        else {
            this.showFilter = false;
        }
        if (((_d = this.lookupItems) === null || _d === void 0 ? void 0 : _d.length) > this.virtualScrollThreshold) {
            this.virtualScroll = true;
        }
        else {
            this.virtualScroll = false;
        }
        this.setupComplete = true;
    }
    groupLookups(lookupItems) {
        const itemGroups = [];
        let currentGroup;
        for (const item of lookupItems) {
            if ((currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.label) !== item.GroupName) {
                currentGroup = {
                    label: item.GroupName,
                    value: item.GroupName,
                    items: []
                };
                itemGroups.push(currentGroup);
            }
            currentGroup.items.push(item);
            /*
                label: item.Display,
                value: item.Id
            }); */
        }
        return itemGroups;
    }
    addBlankItem() {
        if (!this.showBlankOption) {
            return;
        }
        let item = {
            Display: this.blankOptionText || " ",
            Id: null,
        };
        if (this.finalLookupItems) {
            this.finalLookupItems.splice(0, 0, item);
        }
    }
    translateTo(value) {
        if (value == null || value == undefined) {
            value = null;
        }
        else {
            value = value.toString();
        }
        return super.translateTo(value);
    }
}
DwSearchSelectLookupComponent.ɵfac = function DwSearchSelectLookupComponent_Factory(t) { return ɵDwSearchSelectLookupComponent_BaseFactory(t || DwSearchSelectLookupComponent); };
DwSearchSelectLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSearchSelectLookupComponent, selectors: [["dw-search-select-lookup"]], inputs: { placeholder: "placeholder", filterShowThreshold: "filterShowThreshold", alwaysShowFilter: "alwaysShowFilter", showClear: "showClear", virtualScrollThreshold: "virtualScrollThreshold", virtualScrollItems: "virtualScrollItems" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwSearchSelectLookupComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 11, consts: [["wrapControl", "true", 3, "showSuffix"], ["control2", ""], ["optionLabel", "Display", "display", "chip", "scrollHeight", "300px", "appendTo", "body", 3, "placeholder", "options", "resetFilterOnHide", "group", "optionValue", "ngModel", "showClear", "style", "filter", "virtualScroll", "itemSize", "ngModelChange", 4, "ngIf"], ["suffix", "", 2, "padding", "5px"], [3, "hidden", "click"], [3, "hidden", "title", "click"], [4, "ngIf"], ["optionLabel", "Display", "display", "chip", "scrollHeight", "300px", "appendTo", "body", 3, "placeholder", "options", "resetFilterOnHide", "group", "optionValue", "ngModel", "showClear", "filter", "virtualScroll", "itemSize", "ngModelChange"]], template: function DwSearchSelectLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-control-wrapper-with-icons", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwSearchSelectLookupComponent_p_dropdown_2_Template, 1, 13, "p-dropdown", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵlistener("click", function DwSearchSelectLookupComponent_Template_i_click_4_listener($event) { return ctx.openItem($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "i", 5);
        ɵngcc0.ɵɵlistener("click", function DwSearchSelectLookupComponent_Template_i_click_5_listener($event) { return ctx.openItem($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwSearchSelectLookupComponent_span_6_Template, 2, 1, "span", 6);
        ɵngcc0.ɵɵtext(7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("showSuffix", ctx.options == null ? null : ctx.options.showLink);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.setupComplete);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap((ctx.options == null ? null : ctx.options.linkIconClass) || "fa fa-external-link");
        ɵngcc0.ɵɵproperty("hidden", ctx.options == null ? null : ctx.options.linkTooltip);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap((ctx.options == null ? null : ctx.options.linkIconClass) || "fa fa-external-link");
        ɵngcc0.ɵɵproperty("hidden", !(ctx.options == null ? null : ctx.options.linkTooltip))("title", ctx.options == null ? null : ctx.options.linkTooltip);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.additionalDataField);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, directives: [DwControlWrapperWithIconsComponent, ɵngcc4.NgIf, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwSearchSelectLookupComponent.propDecorators = {
    placeholder: [{ type: Input }],
    filterShowThreshold: [{ type: Input }],
    alwaysShowFilter: [{ type: Input }],
    showClear: [{ type: Input }],
    virtualScrollThreshold: [{ type: Input }],
    virtualScrollItems: [{ type: Input }]
};
__decorate$_([
    DwInputConverter(booleanConverter),
    __metadata$K("design:type", Boolean)
], DwSearchSelectLookupComponent.prototype, "alwaysShowFilter", void 0);
__decorate$_([
    DwInputConverter(booleanConverter),
    __metadata$K("design:type", Boolean)
], DwSearchSelectLookupComponent.prototype, "showClear", void 0);
__decorate$_([
    DwInputConverter(intConverter),
    __metadata$K("design:type", Number)
], DwSearchSelectLookupComponent.prototype, "virtualScrollThreshold", void 0);
__decorate$_([
    DwInputConverter(intConverter),
    __metadata$K("design:type", Number)
], DwSearchSelectLookupComponent.prototype, "virtualScrollItems", void 0);

var __decorate$$ = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$L = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwAutoCompleteLookupComponent extends DwSelectLookupComponent {
    constructor() {
        super(...arguments);
        this.placeholder = "";
        this.virtualScroll = false;
        this.virtualScrollThreshold = 50;
        this.virtualScrollItems = 30;
        this.searchSubject = new Subject();
        this.showDebugMessages = false;
        this.ignoreDuplicateSetValues = true;
        // Tracks the last search string that was processed - determine if a search has already been ran
        this.lastSearchText = null;
    }
    ngOnInit() {
        super.ngOnInit();
        this.options = Object.assign(Object.assign({}, this.defaultOptions), this.options);
        this.setupSearchWatch();
    }
    parametersChanged() {
        this.lastSearchText = null;
    }
    get defaultOptions() {
        return this.uiMetaDataConfig.autoCompleteLookupOptionDefaults;
        // return {
        //     maxResults: 30,
        //     searchType: DwLookupSearchType.startsWith,
        //     waitTimeMs: 300,
        //     showChipWhenSelected: true
        // };
    }
    clearItem() {
        this.setTranslatedValue(null);
    }
    ngOnChanges(simpleChanges) {
        super.ngOnChanges(simpleChanges);
        if (simpleChanges.options && !simpleChanges.options.firstChange) {
            // Use defaults if there not are specified
            this.options = Object.assign(Object.assign({}, this.defaultOptions), this.options);
        }
    }
    translateFrom(value) {
        if (value) {
            if (value.Id) {
                return value.Id;
            }
            if (this.showDebugMessages) {
                console.warn('DwAutocomplete - translate from an unknown, non-null value', value);
            }
        }
        return null;
    }
    translateTo(value) {
        var _a, _b, _c, _d, _e;
        // if this value is already set, then we're finished
        if (((_a = this.currentLookup) === null || _a === void 0 ? void 0 : _a.Id) == value) {
            return this.currentLookup;
        }
        if (this.showDebugMessages) {
            console.log(`DwAutoComplete ${this.formControlName} (${this.instanceId}) - ${(_b = this.lookupDef) === null || _b === void 0 ? void 0 : _b.MetaDataLookupId} (${(_c = this.lookupDef) === null || _c === void 0 ? void 0 : _c.UniqueItemName}) - set value to ${value}`);
        }
        if (this.setCurrentLookup(value)) {
            return this.currentLookup;
        }
        if (this.showDebugMessages) {
            console.log(`DwAutoComplete ${this.formControlName}(${this.instanceId}) - ${(_d = this.lookupDef) === null || _d === void 0 ? void 0 : _d.MetaDataLookupId} (${(_e = this.lookupDef) === null || _e === void 0 ? void 0 : _e.UniqueItemName}) - not found`);
        }
        if (value) {
            let lookupItem = findWhere(this.lookupItems, { Id: value });
            // If the data was already loaded, then we need to use the full lookup list
            if (!lookupItem && this.allLookupItems) {
                lookupItem = findWhere(this.allLookupItems, { Id: value });
            }
            if (lookupItem) {
                return lookupItem;
            }
        }
        return value;
    }
    setCurrentLookup(value) {
        var _a;
        if (super.setCurrentLookup(value)) {
            return true;
        }
        if (!this.currentLookup && this.useServerSearch && value) {
            if (!this.lookupDef) {
                return false;
            }
            //let params = this.getQueryParams();
            let params = this.dwLookupParameterUtilService.getQueryParams(this.lookupDef, this.paramValues);
            if (!params) {
                console.warn(`DwAutoCompleteLookup - No parameters so can't call lookup`);
                // Attempting to clear out the lookup items if its not found - 8-15-2023
                this.setupLookupItems([]);
                this.setCurrentLookup(null);
                return false;
            }
            this.dwMetaDataService.getSingleLookupItem(this.lookupId, value, this.useServerSearchParams, params)
                .subscribe(item => {
                if (item) {
                    this.setupLookupItems([item]);
                }
                else {
                    // Attempting to clear out the lookup items if its not found - 8-15-2023
                    this.setupLookupItems([]);
                    this.setCurrentLookup(null);
                }
            });
            // return true, since we are loading it which will start the process over
            return true;
        }
        // Only clear if the id is set, this means it's tied to a lookup (otherwise it is a partial search and that clears the auto-complete text box)
        if (!this.currentLookup && ((_a = this.translatedValue) === null || _a === void 0 ? void 0 : _a.id)) {
            this.translatedValue = null;
        }
    }
    // trigger when the lookup params changed
    lookupParamsChanged() {
        super.lookupParamsChanged();
        this.lastSearchText = null;
        this.lastResultSearch = null;
    }
    searchStart(search) {
        let searchText = search.query.toUpperCase();
        this.searchSubject.next(searchText);
    }
    setupSearchWatch() {
        this.searchSubject.asObservable()
            .pipe(debounceTime(this.options.waitTimeMs))
            .subscribe(searchText => {
            //console.log(`Search - ${searchText} - ${new Date().toString()}`)
            this.search(searchText);
        });
    }
    search(searchText) {
        if (this.useServerSearch) {
            this.searchServer(searchText);
            return;
        }
        this.searchResults(searchText, this.allLookupItems);
    }
    searchResults(searchText, results) {
        const filterResults = [];
        for (let lookupItem of results) {
            if (this.isSearchMatch(lookupItem.Display, searchText)) {
                filterResults.push(lookupItem);
            }
            if (filterResults.length >= this.options.maxResults) {
                break;
            }
        }
        this.lookupItems = filterResults;
        this.handleNoRowsFound(searchText);
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
    }
    isSearchMatch(itemValue, searchText) {
        if (searchText.length == 0) {
            return true;
        }
        if (searchText.indexOf('%') == -1) {
            switch (this.options.searchType) {
                case DwLookupSearchType.contains:
                    return (itemValue.toUpperCase().indexOf(searchText) >= 0);
                case DwLookupSearchType.startsWith:
                    return (itemValue.toUpperCase().indexOf(searchText) == 0);
                case DwLookupSearchType.endsWith:
                    return (itemValue.toUpperCase().indexOf(searchText) == itemValue.length - searchText.length);
            }
        }
        const parts = searchText.split('%');
        let searchTarget = itemValue.toUpperCase();
        // check if the first part is match
        if (!this.isSearchMatch(searchTarget, parts[0])) {
            return false;
        }
        if (parts.length == 1) {
            return true;
        }
        for (let part of parts) {
            if (part.length == 0) {
                continue;
            }
            const index = searchTarget.indexOf(part);
            if (index == -1) {
                return false;
            }
            searchTarget = searchTarget.substring(index + part.length, searchTarget.length);
        }
        return true;
    }
    handleNoRowsFound(searchText) {
        var _a;
        this.noResultMessage = '';
        if (this.lookupItems.length > 0) {
            return;
        }
        if (searchText) {
            this.noResultMessage = ((_a = this.options) === null || _a === void 0 ? void 0 : _a.noResultsMessage) || `No results found`;
        }
    }
    searchServer(searchText) {
        // if (this.lastSearchText!=null && this.lastSearchText == searchText) {
        //     this.searchResults(searchText, this.allLookupItems);
        //     return;
        // }
        var _a;
        const searchParams = {
            SearchString: searchText,
            PagingInfo: { PageNo: 1, PageSize: this.options.maxResults },
            // AlternateSearchField: 'ItemName',
            SearchType: this.options.searchType
        };
        // Check if we can use the already loaded results
        if (((_a = this.allLookupItems) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.allLookupItems.length < this.options.maxResults) {
            let match = false;
            // We've loaded all results, now check if the search type is valid
            switch (this.options.searchType) {
                case DwLookupSearchType.startsWith:
                    match = (searchText.startsWith(this.lastServerSearchText));
                    break;
                case DwLookupSearchType.endsWith:
                    match = (searchText.endsWith(this.lastServerSearchText));
                    break;
                case DwLookupSearchType.contains:
                    match = (searchText.indexOf(this.lastServerSearchText) >= 0);
                    break;
            }
            if (match) {
                // Now we search the already loaded results
                this.searchResults(searchText, this.allLookupItems);
                return;
            }
        }
        //const queryParams = this.getQueryParams();
        let queryParams = this.dwLookupParameterUtilService.getQueryParams(this.lookupDef, this.paramValues);
        if (!queryParams) {
            // We're waiting on paramters so we need to show an empty array//, other it would be an empty array if there aren't any
            this.allLookupItems = [];
            this.lookupItems = [];
            this.handleNoRowsFound(searchText);
            if (!this.destroyed) {
                this.cdr.detectChanges();
            }
            return;
        }
        if (this.serverSearchSubscription) {
            // console.log(`Setting next search - ${searchText}`);
            this.nextSearch = searchText;
            return;
        }
        // Don't repeat the same search over and over
        if (this.lastSearchText == searchText && this.allLookupItems) {
            // Reset arrays so the UI will update 
            this.allLookupItems = [...this.allLookupItems];
            this.lookupItems = [...this.lookupItems];
            if (!this.destroyed) {
                this.cdr.detectChanges();
            }
            return;
        }
        //console.log(`Start Server Search - ${searchText}`);
        this.serverSearchSubscription = this.dwMetaDataService.searchLookup(this.lookupId, searchParams, queryParams)
            .subscribe(results => {
            this.lastServerSearchText = searchText;
            this.lastSearchText = searchText;
            this.allLookupItems = results;
            this.lookupItems = results;
            //console.log(`Completed Server Search - ${searchText} - Items: ${results.length}`);
            this.handleNoRowsFound(searchText);
            if (!this.destroyed) {
                this.cdr.detectChanges();
            }
            this.performingSearch = false;
            this.serverSearchSubscription = null;
            if (this.nextSearch) {
                //console.log(`Starting next search - ${this.nextSearch}`);
                this.searchServer(this.nextSearch);
                this.nextSearch = null;
            }
        });
    }
    lookupLoadComplete() {
        this.lookupItems = [];
        // Initilaize based on the control's value
        if (this.value) {
            if (typeof (this.value) === 'number') {
                this.value = this.value.toString();
            }
            const lookupItem = this.allLookupItems.find(li => li.Id == this.value);
            if (lookupItem) {
                this.translatedValue = lookupItem;
                this.lookupItems = [
                    lookupItem
                ];
                this.setCurrentLookup(this.value);
            }
        }
    }
}
DwAutoCompleteLookupComponent.ɵfac = function DwAutoCompleteLookupComponent_Factory(t) { return ɵDwAutoCompleteLookupComponent_BaseFactory(t || DwAutoCompleteLookupComponent); };
DwAutoCompleteLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAutoCompleteLookupComponent, selectors: [["dw-auto-complete-lookup"]], inputs: { placeholder: "placeholder", virtualScrollThreshold: "virtualScrollThreshold", virtualScrollItems: "virtualScrollItems", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwAutoCompleteLookupComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 3, consts: [[4, "ngIf"], ["inputStyleClass", "form-control", "field", "Display", "appendTo", "body", "baseZIndex", "1100", "dropdown", "true", "dropdownMode", "current", "virtualScroll", "true", "scrollHeight", "300px", 3, "ngModel", "disabled", "suggestions", "placeholder", "ngModelChange", "completeMethod"], [1, "auto-complete-no-result", 3, "hidden"], ["wrapControl", "true", 3, "showSuffix"], ["control2", "", 1, "dw-chip-container"], [1, "dw-chip", "dw-chip-100"], [1, "dw-chip-label-with-remove"], [1, "dw-chip-icon", 3, "click"], [1, "fa", "fa-times-circle"], ["suffix", "", 2, "padding", "5px"], [3, "hidden", "click"], [3, "hidden", "title", "click"]], template: function DwAutoCompleteLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwAutoCompleteLookupComponent_ng_container_0_Template, 4, 9, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, DwAutoCompleteLookupComponent_ng_container_1_Template, 11, 9, "ng-container", 0);
        ɵngcc0.ɵɵtext(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.translatedValue == null ? null : ctx.translatedValue.Id) || !(ctx.options == null ? null : ctx.options.showChipWhenSelected));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.translatedValue == null ? null : ctx.translatedValue.Id) && (ctx.options == null ? null : ctx.options.showChipWhenSelected));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, directives: [ɵngcc4.NgIf, ɵngcc30.AutoComplete, ɵngcc16.BsDropdownDirective, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwControlWrapperWithIconsComponent], encapsulation: 2 });
DwAutoCompleteLookupComponent.propDecorators = {
    placeholder: [{ type: Input }],
    options: [{ type: Input }],
    virtualScrollThreshold: [{ type: Input }],
    virtualScrollItems: [{ type: Input }]
};
__decorate$$([
    DwInputConverter(intConverter),
    __metadata$L("design:type", Number)
], DwAutoCompleteLookupComponent.prototype, "virtualScrollThreshold", void 0);
__decorate$$([
    DwInputConverter(intConverter),
    __metadata$L("design:type", Number)
], DwAutoCompleteLookupComponent.prototype, "virtualScrollItems", void 0);

class DwContentPreferences extends DwUiPreferencesBase {
    constructor() {
        super(DwUiConfigType.content);
        this.items = [];
    }
}

class DwContentConfigEditComponent {
    constructor(uiConfigRegistry) {
        this.uiConfigRegistry = uiConfigRegistry;
        this.itemFields = [];
        this.itemFieldsReadOnly = [];
        this.showMissing = false;
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
        var _a, _b;
        this.preferences = this.modalConfig.data.preferences;
        // Remove blank items
        this.preferences.items = ((_b = (_a = this.preferences) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.filter(item => item && item.name)) || [];
        this.setupForm();
        this.setupInitialState(this.modalConfig.data.designerState);
    }
    setupInitialState(designerState) {
        if (!(designerState === null || designerState === void 0 ? void 0 : designerState.sectionKey)) {
            return;
        }
        const contentItem = this.preferences.items.find(i => i.name == designerState.sectionKey);
        if (!contentItem) {
            return;
        }
        this.activeIndex = this.preferences.items.indexOf(contentItem);
    }
    setupForm() {
        this.formGroup = new FormGroup({});
        this.formArray = new FormArray([]);
        this.formGroup.addControl("items", this.formArray);
        let sortedItems = this.sortItems(this.preferences.items);
        this.preferences.items = sortedItems;
        for (let item of sortedItems) {
            if (item.isMissing) {
                this.hasHiddenContent = true;
            }
            const fc = new FormControl();
            //fc.setValue(item.content);
            const subFormGroup = new FormGroup({});
            const useDefaultContentFC = new FormControl();
            const defaultContentFC = new FormControl();
            defaultContentFC.disable();
            subFormGroup.addControl("content", new FormControl());
            subFormGroup.addControl("defaultContent", defaultContentFC);
            subFormGroup.addControl("name", new FormControl());
            subFormGroup.addControl("isMissing", new FormControl());
            subFormGroup.addControl("useDefaultContent", useDefaultContentFC);
            subFormGroup.addControl("display", new FormControl());
            subFormGroup.addControl("componentItem", new FormControl());
            subFormGroup.addControl("componentName", new FormControl());
            subFormGroup.addControl("config", new FormControl({}));
            var fieldConfig = this.buildFieldConfig(item, false);
            var fieldConfigReadOnly = this.buildFieldConfig(item, true);
            this.itemFields.push(fieldConfig);
            this.itemFieldsReadOnly.push(fieldConfigReadOnly);
            this.formArray.push(subFormGroup);
        }
        this.formGroup.patchValue(this.preferences);
        this.formArray.patchValue(sortedItems);
        //console.log("Sorted Items", sortedItems);
    }
    getTemplateName(contentFormGroup) {
        const itemPref = contentFormGroup.value;
        if (itemPref.useDefaultContent) {
            return ContentTemplate.defaultContent;
        }
        if (itemPref.componentItem) {
            return ContentTemplate.editComponent;
        }
        return ContentTemplate.editContent;
    }
    sortItems(items) {
        return sortBy(items, i => i.contentOrder);
    }
    copyDefaultContent(index) {
        const formGroup = this.formArray.controls[index];
        const content = formGroup.get("content");
        const defaultContent = formGroup.get("defaultContent");
        content.setValue(defaultContent.value);
    }
    buildFieldConfig(item, useDefaultContent) {
        const fieldConfig = new DwFormFieldConfig();
        let fieldName = "content";
        if (useDefaultContent) {
            fieldName = "defaultContent";
        }
        fieldConfig.controlType = item.controlType;
        fieldConfig.label = item.display;
        fieldConfig.attrName = fieldName;
        fieldConfig.hideLabel = true;
        fieldConfig.isReadOnly = useDefaultContent;
        fieldConfig.readOnlyMissingDataText = 'No Content';
        fieldConfig.attr = {
            AttributeName: fieldName,
            AttributeType: DwAttributeType.Text,
            Display: item.display
        };
        return fieldConfig;
    }
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        this.updatePreferences();
        result.closeModal = true;
        result.cancelled = false;
        result.data = {
            preferences: this.preferences
        };
        switch (buttonConfig.command) {
            case DwButtonCommand.cancel:
                result.cancelled = true;
        }
        return of(result);
    }
    updatePreferences() {
        var formData = this.formGroup.value;
        for (let item of this.preferences.items) {
            const index = this.preferences.items.indexOf(item);
            const formDataItem = formData.items[index];
            item.componentName = formDataItem.componentName;
            item.content = formDataItem.content;
            item.config = formDataItem.config;
            item.useDefaultContent = formDataItem.useDefaultContent;
        }
    }
}
DwContentConfigEditComponent.ɵfac = function DwContentConfigEditComponent_Factory(t) { return new (t || DwContentConfigEditComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwContentConfigEditComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContentConfigEditComponent, selectors: [["dw-content-config-edit"]], decls: 4, vars: 1, consts: [[4, "ngIf"], [4, "editComponentTemplate"], [4, "editContentTemplate"], [4, "defaultContentTemplate"], ["dwRow", "", 4, "ngIf"], [3, "formGroup"], ["formArrayName", "items", 3, "multiple"], [4, "ngFor", "ngForOf"], ["dwRow", ""], ["dwCol", "10"], [1, "label"], [3, "ngModel", "ngModelChange"], [3, "selected", 4, "ngIf"], [3, "selected"], ["dwCol", "2"], ["formControlName", "useDefaultContent"], ["dwCol", "12"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["dwDynamicField", "", 3, "fieldDef", "formGroup"], ["title", "Use the default content as a starting point (or recovery)", 1, "btn-sm", "btn-success", 3, "click"], [3, "subFormGroup"], ["formControlName", "componentName", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"]], template: function DwContentConfigEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwContentConfigEditComponent_div_0_Template, 6, 5, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwContentConfigEditComponent_1_Template, 1, 0, undefined, 1);
        ɵngcc0.ɵɵtemplate(2, DwContentConfigEditComponent_2_Template, 1, 0, undefined, 2);
        ɵngcc0.ɵɵtemplate(3, DwContentConfigEditComponent_3_Template, 1, 0, undefined, 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc3.FormArrayName, ɵngcc4.NgForOf, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc11.AccordionTab, ɵngcc6.Header, ɵngcc10.InputSwitch, ɵngcc3.FormControlName, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, DwDynamicFieldComponent, DwContentConfigComponentComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x]; }, styles: [""] });
DwContentConfigEditComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
var ContentTemplate;
(function (ContentTemplate) {
    ContentTemplate["editContent"] = "editContent";
    ContentTemplate["editComponent"] = "editComponent";
    ContentTemplate["defaultContent"] = "defaultContent";
})(ContentTemplate || (ContentTemplate = {}));

class DwContentService {
    constructor(configService, dwMetaDataService, uiConfigService, dwCacheService, dwModalService) {
        this.dwMetaDataService = dwMetaDataService;
        this.uiConfigService = uiConfigService;
        this.dwCacheService = dwCacheService;
        this.dwModalService = dwModalService;
        this.inMemoryUpdateCommand = 'inMemoryUpdate';
        this.uiMetaDataConfig = configService.getConfig(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
        this.contentDefaultPreferences = this.uiMetaDataConfig.contentDefaultPreferences;
    }
    getPreferencesHierarchy(configKey, useLoadedPreferences, componentSetPreferences, item) {
        let ob = of(null);
        if (item) {
            ob = this.dwMetaDataService.getMetaDataItemId(item);
        }
        return ob.pipe(mergeMap(metaDataItemId => {
            return this.uiConfigService.getPreferencesHierarchy(configKey, DwUiConfigType.content, this.contentDefaultPreferences, componentSetPreferences, useLoadedPreferences)
                .pipe(map(prefHierarchy => {
                if (metaDataItemId) {
                    prefHierarchy.metaDataItemId = metaDataItemId;
                }
                return prefHierarchy;
            }));
        }));
    }
    showContentModal(contentPreferences, designerState) {
        let modalConfig = new DwModalConfig();
        const inMemoryButton = {
            buttonText: 'In Memory update',
            buttonTitle: 'Use this to test settings',
            buttonClass: 'btn btn-warning',
            command: this.inMemoryUpdateCommand,
            buttonType: DwButtonType.standard,
            isCancel: false
        };
        modalConfig.title = "Edit Content";
        modalConfig.component = DwContentConfigEditComponent;
        modalConfig.buttons = [
            DwModalButtonStandardConfigs.instance.saveButton,
            inMemoryButton,
            DwModalButtonStandardConfigs.instance.cancelButton
        ];
        modalConfig.allowFullScreen = true;
        modalConfig.data = {
            preferences: contentPreferences,
            designerState: designerState
        };
        modalConfig.modalSize = DwModalSize.large;
        return this.dwModalService.showModal(modalConfig);
    }
    editContent(contentPreferenceHierarchy) {
        var subject = new Subject();
        var finalPreferences = this.uiConfigService.getFinalPreferences(contentPreferenceHierarchy, false);
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Edit Content";
        modalConfig.component = DwContentConfigEditComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.allowFullScreen = true;
        modalConfig.data = {
            preferences: finalPreferences
        };
        modalConfig.modalSize = DwModalSize.large;
        this.dwModalService.showModal(modalConfig)
            .subscribe(r => {
            if (!r.cancelled) {
                // Ensure there is a change befor updating
                if (areEqual(finalPreferences, r.data.preferences)) {
                    subject.next(contentPreferenceHierarchy);
                    return;
                }
                // Clear default content before saving it
                this.clearDefaultContent(r.data.preferences);
                contentPreferenceHierarchy.loadedPreferences = r.data.preferences;
                this.uiConfigService.savePreferencesHierarchy(contentPreferenceHierarchy)
                    .subscribe((result) => {
                    subject.next(result);
                });
            }
        });
        return subject.asObservable();
    }
    clearDefaultContent(preferences) {
        if (!preferences || !preferences.items) {
            for (let item of preferences.items) {
                item.defaultContent = "";
            }
        }
    }
}
DwContentService.ɵfac = function DwContentService_Factory(t) { return new (t || DwContentService)(ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwUiConfigService), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwModalService)); };
DwContentService.ɵprov = ɵɵdefineInjectable({ factory: function DwContentService_Factory() { return new DwContentService(ɵɵinject(DwConfigServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwUiConfigService), ɵɵinject(DwCacheService), ɵɵinject(DwModalService)); }, token: DwContentService, providedIn: "root" });
DwContentService.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwUiConfigService },
    { type: DwCacheService },
    { type: DwModalService }
];

class DwContentConfigWidgetComponent extends DwUiPanelWidgetBaseComponent {
    constructor(fb, dwEventService, dwModalService, dwContextService, dwContentService, dwUiConfigService, dwDesignerStateService) {
        super(fb, dwDesignerStateService);
        this.dwEventService = dwEventService;
        this.dwModalService = dwModalService;
        this.dwContextService = dwContextService;
        this.dwContentService = dwContentService;
        this.dwUiConfigService = dwUiConfigService;
        this.contextDefList = [];
    }
    get contentPreferences() {
        return this.preferences;
    }
    get contentPreferencesHierarchy() {
        return this.preferencesHierarchy;
    }
    startConfigureSection(state) {
        this.configContent(state);
    }
    setupEvents() {
    }
    createForm(fb) {
        return this.fb.group({
            contextNames: [null],
        });
    }
    onSubmit() {
        //console.log(this.configForm.value);
    }
    configContent(state) {
        this.dwContentService.showContentModal(this.preferences, state)
            .subscribe(modalResult => {
            if (modalResult.cancelled) {
                return;
            }
            const preferencesResult = modalResult.data.preferences;
            if (areEqual(this.preferences, preferencesResult)) {
                return;
            }
            // Clear default content
            this.dwContentService.clearDefaultContent(preferencesResult);
            // Can't update item directory
            //this.preferences = r.data.preferences;
            if (modalResult.buttonCommand == this.dwContentService.inMemoryUpdateCommand) {
                this.preferencesChange.emit(preferencesResult);
            }
            else {
                this.preferenceChangeWithSave.emit(preferencesResult);
            }
        });
        // this.subscriptions.push(
        //     this.dwContentService.editContent(this.contentPreferencesHierarchy)
        //         .subscribe((updatedPreferencesHierarchy)=> {
        //             this.preferences = this.dwUiConfigService.getFinalPreferences(this.preferencesHierarchy);
        //             this.preferencesHierarchy = updatedPreferencesHierarchy;
        //     })
        // );
    }
    configSet() {
        super.configSet();
        this.setupConfig();
    }
    setupConfig() {
        this.contextDefinitions = this.dwContextService.contextDefinitions;
        for (let contextDef of this.dwContextService.contextDefinitions) {
            this.contextDefList.push({
                label: contextDef.contextDisplay,
                value: contextDef.contextName
            });
        }
    }
    updateFilters() {
        this.onFormChange();
    }
}
DwContentConfigWidgetComponent.ɵfac = function DwContentConfigWidgetComponent_Factory(t) { return new (t || DwContentConfigWidgetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwContentService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService)); };
DwContentConfigWidgetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContentConfigWidgetComponent, selectors: [["app-dw-content-config-widget"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "formGroup", "ngSubmit"], ["header", "Content"], ["dwRow", ""], ["dwCol", "12"], [1, "btn-sm", "btn-success", 3, "click"], ["header", "Other"], ["formControlName", "contextNames", "display", "chip", 3, "options"], ["pTemplate", "selectedItems"], ["class", "btn btn-success btn-xs tag", 4, "ngFor", "ngForOf"], [1, "btn", "btn-success", "btn-xs", "tag"]], template: function DwContentConfigWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwContentConfigWidgetComponent_div_0_Template, 17, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.preferences);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc6.PrimeTemplate, ɵngcc4.NgForOf], styles: [""] });
DwContentConfigWidgetComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwEventService },
    { type: DwModalService },
    { type: DwContextService },
    { type: DwContentService },
    { type: DwUiConfigService },
    { type: DwDesignerStateService }
];

class DwContentManagerComponent extends DwContextConfigurableBaseComponent {
    constructor(uiConfigService, dwEventService, dwContextService, dwSecurityUserService, dwConfigService, dwContentService) {
        super(uiConfigService, dwEventService, dwContextService, dwSecurityUserService, dwConfigService);
        this.uiConfigService = uiConfigService;
        this.dwEventService = dwEventService;
        this.dwContextService = dwContextService;
        this.dwContentService = dwContentService;
        this.configKey = 'None';
        this.contentLoaded = new EventEmitter();
        this.loading = true;
        this.showLoading = false;
        // Force init to wait until the child components are loaded before loading preferenecs
        //  This gives the children time to register themselves before rendering
        this.initAfterContentInit = true;
    }
    get configType() {
        return DwUiConfigType.content;
    }
    getConfigKey() {
        return this.configKey;
    }
    setupConfig() {
        this.ensureItemsExist(this.finalPreferences);
        this.config = deepCopy(this.finalPreferences);
        this.contentLoaded.emit(null);
        setTimeout(() => {
            this.loading = false;
        }, 0);
    }
    handlePreferenceError(error) {
        const prefError = (error && error.message) ? error.message : error;
        const prefix = error.title ? error.title += ' - ' : '';
        this.errorMessage = `Error loading configuration: ${prefix} ${prefError}`;
        this.configComplete();
    }
    /*  Ensure that all registered items exist in final preferences
    
    */
    ensureItemsExist(finalPreferences) {
        var _a;
        if (!(finalPreferences === null || finalPreferences === void 0 ? void 0 : finalPreferences.items) || !((_a = this.preferences) === null || _a === void 0 ? void 0 : _a.items)) {
            return;
        }
        // Remove any blank items
        finalPreferences.items = finalPreferences.items.filter(item => item && item.name);
        this.preferences.items = this.preferences.items.filter(item => item && item.name);
        // Mark any items that exist in the load preferences as missing
        for (let finalItem of finalPreferences.items) {
            if (!finalItem || !finalItem.name) {
                continue;
            }
            var item = findWhere(this.preferences.items, { name: finalItem.name });
            if (!item) {
                finalItem.isMissing = true;
            }
            else {
                finalItem.isMissing = false;
            }
        }
        for (let item of this.preferences.items) {
            if (!item || !item.name) {
                continue;
            }
            var finalItem = findWhere(finalPreferences.items, { name: item.name });
            if (!finalItem) {
                this.finalPreferences.items.push(item);
                break;
            }
            else {
                finalItem.display = item.display;
                finalItem.controlType = item.controlType;
                finalItem.contentOrder = item.contentOrder;
                finalItem.defaultContent = item.content;
            }
        }
    }
    loadPreferences() {
        return this.dwContentService.getPreferencesHierarchy(this.getConfigKey(), true, this.preferences, this.item);
    }
    getPanelWidgetComponent() {
        return DwContentConfigWidgetComponent;
    }
    ngOnInit() {
        super.ngOnInit();
        if (!this.preferences) {
            this.preferences = new DwContentPreferences();
        }
        if (!this.preferences.items) {
            this.preferences.items = [];
        }
    }
    registerContent(contentItem) {
        const existingItem = this.preferences.items.find(item => item.name === contentItem.name);
        if (!existingItem) {
            this.preferences.items.push(contentItem);
            this.setupConfig();
        }
    }
    getContentItem(name) {
        if (!this.config) {
            return null;
        }
        var item = findWhere(this.config.items, { name: name });
        return item;
    }
    editContent() {
        this.ensureItemsExist(this.finalPreferences);
        this.dwContentService.editContent(this.preferenceHierarchy)
            .subscribe((updatedPrefs) => {
            if (updatedPrefs) {
                this.applyPreferences(updatedPrefs, true);
            }
        });
    }
    startConfigSession() {
        var _a, _b;
        this.ensureItemsExist(this.finalPreferences);
        if (((_b = (_a = this.finalPreferences) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            super.startConfigSession();
        }
    }
    buildContextMenu() {
        super.buildContextMenu();
        if (this.allowConfiguration && this.canEditContent) {
            this.contextMenu.push({
                label: 'Edit Content',
                command: (event) => { this.editContent(); }
            });
        }
    }
}
DwContentManagerComponent.ɵfac = function DwContentManagerComponent_Factory(t) { return new (t || DwContentManagerComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContentService)); };
DwContentManagerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContentManagerComponent, selectors: [["dw-content-manager"]], inputs: { configKey: "configKey", item: "item" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c5, decls: 6, vars: 4, consts: [["dwPageDesignerSelector", "", 1, "dw-content-manager", 3, "configKey"], ["contentManager", ""], ["text", "Loading", 3, "show"], [3, "hidden"], ["appendTo", "body", 3, "target", "model", 4, "ngIf"], ["appendTo", "body", 3, "target", "model"]], template: function DwContentManagerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelement(2, "dw-loading", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵtemplate(5, DwContentManagerComponent_p_contextMenu_5_Template, 1, 2, "p-contextMenu", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("configKey", ctx.configKey);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("show", ctx.showLoading && ctx.loading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.loading);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.contextMenu && ctx.contextMenu.length > 0);
    } }, directives: function () { return [DwDesignerSelector, DwLoadingComponent, ɵngcc4.NgIf, ɵngcc7.ContextMenu]; }, styles: [""] });
DwContentManagerComponent.ctorParameters = () => [
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwContextService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwContentService }
];
DwContentManagerComponent.propDecorators = {
    configKey: [{ type: Input }],
    item: [{ type: Input }]
};

class DwContentPreferenceItem {
}

/* @Component({
  // tslint:disable-next-line:component-selector
  selector: 'dw-content',
  template : `
    dw-content : {{ contentItem?.content }}<br>
  `
}) */
class DwContentDirective {
    constructor(contentManager, 
    // private elementRef: ElementRef,
    renderer) {
        this.contentManager = contentManager;
        this.renderer = renderer;
        this.controlType = DwControlType.HTMLEditor;
        this.displayHtml = "";
        this.configKey = contentManager === null || contentManager === void 0 ? void 0 : contentManager.configKey;
    }
    ngOnInit() {
        // this.registerContent();
        // this.contentManager.contentLoaded
        //     .subscribe(() => {
        //         this.loadContent();
        //     })
        // this.loadContent();
    }
    ngAfterViewInit() {
        this.registerContent();
        this.contentManager.contentLoaded
            .subscribe(() => {
            this.loadContent();
        });
        this.loadContent();
    }
    loadContent() {
        setTimeout(() => {
            let item = this.contentManager.getContentItem(this.name);
            if (item) {
                this.contentItem = item;
                if (this.elementRef.nativeElement) {
                    if (this.contentItem.useDefaultContent) {
                        this.displayHtml = this.originalContent;
                    }
                    else {
                        this.displayHtml = this.contentItem.content;
                    }
                    this.elementRef.nativeElement.innerHTML = this.displayHtml;
                }
            }
        });
    }
    registerContent() {
        if (!this.elementRef) {
            return;
        }
        this.contentItem = new DwContentPreferenceItem();
        this.contentItem.name = this.name;
        this.contentItem.display = this.display || this.name;
        this.contentItem.controlType = this.controlType;
        this.contentItem.useDefaultContent = true;
        if (this.contentOrder) {
            // Convert to a number since it could still be a string at run-time
            this.contentItem.contentOrder = parseInt(this.contentOrder.toString());
        }
        if (this.elementRef.nativeElement) {
            this.originalContent = this.elementRef.nativeElement.innerHTML;
            this.contentItem.content = this.originalContent;
        }
        this.contentManager.registerContent(this.contentItem);
    }
}
DwContentDirective.ɵfac = function DwContentDirective_Factory(t) { return new (t || DwContentDirective)(ɵngcc0.ɵɵdirectiveInject(DwContentManagerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DwContentDirective.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContentDirective, selectors: [["dw-content"]], viewQuery: function DwContentDirective_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c46, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.elementRef = _t.first);
    } }, inputs: { controlType: "controlType", name: "name", display: "display", contentOrder: "contentOrder" }, ngContentSelectors: _c5, decls: 5, vars: 3, consts: [["dwPageDesignerSelector", "", 3, "ngModel", "configKey", "sectionKey"], ["element", ""], ["hidden", "true"], ["innerContent", ""]], template: function DwContentDirective_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "dw-html-view", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2, 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.displayHtml)("configKey", ctx.contentManager.configKey)("sectionKey", ctx.name);
    } }, directives: function () { return [DwHtmlViewComponent, DwDesignerSelector, ɵngcc3.NgControlStatus, ɵngcc3.NgModel]; }, encapsulation: 2 });
DwContentDirective.ctorParameters = () => [
    { type: DwContentManagerComponent, decorators: [{ type: Inject, args: [DwContentManagerComponent,] }] },
    { type: Renderer2 }
];
DwContentDirective.propDecorators = {
    name: [{ type: Input }],
    display: [{ type: Input }],
    controlType: [{ type: Input }],
    contentOrder: [{ type: Input }],
    elementRef: [{ type: ViewChild, args: ['innerContent',] }]
};

class DwWorkflowLookupButtonsComponent extends DwSelectLookupComponent {
    constructor() {
        super(...arguments);
        this.buttonClick = new EventEmitter();
        this.buttons = [];
    }
    lookupLoadComplete() {
        if (!this.lookupItems) {
            return;
        }
        this.buttons = [];
        for (var lookupItem of this.lookupItems) {
            var buttonConfig = {
                lookupItem: lookupItem,
                buttonConfig: {
                    buttonClass: this.getButtonClass(lookupItem),
                    buttonText: this.getLookupItemDisplay(lookupItem),
                    buttonTitle: this.getLookupItemTooltip(lookupItem),
                }
            };
            this.buttons.push(buttonConfig);
        }
    }
    getLookupItemDisplay(lookupItem) {
        if (this.workflowPreferences.useAlternateActionDisplay && lookupItem.Transition && lookupItem.Transition.AlternateActionDisplay) {
            return lookupItem.Transition.AlternateActionDisplay;
        }
        if (lookupItem.Id == this.initialValue && this.workflowPreferences.overrideCurrentStatusDisplay && this.workflowPreferences.currentStatusDisplay) {
            return this.workflowPreferences.currentStatusDisplay;
        }
        return lookupItem[this.workflowPreferences.buttonDisplayAttrName];
    }
    getButtonClass(lookupItem) {
        if (this.workflowPreferences.buttonClassAttrName) {
            return lookupItem[this.workflowPreferences.buttonClassAttrName];
        }
        return '';
    }
    getLookupItemTooltip(lookupItem) {
        if (this.workflowPreferences.toolTipAttrName) {
            return lookupItem[this.workflowPreferences.toolTipAttrName];
        }
        return '';
    }
    click(lookupItem) {
        this.setValue(lookupItem.Id);
        const eventData = {
            requireValidation: true,
            lookupValue: lookupItem.Id
        };
        if (this.workflowPreferences.requireValidationAttrName) {
            eventData.requireValidation = lookupItem[this.workflowPreferences.requireValidationAttrName];
        }
        this.buttonClick.emit(eventData);
    }
}
DwWorkflowLookupButtonsComponent.ɵfac = function DwWorkflowLookupButtonsComponent_Factory(t) { return ɵDwWorkflowLookupButtonsComponent_BaseFactory(t || DwWorkflowLookupButtonsComponent); };
DwWorkflowLookupButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwWorkflowLookupButtonsComponent, selectors: [["dw-workflow-lookup-buttons"]], inputs: { workflowPreferences: "workflowPreferences" }, outputs: { buttonClick: "buttonClick" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwWorkflowLookupButtonsComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[4, "ngFor", "ngForOf"], [3, "disabled", "title", "click"]], template: function DwWorkflowLookupButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwWorkflowLookupButtonsComponent_ng_container_0_Template, 3, 6, "ng-container", 0);
        ɵngcc0.ɵɵtext(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.buttons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, directives: [ɵngcc4.NgForOf], encapsulation: 2 });
DwWorkflowLookupButtonsComponent.propDecorators = {
    buttonClick: [{ type: Output }],
    workflowPreferences: [{ type: Input }]
};

var DwEmailTriggerType;
(function (DwEmailTriggerType) {
    DwEmailTriggerType["attrChange"] = "attrChange";
    DwEmailTriggerType["attrChangeFrom"] = "attrChangeFrom";
    DwEmailTriggerType["attrChangeTo"] = "attrChangeTo";
    DwEmailTriggerType["attrChangeFromTo"] = "attrChangeFromTo";
    DwEmailTriggerType["created"] = "created";
    DwEmailTriggerType["updated"] = "updated";
    DwEmailTriggerType["timeElapsed"] = "timeElapsed";
    DwEmailTriggerType["attrChangeOnUpdate"] = "attrChangeOnUpdate";
})(DwEmailTriggerType || (DwEmailTriggerType = {}));
class DwEmailTriggerTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwEmailTriggerType[propertyName];
    }
    getKeys() {
        return Object.keys(DwEmailTriggerType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwEmailTriggerType.attrChange:
                return "Field Change";
            case DwEmailTriggerType.attrChangeFrom:
                return "Field Change - From";
            case DwEmailTriggerType.attrChangeTo:
                return "Field Change - To";
            case DwEmailTriggerType.attrChangeFromTo:
                return "Field Change - From/To";
            case DwEmailTriggerType.created:
                return "On Creation";
            case DwEmailTriggerType.updated:
                return "On Update";
            case DwEmailTriggerType.timeElapsed:
                return "Elapsed Time";
            case DwEmailTriggerType.attrChangeOnUpdate:
                return 'Field Change On Update';
        }
    }
}

var __decorate$10 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$M = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEmailTemplateConfigComponent = class DwEmailTemplateConfigComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionService = dwExpressionService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.templateConfigFC = new FormControl();
        this.templateConfig = {};
        this.emailDistributionListLookupId = DevwareMetaDataLookups.EmailDistributionListAllItems;
    }
    ngOnInit() {
        super.ngOnInit();
        // Wait until data is loaded before loading
        this.context.mdFormContext.subscribe((result) => {
            if (result.loadDataComplete) {
                this.setupFormField();
            }
        });
        /* setTimeout(() => {
            //console.log("DwEmailTemplateConfigComponent.ngOnInit");
            this.setupFormField();
        }); */
        this.itemLookupId = DevwareMetaDataLookups.MetaDataDatabaseAllItems;
        this.emailTriggerTypes = new DwEmailTriggerTypeList().getEnumList();
    }
    addToEmailReceiver() {
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormField() {
        this.templateConfigFormGroup = new FormGroup({});
        this.queryMeaningFC = new FormControl();
        this.templateConfigFormGroup.addControl("queryMeaning", this.queryMeaningFC);
        this.templateConfigFormGroup.addControl("disabled", new FormControl(false));
        this.templateConfigFormGroup.addControl("testMode", new FormControl(false));
        this.templateConfigFormGroup.addControl("testDistributionListMeaning", new FormControl());
        //  this.templateConfigFormGroup.addControl("mainItemName", new FormControl());
        this.formGroup.addControl("TemplateConfigJson", this.templateConfigFC);
        // this.templateConfigFormGroup.pat(this.templateConfigFC.value);
        this.templateConfigFormGroup.valueChanges
            .subscribe(templateConfig => {
            const templateConfigFC = this.formGroup.get("TemplateConfigJson");
            templateConfigFC.setValue(templateConfig);
        });
        /*         this.toAddresses = new FormArray([]);
                this.ccAddresseses = new FormArray([]);
                this.bccAddresseses = new FormArray([]);
                        
                this.templateConfigFormGroup.addControl("toAddresses", this.toAddresses);
                this.templateConfigFormGroup.addControl("ccAddresseses", this.ccAddresseses);
                this.templateConfigFormGroup.addControl("bccAddresseses", this.bccAddresseses); */
        this.mainItemFc = this.formGroup.get("MainMetaDataItemId");
        if (this.context && this.context.data) {
            const template = this.context.data.value;
            if (template) {
                this.setupTemplateConfig(template);
            }
            else {
                this.context.data.subscribe((template) => {
                    this.setupTemplateConfig(template);
                });
            }
        }
        if (this.mainItemFc) {
            this.mainItemFc.valueChanges
                .pipe(debounceTime(50), distinctUntilChanged())
                .subscribe((value) => {
                this.setupItemMetaData();
            });
        }
        this.queryMeaningFC.valueChanges
            .pipe(debounceTime(50), distinctUntilChanged())
            .subscribe((meaning) => {
            this.loadQueryMetaData();
            // renable disabled controls
            // if (this.queryMeaningFC.disabled) {
            //     this.queryMeaningFC.enable();
            // }
            // if (this.templateConfigFormGroup.disabled) {
            //     this.templateConfigFormGroup.enable();
            // }
        });
    }
    setupTemplateConfig(template) {
        if (this.templateSetup) {
            return;
        }
        this.templateSetup = true;
        this.templateConfig = template.TemplateConfigJson || {};
        this.templateConfigFormGroup.patchValue(this.templateConfig);
        this.setupItemMetaData();
    }
    setupItemMetaData() {
        if (!this.mainItemFc || !this.mainItemFc.value) {
            return;
        }
        const dwMd = new DevwareMetaDataService();
        this.itemId = this.mainItemFc.value;
        this.dwMetaDataService.getMetaDataItemId(dwMd.DwUser.ItemDetail.ItemName)
            .subscribe(dwUserItemId => {
            this.dwUserItemId = dwUserItemId;
            this.setupUserLookupItems();
        });
        const ob2 = this.dwMetaDataService.getMetaDataItemName(this.itemId)
            .subscribe((itemName) => {
            if (this.itemName != itemName) {
                this.itemName = itemName;
                this.loadQueries();
                this.loadMetaData();
            }
            this.loadQueryMetaData();
        });
    }
    loadQueryMetaData() {
        var _a;
        if (!this.itemName) {
            return;
        }
        if (((_a = this.queryMetaData) === null || _a === void 0 ? void 0 : _a.QueryMeaning) != this.queryMeaningFC.value || !this.queryMetaData) {
            this.dwMetaDataService.getSavedQueryMetaData(this.itemName, null, this.queryMeaningFC.value)
                .subscribe(queryMetaData => {
                this.queryMetaData = queryMetaData;
                this.setupUserLookupItems();
            });
        }
    }
    loadQueries() {
        this.dwMetaDataService.getQueries(this.itemId)
            .subscribe(queries => this.queries = queries);
    }
    loadMetaData() {
        var _a;
        if (!this.itemName) {
            return;
        }
        if (this.itemName != ((_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.UniqueItemName)) {
            this.dwMetaDataService.getMetaData(this.itemName)
                .subscribe(itemMetaData => this.itemMetaData = itemMetaData);
        }
    }
    setupUserLookupItems() {
        var _a;
        if (!this.queryMetaData) {
            return;
        }
        const dwMd = new DevwareMetaDataService();
        const userAttrs = [];
        for (let attr of this.queryMetaData.Attributes) {
            let addAttr = false;
            if (((_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.ReferenceMetaDataItemId) == this.dwUserItemId) {
                addAttr = true;
            }
            else {
                if (attr.AttributeType == DwAttributeType.Text) {
                    addAttr = true;
                }
            }
            if (addAttr) {
                userAttrs.push(attr);
            }
        }
        this.userAttrs = userAttrs;
    }
};
DwEmailTemplateConfigComponent.ɵfac = function DwEmailTemplateConfigComponent_Factory(t) { return new (t || DwEmailTemplateConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwEmailTemplateConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateConfigComponent, selectors: [["dw-email-template-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "6"], [1, "label"], ["formControlName", "queryMeaning", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "3"], ["formControlName", "disabled"], ["formControlName", "testMode"], ["dwCol", "6", 4, "ngIf"], ["dwRow", "", 4, "ngIf"], ["formControlName", "testDistributionListMeaning", "valueAttrName", "DistributionListMeaning", 3, "lookupId"], ["dwCol", "12"], [3, "formGroup", "userAttrs", "itemMetaData", "templateConfig", "queryMetaData"], [3, "formGroup", "itemMetaData", "templateConfig", "queryMetaData"]], template: function DwEmailTemplateConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwEmailTemplateConfigComponent_ng_container_0_Template, 23, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup && ctx.templateConfigFormGroup);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwYesNoComponent, DwSelectLookupComponent, DwEmailTemplateRecipientConfigComponent, DwEmailTemplateTriggerConfigComponent]; }, styles: [""] });
DwEmailTemplateConfigComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwEmailTemplateConfigComponent = __decorate$10([
    DwComponent({
        name: 'E-mail Template Config',
        componentType: DwComponentType.formSection,
        parentItemName: 'EmailTemplate',
    }),
    __metadata$M("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService])
], DwEmailTemplateConfigComponent);

var DwEmailGlobalValues;
(function (DwEmailGlobalValues) {
    DwEmailGlobalValues["webSiteBasePath"] = "[WEB_SITE_BASE_PATH]";
    DwEmailGlobalValues["webSiteBasePathSSL"] = "[WEB_SITE_BASE_PATH_SSL]";
})(DwEmailGlobalValues || (DwEmailGlobalValues = {}));

var __decorate$11 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$N = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEmailTemplateFieldsComponent = class DwEmailTemplateFieldsComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataRoutingService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
        this.templateConfig = {};
        this.globalFields = [];
        this.additionalItemCodes = [];
    }
    ngOnInit() {
        super.ngOnInit();
        setTimeout(() => {
            //console.log("DwEmailTemplateConfigComponent.ngOnInit");
            this.setupFormField();
            this.setupUserFields();
            this.setupItemCodes();
        });
    }
    setupUserFields() {
        let dwMd = new DevwareMetaDataService();
        this.dwMetaDataService.getMetaData(DevwareMetaDataItemNames.DwUser)
            .subscribe(userItemMetaData => {
            this.userItemMetaData = userItemMetaData;
        });
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormField() {
        this.mainItemFc = this.formGroup.get("MainMetaDataItemId");
        this.templateConfigFC = this.formGroup.get("TemplateConfigJson");
        // if (this.context && this.context.data) {
        //     const template : DwEmailTemplateEntity = this.context.data.value;
        //     if (template) {
        //         this.setupTemplateConfig(template?.TemplateConfigJson);
        //     } else {
        //         this.context.data.subscribe((template)=>{
        //             this.setupTemplateConfig(template);
        //         });
        //     }
        // }
        if (this.mainItemFc) {
            this.mainItemFc.valueChanges
                .subscribe((value) => {
                this.setupItemMetaData();
            });
        }
        this.formGroup.valueChanges
            .pipe(debounceTime(50), map(data => {
            const rawData = this.formGroup.getRawValue();
            const template = rawData;
            this.templateConfigFC = this.formGroup.get("TemplateConfigJson");
            return template === null || template === void 0 ? void 0 : template.TemplateConfigJson;
        }), distinctUntilChanged())
            .subscribe(templateConfig => {
            this.templateConfig = templateConfig;
            this.setupItemMetaData();
        });
    }
    setupTemplateConfig(templateConfigJson) {
        if (!templateConfigJson) {
            return;
        }
        this.templateConfig = templateConfigJson;
        this.setupItemMetaData();
    }
    setupItemMetaData() {
        if (!this.mainItemFc || !this.mainItemFc.value) {
            return;
        }
        const obj = this.dwMetaDataService.getMetaDataItemName(this.mainItemFc.value)
            .subscribe(itemName => {
            var _a, _b, _c, _d;
            this.itemName = itemName;
            if (((_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.UniqueItemName) !== this.itemName) {
                this.dwMetaDataService.getMetaData(itemName)
                    .subscribe(itemMetaData => {
                    this.itemMetaData = itemMetaData;
                    this.setupItemCodes();
                    this.setupUserLookupItems();
                });
            }
            if (((_b = this.queryMetaData) === null || _b === void 0 ? void 0 : _b.QueryMeaning) !== ((_c = this.templateConfig) === null || _c === void 0 ? void 0 : _c.queryMeaning)) {
                this.dwMetaDataService.getSavedQueryMetaData(itemName, null, (_d = this.templateConfig) === null || _d === void 0 ? void 0 : _d.queryMeaning)
                    .subscribe(queryMetaData => {
                    this.queryMetaData = queryMetaData;
                });
            }
        });
    }
    setupItemCodes() {
        if (!this.itemMetaData) {
            return;
        }
        this.additionalItemCodes = [];
        this.addItemActionCodes(DwMenuActionType.edit, (flatMenus) => `Edit ${this.itemMetaData.Display} (${flatMenus[1].display})`, (flatMenus) => `Edit ${this.itemMetaData.Display}`);
        this.addItemActionCodes(DwMenuActionType.view, (flatMenus) => `View ${this.itemMetaData.Display} (${flatMenus[1].display})`, (flatMenus) => `View ${this.itemMetaData.Display}`);
        this.addItemActionCodes(DwMenuActionType.list, (flatMenus) => `${flatMenus[0].display} (List)`, (flatMenus) => `${flatMenus[0].display}`);
    }
    addItemActionCodes(actionType, linkdisplay, emailDisplay) {
        var keyAttr = findWhere(this.itemMetaData.Attributes, { IsKey: true });
        if (!keyAttr) {
            return;
        }
        const keyCode = `[item.${keyAttr.AttributeName}]`;
        var routes = this.dwMetaDataRoutingService.findExistingRoutes(actionType, this.itemMetaData.UniqueItemName, keyCode);
        for (let route of routes) {
            let flatRoute = this.flattenRoutes(route);
            let url = flatRoute[0].url;
            url = url.replace(":itemName", this.itemMetaData.UniqueItemName);
            const paramName = getMenuActionParamName(this.itemMetaData.UniqueItemName);
            url = url.replace(paramName, keyCode);
            const templateCode = `<a href='http://[${DwEmailGlobalValues.webSiteBasePath}]${url}'>${emailDisplay(flatRoute)}</a>`;
            this.additionalItemCodes.push({
                display: linkdisplay(flatRoute),
                templateCode: templateCode,
                tooltip: url,
            });
        }
    }
    flattenRoutes(route, result) {
        if (!result) {
            result = [];
        }
        if (route && route.children && route.children.length > 0) {
            this.flattenRoutes(route.children[0], result);
        }
        result.push(route);
        return result;
    }
    addItemAttr(queryAttr, useDisplayAttribute = false) {
        var attr = queryAttr.Attribute;
        let attrTemplate = `item.${queryAttr.AttributeName}`;
        if (useDisplayAttribute) {
            attrTemplate = `item.${queryAttr.DisplayAttributeName}`;
        }
        this.appendToBodyTemplate(attrTemplate, true);
    }
    addUserAttr(userAttr, attr) {
        // Find relation name
        const relationProperty = this.getRelationPropertyName(userAttr);
        let attrTemplate = `item.${relationProperty}.${attr.AttributeName}`;
        if (attr.IsLookup) {
            attrTemplate += "Display";
        }
        this.appendToBodyTemplate(attrTemplate, true);
    }
    includeAttr(attr) {
        if (this.uiMetaDataConfig.formDefaultPreferences.ignoreAttributes.indexOf(attr.AttributeName) >= 0) {
            return false;
        }
        let dwMd = new DevwareMetaDataService();
        const fullAttrName = `${dwMd.DwUser.ItemDetail.ItemName}.${attr.AttributeName}`;
        switch (fullAttrName) {
            case dwMd.DwUser.OrganizationId:
            case dwMd.DwUser.OrganizationId:
            case dwMd.DwUser.ForcePasswordChange:
            case dwMd.DwUser.UserBackgroundMediaId:
            case dwMd.DwUser.UserPictureMediaId:
            case dwMd.DwUser.LastLoginDateTime:
            case dwMd.DwUser.UserKey:
            case dwMd.DwUser.PartyReferenceId:
                return false;
        }
        return true;
    }
    getRelationPropertyName(userAttr) {
        return userAttr.AttributeName.replace('Id', '');
        // Find relation name
        for (let relation of this.itemMetaData.Relations) {
            if (relation.FkAttributeName == userAttr.AttributeName && relation.FkMetaDataItemId == this.itemMetaData.MetaDataItemId) {
                return relation.Property;
            }
            if (relation.PkAttributeName == userAttr.AttributeName && relation.PkMetaDataItemId == this.itemMetaData.MetaDataItemId) {
                return relation.Property;
            }
        }
    }
    appendToBodyTemplate(code, addBrackets = false) {
        const bodyTemplateFC = this.formGroup.get("BodyTemplate");
        if (addBrackets) {
            code = `[${code}]`;
        }
        if (bodyTemplateFC) {
            let value = `${bodyTemplateFC.value} ${code}`;
            bodyTemplateFC.setValue(value);
        }
    }
    setupUserLookupItems() {
        const dwMd = new DevwareMetaDataService();
        const userAttrs = [];
        for (let attr of this.itemMetaData.Attributes) {
            if (attr.ReferenceMetaDataItemId == dwMd.DwUser.ItemDetail.ItemId) {
                userAttrs.push(attr);
            }
        }
        this.userAttrs = userAttrs;
    }
};
DwEmailTemplateFieldsComponent.ɵfac = function DwEmailTemplateFieldsComponent_Factory(t) { return new (t || DwEmailTemplateFieldsComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService)); };
DwEmailTemplateFieldsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateFieldsComponent, selectors: [["dw-email-template-fields"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 5, consts: [[3, "header"], [1, "field-container"], [4, "ngFor", "ngForOf"], [3, "header", 4, "ngFor", "ngForOf"], ["class", "field-item", 4, "ngIf"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add Field", 1, "fa", "fa-plus-circle", "hand"], [1, "btn", "btn-sm", "btn-success", 3, "hidden", "click"]], template: function DwEmailTemplateFieldsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h2");
        ɵngcc0.ɵɵtext(2, "Template Fields");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p-accordion");
        ɵngcc0.ɵɵelementStart(4, "p-accordionTab", 0);
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵtemplate(6, DwEmailTemplateFieldsComponent_ng_container_6_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "p-accordionTab", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵtemplate(9, DwEmailTemplateFieldsComponent_ng_container_9_Template, 5, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, DwEmailTemplateFieldsComponent_p_accordionTab_10_Template, 2, 2, "p-accordionTab", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate1("header", "", ctx.itemMetaData == null ? null : ctx.itemMetaData.Display, " Fields");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.queryMetaData == null ? null : ctx.queryMetaData.Attributes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate1("header", "", ctx.itemMetaData == null ? null : ctx.itemMetaData.Display, " Links");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.additionalItemCodes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.userAttrs);
    } }, directives: [ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc4.NgForOf, ɵngcc4.NgIf], styles: [".field-item[_ngcontent-%COMP%]{clear:left;margin-top:2px;width:200px}.field-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{text-align:left;width:100%}.field-container[_ngcontent-%COMP%]{max-height:500px;overflow:auto}"] });
DwEmailTemplateFieldsComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataRoutingService }
];
DwEmailTemplateFieldsComponent = __decorate$11([
    DwComponent({
        name: 'E-mail Template Fields',
        parentItemName: 'EmailTemplate',
        componentType: DwComponentType.formSection,
    }),
    __metadata$N("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetaDataRoutingService])
], DwEmailTemplateFieldsComponent);

var DwEmailSendType;
(function (DwEmailSendType) {
    DwEmailSendType["to"] = "To";
    DwEmailSendType["cc"] = "CC";
    DwEmailSendType["bcc"] = "BCC";
})(DwEmailSendType || (DwEmailSendType = {}));
class DwEmailSendTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwEmailSendType[propertyName];
    }
    getKeys() {
        return Object.keys(DwEmailSendType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwEmailSendType.to:
                return "To";
            case DwEmailSendType.cc:
                return "CC";
            case DwEmailSendType.bcc:
                return "BCC";
        }
    }
}

var DwEmailElapsedTimeType;
(function (DwEmailElapsedTimeType) {
    DwEmailElapsedTimeType["afterDays"] = "afterDays";
    DwEmailElapsedTimeType["beforeDays"] = "beforeDays";
    DwEmailElapsedTimeType["afterHours"] = "afterHours";
    DwEmailElapsedTimeType["beforeHours"] = "beforeHours";
})(DwEmailElapsedTimeType || (DwEmailElapsedTimeType = {}));
class DwEmailElapsedTimeTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwEmailElapsedTimeType[propertyName];
    }
    getKeys() {
        return Object.keys(DwEmailElapsedTimeType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwEmailElapsedTimeType.afterDays:
                return "After Days";
            case DwEmailElapsedTimeType.beforeDays:
                return "Before Days";
            case DwEmailElapsedTimeType.afterHours:
                return "After Hours";
            case DwEmailElapsedTimeType.beforeHours:
                return 'Before hours';
        }
    }
}

class DwEmailTemplateTriggerConfigComponent {
    constructor() {
        this.fieldName = "triggers";
        this.attributeParams = [];
        this.attrValueOldFieldDef = [];
        this.attrValueNewFieldDef = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.emailTriggerTypes = new DwEmailTriggerTypeList().getEnumList();
        this.emailSendTypes = new DwEmailSendTypeList().getEnumList();
        this.emailElapsedTimeTypes = new DwEmailElapsedTimeTypeList().getEnumList();
        this.formArray = this.formGroup.get(this.fieldName);
        if (!this.formArray) {
            this.formArray = new FormArray([]);
            this.formGroup.addControl(this.fieldName, this.formArray);
        }
        this.attributesLookupId = DevwareMetaDataLookups.AttributeByMetaDataItem;
        if (this.itemMetaData) {
            this.attributeParams[0] = this.itemMetaData.MetaDataItemId;
        }
        this.setupTriggers();
        this.setupAttributes();
    }
    ngOnChanges(changes) {
        if (changes.templateConfig && !changes.templateConfig.firstChange) {
            this.setupTriggers();
        }
        if (changes.itemMetaData && changes.itemMetaData && !changes.itemMetaData.firstChange) {
            this.attributeParams[0] = this.itemMetaData.MetaDataItemId;
            this.setupTriggers(false);
            this.setupAttributes();
        }
    }
    setupAttributes() {
        if (!this.itemMetaData) {
            return;
        }
        this.dateAttributes = this.queryMetaData.Attributes.filter(a => a.AttributeType == DwAttributeType.Date || a.AttributeType == DwAttributeType.DateTime).map(a => a.Attribute);
        this.dateTimeAttributes = this.queryMetaData.Attributes.filter(a => a.AttributeType == DwAttributeType.DateTime).map(a => a.Attribute);
        ;
    }
    setupTriggers(addItems = true) {
        if (this.templateConfig) {
            const triggers = this.templateConfig[this.fieldName];
            if (triggers) {
                for (let trigger of triggers) {
                    if (addItems) {
                        this.addItem();
                    }
                    const index = triggers.indexOf(trigger);
                }
                this.formArray.patchValue(triggers);
                this.setupAttrChangeSubscriptions();
            }
        }
    }
    setupAttrFields(attrName, index) {
        var _a;
        if (!attrName || !this.itemMetaData) {
            return;
        }
        //console.log("attribute changed ", attrName);
        const attr = findWhere(this.itemMetaData.Attributes, { AttributeName: attrName });
        if (!attr) {
            this.attrValueOldFieldDef[index] = null;
            this.attrValueNewFieldDef[index] = null;
            return;
        }
        const fieldDef = {
            itemName: (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.UniqueItemName,
            attr: attr,
            attrName: "attrValueOld",
            label: '',
            controlType: attr.MetaDataControlTypeId,
            hideLabel: true,
            formGroupKey: ''
        };
        if (fieldDef.controlType == DwControlType.TextArea || fieldDef.controlType == DwControlType.HTMLEditor) {
            fieldDef.controlType = DwControlType.Textbox;
        }
        this.attrValueOldFieldDef[index] = fieldDef;
        this.attrValueNewFieldDef[index] = Object.assign({}, fieldDef);
        this.attrValueNewFieldDef[index].attrName = "attrValueNew";
    }
    showAttributeField(index) {
        const triggerType = this.getTriggerType(index);
        switch (triggerType) {
            case DwEmailTriggerType.attrChange:
            case DwEmailTriggerType.attrChangeTo:
            case DwEmailTriggerType.attrChangeFrom:
            case DwEmailTriggerType.attrChangeFromTo:
            case DwEmailTriggerType.attrChangeOnUpdate:
                return true;
        }
        return false;
    }
    showOldField(index) {
        const triggerType = this.getTriggerType(index);
        var fromField = this.attrValueOldFieldDef[index];
        switch (triggerType) {
            case DwEmailTriggerType.attrChange:
            case DwEmailTriggerType.attrChangeTo:
                return false;
            case DwEmailTriggerType.attrChangeFrom:
            case DwEmailTriggerType.attrChangeFromTo:
                return !!fromField;
        }
        return false;
    }
    showDateTimeAttr(index) {
        const trigger = this.getTrigger(index);
        if (!trigger) {
            return false;
        }
        if (trigger.elapsedTimeType == DwEmailElapsedTimeType.afterHours || trigger.elapsedTimeType == DwEmailElapsedTimeType.beforeHours) {
            return true;
        }
        return false;
    }
    showDateAttr(index) {
        const trigger = this.getTrigger(index);
        if (!trigger) {
            return false;
        }
        if (trigger.elapsedTimeType == DwEmailElapsedTimeType.afterHours || trigger.elapsedTimeType == DwEmailElapsedTimeType.beforeHours) {
            return false;
        }
        return true;
    }
    showElpasedTimeField(index) {
        const triggerType = this.getTriggerType(index);
        switch (triggerType) {
            case DwEmailTriggerType.timeElapsed:
                return true;
        }
        return false;
    }
    showNewField(index) {
        const triggerType = this.getTriggerType(index);
        var toField = this.attrValueNewFieldDef[index];
        switch (triggerType) {
            case DwEmailTriggerType.attrChange:
            case DwEmailTriggerType.attrChangeFrom:
                return false;
            case DwEmailTriggerType.attrChangeTo:
            case DwEmailTriggerType.attrChangeFromTo:
                return !!toField;
        }
        return false;
    }
    getTriggerType(index) {
        if (!this.formArray) {
            return null;
        }
        const formGroup = this.formArray.controls[index];
        if (formGroup) {
            const receiverTypeFC = formGroup.get("emailTriggerType");
            if (receiverTypeFC) {
                return receiverTypeFC.value;
            }
        }
        return null;
    }
    getTrigger(index) {
        if (!this.formArray) {
            return null;
        }
        const formGroup = this.formArray.controls[index];
        if (formGroup) {
            return formGroup.value;
        }
        return null;
    }
    addItem(afterInit = false) {
        let newFormGroup = new FormGroup({});
        newFormGroup.addControl("emailTriggerType", new FormControl(DwEmailTriggerType.created));
        const attrNameFC = new FormControl();
        newFormGroup.addControl("attrName", attrNameFC);
        newFormGroup.addControl("emailAddress", new FormControl());
        newFormGroup.addControl("attrValueOld", new FormControl());
        newFormGroup.addControl("attrValueNew", new FormControl());
        newFormGroup.addControl("expression", new FormControl());
        newFormGroup.addControl("elapsedTimeType", new FormControl());
        newFormGroup.addControl("elapsedTimeInterval", new FormControl());
        newFormGroup.addControl("elapsedTimeRepeat", new FormControl());
        newFormGroup.addControl("elapsedTimeRepeatInterval", new FormControl());
        this.formArray.push(newFormGroup);
        if (afterInit) {
            this.setupAttrChangeSubscriptions();
        }
        return newFormGroup;
    }
    clearSubscriptions() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setupAttrChangeSubscriptions() {
        this.clearSubscriptions();
        for (let index = 0; index < this.formArray.length; index++) {
            const formGroup = this.formArray.controls[index];
            let attrNameFC = formGroup.get("attrName");
            if (attrNameFC.value) {
                this.setupAttrFields(attrNameFC.value, index);
            }
            this.subscriptions.push(attrNameFC.valueChanges
                .subscribe(value => {
                this.setupAttrFields(value, index);
            }));
        }
    }
    removeItem(index) {
        this.formArray.removeAt(index);
        this.setupAttrChangeSubscriptions();
    }
}
DwEmailTemplateTriggerConfigComponent.ɵfac = function DwEmailTemplateTriggerConfigComponent_Factory(t) { return new (t || DwEmailTemplateTriggerConfigComponent)(); };
DwEmailTemplateTriggerConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateTriggerConfigComponent, selectors: [["dw-email-template-trigger-config"]], inputs: { fieldName: "fieldName", formGroup: "formGroup", templateConfig: "templateConfig", itemMetaData: "itemMetaData", queryMetaData: "queryMetaData" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "formGroup"], [3, "formArrayName", 4, "ngIf"], [3, "formArrayName"], [4, "ngFor", "ngForOf"], [1, "btn", "btn-success", 3, "click"], [1, "fa", "fa-plus"], ["dwRow", "", 3, "formGroupName"], ["dwCol", "0"], ["title", "Remove Link", 1, "btn", "btn-sm", "btn-danger", "hide-mobile", 3, "click"], [1, "fa", "fa-times", "hand"], ["dwCol", "3"], [1, "label"], ["formControlName", "emailTriggerType", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "2", 4, "ngIf"], [4, "ngIf"], ["dwCol", "4", 4, "ngIf"], [3, "ngValue"], ["dwCol", "2"], ["formControlName", "attrName", 1, "form-control"], ["dwDynamicField", "", 3, "fieldDef", "formGroup"], ["formControlName", "elapsedTimeType", 1, "form-control"], ["dwCol", "2", 3, "hidden"], ["type", "input", "dwNumeric", "", "formControlName", "elapsedTimeInterval", 1, "form-control"], ["formControlName", "elapsedTimeRepeat"], ["type", "input", "dwNumeric", "", "formControlName", "elapsedTimeRepeatInterval", 1, "form-control"], ["dwCol", "4"], ["formControlName", "expression", 3, "contextNames", "item", "queryMeaning", "ngModelChange"]], template: function DwEmailTemplateTriggerConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwEmailTemplateTriggerConfigComponent_div_1_Template, 5, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formArray);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, ɵngcc3.FormArrayName, ɵngcc4.NgForOf, DwRowDirective, ɵngcc3.FormGroupName, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDynamicFieldComponent, DwNumericDirective, ɵngcc3.DefaultValueAccessor, DwYesNoComponent, DwExpressionPickerControlComponent]; }, styles: [""] });
DwEmailTemplateTriggerConfigComponent.ctorParameters = () => [];
DwEmailTemplateTriggerConfigComponent.propDecorators = {
    formGroup: [{ type: Input }],
    fieldName: [{ type: Input }],
    templateConfig: [{ type: Input }],
    itemMetaData: [{ type: Input }],
    queryMetaData: [{ type: Input }]
};

var DwEmailRecipientType;
(function (DwEmailRecipientType) {
    DwEmailRecipientType["userAttr"] = "userAttr";
    DwEmailRecipientType["email"] = "email";
    DwEmailRecipientType["distributionList"] = "distributionList";
    DwEmailRecipientType["subQuery"] = "subQuery";
})(DwEmailRecipientType || (DwEmailRecipientType = {}));
class DwEmailRecipientTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwEmailRecipientType[propertyName];
    }
    getKeys() {
        return Object.keys(DwEmailRecipientType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwEmailRecipientType.userAttr:
                return "User Field";
            case DwEmailRecipientType.email:
                return "E-mail Address";
            case DwEmailRecipientType.distributionList:
                return "Distribution List";
            case DwEmailRecipientType.subQuery:
                return 'Sub-Query';
        }
    }
}

class DwEmailTemplateRecipientConfigComponent {
    constructor(dwMetaDataService) {
        this.dwMetaDataService = dwMetaDataService;
        this.fieldName = "recipients";
        this.userAttrs = [];
        this.additionalMetaData = {};
        this.itemQueries = {};
    }
    ngOnInit() {
        this.emailRecipientTypes = new DwEmailRecipientTypeList().getEnumList();
        this.emailSendTypes = new DwEmailSendTypeList().getEnumList();
        this.emailDistributionListLookupId = DevwareMetaDataLookups.EmailDistributionListAllItems;
        this.formArray = this.formGroup.get(this.fieldName);
        if (!this.formArray) {
            this.formArray = new FormArray([]);
            this.formGroup.addControl(this.fieldName, this.formArray);
        }
        this.setupAddresses();
        this.formGroup.valueChanges
            .subscribe(values => {
            if (!values) {
                return;
            }
            const addresses = values[this.fieldName];
            if (!addresses) {
                return;
            }
            this.loadRelations(addresses);
        });
    }
    ngOnChanges(changes) {
        if (changes.templateConfig && !changes.templateConfig.firstChange) {
            this.setupAddresses();
        }
    }
    setupAddresses() {
        if (this.templateConfig) {
            const addresses = this.templateConfig[this.fieldName];
            if (addresses) {
                for (let address of addresses) {
                    this.addItem();
                }
                this.formArray.patchValue(addresses);
                // load initial relations
                this.loadRelations(addresses);
            }
        }
    }
    loadRelations(addresses) {
        for (const address of addresses) {
            this.loadRelation(address.relationshipMeaning, address.prefetchQueryMeaning);
        }
    }
    loadRelation(relationshipName, queryName) {
        var _a, _b, _c;
        const relation = (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.Relations.find(r => r.RelationshipName == relationshipName);
        if (!relation) {
            return;
        }
        const key = this.buildQueryKey(relationshipName, queryName);
        if (this.additionalMetaData[key]) {
            return;
        }
        const uniqueItemName = ((_b = this.itemMetaData) === null || _b === void 0 ? void 0 : _b.UniqueItemName) == relation.PkUniqueItemName ? relation.FkUniqueItemName : relation.PkUniqueItemName;
        const uniqueItemId = ((_c = this.itemMetaData) === null || _c === void 0 ? void 0 : _c.UniqueItemName) == relation.PkUniqueItemName ? relation.FkMetaDataItemId : relation.PkMetaDataItemId;
        this.loadQueries(uniqueItemId, relation.RelationshipName);
        //console.log('Load relation', uniqueItemName, queryName);
        this.dwMetaDataService.getSavedQueryMetaData(uniqueItemName, null, queryName)
            .subscribe(queryMetaData => {
            const key = this.buildQueryKey(relationshipName, queryName);
            this.additionalMetaData[key] = queryMetaData;
        });
    }
    loadQueries(uniqueItemId, relationshipName) {
        if (this.itemQueries[relationshipName]) {
            return;
        }
        this.dwMetaDataService.getQueries(uniqueItemId)
            .subscribe(queries => {
            this.itemQueries[relationshipName] = queries;
        });
    }
    buildQueryKey(relationshipName, queryName) {
        queryName = queryName || 'defalut';
        return `${relationshipName}_${queryName}`;
    }
    hideEmailAddress(index) {
        return !this.receiverTypeEquals(index, DwEmailRecipientType.email);
    }
    hideDistributionList(index) {
        return !this.receiverTypeEquals(index, DwEmailRecipientType.distributionList);
    }
    hideSubQuery(index) {
        return !this.receiverTypeEquals(index, DwEmailRecipientType.subQuery);
    }
    hideUserAttr(index) {
        return !this.receiverTypeEquals(index, DwEmailRecipientType.userAttr);
    }
    receiverTypeEquals(index, recipientType) {
        const currentReceiverType = this.getRecipientType(index);
        return (currentReceiverType == recipientType);
    }
    getRecipientType(index) {
        if (!this.formArray) {
            return null;
        }
        const formGroup = this.formArray.controls[index];
        if (formGroup) {
            const receiverTypeFC = formGroup.get("emailRecipientType");
            if (receiverTypeFC) {
                return receiverTypeFC.value;
            }
        }
        return null;
    }
    addItem() {
        let newFormGroup = new FormGroup({});
        newFormGroup.addControl("emailRecipientType", new FormControl(DwEmailRecipientType.userAttr));
        newFormGroup.addControl("emailSendType", new FormControl(DwEmailSendType.to));
        newFormGroup.addControl("emailAddress", new FormControl());
        newFormGroup.addControl("distributionListMeaning", new FormControl());
        newFormGroup.addControl("itemName", new FormControl());
        newFormGroup.addControl("relationshipMeaning", new FormControl());
        newFormGroup.addControl("expression", new FormControl());
        newFormGroup.addControl("attrName", new FormControl());
        newFormGroup.addControl("prefetchQueryMeaning", new FormControl());
        this.formArray.push(newFormGroup);
        return newFormGroup;
    }
    removeItem(index) {
        this.formArray.removeAt(index);
    }
}
DwEmailTemplateRecipientConfigComponent.ɵfac = function DwEmailTemplateRecipientConfigComponent_Factory(t) { return new (t || DwEmailTemplateRecipientConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwEmailTemplateRecipientConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateRecipientConfigComponent, selectors: [["dw-email-template-recipient-config"]], inputs: { fieldName: "fieldName", userAttrs: "userAttrs", formGroup: "formGroup", templateConfig: "templateConfig", itemMetaData: "itemMetaData", queryMetaData: "queryMetaData" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "formGroup"], [3, "formArrayName", 4, "ngIf"], [3, "formArrayName"], [4, "ngFor", "ngForOf"], [1, "btn", "btn-success", 3, "click"], [1, "fa", "fa-plus"], ["dwRow", "", 3, "formGroupName"], ["dwCol", "0"], ["title", "Remove Link", 1, "btn", "btn-sm", "btn-danger", "hide-mobile", 3, "click"], [1, "fa", "fa-times", "hand"], ["dwCol", "2"], [1, "label"], ["formControlName", "emailSendType", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "emailRecipientType", 1, "form-control"], ["dwCol", "3", 3, "hidden"], ["type", "email", "formControlName", "emailAddress", 1, "form-control"], ["formControlName", "distributionListMeaning", "valueAttrName", "DistributionListMeaning", 3, "lookupId"], ["formControlName", "relationshipMeaning", 1, "form-control"], [3, "hidden"], ["formControlName", "prefetchQueryMeaning", 1, "form-control"], [3, "ngValue"], ["formControlName", "attrName", 1, "form-control"], ["ngValue", ""], ["dwCol", "4", 4, "ngIf"], ["dwCol", "4"], ["formControlName", "expression", 3, "contextNames", "item", "queryMeaning", "ngModelChange"]], template: function DwEmailTemplateRecipientConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwEmailTemplateRecipientConfigComponent_div_1_Template, 5, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formArray);
    } }, directives: function () { return [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, ɵngcc3.FormArrayName, ɵngcc4.NgForOf, DwRowDirective, ɵngcc3.FormGroupName, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor, DwSelectLookupComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwExpressionPickerControlComponent]; }, styles: [""] });
DwEmailTemplateRecipientConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwEmailTemplateRecipientConfigComponent.propDecorators = {
    formGroup: [{ type: Input }],
    fieldName: [{ type: Input }],
    templateConfig: [{ type: Input }],
    userAttrs: [{ type: Input }],
    itemMetaData: [{ type: Input }],
    queryMetaData: [{ type: Input }]
};

// tslint:disable
var FaqsMetaDataItemNames;
(function (FaqsMetaDataItemNames) {
    FaqsMetaDataItemNames["DwFaqCategory"] = "dw_FaqCategory";
    FaqsMetaDataItemNames["DwFaqItem"] = "dw_FaqItem";
})(FaqsMetaDataItemNames || (FaqsMetaDataItemNames = {}));
var FaqsMetaDataLookups;
(function (FaqsMetaDataLookups) {
    FaqsMetaDataLookups[FaqsMetaDataLookups["FaqCategoryAllItems"] = 380] = "FaqCategoryAllItems";
    FaqsMetaDataLookups[FaqsMetaDataLookups["FaqItemAllItems"] = 381] = "FaqItemAllItems";
})(FaqsMetaDataLookups || (FaqsMetaDataLookups = {}));
class FaqsMetaDataService {
    constructor() {
        this.DwFaqCategory = new DwFaqCategory();
        this.DwFaqItem = new DwFaqItem();
    }
}
FaqsMetaDataService.ɵfac = function FaqsMetaDataService_Factory(t) { return new (t || FaqsMetaDataService)(); };
FaqsMetaDataService.ɵprov = ɵɵdefineInjectable({ factory: function FaqsMetaDataService_Factory() { return new FaqsMetaDataService(); }, token: FaqsMetaDataService, providedIn: "root" });
// Generated Classes for MetaData service
class DwFaqCategory {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_FaqCategory.';
        // Attributes
        this.FaqCategoryId = this.i + 'FaqCategoryId';
        this.CategoryDisplay = this.i + 'CategoryDisplay';
        this.CategoryOrder = this.i + 'CategoryOrder';
        this.Relations = {
            /** Relation: Faq Item */
            DwFaqItem: {
                RelationName: 'dw_FaqCategory|dw_FaqItem|FaqCategoryId',
                FieldPrefix: 'DwFaqItem'
            },
        };
        this.ItemDetail.ItemId = 378;
        this.ItemDetail.ItemName = 'dw_FaqCategory';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwFaqItem {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_FaqItem.';
        // Attributes
        this.FaqItemId = this.i + 'FaqItemId';
        this.Question = this.i + 'Question';
        this.Answer = this.i + 'Answer';
        this.QuestionOrder = this.i + 'QuestionOrder';
        this.FaqCategoryId = this.i + 'FaqCategoryId';
        this.Relations = {
            /** Relation: FAQ Category */
            DwFaqCategory: {
                RelationName: 'dw_FaqCategory|dw_FaqItem|FaqCategoryId',
                FieldPrefix: 'DwFaqCategory'
            },
        };
        this.ItemDetail.ItemId = 379;
        this.ItemDetail.ItemName = 'dw_FaqItem';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}

class DwFaqsService {
    constructor(dwOrmDataService, dwCacheService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwCacheService = dwCacheService;
    }
    getFaqs() {
        let cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(FaqsMetaDataItemNames.DwFaqCategory));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(FaqsMetaDataItemNames.DwFaqItem));
        return this.dwCacheService.get("Faqs", this.loadFaqs(), null, cacheInvalidationTopics);
    }
    loadFaqs() {
        const dwMd = new FaqsMetaDataService();
        const qh = new DwQueryHelper();
        const query = dwMd.DwFaqCategory.CreateQuery();
        query.OrderBy(dwMd.DwFaqCategory.CategoryOrder, true);
        query.AddPrefetchPath(dwMd.DwFaqCategory.Relations.DwFaqItem, dwMd.DwFaqItem.CreateQuery()
            .OrderBy(dwMd.DwFaqItem.QuestionOrder, true));
        return this.dwOrmDataService.executeQuery(query);
    }
}
DwFaqsService.ɵfac = function DwFaqsService_Factory(t) { return new (t || DwFaqsService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwCacheService)); };
DwFaqsService.ɵprov = ɵɵdefineInjectable({ factory: function DwFaqsService_Factory() { return new DwFaqsService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwCacheService)); }, token: DwFaqsService, providedIn: "root" });
DwFaqsService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwCacheService }
];

class DwPageConfigBaseComponent {
    getConfigValue() {
        return this.configFormGroup.value;
    }
    setConfigValue(value) {
        this.configFormGroup.patchValue(value || {});
    }
    setupForm() {
        this.configFormGroup = new FormGroup({});
    }
}
DwPageConfigBaseComponent.ɵfac = function DwPageConfigBaseComponent_Factory(t) { return new (t || DwPageConfigBaseComponent)(); };
DwPageConfigBaseComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwPageConfigBaseComponent });

class DwFaqsConfigComponent extends DwPageConfigBaseComponent {
    setupForm() {
        super.setupForm();
        this.configFormGroup.addControl('categoryClass', new FormControl());
        this.configFormGroup.addControl('questionClass', new FormControl());
        this.configFormGroup.addControl('answerClass', new FormControl());
    }
}
DwFaqsConfigComponent.ɵfac = function DwFaqsConfigComponent_Factory(t) { return ɵDwFaqsConfigComponent_BaseFactory(t || DwFaqsConfigComponent); };
DwFaqsConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFaqsConfigComponent, selectors: [["dw-faqs-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 16, vars: 1, consts: [[3, "formGroup"], ["dwRow", ""], ["dwCol", ""], [1, "label"], ["type", "text", "formControlName", "categoryClass", 1, "form-control"], ["type", "text", "formControlName", "questionClass", 1, "form-control"], ["type", "text", "formControlName", "answerClass", 1, "form-control"]], template: function DwFaqsConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "Category Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "input", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelementStart(8, "label", 3);
        ɵngcc0.ɵɵtext(9, "Question Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "input", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 1);
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelementStart(13, "label", 3);
        ɵngcc0.ɵɵtext(14, "Answer Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "input", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.configFormGroup);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });

var __decorate$12 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$O = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwFaqsComponent = class DwFaqsComponent {
    constructor(dwFaqService) {
        this.dwFaqService = dwFaqService;
    }
    ngOnInit() {
        this.dwFaqService.getFaqs()
            .subscribe(faqCategories => {
            this.faqCategories = faqCategories;
        });
    }
};
DwFaqsComponent.ɵfac = function DwFaqsComponent_Factory(t) { return new (t || DwFaqsComponent)(ɵngcc0.ɵɵdirectiveInject(DwFaqsService)); };
DwFaqsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFaqsComponent, selectors: [["dw-faqs"]], decls: 8, vars: 1, consts: [["configKey", "faqs"], ["name", "page-title", "display", "Page Title"], ["name", "page-detail", "display", "Page Detail"], [4, "ngFor", "ngForOf"], [1, "dw-form-header-only-small", 3, "ngClass"], [1, "question", "hand", 3, "ngClass", "click"], [1, "answer", 3, "ngClass"], [3, "ngModel", 4, "ngIf"], [3, "ngModel"]], template: function DwFaqsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "dw-content-manager", 0);
        ɵngcc0.ɵɵelementStart(2, "h1");
        ɵngcc0.ɵɵelementStart(3, "dw-content", 1);
        ɵngcc0.ɵɵtext(4, " Frequently Asked Questions ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "dw-content", 2);
        ɵngcc0.ɵɵtext(6, " Have questions, we've got answers! ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DwFaqsComponent_div_7_Template, 5, 3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.faqCategories);
    } }, directives: [DwContentManagerComponent, DwContentDirective, ɵngcc4.NgForOf, ɵngcc4.NgClass, ɵngcc4.NgIf, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [".question[_ngcontent-%COMP%]{font-size:17px;font-weight:700;margin-bottom:5px;margin-top:10px}.answer[_ngcontent-%COMP%]{font-size:14px;font-weight:400}"] });
DwFaqsComponent.ctorParameters = () => [
    { type: DwFaqsService }
];
DwFaqsComponent = __decorate$12([
    DwComponent({
        name: 'FAQs',
        componentType: DwComponentType.pageComponent,
        isGlobal: true,
        configComponent: DwFaqsConfigComponent
    }),
    __metadata$O("design:paramtypes", [DwFaqsService])
], DwFaqsComponent);

var __decorate$13 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$P = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwRuleConfigComponent = class DwRuleConfigComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwContextService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwContextService = dwContextService;
        this.contextDefList = [];
        this.contextNames = [];
        this.itemName = "";
        this.itemNameLoaded = false;
    }
    ngOnInit() {
        super.ngOnInit();
        //console.log("DwRuleConfigComponent.ngOnInit");
        setTimeout(() => {
            //console.log("DwRuleConfigComponent.ngOnInit - After timeout");
            this.setupFormFields();
        }, 10);
        this.contextDefinitions = this.dwContextService.contextDefinitions;
        for (let contextDef of this.dwContextService.contextDefinitions) {
            this.contextDefList.push({
                label: contextDef.contextDisplay,
                value: contextDef.contextName
            });
        }
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormFields() {
        this.ruleFG = new FormGroup({});
        this.ruleFG.addControl("ruleName", new FormControl());
        this.ruleFG.addControl("ruleDescription", new FormControl());
        this.ruleFG.addControl("expression", new FormControl());
        this.contextNamesFC = new FormControl();
        this.ruleFG.addControl("contextNames", this.contextNamesFC);
        this.mainMetaDataItemIdFc = this.formGroup.get("MainMetaDataItemId");
        this.formGroup.addControl("RuleJson", this.ruleFG);
        this.setupMainItemData();
        this.context.data.subscribe(values => {
            if (!values) {
                return;
            }
            //console.log("DwRuleConfig - context data value changes", values);
            this.setupMainItemData();
        });
        this.formGroup.valueChanges
            .subscribe(values => {
            //console.log("DwRuleConfig - formgroup value changes");
        });
        this.mainMetaDataItemIdFc.valueChanges
            .subscribe(value => {
            this.setupMainItemData();
        });
        if (this.context.data.value && this.context.data.value.RuleJson) {
            this.ruleFG.patchValue(this.context.data.value.RuleJson);
        }
    }
    setupMainItemData() {
        let itemId = this.mainMetaDataItemIdFc.value;
        if (!itemId) {
            if (this.context.mdFormContext && this.context.mdFormContext.value.loadDataComplete) {
                this.itemNameLoaded = true;
            }
            return;
        }
        this.dwMetaDataService.getMetaDataItemName(itemId)
            .subscribe(itemName => {
            this.itemName = itemName;
            this.itemNameLoaded = true;
            //console.log("setupMainItemData", itemId, itemName);
        });
    }
};
DwRuleConfigComponent.ɵfac = function DwRuleConfigComponent_Factory(t) { return new (t || DwRuleConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwRuleConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRuleConfigComponent, selectors: [["dw-rule-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "6"], [1, "label"], ["type", "text", "formControlName", "ruleName", 1, "form-control"], ["dwCol", "12"], ["formControlName", "ruleDescription", 1, "form-control"], ["formControlName", "contextNames", "includeCustomContexts", "true", 3, "itemName"], ["dwRow", "", 4, "ngIf"], ["formControlName", "expression", 3, "contextNames", "item"]], template: function DwRuleConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRuleConfigComponent_div_0_Template, 18, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.ruleFG);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwContextDefMultiSelectComponent, DwExpressionPickerControlComponent]; }, styles: [""] });
DwRuleConfigComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];
DwRuleConfigComponent = __decorate$13([
    DwComponent({
        key: 'dwRuleConfig',
        name: 'Rule Config',
        parentItemName: 'RuleDefinition',
        componentType: DwComponentType.formSection,
    }),
    __metadata$P("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwContextService])
], DwRuleConfigComponent);

class DwMetadataGridConfigColumnsModalComponent {
    constructor(dwMetaDataService, dwOrmDataService, dwLoggingService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwLoggingService = dwLoggingService;
        this.itemMetaDataList = {};
    }
    buttonClick(buttonConfig) {
        // Update preferences to use final column index
        for (const view of this.views) {
            if (view.columnPreferences) {
                for (let i = 0; i < view.columnPreferences.length; i++) {
                    let columnPref = view.columnPreferences[i];
                    columnPref.columnIndex = i;
                }
            }
        }
        let result = new DwModalResult();
        result.closeModal = true;
        result.cancelled = buttonConfig.isCancel;
        result.data = {
            views: this.views
        };
        return of(result);
    }
    ngOnInit() {
        this.views = this.modalConfig.data.views;
        if (!this.views || this.views.length === 0) {
            throw new Error("gridPreferences.views are null, this shouldn't be able to happen!");
        }
        this.itemName = this.modalConfig.data.itemName;
        this.dwMetaDataService.getMetaData(this.itemName)
            .subscribe(itemMetaData => {
            this.itemMetaDataList[this.itemName] = itemMetaData;
            this.initSelectedView();
        });
    }
    initSelectedView() {
        let selectedView = this.views.find(v => v.key === this.modalConfig.data.selectedViewKey);
        if (!selectedView) {
            selectedView = this.views[0];
        }
        if (!selectedView.columnPreferences) {
            selectedView.columnPreferences = [];
        }
        this.changeView(selectedView);
    }
    changeView(view) {
        this.selectedView = view;
        this.dwMetaDataService.getSavedQueryMetaData(this.itemName, null, view.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.selectedQueryMetaData = queryMetaData;
            this.setupInitialColumns();
            this.buildAvailableAttrs();
            this.selectedField = null;
        });
    }
    ngAfterViewInit() {
        this.orderList.onSelectionChange.
            subscribe(e => {
            setTimeout(() => {
                if (this.orderList.selection && this.orderList.selection.length > 0) {
                    this.setSelectedField(this.orderList.selection[0]);
                }
                else {
                    this.setSelectedField(null);
                }
            });
        });
    }
    setupInitialColumns() {
        this.selectedView.columnPreferences = this.selectedView.columnPreferences || [];
        if (this.selectedView.columnPreferences.length == 0) {
            for (let attr of this.selectedQueryMetaData.Attributes) {
                this.addItem(attr);
            }
        }
        else {
            var cleanArray = [];
            for (let columnPref of this.selectedView.columnPreferences) {
                if (!columnPref.hide && columnPref.field != 'editColumn') {
                    cleanArray.push(columnPref);
                }
            }
            this.selectedView.columnPreferences = cleanArray;
        }
    }
    setSelectedField(field) {
        this.selectedField = field;
    }
    getFieldDisplay(field) {
        if (field.label)
            return field.label;
        if (this.selectedQueryMetaData) {
            const attr = this.selectedQueryMetaData.Attributes.find(a => a.AttributeName == field.field);
            if (attr) {
                return attr.AttributeDisplay;
            }
        }
        if (field.field == 'EditColumn') {
            return 'Edit Column';
        }
        return field.field;
    }
    removeAll() {
        this.selectedView.columnPreferences = [];
        this.selectedField = null;
        this.buildAvailableAttrs();
    }
    buildAvailableAttrs() {
        const attrs = [];
        for (let attr of this.selectedQueryMetaData.Attributes) {
            const found = findWhere(this.selectedView.columnPreferences, { field: attr.AttributeName });
            if (!found) {
                attrs.push(attr);
            }
        }
        this.availableAttributes = attrs;
    }
    addItem(attr) {
        const columnPref = {
            columnIndex: this.selectedView.columnPreferences.length,
            field: attr.AttributeName,
            hide: false,
        };
        this.selectedView.columnPreferences.push(columnPref);
        this.buildAvailableAttrs();
    }
    removeItem(item) {
        const index = this.selectedView.columnPreferences.indexOf(item);
        if (index >= 0)
            this.selectedView.columnPreferences.splice(index, 1);
        this.buildAvailableAttrs();
    }
}
DwMetadataGridConfigColumnsModalComponent.ɵfac = function DwMetadataGridConfigColumnsModalComponent_Factory(t) { return new (t || DwMetadataGridConfigColumnsModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwLoggingService)); };
DwMetadataGridConfigColumnsModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataGridConfigColumnsModalComponent, selectors: [["dw-metadata-grid-config-columns-modal"]], viewQuery: function DwMetadataGridConfigColumnsModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(OrderList, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.orderList = _t.first);
    } }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "header"], ["dragdrop", "true", "controlsPosition", "right", "styleClass", "dw-order-list", 3, "value"], ["pTemplate", "item"], ["dwCol", "12"], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["cla", ""], ["header", "Add Columns"], [1, "dw-order-list"], ["class", "field-item", 4, "ngFor", "ngForOf"], ["header", "Field Properties", 4, "ngIf"], [3, "ngValue"], [1, "order-item"], ["title", "Remove Field", 1, "fa", "fa-times", "hand", "pull-right", 3, "click"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add Field", 1, "fa", "fa-plus-circle", "hand"], ["header", "Field Properties"], ["header", "Basic Settings"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwMetadataGridConfigColumnsModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataGridConfigColumnsModalComponent_ng_container_0_Template, 23, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedView);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc21.OrderList, ɵngcc6.PrimeTemplate, ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc3.DefaultValueAccessor], styles: ["@media (min-width:768px){.ui-orderlist[_ngcontent-%COMP%]   .ui-orderlist-controls[_ngcontent-%COMP%]{padding:5px!important;width:50px}.ui-orderlist[_ngcontent-%COMP%]   .ui-orderlist-list-container[_ngcontent-%COMP%]{width:calc(100% - 55px)}.ui-orderlist[_ngcontent-%COMP%]   .ui-orderlist-list[_ngcontent-%COMP%]{height:500px}}.field-item[_ngcontent-%COMP%]{clear:left;margin-top:2px;width:200px}.field-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{text-align:left;width:100%}.header[_ngcontent-%COMP%]{margin-bottom:4px}"] });
DwMetadataGridConfigColumnsModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwLoggingService }
];
DwMetadataGridConfigColumnsModalComponent.propDecorators = {
    orderList: [{ type: ViewChild, args: [OrderList,] }]
};

var DwQueryTreeNodeType;
(function (DwQueryTreeNodeType) {
    DwQueryTreeNodeType[DwQueryTreeNodeType["settings"] = 0] = "settings";
    DwQueryTreeNodeType[DwQueryTreeNodeType["prefetch"] = 1] = "prefetch";
    DwQueryTreeNodeType[DwQueryTreeNodeType["queryRoot"] = 2] = "queryRoot";
    DwQueryTreeNodeType[DwQueryTreeNodeType["queryRelation"] = 3] = "queryRelation";
    DwQueryTreeNodeType[DwQueryTreeNodeType["testQuery"] = 4] = "testQuery";
})(DwQueryTreeNodeType || (DwQueryTreeNodeType = {}));
class DwQueryTreeNode {
    constructor(type) {
        this.data = {};
        this.data.queryNodeType = type;
    }
}
class DwQuerySettingItemNode extends DwQueryTreeNode {
    constructor() {
        super(DwQueryTreeNodeType.settings);
    }
}
class DwQueryTestNode extends DwQueryTreeNode {
    constructor() {
        super(DwQueryTreeNodeType.testQuery);
    }
}
class DwQueryPrefetchItemNode extends DwQueryTreeNode {
    constructor() {
        super(DwQueryTreeNodeType.prefetch);
    }
}
class DwQueryRootItemNode extends DwQueryTreeNode {
    constructor() {
        super(DwQueryTreeNodeType.queryRoot);
    }
}
class DwQueryRelationItemNode extends DwQueryTreeNode {
    constructor() {
        super(DwQueryTreeNodeType.queryRelation);
    }
}

class DwQueryEditorControllerService {
    constructor(dwMetaDataService, dwMetaDataRoutingService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
        this.queryEditorStateSubject = new BehaviorSubject(null);
    }
    getQueryEditorState() {
        return this.queryEditorStateSubject.asObservable();
    }
    updateState(queryEditorState) {
        this.queryEditorStateSubject.next(queryEditorState);
    }
    setupQuery(query, item) {
        if (!query || query.RootTable !== item) {
            query = new DwQuery(item);
            // Default to show all fields
            query.getFieldSettings().IncludeRootItemFields = true;
        }
        else {
            // Re-create the query to ensure it is a DwQuery object type
            query = deepCopyToObject(query, new DwQuery(item));
        }
        this.queryEditorState = {
            query: query,
            rootItem: item,
            itemMetaData: {},
            queryTree: [],
            selectedNode: null
        };
        this.updateTree();
    }
    getItemMetaData(item) {
        const itemName = item;
        if (this.queryEditorState.itemMetaData[itemName]) {
            return of(this.queryEditorState.itemMetaData[itemName]);
        }
        return this.dwMetaDataService.getMetaData(item)
            .pipe(map(itemMetaData => {
            this.queryEditorState.itemMetaData[itemName] = itemMetaData;
            return itemMetaData;
        }));
    }
    updateTree(afterUpdate) {
        // Update the tree to reflect the latest relations
        this.buildQueryTree(this.queryEditorState.query, this.queryEditorState.rootItem, this.queryEditorState.queryTree)
            .subscribe(queryTree => {
            // Always determine the current selected node
            this.determineSelectedNode(this.queryEditorState, queryTree);
            this.queryEditorState.queryTree = queryTree;
            if (afterUpdate) {
                afterUpdate();
            }
            this.queryEditorStateSubject.next(this.queryEditorState);
        });
    }
    buildQueryTree(query, item, currentTree) {
        const queryTree = [];
        if (!item) {
            return of(queryTree);
        }
        const rootNode = new DwQuerySettingItemNode();
        rootNode.label = 'Settings';
        rootNode.children = [];
        queryTree.push(rootNode);
        const testNode = new DwQueryTestNode();
        testNode.label = 'Test Query';
        queryTree.push(testNode);
        return this.getItemMetaData(item)
            .pipe(mergeMap(rootItemMetaData => {
            const queryRoot = new DwQueryRootItemNode();
            queryRoot.label = rootItemMetaData.Display;
            queryRoot.data.item = item;
            this.syncTreeNode(queryRoot, currentTree);
            // Add to the first item in the tree
            queryTree.unshift(queryRoot);
            this.syncTreeNode(queryRoot, currentTree);
            return this.buildQueryTreeRelations(item, query.Relations)
                .pipe(map(relationNodes => {
                queryRoot.children = relationNodes;
                if (relationNodes.find(r => r.expanded)) {
                    queryRoot.expanded = true;
                }
                return queryTree;
            }));
        }));
    }
    determineSelectedNode(editorState, newQueryTree) {
        if (editorState.selectedNode) {
            // get existing selected node if found
            editorState.selectedNode = this.getExistingNode(editorState.selectedNode, editorState.queryTree);
        }
        if (newQueryTree && newQueryTree.length > 0 && (!editorState.selectedNode || editorState.selectedNode.data.isRemoved)) {
            editorState.selectedNode = newQueryTree[0];
        }
    }
    syncTreeNode(newNode, currentTree) {
        const existingNode = this.getExistingNode(newNode, currentTree);
        if (!existingNode) {
            return;
        }
        newNode.expanded = existingNode.expanded;
    }
    getExistingNode(newNode, currentTree) {
        switch (newNode.data.queryNodeType) {
            case DwQueryTreeNodeType.queryRoot:
                const relatedRootNode = this.findNode(currentTree, (node) => node.data.queryNodeType == newNode.data.queryNodeType);
                return relatedRootNode;
            case DwQueryTreeNodeType.queryRelation:
                const newRelationNode = newNode;
                const relatedRoelationNode = this.findNode(currentTree, (node) => {
                    var _a, _b;
                    let node2 = node;
                    if (node2.data.queryNodeType != DwQueryTreeNodeType.queryRelation) {
                        return false;
                    }
                    if (((_a = newRelationNode.data.relation) === null || _a === void 0 ? void 0 : _a.RelationshipName) != ((_b = node2.data.relation) === null || _b === void 0 ? void 0 : _b.RelationshipName)) {
                        return false;
                    }
                    if (newRelationNode.data.queryRelation.FieldPrefix != node2.data.queryRelation.FieldPrefix) {
                        return false;
                    }
                    return true;
                });
                return relatedRoelationNode;
        }
    }
    findNode(nodes, findFunc) {
        var _a;
        for (const node of nodes || []) {
            const isFindMatch = findFunc(node);
            if (isFindMatch) {
                return node;
            }
            if (((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const foundChildNode = this.findNode(node.children, findFunc);
                if (foundChildNode) {
                    return foundChildNode;
                }
            }
        }
        return null;
    }
    buildContextMenu(node) {
        var _a, _b, _c, _d, _e, _f;
        const contextMenu = [];
        const state = this.queryEditorStateSubject.value;
        if (((_a = node.data) === null || _a === void 0 ? void 0 : _a.queryNodeType) == DwQueryTreeNodeType.queryRoot || ((_b = node.data) === null || _b === void 0 ? void 0 : _b.queryNodeType) == DwQueryTreeNodeType.queryRelation) {
            const menu = {
                label: 'Add Relation',
                command: (event) => {
                    this.addRelation(node);
                }
            };
            contextMenu.push(menu);
        }
        if (((_c = node.data) === null || _c === void 0 ? void 0 : _c.queryNodeType) == DwQueryTreeNodeType.queryRelation) {
            const menu = {
                label: 'Remove Relation',
                command: (event) => {
                    this.removeRelation(node);
                }
            };
            contextMenu.push(menu);
            // Add reparent option for first level relations
            if (node.parent && !node.parent.parent) {
                const menu2 = {
                    label: 'Make Query Parent',
                    command: (event) => {
                        this.makeQueryParent(node);
                    }
                };
                contextMenu.push(menu2);
            }
        }
        // if (node.data?.queryNodeType == DwQueryTreeNodeType.queryRoot) {
        //     const item = state.itemMetaData[state.rootItem];
        //     const menu2: MenuItem = {
        //         label: `Edit Meta Data for ${item.Display}`,
        //         command: (event) => {
        //             this.gotoMetaDataItem(item, event?.originalEvent);
        //         }
        //     };
        //     contextMenu.push(menu2);
        // }
        // Add Meta data links for the root and any relations
        let itemName;
        if (((_d = node.data) === null || _d === void 0 ? void 0 : _d.queryNodeType) == DwQueryTreeNodeType.queryRelation) {
            const relationNode = node;
            itemName = (_e = relationNode.data) === null || _e === void 0 ? void 0 : _e.item;
        }
        if (((_f = node.data) === null || _f === void 0 ? void 0 : _f.queryNodeType) == DwQueryTreeNodeType.queryRoot) {
            itemName = state.rootItem;
        }
        if (itemName) {
            const item = state.itemMetaData[itemName];
            if (item) {
                const menu2 = {
                    label: `Edit Meta Data for ${item.Display}`,
                    command: (event) => {
                        this.gotoMetaDataItem(item, event === null || event === void 0 ? void 0 : event.originalEvent);
                    }
                };
                contextMenu.push(menu2);
            }
        }
        return contextMenu;
    }
    makeQueryParent(node) {
        var _a;
        alert('We recommend you copy the query prior to choosing this option to preserve the existing query.');
        const newState = Object.assign({}, this.queryEditorState);
        const query = newState.query;
        query.RootTable = node.data.item;
        const parent = node.parent;
        const newSubRelations = [...query.Relations];
        const index = newSubRelations.indexOf(node.data.queryRelation);
        if (index >= 0) {
            newSubRelations.splice(index, 1);
        }
        // Add parent relation
        const oldParentRelation = {
            RelationName: node.data.relation.RelationshipName,
            JoinType: node.data.queryRelation.JoinType,
            Filter: query.Filter,
            SubRelations: newSubRelations,
            FieldPrefix: parent.data.item,
        };
        if (!query.FieldSettings.IncludeRootItemFields) {
            if (((_a = query.FieldSettings.IncludeFields) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                oldParentRelation.RelationFields = [...query.FieldSettings.IncludeFields];
            }
        }
        else {
            const parentMetaData = newState.itemMetaData[parent.data.item];
            const relationFields = [];
            for (const attr of (parentMetaData === null || parentMetaData === void 0 ? void 0 : parentMetaData.Attributes) || []) {
                const field = {
                    FieldType: DwFieldType.Standard,
                    FullFieldName: `${parentMetaData.UniqueItemName}.${attr.AttributeName}`,
                };
                relationFields.push(field);
            }
            oldParentRelation.RelationFields = relationFields;
        }
        query.FieldSettings.IncludeRootItemFields = false;
        query.FieldSettings.IncludeFields = node.data.queryRelation.RelationFields;
        query.Relations = [oldParentRelation];
        query.Filter = new DwQueryFilterGroup();
        this.setupQuery(query, query.RootTable);
    }
    gotoMetaDataItem(item, event) {
        const keyValue = item.MetaDataItemId;
        const browserEvent = getDwBrowserEvent(event);
        const windowOptions = getWindowOpenOptions(browserEvent, {});
        this.dwMetaDataRoutingService.routeToEditOrViewWithKey(null, DevwareMetaDataItemNames.DwMetaDataItem, keyValue, DwMenuActionType.edit, windowOptions);
    }
    addRelation(node) {
        const newState = Object.assign({}, this.queryEditorState);
        if (this.queryEditorState.selectedNode != node) {
            this.queryEditorState.selectedNode = node;
            this.updateState(newState);
            setTimeout(() => {
                const newState2 = Object.assign({}, this.queryEditorState);
                newState2.showAddRelation = true;
                this.updateState(newState2);
            }, 100);
            return;
        }
        newState.showAddRelation = true;
        this.updateState(newState);
    }
    changeRelation(node, relation) {
        // update properties on the existing 
        node.data.queryRelation.RelationName = relation.RelationshipName;
        const existingNode = this.getExistingNode(node, this.queryEditorState.queryTree);
        if (!existingNode) {
            return;
        }
        existingNode.data.queryRelation.RelationName = relation.RelationshipName;
        this.updateTree(() => {
            const currentState = this.queryEditorState;
            // Get parent node (since we can't find the current node since the relationship changed)
            const newParentNode = this.getExistingNode(node, currentState.queryTree);
            if (newParentNode) {
                currentState.selectedNode = newParentNode;
            }
            else {
                currentState.selectedNode = currentState.queryTree[0];
            }
        });
        // const newState = { ...this.queryEditorState };
        // // Get parent node (since we can't find the current node since the relationship changed)
        // const newParentNode = this.getExistingNode(node.parent as any, newState.queryTree);
        // if (newParentNode) {
        //     newState.selectedNode = newParentNode.children[0];
        // }
        // this.updateState(newState);
    }
    removeRelation(node) {
        const parentNode = node.parent;
        const newState = Object.assign({}, this.queryEditorState);
        let parentRelations = newState.query.Relations;
        if (parentNode instanceof DwQueryRelationItemNode) {
            const parentRelation = parentNode;
            parentRelations = parentRelation.data.queryRelation.SubRelations;
        }
        const relationIndex = parentRelations.indexOf(node.data.queryRelation);
        if (relationIndex >= 0) {
            parentRelations.splice(relationIndex, 1);
        }
        const nodeIndex = parentNode.children.indexOf(node);
        if (nodeIndex >= 0) {
            node.data.isRemoved = true;
            parentNode.children.splice(nodeIndex, 1);
        }
        newState.selectedNode = parentNode;
        this.updateState(newState);
    }
    buildQueryTreeRelations(parentItem, queryRelations, parentIsInvalid = false) {
        const relationNodes = [];
        if (!queryRelations || queryRelations.length == 0) {
            return of([]);
        }
        return this.getItemMetaData(parentItem)
            .pipe(mergeMap(parentItemMetaData => {
            const relationObs = [];
            for (const queryRelation of queryRelations) {
                const relationOb = this.buildQueryTreeRelation(parentItemMetaData, queryRelation, parentIsInvalid)
                    .pipe(tap(relationNode => {
                    if (relationNode) {
                        relationNodes.push(relationNode);
                    }
                }));
                relationObs.push(relationOb);
            }
            // Wait until all relation obserables complete, then return the array
            return combineLatest(relationObs, results => {
                return relationNodes;
            });
        }));
    }
    buildQueryTreeRelation(parentItemMetaData, queryRelation, parentIsInvalid = false) {
        var _a;
        const relation = findWhere(parentItemMetaData === null || parentItemMetaData === void 0 ? void 0 : parentItemMetaData.Relations, { RelationshipName: queryRelation.RelationName });
        const node = new DwQueryRelationItemNode();
        node.data.relation = relation;
        node.data.queryRelation = queryRelation;
        node.data.parentIsInvalid = parentIsInvalid;
        node.icon = 'fa fa-table';
        if (!relation || parentIsInvalid) {
            let message = `Relation ${queryRelation.RelationName} was not found as a relationship for ${parentItemMetaData === null || parentItemMetaData === void 0 ? void 0 : parentItemMetaData.Display}`;
            if (parentIsInvalid) {
                message = 'Parent Relationship is not valid and must be fixed';
            }
            console.warn(message);
            node.data.hasErrors = true;
            node.data.errorMessage = message;
            node.label = queryRelation.RelationName + ' (Missing)';
            node.icon = 'fa fa-table dw-red';
            this.expandAllParents(node);
            // return of(null);
        }
        else {
            node.data.item = (_a = relation === null || relation === void 0 ? void 0 : relation.NamingInfo) === null || _a === void 0 ? void 0 : _a.RelationshipItemName;
            node.label = relation.NamingInfo.RelationshipDisplayName;
        }
        if (queryRelation.SubRelations && queryRelation.SubRelations.length > 0) {
            return this.buildQueryTreeRelations(node.data.item, queryRelation.SubRelations, node.data.hasErrors)
                .pipe(map(relationNodes => {
                node.children = relationNodes;
                if (relationNodes.find(r => r.data.hasErrors)) {
                    node.expanded = true;
                }
                return node;
            }));
        }
        return of(node);
    }
    expandAllParents(node) {
        var parent = node.parent;
        if (!parent) {
            return;
        }
        parent.expanded = true;
        this.expandAllParents(parent);
    }
}
DwQueryEditorControllerService.ɵfac = function DwQueryEditorControllerService_Factory(t) { return new (t || DwQueryEditorControllerService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataRoutingService)); };
DwQueryEditorControllerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwQueryEditorControllerService, factory: DwQueryEditorControllerService.ɵfac });
DwQueryEditorControllerService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataRoutingService }
];
function SyncTreeNode(queryRoot, currentTree) {
    throw new Error('Function not implemented.');
}

class DwQueryEditorContainerComponent extends DwControlBaseComponent {
    constructor(dwQueryEditorController) {
        super();
        this.dwQueryEditorController = dwQueryEditorController;
        this.itemChange = new EventEmitter();
    }
    translateTo(query) {
        this.dwQueryEditorController.setupQuery(query, this.item);
        return query;
    }
    ngOnChanges(changes) {
        var _a, _b;
        if (changes.item && !changes.item.firstChange && changes.item.currentValue) {
            if (this.item != ((_b = (_a = this.editorState) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.RootTable)) {
                this.dwQueryEditorController.setupQuery(this.translatedValue, this.item);
            }
        }
    }
    contextMenuClick(event, node) {
        this.contextMenuItems = this.dwQueryEditorController.buildContextMenu(node);
        if (this.contextMenuItems.length > 0) {
            this.cmRoutes.show(event);
            return;
        }
        event.preventDefault();
        return false;
    }
    ngOnInit() {
        this.contextMenuItems = [];
        this.dwQueryEditorController.getQueryEditorState()
            .subscribe(editorState => {
            if (!editorState) {
                return;
            }
            this.editorState = editorState;
            this.selectedNode = this.editorState.selectedNode;
            if (this.editorState.query) {
                this.setValue(this.editorState.query);
            }
            if (this.item != this.editorState.query.RootTable) {
                const itemMd = this.editorState.itemMetaData[this.editorState.query.RootTable];
                this.itemChange.emit({
                    itemName: this.editorState.query.RootTable,
                    metaDataItemId: itemMd.MetaDataItemId
                });
            }
        });
        if (this.translatedValue) {
            this.dwQueryEditorController.setupQuery(this.translatedValue, this.item);
        }
    }
    selectNode(node) {
        this.cmRoutes.hide();
        this.selectedNode = node;
        this.editorState.selectedNode = node;
        this.dwQueryEditorController.updateState(this.editorState);
    }
}
DwQueryEditorContainerComponent.ɵfac = function DwQueryEditorContainerComponent_Factory(t) { return new (t || DwQueryEditorContainerComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService)); };
DwQueryEditorContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorContainerComponent, selectors: [["dw-query-editor"]], viewQuery: function DwQueryEditorContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c72, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cmRoutes = _t.first);
    } }, inputs: { item: "item" }, outputs: { itemChange: "itemChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DwQueryEditorControllerService,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwQueryEditorContainerComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "dw-panel", 4, "ngIf"], [1, "dw-panel"], [1, "dw-panel-left"], ["selectionMode", "single", 3, "value", "selection", "selectionChange"], ["pTemplate", "default"], [1, "dw-panel-right"], [3, "node"], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "model"], ["contextMenu1", ""], [3, "contextmenu"]], template: function DwQueryEditorContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQueryEditorContainerComponent_div_0_Template, 8, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.editorState);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc8.Tree, ɵngcc6.PrimeTemplate, DwQueryPanelFactoryComponent, ɵngcc7.ContextMenu]; }, styles: [".move-arrow-down[_ngcontent-%COMP%]{display:block;margin-top:-25px}.dw-panel[_ngcontent-%COMP%]{height:100%;overflow:auto;width:100%}.dw-panel[_ngcontent-%COMP%]   .dw-panel-left[_ngcontent-%COMP%]{float:left;height:100%;width:350px}.dw-panel[_ngcontent-%COMP%]   .dw-panel-right[_ngcontent-%COMP%]{background-color:#fff;border:1px solid #c8c8c8;border-radius:3px;color:#333;float:left;height:100%;max-width:1024px;min-width:800px;padding:.571em 1em;width:calc(100% - 360px)}.dw-panel-flex[_ngcontent-%COMP%]{background-color:#000;display:flex;flex-flow:row;height:100%;padding:5px}.dw-panel-flex[_ngcontent-%COMP%]   .dw-panel-left[_ngcontent-%COMP%]{background-color:#add8e6;display:flex;flex-direction:row;padding:5px;width:300px}.dw-panel-flex[_ngcontent-%COMP%]   .dw-panel-right[_ngcontent-%COMP%]{background-color:#90ee90;display:flex;flex:3;flex-basis:100%;flex-direction:row;padding:5px}.ui-tree[_ngcontent-%COMP%]{width:100%}"] });
DwQueryEditorContainerComponent.ctorParameters = () => [
    { type: DwQueryEditorControllerService }
];
DwQueryEditorContainerComponent.propDecorators = {
    item: [{ type: Input }],
    itemChange: [{ type: Output }],
    cmRoutes: [{ type: ViewChild, args: ['contextMenu1',] }]
};

class DwQueryPanelBase {
    constructor(dwQueryEditorController) {
        this.dwQueryEditorController = dwQueryEditorController;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.dwQueryEditorController.getQueryEditorState()
            .subscribe(editorState => {
            this.editorState = editorState;
            this.setupPanel();
        }));
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    updateState() {
        this.dwQueryEditorController.updateState(this.editorState);
    }
}
DwQueryPanelBase.ɵfac = function DwQueryPanelBase_Factory(t) { return new (t || DwQueryPanelBase)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService)); };
DwQueryPanelBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwQueryPanelBase, inputs: { node: "node" } });
DwQueryPanelBase.ctorParameters = () => [
    { type: DwQueryEditorControllerService }
];
DwQueryPanelBase.propDecorators = {
    node: [{ type: Input }]
};

class DwQueryPanelSettingsComponent extends DwQueryPanelBase {
    constructor(dwQueryEditorController) {
        super(dwQueryEditorController);
    }
    setupPanel() {
        // No setup to perform
    }
    updateDistinct(distinctValue) {
        this.editorState.query.PagingInfo = this.editorState.query.PagingInfo || {};
        this.editorState.query.PagingInfo.Distinct = distinctValue;
    }
}
DwQueryPanelSettingsComponent.ɵfac = function DwQueryPanelSettingsComponent_Factory(t) { return new (t || DwQueryPanelSettingsComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService)); };
DwQueryPanelSettingsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryPanelSettingsComponent, selectors: [["dw-query-panel-settings"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 1, consts: [["class", "settings-panel", 4, "ngIf"], [1, "settings-panel"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"]], template: function DwQueryPanelSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h2");
        ɵngcc0.ɵɵtext(1, "Settings");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, DwQueryPanelSettingsComponent_div_2_Template, 31, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.editorState == null ? null : ctx.editorState.query == null ? null : ctx.editorState.query.FieldSettings);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [_c73] });
DwQueryPanelSettingsComponent.ctorParameters = () => [
    { type: DwQueryEditorControllerService }
];

class DwQueryPanelRootComponent extends DwQueryPanelBase {
    constructor(dwQueryEditorController) {
        super(dwQueryEditorController);
    }
    setupPanel() {
        if (!this.node || !this.node.data) {
            return;
        }
        this.subscriptions.push(this.dwQueryEditorController.getQueryEditorState()
            .subscribe(s => {
            if (s.showAddRelation) {
                this.startAddRelation();
                s.showAddRelation = false;
                this.dwQueryEditorController.updateState(s);
            }
        }));
        this.subscriptions.push(this.dwQueryEditorController.getItemMetaData(this.node.data.item)
            .subscribe(itemMetaData => {
            this.setupChildState(itemMetaData);
        }));
    }
    setupChildState(itemMetaData) {
        const query = this.editorState.query;
        const fieldSettings = this.editorState.query.FieldSettings;
        this.fieldState = {
            itemMd: itemMetaData,
            allowIncludeRootItemFields: true,
            includeRootItemFields: fieldSettings.IncludeRootItemFields,
            selectedFields: fieldSettings.IncludeFields,
            isAggreateQuery: fieldSettings.AggregateQuery || fieldSettings.AggregateQueryWithRollup
        };
        this.filterState = {
            item: itemMetaData.UniqueItemName,
            filters: query.Filter
        };
        this.sortState = {
            itemMd: itemMetaData,
            order: query.Order
        };
    }
    startAddRelation() {
        this.addingRelation = true;
    }
    completeAddRelation(relation) {
        const query = this.editorState.query;
        const queryRelation = new DwQueryRelation();
        queryRelation.RelationName = relation.RelationshipName;
        queryRelation.FieldPrefix = relation.NamingInfo.FieldPrefix;
        query.Relations = query.Relations || [];
        query.Relations.push(queryRelation);
        this.dwQueryEditorController.updateTree();
        this.dwQueryEditorController.updateState(this.editorState);
    }
    filterStateChange(filterState) {
        this.filterState = filterState;
        // Need to update the filters on the query
        const query = this.editorState.query;
        query.Filter = filterState.filters;
        this.updateState();
    }
    fieldStateChange(fieldState) {
        this.fieldState = fieldState;
        const query = this.editorState.query;
        query.getFieldSettings().IncludeRootItemFields = fieldState.includeRootItemFields;
        query.getFieldSettings().IncludeFields = fieldState.selectedFields;
        this.updateState();
    }
    sortStateChange(sortState) {
        this.sortState = sortState;
        const query = this.editorState.query;
        query.Order = sortState.order;
        this.updateState();
    }
}
DwQueryPanelRootComponent.ɵfac = function DwQueryPanelRootComponent_Factory(t) { return new (t || DwQueryPanelRootComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService)); };
DwQueryPanelRootComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryPanelRootComponent, selectors: [["dw-query-panel-root"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 7, consts: [["dwRow", ""], ["dwCol", "6"], ["class", "pull-right", 4, "ngIf"], [3, "itemMetaData", "showAddRelation", "completeAddRelation", "showAddRelationChange"], ["header", "Fields"], [3, "fieldState", "fieldStateChange"], ["header", "Filters"], [3, "filterState", "filterStateChange"], ["header", "Sorting"], [3, "sortState", "sortStateChange"], [1, "pull-right"], ["title", "Add Relation", 1, "hand", 3, "click"], [1, "fa", "fa-exchange-alt"]], template: function DwQueryPanelRootComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h2");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵtemplate(5, DwQueryPanelRootComponent_div_5_Template, 3, 0, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "dw-query-editor-add-relation", 3);
        ɵngcc0.ɵɵlistener("completeAddRelation", function DwQueryPanelRootComponent_Template_dw_query_editor_add_relation_completeAddRelation_6_listener($event) { return ctx.completeAddRelation($event); })("showAddRelationChange", function DwQueryPanelRootComponent_Template_dw_query_editor_add_relation_showAddRelationChange_6_listener($event) { return ctx.addingRelation = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "p-tabView");
        ɵngcc0.ɵɵelementStart(8, "p-tabPanel", 4);
        ɵngcc0.ɵɵelementStart(9, "dw-query-editor-fields-advanced", 5);
        ɵngcc0.ɵɵlistener("fieldStateChange", function DwQueryPanelRootComponent_Template_dw_query_editor_fields_advanced_fieldStateChange_9_listener($event) { return ctx.fieldStateChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p-tabPanel", 6);
        ɵngcc0.ɵɵelementStart(11, "dw-query-editor-filters", 7);
        ɵngcc0.ɵɵlistener("filterStateChange", function DwQueryPanelRootComponent_Template_dw_query_editor_filters_filterStateChange_11_listener($event) { return ctx.filterStateChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p-tabPanel", 8);
        ɵngcc0.ɵɵelementStart(13, "dw-query-editor-sort", 9);
        ɵngcc0.ɵɵlistener("sortStateChange", function DwQueryPanelRootComponent_Template_dw_query_editor_sort_sortStateChange_13_listener($event) { return ctx.sortStateChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.fieldState == null ? null : ctx.fieldState.itemMd == null ? null : ctx.fieldState.itemMd.Display);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.addingRelation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("itemMetaData", ctx.fieldState.itemMd)("showAddRelation", ctx.addingRelation);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("fieldState", ctx.fieldState);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("filterState", ctx.filterState);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("sortState", ctx.sortState);
    } }, directives: function () { return [DwRowDirective, DwColDirective, ɵngcc4.NgIf, DwQueryEditorAddRelationComponent, ɵngcc9.TabView, ɵngcc9.TabPanel, DwQueryEditorFieldsAdvancedComponent, DwQueryEditorFiltersComponent, DwQueryEditorSortComponent]; }, styles: [".pull-right[_ngcontent-%COMP%]{float:right}"] });
DwQueryPanelRootComponent.ctorParameters = () => [
    { type: DwQueryEditorControllerService }
];

class DwQueryPanelRelationComponent extends DwQueryPanelBase {
    constructor(dwQueryEditorController) {
        super(dwQueryEditorController);
    }
    setupPanel() {
        if (!this.node || !this.node.data) {
            return;
        }
        this.queryNode = this.node.data;
        this.subscriptions.push(this.dwQueryEditorController.getQueryEditorState()
            .subscribe(s => {
            if (s.showAddRelation) {
                this.startAddRelation();
                s.showAddRelation = false;
                this.dwQueryEditorController.updateState(s);
            }
        }));
        this.dwQueryEditorController.getItemMetaData(this.node.data.item)
            .subscribe(itemMetaData => {
            this.setupChildState(itemMetaData);
        });
        const parentItem = this.node.parent.data.item;
        if (parentItem) {
            this.dwQueryEditorController.getItemMetaData(this.node.parent.data.item)
                .subscribe(parentItemMetaData => {
                this.parentItemMetaData = parentItemMetaData;
            });
        }
    }
    setupChildState(itemMetaData) {
        const query = this.editorState.query;
        this.queryNode = this.node.data;
        const queryRelation = this.node.data.queryRelation;
        if (this.queryNode.hasErrors) {
            this.message = {
                messageHeading: 'Relationship Error',
                messageBody: this.queryNode.errorMessage,
                severity: DwMessageSeverity.error
            };
            // Get the parent meta data so we can fix the relation
            return;
        }
        this.fieldState = {
            itemMd: itemMetaData,
            allowIncludeRootItemFields: false,
            includeRootItemFields: false,
            selectedFields: queryRelation.RelationFields || [],
            isAggreateQuery: this.editorState.query.FieldSettings.AggregateQuery || this.editorState.query.FieldSettings.AggregateQueryWithRollup
        };
        this.relation = itemMetaData.Relations.find(r => r.RelationshipName == queryRelation.RelationName);
        if (this.relation) {
            this.relationSettingState = {
                joinType: queryRelation.JoinType,
                fieldPrefix: queryRelation.FieldPrefix,
                fieldDisplayPrefix: queryRelation.FieldDisplayPrefix
            };
            this.filterState = {
                item: itemMetaData.UniqueItemName,
                filters: queryRelation.Filter
            };
        }
    }
    startAddRelation() {
        this.addingRelation = true;
    }
    completeAddRelation(relation) {
        const query = this.editorState.query;
        const queryRelation = new DwQueryRelation();
        queryRelation.RelationName = relation.RelationshipName;
        queryRelation.FieldPrefix = relation.NamingInfo.FieldPrefix;
        this.node.data.queryRelation.SubRelations.push(queryRelation);
        this.dwQueryEditorController.updateTree();
        this.addingRelation = false;
        this.updateState();
    }
    startChangeRelation() {
        this.changingRelation = true;
    }
    startFixRelation() {
        this.fixingRelation = true;
    }
    completeFixRelation(relation) {
        this.fixingRelation = false;
        this.dwQueryEditorController.changeRelation(this.node, relation);
    }
    removeRelation() {
        this.dwQueryEditorController.removeRelation(this.node);
    }
    relationSettingStateChange(relationSettingState) {
        this.relationSettingState = relationSettingState;
        const queryRelation = this.node.data.queryRelation;
        queryRelation.FieldPrefix = relationSettingState.fieldPrefix;
        queryRelation.FieldDisplayPrefix = relationSettingState.fieldDisplayPrefix;
        queryRelation.JoinType = relationSettingState.joinType;
        this.updateState();
    }
    filterStateChange(filterState) {
        this.filterState = filterState;
        // Need to update the filters on the query
        const queryRelation = this.node.data.queryRelation;
        queryRelation.Filter = filterState.filters;
        this.updateState();
    }
    fieldStateChange(fieldState) {
        this.fieldState = fieldState;
        // Need to update the filters on the query
        const queryRelation = this.node.data.queryRelation;
        queryRelation.RelationFields = fieldState.selectedFields;
        this.updateState();
    }
}
DwQueryPanelRelationComponent.ɵfac = function DwQueryPanelRelationComponent_Factory(t) { return new (t || DwQueryPanelRelationComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService)); };
DwQueryPanelRelationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryPanelRelationComponent, selectors: [["dw-query-panel-relation"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[3, "message", "messageChange"], [4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], ["class", "pull-right", 4, "ngIf"], ["class", "pull-right ml-1 mr-1", 4, "ngIf"], [3, "itemMetaData", "showAddRelation", "completeAddRelation", "showAddRelationChange", 4, "ngIf"], ["header", "Fields"], [3, "fieldState", "fieldStateChange"], ["header", "Filters"], [3, "filterState", "filterStateChange"], ["header", "Relation Properties"], [3, "relationSettingState", "relation", "relationSettingStateChange"], [1, "pull-right"], ["title", "Add Relation", 1, "hand", 3, "click"], [1, "fa", "fa-fa", "fa-plus-square"], [1, "pull-right", "ml-1", "mr-1"], ["title", "Change Relation", 1, "hand", 3, "click"], [1, "fa", "fa-edit"], [3, "itemMetaData", "showAddRelation", "completeAddRelation", "showAddRelationChange"], ["class", "btn btn-success mr-2", 3, "click", 4, "ngIf"], ["title", "Remove relation and all children", 1, "btn", "btn-warning", 3, "click"], [1, "btn", "btn-success", "mr-2", 3, "click"]], template: function DwQueryPanelRelationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-message", 0);
        ɵngcc0.ɵɵlistener("messageChange", function DwQueryPanelRelationComponent_Template_dw_message_messageChange_0_listener($event) { return ctx.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(1, DwQueryPanelRelationComponent_ng_container_1_Template, 17, 9, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, DwQueryPanelRelationComponent_ng_container_2_Template, 3, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relation);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.relation);
    } }, directives: function () { return [DwMessageComponent, ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc9.TabView, ɵngcc9.TabPanel, DwQueryEditorFieldsAdvancedComponent, DwQueryEditorFiltersComponent, DwQueryRelationSettingsComponent, DwQueryEditorAddRelationComponent, DwQueryEditorFixRelationComponent]; }, styles: [".pull-right[_ngcontent-%COMP%]{float:right}"] });
DwQueryPanelRelationComponent.ctorParameters = () => [
    { type: DwQueryEditorControllerService }
];

class DwQueryPanelTestComponent extends DwQueryPanelBase {
    constructor(dwQueryEditorController) {
        super(dwQueryEditorController);
        this.loadCount = false;
    }
    setupPanel() {
        // No setup to perform
        this.dwQueryEditorController.getQueryEditorState()
            .subscribe(state => {
            this.item = state.rootItem;
            this.query = deepCopy(state.query);
        });
    }
}
DwQueryPanelTestComponent.ɵfac = function DwQueryPanelTestComponent_Factory(t) { return new (t || DwQueryPanelTestComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService)); };
DwQueryPanelTestComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryPanelTestComponent, selectors: [["dw-query-panel-test"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 4, consts: [["dwRow", ""], ["dwCol", ""], [1, "label"], [3, "ngModel", "ngModelChange"], [3, "item", "query", "loadCount"]], template: function DwQueryPanelTestComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3, "Load Count");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryPanelTestComponent_Template_dw_yesno_ngModelChange_4_listener($event) { return ctx.loadCount = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "dw-quick-grid", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.loadCount);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("item", ctx.item)("query", ctx.query)("loadCount", ctx.loadCount);
    } }, directives: function () { return [DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwQuickGrid]; }, encapsulation: 2 });
DwQueryPanelTestComponent.ctorParameters = () => [
    { type: DwQueryEditorControllerService }
];

class DwQueryPanelFactoryComponent extends DwQueryPanelBase {
    constructor(dwQueryEditorController, resolver) {
        super(dwQueryEditorController);
        this.resolver = resolver;
    }
    ngAfterViewInit() {
        this.loadQueryPanel();
    }
    ngOnChanges(changes) {
        if (changes.node) {
            if (!changes.node.firstChange) {
                this.loadQueryPanel();
            }
        }
    }
    setupPanel() {
    }
    loadQueryPanel() {
        if (!this.dwComponentHost || !this.dwComponentHost.viewContainerRef || !this.node || !this.node.data) {
            return;
        }
        const component = this.determineQueryPanelComponent(this.node.data.queryNodeType);
        if (!component) {
            return;
        }
        if (this.componentInstance) {
            if (this.componentInstance.destroy) {
                this.componentInstance.destroy();
            }
            this.componentInstance = null;
        }
        let viewContainerRef = this.dwComponentHost.viewContainerRef;
        viewContainerRef.clear();
        if (!component) {
            return;
        }
        const componentFactory = this.resolver.resolveComponentFactory(component);
        let componentRef = viewContainerRef.createComponent(componentFactory);
        this.componentInstance = componentRef.instance;
        // Do this in a timeout to eliminate the error "Expression has changed after it was checked"
        this.componentInstance.node = this.node;
        componentRef.changeDetectorRef.detectChanges();
    }
    determineQueryPanelComponent(queryNodeType) {
        switch (queryNodeType) {
            case DwQueryTreeNodeType.settings:
                return DwQueryPanelSettingsComponent;
            case DwQueryTreeNodeType.queryRoot:
                return DwQueryPanelRootComponent;
            case DwQueryTreeNodeType.queryRelation:
                return DwQueryPanelRelationComponent;
            case DwQueryTreeNodeType.testQuery:
                return DwQueryPanelTestComponent;
        }
        return null;
    }
}
DwQueryPanelFactoryComponent.ɵfac = function DwQueryPanelFactoryComponent_Factory(t) { return new (t || DwQueryPanelFactoryComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryEditorControllerService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
DwQueryPanelFactoryComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryPanelFactoryComponent, selectors: [["dw-query-panel-factory"]], viewQuery: function DwQueryPanelFactoryComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwComponentHost, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwComponentHost = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 0, consts: [["dw-component-host", ""]], template: function DwQueryPanelFactoryComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQueryPanelFactoryComponent_ng_template_0_Template, 0, 0, "ng-template", 0);
    } }, directives: [DwComponentHost], encapsulation: 2 });
DwQueryPanelFactoryComponent.ctorParameters = () => [
    { type: DwQueryEditorControllerService },
    { type: ComponentFactoryResolver }
];
DwQueryPanelFactoryComponent.propDecorators = {
    dwComponentHost: [{ type: ViewChild, args: [DwComponentHost, { static: true },] }]
};

class DwQueryEditorFieldsComponent {
    constructor() {
        this.fieldStateChange = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.fieldState) {
            this.allAttributes = this.buildQueryAttributes();
            this.buildAvailableFields();
        }
    }
    buildAvailableFields() {
        if (this.fieldState) {
            let availableAttributes = [];
            for (let attr of this.allAttributes) {
                if (!this.hasAttribute(attr)) {
                    availableAttributes.push(attr);
                }
            }
            this.availableAttributes = availableAttributes;
        }
    }
    buildQueryAttributes() {
        const queryAttributes = [];
        if (!this.fieldState.itemMd) {
            return;
        }
        for (let attr of this.fieldState.itemMd.Attributes) {
            const queryAttr = {};
            queryAttr.AttributeName = attr.AttributeName;
            queryAttr.AttributeDisplay = attr.Display;
            queryAttr.Attribute = attr;
            queryAttributes.push(queryAttr);
        }
        return queryAttributes;
    }
    getFieldDisplay(field) {
        const attr = this.findAttribute(field.FullFieldName);
        if (attr) {
            return attr.Display;
        }
        return "No Field Name";
    }
    removeField(field) {
        const fields = this.fieldState.selectedFields;
        const index = fields.indexOf(field);
        if (index >= 0) {
            fields.splice(index, 1);
        }
        this.buildAvailableFields();
        this.stateChange();
    }
    addField(attr) {
        const qh = new DwQueryHelper();
        const field = new DwField();
        const fields = this.fieldState.selectedFields;
        let itemName = this.fieldState.itemMd.UniqueItemName;
        field.FullFieldName = qh.fields.buildFullFieldName(attr.AttributeName, itemName);
        fields.push(field);
        this.buildAvailableFields();
        this.stateChange();
    }
    rootItemFieldsChange() {
        if (this.fieldState.includeRootItemFields) {
        }
        this.stateChange();
    }
    stateChange() {
        this.fieldStateChange.emit(this.fieldState);
    }
    findAttribute(fullFieldName) {
        let qh = new DwQueryHelper();
        const itemMetaData = this.fieldState.itemMd;
        const parsedField = qh.fields.parseFullFieldName(fullFieldName);
        if (itemMetaData) {
            const attr = findWhere(itemMetaData.Attributes, { AttributeName: parsedField.FieldName });
            return attr;
        }
    }
    hasAttribute(attr) {
        const qh = new DwQueryHelper();
        for (let field of this.fieldState.selectedFields) {
            // parse field name
            const parsedField = qh.fields.parseFullFieldName(field.FullFieldName, this.fieldState.itemMd.UniqueItemName);
            if (parsedField.FieldName == attr.AttributeName) {
                return true;
            }
        }
        return false;
    }
}
DwQueryEditorFieldsComponent.ɵfac = function DwQueryEditorFieldsComponent_Factory(t) { return new (t || DwQueryEditorFieldsComponent)(); };
DwQueryEditorFieldsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorFieldsComponent, selectors: [["dw-query-editor-fields"]], inputs: { fieldState: "fieldState" }, outputs: { fieldStateChange: "fieldStateChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["dwRow", "", 4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], [1, "fields-list"], [1, "field-item", 3, "hidden"], [4, "ngIf"], ["header", "Add Fields"], ["class", "fields-list2", 4, "ngIf"], ["header", "Field Properties", 4, "ngIf"], [3, "hidden"], ["class", "field-item", 4, "ngFor", "ngForOf"], [1, "field-item"], ["title", "Remove Field", 1, "fa", "fa-times", "hand", "pull-right", 3, "click"], [3, "ngModel", "ngModelChange"], [1, "fields-list2"], ["addTooltip", "Add Field", 3, "attributes", "attributeClick"], ["header", "Field Properties"], ["header", "Basic Settings"], ["dwCol", "12"], ["type", "text", 1, "form-control"]], template: function DwQueryEditorFieldsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQueryEditorFieldsComponent_div_0_Template, 12, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldState);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc4.NgForOf, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwFieldSelectionComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab]; }, styles: [".max-width[_ngcontent-%COMP%]{max-width:800px}.fields-list2[_ngcontent-%COMP%]{height:516px;overflow:auto}.fields-list[_ngcontent-%COMP%]{border:1px solid #000;height:600px;overflow:auto;padding:1px;width:100%}.fields-list[_ngcontent-%COMP%]   .field-item[_ngcontent-%COMP%]{cursor:pointer;padding:5px;width:100%}.fields-list[_ngcontent-%COMP%]   .field-item-selected[_ngcontent-%COMP%]{background-color:#53a0e4;color:#fff}.fields-list[_ngcontent-%COMP%]   .field-item[_ngcontent-%COMP%]:hover{background-color:#eaeaea;color:#333}.pull-right[_ngcontent-%COMP%]{float:right}"] });
DwQueryEditorFieldsComponent.propDecorators = {
    fieldState: [{ type: Input }],
    fieldStateChange: [{ type: Output }]
};

class DwQueryEditorAddRelationComponent {
    constructor() {
        this.completeAddRelation = new EventEmitter();
        this.cancelAddRelation = new EventEmitter();
        this.showAddRelationChange = new EventEmitter();
    }
    okClick() {
        if (this.selectedRelation) {
            this.completeAddRelation.emit(this.selectedRelation);
            this.close();
        }
    }
    close() {
        this.showAddRelation = false;
        this.showAddRelationChange.emit();
    }
}
DwQueryEditorAddRelationComponent.ɵfac = function DwQueryEditorAddRelationComponent_Factory(t) { return new (t || DwQueryEditorAddRelationComponent)(); };
DwQueryEditorAddRelationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorAddRelationComponent, selectors: [["dw-query-editor-add-relation"]], inputs: { showAddRelation: "showAddRelation", itemMetaData: "itemMetaData" }, outputs: { completeAddRelation: "completeAddRelation", cancelAddRelation: "cancelAddRelation", showAddRelationChange: "showAddRelationChange" }, decls: 1, vars: 1, consts: [["class", "card", 4, "ngIf"], [1, "card"], [1, "card-body"], [1, "card-title"], [1, "card-text"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["placeholder", "Select Relation", "place", "", "optionLabel", "NamingInfo.RelationshipDisplayName", "filter", "true", "virtualScroll", "true", "itemSize", "30", "autoDisplayFirst", "false", 3, "options", "ngModel", "ngModelChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], [1, "btn", "btn-success", 3, "click"], [1, "btn", "btn-danger", 3, "click"]], template: function DwQueryEditorAddRelationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQueryEditorAddRelationComponent_div_0_Template, 17, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAddRelation && ctx.itemMetaData.Relations);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.PrimeTemplate, DwButtonBarComponent], encapsulation: 2 });
DwQueryEditorAddRelationComponent.propDecorators = {
    itemMetaData: [{ type: Input }],
    completeAddRelation: [{ type: Output }],
    cancelAddRelation: [{ type: Output }],
    showAddRelation: [{ type: Input }],
    showAddRelationChange: [{ type: Output }]
};

class DwjoinTypeList extends DwEnumListBase {
    constructor() {
        super();
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwJoinType[propertyName];
    }
    getKeys() {
        return Object.keys(DwJoinType);
    }
    getEnumDisplay(value) {
        switch (value) {
            case DwJoinType.InnerJoin:
                return "Inner Join";
            case DwJoinType.LeftOuterJoin:
                return "Left Outer Join";
            case DwJoinType.RightOuterJoin:
                return "Right Outer Join";
            case DwJoinType.FullOuterJoin:
                return "Full Outer Join";
            case DwJoinType.CrossJoin:
                return "Cross Join";
        }
        return null;
    }
}

class DwQueryRelationSettingsComponent {
    constructor(dwMetaDataService) {
        this.dwMetaDataService = dwMetaDataService;
        this.relationSettingState = {};
        this.relationSettingStateChange = new EventEmitter();
        this.joinTypesList = [];
        this.joinTypesList = new DwjoinTypeList().getEnumList();
    }
    ngOnInit() {
        this.setupRelationDesc();
    }
    ngOnChanges(changes) {
        //this.dwMetaDataService.getmetada
        if (changes.relation) {
            this.setupRelationDesc();
        }
    }
    setupRelationDesc() {
        if (!this.relation) {
            this.relationDesc = null;
            return;
        }
        this.relationDesc = `${this.relation.PkSchemaName}.${this.relation.PkUniqueItemName}.${this.relation.PkAttributeName} = ${this.relation.FkSchemaName}.${this.relation.FkUniqueItemName}.${this.relation.FkAttributeName}`;
    }
    relationStateChange() {
        this.relationSettingStateChange.emit(this.relationSettingState);
    }
}
DwQueryRelationSettingsComponent.ɵfac = function DwQueryRelationSettingsComponent_Factory(t) { return new (t || DwQueryRelationSettingsComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwQueryRelationSettingsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryRelationSettingsComponent, selectors: [["dw-query-relation-settings"]], inputs: { relationSettingState: "relationSettingState", relation: "relation" }, outputs: { relationSettingStateChange: "relationSettingStateChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [["dwRow", ""], ["class", "col-md-5", 4, "ngIf"], ["class", "col-md-7", 4, "ngIf"], [1, "col-md-5"], [1, "col-md-12"], [1, "label"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "col-md-7"], [1, "form-control"], [1, "form-control", 2, "height", "auto"]], template: function DwQueryRelationSettingsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwQueryRelationSettingsComponent_div_1_Template, 17, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwQueryRelationSettingsComponent_div_2_Template, 13, 2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relationSettingState);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relation);
    } }, directives: [DwRowDirective, ɵngcc4.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [_c73] });
DwQueryRelationSettingsComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwQueryRelationSettingsComponent.propDecorators = {
    relationSettingState: [{ type: Input }],
    relationSettingStateChange: [{ type: Output }],
    relation: [{ type: Input }]
};

class DwQueryEditorFiltersComponent {
    constructor(dwQueryFilterConverterService) {
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
        this.filterStateChange = new EventEmitter();
        this.ignoreChange = false;
    }
    ngOnInit() {
        if (this.filterState) {
            this.expressionGroup = this.dwQueryFilterConverterService.convertFilterToExpression(this.filterState.filters);
        }
    }
    ngOnChanges(changes) {
        if (changes.filterState && !changes.filterState.firstChange && this.filterState) {
            if (this.ignoreChange) {
                return;
            }
            this.expressionGroup = this.dwQueryFilterConverterService.convertFilterToExpression(this.filterState.filters);
        }
    }
    expressionGroupChange(expressionGroup) {
        //console.log("Expression group change", expressionGroup);
        const filters = this.dwQueryFilterConverterService.convertExpressionToFilter(expressionGroup, {});
        this.filterState.filters = filters;
        this.ignoreChange = true;
        this.filterStateChange.emit(this.filterState);
        setTimeout(() => {
            this.ignoreChange = false;
        });
    }
}
DwQueryEditorFiltersComponent.ɵfac = function DwQueryEditorFiltersComponent_Factory(t) { return new (t || DwQueryEditorFiltersComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryFilterConverterService)); };
DwQueryEditorFiltersComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorFiltersComponent, selectors: [["dw-query-editor-filters"]], inputs: { filterState: "filterState" }, outputs: { filterStateChange: "filterStateChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[3, "item", "ngModel", "ngModelChange"]], template: function DwQueryEditorFiltersComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-expression-group-control", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwQueryEditorFiltersComponent_Template_dw_expression_group_control_ngModelChange_0_listener($event) { return ctx.expressionGroup = $event; })("ngModelChange", function DwQueryEditorFiltersComponent_Template_dw_expression_group_control_ngModelChange_0_listener($event) { return ctx.expressionGroupChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("item", ctx.filterState == null ? null : ctx.filterState.item)("ngModel", ctx.expressionGroup);
    } }, directives: [DwExpressionGroupControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [""] });
DwQueryEditorFiltersComponent.ctorParameters = () => [
    { type: DwQueryFilterConverterService }
];
DwQueryEditorFiltersComponent.propDecorators = {
    filterState: [{ type: Input }],
    filterStateChange: [{ type: Output }]
};

var __decorate$14 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Q = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwQuerySectionComponent = class DwQuerySectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwContextService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwContextService = dwContextService;
        this.itemName = "";
        this.itemNameLoaded = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupFormFields();
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormFields() {
        let initialQueryValue = null;
        if (this.context.data && this.context.data.value) {
            initialQueryValue = this.context.data.value.Query;
        }
        this.formGroup.addControl('Query', new FormControl(initialQueryValue));
        this.mainMetaDataItemIdFc = this.formGroup.get("MetaDataItemId");
        this.formGroup.valueChanges
            .subscribe(value => {
            // console.log('DwQuery - Value changes', value);
        });
        this.mainMetaDataItemIdFc.valueChanges
            .subscribe(value => {
            this.setupMainItemData();
        });
    }
    handleItemChange(event) {
        // update the main item id
        this.mainMetaDataItemIdFc.setValue(event.metaDataItemId);
    }
    setupMainItemData() {
        let itemId = this.mainMetaDataItemIdFc.value;
        if (!itemId) {
            if (this.context.mdFormContext && this.context.mdFormContext.value.loadDataComplete) {
                this.itemNameLoaded = true;
            }
            return;
        }
        this.dwMetaDataService.getMetaDataItemName(itemId)
            .subscribe(itemName => {
            this.itemName = itemName;
            this.itemNameLoaded = true;
        });
    }
};
DwQuerySectionComponent.ɵfac = function DwQuerySectionComponent_Factory(t) { return new (t || DwQuerySectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwQuerySectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQuerySectionComponent, selectors: [["dw-query-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["formControlName", "Query", 3, "item", "itemChange"]], template: function DwQuerySectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQuerySectionComponent_div_0_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup && ctx.itemNameLoaded);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwQueryEditorContainerComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], styles: [""] });
DwQuerySectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];
DwQuerySectionComponent = __decorate$14([
    DwComponent({
        name: 'Query Editor',
        parentItemName: 'dw_MetaDataQuery',
        componentType: DwComponentType.formSection,
    }),
    __metadata$Q("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwContextService])
], DwQuerySectionComponent);

function DwUiConfigInitDecorator(info) {
    //console.log("DwUiConfigInitDecorator");
    return function (target, propertyKey, descriptor) {
        let func = target[propertyKey];
        const decoratorInfo = {
            name: info.name,
            target: target,
            propertyKey: propertyKey,
            useDI: info.useDI,
        };
        DwUiConfigRegistryService.addUiConfigInit(decoratorInfo);
    };
    /* return function (constructor: Function) {

    } */
}

class DwExpressionVisibilityConfigComponent extends DwChildConfigBaseComponent {
    constructor() {
        super();
        this.visibiltyTypes = new DwExprVisibilityTypeList().getEnumList();
    }
    getDefaultConfig() {
        return {
            visiblilityType: DwExprVisibilityType.none,
            expression: null
        };
    }
}
DwExpressionVisibilityConfigComponent.ɵfac = function DwExpressionVisibilityConfigComponent_Factory(t) { return new (t || DwExpressionVisibilityConfigComponent)(); };
DwExpressionVisibilityConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpressionVisibilityConfigComponent, selectors: [["dw-expression-visibility-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "values", "ngModelChange"], ["dwRow", "", 4, "ngIf"], [3, "ngModel", "queryMeaning", "contextNames", "item", "ngModelChange"]], template: function DwExpressionVisibilityConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwExpressionVisibilityConfigComponent_ng_container_0_Template, 8, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRowDirective, DwColDirective, DwRadioListComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwExpressionPickerControlComponent]; }, styles: [""] });
DwExpressionVisibilityConfigComponent.ctorParameters = () => [];

var DwButtonBarStyles;
(function (DwButtonBarStyles) {
    DwButtonBarStyles["default"] = "";
    DwButtonBarStyles["right"] = "button-bar-right";
    DwButtonBarStyles["basic"] = "button-bar-basic";
    DwButtonBarStyles["basicRight"] = "button-bar-basic-right";
    DwButtonBarStyles["stacked"] = "button-bar-stacked";
    DwButtonBarStyles["gridActionBarLeft"] = "grid-action-bar-left";
    DwButtonBarStyles["gridActionBarRight"] = "grid-action-bar-right";
    DwButtonBarStyles["gridActionRow"] = "grid-action-row";
    // gridActionRow = 'dw-grid-row-buttons'
})(DwButtonBarStyles || (DwButtonBarStyles = {}));

var __decorate$15 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$R = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwUiMetadataRegistrationService {
    constructor(uiConfigRegistyService, dwConfigService) {
        this.uiConfigRegistyService = uiConfigRegistyService;
        this.dwConfigService = dwConfigService;
        // this.setupRegistrations();
    }
    setupRegistrations() {
        this.setupContainerStyles();
        this.setupButtonContainerStyles();
        this.setupGridStyles();
        this.setupListStyles();
        this.registerComponents();
    }
    setupContainerStyles() {
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: '',
            display: 'Default',
            containerClass: 'dw-form-section-container2',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'dw-form-section-container-header'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'standard',
            display: 'Standard - no max width',
            containerClass: 'dw-form-section-container-no-width',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'dw-form-section-container-header'
        });
        // this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
        //   keyName: 'large',
        //   display: 'Large with max width',
        //   containerClass: 'dw-form-section-container-large',
        //   containerInnerClass: '',
        //   containerTitleClass: ''
        // });
        // this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
        //   keyName: 'medium',
        //   display: 'Medium',
        //   containerClass: 'dw-form-section-container-medium',
        //   containerInnerClass: '',
        //   containerTitleClass: ''
        // });
        // this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, <DwUiContainerStyleReference>{
        //   keyName: 'small',
        //   display: 'Small',
        //   containerClass: 'dw-form-section-container-small',
        //   containerInnerClass: '',
        //   containerTitleClass: ''
        // });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'Devware_Container',
            display: 'Devware Default',
            containerClass: 'dw-form-section-container2',
            containerInnerClass: 'dw-form-section-container-inner',
            containerTitleClass: 'dw-form-section-container-header'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'Devware_1200MaxWith',
            display: 'Devware 1200 Width only',
            containerClass: 'dw-form-section-container-widthOnly',
            containerInnerClass: '',
            containerTitleClass: ''
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'TITLE_ONLY',
            display: 'Title Only',
            containerTitleClass: 'dw-form-header-only'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'TITLE_ONLY_LINE',
            display: 'Title Only With Line',
            containerTitleClass: 'dw-form-header-with-line'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'TITLE_ONLY_SMALLER',
            display: 'Title Only (smaller)',
            containerTitleClass: 'dw-form-header-only-small'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'TITLE_WITH_INDENT',
            display: 'Title with Indent',
            containerClass: 'dw-form-indent-section',
            containerInnerClass: 'dw-form-indent-section-inner',
            containerTitleClass: 'dw-form-indent-section-header'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.containerStyles, {
            keyName: 'none',
            display: 'None - use for overriding',
            containerClass: '',
            containerInnerClass: '',
            containerTitleClass: ''
        });
    }
    setupListStyles() {
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, {
            keyName: '',
            display: 'Default List style',
            containerClass: 'dw-section-container',
            containerHeaderClass: 'dw-section-container-header',
            filterContainerClass: 'dw-section-container-filter',
            filterHeaderClass: 'dw-section-container-filter-header',
            filterBodyClass: 'dw-section-container-filter-body',
            filterButtonContainer: 'pull-right',
            actionBarClass: 'dw-section-container-action-bar',
            bodyClass: 'dw-section-container-inner',
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.listStyles, {
            keyName: 'listSimple',
            display: 'Simple List',
            containerClass: 'dw-list-simple-container',
            containerHeaderClass: 'dw-section-container-header',
            filterContainerClass: 'dw-section-container-filter',
            filterHeaderClass: 'dw-section-container-filter-header',
            filterBodyClass: 'dw-section-container-filter-body',
            filterButtonContainer: 'pull-left',
            actionBarClass: 'dw-section-container-action-bar',
            bodyClass: 'dw-section-container-inner',
        });
    }
    setupGridStyles() {
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, {
            keyName: '',
            display: 'Default',
            containerClass: 'dw-grid-container',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
            actionBarContainerClass: 'dw-grid-action-bar-container',
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, {
            keyName: 'default-large',
            display: 'Default - large',
            containerClass: 'dw-grid-container dw-grid-font-large',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
            actionBarContainerClass: 'dw-grid-action-bar-container',
            rowHeight: 35,
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, {
            keyName: 'Simple',
            display: 'Simple',
            containerClass: 'dw-grid-container-simple',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
            actionBarContainerClass: 'dw-grid-action-bar-container',
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.gridStyles, {
            keyName: 'Simple-Large',
            display: 'Simple Large',
            containerClass: 'dw-grid-container-simple dw-grid-font-large',
            filterHeaderClass: 'dw-grid-filter-header',
            filterBodyClass: 'dw-grid-filter-body',
            actionBarClass: 'dw-grid-action-bar',
            actionBarContainerClass: 'dw-grid-action-bar-container',
            rowHeight: 35,
        });
    }
    setupButtonContainerStyles() {
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.default,
            display: 'Button Bar (Default)',
            containerClass: 'dw-button-bar-container',
            containerInnerClass: 'pull-left'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.right,
            display: 'Button Bar - Right',
            containerClass: 'dw-button-bar-container',
            containerInnerClass: 'pull-right'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.basic,
            display: 'Button Bar - Basic',
            containerClass: 'dw-button-bar-basic',
            containerInnerClass: ''
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.basicRight,
            display: 'Button Bar - Basic Right',
            containerClass: 'dw-button-bar-basic',
            containerInnerClass: 'pull-right'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.stacked,
            display: 'Stacked Buttons',
            containerClass: 'dw-button-bar-verticle',
            containerInnerClass: ''
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.gridActionBarLeft,
            display: 'Grid Action Bar Left',
            containerClass: 'dw-grid-action-bar-preview-container',
            containerInnerClass: 'dw-grid-action-bar-preview-left'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.gridActionBarRight,
            display: 'Grid Action Bar Right',
            containerClass: 'dw-grid-action-bar-preview-container',
            containerInnerClass: 'dw-grid-action-bar-preview-right'
        });
        this.uiConfigRegistyService.registerItem(DwUiRegistryType.buttonContainerStyles, {
            keyName: DwButtonBarStyles.gridActionRow,
            display: 'Grid Action Row',
            containerClass: 'dw-grid-action-row-preview-container',
            containerInnerClass: 'dw-grid-row-buttons'
        });
    }
    registerComponents() {
        let dwMd = new DevwareMetaDataService();
        this.uiConfigRegistyService.registerComponent({
            key: 'E-mail Template Config',
            name: 'E-mail Template Config',
            component: DwEmailTemplateConfigComponent,
            componentType: DwComponentType.formSection,
            parentItemName: dwMd.DwEmailTemplate.ItemDetail.ItemName,
        });
        this.uiConfigRegistyService.registerComponent({
            key: 'Rule Config Config',
            name: 'Rule Config',
            component: DwRuleConfigComponent,
            componentType: DwComponentType.formSection,
            parentItemName: dwMd.DwRuleDefinition.ItemDetail.ItemName,
        });
        this.uiConfigRegistyService.registerComponent({
            key: 'E-mail Template Fields',
            name: 'E-mail Template Fields',
            component: DwEmailTemplateFieldsComponent,
            componentType: DwComponentType.formSection,
            parentItemName: dwMd.DwEmailTemplate.ItemDetail.ItemName,
        });
        var uiConfig = this.dwConfigService.getConfig(DwUiConfigName, new DwUIConfigDefaults());
        uiConfig.expressionVisibilityConfigComponent = DwExpressionVisibilityConfigComponent;
    }
}
DwUiMetadataRegistrationService.ɵfac = function DwUiMetadataRegistrationService_Factory(t) { return new (t || DwUiMetadataRegistrationService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwConfigServiceToken)); };
DwUiMetadataRegistrationService.ɵprov = ɵɵdefineInjectable({ factory: function DwUiMetadataRegistrationService_Factory() { return new DwUiMetadataRegistrationService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwConfigServiceToken)); }, token: DwUiMetadataRegistrationService, providedIn: "root" });
DwUiMetadataRegistrationService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];
__decorate$15([
    DwUiConfigInitDecorator({
        name: 'DwUiMetadataRegistrationService',
        useDI: true,
    }),
    __metadata$R("design:type", Function),
    __metadata$R("design:paramtypes", []),
    __metadata$R("design:returntype", void 0)
], DwUiMetadataRegistrationService.prototype, "setupRegistrations", null);

class DwQueryEditorSortComponent {
    constructor() {
        this.sortStateChange = new EventEmitter();
        this.availableFields = [];
    }
    ngOnInit() {
        if (this.sortState && !this.sortState.order) {
            this.sortState.order = [];
        }
        this.buildAvailableFields();
    }
    buildAvailableFields() {
        for (const attr of this.sortState.itemMd.Attributes) {
            this.availableFields.push({
                sortDisplay: attr.Display,
                fullFieldName: this.sortState.itemMd.UniqueItemName + '.' + attr.AttributeName
            });
        }
    }
    addSort() {
        const orderItem = {
            Field: { FullFieldName: '' },
            IsAscending: true
        };
        this.sortState.order.push(orderItem);
        this.sortChanged();
    }
    removeSort(sortItem) {
        const index = this.sortState.order.indexOf(sortItem);
        this.sortState.order.splice(index, 1);
        this.sortChanged();
    }
    sortChanged() {
        this.sortStateChange.emit(this.sortState);
    }
}
DwQueryEditorSortComponent.ɵfac = function DwQueryEditorSortComponent_Factory(t) { return new (t || DwQueryEditorSortComponent)(); };
DwQueryEditorSortComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorSortComponent, selectors: [["dw-query-editor-sort"]], inputs: { sortState: "sortState" }, outputs: { sortStateChange: "sortStateChange" }, decls: 3, vars: 1, consts: [["class", "row", 4, "ngFor", "ngForOf"], [1, "btn", "btn-success", 3, "click"], [1, "row"], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "2"], [3, "ngModel", "ngModelChange"], ["dwCol", "1"], ["title", "removeSort()", 1, "fa", "fa-times", 3, "click"], [3, "ngValue"]], template: function DwQueryEditorSortComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQueryEditorSortComponent_div_0_Template, 14, 3, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function DwQueryEditorSortComponent_Template_button_click_1_listener() { return ctx.addSort(); });
        ɵngcc0.ɵɵtext(2, "Add Sort");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sortState.order);
    } }, directives: [ɵngcc4.NgForOf, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
DwQueryEditorSortComponent.ctorParameters = () => [];
DwQueryEditorSortComponent.propDecorators = {
    sortState: [{ type: Input }],
    sortStateChange: [{ type: Output }]
};

var DwMdEventTriggerType;
(function (DwMdEventTriggerType) {
    DwMdEventTriggerType["attrChange"] = "attrChange";
    DwMdEventTriggerType["attrChangeFrom"] = "attrChangeFrom";
    DwMdEventTriggerType["attrChangeTo"] = "attrChangeTo";
    DwMdEventTriggerType["attrChangeFromTo"] = "attrChangeFromTo";
    DwMdEventTriggerType["created"] = "created";
    DwMdEventTriggerType["updated"] = "updated";
    DwMdEventTriggerType["deleted"] = "deleted";
    DwMdEventTriggerType["load"] = "load";
    DwMdEventTriggerType["query"] = "query";
})(DwMdEventTriggerType || (DwMdEventTriggerType = {}));
class DwEventTriggerTypeList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwMdEventTriggerType[propertyName];
    }
    getKeys() {
        return Object.keys(DwMdEventTriggerType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwMdEventTriggerType.attrChange:
                return 'Field Update';
            case DwMdEventTriggerType.attrChangeFrom:
                return 'Field Update - From';
            case DwMdEventTriggerType.attrChangeTo:
                return 'Field Update - To';
            case DwMdEventTriggerType.attrChangeFromTo:
                return 'Field Update - From/To';
            case DwMdEventTriggerType.created:
                return 'On Creation';
            case DwMdEventTriggerType.updated:
                return 'On Update';
            case DwMdEventTriggerType.deleted:
                return 'On Delete';
            case DwMdEventTriggerType.load:
                return 'On Load';
            case DwMdEventTriggerType.query:
                return 'On Query';
        }
    }
}

const DwMdEventHandlerItemType = 'DwMdEventHandlerItemType';

var __decorate$16 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$S = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEventConfigComponent = class DwEventConfigComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionService = dwExpressionService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.eventConfig = {};
        this.eventHandlers = [];
    }
    ngOnInit() {
        super.ngOnInit();
        // Wait until data is loaded before loading
        this.context.mdFormContext.subscribe((result) => {
            if (result.loadDataComplete) {
                this.setupFormField();
            }
        });
        this.setupEventHandlers();
        this.itemLookupId = DevwareMetaDataLookups.MetaDataDatabaseAllItems;
        this.emailTriggerTypes = new DwEventTriggerTypeList().getEnumList();
    }
    changeComponent() {
        const component = this.eventHandlers.find(cl => cl.keyName === this.eventHandlerKeyNameControl.value);
        this.configComponent = null;
        if (component) {
            this.configComponent = component.configComponent;
        }
    }
    setupConfigComponent(componentInstance) {
        this.componentInstance = componentInstance;
        this.componentInstance.configFormGroup = this.additionalConfigFormGroup;
        const origValue = this.additionalConfigControl.value;
        this.componentInstance.createForm();
        if (origValue) {
            this.additionalConfigFormGroup.patchValue(origValue);
        }
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormField() {
        this.eventConfigFormGroup = new FormGroup({});
        this.eventHandlerKeyNameControl = new FormControl();
        this.eventConfigFormGroup.addControl("eventHandlerKeyName", this.eventHandlerKeyNameControl);
        this.additionalConfigControl = new FormControl();
        this.eventConfigFormGroup.addControl("additionalConfig", this.additionalConfigControl);
        this.additionalConfigFormGroup = new FormGroup({});
        this.formGroup.addControl("EventConfigJson", this.eventConfigFormGroup);
        this.eventHandlerKeyNameControl.valueChanges.subscribe((value) => {
            this.changeComponent();
        });
        this.additionalConfigFormGroup.valueChanges.subscribe(value => {
            //console.log("additionalConfigFormGroup value", value);
            if (value) {
                this.additionalConfigControl.setValue(value);
            }
        });
        this.mainItemFc = this.formGroup.get("MainMetaDataItemId");
        this.changeComponent();
        if (this.context && this.context.data) {
            const event = this.context.data.value;
            if (event) {
                this.setupConfig(event);
            }
            else {
                this.context.data.subscribe((event) => {
                    this.setupConfig(event);
                });
            }
        }
        if (this.mainItemFc) {
            this.mainItemFc.valueChanges
                .subscribe((value) => {
                this.setupItemMetaData();
            });
        }
    }
    setupConfig(event) {
        if (this.configSetup) {
            return;
        }
        this.configSetup = true;
        this.eventConfig = event.EventConfigJson || {};
        this.eventConfigFormGroup.patchValue(this.eventConfig);
        // Set the value for the additional form group
        if (this.eventConfig.additionalConfig) {
            this.additionalConfigControl.patchValue(this.eventConfig.additionalConfig);
        }
        this.setupItemMetaData();
    }
    setupItemMetaData() {
        if (!this.mainItemFc || !this.mainItemFc.value) {
            this.itemMetaData = null;
            return;
        }
        const ob = this.dwMetaDataService.getMetaDataItemName(this.mainItemFc.value)
            .pipe(flatMap((itemName) => {
            return this.dwMetaDataService.getMetaData(itemName);
        }));
        ob.subscribe((itemMetaData) => {
            this.itemMetaData = itemMetaData;
            this.setupEventHandlers();
        });
    }
    setupEventHandlers() {
        this.eventHandlers = this.dwUiConfigRegistryService.getRegisteredItems(DwMdEventHandlerItemType)
            .map(i => i)
            .filter(i => !i.parentItemName ||
            (this.itemMetaData && this.itemMetaData.UniqueItemName === i.parentItemName));
    }
};
DwEventConfigComponent.ɵfac = function DwEventConfigComponent_Factory(t) { return new (t || DwEventConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwEventConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEventConfigComponent, selectors: [["dw-event-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], [3, "formGroup", "itemMetaData", "eventConfig"], ["dwCol", "6"], ["formControlName", "eventHandlerKeyName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], [3, "ngValue"], [3, "component", "configure"]], template: function DwEventConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwEventConfigComponent_ng_container_0_Template, 15, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup && ctx.eventConfigFormGroup);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, DwEventTriggerComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDynamicLoaderComponent]; }, encapsulation: 2 });
DwEventConfigComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwEventConfigComponent = __decorate$16([
    DwComponent({
        name: 'Event Config',
        componentType: DwComponentType.formSection,
        parentItemName: 'dw_MetaDataEvent',
    }),
    __metadata$S("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService])
], DwEventConfigComponent);

class DwEventTriggerComponent {
    constructor() {
        this.fieldName = "triggers";
        this.attrValueOldFieldDef = [];
        this.attrValueNewFieldDef = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.triggerTypes = new DwEventTriggerTypeList().getEnumList();
        this.setupAvailableTriggerTypes();
        this.formArray = this.formGroup.get(this.fieldName);
        if (!this.formArray) {
            this.formArray = new FormArray([]);
            this.formGroup.addControl(this.fieldName, this.formArray);
        }
        this.attributesLookupId = DevwareMetaDataLookups.AttributeByMetaDataItem;
        this.setupTriggers();
    }
    ngOnChanges(changes) {
        if (changes.eventConfig && !changes.eventConfig.firstChange) {
            this.setupTriggers();
        }
        if (changes.itemMetaData && !changes.itemMetaData.firstChange) {
            this.setupAvailableTriggerTypes();
            this.setupTriggers(false);
        }
    }
    setupTriggers(addItems = true) {
        if (this.eventConfig) {
            const triggers = this.eventConfig[this.fieldName];
            if (triggers) {
                for (let trigger of triggers) {
                    if (addItems) {
                        this.addItem();
                    }
                    const index = triggers.indexOf(trigger);
                }
                this.formArray.patchValue(triggers);
                this.setupAttrChangeSubscriptions();
            }
        }
    }
    setupAttrFields(attrName, index) {
        var _a;
        if (!attrName || !this.itemMetaData) {
            return;
        }
        const attr = findWhere(this.itemMetaData.Attributes, { AttributeName: attrName });
        if (!attr) {
            this.attrValueOldFieldDef[index] = null;
            this.attrValueNewFieldDef[index] = null;
            return;
        }
        const fieldDef = {
            itemName: (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.UniqueItemName,
            attr: attr,
            attrName: "attrValueOld",
            label: '',
            controlType: attr.MetaDataControlTypeId,
            hideLabel: true,
            formGroupKey: '',
        };
        if (fieldDef.controlType == DwControlType.TextArea || fieldDef.controlType == DwControlType.HTMLEditor) {
            fieldDef.controlType = DwControlType.Textbox;
        }
        this.attrValueOldFieldDef[index] = fieldDef;
        this.attrValueNewFieldDef[index] = Object.assign({}, fieldDef);
        this.attrValueNewFieldDef[index].attrName = "attrValueNew";
    }
    showAttributeField(index) {
        const triggerType = this.getTriggerType(index);
        switch (triggerType) {
            case DwMdEventTriggerType.attrChange:
            case DwMdEventTriggerType.attrChangeTo:
            case DwMdEventTriggerType.attrChangeFrom:
            case DwMdEventTriggerType.attrChangeFromTo:
                return true;
        }
        return false;
    }
    showOldField(index) {
        const triggerType = this.getTriggerType(index);
        var fromField = this.attrValueOldFieldDef[index];
        switch (triggerType) {
            case DwMdEventTriggerType.attrChange:
            case DwMdEventTriggerType.attrChangeTo:
                return false;
            case DwMdEventTriggerType.attrChangeFrom:
            case DwMdEventTriggerType.attrChangeFromTo:
                return !!fromField;
        }
        return false;
    }
    setupAvailableTriggerTypes() {
        this.availableTriggerTypes = [];
        for (const triggerType of this.triggerTypes) {
            let add = false;
            switch (triggerType.value) {
                case DwMdEventTriggerType.created:
                case DwMdEventTriggerType.updated:
                case DwMdEventTriggerType.deleted:
                    add = true;
                    break;
                default:
                    if (this.itemMetaData) {
                        add = true;
                    }
            }
            if (add) {
                this.availableTriggerTypes.push(triggerType);
            }
        }
    }
    showNewField(index) {
        const triggerType = this.getTriggerType(index);
        var toField = this.attrValueNewFieldDef[index];
        switch (triggerType) {
            case DwMdEventTriggerType.attrChange:
            case DwMdEventTriggerType.attrChangeFrom:
                return false;
            case DwMdEventTriggerType.attrChangeTo:
            case DwMdEventTriggerType.attrChangeFromTo:
                return !!toField;
        }
        return false;
    }
    getTriggerType(index) {
        if (!this.formArray) {
            return null;
        }
        const formGroup = this.formArray.controls[index];
        if (formGroup) {
            const receiverTypeFC = formGroup.get("eventTriggerType");
            if (receiverTypeFC) {
                return receiverTypeFC.value;
            }
        }
        return null;
    }
    addItem(afterInit = false) {
        let newFormGroup = new FormGroup({});
        newFormGroup.addControl("eventTriggerType", new FormControl(DwMdEventTriggerType.created));
        const attrNameFC = new FormControl();
        newFormGroup.addControl("attrName", attrNameFC);
        newFormGroup.addControl("attrValueOld", new FormControl());
        newFormGroup.addControl("attrValueNew", new FormControl());
        this.formArray.push(newFormGroup);
        if (afterInit) {
            this.setupAttrChangeSubscriptions();
        }
        return newFormGroup;
    }
    clearSubscriptions() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setupAttrChangeSubscriptions() {
        this.clearSubscriptions();
        for (let index = 0; index < this.formArray.length; index++) {
            const formGroup = this.formArray.controls[index];
            let attrNameFC = formGroup.get("attrName");
            if (attrNameFC.value) {
                this.setupAttrFields(attrNameFC.value, index);
            }
            this.subscriptions.push(attrNameFC.valueChanges
                .subscribe(value => {
                this.setupAttrFields(value, index);
            }));
        }
    }
    removeItem(index) {
        this.formArray.removeAt(index);
        this.setupAttrChangeSubscriptions();
    }
}
DwEventTriggerComponent.ɵfac = function DwEventTriggerComponent_Factory(t) { return new (t || DwEventTriggerComponent)(); };
DwEventTriggerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEventTriggerComponent, selectors: [["dw-event-trigger-config"]], inputs: { fieldName: "fieldName", formGroup: "formGroup", eventConfig: "eventConfig", itemMetaData: "itemMetaData" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "formGroup"], [3, "formArrayName", 4, "ngIf"], [3, "formArrayName"], [4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "btn", "btn-success", 3, "click"], [1, "fa", "fa-plus"], ["dwRow", "", 3, "formGroup"], ["dwCol", "0"], ["title", "Remove Link", 1, "btn", "btn-sm", "btn-danger", "hide-mobile", 3, "click"], [1, "fa", "fa-times", "hand"], ["dwCol", "3"], [1, "label"], ["formControlName", "eventTriggerType", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "2", 4, "ngIf"], [3, "ngValue"], ["dwCol", "2"], ["formControlName", "attrName", 1, "form-control"], ["dwDynamicField", "", 3, "fieldDef", "formGroup"]], template: function DwEventTriggerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwEventTriggerComponent_div_1_Template, 6, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formArray);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, ɵngcc3.FormArrayName, ɵngcc4.NgForOf, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDynamicFieldComponent], encapsulation: 2 });
DwEventTriggerComponent.ctorParameters = () => [];
DwEventTriggerComponent.propDecorators = {
    formGroup: [{ type: Input }],
    fieldName: [{ type: Input }],
    eventConfig: [{ type: Input }],
    itemMetaData: [{ type: Input }]
};

class DwMdEventRepositoryService {
    constructor(dwOrmDataService, cacheService) {
        this.dwOrmDataService = dwOrmDataService;
        this.cacheService = cacheService;
    }
    /**
     * Loads all Meta Data Events
     */
    getMetaDataEvents() {
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DevwareMetaDataItemNames.DwMetaDataEvent);
        return this.cacheService.get("metaDataEvents", this.loadMetaDataEvents(), null, cacheInvalidationTopics);
    }
    loadMetaDataEvents() {
        const md = new DevwareMetaDataService();
        const query = md.DwMetaDataEvent.CreateQuery()
            .AddPrefetchPath(md.DwMetaDataEvent.Relations.DwMetaDataItemByMainMetaDataItemId);
        return this.dwOrmDataService.executeQuery(query);
    }
}
DwMdEventRepositoryService.ɵfac = function DwMdEventRepositoryService_Factory(t) { return new (t || DwMdEventRepositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwCacheService)); };
DwMdEventRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwMdEventRepositoryService_Factory() { return new DwMdEventRepositoryService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwCacheService)); }, token: DwMdEventRepositoryService, providedIn: "root" });
DwMdEventRepositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwCacheService }
];

class DwMdEventHandlerOrchestratorService {
    constructor(dwMdEventService, eventRepositoryService, configRegistryService, injector) {
        this.dwMdEventService = dwMdEventService;
        this.eventRepositoryService = eventRepositoryService;
        this.configRegistryService = configRegistryService;
        this.injector = injector;
        this.subscriptions = [];
        setTimeout(() => {
            this.setupEventListener();
        }, 500);
    }
    setupEventListener() {
        this.dwMdEventService.getAllEvents()
            .subscribe((eventData) => {
            this.handleEvent(eventData);
        });
    }
    handleEvent(eventData) {
        // console.log(`Event Handler orchestrator : Event ${eventData.eventType} for ${eventData.itemName}`, eventData);
        const subscription = this.eventRepositoryService.getMetaDataEvents()
            .subscribe(events => {
            for (var event of events) {
                if (this.isEventMatch(event, eventData)) {
                    this.callEventHandler(event, eventData);
                }
            }
        });
    }
    callEventHandler(event, eventData) {
        const eventConfig = event.EventConfigJson;
        const eventHandler = this.createEventHandler(event, eventConfig);
        if (!eventHandler) {
            return;
        }
        eventHandler.handleEvent(event, eventData, eventConfig);
    }
    createEventHandler(event, eventConfig) {
        if (!eventConfig || !eventConfig.eventHandlerKeyName) {
            console.warn(`Event does not have an event handler configured.  Please edit the event and add a handler for event ${event.EventName}`);
            return null;
        }
        const eventRegistration = this.configRegistryService.getRegisteredItem(DwMdEventHandlerItemType, eventConfig.eventHandlerKeyName);
        if (!eventRegistration) {
            console.warn(`Event handler not registered for event ${event.EventName} and registration key ${eventConfig.eventHandlerKeyName}`);
            return null;
        }
        let eventHandler;
        if (eventRegistration.useDI) {
            eventHandler = this.injector.get(eventRegistration.handlerClass);
        }
        else {
            console.error(`Event handler must use DI for event ${event.EventName} and registration key ${eventRegistration.keyName}`);
            return null;
        }
        if (!eventHandler || !eventHandler.handleEvent) {
            console.warn(`Event handler is invalid for event ${event.EventName} and registration key ${eventRegistration.keyName}.  Class must implement the interface DwMdEventHandlerService`);
            return null;
        }
        return eventHandler;
    }
    isEventMatch(event, eventData) {
        // Exclude events for other items
        if (event.MainDwMetaDataItem && event.MainDwMetaDataItem.UniqueItemName.toUpperCase() !== eventData.itemName.toUpperCase()) {
            return false;
        }
        const eventConfig = event.EventConfigJson;
        // Exclude events without triggers
        if (!eventConfig || !eventConfig.triggers) {
            return false;
        }
        for (const trigger of eventConfig.triggers) {
            if (this.isEventTriggerMatch(trigger, eventData)) {
                return true;
            }
        }
        return false;
    }
    isEventTriggerMatch(trigger, eventData) {
        switch (trigger.eventTriggerType) {
            case DwMdEventTriggerType.created:
                return eventData.eventType === DwMdEventType.create;
            case DwMdEventTriggerType.deleted:
                return eventData.eventType === DwMdEventType.delete;
            case DwMdEventTriggerType.updated:
                return eventData.eventType === DwMdEventType.update;
        }
        return false;
    }
}
DwMdEventHandlerOrchestratorService.ɵfac = function DwMdEventHandlerOrchestratorService_Factory(t) { return new (t || DwMdEventHandlerOrchestratorService)(ɵngcc0.ɵɵinject(DwMdEventService), ɵngcc0.ɵɵinject(DwMdEventRepositoryService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwMdEventHandlerOrchestratorService.ɵprov = ɵɵdefineInjectable({ factory: function DwMdEventHandlerOrchestratorService_Factory() { return new DwMdEventHandlerOrchestratorService(ɵɵinject(DwMdEventService), ɵɵinject(DwMdEventRepositoryService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(INJECTOR)); }, token: DwMdEventHandlerOrchestratorService, providedIn: "root" });
DwMdEventHandlerOrchestratorService.ctorParameters = () => [
    { type: DwMdEventService },
    { type: DwMdEventRepositoryService },
    { type: DwUiConfigRegistryService },
    { type: Injector }
];

class DwMdSectionTextConfigComponent extends DwMdSectionConfigBaseComponent {
    ngOnInit() {
        this.setupFieldSources();
        this.setupFieldSourcesNew();
    }
    sectionChanged() {
        let itemName = this.getParentItemName();
        this.getItemMetaData(itemName)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
            this.setupFieldSources();
            this.buildAvailableAttrs();
        });
    }
    setDwGridEditApi(api) {
        this.dwHtmlEditApi = api;
    }
    setupFieldSources() {
        if (!this.itemMetaData) {
            return;
        }
        this.dwMetaDataService.getSavedQueryMetaData(this.itemMetaData.UniqueItemName)
            .subscribe(queryMetaData => {
            this.fieldSources = [
                { display: this.itemMetaData.Display, rootTable: true, attributes: queryMetaData.Attributes }
            ];
            this.dwContextService.getContextMetaDataList(this.contextNames)
                .subscribe(contextMdList => {
                for (const contextName of this.contextNames) {
                    const contextDef = this.dwContextService.getContextDef(contextName);
                    if (contextDef) {
                        const contextDefMetaData = contextMdList[contextName];
                        let attributes = contextDefMetaData.attributes;
                        if (contextDefMetaData) {
                            attributes = contextDefMetaData.attributes;
                        }
                        this.fieldSources.push({
                            display: contextDef.contextDisplay,
                            rootTable: false,
                            contextDefinition: contextDef,
                            attributes: attributes
                        });
                    }
                }
            });
            this.setFieldSource(this.fieldSources[0]);
        });
    }
    setupFieldSourcesNew() {
        if (!this.itemMetaData) {
            return;
        }
        this.dwMetaDataService.getSavedQueryMetaData(this.itemMetaData.UniqueItemName)
            .subscribe(queryMetaData => {
            this.htmlEditFieldSources = [
                {
                    display: this.itemMetaData.Display,
                    fieldItems: this.convertAttrToFieldItem(queryMetaData.Attributes, "data")
                }
            ];
            this.dwContextService.getContextMetaDataList(this.contextNames)
                .subscribe(contextMdList => {
                var _a;
                for (const contextName of this.contextNames) {
                    const contextDef = this.dwContextService.getContextDef(contextName);
                    if (contextDef) {
                        const contextDefMetaData = contextMdList[contextName];
                        if (((_a = contextDefMetaData === null || contextDefMetaData === void 0 ? void 0 : contextDefMetaData.attributes) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            this.htmlEditFieldSources.push({ display: contextDef.contextDisplay,
                                fieldItems: this.convertAttrToFieldItem(contextDefMetaData.attributes, `context.${contextDef.contextName}`) });
                        }
                    }
                }
            });
        });
    }
    convertAttrToFieldItem(queryAttributes, codePrefix) {
        const fieldItems = [];
        for (let attr of queryAttributes) {
            fieldItems.push({ display: attr.AttributeDisplay, insertCode: `[${codePrefix}.${attr.AttributeName}]` });
            if (attr.DisplayAttributeName != attr.AttributeName) {
                fieldItems.push({ display: `${attr.AttributeDisplay} (Display)`, insertCode: `[${codePrefix}.${attr.DisplayAttributeName}]` });
            }
        }
        return fieldItems;
    }
    setFieldSource(fieldSource) {
        this.selectedFieldSource = fieldSource;
        this.buildAvailableAttrs();
    }
    buildAvailableAttrs() {
        if (!this.section || !this.itemMetaData || !this.selectedFieldSource) {
            return;
        }
        const attrs = [];
        this.availableAttributes = this.selectedFieldSource.attributes;
    }
    addItem(attr) {
        let code = `[data.${attr.AttributeName}]`;
        if (this.selectedFieldSource.contextDefinition) {
            code = `[context.${this.selectedFieldSource.contextDefinition.contextName}.${attr.AttributeName}]`;
        }
        if (this.dwHtmlEditApi) {
            this.dwHtmlEditApi.insertText(code);
            return;
        }
        this.section.htmlContent = this.section.htmlContent || '';
        this.section.htmlContent += code;
    }
}
DwMdSectionTextConfigComponent.ɵfac = function DwMdSectionTextConfigComponent_Factory(t) { return ɵDwMdSectionTextConfigComponent_BaseFactory(t || DwMdSectionTextConfigComponent); };
DwMdSectionTextConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionTextConfigComponent, selectors: [["dw-md-section-text-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 9, consts: [["header", "Text Configuration"], ["dwRow", ""], ["dwCol", "12"], [3, "ngModel", "fieldSources", "ngModelChange"], ["dwCol", "4"], ["type", "text", "placeholder", "None", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "showReadOnlySection", "sectionChange"]], template: function DwMdSectionTextConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-tabView");
        ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "dw-html-edit", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTextConfigComponent_Template_dw_html_edit_ngModelChange_4_listener($event) { return ctx.section.htmlContent = $event; })("ngModel", function DwMdSectionTextConfigComponent_Template_dw_html_edit_ngModel_4_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 1);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Blank Replacement Value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdSectionTextConfigComponent_Template_input_ngModelChange_9_listener($event) { return ctx.section.blankReplacementValue = $event; })("ngModel", function DwMdSectionTextConfigComponent_Template_input_ngModel_9_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p-tabPanel", 6);
        ɵngcc0.ɵɵelementStart(11, "div");
        ɵngcc0.ɵɵelementStart(12, "dw-md-section-standard-config", 7);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdSectionTextConfigComponent_Template_dw_md_section_standard_config_sectionChange_12_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdSectionTextConfigComponent_Template_dw_md_section_standard_config_sectionChange_12_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.htmlContent)("fieldSources", ctx.htmlEditFieldSources);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.blankReplacementValue);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName)("showReadOnlySection", false);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwHtmlEditComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, DwMdSectionStandardConfigComponent], styles: [""], encapsulation: 2 });

var __decorate$17 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$T = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwTextSectionComponent = class DwTextSectionComponent extends DwSectionBaseComponent {
    constructor(uiMetaDataConfig, dwExpressionService, dwUiConfigRegistryService, dwMetaDataService, dwMdFormUtilService, dwTemplateUtil, dwContextService, dwConfigService, dwMetaDataFormStateService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMdFormUtilService = dwMdFormUtilService;
        this.dwTemplateUtil = dwTemplateUtil;
        this.dwContextService = dwContextService;
        this.dwConfigService = dwConfigService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.contextSubscriptions = {};
    }
    contextChanged() {
        this.setupBody();
    }
    formConfigChanged() {
        this.setupBody();
    }
    setupBody() {
        if (!this.sectionConfig) {
            return;
        }
        this.itemName = this.dwMdFormUtilService.getParentItemName(this.formConfig.section, this.sectionConfig, this.formConfig.rootItemName);
        this.queryMetaData = this.formConfig.queryMetaDataList[this.itemName];
        this.template = this.dwTemplateUtil.parseTemplate(this.sectionConfig.htmlContent);
        this.htmlContent = this.replaceContent();
        this.cleanupSubscriptions();
        this.dataSubjectResult = this.dwMdFormUtilService.getDataSubject(this.sectionConfig, this.context, this.formGroup, this.formConfig.section, this.formConfig.queryMetaDataList);
        this.setupSubscriptions();
    }
    cleanupSubscriptions() {
        var _a;
        if ((_a = this.dataSubjectResult) === null || _a === void 0 ? void 0 : _a.subscription) {
            this.dataSubjectResult.subscription.unsubscribe();
            this.dataSubjectResult = null;
        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        // Cleanup all subscriptions
        for (let prop in this.contextSubscriptions) {
            if (this.contextSubscriptions.hasOwnProperty(prop)) {
                this.contextSubscriptions[prop].unsubscribe();
            }
        }
    }
    getDataContextValue() {
        // Use context data instead since the above only returns values for controls for child data areas
        let rootData = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME].value;
        // Gets all data for this section
        const sectionData = this.dwMdFormUtilService.getChildSectionData(this.sectionConfig, rootData, this.formGroup, this.formConfig.section, this.formConfig.queryMetaDataList);
        return sectionData;
    }
    setupSubscriptions() {
        const formContext = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        if (!(formContext === null || formContext === void 0 ? void 0 : formContext.value)) {
            return;
        }
        const missingContexts = [];
        for (let placeHolder of this.template.placeHolders) {
            let contextName = this.getContextName(placeHolder);
            if (!contextName) {
                continue;
            }
            const context = this.context[contextName];
            if (!context) {
                missingContexts.push(contextName);
                continue;
            }
            if (!this.contextSubscriptions[contextName]) {
                this.contextSubscriptions[contextName] = context.subscribe(value => {
                    this.htmlContent = this.replaceContent();
                });
            }
        }
        if (missingContexts.length > 0) {
            if (formContext.value.loadDataComplete) {
                console.warn(`Missing context names : ${missingContexts.join(',')}`);
                return;
            }
            if (!this.contextSubscriptions.formSubscription) {
                this.contextSubscriptions.formSubscription = formContext.subscribe(value => {
                    if (value.loadDataComplete) {
                        this.setupSubscriptions();
                    }
                });
            }
        }
    }
    getContextName(placeHolder) {
        switch (placeHolder.tagType) {
            case DwTagType.context:
                return placeHolder.path;
            case DwTagType.data:
                return DwMdFormContextInfo.DATA_CONTEXT_NAME;
        }
        return null;
    }
    replaceContent() {
        var _a;
        const options = { blankReplacementValue: ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.blankReplacementValue) || 'None' };
        // Map query meta data to options
        options.queryMetaData = this.queryMetaData;
        const dataContextValue = this.getDataContextValue();
        const resolvedContext = this.dwContextService.getResolvedContext(this.context);
        return this.dwTemplateUtil.processTemplate(this.template, dataContextValue, resolvedContext, this.dwConfigService.coreConfig.globals, options);
    }
};
DwTextSectionComponent.ɵfac = function DwTextSectionComponent_Factory(t) { return new (t || DwTextSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwTemplateUtilService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwTextSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTextSectionComponent, selectors: [["dw-text-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 5, consts: [["isHtml", "true", 3, "item", "queryMetaData", "templateText", "dataSubject", "context"]], template: function DwTextSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-template-view-control", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("item", ctx.itemName)("queryMetaData", ctx.queryMetaData)("templateText", ctx.sectionConfig.htmlContent)("dataSubject", ctx.dataSubjectResult == null ? null : ctx.dataSubjectResult.subject)("context", ctx.context);
    } }, directives: function () { return [DwTemplateViewControlComponent]; }, encapsulation: 2 });
DwTextSectionComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwTemplateUtilService },
    { type: DwContextService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwMetaDataFormStateService }
];
DwTextSectionComponent = __decorate$17([
    DwSectionComponent({
        keyName: DwSectionType.text,
        display: 'Rich Text',
        sectionIcon: 'fa fa-align-justify',
        configComponent: DwMdSectionTextConfigComponent,
        hasChildren: false,
    }),
    __metadata$T("design:paramtypes", [Object, DwExpressionService,
        DwUiConfigRegistryService,
        DwMetaDataService,
        DwMetadataFormUtilService,
        DwTemplateUtilService,
        DwContextService,
        DwConfigService,
        DwMetaDataFormStateService])
], DwTextSectionComponent);

class DwAutoCompleteLookupReadOnlyComponent extends DwAutoCompleteLookupComponent {
    constructor() {
        super(...arguments);
        this.missingDataText = 'None';
    }
}
DwAutoCompleteLookupReadOnlyComponent.ɵfac = function DwAutoCompleteLookupReadOnlyComponent_Factory(t) { return ɵDwAutoCompleteLookupReadOnlyComponent_BaseFactory(t || DwAutoCompleteLookupReadOnlyComponent); };
DwAutoCompleteLookupReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAutoCompleteLookupReadOnlyComponent, selectors: [["dw-autocomplete-readonly"]], inputs: { missingDataText: "missingDataText" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwAutoCompleteLookupReadOnlyComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[1, "read-only"]], template: function DwAutoCompleteLookupReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate((ctx.currentLookup == null ? null : ctx.currentLookup.Display) || ctx.missingDataText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, encapsulation: 2 });
DwAutoCompleteLookupReadOnlyComponent.propDecorators = {
    missingDataText: [{ type: Input }]
};

class DwLookupReadonlyComponent extends DwSelectLookupComponent {
    constructor() {
        super(...arguments);
        this.missingDataText = 'None';
    }
    setupLookup() {
        this.useTransitions = false;
        super.setupLookup();
    }
}
DwLookupReadonlyComponent.ɵfac = function DwLookupReadonlyComponent_Factory(t) { return ɵDwLookupReadonlyComponent_BaseFactory(t || DwLookupReadonlyComponent); };
DwLookupReadonlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLookupReadonlyComponent, selectors: [["dw-lookup-readonly"]], inputs: { missingDataText: "missingDataText" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwLookupReadonlyComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[1, "read-only"]], template: function DwLookupReadonlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate((ctx.currentLookup == null ? null : ctx.currentLookup.Display) || ctx.missingDataText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, encapsulation: 2 });
DwLookupReadonlyComponent.propDecorators = {
    missingDataText: [{ type: Input }]
};

class DwFormControlCalcFieldTesterComponent {
    constructor(dwMetaDataService, dwCalcService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwCalcService = dwCalcService;
        this.displayAttributes = [];
    }
    ngOnChanges(changes) {
        if (changes.options && !changes.options.firstChange) {
            this.buildValues();
        }
        if (changes.itemMd && !changes.options.firstChange) {
            this.loadMetaData();
        }
    }
    ngOnInit() {
        this.formGroup = new FormGroup({
            calcField: new FormControl(null)
        });
        this.loadMetaData();
    }
    loadMetaData() {
        if (!this.itemName) {
            return;
        }
        this.dwMetaDataService.getMetaData(this.itemName)
            .subscribe(itemMd => {
            this.itemMd = itemMd;
            this.buildValues();
        });
    }
    testFormula() {
    }
    buildValues() {
        if (!this.itemMd || !this.options || !this.formGroup) {
            return;
        }
        this.displayAttributes = [];
        for (var attr of this.itemMd.Attributes) {
            if (this.isInFormula(attr.AttributeName)) {
                this.displayAttributes.push(attr);
                let formControl = this.formGroup.get(attr.AttributeName);
                if (!formControl) {
                    formControl = new FormControl(null);
                    this.formGroup.addControl(attr.AttributeName, formControl);
                }
            }
        }
    }
    isInFormula(attributeName) {
        const formulaData = `data.${attributeName}`;
        if (this.options && this.options.formula.indexOf(formulaData) >= 0) {
            return true;
        }
        return false;
    }
}
DwFormControlCalcFieldTesterComponent.ɵfac = function DwFormControlCalcFieldTesterComponent_Factory(t) { return new (t || DwFormControlCalcFieldTesterComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwCalcService)); };
DwFormControlCalcFieldTesterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlCalcFieldTesterComponent, selectors: [["dw-fc-calc-tester"]], inputs: { options: "options", itemName: "itemName" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 16, vars: 4, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [3, "formGroup"], [4, "ngIf"], ["dwCol", "12"], ["formControlName", "calcField", 3, "options"], ["dwRow", "", 4, "ngFor", "ngForOf"], ["type", "text", 1, "form-control", 3, "formControlName"]], template: function DwFormControlCalcFieldTesterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "b");
        ɵngcc0.ɵɵtext(2, "Formula Tester");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 0);
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Show inputs");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelementStart(8, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormControlCalcFieldTesterComponent_Template_p_inputSwitch_ngModelChange_8_listener($event) { return ctx.showInputs = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 4);
        ɵngcc0.ɵɵtemplate(10, DwFormControlCalcFieldTesterComponent_ng_container_10_Template, 3, 1, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "div", 6);
        ɵngcc0.ɵɵelementStart(13, "label");
        ɵngcc0.ɵɵtext(14, "Calculated result");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(15, "dw-calc", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.showInputs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showInputs);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("options", ctx.options);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, DwCalcComponent, ɵngcc3.FormControlName, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor], encapsulation: 2 });
DwFormControlCalcFieldTesterComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwCalcService }
];
DwFormControlCalcFieldTesterComponent.propDecorators = {
    options: [{ type: Input }],
    itemName: [{ type: Input }]
};

var __decorate$18 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$U = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMultiSelectLookupComponent extends DwSearchSelectLookupComponent {
    constructor() {
        super(...arguments);
        this.showBlankOption = false;
        this.loadComplete = false;
        this.mapToArray = false;
        this.mapToNumber = false;
        this.classes = "";
        this.autoExpand = true;
    }
    ngOnInit() {
        this.showBlankOption = false;
        this.translatedValue = [];
        super.ngOnInit();
    }
    lookupLoadComplete() {
        super.lookupLoadComplete();
        //this.translatedValue = [...this.translatedValue];
        this.loadComplete = true;
        this.cdr.detectChanges();
    }
    translateTo(value) {
        if (value == null || value == undefined || value == '') {
            value = [];
        }
        if (Array.isArray(value)) {
            value = value.map(value => value ? value.toString() : '');
        }
        if (typeof (value) === 'string') {
            value = value.split(',');
        }
        if (!(value instanceof Array)) {
            value = [value.toString()];
        }
        return value;
    }
    translateFrom(value) {
        if (value instanceof Array) {
            if (this.mapToArray) {
                if (this.mapToNumber) {
                    return value.map(v => parseInt(v));
                }
                return value;
            }
            value = value.join(',');
        }
        return value;
    }
}
DwMultiSelectLookupComponent.ɵfac = function DwMultiSelectLookupComponent_Factory(t) { return ɵDwMultiSelectLookupComponent_BaseFactory(t || DwMultiSelectLookupComponent); };
DwMultiSelectLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiSelectLookupComponent, selectors: [["dw-multi-select-lookup"]], inputs: { mapToArray: "mapToArray", mapToNumber: "mapToNumber", autoExpand: "autoExpand" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwMultiSelectLookupComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["optionLabel", "Display", "display", "chip", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "group", "optionValue", "ngModel", "filter", "virtualScroll", "itemSize", "style", "ngClass", "ngModelChange", 4, "ngIf"], ["optionLabel", "Display", "display", "chip", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "group", "optionValue", "ngModel", "filter", "virtualScroll", "itemSize", "ngClass", "ngModelChange"]], template: function DwMultiSelectLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMultiSelectLookupComponent_p_multiSelect_0_Template, 1, 13, "p-multiSelect", 0);
        ɵngcc0.ɵɵtext(1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadComplete);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, directives: [ɵngcc4.NgIf, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgClass], encapsulation: 2 });
DwMultiSelectLookupComponent.propDecorators = {
    mapToArray: [{ type: Input }],
    mapToNumber: [{ type: Input }],
    autoExpand: [{ type: Input }]
};
__decorate$18([
    DwInputConverter(booleanConverter),
    __metadata$U("design:type", Boolean)
], DwMultiSelectLookupComponent.prototype, "mapToArray", void 0);
__decorate$18([
    DwInputConverter(booleanConverter),
    __metadata$U("design:type", Boolean)
], DwMultiSelectLookupComponent.prototype, "mapToNumber", void 0);
__decorate$18([
    DwInputConverter(booleanConverter),
    __metadata$U("design:type", Boolean)
], DwMultiSelectLookupComponent.prototype, "autoExpand", void 0);

var __decorate$19 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$V = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMetadataGridConfigColumnsComponent {
    constructor(dwMetaDataService, dwOrmDataService, dwMetaDataGridService, dwLoggingService, dwUiConfigRegistryService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataGridService = dwMetaDataGridService;
        this.dwLoggingService = dwLoggingService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.columnsChange = new EventEmitter();
        this.customColumnDefs = [];
        this.addInitialColumns = true;
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Column',
            displayField: 'columnDisplay',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Column',
            showListActionBar: true,
        };
        this.setupQueryMetaData();
        this.customColumnDefs = this.dwUiConfigRegistryService.getMdRegisteredItems(DwUiRegistryType.gridColumn, this.configContext.itemName, 
        // Only include column types that don't require an attribute
        item => !item.requireAttr);
    }
    ngOnChanges(changes) {
        if (changes.configContext && !changes.configContext.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.columns && !changes.columns.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.gridPreferences && !changes.gridPreferences.firstChange) {
            this.setupQueryMetaData();
        }
    }
    onColumnsChange() {
        this.setAllColumnDisplays();
        this.columnsChange.emit(this.columns);
    }
    setupQueryMetaData() {
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
            this.setupControl();
        });
    }
    setupControl() {
        if (!this.gridPreferences) {
            return;
        }
        this.setupInitialColumns();
        this.buildAvailableAttrs();
        this.selectedColumn = null;
    }
    setupInitialColumns() {
        this.columns = this.columns || [];
        if (this.columns.length == 0 && this.addInitialColumns) {
            this.columns = this.dwMetaDataGridService.buildDefaultColumnPreferences(this.queryMetaData, this.gridPreferences);
        }
    }
    setAllColumnDisplays() {
        for (const column of this.columns) {
            column.columnDisplay = this.getColumnDisplay(column);
        }
    }
    getColumnDisplay(field) {
        if (field.label)
            return field.label;
        if (this.queryMetaData) {
            let attr = this.queryMetaData.Attributes.find(a => a.AttributeName == field.field);
            if (attr) {
                return attr.AttributeDisplay;
            }
            attr = this.queryMetaData.Attributes.find(a => `${a.AttributeName}Display` == field.field);
            if (attr) {
                field.field = attr.AttributeName;
                return attr.AttributeDisplay;
            }
        }
        if (field.field == 'EditColumn') {
            return 'Edit Column';
        }
        return field.field;
    }
    removeAll() {
        this.columns = [];
        this.selectedColumn = null;
        this.addInitialColumns = false;
        this.buildAvailableAttrs();
        this.onColumnsChange();
    }
    buildAvailableAttrs() {
        this.setAllColumnDisplays();
        const attrs = [];
        for (let attr of this.queryMetaData.Attributes) {
            const found = this.columns.find(c => c.field == attr.AttributeName);
            if (!found) {
                attrs.push(attr);
            }
        }
        this.availableAttributes = attrs;
    }
    setSelectedColumn(column) {
        this.selectedColumn = column;
        this.selectedAttr = this.queryMetaData.Attributes.find(a => a.AttributeName == column.field);
        column.pinned = column.pinned || null;
    }
    reorderList() {
        let index = 2;
        for (const column of this.columns) {
            column.columnIndex = index;
            index++;
        }
        this.onColumnsChange();
    }
    addItem(attr) {
        const columnPref = {
            columnIndex: this.columns.length + 1,
            field: attr.AttributeName,
            hide: false,
        };
        columnPref.columnDisplay = this.getColumnDisplay(columnPref);
        this.columns = [...this.columns, columnPref];
        this.reorderList();
        this.buildAvailableAttrs();
    }
    addCustomColumn(customColumn) {
        const columnPref = {
            columnIndex: this.columns.length,
            columnRendererKey: customColumn.keyName,
            disabledSort: true,
            label: `${customColumn.display}`,
            hide: false,
        };
        columnPref.columnDisplay = this.getColumnDisplay(columnPref);
        this.columns = [...this.columns, columnPref];
        this.onColumnsChange();
        this.buildAvailableAttrs();
    }
    removeItem(item) {
        const index = this.columns.indexOf(item);
        if (this.selectedColumn) {
            if (this.columns.indexOf(this.selectedColumn) == index) {
                this.selectedColumn = null;
            }
        }
        if (index >= 0) {
            this.columns.splice(index, 1);
        }
        this.onColumnsChange();
        this.buildAvailableAttrs();
    }
}
DwMetadataGridConfigColumnsComponent.ɵfac = function DwMetadataGridConfigColumnsComponent_Factory(t) { return new (t || DwMetadataGridConfigColumnsComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridService), ɵngcc0.ɵɵdirectiveInject(DwLoggingService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwMetadataGridConfigColumnsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataGridConfigColumnsComponent, selectors: [["dw-metadata-grid-config-columns"]], inputs: { columns: "columns", configContext: "configContext", gridPreferences: "gridPreferences", useColumnFlex: "useColumnFlex", inlineEditEnabled: "inlineEditEnabled" }, outputs: { columnsChange: "columnsChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 14, vars: 12, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], ["header", "Field Columns", 3, "selected"], [3, "hidden"], ["addTooltip", "Add Field", 3, "attributes", "attributeClick"], ["header", "Other Columns"], ["class", "dw-field-item", 4, "ngFor", "ngForOf"], ["actionBar", ""], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], [3, "useColumnFlex", "columnPreference", "attribute", "configContext", "queryMetaData", "columnPreferenceChange"], [1, "dw-field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add Column", 1, "fa", "fa-plus-circle", "hand"]], template: function DwMetadataGridConfigColumnsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 0);
        ɵngcc0.ɵɵlistener("selectedItemChange", function DwMetadataGridConfigColumnsComponent_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { return ctx.setSelectedColumn($event); })("removeItem", function DwMetadataGridConfigColumnsComponent_Template_dw_ui_config_list_removeItem_0_listener($event) { return ctx.removeItem($event); })("reorder", function DwMetadataGridConfigColumnsComponent_Template_dw_ui_config_list_reorder_0_listener() { return ctx.reorderList(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p-accordion");
        ɵngcc0.ɵɵelementStart(3, "p-accordionTab", 2);
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5, " All fields have been added! ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "dw-field-selection", 4);
        ɵngcc0.ɵɵlistener("attributeClick", function DwMetadataGridConfigColumnsComponent_Template_dw_field_selection_attributeClick_6_listener($event) { return ctx.addItem($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "p-accordionTab", 5);
        ɵngcc0.ɵɵtemplate(8, DwMetadataGridConfigColumnsComponent_div_8_Template, 4, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵelementStart(10, "button", 8);
        ɵngcc0.ɵɵlistener("click", function DwMetadataGridConfigColumnsComponent_Template_button_click_10_listener() { return ctx.removeAll(); });
        ɵngcc0.ɵɵtext(11, "Remove All");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelementStart(13, "dw-metadata-grid-config-column", 10);
        ɵngcc0.ɵɵlistener("columnPreferenceChange", function DwMetadataGridConfigColumnsComponent_Template_dw_metadata_grid_config_column_columnPreferenceChange_13_listener($event) { return ctx.selectedColumn = $event; })("columnPreferenceChange", function DwMetadataGridConfigColumnsComponent_Template_dw_metadata_grid_config_column_columnPreferenceChange_13_listener() { return ctx.onColumnsChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.columns)("config", ctx.listConfig)("selectedItem", ctx.selectedColumn);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", (ctx.availableAttributes == null ? null : ctx.availableAttributes.length) > 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("attributes", ctx.availableAttributes);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.customColumnDefs);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("useColumnFlex", ctx.useColumnFlex)("columnPreference", ctx.selectedColumn)("attribute", ctx.selectedAttr)("configContext", ctx.configContext)("queryMetaData", ctx.queryMetaData);
    } }, directives: function () { return [DwUiConfigListComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwFieldSelectionComponent, ɵngcc4.NgForOf, DwMetadataGridConfigColumnComponent]; }, encapsulation: 2 });
DwMetadataGridConfigColumnsComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataGridService },
    { type: DwLoggingService },
    { type: DwUiConfigRegistryService }
];
DwMetadataGridConfigColumnsComponent.propDecorators = {
    configContext: [{ type: Input }],
    columns: [{ type: Input }],
    columnsChange: [{ type: Output }],
    gridPreferences: [{ type: Input }],
    useColumnFlex: [{ type: Input }],
    inlineEditEnabled: [{ type: Input }]
};
__decorate$19([
    DwInputConverter(booleanConverter),
    __metadata$V("design:type", Boolean)
], DwMetadataGridConfigColumnsComponent.prototype, "inlineEditEnabled", void 0);

class DwFilterItemBase {
    constructor() {
        this.filterChange = new EventEmitter();
        this.subscriptions = [];
    }
    ;
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
        this.filterChange.emit(value);
    }
    // override method to handle filter setup
    setupFilter() { }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
DwFilterItemBase.ɵfac = function DwFilterItemBase_Factory(t) { return new (t || DwFilterItemBase)(); };
DwFilterItemBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwFilterItemBase, inputs: { filter: "filter", item: "item", queryMetaData: "queryMetaData", filterConfig: "filterConfig", resolvedContext: "resolvedContext" }, outputs: { filterChange: "filterChange" } });
DwFilterItemBase.propDecorators = {
    item: [{ type: Input }],
    queryMetaData: [{ type: Input }],
    filterConfig: [{ type: Input }],
    resolvedContext: [{ type: Input }],
    filter: [{ type: Input }],
    filterChange: [{ type: Output }]
};

class DwAllTextFieldsCustomFilterConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwMetaDataService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
    }
    setupComponent() {
        super.setupComponent();
        this.setupMetaData();
        if (this.config.includeAllAttributes == null && this.config.includeAttributes == null) {
            this.config.includeAllAttributes = true;
        }
    }
    ngOnInit() {
        this.setupComponent();
    }
    setupMetaData() {
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning, false)
            .subscribe(itemMd => {
            this.primeAttributes = itemMd.Attributes.filter(a => this.isValidAttribute(a)).map(a => { return { label: a.AttributeDisplay, value: a.AttributeName }; });
        });
    }
    isValidAttribute(attr) {
        var _a, _b;
        if ((_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey) {
            return false;
        }
        switch (attr.AttributeType) {
            case DwAttributeType.Text:
            case DwAttributeType.Memo:
            case DwAttributeType.HTML:
                return true;
        }
        return (_b = attr.Attribute) === null || _b === void 0 ? void 0 : _b.IsLookup;
    }
    getDefaultConfig() {
        return {
            includeAllAttributes: true,
        };
    }
}
DwAllTextFieldsCustomFilterConfigComponent.ɵfac = function DwAllTextFieldsCustomFilterConfigComponent_Factory(t) { return new (t || DwAllTextFieldsCustomFilterConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwAllTextFieldsCustomFilterConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAllTextFieldsCustomFilterConfigComponent, selectors: [["dw-all-text-fields-custom-filter-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 26, vars: 7, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 1, "multi-edit-auto-expand", 3, "options", "ngModel", "filter", "ngModelChange"], ["title", "Prevents using numeric search to include the Primary Key", 1, "fa", "fa-info-circle"], ["title", "Prevents searching a specific field (e.g. 'JN:35353' - searches Job Number)", 1, "fa", "fa-info-circle"]], template: function DwAllTextFieldsCustomFilterConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4, "Include All Attributes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_inputSwitch_ngModelChange_6_listener($event) { return ctx.config.includeAllAttributes = $event; })("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_inputSwitch_ngModelChange_6_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Attributes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "p-multiSelect", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_multiSelect_ngModelChange_11_listener($event) { return ctx.config.includeAttributes = $event; })("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_multiSelect_ngModelChange_11_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 0);
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Exclude Primary Key ");
        ɵngcc0.ɵɵelement(16, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 2);
        ɵngcc0.ɵɵelementStart(18, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_inputSwitch_ngModelChange_18_listener($event) { return ctx.config.excludePk = $event; })("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_inputSwitch_ngModelChange_18_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 0);
        ɵngcc0.ɵɵelementStart(20, "div", 1);
        ɵngcc0.ɵɵelementStart(21, "label");
        ɵngcc0.ɵɵtext(22, "Prevented Named Search ");
        ɵngcc0.ɵɵelement(23, "i", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 2);
        ɵngcc0.ɵɵelementStart(25, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_inputSwitch_ngModelChange_25_listener($event) { return ctx.config.preventNamedSearch = $event; })("ngModelChange", function DwAllTextFieldsCustomFilterConfigComponent_Template_p_inputSwitch_ngModelChange_25_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.includeAllAttributes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.config.includeAllAttributes);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("ngModel", ctx.config.includeAttributes)("filter", true);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.excludePk);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.preventNamedSearch);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc12.MultiSelect], styles: [""] });
DwAllTextFieldsCustomFilterConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

class DwAllTextFieldFilterService {
    getSearchableAttributes(textFilterConfig, queryMetaData) {
        textFilterConfig = this.getTextFilterConfigWithDefault(textFilterConfig);
        textFilterConfig.includeAttributes = textFilterConfig.includeAttributes || [];
        return queryMetaData.Attributes.filter(attr => this.isValidAttribute(attr) && (textFilterConfig.includeAllAttributes || textFilterConfig.includeAttributes.find(attrName => attr.AttributeName == attrName)));
    }
    getTextFilterConfigWithDefault(textFilterConfig) {
        textFilterConfig = textFilterConfig || {};
        if (textFilterConfig.includeAllAttributes == undefined) {
            textFilterConfig = {
                includeAllAttributes: true,
                includeAttributes: []
            };
        }
        return textFilterConfig;
    }
    buildInitialFilter(filterConfig, item, queryMetaData, existingFilter, resolvedContext, initialValue) {
        if (initialValue) {
            return this.buildTextFilter(initialValue, filterConfig.filterType, filterConfig.additionalConfig, queryMetaData);
        }
        return null;
    }
    buildTextFilter(searchValue, filterType, textFilterConfig, queryMetaData) {
        textFilterConfig = this.getTextFilterConfigWithDefault(textFilterConfig);
        let newFilter = {
            Op: DwOperator.Or
        };
        let count = 0;
        if (!isNaN(parseInt(searchValue)) && !textFilterConfig.excludePk) {
            const pkAttr = queryMetaData.Attributes.find(a => { var _a; return (_a = a.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey; });
            if (pkAttr) {
                count++;
                const groupName = `GroupText${count}`;
                newFilter[groupName] = this.buildFilter(pkAttr, searchValue, DwFilterType.Equal);
            }
        }
        const searchParts = searchValue.split(":");
        let fieldName;
        let fieldSearchValue;
        if (searchParts.length == 2 && !(textFilterConfig === null || textFilterConfig === void 0 ? void 0 : textFilterConfig.preventNamedSearch)) {
            fieldName = searchParts[0].toUpperCase();
            fieldSearchValue = searchParts[1];
        }
        const searchableAttributes = this.getSearchableAttributes(textFilterConfig, queryMetaData);
        for (const attr of searchableAttributes) {
            count++;
            const groupName = `GroupText${count}`;
            if (this.isAttributeMatch(fieldName, attr) && fieldSearchValue) {
                // If we get an attribute match, we only include that search field
                newFilter = {
                    Op: DwOperator.Or
                };
                newFilter[groupName] = this.buildFilter(attr, fieldSearchValue, filterType);
                return newFilter;
            }
            newFilter[groupName] = this.buildFilter(attr, searchValue, filterType);
        }
        return newFilter;
    }
    isAttributeMatch(fieldName, attr) {
        if (!fieldName) {
            return false;
        }
        const attrNameParts = attr.AttributeDisplay.toUpperCase().split(" ");
        let searchIndex = 0;
        let searchIndexAlt = 0;
        // Attempt to match each name part
        for (let attrNamepart of attrNameParts) {
            // full match
            if (attrNamepart.startsWith(fieldName)) {
                return true;
            }
            const remaingLetters = fieldName.substring(searchIndex, fieldName.length);
            // remaining letters match
            if (attrNamepart.startsWith(remaingLetters)) {
                return true;
            }
            const currentLetter = fieldName[searchIndex];
            searchIndex++;
            let continueOn = false;
            if (attrNamepart.startsWith(currentLetter)) {
                continueOn = true;
            }
            // match as many letters
            let currentWord = fieldName[searchIndexAlt];
            let nextIndex = searchIndexAlt;
            while (attrNamepart.startsWith(currentWord)) {
                nextIndex++;
                // if we're matched all characters, we're finished
                if (nextIndex >= fieldName.length) {
                    return true;
                }
                currentWord += fieldName[nextIndex];
                continueOn = true;
            }
            searchIndexAlt = nextIndex;
            if (!continueOn) {
                return false;
            }
        }
        return true;
    }
    // for(let i=0; i<=attrNameParts.length; i++) {
    // // Match each letter in the field name (e.g. JN matches Job Number - J matches first work, N matches second)
    // for(let i=0; i<=fieldName.length; i++) {
    //     const currentLetter = fieldName[i];
    //     const remaingLetters = fieldName.substring(i, fieldName.length);
    //     if (!attrNameParts[i].startsWith(currentLetter)) {
    //         return false;
    //     }
    //     if (attrNameParts[i].startsWith(fieldName) || attrNameParts[i].startsWith(remaingLetters)){
    //         return true;
    //     }
    // }
    // return true;
    //}
    isValidAttribute(attr) {
        var _a, _b;
        if ((_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey) {
            return false;
        }
        switch (attr.AttributeType) {
            case DwAttributeType.Text:
            case DwAttributeType.Memo:
            case DwAttributeType.HTML:
                return true;
        }
        return (_b = attr.Attribute) === null || _b === void 0 ? void 0 : _b.IsLookup;
    }
    buildFilter(attr, value, filterType) {
        const qh = new DwQueryHelper();
        const filterTypeKey = qh.convertFilterType(filterType);
        const filter = {
            Op: DwOperator.Or
        };
        // Use the display attribute name which works for text as well as lookups
        const attrFilter = filter[attr.DisplayAttributeName] = {};
        attrFilter.Prefix = attr.RelationPrefix;
        attrFilter[filterTypeKey] = value;
        return filter;
    }
}
DwAllTextFieldFilterService.ɵfac = function DwAllTextFieldFilterService_Factory(t) { return new (t || DwAllTextFieldFilterService)(); };
DwAllTextFieldFilterService.ɵprov = ɵɵdefineInjectable({ factory: function DwAllTextFieldFilterService_Factory() { return new DwAllTextFieldFilterService(); }, token: DwAllTextFieldFilterService, providedIn: "root" });

var __decorate$1a = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$W = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwAllTextFieldsCustomFilterComponent = class DwAllTextFieldsCustomFilterComponent extends DwFilterItemBase {
    constructor(dwAllTextFieldFilterService, router) {
        super();
        this.dwAllTextFieldFilterService = dwAllTextFieldFilterService;
        this.router = router;
    }
    setupFilter() {
        const paramName = this.filterConfig.altQueryStringParamName || this.filterConfig.attr;
        let paramValue = null;
        if (paramName) {
            paramValue = getParameterByName(this.router, paramName);
        }
        this.textFilterValue = paramValue || this.filterConfig.defaultValue || "";
    }
    textFilterValueChange(value) {
        if (!value) {
            this.filterChange.emit(null);
            return;
        }
        const newFilter = this.dwAllTextFieldFilterService.buildTextFilter(value, this.filterConfig.filterType, this.filterConfig.additionalConfig, this.queryMetaData);
        this.filterChange.emit(newFilter);
    }
};
DwAllTextFieldsCustomFilterComponent.ɵfac = function DwAllTextFieldsCustomFilterComponent_Factory(t) { return new (t || DwAllTextFieldsCustomFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwAllTextFieldFilterService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
DwAllTextFieldsCustomFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAllTextFieldsCustomFilterComponent, selectors: [["dw-all-text-fields-custom-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[1, "label"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwAllTextFieldsCustomFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAllTextFieldsCustomFilterComponent_Template_input_ngModelChange_2_listener($event) { return ctx.textFilterValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.filterConfig.label || "Text Search");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.textFilterValue);
    } }, directives: [ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwAllTextFieldsCustomFilterComponent.ctorParameters = () => [
    { type: DwAllTextFieldFilterService },
    { type: Router }
];
DwAllTextFieldsCustomFilterComponent = __decorate$1a([
    DwComponent({
        name: 'All Text Filter',
        componentType: DwComponentType.filterItem,
        isGlobal: true,
        configComponent: DwAllTextFieldsCustomFilterConfigComponent,
        configData: {
            showCaption: true,
            showCompareType: true,
            showControlOptions: true,
            attrType: DwAttributeType.Text,
            requireAttr: false,
            showPlaceholderText: true,
            showDefaultValue: true,
            allowAttr: false,
            initialFilterService: DwAllTextFieldFilterService
        }
    }),
    __metadata$W("design:paramtypes", [DwAllTextFieldFilterService, Router])
], DwAllTextFieldsCustomFilterComponent);

class DwRouteBaseConfigComponent {
    constructor(dwUiConfigRegistryService, dwMetaDataService, cdr) {
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.cdr = cdr;
        this.subscriptions = [];
        this.components = [];
        this.sideMenuComponents = [];
        this.menuComponents = [];
    }
    ;
    ngOnInit() {
        //this.setupComponents();
        // Called from instance configuration
        // this.setupForm();
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        if (this.routeConfigFG) {
            for (const controlName in this.routeConfigFG.controls) {
                const fc = this.routeConfigFG.controls[controlName];
                // Skip the child list meu options
                if (fc instanceof FormGroup && controlName == 'childListMenuOptions') {
                    continue;
                }
                fc.disable({ emitEvent: false });
            }
        }
    }
    setupForm() {
        this.setupComponents();
        this.componentOverrideFC = this.addControl('componentOverride');
        this.componentConfigFC = this.addControl('componentConfig');
        this.menuComponentOverrideFC = this.addControl('menuComponentOverride');
        this.menuComponentConfigFC = this.addControl('menuComponentConfig');
        this.addControl('includeInGroup');
        this.addControl('groupDisplay');
        this.subscriptions.push(this.componentOverrideFC.valueChanges.subscribe(value => {
            this.setupChildConfigComponent();
        }));
        this.setupChildConfigComponent();
        this.clearAllFormValidators();
        this.setupMetaDataItemSubscription();
        this.setupInitialFormValue();
    }
    setupChildConfigComponent() {
        var _a, _b;
        if (!((_a = this.componentOverrideFC) === null || _a === void 0 ? void 0 : _a.value)) {
            this.componentOverride = null;
        }
        else {
            this.componentOverride = this.components.find(c => c.key == this.componentOverrideFC.value);
        }
        if (!((_b = this.menuComponentConfigFC) === null || _b === void 0 ? void 0 : _b.value)) {
            this.menuComponentOverride = null;
        }
        else {
            this.menuComponentOverride = this.menuComponents.find(c => c.key == this.menuComponentConfigFC.value);
        }
    }
    updateComponentConfig(value) {
        this.componentConfigFC.setValue(value);
    }
    // configureChildConfigComponent(instance: DwRouteBaseConfigComponent) {
    //   this.childConfigComponentInstance = instance;
    //   if (this.childConfigComponentInstance) {
    //     this.ignoreFormUpdate = true;
    //     this.childConfigComponentInstance.routeConfigFG = this.componentConfigFG;
    //     this.childConfigComponentInstance.route = this.route;
    //     this.childConfigComponentInstance.routeTypeProcessorRegistration = this.routeTypeProcessorRegistration;
    //     this.childConfigComponentInstance.setupForm();
    //     this.ignoreFormUpdate = false;
    //   }
    // }
    setupInitialFormValue() {
        if (this.route) {
            // Make a copy of the route config JSON so we don't use it by reference
            let routeConfig = Object.assign({}, this.route.RouteConfigJSON || {});
            if (this.routeTypeProcessorRegistration && this.routeTypeProcessorRegistration.defaultRouteTypeConfig) {
                // Remove any null properties so these don't cancel out the default values
                routeConfig = removeNullProperties(routeConfig);
                routeConfig = Object.assign(Object.assign({}, this.routeTypeProcessorRegistration.defaultRouteTypeConfig), routeConfig);
            }
            this.routeConfigFG.patchValue(routeConfig, { emitEvent: false });
            this.routeConfigFG.updateValueAndValidity();
        }
    }
    addControl(controlName, validatorVn = null) {
        let control = this.routeConfigFG.get(controlName);
        if (!control) {
            control = new FormControl();
            this.routeConfigFG.addControl(controlName, control);
        }
        control.validator = validatorVn;
        control.enable();
        return control;
    }
    addFormGroup(controlName, validatorVn = null) {
        let control = this.routeConfigFG.get(controlName);
        if (!control) {
            control = new FormGroup({});
            this.routeConfigFG.addControl(controlName, control);
        }
        control.validator = validatorVn;
        control.enable();
        return control;
    }
    clearAllFormValidators() {
        for (const controlName in this.routeConfigFG.controls) {
            const fc = this.routeConfigFG.controls[controlName];
            if (fc.validator) {
                fc.validator = null;
                fc.updateValueAndValidity();
            }
        }
    }
    setupMetaDataItemSubscription() {
        if (this.routeConfigFG && this.routeConfigFG.parent) {
            const parentFG = this.routeConfigFG.parent;
            const dwMd = new DevwareMetaDataService();
            const metaDataItemIdFC = parentFG.get('MetaDataItemId');
            if (metaDataItemIdFC) {
                this.subscriptions.push(metaDataItemIdFC.valueChanges.subscribe(itemId => {
                    this.handleItemIdChange(itemId);
                }));
            }
        }
    }
    handleItemIdChange(itemId) {
        this.itemId = itemId;
        if (!this.itemId) {
            this.itemName = null;
            this.setupComponents();
            return;
        }
        this.dwMetaDataService.getMetaDataItemName(this.itemId)
            .subscribe(itemName => {
            this.itemName = itemName;
            this.setupComponents();
        });
    }
    setupComponents() {
        this.components = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.pageComponent, this.itemName);
        this.sideMenuComponents = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.sideMenuReplacement, this.itemName);
        this.menuComponents = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.menuComponent, this.itemName);
    }
}
DwRouteBaseConfigComponent.ɵfac = function DwRouteBaseConfigComponent_Factory(t) { return new (t || DwRouteBaseConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwRouteBaseConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteBaseConfigComponent, selectors: [["dw-route-base-config"]], inputs: { routeConfigFG: ["routeConfigFormGroup", "routeConfigFG"], route: "route", routeTypeProcessorRegistration: "routeTypeProcessorRegistration" }, decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["title", "Shows global components which have the DwComponent decorator and a component type of Page", 1, "fas", "fa-info-circle"], ["formControlName", "componentOverride", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "9"], ["title", "Groups menus based on a Group Display on any submenus", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "includeInGroup"], ["dwRow", "", 4, "ngIf"], ["title", "Overides the menu display and only shows components of type Menu Component", 1, "fas", "fa-info-circle"], ["formControlName", "menuComponentOverride", 1, "form-control"], ["type", "text", "formControlName", "groupDisplay", 1, "form-control"], [3, "component", "config", "configChange"]], template: function DwRouteBaseConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteBaseConfigComponent_div_0_Template, 28, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, ɵngcc3.DefaultValueAccessor, DwUiChildConfigHostComponent], encapsulation: 2 });
DwRouteBaseConfigComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: ChangeDetectorRef }
];
DwRouteBaseConfigComponent.propDecorators = {
    routeConfigFG: [{ type: Input, args: ['routeConfigFormGroup',] }],
    route: [{ type: Input }],
    routeTypeProcessorRegistration: [{ type: Input }]
};

class DwListRouteConfigComponent extends DwRouteBaseConfigComponent {
    get listRouteSubType() {
        return this.routeConfigFG.get('listRouteSubType');
    }
    setupForm() {
        this.addControl('listRouteSubType', Validators.required);
        this.addControl('configKeyPart');
        this.addControl('printConfigKeyPart');
        this.addControl('replaceSideMenu');
        this.addControl('sideMenuComponent');
        this.addControl('includeInGroup');
        this.addControl('groupDisplay');
        super.setupForm();
        this.subscriptions.push(this.listRouteSubType.valueChanges
            .subscribe(value => this.setupListRouteSubTypeValidation()));
        this.setupListRouteSubTypeValidation();
    }
    setupListRouteSubTypeValidation() {
        let validator;
        if (this.listRouteSubType.value == DwListRouteSubType.custom) {
            validator = Validators.required;
        }
        this.componentOverrideFC.setValidators(validator);
        this.componentOverrideFC.updateValueAndValidity();
    }
}
DwListRouteConfigComponent.ɵfac = function DwListRouteConfigComponent_Factory(t) { return ɵDwListRouteConfigComponent_BaseFactory(t || DwListRouteConfigComponent); };
DwListRouteConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwListRouteConfigComponent, selectors: [["dw-list-route-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["formControlName", "listRouteSubType", 1, "form-control"], ["value", "grid"], ["value", "list"], ["value", "custom"], ["dwRow", "", 4, "ngIf"], ["type", "text", "formControlName", "configKeyPart", 1, "form-control"], ["dwCol", "9"], ["title", "Use this menu's children as the side menu", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "replaceSideMenu"], ["title", "Groups menus based on a Group Display on any submenus", 1, "fa", "fa-info-circle"], ["formControlName", "includeInGroup"], ["title", "Overides the menu display and only shows components of type Menu Component", 1, "fas", "fa-info-circle"], ["formControlName", "menuComponentOverride", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["title", "Shows global components or components for this meta data item which have the DwComponent decorator and a component type of Page", 1, "fas", "fa-info-circle"], ["formControlName", "componentOverride", 1, "form-control"], ["title", "Replaces the standard side replacement menu with a custom component", 1, "fas", "fa-info-circle"], ["formControlName", "sideMenuComponent", 1, "form-control"], ["type", "text", "formControlName", "groupDisplay", 1, "form-control"], [3, "component", "config", "configChange"]], template: function DwListRouteConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwListRouteConfigComponent_div_0_Template, 44, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, ɵngcc4.NgForOf, DwUiChildConfigHostComponent], encapsulation: 2 });

class DwRouteTypeProcessorBase {
    constructor(uiMetaDataConfig, uiConfigRegistryService) {
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.uiConfigRegistryService = uiConfigRegistryService;
    }
    buildRoute(routeEntity) {
        const routeConfig = routeEntity.RouteConfigJSON || {};
        let component = this.getOverrideComponent(routeConfig) || this.getDefaultComponent(routeEntity, routeConfig);
        const baseMenuData = this.buildBaseMenuData(routeEntity, routeConfig);
        const listRoute = {
            path: routeEntity.Path,
            component: component,
            data: baseMenuData
        };
        return this.customizeRoute(listRoute, routeEntity, routeConfig);
    }
    getOverrideComponent(routeConfig) {
        if (routeConfig.componentOverride) {
            const componentRef = this.uiConfigRegistryService.getRegisteredComponent(routeConfig.componentOverride, DwComponentType.pageComponent);
            if (componentRef) {
                return componentRef.component;
            }
        }
        return null;
    }
    getMenuOverrideComponent(routeConfig) {
        if (routeConfig.menuComponentOverride) {
            const componentRef = this.uiConfigRegistryService.getRegisteredComponent(routeConfig.menuComponentOverride, DwComponentType.menuComponent);
            if (componentRef) {
                return componentRef.component;
            }
        }
        return null;
    }
    buildBaseMenuData(routeEntity, routeConfig) {
        const menuData = {
            extInfo: {
                routeItemId: routeEntity.RouteId,
                routeTypeId: routeEntity.RouteTypeId,
                securityExpression: routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.securityExpression
            },
            display: routeEntity.Display,
            iconCssClass: routeEntity.IconCssClass,
            excludeFromMainMenu: routeEntity.ExcludeFromMainMenu,
            showInMenu: routeEntity.ShowInMenu,
            requireAuthentication: routeEntity.RequireAuthentication,
            canAccessPermission: routeEntity.CanAccessPermissionMeaning,
            routeOrder: routeEntity.RouteOrder,
            category: routeEntity.CategoryMeaning,
            parentRouteId: routeEntity.ParentRouteId,
            routeId: routeEntity.RouteId,
            referenceKey: routeEntity.RouteReferenceKey,
            highlightOnExactMatch: routeEntity.HighlightOnExactMatch,
            componentConfig: routeConfig.componentConfig
        };
        menuData.menuComponent = this.getMenuOverrideComponent(routeConfig);
        menuData.menuComponentConfig = routeConfig.menuComponentConfig;
        menuData.childListMenuOptions = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.childListMenuOptions;
        menuData.replaceSideMenu = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.replaceSideMenu;
        menuData.hideReplaceSideMenuBackButton = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.hideReplaceSideMenuBackButton;
        menuData.sideMenuComponent = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.sideMenuComponent;
        menuData.includeInGroup = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.includeInGroup;
        menuData.groupDisplay = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.groupDisplay;
        return menuData;
    }
}
DwRouteTypeProcessorBase.ɵfac = function DwRouteTypeProcessorBase_Factory(t) { return new (t || DwRouteTypeProcessorBase)(ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwUiConfigRegistryService)); };
DwRouteTypeProcessorBase.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRouteTypeProcessorBase, factory: DwRouteTypeProcessorBase.ɵfac });
DwRouteTypeProcessorBase.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService }
];

function DwRouteTypeProcessor(routeTypeRegistration) {
    return function (serviceType) {
        const reg = Object.assign(Object.assign({}, routeTypeRegistration), { keyName: routeTypeRegistration.keyName || routeTypeRegistration.display, service: serviceType });
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerItem(DwUiRegistryType.routeTypeProcessor, reg);
    };
}

var __decorate$1b = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwListRouteProcessor = class DwListRouteProcessor extends DwRouteTypeProcessorBase {
    getDefaultComponent(routeEntity, routeConfig) {
        switch (routeConfig.listRouteSubType) {
            case DwListRouteSubType.list:
                return DwDefaultListPageComponent;
            case DwListRouteSubType.grid:
            default:
                return DwDefaultGridPage;
        }
    }
    customizeRoute(route, routeEntity, routeConfig) {
        var _a;
        const itemName = routeEntity.UniqueItemName;
        let editItemName = itemName;
        if (routeConfig.editMetaDataItem) {
            editItemName = routeConfig.editMetaDataItem;
        }
        const baseMenuData = route.data;
        let printChildRoute = this.buildChildRoute(routeConfig, baseMenuData, DwMenuActionType.print, editItemName, routeConfig.printConfigKeyPart);
        let printConfigKeyPart = routeConfig.printConfigKeyPart || ((_a = printChildRoute === null || printChildRoute === void 0 ? void 0 : printChildRoute.data) === null || _a === void 0 ? void 0 : _a.configKeyPart);
        // Add additional menu properties
        baseMenuData.metaDataItem = itemName,
            baseMenuData.metaDataActionType = DwMenuActionType.list;
        baseMenuData.configKeyPart = routeConfig.configKeyPart;
        baseMenuData.printConfigKeyPart = printConfigKeyPart;
        baseMenuData.replaceSideMenu = routeConfig.replaceSideMenu;
        baseMenuData.sideMenuComponent = routeConfig.sideMenuComponent;
        baseMenuData.includeInGroup = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.includeInGroup;
        baseMenuData.groupDisplay = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.groupDisplay;
        route.children = [
            this.buildChildRoute(routeConfig, baseMenuData, DwMenuActionType.edit, editItemName, printConfigKeyPart),
            this.buildChildRoute(routeConfig, baseMenuData, DwMenuActionType.view, editItemName, printConfigKeyPart),
            this.buildChildRoute(routeConfig, baseMenuData, DwMenuActionType.add, editItemName, printConfigKeyPart),
            this.buildChildRoute(routeConfig, baseMenuData, DwMenuActionType.print, editItemName, printConfigKeyPart),
        ];
        return route;
    }
    buildChildRoute(routeConfig, baseMenuData, menuActionType, editItemName, printConfigKeyPart) {
        const routeFormConfigs = routeConfig.formRouteOptions || [];
        const routeFormConfig = routeFormConfigs.find(fc => fc.formType == menuActionType) || { formType: menuActionType };
        const configKeyPart = routeFormConfig.configKeyPart || routeConfig.configKeyPart;
        // const printConfigKeyPart = routeConfig.printConfigKeyPart || configKeyPart;
        const display = routeFormConfig.displayOverride || getMenuActionTypeDisplay(menuActionType);
        // Determine child path
        let path = getMenuActionTypePath(editItemName, menuActionType);
        if (routeFormConfig.pathOverride) {
            path = routeFormConfig.pathOverride;
        }
        const childMenuData = {
            display: display,
            excludeFromMainMenu: true,
            metaDataItem: editItemName,
            metaDataActionType: menuActionType,
            showInMenu: false,
            configKeyPart: configKeyPart,
            printConfigKeyPart: printConfigKeyPart,
            referenceKey: path,
            isChild: true,
            replaceSideMenu: routeFormConfig.replaceSideMenu,
            sideMenuComponent: routeFormConfig.sideMenuComponent,
        };
        const childRoute = {
            path: path,
            component: DwDefaultFormPage,
            data: Object.assign(Object.assign({}, baseMenuData), childMenuData) // Use any defaults from the base route
        };
        childRoute.data.referenceKey = path;
        return childRoute;
    }
};
DwListRouteProcessor.ɵfac = function DwListRouteProcessor_Factory(t) { return ɵDwListRouteProcessor_BaseFactory(t || DwListRouteProcessor); };
DwListRouteProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwListRouteProcessor, factory: function (t) { return DwListRouteProcessor.ɵfac(t); } });
DwListRouteProcessor = __decorate$1b([
    DwRouteTypeProcessor({
        keyName: 'ListRouteProcessor',
        display: 'List Route Processor',
        configTabDisplay: 'Item List Page Settings',
        configComponent: DwListRouteConfigComponent,
        routeTypeId: DwDynamicRouteType.listPage,
        defaultRouteTypeConfig: {
            listRouteSubType: DwListRouteSubType.grid,
        },
        usesMetaDataItem: true
    })
], DwListRouteProcessor);

class DwMenuRouteConfigComponent extends DwRouteBaseConfigComponent {
    setupForm() {
        this.addControl('hideChildOnMenuPage');
        this.addControl('replaceSideMenu');
        this.addControl('hideReplaceSideMenuBackButton');
        this.addControl('sideMenuComponent');
        this.addControl('navigateToFirstChild');
        this.addControl('useLargeIconView');
        this.addControl('showAsGroup');
        this.addControl('includeInGroup');
        this.addControl('groupDisplay');
        super.setupForm();
    }
}
DwMenuRouteConfigComponent.ɵfac = function DwMenuRouteConfigComponent_Factory(t) { return ɵDwMenuRouteConfigComponent_BaseFactory(t || DwMenuRouteConfigComponent); };
DwMenuRouteConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMenuRouteConfigComponent, selectors: [["dw-dw-menu-route-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["title", "Shows global components which have the DwComponent decorator and a component type of Page", 1, "fas", "fa-info-circle"], ["formControlName", "componentOverride", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "9"], ["title", "Use this menu's children as the side menu", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "replaceSideMenu"], ["dwRow", "", 4, "ngIf"], ["title", "Shows this menu group as a single item on menu pages", 1, "fa", "fa-info-circle"], ["formControlName", "hideChildOnMenuPage"], ["title", "When clicked, navigates to the first child menu", 1, "fa", "fa-info-circle"], ["formControlName", "navigateToFirstChild"], ["title", "Groups menus based on a Group Display on any submenus", 1, "fa", "fa-info-circle"], ["formControlName", "includeInGroup"], ["title", "Overides the menu display and only shows components of type Menu Component", 1, "fas", "fa-info-circle"], ["formControlName", "menuComponentOverride", 1, "form-control"], ["title", "Hide the back button in the replacement menu", 1, "fa", "fa-info-circle"], ["formControlName", "hideReplaceSideMenuBackButton"], ["title", "Replaces the standard side replacement menu with a custom component", 1, "fas", "fa-info-circle"], ["formControlName", "sideMenuComponent", 1, "form-control"], ["type", "text", "formControlName", "groupDisplay", 1, "form-control"], ["title", "Shows all child items in a group", 1, "fa", "fa-info-circle"], ["formControlName", "showAsGroup"], [3, "component", "configure"]], template: function DwMenuRouteConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMenuRouteConfigComponent_div_0_Template, 52, 10, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, ɵngcc3.DefaultValueAccessor, DwDynamicLoaderComponent], styles: [""] });

var __decorate$1c = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwMenuRouteProcessor = class DwMenuRouteProcessor extends DwRouteTypeProcessorBase {
    customizeRoute(route, routeEntity, routeConfig) {
        const baseMenuData = route.data;
        baseMenuData.hideChildOnMenuPage = routeConfig.hideChildOnMenuPage;
        baseMenuData.navigateToFirstChild = routeConfig.navigateToFirstChild;
        baseMenuData.replaceSideMenu = routeConfig.replaceSideMenu;
        baseMenuData.sideMenuComponent = routeConfig.sideMenuComponent;
        baseMenuData.useLargeIconView = routeConfig.useLargeIconView;
        baseMenuData.showAsGroup = routeConfig.showAsGroup;
        baseMenuData.includeInGroup = routeConfig.includeInGroup;
        baseMenuData.groupDisplay = routeConfig.groupDisplay;
        return route;
    }
    getDefaultComponent(routeEntity, routeConfig) {
        return DefaultMenuPageComponent;
    }
};
DwMenuRouteProcessor.ɵfac = function DwMenuRouteProcessor_Factory(t) { return ɵDwMenuRouteProcessor_BaseFactory(t || DwMenuRouteProcessor); };
DwMenuRouteProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMenuRouteProcessor, factory: function (t) { return DwMenuRouteProcessor.ɵfac(t); } });
DwMenuRouteProcessor = __decorate$1c([
    DwRouteTypeProcessor({
        keyName: 'MenuRouteProcessor',
        display: 'Menu Route Processor',
        configTabDisplay: 'Menu Group Page Settings',
        configComponent: DwMenuRouteConfigComponent,
        routeTypeId: DwDynamicRouteType.menuPage,
        isDefault: true
    })
], DwMenuRouteProcessor);

class DwComponentRouteConfigComponent extends DwRouteBaseConfigComponent {
    setupForm() {
        super.setupForm();
        this.componentOverrideFC.validator = Validators.required;
        this.componentOverrideFC.updateValueAndValidity();
    }
}
DwComponentRouteConfigComponent.ɵfac = function DwComponentRouteConfigComponent_Factory(t) { return ɵDwComponentRouteConfigComponent_BaseFactory(t || DwComponentRouteConfigComponent); };
DwComponentRouteConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwComponentRouteConfigComponent, selectors: [["dw-component-route-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["title", "Shows global components which have the DwComponent decorator and a component type of Page", 1, "fas", "fa-info-circle"], ["formControlName", "componentOverride", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["title", "Overides the menu display and only shows components of type Menu Component", 1, "fas", "fa-info-circle"], ["formControlName", "menuComponentOverride", 1, "form-control"], [3, "component", "config", "configChange"]], template: function DwComponentRouteConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwComponentRouteConfigComponent_div_0_Template, 20, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwUiChildConfigHostComponent], encapsulation: 2 });

var __decorate$1d = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwComponentRouteProcessor = class DwComponentRouteProcessor extends DwRouteTypeProcessorBase {
    customizeRoute(route, routeEntity, routeConfig) {
        return route;
    }
    getDefaultComponent(routeEntity, routeConfig) {
        // This should never be needed since a component is required
        return DwPageMenu;
    }
};
DwComponentRouteProcessor.ɵfac = function DwComponentRouteProcessor_Factory(t) { return ɵDwComponentRouteProcessor_BaseFactory(t || DwComponentRouteProcessor); };
DwComponentRouteProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwComponentRouteProcessor, factory: function (t) { return DwComponentRouteProcessor.ɵfac(t); } });
DwComponentRouteProcessor = __decorate$1d([
    DwRouteTypeProcessor({
        keyName: 'ComponentRouteProcessor',
        display: 'Component Route Processor',
        configTabDisplay: 'Component Page Settings',
        configComponent: DwComponentRouteConfigComponent,
        routeTypeId: DwDynamicRouteType.componentPage,
        isDefault: true
    })
], DwComponentRouteProcessor);

class DwContentComponent {
    constructor(contentManager, uiConfigRegistry) {
        this.contentManager = contentManager;
        this.uiConfigRegistry = uiConfigRegistry;
    }
    ngOnInit() {
        this.registerContent();
        this.contentManager.contentLoaded
            .subscribe(() => {
            this.loadContent();
        });
        this.loadContent();
    }
    loadContent() {
        let item = this.contentManager.getContentItem(this.name);
        if (item) {
            this.contentItem = item;
            this.currentComponent = null;
            if (this.contentItem.useDefaultContent) {
                this.currentComponent = this.component;
            }
            else {
                const componentRef = this.uiConfigRegistry.getRegisteredComponent(item.componentName, DwComponentType.pageComponent);
                if (!componentRef) {
                    console.warn(`Could not find page component ${item.componentName}`);
                    return;
                }
                this.currentComponent = componentRef.component;
            }
        }
        if (this.componentInstance) {
            this.setupComponent(this.componentInstance);
        }
    }
    setupComponent(instance) {
        this.componentInstance = instance;
        this.componentInstance.pageConfig = this.contentItem.config;
    }
    registerContent() {
        this.contentItem = new DwContentPreferenceItem();
        this.contentItem.name = this.name;
        this.contentItem.display = this.display || this.name;
        this.contentItem.useDefaultContent = true;
        if (this.contentOrder) {
            // Convert to a number since it could still be a string at run-time
            this.contentItem.contentOrder = parseInt(this.contentOrder.toString());
        }
        this.contentItem.componentItem = true;
        this.contentManager.registerContent(this.contentItem);
    }
}
DwContentComponent.ɵfac = function DwContentComponent_Factory(t) { return new (t || DwContentComponent)(ɵngcc0.ɵɵdirectiveInject(DwContentManagerComponent), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContentComponent, selectors: [["dw-content-component"]], inputs: { name: "name", display: "display", contentOrder: "contentOrder", component: "component" }, decls: 1, vars: 1, consts: [[3, "component", "configure"]], template: function DwContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 0);
        ɵngcc0.ɵɵlistener("configure", function DwContentComponent_Template_dw_dynamic_loader_configure_0_listener($event) { return ctx.setupComponent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("component", ctx.currentComponent);
    } }, directives: [DwDynamicLoaderComponent], encapsulation: 2 });
DwContentComponent.ctorParameters = () => [
    { type: DwContentManagerComponent, decorators: [{ type: Inject, args: [DwContentManagerComponent,] }] },
    { type: DwUiConfigRegistryService }
];
DwContentComponent.propDecorators = {
    name: [{ type: Input }],
    display: [{ type: Input }],
    contentOrder: [{ type: Input }],
    component: [{ type: Input }]
};

class DwContentConfigComponentComponent {
    constructor(uiConfigRegistry) {
        this.uiConfigRegistry = uiConfigRegistry;
        this.componentList = [];
    }
    ngOnInit() {
        this.componentList = this.uiConfigRegistry.getRegisteredComponents(DwComponentType.pageComponent);
        const componentNameFC = this.subFormGroup.get('componentName');
        componentNameFC.valueChanges
            .subscribe(componentName => {
            this.changeComponent(componentName);
        });
        this.changeComponent(componentNameFC.value);
    }
    changeComponent(componentName) {
        this.currentComponent = this.componentList.find(cl => cl.name === componentName);
        this.configComponent = null;
        if (this.currentComponent) {
            this.configComponent = this.currentComponent.configComponent;
        }
    }
    setupConfigComponent(componentInstance) {
        this.componentInstance = componentInstance;
        if (this.componentInstance.setupForm) {
            this.componentInstance.setupForm();
            const configControl = this.subFormGroup.get('config');
            this.componentInstance.setConfigValue(configControl.value);
            // Watch for changes and update the config form control
            this.configSubscription = this.componentInstance.configFormGroup.valueChanges
                .subscribe(configValue => {
                configControl.setValue(configValue);
            });
        }
    }
    clearSubscription() {
        if (this.configSubscription) {
            this.configSubscription.unsubscribe();
            this.configSubscription = null;
        }
    }
    ngOnDestroy() {
        this.clearSubscription();
    }
}
DwContentConfigComponentComponent.ɵfac = function DwContentConfigComponentComponent_Factory(t) { return new (t || DwContentConfigComponentComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwContentConfigComponentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContentConfigComponentComponent, selectors: [["dw-content-config-component"]], inputs: { subFormGroup: "subFormGroup" }, decls: 12, vars: 4, consts: [[3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["formControlName", "componentName", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "component", "configure"]], template: function DwContentConfigComponentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "Component");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "select", 4);
        ɵngcc0.ɵɵelementStart(6, "option", 5);
        ɵngcc0.ɵɵtext(7, "None");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwContentConfigComponentComponent_option_8_Template, 2, 2, "option", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 2);
        ɵngcc0.ɵɵelementStart(11, "dw-dynamic-loader", 7);
        ɵngcc0.ɵɵlistener("configure", function DwContentConfigComponentComponent_Template_dw_dynamic_loader_configure_11_listener($event) { return ctx.setupConfigComponent($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.subFormGroup);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngValue", null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.componentList);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("component", ctx.configComponent);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwDynamicLoaderComponent], styles: [""] });
DwContentConfigComponentComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
DwContentConfigComponentComponent.propDecorators = {
    subFormGroup: [{ type: Input }]
};

class DwActionRouteConfigComponent extends DwRouteBaseConfigComponent {
    constructor() {
        super(...arguments);
        this.actionItems = [];
    }
    setupForm() {
        this.actionItems = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.action)
            .filter(a => a.actionType === DwActionType.menuAction);
        this.clearAllFormValidators();
        const actionKeyFC = this.addControl('actionKey', Validators.required);
        this.actionConfigFC = this.addControl('actionConfig', this.isActionConfigValid());
        this.setupInitialFormValue();
        this.subscriptions.push(actionKeyFC.valueChanges.subscribe(actionKey => {
            this.actionChanged(actionKey);
        }));
        this.actionChanged(actionKeyFC.value);
    }
    actionChanged(actionKey) {
        this.currentActionItem = this.actionItems.find(ai => ai.keyName == actionKey);
    }
    isActionConfigValid() {
        const tempThis = this;
        return (control) => {
            if (tempThis.actionConfigInstance && tempThis.actionConfigInstance.actionConfigFG && tempThis.actionConfigInstance.actionConfigFG.invalid) {
                return { actionConfigInvalid: true };
            }
            return null;
        };
    }
    configureActionConfigComponent(instance) {
        this.actionConfigInstance = instance;
        if (instance) {
            this.actionConfigInstance.setupForm();
            if (this.actionConfigSubscription) {
                this.actionConfigSubscription.unsubscribe();
            }
            this.actionConfigSubscription = this.actionConfigInstance.actionConfigFG.valueChanges
                .subscribe(value => {
                this.actionConfigFC.setValue(value);
            });
            this.actionConfigInstance.actionConfigFG.patchValue(this.actionConfigFC.value || {});
            this.actionConfigFC.updateValueAndValidity();
            this.actionConfigInstance.setupComplete();
        }
    }
}
DwActionRouteConfigComponent.ɵfac = function DwActionRouteConfigComponent_Factory(t) { return ɵDwActionRouteConfigComponent_BaseFactory(t || DwActionRouteConfigComponent); };
DwActionRouteConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwActionRouteConfigComponent, selectors: [["dw-action-route-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["formControlName", "actionKey", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], [3, "component", "configure"]], template: function DwActionRouteConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwActionRouteConfigComponent_div_0_Template, 10, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwDynamicLoaderComponent], encapsulation: 2 });

var __decorate$1e = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwActionRouteProcessor = class DwActionRouteProcessor extends DwRouteTypeProcessorBase {
    customizeRoute(route, routeEntity, routeConfig) {
        route.data.isAction = true;
        route.data.actionKey = routeConfig.actionKey;
        route.data.actionConfig = routeConfig.actionConfig;
        return route;
    }
    getDefaultComponent(routeEntity, routeConfig) {
        // This will never be used since it is an action only
        return DwPageMenu;
    }
};
DwActionRouteProcessor.ɵfac = function DwActionRouteProcessor_Factory(t) { return ɵDwActionRouteProcessor_BaseFactory(t || DwActionRouteProcessor); };
DwActionRouteProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwActionRouteProcessor, factory: function (t) { return DwActionRouteProcessor.ɵfac(t); } });
DwActionRouteProcessor = __decorate$1e([
    DwRouteTypeProcessor({
        keyName: 'ActionRouteProcessor',
        display: 'Action Processor',
        configTabDisplay: 'Action Settings',
        configComponent: DwActionRouteConfigComponent,
        routeTypeId: DwDynamicRouteType.actionLink,
        isDefault: false
    })
], DwActionRouteProcessor);

class DwRouteActionExternalLinkConfigComponent extends DwActionConfigBaseComponent {
    setupComplete() {
        this.configContext.itemName;
    }
    addControls() {
        this.addControl('url', Validators.required);
        this.addControl('openInSameWindow');
        this.addControl('newWindowTarget');
    }
}
DwRouteActionExternalLinkConfigComponent.ɵfac = function DwRouteActionExternalLinkConfigComponent_Factory(t) { return ɵDwRouteActionExternalLinkConfigComponent_BaseFactory(t || DwRouteActionExternalLinkConfigComponent); };
DwRouteActionExternalLinkConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteActionExternalLinkConfigComponent, selectors: [["dw-route-action-external-link-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["title", "Add any additional query string parameters seperated by &.  Use fields like [FieldName] or [globals.name]", 1, "fa", "fa-info-circle"], ["formControlName", "url", 3, "contextNames", "item", "queryMeaning", "showDisplayAttributes", "excludeDataPrefix"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "openInSameWindow"], ["dwRow", "", 3, "hidden"], ["type", "text", "formControlName", "newWindowTarget", 1, "form-control"]], template: function DwRouteActionExternalLinkConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteActionExternalLinkConfigComponent_div_0_Template, 18, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, DwTemplateConfigControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc10.InputSwitch, ɵngcc3.DefaultValueAccessor]; }, encapsulation: 2 });

var __decorate$1f = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$X = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwRouteActionExternalLinkService = class DwRouteActionExternalLinkService {
    constructor(dwRouteActionHelperService, dwRoutingService) {
        this.dwRouteActionHelperService = dwRouteActionHelperService;
        this.dwRoutingService = dwRoutingService;
    }
    handleAction(actionState) {
        var _a, _b;
        if (!actionState.actionConfig || !actionState.actionConfig.url) {
            console.warn(`External Link Action is missing a url!`);
            return;
        }
        const translatedWindowOpenOptions = {
            openInNewWindow: !((_a = actionState.actionConfig) === null || _a === void 0 ? void 0 : _a.openInSameWindow),
            newWindowTarget: (_b = actionState.actionConfig) === null || _b === void 0 ? void 0 : _b.newWindowTarget
        };
        const windowOpenOptions = getWindowOpenOptions(actionState.dwBrowserEvent, translatedWindowOpenOptions);
        const url = this.dwRouteActionHelperService.processUrlParameters(actionState.actionConfig.url, actionState);
        if (url) {
            this.dwRoutingService.navigateToUrl(url, windowOpenOptions);
        }
        return of({ success: true });
    }
};
DwRouteActionExternalLinkService.ɵfac = function DwRouteActionExternalLinkService_Factory(t) { return new (t || DwRouteActionExternalLinkService)(ɵngcc0.ɵɵinject(DwRouteActionHelperService), ɵngcc0.ɵɵinject(DwRoutingServiceToken)); };
DwRouteActionExternalLinkService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRouteActionExternalLinkService, factory: function (t) { return DwRouteActionExternalLinkService.ɵfac(t); } });
DwRouteActionExternalLinkService.ctorParameters = () => [
    { type: DwRouteActionHelperService },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] }
];
DwRouteActionExternalLinkService = __decorate$1f([
    DwAction({
        keyName: DwRouteActionKeys.external,
        display: 'External Link Action',
        actionType: DwActionType.menuAction,
        configComponent: DwRouteActionExternalLinkConfigComponent,
        allowOnce: false,
        configData: {
            // Use this for grid row actions since this could be used in multiple contexts
            singleRowAction: true
        }
    }),
    __metadata$X("design:paramtypes", [DwRouteActionHelperService,
        DwRoutingService])
], DwRouteActionExternalLinkService);

class DwItemRouteConfigComponent extends DwRouteBaseConfigComponent {
    constructor() {
        super(...arguments);
        this.formTypes = [];
    }
    get listRouteSubType() {
        return this.routeConfigFG.get('listRouteSubType');
    }
    setupForm() {
        this.addControl('configKeyPart');
        this.addControl('formType', Validators.required);
        super.setupForm();
        this.addControl('formType', Validators.required);
        this.addControl('replaceSideMenu');
        this.addControl('hideReplaceSideMenuBackButton');
        this.addControl('sideMenuComponent');
        this.addControl('includeInGroup');
        this.addControl('groupDisplay');
        this.setupFormTypes();
    }
    setupFormTypes() {
        this.formTypes = [];
        this.addFormType(DwMenuActionType.add);
        this.addFormType(DwMenuActionType.edit);
        this.addFormType(DwMenuActionType.print);
        this.addFormType(DwMenuActionType.view);
    }
    addFormType(menuActionType) {
        this.formTypes.push({
            display: getMenuActionTypeDisplay(menuActionType),
            key: menuActionType
        });
    }
}
DwItemRouteConfigComponent.ɵfac = function DwItemRouteConfigComponent_Factory(t) { return ɵDwItemRouteConfigComponent_BaseFactory(t || DwItemRouteConfigComponent); };
DwItemRouteConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwItemRouteConfigComponent, selectors: [["dw-item-route-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["title", "Shows global components which have the DwComponent decorator and a component type of Page", 1, "fas", "fa-info-circle"], ["formControlName", "componentOverride", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "formType", 1, "form-control"], ["type", "text", "formControlName", "configKeyPart", 1, "form-control"], ["dwCol", "9"], ["title", "Use this menu's children as the side menu", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "replaceSideMenu"], [4, "ngIf"], ["title", "Groups menus based on a Group Display on any submenus", 1, "fa", "fa-info-circle"], ["formControlName", "includeInGroup"], ["dwRow", "", 4, "ngIf"], ["title", "Overides the menu display and only shows components of type Menu Component", 1, "fas", "fa-info-circle"], ["formControlName", "menuComponentOverride", 1, "form-control"], ["title", "Hide the back button in the replacement menu", 1, "fa", "fa-info-circle"], ["formControlName", "hideReplaceSideMenuBackButton"], ["title", "Replaces the standard side replacement menu with a custom component", 1, "fas", "fa-info-circle"], ["formControlName", "sideMenuComponent", 1, "form-control"], ["type", "text", "formControlName", "groupDisplay", 1, "form-control"], [3, "component", "config", "configChange"]], template: function DwItemRouteConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwItemRouteConfigComponent_div_0_Template, 47, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, DwUiChildConfigHostComponent], encapsulation: 2 });

var __decorate$1g = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwItemRouteProcessor = class DwItemRouteProcessor extends DwRouteTypeProcessorBase {
    getDefaultComponent(routeEntity, routeConfig) {
        return DwDefaultFormPage;
    }
    customizeRoute(route, routeEntity, routeConfig) {
        const itemName = routeEntity.UniqueItemName;
        let editItemName = itemName;
        const baseMenuData = route.data;
        // Add additional menu properties
        baseMenuData.metaDataItem = itemName,
            baseMenuData.metaDataActionType = routeConfig.formType;
        baseMenuData.configKeyPart = routeConfig.configKeyPart;
        baseMenuData.replaceSideMenu = routeConfig.replaceSideMenu;
        baseMenuData.hideReplaceSideMenuBackButton = routeConfig.hideReplaceSideMenuBackButton;
        baseMenuData.sideMenuComponent = routeConfig.sideMenuComponent;
        baseMenuData.childListMenuOptions = routeConfig.childListMenuOptions;
        baseMenuData.includeInGroup = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.includeInGroup;
        baseMenuData.groupDisplay = routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.groupDisplay;
        return route;
    }
};
DwItemRouteProcessor.ɵfac = function DwItemRouteProcessor_Factory(t) { return ɵDwItemRouteProcessor_BaseFactory(t || DwItemRouteProcessor); };
DwItemRouteProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwItemRouteProcessor, factory: function (t) { return DwItemRouteProcessor.ɵfac(t); } });
DwItemRouteProcessor = __decorate$1g([
    DwRouteTypeProcessor({
        keyName: 'ItemRouteProcessor',
        display: 'Item Route Processor',
        configTabDisplay: 'Item Form Page Settings',
        configComponent: DwItemRouteConfigComponent,
        routeTypeId: DwDynamicRouteType.formPage,
        defaultRouteTypeConfig: {
            formType: DwMenuActionType.add
        },
        usesMetaDataItem: true
    })
], DwItemRouteProcessor);

class DwMetadataGridActionsRowConfigComponent extends DwChildConfigBaseComponent {
    // attributes: DwMdAttribute[] = [];
    // primeAttributes: SelectItem[];
    constructor() {
        super();
    }
    getDefaultConfig() {
        return {
            rowClickOptions: {},
            rowDoubleClickOptions: {}
        };
    }
    setRowClick(value) {
        this.config.rowClickOptions = this.config.rowClickOptions || {};
        this.config.rowClickOptions.triggerOnClick = value;
        this.onChange();
    }
    setRowDoubleClick(value) {
        this.config.rowDoubleClickOptions = this.config.rowDoubleClickOptions || {};
        this.config.rowDoubleClickOptions.triggerOnClick = value;
        this.onChange();
    }
}
DwMetadataGridActionsRowConfigComponent.ɵfac = function DwMetadataGridActionsRowConfigComponent_Factory(t) { return new (t || DwMetadataGridActionsRowConfigComponent)(); };
DwMetadataGridActionsRowConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataGridActionsRowConfigComponent, selectors: [["dw-dw-metadata-grid-actions-row-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 4, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [1, "radio-container"]], template: function DwMetadataGridActionsRowConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4, "Trigger on row click");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 2);
        ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_Template_p_inputSwitch_ngModelChange_6_listener($event) { return ctx.setRowClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DwMetadataGridActionsRowConfigComponent_div_7_Template, 14, 3, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 0);
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Trigger on row double-click");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelementStart(13, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataGridActionsRowConfigComponent_Template_p_inputSwitch_ngModelChange_13_listener($event) { return ctx.setRowDoubleClick($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DwMetadataGridActionsRowConfigComponent_div_14_Template, 14, 3, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.rowClickOptions == null ? null : ctx.config.rowClickOptions.triggerOnClick);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.rowClickOptions == null ? null : ctx.config.rowClickOptions.triggerOnClick);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.rowDoubleClickOptions == null ? null : ctx.config.rowDoubleClickOptions.triggerOnClick);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.rowDoubleClickOptions == null ? null : ctx.config.rowDoubleClickOptions.triggerOnClick);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc3.CheckboxControlValueAccessor], styles: [""] });
DwMetadataGridActionsRowConfigComponent.ctorParameters = () => [];

class DwMetadataGridActionsConfigComponent {
    constructor() {
        this.actionPreferenceByModeChange = new EventEmitter();
        this.inlineEditEnabled = true;
        this.actionConfigPreferencesByMode = {};
    }
    ngOnInit() {
        this.setupActionModes();
    }
    onChange() {
        this.actionPreferenceByModeChange.emit(this.actionPreferencesByMode);
    }
    ngOnChanges(changes) {
        this.setupActionModes();
    }
    setupActionModes() {
        this.actionModes = getGridActionModes(this.inlineEditEnabled);
        this.actionConfigPreferencesByMode[DwGridActionLocation.rowButton] = {
            additionalConfigComponent: DwMetadataGridActionsRowConfigComponent,
            test: 'test'
        };
    }
}
DwMetadataGridActionsConfigComponent.ɵfac = function DwMetadataGridActionsConfigComponent_Factory(t) { return new (t || DwMetadataGridActionsConfigComponent)(); };
DwMetadataGridActionsConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataGridActionsConfigComponent, selectors: [["dw-metadata-grid-actions-config"]], inputs: { inlineEditEnabled: "inlineEditEnabled", configContext: "configContext", actionPreferencesByMode: "actionPreferencesByMode" }, outputs: { actionPreferenceByModeChange: "actionPreferenceByModeChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 4, consts: [[3, "configContext", "actionModes", "actionPreferencesByMode", "actionConfigPreferencesByMode", "actionPreferencesByModeChange", "actionPreferenceByModeChange"]], template: function DwMetadataGridActionsConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-action-group-modes-config", 0);
        ɵngcc0.ɵɵlistener("actionPreferencesByModeChange", function DwMetadataGridActionsConfigComponent_Template_dw_action_group_modes_config_actionPreferencesByModeChange_0_listener($event) { return ctx.actionPreferencesByMode = $event; })("actionPreferenceByModeChange", function DwMetadataGridActionsConfigComponent_Template_dw_action_group_modes_config_actionPreferenceByModeChange_0_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("configContext", ctx.configContext)("actionModes", ctx.actionModes)("actionPreferencesByMode", ctx.actionPreferencesByMode)("actionConfigPreferencesByMode", ctx.actionConfigPreferencesByMode);
    } }, directives: [DwActionGroupModesConfigComponent], encapsulation: 2 });
DwMetadataGridActionsConfigComponent.propDecorators = {
    configContext: [{ type: Input }],
    actionPreferencesByMode: [{ type: Input }],
    actionPreferenceByModeChange: [{ type: Output }],
    inlineEditEnabled: [{ type: Input }]
};

var DwMdDataActionType;
(function (DwMdDataActionType) {
    DwMdDataActionType["create"] = "create";
    DwMdDataActionType["update"] = "update";
    DwMdDataActionType["delete"] = "delete";
})(DwMdDataActionType || (DwMdDataActionType = {}));

class DwMetaDataGridNavigationService {
    constructor(metaDataRoutingService, route, dwOrmDataService, dwModalService, dwMessageService) {
        this.metaDataRoutingService = metaDataRoutingService;
        this.route = route;
        this.dwOrmDataService = dwOrmDataService;
        this.dwModalService = dwModalService;
        this.dwMessageService = dwMessageService;
    }
    openAddEditView(data, actionType, mdGridApi, windowOpenOptions) {
        if (mdGridApi.gridConfig.useModal) {
            this.openAddEditViewModal(data, actionType, mdGridApi);
        }
        else {
            this.openAddEditViewPage(data, actionType, mdGridApi, windowOpenOptions);
        }
    }
    openAddEditViewPage(data, actionType, mdGridApi, windowOpenOptions) {
        switch (actionType) {
            case DwMenuActionType.add:
                this.metaDataRoutingService.routeToAdd(this.route, mdGridApi.item, windowOpenOptions);
                break;
            case DwMenuActionType.edit:
            case DwMenuActionType.view:
            case DwMenuActionType.print:
                this.metaDataRoutingService.routeToEditView(this.route, mdGridApi.item, data, actionType, windowOpenOptions);
                break;
        }
    }
    openAddEditViewModal(data, actionType, mdGridApi) {
        const dataSource = mdGridApi.gridConfig.passCurrentDataSource ? mdGridApi.data : null;
        const keyValue = this.dwOrmDataService.getKeyValue(data);
        this.metaDataRoutingService.openAddEditViewModal(actionType, mdGridApi.item, keyValue, mdGridApi.addContext, dataSource, mdGridApi.gridConfig.configKeyPart)
            .subscribe(result => {
            if (!result.cancelled) {
                if (mdGridApi.data && mdGridApi.data.updateCacheItem) {
                    mdGridApi.data.updateCachedItem(result.data);
                }
                mdGridApi.refreshDataSource();
            }
        });
    }
    // let modalConfig = new DwModalConfig();
    // modalConfig.allowFullScreen = true;
    // modalConfig.cloneData = false;
    // modalConfig.modalSize = DwModalSize.large;
    // modalConfig.data = {
    //     keyValue: this.dwOrmDataService.getKeyValue(data),
    //     item: mdGridApi.item,
    //     addContext: mdGridApi.addContext,
    //     dataSource: mdGridApi.gridConfig.passCurrentDataSource ? mdGridApi.data : null,
    //     actionType: actionType,
    //     configKeyPart: mdGridApi.gridConfig.configKeyPart
    // } 
    // modalConfig.component = DwDefaultFormPage;
    // const displayName = mdGridApi.gridConfig.itemDisplayName;
    // switch (actionType) {
    //     case DwMenuActionType.add:
    //         modalConfig.title = `Add ${displayName}`;
    //         modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel;
    //         break;
    //     case DwMenuActionType.edit:
    //         modalConfig.title = `Edit ${displayName}`;
    //         modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel;
    //         break;
    //     case DwMenuActionType.view:
    //         modalConfig.title = `View ${displayName}`;
    //         modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];
    //         break;
    //     case DwMenuActionType.print:
    //         modalConfig.title = `Print ${displayName}`;
    //         modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];
    //         break;
    // }
    // this.dwModalService.showModal(modalConfig)
    //     .subscribe(result => {
    //         if (!result.cancelled) {
    //             if (mdGridApi.data && mdGridApi.data.updateCacheItem) {
    //                 mdGridApi.data.updateCachedItem(result.data);
    //             }
    //             mdGridApi.refreshDataSource();
    //         }
    //     });
    // }
    /**
     * Handles deleting one or more items from the grid
     */
    delete(data, mdGridApi, showDialog = true) {
        let confirmOb = of(true);
        if (showDialog) {
            confirmOb = this.dwModalService.showDialog(mdGridApi.gridConfig.deleteConfirmTitle, mdGridApi.gridConfig.deleteConfirmMessage)
                .pipe(map(result => {
                return result.buttonCommand == DwButtonCommand.yes;
            }));
        }
        return confirmOb.pipe(mergeMap(confirmed => {
            const actionResult = {
                success: true
            };
            if (!confirmed || !mdGridApi.data || !mdGridApi.data.deleteItem) {
                actionResult.cancelled = true;
                return of(actionResult);
            }
            const dataSource = mdGridApi.data;
            let ob;
            if (Array.isArray(data)) {
                ob = dataSource.deleteItems(data, null, false);
            }
            else {
                ob = dataSource.deleteItem(data, null, false);
            }
            return ob
                .pipe(map(dataResult => {
                if (dataResult && dataSource.updateCachedItem) {
                    dataSource.updateCachedItem(dataResult.data);
                }
                let keyName;
                let keys;
                if (Array.isArray(data)) {
                    keyName = data[0]._keyName;
                    keys = data.map(item => item[keyName]);
                }
                else {
                    keyName = data._keyName;
                    keys = [data[keyName]];
                }
                actionResult.dataActionResult = {
                    itemName: mdGridApi.item,
                    keyName: keyName,
                    actionType: DwMdDataActionType.delete,
                    keysEffected: keys,
                };
                actionResult.refreshData = true;
                return actionResult;
            }, catchError((error, caught) => {
                actionResult.success = false;
                actionResult.message = {
                    severity: DwMessageSeverity.error,
                    messageBody: 'Could not delete the item, please ensure that it is not referenced by other items',
                    timeToShow: 10
                };
                // Hide this once we're showing the action result message
                this.dwMessageService.showMessage({
                    messageHeading: 'Error deleting item!',
                    messageBody: 'Could not delete the item, please ensure that it is not referenced by other items',
                    allowClose: true,
                    severity: DwMessageSeverity.error,
                });
                return of(actionResult);
            })));
        }));
    }
}
DwMetaDataGridNavigationService.ɵfac = function DwMetaDataGridNavigationService_Factory(t) { return new (t || DwMetaDataGridNavigationService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingService), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwMessagingService)); };
DwMetaDataGridNavigationService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataGridNavigationService_Factory() { return new DwMetaDataGridNavigationService(ɵɵinject(DwMetaDataRoutingService), ɵɵinject(ActivatedRoute), ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwModalService), ɵɵinject(DwMessagingService)); }, token: DwMetaDataGridNavigationService, providedIn: "root" });
DwMetaDataGridNavigationService.ctorParameters = () => [
    { type: DwMetaDataRoutingService },
    { type: ActivatedRoute },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwModalService },
    { type: DwMessagingService }
];

var __decorate$1h = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Y = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridAddActionService = class DwGridAddActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        const windowOpenOptions = getActionWindowOpenOptions(actionState);
        this.metaDataGridNavigationService.openAddEditView(null, DwMenuActionType.add, actionState.metaDataGridApi, windowOpenOptions);
        return of({
            success: true,
        });
    }
};
DwGridAddActionService.ɵfac = function DwGridAddActionService_Factory(t) { return new (t || DwGridAddActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridAddActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridAddActionService, factory: function (t) { return DwGridAddActionService.ɵfac(t); } });
DwGridAddActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridAddActionService = __decorate$1h([
    DwAction({
        keyName: DwGridActionKeys.gridAdd,
        display: 'Add',
        actionType: DwActionType.gridAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-add',
            buttonTitle: 'Add',
            buttonType: DwButtonType.standard,
        },
        defaultMenuConfig: {
            useMenuDefaults: true,
            useParentDisplay: true,
        },
        defaultSecurityConfig: {
            requireCanCreate: true,
        }
    }),
    __metadata$Y("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridAddActionService);

class DwGridEditConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.attributes = [];
    }
    addControls() {
        this.addControl('openInNewWindow');
        this.addControl('newWindowTarget');
        this.addControl('hideViewButton');
    }
}
DwGridEditConfigComponent.ɵfac = function DwGridEditConfigComponent_Factory(t) { return new (t || DwGridEditConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridEditConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridEditConfigComponent, selectors: [["dw-grid-edit-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "openInNewWindow"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["type", "text", "formControlName", "newWindowTarget", 1, "form-control"], ["title", "Hides the edit button when the current user doesn't have edit permissions instead of converting it to the view button", 1, "fa", "fa-info-circle"], ["formControlName", "hideViewButton"]], template: function DwGridEditConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridEditConfigComponent_div_0_Template, 19, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor], encapsulation: 2 });
DwGridEditConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1i = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$Z = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridEditActionService = class DwGridEditActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        const windowOpenOptions = getActionWindowOpenOptions(actionState);
        this.metaDataGridNavigationService.openAddEditView(actionState.data, DwMenuActionType.edit, actionState.metaDataGridApi, windowOpenOptions);
        return of({
            success: true,
        });
    }
};
DwGridEditActionService.ɵfac = function DwGridEditActionService_Factory(t) { return new (t || DwGridEditActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridEditActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridEditActionService, factory: function (t) { return DwGridEditActionService.ɵfac(t); } });
DwGridEditActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridEditActionService = __decorate$1i([
    DwAction({
        keyName: DwGridActionKeys.gridEdit,
        display: 'Edit',
        actionType: DwActionType.gridRowAction,
        configComponent: DwGridEditConfigComponent,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            iconClass: 'dw-icon-edit-grid',
            buttonTitle: 'Edit',
            buttonType: DwButtonType.iconOnlyNoText,
        },
        defaultMenuConfig: {
            useParentDisplay: true,
            menuIconClass: 'dw-icon-edit-grid',
            itemRequirement: DwActionItemRequirement.single
        },
        defaultSecurityConfig: {
            requireCanUpdate: true
        }
    }),
    __metadata$Z("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridEditActionService);

class DwGridActionNavConfigComponent extends DwActionConfigBaseComponent {
    addControls() {
        this.addControl('openInNewWindow');
        this.addControl('newWindowTarget');
    }
}
DwGridActionNavConfigComponent.ɵfac = function DwGridActionNavConfigComponent_Factory(t) { return ɵDwGridActionNavConfigComponent_BaseFactory(t || DwGridActionNavConfigComponent); };
DwGridActionNavConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridActionNavConfigComponent, selectors: [["dw-grid-action-nav-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "openInNewWindow"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["type", "text", "formControlName", "newWindowTarget", 1, "form-control"]], template: function DwGridActionNavConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridActionNavConfigComponent_div_0_Template, 12, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor], encapsulation: 2 });

var __decorate$1j = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$_ = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridViewActionService = class DwGridViewActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        const windowOpenOptions = getActionWindowOpenOptions(actionState);
        this.metaDataGridNavigationService.openAddEditView(actionState.event.eventData, DwMenuActionType.view, actionState.metaDataGridApi, windowOpenOptions);
        return of({
            success: true,
        });
    }
};
DwGridViewActionService.ɵfac = function DwGridViewActionService_Factory(t) { return new (t || DwGridViewActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridViewActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridViewActionService, factory: function (t) { return DwGridViewActionService.ɵfac(t); } });
DwGridViewActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridViewActionService = __decorate$1j([
    DwAction({
        keyName: DwGridActionKeys.gridView,
        display: 'View',
        actionType: DwActionType.gridRowAction,
        configComponent: DwGridActionNavConfigComponent,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            iconClass: 'dw-icon-view-grid',
            buttonTitle: 'View',
            buttonType: DwButtonType.iconOnlyNoText,
        },
        defaultMenuConfig: {
            useParentDisplay: true,
            menuIconClass: 'dw-icon-view-grid',
            itemRequirement: DwActionItemRequirement.single
        }
    }),
    __metadata$_("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridViewActionService);

var __decorate$1k = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$$ = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridPrintActionSerivce = class DwGridPrintActionSerivce {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        this.metaDataGridNavigationService.openAddEditView(actionState.data, DwMenuActionType.print, actionState.metaDataGridApi);
        return of({
            success: true,
        });
    }
};
DwGridPrintActionSerivce.ɵfac = function DwGridPrintActionSerivce_Factory(t) { return new (t || DwGridPrintActionSerivce)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridPrintActionSerivce.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridPrintActionSerivce, factory: function (t) { return DwGridPrintActionSerivce.ɵfac(t); } });
DwGridPrintActionSerivce.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridPrintActionSerivce = __decorate$1k([
    DwAction({
        keyName: DwGridActionKeys.gridPrint,
        display: 'Print',
        actionType: DwActionType.gridRowAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            iconClass: 'dw-icon-print-grid',
            buttonType: DwButtonType.iconOnlyNoText,
        },
        defaultMenuConfig: {
            useParentDisplay: true,
            menuIconClass: 'dw-icon-print-grid',
            itemRequirement: DwActionItemRequirement.single
        }
    }),
    __metadata$$("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridPrintActionSerivce);

var __decorate$1l = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$10 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridDeleteActionService = class DwGridDeleteActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        return this.metaDataGridNavigationService.delete(actionState.data, actionState.metaDataGridApi, false)
            .pipe(catchError((err, caught) => {
            //console.warn(err);
            const actionResult = {
                success: false,
                message: {
                    severity: DwMessageSeverity.error,
                    messageBody: 'Could not delete the item, please ensure that it is not referenced by other items',
                    timeToShow: 5000
                }
            };
            return of(actionResult);
        }));
    }
};
DwGridDeleteActionService.ɵfac = function DwGridDeleteActionService_Factory(t) { return new (t || DwGridDeleteActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridDeleteActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridDeleteActionService, factory: function (t) { return DwGridDeleteActionService.ɵfac(t); } });
DwGridDeleteActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridDeleteActionService = __decorate$1l([
    DwAction({
        keyName: DwGridActionKeys.gridDelete,
        display: 'Delete',
        actionType: DwActionType.gridRowAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonTitle: 'Delete',
            iconClass: 'dw-icon-delete-grid',
            buttonType: DwButtonType.iconOnlyNoText,
        },
        defaultMenuConfig: {
            useParentDisplay: true,
            menuIconClass: 'dw-icon-delete-grid',
            itemRequirement: DwActionItemRequirement.single
        },
        defaultSecurityConfig: {
            requireCanDelete: true
        },
        defaultConfirmConfig: {
            showDialogConfig: true,
            showConfirmDialog: true,
            title: 'Delete Item?',
            message: 'Deleting an item cannot be undone.  Are you sure you want to delete it?'
        }
    }),
    DwAction({
        keyName: DwGridActionKeys.gridDeleteMulti,
        display: 'Delete Multiple',
        actionType: DwActionType.gridContextMenuAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            iconClass: 'dw-icon-delete-grid',
            buttonType: DwButtonType.iconOnlyNoText,
        },
        defaultMenuConfig: {
            useParentDisplay: true,
            menuIconClass: 'dw-icon-delete-grid',
            itemRequirement: DwActionItemRequirement.multiple
        },
        defaultSecurityConfig: {
            requireCanDelete: true
        },
        defaultConfirmConfig: {
            showDialogConfig: true,
            showConfirmDialog: true,
            title: 'Delete Items?',
            message: 'Deleting an item cannot be undone.  Are you sure you want to delete the selected items?'
        }
    }),
    __metadata$10("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridDeleteActionService);

var __decorate$1m = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$11 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridRefreshActionService = class DwGridRefreshActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        actionState.metaDataGridApi.refreshDataSource(true);
        return of({
            success: true,
        });
    }
};
DwGridRefreshActionService.ɵfac = function DwGridRefreshActionService_Factory(t) { return new (t || DwGridRefreshActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridRefreshActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridRefreshActionService, factory: function (t) { return DwGridRefreshActionService.ɵfac(t); } });
DwGridRefreshActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridRefreshActionService = __decorate$1m([
    DwAction({
        keyName: DwGridActionKeys.gridRefresh,
        display: 'Refresh',
        actionType: DwActionType.gridAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonText: '',
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-refresh',
            command: 'refresh',
            buttonType: DwButtonType.standard,
            buttonTitle: 'Refresh',
        },
    }),
    __metadata$11("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridRefreshActionService);

var __decorate$1n = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$12 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridFilterToggleActionService = class DwGridFilterToggleActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        actionState.metaDataGridApi.toggleFilters();
        return of({
            success: true,
        });
    }
};
DwGridFilterToggleActionService.ɵfac = function DwGridFilterToggleActionService_Factory(t) { return new (t || DwGridFilterToggleActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridFilterToggleActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridFilterToggleActionService, factory: function (t) { return DwGridFilterToggleActionService.ɵfac(t); } });
DwGridFilterToggleActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
DwGridFilterToggleActionService = __decorate$1n([
    DwAction({
        keyName: DwGridActionKeys.gridFilterToggle,
        display: 'Filter Toggle',
        actionType: DwActionType.gridAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonText: '',
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-filter',
            command: 'filter',
            buttonType: DwButtonType.standard,
            buttonTitle: 'Toggle Filters',
        },
    }),
    __metadata$12("design:paramtypes", [DwMetaDataGridNavigationService])
], DwGridFilterToggleActionService);

class DwExportService {
    constructor(dwOrmDataService) {
        this.dwOrmDataService = dwOrmDataService;
    }
    exportData(exportConfig, exportQuery) {
        const columnOptions = this.buildExportColumnOptions(exportConfig);
        return this.dwOrmDataService.exportQuery(exportQuery, exportConfig.exportFileName, columnOptions, exportConfig.exportSortableDates);
    }
    buildExportColumnOptions(exportConfig) {
        const columnOptions = [];
        for (const exportColumn of exportConfig.exportColumns) {
            columnOptions.push({
                AttributeName: exportColumn.attr,
                CaptionOverride: exportColumn.captionOverride
            });
        }
        return columnOptions;
    }
}
DwExportService.ɵfac = function DwExportService_Factory(t) { return new (t || DwExportService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken)); };
DwExportService.ɵprov = ɵɵdefineInjectable({ factory: function DwExportService_Factory() { return new DwExportService(ɵɵinject(DwOrmDataServiceToken)); }, token: DwExportService, providedIn: "root" });
DwExportService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] }
];

var __decorate$1o = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$13 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridExportActionService = class DwGridExportActionService {
    constructor(dwExportService) {
        this.dwExportService = dwExportService;
    }
    handleAction(actionState) {
        const viewPref = actionState.gridConfig.selectedView.gridViewPreferences;
        let exportConfig = viewPref.exportConfig;
        let fileName = `${actionState.gridConfig.itemDisplayName} export`;
        if (!viewPref.useCustomExport) {
            exportConfig = this.buildExportConfig(actionState.gridConfig, fileName);
        }
        if (!exportConfig.exportFileName) {
            exportConfig.exportFileName = fileName;
        }
        // Build the export query
        const exportQuery = this.buildExportQuery(actionState, exportConfig);
        return this.dwExportService.exportData(exportConfig, exportQuery)
            .pipe(map(result => {
            return {
                success: true,
            };
        }));
    }
    buildExportQuery(actionState, exportConfig) {
        const dataSource = actionState.metaDataGridApi.data;
        if (!dataSource.getCurrentQuery) {
            return;
        }
        // Get the export query with the filters/sorting of the data source
        const exportQuery = deepCopy(dataSource.getCurrentQuery(actionState.gridConfig.selectedView.exportQuery));
        var queryBuilder = new DwQueryBuilder(exportQuery);
        // Don't include all root fields
        queryBuilder.getFieldSettings().IncludeRootItemFields = false;
        // Clear all fields including relations
        const existingFields = queryBuilder.clearAllFields();
        // Add all fields included in the export config
        queryBuilder.AddFields(this.buildQueryFieldList(actionState.gridConfig, exportConfig, existingFields));
        return exportQuery;
    }
    buildQueryFieldList(gridConfig, exportConfig, existingFields) {
        var _a, _b;
        const includeFieldList = [];
        const missingFields = [];
        for (let columnConfig of exportConfig.exportColumns) {
            const queryAttr = (_b = (_a = gridConfig.queryMetaData) === null || _a === void 0 ? void 0 : _a.Attributes) === null || _b === void 0 ? void 0 : _b.find(a => { var _a, _b, _c, _d; return ((_a = a.AttributeName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.attr) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = a.DisplayAttributeName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == ((_d = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.attr) === null || _d === void 0 ? void 0 : _d.toUpperCase()); });
            let field = existingFields.find(f => { var _a, _b, _c, _d; return ((_a = f.FieldName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.attr) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = f.FieldAlias) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == ((_d = columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.attr) === null || _d === void 0 ? void 0 : _d.toUpperCase()); });
            if (!field) {
                field = new DwField();
                field.FullFieldName = columnConfig.attr;
            }
            // Don't include fields that don't match an attribute
            if (queryAttr) {
                if (field.FieldType == DwFieldType.Standard) {
                    field.FullFieldName = queryAttr.AttributeName;
                }
                field.RelationName = queryAttr.RelationPrefix;
                includeFieldList.push(field);
            }
            else {
                missingFields.push(columnConfig.attr);
            }
        }
        if (missingFields.length > 0) {
            console.warn(`Export configuration contains missing columns - ${missingFields.join(', ')}`);
        }
        return includeFieldList;
    }
    /**
     * Builds the default export config if it's not overriden
     * @param gridConfig
     */
    buildExportConfig(gridConfig, fileName) {
        var _a, _b;
        const exportConfig = {
            exportFileName: fileName,
            exportColumns: [],
        };
        const viewPref = gridConfig.selectedView.gridViewPreferences;
        // Switch to use view preferences so we get column header overrides
        for (const columnPref of viewPref.columnPreferences) {
            let label = columnPref.label;
            const queryAttr = (_b = (_a = gridConfig.queryMetaData) === null || _a === void 0 ? void 0 : _a.Attributes) === null || _b === void 0 ? void 0 : _b.find(a => { var _a, _b, _c, _d; return ((_a = a.AttributeName) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === ((_b = columnPref === null || columnPref === void 0 ? void 0 : columnPref.field) === null || _b === void 0 ? void 0 : _b.toUpperCase()) || ((_c = a.DisplayAttributeName) === null || _c === void 0 ? void 0 : _c.toUpperCase()) == ((_d = columnPref.field) === null || _d === void 0 ? void 0 : _d.toUpperCase()); });
            if (!label && queryAttr) {
                label = queryAttr === null || queryAttr === void 0 ? void 0 : queryAttr.AttributeDisplay;
            }
            if (label) {
                const columnConfig = {
                    attr: columnPref.field,
                    captionOverride: label
                };
                exportConfig.exportColumns.push(columnConfig);
            }
        }
        // No longer using this because queries with devired columns don't have a header and are removed. (this was the case for Permit due date)
        // for(const columnDef of gridConfig.columnDefs) {
        //     if (columnDef.headerName?.trim()) {
        //         const columnConfig: DwExportColumnConfig = {
        //             attr : columnDef.field,
        //             captionOverride : columnDef.headerName
        //         };
        //         exportConfig.exportColumns.push(columnConfig);
        //     }
        // }
        if (!gridConfig.selectedView.exportOnlyDisplayedColumns) {
            // we need to add all remaining columns
            for (const attr of gridConfig.queryMetaData.Attributes) {
                const existingOption = exportConfig.exportColumns.find(co => co.attr == attr.DisplayAttributeName);
                if (!existingOption) {
                    const columnConfig = {
                        attr: attr.DisplayAttributeName,
                        captionOverride: attr.AttributeDisplay
                    };
                    exportConfig.exportColumns.push(columnConfig);
                }
            }
        }
        return exportConfig;
    }
};
DwGridExportActionService.ɵfac = function DwGridExportActionService_Factory(t) { return new (t || DwGridExportActionService)(ɵngcc0.ɵɵinject(DwExportService)); };
DwGridExportActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridExportActionService, factory: function (t) { return DwGridExportActionService.ɵfac(t); } });
DwGridExportActionService.ctorParameters = () => [
    { type: DwExportService }
];
DwGridExportActionService = __decorate$1o([
    DwAction({
        keyName: DwGridActionKeys.gridExport,
        display: 'Export',
        actionType: DwActionType.gridAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonText: '',
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-export',
            command: 'Export',
            buttonType: DwButtonType.standard,
            buttonTitle: 'Export',
        },
    }),
    __metadata$13("design:paramtypes", [DwExportService])
], DwGridExportActionService);

class DwGridSetValueActionConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.attributes = [];
    }
    addControls() {
        this.addControl('itemName', Validators.required, this.configContext.itemName);
        this.addControl('attrName', Validators.required);
        this.addControl('refreshFullGrid');
        this.setupMetaData();
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes.filter(a => a.IsLookup || a.AttributeType == DwAttributeType.YesNo);
        });
    }
}
DwGridSetValueActionConfigComponent.ɵfac = function DwGridSetValueActionConfigComponent_Factory(t) { return new (t || DwGridSetValueActionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridSetValueActionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridSetValueActionConfigComponent, selectors: [["dw-grid-set-value-action-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["formControlName", "attrName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "refreshFullGrid"], [3, "ngValue"]], template: function DwGridSetValueActionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridSetValueActionConfigComponent_div_0_Template, 13, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwGridSetValueActionConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1p = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$14 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridSetValueActionService = class DwGridSetValueActionService {
    constructor(metaDataService, ormDataService, loggingService) {
        this.metaDataService = metaDataService;
        this.ormDataService = ormDataService;
        this.loggingService = loggingService;
    }
    handleAction(actionState) {
        const { actionConfig, event } = actionState;
        const newValue = event.additionalData;
        const dataToUpdate = actionState.data;
        // Update data
        return this.ormDataService.updateAttributeValue(dataToUpdate, actionConfig.attrName, newValue)
            .pipe(map(dataItems => {
            const keyName = dataItems && dataItems.length > 0 ? dataItems[0]._keyName : '';
            const result = {
                success: true,
                refreshData: actionConfig.refreshFullGrid,
                dataActionResult: {
                    itemName: actionState.metaDataGridApi.item,
                    keyName: keyName,
                    actionType: DwMdDataActionType.update,
                    keysEffected: dataItems.map(dataItem => dataItem[keyName])
                }
            };
            return result;
        }));
    }
    buildContextMenu(menuBuilderState) {
        const { actionPreference, actionConfig } = menuBuilderState;
        const menuConfig = menuBuilderState.actionPreference.menuConfig;
        const subActionFunc = (event, value) => {
            menuBuilderState.actionFunc(actionPreference, event, value);
        };
        return this.buildMenuValues(actionPreference, subActionFunc)
            .pipe(map(subMenus => {
            const menu = {
                label: menuConfig.menuDisplay,
                icon: menuConfig.menuIconClass,
                items: subMenus
            };
            const menuBuilderResult = {
                actionPreference: actionPreference,
                menu: menu,
                success: true
            };
            return menuBuilderResult;
        }));
    }
    buildMenuValues(actionPreference, subActionFunc) {
        const actionConfig = actionPreference.actionConfig || {};
        if (!actionConfig.itemName) {
            this.loggingService.logWarning(`Action ${actionPreference.actionDisplay} is missing an Item so the context menu could not be built`);
            return of(null);
        }
        return this.metaDataService.getMetaData(actionConfig.itemName)
            .pipe(mergeMap(itemMd => {
            const attrMd = itemMd.Attributes.find(a => a.AttributeName == actionConfig.attrName);
            if (!attrMd) {
                this.loggingService.logWarning(`Action ${actionPreference.actionDisplay} for item ${itemMd.Display} - Could not find attribute ${actionConfig.attrName}`);
                return of(null);
            }
            switch (attrMd.AttributeType) {
                case DwAttributeType.YesNo:
                    return this.buildBoolMenu(actionConfig, subActionFunc);
                default:
                    if (attrMd.IsLookup) {
                        return this.buildLookupMenu(actionConfig, subActionFunc, attrMd);
                    }
            }
            this.loggingService.logWarning(`Action ${actionPreference.actionDisplay} for item ${itemMd.Display} - Could build Set Value Action for attribute type of ${attrMd.AttributeType}`);
            return of(null);
        }));
    }
    buildLookupMenu(actionConfig, subActionFunc, attrMd) {
        return this.metaDataService.getLookup(attrMd.MetaDataLookupId)
            .pipe(map(lookupData => {
            let subMenus = [];
            if (!attrMd.AlwaysRequired) {
                const menu = {
                    label: 'Clear Value',
                    command: (event) => {
                        subActionFunc(event, null);
                    }
                };
                subMenus.push(menu);
                subMenus.push({
                    separator: true
                });
            }
            if (lookupData.filter(ld => ld.GroupName).length > 0) {
                const newMenus = this.buildLookupGroupMenu(lookupData, subActionFunc);
                subMenus = [...subMenus, ...newMenus];
            }
            else {
                for (const lookupInfo of lookupData) {
                    const menu = {
                        label: lookupInfo.Display,
                        command: (event) => {
                            subActionFunc(event, lookupInfo.Id);
                        }
                    };
                    subMenus.push(menu);
                }
            }
            return subMenus;
        }));
    }
    buildLookupGroupMenu(lookupItems, subActionFunc) {
        const itemGroups = [];
        let currentGroup;
        for (const lookupInfo of lookupItems) {
            if ((currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.label) !== lookupInfo.GroupName) {
                currentGroup = {
                    label: lookupInfo.GroupName,
                    items: []
                };
                itemGroups.push(currentGroup);
            }
            const menu = {
                label: lookupInfo.Display,
                command: (event) => {
                    subActionFunc(event, lookupInfo.Id);
                }
            };
            currentGroup.items.push(menu);
        }
        return itemGroups;
    }
    buildBoolMenu(actionConfig, subActionFunc) {
        const trueValue = true;
        const falseValue = false;
        const subMenus = [
            {
                label: 'Yes',
                command: (event) => {
                    subActionFunc(event, trueValue);
                }
            },
            {
                label: 'No',
                command: (event) => {
                    subActionFunc(event, falseValue);
                }
            },
        ];
        return of(subMenus);
    }
    ;
};
DwGridSetValueActionService.ɵfac = function DwGridSetValueActionService_Factory(t) { return new (t || DwGridSetValueActionService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwGridSetValueActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridSetValueActionService, factory: function (t) { return DwGridSetValueActionService.ɵfac(t); } });
DwGridSetValueActionService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwLoggingService }
];
DwGridSetValueActionService = __decorate$1p([
    DwAction({
        keyName: DwGridActionKeys.gridSetValue,
        display: 'Set value',
        actionType: DwActionType.gridContextMenuAction,
        isGlobal: true,
        allowOnce: false,
        configComponent: DwGridSetValueActionConfigComponent,
        defaultMenuConfig: {
            useParentDisplay: true,
            itemRequirement: DwActionItemRequirement.multiple,
            useCustomMenus: true,
        },
        defaultSecurityConfig: {
            requireCanUpdate: true
        }
    }),
    __metadata$14("design:paramtypes", [DwMetaDataService,
        DwOrmDataService,
        DwLoggingService])
], DwGridSetValueActionService);

class DwMetaDataRoutingHelperService {
    constructor(dwRouteRepositoryService, dwMenuService, dwMenuHelperService, dwCacheService) {
        this.dwRouteRepositoryService = dwRouteRepositoryService;
        this.dwMenuService = dwMenuService;
        this.dwMenuHelperService = dwMenuHelperService;
        this.dwCacheService = dwCacheService;
    }
    findRouteNode(menuKey, nodes, expandChain) {
        return this.findNode((node) => {
            const nodeData = node.data;
            const found = nodeData.menuKey == menuKey;
            return found;
        }, nodes);
    }
    getRouteTree() {
        const cacheOptions = {
            cacheInvalidationsTopics: [DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwRouteCategory), DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwRoute)]
        };
        return this.dwCacheService.getWithOptions('routeTree', this.loadRouteTree(), cacheOptions);
    }
    findNode(searchFunc, nodes, expandChain) {
        for (const node of nodes) {
            if (searchFunc(node)) {
                return node;
            }
            if (node.children) {
                const foundNode = this.findNode(searchFunc, node.children);
                if (foundNode) {
                    if (expandChain) {
                        node.expanded = true;
                    }
                    return foundNode;
                }
                else {
                    node.expanded = false;
                }
            }
        }
    }
    loadRouteTree() {
        return this.dwRouteRepositoryService.getRouteCategories()
            .pipe(map(categories => {
            const menuItems = this.dwMenuService.menuState.allMenuItems;
            return this.buildRouteTree(categories, menuItems);
        }));
    }
    buildRouteTree(categories, menus) {
        const rootNodes = [];
        for (const category of categories) {
            const categoryNode = this.buildCategoryNode(category, menus);
            if (categoryNode.children.length > 0) {
                rootNodes.push(categoryNode);
            }
        }
        return rootNodes;
    }
    buildCategoryNode(category, menus) {
        const categoryNode = {
            label: category.CategoryDisplay,
            selectable: false,
            data: {
                categoryMeaning: category.CategoryMeaning
            }
        };
        const currentCategory = category.CategoryMeaning.toLowerCase();
        const categoryMenus = menus.filter(menu => {
            if (!menu.display) {
                return false;
            }
            const menuCategory = (menu.data.category || defaultMenuCategory).toLowerCase();
            return menuCategory == currentCategory;
        });
        categoryNode.children = this.buildRouteNodes(categoryMenus, null);
        return categoryNode;
    }
    buildRouteNodes(menus, parentMenu) {
        const nodes = [];
        for (const menu of menus) {
            const routeNode = this.buildRouteNode(menu, parentMenu);
            if (routeNode) {
                nodes.push(routeNode);
            }
        }
        return nodes;
    }
    buildRouteNode(menu, parentMenu) {
        const routeNodeData = {
            menu: menu,
            menuKey: menu.menuKey
        };
        const routeNode = {
            label: menu.display,
            data: routeNodeData
        };
        if (menu.isActionChild && parentMenu) {
            routeNode.label = `${parentMenu.display} - ${menu.display}`;
        }
        if (menu.children) {
            routeNode.children = this.buildRouteNodes(menu.children, menu);
        }
        return routeNode;
    }
}
DwMetaDataRoutingHelperService.ɵfac = function DwMetaDataRoutingHelperService_Factory(t) { return new (t || DwMetaDataRoutingHelperService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingRepositoryService), ɵngcc0.ɵɵinject(DwMenuService), ɵngcc0.ɵɵinject(DwMenuHelperService), ɵngcc0.ɵɵinject(DwCacheService)); };
DwMetaDataRoutingHelperService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataRoutingHelperService_Factory() { return new DwMetaDataRoutingHelperService(ɵɵinject(DwMetaDataRoutingRepositoryService), ɵɵinject(DwMenuService), ɵɵinject(DwMenuHelperService), ɵɵinject(DwCacheService)); }, token: DwMetaDataRoutingHelperService, providedIn: "root" });
DwMetaDataRoutingHelperService.ctorParameters = () => [
    { type: DwMetaDataRoutingRepositoryService },
    { type: DwMenuService },
    { type: DwMenuHelperService },
    { type: DwCacheService }
];

class DwSelectRouteComponent extends DwControlBaseComponent {
    constructor(dwMetaDataService, dwEventService, dwSecurityService, cdr, dwRoutingHelperService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.dwEventService = dwEventService;
        this.dwSecurityService = dwSecurityService;
        this.cdr = cdr;
        this.dwRoutingHelperService = dwRoutingHelperService;
        this.routes = [];
    }
    ngOnInit() {
        this.setupRoutes();
    }
    ngOnChanges(simpleChanges) {
        if (simpleChanges.paramValues) {
            // Re-load the lookup anytime the param values change
            // this.loadLookup();
        }
        this.setTranslatedValue;
    }
    writeValue(value) {
        super.writeValue(value);
    }
    translateFrom(translatedValue) {
        if (!translatedValue) {
            return;
        }
        const routeData = translatedValue.data;
        return routeData.menuKey;
    }
    translateTo(value) {
        if (!this.routes || !value) {
            return;
        }
        const foundNode = this.dwRoutingHelperService.findRouteNode(value, this.routes, true);
        this.expandAllParents(foundNode);
        return foundNode;
    }
    expandAllParents(foundNode) {
        for (const node of this.routes) {
            node.expanded = false;
        }
        while (foundNode) {
            foundNode.expanded = true;
            foundNode = foundNode.parent;
        }
    }
    setupRoutes() {
        this.subscriptions.push(this.dwRoutingHelperService.getRouteTree()
            .subscribe(routeTree => {
            this.routes = routeTree;
            if (this.initialValue) {
                this.writeValue(this.initialValue);
            }
        }));
    }
}
DwSelectRouteComponent.ɵfac = function DwSelectRouteComponent_Factory(t) { return new (t || DwSelectRouteComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingHelperService)); };
DwSelectRouteComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSelectRouteComponent, selectors: [["dw-select-route"]], features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwSelectRouteComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [[3, "treeData", "selection", "selectionChange"]], template: function DwSelectRouteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-tree-select", 0);
        ɵngcc0.ɵɵlistener("selectionChange", function DwSelectRouteComponent_Template_dw_tree_select_selectionChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("treeData", ctx.routes)("selection", ctx.translatedValue);
    } }, directives: [DwTreeSelect], encapsulation: 2 });
DwSelectRouteComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwEventService },
    { type: DwSecurityUserService },
    { type: ChangeDetectorRef },
    { type: DwMetaDataRoutingHelperService }
];

class DwMetadataGridConfigColumnComponent {
    constructor(actionConfigService, uiConfigRegistryService, cdr
    /* private actionMenuBuilderService: DwActionMenuBuilderService,
     @Inject(DwUIConfigToken) private uiConfig: DwUIConfig */
    ) {
        this.actionConfigService = actionConfigService;
        this.uiConfigRegistryService = uiConfigRegistryService;
        this.cdr = cdr;
        this.columnPreferenceChange = new EventEmitter();
        this.inlineEditEnabled = true;
        this.sortDirections = [
            { value: null, display: 'None' },
            { value: 'asc', display: 'Ascending' },
            { value: 'desc', display: 'Descending' },
        ];
        this.actions = [];
        this.showActionPreference = false;
        this.showButtonConfig = false;
        this.showMenuConfig = false;
    }
    ngOnInit() {
        this.columnRendererRegistrations = this.uiConfigRegistryService.getMdRegisteredItems(DwUiRegistryType.gridColumn, this.configContext.itemName, this.isAttributeTypeMatch);
        this.allAttributes = [{ value: '', display: ' ' }, ...this.queryMetaData.Attributes.map(attr => ({ display: attr.AttributeDisplay, value: attr.DisplayAttributeName }))];
        this.setupActions();
    }
    isAttributeTypeMatch(columnRegistration) {
        if (columnRegistration.attrType) {
            return columnRegistration.attrType == this.attribute.AttributeType;
        }
        return true;
    }
    setupActions() {
        const validActionTypes = [DwActionType.gridAction, DwActionType.gridRowAction, DwActionType.menuAction];
        // Get all valid actions
        this.actions = this.actionConfigService.getActionHandlers(this.configContext.itemName, validActionTypes);
    }
    ngOnChanges(changes) {
        if (changes.columnPreference && this.columnPreference) {
            this.setupColumnPreferences();
        }
        if (changes.configContext) {
            this.setupActions();
        }
    }
    setupColumnPreferences() {
        this.cdr.markForCheck();
        if (!this.columnPreference) {
            return;
        }
        this.columnPreference.columnRendererKey = this.columnPreference.columnRendererKey || defaultGridColumnRenderer;
        this.columnPreference.actionPreference = this.columnPreference.actionPreference || {};
        this.columnPreference.securityConfig = this.columnPreference.securityConfig || {};
        //this.columnPreference.sort = this.columnPreference.sort || DwSortDirection.asc;
        this.onColumnRenderTypeChange(this.columnPreference.columnRendererKey);
    }
    onColumnsChange() {
        this.columnPreferenceChange.emit(this.columnPreference);
    }
    onActionPreferenceChange(actionPreference) {
        if (this.columnPreference) {
            this.columnPreference.actionPreference = actionPreference;
        }
    }
    onColumnRenderTypeChange(rendererKey) {
        this.currentColumnRendererRegistration = this.columnRendererRegistrations.find(columnReg => columnReg.keyName === rendererKey);
        this.onColumnsChange();
    }
}
DwMetadataGridConfigColumnComponent.ɵfac = function DwMetadataGridConfigColumnComponent_Factory(t) { return new (t || DwMetadataGridConfigColumnComponent)(ɵngcc0.ɵɵdirectiveInject(DwActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwMetadataGridConfigColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataGridConfigColumnComponent, selectors: [["dw-metadata-grid-config-column"]], inputs: { inlineEditEnabled: "inlineEditEnabled", columnPreference: "columnPreference", useColumnFlex: "useColumnFlex", attribute: "attribute", configContext: "configContext", queryMetaData: "queryMetaData" }, outputs: { columnPreferenceChange: "columnPreferenceChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["header", "Basic Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["dwCol", "9"], ["title", "Wraps the text for this column up to the row height. Row height should be set to multiples of 25px (Row height is set on styling tab on right panel config)", 1, "fa", "fa-info-circle"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"], ["ngValue", "left"], ["ngValue", "right"], ["title", "Hides the columns, but keeps it sortable", 1, "fa", "fa-info-circle"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["header", "Sizing"], ["header", "Sorting"], ["header", "Column Editing", 4, "ngIf"], ["header", "Column Security"], [3, "config", "configContext", "configChange"], ["header", "Conditional Classes"], [3, "conditionalClasses", "itemName", "contextNames", "queryMeaning", "classNames", "classLabels", "conditionalClassesChange", "conditionalClassesChange2"], ["header", "Renderer Settings", 4, "ngIf"], ["basicSettingsDisplay", "Action Settings", "showActionDisplay", "false", "selectFirstTab", "false", "showMenuConfig", "false", 3, "actionPreference", "actions", "showButtonConfig", "configContext", "actionPreferenceChange", 4, "ngIf"], ["type", "number", "DwNumeric", "", "placeholder", "1", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "number", "DwNumeric", "", "placeholder", "Default", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Can also be set by changing the column width in the grid with the config panel open", 1, "fa", "fa-info-circle"], ["type", "number", "DwNumeric", "", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [3, "values", "ngModel", "ngModelChange"], ["title", "Sort order of column - blank means not sorted, 1 - first sorted column, 2 - second sorted column", 1, "fa", "fa-info-circle"], ["optionLabel", "display", "display", "chip", "optionValue", "value", "filter", "true", "appendTo", "body", 3, "options", "ngModel", "showClear", "ngModelChange"], ["header", "Column Editing"], ["title", "Makes this column read-only when editing", 1, "fa", "fa-info-circle"], ["header", "Renderer Settings"], [3, "component", "config", "configContext", "configChange"], ["basicSettingsDisplay", "Action Settings", "showActionDisplay", "false", "selectFirstTab", "false", "showMenuConfig", "false", 3, "actionPreference", "actions", "showButtonConfig", "configContext", "actionPreferenceChange"]], template: function DwMetadataGridConfigColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataGridConfigColumnComponent_p_accordion_0_Template, 60, 30, "p-accordion", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.columnPreference);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc10.InputSwitch, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwSecurityCheckConfigComponent, DwConditionalFieldClassesComponent, ɵngcc3.NumberValueAccessor, DwRadioListComponent, ɵngcc22.Dropdown, DwUiChildConfigHostComponent, DwActionConfigComponent]; }, encapsulation: 2, changeDetection: 0 });
DwMetadataGridConfigColumnComponent.ctorParameters = () => [
    { type: DwActionConfigService },
    { type: DwUiConfigRegistryService },
    { type: ChangeDetectorRef }
];
DwMetadataGridConfigColumnComponent.propDecorators = {
    columnPreference: [{ type: Input }],
    columnPreferenceChange: [{ type: Output }],
    useColumnFlex: [{ type: Input }],
    attribute: [{ type: Input }],
    configContext: [{ type: Input }],
    inlineEditEnabled: [{ type: Input }],
    queryMetaData: [{ type: Input }]
};

var __decorate$1q = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwDateRangeFilterComponent = class DwDateRangeFilterComponent extends DwFilterItemBase {
    setupFilter() {
        this.label = this.filterConfig.label;
        this.attr = this.queryMetaData.Attributes.find(a => a.AttributeName == this.filterConfig.attr);
        if (this.attr) {
            this.label = this.filterConfig.label || this.attr.AttributeDisplay;
        }
    }
    dateRangeChanged() {
        var _a;
        switch ((_a = this.attr) === null || _a === void 0 ? void 0 : _a.AttributeType) {
            case DwAttributeType.DateTime:
                this.buildDateTimeFilter(this.startDate, this.endDate);
                break;
            case DwAttributeType.Date:
                this.buildDateOnlyFilter(this.startDate, this.endDate);
                break;
            default:
                console.warn(`Date Time Filter - can't build filter for ${this.label} because attribute type is not a Date or Date/Time`);
        }
    }
    buildDateTimeFilter(startDate, endDate) {
        if (!startDate || !endDate) {
            this.filter = null;
            return;
        }
        const gmtStartDate = formatDateTimeFromLocal(startDate, true, true);
        // adjust by one day
        const newEndDate = dateTimeAddDays(endDate, 1, true, true);
        const gmtEndDate = formatDateTimeFromLocal(newEndDate, true, true);
        const qh = new DwQueryHelper();
        const filterGroup = qh.filters.Group();
        const greaterThanFilter = qh.filters.GreaterThanEqual(this.filterConfig.attr, gmtStartDate);
        greaterThanFilter.ExactDateTimeCompare = true;
        const lessThanFilter = qh.filters.LessThan(this.filterConfig.attr, gmtEndDate);
        lessThanFilter.ExactDateTimeCompare = true;
        filterGroup.AddFilterAnd(greaterThanFilter);
        filterGroup.AddFilterAnd(lessThanFilter);
        this.filter = filterGroup;
    }
    buildDateOnlyFilter(startDate, endDate) {
        let dateFilter = {
            GreaterThanEqual: startDate,
            LessThanEqual: endDate
        };
        if (startDate == endDate) {
            // build an equals filter
            dateFilter = {
                Equal: this.startDate,
            };
        }
        const fullFilter = {};
        fullFilter[this.filterConfig.attr] = dateFilter;
        this.filter = fullFilter;
    }
};
DwDateRangeFilterComponent.ɵfac = function DwDateRangeFilterComponent_Factory(t) { return ɵDwDateRangeFilterComponent_BaseFactory(t || DwDateRangeFilterComponent); };
DwDateRangeFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDateRangeFilterComponent, selectors: [["dw-date-range-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[1, "label"], [3, "startDate", "endDate", "startDateChange", "endDateChange"]], template: function DwDateRangeFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "dw-date-range-input", 1);
        ɵngcc0.ɵɵlistener("startDateChange", function DwDateRangeFilterComponent_Template_dw_date_range_input_startDateChange_2_listener($event) { return ctx.startDate = $event; })("endDateChange", function DwDateRangeFilterComponent_Template_dw_date_range_input_endDateChange_2_listener($event) { return ctx.endDate = $event; })("startDateChange", function DwDateRangeFilterComponent_Template_dw_date_range_input_startDateChange_2_listener() { return ctx.dateRangeChanged(); })("endDateChange", function DwDateRangeFilterComponent_Template_dw_date_range_input_endDateChange_2_listener() { return ctx.dateRangeChanged(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("startDate", ctx.startDate)("endDate", ctx.endDate);
    } }, directives: [DwDateRangeInputComponent], encapsulation: 2 });
DwDateRangeFilterComponent = __decorate$1q([
    DwComponent({
        name: 'Date Range Filter',
        componentType: DwComponentType.filterItem,
        isGlobal: true,
        configData: {
            showCaption: true,
            showCompareType: false,
            showControlOptions: false,
            attrType: [DwAttributeType.Date, DwAttributeType.DateTime],
            requireAttr: true,
            showPlaceholderText: true,
            showDefaultValue: false,
            allowAttr: true,
        }
    })
], DwDateRangeFilterComponent);

class DwGridMultiEditModalComponent {
    constructor(dwMetaDataService, dwValidationService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwValidationService = dwValidationService;
        this.formGroup = new FormGroup({});
        this.attributeList = [];
        this.availableAttributes = [];
        this.attributesToUpdate = [];
        this.selectedAttributes = [];
        this.submitted = false;
        this.formValidator = new DwDefaultFormValidator();
    }
    ngOnInit() {
        // Use attributes for the item, not the query since this will be a edit form
        this.dwMetaDataService.getMetaData(this.modalConfig.data.item)
            .subscribe(i => {
            this.attributeList = i.Attributes;
            this.updateAvailableAttributes();
            // Default to showing all fields
            this.setSelectedAttributes(this.availableAttributes);
        });
    }
    buttonClick(buttonConfig) {
        let modalResult = {
            cancelled: false,
            buttonCommand: buttonConfig.command,
            closeModal: true,
        };
        this.message = null;
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                const validationResult = this.formValidator.validateForm(this.formGroup, this.dwValidationService);
                if (!validationResult.isValid) {
                    this.message = {
                        messageHeading: validationResult.summaryHeading,
                        messageBody: validationResult.summaryBodyHtml,
                        severity: DwMessageSeverity.warning,
                        allowClose: true,
                    };
                    this.submitted = true;
                    modalResult.closeModal = false;
                    return of(modalResult);
                }
                this.setUpdateAttributes(modalResult);
                break;
            case DwButtonCommand.cancel:
                modalResult.cancelled = true;
                break;
        }
        return of(modalResult);
    }
    setUpdateAttributes(modalResult) {
        if (this.attributesToUpdate.length == 0) {
            modalResult.closeModal = false;
            return;
        }
        const updatedEntity = {
            _itemName: this.modalConfig.data.item,
            _keyName: this.modalConfig.data.keyName
        };
        for (const attrToUpdate of this.attributesToUpdate) {
            updatedEntity[attrToUpdate.attr.AttributeName] = this.formGroup.get(attrToUpdate.attr.AttributeName).value;
        }
        const multiEditResult = {
            fieldsUpdated: true,
            updatedEntity: updatedEntity
        };
        modalResult.cancelled = false;
        modalResult.data = multiEditResult;
    }
    addAttribute(attr) {
        if (!attr) {
            return;
        }
        if (!this.formGroup[attr.AttributeName]) {
            const control = new FormControl();
            this.formGroup.addControl(attr.AttributeName, control);
            if (attr.AlwaysRequired || (!attr.AllowNull && attr.AttributeType != DwAttributeType.Text && attr.AttributeType != DwAttributeType.HTML)) {
                control.validator = Validators.required;
            }
        }
        this.attributesToUpdate.push({
            attr: attr,
            fieldConfig: this.buildFieldConfig(attr, this.modalConfig.data.item),
        });
        this.updateAvailableAttributes();
    }
    removeAttribute(editAttr) {
        const index = this.attributesToUpdate.indexOf(editAttr);
        if (index >= 0) {
            this.attributesToUpdate.splice(index, 1);
        }
        this.updateAvailableAttributes();
    }
    setSelectedAttributes(attributes) {
        this.submitted = false;
        this.message = null;
        this.selectedAttributes = [...attributes];
        this.attributesToUpdate.length = 0;
        for (const attr of attributes) {
            this.addAttribute(attr);
        }
        // Enable/Disable controls appropriately
        for (const attr of this.availableAttributes) {
            const attributeIsAdded = this.attributesToUpdate.find(a => a.attr.AttributeName == attr.AttributeName);
            const control = this.formGroup.controls[attr.AttributeName];
            if (attributeIsAdded) {
                control === null || control === void 0 ? void 0 : control.enable();
            }
            else {
                control === null || control === void 0 ? void 0 : control.disable();
            }
        }
    }
    updateAvailableAttributes() {
        this.availableAttributes = this.attributeList.filter(attr => {
            // Exclude primary keys
            if (attr.IsKey) {
                return false;
            }
            // Use the modal config to determine which attributes to show
            if (this.modalConfig.data.config.includeAllAttributes === false) {
                const includeAttributes = this.modalConfig.data.config.includeAttributes || [];
                return includeAttributes.find(attrName => attr.AttributeName == attrName);
            }
            return true;
        });
    }
    buildFieldConfig(attr, itemName) {
        const fieldConfig = {
            itemName: itemName,
            attrName: attr.AttributeName,
            attr: attr,
            controlType: attr.MetaDataControlTypeId,
            label: attr.Display,
            formGroupKey: ''
        };
        return fieldConfig;
    }
}
DwGridMultiEditModalComponent.ɵfac = function DwGridMultiEditModalComponent_Factory(t) { return new (t || DwGridMultiEditModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwValidationService)); };
DwGridMultiEditModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridMultiEditModalComponent, selectors: [["dw-grid-multi-edit-modal"]], decls: 14, vars: 9, consts: [[3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["optionLabel", "Display", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "ngModel", "ngModelOptions", "filter", "ngModelChange"], [3, "message", "messageChange", 4, "ngIf"], [1, "container-style"], ["dwRow", "", 4, "ngFor", "ngForOf"], ["dwRow", "", 3, "hidden"], [3, "message", "messageChange"], ["dwDynamicField", "", 3, "fieldDef", "formGroup", "submitted"]], template: function DwGridMultiEditModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4, " Select Attributes ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p-multiSelect", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridMultiEditModalComponent_Template_p_multiSelect_ngModelChange_5_listener($event) { return ctx.setSelectedAttributes($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "hr");
        ɵngcc0.ɵɵtemplate(7, DwGridMultiEditModalComponent_dw_message_7_Template, 1, 1, "dw-message", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "div");
        ɵngcc0.ɵɵtemplate(10, DwGridMultiEditModalComponent_div_10_Template, 3, 3, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵtext(13, " Please select one or more attributes to update! ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("options", ctx.availableAttributes)("ngModel", ctx.selectedAttributes)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(8, _c4))("filter", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attributesToUpdate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.attributesToUpdate.length > 0);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc4.NgForOf, DwMessageComponent, DwDynamicFieldComponent], styles: [_c90] });
DwGridMultiEditModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwValidationService }
];

class DwActionResult {
}

class DwGridActionResult extends DwActionResult {
}

class DwGridMultiEditConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.attributes = [];
    }
    addControls() {
        this.addControl('includeAllAttributes');
        this.addControl('includeAttributes');
        this.addControl('refreshFullGrid');
        this.setupMetaData();
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.primeAttributes = itemMd.Attributes.filter(a => !a.IsKey).map(a => { return { label: a.Display, value: a.AttributeName }; });
        });
    }
}
DwGridMultiEditConfigComponent.ɵfac = function DwGridMultiEditConfigComponent_Factory(t) { return new (t || DwGridMultiEditConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridMultiEditConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridMultiEditConfigComponent, selectors: [["dw-grid-multi-edit-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "includeAllAttributes"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["formControlName", "includeAttributes", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["formControlName", "refreshFullGrid"]], template: function DwGridMultiEditConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridMultiEditConfigComponent_div_0_Template, 16, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc12.MultiSelect], encapsulation: 2 });
DwGridMultiEditConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1r = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$15 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridMultiEditActionService = class DwGridMultiEditActionService {
    constructor(dwModalService, dwOrmDataService) {
        this.dwModalService = dwModalService;
        this.dwOrmDataService = dwOrmDataService;
    }
    handleAction(actionState) {
        const modalData = {
            dataItems: actionState.event.eventData,
            config: actionState.actionConfig,
            item: actionState.metaDataGridApi.item,
            keyName: 'Unknown'
        };
        if (!Array.isArray(modalData.dataItems) || modalData.dataItems.length == 0) {
            // Nothing to do in this case
            const result = new DwGridActionResult();
            result.success = false;
            result.message = `At least one record must be selected to perform a multi-edit!`;
            return of(result);
        }
        // Get the keyname from the list of entities
        modalData.keyName = modalData.dataItems[0]._keyName;
        return this.showMultiEditModal(modalData);
    }
    showMultiEditModal(modalData) {
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel;
        modalConfig.allowFullScreen = true;
        modalConfig.data = modalData;
        modalConfig.component = DwGridMultiEditModalComponent;
        modalConfig.modalSize = DwModalSize.responsive;
        // modalConfig.modalSize = DwModalSize.custom;
        // modalConfig.customModalHeight = '750px';
        // modalConfig.customModalWidth = '600px';
        modalConfig.title = `Multi-Edit for ${modalData.dataItems.length} Items`;
        return this.dwModalService.showModal(modalConfig)
            .pipe(mergeMap(modalResult => {
            const multiEditModalResult = modalResult.data;
            if (!modalResult.cancelled && multiEditModalResult.fieldsUpdated) {
                return this.handleMultiEditSave(modalData, multiEditModalResult);
            }
            const result = new DwGridActionResult();
            result.success = true;
            result.refreshData = false;
            return of(result);
        }));
    }
    handleMultiEditSave(modalData, multiEditResult) {
        // Reload entities so we get the most current data
        return this.reloadExistingRecords(modalData)
            .pipe(flatMap(loadedEntities => {
            // Update all of the entities
            return this.updateEntities(modalData, multiEditResult, loadedEntities)
                .pipe(map(finalEntities => {
                const result = new DwGridActionResult();
                result.success = true;
                result.refreshData = true; // modalData.config.refreshFullGrid;
                result.dataActionResult = {
                    itemName: modalData.item,
                    keyName: modalData.keyName,
                    actionType: DwMdDataActionType.update,
                    keysEffected: modalData.dataItems.map(di => di[modalData.keyName])
                };
                return result;
            }));
        }));
    }
    reloadExistingRecords(modalData) {
        const keys = modalData.dataItems.map(di => di[modalData.keyName]);
        const keyFieldName = `${modalData.item}.${modalData.keyName}`;
        const qh = new DwQueryHelper();
        const query = new DwQuery(modalData.item)
            .AddFilterAnd(qh.filters.InList(keyFieldName, keys));
        return this.dwOrmDataService.executeQuery(query);
    }
    updateEntities(modalData, multiEditResult, entities) {
        const updatedEntities = [];
        for (const entity of entities) {
            const newEntity = Object.assign(Object.assign({}, entity), multiEditResult.updatedEntity);
            updatedEntities.push(newEntity);
        }
        return this.dwOrmDataService.saveEntityCollection(updatedEntities, false, false);
    }
};
DwGridMultiEditActionService.ɵfac = function DwGridMultiEditActionService_Factory(t) { return new (t || DwGridMultiEditActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwOrmDataServiceToken)); };
DwGridMultiEditActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridMultiEditActionService, factory: function (t) { return DwGridMultiEditActionService.ɵfac(t); } });
DwGridMultiEditActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] }
];
DwGridMultiEditActionService = __decorate$1r([
    DwAction({
        keyName: DwGridActionKeys.gridMultiEdit,
        display: 'Edit Multiple',
        actionType: DwActionType.gridContextMenuAction,
        configComponent: DwGridMultiEditConfigComponent,
        isGlobal: true,
        allowOnce: false,
        // configComponent: DwGridSetValueActionConfigComponent,
        defaultMenuConfig: {
            useParentDisplay: true,
            itemRequirement: DwActionItemRequirement.multiple,
        },
        defaultSecurityConfig: {
            requireCanUpdate: true
        },
        configData: {
            refreshFullGrid: true,
            includeAllAttributes: true
        }
    }),
    __metadata$15("design:paramtypes", [DwModalService,
        DwOrmDataService])
], DwGridMultiEditActionService);

class DwDefaultValueComponent {
    constructor(dwContextService) {
        this.dwContextService = dwContextService;
        this.defaultValueChange = new EventEmitter();
    }
    ngOnInit() {
        // this.setupControl();
    }
    ngOnChanges(changes) {
        //if (changes.defaultValue && !changes.defaultValue.firstChange) {
        this.setupControl();
        //}
    }
    setReferenceValue(reference) {
        this.defaultValue.reference = reference || {
            referenceType: DwExpressionReferenceType.value,
        };
        this.defaultValueChange.emit(this.defaultValue);
    }
    setupControl() {
        var _a;
        let simpleValue = null;
        if (typeof (this.defaultValue) !== 'object') {
            simpleValue = this.defaultValue;
        }
        if (!this.defaultValue) {
            this.defaultValue = {
                reference: {
                    referenceType: DwExpressionReferenceType.value
                }
            };
        }
        else {
            if (!((_a = this.defaultValue) === null || _a === void 0 ? void 0 : _a.reference)) {
                this.defaultValue = {
                    reference: {
                        referenceType: DwExpressionReferenceType.value,
                        value: simpleValue
                    }
                };
            }
        }
        this.setupFinalContextNames();
        this.buildValueFieldConfig();
    }
    /**
     * Limits the final context names to global context - this is because other contexts are depending on relations
     */
    setupFinalContextNames() {
        const allContexts = this.dwContextService.contextDefinitions;
        this.finalContextNames = [];
        this.contextNames = this.contextNames || [];
        for (let contextName of this.contextNames) {
            const context = allContexts.find(c => c.contextName == contextName);
            if (context && context.isGlobal) {
                this.finalContextNames.push(contextName);
            }
        }
        // TODO: Need to test out related context types to see if they actually work
        this.finalContextNames = this.contextNames;
    }
    buildValueFieldConfig() {
        if (!this.queryAttribute) {
            this.defaultValueFieldConfig = null;
            return;
        }
        const attr = this.queryAttribute.Attribute;
        const newFieldConfig = new DwFormFieldConfig();
        newFieldConfig.attr = attr;
        newFieldConfig.attrName = 'DefaultValue';
        newFieldConfig.controlType = this.controlTypeOverride || attr.MetaDataControlTypeId;
        newFieldConfig.label = 'Default Value';
        newFieldConfig.hideLabel = true;
        if (!areEqual(this.defaultValueFieldConfig, newFieldConfig)) {
            this.defaultValueFieldConfig = newFieldConfig;
        }
    }
}
DwDefaultValueComponent.ɵfac = function DwDefaultValueComponent_Factory(t) { return new (t || DwDefaultValueComponent)(ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwDefaultValueComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDefaultValueComponent, selectors: [["dw-default-value"]], inputs: { defaultValue: "defaultValue", contextNames: "contextNames", queryAttribute: "queryAttribute", controlTypeOverride: "controlTypeOverride" }, outputs: { defaultValueChange: "defaultValueChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[1, "expr-column-full"], [3, "ngModel", "contextNames", "valueFieldConfig", "ngModelChange"]], template: function DwDefaultValueComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dw-expression-reference-control", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwDefaultValueComponent_Template_dw_expression_reference_control_ngModelChange_1_listener($event) { return ctx.setReferenceValue($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.defaultValue.reference)("contextNames", ctx.finalContextNames)("valueFieldConfig", ctx.defaultValueFieldConfig);
    } }, directives: [DwExpressionReferenceControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwDefaultValueComponent.ctorParameters = () => [
    { type: DwContextService }
];
DwDefaultValueComponent.propDecorators = {
    defaultValue: [{ type: Input }],
    defaultValueChange: [{ type: Output }],
    contextNames: [{ type: Input }],
    queryAttribute: [{ type: Input }],
    controlTypeOverride: [{ type: Input }]
};

class DwGridToggleValueActionConfigComponent extends DwChildConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        // protected addControls() {
        //   this.addControl('itemName', Validators.required, this.configContext.itemName);
        //   this.addControl('attrName', Validators.required);
        //   this.addControl('refreshFullGrid');
        //   this.setupMetaData();
        // }
        this.attributes = [];
    }
    getDefaultConfig() {
        return {
            itemName: this.configContext.itemName,
            attrName: '',
            refreshFullGrid: true,
        };
    }
    setupComponent() {
        super.setupComponent();
        this.setupMetaData();
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes.filter(a => a.AttributeType == DwAttributeType.YesNo);
        });
    }
}
DwGridToggleValueActionConfigComponent.ɵfac = function DwGridToggleValueActionConfigComponent_Factory(t) { return new (t || DwGridToggleValueActionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridToggleValueActionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridToggleValueActionConfigComponent, selectors: [["dw-grid-set-value-action-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 3, consts: [["dwRow", ""], ["dwCol", "12"], [1, "label"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [3, "ngValue"]], template: function DwGridToggleValueActionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵtext(4, "Attribute To Toggle");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridToggleValueActionConfigComponent_Template_select_ngModelChange_5_listener($event) { return ctx.config.attrName = $event; })("ngModelChange", function DwGridToggleValueActionConfigComponent_Template_select_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵtemplate(6, DwGridToggleValueActionConfigComponent_option_6_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Refresh Full Grid");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "p-inputSwitch", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridToggleValueActionConfigComponent_Template_p_inputSwitch_ngModelChange_12_listener($event) { return ctx.config.refreshFullGrid = $event; })("ngModelChange", function DwGridToggleValueActionConfigComponent_Template_p_inputSwitch_ngModelChange_12_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.attrName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attributes);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.refreshFullGrid);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwGridToggleValueActionConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1s = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$16 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridToggleValueActionService = class DwGridToggleValueActionService {
    constructor(metaDataService, ormDataService, loggingService) {
        this.metaDataService = metaDataService;
        this.ormDataService = ormDataService;
        this.loggingService = loggingService;
    }
    handleAction(actionState) {
        const { actionConfig, event } = actionState;
        const entity = actionState.data;
        const minOrigEntity = Object.assign({}, entity);
        minOrigEntity[actionState.actionConfig.attrName] = entity[actionState.actionConfig.attrName];
        const minNewEntity = Object.assign({}, entity);
        minNewEntity[actionState.actionConfig.attrName] = !entity[actionState.actionConfig.attrName];
        // console.log('DwGridToggleValue', minOrigEntity, minNewEntity);
        // Update data
        return this.ormDataService.saveEntity(minNewEntity, false, null, minOrigEntity)
            .pipe(map(dataResult => {
            const result = {
                success: true,
                refreshData: actionConfig.refreshFullGrid,
                dataActionResult: {
                    itemName: actionState.metaDataGridApi.item,
                    keyName: dataResult._keyName,
                    actionType: DwMdDataActionType.update,
                    keysEffected: [dataResult[dataResult._keyName]]
                }
            };
            return result;
        }));
    }
};
DwGridToggleValueActionService.ɵfac = function DwGridToggleValueActionService_Factory(t) { return new (t || DwGridToggleValueActionService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwGridToggleValueActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridToggleValueActionService, factory: function (t) { return DwGridToggleValueActionService.ɵfac(t); } });
DwGridToggleValueActionService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwLoggingService }
];
DwGridToggleValueActionService = __decorate$1s([
    DwAction({
        keyName: DwGridActionKeys.gridToggleValue,
        display: 'Toggle value',
        actionType: DwActionType.gridRowAction,
        isGlobal: true,
        allowOnce: false,
        configComponent: DwGridToggleValueActionConfigComponent,
        defaultMenuConfig: {
            useParentDisplay: true,
            itemRequirement: DwActionItemRequirement.multiple,
        },
        defaultSecurityConfig: {
            requireCanUpdate: true
        }
    }),
    __metadata$16("design:paramtypes", [DwMetaDataService,
        DwOrmDataService,
        DwLoggingService])
], DwGridToggleValueActionService);

class DwFormButtonsConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor(cdr, uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb) {
        super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
        this.cdr = cdr;
        this.formActionTypes = [DwActionType.formAction, DwActionType.menuAction];
        this.configContext = {};
        this.tabIndex = 0;
    }
    ngOnInit() {
        this.buttonContainerStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.buttonContainerStyles, false);
        this.section.buttonContainerStyleKey = this.section.buttonContainerStyleKey || '';
        this.section.useFormButtonDefaults = !!this.section.useFormButtonDefaults;
        this.section.useFormModes = !!this.section.useFormModes;
        if (this.section.useFormButtonDefaults) {
            this.actionFormHeaderClass = 'hide';
            //this.tabIndex = 1;
        }
        else {
            this.actionFormHeaderClass = '';
            //this.tabIndex = 0;
        }
    }
    sectionChanged() {
        this.section.actionPreferencesByMode = this.section.actionPreferencesByMode || {};
        if (!this.section) {
            return;
        }
        this.configContext.itemName = this.getParentItemName();
        this.configContext.contextNames = this.contextNames;
        this.actionModes = getFormActionModes(this.section.useFormModes, this.section.buttonContainerStyleKey);
    }
    onSectionChange() {
        this.actionModes = getFormActionModes(this.section.useFormModes, this.section.buttonContainerStyleKey);
        this.actionFormHeaderClass = this.section.useFormButtonDefaults ? 'hide' : '';
        super.onSectionChange();
        this.cdr.detectChanges();
    }
}
DwFormButtonsConfigComponent.ɵfac = function DwFormButtonsConfigComponent_Factory(t) { return new (t || DwFormButtonsConfigComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder)); };
DwFormButtonsConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormButtonsConfigComponent, selectors: [["dw-form-buttons-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 24, vars: 13, consts: [[3, "activeIndex", "activeIndexChange"], ["header", "Actions", 4, "ngIf"], ["header", "Button Section Configuration"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "6", 4, "ngIf"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["title", "Shows action messages instead of the action button circle", 1, "fa", "fa-info-circle"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "showReadOnlySection", "sectionChange"], ["header", "Actions"], ["showEnableVisibleConfig", "true", 3, "configContext", "actionModes", "actionPreferencesByMode", "actionPreferencesByModeChange", "actionPreferenceByModeChange"], [3, "ngValue"]], template: function DwFormButtonsConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView", 0);
        ɵngcc0.ɵɵlistener("activeIndexChange", function DwFormButtonsConfigComponent_Template_p_tabView_activeIndexChange_1_listener($event) { return ctx.tabIndex = $event; });
        ɵngcc0.ɵɵtemplate(2, DwFormButtonsConfigComponent_p_tabPanel_2_Template, 2, 3, "p-tabPanel", 1);
        ɵngcc0.ɵɵelementStart(3, "p-tabPanel", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "label");
        ɵngcc0.ɵɵtext(7, "Use Form Button Defaults");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "dw-yesno", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormButtonsConfigComponent_Template_dw_yesno_ngModelChange_8_listener($event) { return ctx.section.useFormButtonDefaults = $event; })("ngModelChange", function DwFormButtonsConfigComponent_Template_dw_yesno_ngModelChange_8_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DwFormButtonsConfigComponent_div_9_Template, 4, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 3);
        ɵngcc0.ɵɵelementStart(11, "div", 4);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Button Container Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "select", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormButtonsConfigComponent_Template_select_ngModelChange_14_listener($event) { return ctx.section.buttonContainerStyleKey = $event; })("ngModelChange", function DwFormButtonsConfigComponent_Template_select_ngModelChange_14_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(15, DwFormButtonsConfigComponent_option_15_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 4);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Show Action Messages ");
        ɵngcc0.ɵɵelement(19, "i", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "dw-yesno", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormButtonsConfigComponent_Template_dw_yesno_ngModelChange_20_listener($event) { return ctx.section.showActionMessages = $event; })("ngModelChange", function DwFormButtonsConfigComponent_Template_dw_yesno_ngModelChange_20_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "p-tabPanel", 9);
        ɵngcc0.ɵɵelementStart(22, "div");
        ɵngcc0.ɵɵelementStart(23, "dw-md-section-standard-config", 10);
        ɵngcc0.ɵɵlistener("sectionChange", function DwFormButtonsConfigComponent_Template_dw_md_section_standard_config_sectionChange_23_listener($event) { return ctx.section = $event; })("sectionChange", function DwFormButtonsConfigComponent_Template_dw_md_section_standard_config_sectionChange_23_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("activeIndex", ctx.tabIndex);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.useFormButtonDefaults);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useFormButtonDefaults);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.useFormButtonDefaults);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.buttonContainerStyleKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.buttonContainerStyles);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.showActionMessages);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName)("showReadOnlySection", false);
    } }, directives: [ɵngcc9.TabView, ɵngcc4.NgIf, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, DwMdSectionStandardConfigComponent, DwActionGroupModesConfigComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwFormButtonsConfigComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder }
];

class DwFormButtonsSectionConfigProcessor {
    constructor(dwActionConfigService, dwFormActionService, dwMetadataFormUtilService, dwUiConfigRegistryService, uiMetaDataConfig) {
        this.dwActionConfigService = dwActionConfigService;
        this.dwFormActionService = dwFormActionService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.uiMetaDataConfig = uiMetaDataConfig;
    }
    initSectionConfig(sectionParameters) {
        let actionPreferencesByMode = sectionParameters.sectionPreference.actionPreferencesByMode;
        if (sectionParameters.sectionPreference.useFormButtonDefaults) {
            const defaultButtons = this.getFormButtonDefaults(sectionParameters.formConfig.section);
            actionPreferencesByMode = this.dwFormActionService.getDefaultFormActionPreferencesByMode(defaultButtons);
        }
        // Try : moving to from buttons to test theory
        //const finalActionPreferencesByMode =  this.dwActionConfigService.buildFinalActionPreferencesByMode(actionPreferencesByMode, sectionParameters.itemSecurity);
        const finalActionPreferencesByMode = Object.assign({}, actionPreferencesByMode);
        //console.log('Form Buttons - processor', sectionParameters.itemSecurity, finalActionPreferencesByMode);
        return Object.assign(Object.assign({}, sectionParameters.sectionPreference), { finalActionPreferencesByMode: finalActionPreferencesByMode });
    }
    getFormButtonDefaults(rootSection) {
        const sectionRegistrations = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections, false);
        let defaultButtons = this.uiMetaDataConfig.formButtonDefaults;
        // Iterate all sections and determine if any have button defaults
        const sectionWithDefaultButtons = this.dwMetadataFormUtilService.findSections(rootSection, (section) => {
            const sectionRegistration = sectionRegistrations.find(sr => sr.keyName == section.sectionType);
            if (sectionRegistration && sectionRegistration.defaultButtonsOverride) {
                defaultButtons = sectionRegistration.defaultButtonsOverride;
                return true;
            }
        });
        return defaultButtons;
    }
}
DwFormButtonsSectionConfigProcessor.ɵfac = function DwFormButtonsSectionConfigProcessor_Factory(t) { return new (t || DwFormButtonsSectionConfigProcessor)(ɵngcc0.ɵɵinject(DwMetaDataActionConfigService), ɵngcc0.ɵɵinject(DwMetaDataFormActionService), ɵngcc0.ɵɵinject(DwMetadataFormUtilService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwFormButtonsSectionConfigProcessor.ɵprov = ɵɵdefineInjectable({ factory: function DwFormButtonsSectionConfigProcessor_Factory() { return new DwFormButtonsSectionConfigProcessor(ɵɵinject(DwMetaDataActionConfigService), ɵɵinject(DwMetaDataFormActionService), ɵɵinject(DwMetadataFormUtilService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(DwUIMetaDataConfigToken)); }, token: DwFormButtonsSectionConfigProcessor, providedIn: "root" });
DwFormButtonsSectionConfigProcessor.ctorParameters = () => [
    { type: DwMetaDataActionConfigService },
    { type: DwMetaDataFormActionService },
    { type: DwMetadataFormUtilService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];

var __decorate$1t = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$17 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwFormButtonsSectionComponent = class DwFormButtonsSectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwFormActionService, dwActionExecutionService, dwMetaDataFormStateService, dwMetaDataActionExpressionService, dwActionConfigService, dwContextService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwFormActionService = dwFormActionService;
        this.dwActionExecutionService = dwActionExecutionService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataActionExpressionService = dwMetaDataActionExpressionService;
        this.dwActionConfigService = dwActionConfigService;
        this.dwContextService = dwContextService;
        this.actionPreferences = [];
        this.allActionPreferences = [];
        this.actionInitComplete = {};
        this.showActionFiring = false;
        this.actionMessage = 'Saving...';
        this.subscriptions.push(this.dwMetaDataFormStateService.stateChanged.subscribe((state) => {
            this.setupActionFiring(state);
            this.setupActions();
        }));
    }
    setupActionFiring(formState) {
        var _a;
        this.showActionFiring = false;
        this.firingActionPreference = null;
        if (formState.actionFiring && ((_a = formState.actionContext) === null || _a === void 0 ? void 0 : _a.sectionKey) == this.sectionConfig.sectionKey) {
            if (this.sectionConfig.showActionMessages) {
                this.showActionFiring = true;
                this.actionMessage = formState.actionMessage;
            }
            else {
                this.firingActionPreference = formState.actionPreference;
            }
        }
    }
    formConfigChanged() {
        this.sectionConfigChanged();
    }
    sectionConfigChanged() {
        this.setupActions();
    }
    setupActions() {
        if (!this.formConfig || !this.sectionConfig) {
            return;
        }
        let formActionMode = this.dwMetaDataFormStateService.state.formContext.contextMode;
        if (!this.sectionConfig.useFormModes && !this.sectionConfig.useFormButtonDefaults) {
            formActionMode = formModeNone;
        }
        let actionPreferencesByMode = this.sectionConfig.finalActionPreferencesByMode || this.sectionConfig.actionPreferencesByMode || {};
        actionPreferencesByMode = this.dwActionConfigService.buildFinalActionPreferencesByMode(actionPreferencesByMode, this.dwMetaDataFormStateService.state.itemSecurity);
        const newPreferences = actionPreferencesByMode[formActionMode] || [];
        ;
        if (areEqual(this.allActionPreferencesOriginal, newPreferences)) {
            // Nothing to do if the preferences are the same
            return;
        }
        this.actionInitComplete = {};
        this.allActionPreferencesOriginal = deepCopy(newPreferences);
        this.allActionPreferences = actionPreferencesByMode[formActionMode] || [];
        // If we don't have any actions for the designated form mode, check if we should use the combined addEdit mode instead
        if (this.allActionPreferences.length == 0 && (formActionMode == DwFormContextMode.add || formActionMode == DwFormContextMode.edit)) {
            this.allActionPreferences = actionPreferencesByMode[DwFormContextMode.addEdit] || [];
        }
        this.setActionIds(this.allActionPreferences);
        //console.log(`Form Buttons - Setup Actions   Form Mode: ${formActionMode}`, this.allActionPreferences);
        this.setupActionEnabledVisibleRules();
        this.initActions();
    }
    setActionIds(actionPreferences) {
        for (const actionPreference of actionPreferences) {
            if (!actionPreference._uniqueId) {
                actionPreference._uniqueId = `${actionPreference.actionKey}-${actionPreference.actionDisplay}`;
            }
        }
    }
    setupActionEnabledVisibleRules() {
        this.actionPreferences = this.allActionPreferences;
        let actionPrefsResult = this.dwMetaDataActionExpressionService.initActionEnabledVisibleRules(() => this.actionPreferences, this.formGroup, this.context);
        this.actionPreferences = actionPrefsResult.initialResults;
        this.clearActionSubscription();
        this.actionSubscription = actionPrefsResult.observable.subscribe(actionPrefs => {
            if (!areEqual(this.actionPreferences, actionPrefs)) {
                this.actionPreferences = actionPrefs;
            }
        });
    }
    executeAction(actionEvent) {
        // Get data for this level in the hierarchy
        let levelData = this.formGroup.getRawValue();
        if (this.formGroup.parent == null) {
            levelData = this.dwMetaDataFormStateService.state.formApi.getFormData();
        }
        actionEvent.actionContext = {
            sectionKey: this.sectionConfig.sectionKey,
            levelData: levelData
        };
        this.dwMetaDataFormStateService.state.formApi.triggerAction(actionEvent);
    }
    initActions() {
        if (!this.actionPreferences) {
            return;
        }
        for (const actionPreference of this.actionPreferences) {
            const id = actionPreference._uniqueId;
            if (this.actionInitComplete[id]) {
                continue;
            }
            this.actionInitComplete[id] = true;
            this.initCustomAction(actionPreference);
        }
    }
    initCustomAction(actionPreference) {
        const actionDef = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.action, actionPreference.actionKey);
        if (!actionDef) {
            console.warn(`Could not find custom action with key ${actionPreference.actionKey}`);
            return;
        }
        // Can't init component actions because they are not a service and must be instantiated within a compoment host
        if (actionDef.decoratorType == DwDecoratorType.component) {
            return;
        }
        const actionState = {
            config: this.formConfig,
            formApi: this.dwMetaDataFormStateService.state.formApi,
            actionPreference: actionPreference,
            context: this.dwContextService.getResolvedContext(this.dwMetaDataFormStateService.state.context),
            dwBrowserEvent: null,
            additionalActionContext: {
                sectionKey: this.sectionConfig.sectionKey,
                levelData: null
            },
            updateActionPreference: (updatedActionPrefPartial) => {
                let foundPref = this.actionPreferences.find(ap => ap._uniqueId == actionPreference._uniqueId);
                if (foundPref) {
                    let index = this.actionPreferences.indexOf(foundPref);
                    const newPref = deepDefaults(foundPref, updatedActionPrefPartial, null, true);
                    // console.log(`updating action Pref ${actionPreference.actionDisplay}`, updatedActionPrefPartial?.buttonConfig?.disabled, foundPref?.buttonConfig?.disabled, newPref?.buttonConfig);
                    this.actionPreferences[index] = newPref;
                }
            }
        };
        try {
            const ob = this.dwActionExecutionService.initAction(actionPreference.actionKey, actionState);
            if (ob && ob.subscribe) {
                ob.subscribe(result => {
                    // nothing to do with the result
                });
            }
        }
        catch (ex) {
            console.warn(`Action ${actionPreference.actionDisplay} failed to initialize with error`, ex);
        }
    }
    clearActionSubscription() {
        if (this.actionSubscription) {
            this.actionSubscription.unsubscribe();
        }
    }
    OnDestroy() {
        super.ngOnDestroy();
        this.clearActionSubscription();
    }
};
DwFormButtonsSectionComponent.ɵfac = function DwFormButtonsSectionComponent_Factory(t) { return new (t || DwFormButtonsSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormActionService), ɵngcc0.ɵɵdirectiveInject(DwActionExecutionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionExpressionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwFormButtonsSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormButtonsSectionComponent, selectors: [["dw-form-buttons-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 8, consts: [[1, "hide-print-item", 3, "ngClass"], ["convertPreferences", "false", 3, "actionPreferences", "firingActionPreference", "buttonContainerStyleKey", "actionClick"], [1, "dw-button-bar-action-firing-container"], [3, "show", "text"]], template: function DwFormButtonsSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dw-action-bar", 1);
        ɵngcc0.ɵɵlistener("actionClick", function DwFormButtonsSectionComponent_Template_dw_action_bar_actionClick_1_listener($event) { return ctx.executeAction($event); });
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "dw-loading", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c44, (ctx.dwMetaDataFormStateService == null ? null : ctx.dwMetaDataFormStateService.state == null ? null : ctx.dwMetaDataFormStateService.state.showButtons) === false));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("actionPreferences", ctx.actionPreferences)("firingActionPreference", ctx.firingActionPreference)("buttonContainerStyleKey", ctx.sectionConfig == null ? null : ctx.sectionConfig.buttonContainerStyleKey);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("show", ctx.showActionFiring)("text", ctx.actionMessage);
    } }, directives: [ɵngcc4.NgClass, DwActionBarComponent, DwLoadingComponent], encapsulation: 2 });
DwFormButtonsSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormActionService },
    { type: DwActionExecutionService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataActionExpressionService },
    { type: DwMetaDataActionConfigService },
    { type: DwContextService }
];
DwFormButtonsSectionComponent = __decorate$1t([
    DwSectionComponent({
        keyName: DwSectionType.buttonBar,
        display: 'Button Section',
        sectionIcon: 'fa fa-bolt',
        configComponent: DwFormButtonsConfigComponent,
        hasChildren: false,
        sectionConfigInitService: DwFormButtonsSectionConfigProcessor
    }),
    __metadata$17("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetaDataFormActionService,
        DwActionExecutionService,
        DwMetaDataFormStateService,
        DwMetaDataActionExpressionService,
        DwMetaDataActionConfigService,
        DwContextService])
], DwFormButtonsSectionComponent);

class DwFormSaveConfigComponent extends DwActionConfigBaseComponent {
    addControls() {
        this.addControl('saveAndNew');
        this.addControl('saveAndEdit');
        this.addControl('actionMessage');
        this.addControl('requireValidation');
        this.addControl('redirectAfter');
        this.addControl('customizeRedirect');
        this.addControl('redirectMenuKey');
    }
}
DwFormSaveConfigComponent.ɵfac = function DwFormSaveConfigComponent_Factory(t) { return ɵDwFormSaveConfigComponent_BaseFactory(t || DwFormSaveConfigComponent); };
DwFormSaveConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormSaveConfigComponent, selectors: [["dw-dw-form-save-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", "formControlName", "actionMessage", 1, "form-control"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "requireValidation"], ["title", "When in add mode, it saves and redirects to the edit page", 1, "fa", "fa-info-circle"], ["formControlName", "saveAndEdit"], ["formControlName", "redirectAfter"], ["dwRow", "", 4, "ngIf"], ["formControlName", "customizeRedirect"], ["formControlName", "redirectMenuKey"]], template: function DwFormSaveConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFormSaveConfigComponent_div_0_Template, 27, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc10.InputSwitch, DwSelectRouteComponent], encapsulation: 2 });

var __decorate$1u = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$18 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwFormSaveActionService = class DwFormSaveActionService {
    constructor(dwMetaDataRoutingServic, router) {
        this.dwMetaDataRoutingServic = dwMetaDataRoutingServic;
        this.router = router;
    }
    handleAction(actionState) {
        return actionState.formApi.saveData(false)
            .pipe(map(result => {
            var _a, _b;
            if (result.success && actionState.formApi.getFormConfig().formMode == DwFormContextMode.add) {
                if ((_a = actionState.actionConfig) === null || _a === void 0 ? void 0 : _a.saveAndNew) {
                    return this.saveAndNew(actionState, result);
                }
                if ((_b = actionState.actionConfig) === null || _b === void 0 ? void 0 : _b.saveAndEdit) {
                    return this.saveAndEdit(actionState, result);
                }
            }
            return result;
        }));
    }
    saveAndNew(actionState, result) {
        result.rediectAfterOverride = false;
        result.message = 'Save successful';
        actionState.formApi.resetForm();
        return result;
    }
    saveAndEdit(actionState, result) {
        const keyValue = this.getKeyValue(result.saveResult);
        if (!keyValue) {
            return result;
        }
        result.rediectAfterOverride = true;
        result.redirectOverrideInternalUrl = this.dwMetaDataRoutingServic
            .buildEditOrViewUrlWithKey(actionState.formApi.route, actionState.formApi.item, keyValue, DwMenuActionType.edit);
        return result;
    }
    getKeyValue(data) {
        if (!data) {
            return null;
        }
        if (data._keyName) {
            const ormData = data;
            return ormData[ormData._keyName];
        }
    }
};
DwFormSaveActionService.ɵfac = function DwFormSaveActionService_Factory(t) { return new (t || DwFormSaveActionService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingService), ɵngcc0.ɵɵinject(ɵngcc2.Router)); };
DwFormSaveActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFormSaveActionService, factory: function (t) { return DwFormSaveActionService.ɵfac(t); } });
DwFormSaveActionService.ctorParameters = () => [
    { type: DwMetaDataRoutingService },
    { type: Router }
];
DwFormSaveActionService = __decorate$1u([
    DwAction({
        keyName: DwFormActionKeys.formSave,
        display: 'Save',
        actionType: DwActionType.formAction,
        configComponent: DwFormSaveConfigComponent,
        isGlobal: true,
        allowOnce: false,
        order: 1,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonType: DwButtonType.standard,
            buttonClass: 'btn btn-success',
            iconClass: 'fa fa-save',
        },
        defaultSecurityConfig: {
            useSecurityDefaults: true,
        },
        defaultConfirmConfig: {
            showDialogConfig: true,
            showConfirmDialog: false
        },
        configData: {
            requireValidation: true,
            redirectAfter: true,
            actionMessage: 'Saving...',
        }
    }),
    __metadata$18("design:paramtypes", [DwMetaDataRoutingService, Router])
], DwFormSaveActionService);

class DwFormPrintConfigComponent extends DwActionConfigBaseComponent {
    ngOnInit() {
    }
    addControls() {
        this.addControl('actionMessage');
        this.addControl('renderMultiplePage');
        this.addControl('exportPDFFileName');
        this.addControl('pdfRenderWaitTimeMs');
        this.addControl('useBrowserPrint');
        this.addControl('reloadPrintData');
        this.addControl('printConfigKeyOverride');
    }
}
DwFormPrintConfigComponent.ɵfac = function DwFormPrintConfigComponent_Factory(t) { return ɵDwFormPrintConfigComponent_BaseFactory(t || DwFormPrintConfigComponent); };
DwFormPrintConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormPrintConfigComponent, selectors: [["dw-dw-form-print-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", "formControlName", "actionMessage", 1, "form-control"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "useBrowserPrint"], [4, "ngIf"], ["formControlName", "renderMultiplePage"], ["title", "You can use root field name replacement values such [data.FieldName]", 1, "fa", "fa-info-circle"], ["type", "text", "formControlName", "exportPDFFileName", "placeholder", "Uses Item Display - Key value", 1, "form-control"], ["title", "Controls how long to wait for the html to render in milliseconds.  More complex forms with nested data needs more time", 1, "fa", "fa-info-circle"], ["type", "text", "dwNumeric", "", "formControlName", "pdfRenderWaitTimeMs", 1, "form-control"], ["title", "Reload the form data when printing.  This is required is the print from loads data differently from the current form", 1, "fa", "fa-info-circle"], ["formControlName", "reloadPrintData"], ["title", "Overrides the default print key", 1, "fa", "fa-info-circle"], ["type", "text", "formControlName", "printConfigKeyOverride", 1, "form-control"]], template: function DwFormPrintConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFormPrintConfigComponent_div_0_Template, 13, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc10.InputSwitch, DwNumericDirective], encapsulation: 2 });

var __decorate$1v = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwFormPrintActionService = class DwFormPrintActionService {
    handleAction(actionState) {
        const formPrintConfig = actionState.actionConfig;
        // Just use the browser print feature
        if (formPrintConfig === null || formPrintConfig === void 0 ? void 0 : formPrintConfig.useBrowserPrint) {
            window.print();
            return;
        }
        return actionState.formApi.print(formPrintConfig);
    }
};
DwFormPrintActionService.ɵfac = function DwFormPrintActionService_Factory(t) { return new (t || DwFormPrintActionService)(); };
DwFormPrintActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFormPrintActionService, factory: function (t) { return DwFormPrintActionService.ɵfac(t); } });
DwFormPrintActionService = __decorate$1v([
    DwAction({
        keyName: DwFormActionKeys.formPrint,
        display: 'Print',
        actionType: DwActionType.formAction,
        configComponent: DwFormPrintConfigComponent,
        isGlobal: true,
        allowOnce: true,
        order: 2,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonType: DwButtonType.standard,
            buttonClass: 'btn btn-secondary',
            iconClass: 'fa fa-print dw-green',
        },
        defaultSecurityConfig: {},
        defaultConfirmConfig: {
            showDialogConfig: true,
            showConfirmDialog: false
        },
        configData: {
            requireValidation: false,
            redirectAfter: false,
            actionMessage: 'Printing...',
        }
    })
], DwFormPrintActionService);

class DwFormActionConfigDefaultComponent extends DwActionConfigBaseComponent {
    addControls() {
        this.addControl('actionMessage');
        this.addControl('requireValidation');
        this.addControl('redirectAfter');
        this.addControl('customizeRedirect');
        this.addControl('redirectMenuKey');
    }
}
DwFormActionConfigDefaultComponent.ɵfac = function DwFormActionConfigDefaultComponent_Factory(t) { return ɵDwFormActionConfigDefaultComponent_BaseFactory(t || DwFormActionConfigDefaultComponent); };
DwFormActionConfigDefaultComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormActionConfigDefaultComponent, selectors: [["dw-form-action-config-default"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", "formControlName", "actionMessage", 1, "form-control"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "requireValidation"], ["formControlName", "redirectAfter"], ["dwRow", "", 4, "ngIf"], ["formControlName", "customizeRedirect"], ["formControlName", "redirectMenuKey"]], template: function DwFormActionConfigDefaultComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFormActionConfigDefaultComponent_div_0_Template, 20, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc10.InputSwitch, DwSelectRouteComponent], encapsulation: 2 });

var __decorate$1w = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwFormCloseActionService = class DwFormCloseActionService {
    handleAction(actionState) {
        return of({ success: true });
        // return actionState.formApi.cancel();
    }
};
DwFormCloseActionService.ɵfac = function DwFormCloseActionService_Factory(t) { return new (t || DwFormCloseActionService)(); };
DwFormCloseActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFormCloseActionService, factory: function (t) { return DwFormCloseActionService.ɵfac(t); } });
DwFormCloseActionService = __decorate$1w([
    DwAction({
        keyName: DwFormActionKeys.formClose,
        display: 'Close',
        actionType: DwActionType.formAction,
        configComponent: DwFormActionConfigDefaultComponent,
        isGlobal: true,
        allowOnce: true,
        order: 3,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonType: DwButtonType.standard,
            buttonClass: 'btn btn-secondary',
            iconClass: 'fa fa-door-closed dw-green',
        },
        defaultSecurityConfig: {},
        configData: {
            requireValidation: false,
            redirectAfter: true,
        }
    })
], DwFormCloseActionService);

var __decorate$1x = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwFormCancelActionService = class DwFormCancelActionService {
    handleAction(actionState) {
        // return actionState.formApi.cancel();
        return of({ success: true });
    }
};
DwFormCancelActionService.ɵfac = function DwFormCancelActionService_Factory(t) { return new (t || DwFormCancelActionService)(); };
DwFormCancelActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFormCancelActionService, factory: function (t) { return DwFormCancelActionService.ɵfac(t); } });
DwFormCancelActionService = __decorate$1x([
    DwAction({
        keyName: DwFormActionKeys.formCancel,
        display: 'Cancel',
        actionType: DwActionType.formAction,
        configComponent: DwFormActionConfigDefaultComponent,
        isGlobal: true,
        allowOnce: true,
        order: 4,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonType: DwButtonType.standard,
            buttonClass: 'btn btn-danger',
            iconClass: 'fa fa-times-circle',
        },
        defaultSecurityConfig: {},
        defaultConfirmConfig: {
            showDialogConfig: true,
            showConfirmDialog: false
        },
        configData: {
            requireValidation: false,
            redirectAfter: true,
        }
    })
], DwFormCancelActionService);

class DwFormWorkflowButtonsConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.lookupAttributes = [];
        this.attributes = [];
    }
    ngOnInit() {
        super.ngOnInit();
        this.lookupMeaning = DevwareMetaDataLookups.MetaDataLookupAllItems;
        // this.lookupRefItem = DevwareMetaDataItemNames.DwMetaDataAttribute;
        // this.lookupRelatedExprRef = {
        //   referenceType: DwExpressionReferenceType.item,
        //   attrName: "MetaDataLookupId",
        // }
    }
    addControls() {
        this.workflowAttrNameFC = this.addControl('workflowAttrName', Validators.required);
        this.workflowStatusDetailAttrNameFC = this.addControl('workflowStatusDetailAttrName');
        this.lookupIdFC = this.addControl('lookupId');
        this.addControl('showAdminActionText');
        this.addControl('useCustomAttributes');
        this.addControl('buttonDisplayAttrName');
        this.addControl('requireValidationAttrName');
        this.addControl('showValidationRequiredExpr');
        this.addControl('buttonClassAttrName');
        this.addControl('buttonIconAttrName');
        this.addControl('toolTipAttrName');
        this.addControl('useAlternateActionDisplay');
        this.addControl('overrideCurrentStatusDisplay');
        this.addControl('currentStatusDisplay');
        this.addControl('currentStatusAttrName');
        this.addControl('currentStatusButtonClassAttrName');
        this.addControl('buttonTextPrefix');
        this.addControl('updateInitialValueOnSet');
        this.addControl('customizeRedirect');
        this.addControl('redirectMenuKey');
        this.addControl('hideCurrentStatus');
        this.addControl('setStatusOnly');
        this.addControl('useLookupOverride');
        this.addControl('lookupIdOverride');
        this.addControl('validateAfterStatusUpdate');
        // this.subscriptions.push(
        //   this.workflowAttrNameFC.valueChanges.subscribe(newValue => {
        //     this.setupLookupDefinition();
        //   }));
        this.subscriptions.push(this.actionConfigFG.valueChanges
            .pipe(map((value) => {
            return {
                useLookupOverride: value.useLookupOverride,
                lookupId: value.lookupId,
                workflowAttrName: value.workflowAttrName,
                lookupIdOverride: value.lookupIdOverride
            };
        }), distinctUntilChanged())
            .subscribe(newValue => {
            this.setupLookupDefinition(newValue);
        }));
        this.setupMetaData();
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes;
            this.lookupAttributes = itemMd.Attributes.filter(a => a.IsLookup);
            if (!this.workflowAttrNameFC.value && this.lookupAttributes.length > 0) {
                let attribute = this.lookupAttributes.find(a => a.Display.toLowerCase().indexOf('status') > -1);
                if (!attribute) {
                    attribute = this.lookupAttributes[0];
                }
                if (attribute) {
                    this.workflowAttrNameFC.setValue(attribute.AttributeName);
                }
                this.setupLookupDefinition(this.actionConfigFG.value);
            }
        });
    }
    setupLookupDefinition(config) {
        if (!this.lookupAttributes || !config) {
            return;
        }
        const currentAttr = this.lookupAttributes.find(attr => attr.AttributeName == this.workflowAttrNameFC.value);
        this.lookupDefinition = null;
        if (currentAttr && config.lookupId != currentAttr.MetaDataLookupId) {
            config.lookupId = currentAttr.MetaDataLookupId;
            this.lookupIdFC.setValue(currentAttr.MetaDataLookupId);
        }
        let lookupId = config.lookupId;
        if (config.useLookupOverride && config.lookupIdOverride) {
            lookupId = config.lookupIdOverride;
        }
        if (!lookupId) {
            return;
        }
        this.metaDataService.getLookupDefinition(lookupId)
            .subscribe(lookupDef => {
            this.lookupDefinition = lookupDef;
            this.metaDataService.getSavedQueryMetaData(this.lookupDefinition.UniqueItemName, this.lookupDefinition.MetaDataQueryId)
                .subscribe(queryMetaData => {
                this.setupWorkflowAttributeList(lookupDef, queryMetaData);
            });
        });
    }
    setupWorkflowAttributeList(lookupDef, queryMetaData) {
        this.lookupDefAttributeList = [
            {
                AttributeName: 'Display',
                AttributeDisplay: 'Display',
                AttributeType: DwAttributeType.Text,
                DisplayAttributeName: 'Display',
                FieldType: DwFieldType.Standard,
                HasDisplayField: false,
                Attribute: null
            }
        ];
        this.addLookupDefAttribute(this.lookupDefAttributeList, lookupDef.AdditionalAttribute1Id, queryMetaData);
        this.addLookupDefAttribute(this.lookupDefAttributeList, lookupDef.AdditionalAttribute2Id, queryMetaData);
        this.addLookupDefAttribute(this.lookupDefAttributeList, lookupDef.AdditionalAttribute3Id, queryMetaData);
        this.addLookupDefAttribute(this.lookupDefAttributeList, lookupDef.AdditionalAttribute4Id, queryMetaData);
        this.addLookupDefAttribute(this.lookupDefAttributeList, lookupDef.AdditionalAttribute5Id, queryMetaData);
        this.setupWorkflowAttributeDefaults();
    }
    setupWorkflowAttributeDefaults() {
        const attr = this.lookupDefAttributeList.find(a => a.AttributeName == "WorkflowStatusDetailId");
        if (attr && !this.workflowStatusDetailAttrNameFC.value) {
            this.workflowStatusDetailAttrNameFC.setValue(attr.AttributeName);
        }
    }
    addLookupDefAttribute(lookupDefAttributeList, attributeId, queryMetaData) {
        if (!attributeId) {
            return;
        }
        const attr = queryMetaData.Attributes.find(a => a.Attribute && a.Attribute.MetaDataAttributeId == attributeId);
        if (attr) {
            lookupDefAttributeList.push(attr);
        }
    }
}
DwFormWorkflowButtonsConfigComponent.ɵfac = function DwFormWorkflowButtonsConfigComponent_Factory(t) { return new (t || DwFormWorkflowButtonsConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwFormWorkflowButtonsConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormWorkflowButtonsConfigComponent, selectors: [["dw-form-workflow-buttons-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["formControlName", "workflowAttrName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "hideCurrentStatus"], ["formControlName", "setStatusOnly"], [4, "ngIf"], [3, "ngValue"], ["title", "Uses workflow detail to set value for text, buttons, icons, etc.  Must add field to the Lookup", 1, "fa", "fa-info-circle"], ["formControlName", "workflowStatusDetailAttrName", 1, "form-control"], ["title", "Defaults to showing Action Text", 1, "fa", "fa-info-circle"], ["formControlName", "showAdminActionText"], ["formControlName", "updateInitialValueOnSet"], ["formControlName", "useCustomAttributes"], ["formControlName", "buttonDisplayAttrName", 1, "form-control"], ["formControlName", "requireValidationAttrName", 1, "form-control"], ["formControlName", "validateAfterStatusUpdate"], ["formControlName", "buttonClassAttrName", 1, "form-control"], ["formControlName", "buttonIconAttrName", 1, "form-control"], ["formControlName", "toolTipAttrName", 1, "form-control"], ["formControlName", "currentStatusAttrName", 1, "form-control"], ["formControlName", "currentStatusButtonClassAttrName", 1, "form-control"], ["formControlName", "overrideCurrentStatusDisplay"], ["type", "text", "formControlName", "buttonTextPrefix", 1, "form-control"], ["formControlName", "useLookupOverride"], ["formControlName", "showValidationRequiredExpr", 3, "contextNames", "item", "queryMeaning", "ngModelChange"], ["type", "text", "formControlName", "currentStatusDisplay", 1, "form-control"], ["formControlName", "customizeRedirect"], ["formControlName", "redirectMenuKey"], ["formControlName", "lookupIdOverride", 3, "lookupId"]], template: function DwFormWorkflowButtonsConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFormWorkflowButtonsConfigComponent_div_0_Template, 24, 7, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.DefaultValueAccessor, DwExpressionPickerControlComponent, DwSelectRouteComponent, DwSearchSelectLookupComponent]; }, encapsulation: 2 });
DwFormWorkflowButtonsConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

class DwLookupUtilService {
    constructor(dwUserSecurityService) {
        this.dwUserSecurityService = dwUserSecurityService;
    }
    buildTransitionLookups(lookupDef, lookupItems, initialValue, includeFunc) {
        if (!lookupDef.HasTransitions) {
            return lookupItems;
        }
        let limitedLookupItems = [];
        let defaultLookupItem;
        for (let transition of lookupDef.DwMetaDataLookupTransition) {
            if (this.areLookupValuesEqual(transition.TransitionFromValue, initialValue)) {
                // From value matches
                if (!transition.CanTransitionPermission || this.dwUserSecurityService.hasPermission(transition.CanTransitionPermission, true)) {
                    // Add lookup
                    const lookupItem = this.addLookupValue(limitedLookupItems, transition.TransitionToValue, false, lookupItems, includeFunc);
                    if (lookupItem) {
                        // Add transition as a reference
                        lookupItem.Transition = transition;
                    }
                    if (transition.IsDefault) {
                        defaultLookupItem = lookupItem;
                    }
                }
            }
        }
        if (initialValue) {
            this.addLookupValue(limitedLookupItems, initialValue, true, lookupItems);
        }
        // reorder lookup items so they match the original lookup order
        const tempItems = [];
        for (const lookup of lookupItems) {
            if (limitedLookupItems.indexOf(lookup) >= 0) {
                tempItems.push(lookup);
            }
        }
        limitedLookupItems = tempItems;
        return limitedLookupItems;
    }
    addLookupValue(list, value, addAtStart = false, allLookupItems, includeFunc) {
        if (typeof (value) == 'number') {
            value = value.toString();
        }
        var lookupItem = allLookupItems.find(li => li.Id == value);
        if (lookupItem) {
            if (includeFunc && !includeFunc(lookupItem)) {
                return lookupItem;
            }
            // Only add items once (even if the workflow transitions have it multiple times)
            if (list.indexOf(lookupItem) < 0) {
                if (addAtStart) {
                    list.splice(0, 0, lookupItem);
                }
                else {
                    list.push(lookupItem);
                }
            }
        }
        return lookupItem;
    }
    areLookupValuesEqual(value1, value2) {
        if (!value2) {
            if (!value1 || value1 === '') {
                return true;
            }
        }
        if (parseInt(value1) == parseInt(value2)) {
            return true;
        }
        if (value1 == value2) {
            return true;
        }
        return false;
    }
}
DwLookupUtilService.ɵfac = function DwLookupUtilService_Factory(t) { return new (t || DwLookupUtilService)(ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwLookupUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwLookupUtilService_Factory() { return new DwLookupUtilService(ɵɵinject(DwSecurityUserService)); }, token: DwLookupUtilService, providedIn: "root" });
DwLookupUtilService.ctorParameters = () => [
    { type: DwSecurityUserService }
];

var __decorate$1y = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$19 = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwFormWorkflowButtonsActionComponent = class DwFormWorkflowButtonsActionComponent {
    constructor(metaDataService, lookupUtilService, dwExpressionService, dwUiConfigRegisteryService, dwMetaDataFormStateService) {
        this.metaDataService = metaDataService;
        this.lookupUtilService = lookupUtilService;
        this.dwExpressionService = dwExpressionService;
        this.dwUiConfigRegisteryService = dwUiConfigRegisteryService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.buttonCount = new EventEmitter();
        this.lookupButtons = [];
        this.initialValueSet = false;
        this.showValidationRequiredItems = true;
    }
    get actionPreference() {
        return this._actionPreference;
    }
    set actionPreference(value) {
        this._actionPreference = value;
        this.ngOnInit();
    }
    setupComponent() {
    }
    ngOnDestroy() {
        if (this.requiredSubscription) {
            this.requiredSubscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        this.workflowButtonConfig = this.actionPreference.actionConfig;
        this.setupInitialValue();
        this.loadLookupValues();
    }
    ngOnInit() {
        if (!this.actionPreference) {
            return;
        }
        this.workflowButtonConfig = this.actionPreference.actionConfig;
        if (this.workflowButtonConfig.showValidationRequiredExpr) {
            this.setupRequiredExpressionWatch();
        }
        this.setupInitialValue();
        this.loadLookupValues();
    }
    setupRequiredExpressionWatch() {
        this.showValidationRequiredItems = false;
        if (this.requiredSubscription) {
            this.requiredSubscription.unsubscribe();
        }
        if (!this.dwMetaDataFormStateService) {
            return;
        }
        this.requiredSubscription = this.dwExpressionService.evaluateExpressionAsObservable(this.workflowButtonConfig.showValidationRequiredExpr, this.dwMetaDataFormStateService.state.rootFormGroup, this.dwMetaDataFormStateService.state.context)
            .subscribe(result => {
            this.showValidationRequiredItems = result;
            this.setupLookupItems();
        });
    }
    actionClick(lookupItem) {
        if (!this.dwMetaDataFormStateService) {
            return;
        }
        const workflowStatusDetail = this.getWorkflowStatusDetail(lookupItem);
        const validateOnSave = this.isValidationRequired(lookupItem, workflowStatusDetail);
        if (validateOnSave && !this.actionPreference.actionConfig.validateAfterStatusUpdate) {
            const validationResult = this.dwMetaDataFormStateService.state.formApi.validateForm();
            if (!validationResult.isValid) {
                this.dwMetaDataFormStateService.state.formApi.setFormAsSubmitted();
                this.dwMetaDataFormStateService.state.formApi.setFormMessage(this.dwMetaDataFormStateService.state.formApi.createValidationMessage(validationResult));
                return;
            }
        }
        // Set the value on the form
        const updatedStatus = {};
        updatedStatus[this.workflowButtonConfig.workflowAttrName] = lookupItem.Id;
        this.dwMetaDataFormStateService.state.formApi.patchFormData(updatedStatus);
        if (this.workflowButtonConfig.setStatusOnly) {
            if (this.workflowButtonConfig.updateInitialValueOnSet) {
                this.initialValue = lookupItem.Id;
            }
            this.setupLookupItems();
            return;
        }
        if (this.actionPreference.actionConfig.validateAfterStatusUpdate) {
            // We need to wait a bit for the UI to refresh and make any changes based on the updated status
            setTimeout(() => {
                this.continueAction1(lookupItem);
            }, 250);
            return;
        }
        this.continueAction1(lookupItem);
    }
    continueAction1(lookupItem) {
        const workflowStatusDetail = this.getWorkflowStatusDetail(lookupItem);
        const validateOnSave = this.isValidationRequired(lookupItem, workflowStatusDetail);
        if (validateOnSave && this.actionPreference.actionConfig.validateAfterStatusUpdate) {
            const validationResult = this.dwMetaDataFormStateService.state.formApi.validateForm();
            if (!validationResult.isValid) {
                this.dwMetaDataFormStateService.state.formApi.setFormAsSubmitted();
                this.dwMetaDataFormStateService.state.formApi.setFormMessage(this.dwMetaDataFormStateService.state.formApi.createValidationMessage(validationResult));
                return;
            }
        }
        const actionResult = {};
        const actionRegistration = this.dwUiConfigRegisteryService.getRegisteredItem(DwUiRegistryType.action, this.actionPreference.actionKey);
        this.dwMetaDataFormStateService.runBeforeActionIntercepters(this._actionPreference, actionRegistration)
            .subscribe(result => {
            if (result.abort) {
                if (result.message) {
                    this.dwMetaDataFormStateService.state.formApi.showAbortMessage(result.message);
                }
                return;
            }
            this.continueAction2(lookupItem);
        });
    }
    continueAction2(lookupItem) {
        const validateOnSave = false; // Move to above -- this.getValidateOnSave(lookupItem);
        const actionResult = {};
        const subscription = this.dwMetaDataFormStateService.state.formApi.saveData(validateOnSave)
            .subscribe(result => {
            // subscription.unsubscribe();
            if (result.success) {
                this.afterAction(result);
            }
            else {
                let errorMessage;
                if (typeof (result.message) == 'string') {
                    errorMessage = {
                        messageBody: result.message,
                        severity: DwMessageSeverity.error
                    };
                }
                else {
                    errorMessage = result.message;
                }
                this.dwMetaDataFormStateService.state.formApi.setFormMessage(errorMessage);
            }
            setTimeout(() => {
                if (subscription) {
                    subscription.unsubscribe();
                }
            });
        });
    }
    afterAction(actionResult) {
        const actionRegistration = this.dwUiConfigRegisteryService.getRegisteredItem(DwUiRegistryType.action, this.actionPreference.actionKey);
        this.dwMetaDataFormStateService.runAfterActionIntercepters(this._actionPreference, actionRegistration, actionResult)
            .subscribe(result => {
            if (result.abort) {
                return;
            }
            if (this.workflowButtonConfig.redirectAfter !== false) {
                this.dwMetaDataFormStateService.state.formApi.cancel();
            }
        });
    }
    setupInitialValue() {
        if (!this.dwMetaDataFormStateService) {
            this.setInitialValue(null);
            return;
        }
        const context = this.dwMetaDataFormStateService.state.context;
        if (!context[DwMdFormContextInfo.FORM_CONTEXT_NAME] || !context[DwMdFormContextInfo.DATA_CONTEXT_NAME]) {
            return;
        }
        const formContext = context[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        const formContextInfo = formContext.value;
        const dataContext = context[DwMdFormContextInfo.DATA_CONTEXT_NAME];
        // If form is loaded, then we can immediately get the initial value
        if (formContextInfo.loadDataComplete) {
            this.setInitialValue(dataContext.value);
            return;
        }
        // Otherwise we need to wait until data load is complete, then grab it
        formContext.subscribe((formContext) => {
            if (formContext.loadDataComplete) {
                this.setInitialValue(dataContext.value);
            }
        });
    }
    setInitialValue(formData) {
        if (this.initialValueSet) {
            return;
        }
        this.initialValue = null;
        if (formData) {
            this.initialValue = formData[this.workflowButtonConfig.workflowAttrName];
        }
        this.initialValueSet = true;
        this.setupLookupItems();
    }
    loadLookupValues() {
        if (!this.workflowButtonConfig) {
            return;
        }
        let lookupId = this.workflowButtonConfig.lookupId;
        if (this.workflowButtonConfig.useLookupOverride && this.workflowButtonConfig.lookupIdOverride) {
            lookupId = this.workflowButtonConfig.lookupIdOverride;
        }
        // Load required data at the same time, then setup lookup items
        const lookupDefOb = this.metaDataService.getLookupDefinition(lookupId);
        const lookupOb = this.metaDataService.getLookup(lookupId);
        let workflowStatusDetailOb = this.metaDataService.getWorkflowStatuses();
        if (!this.workflowButtonConfig.workflowStatusDetailAttrName) {
            workflowStatusDetailOb = of(null);
        }
        combineLatest([lookupDefOb, lookupOb, workflowStatusDetailOb])
            .subscribe(([lookupDef, lookupItems, workflowStatusDetail]) => {
            this.lookupDef = lookupDef;
            this.allLookupItems = lookupItems;
            this.workflowStatusDetails = workflowStatusDetail;
            this.setupLookupItems();
        });
    }
    setupLookupItems() {
        if (!this.lookupDef || !this.allLookupItems || !this.initialValueSet) {
            return;
        }
        let lookupItems = this.lookupUtilService.buildTransitionLookups(this.lookupDef, this.allLookupItems, this.initialValue);
        if (!this.showValidationRequiredItems) {
            lookupItems = lookupItems.filter(lookupItem => {
                const workflowStatusDetail = this.getWorkflowStatusDetail(lookupItem);
                const required = this.isValidationRequired(lookupItem, workflowStatusDetail);
                if (required) {
                    return false;
                }
                return true;
            });
        }
        this.setupLookupButtons(lookupItems);
    }
    getWorkflowStatusDetail(lookupItem) {
        let workflowStatusDetail;
        if (this.workflowButtonConfig.workflowStatusDetailAttrName) {
            const detailId = lookupItem[this.workflowButtonConfig.workflowStatusDetailAttrName];
            if (detailId) {
                workflowStatusDetail = this.workflowStatusDetails.find(d => d.WorkflowStatusDetailId == detailId);
            }
        }
        return workflowStatusDetail;
    }
    setupLookupButtons(lookupItems) {
        if (!lookupItems) {
            return;
        }
        this.lookupButtons = [];
        const defaultButtonClass = this.actionPreference.buttonConfig.buttonClass || 'btn btn-success';
        for (var lookupItem of lookupItems) {
            const workflowStatusDetail = this.getWorkflowStatusDetail(lookupItem);
            var buttonConfig = {
                lookupItem: lookupItem,
                buttonConfig: {
                    buttonClass: this.getButtonClass(lookupItem, workflowStatusDetail) || defaultButtonClass,
                    buttonText: this.getLookupItemDisplay(lookupItem, workflowStatusDetail),
                    buttonTitle: this.getLookupItemTooltip(lookupItem, workflowStatusDetail),
                    iconClass: this.getLookupIconClass(lookupItem, workflowStatusDetail)
                }
            };
            if (lookupItem.Id != this.initialValue || !this.workflowButtonConfig.hideCurrentStatus) {
                this.lookupButtons.push(buttonConfig);
            }
        }
        this.buttonCount.emit(this.lookupButtons.length);
    }
    getLookupItemDisplay(lookupItem, workflowStatusDetail) {
        if (lookupItem.Id == this.initialValue) {
            if (this.workflowButtonConfig.useCustomAttributes && this.workflowButtonConfig.currentStatusAttrName) {
                if (lookupItem[this.workflowButtonConfig.currentStatusAttrName]) {
                    return lookupItem[this.workflowButtonConfig.currentStatusAttrName];
                }
            }
            if (workflowStatusDetail === null || workflowStatusDetail === void 0 ? void 0 : workflowStatusDetail.CurrentStatusActionText) {
                return workflowStatusDetail === null || workflowStatusDetail === void 0 ? void 0 : workflowStatusDetail.CurrentStatusActionText;
            }
            if (this.workflowButtonConfig.overrideCurrentStatusDisplay && this.workflowButtonConfig.currentStatusDisplay) {
                return this.workflowButtonConfig.currentStatusDisplay;
            }
        }
        if (lookupItem.Transition && lookupItem.Transition.AlternateActionDisplay) {
            return lookupItem.Transition.AlternateActionDisplay;
        }
        // if (lookupItem.Id == this.initialValue && this.workflowButtonConfig.overrideCurrentStatusDisplay && this.workflowButtonConfig.currentStatusDisplay) {
        //     if (this.workflowButtonConfig.useCustomAttributes && this.workflowButtonConfig.currentStatusAttrName) {
        //         if (lookupItem[this.workflowButtonConfig.currentStatusAttrName]) {
        //             return lookupItem[this.workflowButtonConfig.currentStatusAttrName];
        //         }
        //     }
        //     return this.workflowButtonConfig.currentStatusDisplay;
        // }
        if (workflowStatusDetail) {
            if (this.workflowButtonConfig.showAdminActionText && workflowStatusDetail.AdminActionText) {
                return workflowStatusDetail.AdminActionText;
            }
            if (!this.workflowButtonConfig.showAdminActionText && workflowStatusDetail.ActionText) {
                return workflowStatusDetail.ActionText;
            }
        }
        if (this.workflowButtonConfig.useCustomAttributes && this.workflowButtonConfig.buttonDisplayAttrName) {
            const display = lookupItem[this.workflowButtonConfig.buttonDisplayAttrName];
            if (display) {
                return display;
            }
        }
        const statusPrefix = this.workflowButtonConfig.buttonTextPrefix || '';
        return `${statusPrefix}${lookupItem.Display}`;
    }
    getButtonClass(lookupItem, workflowStatusDetail) {
        // Return button class override when it's the current status
        if (lookupItem.Id == this.initialValue && this.workflowButtonConfig.useCustomAttributes && this.workflowButtonConfig.currentStatusButtonClassAttrName) {
            if (lookupItem[this.workflowButtonConfig.currentStatusButtonClassAttrName]) {
                return lookupItem[this.workflowButtonConfig.currentStatusButtonClassAttrName];
            }
        }
        if (lookupItem.Id == this.initialValue && (workflowStatusDetail === null || workflowStatusDetail === void 0 ? void 0 : workflowStatusDetail.CurrentStatusButtonClasses)) {
            return workflowStatusDetail.CurrentStatusButtonClasses;
        }
        if (workflowStatusDetail === null || workflowStatusDetail === void 0 ? void 0 : workflowStatusDetail.ButtonClasses) {
            return workflowStatusDetail.ButtonClasses;
        }
        if (this.workflowButtonConfig.buttonClassAttrName) {
            return lookupItem[this.workflowButtonConfig.buttonClassAttrName];
        }
        return this.actionPreference.buttonConfig.buttonClass;
    }
    getLookupIconClass(lookupItem, workflowStatusDetail) {
        if (this.workflowButtonConfig.buttonIconAttrName) {
            return lookupItem[this.workflowButtonConfig.buttonIconAttrName];
        }
        if (workflowStatusDetail === null || workflowStatusDetail === void 0 ? void 0 : workflowStatusDetail.IconClasses) {
            return workflowStatusDetail.IconClasses;
        }
        return this.actionPreference.buttonConfig.iconClass;
    }
    getLookupItemTooltip(lookupItem, workflowStatusDetail) {
        if (this.workflowButtonConfig.toolTipAttrName) {
            return lookupItem[this.workflowButtonConfig.toolTipAttrName];
        }
        if (workflowStatusDetail === null || workflowStatusDetail === void 0 ? void 0 : workflowStatusDetail.TooltipText) {
            return workflowStatusDetail.TooltipText;
        }
        return '';
    }
    isValidationRequired(lookupItem, workflowStatusDetail) {
        if (this.workflowButtonConfig.setStatusOnly) {
            return false;
        }
        if (this.workflowButtonConfig.requireValidationAttrName && this.workflowButtonConfig.useCustomAttributes) {
            const requireValidation = lookupItem[this.workflowButtonConfig.requireValidationAttrName];
            return (requireValidation === 'True');
        }
        if (workflowStatusDetail) {
            return workflowStatusDetail.ValidationRequired == true;
        }
        return this.workflowButtonConfig.requireValidation !== false;
    }
};
DwFormWorkflowButtonsActionComponent.ɵfac = function DwFormWorkflowButtonsActionComponent_Factory(t) { return new (t || DwFormWorkflowButtonsActionComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwLookupUtilService), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService, 8)); };
DwFormWorkflowButtonsActionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormWorkflowButtonsActionComponent, selectors: [["dw-form-workflow-buttons"]], inputs: { actionPreference: "actionPreference" }, outputs: { buttonCount: "buttonCount" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [3, "buttonConfig", "click"]], template: function DwFormWorkflowButtonsActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFormWorkflowButtonsActionComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.lookupButtons);
    } }, directives: [ɵngcc4.NgForOf, DwButtonComponent], encapsulation: 2 });
DwFormWorkflowButtonsActionComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwLookupUtilService },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataFormStateService, decorators: [{ type: Optional }] }
];
DwFormWorkflowButtonsActionComponent.propDecorators = {
    actionPreference: [{ type: Input }],
    buttonCount: [{ type: Output }]
};
DwFormWorkflowButtonsActionComponent = __decorate$1y([
    DwAction({
        keyName: DwFormActionKeys.formWorkflow,
        display: 'Workflow Buttons',
        actionMessage: 'Saving...',
        decoratorType: DwDecoratorType.component,
        configComponent: DwFormWorkflowButtonsConfigComponent,
        actionType: DwActionType.formAction,
        isGlobal: true,
        allowOnce: true,
        order: 5,
        isButtonComponent: true,
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonType: DwButtonType.standard,
            buttonClass: 'btn btn-success',
        },
        defaultSecurityConfig: {
            requireCanUpdate: true
        },
        configData: {
            requireValidation: true,
            redirectAfter: true,
        }
    }),
    __metadata$19("design:paramtypes", [DwMetaDataService,
        DwLookupUtilService,
        DwExpressionService,
        DwUiConfigRegistryService,
        DwMetaDataFormStateService])
], DwFormWorkflowButtonsActionComponent);

var __decorate$1z = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1a = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwSelectLookupConfigComponent extends DwChildConfigBaseComponent {
    constructor(metaDataService, dwExpressionService, uiMetaDataConfig) {
        super();
        this.metaDataService = metaDataService;
        this.dwExpressionService = dwExpressionService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.hideAdditionalDisplay = false;
        this.hideUseTransitions = false;
    }
    getDefaultConfig() {
        //this.configContext.metaDataQueryMeaning
        return {};
    }
    initConfig() {
        // Ensure config is always initialized
        this.config = this.config || {};
        this.config.lookupParamAttributeOverrides = this.config.lookupParamAttributeOverrides || [];
        this.config.lookupIdOverride = this.config.lookupIdOverride ||
            {
                referenceType: DwExpressionReferenceType.value
            };
        super.initConfig();
        if (!this.dwExpressionService.isEmpyExpressionReference(this.config.lookupIdOverride) && this.config.useLookupOverride !== false) {
            this.config.useLookupOverride = true;
        }
        this.setupLookupDef();
        this.setupLookupOverrideDropdown();
    }
    onLookupOverrideChange() {
        this.setupLookupDef();
        this.onChange();
    }
    setupLookupDef() {
        let lookupId = this.configContext.queryAttr.Attribute.MetaDataLookupId;
        if (this.config.useLookupOverride && !this.dwExpressionService.isEmpyExpressionReference(this.config.lookupIdOverride)) {
            lookupId = this.config.lookupIdOverride.value;
        }
        this.lookupDef = null;
        if (lookupId) {
            this.metaDataService.getLookupDefinition(lookupId)
                .subscribe(lookupDef => {
                this.lookupDef = lookupDef;
                // Init the config fields
                this.config.lookupParamAttributeOverrides = this.config.lookupParamAttributeOverrides || [];
                if (lookupDef.DwMetaDataLookupParam) {
                    for (let index = 0; index < lookupDef.DwMetaDataLookupParam.length; index++) {
                        if (!this.config.lookupParamAttributeOverrides[index]) {
                            this.config.lookupParamAttributeOverrides[index] = {
                                referenceType: DwExpressionReferenceType.item
                            };
                        }
                    }
                }
            });
        }
    }
    setupLookupOverrideDropdown() {
        this.lookupRefItem = DevwareMetaDataItemNames.DwMetaDataAttribute;
        this.lookupRelatedExprRef = {
            referenceType: DwExpressionReferenceType.item,
            attrName: "MetaDataLookupId",
        };
    }
}
DwSelectLookupConfigComponent.ɵfac = function DwSelectLookupConfigComponent_Factory(t) { return new (t || DwSelectLookupConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken)); };
DwSelectLookupConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSelectLookupConfigComponent, selectors: [["dw-select-lookup-config"]], inputs: { hideAdditionalDisplay: "hideAdditionalDisplay", hideUseTransitions: "hideUseTransitions" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [["dwRow", "", 4, "ngIf"], [4, "ngIf"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwCol", "12", 1, "expr-column-full"], [3, "ngModel", "contextNames", "item", "relatedExprRef", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden", 4, "ngIf"], ["dwRow", "", 4, "ngFor", "ngForOf"], [3, "ngModel", "contextNames", "item", "queryMeaning", "ngModelChange"]], template: function DwSelectLookupConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwSelectLookupConfigComponent_div_0_Template, 5, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwSelectLookupConfigComponent_ng_container_1_Template, 12, 7, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, DwSelectLookupConfigComponent_ng_container_2_Template, 6, 1, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.useLookupOverride);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lookupDef && (ctx.lookupDef.DwMetaDataLookupParam == null ? null : ctx.lookupDef.DwMetaDataLookupParam.length) > 0);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwExpressionReferenceControlComponent, ɵngcc3.DefaultValueAccessor, ɵngcc4.NgForOf], styles: [""] });
DwSelectLookupConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwSelectLookupConfigComponent.propDecorators = {
    hideAdditionalDisplay: [{ type: Input }],
    hideUseTransitions: [{ type: Input }]
};
__decorate$1z([
    DwInputConverter(booleanConverter),
    __metadata$1a("design:type", Boolean)
], DwSelectLookupConfigComponent.prototype, "hideAdditionalDisplay", void 0);
__decorate$1z([
    DwInputConverter(booleanConverter),
    __metadata$1a("design:type", Boolean)
], DwSelectLookupConfigComponent.prototype, "hideUseTransitions", void 0);

class DwExpressionDescriptionService {
    constructor(dwMetaDataService, dwContextService, dwExpressionService, dwExpressionComparerService, dwDataFormatService, uiMetaDataConfig) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextService = dwContextService;
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionComparerService = dwExpressionComparerService;
        this.dwDataFormatService = dwDataFormatService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.compareTypeList = new DwExpressionCompareTypeList();
    }
    buildExpressionGroupItemDesc(itemName, exprGroupItem, queryMeaning) {
        let evalResult;
        if (this.dwExpressionService.isEmptyExpressionGroupItem(exprGroupItem)) {
            return of('');
        }
        if ('expressions' in exprGroupItem) {
            // Expression Group
            return this.buildExpressionGroupDesc(itemName, exprGroupItem, queryMeaning);
        }
        else {
            // Expression
            return this.buildExpressionDesc(itemName, exprGroupItem, queryMeaning);
        }
    }
    buildExpressionGroupDesc(itemName, exprGroup, queryMeaning) {
        let expressionDescArray = [];
        var obs = [];
        for (let expr of exprGroup.expressions) {
            obs.push(this.buildExpressionGroupItemDesc(itemName, expr, queryMeaning));
        }
        let totalExprCount = this.getValidExpressionCount(exprGroup);
        return combineLatest(obs)
            .pipe(map(exprResults => {
            let index = 0;
            for (let exprResult of exprResults) {
                let childExprCount = this.getValidExpressionCount(exprGroup.expressions[index]);
                if (childExprCount == 1) {
                    expressionDescArray.push(exprResult);
                }
                if (childExprCount > 1) {
                    expressionDescArray.push(`<div class='exprGroup'>${exprResult}</div>`);
                }
                index++;
            }
            if (exprResults.length === 0) {
                return null;
            }
            return expressionDescArray.join(`<div class="exprOp">${exprGroup.operator}</div>`);
        }));
    }
    getValidExpressionCount(exprGroupItem) {
        if ('expressions' in exprGroupItem) {
            // Expression Group
            let count = 0;
            for (let expr of exprGroupItem.expressions) {
                let childCount = this.getValidExpressionCount(expr);
                if (childCount > 0) {
                    count++;
                }
            }
            return count;
        }
        else {
            if (this.isBlankReference(exprGroupItem === null || exprGroupItem === void 0 ? void 0 : exprGroupItem.reference1) || this.isBlankReference(exprGroupItem === null || exprGroupItem === void 0 ? void 0 : exprGroupItem.reference2)) {
                return 0;
            }
            return 1;
        }
    }
    isBlankReference(exprReference) {
        switch (exprReference === null || exprReference === void 0 ? void 0 : exprReference.referenceType) {
            case DwExpressionReferenceType.item:
            case DwExpressionReferenceType.context:
                if (exprReference === null || exprReference === void 0 ? void 0 : exprReference.attrName) {
                    return false;
                }
            case DwExpressionReferenceType.value:
                if ((exprReference === null || exprReference === void 0 ? void 0 : exprReference.value) !== null) {
                    return false;
                }
        }
        ;
        return true;
    }
    buildExpressionDesc(itemName, dwExpression, queryMeaning) {
        if (this.dwExpressionService.isEmptyExpressionGroupItem(dwExpression)) {
            return of(null);
        }
        if (this.isBlankReference(dwExpression === null || dwExpression === void 0 ? void 0 : dwExpression.reference1) || this.isBlankReference(dwExpression === null || dwExpression === void 0 ? void 0 : dwExpression.reference2)) {
            return of(null);
        }
        let ref1Ob = this.buildExpressionReferenceDesc(itemName, dwExpression.reference1, null, null, queryMeaning);
        let ref2Ob = this.buildExpressionReferenceDesc(itemName, dwExpression.reference2, dwExpression.reference1, dwExpression.compareType, queryMeaning);
        let compareTypeDesc = this.compareTypeList.getEnumDisplay(dwExpression.compareType);
        return combineLatest([ref1Ob, ref2Ob])
            .pipe(map(([ref1Desc, ref2Desc]) => {
            let ref2Html = '';
            if (this.dwExpressionComparerService.compareNeedsValue(dwExpression.compareType)) {
                ref2Html = `<div class="expr2">${ref2Desc}</div>`;
            }
            let exprDescHtml = `<div class="expr"><div class="expr1">${ref1Desc}</div> <div class="exprCompare">${compareTypeDesc}</div>${ref2Html}</div>`;
            return exprDescHtml;
        }));
    }
    buildExpressionReferenceDesc(itemName, exprRef, relatedExprRef, comparerType, queryMeaning) {
        if (this.isBlankReference(exprRef)) {
            return of(null);
        }
        return this.getReferecenMetaData(itemName, exprRef, relatedExprRef, queryMeaning)
            .pipe(map(refMetaData => {
            var _a, _b, _c;
            switch (exprRef.referenceType) {
                case DwExpressionReferenceType.item:
                    if (!((_a = refMetaData === null || refMetaData === void 0 ? void 0 : refMetaData.attribute) === null || _a === void 0 ? void 0 : _a.AttributeDisplay)) {
                        console.warn('DwExpressionService - Ref Meta data attribute not returned', refMetaData, itemName, exprRef, queryMeaning);
                    }
                    const display = ((_b = refMetaData === null || refMetaData === void 0 ? void 0 : refMetaData.attribute) === null || _b === void 0 ? void 0 : _b.AttributeDisplay) || `Missing ${exprRef.attrName}`;
                    return display;
                case DwExpressionReferenceType.context:
                    if (!exprRef.attrName) {
                        return `${refMetaData.itemDisplayName}.[No Property Selected]`;
                    }
                    return `${refMetaData.itemDisplayName}.${((_c = refMetaData.attribute) === null || _c === void 0 ? void 0 : _c.AttributeDisplay) || `Missing ${exprRef.attrName}`} `;
                default:
                    let value = exprRef.value;
                    if (value && refMetaData.lookupItems) {
                        value = value.toString();
                        const values = ensureArray(value.split(","));
                        const list = [];
                        values.forEach(value => {
                            let lookupItem = refMetaData.lookupItems.find(li => li.Id == value);
                            if (lookupItem) {
                                value = lookupItem.Display;
                                list.push(value);
                            }
                        });
                        value = list.join(", ");
                    }
                    const formattedValue = this.formatDisplayValue(value, refMetaData.attribute, comparerType);
                    return formattedValue;
            }
        }));
    }
    formatDisplayValue(value, queryAttribute, comparerType) {
        // Hanlde any specific conditions for formatters (added for date/time comparers by day & hour)
        const comparerFormatResult = this.dwExpressionComparerService.getValueDescriptionByCompareType(value, comparerType);
        if (comparerFormatResult.handled) {
            return comparerFormatResult.result;
        }
        const formatOptions = this.dwMetaDataService.getAttributeFormatOptions(queryAttribute === null || queryAttribute === void 0 ? void 0 : queryAttribute.Attribute, this.uiMetaDataConfig.use24HourTime, this.uiMetaDataConfig.useGmtDateTime);
        formatOptions.textSurroundChar = `'`;
        return this.dwDataFormatService.formatValue(value, formatOptions);
    }
    getReferecenMetaData(itemName, exprRef, relatedExprRef, queryMeaning) {
        let attrObservable;
        switch (exprRef.referenceType) {
            case DwExpressionReferenceType.item:
                return this.getItemReferenceMetaData(itemName, exprRef, queryMeaning);
                break;
            case DwExpressionReferenceType.context:
                return this.getContextReferenceMetaData(exprRef);
                break;
            case DwExpressionReferenceType.value:
                if (relatedExprRef) {
                    return this.getReferecenMetaData(itemName, relatedExprRef, null, queryMeaning);
                }
        }
        return of(null);
    }
    getItemReferenceMetaData(itemName, exprRef, queryMeaning) {
        return this.dwMetaDataService.getSavedQueryMetaData(itemName, null, queryMeaning)
            .pipe(mergeMap(queryMd => {
            var _a, _b, _c, _d;
            let exprMd = {
                referenceType: exprRef.referenceType,
                itemDisplayName: itemName,
                attribute: queryMd.Attributes.find(a => a.AttributeName == exprRef.attrName),
            };
            if (((_b = (_a = exprMd.attribute) === null || _a === void 0 ? void 0 : _a.Attribute) === null || _b === void 0 ? void 0 : _b.MetaDataLookupId) && ((_d = (_c = exprMd.attribute) === null || _c === void 0 ? void 0 : _c.Attribute) === null || _d === void 0 ? void 0 : _d.IsLookup)) {
                return this.dwMetaDataService.getLookup(exprMd.attribute.Attribute.MetaDataLookupId)
                    .pipe(map(lookupItems => {
                    exprMd.lookupItems = lookupItems;
                    return exprMd;
                }));
            }
            return of(exprMd);
        }));
    }
    getContextReferenceMetaData(exprRef) {
        return this.dwContextService.getContextMetaData(exprRef.contextName)
            .pipe(mergeMap(contextMd => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            let exprMd = {
                referenceType: exprRef.referenceType,
                itemDisplayName: ((_a = contextMd === null || contextMd === void 0 ? void 0 : contextMd.contextDef) === null || _a === void 0 ? void 0 : _a.contextDisplay) || 'Not Found',
                attribute: contextMd.attributes.find(a => a.AttributeName == exprRef.attrName),
            };
            if ((_c = (_b = exprMd.attribute) === null || _b === void 0 ? void 0 : _b.Attribute) === null || _c === void 0 ? void 0 : _c.CustomListValues) {
                exprMd.lookupItems = (_e = (_d = exprMd.attribute) === null || _d === void 0 ? void 0 : _d.Attribute) === null || _e === void 0 ? void 0 : _e.CustomListValues;
            }
            else {
                if (((_g = (_f = exprMd.attribute) === null || _f === void 0 ? void 0 : _f.Attribute) === null || _g === void 0 ? void 0 : _g.MetaDataLookupId) && ((_j = (_h = exprMd.attribute) === null || _h === void 0 ? void 0 : _h.Attribute) === null || _j === void 0 ? void 0 : _j.IsLookup)) {
                    return this.dwMetaDataService.getLookup(exprMd.attribute.Attribute.MetaDataLookupId)
                        .pipe(map(lookupItems => {
                        exprMd.lookupItems = lookupItems;
                        return exprMd;
                    }));
                }
            }
            return of(exprMd);
        }));
    }
}
DwExpressionDescriptionService.ɵfac = function DwExpressionDescriptionService_Factory(t) { return new (t || DwExpressionDescriptionService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwExpressionComparersService), ɵngcc0.ɵɵinject(DwDataFormatService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwExpressionDescriptionService.ɵprov = ɵɵdefineInjectable({ factory: function DwExpressionDescriptionService_Factory() { return new DwExpressionDescriptionService(ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwContextService), ɵɵinject(DwExpressionService), ɵɵinject(DwExpressionComparersService), ɵɵinject(DwDataFormatService), ɵɵinject(DwUIMetaDataConfigToken)); }, token: DwExpressionDescriptionService, providedIn: "root" });
DwExpressionDescriptionService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService },
    { type: DwExpressionService },
    { type: DwExpressionComparersService },
    { type: DwDataFormatService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];

class DwExpressionPickerControlComponent extends DwControlBaseComponent {
    constructor(dwExpressionService, dwExpressionDescriptionService, cdr) {
        super();
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionDescriptionService = dwExpressionDescriptionService;
        this.cdr = cdr;
        this.contextNames = [];
        this.buttonText = 'Create Expression (Initial)';
        this.addButtonText = 'Create Expression';
        this.editButtonText = 'Edit Expression';
        this.clearButtonText = 'Clear';
    }
    ngOnChanges(changes) {
        if (changes.item || changes.contextNames || changes.querymeaning) {
            if (!isFirstChange(changes)) {
                this.setupExpressionPicker();
            }
        }
    }
    ngOnInit() {
    }
    writeValue(value) {
        super.writeValue(value);
        this.editingExprGroup = deepCopy(value);
        this.exprGroup = value;
        this.setupExpressionPicker();
    }
    setValue(exprGroup) {
        this.exprGroup = exprGroup;
        this.editingExprGroup = deepCopy(exprGroup);
        super.setValue(exprGroup);
        this.setupExpressionPicker();
    }
    setupExpressionPicker() {
        this.dwExpressionDescriptionService.buildExpressionGroupItemDesc(this.item, this.exprGroup, this.queryMeaning)
            .subscribe(exprDesc => {
            this.exprDesc = exprDesc;
            if (!this.destroyed) {
                this.cdr.detectChanges();
            }
        });
        const emptyExpr = this.dwExpressionService.isEmptyExpressionGroupItem(this.exprGroup);
        this.showClear = !emptyExpr;
        this.buttonText = emptyExpr ? this.addButtonText : this.editButtonText;
        if (!this.destroyed) {
            this.cdr.detectChanges();
        }
    }
    clearExpression() {
        this.setValue(null);
    }
    closePopup(cancel = false) {
        if (!cancel) {
            this.setValue(deepCopy(this.editingExprGroup));
        }
        else {
            this.editingExprGroup = deepCopy(this.exprGroup);
        }
        this.editExprPopup.hide();
    }
}
DwExpressionPickerControlComponent.ɵfac = function DwExpressionPickerControlComponent_Factory(t) { return new (t || DwExpressionPickerControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwExpressionDescriptionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwExpressionPickerControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExpressionPickerControlComponent, selectors: [["dw-expression-picker-control"]], viewQuery: function DwExpressionPickerControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c76, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.editExprPopup = _t.first);
    } }, inputs: { contextNames: "contextNames", addButtonText: "addButtonText", editButtonText: "editButtonText", clearButtonText: "clearButtonText", item: "item", queryMeaning: "queryMeaning" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwExpressionPickerControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "expr-container"], [3, "ngModel"], ["type", "button", 1, "btn-sm", "btn-success", 3, "click"], ["type", "button", "class", "btn-sm btn-danger", 3, "click", 4, "ngIf"], ["style2", "{ width: '750px', min-height:'200px'}", "appendTo", "body", 3, "showCloseIcon", "dismissable", "onHide"], ["editExpr", ""], ["pTemplate", ""], ["type", "button", 1, "btn-sm", "btn-danger", 3, "click"], [2, "height", "300px", "overflow-y", "auto"], [2, "width", "calc(100% - 20px)"], [3, "item", "contextNames", "queryMeaning", "ngModel", "ngModelChange"], ["type", "button", 1, "btn", "btn-success", 3, "click"], ["type", "button", 1, "btn", "btn-danger", 3, "click"]], template: function DwExpressionPickerControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwExpressionPickerControlComponent_div_0_Template, 2, 0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwExpressionPickerControlComponent_ng_container_1_Template, 10, 8, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.item && (!ctx.contextNames || (ctx.contextNames == null ? null : ctx.contextNames.length) == 0));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(!ctx.item && (!ctx.contextNames || (ctx.contextNames == null ? null : ctx.contextNames.length) == 0)));
    } }, directives: [ɵngcc4.NgIf, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc31.OverlayPanel, ɵngcc6.PrimeTemplate, DwExpressionGroupControlComponent, DwButtonBarComponent], styles: [".expr{border-radius:5px;float:left;padding:5px}.expr1{background-color:green}.expr1,.expr2{border-radius:5px;color:#fff;float:left;padding:4px}.expr2{background-color:#00f}.exprCompare{float:left;padding:4px}.exprGroup{border:1px dashed #000;float:left;margin:3px}.exprOp{border-radius:5px;float:left;font-weight:700;margin:5px;padding:4px}.expr-container{margin-bottom:5px;overflow:auto;width:100%}"], encapsulation: 2 });
DwExpressionPickerControlComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwExpressionDescriptionService },
    { type: ChangeDetectorRef }
];
DwExpressionPickerControlComponent.propDecorators = {
    item: [{ type: Input }],
    contextNames: [{ type: Input }],
    queryMeaning: [{ type: Input }],
    editExprPopup: [{ type: ViewChild, args: ['editExpr',] }],
    addButtonText: [{ type: Input }],
    editButtonText: [{ type: Input }],
    clearButtonText: [{ type: Input }]
};

class DwCustomContextBase {
    getContextDefinition(contextRegistration) {
        const contextDef = {
            contextName: contextRegistration.keyName,
            contextDisplay: contextRegistration.display,
            isGlobal: contextRegistration.isGlobal,
            firstOnly: contextRegistration.firstOnly,
            item: contextRegistration.item,
            parentItem: contextRegistration.parentItem,
            isCustomUiContext: contextRegistration.isCustomUiContext,
            customUIContextType: contextRegistration.customUIContextType,
            useItemMetaData: !(contextRegistration.useItemMetaData === false) && !!contextRegistration.item,
        };
        const ob = this.setupContextDefinition(contextDef);
        if (ob instanceof Observable) {
            return ob.pipe(map(() => contextDef));
        }
        return contextDef;
    }
    addProperty(attributes, name, display, attrType, controlType, lookupId) {
        let attr = {
            AttributeName: name,
            Display: display,
            AttributeType: attrType || DwAttributeType.Text,
            MetaDataControlTypeId: controlType || DwControlType.Textbox,
            MetaDataLookupId: lookupId,
            IsLookup: !!lookupId,
        };
        let mdQueryAttr = {
            Attribute: attr,
            FieldType: DwFieldType.Standard,
            AttributeDisplay: attr.Display,
            AttributeType: attr.AttributeType,
            AttributeName: attr.AttributeName,
            HasDisplayField: false,
            DisplayAttributeName: attr.AttributeName,
        };
        attributes.push(mdQueryAttr);
        return mdQueryAttr;
    }
    addListValue(listValues, id, display) {
        let lookupItem = {
            Id: id,
            Display: display
        };
        listValues.push(lookupItem);
    }
}

function DwCustomContextDefinition(customContextReg) {
    return function (constructor) {
        DwCustomContextDefinitionFunc(customContextReg, constructor);
    };
}
function DwCustomContextDefinitionFunc(customContextReg, type) {
    const finalReg = Object.assign(Object.assign({}, customContextReg), { keyName: customContextReg.keyName || customContextReg.display, isGlobal: customContextReg.isGlobal || false, firstOnly: !(customContextReg.firstOnly === false), type: type });
    let uiConfigRegistyService = new DwUiConfigRegistryService();
    uiConfigRegistyService.registerItem(DwUiRegistryType.customContext, finalReg);
}

var __decorate$1A = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1b = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwMetaDataFormContextService = class DwMetaDataFormContextService extends DwCustomContextBase {
    constructor(dwSecurityUserService, metadataConfig) {
        super();
        this.dwSecurityUserService = dwSecurityUserService;
        this.metadataConfig = metadataConfig;
    }
    setupContextDefinition(userContextDef) {
        userContextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
        // data is populated by the form automatically
        userContextDef.data = {};
        userContextDef.attributes = this.getContextAttribute();
    }
    getContextAttribute() {
        const attributes = [];
        this.addProperty(attributes, 'keyValue', 'Key Value', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'rootItemName', 'Root Item');
        this.addProperty(attributes, 'loadDataComplete', 'Load Complete');
        this.addProperty(attributes, 'isReadOnly', 'Is Read Only', DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(attributes, 'isModal', 'Is Modal', DwAttributeType.YesNo, DwControlType.Checkbox);
        const contextModeAttr = this.addProperty(attributes, 'contextMode', 'Form Mode (Add/Edit)', DwAttributeType.Text, DwControlType.DropDownList);
        const customListValue = contextModeAttr.Attribute.CustomListValues = [];
        this.addListValue(customListValue, DwFormContextMode.add, 'Add');
        this.addListValue(customListValue, DwFormContextMode.edit, 'Edit');
        this.addListValue(customListValue, DwFormContextMode.view, 'View');
        this.addListValue(customListValue, DwFormContextMode.print, 'Print');
        return attributes;
    }
};
DwMetaDataFormContextService.ɵfac = function DwMetaDataFormContextService_Factory(t) { return new (t || DwMetaDataFormContextService)(ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwMetaDataFormContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataFormContextService, factory: function (t) { return DwMetaDataFormContextService.ɵfac(t); } });
DwMetaDataFormContextService.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwMetaDataFormContextService = __decorate$1A([
    DwCustomContextDefinition({
        keyName: DwMdFormContextInfo.FORM_CONTEXT_NAME,
        display: 'Form Context',
        isGlobal: false,
        isCustomUiContext: true,
        customUIContextType: 'Form'
    }),
    __metadata$1b("design:paramtypes", [DwSecurityUserService, Object])
], DwMetaDataFormContextService);

const DwUserContextDynamicHandlerToken = 'DwUserContextDynamicHandler';

var __decorate$1B = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1c = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwUserContextService = class DwUserContextService extends DwCustomContextBase {
    constructor(dwSecurityUserService, metadataConfig, dwContextRepositoryService, dynamicHandler) {
        super();
        this.dwSecurityUserService = dwSecurityUserService;
        this.metadataConfig = metadataConfig;
        this.dwContextRepositoryService = dwContextRepositoryService;
        this.dynamicHandler = dynamicHandler;
    }
    setupContextDefinition(userContextDef) {
        return this.dwContextRepositoryService.getUserAttributeData()
            .pipe(mergeMap(userExtendedData => {
            const ob = this.setupUserContextDefinition(userContextDef, userExtendedData);
            if (ob) {
                return ob;
            }
            return of(null);
        }));
    }
    setupUserContextDefinition(userContextDef, userExtendedData) {
        var _a;
        userContextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
        userContextDef.noCache = true;
        userContextDef.data = {};
        userContextDef.getCustomContextFunction = (context, contextData) => {
            var _a, _b, _c;
            if (!this.dwSecurityUserService.securityState.isAuthenticated) {
                return {};
            }
            const appUser = deepCopy(this.dwSecurityUserService.securityState.securityContext.ApplicationUser);
            // Convert extended attributes to properties (This allows extended attribute to be accessed just like the other properties)
            for (const extAttr of appUser.ExtendedAttributes || []) {
                appUser[extAttr.AttrName] = extAttr.AttrValue;
            }
            appUser.IsEmulating = ((_a = this.dwSecurityUserService.securityState.securityContext.ApplicationUser) === null || _a === void 0 ? void 0 : _a.UserId) != ((_b = this.dwSecurityUserService.securityState.securityContext.AuthenticatedUser) === null || _b === void 0 ? void 0 : _b.UserId);
            appUser.AuthenticationPermissions = deepCopy(this.dwSecurityUserService.securityState.securityContext.AuthenticatedUser.Permissions);
            if ((_c = this.dynamicHandler) === null || _c === void 0 ? void 0 : _c.customizeUserContext) {
                return this.dynamicHandler.customizeUserContext(appUser, context, userExtendedData);
            }
            return appUser;
        };
        userContextDef.attributes = this.getContextAttribute(userExtendedData);
        if ((_a = this.dynamicHandler) === null || _a === void 0 ? void 0 : _a.setupUserContextDefinition) {
            return this.dynamicHandler.setupUserContextDefinition(userContextDef, userExtendedData);
        }
    }
    getContextAttribute(userExtendedData) {
        var _a, _b;
        const attributes = [];
        this.addProperty(attributes, 'UserId', 'User Id', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'FirstName', 'First Name');
        this.addProperty(attributes, 'LastName', 'Last Name');
        this.addProperty(attributes, 'IsEmulating', 'Is Emulating', DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addPermissionAttributes(attributes);
        for (const extAttr of (userExtendedData === null || userExtendedData === void 0 ? void 0 : userExtendedData.Attributes) || []) {
            const lookupId = (_a = extAttr.Attribute) === null || _a === void 0 ? void 0 : _a.MetaDataLookupId;
            this.addProperty(attributes, extAttr.AttributeName, extAttr.AttributeDisplay, extAttr.AttributeType, ((_b = extAttr.Attribute) === null || _b === void 0 ? void 0 : _b.MetaDataControlTypeId) | DwControlType.NumericTextBox, lookupId);
        }
        for (const extAttr of this.metadataConfig.userContextExtendedAttributes || []) {
            this.addProperty(attributes, extAttr.name, extAttr.display, extAttr.attrType, extAttr.controlType, extAttr.lookupId);
        }
        this.addProperty(attributes, 'FirstNameLastName', 'First/Last Name');
        this.addProperty(attributes, 'LastNameFirstName', 'Last/First Name');
        this.addProperty(attributes, 'Email', 'E-mail');
        this.addProperty(attributes, 'UserName', 'User Name');
        this.addProperty(attributes, 'MobilePhone', 'Mobile Phone');
        this.addProperty(attributes, 'UserPictureMediaId', 'User Picture Media Id', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'UserBackgroundMediaId', 'User Background Media Id', DwAttributeType.Integer, DwControlType.NumericTextBox);
        // var dwMd = new DevwareMetaDataService();
        // var hasPermissionAttr: DwExpressionAttribute = this.addProperty(attributes, 'Permissions', 'Has Permission', DwAttributeType.Text, DwControlType.DropDownList);
        // hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        // hasPermissionAttr.Attribute.MetaDataLookupId = DevwareMetaDataLookups.AppPermissionByMeaning;
        // var hasAuthPermissionAttr: DwExpressionAttribute = this.addProperty(attributes, 'AuthenticationPermissions', 'Has Permission (Auth User)', DwAttributeType.Text, DwControlType.DropDownList);
        // hasAuthPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        // hasAuthPermissionAttr.Attribute.MetaDataLookupId = DevwareMetaDataLookups.AppPermissionByMeaning;
        return attributes;
    }
    addPermissionAttributes(attributes) {
        var hasPermissionAttr = this.addProperty(attributes, 'Permissions', 'Has Permission', DwAttributeType.Text, DwControlType.DropDownList);
        hasPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        hasPermissionAttr.Attribute.MetaDataLookupId = DevwareMetaDataLookups.AppPermissionByMeaning;
        var hasAuthPermissionAttr = this.addProperty(attributes, 'AuthenticationPermissions', 'Has Permission (Auth User)', DwAttributeType.Text, DwControlType.DropDownList);
        hasAuthPermissionAttr.compareTypes = [DwExpressionCompareType.contains, DwExpressionCompareType.notContains, DwExpressionCompareType.inList, DwExpressionCompareType.notInList];
        hasAuthPermissionAttr.Attribute.MetaDataLookupId = DevwareMetaDataLookups.AppPermissionByMeaning;
    }
};
DwUserContextService.ɵfac = function DwUserContextService_Factory(t) { return new (t || DwUserContextService)(ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwContextRepositoryService), ɵngcc0.ɵɵinject(DwUserContextDynamicHandlerToken, 8)); };
DwUserContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwUserContextService, factory: function (t) { return DwUserContextService.ɵfac(t); } });
DwUserContextService.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwContextRepositoryService },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DwUserContextDynamicHandlerToken,] }] }
];
DwUserContextService = __decorate$1B([
    DwCustomContextDefinition({
        keyName: 'currentUser',
        display: 'Current User',
        isGlobal: true,
    }),
    __metadata$1c("design:paramtypes", [DwSecurityUserService, Object, DwContextRepositoryService, Object])
], DwUserContextService);

class DwFieldValidationConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwUiConfigRegistryService) {
        super();
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.validationItemType = DwValidationItemType.formControl;
        this.allRegistrations = [];
        this.availableRegistrations = [];
        this.registrationObject = {};
        this.selectedRegistrationKeys = [];
    }
    getDefaultConfig() {
        return {
            overrideDefaults: false,
            validators: []
        };
    }
    initConfig() {
        var _a;
        super.initConfig();
        this.selectedRegistrationKeys = [];
        const registrations = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.validationRule);
        this.allRegistrations = registrations.filter(reg => {
            const itemTypes = ensureArray(reg.validationItemType);
            return itemTypes.indexOf(this.validationItemType) >= 0;
        });
        this.registrationObject = flattenArray(this.allRegistrations, 'keyName');
        // Ensure we have a config for each validator
        for (let validator of (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators) {
            if (!validator.config) {
                validator.config = {};
            }
            this.selectedRegistrationKeys.push(validator.validatorKey);
        }
        this.setupAvailableRegistrations();
    }
    setupAvailableRegistrations() {
        var _a;
        const availableRegistrations = [];
        var sortedRegistrations = sortArray(this.allRegistrations, (item) => !item.allowMultiple);
        for (let registration of sortedRegistrations) {
            if (registration.allowMultiple || !((_a = this.config) === null || _a === void 0 ? void 0 : _a.validators.find(v => v.validatorKey == registration.keyName))) {
                availableRegistrations.push(registration);
            }
        }
        this.availableRegistrations = availableRegistrations;
        if (this.availableRegistrations.length > 0) {
            this.selectedRegistrationKey = this.availableRegistrations[0].keyName;
        }
    }
    addValidator() {
        if (!this.selectedRegistrationKey) {
            return;
        }
        this.config.validators.push({
            validatorKey: this.selectedRegistrationKey,
            config: {}
        });
        this.setupAvailableRegistrations();
    }
    updateRegistrations() {
        var _a;
        // Add new validators
        for (let key of this.selectedRegistrationKeys) {
            let config = (_a = this.config) === null || _a === void 0 ? void 0 : _a.validators.find(v => v.validatorKey == key);
            if (!config) {
                this.config.validators.push({
                    validatorKey: key,
                    config: {}
                });
            }
        }
        // Remove existing validators
        for (let i = this.config.validators.length - 1; i >= 0; i--) {
            const validator = this.config.validators[i];
            if (this.selectedRegistrationKeys.indexOf(validator.validatorKey) === -1) {
                this.config.validators.splice(i, 1);
            }
        }
    }
    validatorChange() {
    }
}
DwFieldValidationConfigComponent.ɵfac = function DwFieldValidationConfigComponent_Factory(t) { return new (t || DwFieldValidationConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwFieldValidationConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFieldValidationConfigComponent, selectors: [["dw-field-validation-config"]], inputs: { validationItemType: "validationItemType" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 3, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [4, "ngIf"], [3, "items", "itemsChange", 4, "ngIf"], [3, "items", "itemsChange"], [4, "dwListItem"], [3, "config", "validatorKey", "configContext", "configChange"], ["dwCol", "12"], [3, "ngModel", "queryMeaning", "contextNames", "item", "ngModelChange"], ["title", "Allows conditional validation based on an expression. If result is true, validator is added", 1, "fa", "fa-info-circle"], ["class", "fa fa-info-circle", 3, "title", 4, "ngIf"], [1, "fa", "fa-info-circle", 3, "title"], ["optionLabel", "display", "optionValue", "keyName", "display", "chip", "appendTo", "body", "baseZIndex", "2000", 3, "options", "ngModel", "ngModelChange"], [1, "btn-sm", "btn-success", "mt-1", 3, "enabled", "click"], [4, "ngFor", "ngForOf"]], template: function DwFieldValidationConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Override Defaults");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFieldValidationConfigComponent_Template_p_inputSwitch_ngModelChange_5_listener($event) { return ctx.config.overrideDefaults = $event; })("ngModelChange", function DwFieldValidationConfigComponent_Template_p_inputSwitch_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwFieldValidationConfigComponent_ng_container_6_Template, 3, 2, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(7, DwFieldValidationConfigComponent_ng_container_7_Template, 7, 3, "ng-container", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.overrideDefaults);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.overrideDefaults);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: function () { return [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwOrderedListComponent, DwListItemDirective, DwValidationConfigBaseComponent, DwExpressionPickerControlComponent, ɵngcc22.Dropdown, ɵngcc12.MultiSelect, ɵngcc4.NgForOf]; }, encapsulation: 2 });
DwFieldValidationConfigComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
DwFieldValidationConfigComponent.propDecorators = {
    validationItemType: [{ type: Input }]
};

class DwMdChildDataRepeaterSectionConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.filterFormGroup = new FormGroup({});
        this.filterFieldConfig = {};
        this.availableRelations = [];
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        if (!this.section.parentItem)
            this.section.parentItem = this.getParentItemName();
        if (!this.section.section) {
            const containerSection = new DwContainerSectionPreference();
            this.section.section = containerSection;
            this.onSectionChange();
        }
        this.section.filters = this.section.filters || [];
        this.section.useFilters = this.section.useFilters || false;
        this.section.showAsGrid = this.section.showAsGrid || false;
        this.section.excludeFromSave = this.section.excludeFromSave || false;
        this.section.excludeChildControls = this.section.excludeChildControls || false;
        this.section.hideAdd = this.section.hideAdd || false;
        this.section.hideRemove = this.section.hideRemove || false;
        this.section.autoAddRows = this.section.autoAddRows || false;
        this.section.filterSetDefaultValues = this.section.filterSetDefaultValues || false;
        if (this.section.hideAddAndRemove) {
            this.section.hideAddAndRemove = false;
            this.section.hideAdd = true;
            this.section.hideRemove = true;
        }
        if (!this.section.validationConfig) {
            this.section.validationConfig = {
                overrideDefaults: false,
                validators: [],
            };
        }
        this.setupRelationship(this.section.relationshipName);
        this.setupAvailableRelationships();
        this.setupFilterWatch();
    }
    onShowAsGridChange() {
        if (this.section.showAsGrid) {
            if (!this.originalChildSection) {
                this.originalChildSection = this.section.section;
                this.originalUseFilters = this.section.useFilters;
            }
            if (this.section.section.sectionType != 'form') {
                this.section.section = new DwFormSectionPreference();
            }
            this.section.useFilters = false;
        }
        else {
            this.section.section = this.originalChildSection || new DwContainerSectionPreference();
            this.section.useFilters = this.originalUseFilters;
        }
        this.onSectionChange();
    }
    setupAvailableRelationships() {
        const parentName = this.getParentItemName();
        if (!parentName) {
            return;
        }
        this.getItemMetaData(parentName)
            .subscribe(parentMetaData => {
            this.availableRelations = parentMetaData === null || parentMetaData === void 0 ? void 0 : parentMetaData.Relations.filter(relation => {
                return relation.IsPrimaryItem && relation.RelationshipTypeId != DwRelationshipType.OneToOne;
                ;
            });
        });
    }
    setupRelationship(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        this.relationship = findWhere(this.availableRelations, { RelationshipName: relationshipName });
        this.relationshipDisplay = null;
        if (this.relationship) {
            this.relationshipDisplay = `${this.relationship.PkUniqueItemName}.${this.relationship.PkAttributeName} (PK) = ${this.relationship.FkUniqueItemName}.${this.relationship.FkAttributeName} (FK)`;
        }
        this.setupAttributes();
    }
    setSectionRelationshipItems(relationshipName) {
        this.setupRelationship(relationshipName);
        if (this.relationship) {
            this.section.relationshipName = this.relationship.RelationshipName;
            this.section.propertyName = this.relationship.NamingInfo.RelationshipPropertyName;
            if (this.relationship.IsPrimaryItem) {
                this.section.childItem = this.relationship.FkUniqueItemName;
            }
            else {
                this.section.childItem = this.relationship.PkUniqueItemName;
            }
        }
        this.setupAttributes();
        this.onSectionChange();
    }
    setSelectedAttributes(attributes) {
        var _a;
        this.selectedAttributes = attributes;
        const newFilters = [];
        for (let attr of this.selectedAttributes) {
            let filter = ((_a = this.section.filters) === null || _a === void 0 ? void 0 : _a.find(f => f.attrName == attr.AttributeName)) ||
                { attrName: attr.AttributeName };
            this.ensureFormControl(attr.AttributeName, filter.filterValue);
            this.filterFieldConfig[attr.AttributeName] = this.dwFormUtilService.buildFieldConfig(attr, this.itemName);
            newFilters.push(filter);
        }
        this.section.filters = newFilters;
    }
    setupFilterWatch() {
        this.filterFormGroup.valueChanges.subscribe(value => {
            this.updateFilterValues(value);
        });
    }
    updateFilterValues(allFilterValues) {
        if (!this.section.filters && allFilterValues) {
            return;
        }
        for (let filter of this.section.filters) {
            filter.filterValue = allFilterValues[filter.attrName];
        }
    }
    ensureFormControl(attrName, attrValue) {
        let fc = this.filterFormGroup.get(attrName);
        if (!fc) {
            fc = new FormControl(attrValue);
            this.filterFormGroup.addControl(attrName, fc);
        }
    }
    setupAttributes() {
        if (!this.section.childItem) {
            this.updateAvailableAttributes(false);
        }
        if (this.childItemMetaData && this.childItemMetaData.UniqueItemName == this.section.childItem) {
            return;
        }
        this.getItemMetaData(this.section.childItem)
            .subscribe(childItemMetaData => {
            this.childItemMetaData = childItemMetaData;
            this.updateAvailableAttributes(true);
        });
    }
    updateAvailableAttributes(updateSelectedAttribute) {
        if (!this.childItemMetaData) {
            this.availableAttributes = null;
            this.selectedAttributes = null;
            return;
        }
        this.availableAttributes = this.childItemMetaData.Attributes;
        if (!updateSelectedAttribute) {
            return;
        }
        const selectedAttributes = this.childItemMetaData.Attributes.filter(a => { var _a; return (_a = this.section.filters) === null || _a === void 0 ? void 0 : _a.find(f => f.attrName == a.AttributeName); });
        this.setSelectedAttributes(selectedAttributes);
    }
}
DwMdChildDataRepeaterSectionConfigComponent.ɵfac = function DwMdChildDataRepeaterSectionConfigComponent_Factory(t) { return ɵDwMdChildDataRepeaterSectionConfigComponent_BaseFactory(t || DwMdChildDataRepeaterSectionConfigComponent); };
DwMdChildDataRepeaterSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdChildDataRepeaterSectionConfigComponent, selectors: [["dw-md-child-data-repeater-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 62, vars: 22, consts: [["header", "Child Data Repeater Configuration"], [3, "multiple"], ["header", "Data Configuration", 3, "selected"], ["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["dwCol", "6"], ["title", "Allows rows to be ordered and sets an order value in the designated field", 1, "fa", "fa-info-circle"], [3, "ngModel", "ngModelChange"], ["dwCol", "6", 4, "ngIf"], ["header", "Filters", 4, "ngIf"], ["header", "Repeater Options"], ["dwCol", "4"], ["title", "Excludes this child and any children from being saved.  Also makes all forms read-only and hides add/remove buttons", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["type", "text", "placeholder", "There are no items to display", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", "placeholder", "Add", 1, "form-control", 3, "ngModel", "ngModelChange"], ["header", "Validation", 4, "ngIf"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"], [3, "ngValue"], ["title", "Assigns an order value to each row starting at 1", 1, "fa", "fa-info-circle"], ["optionLabel", "Display", "optionValue", "AttributeName", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 1, "multi-edit-auto-expand", 3, "options", "ngModel", "filter", "ngModelChange"], ["title", "Allows reusing the same table for multiple repeaters or simply filtering the data by a simple filter (Does not work with orderable)", 1, "fa", "fa-info-circle"], ["header", "Filters"], ["title", "Any equal filters for an attribute will be used to set the default value for the row.  This ensures the correct data is set on the entity when saved.", 1, "fa", "fa-info-circle"], ["title", "Attributes to filter on will also be set by default for new rows", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "item", "ngModelChange"], [4, "ngIf"], ["optionLabel", "Display", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 1, "multi-edit-auto-expand", 3, "options", "ngModel", "filter", "ngModelChange"], ["dwCol", "6", 4, "ngFor", "ngForOf"], ["dwDynamicField", "", 3, "fieldDef", "formGroup", "submitted"], ["header", "Validation"], ["validationItemType", "formArray", 3, "config", "configContext", "configChange"]], template: function DwMdChildDataRepeaterSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "p-accordion", 1);
        ɵngcc0.ɵɵelementStart(4, "p-accordionTab", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "select", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_select_ngModelChange_9_listener($event) { return ctx.section.relationshipName = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_select_ngModelChange_9_listener($event) { return ctx.setSectionRelationshipItems($event); });
        ɵngcc0.ɵɵtemplate(10, DwMdChildDataRepeaterSectionConfigComponent_option_10_Template, 2, 2, "option", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, DwMdChildDataRepeaterSectionConfigComponent_div_11_Template, 5, 1, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "div", 3);
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Is Orderable ");
        ɵngcc0.ɵɵelement(16, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "dw-yesno", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_17_listener($event) { return ctx.section.isOrderable = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_17_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, DwMdChildDataRepeaterSectionConfigComponent_div_18_Template, 5, 3, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(19, DwMdChildDataRepeaterSectionConfigComponent_div_19_Template, 7, 3, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, DwMdChildDataRepeaterSectionConfigComponent_p_accordionTab_20_Template, 15, 6, "p-accordionTab", 12);
        ɵngcc0.ɵɵelementStart(21, "p-accordionTab", 13);
        ɵngcc0.ɵɵelementStart(22, "div", 3);
        ɵngcc0.ɵɵelementStart(23, "div", 14);
        ɵngcc0.ɵɵelementStart(24, "div", 3);
        ɵngcc0.ɵɵelementStart(25, "div", 4);
        ɵngcc0.ɵɵelementStart(26, "label");
        ɵngcc0.ɵɵtext(27, "Exclude From Save ");
        ɵngcc0.ɵɵelement(28, "i", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "dw-yesno", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_29_listener($event) { return ctx.section.excludeFromSave = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_29_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 14);
        ɵngcc0.ɵɵelementStart(31, "div", 3);
        ɵngcc0.ɵɵelementStart(32, "div", 4);
        ɵngcc0.ɵɵelementStart(33, "label");
        ɵngcc0.ɵɵtext(34, "Exclude Child Controls");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "dw-yesno", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_35_listener($event) { return ctx.section.excludeChildControls = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_35_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "div", 3);
        ɵngcc0.ɵɵelementStart(37, "div", 16);
        ɵngcc0.ɵɵelementStart(38, "label");
        ɵngcc0.ɵɵtext(39, "Hide Add");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "dw-yesno", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_40_listener($event) { return ctx.section.hideAdd = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_40_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "div", 16);
        ɵngcc0.ɵɵelementStart(42, "label");
        ɵngcc0.ɵɵtext(43, "Hide Remove");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "dw-yesno", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_44_listener($event) { return ctx.section.hideRemove = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_44_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "div", 8);
        ɵngcc0.ɵɵelementStart(46, "label");
        ɵngcc0.ɵɵtext(47, "Auto Add Rows");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "dw-yesno", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_48_listener($event) { return ctx.section.autoAddRows = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_yesno_ngModelChange_48_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "div", 3);
        ɵngcc0.ɵɵelementStart(50, "div", 8);
        ɵngcc0.ɵɵelementStart(51, "label");
        ɵngcc0.ɵɵtext(52, "No Rows Message");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "input", 17);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_input_ngModelChange_53_listener($event) { return ctx.section.noRowsMessage = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_input_ngModelChange_53_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "div", 8);
        ɵngcc0.ɵɵelementStart(55, "label");
        ɵngcc0.ɵɵtext(56, "Add Text");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(57, "input", 18);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_input_ngModelChange_57_listener($event) { return ctx.section.addTextOverride = $event; })("ngModelChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_input_ngModelChange_57_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(58, DwMdChildDataRepeaterSectionConfigComponent_p_tabPanel_58_Template, 2, 2, "p-tabPanel", 19);
        ɵngcc0.ɵɵelementStart(59, "p-tabPanel", 20);
        ɵngcc0.ɵɵelementStart(60, "div");
        ɵngcc0.ɵɵelementStart(61, "dw-md-section-standard-config", 21);
        ɵngcc0.ɵɵlistener("sectionChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_61_listener($event) { return ctx.section = $event; })("sectionChange", function DwMdChildDataRepeaterSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_61_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("multiple", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.relationshipName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.availableRelations);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relationshipDisplay);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.isOrderable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.isOrderable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.showAsGrid);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.isOrderable && ctx.section.useFilters && ctx.section.childItem);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.excludeFromSave);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.excludeChildControls);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.hideAdd);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.hideRemove);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.autoAddRows);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.noRowsMessage);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.addTextOverride);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section == null ? null : ctx.section.validationConfig);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwYesNoComponent, ɵngcc3.DefaultValueAccessor, DwMdSectionStandardConfigComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc22.Dropdown, DwExpressionPickerControlComponent, ɵngcc12.MultiSelect, DwDynamicFieldComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwFieldValidationConfigComponent], styles: [""] });

function getChildDataRepeaterPrefetchInfo(section) {
    const childDataSection = section;
    if (childDataSection.childItem) {
        return {
            itemName: childDataSection.childItem,
            propertyName: childDataSection.propertyName,
            relationshipName: childDataSection.relationshipName,
            excludeFromSave: childDataSection.excludeFromSave,
            filterExpression: childDataSection.useFilters ? childDataSection.filterExpression : null
        };
    }
    return null;
}

var __decorate$1C = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1d = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwMdChildDataRepeaterSectionComponent = class DwMdChildDataRepeaterSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwExpressionStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwFormBuilderService, dwFormValidationService, dwMetadataFormUtilService, dwContextService, dwFormSectionStateService, dwFormStateService) {
        //super();
        //this.dwMetaDataService = dwMetaDataService;
        super(dwExpressionService, dwFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwFormBuilderService = dwFormBuilderService;
        this.dwFormValidationService = dwFormValidationService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwContextService = dwContextService;
        this.formArraySetup = false;
        this.RepeaterValidationKey = 'childRepeaterValidation';
        this.invalidConfiguration = false;
        this.visibleIndexes = {};
        this.visibleRowCount = 0;
        this.MANUAL_ADD_KEY = "manualAddKey";
        this.nextKeyValue = 0;
    }
    sectionReadOnlyChanged(readOnly) {
        if (this.isSectionReadOnly()) {
            this.dwMetadataFormUtilService.setSectionReadOnly(this.sectionConfig.section, true);
        }
        else {
            this.dwMetadataFormUtilService.setSectionReadOnly(this.sectionConfig.section, false);
        }
    }
    formConfigChanged() {
        this.setupChildData();
    }
    sectionConfigChanged() {
        this.setupChildData();
    }
    onReorder(newItems = null) {
        var _a;
        // Set order attribute for each row
        if (this.sectionConfig.isOrderable && ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.orderAttributeName)) {
            let index = 0;
            let order = 0;
            for (var formGroup of this.formArray.controls) {
                index++;
                if (this.useFilterIndexes && !this.visibleIndexes[index - 1]) {
                    continue;
                }
                order++;
                var attrFormContorl = formGroup.controls[this.sectionConfig.orderAttributeName];
                if (attrFormContorl) {
                    attrFormContorl.setValue(order);
                }
            }
        }
    }
    setupChildData() {
        if (!this.sectionConfig || !this.formConfig) {
            return;
        }
        if (!this.sectionConfig.childItem) {
            this.invalidConfiguration = true;
            this.invalidConfigurationMessage = 'Relationship not set';
            return;
        }
        this.relatedSections = this.dwMetadataFormUtilService.findRelatedSections(this.formConfig.section, this.sectionConfig, this.sectionConfig.sectionType, this.sectionKey, (section) => {
            return section.childItem == this.sectionConfig.childItem;
        });
        this.formArrayName = this.sectionConfig.propertyName;
        this.initFormArray();
        this.dwMetaDataService.getUserMetaDataItemSecurity(this.sectionConfig.childItem)
            .subscribe(itemSecurity => {
            this.itemSecurity = itemSecurity;
        });
        if (this.initialDataSubscription) {
            this.initialDataSubscription.unsubscribe();
            this.initialDataSubscription = null;
        }
        // Get the inital data from the context once form load is complete
        this.initialDataSubscription = this.getInitialData(this.context)
            .subscribe(data => {
            setTimeout(() => {
                this.setChildData(data);
                this.formArraySetup = true;
                this.handleDataUpdates();
            });
        });
        // If we're excluding the section from save, make all child sections read only
        if (this.isSectionReadOnly()) {
            this.dwMetadataFormUtilService.setSectionReadOnly(this.sectionConfig.section, true);
        }
        else {
            this.dwMetadataFormUtilService.setSectionReadOnly(this.sectionConfig.section, false);
        }
    }
    // override parent method
    isSectionReadOnly() {
        if (this.sectionConfig.excludeFromSave) {
            return true;
        }
        return super.isSectionReadOnly();
    }
    initFormArray() {
        this.logMessage(`initFormArray - Before`);
        if (!this.formGroup || this.formArray) {
            return;
        }
        let formArray = this.formGroup.get(this.formArrayName);
        if (formArray instanceof FormArray) {
            this.formArray = formArray;
            return;
        }
        // if formarray control exists, but it isn't a form arary, we need to remove it
        if (formArray) {
            this.formGroup.removeControl(this.formArrayName);
        }
        formArray = new FormArray([]);
        this.formGroup.addControl(this.formArrayName, formArray);
        this.formArray = formArray;
        this.setupValidation();
        this.logMessage(`initFormArray - After`);
    }
    setupValidation() {
        var _a;
        this.logMessage(`setupValidation - Before`);
        if (!this.formArrayName) {
            this.logMessage(`setupValidation - After`);
            return;
        }
        if (this.isSectionReadOnly()) {
            this.logMessage(`setupValidation - After`);
            return;
        }
        // Only setup validation for the main child repeater
        //  Otherwise, each repeater will clear out and reset the validators based on it's repeater config.  Instead, we need to build the validation config for ALL related repeaters
        if (!this.relatedSections.isPrimarySection) {
            this.logMessage(`setupValidation - After`);
            return;
        }
        if (!((_a = this.conditionalExpressionState) === null || _a === void 0 ? void 0 : _a.conditionalExpressionsSetup)) {
            this.conditionalExpressionState = this.dwFormValidationService.initMultiSectionValidation(this.relatedSections, this.formArray, this.context);
        }
        this.logMessage(`setupValidation - After`);
    }
    showDelete(index) {
        var _a;
        const data = this.getChildDataItem(index) || {};
        const keyValue = data._keyName ? data[data._keyName] : null;
        if (!((_a = this.itemSecurity) === null || _a === void 0 ? void 0 : _a.CanDelete) && keyValue) {
            return false;
        }
        //   Handled in isSectionReadOnly override
        // if (this.sectionConfig.excludeFromSave) {
        //   return false;
        // }
        if (this.isSectionReadOnly()) {
            return false;
        }
        const countConfig = this.getCountValidationConfig();
        if (!countConfig) {
            return true;
        }
        if (!this.sectionConfig.hideDeleteBelowMinCount) {
            return true;
        }
        return index >= countConfig.minCount;
    }
    showAdd() {
        var _a;
        if (!((_a = this.itemSecurity) === null || _a === void 0 ? void 0 : _a.CanCreate)) {
            return false;
        }
        // Handled in isSectionReadOnly override
        // if (this.sectionConfig.excludeFromSave) {
        //   return false;
        // }
        if (this.isSectionReadOnly()) {
            return false;
        }
        const countConfig = this.getCountValidationConfig();
        if (countConfig && countConfig.maxCount) {
            if (this.formArray.length >= countConfig.maxCount) {
                return false;
            }
        }
        return true;
    }
    getCountValidationConfig() {
        var _a, _b, _c;
        const countValidator = (_c = (_b = (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.validationConfig) === null || _b === void 0 ? void 0 : _b.validators) === null || _c === void 0 ? void 0 : _c.find(v => v.validatorKey == DwFormValidators.count);
        if (!countValidator) {
            return null;
        }
        return countValidator.config;
    }
    setChildData(data) {
        this.logMessage(`setChildData - Before`);
        if (!data || !data[this.formArrayName]) {
            this.addMinRows();
            this.logMessage(`setChildData - Afterr`);
            return;
        }
        const formArrayData = this.getFormArrayData(data);
        // let formArrayData: any[] = data[this.formArrayName];
        // if (!Array.isArray(formArrayData)) {
        //   formArrayData = [];
        // }
        // if (this.sectionConfig.isOrderable && this.sectionConfig.orderAttributeName) {
        //   formArrayData = sortArrayByField(formArrayData, this.sectionConfig.orderAttributeName);
        // }
        if (!this.relatedSections.isPrimarySection) {
            this.setupFilteredIndexes(formArrayData);
            this.addMinRows();
            this.logMessage(`setChildData - Afterr`);
            return;
        }
        this.formArray.clear();
        if (Array.isArray(formArrayData)) {
            for (let item of formArrayData) {
                this.addItem(false, false);
            }
        }
        this.addMinRows();
        this.formArrayData = formArrayData;
        this.formArray.patchValue(formArrayData);
        this.logMessage(`setChildData - Afterr`);
    }
    updateChildData(data) {
        var _a;
        if (!data) {
            return;
        }
        this.logMessage(`updateChildData - Before`);
        const formArrayData = this.getFormArrayData(data);
        // let formArrayData: any[] = data[this.formArrayName];
        // if (!Array.isArray(formArrayData)) {
        //   formArrayData = [];
        //   this.logMessage(`updateChildData - After`, formArrayData);
        //   return;
        // }
        // // remove deleted items
        // formArrayData = formArrayData.filter(d => !d._isDeleted);
        if (this.previousFormArrayData && areEqual(this.previousFormArrayData, formArrayData)) {
            this.logMessage(`updateChildData - After`, formArrayData);
            return;
        }
        this.previousFormArrayData = formArrayData;
        // Nothing to do since the form array already has all elements (existing elements should get updated fine on a data reload)
        if (formArrayData.length == ((_a = this.formArray) === null || _a === void 0 ? void 0 : _a.length)) {
            this.setupFilteredIndexes(formArrayData);
            this.logMessage(`updateChildData - After`, formArrayData);
            return;
        }
        if (!this.relatedSections.isPrimarySection) {
            this.logMessage(`updateChildData - After`, formArrayData);
            return;
        }
        let addedCount = 0;
        while (this.formArray.controls.length < formArrayData.length) {
            addedCount++;
            const formGroup = this.addItem(false, false);
            const childData = formArrayData[this.formArray.controls.length - 1];
            formGroup.patchValue(childData);
        }
        if (addedCount > 0) {
            this.setupFilteredIndexes(formArrayData);
        }
        this.logMessage(`updateChildData - After`, formArrayData);
    }
    getFormArrayData(data) {
        let formArrayData = data[this.formArrayName];
        if (!formArrayData || !Array.isArray(formArrayData)) {
            formArrayData = [];
        }
        // remove deleted items
        formArrayData = formArrayData.filter(d => !d._isDeleted);
        if (this.sectionConfig.isOrderable && this.sectionConfig.orderAttributeName) {
            formArrayData = sortArrayByField(formArrayData, this.sectionConfig.orderAttributeName);
        }
        return formArrayData;
    }
    setupFilteredIndexes(formArrayData) {
        this.logMessage(`setupFilteredIndexes - Before`);
        this.useFilterIndexes = false;
        if (!formArrayData) {
            const dataContext = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME];
            let data = dataContext === null || dataContext === void 0 ? void 0 : dataContext.value;
            if (!data) {
                return;
            }
            formArrayData = data[this.formArrayName];
        }
        let visibleRowCount = 0;
        // Determine visible rows for this repeater
        if (!this.sectionConfig.useFilters || this.dwExpressionService.isEmptyExpressionGroupItem(this.sectionConfig.filterExpression)) {
            visibleRowCount = formArrayData.length;
        }
        else {
            this.useFilterIndexes = true;
            visibleRowCount = this.determineVisibleRows(formArrayData);
        }
        this.visibleRowCount = visibleRowCount;
        // User extension field in DwFormArray custom interface to pass additional info for validation
        setTimeout(() => {
            this.formArray.countByKey = this.formArray.countByKey || {};
            this.formArray.countByKey[this.sectionKey] = visibleRowCount;
            this.formArray.updateValueAndValidity({ onlySelf: false, emitEvent: true });
            this.logMessage(`setupFilteredIndexes - After`);
        });
    }
    determineVisibleRows(formArrayData) {
        let visibleRowCount = 0;
        for (let index = 0; index < this.formArray.controls.length; index++) {
            const resolvedContext = this.dwContextService.getResolvedContext(this.context);
            const data = formArrayData[index] || {};
            if (data._isDeleted) {
                continue;
            }
            // If an item was manually added to this section, always show it (otherwise, form default won't have populate the value and the add button won't do anything)
            const manualAddValue = data[this.MANUAL_ADD_KEY];
            if (manualAddValue && manualAddValue == this.sectionKey) {
                this.visibleIndexes[index] = true;
            }
            else {
                this.visibleIndexes[index] = this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(this.sectionConfig.filterExpression, data, resolvedContext);
            }
            if (this.visibleIndexes[index]) {
                visibleRowCount++;
            }
        }
        return visibleRowCount;
    }
    getChildDataItem(index) {
        if (!this.formArrayData) {
            return null;
        }
        return this.formArrayData[index];
    }
    addMinRows() {
        var _a, _b;
        this.logMessage(`addMinRows - Before`);
        let count = 0;
        if (!((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.autoAddRows)) {
            this.logMessage(`addMinRows - After`);
            return;
        }
        const minRows = ((_b = this.getCountValidationConfig()) === null || _b === void 0 ? void 0 : _b.minCount) || 0;
        let addedCount = 0;
        while (this.visibleRowCount < minRows) {
            count++;
            this.addItem(true, false);
            addedCount++;
            // Don't let more than 10 just because it would be stupid (e.g. 10000 might kill the UI)
            if (count > 10) {
                break;
            }
        }
        // Only do this once after all rows have been added
        if (addedCount > 0) {
            this.setupComponentComplete();
        }
        this.logMessage(`addMinRows - After`);
    }
    addItemClick() {
        this.logMessage(`Add Item Click - Before`);
        setTimeout(() => {
            this.addItem(true, true);
            this.logMessage(`Add Item Click - After`);
        });
    }
    addItem(manualAdd, setupIndexes) {
        this.logMessage(`Add Item - Before`);
        const newFormGroup = new DwFormGroup({});
        newFormGroup.parentFormGroup = this.formGroup;
        newFormGroup.rootFormGroup = this.formGroup.root;
        const contextFormGroup = this.getContextFormGroup(this.formGroup);
        const nextkeyValue = this.getNextKeyValue();
        this.dwFormBuilderService.addSectionFormControls(newFormGroup, contextFormGroup, this.sectionConfig.section, this.formConfig, this.sectionConfig.childItem, nextkeyValue);
        if (manualAdd) {
            const manualAddControl = this.getOrCreateFormControl(this.MANUAL_ADD_KEY, newFormGroup);
            manualAddControl.setValue(this.sectionKey);
        }
        // Always add filter fields since these control if the row is visible
        this.addFilterFields(newFormGroup, manualAdd);
        this.formArray.push(newFormGroup);
        this.onReorder();
        // TODO: this isn't exactly right since the form array might not contains all the fields we want
        if (!setupIndexes) {
            this.setupFilteredIndexes(this.formArray.getRawValue());
        }
        this.logMessage("Add Item - AFter");
        return newFormGroup;
    }
    getNextKeyValue() {
        // Need to determine what keys values have been used
        if (this.formArray.controls.length == 0) {
            this.nextKeyValue--;
            return this.nextKeyValue;
        }
        let minKeyValue = 0;
        // Determine MetaDataItem
        let itemMetaData = this.formConfig.queryMetaDataList[this.sectionConfig.childItem];
        for (let formGroup of this.formArray.controls) {
            const keyValue = this.dwFormBuilderService.getPrimaryKeyValue(formGroup, itemMetaData);
            if (keyValue < minKeyValue) {
                minKeyValue = keyValue;
            }
        }
        ;
        this.nextKeyValue = minKeyValue - 1;
        return this.nextKeyValue;
    }
    /**
     * Add any fields used in the filter to the form group. This allows the expression processing to happen just the form array data and not rely on other data fields
     * @param newFormGroup
     * @param setDefaults
     */
    addFilterFields(newFormGroup, setDefaults) {
        if (!this.dwExpressionService.isEmptyExpressionGroupItem(this.sectionConfig.filterExpression)) {
            const allFilterControls = this.dwExpressionService.getExpressionValues(this.sectionConfig.filterExpression, (compareType) => true);
            // Ensure we have controls for these types
            for (var attrName in allFilterControls) {
                this.getOrCreateFormControl(attrName, newFormGroup);
            }
            if (setDefaults && this.sectionConfig.filterSetDefaultValues) {
                const initialValue = this.dwExpressionService.getExpressionValues(this.sectionConfig.filterExpression, (compareType) => compareType == DwExpressionCompareType.equal);
                newFormGroup.patchValue(initialValue);
            }
        }
    }
    getContextFormGroup(formGroup) {
        if (formGroup.parent) {
            return this.getContextFormGroup(formGroup.parent);
        }
        return formGroup.controls[DwMdFormContextInfo.CONTEXT_FORM_GROUP];
    }
    removeItem(i) {
        DwFormDebugService.debugMessage(0, this.componentName, `Remove Item {0}`);
        this.formArray.removeAt(i);
        this.setupFilteredIndexes(this.formArray.getRawValue());
    }
    getInitialData(context) {
        var _a;
        const formContext = context[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        const dataContext = context[DwMdFormContextInfo.DATA_CONTEXT_NAME];
        if (!formContext || !dataContext) {
            return;
        }
        if ((_a = formContext.value) === null || _a === void 0 ? void 0 : _a.loadDataComplete) {
            const sectionData = this.getSectionData(dataContext.value);
            return of(sectionData);
        }
        const subject = new Subject();
        const subscription = formContext.subscribe(value => {
            if (value.loadDataComplete) {
                const sectionData = this.getSectionData(dataContext.value);
                subject.next(sectionData);
                subscription.unsubscribe();
            }
        });
        return subject.asObservable();
    }
    getSectionData(dataContextValue) {
        return this.dwMetadataFormUtilService.getChildSectionData(this.sectionConfig, dataContextValue, this.formGroup, this.formConfig.section, this.formConfig.queryMetaDataList);
    }
    handleDataUpdates() {
        const dataContext = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME];
        if (this.dataUpdatesSubscription) {
            this.dataUpdatesSubscription.unsubscribe();
            this.dataUpdatesSubscription = null;
        }
        this.dataUpdatesSubscription = dataContext
            .pipe(distinctUntilChanged())
            .subscribe(data => {
            setTimeout(() => {
                const sectionData = this.getSectionData(data);
                this.updateChildData(sectionData);
            }, 0);
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.logMessage(`ngOnDestroy - Before`);
        if (this.childFormGroup) {
            this.childFormGroup.disable();
        }
        if (this.initialDataSubscription) {
            this.initialDataSubscription.unsubscribe();
            this.initialDataSubscription = null;
        }
        if (this.dataUpdatesSubscription) {
            this.dataUpdatesSubscription.unsubscribe();
            this.dataUpdatesSubscription = null;
        }
        if (this.conditionalExpressionState && this.conditionalExpressionState.conditionalExpressionSubscription) {
            this.conditionalExpressionState.conditionalExpressionSubscription.unsubscribe();
            this.conditionalExpressionState = null;
        }
        this.logMessage(`ngOnDestroy - Before`);
    }
    logMessage(message, data) {
        DwFormDebugService.debugMessage(0, this.componentName, message, data);
    }
};
DwMdChildDataRepeaterSectionComponent.ɵfac = function DwMdChildDataRepeaterSectionComponent_Factory(t) { return new (t || DwMdChildDataRepeaterSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwMdChildDataRepeaterSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdChildDataRepeaterSectionComponent, selectors: [["dw-child-data-repeater-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "hide-print dw-invalid-section", 4, "ngIf"], ["dwRow", "", 3, "formGroup", 4, "ngIf"], [1, "hide-print", "dw-invalid-section"], ["id", "icon", 1, "fas", "fa-cog"], ["id", "message"], ["dwRow", "", 3, "formGroup"], ["dwCol", "12"], [3, "formControlName", "submitted", "filterKey"], [4, "ngIf"], [3, "formArrayName"], ["class", "btn btn-sm btn-success mt-1", 3, "click", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["dwRow", ""], [1, "left-column"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"], ["class", "right-column", 4, "ngIf"], [1, "right-column"], ["title", "Remove", 1, "btn", "btn-sm", "btn-danger", "hide-mobile", "hand", 3, "click"], [1, "fa", "fa-times", "hand"], ["title", "Remove", 1, "btn", "btn-sm", "btn-danger", "show-mobile", 3, "click"], [3, "items", "useVisibleIndexes", "visibleIndexes", "itemsChange"], [4, "dwListItem"], [1, "btn", "btn-sm", "btn-success", "mt-1", 3, "click"]], template: function DwMdChildDataRepeaterSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMdChildDataRepeaterSectionComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMdChildDataRepeaterSectionComponent_div_1_Template, 10, 10, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidConfiguration);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.formArraySetup && ctx.formArray && ctx.sectionConfig && !ctx.invalidConfiguration);
    } }, directives: function () { return [ɵngcc4.NgIf, DwRowDirective, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwColDirective, DwValidationInfo, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.FormArrayName, ɵngcc4.NgForOf, DwDynamicSectionComponent, DwOrderedListComponent, DwListItemDirective]; }, styles: [".right-column[_ngcontent-%COMP%]{float:left;margin-left:4px;margin-top:15px;padding:0;width:30px}.left-column[_ngcontent-%COMP%]{float:left;padding:5px;width:calc(100% - 75px)}.message-text[_ngcontent-%COMP%]{font-size:larger}"] });
DwMdChildDataRepeaterSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwExpressionStateService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormBuilderService },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwMetadataFormUtilService },
    { type: DwContextService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService }
];
DwMdChildDataRepeaterSectionComponent = __decorate$1C([
    DwSectionComponent({
        keyName: DwSectionType.childDataRepeater,
        display: 'Child Repeater',
        sectionIcon: 'fa fa-child',
        configComponent: DwMdChildDataRepeaterSectionConfigComponent,
        hasChildren: false,
        hasChild: true,
        getPrefetchPathInfo: getChildDataRepeaterPrefetchInfo
    }),
    __metadata$1d("design:paramtypes", [DwExpressionService,
        DwExpressionStateService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetadataFormBuilderService,
        DwMetadataFormValidationBuilderService,
        DwMetadataFormUtilService,
        DwContextService,
        DwMetaDataFormSectionStateService,
        DwMetaDataFormStateService])
], DwMdChildDataRepeaterSectionComponent);

class DwDynamicFieldHorizontalComponent extends DwDynamicFieldComponent {
    constructor() {
        super(...arguments);
        this.labelWidth = 150;
        this.labelColStyle = {};
        this.dataColStyle = {};
    }
    setupClasses() {
        super.setupClasses();
        this.labelColStyle = {
            width: `${this.labelWidth || 100}px`,
            flex: 'none',
            'max-width': 'none'
        };
        this.dataColStyle = {
            width: `calc(100% - ${this.labelWidth || 100}px)`,
            flex: 'none',
            'max-width': 'none'
        };
    }
}
DwDynamicFieldHorizontalComponent.ɵfac = function DwDynamicFieldHorizontalComponent_Factory(t) { return ɵDwDynamicFieldHorizontalComponent_BaseFactory(t || DwDynamicFieldHorizontalComponent); };
DwDynamicFieldHorizontalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDynamicFieldHorizontalComponent, selectors: [["", "dwDynamicFieldHorizontal", ""], ["dwDynamicFieldHorizontal"]], inputs: { labelWidth: "labelWidth" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], attrs: _c78, decls: 14, vars: 16, consts: [[1, "row", 3, "hidden", "ngClass"], [1, "col-sm-2", 3, "ngStyle"], [3, "hidden"], [3, "ngClass"], [1, "col-form-label", 3, "ngClass", "hidden"], ["title", "Required", 1, "required-label", 3, "hidden"], [1, "fa", "fa-info-circle", "ml-1", 3, "hidden", "title"], [1, "col-sm-10", 3, "ngStyle"], ["dw-component-host", ""], [3, "formGroup"], [3, "formControlName", "displayName", "submitted"]], template: function DwDynamicFieldHorizontalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵtext(4, "\u00A0\u00A0 ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "label", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementStart(7, "span", 5);
        ɵngcc0.ɵɵtext(8, "\u00A0*");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtemplate(11, DwDynamicFieldHorizontalComponent_ng_template_11_Template, 0, 0, "ng-template", 8);
        ɵngcc0.ɵɵelementContainerStart(12, 9);
        ɵngcc0.ɵɵelement(13, "dw-validation-info", 10);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.fieldDef.isVisible)("ngClass", ctx.dataClasses);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.labelColStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.fieldDef == null ? null : ctx.fieldDef.iconClass));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.fieldDef == null ? null : ctx.fieldDef.iconClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.labelClasses)("hidden", ctx.fieldDef == null ? null : ctx.fieldDef.hideLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.fieldDef == null ? null : ctx.fieldDef.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.isRequired || (ctx.fieldDef == null ? null : ctx.fieldDef.hideLabel));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.fieldDef == null ? null : ctx.fieldDef.infoText))("title", ctx.fieldDef == null ? null : ctx.fieldDef.infoText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.dataColStyle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("displayName", ctx.fieldDef == null ? null : ctx.fieldDef.label)("submitted", ctx.submitted);
    } }, directives: [ɵngcc4.NgClass, ɵngcc4.NgStyle, DwComponentHost, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwValidationInfo, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwDynamicFieldHorizontalComponent.propDecorators = {
    labelWidth: [{ type: Input }]
};

class DwMdPageMenuComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwMdPageMenuComponent.ɵfac = function DwMdPageMenuComponent_Factory(t) { return new (t || DwMdPageMenuComponent)(); };
DwMdPageMenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdPageMenuComponent, selectors: [["dw-dw-md-page-menu"]], decls: 2, vars: 0, template: function DwMdPageMenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-md-page-menu works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwMdPageMenuComponent.ctorParameters = () => [];

var __decorate$1D = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1e = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwRadioLookupComponent extends DwSelectLookupComponent {
    constructor() {
        super(...arguments);
        this.lookupItemsPrime = [];
        this.showFilter = false;
        this.finalLookupItems = [];
        this.maxItems = 20;
    }
    lookupLoadComplete() {
        this.finalLookupItems = ensureArray(this.lookupItems);
    }
    translateTo(value) {
        if (value == null || value == undefined) {
            value = null;
        }
        else {
            value = value.toString();
        }
        return super.translateTo(value);
    }
}
DwRadioLookupComponent.ɵfac = function DwRadioLookupComponent_Factory(t) { return ɵDwRadioLookupComponent_BaseFactory(t || DwRadioLookupComponent); };
DwRadioLookupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRadioLookupComponent, selectors: [["dw-radio-lookup"]], inputs: { maxItems: "maxItems", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwRadioLookupComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[1, "dw-radio-lookup"], ["class", "dw-radio-lookup-item", 4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "dw-radio-lookup-item"], [1, "p-field-radiobutton"], ["name", "radioList", 3, "value", "label", "ngModel", "ngModelChange"], ["class", "dw-radio-lookup", 4, "ngFor", "ngForOf"], [1, "btn", "btn-success", 3, "ngClass", "click"]], template: function DwRadioLookupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwRadioLookupComponent_div_1_Template, 3, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, DwRadioLookupComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵtext(3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.finalLookupItems);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.lookupErorMessage, " ");
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc32.RadioButton, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgClass], encapsulation: 2 });
DwRadioLookupComponent.propDecorators = {
    options: [{ type: Input }],
    maxItems: [{ type: Input }]
};
__decorate$1D([
    DwInputConverter(intConverter),
    __metadata$1e("design:type", Number)
], DwRadioLookupComponent.prototype, "maxItems", void 0);

class DwViewEditSectionConfigComponent extends DwMdSectionConfigBaseComponent {
    sectionChanged() {
        if (!this.section) {
            return;
        }
        if (!this.section.sections) {
            this.section.sections = [];
        }
        this.ensureViewEditSections();
    }
    useSingleTemplateChange() {
        this.ensureViewEditSections();
        this.onSectionChange();
    }
    ensureViewEditSections() {
        if (this.section.useSingleTemplate) {
            if (this.section.sections.length != 1) {
                if (this.section.sections.length == 0) {
                    this.addContainerSection('View/Edit', [new DwFormSectionPreference()]);
                }
                if (this.section.sections[0].title == 'View') {
                    this.section.sections[0].title = 'View/Edit';
                }
                this.section.sections.length = 1;
                this.onSectionChange();
            }
        }
        else {
            if (this.section.sections.length != 2) {
                if (this.section.sections.length == 0) {
                    this.addContainerSection('View', [new DwFormSectionPreference()]);
                }
                if (this.section.sections.length == 1) {
                    const newEditSections = this.cloneViewChildSections();
                    this.addContainerSection('Edit', newEditSections);
                }
                if (this.section.sections[0].title == 'View/Edit') {
                    this.section.sections[0].title = 'View';
                }
                this.section.sections.length = 2;
                this.onSectionChange();
            }
        }
    }
    addContainerSection(title, childSections) {
        const containerSection = new DwContainerSectionPreference();
        containerSection.title = title;
        let formSection = new DwFormSectionPreference();
        containerSection.sections = childSections;
        this.section.sections.push(containerSection);
    }
    cloneViewChildSections() {
        const containerSection = this.section.sections[0];
        const sections = deepCopy(containerSection.sections);
        return sections;
    }
}
DwViewEditSectionConfigComponent.ɵfac = function DwViewEditSectionConfigComponent_Factory(t) { return ɵDwViewEditSectionConfigComponent_BaseFactory(t || DwViewEditSectionConfigComponent); };
DwViewEditSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwViewEditSectionConfigComponent, selectors: [["dw-view-edit-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 15, vars: 7, consts: [["header", "View/Edit Configuration"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelChange"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"]], template: function DwViewEditSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Show Edit on Load");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwViewEditSectionConfigComponent_Template_dw_yesno_ngModelChange_7_listener($event) { return ctx.section.showEditOnLoad = $event; })("ngModelChange", function DwViewEditSectionConfigComponent_Template_dw_yesno_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Use Single Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwViewEditSectionConfigComponent_Template_dw_yesno_ngModelChange_11_listener($event) { return ctx.section.useSingleTemplate = $event; })("ngModelChange", function DwViewEditSectionConfigComponent_Template_dw_yesno_ngModelChange_11_listener() { return ctx.useSingleTemplateChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p-tabPanel", 4);
        ɵngcc0.ɵɵelementStart(13, "div");
        ɵngcc0.ɵɵelementStart(14, "dw-md-section-standard-config", 5);
        ɵngcc0.ɵɵlistener("sectionChange", function DwViewEditSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_14_listener($event) { return ctx.section = $event; })("sectionChange", function DwViewEditSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_14_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.showEditOnLoad);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useSingleTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwMdSectionStandardConfigComponent], encapsulation: 2 });

class DwFormButtonSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.buttonBar;
    }
}

class DwViewEditSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sections = [];
        this.sectionType = DwSectionType.viewEdit;
    }
}

function dwWrapViewEditContainer(section) {
    const newSection = new DwViewEditSectionPreference();
    // move styles to the new container parent
    newSection.useContainerStyling = section.useContainerStyling;
    newSection.showTitle = section.showTitle;
    newSection.containerStyleName = section.containerStyleName;
    newSection.containerStyleName = section.containerStyleName;
    newSection.containerTitleClass = section.containerTitleClass;
    newSection.containerInnerClass = section.containerInnerClass;
    newSection.containerClass = section.containerClass;
    newSection.title = section.title;
    section.containerStyleName = section.containerTitleClass = section.containerInnerClass = section.containerClass = section.title = null;
    section.showTitle = false;
    section.useContainerStyling = false;
    newSection.useSingleTemplate = true;
    newSection.showEditOnLoad = false;
    // Wrap select section in a container unless it's already a container
    if (section.sectionType === DwSectionType.container) {
        newSection.sections = [section];
    }
    else {
        const containerSection = new DwContainerSectionPreference();
        containerSection.title = 'View/Edit';
        containerSection.sections = [section];
        newSection.sections = [containerSection];
    }
    return newSection;
}

var __decorate$1E = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1f = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwViewEditSectionComponent = class DwViewEditSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwActionConfigService, dwMetadataFormUtilService, dwMetaDataFormStateService, dwMetaDataFormActionService, dwMetaDataFormSectionStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwActionConfigService = dwActionConfigService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataFormActionService = dwMetaDataFormActionService;
        this.showEdit = false;
    }
    sectionReadOnlyChanged(readOnly) {
        this.setupSections();
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupSections();
        this.setupFormActionInterceptor();
        this.dwMetaDataFormStateService.addActionInterceptor(this.formActionInterceptor);
    }
    setupFormActionInterceptor() {
        this.formActionInterceptor = {
            interceptorName: 'viewEditSectionInterceptor',
            order: 10,
            onAfterAction: (actionPref, actionConfig, actionResult) => {
                const result = {
                    abort: false
                };
                // If not editing, then ignore all events
                if (!this.showEdit || !actionResult.success) {
                    return of(result);
                }
                if (actionConfig.keyName == DwFormActionKeys.formSave) {
                    result.abort = true;
                    result.message = {
                        messageBody: 'Save Successful',
                        severity: DwMessageSeverity.success,
                        timeToShow: 5000
                    };
                    this.showEdit = false;
                }
                if (actionConfig.keyName == DwFormActionKeys.formCancel) {
                    result.abort = true;
                    if (this.beforeEditData) {
                        this.dwMetaDataFormStateService.state.rootFormGroup.patchValue(this.beforeEditData);
                    }
                    this.showEdit = false;
                }
                return of(result);
            }
        };
    }
    sectionConfigChanged() {
        this.setupSections();
    }
    contextChanged() {
        this.setupSections();
    }
    ngOnDestroy() {
        this.dwMetaDataFormStateService.removeActionInterceptor(this.formActionInterceptor);
        super.ngOnDestroy();
    }
    toggleEdit() {
        setTimeout(() => {
            this.showEdit = !this.showEdit;
            if (this.showEdit) {
                this.beforeEditData = this.dwMetaDataFormStateService.state.rootFormGroup.getRawValue();
            }
        });
    }
    setupSections() {
        var _a, _b, _c;
        if (!this.formConfig || !this.sectionConfig || !this.context || !this.sectionConfig.sections) {
            return;
        }
        if (this.sectionConfig.useSingleTemplate && ((_a = this.sectionConfig.sections) === null || _a === void 0 ? void 0 : _a.length) < 1) {
            console.warn(`Could not setup View/Edit Section because it doesn't have a view/edit section`);
            return;
        }
        if (!this.sectionConfig.useSingleTemplate && ((_b = this.sectionConfig.sections) === null || _b === void 0 ? void 0 : _b.length) < 2) {
            console.warn(`Could not setup View/Edit Section because it doesn't have view and edit sections`);
            return;
        }
        this.showEdit = this.sectionConfig.showEditOnLoad;
        if (this.isSectionReadOnly()) {
            this.showEdit = false;
        }
        if (this.sectionConfig.useSingleTemplate && ((_c = this.sectionConfig.sections) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            this.viewSection = this.sectionConfig.sections[0];
            this.editSection = deepCopy(this.viewSection);
        }
        else {
            this.viewSection = this.sectionConfig.sections[0];
            this.editSection = this.sectionConfig.sections[1];
        }
        this.dwMetadataFormUtilService.setSectionReadOnly(this.editSection, false);
        this.dwMetadataFormUtilService.setSectionReadOnly(this.viewSection, true);
        this.ensureButtonSection(this.editSection);
    }
    ensureButtonSection(editSection) {
        let buttonBarSections = this.dwMetadataFormUtilService.findSections(editSection, (section) => section.sectionType == DwSectionType.buttonBar);
        if (buttonBarSections.length == 0) {
            const buttonBarSection = new DwFormButtonSectionPreference();
            buttonBarSection.useFormButtonDefaults = false;
            buttonBarSection.useFormModes = false;
            // Just show a save and cancel  (These can be customized by adding a button bar to the edit tempalte)
            const buttonDefaults = {};
            buttonDefaults[formModeNone] = [DwFormActionKeys.formSave, DwFormActionKeys.formCancel];
            const actionPreferencesByMode = this.dwMetaDataFormActionService.getDefaultFormActionPreferencesByMode(buttonDefaults);
            buttonBarSection.actionPreferencesByMode = this.dwActionConfigService.buildFinalActionPreferencesByMode(actionPreferencesByMode, this.dwMetaDataFormStateService.state.itemSecurity);
            editSection.sections.push(buttonBarSection);
        }
    }
};
DwViewEditSectionComponent.ɵfac = function DwViewEditSectionComponent_Factory(t) { return new (t || DwViewEditSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormActionService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService)); };
DwViewEditSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwViewEditSectionComponent, selectors: [["dw-view-edit-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 3, consts: [[1, "dw-view-edit-container"], ["class", "dw-form-floating-top-right hide-print-item", 3, "click", 4, "ngIf"], [1, "dw-view-edit-container-after"], [4, "ngIf"], [1, "dw-form-floating-top-right", "hide-print-item", 3, "click"], [1, "fa", "fa-pencil", "circle-icon"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible", "visibleChange"]], template: function DwViewEditSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwViewEditSectionComponent_div_1_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DwViewEditSectionComponent_ng_container_3_Template, 2, 6, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(4, DwViewEditSectionComponent_ng_container_4_Template, 2, 6, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showEdit && !ctx.isSectionReadOnly());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showEdit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showEdit);
    } }, directives: [ɵngcc4.NgIf, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective], encapsulation: 2 });
DwViewEditSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataActionConfigService },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataFormActionService },
    { type: DwMetaDataFormSectionStateService }
];
DwViewEditSectionComponent = __decorate$1E([
    DwSectionComponent({
        keyName: DwSectionType.viewEdit,
        display: 'View/Edit',
        sectionIcon: 'fa fa-align-justify',
        configComponent: DwViewEditSectionConfigComponent,
        hasChildren: true,
        dragDropConfig: {
            preventChildDrag: true
        },
        childrenPropertyName: 'sections',
        wrapOptions: {
            allowWrap: true,
            createWrapSection: dwWrapViewEditContainer
        }
    }),
    __metadata$1f("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetaDataActionConfigService,
        DwMetadataFormUtilService,
        DwMetaDataFormStateService,
        DwMetaDataFormActionService,
        DwMetaDataFormSectionStateService])
], DwViewEditSectionComponent);

class DwAdhocLookupService {
    convertAdhocArrayToString(value, escapeBrackets = false) {
        if (Array.isArray(value)) {
            const delimitedItems = value.map(item => this.addBrackets(item));
            return delimitedItems.join(',');
        }
        return null;
    }
    convertAdhocStringToString(value, escapeBrackets = false) {
        let array;
        if (typeof (value) === 'string') {
            array = value.split(',');
            array = array.map(item => this.removeBrackets(item));
            // Eliminte any blank items
            array = array.filter(item => item);
        }
        if (!Array.isArray(array)) {
            array = [];
        }
        return array.join(',');
    }
    convertAdhocStringToArray(value, escapeBrackets = false) {
        let array;
        if (typeof (value) === 'string') {
            array = value.split(',');
            array = array.map(item => this.removeBrackets(item));
            // Eliminte any blank items
            array = array.filter(item => item);
        }
        if (!Array.isArray(array)) {
            array = [];
        }
        return array;
    }
    addBrackets(item, escapeBrackets = false) {
        let startBracket = '[';
        if (escapeBrackets) {
            startBracket = '[[]';
        }
        return `${startBracket}${item}]`;
    }
    removeBrackets(item) {
        if (!item || item.length < 2 || !item.substring) {
            return '';
        }
        return item.substring(1, item.length - 1);
    }
    translateTo(value) {
        let translatedValue;
        if (typeof (value) === 'string') {
            translatedValue = value.split(',');
            translatedValue = translatedValue.map(item => this.removeBrackets(item));
            // Eliminte any blank items
            translatedValue = translatedValue.filter(item => item);
        }
        if (!Array.isArray(translatedValue)) {
            translatedValue = [];
        }
        return translatedValue;
    }
}
DwAdhocLookupService.ɵfac = function DwAdhocLookupService_Factory(t) { return new (t || DwAdhocLookupService)(); };
DwAdhocLookupService.ɵprov = ɵɵdefineInjectable({ factory: function DwAdhocLookupService_Factory() { return new DwAdhocLookupService(); }, token: DwAdhocLookupService, providedIn: "root" });

class DwMultiSelectAdhocComponent extends DwAutoCompleteLookupComponent {
    constructor(dwMetaDataService, dwEventService, dwSecurityService, cdr, dwAdhocLookupService, dwMetaDataRoutingService, dwLookupParameterUtilService, route, uiMetaDataConfig) {
        super(dwMetaDataService, dwEventService, dwSecurityService, cdr, dwMetaDataRoutingService, dwLookupParameterUtilService, route, uiMetaDataConfig);
        this.dwAdhocLookupService = dwAdhocLookupService;
        this.allowAdd = false;
    }
    addItem(item) {
        var _a, _b;
        if (!(item === null || item === void 0 ? void 0 : item.Display)) {
            this.adhocText = item;
            return;
        }
        let newValue = this.translatedValue || [];
        if (!Array.isArray(newValue)) {
            newValue = [];
        }
        if (newValue.indexOf(item === null || item === void 0 ? void 0 : item.Display) == -1) {
            newValue.push(item === null || item === void 0 ? void 0 : item.Display);
            this.setTranslatedValue(newValue);
        }
        // Hack to clear the typed text
        const input = (_b = (_a = this.autoComplete.el.nativeElement) === null || _a === void 0 ? void 0 : _a.firstChild) === null || _b === void 0 ? void 0 : _b.firstChild;
        if (input) {
            input.value = "";
        }
        this.currentItem = null;
        this.adhocText = "";
    }
    removeItem(item, index) {
        const newValue = this.translatedValue;
        if (Array.isArray(newValue)) {
            newValue.splice(index, 1);
            this.setTranslatedValue(newValue);
        }
    }
    addAdHocItem(item) {
        this.addItem({ Display: item });
    }
    ngOnChanges(simpleChanges) {
        super.ngOnChanges(simpleChanges);
        if (simpleChanges.options && !simpleChanges.options.firstChange) {
            // Use defaults if there not are specified
            this.options = Object.assign(Object.assign({}, this.defaultOptions), this.options);
        }
    }
    translateFrom(value) {
        return this.dwAdhocLookupService.convertAdhocArrayToString(value);
    }
    translateTo(value) {
        return this.dwAdhocLookupService.convertAdhocStringToArray(value);
    }
    setCurrentLookup(value) {
        // Nothing to do here
        return false;
    }
}
DwMultiSelectAdhocComponent.ɵfac = function DwMultiSelectAdhocComponent_Factory(t) { return new (t || DwMultiSelectAdhocComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwAdhocLookupService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService), ɵngcc0.ɵɵdirectiveInject(DwLookupParameterUtilService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken)); };
DwMultiSelectAdhocComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiSelectAdhocComponent, selectors: [["dw-multi-select-adhoc-lookup"]], viewQuery: function DwMultiSelectAdhocComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c80, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.autoComplete = _t.first);
    } }, inputs: { allowAdd: "allowAdd", options: "options" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwMultiSelectAdhocComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 8, vars: 13, consts: [["inputStyleClass", "form-control", "display", "chip", "field", "Display", "appendTo", "body", "baseZIndex", "1100", 3, "ngModel", "disabled", "suggestions", "placeholder", "dropdown", "ngModelChange", "completeMethod"], ["autocomplete", ""], [1, "btn-sm", "btn-success", 3, "hidden", "click"], [1, "dw-chip-container", 3, "hidden"], ["class", "dw-chip", 4, "ngFor", "ngForOf"], [3, "hidden"], [1, "dw-chip"], [1, "dw-chip", "dw-chip-100"], [1, "dw-chip-label-with-remove"], [1, "dw-chip-icon", 3, "click"], [1, "fa", "fa-times-circle"]], template: function DwMultiSelectAdhocComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-autoComplete", 0, 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiSelectAdhocComponent_Template_p_autoComplete_ngModelChange_0_listener($event) { return ctx.addItem($event); })("completeMethod", function DwMultiSelectAdhocComponent_Template_p_autoComplete_completeMethod_0_listener($event) { return ctx.searchStart($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function DwMultiSelectAdhocComponent_Template_button_click_2_listener() { return ctx.addAdHocItem(ctx.adhocText); });
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, DwMultiSelectAdhocComponent_div_5_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtext(7, " No Items selected ");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(12, _c43));
        ɵngcc0.ɵɵproperty("ngModel", ctx.currentItem)("disabled", ctx.disabled)("suggestions", ctx.lookupItems)("placeholder", ctx.placeholder || "Start typing to find values")("dropdown", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.adhocText || (ctx.options == null ? null : ctx.options.preventCustomAdd));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1("Add ", ctx.adhocText, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.translatedValue == null ? null : ctx.translatedValue.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.translatedValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", (ctx.translatedValue == null ? null : ctx.translatedValue.length) > 0);
    } }, directives: [ɵngcc30.AutoComplete, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc16.BsDropdownDirective, ɵngcc4.NgForOf], encapsulation: 2 });
DwMultiSelectAdhocComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwEventService },
    { type: DwSecurityUserService },
    { type: ChangeDetectorRef },
    { type: DwAdhocLookupService },
    { type: DwMetaDataRoutingService },
    { type: DwLookupParameterUtilService },
    { type: ActivatedRoute },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwMultiSelectAdhocComponent.propDecorators = {
    autoComplete: [{ type: ViewChild, args: ['autocomplete',] }],
    options: [{ type: Input }],
    allowAdd: [{ type: Input }]
};

class DwMultiSelectAdhocReadOnlyComponent extends DwMultiSelectAdhocComponent {
    constructor() {
        super(...arguments);
        this.missingDataText = 'None';
    }
}
DwMultiSelectAdhocReadOnlyComponent.ɵfac = function DwMultiSelectAdhocReadOnlyComponent_Factory(t) { return ɵDwMultiSelectAdhocReadOnlyComponent_BaseFactory(t || DwMultiSelectAdhocReadOnlyComponent); };
DwMultiSelectAdhocReadOnlyComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiSelectAdhocReadOnlyComponent, selectors: [["dw-multi-select-adhoc-readonly"]], inputs: { missingDataText: "missingDataText" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwMultiSelectAdhocReadOnlyComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 4, consts: [[1, "dw-chip-container", 3, "hidden"], ["class", "dw-chip", 4, "ngFor", "ngForOf"], [3, "hidden"], [1, "dw-chip"], [1, "dw-chip-label"]], template: function DwMultiSelectAdhocReadOnlyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMultiSelectAdhocReadOnlyComponent_div_1_Template, 3, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !(ctx.translatedValue == null ? null : ctx.translatedValue.length));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.translatedValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", (ctx.translatedValue == null ? null : ctx.translatedValue.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.missingDataText, " ");
    } }, directives: [ɵngcc4.NgForOf], encapsulation: 2 });
DwMultiSelectAdhocReadOnlyComponent.propDecorators = {
    missingDataText: [{ type: Input }]
};

class DwFieldSelectionComponent {
    constructor() {
        this.addTooltip = 'Add Field';
        this.showSearch = false;
        this.fieldSort = DwFieldSorts.none;
        this.attributeClick = new EventEmitter();
    }
    ngOnInit() {
        this.setupAvailableAttributes();
    }
    ngOnChanges(changes) {
        this.setupAvailableAttributes();
    }
    toggleSort() {
        switch (this.fieldSort) {
            case DwFieldSorts.none:
                this.fieldSort = DwFieldSorts.alphaAsc;
                break;
            case DwFieldSorts.alphaAsc:
                this.fieldSort = DwFieldSorts.alphaDesc;
                break;
            case DwFieldSorts.alphaDesc:
                this.fieldSort = DwFieldSorts.none;
                break;
        }
        this.setupAvailableAttributes();
    }
    setupAvailableAttributes() {
        if (!this.attributes) {
            return;
        }
        let attributes = [...this.attributes];
        if (this.searchText) {
            attributes = attributes.filter(a => a.AttributeDisplay.toLowerCase().indexOf(this.searchText) >= 0);
        }
        switch (this.fieldSort) {
            case DwFieldSorts.alphaAsc:
                attributes = sortArrayByField(attributes, 'AttributeDisplay');
                break;
            case DwFieldSorts.alphaDesc:
                attributes = sortArrayByField(attributes, 'AttributeDisplay', null, true);
                break;
        }
        this.availbleAttributes = attributes;
    }
    itemClick(attribute) {
        this.attributeClick.emit(attribute);
    }
    setSearchText(searchText) {
        this.searchText = searchText.toLowerCase();
        this.setupAvailableAttributes();
    }
}
DwFieldSelectionComponent.ɵfac = function DwFieldSelectionComponent_Factory(t) { return new (t || DwFieldSelectionComponent)(); };
DwFieldSelectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFieldSelectionComponent, selectors: [["dw-field-selection"]], inputs: { addTooltip: "addTooltip", attributes: "attributes" }, outputs: { attributeClick: "attributeClick" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "filterContainer", 4, "ngIf"], [1, "filterContainer"], [1, "sort"], ["title", "Toggle Sort", 1, "fa", "fa-sort-numeric-up", "fa-border", 3, "hidden", "click"], ["title", "Toggle Sort", 1, "fa", "fa-sort-alpha-up", "fa-border", 3, "hidden", "click"], ["title", "Toggle Sort", 1, "fa", "fa-sort-alpha-down", "fa-border", 3, "hidden", "click"], ["class", "fa fa-search fa-border", "title", "Show Search", 3, "click", 4, "ngIf"], [1, "removeSpaceContainer"], ["class", "field-item", 4, "ngFor", "ngForOf"], [1, "filter"], [1, "input-group", "mb-3"], [1, "input-group-prepend"], [1, "input-group-text"], ["type", "text", "class", "form-control", 3, "ngModel", "ngModelChange", 4, "ngIf"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Show Search", 1, "fa", "fa-search", "fa-border", 3, "click"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], [1, "fa", "fa-plus-circle", "hand", 3, "title"]], template: function DwFieldSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFieldSelectionComponent_ng_container_0_Template, 11, 7, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.attributes == null ? null : ctx.attributes.length) > 0);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [".filterContainer[_ngcontent-%COMP%]{overflow:auto}.removeSpaceContainer[_ngcontent-%COMP%]{margin-top:-45px;transition:all 2s}.filter[_ngcontent-%COMP%]{float:left;width:100%}.filter[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right;font-size:1.1em}.sort[_ngcontent-%COMP%]{float:right;height:45px}.sort[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{float:right;font-size:1.1em;margin-right:3px}"] });
DwFieldSelectionComponent.ctorParameters = () => [];
DwFieldSelectionComponent.propDecorators = {
    addTooltip: [{ type: Input }],
    attributes: [{ type: Input }],
    attributeClick: [{ type: Output }]
};
var DwFieldSorts;
(function (DwFieldSorts) {
    DwFieldSorts["none"] = "none";
    DwFieldSorts["alphaAsc"] = "alphaAsc";
    DwFieldSorts["alphaDesc"] = "alphaDesc";
})(DwFieldSorts || (DwFieldSorts = {}));

class DwConditionalFieldClassesComponent {
    constructor() {
        this.classNames = ['icon', 'label', 'data'];
        this.classLabels = ['Icon Class', 'Label Classes', 'Data Classes'];
        this.conditionalClassesChange = new EventEmitter();
    }
    ngOnChanges(changes) {
        this.setupControl();
    }
    ngOnInit() {
        this.setupControl();
    }
    setupControl() {
        // Ensure conditional classes are setup
        if (this.conditionalClasses == null) {
            this.conditionalClasses = {};
        }
        for (const className of this.classNames || []) {
            this.conditionalClasses[className] = this.conditionalClasses[className] || [];
        }
        this.onChange();
    }
    addItem(className) {
        this.conditionalClasses[className] = this.conditionalClasses[className] || [];
        const fieldClass = {
            expression: null,
            className: null,
        };
        this.conditionalClasses[className].push(fieldClass);
        this.onChange();
    }
    removeItem(className, fieldClass) {
        const classes = this.conditionalClasses[className] = this.conditionalClasses[className] || [];
        const index = classes.indexOf(fieldClass);
        if (index >= 0) {
            classes.splice(index, 1);
        }
        this.onChange();
    }
    onChange() {
        this.conditionalClassesChange.emit(this.conditionalClasses);
    }
}
DwConditionalFieldClassesComponent.ɵfac = function DwConditionalFieldClassesComponent_Factory(t) { return new (t || DwConditionalFieldClassesComponent)(); };
DwConditionalFieldClassesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwConditionalFieldClassesComponent, selectors: [["dw-conditional-field-classes"]], inputs: { classNames: "classNames", classLabels: "classLabels", conditionalClasses: "conditionalClasses", contextNames: "contextNames", itemName: "itemName", queryMeaning: "queryMeaning" }, outputs: { conditionalClassesChange: "conditionalClassesChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["fieldClassTemplate", ""], ["dwRow", ""], ["dwCol", "12"], ["dwCol", ""], [1, "btn-sm", "btn-success", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["title", "Remove Class", 1, "fa", "fa-times-circle", "dw-red", "pull-right", 3, "click"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "expr-column-full"], [3, "ngModel", "contextNames", "item", "queryMeaning", "ngModelChange"]], template: function DwConditionalFieldClassesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwConditionalFieldClassesComponent_div_0_Template, 10, 2, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwConditionalFieldClassesComponent_ng_template_1_Template, 11, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.classNames);
    } }, directives: [ɵngcc4.NgForOf, DwRowDirective, DwColDirective, ɵngcc4.NgTemplateOutlet, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwExpressionPickerControlComponent], styles: [""] });
DwConditionalFieldClassesComponent.ctorParameters = () => [];
DwConditionalFieldClassesComponent.propDecorators = {
    classNames: [{ type: Input }],
    classLabels: [{ type: Input }],
    conditionalClasses: [{ type: Input }],
    conditionalClassesChange: [{ type: Output }],
    contextNames: [{ type: Input }],
    itemName: [{ type: Input }],
    queryMeaning: [{ type: Input }]
};

class DwGridColumnBaseComponent {
    constructor() {
        this.inEditMode = false;
    }
    initColumn(params) {
        var _a;
        this.params = params;
        if (this.params.colDef) {
            this.gridColumnConfig = this.params.colDef.columnRendererConfig;
        }
        const gridContext = (_a = this.params.resolvedContext) === null || _a === void 0 ? void 0 : _a.mdGridContext;
        this.inEditMode = (gridContext === null || gridContext === void 0 ? void 0 : gridContext.inEditMode) || false;
        this.setDisplayValue();
        this.setupColumn();
    }
    setDisplayValue() {
        this.displayValue = this.params.value;
        if (this.params.renderFunc) {
            if (this.params.renderFunc) {
                this.displayValue = this.params.renderFunc(this.params.value);
            }
        }
    }
    triggerDefaultAction(event) {
        if (!this.params.colDef) {
            return;
        }
        const actionPreference = this.params.colDef.actionPreference;
        if (!actionPreference) {
            alert('No action preference to trigger!');
            return;
        }
        const actionEvent = {
            actionPreference: actionPreference,
            dwBrowserEvent: getDwBrowserEvent(event),
            actionContext: this.params.configContext
        };
        this.triggerAction(actionEvent);
    }
    triggerAction(actionEvent) {
        this.params.triggerGridEvent(this.params.colDef, this.params.data, DwGridEventType.rowActionButton, actionEvent);
    }
    cancelRowEdit(rowData) {
        this.params.cancelRowEdit(rowData);
    }
}

var DwGridRowActionInlineViewModes;
(function (DwGridRowActionInlineViewModes) {
    DwGridRowActionInlineViewModes["always"] = "always";
    DwGridRowActionInlineViewModes["edited"] = "edited";
    DwGridRowActionInlineViewModes["notEdited"] = "notEdited";
    DwGridRowActionInlineViewModes["editing"] = "editing";
    DwGridRowActionInlineViewModes["notEditing"] = "notEditing";
    DwGridRowActionInlineViewModes["deleted"] = "deleted";
    DwGridRowActionInlineViewModes["notDeleted"] = "notDeleted";
})(DwGridRowActionInlineViewModes || (DwGridRowActionInlineViewModes = {}));

var __decorate$1F = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1g = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const defaultGridColumnActionButtonsRenderer = 'dw-grid-column-action-buttons';
let DwGridColumnActionButtonsComponent = class DwGridColumnActionButtonsComponent extends DwGridColumnBaseComponent {
    constructor(mdActionExpressionService) {
        super();
        this.mdActionExpressionService = mdActionExpressionService;
        this.rowActionPreferences = [];
        this.rowActionsInlineEditPreferences = [];
        this.allRowActionPreferences = [];
        this.allRowActionsInlineEditPreferences = [];
        this.edited = false;
        this.editing = false;
    }
    setupColumn() {
        var _a, _b;
        // Allow to use a list of actions preferences or a single action preference
        this.allRowActionPreferences = this.params.rowActionPreferences || [];
        this.allRowActionsInlineEditPreferences = this.params.rowActionsInlineEditPreferences || [];
        if (this.allRowActionPreferences.length == 0 && ((_a = this.params.colDef) === null || _a === void 0 ? void 0 : _a.actionPreference)) {
            this.allRowActionPreferences = [this.params.colDef.actionPreference];
        }
        this.data = this.params.data;
        this.actionContext = Object.assign(Object.assign({}, this.params.configContext), { rowData: this.data, params: this.params });
        this.edited = (_b = this.data) === null || _b === void 0 ? void 0 : _b._edited;
        this.editing = this.params.isEditingRow();
        this.setupButtonVisibility();
        this.rowEditingChangedSubcription = this.params.rowEditingChanged().subscribe(() => {
            var _a;
            console.log('Row editing changed, setting up button visibility');
            this.edited = (_a = this.data) === null || _a === void 0 ? void 0 : _a._edited;
            this.editing = this.params.isEditingRow();
            this.setupButtonVisibility();
        });
    }
    setupButtonVisibility() {
        const rowActionResults = this.mdActionExpressionService.executeActionEnabledVisibleRules(this.allRowActionPreferences, this.params.data, this.params.resolvedContext);
        this.rowActionPreferences = rowActionResults.initialResults;
        const rowActionInlineEditResults = this.mdActionExpressionService.executeActionEnabledVisibleRules(this.allRowActionsInlineEditPreferences, this.params.data, this.params.resolvedContext, 
        // Additional inline rule to show only for edited rows
        (actionPref, actionHandlerRegistration) => {
            return this.showInlineRowAction(actionPref, actionHandlerRegistration);
        });
        this.rowActionsInlineEditPreferences = rowActionInlineEditResults.initialResults;
    }
    showInlineRowAction(actionPref, actionHandlerRegistration) {
        var _a, _b, _c;
        const config = actionHandlerRegistration.configData;
        const state = {
            edited: this.edited,
            editing: this.editing,
            deleted: (_a = this.data) === null || _a === void 0 ? void 0 : _a._isDeleted
        };
        if ((_b = config === null || config === void 0 ? void 0 : config.inlineEditingOptions) === null || _b === void 0 ? void 0 : _b.inlineRowActionViewRule) {
            return config.inlineEditingOptions.inlineRowActionViewRule(state, this.data);
        }
        let result = true;
        switch ((_c = config === null || config === void 0 ? void 0 : config.inlineEditingOptions) === null || _c === void 0 ? void 0 : _c.inlineRowActionViewMode) {
            case DwGridRowActionInlineViewModes.edited:
                result = this.edited;
                break;
            case DwGridRowActionInlineViewModes.notEdited:
                result = !this.edited;
                break;
            case DwGridRowActionInlineViewModes.editing:
                result = this.editing;
                break;
            case DwGridRowActionInlineViewModes.notEditing:
                result = !this.editing;
                break;
            case DwGridRowActionInlineViewModes.always:
            default:
                break;
        }
        return result;
    }
};
DwGridColumnActionButtonsComponent.ɵfac = function DwGridColumnActionButtonsComponent_Factory(t) { return new (t || DwGridColumnActionButtonsComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionExpressionService)); };
DwGridColumnActionButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridColumnActionButtonsComponent, selectors: [["dw-grid-column-action-buttons"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 6, consts: [[1, "dw-grid-row-buttons", 3, "hidden"], ["useContainerStyle", "false", 3, "actionPreferences", "actionContext", "actionClick"]], template: function DwGridColumnActionButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dw-action-bar", 1);
        ɵngcc0.ɵɵlistener("actionClick", function DwGridColumnActionButtonsComponent_Template_dw_action_bar_actionClick_1_listener($event) { return ctx.triggerAction($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 0);
        ɵngcc0.ɵɵelementStart(3, "dw-action-bar", 1);
        ɵngcc0.ɵɵlistener("actionClick", function DwGridColumnActionButtonsComponent_Template_dw_action_bar_actionClick_3_listener($event) { return ctx.triggerAction($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !(ctx.params == null ? null : ctx.params.data) || ctx.inEditMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("actionPreferences", ctx.rowActionPreferences)("actionContext", ctx.actionContext);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.params == null ? null : ctx.params.data) || !ctx.inEditMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("actionPreferences", ctx.rowActionsInlineEditPreferences)("actionContext", ctx.actionContext);
    } }, directives: [DwActionBarComponent], encapsulation: 2 });
DwGridColumnActionButtonsComponent.ctorParameters = () => [
    { type: DwMetaDataActionExpressionService }
];
DwGridColumnActionButtonsComponent = __decorate$1F([
    DwGridColumn({
        keyName: 'dw-grid-column-action-buttons',
        display: 'Action Buttons Column',
        decoratorType: DwDecoratorType.component,
        isGlobal: true,
        allowAction: true,
        showActionButtonConfig: true,
        requireAction: true,
    }),
    __metadata$1g("design:paramtypes", [DwMetaDataActionExpressionService])
], DwGridColumnActionButtonsComponent);

class DwGridColumnImageConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return { imageUrl: '', };
    }
}
DwGridColumnImageConfigComponent.ɵfac = function DwGridColumnImageConfigComponent_Factory(t) { return ɵDwGridColumnImageConfigComponent_BaseFactory(t || DwGridColumnImageConfigComponent); };
DwGridColumnImageConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridColumnImageConfigComponent, selectors: [["dw-dw-grid-column-image-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 31, vars: 6, consts: [["dwRow", ""], ["dwCol", "12"], [1, "label"], ["title", "Replacements can be used using [data.fieldName] and [globals.apiRoot]", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Used when any placeholder is null in the Image Url", 1, "fa", "fa-info-circle"], ["dwCol", "6"], ["title", "Optional field name to display to the right of the image", 1, "fa", "fa-info-circle"]], template: function DwGridColumnImageConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3, "Image Url ");
        ɵngcc0.ɵɵelement(4, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_5_listener($event) { return ctx.config.imageUrl = $event; })("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 0);
        ɵngcc0.ɵɵelementStart(7, "div", 1);
        ɵngcc0.ɵɵelementStart(8, "label", 2);
        ɵngcc0.ɵɵtext(9, "Missing Image Url ");
        ɵngcc0.ɵɵelement(10, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_11_listener($event) { return ctx.config.missingImageUrl = $event; })("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_11_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 0);
        ɵngcc0.ɵɵelementStart(13, "div", 6);
        ɵngcc0.ɵɵelementStart(14, "label", 2);
        ɵngcc0.ɵɵtext(15, "Width");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_16_listener($event) { return ctx.config.imageWidth = $event; })("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_16_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 6);
        ɵngcc0.ɵɵelementStart(18, "label", 2);
        ɵngcc0.ɵɵtext(19, "Height");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_20_listener($event) { return ctx.config.imageHeight = $event; })("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_20_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 0);
        ɵngcc0.ɵɵelementStart(22, "div", 6);
        ɵngcc0.ɵɵelementStart(23, "label", 2);
        ɵngcc0.ɵɵtext(24, "Image Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_25_listener($event) { return ctx.config.imageClass = $event; })("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_25_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 6);
        ɵngcc0.ɵɵelementStart(27, "label", 2);
        ɵngcc0.ɵɵtext(28, "Display Field ");
        ɵngcc0.ɵɵelement(29, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_30_listener($event) { return ctx.config.displayAttributeName = $event; })("ngModelChange", function DwGridColumnImageConfigComponent_Template_input_ngModelChange_30_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.imageUrl);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.missingImageUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.imageWidth);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.imageHeight);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.imageClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.displayAttributeName);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$1G = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1h = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridColumnImageComponent = class DwGridColumnImageComponent extends DwGridColumnBaseComponent {
    constructor(dwConfigService, dwTemplateUtil) {
        super();
        this.dwConfigService = dwConfigService;
        this.dwTemplateUtil = dwTemplateUtil;
        this.style = {};
        this.missingFieldText = "[MISSINGFIELD]";
        this.displayValue2 = '';
    }
    setupColumn() {
        var _a, _b, _c, _d, _e;
        const rowData = this.params.data;
        const globals = this.dwConfigService.coreConfig.globals;
        if (!rowData) {
            return;
        }
        if ((_a = this.gridColumnConfig) === null || _a === void 0 ? void 0 : _a.displayAttributeName) {
            this.displayValue2 = rowData[(_b = this.gridColumnConfig) === null || _b === void 0 ? void 0 : _b.displayAttributeName];
        }
        const options = { blankReplacementValue: this.missingFieldText };
        this.imageSrc = this.dwTemplateUtil.processTemplate((_c = this.gridColumnConfig) === null || _c === void 0 ? void 0 : _c.imageUrl, rowData, null, globals, options);
        let missingField = this.isMissingField(this.imageSrc);
        if (missingField && ((_d = this.gridColumnConfig) === null || _d === void 0 ? void 0 : _d.missingImageUrl)) {
            this.imageSrc = this.dwTemplateUtil.processTemplate((_e = this.gridColumnConfig) === null || _e === void 0 ? void 0 : _e.missingImageUrl, rowData, null, globals, options);
        }
        missingField = this.isMissingField(this.imageSrc);
        if (missingField) {
            this.imageSrc = null;
        }
        this.style.width = this.gridColumnConfig.imageWidth;
        this.style.height = this.gridColumnConfig.imageHeight;
    }
    isMissingField(url) {
        return url.indexOf(this.missingFieldText) >= 0;
    }
};
DwGridColumnImageComponent.ɵfac = function DwGridColumnImageComponent_Factory(t) { return new (t || DwGridColumnImageComponent)(ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwTemplateUtilService)); };
DwGridColumnImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridColumnImageComponent, selectors: [["dw-grid-column-image"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 4, consts: [[1, "dw-image-column-container"], [1, "dw-image-column-image", 3, "ngStyle"], [3, "src", "ngStyle", "ngClass", 4, "ngIf"], [1, "dw-image-column-text", 3, "hidden"], [3, "src", "ngStyle", "ngClass"]], template: function DwGridColumnImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwGridColumnImageComponent_img_2_Template, 1, 3, "img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.style);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.imageSrc);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.gridColumnConfig == null ? null : ctx.gridColumnConfig.displayAttributeName));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.displayValue2, " ");
    } }, directives: [ɵngcc4.NgStyle, ɵngcc4.NgIf, DwMissingImageDirective, ɵngcc4.NgClass], encapsulation: 2 });
DwGridColumnImageComponent.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwTemplateUtilService }
];
DwGridColumnImageComponent = __decorate$1G([
    DwGridColumn({
        keyName: 'dw-grid-column-image',
        display: 'Image Column',
        decoratorType: DwDecoratorType.component,
        configComponent: DwGridColumnImageConfigComponent,
        isGlobal: true,
        allowAction: true,
        showActionButtonConfig: false,
        requireAction: false,
        useAutoRowHeight: true,
        allowAttr: false,
        requireAttr: false
    }),
    __metadata$1h("design:paramtypes", [DwConfigService,
        DwTemplateUtilService])
], DwGridColumnImageComponent);

var __decorate$1H = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwGridColumnLinkRendererService = class DwGridColumnLinkRendererService {
    renderColumn(columnConfig) {
        return (params) => {
            var _a;
            const renderFunc = standardRenderer(columnConfig);
            const innerTemplate = renderFunc(params);
            if (innerTemplate == undefined) {
                return '';
            }
            if (((_a = params.data) === null || _a === void 0 ? void 0 : _a._edited) == true) {
                return innerTemplate;
            }
            return `<span class="a-link">${innerTemplate}</span>`;
        };
    }
};
DwGridColumnLinkRendererService.ɵfac = function DwGridColumnLinkRendererService_Factory(t) { return new (t || DwGridColumnLinkRendererService)(); };
DwGridColumnLinkRendererService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridColumnLinkRendererService, factory: function (t) { return DwGridColumnLinkRendererService.ɵfac(t); } });
DwGridColumnLinkRendererService = __decorate$1H([
    DwGridColumn({
        keyName: 'dw-grid-column-link',
        display: 'Link Column',
        decoratorType: DwDecoratorType.service,
        isGlobal: true,
        allowAction: true,
        showActionButtonConfig: false,
        requireAction: true,
        allowAttr: true,
        requireAttr: true,
    })
], DwGridColumnLinkRendererService);

class DwAssociativeLookupFilterConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwMetaDataService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
    }
    setupComponent() {
        super.setupComponent();
        this.subscriptions.push(this.dwMetaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
            this.loadChildMetaData();
        }));
    }
    loadChildMetaData() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.relationshipInfo) === null || _b === void 0 ? void 0 : _b.childItem)) {
            return;
        }
        this.subscriptions.push(this.dwMetaDataService.getMetaData((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.relationshipInfo) === null || _d === void 0 ? void 0 : _d.childItem)
            .subscribe(itemMetaData => {
            this.childItemMetaData = itemMetaData;
        }));
    }
    onRelationshipChange(relationshipName) {
        this.config.relationshipInfo = this.getRelationshipInfo(relationshipName, this.configContext.itemName);
        this.loadChildMetaData();
        this.onChange();
    }
    onChildRelationshipChange(relationshipName) {
        this.config.childRelationshipInfo = this.getRelationshipInfo(relationshipName, this.config.relationshipInfo.childItem, this.childItemMetaData);
        this.onChange();
    }
    getRelationshipInfo(relationshipName, parentItem, itemMetaData) {
        const relationshipInfo = {};
        if (!itemMetaData) {
            itemMetaData = this.itemMetaData;
        }
        const relationship = itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        if (relationship) {
            relationshipInfo.relationshipName = relationshipName;
            relationshipInfo.propertyName = relationship.NamingInfo.RelationshipPropertyName;
            if (relationship) {
                if (relationship.PkUniqueItemName == parentItem) {
                    relationshipInfo.parentItem = relationship.PkUniqueItemName;
                    relationshipInfo.childItem = relationship.FkUniqueItemName;
                }
                else {
                    relationshipInfo.parentItem = relationship.FkUniqueItemName;
                    relationshipInfo.childItem = relationship.PkUniqueItemName;
                }
            }
        }
        return relationshipInfo;
    }
    getDefaultConfig() {
        return {};
    }
}
DwAssociativeLookupFilterConfigComponent.ɵfac = function DwAssociativeLookupFilterConfigComponent_Factory(t) { return new (t || DwAssociativeLookupFilterConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwAssociativeLookupFilterConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAssociativeLookupFilterConfigComponent, selectors: [["dw-associative-lookup-filter-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 14, vars: 5, consts: [["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], [3, "ngValue"]], template: function DwAssociativeLookupFilterConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "select", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeLookupFilterConfigComponent_Template_select_ngModelChange_4_listener($event) { return ctx.onRelationshipChange($event); });
        ɵngcc0.ɵɵtemplate(5, DwAssociativeLookupFilterConfigComponent_option_5_Template, 2, 3, "option", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwAssociativeLookupFilterConfigComponent_div_6_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(7, DwAssociativeLookupFilterConfigComponent_div_7_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 0);
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Allow Multiple");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 6);
        ɵngcc0.ɵɵelementStart(13, "p-inputSwitch", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAssociativeLookupFilterConfigComponent_Template_p_inputSwitch_ngModelChange_13_listener($event) { return ctx.config.allowMultiple = $event; })("ngModelChange", function DwAssociativeLookupFilterConfigComponent_Template_p_inputSwitch_ngModelChange_13_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config == null ? null : ctx.config.relationshipInfo == null ? null : ctx.config.relationshipInfo.relationshipName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.itemMetaData == null ? null : ctx.itemMetaData.Relations);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config == null ? null : ctx.config.relationshipInfo == null ? null : ctx.config.relationshipInfo.relationshipName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.useChildRelationship && (ctx.config == null ? null : ctx.config.relationshipInfo == null ? null : ctx.config.relationshipInfo.relationshipName));
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.allowMultiple);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
DwAssociativeLookupFilterConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1I = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1i = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwAssociativeLookupFilterComponent = class DwAssociativeLookupFilterComponent extends DwFilterItemBase {
    constructor(dwMetaDataService, cdr) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.cdr = cdr;
        this.lookupIds = [];
    }
    ngOnInit() {
        this.setupList();
    }
    setupList() {
        var _a, _b, _c;
        const additionalConfig = ((_a = this.filterConfig) === null || _a === void 0 ? void 0 : _a.additionalConfig) || {};
        this.childItem = ((_b = additionalConfig.childRelationshipInfo) === null || _b === void 0 ? void 0 : _b.childItem) || additionalConfig.relationshipInfo.childItem;
        this.parentItem = ((_c = additionalConfig.childRelationshipInfo) === null || _c === void 0 ? void 0 : _c.parentItem) || additionalConfig.relationshipInfo.parentItem;
        const ob = this.dwMetaDataService.getAssociativeRelationConfig(this.childItem, this.parentItem, null, null, false);
        ob.subscribe(associativeConfig => {
            if (!associativeConfig) {
                //console.warn(`Associative Config is null`, this.childItem, this.parentItem);
                return;
            }
            //console.warn(`Associative Config is set ${associativeConfig.lookupId}`, associativeConfig);
            this.associativeConfig = associativeConfig;
            this.lookupIdsChanged();
            this.cdr.detectChanges();
        });
    }
    lookupValueChanged() {
        if (this.lookupValue) {
            this.lookupIds = [this.lookupValue];
        }
        else {
            this.lookupIds = [];
        }
        this.lookupIdsChanged();
    }
    lookupIdsChanged() {
        if (!this.associativeConfig) {
            return;
        }
        if (!this.lookupIds || this.lookupIds.length == 0) {
            this.filter = null;
            return;
        }
        const filterGroup = new DwQueryFilterGroup();
        const qh = new DwQueryHelper();
        filterGroup.AddFilterAnd(qh.filters.InList(`${this.childItem}.${this.associativeConfig.associativeFkAttributeName}`, this.lookupIds));
        this.filter = filterGroup;
    }
};
DwAssociativeLookupFilterComponent.ɵfac = function DwAssociativeLookupFilterComponent_Factory(t) { return new (t || DwAssociativeLookupFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwAssociativeLookupFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAssociativeLookupFilterComponent, selectors: [["dw-associative-lookup-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [[1, "label"], [4, "ngIf"], [3, "ngModel", "lookupId", "valueAttrName", "ngModelChange"]], template: function DwAssociativeLookupFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, DwAssociativeLookupFilterComponent_ng_container_2_Template, 2, 3, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(3, DwAssociativeLookupFilterComponent_ng_container_3_Template, 2, 3, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.filterConfig.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.filterConfig == null ? null : ctx.filterConfig.additionalConfig == null ? null : ctx.filterConfig.additionalConfig.allowMultiple) && (ctx.associativeConfig == null ? null : ctx.associativeConfig.lookupId));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !(ctx.filterConfig == null ? null : ctx.filterConfig.additionalConfig == null ? null : ctx.filterConfig.additionalConfig.allowMultiple) && (ctx.associativeConfig == null ? null : ctx.associativeConfig.lookupId));
    } }, directives: [ɵngcc4.NgIf, DwMultiSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwSearchSelectLookupComponent], encapsulation: 2 });
DwAssociativeLookupFilterComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: ChangeDetectorRef }
];
DwAssociativeLookupFilterComponent = __decorate$1I([
    DwComponent({
        name: 'Associative Lookup Filter',
        key: 'dwAssociativeLookupFilter',
        componentType: DwComponentType.filterItem,
        configComponent: DwAssociativeLookupFilterConfigComponent,
        isGlobal: true,
        configData: {
            showCaption: true,
            showCompareType: false,
            showControlOptions: false,
            requireAttr: false,
            showPlaceholderText: true,
            showDefaultValue: false,
            allowAttr: false,
        },
    }),
    __metadata$1i("design:paramtypes", [DwMetaDataService, ChangeDetectorRef])
], DwAssociativeLookupFilterComponent);

class DwAdhocLookupFilterConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwMetaDataService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
    }
    setupComponent() {
        super.setupComponent();
        if (!this.configContext.filterConfig.attr) {
            return;
        }
        this.subscriptions.push(this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
            const attr = this.itemMetaData.Attributes.find(a => { var _a; return a.AttributeName == ((_a = this.configContext.filterConfig) === null || _a === void 0 ? void 0 : _a.attr); });
            if (attr && attr.Attribute.MetaDataLookupId) {
                this.dwMetaDataService.getLookupDefinition(attr.Attribute.MetaDataLookupId)
                    .subscribe(lookupDef => {
                    this.config.lookupMeaning = lookupDef.LookupMeaning;
                    this.onChange();
                });
            }
        }));
    }
    getDefaultConfig() {
        const config = {
            matchAll: true
        };
        return config;
    }
}
DwAdhocLookupFilterConfigComponent.ɵfac = function DwAdhocLookupFilterConfigComponent_Factory(t) { return new (t || DwAdhocLookupFilterConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwAdhocLookupFilterConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAdhocLookupFilterConfigComponent, selectors: [["dw-adhoc-lookup-filter-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 7, vars: 1, consts: [["dwRow", ""], ["dwCol", "9"], ["title", "Determines if matches all or any items selected", 1, "fa", "fa-info-circle"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"]], template: function DwAdhocLookupFilterConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Match All ");
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAdhocLookupFilterConfigComponent_Template_p_inputSwitch_ngModelChange_6_listener($event) { return ctx.config.matchAll = $event; })("ngModelChange", function DwAdhocLookupFilterConfigComponent_Template_p_inputSwitch_ngModelChange_6_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.matchAll);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwAdhocLookupFilterConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1J = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1j = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwAdhocLookupFilterComponent = class DwAdhocLookupFilterComponent extends DwFilterItemBase {
    constructor(dwMetaDataService, dwAdhocLookupService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.dwAdhocLookupService = dwAdhocLookupService;
    }
    setupFilter() {
        var _a, _b;
        this.label = this.filterConfig.label;
        this.attr = this.queryMetaData.Attributes.find(a => a.AttributeName == this.filterConfig.attr);
        if (this.attr) {
            this.label = this.filterConfig.label || this.attr.AttributeDisplay;
            this.lookupIdMeaning = ((_b = (_a = this.filterConfig) === null || _a === void 0 ? void 0 : _a.additionalConfig) === null || _b === void 0 ? void 0 : _b.lookupMeaning) || this.attr.Attribute.MetaDataLookupId;
        }
    }
    valuesChanged() {
        var _a, _b;
        const itemList = this.dwAdhocLookupService.convertAdhocStringToArray(this.values);
        if (!itemList || itemList.length == 0) {
            this.filter = null;
            return;
        }
        const filterGroup = new DwQueryFilterGroup();
        const qh = new DwQueryHelper();
        const filterFieldName = `${this.attr.RelationPrefix}.${this.attr.AttributeName}`;
        for (const item of itemList) {
            // Add brackets so we can unique identify this item in the text field
            const bracketItem = this.dwAdhocLookupService.addBrackets(item, true);
            if ((_b = (_a = this.filterConfig) === null || _a === void 0 ? void 0 : _a.additionalConfig) === null || _b === void 0 ? void 0 : _b.matchAll) {
                filterGroup.AddFilterAnd(qh.filters.Contains(filterFieldName, bracketItem));
            }
            else {
                filterGroup.AddFilterOr(qh.filters.Contains(filterFieldName, bracketItem));
            }
        }
        this.filter = filterGroup;
    }
};
DwAdhocLookupFilterComponent.ɵfac = function DwAdhocLookupFilterComponent_Factory(t) { return new (t || DwAdhocLookupFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwAdhocLookupService)); };
DwAdhocLookupFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAdhocLookupFilterComponent, selectors: [["dw-adhoc-lookup-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, consts: [[1, "label"], [3, "ngModel", "lookupId", "ngModelChange"]], template: function DwAdhocLookupFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "dw-multi-select-adhoc-lookup", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAdhocLookupFilterComponent_Template_dw_multi_select_adhoc_lookup_ngModelChange_2_listener($event) { return ctx.values = $event; })("ngModelChange", function DwAdhocLookupFilterComponent_Template_dw_multi_select_adhoc_lookup_ngModelChange_2_listener() { return ctx.valuesChanged(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.values)("lookupId", ctx.lookupIdMeaning);
    } }, directives: [DwMultiSelectAdhocComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwAdhocLookupFilterComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwAdhocLookupService }
];
DwAdhocLookupFilterComponent = __decorate$1J([
    DwComponent({
        name: 'Adhoc Lookup Filter',
        key: 'dwAdhocLookupFilter',
        componentType: DwComponentType.filterItem,
        configComponent: DwAdhocLookupFilterConfigComponent,
        isGlobal: true,
        configData: {
            showCaption: true,
            showCompareType: false,
            showControlOptions: false,
            showPlaceholderText: true,
            showDefaultValue: false,
            allowAttr: true,
            requireAttr: true,
        },
    }),
    __metadata$1j("design:paramtypes", [DwMetaDataService,
        DwAdhocLookupService])
], DwAdhocLookupFilterComponent);

class DwMultiSelectFilterConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
DwMultiSelectFilterConfigComponent.ɵfac = function DwMultiSelectFilterConfigComponent_Factory(t) { return ɵDwMultiSelectFilterConfigComponent_BaseFactory(t || DwMultiSelectFilterConfigComponent); };
DwMultiSelectFilterConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiSelectFilterConfigComponent, selectors: [["dw-multi-select-filter-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 1, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3", 1, "pull-right"], [3, "ngModel", "ngModelChange"]], template: function DwMultiSelectFilterConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Auto Expand");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiSelectFilterConfigComponent_Template_p_inputSwitch_ngModelChange_5_listener($event) { return ctx.config.autoExpand = $event; })("ngModelChange", function DwMultiSelectFilterConfigComponent_Template_p_inputSwitch_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.autoExpand);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

class DwMultiSelectFilterService {
    constructor(dwMenuService, dwFilterService) {
        this.dwMenuService = dwMenuService;
        this.dwFilterService = dwFilterService;
    }
    buildFilter(attr, value) {
        if (!attr) {
            return null;
        }
        const qh = new DwQueryHelper();
        const filterTypeKey = qh.convertFilterType(DwFilterType.In);
        const filter = {};
        const attrFilter = filter[attr.AttributeName] = {};
        attrFilter.Prefix = attr.RelationPrefix;
        attrFilter[filterTypeKey] = value;
        return filter;
    }
    buildInitialFilter(filterConfig, item, queryMetaData, existingFilter, resolvedContext) {
        const defaultValue = this.getDefaultValue(filterConfig, resolvedContext);
        if (defaultValue) {
            const attr = queryMetaData.Attributes.find(a => a.AttributeName == filterConfig.attr);
            return this.buildFilter(attr, defaultValue);
        }
        return null;
    }
    getDefaultValue(filterConfig, resolvedContext) {
        if (filterConfig.defaultValue) {
            const defaultValue = this.dwFilterService.getDefaultValue(filterConfig.hasDefaultValue, filterConfig.defaultValue, resolvedContext);
            if (defaultValue) {
                return this.parseFilterValue(defaultValue);
            }
        }
        return null;
    }
    parseFilterValue(values) {
        return values.split(',').filter(i => i.trim().length > 0);
    }
}
DwMultiSelectFilterService.ɵfac = function DwMultiSelectFilterService_Factory(t) { return new (t || DwMultiSelectFilterService)(ɵngcc0.ɵɵinject(DwMenuService), ɵngcc0.ɵɵinject(DwMetaDataFilterService)); };
DwMultiSelectFilterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMultiSelectFilterService, factory: DwMultiSelectFilterService.ɵfac });
DwMultiSelectFilterService.ctorParameters = () => [
    { type: DwMenuService },
    { type: DwMetaDataFilterService }
];

var __decorate$1K = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1k = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwMultiSelectLookupFilterComponent = class DwMultiSelectLookupFilterComponent extends DwFilterItemBase {
    constructor(dwFilterService, dwMultiSelectFilterService) {
        super();
        this.dwFilterService = dwFilterService;
        this.dwMultiSelectFilterService = dwMultiSelectFilterService;
    }
    setupFilter() {
        var _a, _b, _c, _d;
        this.label = this.filterConfig.label;
        this.attr = this.queryMetaData.Attributes.find(a => a.AttributeName == this.filterConfig.attr);
        if (this.attr) {
            this.label = this.filterConfig.label || this.attr.AttributeDisplay;
            this.lookupIdMeaning = ((_b = (_a = this.filterConfig) === null || _a === void 0 ? void 0 : _a.additionalConfig) === null || _b === void 0 ? void 0 : _b.lookupMeaning) || this.attr.Attribute.MetaDataLookupId;
        }
        if ((_d = (_c = this.filterConfig.lookupConfig) === null || _c === void 0 ? void 0 : _c.lookupIdOverride) === null || _d === void 0 ? void 0 : _d.value) {
            this.lookupIdMeaning = this.filterConfig.lookupConfig.lookupIdOverride.value;
        }
        const defaultValue = this.dwMultiSelectFilterService.getDefaultValue(this.filterConfig, this.resolvedContext);
        if (defaultValue) {
            this.values = defaultValue;
            this.valuesChanged();
        }
    }
    valuesChanged() {
        if (this.values && typeof (this.values) === 'string') {
            //this.values = (this.values as string).split(',').filter(i => i.trim().length>0);
            this.values = this.dwMultiSelectFilterService.parseFilterValue(this.values);
        }
        if (!this.values || this.values.length == 0) {
            this.filter = null;
            return;
        }
        this.filter = this.dwMultiSelectFilterService.buildFilter(this.attr, this.values);
    }
};
DwMultiSelectLookupFilterComponent.ɵfac = function DwMultiSelectLookupFilterComponent_Factory(t) { return new (t || DwMultiSelectLookupFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwMultiSelectFilterService)); };
DwMultiSelectLookupFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiSelectLookupFilterComponent, selectors: [["dw-multi-select-lookup-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [[1, "label"], ["useTransitions", "false", 3, "ngModel", "lookupId", "autoExpand", "ngModelChange"]], template: function DwMultiSelectLookupFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "dw-multi-select-lookup", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiSelectLookupFilterComponent_Template_dw_multi_select_lookup_ngModelChange_2_listener($event) { return ctx.values = $event; })("ngModelChange", function DwMultiSelectLookupFilterComponent_Template_dw_multi_select_lookup_ngModelChange_2_listener() { return ctx.valuesChanged(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.values)("lookupId", ctx.lookupIdMeaning)("autoExpand", ctx.filterConfig == null ? null : ctx.filterConfig.additionalConfig == null ? null : ctx.filterConfig.additionalConfig.autoExpand);
    } }, directives: [DwMultiSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwMultiSelectLookupFilterComponent.ctorParameters = () => [
    { type: DwMetaDataFilterService },
    { type: DwMultiSelectFilterService }
];
DwMultiSelectLookupFilterComponent = __decorate$1K([
    DwComponent({
        name: 'Multi-Select Lookup Filter',
        key: 'dwMultiSelectLookupFilter',
        componentType: DwComponentType.filterItem,
        isGlobal: true,
        configComponent: DwMultiSelectFilterConfigComponent,
        configData: {
            showCaption: true,
            showCompareType: false,
            showControlOptions: true,
            showPlaceholderText: true,
            showDefaultValue: true,
            defaultValueControlType: DwControlType.MultiSelect,
            allowAttr: true,
            requireAttr: true,
            requireLookup: true,
            initialFilterService: DwMultiSelectFilterService
        },
    }),
    __metadata$1k("design:paramtypes", [DwMetaDataFilterService, DwMultiSelectFilterService])
], DwMultiSelectLookupFilterComponent);

class DwMetaDataListConfigBasicWidgetComponent extends DwUiPanelWidgetBaseComponent {
    constructor(fb, dwEventService, dwModalService, dwUiConfigRegistryService, dwMetaDataService, dwDesignerStateService) {
        super(fb, dwDesignerStateService);
        this.dwEventService = dwEventService;
        this.dwModalService = dwModalService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.queries = [];
        this.setupDropdowns();
    }
    get listmPreferences() {
        return this.preferences;
    }
    get listPreferencesHierarchy() {
        return this.preferencesHierarchy;
    }
    startConfigureSection(state) {
        this.configFilters();
    }
    setupDropdowns() {
        this.listStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.listStyles);
    }
    loadQueries() {
        this.dwMetaDataService.getQueries(this.listPreferencesHierarchy.itemMetaData.MetaDataItemId)
            .subscribe(queries => this.queries = queries);
    }
    configSet() {
        if (!this.configKey)
            return;
        this.loadQueries();
    }
    setupEvents() {
    }
    createForm(fb) {
        return this.fb.group({
            showFilter: [null],
            showFilterOnLoad: [null],
            showHeader: [null],
            headerTitle: [null],
            autoFilter: [null],
            autoFilterDelay: [null],
            showDisplayProperties: [null],
            ignoreAttributes: [null],
            enableSorting: [null],
            useModal: [null],
            showActions: [null],
            hideRefresh: [null],
            hideViewToggle: [null],
            MetaDataQueryMeaning: [null],
            listStyleName: [null]
        });
    }
    onSubmit() {
        //console.log(this.configForm.value);
    }
    configFilters() {
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Configure Filters";
        modalConfig.component = DwMetadataConfigFiltersModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = '1200px';
        modalConfig.customModalHeight = '700px';
        modalConfig.data = {
            filters: this.preferences.filters,
            itemName: this.listPreferencesHierarchy.item
        };
        this.dwModalService.showModal(modalConfig)
            .subscribe(r => {
            if (!r.cancelled) {
                // Ensure there is a change befor updating
                if (areEqual(this.preferences.filters, r.data.filters))
                    return;
                this.preferences.filters = r.data.filters;
                this.preferencesChange.emit(this.preferences);
            }
        });
    }
    updateFilters() {
        this.onFormChange();
    }
}
DwMetaDataListConfigBasicWidgetComponent.ɵfac = function DwMetaDataListConfigBasicWidgetComponent_Factory(t) { return new (t || DwMetaDataListConfigBasicWidgetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService)); };
DwMetaDataListConfigBasicWidgetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataListConfigBasicWidgetComponent, selectors: [["dw-metadata-list-config-basic"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 88, vars: 4, consts: [[3, "formGroup", "ngSubmit"], ["header", "Basic Settings"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "showHeader"], ["dwCol", "12"], ["formControlName", "headerTitle"], ["formControlName", "showDisplayProperties"], ["header", "Filtering"], ["formControlName", "showFilter"], ["formControlName", "showFilterOnLoad"], ["formControlName", "autoFilter"], ["dwCol", "6"], ["type", "number", "formControlName", "autoFilterDelay", 1, "form-control"], [1, "btn", "btn-success", 3, "click"], ["header", "Actions"], ["formControlName", "showActions"], ["formControlName", "hideRefresh"], ["formControlName", "hideViewToggle"], ["header", "Data Setup"], ["formControlName", "MetaDataQueryMeaning", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["header", "List Style"], ["formControlName", "listStyleName", 1, "form-control"]], template: function DwMetaDataListConfigBasicWidgetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h3");
        ɵngcc0.ɵɵtext(2, "List Preferences");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "form", 0);
        ɵngcc0.ɵɵlistener("ngSubmit", function DwMetaDataListConfigBasicWidgetComponent_Template_form_ngSubmit_3_listener() { return ctx.onSubmit(); });
        ɵngcc0.ɵɵelementStart(4, "p-accordion");
        ɵngcc0.ɵɵelementStart(5, "p-accordionTab", 1);
        ɵngcc0.ɵɵelementStart(6, "div", 2);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "label");
        ɵngcc0.ɵɵtext(9, "Show Header");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 4);
        ɵngcc0.ɵɵelement(11, "p-inputSwitch", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 2);
        ɵngcc0.ɵɵelementStart(13, "div", 6);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Header Title");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 6);
        ɵngcc0.ɵɵelement(17, "input", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 2);
        ɵngcc0.ɵɵelementStart(19, "div", 3);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Show Display value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 4);
        ɵngcc0.ɵɵelement(23, "p-inputSwitch", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "p-accordionTab", 9);
        ɵngcc0.ɵɵelementStart(25, "div", 2);
        ɵngcc0.ɵɵelementStart(26, "div", 3);
        ɵngcc0.ɵɵelementStart(27, "label");
        ɵngcc0.ɵɵtext(28, "Allow Filtering");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 4);
        ɵngcc0.ɵɵelement(30, "p-inputSwitch", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 2);
        ɵngcc0.ɵɵelementStart(32, "div", 3);
        ɵngcc0.ɵɵelementStart(33, "label");
        ɵngcc0.ɵɵtext(34, "Show Filter On Load");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 4);
        ɵngcc0.ɵɵelement(36, "p-inputSwitch", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "div", 2);
        ɵngcc0.ɵɵelementStart(38, "div", 3);
        ɵngcc0.ɵɵelementStart(39, "label");
        ɵngcc0.ɵɵtext(40, "Auto Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(41, "div", 4);
        ɵngcc0.ɵɵelement(42, "p-inputSwitch", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "div", 2);
        ɵngcc0.ɵɵelementStart(44, "div", 13);
        ɵngcc0.ɵɵelementStart(45, "label");
        ɵngcc0.ɵɵtext(46, "Filter Delay");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "div", 13);
        ɵngcc0.ɵɵelement(48, "input", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(49, "div", 2);
        ɵngcc0.ɵɵelementStart(50, "div", 6);
        ɵngcc0.ɵɵelementStart(51, "button", 15);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataListConfigBasicWidgetComponent_Template_button_click_51_listener() { return ctx.configFilters(); });
        ɵngcc0.ɵɵtext(52, "Configure Filters");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(53, "p-accordionTab", 16);
        ɵngcc0.ɵɵelementStart(54, "div", 2);
        ɵngcc0.ɵɵelementStart(55, "div", 3);
        ɵngcc0.ɵɵelementStart(56, "label");
        ɵngcc0.ɵɵtext(57, "Show Action bar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(58, "div", 4);
        ɵngcc0.ɵɵelement(59, "p-inputSwitch", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(60, "div", 2);
        ɵngcc0.ɵɵelementStart(61, "div", 3);
        ɵngcc0.ɵɵelementStart(62, "label");
        ɵngcc0.ɵɵtext(63, "Hide Refresh Button");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(64, "div", 4);
        ɵngcc0.ɵɵelement(65, "p-inputSwitch", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(66, "div", 2);
        ɵngcc0.ɵɵelementStart(67, "div", 3);
        ɵngcc0.ɵɵelementStart(68, "label");
        ɵngcc0.ɵɵtext(69, "Hide View Toggle");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(70, "div", 4);
        ɵngcc0.ɵɵelement(71, "p-inputSwitch", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(72, "p-accordionTab", 20);
        ɵngcc0.ɵɵelementStart(73, "div", 2);
        ɵngcc0.ɵɵelementStart(74, "div", 6);
        ɵngcc0.ɵɵelementStart(75, "label");
        ɵngcc0.ɵɵtext(76, "Query");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(77, "select", 21);
        ɵngcc0.ɵɵelementStart(78, "option", 22);
        ɵngcc0.ɵɵtext(79, " Default ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(80, DwMetaDataListConfigBasicWidgetComponent_option_80_Template, 2, 2, "option", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(81, "p-accordionTab", 24);
        ɵngcc0.ɵɵelementStart(82, "div", 2);
        ɵngcc0.ɵɵelementStart(83, "div", 6);
        ɵngcc0.ɵɵelementStart(84, "label");
        ɵngcc0.ɵɵtext(85, "List Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(86, "select", 25);
        ɵngcc0.ɵɵtemplate(87, DwMetaDataListConfigBasicWidgetComponent_option_87_Template, 2, 2, "option", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("formGroup", ctx.configForm);
        ɵngcc0.ɵɵadvance(75);
        ɵngcc0.ɵɵproperty("ngValue", null);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.queries);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.listStyles);
    } }, directives: [ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor, ɵngcc3.NumberValueAccessor, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf], encapsulation: 2 });
DwMetaDataListConfigBasicWidgetComponent.ctorParameters = () => [
    { type: FormBuilder },
    { type: DwEventService },
    { type: DwModalService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwDesignerStateService }
];

class DwMetadataListBasicComponent extends DwUiConfigurableControlBase {
    constructor(metaDataListService, uiConfigService, dwEventService, dwMetaDataFilterService, dwSecurityService, dwConfigService) {
        super(uiConfigService, dwEventService, dwSecurityService, dwConfigService);
        this.metaDataListService = metaDataListService;
        this.dwMetaDataFilterService = dwMetaDataFilterService;
        this.dwSecurityService = dwSecurityService;
        this.configKeyPart = "";
    }
    ngOnInit() {
        //console.log("DwMetaDataListComponent - Initial filters", this.filters);
        super.ngOnInit();
        // Watch for a data change event and update the grid data automatically
        this.subscriptions.push(this.dwEventService.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(this.getItemName()))
            .subscribe((event) => {
            // Need to use a delay so that Angular can view the change (otherwise change events don't run on bound components)
            setTimeout(() => {
                if (this.dwDataList) {
                    this.dwDataList.loadData();
                }
            }, 5);
        }));
    }
    getItemName() {
        return this.item;
    }
    setFilters(filters) {
        this.filters = filters;
        setTimeout(() => {
            if (this.dwDataList) {
                this.dwDataList.filters = this.filters;
            }
        }, 5);
    }
    // #region Abstract Method implementation
    get configType() {
        return DwUiConfigType.list;
    }
    getConfigKey() {
        const itemName = this.item;
        if (!this.configKeyPart)
            return `${itemName}`;
        return `${itemName}-${this.configKeyPart}`;
    }
    setupConfig() {
        if (!this.item || !this.preferenceHierarchy)
            return;
        var newDataSource = this.metaDataListService.getDataSource(this.preferenceHierarchy);
        // if (!this.dataSource || !areEqual(this.getDataSourceItemName(this.dataSource.item), this.getDataSourceItemName(newDataSource.item)))
        if (this.isNewDataSource(newDataSource)) {
            this.dataSource = newDataSource;
        }
        this.config = this.metaDataListService.buildConfig(this.preferenceHierarchy);
        this.configContext = {
            itemName: this.item
        };
        this.filters = this.dwMetaDataFilterService.buildInitialFilters(this.config.filters, null, null, null, this.filters, this.item, this.preferenceHierarchy.queryMetaData[0], {});
    }
    isNewDataSource(newDataSource) {
        if (!this.dataSource) {
            return true;
        }
        if (this.dataSource.length !== undefined) {
            return false;
        }
        if (!areEqual(this.dataSource.item, newDataSource.item)) {
            return true;
        }
        if (this.dataSource.uniqueIdentifier != newDataSource.uniqueIdentifier) {
            return true;
        }
        return false;
    }
    loadPreferences() {
        return this.metaDataListService.getPreferencesHierarchy(this.item, this.getConfigKey(), this.allowConfiguration, this.preferences);
    }
    getPanelWidgetComponent() {
        return DwMetaDataListConfigBasicWidgetComponent;
    }
    getDataSourceItemName(item) {
        if (typeof (item) === 'string') {
            return item;
        }
        if (('ItemDetail' in item)) {
            return item.ItemDetail.ItemName;
        }
        return item.RootTable;
    }
}
DwMetadataListBasicComponent.ɵfac = function DwMetadataListBasicComponent_Factory(t) { return new (t || DwMetadataListBasicComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataListService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken)); };
DwMetadataListBasicComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataListBasicComponent, selectors: [["dw-metadata-list-basic"]], contentQueries: function DwMetadataListBasicComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwCardItemDirective, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwListItemDirective, true, TemplateRef);
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwNoItemsDirective, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cardItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.noItemsTemplate = _t.first);
    } }, viewQuery: function DwMetadataListBasicComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(DwDataListComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwDataList = _t.first);
    } }, inputs: { configKeyPart: "configKeyPart", filters: "filters", dataSource: "dataSource", item: "item" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["container", ""], ["mode", "card", 3, "data", "filters", "config"], ["filter", ""], [3, "configContext", "configKeyPart", "filterConfig", "filters", "filtersChange"], [4, "dwCardItem"], [4, "dwListItem"], [4, "dwNoItems"], [3, "target", "model", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "target", "model"]], template: function DwMetadataListBasicComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataListBasicComponent_div_0_Template, 10, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.configSequenceComplete);
    } }, directives: [ɵngcc4.NgIf, DwActionHostComponent, DwDataListComponent, DwMetadataFiltersComponent, DwCardItemDirective, DwListItemDirective, DwNoItemsDirective, ɵngcc4.NgTemplateOutlet, ɵngcc7.ContextMenu], encapsulation: 2 });
DwMetadataListBasicComponent.ctorParameters = () => [
    { type: DwMetaDataListService },
    { type: DwUiConfigService },
    { type: DwEventService },
    { type: DwMetaDataFilterService },
    { type: DwSecurityUserService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];
DwMetadataListBasicComponent.propDecorators = {
    item: [{ type: Input }],
    filters: [{ type: Input }],
    configKeyPart: [{ type: Input }],
    cardItemTemplate: [{ type: ContentChild, args: [DwCardItemDirective, { static: true, read: TemplateRef },] }],
    listItemTemplate: [{ type: ContentChild, args: [DwListItemDirective, { static: true, read: TemplateRef },] }],
    noItemsTemplate: [{ type: ContentChild, args: [DwNoItemsDirective, { static: true, read: TemplateRef },] }],
    dwDataList: [{ type: ViewChild, args: [DwDataListComponent,] }],
    dataSource: [{ type: Input }]
};

class DwCardConfigComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwContextService, dwUiConfigRegistryService) {
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextService = dwContextService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.preferencesChange = new EventEmitter();
    }
    ngOnInit() {
        var _a, _b;
        this.componentList = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.card, this.configContext.itemName);
        if ((_a = this.preferences) === null || _a === void 0 ? void 0 : _a.cardComponentName) {
            this.changeCardComponent();
        }
        if ((_b = this.preferences) === null || _b === void 0 ? void 0 : _b.listComponentName) {
            this.changeListComponent();
        }
    }
    onChange() {
        this.preferencesChange.emit(this.preferences);
    }
    changeCardComponent() {
        var _a;
        this.cardComponentRef = this.componentList.find(cl => cl.key === this.preferences.cardComponentName);
        this.cardConfigComponent = (_a = this.cardComponentRef) === null || _a === void 0 ? void 0 : _a.configComponent;
        this.onChange();
    }
    changeListComponent() {
        var _a;
        this.listComponentRef = this.componentList.find(cl => cl.key === this.preferences.listComponentName);
        this.listConfigComponent = (_a = this.cardComponentRef) === null || _a === void 0 ? void 0 : _a.configComponent;
        this.onChange();
    }
    setupCardConfigComponent(instance) {
        this.setupConfigComponent(instance, this.cardComponentRef, this.preferences.cardComponentConfig);
        instance.configChange.subscribe(value => {
            this.preferences.cardComponentConfig = value;
        });
    }
    setupListConfigComponent(instance) {
        this.setupConfigComponent(instance, this.listComponentRef, this.preferences.listComponentConfig);
        instance.configChange.subscribe(value => {
            this.preferences.listComponentConfig = value;
        });
    }
    setupConfigComponent(instance, componentRef, config) {
        instance.config = config;
        instance.configContext = Object.assign(Object.assign({}, this.configContext), { cardConfigData: componentRef.configData });
        if (instance.setupComponent) {
            instance.setupComponent();
        }
    }
}
DwCardConfigComponent.ɵfac = function DwCardConfigComponent_Factory(t) { return new (t || DwCardConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwCardConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCardConfigComponent, selectors: [["dw-card-config"]], inputs: { preferences: "preferences", configContext: "configContext" }, outputs: { preferencesChange: "preferencesChange" }, decls: 24, vars: 9, consts: [["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["type", "text", "placeholder", "There are no items found!", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"], ["dwCol", "6", 4, "ngIf"], [3, "component", "configure"]], template: function DwCardConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Card Component");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "select", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwCardConfigComponent_Template_select_ngModelChange_4_listener($event) { return ctx.preferences.cardComponentName = $event; })("ngModelChange", function DwCardConfigComponent_Template_select_ngModelChange_4_listener() { return ctx.changeCardComponent(); });
        ɵngcc0.ɵɵtemplate(5, DwCardConfigComponent_option_5_Template, 2, 2, "option", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "List Component");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "select", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwCardConfigComponent_Template_select_ngModelChange_9_listener($event) { return ctx.preferences.listComponentName = $event; })("ngModelChange", function DwCardConfigComponent_Template_select_ngModelChange_9_listener() { return ctx.changeListComponent(); });
        ɵngcc0.ɵɵtemplate(10, DwCardConfigComponent_option_10_Template, 2, 2, "option", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, DwCardConfigComponent_div_11_Template, 3, 2, "div", 4);
        ɵngcc0.ɵɵelementStart(12, "div", 0);
        ɵngcc0.ɵɵelementStart(13, "div", 5);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "List Component");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "select", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwCardConfigComponent_Template_select_ngModelChange_16_listener($event) { return ctx.preferences.noItemsComponentName = $event; })("ngModelChange", function DwCardConfigComponent_Template_select_ngModelChange_16_listener() { return ctx.changeListComponent(); });
        ɵngcc0.ɵɵtemplate(17, DwCardConfigComponent_option_17_Template, 2, 2, "option", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 0);
        ɵngcc0.ɵɵelementStart(19, "div", 5);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "No Items Message");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwCardConfigComponent_Template_input_ngModelChange_22_listener($event) { return ctx.preferences.noItemsMessage = $event; })("ngModelChange", function DwCardConfigComponent_Template_input_ngModelChange_22_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(23, DwCardConfigComponent_div_23_Template, 6, 2, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.cardComponentName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.componentList);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.listComponentName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.componentList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.cardConfigComponent);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.noItemsComponentName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.componentList);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.noItemsMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwDynamicLoaderComponent], styles: [""] });
DwCardConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService },
    { type: DwUiConfigRegistryService }
];
DwCardConfigComponent.propDecorators = {
    preferences: [{ type: Input }],
    preferencesChange: [{ type: Output }],
    configContext: [{ type: Input }]
};

class DwMetaDataCardContentService {
    constructor(dwConfigService, dwTemplateUtil) {
        this.dwConfigService = dwConfigService;
        this.dwTemplateUtil = dwTemplateUtil;
    }
    getCardContentItemResult(contentItemKey, cardContentConfig, data, resolvedContext) {
        return this.getCardContent(cardContentConfig, data, resolvedContext)
            .pipe(map(results => {
            const result = results.find(r => r.contentItemKey == contentItemKey);
            return result === null || result === void 0 ? void 0 : result.result;
        }));
    }
    getCardContent(cardContentConfig, data, resolvedContext) {
        const results = [];
        const globals = this.dwConfigService.coreConfig.globals;
        const missingFieldText = 'Missing';
        for (const contentItem of (cardContentConfig === null || cardContentConfig === void 0 ? void 0 : cardContentConfig.contentItems) || []) {
            let template = contentItem.useTemplate ? contentItem.template : `[${contentItem.attributeName}]`;
            if (!contentItem.useTemplate && !contentItem.attributeName) {
                template = 'Card Requires Configuration';
            }
            const options = { blankReplacementValue: missingFieldText };
            const result = this.dwTemplateUtil.processTemplate(template, data, resolvedContext, globals, options);
            results.push({
                contentItemKey: contentItem.contentItemKey,
                result: result
            });
        }
        return of(results);
    }
}
DwMetaDataCardContentService.ɵfac = function DwMetaDataCardContentService_Factory(t) { return new (t || DwMetaDataCardContentService)(ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwTemplateUtilService)); };
DwMetaDataCardContentService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataCardContentService_Factory() { return new DwMetaDataCardContentService(ɵɵinject(DwConfigServiceToken), ɵɵinject(DwTemplateUtilService)); }, token: DwMetaDataCardContentService, providedIn: "root" });
DwMetaDataCardContentService.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwTemplateUtilService }
];

class DwCardDefaultConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwMetaDataService, dwContextService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextService = dwContextService;
    }
    getDefaultConfig() {
        const config = this.config || {};
        config.contentItems = [];
        // config.contentItems[0].contentItemKey
        // this.configContext.cardConfigData.contentItemDefinitions[0].display
        return config;
    }
    ngOnInit() {
    }
    setupComponent() {
        var _a;
        super.setupComponent();
        let index = 0;
        this.contentItemDefs = ((_a = this.configContext.cardConfigData) === null || _a === void 0 ? void 0 : _a.contentItemDefinitions) || [];
        this.config.contentItems = this.config.contentItems || [];
        for (const contentItemDef of this.contentItemDefs) {
            let contentItem = this.config.contentItems[index];
            if (!contentItem) {
                contentItem = { useTemplate: true, contentItemKey: contentItemDef.contentItemKey, attributeName: null };
                this.config.contentItems[index] = contentItem;
            }
            index++;
        }
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.allAttributes = queryMetaData.Attributes;
        });
    }
    // Keeping for future use with templates
    setupFieldSources() {
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.allAttributes = queryMetaData.Attributes;
            this.fieldSources = [
                { display: 'Main Item', rootTable: true, attributes: queryMetaData.Attributes }
            ];
            this.dwContextService.getContextMetaDataList(this.configContext.contextNames)
                .subscribe(contextMdList => {
                for (const contextName of this.configContext.contextNames) {
                    const contextDef = this.dwContextService.getContextDef(contextName);
                    if (contextDef) {
                        const contextDefMetaData = contextMdList[contextName];
                        let attributes = contextDefMetaData.attributes;
                        if (contextDefMetaData) {
                            attributes = contextDefMetaData.attributes;
                        }
                        this.fieldSources.push({
                            display: contextDef.contextDisplay,
                            rootTable: false,
                            contextDefinition: contextDef,
                            attributes: attributes
                        });
                    }
                }
            });
            this.setFieldSource(this.fieldSources[0]);
        });
    }
    setFieldSource(fieldSource) {
        this.selectedFieldSource = fieldSource;
        this.buildAvailableAttrs();
    }
    buildAvailableAttrs() {
        const attrs = [];
        this.availableAttributes = this.selectedFieldSource.attributes;
    }
}
DwCardDefaultConfigComponent.ɵfac = function DwCardDefaultConfigComponent_Factory(t) { return new (t || DwCardDefaultConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwCardDefaultConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCardDefaultConfigComponent, selectors: [["dw-card-default-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelChange"], ["dwCol", "12", 4, "ngIf"], ["dwCol", "12"], ["optionLabel", "AttributeDisplay", "display", "chip", "optionValue", "DisplayAttributeName", "filter", "true", "appendTo", "body", 3, "options", "ngModel", "showClear", "ngModelChange"]], template: function DwCardDefaultConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwCardDefaultConfigComponent_ng_container_0_Template, 11, 4, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.contentItemDefs);
    } }, directives: [ɵngcc4.NgForOf, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc22.Dropdown, DwHtmlEditComponent], styles: [""] });
DwCardDefaultConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];

var __decorate$1L = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1l = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwCardDefaultComponent = class DwCardDefaultComponent {
    constructor(dwMetaDataCardContentService) {
        this.dwMetaDataCardContentService = dwMetaDataCardContentService;
        this.cardClick = new EventEmitter();
    }
    setupCard() {
        this.dwMetaDataCardContentService.getCardContentItemResult('main', this.cardConfig, this.data, this.resolvedContent)
            .subscribe(htmlContent => {
            this.htmlContent = htmlContent || 'Card Requires Configuration';
        });
    }
    onCardClick() {
        this.cardClick.emit(this.data);
    }
    ngOnInit() {
    }
};
DwCardDefaultComponent.ɵfac = function DwCardDefaultComponent_Factory(t) { return new (t || DwCardDefaultComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataCardContentService)); };
DwCardDefaultComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCardDefaultComponent, selectors: [["dw-card-default"]], decls: 3, vars: 1, consts: [[1, "card", "card-container", 3, "click"], [1, "card-body"], [3, "ngModel"]], template: function DwCardDefaultComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwCardDefaultComponent_Template_div_click_0_listener() { return ctx.onCardClick(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "dw-html-view", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngModel", ctx.htmlContent);
    } }, directives: [DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [".card-container[_ngcontent-%COMP%] {\n        width:100%;\n        height: 100px;\n        margin-right:10px;\n        float:left;\n      }\n\n      .card-container[_ngcontent-%COMP%]:hover {\n        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\n      }"] });
DwCardDefaultComponent.ctorParameters = () => [
    { type: DwMetaDataCardContentService }
];
DwCardDefaultComponent = __decorate$1L([
    DwComponent({
        name: 'DevwareCard Default',
        key: 'dwCardDefault',
        componentType: DwComponentType.card,
        configComponent: DwCardDefaultConfigComponent,
        isGlobal: true,
        configData: {
            contentItemDefinitions: [{
                    display: 'Main',
                    contentItemKey: 'main'
                }]
        }
    }),
    __metadata$1l("design:paramtypes", [DwMetaDataCardContentService])
], DwCardDefaultComponent);

class DwMetadataListActionsConfigComponent {
    constructor() {
        this.actionPreferenceByModeChange = new EventEmitter();
    }
    ngOnInit() {
        this.actionModes = getListActionModes();
    }
    onChange() {
        this.actionPreferenceByModeChange.emit(this.actionPreferencesByMode);
    }
}
DwMetadataListActionsConfigComponent.ɵfac = function DwMetadataListActionsConfigComponent_Factory(t) { return new (t || DwMetadataListActionsConfigComponent)(); };
DwMetadataListActionsConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataListActionsConfigComponent, selectors: [["dw-metadata-list-actions-config"]], inputs: { configContext: "configContext", actionPreferencesByMode: "actionPreferencesByMode" }, outputs: { actionPreferenceByModeChange: "actionPreferenceByModeChange" }, decls: 1, vars: 3, consts: [[3, "configContext", "actionModes", "actionPreferencesByMode", "actionPreferencesByModeChange", "actionPreferenceByModeChange"]], template: function DwMetadataListActionsConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-action-group-modes-config", 0);
        ɵngcc0.ɵɵlistener("actionPreferencesByModeChange", function DwMetadataListActionsConfigComponent_Template_dw_action_group_modes_config_actionPreferencesByModeChange_0_listener($event) { return ctx.actionPreferencesByMode = $event; })("actionPreferenceByModeChange", function DwMetadataListActionsConfigComponent_Template_dw_action_group_modes_config_actionPreferenceByModeChange_0_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("configContext", ctx.configContext)("actionModes", ctx.actionModes)("actionPreferencesByMode", ctx.actionPreferencesByMode);
    } }, directives: [DwActionGroupModesConfigComponent], encapsulation: 2 });
DwMetadataListActionsConfigComponent.propDecorators = {
    configContext: [{ type: Input }],
    actionPreferencesByMode: [{ type: Input }],
    actionPreferenceByModeChange: [{ type: Output }]
};

class DwMetaDataRoutingNavigationService {
    constructor(metaDataRoutingService, route, dwOrmDataService, dwModalService, dwMessageService) {
        this.metaDataRoutingService = metaDataRoutingService;
        this.route = route;
        this.dwOrmDataService = dwOrmDataService;
        this.dwModalService = dwModalService;
        this.dwMessageService = dwMessageService;
    }
    openAddEditView(data, actionType, navigationInfo) {
        if (navigationInfo.useModal) {
            return this.openAddEditViewModal(data, actionType, navigationInfo);
        }
        else {
            this.openAddEditViewPage(data, actionType, navigationInfo);
            return of(null);
        }
    }
    openAddEditViewPage(data, actionType, navigationInfo) {
        switch (actionType) {
            case DwMenuActionType.add:
                this.metaDataRoutingService.routeToAdd(this.route, navigationInfo.item);
                break;
            case DwMenuActionType.edit:
            case DwMenuActionType.view:
            case DwMenuActionType.print:
                this.metaDataRoutingService.routeToEditView(this.route, navigationInfo.item, data, actionType);
                break;
        }
    }
    openAddEditViewModal(data, actionType, navigationInfo) {
        const keyValue = this.dwOrmDataService.getKeyValue(data);
        const dataSource = navigationInfo.passCurrentDataSource ? navigationInfo.data : null;
        return this.metaDataRoutingService.openAddEditViewModal(actionType, navigationInfo.item, keyValue, navigationInfo.addContext, dataSource);
    }
    /**
     * Handles deleting one or more items from the grid
     */
    delete(data, navigationInfo, showDialog = true) {
        let confirmOb = of(true);
        if (showDialog) {
            confirmOb = this.dwModalService.showDialog(navigationInfo.deleteConfirmTitle, navigationInfo.deleteConfirmMessage)
                .pipe(map(result => {
                return result.buttonCommand == DwButtonCommand.yes;
            }));
        }
        return confirmOb.pipe(mergeMap(confirmed => {
            const actionResult = {
                success: true
            };
            if (!confirmed || !navigationInfo.data || !navigationInfo.data.deleteItem) {
                actionResult.cancelled = true;
                return of(actionResult);
            }
            const dataSource = navigationInfo.data;
            let ob;
            if (Array.isArray(data)) {
                ob = dataSource.deleteItems(data, null, false);
            }
            else {
                ob = dataSource.deleteItem(data, null, false);
            }
            return ob
                .pipe(map(dataResult => {
                if (dataResult && dataSource.updateCachedItem) {
                    dataSource.updateCachedItem(dataResult.data);
                }
                let keyName;
                let keys;
                if (Array.isArray(data)) {
                    keyName = data[0]._keyName;
                    keys = data.map(item => item[keyName]);
                }
                else {
                    keyName = data._keyName;
                    keys = [data[keyName]];
                }
                actionResult.dataActionResult = {
                    itemName: navigationInfo.item,
                    keyName: keyName,
                    actionType: DwMdDataActionType.delete,
                    keysEffected: keys,
                };
                actionResult.refreshData = true;
                return actionResult;
            }, catchError((error, caught) => {
                actionResult.success = false;
                actionResult.message = {
                    severity: DwMessageSeverity.error,
                    messageBody: 'Could not delete the item, please ensure that it is not referenced by other items',
                    timeToShow: 10
                };
                // Hide this once we're showing the action result message
                this.dwMessageService.showMessage({
                    messageHeading: 'Error deleting item!',
                    messageBody: 'Could not delete the item, please ensure that it is not referenced by other items',
                    allowClose: true,
                    severity: DwMessageSeverity.error,
                });
                return of(actionResult);
            })));
        }));
    }
}
DwMetaDataRoutingNavigationService.ɵfac = function DwMetaDataRoutingNavigationService_Factory(t) { return new (t || DwMetaDataRoutingNavigationService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingService), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwMessagingService)); };
DwMetaDataRoutingNavigationService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataRoutingNavigationService_Factory() { return new DwMetaDataRoutingNavigationService(ɵɵinject(DwMetaDataRoutingService), ɵɵinject(ActivatedRoute), ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwModalService), ɵɵinject(DwMessagingService)); }, token: DwMetaDataRoutingNavigationService, providedIn: "root" });
DwMetaDataRoutingNavigationService.ctorParameters = () => [
    { type: DwMetaDataRoutingService },
    { type: ActivatedRoute },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwModalService },
    { type: DwMessagingService }
];

var __decorate$1M = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1m = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwListAddActionService = class DwListAddActionService {
    constructor(metaDataRoutingNavigationService) {
        this.metaDataRoutingNavigationService = metaDataRoutingNavigationService;
    }
    handleAction(actionState) {
        const navigationConfig = {
            item: actionState.item,
            addContext: actionState.metaDataListApi.cardContext,
            passCurrentDataSource: false,
            useModal: false,
            data: actionState.data,
            itemDisplayName: actionState.listConfig.itemDisplayName,
        };
        return this.metaDataRoutingNavigationService.openAddEditView(null, DwMenuActionType.add, navigationConfig)
            .pipe(map(result => {
            const actionResult = {
                success: true
            };
            if (result && result.cancelled) {
                actionResult.cancelled = true;
            }
            return actionResult;
        }));
    }
};
DwListAddActionService.ɵfac = function DwListAddActionService_Factory(t) { return new (t || DwListAddActionService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingNavigationService)); };
DwListAddActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwListAddActionService, factory: function (t) { return DwListAddActionService.ɵfac(t); } });
DwListAddActionService.ctorParameters = () => [
    { type: DwMetaDataRoutingNavigationService }
];
DwListAddActionService = __decorate$1M([
    DwAction({
        keyName: DwListActionKeys.listAdd,
        display: 'Add',
        actionType: DwActionType.listAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: true,
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-add',
            buttonType: DwButtonType.standard,
        },
        defaultMenuConfig: {
            useMenuDefaults: true,
            useParentDisplay: true,
        },
        defaultSecurityConfig: {
            requireCanCreate: true,
        }
    }),
    __metadata$1m("design:paramtypes", [DwMetaDataRoutingNavigationService])
], DwListAddActionService);

var __decorate$1N = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1n = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwListFilterToggleActionService = class DwListFilterToggleActionService {
    constructor() { }
    handleAction(actionState) {
        actionState.metaDataListApi.toggleFilter();
        return of({
            success: true,
        });
    }
};
DwListFilterToggleActionService.ɵfac = function DwListFilterToggleActionService_Factory(t) { return new (t || DwListFilterToggleActionService)(); };
DwListFilterToggleActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwListFilterToggleActionService, factory: function (t) { return DwListFilterToggleActionService.ɵfac(t); } });
DwListFilterToggleActionService.ctorParameters = () => [];
DwListFilterToggleActionService = __decorate$1N([
    DwAction({
        keyName: DwListActionKeys.listFilterToggle,
        display: 'Filter Toggle',
        actionType: DwActionType.listAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonText: '',
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-filter',
            command: 'filter',
            buttonType: DwButtonType.standard,
            buttonTitle: 'Toggle Filters',
        },
    }),
    __metadata$1n("design:paramtypes", [])
], DwListFilterToggleActionService);

var __decorate$1O = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1o = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwListRefreshActionService = class DwListRefreshActionService {
    constructor() { }
    handleAction(actionState) {
        actionState.metaDataListApi.refreshData();
        return of({
            success: true,
        });
    }
};
DwListRefreshActionService.ɵfac = function DwListRefreshActionService_Factory(t) { return new (t || DwListRefreshActionService)(); };
DwListRefreshActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwListRefreshActionService, factory: function (t) { return DwListRefreshActionService.ɵfac(t); } });
DwListRefreshActionService.ctorParameters = () => [];
DwListRefreshActionService = __decorate$1O([
    DwAction({
        keyName: DwListActionKeys.listRefresh,
        display: 'Refresh',
        actionType: DwActionType.listAction,
        isGlobal: true,
        allowOnce: true,
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonText: '',
            buttonClass: 'btn btn-success',
            iconClass: 'dw-icon-refresh',
            command: 'refresh',
            buttonType: DwButtonType.standard,
            buttonTitle: 'Refresh',
        },
    }),
    __metadata$1o("design:paramtypes", [])
], DwListRefreshActionService);

class DwListEditActionService {
    constructor(metaDataRoutingNavigationService) {
        this.metaDataRoutingNavigationService = metaDataRoutingNavigationService;
    }
    handleAction(actionState) {
        const navigationConfig = {
            item: actionState.item,
            addContext: actionState.metaDataListApi.cardContext,
            passCurrentDataSource: false,
            useModal: false,
            data: actionState.data,
            itemDisplayName: actionState.listConfig.itemDisplayName,
        };
        return this.metaDataRoutingNavigationService.openAddEditView(actionState.data, DwMenuActionType.edit, navigationConfig)
            .pipe(map(result => {
            const actionResult = {
                success: true
            };
            if (result && result.cancelled) {
                actionResult.cancelled = true;
            }
            return actionResult;
        }));
    }
}
DwListEditActionService.ɵfac = function DwListEditActionService_Factory(t) { return new (t || DwListEditActionService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingNavigationService)); };
DwListEditActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwListEditActionService, factory: DwListEditActionService.ɵfac });
DwListEditActionService.ctorParameters = () => [
    { type: DwMetaDataRoutingNavigationService }
];
DwActionFunc({
    keyName: DwListActionKeys.listEdit,
    display: 'Edit (List)',
    actionType: DwActionType.listItemAction,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'dw-icon-edit-grid',
        buttonTitle: 'Edit',
        buttonType: DwButtonType.iconOnlyNoText,
    },
    defaultMenuConfig: {
        useParentDisplay: true,
        menuIconClass: 'dw-icon-edit-grid',
        itemRequirement: DwActionItemRequirement.single
    },
    defaultSecurityConfig: {
        requireCanUpdate: true
    }
}, DwListEditActionService);

var __decorate$1P = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwListToggleViewActionComponent = class DwListToggleViewActionComponent {
    constructor() {
        this.mode = DwListViewMode.card;
    }
    setCardMode() {
        this.setMode(DwListViewMode.card);
    }
    setListMode() {
        this.setMode(DwListViewMode.list);
    }
    setMode(mode) {
        var _a, _b;
        this.mode = mode;
        (_b = (_a = this.actionContext) === null || _a === void 0 ? void 0 : _a.metaDataListApi) === null || _b === void 0 ? void 0 : _b.setMode(mode);
    }
    setupComponent() {
        var _a, _b;
        this.mode = ((_b = (_a = this.actionContext) === null || _a === void 0 ? void 0 : _a.metaDataListApi) === null || _b === void 0 ? void 0 : _b.getMode()) || DwListViewMode.card;
    }
};
DwListToggleViewActionComponent.ɵfac = function DwListToggleViewActionComponent_Factory(t) { return new (t || DwListToggleViewActionComponent)(); };
DwListToggleViewActionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwListToggleViewActionComponent, selectors: [["dw-list-toggle-view"]], decls: 5, vars: 6, consts: [[1, "btn-group", "dw-button-right"], [1, "btn", "btn-success", 3, "ngClass", "click"], ["title", "Card View", 1, "fa", "fa-th"], ["title", "List View", 1, "fa", "fa-bars"]], template: function DwListToggleViewActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "label", 1);
        ɵngcc0.ɵɵlistener("click", function DwListToggleViewActionComponent_Template_label_click_1_listener() { return ctx.setCardMode(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "label", 1);
        ɵngcc0.ɵɵlistener("click", function DwListToggleViewActionComponent_Template_label_click_3_listener() { return ctx.setListMode(); });
        ɵngcc0.ɵɵelement(4, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c82, ctx.mode == "card"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c82, ctx.mode == "list"));
    } }, directives: [ɵngcc4.NgClass], encapsulation: 2 });
DwListToggleViewActionComponent = __decorate$1P([
    DwAction({
        keyName: DwListActionKeys.listToggleView,
        display: 'View Toggle',
        actionType: DwActionType.listAction,
        decoratorType: DwDecoratorType.component,
        isGlobal: true,
        allowOnce: true,
        isButtonComponent: true,
    })
], DwListToggleViewActionComponent);

class DwRouteChildMenuConfigComponent {
    constructor(dwUiConfigRegistryService, dwMetaDataService, cdr) {
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwMetaDataService = dwMetaDataService;
        this.cdr = cdr;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.setupForm();
        // Called from instance configuration
        // this.setupForm();
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setupForm() {
        this.childListMenuOptionsFG = this.routeConfigFG.get('childListMenuOptions');
        if (!this.childListMenuOptionsFG) {
            this.childListMenuOptionsFG = new FormGroup({});
            this.routeConfigFG.addControl('childListMenuOptions', this.childListMenuOptionsFG);
        }
        this.addChildControl('isChildListMenu');
        this.addChildControl('showOnParent', null, false);
        this.addChildControl('showOnEditChild', null, true);
        this.addChildControl('showOnViewChild', null, true);
        this.addChildControl('showOnPrintChild', null, true);
    }
    addChildControl(controlName, validatorVn = null, defaultValue) {
        let control = this.childListMenuOptionsFG.get(controlName);
        if (!control) {
            control = new FormControl();
            this.childListMenuOptionsFG.addControl(controlName, control);
            if (!control.value && control.value !== false && defaultValue) {
                control.setValue(defaultValue);
            }
        }
        control.validator = validatorVn;
        control.enable();
        return control;
    }
}
DwRouteChildMenuConfigComponent.ɵfac = function DwRouteChildMenuConfigComponent_Factory(t) { return new (t || DwRouteChildMenuConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwRouteChildMenuConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteChildMenuConfigComponent, selectors: [["dw-route-child-menu-config"]], inputs: { routeConfigFG: ["routeConfigFormGroup", "routeConfigFG"], route: "route", routeTypeProcessorRegistration: "routeTypeProcessorRegistration" }, decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "9"], ["title", "Show this menu under Edit, View or Print child menus", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "isChildListMenu"], [4, "ngIf"], ["title", "Indicates if menu should also show on the parent", 1, "fa", "fa-info-circle"], ["formControlName", "showOnParent"], ["dwCol", "12"], ["title", "Determines which children menu should be displayed on.  Add is not shown since you can't have a child of a new record", 1, "fas", "fa-info-circle"], [1, "form-control", 2, "overflow", "auto", "min-height", "20px"], ["type", "checkbox", "formControlName", "showOnEditChild", 3, "ngModelChange"], ["type", "checkbox", "formControlName", "showOnViewChild", 3, "ngModelChange"], ["type", "checkbox", "formControlName", "showOnPrintChild", 3, "ngModelChange"]], template: function DwRouteChildMenuConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteChildMenuConfigComponent_div_0_Template, 9, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.childListMenuOptionsFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.CheckboxControlValueAccessor], styles: ["input[_ngcontent-%COMP%]{margin-left:10px}"] });
DwRouteChildMenuConfigComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: ChangeDetectorRef }
];
DwRouteChildMenuConfigComponent.propDecorators = {
    routeConfigFG: [{ type: Input, args: ['routeConfigFormGroup',] }],
    route: [{ type: Input }],
    routeTypeProcessorRegistration: [{ type: Input }]
};

class DwParentFilterConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwMetaDataService, dwMenuService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.dwMenuService = dwMenuService;
        this.paramNames = [];
    }
    setupComponent() {
        super.setupComponent();
        this.paramNames = this.dwMenuService.menuState.currentParams.keys;
        this.subscriptions.push(this.dwMetaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
            this.attributeList = this.itemMetaData.Attributes;
            this.setupRelation();
            this.loadChildMetaData();
        }));
    }
    setupRelation() {
        var _a;
        if (!(((_a = this.paramNames) === null || _a === void 0 ? void 0 : _a.length) > 0)) {
            return;
        }
        const paramItemName = this.dwMenuService.menuState.currentParams.getAllMenuData()[0].itemName;
        if (!paramItemName) {
            return;
        }
        const relation = this.itemMetaData.Relations.find(r => r.PkUniqueItemName.toUpperCase() == paramItemName.toUpperCase() || r.FkUniqueItemName.toUpperCase() == paramItemName.toUpperCase());
        if (!relation) {
            return;
        }
        if (relation.PkUniqueItemName == this.itemMetaData.UniqueItemName) {
            this.config.relationAttributeName = relation.FkAttributeName;
        }
        else {
            this.config.relationAttributeName = relation.PkAttributeName;
        }
        if (!this.config.relationParamName) {
            this.config.relationParamName = this.paramNames[0];
        }
        this.configChange.emit(this.config);
    }
    loadChildMetaData() {
        var _a, _b, _c, _d;
        if (!((_b = (_a = this.config) === null || _a === void 0 ? void 0 : _a.relationshipInfo) === null || _b === void 0 ? void 0 : _b.childItem)) {
            this.childItemMetaData = null;
            this.attributeList = this.itemMetaData.Attributes;
            return;
        }
        this.subscriptions.push(this.dwMetaDataService.getMetaData((_d = (_c = this.config) === null || _c === void 0 ? void 0 : _c.relationshipInfo) === null || _d === void 0 ? void 0 : _d.childItem)
            .subscribe(itemMetaData => {
            this.childItemMetaData = itemMetaData;
            this.attributeList = this.childItemMetaData.Attributes;
        }));
    }
    onRelationshipChange(relationshipName) {
        if (!relationshipName) {
            this.config.relationshipInfo = null;
            this.attributeList = this.itemMetaData.Attributes;
            return;
        }
        this.config.relationshipInfo = this.getRelationshipInfo(relationshipName, this.configContext.itemName);
        this.loadChildMetaData();
    }
    onChildRelationshipChange(relationshipName) {
        this.config.childRelationshipInfo = this.getRelationshipInfo(relationshipName, this.config.relationshipInfo.childItem, this.childItemMetaData);
    }
    getRelationshipInfo(relationshipName, parentItem, itemMetaData) {
        const relationshipInfo = {};
        if (!itemMetaData) {
            itemMetaData = this.itemMetaData;
        }
        const relationship = itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        if (relationship) {
            relationshipInfo.relationshipName = relationshipName;
            relationshipInfo.propertyName = relationship.NamingInfo.RelationshipPropertyName;
            if (relationship) {
                if (relationship.PkUniqueItemName == parentItem) {
                    relationshipInfo.parentItem = relationship.PkUniqueItemName;
                    relationshipInfo.childItem = relationship.FkUniqueItemName;
                }
                else {
                    relationshipInfo.parentItem = relationship.FkUniqueItemName;
                    relationshipInfo.childItem = relationship.PkUniqueItemName;
                }
            }
        }
        return relationshipInfo;
    }
    getDefaultConfig() {
        return {};
    }
}
DwParentFilterConfigComponent.ɵfac = function DwParentFilterConfigComponent_Factory(t) { return new (t || DwParentFilterConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMenuService)); };
DwParentFilterConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwParentFilterConfigComponent, selectors: [["dw-dw-parent-filter-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 4, consts: [["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"]], template: function DwParentFilterConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Use Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "p-inputSwitch", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwParentFilterConfigComponent_Template_p_inputSwitch_ngModelChange_5_listener($event) { return ctx.config.useRelationship = $event; })("ngModelChange", function DwParentFilterConfigComponent_Template_p_inputSwitch_ngModelChange_5_listener() { return ctx.onRelationshipChange(null); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwParentFilterConfigComponent_div_6_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(7, DwParentFilterConfigComponent_div_7_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(8, DwParentFilterConfigComponent_div_8_Template, 6, 2, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.useRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.useRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
DwParentFilterConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMenuService }
];

class DwParentFilterService {
    constructor(dwMenuService) {
        this.dwMenuService = dwMenuService;
    }
    getParameterValue(filterConfig) {
        var _a, _b;
        if (!((_a = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.additionalConfig) === null || _a === void 0 ? void 0 : _a.relationParamName)) {
            return null;
        }
        const currentParams = this.dwMenuService.menuState.currentParams;
        if (!currentParams) {
            return null;
        }
        return currentParams.get((_b = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.additionalConfig) === null || _b === void 0 ? void 0 : _b.relationParamName);
    }
    getItemName(filterConfig, item) {
        var _a, _b;
        return ((_b = (_a = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.additionalConfig) === null || _a === void 0 ? void 0 : _a.childRelationshipInfo) === null || _b === void 0 ? void 0 : _b.childItem) || item;
    }
    buildFilter(filterConfig, item, paramValue) {
        var _a, _b;
        if (!item || !paramValue || !((_a = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.additionalConfig) === null || _a === void 0 ? void 0 : _a.relationAttributeName)) {
            return null;
        }
        const filterGroup = new DwQueryFilterGroup();
        const qh = new DwQueryHelper();
        filterGroup.AddFilterAnd(qh.filters.Equal(`${item}.${(_b = filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.additionalConfig) === null || _b === void 0 ? void 0 : _b.relationAttributeName}`, paramValue));
        return filterGroup;
    }
    buildInitialFilter(filterConfig, item, existingFilter, resolvedContext) {
        const filterGroup = new DwQueryFilterGroup();
        const qh = new DwQueryHelper();
        const paramValue = this.getParameterValue(filterConfig);
        const finalItem = this.getItemName(filterConfig, item);
        return this.buildFilter(filterConfig, finalItem, paramValue);
    }
}
DwParentFilterService.ɵfac = function DwParentFilterService_Factory(t) { return new (t || DwParentFilterService)(ɵngcc0.ɵɵinject(DwMenuService)); };
DwParentFilterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwParentFilterService, factory: DwParentFilterService.ɵfac });
DwParentFilterService.ctorParameters = () => [
    { type: DwMenuService }
];

var __decorate$1Q = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1p = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwParentFilterComponent = class DwParentFilterComponent extends DwFilterItemBase {
    constructor(dwParentFilterService) {
        super();
        this.dwParentFilterService = dwParentFilterService;
    }
    ngOnInit() {
        this.setupFilter();
    }
    setupFilter() {
        this.item = this.dwParentFilterService.getItemName(this.filterConfig, this.item);
        this.paramValue = this.dwParentFilterService.getParameterValue(this.filterConfig);
        this.filter = this.dwParentFilterService.buildFilter(this.filterConfig, this.item, this.paramValue);
    }
};
DwParentFilterComponent.ɵfac = function DwParentFilterComponent_Factory(t) { return new (t || DwParentFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwParentFilterService)); };
DwParentFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwParentFilterComponent, selectors: [["dw-parent-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 3, template: function DwParentFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, "Parent Filter");
        ɵngcc0.ɵɵelement(1, "br");
        ɵngcc0.ɵɵtext(2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate3(" ", ctx.item, ".", ctx.filterConfig == null ? null : ctx.filterConfig.additionalConfig == null ? null : ctx.filterConfig.additionalConfig.relationAttributeName, " == ", ctx.paramValue, "");
    } }, encapsulation: 2 });
DwParentFilterComponent.ctorParameters = () => [
    { type: DwParentFilterService }
];
DwParentFilterComponent = __decorate$1Q([
    DwComponent({
        name: 'Parent Route Filter',
        key: 'dwParentRouteFilter',
        componentType: DwComponentType.filterItem,
        configComponent: DwParentFilterConfigComponent,
        isGlobal: true,
        configData: {
            hasUserInterface: false,
            showCaption: false,
            showCompareType: false,
            showControlOptions: false,
            requireAttr: false,
            showPlaceholderText: false,
            showDefaultValue: false,
            allowAttr: false,
            initialFilterService: DwParentFilterService
        },
    }),
    __metadata$1p("design:paramtypes", [DwParentFilterService])
], DwParentFilterComponent);

class DwGridColumnTemplateConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwMetaDataService, cdr) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.cdr = cdr;
    }
    getDefaultConfig() {
        return { htmlContent: '', };
    }
    setupComponent() {
        super.setupComponent();
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
            this.queryMetaData.Attributes[0].AttributeDisplay;
        });
        this.cdr.markForCheck();
    }
    addField() {
        if (!this.selectedField) {
            return;
        }
        const fullFieldName = `[data.${this.selectedField}]`;
        this.config.htmlContent = this.config.htmlContent || '';
        this.config.htmlContent += fullFieldName;
        this.onChange();
        this.cdr.markForCheck();
    }
}
DwGridColumnTemplateConfigComponent.ɵfac = function DwGridColumnTemplateConfigComponent_Factory(t) { return new (t || DwGridColumnTemplateConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwGridColumnTemplateConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridColumnTemplateConfigComponent, selectors: [["dw-grid-column-template-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 19, vars: 4, consts: [["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add Field", 1, "fa", "fa-plus-circle", "hand"], [3, "ngValue"]], template: function DwGridColumnTemplateConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "textarea", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnTemplateConfigComponent_Template_textarea_ngModelChange_4_listener($event) { return ctx.config.htmlContent = $event; })("ngModelChange", function DwGridColumnTemplateConfigComponent_Template_textarea_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Add Fields to Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnTemplateConfigComponent_Template_select_ngModelChange_9_listener($event) { return ctx.selectedField = $event; });
        ɵngcc0.ɵɵtemplate(10, DwGridColumnTemplateConfigComponent_option_10_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "button", 5);
        ɵngcc0.ɵɵlistener("click", function DwGridColumnTemplateConfigComponent_Template_button_click_11_listener() { return ctx.addField(); });
        ɵngcc0.ɵɵelement(12, "i", 6);
        ɵngcc0.ɵɵtext(13, " Add Template Field ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 0);
        ɵngcc0.ɵɵelementStart(15, "div", 1);
        ɵngcc0.ɵɵelementStart(16, "label");
        ɵngcc0.ɵɵtext(17, "Blank Replacement Value");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "textarea", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnTemplateConfigComponent_Template_textarea_ngModelChange_18_listener($event) { return ctx.config.blankReplacementValue = $event; })("ngModelChange", function DwGridColumnTemplateConfigComponent_Template_textarea_ngModelChange_18_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.htmlContent);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.selectedField);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.queryMetaData.Attributes);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.blankReplacementValue);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwGridColumnTemplateConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: ChangeDetectorRef }
];

var __decorate$1R = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1q = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridColumnTemplateComponent = class DwGridColumnTemplateComponent extends DwGridColumnBaseComponent {
    constructor(dwConfigService, dwTemplateUtil) {
        super();
        this.dwConfigService = dwConfigService;
        this.dwTemplateUtil = dwTemplateUtil;
        this.missingFieldText = "";
    }
    setupColumn() {
        var _a;
        const rowData = this.params.data;
        const globals = this.dwConfigService.coreConfig.globals;
        if (!rowData) {
            return;
        }
        const options = {
            blankReplacementValue: this.gridColumnConfig.blankReplacementValue || this.missingFieldText
        };
        // Map query meta data to options
        const gridConfig = this.params.gridConfig;
        options.queryMetaData = gridConfig.queryMetaData;
        this.finalHtmlContent = this.dwTemplateUtil.processTemplate((_a = this.gridColumnConfig) === null || _a === void 0 ? void 0 : _a.htmlContent, rowData, this.params.resolvedContext, globals, options);
    }
    isMissingField(url) {
        return url.indexOf(this.missingFieldText) >= 0;
    }
};
DwGridColumnTemplateComponent.ɵfac = function DwGridColumnTemplateComponent_Factory(t) { return new (t || DwGridColumnTemplateComponent)(ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwTemplateUtilService)); };
DwGridColumnTemplateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridColumnTemplateComponent, selectors: [["dw-grid-column-template"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "ngModel", "ngModelChange"]], template: function DwGridColumnTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-html-view", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridColumnTemplateComponent_Template_dw_html_view_ngModelChange_0_listener($event) { return ctx.finalHtmlContent = $event; });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.finalHtmlContent);
    } }, directives: [DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwGridColumnTemplateComponent.ctorParameters = () => [
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwTemplateUtilService }
];
DwGridColumnTemplateComponent = __decorate$1R([
    DwGridColumn({
        keyName: 'dw-grid-column-template',
        display: 'Template Column',
        decoratorType: DwDecoratorType.component,
        configComponent: DwGridColumnTemplateConfigComponent,
        isGlobal: true,
        allowAction: true,
        showActionButtonConfig: false,
        requireAction: false,
        useAutoRowHeight: false,
        allowAttr: false,
        requireAttr: false
    }),
    __metadata$1q("design:paramtypes", [DwConfigService,
        DwTemplateUtilService])
], DwGridColumnTemplateComponent);

var __decorate$1S = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1r = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const DwAdvancedFilter = 'dwAdvancedFilter';
let DwAdvancedFilterComponent = class DwAdvancedFilterComponent extends DwFilterItemBase {
    constructor(dwQueryFilterConverterService) {
        super();
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
    }
    updateExpression() {
        this.filter = this.dwQueryFilterConverterService.convertExpressionToFilter(this.filterExpression, {});
    }
};
DwAdvancedFilterComponent.ɵfac = function DwAdvancedFilterComponent_Factory(t) { return new (t || DwAdvancedFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwQueryFilterConverterService)); };
DwAdvancedFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAdvancedFilterComponent, selectors: [["dw-advanced-filter"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 4, consts: [[1, "label"], ["addButtonText", "Create Filter", "editButtonText", "Edit Filter", 3, "ngModel", "item", "queryMeaning", "ngModelChange"]], template: function DwAdvancedFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "dw-expression-picker-control", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAdvancedFilterComponent_Template_dw_expression_picker_control_ngModelChange_2_listener($event) { return ctx.filterExpression = $event; })("ngModelChange", function DwAdvancedFilterComponent_Template_dw_expression_picker_control_ngModelChange_2_listener() { return ctx.updateExpression(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.filterConfig.label || "Advanced Search");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.filterExpression)("item", ctx.item)("queryMeaning", ctx.queryMetaData == null ? null : ctx.queryMetaData.QueryMeaning);
    } }, directives: [DwExpressionPickerControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwAdvancedFilterComponent.ctorParameters = () => [
    { type: DwQueryFilterConverterService }
];
DwAdvancedFilterComponent = __decorate$1S([
    DwComponent({
        key: DwAdvancedFilter,
        name: 'Advanced Filter',
        componentType: DwComponentType.filterItem,
        isGlobal: true,
        configData: {
            showCaption: true,
            showCompareType: false,
            showControlOptions: false,
            requireAttr: false,
            showPlaceholderText: false,
            showDefaultValue: false,
            allowAttr: false,
        }
    }),
    __metadata$1r("design:paramtypes", [DwQueryFilterConverterService])
], DwAdvancedFilterComponent);

var __decorate$1T = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1s = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwQuickGrid {
    constructor(dwOrmDataService, dwMetaDataService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.actionPreferencesByMode = {};
        this.customizeActions = false;
        this.gridEvent = new EventEmitter();
        this.setupComplete = false;
    }
    ngOnChanges(changes) {
        this.setupGrid();
    }
    ngOnInit() {
        this.setupGrid();
    }
    onGridEvent(event) {
        this.gridEvent.emit(event);
    }
    setupGrid() {
        this.setupComplete = false;
        const query = this.query ? this.cloneQuery(this.query) : null;
        this.dataSource = new DwOrmDataSource(this.dwOrmDataService, this.dwMetaDataService, query || this.item);
        this.dwMetaDataService.getQueryMetaData(this.query)
            .subscribe(queryMetaData => {
            var _a;
            this.gridPreferences = new DwMetaDataGridPreferences();
            this.gridPreferences.passCurrentDataSource = true;
            this.gridPreferences.showDisplayProperties = (_a = query === null || query === void 0 ? void 0 : query.FieldSettings) === null || _a === void 0 ? void 0 : _a.LoadAllLookupDisplayFields;
            this.gridPreferences.showFooter = true;
            this.gridPreferences.loadTotalRowCount = this.loadCount;
            this.gridPreferences.filters = [{
                    label: 'Advanced Filter',
                    componentName: DwAdvancedFilter
                }];
            this.gridPreferences.hideAdd = true;
            this.gridPreferences.hideEditButton = true;
            this.gridPreferences.hideDeleteButton = true;
            this.gridPreferences.hideRefresh = false;
            this.gridPreferences.hideExport = false;
            this.gridPreferences.showFilter = true;
            this.gridPreferences.showFilterOnLoad = true;
            this.gridPreferences.gridStyle = {
                gridHeight: '300',
                gridHeightMode: DwGridHeightMode.fixedHeight,
                gridStyleName: 'Simple',
            };
            this.gridPreferences.views = [
                {
                    columnPreferences: this.columnPreferences || this.buildColumnPrefs(queryMetaData),
                    actionPreferences: this.actionPreferencesByMode,
                    useCustomActions: this.customizeActions,
                    display: 'Default',
                    filters: null,
                    item: this.item,
                    isDefault: true,
                    query: query,
                    includeAllFields: true
                }
            ];
            this.setupComplete = true;
        });
    }
    cloneQuery(query) {
        const newQuery = new DwQuery(query.RootTable);
        return Object.assign(newQuery, query);
    }
    buildColumnPrefs(queryMetaData) {
        const columns = [];
        const queryFields = this.query.FieldSettings ? this.query.FieldSettings.IncludeFields : [];
        const list = new DwFieldAggregateList();
        let index = 0;
        for (const attr of queryMetaData.Attributes) {
            let attrDisplay = attr.AttributeDisplay;
            const queryField = queryFields.find(field => field.FieldName == attr.AttributeName || field.FieldAlias == attr.AttributeName);
            // if (queryField && queryField.AggregateFunction) {
            //     let aggrDisplay = list.getEnumDisplay(queryField.AggregateFunction);
            //     if (!queryField.FullFieldName) {
            //         attrDisplay = '';
            //     }
            //     let splitWord = (aggrDisplay && attrDisplay) ? ' of ' : '';
            //     attrDisplay = `${aggrDisplay}${splitWord}${attrDisplay}`;
            // }
            columns.push({
                field: attr.AttributeName,
                label: attrDisplay,
                columnIndex: index,
            });
            index++;
        }
        return columns;
    }
}
DwQuickGrid.ɵfac = function DwQuickGrid_Factory(t) { return new (t || DwQuickGrid)(ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwQuickGrid.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQuickGrid, selectors: [["dw-quick-grid"]], inputs: { actionPreferencesByMode: "actionPreferencesByMode", customizeActions: "customizeActions", item: "item", query: "query", filters: "filters", columnPreferences: "columnPreferences", data: "data", loadCount: "loadCount" }, outputs: { gridEvent: "gridEvent" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["configKeyPart", "none", "allowConfig", "false", 3, "item", "filters", "dataSource", "preferences", "gridEvent", 4, "ngIf"], ["configKeyPart", "none", "allowConfig", "false", 3, "item", "filters", "dataSource", "preferences", "gridEvent"]], template: function DwQuickGrid_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQuickGrid_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.setupComplete);
    } }, directives: [ɵngcc4.NgIf, DwMetaDataGridComponent], encapsulation: 2 });
DwQuickGrid.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwQuickGrid.propDecorators = {
    item: [{ type: Input }],
    query: [{ type: Input }],
    filters: [{ type: Input }],
    columnPreferences: [{ type: Input }],
    data: [{ type: Input }],
    actionPreferencesByMode: [{ type: Input }],
    customizeActions: [{ type: Input }],
    gridEvent: [{ type: Output }],
    loadCount: [{ type: Input }]
};
__decorate$1T([
    DwInputConverter(booleanConverter),
    __metadata$1s("design:type", Boolean)
], DwQuickGrid.prototype, "loadCount", void 0);

var DwTileStyles;
(function (DwTileStyles) {
    DwTileStyles["standard"] = "standard";
    DwTileStyles["icon"] = "icon";
})(DwTileStyles || (DwTileStyles = {}));

class DwMetadataFilterTilesConfigComponent {
    constructor(dwMetaDataService, uiMetaDataConfig, dwUiConfigRegistryService, cdr) {
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.cdr = cdr;
        this.tileConfigChange = new EventEmitter();
    }
    ngOnInit() {
        var _a, _b;
        this.listConfig = {
            addItemsHeading: 'Add Tile',
            displayField: 'tileDisplay',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Tile',
            showListActionBar: true,
            showAdditionalTab: true,
            additionalTabHeading: 'Tiles Settings'
        };
        this.setupQueryMetaData();
        this.dwMetaDataService.getAttributeTypes()
            .subscribe(attributeTypes => {
            this.attributeTypes = attributeTypes;
        });
        this.tileTypeConfigs = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.filterTile);
        // Set initial filter tile
        if (this.initialFilterTileKey) {
            this.selectedItem = (_a = this.tileConfig) === null || _a === void 0 ? void 0 : _a.tiles.find(t => t.tileKey == this.initialFilterTileKey);
            this.listConfig.defaultConfigureTab = true;
        }
        if (((_b = this.tileConfig) === null || _b === void 0 ? void 0 : _b.tileStyle) == undefined) {
            this.tileConfig.tileStyle = DwTileStyles.standard;
        }
    }
    ngOnChanges(changes) {
        if (changes.itemName && !changes.itemName.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.configContext && !changes.configContext.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.filters && !changes.filters.firstChange) {
            this.setupQueryMetaData();
        }
    }
    onTileChange() {
        this.tileConfigChange.emit(this.tileConfig);
    }
    setupQueryMetaData() {
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
            this.setupControl();
            queryMetaData.Attributes[0].AttributeDisplay;
        });
    }
    setupControl() {
        this.selectedItem = null;
        this.tileConfig = this.tileConfig || { tiles: [] };
    }
    addTile(tileTypeConfig) {
        const newTile = {
            tileDisplay: `Tile ${this.tileConfig.tiles.length + 1}`,
            tileKey: `tile_${this.tileConfig.tiles.length + 1}`,
            hideTile: false,
            additionalConfig: {},
            filterTypeKey: tileTypeConfig.key,
        };
        this.tileConfig.tiles = [...this.tileConfig.tiles, newTile];
        this.onTileChange();
    }
    setSelectedItem(item) {
        this.selectedItem = item;
        if (this.componentInstance) {
            this.componentInstance.config = item;
            this.componentInstance.setupComponent();
        }
        this.selectedTileTypeConfig = this.tileTypeConfigs.find(t => t.key == item.filterTypeKey);
        this.selectedTileTypeConfig.configComponent;
        this.cdr.detectChanges();
    }
    removeItem(item) {
        const index = this.tileConfig.tiles.indexOf(item);
        if (this.selectedItem) {
            if (this.tileConfig.tiles.indexOf(this.selectedItem) == index) {
                this.selectedItem = null;
            }
        }
        if (index >= 0)
            this.tileConfig.tiles.splice(index, 1);
        this.onTileChange();
    }
    removeAll() {
        this.tileConfig.tiles = [];
        this.onTileChange();
    }
    reorderList() {
        this.onTileChange();
    }
    configureCustomConfig(component) {
        if (this.componentInstance) {
            this.configSubscription.unsubscribe();
            if (this.componentInstance.OnDestroy) {
                this.componentInstance.OnDestory();
            }
        }
        this.componentInstance = component;
        component.config = this.selectedItem;
        component.configContext = this.configContext;
        this.componentInstance.setupComponent();
        this.configSubscription = component.configChange.subscribe(result => {
            this.selectedItem = result;
        });
    }
}
DwMetadataFilterTilesConfigComponent.ɵfac = function DwMetadataFilterTilesConfigComponent_Factory(t) { return new (t || DwMetadataFilterTilesConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwMetadataFilterTilesConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFilterTilesConfigComponent, selectors: [["dw-metadata-filter-tiles-config"]], inputs: { tileConfig: "tileConfig", configContext: "configContext", initialFilterTileKey: "initialFilterTileKey" }, outputs: { tileConfigChange: "tileConfigChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 55, vars: 16, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], ["class", "dw-field-item", 4, "ngFor", "ngForOf"], ["actionBar", ""], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], [4, "ngIf"], ["additionalTab", ""], ["header", "Style Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "12"], [1, "form-control", 3, "ngModel", "ngModelChange"], ["value", "standard"], ["value", "icon"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "9"], ["title", "Automatically expand tile size based on number of visible tiles", 1, "fa", "fa-info-circle"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["title", "Determines max tiles for the row, extra tiles will show in compact mode. Accepts a responsize string: 1,2,4,6 (xs,sm,md,lg)", 1, "fa", "fa-info-circle"], ["header", "Filter Settings"], ["title", "Applies to all tiles", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "item", "queryMeaning", "ngModelChange"], [1, "dw-field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], [1, "hand", 3, "ngClass", "title"], ["header", "Basic Settings", 3, "selected"], ["title", "Excludes the optimization step to group tile queries into a single query.", 1, "fa", "fa-info-circle"], ["title", "Filter to apply for this tile", 1, "fa", "fa-info-circle"], ["header", "Visibility"], ["title", "Choose when this tile is visible", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "queryMeaning", "ngModelChange"], ["header", "Tile Settings", 4, "ngIf"], ["header", "Tile Settings"], [3, "component", "configure"]], template: function DwMetadataFilterTilesConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 0);
        ɵngcc0.ɵɵlistener("selectedItemChange", function DwMetadataFilterTilesConfigComponent_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { return ctx.setSelectedItem($event); })("removeItem", function DwMetadataFilterTilesConfigComponent_Template_dw_ui_config_list_removeItem_0_listener($event) { return ctx.removeItem($event); })("reorder", function DwMetadataFilterTilesConfigComponent_Template_dw_ui_config_list_reorder_0_listener() { return ctx.reorderList(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwMetadataFilterTilesConfigComponent_div_2_Template, 4, 3, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "button", 4);
        ɵngcc0.ɵɵlistener("click", function DwMetadataFilterTilesConfigComponent_Template_button_click_4_listener() { return ctx.removeAll(); });
        ɵngcc0.ɵɵtext(5, "Remove All");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtemplate(7, DwMetadataFilterTilesConfigComponent_p_accordion_7_Template, 58, 17, "p-accordion", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵelementStart(9, "p-accordion");
        ɵngcc0.ɵɵelementStart(10, "p-accordionTab", 8);
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵelementStart(13, "label");
        ɵngcc0.ɵɵtext(14, "Tile Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "select", 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_select_ngModelChange_15_listener($event) { return ctx.tileConfig.tileStyle = $event; });
        ɵngcc0.ɵɵelementStart(16, "option", 12);
        ɵngcc0.ɵɵtext(17, "Standard");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "option", 13);
        ɵngcc0.ɵɵtext(19, "Icon");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 9);
        ɵngcc0.ɵɵelementStart(21, "div", 10);
        ɵngcc0.ɵɵelementStart(22, "label");
        ɵngcc0.ɵɵtext(23, "Tile Default Icon");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_input_ngModelChange_24_listener($event) { return ctx.tileConfig.tileDefaultIconClass = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 9);
        ɵngcc0.ɵɵelementStart(26, "div", 10);
        ɵngcc0.ɵɵelementStart(27, "label");
        ɵngcc0.ɵɵtext(28, "Tile Container Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_input_ngModelChange_29_listener($event) { return ctx.tileConfig.tileContainerClass = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 9);
        ɵngcc0.ɵɵelementStart(31, "div", 10);
        ɵngcc0.ɵɵelementStart(32, "label");
        ɵngcc0.ɵɵtext(33, "Tile Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_input_ngModelChange_34_listener($event) { return ctx.tileConfig.tileClass = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 9);
        ɵngcc0.ɵɵelementStart(36, "div", 15);
        ɵngcc0.ɵɵelementStart(37, "label");
        ɵngcc0.ɵɵtext(38, "Dynamic Sizing ");
        ɵngcc0.ɵɵelement(39, "i", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "div", 17);
        ɵngcc0.ɵɵelementStart(41, "p-inputSwitch", 18);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_p_inputSwitch_ngModelChange_41_listener($event) { return ctx.tileConfig.useResponsiveTiles = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 9);
        ɵngcc0.ɵɵelementStart(43, "div", 10);
        ɵngcc0.ɵɵelementStart(44, "label");
        ɵngcc0.ɵɵtext(45, "Tiles Per Row ");
        ɵngcc0.ɵɵelement(46, "i", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "input", 14);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_input_ngModelChange_47_listener($event) { return ctx.tileConfig.tilesPerRow = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "p-accordionTab", 20);
        ɵngcc0.ɵɵelementStart(49, "div", 9);
        ɵngcc0.ɵɵelementStart(50, "div", 10);
        ɵngcc0.ɵɵelementStart(51, "label");
        ɵngcc0.ɵɵtext(52, "Shared Filter ");
        ɵngcc0.ɵɵelement(53, "i", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(54, "dw-expression-picker-control", 22);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMetadataFilterTilesConfigComponent_Template_dw_expression_picker_control_ngModelChange_54_listener($event) { return ctx.tileConfig.sharedFilterExpression = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.tileConfig.tiles)("config", ctx.listConfig)("selectedItem", ctx.selectedItem);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tileTypeConfigs);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItem);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.tileStyle);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.tileDefaultIconClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.tileContainerClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.tileClass);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.useResponsiveTiles);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.tilesPerRow);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.tileConfig.sharedFilterExpression)("contextNames", ctx.configContext == null ? null : ctx.configContext.contextNames)("item", ctx.configContext == null ? null : ctx.configContext.itemName)("queryMeaning", ctx.configContext == null ? null : ctx.configContext.metaDataQueryMeaning);
    } }, directives: [DwUiConfigListComponent, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, DwExpressionPickerControlComponent, ɵngcc4.NgClass, ColorSelectComponent, DwDynamicLoaderComponent], styles: [""] });
DwMetadataFilterTilesConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: ChangeDetectorRef }
];
DwMetadataFilterTilesConfigComponent.propDecorators = {
    configContext: [{ type: Input }],
    tileConfig: [{ type: Input }],
    tileConfigChange: [{ type: Output }],
    initialFilterTileKey: [{ type: Input }]
};

class DwFilterTileTypeKeys {
}
DwFilterTileTypeKeys.basicTile = 'basicTile';
DwFilterTileTypeKeys.aggregateTile = 'aggregateTile';

class DwBasicTileFilterBuilderService {
    constructor(dwQueryFilterConverterService, dwOrmDataService, dwExpressionService) {
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwExpressionService = dwExpressionService;
        this.RESULT_FIELD = 'Result';
    }
    loadFilterCounts(queryMetaData, tilesConfig, tileStates, resolvedContext) {
        const changedStates = [];
        for (const state of tileStates) {
            if (state.filterTileConfig.filterTypeKey == DwFilterTileTypeKeys.basicTile || !state.filterTileConfig.filterTypeKey) {
                const newState = deepCopy(state);
                newState.loading = false;
                changedStates.push(newState);
            }
        }
        return of(changedStates);
    }
}
DwBasicTileFilterBuilderService.ɵfac = function DwBasicTileFilterBuilderService_Factory(t) { return new (t || DwBasicTileFilterBuilderService)(ɵngcc0.ɵɵinject(DwQueryFilterConverterService), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwExpressionService)); };
DwBasicTileFilterBuilderService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwBasicTileFilterBuilderService, factory: DwBasicTileFilterBuilderService.ɵfac });
DwBasicTileFilterBuilderService.ctorParameters = () => [
    { type: DwQueryFilterConverterService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwExpressionService }
];

class DwBasicTileConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        const config = this.config || {};
        config.additionalConfig = config.additionalConfig || {};
        return config;
    }
    ngOnInit() {
    }
    setupComponent() {
        super.setupComponent();
        this.config.additionalConfig = this.config.additionalConfig || {};
    }
}
DwBasicTileConfigComponent.ɵfac = function DwBasicTileConfigComponent_Factory(t) { return ɵDwBasicTileConfigComponent_BaseFactory(t || DwBasicTileConfigComponent); };
DwBasicTileConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwBasicTileConfigComponent, selectors: [["dw-basic-tile-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 1, consts: [["dwRow", ""], ["dwCol", "12"], ["title", "This will show in the place of a count", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwBasicTileConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Metric Text ");
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwBasicTileConfigComponent_Template_input_ngModelChange_5_listener($event) { return ctx.config.additionalConfig.metricText = $event; })("ngModelChange", function DwBasicTileConfigComponent_Template_input_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.additionalConfig.metricText);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });

var __decorate$1U = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1t = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwBasicTileComponent = class DwBasicTileComponent {
    constructor(dwStyleManagerService) {
        this.dwStyleManagerService = dwStyleManagerService;
        this.compactMode = false;
        this.tileClick = new EventEmitter();
        this.loading = true;
        this.filterChange = new EventEmitter();
    }
    ;
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
        this.filterChange.emit(value);
    }
    // override method to handle filter setup
    setupFilter() { }
    onTileClick() {
        this.tileClick.emit(this.filter);
    }
    ngOnChanges(changes) {
        this.setupTileStyles();
    }
    ngOnInit() {
        this.setupTileStyles();
    }
    setupTileStyles() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        this.tileClass = this.combineClasses((_a = this.tilesConfig) === null || _a === void 0 ? void 0 : _a.tileClass, (_b = this.tileConfig) === null || _b === void 0 ? void 0 : _b.tileClass, 'dw-tile');
        this.tileStyle = ((_c = this.tilesConfig) === null || _c === void 0 ? void 0 : _c.tileStyle) || DwTileStyles.standard;
        const backgroundColor = this.dwStyleManagerService.getBackgroundColorClass((_d = this.tileConfig) === null || _d === void 0 ? void 0 : _d.tileHeaderBackgroundColor);
        const foregroundColor = this.dwStyleManagerService.getForegroundColorClass((_e = this.tileConfig) === null || _e === void 0 ? void 0 : _e.tileHeaderForegroundColor);
        this.tileHeadingClass = this.combineClasses((_f = this.tilesConfig) === null || _f === void 0 ? void 0 : _f.tileHeadingClass, (_g = this.tileConfig) === null || _g === void 0 ? void 0 : _g.tileHeadingClass, 'dw-tile-heading', backgroundColor, foregroundColor);
        this.tileHeadingClass2 = this.combineClasses((_h = this.tilesConfig) === null || _h === void 0 ? void 0 : _h.tileHeadingClass, (_j = this.tileConfig) === null || _j === void 0 ? void 0 : _j.tileHeadingClass, 'dw-tile-heading', foregroundColor);
        this.tileIconContainerClass = this.combineClasses(foregroundColor, backgroundColor, 'dw-tile-icon-container');
        this.tileIconClass = this.combineClasses((_k = this.tileConfig) === null || _k === void 0 ? void 0 : _k.tileIconClass);
        if (!this.tileIconClass) {
            this.tileIconClass = this.tilesConfig.tileDefaultIconClass || 'fa fa-square';
        }
        this.tileCountClass = this.combineClasses((_l = this.tilesConfig) === null || _l === void 0 ? void 0 : _l.tileCountClass, (_m = this.tileConfig) === null || _m === void 0 ? void 0 : _m.tileCountClass, 'dw-tile-count');
        if (this.compactMode) {
            this.tileClass = this.combineClasses((_o = this.tilesConfig) === null || _o === void 0 ? void 0 : _o.tileCompactClass, (_p = this.tileConfig) === null || _p === void 0 ? void 0 : _p.tileCompactClass, 'dw-tile-compact');
        }
        if (this.selected) {
            this.tileClass += ' ' + this.combineClasses((_q = this.tilesConfig) === null || _q === void 0 ? void 0 : _q.tileSelectedClass, null, 'dw-tile-selected');
        }
    }
    combineClasses(baseClass, additionalClass, defaultBaseClass, ...moreClasses) {
        baseClass = baseClass || defaultBaseClass;
        let classList = baseClass;
        if (additionalClass) {
            classList += ' ' + additionalClass;
        }
        for (const className of moreClasses || []) {
            if (className) {
                classList += ' ' + className;
            }
        }
        return classList;
    }
};
DwBasicTileComponent.ɵfac = function DwBasicTileComponent_Factory(t) { return new (t || DwBasicTileComponent)(ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
DwBasicTileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwBasicTileComponent, selectors: [["dw-basic-tile"]], inputs: { compactMode: "compactMode", loading: "loading", filter: "filter", item: "item", queryMetaData: "queryMetaData", tileConfig: "tileConfig", tilesConfig: "tilesConfig", selected: "selected", tileValue: "tileValue" }, outputs: { tileClick: "tileClick", filterChange: "filterChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 18, vars: 17, consts: [[1, "dw-layout-2", 3, "ngClass", "click"], ["class", "dw-tile-icon-container", 4, "ngIf"], [1, "dw-tile-detail-container"], [3, "ngClass", "hidden"], ["show", "true", "text", ""], [3, "ngClass"], [1, "dw-layout-1", 3, "ngClass", "click"], [1, "dw-tile-heading-count"], [1, "dw-tile-loading", 3, "hidden"], [1, "dw-tile-icon-container"], [1, "dw-tile-icon", 3, "ngClass"], [1, "fa-2x", 3, "ngClass"]], template: function DwBasicTileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwBasicTileComponent_Template_div_click_0_listener() { return ctx.onTileClick(); });
        ɵngcc0.ɵɵtemplate(1, DwBasicTileComponent_div_1_Template, 3, 3, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelement(6, "dw-loading", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵlistener("click", function DwBasicTileComponent_Template_div_click_9_listener() { return ctx.onTileClick(); });
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementStart(12, "span", 7);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 3);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 8);
        ɵngcc0.ɵɵelement(17, "dw-loading", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tileIconClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileCountClass)("hidden", ctx.loading || ctx.compactMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.tileValue == null ? ctx.tileConfig == null ? null : ctx.tileConfig.additionalConfig == null ? null : ctx.tileConfig.additionalConfig.metricText : ctx.tileValue, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileCountClass)("hidden", !ctx.loading || ctx.compactMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileHeadingClass2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.tileConfig == null ? null : ctx.tileConfig.tileDisplay, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileHeadingClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.tileConfig == null ? null : ctx.tileConfig.tileDisplay, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" (", ctx.tileValue == null ? ctx.tileConfig == null ? null : ctx.tileConfig.additionalConfig == null ? null : ctx.tileConfig.additionalConfig.metricText : ctx.tileValue, ") ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.tileCountClass)("hidden", ctx.loading || ctx.compactMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.tileValue == null ? ctx.tileConfig == null ? null : ctx.tileConfig.additionalConfig == null ? null : ctx.tileConfig.additionalConfig.metricText : ctx.tileValue, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.loading || ctx.compactMode);
    } }, directives: [ɵngcc4.NgClass, ɵngcc4.NgIf, DwLoadingComponent], encapsulation: 2 });
DwBasicTileComponent.ctorParameters = () => [
    { type: DwStyleManagerService }
];
DwBasicTileComponent.propDecorators = {
    item: [{ type: Input }],
    queryMetaData: [{ type: Input }],
    tileConfig: [{ type: Input }],
    tilesConfig: [{ type: Input }],
    compactMode: [{ type: Input }],
    selected: [{ type: Input }],
    tileValue: [{ type: Input }],
    tileClick: [{ type: Output }],
    loading: [{ type: Input }],
    filter: [{ type: Input }],
    filterChange: [{ type: Output }]
};
__decorate$1U([
    DwInputConverter(booleanConverter),
    __metadata$1t("design:type", Boolean)
], DwBasicTileComponent.prototype, "compactMode", void 0);
__decorate$1U([
    DwInputConverter(booleanConverter),
    __metadata$1t("design:type", Boolean)
], DwBasicTileComponent.prototype, "selected", void 0);
__decorate$1U([
    DwInputConverter(booleanConverter),
    __metadata$1t("design:type", Object)
], DwBasicTileComponent.prototype, "loading", void 0);
DwBasicTileComponent = __decorate$1U([
    DwComponent({
        name: 'Basic Title',
        key: DwFilterTileTypeKeys.basicTile,
        componentType: DwComponentType.filterTile,
        configComponent: DwBasicTileConfigComponent,
        isGlobal: true,
        configData: {
            tileIconClass: 'fa fa-sqaure',
            buildFilterService: DwBasicTileFilterBuilderService
        },
    }),
    __metadata$1t("design:paramtypes", [DwStyleManagerService])
], DwBasicTileComponent);

class DwResponsiveUtilService {
    constructor(dwUiConfig) {
        this.dwUiConfig = dwUiConfig;
        this.resizeSubject = new Subject();
    }
    resize(event) {
        // re-configure the grid style upon browser resize
        this.resizeSubject.next();
    }
    onResize(delayMs = 50) {
        return this.resizeSubject.asObservable().pipe(debounceTime(delayMs));
    }
    getResponseColumns(config, useResponsiveTiles, tileStates) {
        var _a;
        let selectedColumnConfig;
        if (useResponsiveTiles && ((_a = tileStates === null || tileStates === void 0 ? void 0 : tileStates.tiles) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            return tileStates.tiles.length;
        }
        for (const columnConfig of this.dwUiConfig.responsizeColumns) {
            if ((!columnConfig.minSizePx || columnConfig.minSizePx <= window.innerWidth) && (!columnConfig.maxSizePx || columnConfig.maxSizePx >= window.innerWidth)) {
                selectedColumnConfig = columnConfig;
            }
        }
        if (!config) {
            return selectedColumnConfig.columns;
        }
        const configParts = config.split(',');
        const index = this.dwUiConfig.responsizeColumns.indexOf(selectedColumnConfig);
        if (index < configParts.length) {
            return parseInt(configParts[index]);
        }
        return parseInt(configParts[configParts.length - 1]);
    }
}
DwResponsiveUtilService.ɵfac = function DwResponsiveUtilService_Factory(t) { return new (t || DwResponsiveUtilService)(ɵngcc0.ɵɵinject(DwUIConfigToken)); };
DwResponsiveUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwResponsiveUtilService_Factory() { return new DwResponsiveUtilService(ɵɵinject(DwUIConfigToken)); }, token: DwResponsiveUtilService, providedIn: "root" });
DwResponsiveUtilService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];
DwResponsiveUtilService.propDecorators = {
    resize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};

class DwMetadataFilterTilesComponent {
    constructor(dwFilterTileService, dwFilterStateService, dwFilterService, dwEventService, dwResponseUtilService, router) {
        this.dwFilterTileService = dwFilterTileService;
        this.dwFilterStateService = dwFilterStateService;
        this.dwFilterService = dwFilterService;
        this.dwEventService = dwEventService;
        this.dwResponseUtilService = dwResponseUtilService;
        this.router = router;
        this.selectedIndex = 0;
        this.tileSet = false;
        this.columns = 8;
        this.tileContainerClass = 'dw-tile-container';
        this.loading = false;
    }
    ngOnDestroy() {
        if (this.tileSubscription) {
            this.tileSubscription.unsubscribe();
            this.tileSubscription = null;
        }
        if (this.eventSubscription) {
            this.eventSubscription.unsubscribe();
            this.eventSubscription = null;
        }
    }
    ngOnInit() {
        this.setupFilterTiles();
        // Using the tileSet bool to set after context is loaded
        //this.selectTile(0);
        this.eventSubscription = this.dwEventService.getEventData(DwGridEvents.refreshData)
            .pipe(debounceTime(100))
            .subscribe(gridRefreshEvent => {
            if (gridRefreshEvent.itemName == this.configContext.itemName) {
                this.refresh();
            }
        });
        this.setupTileItemStyle();
    }
    ngOnChanges(changes) {
        if (changes.tilesConfig && !changes.tilesConfig.firstChange || changes.sharedFilterExpression) {
            //console.log('Tiles - refreshing config',this.loading);
            this.tileSet = false;
            this.setupFilterTiles();
            this.setupTileItemStyle();
        }
    }
    resize(event) {
        // re-configure the grid style upon browser resize
        this.setupTileItemStyle();
    }
    setupTileItemStyle() {
        if (!this.tilesConfig) {
            return;
        }
        switch (this.tilesConfig.tileStyle) {
            case DwTileStyles.icon:
                this.tileContainerClass = 'dw-tile-container dw-tile-container-icons';
                break;
            case DwTileStyles.standard:
            default:
                this.tileContainerClass = 'dw-tile-container';
                break;
        }
        if (this.tilesConfig.tileContainerClass) {
            this.tileContainerClass = this.tilesConfig.tileContainerClass;
        }
        this.columns = this.dwResponseUtilService.getResponseColumns(this.tilesConfig.tilesPerRow, this.tilesConfig.useResponsiveTiles, this.tileStates);
        let columnWidth = `${100 / this.columns}%`;
        this.tileItemStyle = {
            width: columnWidth
        };
    }
    selectTile(index) {
        var _a;
        this.selectedIndex = index;
        this.tileSet = true;
        //const selectedTile = this.tilesConfig?.tiles[index];
        const selectedTileState = this.tileStates.tiles[index];
        const selectedTile = selectedTileState === null || selectedTileState === void 0 ? void 0 : selectedTileState.filterTileConfig;
        if (selectedTile) {
            const tileFilter = this.dwFilterTileService.buildTileFilter(this.tilesConfig, selectedTile, (_a = this.tileStates) === null || _a === void 0 ? void 0 : _a.resolvedContext);
            const filters = deepCopy(this.dwFilterStateService.state.filters);
            filters.GroupTileFilter = tileFilter;
            this.dwFilterStateService.setFilters(filters, selectedTile.tileKey, null, true);
        }
    }
    refresh() {
        if (this.loading) {
            return;
        }
        this.setupFilterTiles();
    }
    setupFilterTiles() {
        if (this.tileSubscription) {
            // console.log('Tiles - SetupFilterTiles - unsubscribe',this.loading);
            this.tileSubscription.unsubscribe();
            this.tileStates$ = null;
        }
        this.loading = true;
        //console.log('Tiles - SetupFilterTiles - LoadFilterStatues', this.tilesConfig);
        this.tileStates$ = this.dwFilterTileService.loadFilterTileStates(this.configContext, this.tilesConfig, this.sharedFilterExpression);
        this.tileSubscription = this.tileStates$
            .subscribe(tileStates => {
            // Need to set tile stats prior to selecting the first tile
            this.tileStates = tileStates;
            this.setupTileItemStyle();
            if (tileStates.resolvedContext && !this.tileSet) {
                const selectedTileParam = this.dwFilterService.getFilterTileQueryParam();
                let selectedTileIndex = -1;
                if (selectedTileParam) {
                    selectedTileIndex = this.tileStates.tiles.findIndex(tile => tile.filterTileConfig.tileKey == selectedTileParam);
                }
                if (selectedTileIndex > -1) {
                    this.selectTile(selectedTileIndex);
                }
                else {
                    this.selectTile(0);
                }
            }
            this.loading = false;
        });
    }
}
DwMetadataFilterTilesComponent.ɵfac = function DwMetadataFilterTilesComponent_Factory(t) { return new (t || DwMetadataFilterTilesComponent)(ɵngcc0.ɵɵdirectiveInject(DwFilterTileService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwResponsiveUtilService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
DwMetadataFilterTilesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFilterTilesComponent, selectors: [["dw-metadata-filter-tiles"]], hostBindings: function DwMetadataFilterTilesComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwMetadataFilterTilesComponent_resize_HostBindingHandler($event) { return ctx.resize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { configKey: "configKey", viewKey: "viewKey", tilesConfig: "tilesConfig", configContext: "configContext", sharedFilterExpression: "sharedFilterExpression" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class-old", "dw-tile-container", 3, "ngClass", 4, "ngIf"], ["class-old", "dw-tile-container", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["class", "dw-tile-item", 3, "ngStyle", 4, "ngIf"], ["class", "dw-tile-item", "dwPageDesignerSelector", "", "detailKey", "filterTile", 3, "ngStyle", "configKey", "sectionKey", "additionalInfo", 4, "ngIf"], ["dwPageDesignerSelector", "", "detailKey", "filterTile", 1, "dw-tile-item", 3, "ngStyle", "configKey", "sectionKey", "additionalInfo"], [3, "tileConfig", "tilesConfig", "selected", "tileValue", "loading", "click"], [1, "dw-tile-item", 3, "ngStyle"], ["compactMode", "true", 3, "tileConfig", "tilesConfig", "selected", "tileValue", "loading", "click", 4, "ngIf"], ["compactMode", "true", 3, "tileConfig", "tilesConfig", "selected", "tileValue", "loading", "click"]], template: function DwMetadataFilterTilesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetadataFilterTilesComponent_div_0_Template, 3, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.tileStates == null ? null : ctx.tileStates.tiles == null ? null : ctx.tileStates.tiles.length) > 0);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc4.NgForOf, DwDesignerSelector, ɵngcc4.NgStyle, DwBasicTileComponent]; }, encapsulation: 2 });
DwMetadataFilterTilesComponent.ctorParameters = () => [
    { type: DwFilterTileService },
    { type: DwMetaDataFilterStateService },
    { type: DwMetaDataFilterService },
    { type: DwEventService },
    { type: DwResponsiveUtilService },
    { type: Router }
];
DwMetadataFilterTilesComponent.propDecorators = {
    configKey: [{ type: Input }],
    viewKey: [{ type: Input }],
    tilesConfig: [{ type: Input }],
    configContext: [{ type: Input }],
    sharedFilterExpression: [{ type: Input }],
    resize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};

class DwAggregateTileConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        const config = this.config || {};
        config.additionalConfig = config.additionalConfig || {};
        config.additionalConfig.useCustomAggregate = false;
        config.additionalConfig.aggregateFunction = DwFieldAggregate.CountDistinct;
        return config;
    }
    ngOnInit() {
    }
    setupComponent() {
        super.setupComponent();
        this.config.additionalConfig = this.config.additionalConfig || {};
        if (!this.config.additionalConfig.aggregateFunction) {
            this.config.additionalConfig.aggregateFunction = DwFieldAggregate.CountDistinct;
        }
    }
}
DwAggregateTileConfigComponent.ɵfac = function DwAggregateTileConfigComponent_Factory(t) { return ɵDwAggregateTileConfigComponent_BaseFactory(t || DwAggregateTileConfigComponent); };
DwAggregateTileConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAggregateTileConfigComponent, selectors: [["dw-aggregate-tile-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 4, consts: [["dwRow", ""], ["dwCol", "9"], ["title", "Customize the Aggregate function.  Defaults to Count Distinct", 1, "fa", "fa-info-circle"], ["dwCol", "2"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], [3, "ngModel", "showBasicAggregatesOnly", "ngModelChange"]], template: function DwAggregateTileConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Customize Aggregate ");
        ɵngcc0.ɵɵelement(4, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "p-inputSwitch", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAggregateTileConfigComponent_Template_p_inputSwitch_ngModelChange_6_listener($event) { return ctx.config.additionalConfig.useCustomAggregate = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Aggregate Function");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "dw-aggregate-field-control", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAggregateTileConfigComponent_Template_dw_aggregate_field_control_ngModelChange_11_listener($event) { return ctx.config.additionalConfig.aggregateFunction = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.additionalConfig.useCustomAggregate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.config.additionalConfig.useCustomAggregate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.additionalConfig.aggregateFunction)("showBasicAggregatesOnly", true);
    } }, directives: function () { return [DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwAggregateFieldControlComponent]; }, encapsulation: 2 });

class DwAggregateTileFilterBuilderService {
    constructor(dwQueryFilterConverterService, dwOrmDataService, dwExpressionService) {
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwExpressionService = dwExpressionService;
        this.RESULT_FIELD = 'Result';
    }
    loadFilterCounts(queryMetaData, tilesConfig, tileStates, resolvedContext, dwSharedFilterExpression) {
        let currentStates = deepCopy(tileStates);
        const subject = new Subject();
        const obs = [];
        const queryInfoList = this.buildFilterQueryInfos(tilesConfig, resolvedContext);
        // Emit current states
        subject.next(currentStates);
        for (const queryInfo of queryInfoList) {
            const queryOb = this.executeTileQuery(queryInfo, queryMetaData, tilesConfig, tileStates, resolvedContext, dwSharedFilterExpression);
            queryOb.subscribe(results => {
                subject.next(results);
            });
        }
        return subject.asObservable();
    }
    executeTileQuery(queryInfo, queryMetaData, tilesConfig, tileStates, resolvedContext, dwSharedFilterExpression) {
        const query = this.buildTileQuery(queryInfo, queryMetaData, tilesConfig, resolvedContext, dwSharedFilterExpression);
        return this.dwOrmDataService.executeQuery(query)
            .pipe(map(results => {
            const currentStates = deepCopy(tileStates);
            return this.mapQueryResults(results, queryInfo, tileStates);
        }));
    }
    mapQueryResults(results, queryInfo, tileStates) {
        const updatedTileStates = [];
        for (var tileConfig of queryInfo.tileConfigs) {
            const tileState = tileStates.find(ts => ts.filterTileConfig.tileKey == tileConfig.tileKey);
            // This can happen if there is a visbility expression on the tile and it's no longer displayed after evaluation
            if (!tileState) {
                continue;
            }
            tileState.loading = false;
            tileState.metricValue = this.getAggregateValue(results, tileConfig, queryInfo.tileConfigs.length);
            updatedTileStates.push(tileState);
        }
        return updatedTileStates;
    }
    getAggregateValue(results, tileConfig, filterCount) {
        if (!results || results.length == 0) {
            return 0;
        }
        // If only one filter, then we get the result from the first row
        if (filterCount == 1) {
            return results[0][this.RESULT_FIELD];
        }
        // Otherwise, we need to find the match based on the tile config aggregate
        if (!tileConfig.filterExpression) {
            return 0;
        }
        for (const result of results) {
            if (this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(tileConfig.filterExpression, result, {})) {
                return result[this.RESULT_FIELD];
            }
        }
        return 0;
    }
    buildFilterQueryInfos(tilesConfig, resolvedContext) {
        const queryInfoList = [];
        for (const tileConfig of tilesConfig.tiles) {
            this.buildTileQueryInfo(queryInfoList, tileConfig, resolvedContext);
        }
        return queryInfoList;
    }
    buildTileQuery(queryInfo, queryMetaData, tilesConfig, resolvedContext, dwSharedFilterExpression) {
        var _a;
        // Clone original query
        const query = this.cloneQuery(queryMetaData.DataQuery);
        const queryBuilder = new DwQueryBuilder(query);
        query.FieldSettings.AggregateQuery = true;
        query.FieldSettings.AggregateQueryWithRollup = false;
        query.FieldSettings.IncludeRootItemFields = false;
        query.FieldSettings.IncludeFields = [];
        query.Order = [];
        const qh = new DwQueryHelper();
        qh.clearAllFields(query);
        const rootFilter = new DwQueryFilterGroup();
        if (dwSharedFilterExpression) {
            // Add a shared filter
            rootFilter.AddFilterAnd(this.dwQueryFilterConverterService.convertExpressionToFilter(dwSharedFilterExpression, resolvedContext));
        }
        if (tilesConfig.sharedFilterExpression) {
            // Add a shared filter
            rootFilter.AddFilterAnd(this.dwQueryFilterConverterService.convertExpressionToFilter(tilesConfig.sharedFilterExpression, resolvedContext));
        }
        if (queryInfo.filters) {
            rootFilter.AddFilter(queryInfo.filters);
        }
        // Get the safe root filter in case the existing root filters use an OR
        query.getSafeRootFilter().AddFilterAnd(rootFilter);
        if (queryInfo.tileConfigs.length > 1) {
            // If more than one tile config, then we group by all filter fields
            for (const field of queryInfo.fields) {
                query.AddField(field);
            }
        }
        let aggregateFunction = queryInfo.aggregateFunction || DwFieldAggregate.CountDistinct;
        // Get the PK field name
        let pkFieldName = (_a = queryMetaData.Attributes.find(a => { var _a; return (_a = a.Attribute) === null || _a === void 0 ? void 0 : _a.IsKey; })) === null || _a === void 0 ? void 0 : _a.AttributeName;
        // DwFieldAggregate.Coun
        const aggrField = new DwField();
        aggrField.AggregateFunction = aggregateFunction;
        aggrField.FieldType = DwFieldType.Aggregate;
        aggrField.FieldAlias = this.RESULT_FIELD;
        aggrField.FullFieldName = pkFieldName;
        query.AddField(aggrField);
        return query;
    }
    buildTileQueryInfo(queryInfos, tileConfig, resolvedContext) {
        var _a;
        let tileFilter;
        let filterFields = [];
        if (tileConfig.filterTypeKey != DwFilterTileTypeKeys.aggregateTile) {
            return;
        }
        if (tileConfig.filterExpression) {
            tileFilter = this.dwQueryFilterConverterService.convertExpressionToFilter(tileConfig.filterExpression, resolvedContext);
            filterFields = this.getFilterFields(tileFilter);
        }
        let aggregateFunction = DwFieldAggregate.CountDistinct;
        if (((_a = tileConfig.additionalConfig) === null || _a === void 0 ? void 0 : _a.useCustomAggregate) && tileConfig.additionalConfig.aggregateFunction) {
            aggregateFunction = tileConfig.additionalConfig.aggregateFunction;
        }
        const queryInfo = this.getOrCreateQueryInfo(queryInfos, filterFields, aggregateFunction, tileConfig.excludeFromGroupQuery);
        if (tileFilter) {
            queryInfo.filters.AddFilter(tileFilter);
        }
        queryInfo.tileConfigs.push(tileConfig);
    }
    getOrCreateQueryInfo(queryInfos, filterFields, aggregate, excludeFromGroupQuery) {
        let queryInfo = queryInfos.find(qi => qi.excludeFromGroup == false && qi.fields.join(',') == filterFields.join(',') && qi.aggregateFunction == aggregate);
        if (!queryInfo || excludeFromGroupQuery) {
            queryInfo = {
                fields: filterFields,
                aggregateFunction: aggregate,
                filters: new DwQueryFilterGroup(),
                tileConfigs: [],
                excludeFromGroup: excludeFromGroupQuery
            };
            // Make all filters an OR
            queryInfo.filters.Op = DwOperator.Or;
            queryInfos.push(queryInfo);
        }
        return queryInfo;
    }
    getFilterFields(tileFilter, fields = []) {
        if (tileFilter.Attr) {
            if (fields.indexOf(tileFilter.Attr) == -1) {
                fields.push(tileFilter.Attr);
            }
        }
        if (tileFilter instanceof DwQueryFilterGroup) {
            for (const subFilter of tileFilter.Filters) {
                this.getFilterFields(subFilter, fields);
            }
        }
        return fields;
    }
    cloneQuery(query) {
        const newQuery = new DwQuery(query.RootTable);
        return Object.assign(newQuery, deepCopy(query));
    }
}
DwAggregateTileFilterBuilderService.ɵfac = function DwAggregateTileFilterBuilderService_Factory(t) { return new (t || DwAggregateTileFilterBuilderService)(ɵngcc0.ɵɵinject(DwQueryFilterConverterService), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwExpressionService)); };
DwAggregateTileFilterBuilderService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwAggregateTileFilterBuilderService, factory: DwAggregateTileFilterBuilderService.ɵfac });
DwAggregateTileFilterBuilderService.ctorParameters = () => [
    { type: DwQueryFilterConverterService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwExpressionService }
];

var __decorate$1V = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwAggregateTileComponent = class DwAggregateTileComponent extends DwBasicTileComponent {
};
DwAggregateTileComponent.ɵfac = function DwAggregateTileComponent_Factory(t) { return ɵDwAggregateTileComponent_BaseFactory(t || DwAggregateTileComponent); };
DwAggregateTileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAggregateTileComponent, selectors: [["dw-aggregate-tile"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[3, "ngClass", "click", 4, "ngIf"], [3, "ngClass", "click"], [3, "ngClass"], [1, "dw-tile-heading-count"], [3, "ngClass", "hidden"], [1, "dw-tile-loading", 3, "hidden"], ["show", "true", "text", ""], [1, "dw-tile-icon"], [1, "fa", "fa-2x", "fa-users", 3, "ngClass"]], template: function DwAggregateTileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwAggregateTileComponent_div_0_Template, 9, 8, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwAggregateTileComponent_div_1_Template, 11, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgClass, DwLoadingComponent], encapsulation: 2 });
DwAggregateTileComponent = __decorate$1V([
    DwComponent({
        name: 'Aggregate Tile',
        key: DwFilterTileTypeKeys.aggregateTile,
        componentType: DwComponentType.filterTile,
        // Not used since we more the filter expression to the basic tile
        configComponent: DwAggregateTileConfigComponent,
        isGlobal: true,
        configData: {
            tileIconClass: 'fa fa-sigma',
            buildFilterService: DwAggregateTileFilterBuilderService
        },
    })
], DwAggregateTileComponent);

class DwLookupTileComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwLookupTileComponent.ɵfac = function DwLookupTileComponent_Factory(t) { return new (t || DwLookupTileComponent)(); };
DwLookupTileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLookupTileComponent, selectors: [["dw-dw-lookup-tile"]], decls: 2, vars: 0, template: function DwLookupTileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-lookup-tile works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwLookupTileComponent.ctorParameters = () => [];

class DwLookupTileConfigComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwLookupTileConfigComponent.ɵfac = function DwLookupTileConfigComponent_Factory(t) { return new (t || DwLookupTileConfigComponent)(); };
DwLookupTileConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwLookupTileConfigComponent, selectors: [["dw-dw-lookup-tile-config"]], decls: 2, vars: 0, template: function DwLookupTileConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-lookup-tile-config works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwLookupTileConfigComponent.ctorParameters = () => [];

class DwPageDesignerHelperService {
    /**
     * Returns the section hierarchy as a flat list
     * @param rootSection
     * @param sectionDefs
     * @returns
     */
    getSectionConfigList(currentSection, sectionDefs) {
        var _a;
        let sectionConfigs = [];
        sectionConfigs.push(currentSection);
        const sectionDef = sectionDefs.find(sd => sd.key == currentSection.sectionType);
        if ((_a = sectionDef === null || sectionDef === void 0 ? void 0 : sectionDef.configData) === null || _a === void 0 ? void 0 : _a.hasChildren) {
            let children = currentSection.configData[sectionDef === null || sectionDef === void 0 ? void 0 : sectionDef.configData.childrenPropertyName];
            if (sectionDef === null || sectionDef === void 0 ? void 0 : sectionDef.configData.getChildSections) {
                children = sectionDef.configData.getChildSections(currentSection);
            }
            if (Array.isArray(children)) {
                for (const child of children) {
                    const subSections = this.getSectionConfigList(child, sectionDefs);
                    if (subSections && subSections.length > 0) {
                        sectionConfigs.push(...subSections);
                    }
                }
            }
        }
        return sectionConfigs;
    }
}
DwPageDesignerHelperService.ɵfac = function DwPageDesignerHelperService_Factory(t) { return new (t || DwPageDesignerHelperService)(); };
DwPageDesignerHelperService.ɵprov = ɵɵdefineInjectable({ factory: function DwPageDesignerHelperService_Factory() { return new DwPageDesignerHelperService(); }, token: DwPageDesignerHelperService, providedIn: "root" });

class DwPageDesignerStateService extends DwStateBaseService {
    constructor(dwUiConfigRegistryService, dwPageDesignerHelperService) {
        super();
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwPageDesignerHelperService = dwPageDesignerHelperService;
        this.sectionconfigUpdateSubject = new Subject();
    }
    setupPageDesigner(rootConfig, pageDesignerConfig) {
        this.rootConfig = rootConfig;
        this.setState({
            rootConfig: rootConfig,
            pageDesignerConfig: pageDesignerConfig
        });
    }
    getSectionDefs() {
        return this.dwUiConfigRegistryService.getRegisteredComponents(this.state.pageDesignerConfig.componentType);
    }
    getSectionDef(sectionType) {
        return this.dwUiConfigRegistryService.getRegisteredComponent(sectionType, this.state.pageDesignerConfig.componentType);
    }
    setCurrentSectionConfig(sectionKey) {
        this.setState({
            currentSectionConfigKey: sectionKey
        });
    }
    getSectionConfigUpdates(sectionKey) {
        return this.sectionconfigUpdateSubject.asObservable().pipe(filter(key => key == sectionKey));
    }
    publishSectionConfigUpdate(sectionKey) {
        this.sectionconfigUpdateSubject.next(sectionKey);
    }
    clearCurrentSectionConfig() {
        this.setState({
            currentSectionConfigKey: null
        });
    }
    setSelectedSection(sectionKey) {
        this.setState({
            selectedSectionConfigKey: sectionKey,
            currentSectionConfigKey: sectionKey
        });
    }
    clearSelectedSectionConfig() {
        this.setState({
            selectedSectionConfigKey: null
        });
    }
    setShowBorders(show) {
        this.setState({
            showAllBorders: show
        });
    }
    getSectionConfig(sectionKey) {
        const rootSectionConfig = this.rootConfig[this.state.pageDesignerConfig.rootSectionPropertyName];
        const list = this.dwPageDesignerHelperService.getSectionConfigList(rootSectionConfig, this.getSectionDefs());
        const sectionConfig = list.find(sc => sc.sectionKey == sectionKey);
        return sectionConfig;
    }
    getUniqueSectionKey(newSection, setUniqueName) {
        const rootSectionConfig = this.rootConfig[this.state.pageDesignerConfig.rootSectionPropertyName];
        // Get list of all sections of type
        const list = this.dwPageDesignerHelperService.getSectionConfigList(rootSectionConfig, this.getSectionDefs()).filter(sc => sc.sectionType == newSection.sectionType);
        let nextCount = list.length + 1;
        let nextKey = `${newSection.sectionType}${nextCount}`;
        while (list.find(sc => sc.sectionKey == nextKey)) {
            nextCount++;
            nextKey = `${newSection.sectionType}${nextCount}`;
        }
        if (setUniqueName) {
            newSection.sectionName += ' ' + nextCount;
        }
        return nextKey;
    }
    getInitialState() {
        return {};
    }
}
DwPageDesignerStateService.ɵfac = function DwPageDesignerStateService_Factory(t) { return new (t || DwPageDesignerStateService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwPageDesignerHelperService)); };
DwPageDesignerStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwPageDesignerStateService, factory: DwPageDesignerStateService.ɵfac });
DwPageDesignerStateService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwPageDesignerHelperService }
];

class DwPageDesignerDragDropService {
    constructor(document, dwPageDesignerStateService) {
        this.dwPageDesignerStateService = dwPageDesignerStateService;
        this.dropLists = [];
        this.isDragging = false;
        this.document = document;
    }
    register(dropList) {
        this.dropLists.push(dropList);
    }
    dragStart(event) {
        this.isDragging = true;
    }
    dragEnd(event) {
        this.isDragging = false;
    }
    dragMoved(event) {
        this.dragStart(event);
        let elementFromPoint = this.document.elementFromPoint(event.pointerPosition.x, event.pointerPosition.y);
        if (!elementFromPoint) {
            this.currentHoverDropListId = undefined;
            return;
        }
        let dropList = elementFromPoint.classList.contains('cdk-drop-list')
            ? elementFromPoint
            : elementFromPoint.closest('.cdk-drop-list');
        if (!dropList) {
            this.currentHoverDropListId = undefined;
            return;
        }
        this.currentHoverDropListId = dropList.id;
    }
    dragReleased(event) {
        this.currentHoverDropListId = undefined;
        this.dragEnd(event);
    }
    handleSectionDrop(event) {
        console.log('onSectionDrop', event.item.data);
        let data = event.item.data;
        if (!this.isSectionDef(data)) {
            if (event.previousContainer === event.container) {
                moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            }
            else {
                transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
            }
            return;
        }
        if (this.isSectionDef(data)) {
            const newSection = data.configData.createSectionDef(data);
            newSection.sectionKey = this.dwPageDesignerStateService.getUniqueSectionKey(newSection, true);
            event.container.data.splice(event.currentIndex, 0, newSection);
        }
    }
    isSectionDef(itemDef) {
        const sectioDef = itemDef;
        if (sectioDef.component) {
            return true;
        }
        return false;
    }
}
DwPageDesignerDragDropService.ɵfac = function DwPageDesignerDragDropService_Factory(t) { return new (t || DwPageDesignerDragDropService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(DwPageDesignerStateService)); };
DwPageDesignerDragDropService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwPageDesignerDragDropService, factory: DwPageDesignerDragDropService.ɵfac });
DwPageDesignerDragDropService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: DwPageDesignerStateService }
];

class DwPageDesignerComponent {
    constructor(dwDragDropService, dwPageDesignerStateService) {
        this.dwDragDropService = dwDragDropService;
        this.dwPageDesignerStateService = dwPageDesignerStateService;
        this.rootConfigChange = new EventEmitter();
    }
    ngOnInit() {
        this.dwPageDesignerStateService.setupPageDesigner(this.rootConfig, this.pageDesignerConfig);
        this.dwPageDesignerStateService.stateChanged.subscribe(pageDesignerState => {
            this.pageDesignerState = pageDesignerState;
        });
    }
    configureDesigner(componentInstance) {
        var _a, _b;
        if (this.rootConfig && this.rootConfig[(_a = this.pageDesignerConfig) === null || _a === void 0 ? void 0 : _a.rootSectionPropertyName]) {
            componentInstance.sectionConfig = this.rootConfig[(_b = this.pageDesignerConfig) === null || _b === void 0 ? void 0 : _b.rootSectionPropertyName];
        }
    }
    dragMoved(event) {
        this.dwDragDropService.dragMoved(event);
    }
    dragReleased(event) {
        this.dwDragDropService.dragReleased(event);
    }
    /** Predicate function that doesn't allow items to be dropped into a list. */
    noReturnPredicate() {
        return false;
    }
    unselect() {
        this.dwPageDesignerStateService.clearSelectedSectionConfig();
    }
}
DwPageDesignerComponent.ɵfac = function DwPageDesignerComponent_Factory(t) { return new (t || DwPageDesignerComponent)(ɵngcc0.ɵɵdirectiveInject(DwPageDesignerDragDropService), ɵngcc0.ɵɵdirectiveInject(DwPageDesignerStateService)); };
DwPageDesignerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPageDesignerComponent, selectors: [["dw-page-designer"]], inputs: { rootConfig: "rootConfig", pageDesignerConfig: "pageDesignerConfig" }, outputs: { rootConfigChange: "rootConfigChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DwPageDesignerDragDropService, DwPageDesignerStateService])], decls: 1, vars: 1, consts: [["cdkDropListGroup", "", "cdkDragBoundary", "", "style", "width:100%;min-height:500px;position:relative", 3, "click", 4, "ngIf"], ["cdkDropListGroup", "", "cdkDragBoundary", "", 2, "width", "100%", "min-height", "500px", "position", "relative", 3, "click"], [2, "max-width", "1200px"], [1, "btn", "btn-success"], [1, "btn", "btn-warning"], ["right", ""], [1, "btn-group", "dw-button-right"], [1, "btn", "btn-success", 3, "ngClass", "click"], ["title", "Hide Borders", 1, "fa", "fa-border-none"], ["title", "Show Borders", 1, "fa", "fa-border-all"], [3, "component", "configure", 4, "ngIf"], ["cdkDrag", "", 1, "pd-toolbox"], ["cdkDragHandle", "", 1, "pd-toolbox-header"], [1, "fa", "fa-grip-vertical", "pd-section-icon"], ["header", "Toolbox", "cdkDragHandle", ""], ["pTemplate", "header"], [3, "pageDesignerConfig"], ["header", "Configuration", 4, "ngIf"], [3, "component", "configure"], ["cdkDragHandle", ""], ["header", "Configuration"]], template: function DwPageDesignerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwPageDesignerComponent_div_0_Template, 22, 9, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.pageDesignerConfig);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc28.CdkDropListGroup, DwButtonBarComponent, ɵngcc4.NgClass, ɵngcc28.CdkDrag, ɵngcc28.CdkDragHandle, ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc6.PrimeTemplate, DwPageDesignerToolbarComponent, DwDynamicLoaderComponent, DwPageDesignerConfigPanelComponent]; }, encapsulation: 2 });
DwPageDesignerComponent.ctorParameters = () => [
    { type: DwPageDesignerDragDropService },
    { type: DwPageDesignerStateService }
];
DwPageDesignerComponent.propDecorators = {
    rootConfig: [{ type: Input }],
    rootConfigChange: [{ type: Output }],
    pageDesignerConfig: [{ type: Input }]
};

class DwEmailTemplateRootSectionComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwEmailTemplateRootSectionComponent.ɵfac = function DwEmailTemplateRootSectionComponent_Factory(t) { return new (t || DwEmailTemplateRootSectionComponent)(); };
DwEmailTemplateRootSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateRootSectionComponent, selectors: [["dw-email-template-root-section"]], inputs: { sectionConfig: "sectionConfig" }, decls: 2, vars: 1, consts: [[1, "pd-container", 2, "max-width", "1200px"], ["preventMove", "true", "preventRemove", "true", 3, "sectionConfig"]], template: function DwEmailTemplateRootSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-page-designer-section-wrapper", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("sectionConfig", ctx.sectionConfig);
    } }, directives: function () { return [DwPageDesignerSectionWrapperComponent]; }, encapsulation: 2 });
DwEmailTemplateRootSectionComponent.ctorParameters = () => [];
DwEmailTemplateRootSectionComponent.propDecorators = {
    sectionConfig: [{ type: Input }]
};

class DwEmailTemplateDesignerComponent {
    constructor(dwUiConfigRegistryService) {
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
    }
    ngOnInit() {
        this.rootConfig = {
            section: {
                sectionKey: 'root',
                sectionType: 'dwEmailContainerSection',
                sectionName: 'Container',
                config: {
                    sections: [],
                }
            }
        };
        const emailDesignerSections = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.emailDesignSection);
        this.pageDesignerConfig = {
            rootSectionPropertyName: 'section',
            rootSectionDesignComponent: DwEmailTemplateRootSectionComponent,
            sectionDefs: emailDesignerSections,
            componentType: DwComponentType.emailDesignSection
        };
    }
}
DwEmailTemplateDesignerComponent.ɵfac = function DwEmailTemplateDesignerComponent_Factory(t) { return new (t || DwEmailTemplateDesignerComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwEmailTemplateDesignerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateDesignerComponent, selectors: [["dw-email-template-designer"]], decls: 3, vars: 5, consts: [[3, "rootConfig", "pageDesignerConfig"]], template: function DwEmailTemplateDesignerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-page-designer", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "json");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("rootConfig", ctx.rootConfig)("pageDesignerConfig", ctx.pageDesignerConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 3, ctx.rootConfig), "\n");
    } }, directives: [DwPageDesignerComponent], pipes: [ɵngcc4.JsonPipe], encapsulation: 2 });
DwEmailTemplateDesignerComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];

class DwEmailContainerSectionConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
        const config = {
            configData: {
                columnsConfig: {
                    columnLayoutMode: DwColumnLayoutMode.grid12,
                    columns: 1,
                    columnDetails: []
                },
                columns: []
            }
        };
        return {
            config: {
                columns: 1
            }
        };
    }
    setupComponent() {
        if (!this.config) {
        }
        if (!this.config.configData) {
            this.config.configData = {
                columnsConfig: {
                    columns: 1,
                    columnDetails: []
                },
                columns: []
            };
        }
    }
}
DwEmailContainerSectionConfigComponent.ɵfac = function DwEmailContainerSectionConfigComponent_Factory(t) { return ɵDwEmailContainerSectionConfigComponent_BaseFactory(t || DwEmailContainerSectionConfigComponent); };
DwEmailContainerSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailContainerSectionConfigComponent, selectors: [["dw-email-container-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 2, consts: [["dwRow", ""], ["dwCol", "12"], [1, "label"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function DwEmailContainerSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵtext(4, "Section Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailContainerSectionConfigComponent_Template_input_ngModelChange_5_listener($event) { return ctx.config.sectionName = $event; })("ngModelChange", function DwEmailContainerSectionConfigComponent_Template_input_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 0);
        ɵngcc0.ɵɵelementStart(7, "div", 1);
        ɵngcc0.ɵɵelementStart(8, "label", 2);
        ɵngcc0.ɵɵtext(9, "Columns");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailContainerSectionConfigComponent_Template_input_ngModelChange_10_listener($event) { return ctx.config.configData.columnsConfig.columns = $event; })("ngModelChange", function DwEmailContainerSectionConfigComponent_Template_input_ngModelChange_10_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.sectionName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.configData.columnsConfig.columns);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwNumericDirective], encapsulation: 2 });

var __decorate$1W = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1u = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEmailContainerSectionComponent = class DwEmailContainerSectionComponent {
    constructor(dwDragDropService, stateService) {
        this.dwDragDropService = dwDragDropService;
        this.stateService = stateService;
        this.columnPreferences = [];
    }
    ngOnInit() {
        this.setupColumns();
        this.stateService.getSectionConfigUpdates(this.sectionConfig.sectionKey)
            .subscribe(result => {
            this.setupColumns();
        });
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.setupColumns();
        }
    }
    setupColumns() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!((_b = (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.configData) === null || _b === void 0 ? void 0 : _b.columnsConfig) || !((_d = (_c = this.sectionConfig) === null || _c === void 0 ? void 0 : _c.configData) === null || _d === void 0 ? void 0 : _d.columnsConfig.columns)) {
            this.sectionConfig.configData = this.sectionConfig.configData || {};
            this.sectionConfig.configData.columnsConfig = {
                columns: 1,
                columnDetails: []
            };
        }
        this.sectionConfig.configData.columnsConfig.columnDetails = ((_f = (_e = this.sectionConfig) === null || _e === void 0 ? void 0 : _e.configData) === null || _f === void 0 ? void 0 : _f.columnsConfig.columnDetails) || [];
        if (!((_h = (_g = this.sectionConfig) === null || _g === void 0 ? void 0 : _g.configData) === null || _h === void 0 ? void 0 : _h.columns)) {
            this.sectionConfig.configData.columns = [];
        }
        if (this.sectionConfig.configData.columns.length < this.sectionConfig.configData.columnsConfig.columns) {
            this.sectionConfig.configData.columns.length = this.sectionConfig.configData.columnsConfig.columns;
            for (let i = 0; i < this.sectionConfig.configData.columnsConfig.columns; i++) {
                this.sectionConfig.configData.columns[i] = this.sectionConfig.configData.columns[i] || { sections: [] };
            }
        }
        // Setup Column Styles
        let index = 0;
        const regularColumnSize = 12 / this.sectionConfig.configData.columnsConfig.columns;
        for (const column of this.sectionConfig.configData.columns) {
            let columnPreference = Object.assign({}, this.sectionConfig.configData.columnsConfig.columnDetails[index]) || {};
            if (!columnPreference.columnSize) {
                columnPreference.columnSize = regularColumnSize;
            }
            this.columnPreferences[index] = columnPreference;
            index++;
        }
    }
};
DwEmailContainerSectionComponent.ɵfac = function DwEmailContainerSectionComponent_Factory(t) { return new (t || DwEmailContainerSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwPageDesignerDragDropService), ɵngcc0.ɵɵdirectiveInject(DwPageDesignerStateService)); };
DwEmailContainerSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailContainerSectionComponent, selectors: [["dw-email-container-section"]], viewQuery: function DwEmailContainerSectionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CdkDropList, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropList = _t.first);
    } }, inputs: { sectionConfig: "sectionConfig" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [["dwRow", ""], [4, "ngFor", "ngForOf"], [3, "dwCol", "dwColWidth", "dwColClass", 4, "ngIf"], [3, "dwCol", "dwColWidth", "dwColClass"], [3, "sections", "parentSectionConfig"]], template: function DwEmailContainerSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwEmailContainerSectionComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sectionConfig == null ? null : ctx.sectionConfig.configData == null ? null : ctx.sectionConfig.configData.columns);
    } }, directives: function () { return [DwRowDirective, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwColDirective, DwPageDesignerContainerComponent]; }, encapsulation: 2 });
DwEmailContainerSectionComponent.ctorParameters = () => [
    { type: DwPageDesignerDragDropService },
    { type: DwPageDesignerStateService }
];
DwEmailContainerSectionComponent.propDecorators = {
    sectionConfig: [{ type: Input }],
    dropList: [{ type: ViewChild, args: [CdkDropList,] }]
};
DwEmailContainerSectionComponent = __decorate$1W([
    DwComponent({
        key: 'dwEmailContainerSection',
        name: 'Container',
        componentType: DwComponentType.emailDesignSection,
        isGlobal: true,
        configComponent: DwEmailContainerSectionConfigComponent,
        configData: {
            hasChildren: true,
            childrenPropertyName: 'sections',
            toolbarDisplay: 'Container',
            toolbarIconCss: 'fa fa-box',
            toolbarGroupName: 'Layout',
            getChildSections: getEmailChildSections,
            createSectionDef: createEmailSectionDef
        }
    }),
    __metadata$1u("design:paramtypes", [DwPageDesignerDragDropService, DwPageDesignerStateService])
], DwEmailContainerSectionComponent);
function getEmailChildSections(sectionConfig) {
    var _a;
    const sections = [];
    for (const column of ((_a = sectionConfig.configData) === null || _a === void 0 ? void 0 : _a.columns) || []) {
        sections.push(...column.sections);
    }
    return sections;
}
function createEmailSectionDef(params) {
    return {
        sectionKey: '',
        sectionType: params.key,
        sectionName: params.name,
        configData: {
            columns: [
                {
                    sections: []
                }
            ],
            columnsConfig: {
                columns: 1,
                columnDetails: []
            }
        }
    };
}

class DwEmailTextSectionConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
DwEmailTextSectionConfigComponent.ɵfac = function DwEmailTextSectionConfigComponent_Factory(t) { return ɵDwEmailTextSectionConfigComponent_BaseFactory(t || DwEmailTextSectionConfigComponent); };
DwEmailTextSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTextSectionConfigComponent, selectors: [["dw-email-text-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 2, consts: [["class2", "pd-config-panel"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngModel", "ngModelChange"]], template: function DwEmailTextSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "Section Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailTextSectionConfigComponent_Template_input_ngModelChange_5_listener($event) { return ctx.config.sectionName = $event; })("ngModelChange", function DwEmailTextSectionConfigComponent_Template_input_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelementStart(8, "label", 3);
        ɵngcc0.ɵɵtext(9, "Text");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "dw-html-edit", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwEmailTextSectionConfigComponent_Template_dw_html_edit_ngModelChange_10_listener($event) { return ctx.config.configData.html = $event; })("ngModelChange", function DwEmailTextSectionConfigComponent_Template_dw_html_edit_ngModelChange_10_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.sectionName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.configData.html);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwHtmlEditComponent], encapsulation: 2 });

var __decorate$1X = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1v = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEmailTextSectionComponent = class DwEmailTextSectionComponent {
    constructor() { }
    ngOnInit() {
        // this.sectionConfig.config.html
    }
};
DwEmailTextSectionComponent.ɵfac = function DwEmailTextSectionComponent_Factory(t) { return new (t || DwEmailTextSectionComponent)(); };
DwEmailTextSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTextSectionComponent, selectors: [["dw-email-text-section"]], inputs: { sectionConfig: "sectionConfig" }, decls: 1, vars: 1, consts: [[3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "ngModel", "ngModelChange"]], template: function DwEmailTextSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwEmailTextSectionComponent_dw_html_view_0_Template, 1, 1, "dw-html-view", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.sectionConfig == null ? null : ctx.sectionConfig.configData == null ? null : ctx.sectionConfig.configData.html);
    } }, directives: [ɵngcc4.NgIf, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [""] });
DwEmailTextSectionComponent.ctorParameters = () => [];
DwEmailTextSectionComponent.propDecorators = {
    sectionConfig: [{ type: Input }]
};
DwEmailTextSectionComponent = __decorate$1X([
    DwComponent({
        key: 'dwEmailTextSection',
        name: 'E-mail Text Section',
        componentType: DwComponentType.emailDesignSection,
        configComponent: DwEmailTextSectionConfigComponent,
        isGlobal: true,
        configData: {
            toolbarDisplay: 'Text',
            toolbarIconCss: 'fa fa-text',
            toolbarGroupName: 'Standard',
            createSectionDef: createTextSectionDef
        }
    }),
    __metadata$1v("design:paramtypes", [])
], DwEmailTextSectionComponent);
function createTextSectionDef(params) {
    return {
        sectionKey: '',
        sectionType: params.key,
        sectionName: params.name,
        configData: {
            html: 'This is a new text section!'
        }
    };
}

var __decorate$1Y = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1w = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwPageDesignerSectionWrapperComponent {
    constructor(dwPageDesignerStateService, dwDragDropService) {
        this.dwPageDesignerStateService = dwPageDesignerStateService;
        this.dwDragDropService = dwDragDropService;
        this.removeSection = new EventEmitter();
        this.preventRemove = false;
        this.preventMove = false;
        this.sectionSelected = false;
        this.showAllBorders = false;
        this.allowDropPredicate = (drag, drop) => {
            return this.isDropAllowed(drag, drop);
        };
    }
    ngOnChanges(changes) {
        this.setupDesigner();
    }
    ngOnInit() {
        this.setupDesigner();
        this.dwPageDesignerStateService.stateChanged.subscribe(state => {
            var _a;
            this.selectedSectionKey = state.selectedSectionConfigKey;
            this.showAllBorders = state.showAllBorders;
            this.sectionSelected = (this.selectedSectionKey == ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.sectionKey));
        });
    }
    setupDesigner() {
        var _a, _b;
        if (!((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.sectionType)) {
            return;
        }
        this.sectionDef = this.dwPageDesignerStateService.getSectionDef((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.sectionType);
        this.sectionDef.configData.toolbarIconCss;
    }
    configureCustomConfig(componentInstance) {
        componentInstance.sectionConfig = this.sectionConfig;
    }
    selectSection(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        this.dwPageDesignerStateService.setSelectedSection(this.sectionConfig.sectionKey);
    }
    configurationSection() {
        this.dwPageDesignerStateService.setCurrentSectionConfig(this.sectionConfig.sectionKey);
    }
    onSectionDrop(event) {
        this.dwDragDropService.handleSectionDrop(event);
    }
    isDropAllowed(drag, drop) {
        if (this.dwDragDropService.currentHoverDropListId == null) {
            return true;
        }
        return drop.id === this.dwDragDropService.currentHoverDropListId;
    }
    dragMoved(event) {
        this.dwDragDropService.dragMoved(event);
    }
    dragReleased(event) {
        this.dwDragDropService.dragReleased(event);
    }
    onRemoveSection(section) {
        this.removeSection.emit(section);
    }
}
DwPageDesignerSectionWrapperComponent.ɵfac = function DwPageDesignerSectionWrapperComponent_Factory(t) { return new (t || DwPageDesignerSectionWrapperComponent)(ɵngcc0.ɵɵdirectiveInject(DwPageDesignerStateService), ɵngcc0.ɵɵdirectiveInject(DwPageDesignerDragDropService)); };
DwPageDesignerSectionWrapperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPageDesignerSectionWrapperComponent, selectors: [["dw-page-designer-section-wrapper"]], inputs: { preventRemove: "preventRemove", preventMove: "preventMove", sectionConfig: "sectionConfig" }, outputs: { removeSection: "removeSection" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 16, vars: 18, consts: [["cdkDrag", "", "cdkDragPreviewClass2", "hide-preview", 1, "pd-section", 3, "ngClass", "cdkDragData", "cdkDragDisabled", "cdkDragMoved", "cdkDragReleased", "click"], ["class", "pd-drop-section", 4, "cdkDragPlaceholder"], ["cdkDragPreview", "", 1, "pd-tool-item-placeholder2", 3, "hidden"], [1, "pd-tool-item-icon", 3, "ngClass"], [1, "pd-tool-item-text"], [1, "pd-section-header", 3, "ngClass"], ["cdkDragHandle", "", 1, "pull-left", "pd-section-header-title"], ["class", "fa fa-grip-vertical pd-section-icon", 3, "hidden", 4, "ngIf"], [1, "pd-section-icon", 3, "ngClass"], [1, "pull-right"], ["title", "Configure Section", 1, "fa", "fa-cog", "pd-section-icon", 3, "hidden", "click"], ["tile", "Remove Section", 1, "fa", "fa-trash", "pd-section-icon", 3, "hidden", "click"], ["cdkDragHandle", "", 1, "pd-section-inner"], [3, "component", "configure", 4, "ngIf"], [1, "pd-drop-section"], [1, "fa", "fa-grip-vertical", "pd-section-icon", 3, "hidden"], [3, "component", "configure"]], template: function DwPageDesignerSectionWrapperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("cdkDragMoved", function DwPageDesignerSectionWrapperComponent_Template_div_cdkDragMoved_0_listener($event) { return ctx.dragMoved($event); })("cdkDragReleased", function DwPageDesignerSectionWrapperComponent_Template_div_cdkDragReleased_0_listener($event) { return ctx.dragReleased($event); })("click", function DwPageDesignerSectionWrapperComponent_Template_div_click_0_listener($event) { return ctx.selectSection($event); });
        ɵngcc0.ɵɵtemplate(1, DwPageDesignerSectionWrapperComponent_div_1_Template, 2, 0, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, DwPageDesignerSectionWrapperComponent_i_8_Template, 1, 1, "i", 7);
        ɵngcc0.ɵɵelement(9, "i", 8);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵelementStart(12, "i", 10);
        ɵngcc0.ɵɵlistener("click", function DwPageDesignerSectionWrapperComponent_Template_i_click_12_listener() { return ctx.configurationSection(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "i", 11);
        ɵngcc0.ɵɵlistener("click", function DwPageDesignerSectionWrapperComponent_Template_i_click_13_listener() { return ctx.onRemoveSection(ctx.sectionConfig); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 12);
        ɵngcc0.ɵɵtemplate(15, DwPageDesignerSectionWrapperComponent_dw_dynamic_loader_15_Template, 1, 1, "dw-dynamic-loader", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c83, ctx.sectionSelected || ctx.showAllBorders))("cdkDragData", ctx.sectionConfig)("cdkDragDisabled", ctx.preventMove);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.sectionDef.configData.toolbarIconCss);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.sectionDef.configData.toolbarDisplay, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c84, ctx.sectionSelected || ctx.showAllBorders));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.sectionDef.configData.toolbarIconCss);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate2(" ", ctx.sectionConfig.sectionName, " (", ctx.sectionDef.configData.toolbarDisplay, ") ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.sectionDef == null ? null : ctx.sectionDef.configComponent));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.preventRemove);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sectionDef == null ? null : ctx.sectionDef.component);
    } }, directives: [ɵngcc28.CdkDrag, ɵngcc4.NgClass, ɵngcc28.CdkDragPlaceholder, ɵngcc28.CdkDragHandle, ɵngcc4.NgIf, DwDynamicLoaderComponent], styles: [""] });
DwPageDesignerSectionWrapperComponent.ctorParameters = () => [
    { type: DwPageDesignerStateService },
    { type: DwPageDesignerDragDropService }
];
DwPageDesignerSectionWrapperComponent.propDecorators = {
    sectionConfig: [{ type: Input }],
    removeSection: [{ type: Output }],
    preventRemove: [{ type: Input }],
    preventMove: [{ type: Input }]
};
__decorate$1Y([
    DwInputConverter(booleanConverter),
    __metadata$1w("design:type", Boolean)
], DwPageDesignerSectionWrapperComponent.prototype, "preventRemove", void 0);
__decorate$1Y([
    DwInputConverter(booleanConverter),
    __metadata$1w("design:type", Boolean)
], DwPageDesignerSectionWrapperComponent.prototype, "preventMove", void 0);

class DwPageDesignerToolbarComponent {
    constructor(dwDragDropService, stateService) {
        this.dwDragDropService = dwDragDropService;
        this.stateService = stateService;
    }
    ngOnInit() {
    }
    dragMoved(event) {
        this.dwDragDropService.dragMoved(event);
    }
    dragReleased(event) {
        this.dwDragDropService.dragReleased(event);
        // this.dwDragDropService.dragEnd(event);
    }
    /** Predicate function that doesn't allow items to be dropped into a list. */
    noReturnPredicate() {
        return false;
    }
}
DwPageDesignerToolbarComponent.ɵfac = function DwPageDesignerToolbarComponent_Factory(t) { return new (t || DwPageDesignerToolbarComponent)(ɵngcc0.ɵɵdirectiveInject(DwPageDesignerDragDropService), ɵngcc0.ɵɵdirectiveInject(DwPageDesignerStateService)); };
DwPageDesignerToolbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPageDesignerToolbarComponent, selectors: [["dw-page-designer-toolbar"]], inputs: { pageDesignerConfig: "pageDesignerConfig" }, decls: 3, vars: 4, consts: [["cdkDropList", "", "id", "toolbar", "cdkDropListSortingDisabled", "", 3, "cdkDropListData", "cdkDropListEnterPredicate", "cdkDropListConnectedTo"], [1, "row"], ["class", "pd-tool-item", "cdkDrag", "", 3, "cdkDragData", "cdkDragMoved", "cdkDragReleased", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "pd-tool-item", 3, "cdkDragData", "cdkDragMoved", "cdkDragReleased"], ["class", "pd-drop-section", 4, "cdkDragPlaceholder"], ["class", "pd-tool-item-placeholder2", 4, "cdkDragPreview"], [1, "pd-tool-item-icon", 3, "ngClass"], [1, "pd-tool-item-text"], [1, "pd-drop-section"], [1, "pd-tool-item-placeholder2"]], template: function DwPageDesignerToolbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwPageDesignerToolbarComponent_div_2_Template, 6, 3, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkDropListData", ctx.pageDesignerConfig.sectionDefs)("cdkDropListEnterPredicate", ctx.noReturnPredicate)("cdkDropListConnectedTo", ctx.dwDragDropService.dropLists);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.pageDesignerConfig.sectionDefs);
    } }, directives: [ɵngcc28.CdkDropList, ɵngcc4.NgForOf, ɵngcc28.CdkDrag, ɵngcc28.CdkDragPlaceholder, ɵngcc28.CdkDragPreview, ɵngcc4.NgClass], styles: [""] });
DwPageDesignerToolbarComponent.ctorParameters = () => [
    { type: DwPageDesignerDragDropService },
    { type: DwPageDesignerStateService }
];
DwPageDesignerToolbarComponent.propDecorators = {
    pageDesignerConfig: [{ type: Input }]
};

class DwPageDesignerConfigPanelComponent {
    constructor(dwPageDesignerStateService) {
        this.dwPageDesignerStateService = dwPageDesignerStateService;
    }
    ngOnInit() {
        this.dwPageDesignerStateService.stateChanged.subscribe(state => {
            this.setConfigComponent(state.currentSectionConfigKey);
        });
    }
    setConfigComponent(sectionKey) {
        if (!sectionKey) {
            this.sectionDef = null;
            this.sectionConfig = null;
            return;
        }
        this.sectionConfig = this.dwPageDesignerStateService.getSectionConfig(sectionKey);
        this.sectionDef = this.dwPageDesignerStateService.getSectionDef(this.sectionConfig.sectionType);
    }
    onSectionConfigChange() {
        this.dwPageDesignerStateService.publishSectionConfigUpdate(this.sectionConfig.sectionKey);
    }
}
DwPageDesignerConfigPanelComponent.ɵfac = function DwPageDesignerConfigPanelComponent_Factory(t) { return new (t || DwPageDesignerConfigPanelComponent)(ɵngcc0.ɵɵdirectiveInject(DwPageDesignerStateService)); };
DwPageDesignerConfigPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPageDesignerConfigPanelComponent, selectors: [["dw-page-designer-config-panel"]], decls: 2, vars: 1, consts: [[4, "ngIf"], [3, "component", "config", "configContext", "configChange"]], template: function DwPageDesignerConfigPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, DwPageDesignerConfigPanelComponent_ng_container_1_Template, 2, 3, "ng-container", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sectionDef == null ? null : ctx.sectionDef.configComponent);
    } }, directives: [ɵngcc4.NgIf, DwUiChildConfigHostComponent], styles: [""] });
DwPageDesignerConfigPanelComponent.ctorParameters = () => [
    { type: DwPageDesignerStateService }
];

var __decorate$1Z = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1x = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEmailTemplateDividerSectionComponent = class DwEmailTemplateDividerSectionComponent {
    constructor() { }
    ngOnInit() {
    }
};
DwEmailTemplateDividerSectionComponent.ɵfac = function DwEmailTemplateDividerSectionComponent_Factory(t) { return new (t || DwEmailTemplateDividerSectionComponent)(); };
DwEmailTemplateDividerSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateDividerSectionComponent, selectors: [["dw-email-template-divider-section"]], decls: 1, vars: 0, template: function DwEmailTemplateDividerSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "hr");
    } }, encapsulation: 2 });
DwEmailTemplateDividerSectionComponent.ctorParameters = () => [];
DwEmailTemplateDividerSectionComponent = __decorate$1Z([
    DwComponent({
        key: 'dwEmailDividerSection',
        name: 'E-mail Divider Section',
        componentType: DwComponentType.emailDesignSection,
        isGlobal: true,
        configData: {
            toolbarDisplay: 'Divider',
            toolbarIconCss: 'fa fa-horizontal-rule',
            toolbarGroupName: 'Standard',
            createSectionDef: createDividerSectionDef
        }
    }),
    __metadata$1x("design:paramtypes", [])
], DwEmailTemplateDividerSectionComponent);
function createDividerSectionDef(params) {
    return {
        sectionKey: '',
        sectionType: params.key,
        sectionName: params.name,
        configData: {}
    };
}

class DwPageDesignerContainerComponent {
    constructor(dwDragDropService, stateService) {
        this.dwDragDropService = dwDragDropService;
        this.stateService = stateService;
        this.allowDropPredicate = (drag, drop) => {
            return this.isDropAllowed(drag, drop);
        };
    }
    ngOnInit() {
        if (!this.sections) {
            this.sections = [];
        }
        this.stateService.stateChanged.subscribe(state => {
            this.pageDesignerConfig = state.pageDesignerConfig;
        });
    }
    ngAfterViewInit() {
        if (this.dropList) {
            this.dwDragDropService.register(this.dropList);
        }
    }
    onSectionDrop(event) {
        this.dwDragDropService.handleSectionDrop(event);
    }
    showAddSection(event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
    }
    isDropAllowed(drag, drop) {
        let result;
        if (this.dwDragDropService.currentHoverDropListId == null) {
            result = true;
        }
        else {
            result = (drop.id === this.dwDragDropService.currentHoverDropListId);
        }
        console.log(`IsDropAllowed:   result: ${result} Id: ${drop.id}  Hover Id: ${this.dwDragDropService.currentHoverDropListId}`);
        // result = true;
        return result;
    }
    dragMoved(event) {
        this.dwDragDropService.dragMoved(event);
        this.dwDragDropService.dragStart(event);
    }
    dragReleased(event) {
        this.dwDragDropService.dragReleased(event);
        this.dwDragDropService.dragEnd(event);
    }
    removeSection(section) {
        const index = this.sections.indexOf(section);
        this.sections.splice(index, 1);
    }
    closePopup() {
    }
}
DwPageDesignerContainerComponent.ɵfac = function DwPageDesignerContainerComponent_Factory(t) { return new (t || DwPageDesignerContainerComponent)(ɵngcc0.ɵɵdirectiveInject(DwPageDesignerDragDropService), ɵngcc0.ɵɵdirectiveInject(DwPageDesignerStateService)); };
DwPageDesignerContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwPageDesignerContainerComponent, selectors: [["dw-page-designer-container"]], viewQuery: function DwPageDesignerContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CdkDropList, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dropList = _t.first);
    } }, inputs: { sections: "sections", parentSectionConfig: "parentSectionConfig" }, decls: 9, vars: 15, consts: [["cdkDropList", "", "style2", "background-color:goldenrod;min-height:400px", "style2", "min-height: 200px; min-width:500px; overflow:hidden", 1, "pd-container-section", 3, "id", "cdkDropListData", "ngClass", "cdkDropListConnectedTo", "cdkDropListEnterPredicate", "cdkDropListDropped"], ["style2", "background-color:aliceblue;"], [4, "ngFor", "ngForOf"], [1, "pd-add-section", "on-hover", 3, "hidden"], [4, "ngIf"], ["title", "Add Section", 1, "fa", "fa-plus-circle", "pd-section-icon", "on-hover-item", 3, "click"], [3, "showCloseIcon", "dismissable", "onHide"], ["addSectionPanel", ""], ["pTemplate", ""], [3, "sectionConfig", "removeSection"], [3, "pageDesignerConfig"]], template: function DwPageDesignerContainerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r7 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("cdkDropListDropped", function DwPageDesignerContainerComponent_Template_div_cdkDropListDropped_0_listener($event) { return ctx.onSectionDrop($event); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwPageDesignerContainerComponent_ng_container_2_Template, 3, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DwPageDesignerContainerComponent_ng_container_4_Template, 2, 0, "ng-container", 4);
        ɵngcc0.ɵɵelementStart(5, "i", 5);
        ɵngcc0.ɵɵlistener("click", function DwPageDesignerContainerComponent_Template_i_click_5_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const _r2 = ɵngcc0.ɵɵreference(7); return _r2.show($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "p-overlayPanel", 6, 7);
        ɵngcc0.ɵɵlistener("onHide", function DwPageDesignerContainerComponent_Template_p_overlayPanel_onHide_6_listener() { ɵngcc0.ɵɵrestoreView(_r7); const _r2 = ɵngcc0.ɵɵreference(7); return _r2.hide(); });
        ɵngcc0.ɵɵtemplate(8, DwPageDesignerContainerComponent_ng_template_8_Template, 2, 1, "ng-template", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.parentSectionConfig == null ? null : ctx.parentSectionConfig.sectionName)("cdkDropListData", ctx.sections)("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c85, ctx.dwDragDropService.isDragging))("cdkDropListConnectedTo", ctx.dwDragDropService.dropLists)("cdkDropListEnterPredicate", ctx.allowDropPredicate);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sections);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.dwDragDropService.isDragging);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sections || ctx.sections.length == 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(14, _c86));
        ɵngcc0.ɵɵproperty("showCloseIcon", true)("dismissable", false);
    } }, directives: [ɵngcc28.CdkDropList, ɵngcc4.NgClass, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc31.OverlayPanel, ɵngcc6.PrimeTemplate, DwPageDesignerSectionWrapperComponent, DwPageDesignerToolbarComponent], styles: [""] });
DwPageDesignerContainerComponent.ctorParameters = () => [
    { type: DwPageDesignerDragDropService },
    { type: DwPageDesignerStateService }
];
DwPageDesignerContainerComponent.propDecorators = {
    sections: [{ type: Input }],
    parentSectionConfig: [{ type: Input }],
    dropList: [{ type: ViewChild, args: [CdkDropList,] }]
};

class DwOrderedListComponent {
    constructor() {
        this.itemOrderChange = new EventEmitter();
        this.useVisibleIndexes = false;
        this.visibleIndexes = [];
        this.itemRemoved = new EventEmitter();
        this.itemsChange = new EventEmitter();
    }
    ngOnInit() {
    }
    drop(event) {
        moveItemInArray(this.items, event.previousIndex, event.currentIndex);
        this.itemOrderChange.emit();
        this.itemsChange.emit(this.items);
    }
    removeItem(item) {
        var index = this.items.indexOf(item);
        if (index >= 0)
            this.items.splice(index, 1);
        this.itemRemoved.emit(item);
        this.itemsChange.emit(this.items);
    }
}
DwOrderedListComponent.ɵfac = function DwOrderedListComponent_Factory(t) { return new (t || DwOrderedListComponent)(); };
DwOrderedListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwOrderedListComponent, selectors: [["dw-ordered-list"]], contentQueries: function DwOrderedListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵstaticContentQuery(dirIndex, DwListItemDirective, true, TemplateRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listItemTemplate = _t.first);
    } }, inputs: { useVisibleIndexes: "useVisibleIndexes", visibleIndexes: "visibleIndexes", items: "items" }, outputs: { itemOrderChange: "itemOrderChange", itemRemoved: "itemRemoved", itemsChange: "itemsChange" }, decls: 2, vars: 1, consts: [["cdkDropList", "", 1, "dw-ordered-list", 3, "cdkDropListDropped"], ["class", "dw-ordered-box", "cdkDrag", "", 3, "hidden", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "dw-ordered-box", 3, "hidden"], ["class", "dw-ordered-custom-placeholder", 4, "cdkDragPlaceholder"], ["cdkDragHandle", "", 1, "drag-handle-column"], [1, "fa", "fa-grip-vertical", "fa-2x"], [1, "main-column"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "remove-column"], [1, "fa", "fa-times", 3, "click"], [1, "dw-ordered-custom-placeholder"]], template: function DwOrderedListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("cdkDropListDropped", function DwOrderedListComponent_Template_div_cdkDropListDropped_0_listener($event) { return ctx.drop($event); });
        ɵngcc0.ɵɵtemplate(1, DwOrderedListComponent_div_1_Template, 8, 6, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc28.CdkDropList, ɵngcc4.NgForOf, ɵngcc28.CdkDrag, ɵngcc28.CdkDragPlaceholder, ɵngcc28.CdkDragHandle, ɵngcc4.NgTemplateOutlet], styles: [".dw-ordered-list[_ngcontent-%COMP%]{background:#fff;border:1px solid #ccc;border-radius:4px;display:block;max-width:100%;min-height:60px;overflow:hidden;width:100%}.dw-ordered-box[_ngcontent-%COMP%]{align-items:center;background:#fff;border-bottom:1px solid #ccc;box-sizing:border-box;color:rgba(0,0,0,.87);cursor:move;display:flex;flex-direction:row;font-size:14px;justify-content:space-between;padding:5px}.cdk-drag-preview[_ngcontent-%COMP%]{border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box;z-index:9000!important}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}.dw-ordered-box[_ngcontent-%COMP%]:last-child{border:none}.dw-ordered-custom-placeholder[_ngcontent-%COMP%], .dw-ordered-list.cdk-drop-list-dragging[_ngcontent-%COMP%]   .dw-ordered-box[_ngcontent-%COMP%]:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.dw-ordered-custom-placeholder[_ngcontent-%COMP%]{background:#ccc;border:3px dotted #999;min-height:60px}.drag-handle-column[_ngcontent-%COMP%]{float:left;width:20px}.remove-column[_ngcontent-%COMP%]{cursor:pointer;float:left;font-size:1.3em;height:50px;margin-right:3px;padding-top:10px;text-align:left;vertical-align:middle;width:10px}.main-column[_ngcontent-%COMP%]{float:left;padding-left:10px;padding-right:10px;width:calc(100% - 35px)}"] });
DwOrderedListComponent.ctorParameters = () => [];
DwOrderedListComponent.propDecorators = {
    items: [{ type: Input }],
    itemOrderChange: [{ type: Output }],
    useVisibleIndexes: [{ type: Input }],
    visibleIndexes: [{ type: Input }],
    itemRemoved: [{ type: Output }],
    itemsChange: [{ type: Output }],
    listItemTemplate: [{ type: ContentChild, args: [DwListItemDirective, { static: true, read: TemplateRef },] }]
};

class DwSectionConfigPanelComponent {
    constructor(dwSectionConfigStateService) {
        this.dwSectionConfigStateService = dwSectionConfigStateService;
        this.showComponent = true;
        this.ignoreFormUpdate = true;
        this.subscriptions = [];
    }
    ngOnInit() {
        // this.setupFormGroup();
        var _a, _b;
        this.subscriptions.push(this.dwSectionConfigStateService.stateChanged().subscribe(state => {
            this.setCurrentSection(state.currentSection);
        }));
        if ((_a = this.dwSectionConfigStateService.state) === null || _a === void 0 ? void 0 : _a.currentSection) {
            this.setCurrentSection((_b = this.dwSectionConfigStateService.state) === null || _b === void 0 ? void 0 : _b.currentSection);
        }
    }
    ngOnDestroy() {
        // Unsubscribe from any previous subscription
        if (this.componentSubscription) {
            this.componentSubscription.unsubscribe();
        }
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setCurrentSection(section) {
        if (this.currentSection == section) {
            return;
        }
        this.debugSection = deepCopy(section);
        if (this.debugSection) {
            this.debugSection['sections'] = null;
        }
        this.currentSection = section;
        if (!section) {
            this.showComponent = false;
            this.component = null;
            return;
        }
        const newComponent = this.determineComponent(this.currentSection);
        this.ignoreFormUpdate = true;
        if (this.component == newComponent && this.componentInstance) {
            this.showComponent = false;
            this.componentInstance = null;
            setTimeout(() => {
                this.showComponent = true;
            });
        }
        this.component = newComponent;
    }
    configureComponent(componentInstance) {
        this.componentInstance = componentInstance;
        this.componentInstance.itemMetaDataList = this.dwSectionConfigStateService.state.itemMetaDataList;
        // TODO: Add context to part of data configuration/state
        this.componentInstance.contextNames = this.dwSectionConfigStateService.state.preferences.contextNames;
        this.componentInstance.rootItemName = this.dwSectionConfigStateService.state.itemName;
        // this.componentInstance.formGroup = this.formGroup;
        this.componentInstance.preferences = this.dwSectionConfigStateService.state.preferences;
        this.componentInstance.section = this.currentSection;
        this.componentInstance.setupComplete();
        // this.componentInstance.contextNames = this.dwMetadataFormUtilService.getAllContextNames(this.preferences);
        // Unsubscribe from any previous subscription
        if (this.componentSubscription) {
            this.componentSubscription.unsubscribe();
        }
        this.componentSubscription = this.componentInstance.sectionChange
            .subscribe(sectionChange => {
            this.dwSectionConfigStateService.updateSection(sectionChange);
            // TODO - update CDR
            // this.cdr
        });
    }
    determineComponent(section) {
        if (!section) {
            return null;
        }
        const sectionDef = this.dwSectionConfigStateService.getSectionDef(section.sectionType);
        if (sectionDef) {
            return sectionDef.configComponent;
        }
        throw new Error(`No component registered for section type ${section.sectionType}`);
    }
}
DwSectionConfigPanelComponent.ɵfac = function DwSectionConfigPanelComponent_Factory(t) { return new (t || DwSectionConfigPanelComponent)(ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService)); };
DwSectionConfigPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSectionConfigPanelComponent, selectors: [["dw-section-config-panel"]], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "component", "configure"]], template: function DwSectionConfigPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwSectionConfigPanelComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showComponent);
    } }, directives: [ɵngcc4.NgIf, DwDynamicLoaderComponent], styles: [""] });
DwSectionConfigPanelComponent.ctorParameters = () => [
    { type: DwSectionConfigStateService }
];

class DwDataConfigPanelComponent {
    constructor(dwSectionConfigStateService, dwContextService, dwDataVariableService, uiConfigRegistry) {
        this.dwSectionConfigStateService = dwSectionConfigStateService;
        this.dwContextService = dwContextService;
        this.dwDataVariableService = dwDataVariableService;
        this.uiConfigRegistry = uiConfigRegistry;
    }
    ngOnInit() {
        this.preferences = this.dwSectionConfigStateService.state.preferences;
        this.itemName = this.dwSectionConfigStateService.state.itemName;
        this.configKey = this.dwSectionConfigStateService.state.configKey;
        this.setupVariableContextDefinition();
    }
    onChange() {
        this.dwSectionConfigStateService.state.preferences = this.preferences;
        this.dwSectionConfigStateService.stateChanged();
    }
    onVariableConfigChange() {
        this.setupVariableContextDefinition();
        this.onChange();
    }
    setupVariableContextDefinition() {
        var _a;
        // Need to update the registration for the data context
        const contextDef = this.dwDataVariableService.registerVariableDataContext(this.preferences.variableConfig, this.itemName, this.configKey);
        const index = this.preferences.requiredContextNames.indexOf(contextDef.contextName);
        const requireVaraibleContext = ((_a = contextDef.attributes) === null || _a === void 0 ? void 0 : _a.length) > 0;
        let modified = false;
        if (requireVaraibleContext) {
            if (index == -1) {
                this.preferences.requiredContextNames.push(contextDef.contextName);
                modified = true;
            }
        }
        else {
            if (index >= 0) {
                this.preferences.requiredContextNames.splice(index, 1);
                modified = true;
            }
        }
        if (modified) {
            this.preferences.requiredContextNames = [...this.preferences.requiredContextNames];
            this.onChange();
        }
    }
}
DwDataConfigPanelComponent.ɵfac = function DwDataConfigPanelComponent_Factory(t) { return new (t || DwDataConfigPanelComponent)(ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwDataVariableService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwDataConfigPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDataConfigPanelComponent, selectors: [["dw-data-config-panel"]], decls: 14, vars: 6, consts: [["header", "Data Setup"], ["dwRow", ""], ["dwCol", "12"], [3, "ngModel", "itemName", "ngModelChange"], [3, "ngModel", "itemName", "requiredContextNames", "ngModelChange"], ["header", "Variables"], [3, "variableConfig", "variableConfigChange"]], template: function DwDataConfigPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-tabView");
        ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵtext(5, "Data Source");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "dw-datasource-select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwDataConfigPanelComponent_Template_dw_datasource_select_ngModelChange_6_listener($event) { return ctx.preferences.dataSourceName = $event; })("ngModelChange", function DwDataConfigPanelComponent_Template_dw_datasource_select_ngModelChange_6_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 1);
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Context Data");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "dw-context-def-multi-select", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwDataConfigPanelComponent_Template_dw_context_def_multi_select_ngModelChange_11_listener($event) { return ctx.preferences.contextNames = $event; })("ngModelChange", function DwDataConfigPanelComponent_Template_dw_context_def_multi_select_ngModelChange_11_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p-tabPanel", 5);
        ɵngcc0.ɵɵelementStart(13, "dw-data-variable-list-config", 6);
        ɵngcc0.ɵɵlistener("variableConfigChange", function DwDataConfigPanelComponent_Template_dw_data_variable_list_config_variableConfigChange_13_listener($event) { return ctx.preferences.variableConfig = $event; })("variableConfigChange", function DwDataConfigPanelComponent_Template_dw_data_variable_list_config_variableConfigChange_13_listener() { return ctx.onVariableConfigChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.dataSourceName)("itemName", ctx.itemName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.contextNames)("itemName", ctx.itemName)("requiredContextNames", ctx.preferences.requiredContextNames);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("variableConfig", ctx.preferences.variableConfig);
    } }, directives: function () { return [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwDatasourceSelectComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwContextDefMultiSelectComponent, DwDataVariableListConfigComponent]; }, styles: [""] });
DwDataConfigPanelComponent.ctorParameters = () => [
    { type: DwSectionConfigStateService },
    { type: DwContextService },
    { type: DwDataVariableService },
    { type: DwUiConfigRegistryService }
];

class DwFormeventsConfigPanelComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwFormeventsConfigPanelComponent.ɵfac = function DwFormeventsConfigPanelComponent_Factory(t) { return new (t || DwFormeventsConfigPanelComponent)(); };
DwFormeventsConfigPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormeventsConfigPanelComponent, selectors: [["dw-dw-formevents-config-panel"]], decls: 2, vars: 0, template: function DwFormeventsConfigPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-formevents-config-panel works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwFormeventsConfigPanelComponent.ctorParameters = () => [];

class DwSecurityConfigPanelComponent {
    constructor(dwSectionConfigStateService, dwRulesService) {
        this.dwSectionConfigStateService = dwSectionConfigStateService;
        this.dwRulesService = dwRulesService;
    }
    ngOnInit() {
        this.preferences = this.dwSectionConfigStateService.state.preferences;
        this.preferences.useCanEditExpression = this.preferences.useCanEditExpression || false;
        this.preferences.useCanAddExpression = this.preferences.useCanAddExpression || false;
        this.preferences.useCanViewExpression = this.preferences.useCanViewExpression || false;
        this.contextNames = this.preferences.contextNames;
        this.itemName = this.dwSectionConfigStateService.state.itemName;
        this.dwRulesService.getRules(this.dwSectionConfigStateService.state.itemName)
            .subscribe(rules => {
            this.rules = rules;
        });
        this.dwSectionConfigStateService.state.preferences.canAddRuleKey;
    }
    onChange() {
        this.dwSectionConfigStateService.state.preferences = this.preferences;
        this.dwSectionConfigStateService.stateChanged();
    }
}
DwSecurityConfigPanelComponent.ɵfac = function DwSecurityConfigPanelComponent_Factory(t) { return new (t || DwSecurityConfigPanelComponent)(ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService), ɵngcc0.ɵɵdirectiveInject(DwRuleService)); };
DwSecurityConfigPanelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityConfigPanelComponent, selectors: [["dw-security-config-panel"]], decls: 56, vars: 24, consts: [["header", "Access Rules"], ["dwRow", ""], ["dwCol", "12"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden"], [1, "form-control", 3, "ngModel", "ngModelChange"], ["selected", "", 3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "preferences.useCanEditExpression", 3, "contextNames", "item"], ["formControlName", "preferences.canAddExpression", 3, "contextNames", "item"], ["formControlName", "preferences.canViewExpression", 3, "contextNames", "item"], [3, "ngValue"]], template: function DwSecurityConfigPanelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-tabView");
        ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵtext(5, "Can Edit - Use Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityConfigPanelComponent_Template_dw_yesno_ngModelChange_6_listener($event) { return ctx.preferences.useCanEditExpression = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Can Edit Rule");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "select", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityConfigPanelComponent_Template_select_ngModelChange_11_listener($event) { return ctx.preferences.canEditRuleKey = $event; })("ngModelChange", function DwSecurityConfigPanelComponent_Template_select_ngModelChange_11_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementStart(12, "option", 6);
        ɵngcc0.ɵɵtext(13, "None");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DwSecurityConfigPanelComponent_option_14_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 4);
        ɵngcc0.ɵɵelementStart(16, "div", 2);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Can Edit Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(19, "dw-expression-picker-control", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 1);
        ɵngcc0.ɵɵelementStart(21, "div", 2);
        ɵngcc0.ɵɵelementStart(22, "label");
        ɵngcc0.ɵɵtext(23, "Can Add - Use Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityConfigPanelComponent_Template_dw_yesno_ngModelChange_24_listener($event) { return ctx.preferences.useCanAddExpression = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 4);
        ɵngcc0.ɵɵelementStart(26, "div", 2);
        ɵngcc0.ɵɵelementStart(27, "label");
        ɵngcc0.ɵɵtext(28, "Can Add Rule");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "select", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityConfigPanelComponent_Template_select_ngModelChange_29_listener($event) { return ctx.preferences.canAddRuleKey = $event; })("ngModelChange", function DwSecurityConfigPanelComponent_Template_select_ngModelChange_29_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementStart(30, "option", 6);
        ɵngcc0.ɵɵtext(31, "None");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(32, DwSecurityConfigPanelComponent_option_32_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "div", 4);
        ɵngcc0.ɵɵelementStart(34, "div", 2);
        ɵngcc0.ɵɵelementStart(35, "label");
        ɵngcc0.ɵɵtext(36, "Can Add Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(37, "dw-expression-picker-control", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 1);
        ɵngcc0.ɵɵelementStart(39, "div", 2);
        ɵngcc0.ɵɵelementStart(40, "label");
        ɵngcc0.ɵɵtext(41, "Can View - Use Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityConfigPanelComponent_Template_dw_yesno_ngModelChange_42_listener($event) { return ctx.preferences.useCanViewExpression = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "div", 4);
        ɵngcc0.ɵɵelementStart(44, "div", 2);
        ɵngcc0.ɵɵelementStart(45, "label");
        ɵngcc0.ɵɵtext(46, "Can View Rule");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "select", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityConfigPanelComponent_Template_select_ngModelChange_47_listener($event) { return ctx.preferences.canViewRuleKey = $event; })("ngModelChange", function DwSecurityConfigPanelComponent_Template_select_ngModelChange_47_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementStart(48, "option", 6);
        ɵngcc0.ɵɵtext(49, "None");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(50, DwSecurityConfigPanelComponent_option_50_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(51, "div", 4);
        ɵngcc0.ɵɵelementStart(52, "div", 2);
        ɵngcc0.ɵɵelementStart(53, "label");
        ɵngcc0.ɵɵtext(54, "Can View Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(55, "dw-expression-picker-control", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.useCanEditExpression);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.preferences.useCanEditExpression);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.canEditRuleKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngValue", undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.rules);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.preferences.useCanEditExpression);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("item", ctx.itemName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.useCanAddExpression);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.preferences.useCanAddExpression);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.canAddRuleKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngValue", undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.rules);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.preferences.useCanAddExpression);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("item", ctx.itemName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.useCanViewExpression);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.preferences.useCanViewExpression);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.preferences.canViewRuleKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngValue", undefined);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.rules);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.preferences.useCanViewExpression);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("item", ctx.itemName);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf, DwExpressionPickerControlComponent, ɵngcc3.FormControlName], styles: [""] });
DwSecurityConfigPanelComponent.ctorParameters = () => [
    { type: DwSectionConfigStateService },
    { type: DwRuleService }
];

class DwConfigPanelHostComponent {
    constructor(dwSectionConfigStateService) {
        this.dwSectionConfigStateService = dwSectionConfigStateService;
    }
    ngOnInit() {
        var _a;
        this.dwSectionConfigStateService.stateChanged().subscribe(state => {
            this.setupConfigHost(state.currentSectionNode);
        });
        if ((_a = this.dwSectionConfigStateService.state) === null || _a === void 0 ? void 0 : _a.currentSection) {
            this.setupConfigHost(this.dwSectionConfigStateService.state.currentSectionNode);
        }
    }
    setupConfigHost(currentNode) {
        if (!currentNode) {
            this.currentNodeType = null;
            return;
        }
        this.currentNodeType = currentNode.type;
        switch (this.currentNodeType) {
            case DwSectionConfigNodeType.data:
                this.otherConfigComponent = DwDataConfigPanelComponent;
                break;
            case DwSectionConfigNodeType.events:
                this.otherConfigComponent = DwFormeventsConfigPanelComponent;
                break;
            case DwSectionConfigNodeType.security:
                this.otherConfigComponent = DwSecurityConfigPanelComponent;
                break;
        }
    }
}
DwConfigPanelHostComponent.ɵfac = function DwConfigPanelHostComponent_Factory(t) { return new (t || DwConfigPanelHostComponent)(ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService)); };
DwConfigPanelHostComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwConfigPanelHostComponent, selectors: [["dw-config-panel-host"]], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "component", 4, "ngIf"], [3, "component"]], template: function DwConfigPanelHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwConfigPanelHostComponent_dw_section_config_panel_0_Template, 1, 0, "dw-section-config-panel", 0);
        ɵngcc0.ɵɵtemplate(1, DwConfigPanelHostComponent_dw_dynamic_loader_1_Template, 1, 1, "dw-dynamic-loader", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentNodeType == "section");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentNodeType != "section");
    } }, directives: [ɵngcc4.NgIf, DwSectionConfigPanelComponent, DwDynamicLoaderComponent], styles: [""] });
DwConfigPanelHostComponent.ctorParameters = () => [
    { type: DwSectionConfigStateService }
];

var DwDataNodeType;
(function (DwDataNodeType) {
    DwDataNodeType["item"] = "item";
    DwDataNodeType["context"] = "context";
    DwDataNodeType["variable"] = "variable";
    DwDataNodeType["prefetch"] = "prefetch";
    DwDataNodeType["itemRoot"] = "itemRoot";
    DwDataNodeType["contextRoot"] = "contextRoot";
    DwDataNodeType["variableRoot"] = "variableRoot";
})(DwDataNodeType || (DwDataNodeType = {}));

class DwDataConfigStateService {
    constructor(dwMetaDataService, dwContextService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextService = dwContextService;
    }
    initializeState(dataConfig) {
        this.state = {
            dataConfig: dataConfig,
            contextDefinitions: this.getContextDefinitions(dataConfig.rootItemConfig.itemName),
            tree: []
        };
        this.state.tree = this.buildTree(dataConfig);
        return this.state;
    }
    getContextDefinitions(rootItem) {
        const contextDefinitions = this.dwContextService.contextDefinitions.filter(contextDef => contextDef.isGlobal || this.areSameItem(contextDef.parentItem, rootItem));
        return contextDefinitions;
    }
    buildTree(dataConfig) {
        const nodes = [];
        nodes.push(this.buildItemsTree(dataConfig));
        nodes.push(this.buildContextTree(dataConfig));
        nodes.push(this.buildVariablesTree(dataConfig));
        return nodes;
    }
    buildItemsTree(dataConfig) {
        var _a;
        const mainNode = { label: 'Items', icon: 'fa fa-database dw-blue', children: [] };
        mainNode.children.push(this.buildItemNode(dataConfig.rootItemConfig));
        if (((_a = dataConfig.additionalItemConfigs) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const additionalItemsNode = { label: 'Additional Items', icon: 'fa fa-database dw-blue', children: [] };
            mainNode.children.push(additionalItemsNode);
            for (const itemConfig of dataConfig.additionalItemConfigs) {
                additionalItemsNode.children.push(this.buildItemNode(itemConfig));
            }
        }
        return mainNode;
    }
    buildItemNode(itemConfig) {
        var _a;
        const node = {
            label: itemConfig.itemName,
            icon: 'fa fa-table',
            data: {
                nodeType: DwDataNodeType.item,
                config: itemConfig
            }
        };
        if (((_a = itemConfig.prefetchChildren) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            node.children = [];
        }
        for (const childItemConfig of itemConfig.prefetchChildren) {
            const childNode = this.buildItemNode(childItemConfig);
            node.children.push(childNode);
        }
        return node;
    }
    buildContextTree(dataConfig) {
        const mainNode = { label: 'Context', icon: 'fa fa-asterisk dw-green', children: [], data: { nodeType: DwDataNodeType.contextRoot } };
        for (const contextConfig of (dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.contextConfigs) || []) {
            // const contextDef = this.state.contextDefinitions.find(cd => cd.contextName == contextConfig.contextName);
            // const contextDisplay = contextDef ? contextDef.contextDisplay : `${contextConfig.contextName} (Missing)`
            // const node: TreeNode = {
            //     label: contextConfig.contextName,
            //     icon: 'fa fa-table',
            //     type: DwDataNodeType.context,
            //     data: contextConfig
            // }
            mainNode.children.push(this.buildContextDefNode(contextConfig));
        }
        return mainNode;
    }
    buildContextDefNode(contextConfig) {
        const contextDef = this.state.contextDefinitions.find(cd => cd.contextName == contextConfig.contextName);
        let contextDisplay = contextDef ? contextDef.contextDisplay : `${contextConfig.contextName} (Missing)`;
        if (contextConfig.isAdHocContext) {
            contextDisplay = contextConfig.adHocContextDisplay;
        }
        const node = {
            label: contextDisplay,
            icon: 'fa fa-table',
            type: DwDataNodeType.context,
            data: {
                nodeType: DwDataNodeType.context,
                config: contextConfig
            }
        };
        return node;
    }
    buildVariablesTree(dataConfig) {
        const mainNode = { label: 'Variables', icon: 'fa fa-font-case', children: [], data: { nodeType: DwDataNodeType.variableRoot } };
        for (const variableConfig of (dataConfig === null || dataConfig === void 0 ? void 0 : dataConfig.variables) || []) {
            mainNode.children.push(this.buildVariableNode(variableConfig));
        }
        return mainNode;
    }
    buildVariableNode(variableConfig) {
        const node = {
            label: variableConfig.attribute.AttributeDisplay,
            icon: 'fa fa-omega',
            type: DwDataNodeType.context,
            data: variableConfig,
        };
        return node;
    }
    getMenus(node) {
        var _a;
        const menus = [];
        switch ((_a = node.data) === null || _a === void 0 ? void 0 : _a.nodeType) {
            case DwDataNodeType.item:
            case DwDataNodeType.prefetch:
                return this.buildPrefetchMenus(node);
            case DwDataNodeType.contextRoot:
                return this.buildContextDefMenus(node);
            case DwDataNodeType.variableRoot:
                const menu2 = {
                    label: 'Add Variable',
                    command: (event) => {
                        this.addVariable(node);
                    }
                };
                menus.push(menu2);
                break;
        }
        return of(menus);
    }
    buildContextDefMenus(contextDefNode) {
        const menus = [];
        const rootMenu = {
            label: 'Add Context',
            items: []
        };
        menus.push(rootMenu);
        const availableContextDefs = this.state.contextDefinitions.filter(contextDef => {
            const existinContextConfig = this.state.dataConfig.contextConfigs.find(contextConfig => contextConfig.contextName == contextDef.contextName);
            return !existinContextConfig;
        });
        for (const contextDef of availableContextDefs) {
            const contextDefMenu = {
                label: contextDef.contextDisplay,
                command: (event) => {
                    this.addContextDef(contextDef, contextDefNode);
                }
            };
            rootMenu.items.push(contextDefMenu);
        }
        return of(menus);
    }
    addPrefetch(relation, parentNode) {
    }
    addContextDef(contextDef, parentNode) {
        const contextDefConfig = {
            contextName: contextDef.contextName,
            isAdHocContext: false,
        };
        this.state.dataConfig.contextConfigs.push(contextDefConfig);
        const contextNode = this.buildContextDefNode(contextDefConfig);
        parentNode.children.push(contextNode);
        parentNode.expanded = true;
    }
    addVariable(parentNode) {
        const variableConfig = {
            attribute: {
                AttributeName: 'variable1',
                AttributeDisplay: 'Variable 1',
                AttributeType: DwAttributeType.Text,
                FieldType: DwFieldType.Standard,
                HasDisplayField: false,
                DisplayAttributeName: 'variable1',
                Attribute: {
                    AttributeName: 'variable1',
                    AttributeType: DwAttributeType.Text,
                    Display: 'Variable 1'
                }
            }
        };
        this.state.dataConfig.variables.lastIndexOf(variableConfig);
        const variableNode = this.buildVariableNode(variableConfig);
        parentNode.children.push(variableNode);
        parentNode.expanded = true;
    }
    buildPrefetchMenus(node) {
        return this.dwMetaDataService.getMetaData(node.data.config.itemName)
            .pipe(map(itemMd => {
            const menus = [];
            const prefetchMenuRoot = {
                label: 'Add Prefetch',
                items: []
            };
            menus.push(prefetchMenuRoot);
            if (node.data.nodeType == DwDataNodeType.prefetch) {
                const prefetchMenu = {
                    label: 'Remove Prefetch',
                };
                menus.push(prefetchMenu);
            }
            for (const relation of itemMd.Relations) {
                if (!relation.NamingInfo.IsCollectin) {
                    const prefetchMenu = {};
                    prefetchMenu.label = relation.NamingInfo.RelationshipDisplayName;
                    prefetchMenu.command = (event) => {
                        alert(`Add Prefetch ${prefetchMenu.label}`);
                    };
                    prefetchMenuRoot.items.push(prefetchMenu);
                }
            }
            return menus;
        }));
    }
    // loadNodeChildren(node: TreeNode<DwDataConfigItem | DwDataConfigPrefetch>) {
    //     if (node.children != null || (node.type != DwDataNodeType.item && node.type != DwDataNodeType.prefetch)) {
    //         return;
    //     }
    //     node.children = [];
    //     this.dwMetaDataService.getMetaData(node.data.itemName)
    //         .subscribe(itemMd => {
    //             for (const relation of itemMd.Relations) {
    //                 const relationNode = this.createPrefetchNode(relation, itemMd);
    //                 node.children.push(relationNode);
    //             }
    //         });
    // }
    createPrefetchNode(relation, itemMd) {
        const mainItemName = relation.FkUniqueItemName == itemMd.UniqueItemName ? relation.PkUniqueItemName : relation.FkUniqueItemName;
        const prefetchConfig = {
            relationshipName: relation.RelationshipName,
            itemName: mainItemName,
            propertyName: relation.NamingInfo.RelationshipPropertyName,
            prefetchChildren: []
        };
        const prefetchNode = {
            label: relation.NamingInfo.RelationshipDisplayName,
            leaf: false,
            data: {
                nodeType: DwDataNodeType.prefetch,
                config: prefetchConfig
            }
        };
        return prefetchNode;
    }
    areSameItem(item1, item2) {
        if (!item1 || !item2) {
            return false;
        }
        const itemName1 = item1.toUpperCase();
        const itemName2 = item2.toUpperCase();
        return itemName1 === itemName2;
    }
}
DwDataConfigStateService.ɵfac = function DwDataConfigStateService_Factory(t) { return new (t || DwDataConfigStateService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwContextService)); };
DwDataConfigStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwDataConfigStateService, factory: DwDataConfigStateService.ɵfac });
DwDataConfigStateService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];

class DwDataConfigComponent {
    constructor(dwDataConfigService) {
        this.dwDataConfigService = dwDataConfigService;
        this.dataConfigChange = new EventEmitter();
        this.cmMenuItems = [{ label: 'Initial Item' }];
    }
    ngOnInit() {
        const state = this.dwDataConfigService.initializeState(this.dataConfig);
        this.tree = state.tree;
    }
    setCurrentNode(node) {
        this.currentNode = node;
    }
    nodeMenu(event, node) {
        event.preventDefault();
        this.dwDataConfigService.getMenus(node)
            .subscribe(menuItems => {
            this.cmMenuItems = menuItems;
            if (menuItems.length > 0) {
                this.contextMenu.show(event);
            }
        });
    }
}
DwDataConfigComponent.ɵfac = function DwDataConfigComponent_Factory(t) { return new (t || DwDataConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwDataConfigStateService)); };
DwDataConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDataConfigComponent, selectors: [["dw-data-config"]], viewQuery: function DwDataConfigComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c88, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contextMenu = _t.first);
    } }, inputs: { dataConfig: "dataConfig" }, outputs: { dataConfigChange: "dataConfigChange" }, features: [ɵngcc0.ɵɵProvidersFeature([DwDataConfigStateService])], decls: 8, vars: 6, consts: [[1, "dw-panel"], [1, "dw-panel-left"], ["selectionMode", "single", 3, "value", "selection", "selectionChange"], ["pTemplate", "default"], [1, "dw-panel-right"], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "model"], ["contextMenu", ""], [3, "contextmenu"]], template: function DwDataConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "p-tree", 2);
        ɵngcc0.ɵɵlistener("selectionChange", function DwDataConfigComponent_Template_p_tree_selectionChange_3_listener($event) { return ctx.setCurrentNode($event); });
        ɵngcc0.ɵɵtemplate(4, DwDataConfigComponent_ng_template_4_Template, 2, 1, "ng-template", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "p-contextMenu", 5, 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(5, _c89));
        ɵngcc0.ɵɵproperty("value", ctx.tree)("selection", ctx.currentNode);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("model", ctx.cmMenuItems);
    } }, directives: [ɵngcc8.Tree, ɵngcc6.PrimeTemplate, ɵngcc7.ContextMenu], styles: [""] });
DwDataConfigComponent.ctorParameters = () => [
    { type: DwDataConfigStateService }
];
DwDataConfigComponent.propDecorators = {
    dataConfig: [{ type: Input }],
    dataConfigChange: [{ type: Output }],
    contextMenu: [{ type: ViewChild, args: ['contextMenu',] }]
};

var __decorate$1_ = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1y = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var DwDateTimeContextService_1;
const moment$c = moment_;
let DwDateTimeContextService = DwDateTimeContextService_1 = class DwDateTimeContextService extends DwCustomContextBase {
    constructor(metadataConfig) {
        super();
        this.metadataConfig = metadataConfig;
    }
    setupContextDefinition(dateTimeContextDef) {
        dateTimeContextDef.data = {};
        dateTimeContextDef.noCache = true;
        dateTimeContextDef.getCustomContextFunction = (context, contextData) => {
            let dateTimeContext = DwDateTimeContextService_1.staticDateTimeContext;
            const currentDate = moment$c().utc().format("MM/DD/YYYY");
            if ((dateTimeContext === null || dateTimeContext === void 0 ? void 0 : dateTimeContext.CurrentDate) !== currentDate) {
                dateTimeContext = this.buildDateTimeContext();
                DwDateTimeContextService_1.staticDateTimeContext = deepCopy(dateTimeContext);
            }
            dateTimeContext.CurrentDateTime = moment$c().utc().format("MM/DD/YYYY hh:mm A");
            return dateTimeContext;
        };
        dateTimeContextDef.attributes = this.getContextAttribute();
    }
    // Build once since most values don't change for a day
    buildDateTimeContext() {
        const dateTimeContext = {
            CurrentDateTime: moment$c().utc().format("MM/DD/YYYY hh:mm A"),
            CurrentDate: moment$c().utc().format("MM/DD/YYYY"),
            CurrentYear: moment$c().utc().year(),
            CurrentMonth: moment$c().utc().month() + 1,
            CurrentDay: moment$c().utc().day(),
            CurrentMonthStart: moment$c().utc().startOf('month').format("MM/DD/YYYY"),
            CurrentMonthEnd: moment$c().utc().endOf('month').format("MM/DD/YYYY"),
            LastYear: moment$c().utc().year() - 1,
            LastMonth: moment$c().utc().add(-1, 'month').month() + 1,
            LastMonthStart: moment$c().utc().add(-1, 'month').startOf('month').format("MM/DD/YYYY"),
            LastMonthEnd: moment$c().utc().add(-1, 'month').endOf('month').format("MM/DD/YYYY"),
            NextYear: moment$c().utc().year() + 1,
            NextMonth: moment$c().utc().add(1, 'month').month() + 1,
            NextMonthStart: moment$c().utc().add(1, 'month').startOf('month').format("MM/DD/YYYY"),
            NextMonthEnd: moment$c().utc().add(1, 'month').endOf('month').format("MM/DD/YYYY"),
        };
        return dateTimeContext;
    }
    getContextAttribute() {
        const attributes = [];
        this.addProperty(attributes, 'CurrentDateTime', 'Current Date/Time', DwAttributeType.DateTime, DwControlType.DateTimePicker);
        this.addProperty(attributes, 'CurrentDate', 'Current Date', DwAttributeType.Date, DwControlType.DatePicker);
        this.addProperty(attributes, 'CurrentYear', 'Current Year', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'CurrentMonth', 'Current Month', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'CurrentMonthStart', 'Current Month Start', DwAttributeType.Date, DwControlType.DatePicker);
        this.addProperty(attributes, 'CurrentMonthEnd', 'Current Month End', DwAttributeType.Date, DwControlType.DatePicker);
        this.addProperty(attributes, 'CurrentDay', 'Current Day', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'LastYear', 'Last Year', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'LastMonth', 'Last Month', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'LastMonthStart', 'Last Month Start', DwAttributeType.Date, DwControlType.DatePicker);
        this.addProperty(attributes, 'LastMonthEnd', 'Last Month End', DwAttributeType.Date, DwControlType.DatePicker);
        this.addProperty(attributes, 'NextYear', 'Next Year', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'NextMonth', 'Next Month', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'NextMonthStart', 'Next Month Start', DwAttributeType.Date, DwControlType.DatePicker);
        this.addProperty(attributes, 'NextMonthEnd', 'Next Month End', DwAttributeType.Date, DwControlType.DatePicker);
        return attributes;
    }
};
DwDateTimeContextService.ɵfac = function DwDateTimeContextService_Factory(t) { return new (t || DwDateTimeContextService)(ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwDateTimeContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwDateTimeContextService, factory: function (t) { return DwDateTimeContextService.ɵfac(t); } });
DwDateTimeContextService.staticDateTimeContext = null;
DwDateTimeContextService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwDateTimeContextService = DwDateTimeContextService_1 = __decorate$1_([
    DwCustomContextDefinition({
        keyName: 'dateTimeContext',
        display: 'Date/Time Context',
        isGlobal: true,
    }),
    __metadata$1y("design:paramtypes", [Object])
], DwDateTimeContextService);

class DwGridSetValuesActionConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.attrUpdates = [];
        this.attrUpdatesAttrs = [];
        this.allAttributes = [];
    }
    addControls() {
        this.attrNamesFc = this.addControl('attrNames', Validators.required, []);
        this.attrUpdatesFc = this.addControl('attrUpdates');
        this.addControl('refreshFullGrid');
        this.attrNamesFc.valueChanges.subscribe(attrNames => {
            this.setupAttrUpdates();
        });
        this.attrUpdatesFc.valueChanges.subscribe(attrUpdates => {
            this.attrUpdates = attrUpdates || [];
        });
        this.setupMetaData();
    }
    setupMetaData() {
        this.metaDataService.getSavedQueryMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.itemMd = itemMd;
            this.allAttributes = itemMd.Attributes.filter(a => a.Attribute.IsKey == false);
            this.setupAttrUpdates();
        });
    }
    onAttrUpdateChange(attrUpdate) {
        this.attrUpdatesFc.setValue(this.attrUpdates);
    }
    setupAttrUpdates() {
        var _a;
        const attrNames = this.attrNamesFc.value;
        if (!Array.isArray(attrNames)) {
            return;
        }
        for (const attrName of attrNames) {
            let attrUpdate = this.attrUpdates.find(au => au.attrName == attrName);
            if (!attrUpdate) {
                attrUpdate = {
                    attrName: attrName,
                    value: null
                };
                this.attrUpdates.push(attrUpdate);
            }
        }
        this.attrUpdatesAttrs = [];
        for (let i = this.attrUpdates.length - 1; i >= 0; i--) {
            const attrUpdate = this.attrUpdates[i];
            if (attrNames.indexOf(attrUpdate.attrName) == -1) {
                this.attrUpdates.splice(i, 1);
                continue;
            }
            const attr = (_a = this.itemMd) === null || _a === void 0 ? void 0 : _a.Attributes.find(a => a.AttributeName == attrUpdate.attrName);
            this.attrUpdatesAttrs.splice(0, 0, attr);
        }
        this.attrUpdatesFc.setValue(this.attrUpdates, { emitEvent: false });
    }
}
DwGridSetValuesActionConfigComponent.ɵfac = function DwGridSetValuesActionConfigComponent_Factory(t) { return new (t || DwGridSetValuesActionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridSetValuesActionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridSetValuesActionConfigComponent, selectors: [["dw-grid-set-values-action-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["formControlName", "attrNames", "optionLabel", "AttributeDisplay", "display", "chip", "optionValue", "AttributeName", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["dwRow", "", 4, "ngFor", "ngForOf"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "refreshFullGrid"], [3, "defaultValue", "contextNames", "queryAttribute", "defaultValueChange"]], template: function DwGridSetValuesActionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridSetValuesActionConfigComponent_div_0_Template, 13, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgForOf, ɵngcc10.InputSwitch, DwDefaultValueComponent], encapsulation: 2 });
DwGridSetValuesActionConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$1$ = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1z = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridSetValuesActionService = class DwGridSetValuesActionService {
    constructor(metaDataService, ormDataService, dwContextService, dwExpressionService, loggingService) {
        this.metaDataService = metaDataService;
        this.ormDataService = ormDataService;
        this.dwContextService = dwContextService;
        this.dwExpressionService = dwExpressionService;
        this.loggingService = loggingService;
    }
    handleAction(actionState) {
        const { actionConfig, event } = actionState;
        const newValue = event.additionalData;
        const dataToUpdate = actionState.data;
        // First, get the resolve context so we can evaluate the reference values
        return this.dwContextService.getContextsAndResolve(actionState.gridConfigContext.contextNames, {})
            .pipe(mergeMap(resolvedContext => {
            const attrUpdates = [];
            // Build list of updates
            for (const attrUpdateConfig of actionConfig.attrUpdates) {
                let value = null;
                if (attrUpdateConfig.value) {
                    value = this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(attrUpdateConfig.value.reference, {}, resolvedContext);
                }
                attrUpdates.push({
                    attrName: attrUpdateConfig.attrName,
                    newValue: value
                });
            }
            // Execute updates
            return this.ormDataService.updateAttributeValues(dataToUpdate, attrUpdates, false)
                .pipe(map(dataItems => {
                const keyName = dataItems && dataItems.length > 0 ? dataItems[0]._keyName : '';
                // return result to refresh grid or identify which rows to update
                const result = {
                    success: true,
                    refreshData: actionConfig.refreshFullGrid,
                    dataActionResult: {
                        itemName: actionState.metaDataGridApi.item,
                        keyName: keyName,
                        actionType: DwMdDataActionType.update,
                        keysEffected: dataItems.map(dataItem => dataItem[keyName])
                    }
                };
                return result;
            }));
        }));
    }
};
DwGridSetValuesActionService.ɵfac = function DwGridSetValuesActionService_Factory(t) { return new (t || DwGridSetValuesActionService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwLoggingService)); };
DwGridSetValuesActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridSetValuesActionService, factory: function (t) { return DwGridSetValuesActionService.ɵfac(t); } });
DwGridSetValuesActionService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwContextService },
    { type: DwExpressionService },
    { type: DwLoggingService }
];
DwGridSetValuesActionService = __decorate$1$([
    DwAction({
        keyName: DwGridActionKeys.gridSetValues,
        display: 'Set values',
        actionType: DwActionType.gridRowAction,
        isGlobal: true,
        allowOnce: false,
        configComponent: DwGridSetValuesActionConfigComponent,
        defaultMenuConfig: {
            useParentDisplay: true,
            itemRequirement: DwActionItemRequirement.multiple,
            useCustomMenus: false,
        },
        defaultButtonConfig: {
            useParentDisplay: true,
        },
        defaultSecurityConfig: {
            requireCanUpdate: true
        },
        defaultConfirmConfig: {
            showDialogConfig: true,
            showConfirmDialog: false,
        }
    }),
    __metadata$1z("design:paramtypes", [DwMetaDataService,
        DwOrmDataService,
        DwContextService,
        DwExpressionService,
        DwLoggingService])
], DwGridSetValuesActionService);

var __decorate$20 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwMetaDataGridContextService = class DwMetaDataGridContextService extends DwCustomContextBase {
    setupContextDefinition(gridContextDef) {
        gridContextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
        // data is populated by the form automatically
        gridContextDef.data = {};
        gridContextDef.attributes = this.getContextAttribute();
    }
    getContextAttribute() {
        const attributes = [];
        this.addProperty(attributes, 'viewKey', 'View Key', DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(attributes, 'filterTileKey', 'Filter Type Key', DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(attributes, 'dataSelectedCount', 'Selected Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'inEditMode', 'In Edit Mode', DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(attributes, 'updatedCount', 'Updated Count', DwAttributeType.Integer, DwControlType.NumericTextBox);
        return attributes;
    }
};
DwMetaDataGridContextService.ɵfac = function DwMetaDataGridContextService_Factory(t) { return ɵDwMetaDataGridContextService_BaseFactory(t || DwMetaDataGridContextService); };
DwMetaDataGridContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataGridContextService, factory: function (t) { return DwMetaDataGridContextService.ɵfac(t); } });
DwMetaDataGridContextService = __decorate$20([
    DwCustomContextDefinition({
        keyName: DwMdGridContextInfo.GRID_CONTEXT_NAME,
        display: 'Grid Context',
        isGlobal: false,
        isCustomUiContext: true,
        customUIContextType: 'Grid'
    })
], DwMetaDataGridContextService);

class DwExportConfigComponent {
    constructor(dwMetaDataService, uiMetaDataConfig, dwUiConfigRegistryService, cdr) {
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.cdr = cdr;
        this.exportConfigChange = new EventEmitter();
        this.availableAttributes = [];
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Column',
            displayField: 'display',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Column',
            showListActionBar: true,
            showAdditionalTab: true,
            additionalTabHeading: 'Export Options'
        };
        this.setupQueryMetaData();
        if (!this.exportConfig) {
            this.exportConfig = {
                exportColumns: [],
                exportFileName: '',
                exportSortableDates: false
            };
            this.copyGridColumns();
        }
    }
    ngOnChanges(changes) {
        if (changes.configContext && !changes.configContext.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.filters && !changes.filters.firstChange) {
            this.setupQueryMetaData();
        }
        if (changes.exportConfig || changes.gridColumnPreferences) {
            this.setupControl();
        }
    }
    setSelectedItem(item) {
        this.selectedItem = item;
        this.selectedAttr = this.getQueryAttribute(item === null || item === void 0 ? void 0 : item.attr);
        this.onExportChanged();
    }
    addItem(attr) {
        const newItem = {
            attr: attr.AttributeName,
        };
        newItem.display = this.getColumnDisplay(newItem);
        // remove the array to it triggers a change
        this.exportConfig.exportColumns = [...this.exportConfig.exportColumns, newItem];
        this.buildAvailableAttrs();
        this.onExportChanged();
    }
    removeItem(item) {
        const index = this.exportConfig.exportColumns.indexOf(item);
        if (this.selectedItem) {
            if (this.exportConfig.exportColumns.indexOf(this.selectedItem) == index) {
                this.selectedItem = null;
            }
        }
        if (index >= 0) {
            this.exportConfig.exportColumns.splice(index, 1);
        }
        this.buildAvailableAttrs();
        this.onExportChanged();
    }
    removeAll() {
        this.exportConfig.exportColumns = [];
        this.buildAvailableAttrs();
        this.onExportChanged();
    }
    reorderList() {
        this.onExportChanged();
    }
    copyGridColumns() {
        if (!this.gridColumnPreferences) {
            return;
        }
        const newColumns = [];
        for (const columnPref of this.gridColumnPreferences) {
            if (columnPref.field) {
                const exportColumn = {
                    attr: columnPref.field,
                    captionOverride: columnPref.label
                };
                newColumns.push(exportColumn);
            }
        }
        this.exportConfig.exportColumns = newColumns;
        this.buildAvailableAttrs();
        this.onExportChanged();
    }
    onExportChanged() {
        this.setAllDisplays();
        this.exportConfigChange.emit(this.exportConfig);
        this.cdr.detectChanges();
    }
    setupQueryMetaData() {
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
            this.setupControl();
        });
    }
    buildAvailableAttrs() {
        if (!this.queryMetaData) {
            return;
        }
        this.setAllDisplays();
        const attrs = [];
        for (let attr of this.queryMetaData.Attributes) {
            const found = this.exportConfig.exportColumns.find(c => c.attr == attr.AttributeName);
            if (!found) {
                attrs.push(attr);
            }
        }
        this.availableAttributes = attrs;
    }
    setupControl() {
        this.selectedItem = null;
        // Ensure we have a config setup
        if (!this.exportConfig) {
            this.exportConfig = {
                exportColumns: []
            };
        }
        this.exportConfig.exportColumns = this.exportConfig.exportColumns || [];
        this.buildAvailableAttrs();
    }
    setAllDisplays() {
        for (const column of this.exportConfig.exportColumns) {
            column.display = this.getColumnDisplay(column);
        }
    }
    getColumnDisplay(exportColumn) {
        if (exportColumn.captionOverride) {
            return exportColumn.captionOverride;
        }
        let queryAttr = this.getQueryAttribute(exportColumn.attr);
        if (queryAttr) {
            return queryAttr.AttributeDisplay;
        }
        return exportColumn.attr ? `${exportColumn.attr} - Missing` : 'Unknown';
    }
    getQueryAttribute(attrName) {
        if (!attrName) {
            return;
        }
        return this.queryMetaData.Attributes.find(attr => attr.AttributeName.toUpperCase() == attrName.toUpperCase());
    }
}
DwExportConfigComponent.ɵfac = function DwExportConfigComponent_Factory(t) { return new (t || DwExportConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwExportConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExportConfigComponent, selectors: [["dw-export-config"]], inputs: { exportConfig: "exportConfig", configContext: "configContext", gridColumnPreferences: "gridColumnPreferences" }, outputs: { exportConfigChange: "exportConfigChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder", 4, "ngIf"], ["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], ["addTooltip", "Add Column", 3, "attributes", "attributeClick"], ["actionBar", ""], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["class", "btn btn-warning button-spacing", "title", "Replaces all export columns with the grid columns", 3, "click", 4, "ngIf"], ["configureItemTab", ""], [4, "ngIf"], ["additionalTab", ""], ["dwRow", ""], ["dwCol", "12"], ["title", "Any extension will be replaced", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "When set to false, dates will be displayed as string with timezone info, but can't be sorted in Excel", 1, "fa", "fa-info-circle"], ["title", "Replaces all export columns with the grid columns", 1, "btn", "btn-warning", "button-spacing", 3, "click"], ["header", "Basic Settings", 3, "selected"], [1, "form-control"], ["type", "text", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["header", "Column Security"], ["hideSecurityDefault", "true", 3, "config", "configContext", "configChange"]], template: function DwExportConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwExportConfigComponent_dw_ui_config_list_0_Template, 22, 8, "dw-ui-config-list", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.exportConfig);
    } }, directives: [ɵngcc4.NgIf, DwUiConfigListComponent, DwFieldSelectionComponent, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwYesNoComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwSecurityCheckConfigComponent], styles: [""] });
DwExportConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: ChangeDetectorRef }
];
DwExportConfigComponent.propDecorators = {
    configContext: [{ type: Input }],
    exportConfig: [{ type: Input }],
    exportConfigChange: [{ type: Output }],
    gridColumnPreferences: [{ type: Input }]
};

class DwMenuExpressionProcessorService {
    constructor(dwExpressionSevice, dwEventService, dwContextService, dwUserSecurityService) {
        this.dwExpressionSevice = dwExpressionSevice;
        this.dwEventService = dwEventService;
        this.dwContextService = dwContextService;
        this.dwUserSecurityService = dwUserSecurityService;
        this.contextsLoaded = false;
        this.contextNames = [];
    }
    get resolvedContext() {
        return DwMenuExpressionProcessorService._resolvedContext;
    }
    setResolvedContext(value) {
        DwMenuExpressionProcessorService._resolvedContext = value;
    }
    initProcessor(menus, refreshSubject) {
        // Get list of contexts useds
        const contextNames = this.getMenuContexts(menus);
        if (contextNames.length == 0) {
            return;
        }
        this.contextNames = contextNames;
        return this.dwContextService.waitForContextDefLoad()
            .pipe(mergeMap(() => {
            // Refresh the menus when any contexts need refreshing 
            //  This should cause the contexts to be re-evalutaed and the menus to be processed again
            this.setupMenuRefresh(refreshSubject, contextNames);
            // console.log('DwMenuExpressionProcess - Resolve Context - Start', contextNames);
            // console.log('DwMenuExpressionProcess - Resolve Context - Start Security Context', this.dwUserSecurityService.securityState.securityContext);
            return this.dwContextService.getContextsAndResolve(contextNames, {})
                .pipe(tap(resolvedContexts => {
                if (areEqual(resolvedContexts, this.resolvedContext)) {
                    return;
                }
                this.setResolvedContext(resolvedContexts);
                this.contextsLoaded = true;
                // refreshSubject.next(true);
            }));
        }));
    }
    processAllMenus(menus) {
        return menus;
    }
    setupMenuRefresh(refreshSubject, contextNames) {
        if (this.contextRefreshSubscription) {
            this.contextRefreshSubscription.unsubscribe();
            this.contextRefreshSubscription = null;
        }
        if (contextNames.length == 0) {
            return;
        }
        const topics = this.dwContextService.getContextTopics(contextNames);
        if (topics.length == 0) {
            return;
        }
        this.contextRefreshSubscription = this.dwContextService.getContextRefreshObservable(this.contextNames)
            .subscribe(contextNames => {
            if (contextNames) {
                // console.log('DwMenuExpressionProcessor - Refresh Menu', contextNames);
                refreshSubject.next(true);
            }
        });
    }
    canViewMenu(menu) {
        var _a;
        const menuDataExt = (_a = menu.data) === null || _a === void 0 ? void 0 : _a.extInfo;
        if (menuDataExt === null || menuDataExt === void 0 ? void 0 : menuDataExt.securityExpression) {
            if (!this.resolvedContext) {
                return false;
            }
            const result = this.dwExpressionSevice.evaluateExpressionGroupItemWithResolvedData(menuDataExt.securityExpression, {}, this.resolvedContext);
            return result;
        }
        return true;
    }
    getMenuContexts(menus, contextNames) {
        var _a, _b;
        contextNames = contextNames || [];
        for (const menu of menus) {
            const menuDataExt = (_a = menu.data) === null || _a === void 0 ? void 0 : _a.extInfo;
            if (menuDataExt === null || menuDataExt === void 0 ? void 0 : menuDataExt.securityExpression) {
                const dependencies = this.dwExpressionSevice.getExpresionDependencies(menuDataExt.securityExpression);
                for (const dependency of dependencies) {
                    if (dependency.contextName) {
                        if (contextNames.indexOf(dependency.contextName) < 0) {
                            contextNames.push(dependency.contextName);
                        }
                    }
                }
            }
            if (((_b = menu.children) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                this.getMenuContexts(menu.children, contextNames);
            }
        }
        return contextNames;
    }
}
DwMenuExpressionProcessorService.ɵfac = function DwMenuExpressionProcessorService_Factory(t) { return new (t || DwMenuExpressionProcessorService)(ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwEventService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwMenuExpressionProcessorService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMenuExpressionProcessorService, factory: DwMenuExpressionProcessorService.ɵfac });
DwMenuExpressionProcessorService._resolvedContext = null;
DwMenuExpressionProcessorService.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwEventService },
    { type: DwContextService },
    { type: DwSecurityUserService }
];

class DwGridCopyModalComponent {
    constructor(dwMetaDataService, dwValidationService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwValidationService = dwValidationService;
        this.formGroup = new FormGroup({});
        this.attributeList = [];
        this.availableAttributes = [];
        this.attributesToUpdate = [];
        this.selectedAttributes = [];
        this.submitted = false;
        this.formValidator = new DwDefaultFormValidator();
    }
    ngOnInit() {
        // Use attributes for the item, not the query since this will be a edit form
        this.dwMetaDataService.getMetaData(this.modalConfig.data.item)
            .subscribe(i => {
            this.attributeList = i.Attributes;
            this.updateAvailableAttributes();
            // Default to showing all fields
            this.setSelectedAttributes(this.availableAttributes);
        });
    }
    buttonClick(buttonConfig) {
        let modalResult = {
            cancelled: false,
            buttonCommand: buttonConfig.command,
            closeModal: true,
        };
        this.message = null;
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                const validationResult = this.formValidator.validateForm(this.formGroup, this.dwValidationService);
                if (!validationResult.isValid) {
                    this.message = {
                        messageHeading: validationResult.summaryHeading,
                        messageBody: validationResult.summaryBodyHtml,
                        severity: DwMessageSeverity.warning,
                        allowClose: true,
                    };
                    this.submitted = true;
                    modalResult.closeModal = false;
                    return of(modalResult);
                }
                this.setUpdateAttributes(modalResult);
                break;
            case DwButtonCommand.cancel:
                modalResult.cancelled = true;
                break;
        }
        return of(modalResult);
    }
    setUpdateAttributes(modalResult) {
        if (this.attributesToUpdate.length == 0) {
            modalResult.closeModal = false;
            return;
        }
        const updatedEntity = {
            _itemName: this.modalConfig.data.item,
            _keyName: this.modalConfig.data.keyName
        };
        for (const attrToUpdate of this.attributesToUpdate) {
            updatedEntity[attrToUpdate.attr.AttributeName] = this.formGroup.get(attrToUpdate.attr.AttributeName).value;
        }
        const multiEditResult = {
            //fieldsUpdated: true,
            updatedEntity: updatedEntity
        };
        modalResult.cancelled = false;
        modalResult.data = multiEditResult;
    }
    addAttribute(attr) {
        if (!attr) {
            return;
        }
        if (!this.formGroup[attr.AttributeName]) {
            const control = new FormControl();
            this.formGroup.addControl(attr.AttributeName, control);
            if (attr.AlwaysRequired || (!attr.AllowNull && attr.AttributeType != DwAttributeType.Text && attr.AttributeType != DwAttributeType.HTML)) {
                control.validator = Validators.required;
            }
        }
        this.attributesToUpdate.push({
            attr: attr,
            fieldConfig: this.buildFieldConfig(attr, this.modalConfig.data.item),
        });
        this.updateAvailableAttributes();
    }
    removeAttribute(editAttr) {
        const index = this.attributesToUpdate.indexOf(editAttr);
        if (index >= 0) {
            this.attributesToUpdate.splice(index, 1);
        }
        this.updateAvailableAttributes();
    }
    setSelectedAttributes(attributes) {
        this.submitted = false;
        this.message = null;
        this.selectedAttributes = [...attributes];
        this.attributesToUpdate.length = 0;
        for (const attr of attributes) {
            this.addAttribute(attr);
        }
        // Enable/Disable controls appropriately
        for (const attr of this.availableAttributes) {
            const attributeIsAdded = this.attributesToUpdate.find(a => a.attr.AttributeName == attr.AttributeName);
            const control = this.formGroup.controls[attr.AttributeName];
            if (attributeIsAdded) {
                control === null || control === void 0 ? void 0 : control.enable();
            }
            else {
                control === null || control === void 0 ? void 0 : control.disable();
            }
        }
    }
    updateAvailableAttributes() {
        this.availableAttributes = this.attributeList.filter(attr => {
            // Exclude primary keys
            if (attr.IsKey) {
                return false;
            }
            // Use the modal config to determine which attributes to show
            const includeAttributes = this.modalConfig.data.config.includeAttributes || [];
            return includeAttributes.find(attrName => attr.AttributeName == attrName);
        });
    }
    buildFieldConfig(attr, itemName) {
        const fieldConfig = {
            itemName: itemName,
            attrName: attr.AttributeName,
            attr: attr,
            controlType: attr.MetaDataControlTypeId,
            label: attr.Display,
            formGroupKey: ''
        };
        return fieldConfig;
    }
}
DwGridCopyModalComponent.ɵfac = function DwGridCopyModalComponent_Factory(t) { return new (t || DwGridCopyModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwValidationService)); };
DwGridCopyModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridCopyModalComponent, selectors: [["dw-grid-copy-modal"]], decls: 8, vars: 4, consts: [[3, "formGroup"], [3, "message", "messageChange", 4, "ngIf"], [1, "container-style"], ["dwRow", "", 4, "ngFor", "ngForOf"], ["dwRow", "", 3, "hidden"], ["dwCol", "12"], [3, "message", "messageChange"], ["dwRow", ""], ["dwDynamicField", "", 3, "fieldDef", "formGroup", "submitted"]], template: function DwGridCopyModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwGridCopyModalComponent_dw_message_1_Template, 1, 1, "dw-message", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵtemplate(4, DwGridCopyModalComponent_div_4_Template, 3, 3, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtext(7, " Copy action is not configured correctly and requires at least one attribute to update ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attributesToUpdate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.attributesToUpdate.length > 0);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, ɵngcc4.NgForOf, DwRowDirective, DwColDirective, DwMessageComponent, DwDynamicFieldComponent], styles: [_c90] });
DwGridCopyModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwValidationService }
];

class DwGridCopyConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.attributes = [];
    }
    addControls() {
        this.addControl('navigateToEditAfter');
        this.addControl('includeAttributes');
        this.addControl('showRelationships');
        this.addControl('includeRelationships');
        this.addControl('refreshFullGrid');
        this.addControl('showClearAttributes');
        this.addControl('clearAttributes');
        this.setupMetaData();
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.primeAttributes = itemMd.Attributes.filter(a => !a.IsKey).map(a => { return { label: a.Display, value: a.AttributeName }; });
            this.relationships = itemMd.Relations.map(r => { return { label: r.NamingInfo.RelationshipDisplayName, value: r.RelationshipName }; });
        });
    }
}
DwGridCopyConfigComponent.ɵfac = function DwGridCopyConfigComponent_Factory(t) { return new (t || DwGridCopyConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridCopyConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridCopyConfigComponent, selectors: [["dw-grid-copy-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 44, vars: 10, consts: [[3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["title", "Select all attributes that should be updated", 1, "fa", "fa-info-circle"], ["formControlName", "includeAttributes", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["class", "dw-red", 4, "ngIf"], ["dwCol", "9"], ["title", "Identify any additional attributs that should be cleared", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "showClearAttributes"], ["dwRow", "", 3, "hidden"], ["formControlName", "clearAttributes", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["formControlName", "showRelationships"], ["title", "Select all attributes that should be modified", 1, "fa", "fa-info-circle"], ["formControlName", "includeRelationships", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["formControlName", "navigateToEditAfter"], ["formControlName", "refreshFullGrid"], [1, "dw-red"]], template: function DwGridCopyConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4, "Attributes to Display ");
        ɵngcc0.ɵɵelement(5, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(6, "p-multiSelect", 4);
        ɵngcc0.ɵɵtemplate(7, DwGridCopyConfigComponent_span_7_Template, 2, 0, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Clear Attributes ");
        ɵngcc0.ɵɵelement(12, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelement(14, "p-inputSwitch", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 10);
        ɵngcc0.ɵɵelementStart(16, "div", 2);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Attributes to Clear");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(19, "p-multiSelect", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 1);
        ɵngcc0.ɵɵelementStart(21, "div", 6);
        ɵngcc0.ɵɵelementStart(22, "label");
        ɵngcc0.ɵɵtext(23, "Include Relationships");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 8);
        ɵngcc0.ɵɵelement(25, "p-inputSwitch", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 10);
        ɵngcc0.ɵɵelementStart(27, "div", 2);
        ɵngcc0.ɵɵelementStart(28, "label");
        ɵngcc0.ɵɵtext(29, "Relationship to Copy");
        ɵngcc0.ɵɵelement(30, "i", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(31, "p-multiSelect", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 1);
        ɵngcc0.ɵɵelementStart(33, "div", 6);
        ɵngcc0.ɵɵelementStart(34, "label");
        ɵngcc0.ɵɵtext(35, "Navigate To Edit After");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "div", 8);
        ɵngcc0.ɵɵelement(37, "p-inputSwitch", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 1);
        ɵngcc0.ɵɵelementStart(39, "div", 6);
        ɵngcc0.ɵɵelementStart(40, "label");
        ɵngcc0.ɵɵtext(41, "Refresh Full Grid");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 8);
        ɵngcc0.ɵɵelement(43, "p-inputSwitch", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.actionConfigFG);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("filter", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.actionConfigFG == null ? null : ctx.actionConfigFG.value == null ? null : ctx.actionConfigFG.value.includeAttributes == null ? null : ctx.actionConfigFG.value.includeAttributes.length) == 0);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.actionConfigFG.value == null ? null : ctx.actionConfigFG.value.showClearAttributes));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("filter", true);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.actionConfigFG.value == null ? null : ctx.actionConfigFG.value.showRelationships));
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("options", ctx.relationships)("filter", true);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgIf, ɵngcc10.InputSwitch], encapsulation: 2 });
DwGridCopyConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];

var __decorate$21 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1A = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwGridCopyActionService = class DwGridCopyActionService {
    constructor(dwModalService, dwOrmDataService, dwMetaDataService, dwMetaDataGridNavigationService) {
        this.dwModalService = dwModalService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetaDataGridNavigationService = dwMetaDataGridNavigationService;
    }
    handleAction(actionState) {
        const modalData = {
            dataItem: actionState.event.eventData,
            config: actionState.actionConfig,
            item: actionState.metaDataGridApi.item,
            keyName: 'Unknown'
        };
        // if (!Array.isArray(modalData.dataItems) || modalData.dataItems.length == 0) {
        //     // Nothing to do in this case
        //     const result = new DwGridActionResult();
        //     result.success = false;
        //     result.message = `At least one record must be selected to perform a multi-edit!`
        //     return of(result); 
        // }
        // Get the keyname from the list of entities
        modalData.keyName = modalData.dataItem._keyName;
        return this.showCopyModal(modalData, actionState.metaDataGridApi);
    }
    showCopyModal(modalData, mdGridApi) {
        let modalConfig = new DwModalConfig();
        const copyButton = deepCopy(DwModalButtonStandardConfigs.instance.okButton);
        copyButton.buttonText = 'Copy';
        modalConfig.buttons = [copyButton, DwModalButtonStandardConfigs.instance.cancelButton];
        modalConfig.allowFullScreen = true;
        modalConfig.data = modalData;
        modalConfig.component = DwGridCopyModalComponent;
        modalConfig.modalSize = DwModalSize.responsive;
        modalConfig.customModalHeight = '750px';
        modalConfig.customModalWidth = '600px';
        // Get metadata so we show the title with the item display
        return this.loadRequiredMetaData(modalData.item, modalData.dataItem)
            .pipe(mergeMap(metaData => {
            modalConfig.title = `Copy ${metaData.lookupDisplay}`;
            return this.dwModalService.showModal(modalConfig)
                .pipe(mergeMap(modalResult => {
                const copyModalResult = modalResult.data;
                if (!modalResult.cancelled) {
                    return this.handleCopySave(modalData, copyModalResult, mdGridApi, metaData.itemMetaData);
                }
                const result = new DwGridActionResult();
                result.success = true;
                result.refreshData = false;
                return of(result);
            }));
        }));
    }
    loadRequiredMetaData(itemName, data) {
        return this.dwMetaDataService.getMetaData(itemName)
            .pipe(mergeMap(itemMetaData => {
            const keyValue = data[data === null || data === void 0 ? void 0 : data._keyName];
            return this.dwMetaDataService.getItemLookupDisplay(itemMetaData.MetaDataItemId, keyValue)
                .pipe(map(lookupDisplay => {
                return {
                    itemMetaData: itemMetaData,
                    lookupDisplay: lookupDisplay
                };
            }));
        }));
    }
    handleCopySave(modalData, copyResult, mdGridApi, itemMetaData) {
        // Reload entities so we get the most current data
        return this.reloadExistingRecord(modalData, itemMetaData)
            .pipe(mergeMap(reloadedEntity => {
            // Update all of the entities
            return this.updateEntities(modalData, copyResult, reloadedEntity, itemMetaData)
                .pipe(map(newCopyEntity => {
                const result = new DwGridActionResult();
                result.success = true;
                result.refreshData = true; // modalData.config.refreshFullGrid;
                result.dataActionResult = {
                    itemName: modalData.item,
                    keyName: modalData.keyName,
                    actionType: DwMdDataActionType.create,
                    keysEffected: modalData.dataItem[modalData.keyName]
                };
                if (modalData.config.navigateToEditAfter) {
                    this.dwMetaDataGridNavigationService.openAddEditView(newCopyEntity, DwMenuActionType.edit, mdGridApi);
                    //alert(`Navigate to item ${newCopyEntity._itemName} - ${newCopyEntity[newCopyEntity._keyName]}`);
                }
                return result;
            }));
        }));
    }
    reloadExistingRecord(modalData, itemMetaData) {
        const keys = modalData.dataItem[modalData.keyName];
        const keyFieldName = `${modalData.item}.${modalData.keyName}`;
        const qh = new DwQueryHelper();
        const query = new DwQuery(modalData.item)
            .AddFilterAnd(qh.filters.InList(keyFieldName, keys));
        // load relationships
        if (modalData.config.showRelationships && itemMetaData) {
            for (const relationshipName of modalData.config.includeRelationships || []) {
                query.AddPrefetchPath(relationshipName);
            }
        }
        return this.dwOrmDataService.executeQuerySingle(query);
    }
    // private buildLoadEntityQuery(modalData: DwGridCopyModalArgs, itemMetaData: DwMdItem): DwQuery {
    //     const keys = modalData.dataItem[modalData.keyName]
    //     const keyFieldName = `${modalData.item}.${modalData.keyName}`;
    //     const qh = new DwQueryHelper();
    //     const query = new DwQuery(modalData.item)
    //         .AddFilterAnd(qh.filters.InList(keyFieldName, keys));
    //     // load relationships
    //     if (modalData.config.showRelationships && itemMetaData) {
    //         for (const relationshipName of modalData.config.includeRelationships || []) {
    //             query.AddPrefetchPath(relationshipName)
    //         }
    //     }
    //     return query;
    // }
    updateEntities(modalData, copyResult, existingEntity, itemMetaData) {
        const newEntity = Object.assign(Object.assign({}, existingEntity), copyResult.updatedEntity);
        // clear the primary key so it will be saved
        newEntity[modalData.keyName] = null;
        // always clear the uniqueid field (this applies to devware tables and is required to be unique)
        newEntity['UniqueId'] = null;
        // Clear additional attributes
        if (modalData.config.showClearAttributes) {
            for (const attributeName of modalData.config.clearAttributes || []) {
                newEntity[attributeName] = null;
            }
        }
        // clear any relationships keys
        if (modalData.config.showRelationships && itemMetaData) {
            for (const relationshipName of modalData.config.includeRelationships || []) {
                const relation = itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
                if (relation) {
                    const data = newEntity[relation.NamingInfo.RelationshipPropertyName];
                    if (!data)
                        continue;
                    if (Array.isArray(data)) {
                        for (const dataItem of data) {
                            if (dataItem === null || dataItem === void 0 ? void 0 : dataItem._keyName) {
                                dataItem[dataItem._keyName] = null;
                                dataItem['UniqueId'] = null;
                            }
                        }
                    }
                    else {
                        if (data === null || data === void 0 ? void 0 : data._keyName) {
                            data[data._keyName] = null;
                            data['UniqueId'] = null;
                        }
                    }
                }
            }
        }
        return this.dwOrmDataService.saveEntity(newEntity, modalData.config.showRelationships || false);
    }
};
DwGridCopyActionService.ɵfac = function DwGridCopyActionService_Factory(t) { return new (t || DwGridCopyActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridCopyActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridCopyActionService, factory: function (t) { return DwGridCopyActionService.ɵfac(t); } });
DwGridCopyActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataGridNavigationService }
];
DwGridCopyActionService = __decorate$21([
    DwAction({
        keyName: DwGridActionKeys.gridCopy,
        display: 'Copy',
        actionType: DwActionType.gridRowAction,
        configComponent: DwGridCopyConfigComponent,
        isGlobal: true,
        allowOnce: true,
        // configComponent: DwGridSetValueActionConfigComponent,
        defaultMenuConfig: {
            useParentDisplay: true,
            itemRequirement: DwActionItemRequirement.single,
        },
        defaultButtonConfig: {
            useParentDisplay: false,
            buttonClass: 'btn btn-primray',
            iconClass: 'fa fa-copy dw-icon-grid',
            buttonType: DwButtonType.standard,
        },
        defaultSecurityConfig: {
            requireCanCreate: true
        },
        configData: {
            refreshFullGrid: true,
        }
    }),
    __metadata$1A("design:paramtypes", [DwModalService,
        DwOrmDataService,
        DwMetaDataService,
        DwMetaDataGridNavigationService])
], DwGridCopyActionService);

var __decorate$22 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1B = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEmailTemplateComponent = class DwEmailTemplateComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataRoutingService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
        this.templateConfig = {};
    }
    ngOnInit() {
        super.ngOnInit();
        // setTimeout(() => {
        //     //console.log("DwEmailTemplateConfigComponent.ngOnInit");
        //     this.setupUserFields();
        //     this.setupItemCodes();
        // });
    }
    setupComponentComplete() {
        this.setupFormField();
    }
    // private setupUserFields() {
    //     let dwMd = new DevwareMetaDataService();
    //     this.dwMetaDataService.getMetaData(DevwareMetaDataItemNames.DwUser)
    //         .subscribe(userItemMetaData=> {
    //             this.userItemMetaData = userItemMetaData;
    //         });
    // }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormField() {
        this.mainItemFc = this.formGroup.get("MainMetaDataItemId");
        this.templateConfigFC = this.formGroup.get("TemplateConfigJson");
        const bodyTemplate = this.getOrCreateFormControl("BodyTemplate");
        if (this.mainItemFc) {
            this.mainItemFc.valueChanges
                .subscribe((value) => {
                this.setupItemMetaData();
            });
        }
        this.subscriptions.push(this.formGroup.valueChanges
            .pipe(debounceTime(50), map(data => {
            const rawData = this.formGroup.getRawValue();
            const template = rawData;
            this.templateConfigFC = this.formGroup.get("TemplateConfigJson");
            return template === null || template === void 0 ? void 0 : template.TemplateConfigJson;
        }), distinctUntilChanged())
            .subscribe(templateConfig => {
            this.templateConfig = templateConfig;
            this.setupItemMetaData();
        }));
    }
    setupItemMetaData() {
        if (!this.mainItemFc || !this.mainItemFc.value) {
            return;
        }
        const ob = this.dwMetaDataService.getMetaDataItemName(this.mainItemFc.value)
            .subscribe(itemName => {
            var _a, _b, _c;
            this.itemName = itemName;
            this.dwMetaDataService.getMetaData(itemName)
                .subscribe(itemMetaData => {
                this.itemMetaData = itemMetaData;
                this.setupFieldSources();
            });
            if (!this.queryMetaData || ((_a = this.queryMetaData) === null || _a === void 0 ? void 0 : _a.QueryMeaning) !== ((_b = this.templateConfig) === null || _b === void 0 ? void 0 : _b.queryMeaning)) {
                this.dwMetaDataService.getSavedQueryMetaData(itemName, null, (_c = this.templateConfig) === null || _c === void 0 ? void 0 : _c.queryMeaning)
                    .subscribe(queryMetaData => {
                    this.queryMetaData = queryMetaData;
                    this.setupFieldSources();
                });
            }
        });
    }
    setupFieldSources() {
        this.htmlEditFieldSources = [];
        if (!this.itemMetaData || !this.queryMetaData) {
            return;
        }
        this.htmlEditFieldSources.push({
            display: this.itemMetaData.Display,
            fieldItems: this.convertAttrToFieldItem(this.queryMetaData.Attributes, "item")
        });
        const linksFieldSource = this.getLinksFieldSource();
        if (linksFieldSource) {
            this.htmlEditFieldSources.push(linksFieldSource);
        }
    }
    convertAttrToFieldItem(queryAttributes, codePrefix) {
        const fieldItems = [];
        for (let attr of queryAttributes) {
            fieldItems.push({ display: attr.AttributeDisplay, insertCode: `[${codePrefix}.${attr.AttributeName}]` });
            if (attr.DisplayAttributeName != attr.AttributeName) {
                fieldItems.push({ display: `${attr.AttributeDisplay} (Display)`, insertCode: `[item.${attr.DisplayAttributeName}]` });
            }
        }
        return fieldItems;
    }
    getLinksFieldSource() {
        if (!this.itemMetaData) {
            return;
        }
        const linksFieldSource = {
            display: `${this.itemMetaData.Display} links`,
            fieldItems: []
        };
        this.addItemActionCodes(linksFieldSource.fieldItems, DwMenuActionType.edit, (flatMenus) => `Edit ${this.itemMetaData.Display} (${flatMenus[1].display})`, (flatMenus) => `Edit ${this.itemMetaData.Display}`);
        this.addItemActionCodes(linksFieldSource.fieldItems, DwMenuActionType.view, (flatMenus) => `View ${this.itemMetaData.Display} (${flatMenus[1].display})`, (flatMenus) => `View ${this.itemMetaData.Display}`);
        this.addItemActionCodes(linksFieldSource.fieldItems, DwMenuActionType.list, (flatMenus) => `${flatMenus[0].display} (List)`, (flatMenus) => `${flatMenus[0].display}`);
        if (linksFieldSource.fieldItems.length > 0) {
            return linksFieldSource;
        }
    }
    addItemActionCodes(fieldItems, actionType, linkdisplay, emailDisplay) {
        var keyAttr = findWhere(this.itemMetaData.Attributes, { IsKey: true });
        if (!keyAttr) {
            return;
        }
        const keyCode = `[item.${keyAttr.AttributeName}]`;
        var routes = this.dwMetaDataRoutingService.findExistingRoutes(actionType, this.itemMetaData.UniqueItemName, keyCode);
        for (let route of routes) {
            let flatRoute = this.flattenRoutes(route);
            let url = flatRoute[0].url;
            url = url.replace(":itemName", this.itemMetaData.UniqueItemName);
            const paramName = getMenuActionParamName(this.itemMetaData.UniqueItemName);
            url = url.replace(paramName, keyCode);
            // Has to use http in front for the link to count (this is cleaned up when processing the e-mail template)
            const fullUrl = `http://${DwEmailGlobalValues.webSiteBasePath}${url}`;
            fieldItems.push({
                display: linkdisplay(flatRoute),
                insertCode: emailDisplay(flatRoute),
                linkUrl: fullUrl,
                toolTip: url
            });
        }
    }
    flattenRoutes(route, result) {
        if (!result) {
            result = [];
        }
        if (route && route.children && route.children.length > 0) {
            this.flattenRoutes(route.children[0], result);
        }
        result.push(route);
        return result;
    }
};
DwEmailTemplateComponent.ɵfac = function DwEmailTemplateComponent_Factory(t) { return new (t || DwEmailTemplateComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService)); };
DwEmailTemplateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEmailTemplateComponent, selectors: [["dw-email-template"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 2, consts: [[1, "label"], [3, "formGroup"], ["formControlName", "BodyTemplate", 3, "fieldSources"]], template: function DwEmailTemplateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1, "Body Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelement(3, "dw-html-edit", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fieldSources", ctx.htmlEditFieldSources);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwHtmlEditComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwEmailTemplateComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataRoutingService }
];
DwEmailTemplateComponent = __decorate$22([
    DwComponent({
        name: 'E-mail Body Template',
        key: 'dw-email-body-template',
        parentItemName: DevwareMetaDataItemNames.DwEmailTemplate,
        componentType: DwComponentType.formSection,
    }),
    __metadata$1B("design:paramtypes", [DwExpressionService,
        DwUiConfigRegistryService, Object, DwMetaDataService,
        DwMetaDataRoutingService])
], DwEmailTemplateComponent);

var __decorate$23 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const defaultUrlValidationUrl$3 = /^(ftp|http|https):\/\/[^ "]+$/;
var DwCountTags$1;
(function (DwCountTags) {
    DwCountTags["minCount"] = "minCount";
    DwCountTags["maxCount"] = "maxCount";
})(DwCountTags$1 || (DwCountTags$1 = {}));
const errorProperty$3 = 'gridInvalidCount';
let DwGridCountValidationRule = class DwGridCountValidationRule extends DwCountValidationRule {
    createValidator(config) {
        return DwGridValidateCount(config);
    }
};
DwGridCountValidationRule.ɵfac = function DwGridCountValidationRule_Factory(t) { return ɵDwGridCountValidationRule_BaseFactory(t || DwGridCountValidationRule); };
DwGridCountValidationRule.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridCountValidationRule, factory: function (t) { return DwGridCountValidationRule.ɵfac(t); } });
DwGridCountValidationRule = __decorate$23([
    DwValidationRule({
        keyName: 'dwGridCountValidator',
        display: 'Grid Count Validator',
        errorType: errorProperty$3,
        validationItemType: DwValidationItemType.childGrid,
        configComponent: DwCountValidatorConfigComponent,
        messageTemplate: '',
        tags: [
            { tag: DwValidationStandardTagNames.value, display: 'Value' },
            { tag: DwCountTags$1.minCount, display: 'Min Count' },
            { tag: DwCountTags$1.maxCount, display: 'Max Count' }
        ]
    })
], DwGridCountValidationRule);
function DwGridValidateCount(config) {
    return (control) => {
        var _a, _b;
        let count = 0;
        if ((_a = control.value) === null || _a === void 0 ? void 0 : _a.length) {
            count = (_b = control.value) === null || _b === void 0 ? void 0 : _b.length;
        }
        if ((config.minCount && count < config.minCount) || (config.maxCount && count > config.maxCount)) {
            const result = {};
            result[errorProperty$3] = {
                value: count,
                config: config
            };
            return result;
        }
    };
}

class DwMetaDataGridDependencyService {
    constructor(dwExpressionService, dwContextService) {
        this.dwExpressionService = dwExpressionService;
        this.dwContextService = dwContextService;
    }
    getDependencyGroup(gridPreferences, itemName) {
        const dependencies = {
            items: [],
            contexts: []
        };
        const itemDep = {
            itemName: itemName,
            attributes: [],
            queries: [],
            relationships: []
        };
        dependencies.items.push(itemDep);
        for (const view of (gridPreferences === null || gridPreferences === void 0 ? void 0 : gridPreferences.views) || []) {
            this.processView(view, itemDep, dependencies);
        }
        return dependencies;
    }
    processView(view, itemDep, dependencies) {
        let attributeList = itemDep.attributes;
        if (view.metaDataQueryMeaning) {
            const queryDep = this.getOrCreateQueryDependency(dependencies, itemDep, view.metaDataQueryMeaning);
            attributeList = queryDep.attributes;
        }
        this.processColumns(view, attributeList, dependencies);
        this.processFilters(view, attributeList, dependencies);
        this.processExports(view, attributeList, dependencies);
    }
    processColumns(view, attributeList, dependencies) {
        for (const column of view.columnPreferences) {
            this.processColumn(column, attributeList, dependencies);
        }
    }
    processFilters(view, attributeList, dependencies) {
        for (const filter of view.filters) {
            this.processFilter(filter, attributeList, dependencies);
        }
        if (!view.useFilterTiles) {
            return;
        }
        const filterTileConfig = view.filterTilesConfig;
        if (filterTileConfig.sharedFilterExpression) {
            this.processExpression(filterTileConfig.sharedFilterExpression, attributeList, dependencies, { filter: true });
        }
        for (const filterTile of filterTileConfig.tiles) {
            this.processFilterTile(filterTile, attributeList, dependencies);
        }
    }
    processExports(view, attributeList, dependencies) {
        if (!view.useCustomExport) {
            return;
        }
    }
    processFilterTile(filterTile, attributeList, dependencies) {
        if (filterTile.filterExpression) {
            this.processExpression(filterTile.filterExpression, attributeList, dependencies, { filter: true });
        }
        if (filterTile.visibleExpression) {
            this.processExpression(filterTile.filterExpression, attributeList, dependencies, { expression: true });
        }
    }
    processFilter(filter, attributeList, dependencies) {
        const attrDep = this.getOrCreateAttributeDependency(attributeList, filter.attr);
        attrDep.usage.filter = true;
    }
    processColumn(column, attributeList, dependencies) {
        const attrDep = this.getOrCreateAttributeDependency(attributeList, column.field);
        attrDep.usage.display = true;
        if (column.label) {
            attrDep.overrides.caption = column.label;
        }
        if (!column.conditionalFieldClasses) {
            return;
        }
        for (const propName in column.conditionalFieldClasses) {
            if (column.conditionalFieldClasses.hasOwnProperty(propName)) {
                const conditionalClassArray = column.conditionalFieldClasses[propName];
                for (const conditionalClass of conditionalClassArray) {
                    this.processExpression(conditionalClass.expression, attributeList, dependencies, { expression: true });
                }
            }
        }
    }
    processExpression(expression, attributeList, dependencies, usage) {
        const exprDependencies = this.dwExpressionService.getExpresionDependencies(expression);
        for (const exprDep of exprDependencies) {
            switch (exprDep.referenceType) {
                case DwExpressionReferenceType.item:
                    const attrDep = this.getOrCreateAttributeDependency(attributeList, exprDep.attrName);
                    this.setAttributeUsage(attrDep, usage);
                    break;
                case DwExpressionReferenceType.context:
                    const contextDep = this.getOrCreateContextDependency(dependencies, exprDep.contextName);
                    const contextAttrDep = this.getOrCreateAttributeDependency(contextDep.attributes, exprDep.attrName);
                    this.setAttributeUsage(contextAttrDep, usage);
                    break;
            }
        }
    }
    setAttributeUsage(attrDep, usageSettings) {
        if (!attrDep.usage) {
            attrDep.usage = {};
        }
        if (usageSettings === null || usageSettings === void 0 ? void 0 : usageSettings.display) {
            attrDep.usage.display = true;
        }
        if (usageSettings === null || usageSettings === void 0 ? void 0 : usageSettings.expression) {
            attrDep.usage.expression = true;
        }
        if (usageSettings === null || usageSettings === void 0 ? void 0 : usageSettings.filter) {
            attrDep.usage.filter = true;
        }
    }
    processActions(view, attributeList, dependencies) {
        for (const column of view.gridViewPreferences.columnPreferences) {
            const attrDep = this.getOrCreateAttributeDependency(attributeList, column.field);
            attrDep.usage.display = true;
            if (column.label) {
                attrDep.overrides.caption = column.label;
            }
        }
    }
    getOrCreateAttributeDependency(attributeList, attributeName) {
        let attrDep = attributeList.find(al => al.attributeName == attributeName);
        if (attrDep) {
            return attrDep;
        }
        attrDep = {
            attributeName: attributeName,
            usage: {},
            overrides: {}
        };
        attributeList.push(attrDep);
        return attrDep;
    }
    getOrCreateQueryDependency(dependencies, itemDep, queryMeaning) {
        let queryDep = itemDep.queries.find(q => q.queryMeaning == queryMeaning);
        if (queryDep) {
            return queryDep;
        }
        queryDep = {
            queryMeaning: queryMeaning,
            attributes: []
        };
        itemDep.queries.push(queryDep);
        return queryDep;
    }
    getOrCreateContextDependency(dependencies, contextMeaning) {
        let contextDep = dependencies.contexts.find(al => al.contextMeaning == contextMeaning);
        if (contextDep) {
            return contextDep;
        }
        const contextDef = this.dwContextService.contextDefinitions.find(cd => cd.contextName == contextMeaning);
        const isCodeContext = !(contextDef === null || contextDef === void 0 ? void 0 : contextDef.isServerDef);
        contextDep = {
            contextMeaning: contextMeaning,
            attributes: [],
            isCodeContext: isCodeContext
        };
        dependencies.contexts.push(contextDep);
        return contextDep;
    }
}
DwMetaDataGridDependencyService.ɵfac = function DwMetaDataGridDependencyService_Factory(t) { return new (t || DwMetaDataGridDependencyService)(ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwContextService)); };
DwMetaDataGridDependencyService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataGridDependencyService_Factory() { return new DwMetaDataGridDependencyService(ɵɵinject(DwExpressionService), ɵɵinject(DwContextService)); }, token: DwMetaDataGridDependencyService, providedIn: "root" });
DwMetaDataGridDependencyService.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwContextService }
];

class DwDependencyViewComponent {
    constructor(dwMetaDataGridDependencyService) {
        this.dwMetaDataGridDependencyService = dwMetaDataGridDependencyService;
    }
    ngOnChanges(changes) {
        this.dependencies = this.dwMetaDataGridDependencyService.getDependencyGroup(this.configPreferenecs, this.itemName);
    }
}
DwDependencyViewComponent.ɵfac = function DwDependencyViewComponent_Factory(t) { return new (t || DwDependencyViewComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridDependencyService)); };
DwDependencyViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDependencyViewComponent, selectors: [["dw-dependency-view"]], inputs: { configPreferenecs: "configPreferenecs", itemName: "itemName" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 3, template: function DwDependencyViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "b");
        ɵngcc0.ɵɵtext(1, "Dependencies");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "json");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.dependencies), "");
    } }, pipes: [ɵngcc4.JsonPipe], styles: [""] });
DwDependencyViewComponent.ctorParameters = () => [
    { type: DwMetaDataGridDependencyService }
];
DwDependencyViewComponent.propDecorators = {
    configPreferenecs: [{ type: Input }],
    itemName: [{ type: Input }]
};

class DwDataVariableListConfigComponent {
    constructor(dwMetaDataService, uiMetaDataConfig, dwUiConfigRegistryService, dwDataVariableService, cdr) {
        this.dwMetaDataService = dwMetaDataService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwDataVariableService = dwDataVariableService;
        this.cdr = cdr;
        this.variableConfigChange = new EventEmitter();
        this.attributeTypeLookupId = DevwareMetaDataLookups.MetaDataAttributeTypeAllItems;
        this.controlTypeLookupId = DevwareMetaDataLookups.MetaDataControlTypeAllItems;
        this.lookupLookupId = DevwareMetaDataLookups.MetaDataLookupAllItems;
        this.availableAttributes = [];
        this.newlyAdded = [];
        this.overrideEdit = false;
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Variable',
            displayField: 'display',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Variable',
            showListActionBar: false,
            showAdditionalTab: false,
            additionalTabHeading: 'Variable Options'
        };
        this.setupControl();
    }
    ngOnChanges(changes) {
        this.overrideEdit = false;
    }
    setSelectedItem(item) {
        this.selectedItem = item;
        this.isNewVariable = this.newlyAdded.indexOf(item) >= 0;
        this.onChanged();
    }
    addItem() {
        const newVariableInfo = this.getUniqueName();
        const newItem = {
            name: newVariableInfo.name,
            display: newVariableInfo.display,
            attributeType: DwAttributeTypeNumber.Text,
            controlType: DwControlType.Textbox,
            isLookup: false,
        };
        this.newlyAdded.push(newItem);
        // remove the array to it triggers a change
        this.variableConfig.variables = [...this.variableConfig.variables, newItem];
        this.onChanged();
    }
    getUniqueName() {
        for (let i = 1; i < 1000; i++) {
            const variableInfo = {
                name: `Variable_${i}`,
                display: `Variable ${i}`,
            };
            if (!this.variableConfig.variables.find(v => v.name == variableInfo.name)) {
                return variableInfo;
            }
        }
        const variableInfo = {
            name: `Variable_youhavetoomany}`,
            display: `Variable You Have Too Many!`,
        };
    }
    removeItem(item) {
        const index = this.variableConfig.variables.indexOf(item);
        if (this.selectedItem) {
            if (this.variableConfig.variables.indexOf(this.selectedItem) == index) {
                this.selectedItem = null;
            }
        }
        if (index >= 0) {
            this.variableConfig.variables.splice(index, 1);
        }
        this.onChanged();
    }
    removeAll() {
        this.variableConfig.variables = [];
        this.onChanged();
    }
    reorderList() {
        this.onChanged();
    }
    onCaptionChange(caption) {
        if (this.isNewVariable) {
            this.selectedItem.name = caption.replace(' ', '_').replace(' ', '_').replace(' ', '_').replace(' ', '_').replace(' ', '_').replace(' ', '_').replace(' ', '_').replace(' ', '_').replace(' ', '_');
        }
    }
    onChanged() {
        this.variableConfigChange.emit(this.variableConfig);
        this.cdr.detectChanges();
    }
    setupControl() {
        this.selectedItem = null;
        // Ensure we have a config setup
        if (!this.variableConfig) {
            this.variableConfig = {
                variables: []
            };
        }
        this.variableConfig.variables = this.variableConfig.variables || [];
    }
}
DwDataVariableListConfigComponent.ɵfac = function DwDataVariableListConfigComponent_Factory(t) { return new (t || DwDataVariableListConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwDataVariableService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwDataVariableListConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDataVariableListConfigComponent, selectors: [["dw-data-variable-list-config"]], inputs: { variableConfig: "variableConfig", configContext: "configContext" }, outputs: { variableConfigChange: "variableConfigChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 4, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Create a new variable", 1, "fa", "fa-plus-circle", "hand"], ["actionBar", ""], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], [4, "ngIf"], ["additionalTab", ""], ["header", "Basic Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["title", "Unique name for the variable that can only be set when creating a variable", 1, "fa", "fa-info-circle"], ["title", "You will need to manually fix any variable references", 1, "dw-blue", "pull-right", 3, "hidden", "click"], ["type", "text", 1, "form-control", 3, "ngModel", "disabled", "placeholder", "ngModelChange"], [3, "ngModel", "lookupId", "ngModelChange"], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"]], template: function DwDataVariableListConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 0);
        ɵngcc0.ɵɵlistener("selectedItemChange", function DwDataVariableListConfigComponent_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { return ctx.setSelectedItem($event); })("removeItem", function DwDataVariableListConfigComponent_Template_dw_ui_config_list_removeItem_0_listener($event) { return ctx.removeItem($event); })("reorder", function DwDataVariableListConfigComponent_Template_dw_ui_config_list_reorder_0_listener() { return ctx.reorderList(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function DwDataVariableListConfigComponent_Template_button_click_2_listener() { return ctx.addItem(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵtext(4, " Create Variable ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function DwDataVariableListConfigComponent_Template_button_click_6_listener() { return ctx.removeAll(); });
        ɵngcc0.ɵɵtext(7, "Remove All");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵtemplate(9, DwDataVariableListConfigComponent_p_accordion_9_Template, 33, 13, "p-accordion", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "div", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.variableConfig.variables)("config", ctx.listConfig)("selectedItem", ctx.selectedItem);
        ɵngcc0.ɵɵadvance(9);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItem);
    } }, directives: [DwUiConfigListComponent, ɵngcc4.NgIf, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwSearchSelectLookupComponent, ɵngcc10.InputSwitch], styles: [""] });
DwDataVariableListConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwUiConfigRegistryService },
    { type: DwDataVariableService },
    { type: ChangeDetectorRef }
];
DwDataVariableListConfigComponent.propDecorators = {
    configContext: [{ type: Input }],
    variableConfig: [{ type: Input }],
    variableConfigChange: [{ type: Output }]
};

class DwDataVariableEditConfigComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwDataVariableEditConfigComponent.ɵfac = function DwDataVariableEditConfigComponent_Factory(t) { return new (t || DwDataVariableEditConfigComponent)(); };
DwDataVariableEditConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDataVariableEditConfigComponent, selectors: [["dw-dw-data-variable-edit-config"]], decls: 2, vars: 0, template: function DwDataVariableEditConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-data-variable-edit-config works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwDataVariableEditConfigComponent.ctorParameters = () => [];

var __decorate$24 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1C = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwContextDefMultiSelectComponent extends DwControlBaseComponent {
    constructor(dwContextService) {
        super();
        this.dwContextService = dwContextService;
        this.contextNames = [];
        this.includeCustomContexts = false;
        this.contextDefinitions = [];
        this.selectedContextDefinitions = [];
    }
    ngOnInit() {
        this.setupContextDefinitions();
    }
    ngOnChanges(changes) {
        this.setupContextDefinitions();
    }
    writeValue(value) {
        super.writeValue(value);
        this.contextNames = value || [];
        this.setupContextDefinitions();
    }
    setupContextDefinitions() {
        this.contextDefinitions = this.dwContextService.getValidContextDefinitions(this.itemName, this.requiredContextNames, this.contextNames, this.includeCustomContexts);
        // add missing contexts
        for (let contextName of this.requiredContextNames || []) {
            // Set any additional contexts as required and don't let them be removed
            const contextDef = this.contextDefinitions.find(cd => cd.contextName == contextName);
            if (contextDef && !contextDef.isMissing) {
                contextDef.required = true;
            }
            const index = this.contextNames.indexOf(contextName);
            if (index == -1) {
                this.contextNames.push(contextName);
            }
        }
        this.selectedContextDefinitions = this.contextDefinitions.filter(cd => this.contextNames.indexOf(cd.contextName) >= 0);
        if (this.contextNames.length != this.selectedContextDefinitions.length) {
            this.onSelectedContextChanges();
        }
    }
    onSelectedContextChanges() {
        this.contextNames = this.selectedContextDefinitions.map(cd => cd.contextName);
        this.setValue(this.contextNames);
    }
}
DwContextDefMultiSelectComponent.ɵfac = function DwContextDefMultiSelectComponent_Factory(t) { return new (t || DwContextDefMultiSelectComponent)(ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwContextDefMultiSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwContextDefMultiSelectComponent, selectors: [["dw-context-def-multi-select"]], inputs: { includeCustomContexts: "includeCustomContexts", itemName: "itemName", requiredContextNames: "requiredContextNames" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwContextDefMultiSelectComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 5, consts: [["optionLabel", "contextDisplay", "optionDisabled", "required", "display", "chip", "appendTo", "body", "baseZIndex", "2000", 3, "options", "ngModel", "ngModelChange"], ["pTemplate", "selectedItems"], [1, "dw-chip-container"], ["class", "dw-chip", 4, "ngFor", "ngForOf"], [1, "dw-chip"]], template: function DwContextDefMultiSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-multiSelect", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwContextDefMultiSelectComponent_Template_p_multiSelect_ngModelChange_0_listener($event) { return ctx.selectedContextDefinitions = $event; })("ngModelChange", function DwContextDefMultiSelectComponent_Template_p_multiSelect_ngModelChange_0_listener() { return ctx.onSelectedContextChanges(); });
        ɵngcc0.ɵɵtemplate(1, DwContextDefMultiSelectComponent_ng_template_1_Template, 2, 1, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(4, _c43));
        ɵngcc0.ɵɵproperty("options", ctx.contextDefinitions)("ngModel", ctx.selectedContextDefinitions);
    } }, directives: [ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.PrimeTemplate, ɵngcc4.NgForOf], styles: [""] });
DwContextDefMultiSelectComponent.ctorParameters = () => [
    { type: DwContextService }
];
DwContextDefMultiSelectComponent.propDecorators = {
    itemName: [{ type: Input }],
    requiredContextNames: [{ type: Input }],
    includeCustomContexts: [{ type: Input }]
};
__decorate$24([
    DwInputConverter(booleanConverter),
    __metadata$1C("design:type", Boolean)
], DwContextDefMultiSelectComponent.prototype, "includeCustomContexts", void 0);
function DwInputConvertor(target, propertyKey) {
    throw new Error('Function not implemented.');
}

class DwDatasourceSelectComponent extends DwControlBaseComponent {
    constructor(uiConfigRegistry) {
        super();
        this.uiConfigRegistry = uiConfigRegistry;
    }
    ngOnInit() {
        this.setupDatasources();
    }
    ngOnChanges(changes) {
        if (changes.itemName) {
            this.setupDatasources();
        }
    }
    setupDatasources() {
        this.dataSources = this.uiConfigRegistry.getRegisteredDataSources(this.itemName, true);
    }
    translateTo(value) {
        // Converts value to null if it wasn't (this handles undefined and empty strings)
        if (!value) {
            return null;
        }
        return value;
    }
}
DwDatasourceSelectComponent.ɵfac = function DwDatasourceSelectComponent_Factory(t) { return new (t || DwDatasourceSelectComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwDatasourceSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDatasourceSelectComponent, selectors: [["dw-datasource-select"]], inputs: { itemName: "itemName" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwDatasourceSelectComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [["optionLabel", "display", "optionValue", "keyName", "display", "chip", 3, "options", "ngModel", "ngModelChange"]], template: function DwDatasourceSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dropdown", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwDatasourceSelectComponent_Template_p_dropdown_ngModelChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("options", ctx.dataSources)("ngModel", ctx.translatedValue);
    } }, directives: [ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwDatasourceSelectComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
DwDatasourceSelectComponent.propDecorators = {
    itemName: [{ type: Input }]
};

class DwOpenModalActionConfigComponent extends DwActionConfigBaseComponent {
    constructor(dwMetaDataService, dwContextService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.dwContextService = dwContextService;
        this.showKeyValue = false;
        this.lookupId = DevwareMetaDataLookups.MetaDataItemAllItems;
        this.contextList = [];
    }
    addControls() {
        this.addControl('item', Validators.required);
        this.actionTypeFC = this.addControl('actionType', Validators.required, DwMenuActionType.add);
        this.addControl('configKeyPart');
        this.addControl('keyValueAttrName');
        this.addControl('modalTitleOverride');
        this.useContextFC = this.addControl('useContext', null, false);
        this.contextNameFC = this.addControl('contextName');
        this.subscriptions.push(this.actionTypeFC.valueChanges.subscribe(actionType => {
            this.configureActionType(actionType);
        }));
        this.contextNameFC.valueChanges.subscribe(contextName => {
            if (contextName) {
                this.currentContextMd = this.contextMdList[contextName];
            }
        });
        this.setupMetaData();
    }
    configureActionType(actionType) {
        var _a;
        switch (actionType) {
            case DwMenuActionType.add:
                this.showKeyValue = false;
                break;
            case DwMenuActionType.edit:
            case DwMenuActionType.view:
            case DwMenuActionType.print:
                if ((_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName) {
                    this.showKeyValue = true;
                }
                break;
        }
    }
    setupMetaData() {
        var _a, _b;
        this.dwMetaDataService.getLookup(DevwareMetaDataLookups.MetaDataItemAllItems)
            .subscribe(items => {
            this.items = items.map(i => this.mapItem(i));
        });
        const hasContextItem = !!((_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemName);
        this.showKeyValue = false;
        this.actionTypes = new DwMenuActionTypeList().getEnumList().filter(i => i.value == DwMenuActionType.add || hasContextItem);
        if (!hasContextItem) {
            return;
        }
        this.dwMetaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes;
            this.setDefaultParams();
        });
        if (((_b = this.configContext.contextNames) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            this.dwContextService.getContextMetaDataList(this.configContext.contextNames)
                .subscribe(contextMdList => {
                this.contextMdList = contextMdList;
                this.setupContexts();
            });
        }
        else {
            this.useContextFC.setValue(false);
        }
    }
    setupContexts() {
        if (!this.contextMdList) {
            return;
        }
        for (const contextName of this.configContext.contextNames) {
            const contextDef = this.dwContextService.getContextDef(contextName);
            if (contextDef) {
                const contextDefMetaData = this.contextMdList[contextName];
                contextDef.contextDisplay;
                this.contextList.push(contextDef);
            }
        }
    }
    mapItem(i) {
        const item = Object.assign(Object.assign({}, i), { Id: i.UniqueItemName });
        return item;
    }
    setDefaultParams() {
        //throw new Error('Method not implemented.');
    }
}
DwOpenModalActionConfigComponent.ɵfac = function DwOpenModalActionConfigComponent_Factory(t) { return new (t || DwOpenModalActionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwOpenModalActionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwOpenModalActionConfigComponent, selectors: [["dw-open-modal-action-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["formControlName", "item", 3, "lookupId", "overrideValues"], ["formControlName", "actionType", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["title", "Replaces the default title for the modal", 1, "fa", "fa-info-circle"], ["type", "text", "formControlName", "modalTitleOverride", 1, "form-control"], ["title", "Used to determine which config should be used", 1, "fa", "fa-info-circle"], ["type", "text", "formControlName", "configKeyPart", 1, "form-control"], [3, "ngValue"], ["dwRow", "", 4, "ngIf"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "useContext"], [1, "label"], ["formControlName", "contextName", 1, "form-control"], ["dwCol", "12", 4, "ngIf"], ["formControlName", "keyValueAttrName", 1, "form-control"]], template: function DwOpenModalActionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwOpenModalActionConfigComponent_div_0_Template, 25, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG && ctx.items);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc10.InputSwitch], encapsulation: 2 });
DwOpenModalActionConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];

var __decorate$25 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1D = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwOpenItemModalActionService = class DwOpenItemModalActionService {
    constructor(dwMetaDataRoutingService) {
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
    }
    handleAction(actionState) {
        let keyValue = null;
        if (!actionState.actionConfig.item) {
            console.warn('Open Item Modal action is not properly configured since the item was not selected');
            return;
        }
        if (actionState.actionConfig.keyValueAttrName) {
            // keyValue = actionState.data[actionState.actionConfig.keyValueAttrName];
            keyValue = this.getKeyValue(actionState.actionConfig, actionState.data, actionState.context);
            if (!keyValue) {
                return;
            }
        }
        const modalOptions = {
            title: actionState.actionConfig.modalTitleOverride,
        };
        return this.dwMetaDataRoutingService.openAddEditViewModal(actionState.actionConfig.actionType, actionState.actionConfig.item, keyValue, null, null, actionState.actionConfig.configKeyPart, modalOptions, true)
            .pipe(map(modalResult => {
            // Use a grid result so we can trigger a grid refresh (other UI Components will just ignore it)
            const result = {
                success: !modalResult.cancelled,
                cancelled: modalResult.cancelled,
                dataActionResult: null,
                refreshData: !modalResult.cancelled
            };
            return result;
        }));
    }
    getKeyValue(config, data, resolvedContext) {
        if (!config.useContext) {
            if (!data) {
                return null;
            }
            return data[config.keyValueAttrName];
        }
        if (!resolvedContext || !config.contextName) {
            return null;
        }
        const context = resolvedContext[config.contextName];
        if (context) {
            return context[config.keyValueAttrName];
        }
    }
};
DwOpenItemModalActionService.ɵfac = function DwOpenItemModalActionService_Factory(t) { return new (t || DwOpenItemModalActionService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingService)); };
DwOpenItemModalActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwOpenItemModalActionService, factory: function (t) { return DwOpenItemModalActionService.ɵfac(t); } });
DwOpenItemModalActionService.ctorParameters = () => [
    { type: DwMetaDataRoutingService }
];
DwOpenItemModalActionService = __decorate$25([
    DwAction({
        keyName: DwRouteActionKeys.openItemModal,
        display: 'Open Item Modal',
        actionType: DwActionType.menuAction,
        configComponent: DwOpenModalActionConfigComponent,
        configData: {
            // Use this for grid row actions since this could be used in multiple contexts
            singleRowAction: true
        }
    }),
    __metadata$1D("design:paramtypes", [DwMetaDataRoutingService])
], DwOpenItemModalActionService);

var __decorate$26 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1E = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
let DwEnvironmentContextService = class DwEnvironmentContextService extends DwCustomContextBase {
    constructor(dwAppInitService, metadataConfig) {
        super();
        this.dwAppInitService = dwAppInitService;
        this.metadataConfig = metadataConfig;
    }
    setupContextDefinition(userContextDef) {
        userContextDef.cacheInvalidationTopics = [DwSecurityTopics.SECURITY_CHANGED];
        userContextDef.noCache = false;
        userContextDef.data = {};
        userContextDef.getCustomContextFunction = (context, contextData) => {
            if (this.lastResult) {
                return this.lastResult;
            }
            return this.dwAppInitService.getAppInitResult()
                .pipe(map(appInitResult => {
                this.lastResult = appInitResult.EnvironmentInfo;
                return appInitResult.EnvironmentInfo;
            }));
        };
        userContextDef.getCustomContextKey = (resolvedContext => 'Env');
        userContextDef.attributes = this.getContextAttribute();
    }
    getContextAttribute() {
        const attributes = [];
        this.addProperty(attributes, 'EnvironmentName', 'Environment Name');
        this.addProperty(attributes, 'IsProd', 'Is Prod', DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(attributes, 'IsTest', 'Is Test', DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(attributes, 'IsDev', 'Is Dev', DwAttributeType.YesNo, DwControlType.Checkbox);
        this.addProperty(attributes, 'ClientIPAddress', 'Client IP Address', DwAttributeType.Text, DwControlType.Textbox);
        this.addProperty(attributes, 'ClientIPAddressIsPrivate', 'Client IP Is Private', DwAttributeType.YesNo, DwControlType.Checkbox);
        return attributes;
    }
};
DwEnvironmentContextService.ɵfac = function DwEnvironmentContextService_Factory(t) { return new (t || DwEnvironmentContextService)(ɵngcc0.ɵɵinject(DwAppInitService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwEnvironmentContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwEnvironmentContextService, factory: function (t) { return DwEnvironmentContextService.ɵfac(t); } });
DwEnvironmentContextService.ctorParameters = () => [
    { type: DwAppInitService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
DwEnvironmentContextService = __decorate$26([
    DwCustomContextDefinition({
        keyName: 'dwEnvironmentContext',
        display: 'Environment Context',
        isGlobal: true,
    }),
    __metadata$1E("design:paramtypes", [DwAppInitService, Object])
], DwEnvironmentContextService);

class DwFormControlMultiSelectDateComponent extends DwFormControlDateTimeComponent {
}
DwFormControlMultiSelectDateComponent.ɵfac = function DwFormControlMultiSelectDateComponent_Factory(t) { return ɵDwFormControlMultiSelectDateComponent_BaseFactory(t || DwFormControlMultiSelectDateComponent); };
DwFormControlMultiSelectDateComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormControlMultiSelectDateComponent, selectors: [["dw-fc-multi-select-date"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[3, "formGroup"], [3, "formControlName"]], template: function DwFormControlMultiSelectDateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-date-multi-select", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDateMultiSelectComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwComponentFunc({
    key: 'dw-date-multi-select',
    name: 'Date Multi-select',
    componentType: DwComponentType.formControl,
    isGlobal: true,
}, DwFormControlMultiSelectDateComponent);

class DwMdTemplateService {
    constructor(uiMetaDataConfig, dwMetaDataService, dwTemplateUtil, dwContextService, dwConfigService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwTemplateUtil = dwTemplateUtil;
        this.dwContextService = dwContextService;
        this.dwConfigService = dwConfigService;
    }
    /**
     * Processes a template and return an observable that omits any updates to the template data
     * @param templateText
     * @param blankReplacementValue
     * @param dataSubject
     * @param context
     * @param queryMetaData
     * @returns
     */
    buildTemplateWithWatch(templateText, blankReplacementValue, dataSubject, context, queryMetaData, showLookupDisplays) {
        const template = this.dwTemplateUtil.parseTemplate(templateText);
        return this.setupTemplateSubscriptions(template, dataSubject, context)
            .pipe(mergeMap(() => {
            const options = { blankReplacementValue: blankReplacementValue || 'None' };
            // Map query meta data to options
            options.queryMetaData = queryMetaData;
            const dataValue = dataSubject === null || dataSubject === void 0 ? void 0 : dataSubject.value;
            const resolvedContext = this.dwContextService.getResolvedContext(context);
            return this.populateLookupDisplays(template, dataValue, queryMetaData, showLookupDisplays)
                .pipe(map(finalDataValue => {
                //console.log('buildTemplateWithWatch dataContextValue', dataValue);
                return this.dwTemplateUtil.processTemplate(template, finalDataValue, resolvedContext, this.dwConfigService.coreConfig.globals, options);
            }));
        }));
    }
    validateTemplate(templateText, queryMetaData, contextNames = []) {
        const template = this.dwTemplateUtil.parseTemplate(templateText);
        const validationResult = {
            isValid: true,
            errors: []
        };
        return this.dwContextService.getContextMetaDataList(contextNames)
            .pipe(map(contextMetaDataList => {
            for (let field of template.placeHolders) {
                const validationError = this.validateTemplateField(field, queryMetaData, contextMetaDataList);
                if (validationError) {
                    validationResult.errors.push(validationError);
                }
            }
            if (validationResult.errors.length > 0) {
                validationResult.isValid = false;
                validationResult.errorMessasge = validationResult.errors.map(e => e.errorMessasge).join(",");
            }
            return validationResult;
        }));
    }
    validateTemplateField(field, queryMetaData, contextMetaDataList) {
        var _a, _b;
        const validationError = {
            tagName: field.tagName,
            errorMessasge: ''
        };
        const baseFieldName = field.attrName.split(' ')[0].toUpperCase();
        switch (field.tagType) {
            case DwTagType.data:
                const attr = (_a = queryMetaData === null || queryMetaData === void 0 ? void 0 : queryMetaData.Attributes) === null || _a === void 0 ? void 0 : _a.find(a => baseFieldName == a.AttributeName.toUpperCase() || baseFieldName == a.DisplayAttributeName.toUpperCase());
                if (!attr) {
                    validationError.errorMessasge = `Attribute ${field.attrName} was not found`;
                    return validationError;
                }
                break;
            case DwTagType.context:
                const contextMetaData = contextMetaDataList[field.path];
                if (!contextMetaData) {
                    validationError.errorMessasge = `Context Definition ${field.path} was not found`;
                    return validationError;
                }
                const contextAttr = (_b = contextMetaData === null || contextMetaData === void 0 ? void 0 : contextMetaData.attributes) === null || _b === void 0 ? void 0 : _b.find(a => baseFieldName == a.AttributeName.toUpperCase() || baseFieldName == a.DisplayAttributeName.toUpperCase());
                if (!contextAttr) {
                    validationError.errorMessasge = `Context Attribute ${field.attrName} was not found`;
                    return validationError;
                }
        }
        return null;
    }
    populateLookupDisplays(template, dataValue, queryMetaData, showLookupDisplays) {
        if (!showLookupDisplays || !dataValue) {
            return of(dataValue);
        }
        const obs = [];
        for (let tag of template.placeHolders) {
            const ob = this.getLookupObservable(tag, dataValue, queryMetaData);
            if (ob) {
                obs.push(ob);
            }
        }
        if (obs.length == 0) {
            return of(dataValue);
        }
        return combineLatest(obs)
            .pipe(map(lookupResults => {
            //console.log('Template Service - Lookup Results', lookupResults);
            for (let lookupResult of lookupResults) {
                dataValue[lookupResult.attrName] = lookupResult.lookupDisplay;
            }
            return dataValue;
        }));
    }
    getLookupObservable(tag, dataValue, queryMetaData) {
        var _a, _b;
        if (tag.tagType != DwTagType.data) {
            return null;
        }
        let attr = queryMetaData.Attributes.find(a => a.DisplayAttributeName == tag.attrName);
        if (attr == null) {
            attr = queryMetaData.Attributes.find(a => `${a.AttributeName}Display` == tag.attrName);
        }
        if (!((_a = attr === null || attr === void 0 ? void 0 : attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsLookup) || !((_b = attr === null || attr === void 0 ? void 0 : attr.Attribute) === null || _b === void 0 ? void 0 : _b.MetaDataLookupId)) {
            return null;
        }
        if (dataValue == null) {
            return of({ attrName: tag.attrName, lookupDisplay: '', lookupValue: null });
        }
        const lookupValue = dataValue[attr.AttributeName];
        if (!lookupValue) {
            return of({ attrName: tag.attrName, lookupDisplay: '', lookupValue: lookupValue });
        }
        // Now we have a value and an attribute that is for a lookup
        return this.dwMetaDataService.getSingleLookupItem(attr.Attribute.MetaDataLookupId, lookupValue)
            .pipe(map(lookupItem => {
            const lookupDisplay = lookupItem === null || lookupItem === void 0 ? void 0 : lookupItem.Display;
            return { attrName: tag.attrName, lookupDisplay: lookupDisplay, lookupValue: lookupValue };
        }));
    }
    setupTemplateSubscriptions(template, dataSubject, contexts) {
        const subject = new BehaviorSubject(null);
        const formContext = contexts[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        const missingContexts = [];
        const contextObservables = {};
        // Add the data subject so when it changes the data will also be refreshed
        if (dataSubject) {
            contextObservables.dataSubject = dataSubject;
        }
        for (let placeHolder of template.placeHolders) {
            let contextName = this.getContextName(placeHolder);
            if (!contextName) {
                continue;
            }
            const context = contexts[contextName];
            if (!context) {
                missingContexts.push(contextName);
                continue;
            }
            if (!contextObservables[contextName]) {
                contextObservables[contextName] = context.asObservable();
            }
        }
        if (missingContexts.length > 0) {
            if (formContext === null || formContext === void 0 ? void 0 : formContext.value.loadDataComplete) {
                console.warn(`Missing context names : ${missingContexts.join(',')}`);
            }
            if (!contextObservables.formSubscription) {
                return formContext.pipe(
                // Only return if load data complete is true
                filter(value => value === null || value === void 0 ? void 0 : value.loadDataComplete), mergeMap(value => {
                    return this.setupTemplateSubscriptions(template, dataSubject, contexts);
                }));
            }
        }
        const obArray = unflattenArray(contextObservables);
        combineLatest(unflattenArray(contextObservables))
            .subscribe(values => {
            subject.next(null);
        });
        return subject.asObservable();
    }
    getContextName(placeHolder) {
        switch (placeHolder.tagType) {
            case DwTagType.context:
                return placeHolder.path;
            case DwTagType.data:
                return DwMdFormContextInfo.DATA_CONTEXT_NAME;
        }
        return null;
    }
}
DwMdTemplateService.ɵfac = function DwMdTemplateService_Factory(t) { return new (t || DwMdTemplateService)(ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwTemplateUtilService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwConfigServiceToken)); };
DwMdTemplateService.ɵprov = ɵɵdefineInjectable({ factory: function DwMdTemplateService_Factory() { return new DwMdTemplateService(ɵɵinject(DwUIMetaDataConfigToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwTemplateUtilService), ɵɵinject(DwContextService), ɵɵinject(DwConfigServiceToken)); }, token: DwMdTemplateService, providedIn: "root" });
DwMdTemplateService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwTemplateUtilService },
    { type: DwContextService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];

var __decorate$27 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1F = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwTemplateViewControlComponent {
    constructor(dwMdTemplateService, dwMetaDataService) {
        this.dwMdTemplateService = dwMdTemplateService;
        this.dwMetaDataService = dwMetaDataService;
        this.blankReplacementValue = 'None';
        this.blankPlaceholder = "&nbsp;";
        this.showLookupDisplays = true;
        this.isHtml = false;
    }
    ngOnInit() {
        this.setupTemplateWatch();
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.setupTemplateWatch();
        }
    }
    ngOnDestroy() {
        this.cleanUpSubscriptions();
    }
    setupTemplateWatch() {
        this.cleanUpSubscriptions();
        this.templateResult = this.blankPlaceholder;
        this.templateWatchSubscription =
            this.ensureQueryMetaData()
                .pipe(mergeMap(() => {
                return this.dwMdTemplateService.buildTemplateWithWatch(this.templateText, this.blankReplacementValue, this.dataSubject, this.context, this.queryMetaData, this.showLookupDisplays);
            }))
                .subscribe(templateResult => {
                this.templateResult = templateResult || this.blankPlaceholder;
            });
    }
    cleanUpSubscriptions() {
        if (this.templateWatchSubscription) {
            this.templateWatchSubscription.unsubscribe();
            this.templateWatchSubscription = null;
        }
    }
    ensureQueryMetaData() {
        if (this.queryMetaData) {
            return of(null);
        }
        return this.dwMetaDataService.getSavedQueryMetaData(this.item)
            .pipe(map(queryMetaData => {
            this.queryMetaData = queryMetaData;
        }));
    }
}
DwTemplateViewControlComponent.ɵfac = function DwTemplateViewControlComponent_Factory(t) { return new (t || DwTemplateViewControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwMdTemplateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwTemplateViewControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTemplateViewControlComponent, selectors: [["dw-template-view-control"]], inputs: { blankReplacementValue: "blankReplacementValue", blankPlaceholder: "blankPlaceholder", showLookupDisplays: "showLookupDisplays", isHtml: "isHtml", queryMetaData: "queryMetaData", templateText: "templateText", dataSubject: "dataSubject", context: "context", item: "item" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "ngModel", "ngModelChange", 4, "ngIf"], [3, "ngModel", "ngModelChange"]], template: function DwTemplateViewControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwTemplateViewControlComponent_span_0_Template, 2, 1, "span", 0);
        ɵngcc0.ɵɵtemplate(1, DwTemplateViewControlComponent_dw_html_view_1_Template, 1, 1, "dw-html-view", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isHtml);
    } }, directives: [ɵngcc4.NgIf, DwHtmlViewComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwTemplateViewControlComponent.ctorParameters = () => [
    { type: DwMdTemplateService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwTemplateViewControlComponent.propDecorators = {
    templateText: [{ type: Input }],
    dataSubject: [{ type: Input }],
    blankReplacementValue: [{ type: Input }],
    blankPlaceholder: [{ type: Input }],
    queryMetaData: [{ type: Input }],
    context: [{ type: Input }],
    item: [{ type: Input }],
    showLookupDisplays: [{ type: Input }],
    isHtml: [{ type: Input }]
};
__decorate$27([
    DwInputConverter(booleanConverter),
    __metadata$1F("design:type", Boolean)
], DwTemplateViewControlComponent.prototype, "showLookupDisplays", void 0);
__decorate$27([
    DwInputConverter(booleanConverter),
    __metadata$1F("design:type", Boolean)
], DwTemplateViewControlComponent.prototype, "isHtml", void 0);

var __decorate$28 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1G = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwTemplateConfigControlComponent extends DwControlBaseComponent {
    constructor() {
        super(...arguments);
        this.dataPrefix = 'data';
        this.excludeDataPrefix = false;
        this.fieldReference = {};
    }
    ngOnInit() {
        var _a;
        if (this.item) {
            this.fieldReference = { referenceType: DwExpressionReferenceType.item };
        }
        else {
            if (((_a = this.contextNames) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.fieldReference = { referenceType: DwExpressionReferenceType.context };
            }
        }
    }
    addField() {
        var _a;
        if (!((_a = this.fieldReference) === null || _a === void 0 ? void 0 : _a.attrName)) {
            return;
        }
        let prefix = this.dataPrefix;
        let templateField = '';
        switch (this.fieldReference.referenceType) {
            case DwExpressionReferenceType.context:
                templateField = `[context.${this.fieldReference.contextName}.${this.fieldReference.attrName}]`;
                break;
            case DwExpressionReferenceType.item:
                if (this.excludeDataPrefix) {
                    templateField = `[${this.fieldReference.attrName}]`;
                }
                else {
                    templateField = `[${prefix}.${this.fieldReference.attrName}]`;
                }
        }
        // if (this.fieldReference.referenceType == DwExpressionReferenceType.context && this.fieldReference.contextName) {
        //   prefix = `context.${this.fieldReference.contextName}`;
        // }
        // const templateField = `[${prefix}.${this.fieldReference.attrName}]`;
        this.value = this.value || '';
        this.value += templateField;
        // this.fieldReference = null;
        this.onChange();
    }
}
DwTemplateConfigControlComponent.ɵfac = function DwTemplateConfigControlComponent_Factory(t) { return ɵDwTemplateConfigControlComponent_BaseFactory(t || DwTemplateConfigControlComponent); };
DwTemplateConfigControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTemplateConfigControlComponent, selectors: [["dw-template-config-control"]], inputs: { dataPrefix: "dataPrefix", excludeDataPrefix: "excludeDataPrefix", item: "item", contextNames: "contextNames", queryMeaning: "queryMeaning", showDisplayAttributes: "showDisplayAttributes" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwTemplateConfigControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 6, consts: [["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "pull-left"], [3, "ngModel", "item", "queryMeaning", "contextNames", "showDisplayAttributes", "ngModelChange"], [1, "btn-sn", "btn-success", "ml-2", 3, "click"], [1, "fa", "fa-plus-circle"]], template: function DwTemplateConfigControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "textarea", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwTemplateConfigControlComponent_Template_textarea_ngModelChange_0_listener($event) { return ctx.value = $event; })("ngModelChange", function DwTemplateConfigControlComponent_Template_textarea_ngModelChange_0_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "dw-expression-reference-control", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwTemplateConfigControlComponent_Template_dw_expression_reference_control_ngModelChange_3_listener($event) { return ctx.fieldReference = $event; })("ngModelChange", function DwTemplateConfigControlComponent_Template_dw_expression_reference_control_ngModelChange_3_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function DwTemplateConfigControlComponent_Template_button_click_5_listener() { return ctx.addField(); });
        ɵngcc0.ɵɵelement(6, "i", 4);
        ɵngcc0.ɵɵtext(7, " Add Field");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngModel", ctx.value);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.fieldReference)("item", ctx.item)("queryMeaning", ctx.queryMeaning)("contextNames", ctx.contextNames)("showDisplayAttributes", ctx.showDisplayAttributes);
    } }, directives: [ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwExpressionReferenceControlComponent], encapsulation: 2 });
DwTemplateConfigControlComponent.propDecorators = {
    item: [{ type: Input }],
    contextNames: [{ type: Input }],
    queryMeaning: [{ type: Input }],
    dataPrefix: [{ type: Input }],
    showDisplayAttributes: [{ type: Input }],
    excludeDataPrefix: [{ type: Input }]
};
__decorate$28([
    DwInputConverter(booleanConverter),
    __metadata$1G("design:type", Boolean)
], DwTemplateConfigControlComponent.prototype, "showDisplayAttributes", void 0);
__decorate$28([
    DwInputConverter(booleanConverter),
    __metadata$1G("design:type", Boolean)
], DwTemplateConfigControlComponent.prototype, "excludeDataPrefix", void 0);

var __decorate$29 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1H = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwTitleTemplatesConfigComponent extends DwControlBaseComponent {
    //value: DwSectionTitleTemplate[];
    constructor(dwUiConfigRegistryService) {
        super();
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
    }
    ngOnInit() {
        if (!this.value) {
            this.value = {};
        }
        ;
        //this.value.loadLookupDisplays
        this.value.titleTemplates = this.value.titleTemplates || [];
        this.containerStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.containerStyles);
    }
    addTemplate() {
        this.value.titleTemplates = this.value.titleTemplates || [];
        this.value.titleTemplates.push({});
        this.onChange();
    }
}
DwTitleTemplatesConfigComponent.ɵfac = function DwTitleTemplatesConfigComponent_Factory(t) { return new (t || DwTitleTemplatesConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwTitleTemplatesConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTitleTemplatesConfigComponent, selectors: [["dw-title-templates-config"]], inputs: { item: "item", contextNames: "contextNames", parentUseContainerStyling: "parentUseContainerStyling" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwTitleTemplatesConfigComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 11, vars: 3, consts: [["dwRow", ""], ["dwCol", "2"], [1, "btn-sm", "btn-success", 3, "click"], ["dwCol", "4"], ["title", "Allows shows the display values for lookups and will load automatically", 1, "fa", "fa-info-circle"], [3, "ngModel", "ngModelChange"], ["dwCol", "4", 4, "ngIf"], [3, "items", "itemsChange", 4, "ngIf"], ["title", "Allows customizing the container style and icon", 1, "fa", "fa-info-circle"], [3, "items", "itemsChange"], [4, "dwListItem"], ["dwCol", "12"], ["title", "", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "item", "showDisplayAttributes", "ngModelChange"], ["title", "Uses the first expression which evaluates to true", 1, "fa", "fa-info-circle"], [3, "ngModel", "contextNames", "item", "ngModelChange"], [4, "ngIf"], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "hidden"], [3, "ngValue"]], template: function DwTitleTemplatesConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2);
        ɵngcc0.ɵɵlistener("click", function DwTitleTemplatesConfigComponent_Template_button_click_2_listener() { return ctx.addTemplate(); });
        ɵngcc0.ɵɵtext(3, "Add Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Load Lookup Displays ");
        ɵngcc0.ɵɵelement(7, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "dw-yesno", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwTitleTemplatesConfigComponent_Template_dw_yesno_ngModelChange_8_listener($event) { return ctx.value.loadLookupDisplays = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DwTitleTemplatesConfigComponent_div_9_Template, 5, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, DwTitleTemplatesConfigComponent_dw_ordered_list_10_Template, 2, 1, "dw-ordered-list", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngModel", ctx.value.loadLookupDisplays);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.parentUseContainerStyling);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.value.titleTemplates == null ? null : ctx.value.titleTemplates.length) > 0);
    } }, directives: [DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwOrderedListComponent, DwListItemDirective, DwTemplateConfigControlComponent, DwExpressionPickerControlComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ColorSelectComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwTitleTemplatesConfigComponent.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
DwTitleTemplatesConfigComponent.propDecorators = {
    item: [{ type: Input }],
    contextNames: [{ type: Input }],
    parentUseContainerStyling: [{ type: Input }]
};
__decorate$29([
    DwInputConverter(booleanConverter),
    __metadata$1H("design:type", Boolean)
], DwTitleTemplatesConfigComponent.prototype, "parentUseContainerStyling", void 0);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwConfigService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DwConfigLoaderToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEventService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLoggingService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.Router }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: ɵngcc0.Injector }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwStorageUtil, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCacheService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwEventService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwStorageUtil }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdEventService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwEventService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityStateService, [{
        type: Injectable
    }], function () { return [{ type: DwLoggingService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwStorageUtil }, { type: DwEventService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMessagingService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwLoggingService }, { type: ɵngcc2.Router }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityStateService }, { type: ɵngcc0.Injector }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMessagingInterceptor, [{
        type: Injectable
    }], function () { return [{ type: DwMessagingService }, { type: DwLoggingService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwOrmDataService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwEventService }, { type: DwMdEventService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareMetaDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppInitService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwStorageUtil }, { type: DwCacheService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DwAppInitHandlerToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwEventService }, { type: DwCacheService }, { type: DwAppInitService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDefaultGridPage, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector 
                selector: 'dw-default-grid',
                template: ` 
        <dw-router-parent>   
            <ng-template>
                <dw-content-manager [configKey]="contentConfigKey" [item]="item">
                    <h1>
                        <dw-content name="title" display="Page Title" [controlType]="textboxControlType">
                        </dw-content>
                    </h1>

                    <dw-content name="detail" display="Header Details">
                    </dw-content>

                    <dw-content-component name="component" display="Custom Component"></dw-content-component>
                </dw-content-manager>
            
                <div [id]="configKeyPart">
                    <dw-meta-data-grid [item]="item" [configKeyPart]="configKeyPart" [preferences]="gridPreferences"></dw-meta-data-grid>
                </div>
            </ng-template>
        </dw-router-parent>
`
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: ɵngcc2.Router }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { item: [{
            type: Input
        }], gridPreferences: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwModalService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwEventService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiConfigRegistryService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityRepositoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwStorageUtil }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwAppInitService }, { type: DwCacheService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityUserService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwSecurityStateService }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuHelperService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwSecurityUserService }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DwMenuProcessorToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGoogleAnalyticsService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: ɵngcc2.Router }, { type: ɵngcc2.ActivatedRoute }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityUserService }, { type: ɵngcc2.Router }, { type: ɵngcc2.ActivatedRoute }, { type: DwGoogleAnalyticsService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecuritySSOService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwStorageUtil }, { type: DwLoggingService }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwCacheService }, { type: ɵngcc0.Injector }, { type: ɵngcc2.Router }, { type: DwSecurityStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityOrchestrationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwSecurityStateService }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityUserService }, { type: DwEventService }, { type: DwMessagingService }, { type: ɵngcc2.Router }, { type: DwSecuritySSOService }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAuthGuardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }, { type: DwSecurityStateService }, { type: DwSecurityOrchestrationService }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwServiceExecutionUtil, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCanDeactivateGuard, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuBuilderService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMenuHelperService }, { type: DwSecurityUserService }, { type: DwUiConfigRegistryService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwServiceExecutionUtil }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMenuBuilderService }, { type: DwMenuHelperService }, { type: ɵngcc2.Router }, { type: ɵngcc2.ActivatedRoute }, { type: DwSecurityUserService }, { type: DwEventService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: Array, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DwMenuProcessorToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiConfigService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwCacheService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwUiConfigRegistryService }, { type: ɵngcc0.Injector }, { type: DwLoggingService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwMenuService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormUtilService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContextDefaultsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwSecurityUserService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContextRepositoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwCacheService }, { type: DwAppInitService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContextService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwCacheService }, { type: DwContextDefaultsService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextRepositoryService }, { type: DwUiConfigRegistryService }, { type: DwServiceExecutionUtil }, { type: DwLoggingService }, { type: DwEventService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormActionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataVariableService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigService }, { type: DwUiConfigRegistryService }, { type: DwMetadataFormUtilService }, { type: DwContextService }, { type: DwServiceExecutionUtil }, { type: DwMetaDataFormActionService }, { type: DwLoggingService }, { type: DwDataVariableService }]; }, null); })();
const ɵDwDesignerStateService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwDesignerStateService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDesignerStateService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiPanelWidgetBaseComponent, [{
        type: Directive
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwDesignerStateService }]; }, { preferencesChange: [{
            type: Output
        }], preferenceChangeWithSave: [{
            type: Output
        }], messageChange: [{
            type: Output
        }], preferences: [{
            type: Input
        }], message: [{
            type: Input
        }], preferencesHierarchy: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataRoutingService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMenuService }, { type: DwMenuHelperService }, { type: DwMenuBuilderService }, { type: DwModalService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwComponentHost, [{
        type: Directive,
        args: [{
                selector: '[dw-component-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSectionConfigTreeService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetadataFormUtilService }, { type: DwUiConfigRegistryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSectionConfigStateService, [{
        type: Injectable
    }], function () { return [{ type: DwSectionConfigTreeService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormService }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataSectionConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-section-config',
                template: "<div *ngIf=\"setupComplete\" class=\"p-tab-no-borders\">\r\n    <div class=\"main-container\">\r\n        <p-splitter [style]=\"{'height': '605px'}\" [panelSizes]=\"[30, 70]\">\r\n            <ng-template pTemplate>\r\n                <div class=\"dw-panel\">\r\n                    <p-tree [value]=\"dwSectionConfigStateService.state.sectionTree\" selectionMode=\"single\"\r\n                        [selection]=\"dwSectionConfigStateService.state.currentSectionNode\"\r\n                        (selectionChange)=\"setCurrentSection($event)\"\r\n                        [style]=\"{'height':'600px', 'width':'100%','max-height':'600px','overflow':'auto'}\"\r\n                        draggableNodes=\"true\" droppableNodes=\"true\" (onNodeDrop)=\"nodeDropped($event)\"\r\n                        (onNodeExpand)=\"nodeExpand($event)\" [validateDrop]=\"true\">\r\n                        <ng-template let-node pTemplate=\"section\">\r\n                            <span (contextmenu)=\"nodeMenu($event, node)\">\r\n                                {{node.label}}\r\n                            </span>\r\n                        </ng-template>\r\n                        <ng-template let-node pTemplate=\"other\">\r\n                            <span (contextmenu)=\"nodeMenu($event, node)\">\r\n                                {{node.label}} - Other\r\n                            </span>\r\n                        </ng-template>\r\n                    </p-tree>\r\n                </div>\r\n            </ng-template>\r\n            <ng-template pTemplate>\r\n                <div class=\"dw-panel\">\r\n                    <dw-config-panel-host></dw-config-panel-host>\r\n                </div>\r\n            </ng-template>\r\n        </p-splitter>\r\n\r\n        <p-contextMenu #cmSection [model]=\"cmSectionItems\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-contextMenu>\r\n    </div>\r\n</div>",
                encapsulation: ViewEncapsulation.None,
                providers: [TreeDragDropService, DwSectionConfigStateService],
                styles: [".move-arrow-down{display:block;margin-top:-25px}.main-container{min-width:800px;width:100%}.dw-panel{height:100%;width:100%}.dw-panel .dw-panel-left{float:left;height:100%;width:320px}.dw-panel .dw-panel-right{float:left;height:100%;min-width:800px;padding-left:5px;width:calc(100% - 390px)}.dw-panel-flex{background-color:#000;display:flex;flex-flow:row;height:100%;padding:5px}.dw-panel-flex .dw-panel-left{background-color:#add8e6;display:flex;flex-direction:row;padding:5px;width:300px}.dw-panel-flex .dw-panel-right{background-color:#90ee90;display:flex;flex:3;flex-basis:100%;flex-direction:row;min-width:500px;padding:5px}.ui-tree{width:100%}.tree-icon{color:#4dbd74!important}.button-icon{color:#00f!important}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormService }, { type: ɵngcc3.FormBuilder }, { type: ɵngcc0.ComponentFactoryResolver }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }, { type: DwLoggingService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwMetadataFormUtilService }, { type: DwSectionConfigTreeService }, { type: DwSectionConfigStateService }]; }, { dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost]
        }], cmSection: [{
            type: ViewChild,
            args: ["cmSection"]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormWorkflowConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-form-workflow-config',
                template: "<div style=\"max-width2:500px\">  \r\n    <form [formGroup]=\"formGroup\">\r\n    <p-tabView *ngIf=\"formGroup\">\r\n        <p-tabPanel header=\"Buttons\"> \r\n            <div dwRow> \r\n                <div dwCol=\"6\" formGroupName=\"workflowPreferences\">\r\n                    <label>Enable Workflow</label><br>\r\n                    <p-inputSwitch formControlName=\"enableWorkflow\"></p-inputSwitch>\r\n                </div>\r\n                <div dwCol=\"6\" *ngIf=\"!enableWorkflowFC?.value\">\r\n                    <label>Use Default Buttons</label><br>\r\n                    <p-inputSwitch formControlName=\"useButtonDefaults\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <ng-container *ngIf=\"!formGroup?.useButtonDefaults?.value\">\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <dw-pills [items]=\"formModes\" [(ngModel)]=\"currentFormMode\" [ngModelOptions]=\"{standalone: true}\"></dw-pills>\r\n                    </div>\r\n                </div>\r\n\r\n                \r\n            </ng-container>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Workflow\" *ngIf=\"enableWorkflowFC?.value\" formGroupName=\"workflowPreferences\"> \r\n            <div dwRow> \r\n                <div dwCol=\"6\">\r\n                    <label>Workflow Attribute</label>\r\n                    <select formControlName=\"workflowAttrName\" class=\"form-control\">\r\n                        <option value=\"\"></option>\r\n                        <option *ngFor=\"let attr of itemAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                            {{ attr.Display }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!enableWorkflowFC?.value || !workflowAttrNameFC.value\">\r\n                <div dwCol=\"6\">\r\n                    <label>Button Display Attr</label><br>\r\n                    <select formControlName=\"buttonDisplayAttrName\" class=\"form-control\">\r\n                            <option value=\"\"></option>\r\n                            <option *ngFor=\"let attr of lookupAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                                {{ attr.Display }}\r\n                            </option>\r\n                        </select> \r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Button Class</label><br>\r\n                    <select formControlName=\"buttonClassAttrName\" class=\"form-control\">\r\n                            <option value=\"\"></option>\r\n                            <option *ngFor=\"let attr of lookupAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                                {{ attr.Display }}\r\n                            </option>\r\n                        </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!enableWorkflowFC?.value || !workflowAttrNameFC.value\">\r\n                <div dwCol=\"6\">\r\n                    <label>Tool Tip Attr</label><br>\r\n                    <select formControlName=\"toolTipAttrName\" class=\"form-control\">\r\n                            <option value=\"\"></option>\r\n                            <option *ngFor=\"let attr of lookupAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                                {{ attr.Display }}\r\n                            </option>\r\n                        </select> \r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Require Validation Attr</label>\r\n                    <select formControlName=\"requireValidationAttrName\" class=\"form-control\">\r\n                        <option value=\"\"></option>\r\n                        <option *ngFor=\"let attr of lookupAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                            {{ attr.Display }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\" >\r\n                    <label>Use Alternate Action</label><br>\r\n                    <p-inputSwitch formControlName=\"useAlternateActionDisplay\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!enableWorkflowFC?.value || !workflowAttrNameFC.value\">\r\n                <div dwCol=\"6\" >\r\n                    <label>Override Current Status Display</label><br>\r\n                    <p-inputSwitch formControlName=\"overrideCurrentStatusDisplay\"></p-inputSwitch>\r\n                </div>\r\n                <div dwCol=\"6\" >\r\n                    <label>Override Current Status Display</label><br>\r\n                    <input type=\"text\" formControlName=\"currentStatusDisplay\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n        \r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Test Workflow\" *ngIf=\"lookupId\">\r\n        <button class=\"btn btn-success\" (click)=\"resetTest()\">Reset Test</button>\r\n        <div dwRow>\r\n            <div dwCol=\"6\" >\r\n                <label>Current Status</label><br>\r\n                <dw-select-lookup [lookupId]=\"lookupId\" [ngModel]=\"initialStatusValue\" (ngModelChange)=\"changeInitialValue($event)\" useTransitions=\"false\" [ngModelOptions]=\"{standalone: true}\"></dw-select-lookup>\r\n            </div>\r\n        </div>\r\n        <dw-button-bar [hidden]=\"handlingWorkflowClick\">\r\n            <dw-workflow-lookup-buttons [lookupId]=\"lookupId\" [ngModel]=\"initialStatusValue\" (ngModelChange)=\"changeInitialValue($event)\"  [ngModelOptions]=\"{standalone: true}\" [workflowPreferences]=\"formGroup.value.workflowPreferences\" (buttonClick)=\"workflowButtonClick($event)\"></dw-workflow-lookup-buttons>\r\n\r\n            {{initialStatusValue}}\r\n        </dw-button-bar>\r\n    </p-tabPanel>\r\n</p-tabView>\r\n</form>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormService }, { type: ɵngcc3.FormBuilder }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwModalService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRulesRegistry, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionComparersService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwContextService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwLoggingService }, { type: DwExpressionComparersService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRuleService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwRulesRegistry }, { type: DwExpressionService }, { type: DwCacheService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormConfigWidgetComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-form-config-widget',
                template: "\r\n<div *ngIf=\"!preferences\">\r\n    No preferences loaded\r\n</div>\r\n<div *ngIf=\"preferences\">\r\n    <h3>Form Preferences</h3>\r\n\r\n    <form [formGroup]=\"configForm\" (ngSubmit)=\"onSubmit()\">\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Basic Settings\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Read Only</label>\r\n                    </div>\r\n                    <div>\r\n                        <p-inputSwitch formControlName=\"readOnly\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Use Long Display</label>\r\n                    </div>\r\n                    <div >\r\n                        <p-inputSwitch formControlName=\"useLongDisplay\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Load Display Values</label>\r\n                    </div>\r\n                    <div>\r\n                        <p-inputSwitch formControlName=\"loadDisplayProperties\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Validation Summary</label>\r\n                    </div>\r\n                    <div >\r\n                        <p-inputSwitch formControlName=\"useValidationSummary\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Message Location</label>\r\n                        <select formControlName=\"messageLocation\" class=\"form-control\">\r\n                            <option ngValue=\"null\">Default</option>\r\n                            <option *ngFor=\"let item of messageLocations\" [ngValue]=\"item.value\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Suppress Unsaved changes message</label>\r\n                    </div>\r\n                    <div>\r\n                        <p-inputSwitch formControlName=\"suppressUnsavedChangesMessage\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Sections\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configureSection()\" class=\"btn-sm btn-success\">\r\n                           Configure Sections\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"editMetaDataItem()\" class=\"btn-sm btn-success\">Edit Meta Data Item</button>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Data Setup\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Data Source</label>\r\n                        <select formControlName=\"dataSourceName\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\">Default</option>\r\n                            <option *ngFor=\"let dataSource of dataSources\" [ngValue]=\"dataSource.keyName\">\r\n                                {{dataSource.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Context Data</label>\r\n                        <dw-context-def-multi-select formControlName=\"contextNames\" [itemName]=\"formPreferencesHierarchy.item\" [requiredContextNames]=\"formPreferences.requiredContextNames\">\r\n                        </dw-context-def-multi-select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow *ngIf=\"false\"> \r\n                    <div dwCol=\"12\">\r\n                        <label>Ignore Fields</label>\r\n                        <input type=\"text\" formControlName=\"ignoreAttributes\" />\r\n                    </div>   \r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </form>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwEventService }, { type: DwModalService }, { type: DwMetaDataFormService }, { type: DwMetaDataRoutingService }, { type: DwContextService }, { type: ɵngcc2.ActivatedRoute }, { type: DwUiConfigRegistryService }, { type: DwMetaDataFormConfigService }, { type: DwRuleService }, { type: DwDataVariableService }, { type: DwDesignerStateService }, { type: DwUiConfigService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwValidationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: ɵngcc0.Injector }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-form',
                template: "<div>\r\n    <div *ngIf=\"lastError && !hideErrorMessage\" class=\"alert alert-danger\">\r\n        {{ lastError }}\r\n    </div>\r\n\r\n    <form [formGroup]=\"formGroup\" autocomplete=\"off\">\r\n        <ng-content></ng-content>\r\n\r\n        <ng-template dw-component-host></ng-template>\r\n\r\n        <dw-button-bar *ngIf=\"showButtons\">\r\n            <button (click)=\"onSubmit()\" class=\"btn btn-success\">Saves</button>\r\n            <button (click)=\"cancel()\" class=\"btn btn-danger\">Cancel</button>\r\n        </dw-button-bar>\r\n    </form>\r\n</div>"
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: ɵngcc3.FormBuilder }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwEventService }, { type: ɵngcc0.ComponentFactoryResolver }, { type: DwValidationService }, { type: DwLoggingService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DwFormValidationServiceToken]
            }] }]; }, { hideErrorMessage: [{
            type: Input
        }], formReady: [{
            type: Output
        }], dataLoaded: [{
            type: Output
        }], saveStarted: [{
            type: Output
        }], saveComplete: [{
            type: Output
        }], saveFailed: [{
            type: Output
        }], cancelComplete: [{
            type: Output
        }], formInvalid: [{
            type: Output
        }], dataChanged: [{
            type: Output
        }], formValidator: [{
            type: Input
        }], overrideFormDataSet: [{
            type: Input
        }], showButtons: [{
            type: Input
        }], data: [{
            type: Input
        }], keyValue: [{
            type: Input
        }], newItemDefaults: [{
            type: Input
        }], subFormComponent: [{
            type: Input
        }], context: [{
            type: Input
        }], addContext: [{
            type: Input
        }], dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionStateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwExpressionService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormValidationBuilderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwValidationService }, { type: DwExpressionService }, { type: DwExpressionStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRuleManagerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: DwRuleService }, { type: DwExpressionService }, { type: DwExpressionStateService }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataFormatService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormBuilderService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwMetadataFormUtilService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormValidationBuilderService }, { type: DwRuleManagerService }, { type: DwRuleService }, { type: ɵngcc2.Router }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwDataFormatService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiConfigurableControlBase, [{
        type: Directive
    }], function () { return [{ type: DwUiConfigService }, { type: DwEventService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, { allowConfiguration: [{
            type: Input
        }], preferences: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContextConfigurableBaseComponent, [{
        type: Directive
    }], function () { return [{ type: DwUiConfigService }, { type: DwEventService }, { type: DwContextService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwReportingService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwEventService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionExecutionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: DwUiConfigRegistryService }, { type: DwModalService }, { type: DwServiceExecutionUtil }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionConfigBaseComponent, [{
        type: Directive
    }], function () { return []; }, { actionConfigFG: [{
            type: Input,
            args: ['actionConfigFormGroup']
        }], actionConfig: [{
            type: Input
        }], configContext: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteActionInternalLinkConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-action-internal-link-config',
                template: "<div *ngIf=\"actionConfigFG\" [formGroup]=\"actionConfigFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Use Url</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"useUrl\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"!actionConfigFG?.value?.useUrl\">\r\n        <div dwCol=\"12\">\r\n            <label>Internal Url</label>\r\n            <input type=\"text\" formControlName=\"url\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"actionConfigFG?.value?.useUrl\">\r\n        <div dwCol=\"12\">\r\n            <label>Menu</label>\r\n            <dw-select-route formControlName=\"menuKey\"></dw-select-route>\r\n        </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"!showViewKey\">\r\n        <div dwCol=\"12\">\r\n            <label>Selected View Key</label>\r\n            <input type=\"text\" formControlName=\"viewKey\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"!showKeyValue || !attributes\">\r\n        <div dwCol=\"12\">\r\n            <label>Key Value Param</label>\r\n            <select formControlName=\"keyValueAttrName\" class=\"form-control\">\r\n                <option *ngFor=\"let attr of attributes\" [ngValue]=\"attr.AttributeName\">\r\n                    {{ attr.AttributeDisplay }}\r\n            </select>\r\n\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"showAdditionalParams && additionalParams\">\r\n        <b>{{menuParams?.length }} Required Parameters</b>\r\n        <div dwRow *ngFor=\"let paramName of menuParams; let i = index\">\r\n            <div dwCol=\"12\" class=\"expr-column-full\">\r\n                <label>Param {{i+1}}: {{paramName | addSpaces }}</label>\r\n                <!-- <select class=\"form-control\" [(ngModel)]=\"additionalParams[paramName]\" (ngModelChange)=\"updateAdditionalParams()\" [ngModelOptions]=\"{standalone: true}\">\r\n                    <option *ngFor=\"let attr of attributes\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select> -->\r\n\r\n                <dw-expression-reference-control [(ngModel)]=\"additionalParams[paramName]\" (ngModelChange)=\"updateAdditionalParams()\" [ngModelOptions]=\"{standalone: true}\"\r\n                [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\" [queryMeaning]=\"configContext?.metaDataQueryMeaning\">\r\n              </dw-expression-reference-control>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <div dwRow *ngIf=\"attributes\">\r\n        <div dwCol=\"12\">\r\n            <label>Pass Data</label>\r\n            <p-multiSelect [options]=\"attributes\" optionLabel=\"AttributeDisplay\" optionValue=\"AttributeName\"\r\n                formControlName=\"passDataAttributes\" display=\"chip\" [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\"\r\n                autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Additional Query String <i class=\"fa fa-info-circle\"\r\n                    title=\"Add any additional query string parameters seperated by &.  Use fields like [FieldName] or [globals.name]\"></i></label>\r\n            <input type=\"text\" formControlName=\"additionalQueryString\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Open in New Window</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"openInNewWindow\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow [hidden]=\"!actionConfigFG?.value?.openInNewWindow\">\r\n        <div dwCol=\"12\">\r\n            <label>New Window Target</label>\r\n            <input type=\"text\" formControlName=\"newWindowTarget\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n\r\n</div>"
            }]
    }], function () { return [{ type: DwMenuService }, { type: DwMenuBuilderService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTemplateUtilService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwDataFormatService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteActionHelperService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwExpressionService }, { type: DwTemplateUtilService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteActionInternalLinkService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.Router }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }, { type: DwMenuService }, { type: DwRouteActionHelperService }]; }, null); })();
const ɵDwMetaDataFormStateService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMetaDataFormStateService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormStateService, [{
        type: Injectable
    }], null, null); })();
const ɵDwMetaDataFormValidatorService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMetaDataFormValidatorService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormValidatorService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormEventService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwEventService }]; }, null); })();
const ɵDwMetaDataFormSectionStateService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMetaDataFormSectionStateService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormSectionStateService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormDebugWidgetComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-form-debug-widget',
                template: "<p-accordion>\r\n    <p-accordionTab header=\"Current Section\" [selected]=\"true\" *ngIf=\"currentSectionInfo\">\r\n\r\n\r\n        <dw-ui-info-display [config]=\"currentSectionUiConfig\" [data]=\"currentSectionData\">\r\n\r\n        </dw-ui-info-display>\r\n\r\n\r\n<!--           Section Data: {{currentSectionData | json }}\r\n      \r\n        <h1>{{parentTitle}}</h1>\r\n\r\n        Section Key: {{currentSectionInfo.sectionType}}<br>\r\n        {{currentSectionInfo.title}}\r\n\r\n        <b>{{ fieldInfo?.fieldDisplay }}</b><br>\r\n        <div *ngIf=\"fieldConfiguredOptions\">\r\n            {{fieldConfiguredOptions | json}}\r\n        </div>\r\n\r\n        {{currentSectionData}} -->\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Data\">\r\n\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Expressions\">\r\n\r\n    </p-accordionTab>\r\n</p-accordion>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwMetadataFormUtilService }, { type: DwDesignerStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-meta-data-form',
                template: "<dw-loading [show]=\"!formSetupComplete && !configError\" text=\"Loading\"></dw-loading>\r\n\r\n<div *ngIf=\"configError\" class=\"alert alert-danger\">\r\n    {{configError}}\r\n</div>\r\n\r\n<div #container class=\"dw-form\">\r\n    <div *ngIf=\"configSequenceComplete && formConfig && formConfig.accessErrorMessage\">\r\n        <h1><i class=\"fad fa-user-lock fa-2x\" style=\"--fa-secondary-color: red\"></i> {{formConfig.accessErrorMessage}}</h1>\r\n    </div>\r\n\r\n    <div *ngIf=\"configSequenceComplete && formConfig && formConfig.canAccess\">\r\n        <dw-message [(message)]=\"formMessage\" *ngIf=\"formMessage && formConfig?.messagingConfig?.showTopMessages\">\r\n        </dw-message>\r\n\r\n        <div id='divForm'\r\n            [ngClass]=\"{ 'dw-form-print': (formMode === 'print'), 'dw-form-print-hide-buttons' : (showButtons == false) }\"\r\n            #divForm>\r\n            <dw-form #dwForm [data]=\"dataSource\" [context]=\"context\" [addContext]=\"addContext\" [keyValue]=\"keyValue\"\r\n                showButtons=\"false\" hideErrorMessage=\"true\" (formReady)=\"formReady($event)\"\r\n                (formInvalid)=\"setFormAsSubmitted()\" overrideFormDataSet=\"true\" (dataLoaded)=\"initialDataLoad($event)\"\r\n                (dataChanged)=\"formDataChanged($event, false, true)\">\r\n\r\n                <div id='divRootHidden' #divRootHidden [hidden]=\"!dwFormContext.loadDataComplete\"\r\n                    *ngIf=\"formSetupComplete && context  && securityChecksComplete\">\r\n                    <dw-dynamic-section [formConfig]=\"formConfig\" [context]=\"context\"\r\n                        [sectionConfig]=\"formConfig?.section\" [formGroup]=\"formGroup\" [submitted]=\"submitted\">\r\n                    </dw-dynamic-section>\r\n                </div>\r\n\r\n                <ng-content></ng-content>\r\n            </dw-form>\r\n        </div>\r\n\r\n        <dw-message [(message)]=\"formMessage\" classes=\"dw-alert-top-margin\"\r\n            *ngIf=\"formMessage && formConfig?.messagingConfig?.showBottomMessages\"></dw-message>\r\n    </div>\r\n\r\n    <p-contextMenu [target]=\"container\" [model]=\"contextMenu\" *ngIf=\"contextMenu && contextMenu.length>0\">\r\n    </p-contextMenu>\r\n\r\n    <div *ngIf=\"showPrintingForm && data\" class=\"dw-form-print-container\">\r\n        <dw-meta-data-form #printMdForm [item]=\"item\" [overrideData]=\"!reloadPrintData\" [keyValue]=\"keyValue\"\r\n            [data]=\"data\" [preferences]=\"formPreferences\" [formMode]=\"printFormMode\" showButtons=\"false\"\r\n            [configKeyPart]=\"currentPrintConfigKey\">\r\n        </dw-meta-data-form>\r\n    </div>\r\n</div>",
                providers: [
                    DwMetaDataFormStateService,
                    DwMetaDataFormSectionStateService,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwMetaDataFormComponent),
                        multi: true
                    },
                    {
                        provide: DwFormValidationServiceToken,
                        useClass: DwMetaDataFormValidatorService
                    }
                ],
                viewProviders: [DwMetaDataFormComponent]
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: DwUiConfigService }, { type: DwEventService }, { type: DwMetaDataFormService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataRoutingService }, { type: ɵngcc2.ActivatedRoute }, { type: DwContextService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwRuleManagerService }, { type: DwReportingService, decorators: [{
                type: Inject,
                args: [DwReportingServiceToken]
            }] }, { type: DwLoggingService }, { type: DwActionExecutionService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }, { type: DwRouteActionInternalLinkService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormValidatorService, decorators: [{
                type: Inject,
                args: [DwFormValidationServiceToken]
            }] }, { type: DwFormEventService }]; }, { overrideData: [{
            type: Input
        }], dataChanged: [{
            type: Output
        }], handleRedirect: [{
            type: Input
        }], showButtons: [{
            type: Input
        }], isModal: [{
            type: Input
        }], configKeyPart: [{
            type: Input
        }], formMode: [{
            type: Input
        }], contextKeys: [{
            type: Input
        }], allFormSetupComplete: [{
            type: Input
        }], returnToPrevious: [{
            type: Output
        }], dwFormContext: [{
            type: Output
        }], printFormMode: [{
            type: Input
        }], data: [{
            type: Input
        }], keyValue: [{
            type: Input
        }], item: [{
            type: Input
        }], addContext: [{
            type: Input
        }], printConfigKeyPart: [{
            type: Input
        }], dwForm: [{
            type: ViewChild,
            args: [DwFormComponent]
        }], divForm: [{
            type: ViewChild,
            args: ['divForm', { static: false }]
        }], printMdForm: [{
            type: ViewChild,
            args: ['printMdForm', { static: false }]
        }], divRootHidden: [{
            type: ViewChild,
            args: ['divRootHidden', { static: false }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDefaultFormPage, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-default-form',
                template: `
    <!--[Form - {{routeDetail?.itemName}} - {{item}} -- IsModel = {{isModal}}]-->
    <dw-router-parent useIf="false" [useModalOutlet]="isModal" [outletName]="outletName">
        <ng-template>
            <ng-container *ngIf="showContent && !securityChanging">
                <dw-content-manager [configKey]="contentConfigKey" [item]="item">
                    <h1>
                        <dw-content name="title" display="Page Title" [controlType]="textboxControlType">
                        </dw-content>
                    </h1>

                    <dw-content name="detail" display="Header Details">
                    </dw-content>

                    <dw-content-component name='component' display='Custom Component'></dw-content-component>
                </dw-content-manager>

                <dw-meta-data-form #mdForm [item]="item" [overrideData]="overrideData"  [data]="data"  [addContext]="addContext" [keyValue]="keyValue" [configKeyPart]="configKeyPart" [printConfigKeyPart]="printConfigKeyPart" [preferences]="formPreferences" [handleRedirect]="!isModal" [showButtons]="!isModal" [isModal]="isModal" [formMode]="formMode" (returnToPrevious)="returnToPrevious($event)">
                </dw-meta-data-form>
            </ng-container>
        </ng-template>
    </dw-router-parent>
    <!-- [/Form - {{item}}]  Route Detail: {{ routeDetail | json }} -->
    `
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: ɵngcc2.Router }, { type: DwModalService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwUiConfigService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwRoutingService }, { type: DwMenuService }, { type: DwSecurityUserService }]; }, { closeModal: [{
            type: Output
        }], formMode: [{
            type: Input
        }], overrideData: [{
            type: Input
        }], configKeyPart: [{
            type: Input
        }], item: [{
            type: Input
        }], keyValue: [{
            type: Input
        }], formPreferences: [{
            type: Input
        }], addContext: [{
            type: Input
        }], data: [{
            type: Input
        }], mdForm: [{
            type: ViewChild,
            args: [DwMetaDataFormComponent, { static: false }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwServerCacheService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CacheAdminComponent, [{
        type: Component,
        args: [{
                selector: 'cache-admin',
                template: "<div>\r\n    <a (click)=\"clearAllCaches()\" class=\"hand link\">Clear All Caches</a><br />\r\n\r\n    <a (click)=\"clearServerCache()\"  class=\"hand\">Clear Server Caches</a><br />\r\n\r\n    <a (click)=\"clearClientCache()\"  class=\"hand\">Clear Client Caches</a><br />\r\n</div>\r\n  "
            }]
    }], function () { return [{ type: DwCacheService }, { type: DwServerCacheService }, { type: DwMessagingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataRoutingRegistryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwRoutingService }, { type: ɵngcc2.Router }, { type: DwMenuService }, { type: DwMenuBuilderService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingAdminRepositoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingAdminTreeService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMenuBuilderService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteTypeFactory, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: ɵngcc0.Injector }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataRoutingRepositoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwAppInitService }, { type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwUiConfigRegistryService }, { type: DwRouteTypeFactory }, { type: DwCacheService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuComponent, [{
        type: Directive
    }], function () { return [{ type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }, { type: ɵngcc2.ActivatedRoute }, { type: DwActionExecutionService }, { type: DwMenuService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, { category: [{
            type: Input
        }], performSecurityTrimming: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DefaultMenuPageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-default-menu-page',
                template: "<dw-page-menu>\r\n    <div *dwMenuContent=\"let context\">\r\n        <dw-content-manager [configKey]=\"configKey\">\r\n            <h1>\r\n                <dw-content name=\"title\" display=\"Page Title\" [controlType]=\"textboxControlType\">\r\n                </dw-content>\r\n            </h1>\r\n\r\n            <dw-content name=\"detail\" display=\"Header Details\">\r\n            </dw-content>\r\n\r\n            <dw-content-component name=\"component\" display=\"Custom Component\"></dw-content-component>\r\n        </dw-content-manager>\r\n    </div>\r\n</dw-page-menu> \r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwMenuService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuContentTemplateDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwMenuContent]'
            }]
    }], null, null); })();
const ɵDwPageMenu_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwPageMenu);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageMenu, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-page-menu',
                template: "<dw-router-parent useIf=\"true\">\r\n    <ng-template>\r\n        <ng-container *ngTemplateOutlet=\"menuContentTemplate;\"></ng-container>\r\n\r\n        <ng-container *ngIf=\"menus?.length > 0\">\r\n            <div class=\"dw-menu-cards\">\r\n                <div dwCol2=\"12\">\r\n                    <ng-container *ngFor=\"let subMenu of menus\">\r\n                        <dw-menu-template [menu]=\"subMenu\" className=\"dw-menu-card\">\r\n                            <i class=\"menu-icon-large {{subMenu?.data?.iconCssClass}}\"></i><br>\r\n                            {{subMenu.display}}\r\n                        </dw-menu-template>\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"menuGroups?.length > 0\">\r\n            <div dwRow>\r\n                <ng-container *ngFor=\"let menuGroup of menuGroups\">\r\n                    <div dwCol=\"12\">\r\n                        <ng-container\r\n                            *ngTemplateOutlet=\"menuSectionGroup; context : {$implicit: menuGroup}\"></ng-container>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n        </ng-container>\r\n    </ng-template>\r\n</dw-router-parent>\r\n\r\n<!-- <div *ngIf=\"!routeActivated\">\r\n    <ng-container *ngTemplateOutlet=\"menuContentTemplate;\"></ng-container>\r\n\r\n    <ng-container *ngIf=\"menus?.length > 0\">\r\n        <div class=\"dw-menu-cards\">\r\n            <div dwCol2=\"12\">\r\n                <ng-container *ngFor=\"let subMenu of menus\">\r\n                    <dw-menu-template [menu]=\"subMenu\" className=\"dw-menu-card\"> \r\n                        <i class=\"menu-icon-large {{subMenu?.data?.iconCssClass}}\"></i><br>\r\n                        {{subMenu.display}}\r\n                    </dw-menu-template>\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"menuGroups?.length > 0\">\r\n        <div dwRow>\r\n            <ng-container *ngFor=\"let menuGroup of menuGroups\" >\r\n                <div dwCol=\"12\">\r\n                    <ng-container *ngTemplateOutlet=\"menuSectionGroup; context : {$implicit: menuGroup}\"></ng-container>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n    </ng-container>\r\n  </div>\r\n<router-outlet (activate)=\"toggleActivate(true)\"  (deactivate)=\"toggleActivate(false)\"></router-outlet> -->\r\n\r\n<ng-template #menuSection let-menu>\r\n    <div class=\"dw-section-container\">\r\n        <div class=\"dw-section-container-header\">\r\n            {{ menu?.display }}\r\n        </div>\r\n        <div class=\"dw-section-container-inner  dw-page-menu\">\r\n            <div *ngFor=\"let subMenu of menu?.children\">\r\n                <dw-menu-link [menu]=\"subMenu\" className=\"nav-link2\" [menuLocation]=\"'menu-page'\"\r\n                    *ngIf=\"!(subMenu.data?.showInMenu === false || subMenu.data?.visibleRuleResult === false)\"></dw-menu-link>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #menuSectionGroup let-menuGroup>\r\n    <dw-container [options]=\"containerOptions\">\r\n        <span header>\r\n            {{ menuGroup?.groupDisplay }}\r\n        </span>\r\n        <div body>\r\n            <div class=\"dw-menu-cards\">\r\n                <div dwCol2=\"12\">\r\n                    <ng-container *ngFor=\"let subMenu of menuGroup?.menus\">\r\n                        <dw-menu-template [menu]=\"subMenu\" className=\"dw-menu-card\">\r\n                            <i class=\"menu-icon-large {{subMenu?.data?.iconCssClass}}\"></i><br>\r\n                            {{subMenu.display}}\r\n                        </dw-menu-template>\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </dw-container>\r\n</ng-template>\r\n\r\n<ng-template #menuSectionGroupOld let-menu>\r\n    <dw-container [options]=\"containerOptions\">\r\n        <span header>\r\n            {{ menu?.display }}\r\n        </span>\r\n        <div body>\r\n            <div class=\"dw-menu-cards\">\r\n                <div dwCol2=\"12\">\r\n                    <ng-container *ngFor=\"let subMenu of menu?.children\">\r\n                        <dw-menu-template [menu]=\"subMenu\" className=\"dw-menu-card\">\r\n                            <i class=\"menu-icon-large {{subMenu?.data?.iconCssClass}}\"></i><br>\r\n                            {{subMenu.display}}\r\n                        </dw-menu-template>\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </dw-container>\r\n</ng-template>"
            }]
    }], null, { category: [{
            type: Input
        }], performSecurityTrimming: [{
            type: Input
        }], menuContentTemplate: [{
            type: ContentChild,
            args: [DwMenuContentTemplateDirective, { static: false, read: TemplateRef }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingAdminConversionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwUiConfigRegistryService }, { type: DwRoutingAdminTreeService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingAdminStateService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwRoutingAdminRepositoryService }, { type: DwMenuService }, { type: DwRoutingAdminTreeService }, { type: ɵngcc2.Router }, { type: DwMetaDataRoutingRegistryService }, { type: DwMetaDataRoutingRepositoryService }, { type: DwRoutingAdminConversionService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingAdminMenuService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwRoutingAdminStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRoutingAdminTreeComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-routing-admin-tree',
                template: "<dw-container *ngIf=\"routingState\">\r\n  <div header>\r\n    Menu Admin\r\n  </div>\r\n  <div body>\r\n    <dw-loading [show]=\"!routingState\"></dw-loading>\r\n\r\n    <div dwRow *ngIf=\"routingState\">\r\n      <div dwCol=\"6\">\r\n        <div class=\"tree-container\">\r\n          <p-tree [value]=\"routingState.treeData\" draggableNodes=\"true\" droppableNodes=\"true\" selectionMode=\"single\"\r\n            [selection]=\"routingState.selectedNode\" (onNodeSelect)=\"setCurrentNode($event)\"\r\n            (onNodeDrop)=\"nodeDropped($event)\" [validateDrop]=\"true\">\r\n\r\n            <ng-template let-node pTemplate=\"category\">\r\n              <span (contextmenu)=\"contextMenuClick($event, node)\">\r\n                <b>{{node.label}}</b>\r\n              </span>\r\n            </ng-template>\r\n\r\n            <ng-template let-node pTemplate=\"dbRoute\">\r\n              <span (contextmenu)=\"contextMenuClick($event, node)\">\r\n                {{node.label}}\r\n              </span>\r\n              <span [hidden]=\"!node.data?.modified\"> *</span>\r\n\r\n              <i [hidden]=\"!node.data?.invalid\" class=\"fa fa-exclamation-triangle text-danger ml-4\"></i>\r\n            </ng-template>\r\n            <ng-template let-node pTemplate=\"staticRoute\">\r\n              <span (contextmenu)=\"contextMenuClick($event, node)\">\r\n                {{node.label}}\r\n              </span>\r\n            </ng-template>\r\n          </p-tree>\r\n\r\n          <p-contextMenu #cmRoutes [model]=\"cmRouteItems\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\">\r\n          </p-contextMenu>\r\n\r\n        </div>\r\n        <dw-button-bar>\r\n          <button class=\"btn btn-success\" (click)=\"saveRoutes()\" [disabled]=\"!routingState?.enableSave\">Save</button>\r\n        </dw-button-bar>\r\n      </div>\r\n      <div dwCol=\"6\">\r\n        <p-tabView [(activeIndex)]=\"selectedTabIndex\">\r\n          <p-tabPanel header=\"Add Menus\">\r\n            <div class=\"dw-minimal-tree\">\r\n              <p-tree [value]=\"routingState.addTreeData\" draggableNodes=\"true\">\r\n                <ng-template let-node pTemplate=\"addMenu\">\r\n                  <span style=\"font-size:1.5em\">\r\n                    <i class=\"far fa-layer-plus fa-border\"></i> {{node.label}}\r\n                  </span>\r\n                </ng-template>\r\n              </p-tree>\r\n            </div>\r\n          </p-tabPanel>\r\n          <p-tabPanel header=\"Configure Menu\">\r\n            <div *ngIf=\"routingState.selectedNode && routingState.selectedNode.type != 'category'\">\r\n              <ng-container *ngIf=\"routingState.selectedNode.data?.routeId; then dynamicMenuEdit; else staticMenuEdit\">\r\n              </ng-container>\r\n            </div>\r\n          </p-tabPanel>\r\n        </p-tabView>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</dw-container>\r\n\r\n<ng-template #dynamicMenuEdit>\r\n  <dw-route-edit *ngIf=\"routingState?.selectedNode.type !== 'dbRouteChild'\" [route]=\"routingState.selectedRoute\"\r\n    (routeChange)=\"updateRoute($event)\" (validChange)=\"validChange($event)\" [treeNode]=\"routingState.selectedNode\"\r\n    (undoConversion)=\"undoConversion(routingState.selectedNode)\">\r\n  </dw-route-edit>\r\n\r\n  <dw-route-edit-child *ngIf=\"routingState?.selectedNode.type === 'dbRouteChild'\" [route]=\"routingState.selectedRoute\"\r\n    [menuData]=\"routingState.selectedNode.data.routeMenuData\" (routeChange)=\"updateChildRoute($event)\">\r\n  </dw-route-edit-child>\r\n</ng-template>\r\n\r\n<ng-template #staticMenuEdit>\r\n  <ng-container\r\n    *ngIf=\"routingState?.selectedNode?.parent.type=='category' || routingState?.selectedNode?.parent?.data?.routeId; then convertStaticRoute; else missingValidParent\">\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #missingValidParent>\r\n  <div class=\"alert alert-warning\">\r\n    Can't convert a child of a static route. Convert the parent node instead!\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #convertStaticRoute>\r\n  <button class=\"btn btn-warning\" (click)=\"convertToDynamicRoute(routingState.selectedNode)\">Convert to DB\r\n    Route</button>\r\n\r\n  <div [hidden]=\"routingState.selectedNode?.children?.length==0\">\r\n    <br>\r\n\r\n    <input type=\"checkbox\" [(ngModel)]=\"convertAllChildren\"> Convert all children\r\n  </div>\r\n</ng-template>",
                encapsulation: ViewEncapsulation.None,
                providers: [TreeDragDropService],
                styles: [".db-route{color:green!important}.static-route{color:#00f!important}.category-node{color:#000;font-size:larger}.tree-container{max-height:700px;overflow:auto}"]
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwRoutingAdminStateService }, { type: DwRoutingAdminMenuService }]; }, { cmRoutes: [{
            type: ViewChild,
            args: ['cmRoutes']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSchedulerService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwProductVersionAdminComponent, [{
        type: Component,
        args: [{
                selector: 'dw-product-version-admin',
                template: "<h1>CAP Product Version</h1>\r\n\r\n<table class=\"product-table\">\r\n    <thead>\r\n        <tr>\r\n            <th>\r\n                Module\r\n            </th>\r\n            <th>\r\n                Version\r\n            </th>\r\n            <th>\r\n                Date\r\n            </th>\r\n            <th>\r\n                Status\r\n            </th>\r\n        </tr>\r\n    </thead>\r\n    <tbody>\r\n        <tr *ngFor=\"let version of productVersions\">\r\n            <td>\r\n                {{version.ModuleName}}\r\n            </td>\r\n            <td>\r\n                {{version.ProductVersion}}\r\n            </td>\r\n            <td>\r\n                {{version.PublishDateTime | date}}\r\n            </td>\r\n\r\n            <td>\r\n                <i class=\"{{version.AdditionalInfo?.iconClass}}\" title=\"{{version.AdditionalInfo?.title}}\"></i>\r\n\r\n\r\n                {{version.ModuleType}}\r\n            </td>\r\n        </tr>\r\n    </tbody>\r\n</table>",
                styles: [".product-table{max-width:800px;width:100%}.product-table table,.product-table td,.product-table th{border:1px solid #000}.product-table table{border-collapse:collapse;font-family:Arial,Helvetica,sans-serif;max-width:800px;width:100%}.product-table th{background-color:green;color:#fff;padding-bottom:12px;padding-top:12px;text-align:left}.product-table td,.product-table th{border:1px solid #000;padding:8px}.product-table tr:hover{background-color:#ddd}.product-table tr:nth-child(2n){background-color:#f2f2f2}"]
            }]
    }], function () { return [{ type: DwAppInitService }, { type: DwSchedulerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSectionBaseComponent, [{
        type: Directive
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { visibleChange: [{
            type: Output
        }], visible: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], context: [{
            type: Input
        }], submitted: [{
            type: Input
        }], sectionConfig: [{
            type: Input
        }], formConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AdminMeaningDefaultComponent, [{
        type: Component,
        args: [{
                selector: 'dw-admin-meaning-default',
                template: ``
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareAdminRouteSetup, [{
        type: Component,
        args: [{
                selector: 'devware-admin-route-setup',
                template: ''
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevareAdminRoutingModule, { imports: function () { return [RouterModule]; }, exports: function () { return [RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevareAdminRoutingModule, [{
        type: NgModule,
        args: [{
                //imports: [RouterModule.forChild(routes)],
                imports: [RouterModule],
                exports: [RouterModule]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityInterceptor, [{
        type: Injectable
    }], function () { return [{ type: DwStorageUtil }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityStateService }, { type: ɵngcc2.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecuritySSOCustomHandlerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwCacheService }, { type: ɵngcc2.Router }, { type: DwStorageUtil }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecuritySSOMSALHandlerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwMessagingService }, { type: DwLoggingService }, { type: ɵngcc2.Router }]; }, null); })();
const ɵDwCoreConfigProvider_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwCoreConfigProvider);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCoreConfigProvider, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityTwoFactorRepositoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwAppInitService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityRegistrationRepositoryService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwAppInitService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareCoreModule, { imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                providers: [
                    DwStorageUtil,
                    DwCacheService,
                    DwServerCacheService,
                    DwCoreConfigProvider,
                    DwSecurityStateService,
                    DwSecurityTwoFactorRepositoryService,
                    DwSecurityRegistrationRepositoryService,
                    DwLoggingService,
                    /*   {
                          provide: ErrorHandler,
                          useClass: DwGlobalErrorHandler
                        }, */
                    {
                        // Define provider here as well so they can just reference the module directly if they don't have an configProviders
                        provide: DwConfigServiceToken,
                        useClass: DwConfigService
                    },
                    {
                        provide: DwRoutingServiceToken,
                        useClass: DwRoutingService
                        /*   useFactory(securityService: DwSecurityUserService, configService: DwConfigService, router: Router, route: ActivatedRoute, analytics : DwGoogleAnalyticsService) {
                              return new DwRoutingService(configService, securityService, router, route, analytics);
                          },
                          deps: [DwSecurityUserService, DwConfigServiceToken,  Router, ActivatedRoute, DwGoogleAnalyticsService] */
                    },
                    {
                        provide: DwSecurityRepositoryServiceToken,
                        useClass: DwSecurityRepositoryService
                    },
                    DwAuthGuardService,
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: DwSecurityInterceptor,
                        multi: true
                    },
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: DwMessagingInterceptor,
                        multi: true
                    },
                    {
                        provide: APP_INITIALIZER,
                        useFactory(injector) {
                            return () => {
                                try {
                                    var promise = DwAppStartup(injector);
                                    return promise;
                                }
                                catch (e) {
                                    console.log('App Start - Error', e);
                                }
                            };
                        },
                        deps: [Injector],
                        multi: true
                    }
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    RouterModule,
                ],
                exports: [],
                entryComponents: []
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridHostDirective, [{
        type: Directive,
        args: [{
                selector: '[dw-grid-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-config',
                template: "<div>\r\n    <h2>Grid Preferences</h2>\r\n\r\n    <form [formGroup]=\"configForm\" (ngSubmit)=\"onSubmit()\">\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Show Filter</label>\r\n            </div>\r\n            <div dwCol=\"9\">\r\n                <p-inputSwitch formControlName=\"showFilter\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Show Filter On Load</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"showFilterOnLoad\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Hide Key</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"hidePrimaryKey\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Show Display value</label>\r\n            </div>\r\n            <div dwCol=\"6\">\r\n                <p-inputSwitch formControlName=\"showDisplayProperties\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Ignore Fields</label>\r\n                <input type=\"text\" formControlName=\"ignoreAttributes\" />\r\n            </div>\r\n        </div>\r\n    </form>\r\n\r\n    \r\n    <!--<button-bar>\r\n        <button class=\"btn\" (click)=\"apply()\">Apply</button>\r\n        <button class=\"btn\" (click)=\"cancel()\">Cancel</button>\r\n    </button-bar>-->\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }]; }, { gridPreferencesChange: [{
            type: Output
        }], apply: [{
            type: Output
        }], gridPreferences: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-grid',
                template: "<ng-content select=\"[filterTiles]\"></ng-content>\r\n\r\n<div [ngClass]=\"gridConfig?.gridStyle?.gridClass\">\r\n    <div [ngClass]=\"styles?.containerClass\">\r\n        <div class=\"dw-grid-filter2\" *ngIf=\"gridConfig.showFilter && !gridConfig.useSideFilters\"\r\n            [hidden]=\"!showFilterSection\">\r\n            <div [ngClass]=\"styles?.filterHeaderClass\">\r\n                Filters\r\n            </div>\r\n            <div [ngClass]=\"styles?.filterBodyClass\">\r\n                <form (onsubmit)=\"applyFilters(filters)\">\r\n                    <ng-content select=\"[filter]\"></ng-content>\r\n\r\n                    <div class=\"row2\">\r\n                        <div class=\"pull-right\">\r\n                            <button type=\"submit\" class=\"btn btn-success\" (click)=\"applyFilters(filters)\"\r\n                                *ngIf=\"!gridConfig.autoFilter\">Filter</button>\r\n\r\n                            <button type=\"button\" class=\"btn btn-warning ml-2\" (click)=\"clearFilters(filters)\"\r\n                                *ngIf=\"gridConfig.showClearFilter\" title=\"Clear all set filters\">Clear</button>\r\n                        </div>\r\n                    </div>\r\n                </form>\r\n            </div>\r\n        </div>\r\n        <div [ngClass]=\"styles?.actionBarContainerClass\">\r\n            <div [ngClass]=\"styles?.actionBarClass\">\r\n                <ng-container *ngIf=\"!resolvedContext?.mdGridContext?.inEditMode\">\r\n                    <div class=\"dw-grid-buttons-left\">\r\n                        <ng-content select=\"[actions]\"></ng-content>\r\n                    <!-- </div>\r\n\r\n                    <div class=\"dw-grid-buttons-left\"> -->\r\n\r\n                        <dw-action-bar [actionPreferences]=\"gridConfig?.actionPreferences?.actionBarLeft\"\r\n                            [actionContext]=\"configContext\" (actionClick)=\"actionPrefClicked($event)\"\r\n                            useContainerStyle=\"false\"></dw-action-bar>\r\n                    </div>\r\n                    <div class=\"dw-grid-buttons-right\">\r\n                        <dw-action-bar [actionPreferences]=\"gridConfig?.actionPreferences?.actionBarRight\"\r\n                            [actionContext]=\"configContext\" (actionClick)=\"actionPrefClicked($event)\"\r\n                            useContainerStyle=\"false\"></dw-action-bar>\r\n                    </div>\r\n                    <ng-content select=\"[actions]\"></ng-content>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"resolvedContext?.mdGridContext?.inEditMode\">\r\n                    <div class=\"dw-grid-buttons-left\">\r\n                        <dw-action-bar [actionPreferences]=\"gridConfig?.actionPreferences?.actionBarLeftInlineEditing\"\r\n                            [actionContext]=\"configContext\" (actionClick)=\"actionPrefClicked($event)\"\r\n                            useContainerStyle=\"false\"></dw-action-bar>\r\n                    </div>\r\n                    <div class=\"dw-grid-buttons-right\">\r\n                        <dw-action-bar [actionPreferences]=\"gridConfig?.actionPreferences?.actionBarRightInlineEditing\"\r\n                            [actionContext]=\"configContext\" (actionClick)=\"actionPrefClicked($event)\"\r\n                            useContainerStyle=\"false\"></dw-action-bar>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n        <div #gridContainer (contextmenu)='triggerContextMenu.emit($event)'>\r\n            <div class=\"dw-grid-split-container\"\r\n                [ngClass]=\"{ 'dw-grid-split-container-full' : !showFilterSection || !gridConfig.useSideFilters }\">\r\n                <div class=\"dw-grid-split-left\">\r\n                    <ng-template dw-grid-host></ng-template>\r\n                </div>\r\n                <div class=\"dw-grid-split-right\" *ngIf=\"gridConfig?.showFilter && gridConfig?.useSideFilters\">\r\n                    <div class=\"dw-grid-split-right-inner\">\r\n                        <ng-content select=\"[rightPanel]\"></ng-content>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <ng-content select=\"[footer]\" *ngIf=\"gridConfig!.showFooter\"></ng-content>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: ɵngcc0.ComponentFactoryResolver }, { type: DwUiConfigService }, { type: DwEventService }, { type: DwUiConfigRegistryService }]; }, { triggerContextMenu: [{
            type: Output
        }], onGridActionEvent: [{
            type: Output
        }], filtersApplied: [{
            type: Output
        }], filtersCleared: [{
            type: Output
        }], configKey: [{
            type: Input
        }], usePrefs: [{
            type: Input
        }], gridReady: [{
            type: Output
        }], gridEvent: [{
            type: Output
        }], gridConfig: [{
            type: Input
        }], filters: [{
            type: Input
        }], filterSetupComplete: [{
            type: Input
        }], gridContextMenu: [{
            type: Input
        }], configContext: [{
            type: Input
        }], resolvedContext: [{
            type: Input
        }], data: [{
            type: Input
        }], dwGridHost: [{
            type: ViewChild,
            args: [DwGridHostDirective, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLoginComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-login',
                template: "<div class=\"login\"> <!-- *ngIf=\"!processing\"> -->\r\n\r\n    <ng-content select=\"[top]\"></ng-content>\r\n\r\n    <div class=\"card\">\r\n        <ng-container *ngIf=\"!showReset\">\r\n            <ng-container *ngTemplateOutlet=\"customLoginTemplate ? customLoginTemplate : basicLogin;\">\r\n            </ng-container>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"showReset\">\r\n            <dw-user-password-reset [(userName)]=\"userName\" (cancelled)=\"resetCancelled()\" [(message)]=\"message\"\r\n                (complete)=\"resetComplete()\"></dw-user-password-reset>\r\n        </ng-container>\r\n    </div>\r\n\r\n    <ng-content select=\"[bottom]\"></ng-content>\r\n</div>\r\n\r\n<ng-template #basicLogin>\r\n    <div class=\"card-header\">Login</div>\r\n    <div class=\"card-body\">\r\n        <dw-message [message]=\"message\"></dw-message>\r\n        <div class=\"body-left\">\r\n            <div class=\"body-left-content\">\r\n                <div class=\"dw-logo-login\">\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"body-right\">\r\n            <div class=\"body-right-content\">\r\n                <form (ngSubmit)=\"login()\">\r\n                    <ng-container *ngIf=\"!showTwoFactor && !showForcePasswordChange\">\r\n                        <div class=\"row\">\r\n                            <div class=\"login-image\">\r\n                                <!-- <img src=\"/assets/img/user-loging.png\" /> -->\r\n                                <i class=\"fa fa-user-circle login-icon\"></i>\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                <dw-floating-label-input\r\n                                    [label]=\"dwUIConfig.registrationConfig?.userNameText || 'Username/E-mail'\"\r\n                                    [inputClass]=\"'form-control'\" [containerClass]=\"'login-input-container'\"\r\n                                    [name]=\"'tbUserName'\" [(ngModel)]=\"userName\" (ngModelChange)=\"userNameChange()\"\r\n                                    [inputAutocomplete]=\"'username'\"\r\n                                    [useFloat]=\"dwUIConfig.registrationConfig?.useFloatLabelOnLogin\">\r\n                                </dw-floating-label-input>\r\n                            </div>\r\n\r\n                            <!-- <div class=\"login-input p-float-label\"\r\n                                *ngIf=\"dwUIConfig.registrationConfig?.useFloatLabelOnLogin\">\r\n                                <input #userNameInput type=\"text\" id=\"tbUserName\" name=\"tbUserName\" class=\"form-control\"\r\n                                    [ngClass]=\"{'p-filled': userName || hasUserNameAutoFillValue || hasUserNameFocus}\"\r\n                                    [(ngModel)]=\"userName\" (ngModelChange)=\"userNameChange()\"\r\n                                    (focus)=\"focusUserName('user')\" (blur)=\"blurUserName()\">\r\n                                <label class2=\"label\" for=\"tbUserName\"\r\n                                    [ngClass]=\"{'p-filled-label': userName || hasUserNameAutoFillValue}\">\r\n                                    {{ dwUIConfig.registrationConfig?.userNameText || 'Username/E-mail'}}\r\n                                </label>\r\n                            </div>\r\n                            <div class=\"login-input\" *ngIf=\"!dwUIConfig.registrationConfig?.useFloatLabelOnLogin\">\r\n                                <label class=\"label\">\r\n                                    {{ dwUIConfig.registrationConfig?.userNameText || 'Username/E-mail'}}\r\n                                </label>\r\n                                <input type=\"text\" id=\"tbUserName\" name=\"tbUserName\" class=\"form-control\"\r\n                                    [(ngModel)]=\"userName\" placeholder=\"username/e-mail\">\r\n                            </div> -->\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"login-image\">\r\n                                <!-- <img src=\"/assets/img/user-password.png\" /> -->\r\n                                <i class=\"fa fa-user-lock login-icon\"></i>\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                <dw-floating-label-input [type]=\"'password'\" [label]=\"'Password'\"\r\n                                    [inputClass]=\"'form-control'\" [containerClass]=\"'login-input-container'\"\r\n                                    [name]=\"'tbPassword'\" [(ngModel)]=\"password\"\r\n                                    [inputAutocomplete]=\"'current-password'\"\r\n                                    [useFloat]=\"dwUIConfig.registrationConfig?.useFloatLabelOnLogin\">\r\n                                </dw-floating-label-input>\r\n                            </div>\r\n                            <!-- <div class=\"login-input\" *ngIf=\"!dwUIConfig.registrationConfig?.useFloatLabelOnLogin\">\r\n                                <label class=\"label\">Password</label>\r\n                                <input type=\"password\" id=\"tbPassword\" name=\"tbPassword\" class=\"form-control\"\r\n                                    [(ngModel)]=\"password\" placeholder=\"password\">\r\n                            </div>\r\n                            <div class=\"login-input p-float-label\"\r\n                                *ngIf=\"dwUIConfig.registrationConfig?.useFloatLabelOnLogin\">\r\n                                <input #passwordInput type=\"password\" id=\"tbPassword\" name=\"tbPassword\" class=\"form-control\"\r\n                                    [ngClass]=\"{'p-filled': password || hasPasswordAutoFillValue || hasPasswordFocus}\"\r\n                                    [(ngModel)]=\"password\" (ngModelChange)=\"passwordChange()\"\r\n                                    (focus)=\"focusPassword('password')\" (blur)=\"blurPassword()\">\r\n\r\n                                <label class2=\"label\" for=\"tbPassword\"\r\n                                    [ngClass]=\"{'p-filled-label': password  || hasPasswordAutoFillValue}\">Password</label>\r\n                            </div> -->\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"login-image\">\r\n                                <!-- <img src=\"/assets/img/user-loging.png\" /> -->\r\n                                <!-- <i class=\"fa fa-user-circle login-icon\"></i> -->\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                <div class=\"input-additional-message\">\r\n                                    <a (click)=\"forgotPassword()\">Forgot your password?</a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12 dw-button-bar-full\">\r\n                                <button type=\"submit\" (click)=\"login()\" class=\"btn btn-success btn-login\"\r\n                                    [disabled]=\"processing\">Login <i *ngIf=\"processing\"\r\n                                        class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n                                <dw-login-sso-options (isProcessing)=\"setIsProcessing($event)\"></dw-login-sso-options>\r\n\r\n                                <button type=\"button\" (click)=\"register()\"\r\n                                    *ngIf=\"!dwUIConfig.registrationConfig?.registrationShowAsLink\"\r\n                                    class=\"btn btn-primary\">\r\n                                    {{ dwUIConfig.registrationConfig?.registerButtonText || 'Register' }}\r\n                                </button>\r\n\r\n                                <a *ngIf=\"dwUIConfig.registrationConfig?.registrationShowAsLink\" (click)=\"register()\">\r\n                                    <span class=\"login-not-registered-text\">\r\n                                        {{ dwUIConfig.registrationConfig?.registrationLinkText || 'Sign up'}}\r\n                                    </span>\r\n                                    <span class=\"login-signup-text\">\r\n                                        {{ dwUIConfig.registrationConfig?.registerButtonText || 'Register' }}\r\n                                    </span>\r\n                                </a>\r\n\r\n                            </div>\r\n                        </div>\r\n\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"showTwoFactor\">\r\n                        <div class=\"row\" *ngIf=\"twoFactorMessage\">\r\n                            <div class=\"login-image\">\r\n\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                {{ twoFactorMessage }}\r\n                                <div class=\"input-additional-message\" *ngIf=\"showResendCode\">\r\n                                    <a (click)=\"resendCode()\">Resend Code</a>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"login-image\">\r\n                                <img src=\"/assets/img/user-password.png\" />\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                <label class=\"label\">Two Factor Code</label>\r\n                                <input type=\"text\" id=\"tbTwoFactorCode\" name=\"tbTwoFactorCode\" class=\"form-control\"\r\n                                    [(ngModel)]=\"twoFactorCode\" placeholder=\"two factor code\" required>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\">\r\n                                <button type=\"submit\" (click)=\"login()\" class=\"form-control btn btn-success\"\r\n                                    [disabled]=\"processing\">Complete Login <i *ngIf=\"processing\"\r\n                                        class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"showForcePasswordChange\">\r\n                        <div class=\"row\" *ngIf=\"changePasswordMessage\">\r\n                            <div class=\"login-image\">\r\n\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                {{ changePasswordMessage }}\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"login-image\">\r\n                                <img src=\"/assets/img/user-password.png\" />\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                <input style=\"display: none\" type=\"text\" name=\"fakeusernameremembered\" />\r\n\r\n                                <label class=\"label\">New Password</label>\r\n                                <input type=\"password\" id=\"tbPasswordNew\" name=\"tbPasswordNew\" class=\"form-control\"\r\n                                    [(ngModel)]=\"newPassword\" placeholder=\"new password\" autocomplete=\"chrome-off\"\r\n                                    required>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"login-image\">\r\n                                <img src=\"/assets/img/user-password.png\" />\r\n                            </div>\r\n                            <div class=\"login-input\">\r\n                                <label class=\"label\">Retype New Password</label>\r\n                                <input type=\"password\" id=\"tbPasswordNew2\" name=\"tbPasswordNew2\" class=\"form-control\"\r\n                                    [(ngModel)]=\"newPasswordRetype\" placeholder=\"retype new password\"\r\n                                    autocomplete=\"chrome-off\" required>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-12\">\r\n                                <button type=\"submit\" (click)=\"changePassword()\" class=\"form-control btn btn-success\"\r\n                                    [disabled]=\"processing\">Change Password <i *ngIf=\"processing\"\r\n                                        class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n\r\n                </form>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSecurityOrchestrationService }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: ɵngcc2.Router }, { type: ɵngcc0.ChangeDetectorRef }]; }, { headerTextChange: [{
            type: Output
        }], showRegister: [{
            type: Input
        }], customLoginTemplate: [{
            type: Input
        }], userNameInput: [{
            type: ViewChild,
            args: ['userNameInput']
        }], passwordInput: [{
            type: ViewChild,
            args: ['passwordInput']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLoginPageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-login-page',
                template: "<div>\r\n    <div dwRow>\r\n        <div dwCol=\"5\">\r\n            <dw-login></dw-login>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwControlBaseComponent, [{
        type: Directive
    }], function () { return []; }, { id: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();
const ɵDwInputComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwInputComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwInputComponent, [{
        type: Component,
        args: [{
                selector: 'dw-input',
                template: "<dw-control-wrapper-with-icons [showPrefix]=\"!!options?.prefix\" [showSuffix]=\"!!options?.suffix\" wrapControl=\"false\">\r\n       <span prefix class=\"input-group-text\">{{options?.prefix}}</span>\r\n       \r\n       <input control #inputElement [ngClass]=\"inputClass\" [ngModel]=\"translatedValue\"\r\n              (ngModelChange)=\"setTranslatedValue($event)\" [type]=\"type\" [placeholder]=\"placeholder || ''\"\r\n              [dwNumeric]=\"numeric\" [decimals]=\"finalDecimals\" [maxlength]=\"maxlength\"\r\n              [dwBrowserAutocomplete]=\"options?.autoCompleteEnabled\"\r\n              [autocompleteText]=\"options?.autoCompleteType\" [allowNegative]=\"finalAllowNegative\">\r\n\r\n       <span suffix class=\"input-group-text\">{{options?.suffix}}</span>\r\n</dw-control-wrapper-with-icons>\r\n\r\n<div class=\"input-group mb-3\" *ngIf=\"false\">\r\n       <div class=\"input-group-prepend\" [hidden]=\"!options?.prefix\">\r\n              <span class=\"input-group-text\">{{options?.prefix}}</span>\r\n       </div>\r\n\r\n       <input #inputElement [ngClass]=\"inputClass\" [ngModel]=\"translatedValue\"\r\n              (ngModelChange)=\"setTranslatedValue($event)\" [type]=\"type\" [placeholder]=\"placeholder || ''\"\r\n              [dwNumeric]=\"numeric\" [decimals]=\"finalDecimals\" [maxlength]=\"maxlength\"\r\n              [dwBrowserAutocomplete]=\"options?.autoCompleteEnabled\" [autocompleteText]=\"options?.autoCompleteType\"\r\n              [allowNegative]=\"finalAllowNegative\" (blur)=\"onBlur($event)\">\r\n\r\n       <div class=\"input-group-append\" [hidden]=\"!options?.suffix\">\r\n              <span class=\"input-group-text\">{{options?.suffix}}</span>\r\n       </div>\r\n</div>\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwInputComponent),
                        multi: true
                    }]
            }]
    }], null, { type: [{
            type: Input
        }], blur: [{
            type: Output
        }], placeholder: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], numeric: [{
            type: Input
        }], decimals: [{
            type: Input
        }], allowNegative: [{
            type: Input
        }], options: [{
            type: Input
        }], inputElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();
const ɵDwYesNoComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwYesNoComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwYesNoComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-yesno',
                template: "<dw-radio-list *ngIf=\"!showAsDropdown\" [values]=\"values\" [ngModel]=\"translatedValue\" (ngModelChange)=\"setTranslatedValue($event)\"></dw-radio-list>\r\n\r\n\r\n<select *ngIf=\"showAsDropdown\" [ngModel]=\"translatedValue\" (ngModelChange)=\"setTranslatedValue($event)\" class=\"form-control\">\r\n    <option *ngFor=\"let value of values\" [ngValue]=\"value.value\">\r\n        {{value.display}}\r\n    </option>\r\n</select>\r\n\r\n<!-- Allow null {{ allowNull}}<br>\r\n\r\nValues: {{values | json }}<br>\r\n\r\ntranslated value: {{translatedValue | json }}<br>\r\n\r\nvalue: {{value | json}}\r\n -->\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwYesNoComponent),
                        multi: true
                    }],
                styles: [".radio-container{margin:5px}.radio-item{margin-left:5px;margin-top:-6px}.container{-moz-user-select:none;-webkit-user-select:none;cursor:pointer;display:block;font-size:22px;margin-bottom:12px;padding-left:35px;position:relative;user-select:none}.container input{cursor:pointer;height:0;opacity:0;position:absolute;width:0}.checkmark{background-color:#eee;border-radius:50%;height:25px;left:0;position:absolute;top:0;width:25px}.container:hover input~.checkmark{background-color:#ccc}.container input:checked~.checkmark{background-color:#2196f3}.checkmark:after{content:\"\";display:none;position:absolute}.container input:checked~.checkmark:after{display:block}.container .checkmark:after{background:#fff;border-radius:50%;height:8px;left:9px;top:9px;width:8px}"]
            }]
    }], null, { groupName: [{
            type: Input
        }], allowNull: [{
            type: Input
        }], nullDisplay: [{
            type: Input
        }], showAsDropdown: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-select',
                template: "<select\r\n       [id]=\"id\"\r\n       (change)=\"onChange($event)\"\r\n       (keyup)=\"onKeyup($event)\"\r\n       (blur)=\"onBlur($event)\"\r\n       ([ngModel])=\"value\"\r\n       [disabled]=\"disabled\">\r\n    <option *ngIf=\"showBlank\">{{blankText}}</option>\r\n    <option *ngFor=\"let item of options\" value=\"{{item[idField]}}\" >\r\n        {{item[displayField]}}\r\n    </option>\r\n</select>\r\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwSelectComponent),
                        multi: true
                    }]
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], showBlank: [{
            type: Input
        }], blankText: [{
            type: Input
        }], displayField: [{
            type: Input
        }], idField: [{
            type: Input
        }], id: [{
            type: Input
        }], disabled: [{
            type: Input
        }], _inputElement: [{
            type: ViewChild,
            args: ['inputElement']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwColDirective, [{
        type: Directive,
        args: [{
                selector: '[dwCol]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { colSize: [{
            type: Input,
            args: ['dwCol']
        }], sizeType: [{
            type: Input,
            args: ['dwSizeType']
        }], layoutMode: [{
            type: Input,
            args: ['layoutMode']
        }], elementClass: [{
            type: HostBinding,
            args: ['class']
        }], style: [{
            type: HostBinding,
            args: ['style']
        }], colWidth: [{
            type: Input,
            args: ['dwColWidth']
        }], colClass: [{
            type: Input,
            args: ['dwColClass']
        }], options: [{
            type: Input,
            args: ['dwColOptions']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRowDirective, [{
        type: Directive,
        args: [{
                selector: '[dwRow]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { elementClass: [{
            type: HostBinding,
            args: ['class']
        }], elementStyle: [{
            type: HostBinding,
            args: ['style']
        }], layoutMode: [{
            type: Input,
            args: ['layoutMode']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwNavDropdownDirective, [{
        type: Directive,
        args: [{
                selector: '[dwAppNavDropdown]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwNavDropdownToggleDirective, [{
        type: Directive,
        args: [{
                selector: '[dwAppNavDropdownToggle]'
            }]
    }], function () { return [{ type: DwNavDropdownDirective }]; }, { toggleOpen: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppSidebarNavComponent, [{
        type: Component,
        args: [{
                selector: 'dw-app-sidebar-nav',
                template: `
    <ul class="nav">
      
      <div *ngFor="let navitem of navItems">
           
           <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
            
           <dw-app-sidebar-nav-title *ngIf="isTitle(navitem)" [title]='navitem'></dw-app-sidebar-nav-title>
           <dw-app-sidebar-nav-item *ngIf="!isDivider(navitem)&&!isTitle(navitem)" [item]='navitem'></dw-app-sidebar-nav-item>
      </div>
    </ul>`
            }]
    }], function () { return []; }, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], navItems: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppSidebarNavItemComponent, [{
        type: Component,
        args: [{
                selector: 'dw-app-sidebar-nav-item',
                template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
        <dw-menu-link [menu]="item" [menuLocation]="'side-bar'"></dw-menu-link>
      <!-- <dw-app-sidebar-nav-link [link]='item' [exactMatch]='item?.data?.highlightOnExactMatch'></dw-app-sidebar-nav-link> -->
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          dwAppNavDropdown>
        <dw-app-sidebar-nav-dropdown [link]='item'></dw-app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: ɵngcc0.ElementRef }, { type: DwMenuService }]; }, { item: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppSidebarNavLinkComponent, [{
        type: Component,
        args: [{
                selector: 'dw-app-sidebar-nav-link',
                template: `
        <dw-menu-link [menu]="link"></dw-menu-link>
  `
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: ɵngcc0.ElementRef }]; }, { exactMatch: [{
            type: Input
        }], link: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppSidebarNavDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'dw-app-sidebar-nav-dropdown',
                template: `
    <a class="nav-link nav-dropdown-toggle" dwAppNavDropdownToggle>
      <i *ngIf="isIcon()" class="nav-icon {{ link.data.iconCssClass }}"></i>
      {{ link.display }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <dw-app-sidebar-nav-item [item]='child'></dw-app-sidebar-nav-item>
      </ng-template>
    </ul>
  `,
                styles: ['.nav-dropdown-toggle { cursor: pointer; }']
            }]
    }], function () { return [{ type: ɵngcc2.Router }, { type: ɵngcc0.ElementRef }]; }, { link: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppSidebarNavTitleComponent, [{
        type: Component,
        args: [{
                selector: 'dw-app-sidebar-nav-title',
                template: ''
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { title: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiConfigHostDirective, [{
        type: Directive,
        args: [{
                selector: '[dw-ui-config-host]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiConfigPanelComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-ui-config-panel',
                template: "\r\n<div class=\"config-bar\" [hidden]=\"!canConfigure\">\r\n    <div class=\"config-bar-left-panel\" *ngIf=\"hasConfigurations\">\r\n        <div class=\"config-handle\" (click)=\"toggleSidebar('config')\" [ngClass]=\"{ 'selected-handle': panelMode=='config' && isExpanded }\">\r\n            <i class=\"fa fa-cog\"></i>\r\n        </div>\r\n        <div class=\"config-handle2\" [hidden]=\"!currentWidgetConfig?.debugComponent\" (click)=\"toggleSidebar('debug')\" [ngClass]=\"{ 'selected-handle': panelMode=='debug' && isExpanded }\">\r\n            <i class=\"fa fa-bug\"></i>\r\n        </div>\r\n    </div>\r\n    <div class=\"config-bar-body\">\r\n        <h3>Configuration</h3>\r\n\r\n        <div dwRow *ngIf=\"widgetConfigs && widgetConfigs.length>0\">\r\n            <div dwCol=\"12\">\r\n                <label>Configuration</label>\r\n            </div>\r\n            <div dwCol=\"12\">\r\n                <select [ngModel]=\"currentWidgetConfig\" (ngModelChange)=\"setConfigComponent($event)\" class=\"form-control\" [ngModelOptions]=\"{standalone: true}\">\r\n                    <option *ngFor=\"let widgetConfig of widgetConfigs, let i = index\" [ngValue]=\"widgetConfig\">\r\n                            {{getWidgetConfigDisplay(widgetConfig)}}\r\n                    </option>\r\n                </select> \r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"!widgetConfigs || widgetConfigs.length==0\">\r\n            <div dwCol=\"12\">\r\n                No Components to configure\r\n            </div>\r\n        </div>\r\n\r\n        <div [hidden]=\"panelMode!='config'\">\r\n            <ng-template dw-ui-config-host #config></ng-template>\r\n        </div>\r\n        <div [hidden]=\"panelMode!='debug'\">\r\n            DEBUG PANEL\r\n            <dw-dynamic-loader [component]=\"currentWidgetConfig?.debugComponent\"\r\n            (configure)=\"configureDebugComponent($event)\"></dw-dynamic-loader>\r\n        </div>\r\n    </div>\r\n    <div class=\"config-bar-message\" *ngIf=\"currentWidgetInstance && message\">\r\n        <dw-message [(message)]=\"message\"></dw-message>\r\n    </div>\r\n    <div class=\"config-bar-footer\" *ngIf=\"currentWidgetInstance\">\r\n        <button class=\"btn-sm btn-success\" (click)=\"save()\" title=\"Save Prefences\">Save</button><button class=\"btn-sm btn-success\" (click)=\"reset()\" title=\"Reset to Defaults\">Reset</button>\r\n    </div>\r\n\r\n</div>",
                styles: [".config-bar{display:flex;flex:0 0 200px;flex-direction:column;height:calc(100vh - var(--dw-navbar-height,55px));order:-1;position:fixed;width:250px}.config-bar-body{height:100%;padding:5px}.config-bar-footer{background-color:grey;height:55px;padding:5px;width:100%}.config-bar-message{overflow:hidden;padding:5px;width:100%}.config-bar-footer button{float:right;margin-left:8px}.config-bar-left-panel{background-color:#f08080;height:0}.config-bar-left-panel .config-handle{margin-top:200px}.config-bar-left-panel .config-handle,.config-bar-left-panel .config-handle2{background:rgba(0,0,0,.1);border-bottom-left-radius:15px;border-top-left-radius:15px;cursor:pointer;font-size:1.5em;height:37px;line-height:37px;margin-left:-37px;padding-left:7px;width:37px}.config-bar-left-panel .config-handle2{margin-top:2px}.config-bar-left-panel .selected-handle{background-color:#add8e6!important}@media (max-width:1000px){.config-handle{display:none}}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: ɵngcc0.ComponentFactoryResolver }, { type: DwUiConfigService }, { type: DwEventService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwDesignerStateService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { dwUiConfigHost: [{
            type: ViewChild,
            args: [DwUiConfigHostDirective, { static: true }]
        }], dwGridHost: [{
            type: ViewChild,
            args: [DwGridHostDirective]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMessageBarComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-message-bar',
                template: "<div>\r\n    <div *ngIf=\"showToasts\">\r\n        <p-toast [style]=\"{marginTop: '40px', marginRight: '-13px'}\"></p-toast>\r\n    </div>\r\n\r\n    <div *ngIf=\"showRequestCounts\" style2=\"height:8px;overflow:auto;background-color:aqua\">\r\n\r\n        <div style=\"margin-top:-25px;height:10px;\">\r\n            <div style=\"margin-top:-25px;\">\r\n                \r\n                <div [hidden]=\"!showProgress\" [ngClass]=\"{ 'green-progress' : realTimeSaveRequestCount}\">\r\n                    <p-progressBar mode=\"indeterminate\" [style]=\"{'height': '3px'}\"></p-progressBar>&nbsp;\r\n                    \r\n                    <div *ngIf=\"false\">\r\n                        <div class=\"badge badge-light\">{{requestCount}}</div>\r\n                        <div class=\"badge badge-light\">{{saveRequestCount}}</div>\r\n                        <div class=\"badge badge-light\">{{realTimeRequestCount}}</div>\r\n                        <div class=\"badge badge-light\">{{realTimeSaveRequestCount}}</div>\r\n                    </div>\r\n                </div>\r\n                <div [hidden]=\"showProgress\" style=\"height:3px;\">\r\n                    <!-- Place holder to reduce bounce -->\r\n                </div>\r\n            </div>\r\n            <div style=\"margin-top:25px\">\r\n            </div>\r\n        </div> \r\n    </div>\r\n</div>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".blueProgress .ui-progressbar .ui-progressbar-label{color:#ff0}.greenProgress,.greenProgress .ui-progressbar .ui-progressbar-value{background-color:#90ee90}.greenProgress{color:red}.customProgress .ui-progressbar .ui-progressbar-label{color:#ff0}.customProgress .ui-progressbar .ui-progressbar-value{background:red}.green{color:#90ee90}"]
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwMessagingService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: ɵngcc6.MessageService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ApplicationRef }]; }, { showToasts: [{
            type: Input
        }], showRequestCounts: [{
            type: Input
        }], locationKey: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwModalHostComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-modal-host',
                template: "<div>\r\n    <div class=\"dw-modal-backdrop2\" [ngClass]=\"{'dw-modal-backup-show3' : showModal }\">\r\n        <p-dialog [(visible)]=\"showModal\" [baseZIndex]=\"baseZIndex\" [closable]=\"closable\" [closeOnEscape]=\"closeOnEscape\" autoZIndex=\"false\" [keepInViewport]=\"false\" [blockScroll]=\"true\" [modal]=\"true\" [maximizable]=\"modalConfig?.allowFullScreen\" transitionOptions=\"250ms cubic-bezier(0.25, 0.8, 0.25, 1)\" transitionOptions2=\"0ms ease-in\"  (visibleChange)=\"changeVisible($event)\" [style]=\"modalStyle\" contentStyle2=\"{'min-width':'50vw','max-height': '78vh'}\" class=\"dw-modal\">\r\n            <p-header>\r\n                {{modalConfig?.title}}\r\n            </p-header> \r\n            <div class=\"dw-modal-content\" [ngStyle]=\"bodyStyle\">\r\n                <dw-html-view [ngModel]=\"modalConfig?.content\" *ngIf=\"modalConfig?.content\"></dw-html-view>\r\n                \r\n                <ng-template dw-component-host></ng-template>\r\n            </div>\r\n            <p-footer *ngIf=\"!modalConfig?.hideFooter\">\r\n                <!-- <button (click)=\"displayModal2()\">Show Modal 2</button> -->\r\n                <ng-container *ngFor=\"let button of modalConfig?.buttons\">\r\n                    <dw-button [buttonConfig]=\"button\" (click)=\"buttonClick(button)\"></dw-button>\r\n                </ng-container>\r\n            </p-footer>\r\n        </p-dialog>\r\n\r\n\r\n        <p-dialog [(visible)]=\"showModal2\" [baseZIndex]=\"baseZIndex2\" autoZIndex=\"false\" [keepInViewport]=\"false\" [blockScroll]=\"true\" [modal]=\"true\" [maximizable]=\"modalConfig?.allowFullScreen\" transitionOptions=\"250ms cubic-bezier(0.25, 0.8, 0.25, 1)\" transitionOptions2=\"0ms ease-in\"  (visibleChange)=\"changeVisible($event)\" [style]=\"modalStyle\" contentStyle2=\"{'min-width':'50vw','max-height': '78vh'}\" class=\"dw-modal\">\r\n            <p-header>\r\n                {{modalConfig?.title}}\r\n            </p-header>\r\n            <div class=\"dw-modal-content\" [ngStyle]=\"bodyStyle\">\r\n                <dw-html-view [ngModel]=\"modalConfig?.content\" *ngIf=\"modalConfig?.content\"></dw-html-view>\r\n                \r\n                <ng-template dw-component-host></ng-template>\r\n            </div>\r\n            <p-footer *ngIf=\"!modalConfig?.hideFooter\">\r\n                <ng-container *ngFor=\"let button of modalConfig?.buttons\">\r\n                    <dw-button [buttonConfig]=\"button\" (click)=\"buttonClick(button)\"></dw-button>\r\n                    <!--<button type=\"{{button.type}}\" (click)=\"buttonClick(button)\" class=\"{{button.buttonClass}}\">{{button.buttonText}}</button>-->\r\n                </ng-container>\r\n            </p-footer>\r\n        </p-dialog>\r\n    </div>\r\n</div>",
                styles: [".dw-modal-backdrop{bottom:0;display:none;left:0;opacity:0;position:fixed;right:0;top:0;z-index:1020}.dw-modal-backup-show{display:block;opacity:1}.dw-modal-content{max-height:80vh;padding:3px}"]
            }]
    }], function () { return [{ type: DwModalService }, { type: ɵngcc0.ComponentFactoryResolver }, { type: DwSecurityStateService }]; }, { instanceNo: [{
            type: Input
        }], dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwButtonComponent, [{
        type: Component,
        args: [{
                selector: 'dw-button',
                template: "<ng-container [ngSwitch]=\"buttonConfig?.buttonType\">\r\n            \r\n    <button type=\"button\" *ngSwitchDefault [class]=\"buttonConfig?.buttonClass\" [title]=\"buttonConfig?.buttonTitle || ''\" [disabled]=\"disabled || buttonConfig?.disabled\" [hidden]=\"buttonConfig?.hidden\" (middleclick)=\"middleClick($event)\">\r\n        <i *ngIf=\"buttonConfig?.iconClass && !buttonConfig?.showIconAfterText\" [class]=\"buttonConfig?.iconClass\"></i>\r\n        {{buttonConfig?.buttonText}} <i [hidden]=\"!firing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n        <i *ngIf=\"buttonConfig?.iconClass && buttonConfig?.showIconAfterText\" [class]=\"buttonConfig?.iconClass\"></i>\r\n\r\n        <span class=\"fa fa-caret-down\" [hidden]=\"!showCaret\"></span>\r\n    </button>\r\n   \r\n    <span *ngSwitchCase=\"'iconOnly'\">\r\n        <i *ngIf=\"buttonConfig?.iconClass && !buttonConfig?.showIconAfterText\" [class]=\"buttonConfig?.iconClass\" [ngClass]=\"{ 'dw-icon-disabled': disabled || buttonConfig?.disabled }\"></i>\r\n        {{buttonConfig?.buttonText}}\r\n        <i *ngIf=\"buttonConfig?.iconClass && buttonConfig?.showIconAfterText\" [class]=\"buttonConfig?.iconClass\" [ngClass]=\"{ 'dw-icon-disabled': disabled || buttonConfig?.disabled }\"></i>\r\n        \r\n        <span class=\"fa fa-caret-down\" [hidden]=\"!showCaret\"></span>\r\n    </span>\r\n    \r\n    <span *ngSwitchCase=\"'iconOnlyNoText'\">\r\n        <i  class=\"{{buttonConfig?.iconClass}} hand\" [title]=\"buttonConfig?.buttonTitle || ''\" [hidden]=\"buttonConfig?.hidden\" [ngClass]=\"{ 'dw-icon-disabled': disabled || buttonConfig?.disabled }\"></i>\r\n\r\n        <span class=\"fa fa-caret-down\" [hidden]=\"!showCaret\"></span>\r\n    </span> \r\n\r\n    <span *ngSwitchCase=\"'link'\">\r\n        <a href=\"#\" (click)=\"$event.preventDefault()\"><i class=\"{{buttonConfig?.iconClass}} hand\" [title]=\"buttonConfig?.buttonTitle || ''\" [hidden]=\"buttonConfig?.hidden\" [ngClass]=\"{ 'dw-icon-disabled': disabled || buttonConfig?.disabled }\" ></i> {{buttonConfig?.buttonText}}</a>\r\n\r\n        <span class=\"fa fa-caret-down\" [hidden]=\"!showCaret\"></span>\r\n    </span>\r\n</ng-container>\r\n"
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], middleclick: [{
            type: Output,
            args: ['middleclick']
        }], firing: [{
            type: Input
        }], showCaret: [{
            type: Input
        }], buttonConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityEmulationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwSecurityStateService }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityUserService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityEmulationComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-emulation',
                template: "<div class=\"emulation-box\">\r\n  <form [formGroup]=\"formGroup\" (ngSubmit)=\"findUsers()\"> \r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n          <label>First Name</label>\r\n          <input class=\"form-control\" formControlName=\"firstName\" autofocus>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n          <label>Last Name</label>\r\n          <input class=\"form-control\" formControlName=\"lastName\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n          <label>E-mail</label>\r\n          <input class=\"form-control\" formControlName=\"email\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <button class=\"btn btn-success\">Search</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n\r\n<dw-message [message]=\"message\"></dw-message>\r\n\r\n<div class=\"search-results\">\r\n  <ul  class=\"list-group\">\r\n    <li class=\"list-group-item\" *ngFor=\"let user of users\">\r\n        <span class=\"pull-right hand\">\r\n            <a (click)=\"emulateUser(user)\">Emulate</a>\r\n        </span>\r\n\r\n        {{user.FirstName}} {{user.LastName }} ({{user.Email }})\r\n    </li>\r\n  </ul>\r\n</div>\r\n",
                styles: [".emulation-box{background:#fff;box-shadow:0 0 5px #ccc;margin:10px;max-width:690px;min-width:350px;padding:23px}.search-results{clear:left;margin-top:10px;max-height:200px;overflow:auto;width:100%}"]
            }]
    }], function () { return [{ type: DwSecurityEmulationService }, { type: ɵngcc3.FormBuilder }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityAvatarComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-avatar',
                template: `
    <img src="{{avatarUrl}}" class="security-avatar" alt="Avatar" />
  `
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityInfoComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-info',
                template: "<div class=\"security-info\">\r\n    <div *ngIf=\"isAuthenticated\" class2=\"security-info\">\r\n        <ul class=\"nav navbar-nav ml-auto\">\r\n            <li #dropDown class=\"nav-item dropdown\" dropdown [autoClose]=\"true\" placement=\"bottom right\">\r\n                <a class=\"nav-link\" data-toggle=\"dropdown\" href=\"#\" role=\"button\" aria-haspopup=\"true\"\r\n                    aria-expanded=\"false\" dropdownToggle (click)=\"false\">\r\n                    <dw-dynamic-loader [component]=\"defaultAvatar\" componentName=\"securityAvatar\"></dw-dynamic-loader>\r\n                    <div class=\"user-info-detail\">\r\n                        <span>{{fullNameDisplay}}</span>\r\n                        <i class=\"fa fa-chevron-down pull-right\"></i> \r\n                    </div>\r\n                </a>\r\n                <div class=\"dropdown-menu dropdown-menu-right\" *dropdownMenu aria-labelledby=\"simple-dropdown\"\r\n                    (click)=\"meunClick($event)\">\r\n                    <!-- <div class=\"dropdown-header\"><b>{{authenticatedUser?.FirstNameLastName}}</b></div> -->\r\n                    <div class=\"dropdown-header\"><b>{{authenticateNameDisplay}}</b></div>\r\n                    <a class=\"dropdown-item  hand\" *ngIf=\"canEmulate\" (click)=\"showEmulateSelection()\"><i\r\n                            class=\"fa fa-user-friends\"></i> Emulate</a>\r\n                    <a class=\"dropdown-item hand\" *ngIf=\"isEmulating\" (click)=\"cancelEmulation()\"> <i\r\n                            class=\"fa fa-user-slash\"></i> Cancel Emulation</a>\r\n\r\n                    <dw-security-user-menu></dw-security-user-menu>\r\n\r\n                    <div class=\"divider\"></div>\r\n                    <a class=\"dropdown-item  hand\" (click)=\"logout()\">\r\n                        <i class=\"fa fa-sign-out\"></i>\r\n                        Logout\r\n                    </a>\r\n                </div>\r\n                <div class=\"user-info-additional-detail\">{{addionalLine}}</div>\r\n                <!--<dw-navigation nav-category=\"USER_MENU\"></dw-navigation>-->\r\n            </li>\r\n        </ul>\r\n    </div>\r\n    <div *ngIf=\"!isAuthenticated\" class2=\"security-info\">\r\n        <div (click)=\"login()\" class=\"security-login-link\"><i class=\"fa fa-power-off\"></i> Login</div>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityUserService }, { type: DwSecurityEmulationService }, { type: DwSecurityOrchestrationService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwModalService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { dropDown: [{
            type: ViewChild,
            args: [BsDropdownDirective]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionHostComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-host',
                template: `
  	<ng-template dw-component-host></ng-template>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }]; }, { dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwModal, [{
        type: Component,
        args: [{
                selector: 'dw-modal',
                template: "<div>\r\n    Modal content:\r\n\r\n    <style>\r\n        .modal {\r\n            display:unset;\r\n            top:unset;\r\n            bottom:unset;\r\n        }\r\n        .close {\r\n            margin-top:-30px;\r\n            margin-right:-25px;\r\n        }\r\n    </style>\r\n    <div class=\"modal\" id=\"myModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\">\r\n        <div class=\"modal-dialog\" role=\"document\">\r\n            <div class=\"modal-content\">\r\n                <div class=\"modal-header\">\r\n                    <h4 class=\"modal-title\" id=\"myModalLabel\">Modal title</h4>\r\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>\r\n                </div>\r\n                <div class=\"modal-body\">\r\n                    <form>\r\n                        <div class=\"form-group\">\r\n                            <label for=\"recipient-name\" class=\"control-label\">Recipient:</label>\r\n                            <input type=\"text\" class=\"form-control\" id=\"recipient-name\">\r\n                        </div>\r\n                        <div class=\"form-group\">\r\n                            <label for=\"message-text\" class=\"control-label\">Message:</label>\r\n                            <textarea class=\"form-control\" id=\"message-text\"></textarea>\r\n                        </div>\r\n                    </form>\r\n                </div>\r\n                <div class=\"modal-footer\">\r\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\r\n                    <button type=\"button\" class=\"btn btn-primary\">Save changes</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>"
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwHtmlViewComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-html-view',
                template: `
    <div class='htmlContainer' [innerHTML]="translatedValue"></div>
  `,
                encapsulation: ViewEncapsulation.None,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwHtmlViewComponent),
                        multi: true
                    }],
                styles: [".htmlContainer p{margin-bottom:0}"]
            }]
    }], function () { return [{ type: ɵngcc17.DomSanitizer }, { type: ɵngcc0.ChangeDetectorRef }]; }, { missingDataText: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCardItemDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwCardItem]'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListItemDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwListItem]'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwNoItemsDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwNoItems]'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataListComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-data-list',
                template: "<ng-content select=\"[filterTiles]\"></ng-content>\r\n\r\n<div [ngClass]=\"styles?.containerClass\">\r\n\r\n    <div [ngClass]=\"styles?.containerHeaderClass\"\r\n        *ngIf=\"config?.showHeader && (!config?.showActions || showFilterSection)\">\r\n        {{config!.headerTitle}}\r\n    </div>\r\n    <div [ngClass]=\"styles?.filterContainerClass\" *ngIf=\"showFilterSection\">\r\n        <div [ngClass]=\"styles?.filterHeaderClass\">\r\n            Filters\r\n        </div>\r\n        <div [ngClass]=\"styles?.filterBodyClass\">\r\n            <form (onsubmit)=\"applyFilters(filters)\">\r\n                <ng-content select=\"[filter]\"></ng-content>\r\n\r\n                <div class=\"row2\" *ngIf=\"!config?.autoFilter\">\r\n                    <div [ngClass]=\"styles?.filterButtonContainer\">\r\n                        <button type=\"submit\" class=\"btn btn-success\" (click)=\"applyFilters(filters)\">Filter</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n\r\n    <div [ngClass]=\"styles?.actionBarClass\" *ngIf=\"config?.showActions\">\r\n        <div class=\"dw-grid-buttons-left\">\r\n            <div class=\"dw-section-container-header\" *ngIf=\"config?.showHeader && !showFilterSection\">\r\n                {{config!.headerTitle}}\r\n            </div>\r\n            <dw-action-bar [actionPreferences]=\"config?.actionPreferencesByMode?.actionBarLeft\"\r\n                (actionClick)=\"actionPrefClicked($event)\" useContainerStyle=\"false\" [actionContext]=\"actionContext\">\r\n            </dw-action-bar>\r\n        </div>\r\n        <div class=\"dw-grid-buttons-right\">\r\n            <dw-action-bar [actionPreferences]=\"config?.actionPreferencesByMode?.actionBarRight\"\r\n                (actionClick)=\"actionPrefClicked($event)\" useContainerStyle=\"false\" [actionContext]=\"actionContext\">\r\n            </dw-action-bar>\r\n        </div>\r\n    </div>\r\n    <div [ngClass]=\"styles?.bodyClass\">\r\n         <div infiniteScroll [infiniteScrollDistance]=\"2\" [infiniteScrollThrottle]=\"50\" (scrolled)=\"onScroll()\"> \r\n            <div>\r\n                <div style=\"width:100%\"></div>\r\n                <ng-container [ngSwitch]=\"mode\">\r\n                    <ng-container *ngSwitchCase=\"'card'\">\r\n                        <div class=\"row\">\r\n                            <ng-container *ngFor=\"let item of displayedData\">\r\n                                <ng-container *ngTemplateOutlet=\"cardItemTemplate; context : {$implicit: item}\">\r\n                                </ng-container>\r\n                            </ng-container>\r\n                        </div>\r\n                    </ng-container>\r\n                    <ng-container *ngSwitchCase=\"'list'\">\r\n                        <div class=\"row\">\r\n                            <ng-container *ngFor=\"let item of displayedData\">\r\n                                <ng-container *ngTemplateOutlet=\"listItemTemplate; context : {$implicit: item}\">\r\n                                </ng-container>\r\n                            </ng-container>\r\n                        </div>\r\n                    </ng-container>\r\n                </ng-container>\r\n            </div>\r\n        </div>\r\n        <div *ngIf=\"!isLoading && (!displayedData || displayedData.length==0)\">\r\n            <span *ngIf=\"!noItemsTemplate\">There are no items found</span>\r\n\r\n            <ng-container *ngTemplateOutlet=\"noItemsTemplate; context : {$implicit: item}\"></ng-container>\r\n        </div>\r\n        <dw-loading [show]=\"isLoading && !config?.hideLoading\" text=\"Loading\"></dw-loading>\r\n\r\n        <dw-action-bar [actionPreferences]=\"config?.actionPreferencesByMode?.actionBarBottom\"\r\n            (actionClick)=\"actionPrefClicked($event)\" useContainerStyle=\"true\" [actionContext]=\"actionContext\">\r\n        </dw-action-bar>\r\n    </div>\r\n</div>",
                styles: [".row{margin-left:0;margin-right:0}"]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, { config: [{
            type: Input
        }], actionClick: [{
            type: Output
        }], dataLoadComplete: [{
            type: Output
        }], mode: [{
            type: Input
        }], displayCount: [{
            type: Input
        }], defaultPageSize: [{
            type: Input
        }], defaultDisplayPageSize: [{
            type: Input
        }], filters: [{
            type: Input
        }], data: [{
            type: Input
        }], cardContext: [{
            type: Input
        }], actionContext: [{
            type: Input
        }], cardItemTemplate: [{
            type: ContentChild,
            args: [DwCardItemDirective, { static: true, read: TemplateRef }]
        }], listItemTemplate: [{
            type: ContentChild,
            args: [DwListItemDirective, { static: true, read: TemplateRef }]
        }], noItemsTemplate: [{
            type: ContentChild,
            args: [DwNoItemsDirective, { static: true, read: TemplateRef }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwReadOnlyControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-readonly',
                template: `<div class="read-only" [innerHtml]="translatedValue"></div>`,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwReadOnlyControlComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: ɵngcc17.DomSanitizer }]; }, { missingDataText: [{
            type: Input
        }], use24HourTime: [{
            type: Input
        }], formatType: [{
            type: Input
        }], useGmtDateTime: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouterParentComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-router-parent',
                template: "<div [ngClass]=\"pageStyleName\">\r\n   <div *ngIf=\"loadContent && !useIf\" [hidden]=\"false || childRouteActivated\" [ngClass]=\"pageSyleNameInner\">\r\n      <ng-container *ngTemplateOutlet=\"templateRef;\"></ng-container>\r\n   </div>\r\n   <div *ngIf=\"loadContent && useIf && !childRouteActivated\" [ngClass]=\"pageSyleNameInner\">\r\n      <ng-container *ngTemplateOutlet=\"templateRef;\"></ng-container>\r\n   </div>\r\n\r\n   <ng-container *ngIf=\"!useModalOutlet\">\r\n      <router-outlet (activate)=\"toggleActivate(true)\" (deactivate)=\"toggleActivate(false)\"\r\n         #myOutlet=\"outlet\"></router-outlet>\r\n   </ng-container>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }]; }, { useIf: [{
            type: Input
        }], useModalOutlet: [{
            type: Input
        }], outletName: [{
            type: Input
        }], activated: [{
            type: Output
        }], reactivated: [{
            type: Output
        }], templateRef: [{
            type: ContentChild,
            args: [TemplateRef, { static: true }]
        }] }); })();
const ɵDwDateValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwDateValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateValidationRule, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateInputControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-date',
                template: `
        <p-calendar 
            [ngModel]="translatedValue" 
            (ngModelChange)="setTranslatedValue($event)" 
            [showIcon]="true" 
            [hourFormat]="hourFormat" 
            [showTime]="showTime" 
            [timeOnly]="timeOnly" 
            [todayButtonStyleClass]="todayStyle" 
            [showButtonBar]="true" 
            [disabledDays]="disabledDays" 
            [numberOfMonths]="monthsToShow" 
            [disabled]="disabled"
            dataType="string" 
            appendTo="body" baseZIndex="1100" autoZIndex="false" ></p-calendar>
        `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwDateInputControlComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: ɵngcc3.ControlContainer, decorators: [{
                type: Optional
            }] }]; }, { useGmtDateTime: [{
            type: Input
        }], showTime: [{
            type: Input
        }], timeOnly: [{
            type: Input
        }], use24HourTime: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], dateOptions: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPillsDisplayDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwDisplay]'
            }]
    }], null, null); })();
const ɵDwPillsComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwPillsComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPillsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-pills',
                template: `
    <div class="dw-pills">
        <ng-container *ngFor="let item of pillItems">
            <div (click)="setTranslatedValue(item)" [ngClass]="{ 'active' : item.value == value}" class="dw-pill" [title]="item.tooltip">
                <i [ngClass]="item.iconClass" [hidden]="!item.iconClass"></i>{{ item.display }}
            </div>
        </ng-container> 
    </div>
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwPillsComponent),
                        multi: true
                    }],
                styles: [".dw-pill{cursor:pointer;margin-right:5px;padding:5px}"]
            }]
    }], null, { iconField: [{
            type: Input
        }], items: [{
            type: Input
        }], valueField: [{
            type: Input
        }], displayField: [{
            type: Input
        }], tooltipField: [{
            type: Input
        }], pillsDisplayTemplate: [{
            type: ContentChild,
            args: [DwPillsDisplayDirective, { static: true, read: TemplateRef }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwValidationInfo, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-validation-info',
                template: `<span class="invalid-feedback">{{errorMessage}}</span>`,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwValidationInfo),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: ɵngcc3.ControlContainer, decorators: [{
                type: Optional
            }, {
                type: Host
            }, {
                type: SkipSelf
            }] }, { type: DwValidationService }]; }, { messageSeparator: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], displayName: [{
            type: Input
        }], submitted: [{
            type: Input
        }], filterKey: [{
            type: Input
        }], formGroup: [{
            type: Input
        }] }); })();
const ɵDwHtmlEditComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwHtmlEditComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwHtmlEditComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-html-edit',
                template: "\r\n\r\n<div #container *ngIf=\"true\">\r\n\r\n    <ng-container *ngIf=\"!fieldSources || fieldSources.length == 0\">\r\n        <dw-quill-editor [html]=\"editableHtml\" (htmlChange)=\"setEditableHtml($event)\"\r\n            (onEditorCreated)=\"editorCreated($event)\" [modules]=\"modules\" [disabled]=\"disabled\" *ngIf=\"!viewMarkup\">\r\n        </dw-quill-editor>\r\n\r\n    </ng-container>\r\n\r\n    <div *ngIf=\"viewMarkup\">\r\n        <div class=\"ql-toolbar ql-snow\">\r\n            <span class=\"ql-formats hand\" (click)=\"toggleViewMarkup()\">\r\n                Return\r\n            </span>\r\n        </div>\r\n        <textarea [ngModel]=\"translatedValue\" (ngModelChange)=\"setTranslatedValue($event)\"\r\n            [style]=\"{'min-height':'120px'}\"></textArea>\r\n    </div>\r\n\r\n    <p-splitter [style]=\"{'height': '500px'}\" [panelSizes]=\"[70,30]\" *ngIf=\"!viewMarkup && fieldSources?.length > 0\">\r\n        <ng-template pTemplate>\r\n            <div class=\"left-panel\">\r\n                <dw-quill-editor [html]=\"editableHtml\" (htmlChange)=\"setEditableHtml($event)\"\r\n                    (onEditorCreated)=\"editorCreated($event)\" [modules]=\"modules\" [disabled]=\"disabled\"\r\n                    *ngIf=\"!viewMarkup\">\r\n                </dw-quill-editor>\r\n            </div>\r\n        </ng-template>\r\n        <ng-template pTemplate>\r\n            <div class=\"right-panel\">\r\n                <p-accordion multiple=\"true\">\r\n                    <p-accordionTab *ngFor=\"let fieldSource of fieldSources;let i = index\"\r\n                        [header]=\"fieldSource.display\" [selected]=\"i==0\">\r\n                        <div *ngFor=\"let field of fieldSource?.fieldItems\" class=\"field-item\">\r\n                            <button class=\"btn btn-sm btn-success\" (click)=\"addItem(field)\">\r\n                                <i class=\"fa fa-plus-circle hand\" title=\"Add\"></i>\r\n                                {{field.display}}\r\n                            </button>\r\n                        </div>\r\n                    </p-accordionTab>\r\n                </p-accordion>\r\n            </div>\r\n        </ng-template>\r\n    </p-splitter>\r\n</div>\r\n\r\n",
                encapsulation: ViewEncapsulation.None,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwHtmlEditComponent),
                        multi: true
                    }],
                styles: [".ql-viewhtml{background-color:red}.ql-viewhtml:before{content:\"View\"}.ql-editor{background-color:#fff;color:#333}.ql-toolbar{background-color:#f4f4f4;border:1px solid #c8c8c8}.ql-tooltip{left:50px!important;top:15px!important;width:500px!important}.ql-tooltip input[type=text]{width:365px!important}.left-panel .ql-container{height:424px}.right-panel{height:500px;overflow:auto;padding:4px;width:100%}.right-panel .field-item{width:100%}"]
            }]
    }], null, { fieldSources: [{
            type: Input
        }], apiReady: [{
            type: Output
        }], options: [{
            type: Input
        }] }); })();
const ɵDwUrlReadOnlyControlComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwUrlReadOnlyControlComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUrlReadOnlyControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-url-readonly',
                template: `
        <a [hidden]="!translatedValue" class="read-only" href="{{translatedValue}}" target="_blank">{{translatedValue}}</a>
        <span [hidden]="translatedValue">{{missingDataText}}</span>
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwUrlReadOnlyControlComponent),
                        multi: true
                    }]
            }]
    }], null, { missingDataText: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLoadingComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-loading',
                template: `
    <span *ngIf="show" class="loading-panel">
        
       <!--  <i class="fa fa-cog fa-spin fa-fw"></i>
        <i class="fa fa-spinner fa-spin fa-fw"></i>
        <i class="fa fa-cog fa-pulse fa-fw"></i> -->
        <i class="fa fa-spinner fa-pulse fa-fw"></i>

        <span>{{text}}</span>
    </span>
  `,
                styles: [".loading-panel{font-size:2em}"]
            }]
    }], function () { return []; }, { show: [{
            type: Input
        }], text: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEvenColumnRowComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-even-column-row',
                template: "Even Row Col - Start<br>\r\n<div style=\"margin-left:200px\">\r\n    <div class=\"group-box-outer-container\">\r\n        <div class=\"group-box-container\"> <!-- added -->\r\n            <div class=\"group-box-sub-container\"> <!-- added -->\r\n                <div class=\"group-box-col1\">\r\n                    <div class=\"group-box-inner-container\">\r\n                        <ng-content select=\"[col1]\"></ng-content>\r\n                    </div>\r\n                </div>\r\n                <div class=\"group-box-col2\">\r\n        \r\n                    <div class=\"group-box-inner-container\">\r\n                        <ng-content select=\"[col2]\"></ng-content>\r\n                    </div>\r\n                </div>\r\n            </div> <!-- added -->\r\n        </div> <!-- added -->\r\n    </div>\r\n</div>\r\n<br>Even Row Col - End",
                styles: [".group-box-outer-container{overflow:auto}.group-box-container{float:left;width:100%}.group-box-sub-container{float:left;position:relative;right:50%;width:100%}.group-box-col1,.group-box-col2{float:left;left:50%;position:relative;width:50%}.group-box-inner-container{width:100%}"]
            }]
    }], function () { return []; }, { columns: [{
            type: Input
        }], column1Width: [{
            type: Input
        }], column2Width: [{
            type: Input
        }], column3Width: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSsoLoginComponent, [{
        type: Component,
        args: [{
                selector: 'dw-sso-login',
                template: `<div>
    
  </div>`
            }]
    }], function () { return [{ type: DwSecurityUserService }, { type: DwSecurityOrchestrationService }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicHostDirective, [{
        type: Directive,
        args: [{
                selector: '[dwDynamicHost]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dynamic-loader,[dwDynamicLoader]',
                template: `<ng-template dwDynamicHost></ng-template>`
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: DwUiConfigRegistryService }]; }, { configure: [{
            type: Output
        }], component: [{
            type: Input
        }], componentName: [{
            type: Input
        }], defaultComponentName: [{
            type: Input
        }], dynamicHost: [{
            type: ViewChild,
            args: [DwDynamicHostDirective, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityErrorPageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-security-error-page',
                template: "<h1>Security Error</h1>>\r\n\r\n<div>\r\n  You don't have access to this area!\r\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwNumericDirective, [{
        type: Directive,
        args: [{
                selector: 'input[dwNumeric]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc17.DomSanitizer }]; }, { isActive: [{
            type: Input,
            args: ['dwNumeric']
        }], invalidKeyStyle: [{
            type: Input
        }], onPaste: [{
            type: HostListener,
            args: ['paste', ['$event']]
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], elementStyle: [{
            type: HostBinding,
            args: ['style']
        }], decimals: [{
            type: Input
        }], allowNegative: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LazyLoadScriptService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCalcService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: LazyLoadScriptService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCalcComponent, [{
        type: Component,
        args: [{
                selector: 'dw-calc',
                template: `
    <div>
      <span class="read-only" [innerHtml]="displayValue"></span>  
      <span [hidden]="!errorMessage" class="error-text">
        Error 
        <i class="fa fa-info-circle" title="{{errorMessage}}"></i>
      </span>
    </div>
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwCalcComponent),
                        multi: true
                    }],
                styles: [`
    .error-text {
      color: red;
      font-weight: bold;
    }
  `]
            }]
    }], function () { return [{ type: ɵngcc3.ControlContainer }, { type: DwCalcService }, { type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, { nullDefaultValue: [{
            type: Input
        }], formula: [{
            type: Input
        }], options: [{
            type: Input
        }], formControlName: [{
            type: Input
        }], context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMessageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-message',
                template: `
  <div *ngIf="message" class="dw-alert alert" [ngClass]="alertClasses">
    <button type="button" class="close" aria-label="Close" *ngIf="message.allowClose" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 *ngIf="message.messageHeading">{{message.messageHeading}}</h4> 

    <dw-html-view [ngModel]="message.messageBody"></dw-html-view> 

    <a *ngIf="message.linkUrl" (click)="linkClick()"> <i [class]="message.linkIcon" *ngIf="message.linkIcon"></i> {{message.linkText}} </a>
  </div>
  `
            }]
    }], function () { return [{ type: DwRoutingService }]; }, { messageChange: [{
            type: Output
        }], message: [{
            type: Input
        }], classes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwBootstrapDateTimeInputComponent, [{
        type: Component,
        args: [{
                selector: 'dw-bootstrap-date-time-input',
                template: "<div class=\"input-group mr-2\">\r\n  <input [ngClass]=\"ngControl?.valid ? 'ng-valid' : 'ng-invalid'\" #popover=\"ngbPopover\" [ngbPopover]=\"popoverContent\" popoverClass=\"dw-date-time-picker\" (shown)=\"popoverShown()\" container=\"body\" placement=\"bottom-left\" class=\"form-control date-time-input-text\" (blur)=\"inputBlur($event)\" [ngModel]=\"dateString\" (ngModelChange)=\"onInputChange($event)\" [disabled]='disabled' />\r\n  \r\n  \r\n  <div class=\"input-group-append\">\r\n      <button class=\"btn date-time-icon\" [disabled]=\"disabled\" type=\"button\" *ngIf=\"!timeOnly\" (click)=\"popover.toggle()\" (focus)=\"onButtonFocus()\">\r\n          <i class=\"far fa-calendar\"></i>\r\n      </button>\r\n      <button class=\"btn date-time-icon\" [disabled]=\"disabled\" type=\"button\" *ngIf=\"timeOnly\" (click)=\"popover.toggle()\" (focus)=\"onButtonFocus()\">\r\n        <i class=\"far fa-clock\"></i>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"dw-red\" *ngIf=\"isInvalidDate\">Date is not valid.  Please enter a valid date</div>\r\n\r\n<ng-template #popoverContent>\r\n  <ng-container *ngIf=\"timeOnly then timeContent else calendarContent2\"></ng-container>\r\n</ng-template>\r\n \r\n<ng-template #calendarContent2>\r\n  <div>\r\n      <ngb-datepicker #dp name=\"datepicker\" [ngModel]=\"datetime\"  (dateSelect)=\"onDateSelection($event, popover)\" (select)=\"onDateSelection($event, popover)\" [markDisabled]=\"isDisabledFunc()\" [firstDayOfWeek]=\"firstDayOfWeek\" [displayMonths]=\"monthsToShow\" ></ngb-datepicker>\r\n      <ngb-timepicker *ngIf=\"showTime && datetime\" #tp name=\"timepicker\" [ngModel]=\"datetime\" (ngModelChange)=\"onTimeChange($event)\" [seconds]=\"dateOptions?.showSeconds\"\r\n      [hourStep]=\"dateOptions?.hourStep\" [minuteStep]=\"dateOptions?.minuteStep\" [secondStep]=\"dateOptions?.secondStep\" [meridian]=\"!use24HourTime\"></ngb-timepicker>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #timeContent>\r\n  <div>\r\n      <ngb-timepicker *ngIf=\"showTime\" #tp name=\"timepicker\" [ngModel]=\"datetime\" (ngModelChange)=\"onTimeChange($event)\" [seconds]=\"dateOptions?.showSeconds\"\r\n      [hourStep]=\"dateOptions?.hourStep\" [minuteStep]=\"dateOptions?.minuteStep\" [secondStep]=\"dateOptions?.secondStep\" [meridian]=\"!use24HourTime\"></ngb-timepicker>\r\n  </div>\r\n</ng-template>\r\n\r\n ",
                providers: [
                    DatePipe,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwBootstrapDateTimeInputComponent),
                        multi: true
                    }
                ],
                styles: [".date-time-icon{background-color:#007ad9;border:1px solid #007ad9;color:#fff;font-size:14px}.date-time-input-text{background:#fff;color:#333;font-size:14px}"]
            }]
    }], function () { return [{ type: ɵngcc20.NgbPopoverConfig }, { type: ɵngcc0.Injector }]; }, { inputDatetimeFormat: [{
            type: Input
        }], seconds: [{
            type: Input
        }], showTime: [{
            type: Input
        }], timeOnly: [{
            type: Input
        }], use24HourTime: [{
            type: Input
        }], log: [{
            type: Output
        }], disabled: [{
            type: Input
        }], dateOptions: [{
            type: Input
        }], dateString: [{
            type: Input
        }], dp: [{
            type: ViewChild,
            args: [NgbDatepicker, { static: false }]
        }], popover: [{
            type: ViewChild,
            args: [NgbPopover, { static: false }]
        }] }); })();
const ɵDwDateInputControl2Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwDateInputControl2Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateInputControl2Component, [{
        type: Component,
        args: [{
                selector: 'dw-date2',
                template: `
  <dw-bootstrap-date-time-input [ngModel]="translatedValue" (log)="logMessage($event)" [dateOptions]="dateOptions" [showTime]="showTime" [timeOnly]="timeOnly" [use24HourTime]="use24HourTime" (ngModelChange)="setTranslatedValue($event)" [inputDatetimeFormat]="dateFormat" ></dw-bootstrap-date-time-input>
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwDateInputControl2Component),
                        multi: true
                    }]
            }]
    }], null, { log: [{
            type: Output
        }] }); })();
const ɵDwInputReadOnlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwInputReadOnlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwInputReadOnlyComponent, [{
        type: Component,
        args: [{
                selector: 'dw-input-readonly',
                template: `<div class="read-only" [innerHtml]="translatedValue"></div>`,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwInputReadOnlyComponent),
                        multi: true
                    }]
            }]
    }], null, { missingDataText: [{
            type: Input
        }], class: [{
            type: Input
        }], numeric: [{
            type: Input
        }], allowDecimal: [{
            type: Input
        }], decimals: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiConfigListComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ui-config-list',
                template: "<div dwRow [ngClass]=\"listClass\">\r\n  <div dwCol=\"6\">\r\n      <p-orderList [value]=\"items\" [selection]=\"[selectedItem]\" (onSelectionChange)=\"onSelectItem($event)\" (onReorder)=\"onReorder()\"  dragdrop=\"true\" controlsPosition=\"right\">\r\n          <ng-template let-item pTemplate=\"item\">\r\n              <div class=\"order-item\">\r\n                  {{config?.displayField ? item[config.displayField] : item}}\r\n                  <i class=\"fa ml-1\" *ngIf=\"config.iconClassField && item[config.iconClassField]  && (!config.iconTooltipField || !item[config.iconTooltipField])\" [ngClass]=\"item[config.iconClassField]\"></i>\r\n                  <i class=\"fa ml-1\" *ngIf=\"config.iconClassField && item[config.iconClassField] && config.iconTooltipField && item[config.iconTooltipField]\" [ngClass]=\"item[config.iconClassField]\" [title]=\"item[config.iconTooltipField]\" ></i>\r\n\r\n                  <i class=\"fa fa-times hand pull-right\" (click)=\"onRemoveItem(item)\" [hidden]=\"!config?.allowRemoveItem\" title=\"Remove\"></i>\r\n              </div>\r\n          </ng-template>\r\n      </p-orderList>\r\n      <div dwRow *ngIf=\"config?.showListActionBar\">\r\n          <div dwCol=\"12\">\r\n            <ng-content select=\"[actionBar]\"></ng-content>\r\n          </div>\r\n      </div>\r\n  </div> \r\n  <div dwCol=\"6\">\r\n      <p-tabView styleClass=\"dw-config-tabs\" [(activeIndex)]=\"selectedTabIndex\" >\r\n          <p-tabPanel [header]=\"config?.addItemsHeading || 'Add Items'\" styleClass=\"dw-field-list\">\r\n            <ng-content select=\"[addItemsTab]\"></ng-content>\r\n          </p-tabPanel>\r\n        \r\n          <p-tabPanel [header]=\"config?.configureItemHeading || 'Configure Item'\" *ngIf=\"selectedItem && config?.allowConfigureItem\">\r\n            <ng-content select=\"[configureItemTab]\"></ng-content>\r\n          </p-tabPanel>\r\n\r\n          <p-tabPanel [header]=\"config?.additionalTabHeading\" *ngIf=\"config?.showAdditionalTab\">\r\n            <ng-content select=\"[additionalTab]\"></ng-content>\r\n          </p-tabPanel> \r\n      </p-tabView>\r\n  </div>\r\n</div>"
            }]
    }], function () { return []; }, { selectedItemChange: [{
            type: Output
        }], reorder: [{
            type: Output
        }], removeItem: [{
            type: Output
        }], size: [{
            type: Input
        }], selectedItem: [{
            type: Input
        }], config: [{
            type: Input
        }], items: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwBrowserAutocomplete, [{
        type: Directive,
        args: [{
                selector: 'input[dwBrowserAutocomplete]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { autocompleteEnabled: [{
            type: Input,
            args: ['dwBrowserAutocomplete']
        }], autocompleteText: [{
            type: Input
        }], defaultAutocompleteText: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwStyleManagerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContainerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-container',
                template: `
  <div [ngClass]="styles.containerClass">
    
    <div id="header" [hidden]="!options.showTitle" [class]="styles.containerTitleClass" [ngClass]="{ 'dw-container-collapsable': options?.containerAllowCollapse  }" (click)="toggle()">
      <span class="mr-1" [ngClass]="expandCollapseLocationClass" [hidden]="!options?.containerAllowCollapse">
          <i [ngClass]="expandIconClass" title="Expand" [hidden]="!collapsed"></i>
          <i [ngClass]="collapseIconClass" title="Collapse" [hidden]="collapsed"></i>
      </span>

      <i id="headerIcon" class="{{styles.iconClass}} mr-2" [hidden]="!options.containerHeaderIcon"></i>

      <ng-content select="[header]"></ng-content>

    </div>

    <div id="inner" [class]="styles.containerInnerClass" [dwExpandable]="options?.containerAllowCollapse" [collapsed]="collapsed">
      <div [class]="styles.containerInnerPaddingClass">
        <ng-content select="[body]"></ng-content>
      </div>
    </div>
  
  </div>
    
  `,
                encapsulation: ViewEncapsulation.None
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwStyleManagerService }]; }, { collapsed: [{
            type: Input
        }], collapsedChange: [{
            type: Output
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuLinkComponent, [{
        type: Component,
        args: [{
                selector: 'dw-menu-link',
                template: `
 	<ng-container *ngIf="!menu?.data?.menuComponent">
		<a [routerLink]="menu.url" routerLinkActive="active" (click)="hideMobile()"
		[routerLinkActiveOptions]="{ exact: menu?.data?.highlightOnExactMatch }" [ngClass]="className" [hidden]="menu?.data?.isAction">
			<i class="nav-icon {{additionalIconClass}} {{ menu!.data!.iconCssClass }}" [hidden]="hideIcon"></i>
			<span class="dw-menu-display">{{menu.display}}</span>
		</a>
		<a [ngClass]="className" class="hand" [hidden]="!menu?.data?.isAction" (click)="doAction(menu, $event)">
			<i class="{{additionalIconClass}} {{ menu!.data!.iconCssClass }}" [hidden]="hideIcon"></i>
			<span class="dw-menu-display">{{menu.display}}</span>
		</a>
	</ng-container>
	<ng-container *ngIf="menu?.data?.menuComponent">
		<dw-dynamic-loader [component]="menu.data.menuComponent" (configure)="configureMenuComponent($event)"></dw-dynamic-loader>
	</ng-container>
  `
            }]
    }], function () { return [{ type: DwActionExecutionService }, { type: ɵngcc2.Router }, { type: ɵngcc2.ActivatedRoute }, { type: DwMenuBuilderService }]; }, { className: [{
            type: Input
        }], additionalIconClass: [{
            type: Input
        }], hideIcon: [{
            type: Input
        }], menu: [{
            type: Input
        }], menuLocation: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateRangeInputComponent, [{
        type: Component,
        args: [{
                selector: 'dw-date-range-input',
                template: "<div class=\"input-group mr-2\">\r\n  <input #popover=\"ngbPopover\" [ngbPopover]=\"popoverContent\" popoverClass=\"dw-date-time-picker\" (shown)=\"popoverShown()\" container=\"body\" placement=\"bottom-left\" class=\"form-control date-time-input-text\" [ngModel]=\"dateRangeDisplay\" (ngModelChange)=\"onInputChange($event)\" [disabled]='false' dwBrowserAutocomplete=\"false\"/>\r\n\r\n  <div class=\"input-group-append\">\r\n      <button class=\"btn date-time-icon\" [disabled]='disabled' type=\"button\" (click)=\"popover.toggle()\">\r\n          <i class=\"far fa-calendar\"></i>\r\n      </button>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #popoverContent>\r\n  <div class=\"date-range-picker\">\r\n    <ngb-datepicker [ngModel]=\"startDateTime\"  #dp (dateSelect)=\"onDateSelection($event)\" (select)=\"onDateSelection($event)\" [displayMonths]=\"2\" [dayTemplate]=\"dayTemplate\" outsideDays=\"hidden\" [firstDayOfWeek]=\"firstDayOfWeek\">\r\n    </ngb-datepicker>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #dayTemplate let-date let-focused=\"focused\">\r\n  <span class=\"custom-day\"\r\n        [class.focused]=\"focused\"\r\n        [class.range]=\"isRange(date)\"\r\n        [class.faded]=\"isHovered(date) || isInside(date)\"\r\n        (mouseenter)=\"hoveredDate = date\"\r\n        (mouseleave)=\"hoveredDate = null\">\r\n    {{ date.day }}\r\n  </span>\r\n</ng-template>",
                styles: [".custom-day{display:inline-block;height:2rem;padding:.185rem .25rem;text-align:center;width:2rem}.custom-day.focused{background-color:#e6e6e6}.custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.custom-day.faded{background-color:rgba(2,117,216,.5)}.date-time-icon{background-color:#007ad9;border:1px solid #007ad9;color:#fff;font-size:14px}.date-time-input-text{background:#fff;color:#333;font-size:14px}"]
            }]
    }], function () { return [{ type: ɵngcc20.NgbPopoverConfig }, { type: ɵngcc0.ChangeDetectorRef }]; }, { startDateChange: [{
            type: Output
        }], endDateChange: [{
            type: Output
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], disabled: [{
            type: Input
        }], datePickerControl: [{
            type: ViewChild,
            args: [NgbDatepicker, { static: false }]
        }], popover: [{
            type: ViewChild,
            args: [NgbPopover, { static: true }]
        }] }); })();
const ɵDwSecurityUserMenuComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwSecurityUserMenuComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityUserMenuComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-user-menu',
                template: `
   <ng-container *ngFor="let menu of routeHierarchy">
   
       <dw-menu-link [menu]="menu" className="dropdown-item  hand" [menuLocation]="'user'"></dw-menu-link>
       
		</ng-container>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionConfigService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionMenuBuilderService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMenuHelperService }, { type: DwSecurityUserService }, { type: DwUiConfigRegistryService }, { type: DwActionExecutionService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionGroupConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-group-config',
                template: "<div class=\"action-container\">\r\n  <dw-action-bar [hidden]=\"!showButtonConfig\" [actionPreferences]=\"displayActionPreferences\"\r\n    [buttonContainerStyleKey]=\"buttonContainerStyleKey\" convertPreferences=\"false\"></dw-action-bar>\r\n\r\n  <button #sampleMenu [hidden]=\"!showMenuConfig\" (click)=\"contextMenu.show()\">Sample Context Menu</button>\r\n\r\n  <div *ngIf=\"showButtonConfig && displayActionPreferences.length == 0\">\r\n    No buttons to preview\r\n  </div>\r\n\r\n  <p-contextMenu #contextMenu [target]=\"sampleMenu\" [model]=\"testMenus\" appendTo=\"body\" baseZIndex=\"10000\">\r\n  </p-contextMenu>\r\n</div>\r\n\r\n<dw-ui-config-list [items]=\"actionPreferences\" [config]=\"listConfig\" [selectedItem]=\"selectedItem\"\r\n   [size]=\"size\" (selectedItemChange)=\"setSelectedItem($event)\" (reorder)=\"reorderList()\"\r\n  (removeItem)=\"removeItem($event)\">\r\n\r\n  <div addItemsTab>\r\n    <div *ngFor=\"let action of availableActions\" class=\"dw-field-item\">\r\n      <button class=\"btn btn-sm btn-success\" (click)=\"addItem(action)\">\r\n        <i class=\"fa fa-plus-circle hand\" title=\"Add Action\"></i>\r\n        {{action.display}}\r\n      </button>\r\n    </div>\r\n  </div>\r\n\r\n  <div actionBar>\r\n    <button class=\"btn-sm btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n  </div>\r\n\r\n  <div configureItemTab>\r\n    <dw-action-config [(actionPreference)]=\"selectedItem\" (actionPreferenceChange)=\"onChange($event)\"\r\n      [actionConfigPreferences]=\"actionConfigPreferences\"\r\n      [actions]=\"actions\" [showButtonConfig]=\"showButtonConfig\" [showMenuConfig]=\"showMenuConfig\"\r\n      [configContext]=\"configContext\" [showEnableVisibleConfig]=\"showEnableVisibleConfig\" *ngIf=\"selectedItem\">\r\n    </dw-action-config>\r\n  </div>\r\n\r\n</dw-ui-config-list>",
                styles: [".action-container{margin:4px;min-height:51px;overflow:auto}"]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwActionConfigService }, { type: DwActionMenuBuilderService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { actionPreferences: [{
            type: Input
        }], actionPreferencesChange: [{
            type: Output
        }], showButtonConfig: [{
            type: Input
        }], showMenuConfig: [{
            type: Input
        }], showEnableVisibleConfig: [{
            type: Input
        }], size: [{
            type: Input
        }], configContext: [{
            type: Input
        }], actionConfigPreferences: [{
            type: Input
        }], actionTypes: [{
            type: Input
        }], buttonContainerStyleKey: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwChildConfigBaseComponent, [{
        type: Directive
    }], function () { return []; }, { configChange: [{
            type: Output
        }], isValidChange: [{
            type: Output
        }], config: [{
            type: Input
        }], isValid: [{
            type: Input
        }], configContext: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-config',
                template: "<div [formGroup]=\"formGroup\">\r\n  <p-accordion [multiple]=\"true\">\r\n    <p-accordionTab [header]=\"basicSettingsDisplay\" [selected]=\"selectFirstTab\">\r\n      <div dwRow *ngIf=\"showActionDisplay\">\r\n        <div dwCol=\"12\">\r\n          <label>Action Display</label>\r\n          <input formControlName=\"actionDisplay\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Action</label>\r\n          <select formControlName=\"actionKey\" class=\"form-control\">\r\n            <option *ngFor=\"let action of actions\" [ngValue]=\"action.keyName\">\r\n              {{ action.display }}\r\n            </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n      <div dwRow *ngIf=\"actionConfigPreferences?.additionalConfigComponent\">\r\n        <div dwCol=\"12\">\r\n          <dw-dynamic-loader [component]=\"actionConfigPreferences?.additionalConfigComponent\"\r\n            (configure)=\"configureModeActionConfigComponent($event)\"></dw-dynamic-loader>\r\n        </div>\r\n      </div>\r\n      <div dwRow *ngIf=\"currentActionItem?.configComponent\">\r\n        <div dwCol=\"12\">\r\n          <dw-dynamic-loader [component]=\"currentActionItem?.configComponent\"\r\n            (configure)=\"configureActionConfigComponent($event)\"></dw-dynamic-loader>\r\n        </div>\r\n      </div>\r\n    </p-accordionTab>\r\n    <!-- <p-accordionTab header=\"Action Configuration\" *ngIf=\"currentActionItem?.configComponent\">\r\n    </p-accordionTab> -->\r\n    <p-accordionTab header=\"Action Security\" *ngIf=\"showSecurityConfig\">\r\n      <dw-security-check-config [config]=\"securityConfigFC.value\" (configChange)=\"securityConfigChange($event)\"\r\n        [configContext]=\"configContext\"></dw-security-check-config>\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Button Configuration\" *ngIf=\"showButtonConfig\">\r\n      <dw-button-config [config]=\"buttonConfigFC.value\" (configChange)=\"buttonConfigChange($event)\"\r\n        [configContext]=\"configContext\">\r\n      </dw-button-config>\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Context Menu Configuration\" *ngIf=\"showMenuConfig\">\r\n      <dw-context-menu-config [config]=\"menuConfigFC.value\" (configChange)=\"menuConfigChange($event)\"\r\n        [configContext]=\"configContext\">\r\n      </dw-context-menu-config>\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Visible/Enabled Configuration\" *ngIf=\"true || showEnableVisibleConfig && expressionVisibilityConfigComponent\">\r\n      <dw-ui-child-config-host [component]=\"expressionVisibilityConfigComponent\"\r\n        [(config)]=\"enableVisibleConfigFC.value\" (configChange)=\"enableVisibleConfigChange($event)\"\r\n        [configContext]=\"configContext\">\r\n      </dw-ui-child-config-host>\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Confirm Dialog Configuration\"\r\n      *ngIf=\"currentActionItem?.defaultConfirmConfig?.showDialogConfig\">\r\n      <dw-confirm-dialog-config [config]=\"confirmConfigFC.value\" (configChange)=\"confirmConfigChange($event)\"\r\n        [configContext]=\"configContext\">\r\n      </dw-confirm-dialog-config>\r\n    </p-accordionTab>\r\n  </p-accordion> \r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, { actionPreferenceChange: [{
            type: Output
        }], actions: [{
            type: Input
        }], basicSettingsDisplay: [{
            type: Input
        }], showActionDisplay: [{
            type: Input
        }], showEnableVisibleConfig: [{
            type: Input
        }], showSecurityConfig: [{
            type: Input
        }], selectFirstTab: [{
            type: Input
        }], configContext: [{
            type: Input
        }], actionPreference: [{
            type: Input
        }], actionConfigPreferences: [{
            type: Input
        }], showButtonConfig: [{
            type: Input
        }], showMenuConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwButtonBarComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-button-bar',
                template: "<div class=\"dw-button-bar-container\">\r\n    <div class=\"pull-left\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n    <div class=\"pull-right\">\r\n        <ng-content select=\"[right]\"></ng-content>\r\n    </div>\r\n</div>",
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }]
    }], null, null); })();
const ɵDwButtonConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwButtonConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwButtonConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-button-config',
                template: "<ng-container *ngIf=\"config\">\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Use Defaults</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch [(ngModel)]=\"config.useButtonDefaults\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n\r\n  <ng-container *ngIf=\"!config.useButtonDefaults\">\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Use Parent Display</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.useParentDisplay\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"!config.useParentDisplay\">\r\n      <div dwCol=\"12\">\r\n        <label>Button Text</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.buttonText\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Button Tooltip</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.buttonTitle\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Button Type</label>\r\n        <select [(ngModel)]=\"config.buttonType\" (ngModelChange)=\"onChange()\" [ngModelOptions]=\"{standalone: true}\"\r\n          class=\"form-control\">\r\n          <option value=\"standard\">Standard</option>\r\n          <option value=\"iconOnly\">Icon</option>\r\n          <option value=\"iconOnlyNoText\">Icon Only (No Text)</option>\r\n          <option value=\"link\">Link</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label title=\"Displays when the action is executing\">Action Message</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.actionMessage\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"showCommand\">\r\n      <div dwCol=\"12\">\r\n        <label>Button Command</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.commandName\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\" [disabled]=\"config.formAction !== 'custom'\">\r\n      </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Button Class</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.buttonClass\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Icon Class</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.iconClass\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Show Icon After Text</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.showIconAfterText\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Include in Button Group <i class=\"fa fa-info-circle\"\r\n            title=\"Includes in a button group (requires a button group action before this action)\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.includeInGroup\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Show Divider before <i class=\"fa fa-info-circle\"\r\n            title=\"Adds a divider before this action in the button group drop down\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.showDividerBefore\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n\r\n  </ng-container>\r\n\r\n</ng-container>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionBarComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-bar',
                template: `
  <ng-container *ngIf="useContainerStyle && finalActionPreferences?.length > 0">
    <div [ngClass]="buttonContainerStyle?.containerClass">
      <div [ngClass]="buttonContainerStyle?.containerInnerClass">
         <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
      </div>
    </div>
  </ng-container>    

  <ng-container *ngIf="!useContainerStyle">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </ng-container>

  <!-- Template to reuse the button rendering logic in both places above -->
  <ng-template #actionButtons>
    <ng-container *ngFor="let actionPref of finalActionPreferences; index as index; trackBy trackByMethod">
      <ng-container [ngSwitch]="actionRegistrations[index]?.decoratorType">
        <!-- Custom component -->
        <ng-container *ngIf="!actionPref.buttonConfig.hidden">
           <dw-dynamic-loader *ngSwitchCase="'component'" [component]="actionRegistrations[index]?.actionComponent" (configure)="configureComponent($event, actionPref)"></dw-dynamic-loader>
        </ng-container>
        <!-- Standard button -->

        <dw-button *ngSwitchDefault [buttonConfig]="actionPref.buttonConfig" [firing]="index==firingActionIndex" [hidden]="actionPref.buttonConfig?.includeInGroup" (click)="click(actionPref, false, $event)" (auxClick)="auxClick(actionPref, $event)" (middleclick)="click(actionPref, true, $event)"></dw-button>
      </ng-container>
    </ng-container>
    <ng-content></ng-content>
  </ng-template>
`
            }]
    }], function () { return [{ type: DwActionConfigService }, { type: DwUiConfigRegistryService }]; }, { actionClick: [{
            type: Output
        }], useContainerStyle: [{
            type: Input
        }], convertPreferences: [{
            type: Input
        }], actionPreferences: [{
            type: Input
        }], firingActionPreference: [{
            type: Input
        }], actionContext: [{
            type: Input
        }], buttonContainerStyleKey: [{
            type: Input
        }] }); })();
const ɵDwContextMenuConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwContextMenuConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContextMenuConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-context-menu-config',
                template: "<ng-container *ngIf=\"config\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label>Menu Group</label>\r\n      <input type=\"text\" [(ngModel)]=\"config.menuGroupDisplay\" (ngModelChange)=\"onChange()\"\r\n      [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Use Defaults</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch [(ngModel)]=\"config.useMenuDefaults\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"!config.useMenuDefaults\">\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Use Parent Display</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.useParentDisplay\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"!config.useParentDisplay\">\r\n      <div dwCol=\"12\">\r\n        <label>Button Text</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.menuDisplay\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Menu Icon</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.menuIconClass\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Item Requirement</label>\r\n        <select [(ngModel)]=\"config.itemRequirement\" (ngModelChange)=\"onChange()\" class=\"form-control\">\r\n          <option value=\"none\">None</option>\r\n          <option value=\"single\">Single</option>\r\n          <option value=\"multiple\">Multiple</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-container>"
            }]
    }], null, null); })();
const ɵDwSecurityCheckConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwSecurityCheckConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityCheckConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-check-config',
                template: "<ng-container *ngIf=\"config\">\r\n  <div dwRow [hidden]=\"hideSecurityDefault\">\r\n    <div dwCol=\"9\">\r\n      <label>Use Security Default</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch [(ngModel)]=\"config.useSecurityDefaults\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"!config.useSecurityDefaults || hideSecurityDefault\">\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Require Authentication</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.requireAuthentication\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.requireAuthentication\">\r\n      <div dwCol=\"12\">\r\n        <label>Permission</label>\r\n        <dw-security-permission-select name=\"permission\" [(ngModel)]=\"config.permissionMeaning\"\r\n          (ngModelChange)=\"onChange()\">\r\n        </dw-security-permission-select>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.requireAuthentication\">\r\n      <div dwCol=\"9\">\r\n        <label>Use Emulated Permissions</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.useEmulatedPermissions\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <ng-container *ngIf=\"configContext.itemName\">\r\n      <hr>\r\n      <b>Item Security</b>\r\n\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Require Can Create</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch [(ngModel)]=\"config.requireCanCreate\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Require Can Update</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch [(ngModel)]=\"config.requireCanUpdate\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Require Can Delete</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch [(ngModel)]=\"config.requireCanDelete\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n\r\n    </ng-container>\r\n  </ng-container>\r\n</ng-container>"
            }]
    }], null, { hideSecurityDefault: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityPermissionSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-permission-select',
                template: `
    <div class="mb-3">
      <p-dropdown  [id]="id" [options]="permissionGroups" [group]="true" [showClear]="true" [(ngModel)]="value" (ngModelChange)="setValue($event)" [style]="{'width':'100%'}" [filter]="showFilter" appendTo="body" [placeholder]="showBlank ? blankOptionText : ''"></p-dropdown>
    </div>
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwSecurityPermissionSelectComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }]; }, { showBlank: [{
            type: Input
        }], blankOptionText: [{
            type: Input
        }], usePermissionMeaning: [{
            type: Input
        }], showFilter: [{
            type: Input
        }] }); })();
const ɵDwConfirmDialogConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwConfirmDialogConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwConfirmDialogConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-confirm-dialog-config',
                template: "<ng-container *ngIf=\"config\">\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Use Defaults</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch [(ngModel)]=\"config.useConfirmDefaults\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"!config.useConfirmDefaults\">\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Show Confirm Dialog</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.showConfirmDialog\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.showConfirmDialog\">\r\n      <div dwCol=\"12\">\r\n        <label>Title</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.title\" (ngModelChange)=\"onChange()\" [ngModelOptions]=\"{standalone: true}\"\r\n          class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.showConfirmDialog\">\r\n      <div dwCol=\"12\">\r\n        <label>Message</label>\r\n        <input type=\"text\" [(ngModel)]=\"config.message\" (ngModelChange)=\"onChange()\"\r\n          [ngModelOptions]=\"{standalone: true}\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n</ng-container> "
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTreeSelect, [{
        type: Component,
        args: [{
                selector: 'dw-tree-select',
                template: "<div>\r\n    <div class=\"drop-down-tree-field\">\r\n        <input #inputElement type=\"text\" (click)=\"click($event)\" class=\"form-control hand\" value={{selection?.label}} readonly>\r\n        <span class=\"pi pi-fw pi-caret-down drop-down-icon hand ui-dropdown-trigger\" (click)=\"click($event)\"></span> \r\n    </div>\r\n    <div class=\"dropdown-section\" [ngClass]=\"{'hide': visible == false}\" [attr.id]=\"id\" (clickOutside)=\"outsideClick()\">\r\n        <p-tree [value]=\"treeData\" selectionMode=\"single\" [(selection)]=\"selection\" (onNodeSelect)=\"nodeSelect($event)\"\r\n            [styleClass]=\"'custom-ui-tree'\"> </p-tree>\r\n    </div>\r\n</div> ",
                encapsulation: ViewEncapsulation.None,
                styles: ["@charset \"UTF-8\";.drop-down-tree-field{position:relative}.drop-down-tree-field .form-control:disabled,.drop-down-tree-field .form-control[readonly],.dropdown-section{background-color:#fff}.dropdown-section{background-clip:padding-box;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;min-width:10rem;overflow-x:none;overflow-y:auto;padding:0;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section .ui-treenode-content-selected{background-color:#007ad9;border:1px;color:#fff}.hide{display:none}.drop-down-icon{color:#848484;position:absolute;right:3px;text-align:center;top:20%;width:2.357em}.custom-ui-tree{height:100%;width:100%!important}.custom-ui-tree,.custom-ui-tree .ui-tree-container{padding:0!important}.pi-caret-down:before{content:\"\uE902\"!important}"]
            }]
    }], function () { return []; }, { dropDownHeight: [{
            type: Input
        }], selectionChange: [{
            type: Output
        }], selection: [{
            type: Input
        }], reset: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], targetElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }], treeData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwClickOutsideDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[clickOutside]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc2.Router }]; }, { clickOutside: [{
            type: Output
        }], includeKeys: [{
            type: Input
        }], includeNavigationevents: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['document:click', ['$event.target']]
        }], keydown: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiChildConfigHostComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ui-child-config-host',
                template: `
    <dw-dynamic-loader [component]="component" (configure)="setComponentInstance($event)"></dw-dynamic-loader>
  `
            }]
    }], function () { return []; }, { configChange: [{
            type: Output
        }], isValidChange: [{
            type: Output
        }], config: [{
            type: Input
        }], isValid: [{
            type: Input
        }], configContext: [{
            type: Input
        }], component: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionGroupModesConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-group-modes-config',
                template: "<div *ngIf=\"actionModes\">\r\n\r\n  <div dwRow *ngIf=\"actionModes?.length>1\">\r\n    <div dwCol=\"12\">\r\n      <dw-pills [items]=\"actionModes\" [(ngModel)]=\"currentModeValue\" valueField=\"modeValue\" displayField=\"modeDisplay\"\r\n    (ngModelChange)=\"setupMode()\"></dw-pills>\r\n    </div>\r\n  </div>\r\n\r\n  <dw-action-group-config *ngIf=\"currentMode\" [(actionPreferences)]=\"modeActions\" (actionPreferencesChange)=\"onChange()\" \r\n    [actionConfigPreferences]=\"actionConfigPreferences\"\r\n    [size]=\"size\"\r\n    [actionTypes]=\"currentMode.actionTypes\" [showButtonConfig]=\"currentMode.showButtonConfig\" [buttonContainerStyleKey]=\"currentMode.buttonContainerStyleKey\" [showMenuConfig]=\"currentMode.showMenuConfig\"\r\n    [configContext]=\"configContext\">\r\n  </dw-action-group-config>\r\n</div>"
            }]
    }], function () { return []; }, { actionPreferenceByModeChange: [{
            type: Output
        }], modeChange: [{
            type: Output
        }], actionPreferencesByMode: [{
            type: Input
        }], actionConfigPreferencesByMode: [{
            type: Input
        }], configContext: [{
            type: Input
        }], actionModes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRadioListComponent, [{
        type: Component,
        args: [{
                selector: 'dw-radio-list',
                template: "<div id=\"radio-list-control\">\r\n    <span *ngFor=\"let item of values\" id=\"radio-item\">\r\n        <label class=\"radio-container\">\r\n            <input type=\"radio\"\r\n                   [name]=\"groupName\"\r\n                   [value]=\"item.value\"\r\n                   [disabled]=\"disabled\"\r\n                   [ngModel]=\"translatedValue\"\r\n                   (ngModelChange)=\"setTranslatedValue($event)\"\r\n                   (change)=\"onChange($event)\"\r\n                   (keyup)=\"onKeyup($event)\"\r\n                   (blur)=\"onBlur($event)\"\r\n                   />\r\n            <span class=\"radio-item\">{{item.display}}</span>\r\n        </label>\r\n    </span>\r\n</div>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwRadioListComponent),
                        multi: true
                    }],
                styles: [".radio-container{margin:5px}.radio-item{margin-left:5px;margin-top:-6px}"]
            }]
    }], function () { return []; }, { groupName: [{
            type: Input
        }], values: [{
            type: Input
        }] }); })();
const ɵDwCountValidatorConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwCountValidatorConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCountValidatorConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-count-validator-config',
                template: `
  <div dwRow>
    <div dwCol="12">
        <label>Min Count</label>
        <input dwNumeric [(ngModel)]="config.minCount" (ngModelChange)="onChange()" class="form-control">
    </div>
  </div>
  <div dwRow>
  <div dwCol="12">
      <label>Max Count</label>
      <input dwNumeric [(ngModel)]="config.maxCount" (ngModelChange)="onChange()" class="form-control">
  </div>
</div>
  `
            }]
    }], null, null); })();
const ɵDwCountValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwCountValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCountValidationRule, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailValidationRule, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, null); })();
const ɵDwMinValidationConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMinValidationConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMinValidationConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-min-validator-config',
                template: `
  <div dwRow>
    <div dwCol="12">
        <label>Min Value</label>
        <input dwNumeric [(ngModel)]="config.min" (ngModelChange)="onChange()" class="form-control">
    </div>
  </div>
  `
            }]
    }], null, null); })();
const ɵDwMinValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMinValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMinValidationRule, [{
        type: Injectable
    }], null, null); })();
const ɵDwMaxValidatorConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMaxValidatorConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMaxValidatorConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-max-validator-config',
                template: `
  <div dwRow>
    <div dwCol="12">
        <label>Max Value</label>
        <input dwNumeric [(ngModel)]="config.max" (ngModelChange)="onChange()" class="form-control">
    </div>
  </div>
  `
            }]
    }], null, null); })();
const ɵDwMaxValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMaxValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMaxValidationRule, [{
        type: Injectable
    }], null, null); })();
const ɵDwMaxLengthValidatorConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMaxLengthValidatorConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMaxLengthValidatorConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-max-length-validator-config',
                template: `
  <div dwRow>
    <div dwCol="12">
        <label>Max Length</label>
        <input dwNumeric [(ngModel)]="config.maxLength" (ngModelChange)="onChange()" class="form-control">
    </div>
  </div>
  `
            }]
    }], null, null); })();
const ɵDwMaxLengthValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMaxLengthValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMaxLengthValidationRule, [{
        type: Injectable
    }], null, null); })();
const ɵDwPatternValidatorConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwPatternValidatorConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPatternValidatorConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-pattern-validator-config',
                template: `
  <div dwRow>
    <div dwCol="12">
        <label>RegEx Pattern</label>
        <input [(ngModel)]="config.pattern" (ngModelChange)="onChange()" class="form-control">
    </div>
  </div>
  `
            }]
    }], null, null); })();
const ɵDwPatternValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwPatternValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPatternValidationRule, [{
        type: Injectable
    }], null, null); })();
const ɵDwRequiredValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwRequiredValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRequiredValidationRule, [{
        type: Injectable
    }], null, null); })();
const ɵDwUrlValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwUrlValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUrlValidationRule, [{
        type: Injectable
    }], null, null); })();
const ɵDwRequiredTrueValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwRequiredTrueValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRequiredTrueValidationRule, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwValidationConfigBaseComponent, [{
        type: Component,
        args: [{
                selector: 'dw-validation-config-base',
                template: "<div><b>{{validationRuleRegistration?.display || 'Validation Rule Not Found' }}</b></div>\r\n\r\n<ng-container *ngIf=\"config && validationRuleRegistration\">\r\n    <div dwRow *ngIf=\"validationRuleRegistration.showAfterSubmittedOptions\">\r\n        <div dwCol=\"9\">\r\n            <label>Show after submission <i class=\"fa fa-info-circle\"\r\n                    title=\"Message will be hidden and only display after they click save (or next)\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [(ngModel)]=\"config.showAfterSubmitted\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"!validationRuleRegistration.requireMessage\">\r\n        <div dwCol=\"9\" >\r\n            <label>Override Message</label>\r\n        </div> \r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [(ngModel)]=\"config.overrideMessage\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.overrideMessage || validationRuleRegistration.requireMessage\">\r\n        <div dwCol=\"12\">\r\n            <label>Message</label>\r\n            <textarea [(ngModel)]=\"config.message\" (ngModelChange)=\"onChange()\" class=\"form-control\"\r\n                rows=\"1\"></textarea>\r\n\r\n            <div *ngFor=\"let tag of validationRuleRegistration?.tags\">\r\n                <button class=\"btn btn-sm btn-success float-left mr-2\" (click)=\"addTag(tag)\">\r\n                    <i class=\"fa fa-plus-circle hand \" title=\"Add Field\"></i>\r\n                    {{tag.display}}\r\n                </button>\r\n            </div>\r\n        </div>\r\n        <!-- <div dwCol=\"12\">\r\n            <label>Message Class <i class=\"fa fa-info-circle\" title=\"Css Class to style the error message\"></i></label>\r\n            <input type=\"text\" [(ngModel)]=\"config.messageClass\" (ngModelChange)=\"onChange()\"\r\n                class=\"form-control\">\r\n        </div> -->\r\n    </div>\r\n    <ng-container *ngIf=\"validationRuleRegistration?.configComponent\">\r\n        <dw-ui-child-config-host [component]=\"validationRuleRegistration.configComponent\" [(config)]=\"config\"\r\n            [configContext]=\"configContext\" (configChange)=\"onChange()\"></dw-ui-child-config-host>\r\n    </ng-container>\r\n</ng-container>"
            }]
    }], function () { return [{ type: DwValidationService }]; }, { validatorKey: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserPasswordResetComponent, [{
        type: Component,
        args: [{
                selector: 'dw-user-password-reset',
                template: "<!-- fake fields are a workaround for chrome autofill getting the wrong fields -->\r\n<input style=\"display: none\" type=\"text\" name=\"fakeusernameremembered\" />\r\n<input style=\"display: none\" type=\"password\" name=\"fakepasswordremembered\" />\r\n\r\n<form name=\"loginForm\" autocomplete=\"off\">\r\n\r\n    <ng-container *ngIf=\"!showReset\">\r\n        <ng-container *ngTemplateOutlet=\"forgotPassword\">\r\n        </ng-container>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"showReset\">\r\n        <ng-container *ngTemplateOutlet=\"resetPassword\">\r\n        </ng-container>\r\n    </ng-container>\r\n</form>\r\n\r\n\r\n<ng-template #forgotPassword>\r\n    <div class=\"card-header\">Forgot Password</div>\r\n    <div class=\"card-body\">\r\n        <dw-message [message]=\"message\"></dw-message>\r\n        <div class=\"body-left\">\r\n            <div class=\"body-left-content\">\r\n                <div class=\"dw-logo-login\">\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"body-right\">\r\n            <div class=\"body-right-content\">\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"login-image\">\r\n                        <i class=\"fa fa-user-circle login-icon\"></i>\r\n                        <!-- <img src=\"/assets/img/user-loging.png\" /> -->\r\n                    </div>\r\n                    <div class=\"login-input\">\r\n                        <label class=\"label\">Username/E-mail</label>\r\n                        <input type=\"text\" id=\"tbUserName\" name=\"tbUserName\" class=\"form-control\" [(ngModel)]=\"userName\"\r\n                            placeholder=\"username/e-mail\" required>\r\n\r\n                        <a (click)=\"showResetPassword()\" class=\"hand\">I already have a code</a>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <button type=\"button\" (click)=\"sendResetEmail()\" class=\"form-control btn btn-primary\"  [disabled]=\"processing\">Send Recovery\r\n                            E-mail <i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n                        </button>\r\n                        <button type=\"button\" (click)=\"cancel()\" class=\"form-control btn btn-danger\">Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n\r\n<ng-template #resetPassword>\r\n    <div class=\"card-header\">Reset your Password</div>\r\n    <div class=\"card-body\">\r\n        <dw-message [message]=\"message\"></dw-message>\r\n        <div class=\"body-left\">\r\n            <div class=\"body-left-content\">\r\n                <div class=\"dw-logo-login\">\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"body-right\">\r\n            <div class=\"body-right-content\">\r\n                <div class=\"row\">\r\n                    <div class=\"login-image\">\r\n                        <i class=\"fa fa-barcode-alt login-icon\"></i>\r\n                    </div>\r\n                    <div class=\"login-input\">\r\n                        <label class=\"label\">Reset Code</label>\r\n                        <input type=\"text\" id=\"tbResetCode\" name=\"tbResetCode\" class=\"form-control\"\r\n                            [(ngModel)]=\"resetCode\" placeholder=\"reset code\" autocomplete=\"new-password\" required>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"login-image\">\r\n                        <!-- <img src=\"/assets/img/user-loging.png\" /> -->\r\n                        <i class=\"fa fa-user-circle login-icon\"></i>\r\n                    </div>\r\n                    <div class=\"login-input\">\r\n                        <label class=\"label\">Username/E-mail</label>\r\n                        <input type=\"text\" id=\"tbUserName\" name=\"tbUserName\" class=\"form-control\" [(ngModel)]=\"userName\"\r\n                            placeholder=\"username/e-mail\" autocomplete=\"chrome-off\" required>\r\n                    </div>\r\n                </div>\r\n                <dw-password [(password)]=\"newPassword\" [(isPasswordValid)]=\"isPasswordValid\"></dw-password>\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <button type=\"button\" (click)=\"resetPassword2()\" class=\"form-control btn btn-primary\" [disabled]=\"processing\">Reset Password <i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n                        <button type=\"button\" (click)=\"cancel()\" class=\"form-control btn btn-danger\" >Cancel</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: ɵngcc2.Router }, { type: DwSecurityUserService }, { type: DwSecurityTwoFactorRepositoryService }, { type: DwAppInitService }]; }, { userNameChange: [{
            type: Output
        }], complete: [{
            type: Output
        }], cancelled: [{
            type: Output
        }], messageChange: [{
            type: Output
        }], userName: [{
            type: Input
        }], message: [{
            type: Input
        }] }); })();
const ɵDwUserChangePasswordComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwUserChangePasswordComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserChangePasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dw-user-change-password',
                template: "<!-- <dw-message [message]=\"message\"></dw-message> -->\r\n\r\n\r\n<div class=\"login\">\r\n\r\n\r\n    <div class=\"card\">\r\n        <ng-container *ngTemplateOutlet=\"changePassword\">\r\n        </ng-container>\r\n    </div>\r\n</div>\r\n\r\n<ng-template #changePassword>\r\n    <div class=\"card-header\">Change your Password</div>\r\n    <div class=\"card-body\">\r\n        <dw-message [message]=\"message\"></dw-message>\r\n        <div class=\"body-left\">\r\n            <div class=\"body-left-content\">\r\n                <div class=\"dw-logo-login\">\r\n\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"body-right\">\r\n            <div class=\"body-right-content\">\r\n\r\n\r\n                <div class=\"row\">\r\n                    <div class=\"login-image\">\r\n                        <!-- <img src=\"/assets/img/user-loging.png\" /> -->\r\n                        <i class=\"fa fa-user-circle login-icon\"></i>\r\n                    </div>\r\n                    <div class=\"login-input\">\r\n                        <label class=\"label\">Username/E-mail</label>\r\n                        <input type=\"text\" id=\"tbUserName\" name=\"tbUserName\" class=\"form-control\" [(ngModel)]=\"userName\"\r\n                            placeholder=\"username/e-mail\" autocomplete=\"chrome-off\" required>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"login-image\">\r\n                        <i class=\"fa fa-user-lock login-icon\"></i>\r\n                    </div>\r\n                    <div class=\"login-input\">\r\n                        <label class=\"label\">Password</label>\r\n                        <input type=\"password\" id=\"tbPassword\" name=\"tbPassword\" class=\"form-control\"\r\n                            [(ngModel)]=\"oldPassword\" placeholder=\"old password\" required>\r\n                    </div>\r\n                </div>\r\n                <ng-container *ngIf=\"showTwoFactor\">\r\n                    <div class=\"row\" *ngIf=\"twoFactorMessage\">\r\n                        <div class=\"login-image\">\r\n                            \r\n                        </div>\r\n                        <div class=\"login-input\">\r\n                            {{ twoFactorMessage }}\r\n                            <div style=\"margin-top:3px;margin-bottom:3px;height:10px;\" *ngIf=\"showResendCode\">\r\n                                <a (click)=\"resendCode()\">Resend Code</a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                        <div class=\"login-image\">\r\n                            <!-- <img src=\"/assets/img/user-password.png\" /> -->\r\n                            <i class=\"fa fa-barcode-alt login-icon\"></i>\r\n                        </div>\r\n                        <div class=\"login-input\">\r\n                            <label class=\"label\">Two Factor Code</label>\r\n                            <input type=\"text\" id=\"tbTwoFactorCode\" name=\"tbTwoFactorCode\" class=\"form-control\"\r\n                                [(ngModel)]=\"twoFactorCode\" placeholder=\"two factor code\" required>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n                <dw-password [(password)]=\"newPassword\" [(isPasswordValid)]=\"isPasswordValid\"></dw-password>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-12\">\r\n                        <button (click)=\"changePassword2()\" class=\"form-control btn btn-primary\"\r\n                            [disabled]=\"processing\">\r\n                            Change Password<i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>",
                styles: [""]
            }]
    }], null, null); })();
const ɵDwMenuTemplateComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMenuTemplateComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'dw-menu-template',
                template: `
      <div (click)="doAction(menu, $event)" [ngClass]="className">
        <ng-content></ng-content>
      </div>
    `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserRegistrationComponent, [{
        type: Component,
        args: [{
                selector: 'dw-user-registration',
                template: "<div class=\"login\">\r\n    <ng-content select=\"[top]\"></ng-content>\r\n    <div class=\"card\">\r\n        <div class=\"card-header\">{{ dwUIConfig.registrationConfig?.registerTitle || 'Register' }}</div>\r\n        <div class=\"card-body\">\r\n            <dw-message [message]=\"message\"></dw-message>\r\n            <div class=\"body-left\">\r\n                <div class=\"body-left-content\">\r\n                    <div class=\"dw-logo-login\">\r\n\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"body-right\">\r\n                <div class=\"body-right-content\">\r\n                    <ng-container *ngIf=\"showTwoFactor; then twoFactorTemplate; else userRegistrationTemplate\">\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <ng-content select=\"[bottom]\"></ng-content>\r\n</div>\r\n\r\n<ng-template #userRegistrationTemplate>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"login-image\">\r\n            <i class=\"fa fa-id-card login-icon\" *ngIf=\"userRegistration.FirstName && userRegistration.LastName\"></i>\r\n            <i class=\"fa fa-id-card login-icon dw-orange\"\r\n                *ngIf=\"!userRegistration.FirstName || !userRegistration.LastName\"></i>\r\n        </div>\r\n        <div class=\"login-input\">\r\n            <div style=\"width:50%;\" class=\"pull-left\">\r\n\r\n                <dw-floating-label-input [label]=\"'First Name'\" [inputClass]=\"'form-control'\"\r\n                    [containerClass]=\"'login-input-container'\" [name]=\"'tbFirstName'\"\r\n                    [(ngModel)]=\"userRegistration.FirstName\"  [autoComplete]=\"'givenName'\"\r\n                    [useFloat]=\"dwUIConfig.registrationConfig?.useFloatLabelOnRegistration\" [placeholder]=\"'First Name'\">\r\n                </dw-floating-label-input>\r\n            </div>\r\n            <div style=\"width: calc(50% - 3px); margin-left:2px\" class=\"pull-left\">\r\n                <dw-floating-label-input [label]=\"'Last Name'\" [inputClass]=\"'form-control'\"\r\n                    [containerClass]=\"'login-input-container'\" [name]=\"'tbLastName'\"\r\n                    [(ngModel)]=\"userRegistration.LastName\"  [autoComplete]=\"'familyName'\"\r\n                    [useFloat]=\"dwUIConfig.registrationConfig?.useFloatLabelOnRegistration\" [placeholder]=\"'Last Name'\">\r\n                </dw-floating-label-input>\r\n                <!-- \r\n                <label class=\"label\">Last Name</label>\r\n                <input type=\"text\" id=\"tbLastName\" name=\"tbLastName\" class=\"form-control\"\r\n                    [(ngModel)]=\"userRegistration.LastName\" placeholder=\"Last Name\" autocomplete=\"chrome-off\" required> -->\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <!-- <div class=\"row\">\r\n        <div class=\"login-image\">\r\n        </div>\r\n        <div class=\"login-input\">\r\n            <label class=\"label\">Last Name</label>\r\n            <input type=\"text\" id=\"tbLastName\" name=\"tbLastName\" class=\"form-control\"\r\n                [(ngModel)]=\"userRegistration.LastName\" placeholder=\"Last Name\" autocomplete=\"chrome-off\" required>\r\n        </div>\r\n    </div> -->\r\n    <div class=\"row\">\r\n        <div class=\"login-image\">\r\n            <i class=\"fa fa-envelope login-icon\" *ngIf=\"isEmailValid && userRegistration.Email\"></i>\r\n            <i class=\"fa fa-envelope login-icon dw-orange\" *ngIf=\"!userRegistration.Email\"></i>\r\n            <i class=\"fa fa-envelope login-icon dw-red\" *ngIf=\"!isEmailValid && userRegistration.Email\"></i>\r\n        </div>\r\n        <div class=\"login-input\">\r\n                <dw-floating-label-input [label]=\"dwUIConfig.registrationConfig?.registrationEmailText || 'E-mail'\"\r\n                    [inputClass]=\"'form-control'\" [containerClass]=\"'login-input-container'\" [name]=\"'tbEmail'\"\r\n                    [(ngModel)]=\"userRegistration.Email\" (ngModelChange)=\"changeEmail()\"  [autoComplete]=\"'email'\"\r\n                    [useFloat]=\"dwUIConfig.registrationConfig?.useFloatLabelOnRegistration\" [placeholder]=\"'E-mail'\">\r\n                </dw-floating-label-input>\r\n                <div *ngIf=\"!isEmailValid && userRegistration.Email\" class=\"dw-red\">\r\n                    E-mail address is not valid\r\n                </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" *ngIf=\"!dwUIConfig.registrationConfig?.registrationHideUserName\">\r\n        <div class=\"login-image\">\r\n            <!-- <img src=\"/assets/img/user-loging.png\" /> -->\r\n            <i class=\"fa fa-user-circle login-icon\" *ngIf=\"userRegistration.UserName\"></i>\r\n            <i class=\"fa fa-user-circle login-icon dw-orange\" *ngIf=\"!userRegistration.UserName\"></i>\r\n        </div>\r\n        <div class=\"login-input\">\r\n            <label class=\"label\">Username</label>\r\n            <input type=\"text\" id=\"tbUserName\" name=\"tbUserName\" class=\"form-control\"\r\n                [(ngModel)]=\"userRegistration.UserName\" placeholder=\"Username\" autocomplete=\"chrome-off\" required>\r\n        </div>\r\n    </div>\r\n    <dw-password [(password)]=\"userRegistration.Password\" [(isPasswordValid)]=\"isPasswordValid\" [useFloat]=\"dwUIConfig.registrationConfig?.useFloatLabelOnRegistration\"></dw-password>\r\n\r\n    <dw-dynamic-loader *ngIf=\"dwUIConfig.registrationConfig?.registrationComponentKey\"\r\n        [componentName]=\"dwUIConfig.registrationConfig?.registrationComponentKey\"\r\n        (configure)=\"configureRegistrationCustomComponent($event)\">\r\n    </dw-dynamic-loader>\r\n\r\n    <div class=\"row\" *ngIf=\"captchaConfiguration?.enableCaptcha && captchaConfiguration?.siteKey\">\r\n        <div class=\"col-md-12\">\r\n            <p-captcha [siteKey]=\"captchaConfiguration?.siteKey\" (onResponse)=\"showCapchtaResponse($event)\"\r\n                (onExpire)=\"resetCaptcha()\" (initCallback)=\"initCapchta($event)\"></p-captcha>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <a (click)=\"gotoLogin()\" class=\"hand\">I already have an account</a>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <button (click)=\"registerUser()\" class=\"form-control btn btn-primary btn-register\" [disabled]=\"processing\">\r\n                {{ dwUIConfig.registrationConfig?.registerButtonText || 'Register' }}\r\n                <i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n\r\n<ng-template #twoFactorTemplate>\r\n    <div class=\"row\">\r\n        <div class=\"login-image\">\r\n\r\n        </div>\r\n        <div class=\"login-input\">\r\n            To complete your registration, please enter the Two Factor Code that was sent to your e-mail address\r\n            <div style=\"margin-top:3px;margin-bottom:3px;height:10px;\">\r\n                <a (click)=\"resendCode()\">Resend Code</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"login-image\">\r\n            <img src=\"/assets/img/user-password.png\" />\r\n        </div>\r\n        <div class=\"login-input\">\r\n            <label class=\"label\">Two Factor Code</label>\r\n            <input type=\"text\" id=\"tbTwoFactorCode\" name=\"tbTwoFactorCode\" class=\"form-control\"\r\n                [(ngModel)]=\"twoFactorCode\" placeholder=\"two factor code\" required>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <button type=\"submit\" (click)=\"loginWithTwoFactorCode()\" class=\"form-control btn btn-success\"\r\n                [disabled]=\"processing\">Complete Registration <i *ngIf=\"processing\"\r\n                    class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n        </div>\r\n    </div>\r\n</ng-template>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwSecurityRegistrationRepositoryService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwSecurityOrchestrationService }, { type: DwSecurityStateService }, { type: DwAppInitService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(QuillEditorComponent, [{
        type: Component,
        args: [{
                selector: 'dw-quill-editor',
                template: "<div quill-editor-toolbar style=\"display:none\">\r\n    <span class=\"ql-formats\">\r\n      <select class=\"ql-header\" title=\"Heading\">\r\n        <option value=\"1\"></option>\r\n        <option value=\"2\"></option>\r\n        <option value=\"3\"></option>\r\n        <option value=\"4\"></option>\r\n        <option value=\"5\"></option>\r\n        <option selected=\"selected\"></option>\r\n      </select>\r\n    </span>\r\n    <span class=\"ql-formats\">\r\n      <button class=\"ql-bold\" title=\"Bold\"></button>\r\n      <button class=\"ql-italic\" title=\"Italic\"></button>\r\n      <button class=\"ql-underline\" title=\"Underline\"></button>\r\n      <button class=\"ql-strike\" title=\"Strike\"></button>\r\n    </span>\r\n    <span class=\"ql-formats\">\r\n      <button class=\"ql-link\" title=\"Link\"></button>\r\n      <button class=\"ql-blockquote\" title=\"Block Quote\"></button>\r\n      <button class=\"ql-code-block\" title=\"Code Block\"></button>\r\n      <button class=\"ql-script\" value=\"sub\" title=\"Subscript\"></button>\r\n      <button class=\"ql-script\" value=\"super\" title=\"Superscript\"></button>\r\n    </span>\r\n    <span class=\"ql-formats\">\r\n      <button class=\"ql-list\" value=\"ordered\" title=\"Ordered List\"></button>\r\n      <button class=\"ql-list\" value=\"bullet\" title=\"Bullet List\"></button>\r\n      <button class=\"ql-indent\" value=\"-1\" title=\"Increase Indent\"></button>\r\n      <button class=\"ql-indent\" value=\"+1\" title=\"Decrease Indent\"></button>\r\n    </span>\r\n    <span class=\"ql-formats\">\r\n      <select class=\"ql-color\" title=\"Font Color\">\r\n        <option selected></option>\r\n        <option value=\"#ffffff\"></option>\r\n        <option value=\"#eeeeee\"></option>\r\n        <option value=\"#808080\"></option>\r\n        <option value=\"#ff0000\"></option>\r\n        <option value=\"#00ff00\"></option>\r\n        <option value=\"#0000ff\"></option>\r\n      </select>\r\n      <select class=\"ql-background\" title=\"Background Color\">\r\n        <option selected></option>\r\n        <option value=\"#eeeeee\"></option>\r\n        <option value=\"#808080\"></option>\r\n        <option value=\"#000000\"></option>\r\n        <option value=\"#ff0000\"></option>\r\n        <option value=\"#00ff00\"></option>\r\n        <option value=\"#0000ff\"></option>\r\n      </select>\r\n    </span>\r\n    <span class=\"ql-formats\">\r\n      <select class=\"ql-align\" title=\"Aligment\">\r\n        <option selected></option>\r\n        <option value=\"center\"></option>\r\n        <option value=\"right\"></option>\r\n        <option value=\"justify\"></option>\r\n      </select>\r\n    </span>\r\n    <span class=\"ql-formats\">\r\n      <select class=\"ql-script\" id=\"custom-fields\" title=\"Fields\">\r\n        <option selected></option>\r\n        <option value=\"field1\">Field 1</option>\r\n        <option value=\"field2\">Field 2</option>\r\n        <option value=\"field3\">Field 3</option>\r\n      </select>\r\n    </span>\r\n  </div> \r\n  <div quill-editor-container></div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: LazyLoadScriptService }]; }, { html: [{
            type: Input
        }], htmlChange: [{
            type: Output
        }], onEditorCreated: [{
            type: Output
        }], disabled: [{
            type: Input
        }], modules: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityTwofactorSetupComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-security-twofactor-setup',
                template: "<H1>Two-factor Authentication</H1>\r\n\r\n<p>\r\n    Two-factor authentication (2FA) is an extra layer of security used when logging into websites or apps.\r\n</p>\r\n\r\n<div dwRow>\r\n    <div dwCol=\"6\">\r\n        <dw-message [message]=\"message\"></dw-message>\r\n\r\n        <ng-container *ngIf=\"!twoFactorEnabled  && !showDisableTwoFactor\">\r\n\r\n            <button class=\"btn btn-success\" (click)=\"showStep1()\" *ngIf=\"step == 0\">Enable Two-Factor\r\n                Authentication</button>\r\n\r\n            <ng-container *ngIf=\"step == 1\">\r\n\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <h2>Choose your two-factor method</h2>\r\n\r\n                        <label class=\"radio-container\">\r\n                            <input type=\"radio\" name=\"factorType\" value=\"AuthenticatorApp\"\r\n                                [(ngModel)]=\"twoFactorRequest.FactorType\" />\r\n                            <span class=\"radio-item\"> <strong>Setup using an app</strong></span>\r\n\r\n                            <div class=\"radio-desc\">\r\n                                Use an application on your phone to get two-factor authentication codes when prompted.\r\n                                We recommend using cloud-based TOTP apps such as: 1Password, Authy, LastPass\r\n                                Authenticator, or Microsoft Authenticator.\r\n                            </div>\r\n                        </label>\r\n\r\n                        <label class=\"radio-container\">\r\n                            <input type=\"radio\" name=\"factorType\" value=\"Email\"\r\n                                [(ngModel)]=\"twoFactorRequest.FactorType\" />\r\n                            <span class=\"radio-item\"> <strong>Setup using E-mail</strong></span>\r\n\r\n                            <div class=\"radio-desc\">\r\n                                We will send you an e-mail with a security code when prompted.\r\n                            </div>\r\n                        </label>\r\n                    </div>\r\n                </div>\r\n\r\n                <button class=\"btn btn-success\" (click)=\"showStep2()\" [disabled]=\"processing\">Continue <i\r\n                        *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n                </button>\r\n\r\n                <button class=\"btn btn-secondary ml-2\" (click)=\"cancel()\">Cancel</button>\r\n\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"step == 2\">\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <h2>Authentication Verification</h2>\r\n\r\n                        <div *ngIf=\"twoFactorResponse?.TwoFactorSetup\">\r\n                            <image src=\"{{twoFactorResponse.TwoFactorSetup.QrCodeSetupImageUrl}}\">\r\n                            </image>\r\n\r\n                            <image [src]=\"twoFactorResponse.TwoFactorSetup.QrCodeSetupImageUrl\">\r\n                            </image>\r\n\r\n                            {{twoFactorResponse.TwoFactorSetup.QrCodeSetupImageUrl}}\r\n                            \r\n                            <br>\r\n                            Account: {{twoFactorResponse?.TwoFactorSetup.Account}}<br>\r\n                            Manual Entry Key: {{twoFactorResponse?.TwoFactorSetup.ManualEntryKey}}\r\n                        </div>\r\n\r\n                        Enter the six-digit code below: <span *ngIf=\"showResendCode\">(  <a class=\"dw-blue\" (click)=\"resendCode()\" *ngIf=\"showResendCode\">Resend Code</a>)</span>\r\n                  \r\n                        <input type=\"text\" class=\"form-control code-input\" [(ngModel)]=\"twoFactorRequest.TwoFactorCode\">\r\n                    </div>\r\n                </div>\r\n\r\n                <button class=\"btn btn-success\" (click)=\"complete()\" [disabled]=\"processing\">\r\n                    Complete Setup\r\n                    <i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n                </button>\r\n\r\n                <button class=\"btn btn-secondary ml-2\" (click)=\"cancel()\">Cancel</button>\r\n\r\n            </ng-container>\r\n\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"twoFactorEnabled && !showDisableTwoFactor\">\r\n            <h2>Two-factor authentication has been setup for your account.</h2>\r\n\r\n            <button class=\"btn btn-danger\" (click)=\"startDisableTwoFactor()\">Disable Two-factor Authentication</button>\r\n        </ng-container>\r\n\r\n        <ng-container *ngIf=\"showDisableTwoFactor\">\r\n            <h2>Disable your two-factor authentication</h2>\r\n\r\n            Enter the six-digit code below:  <span *ngIf=\"showResendCode\">(  <a class=\"dw-blue\" (click)=\"resendCode()\" *ngIf=\"showResendCode\">Resend Code</a>)</span>\r\n            <!-- <div style=\"margin-top:3px;margin-bottom:3px;height:10px;\" *ngIf=\"showResendCode\">\r\n                <a (click)=\"resendCode()\">Resend Code</a>\r\n            </div> -->\r\n            <input type=\"text\" class=\"form-control code-input\" [(ngModel)]=\"disableTwoFactorCode\">\r\n\r\n            <button class=\"btn btn-danger\" (click)=\"disabledTwoFactor()\" [disabled]=\"processing\">\r\n                Complete Disable Two-factor Authentication\r\n                <i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i>\r\n            </button>\r\n\r\n            <button class=\"btn btn-secondary ml-2\" (click)=\"cancel()\">Cancel</button>\r\n        </ng-container>\r\n\r\n    </div>\r\n</div>",
                styles: [".radio-container{margin:5px}.radio-item{margin-left:5px;margin-top:-6px}.radio-desc{margin-bottom:4px;margin-left:15px;margin-top:4px}.code-input{max-width:150px}"]
            }]
    }], function () { return [{ type: DwSecurityUserService }, { type: DwSecurityOrchestrationService }, { type: DwSecurityTwoFactorRepositoryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLoginSsoOptionsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-login-sso-options',
                template: "<ng-container *ngFor=\"let ssoConfig of ssoConfigs\">\r\n    <button type=\"button\" (click)=\"authenticateWithSSO(ssoConfig)\" class=\"{{ssoConfig.ButtonClass}}\"\r\n        [disabled]=\"processing\">\r\n        <i class=\"{{ssoConfig.ButtonIconClass}}\" [hidden]=\"!ssoConfig.ButtonIconClass\"></i>\r\n        {{ssoConfig.ButtonText || 'Login with SSO'}}\r\n\r\n        <i *ngIf=\"processing\" class=\"fa fa-spinner fa-pulse fa-fw\"></i></button>\r\n</ng-container>"
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwSecurityOrchestrationService }]; }, { isProcessing: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFileSizePipe, [{
        type: Pipe,
        args: [{
                name: 'filesize'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDivHeightDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[dwHeight]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc17.DomSanitizer }]; }, { heightPercent: [{
            type: Input,
            args: ['dwHeight']
        }], name: [{
            type: Input,
            args: ['name']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event.target']]
        }], divHeight: [{
            type: HostBinding,
            args: ['style.height.px']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMissingImageDirective, [{
        type: Directive,
        args: [{
                selector: "img,[dwMissingImage]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { defaultSrc: [{
            type: Input
        }], onError: [{
            type: HostListener,
            args: ["error"]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFileExtPipe, [{
        type: Pipe,
        args: [{
                name: 'fileext'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDivColumnManagerDirective, [{
        type: Directive,
        args: [{
                selector: '[dwColumnManager]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc17.DomSanitizer }]; }, { heightPercent: [{
            type: Input,
            args: ['heightPercent']
        }], columns: [{
            type: Input,
            args: ['dwColumnManager']
        }], name: [{
            type: Input,
            args: ['name']
        }], itemCount: [{
            type: Input,
            args: ['itemCount']
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event.target']]
        }], divWidth: [{
            type: HostBinding,
            args: ['style.width']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwStyleBuilderComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-style-builder',
                template: "<p>dw-style-builder works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAddSpacesPipe, [{
        type: Pipe,
        args: [{
                name: 'addSpaces'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMiddleClickDirective, [{
        type: Directive,
        args: [{ selector: '[middleclick]' }]
    }], function () { return []; }, { middleclick: [{
            type: Output,
            args: ['middleclick']
        }], middleclickEvent: [{
            type: HostListener,
            args: ['mouseup', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPasswordUtilService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dw-password',
                template: "<div class=\"row\">\r\n    <div class=\"login-image\">\r\n        <i class=\"fa fa-lock login-icon dw-orange\" *ngIf=\"!password\"></i>\r\n        <i class=\"fa fa-lock login-icon dw-red\" *ngIf=\"password && passwordCheckResults?.messages\"></i>\r\n        <i class=\"fa fa-lock login-icon\" *ngIf=\"password && !passwordCheckResults?.messages\"></i>\r\n    </div>\r\n    <div class=\"login-input\">\r\n        <input style=\"display: none\" type=\"text\" name=\"fakeusernameremembered\" />\r\n\r\n        <!-- <label class=\"label\">New Password</label>\r\n        <input type=\"password\" id=\"tbPasswordNew\" name=\"tbPasswordNew\" class=\"form-control\" [(ngModel)]=\"password\"\r\n            placeholder=\"Password\" (ngModelChange)=\"onChange()\" autocomplete=\"new-password\" required> -->\r\n\r\n        <dw-floating-label-input [type]=\"'password'\" [label]=\"'New Password'\" [inputClass]=\"'form-control'\"\r\n            [containerClass]=\"'login-input-container'\" [name]=\"'tbPasswordNew'\" [(ngModel)]=\"password\" (ngModelChange)=\"onChange()\"\r\n            [inputAutocomplete]=\"'new-password'\" [useFloat]=\"useFloat\"\r\n            [placeholder]=\"'Password'\">\r\n        </dw-floating-label-input>\r\n\r\n        <div *ngIf=\"passwordCheckResults?.messages\" class=\"dw-red\">\r\n            Password requires:\r\n            <ul>\r\n                <li *ngFor=\"let message of passwordCheckResults.messages\">\r\n                    {{message}}\r\n                </li>\r\n            </ul>\r\n        </div>\r\n        <div *ngIf=\"!passwordCheckResults?.messages && password\" class=\"dw-green\">\r\n            Password meets complexity requirements\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"login-image\">\r\n        <!-- <img src=\"/assets/img/user-password.png\" /> -->\r\n        <i class=\"fa fa-lock-open-alt login-icon dw-orange\" *ngIf=\"!passwordRetype\"></i>\r\n        <i class=\"fa fa-lock-open-alt login-icon dw-red\" *ngIf=\"passwordRetype && password != passwordRetype\"></i>\r\n        <i class=\"fa fa-lock-alt login-icon\" *ngIf=\"passwordRetype && password == passwordRetype\"></i>\r\n    </div>\r\n    <div class=\"login-input\">\r\n        <input style=\"display: none\" type=\"text\" name=\"fakeusernameremembered\" />\r\n\r\n        <!-- <label class=\"label\">Retype New Password</label>\r\n        <input type=\"password\" id=\"tbPasswordRetype\" name=\"tbPasswordRetype\" class=\"form-control\"\r\n            [(ngModel)]=\"passwordRetype\" (ngModelChange)=\"onChange()\" placeholder=\"Retype Password\"\r\n            autocomplete=\"new-password\" required> -->\r\n        <dw-floating-label-input [type]=\"'password'\" [label]=\"'Retype New Password'\" [inputClass]=\"'form-control'\"\r\n            [containerClass]=\"'login-input-container'\" [name]=\"'tbPasswordRetype'\" [(ngModel)]=\"passwordRetype\" (ngModelChange)=\"onChange()\"\r\n            [inputAutocomplete]=\"'new-password'\" [useFloat]=\"useFloat\"\r\n            [placeholder]=\"'Retype Password'\">\r\n        </dw-floating-label-input>\r\n\r\n        <div *ngIf=\"passwordRetype && password != passwordRetype\" class=\"dw-red\">\r\n            Passwords do not match\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwSecurityRegistrationRepositoryService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwSecurityOrchestrationService }, { type: DwSecurityStateService }, { type: DwAppInitService }, { type: DwPasswordUtilService }]; }, { passwordChange: [{
            type: Output
        }], isPasswordValidChange: [{
            type: Output
        }], useFloat: [{
            type: Input
        }], isPasswordValid: [{
            type: Input
        }], password: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateMultiSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-date-multi-select',
                template: "\r\n\r\n<div *ngIf=\"disabled\">\r\n    {{ dateListDisplay }}\r\n</div>\r\n\r\n<div class=\"input-group mr-2\" *ngIf=\"!disabled\">\r\n  <input #popover=\"ngbPopover\" [ngbPopover]=\"popoverContent\" popoverClass=\"dw-date-time-picker\" (shown)=\"popoverShown()\"\r\n    container=\"body\" placement=\"bottom-left\" class=\"form-control date-time-input-text\" [ngModel]=\"dateListDisplay\"\r\n    (ngModelChange)=\"onInputChange($event)\" [disabled]='true' dwBrowserAutocomplete=\"false\" />\r\n\r\n  <div class=\"input-group-append\">\r\n    <button class=\"btn date-time-icon\" [disabled]='disabled' type=\"button\" (click)=\"popover.toggle()\">\r\n      <i class=\"far fa-calendar\"></i>\r\n    </button>\r\n  </div>\r\n</div>\r\n\r\n<ng-template #popoverContent>\r\n  <div class=\"date-range-picker\">\r\n    <ngb-datepicker [ngModel]=\"startDateTime\" #dp (dateSelect)=\"onDateSelection($event)\"\r\n      (select)=\"onDateSelection($event)\" [displayMonths]=\"2\" [firstDayOfWeek]=\"firstDayOfWeek\" [dayTemplate]=\"dayTemplate\" outsideDays=\"hidden\">\r\n    </ngb-datepicker>\r\n  </div>\r\n</ng-template>\r\n\r\n<ng-template #dayTemplate let-date let-focused=\"focused\">\r\n  <span class=\"custom-day\" [class.focused]=\"focused\" [class.range]=\"isRange(date)\"\r\n    [class.faded]=\"isHovered(date) || isInside(date)\" (mouseenter)=\"hoveredDate = date\"\r\n    (mouseleave)=\"hoveredDate = null\">\r\n    {{ date.day }}\r\n  </span>\r\n</ng-template>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwDateMultiSelectComponent),
                        multi: true
                    }],
                styles: [".custom-day{display:inline-block;height:2rem;padding:.185rem .25rem;text-align:center;width:2rem}.custom-day.focused{background-color:#e6e6e6}.custom-day.range,.custom-day:hover{background-color:#0275d8;color:#fff}.custom-day.faded{background-color:rgba(2,117,216,.5)}.date-time-icon{background-color:#007ad9;border:1px solid #007ad9;color:#fff;font-size:14px}.date-time-input-text{background:#fff;color:#333;font-size:14px}"]
            }]
    }], function () { return [{ type: ɵngcc20.NgbPopoverConfig }, { type: ɵngcc0.ChangeDetectorRef }]; }, { dateList: [{
            type: Input
        }], dateListChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], datePickerControl: [{
            type: ViewChild,
            args: [NgbDatepicker, { static: false }]
        }], popover: [{
            type: ViewChild,
            args: [NgbPopover, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpandableSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-expandable-section',
                template: `
    <div [ngStyle]="computedStyle" class="dw-container-transitions">
      <div #innerContent>
        <ng-content></ng-content>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { collapsed: [{
            type: Input
        }], innerContent: [{
            type: ViewChild,
            args: ['innerContent']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpandableDirective, [{
        type: Directive,
        args: [{
                selector: '[dwExpandable]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { enabled: [{
            type: Input,
            args: ['dwExpandable']
        }], computedStyle: [{
            type: HostBinding,
            args: ["style"]
        }], collapsed: [{
            type: Input
        }] }); })();
const ɵDwCustomValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwCustomValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCustomValidationRule, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDatePipe, [{
        type: Pipe,
        args: [{
                name: 'dwDate'
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiInfoDisplayComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ui-info-display',
                template: "<div *ngFor=\"let section of config?.sections; let i = index\">\r\n    <ng-container *ngIf=\"sectionVisible[i]\">\r\n        <div class=\"section-title\">{{section.sectionDisplay}}</div>\r\n\r\n        <div class=\"data-row\" *ngFor=\"let field of section?.fields\">\r\n                <label class=\"label\">{{field.display}}</label>\r\n                <div class=\"data\" *ngIf=\"finalData[field.fieldPath]\">{{ finalData[field.fieldPath] }}</div>\r\n        </div>\r\n    </ng-container>\r\n</div> \r\n",
                styles: [".section-title{font-size:14px;font-weight:700}.data-row{border:1px solid #000;clear:left;margin-left:3px;margin-right:3px;overflow:auto;width:100%}.label{border-right:1px dashed #000;float:left;font-size:10px;width:40%}.data{font-size:11px;text-overflow:ellipsis;width:60%}"]
            }]
    }], function () { return []; }, { config: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwControlWrapperWithIconsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-control-wrapper-with-icons',
                template: "<div class=\"input-group\">\r\n\r\n    <div class=\"input-group-prepend\" [hidden]=\"!showPrefix\">\r\n        <ng-content select=\"[prefix]\"></ng-content>\r\n    </div>\r\n\r\n    \r\n    <ng-content select=\"[control]\" *ngIf=\"!wrapControl\"></ng-content>\r\n    \r\n    <div class=\"input-group-middle\" *ngIf=\"wrapControl\">\r\n        <ng-content select=\"[control2]\"></ng-content>\r\n    </div>\r\n\r\n    <div class=\"input-group-append\" [hidden]=\"!showSuffix\">\r\n        <ng-content select=\"[suffix]\"></ng-content>\r\n    </div>\r\n</div>",
                styles: [".input-group-middle{flex:1 1 auto;margin-bottom:0;position:relative;width:1%}"]
            }]
    }], function () { return []; }, { wrapControl: [{
            type: Input
        }], showPrefix: [{
            type: Input
        }], showSuffix: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ColorSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-color-select',
                template: "\r\n<p-dropdown [placeholder]=\"placeholder\" [options]=\"colors\" optionLabel=\"display\" display=\"chip\" optionValue=\"name\" [(ngModel)]=\"translatedValue\" [showClear]=\"true\" (ngModelChange)=\"setTranslatedValue($event)\" [style]=\"{'width':'100%'}\" [filter]=\"showFilter\" scrollHeight=\"300px\" appendTo=\"body\">\r\n    <ng-template pTemplate=\"selectedItem\" let-color>\r\n        <div class=\"color-patch\" [ngClass]=\"color.backgroundClass\">{{ color.display }}</div> \r\n    </ng-template>\r\n    <ng-template let-color pTemplate=\"item\">\r\n        <div class=\"color-patch\" [ngClass]=\"color.backgroundClass\"> {{ color.display }}</div>\r\n    </ng-template>\r\n</p-dropdown>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => ColorSelectComponent),
                        multi: true
                    }],
                styles: [".color-patch{border:1px solid #000;float:left;text-align:center;width:100%}"]
            }]
    }], function () { return [{ type: DwStyleManagerService }]; }, { placeholder: [{
            type: Input
        }], showFilter: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwButtonClassSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-button-class-select',
                template: "<p>dw-button-class-select works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwStyleManagerService }]; }, { placeholder: [{
            type: Input
        }], showFilter: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwColorPickerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-color-picker',
                template: "<dw-custom-dropdown (clearValue)=\"clearValue()\" [allowClear]=\"!!translatedValue\" dropDownHeight=\"257px\">\n    <div control>\n        <div [hidden]=\"translatedValue\" class=\"color-select\">Select Color</div>\n        <div [hidden]=\"!translatedValue\" class=\"color-patch\" [ngStyle]=\"{ 'background-color': translatedValue }\"\n            title=\"{{translatedValue}}\"></div>\n    </div>\n    <div dropdown class=\"picker-container\">\n        <!-- <div dwRow>\n            <div dwCol>\n                <ng-container *ngFor=\"let color of colors\">\n\n                    <div [class]=\"color.backgroundClass\" (click)=\"setColor(color)\" style=\"width:25px;height:25px; margin:5px; float: left\"\n                        [title]=\"color.name\">\n\n                    </div>\n                </ng-container>\n            </div>\n        </div> -->\n        <div dwRow>\n            <div dwCol>\n                Hex:\n                <input type=\"text\" [(ngModel)]=\"translatedValue\" (ngModelChange)=\"setTranslatedValue($event)\" class=\"form-control\" />\n            </div>\n        </div>\n        <div dwRow>\n            <div dwCol>\n                <p-colorPicker [(ngModel)]=\"translatedValue\" (ngModelChange)=\"setTranslatedValue($event)\" [inline]=\"true\"></p-colorPicker>\n            </div>\n        </div>\n    </div>\n</dw-custom-dropdown>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwColorPickerComponent),
                        multi: true
                    }],
                styles: [".picker-container{overflow:hidden;padding:5px}.color-patch{border:1px solid #000;color:#fff;text-align:center}.color-patch,.color-select{float:left;height:24px;width:100%}"]
            }]
    }], function () { return [{ type: DwStyleManagerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCustomDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'dw-custom-dropdown',
                template: "<div>\n    <div #dropDownControl class=\"drop-down-field form-control hand\" >\n        <div (click)=\"click($event)\" class=\"drop-down-control hand\">\n            <ng-content select=\"[control]\"></ng-content>\n        </div>\n        \n        <i class=\"p-dropdown-clear-icon pi pi-times ng-tns-c110-4 ng-star-inserted hand\" [hidden]=\"!allowClear\" (click)=\"clearValue.emit()\"></i>\n        <span class=\"pi pi-fw pi-caret-down drop-down-icon hand ui-dropdown-trigger\" (click)=\"click($event)\"></span> \n    </div>\n    <div class=\"dropdown-section p-dropdown-panel\" [ngClass]=\"{'hide': visible == false}\" [attr.id]=\"id\" (clickOutside)=\"outsideClick()\">\n        <ng-content select=\"[dropdown]\"></ng-content>\n    </div>\n</div>",
                styles: ["@charset \"UTF-8\";.drop-down-field{position:relative}.drop-down-field .form-control:disabled,.drop-down-field .form-control[readonly]{background-color:#fff}.drop-down-control{width:calc(100% - 40px)}.dropdown-section{background-clip:padding-box;background-color:#fff;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;min-width:10rem;overflow-x:none;overflow-y:auto;padding:0;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section .ui-treenode-content-selected{background-color:#007ad9;border:1px;color:#fff}.hide{display:none}.drop-down-icon{color:#848484;position:absolute;right:3px;text-align:center;top:20%;width:2.357em}.custom-ui-tree{height:100%;width:100%!important}.custom-ui-tree,.custom-ui-tree .ui-tree-container{padding:0!important}.pi-caret-down:before{content:\"\uE902\"!important}"]
            }]
    }], function () { return []; }, { dropDownHeight: [{
            type: Input
        }], visible: [{
            type: Input
        }], allowClear: [{
            type: Input
        }], clearValue: [{
            type: Output
        }], reset: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], targetElement: [{
            type: ViewChild,
            args: ['dropDownControl', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwButtonDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'dw-button-dropdown',
                template: "<div class=\"btn-group\" dropdown>\n\n    <div #inputElement class=\"dropdown-button\">\n        <dw-button  [buttonConfig]=\"buttonConfig\" [showCaret]=\"showCaret\" (click)=\"click($event)\"></dw-button>\n    </div>\n\n    <!-- <button #inputElement dropdownToggle type=\"button\" class=\"btn btn-success dropdown-toggle\" (click)=\"click($event)\">\n        <i *ngIf=\"buttonConfig?.iconClass && !buttonConfig?.showIconAfterText\" [class]=\"buttonConfig?.iconClass\"></i>\n        {{buttonConfig?.buttonText}}\n        <i *ngIf=\"buttonConfig?.iconClass && buttonConfig?.showIconAfterText\" [class]=\"buttonConfig?.iconClass\"></i>\n        <span class=\"caret\"></span>\n    </button> -->\n\n    <div #menuSection class=\"dropdown-section\" [ngClass]=\"{'hide': visible == false}\" [attr.id]=\"id\" (clickOutside)=\"outsideClick()\">\n        <!-- <li role=\"menuitem\"><a class=\"dropdown-item\" href=\"#\">Assign Courses</a>\n        <li class=\"divider dropdown-divider\"></li>\n        <li role=\"menuitem\"><a class=\"dropdown-item\" href=\"#\">Send Join Request</a></li>\n        <li role=\"menuitem\"><a class=\"dropdown-item\" href=\"#\">All Join Requests</a></li> -->\n\n        <ng-container *ngFor=\"let menuItem of menuItems\">\n            <li class=\"divider dropdown-divider\" [hidden]=\"!menuItem.dividerBefore\"></li>\n            <li role=\"menuitem\" class=\"dropdown-menu-item\" (click)=\"onMenuClick(menuItem, $event)\"><a class=\"dropdown-item\">{{menuItem.display}}</a></li>\n        </ng-container>\n\n        <!-- <li role=\"menuitem\"><a class=\"dropdown-item\" href=\"#\">Manage Groups</a></li> -->\n    </div>\n</div>\n\n",
                styles: ["@charset \"UTF-8\";.drop-down-tree-field{position:relative}.drop-down-tree-field .form-control:disabled,.drop-down-tree-field .form-control[readonly],.dropdown-section{background-color:#fff}.dropdown-section{background-clip:padding-box;border:1px solid #e9ecef;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;max-width:80vw;min-width:100px;overflow-x:none;overflow-y:auto;padding:5px;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section .ui-treenode-content-selected{background-color:#007ad9;border:1px;color:#fff}.hide{display:none}.dropdown-button{margin-left:3px}.drop-down-icon{color:#848484;position:absolute;right:3px;text-align:center;top:20%;width:2.357em}.custom-ui-tree{height:100%;width:100%!important}.custom-ui-tree,.custom-ui-tree .ui-tree-container{padding:0!important}.pi-caret-down:before{content:\"\uE902\"!important}.dropdown-item{padding:5px!important}.dropdown-menu-item{cursor:pointer;padding-left:10px!important;padding-right:10px!important}"]
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], showCaret: [{
            type: Input
        }], menuClick: [{
            type: Output
        }], menuItems: [{
            type: Input
        }], reset: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }], buttonConfig: [{
            type: Input
        }], targetElement: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }], menuSectionElement: [{
            type: ViewChild,
            args: ['menuSection', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTermsOfServiceModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-terms-of-service-modal',
                template: "<!-- <h2>To continue you need to accept the terms of this service</h2> -->\n\n<div class=\"dw-terms-of-service-container\">\n    <dw-html-view [ngModel]=\"modalConfig.data.TermsOfService.TermsOfServiceText\"></dw-html-view>\n\n    <br><a [href]=\"modalConfig.data.TermsOfService.TermsOfServiceLinkUrl\" target=\"_blank\">Terms of Service</a>\n\n    <dw-message [(message)]=\"message\"></dw-message>\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFloatingLabelInputComponent, [{
        type: Component,
        args: [{
                selector: 'dw-floating-label-input',
                template: "<div [ngClass]=\"containerClass\" class=\"p-float-label\" *ngIf=\"useFloat\">\n    <!-- <label class=\"label\">Username/E-mail</label> -->\n    <input #inputElement [type]=\"type\" [id]=\"name\" [name]=\"name\"\n        [ngClass]=\"floatingInputClasses\"\n        [(ngModel)]=\"value\"\n        (ngModelChange)=\"valueChange()\" (focus)=\"focusInput\" (blur)=\"blurInput()\"\n        [autocomplete]=\"inputAutoComplete\"\n        >\n    <label class2=\"label\" [for]=\"name\" [ngClass]=\"floatingLabelClasses\">\n        {{ label}}\n    </label>\n</div>\n<div [ngClass]=\"containerClass\" *ngIf=\"!useFloat\">\n    <label [ngClass]=\"labelClass\">\n        {{ label }}\n    </label>\n    <input [type]=\"type\" [ngClass]=\"inputClass\" [id]=\"name\" [name]=\"name\" [(ngModel)]=\"value\"\n        (ngModelChange)=\"valueChange()\" [placeholder]=\"placeholder\" [autocomplete]=\"inputAutoComplete\">\n</div>\n<!-- Name: {{name}}<br>\nAuto Complete: {{inputAutocomplete}}<br> -->\n",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwFloatingLabelInputComponent),
                        multi: true
                    }],
                styles: [""]
            }]
    }], function () { return []; }, { useFloat: [{
            type: Input
        }], type: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], inputClass: [{
            type: Input
        }], labelClass: [{
            type: Input
        }], containerClass: [{
            type: Input
        }], name: [{
            type: Input
        }], inputAutocomplete: [{
            type: Input
        }], label: [{
            type: Input
        }], maxlength: [{
            type: Input
        }], userNameInput: [{
            type: ViewChild,
            args: ['inputElement']
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareUIModule, { declarations: function () { return [DwDivColumnManagerDirective, DwLoginComponent, DwLoginPageComponent, DwSecurityInfoComponent, DwGridComponent, DwGridConfigComponent, DwGridHostDirective, DwComponentHost, DwRowDirective, DwColDirective, DwInputComponent, DwInputReadOnlyComponent, DwYesNoComponent, DwRadioListComponent, DwButtonBarComponent, DwSelectComponent, DwReadOnlyControlComponent, DwAppSidebarNavComponent, DwAppSidebarNavItemComponent, DwAppSidebarNavLinkComponent, DwAppSidebarNavDropdownComponent, DwAppSidebarNavTitleComponent, DwNavDropdownDirective, DwNavDropdownToggleDirective, DwUiConfigPanelComponent, DwUiConfigHostDirective, DwFormComponent, DwMessageBarComponent, DwModalHostComponent, DwButtonComponent, DwSecurityEmulationComponent, DwActionHostComponent, DwModal, DwHtmlViewComponent, DwDataListComponent, DwCardItemDirective, DwListItemDirective, DwNoItemsDirective, DwPillsDisplayDirective, DwRouterParentComponent, DwDateInputControlComponent, DwDateInputControl2Component, DwDateRangeInputComponent, DwPillsComponent, DwValidationInfo, DwHtmlEditComponent, DwUrlReadOnlyControlComponent, DwLoadingComponent, DwEvenColumnRowComponent, DwSsoLoginComponent, DwDynamicLoaderComponent, DwDynamicHostDirective, DwSecurityErrorPageComponent, DwNumericDirective, DwCalcComponent, DwMessageComponent, DwBootstrapDateTimeInputComponent, DwUiConfigListComponent, DwBrowserAutocomplete, DwContainerComponent, DwMenuLinkComponent, DwSecurityAvatarComponent, DwSecurityUserMenuComponent, DwActionGroupConfigComponent, DwActionConfigComponent, DwButtonConfigComponent, DwActionBarComponent, DwContextMenuConfigComponent, DwSecurityCheckConfigComponent, DwSecurityPermissionSelectComponent, DwConfirmDialogConfigComponent, DwTreeSelect, DwClickOutsideDirective, DwUiChildConfigHostComponent, DwActionGroupModesConfigComponent, DwValidationConfigBaseComponent, DwMaxValidatorConfigComponent, DwMinValidationConfigComponent, DwMaxLengthValidatorConfigComponent, DwPatternValidatorConfigComponent, DwCountValidatorConfigComponent, DwUserPasswordResetComponent, DwUserChangePasswordComponent, DwMenuTemplateComponent, DwUserRegistrationComponent, QuillEditorComponent, DwSecurityTwofactorSetupComponent, DwLoginSsoOptionsComponent, DwFileSizePipe, DwFileExtPipe, DwAddSpacesPipe, DwDatePipe, DwDivHeightDirective, DwDivColumnManagerDirective, DwMissingImageDirective, DwMiddleClickDirective, DwStyleBuilderComponent, DwPasswordComponent, DwDateMultiSelectComponent, DwExpandableSectionComponent, DwExpandableDirective, DwUiInfoDisplayComponent, DwControlWrapperWithIconsComponent, ColorSelectComponent, DwButtonClassSelectComponent, DwColorPickerComponent, DwCustomDropdownComponent, DwButtonDropdownComponent, DwTermsOfServiceModalComponent, DwFloatingLabelInputComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule, DevwareCoreModule, RouterModule,
        OrderListModule,
        TabViewModule,
        MenuModule,
        DropdownModule,
        BsDropdownModule,
        NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule,
        TriStateCheckboxModule,
        SelectButtonModule,
        InputSwitchModule,
        CalendarModule,
        ToastModule,
        ProgressBarModule,
        DialogModule,
        ButtonsModule,
        //EditorModule,
        //PasswordModule,
        ContextMenuModule,
        TreeModule,
        // QuillModule,
        AccordionModule,
        InfiniteScrollModule,
        SplitterModule,
        InputTextModule,
        ColorPickerModule,
        CaptchaModule]; }, exports: function () { return [DwLoginComponent, DwLoginPageComponent, DwSecurityInfoComponent, DwGridComponent, DwGridConfigComponent, DwRowDirective, DwColDirective, DwInputComponent, DwInputReadOnlyComponent, DwYesNoComponent, DwRadioListComponent, DwButtonBarComponent, DwSelectComponent, DwAppSidebarNavComponent, DwAppSidebarNavItemComponent, DwAppSidebarNavLinkComponent, DwAppSidebarNavDropdownComponent, DwAppSidebarNavTitleComponent, DwNavDropdownDirective, DwNavDropdownToggleDirective, DwUiConfigPanelComponent, DwFormComponent, DwComponentHost, DwMessageBarComponent, DwMessageComponent, DwModalHostComponent, DwButtonComponent, DwActionHostComponent, DwHtmlViewComponent, DwDataListComponent, DwCardItemDirective, DwListItemDirective, DwNoItemsDirective, DwPillsDisplayDirective, DwReadOnlyControlComponent, DwRouterParentComponent, DwDateInputControlComponent, DwDateInputControl2Component, DwDateRangeInputComponent, DwPillsComponent, DwValidationInfo, DwHtmlEditComponent, DwUrlReadOnlyControlComponent, DwLoadingComponent, DwEvenColumnRowComponent, DwSsoLoginComponent, DwDynamicLoaderComponent, DwDynamicHostDirective, DwNumericDirective, DwCalcComponent, DwUiConfigListComponent, DwBrowserAutocomplete, DwContainerComponent, DwMenuLinkComponent, DwSecurityAvatarComponent, DwSecurityUserMenuComponent, DwActionGroupConfigComponent, DwActionConfigComponent, DwActionBarComponent, DwTreeSelect, DwClickOutsideDirective, DwUiChildConfigHostComponent, DwSecurityCheckConfigComponent, DwActionGroupModesConfigComponent, DwValidationConfigBaseComponent, DwMaxValidatorConfigComponent, DwMinValidationConfigComponent, DwCountValidatorConfigComponent, DwMenuTemplateComponent, DwUserPasswordResetComponent, DwUserChangePasswordComponent, DwMenuTemplateComponent, DwUserRegistrationComponent, DwSecurityPermissionSelectComponent, QuillEditorComponent, DwFileSizePipe, DwFileExtPipe, DwAddSpacesPipe, DwDatePipe, DwDivHeightDirective, DwDivColumnManagerDirective, DwMissingImageDirective, DwMiddleClickDirective, DwDateMultiSelectComponent, DwExpandableSectionComponent, DwExpandableDirective, DwUiInfoDisplayComponent, DwControlWrapperWithIconsComponent, ColorSelectComponent, DwColorPickerComponent, DwButtonDropdownComponent, DwFloatingLabelInputComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareUIModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwDivColumnManagerDirective,
                    DwLoginComponent,
                    DwLoginPageComponent,
                    DwSecurityInfoComponent,
                    DwGridComponent,
                    DwGridConfigComponent,
                    DwGridHostDirective,
                    DwComponentHost,
                    DwRowDirective,
                    DwColDirective,
                    DwInputComponent,
                    DwInputReadOnlyComponent,
                    DwYesNoComponent,
                    DwRadioListComponent,
                    DwButtonBarComponent,
                    DwSelectComponent,
                    DwReadOnlyControlComponent,
                    DwAppSidebarNavComponent,
                    DwAppSidebarNavItemComponent,
                    DwAppSidebarNavLinkComponent,
                    DwAppSidebarNavDropdownComponent,
                    DwAppSidebarNavTitleComponent,
                    DwNavDropdownDirective,
                    DwNavDropdownToggleDirective,
                    DwUiConfigPanelComponent,
                    DwUiConfigHostDirective,
                    DwFormComponent,
                    DwMessageBarComponent,
                    DwModalHostComponent,
                    DwButtonComponent,
                    DwSecurityEmulationComponent,
                    DwActionHostComponent,
                    DwModal,
                    DwHtmlViewComponent,
                    DwDataListComponent,
                    DwCardItemDirective,
                    DwListItemDirective,
                    DwNoItemsDirective,
                    DwPillsDisplayDirective,
                    DwRouterParentComponent,
                    DwDateInputControlComponent,
                    DwDateInputControl2Component,
                    DwDateRangeInputComponent,
                    DwPillsComponent,
                    DwValidationInfo,
                    DwHtmlEditComponent,
                    DwUrlReadOnlyControlComponent,
                    DwLoadingComponent,
                    DwEvenColumnRowComponent,
                    DwSsoLoginComponent,
                    DwDynamicLoaderComponent,
                    DwDynamicHostDirective,
                    DwSecurityErrorPageComponent,
                    DwNumericDirective,
                    DwCalcComponent,
                    DwMessageComponent,
                    DwBootstrapDateTimeInputComponent,
                    DwUiConfigListComponent,
                    DwBrowserAutocomplete,
                    DwContainerComponent,
                    DwMenuLinkComponent,
                    DwSecurityAvatarComponent,
                    DwSecurityUserMenuComponent,
                    DwActionGroupConfigComponent,
                    DwActionConfigComponent,
                    DwButtonConfigComponent,
                    DwActionBarComponent,
                    DwContextMenuConfigComponent,
                    DwSecurityCheckConfigComponent,
                    DwSecurityPermissionSelectComponent,
                    DwConfirmDialogConfigComponent,
                    DwTreeSelect,
                    DwClickOutsideDirective,
                    DwUiChildConfigHostComponent,
                    DwActionGroupModesConfigComponent,
                    DwValidationConfigBaseComponent,
                    DwMaxValidatorConfigComponent,
                    DwMinValidationConfigComponent,
                    DwMaxLengthValidatorConfigComponent,
                    DwPatternValidatorConfigComponent,
                    DwCountValidatorConfigComponent,
                    DwUserPasswordResetComponent,
                    DwUserChangePasswordComponent,
                    DwMenuTemplateComponent,
                    DwUserRegistrationComponent,
                    QuillEditorComponent,
                    DwSecurityTwofactorSetupComponent,
                    DwLoginSsoOptionsComponent,
                    DwFileSizePipe,
                    DwFileExtPipe,
                    DwAddSpacesPipe,
                    DwDatePipe,
                    DwDivHeightDirective,
                    DwDivColumnManagerDirective,
                    DwMissingImageDirective,
                    DwMiddleClickDirective,
                    DwStyleBuilderComponent,
                    DwPasswordComponent,
                    DwDateMultiSelectComponent,
                    DwExpandableSectionComponent,
                    DwExpandableDirective,
                    DwUiInfoDisplayComponent,
                    DwControlWrapperWithIconsComponent,
                    ColorSelectComponent,
                    DwButtonClassSelectComponent,
                    DwColorPickerComponent,
                    DwCustomDropdownComponent,
                    DwButtonDropdownComponent,
                    DwTermsOfServiceModalComponent,
                    DwFloatingLabelInputComponent,
                ],
                providers: [
                    DwUiConfigService,
                    /*  DwGridColumnDefaultRendererService,
                     DwGridColumnBooleanRendererService,
                     DwGridColumnLinkRendererService, */
                    DwUiConfigRegistryService,
                    // Add the primeng message service (you would think this would be a provider in the ToastModule, but it's not - maybe a highlevel service used in other components)
                    MessageService,
                    {
                        provide: DwUIConfigToken,
                        useFactory(configService) {
                            const uiConfig = configService.getConfig(DwUiConfigName, new DwUIConfigDefaults());
                            return uiConfig;
                        },
                        deps: [DwConfigServiceToken]
                    },
                    DwCountValidationRule,
                    DwEmailValidationRule,
                    DwMinValidationRule,
                    DwMaxValidationRule,
                    DwMaxLengthValidationRule,
                    DwPatternValidationRule,
                    DwRequiredValidationRule,
                    DwRequiredTrueValidationRule,
                    DwUrlValidationRule,
                    DwCustomValidationRule,
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule,
                    DevwareCoreModule,
                    RouterModule,
                    OrderListModule,
                    TabViewModule,
                    MenuModule,
                    DropdownModule,
                    BsDropdownModule,
                    NgbDatepickerModule, NgbTimepickerModule, NgbPopoverModule,
                    TriStateCheckboxModule,
                    SelectButtonModule,
                    InputSwitchModule,
                    CalendarModule,
                    ToastModule,
                    ProgressBarModule,
                    DialogModule,
                    ButtonsModule,
                    //EditorModule,
                    //PasswordModule,
                    ContextMenuModule,
                    TreeModule,
                    // QuillModule,
                    AccordionModule,
                    InfiniteScrollModule,
                    SplitterModule,
                    InputTextModule,
                    ColorPickerModule,
                    CaptchaModule
                ],
                exports: [
                    DwLoginComponent,
                    DwLoginPageComponent,
                    DwSecurityInfoComponent,
                    DwGridComponent,
                    DwGridConfigComponent,
                    DwRowDirective,
                    DwColDirective,
                    DwInputComponent,
                    DwInputReadOnlyComponent,
                    DwYesNoComponent,
                    DwRadioListComponent,
                    DwButtonBarComponent,
                    DwSelectComponent,
                    DwAppSidebarNavComponent,
                    DwAppSidebarNavItemComponent,
                    DwAppSidebarNavLinkComponent,
                    DwAppSidebarNavDropdownComponent,
                    DwAppSidebarNavTitleComponent,
                    DwNavDropdownDirective,
                    DwNavDropdownToggleDirective,
                    DwUiConfigPanelComponent,
                    DwFormComponent,
                    DwComponentHost,
                    DwMessageBarComponent,
                    DwMessageComponent,
                    DwModalHostComponent,
                    DwButtonComponent,
                    DwActionHostComponent,
                    DwHtmlViewComponent,
                    DwDataListComponent,
                    DwCardItemDirective,
                    DwListItemDirective,
                    DwNoItemsDirective,
                    DwPillsDisplayDirective,
                    DwReadOnlyControlComponent,
                    DwRouterParentComponent,
                    DwDateInputControlComponent,
                    DwDateInputControl2Component,
                    DwDateRangeInputComponent,
                    DwPillsComponent,
                    DwValidationInfo,
                    DwHtmlEditComponent,
                    DwUrlReadOnlyControlComponent,
                    DwLoadingComponent,
                    DwEvenColumnRowComponent,
                    DwSsoLoginComponent,
                    DwDynamicLoaderComponent,
                    DwDynamicHostDirective,
                    DwNumericDirective,
                    DwCalcComponent,
                    DwUiConfigListComponent,
                    DwBrowserAutocomplete,
                    DwContainerComponent,
                    DwMenuLinkComponent,
                    DwSecurityAvatarComponent,
                    DwSecurityUserMenuComponent,
                    DwActionGroupConfigComponent,
                    DwActionConfigComponent,
                    DwActionBarComponent,
                    DwTreeSelect,
                    DwClickOutsideDirective,
                    DwUiChildConfigHostComponent,
                    DwSecurityCheckConfigComponent,
                    DwActionGroupModesConfigComponent,
                    DwValidationConfigBaseComponent,
                    DwMaxValidatorConfigComponent,
                    DwMinValidationConfigComponent,
                    DwCountValidatorConfigComponent,
                    DwMenuTemplateComponent,
                    DwUserPasswordResetComponent,
                    DwUserChangePasswordComponent,
                    DwMenuTemplateComponent,
                    DwUserRegistrationComponent,
                    DwSecurityPermissionSelectComponent,
                    QuillEditorComponent,
                    DwFileSizePipe,
                    DwFileExtPipe,
                    DwAddSpacesPipe,
                    DwDatePipe,
                    DwDivHeightDirective,
                    DwDivColumnManagerDirective,
                    DwMissingImageDirective,
                    DwMiddleClickDirective,
                    DwDateMultiSelectComponent,
                    DwExpandableSectionComponent,
                    DwExpandableDirective,
                    DwUiInfoDisplayComponent,
                    DwControlWrapperWithIconsComponent,
                    ColorSelectComponent,
                    DwColorPickerComponent,
                    DwButtonDropdownComponent,
                    DwFloatingLabelInputComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareOrmModule, { imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule, DevwareCoreModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareOrmModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    DevwareCoreModule,
                ],
                providers: [
                    // DevwareMetaDataService,
                    {
                        provide: DwOrmDataServiceToken,
                        useClass: DwOrmDataService
                    },
                    {
                        provide: DwMetaDataServiceToken,
                        useClass: DwMetaDataService
                    },
                    {
                        provide: DwReportingServiceToken,
                        useClass: DwReportingService
                    },
                ],
                exports: [],
                entryComponents: []
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTermsOfServiceManagerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwSecurityStateService }, { type: DwModalService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDefaultLayoutComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-layout',
                template: "<dw-app-header [fixed]=\"true\" [sidebarToggler]=\"'lg'\" [mobileAsideMenuToggler]=\"'sm'\" [asideMenuToggler]=\"'lg'\">\r\n\r\n    <div navbarBrand style=\"display:inline-flex\">\r\n        <div class=\"pull-left\">\r\n            <a class2=\"navbar-brand\" [routerLink]=\"'/'\">\r\n                <div class=\"dw-logo\"></div>\r\n                <ng-content select=\"[logo]\"></ng-content>\r\n            </a>\r\n        </div>\r\n    </div>\r\n    <div topMenu style=\"display:inline-flex\">\r\n        <div style=\"display:inline-flex\">\r\n            <ng-content select=\"[topMenu]\"></ng-content>\r\n        </div>\r\n        <div style=\"display:inline-flex\">\r\n            <dw-top-menu category=\"top-menu\"></dw-top-menu>\r\n        </div>\r\n    </div>\r\n    <div topRight style=\"display:inline-flex;\">\r\n        <ng-content select=\"[topRight]\"></ng-content>\r\n    </div>\r\n    <div securityInfo style=\"display:inline-flex\">\r\n        <dw-security-info></dw-security-info>\r\n        <dw-message-bar showToasts=\"true\"></dw-message-bar>\r\n    </div>\r\n\r\n</dw-app-header>\r\n\r\n<div class=\"app-body\">\r\n    <app-sidebar [fixed]=\"true\" [display]=\"false\" [display]=\"'lg'\" [minimized]=\"sidebarMinimized\">\r\n        <ng-content select=\"[sideBarTop]\"></ng-content>\r\n        <dw-side-menu></dw-side-menu>\r\n        <app-sidebar-nav perfectScrollbar disabled=\"sidebarMinimized\"></app-sidebar-nav>\r\n        <ng-content select=\"[sideBarBottom]\"></ng-content>\r\n        <app-sidebar-minimizer *ngIf=\"!hideSideBarMinimizer\"></app-sidebar-minimizer>\r\n    </app-sidebar>\r\n\r\n    <main class=\"main\">\r\n        <dw-breadcrumb>\r\n            <div breadcrumb>\r\n                <ng-content select=\"[breadcrumb]\"></ng-content>\r\n            </div>\r\n        </dw-breadcrumb>\r\n        <dw-message-bar showRequestCounts=\"true\"></dw-message-bar>\r\n\r\n        <dw-angular-version-checker></dw-angular-version-checker>\r\n\r\n        <div class=\"container-fluid\">\r\n            <ng-container *ngIf=\"showLoginProcess\">\r\n                <dw-message *ngIf=\"showError\" [message]=\"message\"></dw-message>\r\n                <ng-container *ngIf=\"!showRouterOutlet\">\r\n                    <div class=\"security-message-box\">\r\n                        <h2><img src=\"/assets/img/loader2.gif\" /> {{securityMessage }}</h2>\r\n                    </div>\r\n                </ng-container>\r\n            </ng-container>\r\n\r\n            <div class=\"logout-message-container\" [hidden]=\"!logoutMessage\">\r\n                <dw-message [(message)]=\"logoutMessage\"></dw-message>\r\n            </div>\r\n\r\n            <ng-container *ngIf=\"showRouterOutlet || !hideRouterOutletOnLogin || alwaysShowRouterRoutlet\">\r\n                <router-outlet></router-outlet>\r\n            </ng-container>\r\n<!-- \r\n            Outlet Shown: {{showRouterOutlet || !hideRouterOutletOnLogin || alwaysShowRouterRoutlet}} <br><br>\r\n                        \r\n            Show outlet: {{showRouterOutlet}} <br>\r\n            hide on Login {{ hideRouterOutletOnLogin }} <br>\r\n            Always show {{ alwaysShowRouterRoutlet }} <br> -->\r\n        </div>\r\n\r\n    </main>\r\n\r\n    <app-aside [fixed]=\"true\" display2=\"'lg'\" [display]=\"false\">\r\n        <dw-ui-config-panel></dw-ui-config-panel>\r\n    </app-aside>\r\n</div>\r\n\r\n<dw-modal-host *ngIf=\"showModalHost\"></dw-modal-host>\r\n\r\n<app-footer fixed=\"false\" *ngIf=\"uiConfig.showFooter\">\r\n    <a href=\"https://www.devwareapps.com\" target=\"_blank\" ral=\"noopener\" *ngIf=\"uiConfig.showDevwareLogo\">\r\n        <img src=\"/assets/img/brand/footer-logo.png\" class=\"logo-footer\" />\r\n    </a>\r\n</app-footer>\r\n"
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwSecurityStateService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }, { type: DwMessagingService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwEventService }, { type: DwModalService }, { type: DwTermsOfServiceManagerService }]; }, { showLoginProcess: [{
            type: Input
        }], hideRouterOutletOnLogin: [{
            type: Input
        }], sidebarMinimized: [{
            type: Input
        }], hideSideBarMinimizer: [{
            type: Input
        }], bodyClasses: [{
            type: Input
        }], showLogoutMessageDialog: [{
            type: Input
        }], showLogoutMessage: [{
            type: Input
        }] }); })();
const ɵDwTopMenu_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwTopMenu);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTopMenu, [{
        type: Component,
        args: [{
                selector: 'dw-top-menu',
                template: `
	<div id='topMenu' class="top-menu-container">
		 <div class="nav-item pull-left" *ngFor="let menu of routeHierarchy" [routerLinkActive]="['link-active']">
		 	<dw-menu-link [menu]="menu" className="nav-link" [menuLocation]="'top'"></dw-menu-link>
		</div>
	</div>
  `
            }]
    }], null, null); })();
const ɵDwSideMenu_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwSideMenu);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSideMenu, [{
        type: Component,
        args: [{
                selector: 'dw-side-menu',
                template: `
        <ng-container *ngIf="!replacementSideMenu">
            <dw-app-sidebar-nav [navItems]="routeHierarchy" perfectScrollbar disabled="sidebarMinimized"></dw-app-sidebar-nav> 
        </ng-container>
        <ng-container *ngIf="replacementSideMenu && !hasSideComponent">
            <ul class="replacement-nav" *ngIf="!replacementSideMenu.hideBackMenu">
                <li class="nav-item">
                    <dw-menu-link [menu]="backMenu" [menuLocation]="'side-bar-back'"></dw-menu-link>
                </li>
        
                <div class="menu-parent-header" [ngClass]="{ 'nav-link' : !replacementSideMenu.parentMenu.navigateToFirstChild }" [routerLink]="replacementSideMenu.parentMenu.url">{{ replacementSideMenu.parentMenu.display }}</div>
            </ul>

            <dw-app-sidebar-nav [navItems]="replacementSideMenu.replacementMenus" perfectScrollbar disabled="sidebarMinimized">
            
            </dw-app-sidebar-nav> 
        </ng-container>
        <ng-container *ngIf="replacementSideMenu && hasSideComponent">
            <!--Use Side Menu Component: {{ replacementSideMenu.sideMenuComponent || 'None' }}-->
            <ul class="replacement-nav" *ngIf="!replacementSideMenu.hideBackMenu">
                <li class="nav-item">
                   <dw-menu-link [menu]="backMenu" [menuLocation]="'side-bar-back'"></dw-menu-link>
                </li>
                <dw-dynamic-loader [componentName]="replacementSideMenu.sideMenuComponent"
                (configure)="configureSideMenuComponent($event)"></dw-dynamic-loader>
            </ul>

        </ng-container>
    `
            }]
    }], null, null); })();
const ɵDwBreadcrumbMenuComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwBreadcrumbMenuComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwBreadcrumbMenuComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-breadcrumb',
                template: `
<div class="breadcrumb-container hide-print-item" style2="display:flex;flex-wrap:wrap;background-color:white;border-bottom:1px solid #c8ced3;height:45px;margin-bottom:1.5rem">
    
        <ol class="breadcrumb">
            <li class="breadcrumb-item" *ngFor="let breadcrumb of breadCrumbs; last as last, index as i" 
                [ngClass]="{active: last, 'hide-mobile' : hideMobile(breadcrumb, i) }">
                <a *ngIf="!last" [routerLink]="breadcrumb.finalUrl">{{breadcrumb.breadcrumbDisplay}}</a>
                <span *ngIf="last" [routerLink]="breadcrumb.finalUrl">{{breadcrumb.breadcrumbDisplay}}</span>
            </li>
        </ol>
    
    <div style="float:left;width:20%" *ngIf="false">
        <ng-content select="[breadcrumb]"></ng-content>
    </div>
</div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPage404Component, [{
        type: Component,
        args: [{
                selector: 'dw-page-404',
                template: `
    <div dwRow>
      <div dwCol="5">
        <div class="alert alert-danger" style="overflow:auto">
          <i class="fas fa-exclamation-triangle fa-4x red float-left"></i>
          <div class="float-left ml-5 fa-2x">We couldn't find the page you were looking for!</div>
        </div>
      </div>
    </div>

    <button class="btn btn-success mt-2" routerLink="/">Return to Home</button>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAppHeaderComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-app-header',
                template: "<header class=\"app-header navbar\">\r\n\t<div>\r\n\t\t<div style=\"display:inline-flex\">\r\n\t\t\t<ng-template [ngIf]=\"mobileSidebarToggler != false\">\r\n\t\t\t\t<button class=\"navbar-toggler d-lg-none dw-navbar-toggler\" type=\"button\" appSidebarToggler>\r\n\t\t\t\t\t<!-- <span class=\"navbar-toggler-icon\"></span> -->\r\n\t\t\t\t\t<i class=\"fal fa-bars\"></i>\r\n\t\t\t\t</button>\r\n\t\t\t</ng-template>\r\n\r\n\t\t\t<ng-template [ngIf]=\"sidebarToggler != false\">\r\n\t\t\t\t<button class=\"navbar-toggler d-md-down-none dw-navbar-toggler\" type=\"button\" [appSidebarToggler]=\"sidebarToggler\">\r\n\t\t\t\t\t<!-- <span class=\"navbar-toggler-icon\"></span> -->\r\n\t\t\t\t\t<i class=\"fal fa-bars\"></i>\r\n\t\t\t\t</button>\r\n\t\t\t</ng-template>\r\n\t\t\t<ng-content select=\"[navbarBrand]\"></ng-content>\r\n\t\t</div>\r\n\t\t<div style=\"display:inline-flex;\">\r\n\t\t\t<div class=\"top-menu-section\">\r\n\t\t\t\t<ng-content select=\"[topMenu]\"></ng-content>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div style=\"display:inline-flex;\">\r\n\t\t\t<div class=\"top-right-section\">\r\n\t\t\t\t<ng-content select=\"[topRight]\"></ng-content>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n    <div  style=\"display:inline-flex\" >\r\n        <ng-content select=\"[securityInfo]\"></ng-content>\r\n\r\n        <ng-template [ngIf]=\"false && canConfigure && (hasConfigurations || alwaysShowConfigIcon) && asideMenuToggler != false\">\r\n            <button class=\"navbar-toggler d-md-down-none dw-toggler\" type=\"button\" [appAsideMenuToggler]=\"asideMenuToggler\">\r\n                <i class=\"dw-admin-icon fa-2x\"></i>\r\n\t\t\t\t<div class=\"dw-admin-image\"  title=\"Customize\"></div>\r\n            </button>\r\n        </ng-template>\r\n        <ng-template [ngIf]=\"false && canConfigure && (hasConfigurations || alwaysShowConfigIcon) && mobileAsideMenuToggler != false\">\r\n            <button class=\"navbar-toggler d-lg-none\" type=\"button\" appAsideMenuToggler>\r\n                <i class=\"dw-admin-icon fa-2x\"></i>\r\n                <div class=\"dw-admin-image\" title=\"Customize\"></div>\r\n            </button>\r\n        </ng-template>\r\n    </div>\r\n</header>"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwUiConfigService }]; }, { fixed: [{
            type: Input
        }], navbarBrand: [{
            type: Input
        }], navbarBrandFull: [{
            type: Input
        }], navbarBrandMinimized: [{
            type: Input
        }], sidebarToggler: [{
            type: Input
        }], mobileSidebarToggler: [{
            type: Input
        }], asideMenuToggler: [{
            type: Input
        }], mobileAsideMenuToggler: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAutoUpdateCheckerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: ɵngcc1.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AutoUpdateCheckerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-angular-version-checker',
                template: `
      <div class="alert alert-danger dw-app-update-container" [hidden]="!angularVersionHasChanges" [title]="tooltip" (click)="refreshApp()" >
        <i class="fa fa-cloud-download-alt"></i> {{ message }}
      </div> 
     `
            }]
    }], function () { return [{ type: DwAutoUpdateCheckerService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareUILayoutModule, { declarations: function () { return [DwDefaultLayoutComponent, DwTopMenu, DwSideMenu, DwBreadcrumbMenuComponent, DwPage404Component, DwPageMenu, DwAppHeaderComponent, DwMenuContentTemplateDirective, AutoUpdateCheckerComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule, DevwareCoreModule, DevwareUIModule, AppAsideModule,
        AppBreadcrumbModule,
        AppHeaderModule,
        AppFooterModule,
        AppSidebarModule,
        RouterModule,
        BsDropdownModule,
        TabsModule,
        DialogModule]; }, exports: function () { return [DwDefaultLayoutComponent, DwPage404Component, DwPageMenu, DwAppHeaderComponent, DwMenuContentTemplateDirective]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareUILayoutModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwDefaultLayoutComponent,
                    DwTopMenu,
                    DwSideMenu,
                    DwBreadcrumbMenuComponent,
                    DwPage404Component,
                    DwPageMenu,
                    DwAppHeaderComponent,
                    DwMenuContentTemplateDirective,
                    AutoUpdateCheckerComponent
                ],
                providers: [],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    DevwareCoreModule,
                    DevwareUIModule,
                    AppAsideModule,
                    AppBreadcrumbModule,
                    AppHeaderModule,
                    AppFooterModule,
                    AppSidebarModule,
                    RouterModule,
                    BsDropdownModule,
                    TabsModule,
                    DialogModule,
                ],
                exports: [
                    DwDefaultLayoutComponent,
                    DwPage404Component,
                    DwPageMenu,
                    DwAppHeaderComponent,
                    DwMenuContentTemplateDirective
                ],
                entryComponents: [
                    DwDefaultLayoutComponent,
                    DwPage404Component,
                    DwPageMenu
                ]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityCheckService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwSecurityUserService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataActionConfigService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwSecurityCheckService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataActionExpressionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwExpressionStateService }, { type: DwUiConfigRegistryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridActionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwActionConfigService }, { type: DwActionMenuBuilderService }, { type: DwMetaDataActionConfigService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataActionExpressionService }]; }, null); })();
const ɵDwGridColumnBooleanConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwGridColumnBooleanConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnBooleanConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-column-boolean-config',
                template: "<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Yes Icon Class</label>\r\n       <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.yesIconClass\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Yes Display Value</label>\r\n       <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.yesDisplayValue\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<hr>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">No Icon Class</label>\r\n       <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.noIconClass\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">No Display Value</label>\r\n       <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.noDisplayValue\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<hr>\r\n<!-- <div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Blank Icon Class</label>\r\n       <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.blankIconClass\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Blank Display Value</label>\r\n       <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.blankDisplayValue\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div> -->\r\n"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnBooleanRendererService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnDefaultRendererService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridService, [{
        type: Injectable
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataRoutingService }, { type: DwUiConfigService }, { type: DwCacheService }, { type: DwMessagingService }, { type: DwMetaDataGridActionService }, { type: DwActionConfigService }, { type: DwSecurityCheckService }, { type: DwUiConfigRegistryService }, { type: DwSecurityUserService }, { type: DwContextService }, { type: DwExpressionService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataGridConfigViewsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-metadata-grid-config-views',
                template: "<div *ngIf=\"setupComplete\">\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <label>View</label>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <div class=\"view-dropdown-container\">\r\n                <p-dropdown [options]=\"items\" [ngModel]=\"selectedItem\" (ngModelChange)=\"setSelectedItem($event)\"\r\n                    optionLabel=\"display\" [style]=\"{'width':'100%'}\" appendTo=\"body\">\r\n                    <ng-template let-item pTemplate=\"selectedItem\">\r\n                        <div>\r\n                            {{item?.display}}\r\n\r\n                            <i class=\"fas fa-star yellow hand\" [hidden]=\"!item?.value?.isDefault\"\r\n                                title=\"Initial View\"></i>\r\n                        </div>\r\n                    </ng-template>\r\n                    <ng-template let-item pTemplate=\"item\">\r\n                        <div>\r\n                            {{item?.display}}\r\n\r\n                            <i class=\"fas fa-star yellow hand\" [hidden]=\"!item?.value?.isDefault\"\r\n                                title=\"Initial View\"></i>\r\n                        </div>\r\n                    </ng-template>\r\n                </p-dropdown>\r\n            </div>\r\n            <div class=\"view-actions\">\r\n                <button type=\"button\" #menuContainer pButton icon=\"fa fa-cog\" (click)=\"menu.toggle($event)\"></button>\r\n\r\n                <p-menu #menu [popup]=\"true\" [model]=\"viewMenuItems\" appendTo=\"body\" baseZIndex=\"2000\"\r\n                    autoZIndex=\"false\"></p-menu>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <p-tabView *ngIf=\"selectedItem\" styleClass=\"dw-fixed-tabs\" [(activeIndex)]=\"tabIndex\">\r\n        <p-tabPanel header=\"Columns\"\r\n            *ngIf=\"!(selectedItem.defaults?.useDefaults && selectedItem.defaults?.defaultViewKey && (selectedItem.defaults?.useAll || selectedItem.defaults?.useColumns))\">\r\n            <dw-metadata-grid-config-columns [configContext]=\"configContext\"\r\n                [(columns)]=\"selectedItem.columnPreferences\" [gridPreferences]=\"gridPreferences\" [useColumnFlex]=\"selectedItem.useColumnFlex\"\r\n                [inlineEditEnabled]=\"selectedItem.inlineEditEnabled\">\r\n            </dw-metadata-grid-config-columns>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Filters\"\r\n            *ngIf=\"!(selectedItem.defaults?.useDefaults && selectedItem.defaults?.defaultViewKey && (selectedItem.defaults?.useAll || selectedItem.defaults?.useFilters))\">\r\n            <dw-metadata-config-filters [configContext]=\"configContext\" [(filters)]=\"selectedItem.filters\"\r\n                [initialFilterKey]=\"initialFilterKey\" showAdditionalTab=\"true\">\r\n                <div additionalTab>\r\n                    <p-accordion>\r\n                        <p-accordionTab header=\"View Options\" [selected]=\"true\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Filter Tiles</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.useFilterTiles\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </p-accordionTab>\r\n                        <p-accordionTab header=\"Grid Filter Options\" [selected]=\"true\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Show Filter On Load</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"gridPreferences.showFilterOnLoad\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Side Filters</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"gridPreferences.useSideFilters\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Show Clear Filter</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"gridPreferences.showClearFilter\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Auto Filter</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"gridPreferences.autoFilter\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow [hidden]=\"!gridPreferences.autoFilter\">\r\n                                <div dwCol=\"6\">\r\n                                    <label>Auto Filter Delay</label>\r\n                                </div>\r\n                                <div dwCol=\"6\">\r\n                                    <input type=\"number\" [(ngModel)]=\"gridPreferences.autoFilterDelay\"\r\n                                        class=\"form-control\">\r\n                                </div>\r\n                            </div>\r\n                        </p-accordionTab>\r\n                    </p-accordion>\r\n                </div>\r\n            </dw-metadata-config-filters>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Filter Tiles\"\r\n            *ngIf=\"selectedItem.useFilterTiles && !(selectedItem.defaults?.useDefaults && selectedItem.defaults?.defaultViewKey && (selectedItem.defaults?.useAll || selectedItem.defaults?.useFilterTiles))\">\r\n\r\n            <dw-metadata-filter-tiles-config [configContext]=\"configContext\"\r\n                [(tileConfig)]=\"selectedItem.filterTilesConfig\"\r\n                [initialFilterTileKey]=\"initialFilterTileKey\"></dw-metadata-filter-tiles-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Actions\"\r\n            *ngIf=\"selectedItem.useCustomActions && !(selectedItem.defaults?.useDefaults && selectedItem.defaults?.defaultViewKey && (selectedItem.defaults?.useAll || selectedItem.defaults?.useActions))\">\r\n\r\n            <dw-metadata-grid-actions-config [configContext]=\"configContext\"\r\n                [(actionPreferencesByMode)]=\"selectedItem.actionPreferences\"\r\n                (actionPreferenceByModeChange)=\"updateActionPreferences($event)\"\r\n                [inlineEditEnabled]=\"selectedItem.inlineEditEnabled\">\r\n            </dw-metadata-grid-actions-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Export\"\r\n            *ngIf=\"selectedItem.useCustomExport && !(selectedItem.defaults?.useDefaults && selectedItem.defaults?.defaultViewKey && (selectedItem.defaults?.useAll || selectedItem.defaults?.useExport))\">\r\n\r\n            <dw-export-config [configContext]=\"configContext\" [(exportConfig)]=\"selectedItem.exportConfig\"\r\n                [gridColumnPreferences]=\"selectedItem.columnPreferences\">\r\n            </dw-export-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"View Properties\">\r\n            <p-accordion>\r\n                <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>View Display</label>\r\n                            <input type=\"text\" [(ngModel)]=\"selectedItem.display\" class=\"form-control\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>View Key</label>\r\n                            <input type=\"text\" [(ngModel)]=\"selectedItem.key\" class=\"form-control\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>View Icon</label>\r\n                            <input type=\"text\" [(ngModel)]=\"selectedItem.iconCss\" class=\"form-control\">\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Customizations\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Customize Actions</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.useCustomActions\"\r\n                                        (ngModelChange)=\"changeUseCustomActions($event)\">\r\n                                    </p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Flex Columns</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.useColumnFlex\"\r\n                                        (ngModelChange)=\"updateFlexColumns($event)\">\r\n                                    </p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow *ngIf=\"selectedItem.useCustomActions\">\r\n                        <div dwCol=\"6\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Show Row Actions on Right</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.showRowActionsOnRight\"\r\n                                        (ngModelChange)=\"changeUseCustomActions($event)\">\r\n                                    </p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"12\">\r\n                                    <label>Action Column Header</label>\r\n                              \r\n                                    <input [(ngModel)]=\"selectedItem.actionColumnHeader\" class=\"form-control\">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Data Source\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Data Source</label>\r\n                            <select [(ngModel)]=\"selectedItem.dataSourceName\" (ngModelChange)=\"updateDataSourceInfo()\"\r\n                                class=\"form-control\">\r\n                                <option [ngValue]=\"null\">Default</option>\r\n                                <option *ngFor=\"let dataSource of dataSources\" [ngValue]=\"dataSource.keyName\">\r\n                                    {{dataSource.display}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Query</label>\r\n                            <select [(ngModel)]=\"selectedItem.metaDataQueryMeaning\"\r\n                                (ngModelChange)=\"updateDataSourceInfo()\" class=\"form-control\">\r\n                                <option [ngValue]=\"null\">\r\n                                    Default\r\n                                </option>\r\n                                <option *ngFor=\"let query of queries\" [ngValue]=\"query.QueryMeaning\">\r\n                                    {{query.QueryName}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Additional Filter <i class=\"fa fa-info-circle\"\r\n                                    title=\"Use this to apply a filter to all filter tiles and the grid\"></i></label>\r\n                            <dw-expression-picker-control [(ngModel)]=\"selectedItem.sharedFilterExpression\"\r\n                                [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\"\r\n                                [queryMeaning]=\"configContext?.metaDataQueryMeaning\">\r\n                            </dw-expression-picker-control>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Load all fields <i class=\"fa fa-info-circle\"\r\n                                            title=\"Loads all fields in the table even if they aren't displayed.\"></i></label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.includeAllFields\">\r\n                                    </p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"9\">\r\n                                    <label>Distinct Rows Only <i class=\"fa fa-info-circle\"\r\n                                            title=\"Only include distinct rows\"></i></label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.distinctRowsOnly\">\r\n                                    </p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Context Data</label>\r\n                            <p-multiSelect [options]=\"contextDefs\" [(ngModel)]=\"gridPreferences.contextNames\"\r\n                                (ngModelChange)=\"updateContextNames()\" optionLabel=\"contextDisplay\"\r\n                                optionValue=\"contextName\" display=\"chip\" [style]=\"{'width':'100%'}\" appendTo=\"body\"\r\n                                baseZIndex=\"2000\">\r\n                            </p-multiSelect>\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Defaults\" *ngIf=\"items?.length > 1\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"4\">\r\n                            <div dwCol=\"9\">\r\n                                <label>Use Defaults</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useDefaults\"\r\n                                    (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                        <div dwCol=\"4\" *ngIf=\"selectedItem.defaults.useDefaults\">\r\n                            <label>Primary Grid View</label>\r\n                            <div class=\"view-dropdown-container\">\r\n                                <select [(ngModel)]=\"selectedItem.defaults.defaultViewKey\" class=\"form-control\">\r\n                                    <ng-container *ngFor=\"let view of items\">\r\n                                        <option [ngValue]=\"view.key\"\r\n                                            [hidden]=\"view.key == selectedItem.key || view.defaults?.useDefaults\">\r\n                                            {{view.display}}\r\n                                        </option>\r\n                                    </ng-container>\r\n                                </select>\r\n                            </div>\r\n                            <div class=\"view-actions\">\r\n                                <button type=\"button\" #menuContainer2 pButton icon=\"fa fa-copy\" title=\"Copy from view\"\r\n                                    (click)=\"menu2.show($event)\"></button>\r\n\r\n                                <p-menu #menu2 [popup]=\"true\" [model]=\"copyDefaultsMenuItems\" appendTo=\"body\"\r\n                                    baseZIndex=\"2000\" autoZIndex=\"false\"></p-menu>\r\n                            </div>\r\n                        </div>\r\n                        <div dwCol=\"4\"\r\n                            *ngIf=\"selectedItem.defaults.useDefaults && selectedItem.defaults.defaultViewKey\">\r\n\r\n                            <div dwCol=\"9\">\r\n                                <label>Use All</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useAll\" (ngModelChange)=\"onChange()\">\r\n                                </p-inputSwitch>\r\n                            </div>\r\n\r\n                        </div>\r\n                    </div>\r\n                    <ng-container\r\n                        *ngIf=\"selectedItem.defaults.useDefaults && selectedItem.defaults.defaultViewKey && !selectedItem.defaults.useAll\">\r\n                        <div dwRow>\r\n\r\n                            <div dwCol=\"3\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Columns</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useColumns\"\r\n                                        (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Filters</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useFilters\"\r\n                                        (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Filter Tiles</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useFilterTiles\"\r\n                                        (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Actions</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useActions\"\r\n                                        (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Use Export Options</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch [(ngModel)]=\"selectedItem.defaults.useExport\"\r\n                                        (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Security/Visibility\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"9\">\r\n                            <label>Require Authentication</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"selectedItem.requireAuthentication\"\r\n                                (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow *ngIf=\"selectedItem.requireAuthentication\">\r\n                        <div dwCol=\"12\">\r\n                            <label>Permission</label>\r\n                            <dw-security-permission-select name=\"permission\"\r\n                                [(ngModel)]=\"selectedItem.permissionMeaning\" (ngModelChange)=\"onChange()\">\r\n                            </dw-security-permission-select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Visible Expression <i class=\"fa fa-info-circle\"\r\n                                    title=\"Use this to apply additional rules for when this view should be displayed\"></i></label>\r\n                            <dw-expression-picker-control [(ngModel)]=\"selectedItem.viewVisisbleExpression\"\r\n                                [contextNames]=\"configContext?.contextNames\">\r\n                            </dw-expression-picker-control>\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Export Options\"\r\n                    *ngIf=\"!(selectedItem.defaults?.useDefaults && selectedItem.defaults?.defaultViewKey && (selectedItem.defaults?.useAll || selectedItem.defaults?.useExport))\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"9\">\r\n                            <label>Customize Export</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"selectedItem.useCustomExport\" (ngModelChange)=\"onChange()\">\r\n                            </p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow [hidden]=\"selectedItem.useCustomExport\">\r\n                        <div dwCol=\"9\">\r\n                            <label>Export only Displayed Columns</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"selectedItem.exportOnlyDisplayedColumns\"\r\n                                (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Inline Editing Options\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"9\">\r\n                            <label>Allow Inline Editing</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"selectedItem.inlineEditEnabled\">\r\n                            </p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                    <ng-container *ngIf=\"selectedItem.inlineEditEnabled\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"9\">\r\n                                <label>Inline Editing Mode</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <select [(ngModel)]=\"selectedItem.inlineEditMode\" class=\"form-control\">\r\n                                    <option value=\"fullRow\">Full Row</option>\r\n                                    <option value=\"individualCell\">Individual Cells</option>\r\n                                    <option value=\"allRows\">All Rows</option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow>\r\n                            <div dwCol=\"9\">\r\n                                <label>Start in Edit Mode</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"selectedItem.startInEditMode\">\r\n                                </p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow>\r\n                            <div dwCol=\"9\">\r\n                                <label>Use Pop-up editor</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"selectedItem.inlineEditUsePopup\">\r\n                                </p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n                </p-accordionTab>\r\n            </p-accordion>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [".view-dropdown-container{float:left;width:calc(100% - 50px)}.view-actions{float:left;padding-left:4px;width:50px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataGridService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataGridActionService }, { type: DwUiConfigRegistryService }, { type: DwContextService }]; }, { orderList: [{
            type: ViewChild,
            args: [OrderList]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridConfigWidgetComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-grid-config',
                template: "<div>\r\n    <h3>Grid Preferences</h3>\r\n\r\n    <form [formGroup]=\"configForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Basic Settings\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Enable Sorting</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"enableSorting\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>use Modal</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"useModal\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Key</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hidePrimaryKey\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Display value</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showDisplayProperties\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Footer</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showFooter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow *ngIf=\"configForm?.value?.showFooter\">\r\n                    <div dwCol=\"9\">\r\n                        <label>Load Total Row Count</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"loadTotalRowCount\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Views\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configViews()\" class=\"btn btn-success\">Configure Views</button>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Columns\" *ngIf=\"false\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configColumns()\" class=\"btn btn-success\">Configure Columns</button>\r\n                    </div>\r\n                </div> \r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Filtering Options\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Filter On Load</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showFilterOnLoad\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Use Side Filter</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"useSideFilters\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Clear Filter</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showClearFilter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Auto Filter</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"autoFilter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\"> \r\n                        <label>Filter Delay</label>\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <input type=\"number\" formControlName=\"autoFilterDelay\" class=\"form-control\">\r\n                    </div> \r\n                </div>\r\n                <div dwRow *ngIf=\"false\">\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configFilters()\" class=\"btn btn-success\">Configure Filters</button>\r\n                    </div>\r\n                </div>\r\n                <div dwRow *ngIf=\"false\">\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configAdvancedFilters()\" class=\"btn btn-success\">Configure Filters</button>\r\n                    </div>\r\n                </div>\r\n\t\t\t</p-accordionTab>\r\n\t\t\t<p-accordionTab header=\"Action Defaults\">\r\n                <div class=\"alert alert-warning\" *ngIf=\"hasCustomActions\">\r\n                    Selected View is overriding these settings! \r\n                </div>\r\n\t\t\t\t<div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Edit Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideEditButton\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show View Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showViewButton\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n\t\t\t\t<div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Delete Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideDeleteButton\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Add Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideAdd\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Refresh Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideRefresh\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Export Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideExport\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Allow Row Select</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"allowRowSelect\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow *ngIf=\"configForm?.value?.allowRowSelect\">\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Checkbox</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"useCheckboxSelection\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab> \r\n            <p-accordionTab header=\"Styling\">\r\n                <div formGroupName=\"gridStyle\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Grid Style</label>\r\n                            <select formControlName=\"gridStyleName\" class=\"form-control\">\r\n                                <option *ngFor=\"let item of gridStyles\" [ngValue]=\"item.keyName\">\r\n                                    {{item.display}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Grid Height Mode</label>\r\n                            <select formControlName=\"gridHeightMode\" class=\"form-control\">\r\n                                <option *ngFor=\"let mode of gridHeightModes\" [ngValue]=\"mode.value\">{{mode.display}}</option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Grid Height</label>\r\n                            <input type=\"text\" formControlName=\"gridHeight\" class=\"form-control\" />\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Row Height</label>\r\n                            <input type=\"text\" formControlName=\"rowHeight\" dwNumeric class=\"form-control\" />\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Header Height</label>\r\n                            <input type=\"text\" formControlName=\"headerHeight\" dwNumeric class=\"form-control\" />\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <div dwCol=\"9\">\r\n                                <label>Customize Action Column</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch formControlName=\"actionColumnUseCustomWidth\"></p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow *ngIf=\"configForm?.value?.gridStyle?.actionColumnUseCustomWidth\">\r\n                        <div dwCol=\"12\">\r\n                            <label>Action Column Width (px)</label>\r\n                            <input type=\"text\" formControlName=\"actionColumnWidth\" dwNumeric class=\"form-control\" />\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </form>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwEventService }, { type: DwModalService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataGridService }, { type: DwDesignerStateService }, { type: DwUiConfigService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryFilterConverterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwExpressionService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFilterTileService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwQueryFilterConverterService }, { type: DwContextService }, { type: DwExpressionService }, { type: ɵngcc2.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFilterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwUiConfigRegistryService }, { type: DwFilterTileService }, { type: ɵngcc2.Router }, { type: ɵngcc0.Injector }, { type: DwContextService }, { type: DwExpressionService }, { type: DwQueryFilterConverterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFilterStateService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-meta-data-grid',
                template: "<div #container2 (contextmenu)=\"onContextMenu(false, null, $event)\" class=\"dw-grid\" dwPageDesignerSelector [configKey]=\"gridConfig?.configKey\" [sectionKey]=\"selectedViewKey\">\r\n    <div>\r\n        <dw-loading [show]=\"!gridConfig && !errorMessage\" text=\"Configuring Grid\"></dw-loading>\r\n        <div *ngIf=\"errorMessage\" class=\"alert alert-danger\">\r\n            {{errorMessage}}\r\n        </div>\r\n        <dw-message [(message)]=\"gridMessage\"></dw-message>\r\n    </div>\r\n\r\n    <dw-action-host></dw-action-host>\r\n\r\n    <div *ngIf=\"gridConfig && gridConfig.accessErrorMessage\">\r\n        <h1><i class=\"fa fa-lock fa-2x\"></i> {{gridConfig.accessErrorMessage}}</h1>\r\n    </div>\r\n\r\n    <div *ngIf=\"gridConfig && gridConfig.canAccess\" #gridContainer [ngClass]=\"{ 'dw-grid-with-views' : gridConfig?.views?.length > 1 }\">\r\n\r\n        <!-- <dw-dependency-view [item]=\"item\" [configPreferenecs]=\"preferences\"></dw-dependency-view> -->\r\n\r\n\r\n        <dw-grid [gridConfig]=\"gridConfig\"  [configContext]=\"configContext\" [resolvedContext]=\"gridConfig.resolvedContext\" (triggerContextMenu)=\"onContextMenu(true, null, $event)\" [data]=\"dataSource\" [filters]=\"filters\" (gridReady)=\"gridReady($event)\" (filtersApplied)=\"filtersApplied($event)\" (filtersCleared)=\"filtersCleared($event)\"\r\n            (gridEvent)=\"onGridEvent($event)\">\r\n\r\n            <div filterTiles *ngIf=\"gridConfig?.selectedView?.gridViewPreferences?.useFilterTiles\">\r\n                <dw-metadata-filter-tiles [configKey]=\"gridConfig?.configKey\" [viewKey]=\"selectedViewKey\" [configContext]=\"configContext\" [tilesConfig]=\"gridConfig?.filterTilesConfig\" [sharedFilterExpression]=\"gridConfig.sharedFilterExpression\"></dw-metadata-filter-tiles>\r\n            </div>\r\n            <div filter *ngIf=\"gridConfig.showFilter\">\r\n                <dw-metadata-filters [configKey]=\"gridConfig?.configKey\" [viewKey]=\"selectedViewKey\" [configContext]=\"configContext\" [configKeyPart]=\"configKeyPart\" [filterConfig]=\"gridConfig.filters\" [sharedFilterExpression]=\"gridConfig.sharedFilterExpression\"></dw-metadata-filters>\r\n            </div>\r\n            <div rightPanel>\r\n                <dw-metadata-filters-vertical [configContext]=\"configContext\" [configKeyPart]=\"configKeyPart\" [filterConfig]=\"gridConfig.filters\" [sharedFilterExpression]=\"gridConfig.sharedFilterExpression\"></dw-metadata-filters-vertical>\r\n            </div>\r\n            <ng-container actions>\r\n                <div class=\"dw-grid-view\" [hidden]=\"gridConfig.views?.length===1\" #actions>\r\n                    <p-dropdown  [options]=\"gridConfig.views\" optionLabel=\"display\" optionValue=\"key\" [(ngModel)]=\"selectedViewKey\" (ngModelChange)=\"setView($event)\" [filter]=\"true\" [style]=\"{'width':'100%'}\" appendTo=\"body\">\r\n                    </p-dropdown>\r\n                </div>\r\n            </ng-container>\r\n        </dw-grid> \r\n    </div>\r\n       <p-contextMenu #cmGrid [target]=\"container2\" [model]=\"gridContextMenu\" \r\n            appendTo=\"body\"></p-contextMenu>\r\n</div>\r\n<!--{{ChangeDetectionCount}}-->\r\n\r\n",
                providers: [DwMetaDataFilterStateService]
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataGridService }, { type: DwUiConfigService }, { type: DwEventService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwMetaDataFilterService }, { type: DwActionExecutionService }, { type: DwMetaDataGridActionService }, { type: DwMetaDataActionExpressionService }, { type: ɵngcc2.Router }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }, { type: DwMetaDataFilterStateService }, { type: DwContextService }]; }, { ignoreAddEditEvents: [{
            type: Input
        }], gridEvent: [{
            type: Output
        }], configKeyPart: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], externalFilters: [{
            type: Input,
            args: ['filters']
        }], dataSource: [{
            type: Input
        }], item: [{
            type: Input
        }], addContext: [{
            type: Input
        }], gridCallbacks: [{
            type: Input
        }], dwGrid: [{
            type: ViewChild,
            args: [DwGridComponent, { static: false }]
        }], cmGrid: [{
            type: ViewChild,
            args: ['cmGrid', { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlInputComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-input',
                template: `
    <div [formGroup]="formGroup">
      <!-- <input type="text" [formControlName]="fieldDef?.attrName" [placeholder]="fieldDef?.placeholderText || ''" [class]="inputClass" /> -->
      <dw-input [formControlName]="fieldDef?.attrName" [id]="fieldDef?.attrName" [placeholder]="fieldDef?.placeholderText || ''" [inputClass]="inputClass" [options]="fieldDef?.controlOptions"></dw-input>
    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLookupParameterUtilService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwExpressionService }, { type: DwExpressionStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-dropdown',
                template: `
    <div 
      class="dynamic-field form-input" 
      [formGroup]="formGroup">

      <span *ngIf="false && fieldDef?.attr?.MetaDataLookupParamAttribute1Name">
            Parent Field 1 : {{fieldDef?.attr?.MetaDataLookupParamAttribute1Name}}  Parent Field 2 : {{fieldDef?.attr?.MetaDataLookupParamAttribute2Name}}<br>
      </span>
      <dw-select-lookup [formControlName]="fieldDef?.attrName" [options]="fieldDef?.controlOptions" [lookupId]="lookupId" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.lookupConfig?.alternateValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName">
      </dw-select-lookup>

     
    </div>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionService }, { type: DwLookupParameterUtilService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicFieldDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwDynamicField2]'
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: ɵngcc0.ViewContainerRef }]; }, { fieldDef: [{
            type: Input
        }], formGroup: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlNumericInputComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-numeric-input',
                template: `
    <div [formGroup]="formGroup">
    <!-- <input type="text" [formControlName]="fieldDef?.attrName" [class]="inputClass" dwNumeric [decimals]="fieldDef?.attr?.Decimals" [maxlength]="fieldDef?.attr?.MaxLength || 10" [placeholder]="fieldDef?.placeholderText || ''" /> -->
    
      <dw-input [formControlName]="fieldDef?.attrName" [placeholder]="fieldDef?.placeholderText || ''" [maxlength]="fieldDef?.attr?.MaxLength || 10" [inputClass]="inputClass" [numeric]="true" [decimals]="fieldDef?.attr?.Decimals" [options]="fieldDef?.controlOptions"></dw-input>

    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlTextAreaComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-textarea',
                template: `
    <div [formGroup]="formGroup">
      <textarea [formControlName]="fieldDef?.attrName" [class]="inputClass" [placeholder]="fieldDef?.placeholderText || ''" [rows]="fieldDef?.controlOptions?.rows" [ngStyle]="style"></textarea>
    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlHtmlEditorComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-html-editor',
                template: `
    <div [formGroup]="formGroup" #container>
        <dw-html-edit [formControlName]="fieldDef?.attrName"></dw-html-edit>
    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-readonly',
                template: `
    <div [formGroup]="formGroup">

   
      <dw-readonly [formControlName]="fieldControlName" [formatType]="getFormatType()" [missingDataText]="fieldDef?.readOnlyMissingDataText || 'None'" [useGmtDateTime]="useGmtDateTime()" [use24HourTime]="use24HourTime()"></dw-readonly>
    </div>
  `
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, { useDisplayField: [{
            type: Input
        }], context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlLookupReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-lookup-readonly',
                template: `
        <div  class="dynamic-field form-input" [formGroup]="formGroup">
            <dw-lookup-readonly [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [missingDataText]="fieldDef?.readOnlyMissingDataText || 'None'" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.lookupConfig?.alternateValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName">
            </dw-lookup-readonly>   
        </div>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionService }, { type: DwLookupParameterUtilService }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlHtmlReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-html-readonly',
                template: `
    <div [formGroup]="formGroup">
        <dw-html-view [formControlName]="fieldDef?.attrName" [missingDataText]="fieldDef?.readOnlyMissingDataText || ''">
        </dw-html-view>
    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlInputYesNoDropdownComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-input-yesno-dropdown',
                template: `
    <div [formGroup]="formGroup">
      <dw-yesno [formControlName]="fieldDef?.attrName" [attr.id]="fieldDef?.attrName || ''" allowNull="true" showAsDropdown="true"></dw-yesno>
    </div>
  `
            }]
    }], null, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlUrlReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-url-readonly',
                template: `
    <div [formGroup]="formGroup">
      <dw-url-readonly [formControlName]="fieldDef?.attrName" [missingDataText]="fieldDef?.readOnlyMissingDataText || 'None'"></dw-url-readonly>
    </div>
  `
            }]
    }], null, { context: [{
            type: Input
        }] }); })();
const ɵDwFormControlSearchLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlSearchLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlSearchLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-dropdown',
                template: `
    <div 
      class="dynamic-field form-input" 
      [formGroup]="formGroup">

      <span *ngIf="false && fieldDef?.attr?.MetaDataLookupParamAttribute1Name">
            Parent Field 1 : {{fieldDef?.attr?.MetaDataLookupParamAttribute1Name}}  Parent Field 2 : {{fieldDef?.attr?.MetaDataLookupParamAttribute2Name}}<br>
      </span>
      <dw-search-select-lookup [formControlName]="fieldDef?.attrName"  [options]="fieldDef?.controlOptions" [lookupId]="lookupId" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName" [placeholder]="fieldDef?.placeholderText || ''">
      </dw-search-select-lookup>
    </div>
  `
            }]
    }], null, null); })();
const ɵDwFormControlAutoCompleteLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlAutoCompleteLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlAutoCompleteLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-autocomplete',
                template: `
    <div  class="dynamic-field form-input" [formGroup]="formGroup">
      <dw-auto-complete-lookup [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [options]="fieldDef?.controlOptions" useServerSearch="false" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName" [placeholder]="fieldDef?.placeholderText || ''">
      </dw-auto-complete-lookup>
    </div>
  `
            }]
    }], null, null); })();
const ɵDwFormControlAutoCompleteServerLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlAutoCompleteServerLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlAutoCompleteServerLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-autocomplete-server',
                template: `
    <div 
      class="dynamic-field form-input" 
      [formGroup]="formGroup">

      <dw-auto-complete-lookup [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [options]="fieldDef?.controlOptions" useServerSearch="true" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName" [placeholder]="fieldDef?.placeholderText || ''">
      </dw-auto-complete-lookup>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlCalcFieldComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-calc-field',
                template: `
    <div [formGroup]="formGroup">
      <dw-calc [formControlName]="fieldDef?.attrName" [id]="fieldDef?.attrName  || ''" [context]="context" [options]="fieldDef?.controlOptions"></dw-calc>
    </div>
  `
            }]
    }], null, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlDateFieldConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-date-field-config',
                template: `
        <div dwRow>
            <div dwCol="9">
               Set Valid Days
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.validDaysSet" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>
        <div dwRow *ngIf="controlOptions.validDaysSet">
            <div dwCol="12" >
                <label>Valid Day</label>

                <div class="form-control" style="overflow:auto; min-height:50px">
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[0]" (ngModelChange)="fieldChange($event)"> Sun
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[1]" (ngModelChange)="fieldChange($event)"> Mon
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[2]" (ngModelChange)="fieldChange($event)"> Tues
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[3]" (ngModelChange)="fieldChange($event)"> Wed
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[4]" (ngModelChange)="fieldChange($event)"> Thurs
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[5]" (ngModelChange)="fieldChange($event)"> Fri
                    <input type="checkbox" [(ngModel)]="controlOptions.validDays[6]" (ngModelChange)="fieldChange($event)"> Sat
                </div>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                Months to show
            </div>
            <div dwCol="12">
                <input type="text" class="form-control" dwNumeric [(ngModel)]="controlOptions.monthsToShow" (ngModelChange)="fieldChange($event)">
            </div>
        </div>
        <div dwRow>
            <div dwCol="9">
                Min Date of today
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.minDate.isToday" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>

        <div dwRow>
            <div dwCol="9">
                Max Date of today
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.maxDate.isToday" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>
  `
            }]
    }], function () { return []; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlCalcFieldConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-calc-field-config',
                template: `
    <div dwCol="12">
        <label>Formula</label> <i class="fas fa-info-circle info-spacer" title="Add data fields to the formula using data.FieldName.  Uses Math.js"></i>
        <textarea class="form-control formula-text" [(ngModel)]="controlOptions.formula"  (ngModelChange)="fieldChange($event)"></textarea>
    </div>
    <div dwRow>
        <div dwCol="9">
            <label>More Options</label>
        </div>
        <div dwCol="3">
            <p-inputSwitch [(ngModel)]="showMoreOptions"></p-inputSwitch>
        </div>
    </div> 
    <ng-container *ngIf="showMoreOptions">
        <div dwCol="12">
            <label>Prefix</label> 
            <input type="text" class="form-control" [(ngModel)]="controlOptions.prefix"  (ngModelChange)="fieldChange($event)"/>
        </div>
        <div dwCol="12">
            <label>Suffix</label> 
            <input type="text" class="form-control" [(ngModel)]="controlOptions.suffix"  (ngModelChange)="fieldChange($event)"/>
        </div>
        <div dwCol="12">
            <label>Decimals</label> 
            <input type="text" class="form-control" [(ngModel)]="controlOptions.decimals"  (ngModelChange)="fieldChange($event)"/>
        </div>
        <div dwCol="12">
            <label>Empty field default<i class="fas fa-info-circle info-spacer" title="Replacement value for blank fields (these will error in math.js)"></i></label> 
            <input type="text" class="form-control" [(ngModel)]="controlOptions.nullDefaultValue"  (ngModelChange)="fieldChange($event)"/>
        </div>
    </ng-container>
    <div dwRow>
        <div dwCol="9">
            <label>Show Tester</label>
        </div>
        <div dwCol="3">
            <p-inputSwitch [(ngModel)]="showTester"></p-inputSwitch>
        </div>
    </div>
    <ng-container *ngIf="showTester">
        <dw-fc-calc-tester [options]="controlOptions" [itemName]="itemName"></dw-fc-calc-tester>
    </ng-container>
  `,
                styles: [`
    .formula-text {
        height:150px !important;
    }

    .info-spacer {
        margin-left:5px;
    }
  
  `]
            }]
    }], function () { return []; }, { controlOptionsChange: [{
            type: Output
        }], controlOptions: [{
            type: Input
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
const ɵDwFormControlAutoCompleteLookupReadOnlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlAutoCompleteLookupReadOnlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlAutoCompleteLookupReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-lookup-server-readonly',
                template: `
        <div  class="dynamic-field form-input" [formGroup]="formGroup">
            <dw-autocomplete-readonly [formControlName]="fieldDef?.attrName" [missingDataText]="fieldDef?.readOnlyMissingDataText || 'None'"  [options]="fieldDef?.controlOptions" [lookupId]="lookupId" useServerSearch="true" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.lookupConfig?.alternateValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName">
            </dw-autocomplete-readonly>   
        </div>
  `
            }]
    }], null, null); })();
const ɵDwFormControlMultiSelectLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlMultiSelectLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlMultiSelectLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-multiselect',
                template: `
    <div 
      class="dynamic-field form-input" 
      [formGroup]="formGroup">

      <dw-multi-select-lookup [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName">
      </dw-multi-select-lookup>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlAutoCompleteLookupConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-autocomplete-lookup-config',
                template: `
        Options: {{controlOptions | json}}
        <div dwRow>
            <div dwCol="12">
                <label>Max Search Results</label>
                <input type="text" dwNumeric [(ngModel)]="controlOptions.maxResults" (ngModelChange)="fieldChange($event)" class="form-control" placeholder="Default"/>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                <label>Search Type</label>
                <select [(ngModel)]="controlOptions.searchType" (ngModelChange)="fieldChange($event)" class="form-control">
                    <option *ngFor="let item of searchTypes" [ngValue]="item.value">
                        {{item.display}}
                    </option>
                </select>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                <label>Search Wait Time</label>
                <input type="text" dwNumeric [(ngModel)]="controlOptions.waitTimeMs" (ngModelChange)="fieldChange($event)" class="form-control" placeholder="Default"/>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                Show chip when selected
            </div>
            <div dwCol="12">
                <dw-yesno [(ngModel)]="controlOptions.showChipWhenSelected" (ngModelChange)="fieldChange($event)"></dw-yesno>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                Show link
            </div>
            <div dwCol="12">
                <dw-yesno [(ngModel)]="controlOptions.showLink" (ngModelChange)="fieldChange($event)"></dw-yesno>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                Open in new window
            </div>
            <div dwCol="12">
                <dw-yesno [(ngModel)]="controlOptions.windowOpenOptions.openInNewWindow" (ngModelChange)="fieldChange($event)"></dw-yesno>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                New Window Target
            </div>
            <div dwCol="12">
                <input type="text" [(ngModel)]="controlOptions.windowOpenOptions.newWindowTarget" (ngModelChange)="fieldChange($event)" placeholder="_blank" class="form-control"/>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                <label>Link Toolip</label>
                <input type="text"  [(ngModel)]="controlOptions.linkTooltip" (ngModelChange)="fieldChange($event)" class="form-control"/>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                <label>Link Icon</label>
                <input type="text"  [(ngModel)]="controlOptions.linkIconClass" (ngModelChange)="fieldChange($event)" class="form-control"/>
            </div>
        </div>
  `
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlDateComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-date',
                template: `<div [formGroup]="formGroup">
        <dw-date [formControlName]="fieldDef?.attrName" showTime="false" [dateOptions]="fieldDef?.controlOptions"></dw-date>
    </div>`
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
const ɵDwFormControlDate2Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlDate2Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlDate2Component, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-date2',
                template: `<div [formGroup]="formGroup">
        <dw-date2 [formControlName]="fieldDef?.attrName" showTime="false" [dateOptions]="fieldDef?.controlOptions"></dw-date2>
    </div>`
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlDateTimeComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-date-time',
                template: `
    <div [formGroup]="formGroup">
        <dw-date [formControlName]="fieldDef?.attrName" showTime="true" [useGmtDateTime]="useGmtDateTime()" [use24HourTime]="use24HourTime()"></dw-date>
    </div>
  `
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, { context: [{
            type: Input
        }] }); })();
const ɵDwFormControlDateTime2Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlDateTime2Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlDateTime2Component, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-date-time2',
                template: `
    <div [formGroup]="formGroup">
        <dw-date2 [formControlName]="fieldDef?.attrName" showTime="true" [useGmtDateTime]="useGmtDateTime()" [use24HourTime]="use24HourTime()" [dateOptions]="fieldDef?.controlOptions"></dw-date2>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlTimeComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-time',
                template: `
    <div [formGroup]="formGroup">
        <dw-date [formControlName]="fieldDef?.attrName" showTime="true" timeOnly="true" [dateOptions]="fieldDef?.controlOptions"></dw-date>
    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
const ɵDwFormControlTime2Component_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlTime2Component);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlTime2Component, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-time2',
                template: `
    <div [formGroup]="formGroup">
        <dw-date2 [formControlName]="fieldDef?.attrName" showTime="true" timeOnly="true" [dateOptions]="fieldDef?.controlOptions"></dw-date2>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlInputConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-input-config',
                template: `
        <div dwRow>
            <div dwCol="12">
                Prefix
            </div>
            <div dwCol="12">
                <input type="text" class="form-control" [(ngModel)]="controlOptions.prefix" (ngModelChange)="fieldChange($event)">
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                Suffix
            </div>
            <div dwCol="12">
                <input type="text" class="form-control" [(ngModel)]="controlOptions.suffix" (ngModelChange)="fieldChange($event)">
            </div>
        </div>
        <div dwRow>
            <div dwCol="9">
                Browser Autocomplete Enabled
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.autoCompleteEnabled" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>
        <div dwRow *ngIf="controlOptions?.autoCompleteEnabled">
            <div dwCol="12">
                Browser Autocomplete Type
            </div>
            <div dwCol="12">
                <input type="text" class="form-control" [(ngModel)]="controlOptions.autoCompleteType" (ngModelChange)="fieldChange($event)">
            </div>
        </div>   
        <ng-container *ngIf="showNumericOptions">
            <h2>Numeric Control Options</h2> 
            <div dwRow>
                <div dwCol="12">
                    Decimals Override
                </div>
                <div dwCol="12">
                    <input dwNumeric class="form-control" [(ngModel)]="controlOptions.decimalsOverride" [placeholder]="decimalsPlaceholder">
                </div>
            </div>
            <div dwRow>
                <div dwCol="9">
                    Allow negative
                </div>
                <div dwCol="3">
                    <p-inputSwitch [(ngModel)]="controlOptions.allowNegative"></p-inputSwitch>
                </div>
            </div>
            <div dwRow>
                <div dwCol="9">
                    Format without place holder separator
                </div>
                <div dwCol="3">
                    <p-inputSwitch [(ngModel)]="controlOptions.excludeLocalNumericFormatting"></p-inputSwitch>
                </div>
            </div>
            <div dwRow>
            <div dwCol="12">
                Multiplier <i class="fa fa-info-circle" title="Converts the underlying values using this multiplier.  Use for percentages stored as decimals or converting unit of meatures"></i>
                </div>
                <div dwCol="12">
                <input dwNumeric class="form-control" [(ngModel)]="controlOptions.multiplier">
            </div>
        </div>
        </ng-container>
       
  `
            }]
    }], function () { return []; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlInputReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-input-readonly',
                template: `
    <div [formGroup]="formGroup">
      <dw-input-readonly [formControlName]="fieldDef?.attrName" [options]="fieldDef?.controlOptions" [missingDataText]="fieldDef?.readOnlyMissingDataText || 'None'"></dw-input-readonly>
    </div>
  `
            }]
    }], null, { context: [{
            type: Input
        }] }); })();
const ɵDwFormControlNumericInputReadOnlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlNumericInputReadOnlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlNumericInputReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-numeric-readonly',
                template: `
    <div [formGroup]="formGroup">
      <dw-input-readonly [formControlName]="fieldDef?.attrName" [options]="fieldDef?.controlOptions" [numeric]="true" [decimals]="fieldDef?.attr?.Decimals"></dw-input-readonly>
    </div>
  `
            }]
    }], null, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlTextAreaConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-textarea-config',
                template: `
        <div dwRow>
            <div dwCol="12">
                Rows
            </div>
            <div dwCol="12">
                <input type="text" class="form-control" [(ngModel)]="controlOptions.rows" (ngModelChange)="fieldChange($event)">
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                Height
            </div>
            <div dwCol="12">
                <input type="text" class="form-control" [(ngModel)]="controlOptions.height" (ngModelChange)="fieldChange($event)">
            </div>
        </div>
  `
            }]
    }], function () { return []; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
const ɵDwFormControlRadioLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlRadioLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlRadioLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-radio-lookup',
                template: `
    <div  class="dynamic-field form-input" [formGroup]="formGroup">
      <dw-radio-lookup [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [options]="fieldDef?.controlOptions" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName">
      </dw-radio-lookup>
    </div>
  `
            }]
    }], null, null); })();
const ɵDwFormControlMulitSelectAdhocComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlMulitSelectAdhocComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlMulitSelectAdhocComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-multi-select-adhoc',
                template: `
    <div  class="dynamic-field form-input" [formGroup]="formGroup">
      <dw-multi-select-adhoc-lookup [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [options]="fieldDef?.controlOptions" useServerSearch="false" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName" [placeholder]="fieldDef?.placeholderText || ''">
      </dw-multi-select-adhoc-lookup>
    </div>
  `
            }]
    }], null, null); })();
const ɵDwFormControlMulitSelectAdhocReadOnlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlMulitSelectAdhocReadOnlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlMulitSelectAdhocReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-multi-select-adhoc',
                template: `
    <div  class="dynamic-field form-input" [formGroup]="formGroup">
      <dw-multi-select-adhoc-readonly [formControlName]="fieldDef?.attrName" [lookupId]="lookupId" [options]="fieldDef?.controlOptions" useServerSearch="false" [paramValues]="paramValues" [overrideValues]="fieldDef?.attr?.CustomListValues" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'" [useTransitions]="fieldDef?.lookupConfig?.useTransitions" [additionalDataField]="fieldDef?.lookupConfig?.addittionalDisplayAttrName" [placeholder]="fieldDef?.placeholderText || ''">
      </dw-multi-select-adhoc-readonly>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlInputYesNoComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-input-yesno',
                template: `
    <div [formGroup]="formGroup">
      <dw-yesno [formControlName]="fieldDef?.attrName" [attr.id]="fieldDef?.attrName || ''"></dw-yesno>
    </div>
  `
            }]
    }], null, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlMultiSelectAdhocConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-autocomplete-lookup-config',
                template: `
        <div dwRow>
            <div dwCol="12">
                <label>Max Search Results</label>
                <input type="text" dwNumeric [(ngModel)]="controlOptions.maxResults" (ngModelChange)="fieldChange($event)" class="form-control"/>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                <label>Search Type</label>
                <select [(ngModel)]="controlOptions.searchType" (ngModelChange)="fieldChange($event)" class="form-control">
                    <option *ngFor="let item of searchTypes" [ngValue]="item.value">
                        {{item.display}}
                    </option>
                </select>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                <label>Search Wait Time</label>
                <input type="text" dwNumeric [(ngModel)]="controlOptions.waitTimeMs" (ngModelChange)="fieldChange($event)" class="form-control"/>
            </div>
        </div>
        <div dwRow>
            <div dwCol="9">
                Prevent Custom Add
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.preventCustomAdd" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>
  `
            }]
    }], function () { return []; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
const ɵDwDefaultListPageComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwDefaultListPageComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDefaultListPageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-default-list-page',
                template: `
  <dw-router-parent>
      <ng-template>
          <dw-content-manager [configKey]="contentConfigKey" [item]="item">
              <h1>
                  <dw-content name="title" display="Page Title" [controlType]="textboxControlType">
                  </dw-content>
              </h1>

              <dw-content name="detail" display="Header Details">
              </dw-content>

              <dw-content-component name="component" display="Custom Component"></dw-content-component>
          </dw-content-manager>
      
          <dw-meta-data-list [item]="item" [configKeyPart]="configKeyPart"></dw-meta-data-list>
      </ng-template>
  </dw-router-parent>
`
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlLookupConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-lookup-config',
                template: `
        <div dwRow>
            <div dwCol="12">
                Show link
            </div>
            <div dwCol="12">
                <dw-yesno [(ngModel)]="controlOptions.showLink" (ngModelChange)="fieldChange($event)"></dw-yesno>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                Open in new window
            </div>
            <div dwCol="12">
                <dw-yesno [(ngModel)]="controlOptions.windowOpenOptions.openInNewWindow" (ngModelChange)="fieldChange($event)"></dw-yesno>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                New Window Target
            </div>
            <div dwCol="12">
                <input type="text" [(ngModel)]="controlOptions.windowOpenOptions.newWindowTarget" (ngModelChange)="fieldChange($event)" placeholder="_blank" class="form-control"/>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                <label>Link Toolip</label>
                <input type="text"  [(ngModel)]="controlOptions.linkTooltip" (ngModelChange)="fieldChange($event)" class="form-control"/>
            </div>
        </div>
        <div dwRow [hidden]="!controlOptions.showLink">
            <div dwCol="12">
                <label>Link Icon</label>
                <input type="text"  [(ngModel)]="controlOptions.linkIconClass" (ngModelChange)="fieldChange($event)" class="form-control"/>
            </div>
        </div>
  `
            }]
    }], function () { return []; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwHtmlEditControlConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-html-edit-control-config',
                template: `
        <div dwRow>
            <div dwCol="9">
                Allow View Source
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.allowViewSource" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>
        <div dwRow>
            <div dwCol="9">
                Use Delayed Set Value <i class="fa fa-info-circle" title="Work around for quill error when setting the form control directly.  Only set to true if you run into an error"></i>
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="controlOptions.useDelayedSetValue" (ngModelChange)="fieldChange($event)"></p-inputSwitch>
            </div>
        </div>   
  `
            }]
    }], function () { return []; }, { controlOptions: [{
            type: Input
        }], controlOptionsChange: [{
            type: Output
        }], itemName: [{
            type: Input
        }], fieldConfig: [{
            type: Input
        }], attribute: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicFieldComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[dwDynamicField],dwDynamicField',
                template: `
    <div [hidden]="fieldDef?.isVisible==false"> 
      <span [hidden]="!fieldDef?.iconClass">
        <i [ngClass]="fieldDef?.iconClass"></i>&nbsp;&nbsp;
      </span>
      <label [ngClass]="labelClasses" [hidden]="fieldDef?.hideLabel">{{ fieldDef?.label }}<span class="required-label" [hidden]="!isRequired || fieldDef?.hideLabel || usingReadOnlyControl" title="Required">&nbsp;*</span> <i class="fa fa-info-circle ml-1" [hidden]="!fieldDef?.infoText" [title]="fieldDef?.infoText"></i></label>
      <span [ngClass]="dataClasses">
         <ng-template dw-component-host></ng-template>
      </span>
      <ng-container [formGroup]="formGroup">
        <dw-validation-info [formControlName]="fieldDef?.attrName" [displayName]="fieldDef?.label" [submitted]="submitted"></dw-validation-info>
      </ng-container>
    </div>

    
       <!-- Visible: {{fieldDef.isVisible}}<br>
        ReadOnly: {{fieldDef.isReadOnly}}
        Status: {{formControl?.status}}
        Required: {{isRequired}}<br> -->
       
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwExpressionService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwUiConfigRegistryService }]; }, { colSize: [{
            type: Input
        }], submitted: [{
            type: Input
        }], useDisplayFields: [{
            type: Input
        }], isRequired: [{
            type: Input
        }], recreateControlOnChange: [{
            type: Input
        }], initialFieldDef: [{
            type: Input,
            args: ['fieldDef']
        }], formGroup: [{
            type: Input
        }], context: [{
            type: Input
        }], dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlInputSwitchComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-input-switch',
                template: `
    <div [formGroup]="formGroup">
      <p-inputSwitch [formControlName]="fieldDef?.attrName"></p-inputSwitch>
    </div>
  `
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionConfigBaseComponent, [{
        type: Directive
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }]; }, { contextNames: [{
            type: Input
        }], sectionChange: [{
            type: Output
        }], section: [{
            type: Input
        }], itemName: [{
            type: Input
        }], rootItemName: [{
            type: Input
        }], itemMetaDataList: [{
            type: Input
        }], preferences: [{
            type: Input
        }] }); })();
const ɵDwMdSectionFormConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionFormConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionFormConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-md-section-form-config',
                template: "<div style=\"width:100%\">\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Fields\">\r\n            <dw-md-section-form-fields-config [contextNames]=\"contextNames\" [preferences]=\"preferences\"\r\n                [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\" [section]=\"section\">\r\n            </dw-md-section-form-fields-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Form Settings\">\r\n            <ng-container *ngIf=\"section\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label>Form Style</label>\r\n                        <select class=\"form-control\" [(ngModel)]=\"section.formStyle\">\r\n                            <option *ngFor=\"let item of formStyles\" [ngValue]=\"item.value\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    <div class=\"col-md-6\" *ngIf=\"section?.formStyle==horizontalForm\">\r\n                        <label>Label Width</label>\r\n                        <input type=\"text\" dwNumeric [(ngModel)]=\"section.labelWidth\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label>Is Read Only</label>\r\n                        <dw-yesno [(ngModel)]=\"section.isReadOnly\" allowNull=\"true\" nullDisplay=\"Automatic\"></dw-yesno>\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <label>Read Only Expression</label>\r\n                        <dw-expression-picker-control [(ngModel)]=\"section.isReadOnlyExpression\"\r\n                            [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                        </dw-expression-picker-control>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-md-6\">\r\n                        <label>Label Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"section.labelClass\" class=\"form-control\">\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <label>Data Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"section.dataClass\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n            </ng-container>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Validation\" *ngIf=\"section?.validationConfig\">\r\n            <dw-field-validation-config [(config)]=\"section.validationConfig\" [configContext]=\"metaDataConfigContext\"\r\n                validationItemType=\"formGroup\"></dw-field-validation-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [preferences]=\"preferences\"\r\n                    [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\" [showColumnConfig]=\"true\" [showReadOnlySection]=\"false\"\r\n                    [section]=\"section\">\r\n                </dw-md-section-standard-config>\r\n            </div>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Preview\">\r\n            <dw-md-section-preview [contextNames]=\"contextNames\" [preferences]=\"preferences\"\r\n                [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\" [section]=\"section\">\r\n            </dw-md-section-preview>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSectionReadonlyBaseComponent, [{
        type: Directive
    }], function () { return [{ type: DwExpressionService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormSectionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-form-section',
                template: `
    <ng-container *ngIf="visible">
        
        <dw-validation-info [formGroup]="formGroup" [submitted]="submitted" [filterKey]="relatedSections?.currentSectionKey" ></dw-validation-info>
        <div *ngFor="let formRow of formRows; trackBy: trackByIndex" [hidden]="!formSetupComplete"> 
            <div dwRow>
                <ng-container *ngFor="let column of formRow.columns; trackBy: trackByIndex">
                    <div [dwCol]="column.columnSize" [dwColWidth]="column.customWidth" [dwColClass]="column.columnClass" dwPageDesignerSelector [configKey]="formConfig?.configKey" [sectionKey]="sectionKey" [detailKey]="column.item" [additionalInfo]="formFieldConfigList[column.item]">
                        
                        <div class="dw-placeholder" *ngIf="column.isPlaceHolder"></div>
                        
                        <ng-container *ngIf="!column.isPlaceHolder">
                            <ng-container [ngSwitch]="sectionConfig?.formStyle">
                                <dwDynamicFieldHorizontal *ngSwitchCase="'horizontalForm'" [isRequired]="formFieldRequiredList[column.item]?.isRequired" [labelWidth]="sectionConfig?.labelWidth" [fieldDef]="formFieldConfigList[column.item]" [formGroup]="formGroupList[column.formGroupKey]" [submitted]="submitted" [context]="context" [useDisplayFields]="formConfig.loadDisplayProperties"></dwDynamicFieldHorizontal>
                                <dwDynamicField *ngSwitchDefault [isRequired]="formFieldRequiredList[column.item]?.isRequired" [fieldDef]="formFieldConfigList[column.item]" [formGroup]="formGroupList[column.formGroupKey]" [submitted]="submitted" [context]="context" [useDisplayFields]="formConfig.loadDisplayProperties"></dwDynamicField>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
        </div>
        <!-- Expression Results: 
         {{ conditionalExpressionResult | json }}-->
    </ng-container> 

  `
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwContextService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwMetadataFormValidationBuilderService }, { type: DwExpressionStateService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }]; }, null); })();
const ɵDwMdSectionComponentConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionComponentConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionComponentConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-section-component-config',
                template: "<div>\r\n        <p-tabView>\r\n            <p-tabPanel header=\"Component Configuration\">\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <label>Component Item</label>\r\n                        <select [(ngModel)]=\"section.componentName\" (ngModelChange)=\"changeComponent()\" class=\"form-control\">\r\n                            <option *ngFor=\"let item of componentList\" [ngValue]=\"item.key\">\r\n                                {{item.name}}\r\n                            </option>\r\n                        </select> \r\n                    </div>\r\n                </div>\r\n                <div dwRow *ngIf=\"configComponent\">\r\n                    <div dwCol=\"12\">\r\n                        <hr>\r\n                        <b>Component Configuration</b>\r\n                        <dw-dynamic-loader [component]=\"configComponent\" (configure)=\"setupConfigComponent($event)\"></dw-dynamic-loader>\r\n                    </div>\r\n                </div>\r\n            </p-tabPanel>\r\n            <p-tabPanel header=\"Section Configuration\" *ngIf=\"currentComponent?.componentType != pageComponentType\">\r\n                <div>\r\n                    <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\" [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                    </dw-md-section-standard-config>       \r\n                </div>\r\n            </p-tabPanel>\r\n        </p-tabView>  \r\n    </div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicSectionSetupService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwExpressionStateService }, { type: DwExpressionService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicSectionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-dynamic-section',
                template: `
        <div [hidden]="!containerVisible" dwPageDesignerSelector [configKey]="formConfig?.configKey" [sectionKey]="sectionKey" [additionalInfo]="sectionConfig">
           <dw-container 
           [options]="containerOptions">

                <span header>
                    <ng-container *ngIf="!useTitleTemplate">
                        {{ sectionConfig?.title }}
                    </ng-container>
                    <ng-container *ngIf="useTitleTemplate">
                        <dw-template-view-control [item]="itemName" [queryMetaData]="queryMetaData" [templateText]="currentTitleTemplate"
                            [dataSubject]="dataSubjectResult?.subject" [context]="context" isHtml="false" [showLookupDisplays]="sectionConfig?.titleTemplatePreferences?.loadLookupDisplays"
                            [blankPlaceholder]="sectionConfig?.title">
                        
                        </dw-template-view-control>
                  </ng-container>
                </span>
                <div body>
                    <ng-template dw-component-host></ng-template>
                </div>
            </dw-container>
        </div>
        <div *ngIf="invalidConfiguration && !isComponentMissing" class="hide-print dw-invalid-section">
            <i class="fas fa-cog" id="icon"></i>

            <div id="message">Component section has an invalid configuration. ({{invalidConfigurationMessage}})</div>
        </div>
        <div *ngIf="isComponentMissing" class="hide-print dw-invalid-section">
            <i class="fas fa-exclamation-triangle" id="icon"></i>

            <div id="message">{{invalidConfigurationMessage}}</div>
        </div>
    <div *ngIf="false">
        {{componentName}} - {{sectionConfig?.sectionType}} <br>
        <i class="fa fa-eye" [hidden]="!(sectionConfig?.isReadOnlyContainer || isSectionReadOnly() || sectionConfig?.isReadOnlyFromParent || sectionConfig?.isReadOnlyParentSource)"
            title="
            isReadOnlyContainer: {{ sectionConfig?.isReadOnlyContainer  }}   
            isSectionReadOnly: {{ isSectionReadOnly() }}    
            isReadOnlyFromParent: {{sectionConfig?.isReadOnlyFromParent}}    
            isReadOnlyParentSource: {{sectionConfig?.isReadOnlyParentSource}}    
            "></i>
        </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionStateService }, { type: DwMetadataFormUtilService }, { type: DwDynamicSectionSetupService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }]; }, { excludeStyling: [{
            type: Input
        }], reloadComponentOnChange: [{
            type: Input
        }], parentIsVisible: [{
            type: Input
        }], dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFormConfigFieldsComponent, [{
        type: Component,
        args: [{
                selector: 'app-dw-metadata-form-config-fields',
                template: "<div>\r\n    <table class=\"table table-striped\">\r\n        <thead>\r\n            <tr>\r\n                <td></td>\r\n                <td>Field</td>\r\n               \r\n                <td>New Row</td>\r\n                <td>Span Columns</td>\r\n                <td>Read Only</td>\r\n                <td></td>\r\n            </tr>\r\n        </thead>\r\n        <tbody>\r\n            <tr *ngFor=\"let item of formSection?.fields\">\r\n                <td>\r\n                    <i class=\"fa fa-times hand\" (click)=\"removeItem(item)\" title=\"Remove Field\"></i>\r\n                </td>\r\n                <td>\r\n                    <select [(ngModel)]=\"item.attrName\">\r\n                        <option *ngFor=\"let attr of itemMetaData?.Attributes\" [ngValue]=\"attr.AttributeName\">\r\n                            {{ attr.Display }}\r\n                        </option>\r\n                    </select> \r\n                </td>\r\n                <td>\r\n                    <p-inputSwitch [(ngModel)]=\"item.columnItemPreferences!.newRowBefore\"></p-inputSwitch>\r\n                </td>\r\n                <td>\r\n                    <p-inputSwitch [(ngModel)]=\"item.columnItemPreferences!.spanAllColumns\"></p-inputSwitch>\r\n                </td>\r\n                <td>\r\n                    <p-inputSwitch [(ngModel)]=\"item.isReadOnly\"></p-inputSwitch>\r\n                </td>\r\n                <td>\r\n                        <i class=\"fa fa-sort-up hand pull-left clear-left\" (click)=\"moveUp(item)\"></i>\r\n                        <i class=\"fa fa-sort-down hand pull-left clear-left\" (click)=\"moveDown(item)\"></i>\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n\r\n    <button (click)=\"addItem()\">\r\n        <i class=\"fa fa-plus hand\"></i>\r\n        Add Field\r\n    </button>\r\n\r\n    <!--<br />Filters : <br /> {{preferences.filters | json}}<br /><br />-->\r\n\r\n</div>\r\n"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormService }]; }, null); })();
const ɵDwMdSectionTabStripConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionTabStripConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionTabStripConfigComponent, [{
        type: Component,
        args: [{
                selector: 'app-dw-md-section-tab-strip-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Tab Strip Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Tab Strip Style</label>\r\n                    <select [(ngModel)]=\"section.tabStripStyle\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let item of tabStripStyleList\" [ngValue]=\"item.value\">\r\n                            {{item.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Tab Index Variable <i class=\"fa fa-info-circle\" title=\"Assigns the current tab index to this variable so it can be used in expressions\"></i></label>\r\n\r\n                    <input type=\"text\" [(ngModel)]=\"section.tabIndexVariableName\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"6\" *ngIf=\"section.tabIndexVariableName\">\r\n                    <label>Set Tab on Variable Change <i class=\"fa fa-info-circle\" title=\"Sets the tab when the variable is updated\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.tabIndexVariableSetOnChange\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Use Shared Container <i class=\"fa fa-info-circle\" title=\"Creates a shared container that is displayed for every tab\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.useSharedContainer\" (ngModelChange)=\"onSharedContainerChange()\"\r\n                        class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\" [hidden]=\"!section.useSharedContainer\">\r\n                    <label>Shared Container Position</label>\r\n                    <select [(ngModel)]=\"section.sharedContainerPosition\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let item of tabSharedContainerPositionList\" [ngValue]=\"item.value\">\r\n                            {{item.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n\r\n            <dw-ordered-list [(items)]=\"orderableSections\" (itemsChange)=\"onSectionTabChange()\" *ngIf=\"section\">\r\n                <ng-container *dwListItem=\"let section\">\r\n                    <label>Tab Name</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.tabHeading\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                </ng-container>\r\n            </dw-ordered-list>\r\n            <br>\r\n\r\n            <button (click)=\"addItem()\">\r\n                <i class=\"fa fa-plus hand\"></i>\r\n                Add Tab\r\n            </button>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\"\r\n                    (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"\r\n                    [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                </dw-md-section-standard-config>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTabStripSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-tab-strip-section',
                template: "<div [hidden]=\"!visible\" *ngIf=\"!inPrintMode\">\r\n\r\n    <ng-container *ngIf=\"!showPills\">\r\n        <p-tabView *ngIf=\"!showPills\" class=\"p-tabview-panels-hidden\" [(activeIndex)]=\"activeTabIndex\"\r\n            (onChange)=\"handleTabChange()\">\r\n            <ng-container *ngFor=\"let section of visibleTabs; let i = index\">\r\n                <p-tabPanel #tabPanel2 header=\"{{section.tabHeading}}\" [selected]=\"i==0\">\r\n                    <ng-template pTemplate=\"header\"><span dwPageDesignerSelector highlight=\"false\"\r\n                            stopPropagation=\"false\" [configKey]=\"formConfig?.configKey\" [sectionKey]=\"visibleTabKeys[i]\"\r\n                            [detailKey]=\"i\" [additionalInfo]=\"\">{{section.tabHeading}}</span></ng-template>\r\n                </p-tabPanel>\r\n            </ng-container>\r\n        </p-tabView>\r\n        <div class=\"p-tabview\">\r\n            <div class=\"p-tabview-panels\">\r\n                <ng-container *ngTemplateOutlet=\"tabContent\"></ng-container>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"showPills\">\r\n        <div style=\"overflow:auto\">\r\n            <dw-pills *ngIf=\"showPills\" [items]=\"visibleTabs\" [(ngModel)]=\"currentPillsTab\" valueField=\"sectionKey\"\r\n                displayField=\"tabHeading\" (ngModelChange)=\"setPillsTab($event)\"></dw-pills>\r\n        </div>\r\n        <div>\r\n            <ng-container *ngTemplateOutlet=\"tabContent\"></ng-container>\r\n        </div>\r\n    </ng-container>\r\n</div>\r\n\r\n<ng-template #tabContent>\r\n    <dw-dynamic-section *ngIf=\"containerSection && showSharedContainerAtTop\" [formConfig]=\"formConfig\"\r\n        [sectionConfig]=\"containerSection\" [formGroup]=\"formGroup\" [context]=\"context\" [submitted]=\"submitted\"\r\n        [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n    <ng-container *ngFor=\"let section of visibleTabs; let i = index\">\r\n        <div *ngIf=\"!section.loadOnClick || tabsLoaded[i]\" [hidden]=\"currentDisplayIndex != i\">\r\n            <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"section\" [formGroup]=\"formGroup\"\r\n                [context]=\"context\" [submitted]=\"submitted\" [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n        </div>\r\n    </ng-container>\r\n\r\n    <dw-dynamic-section *ngIf=\"containerSection && !showSharedContainerAtTop\" [formConfig]=\"formConfig\"\r\n        [sectionConfig]=\"containerSection\" [formGroup]=\"formGroup\" [context]=\"context\" [submitted]=\"submitted\"\r\n        [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n</ng-template>\r\n\r\n<div [hidden]=\"!visible\" *ngIf=\"inPrintMode\">\r\n    <ng-container *ngFor=\"let section of visibleTabs; let i = index\" class=\"dw-tab-print-container\">\r\n        <dw-container>\r\n            <div header>\r\n                {{section.tabHeading}}\r\n            </div>\r\n            <div body>\r\n\r\n                <dw-dynamic-section *ngIf=\"containerSection && showSharedContainerAtTop\" [formConfig]=\"formConfig\"\r\n                    [sectionConfig]=\"containerSection\" [formGroup]=\"formGroup\" [context]=\"context\"\r\n                    [submitted]=\"submitted\" [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n\r\n                <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"section\" [formGroup]=\"formGroup\"\r\n                    [context]=\"context\" [submitted]=\"submitted\" [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n\r\n                <dw-dynamic-section *ngIf=\"containerSection && !showSharedContainerAtTop\" [formConfig]=\"formConfig\"\r\n                    [sectionConfig]=\"containerSection\" [formGroup]=\"formGroup\" [context]=\"context\"\r\n                    [submitted]=\"submitted\" [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n            </div>\r\n        </dw-container>\r\n    </ng-container>\r\n</div>"
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionStateService }, { type: DwMetaDataFormStateService }, { type: DwMetadataFormUtilService }]; }, { tabView: [{
            type: ViewChild,
            args: [TabView, { static: true }]
        }] }); })();
const ɵDwMdSectionTabConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionTabConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionTabConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-section-tab-config',
                template: "<div *ngIf=\"!loading\">\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Tab Configuration\">\r\n\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Tab Heading</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.tabHeading\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Tab Class</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.tabClass\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Content Section Type</label>\r\n                    <select [(ngModel)]=\"section.section.sectionType\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                            {{sectionDef.display}}\r\n                        </option>\r\n                    </select>\r\n\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Load On Click</label>\r\n                    <dw-yesno [(ngModel)]=\"section.loadOnClick\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"itemName\">\r\n                <div dwCol=\"12\">\r\n                    <label>Visible Expression</label>\r\n                    <dw-expression-picker-control [(ngModel)]=\"section.visibleExpression\" [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
const ɵDwTabSectionComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwTabSectionComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTabSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-tab-section',
                template: `
    <dw-dynamic-section [formConfig]="formConfig" [sectionConfig]="sectionConfig.section" [formGroup]="formGroup" [context]="context" [submitted]="submitted" [parentIsVisible]="visible"></dw-dynamic-section>
  `
            }]
    }], null, null); })();
const ɵDwMdSectionContainerConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionContainerConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionContainerConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-section-container-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Container Configuration\">\r\n\r\n            <dw-ordered-list [(items)]=\"section.sections\" (itemsChange)=\"onSectionChange()\" *ngIf=\"section\">\r\n                <ng-container *dwListItem=\"let section\">\r\n                     <label>Section Type</label>\r\n                     <select [(ngModel)]=\"section.sectionType\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                            {{sectionDef.display}}\r\n                        </option>\r\n                    </select>\r\n                </ng-container>\r\n            </dw-ordered-list>\r\n\r\n            <div cdkDropList class=\"example-list\" (cdkDropListDropped)=\"drop($event)\" *ngIf=\"false\">\r\n                <div class=\"example-box\" *ngFor=\"let section of section?.sections\" cdkDrag>\r\n                    <div class=\"example-custom-placeholder\" *cdkDragPlaceholder></div>\r\n                   \r\n                </div>\r\n            </div>\r\n\r\n            <table class=\"table table-striped\" *ngIf=\"false\">\r\n                <thead>\r\n                    <tr>\r\n                        <td></td>\r\n                        <td>Section Type</td>\r\n                        <td></td>\r\n                    </tr>\r\n                </thead>\r\n                <tbody cdkDropList (cdkDropListDropped)=\"drop($event)\" class=\"example-list\">\r\n                    <tr class=\"example-box\" *ngFor=\"let section of section?.sections\" cdkDrag>\r\n                        <div class=\"example-custom-placeholder\" *cdkDragPlaceholder></div>\r\n                        <td>\r\n                            <i class=\"fa fa-times hand\" (click)=\"removeItem(section)\" title=\"Remove Tab\"></i>\r\n                        </td>\r\n                        <td>\r\n                            <select [(ngModel)]=\"section.sectionType\" (ngModelChange)=\"onSectionChange()\"\r\n                                class=\"form-control\">\r\n                                <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                                    {{sectionDef.display}}\r\n                                </option>\r\n                            </select>\r\n                        </td>\r\n                        <td>\r\n                            <i class=\"fa fa-grip-verticle fa-3x\" *cdkDragHandle></i>\r\n                            <i class=\"fa fa-2x fa-sort-up hand pull-left clear-left\" (click)=\"moveUp(section)\" [hidden]=\"true\"></i>\r\n                            <i class=\"fa fa-2x fa-sort-down hand move-arrow-down\" (click)=\"moveDown(section)\" [hidden]=\"true\"></i>\r\n                        </td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n            <br>\r\n            <button (click)=\"addItem()\">\r\n                <i class=\"fa fa-plus hand\"></i>\r\n                Add Section\r\n            </button>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [contextNames]=\"contextNames\"\r\n                    [preferences]=\"preferences\" [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\"\r\n                    showColumnConfig=\"true\">\r\n                </dw-md-section-standard-config>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [".example-list{background:#fff;border:1px solid #ccc;border-radius:4px;display:block;max-width:100%;min-height:60px;overflow:hidden;width:100%}.example-box{align-items:center;background:#fff;border-bottom:1px solid #ccc;box-sizing:border-box;color:rgba(0,0,0,.87);cursor:move;display:flex;flex-direction:row;font-size:14px;justify-content:space-between;padding:20px 10px}.cdk-drag-preview{border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.example-box:last-child{border:none}.example-custom-placeholder,.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.example-custom-placeholder{background:#ccc;border:3px dotted #999;min-height:60px}"]
            }]
    }], null, null); })();
const ɵDwContainerSectionComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwContainerSectionComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContainerSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-container-section',
                template: `
    <div [hidden]="!containerSectionVisible">
        <ng-container *ngFor="let formRow of sectionRows; let r = index; trackBy : trackByIndex"> 
            <div dwRow  [layoutMode]="sectionConfig?.columnPreferences?.columnLayoutMode">
                <ng-container *ngFor="let column of formRow.columns; let c = index; trackBy : trackByIndex">
                    <ng-container *ngIf="column.item">
                        <div [dwCol]="column.columnSize" [layoutMode]="sectionConfig?.columnPreferences?.columnLayoutMode" [dwColOptions]="column.columnOptions" [dwColWidth]="column.customWidth" [dwColClass]="column.columnClass">
                            <dw-dynamic-section [formConfig]="formConfig" (visibleChange)="setChildVisibility(r*10+c, $event)" [sectionConfig]="column.item" [formGroup]="formGroup" [context]="context" [submitted]="submitted" [parentIsVisible]="visible"></dw-dynamic-section>
                        </div>
                    </ng-container>
                </ng-container>
            </div> 
        </ng-container>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAssociativeListComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-associative-list',
                template: "<div>\r\n\t<div dwRow>\r\n\t\t<div [dwCol]=\"12\" [ngSwitch]=\"finalDisplayType\">\r\n\r\n\t\t\t<ng-container *ngSwitchCase=\"'readonly'\">\r\n\t\t\t\t<ng-container *ngTemplateOutlet=\"readonly\">\r\n\t\t\t\t</ng-container>\r\n\t\t\t</ng-container>\r\n\r\n\t\t\t<ng-container *ngSwitchCase=\"'dropdown'\">\r\n\t\t\t\t<ng-container *ngTemplateOutlet=\"dropdown\">\r\n\t\t\t\t</ng-container>\r\n\t\t\t</ng-container>\r\n\r\n\t\t\t<ng-container *ngSwitchDefault>\r\n\t\t\t\t<ng-container *ngTemplateOutlet=\"list\">\r\n\t\t\t\t</ng-container>\r\n\t\t\t</ng-container>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n\r\n<ng-template #dropdown>\r\n\t<p-multiSelect [options]=\"convertedLookupValues\" [group]=\"hasGrouping\" display=\"chip\" [autoExpand]=\"autoExpand\"\r\n\t\t[(ngModel)]=\"selectedItems\" display=\"chip\" (ngModelChange)=\"updateAssocativeCollection($event)\"\r\n\t\t[filter]=\"showFilter\" [virtualScroll]=\"virtualScroll\" [itemSize]=\"virtualScrollItems\" [style]=\"{'width':'100%'}\"\r\n\t\tappendTo=\"body\" [ngClass]=\"{ 'multi-edit-auto-expand': autoExpand }\"></p-multiSelect>\r\n</ng-template>\r\n\r\n<ng-template #list>\r\n\t<div [ngClass]=\"listClass\">\r\n\t\t<p-listbox [options]=\"convertedLookupValues\" [group]=\"hasGrouping\" [ngModel]=\"selectedItems\"\r\n\t\t\t(ngModelChange)=\"updateAssocativeCollection($event)\" filter=\"filter\" multiple=\"true\" checkbox=\"true\"\r\n\t\t\t[filter]=\"showFilter\" [listStyle]=\"listBoxStyle\"></p-listbox>\r\n\t</div>\r\n</ng-template>\r\n\r\n<ng-template #readonly>\r\n\t<div [hidden]=\"!displayItems?.length\" [ngClass]=\"finalReadOnlyItemStyle?.containerClass\"\r\n\t\tclass2=\"{{readOnlyItemStyle?.containerClass || 'dw-chip-container'}}\">\r\n\t\t<ng-container *ngFor=\"let item of displayItems,let i=index\">\r\n\t\t\t<div [ngClass]=\"finalReadOnlyItemStyle?.chipClass\">\r\n\t\t\t\t<span [ngClass]=\"finalReadOnlyItemStyle?.chipLabelClass\"\r\n\t\t\t\t\tclass2=\"readOnlyItemStyle?.chipLabelClass dw-chip-label\">{{item}}</span>\r\n\t\t\t</div>\r\n\t\t\t<div [hidden]=\"displayItems?.length-1 == i\" [ngClass]=\"finalReadOnlyItemStyle?.chipDelimiterClass\">\r\n\t\t\t\t{{finalReadOnlyItemStyle?.chipDelimiter}}\r\n\t\t\t</div>\r\n\t\t</ng-container>\r\n\t</div>\r\n\t<div [hidden]=\"displayItems?.length>0\">\r\n\t\tNone\r\n\t</div>\r\n</ng-template>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: DwAssociativeListComponent,
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwLookupParameterUtilService }, { type: DwEventService }]; }, { isReadOnly: [{
            type: Input
        }], useLoadedDisplayValues: [{
            type: Input
        }], virtualScrollThreshold: [{
            type: Input
        }], virtualScrollItems: [{
            type: Input
        }], displayType: [{
            type: Input
        }], autoExpand: [{
            type: Input
        }], listBoxMaxHeight: [{
            type: Input
        }], filterItemsThreshold: [{
            type: Input
        }], displayItems: [{
            type: Input
        }], displayItemsChange: [{
            type: Output
        }], parentItem: [{
            type: Input
        }], associativeItem: [{
            type: Input
        }], lookupAttributeName: [{
            type: Input
        }], lookupConfig: [{
            type: Input
        }], listColumns: [{
            type: Input
        }], readOnlyItemStyle: [{
            type: Input
        }], parentFormGroup: [{
            type: Input
        }], context: [{
            type: Input
        }] }); })();
const ɵDwMdSectionAssociativeListConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionAssociativeListConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionAssociativeListConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-section-associative-list-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Associative List Configuration\">\r\n            <p-accordion [multiple]=\"true\">\r\n                <p-accordionTab header=\"List Settings\" [selected]=\"true\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Parent Item</label>\r\n                            <div class=\"form-control\">{{itemMetaData?.Display}} ({{itemMetaData?.UniqueItemName}})</div>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Relationship</label>\r\n                            <select [(ngModel)]=\"section.relationshipName\"\r\n                                (ngModelChange)=\"onRelationshipChange($event)\" class=\"form-control\">\r\n                                <option *ngFor=\"let item of itemMetaData?.Relations\" [ngValue]=\"item.RelationshipName\">\r\n                                    {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Related Item</label>\r\n                            <div class=\"form-control\">{{associativeItemMetaData?.Display}} ({{section.associativeItem}})</div>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Lookup Field Name</label>\r\n                            <select [(ngModel)]=\"section.lookupAttributeName\" (ngModelChange)=\"setupLookupAttribute()\"  class=\"form-control\">\r\n                                <option *ngFor=\"let item of lookupAttributes\" [ngValue]=\"item.AttributeName\">\r\n                                    {{ item.Display }}\r\n                                </option>\r\n                            </select> \r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"4\">\r\n                            <label>Display Type</label>\r\n                            <select [(ngModel)]=\"section.displayType\" (ngModelChange)=\"onSectionChange()\"\r\n                                class=\"form-control\">\r\n                                <option *ngFor=\"let item of displayTypes\" [ngValue]=\"item.value\">\r\n                                    {{item.display}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                        <div dwCol=\"4\" *ngIf=\"section.displayType == 'dropdown'\">\r\n                            <label>Auto Expand</label>\r\n                            <dw-yesno [(ngModel)]=\"section.autoExpand\" (ngModelChange)=\"onSectionChange()\"\r\n                                allowNull=\"false\">\r\n                            </dw-yesno>\r\n                        </div>\r\n                        <div dwCol=\"4\" *ngIf=\"section.displayType != 'dropdown'\">\r\n                            <label>List Max Height</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.listBoxMaxHeight\"\r\n                                (ngModelChange)=\"onSectionChange()\" placeholder=\"450px\">\r\n                        </div>\r\n                        <div dwCol=\"4\" *ngIf=\"section.displayType != 'dropdown'\">\r\n                            <label>List Columns (Max 4)</label>\r\n                            <input type=\"numeric\" [dwNumeric] maxlength=\"1\" class=\"form-control\" [(ngModel)]=\"section.listColumns\"\r\n                                (ngModelChange)=\"onSectionChange()\" placeholder=\"1\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div class=\"col-md-6\">\r\n                            <label>Is Read Only</label>\r\n                            <dw-yesno [(ngModel)]=\"section.isReadOnly\" (ngModelChange)=\"onSectionChange()\"\r\n                                allowNull=\"true\" nullDisplay=\"Automatic\"></dw-yesno>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Show Filter Threshold <i class=\"fa fa-info-circle\" title=\"Minimum number of items in the list before the filter is dispalyed\"></i></label>\r\n                            <input type=\"text\" dwNumeric class=\"form-control\" [(ngModel)]=\"section.filterItemsThreshold\" placeholder=\"15\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Label</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.label\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Label Class</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.labelClass\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>List Display Variable Name <i class=\"fa fa-info-circle\" title=\"Assigns the string display value of the selected items to a variable\"></i> </label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.displayVariableName\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                        <div dwCol=\"6\" *ngIf=\"section.displayVariableName\">\r\n                            <label>List Display Delimiter</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.displayVariableDelimiter\" placeholder=\", \"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                    </div>\r\n                   \r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Lookup Settings\" [selected]=\"false\" *ngIf=\"lookupFieldContext\">\r\n                    <dw-select-lookup-config [(config)]=\"section.lookupConfig\" (configChange)=\"updateLookupSettings()\"\r\n                    [configContext]=\"lookupFieldContext\" [hideAdditionalDisplay]=\"true\" [hideUseTransitions]=\"true\"></dw-select-lookup-config>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Style Settings\" [selected]=\"false\">\r\n                    <div class=\"row\" *ngIf=\"section\">\r\n                        <div class=\"col-md-6\">\r\n                            <label>Form Style</label>\r\n                            <select class=\"form-control\" [(ngModel)]=\"section.formStyle\">\r\n                                <option *ngFor=\"let item of formStyles\" [ngValue]=\"item.value\">\r\n                                    {{item.display}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                        <div class=\"col-md-6\" *ngIf=\"section?.formStyle==horizontalForm\">\r\n                            <label>Label Width</label>\r\n                            <input type=\"text\" dwNumeric [(ngModel)]=\"section.labelWidth\" class=\"form-control\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Read-only Container Class</label>\r\n                            <input type=\"text\" class=\"form-control\"\r\n                                [(ngModel)]=\"section.readOnlyItemStyle.containerClass\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Chip Class</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.readOnlyItemStyle.chipClass\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Chip Label Class</label>\r\n                            <input type=\"text\" class=\"form-control\"\r\n                                [(ngModel)]=\"section.readOnlyItemStyle.chipLabelClass\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Chip Delimiter</label>\r\n                            <input type=\"text\" class=\"form-control\"\r\n                                [(ngModel)]=\"section.readOnlyItemStyle.chipDelimiter\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Chip Delimiter Class</label>\r\n                            <input type=\"text\" class=\"form-control\"\r\n                                [(ngModel)]=\"section.readOnlyItemStyle.chipDelimiterClass\"\r\n                                (ngModelChange)=\"onSectionChange()\">\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n            </p-accordion>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Validation\" *ngIf=\"section?.validationConfig\">\r\n            <dw-field-validation-config [(config)]=\"section.validationConfig\" [configContext]=\"metaDataConfigContext\"\r\n                validationItemType=\"formArray\"></dw-field-validation-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\"\r\n                    (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"\r\n                    [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\" [showReadOnlySection]=\"false\">\r\n                </dw-md-section-standard-config>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAssociativeListSectionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-associative-list-section',
                template: `
	<ng-container *ngIf="formGroupSetup && sectionConfig">
		<div [ngSwitch]="sectionConfig?.formStyle" [formGroup]="formGroup">
			<div class="row" *ngSwitchCase="'horizontalForm'">
				<div class="col-sm-2" [ngStyle]="labelColStyle"> 
						<label [hidden]="!sectionConfig?.label" class="label {{ sectionConfig?.labelClass}}">{{sectionConfig?.label}}</label>
				</div>
				<div class="col-sm-10" [ngStyle]="dataColStyle">
						<dw-associative-list [formControlName]="controlName" [autoExpand]="sectionConfig?.autoExpand" [parentItem]="sectionConfig!.parentItem" [isReadOnly]="isSectionReadOnly()" [useLoadedDisplayValues]="useLoadedDisplayValues" [associativeItem]="sectionConfig!.associativeItem" [displayType]="sectionConfig?.displayType" [readOnlyItemStyle]="sectionConfig?.readOnlyItemStyle">
						</dw-associative-list>
				</div>
			</div>

			<div [formGroup]="formGroup"  *ngSwitchDefault>
				<label [hidden]="!sectionConfig?.label" class="label {{ sectionConfig?.labelClass}}">{{sectionConfig?.label}}</label>
				<dw-associative-list [formControlName]="controlName" [autoExpand]="sectionConfig?.autoExpand" [listBoxMaxHeight]="sectionConfig?.listBoxMaxHeight" [listColumns]="sectionConfig?.listColumns"
				[parentItem]="sectionConfig!.parentItem" [associativeItem]="sectionConfig!.associativeItem" [displayType]="sectionConfig?.displayType" 
				[lookupAttributeName]="sectionConfig?.lookupAttributeName" [lookupConfig]="sectionConfig?.lookupConfig"
				[isReadOnly]="isSectionReadOnly()" [useLoadedDisplayValues]="useLoadedDisplayValues" 
				[readOnlyItemStyle]="sectionConfig?.readOnlyItemStyle" [parentFormGroup]="formGroup" [context]="context"
				[filterItemsThreshold]="sectionConfig?.filterItemsThreshold" [(displayItems)]="displayItems" (displayItemsChange)="steDisplayItemsVariable($event)">
				</dw-associative-list>
			</div>

			  <dw-validation-info [formControlName]="controlName" [submitted]="submitted"></dw-validation-info>
		</div>
	</ng-container>
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormValidationBuilderService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DynamicRoutingInitComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-dynamic-routing-init',
                template: ''
            }]
    }], function () { return [{ type: DwMetaDataRoutingRegistryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataListService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigService }, { type: DwCacheService }, { type: DwMetaDataActionConfigService }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataConfigFiltersModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-metadata-config-filters-modal',
                template: `
    <dw-metadata-config-filters [configContext]="configContext" [(filters)]="filters"></dw-metadata-config-filters>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataListConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-list-config',
                template: "<p-tabView styleClass=\"dw-fixed-tabs\" [(activeIndex)]=\"tabIndex\">\r\n    <p-tabPanel header=\"Card\">\r\n        <dw-card-config [preferences]=\"preferences\" (preferencesChange)=\"updatePreferences($event)\"\r\n            [configContext]=\"configContext\"></dw-card-config>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Actions\">\r\n        <dw-metadata-list-actions-config [configContext]=\"configContext\"\r\n            [(actionPreferencesByMode)]=\"preferences.actionPreferencesByMode\"\r\n            (actionPreferenceByModeChange)=\"updateActionPreferences($event)\">\r\n        </dw-metadata-list-actions-config>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Filters\">\r\n        <dw-metadata-config-filters [configContext]=\"configContext\" [(filters)]=\"preferences.filters\" [initialFilterKey]=\"initialFilterKey\"\r\n            showAdditionalTab=\"true\">\r\n            <div additionalTab>\r\n                <p-accordion>\r\n                    <p-accordionTab header=\"View Options\" [selected]=\"true\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"9\">\r\n                                <label>Use Filter Tiles</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"preferences.useFilterTiles\"></p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                    </p-accordionTab>\r\n                    <p-accordionTab header=\"Grid Filter Options\" [selected]=\"true\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"9\">\r\n                                <label>Show Filter On Load</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"preferences.showFilterOnLoad\"></p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow>\r\n                            <div dwCol=\"9\">\r\n                                <label>Auto Filter</label>\r\n                            </div>\r\n                            <div dwCol=\"3\">\r\n                                <p-inputSwitch [(ngModel)]=\"preferences.autoFilter\"></p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow [hidden]=\"!preferences.autoFilter\">\r\n                            <div dwCol=\"6\">\r\n                                <label>Auto Filter Delay</label>\r\n                            </div>\r\n                            <div dwCol=\"6\">\r\n                                <input type=\"number\" [(ngModel)]=\"preferences.autoFilterDelay\" class=\"form-control\">\r\n                            </div>\r\n                        </div>\r\n                    </p-accordionTab>\r\n                </p-accordion>\r\n            </div>\r\n        </dw-metadata-config-filters>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Filter Tiles\"\r\n        *ngIf=\"preferences.useFilterTiles\">\r\n        <dw-metadata-filter-tiles-config [configContext]=\"configContext\" [initialFilterTileKey]=\"initialFilterTileKey\"\r\n            [(tileConfig)]=\"preferences.filterTilesConfig\"></dw-metadata-filter-tiles-config>\r\n    </p-tabPanel>\r\n</p-tabView>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataListConfigWidgetComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-list-config',
                template: "<div>\r\n    <h3>List Preferences</h3>\r\n\r\n    <form [formGroup]=\"configForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Basic Settings\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Header</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showHeader\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow [hidden]=\"configForm?.value?.showHeader !== true\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Header Title</label>\r\n                    </div>\r\n                    <div dwCol=\"12\">\r\n                        <input formControlName=\"headerTitle\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Display value</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showDisplayProperties\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Loading <i class=\"fa fa-info-circle\" title=\"Hides the loading icon\"></i></label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideLoading\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Cards\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configList()\" class=\"btn btn-success\">Configure List</button>\r\n                    </div>\r\n                </div>\r\n\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Filtering\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Allow Filtering</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showFilter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Filter On Load</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showFilterOnLoad\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Auto Filter</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"autoFilter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <label>Filter Delay</label>\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <input type=\"number\" formControlName=\"autoFilterDelay\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Actions\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Action bar</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showActions\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Refresh Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideRefresh\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide View Toggle</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideViewToggle\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Data Setup\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Data Source</label>\r\n                        <select formControlName=\"dataSourceName\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\">Default</option>\r\n                            <option *ngFor=\"let dataSource of dataSources\" [ngValue]=\"dataSource.keyName\">\r\n                                {{dataSource.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Query</label>\r\n                        <select formControlName=\"metaDataQueryMeaning\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\">\r\n                                Default\r\n                            </option>\r\n                            <option *ngFor=\"let query of queries\" [ngValue]=\"query.QueryMeaning\">\r\n                                {{query.QueryName}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Context Data</label>\r\n                          <p-multiSelect [options]=\"contextDefListWithMissing\" formControlName=\"contextNames\" display=\"chip\">\r\n                                <ng-template let-value pTemplate=\"selectedItems\">\r\n                                    <span *ngFor=\"let val of value\" class=\"btn btn-success btn-xs tag\">\r\n                                        <span>{{ getContextDefDisplay(val) }}</span>\r\n                                    </span>\r\n                                    <span *ngIf=\"!value || value.length === 0\">None</span>\r\n                                </ng-template>\r\n                        </p-multiSelect>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Display Page Size <i class=\"fa fa-info-circle\" title=\"Number of cards dispalyed in each scroll attempt.  (This will vary depending on how many cards per row).\"></i></label>\r\n                        <input type=\"number\" dwNumeric formControlName=\"displayPageSize\" class=\"form-control\" placeholder=\"50\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Load Page Size <i class=\"fa fa-info-circle\" title=\"Number of records loaded at a time.  Should be more than the display count.\"></i></label>\r\n                        <input type=\"number\" dwNumeric formControlName=\"loadPageSize\" class=\"form-control\" placeholder=\"100\">\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"List Style\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>List Style</label>\r\n                        <select formControlName=\"listStyleName\" class=\"form-control\">\r\n                            <option *ngFor=\"let item of listStyles\" [ngValue]=\"item.keyName\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>List Class</label>\r\n                        <input type=\"text\" formControlName=\"listClass\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Card Item Class</label>\r\n                        <input type=\"text\" formControlName=\"cardItemClass\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>List Item Class</label>\r\n                        <input type=\"text\" formControlName=\"listItemClass\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </form>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwEventService }, { type: DwModalService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }, { type: DwDesignerStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataListComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-meta-data-list',
                template: "\r\n<div *ngIf=\"configSequenceComplete\" #containerList (click)=\"contextMenu = []\">\r\n    <dw-action-host></dw-action-host>\r\n    <dw-message [(message)]=\"gridMessage\"></dw-message>\r\n\r\n    <dw-data-list #datalist [data]=\"dataSource\" [filters]=\"filters\" [config]=\"config\" mode=\"card\" (actionClick)=\"actionPrefClicked($event)\" [actionContext]=\"actionContext\" (dataLoadComplete)=\"onDataLoadComplete($event)\">\r\n        <div filterTiles *ngIf=\"config?.useFilterTiles\">\r\n            <dw-metadata-filter-tiles [configContext]=\"configContext\" [tilesConfig]=\"config?.filterTilesConfig\"></dw-metadata-filter-tiles>\r\n        </div>\r\n        <div filter>\r\n            <dw-metadata-filters [configContext]=\"configContext\" [configKeyPart]=\"configKeyPart\" [filterConfig]=\"config.filters\" [filters]=\"filters\" (filtersChange)=\"setFilters($event)\"></dw-metadata-filters>\r\n        </div>\r\n        <ng-container *dwCardItem=\"let item\">\r\n            <dw-dynamic-loader [componentName]=\"config.cardComponentName\" defaultComponentName=\"dwCardDefault\" (configure)=\"setupCardComponent($event, item)\" [ngClass]=\"config.cardItemClass\"></dw-dynamic-loader>\r\n        </ng-container>\r\n        <ng-container *dwListItem=\"let item\">\r\n            <dw-dynamic-loader [componentName]=\"config.listComponentName\" defaultComponentName=\"dwCardDefault\" (configure)=\"setupListComponent($event, item)\" [ngClass]=\"config.listItemClass\"></dw-dynamic-loader>\r\n        </ng-container>\r\n        <ng-container *dwNoItems=\"let item\">\r\n\r\n            <ng-container *ngIf=\"!noItemsTemplate\">\r\n                <dw-dynamic-loader *ngIf=\"config.noItemsComponentName\" [componentName]=\"config.noItemsComponentName\" defaultComponentName=\"dwCardDefault\" (configure)=\"setupNoItemsComponent($event, item)\" [ngClass]=\"config.cardItemClass\"></dw-dynamic-loader>\r\n    \r\n                <span *ngIf=\"!config.noItemsComponentName\">  {{ config.noItemsMessage || 'There are no items found!' }}</span>\r\n            </ng-container>\r\n        </ng-container>\r\n    </dw-data-list>\r\n    <p-contextMenu [target]=\"containerList\" [model]=\"contextMenu\" *ngIf=\"contextMenu && contextMenu.length>0\"></p-contextMenu>\r\n</div>",
                providers: [DwMetaDataFilterStateService],
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataListService }, { type: DwUiConfigService }, { type: DwEventService }, { type: DwMetaDataFilterService }, { type: DwMetaDataFilterStateService }, { type: DwSecurityUserService }, { type: DwActionExecutionService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, { configKeyPart: [{
            type: Input
        }], dataLoadComplete: [{
            type: Output
        }], cardClick: [{
            type: Output
        }], filters: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], config: [{
            type: Input
        }], item: [{
            type: Input
        }], dwDataList: [{
            type: ViewChild,
            args: ['datalist']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFiltersComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-filters',
                template: "<div autocomplete=\"off\">\r\n    <div dwRow class=\"filters\">\r\n        <ng-container *ngFor=\"let filterFieldConfig of filterFieldConfigs;\">\r\n            <ng-container *ngIf=\"filterFieldConfig?.newRow\">\r\n                <div class=\"new-row\"></div>\r\n            </ng-container>\r\n            <div [dwCol]=\"filterFieldConfig.columnSize\" dwPageDesignerSelector [configKey]=\"configKey\" [sectionKey]=\"viewKey\" detailKey=\"filter\"  [additionalInfo]=\"filterFieldConfig.filterConfig\">\r\n                <span *ngIf=\"!filterFieldConfig.componentType\" dwDynamicField [fieldDef]=\"filterFieldConfig.fieldConfig\"\r\n                    [formGroup]=\"formGroup\"></span>\r\n\r\n                <dw-dynamic-loader *ngIf=\"filterFieldConfig.componentType\" [component]=\"filterFieldConfig.componentType\"\r\n                    (configure)=\"configFilterItemComponent($event, filterFieldConfig)\"></dw-dynamic-loader>\r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n</div>",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DwMetaDataFilterService }, { type: DwMetaDataFilterStateService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.Router }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }]; }, { configKey: [{
            type: Input
        }], viewKey: [{
            type: Input
        }], configContext: [{
            type: Input
        }], filterConfig: [{
            type: Input
        }], sharedFilterExpression: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataConfigFiltersComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-config-filters',
                template: "<dw-ui-config-list [items]=\"filters\" [config]=\"listConfig\" [selectedItem]=\"selectedFilter\" size=\"large\"\r\n    (selectedItemChange)=\"setSelectedFilter($event)\" (removeItem)=\"removeItem($event)\" (reorder)=\"reorderList()\">\r\n    <div addItemsTab>\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Field Filters\" [selected]=\"true\">\r\n                <dw-field-selection [attributes]=\"queryMetaData?.Attributes\" (attributeClick)=\"addItem($event)\"\r\n                    addTooltip=\"Add Filter\"></dw-field-selection>\r\n\r\n                <!--  <div *ngFor=\"let attr of queryMetaData?.Attributes\" class=\"dw-field-item\">\r\n                    <button class=\"btn btn-sm btn-success\" (click)=\"addItem(attr)\">\r\n                        <i class=\"fa fa-plus-circle hand\" title=\"Add Filter\"></i>\r\n                        {{attr.AttributeDisplay}}\r\n                    </button>\r\n                </div> -->\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Other Filters\">\r\n                <div *ngFor=\"let componentItem of componentList\" class=\"dw-field-item\">\r\n                    <button class=\"btn btn-sm btn-success\" (click)=\"addComponentFilter(componentItem)\"\r\n                        *ngIf=\"!componentItem.configData?.requireAttr\">\r\n                        <i class=\"fa fa-plus-circle hand\" title=\"Add Filter\"></i>\r\n                        {{componentItem.name}}\r\n                    </button>\r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </div>\r\n    <div actionBar>\r\n        <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n    </div>\r\n    <div configureItemTab>\r\n        <p-accordion *ngIf=\"selectedFilter\">\r\n            <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Custom Filter Component</label>\r\n                        <select [(ngModel)]=\"selectedFilter.componentName\"\r\n                            (ngModelChange)=\"filterComponentChange($event)\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\" *ngIf=\"selectedFilter?.attr\">None</option>\r\n                            <option *ngFor=\"let item of selectedFilterComponentList\" [ngValue]=\"item.key\">\r\n                                {{item.name}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow [hidden]=\"selectedFilterComponent && !selectedFilterComponent?.configData?.showCompareType\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Compare Type</label>\r\n                        <select [(ngModel)]=\"selectedFilter.filterType\" (ngModelChange)=\"controlTypeOverrideChange()\"\r\n                            class=\"form-control\">\r\n                            <option *ngFor=\"let comparer of selectedComparers\" [ngValue]=\"comparer.ComparerMeaning\">\r\n                                {{ comparer.ComparerName }}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n\r\n                <!-- <div dwRow\r\n                    *ngIf=\"defaultValueFormGroup && selectedFilterValueConfig && filterRequiresValue(selectedFilter.filterType)\"\r\n                    [hidden]=\"selectedFilterComponent && !selectedFilterComponent?.configData?.showDefaultValue\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Default value</label>\r\n                    </div>\r\n                    <div dwCol=\"12\" dwDynamicField [formGroup]=\"defaultValueFormGroup\"\r\n                        [fieldDef]=\"selectedFilterValueConfig\" recreateControlOnChange=\"true\">\r\n                    </div>\r\n                </div> -->\r\n\r\n                <!-- <ng-container *ngIf=\"defaultValueFormGroup && selectedFilterValueConfig && filterRequiresValue(selectedFilter.filterType)\">\r\n                \r\n                    <div dwRow [hidden]=\"selectedFilterComponent && !selectedFilterComponent?.configData?.showDefaultValue\">\r\n                        <div dwCol=\"9\">\r\n                            <label>Use Default Value</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"selectedFilter.hasDefaultValue\"></p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                    <ng-container *ngIf=\"selectedFilter.hasDefaultValue\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"12\">\r\n                                <dw-default-value [(defaultValue)]=\"selectedFilter.defaultValue\" [contextNames]=\"configContext?.contextNames\" [queryAttribute]=\"selectedAttr\"></dw-default-value>\r\n                            </div>\r\n                        </div>\r\n                    </ng-container>\r\n                </ng-container> -->\r\n\r\n                <div dwRow [hidden]=\"selectedFilterComponent && !selectedFilterComponent?.configData?.showCaption\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Caption Override</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedFilter.label\" (ngModelChange)=\"onFiltersChange()\"\r\n                            class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow\r\n                    [hidden]=\"selectedFilterComponent  && !selectedFilterComponent?.configData?.showPlaceholderText\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Placeholder Text</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedFilter.placeholderText\"\r\n                            (ngModelChange)=\"onFiltersChange()\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow\r\n                    [hidden]=\"selectedFilterComponent && selectedFilterComponent?.configData?.hideQueryStringParamName\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Alt Query String Param <i class=\"fa fa-info-circle\" title=\"Overrides using the attribute name to populate default values\"></i></label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedFilter.altQueryStringParamName\"\r\n                            (ngModelChange)=\"onFiltersChange()\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Filter</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch [(ngModel)]=\"selectedFilter.showFilter\" (ngModelChange)=\"onFiltersChange()\">\r\n                        </p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Default Value\"\r\n                *ngIf=\"defaultValueFormGroup && selectedFilterValueConfig && filterRequiresValue(selectedFilter.filterType) && !(selectedFilterComponent && !selectedFilterComponent?.configData?.showDefaultValue)\">\r\n\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Use Default Value</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch [(ngModel)]=\"selectedFilter.hasDefaultValue\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <ng-container *ngIf=\"selectedFilter.hasDefaultValue\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <dw-default-value [(defaultValue)]=\"selectedFilter.defaultValue\"\r\n                                (defaultValueChange)=\"updateDefaultValue($event)\"\r\n                                [contextNames]=\"configContext?.contextNames\" [queryAttribute]=\"selectedDefaultValueAttr\">\r\n                            </dw-default-value>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Filter Settings\" [hidden]=\"!selectedComponentConfig\">\r\n                <dw-ui-child-config-host [component]=\"selectedComponentConfig\"\r\n                    [(config)]=\"selectedFilter.additionalConfig\" (configChange)=\"setAdditionalConfig($event)\"\r\n                    [configContext]=\"filterConfigContext\">\r\n                </dw-ui-child-config-host>\r\n\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Filter Layout\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>New Row Before</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch [(ngModel)]=\"selectedFilter.newRowBefore\" (ngModelChange)=\"onFiltersChange()\">\r\n                        </p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Span All Columns</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch [(ngModel)]=\"selectedFilter.spanAllColumns\" (ngModelChange)=\"onFiltersChange()\">\r\n                        </p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Control Overrides\"\r\n                [hidden]=\"selectedFilterComponent && !selectedFilterComponent?.configData?.showControlOptions\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Show As Lookup</label>\r\n               \r\n                        <dw-yesno [(ngModel)]=\"selectedFilter.showAsLookup\" [allowNull]=\"true\" nullDisplay=\"From Attribute\" (ngModelChange)=\"onShowAsLookupChange()\"></dw-yesno>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Control Type Override</label>\r\n                        <select [(ngModel)]=\"selectedFilter.controlTypeOverride\"\r\n                            (ngModelChange)=\"controlTypeOverrideChange()\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\"> </option>\r\n                            <option *ngFor=\"let controlType of selectedControlTypes\"\r\n                                [ngValue]=\"controlType.MetaDataControlTypeId\">\r\n                                {{ controlType.ControlTypeName }}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <dw-select-lookup-config *ngIf=\"showLookupConfig\" [(config)]=\"selectedFilter.lookupConfig\" (configChange)=\"controlTypeOverrideChange()\"\r\n                    [configContext]=\"dwFormFieldContext\">\r\n            </dw-select-lookup-config>\r\n            </p-accordionTab>\r\n\r\n            <p-accordionTab header=\"Control Settings\" *ngIf=\"controlOptionsComponentType\"\r\n                [hidden]=\"selectedFilterComponent && !selectedFilterComponent?.configData?.showControlOptions\">\r\n                <dw-dynamic-loader [component]=\"controlOptionsComponentType\"\r\n                    (configure)=\"configureFieldControlOptionInstance($event)\"></dw-dynamic-loader>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </div>\r\n    <div additionalTab>\r\n        <ng-content select=\"[additionalTab]\"></ng-content>\r\n    </div>\r\n</dw-ui-config-list>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { filtersChange: [{
            type: Output
        }], showAdditionalTab: [{
            type: Input
        }], additionalTabHeading: [{
            type: Input
        }], filters: [{
            type: Input
        }], configContext: [{
            type: Input
        }], initialFilterKey: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSelectLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-select-lookup',
                template: `
  <select class="form-control" [ngModel]="translatedValue" (ngModelChange)="setTranslatedValue($event)" [disabled]="disabled">
      <option value="" *ngIf="showBlankOption">{{blankOptionText}}</option>
      <option *ngFor="let lookupItem of lookupItems, trackBy: getLookupItemKeyFuntion(lookupDef)" [value]="lookupItem[valueAttrName]">
          {{lookupItem.Display }}
      </option>
  </select>
  <span *ngIf="additionalDataField">{{getAdditionalFieldDisplay()}}</span>
  {{lookupErorMessage}}
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwSelectLookupComponent),
                        multi: true
                    }],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwEventService }, { type: DwSecurityUserService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwMetaDataRoutingService }, { type: DwLookupParameterUtilService }, { type: ɵngcc2.ActivatedRoute }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, { showBlankOption: [{
            type: Input
        }], blankOptionText: [{
            type: Input
        }], valueAttrName: [{
            type: Input
        }], useTransitions: [{
            type: Input
        }], useServerSearch: [{
            type: Input
        }], useServerSearchParams: [{
            type: Input
        }], additionalDataField: [{
            type: Input
        }], paramValues: [{
            type: Input
        }], lookupDef: [{
            type: Input
        }], lookupId: [{
            type: Input
        }], overrideValues: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionStandardConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-md-section-standard-config',
                template: "<div [formGroup]=\"formGroup\" *ngIf=\"formSetup\">\r\n    <p-accordion [multiple]=\"true\">\r\n        <p-accordionTab header=\"Title Settings\" [selected]=\"true\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Title</label>\r\n                    <input type=\"text\" formControlName=\"title\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <label>Show Title</label>\r\n                    <dw-yesno formControlName=\"showTitle\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"3\" [hidden]=\"!formGroup.value?.showTitle\">\r\n                    <label>Use Title Templates</label>\r\n                    <dw-yesno formControlName=\"useTitleTemplates\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab header=\"Container Settings\" [selected]=\"true\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Style as Container</label>\r\n                    <dw-yesno formControlName=\"useContainerStyling\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Section Type</label>\r\n                    <select formControlName=\"sectionType\" class=\"form-control\">\r\n                        <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                            {{sectionDef.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!formGroup.value?.useContainerStyling\">\r\n                <div dwCol=\"4\">\r\n                    <label>Style Name</label>\r\n                    <select formControlName=\"containerStyleName\" class=\"form-control\">\r\n                        <option *ngFor=\"let item of containerStyles\" [ngValue]=\"item.keyName\">\r\n                            {{item.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Override Styles</label>\r\n                    <dw-yesno formControlName=\"overrideContainerStyles\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Container Icon</label>\r\n                    <input type=\"text\" formControlName=\"containerHeaderIcon\" class=\"form-control\">\r\n\r\n                    <i class=\"{{formGroup.value?.containerHeaderIcon}}\" [ngClass]=\"currentIconColor?.foregroundClass\"\r\n                        [hidden]=\"!formGroup.value?.containerHeaderIcon\"></i>\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!formGroup.value?.useContainerStyling\">\r\n                <div dwCol=\"4\">\r\n                    <label>Header Background Color</label>\r\n                    <dw-color-select formControlName=\"containerHeaderBackgroundColor\"></dw-color-select>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Header Text Color</label>\r\n                    <dw-color-select formControlName=\"containerHeaderForegroundColor\"></dw-color-select>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Icon Color</label>\r\n                    <dw-color-select formControlName=\"containerHeaderIconColor\"></dw-color-select>\r\n                </div>\r\n            </div>\r\n\r\n            <div dwRow [hidden]=\"!formGroup.value?.useContainerStyling\">\r\n                <div dwCol=\"4\">\r\n                    <label>Allow Collapse</label>\r\n                    <dw-yesno formControlName=\"containerAllowCollapse\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"4\" [hidden]=\"!formGroup.value?.containerAllowCollapse\">\r\n                    <label>Collapsed Expression</label>\r\n                    <dw-expression-picker-control formControlName=\"containerCollapseDefaultExpression\"\r\n                        [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n                <div dwCol=\"4\" [hidden]=\"!formGroup.value?.containerAllowCollapse\">\r\n                    <label>Default to Collapsed</label>\r\n                    <dw-yesno formControlName=\"containerCollapseDefault\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!formGroup.value?.useContainerStyling\">\r\n                <div dwCol=\"4\" [hidden]=\"!formGroup.value?.overrideContainerStyles\">\r\n                    <label>Container Width</label>\r\n                    <input type=\"text\" formControlName=\"containerWidth\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"4\" [hidden]=\"!formGroup.value?.overrideContainerStyles\">\r\n                    <label>Container Height</label>\r\n                    <input type=\"text\" formControlName=\"containerHeight\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"!formGroup.value?.useContainerStyling || !formGroup.value?.overrideContainerStyles\">\r\n                <div dwCol=\"4\">\r\n                    <label>Container Class</label>\r\n                    <input type=\"text\" formControlName=\"containerClass\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Container Inner Class</label>\r\n                    <input type=\"text\" formControlName=\"containerInnerClass\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Container Title Class</label>\r\n                    <input type=\"text\" formControlName=\"containerTitleClass\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Visible Expression</label>\r\n                    <dw-expression-picker-control formControlName=\"visibleExpression\" [contextNames]=\"contextNames\"\r\n                        [item]=\"itemName\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\" *ngIf=\"showReadOnlySection\">\r\n                <div class=\"col-md-6\">\r\n                    <label>Is Read Only <i class=\"fa fa-info-circle\"\r\n                            title=\"Propogates to all child sections unless overridden\"></i></label>\r\n                    <dw-yesno formControlName=\"isReadOnlyContainer\" allowNull=\"true\" nullDisplay=\"Automatic\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Read Only Expression <i class=\"fa fa-info-circle\"\r\n                            title=\"Overrides the Is Read Only value when set\"></i></label>\r\n                    <dw-expression-picker-control formControlName=\"readOnlyContainerExpression\"\r\n                        [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab header=\"Title Templates\"\r\n            *ngIf=\"formGroup?.value?.useTitleTemplates && formGroup.value?.showTitle\">\r\n            <dw-title-templates-config formControlName=\"titleTemplatePreferences\" [contextNames]=\"contextNames\"\r\n                [item]=\"itemName\"\r\n                [parentUseContainerStyling]=formGroup.value?.useContainerStyling></dw-title-templates-config>\r\n        </p-accordionTab>\r\n\r\n        <p-accordionTab header=\"Column Settings\" *ngIf=\"showColumnConfig && columnConfigSetup\">\r\n            <ng-container formGroupName=\"columnPreferences\">\r\n                <div dwRow>\r\n                    <div dwCol=\"4\">\r\n                        <label>Columns</label>\r\n                        <input type=\"number\" dwNumeric formControlName=\"columns\" class=\"form-control\">\r\n                    </div>\r\n                    <div dwCol=\"4\">\r\n                        <label>Column Layout Mode</label>\r\n                        <select formControlName=\"columnLayoutMode\" class=\"form-control\">\r\n                            <option *ngFor=\"let item of columnLayoutModes\" [ngValue]=\"item.value\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"4\" *ngIf=\"!columnDetails || columnDetails?.length==0\">\r\n                        <button (click)=\"addColumnDetail()\" class=\"btn btn-success\">Configure columns</button>\r\n                    </div>\r\n                </div>\r\n                <ng-container formArrayName=\"columnDetails\" *ngIf=\"columnDetails && columnDetails.length>0\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"1\"></div>\r\n                        <ng-container *ngIf=\"isFlexLayout()\">\r\n                            <div dwCol=\"2\">Flex Size <i class=\"fa fa-info-circle\" title=\"column flex weight, defaults to 1 - equal size\"></i></div>\r\n                            <div dwCol=\"2\">Flex Grow <i class=\"fa fa-info-circle\" title=\"column expands to consume extra space\"></i></div>\r\n                          </ng-container>\r\n                        <ng-container *ngIf=\"!isFlexLayout()\">\r\n                            <div dwCol=\"3\">Column Size <i class=\"fa fa-info-circle\" title=\"Column size in a 12 column grid (6 = 50% or 2 columns, 4 = 33% or 3 columns, 3 = 25% or 4 columns, 2 = 16% or 6 columns, 1 = 8% or 12 columns)\"></i></div>\r\n                        </ng-container>\r\n                        <div dwCol=\"2\">Width</div>\r\n                        <div dwCol=\"2\">Height</div>\r\n                        <div dwCol=\"3\">Class</div>\r\n                    </div>\r\n                    <ng-container>\r\n                        <ng-container *ngFor=\"let columnDetail of columnDetails.controls; index as i\">\r\n                            <div dwRow [formGroupName]=\"i\">\r\n                                <div dwCol=\"1\">\r\n                                    <i class=\"fa fa-times hand\" (click)=\"removeColumn(i)\" title=\"Remove Column\"></i>\r\n                                </div>\r\n                                <ng-container *ngIf=\"isFlexLayout()\">\r\n                                    <div dwCol=\"2\">\r\n                                        <input type=\"number\" dwNumeric formControlName=\"flexSize\" placeholder=\"1\" class=\"form-control\">\r\n                                    </div>\r\n                                    <div dwCol=\"2\">\r\n                                        <input type=\"number\" dwNumeric formControlName=\"flexGrow\" class=\"form-control\">\r\n                                    </div>\r\n                                  </ng-container>\r\n                                  <ng-container *ngIf=\"!isFlexLayout()\">\r\n                                    <div dwCol=\"3\">\r\n                                        <input type=\"number\" dwNumeric formControlName=\"columnSize\" class=\"form-control\">\r\n                                    </div>\r\n                                </ng-container>\r\n\r\n                                <div dwCol=\"2\">\r\n                                    <input type=\"text\" formControlName=\"customWidth\" class=\"form-control\">\r\n                                </div>\r\n                                <div dwCol=\"2\">\r\n                                    <input type=\"text\" formControlName=\"customHeight\" class=\"form-control\">\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <input type=\"text\" formControlName=\"columnClass\" class=\"form-control\">\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <button (click)=\"addColumnDetail()\" class=\"btn btn-success\"\r\n                            *ngIf=\"columnPreferences.value.columns > columnDetails.controls.length\">Add\r\n                            Column</button>\r\n                    </ng-container>\r\n                </ng-container>\r\n            </ng-container>\r\n\r\n        </p-accordionTab>\r\n    </p-accordion>\r\n\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }, { type: DwStyleManagerService }]; }, { showReadOnlySection: [{
            type: Input
        }], showColumnConfig: [{
            type: Input
        }] }); })();
const ɵDwMdSectionGridConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionGridConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionGridConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-section-grid-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Grid Configuration\">\r\n            <div dwRow>\r\n              <!--   <div dwCol=\"6\">\r\n                    <label>Parent Item</label>\r\n                    <div class=\"form-control\">{{itemMetaData?.Display}}</div>\r\n                </div> -->\r\n                <div dwCol=\"6\">\r\n                    <label>Relationship</label>\r\n                    <select [(ngModel)]=\"section.relationshipName\" (ngModelChange)=\"setSectionRelationshipItems($event)\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of itemMetaData?.Relations\" [ngValue]=\"item.RelationshipName\">\r\n                            {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Show as Data List</label>\r\n                    <dw-yesno [(ngModel)]=\"section.showAsList\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Item Name</label>\r\n                    <div class=\"form-control\">{{section?.itemName}}</div>\r\n                </div> \r\n                <div dwCol=\"6\">\r\n                    <label>Property Name</label>\r\n                    <div class=\"form-control\">{{section.propertyName}}</div>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Use Parent Data</label>\r\n                    <dw-yesno [(ngModel)]=\"section.useParentData\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <!-- <div dwCol=\"6\">\r\n                    <label>Config Key Suffix (Optional)</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.configKeySuffix\" class=\"form-control\">\r\n                </div> -->\r\n                 <div dwCol=\"6\" *ngIf=\"secondaryRelationships && secondaryRelationships.length>0\">\r\n                    <label>Secondary Relationship</label>\r\n                    <select [(ngModel)]=\"section.secondaryRelationshipName\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of secondaryRelationships\" [ngValue]=\"item.RelationshipName\">\r\n                            {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Use Shared Config <i class=\"fa fa-info-circle\" title=\"Allows using a shared grid config by omiting the form config prefix for the grid\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.useSharedConfig\" class=\"form-control\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Config Key Suffix (Optional)</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.configKeySuffix\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Validation\" *ngIf=\"section?.validationConfig && section.useParentData\">\r\n            <dw-field-validation-config [(config)]=\"section.validationConfig\" validationItemType=\"childGrid\" [configContext]=\"metaDataConfigContext\"></dw-field-validation-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"  [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                </dw-md-section-standard-config>       \r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>  \r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-section',
                template: `
    <div *ngIf="invalidConfiguration" class="hide-print dw-invalid-section">
        <i class="fas fa-cog" id="icon"></i>

        <div id="message">Grid/list section has an invalid configuration. ({{invalidConfigurationMessage}})</div>
    </div>
     <ng-container *ngIf="setupComplete">
        <div dwRow>
            <div dwCol="12" [formGroup]="formGroup" *ngIf="childFormGroupName" >
                <dw-validation-info [formControlName]="childFormGroupName" [submitted]="submitted"></dw-validation-info>
            </div>
        </div>
        <ng-container *ngIf="sectionConfig?.itemName">
            <dw-meta-data-grid *ngIf="!sectionConfig?.showAsList" [dataSource]="dataSource" [readOnly]="isSectionReadOnly()" [preferences]="gridPreferences"  [item]="sectionConfig.itemName" [addContext]="addContext" [configKeyPart]="configKeyPart" [filters]="filters"></dw-meta-data-grid>

            <dw-meta-data-list *ngIf="sectionConfig?.showAsList" [dataSource]="dataSource" [item]="sectionConfig.itemName" [configKeyPart]="configKeyPart" [filters]="filters"></dw-meta-data-list>
        </ng-container>
        <ng-container *ngIf="!sectionConfig?.itemName">
        </ng-container>
    </ng-container>
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwExpressionStateService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormStateService }, { type: DwMetadataFormValidationBuilderService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-expression-control',
                template: `
        <div *ngIf="expr" dwRow>
            <div class="expr-column">
                <dw-expression-reference-control [(ngModel)]="expr.reference1" (ngModelChange)="setReference1($event)" [item]="item" [queryMeaning]="queryMeaning" [contextNames]="contextNames" >
                </dw-expression-reference-control>
            </div>
            <div class="expr-column" [hidden]="!compareTypes || compareTypes?.length==0">
                <select [(ngModel)]="expr.compareType" (ngModelChange)="setValue(expr)" class="form-control">
                    <option *ngFor="let compareType of compareTypes" [ngValue]="compareType.value">
                        {{ compareType.display }}
                    </option>
                </select>
            </div>
            <div class="expr-column" [hidden]="!compareTypes || compareTypes?.length==0 || !compareNeedsValue(expr.compareType)">
                <!--Expr Ref(expControl) : {{expr.reference1 | json}}  <br>-->
                <dw-expression-reference-control [(ngModel)]="expr.reference2" (ngModelChange)="setValue(expr)" [relatedExprRef]="relatedExprRef" [item]="item" [queryMeaning]="queryMeaning" [contextNames]="contextNames" [comparerType]="expr.compareType">
                </dw-expression-reference-control>

                </div>
            </div>
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwExpressionControlComponent),
                        multi: true
                    }],
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionComparersService }]; }, { contextNames: [{
            type: Input
        }], item: [{
            type: Input
        }], queryMeaning: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionGroupControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-expression-group-control',
                template: "<div *ngIf=\"item || contextNames?.length>0\">\r\n    <div *ngIf=\"exprGroup\" class=\"expression-group-box\">\r\n        <ng-container *ngFor=\"let expr of exprGroup.expressions, first as isFirst, last as isLast, index as i\"> \r\n            <div class=\"expression-row\" *ngIf=\"!isFirst\">\r\n                <div class=\"expression-remove-col\">\r\n                </div>\r\n                <div class=\"expression-col-operator\">\r\n                    <select [(ngModel)]=\"exprGroup.operator\" (ngModelChange)=\"setValue(exprGroup)\" class=\"form-control\">\r\n                        <option *ngFor=\"let operatorType of operatorTypes\" [ngValue]=\"operatorType.value\">\r\n                            {{ operatorType.display }}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"expression-row\">\r\n                <div class=\"expression-remove-col\">\r\n                    <i class=\"fa fa-times hand\" (click)=\"removeExpr(expr)\" title=\"Remove Field\"></i>\r\n                </div> \r\n                <div class=\"expression-col\">\r\n                    <ng-container *ngIf=\"isExpressionGroup(expr)\">\r\n                            <dw-expression-bracket>\r\n                                <dw-expression-group-control [ngModel]=\"expr\" (ngModelChange)=\"setExprValue(exprGroup, expr, index)\" [contextNames]=\"contextNames\" [item]=\"item\" [queryMeaning]=\"queryMeaning\"></dw-expression-group-control>    \r\n                            </dw-expression-bracket>\r\n                    </ng-container>\r\n                    <ng-container *ngIf=\"!isExpressionGroup(expr)\">\r\n                        <dw-expression-control [ngModel]=\"expr\" (ngModelChange)=\"setExprValue(exprGroup, expr, index)\" [contextNames]=\"contextNames\" [item]=\"item\" [queryMeaning]=\"queryMeaning\"></dw-expression-control>    \r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n   </div>\r\n   <div class=\"expression-button-bar\">\r\n        <button class=\"btn btn-sm btn-primary\" (click)=\"addExpr()\" title=\"Add Expression\">\r\n            <i class=\"fa fa-plus hand\"></i>\r\n        </button>\r\n        <button class=\"btn btn-sm btn-primary\" (click)=\"addExprGroup()\" title=\"Add Group\">\r\n            <i class=\"fa fa-layer-plus hand\"></i>\r\n        </button>\r\n    </div>\r\n</div>\r\n<div *ngIf=\"!item && (!contextNames || contextNames?.length==0)\">\r\n    Expression require an Item or a Context Name\r\n</div>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwExpressionGroupControlComponent),
                        multi: true
                    }],
                viewProviders: [DwExpressionGroupControlComponent],
                styles: [".expression-group-box{margin:5px;width:100%}.expression-row{clear:left;display:flex;flex-wrap:wrap}.expression-group-box-column{float:left;padding:5px;width:5px}.expression-remove-col{float:left;padding:5px;width:20px}.expression-group-box-column-first{border-top:1px solid #000}.expression-group-box-column-last{border-bottom:1px solid #000}.expression-col{float:left;margin-left:15px}.expression-col-operator{float:left;margin-left:25px;width:100px}.expression-button-bar button{margin-left:5px}"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { contextNames: [{
            type: Input
        }], item: [{
            type: Input
        }], queryMeaning: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionReferenceControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-expression-reference-control',
                template: "\r\n<div *ngIf=\"!exprRef || !referenceTypes?.length\">\r\n    No Expression Reference or reference types\r\n\r\n    Expr Ref: {{exprRef | json }}\r\n    Ref Types: {{ referenceTypes | json }}\r\n</div>\r\n<div *ngIf=\"exprRef && referenceTypes?.length>0\">\r\n    <div class=\"expr-column\">\r\n        <dw-pills [items]=\"availableReferenceTypes\" [(ngModel)]=\"exprRef.referenceType\" (ngModelChange)=\"setRefeferenceType($event)\"></dw-pills>\r\n    </div>\r\n    <div [ngSwitch]=\"exprRef.referenceType\"  class=\"expr-column\">\r\n        <ng-container *ngSwitchCase=\"'item'\">   \r\n            <p-dropdown  [options]=\"itemAttributes\"  optionLabel=\"AttributeDisplay\" display=\"chip\" optionValue=\"AttributeName\" [(ngModel)]=\"exprRef.attrName\" (ngModelChange)=\"setValue(exprRef)\" [style]=\"{'width':'100%'}\" filter=\"true\" appendTo=\"body\"></p-dropdown>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'context'\">\r\n           <div class=\"expr-column\">\r\n                <select [(ngModel)]=\"exprRef.contextName\" (ngModelChange)=\"setValue(exprRef)\" class=\"form-control\">\r\n                    <option *ngFor=\"let contextDef of contextDefs\" [ngValue]=\"contextDef.contextName\">\r\n                        {{ contextDef.contextDisplay }}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n            <div class=\"expr-column\">\r\n                <p-dropdown  [options]=\"currentContextAttributes\"  optionLabel=\"AttributeDisplay\" display=\"chip\" optionValue=\"AttributeName\" [(ngModel)]=\"exprRef.attrName\" (ngModelChange)=\"setValue(exprRef)\" [style]=\"{'width':'100%'}\" filter=\"true\" appendTo=\"body\"></p-dropdown>\r\n\r\n                <select [(ngModel)]=\"exprRef.attrName\" (ngModelChange)=\"setValue(exprRef);\" *ngIf=\"false && exprRef.contextName\" class=\"form-control\">\r\n                    <option *ngFor=\"let attr of currentContextAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n        </ng-container>\r\n        <ng-container *ngSwitchCase=\"'value'\">\r\n            <form [formGroup]=\"formGroup\" *ngIf=\"formGroup && valueFieldDef\"> \r\n               <div dwDynamicField [fieldDef]=\"valueFieldDef\" [formGroup]=\"formGroup\"></div>\r\n            </form>\r\n            <div *ngIf=\"!formGroup || !valueFieldDef\">\r\n               <input type=\"text\" [(ngModel)]=\"exprRef.value\" (ngModelChange)=\"setValue(exprRef)\" class=\"form-control\" />\r\n            </div>\r\n        </ng-container> \r\n    </div>\r\n</div>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwExpressionReferenceControlComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwContextService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionComparersService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc3.FormBuilder }]; }, { contextNames: [{
            type: Input
        }], showDisplayAttributes: [{
            type: Input
        }], relatedExprRef: [{
            type: Input
        }], item: [{
            type: Input
        }], queryMeaning: [{
            type: Input
        }], valueFieldConfig: [{
            type: Input
        }], comparerType: [{
            type: Input
        }] }); })();
const ɵDwMdChildDataSectionConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdChildDataSectionConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdChildDataSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-child-data-section-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Child Data Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Relationship</label>\r\n                    <select [(ngModel)]=\"section.relationshipName\" (ngModelChange)=\"setSectionRelationshipItems($event)\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of availableRelations\" [ngValue]=\"item.RelationshipName\">\r\n                            {{item.NamingInfo?.RelationshipDisplayName}}   <!--{{item.FkItemName}} (By {{item.FkAttributeName}}) -->\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"relationshipDisplay\">\r\n                <div dwCol=\"12\">\r\n                    {{relationshipDisplay}}<br>\r\n                    Property: {{section.propertyName }}\r\n                    <br><br>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"4\">\r\n                    <label>Child Section Type</label>\r\n                    <select [(ngModel)]=\"section.section.sectionType\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                            {{sectionDef.display}}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Exclude From Save <i class=\"fa fa-info-circle\" title=\"Excludes this child and any children from being saved.  Also makes any forms read-only\"></i></label>\r\n                                         <dw-yesno [(ngModel)]=\"section.excludeFromSave\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"9\">\r\n                            <label>Exclude Child Controls</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"section.excludeChildControls\" (ngModelChange)=\"onSectionChange()\"></p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\" [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                </dw-md-section-standard-config>       \r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>  \r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwChildDataSectionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-child-data-section',
                template: `
    <div *ngIf="invalidConfiguration" class="hide-print dw-invalid-section">
          <i class="fas fa-cog" id="icon"></i>

          <div id="message">Child Data section has an invalid configuration. ({{invalidConfigurationMessage}})</div>
    </div>
    <div [formGroup]="formGroup" *ngIf="formGroupSetup && sectionConfig">
        <ng-container [formGroupName]="formGroupName">
            <dw-dynamic-section [formConfig]="formConfig" [sectionConfig]="sectionConfig.section" [formGroup]="childFormGroup" [context]="context" [submitted]="submitted" [parentIsVisible]="visible"></dw-dynamic-section>
        </ng-container>
	</div>
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionBracketComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-expression-bracket',
                template: ` 
    <div class="group-box-outer-container">
        <div class="group-box-container"> 
            <div class="group-box-sub-container"> 
                <div class="group-box-col1">&nbsp;</div>
                <div class="group-box-col2">
                        <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
  `,
                styles: [".group-box-outer-container{border-left:1px solid #000;overflow:auto;overflow-x:hidden}.group-box-container{float:left;margin-right:20px;overflow:hidden;width:100%}.group-box-sub-container{border-bottom:1px solid #000;border-left:1px solid #000;border-top:1px solid #000;float:left;position:relative;right:calc(100% - 10px);width:100%}.group-box-col1{width:10px}.group-box-col1,.group-box-col2{float:left;left:calc(100% - 10px)}.group-box-col2{position:relative;width:calc(100% - 10px)}.group-box-inner-container{width:100%}"]
            }]
    }], function () { return []; }, null); })();
const ɵDwMdSectionPreviewComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionPreviewComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionPreviewComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-md-section-preview',
                template: "<div>\r\n    <button (click)=\"refreshPreview()\">Refresh Preview</button>\r\n\r\n    <div *ngIf=\"showPreview\">\r\n        <form [formGroup]=\"formGroup\">\r\n            <dw-dynamic-section [formConfig]=\"formConfig\" [context]=\"context\" [sectionConfig]=\"section\"\r\n                [formGroup]=\"formGroup\" [submitted]=\"submitted\"></dw-dynamic-section>\r\n\r\n            <dw-button-bar>\r\n                <button class=\"btn btn-success\" (click)=\"sampleSave()\">Sample Save</button>\r\n            </dw-button-bar>\r\n        </form>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionFormFieldConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-md-section-form-field-config',
                template: "<div *ngIf=\"selectedFieldContextMd\">\r\n    <label class=\"label\">Context: &nbsp; </label>\r\n    {{selectedFieldContextMd?.contextDef?.contextDisplay}}\r\n</div>\r\n<div>\r\n    <label class=\"label\">Field:&nbsp; </label> {{selectedField?.attrName}}\r\n</div>\r\n\r\n<dw-message [message]=\"message\"></dw-message>\r\n\r\n<p-accordion *ngIf=\"selectedField\">\r\n    <p-accordionTab [selected]=\"true\">\r\n        <ng-template pTemplate=\"header\">Basic Settings\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasBasicSettings\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Caption Override</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.label\" (ngModelChange)=\"updateField()\"\r\n                        [placeholder]=\"selectedAttr?.AttributeDisplay || ''\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Placeholder Text</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.placeholderText\" (ngModelChange)=\"updateField()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Read only Missing Data Text</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.readOnlyMissingDataText\"\r\n                        (ngModelChange)=\"updateField()\" placeholder=\"None\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    Hide Label\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.hideLabel\"\r\n                        (ngModelChange)=\"updateField()\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Info Icon Text</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.infoText\" (ngModelChange)=\"updateField()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n            </div>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n    <p-accordionTab headerOld=\"Default Value\">\r\n        <ng-template pTemplate=\"header\">Default Value\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasDefaultValue\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    <label>Use Default Value</label>\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.hasDefaultValue\"\r\n                        (ngModelChange)=\"updateField()\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <ng-container *ngIf=\"selectedField.hasDefaultValue\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <dw-default-value [(defaultValue)]=\"selectedField.defaultValue\"\r\n                            (defaultValueChange)=\"updateField()\" [contextNames]=\"contextNames\"\r\n                            [queryAttribute]=\"selectedAttr\"></dw-default-value>\r\n                    </div>\r\n                </div>\r\n            </ng-container>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n    <p-accordionTab headerOld=\"Field Layout\">\r\n        <ng-template pTemplate=\"header\">Field Layout\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasFieldLayout\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    New Row Before\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.columnItemPreferences.newRowBefore\"\r\n                        (ngModelChange)=\"updateField()\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    Span All Columns\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.columnItemPreferences.spanAllColumns\"\r\n                        (ngModelChange)=\"updateField()\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"selectedField.columnItemPreferences.spanAllColumns\">\r\n                <div dwCol=\"12\">\r\n                    <label>Column Size Override <i class=\"fa fa-info-circle\"\r\n                            title=\"Column size using a 12 column layout\"></i></label>\r\n                    <input dwNumeric type=\"number\" [(ngModel)]=\"selectedField.columnItemPreferences.columnSizeOverride\"\r\n                        (ngModelChange)=\"updateField()\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow [hidden]=\"selectedField.columnItemPreferences.spanAllColumns\">\r\n                <div dwCol=\"12\">\r\n                    <label>Skip Columns <i class=\"fa fa-info-circle\"\r\n                            title=\"Skips columns before placing this field\"></i></label>\r\n                    <input dwNumeric type=\"number\" [(ngModel)]=\"selectedField.columnItemPreferences.skipColumns\"\r\n                        (ngModelChange)=\"updateField()\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n    <p-accordionTab headerOld=\"Classes\">\r\n        <ng-template pTemplate=\"header\">Classes\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasClasess\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Label Class</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.labelClass\" (ngModelChange)=\"updateField()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Data Class</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.dataClass\" (ngModelChange)=\"updateField()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Icon Class</label>\r\n                    <input type=\"text\" [(ngModel)]=\"selectedField.iconClass\" (ngModelChange)=\"updateField()\"\r\n                        class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <b>Conditional Classes</b>\r\n            <dw-conditional-field-classes [(conditionalClasses)]=\"selectedField.conditionalFieldClasses\"\r\n                (conditionalClassesChange)=\"updateField()\" [contextNames]=\"contextNames\" [itemName]=\"itemName\"\r\n                [classNames]=\"['label','data', 'icon']\"\r\n                [classLabels]=\"['Label Classes','Data Classes', 'Icon Classes']\">\r\n            </dw-conditional-field-classes>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n    <p-accordionTab headerOld=\"Read Only/Visibility\">\r\n        <ng-template pTemplate=\"header\">Read Only/Visibility\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasReadOnlyVisible\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    Is Read Only\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.isReadOnly\"\r\n                        (ngModelChange)=\"updateField()\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    Is Read Only (Expression)\r\n                </div>\r\n                <div dwCol=\"12\">\r\n                    <div class=\"expr-column-full\">\r\n                        <dw-expression-picker-control [(ngModel)]=\"selectedField.isReadOnlyExpression\"\r\n                            (ngModelChange)=\"updateField()\" [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                        </dw-expression-picker-control>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    Is Visible (Expression)\r\n                </div>\r\n                <div dwCol=\"12\">\r\n                    <dw-expression-picker-control [(ngModel)]=\"selectedField.isVisibleExpression\"\r\n                        (ngModelChange)=\"updateField()\" [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    Rearrange Fields <i class=\"fa fa-info-circle\"\r\n                        title=\"Causes fields to move when the visiblity changes\"></i>\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.columnItemPreferences.rearrangeFieldsOnVisibleChange\"\r\n                        (ngModelChange)=\"updateField()\">\r\n                    </p-inputSwitch>\r\n                </div>\r\n            </div>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n    <p-accordionTab headerOld=\"Control Overrides\">\r\n        <ng-template pTemplate=\"header\">Control Overrides\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasControlOverrides\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <div dwRow>\r\n                <div dwCol=\"9\">\r\n                    Customize Control Type <i class=\"fa fa-info-circle\"\r\n                        title=\"Change the control type from the default (Attribute Control Type) or use a custom control\"></i>\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.useControlTypeOverride\" (ngModelChange)=\"updateField()\"\r\n                        (ngModelChange)=\"setShowControlTypeOverride($event)\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"selectedField.useControlTypeOverride\">\r\n                <div dwCol=\"9\">\r\n                    Use Custom Control\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <p-inputSwitch [(ngModel)]=\"selectedField.useCustomControl\"\r\n                        (ngModelChange)=\"updateField()\"></p-inputSwitch>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\" *ngIf=\"selectedField.useControlTypeOverride && selectedField.useCustomControl\">\r\n                    <label>Custom Control</label>\r\n                    <p-dropdown [(ngModel)]=\"selectedField.customControlTypeKey\" [options]=\"customControlTypes\"\r\n                        optionLabel=\"name\" optionValue=\"key\" display=\"chip\" [showClear]=\"true\"\r\n                        (ngModelChange)=\"setControlTypeOverride($event)\" [style]=\"{'width':'100%'}\" filter=\"true\"\r\n                        scrollHeight=\"300px\" appendTo=\"body\"></p-dropdown>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\" *ngIf=\"selectedField.useControlTypeOverride && !selectedField.useCustomControl\">\r\n                    <label>Standard Control</label>\r\n                    <dw-search-select-lookup [(ngModel)]=\"selectedField.controlTypeOverride\"\r\n                        [lookupId]=\"controlTypeLookupId\" (ngModelChange)=\"setControlTypeOverride($event)\">\r\n                    </dw-search-select-lookup>\r\n                </div>\r\n            </div>\r\n\r\n            <dw-select-lookup-config [(config)]=\"selectedField.lookupConfig\" (configChange)=\"updateField()\"\r\n                [configContext]=\"dwFormFieldContext\">\r\n            </dw-select-lookup-config>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n    <p-accordionTab headerOld=\"Control Settings\" *ngIf=\"controlOptionsComponentType\">\r\n        <ng-template pTemplate=\"header\">Control Settings\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasControlSettings\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <dw-dynamic-loader [component]=\"controlOptionsComponentType\"\r\n                (configure)=\"configureFieldControlOptionInstance($event)\"></dw-dynamic-loader>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n\r\n    <p-accordionTab headerOld=\"Validation\">\r\n        <ng-template pTemplate=\"header\">Validation\r\n            <i class=\"fas fa-wrench dw-orange ml-1\" title=\"Has Configurations\"\r\n                [hidden]=\"!fieldConfiguredOptions?.hasCustomValidation\"></i>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"content\">\r\n            <dw-field-validation-config [(config)]=\"selectedField.validationConfig\" (configChange)=\"updateField()\"\r\n                [configContext]=\"dwFormFieldContext\"></dw-field-validation-config>\r\n        </ng-template>\r\n    </p-accordionTab>\r\n\r\n</p-accordion>",
                encapsulation: ViewEncapsulation.None,
                styles: [".dw-field-list{max-height:500px;overflow:auto}.field-section{height:400px;overflow:auto;width:100%}.field-item{clear:left;margin-top:2px;width:200px}.field-item .btn{text-align:left;width:100%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }, { type: DwMetadataFormValidationBuilderService }, { type: DwSectionConfigStateService }]; }, { selectedFieldChange: [{
            type: Output
        }], selectedField: [{
            type: Input
        }], selectedAttr: [{
            type: Input
        }], itemName: [{
            type: Input
        }], contextNames: [{
            type: Input
        }], contextMdList: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicControlComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-dynamic-control',
                template: `
    <div> 
       <ng-template dw-component-host></ng-template>
    </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, { colSize: [{
            type: Input
        }], submitted: [{
            type: Input
        }], fieldDef: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
const ɵDwSearchSelectLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwSearchSelectLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSearchSelectLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-search-select-lookup',
                template: `
    <!--<p-dropdown *ngIf="setupComplete" [options]="finalLookupItems" [resetFilterOnHide]="true" [group]="useGroups" optionLabel="Display" display="chip" [optionValue]="valueAttrName" [(ngModel)]="translatedValue" [showClear]="showClear" (ngModelChange)="setTranslatedValue($event)" [style]="{'width':'100%'}" [filter]="showFilter" [virtualScroll]="virtualScroll" [itemSize]="virtualScrollItems" scrollHeight="300px" appendTo="body"></p-dropdown>-->

    <dw-control-wrapper-with-icons [showSuffix]="options?.showLink" wrapControl="true">
        <div control2>
            <p-dropdown *ngIf="setupComplete" [placeholder]="placeholder" [options]="finalLookupItems" [resetFilterOnHide]="true" [group]="useGroups" optionLabel="Display" display="chip" [optionValue]="valueAttrName" [(ngModel)]="translatedValue" [showClear]="showClear" (ngModelChange)="setTranslatedValue($event)" [style]="{'width':'100%'}" [filter]="showFilter" [virtualScroll]="virtualScroll" [itemSize]="virtualScrollItems" scrollHeight="300px" appendTo="body"></p-dropdown>
        </div>
        <div suffix style="padding:5px">
            <i [class]="options?.linkIconClass || 'fa fa-external-link'" [hidden]="options?.linkTooltip" (click)="openItem($event)"></i>
            <i [class]="options?.linkIconClass || 'fa fa-external-link'" [hidden]="!options?.linkTooltip" [title]="options?.linkTooltip" (click)="openItem($event)"></i>
        </div>
    </dw-control-wrapper-with-icons>

    <span *ngIf="additionalDataField">{{getAdditionalFieldDisplay()}}</span>

    {{lookupErorMessage}}
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwSearchSelectLookupComponent),
                        multi: true
                    }]
            }]
    }], null, { placeholder: [{
            type: Input
        }], filterShowThreshold: [{
            type: Input
        }], alwaysShowFilter: [{
            type: Input
        }], showClear: [{
            type: Input
        }], virtualScrollThreshold: [{
            type: Input
        }], virtualScrollItems: [{
            type: Input
        }] }); })();
const ɵDwAutoCompleteLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAutoCompleteLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAutoCompleteLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-auto-complete-lookup',
                template: `
        <ng-container *ngIf="!translatedValue?.Id || !options?.showChipWhenSelected">
            <p-autoComplete inputStyleClass="form-control" [(ngModel)]="translatedValue" (ngModelChange)="setTranslatedValue($event)" [disabled]="disabled" [style]="{'width':'100%'}" [suggestions]="lookupItems" (completeMethod)="searchStart($event)" field="Display" appendTo="body" baseZIndex="1100" [placeholder]="placeholder || ''" dropdown="true" dropdownMode="current"  virtualScroll="true" scrollHeight="300px">
           
            </p-autoComplete>
            <div [hidden]="!noResultMessage" class="auto-complete-no-result">
                {{noResultMessage}}
            </div>
        </ng-container>
        <ng-container *ngIf="translatedValue?.Id && options?.showChipWhenSelected">
            <dw-control-wrapper-with-icons [showSuffix]="options?.showLink" wrapControl="true">
                <div control2 class="p-multiselect" class="dw-chip-container">
                    <div class="dw-chip dw-chip-100">
                        <div class="dw-chip-label-with-remove">{{translatedValue?.Display}}</div>
                        <div class="dw-chip-icon" (click)="clearItem()"><i class="fa fa-times-circle"></i></div>
                    </div>
                </div>
                <div suffix style="padding:5px">
                    <i [class]="options?.linkIconClass || 'fa fa-external-link'" [hidden]="options?.linkTooltip" (click)="openItem($event)"></i>
                    <i [class]="options?.linkIconClass || 'fa fa-external-link'" [hidden]="!options?.linkTooltip" [title]="options?.linkTooltip" (click)="openItem($event)"></i>
                </div>
            </dw-control-wrapper-with-icons>
        </ng-container>

        {{lookupErorMessage}}
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwAutoCompleteLookupComponent),
                        multi: true
                    }]
            }]
    }], null, { placeholder: [{
            type: Input
        }], virtualScrollThreshold: [{
            type: Input
        }], virtualScrollItems: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentConfigEditComponent, [{
        type: Component,
        args: [{
                selector: 'dw-content-config-edit',
                template: "<div *ngIf=\"formGroup\">\r\n    <div dwRow *ngIf=\"hasHiddenContent\">\r\n        <div dwCol=\"10\">\r\n            <label class=\"label\">Show Hidden Content</label>\r\n            <dw-yesno [(ngModel)]=\"showMissing\"></dw-yesno>\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"preferences?.items?.length == 0\">\r\n        There are no content items for this section\r\n    </div>\r\n\r\n\r\n    <form [formGroup]=\"formGroup\">\r\n        <p-accordion formArrayName=\"items\" [multiple]=\"true\" >\r\n            <ng-container *ngFor=\"let subFormGroup of formArray.controls, index as i\">\r\n                <p-accordionTab *ngIf=\"showMissing || !subFormGroup.get('isMissing').value\" [selected]=\"activeIndex == i\" >\r\n                    <p-header>\r\n                        {{subFormGroup.get('display').value}}\r\n                    </p-header>\r\n                    <div [formGroup]=\"subFormGroup\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"2\">\r\n                                <label class=\"label\">Use Default</label>\r\n                            </div>\r\n                            <div dwCol=\"2\">\r\n                                <p-inputSwitch formControlName=\"useDefaultContent\"></p-inputSwitch>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow>\r\n                            <div dwCol=\"12\">\r\n                                <div [ngSwitch]=\"getTemplateName(subFormGroup)\">\r\n                                    <ng-container *ngSwitchCase=\"'defaultContent'\">\r\n                                        <div dwDynamicField [fieldDef]=\"itemFieldsReadOnly[i]\"\r\n                                            [formGroup]=\"subFormGroup\">\r\n                                        </div>\r\n                                    </ng-container>\r\n\r\n                                    <ng-container *ngSwitchCase=\"'editContent'\">\r\n                                        <button class=\"btn-sm btn-success\" (click)=\"copyDefaultContent(i)\"\r\n                                            title=\"Use the default content as a starting point (or recovery)\">Copy Default\r\n                                            Content</button><br>\r\n                                        <div dwDynamicField [fieldDef]=\"itemFields[i]\" [formGroup]=\"subFormGroup\">\r\n                                        </div>\r\n                                    </ng-container>\r\n\r\n                                    <ng-container *ngSwitchCase=\"'editComponent'\">\r\n                                        <dw-content-config-component [subFormGroup]=\"subFormGroup\"></dw-content-config-component>\r\n                                    </ng-container>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n            </ng-container>\r\n        </p-accordion>\r\n    </form>\r\n</div>\r\n\r\n<ng-template *editComponentTemplate>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Component</label>\r\n        <select formControlName='componentName' class=\"form-control\">\r\n            <option [ngValue]=\"null\">None</option>\r\n            <option *ngFor=\"let item of components\" [ngValue]=\"item.name\">\r\n                {{ item.name }}\r\n            </option>\r\n        </select>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template *editContentTemplate>\r\n    <button class=\"btn-sm btn-success\" (click)=\"copyDefaultContent(i)\"\r\n        title=\"Use the default content as a starting point (or recovery)\">Copy Default Content</button><br>\r\n    <div dwDynamicField [fieldDef]=\"itemFields[i]\" [formGroup]=\"formArray.controls[i]\"></div>\r\n\r\n</ng-template>\r\n\r\n<ng-template *defaultContentTemplate>\r\n    <div dwDynamicField [fieldDef]=\"itemFieldsReadOnly[i]\" [formGroup]=\"formArray.controls[i]\"></div>\r\n</ng-template>",
                styles: [""]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwUiConfigService }, { type: DwCacheService }, { type: DwModalService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentConfigWidgetComponent, [{
        type: Component,
        args: [{
                selector: 'app-dw-content-config-widget',
                template: "\r\n<div *ngIf=\"preferences\">\r\n    <h3>Content Preferences</h3>\r\n\r\n    <form [formGroup]=\"configForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n        <p-accordion>\r\n            \r\n            <p-accordionTab header=\"Content\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configContent()\" class=\"btn-sm btn-success\">\r\n                           Edit Content\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Other\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Context Data</label>\r\n                        <p-multiSelect [options]=\"contextDefList\" formControlName=\"contextNames\" display=\"chip\">\r\n                                <ng-template let-value pTemplate=\"selectedItems\">\r\n                                    <span *ngFor=\"let val of value\" class=\"btn btn-success btn-xs tag\">\r\n                                        <!-- <span class=\"tag-close\" ng-click=\"unselectedItem(item)\"> \u00D7</span> -->\r\n                                        <span>{{val}}</span>\r\n                                    </span>\r\n                                    <span *ngIf=\"!value || value.length === 0\">None</span>\r\n                                </ng-template>\r\n                        </p-multiSelect>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </form>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwEventService }, { type: DwModalService }, { type: DwContextService }, { type: DwContentService }, { type: DwUiConfigService }, { type: DwDesignerStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentManagerComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-content-manager',
                template: "<div #contentManager class=\"dw-content-manager\" dwPageDesignerSelector [configKey]=\"configKey\">\r\n    <dw-loading [show]=\"showLoading && loading\" text=\"Loading\"></dw-loading>\r\n\r\n    <div [hidden]=\"loading\">\r\n        <ng-content></ng-content>\r\n\r\n        <p-contextMenu [target]=\"contentManager\" [model]=\"contextMenu\" *ngIf=\"contextMenu && contextMenu.length>0\" appendTo=\"body\"></p-contextMenu>\r\n\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwUiConfigService }, { type: DwEventService }, { type: DwContextService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwContentService }]; }, { configKey: [{
            type: Input
        }], item: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentDirective, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: 'dw-content',
                template: `
        <dw-html-view [ngModel]="displayHtml" #element dwPageDesignerSelector [configKey]="contentManager.configKey" [sectionKey]="name">
        </dw-html-view> 

        <div #innerContent hidden="true">
            <ng-content></ng-content>
        </div>
    `
            }]
    }], function () { return [{ type: DwContentManagerComponent, decorators: [{
                type: Inject,
                args: [DwContentManagerComponent]
            }] }, { type: ɵngcc0.Renderer2 }]; }, { controlType: [{
            type: Input
        }], name: [{
            type: Input
        }], display: [{
            type: Input
        }], contentOrder: [{
            type: Input
        }], elementRef: [{
            type: ViewChild,
            args: ['innerContent']
        }] }); })();
const ɵDwWorkflowLookupButtonsComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwWorkflowLookupButtonsComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWorkflowLookupButtonsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-workflow-lookup-buttons',
                template: `
        <ng-container *ngFor="let button of buttons">
            <button class="btn btn-success {{ button.buttonConfig.buttonClass }}" [disabled]="disabled" (click)="click(button.lookupItem)" [title]="button.buttonConfig.buttonTitle || ''"> {{ button.buttonConfig.buttonText }} </button>
        </ng-container>
        {{lookupErorMessage}}
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwWorkflowLookupButtonsComponent),
                        multi: true
                    }]
            }]
    }], null, { buttonClick: [{
            type: Output
        }], workflowPreferences: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-template-config',
                template: "\r\n<ng-container *ngIf=\"formGroup && templateConfigFormGroup\">\r\n    <div [formGroup]=\"formGroup\">\r\n        <div [formGroup]=\"templateConfigFormGroup\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label class=\"label\">\r\n                        Query\r\n                    </label>\r\n                    <select formControlName=\"queryMeaning\" class=\"form-control\">\r\n                        <option [ngValue]=\"null\">\r\n                            Default\r\n                        </option>\r\n                        <option *ngFor=\"let query of queries\" [ngValue]=\"query.QueryMeaning\">\r\n                            {{query.QueryName}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n               \r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"3\">\r\n                    <label class=\"label\">\r\n                        Disabled\r\n                    </label>\r\n                   <dw-yesno formControlName=\"disabled\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <label class=\"label\">\r\n                        Test Mode\r\n                    </label>\r\n                   <dw-yesno formControlName=\"testMode\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\" *ngIf=\"templateConfigFormGroup.value?.testMode\">\r\n                    <label class=\"label\">\r\n                        Test Distribution List (Optional)\r\n                    </label>\r\n                    <dw-select-lookup formControlName=\"testDistributionListMeaning\" [lookupId]=\"emailDistributionListLookupId\" valueAttrName=\"DistributionListMeaning\"></dw-select-lookup>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"queryMetaData\">\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">\r\n                        E-mail Recipients\r\n                    </label>\r\n\r\n                    <dw-email-template-recipient-config [formGroup]=\"templateConfigFormGroup\" [userAttrs]=\"userAttrs\" [itemMetaData]=\"itemMetaData\" [templateConfig]=\"templateConfig\" [queryMetaData]=\"queryMetaData\">\r\n                    </dw-email-template-recipient-config>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"queryMetaData\">\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">\r\n                        E-mail Events\r\n                    </label>\r\n\r\n                    <dw-email-template-trigger-config [formGroup]=\"templateConfigFormGroup\" [itemMetaData]=\"itemMetaData\" [templateConfig]=\"templateConfig\" [queryMetaData]=\"queryMetaData\">\r\n                    </dw-email-template-trigger-config>\r\n                </div>\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateFieldsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-template-fields',
                template: "<div>\r\n    <h2>Template Fields</h2>\r\n\r\n    <p-accordion>\r\n        <p-accordionTab header=\"{{itemMetaData?.Display}} Fields\">\r\n            <div class=\"field-container\">\r\n                <ng-container *ngFor=\"let attr of queryMetaData?.Attributes\">\r\n                    <div *ngIf=\"includeAttr(attr)\" class=\"field-item\">\r\n                        <button class=\"btn btn-sm btn-success\" (click)=\"addItemAttr(attr)\">\r\n                            <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n                            {{attr.AttributeDisplay}}\r\n                        </button>\r\n                        <button class=\"btn btn-sm btn-success\" [hidden]=\"attr.DisplayAttributeName == attr.AttributeName\" (click)=\"addItemAttr(attr, true)\">\r\n                            <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n                            {{attr.AttributeDisplay}} - Display\r\n                        </button>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab header=\"{{itemMetaData?.Display}} Links\">\r\n            <div class=\"field-container\">\r\n                <ng-container *ngFor=\"let code of additionalItemCodes\">\r\n                    <div class=\"field-item\">\r\n                        <button class=\"btn btn-sm btn-success\" (click)=\"appendToBodyTemplate(code.templateCode);\">\r\n                            <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n                            {{code.display}}\r\n                        </button>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab *ngFor=\"let userAttr of userAttrs\" header=\"{{userAttr.Display}} Fields\">\r\n\r\n            <ng-container *ngFor=\"let attr of userItemMetaData?.Attributes\">\r\n                <div *ngIf=\"includeAttr(attr)\" class=\"field-item\">\r\n                    <button class=\"btn btn-sm btn-success\" (click)=\"addUserAttr(userAttr, attr)\">\r\n                        <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n                        {{attr.Display}}\r\n                    </button>\r\n                </div>\r\n            </ng-container>\r\n        </p-accordionTab>\r\n    </p-accordion>\r\n</div>",
                styles: [".field-item{clear:left;margin-top:2px;width:200px}.field-item .btn{text-align:left;width:100%}.field-container{max-height:500px;overflow:auto}"]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataRoutingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateTriggerConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-email-template-trigger-config',
                template: "<div [formGroup]=\"formGroup\">\r\n    <div [formArrayName]=\"fieldName\" *ngIf=\"formArray\">\r\n        <ng-container *ngFor=\"let item of formArray.controls; index as i\">\r\n            <div dwRow [formGroupName]=\"i\">\r\n                <div dwCol=\"0\">\r\n                    <br>\r\n                    <button class=\"btn btn-sm btn-danger hide-mobile\" (click)=\"removeItem(i)\" title=\"Remove Link\">\r\n                        <i class=\"fa fa-times hand\"></i>\r\n                    </button>\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <label class=\"label\">Event Type</label>\r\n                    <select formControlName=\"emailTriggerType\" class=\"form-control\">\r\n                        <option *ngFor=\"let emailTriggerType of emailTriggerTypes\" [ngValue]=\"emailTriggerType.value\">\r\n                            {{emailTriggerType.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"2\" *ngIf=\"showAttributeField(i)\">\r\n                    <label class=\"label\">Attribute</label>\r\n                    <select formControlName=\"attrName\" class=\"form-control\">\r\n                        <option *ngFor=\"let attr of itemMetaData?.Attributes\" [ngValue]=\"attr.AttributeName\">\r\n                            {{attr.Display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"2\" *ngIf=\"showOldField(i)\">\r\n                    <label class=\"label\">Old Value</label>\r\n                    <div dwDynamicField [fieldDef]=\"attrValueOldFieldDef[i]\" [formGroup]=\"formArray.controls[i]\"></div>\r\n                </div>\r\n                <div dwCol=\"2\" *ngIf=\"showNewField(i)\">\r\n                    <label class=\"label\">New Value</label>\r\n                    <div dwDynamicField [fieldDef]=\"attrValueNewFieldDef[i]\" [formGroup]=\"formArray.controls[i]\"></div>\r\n                </div>\r\n                <ng-container *ngIf=\"showElpasedTimeField(i)\">\r\n                    <div dwCol=\"2\">\r\n                        <label class=\"label\">Type</label>\r\n                        <select formControlName=\"elapsedTimeType\" class=\"form-control\">\r\n                            <option *ngFor=\"let opt of emailElapsedTimeTypes\" [ngValue]=\"opt.value\">\r\n                                {{opt.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    <div dwCol=\"2\" *ngIf=\"showDateTimeAttr(i)\">\r\n                        <label class=\"label\">Date/Time Attribute</label>\r\n                        <select formControlName=\"attrName\" class=\"form-control\">\r\n                            <option *ngFor=\"let attr of dateTimeAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                                {{attr.Display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    <div dwCol=\"2\" *ngIf=\"showDateAttr(i)\">\r\n                        <label class=\"label\">Date Attribute</label>\r\n                        <select formControlName=\"attrName\" class=\"form-control\">\r\n                            <option *ngFor=\"let attr of dateAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                                {{attr.Display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    <div dwCol=\"2\" [hidden]=\"!formArray.value[i]?.attrName\">\r\n                        <label class=\"label\">Interval</label>\r\n                        <input type=\"input\" dwNumeric formControlName=\"elapsedTimeInterval\" class=\"form-control\">\r\n\r\n                        <label class=\"label\">Repeat</label>\r\n                        <dw-yesno formControlName=\"elapsedTimeRepeat\"></dw-yesno>\r\n\r\n                        <ng-container *ngIf=\"formArray.value[i]?.elapsedTimeRepeat\">\r\n                            <label class=\"label\">Repeat Interval</label>\r\n                            <input type=\"input\" dwNumeric formControlName=\"elapsedTimeRepeatInterval\" class=\"form-control\">\r\n                        </ng-container>\r\n                    </div>\r\n                </ng-container>\r\n\r\n                <div dwCol=\"4\" *ngIf=\"itemMetaData?.ItemName\">\r\n                    <label class=\"label\">Condition</label>\r\n                    <dw-expression-picker-control formControlName=\"expression\" (ngModelChange)=\"onChange()\"\r\n                        [contextNames]=\"contextNames\" [item]=\"itemMetaData?.ItemName\"\r\n                        [queryMeaning]=\"queryMetaData?.QueryMeaning\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n\r\n            </div>\r\n        </ng-container>\r\n\r\n        <button class=\"btn btn-success\" (click)=\"addItem(true)\"><i class=\"fa fa-plus\"></i> Add</button>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { fieldName: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], templateConfig: [{
            type: Input
        }], itemMetaData: [{
            type: Input
        }], queryMetaData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateRecipientConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-email-template-recipient-config',
                template: "<div [formGroup]=\"formGroup\">\r\n    <div [formArrayName]=\"fieldName\" *ngIf=\"formArray\">\r\n        <ng-container *ngFor=\"let item of formArray.controls; index as i\">\r\n            <div dwRow [formGroupName]=\"i\">\r\n                <div dwCol=\"0\">\r\n                    <br>\r\n                    <button class=\"btn btn-sm btn-danger hide-mobile\" (click)=\"removeItem(i)\" title=\"Remove Link\">\r\n                        <i class=\"fa fa-times hand\"></i>\r\n                    </button>\r\n                </div>\r\n                <div dwCol=\"2\">\r\n                    <label class=\"label\">Address Type</label>\r\n                    <select formControlName=\"emailSendType\" class=\"form-control\">\r\n                        <option *ngFor=\"let emailSendTypes of emailSendTypes\" [ngValue]=\"emailSendTypes.value\">\r\n                            {{emailSendTypes.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"2\">\r\n                    <label class=\"label\">Recipient Type</label>\r\n                    <select formControlName=\"emailRecipientType\" class=\"form-control\">\r\n                        <option *ngFor=\"let receiverType of emailRecipientTypes\" [ngValue]=\"receiverType.value\">\r\n                            {{receiverType.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"3\" [hidden]=\"hideEmailAddress(i)\">\r\n                    <label class=\"label\">E-mail Address</label>\r\n                    <input type=\"email\" formControlName=\"emailAddress\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"3\" [hidden]=\"hideDistributionList(i)\">\r\n                    <label class=\"label\">Distribution List</label>\r\n\r\n                    <dw-select-lookup formControlName=\"distributionListMeaning\"\r\n                        [lookupId]=\"emailDistributionListLookupId\" valueAttrName=\"DistributionListMeaning\">\r\n                    </dw-select-lookup>\r\n                </div>\r\n                <div dwCol=\"3\" [hidden]=\"hideSubQuery(i)\">\r\n                    <label class=\"label\">Relationship</label>\r\n\r\n                    <select formControlName=\"relationshipMeaning\" class=\"form-control\">\r\n                        <option *ngFor=\"let relation of  itemMetaData?.Relations\" [ngValue]=\"relation.RelationshipName\">\r\n                            {{relation.NamingInfo.RelationshipDisplayName}}\r\n                        </option>\r\n                    </select>\r\n                    <div [hidden]=\"!itemQueries[item?.value?.relationshipName]?.length\">\r\n                        <label class=\"label\">Query</label>\r\n                        <select formControlName=\"prefetchQueryMeaning\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\">\r\n                                Default\r\n                            </option>\r\n                            <option *ngFor=\"let query of itemQueries[item?.value?.relationshipMeaning]\"\r\n                                [ngValue]=\"query.QueryMeaning\">\r\n                                {{query.QueryName}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                    <div [hidden]=\"!item?.value?.relationshipMeaning\">\r\n                        <label class=\"label\">E-mail Field</label>\r\n\r\n                        <select formControlName=\"attrName\" class=\"form-control\">\r\n                            <option ngValue=\"\"></option>\r\n                            <option\r\n                                *ngFor=\"let attr of additionalMetaData[buildQueryKey(item?.value?.relationshipMeaning, item?.value?.prefetchQueryMeaning)]?.Attributes\"\r\n                                [ngValue]=\"attr.AttributeName\">\r\n                                {{attr.AttributeDisplay}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwCol=\"3\" [hidden]=\"hideUserAttr(i)\">\r\n                    <label class=\"label\">Item Field</label>\r\n                    <select formControlName=\"attrName\" class=\"form-control\">\r\n                        <option ngValue=\"\"></option>\r\n                        <option *ngFor=\"let attr of userAttrs\" [ngValue]=\"attr.AttributeName\">\r\n                            {{attr.AttributeDisplay}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"4\" *ngIf=\"itemMetaData?.ItemName\">\r\n                    <label class=\"label\">Condition</label>\r\n                    <dw-expression-picker-control formControlName=\"expression\" (ngModelChange)=\"onChange()\"\r\n                        [contextNames]=\"contextNames\" [item]=\"itemMetaData?.ItemName\"\r\n                        [queryMeaning]=\"queryMetaData?.QueryMeaning\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <button class=\"btn btn-success\" (click)=\"addItem()\"><i class=\"fa fa-plus\"></i> Add</button>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { fieldName: [{
            type: Input
        }], userAttrs: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], templateConfig: [{
            type: Input
        }], itemMetaData: [{
            type: Input
        }], queryMetaData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(FaqsMetaDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaqsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwCacheService }]; }, null); })();
const ɵDwFaqsConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFaqsConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaqsConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-faqs-config',
                template: `
  <div [formGroup]="configFormGroup">
    <div dwRow>
      <div dwCol>
          <label class="label">Category Class</label>
          <input type="text" formControlName="categoryClass" class="form-control">
      </div>
    </div>
    <div dwRow>
      <div dwCol>
          <label class="label">Question Class</label>
          <input type="text" formControlName="questionClass" class="form-control">
      </div>
    </div>
    <div dwRow>
      <div dwCol>
          <label class="label">Answer Class</label>
          <input type="text" formControlName="answerClass" class="form-control">
      </div>
    </div>
  </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaqsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-faqs',
                template: "<div>\r\n    <dw-content-manager configKey=\"faqs\">\r\n        <h1>\r\n            <dw-content name=\"page-title\" display=\"Page Title\">\r\n                Frequently Asked Questions\r\n            </dw-content>\r\n        </h1>\r\n        <dw-content name=\"page-detail\" display=\"Page Detail\">\r\n            Have questions, we've got answers!\r\n        </dw-content>\r\n    </dw-content-manager>\r\n\r\n    <div *ngFor=\"let category of faqCategories\">\r\n        <div class=\"dw-form-header-only-small\" [ngClass]=\"pageConfig?.categoryClass\">\r\n            <h2>{{category.CategoryDisplay}}</h2>\r\n        </div>\r\n        <div *ngFor=\"let item of category.DwFaqItem, let i=index\">\r\n            <div class=\"question hand\" (click)=\"item.showItem=!item.showItem\" [ngClass]=\"pageConfig?.questionClass\">\r\n                {{item.Question}}\r\n            </div>\r\n\r\n            <div class=\"answer\" [ngClass]=\"pageConfig?.answerClass\">\r\n                <dw-html-view [ngModel]=\"item.Answer\" *ngIf=\"item.showItem\"></dw-html-view>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n",
                styles: [".question{font-size:17px;font-weight:700;margin-bottom:5px;margin-top:10px}.answer{font-size:14px;font-weight:400}"]
            }]
    }], function () { return [{ type: DwFaqsService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRuleConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-rule-config',
                template: "<div *ngIf=\"ruleFG\" [formGroup]=\"formGroup\">\r\n    <div [formGroup]=\"ruleFG\">\r\n        <div dwRow>\r\n            <div dwCol=\"6\">\r\n                <label class=\"label\">Rule Name</label>\r\n                <input type=\"text\" formControlName=\"ruleName\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label class=\"label\">Rule Description</label>\r\n                <textarea formControlName=\"ruleDescription\" class=\"form-control\"></textarea>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label class=\"label\">Context Names</label>\r\n\r\n                <dw-context-def-multi-select formControlName=\"contextNames\" [itemName]=\"itemName\" includeCustomContexts=\"true\">\r\n                </dw-context-def-multi-select>\r\n\r\n                <!-- <p-multiSelect [options]=\"contextDefList\" formControlName=\"contextNames\" display=\"chip\" appendTo=\"body\">\r\n                    <ng-template let-value pTemplate=\"selectedItems\">\r\n                        <span *ngFor=\"let val of value\" class=\"btn btn-success btn-xs tag\">\r\n                            <span>{{val}}</span>\r\n                        </span>\r\n                        <span *ngIf=\"!value || value.length === 0\">None</span>\r\n                    </ng-template>\r\n                </p-multiSelect> -->\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"itemNameLoaded\">\r\n            <div dwCol=\"12\">\r\n                <label class=\"label\">Expression</label>\r\n\r\n                <dw-expression-picker-control formControlName=\"expression\" [contextNames]=\"contextNamesFC?.value\" [item]=\"itemName\">\r\n                </dw-expression-picker-control>\r\n                \r\n\r\n                <!-- <dw-expression-group-control formControlName=\"expression\" [contextNames]=\"contextNamesFC?.value\"\r\n                    [item]=\"itemName\">\r\n                </dw-expression-group-control> -->\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataGridConfigColumnsModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-grid-config-columns-modal',
                template: "<ng-container *ngIf=\"selectedView\">\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <label>View</label>\r\n            <select [ngModel]=\"selectedView\" (ngModelChange)=\"changeView($event)\" class=\"form-control\">\r\n                <option *ngFor=\"let view of views\" [ngValue]=\"view\">\r\n                    {{view.display}}\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <h2 class=\"header\">Columns</h2>\r\n            <p-orderList [value]=\"selectedView.columnPreferences\" dragdrop=\"true\" controlsPosition=\"right\"\r\n                styleClass=\"dw-order-list\">\r\n                <ng-template let-item pTemplate=\"item\">\r\n                    <div class=\"order-item\">\r\n                        {{getFieldDisplay(item)}}\r\n\r\n                        <i class=\"fa fa-times hand pull-right\" (click)=\"removeItem(item)\" title=\"Remove Field\"></i>\r\n                    </div>\r\n                </ng-template>\r\n            </p-orderList>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div dwCol=\"6\">\r\n            <p-tabView cla>\r\n                <p-tabPanel header=\"Add Columns\">\r\n                    <div class=\"dw-order-list\">\r\n                        <div *ngFor=\"let attr of availableAttributes\" class=\"field-item\">\r\n                            <button class=\"btn btn-sm btn-success\" (click)=\"addItem(attr)\">\r\n                                <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n                                {{attr.AttributeDisplay}}\r\n                            </button>\r\n                        </div>\r\n                    </div>\r\n                </p-tabPanel>\r\n                <p-tabPanel header=\"Field Properties\" *ngIf=\"selectedField\">\r\n                    <p-accordion>\r\n                        <p-accordionTab header=\"Basic Settings\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"12\">\r\n                                    <label>Caption Override</label>\r\n                                    <input type=\"text\" [(ngModel)]=\"selectedField.label\" class=\"form-control\">\r\n                                </div>\r\n                            </div>\r\n                        </p-accordionTab>\r\n                    </p-accordion>\r\n                </p-tabPanel>\r\n            </p-tabView>\r\n        </div>\r\n    </div>\r\n</ng-container>",
                styles: ["@media (min-width:768px){.ui-orderlist .ui-orderlist-controls{padding:5px!important;width:50px}.ui-orderlist .ui-orderlist-list-container{width:calc(100% - 55px)}.ui-orderlist .ui-orderlist-list{height:500px}}.field-item{clear:left;margin-top:2px;width:200px}.field-item .btn{text-align:left;width:100%}.header{margin-bottom:4px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwLoggingService }]; }, { orderList: [{
            type: ViewChild,
            args: [OrderList]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorControllerService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataRoutingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorContainerComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-editor',
                template: "<div class=\"dw-panel\" *ngIf=\"editorState\" >\r\n    <div class=\"dw-panel-left\">\r\n        <p-tree [value]=\"editorState?.queryTree\" selectionMode=\"single\" [selection]=\"editorState?.selectedNode\" (selectionChange)=\"selectNode($event)\">\r\n            <ng-template let-node pTemplate=\"default\">\r\n                <span (contextmenu)=\"contextMenuClick($event, node)\">\r\n                    {{node.label}}\r\n                </span>\r\n            </ng-template>\r\n        </p-tree>  \r\n    </div>\r\n    <div class=\"dw-panel-right\">\r\n        <dw-query-panel-factory [node]=\"editorState?.selectedNode\"></dw-query-panel-factory>\r\n    </div>\r\n    \r\n    <p-contextMenu #contextMenu1 [model]=\"contextMenuItems\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-contextMenu>\r\n</div>\r\n",
                providers: [DwQueryEditorControllerService,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwQueryEditorContainerComponent),
                        multi: true
                    }],
                styles: [".move-arrow-down{display:block;margin-top:-25px}.dw-panel{height:100%;overflow:auto;width:100%}.dw-panel .dw-panel-left{float:left;height:100%;width:350px}.dw-panel .dw-panel-right{background-color:#fff;border:1px solid #c8c8c8;border-radius:3px;color:#333;float:left;height:100%;max-width:1024px;min-width:800px;padding:.571em 1em;width:calc(100% - 360px)}.dw-panel-flex{background-color:#000;display:flex;flex-flow:row;height:100%;padding:5px}.dw-panel-flex .dw-panel-left{background-color:#add8e6;display:flex;flex-direction:row;padding:5px;width:300px}.dw-panel-flex .dw-panel-right{background-color:#90ee90;display:flex;flex:3;flex-basis:100%;flex-direction:row;padding:5px}.ui-tree{width:100%}"]
            }]
    }], function () { return [{ type: DwQueryEditorControllerService }]; }, { itemChange: [{
            type: Output
        }], item: [{
            type: Input
        }], cmRoutes: [{
            type: ViewChild,
            args: ['contextMenu1']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryPanelBase, [{
        type: Directive
    }], function () { return [{ type: DwQueryEditorControllerService }]; }, { node: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryPanelSettingsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-panel-settings',
                template: "<h2>Settings</h2>\r\n\r\n<div class=\"settings-panel\" *ngIf=\"editorState?.query?.FieldSettings\">\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Load All Lookup Displays</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [(ngModel)]=\"editorState.query.FieldSettings.LoadAllLookupDisplayFields\" (ngModelChange)=\"updateState()\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Load Custom Fields</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [(ngModel)]=\"editorState.query.FieldSettings.LoadCustomFields\" (ngModelChange)=\"updateState()\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Aggregate Query</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [(ngModel)]=\"editorState.query.FieldSettings.AggregateQuery\" (ngModelChange)=\"updateState()\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Aggregate Query With Rollup</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [(ngModel)]=\"editorState.query.FieldSettings.AggregateQueryWithRollup\" (ngModelChange)=\"updateState()\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Return distinct records</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [ngModel]=\"editorState.query.PagingInfo?.Distinct\" (ngModelChange)=\"updateDistinct($event)\"></p-inputSwitch>\r\n        </div> \r\n    </div>\r\n</div>\r\n ",
                styles: [".settings-panel{max-width:400px}"]
            }]
    }], function () { return [{ type: DwQueryEditorControllerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryPanelRootComponent, [{
        type: Component,
        args: [{
                selector: 'dw-query-panel-root',
                template: "\r\n<div dwRow>\r\n    <div dwCol=\"6\">\r\n        <h2>{{fieldState?.itemMd?.Display}}</h2>\r\n    </div>\r\n    <div dwCol=\"6\">\r\n        <div class=\"pull-right\" *ngIf=\"!addingRelation\">\r\n            <button title='Add Relation' class=\"hand\" (click)=\"startAddRelation()\"><i class=\"fa fa-exchange-alt\"></i></button>    \r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<dw-query-editor-add-relation [itemMetaData]=\"fieldState.itemMd\" (completeAddRelation)=\"completeAddRelation($event)\" [(showAddRelation)]=\"addingRelation\"></dw-query-editor-add-relation>\r\n\r\n<p-tabView>\r\n    <p-tabPanel header=\"Fields\">\r\n        <dw-query-editor-fields-advanced [fieldState]=\"fieldState\" (fieldStateChange)=\"fieldStateChange($event)\"></dw-query-editor-fields-advanced>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Filters\">\r\n        <dw-query-editor-filters [filterState]=\"filterState\" (filterStateChange)=\"filterStateChange($event)\"></dw-query-editor-filters>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Sorting\">\r\n        <dw-query-editor-sort [sortState]=\"sortState\" (sortStateChange)=\"sortStateChange($event)\"></dw-query-editor-sort>\r\n    </p-tabPanel>\r\n</p-tabView>",
                styles: [".pull-right{float:right}"]
            }]
    }], function () { return [{ type: DwQueryEditorControllerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryPanelRelationComponent, [{
        type: Component,
        args: [{
                selector: 'dw-query-panel-relation',
                template: "\r\n<dw-message [(message)]=\"message\"></dw-message>\r\n\r\n<ng-container *ngIf=\"relation\">\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <h2>{{fieldState?.itemMd?.Display}}</h2>\r\n        </div>\r\n        <div dwCol=\"6\">\r\n            <div class=\"pull-right\" *ngIf=\"!addingRelation\">\r\n                <button title='Add Relation' class=\"hand\" (click)=\"startAddRelation()\"><i\r\n                        class=\"fa fa-fa fa-plus-square\"></i></button>\r\n            </div>\r\n            <div class=\"pull-right ml-1 mr-1\" *ngIf=\"!addingRelation\">\r\n                <button title='Change Relation' class=\"hand\" (click)=\"startChangeRelation()\"><i\r\n                        class=\"fa fa-edit\"></i></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <dw-query-editor-add-relation [itemMetaData]=\"fieldState.itemMd\" (completeAddRelation)=\"completeAddRelation($event)\"\r\n        *ngIf=\"fieldState?.itemMd\" [(showAddRelation)]=\"addingRelation\"></dw-query-editor-add-relation>\r\n\r\n    <dw-query-editor-fix-relation [itemMetaData]=\"parentItemMetaData\" (completeAddRelation)=\"completeFixRelation($event)\"\r\n        *ngIf=\"parentItemMetaData\" [(showAddRelation)]=\"changingRelation\"></dw-query-editor-fix-relation>\r\n\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Fields\">\r\n            <dw-query-editor-fields-advanced [fieldState]=\"fieldState\"\r\n                (fieldStateChange)=\"fieldStateChange($event)\"></dw-query-editor-fields-advanced>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Filters\">\r\n            <dw-query-editor-filters [filterState]=\"filterState\" (filterStateChange)=\"filterStateChange($event)\">\r\n            </dw-query-editor-filters>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Relation Properties\">\r\n            <dw-query-relation-settings [relationSettingState]=\"relationSettingState\"\r\n                (relationSettingStateChange)=\"relationSettingStateChange($event)\"\r\n                [relation]=\"relation\"></dw-query-relation-settings>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</ng-container>\r\n<ng-container *ngIf=\"!relation\">\r\n    <div *ngIf=\"queryNode.parentIsInvalid\">\r\n        Please fix the parent relation\r\n    </div>\r\n    <div *ngIf=\"!queryNode.parentIsInvalid\">\r\n        <ng-container *ngIf=\"!fixingRelation\">\r\n            <button (click)=\"startFixRelation()\" *ngIf=\"parentItemMetaData\" class=\"btn btn-success mr-2\">Change relationship</button>\r\n            <button (click)=\"removeRelation()\" class=\"btn btn-warning\" title=\"Remove relation and all children\">Remove Relationship</button>\r\n        </ng-container>\r\n        \r\n        <dw-query-editor-fix-relation [itemMetaData]=\"parentItemMetaData\" (completeAddRelation)=\"completeFixRelation($event)\"\r\n        *ngIf=\"parentItemMetaData\" [(showAddRelation)]=\"fixingRelation\"></dw-query-editor-fix-relation>\r\n    </div> \r\n\r\n</ng-container>",
                styles: [".pull-right{float:right}"]
            }]
    }], function () { return [{ type: DwQueryEditorControllerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryPanelTestComponent, [{
        type: Component,
        args: [{
                selector: 'dw-query-panel-test',
                template: `
    <div dwRow>
      <div dwCol>
        <label class="label">Load Count</label>
        <dw-yesno [(ngModel)]="loadCount"></dw-yesno>
      </div>
    </div>

    <dw-quick-grid [item]="item" [query]="query" [loadCount]="loadCount"></dw-quick-grid>
    
  `
            }]
    }], function () { return [{ type: DwQueryEditorControllerService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryPanelFactoryComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-panel-factory',
                template: `<ng-template dw-component-host></ng-template>`
            }]
    }], function () { return [{ type: DwQueryEditorControllerService }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { dwComponentHost: [{
            type: ViewChild,
            args: [DwComponentHost, { static: true }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorFieldsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-editor-fields',
                template: "\r\n<div dwRow *ngIf=\"fieldState\">\r\n    <div dwCol=\"6\">\r\n        <div class=\"fields-list\">\r\n            <div class=\"field-item\" [hidden]=\"!fieldState.includeRootItemFields\">\r\n                All {{ fieldState.itemMd?.Display }} Fields\r\n            </div>\r\n            <div *ngIf=\"!fieldState.includeRootItemFields\">\r\n                <div [hidden]=\"fieldState.selectedFields.length\">\r\n                    No Fields added\r\n                </div>\r\n                <div class=\"field-item\" *ngFor=\"let field of fieldState.selectedFields\">\r\n                    {{ getFieldDisplay(field) }}\r\n\r\n                    <i class=\"fa fa-times hand pull-right\" (click)=\"removeField(field)\" title=\"Remove Field\"></i>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div dwCol=\"6\">\r\n        <p-tabView>\r\n            <p-tabPanel header=\"Add Fields\">\r\n                <div *ngIf=\"fieldState.allowIncludeRootItemFields\">\r\n                    <label>Include All Fields</label>\r\n\r\n                    <dw-yesno [(ngModel)]=\"fieldState.includeRootItemFields\" (ngModelChange)='rootItemFieldsChange()'>\r\n                    </dw-yesno>\r\n                </div>\r\n                <div class=\"fields-list2\" *ngIf=\"!fieldState.includeRootItemFields\">\r\n                    <dw-field-selection [attributes]=\"availableAttributes\" (attributeClick)=\"addField($event)\" addTooltip=\"Add Field\"></dw-field-selection>\r\n\r\n                    <!-- <div *ngFor=\"let attr of availableFields\" class=\"field-item\">\r\n                        <button class=\"btn btn-sm btn-success\" (click)=\"addField(attr)\">\r\n                            <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n                            {{attr.Display}}\r\n                        </button>\r\n                    </div> -->\r\n                </div>\r\n            </p-tabPanel>\r\n            <p-tabPanel header=\"Field Properties\" *ngIf=\"selectedAttribute\">\r\n                <p-accordion>\r\n                    <p-accordionTab header=\"Basic Settings\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"12\">\r\n                                <label>Caption Override</label>\r\n                                <input type=\"text\" class=\"form-control\">\r\n                            </div>\r\n                        </div>\r\n                    </p-accordionTab>\r\n                </p-accordion>\r\n            </p-tabPanel>\r\n        </p-tabView>\r\n    </div>\r\n</div>\r\n\r\n",
                styles: [".max-width{max-width:800px}.fields-list2{height:516px;overflow:auto}.fields-list{border:1px solid #000;height:600px;overflow:auto;padding:1px;width:100%}.fields-list .field-item{cursor:pointer;padding:5px;width:100%}.fields-list .field-item-selected{background-color:#53a0e4;color:#fff}.fields-list .field-item:hover{background-color:#eaeaea;color:#333}.pull-right{float:right}"]
            }]
    }], function () { return []; }, { fieldStateChange: [{
            type: Output
        }], fieldState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorAddRelationComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-editor-add-relation',
                template: "<div *ngIf=\"showAddRelation && itemMetaData.Relations\" class=\"card\">\r\n    <div class=\"card-body\">\r\n        <h5 class=\"card-title\">Add Relation</h5>\r\n\r\n        <div class=\"card-text\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Relations</label>\r\n                    <p-dropdown [style]=\"{'width':'100%'}\" placeholder=\"Select Relation\"\r\n                        [options]=\"itemMetaData.Relations\" [(ngModel)]=\"selectedRelation\" place\r\n                        optionLabel=\"NamingInfo.RelationshipDisplayName\" filter=\"true\" virtualScroll=\"true\"\r\n                        itemSize=\"30\" autoDisplayFirst=\"false\">\r\n                        <ng-template let-item pTemplate=\"selectedItem\">\r\n                            {{item?.NamingInfo?.RelationshipDisplayName }}\r\n                        </ng-template>\r\n                        <ng-template let-item pTemplate=\"item\">\r\n                            {{item?.NamingInfo?.RelationshipDisplayName }}\r\n                        </ng-template>\r\n                    </p-dropdown>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <dw-button-bar>\r\n            <button class=\"btn btn-success\" (click)=\"okClick()\">Add relation</button>\r\n            <button class=\"btn btn-danger\" (click)=\"close()\">Cancel</button>\r\n        </dw-button-bar>\r\n    </div>\r\n</div>"
            }]
    }], function () { return []; }, { completeAddRelation: [{
            type: Output
        }], cancelAddRelation: [{
            type: Output
        }], showAddRelationChange: [{
            type: Output
        }], showAddRelation: [{
            type: Input
        }], itemMetaData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryRelationSettingsComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-relation-settings',
                template: "<div dwRow>\r\n    <div class=\"col-md-5\" *ngIf=\"relationSettingState\">\r\n        <div dwRow>\r\n            <div class=\"col-md-12\">\r\n                <label class=\"label\">Field Name Prefix</label>\r\n                <input type=\"text\" [(ngModel)]=\"relationSettingState.fieldPrefix\"\r\n                    (ngModelChange)=\"relationStateChange()\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div class=\"col-md-12\">\r\n                <label class=\"label\">Field Display Prefix</label>\r\n                <input type=\"text\" [(ngModel)]=\"relationSettingState.fieldDisplayPrefix\"\r\n                    (ngModelChange)=\"relationStateChange()\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div class=\"col-md-12\">\r\n                <label class=\"label\">Join Type</label>\r\n                <select [(ngModel)]=\"relationSettingState.joinType\" (ngModelChange)=\"relationStateChange()\"\r\n                    class=\"form-control\">\r\n                    <option *ngFor=\"let item of joinTypesList\" [ngValue]=\"item.value\">\r\n                        {{item.display}}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-7\" *ngIf=\"relation\">\r\n        <div dwRow>\r\n            <div class=\"col-md-12\">\r\n                <label class=\"label\">Relation Name</label> \r\n                <div class=\"form-control\">\r\n                    {{relation?.RelationshipName}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div class=\"col-md-12\">\r\n                <label class=\"label\">Relationship Deatils</label> \r\n                <div class=\"form-control\" style=\"height:auto\">\r\n                    {{relationDesc}}\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <!-- <label class=\"label\">Relation Name</label> <br>{{relation?.RelationshipName}}<br>\r\n        <label class=\"label\">Relationship Deatils</label> <br>{{relationDesc}} -->\r\n    </div>\r\n</div>\r\n<!-- <div class=\"settings-panel\" *ngIf=\"relationSettingState\">\r\n\r\n</div> -->",
                styles: [".settings-panel{max-width:400px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { relationSettingState: [{
            type: Input
        }], relationSettingStateChange: [{
            type: Output
        }], relation: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorFiltersComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-editor-filters',
                template: "<dw-expression-group-control [item]=\"filterState?.item\" [(ngModel)]=\"expressionGroup\" (ngModelChange)=\"expressionGroupChange($event)\">\r\n</dw-expression-group-control>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwQueryFilterConverterService }]; }, { filterStateChange: [{
            type: Output
        }], filterState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQuerySectionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-query-section',
                template: "<div *ngIf=\"formGroup && itemNameLoaded\" [formGroup]=\"formGroup\">\r\n    <dw-query-editor [item]=\"itemName\" (itemChange)=\"handleItemChange($event)\" formControlName=\"Query\"></dw-query-editor>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionVisibilityConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-expression-visibility-config',
                template: "<ng-container *ngIf=\"config\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Type</label>\r\n        </div>\r\n        <div dwCol=\"12\">\r\n            <dw-radio-list class=\"form-control\"  [(ngModel)]=\"config.visiblilityType\" (ngModelChange)=\"onChange()\" [values]=\"visibiltyTypes\"></dw-radio-list>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.visiblilityType !== 'none'\">\r\n        <div dwCol=\"12\">\r\n            <label>Expression</label>\r\n        </div>\r\n        <div dwCol=\"12\">\r\n            <dw-expression-picker-control  [(ngModel)]=\"config.expression\" (ngModelChange)=\"onChange()\" [queryMeaning]=\"configContext.metaDataQueryMeaning\" [contextNames]=\"configContext.contextNames\"  [item]=\"configContext.itemName\">\r\n            </dw-expression-picker-control>\r\n        </div>\r\n    </div>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiMetadataRegistrationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorSortComponent, [{
        type: Component,
        args: [{
                selector: 'dw-query-editor-sort',
                template: "\r\n<div class=\"row\" *ngFor=\"let order of sortState.order\">\r\n  <div dwCol=\"6\">\r\n    <label>Field</label>\r\n <select class=\"form-control\" [(ngModel)]=\"order.Field.FullFieldName\" (ngModelChange)=\"sortChanged()\">\r\n      <option *ngFor=\"let attr of availableFields\" [ngValue]=\"attr.fullFieldName\">\r\n        {{attr.sortDisplay}}\r\n      </option>\r\n    </select>\r\n  </div>\r\n  <div dwCol=\"2\">\r\n    <label>Is Ascending</label><br>\r\n    <p-inputSwitch [(ngModel)]=\"order.IsAscending\" (ngModelChange)=\"sortChanged()\"></p-inputSwitch>\r\n  </div>\r\n  <div dwCol=\"1\">\r\n    <br>\r\n    <i class=\"fa fa-times\" (click)=\"removeSort(order)\" title=\"removeSort()\"></i>\r\n  </div>\r\n\r\n</div>\r\n\r\n<button class=\"btn btn-success\" (click)=\"addSort()\">Add Sort</button>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { sortStateChange: [{
            type: Output
        }], sortState: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEventConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-event-config',
                template: "\r\n<ng-container *ngIf=\"formGroup && eventConfigFormGroup\">\r\n    <div [formGroup]=\"formGroup\">\r\n        <div [formGroup]=\"eventConfigFormGroup\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">\r\n                        Event Triggers\r\n                    </label>\r\n\r\n                    <dw-event-trigger-config [formGroup]=\"eventConfigFormGroup\" [itemMetaData]=\"itemMetaData\" [eventConfig]=\"eventConfig\">\r\n                    </dw-event-trigger-config>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label class=\"label\">\r\n                        Event Handler\r\n                    </label>\r\n                    <select formControlName=\"eventHandlerKeyName\" class=\"form-control\">\r\n                        <option *ngFor=\"let eventHandler of eventHandlers\" [ngValue]=\"eventHandler.keyName\">\r\n                            {{eventHandler.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"configComponent\">\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">\r\n                        Component Config\r\n                    </label>\r\n                    <dw-dynamic-loader [component]=\"configComponent\" (configure)=\"setupConfigComponent($event)\"></dw-dynamic-loader>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-container>\r\n"
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEventTriggerComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-event-trigger-config',
                template: "\r\n<div [formGroup]=\"formGroup\">\r\n\r\n    \r\n    <div [formArrayName]=\"fieldName\" *ngIf=\"formArray\">\r\n        <div *ngIf=\"formArray.controls.length === 0\">\r\n            No Trigger configured.  Please add at least one trigger\r\n        </div>\r\n        <ng-container *ngFor=\"let item of formArray.controls; index as i\">\r\n            <div dwRow [formGroup]=\"formArray.controls[i]\">\r\n                <div dwCol=\"0\">\r\n                    <br>\r\n                    <button class=\"btn btn-sm btn-danger hide-mobile\" (click)=\"removeItem(i)\" title=\"Remove Link\">\r\n                        <i class=\"fa fa-times hand\"></i>\r\n                    </button>\r\n                </div>\r\n                <div dwCol=\"3\">\r\n                    <label class=\"label\">Event Type</label>\r\n                    <select formControlName=\"eventTriggerType\" class=\"form-control\">\r\n                        <option *ngFor=\"let eventTriggerType of availableTriggerTypes\" [ngValue]=\"eventTriggerType.value\">\r\n                            {{eventTriggerType.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"2\" *ngIf=\"showAttributeField(i)\">\r\n                    <label class=\"label\">Attribute</label>\r\n                    <select formControlName=\"attrName\" class=\"form-control\">\r\n                        <option *ngFor=\"let attr of itemMetaData?.Attributes\" [ngValue]=\"attr.AttributeName\">\r\n                            {{attr.Display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"2\" *ngIf=\"showOldField(i)\">\r\n                    <label class=\"label\">Old Value</label>\r\n                    <div dwDynamicField [fieldDef]=\"attrValueOldFieldDef[i]\" [formGroup]=\"formArray.controls[i]\"></div>\r\n                </div>\r\n                <div dwCol=\"2\" *ngIf=\"showNewField(i)\">\r\n                    <label class=\"label\">New Value</label>\r\n                    <div dwDynamicField [fieldDef]=\"attrValueNewFieldDef[i]\" [formGroup]=\"formArray.controls[i]\"></div>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n\r\n        <button class=\"btn btn-success\" (click)=\"addItem(true)\"><i class=\"fa fa-plus\"></i> Add</button>\r\n    </div>\r\n</div>"
            }]
    }], function () { return []; }, { fieldName: [{
            type: Input
        }], formGroup: [{
            type: Input
        }], eventConfig: [{
            type: Input
        }], itemMetaData: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdEventRepositoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwCacheService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdEventHandlerOrchestratorService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwMdEventService }, { type: DwMdEventRepositoryService }, { type: DwUiConfigRegistryService }, { type: ɵngcc0.Injector }]; }, null); })();
const ɵDwMdSectionTextConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionTextConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionTextConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-section-text-config',
                template: "<p-tabView>\r\n    <p-tabPanel header=\"Text Configuration\">\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <dw-html-edit [(ngModel)]=\"section.htmlContent\" (ngModel)=\"onSectionChange()\" [fieldSources]=\"htmlEditFieldSources\"></dw-html-edit>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"4\">\r\n                <label>Blank Replacement Value</label>\r\n                <input type=\"text\" [(ngModel)]=\"section.blankReplacementValue\" (ngModel)=\"onSectionChange()\" class=\"form-control\" placeholder=\"None\">\r\n            </div>\r\n        </div>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Section Configuration\">\r\n        <div>\r\n            <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"\r\n                [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\" [showReadOnlySection]=\"false\">\r\n            </dw-md-section-standard-config>\r\n        </div>\r\n    </p-tabPanel>\r\n</p-tabView>",
                encapsulation: ViewEncapsulation.None,
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTextSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-text-section',
                template: `
      <!-- <dw-html-view [(ngModel)]="htmlContent" *ngIf="false">
       </dw-html-view>-->

      <dw-template-view-control [item]="itemName" [queryMetaData]="queryMetaData" [templateText]="sectionConfig.htmlContent"
        [dataSubject]="dataSubjectResult?.subject" [context]="context" isHtml="true">
      
      </dw-template-view-control>
  `
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwTemplateUtilService }, { type: DwContextService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwMetaDataFormStateService }]; }, null); })();
const ɵDwAutoCompleteLookupReadOnlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAutoCompleteLookupReadOnlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAutoCompleteLookupReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-autocomplete-readonly',
                template: `<div class="read-only">{{ currentLookup?.Display || missingDataText  }}<div>
  {{lookupErorMessage}}
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwAutoCompleteLookupReadOnlyComponent),
                        multi: true
                    }]
            }]
    }], null, { missingDataText: [{
            type: Input
        }] }); })();
const ɵDwLookupReadonlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwLookupReadonlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLookupReadonlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-lookup-readonly',
                template: `<div class="read-only">{{ currentLookup?.Display || missingDataText }}</div>
  {{lookupErorMessage}}
   
   `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwLookupReadonlyComponent),
                        multi: true
                    }]
            }]
    }], null, { missingDataText: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlCalcFieldTesterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fc-calc-tester',
                template: `
    <div> <b>Formula Tester</b>
        <div dwRow>
            <div dwCol="9">
                <label>Show inputs</label>
            </div>
            <div dwCol="3">
                <p-inputSwitch [(ngModel)]="showInputs"></p-inputSwitch>
            </div>
        </div>
        <div [formGroup]="formGroup">
            <ng-container *ngIf="showInputs">
                <div dwRow *ngFor="let attr of displayAttributes">
                    <div dwCol="12">
                        <label>{{attr.Display}}</label>
                        <input type="text" class="form-control" [formControlName]="attr.AttributeName">
                    </div>
                </div>

                 <hr>
            </ng-container>

            <div dwRow>
                <div dwCol="12">
                    <label>Calculated result</label>
                    <dw-calc formControlName="calcField" [options]="options"></dw-calc>
                </div>
            </div>
        </div>
    </div>
    `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwCalcService }]; }, { options: [{
            type: Input
        }], itemName: [{
            type: Input
        }] }); })();
const ɵDwMultiSelectLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMultiSelectLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiSelectLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-multi-select-lookup',
                template: `
        <p-multiSelect *ngIf="loadComplete" [options]="finalLookupItems" [group]="useGroups" optionLabel="Display" display="chip" [optionValue]="valueAttrName" [(ngModel)]="translatedValue" display="chip" [filter]="showFilter" (ngModelChange)="setTranslatedValue($event)" [virtualScroll]="virtualScroll" [itemSize]="virtualScrollItems" [style]="{'width':'100%'}" appendTo="body" baseZIndex="2000" autoZIndex="false" [ngClass]="{ 'multi-edit-auto-expand': autoExpand }"></p-multiSelect>
        {{lookupErorMessage}}
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwMultiSelectLookupComponent),
                        multi: true
                    }]
            }]
    }], null, { mapToArray: [{
            type: Input
        }], mapToNumber: [{
            type: Input
        }], autoExpand: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataGridConfigColumnsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-grid-config-columns',
                template: "<dw-ui-config-list [items]=\"columns\" [config]=\"listConfig\" [selectedItem]=\"selectedColumn\" size=\"large\"\r\n  (selectedItemChange)=\"setSelectedColumn($event)\" (removeItem)=\"removeItem($event)\" (reorder)=\"reorderList()\">\r\n  <div addItemsTab>\r\n    <p-accordion>\r\n      <p-accordionTab header=\"Field Columns\" [selected]=\"true\">\r\n        <span [hidden]=\"availableAttributes?.length>0\">\r\n          All fields have been added!\r\n        </span>\r\n    \r\n        <dw-field-selection [attributes]=\"availableAttributes\" (attributeClick)=\"addItem($event)\" addTooltip=\"Add Field\"></dw-field-selection>\r\n      </p-accordionTab>\r\n      <p-accordionTab header=\"Other Columns\">\r\n          <div *ngFor=\"let customColumnDef of customColumnDefs\" class=\"dw-field-item\">\r\n              <button class=\"btn btn-sm btn-success\" (click)=\"addCustomColumn(customColumnDef)\">\r\n                  <i class=\"fa fa-plus-circle hand\" title=\"Add Column\"></i>\r\n                  {{customColumnDef.display}}\r\n              </button>\r\n          </div>\r\n      </p-accordionTab>\r\n  </p-accordion>\r\n\r\n  </div>\r\n  <div actionBar>\r\n    <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n  </div>\r\n  <div configureItemTab>\r\n    <dw-metadata-grid-config-column [useColumnFlex]=\"useColumnFlex\" [(columnPreference)]=\"selectedColumn\"  (columnPreferenceChange)=\"onColumnsChange()\" [attribute]=\"selectedAttr\" [configContext]=\"configContext\" [queryMetaData]=\"queryMetaData\">\r\n    </dw-metadata-grid-config-column>\r\n\r\n  </div>\r\n</dw-ui-config-list>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataGridService }, { type: DwLoggingService }, { type: DwUiConfigRegistryService }]; }, { columnsChange: [{
            type: Output
        }], columns: [{
            type: Input
        }], configContext: [{
            type: Input
        }], gridPreferences: [{
            type: Input
        }], useColumnFlex: [{
            type: Input
        }], inlineEditEnabled: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFilterItemBase, [{
        type: Directive
    }], function () { return []; }, { filterChange: [{
            type: Output
        }], filter: [{
            type: Input
        }], item: [{
            type: Input
        }], queryMetaData: [{
            type: Input
        }], filterConfig: [{
            type: Input
        }], resolvedContext: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAllTextFieldsCustomFilterConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-all-text-fields-custom-filter-config',
                template: "<div>\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n          <label>Include All Attributes</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n          <p-inputSwitch [(ngModel)]=\"config.includeAllAttributes\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"config.includeAllAttributes\">\r\n      <div dwCol=\"12\">\r\n        <label>Attributes</label>\r\n        <p-multiSelect [options]=\"primeAttributes\" [(ngModel)]=\"config.includeAttributes\" (ngModelChange)=\"onChange()\" class=\"multi-edit-auto-expand\" display=\"chip\" [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Exclude Primary Key <i class=\"fa fa-info-circle\" title=\"Prevents using numeric search to include the Primary Key\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.excludePk\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Prevented Named Search <i class=\"fa fa-info-circle\" title=\"Prevents searching a specific field (e.g. 'JN:35353' - searches Job Number)\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.preventNamedSearch\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAllTextFieldFilterService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAllTextFieldsCustomFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-all-text-fields-custom-filter',
                template: `
    <label class='label'>{{ filterConfig.label || 'Text Search'}}</label>
    <input type="text" class="form-control" [ngModel]='textFilterValue' (ngModelChange)="textFilterValueChange($event)"/>
  `
            }]
    }], function () { return [{ type: DwAllTextFieldFilterService }, { type: ɵngcc2.Router }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteBaseConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-base-config',
                template: `
  <div *ngIf="routeConfigFG" [formGroup]="routeConfigFG">
    <div dwRow>
      <div dwCol="12">
          <label>Component Page Override <i class="fas fa-info-circle" title="Shows global components which have the DwComponent decorator and a component type of Page"></i></label>
          <select formControlName="componentOverride" class="form-control">
              <option [ngValue]="null">None</option>
              <option *ngFor="let item of components" [ngValue]="item.key">
                {{ item.name }}
              </option>
          </select>
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
        <label>Include In Group <i class="fa fa-info-circle"
            title="Groups menus based on a Group Display on any submenus"></i></label>
      </div>
      <div dwCol="3">
        <p-inputSwitch formControlName="includeInGroup"></p-inputSwitch>
      </div>
    </div>
    <div dwRow *ngIf="routeConfigFG?.value?.includeInGroup">
      <div dwCol="12">
        <label>Group Display<i class="fa fa-info-circle"
            title="Groups menus based on a Group Display on any submenus"></i></label>
        <input type="text" class="form-control" formControlName="groupDisplay" />
      </div>
    </div>
    <div dwRow *ngIf="componentOverride?.configComponent">
      <div dwCol="12">
          <h2>Component Config</h2>
          <hr>
          <dw-ui-child-config-host [component]="componentOverride.configComponent" [(config)]="componentConfigFC.value" (configChange)="updateComponentConfig($event)">
          </dw-ui-child-config-host>

      </div>
    </div>
     <div dwRow>
      <div dwCol="12">
          <label>Menu Component Override  2 <i class="fas fa-info-circle" title="Overides the menu display and only shows components of type Menu Component"></i></label>
          <select formControlName="menuComponentOverride" class="form-control">
              <option [ngValue]="null">None</option>
              <option *ngFor="let item of menuComponents" [ngValue]="item.key">
                {{ item.name }}
              </option>
          </select>
      </div>
    </div>
  </div>
  `
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { routeConfigFG: [{
            type: Input,
            args: ['routeConfigFormGroup']
        }], route: [{
            type: Input
        }], routeTypeProcessorRegistration: [{
            type: Input
        }] }); })();
const ɵDwListRouteConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwListRouteConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListRouteConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-list-route-config',
                template: "<div *ngIf=\"routeConfigFG\" [formGroup]=\"routeConfigFG\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Component Type</label>\r\n      <select formControlName=\"listRouteSubType\" class=\"form-control\">\r\n        <option value=\"grid\">Grid</option>\r\n        <option value=\"list\">List</option>\r\n        <option value=\"custom\">Custom</option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"listRouteSubType.value === 'custom'\">\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Custom Component <i class=\"fas fa-info-circle\"\r\n          title=\"Shows global components or components for this meta data item which have the DwComponent decorator and a component type of Page\"></i></label>\r\n      <select formControlName=\"componentOverride\" class=\"form-control\">\r\n        <option [ngValue]=\"null\">None</option>\r\n        <option *ngFor=\"let item of components\" [ngValue]=\"item.key\">\r\n          {{ item.name }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Config Key</label>\r\n      <input type=\"text\" formControlName=\"configKeyPart\" class=\"form-control\">\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Replace Side Menu <i class=\"fa fa-info-circle\"\r\n          title=\"Use this menu's children as the side menu\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch formControlName=\"replaceSideMenu\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"routeConfigFG?.value?.replaceSideMenu\">\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Side Menu Component <i class=\"fas fa-info-circle\"\r\n          title=\"Replaces the standard side replacement menu with a custom component\"></i></label>\r\n      <select formControlName=\"sideMenuComponent\" class=\"form-control\">\r\n        <option [ngValue]=\"null\">None</option>\r\n        <option *ngFor=\"let item of sideMenuComponents\" [ngValue]=\"item.key\">\r\n          {{ item.name }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div> \r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Include In Group <i class=\"fa fa-info-circle\"\r\n          title=\"Groups menus based on a Group Display on any submenus\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch formControlName=\"includeInGroup\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"routeConfigFG?.value?.includeInGroup\">\r\n    <div dwCol=\"12\">\r\n      <label>Group Display <i class=\"fa fa-info-circle\"\r\n          title=\"Groups menus based on a Group Display on any submenus\"></i></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"groupDisplay\" />\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"componentOverride?.configComponent\">\r\n    <div dwCol=\"12\">\r\n      <label>Component Config</label>\r\n      <dw-ui-child-config-host [component]=\"componentOverride.configComponent\" [(config)]=\"componentConfigFC.value\"\r\n        (configChange)=\"updateComponentConfig($event)\">\r\n      </dw-ui-child-config-host>\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>Menu Component Override  4 <i class=\"fas fa-info-circle\" title=\"Overides the menu display and only shows components of type Menu Component\"></i></label>\r\n        <select formControlName=\"menuComponentOverride\" class=\"form-control\">\r\n            <option [ngValue]=\"null\">None</option>\r\n            <option *ngFor=\"let item of menuComponents\" [ngValue]=\"item.key\">\r\n              {{ item.name }}\r\n            </option>\r\n        </select>\r\n    </div>\r\n  </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteTypeProcessorBase, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }]; }, null); })();
const ɵDwListRouteProcessor_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwListRouteProcessor);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListRouteProcessor, [{
        type: Injectable
    }], null, null); })();
const ɵDwMenuRouteConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMenuRouteConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuRouteConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-menu-route-config',
                template: "<div *ngIf=\"routeConfigFG\" [formGroup]=\"routeConfigFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Component Override <i class=\"fas fa-info-circle\"\r\n                    title=\"Shows global components which have the DwComponent decorator and a component type of Page\"></i></label>\r\n            <select formControlName=\"componentOverride\" class=\"form-control\">\r\n                <option [ngValue]=\"null\">None</option>\r\n                <option *ngFor=\"let item of components\" [ngValue]=\"item.key\">\r\n                    {{ item.name }}\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Replace Side Menu <i class=\"fa fa-info-circle\"\r\n                    title=\"Use this menu's children as the side menu\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"replaceSideMenu\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"routeConfigFG?.value?.replaceSideMenu\">\r\n        <div dwCol=\"9\">\r\n            <label>Hide Back Button <i class=\"fa fa-info-circle\"\r\n                    title=\"Hide the back button in the replacement menu\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"hideReplaceSideMenuBackButton\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"routeConfigFG?.value?.replaceSideMenu\">\r\n        <div dwCol=\"12\">\r\n            <label>Side Menu Component <i class=\"fas fa-info-circle\"\r\n                    title=\"Replaces the standard side replacement menu with a custom component\"></i></label>\r\n            <select formControlName=\"sideMenuComponent\" class=\"form-control\">\r\n                <option [ngValue]=\"null\">None</option>\r\n                <option *ngFor=\"let item of sideMenuComponents\" [ngValue]=\"item.key\">\r\n                    {{ item.name }}\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Hide Children on Menu Page <i class=\"fa fa-info-circle\"\r\n                    title=\"Shows this menu group as a single item on menu pages\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"hideChildOnMenuPage\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Auto Navigate to First Child <i class=\"fa fa-info-circle\"\r\n                    title=\"When clicked, navigates to the first child menu\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"navigateToFirstChild\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <!-- <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Use Large Icon View <i class=\"fa fa-info-circle\"\r\n                    title=\"Shows large icons for menus without children\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"useLargeIconView\"></p-inputSwitch>\r\n        </div>\r\n    </div> -->\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Include In Group <i class=\"fa fa-info-circle\"\r\n                    title=\"Groups menus based on a Group Display on any submenus\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"includeInGroup\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"routeConfigFG?.value?.includeInGroup\">\r\n        <div dwCol=\"12\">\r\n            <label>Group Display <i class=\"fa fa-info-circle\"\r\n                    title=\"Groups menus based on a Group Display on any submenus\"></i></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"groupDisplay\" />\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"!routeConfigFG?.value?.includeInGroup\">\r\n        <div dwCol=\"9\">\r\n            <label>Show As Group <i class=\"fa fa-info-circle\" title=\"Shows all child items in a group\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"showAsGroup\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"componentOverride?.configComponent\">\r\n        <div dwCol=\"12\">\r\n            <h2>{{componentOverride.name}} Config</h2>\r\n            <hr>\r\n            <dw-dynamic-loader [component]=\"componentOverride.configComponent\"\r\n                (configure)=\"configureChildConfigComponent($event)\"></dw-dynamic-loader>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Menu Component Override 5 <i class=\"fas fa-info-circle\"\r\n                    title=\"Overides the menu display and only shows components of type Menu Component\"></i></label>\r\n            <select formControlName=\"menuComponentOverride\" class=\"form-control\">\r\n                <option [ngValue]=\"null\">None</option>\r\n                <option *ngFor=\"let item of menuComponents\" [ngValue]=\"item.key\">\r\n                    {{ item.name }}\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
const ɵDwMenuRouteProcessor_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMenuRouteProcessor);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuRouteProcessor, [{
        type: Injectable
    }], null, null); })();
const ɵDwComponentRouteConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwComponentRouteConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwComponentRouteConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-component-route-config',
                template: `
  <div *ngIf="routeConfigFG" [formGroup]="routeConfigFG">
    <div dwRow>
      <div dwCol="12">
          <label class="label">Component   <i class="fas fa-info-circle" title="Shows global components which have the DwComponent decorator and a component type of Page"></i></label>
          <select formControlName="componentOverride" class="form-control">
              <option [ngValue]="null">Select a Component</option>
              <option *ngFor="let item of components" [ngValue]="item.key">
                {{ item.name }}
              </option>
          </select>
      </div>
    </div>
    <div dwRow *ngIf="componentOverride?.configComponent">
      <div dwCol="12">
          <h2>{{componentOverride.name}}  Config</h2>
          <hr>
          <dw-ui-child-config-host [component]="componentOverride.configComponent" [(config)]="componentConfigFC.value" (configChange)="updateComponentConfig($event)">
          </dw-ui-child-config-host>
      </div>
    </div>
    <div dwRow>
      <div dwCol="12">
          <label>Menu Component Override  6 <i class="fas fa-info-circle" title="Overides the menu display and only shows components of type Menu Component"></i></label>
          <select formControlName="menuComponentOverride" class="form-control">
              <option [ngValue]="null">None</option>
              <option *ngFor="let item of menuComponents" [ngValue]="item.key">
                {{ item.name }}
              </option>
          </select>
      </div>
    </div>
  </div>
  `
            }]
    }], null, null); })();
const ɵDwComponentRouteProcessor_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwComponentRouteProcessor);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwComponentRouteProcessor, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentComponent, [{
        type: Component,
        args: [{
                selector: 'dw-content-component',
                template: `
    <dw-dynamic-loader [component]="currentComponent" (configure)="setupComponent($event)"></dw-dynamic-loader>
  `
            }]
    }], function () { return [{ type: DwContentManagerComponent, decorators: [{
                type: Inject,
                args: [DwContentManagerComponent]
            }] }, { type: DwUiConfigRegistryService }]; }, { name: [{
            type: Input
        }], display: [{
            type: Input
        }], contentOrder: [{
            type: Input
        }], component: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContentConfigComponentComponent, [{
        type: Component,
        args: [{
                selector: 'dw-content-config-component',
                template: "<div [formGroup]=\"subFormGroup\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Component</label>\r\n      <select formControlName='componentName' class=\"form-control\">\r\n        <option [ngValue]=\"null\">None</option>\r\n        <option *ngFor=\"let item of componentList\" [ngValue]=\"item.key\">\r\n          {{ item.name }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <dw-dynamic-loader [component]=\"configComponent\" (configure)=\"setupConfigComponent($event)\"></dw-dynamic-loader>\r\n    </div>\r\n  </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, { subFormGroup: [{
            type: Input
        }] }); })();
const ɵDwActionRouteConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwActionRouteConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionRouteConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-route-config',
                template: "<div *ngIf=\"routeConfigFG\" [formGroup]=\"routeConfigFG\">\r\n    <div dwRow>\r\n      <div dwCol=\"12\" >\r\n        <label class=\"label\">Action</label>\r\n        <select formControlName=\"actionKey\" class=\"form-control\">\r\n          <option [ngValue]=\"null\">None</option>\r\n          <option *ngFor=\"let actionItem of actionItems\" [ngValue]=\"actionItem.keyName\">\r\n            {{ actionItem.display }}\r\n          </option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n\r\n    <div dwRow *ngIf=\"currentActionItem?.configComponent\">\r\n      <div dwCol=\"12\">\r\n        <dw-dynamic-loader [component]=\"currentActionItem?.configComponent\" (configure)=\"configureActionConfigComponent($event)\"></dw-dynamic-loader>\r\n      </div>\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();
const ɵDwActionRouteProcessor_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwActionRouteProcessor);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwActionRouteProcessor, [{
        type: Injectable
    }], null, null); })();
const ɵDwRouteActionExternalLinkConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwRouteActionExternalLinkConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteActionExternalLinkConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-action-external-link-config',
                template: `
  <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
    <div dwRow>
      <div dwCol="12">
          <label>External Url with Query string <i class="fa fa-info-circle" title="Add any additional query string parameters seperated by &.  Use fields like [FieldName] or [globals.name]"></i></label>
          <dw-template-config-control formControlName="url"
          [contextNames]="configContext?.contextNames" [item]="configContext?.itemName" [queryMeaning]="configContext?.metaDataQueryMeaning"
          [showDisplayAttributes]="true" [excludeDataPrefix]="true"></dw-template-config-control>

          <!--<input type="text" formControlName="url" class="form-control">-->
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
          <label>Open in Same Window</label>
      </div>
      <div dwCol="3">
          <p-inputSwitch formControlName="openInSameWindow"></p-inputSwitch>
      </div>
    </div>
    <div dwRow [hidden]="actionConfigFG?.value?.openInSameWindow">
      <div dwCol="12">
          <label>New Window Target</label>
          <input type="text" formControlName="newWindowTarget" class="form-control">
      </div>
    </div>
  </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteActionExternalLinkService, [{
        type: Injectable
    }], function () { return [{ type: DwRouteActionHelperService }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }]; }, null); })();
const ɵDwItemRouteConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwItemRouteConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwItemRouteConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-item-route-config',
                template: "<div *ngIf=\"routeConfigFG\" [formGroup]=\"routeConfigFG\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Component Override <i class=\"fas fa-info-circle\"\r\n          title=\"Shows global components which have the DwComponent decorator and a component type of Page\"></i></label>\r\n      <select formControlName=\"componentOverride\" class=\"form-control\">\r\n        <option [ngValue]=\"null\">None</option>\r\n        <option *ngFor=\"let item of components\" [ngValue]=\"item.key\">\r\n          {{ item.name }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Form Type</label>\r\n      <select formControlName=\"formType\" class=\"form-control\">\r\n        <option *ngFor=\"let formType of formTypes\" [ngValue]=\"formType.key\">\r\n          {{formType.display }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">Config Key</label>\r\n      <input type=\"text\" formControlName=\"configKeyPart\" class=\"form-control\">\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Replace Side Menu <i class=\"fa fa-info-circle\"\r\n          title=\"Use this menu's children as the side menu\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch formControlName=\"replaceSideMenu\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <ng-container *ngIf=\"routeConfigFG?.value?.replaceSideMenu\">\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Hide Back Button <i class=\"fa fa-info-circle\"\r\n            title=\"Hide the back button in the replacement menu\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch formControlName=\"hideReplaceSideMenuBackButton\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label class=\"label\">Side Menu Component <i class=\"fas fa-info-circle\"\r\n            title=\"Replaces the standard side replacement menu with a custom component\"></i></label>\r\n        <select formControlName=\"sideMenuComponent\" class=\"form-control\">\r\n          <option [ngValue]=\"null\">None</option>\r\n          <option *ngFor=\"let item of sideMenuComponents\" [ngValue]=\"item.key\">\r\n            {{ item.name }}\r\n          </option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n  </ng-container>\r\n  <div dwRow>\r\n    <div dwCol=\"9\">\r\n      <label>Include In Group <i class=\"fa fa-info-circle\"\r\n          title=\"Groups menus based on a Group Display on any submenus\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch formControlName=\"includeInGroup\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"routeConfigFG?.value?.includeInGroup\">\r\n    <div dwCol=\"12\">\r\n      <label>Group Display <i class=\"fa fa-info-circle\"\r\n          title=\"Groups menus based on a Group Display on any submenus\"></i></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"groupDisplay\" />\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"componentOverride?.configComponent\">\r\n    <div dwCol=\"12\">\r\n      <h2>{{componentOverride.name}} Config</h2>\r\n      <hr>\r\n      <dw-ui-child-config-host [component]=\"componentOverride.configComponent\" [(config)]=\"componentConfigFC.value\"\r\n        (configChange)=\"updateComponentConfig($event)\">\r\n      </dw-ui-child-config-host>\r\n\r\n    </div>\r\n  </div>\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label>Menu Component Override 3 <i class=\"fas fa-info-circle\"\r\n          title=\"Overides the menu display and only shows components of type Menu Component\"></i></label>\r\n      <select formControlName=\"menuComponentOverride\" class=\"form-control\">\r\n        <option [ngValue]=\"null\">None</option>\r\n        <option *ngFor=\"let item of menuComponents\" [ngValue]=\"item.key\">\r\n          {{ item.name }}\r\n        </option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n</div>"
            }]
    }], null, null); })();
const ɵDwItemRouteProcessor_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwItemRouteProcessor);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwItemRouteProcessor, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataGridActionsRowConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-metadata-grid-actions-row-config',
                template: "<div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Trigger on row click</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [ngModel]=\"config.rowClickOptions?.triggerOnClick\" (ngModelChange)=\"setRowClick($event)\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.rowClickOptions?.triggerOnClick\">\r\n        <div dwCol=\"12\">\r\n            <label>Keyboard Modifiers</label>\r\n        </div>\r\n        <div dwCol=\"12\">\r\n            <label><input type=\"checkbox\" [(ngModel)]=\"config.rowClickOptions.ctrlKey\"> Control</label>\r\n            <label><input type=\"checkbox\" [(ngModel)]=\"config.rowClickOptions.altKey\"> Alt</label>\r\n            <label><input type=\"checkbox\" [(ngModel)]=\"config.rowClickOptions.shiftKey\"> Shift</label>\r\n        </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Trigger on row double-click</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch [ngModel]=\"config.rowDoubleClickOptions?.triggerOnClick\" (ngModelChange)=\"setRowDoubleClick($event)\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"config.rowDoubleClickOptions?.triggerOnClick\">\r\n        <div dwCol=\"12\">\r\n            <label>Keyboard Modifiers</label>\r\n        </div>\r\n        <div dwCol=\"12\">\r\n            <label class=\"radio-container\"><input type=\"checkbox\" [(ngModel)]=\"config.rowDoubleClickOptions.ctrlKey\"> Control</label>\r\n            <label class=\"radio-container\"><input type=\"checkbox\" [(ngModel)]=\"config.rowDoubleClickOptions.altKey\"> Alt</label>\r\n            <label class=\"radio-container\"><input type=\"checkbox\" [(ngModel)]=\"config.rowDoubleClickOptions.shiftKey\"> Shift</label>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataGridActionsConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-grid-actions-config',
                template: `
    <dw-action-group-modes-config [configContext]="configContext" [actionModes]="actionModes"
      [(actionPreferencesByMode)]="actionPreferencesByMode" (actionPreferenceByModeChange)="onChange()"
      [actionConfigPreferencesByMode]="actionConfigPreferencesByMode">
    </dw-action-group-modes-config>
  `
            }]
    }], function () { return []; }, { actionPreferenceByModeChange: [{
            type: Output
        }], inlineEditEnabled: [{
            type: Input
        }], configContext: [{
            type: Input
        }], actionPreferencesByMode: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridNavigationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetaDataRoutingService }, { type: ɵngcc2.ActivatedRoute }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwModalService }, { type: DwMessagingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridAddActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridEditConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-edit-config',
                template: `
    <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
      <div dwRow>
        <div dwCol="9">
            <label>Open in New Window</label>
        </div>
        <div dwCol="3">
            <p-inputSwitch formControlName="openInNewWindow"></p-inputSwitch>
        </div>
      </div>
      <div dwRow [hidden]="!actionConfigFG?.value?.openInNewWindow">
        <div dwCol="12">
            <label>New Window Target</label>
            <input type="text" formControlName="newWindowTarget" class="form-control">
        </div>
      </div>
      <div dwRow>
        <div dwCol="9">
          <label>Hide when user can't update <i class="fa fa-info-circle" title="Hides the edit button when the current user doesn't have edit permissions instead of converting it to the view button"></i></label>
        </div>
        <div dwCol="3">
        <p-inputSwitch formControlName="hideViewButton"></p-inputSwitch>
        </div>
      </div>
    </div>
    `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridEditActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
const ɵDwGridActionNavConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwGridActionNavConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridActionNavConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-action-nav-config',
                template: `
  <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
    <div dwRow>
      <div dwCol="9">
          <label>Open in New Window</label>
      </div>
      <div dwCol="3">
          <p-inputSwitch formControlName="openInNewWindow"></p-inputSwitch>
      </div>
    </div>
    <div dwRow [hidden]="!actionConfigFG?.value?.openInNewWindow">
      <div dwCol="12">
          <label>New Window Target</label>
          <input type="text" formControlName="newWindowTarget" class="form-control">
      </div>
    </div>
</div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridViewActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridPrintActionSerivce, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridDeleteActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridRefreshActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridFilterToggleActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExportService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridExportActionService, [{
        type: Injectable
    }], function () { return [{ type: DwExportService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridSetValueActionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-set-value-action-config',
                template: `

  <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
    <div dwRow>
      <div dwCol="12">
          <label class="label">Attribute To Update</label>
          <select formControlName="attrName" class="form-control">
              <option *ngFor="let attr of attributes" [ngValue]="attr.AttributeName">
                {{ attr.Display }}
          </select>
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
        <label>Refresh Full Grid</label>
      </div>
      <div dwCol="3">
        <p-inputSwitch formControlName="refreshFullGrid"></p-inputSwitch>
      </div>
    </div>

  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridSetValueActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataRoutingHelperService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetaDataRoutingRepositoryService }, { type: DwMenuService }, { type: DwMenuHelperService }, { type: DwCacheService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSelectRouteComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-select-route',
                template: `
        <dw-tree-select [treeData]="routes" [selection]="translatedValue" (selectionChange)="setTranslatedValue($event)"></dw-tree-select>
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwSelectRouteComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwEventService }, { type: DwSecurityUserService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwMetaDataRoutingHelperService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataGridConfigColumnComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-grid-config-column',
                template: "<p-accordion *ngIf=\"columnPreference\">\r\n  <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Caption Override</label>\r\n        <input type=\"text\" [(ngModel)]=\"columnPreference.label\" (ngModelChange)=\"onColumnsChange()\"\r\n          [placeholder]=\"attribute?.AttributeDisplay\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Wrap Text <i class=\"fa fa-info-circle\"\r\n            title=\"Wraps the text for this column up to the row height. Row height should be set to multiples of 25px (Row height is set on styling tab on right panel config)\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"columnPreference.wrapText\" (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Pinned</label>\r\n        <select [(ngModel)]=\"columnPreference.pinned\" class=\"form-control\">\r\n          <option [ngValue]=\"null\">None</option>\r\n          <option ngValue=\"left\">Left</option>\r\n          <option ngValue=\"right\">Right</option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Hide <i class=\"fa fa-info-circle\" title=\"Hides the columns, but keeps it sortable\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"columnPreference.hide\" (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label>Column Type</label>\r\n        <select [(ngModel)]=\"columnPreference.columnRendererKey\" (ngModelChange)=\"onColumnRenderTypeChange($event)\"\r\n          class=\"form-control\">\r\n          <option *ngFor=\"let item of columnRendererRegistrations\" [ngValue]=\"item.keyName\">\r\n            {{item.display}}\r\n          </option>\r\n        </select>\r\n      </div>\r\n    </div>\r\n\r\n    <div dwRow *ngIf=\"currentColumnRendererRegistration.allowAction\">\r\n      <div dwCol=\"9\">\r\n        <label>Use Action</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"columnPreference.useAction\" (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n  </p-accordionTab>\r\n  <p-accordionTab header=\"Sizing\">\r\n\r\n    <ng-container *ngIf=\"useColumnFlex\">\r\n\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Use Flex</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch [(ngModel)]=\"columnPreference.useFlex\" (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow *ngIf=\"columnPreference.useFlex\">\r\n        <div dwCol=\"9\">\r\n          <label>Flex</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <input type=\"number\" DwNumeric [(ngModel)]=\"columnPreference.flex\" (ngModelChange)=\"onColumnsChange()\"\r\n            placeholder=\"1\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow *ngIf=\"columnPreference.useFlex\">\r\n        <div dwCol=\"9\">\r\n          <label>Min Width</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <input type=\"number\" DwNumeric [(ngModel)]=\"columnPreference.minWidth\" (ngModelChange)=\"onColumnsChange()\"\r\n            placeholder=\"Default\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n\r\n    <div dwRow *ngIf=\"!columnPreference.useFlex || !useColumnFlex\">\r\n      <div dwCol=\"9\">\r\n        <label>Width <i class=\"fa fa-info-circle\"\r\n            title=\"Can also be set by changing the column width in the grid with the config panel open\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <input type=\"number\" DwNumeric [(ngModel)]=\"columnPreference.width\" (ngModelChange)=\"onColumnsChange()\"\r\n          [placeholder]=\"200\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n  </p-accordionTab>\r\n  <p-accordionTab header=\"Sorting\">\r\n    <div dwRow *ngIf=\"!columnPreference.disabledSort\">\r\n      <div dwCol=\"12\">\r\n        <label>Sorting</label>\r\n        <dw-radio-list [values]=\"sortDirections\" [(ngModel)]=\"columnPreference.sort\"></dw-radio-list>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"!columnPreference.disabledSort && columnPreference.sort\">\r\n      <div dwCol=\"12\">\r\n        <label>Sort Order <i class=\"fa fa-info-circle\"\r\n            title=\"Sort order of column - blank means not sorted, 1 - first sorted column, 2 - second sorted column\"></i></label>\r\n        <input type=\"number\" DwNumeric [(ngModel)]=\"columnPreference.sortOrder\" (ngModelChange)=\"onColumnsChange()\"\r\n          placeholder=\"Default\" class=\"form-control\">\r\n      </div>\r\n    </div>\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Disable Sorting</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"columnPreference.disabledSort\" (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"!columnPreference.disabledSort\">\r\n      <div dwCol=\"9\">\r\n        <label>Use Alternative Sort Field</label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"columnPreference.useAltSortField\"\r\n          (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"columnPreference.useAltSortField && !columnPreference.disabledSort\">\r\n      <div dwCol=\"12\">\r\n        <label>Alternative Sort Field</label>\r\n        <p-dropdown [options]=\"allAttributes\" optionLabel=\"display\" display=\"chip\" optionValue=\"value\"\r\n          [(ngModel)]=\"columnPreference.Lo\" [showClear]=\"true\" (ngModelChange)=\"onChange()\" [style]=\"{'width':'100%'}\"\r\n          filter=\"true\" appendTo=\"body\"></p-dropdown>\r\n      </div>\r\n    </div>\r\n  </p-accordionTab>\r\n\r\n  <p-accordionTab header=\"Column Editing\" *ngIf=\"inlineEditEnabled\">\r\n    <div dwRow>\r\n      <div dwCol=\"9\">\r\n        <label>Disable Editing <i class=\"fa fa-info-circle\"\r\n            title=\"Makes this column read-only when editing\"></i></label>\r\n      </div>\r\n      <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"columnPreference.inlineEditDisabled\"\r\n          (ngModelChange)=\"onColumnsChange()\"></p-inputSwitch>\r\n      </div>\r\n    </div>\r\n  </p-accordionTab>\r\n  <p-accordionTab header=\"Column Security\">\r\n    <dw-security-check-config [(config)]=\"columnPreference.securityConfig\" (configChange)=\"onColumnsChange()\"\r\n      [configContext]=\"configContext\"></dw-security-check-config>\r\n  </p-accordionTab>\r\n\r\n  <p-accordionTab header=\"Conditional Classes\">\r\n    <dw-conditional-field-classes [(conditionalClasses)]=\"columnPreference.conditionalFieldClasses\"\r\n      (conditionalClassesChange2)=\"setConditionalClasses($event)\" [itemName]=\"configContext.itemName\"\r\n      [contextNames]=\"configContext.contextNames\" [queryMeaning]=\"configContext.metaDataQueryMeaning\"\r\n      [classNames]=\"['data']\" [classLabels]=\"['Data Classes']\">\r\n    </dw-conditional-field-classes>\r\n  </p-accordionTab>\r\n\r\n  <p-accordionTab header=\"Renderer Settings\" *ngIf=\"currentColumnRendererRegistration?.configComponent\">\r\n    <dw-ui-child-config-host [component]=\"currentColumnRendererRegistration?.configComponent\"\r\n      [(config)]=\"columnPreference.columnRendererConfig\" (configChange)=\"onColumnsChange()\"\r\n      [configContext]=\"configContext\">\r\n    </dw-ui-child-config-host>\r\n  </p-accordionTab>\r\n\r\n  <dw-action-config *ngIf=\"columnPreference?.useAction\" [actionPreference]=\"columnPreference.actionPreference\"\r\n    (actionPreferenceChange)=\"onActionPreferenceChange($event)\" basicSettingsDisplay='Action Settings'\r\n    [actions]=\"actions\" showActionDisplay=\"false\" selectFirstTab=\"false\"\r\n    [showButtonConfig]=\"currentColumnRendererRegistration?.showActionButtonConfig\" showMenuConfig=\"false\"\r\n    [configContext]=\"configContext\">\r\n  </dw-action-config>\r\n</p-accordion>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DwActionConfigService }, { type: DwUiConfigRegistryService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { columnPreferenceChange: [{
            type: Output
        }], inlineEditEnabled: [{
            type: Input
        }], columnPreference: [{
            type: Input
        }], useColumnFlex: [{
            type: Input
        }], attribute: [{
            type: Input
        }], configContext: [{
            type: Input
        }], queryMetaData: [{
            type: Input
        }] }); })();
const ɵDwDateRangeFilterComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwDateRangeFilterComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateRangeFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-date-range-filter',
                template: `
  <label class='label'>{{ label}}</label>
  <dw-date-range-input [(startDate)]="startDate" [(endDate)]="endDate" (startDateChange)="dateRangeChanged()" (endDateChange)="dateRangeChanged()"></dw-date-range-input>
`
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridMultiEditModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-multi-edit-modal',
                template: "<div [formGroup]=\"formGroup\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <label class=\"label\">\r\n        Select Attributes\r\n      </label>\r\n      <p-multiSelect [options]=\"availableAttributes\" optionLabel=\"Display\" [ngModel]=\"selectedAttributes\" display=\"chip\"\r\n        (ngModelChange)=\"setSelectedAttributes($event)\" [ngModelOptions]=\"{ standalone: true}\" [filter]=\"true\"\r\n        appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\">\r\n      </p-multiSelect>\r\n    </div>\r\n  </div>\r\n  <hr>\r\n\r\n  <dw-message [(message)]=\"message\" *ngIf=\"message\"></dw-message>\r\n\r\n  <div class=\"container-style\">\r\n    <div>\r\n      <div dwRow *ngFor=\"let attrToUpdate of attributesToUpdate\">\r\n        <div dwCol=\"12\">\r\n          <div dwDynamicField [fieldDef]=\"attrToUpdate.fieldConfig\" [formGroup]=\"formGroup\" [submitted]=\"submitted\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div dwRow [hidden]=\"attributesToUpdate.length > 0\">\r\n    <div dwCol=\"12\">\r\n      Please select one or more attributes to update!\r\n    </div>\r\n  </div>\r\n</div>",
                styles: [".container-style{max-height:500px;min-width:500px;overflow-x:hidden;overflow-y:auto;padding:3px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwValidationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridMultiEditConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-multi-edit-config',
                template: `
    <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
      <div dwRow>
        <div dwCol="9">
            <label>Include All Attributes</label>
        </div>
        <div dwCol="3">
            <p-inputSwitch formControlName="includeAllAttributes"></p-inputSwitch>
        </div>
      </div>
      <div dwRow [hidden]="actionConfigFG.value?.includeAllAttributes">
        <div dwCol="12">
          <p-multiSelect [options]="primeAttributes" formControlName="includeAttributes" display="chip" [filter]="true" appendTo="body" baseZIndex="2000" autoZIndex="false"></p-multiSelect>
        </div>
      </div>
      <div dwRow>
        <div dwCol="9">
            <label>Refresh Full Grid</label>
        </div>
        <div dwCol="3">
            <p-inputSwitch formControlName="refreshFullGrid"></p-inputSwitch>
        </div>
      </div>
    </div>
    `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridMultiEditActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDefaultValueComponent, [{
        type: Component,
        args: [{
                selector: 'dw-default-value',
                template: `
    <div class="expr-column-full">
      <dw-expression-reference-control [ngModel]="defaultValue.reference" (ngModelChange)="setReferenceValue($event)" [contextNames]="finalContextNames" [valueFieldConfig]="defaultValueFieldConfig">
      </dw-expression-reference-control>
    </div>
  `
            }]
    }], function () { return [{ type: DwContextService }]; }, { defaultValueChange: [{
            type: Output
        }], defaultValue: [{
            type: Input
        }], contextNames: [{
            type: Input
        }], queryAttribute: [{
            type: Input
        }], controlTypeOverride: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridToggleValueActionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-set-value-action-config',
                template: `

  <div>
    <div dwRow>
      <div dwCol="12">
          <label class="label">Attribute To Toggle</label>
          <select [(ngModel)]="config.attrName" (ngModelChange)="onChange()" class="form-control">
              <option *ngFor="let attr of attributes" [ngValue]="attr.AttributeName">
                {{ attr.Display }}
          </select>
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
        <label>Refresh Full Grid</label>
      </div>
      <div dwCol="3">
        <p-inputSwitch [(ngModel)]="config.refreshFullGrid" (ngModelChange)="onChange()"></p-inputSwitch>
      </div>
    </div>
  </div>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridToggleValueActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwLoggingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormButtonsConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-buttons-config',
                template: "<div>\r\n  \r\n  <p-tabView [(activeIndex)]=\"tabIndex\">\r\n     <p-tabPanel header=\"Actions\" *ngIf=\"!section.useFormButtonDefaults\">\r\n      <dw-action-group-modes-config [configContext]=\"configContext\" [actionModes]=\"actionModes\" showEnableVisibleConfig=\"true\"\r\n      [(actionPreferencesByMode)]=\"section.actionPreferencesByMode\" (actionPreferenceByModeChange)=\"onSectionChange()\">\r\n    </dw-action-group-modes-config>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Button Section Configuration\">\r\n      <div dwRow>\r\n        <div dwCol=\"6\">\r\n          <label>Use Form Button Defaults</label>\r\n          <dw-yesno [(ngModel)]=\"section.useFormButtonDefaults\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\"></dw-yesno>\r\n        </div>\r\n        <div dwCol=\"6\" *ngIf=\"!section.useFormButtonDefaults\">\r\n          <label>Show Form Modes</label>\r\n          <dw-yesno [(ngModel)]=\"section.useFormModes\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\"></dw-yesno>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"6\">\r\n          <label>Button Container Style</label>\r\n          <select  [(ngModel)]=\"section.buttonContainerStyleKey\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\">\r\n            <option *ngFor=\"let item of buttonContainerStyles\" [ngValue]=\"item.keyName\">\r\n                {{item.display}}\r\n            </option>\r\n        </select>\r\n        </div>\r\n        <div dwCol=\"6\">\r\n          <label>Show Action Messages <i class=\"fa fa-info-circle\" title=\"Shows action messages instead of the action button circle\"></i></label>\r\n          <dw-yesno [(ngModel)]=\"section.showActionMessages\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\"></dw-yesno>\r\n        </div>\r\n      </div>\r\n    </p-tabPanel> \r\n  \r\n    <p-tabPanel header=\"Section Configuration\">\r\n      <div>\r\n        <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"\r\n          [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\" [showReadOnlySection]=\"false\">\r\n        </dw-md-section-standard-config>\r\n      </div>\r\n    </p-tabPanel>\r\n  </p-tabView>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormButtonsSectionConfigProcessor, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetaDataActionConfigService }, { type: DwMetaDataFormActionService }, { type: DwMetadataFormUtilService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormButtonsSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-buttons-section',
                template: `
    <div [ngClass]="{ 'hide': dwMetaDataFormStateService?.state?.showButtons === false }" class="hide-print-item">
      <dw-action-bar [actionPreferences]="actionPreferences" [firingActionPreference]="firingActionPreference" (actionClick)="executeAction($event)" [buttonContainerStyleKey]="sectionConfig?.buttonContainerStyleKey" convertPreferences="false">
        <div class="dw-button-bar-action-firing-container"> 
          <dw-loading [show]="showActionFiring" [text]="actionMessage"></dw-loading>
        </div>
      </dw-action-bar>
      
      <!-- Next hidden = {{actionPreferences[3].buttonConfig.hidden}}<br>
      Previous Hidden = {{actionPreferences[2].buttonConfig.hidden}}<br>
      Display: {{actionPreferences[3].actionDisplay}}<br> -->
    </div>
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormActionService }, { type: DwActionExecutionService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataActionExpressionService }, { type: DwMetaDataActionConfigService }, { type: DwContextService }]; }, null); })();
const ɵDwFormSaveConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormSaveConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormSaveConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-form-save-config',
                template: "<div *ngIf=\"actionConfigFG\" [formGroup]=\"actionConfigFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Action Message</label>\r\n            <input type=\"text\" formControlName=\"actionMessage\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Require Validation</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"requireValidation\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <!-- Didn't have time to get it to work correctly - Re-add later<div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Save and New <i class=\"fa fa-info-circle\" title=\"When in add mode, it saves and redirects back to add\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"saveAndNew\"></p-inputSwitch>\r\n        </div>\r\n    </div> -->\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Save and Edit <i class=\"fa fa-info-circle\" title=\"When in add mode, it saves and redirects to the edit page\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"saveAndEdit\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Redirect After</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"redirectAfter\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG?.value?.redirectAfter\">\r\n        <div dwCol=\"9\">\r\n            <label>Customize Redirect</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"customizeRedirect\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG?.value?.customizeRedirect\">\r\n        <div dwCol=\"12\">\r\n            <label>Redirect Menu</label>\r\n            <dw-select-route formControlName=\"redirectMenuKey\"></dw-select-route>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormSaveActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataRoutingService }, { type: ɵngcc2.Router }]; }, null); })();
const ɵDwFormPrintConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormPrintConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormPrintConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-form-print-config',
                template: "<div *ngIf=\"actionConfigFG\" [formGroup]=\"actionConfigFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Action Message</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"actionMessage\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Use Browser Print</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"useBrowserPrint\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"!actionConfigFG?.value?.useBrowserPrint\">\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Render Multiple Pages</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"renderMultiplePage\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Export PDF File Name <i class=\"fa fa-info-circle\"\r\n                        title=\"You can use root field name replacement values such [data.FieldName]\"></i></label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"exportPDFFileName\"\r\n                    placeholder=\"Uses Item Display - Key value\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Render Wait Time (ms) <i class=\"fa fa-info-circle\"\r\n                        title=\"Controls how long to wait for the html to render in milliseconds.  More complex forms with nested data needs more time\"></i></label>\r\n                <input type=\"text\" dwNumeric class=\"form-control\" formControlName=\"pdfRenderWaitTimeMs\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Reload Print Data <i class=\"fa fa-info-circle\"\r\n                        title=\"Reload the form data when printing.  This is required is the print from loads data differently from the current form\"></i></label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"reloadPrintData\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Print Config Key Override <i class=\"fa fa-info-circle\"\r\n                    title=\"Overrides the default print key\"></i></label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"printConfigKeyOverride\">\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormPrintActionService, [{
        type: Injectable
    }], null, null); })();
const ɵDwFormActionConfigDefaultComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormActionConfigDefaultComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormActionConfigDefaultComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-action-config-default',
                template: "<div *ngIf=\"actionConfigFG\" [formGroup]=\"actionConfigFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Action Message</label>\r\n            <input type=\"text\" formControlName=\"actionMessage\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Require Validation</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"requireValidation\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Redirect After</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"redirectAfter\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG?.value?.redirectAfter\">\r\n        <div dwCol=\"9\">\r\n            <label>Customize Redirect</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"customizeRedirect\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG?.value?.customizeRedirect\">\r\n        <div dwCol=\"12\">\r\n            <label>Redirect Menu</label>\r\n            <dw-select-route formControlName=\"redirectMenuKey\"></dw-select-route>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormCloseActionService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormCancelActionService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormWorkflowButtonsConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-workflow-buttons-config',
                template: "<div *ngIf=\"actionConfigFG\" [formGroup]=\"actionConfigFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Workflow Attribute</label>\r\n            <select formControlName=\"workflowAttrName\" class=\"form-control\">\r\n                <option *ngFor=\"let attr of lookupAttributes\" [ngValue]=\"attr.AttributeName\">\r\n                    {{ attr.Display }}\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"lookupDefAttributeList\">\r\n        <div dwCol=\"12\">\r\n            <label>Workflow Status Detail Attribute <i class=\"fa fa-info-circle\" title=\"Uses workflow detail to set value for text, buttons, icons, etc.  Must add field to the Lookup\"></i></label>\r\n            <select formControlName=\"workflowStatusDetailAttrName\" class=\"form-control\">\r\n                <option [ngValue]=\"null\">none</option>\r\n                <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                    {{ attr.AttributeDisplay }}\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG.value?.workflowStatusDetailAttrName\">\r\n        <div dwCol=\"9\">\r\n            <label>Show Admin Action Text <i class=\"fa fa-info-circle\" title=\"Defaults to showing Action Text\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"showAdminActionText\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Hide Current Status</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"hideCurrentStatus\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Set Status Only (No Save)</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"setStatusOnly\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG.value?.setStatusOnly\">\r\n        <div dwCol=\"9\">\r\n            <label>Update lookup on set</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"updateInitialValueOnSet\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"lookupDefAttributeList\">\r\n        <div dwCol=\"9\">\r\n            <label>Customize Workflow Display</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"useCustomAttributes\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"actionConfigFG?.value?.useCustomAttributes && lookupDefAttributeList\">\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Button Display Attribute</label>\r\n                <select formControlName=\"buttonDisplayAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">Default</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Validation Required Attribute</label>\r\n                <select formControlName=\"requireValidationAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">None</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Validate After Update</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"validateAfterStatusUpdate\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.requireValidationAttrName || actionConfigFG.value?.workflowStatusDetailAttrName\">\r\n            <div dwCol=\"12\">\r\n                <label>Show Required Expression</label>\r\n                <dw-expression-picker-control formControlName=\"showValidationRequiredExpr\" (ngModelChange)=\"onChange()\"\r\n                    [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\"\r\n                    [queryMeaning]=\"configContext?.QueryMeaning\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Button Class Attribute</label>\r\n                <select formControlName=\"buttonClassAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">None</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Icon Class Attribute</label>\r\n                <select formControlName=\"buttonIconAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">None</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Toolip Attribute</label>\r\n                <select formControlName=\"toolTipAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">None</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Current Status Attribute</label>\r\n                <select formControlName=\"currentStatusAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">None</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Current Status Button Class Attribute</label>\r\n                <select formControlName=\"currentStatusButtonClassAttrName\" class=\"form-control\">\r\n                    <option [ngValue]=\"null\">None</option>\r\n                    <option *ngFor=\"let attr of lookupDefAttributeList\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Override Current Status</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"overrideCurrentStatusDisplay\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.overrideCurrentStatusDisplay\">\r\n            <div dwCol=\"12\">\r\n                <label>Current Status Display</label>\r\n                <input type=\"text\" formControlName=\"currentStatusDisplay\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Status Prefix</label>\r\n                <input type=\"text\" formControlName=\"buttonTextPrefix\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.redirectAfter\">\r\n            <div dwCol=\"9\">\r\n                <label>Customize Redirect</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"customizeRedirect\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.customizeRedirect\">\r\n            <div dwCol=\"12\">\r\n                <label>Redirect Menu</label>\r\n                <dw-select-route formControlName=\"redirectMenuKey\"></dw-select-route>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Override Lookup</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"useLookupOverride\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.useLookupOverride\">\r\n            <div dwCol=\"12\">\r\n                <label>Lookup</label>\r\n                <dw-search-select-lookup formControlName=\"lookupIdOverride\" [lookupId]=\"lookupMeaning\">\r\n                </dw-search-select-lookup>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLookupUtilService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwSecurityUserService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormWorkflowButtonsActionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-workflow-buttons',
                template: `
        <ng-container *ngFor="let button of lookupButtons">
            <dw-button [buttonConfig]="button.buttonConfig" (click)="actionClick(button.lookupItem)"></dw-button>
        </ng-container>
    `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwLookupUtilService }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataFormStateService, decorators: [{
                type: Optional
            }] }]; }, { buttonCount: [{
            type: Output
        }], actionPreference: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSelectLookupConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-select-lookup-config',
                template: "<div dwRow *ngIf=\"config\">\r\n  <div dwCol=\"9\">\r\n    Customize Lookup\r\n  </div>\r\n  <div dwCol=\"3\">\r\n    <p-inputSwitch [(ngModel)]=\"config.useLookupOverride\" (ngModelChange)=\"onChange()\">\r\n    </p-inputSwitch>\r\n  </div>\r\n</div>\r\n<ng-container *ngIf=\"config?.useLookupOverride\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\" class=\"expr-column-full\">\r\n      <label>Use Lookup</label>\r\n      <dw-expression-reference-control [(ngModel)]=\"config.lookupIdOverride\" (ngModelChange)=\"onLookupOverrideChange()\"\r\n        [contextNames]=\"configContext.contextNames\" [item]=\"lookupRefItem\" [relatedExprRef]=\"lookupRelatedExprRef\">\r\n      </dw-expression-reference-control>\r\n    </div>\r\n  </div>\r\n  <div dwRow [hidden]=\"hideAdditionalDisplay\">\r\n    <div dwCol=\"12\">\r\n      <label>Additional Display Attr</label>\r\n      <input type=\"text\" [(ngModel)]=\"config.addittionalDisplayAttrName\" (ngModelChange)=\"onChange()\"\r\n        class=\"form-control\">\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngIf=\"lookupDef?.HasTransitions\" [hidden]=\"hideUseTransitions\">\r\n    <div dwCol=\"9\">\r\n      Use Transitions\r\n    </div>\r\n    <div dwCol=\"3\">\r\n      <p-inputSwitch [(ngModel)]=\"config.useTransitions\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n<ng-container *ngIf=\"lookupDef && lookupDef.DwMetaDataLookupParam?.length > 0\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n      <b>Lookup Parameters</b>\r\n    </div>\r\n  </div>\r\n  <div dwRow *ngFor=\"let lookupParam of lookupDef.DwMetaDataLookupParam; let index = index\">\r\n    <div dwCol=\"12\" class=\"expr-column-full\">\r\n\r\n      <label>Param {{index + 1}} - {{ lookupParam.UseAttribute ? lookupParam.AttributeName :\r\n        lookupParam.ParamNameOverride}}</label>\r\n\r\n      <dw-expression-reference-control [(ngModel)]=\"config.lookupParamAttributeOverrides[index]\"\r\n        (ngModelChange)=\"onChange()\" [contextNames]=\"configContext.contextNames\" [item]=\"configContext.itemName\"\r\n        [queryMeaning]=\"configContext.metaDataQueryMeaning\">\r\n      </dw-expression-reference-control>\r\n    </div>\r\n  </div>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, { hideAdditionalDisplay: [{
            type: Input
        }], hideUseTransitions: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionDescriptionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }, { type: DwExpressionService }, { type: DwExpressionComparersService }, { type: DwDataFormatService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExpressionPickerControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-expression-picker-control',
                template: "<div *ngIf=\"!item && (!contextNames || contextNames?.length==0)\">\r\n    Expressions require an Item or at least one Context Name\r\n</div>\r\n<ng-container *ngIf=\"!(!item && (!contextNames || contextNames?.length==0))\">\r\n    \r\n    <div class=\"expr-container\">\r\n        <dw-html-view [ngModel]=\"exprDesc\"></dw-html-view>\r\n    </div>\r\n\r\n    <button  type=\"button\" class=\"btn-sm btn-success\" (click)=\"editExpr.show($event)\">{{ buttonText }}</button>&nbsp; \r\n    <button  type=\"button\" *ngIf=\"showClear\" class=\"btn-sm btn-danger\" (click)=\"clearExpression()\">{{ clearButtonText}}</button>\r\n\r\n    <p-overlayPanel #editExpr [showCloseIcon]=\"true\" (onHide)=\"closePopup(true)\" [style]=\"{width: '850px'}\" style2=\"{ width: '750px', min-height:'200px'}\" appendTo=\"body\" [dismissable]=\"false\">\r\n        <ng-template pTemplate>\r\n            <div style=\"height:300px;overflow-y:auto\">\r\n                <div style=\"width:calc(100% - 20px)\">\r\n                    <dw-expression-group-control [item]=\"item\" [contextNames]=\"contextNames\" [queryMeaning]=\"queryMeaning\" [(ngModel)]=\"editingExprGroup\">\r\n                    </dw-expression-group-control>\r\n                </div>\r\n            </div>\r\n            <dw-button-bar>\r\n                <button type=\"button\" (click)=\"closePopup()\" class=\"btn btn-success\">Ok</button> <button  type=\"button\" (click)=\"closePopup(true)\" class=\"btn btn-danger\">Cancel</button>\r\n            </dw-button-bar>\r\n        </ng-template>\r\n    </p-overlayPanel>\r\n</ng-container>",
                encapsulation: ViewEncapsulation.None,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwExpressionPickerControlComponent),
                        multi: true
                    }],
                styles: [".expr{border-radius:5px;float:left;padding:5px}.expr1{background-color:green}.expr1,.expr2{border-radius:5px;color:#fff;float:left;padding:4px}.expr2{background-color:#00f}.exprCompare{float:left;padding:4px}.exprGroup{border:1px dashed #000;float:left;margin:3px}.exprOp{border-radius:5px;float:left;font-weight:700;margin:5px;padding:4px}.expr-container{margin-bottom:5px;overflow:auto;width:100%}"]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwExpressionDescriptionService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { contextNames: [{
            type: Input
        }], addButtonText: [{
            type: Input
        }], editButtonText: [{
            type: Input
        }], clearButtonText: [{
            type: Input
        }], item: [{
            type: Input
        }], queryMeaning: [{
            type: Input
        }], editExprPopup: [{
            type: ViewChild,
            args: ['editExpr']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataFormContextService, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityUserService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserContextService, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityUserService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwContextRepositoryService }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DwUserContextDynamicHandlerToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFieldValidationConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-field-validation-config',
                template: "<div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Override Defaults</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.overrideDefaults\" (ngModelChange)=\"onChange()\"></p-inputSwitch>\r\n    </div>\r\n</div>\r\n<ng-container *ngIf=\"config?.overrideDefaults\">\r\n\r\n    <dw-ordered-list [(items)]=\"config.validators\" (itemsChange)=\"onSectionChange()\" *ngIf=\"config.validators?.length>0\">\r\n        <ng-container *dwListItem=\"let validator\">\r\n\r\n            <dw-validation-config-base [(config)]=\"validator.config\" (configChange)=\"validatorChange()\"\r\n                [validatorKey]=\"validator.validatorKey\" [configContext]=\"contextContext\">\r\n            </dw-validation-config-base>\r\n\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label *ngIf=\"!registrationObject[validator.validatorKey] || !registrationObject[validator.validatorKey].expressionLabel\">Enabled Expression <i class=\"fa fa-info-circle\"\r\n                            title=\"Allows conditional validation based on an expression. If result is true, validator is added\"></i></label>\r\n                    <label *ngIf=\"registrationObject[validator.validatorKey] && registrationObject[validator.validatorKey].expressionLabel\">{{registrationObject[validator.validatorKey].expressionLabel}}\r\n                         <i class=\"fa fa-info-circle\" *ngIf=\"registrationObject[validator.validatorKey].exprressionTooltip\" title=\"{{registrationObject[validator.validatorKey].exprressionTooltip}}\"></i></label>\r\n                    <dw-expression-picker-control [(ngModel)]=\"validator.conditionExpressionGroup\"\r\n                        (ngModelChange)=\"onChange()\" [queryMeaning]=\"configContext?.metaDataQueryMeaning\"\r\n                        [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\">\r\n                    </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n    </dw-ordered-list>\r\n\r\n    <fieldset *ngIf=\"availableRegistrations?.length>0\">\r\n        <legend>Add Validator</legend>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Validator</label>\r\n                <p-dropdown [options]=\"availableRegistrations\" [(ngModel)]=\"selectedRegistrationKey\"\r\n                    optionLabel=\"display\" optionValue=\"keyName\" display=\"chip\" appendTo=\"body\"\r\n                    baseZIndex=\"2000\"></p-dropdown>\r\n\r\n                <button (click)=\"addValidator()\" [enabled]=\"selectedRegistrationKey\" class=\"btn-sm btn-success mt-1\">Add\r\n                    Validator</button>\r\n            </div>\r\n        </div>\r\n    </fieldset>\r\n\r\n\r\n</ng-container>\r\n<ng-container *ngIf=\"false\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Selected Validators</label>\r\n            <p-multiSelect [options]=\"allRegistrations\" [(ngModel)]=\"selectedRegistrationKeys\"\r\n                (ngModelChange)=\"updateRegistrations()\" optionLabel=\"display\" optionValue=\"keyName\" display=\"chip\"\r\n                appendTo=\"body\" baseZIndex=\"2000\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngFor=\"let validator of config?.validators\">\r\n        <dw-validation-config-base [(config)]=\"validator.config\" (configChange)=\"validatorChange()\"\r\n            [validatorKey]=\"validator.validatorKey\" [configContext]=\"contextContext\">\r\n        </dw-validation-config-base>\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Enabled Expression <i class=\"fa fa-info-circle\"\r\n                        title=\"Allows conditional validation based on an expression. If result is true, validator is added\"></i></label>\r\n                <dw-expression-picker-control [(ngModel)]=\"validator.conditionExpressionGroup\"\r\n                    (ngModelChange)=\"onChange()\" [queryMeaning]=\"configContext?.metaDataQueryMeaning\"\r\n                    [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-container>"
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, { validationItemType: [{
            type: Input
        }] }); })();
const ɵDwMdChildDataRepeaterSectionConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdChildDataRepeaterSectionConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdChildDataRepeaterSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-md-child-data-repeater-section-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Child Data Repeater Configuration\">\r\n            <p-accordion [multiple]=\"true\">\r\n                <p-accordionTab header=\"Data Configuration\" [selected]=\"true\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Relationship</label>\r\n                            <select [(ngModel)]=\"section.relationshipName\"\r\n                                (ngModelChange)=\"setSectionRelationshipItems($event)\" class=\"form-control\">\r\n                                <option *ngFor=\"let item of availableRelations\" [ngValue]=\"item.RelationshipName\">\r\n                                    {{item.NamingInfo?.RelationshipDisplayName}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow *ngIf=\"relationshipDisplay\">\r\n                        <div dwCol=\"12\">\r\n                            {{relationshipDisplay}}\r\n                            <br><br>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Is Orderable <i class=\"fa fa-info-circle\"\r\n                                    title=\"Allows rows to be ordered and sets an order value in the designated field\"></i></label>\r\n                            <dw-yesno [(ngModel)]=\"section.isOrderable\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                        <div dwCol=\"6\" *ngIf=\"section.isOrderable\">\r\n                            <label>Order Attribute <i class=\"fa fa-info-circle\"\r\n                                    title=\"Assigns an order value to each row starting at 1\"></i></label>\r\n                            <p-dropdown [options]=\"availableAttributes\" optionLabel=\"Display\"\r\n                                optionValue=\"AttributeName\" [(ngModel)]=\"section.orderAttributeName\" display=\"chip\"\r\n                                (ngModelChange)=\"onSectionChange()\" [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\"\r\n                                autoZIndex=\"false\" class=\"multi-edit-auto-expand\">\r\n                            </p-dropdown>\r\n                        </div>\r\n                    </div>\r\n                    <!-- <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>Show As Grid <i class=\"fa fa-info-circle\"\r\n                                    title=\"Renders a simple grid with one header row and data rows without headers\"></i></label>\r\n                            <dw-yesno [(ngModel)]=\"section.showAsGrid\" (ngModelChange)=\"onShowAsGridChange()\"></dw-yesno>\r\n                        </div>\r\n                    </div> -->\r\n                    <div dwRow *ngIf=\"!section.showAsGrid\">\r\n                        <div dwCol=\"6\">\r\n                            <label>Child Section Type</label>\r\n                            <select [(ngModel)]=\"section.section.sectionType\" (ngModelChange)=\"onSectionChange()\"\r\n                                class=\"form-control\">\r\n                                <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                                    {{sectionDef.display}}\r\n                                </option>\r\n                            </select>\r\n                        </div>\r\n                        <div dwCol=\"6\" *ngIf=\"!section.isOrderable\">\r\n                            <label>Use Filters <i class=\"fa fa-info-circle\"\r\n                                    title=\"Allows reusing the same table for multiple repeaters or simply filtering the data by a simple filter (Does not work with orderable)\"></i></label>\r\n                            <dw-yesno [(ngModel)]=\"section.useFilters\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Filters\" *ngIf=\"!section.isOrderable && section.useFilters && section.childItem\">\r\n                    <div dwRow *ngIf=\"false\">\r\n                        <div dwCol=\"12\">\r\n                            Note: Filters are used to limit repeater data and also reuse the same table with multiple\r\n                            child repeaters on the same form. If you need a read-only view with a query and more\r\n                            powerful filters, consider using a data grid/list section.\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Set Defaults from Filter <i class=\"fa fa-info-circle\"\r\n                                    title=\"Any equal filters for an attribute will be used to set the default value for the row.  This ensures the correct data is set on the entity when saved.\"></i></label>\r\n\r\n                            <dw-yesno [(ngModel)]=\"section.filterSetDefaultValues\"\r\n                                (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"12\">\r\n                            <label>Filter Expression <i class=\"fa fa-info-circle\"\r\n                                    title=\"Attributes to filter on will also be set by default for new rows\"></i></label>\r\n\r\n                            <dw-expression-picker-control [(ngModel)]=\"section.filterExpression\"\r\n                                [contextNames]=\"contextNames\" [item]=\"section?.childItem\">\r\n                            </dw-expression-picker-control>\r\n                        </div>\r\n                    </div>\r\n                    <ng-container *ngIf=\"false\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"12\">\r\n                                <label>Filter Attributes <i class=\"fa fa-info-circle\"\r\n                                        title=\"Attributes to filter on will also be set by default for new rows\"></i></label>\r\n                                <p-multiSelect [options]=\"availableAttributes\" optionLabel=\"Display\"\r\n                                    [ngModel]=\"selectedAttributes\" display=\"chip\"\r\n                                    (ngModelChange)=\"setSelectedAttributes($event)\" [filter]=\"true\" appendTo=\"body\"\r\n                                    baseZIndex=\"2000\" autoZIndex=\"false\" class=\"multi-edit-auto-expand\">\r\n                                </p-multiSelect>\r\n\r\n                            </div>\r\n                        </div>\r\n                        <ng-container *ngIf=\"selectedAttributes?.length > 0\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"12\">\r\n                                    <h2>Filter Values</h2>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow>\r\n                                <div dwCol=\"6\" *ngFor=\"let attr of selectedAttributes\">\r\n                                    <div dwDynamicField [fieldDef]=\"filterFieldConfig[attr.AttributeName]\"\r\n                                        [formGroup]=\"filterFormGroup\" [submitted]=\"submitted\">\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                        </ng-container>\r\n                    </ng-container>\r\n                </p-accordionTab>\r\n                <p-accordionTab header=\"Repeater Options\">\r\n                    <div dwRow>\r\n                        <div dwCol=\"4\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"12\">\r\n                                    <label>Exclude From Save <i class=\"fa fa-info-circle\"\r\n                                            title=\"Excludes this child and any children from being saved.  Also makes all forms read-only and hides add/remove buttons\"></i></label>\r\n                                    <dw-yesno [(ngModel)]=\"section.excludeFromSave\"\r\n                                        (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div dwCol=\"4\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"12\">\r\n                                    <label>Exclude Child Controls</label>\r\n                                    <dw-yesno [(ngModel)]=\"section.excludeChildControls\"\r\n                                        (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"3\">\r\n                            <label>Hide Add</label>\r\n                            <dw-yesno [(ngModel)]=\"section.hideAdd\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <label>Hide Remove</label>\r\n                            <dw-yesno [(ngModel)]=\"section.hideRemove\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Auto Add Rows</label>\r\n                            <dw-yesno [(ngModel)]=\"section.autoAddRows\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                        </div>\r\n                    </div>\r\n                    <div dwRow>\r\n                        <div dwCol=\"6\">\r\n                            <label>No Rows Message</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.noRowsMessage\"\r\n                                (ngModelChange)=\"onSectionChange()\" placeholder=\"There are no items to display\">\r\n                        </div>\r\n                        <div dwCol=\"6\">\r\n                            <label>Add Text</label>\r\n                            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.addTextOverride\"\r\n                                (ngModelChange)=\"onSectionChange()\" placeholder=\"Add\">\r\n                        </div>\r\n                    </div>\r\n                </p-accordionTab>\r\n\r\n            </p-accordion>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Validation\" *ngIf=\"section?.validationConfig\">\r\n            <dw-field-validation-config [(config)]=\"section.validationConfig\" [configContext]=\"metaDataConfigContext\"\r\n                validationItemType=\"formArray\"></dw-field-validation-config>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\"\r\n                    (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"\r\n                    [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                </dw-md-section-standard-config>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdChildDataRepeaterSectionComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-child-data-repeater-section',
                template: "<div *ngIf=\"invalidConfiguration\" class=\"hide-print dw-invalid-section\">\r\n    <i class=\"fas fa-cog\" id=\"icon\"></i>\r\n\r\n    <div id=\"message\">Child Data Repeater section has an invalid configuration. ({{invalidConfigurationMessage}})</div>\r\n</div>\r\n\r\n<!-- Main Child Repeater: {{isMainChildRepeater}}<br>\r\nVisible Row Count: {{visibleRowCount}}<br>\r\nForm Array Count: {{ formArray?.length }}<br>\r\n\r\nFormArrayData : <pre><p>{{ formArray?.getRawValue() | json }}</p></pre><br>  -->\r\n<div dwRow [formGroup]=\"formGroup\" *ngIf=\"formArraySetup && formArray && sectionConfig && !invalidConfiguration\">\r\n    <div dwCol=\"12\">\r\n        <dw-validation-info [formControlName]=\"formArrayName\" [submitted]=\"submitted\"\r\n            [filterKey]=\"sectionKey\"></dw-validation-info>\r\n        <ng-container *ngIf=\"visibleRowCount == 0\"> {{ sectionConfig?.noRowsMessage || 'There are no items to display'\r\n            }}</ng-container>\r\n    </div>\r\n    <div dwCol=\"12\">\r\n        <ng-container [formArrayName]=\"formArrayName\">\r\n            <ng-container *ngIf=\"sectionConfig?.showAsGrid\">\r\n                \r\n            </ng-container>\r\n            <ng-container *ngIf=\"!sectionConfig?.isOrderable && !sectionConfig?.showAsGrid\">\r\n                <ng-container *ngFor=\"let item of formArray.controls; index as i\">\r\n                    <div dwRow *ngIf=\"!useFilterIndexes || visibleIndexes[i]\">\r\n                        <div dwCol=\"12\">\r\n                            <div class='left-column'>\r\n                                <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"sectionConfig.section\"\r\n                                    [formGroup]=\"formArray.controls[i]\" [context]=\"context\" [submitted]=\"submitted\"\r\n                                    [parentIsVisible]=\"visible\">\r\n                                </dw-dynamic-section>\r\n                            </div>\r\n                            <div class='right-column' *ngIf=\"!formConfig?.readOnly && !sectionConfig?.hideRemove\">\r\n\r\n                                <ng-container *ngIf=\"showDelete(i)\">\r\n                                    <button class=\"btn btn-sm btn-danger hide-mobile hand\" (click)=\"removeItem(i)\"\r\n                                        title=\"Remove\">\r\n                                        <i class=\"fa fa-times hand\"></i>\r\n                                    </button>\r\n                                    <button class=\"btn btn-sm btn-danger show-mobile\" (click)=\"removeItem(i)\"\r\n                                        title=\"Remove\">\r\n                                        <i class=\"fa fa-times hand\"></i> Remove\r\n                                    </button>\r\n                                </ng-container>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </ng-container>\r\n            </ng-container>\r\n            <ng-container *ngIf=\"sectionConfig?.isOrderable && !sectionConfig?.showAsGrid\">\r\n                <dw-ordered-list [(items)]=\"formArray.controls\" (itemsChange)=\"onReorder($event)\" [useVisibleIndexes]=\"false\" [visibleIndexes]=\"visibleIndexes\">\r\n                    <ng-container *dwListItem=\"let item, index as i\">\r\n                        <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"sectionConfig.section\"\r\n                            [formGroup]=\"item\" [context]=\"context\" [submitted]=\"submitted\" [parentIsVisible]=\"visible\">\r\n                        </dw-dynamic-section>\r\n                    </ng-container>\r\n                </dw-ordered-list>\r\n            </ng-container>\r\n        </ng-container>\r\n        <button (click)=\"addItemClick()\" class=\"btn btn-sm btn-success mt-1\"\r\n            *ngIf=\"!formConfig?.readOnly && !sectionConfig?.hideAdd && showAdd()\"> {{ sectionConfig?.addTextOverride ||\r\n            'Add' }}</button>\r\n    </div>\r\n</div>\r\n<!-- \r\nUse Filters: {{useFilterIndexes }}<br>\r\nVisible Indexes {{  visibleIndexes | json}}<br> -->",
                styles: [".right-column{float:left;margin-left:4px;margin-top:15px;padding:0;width:30px}.left-column{float:left;padding:5px;width:calc(100% - 75px)}.message-text{font-size:larger}"]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwExpressionStateService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormBuilderService }, { type: DwMetadataFormValidationBuilderService }, { type: DwMetadataFormUtilService }, { type: DwContextService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }]; }, null); })();
const ɵDwDynamicFieldHorizontalComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwDynamicFieldHorizontalComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDynamicFieldHorizontalComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: '[dwDynamicFieldHorizontal],dwDynamicFieldHorizontal',
                template: `
    <div [hidden]="!fieldDef.isVisible" [ngClass]="dataClasses" class="row">
       <div class="col-sm-2" [ngStyle]="labelColStyle"> 
            <span [hidden]="!fieldDef?.iconClass">
                <i [ngClass]="fieldDef?.iconClass"></i>&nbsp;&nbsp;
            </span>
            <label [ngClass]="labelClasses" class="col-form-label" [hidden]="fieldDef?.hideLabel">{{ fieldDef?.label }} <span class="required-label" [hidden]="!isRequired || fieldDef?.hideLabel" title="Required">&nbsp;*</span> <i class="fa fa-info-circle ml-1" [hidden]="!fieldDef?.infoText" [title]="fieldDef?.infoText"></i></label>
      </div>
      <div class="col-sm-10" [ngStyle]="dataColStyle">
        <ng-template dw-component-host></ng-template>
        <ng-container [formGroup]="formGroup">
            <dw-validation-info [formControlName]="fieldDef?.attrName" [displayName]="fieldDef?.label" [submitted]="submitted"></dw-validation-info>
        </ng-container>
       </div>
    </div>
  `
            }]
    }], null, { labelWidth: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdPageMenuComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-md-page-menu',
                template: "<p>dw-md-page-menu works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
const ɵDwRadioLookupComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwRadioLookupComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRadioLookupComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-radio-lookup',
                template: `
        <div class="dw-radio-lookup">
            <div class="dw-radio-lookup-item" *ngFor="let item of finalLookupItems">
                <div class="p-field-radiobutton">
                    <p-radioButton name="radioList" [value]="item.Id" [label]="item.Display" [(ngModel)]="translatedValue" (ngModelChange)="setTranslatedValue(item.Id)"></p-radioButton>
                    <!--  Moved to p-radioButton label property <label for="radioList">{{item.Display}}</label>-->
                </div>
            </div> 
        </div>

        
        <ng-container *ngIf="false">
            <div class="dw-radio-lookup" *ngFor="let item of finalLookupItems">
                <button class="btn btn-success" (click)="setTranslatedValue(item.Id)" [ngClass]="{ active : item?.Id == translatedValue}">{{item.Display}}</button>
            </div>
        </ng-container>

        {{lookupErorMessage}}
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwRadioLookupComponent),
                        multi: true
                    }]
            }]
    }], null, { maxItems: [{
            type: Input
        }], options: [{
            type: Input
        }] }); })();
const ɵDwViewEditSectionConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwViewEditSectionConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwViewEditSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-view-edit-section-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"View/Edit Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Show Edit on Load</label>\r\n                    <dw-yesno [(ngModel)]=\"section.showEditOnLoad\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Use Single Template</label>\r\n                    <dw-yesno [(ngModel)]=\"section.useSingleTemplate\" (ngModelChange)=\"useSingleTemplateChange()\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\" (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\" [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                </dw-md-section-standard-config>       \r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>  \r\n\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwViewEditSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-view-edit-section',
                template: `
    <div class="dw-view-edit-container">
      <div class="dw-form-floating-top-right hide-print-item" (click)="toggleEdit()" *ngIf="!showEdit && !isSectionReadOnly()">
        <i class="fa fa-pencil circle-icon"></i>
      </div>
    </div>
    <div class="dw-view-edit-container-after">
      <ng-container *ngIf="!showEdit">
        <dw-dynamic-section [formConfig]="formConfig" (visibleChange)="setChildVisibility(r*10+c, $event)" [sectionConfig]="viewSection" [formGroup]="formGroup" [context]="context" [submitted]="submitted" [parentIsVisible]="visible"></dw-dynamic-section>
      </ng-container>

      <ng-container *ngIf="showEdit">
        <dw-dynamic-section [formConfig]="formConfig" (visibleChange)="setChildVisibility(r*10+c, $event)" [sectionConfig]="editSection" [formGroup]="formGroup" [context]="context" [submitted]="submitted" [parentIsVisible]="visible"></dw-dynamic-section>
      </ng-container>
    </div>    
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataActionConfigService }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataFormActionService }, { type: DwMetaDataFormSectionStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAdhocLookupService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiSelectAdhocComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-multi-select-adhoc-lookup',
                template: `
        <p-autoComplete #autocomplete inputStyleClass="form-control" display="chip" [ngModel]="currentItem" (ngModelChange)="addItem($event)" [disabled]="disabled" [style]="{'width':'100%'}" [suggestions]="lookupItems" (completeMethod)="searchStart($event)" field="Display" appendTo="body" baseZIndex="1100" [placeholder]="placeholder || 'Start typing to find values'" [dropdown]="true"></p-autoComplete>


        <button class="btn-sm btn-success" [hidden]="!adhocText || options?.preventCustomAdd" (click)="addAdHocItem(adhocText)">Add {{adhocText}}</button>

        <div [hidden]="!translatedValue?.length" class="dw-chip-container">
            <div *ngFor="let item of translatedValue; let i = index" class="dw-chip">
                <div class="dw-chip dw-chip-100">
                    <div class="dw-chip-label-with-remove">{{item}}</div>
                    <div class="dw-chip-icon" (click)="removeItem(item, i)"><i class="fa fa-times-circle"></i></div>
                </div>
            </div>
        </div>
        <div [hidden]="translatedValue?.length>0">
            No Items selected
        </div>
    `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwMultiSelectAdhocComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwEventService }, { type: DwSecurityUserService }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwAdhocLookupService }, { type: DwMetaDataRoutingService }, { type: DwLookupParameterUtilService }, { type: ɵngcc2.ActivatedRoute }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, { allowAdd: [{
            type: Input
        }], options: [{
            type: Input
        }], autoComplete: [{
            type: ViewChild,
            args: ['autocomplete']
        }] }); })();
const ɵDwMultiSelectAdhocReadOnlyComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMultiSelectAdhocReadOnlyComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiSelectAdhocReadOnlyComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-multi-select-adhoc-readonly',
                template: `
    <div [hidden]="!translatedValue?.length" class="dw-chip-container">
        <div *ngFor="let item of translatedValue; let i = index" class="dw-chip">
            <span class="dw-chip-label">{{item}}</span>
        </div>
    </div>
    <div [hidden]="translatedValue?.length>0">
        {{ missingDataText }}
    </div>
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwMultiSelectAdhocReadOnlyComponent),
                        multi: true
                    }]
            }]
    }], null, { missingDataText: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFieldSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-field-selection',
                template: "<ng-container *ngIf=\"attributes?.length > 0\">\r\n    <div class=\"filterContainer\" *ngIf=\"showSearch\">\r\n        <div class=\"filter\">\r\n            <div class=\"input-group mb-3\">\r\n                <div class=\"input-group-prepend\">\r\n                    <span class=\"input-group-text\">Search</span>\r\n                </div>\r\n\r\n                <input type=\"text\" class=\"form-control\" [ngModel]=\"searchText\" (ngModelChange)=\"setSearchText($event)\"\r\n                    *ngIf=\"showSearch\">\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"filterContainer\">\r\n        <div class=\"sort\">\r\n            <i class=\"fa fa-sort-numeric-up fa-border\" [hidden]=\"fieldSort != 'none'\" (click)=\"toggleSort()\"\r\n                title='Toggle Sort'></i>\r\n            <i class=\"fa fa-sort-alpha-up fa-border\" [hidden]=\"fieldSort != 'alphaAsc'\" (click)=\"toggleSort()\"\r\n                title='Toggle Sort'></i>\r\n            <i class=\"fa fa-sort-alpha-down fa-border\" [hidden]=\"fieldSort != 'alphaDesc'\" (click)=\"toggleSort()\"\r\n                title='Toggle Sort'></i>\r\n            <i class=\"fa fa-search fa-border\" (click)=\"showSearch = true\" title='Show Search' *ngIf=\"!showSearch\"></i>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"removeSpaceContainer\">\r\n\r\n    </div>\r\n\r\n    <div *ngFor=\"let attr of availbleAttributes\" class=\"field-item\">\r\n        <button class=\"btn btn-sm btn-success\" (click)=\"itemClick(attr)\">\r\n            <i class=\"fa fa-plus-circle hand\" [title]=\"addTooltip\"></i>\r\n            {{attr.AttributeDisplay}}\r\n        </button>\r\n    </div>\r\n\r\n    <div *ngIf=\"availbleAttributes.length === 0\">\r\n        No Fields found\r\n    </div>\r\n</ng-container>",
                styles: [".filterContainer{overflow:auto}.removeSpaceContainer{margin-top:-45px;transition:all 2s}.filter{float:left;width:100%}.filter i{float:right;font-size:1.1em}.sort{float:right;height:45px}.sort i{float:right;font-size:1.1em;margin-right:3px}"]
            }]
    }], function () { return []; }, { addTooltip: [{
            type: Input
        }], attributeClick: [{
            type: Output
        }], attributes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwConditionalFieldClassesComponent, [{
        type: Component,
        args: [{
                selector: 'dw-conditional-field-classes',
                template: "<div *ngFor=\"let className of classNames; let i = index\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <b>{{classLabels[i]}}</b>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngFor=\"let fieldClass of conditionalClasses[className];let i = index\">\r\n        <ng-container *ngTemplateOutlet=\"fieldClassTemplate; context: {fieldClass: fieldClass, className: className, index:i }\"></ng-container>\r\n    </ng-container>\r\n    <div dwRow>\r\n        <div dwCol>\r\n            <button class=\"btn-sm btn-success\" (click)=\"addItem(className)\">Add</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<ng-template #fieldClassTemplate let-fieldClass=\"fieldClass\" let-className='className' let-index='index'>  \r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Conditional Class {{index+1}}</label>\r\n            <i class=\"fa fa-times-circle dw-red pull-right\" title=\"Remove Class\" (click)=\"removeItem(className, fieldClass)\"></i>\r\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"fieldClass.className\" (ngModelChange)=\"onChange()\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <div class=\"expr-column-full\">\r\n                <dw-expression-picker-control [(ngModel)]=\"fieldClass.expression\" (ngModelChange)=\"onChange()\"\r\n                    [contextNames]=\"contextNames\" [item]=\"itemName\" [queryMeaning]=\"queryMeaning\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n    </div>\r\n  \r\n    <hr>\r\n</ng-template>",
                styles: [""]
            }]
    }], function () { return []; }, { classNames: [{
            type: Input
        }], classLabels: [{
            type: Input
        }], conditionalClassesChange: [{
            type: Output
        }], conditionalClasses: [{
            type: Input
        }], contextNames: [{
            type: Input
        }], itemName: [{
            type: Input
        }], queryMeaning: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnActionButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-column-action-buttons',
                template: `
  <div class="dw-grid-row-buttons" [hidden]="!params?.data || inEditMode">
    <dw-action-bar [actionPreferences]="rowActionPreferences" [actionContext]="actionContext" (actionClick)="triggerAction($event)" useContainerStyle="false"></dw-action-bar>
  </div> 
  <div class="dw-grid-row-buttons" [hidden]="!params?.data || !inEditMode">
    <dw-action-bar [actionPreferences]="rowActionsInlineEditPreferences" [actionContext]="actionContext" (actionClick)="triggerAction($event)" useContainerStyle="false"></dw-action-bar>
  </div> 
    `
            }]
    }], function () { return [{ type: DwMetaDataActionExpressionService }]; }, null); })();
const ɵDwGridColumnImageConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwGridColumnImageConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnImageConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-grid-column-image-config',
                template: "<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Image Url \r\n            <i class=\"fa fa-info-circle\" title=\"Replacements can be used using [data.fieldName] and [globals.apiRoot]\"></i>\r\n        </label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.imageUrl\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Missing Image Url\r\n            <i class=\"fa fa-info-circle\" title=\"Used when any placeholder is null in the Image Url\"></i>\r\n        </label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.missingImageUrl\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"6\">\r\n        <label class=\"label\">Width</label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.imageWidth\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n    <div dwCol=\"6\">\r\n        <label class=\"label\">Height</label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.imageHeight\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"6\">\r\n        <label class=\"label\">Image Class</label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.imageClass\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n    <div dwCol=\"6\">\r\n        <label class=\"label\">Display Field <i class=\"fa fa-info-circle\" title=\"Optional field name to display to the right of the image\"></i></label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"config.displayAttributeName\" (ngModelChange)=\"onChange()\">\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnImageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-column-image',
                template: `
    <div class="dw-image-column-container">
      <div [ngStyle]="style" class="dw-image-column-image">
        <img [src]="imageSrc" *ngIf="imageSrc" [ngStyle]="style" [ngClass]="gridColumnConfig?.imageClass" >
      </div>
      <div class="dw-image-column-text" [hidden]="!gridColumnConfig?.displayAttributeName">
        {{displayValue2}}
      </div>
    </div>
    <!--<div [ngStyle]="style">
      <img [src]="imageSrc" *ngIf="imageSrc" [ngStyle]="style" [ngClass]="gridColumnConfig?.imageClass" >
    </div>

  <div style="display:flex;white-space:nowrap">
    <div [ngStyle]="style" style2="display:inline-block">
      <img [src]="imageSrc" *ngIf="imageSrc" [ngStyle]="style" [ngClass]="gridColumnConfig?.imageClass" >
    </div>
    <div style="overflow:hidden;text-overflow:ellipsis;margin-left:5px;">
      {{displayValue2}}
    </div>
 </div>-->
  `
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwTemplateUtilService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnLinkRendererService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAssociativeLookupFilterConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-associative-lookup-filter-config',
                template: "<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>Relationship</label>\r\n        <select [ngModel]=\"config?.relationshipInfo?.relationshipName\" (ngModelChange)=\"onRelationshipChange($event)\"  class=\"form-control\">\r\n            <option *ngFor=\"let item of itemMetaData?.Relations\" [ngValue]=\"item.RelationshipName\">\r\n                {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"config?.relationshipInfo?.relationshipName\">\r\n    <div dwCol=\"9\">\r\n        <label>Use Child Relationship</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.useChildRelationship\" (ngModelChange)=\"onChange()\">\r\n        </p-inputSwitch>\r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"config.useChildRelationship && config?.relationshipInfo?.relationshipName\">\r\n    <div dwCol=\"12\">\r\n        <label>Child Relationship</label>\r\n        <select [ngModel]=\"config?.childRelationshipInfo?.relationshipName\" (ngModelChange)=\"onChildRelationshipChange($event)\"  class=\"form-control\">\r\n            <option *ngFor=\"let item of childItemMetaData?.Relations\" [ngValue]=\"item.RelationshipName\">\r\n                {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Allow Multiple</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.allowMultiple\" (ngModelChange)=\"onChange()\">\r\n        </p-inputSwitch>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAssociativeLookupFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-associative-lookup-filter',
                template: `
  <label class='label'>{{ filterConfig.label}}</label>

  <ng-container *ngIf="filterConfig?.additionalConfig?.allowMultiple && associativeConfig?.lookupId">
    <dw-multi-select-lookup [(ngModel)]="lookupIds" (ngModelChange)="lookupIdsChanged()" [lookupId]="associativeConfig?.lookupId" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'">
    </dw-multi-select-lookup>
  </ng-container>

  <ng-container *ngIf="!filterConfig?.additionalConfig?.allowMultiple  && associativeConfig?.lookupId">
    <dw-search-select-lookup [(ngModel)]="lookupValue" (ngModelChange)="lookupValueChanged()" [lookupId]="associativeConfig?.lookupId" [valueAttrName]="fieldDef?.alternateLookupValueAttrName || 'Id'">
    </dw-search-select-lookup>
  </ng-container>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAdhocLookupFilterConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-adhoc-lookup-filter-config',
                template: "<div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Match All <i class=\"fa fa-info-circle\" title=\"Determines if matches all or any items selected\"></i></label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.matchAll\" (ngModelChange)=\"onChange()\">\r\n        </p-inputSwitch>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAdhocLookupFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-adhoc-lookup-filter',
                template: `
  <label class='label'>{{ label }}</label>
  
  <dw-multi-select-adhoc-lookup [(ngModel)]="values" (ngModelChange)="valuesChanged()" [lookupId]="lookupIdMeaning">
  </dw-multi-select-adhoc-lookup>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwAdhocLookupService }]; }, null); })();
const ɵDwMultiSelectFilterConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMultiSelectFilterConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiSelectFilterConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-multi-select-filter-config',
                template: "<div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Auto Expand</label>\r\n    </div>\r\n    <div dwCol=\"3\" class=\"pull-right\">\r\n        <p-inputSwitch [(ngModel)]=\"config.autoExpand\" (ngModelChange)=\"onChange()\">\r\n        </p-inputSwitch>\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiSelectFilterService, [{
        type: Injectable
    }], function () { return [{ type: DwMenuService }, { type: DwMetaDataFilterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiSelectLookupFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-multi-select-lookup-filter',
                template: `
  <label class='label'>{{ label }}</label>
  
  <dw-multi-select-lookup [(ngModel)]="values" (ngModelChange)="valuesChanged()" [lookupId]="lookupIdMeaning" [autoExpand]="filterConfig?.additionalConfig?.autoExpand" useTransitions="false">
  </dw-multi-select-lookup>
  `
            }]
    }], function () { return [{ type: DwMetaDataFilterService }, { type: DwMultiSelectFilterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataListConfigBasicWidgetComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-list-config-basic',
                template: "<div>\r\n    <h3>List Preferences</h3>\r\n\r\n    <form [formGroup]=\"configForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Basic Settings\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Header</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showHeader\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Header Title</label>\r\n                    </div>\r\n                    <div dwCol=\"12\">\r\n                        <input formControlName=\"headerTitle\">\r\n                    </div>\r\n                </div>\r\n            \r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Show Display value</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showDisplayProperties\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Filtering\">\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Allow Filtering</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"showFilter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                        <div dwCol=\"9\">\r\n                            <label>Show Filter On Load</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch formControlName=\"showFilterOnLoad\"></p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Auto Filter</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"autoFilter\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\"> \r\n                        <label>Filter Delay</label>\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <input type=\"number\" formControlName=\"autoFilterDelay\" class=\"form-control\">\r\n                    </div> \r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <button (click)=\"configFilters()\" class=\"btn btn-success\">Configure Filters</button>\r\n                    </div>\r\n                </div>\r\n\t\t\t</p-accordionTab>\r\n\t\t\t<p-accordionTab header=\"Actions\">\r\n                <div dwRow>\r\n                        <div dwCol=\"9\">\r\n                            <label>Show Action bar</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch formControlName=\"showActions\"></p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n\t\t\t\t<div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide Refresh Button</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideRefresh\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Hide View Toggle</label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch formControlName=\"hideViewToggle\"></p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab> \r\n            <p-accordionTab header=\"Data Setup\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Query</label>\r\n                        <select formControlName=\"MetaDataQueryMeaning\" class=\"form-control\">\r\n                            <option [ngValue]=\"null\">\r\n                                Default\r\n                            </option>\r\n                            <option *ngFor=\"let query of queries\" [ngValue]=\"query.QueryMeaning\">\r\n                                {{query.QueryName}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"List Style\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>List Style</label>\r\n                        <select formControlName=\"listStyleName\" class=\"form-control\">\r\n                            <option *ngFor=\"let item of listStyles\" [ngValue]=\"item.keyName\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </form>\r\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.FormBuilder }, { type: DwEventService }, { type: DwModalService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwDesignerStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataListBasicComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-metadata-list-basic',
                template: "\r\n<div *ngIf=\"configSequenceComplete\" #container>\r\n    <dw-action-host></dw-action-host>\r\n\r\n    <dw-data-list [data]=\"dataSource\" [filters]=\"filters\" [config]=\"config\" mode=\"card\">\r\n        <div filter>\r\n            <dw-metadata-filters [configContext]=\"configContext\" [configKeyPart]=\"configKeyPart\" [filterConfig]=\"config.filters\" [filters]=\"filters\" (filtersChange)=\"setFilters($event)\"></dw-metadata-filters>\r\n        </div>\r\n        <ng-container *dwCardItem=\"let item\">\r\n            <ng-container *ngTemplateOutlet=\"cardItemTemplate; context : {$implicit: item}\"></ng-container>\r\n        </ng-container>\r\n        <ng-container *dwListItem=\"let item\">\r\n            <ng-container *ngTemplateOutlet=\"listItemTemplate; context : {$implicit: item}\"></ng-container>\r\n        </ng-container>\r\n        <ng-container *dwNoItems=\"let item\">\r\n            <span *ngIf=\"!noItemsTemplate\">There are no items found!</span>\r\n\r\n            <ng-container *ngTemplateOutlet=\"noItemsTemplate; context : {$implicit: item}\"></ng-container>\r\n        </ng-container>\r\n    </dw-data-list>\r\n    <p-contextMenu [target]=\"container\" [model]=\"contextMenu\" *ngIf=\"contextMenu && contextMenu.length>0\"></p-contextMenu>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: DwMetaDataListService }, { type: DwUiConfigService }, { type: DwEventService }, { type: DwMetaDataFilterService }, { type: DwSecurityUserService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, { configKeyPart: [{
            type: Input
        }], filters: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], item: [{
            type: Input
        }], cardItemTemplate: [{
            type: ContentChild,
            args: [DwCardItemDirective, { static: true, read: TemplateRef }]
        }], listItemTemplate: [{
            type: ContentChild,
            args: [DwListItemDirective, { static: true, read: TemplateRef }]
        }], noItemsTemplate: [{
            type: ContentChild,
            args: [DwNoItemsDirective, { static: true, read: TemplateRef }]
        }], dwDataList: [{
            type: ViewChild,
            args: [DwDataListComponent]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCardConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-card-config',
                template: "<div dwRow>\r\n    <div dwCol=\"6\">\r\n        <label>Card Component</label>\r\n        <select [(ngModel)]=\"preferences.cardComponentName\" (ngModelChange)=\"changeCardComponent()\" class=\"form-control\">\r\n            <option *ngFor=\"let item of componentList\" [ngValue]=\"item.key\">\r\n                {{item.name}}\r\n            </option>\r\n        </select> \r\n    </div> \r\n    <div dwCol=\"6\">\r\n        <label>List Component</label>\r\n        <select [(ngModel)]=\"preferences.listComponentName\" (ngModelChange)=\"changeListComponent()\" class=\"form-control\">\r\n            <option *ngFor=\"let item of componentList\" [ngValue]=\"item.key\">\r\n                {{item.name}}\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"cardConfigComponent\">\r\n    <div dwCol=\"6\" *ngIf=\"cardConfigComponent\">\r\n        <b>Card Component Configuration</b><br>\r\n        <dw-dynamic-loader [component]=\"cardConfigComponent\" (configure)=\"setupCardConfigComponent($event)\"></dw-dynamic-loader>\r\n    </div>\r\n    <div dwCol=\"6\" *ngIf=\"listConfigComponent\">\r\n        <b>List Component Configuration</b><br>\r\n        <dw-dynamic-loader [component]=\"listConfigComponent\" (configure)=\"setupListConfigComponent($event)\"></dw-dynamic-loader>\r\n    </div>\r\n</div>\r\n\r\n\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>List Component</label>\r\n        <select [(ngModel)]=\"preferences.noItemsComponentName\" (ngModelChange)=\"changeListComponent()\" class=\"form-control\">\r\n            <option *ngFor=\"let item of componentList\" [ngValue]=\"item.key\">\r\n                {{item.name}}\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>\r\n\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>No Items Message</label>\r\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"preferences.noItemsMessage\" (ngModelChange)=\"onChange()\" placeholder=\"There are no items found!\">\r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"false\">\r\n    <div dwCol=\"6\">\r\n        <label>Card Action</label>\r\n        <select [(ngModel)]=\"preferences.cardAction\" (ngModelChange)=\"onChange()\" class=\"form-control\">\r\n            <option *ngFor=\"let item of componentList\" [ngValue]=\"item.key\">\r\n                {{item.name}}\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }, { type: DwUiConfigRegistryService }]; }, { preferencesChange: [{
            type: Output
        }], preferences: [{
            type: Input
        }], configContext: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataCardContentService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwTemplateUtilService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCardDefaultConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-card-default-config',
                template: "<ng-container *ngFor=\"let contentItemDefinition of contentItemDefs; let i = index\">\r\n    <b>{{ contentItemDefinition.display }}</b><br>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <label>Use Template</label>\r\n            <dw-yesno [(ngModel)]=\"config.contentItems[i].useTemplate\" (ngModelChange)=\"onChange()\"></dw-yesno>\r\n        </div>\r\n        <div dwCol=\"12\" *ngIf=\"!config?.contentItems[i].useTemplate\">\r\n            <label>Attribute</label>\r\n\r\n            <p-dropdown [options]=\"allAttributes\" optionLabel=\"AttributeDisplay\" display=\"chip\" optionValue=\"DisplayAttributeName\" [(ngModel)]=\"config.contentItems[i].attributeName\" [showClear]=\"true\" (ngModelChange)=\"onChange()\" [style]=\"{'width':'100%'}\" filter=\"true\" appendTo=\"body\"></p-dropdown>\r\n        </div>\r\n        <div dwCol=\"12\" *ngIf=\"config?.contentItems[i].useTemplate\">\r\n            <label>Template</label>\r\n\r\n            <dw-html-edit [(ngModel)]=\"config.contentItems[i].template\" (ngModelChange)=\"onChange()\">\r\n            </dw-html-edit>\r\n        </div>\r\n    </div>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCardDefaultComponent, [{
        type: Component,
        args: [{
                selector: 'dw-card-default',
                template: `
    <div class="card card-container" (click)="onCardClick()">
      <div class="card-body">

      <dw-html-view [ngModel]="htmlContent">
      </dw-html-view>
      </div>
    </div>
  `,
                styles: [`
      .card-container {
        width:100%;
        height: 100px;
        margin-right:10px;
        float:left;
      }

      .card-container:hover {
        box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
      }
    `]
            }]
    }], function () { return [{ type: DwMetaDataCardContentService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataListActionsConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-list-actions-config',
                template: `
  <dw-action-group-modes-config [configContext]="configContext" [actionModes]="actionModes"
    [(actionPreferencesByMode)]="actionPreferencesByMode" (actionPreferenceByModeChange)="onChange()">
  </dw-action-group-modes-config>`
            }]
    }], function () { return []; }, { actionPreferenceByModeChange: [{
            type: Output
        }], configContext: [{
            type: Input
        }], actionPreferencesByMode: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataRoutingNavigationService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetaDataRoutingService }, { type: ɵngcc2.ActivatedRoute }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwModalService }, { type: DwMessagingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListAddActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataRoutingNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListFilterToggleActionService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListRefreshActionService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListEditActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataRoutingNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListToggleViewActionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-list-toggle-view',
                template: `
    <div class="btn-group dw-button-right">
        <label class="btn btn-success" (click)="setCardMode()" [ngClass]="{ 'dw-btn-success-active': mode=='card' }">
            <i class="fa fa-th" title="Card View"></i>
        </label>
        <label class="btn btn-success" (click)="setListMode()" [ngClass]="{ 'dw-btn-success-active': mode=='list' }" >
            <i class="fa fa-bars" title="List View"></i>
        </label>
    </div>
    `
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteChildMenuConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-child-menu-config',
                template: "<div [formGroup]=\"childListMenuOptionsFG\" *ngIf=\"childListMenuOptionsFG\">\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Is Child List Menu <i class=\"fa fa-info-circle\"\r\n                    title=\"Show this menu under Edit, View or Print child menus\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"isChildListMenu\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"childListMenuOptionsFG?.value?.isChildListMenu\">\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Show on Parent <i class=\"fa fa-info-circle\"\r\n                        title=\"Indicates if menu should also show on the parent\"></i></label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"showOnParent\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Select Children <i class=\"fas fa-info-circle\"\r\n                        title=\"Determines which children menu should be displayed on.  Add is not shown since you can't have a child of a new record\"></i></label>\r\n                <div class=\"form-control\" style=\"overflow:auto; min-height:20px\">\r\n                    <input type=\"checkbox\" formControlName=\"showOnEditChild\" (ngModelChange)=\"fieldChange($event)\"> Edit\r\n                    <input type=\"checkbox\" formControlName=\"showOnViewChild\" (ngModelChange)=\"fieldChange($event)\"> View\r\n                    <input type=\"checkbox\" formControlName=\"showOnPrintChild\" (ngModelChange)=\"fieldChange($event)\"> Print\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                styles: ["input{margin-left:10px}"]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, { routeConfigFG: [{
            type: Input,
            args: ['routeConfigFormGroup']
        }], route: [{
            type: Input
        }], routeTypeProcessorRegistration: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwParentFilterConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-parent-filter-config',
                template: "\r\n<div dwRow>\r\n    <div dwCol=\"9\">\r\n        <label>Use Relationship</label>\r\n    </div>\r\n    <div dwCol=\"3\">\r\n        <p-inputSwitch [(ngModel)]=\"config.useRelationship\" (ngModelChange)=\"onRelationshipChange(null)\">\r\n        </p-inputSwitch>\r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"config.useRelationship\">\r\n    <div dwCol=\"12\">\r\n        <label>Relationship</label>\r\n        <select [ngModel]=\"config?.relationshipInfo?.relationshipName\" (ngModelChange)=\"onRelationshipChange($event)\"  class=\"form-control\">\r\n            <option *ngFor=\"let item of itemMetaData?.Relations\" [ngValue]=\"item.RelationshipName\">\r\n                {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"config\">\r\n    <div dwCol=\"12\">\r\n        <label>Filter Attribute</label>\r\n        <select [(ngModel)]=\"config.relationAttributeName\" (ngModelChange)=\"onChange()\"  class=\"form-control\">\r\n            <option *ngFor=\"let attr of attributeList\" [ngValue]=\"attr.AttributeName\">\r\n                {{attr.Display}}\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"config\">\r\n    <div dwCol=\"12\">\r\n        <label>Route Parameter</label>\r\n        <select [(ngModel)]=\"config.relationParamName\" (ngModelChange)=\"onChange()\"  class=\"form-control\">\r\n            <option *ngFor=\"let paramname of paramNames\" [ngValue]=\"paramname\">\r\n                {{paramname}}\r\n            </option>\r\n        </select> \r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMenuService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwParentFilterService, [{
        type: Injectable
    }], function () { return [{ type: DwMenuService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwParentFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-parent-filter',
                template: `Parent Filter<br> {{item}}.{{filterConfig?.additionalConfig?.relationAttributeName}} == {{paramValue}}`
            }]
    }], function () { return [{ type: DwParentFilterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnTemplateConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-column-template-config',
                template: "<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>Template</label>\r\n        <textarea type=\"text\" [(ngModel)]=\"config.htmlContent\" (ngModelChange)=\"onChange()\" class=\"form-control\"></textarea>\r\n    </div>\r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>Add Fields to Template</label>\r\n        <select [(ngModel)]=\"selectedField\" class=\"form-control\">\r\n            <option *ngFor=\"let attr of queryMetaData.Attributes\" [ngValue]=\"attr.DisplayAttributeName\">\r\n                {{ attr.AttributeDisplay}}\r\n            </option>\r\n        </select>\r\n        \r\n        <button class=\"btn btn-sm btn-success\" (click)=\"addField()\">\r\n            <i class=\"fa fa-plus-circle hand\" title=\"Add Field\"></i>\r\n            Add Template Field\r\n        </button>\r\n    </div> \r\n</div>\r\n<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label>Blank Replacement Value</label>\r\n        <textarea type=\"text\" [(ngModel)]=\"config.blankReplacementValue\" (ngModelChange)=\"onChange()\" class=\"form-control\"></textarea>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridColumnTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-column-template',
                template: `
  <dw-html-view [(ngModel)]="finalHtmlContent">
  </dw-html-view>
  `
            }]
    }], function () { return [{ type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwTemplateUtilService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAdvancedFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-advanced-filter',
                template: `
    <label class='label'>{{ filterConfig.label || 'Advanced Search'}}</label>
    <dw-expression-picker-control [(ngModel)]="filterExpression" (ngModelChange)="updateExpression()" addButtonText="Create Filter" editButtonText="Edit Filter"
        [item]="item" [queryMeaning]="queryMetaData?.QueryMeaning">
    </dw-expression-picker-control>
  `
            }]
    }], function () { return [{ type: DwQueryFilterConverterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQuickGrid, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-quick-grid',
                template: `
        <ng-container *ngIf="setupComplete">
            <dw-meta-data-grid *ngIf="gridPreferences" [item]="item" configKeyPart="none" [filters]="filters" allowConfig="false" [dataSource]="data || dataSource" [preferences]="gridPreferences" (gridEvent)="onGridEvent($event)"></dw-meta-data-grid>
        </ng-container>
    `
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { actionPreferencesByMode: [{
            type: Input
        }], customizeActions: [{
            type: Input
        }], gridEvent: [{
            type: Output
        }], item: [{
            type: Input
        }], query: [{
            type: Input
        }], filters: [{
            type: Input
        }], columnPreferences: [{
            type: Input
        }], data: [{
            type: Input
        }], loadCount: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFilterTilesConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-filter-tiles-config',
                template: "<dw-ui-config-list [items]=\"tileConfig.tiles\" [config]=\"listConfig\" [selectedItem]=\"selectedItem\" size=\"large\"\r\n    (selectedItemChange)=\"setSelectedItem($event)\" (removeItem)=\"removeItem($event)\" (reorder)=\"reorderList()\">\r\n    <div addItemsTab>\r\n        <div *ngFor=\"let tileTypeConfig of tileTypeConfigs\" class=\"dw-field-item\">\r\n            <button class=\"btn btn-sm btn-success\" (click)=\"addTile(tileTypeConfig)\">\r\n                <i class=\"hand\" [ngClass]=\"tileTypeConfig?.configData?.tileIconClass\"\r\n                    title=\"Add  {{tileTypeConfig.name}} Tile\"></i>\r\n                {{tileTypeConfig.name}}\r\n            </button>\r\n        </div>\r\n\r\n    </div>\r\n    <div actionBar>\r\n        <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n    </div>\r\n    <div configureItemTab>\r\n        <p-accordion *ngIf=\"selectedItem\">\r\n            <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Display</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.tileDisplay\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Header Foreground Color</label>\r\n                        <dw-color-select [(ngModel)]=\"selectedItem.tileHeaderForegroundColor\"></dw-color-select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Header Background Color</label>\r\n                        <dw-color-select [(ngModel)]=\"selectedItem.tileHeaderBackgroundColor\"></dw-color-select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Icon Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.tileIconClass\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.tileClass\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Heading Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.tileHeadingClass\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Key</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.tileKey\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Exclude from Group Query <i class=\"fa fa-info-circle\"\r\n                                title=\"Excludes the optimization step to group tile queries into a single query.\"></i></label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch [(ngModel)]=\"selectedItem.excludeFromGroupQuery\">\r\n                        </p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Filter <i class=\"fa fa-info-circle\" title=\"Filter to apply for this tile\"></i></label>\r\n                        <dw-expression-picker-control [(ngModel)]=\"selectedItem.filterExpression\"\r\n                            [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\"\r\n                            [queryMeaning]=\"configContext?.metaDataQueryMeaning\">\r\n                        </dw-expression-picker-control>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Visibility\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Visible Expression <i class=\"fa fa-info-circle\"\r\n                                title=\"Choose when this tile is visible\"></i></label>\r\n                        <dw-expression-picker-control [(ngModel)]=\"selectedItem.visibleExpression\"\r\n                            [contextNames]=\"configContext?.contextNames\"\r\n                            [queryMeaning]=\"configContext?.metaDataQueryMeaning\">\r\n                        </dw-expression-picker-control>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n\r\n            <p-accordionTab header=\"Tile Settings\" *ngIf=\"selectedTileTypeConfig?.configComponent\">\r\n                <dw-dynamic-loader [component]=\"selectedTileTypeConfig?.configComponent\"\r\n                    (configure)=\"configureCustomConfig($event)\"></dw-dynamic-loader>\r\n            </p-accordionTab>\r\n\r\n        </p-accordion>\r\n    </div>\r\n    <div additionalTab>\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Style Settings\" [selected]=\"true\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Style</label>\r\n                        <select [(ngModel)]=\"tileConfig.tileStyle\"\r\n                            class=\"form-control\">\r\n                            <option value=\"standard\">Standard</option>\r\n                            <option value=\"icon\">Icon</option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Default Icon</label>\r\n                        <input type=\"text\" [(ngModel)]=\"tileConfig.tileDefaultIconClass\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Container Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"tileConfig.tileContainerClass\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tile Class</label>\r\n                        <input type=\"text\" [(ngModel)]=\"tileConfig.tileClass\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"9\">\r\n                        <label>Dynamic Sizing <i class=\"fa fa-info-circle\"\r\n                            title=\"Automatically expand tile size based on number of visible tiles\"></i></label>\r\n                    </div>\r\n                    <div dwCol=\"3\">\r\n                        <p-inputSwitch [(ngModel)]=\"tileConfig.useResponsiveTiles\">\r\n                        </p-inputSwitch>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Tiles Per Row <i class=\"fa fa-info-circle\"\r\n                                title=\"Determines max tiles for the row, extra tiles will show in compact mode. Accepts a responsize string: 1,2,4,6 (xs,sm,md,lg)\"></i></label>\r\n                        <input type=\"text\" [(ngModel)]=\"tileConfig.tilesPerRow\" class=\"form-control\" />\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Filter Settings\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Shared Filter <i class=\"fa fa-info-circle\" title=\"Applies to all tiles\"></i></label>\r\n                        <dw-expression-picker-control [(ngModel)]=\"tileConfig.sharedFilterExpression\"\r\n                            [contextNames]=\"configContext?.contextNames\" [item]=\"configContext?.itemName\"\r\n                            [queryMeaning]=\"configContext?.metaDataQueryMeaning\">\r\n                        </dw-expression-picker-control>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n\r\n    </div>\r\n</dw-ui-config-list>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { tileConfigChange: [{
            type: Output
        }], tileConfig: [{
            type: Input
        }], configContext: [{
            type: Input
        }], initialFilterTileKey: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwBasicTileFilterBuilderService, [{
        type: Injectable
    }], function () { return [{ type: DwQueryFilterConverterService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwExpressionService }]; }, null); })();
const ɵDwBasicTileConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwBasicTileConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwBasicTileConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-basic-tile-config',
                template: `
    <div dwRow>
      <div dwCol="12">
          <label>Metric Text <i class="fa fa-info-circle" title="This will show in the place of a count"></i></label>
          <input type="text" class="form-control" [(ngModel)]="config.additionalConfig.metricText" (ngModelChange)="onChange()">
        </div>
    </div>
   `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwBasicTileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-basic-tile',
                template: "<div (click)=\"onTileClick()\" [ngClass]=\"tileClass\" class=\"dw-layout-2\">\r\n  <div class=\"dw-tile-icon-container\" *ngIf=\"tileIconClass\">\r\n    <div class=\"dw-tile-icon\" [ngClass]=\"tileIconContainerClass\">\r\n      <i class=\"fa-2x\" [ngClass]=\"tileIconClass\" [ngClass]=\"tileIconClass\"></i>\r\n    </div>\r\n  </div>\r\n  <div class=\"dw-tile-detail-container\">\r\n    <div [ngClass]=\"tileCountClass\" [hidden]=\"loading || compactMode\">\r\n      {{ tileValue==null ? tileConfig?.additionalConfig?.metricText : tileValue }}\r\n    </div>\r\n    <div [ngClass]=\"tileCountClass\" [hidden]=\"!loading || compactMode\">\r\n      <dw-loading show=\"true\" text=\"\"></dw-loading>\r\n    </div>\r\n    <div [ngClass]=\"tileHeadingClass2\">\r\n      {{tileConfig?.tileDisplay}}\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div (click)=\"onTileClick()\" [ngClass]=\"tileClass\" class=\"dw-layout-1\">\r\n  <div [ngClass]=\"tileHeadingClass\">\r\n    {{tileConfig?.tileDisplay}}\r\n\r\n    <span class=\"dw-tile-heading-count\">\r\n      ({{ tileValue==null ? tileConfig?.additionalConfig?.metricText : tileValue }})\r\n    </span>\r\n  </div>\r\n  <div [ngClass]=\"tileCountClass\" [hidden]=\"loading || compactMode\">\r\n    {{ tileValue==null ? tileConfig?.additionalConfig?.metricText : tileValue }}\r\n  </div>\r\n  <div class=\"dw-tile-loading\" [hidden]=\"!loading || compactMode\">\r\n    <dw-loading show=\"true\" text=\"\"></dw-loading>\r\n  </div>\r\n</div>"
                // template: `
                //   <div (click)="onTileClick()" [ngClass]="tileClass">
                //     <div [ngClass]="tileHeadingClass">
                //         {{tileConfig?.tileDisplay}}
                //     </div>
                //     <div [ngClass]="tileCountClass" [hidden]="loading">
                //       {{tileValue || 'None'}}
                //     </div>
                //     <div class="dw-tile-loading" [hidden]="!loading">
                //       <dw-loading show="true" text=""></dw-loading>
                //     </div>
                //   </div>
                //   {{tileClass}}<br>
                //   {{tileConfig | json }}
                // `
            }]
    }], function () { return [{ type: DwStyleManagerService }]; }, { compactMode: [{
            type: Input
        }], tileClick: [{
            type: Output
        }], loading: [{
            type: Input
        }], filterChange: [{
            type: Output
        }], filter: [{
            type: Input
        }], item: [{
            type: Input
        }], queryMetaData: [{
            type: Input
        }], tileConfig: [{
            type: Input
        }], tilesConfig: [{
            type: Input
        }], selected: [{
            type: Input
        }], tileValue: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwResponsiveUtilService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, { resize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFilterTilesComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-filter-tiles',
                template: `
    <div class-old="dw-tile-container" [ngClass]="tileContainerClass" *ngIf="tileStates?.tiles?.length > 0">
      <ng-container *ngFor="let tileState of tileStates.tiles, let i = index">
        <div class="dw-tile-item" [ngStyle]="tileItemStyle" *ngIf="tileStates.tiles.length <= columns || i < columns-1" dwPageDesignerSelector [configKey]="configKey" [sectionKey]="viewKey" detailKey="filterTile" [additionalInfo]="tileState.filterTileConfig">
          <dw-basic-tile [tileConfig]="tileState.filterTileConfig" [tilesConfig]="tilesConfig" [selected]="i == selectedIndex" [tileValue]="tileState.metricValue" [loading]="tileState.loading" (click)="selectTile(i)"></dw-basic-tile>
        </div>
      </ng-container>

      <div class="dw-tile-item" [ngStyle]="tileItemStyle" *ngIf="tileStates.tiles.length > columns">
        <ng-container *ngFor="let tileState of tileStates.tiles, let i = index">
          <dw-basic-tile *ngIf="i >= (columns-1)" [tileConfig]="tileState.filterTileConfig" compactMode="true" [tilesConfig]="tilesConfig" [selected]="i == selectedIndex" [tileValue]="tileState.metricValue" [loading]="tileState.loading" (click)="selectTile(i)"></dw-basic-tile>
        </ng-container>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: DwFilterTileService }, { type: DwMetaDataFilterStateService }, { type: DwMetaDataFilterService }, { type: DwEventService }, { type: DwResponsiveUtilService }, { type: ɵngcc2.Router }]; }, { resize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], configKey: [{
            type: Input
        }], viewKey: [{
            type: Input
        }], tilesConfig: [{
            type: Input
        }], configContext: [{
            type: Input
        }], sharedFilterExpression: [{
            type: Input
        }] }); })();
const ɵDwAggregateTileConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAggregateTileConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateTileConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-aggregate-tile-config',
                template: `
    <div dwRow>
      <div dwCol="9">
          <label>Customize Aggregate <i class="fa fa-info-circle" title="Customize the Aggregate function.  Defaults to Count Distinct"></i></label>
        </div> 
        <div dwCol="2">
          <p-inputSwitch [(ngModel)]="config.additionalConfig.useCustomAggregate"></p-inputSwitch>
        </div>
    </div>
    <div dwRow [hidden]="!config.additionalConfig.useCustomAggregate">
      <div dwCol="12">
          <label>Aggregate Function</label>
          <dw-aggregate-field-control [(ngModel)]="config.additionalConfig.aggregateFunction" [showBasicAggregatesOnly]="true"></dw-aggregate-field-control>
        </div> 
    </div>
   `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateTileFilterBuilderService, [{
        type: Injectable
    }], function () { return [{ type: DwQueryFilterConverterService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwExpressionService }]; }, null); })();
const ɵDwAggregateTileComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAggregateTileComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateTileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-aggregate-tile',
                template: "<div (click)=\"onTileClick()\" [ngClass]=\"tileClass\" *ngIf=\"false\">\r\n  <div [ngClass]=\"tileHeadingClass\">\r\n    {{tileConfig?.tileDisplay}} 25\r\n\r\n    <span class=\"dw-tile-heading-count\">\r\n      {{ tileValue == null ? '' : tileValue }}\r\n    </span>\r\n  </div>\r\n  <div [ngClass]=\"tileCountClass\" [hidden]=\"loading\">\r\n    {{ tileValue == null ? 'None2' : tileValue }}\r\n  </div>\r\n  <div class=\"dw-tile-loading\" [hidden]=\"!loading\">\r\n    <dw-loading show=\"true\" text=\"\"></dw-loading>\r\n  </div>\r\n</div>\r\n\r\n<div (click)=\"onTileClick()\" [ngClass]=\"tileClass\" *ngIf=\"false\">\r\n  <div class=\"dw-tile-icon\">\r\n    <i class=\"fa fa-2x fa-users\" [ngClass]=\"tileIconClass\"></i>\r\n  </div>\r\n  <div [ngClass]=\"tileHeadingClass\">\r\n    {{tileConfig?.tileDisplay}} 25\r\n\r\n    <span class=\"dw-tile-heading-count\">\r\n      {{ tileValue == null ? '' : tileValue }}\r\n    </span>\r\n  </div>\r\n  <div [ngClass]=\"tileCountClass\" [hidden]=\"loading\">\r\n    {{ tileValue == null ? 'None2' : tileValue }}\r\n  </div>\r\n  <div class=\"dw-tile-loading\" [hidden]=\"!loading\">\r\n    <dw-loading show=\"true\" text=\"\"></dw-loading>\r\n  </div>\r\n</div>"
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLookupTileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-lookup-tile',
                template: "<p>dw-lookup-tile works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwLookupTileConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-lookup-tile-config',
                template: "<p>dw-lookup-tile-config works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerHelperService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerStateService, [{
        type: Injectable
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwPageDesignerHelperService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerDragDropService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: DwPageDesignerStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-page-designer',
                template: "\r\n<div cdkDropListGroup *ngIf=\"pageDesignerConfig\" cdkDragBoundary  style=\"width:100%;min-height:500px;position:relative\" (click)=\"unselect()\">\r\n\r\n    <div style=\"max-width:1200px\">\r\n        <dw-button-bar>\r\n            <button class=\"btn btn-success\">Save Design</button> <button class=\"btn btn-warning\">Reset</button>\r\n\r\n            <div right>\r\n                <div class=\"btn-group dw-button-right\">\r\n                    <label class=\"btn btn-success\" (click)=\"dwPageDesignerStateService.setShowBorders(false)\" [ngClass]=\"{ 'dw-btn-success-active': pageDesignerState?.showAllBorders }\">\r\n                        <i class=\"fa fa-border-none\" title=\"Hide Borders\"></i>\r\n                    </label>\r\n                    <label class=\"btn btn-success\" (click)=\"dwPageDesignerStateService.setShowBorders(true)\" [ngClass]=\"{ 'dw-btn-success-active': !pageDesignerState?.showAllBorders }\" >\r\n                        <i class=\"fa fa-border-all\" title=\"Show Borders\"></i>\r\n                    </label>\r\n                </div>\r\n            </div>\r\n        </dw-button-bar>\r\n    </div>\r\n    <dw-dynamic-loader *ngIf=\"pageDesignerConfig.rootSectionDesignComponent\"\r\n        [component]=\"pageDesignerConfig.rootSectionDesignComponent\" (configure)=\"configureDesigner($event)\">\r\n    </dw-dynamic-loader>\r\n\r\n    <div class=\"pd-toolbox\" cdkDrag>\r\n        <div class=\"pd-toolbox-header\" cdkDragHandle>\r\n            <i class=\"fa fa-grip-vertical pd-section-icon\"></i>\r\n        </div>\r\n        <p-tabView>\r\n            <p-tabPanel header=\"Toolbox\"  cdkDragHandle>\r\n                <ng-template pTemplate=\"header\"><div cdkDragHandle>Toolbox</div></ng-template>\r\n\r\n                <dw-page-designer-toolbar [pageDesignerConfig]=\"pageDesignerConfig\"></dw-page-designer-toolbar>\r\n            </p-tabPanel>\r\n            <p-tabPanel header=\"Configuration\" *ngIf=\"pageDesignerState.currentSectionConfigKey\">\r\n                <ng-template pTemplate=\"header\"><div cdkDragHandle>Configuration</div></ng-template>\r\n\r\n                <dw-page-designer-config-panel></dw-page-designer-config-panel>\r\n            </p-tabPanel>\r\n        </p-tabView>\r\n\r\n    </div>\r\n</div>",
                providers: [DwPageDesignerDragDropService, DwPageDesignerStateService]
            }]
    }], function () { return [{ type: DwPageDesignerDragDropService }, { type: DwPageDesignerStateService }]; }, { rootConfigChange: [{
            type: Output
        }], rootConfig: [{
            type: Input
        }], pageDesignerConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateRootSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-template-root-section',
                template: `
    <div class="pd-container" style="max-width:1200px">
      <dw-page-designer-section-wrapper [sectionConfig]="sectionConfig" preventMove="true" preventRemove="true"></dw-page-designer-section-wrapper>
    </div>
  `
            }]
    }], function () { return []; }, { sectionConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateDesignerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-template-designer',
                template: `
  <dw-page-designer [rootConfig]="rootConfig" [pageDesignerConfig]="pageDesignerConfig"></dw-page-designer>

  {{ rootConfig | json }}
`
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, null); })();
const ɵDwEmailContainerSectionConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwEmailContainerSectionConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailContainerSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-container-section-config',
                template: `
  <div>
    <div dwRow>
      <div dwCol="12">
          <label class="label">Section Name</label>
          <input type="text" [(ngModel)]="config.sectionName" (ngModelChange)="onChange()" class="form-control">
      </div>
    </div>
      <div dwRow>
        <div dwCol="12">
            <label class="label">Columns</label>
            <input type="text" dwNumeric [(ngModel)]="config.configData.columnsConfig.columns" (ngModelChange)="onChange()" class="form-control">
        </div>
      </div>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailContainerSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-container-section',
                template: "<div dwRow>\r\n    <ng-container *ngFor=\"let column of sectionConfig?.configData?.columns; let i = index\">\r\n        <div [dwCol]=\"columnPreferences[i].columnSize\" [dwColWidth]=\"columnPreferences[i].customWidth\" *ngIf=\"i < sectionConfig?.configData?.columnsConfig?.columns\"\r\n            [dwColClass]=\"columnPreferences[i].columnClass\">\r\n\r\n            <dw-page-designer-container [sections]=\"column.sections\"\r\n                [parentSectionConfig]=\"sectionConfig\"></dw-page-designer-container>\r\n\r\n            </div>\r\n    </ng-container>\r\n</div>\r\n\r\n"
            }]
    }], function () { return [{ type: DwPageDesignerDragDropService }, { type: DwPageDesignerStateService }]; }, { sectionConfig: [{
            type: Input
        }], dropList: [{
            type: ViewChild,
            args: [CdkDropList]
        }] }); })();
const ɵDwEmailTextSectionConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwEmailTextSectionConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTextSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-text-section-config',
                template: `
  <div class2="pd-config-panel">
    <div dwRow>
      <div dwCol="12">
          <label class="label">Section Name</label>
          <input type="text" [(ngModel)]="config.sectionName" (ngModelChange)="onChange()" class="form-control">
      </div>
    </div>
      <div dwRow>
        <div dwCol="12">
            <label class="label">Text</label>
            <dw-html-edit [(ngModel)]="config.configData.html" (ngModelChange)="onChange()"></dw-html-edit>
        </div>
      </div>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTextSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-text-section',
                template: "<dw-html-view [(ngModel)]=\"sectionConfig.configData.html\" *ngIf=\"sectionConfig?.configData?.html\"></dw-html-view>",
                styles: [""]
            }]
    }], function () { return []; }, { sectionConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerSectionWrapperComponent, [{
        type: Component,
        args: [{
                selector: 'dw-page-designer-section-wrapper',
                template: "\r\n<div class=\"pd-section\" [ngClass]=\"{ 'pd-section-selected': sectionSelected || showAllBorders }\" cdkDrag [cdkDragData]=\"sectionConfig\" (cdkDragMoved)=\"dragMoved($event)\"\r\n    (cdkDragReleased)=\"dragReleased($event)\" cdkDragPreviewClass2=\"hide-preview\" [cdkDragDisabled]=\"preventMove\" (click)=\"selectSection($event)\">\r\n\r\n    <div *cdkDragPlaceholder class=\"pd-drop-section\">\r\n        Drop Section Here\r\n    </div>\r\n\r\n    <div class=\"pd-tool-item-placeholder2\" cdkDragPreview [hidden]=\"true\">\r\n        <i class=\"pd-tool-item-icon\" [ngClass]=\"sectionDef.configData.toolbarIconCss\"></i>\r\n        <div class=\"pd-tool-item-text\">\r\n            {{sectionDef.configData.toolbarDisplay}}\r\n        </div>\r\n    </div>\r\n    \r\n    <div class=\"pd-section-header\" [ngClass]=\"{ 'pd-section-header-selected': sectionSelected || showAllBorders }\">\r\n        <div class=\"pull-left pd-section-header-title\" cdkDragHandle>\r\n            <i class=\"fa fa-grip-vertical pd-section-icon\" [hidden]=\"preventMove\" *ngIf=\"false\"></i>\r\n            <i class=\"pd-section-icon\" [ngClass]=\"sectionDef.configData.toolbarIconCss\"></i>\r\n            {{sectionConfig.sectionName}} ({{sectionDef.configData.toolbarDisplay}})\r\n        </div>\r\n        <div class=\"pull-right\">\r\n            <i class=\"fa fa-cog pd-section-icon\" title=\"Configure Section\" (click)=\"configurationSection()\" [hidden]=\"!sectionDef?.configComponent\"></i>\r\n            <i class=\"fa fa-trash pd-section-icon\" (click)=\"onRemoveSection(sectionConfig)\" tile=\"Remove Section\" [hidden]=\"preventRemove\"></i>\r\n        </div>\r\n    </div>\r\n    <div class=\"pd-section-inner\" cdkDragHandle>\r\n        <dw-dynamic-loader *ngIf=\"sectionDef?.component\" [component]=\"sectionDef?.component\"\r\n            (configure)=\"configureCustomConfig($event)\"></dw-dynamic-loader>\r\n    </div>\r\n</div>\r\n\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwPageDesignerStateService }, { type: DwPageDesignerDragDropService }]; }, { removeSection: [{
            type: Output
        }], preventRemove: [{
            type: Input
        }], preventMove: [{
            type: Input
        }], sectionConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerToolbarComponent, [{
        type: Component,
        args: [{
                selector: 'dw-page-designer-toolbar',
                template: "\r\n<div cdkDropList id='toolbar' [cdkDropListData]=\"pageDesignerConfig.sectionDefs\"\r\n    cdkDropListSortingDisabled [cdkDropListEnterPredicate]=\"noReturnPredicate\"\r\n    [cdkDropListConnectedTo]=\"dwDragDropService.dropLists\">\r\n    <!-- [cdkDropListConnectedTo]=\"toolbarIds\">-->\r\n\r\n    <div class=\"row\">\r\n        <div class=\"pd-tool-item\" cdkDrag *ngFor=\"let sectionDef of pageDesignerConfig.sectionDefs\"\r\n            [cdkDragData]=\"sectionDef\" (cdkDragMoved)=\"dragMoved($event)\"\r\n            (cdkDragReleased)=\"dragReleased($event)\">\r\n            <div class=\"pd-drop-section\" *cdkDragPlaceholder>\r\n                Drop Section Here\r\n            </div>\r\n\r\n            <div class=\"pd-tool-item-placeholder2\" *cdkDragPreview>\r\n                <i class=\"pd-tool-item-icon\" [ngClass]=\"sectionDef.configData.toolbarIconCss\"></i>\r\n                <div class=\"pd-tool-item-text\">\r\n                    {{sectionDef.configData.toolbarDisplay}}\r\n                </div>\r\n                <!-- <div [ngClass]=\"toolBarItem.createSection.className\">\r\n                        {{toolBarItem.display}}\r\n                    </div> -->\r\n            </div>\r\n            <i class=\"pd-tool-item-icon\" [ngClass]=\"sectionDef.configData.toolbarIconCss\"></i>\r\n            <div class=\"pd-tool-item-text\">\r\n                {{sectionDef.configData.toolbarDisplay}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwPageDesignerDragDropService }, { type: DwPageDesignerStateService }]; }, { pageDesignerConfig: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerConfigPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dw-page-designer-config-panel',
                template: "<div>\r\n    <ng-container *ngIf=\"sectionDef?.configComponent\">\r\n        <dw-ui-child-config-host [component]=\"sectionDef?.configComponent\" [(config)]=\"sectionConfig\"\r\n            (configChange)=\"onSectionConfigChange()\" [configContext]=\"configContext\">\r\n        </dw-ui-child-config-host>\r\n    </ng-container>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwPageDesignerStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateDividerSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-template-divider-section',
                template: `
    <hr>
  `
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPageDesignerContainerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-page-designer-container',
                template: "<div [id]=\"parentSectionConfig?.sectionName\" cdkDropList [cdkDropListData]=\"sections\" style2=\"background-color:goldenrod;min-height:400px\"\r\n    style2=\"min-height: 200px; min-width:500px; overflow:hidden\" class=\"pd-container-section\" [ngClass]=\"{ 'pd-container-section-dragging': dwDragDropService.isDragging }\"\r\n    [cdkDropListConnectedTo]=\"dwDragDropService.dropLists\" [cdkDropListEnterPredicate]=\"allowDropPredicate\"\r\n    (cdkDropListDropped)=\"onSectionDrop($event)\">\r\n\r\n    <div style2=\"background-color:aliceblue;\">\r\n        <ng-container *ngFor=\"let childSection of sections\">\r\n            <div>\r\n                <dw-page-designer-section-wrapper [sectionConfig]=\"childSection\" (removeSection)=\"removeSection($event)\">\r\n                </dw-page-designer-section-wrapper>\r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n\r\n    <div class=\"pd-add-section on-hover\" [hidden]=\"dwDragDropService.isDragging\">\r\n        <ng-container *ngIf=\"!sections || sections.length ==0\">\r\n            No sections\r\n        </ng-container>\r\n\r\n        <i class=\"fa fa-plus-circle pd-section-icon on-hover-item\" title=\"Add Section\" (click)=\"addSectionPanel.show($event)\"></i>\r\n    </div>\r\n\r\n    <p-overlayPanel #addSectionPanel [showCloseIcon]=\"true\" (onHide)=\"addSectionPanel.hide()\" [style]=\"{width: '450px'}\"  [dismissable]=\"false\">\r\n        <ng-template pTemplate>\r\n            Designer Toolbar\r\n           <dw-page-designer-toolbar [pageDesignerConfig]=\"pageDesignerConfig\"></dw-page-designer-toolbar>\r\n        </ng-template>\r\n    </p-overlayPanel>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwPageDesignerDragDropService }, { type: DwPageDesignerStateService }]; }, { sections: [{
            type: Input
        }], parentSectionConfig: [{
            type: Input
        }], dropList: [{
            type: ViewChild,
            args: [CdkDropList]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwOrderedListComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ordered-list',
                template: "<div cdkDropList class=\"dw-ordered-list\" (cdkDropListDropped)=\"drop($event)\">\r\n    <div class=\"dw-ordered-box\" *ngFor=\"let item of items, let i = index\" cdkDrag [hidden]=\"useVisibleIndexes && visibleIndexes && !visibleIndexes[i]\">\r\n\r\n        <div class=\"dw-ordered-custom-placeholder\" *cdkDragPlaceholder></div>\r\n        \r\n        <div class=\"drag-handle-column\" cdkDragHandle>\r\n            <i class=\"fa fa-grip-vertical fa-2x\"></i>\r\n        </div>\r\n\r\n        <div class=\"main-column\">\r\n            <ng-container *ngTemplateOutlet=\"listItemTemplate; context : {$implicit: item, index: i}\"></ng-container>\r\n        </div>\r\n\r\n        <div class=\"remove-column\">\r\n            <i class=\"fa fa-times\" (click)=\"removeItem(item)\"></i>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!-- \r\nUse Visible Indexes: {{useVisibleIndexes}}<br>\r\nVisible Index: {{visibleIndexes | json}}<br> -->\r\n<!-- <div *ngFor=\"let item of items, let i = index\">\r\n   {{i}} - {{items[i]?.value?.SectionName}} - Order: {{items[i]?.value?.SectionOrder}}<br>\r\n\r\n   Visible: {{visibleIndexes[i]}}\r\n</div> -->",
                styles: [".dw-ordered-list{background:#fff;border:1px solid #ccc;border-radius:4px;display:block;max-width:100%;min-height:60px;overflow:hidden;width:100%}.dw-ordered-box{align-items:center;background:#fff;border-bottom:1px solid #ccc;box-sizing:border-box;color:rgba(0,0,0,.87);cursor:move;display:flex;flex-direction:row;font-size:14px;justify-content:space-between;padding:5px}.cdk-drag-preview{border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box;z-index:9000!important}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.dw-ordered-box:last-child{border:none}.dw-ordered-custom-placeholder,.dw-ordered-list.cdk-drop-list-dragging .dw-ordered-box:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.dw-ordered-custom-placeholder{background:#ccc;border:3px dotted #999;min-height:60px}.drag-handle-column{float:left;width:20px}.remove-column{cursor:pointer;float:left;font-size:1.3em;height:50px;margin-right:3px;padding-top:10px;text-align:left;vertical-align:middle;width:10px}.main-column{float:left;padding-left:10px;padding-right:10px;width:calc(100% - 35px)}"]
            }]
    }], function () { return []; }, { itemOrderChange: [{
            type: Output
        }], useVisibleIndexes: [{
            type: Input
        }], visibleIndexes: [{
            type: Input
        }], itemRemoved: [{
            type: Output
        }], itemsChange: [{
            type: Output
        }], items: [{
            type: Input
        }], listItemTemplate: [{
            type: ContentChild,
            args: [DwListItemDirective, { static: true, read: TemplateRef }]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSectionConfigPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dw-section-config-panel',
                template: "<ng-container *ngIf=\"showComponent\">\r\n\r\n    <dw-dynamic-loader [component]=\"component\"\r\n    (configure)=\"configureComponent($event)\"></dw-dynamic-loader>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSectionConfigStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataConfigPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dw-data-config-panel',
                template: "<p-tabView>\r\n    <p-tabPanel header=\"Data Setup\">\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Data Source</label>\r\n                <dw-datasource-select  [(ngModel)]=\"preferences.dataSourceName\" (ngModelChange)=\"onChange()\" [itemName]=\"itemName\"></dw-datasource-select>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Context Data</label>\r\n                <dw-context-def-multi-select [(ngModel)]=\"preferences.contextNames\" (ngModelChange)=\"onChange()\" [itemName]=\"itemName\" [requiredContextNames]=\"preferences.requiredContextNames\">\r\n\r\n                </dw-context-def-multi-select>\r\n            </div>\r\n        </div>\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Variables\">\r\n        <dw-data-variable-list-config [(variableConfig)]=\"preferences.variableConfig\" (variableConfigChange)=\"onVariableConfigChange()\" ></dw-data-variable-list-config>\r\n    </p-tabPanel>\r\n</p-tabView>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwSectionConfigStateService }, { type: DwContextService }, { type: DwDataVariableService }, { type: DwUiConfigRegistryService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormeventsConfigPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-formevents-config-panel',
                template: "<p>dw-formevents-config-panel works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityConfigPanelComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-config-panel',
                template: "<p-tabView>\r\n    <p-tabPanel header=\"Access Rules\">\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Can Edit - Use Expression</label>\r\n                <dw-yesno [(ngModel)]=\"preferences.useCanEditExpression\"></dw-yesno>\r\n            </div>\r\n        </div>\r\n        <div dwRow [hidden]=\"preferences.useCanEditExpression\">\r\n            <div dwCol=\"12\">\r\n                <label>Can Edit Rule</label>\r\n                <select [(ngModel)]=\"preferences.canEditRuleKey\" class=\"form-control\" (ngModelChange)=\"onChange()\">\r\n                    <option [ngValue]=\"undefined\" selected>None</option>\r\n                    <option *ngFor=\"let rule of rules\" [ngValue]=\"rule.ruleKey\">\r\n                        {{rule.ruleName}}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow [hidden]=\"!preferences.useCanEditExpression\">\r\n            <div dwCol=\"12\">\r\n                <label>Can Edit Expression</label>\r\n                <dw-expression-picker-control formControlName=\"preferences.useCanEditExpression\"\r\n                    [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Can Add - Use Expression</label>\r\n                <dw-yesno [(ngModel)]=\"preferences.useCanAddExpression\"></dw-yesno>\r\n            </div>\r\n        </div>\r\n        <div dwRow [hidden]=\"preferences.useCanAddExpression\">\r\n            <div dwCol=\"12\">\r\n                <label>Can Add Rule</label>\r\n                <select [(ngModel)]=\"preferences.canAddRuleKey\" class=\"form-control\" (ngModelChange)=\"onChange()\">\r\n                    <option [ngValue]=\"undefined\" selected>None</option>\r\n                    <option *ngFor=\"let rule of rules\" [ngValue]=\"rule.ruleKey\">\r\n                        {{rule.ruleName}}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow [hidden]=\"!preferences.useCanAddExpression\">\r\n            <div dwCol=\"12\">\r\n                <label>Can Add Expression</label>\r\n                <dw-expression-picker-control formControlName=\"preferences.canAddExpression\"\r\n                    [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Can View - Use Expression</label>\r\n                <dw-yesno [(ngModel)]=\"preferences.useCanViewExpression\"></dw-yesno>\r\n            </div>\r\n        </div>\r\n        <div dwRow [hidden]=\"preferences.useCanViewExpression\">\r\n            <div dwCol=\"12\">\r\n                <label>Can View Rule</label>\r\n                <select [(ngModel)]=\"preferences.canViewRuleKey\" class=\"form-control\" (ngModelChange)=\"onChange()\">\r\n                    <option [ngValue]=\"undefined\" selected>None</option>\r\n                    <option *ngFor=\"let rule of rules\" [ngValue]=\"rule.ruleKey\">\r\n                        {{rule.ruleName}}\r\n                    </option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n        <div dwRow [hidden]=\"!preferences.useCanViewExpression\">\r\n            <div dwCol=\"12\">\r\n                <label>Can View Expression</label>\r\n                <dw-expression-picker-control formControlName=\"preferences.canViewExpression\"\r\n                    [contextNames]=\"contextNames\" [item]=\"itemName\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n\r\n    </p-tabPanel>\r\n</p-tabView>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSectionConfigStateService }, { type: DwRuleService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwConfigPanelHostComponent, [{
        type: Component,
        args: [{
                selector: 'dw-config-panel-host',
                template: "<dw-section-config-panel *ngIf=\"currentNodeType == 'section'\"></dw-section-config-panel>\r\n\r\n\r\n<dw-dynamic-loader *ngIf=\"currentNodeType != 'section'\" [component]=\"otherConfigComponent\"></dw-dynamic-loader>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwSectionConfigStateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataConfigStateService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-data-config',
                template: "<div>\r\n    <div class=\"dw-panel\" >\r\n        <div class=\"dw-panel-left\">\r\n            <p-tree [value]=\"tree\" selectionMode=\"single\" [selection]=\"currentNode\" (selectionChange)=\"setCurrentNode($event)\" [style]=\"{'height':'600px', 'max-height':'600px','overflow':'auto'}\"> \r\n                <ng-template let-node pTemplate=\"default\">\r\n                    <span (contextmenu)=\"nodeMenu($event, node)\">\r\n                        {{node.label}}\r\n                    </span>\r\n                </ng-template>\r\n            </p-tree>  \r\n        </div>\r\n        <div class=\"dw-panel-right\">\r\n\r\n \r\n        </div>\r\n        \r\n        <p-contextMenu #contextMenu [model]=\"cmMenuItems\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-contextMenu>\r\n    </div>\r\n</div>\r\n",
                providers: [DwDataConfigStateService],
                styles: [""]
            }]
    }], function () { return [{ type: DwDataConfigStateService }]; }, { dataConfigChange: [{
            type: Output
        }], dataConfig: [{
            type: Input
        }], contextMenu: [{
            type: ViewChild,
            args: ['contextMenu']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateTimeContextService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridSetValuesActionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-set-values-action-config',
                template: `

  <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
    <div dwRow>
      <div dwCol="12">
          <label class="label">Attributes To Update</label>

          <p-multiSelect [options]="allAttributes" formControlName="attrNames" optionLabel="AttributeDisplay" display="chip" optionValue="AttributeName" display="chip" [filter]="true" appendTo="body" baseZIndex="2000" autoZIndex="false"></p-multiSelect>
      </div>
    </div>
    <div dwRow *ngFor="let attrUpdate of attrUpdates; let i = index">
      <div dwCol="12">
          <label class="label"> {{ attrUpdatesAttrs[i]?.AttributeDisplay }} </label>

          <dw-default-value [(defaultValue)]="attrUpdate.value" (defaultValueChange)="onAttrUpdateChange(attrUpdate)" [contextNames]="configContext.contextNames" [queryAttribute]="attrUpdatesAttrs[i]"></dw-default-value>
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
        <label>Refresh Full Grid</label>
      </div>
      <div dwCol="3">
        <p-inputSwitch formControlName="refreshFullGrid"></p-inputSwitch>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridSetValuesActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwContextService }, { type: DwExpressionService }, { type: DwLoggingService }]; }, null); })();
const ɵDwMetaDataGridContextService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMetaDataGridContextService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridContextService, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExportConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-export-config',
                template: "\r\n<dw-ui-config-list *ngIf=\"exportConfig\" [items]=\"exportConfig.exportColumns\" [config]=\"listConfig\" [selectedItem]=\"selectedItem\" size=\"large\"\r\n    (selectedItemChange)=\"setSelectedItem($event)\" (removeItem)=\"removeItem($event)\" (reorder)=\"reorderList()\">\r\n    <div addItemsTab>\r\n        <dw-field-selection [attributes]=\"availableAttributes\" (attributeClick)=\"addItem($event)\"\r\n            addTooltip=\"Add Column\"></dw-field-selection>\r\n    </div>\r\n    <div actionBar>\r\n        <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n\r\n        <button class=\"btn btn-warning button-spacing\" (click)=\"copyGridColumns()\" *ngIf=\"gridColumnPreferences\" title=\"Replaces all export columns with the grid columns\">Copy Grid Columns</button>\r\n    </div>\r\n    <div configureItemTab>\r\n        <p-accordion *ngIf=\"selectedItem\">\r\n            <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Attribute Name</label>\r\n                        <div class=\"form-control\">{{selectedItem.attr}}</div>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Caption Override</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.captionOverride\" (ngModelChange)=\"onExportChanged()\" [placeholder]=\"selectedAttr?.AttributeDisplay\" class=\"form-control\">\r\n                    </div>\r\n                </div> \r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Column Security\">\r\n                <dw-security-check-config [(config)]=\"selectedItem.securityConfig\" (configChange)=\"onExportChanged()\" hideSecurityDefault=\"true\"\r\n                    [configContext]=\"configContext\"></dw-security-check-config>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </div>\r\n    <div additionalTab>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Export File Name <i class=\"fa fa-info-circle\" title=\"Any extension will be replaced\"></i></label>\r\n                <input type=\"text\" [(ngModel)]=\"exportConfig.exportFileName\" (ngModelChange)=\"onExportChanged()\" class=\"form-control\">\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Export Sortable Dates <i class=\"fa fa-info-circle\" title=\"When set to false, dates will be displayed as string with timezone info, but can't be sorted in Excel\"></i></label>\r\n                <dw-yesno type=\"text\" [(ngModel)]=\"exportConfig.exportSortableDates\" (ngModelChange)=\"onExportChanged()\" class=\"form-control\"></dw-yesno>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</dw-ui-config-list>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { exportConfigChange: [{
            type: Output
        }], exportConfig: [{
            type: Input
        }], configContext: [{
            type: Input
        }], gridColumnPreferences: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMenuExpressionProcessorService, [{
        type: Injectable
    }], function () { return [{ type: DwExpressionService }, { type: DwEventService }, { type: DwContextService }, { type: DwSecurityUserService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCopyModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-copy-modal',
                template: "<div [formGroup]=\"formGroup\">\r\n    <!-- <div dwRow>\r\n      <div dwCol=\"12\">\r\n        <label class=\"label\">\r\n          Select Attributes\r\n        </label>\r\n        <p-multiSelect [options]=\"availableAttributes\" optionLabel=\"Display\" [ngModel]=\"selectedAttributes\" display=\"chip\"\r\n          (ngModelChange)=\"setSelectedAttributes($event)\" [ngModelOptions]=\"{ standalone: true}\" [filter]=\"true\"\r\n          appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\">\r\n        </p-multiSelect>\r\n      </div>\r\n    </div>\r\n    <hr> -->\r\n  \r\n    <dw-message [(message)]=\"message\" *ngIf=\"message\"></dw-message>\r\n  \r\n    <div  class=\"container-style\">\r\n      <div>\r\n        <div dwRow *ngFor=\"let attrToUpdate of attributesToUpdate\">\r\n          <div dwCol=\"12\">\r\n            <div dwDynamicField [fieldDef]=\"attrToUpdate.fieldConfig\" [formGroup]=\"formGroup\" [submitted]=\"submitted\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"attributesToUpdate.length > 0\">\r\n      <div dwCol=\"12\">\r\n        Copy action is not configured correctly and requires at least one attribute to update\r\n      </div>\r\n    </div>\r\n  </div>",
                styles: [".container-style{max-height:500px;min-width:500px;overflow-x:hidden;overflow-y:auto;padding:3px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwValidationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCopyConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-copy-config',
                template: "<div [formGroup]=\"actionConfigFG\">\r\n   \r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Attributes to Display <i class=\"fa fa-info-circle\"\r\n                    title=\"Select all attributes that should be updated\"></i></label>\r\n            <p-multiSelect [options]=\"primeAttributes\" formControlName=\"includeAttributes\" display=\"chip\"\r\n                [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n\r\n            <span *ngIf=\"actionConfigFG?.value?.includeAttributes?.length == 0\" class=\"dw-red\">\r\n                Please select at least one attribute to replace for a copy\r\n            </span>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Clear Attributes <i class=\"fa fa-info-circle\"\r\n                title=\"Identify any additional attributs that should be cleared\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"showClearAttributes\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow  [hidden]=\"!actionConfigFG.value?.showClearAttributes\">\r\n        <div dwCol=\"12\">\r\n            <label>Attributes to Clear</label>\r\n            <p-multiSelect [options]=\"primeAttributes\" formControlName=\"clearAttributes\" display=\"chip\"\r\n                [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Include Relationships</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"showRelationships\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow [hidden]=\"!actionConfigFG.value?.showRelationships\">\r\n        <div dwCol=\"12\">\r\n            <label>Relationship to Copy<i class=\"fa fa-info-circle\"\r\n                    title=\"Select all attributes that should be modified\"></i></label>\r\n            <p-multiSelect [options]=\"relationships\" formControlName=\"includeRelationships\" display=\"chip\"\r\n                [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div> \r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Navigate To Edit After</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"navigateToEditAfter\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Refresh Full Grid</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"refreshFullGrid\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCopyActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataGridNavigationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailTemplateComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-template',
                template: `
    <label class="label">Body Template</label>
    <div [formGroup]="formGroup">
      <dw-html-edit formControlName="BodyTemplate" [fieldSources]="htmlEditFieldSources"></dw-html-edit>
    </div>
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataRoutingService }]; }, null); })();
const ɵDwGridCountValidationRule_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwGridCountValidationRule);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCountValidationRule, [{
        type: Injectable
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataGridDependencyService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwExpressionService }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDependencyViewComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dependency-view',
                template: "\r\n\r\n\r\n<b>Dependencies</b>\r\n\r\n{{ dependencies | json }}",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataGridDependencyService }]; }, { configPreferenecs: [{
            type: Input
        }], itemName: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataVariableListConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-data-variable-list-config',
                template: "<dw-ui-config-list [items]=\"variableConfig.variables\" [config]=\"listConfig\" [selectedItem]=\"selectedItem\" size=\"large\"\r\n    (selectedItemChange)=\"setSelectedItem($event)\" (removeItem)=\"removeItem($event)\" (reorder)=\"reorderList()\">\r\n    <div addItemsTab>\r\n        <button class=\"btn btn-sm btn-success\" (click)=\"addItem()\">\r\n            <i class=\"fa fa-plus-circle hand\" title=\"Create a new variable\"></i>\r\n            Create Variable\r\n        </button>\r\n    </div>\r\n    <div actionBar>\r\n        <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n    </div>\r\n    <div configureItemTab>\r\n        <p-accordion *ngIf=\"selectedItem\">\r\n            <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Caption</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.display\" (ngModelChange)=\"onCaptionChange($event)\"\r\n                            [placeholder]=\"selectedAttr?.AttributeDisplay\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Variable Name <i class=\"fa fa-info-circle\" title=\"Unique name for the variable that can only be set when creating a variable\"></i></label>\r\n                        <a (click)=\"overrideEdit=true\" [hidden]=\"overrideEdit\" class=\"dw-blue pull-right\" title=\"You will need to manually fix any variable references\">Override</a>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.name\" (ngModelChange)=\"onChanged()\" [disabled]=\"!isNewVariable && !overrideEdit\"\r\n                            [placeholder]=\"selectedAttr?.AttributeDisplay\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Attribute Type</label>\r\n                        <dw-search-select-lookup [(ngModel)]=\"selectedItem.attributeType\"\r\n                            [lookupId]=\"attributeTypeLookupId\" (ngModelChange)=\"onChanged()\">\r\n                        </dw-search-select-lookup>\r\n                    </div>\r\n                </div>\r\n            \r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Control Type</label>\r\n                        <dw-search-select-lookup [(ngModel)]=\"selectedItem.controlType\" [lookupId]=\"controlTypeLookupId\"\r\n                            (ngModelChange)=\"onChanged()\">\r\n                        </dw-search-select-lookup>\r\n                    </div>\r\n                </div>    \r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <div dwCol=\"9\">\r\n                            <label>Is Lookup</label>\r\n                        </div>\r\n                        <div dwCol=\"3\">\r\n                            <p-inputSwitch [(ngModel)]=\"selectedItem.isLookup\" (ngModelChange)=\"onChanged()\">\r\n                            </p-inputSwitch>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div dwRow *ngIf=\"selectedItem.isLookup\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Lookup</label>\r\n                        <dw-search-select-lookup [(ngModel)]=\"selectedItem.metaDataLookupId\" [lookupId]=\"lookupLookupId\"\r\n                            (ngModelChange)=\"onChanged()\">\r\n                        </dw-search-select-lookup>\r\n                    </div>\r\n                </div>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </div>\r\n    <div additionalTab>\r\n    </div>\r\n</dw-ui-config-list>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwUiConfigRegistryService }, { type: DwDataVariableService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { variableConfigChange: [{
            type: Output
        }], variableConfig: [{
            type: Input
        }], configContext: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataVariableEditConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-data-variable-edit-config',
                template: "<p>dw-data-variable-edit-config works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwContextDefMultiSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-context-def-multi-select',
                template: "<p-multiSelect [options]=\"contextDefinitions\" [(ngModel)]=\"selectedContextDefinitions\"\r\n    (ngModelChange)=\"onSelectedContextChanges()\" optionLabel=\"contextDisplay\" optionDisabled=\"required\" display=\"chip\"\r\n    [style]=\"{'width':'100%'}\" appendTo=\"body\" baseZIndex=\"2000\">\r\n    <ng-template let-value pTemplate=\"selectedItems\">\r\n        <div class=\"dw-chip-container\">\r\n            <div class=\"dw-chip\" *ngFor=\"let contextDef of selectedContextDefinitions\">\r\n                <div>{{ contextDef.contextDisplay }}</div>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n</p-multiSelect>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwContextDefMultiSelectComponent),
                        multi: true
                    }],
                styles: [""]
            }]
    }], function () { return [{ type: DwContextService }]; }, { includeCustomContexts: [{
            type: Input
        }], itemName: [{
            type: Input
        }], requiredContextNames: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDatasourceSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-datasource-select',
                template: `
    <p-dropdown [options]="dataSources" [ngModel]="translatedValue" (ngModelChange)="setTranslatedValue($event)" optionLabel="display" optionValue="keyName" display="chip">
    </p-dropdown>
  `,
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwDatasourceSelectComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, { itemName: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwOpenModalActionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-open-modal-action-config',
                template: "<div *ngIf=\"actionConfigFG && items\" [formGroup]=\"actionConfigFG\">\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Item</label>\r\n            <dw-search-select-lookup formControlName=\"item\" [lookupId]=\"lookupId\" [overrideValues]=\"items\">\r\n            </dw-search-select-lookup>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>View Type 2</label>\r\n\r\n            <select formControlName=\"actionType\" class=\"form-control\">\r\n                <option *ngFor=\"let item of actionTypes\" [ngValue]=\"item.value\">\r\n                    {{item.display}}\r\n                </option>\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"showKeyValue\" >\r\n        <div dwRow *ngIf=\"contextList?.length>0\"> \r\n            <div dwCol=\"9\">\r\n                <label>Use Context</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"useContext\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <ng-container *ngIf=\"actionConfigFG?.value?.useContext && contextList?.length>0\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Context</label>\r\n                    <select formControlName=\"contextName\" class=\"form-control\">\r\n                        <option *ngFor=\"let contextDef of contextList\" [ngValue]=\"contextDef.contextName\">\r\n                            {{ contextDef.contextDisplay }}\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\" *ngIf=\"currentContextMd?.attributes?.length>0\">\r\n                    <label >Key Value Attribute</label>\r\n                    <select formControlName=\"keyValueAttrName\" class=\"form-control\">\r\n                        <option *ngFor=\"let attr of currentContextMd?.attributes || []\" [ngValue]=\"attr.AttributeName\">\r\n                            {{ attr.AttributeDisplay }}\r\n                    </select>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n        <div dwRow *ngIf=\"!actionConfigFG?.value?.useContext || contextList?.length == 0\">\r\n            <div dwCol=\"12\">\r\n                <label>Key Value Attribute</label>\r\n                <select formControlName=\"keyValueAttrName\" class=\"form-control\">\r\n                    <option *ngFor=\"let attr of attributes\" [ngValue]=\"attr.AttributeName\">\r\n                        {{ attr.AttributeDisplay }}\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Modal Title Override <i class=\"fa fa-info-circle\"\r\n                    title=\"Replaces the default title for the modal\"></i></label>\r\n            <input type=\"text\" formControlName=\"modalTitleOverride\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Config Key Part <i class=\"fa fa-info-circle\"\r\n                    title=\"Used to determine which config should be used\"></i></label>\r\n            <input type=\"text\" formControlName=\"configKeyPart\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwOpenItemModalActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataRoutingService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEnvironmentContextService, [{
        type: Injectable
    }], function () { return [{ type: DwAppInitService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
const ɵDwFormControlMultiSelectDateComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFormControlMultiSelectDateComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormControlMultiSelectDateComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-fc-multi-select-date',
                template: `
    <div [formGroup]="formGroup">
        <dw-date-multi-select [formControlName]="fieldDef?.attrName"></dw-date-multi-select>
    </div>
  `
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdTemplateService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwTemplateUtilService }, { type: DwContextService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTemplateViewControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-template-view-control',
                template: `
    <span *ngIf="!isHtml">
      {{templateResult}}
    </span>

    <dw-html-view *ngIf="isHtml" [(ngModel)]="templateResult">
    </dw-html-view>
  
  `
            }]
    }], function () { return [{ type: DwMdTemplateService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { blankReplacementValue: [{
            type: Input
        }], blankPlaceholder: [{
            type: Input
        }], showLookupDisplays: [{
            type: Input
        }], isHtml: [{
            type: Input
        }], queryMetaData: [{
            type: Input
        }], templateText: [{
            type: Input
        }], dataSubject: [{
            type: Input
        }], context: [{
            type: Input
        }], item: [{
            type: Input
        }] }); })();
const ɵDwTemplateConfigControlComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwTemplateConfigControlComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTemplateConfigControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-template-config-control',
                template: "<textarea type=\"text\" [(ngModel)]=\"value\" (ngModelChange)=\"onChange()\" class=\"form-control\"></textarea>\r\n\r\n<div>\r\n    <div class=\"pull-left\">\r\n        <dw-expression-reference-control [(ngModel)]=\"fieldReference\" (ngModelChange)=\"onChange()\" [item]=\"item\" [queryMeaning]=\"queryMeaning\" [contextNames]=\"contextNames\" [showDisplayAttributes]=\"showDisplayAttributes\">\r\n        </dw-expression-reference-control>        \r\n    </div>\r\n    <div class=\"pull-left\">\r\n        <button class=\"btn-sn btn-success ml-2\" (click)=\"addField()\"><i class=\"fa fa-plus-circle\"></i> Add Field</button>\r\n    </div>\r\n</div>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwTemplateConfigControlComponent),
                        multi: true
                    }]
            }]
    }], null, { dataPrefix: [{
            type: Input
        }], excludeDataPrefix: [{
            type: Input
        }], item: [{
            type: Input
        }], contextNames: [{
            type: Input
        }], queryMeaning: [{
            type: Input
        }], showDisplayAttributes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTitleTemplatesConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-title-templates-config',
                template: "<div dwRow>\r\n    <div dwCol=\"2\">\r\n        <button class=\"btn-sm btn-success\" (click)=\"addTemplate()\">Add Template</button>\r\n    </div>\r\n\r\n    <div dwCol=\"4\">\r\n        <label>Load Lookup Displays <i class=\"fa fa-info-circle\"\r\n                title=\"Allows shows the display values for lookups and will load automatically\"></i></label>\r\n        <dw-yesno [(ngModel)]=\"value.loadLookupDisplays\"></dw-yesno>\r\n    </div>\r\n    <div dwCol=\"4\" *ngIf=\"parentUseContainerStyling\">\r\n        <label>Customize Styles <i class=\"fa fa-info-circle\"\r\n                title=\"Allows customizing the container style and icon\"></i></label>\r\n        <dw-yesno [(ngModel)]=\"value.showContainerOptions\"></dw-yesno>\r\n    </div>\r\n</div>\r\n\r\n\r\n<dw-ordered-list [(items)]=\"value.titleTemplates\" (itemsChange)=\"onChange()\" *ngIf=\"value.titleTemplates?.length>0\">\r\n    <ng-container *dwListItem=\"let templateConfig\">\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Template <i class=\"fa fa-info-circle\" title=\"\"></i></label>\r\n                <dw-template-config-control [(ngModel)]=\"templateConfig.template\" (ngModelChange)=\"onChange()\"\r\n                    [contextNames]=\"contextNames\" [item]=\"item\"\r\n                    [showDisplayAttributes]=\"value.loadLookupDisplays\"></dw-template-config-control>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Expression <i class=\"fa fa-info-circle\"\r\n                        title=\"Uses the first expression which evaluates to true\"></i></label>\r\n                <dw-expression-picker-control [(ngModel)]=\"templateConfig.expression\" (ngModelChange)=\"onChange()\"\r\n                    [contextNames]=\"contextNames\" [item]=\"item\">\r\n                </dw-expression-picker-control>\r\n            </div>\r\n        </div>\r\n        <ng-container *ngIf=\"parentUseContainerStyling && value.showContainerOptions\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Container Style</label>\r\n                    <select [(ngModel)]=\"templateConfig.containerStyleName\" class=\"form-control\">\r\n                        <option *ngFor=\"let item of containerStyles\" [ngValue]=\"item.keyName\">\r\n                            {{item.display}}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Container Icon</label>\r\n                    <input type=\"text\" [(ngModel)]=\"templateConfig.containerHeaderIcon\" class=\"form-control\">\r\n\r\n                    <i class=\"{{templateConfig.containerHeaderIcon}}\"\r\n                        [hidden]=\"!templateConfig.containerHeaderIcon\"></i>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"4\">\r\n                    <label>Header Background Color</label>\r\n                    <dw-color-select [(ngModel)]=\"templateConfig.containerHeaderBackgroundColor\"></dw-color-select>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Header Text Color</label>\r\n                    <dw-color-select [(ngModel)]=\"templateConfig.containerHeaderForegroundColor\"></dw-color-select>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Icon Color</label>\r\n                    <dw-color-select [(ngModel)]=\"templateConfig.containerHeaderIconColor\"></dw-color-select>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n    </ng-container>\r\n</dw-ordered-list>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwTitleTemplatesConfigComponent),
                        multi: true
                    }]
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, { item: [{
            type: Input
        }], contextNames: [{
            type: Input
        }], parentUseContainerStyling: [{
            type: Input
        }] }); })();


class DwFormMultiCreateConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
        this.attributes = [];
        this.attributeConfigs = [];
        this.selectedAttributes = [];
    }
    addControls() {
        this.addControl('attributeName');
        this.addControl('attributeValueReference', null, { referenceType: DwExpressionReferenceType.item });
        this.attributeConfigsFc = this.addControl('attributeConfigs');
        this.addControl('showClearAttributes');
        this.addControl('clearAttributes');
        this.addControl('afterCreateMessage');
        this.addControl('actionMessage');
        this.addControl('requireValidation');
        this.addControl('redirectAfter');
        this.addControl('customizeRedirect');
        this.addControl('redirectMenuKey');
        this.setupMetaData();
    }
    setupComplete() {
        var _a;
        this.attributeConfigs = ((_a = this.actionConfigFG.value) === null || _a === void 0 ? void 0 : _a.attributeConfigs) || [];
        this.selectedAttributes = this.attributeConfigs.map(ac => ac.attrName);
        this.validateAttributeConfigs();
    }
    onSelectAttributeChange() {
        const attributeConfigs = [];
        for (let attrName of this.selectedAttributes) {
            let config = this.attributeConfigs.find(ac => ac.attrName == attrName);
            if (!config) {
                config = {
                    attrName: attrName,
                    attrDisplay: attrName,
                    valueReference: { referenceType: DwExpressionReferenceType.value },
                    relatedReference: { referenceType: DwExpressionReferenceType.item, attrName: attrName },
                    attributeMissing: true,
                };
                const attr = this.attributes.find(a => a.AttributeName == attrName);
                if (attr) {
                    config.attrDisplay = attr.Display;
                    config.attributeMissing = false;
                }
            }
            attributeConfigs.push(config);
        }
        this.attributeConfigs = attributeConfigs;
        this.updateAttributeConfigs();
    }
    removeAttributeConfig(attributeConfig) {
        const index = this.attributeConfigs.indexOf(attributeConfig);
        if (index >= 0) {
            this.attributeConfigs.splice(index, 1);
        }
        this.selectedAttributes = this.attributeConfigs.map(ac => ac.attrName);
    }
    updateAttributeConfigs() {
        this.attributeConfigsFc.setValue(this.attributeConfigs);
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes;
            this.primeAttributes = itemMd.Attributes.filter(a => !a.IsKey).map(a => { return { label: a.Display, value: a.AttributeName }; });
            this.relationships = itemMd.Relations.map(r => { return { label: r.NamingInfo.RelationshipDisplayName, value: r.RelationshipName }; });
            this.validateAttributeConfigs();
        });
    }
    validateAttributeConfigs() {
        if (!this.attributes || !this.attributeConfigs) {
            return;
        }
        // Validate existing Attribute Configs
        for (let attrConfig of this.attributeConfigs) {
            if (!this.attributes.find(a => a.AttributeName == attrConfig.attrName)) {
                attrConfig.attributeMissing = true;
            }
            else {
                attrConfig.attributeMissing = false;
            }
        }
    }
}
DwFormMultiCreateConfigComponent.ɵfac = function DwFormMultiCreateConfigComponent_Factory(t) { return new (t || DwFormMultiCreateConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwFormMultiCreateConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormMultiCreateConfigComponent, selectors: [["dw-dw-form-multi-create-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 52, vars: 15, consts: [[3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["title", "Attribute that will be unique for each new record, set for each value in the multiple value source", 1, "fa", "fa-info-circle"], ["formControlName", "attributeName", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter", "ngModelChange"], ["dwCol", "12", 1, "expr-column-full"], ["title", "Should be a multi-select or comma delimited field", 1, "fa", "fa-info-circle"], ["formControlName", "attributeValueReference", 3, "contextNames", "item"], ["title", "Additional attributes to set values on (these override any form values)", 1, "fa", "fa-info-circle"], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "ngModel", "ngModelOptions", "filter", "ngModelChange"], ["dwRow", "", 4, "ngFor", "ngForOf"], ["title", "These attributes are cleared before saving", 1, "fa", "fa-info-circle"], ["formControlName", "clearAttributes", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["type", "text", "formControlName", "afterCreateMessage", 1, "form-control"], ["type", "text", "formControlName", "actionMessage", 1, "form-control"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "requireValidation"], ["formControlName", "redirectAfter"], ["dwRow", "", 4, "ngIf"], ["title", "Remove attribute", 1, "fa", "fa-times", "hand", "pull-right", "mt-2", 3, "click"], [4, "ngIf"], [1, "dw-red"], [3, "ngModel", "ngModelOptions", "contextNames", "item", "relatedExprRef", "ngModelChange"], ["formControlName", "customizeRedirect"], ["formControlName", "redirectMenuKey"]], template: function DwFormMultiCreateConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hr");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵtext(5, "Unique Attribute ");
        ɵngcc0.ɵɵelement(6, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "p-dropdown", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormMultiCreateConfigComponent_Template_p_dropdown_ngModelChange_7_listener() { return ctx.onSelectAttributeChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Multiple Value Source ");
        ɵngcc0.ɵɵelement(12, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(13, "dw-expression-reference-control", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 1);
        ɵngcc0.ɵɵelementStart(15, "div", 2);
        ɵngcc0.ɵɵelementStart(16, "label");
        ɵngcc0.ɵɵtext(17, "Attributes to set ");
        ɵngcc0.ɵɵelement(18, "i", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "p-multiSelect", 9);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormMultiCreateConfigComponent_Template_p_multiSelect_ngModelChange_19_listener($event) { return ctx.selectedAttributes = $event; })("ngModelChange", function DwFormMultiCreateConfigComponent_Template_p_multiSelect_ngModelChange_19_listener() { return ctx.onSelectAttributeChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(20, DwFormMultiCreateConfigComponent_div_20_Template, 7, 3, "div", 10);
        ɵngcc0.ɵɵelementStart(21, "div", 1);
        ɵngcc0.ɵɵelementStart(22, "div", 2);
        ɵngcc0.ɵɵelementStart(23, "label");
        ɵngcc0.ɵɵtext(24, "Attributes to Clear ");
        ɵngcc0.ɵɵelement(25, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(26, "p-multiSelect", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(27, "hr");
        ɵngcc0.ɵɵelementStart(28, "div", 1);
        ɵngcc0.ɵɵelementStart(29, "div", 2);
        ɵngcc0.ɵɵelementStart(30, "label");
        ɵngcc0.ɵɵtext(31, "After Create Message");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(32, "input", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "div", 1);
        ɵngcc0.ɵɵelementStart(34, "div", 2);
        ɵngcc0.ɵɵelementStart(35, "label");
        ɵngcc0.ɵɵtext(36, "Action Message");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(37, "input", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(38, "div", 1);
        ɵngcc0.ɵɵelementStart(39, "div", 15);
        ɵngcc0.ɵɵelementStart(40, "label");
        ɵngcc0.ɵɵtext(41, "Require Validation");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 16);
        ɵngcc0.ɵɵelement(43, "p-inputSwitch", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "div", 1);
        ɵngcc0.ɵɵelementStart(45, "div", 15);
        ɵngcc0.ɵɵelementStart(46, "label");
        ɵngcc0.ɵɵtext(47, "Redirect After");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "div", 16);
        ɵngcc0.ɵɵelement(49, "p-inputSwitch", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(50, DwFormMultiCreateConfigComponent_div_50_Template, 6, 0, "div", 19);
        ɵngcc0.ɵɵtemplate(51, DwFormMultiCreateConfigComponent_div_51_Template, 5, 0, "div", 19);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.actionConfigFG);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("filter", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("contextNames", ctx.configContext.contextNames)("item", ctx.configContext.itemName);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("ngModel", ctx.selectedAttributes)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(14, _c4))("filter", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attributeConfigs);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("filter", true);
        ɵngcc0.ɵɵadvance(24);
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG == null ? null : ctx.actionConfigFG.value == null ? null : ctx.actionConfigFG.value.redirectAfter);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG == null ? null : ctx.actionConfigFG.value == null ? null : ctx.actionConfigFG.value.customizeRedirect);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwExpressionReferenceControlComponent, ɵngcc12.MultiSelect, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, ɵngcc4.NgIf, DwSelectRouteComponent], encapsulation: 2 });
DwFormMultiCreateConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormMultiCreateConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-form-multi-create-config',
                template: "<div [formGroup]=\"actionConfigFG\">\r\n    <hr>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Unique Attribute\r\n                <i class=\"fa fa-info-circle\"\r\n                    title=\"Attribute that will be unique for each new record, set for each value in the multiple value source\"></i></label>\r\n            <p-dropdown [options]=\"primeAttributes\" formControlName=\"attributeName\"\r\n                (ngModelChange)=\"onSelectAttributeChange()\" [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\"\r\n                autoZIndex=\"false\"></p-dropdown>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\" class=\"expr-column-full\">\r\n            <label>Multiple Value Source\r\n                <i class=\"fa fa-info-circle\" title=\"Should be a multi-select or comma delimited field\"></i></label>\r\n            <dw-expression-reference-control formControlName=\"attributeValueReference\"\r\n                [contextNames]=\"configContext.contextNames\" [item]=\"configContext.itemName\">\r\n            </dw-expression-reference-control>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Attributes to set\r\n                <i class=\"fa fa-info-circle\" title=\"Additional attributes to set values on (these override any form values)\"></i></label>\r\n            <p-multiSelect [options]=\"primeAttributes\" [(ngModel)]=\"selectedAttributes\"\r\n                (ngModelChange)=\"onSelectAttributeChange()\" [ngModelOptions]=\"{standalone:true}\" [filter]=\"true\"\r\n                appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngFor=\"let attributeConfig of attributeConfigs\">\r\n        <div dwCol=\"12\" class=\"expr-column-full\">\r\n            <label>{{attributeConfig.attrDisplay}}</label><i class=\"fa fa-times hand pull-right mt-2\" (click)=\"removeAttributeConfig(attributeConfig)\" title=\"Remove attribute\"></i>\r\n\r\n            <ng-container *ngIf=\"attributeConfig.attributeMissing\">\r\n                <label class=\"dw-red\">{{attributeConfig.attrName}} is not found</label>\r\n                <hr>\r\n            </ng-container>\r\n\r\n            <ng-container *ngIf=\"!attributeConfig.attributeMissing\">\r\n                <dw-expression-reference-control [(ngModel)]=\"attributeConfig.valueReference\" (ngModelChange)=\"updateAttributeConfigs()\"\r\n                    [ngModelOptions]=\"{standalone:true}\" [contextNames]=\"configContext.contextNames\"\r\n                    [item]=\"configContext.itemName\" [relatedExprRef]=\"attributeConfig.relatedReference\">\r\n                </dw-expression-reference-control>\r\n            </ng-container>\r\n\r\n       \r\n        </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Attributes to Clear\r\n                <i class=\"fa fa-info-circle\" title=\"These attributes are cleared before saving\"></i>\r\n            </label>\r\n            <p-multiSelect [options]=\"primeAttributes\" formControlName=\"clearAttributes\" display=\"chip\" [filter]=\"true\"\r\n                appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n    <hr>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>After Create Message</label>\r\n            <input type=\"text\" formControlName=\"afterCreateMessage\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Action Message</label>\r\n            <input type=\"text\" formControlName=\"actionMessage\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Require Validation</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"requireValidation\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Redirect After</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"redirectAfter\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG?.value?.redirectAfter\">\r\n        <div dwCol=\"9\">\r\n            <label>Customize Redirect</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"customizeRedirect\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"actionConfigFG?.value?.customizeRedirect\">\r\n        <div dwCol=\"12\">\r\n            <label>Redirect Menu</label>\r\n            <dw-select-route formControlName=\"redirectMenuKey\"></dw-select-route>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();

DwActionFunc({
    keyName: DwFormActionKeys.formMultiCreate,
    display: 'Multi Create',
    actionType: DwActionType.formAction,
    configComponent: DwFormMultiCreateConfigComponent,
    isGlobal: true,
    allowOnce: false,
    order: 1,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-success',
        iconClass: 'fa fa-save',
    },
    defaultSecurityConfig: {
        useSecurityDefaults: true,
        requireCanCreate: true,
    },
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: true,
        redirectAfter: true,
        actionMessage: 'Creating...',
    }
}, null, () => DwFormMultiCreateActionService);
class DwFormMultiCreateActionService {
    constructor(dwExpressionService, dwContextService, dwOrmDataService, dwMetaDataService) {
        this.dwExpressionService = dwExpressionService;
        this.dwContextService = dwContextService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
    }
    handleAction(actionState) {
        const entityData = actionState.formApi.getFormData();
        const resolvedContext = actionState.context; // context is already resolved
        const multipleAttributeValues = convertToArray(this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(actionState.actionConfig.attributeValueReference, entityData, resolvedContext));
        if (!actionState.actionConfig.attributeName) {
            return of({
                success: false,
                message: 'Multi-Create is not configured correctly, a unique attribute must be selected'
            });
        }
        // if no values, then we do nothing
        if (multipleAttributeValues.length == 0) {
            return of({
                success: false,
            });
        }
        const entityCol = [];
        for (let uniqueValue of multipleAttributeValues) {
            const item = this.mapNewItem(entityData, resolvedContext, actionState.actionConfig, uniqueValue);
            entityCol.push(item);
        }
        return this.dwOrmDataService.saveEntityCollection(entityCol, true, false)
            .pipe(map(results => {
            return {
                success: true,
                message: actionState.actionConfig.afterCreateMessage
            };
        }));
    }
    mapNewItem(entityData, resolvedContext, formMultiCreateConfig, uniqueValue) {
        // Make a copy of the original data
        const newEntity = deepCopy(entityData);
        // Clear any keys for the parent or related children
        this.dwOrmDataService.clearEntityKeys(newEntity);
        // Set the unique value for the entity
        newEntity[formMultiCreateConfig.attributeName] = uniqueValue;
        // Clear values (this happens first so it doesn't clear set values)
        for (let attrName of formMultiCreateConfig.clearAttributes || []) {
            newEntity[attrName] = null;
        }
        // Set any additional values
        for (let attrToSet of formMultiCreateConfig.attributeConfigs || []) {
            const attrValue = this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(attrToSet.valueReference, entityData, resolvedContext);
            newEntity[attrToSet.attrName] = attrValue;
        }
        return newEntity;
    }
}
DwFormMultiCreateActionService.ɵfac = function DwFormMultiCreateActionService_Factory(t) { return new (t || DwFormMultiCreateActionService)(ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken)); };
DwFormMultiCreateActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFormMultiCreateActionService, factory: DwFormMultiCreateActionService.ɵfac });
DwFormMultiCreateActionService.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwContextService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormMultiCreateActionService, [{
        type: Injectable
    }], function () { return [{ type: DwExpressionService }, { type: DwContextService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();

class DwFormSetValuesConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService, dwContextService) {
        super();
        this.metaDataService = metaDataService;
        this.dwContextService = dwContextService;
        this.attributes = [];
        this.attributeConfigs = [];
        this.selectedAttributes = [];
        this.selectedContextAttributes = [];
    }
    addControls() {
        this.attributeConfigsFc = this.addControl('attributeConfigs');
        this.contextConfigsFc = this.addControl('contextConfigs');
        this.addControl('showClearAttributes');
        this.addControl('clearAttributes');
        this.addControl('actionMessage');
        this.addControl('requireValidation');
        this.addControl('redirectAfter');
        this.addControl('customizeRedirect');
        this.addControl('redirectMenuKey');
        this.addControl('saveAfter');
        this.setupMetaData();
        this.setupContextDefs();
    }
    setupComplete() {
        const existingConfig = this.actionConfigFG.value;
        this.attributeConfigs = existingConfig.attributeConfigs || [];
        this.selectedAttributes = this.attributeConfigs.map(ac => ac.attrName);
        this.contextConfigs = existingConfig.contextConfigs || [];
        if (this.contextConfigs.length > 0 && this.contextAttributes) {
            this.selectedContextAttributes = this.contextAttributes.filter(ca => this.contextConfigs.find(cc => cc.contextName == ca.contextName && cc.attrName == ca.attrName));
        }
    }
    onSelectAttributeChange() {
        const attributeConfigs = [];
        for (let attrName of this.selectedAttributes) {
            let config = this.attributeConfigs.find(ac => ac.attrName == attrName);
            if (!config) {
                config = {
                    attrName: attrName,
                    attrDisplay: attrName,
                    valueReference: { referenceType: DwExpressionReferenceType.item },
                    relatedReference: { referenceType: DwExpressionReferenceType.item, attrName: attrName }
                };
                const attr = this.attributes.find(a => a.AttributeName == attrName);
                if (attr) {
                    config.attrDisplay = attr.Display;
                }
            }
            attributeConfigs.push(config);
        }
        this.attributeConfigs = attributeConfigs;
        this.updateAttributeConfigs();
    }
    onContextAttributeChange() {
        const contextConfigs = [];
        for (let contextAttr of this.selectedContextAttributes) {
            let config = this.contextConfigs.find(ac => ac.contextName == contextAttr.contextName && ac.attrName == contextAttr.attrName);
            if (!config) {
                config = {
                    contextName: contextAttr.contextName,
                    attrName: contextAttr.attrName,
                    attrDisplay: contextAttr.attrDisplay,
                    valueReference: { referenceType: DwExpressionReferenceType.item },
                    relatedReference: { referenceType: DwExpressionReferenceType.context, contextName: contextAttr.contextName, attrName: contextAttr.attrName }
                };
            }
            contextConfigs.push(config);
        }
        this.contextConfigs = contextConfigs;
        this.updateAttributeConfigs();
    }
    updateAttributeConfigs() {
        this.attributeConfigsFc.setValue(this.attributeConfigs);
        this.contextConfigsFc.setValue(this.contextConfigs);
    }
    setupMetaData() {
        this.metaDataService.getMetaData(this.configContext.itemName)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes;
            this.primeAttributes = itemMd.Attributes.filter(a => !a.IsKey).map(a => { return { label: a.Display, value: a.AttributeName }; });
            this.relationships = itemMd.Relations.map(r => { return { label: r.NamingInfo.RelationshipDisplayName, value: r.RelationshipName }; });
        });
    }
    setupContextDefs() {
        // Get a list of all editable contexts
        this.contextDefs = this.dwContextService.getContextDefinitions(this.configContext.contextNames).filter(cd => cd.isEditable);
        this.dwContextService.getContextMetaDataList(this.contextDefs.map(cd => cd.contextName))
            .subscribe(contextDefsMetaData => {
            this.contextDefMetaData = contextDefsMetaData;
            this.setupContextAttributeList();
            this.setupComplete();
        });
    }
    setupContextAttributeList() {
        const contextAttributes = [];
        for (let contextDef of this.contextDefs) {
            const contextMetaData = this.contextDefMetaData[contextDef.contextName];
            for (let attr of contextMetaData.attributes) {
                const contextAttr = {
                    contextName: contextDef.contextName,
                    attrName: attr.AttributeName,
                    attrDisplay: `${contextDef.contextDisplay} - ${attr.AttributeDisplay}`,
                };
                contextAttributes.push(contextAttr);
            }
        }
        this.contextAttributes = contextAttributes;
    }
}
DwFormSetValuesConfigComponent.ɵfac = function DwFormSetValuesConfigComponent_Factory(t) { return new (t || DwFormSetValuesConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwFormSetValuesConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormSetValuesConfigComponent, selectors: [["dw-form-set-values-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 27, vars: 11, consts: [[3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "ngModel", "ngModelOptions", "filter", "ngModelChange"], ["dwRow", "", 4, "ngFor", "ngForOf"], [4, "ngIf"], ["formControlName", "clearAttributes", "display", "chip", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "filter"], ["type", "text", "formControlName", "actionMessage", 1, "form-control"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "saveAfter"], ["dwCol", "12", 1, "expr-column-full"], [3, "ngModel", "ngModelOptions", "contextNames", "item", "relatedExprRef", "ngModelChange"], ["optionLabel", "attrDisplay", "appendTo", "body", "baseZIndex", "2000", "autoZIndex", "false", 3, "options", "ngModel", "ngModelOptions", "filter", "ngModelChange"], ["formControlName", "redirectAfter"], ["dwRow", "", 4, "ngIf"], ["formControlName", "customizeRedirect"], ["formControlName", "redirectMenuKey"]], template: function DwFormSetValuesConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "hr");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "label");
        ɵngcc0.ɵɵtext(5, "Attributes to set");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "p-multiSelect", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFormSetValuesConfigComponent_Template_p_multiSelect_ngModelChange_6_listener($event) { return ctx.selectedAttributes = $event; })("ngModelChange", function DwFormSetValuesConfigComponent_Template_p_multiSelect_ngModelChange_6_listener() { return ctx.onSelectAttributeChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, DwFormSetValuesConfigComponent_div_7_Template, 5, 7, "div", 4);
        ɵngcc0.ɵɵtemplate(8, DwFormSetValuesConfigComponent_ng_container_8_Template, 7, 6, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 2);
        ɵngcc0.ɵɵelementStart(11, "label");
        ɵngcc0.ɵɵtext(12, "Attributes to Clear ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(13, "p-multiSelect", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "hr");
        ɵngcc0.ɵɵelementStart(15, "div", 1);
        ɵngcc0.ɵɵelementStart(16, "div", 2);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Action Message");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(19, "input", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 1);
        ɵngcc0.ɵɵelementStart(21, "div", 8);
        ɵngcc0.ɵɵelementStart(22, "label");
        ɵngcc0.ɵɵtext(23, "Save After");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 9);
        ɵngcc0.ɵɵelement(25, "p-inputSwitch", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(26, DwFormSetValuesConfigComponent_ng_container_26_Template, 9, 2, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.actionConfigFG);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("ngModel", ctx.selectedAttributes)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(10, _c4))("filter", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.attributeConfigs);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.contextAttributes == null ? null : ctx.contextAttributes.length) > 0);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("options", ctx.primeAttributes)("filter", true);
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG == null ? null : ctx.actionConfigFG.value == null ? null : ctx.actionConfigFG.value.saveAfter);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc12.MultiSelect, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor, ɵngcc10.InputSwitch, DwExpressionReferenceControlComponent, DwSelectRouteComponent], encapsulation: 2 });
DwFormSetValuesConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormSetValuesConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-set-values-config',
                template: "<div [formGroup]=\"actionConfigFG\">\r\n    <hr>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Attributes to set</label>\r\n            <p-multiSelect [options]=\"primeAttributes\" [(ngModel)]=\"selectedAttributes\"\r\n                (ngModelChange)=\"onSelectAttributeChange()\" [ngModelOptions]=\"{standalone:true}\" [filter]=\"true\"\r\n                appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngFor=\"let attributeConfig of attributeConfigs\">\r\n        <div dwCol=\"12\" class=\"expr-column-full\">\r\n            <label>{{attributeConfig.attrDisplay}}</label>\r\n            <dw-expression-reference-control [(ngModel)]=\"attributeConfig.valueReference\"\r\n                (ngModelChange)=\"updateAttributeConfigs()\" [ngModelOptions]=\"{standalone:true}\"\r\n                [contextNames]=\"configContext.contextNames\" [item]=\"configContext.itemName\"\r\n                [relatedExprRef]=\"attributeConfig.relatedReference\">\r\n            </dw-expression-reference-control>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"contextAttributes?.length > 0\">\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label>Context Attributes to set</label>\r\n                <p-multiSelect [options]=\"contextAttributes\" [(ngModel)]=\"selectedContextAttributes\"\r\n                    optionLabel=\"attrDisplay\" (ngModelChange)=\"onContextAttributeChange()\"\r\n                    [ngModelOptions]=\"{standalone:true}\" [filter]=\"true\" appendTo=\"body\" baseZIndex=\"2000\"\r\n                    autoZIndex=\"false\"></p-multiSelect>\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngFor=\"let contextConfig of contextConfigs\">\r\n            <div dwCol=\"12\" class=\"expr-column-full\">\r\n                <label>{{contextConfig.attrDisplay}}</label>\r\n                <dw-expression-reference-control [(ngModel)]=\"contextConfig.valueReference\"\r\n                    (ngModelChange)=\"updateAttributeConfigs()\" [ngModelOptions]=\"{standalone:true}\"\r\n                    [contextNames]=\"configContext.contextNames\" [item]=\"configContext.itemName\"\r\n                    [relatedExprRef]=\"contextConfig.relatedReference\">\r\n                </dw-expression-reference-control>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Attributes to Clear\r\n            </label>\r\n            <p-multiSelect [options]=\"primeAttributes\" formControlName=\"clearAttributes\" display=\"chip\" [filter]=\"true\"\r\n                appendTo=\"body\" baseZIndex=\"2000\" autoZIndex=\"false\"></p-multiSelect>\r\n        </div>\r\n    </div>\r\n    <hr>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label>Action Message</label>\r\n            <input type=\"text\" formControlName=\"actionMessage\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Save After</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"saveAfter\"></p-inputSwitch>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"actionConfigFG?.value?.saveAfter\">\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                <label>Redirect After</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"redirectAfter\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.redirectAfter\">\r\n            <div dwCol=\"9\">\r\n                <label>Customize Redirect</label>\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch formControlName=\"customizeRedirect\"></p-inputSwitch>\r\n            </div>\r\n        </div>\r\n        <div dwRow *ngIf=\"actionConfigFG?.value?.customizeRedirect\">\r\n            <div dwCol=\"12\">\r\n                <label>Redirect Menu</label>\r\n                <dw-select-route formControlName=\"redirectMenuKey\"></dw-select-route>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();

class DwFormSetValuesActionService {
    constructor(dwExpressionService, dwContextService, dwOrmDataService, dwMetaDataService, dwFormUtilService) {
        this.dwExpressionService = dwExpressionService;
        this.dwContextService = dwContextService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwFormUtilService = dwFormUtilService;
    }
    handleAction(actionState) {
        var _a;
        const resolvedContext = actionState.context; // context is already resolved
        const entityData = actionState.formApi.getFormData();
        const updatedEntityData = this.updateEntityData(actionState.formApi, entityData, resolvedContext, actionState.actionConfig, (_a = actionState.additionalActionContext) === null || _a === void 0 ? void 0 : _a.sectionKey);
        this.updateContextData(actionState.formApi, entityData, resolvedContext, actionState.actionConfig);
        if (actionState.actionConfig.saveAfter) {
            actionState.formApi.saveData(false);
        }
        return of({
            success: true
        });
    }
    updateEntityData(formApi, entityData, resolvedContext, formMultiCreateConfig, sectionKey) {
        // We need to get the data associated the current level where the action is being executed (This could be a child data section)
        const formConfig = formApi.getFormConfig();
        const section = this.dwFormUtilService.findSectionbyKey(formConfig.section, sectionKey);
        entityData = deepCopy(entityData);
        const childData = this.dwFormUtilService.getChildSectionData(section, entityData, formApi.formGroup, formConfig.section, formConfig.queryMetaDataList);
        const updatedEntityData = childData;
        let hasUpdates = false;
        // Clear values (this happens first so it doesn't clear set values)
        for (let attrName of formMultiCreateConfig.clearAttributes || []) {
            updatedEntityData[attrName] = null;
            hasUpdates = true;
        }
        // Set any additional values
        for (let attrToSet of formMultiCreateConfig.attributeConfigs || []) {
            const attrValue = this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(attrToSet.valueReference, childData, resolvedContext);
            updatedEntityData[attrToSet.attrName] = attrValue;
            hasUpdates = true;
        }
        // Only update if data was modified
        if (hasUpdates) {
            // Update the entity data so we include the child data
            formApi.patchFormData(entityData);
        }
        return updatedEntityData;
    }
    updateContextData(formApi, entityData, resolvedContext, formMultiCreateConfig) {
        const updatedContextData = {};
        // iterate over all context value updates and get the values
        for (let contextConfig of formMultiCreateConfig.contextConfigs || []) {
            if (!updatedContextData[contextConfig.contextName]) {
                updatedContextData[contextConfig.contextName] = {};
            }
            const contextData = updatedContextData[contextConfig.contextName];
            const attrValue = this.dwExpressionService.evaluateExpressionReferenceWithResolvedData(contextConfig.valueReference, entityData, resolvedContext);
            contextData[contextConfig.attrName] = attrValue;
        }
        for (let contextName in updatedContextData) {
            if (updatedContextData.hasOwnProperty(contextName)) {
                const updatedContext = updatedContextData[contextName];
                formApi.patchContextData(contextName, updatedContext);
            }
        }
    }
}
DwFormSetValuesActionService.ɵfac = function DwFormSetValuesActionService_Factory(t) { return new (t || DwFormSetValuesActionService)(ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwContextService), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwMetadataFormUtilService)); };
DwFormSetValuesActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFormSetValuesActionService, factory: DwFormSetValuesActionService.ɵfac });
DwFormSetValuesActionService.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwContextService },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormSetValuesActionService, [{
        type: Injectable
    }], function () { return [{ type: DwExpressionService }, { type: DwContextService }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }]; }, null); })();
DwActionFunc({
    keyName: DwFormActionKeys.formSetValues,
    display: 'Set Values',
    actionType: DwActionType.formAction,
    configComponent: DwFormSetValuesConfigComponent,
    isGlobal: true,
    allowOnce: false,
    order: 1,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-th-list',
    },
    defaultSecurityConfig: {
        useSecurityDefaults: true,
    },
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: 'Values Set',
    }
}, DwFormSetValuesActionService);

class DwGridQuickSearchConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
    }
    addControls() {
        this.addControl('placeholderText');
        this.addControl('autoFilterDelayMs');
        this.addControl('searchBoxWidthPx');
        this.addControl('searchContainerClass');
        //this.addControl('excludePk');
        this.textFilterConfigFC = this.addControl('textFilterConfig');
    }
    updateTextFilterConfig(textFilterConfig) {
        this.textFilterConfigFC.setValue(textFilterConfig);
    }
}
DwGridQuickSearchConfigComponent.ɵfac = function DwGridQuickSearchConfigComponent_Factory(t) { return new (t || DwGridQuickSearchConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwGridQuickSearchConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridQuickSearchConfigComponent, selectors: [["dw-grid-quick-search-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "config", "configContext", "configChange"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", "formControlName", "placeholderText", "placeholder", "Search...", 1, "form-control"], ["dwCol", "6"], ["type", "number", "formControlName", "searchBoxWidthPx", "placeholder", "300px", 1, "form-control"], ["type", "number", "formControlName", "autoFilterDelayMs", "placeholder", "500", 1, "form-control"], ["formControlName", "searchContainerClass", 1, "form-control"]], template: function DwGridQuickSearchConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridQuickSearchConfigComponent_div_0_Template, 25, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwAllTextFieldsCustomFilterConfigComponent, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NumberValueAccessor], encapsulation: 2 });
DwGridQuickSearchConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridQuickSearchConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-quick-search-config',
                template: `
    <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
      <dw-all-text-fields-custom-filter-config [config]="textFilterConfigFC.value" (configChange)="updateTextFilterConfig($event)" [configContext]="configContext"></dw-all-text-fields-custom-filter-config>
      <div dwRow>
        <div dwCol="12">
            <label>Search Text</label>
            <input type="text" class="form-control" formControlName="placeholderText" placeholder="Search...">
        </div>
      </div>
      <div dwRow>
          <div dwCol="6"> 
              <label>Search Text Box Width (px)</label>
          </div>
          <div dwCol="6">
              <input type="number" formControlName="searchBoxWidthPx" class="form-control" placeholder="300px">
          </div> 
      </div>
      
      <div dwRow>
          <div dwCol="6"> 
              <label>Filter Delay (ms)</label>
          </div>
          <div dwCol="6">
              <input type="number" formControlName="autoFilterDelayMs" class="form-control" placeholder="500">
          </div> 
      </div>
      <div dwRow>
          <div dwCol="6"> 
              <label>Search Container Class</label>
          </div>
          <div dwCol="6">
              <input formControlName="searchContainerClass" class="form-control">
          </div> 
      </div>
    </div>
    `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();

// DwActionFunc<DwGridActionConfig>({
//   keyName: DwGridActionKeys.gridQuickSearch,
//   display: 'Quick Search 2',
//   actionType: DwActionType.gridAction,
//   decoratorType: DwDecoratorType.component,
//   configComponent: DwGridQuickSearchConfigComponent,
//   isGlobal: true,
//   allowOnce: true,
// }, null, () => DwGridQuickSearchActionComponent);
class DwGridQuickSearchActionComponent {
    constructor(dwAllTextFieldFilterService, dwMetaDataService, dwFilterService, 
    // Set to optional for it to render in the config preview action bar
    dwFilterStateService, cdr, dwEventService) {
        this.dwAllTextFieldFilterService = dwAllTextFieldFilterService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwFilterService = dwFilterService;
        this.dwFilterStateService = dwFilterStateService;
        this.cdr = cdr;
        this.dwEventService = dwEventService;
        this.textFilterSubject = new Subject();
        this.placeholderText = 'Search...';
        this.containerStyle = {
            //width: '200px',
            //float: 'left',
            position: 'relative',
            'margin-bottom': '0px',
        };
    }
    clearSearch() {
        this.textFilterValue = '';
        this.applyFilter(this.textFilterValue);
        //
    }
    setupComponent() {
        var _a, _b, _c, _d, _e, _f;
        if (!((_a = this.actionContext) === null || _a === void 0 ? void 0 : _a.itemName) || !this.actionPreference) {
            console.warn(`No context item passed so search can't initialize`);
            return;
        }
        this.textFilterConfig = (_b = this.actionPreference.actionConfig) === null || _b === void 0 ? void 0 : _b.textFilterConfig;
        this.placeholderText = ((_c = this.actionPreference.actionConfig) === null || _c === void 0 ? void 0 : _c.placeholderText) || "Search...";
        if ((_d = this.actionPreference.actionConfig) === null || _d === void 0 ? void 0 : _d.searchBoxWidthPx) {
            this.containerStyle.width = `${(_e = this.actionPreference.actionConfig) === null || _e === void 0 ? void 0 : _e.searchBoxWidthPx}px`;
        }
        this.dwMetaDataService.getSavedQueryMetaData(this.actionContext.itemName, null, this.actionContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
        });
        this.textFilterSubject
            .pipe(debounceTime(((_f = this.actionPreference.actionConfig) === null || _f === void 0 ? void 0 : _f.autoFilterDelayMs) || 400))
            .subscribe(searchValue => {
            this.applyFilter(searchValue);
        });
        this.dwEventService.getEventData(DwGridEvents.setQuickSearchText)
            .subscribe(event => {
            if ((event === null || event === void 0 ? void 0 : event.itemName) == this.actionContext.itemName) {
                this.textFilterValue = event.quickSearchText;
                this.applyFilter(this.textFilterValue);
            }
        });
    }
    textFilterValueChange(value) {
        this.textFilterSubject.next(value);
    }
    applyFilter(value) {
        var _a;
        let newFilter = null;
        if (value) {
            newFilter = this.dwAllTextFieldFilterService.buildTextFilter(value, DwFilterType.Contains, this.textFilterConfig, this.queryMetaData);
        }
        const allFilters = this.dwFilterStateService.state.filters || {};
        allFilters['GroupQuickSearch'] = newFilter;
        const preserveFilters = {};
        preserveFilters['GroupQuickSearch'] = newFilter;
        (_a = this.dwFilterStateService) === null || _a === void 0 ? void 0 : _a.setFilters(allFilters, null, null, true, preserveFilters);
    }
    ngOnInit() {
    }
}
DwGridQuickSearchActionComponent.ɵfac = function DwGridQuickSearchActionComponent_Factory(t) { return new (t || DwGridQuickSearchActionComponent)(ɵngcc0.ɵɵdirectiveInject(DwAllTextFieldFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwEventService)); };
DwGridQuickSearchActionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridQuickSearchActionComponent, selectors: [["dw-grid-quick-search-action"]], decls: 5, vars: 5, consts: [[1, "action", 3, "ngClass"], [1, "form-group", "has-prefix", "has-suffix", "quick-search", 3, "ngStyle"], ["type", "text", "style2", "margin-bottom:0px", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], [1, "fa", "fa-search", "form-control-prefix"], ["title", "Clear Search", 1, "fa", "fa-times-circle", "form-control-suffix", "form-control-suffix-allow-click", 3, "hidden", "click"]], template: function DwGridQuickSearchActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwGridQuickSearchActionComponent_Template_input_ngModelChange_2_listener($event) { return ctx.textFilterValue = $event; })("ngModelChange", function DwGridQuickSearchActionComponent_Template_input_ngModelChange_2_listener($event) { return ctx.textFilterValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵlistener("click", function DwGridQuickSearchActionComponent_Template_i_click_4_listener() { return ctx.clearSearch(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.actionPreference == null ? null : ctx.actionPreference.actionConfig == null ? null : ctx.actionPreference.actionConfig.searchContainerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.containerStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.textFilterValue)("placeholder", ctx.placeholderText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.textFilterValue);
    } }, directives: [ɵngcc4.NgClass, ɵngcc4.NgStyle, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwGridQuickSearchActionComponent.ctorParameters = () => [
    { type: DwAllTextFieldFilterService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFilterService },
    { type: DwMetaDataFilterStateService, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef },
    { type: DwEventService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridQuickSearchActionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-quick-search-action',
                template: `
    <div class="action" [ngClass]="actionPreference?.actionConfig?.searchContainerClass">
      <div [ngStyle]="containerStyle" class="form-group has-prefix has-suffix quick-search">
        <input type="text" class="form-control" style2="margin-bottom:0px" [(ngModel)]='textFilterValue' (ngModelChange)="textFilterValueChange($event)" [placeholder]="placeholderText"/>
        <span class="fa fa-search form-control-prefix"></span>
        <i class="fa fa-times-circle form-control-suffix form-control-suffix-allow-click" [hidden]="!textFilterValue" (click)="clearSearch()" title="Clear Search"></i>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: DwAllTextFieldFilterService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFilterService }, { type: DwMetaDataFilterStateService, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwEventService }]; }, null); })();
const ɵ0$1 = () => DwGridQuickSearchActionComponent;
const _dwActionGridQuickSearch = new DwActionRegistration().RegisterAction({
    keyName: DwGridActionKeys.gridQuickSearch,
    display: 'Quick Search',
    actionType: DwActionType.gridAction,
    decoratorType: DwDecoratorType.component,
    configComponent: DwGridQuickSearchConfigComponent,
    isGlobal: true,
    allowOnce: false,
}, DwGridQuickSearchActionComponent, ɵ0$1);
// DwActionFunc<DwGridActionConfig>({
//   keyName: DwGridActionKeys.gridQuickSearch,
//   display: 'Quick Search',
//   actionType: DwActionType.gridAction,
//   decoratorType: DwDecoratorType.component,
//   configComponent: DwGridQuickSearchConfigComponent,
//   isGlobal: true,
//   allowOnce: true,
// }, DwGridQuickSearchActionComponent);

class DwMetadataFiltersVerticalComponent extends DwMetadataFiltersComponent {
    constructor(dwFilterService, dwFilterStateService, cdr, router, dwRoutingService) {
        super(dwFilterService, dwFilterStateService, cdr, router, dwRoutingService);
        this.showAdvancedFilter = false;
        this.advancedFilterConfig = this.getAdvancedFilterConfig();
    }
    ngOnInit() {
        super.ngOnInit();
    }
    toggleAdvancedFilter() {
        this.showAdvancedFilter = !this.showAdvancedFilter;
    }
    customizeFormFieldConfig(fields) {
        // Just leave this as an override (used in the verticle filter)
        const existingAdvancedSearch = fields.find(f => f.filterConfig.componentName == DwAdvancedFilter);
        if (existingAdvancedSearch) {
            this.advancedFilterConfig = existingAdvancedSearch;
            return;
        }
        fields.push(this.advancedFilterConfig);
    }
    getAdvancedFilterConfig() {
        const filterFieldConfig = {
            columnSize: 1,
            componentType: DwAdvancedFilterComponent,
            newRow: true,
            filterConfig: {
                componentName: DwAdvancedFilter,
                showFilter: false,
                attr: null,
                filterType: null
            }
        };
        return filterFieldConfig;
    }
}
DwMetadataFiltersVerticalComponent.ɵfac = function DwMetadataFiltersVerticalComponent_Factory(t) { return new (t || DwMetadataFiltersVerticalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(DwRoutingServiceToken)); };
DwMetadataFiltersVerticalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetadataFiltersVerticalComponent, selectors: [["dw-metadata-filters-vertical"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 4, consts: [["autocomplete", "off"], ["dwRow", "", 1, "filters"], [4, "ngFor", "ngForOf"], [3, "hidden"], [3, "click"], ["title", "Hides and clears the Advanced Filter", 3, "click"], [3, "component", "configure"], [4, "ngIf"], [3, "dwCol"], ["dwDynamicField", "", 3, "fieldDef", "formGroup", 4, "ngIf"], [3, "component", "configure", 4, "ngIf"], [1, "new-row"], ["dwDynamicField", "", 3, "fieldDef", "formGroup"]], template: function DwMetadataFiltersVerticalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwMetadataFiltersVerticalComponent_ng_container_2_Template, 5, 4, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "hr");
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "a", 4);
        ɵngcc0.ɵɵlistener("click", function DwMetadataFiltersVerticalComponent_Template_a_click_5_listener() { return ctx.toggleAdvancedFilter(); });
        ɵngcc0.ɵɵtext(6, "Advanced Search");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "a", 5);
        ɵngcc0.ɵɵlistener("click", function DwMetadataFiltersVerticalComponent_Template_a_click_8_listener() { return ctx.toggleAdvancedFilter(); });
        ɵngcc0.ɵɵtext(9, "Hide Advanced Filter");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "br");
        ɵngcc0.ɵɵelementStart(11, "dw-dynamic-loader", 6);
        ɵngcc0.ɵɵlistener("configure", function DwMetadataFiltersVerticalComponent_Template_dw_dynamic_loader_configure_11_listener($event) { return ctx.configFilterItemComponent($event, ctx.advancedFilterConfig); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.filterFieldConfigs);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.showAdvancedFilter);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showAdvancedFilter);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("component", ctx.advancedFilterConfig.componentType);
    } }, directives: [DwRowDirective, ɵngcc4.NgForOf, DwDynamicLoaderComponent, ɵngcc4.NgIf, DwColDirective, DwDynamicFieldComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective], styles: [""] });
DwMetadataFiltersVerticalComponent.ctorParameters = () => [
    { type: DwMetaDataFilterService },
    { type: DwMetaDataFilterStateService },
    { type: ChangeDetectorRef },
    { type: Router },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetadataFiltersVerticalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-metadata-filters-vertical',
                template: "<div autocomplete=\"off\">\r\n\r\n\r\n\r\n    <div dwRow class=\"filters\">\r\n        <ng-container *ngFor=\"let filterFieldConfig of filterFieldConfigs;\">\r\n            <ng-container *ngIf=\"filterFieldConfig?.newRow\">\r\n                <div class=\"new-row\"></div>\r\n            </ng-container>\r\n            <div [dwCol]=\"12\">\r\n                <span *ngIf=\"!filterFieldConfig.componentType\" dwDynamicField [fieldDef]=\"filterFieldConfig.fieldConfig\"\r\n                    [formGroup]=\"formGroup\"></span>\r\n\r\n                <dw-dynamic-loader *ngIf=\"filterFieldConfig.componentType && filterFieldConfig.componentType != advancedFilterConfig.componentType\" [component]=\"filterFieldConfig.componentType\"\r\n                    (configure)=\"configFilterItemComponent($event, filterFieldConfig)\"></dw-dynamic-loader>\r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n    \r\n    <hr>\r\n    <div [hidden]=\"showAdvancedFilter\">\r\n        <a (click)=\"toggleAdvancedFilter()\">Advanced Search</a>\r\n    </div>\r\n    <div [hidden]=\"!showAdvancedFilter\">\r\n        <a (click)=\"toggleAdvancedFilter()\" title=\"Hides and clears the Advanced Filter\">Hide Advanced Filter</a><br>\r\n\r\n        <dw-dynamic-loader [component]=\"advancedFilterConfig.componentType\"\r\n                    (configure)=\"configFilterItemComponent($event, advancedFilterConfig)\"></dw-dynamic-loader>\r\n    </div>\r\n\r\n\r\n</div>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataFilterService }, { type: DwMetaDataFilterStateService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.Router }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }]; }, null); })();

class DwStandardFilterComponent extends DwFilterItemBase {
    constructor(dwMetaDataService, cdr, dwMetaDataFilterService, dwExpressionComparerService, dwQueryFilterConverterService) {
        super();
        this.dwMetaDataService = dwMetaDataService;
        this.cdr = cdr;
        this.dwMetaDataFilterService = dwMetaDataFilterService;
        this.dwExpressionComparerService = dwExpressionComparerService;
        this.dwQueryFilterConverterService = dwQueryFilterConverterService;
        this.formGroup = new FormGroup({});
        this.formControl = new FormControl();
        this.contextMenus = [];
    }
    showMenu(event) {
        this.contextMenuControl.show(event);
    }
    ngOnInit() {
        this.setupFilter();
    }
    setupFilter() {
        if (!this.filterConfig) {
            return;
        }
        this.queryAttr = this.queryMetaData.Attributes.find(a => a.AttributeName == this.filterConfig.attr);
        this.fieldConfig = this.dwMetaDataFilterService.buildFieldConfig(this.filterConfig, this.queryAttr);
        if (!this.fieldConfig) {
            return;
        }
        this.fieldConfig.hideLabel = true;
        this.formGroup.addControl(this.fieldConfig.attrName, this.formControl);
        this.subscriptions.push(this.formControl.valueChanges.subscribe(value => {
            this.buildFilter(value);
        }));
        this.setupCompareTypes();
    }
    setupCompareTypes() {
        this.compareTypes = this.dwExpressionComparerService.getAttributeCompareTypes(this.queryAttr);
        const currentCompareType = this.dwQueryFilterConverterService.convertQueryCompareType(this.filterConfig.filterType);
        this.compareType = this.compareTypes.find(ct => ct.value == currentCompareType);
        this.contextMenus = [];
        // Build out the context menu of compare types
        for (let compareType of this.compareTypes) {
            this.contextMenus.push({
                label: compareType.display,
                command: (event) => {
                    this.compareType = compareType;
                    this.buildFilter(this.formControl.value);
                }
            });
        }
    }
    buildFilter(filterValue) {
        const qh = new DwQueryHelper();
        const filterType = this.dwQueryFilterConverterService.convertExpressionCompareType(this.compareType.value);
        const filterTypeKey = qh.convertFilterType(filterType);
        const filter = {};
        if (filterValue) {
            // Use the display attribute name which works for text as well as lookups
            const attrFilter = filter[this.fieldConfig.attrName] = {};
            attrFilter.Prefix = this.queryAttr.RelationPrefix;
            attrFilter[filterTypeKey] = filterValue;
        }
        this.filter = filter;
    }
}
DwStandardFilterComponent.ɵfac = function DwStandardFilterComponent_Factory(t) { return new (t || DwStandardFilterComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwExpressionComparersService), ɵngcc0.ɵɵdirectiveInject(DwQueryFilterConverterService)); };
DwStandardFilterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwStandardFilterComponent, selectors: [["dw-standard-filter"]], viewQuery: function DwStandardFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c88, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.contextMenuControl = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 5, consts: [[1, "label"], [1, "filter-type-text", 3, "click"], ["compareLabel", ""], ["dwDynamicField", "", 3, "fieldDef", "formGroup", 4, "ngIf"], ["appendTo", "body", 3, "model", "target"], ["contextMenu", ""], ["dwDynamicField", "", 3, "fieldDef", "formGroup"]], template: function DwStandardFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "label", 1, 2);
        ɵngcc0.ɵɵlistener("click", function DwStandardFilterComponent_Template_label_click_2_listener($event) { return ctx.showMenu($event); });
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwStandardFilterComponent_span_5_Template, 1, 2, "span", 3);
        ɵngcc0.ɵɵelement(6, "p-contextMenu", 4, 5);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.fieldConfig == null ? null : ctx.fieldConfig.label);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1("", ctx.compareType == null ? null : ctx.compareType.display, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldConfig);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("model", ctx.contextMenus)("target", _r0);
    } }, directives: [ɵngcc4.NgIf, ɵngcc7.ContextMenu, DwDynamicFieldComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective], styles: [".filter-type-text[_ngcontent-%COMP%]{float:right;font-size:8pt}"] });
DwStandardFilterComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: ChangeDetectorRef },
    { type: DwMetaDataFilterService },
    { type: DwExpressionComparersService },
    { type: DwQueryFilterConverterService }
];
DwStandardFilterComponent.propDecorators = {
    contextMenuControl: [{ type: ViewChild, args: ['contextMenu', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwStandardFilterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-standard-filter',
                template: `
    <label class='label'>{{ fieldConfig?.label}}</label><label #compareLabel class="filter-type-text" (click)="showMenu($event)">{{compareType?.display}} </label>

    <span dwDynamicField *ngIf="fieldConfig" [fieldDef]="fieldConfig" [formGroup]="formGroup"></span>
    <p-contextMenu #contextMenu [model]="contextMenus" appendTo="body" [target]="compareLabel"></p-contextMenu>
  `,
                styles: [".filter-type-text{float:right;font-size:8pt}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: ɵngcc0.ChangeDetectorRef }, { type: DwMetaDataFilterService }, { type: DwExpressionComparersService }, { type: DwQueryFilterConverterService }]; }, { contextMenuControl: [{
            type: ViewChild,
            args: ['contextMenu', { static: true }]
        }] }); })();
DwComponentFunc({
    name: 'Standard Filter',
    key: 'dwStandardFilter',
    componentType: DwComponentType.filterItem,
    isGlobal: true,
    configData: {
        showCaption: true,
        showCompareType: true,
        showControlOptions: true,
        requireAttr: true,
        showPlaceholderText: true,
        showDefaultValue: true,
        allowAttr: true,
    },
}, DwStandardFilterComponent);

class DwGridImplementationComponent {
    constructor() {
        this.eventsSubject = new Subject();
        this.events = this.eventsSubject.asObservable();
        this.bindableData = null;
        this.pageInfo = new DwDataPageReturnInfo();
        this.subscriptions = [];
    }
    get filters() {
        return this._filters;
    }
    set filters(filters) {
        //console.log('changing filters from', this._filters, filters);
        this._filters = filters;
    }
    // constructor(protected dwEventService: DwEventService) { 
    // }
    ngOnInit() {
        this.setupDataSource();
    }
    ngOnChanges(changes) {
        let test = "to use a breakpoint";
        if (changes.data && changes.data.currentValue) {
            this.setupDataSource();
        }
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    setData(data) {
        this.data = data;
        this.setupData();
    }
    setupData() {
        if (!this.data)
            return;
        //console.log('Ag Grid - setup Data Source', this.data?.item);
        if (this.data.requestData) {
            this.dataSource = this.data;
        }
        else
            this.setupBindableData(this.data);
    }
    setupDataSource() {
        this.setupData();
    }
    refreshDataSource(force) {
        // Defer to the base class
        this.onGridEvent({ eventType: DwGridEventType.refresh, dwBrowserEvent: null });
    }
    setupBindableData(data, clear = true) {
        if (!data)
            return;
        this.bindableData = this.bindableData || [];
        if (clear) {
            this.bindableData = [];
        }
        for (let dataItem of data) {
            this.bindableData.push(dataItem);
        }
    }
    applyFilters(filters) {
        this.filters = deepCopy(filters);
        this.refreshDataSource();
    }
    requestData() {
        if (!this.dataSource)
            return;
        let request = new DwDataRequest();
        let observableResult = this.dataSource.requestData(request);
        this.subscriptions.push(observableResult.subscribe((result) => {
            if (isDwDataPageResults(result)) {
                if (result.pageInfo)
                    this.pageInfo = result.pageInfo;
                let clearData = (this.pageInfo.currentPageNo == 1);
                this.setupBindableData(result.data, clearData);
            }
            else {
                // if just passing a simple array, then always clear the data
                this.setupBindableData(result, true);
            }
        }));
        if (this.dataSource instanceof DwInMemoryDataSource) {
            this.subscriptions.push(this.dataSource.dataChanged()
                .subscribe(data => {
                this.setupBindableData(data, true);
            }));
        }
    }
    onGridEvent(gridEvent) {
        this.eventsSubject.next(gridEvent);
    }
    findColumn(field) {
        var foundColumn = findWhere(this.gridConfig.columnDefs, { field: field });
        if (!foundColumn) {
            // try finding column by key (should be set on custom columns and always be unique)
            foundColumn = findWhere(this.gridConfig.columnDefs, { key: field });
        }
        return foundColumn;
    }
}
DwGridImplementationComponent.ɵfac = function DwGridImplementationComponent_Factory(t) { return new (t || DwGridImplementationComponent)(); };
DwGridImplementationComponent.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwGridImplementationComponent, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridImplementationComponent, [{
        type: Directive
    }], function () { return []; }, null); })();

class DwGridCardListComponent extends DwGridImplementationComponent {
    constructor() {
        super();
        this.triggerAction = new EventEmitter();
    }
    setupComplete() {
        this.setupListConfig();
    }
    triggerGridEvent(colDef, data, eventType, actionEvent, browserEvent) {
    }
    getSelectedRows() {
        return [];
    }
    getEditedRows() {
        return [];
    }
    unselectAllRows() {
    }
    selectAllRows() {
    }
    getColumnState() {
        return [];
    }
    updateGridConfig(newGridConfig, dataSource, filters) {
        this.gridConfig = newGridConfig;
        this.dataSource = dataSource;
        this.filters = filters;
        this.setupListConfig();
    }
    setupListConfig() {
        this.listConfig = {
            showFilter: false,
            hideRefresh: false,
            hideViewToggle: true,
            showHeader: false,
            autoFilter: this.gridConfig.autoFilter,
            autoFilterDelay: this.gridConfig.autoFilterDelay,
            headerTitle: '',
            showActions: false,
            listStyleName: 'none',
            hideLoading: true,
        };
        const cardContentConfig = {
            contentItems: [
                {
                    contentItemKey: 'main',
                    useTemplate: true,
                    template: 'Item: [Display]',
                }
            ]
        };
        this.cardListConfig = {
            cardItemClass: 'col-md-3',
            cardComponentName: 'dwCardDefault',
            noItemsMessage: 'There is currently no data to dispaly',
            cardComponentConfig: cardContentConfig
        };
    }
    setupCardComponent(componentInstance, data) {
        if (!componentInstance) {
            return;
        }
        componentInstance.cardConfig = this.cardListConfig.cardComponentConfig;
        componentInstance.data = data;
        componentInstance.setupCard();
        componentInstance.cardClick.subscribe(data => {
            // this.fireCardClickDefaultAction(data);
        });
    }
    processDataActionResult(dataActionResult) {
    }
}
DwGridCardListComponent.ɵfac = function DwGridCardListComponent_Factory(t) { return new (t || DwGridCardListComponent)(); };
DwGridCardListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridCardListComponent, selectors: [["dw-grid-card-list"]], inputs: { gridConfig: "gridConfig", data: "data" }, outputs: { triggerAction: "triggerAction" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["mode", "card", 3, "data", "filters", "config", "actionContext", "actionClick", 4, "ngIf"], ["mode", "card", 3, "data", "filters", "config", "actionContext", "actionClick"], ["datalist", ""], [4, "dwCardItem"], [4, "dwNoItems"], ["defaultComponentName", "dwCardDefault", 3, "componentName", "ngClass", "configure"], [4, "ngIf"]], template: function DwGridCardListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwGridCardListComponent_dw_data_list_0_Template, 4, 4, "dw-data-list", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.listConfig);
    } }, directives: [ɵngcc4.NgIf, DwDataListComponent, DwCardItemDirective, DwNoItemsDirective, DwDynamicLoaderComponent, ɵngcc4.NgClass], styles: [""] });
DwGridCardListComponent.ctorParameters = () => [];
DwGridCardListComponent.propDecorators = {
    gridConfig: [{ type: Input }],
    data: [{ type: Input }],
    triggerAction: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCardListComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-card-list',
                template: "<dw-data-list *ngIf=\"listConfig\" #datalist [data]=\"dataSource\" [filters]=\"filters\" [config]=\"listConfig\" mode=\"card\" (actionClick)=\"actionPrefClicked($event)\" [actionContext]=\"actionContext\">\r\n    <ng-container *dwCardItem=\"let item\">\r\n        <dw-dynamic-loader [componentName]=\"cardListConfig.cardComponentName\" defaultComponentName=\"dwCardDefault\" (configure)=\"setupCardComponent($event, item)\" [ngClass]=\"cardListConfig.cardItemClass\"></dw-dynamic-loader>\r\n    </ng-container>\r\n    <ng-container *dwNoItems=\"let item\">\r\n        <span *ngIf=\"!noItemsTemplate\">  {{ cardListConfig.noItemsMessage || 'There are no items found!' }}</span>\r\n    </ng-container>\r\n</dw-data-list>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { triggerAction: [{
            type: Output
        }], gridConfig: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class DwListQuickSearchConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService) {
        super();
        this.metaDataService = metaDataService;
    }
    addControls() {
        this.addControl('placeholderText');
        this.addControl('autoFilterDelayMs');
        this.addControl('searchBoxWidthPx');
        //this.addControl('excludePk');
        this.textFilterConfigFC = this.addControl('textFilterConfig');
    }
    updateTextFilterConfig(textFilterConfig) {
        this.textFilterConfigFC.setValue(textFilterConfig);
    }
}
DwListQuickSearchConfigComponent.ɵfac = function DwListQuickSearchConfigComponent_Factory(t) { return new (t || DwListQuickSearchConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwListQuickSearchConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwListQuickSearchConfigComponent, selectors: [["dw-list-quick-search-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [3, "config", "configContext", "configChange"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", "formControlName", "placeholderText", "placeholder", "Search...", 1, "form-control"], ["dwCol", "6"], ["type", "number", "formControlName", "searchBoxWidthPx", "placeholder", "200px", 1, "form-control"], ["type", "number", "formControlName", "autoFilterDelayMs", "placeholder", "500", 1, "form-control"]], template: function DwListQuickSearchConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwListQuickSearchConfigComponent_div_0_Template, 19, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwAllTextFieldsCustomFilterConfigComponent, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NumberValueAccessor], encapsulation: 2 });
DwListQuickSearchConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListQuickSearchConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-list-quick-search-config',
                template: `
    <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
      <dw-all-text-fields-custom-filter-config [config]="textFilterConfigFC.value" (configChange)="updateTextFilterConfig($event)" [configContext]="configContext"></dw-all-text-fields-custom-filter-config>
      <div dwRow>
        <div dwCol="12">
            <label>Search Text</label>
            <input type="text" class="form-control" formControlName="placeholderText" placeholder="Search...">
        </div>
      </div>
      <div dwRow>
          <div dwCol="6"> 
              <label>Search Text Box Width (px)</label>
          </div>
          <div dwCol="6">
              <input type="number" formControlName="searchBoxWidthPx" class="form-control" placeholder="200px">
          </div> 
      </div>
      
      <div dwRow>
          <div dwCol="6"> 
              <label>Filter Delay (ms)</label>
          </div>
          <div dwCol="6">
              <input type="number" formControlName="autoFilterDelayMs" class="form-control" placeholder="500">
          </div> 
      </div>
    </div>
    `
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();

class DwListQuickSearchActionComponent {
    constructor(dwAllTextFieldFilterService, dwMetaDataService, dwFilterService, 
    // Set to optional for it to render in the config preview action bar
    dwFilterStateService, cdr) {
        this.dwAllTextFieldFilterService = dwAllTextFieldFilterService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwFilterService = dwFilterService;
        this.dwFilterStateService = dwFilterStateService;
        this.cdr = cdr;
        this.textFilterSubject = new Subject();
        this.placeholderText = 'Search...';
        this.containerStyle = {
            width: '200px',
            //float: 'left',
            position: 'relative',
            'margin-bottom': '0px',
        };
    }
    clearSearch() {
        this.textFilterValue = '';
        this.applyFilter(this.textFilterValue);
    }
    setupComponent() {
        var _a, _b, _c, _d, _e;
        if (!((_a = this.actionContext) === null || _a === void 0 ? void 0 : _a.itemName) || !this.actionPreference) {
            console.warn(`No context item passed so search can't initialize`);
            return;
        }
        this.textFilterConfig = (_b = this.actionPreference.actionConfig) === null || _b === void 0 ? void 0 : _b.textFilterConfig;
        this.placeholderText = ((_c = this.actionPreference.actionConfig) === null || _c === void 0 ? void 0 : _c.placeholderText) || "Search...";
        this.containerStyle.width = `${((_d = this.actionPreference.actionConfig) === null || _d === void 0 ? void 0 : _d.searchBoxWidthPx) || 300}px`;
        this.dwMetaDataService.getSavedQueryMetaData(this.actionContext.itemName, null, this.actionContext.metaDataQueryMeaning)
            .subscribe(queryMetaData => {
            this.queryMetaData = queryMetaData;
        });
        this.textFilterSubject
            .pipe(debounceTime(((_e = this.actionPreference.actionConfig) === null || _e === void 0 ? void 0 : _e.autoFilterDelayMs) || 400))
            .subscribe(searchValue => {
            this.applyFilter(searchValue);
        });
    }
    textFilterValueChange(value) {
        this.textFilterSubject.next(value);
    }
    applyFilter(value) {
        var _a;
        let newFilter = null;
        if (value) {
            newFilter = this.dwAllTextFieldFilterService.buildTextFilter(value, DwFilterType.Contains, this.textFilterConfig, this.queryMetaData);
        }
        const allFilters = this.dwFilterStateService.state.filters || {};
        allFilters['GroupQuickSearch'] = newFilter;
        (_a = this.dwFilterStateService) === null || _a === void 0 ? void 0 : _a.setFilters(allFilters, null, null, true);
    }
    ngOnInit() {
    }
}
DwListQuickSearchActionComponent.ɵfac = function DwListQuickSearchActionComponent_Factory(t) { return new (t || DwListQuickSearchActionComponent)(ɵngcc0.ɵɵdirectiveInject(DwAllTextFieldFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFilterStateService, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwListQuickSearchActionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwListQuickSearchActionComponent, selectors: [["dw-list-quick-search-action"]], decls: 5, vars: 4, consts: [[1, "action"], [1, "form-group", "has-prefix", "has-suffix", 3, "ngStyle"], ["type", "text", 1, "form-control", 2, "margin-bottom", "0px", 3, "ngModel", "placeholder", "ngModelChange"], [1, "fa", "fa-search", "form-control-prefix"], ["title", "Clear Search", 1, "fa", "fa-times-circle", "form-control-suffix", "form-control-suffix-allow-click", 3, "hidden", "click"]], template: function DwListQuickSearchActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwListQuickSearchActionComponent_Template_input_ngModelChange_2_listener($event) { return ctx.textFilterValue = $event; })("ngModelChange", function DwListQuickSearchActionComponent_Template_input_ngModelChange_2_listener($event) { return ctx.textFilterValueChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "i", 4);
        ɵngcc0.ɵɵlistener("click", function DwListQuickSearchActionComponent_Template_i_click_4_listener() { return ctx.clearSearch(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.containerStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.textFilterValue)("placeholder", ctx.placeholderText);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !ctx.textFilterValue);
    } }, directives: [ɵngcc4.NgStyle, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwListQuickSearchActionComponent.ctorParameters = () => [
    { type: DwAllTextFieldFilterService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFilterService },
    { type: DwMetaDataFilterStateService, decorators: [{ type: Optional }] },
    { type: ChangeDetectorRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListQuickSearchActionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-list-quick-search-action',
                template: `
    <div class="action">
      <div [ngStyle]="containerStyle" class="form-group has-prefix has-suffix">
        <input type="text" class="form-control" style="margin-bottom:0px" [(ngModel)]='textFilterValue' (ngModelChange)="textFilterValueChange($event)" [placeholder]="placeholderText"/>
        <span class="fa fa-search form-control-prefix"></span>
        <i class="fa fa-times-circle form-control-suffix form-control-suffix-allow-click" [hidden]="!textFilterValue" (click)="clearSearch()" title="Clear Search"></i>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: DwAllTextFieldFilterService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFilterService }, { type: DwMetaDataFilterStateService, decorators: [{
                type: Optional
            }] }, { type: ɵngcc0.ChangeDetectorRef }]; }, null); })();
DwActionFunc({
    keyName: DwListActionKeys.listQuickSearch,
    display: 'Quick Search',
    actionType: DwActionType.listAction,
    decoratorType: DwDecoratorType.component,
    configComponent: DwListQuickSearchConfigComponent,
    isGlobal: true,
    allowOnce: true,
}, DwListQuickSearchActionComponent);

class DwAggregateFieldService {
    getAggregateFields() {
        return new DwFieldAggregateList().getEnumList();
    }
    requiresFieldValue(fieldAggregate) {
        switch (fieldAggregate) {
            case DwFieldAggregate.None:
            case DwFieldAggregate.Count:
            case DwFieldAggregate.CountDistinct:
            case DwFieldAggregate.CountAll:
            case DwFieldAggregate.CountAllDistinct:
                return false;
        }
        return true;
    }
    getAggregateDisplay(field, itemMetaData) {
        var _a;
        if (!field.AggregateFunction) {
            return field.FieldAlias;
        }
        const attr = this.findAttribute(itemMetaData, field.FullFieldName);
        const aggregateDisplay = (_a = this.getAggregateFields().find(a => a.value == field.AggregateFunction)) === null || _a === void 0 ? void 0 : _a.display;
        if (attr) {
            return `${aggregateDisplay} of ${attr.Display}`;
        }
        return aggregateDisplay;
    }
    findAttribute(itemMetaData, fullFieldName) {
        if (!fullFieldName) {
            return;
        }
        let qh = new DwQueryHelper();
        const parsedField = qh.fields.parseFullFieldName(fullFieldName);
        if (itemMetaData) {
            const attr = itemMetaData.Attributes.find(a => a.AttributeName == parsedField.FieldName);
            return attr;
        }
    }
}
DwAggregateFieldService.ɵfac = function DwAggregateFieldService_Factory(t) { return new (t || DwAggregateFieldService)(); };
DwAggregateFieldService.ɵprov = ɵɵdefineInjectable({ factory: function DwAggregateFieldService_Factory() { return new DwAggregateFieldService(); }, token: DwAggregateFieldService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateFieldService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class DwAggregateFieldConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwAggregateFieldService) {
        super();
        this.dwAggregateFieldService = dwAggregateFieldService;
    }
    getDefaultConfig() {
        return {};
    }
    setupComponent() {
        super.setupComponent();
        this.aggregateFieldList = this.dwAggregateFieldService.getAggregateFields();
        this.setFieldInfo();
    }
    setupAttributes() {
        var _a;
        const itemMetaData = (_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemMetaData;
        if (!itemMetaData) {
            return;
        }
        this.aggregateAttributes = itemMetaData.Attributes.filter(a => !a.IsLookup &&
            (a.AttributeType == DwAttributeType.Decimal ||
                a.AttributeType == DwAttributeType.Integer ||
                a.AttributeType == DwAttributeType.Date ||
                a.AttributeType == DwAttributeType.DateTime ||
                a.AttributeType == DwAttributeType.LargeInteger ||
                a.AttributeType == DwAttributeType.Money ||
                a.AttributeType == DwAttributeType.Percentage)).map(attr => {
            return {
                Display: attr.Display,
                AttributeName: `${itemMetaData.UniqueItemName}.${attr.AttributeName}`
            };
        });
        // if (!this.requireAttributeField) {
        //   this.aggregateAttributes = [{ Display:' ', AttributeName: null} as any, ...this.aggregateAttributes];
        // }
    }
    setFieldInfo() {
        this.requireAttributeField = this.dwAggregateFieldService.requiresFieldValue(this.config.AggregateFunction);
        this.setupAttributes();
        if (this.requireAttributeField && !this.config.FieldName) {
            this.config.FieldName = this.aggregateAttributes[0].AttributeName;
            this.onChange();
        }
    }
    onChange() {
        this.setFieldInfo();
        super.onChange();
    }
}
DwAggregateFieldConfigComponent.ɵfac = function DwAggregateFieldConfigComponent_Factory(t) { return new (t || DwAggregateFieldConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService)); };
DwAggregateFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAggregateFieldConfigComponent, selectors: [["dw-aggregate-field-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 12, vars: 14, consts: [["dwRow", ""], ["dwCol", "12"], ["optionLabel", "display", "display", "chip", "optionValue", "value", "appendTo", "body", 3, "options", "ngModel", "filter", "ngModelChange"], [3, "hidden"], ["optionLabel", "Display", "display", "chip", "optionValue", "AttributeName", "placeholder", " ", "appendTo", "body", 3, "options", "showClear", "ngModel", "filter", "ngModelChange"]], template: function DwAggregateFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Aggregate Function");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p-dropdown", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAggregateFieldConfigComponent_Template_p_dropdown_ngModelChange_4_listener($event) { return ctx.config.AggregateFunction = $event; })("ngModelChange", function DwAggregateFieldConfigComponent_Template_p_dropdown_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Aggregate Field ");
        ɵngcc0.ɵɵelementStart(9, "span", 3);
        ɵngcc0.ɵɵtext(10, " - Required");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "p-dropdown", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAggregateFieldConfigComponent_Template_p_dropdown_ngModelChange_11_listener($event) { return ctx.config.FullFieldName = $event; })("ngModelChange", function DwAggregateFieldConfigComponent_Template_p_dropdown_ngModelChange_11_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(12, _c43));
        ɵngcc0.ɵɵproperty("options", ctx.aggregateFieldList)("ngModel", ctx.config.AggregateFunction)("filter", true);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", !ctx.requireAttributeField);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(13, _c43));
        ɵngcc0.ɵɵproperty("options", ctx.aggregateAttributes)("showClear", !ctx.requireAttributeField)("ngModel", ctx.config.FullFieldName)("filter", true);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwAggregateFieldConfigComponent.ctorParameters = () => [
    { type: DwAggregateFieldService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateFieldConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-aggregate-field-config',
                template: `
    <div dwRow>
      <div dwCol="12">
          <label>Aggregate Function</label>
          <p-dropdown [options]="aggregateFieldList" optionLabel="display" display="chip" optionValue="value"  [(ngModel)]="config.AggregateFunction" (ngModelChange)="onChange()" [style]="{'width':'100%'}" [filter]="true" appendTo="body"></p-dropdown>
      </div>
    </div>
    <div dwRow>
      <div dwCol="12">
          <label>Aggregate Field <span [hidden]="!requireAttributeField"> - Required</span></label>
          <p-dropdown [options]="aggregateAttributes" optionLabel="Display" display="chip" optionValue="AttributeName" placeholder=" " [showClear]="!requireAttributeField"  [(ngModel)]="config.FullFieldName" (ngModelChange)="onChange()" [style]="{'width':'100%'}" [filter]="true" appendTo="body"></p-dropdown>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: DwAggregateFieldService }]; }, null); })();

class DwChildRollupFieldConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwAggregateFieldService, dwMetaDataService) {
        super();
        this.dwAggregateFieldService = dwAggregateFieldService;
        this.dwMetaDataService = dwMetaDataService;
        this.rollupFieldConfig = {};
    }
    getDefaultConfig() {
        return {};
    }
    setupComponent() {
        var _a, _b, _c, _d;
        super.setupComponent();
        this.parentItemName = (_b = (_a = this.configContext) === null || _a === void 0 ? void 0 : _a.itemMetaData) === null || _b === void 0 ? void 0 : _b.UniqueItemName;
        this.relationships = (_d = (_c = this.configContext) === null || _c === void 0 ? void 0 : _c.itemMetaData) === null || _d === void 0 ? void 0 : _d.Relations; // .filter(r => r.PkUniqueItemName ==  this.parentItemName);
        if (this.config.CustomFieldConfig) {
            this.rollupFieldConfig = JSON.parse(this.config.CustomFieldConfig) || {};
        }
        this.rollupFieldConfig.ParentItemName = this.parentItemName;
        this.setupRelationship();
    }
    setupRelationship() {
        if (!this.rollupFieldConfig.RelationName) {
            return;
        }
        const relationship = this.relationships.find(r => r.RelationshipName == this.rollupFieldConfig.RelationName);
        if (!relationship) {
            return;
        }
        this.childItemName = relationship.PkUniqueItemName == this.parentItemName ? relationship.FkUniqueItemName : relationship.PkUniqueItemName;
        const childItemId = relationship.PkUniqueItemName == this.parentItemName ? relationship.FkMetaDataItemId : relationship.PkMetaDataItemId;
        this.dwMetaDataService.getQueries(childItemId)
            .subscribe(childQueries => {
            this.childQueries = [{ QueryName: ' ' }, ...childQueries];
        });
    }
    updateConfig() {
        this.config.CustomFieldConfig = JSON.stringify(this.rollupFieldConfig);
        this.setupRelationship();
        this.onChange();
    }
}
DwChildRollupFieldConfigComponent.ɵfac = function DwChildRollupFieldConfigComponent_Factory(t) { return new (t || DwChildRollupFieldConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwChildRollupFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwChildRollupFieldConfigComponent, selectors: [["dw-child-rollup-field-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 24, vars: 7, consts: [["dwRow", ""], ["dwCol", "12"], [3, "relations", "selectedRelationName", "selectedRelationNameChange"], ["dwRow", "", 4, "ngIf"], ["type", "text", "placeholder", "Defaults to ', '", 1, "form-control", 3, "ngModel", "ngModelChange"], ["type", "number", "dwNumeric", "", "placeholder", "50", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "9"], ["title", "Return only unique values", 1, "fa", "fa-info-circle"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["optionLabel", "QueryName", "display", "chip", "optionValue", "QueryMeaning", "scrollHeight", "300px", "appendTo", "body", 3, "options", "resetFilterOnHide", "ngModel", "showClear", "filter", "ngModelChange"], ["excludeDataPrefix", "true", 3, "ngModel", "item", "queryMeaning", "showDisplayAttributes", "ngModelChange"]], template: function DwChildRollupFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "dw-relation-select", 2);
        ɵngcc0.ɵɵlistener("selectedRelationNameChange", function DwChildRollupFieldConfigComponent_Template_dw_relation_select_selectedRelationNameChange_4_listener($event) { return ctx.rollupFieldConfig.RelationName = $event; })("selectedRelationNameChange", function DwChildRollupFieldConfigComponent_Template_dw_relation_select_selectedRelationNameChange_4_listener() { return ctx.updateConfig(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwChildRollupFieldConfigComponent_div_5_Template, 5, 8, "div", 3);
        ɵngcc0.ɵɵtemplate(6, DwChildRollupFieldConfigComponent_div_6_Template, 5, 4, "div", 3);
        ɵngcc0.ɵɵelementStart(7, "div", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Item Separator");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwChildRollupFieldConfigComponent_Template_input_ngModelChange_11_listener($event) { return ctx.rollupFieldConfig.ItemSeparatorOverride = $event; })("ngModelChange", function DwChildRollupFieldConfigComponent_Template_input_ngModelChange_11_listener() { return ctx.updateConfig(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 0);
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Max Items");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwChildRollupFieldConfigComponent_Template_input_ngModelChange_16_listener($event) { return ctx.rollupFieldConfig.MaxItemsReturned = $event; })("ngModelChange", function DwChildRollupFieldConfigComponent_Template_input_ngModelChange_16_listener() { return ctx.updateConfig(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 0);
        ɵngcc0.ɵɵelementStart(18, "div", 6);
        ɵngcc0.ɵɵelementStart(19, "label");
        ɵngcc0.ɵɵtext(20, "Distinct ");
        ɵngcc0.ɵɵelement(21, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 8);
        ɵngcc0.ɵɵelementStart(23, "p-inputSwitch", 9);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwChildRollupFieldConfigComponent_Template_p_inputSwitch_ngModelChange_23_listener($event) { return ctx.rollupFieldConfig.Distinct = $event; })("ngModelChange", function DwChildRollupFieldConfigComponent_Template_p_inputSwitch_ngModelChange_23_listener() { return ctx.updateConfig(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("relations", ctx.relationships)("selectedRelationName", ctx.rollupFieldConfig.RelationName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.childQueries == null ? null : ctx.childQueries.length) > 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.childItemName);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.rollupFieldConfig.ItemSeparatorOverride);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.rollupFieldConfig.MaxItemsReturned);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.rollupFieldConfig.Distinct);
    } }, directives: function () { return [DwRowDirective, DwColDirective, DwRelationSelectComponent, ɵngcc4.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.NumberValueAccessor, DwNumericDirective, ɵngcc10.InputSwitch, ɵngcc22.Dropdown, DwTemplateConfigControlComponent]; }, encapsulation: 2 });
DwChildRollupFieldConfigComponent.ctorParameters = () => [
    { type: DwAggregateFieldService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwChildRollupFieldConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-child-rollup-field-config',
                template: `
    <div dwRow>
      <div dwCol="12">
          <label>Relationship</label>
          <dw-relation-select [relations]="relationships" [(selectedRelationName)]="rollupFieldConfig.RelationName" (selectedRelationNameChange)="updateConfig()"></dw-relation-select>
      </div>
    </div>
    <div dwRow *ngIf="childQueries?.length > 1">
      <div dwCol="12">
          <label>Query</label>
          <p-dropdown [options]="childQueries" [resetFilterOnHide]="true"  optionLabel="QueryName" display="chip" optionValue="QueryMeaning" [(ngModel)]="rollupFieldConfig.QueryMeaning" [showClear]="true" (ngModelChange)="updateConfig()" [style]="{'width':'100%'}" [filter]="true" scrollHeight="300px" appendTo="body"></p-dropdown>
      </div>
    </div>
    <div dwRow *ngIf="childItemName">
      <div dwCol="12">
          <label>Item Template</label>
          <dw-template-config-control [(ngModel)]="rollupFieldConfig.ItemTemplate" excludeDataPrefix="true" (ngModelChange)="updateConfig()"
          [item]="childItemName" [queryMeaning]="rollupFieldConfig.QueryMeaning"
          [showDisplayAttributes]="true"></dw-template-config-control>
      </div>
    </div>
    <div dwRow>
      <div dwCol="12">
          <label>Item Separator</label>
          <input type="text" class="form-control" [(ngModel)]="rollupFieldConfig.ItemSeparatorOverride" (ngModelChange)="updateConfig()" placeholder="Defaults to ', '">
      </div>
    </div>
    <div dwRow>
      <div dwCol="12">
          <label>Max Items</label>
          <input type="number" class="form-control"  dwNumeric [(ngModel)]="rollupFieldConfig.MaxItemsReturned" (ngModelChange)="updateConfig()" placeholder="50">
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
          <label>Distinct <i class="fa fa-info-circle" title="Return only unique values"></i></label>
      </div>
      <div dwCol="3">
          <p-inputSwitch [(ngModel)]="rollupFieldConfig.Distinct" (ngModelChange)="updateConfig()"></p-inputSwitch>
      </div> 
  </div>
  `
            }]
    }], function () { return [{ type: DwAggregateFieldService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();

class DwJsonFieldConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwAggregateFieldService) {
        super();
        this.dwAggregateFieldService = dwAggregateFieldService;
        this.attributeTypeLookupId = DevwareMetaDataLookups.MetaDataAttributeTypeAllItems;
    }
    getDefaultConfig() {
        return {};
    }
    setupComponent() {
        super.setupComponent();
        if (this.config.CustomFieldConfig) {
            this.jsonFieldConfig = JSON.parse(this.config.CustomFieldConfig) || {};
        }
        else {
            this.jsonFieldConfig = {};
        }
        // Sorted array of posssilbe JSON attributes (show JSON types first)
        this.jsonAttributes = sortArray(this.configContext.itemMetaData.Attributes.filter(a => a.AttributeType == DwAttributeType.JSON || a.AttributeType == DwAttributeType.Text), (item) => item.AttributeType);
        if (!this.jsonFieldConfig.JsonFieldName && this.jsonAttributes.length > 0) {
            this.jsonFieldConfig.JsonFieldName = this.jsonAttributes[0].AttributeName;
        }
    }
    onChange() {
        this.config.CustomFieldConfig = JSON.stringify(this.jsonFieldConfig);
        this.onChange();
    }
}
DwJsonFieldConfigComponent.ɵfac = function DwJsonFieldConfigComponent_Factory(t) { return new (t || DwJsonFieldConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService)); };
DwJsonFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwJsonFieldConfigComponent, selectors: [["dw-json-field-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 17, vars: 9, consts: [["dwRow", ""], ["dwCol", "12"], ["optionLabel", "Display", "display", "chip", "optionValue", "AttributeName", "appendTo", "body", 3, "options", "ngModel", "filter", "ngModelChange"], ["title", "Json path starting with $. (See SQL JSON Path expressions for more info)", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Determines the type of value to return in the query", 1, "fa", "fa-info-circle"], ["showBlank", "true", 3, "lookupId", "ngModel", "ngModelChange"]], template: function DwJsonFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Aggregate Function");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "p-dropdown", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwJsonFieldConfigComponent_Template_p_dropdown_ngModelChange_4_listener($event) { return ctx.jsonFieldConfig.JsonFieldName = $event; })("ngModelChange", function DwJsonFieldConfigComponent_Template_p_dropdown_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 0);
        ɵngcc0.ɵɵelementStart(6, "div", 1);
        ɵngcc0.ɵɵelementStart(7, "label");
        ɵngcc0.ɵɵtext(8, "Json Path ");
        ɵngcc0.ɵɵelement(9, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwJsonFieldConfigComponent_Template_input_ngModelChange_10_listener($event) { return ctx.jsonFieldConfig.JsonPath = $event; })("ngModelChange", function DwJsonFieldConfigComponent_Template_input_ngModelChange_10_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵelementStart(13, "label");
        ɵngcc0.ɵɵtext(14, "Attribute Type ");
        ɵngcc0.ɵɵelement(15, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "dw-search-select-lookup", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwJsonFieldConfigComponent_Template_dw_search_select_lookup_ngModelChange_16_listener($event) { return ctx.jsonFieldConfig.JsonAttributeType = $event; })("ngModelChange", function DwJsonFieldConfigComponent_Template_dw_search_select_lookup_ngModelChange_16_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(8, _c43));
        ɵngcc0.ɵɵproperty("options", ctx.jsonAttributes)("ngModel", ctx.jsonFieldConfig.JsonFieldName)("filter", true);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.jsonFieldConfig.JsonPath);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("lookupId", ctx.attributeTypeLookupId)("ngModel", ctx.jsonFieldConfig.JsonAttributeType);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, DwSearchSelectLookupComponent], encapsulation: 2 });
DwJsonFieldConfigComponent.ctorParameters = () => [
    { type: DwAggregateFieldService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwJsonFieldConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-json-field-config',
                template: `
    <div dwRow>
      <div dwCol="12">
          <label>Aggregate Function</label>
          <p-dropdown [options]="jsonAttributes" optionLabel="Display" display="chip" optionValue="AttributeName"  [(ngModel)]="jsonFieldConfig.JsonFieldName" (ngModelChange)="onChange()" [style]="{'width':'100%'}" [filter]="true" appendTo="body"></p-dropdown>
      </div>
    </div>
    <div dwRow>
      <div dwCol="12">
          <label>Json Path <i class="fa fa-info-circle" title="Json path starting with $. (See SQL JSON Path expressions for more info)"></i></label>
          <input type="text" class="form-control" [(ngModel)]="jsonFieldConfig.JsonPath" (ngModelChange)="onChange()">
      </div>
    </div>
    <div dwRow>
      <div dwCol="12">
          <label>Attribute Type <i class="fa fa-info-circle" title="Determines the type of value to return in the query"></i></label>
          <dw-search-select-lookup [lookupId]="attributeTypeLookupId" showBlank="true" [(ngModel)]="jsonFieldConfig.JsonAttributeType"  (ngModelChange)="onChange()"></dw-search-select-lookup>
      </div>
    </div>
  `
            }]
    }], function () { return [{ type: DwAggregateFieldService }]; }, null); })();

class DwTemplateFieldConfigComponent extends DwChildConfigBaseComponent {
    constructor(dwAggregateFieldService) {
        super();
        this.dwAggregateFieldService = dwAggregateFieldService;
    }
    getDefaultConfig() {
        return {};
    }
    setupComponent() {
        super.setupComponent();
    }
    onChange() {
        this.onChange();
    }
}
DwTemplateFieldConfigComponent.ɵfac = function DwTemplateFieldConfigComponent_Factory(t) { return new (t || DwTemplateFieldConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService)); };
DwTemplateFieldConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTemplateFieldConfigComponent, selectors: [["dw-template-field-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 5, vars: 3, consts: [["dwRow", ""], ["dwCol", "12"], ["excludeDataPrefix", "true", 3, "ngModel", "item", "showDisplayAttributes", "ngModelChange"]], template: function DwTemplateFieldConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "dw-template-config-control", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwTemplateFieldConfigComponent_Template_dw_template_config_control_ngModelChange_4_listener($event) { return ctx.config.Template = $event; })("ngModelChange", function DwTemplateFieldConfigComponent_Template_dw_template_config_control_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.Template)("item", ctx.configContext.itemMetaData.UniqueItemName)("showDisplayAttributes", true);
    } }, directives: [DwRowDirective, DwColDirective, DwTemplateConfigControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
DwTemplateFieldConfigComponent.ctorParameters = () => [
    { type: DwAggregateFieldService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTemplateFieldConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-template-field-config',
                template: `
  <div dwRow>
    <div dwCol="12">
        <label>Template</label>
        <dw-template-config-control [(ngModel)]="config.Template" excludeDataPrefix="true" (ngModelChange)="onChange()"
        [item]="configContext.itemMetaData.UniqueItemName"
        [showDisplayAttributes]="true"></dw-template-config-control>
    </div>
  </div>
  `
            }]
    }], function () { return [{ type: DwAggregateFieldService }]; }, null); })();

var DwAdditionalFieldTypes;
(function (DwAdditionalFieldTypes) {
    DwAdditionalFieldTypes["aggregateField"] = "AggregateField";
    DwAdditionalFieldTypes["childListCustomField"] = "ChildRollupCustomField";
    DwAdditionalFieldTypes["jsonCustomField"] = "JsonCustomField";
    DwAdditionalFieldTypes["templateField"] = "templateField";
})(DwAdditionalFieldTypes || (DwAdditionalFieldTypes = {}));

class DwFieldTypeService {
    getCustomFieldTypes(itemMetaData) {
        const definitions = [];
        definitions.push({
            display: 'Aggregate Field',
            keyName: DwAdditionalFieldTypes.aggregateField,
            fieldConfigComponent: DwAggregateFieldConfigComponent,
            createField: (createContext) => {
                return {
                    FieldType: DwFieldType.Aggregate,
                    AggregateFunction: DwFieldAggregate.Count,
                    FieldAlias: 'Count',
                };
            },
            isMatch: (field) => {
                return field.FieldType == DwFieldType.Aggregate;
            },
            getAttributeType: (field, attr) => {
                return this.getAggregateAttributeType(field, attr);
            }
        });
        definitions.push({
            display: 'Child List',
            keyName: DwAdditionalFieldTypes.childListCustomField,
            fieldConfigComponent: DwChildRollupFieldConfigComponent,
            createField: (createContext) => {
                return {
                    FieldType: DwFieldType.Custom,
                    CaptionOverride: 'Child List',
                    FieldAlias: 'ChildList',
                    CustomFieldType: DwAdditionalFieldTypes.childListCustomField,
                };
            },
            isMatch: (field) => {
                return field.FieldType == DwFieldType.Custom && field.CustomFieldType == DwAdditionalFieldTypes.childListCustomField;
            },
            getAttributeType: (field, attr) => {
                return DwAttributeType.Text;
            }
        });
        definitions.push({
            display: 'JSON Field',
            keyName: DwAdditionalFieldTypes.jsonCustomField,
            fieldConfigComponent: DwJsonFieldConfigComponent,
            createField: (createContext) => {
                return {
                    FieldType: DwFieldType.Custom,
                    CaptionOverride: 'JSON Field',
                    FieldAlias: 'JSonField',
                    CustomFieldType: DwAdditionalFieldTypes.jsonCustomField
                };
            },
            isMatch: (field) => {
                return field.FieldType == DwFieldType.Custom && field.CustomFieldType == DwAdditionalFieldTypes.jsonCustomField;
            },
            getAttributeType: (field, attr) => {
                let jsonFieldConfig;
                if (field.CustomFieldConfig) {
                    jsonFieldConfig = JSON.parse(field.CustomFieldConfig);
                    if (jsonFieldConfig === null || jsonFieldConfig === void 0 ? void 0 : jsonFieldConfig.JsonAttributeType) {
                        return convertToAttributeType(jsonFieldConfig === null || jsonFieldConfig === void 0 ? void 0 : jsonFieldConfig.JsonAttributeType);
                    }
                }
                return DwAttributeType.Text;
            }
        });
        definitions.push({
            display: 'Template Field',
            keyName: DwAdditionalFieldTypes.templateField,
            fieldConfigComponent: DwTemplateFieldConfigComponent,
            createField: (createContext) => {
                return {
                    FieldType: DwFieldType.Template,
                    CaptionOverride: 'Template',
                    FieldAlias: 'Template',
                    Template: ''
                };
            },
            isMatch: (field) => {
                return field.FieldType == DwFieldType.Template;
            },
            getAttributeType: (field, attr) => {
                return DwAttributeType.Text;
            }
        });
        return definitions;
    }
    getAggregateAttributeType(field, attr) {
        switch (field.AggregateFunction) {
            case DwFieldAggregate.None:
                return null;
            case DwFieldAggregate.Count:
            case DwFieldAggregate.CountDistinct:
            case DwFieldAggregate.CountAll:
            case DwFieldAggregate.CountAllDistinct:
            case DwFieldAggregate.Avg:
                return DwAttributeType.Integer;
            case DwFieldAggregate.CountBig:
                return DwAttributeType.LargeInteger;
            case DwFieldAggregate.Sum:
            case DwFieldAggregate.StDev:
            case DwFieldAggregate.StDevP:
            case DwFieldAggregate.Var:
            case DwFieldAggregate.VarP:
            case DwFieldAggregate.Min:
            case DwFieldAggregate.Max:
                if (attr) {
                    return attr.AttributeType;
                }
            case DwFieldAggregate.Grouping:
                return null;
        }
        return DwAttributeType.Decimal;
    }
}
DwFieldTypeService.ɵfac = function DwFieldTypeService_Factory(t) { return new (t || DwFieldTypeService)(); };
DwFieldTypeService.ɵprov = ɵɵdefineInjectable({ factory: function DwFieldTypeService_Factory() { return new DwFieldTypeService(); }, token: DwFieldTypeService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFieldTypeService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class DwQueryEditorFieldsAdvancedComponent {
    constructor(dwAggregateFieldService, dwMetaDataService, dwFieldTypeService) {
        this.dwAggregateFieldService = dwAggregateFieldService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwFieldTypeService = dwFieldTypeService;
        this.fieldStateChange = new EventEmitter();
        this.fieldConfigContext = {};
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Field',
            displayField: 'fieldDisplay',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Configure Field',
            showListActionBar: true,
        };
        this.dwMetaDataService.getDatabaseDetails()
            .subscribe(databaseDetails => {
            this.databaseDetails = databaseDetails;
            this.setupValueFieldFormatters();
        });
    }
    ngOnChanges(changes) {
        if (changes.fieldState) {
            this.allAttributes = this.buildQueryAttributes();
            this.fieldConfigContext.itemMetaData = this.fieldState.itemMd;
            this.buildAvailableFields();
        }
    }
    buildAvailableFields() {
        this.customFieldTypes = this.dwFieldTypeService.getCustomFieldTypes(this.fieldState.itemMd);
        if (this.fieldState) {
            let availableAttributes = [];
            for (let attr of this.allAttributes) {
                if (!this.hasAttribute(attr)) {
                    availableAttributes.push(attr);
                }
            }
            this.availableAttributes = availableAttributes;
            this.buildDisplayFields();
        }
    }
    reorderList() {
        const fields = [];
        for (let listItem of this.listFields) {
            fields.push(listItem.field);
        }
        this.fieldState.selectedFields = fields;
        this.stateChange();
    }
    setSelectedItem(fieldListItem) {
        this.selectedItem = fieldListItem;
        this.customFieldType = this.customFieldTypes.find(f => (f === null || f === void 0 ? void 0 : f.isMatch) && f.isMatch(this.selectedItem.field));
        this.setupValueFieldFormatters();
    }
    setupValueFieldFormatters() {
        var _a;
        if (!this.selectedItem) {
            return;
        }
        const attributeType = this.getAttributeType(this.selectedItem.field);
        this.validFieldFormatters = sortArray((_a = this.databaseDetails.SQLValueFormatters) === null || _a === void 0 ? void 0 : _a.filter(fv => fv.ValidAttributeTypes.find(at => at == attributeType)), (ff) => ff === null || ff === void 0 ? void 0 : ff.FormatName);
    }
    removeAll() {
        this.fieldState.selectedFields = [];
        this.stateChange();
    }
    buildDisplayFields() {
        if (!this.allAttributes) {
            return;
        }
        const listFields = [];
        const qh = new DwQueryHelper();
        for (let field of this.fieldState.selectedFields) {
            let attrDisplay = this.getDefaultDisplay(field);
            listFields.push({
                attrDisplay: attrDisplay,
                fieldDisplay: field.CaptionOverride ? field.CaptionOverride : attrDisplay,
                field: field
            });
        }
        const originalListFields = this.listFields;
        this.listFields = listFields;
        if (this.selectedItem) {
            const selectedIndex = originalListFields.indexOf(this.selectedItem);
            if (selectedIndex >= 0) {
                this.selectedItem = listFields[selectedIndex];
            }
        }
    }
    // let attrDisplay = field.FieldName;
    // if (field.FullFieldName) {
    //   const parsedField = qh.fields.parseFullFieldName(field.FullFieldName);
    //   const attr = this.allAttributes.find(a => a.AttributeName == parsedField.FieldName);
    //   if (attr) {
    //     attrDisplay = attr.AttributeDisplay;
    //   }
    // }
    getDefaultDisplay(field) {
        var _a;
        const attr = this.findAttribute(field.FullFieldName);
        switch (field.FieldType) {
            case DwFieldType.Aggregate:
                const aggregateDisplay = (_a = this.dwAggregateFieldService.getAggregateFields().find(a => a.value == field.AggregateFunction)) === null || _a === void 0 ? void 0 : _a.display;
                if (attr) {
                    return `${aggregateDisplay} of ${attr.Display}`;
                }
                if (aggregateDisplay) {
                    return aggregateDisplay;
                }
            case DwFieldType.Custom:
                break;
            case DwFieldType.Expression:
                break;
            default:
                if (attr) {
                    return attr.Display;
                }
                break;
        }
        if (field.FieldAlias) {
            return field.FieldAlias;
        }
        return field.FieldName;
    }
    getAttributeType(field) {
        var _a;
        const attr = this.findAttribute(field.FullFieldName);
        const customFieldType = this.customFieldTypes.find(cft => cft.isMatch(field));
        if (customFieldType) {
            return customFieldType.getAttributeType(field, attr);
        }
        switch (field.FieldType) {
            case DwFieldType.Aggregate:
                const aggregateDisplay = (_a = this.dwAggregateFieldService.getAggregateFields().find(a => a.value == field.AggregateFunction)) === null || _a === void 0 ? void 0 : _a.display;
                if (!attr) {
                    return DwAttributeType.Decimal;
                }
            case DwFieldType.Custom:
                return DwAttributeType.Text;
            case DwFieldType.Expression:
                return DwAttributeType.Text;
                break;
        }
        return (attr === null || attr === void 0 ? void 0 : attr.AttributeType) || DwAttributeType.Text;
    }
    buildQueryAttributes() {
        const queryAttributes = [];
        if (!this.fieldState.itemMd) {
            return;
        }
        for (let attr of this.fieldState.itemMd.Attributes) {
            const queryAttr = {};
            queryAttr.AttributeName = attr.AttributeName;
            queryAttr.AttributeDisplay = attr.Display;
            queryAttr.Attribute = attr;
            queryAttributes.push(queryAttr);
        }
        return queryAttributes;
    }
    getFieldDisplay(field) {
        const attr = this.findAttribute(field.FullFieldName);
        if (attr) {
            return attr.Display;
        }
        return "No Field Name";
    }
    fieldChange() {
        if (!this.selectedItem) {
            return;
        }
        const field = this.selectedItem.field;
        let attrDisplay = this.getDefaultDisplay(field);
        this.selectedItem.attrDisplay = attrDisplay,
            this.selectedItem.fieldDisplay = field.CaptionOverride ? field.CaptionOverride : attrDisplay;
    }
    removeField(fieldListItem) {
        const fields = this.fieldState.selectedFields;
        const index = this.listFields.indexOf(fieldListItem);
        if (index >= 0) {
            fields.splice(index, 1);
            this.listFields.splice(index, 1);
        }
        this.buildAvailableFields();
        this.stateChange();
    }
    addAttribute(attr) {
        const qh = new DwQueryHelper();
        const field = new DwField();
        const fields = this.fieldState.selectedFields;
        let itemName = this.fieldState.itemMd.UniqueItemName;
        field.FullFieldName = qh.fields.buildFullFieldName(attr.AttributeName, itemName);
        fields.push(field);
        this.buildAvailableFields();
        this.stateChange();
    }
    addField(field) {
        this.fieldState.selectedFields.push(field);
        this.buildAvailableFields();
    }
    addCustomField(customField) {
        this.addField(customField.createField({}));
    }
    rootItemFieldsChange() {
        if (this.fieldState.includeRootItemFields) {
        }
        this.stateChange();
    }
    stateChange() {
        this.fieldStateChange.emit(this.fieldState);
    }
    findAttribute(fullFieldName) {
        if (!fullFieldName) {
            return null;
        }
        let qh = new DwQueryHelper();
        const itemMetaData = this.fieldState.itemMd;
        const parsedField = qh.fields.parseFullFieldName(fullFieldName);
        if (itemMetaData) {
            const attr = findWhere(itemMetaData.Attributes, { AttributeName: parsedField.FieldName });
            return attr;
        }
    }
    hasAttribute(attr) {
        const qh = new DwQueryHelper();
        for (let field of this.fieldState.selectedFields) {
            // Only look for standard fields
            if (field.FieldType == null || field.FieldType == DwFieldType.Standard) {
                // parse field name
                const parsedField = qh.fields.parseFullFieldName(field.FullFieldName, this.fieldState.itemMd.UniqueItemName);
                if (parsedField.FieldName == attr.AttributeName) {
                    return true;
                }
            }
        }
        return false;
    }
}
DwQueryEditorFieldsAdvancedComponent.ɵfac = function DwQueryEditorFieldsAdvancedComponent_Factory(t) { return new (t || DwQueryEditorFieldsAdvancedComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwFieldTypeService)); };
DwQueryEditorFieldsAdvancedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorFieldsAdvancedComponent, selectors: [["dw-query-editor-fields-advanced"]], inputs: { fieldState: "fieldState" }, outputs: { fieldStateChange: "fieldStateChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c69, decls: 16, vars: 9, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], ["header", "Fields", 3, "selected"], [4, "ngIf"], ["class", "fields-list2", 4, "ngIf"], ["header", "Aggregate Fields", 4, "ngIf"], ["header", "Other Field Types"], ["class", "field-item", 4, "ngFor", "ngForOf"], ["actionBar", ""], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], ["additionalTab", ""], [3, "ngModel", "ngModelChange"], [1, "fields-list2"], ["addTooltip", "Add Field", 3, "attributes", "attributeClick"], ["header", "Aggregate Fields"], [3, "itemMetaData", "addField"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], [1, "fa", "fa-plus-circle", "hand"], ["header", "Basic Settings", 3, "selected"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", 1, "form-control", 3, "ngModel", "placeholder", "ngModelChange"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["placeholder", "  ", "optionLabel", "FormatName", "display", "chip", "optionValue", "FormatKey", "scrollHeight", "300px", "appendTo", "body", 3, "options", "resetFilterOnHide", "ngModel", "showClear", "ngModelChange"], [3, "component", "config", "configContext", "configChange", 4, "ngIf"], [3, "component", "config", "configContext", "configChange"]], template: function DwQueryEditorFieldsAdvancedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c68);
        ɵngcc0.ɵɵelementStart(0, "dw-ui-config-list", 0);
        ɵngcc0.ɵɵlistener("selectedItemChange", function DwQueryEditorFieldsAdvancedComponent_Template_dw_ui_config_list_selectedItemChange_0_listener($event) { return ctx.setSelectedItem($event); })("removeItem", function DwQueryEditorFieldsAdvancedComponent_Template_dw_ui_config_list_removeItem_0_listener($event) { return ctx.removeField($event); })("reorder", function DwQueryEditorFieldsAdvancedComponent_Template_dw_ui_config_list_reorder_0_listener() { return ctx.reorderList(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "p-accordion");
        ɵngcc0.ɵɵelementStart(3, "p-accordionTab", 2);
        ɵngcc0.ɵɵtemplate(4, DwQueryEditorFieldsAdvancedComponent_div_4_Template, 4, 1, "div", 3);
        ɵngcc0.ɵɵtemplate(5, DwQueryEditorFieldsAdvancedComponent_div_5_Template, 2, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, DwQueryEditorFieldsAdvancedComponent_p_accordionTab_6_Template, 2, 1, "p-accordionTab", 5);
        ɵngcc0.ɵɵelementStart(7, "p-accordionTab", 6);
        ɵngcc0.ɵɵtemplate(8, DwQueryEditorFieldsAdvancedComponent_div_8_Template, 4, 1, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵelementStart(10, "button", 9);
        ɵngcc0.ɵɵlistener("click", function DwQueryEditorFieldsAdvancedComponent_Template_button_click_10_listener() { return ctx.removeAll(); });
        ɵngcc0.ɵɵtext(11, "Remove All");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 10);
        ɵngcc0.ɵɵtemplate(13, DwQueryEditorFieldsAdvancedComponent_p_accordion_13_Template, 20, 14, "p-accordion", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 11);
        ɵngcc0.ɵɵprojection(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.listFields)("config", ctx.listConfig)("selectedItem", ctx.selectedItem);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldState.allowIncludeRootItemFields);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.fieldState.includeRootItemFields);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldState.isAggreateQuery);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.customFieldTypes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItem == null ? null : ctx.selectedItem.field);
    } }, directives: function () { return [DwUiConfigListComponent, ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc4.NgIf, ɵngcc4.NgForOf, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwFieldSelectionComponent, DwAggregateFieldSelectionComponent, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc22.Dropdown, DwUiChildConfigHostComponent]; }, styles: [""] });
DwQueryEditorFieldsAdvancedComponent.ctorParameters = () => [
    { type: DwAggregateFieldService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwFieldTypeService }
];
DwQueryEditorFieldsAdvancedComponent.propDecorators = {
    fieldState: [{ type: Input }],
    fieldStateChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorFieldsAdvancedComponent, [{
        type: Component,
        args: [{
                selector: 'dw-query-editor-fields-advanced',
                template: "<dw-ui-config-list [items]=\"listFields\" [config]=\"listConfig\" [selectedItem]=\"selectedItem\" size=\"large\"\r\n    (selectedItemChange)=\"setSelectedItem($event)\" (removeItem)=\"removeField($event)\" (reorder)=\"reorderList()\">\r\n    <div addItemsTab>\r\n        <p-accordion>\r\n            <p-accordionTab header=\"Fields\" [selected]=\"true\">\r\n                <div *ngIf=\"fieldState.allowIncludeRootItemFields\">\r\n                    <label>Include All Fields</label>\r\n\r\n                    <dw-yesno [(ngModel)]=\"fieldState.includeRootItemFields\" (ngModelChange)='rootItemFieldsChange()'>\r\n                    </dw-yesno>\r\n                </div>\r\n                <div class=\"fields-list2\" *ngIf=\"!fieldState.includeRootItemFields\">\r\n                    <dw-field-selection [attributes]=\"availableAttributes\" (attributeClick)=\"addAttribute($event)\"\r\n                        addTooltip=\"Add Field\"></dw-field-selection>\r\n                </div>\r\n            </p-accordionTab>\r\n\r\n            <p-accordionTab header=\"Aggregate Fields\" *ngIf=\"fieldState.isAggreateQuery\">\r\n                <dw-aggregate-field-selection [itemMetaData]=\"fieldState.itemMd\" (addField)=\"addField($event)\"></dw-aggregate-field-selection>\r\n            </p-accordionTab>\r\n            <p-accordionTab header=\"Other Field Types\">\r\n                \r\n                <div *ngFor=\"let customFieldType of customFieldTypes\" class=\"field-item\">\r\n                    <button class=\"btn btn-sm btn-success\" (click)=\"addCustomField(customFieldType)\">\r\n                        <i class=\"fa fa-plus-circle hand\"></i>\r\n                        {{customFieldType.display}}\r\n                    </button>\r\n                </div>\r\n\r\n                \r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </div>\r\n    <div actionBar>\r\n        <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n    </div>\r\n    <div configureItemTab>\r\n        <p-accordion *ngIf=\"selectedItem?.field\">\r\n            Field Name : {{selectedItem.field.FullFieldName}}<br>\r\n\r\n            <p-accordionTab header=\"Basic Settings\" [selected]=\"true\">\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Caption Override</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.field.CaptionOverride\" (ngModelChange)=\"fieldChange()\" [placeholder]=\"selectedItem.attrDisplay\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"12\">\r\n                        <label>Field Alias</label>\r\n                        <input type=\"text\" [(ngModel)]=\"selectedItem.field.FieldAlias\" (ngModelChange)=\"fieldChange()\" class=\"form-control\">\r\n                    </div>\r\n                </div>\r\n                <div dwRow [hidden]=\"!validFieldFormatters?.length>0\">\r\n                    <div dwCol=\"12\">\r\n                        <label>Format Name</label>\r\n                        <p-dropdown [options]=\"validFieldFormatters\" placeholder=\"  \" [resetFilterOnHide]=\"true\"  optionLabel=\"FormatName\" display=\"chip\" optionValue=\"FormatKey\" [(ngModel)]=\"selectedItem.field.FormatName\" [showClear]=\"true\" (ngModelChange)=\"fieldChange()\" [style]=\"{'width':'100%'}\" scrollHeight=\"300px\" appendTo=\"body\"></p-dropdown>\r\n                    </div>\r\n                </div>\r\n                <dw-ui-child-config-host *ngIf=\"customFieldType?.fieldConfigComponent\" [component]=\"customFieldType?.fieldConfigComponent\"\r\n                    [(config)]=\"selectedItem.field\" (configChange)=\"fieldChange()\"\r\n                    [configContext]=\"fieldConfigContext\">\r\n                </dw-ui-child-config-host>\r\n            </p-accordionTab>\r\n        </p-accordion>\r\n    </div>\r\n    <div additionalTab>\r\n        <ng-content select=\"[additionalTab]\"></ng-content>\r\n    </div>\r\n</dw-ui-config-list>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwAggregateFieldService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwFieldTypeService }]; }, { fieldStateChange: [{
            type: Output
        }], fieldState: [{
            type: Input
        }] }); })();

class DwAggregateFieldSelectionComponent {
    constructor(dwAggregateFieldService) {
        this.dwAggregateFieldService = dwAggregateFieldService;
        this.addField = new EventEmitter();
    }
    ngOnInit() {
        this.aggregateFieldList = this.dwAggregateFieldService.getAggregateFields();
    }
    addAggregate(aggregateField) {
        const field = new DwField();
        field.FieldType = DwFieldType.Aggregate;
        field.AggregateFunction = aggregateField.value;
        //field.CaptionOverride = this.dwAggregateFieldService.getAggregateDisplay(field, this.itemMetaData);
        field.FieldAlias = aggregateField.display;
        if (this.dwAggregateFieldService.requiresFieldValue(field.AggregateFunction)) {
            const attr = this.getDefaultAggregateAttr();
            if (attr) {
                field.FullFieldName = `${this.itemMetaData.UniqueItemName}.${attr.AttributeName}`;
            }
        }
        this.addField.emit(field);
    }
    getDefaultAggregateAttr() {
        var _a;
        const allAttributes = ((_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.Attributes) || [];
        // First, get a currency or numeric field
        let field = allAttributes.find(a => !a.IsKey && (a.MetaDataControlTypeId == DwControlType.CurrencyTextBox || a.MetaDataControlTypeId == DwControlType.NumericTextBox));
        if (!field) {
            field = allAttributes.find(a => (!a.IsKey && !a.IsLookup) && (a.AttributeType == DwAttributeType.Decimal || a.AttributeType == DwAttributeType.Integer));
        }
        if (!field) {
            field = allAttributes.find(a => a.AttributeType == DwAttributeType.Decimal || a.AttributeType == DwAttributeType.Integer);
        }
        return field;
    }
}
DwAggregateFieldSelectionComponent.ɵfac = function DwAggregateFieldSelectionComponent_Factory(t) { return new (t || DwAggregateFieldSelectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService)); };
DwAggregateFieldSelectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAggregateFieldSelectionComponent, selectors: [["dw-aggregate-field-selection"]], inputs: { itemMetaData: "itemMetaData" }, outputs: { addField: "addField" }, decls: 1, vars: 1, consts: [["class", "field-item", 4, "ngFor", "ngForOf"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], [1, "fa", "fa-plus-circle", "hand"]], template: function DwAggregateFieldSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwAggregateFieldSelectionComponent_div_0_Template, 4, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx.aggregateFieldList);
    } }, directives: [ɵngcc4.NgForOf], styles: [""] });
DwAggregateFieldSelectionComponent.ctorParameters = () => [
    { type: DwAggregateFieldService }
];
DwAggregateFieldSelectionComponent.propDecorators = {
    itemMetaData: [{ type: Input }],
    addField: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateFieldSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-aggregate-field-selection',
                template: "<div *ngFor=\"let aggregateField of aggregateFieldList\" class=\"field-item\">\r\n    <button class=\"btn btn-sm btn-success\" (click)=\"addAggregate(aggregateField)\">\r\n        <i class=\"fa fa-plus-circle hand\"></i>\r\n        {{aggregateField.display}}\r\n    </button>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwAggregateFieldService }]; }, { addField: [{
            type: Output
        }], itemMetaData: [{
            type: Input
        }] }); })();

class DwRelationSelectComponent {
    constructor() {
        this.selectedRelationChange = new EventEmitter();
        this.selectedRelationNameChange = new EventEmitter();
    }
    ngOnChanges(changes) {
        if (changes.relations) {
            this.setupRelationships();
        }
        if (changes.selectedRelationName) {
            this.setRelationship();
        }
    }
    ngOnInit() {
        this.setupRelationships();
    }
    setupRelationships() {
        this.sortedRelations = sortArray(this.relations, (f) => { var _a; return (_a = f.NamingInfo) === null || _a === void 0 ? void 0 : _a.RelationshipDisplayName; });
    }
    setRelationship() {
        if (this.selectedRelationName) {
            this.selectedRelation = this.relations.find(r => r.RelationshipName == this.selectedRelationName);
        }
    }
    onRelationChange() {
        var _a;
        this.selectedRelationChange.emit(this.selectedRelation);
        this.selectedRelationName = (_a = this.selectedRelation) === null || _a === void 0 ? void 0 : _a.RelationshipName;
        this.selectedRelationNameChange.emit(this.selectedRelationName);
    }
}
DwRelationSelectComponent.ɵfac = function DwRelationSelectComponent_Factory(t) { return new (t || DwRelationSelectComponent)(); };
DwRelationSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRelationSelectComponent, selectors: [["dw-relation-select"]], inputs: { selectedRelation: "selectedRelation", selectedRelationName: "selectedRelationName", relations: "relations" }, outputs: { selectedRelationChange: "selectedRelationChange", selectedRelationNameChange: "selectedRelationNameChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 5, consts: [["placeholder", "Select Relation", "place", "", "optionLabel", "NamingInfo.RelationshipDisplayName", "filter", "true", "virtualScroll", "true", "itemSize", "30", "autoDisplayFirst", "false", "appendTo", "body", 3, "options", "ngModel", "ngModelChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"]], template: function DwRelationSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dropdown", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwRelationSelectComponent_Template_p_dropdown_ngModelChange_0_listener($event) { return ctx.selectedRelation = $event; })("ngModelChange", function DwRelationSelectComponent_Template_p_dropdown_ngModelChange_0_listener() { return ctx.onRelationChange(); });
        ɵngcc0.ɵɵtemplate(1, DwRelationSelectComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
        ɵngcc0.ɵɵtemplate(2, DwRelationSelectComponent_ng_template_2_Template, 1, 1, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(4, _c43));
        ɵngcc0.ɵɵproperty("options", ctx.sortedRelations)("ngModel", ctx.selectedRelation);
    } }, directives: [ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.PrimeTemplate], encapsulation: 2 });
DwRelationSelectComponent.ctorParameters = () => [];
DwRelationSelectComponent.propDecorators = {
    relations: [{ type: Input }],
    selectedRelation: [{ type: Input }],
    selectedRelationName: [{ type: Input }],
    selectedRelationChange: [{ type: Output }],
    selectedRelationNameChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRelationSelectComponent, [{
        type: Component,
        args: [{
                selector: 'dw-relation-select',
                template: `
  <p-dropdown [style]="{'width':'100%'}" placeholder="Select Relation"
      [options]="sortedRelations" [(ngModel)]="selectedRelation" place

      (ngModelChange)="onRelationChange()" 
      optionLabel="NamingInfo.RelationshipDisplayName" filter="true" virtualScroll="true"
      itemSize="30" autoDisplayFirst="false" appendTo="body">
      <ng-template let-item pTemplate="selectedItem">
          {{item?.NamingInfo?.RelationshipDisplayName }}
      </ng-template>
      <ng-template let-item pTemplate="item">
          {{item?.NamingInfo?.RelationshipDisplayName }}
      </ng-template>
  </p-dropdown>
 `
            }]
    }], function () { return []; }, { selectedRelationChange: [{
            type: Output
        }], selectedRelationNameChange: [{
            type: Output
        }], selectedRelation: [{
            type: Input
        }], selectedRelationName: [{
            type: Input
        }], relations: [{
            type: Input
        }] }); })();

var __decorate$2a = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1I = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwDesignerSelector {
    constructor(dwDesignerStateService) {
        this.dwDesignerStateService = dwDesignerStateService;
        this.highlight = false;
        this.stopPropagation = true;
        this.subscriptions = [];
    }
    ngOnInit() {
        this.subscriptions.push(this.dwDesignerStateService.stateChanged.subscribe(state => {
            this.setSelectedState(state);
        }));
    }
    setSelectedState(state) {
        let isSelected = false;
        if (this.sectionKey && state.configKey == this.configKey && state.sectionKey == this.sectionKey) {
            if (!state.detailKey && !this.detailKey) {
                isSelected = true;
            }
            else if (state.detailKey == this.detailKey) {
                isSelected = true;
            }
        }
        if (isSelected && this.highlight) {
            this.hoverClass = "dw-highlight-area";
        }
        else {
            this.hoverClass = null;
        }
    }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    // @HostListener('document:keydown', ['$event']) doubleClick(e: KeyboardEvent) {
    //     if (DwDesignerSelector.lastEvent && DwDesignerSelector.lastEvent == e) {
    //         //console.log(`${this.sectionKey}-${this.detailKey} - Event Skipped`);
    //         e.stopPropagation();
    //         return;
    //     }
    //     //console.log(`${this.sectionKey}-${this.detailKey}`, e);
    //     DwDesignerSelector.lastEvent = e;
    //     console.log(`Keyboard Event ${e.ctrlKey}  Key: ${e.key}`);
    //     Can handle F1-F12, Ctrl + key combinations, etc.
    //     if (e.ctrlKey && e.key == "d") {
    //         this.dwDesignerStateService.configureSection(this.sectionKey, this.detailKey, this.configKey, this.additionalInfo); // this.additionalInfo);    
    //     }
    //     e.preventDefault();
    //     e.stopPropagation();
    // }
    click(e) {
        // We only want to handle the event once, but if we stopPropogation it causes issues with some controls (like the tab strip)
        //  So instead, we allow progation, but the second directive that receives the exact same event will just ignore and then stopPropagation
        if (DwDesignerSelector.lastEvent && DwDesignerSelector.lastEvent == e) {
            //console.log(`${this.sectionKey}-${this.detailKey} - Event Skipped`);
            //e.stopPropagation();
            return;
        }
        //console.log(`${this.sectionKey}-${this.detailKey}`, e);
        DwDesignerSelector.lastEvent = e;
        if (e.altKey) {
            this.dwDesignerStateService.configureSection(this.sectionKey, this.detailKey, this.configKey, this.additionalInfo); // this.additionalInfo);    
        }
        else {
            this.dwDesignerStateService.setSection(this.sectionKey, this.detailKey, this.configKey, this.additionalInfo); // this.additionalInfo);
        }
        // if (this.stopPropagation && e.stopPropagation){
        //     e.stopPropagation();
        // }
        // if (e?.preventDefault) {
        //     e.preventDefault();
        // } 
    }
}
DwDesignerSelector.ɵfac = function DwDesignerSelector_Factory(t) { return new (t || DwDesignerSelector)(ɵngcc0.ɵɵdirectiveInject(DwDesignerStateService)); };
DwDesignerSelector.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwDesignerSelector, selectors: [["", "dwPageDesignerSelector", ""]], hostVars: 2, hostBindings: function DwDesignerSelector_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function DwDesignerSelector_click_HostBindingHandler($event) { return ctx.click($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.hoverClass);
    } }, inputs: { highlight: "highlight", stopPropagation: "stopPropagation", sectionKey: "sectionKey", detailKey: "detailKey", configKey: "configKey", additionalInfo: "additionalInfo" } });
DwDesignerSelector.lastEvent = null;
DwDesignerSelector.ctorParameters = () => [
    { type: DwDesignerStateService }
];
DwDesignerSelector.propDecorators = {
    sectionKey: [{ type: Input }],
    detailKey: [{ type: Input }],
    configKey: [{ type: Input }],
    additionalInfo: [{ type: Input }],
    highlight: [{ type: Input }],
    stopPropagation: [{ type: Input }],
    hoverClass: [{ type: HostBinding, args: ["class",] }],
    click: [{ type: HostListener, args: ['click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDesignerSelector, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[dwPageDesignerSelector]'
            }]
    }], function () { return [{ type: DwDesignerStateService }]; }, { highlight: [{
            type: Input
        }], stopPropagation: [{
            type: Input
        }], hoverClass: [{
            type: HostBinding,
            args: ["class"]
        }], 
    // @HostListener('document:keydown', ['$event']) doubleClick(e: KeyboardEvent) {
    //     if (DwDesignerSelector.lastEvent && DwDesignerSelector.lastEvent == e) {
    //         //console.log(`${this.sectionKey}-${this.detailKey} - Event Skipped`);
    //         e.stopPropagation();
    //         return;
    //     }
    //     //console.log(`${this.sectionKey}-${this.detailKey}`, e);
    //     DwDesignerSelector.lastEvent = e;
    //     console.log(`Keyboard Event ${e.ctrlKey}  Key: ${e.key}`);
    //     Can handle F1-F12, Ctrl + key combinations, etc.
    //     if (e.ctrlKey && e.key == "d") {
    //         this.dwDesignerStateService.configureSection(this.sectionKey, this.detailKey, this.configKey, this.additionalInfo); // this.additionalInfo);    
    //     }
    //     e.preventDefault();
    //     e.stopPropagation();
    // }
    click: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], sectionKey: [{
            type: Input
        }], detailKey: [{
            type: Input
        }], configKey: [{
            type: Input
        }], additionalInfo: [{
            type: Input
        }] }); })();
__decorate$2a([
    DwInputConverter(booleanConverter),
    __metadata$1I("design:type", Boolean)
], DwDesignerSelector.prototype, "highlight", void 0);
__decorate$2a([
    DwInputConverter(booleanConverter),
    __metadata$1I("design:type", Boolean)
], DwDesignerSelector.prototype, "stopPropagation", void 0);

class DwMdSectionFormFieldsConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb, dwFormValiadtionService, dwSectionConfigStateService) {
        super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
        this.fb = fb;
        this.dwFormValiadtionService = dwFormValiadtionService;
        this.dwSectionConfigStateService = dwSectionConfigStateService;
        this.listFields = [];
        this.allowDuplicateFields = false;
        this.fieldSetupComplete = false;
    }
    ngOnInit() {
        this.listConfig = {
            addItemsHeading: 'Add Field',
            displayField: 'fieldDisplay',
            iconClassField: 'iconClass',
            iconTooltipField: 'iconTooltip',
            allowRemoveItem: true,
            allowConfigureItem: true,
            configureItemHeading: 'Field Properties',
            showListActionBar: true,
        };
        this.setupFieldSources();
        this.setFieldColumnItemPreference();
    }
    fieldSourcesSetupComplete() {
        // Continue setup once we have the field soures loaded
        this.setupFieldList();
        this.defaultSelectedFieldFromDesigner();
        this.fieldSetupComplete = true;
    }
    /**
     * Finds the first attribute that matches - this might not be the correct one if the field is listed more than once
     * @returns
     */
    defaultSelectedFieldFromDesigner() {
        var _a, _b, _c;
        const selectedAttrName = (_b = (_a = this.dwSectionConfigStateService.state.designerState) === null || _a === void 0 ? void 0 : _a.additionalInfo) === null || _b === void 0 ? void 0 : _b.attrName;
        if (!selectedAttrName) {
            return;
        }
        // Only use the designer state once, so if they click off the section and back to it, we don't want to default it
        if (this.dwSectionConfigStateService.state.designerDetailUsed) {
            return;
        }
        const fieldRef = (_c = this.listFields) === null || _c === void 0 ? void 0 : _c.find(f => f.field.attrName == selectedAttrName);
        if (fieldRef) {
            this.setSelectedField(fieldRef);
            this.dwSectionConfigStateService.setDesignerDetailUsed();
            if (this.listConfig) {
                this.listConfig.defaultConfigureTab = true;
            }
        }
    }
    ngOnChanges(changes) {
        if (changes.itemMetaData && !changes.itemMetaData.firstChange) {
            this.setupFieldSources();
        }
    }
    setupFieldSources() {
        if (!this.itemMetaData) {
            return;
        }
        this.getContextAndMetaData()
            .subscribe(results => {
            const queryMetaData = results.queryMetaData;
            const contextMdList = results.contextMdList;
            const fieldSources = [
                { display: this.itemMetaData.Display, rootTable: true, attributes: queryMetaData.Attributes }
            ];
            this.contextMdList = contextMdList;
            for (const contextName of this.contextNames) {
                const contextDef = this.dwContextService.getContextDef(contextName);
                if (contextDef) {
                    const contextDefMetaData = contextMdList[contextName];
                    let attributes = contextDefMetaData.attributes;
                    if (contextDefMetaData) {
                        attributes = contextDefMetaData.attributes;
                    }
                    fieldSources.push({
                        display: contextDef.contextDisplay,
                        rootTable: false,
                        contextDefinition: contextDef,
                        attributes: attributes
                    });
                }
            }
            this.fieldSources = fieldSources;
            this.setFieldSource(this.fieldSources[0]);
            this.fieldSourcesSetupComplete();
        });
    }
    getContextAndMetaData() {
        return this.dwMetaDataService.getSavedQueryMetaData(this.itemMetaData.UniqueItemName)
            .pipe(mergeMap(queryMetaData => {
            this.fieldSources = [
                { display: this.itemMetaData.Display, rootTable: true, attributes: queryMetaData.Attributes }
            ];
            return this.dwContextService.getContextMetaDataList(this.contextNames)
                .pipe(map(contextMdList => {
                return {
                    queryMetaData,
                    contextMdList
                };
            }));
        }));
    }
    setFieldSource(fieldSource) {
        this.selectedFieldSource = fieldSource;
        this.buildAvailableAttrs();
    }
    setupFieldList() {
        if (!this.section || !this.section.fields) {
            return;
        }
        const listFields = [];
        for (const field of this.section.fields) {
            const fieldRef = this.buildFieldRef(field);
            listFields.push(fieldRef);
        }
        this.listFields = listFields;
        // Reassign the selected field so the reference matches the new list
        if (this.selectedField) {
            const newSelectedField = this.listFields.find(lf => lf.field.attrName == this.selectedField.field.attrName && lf.field.contextName == this.selectedField.field.contextName);
            this.setSelectedField(newSelectedField);
        }
    }
    buildFieldRef(field) {
        const attr = this.getAttribute(field);
        const fieldRef = {
            fieldDisplay: this.getFieldDisplay(field, attr),
            field: field,
            attr: attr
        };
        this.setFieldConfiguredOptions(fieldRef);
        return fieldRef;
    }
    setFieldConfiguredOptions(fieldRef) {
        const fieldConfiguredOptions = getFieldConfiguredOptions(fieldRef.field, fieldRef.attr);
        if (fieldConfiguredOptions.hasErrors) {
            fieldRef.iconClass = 'fa fa-exclamation-triangle dw-red';
            fieldRef.iconTooltip = fieldConfiguredOptions.errorDesc;
            // we won't show configured options, since there is an error
            return;
        }
        if (fieldConfiguredOptions.hasAnyOverrides) {
            fieldRef.iconClass = 'fa fa-wrench dw-orange';
            fieldRef.iconTooltip = fieldConfiguredOptions.overrideDesc;
        }
        else {
            fieldRef.iconClass = '';
            fieldRef.iconTooltip = '';
        }
    }
    // setFieldDisplays() {
    //   if (!this.section || !this.section.fields) {
    //     return;
    //   }
    //   for (const field of this.section.fields) {
    //     field.fieldDisplay = this.getFieldDisplay(field);
    //   }
    // }
    // setConditionalClasses(conditionalClasses: DwConditionalFieldClasses) {
    //     this.selectedField.conditionalFieldClasses = conditionalClasses;
    // }
    updateField(field) {
        this.selectedField.field = field;
        this.selectedField.fieldDisplay = this.getFieldDisplay(field, this.selectedField.attr);
        this.setFieldConfiguredOptions(this.selectedField);
        this.onSectionChange();
    }
    setSelectedField(field) {
        this.selectedField = field;
        this.selectedAttr = this.getAttribute(this.selectedField.field);
        return;
    }
    getFieldDisplay(field, attr) {
        if (field.label)
            return field.label;
        if (attr) {
            return attr.AttributeDisplay;
        }
        return field.attrName;
    }
    getAttribute(field) {
        if (!this.fieldSources) {
            return;
        }
        let fieldSource = this.fieldSources.find(fs => fs.rootTable);
        let displayPrefix = '';
        if (field.contextName) {
            fieldSource = this.fieldSources.find(fs => fs.contextDefinition && fs.contextDefinition.contextName === field.contextName);
            // displayPrefix = fieldSource?.contextDefinition?.contextDisplay + ' - ';
        }
        if (fieldSource) {
            const attr = findWhere(fieldSource.attributes, { AttributeName: field.attrName });
            if (attr) {
                return Object.assign(Object.assign({}, attr), { AttributeDisplay: `${displayPrefix}${attr.AttributeDisplay}` });
            }
        }
        return null;
    }
    sectionChanged() {
        this.setFieldColumnItemPreference();
        let itemName = this.getParentItemName();
        this.getItemMetaData(itemName)
            .subscribe(itemMetaData => {
            this.itemMetaData = itemMetaData;
            this.setupFieldSources();
            this.buildAvailableAttrs();
        });
    }
    setFieldColumnItemPreference() {
        if (!this.section) {
            return;
        }
        if (!this.section.fields) {
            this.section.fields = [];
        }
        for (let field of this.section.fields) {
            if (!field.columnItemPreferences)
                field.columnItemPreferences = new DwFormColumnItemPreference();
        }
    }
    buildAvailableAttrs() {
        if (!this.section || !this.itemMetaData || !this.selectedFieldSource) {
            return;
        }
        const attrs = [];
        let allAttributes = this.selectedFieldSource.attributes;
        for (let attr of allAttributes) {
            const found = this.section.fields.find((field) => {
                if (field.attrName.toUpperCase() != attr.AttributeName.toUpperCase()) {
                    return false;
                }
                if (this.selectedFieldSource.contextDefinition) {
                    return field.contextName == this.selectedFieldSource.contextDefinition.contextName;
                }
                return !field.contextName;
            });
            if (!found || this.allowDuplicateFields) {
                attrs.push(attr);
            }
        }
        this.availableAttributes = attrs;
    }
    addItem(attr) {
        let field = new DwFormFieldPreference();
        field.columnItemPreferences = new DwFormColumnItemPreference();
        field.attrName = attr.AttributeName;
        if (this.selectedFieldSource.contextDefinition) {
            field.contextName = this.selectedFieldSource.contextDefinition.contextName;
        }
        // field.fieldDisplay = this.getFieldDisplay(field);
        this.section.fields = [...this.section.fields, field];
        const fieldRef = this.buildFieldRef(field);
        this.listFields = [...this.listFields, fieldRef];
        this.buildAvailableAttrs();
    }
    reorderList() {
        // Nothing to update here
        // Need to reorder the actual section field list
        const newFieldList = [];
        for (let fieldRef of this.listFields) {
            newFieldList.push(fieldRef.field);
        }
        this.section.fields = newFieldList;
    }
    removeItem(item) {
        var index = this.section.fields.indexOf(item.field);
        if (index >= 0)
            this.section.fields.splice(index, 1);
        var fieldRefIndex = this.listFields.indexOf(item);
        if (fieldRefIndex >= 0) {
            this.listFields.splice(fieldRefIndex, 1);
        }
        this.selectedField = null;
        this.buildAvailableAttrs();
    }
    removeAll() {
        this.section.fields.length = 0;
        this.listFields.length = 0;
        this.selectedField = null;
        this.buildAvailableAttrs();
    }
}
DwMdSectionFormFieldsConfigComponent.ɵfac = function DwMdSectionFormFieldsConfigComponent_Factory(t) { return new (t || DwMdSectionFormFieldsConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwSectionConfigStateService)); };
DwMdSectionFormFieldsConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMdSectionFormFieldsConfigComponent, selectors: [["dw-md-section-form-fields-config"]], viewQuery: function DwMdSectionFormFieldsConfigComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(OrderList, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.orderList = _t.first);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder", 4, "ngIf"], ["size", "large", 3, "items", "config", "selectedItem", "selectedItemChange", "removeItem", "reorder"], ["addItemsTab", ""], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [1, "field-section"], ["addTooltip", "Add Field", 3, "attributes", "attributeClick"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], [3, "ngModel", "ngModelChange"], ["actionBar", ""], ["dwCol", "6"], [1, "btn", "btn-danger", "button-spacing", 3, "click"], ["configureItemTab", ""], [3, "selectedField", "selectedAttr", "itemName", "contextNames", "contextMdList", "selectedFieldChange", 4, "ngIf"], [3, "ngValue"], [3, "selectedField", "selectedAttr", "itemName", "contextNames", "contextMdList", "selectedFieldChange"]], template: function DwMdSectionFormFieldsConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMdSectionFormFieldsConfigComponent_dw_ui_config_list_0_Template, 18, 8, "dw-ui-config-list", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldSetupComplete);
    } }, directives: [ɵngcc4.NgIf, DwUiConfigListComponent, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, DwFieldSelectionComponent, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwMdSectionFormFieldConfigComponent], styles: [_c92], encapsulation: 2 });
DwMdSectionFormFieldsConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwSectionConfigStateService }
];
DwMdSectionFormFieldsConfigComponent.propDecorators = {
    orderList: [{ type: ViewChild, args: [OrderList,] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionFormFieldsConfigComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-md-section-form-fields-config',
                template: "<dw-ui-config-list *ngIf=\"fieldSetupComplete\" [items]=\"listFields\" [config]=\"listConfig\" [selectedItem]=\"selectedField\" size=\"large\"\r\n    (selectedItemChange)=\"setSelectedField($event)\" (removeItem)=\"removeItem($event)\" (reorder)=\"reorderList()\">\r\n    <div addItemsTab>\r\n        <select [ngModel]=\"selectedFieldSource\" (ngModelChange)=\"setFieldSource($event)\" class=\"form-control\">\r\n            <option *ngFor=\"let fieldSource of this.fieldSources\" [ngValue]=\"fieldSource\">\r\n                {{ fieldSource.display }}\r\n            </option>\r\n        </select>\r\n\r\n        <div class=\"field-section\">\r\n            <dw-field-selection [attributes]=\"availableAttributes\" (attributeClick)=\"addItem($event)\"\r\n                addTooltip=\"Add Field\"></dw-field-selection>\r\n        </div>\r\n\r\n        <div dwRow>\r\n            <div dwCol=\"9\">\r\n                Allow adding duplicate fields\r\n            </div>\r\n            <div dwCol=\"3\">\r\n                <p-inputSwitch [(ngModel)]=\"allowDuplicateFields\" (ngModelChange)=\"setFieldSource(selectedFieldSource)\">\r\n                </p-inputSwitch>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div actionBar>\r\n        <div dwRow>\r\n            <div dwCol=\"6\">\r\n                <button class=\"btn btn-danger button-spacing\" (click)=\"removeAll()\">Remove All</button>\r\n            </div> \r\n        </div>\r\n    </div>\r\n    <div configureItemTab>\r\n        <dw-md-section-form-field-config *ngIf=\"selectedField\" [(selectedField)]=\"selectedField.field\" (selectedFieldChange)=\"updateField($event)\" [selectedAttr]=\"selectedAttr\" [itemName]=\"itemName\" [contextNames]=\"contextNames\" [contextMdList]=\"contextMdList\"></dw-md-section-form-field-config>\r\n    </div>\r\n</dw-ui-config-list>\r\n\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".dw-field-list{max-height:500px;overflow:auto}.field-section{height:400px;overflow:auto;width:100%}.field-item{clear:left;margin-top:2px;width:200px}.field-item .btn{text-align:left;width:100%}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }, { type: DwMetadataFormValidationBuilderService }, { type: DwSectionConfigStateService }]; }, { orderList: [{
            type: ViewChild,
            args: [OrderList]
        }] }); })();

class DwQueryEditorFixRelationComponent extends DwQueryEditorAddRelationComponent {
    ngOnInit() {
    }
}
DwQueryEditorFixRelationComponent.ɵfac = function DwQueryEditorFixRelationComponent_Factory(t) { return ɵDwQueryEditorFixRelationComponent_BaseFactory(t || DwQueryEditorFixRelationComponent); };
DwQueryEditorFixRelationComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwQueryEditorFixRelationComponent, selectors: [["dw-query-editor-fix-relation"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "card", 4, "ngIf"], [1, "card"], [1, "card-body"], [1, "card-title"], [1, "card-text"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["placeholder", "Select Relation", "place", "", "optionLabel", "NamingInfo.RelationshipDisplayName", "filter", "true", "virtualScroll", "true", "itemSize", "30", "autoDisplayFirst", "false", 3, "options", "ngModel", "ngModelChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], [1, "btn", "btn-success", 3, "click"], [1, "btn", "btn-danger", 3, "click"]], template: function DwQueryEditorFixRelationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwQueryEditorFixRelationComponent_div_0_Template, 17, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAddRelation && ctx.itemMetaData.Relations);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc6.PrimeTemplate, DwButtonBarComponent], encapsulation: 2 });
const ɵDwQueryEditorFixRelationComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwQueryEditorFixRelationComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwQueryEditorFixRelationComponent, [{
        type: Component,
        args: [{
                selector: 'dw-query-editor-fix-relation',
                template: "\r\n\r\n<div *ngIf=\"showAddRelation && itemMetaData.Relations\" class=\"card\">\r\n    <div class=\"card-body\">\r\n        <h5 class=\"card-title\">Choose another Relation</h5>\r\n\r\n        <div class=\"card-text\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Relations</label>\r\n                    <p-dropdown [style]=\"{'width':'100%'}\" placeholder=\"Select Relation\"\r\n                        [options]=\"itemMetaData.Relations\" [(ngModel)]=\"selectedRelation\" place\r\n                        optionLabel=\"NamingInfo.RelationshipDisplayName\" filter=\"true\" virtualScroll=\"true\"\r\n                        itemSize=\"30\" autoDisplayFirst=\"false\">\r\n                        <ng-template let-item pTemplate=\"selectedItem\">\r\n                            {{item?.NamingInfo?.RelationshipDisplayName }}\r\n                        </ng-template>\r\n                        <ng-template let-item pTemplate=\"item\">\r\n                            {{item?.NamingInfo?.RelationshipDisplayName }}\r\n                        </ng-template>\r\n                    </p-dropdown>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <dw-button-bar>\r\n            <button class=\"btn btn-success\" (click)=\"okClick()\">Fix relation</button>\r\n            <button class=\"btn btn-danger\" (click)=\"close()\">Cancel</button>\r\n        </dw-button-bar>\r\n    </div>\r\n</div>"
            }]
    }], null, null); })();

class DwGridStartInlineEditsActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        actionState.metaDataGridApi.inlineEditApi.startInlineEdits(0, true);
        return of({ success: true });
    }
}
DwGridStartInlineEditsActionService.ɵfac = function DwGridStartInlineEditsActionService_Factory(t) { return new (t || DwGridStartInlineEditsActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridStartInlineEditsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridStartInlineEditsActionService, factory: DwGridStartInlineEditsActionService.ɵfac });
DwGridStartInlineEditsActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridStartInlineEditsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_StartInlineEdit,
    display: 'Start Inline Grid Edit',
    actionType: DwActionType.gridAction,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Start Inline Edits',
        iconClass: 'fa fa-edit',
        buttonClass: 'btn btn-success',
        buttonTitle: 'Start Inline Edits',
        buttonType: DwButtonType.standard,
    },
    defaultSecurityConfig: {}
}, DwGridStartInlineEditsActionService);

class DwGridCancelInlineEditsActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        actionState.metaDataGridApi.inlineEditApi.cancelInLineEdits(true);
        return of({ success: true });
    }
    showConfirmDialog(actionState) {
        const rows = actionState.metaDataGridApi.getEditedRows();
        const result = {
            overrideConfig: false,
        };
        if (rows.length == 0) {
            result.overrideConfig = true;
            result.resultConfig = {
                showConfirmDialog: false,
            };
        }
        return result;
    }
}
DwGridCancelInlineEditsActionService.ɵfac = function DwGridCancelInlineEditsActionService_Factory(t) { return new (t || DwGridCancelInlineEditsActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridCancelInlineEditsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridCancelInlineEditsActionService, factory: DwGridCancelInlineEditsActionService.ɵfac });
DwGridCancelInlineEditsActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCancelInlineEditsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_CancelInlineEdits,
    display: 'Cancel All Edits',
    actionType: DwActionType.gridActionInlineEdit,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-times',
        buttonClass: 'btn btn-danger',
        buttonTitle: 'Cancel Row Edit',
        buttonType: DwButtonType.standard,
    },
    defaultConfirmConfig: {
        showConfirmDialog: true,
        showDialogConfig: true,
        title: 'Cancel all edits?',
        message: 'Are you sure you want to cancel all edits?'
    },
    defaultSecurityConfig: {}
}, DwGridCancelInlineEditsActionService);

class DwGridCancelInlineRowEditActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        var _a;
        const params = (_a = actionState.event.actionContext) === null || _a === void 0 ? void 0 : _a.params;
        if (params === null || params === void 0 ? void 0 : params.cancelRowEdit) {
            params.cancelRowEdit(params.data);
        }
        return of({ success: true });
    }
}
DwGridCancelInlineRowEditActionService.ɵfac = function DwGridCancelInlineRowEditActionService_Factory(t) { return new (t || DwGridCancelInlineRowEditActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridCancelInlineRowEditActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridCancelInlineRowEditActionService, factory: DwGridCancelInlineRowEditActionService.ɵfac });
DwGridCancelInlineRowEditActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCancelInlineRowEditActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_CancelInlineRowEdit,
    display: 'Cancel (Inline)',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.service,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {},
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Cancel',
        buttonTitle: 'Cancel Edit',
        //iconClass: 'dw-icon-grid fa fa-times dw-red',
        iconClass: 'fa fa-times',
        buttonClass: 'btn-sm btn-danger',
        buttonType: DwButtonType.standard,
    },
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewMode: DwGridRowActionInlineViewModes.editing,
        }
    }
}, DwGridCancelInlineRowEditActionService);
function dwGridCancelActionRule(editingState, data) {
    if (editingState === null || editingState === void 0 ? void 0 : editingState.editing) {
        return false;
    }
    if ((editingState === null || editingState === void 0 ? void 0 : editingState.edited) || (editingState === null || editingState === void 0 ? void 0 : editingState.deleted)) {
        return true;
    }
}

class DwGridSaveInlineEditsActionService {
    constructor(metaDataGridNavigationService, metaDataGridService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
        this.metaDataGridService = metaDataGridService;
    }
    handleAction(actionState) {
        const result = {
            success: true,
        };
        const rows = actionState.metaDataGridApi.getEditedRows();
        const invalidRows = rows.filter(r => { var _a; return ((_a = r._validation) === null || _a === void 0 ? void 0 : _a.isValid) == false; });
        if (invalidRows.length > 0) {
            const plural = invalidRows.length > 1 ? 's' : '';
            const verb = invalidRows.length > 1 ? 'are' : 'is';
            result.success = false;
            result.message = {
                messageBody: `There ${verb} ${invalidRows.length} invalid row${plural}.  Please correct the errors and try again.`,
                severity: DwMessageSeverity.warning,
                allowClose: true,
                timeToShow: 3000
            };
            return of(result);
        }
        const dataSource = actionState.metaDataGridApi.data;
        if (!dataSource.saveAllItems) {
            result.success = false;
            result.message = {
                messageBody: `Could not save items because the grid doesn't use a data source.`,
                severity: DwMessageSeverity.warning,
                allowClose: true,
                timeToShow: 3000
            };
            return of(result);
        }
        const finalRows = this.metaDataGridService.cleanupEditableData(rows);
        return dataSource.saveAllItems(finalRows).pipe(map((results) => {
            result.message = {
                messageBody: rows.length == 1 ? `${rows.length} item has been saved` : `${rows.length} items have been saved`,
                severity: DwMessageSeverity.success,
                allowClose: true,
                timeToShow: 3000
            };
            actionState.metaDataGridApi.inlineEditApi.cancelInLineEdits(true);
            return result;
            // this.gridContext.inEditMode = false;
            // this.gridContext.updatedCount = 0;
            // this.updateGridContext();
            // this.gridApi.refreshDataSource(true);
        }));
    }
}
DwGridSaveInlineEditsActionService.ɵfac = function DwGridSaveInlineEditsActionService_Factory(t) { return new (t || DwGridSaveInlineEditsActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService), ɵngcc0.ɵɵinject(DwMetaDataGridService)); };
DwGridSaveInlineEditsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridSaveInlineEditsActionService, factory: DwGridSaveInlineEditsActionService.ɵfac });
DwGridSaveInlineEditsActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService },
    { type: DwMetaDataGridService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridSaveInlineEditsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }, { type: DwMetaDataGridService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_SaveInLineEdits,
    display: 'Save All Edits',
    actionType: DwActionType.gridActionInlineEdit,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-save',
        buttonClass: 'btn btn-success',
        buttonTitle: 'Save all Edits',
        buttonType: DwButtonType.standard,
    },
    defaultSecurityConfig: {}
}, DwGridSaveInlineEditsActionService);

class DwGridDeleteInlineRowEditActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        var _a;
        const params = (_a = actionState.event.actionContext) === null || _a === void 0 ? void 0 : _a.params;
        if (params === null || params === void 0 ? void 0 : params.markRowDeleted) {
            params.markRowDeleted(params.data);
        }
        return of({ success: true });
    }
}
DwGridDeleteInlineRowEditActionService.ɵfac = function DwGridDeleteInlineRowEditActionService_Factory(t) { return new (t || DwGridDeleteInlineRowEditActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridDeleteInlineRowEditActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridDeleteInlineRowEditActionService, factory: DwGridDeleteInlineRowEditActionService.ɵfac });
DwGridDeleteInlineRowEditActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridDeleteInlineRowEditActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_DeleteInlineRowEdit,
    display: 'Delete Row (Inline)',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.service,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {
        requireCanDelete: true
    },
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonTitle: 'Mark Row as Deleted',
        iconClass: 'dw-icon-delete-grid',
        buttonType: DwButtonType.iconOnlyNoText,
    },
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewMode: DwGridRowActionInlineViewModes.notEditing,
            inlineRowActionViewRule: dwGridDeleteActionRule
        }
    }
}, DwGridDeleteInlineRowEditActionService);
function dwGridDeleteActionRule(editingState, data) {
    if (editingState === null || editingState === void 0 ? void 0 : editingState.editing) {
        return false;
    }
    if (!(editingState === null || editingState === void 0 ? void 0 : editingState.deleted)) {
        return true;
    }
}

class DwGridStartEditInlineEditsActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        var _a;
        const params = (_a = actionState.event.actionContext) === null || _a === void 0 ? void 0 : _a.params;
        if (params.startRowEdit) {
            params.startRowEdit(params.data);
        }
        return of({ success: true });
    }
}
DwGridStartEditInlineEditsActionService.ɵfac = function DwGridStartEditInlineEditsActionService_Factory(t) { return new (t || DwGridStartEditInlineEditsActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridStartEditInlineEditsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridStartEditInlineEditsActionService, factory: DwGridStartEditInlineEditsActionService.ɵfac });
DwGridStartEditInlineEditsActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridStartEditInlineEditsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_StartEditInlineRowEdit,
    display: 'Start Inline Row Edit',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.service,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {
        requireCanDelete: true
    },
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'dw-icon-edit-grid',
        buttonTitle: 'Edit',
        buttonType: DwButtonType.iconOnlyNoText,
    },
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewMode: DwGridRowActionInlineViewModes.notEditing,
        }
    }
}, DwGridStartEditInlineEditsActionService);

class DwGridCompleteEditInlineEditsActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        var _a;
        const params = (_a = actionState.event.actionContext) === null || _a === void 0 ? void 0 : _a.params;
        if (params.completeRowEdit) {
            params.completeRowEdit(params.data);
        }
        return of({ success: true });
    }
}
DwGridCompleteEditInlineEditsActionService.ɵfac = function DwGridCompleteEditInlineEditsActionService_Factory(t) { return new (t || DwGridCompleteEditInlineEditsActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridCompleteEditInlineEditsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridCompleteEditInlineEditsActionService, factory: DwGridCompleteEditInlineEditsActionService.ɵfac });
DwGridCompleteEditInlineEditsActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridCompleteEditInlineEditsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_CompleteInlineRowEdit,
    display: 'Complete Inline Row Edit',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.service,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {},
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Save',
        //buttonTitle: 'Save Edit',
        //iconClass: 'dw-icon-grid fa fa-times dw-red',
        iconClass: 'fa fa-disk',
        buttonClass: 'btn-sm btn-success',
        buttonType: DwButtonType.standard,
    },
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewMode: DwGridRowActionInlineViewModes.editing,
        }
    }
}, DwGridCompleteEditInlineEditsActionService);

class DwFormDebugSectionComponent extends DwSectionBaseComponent {
    constructor(resolver, dwConfigService, uiMetaDataConfig, dwExpressionService, dwUiConfigRegistryService, dwMetaDataService, dwExpressionStateService, dwMdFormUtilService, dwMetaDataFormSectionStateService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.resolver = resolver;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwMdFormUtilService = dwMdFormUtilService;
        this.dwMetaDataFormSectionStateService = dwMetaDataFormSectionStateService;
        this.formSectionInfo = [];
        this.sectionDefinitions = dwUiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
    }
    sectionConfigChanged() {
        this.setupDebug();
    }
    ngOnInit() {
        super.ngOnInit();
        this.dwMetaDataFormSectionStateService.stateChanged.subscribe((state) => {
            this.state = state;
            this.formSectionInfo = [];
            for (let sectionId in state.formSections) {
                if (state.formSections.hasOwnProperty(sectionId)) {
                    const sectionState = state.formSections[sectionId];
                    const sectionConfig = sectionState.sectionConfig;
                    sectionConfig.title;
                    sectionConfig.sectionType;
                    this.formSectionInfo.push(Object.assign(Object.assign({}, sectionState), { formGroup: null, fieldStates: null }));
                }
            }
        });
    }
    setupDebug() {
        const sections = this.dwMdFormUtilService.sectionsMap;
    }
}
DwFormDebugSectionComponent.ɵfac = function DwFormDebugSectionComponent_Factory(t) { return new (t || DwFormDebugSectionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService)); };
DwFormDebugSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFormDebugSectionComponent, selectors: [["dw-form-debug-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[4, "ngFor", "ngForOf"]], template: function DwFormDebugSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0, " Sections State : ");
        ɵngcc0.ɵɵtemplate(1, DwFormDebugSectionComponent_div_1_Template, 8, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.formSectionInfo);
    } }, directives: [ɵngcc4.NgForOf], encapsulation: 2 });
DwFormDebugSectionComponent.ctorParameters = () => [
    { type: ComponentFactoryResolver },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionStateService },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormSectionStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFormDebugSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-form-debug-section',
                template: `
    Sections State : 
    <div *ngFor="let section of formSectionInfo">
      {{section.sectionId}}-{{sectionConfig.title}} : {{section.sectionConfig.sectionType}}<br>
      
      Visible: {{section.visible}}<br>
      Read Only: {{section.readonly}}<br>
    <div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ComponentFactoryResolver }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionStateService }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormSectionStateService }]; }, null); })();
DwComponentFunc({
    key: 'dwFormDebugSection',
    name: 'Devware Form Debug Section',
    componentType: DwComponentType.formSection,
    isGlobal: true,
}, DwFormDebugSectionComponent);

class DwGridStatusInlineEditsActionComponent {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
        this.deletedErrorMessage = 'This row has been marked for deletion';
    }
    setupComponent() {
        var _a, _b, _c, _d, _e;
        this.validationErrorMessage = '';
        this.data = (_a = this.actionContext) === null || _a === void 0 ? void 0 : _a.rowData;
        this.validation = (_c = (_b = this.actionContext) === null || _b === void 0 ? void 0 : _b.rowData) === null || _c === void 0 ? void 0 : _c._validation;
        this.params = (_d = this.actionContext) === null || _d === void 0 ? void 0 : _d.params;
        if (((_e = this.validation) === null || _e === void 0 ? void 0 : _e.isValid) === false) {
            console.log('Row is invalid', this.validation);
            const plural = this.validation.validationErrors.length == 1 ? '' : 's';
            this.validationErrorMessage = `Validation Error${plural}: ${this.validation.validationErrors.join(', ')}`;
        }
    }
    cancelRowEdit() {
        var _a, _b, _c, _d;
        if ((_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b._originalData) {
            this.params.cancelRowEdit((_d = (_c = this.params) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d._originalData);
        }
    }
}
DwGridStatusInlineEditsActionComponent.ɵfac = function DwGridStatusInlineEditsActionComponent_Factory(t) { return new (t || DwGridStatusInlineEditsActionComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataGridNavigationService)); };
DwGridStatusInlineEditsActionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwGridStatusInlineEditsActionComponent, selectors: [["dw-grid-status-inline-edits-action"]], decls: 1, vars: 2, consts: [[1, "dw-icon-grid", "fad", "fa-triangle", "dw-orange", 2, "margin-right", "3px", 3, "hidden", "title"]], template: function DwGridStatusInlineEditsActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "span", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", !ctx.validationErrorMessage)("title", ctx.validationErrorMessage);
    } }, encapsulation: 2 });
DwGridStatusInlineEditsActionComponent.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridStatusInlineEditsActionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-grid-status-inline-edits-action',
                template: ` 
        <span [hidden]="!validationErrorMessage" class="dw-icon-grid fad fa-triangle dw-orange" style="margin-right: 3px" [title]="validationErrorMessage"></span>
    `
            }]
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_StatusInlineRowEdit,
    display: 'Edit Row Status',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.component,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {},
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewMode: DwGridRowActionInlineViewModes.always,
        }
    }
}, DwGridStatusInlineEditsActionComponent);

class DwGridUndoInlineRowEditActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        var _a;
        const params = (_a = actionState.event.actionContext) === null || _a === void 0 ? void 0 : _a.params;
        if (params === null || params === void 0 ? void 0 : params.undoRowEdit) {
            params.undoRowEdit(params.data);
        }
        return of({ success: true });
    }
}
DwGridUndoInlineRowEditActionService.ɵfac = function DwGridUndoInlineRowEditActionService_Factory(t) { return new (t || DwGridUndoInlineRowEditActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridUndoInlineRowEditActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridUndoInlineRowEditActionService, factory: DwGridUndoInlineRowEditActionService.ɵfac });
DwGridUndoInlineRowEditActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridUndoInlineRowEditActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_UndoInlineRowEdit,
    display: 'Undo Row Changes (Inline)',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.service,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {},
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonTitle: 'Undo Row Changes',
        iconClass: 'dw-icon-grid fa fa-undo dw-orange',
        buttonType: DwButtonType.iconOnlyNoText,
    },
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewRule: dwGridDeleteUndoActionRule
        }
    }
}, DwGridUndoInlineRowEditActionService);
DwActionFunc({
    keyName: DwGridActionKeys.gridEdit_UndoDeleteInlineRowEdit,
    display: 'Undo Delete (Inline)',
    actionType: DwActionType.gridRowActionInlineEdit,
    decoratorType: DwDecoratorType.service,
    isGlobal: true,
    allowOnce: true,
    defaultSecurityConfig: {},
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonTitle: 'Undo Delete',
        iconClass: 'dw-icon-grid fa fa-trash-undo dw-orange',
        buttonType: DwButtonType.iconOnlyNoText,
    },
    configData: {
        inlineEditingOptions: {
            inlineRowActionViewRule: dwGridDeleteUndoActionRule
        }
    }
}, DwGridUndoInlineRowEditActionService);
function dwGridUndoActionRule(editingState, data) {
    if (editingState === null || editingState === void 0 ? void 0 : editingState.editing) {
        return false;
    }
    if ((editingState === null || editingState === void 0 ? void 0 : editingState.edited) || (editingState === null || editingState === void 0 ? void 0 : editingState.deleted)) {
        return true;
    }
}
function dwGridDeleteUndoActionRule(editingState, data) {
    if (editingState === null || editingState === void 0 ? void 0 : editingState.editing) {
        return false;
    }
    if ((editingState === null || editingState === void 0 ? void 0 : editingState.edited) || (editingState === null || editingState === void 0 ? void 0 : editingState.deleted)) {
        return true;
    }
}

class DwCardDesignerComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwCardDesignerComponent.ɵfac = function DwCardDesignerComponent_Factory(t) { return new (t || DwCardDesignerComponent)(); };
DwCardDesignerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCardDesignerComponent, selectors: [["dw-dw-card-designer"]], decls: 2, vars: 0, template: function DwCardDesignerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-card-designer works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwCardDesignerComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCardDesignerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-card-designer',
                template: "<p>dw-card-designer works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

class DwCardDesignerConfigComponent {
    constructor() { }
    ngOnInit() {
    }
}
DwCardDesignerConfigComponent.ɵfac = function DwCardDesignerConfigComponent_Factory(t) { return new (t || DwCardDesignerConfigComponent)(); };
DwCardDesignerConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwCardDesignerConfigComponent, selectors: [["dw-dw-card-designer-config"]], decls: 2, vars: 0, template: function DwCardDesignerConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "dw-card-designer-config works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
DwCardDesignerConfigComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwCardDesignerConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-card-designer-config',
                template: "<p>dw-card-designer-config works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

const DATA_VARIABLE_CONTEXT = 'Data_Variable_Context';
class DwDataVariableContext extends DwCustomContextBase {
    constructor(dwSecurityUserService, metadataConfig) {
        super();
        this.dwSecurityUserService = dwSecurityUserService;
        this.metadataConfig = metadataConfig;
    }
    setupContextDefinition(contextDef) {
        // data is populated by the form automatically
        contextDef.data = {};
    }
}
DwDataVariableContext.ɵfac = function DwDataVariableContext_Factory(t) { return new (t || DwDataVariableContext)(ɵngcc0.ɵɵinject(DwSecurityUserService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken)); };
DwDataVariableContext.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwDataVariableContext, factory: DwDataVariableContext.ɵfac });
DwDataVariableContext.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDataVariableContext, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityUserService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }]; }, null); })();
DwCustomContextDefinitionFunc({
    keyName: DATA_VARIABLE_CONTEXT,
    display: 'Variable Context',
    isGlobal: false,
}, DwDataVariableContext);

class DataImportRowGridFormSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwExpressionStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwOrmDataService, dwMetaDataFormStateService, dwFormValidationService, dwMetaDataFormSectionStateService, dwFormStateService, devwareMetaDataService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwFormValidationService = dwFormValidationService;
        this.devwareMetaDataService = devwareMetaDataService;
        this.configKeyPart = 'data-import-row';
        this.setupComplete = false;
        this.formApi = this.dwMetaDataFormStateService.state.formApi;
    }
    ngOnInit() {
        this.runAfterFormDataLoaded(() => {
            this.dataImport = this.formApi.getFormData();
            this.setupGrid();
        });
    }
    setupGrid() {
        if (!this.dataImport.MetaDataItemId) {
            return;
        }
        this.gridPreferences = {
            hideAdd: true,
            gridStyle: {
                gridStyleName: 'Simple',
                gridHeightMode: DwGridHeightMode.fixedHeight,
                gridHeight: '300',
            }
        };
        this.dwMetaDataService.getMetaDataByItemId(this.dataImport.MetaDataItemId).subscribe((metadata) => {
            this.metadata = metadata;
            this.getDataRows();
            // const keyValues = this.dataImport.DwDataImportRow.map(r => r.ReferenceKeyValue);
            // this.filters[keyAttribute.AttributeName] = {
            //   InList: keyValues
            // }
            this.setupComplete = true;
        });
    }
    getDataRows() {
        const query = this.devwareMetaDataService.DwDataImportRow.CreateQuery();
        const qh = new DwQueryHelper();
        query.AddFilterAnd(qh.filters.Equal(this.devwareMetaDataService.DwDataImportRow.DataImportId, this.dataImport.DataImportId));
        this.dwOrmDataService.executeQuery(query).subscribe((rows) => {
            this.setupGridFilter(rows);
        });
    }
    setupGridFilter(rows) {
        const keyAttribute = this.metadata.Attributes.find(a => a.IsKey);
        if (!keyAttribute) {
            return;
        }
        const keyValues = rows.map(r => r.ReferenceKeyValue);
        if (keyValues.length == 0) {
            keyValues.push(-1);
        }
        this.filters = {};
        this.filters[keyAttribute.AttributeName] = {
            In: keyValues
        };
    }
    sectionReadOnlyChanged(readOnly) {
    }
}
DataImportRowGridFormSectionComponent.ɵfac = function DataImportRowGridFormSectionComponent_Factory(t) { return new (t || DataImportRowGridFormSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwExpressionStateService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DevwareMetaDataService)); };
DataImportRowGridFormSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DataImportRowGridFormSectionComponent, selectors: [["dw-data-import-row-grid-form-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "preferences", "item", "configKeyPart", "filters"]], template: function DataImportRowGridFormSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DataImportRowGridFormSectionComponent_ng_container_0_Template, 2, 4, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.setupComplete);
    } }, directives: [ɵngcc4.NgIf, DwMetaDataGridComponent], styles: [""] });
DataImportRowGridFormSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwExpressionStateService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataFormStateService },
    { type: DwMetadataFormValidationBuilderService },
    { type: DwMetaDataFormSectionStateService },
    { type: DwMetaDataFormStateService },
    { type: DevwareMetaDataService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DataImportRowGridFormSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-data-import-row-grid-form-section',
                template: "\r\n<ng-container *ngIf=\"setupComplete\">\r\n    <dw-meta-data-grid [preferences]=\"gridPreferences\" [item]=\"metadata.UniqueItemName\" [configKeyPart]=\"configKeyPart\" [filters]=\"filters\"></dw-meta-data-grid>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwExpressionStateService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataFormStateService }, { type: DwMetadataFormValidationBuilderService }, { type: DwMetaDataFormSectionStateService }, { type: DwMetaDataFormStateService }, { type: DevwareMetaDataService }]; }, null); })();
DwComponentFunc({
    key: 'data-import-row-grid-form-section',
    name: 'Data Import - Row Grid',
    componentType: DwComponentType.formSection,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataImport,
    isGlobal: true
}, DataImportRowGridFormSectionComponent);

class DwGridPasthroughActionService {
    constructor(metaDataGridNavigationService) {
        this.metaDataGridNavigationService = metaDataGridNavigationService;
    }
    handleAction(actionState) {
        // Do nothing action
        return of({
            success: true,
        });
    }
}
DwGridPasthroughActionService.ɵfac = function DwGridPasthroughActionService_Factory(t) { return new (t || DwGridPasthroughActionService)(ɵngcc0.ɵɵinject(DwMetaDataGridNavigationService)); };
DwGridPasthroughActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridPasthroughActionService, factory: DwGridPasthroughActionService.ɵfac });
DwGridPasthroughActionService.ctorParameters = () => [
    { type: DwMetaDataGridNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridPasthroughActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataGridNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwGridActionKeys.gridPassthrough,
    display: 'Passthourgh Action - Grid',
    actionType: DwActionType.gridAction,
    isGlobal: true,
    allowOnce: false,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonClass: 'btn btn-success',
        buttonType: DwButtonType.standard,
    },
    defaultMenuConfig: {
        useMenuDefaults: true,
        useParentDisplay: true,
    },
    defaultSecurityConfig: {}
}, DwGridPasthroughActionService);
DwActionFunc({
    keyName: DwGridActionKeys.gridPassthroughRow,
    display: 'Passthourgh Action - Row',
    actionType: DwActionType.gridRowAction,
    isGlobal: true,
    allowOnce: false,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonClass: 'btn btn-success',
        buttonType: DwButtonType.standard,
    },
    defaultMenuConfig: {
        useMenuDefaults: true,
        useParentDisplay: true,
        itemRequirement: DwActionItemRequirement.multiple,
    },
    defaultSecurityConfig: {},
    configData: {}
}, DwGridPasthroughActionService);

class DwListViewActionService {
    constructor(metaDataRoutingNavigationService) {
        this.metaDataRoutingNavigationService = metaDataRoutingNavigationService;
    }
    handleAction(actionState) {
        const navigationConfig = {
            item: actionState.item,
            addContext: actionState.metaDataListApi.cardContext,
            passCurrentDataSource: false,
            useModal: false,
            data: actionState.data,
            itemDisplayName: actionState.listConfig.itemDisplayName,
        };
        return this.metaDataRoutingNavigationService.openAddEditView(actionState.data, DwMenuActionType.view, navigationConfig)
            .pipe(map(result => {
            const actionResult = {
                success: true
            };
            if (result && result.cancelled) {
                actionResult.cancelled = true;
            }
            return actionResult;
        }));
    }
}
DwListViewActionService.ɵfac = function DwListViewActionService_Factory(t) { return new (t || DwListViewActionService)(ɵngcc0.ɵɵinject(DwMetaDataRoutingNavigationService)); };
DwListViewActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwListViewActionService, factory: DwListViewActionService.ɵfac });
DwListViewActionService.ctorParameters = () => [
    { type: DwMetaDataRoutingNavigationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwListViewActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataRoutingNavigationService }]; }, null); })();
DwActionFunc({
    keyName: DwListActionKeys.listView,
    display: 'View (List)',
    actionType: DwActionType.listItemAction,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'dw-icon-view-grid',
        buttonTitle: 'View',
        buttonType: DwButtonType.iconOnlyNoText,
    },
    defaultMenuConfig: {
        useParentDisplay: true,
        menuIconClass: 'dw-icon-view-grid',
        itemRequirement: DwActionItemRequirement.single
    },
    defaultSecurityConfig: {
        requireCanUpdate: true
    }
}, DwListViewActionService);

class DwColorPickerFieldComponent {
    constructor() {
        this.inputClass = "form-control";
    }
}
DwColorPickerFieldComponent.ɵfac = function DwColorPickerFieldComponent_Factory(t) { return new (t || DwColorPickerFieldComponent)(); };
DwColorPickerFieldComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwColorPickerFieldComponent, selectors: [["dw-color-picker-field"]], inputs: { context: "context" }, decls: 2, vars: 2, consts: [[3, "formGroup"], [3, "formControlName"]], template: function DwColorPickerFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-color-picker", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwColorPickerComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwColorPickerFieldComponent.propDecorators = {
    context: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwColorPickerFieldComponent, [{
        type: Component,
        args: [{
                selector: 'dw-color-picker-field',
                template: `
  <div [formGroup]="formGroup">
    <dw-color-picker [formControlName]="fieldDef?.attrName"></dw-color-picker>
  </div>
`
            }]
    }], function () { return []; }, { context: [{
            type: Input
        }] }); })();
DwComponentFunc({
    key: 'dw-color-picker-field',
    name: 'Color Picker',
    componentType: DwComponentType.formControl,
    isGlobal: true,
}, DwColorPickerFieldComponent);

class DwMetaDataRoutingAppInitHandlerService {
    constructor(injector) {
        this.injector = injector;
    }
    handleAppInit(appInitResult) {
        //console.log('App Init - Routing');
        const mdRoutingRepositoryService = this.injector.get(DwMetaDataRoutingRepositoryService);
        return mdRoutingRepositoryService.setupRepositoryRoutes();
    }
}
DwMetaDataRoutingAppInitHandlerService.ɵfac = function DwMetaDataRoutingAppInitHandlerService_Factory(t) { return new (t || DwMetaDataRoutingAppInitHandlerService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwMetaDataRoutingAppInitHandlerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwMetaDataRoutingAppInitHandlerService, factory: DwMetaDataRoutingAppInitHandlerService.ɵfac });
DwMetaDataRoutingAppInitHandlerService.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataRoutingAppInitHandlerService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class ActionButtonGroupConfigComponent extends DwActionConfigBaseComponent {
    constructor() {
        super();
    }
    addControls() {
        this.addControl('hideCaret');
    }
}
ActionButtonGroupConfigComponent.ɵfac = function ActionButtonGroupConfigComponent_Factory(t) { return new (t || ActionButtonGroupConfigComponent)(); };
ActionButtonGroupConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ActionButtonGroupConfigComponent, selectors: [["dw-action-button-group-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "9"], ["title", "Hides the down arrow to the right of the icon or text", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "hideCaret"]], template: function ActionButtonGroupConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ActionButtonGroupConfigComponent_div_0_Template, 8, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
ActionButtonGroupConfigComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ActionButtonGroupConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-button-group-config',
                template: `
    <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
      <div dwRow>
        <div dwCol="9">
            <label>Hide Caret <i class="fa fa-info-circle" title="Hides the down arrow to the right of the icon or text"></i></label>
        </div>
        <div dwCol="3">
            <p-inputSwitch formControlName="hideCaret"></p-inputSwitch>
        </div>
    </div>
    `
            }]
    }], function () { return []; }, null); })();

class ActionButtonGroupComponent {
    constructor() {
        this.allActionPreferences = [];
        this.showCaret = true;
        this.executeAction = new EventEmitter();
        this.menuItems = [];
    }
    setupComponent() {
        var _a, _b, _c, _d, _e;
        this.showCaret = ((_a = this.actionPreference.actionConfig) === null || _a === void 0 ? void 0 : _a.hideCaret) !== true;
        const startIndex = this.allActionPreferences.indexOf(this.actionPreference);
        for (let i = startIndex + 1; i < this.allActionPreferences.length; i++) {
            const actionPreference = this.allActionPreferences[i];
            // If we hit another action group, stop
            if (actionPreference.actionKey.indexOf('ActionButtonGroup') >= 0) {
                break;
            }
            // Only include buttons that are included in group
            if ((_b = actionPreference.buttonConfig) === null || _b === void 0 ? void 0 : _b.includeInGroup) {
                // Hide the regular button
                // actionPreference.buttonConfig.hidden = true;
                const menuItem = {
                    display: ((_c = actionPreference.buttonConfig) === null || _c === void 0 ? void 0 : _c.buttonText) || actionPreference.actionDisplay,
                    iconClass: (_d = actionPreference.buttonConfig) === null || _d === void 0 ? void 0 : _d.iconClass,
                    data: actionPreference,
                    dividerBefore: (_e = actionPreference.buttonConfig) === null || _e === void 0 ? void 0 : _e.showDividerBefore
                };
                this.menuItems.push(menuItem);
            }
        }
        ;
    }
    ngOnInit() {
    }
    actionClick(menuEvent) {
        const eventData = {
            actionPreference: menuEvent.menuItem.data,
            event: menuEvent.event
        };
        this.executeAction.emit(eventData);
    }
}
ActionButtonGroupComponent.ɵfac = function ActionButtonGroupComponent_Factory(t) { return new (t || ActionButtonGroupComponent)(); };
ActionButtonGroupComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ActionButtonGroupComponent, selectors: [["dw-action-button-group"]], decls: 1, vars: 3, consts: [[3, "buttonConfig", "showCaret", "menuItems", "menuClick"]], template: function ActionButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-button-dropdown", 0);
        ɵngcc0.ɵɵlistener("menuClick", function ActionButtonGroupComponent_Template_dw_button_dropdown_menuClick_0_listener($event) { return ctx.actionClick($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("buttonConfig", ctx.actionPreference == null ? null : ctx.actionPreference.buttonConfig)("showCaret", ctx.showCaret)("menuItems", ctx.menuItems);
    } }, directives: [DwButtonDropdownComponent], styles: [""] });
ActionButtonGroupComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ActionButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-button-group',
                template: "\n\n<dw-button-dropdown [buttonConfig]=\"actionPreference?.buttonConfig\" [showCaret]=\"showCaret\" [menuItems]=\"menuItems\" (menuClick)=\"actionClick($event)\"></dw-button-dropdown>\n\n<!-- <dw-tree-select [hidden]=\"true\"></dw-tree-select>  -->\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
let a = DwActionFunc({
    keyName: 'ActionButtonGroup-Grid',
    display: 'Action Button Group',
    actionType: DwActionType.gridAction,
    decoratorType: DwDecoratorType.component,
    configComponent: ActionButtonGroupConfigComponent,
    isGlobal: true,
    allowOnce: true,
}, ActionButtonGroupComponent);
actionRegList.push(a);
DwActionFunc({
    keyName: 'ActionButtonGroup-Grid_Row',
    display: 'Action Button Group',
    actionType: DwActionType.gridRowAction,
    decoratorType: DwDecoratorType.component,
    configComponent: ActionButtonGroupConfigComponent,
    isGlobal: true,
    allowOnce: true,
}, ActionButtonGroupComponent);

class DevwareUiMetaDataRegistrationService {
    constructor() {
        this.actionRegistration = new DwActionRegistration();
    }
    registerItems() {
        this.actionRegistration.RegisterAction({
            keyName: 'ActionButtonGroup-Grid',
            display: 'Action Button Group',
            actionType: DwActionType.gridAction,
            decoratorType: DwDecoratorType.component,
            configComponent: null,
            isGlobal: true,
            allowOnce: true,
        }, ActionButtonGroupComponent);
    }
    registerActions() {
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerItem(DwUiRegistryType.action, _dwActionGridQuickSearch);
    }
}
DevwareUiMetaDataRegistrationService.ɵfac = function DevwareUiMetaDataRegistrationService_Factory(t) { return new (t || DevwareUiMetaDataRegistrationService)(); };
DevwareUiMetaDataRegistrationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DevwareUiMetaDataRegistrationService, factory: DevwareUiMetaDataRegistrationService.ɵfac });
DevwareUiMetaDataRegistrationService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareUiMetaDataRegistrationService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class DwAggregateFieldControlComponent extends DwControlBaseComponent {
    constructor(dwAggregateFieldService) {
        super();
        this.dwAggregateFieldService = dwAggregateFieldService;
        this.showBasicAggregatesOnly = false;
    }
    ngOnInit() {
        this.setupAggregateList();
    }
    ngOnChanges(changes) {
        this.setupAggregateList();
    }
    setupAggregateList() {
        this.aggregateFieldList = this.dwAggregateFieldService.getAggregateFields();
        if (this.showBasicAggregatesOnly) {
            this.aggregateFieldList = this.aggregateFieldList.filter(x => !this.dwAggregateFieldService.requiresFieldValue(x.value));
        }
    }
}
DwAggregateFieldControlComponent.ɵfac = function DwAggregateFieldControlComponent_Factory(t) { return new (t || DwAggregateFieldControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwAggregateFieldService)); };
DwAggregateFieldControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAggregateFieldControlComponent, selectors: [["dw-aggregate-field-control"]], inputs: { showBasicAggregatesOnly: "showBasicAggregatesOnly" }, features: [ɵngcc0.ɵɵProvidersFeature([{
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => DwAggregateFieldControlComponent),
                multi: true
            }]), ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 8, consts: [["appendTo", "body", 3, "options", "ngModel", "showClear", "optionLabel", "optionValue", "ngModelChange"]], template: function DwAggregateFieldControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dropdown", 0);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAggregateFieldControlComponent_Template_p_dropdown_ngModelChange_0_listener($event) { return ctx.translatedValue = $event; })("ngModelChange", function DwAggregateFieldControlComponent_Template_p_dropdown_ngModelChange_0_listener($event) { return ctx.setTranslatedValue($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(7, _c43));
        ɵngcc0.ɵɵproperty("options", ctx.aggregateFieldList)("ngModel", ctx.translatedValue)("showClear", true)("optionLabel", "display")("optionValue", "value");
    } }, directives: [ɵngcc22.Dropdown, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [""] });
DwAggregateFieldControlComponent.ctorParameters = () => [
    { type: DwAggregateFieldService }
];
DwAggregateFieldControlComponent.propDecorators = {
    showBasicAggregatesOnly: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAggregateFieldControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-aggregate-field-control',
                template: "<p-dropdown [options]=\"aggregateFieldList\" [(ngModel)]=\"translatedValue\" (ngModelChange)=\"setTranslatedValue($event)\" [style]=\"{'width':'100%'}\" [showClear]=\"true\" [optionLabel]=\"'display'\" appendTo=\"body\" [optionValue]=\"'value'\">\n</p-dropdown>",
                providers: [{
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(() => DwAggregateFieldControlComponent),
                        multi: true
                    }],
                styles: [""]
            }]
    }], function () { return [{ type: DwAggregateFieldService }]; }, { showBasicAggregatesOnly: [{
            type: Input
        }] }); })();

class DevwareUIMetaDataModule {
    static forRoot(coreConfig) {
        return {
            ngModule: DevwareUIMetaDataModule,
        };
    }
    static forChild() {
        // Nothing to do here, but want to keep things consistent in case we do later
        return {
            ngModule: DevwareUIMetaDataModule,
            providers: []
        };
    }
}
DevwareUIMetaDataModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareUIMetaDataModule });
DevwareUIMetaDataModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareUIMetaDataModule_Factory(t) { return new (t || DevwareUIMetaDataModule)(); }, providers: [
        DwGridColumnDefaultRendererService,
        DwGridColumnBooleanRendererService,
        DwGridColumnLinkRendererService,
        DwMetaDataGridService,
        DwMetaDataFormService,
        DwMetaDataRoutingService,
        DwContextDefaultsService,
        DwContextService,
        DwUiMetadataRegistrationService,
        DwMdEventHandlerOrchestratorService,
        DwListRouteProcessor,
        DwMenuRouteProcessor,
        DwComponentRouteProcessor,
        DwActionRouteProcessor,
        DwItemRouteProcessor,
        DwRouteActionInternalLinkService,
        DwRouteActionExternalLinkService,
        DwOpenItemModalActionService,
        DwGridAddActionService,
        DwGridEditActionService,
        DwGridViewActionService,
        DwGridPrintActionSerivce,
        DwGridDeleteActionService,
        DwGridRefreshActionService,
        DwGridFilterToggleActionService,
        DwGridExportActionService,
        DwGridSetValueActionService,
        DwGridMultiEditActionService,
        DwGridCopyActionService,
        DwGridToggleValueActionService,
        DwFormSaveActionService,
        DwFormPrintActionService,
        DwFormCloseActionService,
        DwFormCancelActionService,
        DwUserContextService,
        DwMetaDataFormContextService,
        DwListAddActionService,
        DwListFilterToggleActionService,
        DwListRefreshActionService,
        DwListEditActionService,
        DwListViewActionService,
        DwParentFilterService,
        DwFilterTileService,
        DwAggregateTileFilterBuilderService,
        DwBasicTileFilterBuilderService,
        DwDateTimeContextService,
        DwGridSetValuesActionService,
        DwMetaDataGridContextService,
        DwGridCountValidationRule,
        DwEnvironmentContextService,
        DwFormMultiCreateActionService,
        DwFormSetValuesActionService,
        DwMultiSelectFilterService,
        DwGridStartInlineEditsActionService,
        DwGridCancelInlineEditsActionService,
        DwGridSaveInlineEditsActionService,
        DwGridDeleteInlineRowEditActionService,
        DwGridStartEditInlineEditsActionService,
        DwGridCompleteEditInlineEditsActionService,
        DwGridCancelInlineRowEditActionService,
        DwGridUndoInlineRowEditActionService,
        DwGridPasthroughActionService,
        DwDataVariableContext,
        DevwareUiMetaDataRegistrationService,
        {
            provide: DwMenuProcessorToken,
            useClass: DwMenuExpressionProcessorService,
            multi: true
        },
        {
            provide: DwUIMetaDataConfigToken,
            useFactory(configService) {
                const uiMetaDataConfig = configService.getConfig(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
                return uiMetaDataConfig;
            },
            deps: [DwConfigServiceToken, DwMdEventHandlerOrchestratorService]
        },
        {
            provide: DwAppInitHandlerToken,
            useClass: DwMetaDataRoutingAppInitHandlerService,
            multi: true
        },
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            TabViewModule,
            DevwareCoreModule,
            DevwareUIModule,
            DevwareUILayoutModule,
            DevwareOrmModule,
            RouterModule,
            ReactiveFormsModule,
            InputSwitchModule,
            InputTextModule,
            CalendarModule,
            DropdownModule,
            RadioButtonModule,
            AccordionModule,
            ListboxModule,
            TreeModule,
            ContextMenuModule,
            MenuModule,
            OrderListModule,
            MultiSelectModule,
            AutoCompleteModule,
            OverlayPanelModule,
            DragDropModule,
            SplitterModule,
            BsDropdownModule
            // QuillModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareUIMetaDataModule, { declarations: function () { return [DwMetaDataGridComponent, DwMetaDataGridConfigWidgetComponent, DwMetaDataFormComponent, DwFormControlInputComponent, DwFormControlInputReadOnlyComponent, DwFormControlNumericInputComponent, DwFormControlNumericInputReadOnlyComponent, DwFormControlInputConfigComponent, DwHtmlEditControlConfigComponent, DwFormControlLookupComponent, DwFormControlMultiSelectLookupComponent, DwFormControlLookupReadOnlyComponent, DwAutoCompleteLookupReadOnlyComponent, DwFormControlAutoCompleteLookupReadOnlyComponent, DwFormControlDateComponent, DwFormControlDateTimeComponent, DwFormControlTimeComponent, DwFormControlDate2Component, DwFormControlDateTime2Component, DwFormControlTime2Component, DwFormControlInputSwitchComponent, DwFormControlTextAreaComponent, DwFormControlHtmlEditorComponent, DwFormControlReadOnlyComponent, DwDynamicFieldDirective, DwDynamicFieldComponent, DwDynamicFieldHorizontalComponent, DwDefaultFormPage, DwDefaultGridPage, DwDynamicSectionComponent, DwFormSectionComponent, DwMetadataFormConfigWidgetComponent, DwMetadataFormConfigFieldsComponent, DwTabStripSectionComponent, DwTabSectionComponent, DwContainerSectionComponent, DwAssociativeListComponent, DwAssociativeListSectionComponent, DynamicRoutingInitComponent, DwMetadataListComponent, DwMetaDataListConfigWidgetComponent, DwMetadataListBasicComponent, DwMetaDataListConfigBasicWidgetComponent, DwMetadataFiltersComponent, DwMetadataConfigFiltersComponent, DwSelectLookupComponent, DwFormControlLookupReadOnlyComponent, DwAutoCompleteLookupReadOnlyComponent, DwFormControlHtmlReadOnlyComponent, DwMetadataSectionConfigComponent, DwFormControlInputYesNoComponent, DwMdSectionFormConfigComponent, DwMdSectionStandardConfigComponent, DwMdSectionTabStripConfigComponent, DwMdSectionTabConfigComponent, DwMdSectionContainerConfigComponent, DwMdSectionAssociativeListConfigComponent, DwMdSectionComponentConfigComponent, DwMdSectionGridConfigComponent, DwGridSectionComponent, DwExpressionControlComponent, DwExpressionGroupControlComponent, DwExpressionReferenceControlComponent, DwMdChildDataSectionConfigComponent, DwChildDataSectionComponent, DwMdSectionPreviewComponent, DwMdSectionFormFieldConfigComponent, DwExpressionBracketComponent, DwMetadataSectionConfigComponent, DwDynamicControlComponent, DwSearchSelectLookupComponent, DwFormControlUrlReadOnlyComponent, DwFormControlSearchLookupComponent, DwLookupReadonlyComponent, DwAutoCompleteLookupComponent, DwFormControlAutoCompleteLookupComponent, DwFormControlAutoCompleteServerLookupComponent, DwContentManagerComponent, DwContentComponent, DwContentDirective, DwContentConfigWidgetComponent, DwContentConfigEditComponent, DwWorkflowLookupButtonsComponent, DwMetadataFormWorkflowConfigComponent, DwEmailTemplateConfigComponent, DwEmailTemplateFieldsComponent, DwEmailTemplateRecipientConfigComponent, DwEmailTemplateTriggerConfigComponent, DwFaqsComponent, DwRuleConfigComponent, DwMetadataGridConfigColumnsModalComponent, DwQueryEditorFieldsComponent, DwQueryEditorContainerComponent, DwQueryPanelFactoryComponent, DwQueryPanelSettingsComponent, DwQueryPanelRelationComponent, DwQueryPanelRootComponent, DwQueryEditorAddRelationComponent, DwQueryRelationSettingsComponent, DwQueryEditorFiltersComponent, DwQuerySectionComponent, DwQueryEditorSortComponent, DwMetadataGridConfigViewsComponent, DwEventConfigComponent, DwEventTriggerComponent, DwFormControlCalcFieldComponent, DwFormControlCalcFieldConfigComponent, DwFormControlCalcFieldTesterComponent, DwFormControlDateFieldConfigComponent, DwTextSectionComponent, DwMdSectionTextConfigComponent, DwMultiSelectLookupComponent, DwFormControlAutoCompleteLookupConfigComponent, DwFormControlMultiSelectAdhocConfigComponent, DwMetadataConfigFiltersModalComponent, DwMetadataGridConfigColumnsComponent, DwAllTextFieldsCustomFilterComponent, DwFaqsConfigComponent, DwContentConfigComponentComponent, DwRouteBaseConfigComponent, DwListRouteConfigComponent, DwComponentRouteConfigComponent, DwRouteBaseConfigComponent, DwActionRouteConfigComponent, DwRouteActionExternalLinkConfigComponent, DwRouteActionInternalLinkConfigComponent, DwItemRouteConfigComponent, DwMetadataGridActionsConfigComponent, DwGridSetValueActionConfigComponent, DwFormControlTextAreaConfigComponent, DwSelectRouteComponent, DwMetadataGridConfigColumnComponent, DwDateRangeFilterComponent, DwGridMultiEditModalComponent, DwGridMultiEditConfigComponent, DwDefaultValueComponent, DwDateRangeFilterComponent, DwGridToggleValueActionConfigComponent, DwFormButtonsSectionComponent, DwFormButtonsConfigComponent, DwFormWorkflowButtonsActionComponent, DwFormWorkflowButtonsConfigComponent, DwFormActionConfigDefaultComponent, DwSelectLookupConfigComponent, DwExpressionVisibilityConfigComponent, DwExpressionPickerControlComponent, DwFieldValidationConfigComponent, DwMdChildDataRepeaterSectionComponent, DwMdChildDataRepeaterSectionConfigComponent, DwMenuRouteConfigComponent, DwMdPageMenuComponent, DefaultMenuPageComponent, DwRadioLookupComponent, DwFormControlRadioLookupComponent, DwViewEditSectionComponent, DwViewEditSectionConfigComponent, DwDefaultListPageComponent, DwMultiSelectAdhocComponent, DwMultiSelectAdhocReadOnlyComponent, DwFormControlMulitSelectAdhocComponent, DwFormControlMulitSelectAdhocReadOnlyComponent, DwFieldSelectionComponent, DwConditionalFieldClassesComponent, DwGridColumnActionButtonsComponent, DwGridColumnBooleanConfigComponent, DwGridColumnImageComponent, DwGridColumnImageConfigComponent, DwAssociativeLookupFilterComponent, DwAssociativeLookupFilterConfigComponent, DwAdhocLookupFilterComponent, DwAdhocLookupFilterConfigComponent, DwMultiSelectLookupFilterComponent, DwMetadataListConfigComponent, DwCardConfigComponent, DwCardDefaultComponent, DwMetadataListActionsConfigComponent, DwListToggleViewActionComponent, DwRouteChildMenuConfigComponent, DwParentFilterComponent, DwParentFilterConfigComponent, DwGridColumnTemplateComponent, DwGridColumnTemplateConfigComponent, DwMultiSelectFilterConfigComponent, DwQuickGrid, DwQueryPanelTestComponent, DwMetadataFilterTilesConfigComponent, DwBasicTileComponent, DwAggregateTileComponent, DwMetadataFilterTilesComponent, DwAggregateTileConfigComponent, DwAdvancedFilterComponent, DwBasicTileConfigComponent, DwLookupTileComponent, DwLookupTileConfigComponent, DwPageDesignerComponent, DwEmailTemplateDesignerComponent, DwEmailTemplateRootSectionComponent, DwEmailContainerSectionComponent, DwEmailTextSectionComponent, DwPageDesignerSectionWrapperComponent, DwEmailTextSectionConfigComponent, DwPageDesignerToolbarComponent, DwPageDesignerConfigPanelComponent, DwEmailTemplateDividerSectionComponent, DwPageDesignerContainerComponent, DwEmailContainerSectionConfigComponent, DwOrderedListComponent, DwSectionConfigPanelComponent, DwDataConfigPanelComponent, DwConfigPanelHostComponent, DwFormeventsConfigPanelComponent, DwDataConfigComponent, DwGridSetValuesActionConfigComponent, DwCardDefaultConfigComponent, DwSecurityConfigPanelComponent, DwFormControlInputYesNoDropdownComponent, DwExportConfigComponent, DwGridCopyModalComponent, DwGridCopyConfigComponent, DwEmailTemplateComponent, DwFormPrintConfigComponent, DwDependencyViewComponent, DwFormPrintConfigComponent, DwDataVariableListConfigComponent, DwDataVariableEditConfigComponent, DwContextDefMultiSelectComponent, DwDatasourceSelectComponent, DwGridActionNavConfigComponent, DwOpenModalActionConfigComponent, DwFormControlMultiSelectDateComponent, DwTitleTemplatesConfigComponent, DwTemplateViewControlComponent, DwTemplateConfigControlComponent, DwFormMultiCreateConfigComponent, DwFormSetValuesConfigComponent, DwAllTextFieldsCustomFilterConfigComponent, DwGridQuickSearchActionComponent, DwGridQuickSearchConfigComponent, DwMetadataFiltersVerticalComponent, DwStandardFilterComponent, DwGridCardListComponent, DwListQuickSearchActionComponent, DwListQuickSearchConfigComponent, DwQueryEditorFieldsAdvancedComponent, DwAggregateFieldSelectionComponent, DwAggregateFieldConfigComponent, DwChildRollupFieldConfigComponent, DwRelationSelectComponent, DwJsonFieldConfigComponent, DwTemplateFieldConfigComponent, DwGridEditConfigComponent, DwTemplateFieldConfigComponent, DwGridCardListComponent, DwFormSetValuesConfigComponent, DwDesignerSelector, DwMdSectionFormFieldsConfigComponent, DwMetadataFormDebugWidgetComponent, DwFormControlLookupConfigComponent, DwQueryEditorFixRelationComponent, DwFormDebugSectionComponent, DwGridStatusInlineEditsActionComponent, DwMetadataGridActionsRowConfigComponent, DwCardDesignerComponent, DwCardDesignerConfigComponent, DwFormSaveConfigComponent, DataImportRowGridFormSectionComponent, DwColorPickerFieldComponent, ActionButtonGroupComponent, DwAggregateFieldControlComponent, ActionButtonGroupConfigComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        TabViewModule, DevwareCoreModule, DevwareUIModule, DevwareUILayoutModule, DevwareOrmModule, RouterModule,
        ReactiveFormsModule,
        InputSwitchModule,
        InputTextModule,
        CalendarModule,
        DropdownModule,
        RadioButtonModule,
        AccordionModule,
        ListboxModule,
        TreeModule,
        ContextMenuModule,
        MenuModule,
        OrderListModule,
        MultiSelectModule,
        AutoCompleteModule,
        OverlayPanelModule,
        DragDropModule,
        SplitterModule,
        BsDropdownModule
        // QuillModule
    ]; }, exports: function () { return [DwMetaDataGridComponent, DwMetaDataGridConfigWidgetComponent, DwQuickGrid, DwMetaDataFormComponent, DwDynamicFieldComponent, DwDynamicFieldHorizontalComponent, DwDefaultFormPage, DwDefaultGridPage, DwMetadataFormConfigFieldsComponent, DwAssociativeListComponent, DynamicRoutingInitComponent, DwMetadataListComponent, DwMetadataListBasicComponent, DwMetadataFiltersComponent, DwMetadataConfigFiltersComponent, DwFormControlHtmlReadOnlyComponent, DwMetadataSectionConfigComponent, DwFormControlInputYesNoComponent, DwExpressionControlComponent, DwExpressionGroupControlComponent, DwExpressionBracketComponent, DwExpressionReferenceControlComponent, DwSelectLookupComponent, DwSearchSelectLookupComponent, DwFormControlUrlReadOnlyComponent, DwFormControlSearchLookupComponent, DwAutoCompleteLookupComponent, DwFormControlAutoCompleteLookupComponent, DwFormControlLookupReadOnlyComponent, DwAutoCompleteLookupReadOnlyComponent, DwFormControlAutoCompleteServerLookupComponent, DwRadioLookupComponent, DwMultiSelectAdhocComponent, DwContentManagerComponent, DwContentComponent, DwContentDirective, DwContentConfigWidgetComponent, DwContentConfigEditComponent, DwWorkflowLookupButtonsComponent, DwEmailTemplateConfigComponent, DwEmailTemplateFieldsComponent, DwQueryEditorContainerComponent, DwQuerySectionComponent, DwEventConfigComponent, DwFormControlCalcFieldComponent, DwLookupReadonlyComponent, DwMultiSelectLookupComponent, DwFormControlAutoCompleteLookupConfigComponent, DwFormControlMultiSelectAdhocConfigComponent, DwMdSectionStandardConfigComponent, DwDynamicSectionComponent, DwFormControlInputConfigComponent, DwHtmlEditControlConfigComponent, DwFormControlInputReadOnlyComponent, DwFormControlNumericInputComponent, DwFormControlNumericInputReadOnlyComponent, DwMetadataConfigFiltersModalComponent, DwRouteBaseConfigComponent, DwListRouteConfigComponent, DwSelectRouteComponent, DwFormWorkflowButtonsActionComponent, DwFormWorkflowButtonsConfigComponent, DwExpressionPickerControlComponent, DwMultiSelectAdhocComponent, DwMultiSelectAdhocReadOnlyComponent, DwRouteChildMenuConfigComponent, DwMetadataFilterTilesConfigComponent, DwPageDesignerComponent, DwEmailTemplateDesignerComponent, DwEmailContainerSectionComponent, DwOrderedListComponent, DwFieldValidationConfigComponent, DwFormControlMultiSelectDateComponent, DwConditionalFieldClassesComponent, DwListQuickSearchActionComponent, DwListQuickSearchConfigComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareUIMetaDataModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwMetaDataGridComponent,
                    DwMetaDataGridConfigWidgetComponent,
                    DwMetaDataFormComponent,
                    DwFormControlInputComponent,
                    DwFormControlInputReadOnlyComponent,
                    DwFormControlNumericInputComponent,
                    DwFormControlNumericInputReadOnlyComponent,
                    DwFormControlInputConfigComponent,
                    DwHtmlEditControlConfigComponent,
                    DwFormControlLookupComponent,
                    DwFormControlMultiSelectLookupComponent,
                    DwFormControlLookupReadOnlyComponent,
                    DwAutoCompleteLookupReadOnlyComponent,
                    DwFormControlAutoCompleteLookupReadOnlyComponent,
                    DwFormControlDateComponent,
                    DwFormControlDateTimeComponent,
                    DwFormControlTimeComponent,
                    DwFormControlDate2Component,
                    DwFormControlDateTime2Component,
                    DwFormControlTime2Component,
                    DwFormControlInputSwitchComponent,
                    DwFormControlTextAreaComponent,
                    DwFormControlHtmlEditorComponent,
                    DwFormControlReadOnlyComponent,
                    DwDynamicFieldDirective,
                    DwDynamicFieldComponent,
                    DwDynamicFieldHorizontalComponent,
                    DwDefaultFormPage,
                    DwDefaultGridPage,
                    DwDynamicSectionComponent,
                    DwFormSectionComponent,
                    DwMetadataFormConfigWidgetComponent,
                    DwMetadataFormConfigFieldsComponent,
                    DwTabStripSectionComponent,
                    DwTabSectionComponent,
                    DwContainerSectionComponent,
                    DwAssociativeListComponent,
                    DwAssociativeListSectionComponent,
                    DynamicRoutingInitComponent,
                    DwMetadataListComponent,
                    DwMetaDataListConfigWidgetComponent,
                    DwMetadataListBasicComponent,
                    DwMetaDataListConfigBasicWidgetComponent,
                    DwMetadataFiltersComponent,
                    DwMetadataConfigFiltersComponent,
                    DwSelectLookupComponent,
                    DwFormControlLookupReadOnlyComponent,
                    DwAutoCompleteLookupReadOnlyComponent,
                    DwFormControlHtmlReadOnlyComponent,
                    DwMetadataSectionConfigComponent,
                    DwFormControlInputYesNoComponent,
                    DwMdSectionFormConfigComponent,
                    DwMdSectionStandardConfigComponent,
                    DwMdSectionTabStripConfigComponent,
                    DwMdSectionTabConfigComponent,
                    DwMdSectionContainerConfigComponent,
                    DwMdSectionAssociativeListConfigComponent,
                    DwMdSectionComponentConfigComponent,
                    DwMdSectionGridConfigComponent,
                    DwGridSectionComponent,
                    DwExpressionControlComponent,
                    DwExpressionGroupControlComponent,
                    DwExpressionReferenceControlComponent,
                    DwMdChildDataSectionConfigComponent,
                    DwChildDataSectionComponent,
                    DwMdSectionPreviewComponent,
                    DwMdSectionFormFieldConfigComponent,
                    DwExpressionBracketComponent,
                    DwMetadataSectionConfigComponent,
                    DwDynamicControlComponent,
                    DwSearchSelectLookupComponent,
                    DwFormControlUrlReadOnlyComponent,
                    DwFormControlSearchLookupComponent,
                    DwLookupReadonlyComponent,
                    DwAutoCompleteLookupComponent,
                    DwFormControlAutoCompleteLookupComponent,
                    DwFormControlAutoCompleteServerLookupComponent,
                    DwContentManagerComponent,
                    DwContentComponent,
                    DwContentDirective,
                    DwContentConfigWidgetComponent,
                    DwContentConfigEditComponent,
                    DwWorkflowLookupButtonsComponent,
                    DwMetadataFormWorkflowConfigComponent,
                    DwEmailTemplateConfigComponent,
                    DwEmailTemplateFieldsComponent,
                    DwEmailTemplateRecipientConfigComponent,
                    DwEmailTemplateTriggerConfigComponent,
                    DwFaqsComponent,
                    DwRuleConfigComponent,
                    DwMetadataGridConfigColumnsModalComponent,
                    DwQueryEditorFieldsComponent,
                    DwQueryEditorContainerComponent,
                    DwQueryPanelFactoryComponent,
                    DwQueryPanelSettingsComponent,
                    DwQueryPanelRelationComponent,
                    DwQueryPanelRootComponent,
                    DwQueryEditorAddRelationComponent,
                    DwQueryRelationSettingsComponent,
                    DwQueryEditorFiltersComponent,
                    DwQuerySectionComponent,
                    DwQueryEditorSortComponent,
                    DwMetadataGridConfigViewsComponent,
                    DwEventConfigComponent,
                    DwEventTriggerComponent,
                    DwFormControlCalcFieldComponent,
                    DwFormControlCalcFieldConfigComponent,
                    DwFormControlCalcFieldTesterComponent,
                    DwFormControlDateFieldConfigComponent,
                    DwTextSectionComponent,
                    DwMdSectionTextConfigComponent,
                    DwMultiSelectLookupComponent,
                    DwFormControlAutoCompleteLookupConfigComponent,
                    DwFormControlMultiSelectAdhocConfigComponent,
                    DwMetadataConfigFiltersModalComponent,
                    DwMetadataGridConfigColumnsComponent,
                    DwAllTextFieldsCustomFilterComponent,
                    DwFaqsConfigComponent,
                    DwContentConfigComponentComponent,
                    DwRouteBaseConfigComponent,
                    DwListRouteConfigComponent,
                    DwComponentRouteConfigComponent,
                    DwRouteBaseConfigComponent,
                    DwActionRouteConfigComponent,
                    DwRouteActionExternalLinkConfigComponent,
                    DwRouteActionInternalLinkConfigComponent,
                    DwItemRouteConfigComponent,
                    DwMetadataGridActionsConfigComponent,
                    DwGridSetValueActionConfigComponent,
                    DwFormControlTextAreaConfigComponent,
                    DwSelectRouteComponent,
                    DwMetadataGridConfigColumnComponent,
                    DwDateRangeFilterComponent,
                    DwGridMultiEditModalComponent,
                    DwGridMultiEditConfigComponent,
                    DwDefaultValueComponent,
                    DwDateRangeFilterComponent,
                    DwGridToggleValueActionConfigComponent,
                    DwFormButtonsSectionComponent,
                    DwFormButtonsConfigComponent,
                    DwFormWorkflowButtonsActionComponent,
                    DwFormWorkflowButtonsConfigComponent,
                    DwFormActionConfigDefaultComponent,
                    DwSelectLookupConfigComponent,
                    DwExpressionVisibilityConfigComponent,
                    DwExpressionPickerControlComponent,
                    DwFieldValidationConfigComponent,
                    DwMdChildDataRepeaterSectionComponent,
                    DwMdChildDataRepeaterSectionConfigComponent,
                    DwMenuRouteConfigComponent,
                    DwMdPageMenuComponent,
                    DefaultMenuPageComponent,
                    DwRadioLookupComponent,
                    DwFormControlRadioLookupComponent,
                    DwViewEditSectionComponent,
                    DwViewEditSectionConfigComponent,
                    DwDefaultListPageComponent,
                    DwMultiSelectAdhocComponent,
                    DwMultiSelectAdhocReadOnlyComponent,
                    DwFormControlMulitSelectAdhocComponent,
                    DwFormControlMulitSelectAdhocReadOnlyComponent,
                    DwFieldSelectionComponent,
                    DwConditionalFieldClassesComponent,
                    DwGridColumnActionButtonsComponent,
                    DwGridColumnBooleanConfigComponent,
                    DwGridColumnImageComponent,
                    DwGridColumnImageConfigComponent,
                    DwAssociativeLookupFilterComponent,
                    DwAssociativeLookupFilterConfigComponent,
                    DwAdhocLookupFilterComponent,
                    DwAdhocLookupFilterConfigComponent,
                    DwMultiSelectLookupFilterComponent,
                    DwMetadataListConfigComponent,
                    DwCardConfigComponent,
                    DwCardDefaultComponent,
                    DwMetadataListActionsConfigComponent,
                    DwListToggleViewActionComponent,
                    DwRouteChildMenuConfigComponent,
                    DwParentFilterComponent,
                    DwParentFilterConfigComponent,
                    DwGridColumnTemplateComponent,
                    DwGridColumnTemplateConfigComponent,
                    DwMultiSelectFilterConfigComponent,
                    DwQuickGrid,
                    DwQueryPanelTestComponent,
                    DwMetadataFilterTilesConfigComponent,
                    DwBasicTileComponent,
                    DwAggregateTileComponent,
                    DwMetadataFilterTilesComponent,
                    DwAggregateTileConfigComponent,
                    DwAdvancedFilterComponent,
                    DwBasicTileConfigComponent,
                    DwLookupTileComponent,
                    DwLookupTileConfigComponent,
                    DwPageDesignerComponent,
                    DwEmailTemplateDesignerComponent,
                    DwEmailTemplateRootSectionComponent,
                    DwEmailContainerSectionComponent,
                    DwEmailTextSectionComponent,
                    DwPageDesignerSectionWrapperComponent,
                    DwEmailTextSectionConfigComponent,
                    DwPageDesignerToolbarComponent,
                    DwPageDesignerConfigPanelComponent,
                    DwEmailTemplateDividerSectionComponent,
                    DwPageDesignerContainerComponent,
                    DwEmailContainerSectionConfigComponent,
                    DwOrderedListComponent,
                    DwSectionConfigPanelComponent,
                    DwDataConfigPanelComponent,
                    DwConfigPanelHostComponent,
                    DwFormeventsConfigPanelComponent,
                    DwDataConfigComponent,
                    DwGridSetValuesActionConfigComponent,
                    DwCardDefaultConfigComponent,
                    DwSecurityConfigPanelComponent,
                    DwFormControlInputYesNoDropdownComponent,
                    DwExportConfigComponent,
                    DwGridCopyModalComponent,
                    DwGridCopyConfigComponent,
                    DwEmailTemplateComponent,
                    DwFormPrintConfigComponent,
                    DwDependencyViewComponent,
                    DwFormPrintConfigComponent,
                    DwDataVariableListConfigComponent,
                    DwDataVariableEditConfigComponent,
                    DwContextDefMultiSelectComponent,
                    DwDatasourceSelectComponent,
                    DwGridActionNavConfigComponent,
                    DwOpenModalActionConfigComponent,
                    DwFormControlMultiSelectDateComponent,
                    DwTitleTemplatesConfigComponent,
                    DwTemplateViewControlComponent,
                    DwTemplateConfigControlComponent,
                    DwFormMultiCreateConfigComponent,
                    DwFormSetValuesConfigComponent,
                    DwAllTextFieldsCustomFilterConfigComponent,
                    DwGridQuickSearchActionComponent,
                    DwGridQuickSearchConfigComponent,
                    DwMetadataFiltersVerticalComponent,
                    DwStandardFilterComponent,
                    DwGridCardListComponent,
                    DwListQuickSearchActionComponent,
                    DwListQuickSearchConfigComponent,
                    DwQueryEditorFieldsAdvancedComponent,
                    DwAggregateFieldSelectionComponent,
                    DwAggregateFieldConfigComponent,
                    DwChildRollupFieldConfigComponent,
                    DwRelationSelectComponent,
                    DwJsonFieldConfigComponent,
                    DwTemplateFieldConfigComponent,
                    DwGridEditConfigComponent,
                    DwTemplateFieldConfigComponent,
                    DwGridCardListComponent,
                    DwFormSetValuesConfigComponent,
                    DwDesignerSelector,
                    DwMdSectionFormFieldsConfigComponent,
                    DwMetadataFormDebugWidgetComponent,
                    DwFormControlLookupConfigComponent,
                    DwQueryEditorFixRelationComponent,
                    DwFormDebugSectionComponent,
                    DwGridStatusInlineEditsActionComponent,
                    DwMetadataGridActionsRowConfigComponent,
                    DwCardDesignerComponent,
                    DwCardDesignerConfigComponent,
                    DwFormSaveConfigComponent,
                    DataImportRowGridFormSectionComponent,
                    DwColorPickerFieldComponent,
                    ActionButtonGroupComponent,
                    DwAggregateFieldControlComponent,
                    ActionButtonGroupConfigComponent,
                ],
                providers: [
                    DwGridColumnDefaultRendererService,
                    DwGridColumnBooleanRendererService,
                    DwGridColumnLinkRendererService,
                    DwMetaDataGridService,
                    DwMetaDataFormService,
                    DwMetaDataRoutingService,
                    DwContextDefaultsService,
                    DwContextService,
                    DwUiMetadataRegistrationService,
                    DwMdEventHandlerOrchestratorService,
                    DwListRouteProcessor,
                    DwMenuRouteProcessor,
                    DwComponentRouteProcessor,
                    DwActionRouteProcessor,
                    DwItemRouteProcessor,
                    DwRouteActionInternalLinkService,
                    DwRouteActionExternalLinkService,
                    DwOpenItemModalActionService,
                    DwGridAddActionService,
                    DwGridEditActionService,
                    DwGridViewActionService,
                    DwGridPrintActionSerivce,
                    DwGridDeleteActionService,
                    DwGridRefreshActionService,
                    DwGridFilterToggleActionService,
                    DwGridExportActionService,
                    DwGridSetValueActionService,
                    DwGridMultiEditActionService,
                    DwGridCopyActionService,
                    DwGridToggleValueActionService,
                    DwFormSaveActionService,
                    DwFormPrintActionService,
                    DwFormCloseActionService,
                    DwFormCancelActionService,
                    DwUserContextService,
                    DwMetaDataFormContextService,
                    DwListAddActionService,
                    DwListFilterToggleActionService,
                    DwListRefreshActionService,
                    DwListEditActionService,
                    DwListViewActionService,
                    DwParentFilterService,
                    DwFilterTileService,
                    DwAggregateTileFilterBuilderService,
                    DwBasicTileFilterBuilderService,
                    DwDateTimeContextService,
                    DwGridSetValuesActionService,
                    DwMetaDataGridContextService,
                    DwGridCountValidationRule,
                    DwEnvironmentContextService,
                    DwFormMultiCreateActionService,
                    DwFormSetValuesActionService,
                    DwMultiSelectFilterService,
                    DwGridStartInlineEditsActionService,
                    DwGridCancelInlineEditsActionService,
                    DwGridSaveInlineEditsActionService,
                    DwGridDeleteInlineRowEditActionService,
                    DwGridStartEditInlineEditsActionService,
                    DwGridCompleteEditInlineEditsActionService,
                    DwGridCancelInlineRowEditActionService,
                    DwGridUndoInlineRowEditActionService,
                    DwGridPasthroughActionService,
                    DwDataVariableContext,
                    DevwareUiMetaDataRegistrationService,
                    {
                        provide: DwMenuProcessorToken,
                        useClass: DwMenuExpressionProcessorService,
                        multi: true
                    },
                    {
                        provide: DwUIMetaDataConfigToken,
                        useFactory(configService) {
                            const uiMetaDataConfig = configService.getConfig(DwUIMetaDataConfigDefaults.configName, new DwUIMetaDataConfigDefaults());
                            return uiMetaDataConfig;
                        },
                        deps: [DwConfigServiceToken, DwMdEventHandlerOrchestratorService]
                    },
                    {
                        provide: DwAppInitHandlerToken,
                        useClass: DwMetaDataRoutingAppInitHandlerService,
                        multi: true
                    },
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    TabViewModule,
                    DevwareCoreModule,
                    DevwareUIModule,
                    DevwareUILayoutModule,
                    DevwareOrmModule,
                    RouterModule,
                    ReactiveFormsModule,
                    InputSwitchModule,
                    InputTextModule,
                    CalendarModule,
                    DropdownModule,
                    RadioButtonModule,
                    AccordionModule,
                    ListboxModule,
                    TreeModule,
                    ContextMenuModule,
                    MenuModule,
                    OrderListModule,
                    MultiSelectModule,
                    AutoCompleteModule,
                    OverlayPanelModule,
                    DragDropModule,
                    SplitterModule,
                    BsDropdownModule
                    // QuillModule
                ],
                exports: [
                    DwMetaDataGridComponent,
                    DwMetaDataGridConfigWidgetComponent,
                    DwQuickGrid,
                    DwMetaDataFormComponent,
                    DwDynamicFieldComponent,
                    DwDynamicFieldHorizontalComponent,
                    DwDefaultFormPage,
                    DwDefaultGridPage,
                    DwMetadataFormConfigFieldsComponent,
                    DwAssociativeListComponent,
                    DynamicRoutingInitComponent,
                    DwMetadataListComponent,
                    DwMetadataListBasicComponent,
                    DwMetadataFiltersComponent,
                    DwMetadataConfigFiltersComponent,
                    DwFormControlHtmlReadOnlyComponent,
                    DwMetadataSectionConfigComponent,
                    DwFormControlInputYesNoComponent,
                    DwExpressionControlComponent,
                    DwExpressionGroupControlComponent,
                    DwExpressionBracketComponent,
                    DwExpressionReferenceControlComponent,
                    DwSelectLookupComponent,
                    DwSearchSelectLookupComponent,
                    DwFormControlUrlReadOnlyComponent,
                    DwFormControlSearchLookupComponent,
                    DwAutoCompleteLookupComponent,
                    DwFormControlAutoCompleteLookupComponent,
                    DwFormControlLookupReadOnlyComponent,
                    DwAutoCompleteLookupReadOnlyComponent,
                    DwFormControlAutoCompleteServerLookupComponent,
                    DwRadioLookupComponent,
                    DwMultiSelectAdhocComponent,
                    DwContentManagerComponent,
                    DwContentComponent,
                    DwContentDirective,
                    DwContentConfigWidgetComponent,
                    DwContentConfigEditComponent,
                    DwWorkflowLookupButtonsComponent,
                    DwEmailTemplateConfigComponent,
                    DwEmailTemplateFieldsComponent,
                    DwQueryEditorContainerComponent,
                    DwQuerySectionComponent,
                    DwEventConfigComponent,
                    DwFormControlCalcFieldComponent,
                    DwLookupReadonlyComponent,
                    DwMultiSelectLookupComponent,
                    DwFormControlAutoCompleteLookupConfigComponent,
                    DwFormControlMultiSelectAdhocConfigComponent,
                    DwMdSectionStandardConfigComponent,
                    DwDynamicSectionComponent,
                    DwFormControlInputConfigComponent,
                    DwHtmlEditControlConfigComponent,
                    DwFormControlInputReadOnlyComponent,
                    DwFormControlNumericInputComponent,
                    DwFormControlNumericInputReadOnlyComponent,
                    DwMetadataConfigFiltersModalComponent,
                    DwRouteBaseConfigComponent,
                    DwListRouteConfigComponent,
                    DwSelectRouteComponent,
                    DwFormWorkflowButtonsActionComponent,
                    DwFormWorkflowButtonsConfigComponent,
                    DwExpressionPickerControlComponent,
                    DwMultiSelectAdhocComponent,
                    DwMultiSelectAdhocReadOnlyComponent,
                    DwRouteChildMenuConfigComponent,
                    DwMetadataFilterTilesConfigComponent,
                    DwPageDesignerComponent,
                    DwEmailTemplateDesignerComponent,
                    DwEmailContainerSectionComponent,
                    DwOrderedListComponent,
                    DwFieldValidationConfigComponent,
                    DwFormControlMultiSelectDateComponent,
                    DwConditionalFieldClassesComponent,
                    DwListQuickSearchActionComponent,
                    DwListQuickSearchConfigComponent
                ]
            }]
    }], null, null); })();

class UserProfileConfigComponent extends DwChildConfigBaseComponent {
    getDefaultConfig() {
        return {};
    }
}
UserProfileConfigComponent.ɵfac = function UserProfileConfigComponent_Factory(t) { return ɵUserProfileConfigComponent_BaseFactory(t || UserProfileConfigComponent); };
UserProfileConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserProfileConfigComponent, selectors: [["dw-user-profile-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 1, consts: [["dwRow", ""], ["dwCol", "12"], [1, "label"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"]], template: function UserProfileConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵtext(4, "Config Key 3");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function UserProfileConfigComponent_Template_input_ngModelChange_5_listener($event) { return ctx.config.configKeyPart = $event; })("ngModelChange", function UserProfileConfigComponent_Template_input_ngModelChange_5_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.config.configKeyPart);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], encapsulation: 2 });
const ɵUserProfileConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(UserProfileConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserProfileConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-user-profile-config',
                template: `
    <div>
      <div dwRow>
          <div dwCol="12">
              <label class="label">Config Key 3</label>
              <input type="text" [(ngModel)]="config.configKeyPart" (ngModelChange)="onChange()" class="form-control">
          </div>
      </div>
    </div>
  `
            }]
    }], null, null); })();

class UserProfileComponent {
    constructor(securityUserService, routingService, dwModalService, metaDataConfig, dwMenuService, route) {
        this.securityUserService = securityUserService;
        this.routingService = routingService;
        this.dwModalService = dwModalService;
        this.metaDataConfig = metaDataConfig;
        this.dwMenuService = dwMenuService;
        this.route = route;
        this.subscriptions = [];
        this.configKeyPart = 'profile';
    }
    canNavigate() {
        return this.mdForm.canNavigate();
    }
    ngOnInit() {
        var _a;
        this.subscriptions.push(this.securityUserService.securityContextChanged().subscribe(securityContext => {
            if (securityContext) {
                this.keyValue = securityContext.ApplicationUser.UserId;
            }
        }));
        this.currentMenu = this.dwMenuService.menuState.currentMenu;
        this.userProfileConfig = this.currentMenu.data.componentConfig;
        this.configKeyPart = ((_a = this.userProfileConfig) === null || _a === void 0 ? void 0 : _a.configKeyPart) || 'profile';
    }
    getRouteMenueData(route) {
        if (route.snapshot.routeConfig) {
            var routeConfig = route.snapshot.routeConfig;
            const dwMenuData = this.route.snapshot.data;
            if (dwMenuData) {
                return dwMenuData;
            }
        }
        return new DwMenuData;
    }
    ngOnDestroy() {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
}
UserProfileComponent.ɵfac = function UserProfileComponent_Factory(t) { return new (t || UserProfileComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwRoutingServiceToken), ɵngcc0.ɵɵdirectiveInject(DwModalService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMenuService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute)); };
UserProfileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: UserProfileComponent, selectors: [["dw-user-profile"]], viewQuery: function UserProfileComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c93, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.mdForm = _t.first);
    } }, decls: 3, vars: 2, consts: [["item", "dw_User", 3, "configKeyPart", "keyValue"], ["mdForm", ""]], template: function UserProfileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "dw-default-form", 0, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("configKeyPart", ctx.configKeyPart)("keyValue", ctx.keyValue);
    } }, directives: [DwDefaultFormPage], styles: [""] });
UserProfileComponent.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: DwRoutingService, decorators: [{ type: Inject, args: [DwRoutingServiceToken,] }] },
    { type: DwModalService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMenuService },
    { type: ActivatedRoute }
];
UserProfileComponent.propDecorators = {
    mdForm: [{ type: ViewChild, args: ['mdForm',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserProfileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-user-profile',
                template: "<div>\r\n  <dw-default-form #mdForm item=\"dw_User\" [configKeyPart]=\"configKeyPart\" [keyValue]=\"keyValue\">\r\n  </dw-default-form>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwSecurityUserService }, { type: DwRoutingService, decorators: [{
                type: Inject,
                args: [DwRoutingServiceToken]
            }] }, { type: DwModalService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMenuService }, { type: ɵngcc2.ActivatedRoute }]; }, { mdForm: [{
            type: ViewChild,
            args: ['mdForm']
        }] }); })();
DwComponentFunc({
    key: 'dwUserProfile',
    name: 'User Profile',
    componentType: DwComponentType.pageComponent,
    isGlobal: true,
    configComponent: UserProfileConfigComponent
}, UserProfileComponent);

class DwEmailService {
    constructor(dwOrmDataService, configService, dwCacheService, dwUiConfigRegistry, httpClient, dwSecurityService) {
        this.dwOrmDataService = dwOrmDataService;
        this.configService = configService;
        this.dwCacheService = dwCacheService;
        this.dwUiConfigRegistry = dwUiConfigRegistry;
        this.httpClient = httpClient;
        this.dwSecurityService = dwSecurityService;
        this.apiRoot = `${configService.coreConfig.apiRoot}communication/email/`;
    }
    getEmailLists() {
        return this.dwUiConfigRegistry.getRegisteredItems(DwUiRegistryType.emailLists);
    }
    getEmailSenderTempaltes() {
        return this.getAllEmailTemplates()
            .pipe(map(results => {
            return where(results, { AllowFromEmailSender: true });
        }));
    }
    getAllEmailTemplates() {
        var cacheInvalidationTopics = [];
        let dwMd = new DevwareMetaDataService();
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwEmailTemplate));
        return this.dwCacheService.get("emailTemplates", this.loadEmailTemplates(), null, cacheInvalidationTopics);
    }
    loadEmailTemplates() {
        let dwMd = new DevwareMetaDataService();
        const qh = this.dwOrmDataService.QueryHelper;
        const query = dwMd.DwEmailTemplate.CreateQuery();
        return this.dwOrmDataService.executeQuery(query);
    }
    getEmailRecipients(userList) {
        if (userList.userResults) {
            return of(userList.userResults);
        }
        return this.dwOrmDataService.executeQuery(userList.query)
            .pipe(map((userResults) => {
            userList.userResults = userResults;
            return userResults;
        }));
    }
    getCurrentUserEmailInfo() {
        if (!this.dwSecurityService.securityState.isAuthenticated) {
            return null;
        }
        var user = this.dwSecurityService.securityState.securityContext.ApplicationUser;
        const currentUser = {
            FirstName: user.FirstName,
            LastName: user.LastName,
            Email: user.Email,
            UserId: user.UserId,
            UserName: user.UserName,
            _itemName: "User",
            _keyName: "UserId"
        };
        return currentUser;
    }
    sendEmailWithTemplate(templateMeaning, recipientEmail, jsonData) {
        throw new Error('sendEmailWithTemplate has been implemented in Devware.Core');
        /*  let url = `${this.apiRoot}SendEmailWithTemplate`;
 
         let body = {
             templateMeaning : templateMeaning,
             recipient : recipientEmail,
             jsonData : jsonData,
         };
 
         let result = this.httpClient.post(url, body);
 
         return result; */
    }
}
DwEmailService.ɵfac = function DwEmailService_Factory(t) { return new (t || DwEmailService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwEmailService.ɵprov = ɵɵdefineInjectable({ factory: function DwEmailService_Factory() { return new DwEmailService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwCacheService), ɵɵinject(DwUiConfigRegistryService), ɵɵinject(HttpClient), ɵɵinject(DwSecurityUserService)); }, token: DwEmailService, providedIn: "root" });
DwEmailService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: DwCacheService },
    { type: DwUiConfigRegistryService },
    { type: HttpClient },
    { type: DwSecurityUserService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmailService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: DwCacheService }, { type: DwUiConfigRegistryService }, { type: ɵngcc1.HttpClient }, { type: DwSecurityUserService }]; }, null); })();

class EmailSenderComponent {
    constructor(dwEmailService) {
        this.dwEmailService = dwEmailService;
        this.emailInfo = {};
        this.emailCount = 0;
    }
    ngOnInit() {
        this.dwEmailService.getEmailSenderTempaltes()
            .subscribe(templates => {
            this.emailTemplates = templates;
        });
        this.emailLists = this.dwEmailService.getEmailLists();
        this.currentUserEmailInfo = this.dwEmailService.getCurrentUserEmailInfo();
    }
    isAdhocTemplate() {
        if (this.emailInfo && this.emailInfo.emailTemplate) {
            if (this.emailInfo.emailTemplate.TemplateMeaning.toUpperCase().indexOf('adhoc')) {
                return true;
            }
        }
        return false;
    }
    userListChanged() {
        this.currentUserResults = null;
        if (this.emailInfo && this.emailInfo.emailListItem) {
            this.dwEmailService.getEmailRecipients(this.emailInfo.emailListItem)
                .subscribe(userResults => {
                this.currentUserResults = userResults;
            });
        }
    }
    /**
     * Send All e-mails
     */
    send() {
        this.emailCount = 0;
        this.sendComplete = false;
        for (let user of this.currentUserResults) {
            this.sendEmail(user)
                .subscribe(() => {
                this.emailCount++;
            });
        }
    }
    /**
     * Send a test e-mail to the current user
     */
    sendTest() {
        this.emailCount = 0;
        this.sendComplete = false;
        this.sendEmail(this.currentUserEmailInfo)
            .subscribe(emailResult => {
            this.emailCount++;
            this.sendComplete = true;
        });
    }
    sendEmail(user) {
        var templateData = {
            item: user
        };
        if (!templateData) {
            return;
        }
        if (this.isAdhocTemplate()) {
            templateData.subject = this.emailInfo.subject;
            templateData.body = this.emailInfo.body;
        }
        let jsonData = JSON.stringify(templateData);
        return this.dwEmailService.sendEmailWithTemplate(this.emailInfo.emailTemplate.TemplateMeaning, user.Email, jsonData);
    }
}
EmailSenderComponent.ɵfac = function EmailSenderComponent_Factory(t) { return new (t || EmailSenderComponent)(ɵngcc0.ɵɵdirectiveInject(DwEmailService)); };
EmailSenderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EmailSenderComponent, selectors: [["dw-email-sender"]], decls: 28, vars: 11, consts: [["dwRow", ""], ["dwCol", "5"], [1, "label"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwRow", "", 4, "ngIf"], [4, "ngIf"], [1, "btn", "btn-success", 3, "title", "click"], ["title", "Send to all users in the selected list", 1, "btn", "btn-success", 3, "click"], [3, "hidden"], [3, "ngValue"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngModel", "ngModelChange"]], template: function EmailSenderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵtext(2, "E-mail Sender");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 0);
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "label", 2);
        ɵngcc0.ɵɵtext(6, "E-mail Template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function EmailSenderComponent_Template_select_ngModelChange_7_listener($event) { return ctx.emailInfo.emailTemplate = $event; });
        ɵngcc0.ɵɵtemplate(8, EmailSenderComponent_option_8_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, EmailSenderComponent_div_9_Template, 5, 1, "div", 5);
        ɵngcc0.ɵɵtemplate(10, EmailSenderComponent_div_10_Template, 5, 1, "div", 5);
        ɵngcc0.ɵɵelementStart(11, "div", 0);
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵelementStart(13, "label", 2);
        ɵngcc0.ɵɵtext(14, "User's to send to");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function EmailSenderComponent_Template_select_ngModelChange_15_listener($event) { return ctx.emailInfo.emailListItem = $event; });
        ɵngcc0.ɵɵtemplate(16, EmailSenderComponent_option_16_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, EmailSenderComponent_div_17_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "dw-button-bar");
        ɵngcc0.ɵɵelementStart(19, "button", 7);
        ɵngcc0.ɵɵlistener("click", function EmailSenderComponent_Template_button_click_19_listener() { return ctx.sendTest(); });
        ɵngcc0.ɵɵtext(20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "button", 8);
        ɵngcc0.ɵɵlistener("click", function EmailSenderComponent_Template_button_click_21_listener() { return ctx.send(); });
        ɵngcc0.ɵɵtext(22, " Send ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "div", 0);
        ɵngcc0.ɵɵelementStart(24, "div", 1);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵelementStart(26, "div", 9);
        ɵngcc0.ɵɵtext(27, "Complete!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.emailInfo.emailTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.emailTemplates);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAdhocTemplate());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAdhocTemplate());
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.emailInfo.emailListItem);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.emailLists);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentUserResults);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate1("title", "Only send to ", ctx.currentUserEmailInfo == null ? null : ctx.currentUserEmailInfo.Email, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" Send a test message ", ctx.currentUserEmailInfo == null ? null : ctx.currentUserEmailInfo.Email, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" E-mails send: ", ctx.emailCount, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.sendComplete);
    } }, directives: [DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgIf, DwButtonBarComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc3.DefaultValueAccessor, DwHtmlEditComponent], styles: [""] });
EmailSenderComponent.ctorParameters = () => [
    { type: DwEmailService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EmailSenderComponent, [{
        type: Component,
        args: [{
                selector: 'dw-email-sender',
                template: "<div>\r\n    <h1>E-mail Sender</h1>\r\n    <div dwRow>\r\n        <div dwCol=\"5\">\r\n            <label class=\"label\">E-mail Template</label>\r\n            <select class=\"form-control\" [(ngModel)]=\"emailInfo.emailTemplate\">\r\n                <option *ngFor=\"let template of emailTemplates\" [ngValue]=\"template\">\r\n                    {{template.TemplateMeaning}}\r\n                </option>\r\n\r\n            </select>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"isAdhocTemplate()\">\r\n        <div dwCol=\"5\">\r\n            <label class=\"label\">Subject</label>\r\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"emailInfo.subject\">\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"isAdhocTemplate()\">\r\n        <div dwCol=\"5\">\r\n            <label class=\"label\">Body</label>\r\n            <dw-html-edit [(ngModel)]=\"emailInfo.body\"></dw-html-edit>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"5\">\r\n            <label class=\"label\">User's to send to</label>\r\n            <select class=\"form-control\" [(ngModel)]=\"emailInfo.emailListItem\">\r\n                <option *ngFor=\"let emailList of emailLists\" [ngValue]=\"emailList\">\r\n                    {{emailList.display}}\r\n                </option>\r\n            </select>\r\n            <div *ngIf=\"currentUserResults\">{{currentUserResults.length}} E-mails to send</div>\r\n        </div>\r\n    </div>\r\n    <dw-button-bar>\r\n        <button class=\"btn btn-success\" (click)=\"sendTest()\" title=\"Only send to {{currentUserEmailInfo?.Email}}\">\r\n            Send a test message {{currentUserEmailInfo?.Email}}\r\n        </button>\r\n        <button class=\"btn btn-success\" (click)=\"send()\" title=\"Send to all users in the selected list\">\r\n            Send\r\n        </button>\r\n    </dw-button-bar>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"5\">\r\n            E-mails send: {{ emailCount }}\r\n\r\n            <div [hidden]=\"!sendComplete\">Complete!</div>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwEmailService }]; }, null); })();

class DwMetaDataLookupTransitionSectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupFormFields();
    }
    setupComponentComplete() {
        this.runAfterFormDataLoaded(() => {
            const data = this.context.data.value;
            this.formGroup.patchValue(data);
        });
    }
    get transitionFromValue() {
        return this.formGroup.get('TransitionFromValue');
    }
    get transitionToValue() {
        return this.formGroup.get('TransitionToValue');
    }
    get transitionFromValueDisplay() {
        return this.formGroup.get('TransitionFromValueDisplay');
    }
    get transitionToValueDisplay() {
        return this.formGroup.get('TransitionToValueDisplay');
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormFields() {
        this.formGroup.addControl('TransitionFromValue', new FormControl());
        this.formGroup.addControl('TransitionFromValueDisplay', new FormControl());
        this.formGroup.addControl('TransitionToValue', new FormControl());
        this.formGroup.addControl('TransitionToValueDisplay', new FormControl());
        const data = this.context.data.value;
        this.transitionFromValue.valueChanges.subscribe(fromValue => {
            this.updateLookupDisplay(fromValue, this.transitionFromValueDisplay);
        });
        this.transitionToValue.valueChanges.subscribe(fromValue => {
            this.updateLookupDisplay(fromValue, this.transitionToValueDisplay);
        });
        if (data && !isEmptyObject(data)) {
            this.formGroup.patchValue(data);
        }
    }
    updateLookupDisplay(value, field) {
        if (!this.context.data.value) {
            return;
        }
        const lookupId = parseInt(this.context.data.value.MetaDataLookupId);
        if (!lookupId) {
            return;
        }
        this.dwMetaDataService.getLookupDisplay(lookupId, value)
            .subscribe(displayValue => {
            field.setValue(displayValue);
        });
    }
}
DwMetaDataLookupTransitionSectionComponent.ɵfac = function DwMetaDataLookupTransitionSectionComponent_Factory(t) { return new (t || DwMetaDataLookupTransitionSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwMetaDataLookupTransitionSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataLookupTransitionSectionComponent, selectors: [["dw-meta-data-lookup-transition-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[3, "formGroup"], ["dwRow", "", 4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], [1, "label"], ["formControlName", "TransitionFromValue", "useTransitions", "false", 3, "lookupId"], ["formControlName", "TransitionToValue", "useTransitions", "false", 3, "lookupId"]], template: function DwMetaDataLookupTransitionSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMetaDataLookupTransitionSectionComponent_div_1_Template, 9, 2, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.context == null ? null : ctx.context.data == null ? null : ctx.context.data.value == null ? null : ctx.context.data.value.MetaDataLookupId);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, DwRowDirective, DwColDirective, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], styles: [""] });
DwMetaDataLookupTransitionSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataLookupTransitionSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-lookup-transition-section',
                template: "<div [formGroup]=\"formGroup\">\r\n  <div dwRow *ngIf=\"context?.data?.value?.MetaDataLookupId\">\r\n    <div dwCol=\"6\">\r\n      <label class=\"label\">Transition From</label>\r\n      <dw-search-select-lookup formControlName=\"TransitionFromValue\" [lookupId]=\"context?.data?.value?.MetaDataLookupId\" useTransitions=\"false\">\r\n      </dw-search-select-lookup>\r\n    </div>\r\n    <div dwCol=\"6\">\r\n      <label class=\"label\">Transition To</label>\r\n      <dw-search-select-lookup formControlName=\"TransitionToValue\" [lookupId]=\"context?.data?.value?.MetaDataLookupId\" useTransitions=\"false\">\r\n      </dw-search-select-lookup>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
DwComponentFunc({
    name: 'Lookup Transition Section',
    key: 'Lookup Transistion Section',
    parentItemName: 'dw_MetaDataLookupTransition',
    componentType: DwComponentType.formSection,
}, DwMetaDataLookupTransitionSectionComponent);

// @DwFormAction({
//   name: 'Generate Token',
//   actionKey: 'security-generate-pat',
//   actionMessage: 'Generating Personal Access Token...',
//   parentItemName: DevwareMetaDataItemNames.DwSecurityPersonalAccessToken,
//   useDi: true,
//   buttonConfig: {
//     buttonText: 'Generate PAT',
//     buttonTitle: 'Generates a Personal Access Token',
//     command: 'generate-pat',
//     iconClass: 'fa fa-key-skeleton',
//     buttonClass: 'btn btn-primary',
//   },
// })
// @DwAction({
//   keyName: 'security-generate-pat',
//   display: 'Generate PAT',
//   actionType: DwActionType.formAction,
//   parentItemName: DevwareMetaDataItemNames.DwSecurityPersonalAccessToken,
//   defaultButtonConfig: {
//       useParentDisplay: true,
//       iconClass: 'fa fa-key-skeleton',
//       buttonClass: 'btn btn-primary',
//       buttonTitle: 'Generates a Personal Access Token',
//   },
//   defaultSecurityConfig: {
//       requireAuthentication: true,
//       useEmulatedPermissions: true,
//       requireCanUpdate: true
//   }
// })
class DwGeneratePatActionService {
    constructor(securityRepository, eventsService) {
        this.securityRepository = securityRepository;
        this.eventsService = eventsService;
    }
    initAction(formInitActionState) {
        this.formInitActionState = formInitActionState;
        return;
    }
    handleAction(formActionState) {
        const result = {
            success: false,
            message: 'Unknown issue creating PAT Token!'
        };
        const patToken = formActionState.formApi.getFormData();
        return this.securityRepository.createPersonalAccessToken(patToken)
            .pipe(map((patResult) => {
            // result.message = `PAT Successfully created and has been copied to your clipboard`;
            result.message = {
                messageBody: `PAT Successfully created and has been copied to your clipboard`,
                allowClose: false,
                severity: DwMessageSeverity.success,
            };
            result.success = true;
            result.returnAfter = false;
            navigator.clipboard.writeText(patResult.AccessToken);
            formActionState.formApi.setFormData(patResult);
            // this.updateForm(formActionState, patResult.AccessToken);
            this.publishItemChanged();
            return result;
        }));
    }
    publishItemChanged() {
        this.eventsService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwSecurityPersonalAccessToken), null);
    }
    // Publish all save events
    updateForm(formActionState, accessToken) {
        const formApi = formActionState.formApi;
        const formConfig = formApi.getFormConfig();
        const container = formConfig.section;
        const formSection = container.sections[0];
        const textSection = container.sections[1];
        for (var field of formSection.fields) {
            field.isReadOnly = true;
        }
        textSection.htmlContent = `<hr><br>
        <p>Below is your generated token and it has been copied to your clipboard.  Please keep in a safe place as it cannot be recovered</p>

        <textarea>${accessToken}</textarea>      
      `;
        const data = formActionState.formApi.getFormData();
        formApi.setFormConfig(formConfig, true);
    }
}
DwGeneratePatActionService.ɵfac = function DwGeneratePatActionService_Factory(t) { return new (t || DwGeneratePatActionService)(ɵngcc0.ɵɵinject(DwSecurityRepositoryServiceToken), ɵngcc0.ɵɵinject(DwEventService)); };
DwGeneratePatActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGeneratePatActionService, factory: DwGeneratePatActionService.ɵfac });
DwGeneratePatActionService.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] },
    { type: DwEventService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGeneratePatActionService, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }, { type: DwEventService }]; }, null); })();
DwActionFunc({
    keyName: 'security-generate-pat',
    display: 'Generate PAT',
    actionType: DwActionType.formAction,
    parentItemName: DevwareMetaDataItemNames.DwSecurityPersonalAccessToken,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-key-skeleton',
        buttonClass: 'btn btn-primary',
        buttonTitle: 'Generates a Personal Access Token',
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        requireCanUpdate: true
    }
}, DwGeneratePatActionService);

var __decorate$2b = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwRouteConfigEditComponent = class DwRouteConfigEditComponent extends DwSectionBaseComponent {
    constructor() {
        super(...arguments);
        this.components = [];
    }
    ngOnInit() {
        super.ngOnInit();
        this.components = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.pageComponent);
        this.setupForm();
    }
    setupForm() {
        let initialConfigValue = {};
        if (this.context.data && this.context.data.value) {
            initialConfigValue = this.context.data.value.RouteConfigJSON || {};
        }
        /*  this.routeConfigFC = new FormControl(initialConfigValue);
         this.formGroup.addControl('RouteConfigJSON', this.routeConfigFC); */
        this.routeConfigFG = new FormGroup({});
        this.routeConfigFG.addControl('componentOverride', new FormControl());
        this.routeConfigFG.patchValue(initialConfigValue);
        this.formGroup.addControl('RouteConfigJSON', this.routeConfigFG);
        this.formGroup.valueChanges
            .subscribe((result) => {
            if (result && result.MetaDataItemId && result.MetaDataItemId != this.itemId) {
                this.itemId = result.MetaDataItemId;
                if (!this.itemId) {
                    this.itemName = null;
                    this.setupComponents();
                }
                else {
                    this.dwMetaDataService.getMetaDataItemName(this.itemId)
                        .subscribe(itemName => {
                        this.itemName = itemName;
                        this.setupComponents();
                    });
                }
            }
        });
    }
    setupComponents() {
        this.components = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.pageComponent, this.itemName);
    }
}
const ɵDwRouteConfigEditComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwRouteConfigEditComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteConfigEditComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-config-edit',
                template: "<div *ngIf=\"routeConfigFG\" [formGroup]=\"routeConfigFG\">\r\n  <div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\" >Component Override</label>\r\n        <select formControlName=\"componentOverride\" class=\"form-control\">\r\n            <option [ngValue]=\"null\">None</option>\r\n            <option *ngFor=\"let item of components\" [ngValue]=\"item.key\">\r\n              {{ item.name }}\r\n            </option>\r\n        </select>\r\n    </div>\r\n  </div>\r\n</div>"
            }]
    }], null, null); })();;
DwRouteConfigEditComponent.ɵfac = function DwRouteConfigEditComponent_Factory(t) { return ɵDwRouteConfigEditComponent_BaseFactory(t || DwRouteConfigEditComponent); };
DwRouteConfigEditComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteConfigEditComponent, selectors: [["dw-route-config-edit"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["formControlName", "componentOverride", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"]], template: function DwRouteConfigEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteConfigEditComponent_div_0_Template, 9, 3, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.routeConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf], encapsulation: 2 });
DwRouteConfigEditComponent = __decorate$2b([
    DwComponent({
        name: 'Route Config Editor',
        componentType: DwComponentType.formSection,
        isGlobal: false,
        parentItemName: DevwareMetaDataItemNames.DwRoute,
    })
], DwRouteConfigEditComponent);

class DwRouteEditComponent {
    constructor(dwMetaDataService, dwRouteTypeFactory, cdr) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwRouteTypeFactory = dwRouteTypeFactory;
        this.cdr = cdr;
        this.routeChange = new EventEmitter();
        this.validChange = new EventEmitter();
        this.undoConversion = new EventEmitter();
        this.allowPathChange = true;
        this.permissionLookupId = DevwareMetaDataLookups.AppPermissionAllItems;
        this.routeCategoryLookupId = DevwareMetaDataLookups.RouteCategoryAllItems;
        this.settingUpForm = false;
    }
    onUndoConversion() {
        this.undoConversion.emit();
    }
    ngOnInit() {
        this.dwMetaDataService.getMetaData(DevwareMetaDataItemNames.DwRoute)
            .subscribe(itemMd => {
            this.buildForm(itemMd);
            this.setFormData();
            this.cdr.detectChanges();
        });
    }
    ngOnChanges(changes) {
        if (changes.route && !changes.route.firstChange) {
            this.setFormData();
        }
    }
    setFormData() {
        if (this.formGroup) {
            if (!this.route) {
                return;
            }
            if (!this.route.Path) {
                this.allowPathChange = true;
            }
            this.settingUpForm = true;
            this.route.RouteConfigJSON = this.route.RouteConfigJSON || {};
            this.ignoreFormUpdate = true;
            this.formGroup.reset({ RouteConfigJSON: {} }, { emitEvent: false });
            this.formGroup.patchValue(this.route, { emitEvent: false });
            this.ignoreFormUpdate = false;
            this.lastValid = null;
            this.setupRouteConfigComponent();
        }
    }
    buildForm(itemMetaData) {
        this.formGroup = new FormGroup({});
        this.routeConfigFG = new FormGroup({
            formRouteOptions: new FormControl(),
        });
        this.formGroup.addControl('RouteConfigJSON', this.routeConfigFG);
        // this.formGroup.addControl('categories', new FormControl());
        for (const attr of itemMetaData.Attributes) {
            const formControl = new FormControl();
            this.formGroup.addControl(attr.AttributeName, formControl);
            if (attr.AlwaysRequired) {
                formControl.setValidators([Validators.required]);
            }
        }
        // Always request the MetaDataItemId (When it's displayed)
        this.metaDataItemFC = this.formGroup.get('MetaDataItemId');
        this.displayFC = this.formGroup.get('Display');
        this.pathFC = this.formGroup.get('Path');
        // Make Item id always required - it will enabled/disabled based on route type
        this.metaDataItemFC.validator = Validators.required;
        // Set lookups for Route Type and MetaDataItemId
        this.routeTypeLookupId = this.getLookupId(itemMetaData, 'RouteTypeId');
        this.metaDataItemsLookupId = this.getLookupId(itemMetaData, 'MetaDataItemId');
        // this.metaDataItemFC.valueChanges.subscribe(itemId => this.handleMetaDataItemChange(itemId));
        this.displayFC.valueChanges.subscribe(display => this.handleDisplayChange(display));
        this.formGroup.valueChanges
            .pipe(debounceTime(10)) // Wait 10 ms before handling this, otherwise it can cause an infinite loop when setting up conditional validators
            .subscribe(value => this.handleFormGroupChange(value));
    }
    handleFormGroupChange(value) {
        //console.log(`handleFormGroupChange`, this.formGroup.value?.RouteConfigJSON?.securityExpression, value?.routeConfigJson.securityExpression);
        var _a, _b;
        value = this.formGroup.getRawValue();
        if (this.lastValid != this.formGroup.valid) {
            this.lastValid = this.formGroup.valid;
            this.validChange.emit(this.formGroup.valid);
        }
        if (this.settingUpForm) {
            return;
        }
        if (this.ignoreFormUpdate) {
            return;
        }
        this.cdr.markForCheck();
        // Note: Changed to use a deep copy so it preserves actionConfig items for children
        //const newRoute: DwRouteEntity = { ...this.route, ...removeNullProperties(value) };
        const newRouteConfigJSON = deepCopy(value.RouteConfigJSON);
        const newRoute = deepDefaults(removeNullProperties(value), this.route);
        //console.log(`handleFormGroupChange - after Route update`, (newRoute?.RouteConfigJSON as any)?.securityExpression, value?.RouteConfigJSON?.securityExpression);
        newRoute.RouteConfigJSON = newRouteConfigJSON;
        //console.log(`handleFormGroupChange - after Route update fix`, (newRoute?.RouteConfigJSON as any)?.securityExpression, value?.RouteConfigJSON?.securityExpression);
        // console.log('Copy compare ', newRoute, newRoute2);
        newRoute.MetaDataItemId = value.MetaDataItemId;
        if (((_a = this.itemMd) === null || _a === void 0 ? void 0 : _a.MetaDataItemId) != newRoute.MetaDataItemId) {
            // Only update the display when the route exists and the item ids don't match (e.g. when they change the drop-down)
            const updateDisplay = this.route && ((_b = this.route) === null || _b === void 0 ? void 0 : _b.MetaDataItemId) != newRoute.MetaDataItemId;
            // Meta data item is different
            this.handleMetaDataItemChange(newRoute.MetaDataItemId, updateDisplay);
        }
        if (areEqual(newRoute, this.route)) {
            return;
        }
        this.route = newRoute;
        this.routeChange.emit(this.route);
    }
    handleMetaDataItemChange(itemId, updateDisplay) {
        if (!itemId) {
            this.itemMd = null;
            return;
        }
        if (this.itemMd && itemId == this.itemMd.MetaDataItemId) {
            return;
        }
        const currentRoute = this.formGroup.value;
        this.dwMetaDataService.getMetaDataItemName(itemId)
            .subscribe(itemName => {
            this.dwMetaDataService.getMetaData(itemName)
                .subscribe(itemMd => {
                this.itemMd = itemMd;
                if (updateDisplay) {
                    this.displayFC.setValue(itemMd.Display);
                    this.pathFC.setValue(this.buildPath(itemMd.Display));
                }
            });
        });
    }
    handleDisplayChange(display) {
        const currentRoute = this.formGroup.value;
        const oldPath = this.buildPath(currentRoute.Display);
        const newPath = this.buildPath(display);
        if (oldPath != currentRoute.Path && currentRoute.Path) {
            return;
        }
        if (newPath === currentRoute.Path) {
            return;
        }
        this.pathFC.setValue(newPath);
    }
    buildPath(display) {
        display = display.replace(/ /g, '-');
        display = encodeURI(display);
        return display.toLowerCase();
    }
    getLookupId(itemMetaData, attrName) {
        const attr = itemMetaData.Attributes.find(a => a.AttributeName == attrName);
        if (attr) {
            return attr.MetaDataLookupId;
        }
    }
    setupFormComplete() {
        if (!this.settingUpForm) {
            return;
        }
        this.settingUpForm = false;
        // Do
        const newRoute = Object.assign(Object.assign({}, this.route), removeNullProperties(this.formGroup.value));
        this.cdr.detectChanges();
    }
    setupRouteConfigComponent() {
        if (this.ignoreFormUpdate) {
            return;
        }
        if (this.route && this.route.RouteTypeId) {
            const routeTypeProcessorRegistration = this.dwRouteTypeFactory.getRouteProcessorRegistration(this.route.RouteTypeId, false);
            if (!routeTypeProcessorRegistration) {
                this.routeTypeProcessorRegistration = null;
                this.routeConfigComponentType = null;
                this.setupFormComplete();
                return;
            }
            if (this.routeTypeProcessorRegistration && routeTypeProcessorRegistration.keyName == this.routeTypeProcessorRegistration.keyName) {
                this.configureRouteConfigComponentType(this.routeConfigComponentInstance);
                return;
            }
            this.routeTypeProcessorRegistration = routeTypeProcessorRegistration;
            this.routeConfigComponentType = this.routeTypeProcessorRegistration.configComponent;
            const metaDataItemFC = this.formGroup.get('MetaDataItemId');
            // Toggle the required validate for MetaDataItem
            if (this.routeTypeProcessorRegistration.usesMetaDataItem) {
                metaDataItemFC.enable();
            }
            else {
                metaDataItemFC.disable();
            }
        }
    }
    configureRouteConfigComponentType(instance) {
        this.routeConfigComponentInstance = instance;
        if (this.routeConfigComponentInstance) {
            this.ignoreFormUpdate = true;
            this.routeConfigComponentInstance.routeConfigFG = this.routeConfigFG;
            this.routeConfigComponentInstance.route = this.route;
            this.routeConfigComponentInstance.routeTypeProcessorRegistration = this.routeTypeProcessorRegistration;
            this.routeConfigComponentInstance.setupForm();
            this.ignoreFormUpdate = false;
        }
        this.setupFormComplete();
    }
}
DwRouteEditComponent.ɵfac = function DwRouteEditComponent_Factory(t) { return new (t || DwRouteEditComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwRouteTypeFactory), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
DwRouteEditComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteEditComponent, selectors: [["dw-route-edit"]], viewQuery: function DwRouteEditComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(DwDynamicLoaderComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwLoader = _t.first);
    } }, inputs: { route: "route", treeNode: "treeNode" }, outputs: { routeChange: "routeChange", validChange: "validChange", undoConversion: "undoConversion" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "dw-form-highlight-invalid", 3, "formGroup", 4, "ngIf"], [1, "dw-form-highlight-invalid", 3, "formGroup"], [1, "alert", "alert-danger", 3, "hidden"], ["class", "alertmt-3", 4, "ngIf"], ["multiple", "true"], ["header", "Basic Settings", "selected", "true"], ["dwRow", ""], ["dwCol", "12"], ["formControlName", "RouteTypeId", "showBlankOption", "false", 3, "lookupId", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["title", "Required", 1, "required-label"], ["formControlName", "MetaDataItemId", "blankOptionText", "None", 3, "lookupId"], ["type", "text", "formControlName", "Display", 1, "form-control"], ["type", "text", "formControlName", "Path", 1, "form-control"], ["type", "text", "formControlName", "IconCssClass", 1, "form-control"], ["type", "text", "formControlName", "RouteOrder", 1, "form-control"], ["title", "Validation Errors", 1, "fa", "fa-exclamation-triangle", "text-danger", 3, "hidden"], [3, "component", "configure"], ["header", "Child Menu Settings"], [3, "routeConfigFormGroup"], ["header", "Security"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "RequireAuthentication"], ["dwRow", "", 4, "ngIf"], ["header", "Menu Visibility"], ["formControlName", "ShowInMenu"], ["formControlName", "ExcludeFromMainMenu"], ["formControlName", "HighlightOnExactMatch"], [3, "routeConfigFG", "route"], [1, "alertmt-3"], ["type", "button", 1, "btn", "btn-danger", 3, "click"], ["formControlName", "CanAccessPermissionMeaning"]], template: function DwRouteEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteEditComponent_form_0_Template, 73, 13, "form", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup);
    } }, directives: function () { return [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.DefaultValueAccessor, ɵngcc6.Header, DwDynamicLoaderComponent, DwRouteChildMenuConfigComponent, ɵngcc10.InputSwitch, DwRouteEditSecurityComponent, DwSecurityPermissionSelectComponent]; }, encapsulation: 2, changeDetection: 0 });
DwRouteEditComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwRouteTypeFactory },
    { type: ChangeDetectorRef }
];
DwRouteEditComponent.propDecorators = {
    route: [{ type: Input }],
    routeChange: [{ type: Output }],
    validChange: [{ type: Output }],
    undoConversion: [{ type: Output }],
    treeNode: [{ type: Input }],
    dwLoader: [{ type: ViewChild, args: [DwDynamicLoaderComponent, { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteEditComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-edit',
                template: "<form *ngIf=\"formGroup\" [formGroup]=\"formGroup\" class=\"dw-form-highlight-invalid\">\r\n  <div [hidden]=\"!formGroup.invalid\" class=\"alert alert-danger\">\r\n    Please fill in all required fields.\r\n\r\n    <div *ngIf=\"treeNode?.data?.invalidMessage\" class=\"alertmt-3\">\r\n      Conversion Error: {{treeNode?.data?.invalidMessage}}\r\n\r\n      <button class=\"btn btn-danger\" type=\"button\" (click)=\"onUndoConversion()\">Undo Conversion</button>\r\n    </div>\r\n  </div>\r\n\r\n  <p-accordion multiple=\"true\">\r\n    <p-accordionTab header=\"Basic Settings\" selected=\"true\">\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Menu Type</label>\r\n          <dw-search-select-lookup [lookupId]=\"routeTypeLookupId\" formControlName=\"RouteTypeId\"\r\n            (ngModelChange)=\"setupRouteConfigComponent()\" showBlankOption=\"false\">\r\n          </dw-search-select-lookup>\r\n        </div>\r\n      </div>\r\n      <div dwRow [hidden]=\"!routeTypeProcessorRegistration?.usesMetaDataItem\">\r\n        <div dwCol=\"12\">\r\n          <label>Meta Data Item <span class=\"required-label\" title=\"Required\">&nbsp;*</span></label> \r\n          <dw-search-select-lookup [lookupId]=\"metaDataItemsLookupId\" formControlName=\"MetaDataItemId\"\r\n            blankOptionText=\"None\">\r\n          </dw-search-select-lookup>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Display</label>\r\n          <input type=\"text\" formControlName=\"Display\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Path</label>\r\n          <input type=\"text\" formControlName=\"Path\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Icon Css</label>\r\n          <input type=\"text\" formControlName=\"IconCssClass\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Order</label>\r\n          <input type=\"text\" formControlName=\"RouteOrder\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n    </p-accordionTab>\r\n    <p-accordionTab>\r\n      <p-header>\r\n        {{routeTypeProcessorRegistration?.configTabDisplay}} <i [hidden]=\"!routeConfigFG.invalid\"\r\n          class=\"fa fa-exclamation-triangle text-danger\" title=\"Validation Errors\"></i>\r\n      </p-header>\r\n      <dw-dynamic-loader [component]=\"routeTypeProcessorRegistration?.configComponent\"\r\n        (configure)=\"configureRouteConfigComponentType($event)\"></dw-dynamic-loader>\r\n\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Child Menu Settings\">\r\n      <dw-route-child-menu-config [routeConfigFormGroup]=\"routeConfigFG\"></dw-route-child-menu-config>\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Security\">\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Require Authentication</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch formControlName=\"RequireAuthentication\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow *ngIf=\"formGroup.value?.RequireAuthentication\">\r\n        <div dwCol=\"12\">\r\n          <label>Permission</label>\r\n          <dw-security-permission-select formControlName=\"CanAccessPermissionMeaning\">\r\n          </dw-security-permission-select>\r\n        </div>\r\n      </div>\r\n    </p-accordionTab>\r\n    <p-accordionTab header=\"Menu Visibility\">\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Show In Menu</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch formControlName=\"ShowInMenu\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Exclude From Main Menu</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch formControlName=\"ExcludeFromMainMenu\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Highlight Sidebar on Exact Match</label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch formControlName=\"HighlightOnExactMatch\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <dw-route-edit-security [routeConfigFG]=\"routeConfigFG\" [route]=\"route\"></dw-route-edit-security>\r\n    </p-accordionTab>\r\n  </p-accordion>\r\n</form>",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwRouteTypeFactory }, { type: ɵngcc0.ChangeDetectorRef }]; }, { routeChange: [{
            type: Output
        }], validChange: [{
            type: Output
        }], undoConversion: [{
            type: Output
        }], route: [{
            type: Input
        }], treeNode: [{
            type: Input
        }], dwLoader: [{
            type: ViewChild,
            args: [DwDynamicLoaderComponent, { static: true }]
        }] }); })();

class DwRouteAddComponent {
    constructor() {
        this.routeAdded = new EventEmitter();
    }
    ngOnInit() {
        this.resetToDefaultRoute();
    }
    resetToDefaultRoute() {
        this.newRoute = {
            _itemName: DevwareMetaDataItemNames.DwRoute,
            RouteTypeId: DwDynamicRouteType.menuPage,
            Display: 'New Menu',
            Path: 'new-menu',
            ExcludeFromMainMenu: true,
            ShowInMenu: true,
            RequireAuthentication: true
        };
        this.isValid = true;
    }
    validChange(isValid) {
        this.isValid = isValid;
    }
    addRoute() {
        this.routeAdded.emit(this.newRoute);
        this.resetToDefaultRoute();
    }
}
DwRouteAddComponent.ɵfac = function DwRouteAddComponent_Factory(t) { return new (t || DwRouteAddComponent)(); };
DwRouteAddComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteAddComponent, selectors: [["dw-route-add"]], outputs: { routeAdded: "routeAdded" }, decls: 4, vars: 2, consts: [[3, "route", "routeChange", "validChange"], [1, "btn", "btn-success", 3, "disabled", "click"]], template: function DwRouteAddComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-route-edit", 0);
        ɵngcc0.ɵɵlistener("routeChange", function DwRouteAddComponent_Template_dw_route_edit_routeChange_0_listener($event) { return ctx.newRoute = $event; })("validChange", function DwRouteAddComponent_Template_dw_route_edit_validChange_0_listener($event) { return ctx.validChange($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(1, "dw-button-bar");
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵlistener("click", function DwRouteAddComponent_Template_button_click_2_listener() { return ctx.addRoute(); });
        ɵngcc0.ɵɵtext(3, "Add");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("route", ctx.newRoute);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.isValid);
    } }, directives: [DwRouteEditComponent, DwButtonBarComponent], encapsulation: 2 });
DwRouteAddComponent.ctorParameters = () => [];
DwRouteAddComponent.propDecorators = {
    routeAdded: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteAddComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-add',
                template: "\r\n\r\n\r\n <dw-route-edit [(route)]=\"newRoute\" (validChange)=\"validChange($event)\">\r\n</dw-route-edit>\r\n\r\n<dw-button-bar>\r\n    <button class=\"btn btn-success\" (click)=\"addRoute()\" [disabled]=\"!isValid\">Add</button>\r\n</dw-button-bar>"
            }]
    }], function () { return []; }, { routeAdded: [{
            type: Output
        }] }); })();

class DwRouteEditChildComponent {
    constructor(metaDataService, dwUiConfigRegistryService) {
        this.metaDataService = metaDataService;
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.routeChange = new EventEmitter();
        this.displayPlaceholder = '';
    }
    ngOnInit() {
        this.buildForm();
        this.setData();
    }
    ngOnChanges(changes) {
        const change = changes.route || changes.menuData;
        if (change && !change.firstChange) {
            this.setData();
        }
    }
    setData() {
        if (this.menuData && this.route) {
            this.listRouteConfig = (this.route.RouteConfigJSON || {});
            this.listRouteConfig.formRouteOptions = this.listRouteConfig.formRouteOptions || [];
            this.listRouteFormConfig = this.listRouteConfig.formRouteOptions.find(fc => fc.formType == this.menuData.metaDataActionType);
            if (!this.listRouteFormConfig) {
                this.listRouteFormConfig = { formType: this.menuData.metaDataActionType };
                this.listRouteConfig.formRouteOptions.push(this.listRouteFormConfig);
            }
            this.displayPlaceholder = getMenuActionTypeDisplay(this.menuData.metaDataActionType);
            this.metaDataService.getMetaDataItemName(this.route.MetaDataItemId)
                .subscribe(itemName => {
                this.itemName = itemName;
                this.setupComponents();
                this.pathPlaceholder = getMenuActionTypePath(itemName, this.menuData.metaDataActionType);
            });
            this.formGroup.reset({}, { emitEvent: false });
            this.formGroup.patchValue(this.listRouteFormConfig, { emitEvent: false });
        }
    }
    buildForm() {
        this.formGroup = new FormGroup({});
        this.formGroup.addControl('formType', new FormControl());
        this.formGroup.addControl('displayOverride', new FormControl());
        this.formGroup.addControl('configKeyPart', new FormControl());
        this.formGroup.addControl('pathOverride', new FormControl());
        this.formGroup.addControl('replaceSideMenu', new FormControl());
        this.formGroup.addControl('hideReplaceSideMenuBackButton', new FormControl());
        this.formGroup.addControl('sideMenuComponent', new FormControl());
        this.formGroup.addControl('includeInGroup', new FormControl());
        this.formGroup.addControl('groupDisplay', new FormControl());
        this.formGroup.valueChanges.subscribe(value => {
            this.updateRoute(value);
        });
    }
    updateRoute(value) {
        this.listRouteFormConfig.displayOverride = value.displayOverride;
        this.listRouteFormConfig.configKeyPart = value.configKeyPart;
        this.listRouteFormConfig.pathOverride = value.pathOverride;
        this.listRouteFormConfig.replaceSideMenu = value.replaceSideMenu;
        this.listRouteFormConfig.hideReplaceSideMenuBackButton = value.hideReplaceSideMenuBackButton;
        this.listRouteFormConfig.sideMenuComponent = value.sideMenuComponent;
        this.listRouteFormConfig.includeInGroup = value.includeInGroup;
        this.listRouteFormConfig.groupDisplay = value.groupDisplay;
        this.routeChange.emit(this.route);
    }
    setupComponents() {
        this.sideMenuComponents = this.dwUiConfigRegistryService.getRegisteredComponents(DwComponentType.sideMenuReplacement, this.itemName);
    }
}
DwRouteEditChildComponent.ɵfac = function DwRouteEditChildComponent_Factory(t) { return new (t || DwRouteEditChildComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService)); };
DwRouteEditChildComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteEditChildComponent, selectors: [["dw-route-edit-child"]], inputs: { route: "route", menuData: "menuData" }, outputs: { routeChange: "routeChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["multiple", "true"], ["header", "Basic Settings", "selected", "true"], ["dwRow", ""], ["dwCol", "12"], ["type", "text", "formControlName", "displayOverride", 1, "form-control", 3, "placeholder"], ["type", "text", "formControlName", "configKeyPart", 1, "form-control"], ["type", "text", "formControlName", "pathOverride", 1, "form-control", 3, "placeholder"], ["dwCol", "9"], ["title", "Use this menu's children as the side menu", 1, "fa", "fa-info-circle"], ["dwCol", "3"], ["formControlName", "replaceSideMenu"], ["dwRow", "", 4, "ngIf"], ["title", "When parent menu group is set to 'Use Menu Groups', it uses this display as a grouping mechanism", 1, "fa", "fa-info-circle"], ["title", "Hide the back button in the replacement menu", 1, "fa", "fa-info-circle"], ["formControlName", "hideReplaceSideMenuBackButton"], [1, "label"], ["title", "Replaces the standard side replacement menu with a custom component", 1, "fas", "fa-info-circle"], ["formControlName", "sideMenuComponent", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf"]], template: function DwRouteEditChildComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwRouteEditChildComponent_form_0_Template, 34, 5, "form", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.formGroup);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.ɵangular_packages_forms_forms_y, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc10.InputSwitch, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgForOf], encapsulation: 2 });
DwRouteEditChildComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwUiConfigRegistryService }
];
DwRouteEditChildComponent.propDecorators = {
    route: [{ type: Input }],
    routeChange: [{ type: Output }],
    menuData: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteEditChildComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-edit-child',
                template: "<form *ngIf=\"formGroup\" [formGroup]=\"formGroup\">\r\n  <p-accordion multiple=\"true\">\r\n    <p-accordionTab header=\"Basic Settings\" selected=\"true\">\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Display</label>\r\n          <input type=\"text\" formControlName=\"displayOverride\" [placeholder]=\"displayPlaceholder\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Config Key Override</label>\r\n          <input type=\"text\" formControlName=\"configKeyPart\" class=\"form-control\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"12\">\r\n          <label>Path Override</label>\r\n          <input type=\"text\" formControlName=\"pathOverride\" class=\"form-control\" [placeholder]=\"pathPlaceholder\">\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n          <label>Replace Side Menu <i class=\"fa fa-info-circle\"\r\n              title=\"Use this menu's children as the side menu\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch formControlName=\"replaceSideMenu\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow *ngIf=\"formGroup?.value?.replaceSideMenu\">\r\n        <div dwCol=\"9\">\r\n          <label>Hide Back Button <i class=\"fa fa-info-circle\"\r\n              title=\"Hide the back button in the replacement menu\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n          <p-inputSwitch formControlName=\"hideReplaceSideMenuBackButton\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      <div dwRow>\r\n        <div dwCol=\"9\">\r\n            <label>Menu Group Display <i class=\"fa fa-info-circle\"\r\n                    title=\"When parent menu group is set to 'Use Menu Groups', it uses this display as a grouping mechanism\"></i></label>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <p-inputSwitch formControlName=\"replaceSideMenu\"></p-inputSwitch>\r\n        </div>\r\n      </div>\r\n      \r\n      <div dwRow *ngIf=\"formGroup?.value?.replaceSideMenu\">\r\n        <div dwCol=\"12\">\r\n          <label class=\"label\">Side Menu Component <i class=\"fas fa-info-circle\"\r\n              title=\"Replaces the standard side replacement menu with a custom component\"></i></label>\r\n          <select formControlName=\"sideMenuComponent\" class=\"form-control\">\r\n            <option [ngValue]=\"null\">None</option>\r\n            <option *ngFor=\"let item of sideMenuComponents\" [ngValue]=\"item.key\">\r\n              {{ item.name }}\r\n            </option>\r\n          </select>\r\n        </div>\r\n      </div>\r\n    </p-accordionTab>\r\n  </p-accordion>\r\n</form>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwUiConfigRegistryService }]; }, { routeChange: [{
            type: Output
        }], route: [{
            type: Input
        }], menuData: [{
            type: Input
        }] }); })();

var DwImportMode;
(function (DwImportMode) {
    DwImportMode["All"] = "All";
    DwImportMode["UpdateExisting"] = "UpdateExisting";
    DwImportMode["AddAllNew"] = "AddAllNew";
    DwImportMode["UpdateSelected"] = "UpdateSelected";
    DwImportMode["AddSelected"] = "AddSelected";
})(DwImportMode || (DwImportMode = {}));
class DwImportModeList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwImportMode[propertyName];
    }
    getKeys() {
        return Object.keys(DwImportMode);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwImportMode.All:
                return 'Add New & Updating Existing';
            case DwImportMode.AddAllNew:
                return 'Add New Only';
            case DwImportMode.UpdateExisting:
                return 'Update Existing Only';
            default:
                return null;
        }
    }
}

/************************************************
   Generated with the Devware CAP CLI
   Code Gen Name   DevwareFeatureAreas
   API Url         https://localhost:44368

   Generated By    DEVWARE/anthony.monsees
   Generate On     8/25/2023 12:26:59 PM
************************************************/
var DevwareFeatureAreasMetaDataItemNames;
(function (DevwareFeatureAreasMetaDataItemNames) {
    DevwareFeatureAreasMetaDataItemNames["DwFeatureArea"] = "dw_FeatureArea";
    DevwareFeatureAreasMetaDataItemNames["DwFeatureAreaDetail"] = "dw_FeatureAreaDetail";
    DevwareFeatureAreasMetaDataItemNames["DwFeatureAreaDetailGroup"] = "dw_FeatureAreaDetailGroup";
    DevwareFeatureAreasMetaDataItemNames["DwFeatureAreaDetailType"] = "dw_FeatureAreaDetailType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataAttribute"] = "dw_MetaDataAttribute";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataAttributeFormat"] = "dw_MetaDataAttributeFormat";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataAttributeType"] = "dw_MetaDataAttributeType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataAttributeTypeComparerMap"] = "dw_MetaDataAttributeTypeComparerMap";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataAttributeTypeControlTypeMap"] = "dw_MetaDataAttributeTypeControlTypeMap";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataAttributeTypeSqlTypeMap"] = "dw_MetaDataAttributeTypeSqlTypeMap";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataCollection"] = "dw_MetaDataCollection";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataComparer"] = "dw_MetaDataComparer";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataControlType"] = "dw_MetaDataControlType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataDatabase"] = "dw_MetaDataDatabase";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataDatabaseSystem"] = "dw_MetaDataDatabaseSystem";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataDotNetType"] = "dw_MetaDataDotNetType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataEnvironmentOfRecordType"] = "dw_MetaDataEnvironmentOfRecordType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataEvent"] = "dw_MetaDataEvent";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataGroup"] = "dw_MetaDataGroup";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataHistory"] = "dw_MetaDataHistory";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataHistoryDetail"] = "dw_MetaDataHistoryDetail";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataHistoryType"] = "dw_MetaDataHistoryType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataImport"] = "dw_MetaDataImport";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataImportLog"] = "dw_MetaDataImportLog";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataItem"] = "dw_MetaDataItem";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataItemRelationship"] = "dw_MetaDataItemRelationship";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataItemRelationshipType"] = "dw_MetaDataItemRelationshipType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataItemStatus"] = "dw_MetaDataItemStatus";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataItemType"] = "dw_MetaDataItemType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataLookup"] = "dw_MetaDataLookup";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataLookupParam"] = "dw_MetaDataLookupParam";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataLookupTransition"] = "dw_MetaDataLookupTransition";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataOperation"] = "dw_MetaDataOperation";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataOperationType"] = "dw_MetaDataOperationType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataQuery"] = "dw_MetaDataQuery";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSecurityGroup"] = "dw_MetaDataSecurityGroup";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSecurityGroupAttribute"] = "dw_MetaDataSecurityGroupAttribute";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSecurityGroupItem"] = "dw_MetaDataSecurityGroupItem";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSecurityItemRule"] = "dw_MetaDataSecurityItemRule";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSqlType"] = "dw_MetaDataSqlType";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSystem"] = "dw_MetaDataSystem";
    DevwareFeatureAreasMetaDataItemNames["DwMetaDataSystemType"] = "dw_MetaDataSystemType";
})(DevwareFeatureAreasMetaDataItemNames || (DevwareFeatureAreasMetaDataItemNames = {}));
var DevwareFeatureAreasMetaDataLookups;
(function (DevwareFeatureAreasMetaDataLookups) {
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["AttributeByMetaDataItem"] = 372] = "AttributeByMetaDataItem";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["FeatureAreaAllItems"] = 2804] = "FeatureAreaAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["FeatureAreaDetailAllItems"] = 2799] = "FeatureAreaDetailAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["FeatureAreaDetailGroupAllItems"] = 2832] = "FeatureAreaDetailGroupAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["FeatureAreaDetailTypeAllItems"] = 2798] = "FeatureAreaDetailTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["FeatureAreaDetailTypesByGroup"] = 2833] = "FeatureAreaDetailTypesByGroup";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataItemGroupByDatabase"] = 2761] = "MetaDataItemGroupByDatabase";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataQueryByItem"] = 2809] = "MetaDataQueryByItem";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSchemasByDatabase"] = 2831] = "MetaDataSchemasByDatabase";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeWithItemName"] = 1514] = "MetaDataAttributeWithItemName";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeAllItems"] = 25] = "MetaDataAttributeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeFormatAllItems"] = 78] = "MetaDataAttributeFormatAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeTypeAllItems"] = 87] = "MetaDataAttributeTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeTypeComparerMapAllItems"] = 2] = "MetaDataAttributeTypeComparerMapAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeTypeControlTypeMapAllItems"] = 3] = "MetaDataAttributeTypeControlTypeMapAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataAttributeTypeSqlTypeMapAllItems"] = 5] = "MetaDataAttributeTypeSqlTypeMapAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataCollectionAllItems"] = 1760] = "MetaDataCollectionAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataComparerAllItems"] = 6] = "MetaDataComparerAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataControlTypeAllItems"] = 9] = "MetaDataControlTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataDatabaseAllItems"] = 86] = "MetaDataDatabaseAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataDatabaseSystemAllItems"] = 10] = "MetaDataDatabaseSystemAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataDotNetTypeAllItems"] = 12] = "MetaDataDotNetTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataEnvironmentOfRecordTypeAllItems"] = 2806] = "MetaDataEnvironmentOfRecordTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataEventAllItems"] = 1465] = "MetaDataEventAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataGroupAllItems"] = 1538] = "MetaDataGroupAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataHistoryAllItems"] = 2797] = "MetaDataHistoryAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataHistoryDetailAllItems"] = 2796] = "MetaDataHistoryDetailAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataHistoryTypeAllItems"] = 2795] = "MetaDataHistoryTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataImportAllItems"] = 2803] = "MetaDataImportAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataImportLogAllItems"] = 2808] = "MetaDataImportLogAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataItemAllItems"] = 69] = "MetaDataItemAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataItemRelationshipAllItems"] = 28] = "MetaDataItemRelationshipAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataItemRelationshipTypeAllItems"] = 26] = "MetaDataItemRelationshipTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataItemStatusAllItems"] = 14] = "MetaDataItemStatusAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataItemTypeAllItems"] = 16] = "MetaDataItemTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataLookupAllItems"] = 17] = "MetaDataLookupAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataLookupParamAllItems"] = 18] = "MetaDataLookupParamAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataLookupTransitionAllItems"] = 370] = "MetaDataLookupTransitionAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataOperationAllItems"] = 1761] = "MetaDataOperationAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataOperationTypeAllItems"] = 1759] = "MetaDataOperationTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataQueryAllItems"] = 19] = "MetaDataQueryAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSecurityGroupAllItems"] = 4] = "MetaDataSecurityGroupAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSecurityGroupAttributeAllItems"] = 88] = "MetaDataSecurityGroupAttributeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSecurityGroupItemAllItems"] = 85] = "MetaDataSecurityGroupItemAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSecurityItemRuleAllItems"] = 1499] = "MetaDataSecurityItemRuleAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSqlTypeAllItems"] = 23] = "MetaDataSqlTypeAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSystemAllItems"] = 1762] = "MetaDataSystemAllItems";
    DevwareFeatureAreasMetaDataLookups[DevwareFeatureAreasMetaDataLookups["MetaDataSystemTypeAllItems"] = 1758] = "MetaDataSystemTypeAllItems";
})(DevwareFeatureAreasMetaDataLookups || (DevwareFeatureAreasMetaDataLookups = {}));
// Generated Classes for MetaData service
class DwFeatureAreaMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwFeatureAreaMetaDataAttributes();
        this.Relations = new DwFeatureAreaMetaDataRelations();
        this.ItemDetail.itemId = 3772;
        this.ItemDetail.itemName = 'dw_FeatureArea';
        this.ItemDetail.keyName = 'FeatureAreaId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwFeatureAreaMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureArea.';
        // Attributes
        this.FeatureAreaId = new DwItemAttribute(this.i, 'FeatureAreaId');
        this.FeatureAreaName = new DwItemAttribute(this.i, 'FeatureAreaName');
        this.FeatureAreaMeaning = new DwItemAttribute(this.i, 'FeatureAreaMeaning');
        this.FeatureAreaDescription = new DwItemAttribute(this.i, 'FeatureAreaDescription');
        this.FeatureAreaConfig = new DwItemAttribute(this.i, 'FeatureAreaConfig');
        this.MetaDataDatabaseId = new DwItemAttribute(this.i, 'MetaDataDatabaseId');
        this.SchemaList = new DwItemAttribute(this.i, 'SchemaList');
        this.IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwFeatureAreaMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Database */
        this.DwMetaDataDatabase = new DwItemRelationship('dw_MetaDataDatabase|dw_FeatureArea|MetaDataDatabaseId', 'DwMetaDataDatabase', 'DwMetaDataDatabase');
        /** Relation: Feature Area Detail */
        this.DwFeatureAreaDetail = new DwItemRelationship('dw_FeatureArea|dw_FeatureAreaDetail|FeatureAreaId', 'DwFeatureAreaDetail', 'DwFeatureAreaDetail');
    }
}
;
class DwFeatureAreaDetailMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwFeatureAreaDetailMetaDataAttributes();
        this.Relations = new DwFeatureAreaDetailMetaDataRelations();
        this.ItemDetail.itemId = 3767;
        this.ItemDetail.itemName = 'dw_FeatureAreaDetail';
        this.ItemDetail.keyName = 'FeatureAreaDetailId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwFeatureAreaDetailMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureAreaDetail.';
        // Attributes
        this.FeatureAreaDetailId = new DwItemAttribute(this.i, 'FeatureAreaDetailId');
        this.FeatureAreaId = new DwItemAttribute(this.i, 'FeatureAreaId');
        this.FeatureAreaDetailTypeId = new DwItemAttribute(this.i, 'FeatureAreaDetailTypeId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.ReferenceKeyValue = new DwItemAttribute(this.i, 'ReferenceKeyValue');
        this.ReferenceDisplay = new DwItemAttribute(this.i, 'ReferenceDisplay');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwFeatureAreaDetailMetaDataRelations {
    constructor() {
        /** Relation: Feature Area */
        this.DwFeatureArea = new DwItemRelationship('dw_FeatureArea|dw_FeatureAreaDetail|FeatureAreaId', 'DwFeatureArea', 'DwFeatureArea');
        /** Relation: Feature Area Detail Type */
        this.DwFeatureAreaDetailType = new DwItemRelationship('dw_FeatureAreaDetailType|dw_FeatureAreaDetail|FeatureAreaDetailTypeId', 'DwFeatureAreaDetailType', 'DwFeatureAreaDetailType');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_FeatureAreaDetail|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
    }
}
;
class DwFeatureAreaDetailGroupMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwFeatureAreaDetailGroupMetaDataAttributes();
        this.Relations = new DwFeatureAreaDetailGroupMetaDataRelations();
        this.ItemDetail.itemId = 3798;
        this.ItemDetail.itemName = 'dw_FeatureAreaDetailGroup';
        this.ItemDetail.keyName = 'FeatureAreaDetailGroupId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwFeatureAreaDetailGroupMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureAreaDetailGroup.';
        // Attributes
        this.FeatureAreaDetailGroupId = new DwItemAttribute(this.i, 'FeatureAreaDetailGroupId');
        this.DetailGroupDisplay = new DwItemAttribute(this.i, 'DetailGroupDisplay');
        this.DetailGroupMeaning = new DwItemAttribute(this.i, 'DetailGroupMeaning');
        this.IconClass = new DwItemAttribute(this.i, 'IconClass');
        this.DetailGroupOrder = new DwItemAttribute(this.i, 'DetailGroupOrder');
    }
}
class DwFeatureAreaDetailGroupMetaDataRelations {
    constructor() {
        /** Relation: Feature Area Detail Type */
        this.DwFeatureAreaDetailType = new DwItemRelationship('dw_FeatureAreaDetailGroup|dw_FeatureAreaDetailType|FeatureAreaDetailGroupId', 'DwFeatureAreaDetailType', 'DwFeatureAreaDetailType');
    }
}
;
class DwFeatureAreaDetailTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwFeatureAreaDetailTypeMetaDataAttributes();
        this.Relations = new DwFeatureAreaDetailTypeMetaDataRelations();
        this.ItemDetail.itemId = 3766;
        this.ItemDetail.itemName = 'dw_FeatureAreaDetailType';
        this.ItemDetail.keyName = 'FeatureAreaDetailTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwFeatureAreaDetailTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_FeatureAreaDetailType.';
        // Attributes
        this.FeatureAreaDetailTypeId = new DwItemAttribute(this.i, 'FeatureAreaDetailTypeId');
        this.DetailTypeDisplay = new DwItemAttribute(this.i, 'DetailTypeDisplay');
        this.DetailTypeMeaning = new DwItemAttribute(this.i, 'DetailTypeMeaning');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.FeatureAreaDetailGroupId = new DwItemAttribute(this.i, 'FeatureAreaDetailGroupId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.ItemReferenceOnly = new DwItemAttribute(this.i, 'ItemReferenceOnly');
    }
}
class DwFeatureAreaDetailTypeMetaDataRelations {
    constructor() {
        /** Relation: Feature Area Detail Group */
        this.DwFeatureAreaDetailGroup = new DwItemRelationship('dw_FeatureAreaDetailGroup|dw_FeatureAreaDetailType|FeatureAreaDetailGroupId', 'DwFeatureAreaDetailGroup', 'DwFeatureAreaDetailGroup');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_FeatureAreaDetailType|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Feature Area Detail */
        this.DwFeatureAreaDetail = new DwItemRelationship('dw_FeatureAreaDetailType|dw_FeatureAreaDetail|FeatureAreaDetailTypeId', 'DwFeatureAreaDetail', 'DwFeatureAreaDetail');
    }
}
;
class DwMetaDataAttributeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataAttributeMetaDataAttributes();
        this.Relations = new DwMetaDataAttributeMetaDataRelations();
        this.ItemDetail.itemId = 25;
        this.ItemDetail.itemName = 'dw_MetaDataAttribute';
        this.ItemDetail.keyName = 'MetaDataAttributeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataAttributeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttribute.';
        // Attributes
        this.MetaDataAttributeId = new DwItemAttribute(this.i, 'MetaDataAttributeId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.AttributeName = new DwItemAttribute(this.i, 'AttributeName');
        this.AttributeLength = new DwItemAttribute(this.i, 'AttributeLength');
        this.Display = new DwItemAttribute(this.i, 'Display');
        this.MetaDataAttributeTypeId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeId');
        this.MetaDataAttributeDefinitionId = new DwItemAttribute(this.i, 'MetaDataAttributeDefinitionId');
        this.MetaDataSqlTypeId = new DwItemAttribute(this.i, 'MetaDataSqlTypeId');
        this.AllowNull = new DwItemAttribute(this.i, 'AllowNull');
        this.AttributeIndex = new DwItemAttribute(this.i, 'AttributeIndex');
        this.IsKey = new DwItemAttribute(this.i, 'IsKey');
        this.ReferenceMetaDataItemId = new DwItemAttribute(this.i, 'ReferenceMetaDataItemId');
        this.IsActive = new DwItemAttribute(this.i, 'IsActive');
        this.Layer = new DwItemAttribute(this.i, 'Layer');
        this.IsCustomAttribute = new DwItemAttribute(this.i, 'IsCustomAttribute');
        this.CustomAttributeIndex = new DwItemAttribute(this.i, 'CustomAttributeIndex');
        this.MetaDataControlTypeId = new DwItemAttribute(this.i, 'MetaDataControlTypeId');
        this.MaxLength = new DwItemAttribute(this.i, 'MaxLength');
        this.MinValue = new DwItemAttribute(this.i, 'MinValue');
        this.MaxValue = new DwItemAttribute(this.i, 'MaxValue');
        this.Decimals = new DwItemAttribute(this.i, 'Decimals');
        this.AlwaysRequired = new DwItemAttribute(this.i, 'AlwaysRequired');
        this.CodeSetId = new DwItemAttribute(this.i, 'CodeSetId');
        this.MetaDataLookupId = new DwItemAttribute(this.i, 'MetaDataLookupId');
        this.MetaDataAttributeFormatId = new DwItemAttribute(this.i, 'MetaDataAttributeFormatId');
        this.DefaultValue = new DwItemAttribute(this.i, 'DefaultValue');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.LongDisplay = new DwItemAttribute(this.i, 'LongDisplay');
        this.MetaDataLookupParamAttribute1Id = new DwItemAttribute(this.i, 'MetaDataLookupParamAttribute1Id');
        this.MetaDatalookupParamAttribute2Id = new DwItemAttribute(this.i, 'MetaDatalookupParamAttribute2Id');
        this.UseGmtDateTime = new DwItemAttribute(this.i, 'UseGmtDateTime');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.IsLookup = new DwItemAttribute(this.i, 'IsLookup');
        this.ReferenceIsParent = new DwItemAttribute(this.i, 'ReferenceIsParent');
        this.ExcludeFromHistory = new DwItemAttribute(this.i, 'ExcludeFromHistory');
    }
}
class DwMetaDataAttributeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute Format - Format */
        this.DwMetaDataAttributeFormatByMetaDataAttributeFormatId = new DwItemRelationship('dw_MetaDataAttributeFormat|dw_MetaDataAttribute|MetaDataAttributeFormatId', 'MetaDataAttributeFormatIdDwMetaDataAttributeFormat', 'MetaDataAttributeFormatIdDwMetaDataAttributeFormat');
        /** Relation: Meta Data Attribute Type */
        this.DwMetaDataAttributeType = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttribute|MetaDataAttributeTypeId', 'DwMetaDataAttributeType', 'DwMetaDataAttributeType');
        /** Relation: Meta Data Control Type */
        this.DwMetaDataControlType = new DwItemRelationship('dw_MetaDataControlType|dw_MetaDataAttribute|MetaDataControlTypeId', 'DwMetaDataControlType', 'DwMetaDataControlType');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataAttribute|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Meta Data Item - Reference Item */
        this.DwMetaDataItemByReferenceMetaDataItemId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataItem|ReferenceMetaDataItemId', 'ReferenceDwMetaDataItem', 'ReferenceDwMetaDataItem');
        /** Relation: Meta Data Lookup */
        this.DwMetaDataLookup = new DwItemRelationship('dw_MetaDataLookup|dw_MetaDataAttribute|MetaDataLookupId', 'DwMetaDataLookup', 'DwMetaDataLookup');
        /** Relation: Meta Data Attribute - Lookup Param 1 - One */
        this.DwMetaDataAttributeByMetaDataLookupParamAttribute1Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataAttribute|MetaDataLookupParamAttribute1Id', 'MetaDataLookupParamAttribute1IdDwMetaDataAttribute', 'MetaDataLookupParamAttribute1IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Lookup Param 2 - One */
        this.DwMetaDataAttributeByMetaDatalookupParamAttribute2Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataAttribute|MetaDatalookupParamAttribute2Id', 'MetaDatalookupParamAttribute2IdDwMetaDataAttribute', 'MetaDatalookupParamAttribute2IdDwMetaDataAttribute');
        /** Relation: Meta Data Sql Type */
        this.DwMetaDataSqlType = new DwItemRelationship('dw_MetaDataSqlType|dw_MetaDataAttribute|MetaDataSqlTypeId', 'DwMetaDataSqlType', 'DwMetaDataSqlType');
        /** Relation: Relationships - Pk - Many */
        this.DwMetaDataItemRelationshipByPkMetaDataAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataItemRelationship|PkMetaDataAttributeId', 'PkDwMetaDataItemRelationship', 'PkDwMetaDataItemRelationship');
        /** Relation: Relationships - Fk - Many */
        this.DwMetaDataItemRelationshipByFkMetaDataAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataItemRelationship|FkMetaDataAttributeId', 'FkDwMetaDataItemRelationship', 'FkDwMetaDataItemRelationship');
        /** Relation: Meta Data Lookup - Additional Attribute1 - Many */
        this.DwMetaDataLookupByAdditionalAttribute1Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute1Id', 'AdditionalAttribute1IdDwMetaDataLookup', 'AdditionalAttribute1IdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Additional Attribute2 - Many */
        this.DwMetaDataLookupByAdditionalAttribute2Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute2Id', 'AdditionalAttribute2IdDwMetaDataLookup', 'AdditionalAttribute2IdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Additional Attribute3 - Many */
        this.DwMetaDataLookupByAdditionalAttribute3Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute3Id', 'AdditionalAttribute3IdDwMetaDataLookup', 'AdditionalAttribute3IdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Additional Attribute4 - Many */
        this.DwMetaDataLookupByAdditionalAttribute4Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute4Id', 'AdditionalAttribute4IdDwMetaDataLookup', 'AdditionalAttribute4IdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Transition Reference Attribute1 - Many */
        this.DwMetaDataLookupByTransitionReferenceAttribute1Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute1Id', 'TransitionReferenceAttribute1IdDwMetaDataLookup', 'TransitionReferenceAttribute1IdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Transition Reference Attribute2 - Many */
        this.DwMetaDataLookupByTransitionReferenceAttribute2Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute2Id', 'TransitionReferenceAttribute2IdDwMetaDataLookup', 'TransitionReferenceAttribute2IdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Key Attribute - Many */
        this.DwMetaDataLookupByKeyAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|KeyAttributeId', 'KeyAttributeIdDwMetaDataLookup', 'KeyAttributeIdDwMetaDataLookup');
        /** Relation: Meta Data Lookup - Group By Attribute - Many */
        this.DwMetaDataLookupByGroupByAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|GroupByAttributeId', 'GroupByAttributeIdDwMetaDataLookup', 'GroupByAttributeIdDwMetaDataLookup');
        /** Relation: Meta Data Lookup Param */
        this.DwMetaDataLookupParam = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookupParam|MetaDataAttributeId', 'DwMetaDataLookupParam', 'DwMetaDataLookupParam');
        /** Relation: Security Group Attribute */
        this.DwMetaDataSecurityGroupAttribute = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataSecurityGroupAttribute|MetaDataAttributeId', 'DwMetaDataSecurityGroupAttribute', 'DwMetaDataSecurityGroupAttribute');
    }
}
;
class DwMetaDataAttributeFormatMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataAttributeFormatMetaDataAttributes();
        this.Relations = new DwMetaDataAttributeFormatMetaDataRelations();
        this.ItemDetail.itemId = 78;
        this.ItemDetail.itemName = 'dw_MetaDataAttributeFormat';
        this.ItemDetail.keyName = 'MetaDataAttributeFormatid';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataAttributeFormatMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeFormat.';
        // Attributes
        this.MetaDataAttributeFormatid = new DwItemAttribute(this.i, 'MetaDataAttributeFormatid');
        this.FormatDisplay = new DwItemAttribute(this.i, 'FormatDisplay');
        this.FormatCode = new DwItemAttribute(this.i, 'FormatCode');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataAttributeFormatMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute - Many */
        this.DwMetaDataAttributeByMetaDataAttributeFormatId = new DwItemRelationship('dw_MetaDataAttributeFormat|dw_MetaDataAttribute|MetaDataAttributeFormatId', 'MetaDataAttributeFormatIdDwMetaDataAttribute', 'MetaDataAttributeFormatIdDwMetaDataAttribute');
    }
}
;
class DwMetaDataAttributeTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataAttributeTypeMetaDataAttributes();
        this.Relations = new DwMetaDataAttributeTypeMetaDataRelations();
        this.ItemDetail.itemId = 87;
        this.ItemDetail.itemName = 'dw_MetaDataAttributeType';
        this.ItemDetail.keyName = 'MetaDataAttributeTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataAttributeTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeType.';
        // Attributes
        this.MetaDataAttributeTypeId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeId');
        this.AttributeTypeName = new DwItemAttribute(this.i, 'AttributeTypeName');
        this.MetaDataDotNetTypeId = new DwItemAttribute(this.i, 'MetaDataDotNetTypeId');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataAttributeTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Dot Net Type */
        this.DwMetaDataDotNetType = new DwItemRelationship('dw_MetaDataDotNetType|dw_MetaDataAttributeType|MetaDataDotNetTypeId', 'DwMetaDataDotNetType', 'DwMetaDataDotNetType');
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttribute|MetaDataAttributeTypeId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Meta Data Attribute Type Comparer Map */
        this.DwMetaDataAttributeTypeComparerMap = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttributeTypeComparerMap|MetaDataAttributeTypeId', 'DwMetaDataAttributeTypeComparerMap', 'DwMetaDataAttributeTypeComparerMap');
        /** Relation: Meta Data Attribute Type Control Type Map */
        this.DwMetaDataAttributeTypeControlTypeMap = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataAttributeTypeId', 'DwMetaDataAttributeTypeControlTypeMap', 'DwMetaDataAttributeTypeControlTypeMap');
        /** Relation: Meta Data Attribute Type Sql Type Map */
        this.DwMetaDataAttributeTypeSqlTypeMap = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataAttributeTypeId', 'DwMetaDataAttributeTypeSqlTypeMap', 'DwMetaDataAttributeTypeSqlTypeMap');
        /** Relation: Meta Data Comparer - Alt First Value Attribute Type - Many */
        this.DwMetaDataComparerByAltFirstValueAttributeTypeId = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataComparer|AltFirstValueAttributeTypeId', 'AltFirstValueAttributeTypeIdDwMetaDataComparer', 'AltFirstValueAttributeTypeIdDwMetaDataComparer');
    }
}
;
class DwMetaDataAttributeTypeComparerMapMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataAttributeTypeComparerMapMetaDataAttributes();
        this.Relations = new DwMetaDataAttributeTypeComparerMapMetaDataRelations();
        this.ItemDetail.itemId = 2;
        this.ItemDetail.itemName = 'dw_MetaDataAttributeTypeComparerMap';
        this.ItemDetail.keyName = 'MetaDataAttributeTypeComparerMapId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataAttributeTypeComparerMapMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeTypeComparerMap.';
        // Attributes
        this.MetaDataAttributeTypeComparerMapId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeComparerMapId');
        this.MetaDataAttributeTypeId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeId');
        this.MetaDataComparerId = new DwItemAttribute(this.i, 'MetaDataComparerId');
        this.IsDefault = new DwItemAttribute(this.i, 'IsDefault');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataAttributeTypeComparerMapMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute Type */
        this.DwMetaDataAttributeType = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttributeTypeComparerMap|MetaDataAttributeTypeId', 'DwMetaDataAttributeType', 'DwMetaDataAttributeType');
        /** Relation: Meta Data Comparer */
        this.DwMetaDataComparer = new DwItemRelationship('dw_MetaDataComparer|dw_MetaDataAttributeTypeComparerMap|MetaDataComparerId', 'DwMetaDataComparer', 'DwMetaDataComparer');
    }
}
;
class DwMetaDataAttributeTypeControlTypeMapMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataAttributeTypeControlTypeMapMetaDataAttributes();
        this.Relations = new DwMetaDataAttributeTypeControlTypeMapMetaDataRelations();
        this.ItemDetail.itemId = 3;
        this.ItemDetail.itemName = 'dw_MetaDataAttributeTypeControlTypeMap';
        this.ItemDetail.keyName = 'MetaDataAttributeTypeControlTypeMapId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataAttributeTypeControlTypeMapMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeTypeControlTypeMap.';
        // Attributes
        this.MetaDataAttributeTypeControlTypeMapId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeControlTypeMapId');
        this.MetaDataAttributeTypeId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeId');
        this.MetaDataControlTypeId = new DwItemAttribute(this.i, 'MetaDataControlTypeId');
        this.IsDefault = new DwItemAttribute(this.i, 'IsDefault');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.IsLookup = new DwItemAttribute(this.i, 'IsLookup');
    }
}
class DwMetaDataAttributeTypeControlTypeMapMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute Type */
        this.DwMetaDataAttributeType = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataAttributeTypeId', 'DwMetaDataAttributeType', 'DwMetaDataAttributeType');
        /** Relation: Meta Data Control Type */
        this.DwMetaDataControlType = new DwItemRelationship('dw_MetaDataControlType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataControlTypeId', 'DwMetaDataControlType', 'DwMetaDataControlType');
    }
}
;
class DwMetaDataAttributeTypeSqlTypeMapMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataAttributeTypeSqlTypeMapMetaDataAttributes();
        this.Relations = new DwMetaDataAttributeTypeSqlTypeMapMetaDataRelations();
        this.ItemDetail.itemId = 5;
        this.ItemDetail.itemName = 'dw_MetaDataAttributeTypeSqlTypeMap';
        this.ItemDetail.keyName = 'MetaDataAttributeTypeSqlTypeMapId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataAttributeTypeSqlTypeMapMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataAttributeTypeSqlTypeMap.';
        // Attributes
        this.MetaDataAttributeTypeSqlTypeMapId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeSqlTypeMapId');
        this.MetaDataAttributeTypeId = new DwItemAttribute(this.i, 'MetaDataAttributeTypeId');
        this.MetaDataSqlTypeId = new DwItemAttribute(this.i, 'MetaDataSqlTypeId');
        this.IsDefault = new DwItemAttribute(this.i, 'IsDefault');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataAttributeTypeSqlTypeMapMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute Type */
        this.DwMetaDataAttributeType = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataAttributeTypeId', 'DwMetaDataAttributeType', 'DwMetaDataAttributeType');
        /** Relation: Meta Data Sql Type */
        this.DwMetaDataSqlType = new DwItemRelationship('dw_MetaDataSqlType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataSqlTypeId', 'DwMetaDataSqlType', 'DwMetaDataSqlType');
    }
}
;
class DwMetaDataCollectionMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataCollectionMetaDataAttributes();
        this.Relations = new DwMetaDataCollectionMetaDataRelations();
        this.ItemDetail.itemId = 2733;
        this.ItemDetail.itemName = 'dw_MetaDataCollection';
        this.ItemDetail.keyName = 'MetaDataCollectionId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataCollectionMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataCollection.';
        // Attributes
        this.MetaDataCollectionId = new DwItemAttribute(this.i, 'MetaDataCollectionId');
        this.MetaDataSystemId = new DwItemAttribute(this.i, 'MetaDataSystemId');
        this.CollectionDisplay = new DwItemAttribute(this.i, 'CollectionDisplay');
        this.CollectionMeaning = new DwItemAttribute(this.i, 'CollectionMeaning');
        this.DefaultMetaDataItemId = new DwItemAttribute(this.i, 'DefaultMetaDataItemId');
    }
}
class DwMetaDataCollectionMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item - Default Meta Data Item */
        this.DwMetaDataItemByDefaultMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataCollection|DefaultMetaDataItemId', 'DefaultDwMetaDataItem', 'DefaultDwMetaDataItem');
        /** Relation: Meta Data System */
        this.DwMetaDataSystem = new DwItemRelationship('dw_MetaDataSystem|dw_MetaDataCollection|MetaDataSystemId', 'DwMetaDataSystem', 'DwMetaDataSystem');
        /** Relation: Meta Data Operation */
        this.DwMetaDataOperation = new DwItemRelationship('dw_MetaDataCollection|dw_MetaDataOperation|MetaDataCollectionId', 'DwMetaDataOperation', 'DwMetaDataOperation');
    }
}
;
class DwMetaDataComparerMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataComparerMetaDataAttributes();
        this.Relations = new DwMetaDataComparerMetaDataRelations();
        this.ItemDetail.itemId = 6;
        this.ItemDetail.itemName = 'dw_MetaDataComparer';
        this.ItemDetail.keyName = 'MetaDataComparerId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataComparerMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataComparer.';
        // Attributes
        this.MetaDataComparerId = new DwItemAttribute(this.i, 'MetaDataComparerId');
        this.ComparerName = new DwItemAttribute(this.i, 'ComparerName');
        this.ComparerDisplay = new DwItemAttribute(this.i, 'ComparerDisplay');
        this.ComparerMeaning = new DwItemAttribute(this.i, 'ComparerMeaning');
        this.RequiresFirstValue = new DwItemAttribute(this.i, 'RequiresFirstValue');
        this.RequiresSecondValue = new DwItemAttribute(this.i, 'RequiresSecondValue');
        this.AllowUseOfFields = new DwItemAttribute(this.i, 'AllowUseOfFields');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.AltFirstValueAttributeTypeId = new DwItemAttribute(this.i, 'AltFirstValueAttributeTypeId');
    }
}
class DwMetaDataComparerMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute Type - Alternate First Value Type */
        this.DwMetaDataAttributeTypeByAltFirstValueAttributeTypeId = new DwItemRelationship('dw_MetaDataAttributeType|dw_MetaDataComparer|AltFirstValueAttributeTypeId', 'AltFirstValueAttributeTypeIdDwMetaDataAttributeType', 'AltFirstValueAttributeTypeIdDwMetaDataAttributeType');
        /** Relation: Meta Data Attribute Type Comparer Map */
        this.DwMetaDataAttributeTypeComparerMap = new DwItemRelationship('dw_MetaDataComparer|dw_MetaDataAttributeTypeComparerMap|MetaDataComparerId', 'DwMetaDataAttributeTypeComparerMap', 'DwMetaDataAttributeTypeComparerMap');
    }
}
;
class DwMetaDataControlTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataControlTypeMetaDataAttributes();
        this.Relations = new DwMetaDataControlTypeMetaDataRelations();
        this.ItemDetail.itemId = 9;
        this.ItemDetail.itemName = 'dw_MetaDataControlType';
        this.ItemDetail.keyName = 'MetaDataControlTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataControlTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataControlType.';
        // Attributes
        this.MetaDataControlTypeId = new DwItemAttribute(this.i, 'MetaDataControlTypeId');
        this.ControlTypeName = new DwItemAttribute(this.i, 'ControlTypeName');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataControlTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataControlType|dw_MetaDataAttribute|MetaDataControlTypeId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Meta Data Attribute Type Control Type Map */
        this.DwMetaDataAttributeTypeControlTypeMap = new DwItemRelationship('dw_MetaDataControlType|dw_MetaDataAttributeTypeControlTypeMap|MetaDataControlTypeId', 'DwMetaDataAttributeTypeControlTypeMap', 'DwMetaDataAttributeTypeControlTypeMap');
    }
}
;
class DwMetaDataDatabaseMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataDatabaseMetaDataAttributes();
        this.Relations = new DwMetaDataDatabaseMetaDataRelations();
        this.ItemDetail.itemId = 86;
        this.ItemDetail.itemName = 'dw_MetaDataDatabase';
        this.ItemDetail.keyName = 'MetaDataDatabaseId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataDatabaseMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataDatabase.';
        // Attributes
        this.MetaDataDatabaseId = new DwItemAttribute(this.i, 'MetaDataDatabaseId');
        this.DatabaseDisplayName = new DwItemAttribute(this.i, 'DatabaseDisplayName');
        this.DatabaseMeaning = new DwItemAttribute(this.i, 'DatabaseMeaning');
        this.MetaDataDatabaseSystemId = new DwItemAttribute(this.i, 'MetaDataDatabaseSystemId');
        this.DatabaseConnectionString = new DwItemAttribute(this.i, 'DatabaseConnectionString');
        this.DatabaseCatalogName = new DwItemAttribute(this.i, 'DatabaseCatalogName');
        this.DatabaseConnectionStringSetting = new DwItemAttribute(this.i, 'DatabaseConnectionStringSetting');
        this.DatabaseCatalogNameSetting = new DwItemAttribute(this.i, 'DatabaseCatalogNameSetting');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataDatabaseMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Database System */
        this.DwMetaDataDatabaseSystem = new DwItemRelationship('dw_MetaDataDatabaseSystem|dw_MetaDataDatabase|MetaDataDatabaseSystemId', 'DwMetaDataDatabaseSystem', 'DwMetaDataDatabaseSystem');
        /** Relation: Feature Area */
        this.DwFeatureArea = new DwItemRelationship('dw_MetaDataDatabase|dw_FeatureArea|MetaDataDatabaseId', 'DwFeatureArea', 'DwFeatureArea');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataDatabase|dw_MetaDataItem|MetaDataDatabaseId', 'DwMetaDataItem', 'DwMetaDataItem');
    }
}
;
class DwMetaDataDatabaseSystemMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataDatabaseSystemMetaDataAttributes();
        this.Relations = new DwMetaDataDatabaseSystemMetaDataRelations();
        this.ItemDetail.itemId = 10;
        this.ItemDetail.itemName = 'dw_MetaDataDatabaseSystem';
        this.ItemDetail.keyName = 'MetaDataDatabaseSystemId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataDatabaseSystemMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataDatabaseSystem.';
        // Attributes
        this.MetaDataDatabaseSystemId = new DwItemAttribute(this.i, 'MetaDataDatabaseSystemId');
        this.DatabaseType = new DwItemAttribute(this.i, 'DatabaseType');
        this.DataUtilTypeName = new DwItemAttribute(this.i, 'DataUtilTypeName');
        this.QueryEngineTypeName = new DwItemAttribute(this.i, 'QueryEngineTypeName');
        this.SchemaServiceTypeName = new DwItemAttribute(this.i, 'SchemaServiceTypeName');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.DatabaseSystemKey = new DwItemAttribute(this.i, 'DatabaseSystemKey');
    }
}
class DwMetaDataDatabaseSystemMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Database */
        this.DwMetaDataDatabase = new DwItemRelationship('dw_MetaDataDatabaseSystem|dw_MetaDataDatabase|MetaDataDatabaseSystemId', 'DwMetaDataDatabase', 'DwMetaDataDatabase');
        /** Relation: Meta Data Sql Type */
        this.DwMetaDataSqlType = new DwItemRelationship('dw_MetaDataDatabaseSystem|dw_MetaDataSqlType|MetaDataDatabaseSystemId', 'DwMetaDataSqlType', 'DwMetaDataSqlType');
    }
}
;
class DwMetaDataDotNetTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataDotNetTypeMetaDataAttributes();
        this.Relations = new DwMetaDataDotNetTypeMetaDataRelations();
        this.ItemDetail.itemId = 12;
        this.ItemDetail.itemName = 'dw_MetaDataDotNetType';
        this.ItemDetail.keyName = 'MetaDataDotNetTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataDotNetTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataDotNetType.';
        // Attributes
        this.MetaDataDotNetTypeId = new DwItemAttribute(this.i, 'MetaDataDotNetTypeId');
        this.DotNetType = new DwItemAttribute(this.i, 'DotNetType');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataDotNetTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute Type */
        this.DwMetaDataAttributeType = new DwItemRelationship('dw_MetaDataDotNetType|dw_MetaDataAttributeType|MetaDataDotNetTypeId', 'DwMetaDataAttributeType', 'DwMetaDataAttributeType');
    }
}
;
class DwMetaDataEnvironmentOfRecordTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataEnvironmentOfRecordTypeMetaDataAttributes();
        this.Relations = new DwMetaDataEnvironmentOfRecordTypeMetaDataRelations();
        this.ItemDetail.itemId = 3774;
        this.ItemDetail.itemName = 'dw_MetaDataEnvironmentOfRecordType';
        this.ItemDetail.keyName = 'MetaDataEnvironmentOfRecordTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataEnvironmentOfRecordTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataEnvironmentOfRecordType.';
        // Attributes
        this.MetaDataEnvironmentOfRecordTypeId = new DwItemAttribute(this.i, 'MetaDataEnvironmentOfRecordTypeId');
        this.EnvironmentOfRecordType = new DwItemAttribute(this.i, 'EnvironmentOfRecordType');
        this.EnvironmentOfRecordDescription = new DwItemAttribute(this.i, 'EnvironmentOfRecordDescription');
    }
}
class DwMetaDataEnvironmentOfRecordTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataEnvironmentOfRecordType|dw_MetaDataItem|MetaDataEnvironmentOfRecordTypeId', 'DwMetaDataItem', 'DwMetaDataItem');
    }
}
;
class DwMetaDataEventMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataEventMetaDataAttributes();
        this.Relations = new DwMetaDataEventMetaDataRelations();
        this.ItemDetail.itemId = 2460;
        this.ItemDetail.itemName = 'dw_MetaDataEvent';
        this.ItemDetail.keyName = 'MetaDataEventId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataEventMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataEvent.';
        // Attributes
        this.MetaDataEventId = new DwItemAttribute(this.i, 'MetaDataEventId');
        this.EventName = new DwItemAttribute(this.i, 'EventName');
        this.MainMetaDataItemId = new DwItemAttribute(this.i, 'MainMetaDataItemId');
        this.EventConfigJson = new DwItemAttribute(this.i, 'EventConfigJson');
    }
}
class DwMetaDataEventMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item - Main Meta Data Item */
        this.DwMetaDataItemByMainMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataEvent|MainMetaDataItemId', 'MainDwMetaDataItem', 'MainDwMetaDataItem');
    }
}
;
class DwMetaDataGroupMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataGroupMetaDataAttributes();
        this.Relations = new DwMetaDataGroupMetaDataRelations();
        this.ItemDetail.itemId = 2512;
        this.ItemDetail.itemName = 'dw_MetaDataGroup';
        this.ItemDetail.keyName = 'MetaDataGroupId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataGroupMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataGroup.';
        // Attributes
        this.MetaDataGroupId = new DwItemAttribute(this.i, 'MetaDataGroupId');
        this.GroupName = new DwItemAttribute(this.i, 'GroupName');
        this.IsSystemGroup = new DwItemAttribute(this.i, 'IsSystemGroup');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
    }
}
class DwMetaDataGroupMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataGroup|dw_MetaDataItem|MetaDataGroupId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Security Group */
        this.DwMetaDataSecurityGroup = new DwItemRelationship('dw_MetaDataGroup|dw_MetaDataSecurityGroup|MetaDataGroupId', 'DwMetaDataSecurityGroup', 'DwMetaDataSecurityGroup');
    }
}
;
class DwMetaDataHistoryMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataHistoryMetaDataAttributes();
        this.Relations = new DwMetaDataHistoryMetaDataRelations();
        this.ItemDetail.itemId = 3765;
        this.ItemDetail.itemName = 'dw_MetaDataHistory';
        this.ItemDetail.keyName = 'MetaDataHistoryId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataHistoryMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataHistory.';
        // Attributes
        this.MetaDataHistoryId = new DwItemAttribute(this.i, 'MetaDataHistoryId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.KeyValue = new DwItemAttribute(this.i, 'KeyValue');
        this.MetaDataHistoryTypeId = new DwItemAttribute(this.i, 'MetaDataHistoryTypeId');
        this.RecordDescription = new DwItemAttribute(this.i, 'RecordDescription');
        this.ChangeSummary = new DwItemAttribute(this.i, 'ChangeSummary');
        this.AttributeChangeJSON = new DwItemAttribute(this.i, 'AttributeChangeJSON');
        this.ChangedByApplicationUserId = new DwItemAttribute(this.i, 'ChangedByApplicationUserId');
        this.ChangedByAuthenticatedUserId = new DwItemAttribute(this.i, 'ChangedByAuthenticatedUserId');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ParentMetaDataItemId = new DwItemAttribute(this.i, 'ParentMetaDataItemId');
        this.ParentKeyValue = new DwItemAttribute(this.i, 'ParentKeyValue');
        this.MetaDataImportId = new DwItemAttribute(this.i, 'MetaDataImportId');
    }
}
class DwMetaDataHistoryMetaDataRelations {
    constructor() {
        /** Relation: Meta Data History Type */
        this.DwMetaDataHistoryType = new DwItemRelationship('dw_MetaDataHistoryType|dw_MetaDataHistory|MetaDataHistoryTypeId', 'DwMetaDataHistoryType', 'DwMetaDataHistoryType');
        /** Relation: Meta Data Import */
        this.DwMetaDataImport = new DwItemRelationship('dw_MetaDataImport|dw_MetaDataHistory|MetaDataImportId', 'DwMetaDataImport', 'DwMetaDataImport');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataHistory|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Meta Data Item - Parent Meta Data Item */
        this.DwMetaDataItemByParentMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataHistory|ParentMetaDataItemId', 'ParentDwMetaDataItem', 'ParentDwMetaDataItem');
        /** Relation: Meta Data History Detail */
        this.DwMetaDataHistoryDetail = new DwItemRelationship('dw_MetaDataHistory|dw_MetaDataHistoryDetail|MetaDataHistoryId', 'DwMetaDataHistoryDetail', 'DwMetaDataHistoryDetail');
    }
}
;
class DwMetaDataHistoryDetailMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataHistoryDetailMetaDataAttributes();
        this.Relations = new DwMetaDataHistoryDetailMetaDataRelations();
        this.ItemDetail.itemId = 3764;
        this.ItemDetail.itemName = 'dw_MetaDataHistoryDetail';
        this.ItemDetail.keyName = 'MetaDataHistoryDetailId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataHistoryDetailMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataHistoryDetail.';
        // Attributes
        this.MetaDataHistoryDetailId = new DwItemAttribute(this.i, 'MetaDataHistoryDetailId');
        this.MetaDataHistoryId = new DwItemAttribute(this.i, 'MetaDataHistoryId');
        this.PreviousEntityJSON = new DwItemAttribute(this.i, 'PreviousEntityJSON');
        this.NewEntityJSON = new DwItemAttribute(this.i, 'NewEntityJSON');
        this.AttributeChangesJSON = new DwItemAttribute(this.i, 'AttributeChangesJSON');
    }
}
class DwMetaDataHistoryDetailMetaDataRelations {
    constructor() {
        /** Relation: Meta Data History */
        this.DwMetaDataHistory = new DwItemRelationship('dw_MetaDataHistory|dw_MetaDataHistoryDetail|MetaDataHistoryId', 'DwMetaDataHistory', 'DwMetaDataHistory');
    }
}
;
class DwMetaDataHistoryTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataHistoryTypeMetaDataAttributes();
        this.Relations = new DwMetaDataHistoryTypeMetaDataRelations();
        this.ItemDetail.itemId = 3763;
        this.ItemDetail.itemName = 'dw_MetaDataHistoryType';
        this.ItemDetail.keyName = 'MetaDataHistoryTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataHistoryTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataHistoryType.';
        // Attributes
        this.MetaDataHistoryTypeId = new DwItemAttribute(this.i, 'MetaDataHistoryTypeId');
        this.MetaDataHistoryType = new DwItemAttribute(this.i, 'MetaDataHistoryType');
        this.IconCss = new DwItemAttribute(this.i, 'IconCss');
    }
}
class DwMetaDataHistoryTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data History */
        this.DwMetaDataHistory = new DwItemRelationship('dw_MetaDataHistoryType|dw_MetaDataHistory|MetaDataHistoryTypeId', 'DwMetaDataHistory', 'DwMetaDataHistory');
    }
}
;
class DwMetaDataImportMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataImportMetaDataAttributes();
        this.Relations = new DwMetaDataImportMetaDataRelations();
        this.ItemDetail.itemId = 3771;
        this.ItemDetail.itemName = 'dw_MetaDataImport';
        this.ItemDetail.keyName = 'MetaDataImportId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataImportMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataImport.';
        // Attributes
        this.MetaDataImportId = new DwItemAttribute(this.i, 'MetaDataImportId');
        this.DesignSessionId = new DwItemAttribute(this.i, 'DesignSessionId');
        this.ImportRequestJSON = new DwItemAttribute(this.i, 'ImportRequestJSON');
        this.ImportResultJSON = new DwItemAttribute(this.i, 'ImportResultJSON');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.ImportDescription = new DwItemAttribute(this.i, 'ImportDescription');
        this.ImportResultDescription = new DwItemAttribute(this.i, 'ImportResultDescription');
        this.ImportStartDateTime = new DwItemAttribute(this.i, 'ImportStartDateTime');
        this.ImportCompletionDateTime = new DwItemAttribute(this.i, 'ImportCompletionDateTime');
        this.IsSuccess = new DwItemAttribute(this.i, 'IsSuccess');
    }
}
class DwMetaDataImportMetaDataRelations {
    constructor() {
        /** Relation: Meta Data History */
        this.DwMetaDataHistory = new DwItemRelationship('dw_MetaDataImport|dw_MetaDataHistory|MetaDataImportId', 'DwMetaDataHistory', 'DwMetaDataHistory');
        /** Relation: Meta Data Import Log */
        this.DwMetaDataImportLog = new DwItemRelationship('dw_MetaDataImport|dw_MetaDataImportLog|MetaDataImportId', 'DwMetaDataImportLog', 'DwMetaDataImportLog');
    }
}
;
class DwMetaDataImportLogMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataImportLogMetaDataAttributes();
        this.Relations = new DwMetaDataImportLogMetaDataRelations();
        this.ItemDetail.itemId = 3777;
        this.ItemDetail.itemName = 'dw_MetaDataImportLog';
        this.ItemDetail.keyName = 'MetaDataImportLogId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataImportLogMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataImportLog.';
        // Attributes
        this.MetaDataImportLogId = new DwItemAttribute(this.i, 'MetaDataImportLogId');
        this.MetaDataImportId = new DwItemAttribute(this.i, 'MetaDataImportId');
        this.LogId = new DwItemAttribute(this.i, 'LogId');
    }
}
class DwMetaDataImportLogMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Import */
        this.DwMetaDataImport = new DwItemRelationship('dw_MetaDataImport|dw_MetaDataImportLog|MetaDataImportId', 'DwMetaDataImport', 'DwMetaDataImport');
    }
}
;
class DwMetaDataItemMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataItemMetaDataAttributes();
        this.Relations = new DwMetaDataItemMetaDataRelations();
        this.ItemDetail.itemId = 69;
        this.ItemDetail.itemName = 'dw_MetaDataItem';
        this.ItemDetail.keyName = 'MetaDataItemId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataItemMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItem.';
        // Attributes
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.MetaDataDatabaseId = new DwItemAttribute(this.i, 'MetaDataDatabaseId');
        this.SchemaName = new DwItemAttribute(this.i, 'SchemaName');
        this.ItemName = new DwItemAttribute(this.i, 'ItemName');
        this.Display = new DwItemAttribute(this.i, 'Display');
        this.MetaDataItemTypeId = new DwItemAttribute(this.i, 'MetaDataItemTypeId');
        this.MetaDataItemStatusId = new DwItemAttribute(this.i, 'MetaDataItemStatusId');
        this.GenerateClientCode = new DwItemAttribute(this.i, 'GenerateClientCode');
        this.Layer = new DwItemAttribute(this.i, 'Layer');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.IsView = new DwItemAttribute(this.i, 'IsView');
        this.UniqueItemName = new DwItemAttribute(this.i, 'UniqueItemName');
        this.MetaDataGroupId = new DwItemAttribute(this.i, 'MetaDataGroupId');
        this.MetaDataSystemId = new DwItemAttribute(this.i, 'MetaDataSystemId');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.MetaDataEnvironmentOfRecordTypeId = new DwItemAttribute(this.i, 'MetaDataEnvironmentOfRecordTypeId');
        this.EnableHistory = new DwItemAttribute(this.i, 'EnableHistory');
    }
}
class DwMetaDataItemMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Database */
        this.DwMetaDataDatabase = new DwItemRelationship('dw_MetaDataDatabase|dw_MetaDataItem|MetaDataDatabaseId', 'DwMetaDataDatabase', 'DwMetaDataDatabase');
        /** Relation: Meta Data Environment Of Record Type */
        this.DwMetaDataEnvironmentOfRecordType = new DwItemRelationship('dw_MetaDataEnvironmentOfRecordType|dw_MetaDataItem|MetaDataEnvironmentOfRecordTypeId', 'DwMetaDataEnvironmentOfRecordType', 'DwMetaDataEnvironmentOfRecordType');
        /** Relation: Meta Data Group */
        this.DwMetaDataGroup = new DwItemRelationship('dw_MetaDataGroup|dw_MetaDataItem|MetaDataGroupId', 'DwMetaDataGroup', 'DwMetaDataGroup');
        /** Relation: Meta Data Item Status */
        this.DwMetaDataItemStatus = new DwItemRelationship('dw_MetaDataItemStatus|dw_MetaDataItem|MetaDataItemStatusId', 'DwMetaDataItemStatus', 'DwMetaDataItemStatus');
        /** Relation: Meta Data Item Type */
        this.DwMetaDataItemType = new DwItemRelationship('dw_MetaDataItemType|dw_MetaDataItem|MetaDataItemTypeId', 'DwMetaDataItemType', 'DwMetaDataItemType');
        /** Relation: Meta Data System */
        this.DwMetaDataSystem = new DwItemRelationship('dw_MetaDataSystem|dw_MetaDataItem|MetaDataSystemId', 'DwMetaDataSystem', 'DwMetaDataSystem');
        /** Relation: Feature Area Detail */
        this.DwFeatureAreaDetail = new DwItemRelationship('dw_MetaDataItem|dw_FeatureAreaDetail|MetaDataItemId', 'DwFeatureAreaDetail', 'DwFeatureAreaDetail');
        /** Relation: Feature Area Detail Type */
        this.DwFeatureAreaDetailType = new DwItemRelationship('dw_MetaDataItem|dw_FeatureAreaDetailType|MetaDataItemId', 'DwFeatureAreaDetailType', 'DwFeatureAreaDetailType');
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataAttribute|MetaDataItemId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Reference - Many */
        this.DwMetaDataAttributeByReferenceMetaDataItemId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataItem|ReferenceMetaDataItemId', 'ReferenceDwMetaDataAttribute', 'ReferenceDwMetaDataAttribute');
        /** Relation: Meta Data Collection - Default - Many */
        this.DwMetaDataCollectionByDefaultMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataCollection|DefaultMetaDataItemId', 'DefaultDwMetaDataCollection', 'DefaultDwMetaDataCollection');
        /** Relation: Meta Data Event - Main - Many */
        this.DwMetaDataEventByMainMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataEvent|MainMetaDataItemId', 'MainDwMetaDataEvent', 'MainDwMetaDataEvent');
        /** Relation: Meta Data History */
        this.DwMetaDataHistory = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataHistory|MetaDataItemId', 'DwMetaDataHistory', 'DwMetaDataHistory');
        /** Relation: Meta Data History - Parent - Many */
        this.DwMetaDataHistoryByParentMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataHistory|ParentMetaDataItemId', 'ParentDwMetaDataHistory', 'ParentDwMetaDataHistory');
        /** Relation: Relationships - Pk - Many */
        this.DwMetaDataItemRelationshipByPkMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataItemRelationship|PkMetaDataItemId', 'PkDwMetaDataItemRelationship', 'PkDwMetaDataItemRelationship');
        /** Relation: Relationships - Fk - Many */
        this.DwMetaDataItemRelationshipByFkMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataItemRelationship|FkMetaDataItemId', 'FkDwMetaDataItemRelationship', 'FkDwMetaDataItemRelationship');
        /** Relation: Meta Data Lookup */
        this.DwMetaDataLookup = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataLookup|MetaDataItemId', 'DwMetaDataLookup', 'DwMetaDataLookup');
        /** Relation: Meta Data Query */
        this.DwMetaDataQuery = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataQuery|MetaDataItemId', 'DwMetaDataQuery', 'DwMetaDataQuery');
        /** Relation: Security Group Item */
        this.DwMetaDataSecurityGroupItem = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataSecurityGroupItem|MetaDataItemId', 'DwMetaDataSecurityGroupItem', 'DwMetaDataSecurityGroupItem');
        /** Relation: Meta Data Security Item Rule */
        this.DwMetaDataSecurityItemRule = new DwItemRelationship('dw_MetaDataItem|MetaDataSecurityItemRule|MetaDataItemId', 'DwMetaDataSecurityItemRule', 'DwMetaDataSecurityItemRule');
    }
}
;
class DwMetaDataItemRelationshipMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataItemRelationshipMetaDataAttributes();
        this.Relations = new DwMetaDataItemRelationshipMetaDataRelations();
        this.ItemDetail.itemId = 28;
        this.ItemDetail.itemName = 'dw_MetaDataItemRelationship';
        this.ItemDetail.keyName = 'MetaDataItemRelationshipId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataItemRelationshipMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemRelationship.';
        // Attributes
        this.MetaDataItemRelationshipId = new DwItemAttribute(this.i, 'MetaDataItemRelationshipId');
        this.RelationshipName = new DwItemAttribute(this.i, 'RelationshipName');
        this.PkMetaDataItemId = new DwItemAttribute(this.i, 'PkMetaDataItemId');
        this.PkMetaDataAttributeId = new DwItemAttribute(this.i, 'PkMetaDataAttributeId');
        this.FkMetaDataItemId = new DwItemAttribute(this.i, 'FkMetaDataItemId');
        this.FkMetaDataAttributeId = new DwItemAttribute(this.i, 'FkMetaDataAttributeId');
        this.RelationshipTypeId = new DwItemAttribute(this.i, 'RelationshipTypeId');
        this.IsActive = new DwItemAttribute(this.i, 'IsActive');
        this.GenerateCode = new DwItemAttribute(this.i, 'GenerateCode');
        this.PkItemPropertyOverride = new DwItemAttribute(this.i, 'PkItemPropertyOverride');
        this.FkItemPropertyOverride = new DwItemAttribute(this.i, 'FkItemPropertyOverride');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.IsCustomRelationship = new DwItemAttribute(this.i, 'IsCustomRelationship');
        this.PhyiscalRelationshipName = new DwItemAttribute(this.i, 'PhyiscalRelationshipName');
        this.CascadeDelete = new DwItemAttribute(this.i, 'CascadeDelete');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.PkMetaDataAttribute2Id = new DwItemAttribute(this.i, 'PkMetaDataAttribute2Id');
        this.PkMetaDataAttribute3Id = new DwItemAttribute(this.i, 'PkMetaDataAttribute3Id');
        this.FkMetaDataAttribute2Id = new DwItemAttribute(this.i, 'FkMetaDataAttribute2Id');
        this.FkMetaDataAttribute3Id = new DwItemAttribute(this.i, 'FkMetaDataAttribute3Id');
    }
}
class DwMetaDataItemRelationshipMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute - Pk Meta Data Attribute */
        this.DwMetaDataAttributeByPkMetaDataAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataItemRelationship|PkMetaDataAttributeId', 'PkDwMetaDataAttribute', 'PkDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Fk Meta Data Attribute */
        this.DwMetaDataAttributeByFkMetaDataAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataItemRelationship|FkMetaDataAttributeId', 'FkDwMetaDataAttribute', 'FkDwMetaDataAttribute');
        /** Relation: Meta Data Item - Pk Meta Data Item */
        this.DwMetaDataItemByPkMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataItemRelationship|PkMetaDataItemId', 'PkDwMetaDataItem', 'PkDwMetaDataItem');
        /** Relation: Meta Data Item - Fk Meta Data Item */
        this.DwMetaDataItemByFkMetaDataItemId = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataItemRelationship|FkMetaDataItemId', 'FkDwMetaDataItem', 'FkDwMetaDataItem');
        /** Relation: Meta Data Item Relationship Type */
        this.DwMetaDataItemRelationshipType = new DwItemRelationship('dw_MetaDataItemRelationshipType|dw_MetaDataItemRelationship|RelationshipTypeId', 'DwMetaDataItemRelationshipType', 'DwMetaDataItemRelationshipType');
    }
}
;
class DwMetaDataItemRelationshipTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataItemRelationshipTypeMetaDataAttributes();
        this.Relations = new DwMetaDataItemRelationshipTypeMetaDataRelations();
        this.ItemDetail.itemId = 26;
        this.ItemDetail.itemName = 'dw_MetaDataItemRelationshipType';
        this.ItemDetail.keyName = 'RelationshipTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataItemRelationshipTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemRelationshipType.';
        // Attributes
        this.RelationshipTypeId = new DwItemAttribute(this.i, 'RelationshipTypeId');
        this.RelationshipTypeName = new DwItemAttribute(this.i, 'RelationshipTypeName');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataItemRelationshipTypeMetaDataRelations {
    constructor() {
        /** Relation: Relationships */
        this.DwMetaDataItemRelationship = new DwItemRelationship('dw_MetaDataItemRelationshipType|dw_MetaDataItemRelationship|RelationshipTypeId', 'DwMetaDataItemRelationship', 'DwMetaDataItemRelationship');
    }
}
;
class DwMetaDataItemStatusMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataItemStatusMetaDataAttributes();
        this.Relations = new DwMetaDataItemStatusMetaDataRelations();
        this.ItemDetail.itemId = 14;
        this.ItemDetail.itemName = 'dw_MetaDataItemStatus';
        this.ItemDetail.keyName = 'MetaDataItemStatusId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataItemStatusMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemStatus.';
        // Attributes
        this.MetaDataItemStatusId = new DwItemAttribute(this.i, 'MetaDataItemStatusId');
        this.ItemStatus = new DwItemAttribute(this.i, 'ItemStatus');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataItemStatusMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItemStatus|dw_MetaDataItem|MetaDataItemStatusId', 'DwMetaDataItem', 'DwMetaDataItem');
    }
}
;
class DwMetaDataItemTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataItemTypeMetaDataAttributes();
        this.Relations = new DwMetaDataItemTypeMetaDataRelations();
        this.ItemDetail.itemId = 16;
        this.ItemDetail.itemName = 'dw_MetaDataItemType';
        this.ItemDetail.keyName = 'MetaDataItemTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataItemTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataItemType.';
        // Attributes
        this.MetaDataItemTypeId = new DwItemAttribute(this.i, 'MetaDataItemTypeId');
        this.ItemTypeDisplay = new DwItemAttribute(this.i, 'ItemTypeDisplay');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataItemTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItemType|dw_MetaDataItem|MetaDataItemTypeId', 'DwMetaDataItem', 'DwMetaDataItem');
    }
}
;
class DwMetaDataLookupMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataLookupMetaDataAttributes();
        this.Relations = new DwMetaDataLookupMetaDataRelations();
        this.ItemDetail.itemId = 17;
        this.ItemDetail.itemName = 'dw_MetaDataLookup';
        this.ItemDetail.keyName = 'MetaDataLookupId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataLookupMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataLookup.';
        // Attributes
        this.MetaDataLookupId = new DwItemAttribute(this.i, 'MetaDataLookupId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.LookupName = new DwItemAttribute(this.i, 'LookupName');
        this.IsDefault = new DwItemAttribute(this.i, 'IsDefault');
        this.MetaDataQueryId = new DwItemAttribute(this.i, 'MetaDataQueryId');
        this.DisplayTemplate = new DwItemAttribute(this.i, 'DisplayTemplate');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.AdditionalAttribute1Id = new DwItemAttribute(this.i, 'AdditionalAttribute1Id');
        this.AdditionalAttribute2Id = new DwItemAttribute(this.i, 'AdditionalAttribute2Id');
        this.AdditionalAttribute3Id = new DwItemAttribute(this.i, 'AdditionalAttribute3Id');
        this.AdditionalAttribute4Id = new DwItemAttribute(this.i, 'AdditionalAttribute4Id');
        this.AdditionalAttribute5Id = new DwItemAttribute(this.i, 'AdditionalAttribute5Id');
        this.HasTransitions = new DwItemAttribute(this.i, 'HasTransitions');
        this.TransitionReferenceAttribute1Id = new DwItemAttribute(this.i, 'TransitionReferenceAttribute1Id');
        this.TransitionReferenceAttribute2Id = new DwItemAttribute(this.i, 'TransitionReferenceAttribute2Id');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.LookupMeaning = new DwItemAttribute(this.i, 'LookupMeaning');
        this.KeyAttributeId = new DwItemAttribute(this.i, 'KeyAttributeId');
        this.CacheLookup = new DwItemAttribute(this.i, 'CacheLookup');
        this.IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
        this.GroupByAttributeId = new DwItemAttribute(this.i, 'GroupByAttributeId');
        this.GroupByTemplate = new DwItemAttribute(this.i, 'GroupByTemplate');
        this.IsLargeLookup = new DwItemAttribute(this.i, 'IsLargeLookup');
        this.LookupConfigJSON = new DwItemAttribute(this.i, 'LookupConfigJSON');
    }
}
class DwMetaDataLookupMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute - Additional Attribute 1 */
        this.DwMetaDataAttributeByAdditionalAttribute1Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute1Id', 'AdditionalAttribute1IdDwMetaDataAttribute', 'AdditionalAttribute1IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Additional Attribute 2 */
        this.DwMetaDataAttributeByAdditionalAttribute2Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute2Id', 'AdditionalAttribute2IdDwMetaDataAttribute', 'AdditionalAttribute2IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Additional Attribute 3 */
        this.DwMetaDataAttributeByAdditionalAttribute3Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute3Id', 'AdditionalAttribute3IdDwMetaDataAttribute', 'AdditionalAttribute3IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Additional Attribute 4 */
        this.DwMetaDataAttributeByAdditionalAttribute4Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|AdditionalAttribute4Id', 'AdditionalAttribute4IdDwMetaDataAttribute', 'AdditionalAttribute4IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Transition Reference Attribute1 */
        this.DwMetaDataAttributeByTransitionReferenceAttribute1Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute1Id', 'TransitionReferenceAttribute1IdDwMetaDataAttribute', 'TransitionReferenceAttribute1IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Transition Reference Attribute2 */
        this.DwMetaDataAttributeByTransitionReferenceAttribute2Id = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|TransitionReferenceAttribute2Id', 'TransitionReferenceAttribute2IdDwMetaDataAttribute', 'TransitionReferenceAttribute2IdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Alternate Key Attribute */
        this.DwMetaDataAttributeByKeyAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|KeyAttributeId', 'KeyAttributeIdDwMetaDataAttribute', 'KeyAttributeIdDwMetaDataAttribute');
        /** Relation: Meta Data Attribute - Group By Attribute */
        this.DwMetaDataAttributeByGroupByAttributeId = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookup|GroupByAttributeId', 'GroupByAttributeIdDwMetaDataAttribute', 'GroupByAttributeIdDwMetaDataAttribute');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataLookup|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Meta Data Query */
        this.DwMetaDataQuery = new DwItemRelationship('dw_MetaDataQuery|dw_MetaDataLookup|MetaDataQueryId', 'DwMetaDataQuery', 'DwMetaDataQuery');
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataLookup|dw_MetaDataAttribute|MetaDataLookupId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Meta Data Lookup Param */
        this.DwMetaDataLookupParam = new DwItemRelationship('dw_MetaDataLookup|dw_MetaDataLookupParam|MetaDataLookupId', 'DwMetaDataLookupParam', 'DwMetaDataLookupParam');
        /** Relation: Meta Data Lookup Transition */
        this.DwMetaDataLookupTransition = new DwItemRelationship('dw_MetaDataLookup|dw_MetaDataLookupTransition|MetaDataLookupId', 'DwMetaDataLookupTransition', 'DwMetaDataLookupTransition');
    }
}
;
class DwMetaDataLookupParamMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataLookupParamMetaDataAttributes();
        this.Relations = new DwMetaDataLookupParamMetaDataRelations();
        this.ItemDetail.itemId = 18;
        this.ItemDetail.itemName = 'dw_MetaDataLookupParam';
        this.ItemDetail.keyName = 'MetaDataLookupParamId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataLookupParamMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataLookupParam.';
        // Attributes
        this.MetaDataLookupParamId = new DwItemAttribute(this.i, 'MetaDataLookupParamId');
        this.MetaDataLookupId = new DwItemAttribute(this.i, 'MetaDataLookupId');
        this.MetaDataAttributeId = new DwItemAttribute(this.i, 'MetaDataAttributeId');
        this.DefaultValue = new DwItemAttribute(this.i, 'DefaultValue');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.UseAttribute = new DwItemAttribute(this.i, 'UseAttribute');
        this.ParamNameOverride = new DwItemAttribute(this.i, 'ParamNameOverride');
        this.IsRequired = new DwItemAttribute(this.i, 'IsRequired');
    }
}
class DwMetaDataLookupParamMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataLookupParam|MetaDataAttributeId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Meta Data Lookup */
        this.DwMetaDataLookup = new DwItemRelationship('dw_MetaDataLookup|dw_MetaDataLookupParam|MetaDataLookupId', 'DwMetaDataLookup', 'DwMetaDataLookup');
    }
}
;
class DwMetaDataLookupTransitionMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataLookupTransitionMetaDataAttributes();
        this.Relations = new DwMetaDataLookupTransitionMetaDataRelations();
        this.ItemDetail.itemId = 370;
        this.ItemDetail.itemName = 'dw_MetaDataLookupTransition';
        this.ItemDetail.keyName = 'MetaDataLookupTransitionId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataLookupTransitionMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataLookupTransition.';
        // Attributes
        this.MetaDataLookupTransitionId = new DwItemAttribute(this.i, 'MetaDataLookupTransitionId');
        this.MetaDataLookupId = new DwItemAttribute(this.i, 'MetaDataLookupId');
        this.TransitionFromValue = new DwItemAttribute(this.i, 'TransitionFromValue');
        this.TransitionToValue = new DwItemAttribute(this.i, 'TransitionToValue');
        this.CanTransitionPermission = new DwItemAttribute(this.i, 'CanTransitionPermission');
        this.TransitionReferenceValue1 = new DwItemAttribute(this.i, 'TransitionReferenceValue1');
        this.TransitionReferenceValue2 = new DwItemAttribute(this.i, 'TransitionReferenceValue2');
        this.IsDefault = new DwItemAttribute(this.i, 'IsDefault');
        this.AlternateActionDisplay = new DwItemAttribute(this.i, 'AlternateActionDisplay');
        this.TransitionFromValueDisplay = new DwItemAttribute(this.i, 'TransitionFromValueDisplay');
        this.TransitionToValueDisplay = new DwItemAttribute(this.i, 'TransitionToValueDisplay');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
    }
}
class DwMetaDataLookupTransitionMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Lookup */
        this.DwMetaDataLookup = new DwItemRelationship('dw_MetaDataLookup|dw_MetaDataLookupTransition|MetaDataLookupId', 'DwMetaDataLookup', 'DwMetaDataLookup');
    }
}
;
class DwMetaDataOperationMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataOperationMetaDataAttributes();
        this.Relations = new DwMetaDataOperationMetaDataRelations();
        this.ItemDetail.itemId = 2734;
        this.ItemDetail.itemName = 'dw_MetaDataOperation';
        this.ItemDetail.keyName = 'MetaDataOperationId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataOperationMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataOperation.';
        // Attributes
        this.MetaDataOperationId = new DwItemAttribute(this.i, 'MetaDataOperationId');
        this.MetaDataSystemId = new DwItemAttribute(this.i, 'MetaDataSystemId');
        this.MetaDataOperationTypeId = new DwItemAttribute(this.i, 'MetaDataOperationTypeId');
        this.MetaDataCollectionId = new DwItemAttribute(this.i, 'MetaDataCollectionId');
        this.OperationDisplay = new DwItemAttribute(this.i, 'OperationDisplay');
        this.ApiConfigJSON = new DwItemAttribute(this.i, 'ApiConfigJSON');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
    }
}
class DwMetaDataOperationMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Collection */
        this.DwMetaDataCollection = new DwItemRelationship('dw_MetaDataCollection|dw_MetaDataOperation|MetaDataCollectionId', 'DwMetaDataCollection', 'DwMetaDataCollection');
        /** Relation: Meta Data Operation Type */
        this.DwMetaDataOperationType = new DwItemRelationship('dw_MetaDataOperationType|dw_MetaDataOperation|MetaDataOperationTypeId', 'DwMetaDataOperationType', 'DwMetaDataOperationType');
        /** Relation: Meta Data System */
        this.DwMetaDataSystem = new DwItemRelationship('dw_MetaDataSystem|dw_MetaDataOperation|MetaDataSystemId', 'DwMetaDataSystem', 'DwMetaDataSystem');
    }
}
;
class DwMetaDataOperationTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataOperationTypeMetaDataAttributes();
        this.Relations = new DwMetaDataOperationTypeMetaDataRelations();
        this.ItemDetail.itemId = 2732;
        this.ItemDetail.itemName = 'dw_MetaDataOperationType';
        this.ItemDetail.keyName = 'MetaDataOperationTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataOperationTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataOperationType.';
        // Attributes
        this.MetaDataOperationTypeId = new DwItemAttribute(this.i, 'MetaDataOperationTypeId');
        this.OperationTypeDisplay = new DwItemAttribute(this.i, 'OperationTypeDisplay');
    }
}
class DwMetaDataOperationTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Operation */
        this.DwMetaDataOperation = new DwItemRelationship('dw_MetaDataOperationType|dw_MetaDataOperation|MetaDataOperationTypeId', 'DwMetaDataOperation', 'DwMetaDataOperation');
    }
}
;
class DwMetaDataQueryMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataQueryMetaDataAttributes();
        this.Relations = new DwMetaDataQueryMetaDataRelations();
        this.ItemDetail.itemId = 19;
        this.ItemDetail.itemName = 'dw_MetaDataQuery';
        this.ItemDetail.keyName = 'MetaDataQueryId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataQueryMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataQuery.';
        // Attributes
        this.MetaDataQueryId = new DwItemAttribute(this.i, 'MetaDataQueryId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.QueryName = new DwItemAttribute(this.i, 'QueryName');
        this.QueryDesc = new DwItemAttribute(this.i, 'QueryDesc');
        this.Query = new DwItemAttribute(this.i, 'Query');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.QueryMeaning = new DwItemAttribute(this.i, 'QueryMeaning');
    }
}
class DwMetaDataQueryMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataQuery|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Meta Data Lookup */
        this.DwMetaDataLookup = new DwItemRelationship('dw_MetaDataQuery|dw_MetaDataLookup|MetaDataQueryId', 'DwMetaDataLookup', 'DwMetaDataLookup');
    }
}
;
class DwMetaDataSecurityGroupMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSecurityGroupMetaDataAttributes();
        this.Relations = new DwMetaDataSecurityGroupMetaDataRelations();
        this.ItemDetail.itemId = 4;
        this.ItemDetail.itemName = 'dw_MetaDataSecurityGroup';
        this.ItemDetail.keyName = 'MetaDataSecurityGroupId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSecurityGroupMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityGroup.';
        // Attributes
        this.MetaDataSecurityGroupId = new DwItemAttribute(this.i, 'MetaDataSecurityGroupId');
        this.SecurityGroupName = new DwItemAttribute(this.i, 'SecurityGroupName');
        this.PermissionMeaning = new DwItemAttribute(this.i, 'PermissionMeaning');
        this.CanCreateAny = new DwItemAttribute(this.i, 'CanCreateAny');
        this.CanReadAny = new DwItemAttribute(this.i, 'CanReadAny');
        this.CanUpdateAny = new DwItemAttribute(this.i, 'CanUpdateAny');
        this.CanDeletedAny = new DwItemAttribute(this.i, 'CanDeletedAny');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.MetaDataGroupId = new DwItemAttribute(this.i, 'MetaDataGroupId');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.IsBuiltIn = new DwItemAttribute(this.i, 'IsBuiltIn');
    }
}
class DwMetaDataSecurityGroupMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Group */
        this.DwMetaDataGroup = new DwItemRelationship('dw_MetaDataGroup|dw_MetaDataSecurityGroup|MetaDataGroupId', 'DwMetaDataGroup', 'DwMetaDataGroup');
        /** Relation: Security Group Item */
        this.DwMetaDataSecurityGroupItem = new DwItemRelationship('dw_MetaDataSecurityGroup|dw_MetaDataSecurityGroupItem|MetaDataSecurityGroupId', 'DwMetaDataSecurityGroupItem', 'DwMetaDataSecurityGroupItem');
    }
}
;
class DwMetaDataSecurityGroupAttributeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSecurityGroupAttributeMetaDataAttributes();
        this.Relations = new DwMetaDataSecurityGroupAttributeMetaDataRelations();
        this.ItemDetail.itemId = 88;
        this.ItemDetail.itemName = 'dw_MetaDataSecurityGroupAttribute';
        this.ItemDetail.keyName = 'MetaDataSecurityGroupAttributeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSecurityGroupAttributeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityGroupAttribute.';
        // Attributes
        this.MetaDataSecurityGroupAttributeId = new DwItemAttribute(this.i, 'MetaDataSecurityGroupAttributeId');
        this.MetaDataSecurityGroupItemId = new DwItemAttribute(this.i, 'MetaDataSecurityGroupItemId');
        this.MetaDataAttributeId = new DwItemAttribute(this.i, 'MetaDataAttributeId');
        this.CanRead = new DwItemAttribute(this.i, 'CanRead');
        this.CanUpdate = new DwItemAttribute(this.i, 'CanUpdate');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
    }
}
class DwMetaDataSecurityGroupAttributeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataAttribute|dw_MetaDataSecurityGroupAttribute|MetaDataAttributeId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Security Group Item */
        this.DwMetaDataSecurityGroupItem = new DwItemRelationship('dw_MetaDataSecurityGroupItem|dw_MetaDataSecurityGroupAttribute|MetaDataSecurityGroupItemId', 'DwMetaDataSecurityGroupItem', 'DwMetaDataSecurityGroupItem');
    }
}
;
class DwMetaDataSecurityGroupItemMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSecurityGroupItemMetaDataAttributes();
        this.Relations = new DwMetaDataSecurityGroupItemMetaDataRelations();
        this.ItemDetail.itemId = 85;
        this.ItemDetail.itemName = 'dw_MetaDataSecurityGroupItem';
        this.ItemDetail.keyName = 'MetaDataSecurityGroupItemId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSecurityGroupItemMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityGroupItem.';
        // Attributes
        this.MetaDataSecurityGroupItemId = new DwItemAttribute(this.i, 'MetaDataSecurityGroupItemId');
        this.MetaDataSecurityGroupId = new DwItemAttribute(this.i, 'MetaDataSecurityGroupId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.CanCreate = new DwItemAttribute(this.i, 'CanCreate');
        this.CanRead = new DwItemAttribute(this.i, 'CanRead');
        this.CanUpdate = new DwItemAttribute(this.i, 'CanUpdate');
        this.CanDelete = new DwItemAttribute(this.i, 'CanDelete');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
        this.UseFieldLevelSecurity = new DwItemAttribute(this.i, 'UseFieldLevelSecurity');
        this.FieldCanReadDefault = new DwItemAttribute(this.i, 'FieldCanReadDefault');
        this.FieldCanUpdateDefault = new DwItemAttribute(this.i, 'FieldCanUpdateDefault');
    }
}
class DwMetaDataSecurityGroupItemMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|dw_MetaDataSecurityGroupItem|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Security Group */
        this.DwMetaDataSecurityGroup = new DwItemRelationship('dw_MetaDataSecurityGroup|dw_MetaDataSecurityGroupItem|MetaDataSecurityGroupId', 'DwMetaDataSecurityGroup', 'DwMetaDataSecurityGroup');
        /** Relation: Security Group Attribute */
        this.DwMetaDataSecurityGroupAttribute = new DwItemRelationship('dw_MetaDataSecurityGroupItem|dw_MetaDataSecurityGroupAttribute|MetaDataSecurityGroupItemId', 'DwMetaDataSecurityGroupAttribute', 'DwMetaDataSecurityGroupAttribute');
    }
}
;
class DwMetaDataSecurityItemRuleMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSecurityItemRuleMetaDataAttributes();
        this.Relations = new DwMetaDataSecurityItemRuleMetaDataRelations();
        this.ItemDetail.itemId = 2486;
        this.ItemDetail.itemName = 'dw_MetaDataSecurityItemRule';
        this.ItemDetail.keyName = 'MetaDataSecurityItemRuleId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSecurityItemRuleMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSecurityItemRule.';
        // Attributes
        this.MetaDataSecurityItemRuleId = new DwItemAttribute(this.i, 'MetaDataSecurityItemRuleId');
        this.MetaDataItemId = new DwItemAttribute(this.i, 'MetaDataItemId');
        this.RuleName = new DwItemAttribute(this.i, 'RuleName');
        this.RuleOrder = new DwItemAttribute(this.i, 'RuleOrder');
        this.PermissionMeaning = new DwItemAttribute(this.i, 'PermissionMeaning');
        this.MetaDataQueryId = new DwItemAttribute(this.i, 'MetaDataQueryId');
        this.RuleFilterJSON = new DwItemAttribute(this.i, 'RuleFilterJSON');
        this.ClearPreviousRules = new DwItemAttribute(this.i, 'ClearPreviousRules');
        this.CanCreate = new DwItemAttribute(this.i, 'CanCreate');
        this.CanRead = new DwItemAttribute(this.i, 'CanRead');
        this.CanUpdate = new DwItemAttribute(this.i, 'CanUpdate');
        this.CanDelete = new DwItemAttribute(this.i, 'CanDelete');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataSecurityItemRuleMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataItem|MetaDataSecurityItemRule|MetaDataItemId', 'DwMetaDataItem', 'DwMetaDataItem');
    }
}
;
class DwMetaDataSqlTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSqlTypeMetaDataAttributes();
        this.Relations = new DwMetaDataSqlTypeMetaDataRelations();
        this.ItemDetail.itemId = 23;
        this.ItemDetail.itemName = 'dw_MetaDataSqlType';
        this.ItemDetail.keyName = 'MetaDataSqlTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSqlTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSqlType.';
        // Attributes
        this.MetaDataSqlTypeId = new DwItemAttribute(this.i, 'MetaDataSqlTypeId');
        this.MetaDataDatabaseSystemId = new DwItemAttribute(this.i, 'MetaDataDatabaseSystemId');
        this.SqlTypeName = new DwItemAttribute(this.i, 'SqlTypeName');
        this.HasLength = new DwItemAttribute(this.i, 'HasLength');
        this.MinValue = new DwItemAttribute(this.i, 'MinValue');
        this.MaxValue = new DwItemAttribute(this.i, 'MaxValue');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    }
}
class DwMetaDataSqlTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data Database System */
        this.DwMetaDataDatabaseSystem = new DwItemRelationship('dw_MetaDataDatabaseSystem|dw_MetaDataSqlType|MetaDataDatabaseSystemId', 'DwMetaDataDatabaseSystem', 'DwMetaDataDatabaseSystem');
        /** Relation: Meta Data Attribute */
        this.DwMetaDataAttribute = new DwItemRelationship('dw_MetaDataSqlType|dw_MetaDataAttribute|MetaDataSqlTypeId', 'DwMetaDataAttribute', 'DwMetaDataAttribute');
        /** Relation: Meta Data Attribute Type Sql Type Map */
        this.DwMetaDataAttributeTypeSqlTypeMap = new DwItemRelationship('dw_MetaDataSqlType|dw_MetaDataAttributeTypeSqlTypeMap|MetaDataSqlTypeId', 'DwMetaDataAttributeTypeSqlTypeMap', 'DwMetaDataAttributeTypeSqlTypeMap');
    }
}
;
class DwMetaDataSystemMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSystemMetaDataAttributes();
        this.Relations = new DwMetaDataSystemMetaDataRelations();
        this.ItemDetail.itemId = 2735;
        this.ItemDetail.itemName = 'dw_MetaDataSystem';
        this.ItemDetail.keyName = 'MetaDataSystemId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSystemMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSystem.';
        // Attributes
        this.MetaDataSystemId = new DwItemAttribute(this.i, 'MetaDataSystemId');
        this.SystemDisplay = new DwItemAttribute(this.i, 'SystemDisplay');
        this.SystemMeaning = new DwItemAttribute(this.i, 'SystemMeaning');
        this.SystemCode = new DwItemAttribute(this.i, 'SystemCode');
        this.MetaDataSystemTypeId = new DwItemAttribute(this.i, 'MetaDataSystemTypeId');
        this.SystemConfigJSON = new DwItemAttribute(this.i, 'SystemConfigJSON');
        this.UniqueId = new DwItemAttribute(this.i, 'UniqueId');
    }
}
class DwMetaDataSystemMetaDataRelations {
    constructor() {
        /** Relation: Meta Data System Type */
        this.DwMetaDataSystemType = new DwItemRelationship('dw_MetaDataSystemType|dw_MetaDataSystem|MetaDataSystemTypeId', 'DwMetaDataSystemType', 'DwMetaDataSystemType');
        /** Relation: Meta Data Collection */
        this.DwMetaDataCollection = new DwItemRelationship('dw_MetaDataSystem|dw_MetaDataCollection|MetaDataSystemId', 'DwMetaDataCollection', 'DwMetaDataCollection');
        /** Relation: Meta Data Item */
        this.DwMetaDataItem = new DwItemRelationship('dw_MetaDataSystem|dw_MetaDataItem|MetaDataSystemId', 'DwMetaDataItem', 'DwMetaDataItem');
        /** Relation: Meta Data Operation */
        this.DwMetaDataOperation = new DwItemRelationship('dw_MetaDataSystem|dw_MetaDataOperation|MetaDataSystemId', 'DwMetaDataOperation', 'DwMetaDataOperation');
    }
}
;
class DwMetaDataSystemTypeMetaData$1 {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMetaDataSystemTypeMetaDataAttributes();
        this.Relations = new DwMetaDataSystemTypeMetaDataRelations();
        this.ItemDetail.itemId = 2731;
        this.ItemDetail.itemName = 'dw_MetaDataSystemType';
        this.ItemDetail.keyName = 'MetaDataSystemTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMetaDataSystemTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_MetaDataSystemType.';
        // Attributes
        this.MetaDataSystemTypeId = new DwItemAttribute(this.i, 'MetaDataSystemTypeId');
        this.SystemTypeDisplay = new DwItemAttribute(this.i, 'SystemTypeDisplay');
        this.SystemMeaning = new DwItemAttribute(this.i, 'SystemMeaning');
        this.IconClass = new DwItemAttribute(this.i, 'IconClass');
        this.FeaturesJSON = new DwItemAttribute(this.i, 'FeaturesJSON');
    }
}
class DwMetaDataSystemTypeMetaDataRelations {
    constructor() {
        /** Relation: Meta Data System */
        this.DwMetaDataSystem = new DwItemRelationship('dw_MetaDataSystemType|dw_MetaDataSystem|MetaDataSystemTypeId', 'DwMetaDataSystem', 'DwMetaDataSystem');
    }
}
;
class DevwareFeatureAreasMetaData {
}
DevwareFeatureAreasMetaData.DwFeatureArea = new DwFeatureAreaMetaData$1();
DevwareFeatureAreasMetaData.DwFeatureAreaDetail = new DwFeatureAreaDetailMetaData$1();
DevwareFeatureAreasMetaData.DwFeatureAreaDetailGroup = new DwFeatureAreaDetailGroupMetaData$1();
DevwareFeatureAreasMetaData.DwFeatureAreaDetailType = new DwFeatureAreaDetailTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataAttribute = new DwMetaDataAttributeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataAttributeFormat = new DwMetaDataAttributeFormatMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataAttributeType = new DwMetaDataAttributeTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataAttributeTypeComparerMap = new DwMetaDataAttributeTypeComparerMapMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataAttributeTypeControlTypeMap = new DwMetaDataAttributeTypeControlTypeMapMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataAttributeTypeSqlTypeMap = new DwMetaDataAttributeTypeSqlTypeMapMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataCollection = new DwMetaDataCollectionMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataComparer = new DwMetaDataComparerMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataControlType = new DwMetaDataControlTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataDatabase = new DwMetaDataDatabaseMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataDatabaseSystem = new DwMetaDataDatabaseSystemMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataDotNetType = new DwMetaDataDotNetTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataEnvironmentOfRecordType = new DwMetaDataEnvironmentOfRecordTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataEvent = new DwMetaDataEventMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataGroup = new DwMetaDataGroupMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataHistory = new DwMetaDataHistoryMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataHistoryDetail = new DwMetaDataHistoryDetailMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataHistoryType = new DwMetaDataHistoryTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataImport = new DwMetaDataImportMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataImportLog = new DwMetaDataImportLogMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataItem = new DwMetaDataItemMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataItemRelationship = new DwMetaDataItemRelationshipMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataItemRelationshipType = new DwMetaDataItemRelationshipTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataItemStatus = new DwMetaDataItemStatusMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataItemType = new DwMetaDataItemTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataLookup = new DwMetaDataLookupMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataLookupParam = new DwMetaDataLookupParamMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataLookupTransition = new DwMetaDataLookupTransitionMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataOperation = new DwMetaDataOperationMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataOperationType = new DwMetaDataOperationTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataQuery = new DwMetaDataQueryMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSecurityGroup = new DwMetaDataSecurityGroupMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSecurityGroupAttribute = new DwMetaDataSecurityGroupAttributeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSecurityGroupItem = new DwMetaDataSecurityGroupItemMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSecurityItemRule = new DwMetaDataSecurityItemRuleMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSqlType = new DwMetaDataSqlTypeMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSystem = new DwMetaDataSystemMetaData$1();
DevwareFeatureAreasMetaData.DwMetaDataSystemType = new DwMetaDataSystemTypeMetaData$1();
// Lookup Value Enums  {
var FeatureAreaDetailTypeAllItems;
(function (FeatureAreaDetailTypeAllItems) {
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Items"] = 1] = "Items";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Permissions"] = 2] = "Permissions";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Roles"] = 3] = "Roles";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["SecurityGroup"] = 4] = "SecurityGroup";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Menus"] = 5] = "Menus";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Email"] = 6] = "Email";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["ProcessDefinition"] = 7] = "ProcessDefinition";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["ProcessSchedules"] = 8] = "ProcessSchedules";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["UserInterfaceConfig"] = 9] = "UserInterfaceConfig";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Lookups"] = 10] = "Lookups";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Queries"] = 11] = "Queries";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Rules"] = 12] = "Rules";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["Events"] = 13] = "Events";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["ContextData"] = 14] = "ContextData";
    FeatureAreaDetailTypeAllItems[FeatureAreaDetailTypeAllItems["SecurityGroupItems"] = 15] = "SecurityGroupItems";
})(FeatureAreaDetailTypeAllItems || (FeatureAreaDetailTypeAllItems = {}));
var FeatureAreaDetailGroupAllItems;
(function (FeatureAreaDetailGroupAllItems) {
    FeatureAreaDetailGroupAllItems[FeatureAreaDetailGroupAllItems["Data"] = 1] = "Data";
    FeatureAreaDetailGroupAllItems[FeatureAreaDetailGroupAllItems["Security"] = 2] = "Security";
    FeatureAreaDetailGroupAllItems[FeatureAreaDetailGroupAllItems["Menus"] = 3] = "Menus";
    FeatureAreaDetailGroupAllItems[FeatureAreaDetailGroupAllItems["EMail"] = 4] = "EMail";
    FeatureAreaDetailGroupAllItems[FeatureAreaDetailGroupAllItems["Processes"] = 5] = "Processes";
    FeatureAreaDetailGroupAllItems[FeatureAreaDetailGroupAllItems["UserInterfaces"] = 6] = "UserInterfaces";
})(FeatureAreaDetailGroupAllItems || (FeatureAreaDetailGroupAllItems = {}));

class DwFeatureAreaRepositoryService {
    constructor(dwOrmDataService, dwMetaDataService, dwAdhocLookupService, dwCacheService, dwMdEventService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwAdhocLookupService = dwAdhocLookupService;
        this.dwCacheService = dwCacheService;
        this.dwMdEventService = dwMdEventService;
    }
    loadFeatureArea(featureAreaId) {
        const query = DevwareMetaData.DwFeatureArea.CreateQuery();
        const qh = new DwQueryHelper();
        query.AddFilterAnd(qh.filters.Equal(DevwareMetaData.DwFeatureArea.FeatureAreaId, featureAreaId));
        return this.dwOrmDataService.executeQuerySingle(query);
    }
    loadFeatureAreaDetails(featureAreaId, featureAreaDetailTypeId) {
        const query = DevwareMetaData.DwFeatureAreaDetail.CreateQuery();
        const qh = new DwQueryHelper();
        query.AddFilterAnd(qh.filters.Equal(DevwareMetaData.DwFeatureAreaDetail.FeatureAreaId, featureAreaId));
        if (featureAreaDetailTypeId) {
            query.AddFilterAnd(qh.filters.Equal(DevwareMetaData.DwFeatureAreaDetail.FeatureAreaDetailTypeId, featureAreaDetailTypeId));
        }
        return this.dwOrmDataService.executeQuery(query);
    }
    loadFeatureAreaDetails2(featureAreaId, featureAreaDetailTypeId) {
        const query = DevwareFeatureAreasMetaData.DwFeatureAreaDetail.CreateQueryBuilder();
        query.addFilterAnd(filters => filters.Equal(f => f.FeatureAreaId, featureAreaId));
        if (featureAreaDetailTypeId) {
            query.addFilterAnd(filters => filters.Equal(f => f.FeatureAreaDetailTypeId, featureAreaDetailTypeId));
        }
        return this.dwOrmDataService.executeQuery(query);
    }
    saveFeatureAreaDetails(newFeatureAreaDetails) {
        return this.dwOrmDataService.saveEntityCollection(newFeatureAreaDetails, false);
    }
    deleteFeatureAreaDetails(items) {
        items.forEach(i => {
            this.dwOrmDataService.markItemAsDeleted(i);
        });
        return this.saveFeatureAreaDetails(items);
    }
    getFeatureAreaGroups() {
        const topics = [];
        topics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwFeatureAreaDetailGroup.ItemDetail.ItemName));
        topics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwFeatureAreaDetailType.ItemDetail.ItemName));
        return this.dwCacheService.getWithOptions('featureAreaGroups', this.loadFeatureAreaGroups(), { cacheInvalidationsTopics: topics });
    }
    getFeatureDetailType(item) {
        return this.getFeatureAreaGroups()
            .pipe(map(groups => {
            for (const group of groups) {
                for (const detail of group.DwFeatureAreaDetailType) {
                    if (detail.DwMetaDataItem.UniqueItemName == item) {
                        return detail;
                    }
                }
            }
        }));
    }
    getFeatureDetailLimitedLookup(item, lookupId, featureAreaId) {
        return this.getFeatureDetailType(item)
            .pipe(mergeMap(faDetailType => {
            const lookupOb = this.dwMetaDataService.getLookup(lookupId);
            const featureAreaOb = this.loadFeatureAreaDetails(featureAreaId, faDetailType.FeatureAreaDetailTypeId);
            return combineLatest([lookupOb, featureAreaOb])
                .pipe(map(([lookupItems, featureAreaDetails]) => {
                const finalLookupItems = lookupItems.filter(li => featureAreaDetails.find(fa => fa.ReferenceKeyValue.toString() == li.Id));
                return finalLookupItems;
            }));
        }));
    }
    getFeatureDetailLookupInfo(featureArea, featureAreaDetails, faDetailType, removeExistingItems = true) {
        return this.dwMetaDataService.getLookupDefinitions()
            .pipe(mergeMap(lookupDefinitions => {
            const result = {
                lookupDefinition: lookupDefinitions.find(ld => ld.MetaDataItemId == faDetailType.MetaDataItemId && ld.IsDefault),
                lookupItems: []
            };
            return this.dwMetaDataService.getLookup(result.lookupDefinition.MetaDataLookupId)
                .pipe(mergeMap(lookupItems => {
                return this.limitLookupItems(featureArea, featureAreaDetails, lookupItems, faDetailType, removeExistingItems)
                    .pipe(map(lookupItems => {
                    result.lookupItems = lookupItems;
                    return result;
                }));
            }));
        }));
    }
    getSelectedFeatureDetails(featureAreaDetails, itemName, referenceKeys) {
        return this.getFeatureDetailType(itemName)
            .pipe(map(featureDetailType => {
            const result = {
                selectedDetails: [],
                otherDetails: []
            };
            for (const faDetail of featureAreaDetails) {
                let found = false;
                if (faDetail.FeatureAreaDetailTypeId == featureDetailType.FeatureAreaDetailTypeId) {
                    found = !!referenceKeys.find(key => key == faDetail.ReferenceKeyValue);
                }
                if (found) {
                    result.selectedDetails.push(faDetail);
                }
                else {
                    result.otherDetails.push(faDetail);
                }
            }
            return result;
        }));
    }
    limitLookupItems(featureArea, featureAreaDetails, lookupItems, faDetailType, removeExistingItems = true) {
        if (removeExistingItems && featureAreaDetails && featureAreaDetails.length > 0) {
            // remove any items that have already been added
            lookupItems = lookupItems.filter(li => !featureAreaDetails.find(ad => ad.FeatureAreaDetailTypeId == faDetailType.FeatureAreaDetailTypeId && ad.ReferenceKeyValue.toString() == li.Id));
        }
        if (faDetailType.DwMetaDataItem.UniqueItemName != DevwareMetaDataItemNames.DwMetaDataItem) {
            return of(lookupItems);
        }
        return this.getFeatureMetaDataItems(featureArea)
            .pipe(map(items => {
            // limit to the items valid for the feature area
            lookupItems = lookupItems.filter(li => items.find(i => i.MetaDataItemId.toString() == li.Id));
            return lookupItems;
        }));
    }
    getFeatureMetaDataItems(featureArea) {
        const query = DevwareMetaData.DwMetaDataItem.CreateQuery();
        const qh = new DwQueryHelper();
        query.FieldSettings.IncludeRootItemFields = false;
        query.AddField(DevwareMetaData.DwMetaDataItem.UniqueItemName);
        // limit to Feature database
        query.AddFilterAnd(qh.filters.Equal(DevwareMetaData.DwMetaDataItem.MetaDataDatabaseId, featureArea.MetaDataDatabaseId));
        // limit to schemas (if they exist)
        const schemas = this.dwAdhocLookupService.convertAdhocStringToArray(featureArea.SchemaList);
        if (schemas.length > 0) {
            query.AddFilterAnd(qh.filters.InList(DevwareMetaData.DwMetaDataItem.SchemaName, schemas));
        }
        return this.dwOrmDataService.executeQuery(query);
    }
    loadFeatureAreaGroups() {
        const query = DevwareMetaData.DwFeatureAreaDetailGroup.CreateQuery();
        const itemQuery = DevwareMetaData.DwMetaDataItem.CreateQuery();
        itemQuery.AddPrefetchPath(DevwareMetaData.DwMetaDataItem.Relations.DwMetaDataAttribute);
        const detailQuery = DevwareMetaData.DwFeatureAreaDetailType.CreateQuery();
        detailQuery.AddPrefetchPath(DevwareMetaData.DwFeatureAreaDetailType.Relations.DwMetaDataItem, itemQuery);
        query.AddPrefetchPath(DevwareMetaData.DwFeatureAreaDetailGroup.Relations.DwFeatureAreaDetailType, detailQuery);
        return this.dwOrmDataService.executeQuery(query);
    }
    getFeatureAreaDisplayGroups(featureAreaDetails) {
        return this.getFeatureAreaGroups()
            .pipe(map(groups => {
            const groupItems = [];
            for (let group of groups) {
                const groupItem = {
                    group: group,
                    details: []
                };
                for (let detail of group.DwFeatureAreaDetailType) {
                    const detailItem = {
                        detail: detail,
                        areaDetails: []
                    };
                    for (let faDetail of featureAreaDetails) {
                        if (!faDetail._isDeleted && faDetail.FeatureAreaDetailTypeId == detail.FeatureAreaDetailTypeId) {
                            detailItem.areaDetails.push(faDetail);
                        }
                    }
                    if (detailItem.areaDetails.length > 0) {
                        groupItem.details.push(detailItem);
                    }
                }
                if (groupItem.details.length > 0) {
                    groupItems.push(groupItem);
                }
            }
            return groupItems;
        }));
    }
    /**
     * Get all create events for feature area tables so we can add a link
     * @param featureAreaGroups
     * @returns
     */
    getFeatureAreaItemAddEvents(featureAreaGroups) {
        const details = [];
        // Get a list of items that we need to handle adding
        for (let featureAreaGroup of featureAreaGroups) {
            for (let featureAreaDetail of featureAreaGroup.DwFeatureAreaDetailType) {
                if (!featureAreaDetail.ItemReferenceOnly) {
                    details.push(featureAreaDetail);
                }
            }
        }
        const items = details.map(d => d.DwMetaDataItem.UniqueItemName);
        return this.dwMdEventService.getCreateEvents(...items)
            .pipe(map(createEvent => {
            const areaDetailAddEvent = {
                createEvent: createEvent,
                featureAreaDetail: details.find(i => i.DwMetaDataItem.UniqueItemName == createEvent.itemName)
            };
            return areaDetailAddEvent;
        }));
    }
}
DwFeatureAreaRepositoryService.ɵfac = function DwFeatureAreaRepositoryService_Factory(t) { return new (t || DwFeatureAreaRepositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwAdhocLookupService), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwMdEventService)); };
DwFeatureAreaRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwFeatureAreaRepositoryService_Factory() { return new DwFeatureAreaRepositoryService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwAdhocLookupService), ɵɵinject(DwCacheService), ɵɵinject(DwMdEventService)); }, token: DwFeatureAreaRepositoryService, providedIn: "root" });
DwFeatureAreaRepositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwAdhocLookupService },
    { type: DwCacheService },
    { type: DwMdEventService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFeatureAreaRepositoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwAdhocLookupService }, { type: DwCacheService }, { type: DwMdEventService }]; }, null); })();

class DwImportMetaDataModalComponent {
    constructor(dwMetaDataService, dwFeatureAreaRepository, dwAdhocLookupService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwFeatureAreaRepository = dwFeatureAreaRepository;
        this.dwAdhocLookupService = dwAdhocLookupService;
        this.running = false;
        this.importMode = DwImportMode.All;
        this.paramValues = {};
        this.schemaLookupMeaning = 'Meta_Data_Schemas_by_Database';
    }
    ngOnInit() {
        var _a;
        this.metaDataDatabaseLookupId = DevwareMetaDataLookups.MetaDataDatabaseAllItems;
        this.importModes = new DwImportModeList().getEnumList();
        if ((_a = this.modalConfig.data) === null || _a === void 0 ? void 0 : _a.featureAreaId) {
            this.dwFeatureAreaRepository.loadFeatureArea(this.modalConfig.data.featureAreaId)
                .subscribe(featureArea => {
                this.featureArea = featureArea;
                this.databaseId = featureArea.MetaDataDatabaseId;
                this.schemas = featureArea.SchemaList;
                this.paramValues = { MetaDataDatabaseId: featureArea.MetaDataDatabaseId };
            });
        }
        else {
            this.dwMetaDataService.getLookup(this.metaDataDatabaseLookupId)
                .subscribe(lookupData => {
                if (!this.databaseId) {
                    this.databaseId = this.modalConfig.data.defaultDatabaseId;
                    this.databaseId = parseInt(lookupData[0].Id);
                }
            });
        }
    }
    updateDatabaseId() {
        this.paramValues = { MetaDataDatabaseId: this.databaseId };
        this.schemas = "";
    }
    buttonClick(buttonConfig) {
        var _a;
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                if (!this.databaseId) {
                    return;
                }
                this.running = true;
                const importOptions = {
                    MetaDataDatabaseId: parseInt(this.databaseId.toString()),
                    ImportMode: this.importMode,
                    FeatureAreaId: (_a = this.featureArea) === null || _a === void 0 ? void 0 : _a.FeatureAreaId
                };
                if (this.schemas) {
                    importOptions.SchemaNames = this.dwAdhocLookupService.convertAdhocStringToArray(this.schemas);
                    // importOptions.SchemaNames = [this.schema];
                }
                return this.dwMetaDataService.importMetaDataWithOptions(importOptions)
                    .pipe(map(importResult => {
                    this.running = false;
                    const modalResult = new DwModalResult();
                    modalResult.closeModal = true;
                    modalResult.cancelled = false;
                    modalResult.buttonCommand = buttonConfig.command;
                    modalResult.data = importResult;
                    return modalResult;
                }));
            default:
                const modalResult = new DwModalResult();
                modalResult.cancelled = true;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
                return of(modalResult);
        }
    }
}
DwImportMetaDataModalComponent.ɵfac = function DwImportMetaDataModalComponent_Factory(t) { return new (t || DwImportMetaDataModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwAdhocLookupService)); };
DwImportMetaDataModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwImportMetaDataModalComponent, selectors: [["dw-import-meta-data-modal"]], decls: 2, vars: 2, consts: [["text", "Importing Meta Data", 3, "show"], [4, "ngIf"], [1, "row"], [1, "col-md-12"], [1, "label"], ["showBlankOption", "false", "blankOptionText", "Select Database", 3, "ngModel", "lookupId", "ngModelChange"], [3, "ngModel", "lookupId", "paramValues", "ngModelChange"], [3, "values", "ngModel", "ngModelChange"]], template: function DwImportMetaDataModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-loading", 0);
        ɵngcc0.ɵɵtemplate(1, DwImportMetaDataModalComponent_div_1_Template, 16, 7, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("show", ctx.running);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.running);
    } }, directives: [DwLoadingComponent, ɵngcc4.NgIf, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwMultiSelectAdhocComponent, DwRadioListComponent], encapsulation: 2 });
DwImportMetaDataModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwFeatureAreaRepositoryService },
    { type: DwAdhocLookupService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwImportMetaDataModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-import-meta-data-modal',
                template: "<dw-loading [show]=\"running\" text=\"Importing Meta Data\"></dw-loading>\r\n\r\n<div *ngIf=\"!running\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label class=\"label\">Meta Data Database</label>\r\n            <dw-search-select-lookup [(ngModel)]=\"databaseId\" (ngModelChange)=\"updateDatabaseId()\" [lookupId]=\"metaDataDatabaseLookupId\"\r\n                showBlankOption=\"false\" blankOptionText=\"Select Database\" ></dw-search-select-lookup>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label class=\"label\">Schemas</label>\r\n\r\n            <dw-multi-select-adhoc-lookup [(ngModel)]=\"schemas\" [lookupId]=\"schemaLookupMeaning\" [paramValues]=\"paramValues\" >\r\n            </dw-multi-select-adhoc-lookup>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label class=\"label\">Import Mode</label>\r\n            <dw-radio-list [values]=\"importModes\" [(ngModel)]=\"importMode\"></dw-radio-list>\r\n        </div>\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwFeatureAreaRepositoryService }, { type: DwAdhocLookupService }]; }, null); })();

class DwRefreshMetadataActionService {
    constructor(
    /*  @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
     private route: ActivatedRoute,
     private metaDataRoutingService: DwMetaDataRoutingService, */
    dwModalService, dwMenuService) {
        this.dwModalService = dwModalService;
        this.dwMenuService = dwMenuService;
    }
    handleAction(actionState) {
        return this.showRefreshPopup();
    }
    showRefreshPopup() {
        let modalConfig = new DwModalConfig();
        const featureAreaId = this.dwMenuService.getMenuParam('dw_FeatureAreaId');
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.allowFullScreen = false;
        modalConfig.data = {
            featureAreaId: featureAreaId
        };
        modalConfig.component = DwImportMetaDataModalComponent;
        modalConfig.title = 'Import Meta Data';
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(importModalResult => {
            const result = new DwGridActionResult();
            if (importModalResult.cancelled) {
                result.refreshData = false;
                result.cancelled = true;
                return result;
            }
            result.success = importModalResult.data.IsSuccess;
            const message = {
                messageHeading: 'Meta Data Import',
                messageBody: importModalResult.data.ImportResultDescription,
                timeToShow: importModalResult.data.IsSuccess ? 10000 : null,
                allowClose: true,
                severity: importModalResult.data.IsSuccess ? DwMessageSeverity.success : DwMessageSeverity.error,
                linkText: 'View Import Details',
                linkUrl: `/admin/data/items/dw_MetaDataImport/view/${importModalResult.data.MetaDataImportId}`
            };
            result.message = message;
            result.refreshData = true;
            return result;
        }));
    }
}
DwRefreshMetadataActionService.ɵfac = function DwRefreshMetadataActionService_Factory(t) { return new (t || DwRefreshMetadataActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwMenuService)); };
DwRefreshMetadataActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRefreshMetadataActionService, factory: DwRefreshMetadataActionService.ɵfac });
DwRefreshMetadataActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwMenuService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRefreshMetadataActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwMenuService }]; }, null); })();
DwActionFunc({
    keyName: 'metadataRefresh',
    display: 'Import Meta data',
    actionType: DwActionType.gridAction,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataItem,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-database',
        buttonClass: 'btn btn-success',
        buttonTitle: 'Imports Meta Data from the database'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: true
    }
}, DwRefreshMetadataActionService);

class DwViewItemListActionService {
    constructor(route, metaDataRoutingService, dwModalService) {
        this.route = route;
        this.metaDataRoutingService = metaDataRoutingService;
        this.dwModalService = dwModalService;
    }
    handleAction(gridActionState) {
        return this.viewItem(gridActionState);
    }
    viewItem(gridActionState) {
        if (!gridActionState.data) {
            throw new Error('Can not execute view Item event because no event data was passed');
        }
        const mdItem = gridActionState.data;
        this.metaDataRoutingService.routeToParent(this.route, mdItem.UniqueItemName, DwMenuActionType.list);
        const result = new DwGridActionResult();
        result.success = true;
        result.refreshData = false;
        return of(result);
    }
}
DwViewItemListActionService.ɵfac = function DwViewItemListActionService_Factory(t) { return new (t || DwViewItemListActionService)(ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(DwMetaDataRoutingService), ɵngcc0.ɵɵinject(DwModalService)); };
DwViewItemListActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwViewItemListActionService, factory: DwViewItemListActionService.ɵfac });
DwViewItemListActionService.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: DwMetaDataRoutingService },
    { type: DwModalService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwViewItemListActionService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: DwMetaDataRoutingService }, { type: DwModalService }]; }, null); })();
DwActionFunc({
    keyName: 'viewItemList',
    display: 'View Item List',
    actionType: DwActionType.gridRowAction,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataItem,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'dw-icon-search-grid',
        buttonType: DwButtonType.iconOnlyNoText,
        buttonTitle: 'View Item Grid'
    }
}, DwViewItemListActionService);

class DwRefreshMetadataMenuActionService {
    constructor(dwMetaDataService) {
        this.dwMetaDataService = dwMetaDataService;
    }
    handleAction(actionState) {
        const items = actionState.data;
        return this.refreshItems(items);
    }
    refreshItems(items) {
        if (!items || items.length == 0) {
            return of({ success: true });
        }
        const importOptions = {
            MetaDataDatabaseId: items[0].MetaDataDatabaseId,
            ImportMode: DwImportMode.UpdateSelected,
            ItemIds: items.map(i => i.MetaDataItemId)
        };
        return this.dwMetaDataService.importMetaDataWithOptions(importOptions)
            .pipe(map(importResult => {
            const result = {
                success: importResult.IsSuccess,
                refreshData: true,
            };
            const message = {
                messageHeading: 'Meta Data Import',
                messageBody: importResult.ImportResultDescription,
                timeToShow: importResult.IsSuccess ? 10000 : null,
                allowClose: true,
                severity: importResult.IsSuccess ? DwMessageSeverity.success : DwMessageSeverity.error,
                linkText: 'View Import Details',
                linkUrl: `/admin/data/items/dw_MetaDataImport/view/${importResult.MetaDataImportId}`
            };
            result.message = message;
            return result;
        }));
    }
}
DwRefreshMetadataMenuActionService.ɵfac = function DwRefreshMetadataMenuActionService_Factory(t) { return new (t || DwRefreshMetadataMenuActionService)(ɵngcc0.ɵɵinject(DwMetaDataServiceToken)); };
DwRefreshMetadataMenuActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwRefreshMetadataMenuActionService, factory: DwRefreshMetadataMenuActionService.ɵfac });
DwRefreshMetadataMenuActionService.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRefreshMetadataMenuActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, null); })();
DwActionFunc({
    keyName: 'metadataRefreshMenu',
    display: 'Refresh Selected',
    actionType: DwActionType.gridContextMenuAction,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataItem,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: true
    },
    defaultMenuConfig: {
        useParentDisplay: true,
        itemRequirement: DwActionItemRequirement.multiple,
    }
}, DwRefreshMetadataMenuActionService);

function DwBreadCrumbCustomization(breadcrumbDef) {
    return function (constructor) {
        DwBreadCrumbCustomizationFunc(breadcrumbDef, constructor);
    };
}
function DwBreadCrumbCustomizationFunc(breadcrumbDef, componentOrService) {
    let actionRef = Object.assign(Object.assign({}, breadcrumbDef), { keyName: breadcrumbDef.keyName || breadcrumbDef.display, service: componentOrService });
    let uiConfigRegistyService = new DwUiConfigRegistryService();
    uiConfigRegistyService.registerItem(DwUiRegistryType.breadCrumbCustomizationProcessor, actionRef);
}

class DwGridViewBreadcrumbProcessor {
    processBreadcrumb(breadcrumbMenu, routeSnapshot, url, menu, menuData) {
        var _a;
        if (((_a = menu === null || menu === void 0 ? void 0 : menu.data) === null || _a === void 0 ? void 0 : _a.referenceKey) === 'mdGridView') {
            if (routeSnapshot.params.itemName && breadcrumbMenu.data) {
                breadcrumbMenu.metaDataItem = routeSnapshot.params.itemName;
                breadcrumbMenu.breadcrumbDisplay = addSpaces(routeSnapshot.params.itemName);
            }
        }
    }
}
DwGridViewBreadcrumbProcessor.ɵfac = function DwGridViewBreadcrumbProcessor_Factory(t) { return new (t || DwGridViewBreadcrumbProcessor)(); };
DwGridViewBreadcrumbProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGridViewBreadcrumbProcessor, factory: DwGridViewBreadcrumbProcessor.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGridViewBreadcrumbProcessor, [{
        type: Injectable
    }], null, null); })();
DwBreadCrumbCustomizationFunc({
    keyName: 'dwGridViewBreadcrumbProcessor',
    display: 'Grid View Breadcrumb Processor',
    order: 1,
}, DwGridViewBreadcrumbProcessor);

class UserProfileBreadcrumbProcessor {
    constructor(dwSecurityState) {
        this.dwSecurityState = dwSecurityState;
    }
    processBreadcrumb(breadcrumbMenu, routeSnapshot, url, menu, menuData) {
        if ((menu === null || menu === void 0 ? void 0 : menu.path) === 'user-profile') {
            if (this.dwSecurityState.securityState.isAuthenticated) {
                const user = this.dwSecurityState.securityState.securityContext.ApplicationUser;
                breadcrumbMenu.breadcrumbDisplay = `${user.FirstName}'s Profile`;
                /*
                 Just playing around to see how async items would work ... and this worked just fine!
                let count=0;
                 setInterval(() => {
                     count++;
                     breadcrumbMenu.breadcrumbDisplay = `${user.FirstName}'s Profile ${count}`;
                 },1000) */
            }
            // breadcrumbMenu.breadcrumbDisplay = "Some user prorfile!";
        }
    }
}
UserProfileBreadcrumbProcessor.ɵfac = function UserProfileBreadcrumbProcessor_Factory(t) { return new (t || UserProfileBreadcrumbProcessor)(ɵngcc0.ɵɵinject(DwSecurityStateService)); };
UserProfileBreadcrumbProcessor.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: UserProfileBreadcrumbProcessor, factory: UserProfileBreadcrumbProcessor.ɵfac });
UserProfileBreadcrumbProcessor.ctorParameters = () => [
    { type: DwSecurityStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(UserProfileBreadcrumbProcessor, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityStateService }]; }, null); })();
DwBreadCrumbCustomizationFunc({
    keyName: 'UserProfileBreadcrumbProcessor',
    display: 'User Profile Breadcrumb Processor',
    order: 1
}, UserProfileBreadcrumbProcessor);

var __decorate$2c = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwItemParentContextService = class DwItemParentContextService extends DwCustomContextBase {
    setupContextDefinition(userContextDef) {
        userContextDef.data = {};
        userContextDef.getCustomContextFunction = (context, contextData) => {
            const lookupData = context === null || context === void 0 ? void 0 : context.data;
            return lookupData;
        };
        userContextDef.attributes = this.getContextAttribute();
    }
    getContextAttribute() {
        const attributes = [];
        this.addProperty(attributes, 'MetaDataItemId', 'Item Id', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'MetaDataQueryId', 'Query Id', DwAttributeType.Integer, DwControlType.NumericTextBox);
        return attributes;
    }
}
const ɵDwItemParentContextService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwItemParentContextService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwItemParentContextService, [{
        type: Injectable
    }], null, null); })();;
DwItemParentContextService.ɵfac = function DwItemParentContextService_Factory(t) { return ɵDwItemParentContextService_BaseFactory(t || DwItemParentContextService); };
DwItemParentContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwItemParentContextService, factory: function (t) { return DwItemParentContextService.ɵfac(t); } });
DwItemParentContextService = __decorate$2c([
    DwCustomContextDefinition({
        keyName: 'itemParentContext',
        display: 'Item parent Context',
        isGlobal: false,
        parentItem: DevwareMetaDataItemNames.DwMetaDataLookup
    }),
    DwCustomContextDefinition({
        keyName: 'itemParentContext2',
        display: 'Item parent Context',
        isGlobal: false,
        parentItem: DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem
    })
], DwItemParentContextService);

class DwMetaDataLookupTesterComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataFormStateService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.showTester = true;
    }
    ngOnInit() {
    }
    testLookup() {
        this.lookupDef = this.dwMetaDataFormStateService.state.formApi.getFormData();
        //
        if (this.lookupDef.GroupByAttributeId) {
        }
        this.lookupItems = null;
        this.errorMessage = null;
        if (!this.lookupDef.MetaDataLookupId) {
            this.lookupDef.MetaDataLookupId = -1;
        }
        if (!this.lookupDef.LookupMeaning) {
            this.lookupDef.LookupMeaning = 'Test_Lookup';
        }
        this.subscriptions.push(this.dwMetaDataService.testLookup(this.lookupDef, 20)
            .subscribe(result => {
            this.lookupItems = result;
            this.errorMessage = null;
        }, error => {
            this.errorMessage = getErrorDetails(error).message;
        }));
    }
    getLookupDef() {
        const lookup = this.dwMetaDataFormStateService.state.formApi.getFormData();
        if (!this.lookupDef.GroupByAttributeId) {
            return of(lookup);
        }
        // Need to load the group attribute name
        return this.dwMetaDataService.getMetaDataItemName(lookup.MetaDataItemId)
            .pipe(mergeMap(itemName => {
            return this.dwMetaDataService.getMetaData(itemName)
                .pipe(map(itemMd => {
                const attr = itemMd === null || itemMd === void 0 ? void 0 : itemMd.Attributes.find(a => a.MetaDataAttributeId == parseInt(lookup.GroupByAttributeId.toString()));
                lookup.GroupByAttributeName = attr === null || attr === void 0 ? void 0 : attr.AttributeName;
                return lookup;
            }));
        }));
    }
}
DwMetaDataLookupTesterComponent.ɵfac = function DwMetaDataLookupTesterComponent_Factory(t) { return new (t || DwMetaDataLookupTesterComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwMetaDataLookupTesterComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataLookupTesterComponent, selectors: [["dw-meta-data-lookup-tester"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["dwRow", "", 4, "ngIf"], [4, "ngIf"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelOptions", "ngModelChange"], [1, "btn", "btn-primary", 3, "click"], ["dwCol", "6", 4, "ngIf"], ["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"], ["lookupId", "-1", 3, "lookupDef", "overrideValues"]], template: function DwMetaDataLookupTesterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetaDataLookupTesterComponent_div_0_Template, 5, 3, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMetaDataLookupTesterComponent_ng_container_1_Template, 7, 1, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showTester);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showTester);
    } }, directives: [ɵngcc4.NgIf, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwSearchSelectLookupComponent], encapsulation: 2 });
DwMetaDataLookupTesterComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataLookupTesterComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-lookup-tester',
                template: `
    <div dwRow *ngIf="!showTester">
      <div dwCol="6">
            <label>Show Tester</label>
            <dw-yesno [(ngModel)]="showTester" [ngModelOptions]="{standalone:true}"></dw-yesno>
      </div>
    </div>
    <ng-container *ngIf="showTester">
      <div dwRow>
        <div dwCol="6">
            <button class="btn btn-primary" (click)="testLookup()">Test Lookup</button>
        </div>
      </div>
      <div dwRow>
        <div dwCol="6" *ngIf="errorMessage || lookupItems">
            <label>Test Results</label><br>
            <div *ngIf="errorMessage" class="alert alert-danger">
                {{errorMessage}}
            </div>
            <div *ngIf="lookupItems">
              <dw-search-select-lookup [lookupDef]="lookupDef" lookupId="-1" [overrideValues]="lookupItems"></dw-search-select-lookup>
            </div>
        </div>
    </div>
    </ng-container>
  `
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormStateService }]; }, null); })();
DwComponentFunc({
    key: 'metaDataLookupTester',
    name: 'Lookup Tester',
    isGlobal: false,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataLookup,
    componentType: DwComponentType.pageComponent
}, DwMetaDataLookupTesterComponent);

class DevwareGetStartedComponent {
    constructor() {
        this.textboxControlType = DwControlType.Textbox;
    }
    ngOnInit() {
    }
}
DevwareGetStartedComponent.ɵfac = function DevwareGetStartedComponent_Factory(t) { return new (t || DevwareGetStartedComponent)(); };
DevwareGetStartedComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DevwareGetStartedComponent, selectors: [["dw-devware-get-started"]], decls: 39, vars: 1, consts: [["configKey", "devware-get-started"], ["name", "title", "display", "Page Title", 3, "controlType"], ["name", "detail", "display", "Header Details"], [1, "getting-started"], ["src", "/assets/img/stock/cap-overview.png", "width", "1000"], ["href", "https://docs.devwareapps.com/docs/getting-started", "rel", "noopener noreferrer", "target", "_blank"], ["href", "https://docs.devwareapps.com/v1/docs/first-time-run", "rel", "noopener noreferrer", "target", "_blank"], ["href", "https://docs.devwareapps.com/v1/docs/connect-youre-own-databases", "rel", "noopener noreferrer", "target", "_blank"], ["href", "https://docs.devwareapps.com/v1/docs/menu-and-routing-overview", "rel", "noopener noreferrer", "target", "_blank"], ["name", "component", "display", "Custom Component"]], template: function DevwareGetStartedComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-content-manager", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵelementStart(2, "dw-content", 1);
        ɵngcc0.ɵɵtext(3, " Welcome to the Devware CAP ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "dw-content", 2);
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "p");
        ɵngcc0.ɵɵtext(7, "The Devware CAP is a Rapid Application Development platform that integrates data across your business to quickly build data-driven business applications.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "p");
        ɵngcc0.ɵɵelement(9, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "p");
        ɵngcc0.ɵɵelement(11, "img", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "p");
        ɵngcc0.ɵɵelement(13, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "h2");
        ɵngcc0.ɵɵtext(15, "Getting Started ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "p");
        ɵngcc0.ɵɵelement(17, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "p");
        ɵngcc0.ɵɵtext(19, "Now sure what to do next? Check out the following guides to help you get started!");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "p");
        ɵngcc0.ɵɵelementStart(21, "a", 5);
        ɵngcc0.ɵɵelementStart(22, "strong");
        ɵngcc0.ɵɵtext(23, "Getting Started with the Devware CAP");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "p");
        ɵngcc0.ɵɵelementStart(25, "a", 6);
        ɵngcc0.ɵɵelementStart(26, "strong");
        ɵngcc0.ɵɵtext(27, "First Time Running the CAP");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "p");
        ɵngcc0.ɵɵelementStart(29, "a", 7);
        ɵngcc0.ɵɵelementStart(30, "strong");
        ɵngcc0.ɵɵtext(31, "Connect your databases");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "p");
        ɵngcc0.ɵɵelementStart(33, "a", 8);
        ɵngcc0.ɵɵelementStart(34, "strong");
        ɵngcc0.ɵɵtext(35, "Menu and Routing Overview");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(36, "p");
        ɵngcc0.ɵɵelement(37, "br");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(38, "dw-content-component", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("controlType", ctx.textboxControlType);
    } }, directives: [DwContentManagerComponent, DwContentDirective, DwMissingImageDirective, DwContentComponent], styles: [""] });
DevwareGetStartedComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareGetStartedComponent, [{
        type: Component,
        args: [{
                selector: 'dw-devware-get-started',
                template: "<dw-content-manager configKey=\"devware-get-started\">\r\n    <h1>\r\n        <dw-content name=\"title\" display=\"Page Title\" [controlType]=\"textboxControlType\">\r\n            Welcome to the Devware CAP\r\n        </dw-content>\r\n    </h1>\r\n\r\n    <dw-content name=\"detail\" display=\"Header Details\">\r\n        <div class=\"getting-started\"><p>The Devware CAP is a Rapid Application Development platform that integrates data across your business to quickly build data-driven business applications.</p><p><br></p><p><img src=\"/assets/img/stock/cap-overview.png\" width=\"1000\"> </p><p><br></p><h2>Getting Started </h2><p><br></p><p>Now sure what to do next? Check out the following guides to help you get started!</p><p><a href=\"https://docs.devwareapps.com/docs/getting-started\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>Getting Started with the Devware CAP</strong></a></p><p><a href=\"https://docs.devwareapps.com/v1/docs/first-time-run\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>First Time Running the CAP</strong></a></p><p><a href=\"https://docs.devwareapps.com/v1/docs/connect-youre-own-databases\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>Connect your databases</strong></a></p><p><a href=\"https://docs.devwareapps.com/v1/docs/menu-and-routing-overview\" rel=\"noopener noreferrer\" target=\"_blank\"><strong>Menu and Routing Overview</strong></a></p><p><br></p></div>\r\n    </dw-content>\r\n\r\n    <dw-content-component name='component' display='Custom Component'></dw-content-component>\r\n</dw-content-manager>",
                styles: [""]
            }]
    }], function () { return []; }, null); })();
DwComponentFunc({
    name: 'Devware Get Started',
    key: 'devware-get-started',
    componentType: DwComponentType.pageComponent,
    isGlobal: true
}, DevwareGetStartedComponent);

var MonthDayInterval;
(function (MonthDayInterval) {
    MonthDayInterval["First"] = "First";
    MonthDayInterval["Seconds"] = "Second";
    MonthDayInterval["Third"] = "Third";
    MonthDayInterval["Fourth"] = "Fourth";
    MonthDayInterval["Last"] = "Last";
})(MonthDayInterval || (MonthDayInterval = {}));
class MonthDayIntervalList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return MonthDayInterval[propertyName];
    }
    getKeys() {
        return Object.keys(MonthDayInterval);
    }
    getEnumDisplay(item) {
        switch (item) {
            default:
                return item;
        }
    }
}

var ScheduleFrequency;
(function (ScheduleFrequency) {
    ScheduleFrequency["OneTime"] = "OneTime";
    ScheduleFrequency["Periodic"] = "Periodic";
    ScheduleFrequency["Daily"] = "Daily";
    ScheduleFrequency["Weekly"] = "Weekly";
    ScheduleFrequency["Monthly"] = "Monthly";
    ScheduleFrequency["OnDemand"] = "OnDemand";
    ScheduleFrequency["Always"] = "Always";
})(ScheduleFrequency || (ScheduleFrequency = {}));
class ScheduleFrequencyList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return ScheduleFrequency[propertyName];
    }
    getKeys() {
        return Object.keys(ScheduleFrequency);
    }
    getEnumDisplay(item) {
        switch (item) {
            /* case ScheduleFrequency.Always:
                return 'Always';
            case ScheduleFrequency.Periodic:
                return 'Periodic';
            case ScheduleFrequency.Daily:
                return 'Daily';
            case ScheduleFrequency.Weekly:
                return 'Weekly'; */
            case ScheduleFrequency.Monthly:
                return 'Monthly';
            case ScheduleFrequency.OnDemand:
                return 'On Demand';
            case ScheduleFrequency.OneTime:
                return 'One Time';
            default:
                return item;
        }
    }
}

var MonthDaySelection;
(function (MonthDaySelection) {
    MonthDaySelection["Day"] = "Day";
    MonthDaySelection["Weekday"] = "Weekday";
    MonthDaySelection["Weekend"] = "Weekend";
    MonthDaySelection["Sunday"] = "Sunday";
    MonthDaySelection["Monday"] = "Monday";
    MonthDaySelection["Tuesday"] = "Tuesday";
    MonthDaySelection["Wednesday"] = "Wednesday";
    MonthDaySelection["Thursday"] = "Thursday";
    MonthDaySelection["Friday"] = "Friday";
    MonthDaySelection["Saturday"] = "Saturday";
})(MonthDaySelection || (MonthDaySelection = {}));
class MonthDaySelectionList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return MonthDaySelection[propertyName];
    }
    getKeys() {
        return Object.keys(MonthDaySelection);
    }
    getEnumDisplay(item) {
        switch (item) {
            default:
                return item;
        }
    }
}

var __decorate$2d = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let DwProcessScheduleConfigComponent = class DwProcessScheduleConfigComponent extends DwSectionBaseComponent {
    constructor() {
        super(...arguments);
        this.ignoreChange = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.scheduleFrequencies = new ScheduleFrequencyList().getEnumList();
        this.monthDayIntervals = new MonthDayIntervalList().getEnumList();
        this.monthDaySelection = new MonthDaySelectionList().getEnumList();
        this.setupFormFields();
    }
    /**
    * Sets up the FormGroup and Form controls
    **/
    setupFormFields() {
        let initialValue = null;
        if (this.context.data && this.context.data.value) {
            initialValue = this.context.data.value.ScheduleJSON;
        }
        this.scheduleJsonFC = new FormControl(initialValue);
        //    this.formGroup.getRawValue();
        this.formGroup.addControl('ScheduleJSON', this.scheduleJsonFC);
        this.setupScheduleDef();
        this.scheduleJsonFC.valueChanges.subscribe(value => {
            if (value && !this.ignoreChange) {
                this.setupScheduleDef();
            }
        });
    }
    setupScheduleDef() {
        const scheduleJSONFC = this.formGroup.get("ScheduleJSON");
        this.scheduleDefinition = scheduleJSONFC.value;
        if (!this.scheduleDefinition) {
            this.scheduleDefinition = {};
        }
        if (!this.scheduleDefinition.Frequency) {
            this.scheduleDefinition.Frequency = ScheduleFrequency.Daily;
        }
        if (!this.scheduleDefinition.PeriodicInterval) {
            this.scheduleDefinition.PeriodicInterval = 5 * 60;
        }
        this.setupInterval();
    }
    onScheduleChange() {
        if (this.scheduleDefinition) {
            this.ignoreChange = true;
            const scheduleJSONFC = this.formGroup.get("ScheduleJSON");
            scheduleJSONFC.setValue(this.scheduleDefinition);
            this.ignoreChange = false;
        }
    }
    setupInterval() {
        let periodicInterval = this.scheduleDefinition.PeriodicInterval;
        switch (this.scheduleDefinition.Frequency) {
            case ScheduleFrequency.Periodic:
                if (periodicInterval % 60 == 0) {
                    if (periodicInterval % 60 * 60 == 0 && periodicInterval > 60 * 60) {
                        this.intervalUOM = IntervalUOM.hours;
                        this.intervalValue = periodicInterval / 60 / 60;
                    }
                    else {
                        this.intervalUOM = IntervalUOM.minutes;
                        this.intervalValue = periodicInterval / 60;
                    }
                }
                else {
                    this.intervalUOM = IntervalUOM.seconds;
                    this.intervalValue = periodicInterval;
                }
                break;
            case ScheduleFrequency.Daily:
                if (periodicInterval > 99 || periodicInterval < 1) {
                    periodicInterval = 1;
                }
                this.intervalUOM = IntervalUOM.days;
                this.intervalValue = periodicInterval;
                break;
            case ScheduleFrequency.Daily:
                if (periodicInterval > 99 || periodicInterval < 1) {
                    periodicInterval = 1;
                }
                this.intervalUOM = IntervalUOM.weeks;
                this.intervalValue = periodicInterval;
                break;
            case ScheduleFrequency.Monthly:
                if (periodicInterval > 99 || periodicInterval < 1) {
                    periodicInterval = 1;
                }
                this.intervalUOM = IntervalUOM.months;
                this.intervalValue = periodicInterval;
                break;
        }
    }
    frequencyChange() {
        switch (this.scheduleDefinition.Frequency) {
            case ScheduleFrequency.Periodic:
                this.scheduleDefinition.PeriodicInterval = 5 * 60;
                this.scheduleDefinition.OffsetMinute = 0;
                this.scheduleDefinition.OffsetSecond = 0;
                break;
            case ScheduleFrequency.Daily:
            case ScheduleFrequency.Weekly:
            case ScheduleFrequency.Monthly:
                this.scheduleDefinition.PeriodicInterval = 1;
                this.scheduleDefinition.StartTime = '12:00 PM';
                this.scheduleDefinition.MonthDayInterval = MonthDayInterval.First;
                this.scheduleDefinition.MonthDaySelection = MonthDaySelection.Day;
                this.scheduleDefinition.RunOnSunday = this.scheduleDefinition.RunOnMonday = this.scheduleDefinition.RunOnTuesday = this.scheduleDefinition.RunOnWednesday = this.scheduleDefinition.RunOnThursday = this.scheduleDefinition.RunOnFriday = false;
                this.scheduleDefinition.RunOnSaturday = true;
                break;
        }
        this.setupInterval();
        this.updateInterval();
        this.onScheduleChange();
    }
    selectAllDays() {
        this.scheduleDefinition.RunOnSaturday = this.scheduleDefinition.RunOnSunday = this.scheduleDefinition.RunOnMonday = this.scheduleDefinition.RunOnTuesday = this.scheduleDefinition.RunOnWednesday = this.scheduleDefinition.RunOnThursday = this.scheduleDefinition.RunOnFriday = true;
    }
    clearAllDays() {
        this.scheduleDefinition.RunOnSaturday = this.scheduleDefinition.RunOnSunday = this.scheduleDefinition.RunOnMonday = this.scheduleDefinition.RunOnTuesday = this.scheduleDefinition.RunOnWednesday = this.scheduleDefinition.RunOnThursday = this.scheduleDefinition.RunOnFriday = false;
    }
    updateInterval() {
        if (!this.intervalValue) {
            this.intervalValue = 5;
        }
        switch (this.intervalUOM) {
            case IntervalUOM.seconds:
                this.scheduleDefinition.PeriodicInterval = this.intervalValue;
                break;
            case IntervalUOM.minutes:
                this.scheduleDefinition.PeriodicInterval = this.intervalValue * 60;
                ;
                break;
            case IntervalUOM.hours:
                this.scheduleDefinition.PeriodicInterval = this.intervalValue * 60 * 60;
                break;
            default:
                this.scheduleDefinition.PeriodicInterval = this.intervalValue;
        }
        this.onScheduleChange();
    }
}
const ɵDwProcessScheduleConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwProcessScheduleConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwProcessScheduleConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-process-schedule-config',
                template: "<div class=\"schedulePanel\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Frequency</label>\r\n\r\n            <dw-radio-list [values]=\"scheduleFrequencies\" [(ngModel)]=\"scheduleDefinition.Frequency\"\r\n                (ngModelChange)=\"frequencyChange()\"></dw-radio-list>\r\n        </div>\r\n    </div>\r\n\r\n    <ng-container [ngSwitch]=\"scheduleDefinition?.Frequency\">\r\n\r\n        <div *ngSwitchCase=\"'Periodic'\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Schedule</label>\r\n                    <div class=\"float-left even-text\">Run Every </div>\r\n\r\n                    <div class=\"float-left control-item numeric-input\">\r\n                        <dw-input [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item\">\r\n                        <select [(ngModel)]=\"intervalUOM\" (ngModelChange)=\"updateInterval()\" class=\"form-control\">\r\n                            <option value=\"seconds\">Second<ng-container *ngIf=\"intervalValue != '1'\">s</ng-container></option>\r\n                            <option value=\"minutes\">Minute<ng-container *ngIf=\"intervalValue != '1'\">s</ng-container></option>\r\n                            <option value=\"hours\">Hour<ng-container *ngIf=\"intervalValue != '1'\">s</ng-container></option>\r\n                        </select>\r\n                    </div>\r\n\r\n                    <ng-container *ngIf=\"intervalUOM == 'minutes' || intervalUOM == 'hours' || true\">\r\n                        <div class=\"float-left control-item  even-text\">\r\n                            at an offset of \r\n                        </div>\r\n\r\n                        <ng-container *ngIf=\"intervalUOM == 'minutes' || intervalUOM == 'hours'\">\r\n                            <div class=\"float-left control-item numeric-input\">\r\n                                <dw-input [(ngModel)]=\"scheduleDefinition.OffsetMinute\" (ngModelChange)=\"onScheduleChange()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n                            </div>\r\n\r\n                            <div class=\"float-left control-item  even-text\">\r\n                                minute<ng-container *ngIf=\"scheduleDefinition.OffsetMinute != '1'\">s</ng-container> and\r\n                            </div>\r\n                        </ng-container>\r\n\r\n                        <div class=\"float-left control-item numeric-input\">\r\n                            <dw-input [(ngModel)]=\"scheduleDefinition.OffsetSecond\" (ngModelChange)=\"onScheduleChange()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n                        </div>\r\n\r\n                        <div class=\"float-left control-item  even-text\">\r\n                            second<ng-container *ngIf=\"scheduleDefinition.OffsetSecond != '1'\">s</ng-container> \r\n                        </div>\r\n\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div *ngSwitchCase=\"'Daily'\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Schedule</label>\r\n                    <div class=\"float-left  even-text\">Run Every </div>\r\n\r\n                    <div class=\"float-left control-item numeric-input\">\r\n                        <dw-input [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n\r\n                        <!-- <input type=\"Text\" dwNumeric [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" class=\"form-control numeric-input\">  -->\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item  even-text\">\r\n                        Day<ng-container *ngIf=\"intervalValue != '1'\">s</ng-container> at\r\n                    </div>\r\n                    <div class=\"float-left control-item\">\r\n                        <dw-date timeOnly=\"true\" [(ngModel)]=\"scheduleDefinition.StartTime\" (ngModelChanges)=\"onScheduleChange()\"></dw-date>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div *ngSwitchCase=\"'Weekly'\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Schedule</label>\r\n                    <div class=\"float-left even-text\">Run Every </div>\r\n\r\n                    <div class=\"float-left control-item numeric-input\">\r\n                        <dw-input [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n\r\n                        <!-- <input type=\"Text\" dwNumeric [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" class=\"form-control numeric-input\">  -->\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item even-text\">\r\n                        Week<ng-container *ngIf=\"intervalValue != '1'\">s</ng-container> at\r\n                    </div>\r\n                    <div class=\"float-left control-item\">\r\n                        <dw-date timeOnly=\"true\" [(ngModel)]=\"scheduleDefinition.StartTime\" (ngModelChanges)=\"onScheduleChange()\"></dw-date>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Days to Run</label>\r\n\r\n                    <div>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnMonday\" (ngModelChange)=\"onScheduleChange()\"> Monday</label>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnTuesday\" (ngModelChange)=\"onScheduleChange()\"> Tuesday</label>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnWednesday\" (ngModelChange)=\"onScheduleChange()\"> Wednesday</label>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnThursday\" (ngModelChange)=\"onScheduleChange()\"> Thursday</label>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnFriday\" (ngModelChange)=\"onScheduleChange()\"> Friday</label>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnSaturday\" (ngModelChange)=\"onScheduleChange()\"> Saturday</label>\r\n                        <label class=\"check-box-item\"><input type=\"checkbox\" [(ngModel)]=\"scheduleDefinition.RunOnSunday\" (ngModelChange)=\"onScheduleChange()\"> Sunday</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div *ngSwitchCase=\"'Monthly'\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Schedule</label>\r\n\r\n                    <div class=\"float-left even-text\">Run on the </div>\r\n\r\n                    <div class=\"float-left control-item\">\r\n                        <select [(ngModel)]=\"scheduleDefinition.MonthDayInterval\" (ngModelChange)=\"onScheduleChange()\" class=\"form-control\">\r\n                            <option *ngFor=\"let item of monthDayIntervals\" [ngValue]=\"item.value\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item\">\r\n                        <select [(ngModel)]=\"scheduleDefinition.MonthDaySelection\" (ngModelChange)=\"onScheduleChange()\" class=\"form-control\">\r\n                            <option *ngFor=\"let item of monthDaySelection\" [ngValue]=\"item.value\">\r\n                                {{item.display}}\r\n                            </option>\r\n                        </select>\r\n                    </div>\r\n\r\n\r\n                 <!--    <div class=\"float-left control-item numeric-input\">\r\n                        <dw-input [(ngModel)]=\"scheduleDefinition.DayOfMonth\" (ngModelChange)=\"onScheduleChange()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n                    </div> -->\r\n\r\n                    <div class=\"float-left control-item even-text\">\r\n                        of every\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item numeric-input\">\r\n                        <dw-input [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" inputClass=\"form-control\" [numeric]=\"true\"></dw-input>\r\n\r\n                        <!-- <input type=\"Text\" dwNumeric [(ngModel)]=\"intervalValue\" (ngModelChange)=\"updateInterval()\" maxlength=\"2\" class=\"form-control numeric-input\">  -->\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item even-text\">\r\n                        Month<ng-container *ngIf=\"intervalValue != '1'\">s</ng-container>\r\n                    </div>\r\n                  \r\n                   <!--  <div class=\"float-left control-item even-text\">\r\n                        from the \r\n                    </div>\r\n                    <div class=\"float-left control-item\">\r\n                        <select [(ngModel)]=\"scheduleDefinition.DayOfMonthOrder\" (ngModelChange)=\"onScheduleChange()\" class=\"form-control\">\r\n                            <option value=\"BeginningOfMonth\">Start of the Month</option>\r\n                            <option value=\"EndOfMonth\">End of the Month</option>\r\n                        </select>\r\n                    </div> -->\r\n                    <div class=\"float-left control-item even-text\">\r\n                        at\r\n                    </div>\r\n                    <div class=\"float-left control-item\">\r\n                        <dw-date timeOnly=\"true\" [(ngModel)]=\"scheduleDefinition.StartTime\" (ngModelChanges)=\"onScheduleChange()\"></dw-date>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div *ngSwitchCase=\"'OneTime'\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label class=\"label\">Schedule</label>\r\n                    <div class=\"float-left even-text\">Run On </div>\r\n\r\n                    <div class=\"float-left control-item\">\r\n                        <dw-date showTime=\"false\" [(ngModel)]=\"scheduleDefinition.StartDate\" (ngModelChanges)=\"onScheduleChange()\"></dw-date>\r\n                    </div>\r\n\r\n                    <div class=\"float-left control-item even-text\">at </div>\r\n\r\n                    <div class=\"float-left control-item\">\r\n                        <dw-date timeOnly=\"true\" [(ngModel)]=\"scheduleDefinition.StartTime\" (ngModelChanges)=\"onScheduleChange()\"></dw-date>\r\n                    </div>\r\n                    \r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n  <!--   <div>\r\n       {{scheduleDefinition | json }}<br>\r\n    </div> -->\r\n</div> \r\n\r\n<ng-template>\r\n    <h2>Offset<i class=\"fa fa-info-circle\"\r\n            title=\"Controls when the process is started. (e.g. 2 miuntes, 30 seconds after the hour vs on the hour)  Useful when you have multiple processes and want to stagger them\"></i>\r\n    </h2>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            Offset Minute\r\n            <input type=\"Text\" dwNumeric [(ngModel)]=\"scheduleDefinition.MinuteOffset\"\r\n                (ngModelChange)=\"onScheduleChange()\">\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            Offset Second\r\n        </div>\r\n    </div>\r\n</ng-template>",
                styles: [".control-item{float:left;margin-left:5px}.numeric-input{width:60px!important}.even-text{margin-top:6px}.check-box-item{margin-right:5px;margin-top:5px}.label{width:100%}"]
            }]
    }], null, null); })();;
DwProcessScheduleConfigComponent.ɵfac = function DwProcessScheduleConfigComponent_Factory(t) { return ɵDwProcessScheduleConfigComponent_BaseFactory(t || DwProcessScheduleConfigComponent); };
DwProcessScheduleConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwProcessScheduleConfigComponent, selectors: [["dw-process-schedule-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 8, consts: [[1, "schedulePanel"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], [3, "values", "ngModel", "ngModelChange"], [3, "ngSwitch"], [4, "ngSwitchCase"], [1, "float-left", "even-text"], [1, "float-left", "control-item", "numeric-input"], ["maxlength", "2", "inputClass", "form-control", 3, "ngModel", "numeric", "ngModelChange"], [1, "float-left", "control-item"], [1, "form-control", 3, "ngModel", "ngModelChange"], ["value", "seconds"], [4, "ngIf"], ["value", "minutes"], ["value", "hours"], [1, "float-left", "control-item", "even-text"], ["timeOnly", "true", 3, "ngModel", "ngModelChange", "ngModelChanges"], [1, "check-box-item"], ["type", "checkbox", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["showTime", "false", 3, "ngModel", "ngModelChange", "ngModelChanges"], ["title", "Controls when the process is started. (e.g. 2 miuntes, 30 seconds after the hour vs on the hour)  Useful when you have multiple processes and want to stagger them", 1, "fa", "fa-info-circle"], ["type", "Text", "dwNumeric", "", 3, "ngModel", "ngModelChange"]], template: function DwProcessScheduleConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label", 3);
        ɵngcc0.ɵɵtext(4, "Frequency");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "dw-radio-list", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwProcessScheduleConfigComponent_Template_dw_radio_list_ngModelChange_5_listener($event) { return ctx.scheduleDefinition.Frequency = $event; })("ngModelChange", function DwProcessScheduleConfigComponent_Template_dw_radio_list_ngModelChange_5_listener() { return ctx.frequencyChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerStart(6, 5);
        ɵngcc0.ɵɵtemplate(7, DwProcessScheduleConfigComponent_div_7_Template, 21, 7, "div", 6);
        ɵngcc0.ɵɵtemplate(8, DwProcessScheduleConfigComponent_div_8_Template, 15, 4, "div", 6);
        ɵngcc0.ɵɵtemplate(9, DwProcessScheduleConfigComponent_div_9_Template, 41, 11, "div", 6);
        ɵngcc0.ɵɵtemplate(10, DwProcessScheduleConfigComponent_div_10_Template, 24, 8, "div", 6);
        ɵngcc0.ɵɵtemplate(11, DwProcessScheduleConfigComponent_div_11_Template, 13, 2, "div", 6);
        ɵngcc0.ɵɵelementContainerEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DwProcessScheduleConfigComponent_ng_template_12_Template, 10, 1, "ng-template");
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("values", ctx.scheduleFrequencies)("ngModel", ctx.scheduleDefinition.Frequency);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.scheduleDefinition == null ? null : ctx.scheduleDefinition.Frequency);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Periodic");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Daily");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Weekly");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "Monthly");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", "OneTime");
    } }, directives: [DwRowDirective, DwColDirective, DwRadioListComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, DwInputComponent, ɵngcc3.MaxLengthValidator, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, ɵngcc4.NgIf, DwDateInputControlComponent, ɵngcc3.CheckboxControlValueAccessor, ɵngcc4.NgForOf, DwNumericDirective, ɵngcc3.DefaultValueAccessor], styles: [".control-item[_ngcontent-%COMP%]{float:left;margin-left:5px}.numeric-input[_ngcontent-%COMP%]{width:60px!important}.even-text[_ngcontent-%COMP%]{margin-top:6px}.check-box-item[_ngcontent-%COMP%]{margin-right:5px;margin-top:5px}.label[_ngcontent-%COMP%]{width:100%}"] });
DwProcessScheduleConfigComponent = __decorate$2d([
    DwComponent({
        key: 'dwProcessScheduleConfig',
        name: 'Process Schedule Config',
        parentItemName: 'dw_ProcessSchedule',
        componentType: DwComponentType.formSection,
    })
], DwProcessScheduleConfigComponent);
var IntervalUOM;
(function (IntervalUOM) {
    IntervalUOM["seconds"] = "seconds";
    IntervalUOM["minutes"] = "minutes";
    IntervalUOM["hours"] = "hours";
    IntervalUOM["days"] = "days";
    IntervalUOM["weeks"] = "weeks";
    IntervalUOM["months"] = "months";
})(IntervalUOM || (IntervalUOM = {}));

var SchedulerServiceStatus;
(function (SchedulerServiceStatus) {
    SchedulerServiceStatus["Stopped"] = "Stopped";
    SchedulerServiceStatus["StartPending"] = "StartPending";
    SchedulerServiceStatus["StopPending"] = "StopPending";
    SchedulerServiceStatus["Running"] = "Running";
    SchedulerServiceStatus["ContinuePending"] = "ContinuePending";
    SchedulerServiceStatus["PausePending"] = "PausePending";
    SchedulerServiceStatus["Paused"] = "Paused";
})(SchedulerServiceStatus || (SchedulerServiceStatus = {}));
function getScheduleServiceStatusDisplay(status) {
    switch (status) {
        case SchedulerServiceStatus.StartPending:
            return 'Start Pending';
        case SchedulerServiceStatus.StopPending:
            return 'Stop Pending';
        case SchedulerServiceStatus.ContinuePending:
            return 'Continue Pending';
        case SchedulerServiceStatus.PausePending:
            return 'Pause Pending';
    }
    return status;
}

const DwAdminConfigName = 'DwAdminConfig';
const DwAdminConfigToken = new InjectionToken("DwAdminConfigName");

// @DwComponent({
//   key: 'dwProcessSchedulerStatus',
//   name: 'Process Scheduler Status',
//   isGlobal: true,
//   componentType: DwComponentType.pageComponent,
//   configData : {
//     test : forwardRef(() => DwProcessSchedulerStatusComponent)
//   }
// })
class DwProcessSchedulerStatusComponent {
    constructor(dwSchedulerService, dwEventService, dwAdminConfig) {
        this.dwSchedulerService = dwSchedulerService;
        this.dwEventService = dwEventService;
        this.dwAdminConfig = dwAdminConfig;
        this.defaultServiceCheckInterval = 60000;
        this.defaultScheduleCheckInterval = 5000;
        this.loading = true;
        this.serviceStatusClass = 'dw-red';
        this.serviceStatusText = '';
        this.destroyed = false;
        this.subscriptions = [];
        this.schedulerConfig = this.dwAdminConfig.schedulerConfig;
    }
    ngOnInit() {
        this.checkServiceStatus(true, this.schedulerConfig.serviceCheckInterval || this.defaultScheduleCheckInterval);
        this.checkScheduleChanges(this.schedulerConfig.scheduleCheckInterval || this.defaultScheduleCheckInterval);
    }
    ngOnDestroy() {
        this.destroyed = true;
        for (var subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        if (this.serviceTimeoutHandle) {
            clearTimeout(this.serviceTimeoutHandle);
        }
        if (this.scheduleTimeoutHandle) {
            clearTimeout(this.scheduleTimeoutHandle);
        }
    }
    checkServiceStatus(repeat = false, intervalOverride, waitForStatus) {
        this.subscriptions.push(this.dwSchedulerService.getServiceStatus()
            .subscribe(result => {
            this.serviceStatusResult = result;
            this.setServiceStatusClass();
            this.checkSchedulerHeartbeat();
            if (waitForStatus && this.serviceStatusResult.ServiceStatus == waitForStatus) {
                return;
            }
            if (this.serviceTimeoutHandle) {
                clearTimeout(this.serviceTimeoutHandle);
            }
            if (this.destroyed) {
                return;
            }
            this.serviceTimeoutHandle = setTimeout(() => {
                this.checkServiceStatus(false, intervalOverride);
            }, intervalOverride);
        }));
    }
    checkScheduleChanges(checkFrequency) {
        this.scheduleTimeoutHandle = setInterval(() => {
            this.checkScheduleRefresh();
        }, checkFrequency);
    }
    checkScheduleRefresh() {
        this.dwSchedulerService.getLastModifiedSchedule()
            .subscribe(result => {
            if (this.hasScheduleChanges(result)) {
                // Need to refresh grid
                this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaData.DwProcessSchedule.ItemDetail.ItemName), {});
            }
            this.lastScheduleHistory = result;
        });
    }
    hasScheduleChanges(updatedScheduleHistory) {
        if (!this.lastScheduleHistory || !this.lastScheduleHistory.DwProcessScheduleSummary) {
            return false;
        }
        if (this.lastScheduleHistory.ModifiedDateTime != updatedScheduleHistory.ModifiedDateTime) {
            return true;
        }
        if (this.lastScheduleHistory.DwProcessScheduleSummary.ModifiedDateTime != updatedScheduleHistory.DwProcessScheduleSummary.ModifiedDateTime) {
            return true;
        }
        return false;
    }
    checkSchedulerHeartbeat() {
        this.subscriptions.push(this.dwSchedulerService.checkHeartbeat()
            .subscribe(result => {
            this.loading = false;
            /*  if (!result.Success && this.serviceStatusResult.ServiceStatus == SchedulerServiceStatus.Running) {
               this.showServiceMessage(result, '', 'Error checking API heartbeat!')
             } */
            this.schedulerHeartbeat = result;
        }));
    }
    setServiceStatusClass() {
        this.serviceStatusClass = 'dw-red';
        this.serviceStatusText = getScheduleServiceStatusDisplay(this.serviceStatusResult.ServiceStatus);
        if (this.serviceStatusResult.Success) {
            switch (this.serviceStatusResult.ServiceStatus) {
                case SchedulerServiceStatus.Running:
                    this.serviceStatusClass = 'dw-green';
                    break;
                case SchedulerServiceStatus.StartPending:
                case SchedulerServiceStatus.StopPending:
                case SchedulerServiceStatus.ContinuePending:
                case SchedulerServiceStatus.PausePending:
                    this.serviceStatusClass = 'dw-orange';
                    break;
                case SchedulerServiceStatus.Stopped:
                case SchedulerServiceStatus.Paused:
                    // Still red
                    break;
            }
        }
        else {
            this.serviceStatusText = 'Error';
        }
    }
    startService() {
        this.dwSchedulerService.startService()
            .subscribe(result => {
            this.showServiceMessage(result, 'Scheduler Service successfully started', 'Could not start scheduler service');
            this.checkServiceStatus(true, 5, SchedulerServiceStatus.Running);
        });
    }
    stopService() {
        this.dwSchedulerService.stopService()
            .subscribe(result => {
            this.showServiceMessage(result, 'Scheduler Service successfully stopped', 'Could not stop scheduler service');
            this.checkServiceStatus(true, 5, SchedulerServiceStatus.Stopped);
        });
    }
    showServiceMessage(result, successMessage, errorMessage) {
        const message = {};
        message.allowClose = true;
        if (result.Success) {
            message.messageBody = successMessage;
            message.severity = DwMessageSeverity.success;
            message.timeToShow = 10000;
        }
        else {
            message.messageBody = `${errorMessage} ${result.Message}`;
            if (result.LogId) {
                message.linkUrl = `/admin/other/logging/edit/${result.LogId}`;
                message.linkText = 'View Error';
                message.linkIcon = 'fa fa-log';
            }
            message.severity = DwMessageSeverity.error;
        }
        this.message = message;
    }
}
DwProcessSchedulerStatusComponent.ɵfac = function DwProcessSchedulerStatusComponent_Factory(t) { return new (t || DwProcessSchedulerStatusComponent)(ɵngcc0.ɵɵdirectiveInject(DwSchedulerService), ɵngcc0.ɵɵdirectiveInject(DwEventService), ɵngcc0.ɵɵdirectiveInject(DwAdminConfigToken)); };
DwProcessSchedulerStatusComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwProcessSchedulerStatusComponent, selectors: [["dw-process-scheduler-status"]], decls: 2, vars: 2, consts: [[3, "message", "messageChange"], ["class", "card-container", 4, "ngIf"], [1, "card-container"], [1, "card", 2, "width", "18rem"], [1, "card-body"], [1, "card-title"], [1, "card-text", 2, "overflow", "auto"], [1, "float-left", 3, "title"], [1, "fa", "fa-clock", "fa-2x", 3, "ngClass"], [1, "float-left", "ml-5", 3, "hidden", "title"], [1, "fa", "fa-signal-alt", "fa-2x", "dw-green"], [1, "fa", "fa-signal-slash", "fa-2x", "dw-red"], [4, "ngIf"], [1, "card-link", "hand", 3, "click"], [1, "fa", "fa-sync-alt"], [1, "card-link", "hand", 3, "hidden", "click"], [1, "fa", "fa-play", "dw-green"], [1, "fa", "fa-stop", "dw-red"]], template: function DwProcessSchedulerStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-message", 0);
        ɵngcc0.ɵɵlistener("messageChange", function DwProcessSchedulerStatusComponent_Template_dw_message_messageChange_0_listener($event) { return ctx.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(1, DwProcessSchedulerStatusComponent_div_1_Template, 20, 8, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading);
    } }, directives: [DwMessageComponent, ɵngcc4.NgIf, ɵngcc4.NgClass], styles: [".card-container[_ngcontent-%COMP%]{overflow:auto}.card[_ngcontent-%COMP%]{float:left;margin-right:25px}"] });
DwProcessSchedulerStatusComponent.ctorParameters = () => [
    { type: DwSchedulerService },
    { type: DwEventService },
    { type: undefined, decorators: [{ type: Inject, args: [DwAdminConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwProcessSchedulerStatusComponent, [{
        type: Component,
        args: [{
                selector: 'dw-process-scheduler-status',
                template: "<dw-message [(message)]=\"message\"></dw-message>\r\n\r\n<div class=\"card-container\" *ngIf=\"!loading\">\r\n    <div class=\"card\" style=\"width: 18rem;\">\r\n        <div class=\"card-body\">\r\n            <h5 class=\"card-title\">Scheduler Service</h5>\r\n\r\n            <div class=\"card-text\" style=\"overflow:auto\">\r\n                <div class=\"float-left\" [title]=\"serviceStatusResult?.Message || ''\"><i class=\"fa fa-clock  fa-2x\"\r\n                        [ngClass]=\"serviceStatusClass\"></i> {{serviceStatusText}}</div>\r\n\r\n                <div [hidden]=\"!schedulerHeartbeat?.Success\" class=\"float-left ml-5\"\r\n                    [title]=\"schedulerHeartbeat?.Message || ''\">\r\n                    <i class=\"fa fa-signal-alt fa-2x dw-green\"></i>\r\n                    Api Online\r\n                </div>\r\n                <div [hidden]=\"schedulerHeartbeat?.Success\" class=\"float-left ml-5\"\r\n                    [title]=\"schedulerHeartbeat?.Message || ''\">\r\n                    <i class=\"fa fa-signal-slash  fa-2x dw-red\"></i>\r\n                    Api Offline\r\n                </div>\r\n            </div>\r\n            <br>\r\n            <ng-container *ngIf=\"schedulerConfig?.allowServiceControl\">\r\n                <a class=\"card-link hand\" (click)=\"startService()\"\r\n                    [hidden]=\"serviceStatusResult?.ServiceStatus=='Running'\"><i class=\"fa fa-play dw-green\"></i>&nbsp;\r\n                    Start Service</a>\r\n                <a class=\"card-link hand\" (click)=\"stopService()\"\r\n                    [hidden]=\"serviceStatusResult?.ServiceStatus!='Running'\"><i class=\"fa fa-stop dw-red\"></i>&nbsp;Stop\r\n                    Service</a>\r\n\r\n            </ng-container>\r\n            <a class=\"card-link hand\" (click)=\"checkServiceStatus()\"> <i class=\"fa fa-sync-alt\"></i>&nbsp; Refresh\r\n                Status</a>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [".card-container{overflow:auto}.card{float:left;margin-right:25px}"]
            }]
    }], function () { return [{ type: DwSchedulerService }, { type: DwEventService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwAdminConfigToken]
            }] }]; }, null); })();
DwComponentFunc({
    key: 'dwProcessSchedulerStatus',
    name: 'Process Scheduler Status',
    isGlobal: true,
    componentType: DwComponentType.pageComponent,
}, DwProcessSchedulerStatusComponent);

class DwStartProcessActionService {
    constructor(schedulerService) {
        this.schedulerService = schedulerService;
    }
    handleAction(gridActionState) {
        var _a;
        const processScheduleId = (_a = gridActionState.data) === null || _a === void 0 ? void 0 : _a.ProcessScheduleId;
        return this.schedulerService.startProcess(processScheduleId)
            .pipe(map(processResult => {
            var _a;
            const actionResult = {
                success: processResult.Success
            };
            if (processResult.Success) {
                actionResult.refreshData = true;
                actionResult.message = `Process ${(_a = gridActionState.data) === null || _a === void 0 ? void 0 : _a.ScheduleDescription} was started!`;
            }
            else {
                actionResult.message = processResult.Message;
            }
            return actionResult;
        }));
    }
}
DwStartProcessActionService.ɵfac = function DwStartProcessActionService_Factory(t) { return new (t || DwStartProcessActionService)(ɵngcc0.ɵɵinject(DwSchedulerService)); };
DwStartProcessActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwStartProcessActionService, factory: DwStartProcessActionService.ɵfac });
DwStartProcessActionService.ctorParameters = () => [
    { type: DwSchedulerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwStartProcessActionService, [{
        type: Injectable
    }], function () { return [{ type: DwSchedulerService }]; }, null); })();
DwActionFunc({
    keyName: 'startProcess',
    display: 'Start Process',
    actionType: DwActionType.gridRowAction,
    parentItemName: DevwareMetaDataItemNames.DwProcessSchedule,
    defaultMenuConfig: {
        useParentDisplay: true,
    },
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-bolt dw-green',
        buttonType: DwButtonType.iconOnlyNoText,
        buttonTitle: 'Start Process'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        permissionMeaning: DwSecurityPermissions.AdminSecurityCanAdminAdvanced
    }
}, DwStartProcessActionService);

class DwClearCacheActionService {
    constructor(cacheService, serverCacheService, dwMessageService) {
        this.cacheService = cacheService;
        this.serverCacheService = serverCacheService;
        this.dwMessageService = dwMessageService;
    }
    handleAction(actionState) {
        this.clearAllCaches();
        return of({ success: true });
    }
    clearAllCaches() {
        this.clearServerCache();
        this.clearClientCache();
    }
    clearServerCache() {
        this.serverCacheService.clearAllCaches()
            .subscribe(r => {
            this.dwMessageService.showMessage({ messageHeading: 'Server Cache Clear Complete' });
        });
    }
    clearClientCache() {
        this.cacheService.clearAllClientCaches();
        this.dwMessageService.showMessage({ messageHeading: 'Client Cache Clear Complete', messageBody: 'Please press F5 to refresh your browser!' });
    }
}
DwClearCacheActionService.ɵfac = function DwClearCacheActionService_Factory(t) { return new (t || DwClearCacheActionService)(ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(DwServerCacheService), ɵngcc0.ɵɵinject(DwMessagingService)); };
DwClearCacheActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwClearCacheActionService, factory: DwClearCacheActionService.ɵfac });
DwClearCacheActionService.ctorParameters = () => [
    { type: DwCacheService },
    { type: DwServerCacheService },
    { type: DwMessagingService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwClearCacheActionService, [{
        type: Injectable
    }], function () { return [{ type: DwCacheService }, { type: DwServerCacheService }, { type: DwMessagingService }]; }, null); })();
DwActionFunc({
    keyName: 'clearAllCaches',
    display: 'Clear All Caches',
    actionType: DwActionType.menuAction,
    defaultMenuConfig: {
        useParentDisplay: true,
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        permissionMeaning: DwSecurityPermissions.AdminSecurityCanAdminAdvanced
    }
}, null, forwardRef(() => DwClearCacheActionService));

class DwUserSetPasswordComponent {
    constructor(dwSecurityRepositoryService) {
        this.dwSecurityRepositoryService = dwSecurityRepositoryService;
    }
    ngOnInit() {
        // Set the user that was password in
        this.user = this.modalConfig.data.user;
    }
    buttonClick(buttonConfig) {
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                return this.setUserPassword();
            default:
                const modalResult = new DwModalResult();
                modalResult.cancelled = true;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
                return of(modalResult);
        }
    }
    setUserPassword() {
        const modalResult = new DwModalResult();
        modalResult.cancelled = false;
        modalResult.closeModal = true;
        return this.dwSecurityRepositoryService.setUserPassword(this.user.UserName, this.newPassword)
            .pipe(map(() => {
            return modalResult;
        }, error => {
            var errorDetails = getErrorDetails(error);
            this.message = {
                messageBody: errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.message
            };
            modalResult.closeModal = false;
            return modalResult;
        }));
    }
}
DwUserSetPasswordComponent.ɵfac = function DwUserSetPasswordComponent_Factory(t) { return new (t || DwUserSetPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken)); };
DwUserSetPasswordComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUserSetPasswordComponent, selectors: [["dw-user-set-password"]], decls: 18, vars: 6, consts: [[1, "row"], [1, "col-md-12"], [1, "label"], [1, "form-control"], ["type", "password", 1, "form-control", 3, "ngModel", "ngModelChange"], ["class", "alert alert-danger", 4, "ngIf"], [1, "alert", "alert-danger"]], template: function DwUserSetPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵtext(4, "User");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 0);
        ɵngcc0.ɵɵelementStart(8, "div", 1);
        ɵngcc0.ɵɵelementStart(9, "label", 2);
        ɵngcc0.ɵɵtext(10, "New password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwUserSetPasswordComponent_Template_input_ngModelChange_11_listener($event) { return ctx.newPassword = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 0);
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "label", 2);
        ɵngcc0.ɵɵtext(15, "Retype New password");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwUserSetPasswordComponent_Template_input_ngModelChange_16_listener($event) { return ctx.newPasswordRetype = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(17, DwUserSetPasswordComponent_div_17_Template, 2, 0, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate3("", ctx.user == null ? null : ctx.user.FirstName, " ", ctx.user == null ? null : ctx.user.LastName, " (", ctx.user == null ? null : ctx.user.UserName, ")");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.newPassword);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.newPasswordRetype);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.newPassword && ctx.newPasswordRetype && ctx.newPassword != ctx.newPassword);
    } }, directives: [ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf], encapsulation: 2 });
DwUserSetPasswordComponent.ctorParameters = () => [
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserSetPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'dw-user-set-password',
                template: "<div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label class=\"label\">User</label>\r\n            <div class=\"form-control\">{{user?.FirstName}} {{user?.LastName}}  ({{user?.UserName}})</div>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label class=\"label\">New password</label>\r\n            <input type=\"password\" [(ngModel)]=\"newPassword\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <label class=\"label\">Retype New password</label>\r\n            <input type=\"password\" [(ngModel)]=\"newPasswordRetype\" class=\"form-control\">\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"newPassword && newPasswordRetype && newPassword != newPassword\" class=\"alert alert-danger\">\r\n        Passwords do not match!\r\n    </div>\r\n</div>"
            }]
    }], function () { return [{ type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }]; }, null); })();

class DwUserSetPasswordActionService {
    constructor(dwModalService) {
        this.dwModalService = dwModalService;
    }
    handleAction(actionState) {
        const user = actionState.data;
        if (!user) {
            throw new Error('An user should always be password');
            return;
        }
        return this.showSetUserPopup(user);
    }
    showSetUserPopup(user) {
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.allowFullScreen = false;
        modalConfig.data = {
            user: user
            // No form preferences for now
        };
        modalConfig.component = DwUserSetPasswordComponent;
        modalConfig.title = 'Set User Password';
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {
            const result = new DwGridActionResult();
            if (!modalResult.cancelled) {
                result.success = true;
                result.message = `Password set for ${user.FirstName} ${user.LastName} (${user.UserName})`;
                result.refreshData = true;
            }
            return result;
        }));
    }
}
DwUserSetPasswordActionService.ɵfac = function DwUserSetPasswordActionService_Factory(t) { return new (t || DwUserSetPasswordActionService)(ɵngcc0.ɵɵinject(DwModalService)); };
DwUserSetPasswordActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwUserSetPasswordActionService, factory: DwUserSetPasswordActionService.ɵfac });
DwUserSetPasswordActionService.ctorParameters = () => [
    { type: DwModalService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserSetPasswordActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }]; }, null); })();
DwActionFunc({
    keyName: 'setUserPassword',
    display: 'Set User Password',
    actionType: DwActionType.gridContextMenuAction,
    parentItemName: DevwareMetaDataItemNames.DwUser,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: false,
        permissionMeaning: DwSecurityPermissions.AdminSecurityCanAdminUsers,
        requireCanUpdate: true
    },
    defaultMenuConfig: {
        useParentDisplay: true,
        itemRequirement: DwActionItemRequirement.single
    }
}, DwUserSetPasswordActionService);

/**
 * Determine is event is a Create Event
 * @param event Event
 */
function isMdCreateEvent(event) {
    if (event && event.eventType === DwMdEventType.create) {
        return true;
    }
    return false;
}
/**
 * Determine is event is a Update Event
 * @param event Event
 */
function isMdUpdateEvent(event) {
    if (event && event.eventType === DwMdEventType.update) {
        return true;
    }
    return false;
}
/**
 * Determine is event is a Delete Event
 * @param event Event
 */
function isMdDeleteEvent(event) {
    if (event && event.eventType === DwMdEventType.delete) {
        return true;
    }
    return false;
}
/**
 * Determine is event is a Load Event
 * @param event Event
 */
function isMdLoadEvent(event) {
    if (event && event.eventType === DwMdEventType.load) {
        return true;
    }
    return false;
}
/**
 * Determine is event is a Query Event
 * @param event Event
 */
function isMdQueryEvent(event) {
    if (event && event.eventType === DwMdEventType.query) {
        return true;
    }
    return false;
}

function DwMdEventHandler(eventActionDef) {
    //console.log("DwComponent Decorator evaluated", compDef);
    return function (constructor) {
        DwMdEventHandlerFunc(eventActionDef, constructor);
        // let eventRef : DwMdEventHandlerRegistration = {
        //     display: eventActionDef.name,
        //     keyName : eventActionDef.key,
        //     parentItemName : eventActionDef.parentItemName,
        //     useDI: eventActionDef.useDi,
        //     configComponent: eventActionDef.configComponent,
        //     handlerClass: <Type<any>>constructor
        // };
        // let uiConfigRegistyService = new DwUiConfigRegistryService();
        // uiConfigRegistyService.registerItem(DwMdEventHandlerItemType, eventRef);
    };
}
function DwMdEventHandlerFunc(eventActionDef, component) {
    let eventRef = {
        display: eventActionDef.name,
        keyName: eventActionDef.key,
        parentItemName: eventActionDef.parentItemName,
        useDI: eventActionDef.useDi,
        configComponent: eventActionDef.configComponent,
        handlerClass: component
    };
    let uiConfigRegistyService = new DwUiConfigRegistryService();
    uiConfigRegistyService.registerItem(DwMdEventHandlerItemType, eventRef);
}

class DwUserUpdateEventHandler {
    constructor(dwSecurityOrchestration, dwSecurityStateService, dwSecurityOrchestrationService) {
        this.dwSecurityOrchestration = dwSecurityOrchestration;
        this.dwSecurityStateService = dwSecurityStateService;
        this.dwSecurityOrchestrationService = dwSecurityOrchestrationService;
    }
    /**
     * Handles updating the user's name in the security context if anything is updated
     */
    handleEvent(event, eventData, eventConfig) {
        var _a, _b;
        if (isMdUpdateEvent(eventData)) {
            const userEntity = eventData.newItem;
            const mdService = new DevwareMetaDataService;
            const securityContext = this.dwSecurityStateService.securityState.securityContext;
            if (((_a = securityContext.AuthenticatedUser) === null || _a === void 0 ? void 0 : _a.UserId) == userEntity.UserId || ((_b = securityContext.ApplicationUser) === null || _b === void 0 ? void 0 : _b.UserId) == userEntity.UserId) {
                this.dwSecurityOrchestration.reAuthenticate(securityContext.SecurityToken, DwAuthenticationType.reauthenticate)
                    .subscribe(result => {
                    // Just subscribe so the observable will be executed
                });
                //return;
                // if (eventData.changes["FirstName"] || eventData.changes["LastName"] || eventData.changes["UserPictureMediaId"]) {
                //     securityContext.AuthenticatedUser.FirstName = userEntity.FirstName;
                //     securityContext.AuthenticatedUser.LastName = userEntity.LastName;
                //     securityContext.AuthenticatedUser.FirstNameLastName = `${userEntity.FirstName} ${userEntity.LastName}`
                //     securityContext.AuthenticatedUser.LastNameFirstName = `${userEntity.LastName}, ${userEntity.FirstName}`
                //     securityContext.AuthenticatedUser.UserPictureMediaId = userEntity.UserPictureMediaId;
                //     if (securityContext.ApplicationUser.UserId === securityContext.AuthenticatedUser.UserId) {
                //         securityContext.ApplicationUser = securityContext.AuthenticatedUser;
                //     }
                //     this.dwSecurityStateService.setSecurityContext(securityContext);
                // }
            }
            // if (securityContext.ApplicationUser?.UserId == userEntity.UserId) {
            //     this.dwSecurityOrchestration.reAuthenticate(securityContext.SecurityToken, true);
            //     return;
            // if (eventData.changes["FirstName"] || eventData.changes["LastName"] || eventData.changes["UserPictureMediaId"]) {
            //     securityContext.ApplicationUser.FirstName = userEntity.FirstName;
            //     securityContext.ApplicationUser.LastName = userEntity.LastName;
            //     securityContext.ApplicationUser.FirstNameLastName = `${userEntity.FirstName} ${userEntity.LastName}`
            //     securityContext.ApplicationUser.LastNameFirstName = `${userEntity.LastName}, ${userEntity.FirstName}`
            //     securityContext.ApplicationUser.UserPictureMediaId = userEntity.UserPictureMediaId;
            //     this.dwSecurityStateService.setSecurityContext(securityContext);
            // }
            // }
        }
    }
}
DwUserUpdateEventHandler.ɵfac = function DwUserUpdateEventHandler_Factory(t) { return new (t || DwUserUpdateEventHandler)(ɵngcc0.ɵɵinject(DwSecurityOrchestrationService), ɵngcc0.ɵɵinject(DwSecurityStateService), ɵngcc0.ɵɵinject(DwSecurityOrchestrationService)); };
DwUserUpdateEventHandler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwUserUpdateEventHandler, factory: DwUserUpdateEventHandler.ɵfac });
DwUserUpdateEventHandler.ctorParameters = () => [
    { type: DwSecurityOrchestrationService },
    { type: DwSecurityStateService },
    { type: DwSecurityOrchestrationService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserUpdateEventHandler, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityOrchestrationService }, { type: DwSecurityStateService }, { type: DwSecurityOrchestrationService }]; }, null); })();
DwMdEventHandlerFunc({
    key: 'dwUserUpdateEventHandler',
    name: 'Devware User Update Event Handler',
    useDi: true,
    parentItemName: DevwareMetaDataItemNames.DwUser
}, DwUserUpdateEventHandler);

class DwSecurityGroupRepositoryService {
    constructor(dwDataService) {
        this.dwDataService = dwDataService;
    }
    loadSecurityGroupItems(securityGroupId) {
        const md = new DevwareMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwMetaDataSecurityGroupItem.CreateQuery();
        query.AddFilterAnd(qh.filters.Equal(md.DwMetaDataSecurityGroupItem.MetaDataSecurityGroupId, securityGroupId));
        return this.dwDataService.executeQuery(query);
    }
    createSecurityGroupItems(itemTemplate, itemIds) {
        const items = [];
        for (const itemId of itemIds) {
            const item = Object.assign({}, itemTemplate);
            item.MetaDataItemId = itemId;
            items.push(item);
        }
        return this.saveSecurityGroupItems(items);
    }
    saveSecurityGroupItems(items) {
        return this.dwDataService.saveEntityCollection(items);
    }
}
DwSecurityGroupRepositoryService.ɵfac = function DwSecurityGroupRepositoryService_Factory(t) { return new (t || DwSecurityGroupRepositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken)); };
DwSecurityGroupRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecurityGroupRepositoryService_Factory() { return new DwSecurityGroupRepositoryService(ɵɵinject(DwOrmDataServiceToken)); }, token: DwSecurityGroupRepositoryService, providedIn: "root" });
DwSecurityGroupRepositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityGroupRepositoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }]; }, null); })();

class DwSecurityItemQuickAddComponent {
    constructor(dwSecurityGroupRepositoryService) {
        this.dwSecurityGroupRepositoryService = dwSecurityGroupRepositoryService;
        this.mdItemsLookup = DevwareMetaDataLookups.MetaDataItemAllItems;
        this.defaults = {
            CanCreate: false,
            CanRead: true,
            CanUpdate: false,
            CanDelete: false
        };
    }
    ngOnInit() {
        this.securityGroupId = this.modalConfig.data.MetaDataSecurityGroupId;
        this.dwSecurityGroupRepositoryService.loadSecurityGroupItems(this.securityGroupId)
            .subscribe(items => {
            this.existingItems = items;
        });
    }
    buttonClick(buttonConfig) {
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                return this.saveItems();
            default:
                const modalResult = new DwModalResult();
                modalResult.cancelled = true;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
                return of(modalResult);
        }
    }
    saveItems() {
        const modalResult = new DwModalResult();
        modalResult.closeModal = false;
        this.message = null;
        if (this.itemIds.length == 0) {
            this.message = {
                messageBody: 'Please select at least one item',
                allowClose: true,
                timeToShow: 500,
                severity: DwMessageSeverity.error
            };
            return of(modalResult);
        }
        this.defaults.MetaDataSecurityGroupId = this.securityGroupId;
        this.defaults._itemName = DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem;
        return this.dwSecurityGroupRepositoryService.createSecurityGroupItems(this.defaults, this.itemIds)
            .pipe(map(items => {
            modalResult.cancelled = false;
            modalResult.closeModal = true;
            modalResult.data = items;
            return modalResult;
        }));
    }
}
DwSecurityItemQuickAddComponent.ɵfac = function DwSecurityItemQuickAddComponent_Factory(t) { return new (t || DwSecurityItemQuickAddComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityGroupRepositoryService)); };
DwSecurityItemQuickAddComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwSecurityItemQuickAddComponent, selectors: [["dw-security-item-quick-add"]], decls: 24, vars: 6, consts: [[1, "item-container2"], ["dwRow", "", 2, "max-width", "600px", "min-width", "600px"], ["dwCol", "12"], ["mapToArray", "true", 3, "ngModel", "lookupId", "ngModelChange"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelChange"]], template: function DwSecurityItemQuickAddComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "label");
        ɵngcc0.ɵɵtext(4, "Select Items");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "dw-multi-select-lookup", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityItemQuickAddComponent_Template_dw_multi_select_lookup_ngModelChange_5_listener($event) { return ctx.itemIds = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "label");
        ɵngcc0.ɵɵtext(9, "Can Create");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "dw-yesno", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityItemQuickAddComponent_Template_dw_yesno_ngModelChange_10_listener($event) { return ctx.defaults.CanCreate = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Can Read");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "dw-yesno", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityItemQuickAddComponent_Template_dw_yesno_ngModelChange_14_listener($event) { return ctx.defaults.CanRead = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 4);
        ɵngcc0.ɵɵelementStart(16, "div", 5);
        ɵngcc0.ɵɵelementStart(17, "label");
        ɵngcc0.ɵɵtext(18, "Can Update");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "dw-yesno", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityItemQuickAddComponent_Template_dw_yesno_ngModelChange_19_listener($event) { return ctx.defaults.CanUpdate = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 5);
        ɵngcc0.ɵɵelementStart(21, "label");
        ɵngcc0.ɵɵtext(22, "Can Delete");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "dw-yesno", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwSecurityItemQuickAddComponent_Template_dw_yesno_ngModelChange_23_listener($event) { return ctx.defaults.CanDelete = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.itemIds)("lookupId", ctx.mdItemsLookup);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.defaults.CanCreate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.defaults.CanRead);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.defaults.CanUpdate);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.defaults.CanDelete);
    } }, directives: [DwRowDirective, DwColDirective, DwMultiSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwYesNoComponent], styles: [".item-container[_ngcontent-%COMP%]{width:600px}"] });
DwSecurityItemQuickAddComponent.ctorParameters = () => [
    { type: DwSecurityGroupRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityItemQuickAddComponent, [{
        type: Component,
        args: [{
                selector: 'dw-security-item-quick-add',
                template: "<div class=\"item-container2\">\r\n    <!-- <dw-message [messsage]=\"message\"></dw-message> -->\r\n    <div dwRow style=\"max-width:600px;min-width:600px\">\r\n        <div dwCol=\"12\">\r\n            <label>Select Items</label>\r\n            <dw-multi-select-lookup [(ngModel)]=\"itemIds\" [lookupId]=\"mdItemsLookup\" mapToArray=\"true\">\r\n            </dw-multi-select-lookup>\r\n        </div> \r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <label>Can Create</label>\r\n            <dw-yesno [(ngModel)]=\"defaults.CanCreate\"></dw-yesno>\r\n        </div>\r\n        <div dwCol=\"6\">\r\n            <label>Can Read</label>\r\n            <dw-yesno [(ngModel)]=\"defaults.CanRead\"></dw-yesno>\r\n        </div>\r\n    </div>\r\n    <div dwRow>\r\n        <div dwCol=\"6\">\r\n            <label>Can Update</label>\r\n            <dw-yesno [(ngModel)]=\"defaults.CanUpdate\"></dw-yesno>\r\n        </div>\r\n        <div dwCol=\"6\">\r\n            <label>Can Delete</label>\r\n            <dw-yesno [(ngModel)]=\"defaults.CanDelete\"></dw-yesno>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [".item-container{width:600px}"]
            }]
    }], function () { return [{ type: DwSecurityGroupRepositoryService }]; }, null); })();

class DwSecurityItemQuickAddActionService {
    constructor(dwModalService, dwMetaDataFormStateService, dwFormEventService) {
        this.dwModalService = dwModalService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwFormEventService = dwFormEventService;
    }
    handleAction(actionState) {
        return this.showPopup(actionState);
    }
    showPopup(actionState) {
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.allowFullScreen = false;
        modalConfig.data = actionState.metaDataGridApi.addContext;
        //modalConfig.modalSize = DwModalSize.responsive;
        const securityGroup = this.dwFormEventService.getFormDataValue(DevwareMetaDataItemNames.DwMetaDataSecurityGroup);
        //console.log('Security Group form data', securityGroup);
        modalConfig.component = DwSecurityItemQuickAddComponent;
        modalConfig.title = 'Quick Add Security Items';
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {
            const result = new DwGridActionResult();
            if (!modalResult.cancelled) {
                result.success = true;
                //result.message = `Password set for ${user.FirstName} ${user.LastName} (${user.UserName})`;
                result.refreshData = true;
            }
            return result;
        }));
    }
}
DwSecurityItemQuickAddActionService.ɵfac = function DwSecurityItemQuickAddActionService_Factory(t) { return new (t || DwSecurityItemQuickAddActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwMetaDataFormStateService, 8), ɵngcc0.ɵɵinject(DwFormEventService)); };
DwSecurityItemQuickAddActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSecurityItemQuickAddActionService, factory: DwSecurityItemQuickAddActionService.ɵfac });
DwSecurityItemQuickAddActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwMetaDataFormStateService, decorators: [{ type: Optional }] },
    { type: DwFormEventService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityItemQuickAddActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwMetaDataFormStateService, decorators: [{
                type: Optional
            }] }, { type: DwFormEventService }]; }, null); })();
DwActionFunc({
    keyName: 'dwSecurityItemQuickAdd',
    display: 'Quick Add Security Item',
    actionType: DwActionType.gridAction,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataSecurityGroupItem,
    defaultSecurityConfig: {
        requireAuthentication: true,
        requireCanUpdate: true
    },
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Quick Add',
        iconClass: 'fa fa-layer-plus',
        buttonClass: 'btn btn-primary',
        buttonTitle: 'Add multiple items at the same time',
    },
    defaultMenuConfig: {
        useParentDisplay: true,
        itemRequirement: DwActionItemRequirement.none
    }
}, DwSecurityItemQuickAddActionService);

class DwRouteEditSecurityComponent {
    constructor(dwContextService) {
        this.dwContextService = dwContextService;
    }
    ngOnInit() {
        this.setupForm();
        this.contextNames = this.dwContextService.contextDefinitions.filter(cd => cd.isGlobal).map(cd => cd.contextName);
    }
    setupForm() {
        var _a, _b, _c;
        this.securityExpressionFG = this.routeConfigFG.get('securityExpression');
        if (!this.securityExpressionFG) {
            this.securityExpressionFG = new FormControl(null);
            this.routeConfigFG.addControl('securityExpression', this.securityExpressionFG);
            if ((_a = this.route) === null || _a === void 0 ? void 0 : _a.RouteConfigJSON) {
                const routeConfig = (_b = this.route) === null || _b === void 0 ? void 0 : _b.RouteConfigJSON;
                // routeConfig.securityExpression = routeConfig.securityExpression || new DwExpressionGroup;
                this.routeConfigFG.patchValue((_c = this.route) === null || _c === void 0 ? void 0 : _c.RouteConfigJSON);
            }
        }
    }
    onChange() {
    }
}
DwRouteEditSecurityComponent.ɵfac = function DwRouteEditSecurityComponent_Factory(t) { return new (t || DwRouteEditSecurityComponent)(ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwRouteEditSecurityComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwRouteEditSecurityComponent, selectors: [["dw-route-edit-security"]], inputs: { routeConfigFG: "routeConfigFG", route: "route" }, decls: 5, vars: 2, consts: [["dwRow", "", 3, "formGroup"], ["dwCol", "12"], ["formControlName", "securityExpression", 3, "contextNames", "ngModelChange"]], template: function DwRouteEditSecurityComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label");
        ɵngcc0.ɵɵtext(3, "Visible Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "dw-expression-picker-control", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwRouteEditSecurityComponent_Template_dw_expression_picker_control_ngModelChange_4_listener() { return ctx.onChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.routeConfigFG);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames);
    } }, directives: [DwRowDirective, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwColDirective, DwExpressionPickerControlComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
DwRouteEditSecurityComponent.ctorParameters = () => [
    { type: DwContextService }
];
DwRouteEditSecurityComponent.propDecorators = {
    routeConfigFG: [{ type: Input }],
    route: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwRouteEditSecurityComponent, [{
        type: Component,
        args: [{
                selector: 'dw-route-edit-security',
                template: `
  <div dwRow [formGroup]="routeConfigFG">
    <div dwCol="12">
        <label>Visible Expression</label>
        <dw-expression-picker-control formControlName="securityExpression" (ngModelChange)="onChange()"
                        [contextNames]="contextNames">
        </dw-expression-picker-control>
    </div>
  </div>
  
  `
            }]
    }], function () { return [{ type: DwContextService }]; }, { routeConfigFG: [{
            type: Input
        }], route: [{
            type: Input
        }] }); })();

class CurrentSecurityInfoComponent {
    constructor(dwSecurityUserService, dwMetaDataService, dwOrmDataService, securityRepository) {
        this.dwSecurityUserService = dwSecurityUserService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwOrmDataService = dwOrmDataService;
        this.securityRepository = securityRepository;
        this.subscriptions = [];
        this.permissionFilterText = '';
        this.itemFilterText = '';
        this.includeBuiltIn = false;
    }
    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    ngOnInit() {
        this.subscriptions.push(this.dwSecurityUserService.securityContextChanged()
            .subscribe(() => {
            this.setupData();
        }));
        this.setupData();
        this.securityRepository.getPermissions()
            .subscribe(allPermissions => {
            allPermissions[0].PermissionDisplay;
            this.allPermissions = allPermissions;
            this.setupCurrentPermissions();
        });
    }
    setupData() {
        var _a;
        this.applicationUser = (_a = this.dwSecurityUserService.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
        this.setupCurrentPermissions();
        this.subscriptions.push(this.dwMetaDataService.getUserMetaDataSecurity()
            .subscribe(metaDataSecurity => {
            this.metaDataSecurity = metaDataSecurity;
            metaDataSecurity.Items = sortArrayByField(metaDataSecurity.Items, 'ItemName');
            this.filterItems();
        }));
    }
    setupCurrentPermissions() {
        var _a;
        this.applicationUser = (_a = this.dwSecurityUserService.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
        this.currentPermissions = [];
        if (!this.applicationUser) {
            return;
        }
        if (!this.allPermissions) {
            return;
        }
        for (const permMeaning of this.applicationUser.Permissions) {
            const perm = this.allPermissions.find(p => p.PermissionMeaning == permMeaning);
            if (perm) {
                this.currentPermissions.push(perm);
            }
        }
        // this.currentPermissions = this.allPermissions.filter(ap => 
        //   this.applicationUser.Permissions.find(p => p == ap.PermissionMeaning)
        // );
        this.currentPermissions = sortArrayByField(this.currentPermissions, 'PermissionMeaning');
        this.filterPermissions();
    }
    loadPermissions() {
        const md = new DevwareMetaDataService();
        const permissionQuery = md.DwAppPermission.CreateQuery();
        const permissionRoleQuery = md.DwAppPermissionRole.CreateQuery();
        permissionRoleQuery.AddPrefetchPath(md.DwAppPermissionRole.Relations.DwRole);
        permissionQuery.AddPrefetchPath(md.DwAppPermission.Relations.DwAppPermissionRole, permissionRoleQuery);
        permissionQuery.OrderBy(md.DwAppPermission.PermissionMeaning);
        return this.dwOrmDataService.executeQuery(permissionQuery);
    }
    filterPermissions() {
        const filterText = this.permissionFilterText.toUpperCase();
        this.filteredPermissions = [];
        for (const perm of this.currentPermissions) {
            let add = false;
            if (perm.PermissionMeaning.toUpperCase().indexOf(filterText) >= 0) {
                add = true;
            }
            if (perm.PermissionDisplay.toUpperCase().indexOf(filterText) >= 0) {
                add = true;
            }
            if (perm.IsBuiltIn && !this.includeBuiltIn) {
                add = false;
            }
            if (add) {
                this.filteredPermissions.push(perm);
            }
        }
    }
    filterItems() {
        const filterText = this.itemFilterText.toUpperCase();
        this.filteredItems = [];
        for (const item of this.metaDataSecurity.Items) {
            let add = false;
            if (item.ItemName.toUpperCase().indexOf(filterText) >= 0) {
                add = true;
            }
            if (add) {
                this.filteredItems.push(item);
            }
        }
    }
}
CurrentSecurityInfoComponent.ɵfac = function CurrentSecurityInfoComponent_Factory(t) { return new (t || CurrentSecurityInfoComponent)(ɵngcc0.ɵɵdirectiveInject(DwSecurityUserService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwSecurityRepositoryServiceToken)); };
CurrentSecurityInfoComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CurrentSecurityInfoComponent, selectors: [["dw-current-security-info"]], decls: 10, vars: 3, consts: [["styleClass", "dw-fixed-tabs"], ["header", "Permissions"], [4, "ngTemplateOutlet"], ["header", "Item Security"], ["permissions", ""], ["itemSecurity", ""], [4, "ngIf"], ["dwRow", ""], ["dwCol", "3"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngModel", "ngModelChange"], ["dwCol", "12"], [1, "simple-table"], [1, "width-30"], [1, "width-40"], [1, "scrolling-grid"], [4, "ngFor", "ngForOf"], [1, "width-15"], [1, "center", "width-15"], [1, "fa", "fa-check", "fa-2x", 3, "hidden"], ["formatType", "yesno", 3, "ngModel", "ngModelChange"], ["dwCol", "4"], ["dwCol", "2"], ["dwRow", "", 4, "ngFor", "ngForOf"]], template: function CurrentSecurityInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-tabView", 0);
        ɵngcc0.ɵɵelementStart(1, "p-tabPanel", 1);
        ɵngcc0.ɵɵtemplate(2, CurrentSecurityInfoComponent_ng_container_2_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "p-tabPanel", 3);
        ɵngcc0.ɵɵtemplate(4, CurrentSecurityInfoComponent_ng_container_4_Template, 1, 0, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, CurrentSecurityInfoComponent_ng_template_5_Template, 23, 3, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, CurrentSecurityInfoComponent_ng_template_7_Template, 6, 2, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, CurrentSecurityInfoComponent_ng_container_9_Template, 35, 5, "ng-container", 6);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(6);
        const _r4 = ɵngcc0.ɵɵreference(8);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", false);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc4.NgTemplateOutlet, ɵngcc4.NgIf, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, DwYesNoComponent, ɵngcc4.NgForOf, DwReadOnlyControlComponent], styles: [".simple-table[_ngcontent-%COMP%]{border-collapse:collapse;font-family:Arial,Helvetica,sans-serif;width:100%}.simple-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .simple-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid #ddd;padding:8px}.simple-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:nth-child(2n){background-color:#f2f2f2}.simple-table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:hover{background-color:#ddd}.simple-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background-color:#04aa6d;color:#fff;padding-bottom:12px;padding-top:12px;text-align:left}.center[_ngcontent-%COMP%]{text-align:center}.scrolling-grid[_ngcontent-%COMP%]{max-height:540px;overflow:auto}.width-40[_ngcontent-%COMP%]{width:40%}.width-30[_ngcontent-%COMP%]{width:30%}.width-20[_ngcontent-%COMP%]{width:20%}.width-15[_ngcontent-%COMP%]{width:15%}"] });
CurrentSecurityInfoComponent.ctorParameters = () => [
    { type: DwSecurityUserService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwSecurityRepositoryService, decorators: [{ type: Inject, args: [DwSecurityRepositoryServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CurrentSecurityInfoComponent, [{
        type: Component,
        args: [{
                selector: 'dw-current-security-info',
                template: "<!-- <h1>Current User Security Details</h1>\r\n\r\n<h2>{{applicationUser?.FirstNameLastName}} (User Id: {{applicationUser?.UserId}})</h2> -->\r\n\r\n<p-tabView styleClass=\"dw-fixed-tabs\">\r\n    <p-tabPanel header=\"Permissions\">\r\n\r\n        <ng-container *ngTemplateOutlet=\"permissions\"></ng-container>\r\n\r\n    </p-tabPanel>\r\n    <p-tabPanel header=\"Item Security\">\r\n\r\n        <ng-container *ngTemplateOutlet=\"itemSecurity\"></ng-container>\r\n\r\n    </p-tabPanel>\r\n</p-tabView>\r\n\r\n\r\n\r\n<ng-template #permissions>\r\n    <div dwRow>\r\n        <div dwCol=\"3\">\r\n            <label>Search</label>\r\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"permissionFilterText\" (ngModelChange)=\"filterPermissions()\">\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <label>Include Built In</label>\r\n            <dw-yesno [(ngModel)]=\"includeBuiltIn\" (ngModelChange)=\"filterPermissions()\"></dw-yesno>\r\n        </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <table class=\"simple-table\">\r\n                <thead>\r\n                    <th class=\"width-30\">\r\n                        Permission\r\n                    </th>\r\n                    <th class=\"width-30\">\r\n                        Permission Meaning\r\n                    </th>\r\n                    <th class=\"width-40\">\r\n                        Related Roles\r\n                    </th>\r\n                </thead>\r\n            </table>\r\n            <div class=\"scrolling-grid\">\r\n                <table class=\"simple-table\">\r\n                    <tbody>\r\n                        <tr *ngFor=\"let permission of filteredPermissions\">\r\n                            <td class=\"width-30\">\r\n                                {{permission.PermissionDisplay}}\r\n                            </td>\r\n                            <td class=\"width-30\">\r\n                                {{permission.PermissionMeaning}}\r\n                            </td>\r\n                            <td class=\"width-40\">\r\n                                <ul>\r\n                                    <li *ngFor=\"let role of permission.Roles\">\r\n                                        {{ role?.RoleDisplay }}\r\n                                    </li>\r\n                                </ul>\r\n                            </td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-template #itemSecurity>\r\n    <div dwRow>\r\n        <div dwCol=\"3\">\r\n            <label>Search</label>\r\n            <input type=\"text\" class=\"form-control\" [(ngModel)]=\"itemFilterText\" (ngModelChange)=\"filterItems()\">\r\n        </div>\r\n    </div>\r\n\r\n    <div *ngIf=\"metaDataSecurity\">\r\n        <table class=\"simple-table\">\r\n            <thead>\r\n                <th class=\"width-40\">\r\n                    Item\r\n                </th>\r\n                <th class=\"width-15\">\r\n                    Can Read\r\n                </th>\r\n                <th class=\"width-15\">\r\n                    Can Create\r\n                </th>\r\n                <th class=\"width-15\">\r\n                    Can Update\r\n                </th>\r\n                <th class=\"width-15\">\r\n                    Can Delete\r\n                </th>\r\n            </thead>\r\n        </table>\r\n        <div class=\"scrolling-grid\">\r\n            <table class=\"simple-table\">\r\n                <tbody>\r\n                    <tr>\r\n                        <td class=\"width-40\">\r\n                            Overall\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!metaDataSecurity.CanReadAny\"></i>\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!metaDataSecurity.CanInsertAny\"></i>\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!metaDataSecurity.CanUpdateAny\"></i>\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!metaDataSecurity.CanDeleteAny\"></i>\r\n                        </td>\r\n                    </tr>\r\n                    <tr *ngFor=\"let item of filteredItems\">\r\n                        <td>\r\n                            {{item.ItemName}}\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanRead\"></i>\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanCreate\"></i>\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanUpdate\"></i>\r\n                        </td>\r\n                        <td class=\"center width-15\">\r\n                            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanDelete\"></i>\r\n                        </td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n\r\n<ng-container *ngIf=\"false\">\r\n    Overall\r\n    <div dwRow>\r\n        <div dwCol=\"3\">\r\n            <label>Can Read Any</label>\r\n            <dw-readonly formatType=\"yesno\" [(ngModel)]=\"metaDataSecurity.CanReadAny\"></dw-readonly>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <label>Can Create Any</label>\r\n            <dw-readonly formatType=\"yesno\" [(ngModel)]=\"metaDataSecurity.CanCreateAny\"></dw-readonly>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <label>Can Update Any</label>\r\n            <dw-readonly formatType=\"yesno\" [(ngModel)]=\"metaDataSecurity.CanUpdateAny\"></dw-readonly>\r\n        </div>\r\n        <div dwCol=\"3\">\r\n            <label>Can Delete Any</label>\r\n            <dw-readonly formatType=\"yesno\" [(ngModel)]=\"metaDataSecurity.CanDeleteAny\"></dw-readonly>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"4\">\r\n            Item\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <label>Can Read</label>\r\n\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <label>Can Create</label>\r\n\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <label>Can Update</label>\r\n\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <label>Can Delete</label>\r\n\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngFor=\"let item of metaDataSecurity.Items\">\r\n        <div dwCol=\"4\">\r\n            {{item.ItemName}}\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanRead\"></i>\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanCreate\"></i>\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanUpdate\"></i>\r\n        </div>\r\n        <div dwCol=\"2\">\r\n            <i class=\"fa fa-check fa-2x\" [hidden]=\"!item.CanDelete\"></i>\r\n        </div>\r\n    </div>\r\n</ng-container>",
                styles: [".simple-table{border-collapse:collapse;font-family:Arial,Helvetica,sans-serif;width:100%}.simple-table td,.simple-table th{border:1px solid #ddd;padding:8px}.simple-table tr:nth-child(2n){background-color:#f2f2f2}.simple-table tr:hover{background-color:#ddd}.simple-table th{background-color:#04aa6d;color:#fff;padding-bottom:12px;padding-top:12px;text-align:left}.center{text-align:center}.scrolling-grid{max-height:540px;overflow:auto}.width-40{width:40%}.width-30{width:30%}.width-20{width:20%}.width-15{width:15%}"]
            }]
    }], function () { return [{ type: DwSecurityUserService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwSecurityRepositoryService, decorators: [{
                type: Inject,
                args: [DwSecurityRepositoryServiceToken]
            }] }]; }, null); })();
DwComponentFunc({
    key: 'DwSecurityDetails',
    name: 'User Security Details',
    componentType: DwComponentType.pageComponent,
    isGlobal: false,
    parentItemName: DevwareMetaDataItemNames.DwUser
}, CurrentSecurityInfoComponent);

class DwMetaDataHistoryDetailComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, formStateService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.formStateService = formStateService;
        this.attributeChanges = [];
    }
    setupComponentComplete() {
        this.runAfterFormDataLoaded(() => this.getJsonDetail());
    }
    getJsonDetail() {
        var _a;
        this.metaDataHistory = this.formStateService.state.formApi.getFormData();
        this.attributeChanges = (_a = this.metaDataHistory) === null || _a === void 0 ? void 0 : _a.AttributeChangeJSON;
    }
}
DwMetaDataHistoryDetailComponent.ɵfac = function DwMetaDataHistoryDetailComponent_Factory(t) { return new (t || DwMetaDataHistoryDetailComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwMetaDataHistoryDetailComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistoryDetailComponent, selectors: [["dw-meta-data-history-detail"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "itemId", "keyValue", 4, "ngIf"], [3, "itemId", "keyValue"]], template: function DwMetaDataHistoryDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetaDataHistoryDetailComponent_dw_meta_data_history_list_0_Template, 1, 2, "dw-meta-data-history-list", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.metaDataHistory);
    } }, directives: function () { return [ɵngcc4.NgIf, DwMetaDataHistoryListComponent]; }, styles: [".attribute-table[_ngcontent-%COMP%]{border-collapse:collapse}.new-value[_ngcontent-%COMP%]{background-color:#90ee90}.new-value[_ngcontent-%COMP%], .previous-value[_ngcontent-%COMP%]{float:left;margin:5px;padding:10px}.previous-value[_ngcontent-%COMP%]{background-color:#d3d3d3;text-decoration:line-through}"] });
DwMetaDataHistoryDetailComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryDetailComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-history-detail',
                template: "<!-- <b>Changes</b>\r\n\r\n<table class=\"attribute-table\">\r\n    <tr *ngFor=\"let attrChange of attributeChanges\">\r\n        <td>\r\n            {{attrChange.AttributeDisplay}}\r\n        </td>\r\n        <td>\r\n            <div [hidden]=\"!attrChange.NewValueDisplay\" class=\"new-value\">\r\n                {{attrChange.NewValueDisplay}}\r\n            </div>\r\n\r\n            <div [hidden]=\"!attrChange.PreviousValueDisplay\" class=\"previous-value\">\r\n                {{attrChange.PreviousValueDisplay}}\r\n            </div>\r\n        </td>\r\n    </tr>\r\n</table> -->\r\n\r\n\r\n<dw-meta-data-history-list *ngIf=\"metaDataHistory\" [itemId]=\"metaDataHistory.MetaDataItemId\" [keyValue]=\"metaDataHistory.KeyValue\"></dw-meta-data-history-list>",
                styles: [".attribute-table{border-collapse:collapse}.new-value{background-color:#90ee90}.new-value,.previous-value{float:left;margin:5px;padding:10px}.previous-value{background-color:#d3d3d3;text-decoration:line-through}"]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormStateService }]; }, null); })();
// Calling after 
DwComponentFunc({
    name: 'Meta Data History - Changes',
    parentItemName: DevwareMetaDataItemNames.DwMetaDataHistory,
    componentType: DwComponentType.formSection,
}, DwMetaDataHistoryDetailComponent);

const moment$d = moment_;
class DwMetaDataHistoryRepositotyService {
    constructor(dwOrmDataService, dwMetaDataService, dwCacheService) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwCacheService = dwCacheService;
    }
    loadMetaDataHistory(itemName, keyValue, daysToLoad) {
        return this.dwMetaDataService.getMetaDataItemId(itemName)
            .pipe(mergeMap(itemId => {
            return this.loadMetaDataHistoryById(itemId, keyValue);
        }));
    }
    loadMetaDataHistoryById(itemId, keyValue, daysToLoad) {
        const md = new DevwareMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwMetaDataHistory.CreateQuery();
        query.SetFieldSettings(false, true);
        query.AddFilterAnd(qh.filters.Equal(md.DwMetaDataHistory.MetaDataItemId, itemId));
        query.AddFilterAnd(qh.filters.Equal(md.DwMetaDataHistory.KeyValue, keyValue));
        if (daysToLoad) {
            const loadFromDate = moment$d().add(daysToLoad, "days").format("MM/DD/YYYY");
            query.AddFilterAnd(qh.filters.GreaterThanEqual(md.DwMetaDataHistory.CreatedDateTime, loadFromDate));
        }
        query.AddPrefetchPath(md.DwMetaDataHistory.Relations.DwMetaDataHistoryType);
        query.OrderBy(md.DwMetaDataHistory.CreatedDateTime, false);
        return this.dwOrmDataService.executeQuery(query);
    }
    /** Get Cached related items so its only loaded once */
    getRelatedItems(itemId) {
        var cacheInvalidationTopics = [];
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItem));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataAttribute));
        cacheInvalidationTopics.push(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(DevwareMetaDataItemNames.DwMetaDataItemRelationship));
        return this.dwCacheService.get('RelatedItems', this.loadRelatedItems(itemId), null, cacheInvalidationTopics);
    }
    loadRelatedItems(itemId) {
        const md = new DevwareMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwMetaDataAttribute.CreateQuery();
        query.AddFilterAnd(qh.filters.Equal(md.DwMetaDataAttribute.ReferenceMetaDataItemId, itemId));
        query.AddFilterAnd(qh.filters.IsTrue(md.DwMetaDataAttribute.ReferenceIsParent));
        query.AddPrefetchPath(md.DwMetaDataAttribute.Relations.DwMetaDataItem);
        return this.dwOrmDataService.executeQuery(query);
    }
    loadRelatedHistorySummary(itemId, keyValue, daysToLoad) {
        const md = new DevwareMetaDataService();
        const mdHistory = new DevwareMetaDataService().DwMetaDataHistory;
        const qh = new DwQueryHelper();
        const query = mdHistory.CreateQuery();
        query.AddFilterAnd(qh.filters.Equal(mdHistory.ParentMetaDataItemId, itemId));
        query.AddFilterAnd(qh.filters.Equal(mdHistory.ParentKeyValue, keyValue));
        if (daysToLoad) {
            const loadFromDate = moment$d().add(-daysToLoad, "days").format("MM/DD/YYYY");
            query.AddFilterAnd(qh.filters.GreaterThanEqual(mdHistory.CreatedDateTime, loadFromDate));
        }
        query.SetupAggregateQuery(false);
        query.FieldSettings.IncludeRootItemFields = false;
        // Add Group by fields
        query.AddFields([mdHistory.MetaDataItemId, mdHistory.KeyValue, mdHistory.RecordDescription]);
        // Add aggregate fields
        query.AddField(qh.fields.Aggregate('ChangeCount', DwFieldAggregate.Count));
        query.AddField(qh.fields.Aggregate('LastCreatedDateTime', DwFieldAggregate.Max, mdHistory.CreatedDateTime));
        query.AddField(qh.fields.Aggregate('MetaDataHistoryTypeId', DwFieldAggregate.Max, mdHistory.MetaDataHistoryTypeId));
        query.OrderBy('LastCreatedDateTime', false);
        query.AddPrefetchPath(md.DwMetaDataHistory.Relations.DwMetaDataHistoryType);
        return this.dwOrmDataService.executeQuery(query)
            .pipe(map(results => {
            return this.cleanChangedNames(results);
        }));
    }
    /**
     * Updates the results to combine duplicates rows that differ due to the Record Description.  If we have more than one, it should only display the newest name that isn't deleted
     * @param results
     * @returns
     */
    cleanChangedNames(results) {
        const finalResults = [];
        const groupedResults = groupBy(results, (result) => result.KeyValue.toString());
        for (const propName in groupedResults) {
            if (groupedResults.hasOwnProperty(propName)) {
                const group = groupedResults[propName];
                if (group.length == 1) {
                    finalResults.push(group[0]);
                }
                else {
                    let item = group[0];
                    if (item.HistoryTypeId == MetaDataHistoryTypeAllItems.Delete) {
                        item = group.find(i => i.HistoryTypeId != MetaDataHistoryTypeAllItems.Delete);
                        if (!item) {
                            item = group[0];
                        }
                    }
                    // Pick the newest name from the list
                    finalResults.push(item);
                }
            }
        }
        const sortedResults = sortArrayByField(finalResults, 'LastCreatedDateTime', null, true);
        //console.log('sorted history results', finalResults, sortedResults);
        return sortedResults;
    }
}
DwMetaDataHistoryRepositotyService.ɵfac = function DwMetaDataHistoryRepositotyService_Factory(t) { return new (t || DwMetaDataHistoryRepositotyService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwCacheService)); };
DwMetaDataHistoryRepositotyService.ɵprov = ɵɵdefineInjectable({ factory: function DwMetaDataHistoryRepositotyService_Factory() { return new DwMetaDataHistoryRepositotyService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwCacheService)); }, token: DwMetaDataHistoryRepositotyService, providedIn: "root" });
DwMetaDataHistoryRepositotyService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwCacheService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryRepositotyService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwCacheService }]; }, null); })();

var __decorate$2e = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1J = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const moment$e = moment_;
class DwMetaDataHistoryListComponent {
    constructor(metaDataHistoryRepositotyService) {
        this.metaDataHistoryRepositotyService = metaDataHistoryRepositotyService;
        this.showGroups = false;
        this.loading = true;
        this.historyGroups = {
            allHistory: [],
            today: [],
            lastThirty: [],
            older: []
        };
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.initHistoryData();
        }
    }
    ngOnInit() {
        this.initHistoryData();
    }
    initHistoryData() {
        let ob = this.metaDataHistoryRepositotyService.loadMetaDataHistory(this.itemName, this.keyValue);
        if (this.itemId) {
            ob = this.metaDataHistoryRepositotyService.loadMetaDataHistoryById(this.itemId, this.keyValue);
        }
        this.loading = true;
        ob.subscribe(historyList => {
            this.groupHistoryData(historyList);
            this.loading = false;
        });
    }
    setSelected(historyItem) {
        this.selectedHistory = historyItem;
    }
    groupHistoryData(historyData) {
        if (historyData.length > 0) {
            this.selectedHistory = historyData[0];
        }
        this.historyGroups.allHistory = historyData;
        this.historyGroups.totalRows = historyData.length;
        this.historyGroups.today = historyData.filter(data => this.isToday(data.CreatedDateTime));
        this.historyGroups.lastThirty = historyData.filter(data => !this.isToday(data.CreatedDateTime) && this.lessThan(data.CreatedDateTime, 30));
        this.historyGroups.older = historyData.filter(data => !this.isToday(data.CreatedDateTime) && this.greaterThan(data.CreatedDateTime, 30));
        if (this.historyGroups.today.length > 0) {
            this.historyGroups.highlightToday = true;
            this.selectedHistory = this.historyGroups.today[0];
            return;
        }
        if (this.historyGroups.lastThirty.length > 0) {
            this.historyGroups.highlightLastThirty = true;
            this.selectedHistory = this.historyGroups.highlightLastThirty[0];
            return;
        }
        if (this.historyGroups.older.length > 0) {
            this.historyGroups.highlightOlder = true;
            this.selectedHistory = this.historyGroups.older[0];
            return;
        }
    }
    isToday(date) {
        const dateMoment = getMomentValue(date, true, true);
        if (dateMoment.isSame(moment$e(), "day")) {
            return true;
        }
        return false;
    }
    lessThan(date, days) {
        const dateMoment = getMomentValue(date, true, true);
        const compareMoment = moment$e().add(-30, "day");
        if (dateMoment.isSameOrAfter(compareMoment, "day")) {
            return true;
        }
        return false;
    }
    greaterThan(date, days) {
        const dateMoment = getMomentValue(date, true, true);
        const compareMoment = moment$e().add(-30, "day");
        if (dateMoment.isBefore(compareMoment, "day")) {
            return true;
        }
        return false;
    }
}
DwMetaDataHistoryListComponent.ɵfac = function DwMetaDataHistoryListComponent_Factory(t) { return new (t || DwMetaDataHistoryListComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataHistoryRepositotyService)); };
DwMetaDataHistoryListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistoryListComponent, selectors: [["dw-meta-data-history-list"]], inputs: { showGroups: "showGroups", itemName: "itemName", itemId: "itemId", keyValue: "keyValue" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 3, consts: [["dwRow", "", 1, "history-list"], ["dwCol", "12"], [1, "scrolling-section"], [4, "ngIf"], ["dwCol", "12", 4, "ngIf"], ["multiple", "true", 4, "ngIf"], ["multiple", "true"], ["header", "Today", 3, "selected", 4, "ngIf"], ["header", "Last Thiry Days", 3, "selected", 4, "ngIf"], ["header", "Older", 3, "selected", 4, "ngIf"], ["header", "Today", 3, "selected"], [4, "ngFor", "ngForOf"], ["showTime", "true", 3, "metaDataHistory", "isSelected", "selectCard"], ["header", "Last Thiry Days", 3, "selected"], [3, "metaDataHistory", "isSelected", "selectCard"], ["header", "Older", 3, "selected"], [3, "metaDataHistory"]], template: function DwMetaDataHistoryListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, DwMetaDataHistoryListComponent_div_3_Template, 2, 0, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DwMetaDataHistoryListComponent_ng_container_4_Template, 3, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwMetaDataHistoryListComponent_div_5_Template, 3, 1, "div", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.historyGroups.totalRows == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.historyGroups.totalRows > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedHistory && false);
    } }, directives: function () { return [DwRowDirective, DwColDirective, ɵngcc4.NgIf, ɵngcc11.Accordion, ɵngcc11.AccordionTab, ɵngcc4.NgForOf, DwMetaDataHistoryCardComponent, DwMetaDataHistoryAttrChangesComponent]; }, styles: [".scrolling-section[_ngcontent-%COMP%]{border:1px solid #000;height:480px;overflow:auto;width:100%}"] });
DwMetaDataHistoryListComponent.ctorParameters = () => [
    { type: DwMetaDataHistoryRepositotyService }
];
DwMetaDataHistoryListComponent.propDecorators = {
    itemName: [{ type: Input }],
    itemId: [{ type: Input }],
    keyValue: [{ type: Input }],
    showGroups: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryListComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-history-list',
                template: "<div dwRow class=\"history-list\">\r\n    <div dwCol=\"12\">\r\n        <div class=\"scrolling-section\">\r\n            <div *ngIf=\"historyGroups.totalRows == 0\">\r\n                These are no changes found for the given time period.\r\n            </div>\r\n            <ng-container *ngIf=\"historyGroups.totalRows > 0\">\r\n                <p-accordion multiple=\"true\" *ngIf=\"showGroups\">\r\n                    <p-accordionTab header=\"Today\" [selected]=\"historyGroups.highlightToday\"\r\n                        *ngIf=\"historyGroups.today.length > 0\">\r\n                        <ng-container *ngFor=\"let historyItem of historyGroups.today\">\r\n                            <dw-meta-data-history-card [metaDataHistory]=\"historyItem\"\r\n                                [isSelected]=\"historyItem.MetaDataHistoryId == selectedHistory?.MetaDataHistoryId\"\r\n                                (selectCard)=\"setSelected($event)\" showTime=\"true\"></dw-meta-data-history-card>\r\n                        </ng-container>\r\n                    </p-accordionTab>\r\n                    <p-accordionTab header=\"Last Thiry Days\" [selected]=\"historyGroups.highlightLastThirty\"\r\n                        *ngIf=\"historyGroups.lastThirty.length > 0\">\r\n                        <ng-container *ngFor=\"let historyItem of historyGroups.lastThirty\">\r\n                            <dw-meta-data-history-card [metaDataHistory]=\"historyItem\"\r\n                                [isSelected]=\"historyItem.MetaDataHistoryId == selectedHistory?.MetaDataHistoryId\"\r\n                                (selectCard)=\"setSelected($event)\"></dw-meta-data-history-card>\r\n                        </ng-container>\r\n                    </p-accordionTab>\r\n                    <p-accordionTab header=\"Older\" [selected]=\"historyGroups.highlightOlder\"\r\n                        *ngIf=\"historyGroups.older.length > 0\">\r\n                        <ng-container *ngFor=\"let historyItem of historyGroups.older\">\r\n                            <dw-meta-data-history-card [metaDataHistory]=\"historyItem\"\r\n                                [isSelected]=\"historyItem.MetaDataHistoryId == selectedHistory?.MetaDataHistoryId\"\r\n                                (selectCard)=\"setSelected($event)\"></dw-meta-data-history-card>\r\n                        </ng-container>\r\n                    </p-accordionTab>\r\n                </p-accordion>\r\n\r\n                <ng-container *ngIf=\"!showGroups\">\r\n                    <ng-container *ngFor=\"let historyItem of historyGroups.allHistory\">\r\n                        <dw-meta-data-history-card [metaDataHistory]=\"historyItem\"\r\n                            [isSelected]=\"historyItem.MetaDataHistoryId == selectedHistory?.MetaDataHistoryId\"\r\n                            (selectCard)=\"setSelected($event)\"></dw-meta-data-history-card>\r\n                    </ng-container>\r\n                </ng-container>\r\n            </ng-container>\r\n\r\n        </div>\r\n    </div>\r\n    <div dwCol=\"12\" *ngIf=\"selectedHistory && false\">\r\n        <div class=\"scrolling-section\">\r\n            <dw-meta-data-history-attr-changes [metaDataHistory]=\"selectedHistory\"></dw-meta-data-history-attr-changes>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [".scrolling-section{border:1px solid #000;height:480px;overflow:auto;width:100%}"]
            }]
    }], function () { return [{ type: DwMetaDataHistoryRepositotyService }]; }, { showGroups: [{
            type: Input
        }], itemName: [{
            type: Input
        }], itemId: [{
            type: Input
        }], keyValue: [{
            type: Input
        }] }); })();
__decorate$2e([
    DwInputConverter(booleanConverter),
    __metadata$1J("design:type", Boolean)
], DwMetaDataHistoryListComponent.prototype, "showGroups", void 0);

class DwMetaDataHistoryAttrChangesComponent {
    constructor(dwMetaDataService) {
        this.dwMetaDataService = dwMetaDataService;
        this.attributeChanges = [];
        this.showChanges = true;
    }
    ngOnInit() {
        var _a;
        this.attributeChanges = (_a = this.metaDataHistory) === null || _a === void 0 ? void 0 : _a.AttributeChangeJSON;
        this.loadMetaData();
    }
    ngOnChanges(changes) {
        var _a;
        if (!isFirstChange(changes)) {
            this.attributeChanges = (_a = this.metaDataHistory) === null || _a === void 0 ? void 0 : _a.AttributeChangeJSON;
            this.loadMetaData();
        }
        //this.metaDataHistory.DwMetaDataHistoryType = 
    }
    loadMetaData() {
        var _a, _b, _c, _d;
        this.showChanges = true;
        // If an insert or delete, hide the change list
        // if (this.metaDataHistory?.MetaDataHistoryTypeId == MetaDataHistoryTypeAllItems.Insert || this.metaDataHistory?.MetaDataHistoryTypeId == MetaDataHistoryTypeAllItems.Delete) {
        //   this.showChanges = false;
        // }
        if (((_a = this.metaDataHistory) === null || _a === void 0 ? void 0 : _a.MetaDataItemId) && ((_b = this.metaDataHistory) === null || _b === void 0 ? void 0 : _b.MetaDataItemId) != ((_c = this.itemMetaData) === null || _c === void 0 ? void 0 : _c.MetaDataItemId)) {
            this.dwMetaDataService.getMetaDataByItemId((_d = this.metaDataHistory) === null || _d === void 0 ? void 0 : _d.MetaDataItemId)
                .subscribe(itemMetaData => {
                this.itemMetaData = itemMetaData;
                this.addAttributeChangeDisplay();
            });
        }
        this.addAttributeChangeDisplay();
    }
    addAttributeChangeDisplay() {
        if (!this.itemMetaData) {
            return;
        }
        for (var attrChange of this.attributeChanges || []) {
            var attr = this.itemMetaData.Attributes.find(a => a.AttributeName == attrChange.AttributeName);
            if (attr) {
                attrChange.AttributeDisplay = attr.Display;
                attrChange.AttributeType = attr.AttributeType;
                attrChange.IsJSON = (attr.AttributeType == DwAttributeType.JSON);
                if (attrChange.IsJSON) {
                    try {
                        attrChange.NewValueDisplayJSON = JSON.stringify(JSON.parse(attrChange.NewValue), undefined, 2);
                        attrChange.PreviousValueDisplayJSON = JSON.stringify(JSON.parse(attrChange.PreviousValue), undefined, 2);
                    }
                    catch (e) {
                    }
                }
            }
            else {
                attrChange.AttributeDisplay = `${attrChange.AttributeName}  (Not Found)`;
            }
        }
    }
}
DwMetaDataHistoryAttrChangesComponent.ɵfac = function DwMetaDataHistoryAttrChangesComponent_Factory(t) { return new (t || DwMetaDataHistoryAttrChangesComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwMetaDataHistoryAttrChangesComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistoryAttrChangesComponent, selectors: [["dw-meta-data-history-attr-changes"]], inputs: { metaDataHistory: "metaDataHistory" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "hidden"], [1, "attribute-table"], [4, "ngFor", "ngForOf"], ["title", "New Value", 1, "new-value", 3, "hidden"], ["title", "Previous Value", 1, "previous-value", 3, "hidden"]], template: function DwMetaDataHistoryAttrChangesComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMetaDataHistoryAttrChangesComponent_ng_container_0_Template, 3, 1, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, DwMetaDataHistoryAttrChangesComponent_ng_container_1_Template, 3, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showChanges);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showChanges);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgForOf], styles: [".attribute-table[_ngcontent-%COMP%]{border-collapse:collapse;width:100%}.new-value[_ngcontent-%COMP%]{background-color:#90ee90}.new-value[_ngcontent-%COMP%], .previous-value[_ngcontent-%COMP%]{float:left;margin:5px;max-height:200px;overflow:auto;padding:10px}.previous-value[_ngcontent-%COMP%]{background-color:#d3d3d3;text-decoration:line-through}"] });
DwMetaDataHistoryAttrChangesComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwMetaDataHistoryAttrChangesComponent.propDecorators = {
    metaDataHistory: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryAttrChangesComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-history-attr-changes',
                template: "\r\n<ng-container *ngIf=\"!showChanges\">\r\n    <span [hidden]=\"isInsert\">\r\n        Create \r\n    </span>\r\n</ng-container>\r\n<ng-container *ngIf=\"showChanges\">\r\n\r\n    <table class=\"attribute-table\">\r\n        <tr *ngFor=\"let attrChange of attributeChanges\">\r\n            <td>\r\n                {{attrChange.AttributeDisplay}}\r\n            </td>\r\n            <td>\r\n                <ng-container *ngIf=\"!attrChange.IsJSON\">\r\n                    <div [hidden]=\"!attrChange.NewValueDisplay\" class=\"new-value\" title=\"New Value\">\r\n                        {{attrChange.NewValueDisplay}}\r\n                    </div>\r\n\r\n                    <div [hidden]=\"!attrChange.PreviousValueDisplay\" class=\"previous-value\" title=\"Previous Value\">\r\n                        {{attrChange.PreviousValueDisplay}}\r\n                    </div>\r\n                </ng-container>\r\n                <ng-container *ngIf=\"attrChange.IsJSON\">\r\n                    <div [hidden]=\"!attrChange.NewValueDisplay\" class=\"new-value\" title=\"New Value\">\r\n                        <pre>{{attrChange.NewValueDisplayJSON}}</pre>\r\n                    </div>\r\n\r\n                    <div [hidden]=\"!attrChange.PreviousValueDisplay\" class=\"previous-value\" title=\"Previous Value\">\r\n                        <pre>{{attrChange.PreviousValueDisplayJSON}}</pre>\r\n                    </div>\r\n                </ng-container>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</ng-container>",
                styles: [".attribute-table{border-collapse:collapse;width:100%}.new-value{background-color:#90ee90}.new-value,.previous-value{float:left;margin:5px;max-height:200px;overflow:auto;padding:10px}.previous-value{background-color:#d3d3d3;text-decoration:line-through}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { metaDataHistory: [{
            type: Input
        }] }); })();

class DwMetaDataHistoryCardComponent {
    constructor() {
        this.showTime = false;
        this.isSelected = false;
        this.selectCard = new EventEmitter();
        this.expanded = false;
        this.everExpanded = false;
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        // if (this.showTime) {
        //   this.dateDisplay = formatTime(this.metaDataHistory.CreatedDateTime, true);
        // } else {
        // }
        this.dateDisplay = formatDateTimeToLocal(this.metaDataHistory.CreatedDateTime, true, true);
    }
    onClick() {
        this.selectCard.emit(this.metaDataHistory);
        this.everExpanded = true;
        this.expanded = !this.expanded;
    }
}
DwMetaDataHistoryCardComponent.ɵfac = function DwMetaDataHistoryCardComponent_Factory(t) { return new (t || DwMetaDataHistoryCardComponent)(); };
DwMetaDataHistoryCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistoryCardComponent, selectors: [["dw-meta-data-history-card"]], inputs: { showTime: "showTime", isSelected: "isSelected", metaDataHistory: "metaDataHistory" }, outputs: { selectCard: "selectCard" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 15, vars: 12, consts: [[1, "history-card", 3, "click"], [1, "user-info"], [3, "ngClass", "title"], ["title", "Part of a Meta Data Import", 1, "fa", "fa-upload", "ml-2", "dw-orange", 3, "hidden"], [1, "date-info"], ["title", "Expand to show details", 1, "fa", "fa-angle-down", 3, "hidden"], ["title", "Hide Details", 1, "fa", "fa-angle-up", 3, "hidden"], [1, "description", 3, "title"], [1, "scrolling-section2", 3, "dwExpandable", "collapsed"], [3, "metaDataHistory"]], template: function DwMetaDataHistoryCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataHistoryCardComponent_Template_div_click_0_listener() { return ctx.onClick(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelement(7, "i", 5);
        ɵngcc0.ɵɵelement(8, "i", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 7);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "b");
        ɵngcc0.ɵɵtext(13, "Change Details");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "dw-meta-data-history-attr-changes", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.metaDataHistory.DwMetaDataHistoryType == null ? null : ctx.metaDataHistory.DwMetaDataHistoryType.IconCss)("title", ctx.metaDataHistory.MetaDataHistoryTypeIdDisplay);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.metaDataHistory.MetaDataImportId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.metaDataHistory.ChangedByAuthenticatedUserIdDisplay, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.dateDisplay, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.expanded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.expanded);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ctx.metaDataHistory.ChangeSummary);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.metaDataHistory.ChangeSummary, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("dwExpandable", true)("collapsed", !ctx.expanded);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("metaDataHistory", ctx.metaDataHistory);
    } }, directives: [ɵngcc4.NgClass, DwExpandableDirective, DwMetaDataHistoryAttrChangesComponent], styles: [".history-card[_ngcontent-%COMP%]{border-bottom:1px solid #000;cursor:pointer;overflow:hidden;padding:7px;transition:height .25s;width:100%}.history-card-expanded[_ngcontent-%COMP%]{cursor:pointer;transition:height .4s}.user-info[_ngcontent-%COMP%]{float:left}.description[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.date-info[_ngcontent-%COMP%]{float:right}.history-card-selected[_ngcontent-%COMP%]{background-color:#d3d3d3;border:2px solid #00f}.scrolling-section[_ngcontent-%COMP%]{height:240px;overflow:auto;padding:5px;width:100%}"] });
DwMetaDataHistoryCardComponent.ctorParameters = () => [];
DwMetaDataHistoryCardComponent.propDecorators = {
    metaDataHistory: [{ type: Input }],
    showTime: [{ type: Input }],
    isSelected: [{ type: Input }],
    selectCard: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryCardComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-history-card',
                template: "<!-- <div class=\"history-card\" [ngClass]=\"{ 'history-card-expanded': expanded }\" (click)=\"onClick()\"> -->\r\n\r\n<div class=\"history-card\"  (click)=\"onClick()\">\r\n    <div class=\"user-info\">\r\n        <i [ngClass]=\"metaDataHistory.DwMetaDataHistoryType?.IconCss\" [title]=\"metaDataHistory.MetaDataHistoryTypeIdDisplay\"></i>\r\n        <i class=\"fa fa-upload ml-2 dw-orange\" [hidden]=\"!metaDataHistory.MetaDataImportId\" title=\"Part of a Meta Data Import\"></i>\r\n        \r\n        {{ metaDataHistory.ChangedByAuthenticatedUserIdDisplay }}\r\n    </div>\r\n    <div class=\"date-info\" >\r\n        {{ dateDisplay }}\r\n\r\n        <i class=\"fa fa-angle-down\" [hidden]=\"!expanded\" title=\"Expand to show details\"></i>\r\n        <i class=\"fa fa-angle-up\" [hidden]=\"expanded\" title=\"Hide Details\"></i>\r\n    </div>\r\n    <div class=\"description\" [title]=\"metaDataHistory.ChangeSummary\">\r\n        {{ metaDataHistory.ChangeSummary }}\r\n    </div>\r\n    <!-- <div [ngClass]=\"{ 'scrolling-section' : expanded, 'contracted-section' : !expanded}\" class2=\"scrolling-section\">\r\n        <dw-meta-data-history-attr-changes [metaDataHistory]=\"metaDataHistory\" *ngIf=\"everExpanded\"></dw-meta-data-history-attr-changes>\r\n    </div> -->\r\n    <div class=\"scrolling-section2\" [dwExpandable]=\"true\" [collapsed]=\"!expanded\">\r\n        <b>Change Details</b>\r\n        <dw-meta-data-history-attr-changes [metaDataHistory]=\"metaDataHistory\"></dw-meta-data-history-attr-changes>\r\n    </div>\r\n</div>\r\n ",
                styles: [".history-card{border-bottom:1px solid #000;cursor:pointer;overflow:hidden;padding:7px;transition:height .25s;width:100%}.history-card-expanded{cursor:pointer;transition:height .4s}.user-info{float:left}.description{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.date-info{float:right}.history-card-selected{background-color:#d3d3d3;border:2px solid #00f}.scrolling-section{height:240px;overflow:auto;padding:5px;width:100%}"]
            }]
    }], function () { return []; }, { showTime: [{
            type: Input
        }], isSelected: [{
            type: Input
        }], selectCard: [{
            type: Output
        }], metaDataHistory: [{
            type: Input
        }] }); })();

class DwMetaDataHistoryModalComponent {
    constructor() {
        this.running = false;
    }
    ngOnInit() {
    }
    buttonClick(buttonConfig) {
        switch (buttonConfig.command) {
            default:
                const modalResult = new DwModalResult();
                modalResult.cancelled = true;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
                return of(modalResult);
        }
    }
}
DwMetaDataHistoryModalComponent.ɵfac = function DwMetaDataHistoryModalComponent_Factory(t) { return new (t || DwMetaDataHistoryModalComponent)(); };
DwMetaDataHistoryModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistoryModalComponent, selectors: [["dw-dw-meta-data-history-modal"]], decls: 2, vars: 2, consts: [[1, "modal-container"], [3, "itemName", "keyValue"]], template: function DwMetaDataHistoryModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "dw-meta-data-history-main", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("itemName", ctx.modalConfig == null ? null : ctx.modalConfig.data == null ? null : ctx.modalConfig.data.itemName)("keyValue", ctx.modalConfig == null ? null : ctx.modalConfig.data == null ? null : ctx.modalConfig.data.keyValue);
    } }, directives: function () { return [DwMetaDataHistoryMainComponent]; }, styles: [".modal-container[_ngcontent-%COMP%]{min-height:600px;width:1200px}"] });
DwMetaDataHistoryModalComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-meta-data-history-modal',
                template: "\r\n\r\n<div class=\"modal-container\">\r\n    <dw-meta-data-history-main [itemName]=\"modalConfig?.data?.itemName\" [keyValue]=\"modalConfig?.data?.keyValue\"></dw-meta-data-history-main>\r\n</div>",
                styles: [".modal-container{min-height:600px;width:1200px}"]
            }]
    }], function () { return []; }, null); })();

class DwViewHistoryActionService {
    constructor(route, metaDataRoutingService, dwModalService) {
        this.route = route;
        this.metaDataRoutingService = metaDataRoutingService;
        this.dwModalService = dwModalService;
    }
    handleAction(gridActionState) {
        return this.viewItem(gridActionState);
    }
    viewItem(gridActionState) {
        if (!gridActionState.data) {
            throw new Error('Can not execute view Item event because no event data was passed');
        }
        const item = gridActionState.data;
        if (!item._itemName || !item._keyName) {
            throw new Error('Item must have a name and a key');
        }
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];
        modalConfig.allowFullScreen = false;
        modalConfig.data = {
            itemName: item._itemName,
            keyValue: item[item._keyName]
        };
        modalConfig.component = DwMetaDataHistoryModalComponent;
        modalConfig.title = 'View History';
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(metaDataResult => {
            const result = new DwGridActionResult();
            result.success = true;
            result.refreshData = false;
            return result;
        }));
    }
}
DwViewHistoryActionService.ɵfac = function DwViewHistoryActionService_Factory(t) { return new (t || DwViewHistoryActionService)(ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(DwMetaDataRoutingService), ɵngcc0.ɵɵinject(DwModalService)); };
DwViewHistoryActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwViewHistoryActionService, factory: DwViewHistoryActionService.ɵfac });
DwViewHistoryActionService.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: DwMetaDataRoutingService },
    { type: DwModalService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwViewHistoryActionService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: DwMetaDataRoutingService }, { type: DwModalService }]; }, null); })();
function getViewHistoryValidItems(itemName) {
    if (itemName.startsWith("dw_")) {
        return true;
    }
}
DwActionFunc({
    keyName: 'dwViewHistory',
    display: 'View History',
    actionType: DwActionType.gridRowAction,
    parentItemName: getViewHistoryValidItems,
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-book dw-icon-grid dw-blue',
        buttonType: DwButtonType.iconOnlyNoText,
        buttonTitle: 'View History'
    },
    defaultMenuConfig: {
        menuDisplay: 'View History',
    }
}, DwViewHistoryActionService);

class DwMetaDataHistoryMainComponent {
    constructor(metaDataHistoryRepositotyService, dwMetaDataService) {
        this.metaDataHistoryRepositotyService = metaDataHistoryRepositotyService;
        this.dwMetaDataService = dwMetaDataService;
        this.relatedAttributes = [];
        this.daysToLoad = 60;
        this.showRelated = false;
        this.relatedHistory = [];
    }
    ngOnInit() {
        this.loadInitialData();
    }
    changeLoadRelatedItems(value) {
        if (this.relatedHistorySummary == null) {
            this.loadRelatedHistory();
        }
    }
    loadInitialData() {
        this.getItemId()
            .subscribe(() => {
            this.metaDataHistoryRepositotyService.getRelatedItems(this.itemId)
                .subscribe(relatedItems => {
                this.relatedAttributes = relatedItems;
            });
        });
    }
    loadRelatedHistory() {
        if (this.relatedAttributes.length == 0 || this.relatedHistory.length > 0) {
            return;
        }
        this.metaDataHistoryRepositotyService.loadRelatedHistorySummary(this.itemId, this.keyValue, this.daysToLoad)
            .subscribe(relatedHistorySummary => {
            this.buildRelatedHistory(relatedHistorySummary);
        });
    }
    setSelected(relatedHistory, relatedSummary) {
        relatedHistory.selectedHistorySummary = relatedSummary;
    }
    buildRelatedHistory(relatedHistorySummary) {
        for (const relatedAttr of this.relatedAttributes) {
            let itemHistorySummary = relatedHistorySummary.filter(hs => hs.MetaDataItemId == relatedAttr.MetaDataItemId);
            if (itemHistorySummary.length > 0) {
                //itemHistorySummary = sortArray(itemHistorySummary, (i) => i.LastCreatedDateTime);
                const relatedHistoryByItem = {
                    item: relatedAttr.DwMetaDataItem,
                    relatedAttribute: relatedAttr,
                    relatedHistorySummary: itemHistorySummary,
                    selectedHistorySummary: itemHistorySummary[0]
                };
                this.relatedHistory.push(relatedHistoryByItem);
            }
        }
    }
    getItemId() {
        if (this.itemId) {
            return of(this.itemId);
        }
        return this.dwMetaDataService.getMetaDataItemId(this.itemName)
            .pipe(map(itemId => {
            this.itemId = itemId;
            return this.itemId;
        }));
    }
}
DwMetaDataHistoryMainComponent.ɵfac = function DwMetaDataHistoryMainComponent_Factory(t) { return new (t || DwMetaDataHistoryMainComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataHistoryRepositotyService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwMetaDataHistoryMainComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistoryMainComponent, selectors: [["dw-meta-data-history-main"]], inputs: { itemId: "itemId", itemName: "itemName", keyValue: "keyValue" }, decls: 10, vars: 9, consts: [[1, "top-nav"], [1, "nav", "nav-pills"], [1, "nav-item"], [1, "nav-link", "active", 3, "ngClass", "click"], [1, "nav-item", 3, "hidden", "click"], [1, "nav-link", 3, "ngClass", "click"], [3, "hidden", 4, "ngIf"], [4, "ngIf"], [3, "hidden"], [3, "itemId", "keyValue"], [3, "header", 4, "ngFor", "ngForOf"], [3, "header"], ["dwRow", ""], ["dwCol", "4"], [1, "scrolling-section"], [4, "ngFor", "ngForOf"], ["dwCol", "8", 4, "ngIf"], [3, "summary", "isSelected", "selectCard"], ["dwCol", "8"], ["showGroups", "false", 3, "itemId", "keyValue"]], template: function DwMetaDataHistoryMainComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵelementStart(2, "li", 2);
        ɵngcc0.ɵɵelementStart(3, "a", 3);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataHistoryMainComponent_Template_a_click_3_listener() { return ctx.showRelated = false; });
        ɵngcc0.ɵɵtext(4, "Main Changes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "li", 4);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataHistoryMainComponent_Template_li_click_5_listener() { return ctx.loadRelatedHistory(); });
        ɵngcc0.ɵɵelementStart(6, "a", 5);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataHistoryMainComponent_Template_a_click_6_listener() { return ctx.showRelated = true; });
        ɵngcc0.ɵɵtext(7, "Related Changes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwMetaDataHistoryMainComponent_div_8_Template, 2, 3, "div", 6);
        ɵngcc0.ɵɵtemplate(9, DwMetaDataHistoryMainComponent_div_9_Template, 3, 2, "div", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c28, ctx.showRelated == false));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", (ctx.relatedAttributes == null ? null : ctx.relatedAttributes.length) == 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c28, ctx.showRelated == true));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.itemId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showRelated);
    } }, directives: function () { return [ɵngcc4.NgClass, ɵngcc4.NgIf, DwMetaDataHistoryListComponent, ɵngcc9.TabView, ɵngcc4.NgForOf, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwMetaDataHistorySummaryCardComponent]; }, styles: [".top-nav[_ngcontent-%COMP%]{margin-bottom:5px}.scrolling-section[_ngcontent-%COMP%]{border:1px solid #000;height:480px;overflow:auto;width:100%}"] });
DwMetaDataHistoryMainComponent.ctorParameters = () => [
    { type: DwMetaDataHistoryRepositotyService },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwMetaDataHistoryMainComponent.propDecorators = {
    itemName: [{ type: Input }],
    itemId: [{ type: Input }],
    keyValue: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistoryMainComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-history-main',
                template: "<div class=\"top-nav\">\r\n    <ul class=\"nav nav-pills\">\r\n        <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" [ngClass]=\"{ 'active': showRelated == false }\" (click)=\"showRelated = false\">Main\r\n                Changes</a>\r\n        </li>\r\n        <li class=\"nav-item\" [hidden]=\"relatedAttributes?.length == 0\" (click)=\"loadRelatedHistory()\">\r\n            <a class=\"nav-link\" [ngClass]=\"{ 'active': showRelated == true }\" (click)=\"showRelated = true\">Related\r\n                Changes</a>\r\n        </li>\r\n    </ul>\r\n</div>\r\n\r\n<div [hidden]=\"showRelated\" *ngIf=\"itemId\">\r\n    <dw-meta-data-history-list [itemId]=\"itemId\" [keyValue]=\"keyValue\"></dw-meta-data-history-list>\r\n</div>\r\n\r\n<div *ngIf=\"showRelated\">\r\n    <div *ngIf=\"relatedHistory.length == 0\">\r\n        No Related Changes found\r\n    </div>\r\n\r\n    <p-tabView *ngIf=\"relatedHistory.length > 0\">\r\n        <p-tabPanel *ngFor=\"let relatedHistory of relatedHistory\"\r\n            header=\"{{relatedHistory.item?.Display}}\"> \r\n            <div dwRow> \r\n                <div dwCol=\"4\">\r\n                    <div class=\"scrolling-section\">\r\n                        <ng-container *ngFor=\"let relatedSummary of relatedHistory.relatedHistorySummary\">\r\n                            <dw-meta-data-history-summary-card [summary]=\"relatedSummary\"\r\n                                [isSelected]=\"relatedSummary.KeyValue == relatedHistory?.selectedHistorySummary?.KeyValue\"\r\n                                (selectCard)=\"setSelected(relatedHistory, relatedSummary)\">\r\n                            </dw-meta-data-history-summary-card>\r\n                        </ng-container>\r\n                    </div>\r\n                </div>\r\n                <div dwCol=\"8\" *ngIf=\"relatedHistory.selectedHistorySummary\">\r\n                    <dw-meta-data-history-list [itemId]=\"relatedHistory.item.MetaDataItemId\"\r\n                        [keyValue]=\"relatedHistory.selectedHistorySummary.KeyValue\" showGroups=\"false\"></dw-meta-data-history-list>\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [".top-nav{margin-bottom:5px}.scrolling-section{border:1px solid #000;height:480px;overflow:auto;width:100%}"]
            }]
    }], function () { return [{ type: DwMetaDataHistoryRepositotyService }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { itemId: [{
            type: Input
        }], itemName: [{
            type: Input
        }], keyValue: [{
            type: Input
        }] }); })();

class DwMetaDataHistorySummaryCardComponent {
    constructor() {
        this.isSelected = false;
        this.selectCard = new EventEmitter();
    }
    ngOnInit() {
        this.setupDisplay();
    }
    ngOnChanges(changes) {
        this.setupDisplay();
    }
    setupDisplay() {
        this.dateDisplay = formatDateTimeToLocal(this.summary.LastCreatedDateTime, true, true);
    }
    onClick() {
        this.selectCard.emit(this.summary);
    }
}
DwMetaDataHistorySummaryCardComponent.ɵfac = function DwMetaDataHistorySummaryCardComponent_Factory(t) { return new (t || DwMetaDataHistorySummaryCardComponent)(); };
DwMetaDataHistorySummaryCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataHistorySummaryCardComponent, selectors: [["dw-meta-data-history-summary-card"]], inputs: { isSelected: "isSelected", summary: "summary" }, outputs: { selectCard: "selectCard" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 8, consts: [[1, "history-card", 3, "ngClass", "click"], [1, "description", 3, "title"], [3, "ngClass", "title"], [1, "description"]], template: function DwMetaDataHistorySummaryCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwMetaDataHistorySummaryCardComponent_Template_div_click_0_listener() { return ctx.onClick(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c94, ctx.isSelected));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", ctx.summary == null ? null : ctx.summary.RecordDescription);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.summary.DwMetaDataHistoryType == null ? null : ctx.summary.DwMetaDataHistoryType.IconCss)("title", ctx.summary.DwMetaDataHistoryType == null ? null : ctx.summary.DwMetaDataHistoryType.MetaDataHistoryType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.summary == null ? null : ctx.summary.RecordDescription, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" Last Change: ", ctx.dateDisplay, " ");
    } }, directives: [ɵngcc4.NgClass], styles: [".history-card[_ngcontent-%COMP%]{border-bottom:1px solid #000;cursor:pointer;height:60px;padding:7px;width:100%}.user-info[_ngcontent-%COMP%]{float:left}.description[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.date-info[_ngcontent-%COMP%]{float:right}.history-card-selected[_ngcontent-%COMP%]{background-color:#d3d3d3;border:2px solid #00f}"] });
DwMetaDataHistorySummaryCardComponent.ctorParameters = () => [];
DwMetaDataHistorySummaryCardComponent.propDecorators = {
    summary: [{ type: Input }],
    isSelected: [{ type: Input }],
    selectCard: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataHistorySummaryCardComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-history-summary-card',
                template: "<div class=\"history-card\" [ngClass]=\"{ 'history-card-selected': isSelected }\" (click)=\"onClick()\">\r\n   \r\n    <div class=\"description\" [title]=\"summary?.RecordDescription\">\r\n        <i [ngClass]=\"summary.DwMetaDataHistoryType?.IconCss\" [title]=\"summary.DwMetaDataHistoryType?.MetaDataHistoryType\"></i>\r\n        {{ summary?.RecordDescription }}\r\n    </div>\r\n    <div class=\"description\">\r\n        Last Change: {{ dateDisplay }}\r\n    </div>\r\n    \r\n</div>\r\n ",
                styles: [".history-card{border-bottom:1px solid #000;cursor:pointer;height:60px;padding:7px;width:100%}.user-info{float:left}.description{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.date-info{float:right}.history-card-selected{background-color:#d3d3d3;border:2px solid #00f}"]
            }]
    }], function () { return []; }, { isSelected: [{
            type: Input
        }], selectCard: [{
            type: Output
        }], summary: [{
            type: Input
        }] }); })();

class DwFeatureAreaStateService extends DwStateBaseService {
    getInitialState() {
        return {};
    }
    setState(state) {
        super.setState(state);
    }
}
DwFeatureAreaStateService.ɵfac = function DwFeatureAreaStateService_Factory(t) { return ɵDwFeatureAreaStateService_BaseFactory(t || DwFeatureAreaStateService); };
DwFeatureAreaStateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFeatureAreaStateService, factory: DwFeatureAreaStateService.ɵfac });
const ɵDwFeatureAreaStateService_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwFeatureAreaStateService);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFeatureAreaStateService, [{
        type: Injectable
    }], null, null); })();

class DwFeatureAreaDetailsComponent extends DwSectionBaseComponent {
    constructor(uiMetaDataConfig, dwMetaDataService, dwExpressionService, dwUiConfigRegistryService, dwFeatureAreaRepositoryService, dwFeatureAreaState) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.dwFeatureAreaRepositoryService = dwFeatureAreaRepositoryService;
        this.dwFeatureAreaState = dwFeatureAreaState;
    }
    setupComponentComplete() {
        this.subscriptions.push(this.dwFeatureAreaRepositoryService.getFeatureAreaGroups()
            .subscribe(groups => {
            this.groups = groups;
            this.setupItemAddEvents();
        }));
        this.runAfterFormDataLoaded(() => {
            const data = this.formGroup.getRawValue();
            this.featureAreaId = data.FeatureAreaId;
            this.subscriptions.push(this.dwFeatureAreaRepositoryService.loadFeatureAreaDetails(this.featureAreaId)
                .subscribe(details => {
                // Should get set with the state change
                //this.featureAreaDetails = details;
                this.dwFeatureAreaState.setState({ inUse: true, featureArea: data, featureAreaDetails: details });
            }));
        });
        this.subscriptions.push(this.dwFeatureAreaState.stateChanged
            .subscribe(state => {
            // state has been updated
            this.featureAreaDetails = state.featureAreaDetails;
        }));
    }
    setupItemAddEvents() {
        if (!this.groups) {
            return;
        }
        this.subscriptions.push(this.dwFeatureAreaRepositoryService.getFeatureAreaItemAddEvents(this.groups)
            .subscribe(event => {
            // when any child item is created, we need to add a detail link record
            this.createFeatureAreaDetail(event);
        }));
    }
    createFeatureAreaDetail(event) {
        const featureAreaDetail = {
            _itemName: DevwareMetaDataItemNames.DwFeatureAreaDetail,
            FeatureAreaId: this.dwFeatureAreaState.state.featureArea.FeatureAreaId,
            FeatureAreaDetailTypeId: event.featureAreaDetail.FeatureAreaDetailTypeId,
            MetaDataItemId: event.featureAreaDetail.MetaDataItemId,
            ReferenceKeyValue: event.createEvent.newItem[event.createEvent.newItem._keyName],
        };
        this.dwFeatureAreaRepositoryService.saveFeatureAreaDetails([featureAreaDetail])
            .subscribe(savedFeatureAreaDetails => {
            // update the state with the new details
            const allFeatureAreaDetails = [...this.dwFeatureAreaState.state.featureAreaDetails, ...savedFeatureAreaDetails];
            this.dwFeatureAreaState.setState({ featureAreaDetails: allFeatureAreaDetails });
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.dwFeatureAreaState.setState({ inUse: false, featureArea: null, featureAreaDetails: null });
    }
    selectGroup(groupId) {
        var _a;
        this.selectedGroupId = groupId;
        this.featureAreaDetailGroup = (_a = this.groups) === null || _a === void 0 ? void 0 : _a.find(g => g.FeatureAreaDetailGroupId == groupId);
    }
}
DwFeatureAreaDetailsComponent.ɵfac = function DwFeatureAreaDetailsComponent_Factory(t) { return new (t || DwFeatureAreaDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaStateService)); };
DwFeatureAreaDetailsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFeatureAreaDetailsComponent, selectors: [["dw-feature-area-details"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[3, "selectedGroupId", "selectedGroupIdChange"], [4, "ngIf"], [3, "featureAreaDetails", "featureAreaDetailGroup"]], template: function DwFeatureAreaDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-feature-area-detail-group-selector", 0);
        ɵngcc0.ɵɵlistener("selectedGroupIdChange", function DwFeatureAreaDetailsComponent_Template_dw_feature_area_detail_group_selector_selectedGroupIdChange_0_listener($event) { return ctx.selectGroup($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(1, DwFeatureAreaDetailsComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("selectedGroupId", ctx.selectedGroupId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.featureAreaDetailGroup);
    } }, directives: function () { return [DwFeatureAreaDetailGroupSelectorComponent, ɵngcc4.NgIf, DwFeatureAreaGridComponent]; }, styles: [".group-container[_ngcontent-%COMP%]{overflow:auto}.group-item[_ngcontent-%COMP%]{float:left;height:100px;text-align:center;width:100px}.group-item-text[_ngcontent-%COMP%]{font-size:larger;font-weight:700;margin-top:5px}"] });
DwFeatureAreaDetailsComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: DwFeatureAreaRepositoryService },
    { type: DwFeatureAreaStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFeatureAreaDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-feature-area-details',
                template: "<dw-feature-area-detail-group-selector [selectedGroupId]=\"selectedGroupId\" (selectedGroupIdChange)=\"selectGroup($event)\"></dw-feature-area-detail-group-selector>\r\n\r\n<ng-container *ngIf=\"featureAreaDetailGroup\">\r\n    <dw-feature-area-grid [featureAreaDetails]=\"featureAreaDetails\" [featureAreaDetailGroup]=\"featureAreaDetailGroup\"></dw-feature-area-grid>\r\n</ng-container>",
                styles: [".group-container{overflow:auto}.group-item{float:left;height:100px;text-align:center;width:100px}.group-item-text{font-size:larger;font-weight:700;margin-top:5px}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: DwFeatureAreaRepositoryService }, { type: DwFeatureAreaStateService }]; }, null); })();
DwComponentFunc({
    key: 'dw-feature-area-details',
    name: 'Dw Feature Area Details',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: DevwareMetaDataItemNames.DwFeatureArea
}, DwFeatureAreaDetailsComponent);

class DwFeatureAreaDetailGroupSelectorComponent {
    constructor(dwFeatureAreaRepositoryService) {
        this.dwFeatureAreaRepositoryService = dwFeatureAreaRepositoryService;
        this.selectedGroupIdChange = new EventEmitter();
    }
    ngOnInit() {
        this.dwFeatureAreaRepositoryService.getFeatureAreaGroups()
            .subscribe(groups => {
            this.groups = groups;
            this.selectItem(groups[0]);
        });
    }
    selectItem(group) {
        this.selectedGroupId = group.FeatureAreaDetailGroupId;
        this.selectedGroupIdChange.emit(this.selectedGroupId);
    }
}
DwFeatureAreaDetailGroupSelectorComponent.ɵfac = function DwFeatureAreaDetailGroupSelectorComponent_Factory(t) { return new (t || DwFeatureAreaDetailGroupSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService)); };
DwFeatureAreaDetailGroupSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFeatureAreaDetailGroupSelectorComponent, selectors: [["dw-feature-area-detail-group-selector"]], inputs: { selectedGroupId: "selectedGroupId" }, outputs: { selectedGroupIdChange: "selectedGroupIdChange" }, decls: 2, vars: 1, consts: [[1, "group-container"], ["class", "group-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "group-item", 3, "ngClass", "click"], [1, "fa-3x", 3, "ngClass"], [1, "group-item-text"]], template: function DwFeatureAreaDetailGroupSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwFeatureAreaDetailGroupSelectorComponent_div_1_Template, 4, 5, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.groups);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgClass], styles: [".group-container[_ngcontent-%COMP%]{margin:10px 10px 10px 0;overflow:auto}.group-item[_ngcontent-%COMP%]{background-color:#fff;border-radius:10px;box-shadow:0 1px 3px rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,67,.15);cursor:pointer;float:left;height:110px;margin:5px 5px 5px 0;padding:8px;text-align:center;width:110px}.group-item-selected[_ngcontent-%COMP%]{border:2px solid #25a0da!important;box-shadow:0 0 4px #25a0da,0 4px 8px 3px rgba(141,185,219,.15)}.group-item-text[_ngcontent-%COMP%]{font-size:larger;font-weight:700;margin-top:5px}"] });
DwFeatureAreaDetailGroupSelectorComponent.ctorParameters = () => [
    { type: DwFeatureAreaRepositoryService }
];
DwFeatureAreaDetailGroupSelectorComponent.propDecorators = {
    selectedGroupId: [{ type: Input }],
    selectedGroupIdChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFeatureAreaDetailGroupSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'dw-feature-area-detail-group-selector',
                template: "\r\n<div class=\"group-container\">\r\n    <div class=\"group-item\" *ngFor=\"let group of groups\" [ngClass]=\"{ 'group-item-selected': group.FeatureAreaDetailGroupId == selectedGroupId }\" (click)=\"selectItem(group)\">\r\n        <i [ngClass]=\"group.IconClass\" class=\"fa-3x\">\r\n        </i>\r\n\r\n        <div class=\"group-item-text\">\r\n            {{group.DetailGroupDisplay}}\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [".group-container{margin:10px 10px 10px 0;overflow:auto}.group-item{background-color:#fff;border-radius:10px;box-shadow:0 1px 3px rgba(60,64,67,.3),0 4px 8px 3px rgba(60,64,67,.15);cursor:pointer;float:left;height:110px;margin:5px 5px 5px 0;padding:8px;text-align:center;width:110px}.group-item-selected{border:2px solid #25a0da!important;box-shadow:0 0 4px #25a0da,0 4px 8px 3px rgba(141,185,219,.15)}.group-item-text{font-size:larger;font-weight:700;margin-top:5px}"]
            }]
    }], function () { return [{ type: DwFeatureAreaRepositoryService }]; }, { selectedGroupIdChange: [{
            type: Output
        }], selectedGroupId: [{
            type: Input
        }] }); })();

class DwFeatureAreaGridComponent {
    constructor(dwMetaDataService, dwFeatureAreaState) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwFeatureAreaState = dwFeatureAreaState;
        this.gridTabs = [];
        this.tabIndex = 0;
        this.ITEMS_DETAIL_TYPE_ID = 1;
    }
    ngOnInit() {
        this.setupGridTabs();
        this.dwMetaDataService.getMetaDataItemId(DevwareMetaDataItemNames.DwMetaDataItem)
            .subscribe(metaDataItem_ItemId => {
            this.metaDataItem_ItemId = metaDataItem_ItemId;
            this.setupGridTabs();
        });
    }
    ngOnChanges(changes) {
        var _a;
        if (((_a = changes.featureAreaDetailGroup) === null || _a === void 0 ? void 0 : _a.firstChange) === false) {
            this.tabIndex = 0;
        }
        this.setupGridTabs();
    }
    setupGridTabs() {
        if (!this.featureAreaDetails || !this.featureAreaDetailGroup || !this.metaDataItem_ItemId) {
            return;
        }
        this.gridTabs = [];
        for (const detailType of this.featureAreaDetailGroup.DwFeatureAreaDetailType) {
            const gridConfig = {
                display: detailType.DetailTypeDisplay,
                itemName: detailType.DwMetaDataItem.UniqueItemName,
                configKeyPart: 'feature-areas',
                filterAreaDetailTypeId: detailType.FeatureAreaDetailTypeId
            };
            gridConfig.filters = this.buildFilters(detailType);
            this.gridTabs.push(gridConfig);
        }
        // this.gridCallbacks = {
        //   getRowClass: (args) => {
        //     if (args.rowIndex % 4 == 0) {
        //       return 'dw-red';
        //     }
        //   }
        // }
    }
    buildFilters(detailType) {
        var _a;
        const keyFieldName = (_a = detailType.DwMetaDataItem.DwMetaDataAttribute.find(a => a.IsKey)) === null || _a === void 0 ? void 0 : _a.AttributeName;
        if (!keyFieldName) {
            return;
        }
        const keyFilter = this.buildKeyFilter(detailType);
        const referenceFilter = this.buildItemReferenceFilter(detailType);
        const qh = new DwQueryHelper();
        const filterGroup = qh.filters.Group();
        filterGroup.Op = DwOperator.Or;
        filterGroup.AddFilter(keyFilter);
        if (referenceFilter) {
            filterGroup.AddFilterOr(referenceFilter);
        }
        const filters = {
            GroupFilter: filterGroup
        };
        return filters;
    }
    buildKeyFilter(detailType) {
        var _a;
        const keyFieldName = (_a = detailType.DwMetaDataItem.DwMetaDataAttribute.find(a => a.IsKey)) === null || _a === void 0 ? void 0 : _a.AttributeName;
        if (!keyFieldName) {
            return;
        }
        const keyFilter = {};
        keyFilter[keyFieldName] = {};
        const keys = this.getDetailKeys(detailType.FeatureAreaDetailTypeId);
        if (keys.length == 0) {
            keys.push(0);
        }
        const qh = new DwQueryHelper();
        return qh.filters.InList(keyFieldName, keys);
        // keyFilter[keyFieldName].IN = keys;
        // return keyFilter;
    }
    buildItemReferenceFilter(detailType) {
        var _a;
        const referenceFieldName = (_a = detailType.DwMetaDataItem.DwMetaDataAttribute.find(a => a.ReferenceMetaDataItemId == this.metaDataItem_ItemId)) === null || _a === void 0 ? void 0 : _a.AttributeName;
        if (!referenceFieldName) {
            return;
        }
        const itemIds = this.getDetailKeys(this.ITEMS_DETAIL_TYPE_ID);
        if (itemIds.length == 0) {
            itemIds.push(0);
        }
        const qh = new DwQueryHelper();
        return qh.filters.InList(referenceFieldName, itemIds);
    }
    getDetailKeys(filterAreaDetailTypeId) {
        return this.featureAreaDetails.filter(fad => fad.FeatureAreaDetailTypeId == filterAreaDetailTypeId).map(fad2 => fad2.ReferenceKeyValue);
    }
}
DwFeatureAreaGridComponent.ɵfac = function DwFeatureAreaGridComponent_Factory(t) { return new (t || DwFeatureAreaGridComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaStateService)); };
DwFeatureAreaGridComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFeatureAreaGridComponent, selectors: [["dw-feature-area-grid"]], inputs: { featureAreaDetails: "featureAreaDetails", featureAreaDetailGroup: "featureAreaDetailGroup" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "activeIndex", "activeIndexChange", 4, "ngIf"], [3, "activeIndex", "activeIndexChange"], [3, "header", 4, "ngFor", "ngForOf"], [3, "header"], ["isReadOnly", "true", 3, "item", "configKeyPart", "gridCallbacks", "filters"]], template: function DwFeatureAreaGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwFeatureAreaGridComponent_p_tabView_0_Template, 2, 2, "p-tabView", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.gridTabs.length > 0);
    } }, directives: [ɵngcc4.NgIf, ɵngcc9.TabView, ɵngcc4.NgForOf, ɵngcc9.TabPanel, DwMetaDataGridComponent], styles: [""] });
DwFeatureAreaGridComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwFeatureAreaStateService }
];
DwFeatureAreaGridComponent.propDecorators = {
    featureAreaDetails: [{ type: Input }],
    featureAreaDetailGroup: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFeatureAreaGridComponent, [{
        type: Component,
        args: [{
                selector: 'dw-feature-area-grid',
                template: "\r\n\r\n<p-tabView *ngIf=\"gridTabs.length > 0\" [(activeIndex)]=\"tabIndex\">\r\n    <p-tabPanel *ngFor=\"let gridTab of gridTabs\" \r\n        header=\"{{gridTab.display}}\"> \r\n\r\n        \r\n    <dw-meta-data-grid isReadOnly=\"true\" [item]=\"gridTab.itemName\" [configKeyPart]=\"gridTab.configKeyPart\" [gridCallbacks]=\"gridCallbacks\"\r\n        [filters]=\"gridTab.filters\"></dw-meta-data-grid>\r\n\r\n\r\n    </p-tabPanel>\r\n</p-tabView>",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwFeatureAreaStateService }]; }, { featureAreaDetails: [{
            type: Input
        }], featureAreaDetailGroup: [{
            type: Input
        }] }); })();

class DwFaAddDetailModalComponent {
    constructor(dwMetaDataService, dwFeatureAreaRepository) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwFeatureAreaRepository = dwFeatureAreaRepository;
        this.running = false;
        this.detailGroupLookupId = DevwareMetaDataLookups.FeatureAreaDetailGroupAllItems;
        this.detailTypeLookupId = DevwareMetaDataLookups.FeatureAreaDetailTypesByGroup;
        this.selectedItems = [];
        this.addDetailResult = {
            newFeatureAreaDetails: []
        };
    }
    ngOnInit() {
        this.dwFeatureAreaRepository.getFeatureAreaGroups()
            .subscribe(groups => {
            this.groups = groups;
            this.setupDefaults();
        });
    }
    addFeatureDetails() {
        if (!this.selectedItems || this.selectedItems.length == 0) {
            return;
        }
        this.message = null;
        this.alreadyAddedList = [];
        for (let referenceKeyValue of this.selectedItems) {
            this.addFeatureDetail(referenceKeyValue);
        }
        // recreate the array so changes are passed
        this.addDetailResult.newFeatureAreaDetails = [...this.addDetailResult.newFeatureAreaDetails];
        if (this.alreadyAddedList.length > 0) {
            this.message = {
                messageBody: `${this.alreadyAddedList.length} ${this.alreadyAddedList.length > 1 ? 'items' : 'item'} were not added bcause they already exist`,
                severity: DwMessageSeverity.error
            };
        }
        this.selectedItems = [];
    }
    addFeatureDetail(referenceKeyValue) {
        var _a, _b;
        // check if we already have the item
        const featureDetail = {
            _itemName: DevwareMetaDataItemNames.DwFeatureAreaDetail,
            FeatureAreaId: (_a = this.modalConfig.data.featureArea) === null || _a === void 0 ? void 0 : _a.FeatureAreaId,
            FeatureAreaDetailTypeId: this.selectedType.FeatureAreaDetailTypeId,
            MetaDataItemId: this.selectedType.MetaDataItemId,
            ReferenceKeyValue: referenceKeyValue,
            ReferenceDisplay: ''
        };
        let existingDetail = this.modalConfig.data.featureAreaDetails.find(ad => !ad._isDeleted && ad.FeatureAreaDetailTypeId == featureDetail.FeatureAreaDetailTypeId && ad.ReferenceKeyValue == featureDetail.ReferenceKeyValue);
        if (!existingDetail) {
            existingDetail = this.addDetailResult.newFeatureAreaDetails.find(ad => !ad._isDeleted && ad.FeatureAreaDetailTypeId == featureDetail.FeatureAreaDetailTypeId && ad.ReferenceKeyValue == featureDetail.ReferenceKeyValue);
        }
        if (existingDetail) {
            this.alreadyAddedList.push(existingDetail);
            return;
        }
        // Populate the lookup display
        const lookupItem = (_b = this.lookupItems) === null || _b === void 0 ? void 0 : _b.find(li => li.Id == referenceKeyValue.toString());
        if (lookupItem) {
            featureDetail.ReferenceDisplay = limitLength(lookupItem.Display, 100);
        }
        this.addDetailResult.newFeatureAreaDetails.push(featureDetail);
    }
    setupDefaults() {
        for (let group of this.groups) {
            for (let detail of group.DwFeatureAreaDetailType) {
                if (detail.DwMetaDataItem.UniqueItemName == this.modalConfig.data.itemName) {
                    this.selectedGroupId = group.FeatureAreaDetailGroupId;
                    this.selectGroup(group.FeatureAreaDetailGroupId, true);
                    this.selectType(detail.FeatureAreaDetailTypeId);
                    return;
                }
            }
        }
        this.selectedGroupId = this.groups[0].FeatureAreaDetailGroupId;
    }
    selectGroup(groupId, excludeSettingType) {
        if (!this.groups) {
            return;
        }
        this.selectedGroup = this.groups.find(g => g.FeatureAreaDetailGroupId == groupId);
        if (excludeSettingType) {
            return;
        }
        this.selectType(this.selectedGroup.DwFeatureAreaDetailType[0].FeatureAreaDetailTypeId);
    }
    selectType(typeId) {
        if (!this.selectedGroup) {
            return;
        }
        this.selectedTypeId = typeId;
        this.selectedType = this.selectedGroup.DwFeatureAreaDetailType.find(t => t.FeatureAreaDetailTypeId == typeId);
        const allFeatureAreaDetails = [...this.modalConfig.data.featureAreaDetails, ...this.addDetailResult.newFeatureAreaDetails];
        this.dwFeatureAreaRepository.getFeatureDetailLookupInfo(this.modalConfig.data.featureArea, allFeatureAreaDetails, this.selectedType)
            .subscribe(lookupData => {
            this.lookupDef = lookupData.lookupDefinition;
            this.lookupItems = lookupData.lookupItems;
        });
        // this.dwMetaDataService.getLookupDefinitions()
        //   .subscribe(lookupDefinitions => {
        //     this.lookupDef = lookupDefinitions.find(ld => ld.MetaDataItemId == this.selectedType.MetaDataItemId && ld.IsDefault);
        //     this.dwMetaDataService.getLookup(this.lookupDef.MetaDataLookupId)
        //       .subscribe(lookupItems => {
        //         this.lookupItems = this.limitLookupItems(lookupItems, this.selectedType);
        //       })
        //     this.selectedItems = [];
        //   });
    }
    buttonClick(buttonConfig) {
        const modalResult = new DwModalResult();
        modalResult.cancelled = true;
        modalResult.closeModal = true;
        modalResult.buttonCommand = buttonConfig.command;
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                if (this.selectedItems.length > 0) {
                    this.addFeatureDetails();
                }
                this.message = null;
                if (this.addDetailResult.newFeatureAreaDetails.length == 0) {
                    this.message = {
                        messageBody: 'Please add at least one item',
                        severity: DwMessageSeverity.error
                    };
                    modalResult.closeModal = false;
                    return of(modalResult);
                }
                modalResult.cancelled = false;
                modalResult.closeModal = true;
                modalResult.buttonCommand = buttonConfig.command;
                modalResult.data = this.addDetailResult;
                return of(modalResult);
            default:
                return of(modalResult);
        }
    }
}
DwFaAddDetailModalComponent.ɵfac = function DwFaAddDetailModalComponent_Factory(t) { return new (t || DwFaAddDetailModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService)); };
DwFaAddDetailModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFaAddDetailModalComponent, selectors: [["dw-fa-add-detail-modal"]], decls: 16, vars: 12, consts: [[1, "modal-container"], [3, "message", "messageChange"], ["dwRow", ""], ["dwCol", "12"], [1, "label"], ["showBlankOption", "false", 3, "lookupId", "ngModel", "ngModelChange"], ["showBlankOption", "false", 3, "lookupId", "paramValues", "ngModel", "ngModelChange"], ["dwRow", "", "class", "item-selector", 4, "ngIf"], ["dwRow", "", 4, "ngIf"], [4, "ngIf"], ["dwRow", "", 1, "item-selector"], ["mapToArray", "true", "autoExpand", "false", 3, "lookupId", "overrideValues", "ngModel", "ngModelChange"], [1, "btn", "btn-success", 3, "disabled", "click"], [3, "featureAreaDetails", "featureAreaDetailsChange"]], template: function DwFaAddDetailModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dw-message", 1);
        ɵngcc0.ɵɵlistener("messageChange", function DwFaAddDetailModalComponent_Template_dw_message_messageChange_1_listener($event) { return ctx.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "label", 4);
        ɵngcc0.ɵɵtext(5, "Group");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "dw-select-lookup", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFaAddDetailModalComponent_Template_dw_select_lookup_ngModelChange_6_listener($event) { return ctx.selectedGroupId = $event; })("ngModelChange", function DwFaAddDetailModalComponent_Template_dw_select_lookup_ngModelChange_6_listener($event) { return ctx.selectGroup($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelementStart(8, "div", 3);
        ɵngcc0.ɵɵelementStart(9, "label", 4);
        ɵngcc0.ɵɵtext(10, "Detail");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "dw-select-lookup", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFaAddDetailModalComponent_Template_dw_select_lookup_ngModelChange_11_listener($event) { return ctx.selectedTypeId = $event; })("ngModelChange", function DwFaAddDetailModalComponent_Template_dw_select_lookup_ngModelChange_11_listener($event) { return ctx.selectType($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DwFaAddDetailModalComponent_div_12_Template, 5, 4, "div", 7);
        ɵngcc0.ɵɵtemplate(13, DwFaAddDetailModalComponent_div_13_Template, 4, 1, "div", 8);
        ɵngcc0.ɵɵtemplate(14, DwFaAddDetailModalComponent_div_14_Template, 2, 1, "div", 9);
        ɵngcc0.ɵɵtemplate(15, DwFaAddDetailModalComponent_div_15_Template, 4, 1, "div", 8);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("lookupId", ctx.detailGroupLookupId)("ngModel", ctx.selectedGroupId);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("lookupId", ctx.detailTypeLookupId)("paramValues", ɵngcc0.ɵɵpureFunction1(10, _c96, ctx.selectedGroupId))("ngModel", ctx.selectedTypeId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lookupDef);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.lookupDef);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.alreadyAddedList == null ? null : ctx.alreadyAddedList.length) > 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.addDetailResult.newFeatureAreaDetails.length > 0);
    } }, directives: function () { return [DwMessageComponent, DwRowDirective, DwColDirective, DwSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwMultiSelectLookupComponent, DwFaDetailViewComponent]; }, styles: [".modal-container[_ngcontent-%COMP%]{max-width:1000px;min-height:600px;min-width:600px}.item-selector[_ngcontent-%COMP%]{max-width:1200px}"] });
DwFaAddDetailModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwFeatureAreaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaAddDetailModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fa-add-detail-modal',
                template: "<div class=\"modal-container\">\r\n    <dw-message [(message)]=\"message\"></dw-message>\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Group</label>\r\n            <dw-select-lookup [lookupId]=\"detailGroupLookupId\" [(ngModel)]=\"selectedGroupId\" showBlankOption=\"false\"\r\n                (ngModelChange)=\"selectGroup($event)\"></dw-select-lookup>\r\n        </div>\r\n    </div>\r\n\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Detail</label>\r\n            <dw-select-lookup [lookupId]=\"detailTypeLookupId\"\r\n                [paramValues]=\"{ FeatureAreaDetailGroupId: selectedGroupId }\" [(ngModel)]=\"selectedTypeId\" showBlankOption=\"false\"\r\n                (ngModelChange)=\"selectType($event)\"></dw-select-lookup>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"lookupDef\" class=\"item-selector\">\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Choose {{selectedType?.DwMetaDataItem?.Display}}</label>\r\n            <dw-multi-select-lookup [lookupId]=\"lookupDef.MetaDataLookupId\" [overrideValues]=\"lookupItems\" [(ngModel)]=\"selectedItems\" mapToArray=\"true\" autoExpand=\"false\"></dw-multi-select-lookup>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"lookupDef\">\r\n        <div dwCol=\"12\">\r\n           <button class=\"btn btn-success\" (click)=\"addFeatureDetails()\" [disabled]=\"selectedItems.length == 0\">Add Items</button>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"alreadyAddedList?.length > 0\">\r\n        {{alreadyAddedList?.length}} items already existed and were not added\r\n    </div>\r\n    <div dwRow *ngIf=\"addDetailResult.newFeatureAreaDetails.length > 0\">\r\n        <div dwCol=\"12\">\r\n            <hr>\r\n            <dw-fa-detail-view [(featureAreaDetails)]=\"addDetailResult.newFeatureAreaDetails\"></dw-fa-detail-view>\r\n        </div>\r\n    </div>\r\n    \r\n</div>",
                styles: [".modal-container{max-width:1000px;min-height:600px;min-width:600px}.item-selector{max-width:1200px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwFeatureAreaRepositoryService }]; }, null); })();

class DwFalinkDetailsActionService {
    constructor(dwModalService, dwFeatureAreaState, dwFeatureAreaRepositoryService) {
        this.dwModalService = dwModalService;
        this.dwFeatureAreaState = dwFeatureAreaState;
        this.dwFeatureAreaRepositoryService = dwFeatureAreaRepositoryService;
    }
    handleAction(gridState) {
        return this.showModal(gridState.gridConfig.itemName);
    }
    showModal(itemName) {
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.allowFullScreen = true;
        modalConfig.data = {
            itemName: itemName,
            featureArea: this.dwFeatureAreaState.state.featureArea,
            featureAreaDetails: this.dwFeatureAreaState.state.featureAreaDetails,
        };
        modalConfig.component = DwFaAddDetailModalComponent;
        modalConfig.title = 'Link Feature Details';
        return this.dwModalService.showModal(modalConfig)
            .pipe(mergeMap(importModalResult => {
            const result = new DwGridActionResult();
            if (importModalResult.cancelled) {
                result.refreshData = false;
                result.cancelled = true;
                return of(result);
            }
            return this.dwFeatureAreaRepositoryService.saveFeatureAreaDetails(importModalResult.data.newFeatureAreaDetails)
                .pipe(map(savedFeatureAreas => {
                result.success = true;
                result.message = `${savedFeatureAreas.length} Item(s) linked`;
                const allFeatureAreaDetails = [...this.dwFeatureAreaState.state.featureAreaDetails, ...savedFeatureAreas];
                this.dwFeatureAreaState.setState({ featureAreaDetails: allFeatureAreaDetails });
                return result;
            }));
        }));
    }
}
DwFalinkDetailsActionService.ɵfac = function DwFalinkDetailsActionService_Factory(t) { return new (t || DwFalinkDetailsActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwFeatureAreaStateService), ɵngcc0.ɵɵinject(DwFeatureAreaRepositoryService)); };
DwFalinkDetailsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFalinkDetailsActionService, factory: DwFalinkDetailsActionService.ɵfac });
DwFalinkDetailsActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwFeatureAreaStateService },
    { type: DwFeatureAreaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFalinkDetailsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwFeatureAreaStateService }, { type: DwFeatureAreaRepositoryService }]; }, null); })();
function limitToDevwareItems(itemName) {
    return (itemName === null || itemName === void 0 ? void 0 : itemName.indexOf('dw_')) == 0;
}
DwActionFunc({
    keyName: 'dwFeatureAreasLinkItem',
    display: 'Feature Areas - Link Details',
    actionType: DwActionType.gridAction,
    decoratorType: DwDecoratorType.service,
    parentItemName: limitToDevwareItems,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Link Details',
        iconClass: 'fa fa-link',
        buttonClass: 'btn btn-primary',
        buttonTitle: 'Links an item to the selected feature area'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: true
    }
}, DwFalinkDetailsActionService);

var __decorate$2f = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1K = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwFaDetailViewComponent {
    constructor(dwFeatureAreaRepository) {
        this.dwFeatureAreaRepository = dwFeatureAreaRepository;
        this.featureAreaDetailsChange = new EventEmitter();
        this.showDependencies = false;
        this.readOnly = false;
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        if (changes.featureAreaDetails) {
            this.setupGroups();
        }
    }
    removeItem(detailItem, areaDetail) {
        areaDetail._isDeleted = true;
        this.setupGroups();
    }
    setupGroups() {
        this.dwFeatureAreaRepository.getFeatureAreaDisplayGroups(this.featureAreaDetails)
            .subscribe(displayGroups => {
            this.displayGroups = displayGroups;
        });
    }
}
DwFaDetailViewComponent.ɵfac = function DwFaDetailViewComponent_Factory(t) { return new (t || DwFaDetailViewComponent)(ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService)); };
DwFaDetailViewComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFaDetailViewComponent, selectors: [["dw-fa-detail-view"]], inputs: { showDependencies: "showDependencies", readOnly: "readOnly", featureAreaDetails: "featureAreaDetails" }, outputs: { featureAreaDetailsChange: "featureAreaDetailsChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 2, consts: [[1, "display-container"], [3, "hidden"], [4, "ngFor", "ngForOf"], ["class", "detail-container", 4, "ngFor", "ngForOf"], [1, "detail-container"], [1, "dw-chip-container"], [1, "dw-chip"], [1, "dw-chip-label-with-remove"], [1, "dw-chip-icon", 3, "click"], [1, "fa", "fa-times-circle"]], template: function DwFaDetailViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2, " There are no feature areas details ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwFaDetailViewComponent_ng_container_3_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.featureAreaDetails || ctx.featureAreaDetails.length != 0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.displayGroups);
    } }, directives: [ɵngcc4.NgForOf], styles: [".detail-container[_ngcontent-%COMP%], .group-container[_ngcontent-%COMP%]{clear:left;width:100%}"] });
DwFaDetailViewComponent.ctorParameters = () => [
    { type: DwFeatureAreaRepositoryService }
];
DwFaDetailViewComponent.propDecorators = {
    featureAreaDetails: [{ type: Input }],
    featureAreaDetailsChange: [{ type: Output }],
    showDependencies: [{ type: Input }],
    readOnly: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaDetailViewComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fa-detail-view',
                template: "<div class=\"display-container\">\r\n\r\n    <div [hidden]=\"!featureAreaDetails || featureAreaDetails.length != 0\">\r\n        There are no feature areas details\r\n    </div>\r\n\r\n    <ng-container *ngFor=\"let displayGroup of displayGroups\">\r\n        <div *ngFor=\"let displayDetail of displayGroup.details\" class=\"detail-container\">\r\n            <h2>{{displayGroup.group.DetailGroupDisplay}} - {{displayDetail.detail.DetailTypeDisplay}}</h2>\r\n\r\n            <div class=\"dw-chip-container\">\r\n                <ng-container *ngFor=\"let areaDetail of displayDetail.areaDetails\">\r\n                    <div class=\"dw-chip\">\r\n                        <div class=\"dw-chip-label-with-remove\">{{areaDetail.ReferenceDisplay}}</div>\r\n                        <div class=\"dw-chip-icon\" (click)=\"removeItem(displayDetails, areaDetail)\"><i\r\n                                class=\"fa fa-times-circle\"></i></div>\r\n                    </div>\r\n                </ng-container>\r\n            </div>\r\n\r\n        </div>\r\n\r\n    </ng-container>\r\n\r\n</div>",
                styles: [".detail-container,.group-container{clear:left;width:100%}"]
            }]
    }], function () { return [{ type: DwFeatureAreaRepositoryService }]; }, { featureAreaDetailsChange: [{
            type: Output
        }], showDependencies: [{
            type: Input
        }], readOnly: [{
            type: Input
        }], featureAreaDetails: [{
            type: Input
        }] }); })();
__decorate$2f([
    DwInputConverter(),
    __metadata$1K("design:type", Boolean)
], DwFaDetailViewComponent.prototype, "showDependencies", void 0);
__decorate$2f([
    DwInputConverter(),
    __metadata$1K("design:type", Boolean)
], DwFaDetailViewComponent.prototype, "readOnly", void 0);

class DwFaRemoveDetailsActionService {
    constructor(dwModalService, dwFeatureAreaState, dwFeatureAreaRepositoryService) {
        this.dwModalService = dwModalService;
        this.dwFeatureAreaState = dwFeatureAreaState;
        this.dwFeatureAreaRepositoryService = dwFeatureAreaRepositoryService;
    }
    handleAction(gridState) {
        // grid data could be for any item
        const gridData = ensureArray(gridState.data);
        const referenceKeys = gridData.map(i => i[i._keyName]);
        const allFeatureDetails = this.dwFeatureAreaState.state.featureAreaDetails;
        // get a list of the selected feature details for the item and reference keys
        return this.dwFeatureAreaRepositoryService.getSelectedFeatureDetails(allFeatureDetails, gridState.gridConfig.itemName, referenceKeys)
            .pipe(mergeMap(results => {
            // delete the selected items
            return this.dwFeatureAreaRepositoryService.deleteFeatureAreaDetails(results.selectedDetails)
                .pipe(map(details => {
                const result = {
                    success: true,
                    cancelled: false,
                };
                // Update Feature Area state with the details that weren't delete
                this.dwFeatureAreaState.setState({ featureAreaDetails: results.otherDetails });
                return result;
            }));
        }));
    }
}
DwFaRemoveDetailsActionService.ɵfac = function DwFaRemoveDetailsActionService_Factory(t) { return new (t || DwFaRemoveDetailsActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwFeatureAreaStateService), ɵngcc0.ɵɵinject(DwFeatureAreaRepositoryService)); };
DwFaRemoveDetailsActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFaRemoveDetailsActionService, factory: DwFaRemoveDetailsActionService.ɵfac });
DwFaRemoveDetailsActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwFeatureAreaStateService },
    { type: DwFeatureAreaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaRemoveDetailsActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwFeatureAreaStateService }, { type: DwFeatureAreaRepositoryService }]; }, null); })();
DwActionFunc({
    keyName: 'dwFeatureAreasRemoveDetails',
    display: 'Feature Areas - Unlink Details',
    actionType: DwActionType.gridRowAction,
    decoratorType: DwDecoratorType.service,
    parentItemName: limitToDevwareItems,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonType: DwButtonType.iconOnlyNoText,
        buttonText: 'Link Details',
        iconClass: 'fa fa-unlink dw-icon-grid dw-orange',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Unlinks the items from the feature area'
    },
    defaultMenuConfig: {
        useParentDisplay: false,
        menuDisplay: 'Unlink Details',
        menuIconClass: 'fa fa-unlink',
        itemRequirement: DwActionItemRequirement.multiple
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: true
    }
}, DwFaRemoveDetailsActionService);
// const {fdsToDelete, fdsToKeep} = this.getFeatureDetails(gridState.gridConfig.itemName, gridData);
// return this.dwFeatureAreaRepositoryService.deleteFeatureAreaDetails(fdsToDelete)
//     .pipe(map(details => {
//         const result: DwGridActionResult = {
//             success : true,
//             cancelled: false,
//         };
//         // // Update state with by removing the existing details
//         // const existingFeatureDetails = this.dwFeatureAreaState.state.featureAreaDetails;
//         // const updatedFeatureDetails = existingFeatureDetails.filter(i =>  {
//         //     return !featureDetailsToDelete.find(d => i.FeatureAreaDetailId == d.FeatureAreaDetailId);
//         // });
//         this.dwFeatureAreaState.setState({ featureAreaDetails: fdsToKeep });
//         return result;
//     }));
// getFeatureDetails(itemName: string, gridData: DwOrmData[]): { fdsToDelete:DwFeatureAreaDetailEntity[], fdsToKeep: DwFeatureAreaDetailEntity[] } {
//     // Update state with by removing the existing details
//     const existingFeatureDetails = this.dwFeatureAreaState.state.featureAreaDetails;
//     const fdsToDelete: DwFeatureAreaDetailEntity[] = [];
//     const fdsToKeep: DwFeatureAreaDetailEntity[] = [];
//     for(const faDetail of existingFeatureDetails) {
//         let markForDelete = false;
//         if (faDetail.DwMetaDataItem.UniqueItemName == itemName) {
//             markForDelete = !!gridData.find(i => i[i._keyName] == faDetail.ReferenceKeyValue);
//         }
//         if (markForDelete) {
//             fdsToDelete.push(faDetail);
//         } else {
//             fdsToDelete.push(faDetail);
//         }
//     }
//     return { fdsToDelete: fdsToDelete, fdsToKeep: fdsToKeep};
// }

class DwMetaDataItemControlComponent {
    constructor(dwFeatureAreaRepository, dwMenuService) {
        this.dwFeatureAreaRepository = dwFeatureAreaRepository;
        this.dwMenuService = dwMenuService;
        this.itemLookupId = DevwareMetaDataLookups.MetaDataItemAllItems;
        this.lookupItems = [];
        this.limitToFeature = false;
    }
    ngOnInit() {
        this.featureAreaId = this.dwMenuService.getMenuParam('dw_FeatureAreaId');
        if (this.featureAreaId) {
            this.limitToFeature = true;
        }
        this.setupLookupItems();
        this.lookupOptions = {
            showLink: true,
            windowOpenOptions: {
                openInNewWindow: true,
                newWindowTarget: 'MetaData'
            },
            //linkIconClass: 'fa fa-cog',
            linkTooltip: 'Edit Meta Data item'
        };
    }
    toggleLimitToFeature() {
        this.setupLookupItems();
    }
    setupLookupItems() {
        if (this.limitToFeature) {
            this.getLookupItems(this.featureAreaId)
                .subscribe(lookupItems => {
                this.lookupItems = lookupItems;
            });
        }
        else {
            this.lookupItems = null;
        }
    }
    getLookupItems(featureAreaId) {
        return this.dwFeatureAreaRepository.getFeatureDetailLimitedLookup(DevwareMetaDataItemNames.DwMetaDataItem, this.itemLookupId, featureAreaId);
    }
}
DwMetaDataItemControlComponent.ɵfac = function DwMetaDataItemControlComponent_Factory(t) { return new (t || DwMetaDataItemControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwMenuService)); };
DwMetaDataItemControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMetaDataItemControlComponent, selectors: [["dw-meta-data-item-control"]], decls: 3, vars: 6, consts: [[3, "formGroup"], ["class", "check-box-item", 4, "ngIf"], [3, "lookupId", "options", "overrideValues", "formControlName"], [1, "check-box-item"], ["type", "checkbox", 3, "ngModel", "ngModelOptions", "ngModelChange"]], template: function DwMetaDataItemControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMetaDataItemControlComponent_label_1_Template, 3, 3, "label", 1);
        ɵngcc0.ɵɵelement(2, "dw-search-select-lookup", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.featureAreaId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("lookupId", ctx.itemLookupId)("options", ctx.lookupOptions)("overrideValues", ctx.lookupItems)("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgIf, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.CheckboxControlValueAccessor, ɵngcc3.NgModel], encapsulation: 2 });
DwMetaDataItemControlComponent.ctorParameters = () => [
    { type: DwFeatureAreaRepositoryService },
    { type: DwMenuService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMetaDataItemControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-meta-data-item-control',
                template: `
  <div [formGroup]="formGroup">
   <label class="check-box-item" *ngIf="featureAreaId"><input type="checkbox" [(ngModel)]="limitToFeature" (ngModelChange)="toggleLimitToFeature()" [ngModelOptions]="{standalone: true}"> Limit to Feature</label>

    <dw-search-select-lookup [lookupId]="itemLookupId" [options]="lookupOptions" [overrideValues]="lookupItems" [formControlName]="fieldDef?.attrName"  ></dw-search-select-lookup>
  </div>
  `
            }]
    }], function () { return [{ type: DwFeatureAreaRepositoryService }, { type: DwMenuService }]; }, null); })();
DwComponentFunc({
    key: 'dw-meta-data-item-control',
    name: 'Meta Data Item Control',
    componentType: DwComponentType.formControl,
    isGlobal: true,
}, DwMetaDataItemControlComponent);

class DwItemTemplateControlComponent {
    constructor(dwMetaDataService, dwMetaDataFormStateService, dwMdTemplateService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMdTemplateService = dwMdTemplateService;
        this.inputClass = "form-control";
        this.selection = "";
        this.subscriptions = [];
        this.dropDownHeight = 300;
        this.visible = false;
        this.id = Math.floor(Math.random() * 1000);
        this.firstTimeLoad = true;
        this.ignoreNext = false;
    }
    initControl() {
        //console.log('Init Control');
        this.subscriptions.push(this.formGroup.valueChanges
            .pipe(debounceTime(100), map(() => {
            const data = this.formGroup.getRawValue();
            const mdInfo = {
                MetaDataItemId: data.MetaDataItemId,
                MetaDataQueryId: data.MetaDataQueryId
            };
            return mdInfo;
        }), distinctUntilChanged())
            .subscribe(data => {
            this.setupTemplateFields(data.MetaDataItemId, data.MetaDataQueryId);
        }));
        this.templateFC = this.formGroup.get(this.fieldDef.attrName);
        if (this.templateFC) {
            this.subscriptions.push(this.templateFC.valueChanges
                .pipe(debounceTime(20))
                .subscribe(templateText => {
                this.validateTemplate(templateText);
            }));
        }
        const initialData = this.formGroup.getRawValue();
        this.setupTemplateFields(initialData === null || initialData === void 0 ? void 0 : initialData.MetaDataItemId, initialData === null || initialData === void 0 ? void 0 : initialData.MetaDataQueryId);
    }
    click(event) {
        if (this.firstTimeLoad) {
            this.dropDownEl = document.getElementById(this.id);
            document.body.appendChild(this.dropDownEl);
            this.firstTimeLoad = false;
        }
        // Clear the search
        this.searchText = "";
        this.search();
        this.showDropDown();
    }
    search() {
        if (!this.queryMetaData) {
            return;
        }
        if (!this.searchText) {
            this.currentAttributes = this.allAttributes;
            return;
        }
        const searchText = this.searchText.toUpperCase();
        this.currentAttributes = this.allAttributes
            .filter(a => a.AttributeName.toUpperCase().indexOf(searchText) >= 0 || a.AttributeDisplay.toUpperCase().indexOf(searchText) >= 0);
    }
    validateTemplate(template) {
        this.dwMdTemplateService.validateTemplate(template, this.queryMetaData)
            .subscribe(validationResults => {
            this.validationResults = validationResults;
        });
    }
    setPosition() {
        const el = this.dwInputComponent.nativeElement;
        const position = el.getBoundingClientRect();
        this.dropDownEl.style.top = position.height + position.top - 2 + 'px';
        this.dropDownEl.style.left = position.left + 'px';
        this.dropDownEl.style.width = position.width + 'px';
        this.dropDownEl.style.height = this.dropDownHeight + 'px';
    }
    showDropDown() {
        this.visible = !this.visible;
        this.setPosition();
        this.dwInputComponent.nativeElement.focus();
        if (this.visible) {
            this.ignoreNext = true;
        }
    }
    ngOnDestroy() {
        if (this.dropDownEl) {
            document.body.removeChild(this.dropDownEl);
        }
        this.visible = false;
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    closeDropDown() {
        this.visible = false;
    }
    outsideClick() {
        if (this.ignoreNext) {
            this.ignoreNext = false;
            return;
        }
        this.closeDropDown();
    }
    ApendAttribute(attributeName) {
        var _a;
        if (attributeName) {
            const control = this.formGroup.get((_a = this.fieldDef) === null || _a === void 0 ? void 0 : _a.attrName);
            let templateValue = control.value || '';
            templateValue += `[${attributeName}]`;
            control.setValue(templateValue);
        }
    }
    setupTemplateFields(metaDataItemId, metaDataQueryId) {
        var _a, _b;
        if (!metaDataItemId || (this.currentData && ((_a = this.currentData) === null || _a === void 0 ? void 0 : _a.MetaDataItemId) == metaDataItemId && ((_b = this.currentData) === null || _b === void 0 ? void 0 : _b.MetaDataQueryId) == metaDataQueryId)) {
            return;
        }
        this.currentData = {
            MetaDataItemId: metaDataItemId,
            MetaDataQueryId: metaDataQueryId
        };
        this.subscriptions.push(this.dwMetaDataService.getMetaDataItemName(metaDataItemId)
            .pipe(mergeMap(itemName => {
            return this.dwMetaDataService.getSavedQueryMetaData(itemName, metaDataQueryId);
        }))
            .subscribe(queryMetaData => {
            var _a;
            this.queryMetaData = queryMetaData;
            this.setupAttributes();
            this.validateTemplate((_a = this.templateFC) === null || _a === void 0 ? void 0 : _a.value);
        }));
    }
    setupAttributes() {
        var _a;
        const finalAttrs = [];
        for (let attr of this.queryMetaData.Attributes) {
            finalAttrs.push(attr);
            if (attr.DisplayAttributeName != attr.AttributeName || ((_a = attr.Attribute) === null || _a === void 0 ? void 0 : _a.IsLookup)) {
                const displayAttr = Object.assign({}, attr);
                displayAttr.AttributeDisplay = `${attr.AttributeDisplay} (Display)`;
                if (attr.DisplayAttributeName != attr.AttributeName) {
                    displayAttr.AttributeName = attr.DisplayAttributeName;
                }
                else {
                    displayAttr.AttributeName = `${attr.AttributeName}Display`;
                }
                finalAttrs.push(displayAttr);
            }
        }
        this.allAttributes = finalAttrs;
    }
}
DwItemTemplateControlComponent.ɵfac = function DwItemTemplateControlComponent_Factory(t) { return new (t || DwItemTemplateControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMdTemplateService)); };
DwItemTemplateControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwItemTemplateControlComponent, selectors: [["dw-item-template-control"]], viewQuery: function DwItemTemplateControlComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c19, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dwInputComponent = _t.first);
    } }, inputs: { dropDownHeight: "dropDownHeight", context: "context" }, decls: 14, vars: 19, consts: [[3, "formGroup"], ["showSuffix", "true", "wrapControl", "false"], ["type", "text", "control", "", 1, "form-control", 3, "formControlName", "id", "placeholder", "ngModelChange"], ["inputElement", "", "inputElement", ""], ["suffix", "", 1, "icon-section2"], ["title", "Template is valid", 1, "fa", "fa-check-circle", "dw-green", 3, "hidden"], [1, "fa", "fa-minus-circle", "dw-red", 3, "hidden", "title"], ["title", "Add Attributes", 1, "fa", "fa-plus-circle", "hand", 3, "click"], [1, "invalid-feedback", "dw-red", 3, "hidden"], [1, "dropdown-section", 3, "ngClass", "clickOutside"], ["inputClass", "form-control", "placeholder", "search", 3, "ngModel", "ngModelOptions", "ngModelChange"], ["class", "field-item", 4, "ngFor", "ngForOf"], [1, "field-item"], [1, "btn", "btn-sm", "btn-success", 3, "click"], ["title", "Add", 1, "fa", "fa-plus-circle", "hand"]], template: function DwItemTemplateControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "dw-control-wrapper-with-icons", 1);
        ɵngcc0.ɵɵelementStart(2, "input", 2, 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwItemTemplateControlComponent_Template_input_ngModelChange_2_listener($event) { return ctx.validateTemplate($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelement(6, "i", 5);
        ɵngcc0.ɵɵelement(7, "i", 6);
        ɵngcc0.ɵɵelementStart(8, "i", 7);
        ɵngcc0.ɵɵlistener("click", function DwItemTemplateControlComponent_Template_i_click_8_listener($event) { return ctx.click($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 8);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 9);
        ɵngcc0.ɵɵlistener("clickOutside", function DwItemTemplateControlComponent_Template_div_clickOutside_11_listener() { return ctx.outsideClick(); });
        ɵngcc0.ɵɵelementStart(12, "dw-input", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwItemTemplateControlComponent_Template_dw_input_ngModelChange_12_listener($event) { return ctx.searchText = $event; })("ngModelChange", function DwItemTemplateControlComponent_Template_dw_input_ngModelChange_12_listener() { return ctx.search(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(13, DwItemTemplateControlComponent_div_13_Template, 4, 1, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMap(ctx.inputClass);
        ɵngcc0.ɵɵproperty("formControlName", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("id", ctx.fieldDef == null ? null : ctx.fieldDef.attrName)("placeholder", (ctx.fieldDef == null ? null : ctx.fieldDef.placeholderText) || "");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.validationResults == null ? null : ctx.validationResults.isValid));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.validationResults == null ? null : ctx.validationResults.isValid)("title", ctx.validationResults == null ? null : ctx.validationResults.errorMessasge);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", !(ctx.validationResults == null ? null : ctx.validationResults.errorMessasge));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.validationResults == null ? null : ctx.validationResults.errorMessasge, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(16, _c44, ctx.visible == false));
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.searchText)("ngModelOptions", ɵngcc0.ɵɵpureFunction0(18, _c4));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.currentAttributes);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwControlWrapperWithIconsComponent, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc4.NgClass, DwClickOutsideDirective, DwInputComponent, ɵngcc3.NgModel, ɵngcc4.NgForOf], styles: ["@charset \"UTF-8\";.drop-down-tree-field[_ngcontent-%COMP%]{position:relative}.drop-down-tree-field[_ngcontent-%COMP%]   .form-control[_ngcontent-%COMP%]:disabled, .drop-down-tree-field[_ngcontent-%COMP%]   .form-control[readonly][_ngcontent-%COMP%], .dropdown-section[_ngcontent-%COMP%]{background-color:#fff}.dropdown-section[_ngcontent-%COMP%]{background-clip:padding-box;border:1px solid #000;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;min-width:10rem;overflow-x:none;overflow-y:auto;padding:4px;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section[_ngcontent-%COMP%]   .ui-treenode-content-selected[_ngcontent-%COMP%]{background-color:#007ad9;border:1px;color:#fff}.hide[_ngcontent-%COMP%]{display:none}.drop-down-icon[_ngcontent-%COMP%]{color:#848484;position:absolute;right:6px;top:20%}.custom-ui-tree[_ngcontent-%COMP%]{height:100%;width:100%!important}.custom-ui-tree[_ngcontent-%COMP%], .custom-ui-tree[_ngcontent-%COMP%]   .ui-tree-container[_ngcontent-%COMP%]{padding:0!important}.pi-caret-down[_ngcontent-%COMP%]:before{content:\"\uE902\"!important}.input-section[_ngcontent-%COMP%]{float:left;padding-right:5px;width:calc(100% - 40px)}.icon-section[_ngcontent-%COMP%]{float:left}.icon-section[_ngcontent-%COMP%], .icon-section2[_ngcontent-%COMP%]{font-size:medium;margin-top:8px;padding-right:4px;width:40px}.icon-section2[_ngcontent-%COMP%]{margin-left:5px}.field-item[_ngcontent-%COMP%]{padding-bottom:2px}"] });
DwItemTemplateControlComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataFormStateService },
    { type: DwMdTemplateService }
];
DwItemTemplateControlComponent.propDecorators = {
    context: [{ type: Input }],
    dwInputComponent: [{ type: ViewChild, args: ['inputElement', { static: true },] }],
    dropDownHeight: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwItemTemplateControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-item-template-control',
                template: "<div [formGroup]=\"formGroup\">\r\n    <!-- <div class=\"drop-down-tree-field\">\r\n        <div class=\"input-section\">\r\n            <dw-input #inputElement [formControlName]=\"fieldDef?.attrName\" (ngModelChange)=\"validateTemplate($event)\"\r\n                [id]=\"fieldDef?.attrName\" [inputClass]=\"inputClass\" [placeholder]=\"fieldDef?.placeholderText || ''\"\r\n                [options]=\"fieldDef?.controlOptions\"></dw-input>\r\n        </div>\r\n        <div class=\"icon-section\">\r\n\r\n            <i class=\"fa fa-check-circle dw-green\" [hidden]=\"!validationResults?.isValid\" title=\"Template is valid\"></i>\r\n            <i class=\"fa fa-minus-circle dw-red\" [hidden]=\"validationResults?.isValid\"\r\n                [title]=\"validationResults?.errorMessasge\"></i>\r\n\r\n            <i class=\"fa fa-plus-circle hand\" (click)=\"click($event)\" title=\"Add Attributes\"></i>\r\n        </div>\r\n    </div> -->\r\n    <dw-control-wrapper-with-icons showSuffix=\"true\" wrapControl=\"false\">\r\n        <input #inputElement type=\"text\" class=\"form-control\" control #inputElement [formControlName]=\"fieldDef?.attrName\"\r\n            (ngModelChange)=\"validateTemplate($event)\" [id]=\"fieldDef?.attrName\" [class]=\"inputClass\"\r\n            [placeholder]=\"fieldDef?.placeholderText || ''\">\r\n\r\n        <div suffix class=\"icon-section2\">\r\n            <i class=\"fa fa-check-circle dw-green\" [hidden]=\"!validationResults?.isValid\" title=\"Template is valid\"></i>\r\n            <i class=\"fa fa-minus-circle dw-red\" [hidden]=\"validationResults?.isValid\"\r\n                [title]=\"validationResults?.errorMessasge\"></i>\r\n\r\n            <i class=\"fa fa-plus-circle hand\" (click)=\"click($event)\" title=\"Add Attributes\"></i>\r\n        </div>\r\n    </dw-control-wrapper-with-icons>\r\n    <div [hidden]=\"!validationResults?.errorMessasge\" class=\"invalid-feedback dw-red\"> \r\n        {{ validationResults?.errorMessasge }}\r\n    </div>\r\n    <div class=\"dropdown-section\" [ngClass]=\"{'hide': visible == false}\" [attr.id]=\"id\" (clickOutside)=\"outsideClick()\">\r\n        <dw-input inputClass=\"form-control\" placeholder=\"search\" [(ngModel)]=\"searchText\" (ngModelChange)=\"search()\" [ngModelOptions]=\"{standalone: true}\"></dw-input>\r\n        <div *ngFor=\"let field of currentAttributes\" class=\"field-item\">\r\n            <button class=\"btn btn-sm btn-success\" (click)=\"ApendAttribute(field.AttributeName)\">\r\n                <i class=\"fa fa-plus-circle hand\" title=\"Add\"></i>\r\n                {{field.AttributeDisplay}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>\r\n<!-- \r\n<div class=\"input-group\">\r\n\r\n\r\n    <dw-input control #inputElement [formControlName]=\"fieldDef?.attrName\" (ngModelChange)=\"validateTemplate($event)\" [id]=\"fieldDef?.attrName\" [inputClass]=\"inputClass\" [placeholder]=\"fieldDef?.placeholderText || ''\"  [options]=\"fieldDef?.controlOptions\"></dw-input>\r\n \r\n    <div  class=\"input-group-append\">\r\n        <i class=\"fa fa-check-circle dw-green\" [hidden]=\"!validationResults?.isValid\" title=\"Template is valid\"></i>\r\n        <i class=\"fa fa-minus-circle dw-red\" [hidden]=\"validationResults?.isValid\" [title]=\"validationResults?.errorMessasge\"></i>\r\n\r\n        <i class=\"fa fa-plus-circle hand\" (click)=\"click($event)\" title=\"Add Attributes\"></i>\r\n    </div>\r\n</div> -->",
                styles: ["@charset \"UTF-8\";.drop-down-tree-field{position:relative}.drop-down-tree-field .form-control:disabled,.drop-down-tree-field .form-control[readonly],.dropdown-section{background-color:#fff}.dropdown-section{background-clip:padding-box;border:1px solid #000;border-radius:.25rem;color:#212529;float:left;font-size:1rem;left:50px;list-style:none;margin:0;min-width:10rem;overflow-x:none;overflow-y:auto;padding:4px;position:absolute;text-align:left;top:50px;z-index:1030}.dropdown-section .ui-treenode-content-selected{background-color:#007ad9;border:1px;color:#fff}.hide{display:none}.drop-down-icon{color:#848484;position:absolute;right:6px;top:20%}.custom-ui-tree{height:100%;width:100%!important}.custom-ui-tree,.custom-ui-tree .ui-tree-container{padding:0!important}.pi-caret-down:before{content:\"\uE902\"!important}.input-section{float:left;padding-right:5px;width:calc(100% - 40px)}.icon-section{float:left}.icon-section,.icon-section2{font-size:medium;margin-top:8px;padding-right:4px;width:40px}.icon-section2{margin-left:5px}.field-item{padding-bottom:2px}"]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataFormStateService }, { type: DwMdTemplateService }]; }, { dropDownHeight: [{
            type: Input
        }], context: [{
            type: Input
        }], dwInputComponent: [{
            type: ViewChild,
            args: ['inputElement', { static: true }]
        }] }); })();
DwComponentFunc({
    key: 'dw-meta-data-template-control',
    name: 'Meta Data Template Control',
    componentType: DwComponentType.formControl,
    isGlobal: false,
    parentItemName: DevwareMetaDataItemNames.DwMetaDataLookup
}, DwItemTemplateControlComponent);

var DwFaItemSelection;
(function (DwFaItemSelection) {
    DwFaItemSelection["all"] = "All";
    DwFaItemSelection["featureAreas"] = "featureAreas";
    DwFaItemSelection["capBuiltIn"] = "capBuiltIn";
    DwFaItemSelection["adhoc"] = "adhoc";
})(DwFaItemSelection || (DwFaItemSelection = {}));
class DwFaItemSelectionList extends DwEnumListBase {
    getEnumValue(propertyName) {
        return DwFaItemSelection[propertyName];
    }
    getKeys() {
        return Object.keys(DwFaItemSelection);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwFaItemSelection.all:
                return 'All';
            case DwFaItemSelection.featureAreas:
                return 'Feature Areas';
            case DwFaItemSelection.capBuiltIn:
                return 'CAP Built-in';
            case DwFaItemSelection.adhoc:
                return 'Adhoc';
            default:
                return item;
        }
    }
}

var DwFaPublishType;
(function (DwFaPublishType) {
    DwFaPublishType["exportToFile"] = "exportToFile";
    DwFaPublishType["importFromFile"] = "importFromFile";
    DwFaPublishType["publishToEnvironment"] = "publishToEnvironment";
})(DwFaPublishType || (DwFaPublishType = {}));
class DwFaPublishTypeList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwFaPublishType[propertyName];
    }
    getKeys() {
        return Object.keys(DwFaPublishType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwFaPublishType.exportToFile:
                return 'Export To File';
            case DwFaPublishType.importFromFile:
                return 'Import From File';
            case DwFaPublishType.publishToEnvironment:
            // blank out until feature is added
            //return 'Publish To Environment';
            default:
                return item;
        }
    }
}

class DwPublishingApiService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.suppressErrorMessages = true;
        // Setup storage to use
        this.publishingApi = `${configService.coreConfig.apiRoot}/publishing`;
    }
    exportToFile(featureAreaIds, fileName = 'CAP Export.zip') {
        const url = `${this.publishingApi}/exportToFile`;
        let headers = new HttpHeaders();
        if (this.suppressErrorMessages) {
            headers = headers.append(SuppressErrorMessagesHeader, 'true');
        }
        const requestDTO = {
            FeatureAreaIds: featureAreaIds
        };
        return this.http.post(url, requestDTO, { headers: headers, responseType: 'blob' })
            .pipe(tap(result => {
            saveAs(result, fileName);
        }));
    }
    readExportArchive(file) {
        const url = `${this.publishingApi}/readExportArchive`;
        const formData = new FormData();
        formData.append('file', file, file.name);
        //formData.append('mediaInfo', JSON.stringify(mediaInfo));
        let headers = new HttpHeaders();
        headers = headers.set('contentTypeOverride', 'multipart/form-data');
        headers = headers.append(SuppressErrorMessagesHeader, 'true');
        return this.http.post(url, formData, { headers: headers });
    }
    importFromFile(file, featureAreaIds, compareOnly) {
        const url = `${this.publishingApi}/importFromFile`;
        const formData = new FormData();
        const requestDTO = {
            FeatureAreaIds: featureAreaIds,
            CompareOnly: compareOnly
        };
        formData.append('file', file, file.name);
        formData.append('request', JSON.stringify(requestDTO));
        let headers = new HttpHeaders();
        headers = headers.set('contentTypeOverride', 'multipart/form-data');
        headers = headers.append(SuppressErrorMessagesHeader, 'true');
        return this.http.post(url, formData, { headers: headers });
    }
}
DwPublishingApiService.ɵfac = function DwPublishingApiService_Factory(t) { return new (t || DwPublishingApiService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwConfigServiceToken)); };
DwPublishingApiService.ɵprov = ɵɵdefineInjectable({ factory: function DwPublishingApiService_Factory() { return new DwPublishingApiService(ɵɵinject(HttpClient), ɵɵinject(DwConfigServiceToken)); }, token: DwPublishingApiService, providedIn: "root" });
DwPublishingApiService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwPublishingApiService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }]; }, null); })();

class DwFaPublishModalComponent {
    constructor(dwMetaDataService, dwFeatureAreaRepository, dwPublishingApiService) {
        this.dwMetaDataService = dwMetaDataService;
        this.dwFeatureAreaRepository = dwFeatureAreaRepository;
        this.dwPublishingApiService = dwPublishingApiService;
        this.running = false;
        this.DwFaItemSelection = DwFaItemSelection;
        this.DwFaPublishType = DwFaPublishType;
        this.featureAreasLookupId = DevwareMetaDataLookups.FeatureAreaAllItems;
        this.publishRequest = {
            publishType: DwFaPublishType.exportToFile,
            itemSelection: DwFaItemSelection.featureAreas,
            compareOnly: true
        };
    }
    ngOnInit() {
        this.publishTypes = new DwFaPublishTypeList().getLookupList();
        this.itemSelections = new DwFaItemSelectionList().getLookupList();
        this.modalConfig.buttons[0].hidden = true;
        this.setupDefaults();
    }
    setupDefaults() {
        if (this.modalConfig.data.itemName == DevwareMetaDataItemNames.DwFeatureArea) {
            this.publishRequest.featureAreaIds = this.modalConfig.data.keyValues;
        }
    }
    buttonClick(buttonConfig) {
        const modalResult = new DwModalResult();
        modalResult.cancelled = true;
        modalResult.closeModal = true;
        modalResult.buttonCommand = buttonConfig.command;
        switch (buttonConfig.command) {
            case DwButtonCommand.saveAndClose:
                this.message = null;
                return of(modalResult);
        }
        return of(modalResult);
    }
    fileSelected(files) {
        if (files.length == 1) {
            this.currentExportFile = files[0];
            this.dwPublishingApiService.readExportArchive(this.currentExportFile)
                .subscribe(result => {
                this.exportArchiveResult = result;
                this.exportArchiveGroupList = result.ExportGroups.map(fa => ({ Id: fa.FeatureAreaId.toString(), Display: fa.FeatureAreaName }));
                // Assigned all feature areas listed to the publish request
                this.publishRequest.featureAreaIds = result.ExportGroups.map(fa => fa.FeatureAreaId);
            });
        }
    }
    exportToFile() {
        if (this.processing) {
            return;
        }
        this.message = null;
        this.processing = true;
        this.processingMessage = 'Exporting Changes...';
        this.dwPublishingApiService.exportToFile(this.publishRequest.featureAreaIds)
            .subscribe(results => {
            this.processing = false;
            this.message = {
                messageBody: 'Devware Export Archive has been created'
            };
        });
    }
    importFromFile(compareOnly) {
        if (this.processing) {
            return;
        }
        this.message = null;
        this.processing = true;
        if (compareOnly) {
            this.processingMessage = 'Comparing...';
        }
        else {
            this.processingMessage = 'Importing Changes...';
        }
        this.dwPublishingApiService.importFromFile(this.currentExportFile, this.publishRequest.featureAreaIds, compareOnly)
            .subscribe(results => {
            this.processing = false;
            this.importResults = results;
            if (!compareOnly) {
                this.allComplete = true;
            }
            this.message = {};
            if (results.Success) {
                this.changeCount = this.getTotalChangeCount();
                if (this.changeCount > 0) {
                    this.message.messageBody = compareOnly ? 'Compare was successful' : 'Import was successful!';
                }
                else {
                    this.message.messageBody = 'No Changes found so you are all up to date!';
                }
                this.message.severity = DwMessageSeverity.success;
                return;
            }
            else {
                this.message.messageBody = 'Import failed';
                this.message.severity = DwMessageSeverity.error;
            }
        });
    }
    getTotalChangeCount() {
        if (!this.importResults) {
            return null;
        }
        let changeCount = 0;
        for (let result of this.importResults.FeatureAreaCompareResult) {
            changeCount += result.CompareResult.ChangeCount;
        }
        return changeCount;
    }
}
DwFaPublishModalComponent.ɵfac = function DwFaPublishModalComponent_Factory(t) { return new (t || DwFaPublishModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwFeatureAreaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwPublishingApiService)); };
DwFaPublishModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFaPublishModalComponent, selectors: [["dw-fa-publish-modal"]], decls: 7, vars: 4, consts: [["dwRow", ""], ["dwCol", "12"], [1, "label"], [3, "ngModel", "overrideValues", "ngModelChange"], [4, "ngIf"], ["dwRow", "", 4, "ngIf"], [3, "message"], [1, "btn", "btn-primary", 3, "enabled", "click"], [3, "show", "text"], ["mapToArray", "true", "mapToNumber", "true", 3, "ngModel", "lookupId", "ngModelChange"], ["dwRow", "", 3, "hidden"], ["allowedFileTypes", ".zip,.daf", 3, "filesSelected"], [3, "hidden"], [1, "btn", "btn-primary", 3, "hidden", "enabled", "click"], [1, "form-control"], ["mapToArray", "true", "mapToNumber", "true", 3, "ngModel", "overrideValues", "ngModelChange"], [3, "importResults"]], template: function DwFaPublishModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3, "Publish Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "dw-radio-lookup", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwFaPublishModalComponent_Template_dw_radio_lookup_ngModelChange_4_listener($event) { return ctx.publishRequest.publishType = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwFaPublishModalComponent_ng_container_5_Template, 12, 7, "ng-container", 4);
        ɵngcc0.ɵɵtemplate(6, DwFaPublishModalComponent_ng_container_6_Template, 17, 13, "ng-container", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.publishRequest.publishType)("overrideValues", ctx.publishTypes);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.publishRequest.publishType == ctx.DwFaPublishType.exportToFile);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.publishRequest.publishType == ctx.DwFaPublishType.importFromFile);
    } }, directives: function () { return [DwRowDirective, DwColDirective, DwRadioLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwMessageComponent, DwButtonBarComponent, DwLoadingComponent, DwMultiSelectLookupComponent, DwFileUploadComponent, DwExportCompareResultViewerComponent]; }, pipes: function () { return [DwDatePipe]; }, styles: [""] });
DwFaPublishModalComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwFeatureAreaRepositoryService },
    { type: DwPublishingApiService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaPublishModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-fa-publish-modal',
                template: "<div dwRow>\r\n    <div dwCol=\"12\">\r\n        <label class=\"label\">Publish Type</label>\r\n        <dw-radio-lookup [(ngModel)]=\"publishRequest.publishType\" [overrideValues]=\"publishTypes\"></dw-radio-lookup>\r\n    </div>\r\n</div>\r\n<ng-container *ngIf=\"publishRequest.publishType == DwFaPublishType.exportToFile\">\r\n    <div dwRow>\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Item Selection</label>\r\n            <dw-radio-lookup [(ngModel)]=\"publishRequest.itemSelection\"\r\n                [overrideValues]=\"itemSelections\"></dw-radio-lookup>\r\n        </div>\r\n    </div>\r\n    <div dwRow *ngIf=\"publishRequest.itemSelection == DwFaItemSelection.featureAreas\">\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Feature Areas</label>\r\n            <dw-multi-select-lookup [(ngModel)]=\"publishRequest.featureAreaIds\" [lookupId]=\"featureAreasLookupId\"\r\n                mapToArray=\"true\" mapToNumber=\"true\"></dw-multi-select-lookup>\r\n        </div>\r\n    </div>\r\n    <dw-message [message]=\"message\"></dw-message>\r\n    <dw-button-bar>\r\n        <button class=\"btn btn-primary\" (click)=\"exportToFile()\" [enabled]=\"!processing\">Export</button>\r\n        <dw-loading [show]=\"processing\" [text]=\"processingMessage || 'Processing...'\"></dw-loading>\r\n    </dw-button-bar>\r\n</ng-container>\r\n<ng-container *ngIf=\"publishRequest.publishType == DwFaPublishType.importFromFile\">\r\n    <div dwRow [hidden]=\"exportArchiveResult\">\r\n        <div dwCol=\"12\">\r\n            <label class=\"label\">Devware Archive File</label>\r\n            <dw-file-upload allowedFileTypes=\".zip,.daf\" (filesSelected)=\"fileSelected($event)\"></dw-file-upload>\r\n        </div>\r\n    </div>\r\n    <ng-container *ngIf=\"exportArchiveResult && !importResults\">\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label class=\"label\">Archive Info</label>\r\n                <span class=\"form-control\">\r\n                    Created By: {{exportArchiveResult.ArchiveInfo?.CreatedByUser?.FirstNameLastName}} @\r\n                    {{exportArchiveResult.ArchiveInfo?.CreatedDateTime | dwDate}}\r\n                </span>\r\n            </div>\r\n        </div>\r\n        <div dwRow>\r\n            <div dwCol=\"12\">\r\n                <label class=\"label\">Feature Areas</label>\r\n                <dw-multi-select-lookup [(ngModel)]=\"publishRequest.featureAreaIds\"\r\n                    [overrideValues]=\"exportArchiveGroupList\" mapToArray=\"true\"\r\n                    mapToNumber=\"true\"></dw-multi-select-lookup>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"importResults && changeCount>0\">\r\n        <div dwRow [hidden]=\"!exportArchiveResult\">\r\n            <div dwCol=\"12\">\r\n                <dw-export-compare-result-viewer [importResults]=\"importResults\"></dw-export-compare-result-viewer>\r\n            </div>\r\n        </div>\r\n    </ng-container>\r\n    <dw-message [message]=\"message\"></dw-message>\r\n    <dw-button-bar [hidden]=\"allComplete || changeCount==0\">\r\n        <button class=\"btn btn-primary\" (click)=\"importFromFile(true)\" [hidden]=\"importResults\" [enabled]=\"!processing\">Compare </button>\r\n\r\n        <button class=\"btn btn-primary\" (click)=\"importFromFile(false)\" [hidden]=\"importResults\" [enabled]=\"!processing\">Import</button>\r\n        <button class=\"btn btn-primary\" (click)=\"importFromFile(false)\" [hidden]=\"!importResults\" [enabled]=\"!processing\">Import Changes</button>\r\n\r\n        <dw-loading [show]=\"processing\" [text]=\"processingMessage || 'Processing...'\"></dw-loading>\r\n    </dw-button-bar>\r\n</ng-container>\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwFeatureAreaRepositoryService }, { type: DwPublishingApiService }]; }, null); })();

class DwActionState {
}

function isDwClassInfo(classReference) {
    if (typeof classReference == 'string') {
        return false;
    }
    return true;
}

class DwClassReferenceBuilderService {
}

function isDwFormSaveResult(result) {
    if (result.validationFailed === undefined) {
        return false;
    }
    return true;
}

class DwGridActionState extends DwActionState {
}

class DwGridRowActionState extends DwActionState {
}

var DwColumnRenderType;
(function (DwColumnRenderType) {
    DwColumnRenderType["default"] = "default";
    DwColumnRenderType["link"] = "link";
    DwColumnRenderType["template"] = "template";
    DwColumnRenderType["icon"] = "icon";
    DwColumnRenderType["button"] = "button";
    DwColumnRenderType["custom"] = "custom";
})(DwColumnRenderType || (DwColumnRenderType = {}));
class DwColumnRenderTypeList extends DwEnumListBase {
    constructor() {
        super(...arguments);
        this.ignoreBlankDisplayItems = true;
    }
    getEnumValue(propertyName) {
        return DwColumnRenderType[propertyName];
    }
    getKeys() {
        return Object.keys(DwColumnRenderType);
    }
    getEnumDisplay(item) {
        switch (item) {
            case DwColumnRenderType.default:
                return 'Default';
            case DwColumnRenderType.link:
                return 'Link';
            case DwColumnRenderType.template:
                return 'Template';
            case DwColumnRenderType.icon:
                return 'Icon';
            case DwColumnRenderType.button:
                return 'Button';
            case DwColumnRenderType.custom:
                return 'Custom';
        }
    }
}

var DwGridEventCommands;
(function (DwGridEventCommands) {
    DwGridEventCommands["add"] = "add";
    DwGridEventCommands["edit"] = "edit";
    DwGridEventCommands["delete"] = "delete";
    DwGridEventCommands["export"] = "export";
    DwGridEventCommands["view"] = "view";
})(DwGridEventCommands || (DwGridEventCommands = {}));

var DwGridPinState;
(function (DwGridPinState) {
    DwGridPinState["right"] = "right";
    DwGridPinState["left"] = "left";
})(DwGridPinState || (DwGridPinState = {}));

var DwSortDirection;
(function (DwSortDirection) {
    DwSortDirection["asc"] = "asc";
    DwSortDirection["desc"] = "desc";
})(DwSortDirection || (DwSortDirection = {}));

class DwSecurityCheckConfigDefaults {
}

class DwUserRegistrationExtensionBase {
    constructor() {
        this.dataChange = new EventEmitter();
        this.userRegistrationDataChange = new EventEmitter();
    }
    customValalidation(userRegistration, error) {
    }
}
DwUserRegistrationExtensionBase.ɵfac = function DwUserRegistrationExtensionBase_Factory(t) { return new (t || DwUserRegistrationExtensionBase)(); };
DwUserRegistrationExtensionBase.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwUserRegistrationExtensionBase, inputs: { data: "data" }, outputs: { dataChange: "dataChange", userRegistrationDataChange: "userRegistrationDataChange" } });
DwUserRegistrationExtensionBase.propDecorators = {
    data: [{ type: Input }],
    dataChange: [{ type: Output }],
    userRegistrationDataChange: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUserRegistrationExtensionBase, [{
        type: Directive
    }], function () { return []; }, { dataChange: [{
            type: Output
        }], userRegistrationDataChange: [{
            type: Output
        }], data: [{
            type: Input
        }] }); })();

const DwFontAwesomeIconSet = {
    iconSetName: 'Font Awesome 5',
    iconTypes: [
        {
            typeName: 'regular',
            iconPrefixClass: 'far'
        },
        {
            typeName: 'solid',
            iconPrefixClass: 'fas'
        },
        {
            typeName: 'light',
            iconPrefixClass: 'fal'
        },
        {
            typeName: 'duotone',
            iconPrefixClass: 'fad'
        },
        {
            typeName: 'brands',
            iconPrefixClass: 'fab',
            hide: true
        },
    ],
    defaultIconType: 'regular',
    icons: []
};
var FontAwesomeIconTypes;
(function (FontAwesomeIconTypes) {
    FontAwesomeIconTypes["regular"] = "regular";
    FontAwesomeIconTypes["solid"] = "solid";
    FontAwesomeIconTypes["light"] = "light";
    FontAwesomeIconTypes["duo"] = "duo";
    FontAwesomeIconTypes["brand"] = "branchs";
})(FontAwesomeIconTypes || (FontAwesomeIconTypes = {}));
const icons = JSON.parse('[{"iconName":"500px","className":"fa-500px","iconTypes":["brands"]},{"iconName":"Abacus","className":"fa-abacus","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Accessible Icon","className":"fa-accessible-icon","iconTypes":["brands"]},{"iconName":"Accusoft","className":"fa-accusoft","iconTypes":["brands"]},{"iconName":"Acorn","className":"fa-acorn","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Acquisitions Incorporated","className":"fa-acquisitions-incorporated","iconTypes":["brands"]},{"iconName":"Ad","className":"fa-ad","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Address Book","className":"fa-address-book","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Address Card","className":"fa-address-card","iconTypes":["solid","regular","light","duotone"]},{"iconName":"adjust","className":"fa-adjust","iconTypes":["solid","regular","light","duotone"]},{"iconName":"App.net","className":"fa-adn","iconTypes":["brands"]},{"iconName":"Adversal","className":"fa-adversal","iconTypes":["brands"]},{"iconName":"affiliatetheme","className":"fa-affiliatetheme","iconTypes":["brands"]},{"iconName":"Air Conditioner","className":"fa-air-conditioner","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Air Freshener","className":"fa-air-freshener","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Airbnb","className":"fa-airbnb","iconTypes":["brands"]},{"iconName":"Alarm Clock","className":"fa-alarm-clock","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alarm Exclamation","className":"fa-alarm-exclamation","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alarm Plus","className":"fa-alarm-plus","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alarm Snooze","className":"fa-alarm-snooze","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Album","className":"fa-album","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Album Collection","className":"fa-album-collection","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Algolia","className":"fa-algolia","iconTypes":["brands"]},{"iconName":"Alicorn","className":"fa-alicorn","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alien","className":"fa-alien","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alien Monster","className":"fa-alien-monster","iconTypes":["solid","regular","light","duotone"]},{"iconName":"align-center","className":"fa-align-center","iconTypes":["solid","regular","light","duotone"]},{"iconName":"align-justify","className":"fa-align-justify","iconTypes":["solid","regular","light","duotone"]},{"iconName":"align-left","className":"fa-align-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"align-right","className":"fa-align-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Align Slash","className":"fa-align-slash","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alipay","className":"fa-alipay","iconTypes":["brands"]},{"iconName":"Allergies","className":"fa-allergies","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Amazon","className":"fa-amazon","iconTypes":["brands"]},{"iconName":"Amazon Pay","className":"fa-amazon-pay","iconTypes":["brands"]},{"iconName":"ambulance","className":"fa-ambulance","iconTypes":["solid","regular","light","duotone"]},{"iconName":"American Sign Language Interpreting","className":"fa-american-sign-language-interpreting","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Amilia","className":"fa-amilia","iconTypes":["brands"]},{"iconName":"Guitar Amplifier","className":"fa-amp-guitar","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Analytics","className":"fa-analytics","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Anchor","className":"fa-anchor","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Android","className":"fa-android","iconTypes":["brands"]},{"iconName":"Angel","className":"fa-angel","iconTypes":["solid","regular","light","duotone"]},{"iconName":"AngelList","className":"fa-angellist","iconTypes":["brands"]},{"iconName":"Angle Double Down","className":"fa-angle-double-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Angle Double Left","className":"fa-angle-double-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Angle Double Right","className":"fa-angle-double-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Angle Double Up","className":"fa-angle-double-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"angle-down","className":"fa-angle-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"angle-left","className":"fa-angle-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"angle-right","className":"fa-angle-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"angle-up","className":"fa-angle-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Angry Face","className":"fa-angry","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Angry Creative","className":"fa-angrycreative","iconTypes":["brands"]},{"iconName":"Angular","className":"fa-angular","iconTypes":["brands"]},{"iconName":"Ankh","className":"fa-ankh","iconTypes":["solid","regular","light","duotone"]},{"iconName":"App Store","className":"fa-app-store","iconTypes":["brands"]},{"iconName":"iOS App Store","className":"fa-app-store-ios","iconTypes":["brands"]},{"iconName":"Apper Systems AB","className":"fa-apper","iconTypes":["brands"]},{"iconName":"Apple","className":"fa-apple","iconTypes":["brands"]},{"iconName":"Fruit Apple","className":"fa-apple-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Apple Crate","className":"fa-apple-crate","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Apple Pay","className":"fa-apple-pay","iconTypes":["brands"]},{"iconName":"Archive","className":"fa-archive","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Archway","className":"fa-archway","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Circle Down","className":"fa-arrow-alt-circle-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Circle Left","className":"fa-arrow-alt-circle-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Circle Right","className":"fa-arrow-alt-circle-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Circle Up","className":"fa-arrow-alt-circle-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Down","className":"fa-arrow-alt-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow from Bottom","className":"fa-arrow-alt-from-bottom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow from Left","className":"fa-arrow-alt-from-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow from Right","className":"fa-arrow-alt-from-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow from Top","className":"fa-arrow-alt-from-top","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Left","className":"fa-arrow-alt-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Right","className":"fa-arrow-alt-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Square Down","className":"fa-arrow-alt-square-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Square Left","className":"fa-arrow-alt-square-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Square Right","className":"fa-arrow-alt-square-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Square Up","className":"fa-arrow-alt-square-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow to Bottom","className":"fa-arrow-alt-to-bottom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow to Left","className":"fa-arrow-alt-to-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow to Right","className":"fa-arrow-alt-to-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow to Top","className":"fa-arrow-alt-to-top","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrow Up","className":"fa-arrow-alt-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Circle Down","className":"fa-arrow-circle-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Circle Left","className":"fa-arrow-circle-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Circle Right","className":"fa-arrow-circle-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Circle Up","className":"fa-arrow-circle-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"arrow-down","className":"fa-arrow-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow from Bottom","className":"fa-arrow-from-bottom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow from Left","className":"fa-arrow-from-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow from Right","className":"fa-arrow-from-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow from Top","className":"fa-arrow-from-top","iconTypes":["solid","regular","light","duotone"]},{"iconName":"arrow-left","className":"fa-arrow-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"arrow-right","className":"fa-arrow-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Square Down","className":"fa-arrow-square-down","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Square Left","className":"fa-arrow-square-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Square Right","className":"fa-arrow-square-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow Square Up","className":"fa-arrow-square-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow to Bottom","className":"fa-arrow-to-bottom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow to Left","className":"fa-arrow-to-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow to Right","className":"fa-arrow-to-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrow to Top","className":"fa-arrow-to-top","iconTypes":["solid","regular","light","duotone"]},{"iconName":"arrow-up","className":"fa-arrow-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrows","className":"fa-arrows","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrows","className":"fa-arrows-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrows Horizontal","className":"fa-arrows-alt-h","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Arrows Vertical","className":"fa-arrows-alt-v","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrows Horizontal","className":"fa-arrows-h","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Arrows Vertical","className":"fa-arrows-v","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Artstation","className":"fa-artstation","iconTypes":["brands"]},{"iconName":"Assistive Listening Systems","className":"fa-assistive-listening-systems","iconTypes":["solid","regular","light","duotone"]},{"iconName":"asterisk","className":"fa-asterisk","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Asymmetrik, Ltd.","className":"fa-asymmetrik","iconTypes":["brands"]},{"iconName":"At","className":"fa-at","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Atlas","className":"fa-atlas","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Atlassian","className":"fa-atlassian","iconTypes":["brands"]},{"iconName":"Atom","className":"fa-atom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Atom Alt","className":"fa-atom-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Audible","className":"fa-audible","iconTypes":["brands"]},{"iconName":"Audio Description","className":"fa-audio-description","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Autoprefixer","className":"fa-autoprefixer","iconTypes":["brands"]},{"iconName":"avianex","className":"fa-avianex","iconTypes":["brands"]},{"iconName":"Aviato","className":"fa-aviato","iconTypes":["brands"]},{"iconName":"Award","className":"fa-award","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Amazon Web Services (AWS)","className":"fa-aws","iconTypes":["brands"]},{"iconName":"Axe","className":"fa-axe","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Axe Battle","className":"fa-axe-battle","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Baby","className":"fa-baby","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Baby Carriage","className":"fa-baby-carriage","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Backpack","className":"fa-backpack","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Backspace","className":"fa-backspace","iconTypes":["solid","regular","light","duotone"]},{"iconName":"backward","className":"fa-backward","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bacon","className":"fa-bacon","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bacteria","className":"fa-bacteria","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bacterium","className":"fa-bacterium","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Badge","className":"fa-badge","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Check Badge","className":"fa-badge-check","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Badge Dollar","className":"fa-badge-dollar","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Badge Percent","className":"fa-badge-percent","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Sheriff Badge","className":"fa-badge-sheriff","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Honey Badger","className":"fa-badger-honey","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Shopping Bags","className":"fa-bags-shopping","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bahá","className":"fa-bahai","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Balance Scale","className":"fa-balance-scale","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Balance Scale (Left-Weighted)","className":"fa-balance-scale-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Balance Scale (Right-Weighted)","className":"fa-balance-scale-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Ball Pile","className":"fa-ball-pile","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Ballot","className":"fa-ballot","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Ballot Check","className":"fa-ballot-check","iconTypes":["solid","regular","light","duotone"]},{"iconName":"ban","className":"fa-ban","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Band-Aid","className":"fa-band-aid","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bandcamp","className":"fa-bandcamp","iconTypes":["brands"]},{"iconName":"Banjo","className":"fa-banjo","iconTypes":["solid","regular","light","duotone"]},{"iconName":"barcode","className":"fa-barcode","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Barcode","className":"fa-barcode-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Barcode Read","className":"fa-barcode-read","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Barcode Scan","className":"fa-barcode-scan","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bars","className":"fa-bars","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Baseball","className":"fa-baseball","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Baseball Ball","className":"fa-baseball-ball","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Basketball Ball","className":"fa-basketball-ball","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Basketball Hoop","className":"fa-basketball-hoop","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bat","className":"fa-bat","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bath","className":"fa-bath","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery Bolt","className":"fa-battery-bolt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery Empty","className":"fa-battery-empty","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery Full","className":"fa-battery-full","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery 1/2 Full","className":"fa-battery-half","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery 1/4 Full","className":"fa-battery-quarter","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery Slash","className":"fa-battery-slash","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battery 3/4 Full","className":"fa-battery-three-quarters","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Battle.net","className":"fa-battle-net","iconTypes":["brands"]},{"iconName":"Bed","className":"fa-bed","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Bed","className":"fa-bed-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bunkbed","className":"fa-bed-bunk","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bed Empty","className":"fa-bed-empty","iconTypes":["solid","regular","light","duotone"]},{"iconName":"beer","className":"fa-beer","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Behance","className":"fa-behance","iconTypes":["brands"]},{"iconName":"Behance Square","className":"fa-behance-square","iconTypes":["brands"]},{"iconName":"bell","className":"fa-bell","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bell Exclamation","className":"fa-bell-exclamation","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bell On","className":"fa-bell-on","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bell Plus","className":"fa-bell-plus","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bell School","className":"fa-bell-school","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bell School Slash","className":"fa-bell-school-slash","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bell Slash","className":"fa-bell-slash","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bells","className":"fa-bells","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Betamax","className":"fa-betamax","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bezier Curve","className":"fa-bezier-curve","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bible","className":"fa-bible","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bicycle","className":"fa-bicycle","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Biking","className":"fa-biking","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Biking Mountain","className":"fa-biking-mountain","iconTypes":["solid","regular","light","duotone"]},{"iconName":"BIMobject","className":"fa-bimobject","iconTypes":["brands"]},{"iconName":"Binoculars","className":"fa-binoculars","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Biohazard","className":"fa-biohazard","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Birthday Cake","className":"fa-birthday-cake","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bitbucket","className":"fa-bitbucket","iconTypes":["brands"]},{"iconName":"Bitcoin","className":"fa-bitcoin","iconTypes":["brands"]},{"iconName":"Bity","className":"fa-bity","iconTypes":["brands"]},{"iconName":"Font Awesome Black Tie","className":"fa-black-tie","iconTypes":["brands"]},{"iconName":"BlackBerry","className":"fa-blackberry","iconTypes":["brands"]},{"iconName":"Blanket","className":"fa-blanket","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blender","className":"fa-blender","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blender Phone","className":"fa-blender-phone","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blind","className":"fa-blind","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blinds","className":"fa-blinds","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blinds Open","className":"fa-blinds-open","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blinds Raised","className":"fa-blinds-raised","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blog","className":"fa-blog","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Blogger","className":"fa-blogger","iconTypes":["brands"]},{"iconName":"Blogger B","className":"fa-blogger-b","iconTypes":["brands"]},{"iconName":"Bluetooth","className":"fa-bluetooth","iconTypes":["brands"]},{"iconName":"Bluetooth","className":"fa-bluetooth-b","iconTypes":["brands"]},{"iconName":"bold","className":"fa-bold","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Lightning Bolt","className":"fa-bolt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bomb","className":"fa-bomb","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bone","className":"fa-bone","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bone Break","className":"fa-bone-break","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bong","className":"fa-bong","iconTypes":["solid","regular","light","duotone"]},{"iconName":"book","className":"fa-book","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Book","className":"fa-book-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Book of the Dead","className":"fa-book-dead","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Book with Heart","className":"fa-book-heart","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Medical Book","className":"fa-book-medical","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Book Open","className":"fa-book-open","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Book Reader","className":"fa-book-reader","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Book of Spells","className":"fa-book-spells","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Book with User","className":"fa-book-user","iconTypes":["solid","regular","light","duotone"]},{"iconName":"bookmark","className":"fa-bookmark","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Books","className":"fa-books","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Medical Books","className":"fa-books-medical","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Boombox","className":"fa-boombox","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Boot","className":"fa-boot","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Booth with Curtain","className":"fa-booth-curtain","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bootstrap","className":"fa-bootstrap","iconTypes":["brands"]},{"iconName":"Border All","className":"fa-border-all","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Bottom","className":"fa-border-bottom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Center - Horizontal","className":"fa-border-center-h","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Center - Vertical","className":"fa-border-center-v","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Inner","className":"fa-border-inner","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Left","className":"fa-border-left","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border None","className":"fa-border-none","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Outer","className":"fa-border-outer","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Right","className":"fa-border-right","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Style","className":"fa-border-style","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Style-alt","className":"fa-border-style-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Border Top","className":"fa-border-top","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bow Arrow","className":"fa-bow-arrow","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bowling Ball","className":"fa-bowling-ball","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bowling Pins","className":"fa-bowling-pins","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box","className":"fa-box","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Box","className":"fa-box-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box Ballot","className":"fa-box-ballot","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box Check","className":"fa-box-check","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box Fragile","className":"fa-box-fragile","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box Full","className":"fa-box-full","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box with Heart","className":"fa-box-heart","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box Open","className":"fa-box-open","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Tissue Box","className":"fa-box-tissue","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box Up","className":"fa-box-up","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Box with US Dollar","className":"fa-box-usd","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Boxes","className":"fa-boxes","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Alternate Boxes","className":"fa-boxes-alt","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Boxing Glove","className":"fa-boxing-glove","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Brackets","className":"fa-brackets","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Curly Brackets","className":"fa-brackets-curly","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Braille","className":"fa-braille","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Brain","className":"fa-brain","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Loaf of Bread","className":"fa-bread-loaf","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bread Slice","className":"fa-bread-slice","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Briefcase","className":"fa-briefcase","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Medical Briefcase","className":"fa-briefcase-medical","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bring Forward","className":"fa-bring-forward","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Bring Front","className":"fa-bring-front","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Broadcast Tower","className":"fa-broadcast-tower","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Broom","className":"fa-broom","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Browser","className":"fa-browser","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Brush","className":"fa-brush","iconTypes":["solid","regular","light","duotone"]},{"iconName":"BTC","className":"fa-btc","iconTypes":["brands"]},{"iconName":"Buffer","className":"fa-buffer","iconTypes":["brands"]},{"iconName":"Bug","className":"fa-bug","iconTypes":["solid","regular","light","duotone"]},{"iconName":"Building","className":"fa-building","iconTypes":["solid","regular","light","duotone"]},{"iconName":"bullhorn","className":"fa-bullhorn","iconTypes":["solid"]}]');
DwFontAwesomeIconSet.icons = icons;

function DwDatasource(dataSourceInfo) {
    return function (constructor) {
        let componentRef = Object.assign(Object.assign({}, dataSourceInfo), { dataSourceService: constructor });
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerDataSource(componentRef);
    };
}

class DwUiComponentReference {
}

class DefaultListStyle {
    constructor() {
        this.keyName = '';
        this.display = 'Default List style';
        this.order = 1;
        this.containerClass = 'dw-section-container';
        this.containerHeaderClass = 'dw-section-container-header';
        this.filterContainerClass = 'dw-section-container-filter';
    }
}

// DwDataValidationRule

;

class DwFaPublishActionService {
    constructor(dwModalService, dwFeatureAreaState, dwFeatureAreaRepositoryService) {
        this.dwModalService = dwModalService;
        this.dwFeatureAreaState = dwFeatureAreaState;
        this.dwFeatureAreaRepositoryService = dwFeatureAreaRepositoryService;
    }
    handleAction(gridState) {
        let data = ensureArray(gridState.data);
        if (data.length == 0) {
            // grid actions don't get the data passed, only grid row or context menu actions
            data = ensureArray(gridState.metaDataGridApi.getSelectedRows());
        }
        return this.showModal(gridState.gridConfig.itemName, data);
    }
    showModal(item, data) {
        let modalConfig = new DwModalConfig();
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.allowFullScreen = true;
        modalConfig.data = this.buildPublishModalArgs(item, data);
        ;
        modalConfig.component = DwFaPublishModalComponent;
        modalConfig.title = 'Publish Features';
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {
            const result = new DwGridActionResult();
            result.cancelled = modalResult.cancelled;
            result.success = true;
            return result;
        }));
    }
    buildPublishModalArgs(item, data) {
        const publishModalArgs = {
            itemName: item,
        };
        const ormData = ensureArray(data);
        if (ormData.length > 0) {
            const keyName = ormData[0]._keyName;
            if (keyName) {
                publishModalArgs.keyValues = ormData.map(d => d[keyName]);
            }
        }
        return publishModalArgs;
    }
}
DwFaPublishActionService.ɵfac = function DwFaPublishActionService_Factory(t) { return new (t || DwFaPublishActionService)(ɵngcc0.ɵɵinject(DwModalService), ɵngcc0.ɵɵinject(DwFeatureAreaStateService), ɵngcc0.ɵɵinject(DwFeatureAreaRepositoryService)); };
DwFaPublishActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwFaPublishActionService, factory: DwFaPublishActionService.ɵfac });
DwFaPublishActionService.ctorParameters = () => [
    { type: DwModalService },
    { type: DwFeatureAreaStateService },
    { type: DwFeatureAreaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFaPublishActionService, [{
        type: Injectable
    }], function () { return [{ type: DwModalService }, { type: DwFeatureAreaStateService }, { type: DwFeatureAreaRepositoryService }]; }, null); })();
DwActionFunc({
    keyName: 'dwFeatureAreasPublish',
    display: 'Feature Areas - Publish',
    actionType: DwActionType.gridAction,
    decoratorType: DwDecoratorType.service,
    parentItemName: DevwareMetaDataItemNames.DwFeatureArea,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Publish',
        iconClass: 'fa fa-upload',
        buttonClass: 'btn btn-primary',
        buttonTitle: 'Publishes Meta Data and UI changes'
    },
    defaultMenuConfig: {
        useParentDisplay: false,
        menuDisplay: 'Publsih',
        itemRequirement: DwActionItemRequirement.none,
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: false,
        permissionMeaning: DwSecurityPermissions.Ent_Admin_MetaDataCanAdmin,
        requireCanUpdate: false
    }
}, DwFaPublishActionService);

class DwExportCompareResultViewerComponent {
    constructor() {
        this.showAllItems = false;
    }
    ngOnInit() {
        if (!this.compareResult) {
            this.compareResult = this.importResults.FeatureAreaCompareResult[0].CompareResult;
        }
    }
    selectRow(itemResult) {
        this.selectedItemResult = itemResult;
        const itemRowChanges = {
            attributeList: [],
            rowChanges: []
        };
        for (let rowChange of this.selectedItemResult.RowChanges) {
            const rowChangeModel = {
                keyValue: rowChange.KeyValue,
                rowChange: rowChange,
                attrChanges: {}
            };
            for (let attrChange of rowChange.AttrChanges) {
                if (itemRowChanges.attributeList.indexOf(attrChange.AttributeName) == -1) {
                    itemRowChanges.attributeList.push(attrChange.AttributeName);
                }
                rowChangeModel.attrChanges[attrChange.AttributeName] = attrChange;
            }
            itemRowChanges.rowChanges.push(rowChangeModel);
        }
        this.itemRowChanges = itemRowChanges;
    }
}
DwExportCompareResultViewerComponent.ɵfac = function DwExportCompareResultViewerComponent_Factory(t) { return new (t || DwExportCompareResultViewerComponent)(); };
DwExportCompareResultViewerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwExportCompareResultViewerComponent, selectors: [["dw-export-compare-result-viewer"]], inputs: { compareResult: "compareResult", importResults: "importResults" }, decls: 25, vars: 4, consts: [[1, "simple-table"], [1, "width-30"], [1, "width-10"], [1, "scrolling-grid-small"], [3, "hidden", "click", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "hidden", "click"], [1, "width-15"], ["class", "width-15", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], [1, "fa", "fa-exclamation-triangle", "dw-red", 3, "hidden", "title"]], template: function DwExportCompareResultViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
        ɵngcc0.ɵɵelement(1, "Br");
        ɵngcc0.ɵɵelement(2, "br");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementStart(4, "table", 0);
        ɵngcc0.ɵɵelementStart(5, "thead");
        ɵngcc0.ɵɵelementStart(6, "th", 1);
        ɵngcc0.ɵɵtext(7, " Table ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "th", 2);
        ɵngcc0.ɵɵtext(9, " Total Changes ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "th", 2);
        ɵngcc0.ɵɵtext(11, " Source Rows ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "th", 2);
        ɵngcc0.ɵɵtext(13, " Dest Rows ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "th", 2);
        ɵngcc0.ɵɵtext(15, " Creates ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "th", 2);
        ɵngcc0.ɵɵtext(17, " Updates ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "th", 2);
        ɵngcc0.ɵɵtext(19, " Deletes ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 3);
        ɵngcc0.ɵɵelementStart(21, "table", 0);
        ɵngcc0.ɵɵelementStart(22, "tbody");
        ɵngcc0.ɵɵtemplate(23, DwExportCompareResultViewerComponent_tr_23_Template, 15, 8, "tr", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(24, DwExportCompareResultViewerComponent_div_24_Template, 12, 2, "div", 5);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate1("Compare Results for Group ", ctx.compareResult.GroupName, "");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.compareResult.ChangeCount, " Total Changes ");
        ɵngcc0.ɵɵadvance(20);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.compareResult.ItemResults);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedItemResult);
    } }, directives: [ɵngcc4.NgForOf, ɵngcc4.NgIf], styles: [""] });
DwExportCompareResultViewerComponent.ctorParameters = () => [];
DwExportCompareResultViewerComponent.propDecorators = {
    importResults: [{ type: Input }],
    compareResult: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwExportCompareResultViewerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-export-compare-result-viewer',
                template: "Compare Results for Group {{compareResult.GroupName}}<Br>\r\n\r\n<br>\r\n\r\n{{compareResult.ChangeCount}} Total Changes\r\n\r\n<table class=\"simple-table\">\r\n    <thead>\r\n        <th class=\"width-30\">\r\n            Table\r\n        </th>\r\n        <th class=\"width-10\">\r\n            Total Changes\r\n        </th>\r\n        <th class=\"width-10\">\r\n            Source Rows\r\n        </th>\r\n        <th class=\"width-10\">\r\n            Dest Rows\r\n        </th>\r\n        <th class=\"width-10\">\r\n            Creates\r\n        </th>\r\n        <th class=\"width-10\">\r\n            Updates\r\n        </th>\r\n        <th class=\"width-10\">\r\n            Deletes\r\n        </th>\r\n    </thead>\r\n</table>\r\n<div class=\"scrolling-grid-small\">\r\n    <table class=\"simple-table\">\r\n        <tbody>\r\n            <tr *ngFor=\"let itemResult of compareResult.ItemResults\" [hidden]=\"!(itemResult.RowChanges?.length > 0) && !showAllItems\" (click)=\"selectRow(itemResult)\">\r\n                <td class=\"width-30\">\r\n                    {{itemResult.ItemName}}\r\n                </td>\r\n                <td class=\"width-10\">\r\n                    {{itemResult.RowChanges?.length}}\r\n                </td>\r\n                <td class=\"width-10\">\r\n                    {{itemResult.SourceRows}}\r\n                </td>\r\n                <td class=\"width-10\">\r\n                    {{itemResult.DestRows}}\r\n                </td>\r\n                <td class=\"width-10\">\r\n                    {{itemResult.Inserts}}\r\n                </td>\r\n                <td class=\"width-10\">\r\n                    {{itemResult.Updates}}\r\n                </td>\r\n                <td class=\"width-10\">\r\n                    {{itemResult.Deletes}}\r\n                </td>\r\n            </tr>\r\n        </tbody>\r\n    </table>\r\n</div>\r\n\r\n<div *ngIf=\"selectedItemResult\">\r\n\r\n    <table class=\"simple-table\">\r\n        <thead >\r\n            <th class=\"width-15\">Key Value</th>\r\n            <th class=\"width-15\" *ngFor=\"let attr of itemRowChanges.attributeList\">\r\n                {{attr}}\r\n            </th>  \r\n            <th class=\"width-15\">\r\n                Save Type\r\n            </th>\r\n        </thead>\r\n    </table>\r\n    <div class=\"scrolling-grid-small\">\r\n        <table class=\"simple-table\">\r\n            <tbody>\r\n                <tr *ngFor=\"let rowChangeModel of itemRowChanges.rowChanges\">\r\n\r\n                    <td class=\"width-15\">{{rowChangeModel.keyValue}}</td>\r\n                    <td class=\"width-15\" *ngFor=\"let attr of itemRowChanges.attributeList\">\r\n                        {{rowChangeModel.attrChanges[attr]?.PreviousValue }} ->\r\n                        {{rowChangeModel.attrChanges[attr]?.NewValue }}\r\n\r\n                        <i class=\"fa fa-exclamation-triangle dw-red\" [hidden]=\"!rowChangeModel.attrChanges[attr]?.Errors?.length>0\" [title]=\"rowChangeModel.attrChanges[attr]?.Errors[0]\">\r\n                        </i>\r\n                    </td> \r\n                    <td class=\"width-15\">\r\n                        {{rowChangeModel.rowChange.SaveType}}\r\n                    </td>\r\n                </tr>\r\n            </tbody>\r\n        </table>\r\n    </div>\r\n</div>",
                styles: [""]
            }]
    }], function () { return []; }, { compareResult: [{
            type: Input
        }], importResults: [{
            type: Input
        }] }); })();

const DwMediaConfigName = 'MediaConfig';
const DwMediaConfigToken = new InjectionToken(DwMediaConfigName);

// tslint:disable
var MediaMetaDataItemNames;
(function (MediaMetaDataItemNames) {
    MediaMetaDataItemNames["DwMedia"] = "dw_Media";
    MediaMetaDataItemNames["DwMediaDetail"] = "dw_MediaDetail";
    MediaMetaDataItemNames["DwMediaFileExtension"] = "dw_MediaFileExtension";
    MediaMetaDataItemNames["DwMediaFolder"] = "dw_MediaFolder";
    MediaMetaDataItemNames["DwMediaGroup"] = "dw_MediaGroup";
    MediaMetaDataItemNames["DwMediaSecurity"] = "dw_MediaSecurity";
    MediaMetaDataItemNames["DwMediaSizeType"] = "dw_MediaSizeType";
    MediaMetaDataItemNames["DwMediaStorageType"] = "dw_MediaStorageType";
    MediaMetaDataItemNames["DwMediaType"] = "dw_MediaType";
    MediaMetaDataItemNames["DwMediaTypeExtension"] = "dw_MediaTypeExtension";
    MediaMetaDataItemNames["DwRoMedia"] = "dw_roMedia";
})(MediaMetaDataItemNames || (MediaMetaDataItemNames = {}));
var MediaMetaDataLookups;
(function (MediaMetaDataLookups) {
    MediaMetaDataLookups["MediaAllItems"] = "dw_Media_All_Items";
    MediaMetaDataLookups["MediaDetailAllItems"] = "dw_MediaDetail_All_Items";
    MediaMetaDataLookups["MediaFileExtensionAllItems"] = "dw_MediaFileExtension_All_Items";
    MediaMetaDataLookups["MediaFolderAllItems"] = "dw_MediaFolder_All_Items";
    MediaMetaDataLookups["MediaGroupAllItems"] = "dw_MediaGroup_All_Items";
    MediaMetaDataLookups["MediaSecurityAllItems"] = "MediaSecurity_All_Items";
    MediaMetaDataLookups["MediaSizeTypeAllItems"] = "dw_MediaSizeType_All_Items";
    MediaMetaDataLookups["MediaStorageTypeAllItems"] = "dw_MediaStorageType_All_Items";
    MediaMetaDataLookups["MediaTypeAllItems"] = "dw_MediaType_All_Items";
    MediaMetaDataLookups["MediaTypeExtensionAllItems"] = "dw_MediaTypeExtension_All_Items";
    MediaMetaDataLookups["RoMediaAllItems"] = "dw_roMedia_All_Items";
})(MediaMetaDataLookups || (MediaMetaDataLookups = {}));
class MediaMetaDataService {
    constructor() {
        this.DwMedia = new DwMedia();
        this.DwMediaDetail = new DwMediaDetail();
        this.DwMediaFileExtension = new DwMediaFileExtension();
        this.DwMediaFolder = new DwMediaFolder();
        this.DwMediaGroup = new DwMediaGroup();
        this.DwMediaSecurity = new DwMediaSecurity();
        this.DwMediaSizeType = new DwMediaSizeType();
        this.DwMediaStorageType = new DwMediaStorageType();
        this.DwMediaType = new DwMediaType();
        this.DwMediaTypeExtension = new DwMediaTypeExtension();
        this.DwRoMedia = new DwRoMedia();
    }
}
MediaMetaDataService.ɵfac = function MediaMetaDataService_Factory(t) { return new (t || MediaMetaDataService)(); };
MediaMetaDataService.ɵprov = ɵɵdefineInjectable({ factory: function MediaMetaDataService_Factory() { return new MediaMetaDataService(); }, token: MediaMetaDataService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MediaMetaDataService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();
// Generated Classes for MetaData service
class DwMedia {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_Media.';
        // Attributes
        this.MediaId = this.i + 'MediaId';
        this.MediaName = this.i + 'MediaName';
        this.ContainerName = this.i + 'ContainerName';
        this.MediaTypeId = this.i + 'MediaTypeId';
        this.MediaStorageTypeId = this.i + 'MediaStorageTypeId';
        this.MediaGroupId = this.i + 'MediaGroupId';
        this.MediaFolderId = this.i + 'MediaFolderId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.IsSecure = this.i + 'IsSecure';
        this.IsDeleted = this.i + 'IsDeleted';
        this.Relations = {
            /** Relation: Ro Media */
            DwRoMedia: {
                RelationName: 'roMedia|Media|MediaId',
                FieldPrefix: 'DwroMedia',
                PropertyName: 'DwroMedia'
            },
            /** Relation: Media Group */
            DwMediaGroup: {
                RelationName: 'dw_MediaGroup|dw_Media|MediaGroupId',
                FieldPrefix: 'DwMediaGroup',
                PropertyName: 'DwMediaGroup'
            },
            /** Relation: Media Folder */
            DwMediaFolder: {
                RelationName: 'dw_MediaFolder|dw_Media|MediaFolderId',
                FieldPrefix: 'DwMediaFolder',
                PropertyName: 'DwMediaFolder'
            },
            /** Relation: Media Storage Type */
            DwMediaStorageType: {
                RelationName: 'dw_MediaStorageType|dw_Media|MediaStorageTypeId',
                FieldPrefix: 'DwMediaStorageType',
                PropertyName: 'DwMediaStorageType'
            },
            /** Relation: Media Detail */
            DwMediaDetail: {
                RelationName: 'dw_Media|dw_MediaDetail|MediaId',
                FieldPrefix: 'DwMediaDetail',
                PropertyName: 'DwMediaDetail'
            },
            /** Relation: Media Type2 */
            DwMediaType: {
                RelationName: 'dw_MediaType|dw_Media|MediaTypeId',
                FieldPrefix: 'DwMediaType',
                PropertyName: 'DwMediaType'
            },
        };
        this.ItemDetail.ItemId = 208;
        this.ItemDetail.ItemName = 'dw_Media';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaDetail {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaDetail.';
        // Attributes
        this.MediaDetailId = this.i + 'MediaDetailId';
        this.MediaId = this.i + 'MediaId';
        this.MediaSizeTypeId = this.i + 'MediaSizeTypeId';
        this.FileName = this.i + 'FileName';
        this.ImageWidth = this.i + 'ImageWidth';
        this.ImageHeight = this.i + 'ImageHeight';
        this.SizeInBytes = this.i + 'SizeInBytes';
        this.Version = this.i + 'Version';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Media */
            DwMedia: {
                RelationName: 'dw_Media|dw_MediaDetail|MediaId',
                FieldPrefix: 'DwMedia',
                PropertyName: 'DwMedia'
            },
            /** Relation: Media Size Type */
            DwMediaSizeType: {
                RelationName: 'dw_MediaSizeType|dw_MediaDetail|MediaSizeTypeId',
                FieldPrefix: 'DwMediaSizeType',
                PropertyName: 'DwMediaSizeType'
            },
        };
        this.ItemDetail.ItemId = 172;
        this.ItemDetail.ItemName = 'dw_MediaDetail';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaFileExtension {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaFileExtension.';
        // Attributes
        this.MediaFileExtensionId = this.i + 'MediaFileExtensionId';
        this.FileExtension = this.i + 'FileExtension';
        this.IconCss = this.i + 'IconCss';
        this.FileExtensionDescription = this.i + 'FileExtensionDescription';
        this.Relations = {
            /** Relation: Media Type Extension */
            DwMediaTypeExtension: {
                RelationName: 'dw_MediaFileExtension|dw_MediaTypeExtension|MediaFileExtensionId',
                FieldPrefix: 'DwMediaTypeExtension',
                PropertyName: 'DwMediaTypeExtension'
            },
        };
        this.ItemDetail.ItemId = 210;
        this.ItemDetail.ItemName = 'dw_MediaFileExtension';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaFolder {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaFolder.';
        // Attributes
        this.MediaFolderId = this.i + 'MediaFolderId';
        this.MediaGroupId = this.i + 'MediaGroupId';
        this.FolderName = this.i + 'FolderName';
        this.ParentMediaFolderId = this.i + 'ParentMediaFolderId';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Media */
            DwMedia: {
                RelationName: 'dw_MediaFolder|dw_Media|MediaFolderId',
                FieldPrefix: 'DwMedia',
                PropertyName: 'DwMedia'
            },
            /** Relation: Media Group */
            DwMediaGroup: {
                RelationName: 'dw_MediaGroup|dw_MediaFolder|MediaGroupId',
                FieldPrefix: 'DwMediaGroup',
                PropertyName: 'DwMediaGroup'
            },
        };
        this.ItemDetail.ItemId = 184;
        this.ItemDetail.ItemName = 'dw_MediaFolder';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaGroup {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaGroup.';
        // Attributes
        this.MediaGroupId = this.i + 'MediaGroupId';
        this.PartyReferenceId = this.i + 'PartyReferenceId';
        this.IsGlobalGroup = this.i + 'IsGlobalGroup';
        this.GroupName = this.i + 'GroupName';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.IsSecure = this.i + 'IsSecure';
        this.Relations = {
            /** Relation: Ro Media */
            DwRoMedia: {
                RelationName: 'MediaGroup_roMedia',
                FieldPrefix: 'DwroMedia',
                PropertyName: 'DwroMedia'
            },
            /** Relation: Media */
            DwMedia: {
                RelationName: 'dw_MediaGroup|dw_Media|MediaGroupId',
                FieldPrefix: 'DwMedia',
                PropertyName: 'DwMedia'
            },
            /** Relation: Media Folder */
            DwMediaFolder: {
                RelationName: 'dw_MediaGroup|dw_MediaFolder|MediaGroupId',
                FieldPrefix: 'DwMediaFolder',
                PropertyName: 'DwMediaFolder'
            },
        };
        this.ItemDetail.ItemId = 176;
        this.ItemDetail.ItemName = 'dw_MediaGroup';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaSecurity {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaSecurity.';
        // Attributes
        this.MediaSecurityId = this.i + 'MediaSecurityId';
        this.MetaDataItemId = this.i + 'MetaDataItemId';
        this.MediaMetaDataAttributeId = this.i + 'MediaMetaDataAttributeId';
        this.AllowEmulation = this.i + 'AllowEmulation';
        this.ViewAllPermissionMeaning = this.i + 'ViewAllPermissionMeaning';
        this.CheckParentTable = this.i + 'CheckParentTable';
        this.Relations = {};
        this.ItemDetail.ItemId = 3749;
        this.ItemDetail.ItemName = 'dw_MediaSecurity';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaSizeType {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaSizeType.';
        // Attributes
        this.MediaSizeTypeId = this.i + 'MediaSizeTypeId';
        this.MediaSizeType = this.i + 'MediaSizeType';
        this.MaxWidth = this.i + 'MaxWidth';
        this.MaxHeight = this.i + 'MaxHeight';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Media Detail */
            DwMediaDetail: {
                RelationName: 'dw_MediaSizeType|dw_MediaDetail|MediaSizeTypeId',
                FieldPrefix: 'DwMediaDetail',
                PropertyName: 'DwMediaDetail'
            },
        };
        this.ItemDetail.ItemId = 169;
        this.ItemDetail.ItemName = 'dw_MediaSizeType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaStorageType {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaStorageType.';
        // Attributes
        this.MediaStorageTypeId = this.i + 'MediaStorageTypeId';
        this.MediaStorageType = this.i + 'MediaStorageType';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Media */
            DwMedia: {
                RelationName: 'dw_MediaStorageType|dw_Media|MediaStorageTypeId',
                FieldPrefix: 'DwMedia',
                PropertyName: 'DwMedia'
            },
        };
        this.ItemDetail.ItemId = 212;
        this.ItemDetail.ItemName = 'dw_MediaStorageType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaType {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaType.';
        // Attributes
        this.MediaTypeId = this.i + 'MediaTypeId';
        this.MediaType = this.i + 'MediaType';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.ModifiedBy = this.i + 'ModifiedBy';
        this.ModifiedDateTime = this.i + 'ModifiedDateTime';
        this.Relations = {
            /** Relation: Media */
            DwMedia: {
                RelationName: 'dw_MediaType|dw_Media|MediaTypeId',
                FieldPrefix: 'DwMedia',
                PropertyName: 'DwMedia'
            },
            /** Relation: Media Type Extension */
            DwMediaTypeExtension: {
                RelationName: 'dw_MediaType|dw_MediaTypeExtension|MediaTypeId',
                FieldPrefix: 'DwMediaTypeExtension',
                PropertyName: 'DwMediaTypeExtension'
            },
        };
        this.ItemDetail.ItemId = 188;
        this.ItemDetail.ItemName = 'dw_MediaType';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwMediaTypeExtension {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_MediaTypeExtension.';
        // Attributes
        this.MediaTypeExtensionId = this.i + 'MediaTypeExtensionId';
        this.MediaTypeId = this.i + 'MediaTypeId';
        this.MediaFileExtensionId = this.i + 'MediaFileExtensionId';
        this.Relations = {
            /** Relation: Media File Extension */
            DwMediaFileExtension: {
                RelationName: 'dw_MediaFileExtension|dw_MediaTypeExtension|MediaFileExtensionId',
                FieldPrefix: 'DwMediaFileExtension',
                PropertyName: 'DwMediaFileExtension'
            },
            /** Relation: Media Type2 */
            DwMediaType: {
                RelationName: 'dw_MediaType|dw_MediaTypeExtension|MediaTypeId',
                FieldPrefix: 'DwMediaType',
                PropertyName: 'DwMediaType'
            },
        };
        this.ItemDetail.ItemId = 213;
        this.ItemDetail.ItemName = 'dw_MediaTypeExtension';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}
class DwRoMedia {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_roMedia.';
        // Attributes
        this.MediaId = this.i + 'MediaId';
        this.MediaName = this.i + 'MediaName';
        this.MediaTypeId = this.i + 'MediaTypeId';
        this.ContainerName = this.i + 'ContainerName';
        this.FileName = this.i + 'FileName';
        this.MediaSizeTypeId = this.i + 'MediaSizeTypeId';
        this.ImageWidth = this.i + 'ImageWidth';
        this.ImageHeight = this.i + 'ImageHeight';
        this.MediaSizeType = this.i + 'MediaSizeType';
        this.SizeInBytes = this.i + 'SizeInBytes';
        this.Version = this.i + 'Version';
        this.MediaPath = this.i + 'MediaPath';
        this.IsSecure = this.i + 'IsSecure';
        this.CreatedBy = this.i + 'CreatedBy';
        this.CreatedDateTime = this.i + 'CreatedDateTime';
        this.MediaGroupId = this.i + 'MediaGroupId';
        this.MediaFolderId = this.i + 'MediaFolderId';
        this.IsDeleted = this.i + 'IsDeleted';
        this.Relations = {
            /** Relation: Media Group */
            DwMediaGroup: {
                RelationName: 'MediaGroup_roMedia',
                FieldPrefix: 'DwMediaGroup',
                PropertyName: 'DwMediaGroup'
            },
            /** Relation: Media */
            DwMedia: {
                RelationName: 'roMedia|Media|MediaId',
                FieldPrefix: 'DwMedia',
                PropertyName: 'DwMedia'
            },
        };
        this.ItemDetail.ItemId = 202;
        this.ItemDetail.ItemName = 'dw_roMedia';
    }
    CreateQuery() {
        return new DwQuery(this.ItemDetail.ItemName);
    }
}

//import { DwFileUtilService } from './dw-file-util.service';
class DwMediaRepositoryService {
    constructor(http, dwOrmDataService, configService, dwMediaConfig, dwMetaDataService, dwUserSecurityService) {
        var _a, _b, _c;
        this.http = http;
        this.dwOrmDataService = dwOrmDataService;
        this.configService = configService;
        this.dwMediaConfig = dwMediaConfig;
        this.dwMetaDataService = dwMetaDataService;
        this.dwUserSecurityService = dwUserSecurityService;
        // Setup storage to use
        this.mediaApi = `${configService.coreConfig.apiRoot}/media`;
        this.mediaUploadApi = this.mediaApi;
        if (((_a = dwMediaConfig.cdnSettings) === null || _a === void 0 ? void 0 : _a.useCDN) && ((_b = dwMediaConfig.cdnSettings) === null || _b === void 0 ? void 0 : _b.cdnUrl)) {
            this.mediaApi = `${(_c = dwMediaConfig.cdnSettings) === null || _c === void 0 ? void 0 : _c.cdnUrl}/media`;
        }
    }
    uploadFiles(fileDetails, mediaGroupId, isSecure, mediaSizes, concurrentUploads = 3) {
        const mediaUploadResults = [];
        const resultSubject = new Subject();
        const uploadSubjects = new Subject();
        for (const fileDetail of fileDetails) {
            const uploadResult = {
                isPending: true,
                isComplete: false,
                percentComplete: 0,
                fileName: fileDetail.resizedFile ? fileDetail.resizedFile.name : fileDetail.file.name
            };
            if (fileDetail.cancelled) {
                uploadResult.isComplete = true;
            }
            mediaUploadResults.push(uploadResult);
        }
        uploadSubjects.asObservable().pipe(mergeMap(fileDetail => {
            const mediaInfo = this.createMediaInfo(fileDetail, mediaGroupId, isSecure, mediaSizes);
            const index = fileDetails.indexOf(fileDetail);
            return this.uploadFile(mediaInfo, fileDetail.resizedFile || fileDetail.file, fileDetail.cancellationSubject.asObservable());
        }, concurrentUploads)).subscribe(result => {
            const existingResult = mediaUploadResults.find(r => r.fileName == result.fileName);
            // deepCopyToObject(result, existingResult);
            const index = mediaUploadResults.indexOf(existingResult);
            // replace result
            mediaUploadResults[index] = result;
            resultSubject.next([...mediaUploadResults]);
        });
        for (const fileDetail of fileDetails) {
            if (!fileDetail.cancelled) {
                uploadSubjects.next(fileDetail);
            }
        }
        return resultSubject.asObservable();
    }
    getFileExtensions() {
        return this.dwMetaDataService.getLookup(MediaMetaDataLookups.MediaFileExtensionAllItems)
            .pipe(map(lookupList => {
            return lookupList.map(li => li);
        }));
    }
    createMediaInfo(fileDetail, mediaGroupId, isSecure, mediaSizes) {
        const mediaInfo = {
            FileName: fileDetail.file.name,
            MediaGroupId: mediaGroupId,
            MediaName: fileDetail.file.name,
            IsSecure: isSecure,
            MediaSizes: mediaSizes,
            MediaKey: null
        };
        return mediaInfo;
    }
    uploadFile(mediaInfo, file, cancellationTokenOb) {
        const url = `${this.mediaUploadApi}/upload`;
        const formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('mediaInfo', JSON.stringify(mediaInfo));
        let headers = new HttpHeaders();
        headers = headers.set('contentTypeOverride', 'multipart/form-data');
        headers = headers.append(SuppressErrorMessagesHeader, 'true');
        // If no cancellation token, just create a noop version
        if (!cancellationTokenOb) {
            cancellationTokenOb = new Subject().asObservable();
        }
        return this.http.post(url, formData, { reportProgress: true, observe: 'events', headers: headers })
            .pipe(map(event => {
            const uploadResult = {
                isComplete: false,
                isPending: false,
                fileName: file.name
            };
            switch (event.type) {
                case HttpEventType.UploadProgress:
                    uploadResult.percentComplete = Math.round(100 * event.loaded / event.total);
                    break;
                case HttpEventType.Response:
                    uploadResult.isComplete = true;
                    uploadResult.uploadResult = event.body;
                    break;
                default:
                // Other events
            }
            return uploadResult;
        }), catchError(errResponse => {
            const errorDetails = getErrorDetails(errResponse);
            const uploadResult = {
                isComplete: false,
                isPending: false,
                isError: true,
                errorMessage: 'Error uploading file: ' + (errorDetails === null || errorDetails === void 0 ? void 0 : errorDetails.message) || (errResponse === null || errResponse === void 0 ? void 0 : errResponse.message),
                fileName: file.name
            };
            return of(uploadResult);
        }), takeUntil(cancellationTokenOb));
    }
    loadMedia(mediaIds) {
        mediaIds = ensureArray(mediaIds, true);
        if (!Array.isArray(mediaIds)) {
            if (!mediaIds) {
                return of([]);
            }
            mediaIds = [mediaIds];
        }
        if (mediaIds.length == 0) {
            return of([]);
        }
        const md = new MediaMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwRoMedia.CreateQuery();
        let hasMediaIds = false;
        if (mediaIds.length == 0) {
            return of([]);
        }
        query.AddFilterAnd(qh.filters.InList(md.DwRoMedia.MediaId, mediaIds));
        return this.dwOrmDataService.executeQuery(query);
    }
    getImageUrlFromMediaPath(mediaPath, width, height) {
        // Adjust image size for pixel ratio
        let url = `${this.mediaApi}/download/${mediaPath}`;
        if (width && height) {
            width = Math.round(width * window.devicePixelRatio);
            height = Math.round(height * window.devicePixelRatio);
            url += `?width=${width}&height=${height}`;
        }
        return url;
    }
    deleteMedia(mediaIds) {
        var media = mediaIds.map(id => {
            const media = {
                MediaId: id,
                IsDeleted: true,
                _itemName: MediaMetaDataItemNames.DwMedia
                //IsDeleted: true
            };
            return media;
        });
        return this.dwOrmDataService.saveEntityCollection(media);
    }
    createMediaGroup(groupName, isSecure) {
        const mediaGroup = {
            GroupName: groupName,
            IsSecure: isSecure,
            _itemName: DevwareMetaDataItemNames.DwMediaGroup
        };
        return this.dwOrmDataService.saveEntity(mediaGroup, false);
    }
    loadMediaGroup(mediaGroupId, includeFolders = false) {
        const md = new MediaMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwMediaGroup.CreateQuery();
        query.AddFilterAnd(qh.filters.Equal(md.DwMediaGroup.MediaGroupId, mediaGroupId));
        query.AddPrefetchPath(md.DwMediaGroup.Relations.DwRoMedia);
        if (includeFolders) {
            query.AddPrefetchPath(md.DwMediaGroup.Relations.DwMediaFolder);
        }
        return this.dwOrmDataService.executeQuerySingle(query);
    }
    loadMediaSecurity(itemId) {
        const md = new MediaMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwMediaSecurity.CreateQuery();
        query.AddFilterAnd(qh.filters.Equal(md.DwMediaSecurity.MetaDataItemId, itemId));
        return this.dwOrmDataService.executeQuery(query);
    }
    downloadFile(url, filename) {
        this.http.get(url, { responseType: 'blob' })
            .subscribe(fileBlob => {
            // Create a new blob with the binary data
            saveAs(fileBlob, filename);
        });
    }
    parseErrorBlob(err) {
        const reader = new FileReader();
        const obs = new Observable((observer) => {
            reader.onloadend = (e) => {
                observer.error(JSON.parse(reader.result));
                observer.complete();
            };
        });
        reader.readAsText(err.error);
        return obs;
    }
    downloadMedia(roMedia, isSecureGroup = false, isSecure = false, parentItemName, parentAttrName, downloadFileName) {
        let fileUrl = this.getImageUrl(roMedia.ContainerName, roMedia.FileName, roMedia.MediaDetailKey, isSecureGroup, null, null, null, isSecure, roMedia.MediaId, parentItemName, parentAttrName);
        const fileExt = this.getFileExtension(roMedia.FileName);
        let fileName = downloadFileName || `${roMedia.MediaName}.${fileExt}`;
        this.downloadFile(fileUrl, fileName);
    }
    getFileExtension(fileName) {
        var re = /(?:\.([^.]+))?$/;
        fileName = fileName.toLowerCase();
        var ext = re.exec(fileName)[1]; // "txt"
        return ext;
    }
    downloadMediaFromMediaId(mediaId, isSecureGroup = false, isSecure = false, itemName, attrName) {
        return this.loadMedia(mediaId)
            .pipe(map(media => {
            if (media.length > 0) {
                this.downloadMedia(media[0], isSecureGroup, isSecure, itemName, attrName);
            }
            return media;
        }));
    }
    getImageUrl(containerName, fileName, mediaDetailKey, isSecureGroup, width, height, quality, isSecure, mediaId, parentItemName, parentAttrName) {
        // Note: Updated 7/27/21 to use path instead of params for containerName and fileName
        let imageUrl = `${this.mediaApi}/download/${containerName}/${fileName}`;
        let params = [];
        if (mediaDetailKey) {
            params.push(`mediaDetailKey=${mediaDetailKey}`);
        }
        if (width) {
            params.push(`width=${width}`);
            //imageUrl += `&width=${width}`;
        }
        if (height) {
            params.push(`height=${height}`);
            //imageUrl += `&height=${height}`;
        }
        if (quality) {
            params.push(`quality=${quality}`);
        }
        if (isSecure) {
            params.push(`isSecure=${isSecure}`);
            params.push(`isSecureGroup=${isSecureGroup}`);
            params.push(`mediaId=${mediaId}`);
            params.push(`parentItemName=${parentItemName}`);
            params.push(`parentAttributeName=${parentAttrName}`);
            // Add the security token
            params.push(`Authorization=${this.dwUserSecurityService.securityContext.SecurityToken}`);
        }
        if (params.length > 0) {
            imageUrl = `${imageUrl}?${params.join('&')}`;
        }
        return encodeURI(imageUrl);
        // return imageUrl;
    }
}
DwMediaRepositoryService.ɵfac = function DwMediaRepositoryService_Factory(t) { return new (t || DwMediaRepositoryService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwConfigServiceToken), ɵngcc0.ɵɵinject(DwMediaConfigToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwMediaRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwMediaRepositoryService_Factory() { return new DwMediaRepositoryService(ɵɵinject(HttpClient), ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwConfigServiceToken), ɵɵinject(DwMediaConfigToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwSecurityUserService)); }, token: DwMediaRepositoryService, providedIn: "root" });
DwMediaRepositoryService.ctorParameters = () => [
    { type: HttpClient },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwMediaConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwSecurityUserService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMediaRepositoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwMediaConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwSecurityUserService }]; }, null); })();

class DwFileUtilService {
    constructor(dwMediaConfig, dwMediaRepositoryService, sanitizer) {
        this.dwMediaConfig = dwMediaConfig;
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.sanitizer = sanitizer;
    }
    isExtensionMatch(fileName, extensionList) {
        const fileExtensions = extensionList.toLowerCase().split(',');
        const fileExt = this.getFileExtension(fileName);
        const isValid = fileExtensions.find(fe => fe == fileExt || fe == `.${fileExt}`);
        return !!isValid;
    }
    getMediaFileName(media) {
        const fileExt = this.getFileExtension(media.FileName);
        return `${media.MediaName}.${fileExt}`;
    }
    getFileExtension(fileName) {
        var re = /(?:\.([^.]+))?$/;
        fileName = fileName.toLowerCase();
        var ext = re.exec(fileName)[1]; // "txt"
        return ext;
    }
    buildFileDetails(files, validExtensionList, maxFileSizeBytes) {
        const fileDetails = [];
        if (!files) {
            return of(fileDetails);
        }
        let filesArray = [];
        if (files instanceof FileList) {
            filesArray = Array.from(files);
        }
        else {
            filesArray.push(files);
        }
        if (!validExtensionList) {
            validExtensionList = this.dwMediaConfig.defaultFileTypes;
        }
        const validExtensionDisplayList = validExtensionList.split(',').map(item => `${item.trim()}`).join(', ');
        return this.dwMediaRepositoryService.getFileExtensions()
            .pipe(map(fileExtensions => {
            for (const file of filesArray) {
                let isValid = true;
                let errorMessage = '';
                if (!this.isExtensionMatch(file.name, validExtensionList)) {
                    isValid = false;
                    errorMessage = `Invalid File Type!  Valid File types are ${validExtensionDisplayList}`;
                }
                if (this.isExtensionMatch(file.name, this.dwMediaConfig.restrictedFileExtensions)) {
                    isValid = false;
                    const fileSizePipe = new DwFileSizePipe();
                    if (errorMessage) {
                        errorMessage += '; ';
                    }
                    errorMessage += `File Type is on the restricted list and cannot be uploaded`;
                }
                if (file.size > maxFileSizeBytes) {
                    isValid = false;
                    const fileSizePipe = new DwFileSizePipe();
                    if (errorMessage) {
                        errorMessage += '; ';
                    }
                    errorMessage += `File exceeds maximum size of ${fileSizePipe.transform(maxFileSizeBytes)}`;
                }
                const isValidFileExt = this.isExtensionMatch(file.name, validExtensionList);
                const fileDetail = {
                    file: file,
                    isImage: this.isImage(file.name),
                    fileIconCss: this.getFileIcon(file.name, fileExtensions),
                    cancellationSubject: new Subject(),
                    isValid: isValid,
                    errorMessage: errorMessage
                };
                if (fileDetail.isImage) {
                    fileDetail.imageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));
                }
                fileDetails.push(fileDetail);
            }
            return fileDetails;
        }));
    }
    populateMediaDetails(mediaItems, imageWidth, imageHeight, isSecure, isSecureGroup, itemName, attrName) {
        const mediaExtItems = [];
        if (!mediaItems) {
            return of(mediaExtItems);
        }
        return this.dwMediaRepositoryService.getFileExtensions()
            .pipe(map(fileExtensions => {
            for (const media of mediaItems) {
                if (!media.IsDeleted) {
                    const mediaExtItem = media;
                    //const fileExt = this.getFileExtension(media.FileName);
                    mediaExtItem.IsImage = this.isImage(media.FileName),
                        mediaExtItem.FileIconCss = this.getFileIcon(media.FileName, fileExtensions),
                        mediaExtItem.ImageUrl = this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, isSecureGroup, imageWidth, imageHeight, null, isSecure, media.MediaId, itemName, attrName),
                        mediaExtItem.ThumbnailImageUrl = this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, isSecureGroup, this.dwMediaConfig.thumbnailImageSize.width, this.dwMediaConfig.thumbnailImageSize.height, null, isSecure, media.MediaId, itemName, attrName),
                        mediaExtItem.MediumImageUrl = this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, isSecureGroup, this.dwMediaConfig.mediumImageSize.width, this.dwMediaConfig.mediumImageSize.height, null, isSecure, media.MediaId, itemName, attrName),
                        mediaExtItem.FullImageUrl = this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, isSecureGroup, 2000, 2000, null, isSecure, media.MediaId, itemName, attrName),
                        mediaExtItem.DisplayFileName = this.getMediaFileName(media); //`${media.MediaName}.${fileExt}`;
                    mediaExtItems.push(mediaExtItem);
                }
            }
            return mediaExtItems;
        }));
    }
    isImage(fileName) {
        return this.isExtensionMatch(fileName, this.dwMediaConfig.webImageFileExtensions);
    }
    getFileIcon(fileName, fileExtensions) {
        const fileExt = this.getFileExtension(fileName);
        let fileExtLookup = fileExtensions.find(fe => fe.Display == fileExt);
        if (!fileExtLookup) {
            fileExtLookup = fileExtensions.find(fe => fe.Display == '*');
        }
        if (fileExtLookup && fileExtLookup.IconCss) {
            return fileExtLookup.IconCss;
        }
        return 'fa fa-file';
    }
}
DwFileUtilService.ɵfac = function DwFileUtilService_Factory(t) { return new (t || DwFileUtilService)(ɵngcc0.ɵɵinject(DwMediaConfigToken), ɵngcc0.ɵɵinject(DwMediaRepositoryService), ɵngcc0.ɵɵinject(ɵngcc17.DomSanitizer)); };
DwFileUtilService.ɵprov = ɵɵdefineInjectable({ factory: function DwFileUtilService_Factory() { return new DwFileUtilService(ɵɵinject(DwMediaConfigToken), ɵɵinject(DwMediaRepositoryService), ɵɵinject(DomSanitizer)); }, token: DwFileUtilService, providedIn: "root" });
DwFileUtilService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwMediaConfigToken,] }] },
    { type: DwMediaRepositoryService },
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFileUtilService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwMediaConfigToken]
            }] }, { type: DwMediaRepositoryService }, { type: ɵngcc17.DomSanitizer }]; }, null); })();

var __decorate$2g = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1L = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
//const defaultFileTypes = ".jpg,.jpeg,.gif,.png";
class DwFileUploadComponent {
    constructor(dwMediaConfig, dwFileUtilService) {
        this.dwMediaConfig = dwMediaConfig;
        this.dwFileUtilService = dwFileUtilService;
        this.allowMultiple = false;
        this.maxSizeMegaBytes = -1;
        this.ignoreValidation = true;
        this.fileSizeMessage = "{fileName} has a file size of {fileSize} mb which is above the maximum size of {maxSize} mb.";
        this.invalidFileTypeMessage = "{fileName} is not a valid file type.  Allowed file types are {allowedFileTypes}";
        this.filesSelected = new EventEmitter();
        this.message = null;
    }
    ngAfterViewInit() {
        // This got moved to dw-media-selector and dw-multi-file
        // if (this.allowMultiple) {
        //   if (this.fileMultiple) {
        //     this.fileMultiple.nativeElement.click();
        //   }
        // } else {
        //   if (this.fileSingle) {
        //     this.fileSingle.nativeElement.click();
        //   }
        // }
    }
    setMessage(message, severity = DwMessageSeverity.error) {
        this.message = {
            messageBody: message,
            severity: severity
        };
    }
    clearMessage() {
        this.message = null;
    }
    ngOnInit() {
        if (this.maxSizeMegaBytes == -1) {
            this.maxSizeMegaBytes = this.dwMediaConfig.defaultMaxFileSizeMb;
        }
        if (!this.allowedFileTypes) {
            const splitFileTypes = this.dwMediaConfig.defaultFileTypes.split(',');
            this.allowedFileTypes = splitFileTypes.map(ft => ft.startsWith('.') ? ft : `.${ft}`).join(',');
        }
    }
    selectFiles(files, fileControl = null) {
        this.clearMessage();
        // If no files selected, we're done
        if (!files || files.length == 0) {
            return;
        }
        if (!this.validateFiles(files)) {
            return;
        }
        this.filesSelected.emit(files);
        if (fileControl === null || fileControl === void 0 ? void 0 : fileControl.files) {
            fileControl.value = null;
        }
    }
    validateFiles(files) {
        if (files.length > 1 && !this.allowMultiple) {
            this.setMessage('Only one file is allowed to be selected!');
            return false;
        }
        if (this.ignoreValidation) {
            return true;
        }
        for (const file of files) {
            if (file.name) {
                const isValid = this.dwFileUtilService.isExtensionMatch(file.name, this.allowedFileTypes);
                if (!isValid) {
                    this.setMessage(this.invalidFileTypeMessage.replace('{allowedFileTypes}', this.allowedFileTypes).replace('{fileName}', file.name));
                    return false;
                }
            }
            if (file.size > this.maxSizeMegaBytes * 1024 * 1024) {
                const fileSizeMb = Math.round(file.size / 1024 / 1024);
                this.setMessage(this.fileSizeMessage.replace('{maxSize}', this.maxSizeMegaBytes.toString()).replace('{fileName}', file.name).replace('{fileSize}', fileSizeMb.toString()));
                return false;
            }
        }
        return true;
    }
}
DwFileUploadComponent.ɵfac = function DwFileUploadComponent_Factory(t) { return new (t || DwFileUploadComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaConfigToken), ɵngcc0.ɵɵdirectiveInject(DwFileUtilService)); };
DwFileUploadComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFileUploadComponent, selectors: [["dw-file-upload"]], viewQuery: function DwFileUploadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c97, true);
        ɵngcc0.ɵɵstaticViewQuery(_c98, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileSingle = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileMultiple = _t.first);
    } }, inputs: { allowMultiple: "allowMultiple", maxSizeMegaBytes: "maxSizeMegaBytes", ignoreValidation: "ignoreValidation", fileSizeMessage: "fileSizeMessage", invalidFileTypeMessage: "invalidFileTypeMessage", allowedFileTypes: "allowedFileTypes" }, outputs: { filesSelected: "filesSelected" }, decls: 13, vars: 5, consts: [["dwDwFileDrop", "", 1, "dw-drop-box", 3, "hidden", "click", "fileDrop"], ["type", "file", "placeholder", "Choose file", 2, "display", "none", 3, "accept", "change"], ["fileSingle", ""], [1, "fa", "fa-upload"], ["type", "file", "placeholder", "Choose files", "multiple", "", 2, "display", "none", 3, "accept", "change"], ["fileMultiple", ""], [3, "message"]], template: function DwFileUploadComponent_Template(rf, ctx) { if (rf & 1) {
        const _r2 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwFileUploadComponent_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const _r0 = ɵngcc0.ɵɵreference(2); return _r0.click(); })("fileDrop", function DwFileUploadComponent_Template_div_fileDrop_0_listener($event) { return ctx.selectFiles($event); });
        ɵngcc0.ɵɵelementStart(1, "input", 1, 2);
        ɵngcc0.ɵɵlistener("change", function DwFileUploadComponent_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r2); const _r0 = ɵngcc0.ɵɵreference(2); return ctx.selectFiles(_r0.files, _r0); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "div");
        ɵngcc0.ɵɵtext(5, "Click here or drag a file to upload.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 0);
        ɵngcc0.ɵɵlistener("click", function DwFileUploadComponent_Template_div_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r2); const _r1 = ɵngcc0.ɵɵreference(8); return _r1.click(); })("fileDrop", function DwFileUploadComponent_Template_div_fileDrop_6_listener($event) { return ctx.selectFiles($event); });
        ɵngcc0.ɵɵelementStart(7, "input", 4, 5);
        ɵngcc0.ɵɵlistener("change", function DwFileUploadComponent_Template_input_change_7_listener() { ɵngcc0.ɵɵrestoreView(_r2); const _r1 = ɵngcc0.ɵɵreference(8); return ctx.selectFiles(_r1.files, _r1); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(9, "i", 3);
        ɵngcc0.ɵɵelementStart(10, "div");
        ɵngcc0.ɵɵtext(11, "Click here or drag files to upload.");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(12, "dw-message", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("hidden", ctx.allowMultiple);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("accept", ctx.allowedFileTypes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", !ctx.allowMultiple);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("accept", ctx.allowedFileTypes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("message", ctx.message);
    } }, directives: function () { return [DwFileDropDirective, DwMessageComponent]; }, styles: [""] });
DwFileUploadComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwMediaConfigToken,] }] },
    { type: DwFileUtilService }
];
DwFileUploadComponent.propDecorators = {
    allowedFileTypes: [{ type: Input }],
    allowMultiple: [{ type: Input }],
    maxSizeMegaBytes: [{ type: Input }],
    ignoreValidation: [{ type: Input }],
    fileSizeMessage: [{ type: Input }],
    invalidFileTypeMessage: [{ type: Input }],
    filesSelected: [{ type: Output }],
    fileSingle: [{ type: ViewChild, args: ['fileSingle', { static: true },] }],
    fileMultiple: [{ type: ViewChild, args: ['fileMultiple', { static: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFileUploadComponent, [{
        type: Component,
        args: [{
                selector: 'dw-file-upload',
                template: "<div class=\"dw-drop-box\" (click)=\"fileSingle.click()\" dwDwFileDrop (fileDrop)=\"selectFiles($event)\" [hidden]=\"allowMultiple\">\r\n    <input type=\"file\" #fileSingle placeholder=\"Choose file\" (change)=\"selectFiles(fileSingle.files, fileSingle)\" [accept]=\"allowedFileTypes\" style=\"display:none;\">\r\n\r\n    <i class=\"fa fa-upload\"></i>\r\n\r\n    <div>Click here or drag a file to upload.</div>\r\n</div>\r\n\r\n\r\n<div class=\"dw-drop-box\" (click)=\"fileMultiple.click()\" dwDwFileDrop (fileDrop)=\"selectFiles($event)\" [hidden]=\"!allowMultiple\">\r\n    <input type=\"file\" #fileMultiple placeholder=\"Choose files\" (change)=\"selectFiles(fileMultiple.files, fileMultiple)\" [accept]=\"allowedFileTypes\" style=\"display:none;\" multiple>\r\n\r\n    <i class=\"fa fa-upload\"></i>\r\n\r\n    <div>Click here or drag files to upload.</div>\r\n</div>\r\n\r\n<dw-message [message]=\"message\"></dw-message>\r\n\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwMediaConfigToken]
            }] }, { type: DwFileUtilService }]; }, { allowMultiple: [{
            type: Input
        }], maxSizeMegaBytes: [{
            type: Input
        }], ignoreValidation: [{
            type: Input
        }], fileSizeMessage: [{
            type: Input
        }], invalidFileTypeMessage: [{
            type: Input
        }], filesSelected: [{
            type: Output
        }], allowedFileTypes: [{
            type: Input
        }], fileSingle: [{
            type: ViewChild,
            args: ['fileSingle', { static: true }]
        }], fileMultiple: [{
            type: ViewChild,
            args: ['fileMultiple', { static: true }]
        }] }); })();
__decorate$2g([
    DwInputConverter(booleanConverter),
    __metadata$1L("design:type", Boolean)
], DwFileUploadComponent.prototype, "allowMultiple", void 0);
__decorate$2g([
    DwInputConverter(intConverter),
    __metadata$1L("design:type", Number)
], DwFileUploadComponent.prototype, "maxSizeMegaBytes", void 0);
__decorate$2g([
    DwInputConverter(booleanConverter),
    __metadata$1L("design:type", Boolean)
], DwFileUploadComponent.prototype, "ignoreValidation", void 0);

class DwFileDropDirective {
    constructor() {
        this.fileDrop = new EventEmitter();
        this.draggingOver = false;
    }
    onDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
        this.draggingOver = true;
    }
    onDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        this.draggingOver = false;
    }
    onDrop(event) {
        var _a;
        event.preventDefault();
        event.stopPropagation();
        this.draggingOver = false;
        const files = ((_a = event.dataTransfer) === null || _a === void 0 ? void 0 : _a.files) || [];
        if (files.length > 0) {
            this.fileDrop.emit(files);
        }
    }
}
DwFileDropDirective.ɵfac = function DwFileDropDirective_Factory(t) { return new (t || DwFileDropDirective)(); };
DwFileDropDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwFileDropDirective, selectors: [["", "dwDwFileDrop", ""]], hostVars: 2, hostBindings: function DwFileDropDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragover", function DwFileDropDirective_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function DwFileDropDirective_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function DwFileDropDirective_drop_HostBindingHandler($event) { return ctx.onDrop($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("draggingOver", ctx.draggingOver);
    } }, outputs: { fileDrop: "fileDrop" } });
DwFileDropDirective.propDecorators = {
    fileDrop: [{ type: Output }],
    draggingOver: [{ type: HostBinding, args: ['class.draggingOver',] }],
    onDragOver: [{ type: HostListener, args: ['dragover', ['$event'],] }],
    onDragLeave: [{ type: HostListener, args: ['dragleave', ['$event'],] }],
    onDrop: [{ type: HostListener, args: ['drop', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFileDropDirective, [{
        type: Directive,
        args: [{
                selector: '[dwDwFileDrop]'
            }]
    }], function () { return []; }, { fileDrop: [{
            type: Output
        }], draggingOver: [{
            type: HostBinding,
            args: ['class.draggingOver']
        }], onDragOver: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], onDragLeave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], onDrop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }] }); })();

var DwMediaSize;
(function (DwMediaSize) {
    DwMediaSize[DwMediaSize["extraLarge"] = 1] = "extraLarge";
    DwMediaSize[DwMediaSize["large"] = 2] = "large";
    DwMediaSize[DwMediaSize["medium"] = 3] = "medium";
    DwMediaSize[DwMediaSize["small"] = 4] = "small";
    DwMediaSize[DwMediaSize["thumbnail"] = 5] = "thumbnail";
    DwMediaSize[DwMediaSize["original"] = 6] = "original";
})(DwMediaSize || (DwMediaSize = {}));

class DwMediaConfigDefaults {
    constructor() {
        this.defaultMaxFileSizeMb = 5; // Set a 5mb limit as the default
        this.restrictedFileExtensions = 'exe,cmd,bat,php,asp,aspx,ps,scr,vbs,pif,application,gadget,msi';
        this.webImageFileExtensions = 'jpg,jpeg,gif,png';
        this.defaultFileTypes = 'jpg,jpeg,gif,png,pdf';
        this.mediaSizes = [DwMediaSize.extraLarge];
        this.concurrentUploads = 3;
        this.globalMediaGroupId = 1;
        this.thumbnailImageSize = { width: 100, height: 100 };
        this.mediumImageSize = { width: 300, height: 300 };
        this.largeImageSize = { width: 1000, height: 1000 };
    }
}

const STYLES = () => ({
    cropper: lyl `{
    max-width: 400px
    height: 300px
  }`,
    sliderContainer: lyl `{
    text-align: center
    max-width: 400px
    margin: 14px
  }`
});
const ɵ0$2 = STYLES;
class DwImageResizerComponent {
    constructor(sRenderer, _platform) {
        this.sRenderer = sRenderer;
        this._platform = _platform;
        this.imageResized = new EventEmitter();
        this.imageChangeSubject = new Subject();
        this.classes = this.sRenderer.renderSheet(STYLES);
        this.rotatedDegrees = 0;
        this.myConfig = {
            autoCrop: true,
            width: 500,
            height: 500,
            round: false,
            fill: '#ffffff',
            // fill: '#ff2997', // Default transparent if type = png else #000
            type: 'image/png',
            responsiveArea: false,
            keepAspectRatio: true,
        };
    }
    ngOnChanges(changes) {
        if (changes.options) {
            this.setOptions();
        }
        if (changes.sourceImage) {
            this.loadOriginalImage();
        }
    }
    ngAfterViewInit() {
        this.handleAutoCropping();
        this.setOptions();
        if (this._platform.isBrowser) {
            this.loadOriginalImage();
        }
    }
    setOptions() {
        if (!this.options) {
            return;
        }
        this.myConfig.width = this.options.cropWidth;
        this.myConfig.height = this.options.cropHeight;
        this.myConfig.round = !!this.options.cropRound;
        this.myConfig.resizableArea = true;
        this.myConfig.responsiveArea = true;
        // this.myConfig.extraZoomOut = true;
        if (this.options.maintainAspectRatio && this.currentNaturalSize) {
            const isRotated = this.rotatedDegrees % 180 !== 0;
            const adjustedResult = this.adjustByAspectRatio(this.currentNaturalSize, this.options.cropWidth, this.options.cropHeight, isRotated);
            this.myConfig.width = adjustedResult.width;
            this.myConfig.height = adjustedResult.height;
        }
        if (this.options.outputWidth) {
            this.myConfig.output = {
                width: this.options.outputWidth,
                height: this.options.outputHeight
            };
            if (this.options.maintainAspectRatio && this.currentNaturalSize) {
                const isRotated = this.rotatedDegrees % 180 !== 0;
                const adjustedResult = this.adjustByAspectRatio(this.currentNaturalSize, this.options.outputWidth, this.options.outputHeight, isRotated);
                this.myConfig.output = {
                    width: adjustedResult.width,
                    height: adjustedResult.height
                };
            }
        }
        if (this.cropper) {
            this.cropper.config = this.myConfig;
        }
        // this.cropper.config = {...this.cropper.config, ...this.myConfig };
    }
    loadOriginalImage() {
        if (this.sourceImage) {
            this.getImageSize()
                .subscribe(imageSize => {
                this.currentNaturalSize = imageSize;
                this.setOptions();
                this.loadImageSource();
            });
        }
    }
    loadImageSource() {
        if (this.sourceImage && this.cropper) {
            this.rotatedDegrees = 0;
            const event = {
                target: {
                    value: this.sourceImage.name,
                    files: [this.sourceImage],
                }
            };
            this.cropper.selectInputEvent(event);
            setTimeout(() => {
                this.cropper.fit();
            }, 100);
        }
    }
    adjustByAspectRatio(actualSize, maxWidth, maxHeight, isRotated) {
        const aspectRatio = actualSize.width / actualSize.height;
        const result = {};
        if (aspectRatio > 1) {
            // Greater width than one - adjust height
            result.width = maxWidth;
            result.height = maxWidth / aspectRatio;
        }
        else {
            // Greater height than one - adjust width
            result.width = maxHeight * aspectRatio;
            result.height = maxHeight;
        }
        if (isRotated) {
            const tmpHeight = result.height;
            result.height = result.width;
            result.width = tmpHeight;
        }
        return result;
    }
    getImageSize() {
        const subject = new Subject();
        const fr = new FileReader();
        fr.readAsArrayBuffer(this.sourceImage); // image the the 'File' object
        fr.onload = () => {
            const arrayBuffer = fr.result;
            // Convert to base64. String.fromCharCode can hit stack overflow error if you pass
            // the entire arrayBuffer in, iteration gets around this
            let binary = '';
            const bytes = new Uint8Array(arrayBuffer);
            bytes.forEach(b => binary += String.fromCharCode(b));
            const base64Data = window.btoa(binary);
            // Create image object. Note, a default width/height MUST be given to constructor (per 
            // the docs) or naturalWidth/Height will always return 0.
            const imageObj = new Image(100, 100);
            imageObj.src = `data:${this.sourceImage.type};base64,${base64Data}`;
            imageObj.onload = () => {
                subject.next({ width: imageObj.naturalWidth, height: imageObj.naturalHeight });
            };
        };
        return subject.asObservable();
    }
    scroll(event) {
        let wheelDelta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        if (wheelDelta > 0) {
            //this.scale += wheelDelta;
            this.cropper.zoomIn();
        }
        else {
            //this.scale -= wheelDelta;
            //this.cropper.zoomIn();
            this.cropper.zoomOut();
        }
    }
    handleAutoCropping() {
        // Handles auto cropping every 100ms (the built one is slow)
        this.imageChangeSubject
            .pipe(debounceTime(100))
            .subscribe(() => {
            if (this.cropper) {
                // this.cropper.crop();
            }
        });
    }
    onImageSized() {
        this.imageChangeSubject.next();
    }
    selectFile(event) {
        //console.log('File event', event);
        this.cropper.selectInputEvent(event);
        this.cropper.fitToScreen();
    }
    rotate(degrees) {
        if (!this.cropper) {
        }
        this.cropper.rotate(degrees);
        this.cropper.fit();
        this.rotatedDegrees += degrees;
        this.setOptions();
    }
    onCropped(e) {
        this.croppedImage = e.dataURL;
        const blob = this.dataURItoBlob(e.dataURL);
        /// Convert a blob to a file
        const file = blob;
        file.name = this.sourceImage.name;
        file.lastModified = this.sourceImage.lastModified;
        this.imageResized.emit(file);
    }
    onLoaded(e) {
        //console.log('img loaded', e);
        this.cropper.fitToScreen();
        this.onImageSized();
    }
    onError(e) {
        console.warn(`'${e.name}' is not a valid image`, e);
    }
    setScale(scale) {
        this.scale = scale;
        this.cropper.setScale(scale);
    }
    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        // create a view into the buffer
        var ia = new Uint8Array(ab);
        // set the bytes of the buffer to the correct values
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        // write the ArrayBuffer to a blob, and you're done
        var blob = new Blob([ab], { type: mimeString });
        return blob;
    }
}
DwImageResizerComponent.ɵfac = function DwImageResizerComponent_Factory(t) { return new (t || DwImageResizerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc33.StyleRenderer), ɵngcc0.ɵɵdirectiveInject(ɵngcc34.Platform)); };
DwImageResizerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwImageResizerComponent, selectors: [["dw-image-resizer"]], viewQuery: function DwImageResizerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(LyImageCropper, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cropper = _t.first);
    } }, hostBindings: function DwImageResizerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousewheel", function DwImageResizerComponent_mousewheel_HostBindingHandler($event) { return ctx.scroll($event); });
    } }, inputs: { sourceImage: "sourceImage", options: "options" }, outputs: { imageResized: "imageResized" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 6, vars: 6, consts: [["class", "image-button-bar", 4, "ngIf"], [2, "min-height", "400px", 3, "config", "scale", "scaleChange", "minScale", "ready", "cleaned", "cropped", "loaded", "error"], ["step", "0.000001", 3, "ngModel", "min", "max", "ngModelChange"], [1, "image-button-bar"], ["title", "zoom in", 1, "fa", "fa-search-plus", "dw-icon", 3, "click"], ["title", "zoom out", 1, "fa", "fa-search-minus", "dw-icon", 3, "click"], [1, "dw-icon-spacer"], ["title", "routate counter clockwise", 1, "fa", "fa-undo", "dw-icon", 3, "click"], ["title", "rotate clockwise", 1, "fa", "fa-undo", "fa-flip-horizontal", "dw-icon", 3, "click"], ["title", "fit", 1, "fa", "fa-compress", "dw-icon", 3, "click"], ["title", "center", 1, "fa", "fa-album", "dw-icon", 3, "click"], ["title", "fit to screen", 1, "fa", "fa-expand-arrows", "dw-icon", 3, "click"], ["title", "1:1", 1, "fa", "fa-expand", "dw-icon", 3, "click"]], template: function DwImageResizerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementContainerStart(0);
        ɵngcc0.ɵɵtemplate(1, DwImageResizerComponent_div_1_Template, 11, 0, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "ly-img-cropper", 1);
        ɵngcc0.ɵɵlistener("scaleChange", function DwImageResizerComponent_Template_ly_img_cropper_scaleChange_2_listener($event) { return ctx.scale = $event; })("minScale", function DwImageResizerComponent_Template_ly_img_cropper_minScale_2_listener($event) { return ctx.minScale = $event; })("ready", function DwImageResizerComponent_Template_ly_img_cropper_ready_2_listener() { return ctx.ready = true; })("cleaned", function DwImageResizerComponent_Template_ly_img_cropper_cleaned_2_listener() { return ctx.ready = false; })("cropped", function DwImageResizerComponent_Template_ly_img_cropper_cropped_2_listener($event) { return ctx.onCropped($event); })("loaded", function DwImageResizerComponent_Template_ly_img_cropper_loaded_2_listener($event) { return ctx.onLoaded($event); })("scaleChange", function DwImageResizerComponent_Template_ly_img_cropper_scaleChange_2_listener() { return ctx.onImageSized(); })("error", function DwImageResizerComponent_Template_ly_img_cropper_error_2_listener($event) { return ctx.onError($event); });
        ɵngcc0.ɵɵelementStart(3, "span");
        ɵngcc0.ɵɵtext(4, "Drag and drop image");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "p-slider", 2);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageResizerComponent_Template_p_slider_ngModelChange_5_listener($event) { return ctx.scale = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainerEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.ready);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("config", ctx.myConfig)("scale", ctx.scale);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.scale)("min", ctx.minScale)("max", 1);
    } }, directives: [ɵngcc4.NgIf, ɵngcc35.LyImageCropper, ɵngcc36.Slider, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], styles: [""] });
DwImageResizerComponent.ctorParameters = () => [
    { type: StyleRenderer },
    { type: Platform }
];
DwImageResizerComponent.propDecorators = {
    sourceImage: [{ type: Input }],
    options: [{ type: Input }],
    imageResized: [{ type: Output }],
    cropper: [{ type: ViewChild, args: [LyImageCropper,] }],
    scroll: [{ type: HostListener, args: ['mousewheel', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwImageResizerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-image-resizer',
                template: "\r\n<ng-container >\r\n   \r\n    <div *ngIf=\"ready\" class=\"image-button-bar\">\r\n        <i class=\"fa fa-search-plus dw-icon\" (click)=\"cropper.zoomIn()\" title=\"zoom in\"></i>\r\n        <i class=\"fa fa-search-minus dw-icon\" (click)=\"cropper.zoomOut()\" title=\"zoom out\"></i>\r\n        <i class=\"dw-icon-spacer\"></i>\r\n        <i class=\"fa fa-undo dw-icon\" (click)=\"rotate(-90)\" title=\"routate counter clockwise\"></i>\r\n        <i class=\"fa fa-undo fa-flip-horizontal dw-icon\" (click)=\"rotate(90)\" title=\"rotate clockwise\"></i>\r\n        <i class=\"dw-icon-spacer\"></i>\r\n        <i class=\"fa fa-compress dw-icon\" (click)=\"cropper.fit()\" title=\"fit\"></i>\r\n        <i class=\"fa fa-album dw-icon\"  (click)=\"cropper.center()\" title=\"center\"></i>\r\n        <i class=\"fa fa-expand-arrows dw-icon\" (click)=\"cropper.fitToScreen()\" title=\"fit to screen\"></i>\r\n        <i class=\"fa fa-expand dw-icon\" (click)=\"cropper.setScale(1)\" title=\"1:1\"></i>\r\n    </div>\r\n\r\n    <ly-img-cropper [config]=\"myConfig\" [(scale)]=\"scale\" (minScale)=\"minScale = $event\" style=\"min-height:400px;\"\r\n        (ready)=\"ready = true\" (cleaned)=\"ready = false\" (cropped)=\"onCropped($event)\" (loaded)=\"onLoaded($event)\" (scaleChange)=\"onImageSized()\"         (error)=\"onError($event)\">\r\n        <span>Drag and drop image</span>\r\n    </ly-img-cropper>\r\n\r\n    <p-slider [(ngModel)]=\"scale\" [min]=\"minScale\" [max]=\"1\" step=\"0.000001\"></p-slider>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc33.StyleRenderer }, { type: ɵngcc34.Platform }]; }, { imageResized: [{
            type: Output
        }], scroll: [{
            type: HostListener,
            args: ['mousewheel', ['$event']]
        }], sourceImage: [{
            type: Input
        }], options: [{
            type: Input
        }], cropper: [{
            type: ViewChild,
            args: [LyImageCropper]
        }] }); })();

class DwFileUploadModalComponent {
    constructor(dwMediaRepositoryService, dwMediaConfig, dwFileUtilService, sanitizer) {
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.dwMediaConfig = dwMediaConfig;
        this.dwFileUtilService = dwFileUtilService;
        this.sanitizer = sanitizer;
        this.closeModal = new EventEmitter();
        this.fileDetails = [];
        this.uploadResults = [];
        this.showUpload = true;
    }
    ngOnInit() {
        if (this.modalConfig.data) {
            this.fileUploadOptions = this.modalConfig.data;
            this.maxFileSizeBytes = this.fileUploadOptions.maxFileSizeBytes || this.dwMediaConfig.defaultMaxFileSizeMb * 1024 * 1024;
            this.dwFileUtilService.buildFileDetails(this.fileUploadOptions.files, this.fileUploadOptions.mediaSelectOptions.allowedFileTypes, this.maxFileSizeBytes)
                .subscribe(fileDetails => {
                this.fileDetails = fileDetails;
                this.setShowUpload();
            });
            if (!this.fileUploadOptions.mediaSelectOptions.imageResizeOptions) {
                this.fileUploadOptions.mediaSelectOptions.imageResizeOptions = {
                    cropWidth: 200,
                    cropHeight: 200,
                    cropRound: true
                };
            }
        }
    }
    setupDefaults() {
    }
    setShowUpload() {
        let showUpload = true;
        this.clearMessage();
        if (this.uploadStarted) {
            showUpload = false;
        }
        else {
            if (!this.fileUploadOptions.allowMultiple) {
                const existingFile = this.fileDetails.find(fd => !fd.cancelled);
                if (existingFile) {
                    showUpload = false;
                }
            }
            else {
                if (this.fileUploadOptions.maxFiles) {
                    const totalFileCount = this.getTotalFileCount();
                    if (totalFileCount >= this.fileUploadOptions.maxFiles) {
                        showUpload = false;
                        if (totalFileCount > this.fileUploadOptions.maxFiles) {
                            const additionalFileCount = this.fileUploadOptions.maxFiles - this.fileUploadOptions.existingFilesCount;
                            const filesToRemoveCount = totalFileCount - this.fileUploadOptions.maxFiles;
                            this.setMessage(`You can upload only ${additionalFileCount} files for a total of ${this.fileUploadOptions.maxFiles} Files. Please remove ${filesToRemoveCount} files`, DwMessageSeverity.error);
                        }
                    }
                }
            }
        }
        this.showUpload = showUpload;
    }
    getTotalFileCount() {
        const fileCount = this.fileDetails.filter(fd => !fd.cancelled).length;
        const existingFileCount = this.fileUploadOptions.existingFilesCount || 0;
        return fileCount + existingFileCount;
    }
    getInvalidFileCount() {
        return this.fileDetails.filter(fd => !fd.cancelled && !fd.isValid).length;
    }
    setMessage(message, severity = DwMessageSeverity.error) {
        this.message = {
            messageBody: message,
            severity: severity
        };
    }
    clearMessage() {
        this.message = null;
    }
    setResizedImage(fileDetail, resizedImage) {
        fileDetail.resizedFile = resizedImage;
    }
    // setSourceImage(image: File) {
    //   this.sourceImage = image;
    //   // if (this.fileUploadOptions.mediaSelectOptions.imageResizeOptions.allowResize) {
    //   //   this.resizedImage = image;
    //   // }
    //   if (image) {
    //     this.sourceImageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(image));
    //   }
    // }
    buttonClick(buttonConfig) {
        let result = new DwModalResult();
        result.cancelled = false;
        switch (buttonConfig.command) {
            case DwButtonCommand.ok:
            case DwButtonCommand.saveAndClose:
            case DwButtonCommand.save:
                if (!this.validateFiles()) {
                    return of(result);
                }
                this.uploadMedia();
                return of(result);
            case DwButtonCommand.cancel:
                result.closeModal = true;
                result.cancelled = true;
        }
        return of(result);
    }
    validateFiles() {
        const invalidFileCount = this.getInvalidFileCount();
        if (invalidFileCount > 0) {
            this.setMessage(`Please remove any files will errors.`, DwMessageSeverity.warning);
            return false;
        }
        const totalFileCount = this.getTotalFileCount();
        if (totalFileCount > this.fileUploadOptions.maxFiles) {
            return false;
        }
        var validFiles = this.fileDetails.filter(fd => !fd.cancelled && fd.isValid).length;
        if (validFiles === 0) {
            this.setMessage('Please select a file to upload');
            return false;
        }
        return true;
    }
    cancelFile(fileDetail) {
        fileDetail.cancellationSubject.next();
        fileDetail.cancelled = true;
        const index = this.fileDetails.indexOf(fileDetail);
        const uploadResult = this.uploadResults[index];
        if (uploadResult) {
            uploadResult.isCancelled = true;
        }
        this.setShowUpload();
    }
    uploadMedia() {
        if (this.uploadStarted) {
            return;
        }
        this.uploadStarted = true;
        this.ensureMediaGroupId()
            .subscribe(mediaGroupId => {
            this.fileUploadOptions.mediaGroupId = mediaGroupId;
            this.dwMediaRepositoryService.uploadFiles(this.fileDetails, this.fileUploadOptions.mediaGroupId, this.fileUploadOptions.mediaSelectOptions.isSecure, this.dwMediaConfig.mediaSizes, this.dwMediaConfig.concurrentUploads)
                .subscribe(uploadResults => {
                this.uploadResults = uploadResults;
                this.handleUploadResults();
            });
        });
    }
    handleUploadResults() {
        // Check if it is complete
        const pendingFiles = this.uploadResults.find(r => !r.isComplete && !r.isCancelled && !r.isError);
        // Wait until all pending files are complete
        if (pendingFiles) {
            return;
        }
        this.uploadStarted = false;
        const errorFiles = this.uploadResults.find(r => !r.isComplete || r.isError);
        if (errorFiles) {
            this.setMessage('One or more files failed to upload.  Retry or remove these files, then click ok', DwMessageSeverity.error);
            for (const result of this.uploadResults) {
                if (result.isError) {
                    const fileDetail = this.fileDetails.find(fd => fd.file.name == result.fileName);
                    fileDetail.errorMessage = result.errorMessage;
                    fileDetail.isValid = false;
                }
            }
            return;
        }
        for (let index = 0; index < this.fileDetails.length; index++) {
            const fileDetail = this.fileDetails[index];
            const uploadResult = this.uploadResults[index];
            fileDetail.media = uploadResult.uploadResult;
        }
        const fileUploadModalResult = {
            mediaGroupId: this.fileUploadOptions.mediaGroupId,
            media: this.fileDetails.map(fd => fd.media).filter(m => m),
        };
        let modalResult = new DwModalResult();
        modalResult.cancelled = false;
        modalResult.data = fileUploadModalResult;
        this.closeModal.emit(modalResult);
    }
    ensureMediaGroupId() {
        var _a, _b;
        if (!this.fileUploadOptions.mediaGroupId) {
            const mediaGroupName = `${((_a = this.fileUploadOptions.mediaSelectOptions) === null || _a === void 0 ? void 0 : _a.parentItemName) || 'Item'}-${((_b = this.fileUploadOptions.mediaSelectOptions) === null || _b === void 0 ? void 0 : _b.parentAttributeName) || 'Attr'}`;
            return this.dwMediaRepositoryService.createMediaGroup(mediaGroupName, this.fileUploadOptions.mediaSelectOptions.isSecure)
                .pipe(map(mediaGroup => {
                return mediaGroup.MediaGroupId;
            }));
        }
        return of(this.fileUploadOptions.mediaGroupId);
    }
    // uploadMediaOld() {
    //   const file: File = null;
    //   const mediaInfo: DwMediaInfo = {
    //     FileName: file.name,
    //     MediaName: file.name,
    //     MediaGroupId: 1,
    //     Quality: 100,
    //     MediaSizes: [DwMediaSize.extraLarge],
    //     IsSecure: this.fileUploadOptions.mediaSelectOptions.isSecure,
    //     // ParentItemName: this.fileUploadOptions.mediaSelectOptions.parentItemName,
    //     // ParentAttributeName: this.fileUploadOptions.mediaSelectOptions.parentAttributeName,
    //   };
    //   this.message = null;
    //   this.dwMediaRepositoryService.uploadFile(mediaInfo, file)
    //     .subscribe(uploadResult => {
    //       this.uploadResult = uploadResult;
    //       if (this.uploadResult.isComplete) {
    //         let modalResult = new DwModalResult();
    //         modalResult.cancelled = false;
    //         modalResult.data = this.uploadResult.uploadResult;
    //         this.closeModal.emit(modalResult);
    //       }
    //     }, error => {
    //       this.message = {
    //         messageHeading: 'An error occured while uploading your file!',
    //         severity: DwMessageSeverity.error
    //       };
    //       this.uploadResult.isComplete = null;
    //     });
    // }
    filesSelected(files) {
        if (files) {
            this.dwFileUtilService.buildFileDetails(files, this.fileUploadOptions.mediaSelectOptions.allowedFileTypes, this.maxFileSizeBytes)
                .subscribe(newFileDetails => {
                this.fileDetails = [...this.fileDetails, ...newFileDetails].filter(fd => !fd.cancelled);
                this.uploadResults = this.uploadResults.filter(r => !r.isCancelled);
                this.setShowUpload();
            });
        }
    }
}
DwFileUploadModalComponent.ɵfac = function DwFileUploadModalComponent_Factory(t) { return new (t || DwFileUploadModalComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwMediaConfigToken), ɵngcc0.ɵɵdirectiveInject(DwFileUtilService), ɵngcc0.ɵɵdirectiveInject(ɵngcc17.DomSanitizer)); };
DwFileUploadModalComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFileUploadModalComponent, selectors: [["dw-file-upload-modal"]], decls: 6, vars: 5, consts: [[3, "message"], [4, "ngIf"], ["dwRow", "", 4, "ngIf"], [1, "dw-file-list"], ["class", "dw-file", 3, "hidden", 4, "ngFor", "ngForOf"], ["dwRow", ""], ["dwCol", "12"], [3, "allowedFileTypes", "allowMultiple", "filesSelected"], [1, "dw-file", 3, "hidden"], [1, "dw-file-icon"], [3, "ngClass"], [1, "dw-file-name", 3, "title"], [1, "dw-file-size"], [1, "dw-file-status"], [1, "fa", "fa-times", "hand", 3, "hidden", "click"], [1, "fa", "fa-check", "dw-green", 3, "hidden"], ["class", "dw-file-error", 4, "ngIf"], ["class", "dw-file-progress", 4, "ngIf"], [1, "dw-file-error"], [1, "dw-file-progress"], [3, "value"], ["dwRow", "", 1, "mt-2"], [3, "sourceImage", "options", "imageResized"]], template: function DwFileUploadModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-message", 0);
        ɵngcc0.ɵɵtemplate(1, DwFileUploadModalComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwFileUploadModalComponent_div_2_Template, 3, 2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DwFileUploadModalComponent_div_4_Template, 13, 11, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, DwFileUploadModalComponent_ng_container_5_Template, 4, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fileUploadOptions == null ? null : ctx.fileUploadOptions.mediaSelectOptions == null ? null : ctx.fileUploadOptions.mediaSelectOptions.uploadInstructions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showUpload);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fileDetails);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.fileDetails == null ? null : ctx.fileDetails.length) == 1 && ctx.fileDetails[0].file && (ctx.fileUploadOptions == null ? null : ctx.fileUploadOptions.mediaSelectOptions == null ? null : ctx.fileUploadOptions.mediaSelectOptions.imageResizeOptions == null ? null : ctx.fileUploadOptions.mediaSelectOptions.imageResizeOptions.allowResize) && !ctx.uploadResults[0]);
    } }, directives: [DwMessageComponent, ɵngcc4.NgIf, ɵngcc4.NgForOf, DwRowDirective, DwColDirective, DwFileUploadComponent, ɵngcc4.NgClass, ɵngcc14.ProgressBar, DwImageResizerComponent], pipes: [DwFileSizePipe], styles: [""] });
DwFileUploadModalComponent.ctorParameters = () => [
    { type: DwMediaRepositoryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwMediaConfigToken,] }] },
    { type: DwFileUtilService },
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFileUploadModalComponent, [{
        type: Component,
        args: [{
                selector: 'dw-file-upload-modal',
                template: "<dw-message [message]=\"message\"></dw-message>\r\n\r\n<div *ngIf=\"fileUploadOptions?.mediaSelectOptions?.uploadInstructions\">\r\n    {{fileUploadOptions?.mediaSelectOptions?.uploadInstructions}}\r\n</div>\r\n\r\n<div dwRow *ngIf=\"showUpload\">\r\n    <div dwCol=\"12\">\r\n\r\n     \r\n        <dw-file-upload (filesSelected)=\"filesSelected($event)\"\r\n            [allowedFileTypes]=\"fileUploadOptions.mediaSelectOptions.allowedFileTypes\"\r\n            [allowMultiple]=\"fileUploadOptions.allowMultiple\"></dw-file-upload>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"dw-file-list\">\r\n    <div class=\"dw-file\" *ngFor=\"let fileDetail of fileDetails; index as i\" [hidden]=\"fileDetail.cancelled\">\r\n        <div class=\"dw-file-icon\">\r\n            <i [ngClass]=\"fileDetail.fileIconCss\"></i>\r\n        </div>\r\n        <div class=\"dw-file-name\" title=\"{{fileDetail.file.name}}\">\r\n            {{fileDetail.file.name}}\r\n        </div>\r\n        <div class=\"dw-file-size\">\r\n            {{ fileDetail.file.size | filesize}}\r\n        </div>\r\n        <div class=\"dw-file-status\">\r\n            <i class=\"fa fa-times hand\" (click)=\"cancelFile(fileDetail)\" [hidden]=\"uploadResults[i]?.isComplete\"></i>\r\n            <i class=\"fa fa-check dw-green\" [hidden]=\"!uploadResults[i]?.isComplete\"></i>\r\n        </div>\r\n        <div *ngIf=\"fileDetail.errorMessage\" class=\"dw-file-error\">\r\n            {{ fileDetail.errorMessage}}\r\n        </div>\r\n        <div *ngIf=\"uploadResults[i]\" class=\"dw-file-progress\">\r\n            <p-progressBar [value]=\"uploadResults[i]?.percentComplete\" [style]=\"{'height': '4px'}\"></p-progressBar>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<!-- Only show resize options for the first file -->\r\n<ng-container\r\n    *ngIf=\"fileDetails?.length == 1 && fileDetails[0].file && fileUploadOptions?.mediaSelectOptions?.imageResizeOptions?.allowResize && !uploadResults[0]\">\r\n    \r\n    <div dwRow class=\"mt-2\">\r\n        <div dwCol=\"12\">\r\n            <dw-image-resizer [sourceImage]=\"fileDetails[0].file\"\r\n                [options]=\"fileUploadOptions?.mediaSelectOptions?.imageResizeOptions\"\r\n                (imageResized)=\"setResizedImage(fileDetails[0], $event)\"></dw-image-resizer>\r\n        </div>\r\n    </div>\r\n</ng-container>\r\n\r\n<!-- <div dwRow *ngIf=\"sourceImage && !uploadResult && fileUploadOptions?.mediaSelectOptions?.imageResizeOptions?.allowResize\">\r\n    <div dwCol=\"12\">\r\n        <dw-image-resizer [sourceImage]=\"sourceImage\" [options]=\"fileUploadOptions?.mediaSelectOptions?.imageResizeOptions\" (imageResized)=\"setResizedImage($event)\"></dw-image-resizer>\r\n    </div>\r\n</div>\r\n\r\n<div dwRow *ngIf=\"sourceImage && !uploadResult && !fileUploadOptions?.mediaSelectOptions?.imageResizeOptions?.allowResize\">\r\n    <div dwCol=\"12\">\r\n       <img [src]=\"sourceImageUrl\" style=\"width:100%;height:auto\">\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\" *ngIf=\"uploadResult?.isComplete === false\">\r\n    <div class=\"col-md-4\">\r\n        Uploading... {{uploadResult?.percentComplete}}% Complete\r\n    </div>\r\n</div>\r\n<div class=\"row\" *ngIf=\"uploadResult?.isComplete\">\r\n    <div class=\"col-md-4\">\r\n        Processing...\r\n    </div>\r\n</div>\r\n\r\n -->",
                styles: [""]
            }]
    }], function () { return [{ type: DwMediaRepositoryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwMediaConfigToken]
            }] }, { type: DwFileUtilService }, { type: ɵngcc17.DomSanitizer }]; }, null); })();

var DwImageSizeMode;
(function (DwImageSizeMode) {
    DwImageSizeMode["max"] = "max";
    DwImageSizeMode["stretch"] = "stretch";
    DwImageSizeMode["crop"] = "crop";
    DwImageSizeMode["responsiveWidth"] = "responsiveWidth";
})(DwImageSizeMode || (DwImageSizeMode = {}));

var __decorate$2h = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1M = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMediaItemComponent {
    constructor(dwMediaRepositoryService) {
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.mediaChange = new EventEmitter();
        this.ignoreContainerStyle = false;
        this.quality = 100;
        this.containerStyle = {};
        this.mediaStyle = {};
        this.useImageTag = false;
    }
    ngOnInit() {
        this.setupImage();
    }
    ngOnChanges(changes) {
        this.setupImage();
    }
    setDefaults() {
        if (!this.sizeOptions) {
            this.sizeOptions = {};
        }
        if (!this.sizeOptions.mode) {
            this.sizeOptions.mode = DwImageSizeMode.crop;
        }
    }
    setupImage() {
        const mediaUrl = this.getMediaUrl();
        this.mediaUrl = mediaUrl;
        this.containerStyle = this.containerStyle = {};
        let backgroundImage = `url('${mediaUrl}')`;
        if (this.darkenImage) {
            backgroundImage = 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ),' + backgroundImage;
        }
        this.containerStyle.overflow = 'hidden';
        if (mediaUrl) {
            this.containerStyle['background-image'] = backgroundImage;
        }
        else {
            this.containerStyle['background-image'] = null;
        }
        this.containerStyle['background-repeat'] = `no-repeat`;
        this.containerStyle['background-size'] = `cover`;
        if (this.heightPercent) {
            this.containerStyle['padding-top'] = `${this.heightPercent}%`;
        }
    }
    getMediaUrl() {
        var _a, _b;
        this.setDefaults();
        const media = this.media || this.defaultMedia;
        if (!media) {
            if (this.containerName && this.fileName) {
                if (this.isSecure) {
                    console.log("Secure media requires a media record");
                    return this.defaultMediaUrl;
                }
                console.log('Loading image without security!');
                return this.dwMediaRepositoryService.getImageUrl(this.containerName, this.fileName, media.MediaDetailKey, false);
            }
            this.containerStyle = null;
            this.mediaStyle = null;
            const finalSizeOptions = this.determineImageSize(media);
            if ((_a = this.sizeOptions) === null || _a === void 0 ? void 0 : _a.cropToCircle) {
                this.mediaStyle['border-radius'] = '50%';
            }
            return this.defaultMediaUrl;
        }
        const finalSizeOptions = this.determineImageSize(media);
        if ((_b = this.sizeOptions) === null || _b === void 0 ? void 0 : _b.cropToCircle) {
            this.mediaStyle['border-radius'] = '50%';
        }
        return this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, this.isSecureGroup, finalSizeOptions.width, finalSizeOptions.height, this.quality, this.isSecure, media.MediaId, this.parentItemName, this.parentAttributeName);
    }
    determineImageSize(media) {
        let finalWidth, finalHeight;
        let topOffset, leftOffset;
        let preserveStyle = false;
        let width = this.sizeOptions.width || this.sizeOptions.maxWidth;
        ;
        let height = this.sizeOptions.height || this.sizeOptions.maxHeight;
        let finalImageSizeOptions = {};
        // Apply modes when we have media and a width & height
        if (media && ((width && height && media.ImageWidth && media.ImageHeight) || this.sizeOptions.mode == DwImageSizeMode.responsiveWidth)) {
            switch (this.sizeOptions.mode) {
                case DwImageSizeMode.max:
                    // Calc aspect ratio and use it to compute optimal width or height
                    var aspectRatio = media.ImageWidth / media.ImageHeight;
                    if (aspectRatio > 1) {
                        finalWidth = width;
                        finalHeight = width / aspectRatio;
                    }
                    else {
                        finalHeight = height;
                        finalWidth = height * aspectRatio;
                    }
                    if (finalHeight > height) {
                        finalHeight = height;
                        finalWidth = height * aspectRatio;
                    }
                    // Don't limit the size of the container
                    finalImageSizeOptions.width = finalWidth;
                    finalImageSizeOptions.height = finalHeight;
                    preserveStyle = true;
                    this.mediaStyle = {
                        width: `${finalWidth}px`,
                        height: `${finalHeight}px`
                    };
                    this.useImageTag = true;
                    width = finalWidth;
                    height = finalHeight;
                    break;
                case DwImageSizeMode.stretch:
                    finalWidth = width;
                    finalHeight = height;
                    break;
                case DwImageSizeMode.crop:
                    // Calc aspect ratio and use it to compute optimal width or height
                    var aspectRatio = media.ImageWidth / media.ImageHeight;
                    if (aspectRatio > 1) {
                        finalWidth = height * aspectRatio;
                        finalHeight = height;
                        leftOffset = ((finalWidth - width) / 2);
                    }
                    else {
                        finalHeight = width / aspectRatio;
                        finalWidth = width;
                        topOffset = ((finalHeight - height) / 2);
                    }
                    break;
                    finalWidth = width;
                    finalHeight = height;
                    break;
                case DwImageSizeMode.responsiveWidth:
                    // Clear Final width/height since it's responsible, instead, set the styles directly
                    finalWidth = null;
                    finalHeight = null;
                    preserveStyle = true;
                    this.mediaStyle = {
                        width: "100%",
                        height: "auto",
                    };
                    this.useImageTag = true;
                    if (this.sizeOptions.maxWidth) {
                        finalImageSizeOptions.width = this.sizeOptions.maxWidth;
                        if (media.ImageWidth && media.ImageWidth) {
                            const aspectRatio = media.ImageWidth / media.ImageHeight;
                            finalImageSizeOptions.height = Math.round(finalImageSizeOptions.width / aspectRatio);
                        }
                    }
            }
        }
        else {
            finalWidth = width;
            finalHeight = height;
        }
        if (!preserveStyle) {
            this.mediaStyle = {};
            finalImageSizeOptions = {};
        }
        if (finalWidth) {
            finalWidth = parseInt(finalWidth);
            this.mediaStyle.width = `${finalWidth}px`;
            finalImageSizeOptions.width = finalWidth;
        }
        if (finalHeight) {
            finalHeight = parseInt(finalHeight);
            this.mediaStyle.height = `${finalHeight}px`;
            finalImageSizeOptions.height = finalHeight;
        }
        this.containerStyle = {
            overflow: 'hidden'
        };
        if (width) {
            this.containerStyle.width = `${width}px`;
        }
        if (height) {
            this.containerStyle.height = `${height}px`;
        }
        if (this.ignoreContainerStyle) {
            this.containerStyle = {};
        }
        return finalImageSizeOptions;
    }
}
DwMediaItemComponent.ɵfac = function DwMediaItemComponent_Factory(t) { return new (t || DwMediaItemComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService)); };
DwMediaItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMediaItemComponent, selectors: [["dw-media-item"]], inputs: { ignoreContainerStyle: "ignoreContainerStyle", quality: "quality", useImageTag: "useImageTag", sizeOptions: "sizeOptions", containerName: "containerName", fileName: "fileName", media: "media", defaultMediaUrl: "defaultMediaUrl", defaultMedia: "defaultMedia", isSecure: "isSecure", isSecureGroup: "isSecureGroup", parentItemName: "parentItemName", parentAttributeName: "parentAttributeName", mediaClass: "mediaClass", heightPercent: "heightPercent", darkenImage: "darkenImage" }, outputs: { mediaChange: "mediaChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "ngStyle", "ngClass", 4, "ngIf"], [4, "ngIf"], [3, "ngStyle", "ngClass"], [3, "src", "ngStyle"]], template: function DwMediaItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMediaItemComponent_div_0_Template, 1, 2, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMediaItemComponent_ng_container_1_Template, 2, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.useImageTag);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.useImageTag);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgStyle, ɵngcc4.NgClass, DwMissingImageDirective], encapsulation: 2 });
DwMediaItemComponent.ctorParameters = () => [
    { type: DwMediaRepositoryService }
];
DwMediaItemComponent.propDecorators = {
    containerName: [{ type: Input }],
    fileName: [{ type: Input }],
    media: [{ type: Input }],
    mediaChange: [{ type: Output }],
    sizeOptions: [{ type: Input }],
    defaultMediaUrl: [{ type: Input }],
    defaultMedia: [{ type: Input }],
    isSecure: [{ type: Input }],
    isSecureGroup: [{ type: Input }],
    parentItemName: [{ type: Input }],
    parentAttributeName: [{ type: Input }],
    ignoreContainerStyle: [{ type: Input }],
    quality: [{ type: Input }],
    mediaClass: [{ type: Input }],
    heightPercent: [{ type: Input }],
    darkenImage: [{ type: Input }],
    useImageTag: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMediaItemComponent, [{
        type: Component,
        args: [{
                selector: 'dw-media-item',
                template: `
      <div [ngStyle]="containerStyle" [ngClass]="mediaClass" *ngIf="!useImageTag">
      </div>

      <ng-container *ngIf="useImageTag">
        <img [src]="mediaUrl" [ngStyle]="mediaStyle">
      </ng-container>
  `
            }]
    }], function () { return [{ type: DwMediaRepositoryService }]; }, { mediaChange: [{
            type: Output
        }], ignoreContainerStyle: [{
            type: Input
        }], quality: [{
            type: Input
        }], useImageTag: [{
            type: Input
        }], sizeOptions: [{
            type: Input
        }], containerName: [{
            type: Input
        }], fileName: [{
            type: Input
        }], media: [{
            type: Input
        }], defaultMediaUrl: [{
            type: Input
        }], defaultMedia: [{
            type: Input
        }], isSecure: [{
            type: Input
        }], isSecureGroup: [{
            type: Input
        }], parentItemName: [{
            type: Input
        }], parentAttributeName: [{
            type: Input
        }], mediaClass: [{
            type: Input
        }], heightPercent: [{
            type: Input
        }], darkenImage: [{
            type: Input
        }] }); })();
__decorate$2h([
    DwInputConverter(booleanConverter),
    __metadata$1M("design:type", Boolean)
], DwMediaItemComponent.prototype, "ignoreContainerStyle", void 0);
__decorate$2h([
    DwInputConverter(intConverter),
    __metadata$1M("design:type", Number)
], DwMediaItemComponent.prototype, "heightPercent", void 0);
__decorate$2h([
    DwInputConverter(booleanConverter),
    __metadata$1M("design:type", Boolean)
], DwMediaItemComponent.prototype, "darkenImage", void 0);
__decorate$2h([
    DwInputConverter(booleanConverter),
    __metadata$1M("design:type", Boolean)
], DwMediaItemComponent.prototype, "useImageTag", void 0);

const defaultAvatarMediaIdAttrName = 'UserPictureMediaId';
const defaultBannerMediaIdAttrName = 'UserBackgroundMediaId';
const defaultBannerHeightPercent = 25;
class DwAvatarBannerSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.avatarMediaIdAttrName = defaultAvatarMediaIdAttrName;
        this.bannerMediaIdAttrName = defaultBannerMediaIdAttrName;
        this.sectionType = 'dwProfileBanner';
    }
}

class DwAvatarBannerConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.availableRelations = [];
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        this.section.avatarMediaIdAttrName = this.section.avatarMediaIdAttrName || defaultAvatarMediaIdAttrName;
        this.section.bannerMediaIdAttrName = this.section.bannerMediaIdAttrName || defaultBannerMediaIdAttrName;
        this.section.bannerHeightPercent = this.section.bannerHeightPercent || defaultBannerHeightPercent;
        if (this.section.loadWithParent !== true) {
            this.section.loadWithParent = false;
        }
        this.setupAvailableRelationships();
    }
    setupAvailableRelationships() {
        var _a;
        if (!this.itemMetaData) {
            return;
        }
        this.availableRelations = (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.Relations.filter(relation => {
            return relation.PkUniqueItemName == 'roMedia';
        });
    }
    setupRelationship(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        this.relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        this.relationshipDisplay = null;
        if (this.relationship) {
            this.relationshipDisplay = `${this.relationship.PkUniqueItemName}.${this.relationship.PkAttributeName} (PK) = ${this.relationship.FkUniqueItemName}.${this.relationship.FkAttributeName} (FK)`;
        }
    }
    setAvatarRelationship(relationshipName) {
        this.section.avatarRelationshipInfo = this.getRelationshipInfo(relationshipName, this.section.avatarRelationshipInfo);
        this.onSectionChange();
    }
    setBannerRelationship(relationshipName) {
        this.section.bannerRelationshipInfo = this.getRelationshipInfo(relationshipName, this.section.bannerRelationshipInfo);
        this.onSectionChange();
    }
    getRelationshipInfo(relationshipName, defaultInfo) {
        const relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        if (!relationship) {
            return null;
        }
        const relationshipInfo = defaultInfo || {};
        relationshipInfo.relationshipName = relationship.RelationshipName;
        relationshipInfo.propertyName = relationship.NamingInfo.RelationshipPropertyName;
        if (this.relationship.IsPrimaryItem) {
            relationshipInfo.childItem = this.relationship.FkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.PkUniqueItemName;
        }
        else {
            relationshipInfo.childItem = this.relationship.PkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.FkUniqueItemName;
        }
        return relationshipInfo;
    }
}
DwAvatarBannerConfigComponent.ɵfac = function DwAvatarBannerConfigComponent_Factory(t) { return ɵDwAvatarBannerConfigComponent_BaseFactory(t || DwAvatarBannerConfigComponent); };
DwAvatarBannerConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAvatarBannerConfigComponent, selectors: [["dw-avatar-banner-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 33, vars: 9, consts: [["header", "Avatar Banner Configuration"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelChange"], ["type", "text", "placeholder", "Add", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"]], template: function DwAvatarBannerConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Load With Parent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_Template_dw_yesno_ngModelChange_7_listener($event) { return ctx.section.loadWithParent = $event; })("ngModelChange", function DwAvatarBannerConfigComponent_Template_dw_yesno_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Banner Height Percent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_Template_input_ngModelChange_11_listener($event) { return ctx.section.bannerHeightPercent = $event; })("ngModelChange", function DwAvatarBannerConfigComponent_Template_input_ngModelChange_11_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, DwAvatarBannerConfigComponent_div_12_Template, 11, 4, "div", 5);
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "div", 2);
        ɵngcc0.ɵɵelementStart(15, "label");
        ɵngcc0.ɵɵtext(16, "Avatar Media Field");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_Template_select_ngModelChange_17_listener($event) { return ctx.section.avatarMediaIdAttrName = $event; })("ngModelChange", function DwAvatarBannerConfigComponent_Template_select_ngModelChange_17_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(18, DwAvatarBannerConfigComponent_option_18_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 2);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Banner Media Field");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "select", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_Template_select_ngModelChange_22_listener($event) { return ctx.section.bannerMediaIdAttrName = $event; })("ngModelChange", function DwAvatarBannerConfigComponent_Template_select_ngModelChange_22_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(23, DwAvatarBannerConfigComponent_option_23_Template, 2, 2, "option", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 1);
        ɵngcc0.ɵɵelementStart(25, "div", 2);
        ɵngcc0.ɵɵelementStart(26, "label");
        ɵngcc0.ɵɵtext(27, "Default Avatar Media Url");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_Template_input_ngModelChange_28_listener($event) { return ctx.section.defaultAvatarMediaUrl = $event; })("ngModelChange", function DwAvatarBannerConfigComponent_Template_input_ngModelChange_28_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 2);
        ɵngcc0.ɵɵelementStart(30, "label");
        ɵngcc0.ɵɵtext(31, "Default Banner Media Url");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "input", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarBannerConfigComponent_Template_input_ngModelChange_32_listener($event) { return ctx.section.defaultBannerMediaUrl = $event; })("ngModelChange", function DwAvatarBannerConfigComponent_Template_input_ngModelChange_32_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.loadWithParent);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.bannerHeightPercent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section == null ? null : ctx.section.loadWithParent);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.avatarMediaIdAttrName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.itemMetaData == null ? null : ctx.itemMetaData.Attributes);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.bannerMediaIdAttrName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.itemMetaData == null ? null : ctx.itemMetaData.Attributes);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.defaultAvatarMediaUrl);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.defaultBannerMediaUrl);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.DefaultValueAccessor, ɵngcc4.NgIf, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
const ɵDwAvatarBannerConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAvatarBannerConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAvatarBannerConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-avatar-banner-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Avatar Banner Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Load With Parent</label>\r\n                    <dw-yesno [(ngModel)]=\"section.loadWithParent\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div> \r\n                <div dwCol=\"6\">\r\n                    <label>Banner Height Percent</label>\r\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.bannerHeightPercent\" (ngModelChange)=\"onSectionChange()\" placeholder=\"Add\">\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"section?.loadWithParent\">\r\n                <div dwCol=\"6\">\r\n                    <label>Avatar Relationship</label>\r\n                    <select [ngModel]=\"section?.avatarRelationshipInfo?.relationshipName\" (ngModelChange)=\"setAvatarRelationship($event)\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of availableRelations\" [ngValue]=\"item.RelationshipName\">\r\n                            {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Banner Relationship</label>\r\n                    <select [ngModel]=\"section.bannerRelationshipInfo?.relationshipName\" (ngModelChange)=\"setBannerRelationship($event)\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of availableRelations\" [ngValue]=\"item.RelationshipName\">\r\n                            {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Avatar Media Field</label>\r\n                    <select [(ngModel)]=\"section.avatarMediaIdAttrName\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of itemMetaData?.Attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Banner Media Field</label>\r\n                    <select [(ngModel)]=\"section.bannerMediaIdAttrName\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of itemMetaData?.Attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select> \r\n                </div> \r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Default Avatar Media Url</label>\r\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.defaultAvatarMediaUrl\" (ngModelChange)=\"onSectionChange()\">\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Default Banner Media Url</label>\r\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.defaultBannerMediaUrl\" (ngModelChange)=\"onSectionChange()\">\r\n                </div> \r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>  \r\n</div>"
            }]
    }], null, null); })();

function getAvatarBannerPrefetchPathInfo(section) {
    var _a, _b;
    const bannerSection = section;
    ;
    const prefetchPathInfo = [];
    if ((_a = bannerSection.avatarRelationshipInfo) === null || _a === void 0 ? void 0 : _a.childItem) {
        prefetchPathInfo.push(getPrefetchInfo(bannerSection.avatarRelationshipInfo));
    }
    if ((_b = bannerSection.bannerRelationshipInfo) === null || _b === void 0 ? void 0 : _b.childItem) {
        prefetchPathInfo.push(getPrefetchInfo(bannerSection.bannerRelationshipInfo));
    }
    return prefetchPathInfo;
}
function getPrefetchInfo(relationshipInfo) {
    return {
        itemName: relationshipInfo.childItem,
        propertyName: relationshipInfo.propertyName,
        relationshipName: relationshipInfo.relationshipName,
    };
}

// @DwSectionComponent({
//   keyName:'dwProfileBanner',
//   display: 'Devware Avatar Banner',
//   configComponent: DwAvatarBannerConfigComponent,
//   sectionIcon: 'fa fa-id-card',
//   hasReadOnlyMode : true,
//   getPrefetchPathInfo: getAvatarBannerPrefetchPathInfo
// })
class DwAvatarBannerComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwOrmDataService, uiConfig, dwActionConfigService, dwMetadataFormUtilService, dwMetaDataFormStateService, dwMetaDataFormActionService, dwMediaRepositoryService, dwMetaDataFormSectionStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwOrmDataService = dwOrmDataService;
        this.uiConfig = uiConfig;
        this.dwActionConfigService = dwActionConfigService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataFormActionService = dwMetaDataFormActionService;
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.inEditMode = false;
        this.editModeClass = '';
        this.actionPrefs = [];
        this.bannerHeightPercent = defaultBannerHeightPercent;
        this.bannerMediaImageSize = {
            maxWidth: 1500,
            mode: DwImageSizeMode.responsiveWidth
        };
        this.bannerMediaImageReSize = {
            cropWidth: 550,
            cropHeight: 138,
            cropRound: false,
            outputWidth: 2400,
            outputHeight: 600,
            allowResize: true
        };
        this.avatarMediaImageSize = {
            width: 250,
            height: 250,
            mode: DwImageSizeMode.crop
        };
        this.avatarMediaImageReSize = {
            cropWidth: 250,
            cropHeight: 250,
            cropRound: true,
            outputWidth: 250,
            outputHeight: 250,
            allowResize: true
        };
        this.loadingMedia = false;
    }
    sectionReadOnlyChanged(readOnly) {
        this.isReadOnly = readOnly;
    }
    sectionConfigChanged() {
        var _a, _b, _c;
        this.bannerFieldName = ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.bannerMediaIdAttrName) || defaultBannerMediaIdAttrName;
        this.avatarFieldName = ((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.avatarMediaIdAttrName) || defaultAvatarMediaIdAttrName;
        this.bannerHeightPercent = ((_c = this.sectionConfig) === null || _c === void 0 ? void 0 : _c.bannerHeightPercent) || defaultBannerHeightPercent;
        this.bannerMediaImageReSize.cropHeight = this.bannerMediaImageReSize.cropWidth * (this.bannerHeightPercent / 100);
        this.loadMedia();
    }
    formConfigChanged() {
        if (!this.formConfig) {
            return;
        }
        this.isReadOnly = this.isSectionReadOnly();
    }
    setBannerMedia(media) {
        this.bannerMedia = media;
        if (!media) {
            return;
        }
        this.setFormControlValue(this.bannerFieldName, media.MediaId);
    }
    setAvatarMedia(media) {
        this.avatarMedia = media;
        if (!media) {
            return;
        }
        this.setFormControlValue(this.avatarFieldName, media.MediaId);
    }
    clearImages() {
        var _a, _b;
        this.setFormControlValue(this.bannerFieldName, null);
        this.setFormControlValue(this.avatarFieldName, null);
        this.avatarMedia = null;
        this.bannerMedia = null;
        this.defaultBannerMediaUrl = ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.defaultBannerMediaUrl) || this.uiConfig.defaultBackgroundImageUrl;
        this.defaultAvatarMediaUrl = ((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.defaultAvatarMediaUrl) || this.uiConfig.defaultAvatarImageUrl;
    }
    saveParent() {
        const parentEntity = {
            _itemName: this.formConfig.rootItemName
        };
        parentEntity[this.dwMetaDataFormStateService.state.formConfig.keyName] = this.dwMetaDataFormStateService.state.formContext.keyValue;
        if (this.bannerFieldName) {
            parentEntity[this.bannerFieldName] = this.getFormControlValue(this.bannerFieldName);
        }
        if (this.avatarFieldName) {
            parentEntity[this.avatarFieldName] = this.getFormControlValue(this.avatarFieldName);
        }
        return this.dwOrmDataService.saveEntity(parentEntity, false);
    }
    loadMedia() {
        var _a, _b, _c;
        // Wait for form to load data
        const formContext = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        if (!formContext) {
            return;
        }
        if (formContext && !((_a = formContext.value) === null || _a === void 0 ? void 0 : _a.loadDataComplete)) {
            this.subscriptions.push(formContext.subscribe((formContext) => {
                if (formContext.loadDataComplete) {
                    this.loadMedia();
                }
            }));
            return;
        }
        if (!this.sectionConfig || !this.formConfig) {
            // Try again in 50 ms
            setTimeout(() => {
                this.loadMedia();
            }, 500);
            return;
        }
        if (this.loadingMedia) {
            return;
        }
        this.loadingMedia = true;
        const dataRelations = this.dwMetadataFormUtilService.getSectionDataPath(this.sectionConfig, this.formConfig.section, this.formConfig.queryMetaDataList);
        const dataContextValue = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME].value;
        let parentDataItem = dataContextValue;
        for (const dataRelation of dataRelations) {
            if (parentDataItem) {
                parentDataItem = parentDataItem[dataRelation.propertyName];
            }
        }
        let bannerMediaId;
        let avatarMediaId;
        if (parentDataItem) {
            bannerMediaId = parentDataItem[this.bannerFieldName];
            avatarMediaId = parentDataItem[this.avatarFieldName];
        }
        else {
            console.warn(`dw-avatar-banner - Can't find parent data`, dataRelations);
        }
        if (!bannerMediaId) {
            this.defaultBannerMediaUrl = ((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.defaultBannerMediaUrl) || this.uiConfig.defaultBackgroundImageUrl;
            bannerMediaId = this.sectionConfig.defaultBannerMediaId;
        }
        if (!avatarMediaId) {
            this.defaultAvatarMediaUrl = ((_c = this.sectionConfig) === null || _c === void 0 ? void 0 : _c.defaultAvatarMediaUrl) || this.uiConfig.defaultAvatarImageUrl;
            avatarMediaId = this.sectionConfig.defaultAvatarMediaId;
        }
        this.dwMediaRepositoryService.loadMedia([bannerMediaId, avatarMediaId])
            .subscribe(mediaItems => {
            this.bannerMedia = mediaItems.find(mi => mi.MediaId == bannerMediaId);
            this.avatarMedia = mediaItems.find(mi => mi.MediaId == avatarMediaId);
            this.loadingMedia = false;
        });
    }
    setFormControlValue(fieldName, fieldValue) {
        let fc = this.formGroup.get(fieldName);
        if (!fc) {
            fc = new FormControl();
            this.formGroup.addControl(fieldName, fc);
        }
        fc.setValue(fieldValue);
        return fc;
    }
    getFormControlValue(fieldName) {
        let fc = this.formGroup.get(fieldName);
        return fc === null || fc === void 0 ? void 0 : fc.value;
    }
    ngOnInit() {
        super.ngOnInit();
        this.buttonBarSection = this.createButtonBarSection();
        this.setupFormActionInterceptor();
        this.dwMetaDataFormStateService.addActionInterceptor(this.formActionInterceptor);
    }
    setupFormActionInterceptor() {
        this.formActionInterceptor = {
            interceptorName: 'imageEditSectionInterceptor',
            onBeforeAction: (actionPref, actionConfig) => {
                const result = {
                    abort: false
                };
                // If not editing, then ignore all events
                if (!this.inEditMode) {
                    return of(result);
                }
                if (actionPref.actionKey == DwFormActionKeys.formSave) {
                    return this.saveParent()
                        .pipe(map(result => {
                        result.message = {
                            messageBody: 'Save Successful',
                            severity: DwMessageSeverity.success,
                            timeToShow: 5000
                        };
                        this.inEditMode = false;
                        result.abort = true;
                        return result;
                    }));
                }
                return of(result);
            },
            onAfterAction: (actionPref, actionConfig, actionResult) => {
                const result = {
                    abort: false
                };
                // If not editing, then ignore all events
                if (!this.inEditMode) {
                    return of(result);
                }
                if (actionConfig.keyName == DwFormActionKeys.formSave) {
                    result.abort = true;
                    result.message = {
                        messageBody: 'Save Successful',
                        severity: DwMessageSeverity.success,
                        timeToShow: 5000
                    };
                    this.inEditMode = false;
                }
                if (actionConfig.keyName == DwFormActionKeys.formCancel) {
                    result.abort = true;
                    this.cancelEdit();
                }
                return of(result);
            }
        };
    }
    cancelEdit() {
        if (this.beforeEditData) {
            this.dwMetaDataFormStateService.state.rootFormGroup.patchValue(this.beforeEditData);
        }
        this.inEditMode = false;
        this.editModeClass = this.inEditMode ? 'dw-banner-edit-mode' : '';
        this.avatarMedia = this.originalAvatarMedia;
        this.bannerMedia = this.originalBannerMedia;
    }
    createButtonBarSection() {
        const buttonBarSection = new DwFormButtonSectionPreference();
        buttonBarSection.useFormButtonDefaults = false;
        buttonBarSection.useFormModes = false;
        // Just show a save and cancel  (These can be customized by adding a button bar to the edit tempalte)
        const buttonDefaults = {};
        buttonDefaults[formModeNone] = [DwFormActionKeys.formSave, DwFormActionKeys.formCancel];
        const actionPreferencesByMode = this.dwMetaDataFormActionService.getDefaultFormActionPreferencesByMode(buttonDefaults);
        buttonBarSection.actionPreferencesByMode = this.dwActionConfigService.buildFinalActionPreferencesByMode(actionPreferencesByMode, this.dwMetaDataFormStateService.state.itemSecurity);
        buttonBarSection.buttonContainerStyleKey = DwButtonBarStyles.basicRight;
        return buttonBarSection;
    }
    toggleEdit() {
        this.inEditMode = !this.inEditMode;
        if (this.inEditMode) {
            this.beforeEditData = this.dwMetaDataFormStateService.state.rootFormGroup.getRawValue();
            this.originalAvatarMedia = this.avatarMedia;
            this.originalBannerMedia = this.bannerMedia;
        }
        this.editModeClass = this.inEditMode ? 'dw-banner-edit-mode' : '';
    }
}
DwAvatarBannerComponent.ɵfac = function DwAvatarBannerComponent_Factory(t) { return new (t || DwAvatarBannerComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormActionService), ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService)); };
DwAvatarBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAvatarBannerComponent, selectors: [["dw-avatar-banner"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 13, vars: 19, consts: [["id", "banner-header", 3, "ngClass"], [1, "dw-banner-container"], ["selectorClass", "dw-banner-media-select", "selectorText", "Change Image...", 3, "disabled", "media", "resizeOptions", "mediaChange"], ["mediaClass", "dw-banner-small", 3, "media", "darkenImage", "sizeOptions", "heightPercent", "defaultMediaUrl"], [1, "dw-banner-avatar-section"], ["selectorClass", "dw-avatar-media-select", "selectorText", "Change Image...", 3, "disabled", "media", "resizeOptions", "mediaChange"], ["mediaClass", "dw-avatar-small dw-avatar-banner-position dw-avatar-image", 3, "media", "darkenImage", "sizeOptions", "defaultMediaUrl"], ["class", "dw-image-floating-top-right", "title", "Edit Images", 3, "click", 4, "ngIf"], ["class", "dw-image-floating-top-right", "title", "Clear Images", 3, "click", 4, "ngIf"], [1, "after-banner"], ["class", "dw-banner-button-bar-location", 4, "ngIf"], ["title", "Edit Images", 1, "dw-image-floating-top-right", 3, "click"], [1, "fa", "fa-pencil", "circle-icon"], ["title", "Clear Images", 1, "dw-image-floating-top-right", 3, "click"], [1, "fa", "fa-user-times", "circle-icon"], [1, "dw-banner-button-bar-location"], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"]], template: function DwAvatarBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "dw-media-selector", 2);
        ɵngcc0.ɵɵlistener("mediaChange", function DwAvatarBannerComponent_Template_dw_media_selector_mediaChange_3_listener($event) { return ctx.setBannerMedia($event); });
        ɵngcc0.ɵɵelement(4, "dw-media-item", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵelementStart(7, "dw-media-selector", 5);
        ɵngcc0.ɵɵlistener("mediaChange", function DwAvatarBannerComponent_Template_dw_media_selector_mediaChange_7_listener($event) { return ctx.setAvatarMedia($event); });
        ɵngcc0.ɵɵelement(8, "dw-media-item", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, DwAvatarBannerComponent_div_9_Template, 2, 0, "div", 7);
        ɵngcc0.ɵɵtemplate(10, DwAvatarBannerComponent_div_10_Template, 2, 0, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(11, "div", 9);
        ɵngcc0.ɵɵtemplate(12, DwAvatarBannerComponent_div_12_Template, 2, 6, "div", 10);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.editModeClass);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", !ctx.inEditMode)("media", ctx.bannerMedia)("resizeOptions", ctx.bannerMediaImageReSize);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("media", ctx.bannerMedia)("darkenImage", ctx.inEditMode)("sizeOptions", ctx.bannerMediaImageSize)("heightPercent", ctx.bannerHeightPercent)("defaultMediaUrl", ctx.defaultBannerMediaUrl);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", !ctx.inEditMode)("media", ctx.avatarMedia)("resizeOptions", ctx.avatarMediaImageReSize);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("media", ctx.avatarMedia)("darkenImage", ctx.inEditMode)("sizeOptions", ctx.avatarMediaImageSize)("defaultMediaUrl", ctx.defaultAvatarMediaUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.inEditMode && !ctx.isReadOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.inEditMode);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.inEditMode);
    } }, directives: function () { return [ɵngcc4.NgClass, DwMediaSelectorComponent, DwMediaItemComponent, ɵngcc4.NgIf, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective]; }, encapsulation: 2 });
DwAvatarBannerComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwMetaDataActionConfigService },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataFormActionService },
    { type: DwMediaRepositoryService },
    { type: DwMetaDataFormSectionStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAvatarBannerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-avatar-banner',
                template: "<div id=\"banner-header\" [ngClass]=\"editModeClass\">\r\n    <div class=\"dw-banner-container\">\r\n        <div>\r\n            <dw-media-selector [disabled]=\"!inEditMode\" selectorClass=\"dw-banner-media-select\"\r\n                selectorText=\"Change Image...\" [media]=\"bannerMedia\" (mediaChange)=\"setBannerMedia($event)\"\r\n                [resizeOptions]=\"bannerMediaImageReSize\">\r\n                <dw-media-item [media]=\"bannerMedia\" [darkenImage]=\"inEditMode\" [sizeOptions]=\"bannerMediaImageSize\"\r\n                    [heightPercent]=\"bannerHeightPercent\" [defaultMediaUrl]=\"defaultBannerMediaUrl\"\r\n                    mediaClass=\"dw-banner-small\"></dw-media-item>\r\n            </dw-media-selector>\r\n        </div>\r\n    </div>\r\n    <div class=\"dw-banner-avatar-section\">\r\n        <div>\r\n            <dw-media-selector [disabled]=\"!inEditMode\" selectorClass=\"dw-avatar-media-select\"\r\n                selectorText=\"Change Image...\" [media]=\"avatarMedia\" (mediaChange)=\"setAvatarMedia($event)\"\r\n                [resizeOptions]=\"avatarMediaImageReSize\">\r\n                <dw-media-item [media]=\"avatarMedia\" [darkenImage]=\"inEditMode\" [sizeOptions]=\"avatarMediaImageSize\"\r\n                    mediaClass=\"dw-avatar-small dw-avatar-banner-position dw-avatar-image\"\r\n                    [defaultMediaUrl]=\"defaultAvatarMediaUrl\"></dw-media-item>\r\n            </dw-media-selector>\r\n        </div>\r\n    </div>\r\n    <div class=\"dw-image-floating-top-right\" (click)=\"toggleEdit()\" *ngIf=\"!inEditMode  && !isReadOnly\" title='Edit Images'>\r\n        <i class=\"fa fa-pencil circle-icon\"></i>\r\n    </div>\r\n\r\n    <div class=\"dw-image-floating-top-right\" (click)=\"clearImages()\" *ngIf=\"inEditMode\" title='Clear Images'>\r\n        <i class=\"fa fa-user-times circle-icon\"></i>\r\n    </div>\r\n</div>\r\n<!-- Placeholder to ensure following content starts in the correct location -->\r\n<div class=\"after-banner\"></div>\r\n\r\n<div *ngIf=\"inEditMode\" class=\"dw-banner-button-bar-location\">\r\n    <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"buttonBarSection\" [formGroup]=\"formGroup\"\r\n        [context]=\"context\" [submitted]=\"submitted\" [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n</div>"
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwMetaDataActionConfigService }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataFormActionService }, { type: DwMediaRepositoryService }, { type: DwMetaDataFormSectionStateService }]; }, null); })();
// Move here to avoid stuff typescript combine error when packaged
DwSectionComponent({
    keyName: 'dwProfileBanner',
    display: 'Devware Avatar Banner',
    configComponent: DwAvatarBannerConfigComponent,
    sectionIcon: 'fa fa-id-card',
    hasReadOnlyMode: true,
    getPrefetchPathInfo: getAvatarBannerPrefetchPathInfo
})(DwAvatarBannerComponent);

class DwMediaModalService {
    constructor(dwModalService) {
        this.dwModalService = dwModalService;
    }
    showSelectFileModal(options, files) {
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Select Image";
        modalConfig.component = DwFileUploadModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = '600px';
        modalConfig.customModalHeight = '700px';
        modalConfig.cloneData = false;
        const modalData = {
            mediaSelectOptions: options,
            files: files,
            allowMultiple: false,
            existingFilesCount: 0
        };
        modalConfig.data = modalData;
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {
            if (!modalResult.cancelled) {
                const fileUploadResult = modalResult.data;
                return fileUploadResult.media[0];
            }
            return null;
        }));
    }
    showMultipleFileModal(options, mediaGroupId, files, maxFiles, existingFileCount) {
        let modalConfig = new DwModalConfig();
        modalConfig.title = "Select Files";
        modalConfig.component = DwFileUploadModalComponent;
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.okAndClose;
        modalConfig.modalSize = DwModalSize.custom;
        modalConfig.customModalWidth = '600px';
        modalConfig.customModalHeight = '700px';
        modalConfig.cloneData = false;
        const modalData = {
            mediaSelectOptions: options,
            files: files,
            allowMultiple: true,
            mediaGroupId: mediaGroupId,
            maxFiles: maxFiles,
            existingFilesCount: existingFileCount
        };
        modalConfig.data = modalData;
        return this.dwModalService.showModal(modalConfig)
            .pipe(map(modalResult => {
            if (!modalResult.cancelled) {
                return modalResult.data;
            }
            return null;
        }));
    }
}
DwMediaModalService.ɵfac = function DwMediaModalService_Factory(t) { return new (t || DwMediaModalService)(ɵngcc0.ɵɵinject(DwModalService)); };
DwMediaModalService.ɵprov = ɵɵdefineInjectable({ factory: function DwMediaModalService_Factory() { return new DwMediaModalService(ɵɵinject(DwModalService)); }, token: DwMediaModalService, providedIn: "root" });
DwMediaModalService.ctorParameters = () => [
    { type: DwModalService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMediaModalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwModalService }]; }, null); })();

var __decorate$2i = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1N = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMediaSelectorComponent {
    constructor(dwMediaModalService) {
        this.dwMediaModalService = dwMediaModalService;
        this.mediaChange = new EventEmitter();
        this.disabled = false;
        this.selectorText = 'Change...';
        this.selectorIcon = 'fa fa-camera';
        this.selectorClass = '';
        this.showSelectorText = true;
        this.showFileSelectorFirst = true;
    }
    ngOnInit() {
    }
    selectFiles(files, fileInput) {
        var _a, _b;
        if (this.showFileSelectorFirst && !files) {
            (_b = (_a = this.fileSingle) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.click();
            return;
        }
        if (this.disabled) {
            return;
        }
        const options = {
            allowedFileTypes: this.allowedFileTypes,
            imageResizeOptions: this.resizeOptions || {
                cropWidth: 300,
                cropHeight: 300,
                cropRound: true,
            },
            isSecure: this.isSecure,
            parentItemName: this.parentItemName,
            parentAttributeName: this.parentAttributeName,
            uploadInstructions: this.uploadInstructions
        };
        // let file: File;
        // if (files && files.length>0) {
        //   file = files[0];
        // }
        this.dwMediaModalService.showSelectFileModal(options, files)
            .subscribe(media => {
            if (!media) {
                return;
            }
            this.media = media.DwroMedia;
            this.mediaChange.emit(this.media);
        });
    }
}
DwMediaSelectorComponent.ɵfac = function DwMediaSelectorComponent_Factory(t) { return new (t || DwMediaSelectorComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaModalService)); };
DwMediaSelectorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMediaSelectorComponent, selectors: [["dw-media-selector"]], viewQuery: function DwMediaSelectorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c97, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileSingle = _t.first);
    } }, inputs: { disabled: "disabled", selectorText: "selectorText", selectorIcon: "selectorIcon", selectorClass: "selectorClass", showSelectorText: "showSelectorText", showFileSelectorFirst: "showFileSelectorFirst", media: "media", allowedFileTypes: "allowedFileTypes", resizeOptions: "resizeOptions", isSecure: "isSecure", parentItemName: "parentItemName", parentAttributeName: "parentAttributeName", uploadInstructions: "uploadInstructions" }, outputs: { mediaChange: "mediaChange" }, ngContentSelectors: _c5, decls: 5, vars: 2, consts: [["dwDwFileDrop", "", 3, "ngClass", "click", "fileDrop", 4, "ngIf"], ["type", "file", "placeholder", "Choose file", 2, "display", "none", 3, "accept", "change"], ["fileSingle", ""], ["dwDwFileDrop", "", 3, "ngClass", "click", "fileDrop"], ["id", "media-selector-inner", 3, "hidden"], [3, "ngClass"], ["id", "media-selector-text"]], template: function DwMediaSelectorComponent_Template(rf, ctx) { if (rf & 1) {
        const _r5 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, DwMediaSelectorComponent_div_1_Template, 6, 4, "div", 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "input", 1, 2);
        ɵngcc0.ɵɵlistener("change", function DwMediaSelectorComponent_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r5); const _r1 = ɵngcc0.ɵɵreference(4); return ctx.selectFiles(_r1.files, _r1); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("accept", ctx.allowedFileTypes);
    } }, directives: [ɵngcc4.NgIf, DwFileDropDirective, ɵngcc4.NgClass], encapsulation: 2 });
DwMediaSelectorComponent.ctorParameters = () => [
    { type: DwMediaModalService }
];
DwMediaSelectorComponent.propDecorators = {
    allowedFileTypes: [{ type: Input }],
    resizeOptions: [{ type: Input }],
    media: [{ type: Input }],
    mediaChange: [{ type: Output }],
    disabled: [{ type: Input }],
    selectorText: [{ type: Input }],
    selectorIcon: [{ type: Input }],
    selectorClass: [{ type: Input }],
    isSecure: [{ type: Input }],
    parentItemName: [{ type: Input }],
    parentAttributeName: [{ type: Input }],
    uploadInstructions: [{ type: Input }],
    showSelectorText: [{ type: Input }],
    fileSingle: [{ type: ViewChild, args: ['fileSingle', { static: true },] }],
    showFileSelectorFirst: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMediaSelectorComponent, [{
        type: Component,
        args: [{
                selector: 'dw-media-selector',
                template: `
  <div>
    <div *ngIf="!disabled" [ngClass]="selectorClass" (click)="selectFiles()"  dwDwFileDrop (fileDrop)="selectFiles($event)">
      <div id="media-selector-inner" [hidden]="!showSelectorText">
        <i [ngClass]="selectorIcon"></i><br />
        <span id="media-selector-text">{{selectorText}}</span>
        </div>
    </div>
    <ng-content></ng-content>
    <input type="file" #fileSingle placeholder="Choose file" (change)="selectFiles(fileSingle.files, fileSingle)" [accept]="allowedFileTypes" style="display:none;">
  </div>
 `
            }]
    }], function () { return [{ type: DwMediaModalService }]; }, { mediaChange: [{
            type: Output
        }], disabled: [{
            type: Input
        }], selectorText: [{
            type: Input
        }], selectorIcon: [{
            type: Input
        }], selectorClass: [{
            type: Input
        }], showSelectorText: [{
            type: Input
        }], showFileSelectorFirst: [{
            type: Input
        }], media: [{
            type: Input
        }], allowedFileTypes: [{
            type: Input
        }], resizeOptions: [{
            type: Input
        }], isSecure: [{
            type: Input
        }], parentItemName: [{
            type: Input
        }], parentAttributeName: [{
            type: Input
        }], uploadInstructions: [{
            type: Input
        }], fileSingle: [{
            type: ViewChild,
            args: ['fileSingle', { static: true }]
        }] }); })();
__decorate$2i([
    DwInputConverter(booleanConverter),
    __metadata$1N("design:type", Boolean)
], DwMediaSelectorComponent.prototype, "disabled", void 0);
__decorate$2i([
    DwInputConverter(booleanConverter),
    __metadata$1N("design:type", Boolean)
], DwMediaSelectorComponent.prototype, "showSelectorText", void 0);
__decorate$2i([
    DwInputConverter(booleanConverter),
    __metadata$1N("design:type", Boolean)
], DwMediaSelectorComponent.prototype, "showFileSelectorFirst", void 0);

class DwImageSectionConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb, dwMediaRepository) {
        super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
        this.fb = fb;
        this.dwMediaRepository = dwMediaRepository;
        this.availableRelations = [];
        this.fileExtensionsLookup = MediaMetaDataLookups.MediaFileExtensionAllItems;
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        this.section.validationConfig = this.section.validationConfig || {};
        setDefaults(this.section, false, 'imagesOnly', 'isSecure');
        this.loadMediaSecurity();
        this.setupAvailableRelationships();
    }
    setupAvailableRelationships() {
        var _a;
        if (!this.itemMetaData) {
            return;
        }
        this.availableRelations = (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.Relations.filter(relation => {
            return relation.PkUniqueItemName == 'roMedia';
        });
    }
    onSectionChange() {
        this.checkMediaSecurity();
        super.onSectionChange();
    }
    setupRelationship(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        this.relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        this.relationshipDisplay = null;
        if (this.relationship) {
            this.relationshipDisplay = `${this.relationship.PkUniqueItemName}.${this.relationship.PkAttributeName} (PK) = ${this.relationship.FkUniqueItemName}.${this.relationship.FkAttributeName} (FK)`;
        }
    }
    setImageRelationship(relationshipName) {
        this.section.imageRelationshipInfo = this.getRelationshipInfo(relationshipName, this.section.imageRelationshipInfo);
        this.onSectionChange();
    }
    loadMediaSecurity() {
        if (!this.itemMetaData || this.allMediaSecurity) {
            return;
        }
        this.dwMediaRepository.loadMediaSecurity(this.itemMetaData.MetaDataItemId)
            .subscribe(result => {
            this.allMediaSecurity = result;
            this.checkMediaSecurity();
        });
    }
    checkMediaSecurity() {
        if (!this.allMediaSecurity || !this.itemMetaData) {
            return;
        }
        this.currentMediaSecurity = null;
        if (!this.section.imageMediaIdAttrName) {
            return;
        }
        const attr = this.itemMetaData.Attributes.find(a => a.AttributeName == this.section.imageMediaIdAttrName);
        if (!attr) {
            return;
        }
        this.addMediaSecurityLink = `/admin/security/media/add?MetaDataItemId=${this.itemMetaData.MetaDataItemId}&MediaMetaDataAttributeId=${attr.MetaDataAttributeId}`;
        this.currentMediaSecurity = this.allMediaSecurity.find(ms => ms.MediaMetaDataAttributeId == attr.MetaDataAttributeId);
    }
    getRelationshipInfo(relationshipName, defaultInfo) {
        const relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        if (!relationship) {
            return null;
        }
        const relationshipInfo = defaultInfo || {};
        relationshipInfo.relationshipName = relationship.RelationshipName;
        relationshipInfo.propertyName = relationship.NamingInfo.RelationshipPropertyName;
        if (this.relationship.IsPrimaryItem) {
            relationshipInfo.childItem = this.relationship.FkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.PkUniqueItemName;
        }
        else {
            relationshipInfo.childItem = this.relationship.PkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.FkUniqueItemName;
        }
        return relationshipInfo;
    }
}
DwImageSectionConfigComponent.ɵfac = function DwImageSectionConfigComponent_Factory(t) { return new (t || DwImageSectionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService)); };
DwImageSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwImageSectionConfigComponent, selectors: [["dw-image-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 52, vars: 16, consts: [["header", "Image/File Configuration"], ["dwRow", ""], ["dwCol", "6"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "4"], [3, "ngModel", "ngModelChange"], ["dwCol", "4", 4, "ngIf"], ["title", "Shows the select file dialog before showing the modal", 1, "fa", "fa-info-circle"], ["dwCol", "6", 4, "ngIf"], ["title", "Text that is displayed in read-only mode when there is not file", 1, "fa", "fa-info-circle"], ["type", "text", "placeholder", "None", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "12"], ["title", "Add any instructions that will be displayed above the file upload. (e.g. Preferred Image dimensions or file types)", 1, "fa", "fa-info-circle"], ["title", "Changing this will break any existing images in this table", 1, "fa", "fa-info-circle"], [4, "ngIf"], ["header", "Validation", 4, "ngIf"], [3, "ngValue"], ["title", "Only shows the image in a full width view - exclude name, size and download option", 1, "fa", "fa-info-circle"], [3, "ngModel", "lookupId", "ngModelChange"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "hidden"], [1, "fa", "fa-check-circle", "dw-green"], [1, "fa", "fa-minus-circle", "dw-red"], [3, "href"], [3, "ngModel"], ["formatType", "yesno", 3, "ngModel"], ["title", "Ensures the user can view the record this media is assigned to", 1, "fa", "fa-info-circle"], ["header", "Validation"], [3, "config", "configContext", "configChange"]], template: function DwImageSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Media Attribute");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "select", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_select_ngModelChange_7_listener($event) { return ctx.section.imageMediaIdAttrName = $event; })("ngModelChange", function DwImageSectionConfigComponent_Template_select_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(8, DwImageSectionConfigComponent_option_8_Template, 2, 2, "option", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 2);
        ɵngcc0.ɵɵelementStart(10, "label");
        ɵngcc0.ɵɵtext(11, "Label");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_input_ngModelChange_12_listener($event) { return ctx.section.label = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 1);
        ɵngcc0.ɵɵelementStart(14, "div", 6);
        ɵngcc0.ɵɵelementStart(15, "label");
        ɵngcc0.ɵɵtext(16, "Images Only");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "dw-yesno", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_17_listener($event) { return ctx.section.imagesOnly = $event; })("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_17_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(18, DwImageSectionConfigComponent_div_18_Template, 5, 1, "div", 8);
        ɵngcc0.ɵɵelementStart(19, "div", 6);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Show File Selector First ");
        ɵngcc0.ɵɵelement(22, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "dw-yesno", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_23_listener($event) { return ctx.section.showFileSelectorFirst = $event; })("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_23_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(24, DwImageSectionConfigComponent_div_24_Template, 4, 1, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "div", 1);
        ɵngcc0.ɵɵtemplate(26, DwImageSectionConfigComponent_div_26_Template, 4, 2, "div", 8);
        ɵngcc0.ɵɵelementStart(27, "div", 6);
        ɵngcc0.ɵɵelementStart(28, "label");
        ɵngcc0.ɵɵtext(29, "Show File Size");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "dw-yesno", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_30_listener($event) { return ctx.section.showSize = $event; })("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_30_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 6);
        ɵngcc0.ɵɵelementStart(32, "label");
        ɵngcc0.ɵɵtext(33, "No File Text Override ");
        ɵngcc0.ɵɵelement(34, "i", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "input", 12);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_input_ngModelChange_35_listener($event) { return ctx.section.noFileTextOverride = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(36, DwImageSectionConfigComponent_div_36_Template, 9, 2, "div", 13);
        ɵngcc0.ɵɵelementStart(37, "div", 1);
        ɵngcc0.ɵɵelementStart(38, "div", 14);
        ɵngcc0.ɵɵelementStart(39, "label");
        ɵngcc0.ɵɵtext(40, "Upload Instructions ");
        ɵngcc0.ɵɵelement(41, "i", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_input_ngModelChange_42_listener($event) { return ctx.section.uploadInstructions = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "div", 1);
        ɵngcc0.ɵɵelementStart(44, "div", 14);
        ɵngcc0.ɵɵelementStart(45, "label");
        ɵngcc0.ɵɵtext(46, "Secure Image ");
        ɵngcc0.ɵɵelement(47, "i", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(48, "dw-yesno", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_48_listener($event) { return ctx.section.isSecure = $event; })("ngModelChange", function DwImageSectionConfigComponent_Template_dw_yesno_ngModelChange_48_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(49, DwImageSectionConfigComponent_div_49_Template, 11, 3, "div", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(50, DwImageSectionConfigComponent_ng_container_50_Template, 18, 3, "ng-container", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(51, DwImageSectionConfigComponent_p_tabPanel_51_Template, 2, 2, "p-tabPanel", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.imageMediaIdAttrName);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.itemMetaData == null ? null : ctx.itemMetaData.Attributes);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.label);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.imagesOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.imagesOnly);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.showFileSelectorFirst);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.imagesOnly && ctx.section.showImageOnly);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.imagesOnly);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.showSize);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.noFileTextOverride);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.imagesOnly);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.uploadInstructions);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.isSecure);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.isSecure);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.isSecure && ctx.currentMediaSecurity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section == null ? null : ctx.section.validationConfig);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.SelectControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc3.DefaultValueAccessor, DwYesNoComponent, ɵngcc4.NgIf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwMultiSelectAdhocComponent, DwNumericDirective, DwReadOnlyControlComponent, DwFieldValidationConfigComponent], styles: [""] });
DwImageSectionConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder },
    { type: DwMediaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwImageSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-image-section-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Image/File Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Media Attribute</label>\r\n                    <select [(ngModel)]=\"section.imageMediaIdAttrName\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let item of itemMetaData?.Attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Label</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.label\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n           \r\n            <div dwRow>\r\n                <div dwCol=\"4\">\r\n                    <label>Images Only</label>\r\n                    <dw-yesno [(ngModel)]=\"section.imagesOnly\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n\r\n                <div dwCol=\"4\" *ngIf=\"section.imagesOnly\">\r\n                    <label>Show Image Only <i class=\"fa fa-info-circle\" title=\"Only shows the image in a full width view - exclude name, size and download option\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.showImageOnly\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Show File Selector First <i class=\"fa fa-info-circle\" title=\"Shows the select file dialog before showing the modal\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.showFileSelectorFirst\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\" *ngIf=\"section.imagesOnly && section.showImageOnly\">\r\n                    <label>Image Class</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.imageMediaClass\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"4\" *ngIf=\"!section.imagesOnly\">\r\n                    <label>Allowed File Types</label>\r\n                    <dw-multi-select-adhoc-lookup [(ngModel)]=\"section.allowedFileTypes\" [lookupId]=\"fileExtensionsLookup\"></dw-multi-select-adhoc-lookup>\r\n                </div> \r\n                <div dwCol=\"4\">\r\n                    <label>Show File Size</label>\r\n                    <dw-yesno [(ngModel)]=\"section.showSize\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n\r\n                <div dwCol=\"4\">\r\n                    <label>No File Text Override <i class=\"fa fa-info-circle\" title=\"Text that is displayed in read-only mode when there is not file\"></i></label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.noFileTextOverride\" class=\"form-control\" placeholder=\"None\">\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"section.imagesOnly\">\r\n                <div dwCol=\"6\">\r\n                    <label>Max Width</label>\r\n                    <input type=\"text\" dwNumeric [(ngModel)]=\"section.maxWidth\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Max Height</label>\r\n                    <input type=\"text\" dwNumeric [(ngModel)]=\"section.maxHeight\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Upload Instructions <i class=\"fa fa-info-circle\" title=\"Add any instructions that will be displayed above the file upload. (e.g. Preferred Image dimensions or file types)\"></i></label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.uploadInstructions\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Secure Image <i class=\"fa fa-info-circle\" title=\"Changing this will break any existing images in this table\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.isSecure\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n\r\n                    <div *ngIf=\"section.isSecure\">\r\n                        <span [hidden]=\"!currentMediaSecurity\">\r\n                            <i class=\"fa fa-check-circle dw-green\"></i> Media Security Setup Complete!\r\n\r\n                        </span>\r\n                        <span [hidden]=\"currentMediaSecurity\">\r\n                            <i class=\"fa fa-minus-circle dw-red\"></i> Secure images require a configuration record in\r\n                            Media Security. \r\n\r\n                            <a href=\"{{addMediaSecurityLink}}\">Add Media Security</a>\r\n                        </span>\r\n                        <br><br>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <ng-container *ngIf=\"section.isSecure && currentMediaSecurity\">\r\n                <b>Media Security Details</b>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <label>View All Permission</label>\r\n                        <dw-readonly [ngModel]=\"currentMediaSecurity.ViewAllPermissionMeaning\"></dw-readonly>\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <label>Allow Emulation</label>\r\n                        <dw-readonly [ngModel]=\"currentMediaSecurity.AllowEmulation\" formatType=\"yesno\"></dw-readonly>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <label>Check Parent Table <i class=\"fa fa-info-circle\"\r\n                                title=\"Ensures the user can view the record this media is assigned to\"></i></label>\r\n                        <dw-readonly [ngModel]=\"currentMediaSecurity.CheckParentTable\" formatType=\"yesno\"></dw-readonly>\r\n                    </div>\r\n                </div>\r\n            </ng-container>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Validation\" *ngIf=\"section?.validationConfig\">\r\n            <dw-field-validation-config [(config)]=\"section.validationConfig\" [configContext]=\"metaDataConfigContext\"></dw-field-validation-config>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }, { type: DwMediaRepositoryService }]; }, null); })();

class DwImageSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, uiConfig, dwActionConfigService, dwMetadataFormUtilService, dwMetaDataFormStateService, dwMetaDataFormActionService, dwMediaRepositoryService, dwAdhocLookupService, dwFileUtilService, dwFormValidationService, dwMediaConfig, dwMetaDataFormSectionStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.uiConfig = uiConfig;
        this.dwActionConfigService = dwActionConfigService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataFormActionService = dwMetaDataFormActionService;
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.dwAdhocLookupService = dwAdhocLookupService;
        this.dwFileUtilService = dwFileUtilService;
        this.dwFormValidationService = dwFormValidationService;
        this.dwMediaConfig = dwMediaConfig;
        this.isReadOnly = false;
        this.invalidConfiguration = false;
        this.imageMediaImageSize = {
            maxWidth: 550,
            mode: DwImageSizeMode.max
        };
        this.imageMediaImageReSize = {
            cropWidth: 412.5,
            cropHeight: 550,
            cropRound: false,
            outputWidth: 600,
            outputHeight: 800,
            maintainAspectRatio: true,
            allowResize: false
        };
        this.formControlSetup = false;
        this.isRequired = false;
        this.loading = true;
        this.loadingMedia = false;
        this.imageValidationKey = 'imageValidationKey';
    }
    sectionReadOnlyChanged(readOnly) {
        this.isReadOnly = readOnly;
    }
    setupComponentComplete() {
        this.sectionConfig.noFileTextOverride;
        if (!this.sectionConfig.imageMediaIdAttrName) {
            this.invalidConfiguration = true;
            this.invalidConfigurationMessage = 'Media Attribute not set';
            return;
        }
        if (this.sectionConfig.maxWidth) {
            this.imageMediaImageSize.maxWidth = this.sectionConfig.maxWidth;
        }
        if (this.sectionConfig.maxHeight) {
            this.imageMediaImageSize.maxHeight = this.sectionConfig.maxHeight;
        }
        if (this.sectionConfig.showImageOnly) {
            this.imageMediaImageSize.mode = DwImageSizeMode.responsiveWidth;
        }
        this.isReadOnly = this.isSectionReadOnly();
        this.initMedia();
    }
    setBannerMedia(media) {
        var _a;
        this.imageMedia = media;
        if (!media) {
            return;
        }
        this.setFormControlValue((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.imageMediaIdAttrName, media.MediaId);
    }
    setImageMedia(media) {
        var _a;
        this.imageMedia = media;
        this.processMedia();
        if (!media) {
            return;
        }
        this.setFormControlValue((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.imageMediaIdAttrName, media.MediaId);
    }
    clearImages() {
        var _a;
        this.setFormControlValue((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.imageMediaIdAttrName, null);
        this.imageMedia = null;
        this.imageMediaExt = null;
    }
    initMedia() {
        var _a, _b;
        this.runAfterFormDataLoaded(() => this.loadMedia());
        if ((_a = this.sectionConfig.validationConfig) === null || _a === void 0 ? void 0 : _a.validators.find(v => v.validatorKey == DwFormValidators.required)) {
            this.isRequired = true;
        }
        const allowedFileTypesArray = this.dwAdhocLookupService.convertAdhocStringToArray((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.allowedFileTypes);
        let allowedFileTypes = allowedFileTypesArray.map(fileType => `.${fileType}`).join(',');
        if (this.sectionConfig.imagesOnly) {
            allowedFileTypes = this.dwMediaConfig.webImageFileExtensions;
        }
        this.allowedFileTypes = allowedFileTypes;
    }
    loadMedia() {
        if (this.loadingMedia) {
            return;
        }
        this.loadingMedia = true;
        const dataRelations = this.dwMetadataFormUtilService.getSectionDataPath(this.sectionConfig, this.formConfig.section, this.formConfig.queryMetaDataList);
        const dataContextValue = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME].value;
        let parentDataItem = dataContextValue;
        for (const dataRelation of dataRelations) {
            if (parentDataItem) {
                parentDataItem = parentDataItem[dataRelation.propertyName];
            }
        }
        let imageMediaId;
        if (parentDataItem) {
            imageMediaId = parentDataItem[this.sectionConfig.imageMediaIdAttrName];
            this.setFormControlValue(this.sectionConfig.imageMediaIdAttrName, imageMediaId);
        }
        else {
            console.warn(`dw-image-section - Can't find parent data`, dataRelations);
        }
        if (!imageMediaId) {
            this.loadingMedia = false;
            this.loading = false;
            return;
        }
        this.dwMediaRepositoryService.loadMedia(imageMediaId)
            .subscribe(mediaItems => {
            this.imageMedia = mediaItems.find(mi => mi.MediaId == imageMediaId);
            this.processMedia();
            this.loadingMedia = false;
            this.loading = false;
        });
    }
    processMedia() {
        const media = [this.imageMedia];
        this.dwFileUtilService.populateMediaDetails(media, 300, 300, this.sectionConfig.isSecure, false, this.formConfig.rootItemName, this.sectionConfig.imageMediaIdAttrName)
            .subscribe(mediaExtItems => {
            this.imageMediaExt = mediaExtItems[0];
        });
    }
    setFormControlValue(fieldName, fieldValue) {
        if (this.formConfig.readOnly || this.sectionConfig.isReadOnly) {
            return;
        }
        this.imageFC = this.formGroup.get(fieldName);
        if (!this.imageFC) {
            this.imageFC = new FormControl();
            // const validators = this.dwMetadataFormValidationBuilderService.buildValidators(fc, this.sectionConfig.validationConfig);
            // fc.setValidators(validators);
            this.formGroup.addControl(fieldName, this.imageFC);
        }
        this.setupValidation();
        if (this.imageFC.disabled) {
            this.imageFC.enable();
        }
        this.imageFC.setValue(fieldValue);
        this.formControlSetup = true;
        return this.imageFC;
    }
    setupValidation() {
        var _a;
        if (!this.imageFC) {
            return;
        }
        if ((_a = this.formConfig) === null || _a === void 0 ? void 0 : _a.readOnly) {
            return;
        }
        if (this.dwFormValidationService.hasConditionalValidation(this.sectionConfig.validationConfig) && !this.conditionalExpressionState) {
            this.conditionalExpressionState = this.dwFormValidationService.initConditionalExpressionState(this.imageValidationKey, this.sectionConfig.validationConfig, this.formGroup, this.context, (state => {
                this.conditionalExpressionState = state;
                this.setupValidation();
            }));
        }
        // Run in timeout to prevent change after checked error
        setTimeout(() => {
            var _a, _b;
            const validatorsResult = this.dwFormValidationService.buildValidators(this.imageFC, (_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.validationConfig, this.imageValidationKey, (_b = this.conditionalExpressionState) === null || _b === void 0 ? void 0 : _b.conditionalExpressionResult);
            this.imageFC.setValidators(validatorsResult.validators);
            this.imageFC.updateValueAndValidity();
        });
    }
    ngOnInit() {
        super.ngOnInit();
    }
    ngOnDestroy() {
        var _a, _b;
        super.ngOnDestroy();
        if (this.formGroup && ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.imageMediaIdAttrName)) {
            const control = this.formGroup.get((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.imageMediaIdAttrName);
            if (control) {
                setTimeout(() => {
                    control.disable();
                });
            }
        }
    }
}
DwImageSectionComponent.ɵfac = function DwImageSectionComponent_Factory(t) { return new (t || DwImageSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormActionService), ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwAdhocLookupService), ɵngcc0.ɵɵdirectiveInject(DwFileUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormValidationBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMediaConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService)); };
DwImageSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwImageSectionComponent, selectors: [["dw-image-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "hide-print dw-invalid-section", 4, "ngIf"], [4, "ngIf"], [1, "hide-print", "dw-invalid-section"], ["id", "icon", 1, "fas", "fa-cog"], ["id", "message"], [2, "width", "100%"], ["useImageTag", "true", 3, "media", "sizeOptions", "isSecure", "parentItemName", "parentAttributeName", "mediaClass"], ["class", "label", 4, "ngIf"], [3, "show"], ["selectorClass", "dw-media-select", "showSelectorText", "false", "selectorText", "Change Image...", 3, "disabled", "allowedFileTypes", "media", "resizeOptions", "isSecure", "parentItemName", "showFileSelectorFirst", "parentAttributeName", "uploadInstructions", "mediaChange", 4, "ngIf"], [3, "formGroup", 4, "ngIf"], [1, "label"], ["title", "Required", 1, "required-label", 3, "hidden"], [3, "media", "isSecure", "parentItemName", "showSize", "parentAttributeName", "disabled", "removeMedia"], ["selectorClass", "dw-media-select", "showSelectorText", "false", "selectorText", "Change Image...", 3, "disabled", "allowedFileTypes", "media", "resizeOptions", "isSecure", "parentItemName", "showFileSelectorFirst", "parentAttributeName", "uploadInstructions", "mediaChange"], [2, "overflow", "auto", 3, "hidden"], ["dwDwFileDrop", "", 1, "dw-drop-box2", 3, "click", "fileDrop"], [1, "fa", "fa-upload"], [3, "formGroup"], [3, "formControlName", "submitted"]], template: function DwImageSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwImageSectionComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwImageSectionComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidConfiguration);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.invalidConfiguration);
    } }, directives: function () { return [ɵngcc4.NgIf, DwMediaItemComponent, DwLoadingComponent, DwMediaItemCardComponent, DwMediaSelectorComponent, DwFileDropDirective, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwValidationInfo, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName]; }, styles: [""] });
DwImageSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwMetaDataActionConfigService },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataFormActionService },
    { type: DwMediaRepositoryService },
    { type: DwAdhocLookupService },
    { type: DwFileUtilService },
    { type: DwMetadataFormValidationBuilderService },
    { type: undefined, decorators: [{ type: Inject, args: [DwMediaConfigToken,] }] },
    { type: DwMetaDataFormSectionStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwImageSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-image-section',
                template: "<div *ngIf=\"invalidConfiguration\" class=\"hide-print dw-invalid-section\">\r\n    <i class=\"fas fa-cog\" id=\"icon\"></i>\r\n\r\n    <div id=\"message\">Image/File section has an invalid configuration. ({{invalidConfigurationMessage}})</div>\r\n</div>\r\n<ng-container *ngIf=\"!invalidConfiguration\">\r\n\r\n\r\n    <ng-container *ngIf=\"sectionConfig?.showImageOnly\">\r\n        <div style=\"width:100%\">\r\n            <dw-media-item [media]=\"imageMediaExt\" [sizeOptions]=\"imageMediaImageSize\"\r\n                [isSecure]=\"sectionConfig.isSecure\" [parentItemName]=\"formConfig.rootItemName\"\r\n                [parentAttributeName]=\"sectionConfig.imageMediaIdAttrName\" useImageTag=\"true\" [mediaClass]=\"sectionConfig?.imageMediaClass\">\r\n            </dw-media-item>\r\n        </div>\r\n\r\n    </ng-container>\r\n    <ng-container *ngIf=\"!sectionConfig?.showImageOnly\">\r\n\r\n\r\n        <label class=\"label\" *ngIf=\"sectionConfig?.label\">{{sectionConfig.label}} <span class=\"required-label\"\r\n                [hidden]=\"!isRequired || isReadOnly\" title=\"Required\">&nbsp;*</span></label>\r\n\r\n        <div>\r\n            <dw-loading [show]=\"loadingMedia\"></dw-loading>\r\n\r\n            <ng-container *ngIf=\"imageMediaExt\">\r\n                <dw-media-item-card [media]=\"imageMediaExt\" [isSecure]=\"sectionConfig.isSecure\"\r\n                    [parentItemName]=\"formConfig.rootItemName\" [showSize]=\"sectionConfig.showSize\"\r\n                    [parentAttributeName]=\"sectionConfig.imageMediaIdAttrName\" (removeMedia)=\"clearImages()\"\r\n                    [disabled]=\"isReadOnly\">\r\n                </dw-media-item-card>\r\n            </ng-container>\r\n\r\n            <div *ngIf=\"!loading && (!imageMediaExt) && isReadOnly\">\r\n                {{sectionConfig.noFileTextOverride || 'None' }}\r\n            </div>\r\n\r\n            <dw-media-selector [disabled]=\"isReadOnly\" selectorClass=\"dw-media-select\" showSelectorText=\"false\"\r\n                [allowedFileTypes]=\"allowedFileTypes\" *ngIf=\"!imageMedia && !isReadOnly\" selectorText=\"Change Image...\"\r\n                [media]=\"imageMedia\" (mediaChange)=\"setImageMedia($event)\" [resizeOptions]=\"imageMediaImageReSize\"\r\n                [isSecure]=\"sectionConfig.isSecure\" [parentItemName]=\"formConfig.rootItemName\" [showFileSelectorFirst]=\"sectionConfig.showFileSelectorFirst\"\r\n                [parentAttributeName]=\"sectionConfig.imageMediaIdAttrName\" [uploadInstructions]=\"sectionConfig.uploadInstructions\">\r\n\r\n                <!-- <div class=\"dw-drop-box\">\r\n            <div>Click here or drag a file to upload.</div>\r\n        </div> -->\r\n                <div style=\"overflow:auto\" [hidden]=\"loading || isReadOnly\">\r\n                    <div class=\"dw-drop-box2\" (click)=\"selectFiles()\" dwDwFileDrop (fileDrop)=\"selectFiles($event)\">\r\n                        <div><i class=\"fa fa-upload\"></i> Click here or drag files to upload</div>\r\n                    </div>\r\n                </div>\r\n\r\n            </dw-media-selector>\r\n            <!-- <div style=\"width:100%\">\r\n                <dw-media-item [media]=\"imageMedia\" [sizeOptions]=\"imageMediaImageSize\"\r\n                    [isSecure]=\"sectionConfig.isSecure\" [parentItemName]=\"formConfig.rootItemName\"\r\n                    [parentAttributeName]=\"sectionConfig.imageMediaIdAttrName\" mediaClass=\"dw-banner-small\">\r\n                </dw-media-item>\r\n            </div> -->\r\n\r\n            <div [formGroup]=\"formGroup\" *ngIf=\"formGroup && formControlSetup\">\r\n                <dw-validation-info [formControlName]=\"this.sectionConfig?.imageMediaIdAttrName\"\r\n                    [submitted]=\"submitted\">\r\n                </dw-validation-info>\r\n            </div>\r\n        </div>\r\n\r\n    </ng-container>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwMetaDataActionConfigService }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataFormActionService }, { type: DwMediaRepositoryService }, { type: DwAdhocLookupService }, { type: DwFileUtilService }, { type: DwMetadataFormValidationBuilderService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwMediaConfigToken]
            }] }, { type: DwMetaDataFormSectionStateService }]; }, null); })();
DwSectionComponentFunc({
    keyName: 'dwImageSection',
    display: 'Image/File Section',
    configComponent: DwImageSectionConfigComponent,
    sectionIcon: 'fa fa-image',
    hasReadOnlyMode: true
}, DwImageSectionComponent);

class DwMultiFileSectionConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor(uiMetaDataConfig, // Declared as any to fix a circular reference
    dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb, dwMediaRepository) {
        super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
        this.fb = fb;
        this.dwMediaRepository = dwMediaRepository;
        this.availableRelations = [];
        this.showImageOptions = false;
        this.mediaTypeLookupId = MediaMetaDataLookups.MediaTypeAllItems;
        this.fileExtensionsLookup = MediaMetaDataLookups.MediaFileExtensionAllItems;
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        if (this.section && !this.section.multiFileOptions) {
            this.section.multiFileOptions = { showGalleria: true };
        }
        setDefaults(this.section.multiFileOptions, false, 'imagesOnly', 'showGalleria');
        setDefaults(this.section, false, 'isSecure', 'isReadOnly');
        // this.section.multiFileOptions.imagesOnly = this.section.multiFileOptions.imagesOnly || false;
        this.loadMediaSecurity();
        this.setupAvailableRelationships();
        this.setupContextList();
    }
    setupContextList() {
        return this.dwContextService.getContextMetaDataList(this.contextNames)
            .subscribe(contextMdList => {
            this.contextMdList = contextMdList;
            if (this.section.contextName) {
                this.currentContextMd = this.contextMdList[this.section.contextName];
            }
        });
    }
    setContextDef() {
        if (!this.contextMdList) {
            return;
        }
        if (this.section.contextName) {
            this.currentContextMd = this.contextMdList[this.section.contextName];
        }
        this.onSectionChange();
    }
    setupAvailableRelationships() {
        var _a;
        if (!this.itemMetaData) {
            return;
        }
        this.availableRelations = (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.Relations.filter(relation => {
            return relation.PkUniqueItemName == 'roMedia';
        });
    }
    onSectionChange() {
        this.checkMediaSecurity();
        super.onSectionChange();
    }
    setupRelationship(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        this.relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        this.relationshipDisplay = null;
        if (this.relationship) {
            this.relationshipDisplay = `${this.relationship.PkUniqueItemName}.${this.relationship.PkAttributeName} (PK) = ${this.relationship.FkUniqueItemName}.${this.relationship.FkAttributeName} (FK)`;
        }
    }
    setImageRelationship(relationshipName) {
        this.section.imageRelationshipInfo = this.getRelationshipInfo(relationshipName, this.section.imageRelationshipInfo);
        this.onSectionChange();
    }
    loadMediaSecurity() {
        if (!this.itemMetaData || this.allMediaSecurity) {
            return;
        }
        this.dwMediaRepository.loadMediaSecurity(this.itemMetaData.MetaDataItemId)
            .subscribe(result => {
            this.allMediaSecurity = result;
            this.checkMediaSecurity();
        });
    }
    checkMediaSecurity() {
        if (!this.allMediaSecurity || !this.itemMetaData) {
            return;
        }
        this.currentMediaSecurity = null;
        if (!this.section.imageMediaGroupIdAttrName) {
            return;
        }
        const attr = this.itemMetaData.Attributes.find(a => a.AttributeName == this.section.imageMediaGroupIdAttrName);
        if (!attr) {
            return;
        }
        this.addMediaSecurityLink = `/admin/security/media/add?MetaDataItemId=${this.itemMetaData.MetaDataItemId}&MediaMetaDataAttributeId=${attr.MetaDataAttributeId}`;
        this.currentMediaSecurity = this.allMediaSecurity.find(ms => ms.MediaMetaDataAttributeId == attr.MetaDataAttributeId);
    }
    getRelationshipInfo(relationshipName, defaultInfo) {
        const relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        if (!relationship) {
            return null;
        }
        const relationshipInfo = defaultInfo || {};
        relationshipInfo.relationshipName = relationship.RelationshipName;
        relationshipInfo.propertyName = relationship.NamingInfo.RelationshipPropertyName;
        if (this.relationship.IsPrimaryItem) {
            relationshipInfo.childItem = this.relationship.FkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.PkUniqueItemName;
        }
        else {
            relationshipInfo.childItem = this.relationship.PkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.FkUniqueItemName;
        }
        return relationshipInfo;
    }
}
DwMultiFileSectionConfigComponent.ɵfac = function DwMultiFileSectionConfigComponent_Factory(t) { return new (t || DwMultiFileSectionConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormBuilderService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormService), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.FormBuilder), ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService)); };
DwMultiFileSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiFileSectionConfigComponent, selectors: [["dw-multi-file-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 42, vars: 13, consts: [["header", "Multi-file Configuration"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["dwCol", "4"], ["type", "text", "dwNumeric", "", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Shows the select file dialog before showing the modal", 1, "fa", "fa-info-circle"], ["dwCol", "6", 4, "ngIf"], ["dwCol", "12"], ["title", "Add any instructions that will be displayed above the file upload. (e.g. Preferred Image dimensions or file types)", 1, "fa", "fa-info-circle"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["title", "Changing this will break any existing files in this table", 1, "fa", "fa-info-circle"], [4, "ngIf"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [3, "ngModel", "lookupId", "ngModelChange"], ["title", "Number of images accross for high resolutions (> 1200px)", 1, "fa", "fa-info-circle"], ["title", "Number of images accross for medium resolutions (>= 768px)", 1, "fa", "fa-info-circle"], ["title", "Aspect ratio to use for images so they are all the same size.  Creates a box that any image will fit within based on the image width.  (e.g. 4:3 (Default) = 1.33   16:9 = 1.77)", 1, "fa", "fa-info-circle"], [3, "hidden"], [1, "fa", "fa-check-circle", "dw-green"], [1, "fa", "fa-minus-circle", "dw-red"], [3, "href"], [3, "ngModel"], ["formatType", "yesno", 3, "ngModel"], ["title", "Ensures the user can view the record this media is assigned to", 1, "fa", "fa-info-circle"]], template: function DwMultiFileSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Use Context");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_7_listener($event) { return ctx.section.useContext = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwMultiFileSectionConfigComponent_div_8_Template, 7, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(9, DwMultiFileSectionConfigComponent_div_9_Template, 10, 3, "div", 4);
        ɵngcc0.ɵɵelementStart(10, "div", 1);
        ɵngcc0.ɵɵelementStart(11, "div", 5);
        ɵngcc0.ɵɵelementStart(12, "label");
        ɵngcc0.ɵɵtext(13, "Images Only");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_14_listener($event) { return ctx.section.multiFileOptions.imagesOnly = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_14_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 5);
        ɵngcc0.ɵɵelementStart(16, "label");
        ɵngcc0.ɵɵtext(17, "Max Files Allowed");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "input", 6);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_Template_input_ngModelChange_18_listener($event) { return ctx.section.multiFileOptions.maxFiles = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 5);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Show File Selector First ");
        ɵngcc0.ɵɵelement(22, "i", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_23_listener($event) { return ctx.section.showFileSelectorFirst = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_23_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 1);
        ɵngcc0.ɵɵtemplate(25, DwMultiFileSectionConfigComponent_div_25_Template, 4, 2, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(26, DwMultiFileSectionConfigComponent_div_26_Template, 11, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(27, DwMultiFileSectionConfigComponent_div_27_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵelementStart(28, "div", 1);
        ɵngcc0.ɵɵelementStart(29, "div", 9);
        ɵngcc0.ɵɵelementStart(30, "label");
        ɵngcc0.ɵɵtext(31, "Upload Instructions ");
        ɵngcc0.ɵɵelement(32, "i", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "input", 11);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_Template_input_ngModelChange_33_listener($event) { return ctx.section.uploadInstructions = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "div", 1);
        ɵngcc0.ɵɵelementStart(35, "div", 9);
        ɵngcc0.ɵɵelementStart(36, "label");
        ɵngcc0.ɵɵtext(37, "Secure File ");
        ɵngcc0.ɵɵelement(38, "i", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_39_listener($event) { return ctx.section.isSecure = $event; })("ngModelChange", function DwMultiFileSectionConfigComponent_Template_dw_yesno_ngModelChange_39_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(40, DwMultiFileSectionConfigComponent_div_40_Template, 11, 3, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(41, DwMultiFileSectionConfigComponent_ng_container_41_Template, 18, 3, "ng-container", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useContext);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.useContext && ctx.contextMdList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.useContext);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.multiFileOptions.imagesOnly);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.multiFileOptions.maxFiles);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.showFileSelectorFirst);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.multiFileOptions.imagesOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.multiFileOptions.imagesOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.multiFileOptions.imagesOnly);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.uploadInstructions);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.isSecure);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.isSecure);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.isSecure && ctx.currentMediaSecurity);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, DwNumericDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x, DwMultiSelectAdhocComponent, DwReadOnlyControlComponent], styles: [""] });
DwMultiFileSectionConfigComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetadataFormUtilService },
    { type: DwMetadataFormBuilderService },
    { type: DwMetaDataFormService },
    { type: DwContextService },
    { type: DwUiConfigRegistryService },
    { type: FormBuilder },
    { type: DwMediaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiFileSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-multi-file-section-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Multi-file Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Use Context</label> \r\n                    <dw-yesno [(ngModel)]=\"section.useContext\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"section.useContext && contextMdList\">\r\n                <div dwCol=\"6\" *ngIf=\"section.useContext\">\r\n                    <label>Context</label> \r\n                    <select [(ngModel)]=\"section.contextName\" (ngModelChange)=\"setContextDef()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let contextName of contextNames\" [ngValue]=\"contextName\">\r\n                            {{ contextMdList[contextName].contextDef.contextDisplay }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"6\" *ngIf=\"currentContextMd\">\r\n                    <label>Media Group Attribute (Context)</label>\r\n                    <select [(ngModel)]=\"section.imageMediaGroupIdAttrName\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of currentContextMd?.attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Label</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.label\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"!section.useContext\">\r\n                <div dwCol=\"6\">\r\n                    <label>Media Group Attribute</label>\r\n                    <select [(ngModel)]=\"section.imageMediaGroupIdAttrName\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let item of itemMetaData?.Attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Label</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.label\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"4\">\r\n                    <label>Images Only</label>\r\n                    <dw-yesno [(ngModel)]=\"section.multiFileOptions.imagesOnly\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Max Files Allowed</label>\r\n                    <input type=\"text\" dwNumeric [(ngModel)]=\"section.multiFileOptions.maxFiles\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Show File Selector First <i class=\"fa fa-info-circle\" title=\"Shows the select file dialog before showing the modal\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.showFileSelectorFirst\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\" *ngIf=\"!section.multiFileOptions.imagesOnly\">\r\n                    <label>Allowed File Types</label>\r\n                    <dw-multi-select-adhoc-lookup [(ngModel)]=\"section.allowedFileTypes\" [lookupId]=\"fileExtensionsLookup\"></dw-multi-select-adhoc-lookup>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"section.multiFileOptions.imagesOnly\">\r\n                <div dwCol=\"6\">\r\n                    <label>Images per Row - Large <i class=\"fa fa-info-circle\" title=\"Number of images accross for high resolutions (> 1200px)\"></i></label>\r\n                    <input type=\"text\" dwNumeric [(ngModel)]=\"section.multiFileOptions.imagesPerRowLarge\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Images per Row - Medium <i class=\"fa fa-info-circle\" title=\"Number of images accross for medium resolutions (>= 768px)\"></i></label>\r\n                    <input type=\"text\" dwNumeric [(ngModel)]=\"section.multiFileOptions.imagesPerRowMedium\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"section.multiFileOptions.imagesOnly\">\r\n                <div dwCol=\"6\">\r\n                    <label>Image Aspect Ratio <i class=\"fa fa-info-circle\" title=\"Aspect ratio to use for images so they are all the same size.  Creates a box that any image will fit within based on the image width.  (e.g. 4:3 (Default) = 1.33   16:9 = 1.77)\"></i></label>\r\n                    <input type=\"text\" dwNumeric [(ngModel)]=\"section.multiFileOptions.imageAspectRatio\" class=\"form-control\">\r\n                </div>\r\n                <!-- <div dwCol=\"6\">\r\n                    <label>Show Galleria <i class=\"fa fa-info-circle\" title=\"Shows the gallery button for full-screen viewing of images with thumbnails\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.multiFileOptions.showGallery\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div> -->\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Upload Instructions <i class=\"fa fa-info-circle\" title=\"Add any instructions that will be displayed above the file upload. (e.g. Preferred Image dimensions or file types)\"></i></label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.uploadInstructions\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Secure File <i class=\"fa fa-info-circle\" title=\"Changing this will break any existing files in this table\"></i></label>\r\n                    <dw-yesno [(ngModel)]=\"section.isSecure\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n\r\n                    <div *ngIf=\"section.isSecure\">\r\n                        <span [hidden]=\"!currentMediaSecurity\">\r\n                            <i class=\"fa fa-check-circle dw-green\"></i> Media Security Setup Complete!\r\n\r\n                        </span>\r\n                        <span [hidden]=\"currentMediaSecurity\">\r\n                            <i class=\"fa fa-minus-circle dw-red\"></i> Secure files require a configuration record in\r\n                            Media Security. \r\n\r\n                            <a href=\"{{addMediaSecurityLink}}\">Add Media Security</a>\r\n                        </span>\r\n                        <br><br>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <ng-container *ngIf=\"section.isSecure && currentMediaSecurity\">\r\n                <b>Media Security Details</b>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <label>View All Permission</label>\r\n                        <dw-readonly [ngModel]=\"currentMediaSecurity.ViewAllPermissionMeaning\"></dw-readonly>\r\n                    </div>\r\n                    <div dwCol=\"6\">\r\n                        <label>Allow Emulation</label>\r\n                        <dw-readonly [ngModel]=\"currentMediaSecurity.AllowEmulation\" formatType=\"yesno\"></dw-readonly>\r\n                    </div>\r\n                </div>\r\n                <div dwRow>\r\n                    <div dwCol=\"6\">\r\n                        <label>Check Parent Table <i class=\"fa fa-info-circle\"\r\n                                title=\"Ensures the user can view the record this media is assigned to\"></i></label>\r\n                        <dw-readonly [ngModel]=\"currentMediaSecurity.CheckParentTable\" formatType=\"yesno\"></dw-readonly>\r\n                    </div>\r\n                </div>\r\n            </ng-container>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetadataFormUtilService }, { type: DwMetadataFormBuilderService }, { type: DwMetaDataFormService }, { type: DwContextService }, { type: DwUiConfigRegistryService }, { type: ɵngcc3.FormBuilder }, { type: DwMediaRepositoryService }]; }, null); })();

// @DwSectionComponent({
//   keyName: 'dwMultiFileSection',
//   display: 'Multiple Image/File Section',
//   sectionIcon: 'fa fa-copy',
//   configComponent: DwMultiFileSectionConfigComponent,
//   hasReadOnlyMode: true
// })
class DwMultiFileSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, uiConfig, dwActionConfigService, dwMetadataFormUtilService, dwMetaDataFormStateService, dwMetaDataFormActionService, dwMediaRepositoryService, dwAdhocLookupService, dwMediaConfig, dwContextService, dwMetaDataFormSectionStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.uiConfig = uiConfig;
        this.dwActionConfigService = dwActionConfigService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataFormActionService = dwMetaDataFormActionService;
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.dwAdhocLookupService = dwAdhocLookupService;
        this.dwMediaConfig = dwMediaConfig;
        this.dwContextService = dwContextService;
        this.isReadOnly = false;
        this.invalidConfiguration = false;
        this.imageMediaImageSize = {
            maxWidth: 550,
            mode: DwImageSizeMode.max
        };
        this.imageMediaImageReSize = {
            // cropWidth: 412.5,
            // cropHeight: 550,
            // cropRound: false,
            // outputWidth: 600,
            // outputHeight: 800,
            // maintainAspectRatio: true,
            allowResize: false
        };
        this.settingUpMediaGroup = false;
        this.contextLoading = false;
        this.contextLoadingTime = 500;
    }
    sectionReadOnlyChanged(readOnly) {
        this.isReadOnly = readOnly;
    }
    sectionConfigChanged() {
        this.initMedia();
    }
    formConfigChanged() {
        if (!this.formConfig) {
            return;
        }
        this.isReadOnly = this.isSectionReadOnly();
        this.initMedia();
    }
    setMediaGroupId(mediaGroupId) {
        var _a;
        this.mediaGroupId = mediaGroupId;
        if (!mediaGroupId) {
            return;
        }
        this.setFormControlValue((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.imageMediaGroupIdAttrName, mediaGroupId);
    }
    initMedia() {
        this.runAfterFormDataLoaded(() => {
            if (!this.sectionConfig.useContext) {
                this.initFormMediaGroup();
            }
            else {
                this.initContextMedia();
            }
        });
    }
    initContextMedia() {
        if (!this.sectionConfig.useContext || !this.sectionConfig.contextName) {
            return;
        }
        this.isReadOnly = true;
        const context = this.context[this.sectionConfig.contextName];
        if (!context) {
            this.message = {
                messageHeading: `Error loading images - context ${this.sectionConfig.contextName} not found`,
                severity: DwMessageSeverity.error,
            };
            return;
        }
        const contextDef = this.dwContextService.getContextDef(this.sectionConfig.contextName);
        this.setupMediaSectionOptions(contextDef.item);
        if (context.value) {
            this.contextValue = context.value;
            this.setContextMediaGroupId();
        }
        else {
            // If we don't have initial media, let's wait for before showing the default media
            this.contextLoading = true;
            setTimeout(() => {
                if (this.contextLoading) {
                    this.contextLoading = false;
                    this.setContextMediaGroupId();
                }
            }, this.contextLoadingTime);
        }
        context.subscribe(contextValue => {
            this.contextValue = contextValue;
            if (this.contextLoading) {
                this.contextLoading = false;
            }
            this.setContextMediaGroupId();
        });
    }
    setContextMediaGroupId() {
        if (this.contextValue) {
            this.mediaGroupId = this.contextValue[this.sectionConfig.imageMediaGroupIdAttrName];
        }
    }
    initFormMediaGroup() {
        if (this.settingUpMediaGroup) {
            return;
        }
        if (!this.sectionConfig.imageMediaGroupIdAttrName) {
            this.invalidConfiguration = true;
            this.invalidConfigurationMessage = "Media Group Attribute not set";
            return;
        }
        this.settingUpMediaGroup = true;
        const dataRelations = this.dwMetadataFormUtilService.getSectionDataPath(this.sectionConfig, this.formConfig.section, this.formConfig.queryMetaDataList);
        const dataContextValue = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME].value;
        let parentDataItem = dataContextValue;
        let parentItemName = this.formConfig.rootItemName;
        for (const dataRelation of dataRelations) {
            if (parentDataItem) {
                parentItemName = dataRelation.childItem;
                parentDataItem = parentDataItem[dataRelation.propertyName];
            }
        }
        this.setupMediaSectionOptions(parentItemName);
        if (parentDataItem) {
            this.mediaGroupId = parentDataItem[this.sectionConfig.imageMediaGroupIdAttrName];
        }
        else {
            // This can happen on adds and shouldn't show a warning
            //console.warn(`dw-image-section - Can't find parent data`, dataRelations);
        }
    }
    setupMediaSectionOptions(parentItemName) {
        var _a, _b, _c, _d;
        if (!this.sectionConfig) {
            return;
        }
        const allowedFileTypesArray = this.dwAdhocLookupService.convertAdhocStringToArray((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.allowedFileTypes);
        let allowedFileTypes = allowedFileTypesArray.map(fileType => `.${fileType}`).join(',');
        if ((_c = (_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.multiFileOptions) === null || _c === void 0 ? void 0 : _c.imagesOnly) {
            allowedFileTypes = this.dwMediaConfig.webImageFileExtensions;
        }
        this.mediaSelectOptions = {
            allowedFileTypes: allowedFileTypes,
            imageResizeOptions: this.imageMediaImageReSize,
            isSecure: (_d = this.sectionConfig) === null || _d === void 0 ? void 0 : _d.isSecure,
            parentItemName: parentItemName || this.formConfig.rootItemName,
            parentAttributeName: this.sectionConfig.imageMediaGroupIdAttrName,
            uploadInstructions: this.sectionConfig.uploadInstructions
        };
    }
    setFormControlValue(fieldName, fieldValue) {
        let fc = this.formGroup.get(fieldName);
        if (!fc) {
            fc = new FormControl();
            this.formGroup.addControl(fieldName, fc);
        }
        fc.setValue(fieldValue);
        return fc;
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
DwMultiFileSectionComponent.ɵfac = function DwMultiFileSectionComponent_Factory(t) { return new (t || DwMultiFileSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormActionService), ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwAdhocLookupService), ɵngcc0.ɵɵdirectiveInject(DwMediaConfigToken), ɵngcc0.ɵɵdirectiveInject(DwContextService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService)); };
DwMultiFileSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiFileSectionComponent, selectors: [["dw-multi-file-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "hide-print dw-invalid-section", 4, "ngIf"], [4, "ngIf"], [1, "hide-print", "dw-invalid-section"], ["id", "icon", 1, "fas", "fa-cog"], ["id", "message"], ["class", "label", 4, "ngIf"], [3, "mediaGroupId", "disabled", "mediaSelectOptions", "multiFileOptions", "showFileSelectorFirst", "mediaGroupIdChange"], [1, "label"]], template: function DwMultiFileSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMultiFileSectionComponent_div_0_Template, 4, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwMultiFileSectionComponent_ng_container_1_Template, 3, 6, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.invalidConfiguration);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.invalidConfiguration);
    } }, directives: function () { return [ɵngcc4.NgIf, DwMultiFileComponent]; }, styles: [""] });
DwMultiFileSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwMetaDataActionConfigService },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataFormActionService },
    { type: DwMediaRepositoryService },
    { type: DwAdhocLookupService },
    { type: undefined, decorators: [{ type: Inject, args: [DwMediaConfigToken,] }] },
    { type: DwContextService },
    { type: DwMetaDataFormSectionStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiFileSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-multi-file-section',
                template: "\r\n<div *ngIf=\"invalidConfiguration\" class=\"hide-print dw-invalid-section\">\r\n    <i class=\"fas fa-cog\" id=\"icon\"></i>\r\n\r\n    <div id=\"message\">Multi-File section has an invalid configuration. ({{invalidConfigurationMessage}})</div>\r\n</div>\r\n<ng-container *ngIf=\"!invalidConfiguration\">\r\n    <label class=\"label\" *ngIf=\"sectionConfig?.label\">{{sectionConfig.label}}</label>\r\n\r\n    <dw-multi-file [mediaGroupId]=\"mediaGroupId\" (mediaGroupIdChange)=\"setMediaGroupId($event)\" [disabled]=\"isReadOnly\" [mediaSelectOptions]=\"mediaSelectOptions\" [multiFileOptions]=\"sectionConfig?.multiFileOptions\" [showFileSelectorFirst]=\"sectionConfig.showFileSelectorFirst\"></dw-multi-file>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwMetaDataActionConfigService }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataFormActionService }, { type: DwMediaRepositoryService }, { type: DwAdhocLookupService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwMediaConfigToken]
            }] }, { type: DwContextService }, { type: DwMetaDataFormSectionStateService }]; }, null); })();
DwSectionComponentFunc({
    keyName: 'dwMultiFileSection',
    display: 'Multiple Image/File Section',
    sectionIcon: 'fa fa-copy',
    configComponent: DwMultiFileSectionConfigComponent,
    hasReadOnlyMode: true
}, DwMultiFileSectionComponent);

var DwMultiFileViewMode;
(function (DwMultiFileViewMode) {
    DwMultiFileViewMode["images"] = "images";
    DwMultiFileViewMode["gallery"] = "gallery";
    DwMultiFileViewMode["list"] = "list";
})(DwMultiFileViewMode || (DwMultiFileViewMode = {}));

var __decorate$2j = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1O = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwMultiFileComponent {
    constructor(dwMediaRepositoryService, dwMediaModalService, dwFileUtilService, dwMetaDataFormStateService) {
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.dwMediaModalService = dwMediaModalService;
        this.dwFileUtilService = dwFileUtilService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.disabled = false;
        this.mediaGroupIdChange = new EventEmitter();
        this.multiFileOptions = {};
        this.showFileSelectorFirst = true;
        this.loading = true;
        this.loadingMediaGroup = false;
        this.deletedMediaItems = [];
        this.mode = DwMultiFileViewMode.images;
        this.fullScreen = true;
        this.showGallery = false;
        this.currentMediaItems = [];
        this.mediaItemStyle = {};
        this.showViewToggle = false;
        this.responsiveOptions = [
            {
                breakpoint: '1200px',
                numVisible: 6
            },
            {
                breakpoint: '768px',
                numVisible: 3
            },
            {
                breakpoint: '560px',
                numVisible: 1
            }
        ];
        this.galleryIndex = 0;
    }
    ngOnInit() {
        this.setupFormActionInterceptor();
        this.dwMetaDataFormStateService.addActionInterceptor(this.formActionInterceptor);
        this.dwMediaRepositoryService.getFileExtensions()
            .subscribe(fileExts => {
            this.fileExtensions = fileExts;
        });
        this.loadMediaGroup();
    }
    ngOnDestroy() {
        this.dwMetaDataFormStateService.removeActionInterceptor(this.formActionInterceptor);
    }
    ngOnChanges(changes) {
        if (changes.mediaGroupId && !changes.mediaGroupId.firstChange) {
            this.loadMediaGroup();
        }
        if (changes.multiFileOptions) {
            this.initOptions();
        }
    }
    windowResize() {
        this.initOptions();
    }
    initOptions() {
        var _a, _b, _c, _d, _e;
        this.showViewToggle = false;
        this.mode = DwMultiFileViewMode.list;
        if (!((_a = this.multiFileOptions) === null || _a === void 0 ? void 0 : _a.imagesOnly)) {
            return;
        }
        this.mode = DwMultiFileViewMode.images;
        this.showViewToggle = true;
        this.mediaHeightPercent = 100;
        const aspectRatio = ((_b = this.multiFileOptions) === null || _b === void 0 ? void 0 : _b.imageAspectRatio) || 1.33;
        if ((_c = this.multiFileOptions) === null || _c === void 0 ? void 0 : _c.imageAspectRatio) {
            this.mediaHeightPercent = 100 / this.multiFileOptions.imageAspectRatio;
        }
        let imagesPerRow = 4;
        if (window.innerWidth < 768) {
            imagesPerRow = 1;
        }
        else if (window.innerWidth >= 1200) {
            imagesPerRow = ((_d = this.multiFileOptions) === null || _d === void 0 ? void 0 : _d.imagesPerRowLarge) || 4;
        }
        else {
            imagesPerRow = ((_e = this.multiFileOptions) === null || _e === void 0 ? void 0 : _e.imagesPerRowMedium) || 3;
        }
        this.imagesPerRow = imagesPerRow;
        const widthPercent = 100 / imagesPerRow;
        // Set dynamic item style
        this.mediaItemStyle = {
            'width': `${widthPercent}%`
        };
        const galleryWidth = window.innerWidth > 1200 ? 1200 : window.innerWidth;
        const galleryHeight = galleryWidth * 0.75;
        this.galleryStyle = { width: `${galleryWidth}px`, height: `${galleryHeight}px` };
    }
    loadMediaGroup() {
        if (this.loadingMediaGroup || (this.mediaGroup && this.mediaGroup.MediaGroupId == this.mediaGroupId)) {
            return;
        }
        // If there isn't a group, then loading is complete
        if (!this.mediaGroupId) {
            this.loading = false;
            return;
        }
        this.loadingMediaGroup = true;
        this.dwMediaRepositoryService.loadMediaGroup(this.mediaGroupId)
            .subscribe(mediaGroup => {
            this.mediaGroup = mediaGroup;
            // Remove any items marked as deleted
            this.processMedia();
            // mediaGroup.DwroMedia
            this.loadingMediaGroup = false;
            this.loading = false;
        });
    }
    loadAdditionalMedia(mediaIds) {
        if (!this.mediaGroup) {
            this.loadMediaGroup();
            return;
        }
        this.dwMediaRepositoryService.loadMedia(mediaIds)
            .subscribe(roMediaItems => {
            for (const mediaItem of roMediaItems) {
                this.mediaGroup.DwroMedia.push(mediaItem);
                this.processMedia();
            }
        });
    }
    setMode(mode) {
        this.mode = mode;
        if (this.mode == DwMultiFileViewMode.gallery) {
            this.showGallery = true;
        }
    }
    toggleShowGallery(show) {
        if (!show) {
            this.setMode(DwMultiFileViewMode.images);
        }
        else {
            this.setMode(DwMultiFileViewMode.gallery);
        }
    }
    openGallery(media) {
        if (media.IsImage) {
            this.galleryIndex = this.currentMediaItems.indexOf(media);
            this.showGallery = true;
        }
    }
    getMediaUrl(media, width = 600, height = 600) {
        return this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, true, width, height, null, media.IsSecure, media.MediaId, this.mediaSelectOptions.parentItemName, this.mediaSelectOptions.parentAttributeName);
    }
    getMediaStyle(media, fullScreen) {
        if (media.ImageHeight > media.ImageWidth) {
            const widthPercent = (media.ImageWidth * 100 / media.ImageHeight);
            return { width: `${widthPercent}%`, diplay: 'block' };
            return { height: '100%', diplay: 'block' };
        }
        if (fullScreen) {
            return { height: '800px' };
        }
        return { width: '100%', diplay: 'block' };
    }
    removeMedia(media) {
        this.deletedMediaItems.push(media);
        media.IsDeleted = true;
        this.processMedia();
        //const index = this.mediaGroup.DwroMedia.indexOf(media);
        //this.mediaGroup.DwroMedia.splice(index, 1);
    }
    downloadMedia(media) {
        const url = this.getMediaUrl(media);
        this.dwMediaRepositoryService.downloadFile(url, media.DisplayFileName);
    }
    processMedia() {
        if (!this.mediaGroup) {
            return;
        }
        this.dwFileUtilService.populateMediaDetails(this.mediaGroup.DwroMedia, 300, 300, this.mediaSelectOptions.isSecure, true, this.mediaSelectOptions.parentItemName, this.mediaSelectOptions.parentAttributeName)
            .subscribe(mediaExtItems => {
            this.currentMediaItems = mediaExtItems;
        });
    }
    selectFiles(files, fileInput) {
        var _a, _b, _c, _d, _e;
        if (this.disabled) {
            return;
        }
        if (this.showFileSelectorFirst && !files) {
            (_b = (_a = this.fileMultiple) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.click();
            return;
        }
        if (((_c = this.multiFileOptions) === null || _c === void 0 ? void 0 : _c.maxFiles) && this.currentMediaItems.length >= ((_d = this.multiFileOptions) === null || _d === void 0 ? void 0 : _d.maxFiles)) {
            this.message = {
                messageBody: 'You have uploaded the maximum allowed files',
                severity: DwMessageSeverity.error,
                allowClose: true,
            };
            return;
        }
        const mediaSelectOptions = this.mediaSelectOptions || this.getDefaultOptions();
        this.dwMediaModalService.showMultipleFileModal(mediaSelectOptions, this.mediaGroupId, files, (_e = this.multiFileOptions) === null || _e === void 0 ? void 0 : _e.maxFiles, this.currentMediaItems.length)
            .subscribe(uploadResult => {
            if (!uploadResult) {
                return;
            }
            // Set media group id is if didn't already exist
            if (!this.mediaGroupId) {
                this.mediaGroupId = uploadResult.mediaGroupId;
                this.mediaGroupIdChange.emit(this.mediaGroupId);
            }
            const mediaIds = uploadResult.media.map(m => m.MediaId);
            this.loadAdditionalMedia(mediaIds);
        });
    }
    getDefaultOptions() {
        const options = {
            isSecure: false,
            allowedFileTypes: '',
            imageResizeOptions: {
                allowResize: false,
            }
        };
        return options;
    }
    setupFormActionInterceptor() {
        this.formActionInterceptor = {
            interceptorName: 'mutilFileSave',
            order: 1,
            onAfterAction: (actionPref, actionConfig, actionResult) => {
                const result = {
                    abort: false
                };
                // Cast to a save result so we can see if a save occured
                const saveResult = actionResult;
                if (!(saveResult === null || saveResult === void 0 ? void 0 : saveResult.saveResult)) {
                    return of(result);
                }
                return this.deleteMediaItems();
            }
        };
    }
    deleteMediaItems() {
        const result = {
            abort: false
        };
        const deletedMediaIds = this.deletedMediaItems.map(m => m.MediaId);
        if (deletedMediaIds.length) {
            this.dwMediaRepositoryService.deleteMedia(deletedMediaIds)
                .subscribe(() => {
                return result;
            });
        }
        return of(result);
    }
}
DwMultiFileComponent.ɵfac = function DwMultiFileComponent_Factory(t) { return new (t || DwMultiFileComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwMediaModalService), ɵngcc0.ɵɵdirectiveInject(DwFileUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService)); };
DwMultiFileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMultiFileComponent, selectors: [["dw-multi-file"]], viewQuery: function DwMultiFileComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c98, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fileMultiple = _t.first);
    } }, hostBindings: function DwMultiFileComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwMultiFileComponent_resize_HostBindingHandler($event) { return ctx.windowResize($event.target); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { disabled: "disabled", multiFileOptions: "multiFileOptions", showFileSelectorFirst: "showFileSelectorFirst", mediaGroupId: "mediaGroupId", mediaSelectOptions: "mediaSelectOptions" }, outputs: { mediaGroupIdChange: "mediaGroupIdChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 11, vars: 9, consts: [["dwDwFileDrop", "", 3, "fileDrop"], ["style", "overflow:auto", 4, "ngIf"], ["style", "overflow:auto", 3, "hidden", 4, "ngIf"], [3, "message", "messageChange"], [3, "show"], [4, "ngIf"], ["class", "dw-media-list", 4, "ngIf"], ["class", "dw-media-list", 3, "dwColumnManager", "itemCount", "heightPercent", 4, "ngIf"], ["type", "file", "placeholder", "Choose files", "multiple", "", 2, "display", "none", 3, "accept", "change"], ["fileMultiple", ""], [2, "overflow", "auto"], [1, "dw-grid-buttons-left"], ["class", "btn btn-success", 3, "click", 4, "ngIf"], [1, "dw-grid-buttons-left", "dw-grid-buttons-stretch"], ["dwDwFileDrop", "", 1, "dw-drop-box2", 3, "click", "fileDrop"], [1, "fa", "fa-upload"], ["class", "dw-grid-buttons-right", 4, "ngIf"], [1, "btn", "btn-success", 3, "click"], [1, "dw-grid-buttons-right"], [1, "btn-group", "dw-button-right"], [1, "btn", "btn-success", 3, "ngClass", "click"], ["title", "Images View", 1, "fa", "fa-images"], ["class", "btn btn-success", 3, "ngClass", "click", 4, "ngIf"], ["title", "List View", 1, "fa", "fa-bars"], ["title", "Gallery View", 1, "fa", "fa-image"], [2, "overflow", "auto", 3, "hidden"], [1, "dw-media-list"], [4, "ngFor", "ngForOf"], [3, "media", "disabled", "isSecureGroup", "isSecure", "parentItemName", "parentAttributeName", "removeMedia"], [1, "dw-media-list", 3, "dwColumnManager", "itemCount", "heightPercent"], ["class", "dw-media-item", 3, "name", "ngStyle", 4, "ngIf"], [1, "dw-media-item", 3, "name", "ngStyle"], ["dwMissingImage", "", 1, "dw-media-item-image", 3, "src", "alt", "click"], [1, "dw-file-status"], ["class", "fa fa-times hand", "style", "position: absolute; right:30px; top: 30px;color:red", 3, "click", 4, "ngIf"], [1, "fa", "fa-times", "hand", 2, "position", "absolute", "right", "30px", "top", "30px", "color", "red", 3, "click"], [3, "value", "visible", "activeIndex", "containerStyle", "numVisible", "fullScreen", "showThumbnails", "showIndicators", "circular", "showItemNavigators", "baseZIndex", "visibleChange"], ["pTemplate", "item"], ["pTemplate", "thumbnail"], ["pTemplate", "caption2"], [1, "p-justify-center", 2, "overflow", "hidden", "text-align", "center", 3, "ngStyle"], ["dwMissingImage", "", 3, "src", "alt"], [1, "p-grid", "p-nogutter", "p-justify-center"], ["dwMissingImage", "", 2, "width", "100%", "display", "block", 3, "src", "alt"], [1, "dw-file-name"], [2, "margin-bottom", ".5rem", "color", "#ffffff"], ["class", "fa fa-times hand", 3, "click", 4, "ngIf"], [1, "fa", "fa-times", "hand", 3, "click"]], template: function DwMultiFileComponent_Template(rf, ctx) { if (rf & 1) {
        const _r51 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("fileDrop", function DwMultiFileComponent_Template_div_fileDrop_0_listener($event) { return ctx.selectFiles($event); });
        ɵngcc0.ɵɵtemplate(1, DwMultiFileComponent_div_1_Template, 9, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(2, DwMultiFileComponent_div_2_Template, 5, 1, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "dw-message", 3);
        ɵngcc0.ɵɵlistener("messageChange", function DwMultiFileComponent_Template_dw_message_messageChange_3_listener($event) { return ctx.message = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "dw-loading", 4);
        ɵngcc0.ɵɵtemplate(5, DwMultiFileComponent_div_5_Template, 2, 0, "div", 5);
        ɵngcc0.ɵɵtemplate(6, DwMultiFileComponent_div_6_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵtemplate(7, DwMultiFileComponent_div_7_Template, 2, 4, "div", 7);
        ɵngcc0.ɵɵtemplate(8, DwMultiFileComponent_ng_container_8_Template, 5, 12, "ng-container", 5);
        ɵngcc0.ɵɵelementStart(9, "input", 8, 9);
        ɵngcc0.ɵɵlistener("change", function DwMultiFileComponent_Template_input_change_9_listener() { ɵngcc0.ɵɵrestoreView(_r51); const _r6 = ɵngcc0.ɵɵreference(10); return ctx.selectFiles(_r6.files, _r6); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("message", ctx.message);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("show", ctx.loadingMediaGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loading && (!ctx.mediaGroup || (ctx.currentMediaItems == null ? null : ctx.currentMediaItems.length) == 0));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "list");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.mode == "images");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showGallery);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("accept", ctx.mediaSelectOptions == null ? null : ctx.mediaSelectOptions.allowedFileTypes);
    } }, directives: function () { return [DwFileDropDirective, ɵngcc4.NgIf, DwMessageComponent, DwLoadingComponent, ɵngcc4.NgClass, ɵngcc4.NgForOf, DwMediaItemCardComponent, DwDivColumnManagerDirective, ɵngcc4.NgStyle, DwMissingImageDirective, ɵngcc37.Galleria, ɵngcc6.PrimeTemplate]; }, styles: [".dw-media-item[_ngcontent-%COMP%]{cursor:pointer;display:table-cell;float:left;overflow:hidden;padding:5px;position:relative;text-align:center;vertical-align:middle}.dw-media-item-image[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.dw-media-item[_ngcontent-%COMP%]:hover{cursor:pointer;opacity:.75}.dw-media-list[_ngcontent-%COMP%]{max-height:650px;overflow-x:hidden;overflow-y:auto}"] });
DwMultiFileComponent.ctorParameters = () => [
    { type: DwMediaRepositoryService },
    { type: DwMediaModalService },
    { type: DwFileUtilService },
    { type: DwMetaDataFormStateService }
];
DwMultiFileComponent.propDecorators = {
    mediaGroupId: [{ type: Input }],
    disabled: [{ type: Input }],
    mediaGroupIdChange: [{ type: Output }],
    multiFileOptions: [{ type: Input }],
    mediaSelectOptions: [{ type: Input }],
    fileMultiple: [{ type: ViewChild, args: ['fileMultiple', { static: true },] }],
    showFileSelectorFirst: [{ type: Input }],
    windowResize: [{ type: HostListener, args: ['window:resize', ['$event.target'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMultiFileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-multi-file',
                template: "<div dwDwFileDrop (fileDrop)=\"selectFiles($event)\" >\r\n    <div style=\"overflow:auto\" *ngIf=\"false\">\r\n        <div class=\"dw-grid-buttons-left\">\r\n            <button (click)=\"selectFiles()\" class=\"btn btn-success\" *ngIf=\"!disabled\">Add Files</button>\r\n        </div>\r\n        <div class=\"dw-grid-buttons-left dw-grid-buttons-stretch\">\r\n            <div class=\"dw-drop-box2\" (click)=\"selectFiles()\" dwDwFileDrop (fileDrop)=\"selectFiles($event)\">\r\n                <div><i class=\"fa fa-upload\"></i> Click here or drag files to upload</div>\r\n            </div>\r\n        </div>\r\n        <div class=\"dw-grid-buttons-right\" *ngIf=\"showViewToggle\">\r\n            <div class=\"btn-group dw-button-right\">\r\n                <label class=\"btn btn-success\" (click)=\"setMode('images')\"\r\n                    [ngClass]=\"{ 'dw-btn-success-active': mode=='images' }\">\r\n                    <i class=\"fa fa-images\" title=\"Images View\"></i>\r\n                </label>\r\n                <label class=\"btn btn-success\" (click)=\"setMode('gallery')\" *ngIf=\"false\"\r\n                    [ngClass]=\"{ 'dw-btn-success-active': mode=='gallery' }\">\r\n                    <i class=\"fa fa-image\" title=\"Gallery View\"></i>\r\n                </label>\r\n                <label class=\"btn btn-success\" (click)=\"setMode('list')\"\r\n                    [ngClass]=\"{ 'dw-btn-success-active': mode=='list' }\">\r\n                    <i class=\"fa fa-bars\" title=\"List View\"></i>\r\n                </label>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div style=\"overflow:auto\" [hidden]=\"loading\" *ngIf=\"!disabled\">\r\n        <div class=\"dw-drop-box2\" (click)=\"selectFiles()\" dwDwFileDrop (fileDrop)=\"selectFiles($event)\">\r\n            <div><i class=\"fa fa-upload\"></i> Click here or drag files to upload</div>\r\n        </div>\r\n    </div>\r\n\r\n    <dw-message [(message)]=\"message\"></dw-message>\r\n\r\n    <dw-loading [show]=\"loadingMediaGroup\"></dw-loading>\r\n\r\n    <div *ngIf=\"!loading && (!mediaGroup || currentMediaItems?.length == 0)\">\r\n        There are no files\r\n    </div>\r\n\r\n    <div *ngIf=\"mode=='list'\" class=\"dw-media-list\">\r\n\r\n        <ng-container *ngFor=\"let media of currentMediaItems\">\r\n            <dw-media-item-card [media]=\"media\" (removeMedia)=\"removeMedia(media)\" [disabled]=\"disabled\" [isSecureGroup]=\"true\" [isSecure]=\"mediaSelectOptions.isSecure\" [parentItemName]=\"mediaSelectOptions.parentItemName\" [parentAttributeName]=\"mediaSelectOptions.parentAttributeName\">\r\n            </dw-media-item-card>\r\n        </ng-container>\r\n\r\n    </div>\r\n\r\n    <!-- <div *ngIf=\"false\" class=\"dw-media-list\">\r\n        <ng-container *ngFor=\"let media of currentMediaItems\">\r\n            <div class=\"dw-media-item\" [dwHeight]=\"mediaHeightPercent\" [name]=\"media?.MediaName\"\r\n                [ngStyle]=\"mediaItemStyle\" *ngIf=\"media.IsImage\">\r\n                <img (click)=\"openGallery(media)\" [src]=\"media.MediumImageUrl\" [alt]=\"media?.MediaName\"\r\n                    class=\"dw-media-item-image\" [style]=\"getMediaStyle(media)\" dwMissingImage />\r\n\r\n                <div class=\"dw-file-status\">\r\n                    <i class=\"fa fa-times hand\" style=\"position: absolute; right:30px; top: 30px;color:red\"\r\n                        (click)=\"removeMedia(media)\" *ngIf=\"!disabled && false\"></i>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n    </div> -->\r\n\r\n    <div *ngIf=\"mode=='images'\" class=\"dw-media-list\" [dwColumnManager]=\"imagesPerRow\"\r\n        [itemCount]=\"currentMediaItems?.length\" [heightPercent]=\"mediaHeightPercent\">\r\n        <ng-container *ngFor=\"let media of currentMediaItems\">\r\n            <div class=\"dw-media-item\" [name]=\"media?.MediaName\" *ngIf=\"media.IsImage\" [ngStyle]=\"mediaItemStyle\">\r\n                <img (click)=\"openGallery(media)\" [src]=\"media.MediumImageUrl\" [alt]=\"media?.MediaName\"\r\n                    class=\"dw-media-item-image\" [style]=\"getMediaStyle(media)\" dwMissingImage />\r\n\r\n                <div class=\"dw-file-status\">\r\n                    <i class=\"fa fa-times hand\" style=\"position: absolute; right:30px; top: 30px;color:red\"\r\n                        (click)=\"removeMedia(media)\" *ngIf=\"!disabled && false\"></i>\r\n                </div>\r\n            </div>\r\n        </ng-container>\r\n    </div>\r\n\r\n    <ng-container *ngIf=\"showGallery\">\r\n        <p-galleria [value]=\"currentMediaItems\" [(visible)]=\"showGallery\" [activeIndex]=\"galleryIndex\"\r\n            (visibleChange)=\"toggleShowGallery($event)\" [containerStyle]=\"{'max-width': '1200px'}\" [numVisible]=\"5\"\r\n            [fullScreen]=\"fullScreen\" [showThumbnails]=\"true\" [showIndicators]=\"false\" [circular]=\"true\"\r\n            [showItemNavigators]=\"true\" [baseZIndex]=\"10000\">\r\n            <ng-template pTemplate=\"item\" let-item>\r\n                <div [ngStyle]=\"galleryStyle\" style=\"overflow:hidden; text-align:center;\" class=\"p-justify-center\">\r\n                    <img [src]=\"item.FullImageUrl\" [alt]=\"item?.MediaName\" [style]=\"getMediaStyle(item)\"\r\n                        dwMissingImage />\r\n                </div>\r\n            </ng-template>\r\n            <ng-template pTemplate=\"thumbnail\" let-item>\r\n                <div class=\"p-grid p-nogutter p-justify-center\">\r\n                    <img [src]=\"item.ThumbnailImageUrl\" [alt]=\"item?.MediaName\" dwMissingImage\r\n                        style=\"width: 100%; display: block;\" />\r\n                </div>\r\n            </ng-template>\r\n            <ng-template pTemplate=\"caption2\" let-item>\r\n                <div style=\"overflow:auto\">\r\n                    <div class=\"dw-file-name\">\r\n                        <h4 style=\"margin-bottom: .5rem; color: #ffffff;\">{{item.MediaName}}</h4>\r\n                    </div>\r\n                    <div class=\"dw-file-status\">\r\n                        <i class=\"fa fa-times hand\" (click)=\"removeMedia(item)\" *ngIf=\"!disabled\"></i>\r\n                    </div>\r\n                </div>\r\n            </ng-template>\r\n        </p-galleria>\r\n    </ng-container>\r\n    <input type=\"file\" #fileMultiple placeholder=\"Choose files\" (change)=\"selectFiles(fileMultiple.files, fileMultiple)\" [accept]=\"mediaSelectOptions?.allowedFileTypes\" style=\"display:none;\" multiple>\r\n</div>\r\n",
                styles: [".dw-media-item{cursor:pointer;display:table-cell;float:left;overflow:hidden;padding:5px;position:relative;text-align:center;vertical-align:middle}.dw-media-item-image{margin-left:auto;margin-right:auto}.dw-media-item:hover{cursor:pointer;opacity:.75}.dw-media-list{max-height:650px;overflow-x:hidden;overflow-y:auto}"]
            }]
    }], function () { return [{ type: DwMediaRepositoryService }, { type: DwMediaModalService }, { type: DwFileUtilService }, { type: DwMetaDataFormStateService }]; }, { disabled: [{
            type: Input
        }], mediaGroupIdChange: [{
            type: Output
        }], multiFileOptions: [{
            type: Input
        }], showFileSelectorFirst: [{
            type: Input
        }], windowResize: [{
            type: HostListener,
            args: ['window:resize', ['$event.target']]
        }], mediaGroupId: [{
            type: Input
        }], mediaSelectOptions: [{
            type: Input
        }], fileMultiple: [{
            type: ViewChild,
            args: ['fileMultiple', { static: true }]
        }] }); })();
__decorate$2j([
    DwInputConverter(booleanConverter),
    __metadata$1O("design:type", Boolean)
], DwMultiFileComponent.prototype, "disabled", void 0);
__decorate$2j([
    DwInputConverter(booleanConverter),
    __metadata$1O("design:type", Boolean)
], DwMultiFileComponent.prototype, "showFileSelectorFirst", void 0);

class DwMediaItemCardComponent {
    constructor(dwMediaRepositoryService) {
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.disabled = false;
        this.isSecure = false;
        this.isSecureGroup = false;
        this.removeMedia = new EventEmitter();
    }
    ngOnInit() {
    }
    onRemoveMedia(media) {
        this.removeMedia.emit(media);
    }
    downloadMedia(media) {
        const url = this.getMediaUrl(media, null, null);
        this.dwMediaRepositoryService.downloadFile(url, media.DisplayFileName);
    }
    getMediaUrl(media, width = 600, height = 600) {
        return this.dwMediaRepositoryService.getImageUrl(media.ContainerName, media.FileName, media.MediaDetailKey, this.isSecureGroup, width, height, null, this.isSecure, media.MediaId, this.parentItemName, this.parentAttributeName);
    }
}
DwMediaItemCardComponent.ɵfac = function DwMediaItemCardComponent_Factory(t) { return new (t || DwMediaItemCardComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService)); };
DwMediaItemCardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMediaItemCardComponent, selectors: [["dw-media-item-card"]], inputs: { disabled: "disabled", isSecure: "isSecure", isSecureGroup: "isSecureGroup", media: "media", parentItemName: "parentItemName", parentAttributeName: "parentAttributeName", showSize: "showSize" }, outputs: { removeMedia: "removeMedia" }, decls: 15, vars: 9, consts: [["class", "dw-file", 3, "hidden", 4, "ngIf"], [1, "dw-chip", "dw-chip-100"], [1, "dw-chip-label"], [1, "pull-left"], ["style", "max-width: 75px;max-height: 75px", 3, "src", "alt", 4, "ngIf"], ["class", "fa-2x", 3, "ngClass", 4, "ngIf"], [1, "pull-left", "ml-2"], [3, "hidden"], [1, "dw-chip-icon", "hide-print-item", 3, "click"], ["class", "fa fa-times-circle", "title", "Remove", 4, "ngIf"], ["title", "Download", 1, "fa", "fa-download"], [1, "dw-file", 3, "hidden"], [1, "dw-file-icon", 2, "width", "80px"], [1, "dw-file-name", 3, "title"], [1, "dw-file-status"], ["class", "fa fa-times hand dw-file-action", "title", "Remove", 3, "click", 4, "ngIf"], ["title", "Download", 1, "fa", "fa-download", "dw-file-action", 3, "click"], [2, "max-width", "75px", "max-height", "75px", 3, "src", "alt"], [1, "fa-2x", 3, "ngClass"], ["title", "Remove", 1, "fa", "fa-times", "hand", "dw-file-action", 3, "click"], ["title", "Remove", 1, "fa", "fa-times-circle"]], template: function DwMediaItemCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwMediaItemCardComponent_div_0_Template, 12, 10, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵtemplate(4, DwMediaItemCardComponent_img_4_Template, 1, 2, "img", 4);
        ɵngcc0.ɵɵtemplate(5, DwMediaItemCardComponent_i_5_Template, 1, 1, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 6);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementStart(8, "div", 7);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵpipe(10, "filesize");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵlistener("click", function DwMediaItemCardComponent_Template_div_click_11_listener() { return ctx.onRemoveMedia(ctx.media); });
        ɵngcc0.ɵɵtemplate(12, DwMediaItemCardComponent_i_12_Template, 1, 0, "i", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵlistener("click", function DwMediaItemCardComponent_Template_div_click_13_listener() { return ctx.downloadMedia(ctx.media); });
        ɵngcc0.ɵɵelement(14, "i", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", false);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.media.IsImage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.media.IsImage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.media.DisplayFileName, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", !ctx.showSize);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(10, 7, ctx.media.SizeInBytes), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.disabled);
    } }, directives: [ɵngcc4.NgIf, DwMissingImageDirective, ɵngcc4.NgClass], pipes: [DwFileSizePipe], styles: [".dw-media-item[_ngcontent-%COMP%]{cursor:pointer;display:table-cell;float:left;overflow:hidden;padding:5px;position:relative;text-align:center;vertical-align:middle}.dw-media-item-image[_ngcontent-%COMP%]{margin-left:auto;margin-right:auto}.dw-media-item[_ngcontent-%COMP%]:hover{cursor:pointer;opacity:.75}.dw-media-list[_ngcontent-%COMP%]{max-height:650px;overflow:auto}"] });
DwMediaItemCardComponent.ctorParameters = () => [
    { type: DwMediaRepositoryService }
];
DwMediaItemCardComponent.propDecorators = {
    media: [{ type: Input }],
    disabled: [{ type: Input }],
    isSecure: [{ type: Input }],
    isSecureGroup: [{ type: Input }],
    parentItemName: [{ type: Input }],
    parentAttributeName: [{ type: Input }],
    showSize: [{ type: Input }],
    removeMedia: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMediaItemCardComponent, [{
        type: Component,
        args: [{
                selector: 'dw-media-item-card',
                template: "<div class=\"dw-file\" [hidden]=\"media._isDeleted\" *ngIf=\"false\">\r\n    <div class=\"dw-file-icon\" style=\"width:80px\">\r\n        <img [src]=\"media.ThumbnailImageUrl\" [alt]=\"item?.DisplayFileName\" style=\"max-width: 75px;max-height: 75px\"\r\n            *ngIf=\"media.IsImage\" />\r\n        <i [ngClass]=\"media.FileIconCss\" class=\"fa-2x\" *ngIf=\"!media.IsImage\"></i>\r\n    </div>\r\n    <div class=\"dw-file-name\" title=\"{{media.MediaName}}\">\r\n        {{ media.DisplayFileName }}\r\n        <div [hidden]=\"!showSize\">\r\n            {{ media.SizeInBytes | filesize}}\r\n        </div>\r\n    </div>\r\n    <div class=\"dw-file-status\">\r\n        <i class=\"fa fa-times hand dw-file-action\" (click)=\"onRemoveMedia(media)\" *ngIf=\"!disabled\" title=\"Remove\"></i>\r\n        <i class=\"fa fa-download dw-file-action\" (click)=\"downloadMedia(media)\" title=\"Download\"></i>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"dw-chip dw-chip-100\">\r\n    <div class=\"dw-chip-label\">\r\n        <div class=\"pull-left\">\r\n            <img [src]=\"media.ThumbnailImageUrl\" [alt]=\"item?.DisplayFileName\" style=\"max-width: 75px;max-height: 75px\"\r\n                *ngIf=\"media.IsImage\" />\r\n            <i [ngClass]=\"media.FileIconCss\" class=\"fa-2x\" *ngIf=\"!media.IsImage\"></i>\r\n        </div>\r\n        <div class=\"pull-left ml-2\">\r\n            {{ media.DisplayFileName }}\r\n            <div [hidden]=\"!showSize\">\r\n                {{ media.SizeInBytes | filesize}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"dw-chip-icon hide-print-item\" (click)=\"onRemoveMedia(media)\"><i class=\"fa fa-times-circle\"\r\n            *ngIf=\"!disabled\" title=\"Remove\"></i></div>\r\n    <div class=\"dw-chip-icon hide-print-item\" (click)=\"downloadMedia(media)\"><i class=\"fa fa-download\"\r\n            title=\"Download\"></i></div>\r\n</div>",
                styles: [".dw-media-item{cursor:pointer;display:table-cell;float:left;overflow:hidden;padding:5px;position:relative;text-align:center;vertical-align:middle}.dw-media-item-image{margin-left:auto;margin-right:auto}.dw-media-item:hover{cursor:pointer;opacity:.75}.dw-media-list{max-height:650px;overflow:auto}"]
            }]
    }], function () { return [{ type: DwMediaRepositoryService }]; }, { disabled: [{
            type: Input
        }], isSecure: [{
            type: Input
        }], isSecureGroup: [{
            type: Input
        }], removeMedia: [{
            type: Output
        }], media: [{
            type: Input
        }], parentItemName: [{
            type: Input
        }], parentAttributeName: [{
            type: Input
        }], showSize: [{
            type: Input
        }] }); })();

class DwImageComponent {
    constructor(dwMediaRepository) {
        this.dwMediaRepository = dwMediaRepository;
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.setupImage();
        }
    }
    ngOnInit() {
        this.setupImage();
    }
    setupImage() {
        if (this.mediaPath) {
            this.src = this.dwMediaRepository.getImageUrlFromMediaPath(this.mediaPath);
        }
        if (this.mediaId && !this.media) {
            this.dwMediaRepository.loadMedia(this.mediaId).subscribe(mediaItems => {
                var _a;
                this.media = mediaItems[0];
                this.src = this.dwMediaRepository.getImageUrlFromMediaPath((_a = this.media) === null || _a === void 0 ? void 0 : _a.MediaPath);
                this.setupImage();
            });
            return;
        }
        this.containerStyle = {
            'width': this.maxWidth,
            'height': this.maxHeight,
            'overflow': 'hidden'
        };
        this.imageStyle = {
            'width': this.maxWidth
        };
        if (this.dwStyle) {
            this.imageStyle = this.dwStyle;
        }
        if (!this.src) {
            return;
        }
        if (this.lastSrc && this.src == this.lastSrc) {
            return;
        }
        this.lastSrc = this.src;
        const image = new Image();
        image.src = this.src;
        image.onload = (e) => {
            const imageSize = this.getImageSize(e);
            if (!imageSize) {
                this.imageStyle = {
                    'width': this.maxWidth
                };
                return;
            }
            if (imageSize.width > imageSize.height) {
                this.imageStyle = {
                    'width': this.maxWidth
                };
            }
            else {
                this.imageStyle = {
                    'height': this.maxHeight
                };
            }
        };
    }
    getImageSize(imageLoadEvent) {
        const image = imageLoadEvent.currentTarget;
        if (!image) {
            return null;
        }
        return { height: image.height, width: image.width };
    }
}
DwImageComponent.ɵfac = function DwImageComponent_Factory(t) { return new (t || DwImageComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService)); };
DwImageComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwImageComponent, selectors: [["dw-image"]], inputs: { src: "src", mediaId: "mediaId", mediaPath: "mediaPath", defaultSrc: "defaultSrc", maxWidth: "maxWidth", maxHeight: "maxHeight", class: "class", dwStyle: "dwStyle" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 5, consts: [[3, "ngStyle"], [3, "src", "defaultSrc", "ngStyle", "ngClass"]], template: function DwImageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "img", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngStyle", ctx.containerStyle);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.src, ɵngcc0.ɵɵsanitizeUrl)("defaultSrc", ctx.defaultSrc)("ngStyle", ctx.imageStyle)("ngClass", ctx.class);
    } }, directives: [ɵngcc4.NgStyle, DwMissingImageDirective, ɵngcc4.NgClass], encapsulation: 2 });
DwImageComponent.ctorParameters = () => [
    { type: DwMediaRepositoryService }
];
DwImageComponent.propDecorators = {
    src: [{ type: Input }],
    mediaId: [{ type: Input }],
    mediaPath: [{ type: Input }],
    defaultSrc: [{ type: Input }],
    maxWidth: [{ type: Input }],
    maxHeight: [{ type: Input }],
    class: [{ type: Input }],
    dwStyle: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwImageComponent, [{
        type: Component,
        args: [{
                selector: 'dw-image',
                template: `
    <div [ngStyle]="containerStyle">
      <img [src]="src" [defaultSrc]="defaultSrc" [ngStyle]="imageStyle" [ngClass]="class">
    </div>
  `
            }]
    }], function () { return [{ type: DwMediaRepositoryService }]; }, { src: [{
            type: Input
        }], mediaId: [{
            type: Input
        }], mediaPath: [{
            type: Input
        }], defaultSrc: [{
            type: Input
        }], maxWidth: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], class: [{
            type: Input
        }], dwStyle: [{
            type: Input
        }] }); })();

class DwMagicImageDirective {
    constructor(el) {
        this.el = el;
        console.log('dwMagicImageDirective created');
    }
    ngOnChanges(changes) {
        if (!isFirstChange(changes)) {
            this.setupImage();
        }
    }
    ngOnInit() {
        this.setupImage();
    }
    setupImage() {
        if (!this.src) {
            return;
        }
        if (this.lastSrc && this.src == this.lastSrc) {
            return;
        }
        this.lastSrc = this.src;
        const image = new Image();
        image.src = this.src;
        image.onload = (e) => {
            const height = e.path[0].height;
            const width = e.path[0].width;
            if (width > height) {
                this.width = this.maxWidth;
                this.height = null;
            }
            else {
                this.height = this.maxHeight;
                this.width = null;
            }
        };
    }
}
DwMagicImageDirective.ɵfac = function DwMagicImageDirective_Factory(t) { return new (t || DwMagicImageDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DwMagicImageDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMagicImageDirective, selectors: [["", "dwMagicImage", ""]], hostVars: 4, hostBindings: function DwMagicImageDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("width", ctx.width)("height", ctx.height);
    } }, inputs: { maxWidth: "maxWidth", maxHeight: "maxHeight", src: "src" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
DwMagicImageDirective.ctorParameters = () => [
    { type: ElementRef }
];
DwMagicImageDirective.propDecorators = {
    maxWidth: [{ type: Input }],
    maxHeight: [{ type: Input }],
    src: [{ type: Input }],
    width: [{ type: HostBinding, args: ['style.width',] }],
    height: [{ type: HostBinding, args: ['style.height',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMagicImageDirective, [{
        type: Directive,
        args: [{
                selector: "[dwMagicImage]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { width: [{
            type: HostBinding,
            args: ['style.width']
        }], height: [{
            type: HostBinding,
            args: ['style.height']
        }], maxWidth: [{
            type: Input
        }], maxHeight: [{
            type: Input
        }], src: [{
            type: Input
        }] }); })();

class DwAvatarConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.availableRelations = [];
    }
    sectionChanged() {
        if (!this.section) {
            return;
        }
        this.section.avatarMediaIdAttrName = this.section.avatarMediaIdAttrName || defaultAvatarMediaIdAttrName;
        this.section.bannerHeightPercent = this.section.bannerHeightPercent || defaultBannerHeightPercent;
        if (this.section.loadWithParent !== true) {
            this.section.loadWithParent = false;
        }
        this.setupAvailableRelationships();
        this.setupContextList();
    }
    setupContextList() {
        return this.dwContextService.getContextMetaDataList(this.contextNames)
            .subscribe(contextMdList => {
            this.contextMdList = contextMdList;
            if (this.section.contextName) {
                this.currentContextMd = this.contextMdList[this.section.contextName];
            }
        });
    }
    setContextDef() {
        if (!this.contextMdList) {
            return;
        }
        if (this.section.contextName) {
            this.currentContextMd = this.contextMdList[this.section.contextName];
        }
        this.onSectionChange();
    }
    setupAvailableRelationships() {
        var _a;
        if (!this.itemMetaData) {
            return;
        }
        this.availableRelations = (_a = this.itemMetaData) === null || _a === void 0 ? void 0 : _a.Relations.filter(relation => {
            return relation.PkUniqueItemName == 'roMedia';
        });
    }
    setupRelationship(relationshipName) {
        if (!this.itemMetaData) {
            return;
        }
        // Find relationship    
        this.relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        this.relationshipDisplay = null;
        if (this.relationship) {
            this.relationshipDisplay = `${this.relationship.PkUniqueItemName}.${this.relationship.PkAttributeName} (PK) = ${this.relationship.FkUniqueItemName}.${this.relationship.FkAttributeName} (FK)`;
        }
    }
    setAvatarRelationship(relationshipName) {
        this.section.avatarRelationshipInfo = this.getRelationshipInfo(relationshipName, this.section.avatarRelationshipInfo);
        this.onSectionChange();
    }
    getRelationshipInfo(relationshipName, defaultInfo) {
        const relationship = this.itemMetaData.Relations.find(r => r.RelationshipName == relationshipName);
        if (!relationship) {
            return null;
        }
        const relationshipInfo = defaultInfo || {};
        relationshipInfo.relationshipName = relationship.RelationshipName;
        relationshipInfo.propertyName = relationship.NamingInfo.RelationshipPropertyName;
        if (this.relationship.IsPrimaryItem) {
            relationshipInfo.childItem = this.relationship.FkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.PkUniqueItemName;
        }
        else {
            relationshipInfo.childItem = this.relationship.PkUniqueItemName;
            relationshipInfo.parentItem = this.relationship.FkUniqueItemName;
        }
        return relationshipInfo;
    }
}
DwAvatarConfigComponent.ɵfac = function DwAvatarConfigComponent_Factory(t) { return ɵDwAvatarConfigComponent_BaseFactory(t || DwAvatarConfigComponent); };
DwAvatarConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAvatarConfigComponent, selectors: [["dw-avatar-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 38, vars: 10, consts: [["header", "Avatar Configuration"], ["dwRow", ""], ["dwCol", "6"], [3, "ngModel", "ngModelChange"], ["dwRow", "", 4, "ngIf"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], ["dwCol", "4"], ["type", "number", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], ["dwCol", "6", 4, "ngIf"]], template: function DwAvatarConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Load With Parent");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_dw_yesno_ngModelChange_7_listener($event) { return ctx.section.loadWithParent = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_dw_yesno_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwAvatarConfigComponent_div_8_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵelementStart(9, "div", 1);
        ɵngcc0.ɵɵelementStart(10, "div", 2);
        ɵngcc0.ɵɵelementStart(11, "label");
        ɵngcc0.ɵɵtext(12, "Use Context");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_dw_yesno_ngModelChange_13_listener($event) { return ctx.section.useContext = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_dw_yesno_ngModelChange_13_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, DwAvatarConfigComponent_div_14_Template, 3, 2, "div", 4);
        ɵngcc0.ɵɵtemplate(15, DwAvatarConfigComponent_div_15_Template, 6, 2, "div", 4);
        ɵngcc0.ɵɵelementStart(16, "div", 1);
        ɵngcc0.ɵɵelementStart(17, "div", 2);
        ɵngcc0.ɵɵelementStart(18, "label");
        ɵngcc0.ɵɵtext(19, "Default Avatar Media Url");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_20_listener($event) { return ctx.section.defaultAvatarMediaUrl = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_20_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "div", 1);
        ɵngcc0.ɵɵelementStart(22, "div", 6);
        ɵngcc0.ɵɵelementStart(23, "label");
        ɵngcc0.ɵɵtext(24, "Crop to Circle");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "dw-yesno", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_dw_yesno_ngModelChange_25_listener($event) { return ctx.section.cropToCircle = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_dw_yesno_ngModelChange_25_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(26, "div", 2);
        ɵngcc0.ɵɵelementStart(27, "label");
        ɵngcc0.ɵɵtext(28, "Section Padding");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_29_listener($event) { return ctx.section.sectionPadding = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_29_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "div", 6);
        ɵngcc0.ɵɵelementStart(31, "label");
        ɵngcc0.ɵɵtext(32, "Width");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(33, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_33_listener($event) { return ctx.section.imageWidth = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_33_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(34, "div", 6);
        ɵngcc0.ɵɵelementStart(35, "label");
        ɵngcc0.ɵɵtext(36, "Height");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_37_listener($event) { return ctx.section.imageHeight = $event; })("ngModelChange", function DwAvatarConfigComponent_Template_input_ngModelChange_37_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.loadWithParent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section == null ? null : ctx.section.loadWithParent);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.useContext);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section.useContext && ctx.contextMdList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.section.useContext);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.defaultAvatarMediaUrl);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.cropToCircle);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.sectionPadding);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.imageWidth);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.imageHeight);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, DwYesNoComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgIf, ɵngcc3.DefaultValueAccessor, ɵngcc3.NumberValueAccessor, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
const ɵDwAvatarConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAvatarConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAvatarConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-avatar-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Avatar Configuration\">\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Load With Parent</label>\r\n                    <dw-yesno [(ngModel)]=\"section.loadWithParent\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div> \r\n            </div>\r\n            <div dwRow *ngIf=\"section?.loadWithParent\">\r\n                <div dwCol=\"6\">\r\n                    <label>Avatar Relationship</label>\r\n                    <select [ngModel]=\"section?.avatarRelationshipInfo?.relationshipName\" (ngModelChange)=\"setAvatarRelationship($event)\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of availableRelations\" [ngValue]=\"item.RelationshipName\">\r\n                            {{item.FkItemName}} (By {{item.FkAttributeName}})\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Use Context</label> \r\n                    <dw-yesno [(ngModel)]=\"section.useContext\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"section.useContext && contextMdList\">\r\n                <div dwCol=\"6\" *ngIf=\"section.useContext\">\r\n                    <label>Context</label> \r\n                    <select [(ngModel)]=\"section.contextName\" (ngModelChange)=\"setContextDef()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let contextName of contextNames\" [ngValue]=\"contextName\">\r\n                            {{ contextMdList[contextName]?.contextDef?.contextDisplay || contextName }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n                <div dwCol=\"6\" *ngIf=\"currentContextMd\">\r\n                    <label>Avatar Media Field (Context)</label>\r\n                    <select [(ngModel)]=\"section.avatarMediaIdAttrName\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of currentContextMd?.attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n            </div>\r\n            <div dwRow *ngIf=\"!section.useContext\">\r\n                <div dwCol=\"6\">\r\n                    <label>Avatar Media Field</label>\r\n                    <select [(ngModel)]=\"section.avatarMediaIdAttrName\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let item of itemMetaData?.Attributes\" [ngValue]=\"item.AttributeName\">\r\n                            {{ item.AttributeName }}\r\n                        </option>\r\n                    </select> \r\n                </div>\r\n               \r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Default Avatar Media Url</label>\r\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"section.defaultAvatarMediaUrl\" (ngModelChange)=\"onSectionChange()\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"4\">\r\n                    <label>Crop to Circle</label>\r\n                    <dw-yesno [(ngModel)]=\"section.cropToCircle\" (ngModelChange)=\"onSectionChange()\"></dw-yesno>\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Section Padding</label>\r\n                    <input type=\"number\" class=\"form-control\" [(ngModel)]=\"section.sectionPadding\" (ngModelChange)=\"onSectionChange()\">\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Width</label>\r\n                    <input type=\"number\" class=\"form-control\" [(ngModel)]=\"section.imageWidth\" (ngModelChange)=\"onSectionChange()\">\r\n                </div>\r\n                <div dwCol=\"4\">\r\n                    <label>Height</label>\r\n                    <input type=\"number\" class=\"form-control\" [(ngModel)]=\"section.imageHeight\" (ngModelChange)=\"onSectionChange()\">\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>  \r\n</div>",
                styles: [""]
            }]
    }], null, null); })();

// @DwSectionComponent({
//   keyName:'dwProfileBanner',
//   display: 'Devware Avatar Banner',
//   configComponent: DwAvatarBannerConfigComponent,
//   sectionIcon: 'fa fa-id-card',
//   hasReadOnlyMode : true,
//   getPrefetchPathInfo: getAvatarBannerPrefetchPathInfo
// })
class DwAvatarSectionComponent extends DwSectionReadonlyBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwOrmDataService, uiConfig, dwActionConfigService, dwMetadataFormUtilService, dwMetaDataFormStateService, dwMetaDataFormActionService, dwMediaRepositoryService, dwMetaDataFormSectionStateService) {
        super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwOrmDataService = dwOrmDataService;
        this.uiConfig = uiConfig;
        this.dwActionConfigService = dwActionConfigService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwMetaDataFormStateService = dwMetaDataFormStateService;
        this.dwMetaDataFormActionService = dwMetaDataFormActionService;
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.inEditMode = false;
        this.editModeClass = '';
        this.actionPrefs = [];
        this.bannerHeightPercent = defaultBannerHeightPercent;
        this.bannerMediaImageReSize = {
            cropWidth: 550,
            cropHeight: 138,
            cropRound: false,
            outputWidth: 2400,
            outputHeight: 600,
            allowResize: true
        };
        this.avatarMediaImageSize = {
            width: 450,
            height: 450,
            mode: DwImageSizeMode.crop,
            cropToCircle: true
        };
        // avatarMediaImageReSize: DwImageResizeOptions = {
        //   cropWidth: 250,
        //   cropHeight: 250,
        //   cropRound: true,
        //   outputWidth: 250,
        //   outputHeight: 250,
        //   allowResize: true
        // };
        this.sectionStyle = {};
        this.initComplete = false;
        this.loadingMedia = false;
        this.contextLoading = false;
        this.contextLoadingTime = 500; // Context load window in ms - This causes the media to wait for x ms before showing the default media - otherwise we see a flash of the default media
    }
    sectionReadOnlyChanged(readOnly) {
        this.isReadOnly = readOnly;
    }
    sectionConfigChanged() {
        var _a, _b, _c;
        this.avatarFieldName = ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.avatarMediaIdAttrName) || defaultAvatarMediaIdAttrName;
        this.bannerHeightPercent = ((_b = this.sectionConfig) === null || _b === void 0 ? void 0 : _b.bannerHeightPercent) || defaultBannerHeightPercent;
        this.bannerMediaImageReSize.cropHeight = this.bannerMediaImageReSize.cropWidth * (this.bannerHeightPercent / 100);
        this.avatarMediaImageSize.width = this.sectionConfig.imageWidth || 150;
        this.avatarMediaImageSize.height = this.sectionConfig.imageHeight || 150;
        this.avatarMediaImageSize.cropToCircle = (_c = this.sectionConfig.cropToCircle) !== null && _c !== void 0 ? _c : true;
        this.sectionStyle = {
            'width': '100%',
            'padding': '5px',
        };
        if (this.sectionConfig.sectionPadding) {
            this.sectionStyle.padding = `${this.sectionConfig.sectionPadding}px`;
        }
        this.initMedia();
    }
    formConfigChanged() {
        if (!this.formConfig) {
            return;
        }
        this.isReadOnly = this.isSectionReadOnly();
    }
    setAvatarMedia(media) {
        this.avatarMedia = media;
        if (!media) {
            return;
        }
    }
    initMedia() {
        if (this.sectionConfig.useContext) {
            this.initContextMedia();
        }
        else {
            this.initFormMedia();
        }
    }
    initContextMedia() {
        if (!this.sectionConfig.useContext || !this.sectionConfig.contextName) {
            return;
        }
        const context = this.context[this.sectionConfig.contextName];
        if (!context) {
            this.message = {
                messageHeading: `Error loading images - context ${this.sectionConfig.contextName} not found`,
                severity: DwMessageSeverity.error,
            };
            return;
        }
        if (context.value) {
            this.contextValue = context.value;
            this.loadMedia();
        }
        else {
            // If we don't have initial media, let's wait for before showing the default media
            this.contextLoading = true;
            setTimeout(() => {
                if (this.contextLoading) {
                    this.contextLoading = false;
                    this.loadMedia();
                }
            }, this.contextLoadingTime);
        }
        context.subscribe(contextValue => {
            this.contextValue = contextValue;
            if (this.contextLoading) {
                this.contextLoading = false;
            }
            this.loadMedia();
        });
    }
    initFormMedia() {
        var _a;
        // Wait for form to load data
        const formContext = this.context[DwMdFormContextInfo.FORM_CONTEXT_NAME];
        if (!formContext) {
            return;
        }
        if (formContext && !((_a = formContext.value) === null || _a === void 0 ? void 0 : _a.loadDataComplete)) {
            this.subscriptions.push(formContext.subscribe((formContext) => {
                if (formContext.loadDataComplete) {
                    this.loadMedia();
                }
            }));
            return;
        }
        if (!this.sectionConfig || !this.formConfig) {
            // Try again in 50 ms
            setTimeout(() => {
                this.loadMedia();
            }, 500);
            return;
        }
        if (this.loadingMedia) {
            return;
        }
    }
    getMediaId() {
        var _a;
        if ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.useContext) {
            if (this.contextValue) {
                return this.contextValue[this.avatarFieldName];
            }
            return null;
        }
        const dataRelations = this.dwMetadataFormUtilService.getSectionDataPath(this.sectionConfig, this.formConfig.section, this.formConfig.queryMetaDataList);
        const dataContextValue = this.context[DwMdFormContextInfo.DATA_CONTEXT_NAME].value;
        let parentDataItem = dataContextValue;
        for (const dataRelation of dataRelations) {
            if (parentDataItem) {
                parentDataItem = parentDataItem[dataRelation.propertyName];
            }
        }
        if (parentDataItem) {
            return parentDataItem[this.avatarFieldName];
        }
        console.warn(`dw-avatar-banner - Can't find parent data`, dataRelations);
    }
    loadMedia() {
        var _a;
        if (this.loadingMedia) {
            return;
        }
        this.loadingMedia = true;
        let avatarMediaId = this.getMediaId();
        if (!avatarMediaId) {
            if (this.contextLoading) {
                // wait a bit for context to load before showing default media
                return;
            }
            this.defaultAvatarMediaUrl = ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.defaultAvatarMediaUrl) || this.uiConfig.defaultAvatarImageUrl;
            avatarMediaId = this.sectionConfig.defaultAvatarMediaId;
            if (!avatarMediaId) {
                // Delay a bit before marking as complete so cotext can load
                setTimeout(() => {
                    this.initComplete = true;
                }, 1250);
                this.loadingMedia = false;
                return;
            }
        }
        this.dwMediaRepositoryService.loadMedia([avatarMediaId])
            .subscribe(mediaItems => {
            this.initComplete = true;
            this.avatarMedia = mediaItems.find(mi => mi.MediaId == avatarMediaId);
            this.loadingMedia = false;
        });
    }
    setFormControlValue(fieldName, fieldValue) {
        let fc = this.formGroup.get(fieldName);
        if (!fc) {
            fc = new FormControl();
            this.formGroup.addControl(fieldName, fc);
        }
        fc.setValue(fieldValue);
        return fc;
    }
    getFormControlValue(fieldName) {
        let fc = this.formGroup.get(fieldName);
        return fc === null || fc === void 0 ? void 0 : fc.value;
    }
    ngOnInit() {
        super.ngOnInit();
    }
}
DwAvatarSectionComponent.ɵfac = function DwAvatarSectionComponent_Factory(t) { return new (t || DwAvatarSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwOrmDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataActionConfigService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormStateService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormActionService), ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwMetaDataFormSectionStateService)); };
DwAvatarSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAvatarSectionComponent, selectors: [["dw-avatar"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "dw-avatar-section", 3, "ngStyle", 4, "ngIf"], [1, "dw-avatar-section", 3, "ngStyle"], ["mediaClass", "dw-avatar-small dw-avatar-image", 3, "media", "sizeOptions", "useImageTag", "defaultMediaUrl"]], template: function DwAvatarSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwAvatarSectionComponent_div_0_Template, 2, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.initComplete);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgStyle, DwMediaItemComponent], styles: [""] });
DwAvatarSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwMetaDataActionConfigService },
    { type: DwMetadataFormUtilService },
    { type: DwMetaDataFormStateService },
    { type: DwMetaDataFormActionService },
    { type: DwMediaRepositoryService },
    { type: DwMetaDataFormSectionStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAvatarSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-avatar',
                template: "<div [ngStyle]=\"sectionStyle\" class=\"dw-avatar-section\" *ngIf=\"initComplete\">\r\n    <dw-media-item [media]=\"avatarMedia\" [sizeOptions]=\"avatarMediaImageSize\" [useImageTag]=\"true\"\r\n    mediaClass=\"dw-avatar-small dw-avatar-image\"\r\n    [defaultMediaUrl]=\"defaultAvatarMediaUrl\"></dw-media-item>\r\n</div> ",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwMetaDataActionConfigService }, { type: DwMetadataFormUtilService }, { type: DwMetaDataFormStateService }, { type: DwMetaDataFormActionService }, { type: DwMediaRepositoryService }, { type: DwMetaDataFormSectionStateService }]; }, null); })();
// Move here to avoid stuff typescript combine error when packaged
DwSectionComponent({
    keyName: 'dwAvatar',
    display: 'Devware Avatar (Read Only)',
    configComponent: DwAvatarConfigComponent,
    sectionIcon: 'fa fa-id-card',
    hasReadOnlyMode: false,
    getPrefetchPathInfo: getAvatarBannerPrefetchPathInfo
})(DwAvatarSectionComponent);

// @DwComponent({
//   key: 'securityAvatar',
//   componentType: DwComponentType.pageComponent,
//   name: 'Devware Avatar'
// })
class DwAvatarComponent {
    constructor(dwMediaRepositoryService, dwSecurityStateService, dwUiConfig) {
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.dwSecurityStateService = dwSecurityStateService;
        this.dwUiConfig = dwUiConfig;
        this.loading = false;
        this.defaultAvatarUrl = dwUiConfig.defaultAvatarImageUrl || '/assets/img/user-loging.png';
    }
    ngOnInit() {
        this.setupAvatarMedia();
        this.dwSecurityStateService.securityStateObservable.subscribe(securityChange => this.setupAvatarMedia());
    }
    setupAvatarMedia() {
        var _a;
        const user = (_a = this.dwSecurityStateService.securityState.securityContext) === null || _a === void 0 ? void 0 : _a.ApplicationUser;
        if (!(user === null || user === void 0 ? void 0 : user.UserPictureMediaId)) {
            this.avatarMedia = null;
            this.additionalClass = null;
            return;
        }
        if ((user === null || user === void 0 ? void 0 : user.UserPictureMediaId) == this.lastAvatarMediaId) {
            return;
        }
        this.lastAvatarMediaId = user === null || user === void 0 ? void 0 : user.UserPictureMediaId;
        // Check if there is a change
        if (this.avatarMedia && this.avatarMedia.MediaId == (user === null || user === void 0 ? void 0 : user.UserPictureMediaId)) {
            return;
        }
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.dwMediaRepositoryService.loadMedia(user === null || user === void 0 ? void 0 : user.UserPictureMediaId)
            .subscribe(mediaItems => {
            this.avatarMedia = mediaItems.find(mi => mi.MediaId == (user === null || user === void 0 ? void 0 : user.UserPictureMediaId));
            if (this.avatarMedia) {
                this.additionalClass = 'dw-security-image-avatar';
            }
            this.loading = false;
            // Run one more time in case media has changed while it was loading
            this.setupAvatarMedia();
        });
    }
}
DwAvatarComponent.ɵfac = function DwAvatarComponent_Factory(t) { return new (t || DwAvatarComponent)(ɵngcc0.ɵɵdirectiveInject(DwMediaRepositoryService), ɵngcc0.ɵɵdirectiveInject(DwSecurityStateService), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken)); };
DwAvatarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAvatarComponent, selectors: [["dw-avatar"]], decls: 1, vars: 4, consts: [[3, "media", "sizeOptions", "mediaClass", "defaultMediaUrl"]], template: function DwAvatarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "dw-media-item", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵpropertyInterpolate1("mediaClass", "dw-security-avatar ", ctx.additionalClass, "");
        ɵngcc0.ɵɵproperty("media", ctx.avatarMedia)("sizeOptions", ctx.avatarMediaImageSize)("defaultMediaUrl", ctx.defaultAvatarUrl);
    } }, directives: [DwMediaItemComponent], encapsulation: 2 });
DwAvatarComponent.ctorParameters = () => [
    { type: DwMediaRepositoryService },
    { type: DwSecurityStateService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAvatarComponent, [{
        type: Component,
        args: [{
                selector: 'dw-avatar',
                template: `
    <dw-media-item [media]="avatarMedia" [sizeOptions]="avatarMediaImageSize"
       mediaClass="dw-security-avatar {{additionalClass}}"
      [defaultMediaUrl]="defaultAvatarUrl"></dw-media-item>
`
            }]
    }], function () { return [{ type: DwMediaRepositoryService }, { type: DwSecurityStateService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }]; }, null); })();
// Work around for TypeError: Class constructor cannot be invoked with 'new'
DwComponent({
    key: 'securityAvatar',
    componentType: DwComponentType.pageComponent,
    name: 'Devware Avatar'
})(DwAvatarComponent);

class DwDownloadMediaConfigComponent extends DwActionConfigBaseComponent {
    constructor(metaDataService, dwContextService) {
        super();
        this.metaDataService = metaDataService;
        this.dwContextService = dwContextService;
        this.contextList = [];
        this.attributes = [];
    }
    addControls() {
        this.itemFC = this.addControl('itemName');
        this.attrNameFC = this.addControl('attrName', Validators.required);
        this.addControl('isSecure', null, false);
        this.useContextFC = this.addControl('useContext', null, false);
        this.contextNameFC = this.addControl('contextName');
        this.attrNameFC.valueChanges.subscribe(value => {
            var _a;
            const attr = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.find(a => a.AttributeName === value);
            if (attr && attr.ItemName) {
                this.itemFC.setValue(attr.ItemName);
            }
        });
        this.useContextFC.valueChanges.subscribe(value => {
            //this.attrNameFC.setValue(null);
        });
        this.contextNameFC.valueChanges.subscribe(contextName => {
            if (contextName) {
                this.currentContextMd = this.contextMdList[contextName];
            }
        });
        this.setupMetaData();
    }
    setupMetaData() {
        var _a;
        this.metaDataService.getSavedQueryMetaData(this.configContext.itemName, null, this.configContext.metaDataQueryMeaning)
            .subscribe(itemMd => {
            this.attributes = itemMd.Attributes;
        });
        if (((_a = this.configContext.contextNames) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.dwContextService.getContextMetaDataList(this.configContext.contextNames)
                .subscribe(contextMdList => {
                this.contextMdList = contextMdList;
                this.setupContexts();
            });
        }
        else {
            this.useContextFC.setValue(false);
        }
    }
    setupContexts() {
        if (!this.contextMdList) {
            return;
        }
        for (const contextName of this.configContext.contextNames) {
            const contextDef = this.dwContextService.getContextDef(contextName);
            if (contextDef) {
                const contextDefMetaData = this.contextMdList[contextName];
                contextDef.contextDisplay;
                this.contextList.push(contextDef);
            }
        }
    }
}
DwDownloadMediaConfigComponent.ɵfac = function DwDownloadMediaConfigComponent_Factory(t) { return new (t || DwDownloadMediaConfigComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwContextService)); };
DwDownloadMediaConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwDownloadMediaConfigComponent, selectors: [["dw-dw-download-media-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", "", 4, "ngIf"], [4, "ngIf"], ["dwRow", ""], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "isSecure"], ["formControlName", "useContext"], ["dwCol", "12"], [1, "label"], ["formControlName", "contextName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["dwCol", "12", 4, "ngIf"], [3, "ngValue"], ["formControlName", "attrName", 1, "form-control"]], template: function DwDownloadMediaConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwDownloadMediaConfigComponent_div_0_Template, 10, 4, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], encapsulation: 2 });
DwDownloadMediaConfigComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwContextService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDownloadMediaConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-download-media-config',
                template: "<div *ngIf=\"actionConfigFG\" [formGroup]=\"actionConfigFG\">\n    <div dwRow *ngIf=\"contextList?.length>0\">\n        <div dwCol=\"9\">\n            <label>Use Context</label>\n        </div>\n        <div dwCol=\"3\">\n            <p-inputSwitch formControlName=\"useContext\"></p-inputSwitch>\n        </div>\n    </div>\n    <ng-container *ngIf=\"actionConfigFG?.value?.useContext && contextList?.length>0\">\n        <div dwRow>\n            <div dwCol=\"12\">\n                <label class=\"label\">Context</label>\n                <select formControlName=\"contextName\" class=\"form-control\">\n                    <option *ngFor=\"let contextDef of contextList\" [ngValue]=\"contextDef.contextName\">\n                        {{ contextDef.contextDisplay }}\n                </select>\n            </div>\n        </div>\n        <div dwRow>\n            <div dwCol=\"12\" *ngIf=\"currentContextMd?.attributes?.length>0\">\n                <label class=\"label\">Context Media Attribute</label>\n                <select formControlName=\"attrName\" class=\"form-control\">\n                    <option *ngFor=\"let attr of currentContextMd?.attributes || []\" [ngValue]=\"attr.AttributeName\">\n                        {{ attr.AttributeDisplay }}\n                </select>\n            </div>\n        </div>\n    </ng-container>\n    <ng-container *ngIf=\"!actionConfigFG?.value?.useContext || contextList?.length==0\">\n        <div dwRow>\n            <div dwCol=\"12\">\n                <label class=\"label\">Media Attribute</label>\n                <select formControlName=\"attrName\" class=\"form-control\">\n                    <option *ngFor=\"let attr of attributes\" [ngValue]=\"attr.AttributeName\">\n                        {{ attr.AttributeDisplay }}\n                </select>\n            </div>\n        </div>\n    </ng-container>\n    <div dwRow>\n        <div dwCol=\"9\">\n            <label>Is Secure Download</label>\n        </div>\n        <div dwCol=\"3\">\n            <p-inputSwitch formControlName=\"isSecure\"></p-inputSwitch>\n        </div>\n    </div>\n"
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwContextService }]; }, null); })();

class DwDownloadMediaActionService {
    constructor(dwMediaService) {
        this.dwMediaService = dwMediaService;
    }
    handleAction(actionState) {
        const downloadConfig = actionState.actionConfig;
        const mediaId = this.getMediaId(downloadConfig, actionState.data, actionState.context); // actionState.data[downloadConfig.attrName];
        if (!mediaId) {
            return of({ success: false });
        }
        return this.dwMediaService.downloadMediaFromMediaId(mediaId, false, downloadConfig.isSecure, downloadConfig.itemName, downloadConfig.attrName)
            .pipe(map(result => {
            return { success: true };
        }));
    }
    getMediaId(downloadConfig, data, resolvedContext) {
        if (!downloadConfig.useContext) {
            return data[downloadConfig.attrName];
        }
        if (!resolvedContext || !downloadConfig.contextName) {
            return null;
        }
        const context = resolvedContext[downloadConfig.contextName];
        if (context) {
            return context[downloadConfig.attrName];
        }
    }
}
DwDownloadMediaActionService.ɵfac = function DwDownloadMediaActionService_Factory(t) { return new (t || DwDownloadMediaActionService)(ɵngcc0.ɵɵinject(DwMediaRepositoryService)); };
DwDownloadMediaActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwDownloadMediaActionService, factory: DwDownloadMediaActionService.ɵfac });
DwDownloadMediaActionService.ctorParameters = () => [
    { type: DwMediaRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDownloadMediaActionService, [{
        type: Injectable
    }], function () { return [{ type: DwMediaRepositoryService }]; }, null); })();
DwActionFunc({
    keyName: 'dw-download-media-action',
    display: 'Download Media',
    actionType: DwActionType.gridRowAction,
    configComponent: DwDownloadMediaConfigComponent,
    isGlobal: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        //buttonText: 'Reset Student Progress',
        iconClass: 'fa fa-download dw-icon-grid dw-blue',
        buttonType: DwButtonType.iconOnlyNoText,
        buttonClass: 'btn btn-primary',
        buttonTitle: 'Download File'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        // permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: false
    },
    defaultConfirmConfig: {
        showDialogConfig: false,
    }
}, DwDownloadMediaActionService);
DwActionFunc({
    keyName: 'dw-download-media-action-form',
    display: 'Download Media',
    actionType: DwActionType.formAction,
    configComponent: DwDownloadMediaConfigComponent,
    isGlobal: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        //buttonText: 'Reset Student Progress',
        iconClass: 'fa fa-download dw-icon-grid dw-blue',
        buttonType: DwButtonType.iconOnlyNoText,
        buttonClass: 'btn btn-primary',
        buttonTitle: 'Download File'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        // permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: false
    },
    defaultConfirmConfig: {
        showDialogConfig: false,
    }
}, DwDownloadMediaActionService);

class DevwareMediaModule {
}
DevwareMediaModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareMediaModule });
DevwareMediaModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareMediaModule_Factory(t) { return new (t || DevwareMediaModule)(); }, providers: [
        [LyTheme2],
        [StyleRenderer],
        // Theme that will be applied to this module
        { provide: LY_THEME_NAME, useValue: 'minima-light' },
        { provide: LY_THEME, useClass: MinimaLight, multi: true },
        { provide: LY_THEME, useClass: MinimaDark, multi: true },
        // Gestures
        { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig },
        {
            provide: DwMediaConfigToken,
            useFactory(configService) {
                const mediaConfig = configService.getConfig(DwMediaConfigName, new DwMediaConfigDefaults());
                return mediaConfig;
            },
            deps: [DwConfigServiceToken]
        },
        DwDownloadMediaActionService
    ], imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            DevwareCoreModule,
            DevwareOrmModule,
            DevwareUIModule,
            DevwareUIMetaDataModule,
            SliderModule,
            TabViewModule,
            LyImageCropperModule,
            LySliderModule,
            HammerModule,
            InputSwitchModule,
            ProgressBarModule,
            GalleriaModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareMediaModule, { declarations: function () { return [DwFileUploadComponent, DwFileDropDirective, DwImageResizerComponent, DwFileUploadModalComponent, DwMediaItemComponent, DwAvatarBannerComponent, DwMediaSelectorComponent, DwAvatarBannerConfigComponent, DwAvatarComponent, DwImageSectionComponent, DwImageSectionConfigComponent, DwMultiFileSectionComponent, DwMultiFileSectionConfigComponent, DwMultiFileComponent, DwMediaItemCardComponent, DwImageComponent, DwMagicImageDirective, DwAvatarSectionComponent, DwAvatarConfigComponent, DwDownloadMediaConfigComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        ReactiveFormsModule, DevwareCoreModule, DevwareOrmModule, DevwareUIModule, DevwareUIMetaDataModule, SliderModule,
        TabViewModule,
        LyImageCropperModule,
        LySliderModule,
        HammerModule,
        InputSwitchModule,
        ProgressBarModule,
        GalleriaModule]; }, exports: function () { return [DwFileUploadComponent, DwImageResizerComponent, DwMediaItemComponent, DwImageComponent, DwMagicImageDirective, DwMediaSelectorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareMediaModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwFileUploadComponent,
                    DwFileDropDirective,
                    DwImageResizerComponent,
                    DwFileUploadModalComponent,
                    DwMediaItemComponent,
                    DwAvatarBannerComponent,
                    DwMediaSelectorComponent,
                    DwAvatarBannerConfigComponent,
                    DwAvatarComponent,
                    DwImageSectionComponent,
                    DwImageSectionConfigComponent,
                    DwMultiFileSectionComponent,
                    DwMultiFileSectionConfigComponent,
                    DwMultiFileComponent,
                    DwMediaItemCardComponent,
                    DwImageComponent,
                    DwMagicImageDirective,
                    DwAvatarSectionComponent,
                    DwAvatarConfigComponent,
                    DwDownloadMediaConfigComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule,
                    DevwareCoreModule,
                    DevwareOrmModule,
                    DevwareUIModule,
                    DevwareUIMetaDataModule,
                    SliderModule,
                    TabViewModule,
                    LyImageCropperModule,
                    LySliderModule,
                    HammerModule,
                    InputSwitchModule,
                    ProgressBarModule,
                    GalleriaModule,
                ],
                providers: [
                    [LyTheme2],
                    [StyleRenderer],
                    // Theme that will be applied to this module
                    { provide: LY_THEME_NAME, useValue: 'minima-light' },
                    { provide: LY_THEME, useClass: MinimaLight, multi: true },
                    { provide: LY_THEME, useClass: MinimaDark, multi: true },
                    // Gestures
                    { provide: HAMMER_GESTURE_CONFIG, useClass: LyHammerGestureConfig },
                    {
                        provide: DwMediaConfigToken,
                        useFactory(configService) {
                            const mediaConfig = configService.getConfig(DwMediaConfigName, new DwMediaConfigDefaults());
                            return mediaConfig;
                        },
                        deps: [DwConfigServiceToken]
                    },
                    DwDownloadMediaActionService
                ],
                exports: [
                    DwFileUploadComponent,
                    DwImageResizerComponent,
                    DwMediaItemComponent,
                    DwImageComponent,
                    DwMagicImageDirective,
                    DwMediaSelectorComponent
                ]
            }]
    }], null, null); })();

/************************************************
   Generated with the Devware CAP CLI 4.4.44
   Code Gen Name   Themes
   API Url         https://localhost:44368

   Generated By    DEVWARE/anthony.monsees
   Generate On     10/8/2024 5:35:58 AM
************************************************/
var ThemesMetaDataItemNames;
(function (ThemesMetaDataItemNames) {
    ThemesMetaDataItemNames["DwMedia"] = "dw_Media";
    ThemesMetaDataItemNames["DwRoMedia"] = "dw_roMedia";
    ThemesMetaDataItemNames["DwTheme"] = "dw_Theme";
    ThemesMetaDataItemNames["DwThemeProperty"] = "dw_ThemeProperty";
    ThemesMetaDataItemNames["DwThemePropertyDefinition"] = "dw_ThemePropertyDefinition";
    ThemesMetaDataItemNames["DwThemePropertyType"] = "dw_ThemePropertyType";
})(ThemesMetaDataItemNames || (ThemesMetaDataItemNames = {}));
var ThemesMetaDataLookups;
(function (ThemesMetaDataLookups) {
    ThemesMetaDataLookups[ThemesMetaDataLookups["MediaAllItems"] = 208] = "MediaAllItems";
    ThemesMetaDataLookups[ThemesMetaDataLookups["RoMediaAllItems"] = 202] = "RoMediaAllItems";
    ThemesMetaDataLookups[ThemesMetaDataLookups["ThemeAllItems"] = 2860] = "ThemeAllItems";
    ThemesMetaDataLookups[ThemesMetaDataLookups["ThemePropertyAllItems"] = 2863] = "ThemePropertyAllItems";
    ThemesMetaDataLookups[ThemesMetaDataLookups["ThemePropertyDefinitionAllItems"] = 2861] = "ThemePropertyDefinitionAllItems";
    ThemesMetaDataLookups[ThemesMetaDataLookups["ThemePropertyTypeAllItems"] = 2862] = "ThemePropertyTypeAllItems";
})(ThemesMetaDataLookups || (ThemesMetaDataLookups = {}));
// Generated Classes for MetaData service
class DwMediaMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwMediaMetaDataAttributes();
        this.Relations = new DwMediaMetaDataRelations();
        this.ItemDetail.itemId = 208;
        this.ItemDetail.itemName = 'dw_Media';
        this.ItemDetail.keyName = 'MediaId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwMediaMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_Media';
        // Attributes
        this.MediaId = new DwItemAttribute(this.i, 'MediaId');
        this.MediaName = new DwItemAttribute(this.i, 'MediaName');
        this.ContainerName = new DwItemAttribute(this.i, 'ContainerName');
        this.MediaTypeId = new DwItemAttribute(this.i, 'MediaTypeId');
        this.MediaStorageTypeId = new DwItemAttribute(this.i, 'MediaStorageTypeId');
        this.MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
        this.MediaFolderId = new DwItemAttribute(this.i, 'MediaFolderId');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
        this.ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
        this.IsSecure = new DwItemAttribute(this.i, 'IsSecure');
        this.IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    }
}
class DwMediaMetaDataRelations {
    constructor() {
        /** Relation: Ro Media */
        this.DwRoMedia = new DwItemRelationship('roMedia|Media|MediaId', 'DwroMedia', 'DwroMedia');
        /** Relation: Theme - Logo - Many */
        this.DwThemeByLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoMediaId', 'LogoDwTheme', 'LogoDwTheme');
        /** Relation: Theme - Alternate Logo - Many */
        this.DwThemeByAlternateLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|AlternateLogoMediaId', 'AlternateLogoDwTheme', 'AlternateLogoDwTheme');
        /** Relation: Theme - Logo Login - Many */
        this.DwThemeByLogoLoginMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoLoginMediaId', 'LogoLoginDwTheme', 'LogoLoginDwTheme');
    }
}
;
class DwRoMediaMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwRoMediaMetaDataAttributes();
        this.Relations = new DwRoMediaMetaDataRelations();
        this.ItemDetail.itemId = 202;
        this.ItemDetail.itemName = 'dw_roMedia';
        this.ItemDetail.keyName = '';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwRoMediaMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_roMedia';
        // Attributes
        this.MediaId = new DwItemAttribute(this.i, 'MediaId');
        this.MediaName = new DwItemAttribute(this.i, 'MediaName');
        this.MediaTypeId = new DwItemAttribute(this.i, 'MediaTypeId');
        this.ContainerName = new DwItemAttribute(this.i, 'ContainerName');
        this.FileName = new DwItemAttribute(this.i, 'FileName');
        this.MediaSizeTypeId = new DwItemAttribute(this.i, 'MediaSizeTypeId');
        this.ImageWidth = new DwItemAttribute(this.i, 'ImageWidth');
        this.ImageHeight = new DwItemAttribute(this.i, 'ImageHeight');
        this.MediaSizeType = new DwItemAttribute(this.i, 'MediaSizeType');
        this.SizeInBytes = new DwItemAttribute(this.i, 'SizeInBytes');
        this.Version = new DwItemAttribute(this.i, 'Version');
        this.MediaPath = new DwItemAttribute(this.i, 'MediaPath');
        this.IsSecure = new DwItemAttribute(this.i, 'IsSecure');
        this.CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
        this.CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
        this.MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
        this.MediaFolderId = new DwItemAttribute(this.i, 'MediaFolderId');
        this.IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
        this.MediaDetailKey = new DwItemAttribute(this.i, 'MediaDetailKey');
    }
}
class DwRoMediaMetaDataRelations {
    constructor() {
        /** Relation: Media */
        this.DwMedia = new DwItemRelationship('roMedia|Media|MediaId', 'DwMedia', 'DwMedia');
        /** Relation: Theme - Media */
        this.DwThemeByLogoMediaId = new DwItemRelationship('Theme|RoMedia|LogoMediaId', 'LogoDwTheme', 'LogoDwTheme');
        /** Relation: Theme - Media */
        this.DwThemeByAlternateLogoMediaId = new DwItemRelationship('Theme|RoMedia|AlternateLogoMediaId', 'AlternateLogoDwTheme', 'AlternateLogoDwTheme');
    }
}
;
class DwThemeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwThemeMetaDataAttributes();
        this.Relations = new DwThemeMetaDataRelations();
        this.ItemDetail.itemId = 3829;
        this.ItemDetail.itemName = 'dw_Theme';
        this.ItemDetail.keyName = 'ThemeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwThemeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_Theme';
        // Attributes
        this.ThemeId = new DwItemAttribute(this.i, 'ThemeId');
        this.ThemeName = new DwItemAttribute(this.i, 'ThemeName');
        this.IsDefault = new DwItemAttribute(this.i, 'IsDefault');
        this.LogoMediaId = new DwItemAttribute(this.i, 'LogoMediaId');
        this.LogoWidth = new DwItemAttribute(this.i, 'LogoWidth');
        this.LogoHeight = new DwItemAttribute(this.i, 'LogoHeight');
        this.AlternateLogoMediaId = new DwItemAttribute(this.i, 'AlternateLogoMediaId');
        this.AlternateLogoWidth = new DwItemAttribute(this.i, 'AlternateLogoWidth');
        this.AlternateLogoHeight = new DwItemAttribute(this.i, 'AlternateLogoHeight');
        this.LogoLoginMediaId = new DwItemAttribute(this.i, 'LogoLoginMediaId');
        this.LogoLoginWidth = new DwItemAttribute(this.i, 'LogoLoginWidth');
        this.LogoLoginHeight = new DwItemAttribute(this.i, 'LogoLoginHeight');
    }
}
class DwThemeMetaDataRelations {
    constructor() {
        /** Relation: Media - Logo Media */
        this.DwMediaByLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoMediaId', 'LogoDwMedia', 'LogoDwMedia');
        /** Relation: Media - Alternate Logo Media */
        this.DwMediaByAlternateLogoMediaId = new DwItemRelationship('dw_Media|dw_Theme|AlternateLogoMediaId', 'AlternateLogoDwMedia', 'AlternateLogoDwMedia');
        /** Relation: Ro Media - Logo Media */
        this.DwRoMediaByLogoMediaId = new DwItemRelationship('Theme|RoMedia|LogoMediaId', 'LogoDwroMedia', 'LogoDwroMedia');
        /** Relation: Ro Media - Alternate Logo Media */
        this.DwRoMediaByAlternateLogoMediaId = new DwItemRelationship('Theme|RoMedia|AlternateLogoMediaId', 'AlternateLogoDwroMedia', 'AlternateLogoDwroMedia');
        /** Relation: Media - Logo Login Media */
        this.DwMediaByLogoLoginMediaId = new DwItemRelationship('dw_Media|dw_Theme|LogoLoginMediaId', 'LogoLoginDwMedia', 'LogoLoginDwMedia');
        /** Relation: Theme Property */
        this.DwThemeProperty = new DwItemRelationship('dw_Theme|dw_ThemeProperty|ThemeId', 'DwThemeProperty', 'DwThemeProperty');
    }
}
;
class DwThemePropertyMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwThemePropertyMetaDataAttributes();
        this.Relations = new DwThemePropertyMetaDataRelations();
        this.ItemDetail.itemId = 3832;
        this.ItemDetail.itemName = 'dw_ThemeProperty';
        this.ItemDetail.keyName = 'ThemePropertyId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwThemePropertyMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_ThemeProperty';
        // Attributes
        this.ThemePropertyId = new DwItemAttribute(this.i, 'ThemePropertyId');
        this.ThemeId = new DwItemAttribute(this.i, 'ThemeId');
        this.ThemePropertyDefinitionId = new DwItemAttribute(this.i, 'ThemePropertyDefinitionId');
        this.PropertyValue = new DwItemAttribute(this.i, 'PropertyValue');
    }
}
class DwThemePropertyMetaDataRelations {
    constructor() {
        /** Relation: Theme */
        this.DwTheme = new DwItemRelationship('dw_Theme|dw_ThemeProperty|ThemeId', 'DwTheme', 'DwTheme');
        /** Relation: Theme Property Definition */
        this.DwThemePropertyDefinition = new DwItemRelationship('dw_ThemePropertyDefinition|dw_ThemeProperty|ThemePropertyDefinitionId', 'DwThemePropertyDefinition', 'DwThemePropertyDefinition');
    }
}
;
class DwThemePropertyDefinitionMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwThemePropertyDefinitionMetaDataAttributes();
        this.Relations = new DwThemePropertyDefinitionMetaDataRelations();
        this.ItemDetail.itemId = 3830;
        this.ItemDetail.itemName = 'dw_ThemePropertyDefinition';
        this.ItemDetail.keyName = 'ThemePropertyDefinitionId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwThemePropertyDefinitionMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_ThemePropertyDefinition';
        // Attributes
        this.ThemePropertyDefinitionId = new DwItemAttribute(this.i, 'ThemePropertyDefinitionId');
        this.PropertyDisplay = new DwItemAttribute(this.i, 'PropertyDisplay');
        this.PropertyName = new DwItemAttribute(this.i, 'PropertyName');
        this.ThemePropertyTypeId = new DwItemAttribute(this.i, 'ThemePropertyTypeId');
    }
}
class DwThemePropertyDefinitionMetaDataRelations {
    constructor() {
        /** Relation: Theme Property Type */
        this.DwThemePropertyType = new DwItemRelationship('dw_ThemePropertyType|dw_ThemePropertyDefinition|ThemePropertyTypeId', 'DwThemePropertyType', 'DwThemePropertyType');
        /** Relation: Theme Property */
        this.DwThemeProperty = new DwItemRelationship('dw_ThemePropertyDefinition|dw_ThemeProperty|ThemePropertyDefinitionId', 'DwThemeProperty', 'DwThemeProperty');
    }
}
;
class DwThemePropertyTypeMetaData {
    constructor() {
        this.ItemDetail = new DwItemDetail2();
        this.Attributes = new DwThemePropertyTypeMetaDataAttributes();
        this.Relations = new DwThemePropertyTypeMetaDataRelations();
        this.ItemDetail.itemId = 3831;
        this.ItemDetail.itemName = 'dw_ThemePropertyType';
        this.ItemDetail.keyName = 'ThemePropertyTypeId';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.itemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.itemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwThemePropertyTypeMetaDataAttributes {
    constructor() {
        //shortcut to item name - to reduce file size
        this.i = 'dw_ThemePropertyType';
        // Attributes
        this.PropertyType = new DwItemAttribute(this.i, 'PropertyType');
        this.ThemePropertyTypeId = new DwItemAttribute(this.i, 'ThemePropertyTypeId');
    }
}
class DwThemePropertyTypeMetaDataRelations {
    constructor() {
        /** Relation: Theme Property Definition */
        this.DwThemePropertyDefinition = new DwItemRelationship('dw_ThemePropertyType|dw_ThemePropertyDefinition|ThemePropertyTypeId', 'DwThemePropertyDefinition', 'DwThemePropertyDefinition');
    }
}
;
class ThemesMetaData {
}
ThemesMetaData.DwMedia = new DwMediaMetaData();
ThemesMetaData.DwRoMedia = new DwRoMediaMetaData();
ThemesMetaData.DwTheme = new DwThemeMetaData();
ThemesMetaData.DwThemeProperty = new DwThemePropertyMetaData();
ThemesMetaData.DwThemePropertyDefinition = new DwThemePropertyDefinitionMetaData();
ThemesMetaData.DwThemePropertyType = new DwThemePropertyTypeMetaData();
// Lookup Value Enums  {
var ThemePropertyTypeAllItems;
(function (ThemePropertyTypeAllItems) {
    ThemePropertyTypeAllItems[ThemePropertyTypeAllItems["Color"] = 1] = "Color";
    ThemePropertyTypeAllItems[ThemePropertyTypeAllItems["Text"] = 2] = "Text";
    ThemePropertyTypeAllItems[ThemePropertyTypeAllItems["Length"] = 3] = "Length";
})(ThemePropertyTypeAllItems || (ThemePropertyTypeAllItems = {}));

class DwCacheInvalidationTopic {
}

class DwConfigItem {
    constructor(name, config) {
        this.name = name;
        this.config = config;
    }
}

;

class DwProviderItem {
}

class DwDataSort {
    constructor() {
        this.ascending = true;
    }
}

// import * as StackTrace from 'stacktrace-js';
class DwGlobalErrorHandler {
    constructor(injector) {
        this.injector = injector;
    }
    handleError(error) {
        const loggingService = this.injector.get(DwLoggingService);
        const message = error.message ? error.message : error.toString();
        // Prevent duplicate messages from being logged
        if (DwGlobalErrorHandler.loggedErrors.includes(message)) {
            return;
        }
        DwGlobalErrorHandler.loggedErrors.push(message);
        loggingService.logError(message, error);
        // Rethrowing the erorr caused major issues
        //throw error;
    }
}
DwGlobalErrorHandler.ɵfac = function DwGlobalErrorHandler_Factory(t) { return new (t || DwGlobalErrorHandler)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwGlobalErrorHandler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwGlobalErrorHandler, factory: DwGlobalErrorHandler.ɵfac });
DwGlobalErrorHandler.loggedErrors = [];
DwGlobalErrorHandler.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwGlobalErrorHandler, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class DwErrorDetails {
}

class DwNavigationItem {
}

;

class DwDateTimeTransletorService {
}
DwDateTimeTransletorService.ɵfac = function DwDateTimeTransletorService_Factory(t) { return new (t || DwDateTimeTransletorService)(); };
DwDateTimeTransletorService.ɵprov = ɵɵdefineInjectable({ factory: function DwDateTimeTransletorService_Factory() { return new DwDateTimeTransletorService(); }, token: DwDateTimeTransletorService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwDateTimeTransletorService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class DwRouteGuardUtil {
    static secureRoutes(routes, canActivateGuard, canDeactivateGuard) {
        for (const route of routes) {
            if (!route.canActivate || route.canActivate.length === 0) {
                if (canActivateGuard) {
                    route.canActivate = [canActivateGuard];
                }
                if (canDeactivateGuard) {
                    route.canDeactivate = [canDeactivateGuard];
                }
                if (route.children) {
                    this.secureRoutes(route.children, canActivateGuard, canDeactivateGuard);
                }
            }
        }
    }
}

class DwStorageItem {
    constructor() {
        this.expirationDateTime = null;
    }
}

;

class DwThemeRespositoryService {
    // apiRoot: string;
    constructor(dwOrmDataService, dwCacheService, http, injector
    //@Inject(DwConfigServiceToken) private configService: DwConfigService,
    ) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwCacheService = dwCacheService;
        this.http = http;
        this.injector = injector;
        //   this.apiRoot = configService.coreConfig.apiRoot;
    }
    get apiRoot() {
        const configService = this.injector.get(DwConfigServiceToken);
        return configService.coreConfig.apiRoot;
    }
    getThemeResult(themeId) {
        const url = `${this.apiRoot}/themes?themeId=${themeId}`;
        return this.http.get(url);
    }
    saveThemes(defaultThemes) {
        return this.dwOrmDataService.saveEntityCollection(defaultThemes);
    }
    getDefaultThemes(defaultThemeId) {
        const query = ThemesMetaData.DwTheme.CreateQueryBuilder();
        if (defaultThemeId) {
            query.addFilterAnd(f => f.Equal(a => a.ThemeId, defaultThemeId));
        }
        else {
            query.addFilterAnd(f => f.Equal(a => a.IsDefault, true));
        }
        query.addPrefetch(r => r.DwThemeProperty);
        return this.dwOrmDataService.executeQuery(query);
    }
    // Old methods before custom api for theme with caching
    getThemePropertyDefinitions() {
        return this.dwCacheService.get('themePropertyDefinitions', this.loadThemePropertyDefinitions());
    }
    getTheme(themeId) {
        const query = ThemesMetaData.DwTheme.CreateQueryBuilder();
        query.addFilterAnd(f => f.Equal(a => a.ThemeId, themeId));
        query.addPrefetch(r => r.DwThemeProperty);
        //query.addPrefetch(r => r.)
        return this.dwOrmDataService.executeQuerySingle(query);
    }
    loadThemePropertyDefinitions() {
        const query = ThemesMetaData.DwThemePropertyDefinition.CreateQueryBuilder();
        query.addPrefetch(r => r.DwThemePropertyType);
        return this.dwOrmDataService.executeQuery(query);
    }
}
DwThemeRespositoryService.ɵfac = function DwThemeRespositoryService_Factory(t) { return new (t || DwThemeRespositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwThemeRespositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwThemeRespositoryService_Factory() { return new DwThemeRespositoryService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwCacheService), ɵɵinject(HttpClient), ɵɵinject(INJECTOR)); }, token: DwThemeRespositoryService, providedIn: "root" });
DwThemeRespositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwCacheService },
    { type: HttpClient },
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwThemeRespositoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwCacheService }, { type: ɵngcc1.HttpClient }, { type: ɵngcc0.Injector }]; }, null); })();

class DwThemeManagerService {
    constructor(dwMediaRepositoryService, dwCacheService, injector) {
        this.dwMediaRepositoryService = dwMediaRepositoryService;
        this.dwCacheService = dwCacheService;
        this.injector = injector;
    }
    get dwThemeRespositoryService() {
        return this.injector.get(DwThemeRespositoryService);
    }
    applyTheme(themeId) {
        return this.dwThemeRespositoryService.getThemeResult(themeId)
            .pipe(tap(themeResult => {
            return this.applyThemeInternal(themeResult);
        }));
    }
    applyThemeInternal(themeResult) {
        var _a, _b;
        if (!themeResult) {
            return of(null);
        }
        const rootStyle = document.querySelector(':root');
        for (let prop of themeResult.ThemePropertyResults) {
            if (prop.PropertyValue) {
                (_a = rootStyle.style) === null || _a === void 0 ? void 0 : _a.setProperty(prop.PropertyName, prop.PropertyValue);
            }
            else {
                (_b = rootStyle.style) === null || _b === void 0 ? void 0 : _b.setProperty(prop.PropertyName, null);
            }
        }
        this.addLogoStyles('dw-logo', themeResult.Logo, rootStyle);
        this.addLogoStyles('dw-logo-alt1', themeResult.AlternateLogo, rootStyle);
        this.addLogoStyles('dw-logo-login', themeResult.LoginLogo, rootStyle);
    }
    // public applyDefaultThemeOld(defaultThemeId?: number): Observable<any> {
    //     return this.dwThemeRespositoryService.getDefaultThemes(defaultThemeId)
    //         .pipe(mergeMap(themes => {
    //             return this.applyTheme(themes[0]);
    //         }));
    // }
    applyThemeRaw(theme) {
        if (!theme) {
            //    theme = ThemesMetaData.DwTheme.CreateEntity();
            //    theme.DwThemeProperty = [];
            return of(null);
        }
        if (!theme.DwThemeProperty) {
            return this.dwThemeRespositoryService.getTheme(theme.ThemeId)
                .pipe(mergeMap(t => {
                return this.applyThemeProperties(t);
            }));
        }
        return this.applyThemeProperties(theme);
    }
    setDefaultTheme(theme) {
        return this.dwThemeRespositoryService.getDefaultThemes()
            .pipe(mergeMap(defaultThemes => {
            defaultThemes.filter(t => t.ThemeId != (theme === null || theme === void 0 ? void 0 : theme.ThemeId)).forEach(t => t.IsDefault = false);
            theme.IsDefault = true;
            defaultThemes.push(theme);
            return this.dwThemeRespositoryService.saveThemes(defaultThemes);
        }));
    }
    applyThemeProperties(theme) {
        const mediaIds = [];
        if (theme.LogoMediaId) {
            mediaIds.push(theme.LogoMediaId);
        }
        if (theme.AlternateLogoMediaId) {
            mediaIds.push(theme.AlternateLogoMediaId);
        }
        if (theme.LogoLoginMediaId) {
            mediaIds.push(theme.LogoLoginMediaId);
        }
        const obs = [];
        obs.push(this.dwThemeRespositoryService.getThemePropertyDefinitions());
        let mediaOb = of(null);
        if (mediaIds.length > 0) {
            mediaOb = this.getMediaCached(mediaIds); //this.dwMediaRepositoryService.loadMedia(mediaIds);
        }
        obs.push(mediaOb);
        return combineLatest(obs)
            .pipe(map(([propDefinitions, media]) => {
            this.applyThemePropertiesInternal(theme, propDefinitions, media);
        }));
    }
    getMediaCached(mediaIds) {
        const key = `media-${mediaIds.join('-')}`;
        return this.dwCacheService.get(key, this.dwMediaRepositoryService.loadMedia(mediaIds));
    }
    applyThemePropertiesInternal(theme, propDefinitions, media) {
        var _a, _b;
        const rootStyle = document.querySelector(':root');
        for (let prop of propDefinitions) {
            const propDef = propDefinitions.find(pd => pd.ThemePropertyDefinitionId === prop.ThemePropertyDefinitionId);
            if (propDef) {
                (_a = rootStyle.style) === null || _a === void 0 ? void 0 : _a.setProperty(propDef.PropertyName, null);
            }
        }
        for (let prop of theme.DwThemeProperty) {
            const propDef = propDefinitions.find(pd => pd.ThemePropertyDefinitionId === prop.ThemePropertyDefinitionId);
            if (propDef && prop.PropertyValue) {
                (_b = rootStyle.style) === null || _b === void 0 ? void 0 : _b.setProperty(propDef.PropertyName, prop.PropertyValue);
            }
        }
        this.addLogoStylesOld('dw-logo', theme.LogoMediaId, theme.LogoWidth, theme.LogoHeight, media, rootStyle);
        this.addLogoStylesOld('dw-logo-alt1', theme.AlternateLogoMediaId, theme.AlternateLogoWidth, theme.AlternateLogoHeight, media, rootStyle);
        this.addLogoStylesOld('dw-logo-login', theme.LogoLoginMediaId, theme.LogoLoginWidth, theme.LogoLoginHeight, media, rootStyle);
    }
    addLogoStyles(classPrefix, mediaResult, rootStyle) {
        var _a, _b, _c;
        if (!mediaResult || !mediaResult.MediaPath) {
            return;
        }
        const mediaUrl = this.dwMediaRepositoryService.getImageUrlFromMediaPath(mediaResult.MediaPath, mediaResult.Width, mediaResult.Height);
        (_a = rootStyle.style) === null || _a === void 0 ? void 0 : _a.setProperty(`--${classPrefix}-url`, `url(${mediaUrl})`);
        if (mediaResult.Width) {
            (_b = rootStyle.style) === null || _b === void 0 ? void 0 : _b.setProperty(`--${classPrefix}-width`, `${mediaResult.Width}px`);
        }
        if (mediaResult.Height) {
            (_c = rootStyle.style) === null || _c === void 0 ? void 0 : _c.setProperty(`--${classPrefix}-height`, `${mediaResult.Height}px`);
        }
    }
    addLogoStylesOld(classPrefix, logoMediaId, logoWidth, logoHeight, media, rootStyle) {
        var _a, _b, _c;
        if (!logoMediaId) {
            return;
        }
        const logoMedia = media.find(m => m.MediaId === logoMediaId);
        if (logoMedia) {
            const mediaUrl = this.dwMediaRepositoryService.getImageUrl(logoMedia.ContainerName, logoMedia.FileName, logoMedia.MediaDetailKey, false);
            (_a = rootStyle.style) === null || _a === void 0 ? void 0 : _a.setProperty(`--${classPrefix}-url`, `url(${mediaUrl})`);
        }
        if (logoWidth) {
            (_b = rootStyle.style) === null || _b === void 0 ? void 0 : _b.setProperty(`--${classPrefix}-width`, `${logoWidth}px`);
        }
        if (logoHeight) {
            (_c = rootStyle.style) === null || _c === void 0 ? void 0 : _c.setProperty(`--${classPrefix}-height`, `${logoHeight}px`);
        }
    }
    clearTheme() {
        return this.dwThemeRespositoryService.getThemePropertyDefinitions()
            .pipe(map(propDefinitions => {
            var _a;
            const rootStyle = document.querySelector(':root');
            for (let prop of propDefinitions) {
                const propDef = propDefinitions.find(pd => pd.ThemePropertyDefinitionId === prop.ThemePropertyDefinitionId);
                if (propDef) {
                    (_a = rootStyle.style) === null || _a === void 0 ? void 0 : _a.setProperty(propDef.PropertyName, null);
                }
            }
        }));
    }
}
DwThemeManagerService.ɵfac = function DwThemeManagerService_Factory(t) { return new (t || DwThemeManagerService)(ɵngcc0.ɵɵinject(DwMediaRepositoryService), ɵngcc0.ɵɵinject(DwCacheService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwThemeManagerService.ɵprov = ɵɵdefineInjectable({ factory: function DwThemeManagerService_Factory() { return new DwThemeManagerService(ɵɵinject(DwMediaRepositoryService), ɵɵinject(DwCacheService), ɵɵinject(INJECTOR)); }, token: DwThemeManagerService, providedIn: "root" });
DwThemeManagerService.ctorParameters = () => [
    { type: DwMediaRepositoryService },
    { type: DwCacheService },
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwThemeManagerService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMediaRepositoryService }, { type: DwCacheService }, { type: ɵngcc0.Injector }]; }, null); })();

class DwApplyThemeActionService {
    constructor(dwThemeManagerService) {
        this.dwThemeManagerService = dwThemeManagerService;
    }
    handleAction(actionState) {
        let theme = actionState.data;
        if (!theme && actionState.formApi) {
            theme = actionState.formApi.getFormData();
        }
        return this.dwThemeManagerService.applyThemeRaw(theme)
            .pipe(map(() => {
            return { success: true };
        }));
    }
}
DwApplyThemeActionService.ɵfac = function DwApplyThemeActionService_Factory(t) { return new (t || DwApplyThemeActionService)(ɵngcc0.ɵɵinject(DwThemeManagerService)); };
DwApplyThemeActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwApplyThemeActionService, factory: DwApplyThemeActionService.ɵfac });
DwApplyThemeActionService.ctorParameters = () => [
    { type: DwThemeManagerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwApplyThemeActionService, [{
        type: Injectable
    }], function () { return [{ type: DwThemeManagerService }]; }, null); })();
DwActionFunc({
    keyName: 'apply-theme',
    display: 'Apply Theme',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: ThemesMetaDataItemNames.DwTheme,
    allowOnce: true,
    order: 4,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-palette',
    },
    defaultSecurityConfig: {},
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
    }
}, DwApplyThemeActionService);
DwActionFunc({
    keyName: 'apply-theme-grid',
    display: 'Apply Theme - Grid',
    actionType: DwActionType.gridRowAction,
    isGlobal: false,
    parentItemName: ThemesMetaDataItemNames.DwTheme,
    allowOnce: true,
    order: 4,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.iconOnlyNoText,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-palette  dw-icon-grid dw-orange',
    },
    defaultSecurityConfig: {},
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
    }
}, DwApplyThemeActionService);

class ThemePropertyEditControlComponent {
    constructor(dwThemeRespositoryService) {
        this.dwThemeRespositoryService = dwThemeRespositoryService;
        this.inputClass = "form-control";
        this.propertyTypeId = ThemePropertyTypeAllItems.Text;
        this.PropertyTypes = ThemePropertyTypeAllItems;
    }
    ngOnInit() {
        this.dwThemeRespositoryService.getThemePropertyDefinitions().subscribe((propertyDefs) => {
            this.propertyDefs = propertyDefs;
            this.setupEditor();
        });
        this.propertyDefIdFC = this.formGroup.get(ThemesMetaData.DwThemeProperty.Attributes.ThemePropertyDefinitionId.fieldName);
        this.propertyDefIdFC.valueChanges.subscribe((value) => {
            this.setupEditor();
        });
    }
    setupEditor() {
        if (!this.propertyDefs) {
            return;
        }
        const themeProperty = this.formGroup.getRawValue();
        if (!themeProperty.ThemePropertyDefinitionId) {
            return;
        }
        const propDef = this.propertyDefs.find(pd => pd.ThemePropertyDefinitionId === themeProperty.ThemePropertyDefinitionId);
        if (propDef) {
            this.propertyTypeId = propDef.ThemePropertyTypeId;
        }
    }
}
ThemePropertyEditControlComponent.ɵfac = function ThemePropertyEditControlComponent_Factory(t) { return new (t || ThemePropertyEditControlComponent)(ɵngcc0.ɵɵdirectiveInject(DwThemeRespositoryService)); };
ThemePropertyEditControlComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ThemePropertyEditControlComponent, selectors: [["dw-theme-property-edit-control"]], inputs: { context: "context" }, decls: 5, vars: 4, consts: [[3, "formGroup"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngSwitchDefault"], [3, "formControlName"], ["inputClass", "form-control", 3, "formControlName"]], template: function ThemePropertyEditControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ng-continner", 1);
        ɵngcc0.ɵɵtemplate(2, ThemePropertyEditControlComponent_div_2_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ThemePropertyEditControlComponent_div_3_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(4, ThemePropertyEditControlComponent_div_4_Template, 2, 1, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.propertyTypeId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.PropertyTypes.Color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.PropertyTypes.Text);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc4.NgSwitch, ɵngcc4.NgSwitchCase, ɵngcc4.NgSwitchDefault, DwColorPickerComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, DwInputComponent], encapsulation: 2 });
ThemePropertyEditControlComponent.ctorParameters = () => [
    { type: DwThemeRespositoryService }
];
ThemePropertyEditControlComponent.propDecorators = {
    context: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ThemePropertyEditControlComponent, [{
        type: Component,
        args: [{
                selector: 'dw-theme-property-edit-control',
                template: `
  <div [formGroup]="formGroup">
    
    <ng-continner [ngSwitch]="propertyTypeId">
        <div *ngSwitchCase="PropertyTypes.Color">
            <dw-color-picker  [formControlName]="fieldDef?.attrName"></dw-color-picker>
        </div>
        <div *ngSwitchCase="PropertyTypes.Text">
            <dw-input [formControlName]="fieldDef?.attrName" inputClass="form-control"></dw-input>
        </div>
        <div *ngSwitchDefault>
            <dw-input [formControlName]="fieldDef?.attrName" inputClass="form-control"></dw-input>
        </div> 
    </ng-continner>
    
  </div>
`
            }]
    }], function () { return [{ type: DwThemeRespositoryService }]; }, { context: [{
            type: Input
        }] }); })();
DwComponentFunc({
    key: 'dw-theme-property-edit-control',
    name: 'Property Editor',
    componentType: DwComponentType.formControl,
    isGlobal: true,
}, ThemePropertyEditControlComponent);

class DwClearThemeActionService {
    constructor(dwThemeManagerService) {
        this.dwThemeManagerService = dwThemeManagerService;
    }
    handleAction(actionState) {
        return this.dwThemeManagerService.clearTheme()
            .pipe(map(() => {
            return { success: true };
        }));
    }
}
DwClearThemeActionService.ɵfac = function DwClearThemeActionService_Factory(t) { return new (t || DwClearThemeActionService)(ɵngcc0.ɵɵinject(DwThemeManagerService)); };
DwClearThemeActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwClearThemeActionService, factory: DwClearThemeActionService.ɵfac });
DwClearThemeActionService.ctorParameters = () => [
    { type: DwThemeManagerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwClearThemeActionService, [{
        type: Injectable
    }], function () { return [{ type: DwThemeManagerService }]; }, null); })();
DwActionFunc({
    keyName: 'clear-theme',
    display: 'Clear Theme',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: ThemesMetaDataItemNames.DwTheme,
    allowOnce: true,
    order: 4,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-palette',
    },
    defaultSecurityConfig: {},
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
    }
}, DwClearThemeActionService);
DwActionFunc({
    keyName: 'clear-theme-grid',
    display: 'Clear Theme',
    actionType: DwActionType.gridAction,
    isGlobal: false,
    parentItemName: ThemesMetaDataItemNames.DwTheme,
    allowOnce: true,
    order: 4,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-palette dw-blue',
    },
    defaultSecurityConfig: {},
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
    }
}, DwClearThemeActionService);

class DwSetDefaultThemeActionService {
    constructor(dwThemeManagerService) {
        this.dwThemeManagerService = dwThemeManagerService;
    }
    handleAction(actionState) {
        let theme = actionState.data;
        if (!theme && actionState.formApi) {
            theme = actionState.formApi.getFormData();
        }
        return this.dwThemeManagerService.setDefaultTheme(theme)
            .pipe(mergeMap(() => {
            return this.dwThemeManagerService.applyTheme(theme.ThemeId)
                .pipe(map(() => {
                return { success: true };
            }));
        }));
    }
}
DwSetDefaultThemeActionService.ɵfac = function DwSetDefaultThemeActionService_Factory(t) { return new (t || DwSetDefaultThemeActionService)(ɵngcc0.ɵɵinject(DwThemeManagerService)); };
DwSetDefaultThemeActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwSetDefaultThemeActionService, factory: DwSetDefaultThemeActionService.ɵfac });
DwSetDefaultThemeActionService.ctorParameters = () => [
    { type: DwThemeManagerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSetDefaultThemeActionService, [{
        type: Injectable
    }], function () { return [{ type: DwThemeManagerService }]; }, null); })();
DwActionFunc({
    keyName: 'set-default-theme',
    display: 'Set Default Theme',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: ThemesMetaDataItemNames.DwTheme,
    allowOnce: true,
    order: 4,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-palette',
    },
    defaultSecurityConfig: {},
    defaultConfirmConfig: {
        showDialogConfig: false,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
    }
}, DwSetDefaultThemeActionService);
DwActionFunc({
    keyName: 'set-default-theme-grid',
    display: 'Set Default Theme Grid',
    actionType: DwActionType.gridRowAction,
    isGlobal: false,
    parentItemName: ThemesMetaDataItemNames.DwTheme,
    allowOnce: true,
    order: 4,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        iconClass: 'fa fa-palette dw-red',
    },
    defaultSecurityConfig: {},
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
    }
}, DwSetDefaultThemeActionService);

class DwThemeAppInitHandlerService {
    constructor(injector) {
        this.injector = injector;
    }
    handleAppInit(appInitResult, dwCoreConfig) {
        const themesConfig = appInitResult.ThemesConfig;
        const dwThemeManagerService = this.injector.get(DwThemeManagerService);
        const uiConfig = this.injector.get(DwUIConfigToken);
        if (!(uiConfig === null || uiConfig === void 0 ? void 0 : uiConfig.enableThemes)) {
            return;
        }
        return dwThemeManagerService.applyThemeInternal(themesConfig === null || themesConfig === void 0 ? void 0 : themesConfig.CurrentTheme);
    }
}
DwThemeAppInitHandlerService.ɵfac = function DwThemeAppInitHandlerService_Factory(t) { return new (t || DwThemeAppInitHandlerService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
DwThemeAppInitHandlerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwThemeAppInitHandlerService, factory: DwThemeAppInitHandlerService.ɵfac });
DwThemeAppInitHandlerService.ctorParameters = () => [
    { type: Injector }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwThemeAppInitHandlerService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();

class DwAdminConfigDefaults {
    constructor() {
        this.schedulerConfig = {
            allowServiceControl: false,
            serviceCheckInterval: 60000,
            scheduleCheckInterval: 5000
        };
    }
}

class DwSecurityAdminRepositoryService {
    constructor(dwOrmDataService) {
        this.dwOrmDataService = dwOrmDataService;
    }
    getUser(userId) {
        const md = new DevwareMetaDataService();
        const qh = new DwQueryHelper();
        const query = md.DwUser.CreateQuery();
        query.SetFieldSettings(false, true);
        query.AddFilterAnd(qh.filters.Equal(md.DwUser.UserId, userId));
        return this.dwOrmDataService.executeQuerySingle(query);
    }
}
DwSecurityAdminRepositoryService.ɵfac = function DwSecurityAdminRepositoryService_Factory(t) { return new (t || DwSecurityAdminRepositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken)); };
DwSecurityAdminRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwSecurityAdminRepositoryService_Factory() { return new DwSecurityAdminRepositoryService(ɵɵinject(DwOrmDataServiceToken)); }, token: DwSecurityAdminRepositoryService, providedIn: "root" });
DwSecurityAdminRepositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSecurityAdminRepositoryService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }]; }, null); })();

class DwEmulateUserActionService {
    constructor(securityEmulationService, dwSecurityAdminRepositoryService) {
        this.securityEmulationService = securityEmulationService;
        this.dwSecurityAdminRepositoryService = dwSecurityAdminRepositoryService;
    }
    handleAction(actionState) {
        const result = {
            success: false,
        };
        const user = actionState.data;
        if (!(user === null || user === void 0 ? void 0 : user.UserId)) {
            result.message = 'User was not passed in';
            return of(result);
        }
        return this.dwSecurityAdminRepositoryService.getUser(user.UserId)
            .pipe(mergeMap(user => {
            if (!user) {
                result.message = 'User not found';
                return of(result);
            }
            return this.securityEmulationService.emulateUser(user.UserName, `${user.FirstName} ${user.LastName}`)
                .pipe(map((securityResult) => {
                result.success = securityResult.success;
                result.message = securityResult.message;
                return result;
            }));
        }));
    }
}
DwEmulateUserActionService.ɵfac = function DwEmulateUserActionService_Factory(t) { return new (t || DwEmulateUserActionService)(ɵngcc0.ɵɵinject(DwSecurityEmulationService), ɵngcc0.ɵɵinject(DwSecurityAdminRepositoryService)); };
DwEmulateUserActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwEmulateUserActionService, factory: DwEmulateUserActionService.ɵfac });
DwEmulateUserActionService.ctorParameters = () => [
    { type: DwSecurityEmulationService },
    { type: DwSecurityAdminRepositoryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEmulateUserActionService, [{
        type: Injectable
    }], function () { return [{ type: DwSecurityEmulationService }, { type: DwSecurityAdminRepositoryService }]; }, null); })();
DwActionFunc({
    keyName: 'dw-emulate-user-grid-action',
    display: 'Emulate User',
    actionType: DwActionType.gridRowAction,
    isGlobal: true,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: false,
        permissionMeaning: DwSecurityPermissions.SecurityCanEmulate
    }
}, DwEmulateUserActionService);

class StartProcessConfigComponent extends DwActionConfigBaseComponent {
    constructor() {
        super();
        this.processScheudleLookupId = DevwareMetaDataLookups.ProcessScheduleAllItems;
    }
    addControls() {
        this.addControl('processScheduleId');
    }
}
StartProcessConfigComponent.ɵfac = function StartProcessConfigComponent_Factory(t) { return new (t || StartProcessConfigComponent)(); };
StartProcessConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StartProcessConfigComponent, selectors: [["dw-start-process-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], ["dwRow", ""], ["dwCol", "12"], ["formControlName", "processScheduleId", "showBlankOption", "false", "blankOptionText", "Select Process Schduler", 3, "lookupId"]], template: function StartProcessConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, StartProcessConfigComponent_div_0_Template, 7, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.actionConfigFG);
    } }, directives: [ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwRowDirective, DwColDirective, DwSearchSelectLookupComponent, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName], encapsulation: 2 });
StartProcessConfigComponent.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StartProcessConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-start-process-config',
                template: `
     <div *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
        <div dwRow>
            <div dwCol="12"> 
                <label>Process Schedule</label>
            </div>
            <div dwCol="12">
                <dw-search-select-lookup formControlName="processScheduleId" [lookupId]="processScheudleLookupId"
                showBlankOption="false" blankOptionText="Select Process Schduler" ></dw-search-select-lookup>
            </div> 
        </div>
    </div>
  
  `
            }]
    }], function () { return []; }, null); })();

class DwStartProcessMenuActionService {
    constructor(schedulerService) {
        this.schedulerService = schedulerService;
    }
    handleAction(gridActionState) {
        var _a;
        const actionResult = {
            success: false
        };
        const processScheduleId = (_a = gridActionState.actionConfig) === null || _a === void 0 ? void 0 : _a.processScheduleId;
        if (!processScheduleId) {
            actionResult.message = 'Process Schedule Id is required!';
            return of(actionResult);
        }
        return this.schedulerService.startProcess(processScheduleId)
            .pipe(map(processResult => {
            const actionResult = {
                success: processResult.Success
            };
            if (processResult.Success) {
                actionResult.refreshData = true;
                actionResult.message = `Process has been queued to start`;
            }
            else {
                actionResult.message = processResult.Message;
            }
            return actionResult;
        }));
    }
}
DwStartProcessMenuActionService.ɵfac = function DwStartProcessMenuActionService_Factory(t) { return new (t || DwStartProcessMenuActionService)(ɵngcc0.ɵɵinject(DwSchedulerService)); };
DwStartProcessMenuActionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwStartProcessMenuActionService, factory: DwStartProcessMenuActionService.ɵfac });
DwStartProcessMenuActionService.ctorParameters = () => [
    { type: DwSchedulerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwStartProcessMenuActionService, [{
        type: Injectable
    }], function () { return [{ type: DwSchedulerService }]; }, null); })();
DwActionFunc({
    keyName: 'startProcessGlobal',
    display: 'Start Process (Menu)',
    actionType: DwActionType.menuAction,
    isGlobal: true,
    configComponent: StartProcessConfigComponent,
    defaultMenuConfig: {
        useParentDisplay: true,
    },
    defaultButtonConfig: {
        useParentDisplay: true,
        iconClass: 'fa fa-bolt dw-green',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Start Process'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        permissionMeaning: DwSecurityPermissions.AdminSecurityCanAdminAdvanced
    }
}, DwStartProcessMenuActionService);

class DevwareAdminModule {
    static forRoot() {
        return {
            ngModule: DevwareAdminModule,
            providers: []
        };
    }
}
DevwareAdminModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareAdminModule });
DevwareAdminModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareAdminModule_Factory(t) { return new (t || DevwareAdminModule)(); }, providers: [
        DwGeneratePatActionService,
        DwRefreshMetadataActionService,
        DwViewItemListActionService,
        DwRefreshMetadataMenuActionService,
        DwGridViewBreadcrumbProcessor,
        UserProfileBreadcrumbProcessor,
        DwItemParentContextService,
        DwUserSetPasswordActionService,
        DwUserUpdateEventHandler,
        DwSchedulerService,
        DwStartProcessActionService,
        DwClearCacheActionService,
        DwSecurityItemQuickAddActionService,
        DwViewHistoryActionService,
        DwFalinkDetailsActionService,
        DwFaRemoveDetailsActionService,
        DwFeatureAreaStateService,
        DwFaPublishActionService,
        DwApplyThemeActionService,
        DwClearThemeActionService,
        DwSetDefaultThemeActionService,
        DwEmulateUserActionService,
        DwStartProcessMenuActionService,
        {
            provide: DwAppInitHandlerToken,
            useClass: DwThemeAppInitHandlerService,
            multi: true
        },
        {
            provide: DwAdminConfigToken,
            useFactory(configService) {
                const uiConfig = configService.getConfig(DwAdminConfigName, new DwAdminConfigDefaults());
                return uiConfig;
            },
            deps: [DwConfigServiceToken]
        },
    ], imports: [[
            DevareAdminRoutingModule,
            CommonModule,
            HttpClientModule,
            FormsModule,
            ReactiveFormsModule,
            TabViewModule,
            ListboxModule,
            TreeModule,
            AccordionModule,
            InputSwitchModule,
            DropdownModule,
            MenuModule,
            ContextMenuModule,
            DragDropModule$1,
            DevwareCoreModule,
            DevwareUIModule,
            DevwareUILayoutModule,
            DevwareOrmModule,
            DevwareUIMetaDataModule,
            DevwareMediaModule,
            RouterModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareAdminModule, { declarations: function () { return [CacheAdminComponent, UserProfileComponent, EmailSenderComponent, DwImportMetaDataModalComponent, DwMetaDataLookupTransitionSectionComponent, DwRouteConfigEditComponent, DwRoutingAdminTreeComponent, DwRouteEditComponent, DwRouteAddComponent, DwRouteEditChildComponent, DwUserSetPasswordComponent, DwMetaDataLookupTesterComponent, DevwareGetStartedComponent, DwProcessScheduleConfigComponent, DwProcessSchedulerStatusComponent, DwProductVersionAdminComponent, DwSecurityItemQuickAddComponent, AdminMeaningDefaultComponent, DwRouteEditSecurityComponent, CurrentSecurityInfoComponent, DwMetaDataHistoryDetailComponent, DwMetaDataHistoryListComponent, DwMetaDataHistoryAttrChangesComponent, DwMetaDataHistoryCardComponent, DwMetaDataHistoryModalComponent, DwMetaDataHistoryMainComponent, DwMetaDataHistorySummaryCardComponent, DwItemTemplateControlComponent, DwMetaDataHistorySummaryCardComponent, DwFeatureAreaDetailsComponent, DwFeatureAreaDetailGroupSelectorComponent, DwFeatureAreaGridComponent, DwFaAddDetailModalComponent, DwFaDetailViewComponent, DwMetaDataItemControlComponent, DwItemTemplateControlComponent, DwFaPublishModalComponent, DwExportCompareResultViewerComponent, UserProfileConfigComponent, ThemePropertyEditControlComponent, StartProcessConfigComponent]; }, imports: function () { return [DevareAdminRoutingModule, CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        TabViewModule,
        ListboxModule,
        TreeModule,
        AccordionModule,
        InputSwitchModule,
        DropdownModule,
        MenuModule,
        ContextMenuModule,
        DragDropModule$1, DevwareCoreModule, DevwareUIModule, DevwareUILayoutModule, DevwareOrmModule, DevwareUIMetaDataModule, DevwareMediaModule, RouterModule]; }, exports: function () { return [UserProfileComponent, DwItemTemplateControlComponent, ThemePropertyEditControlComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareAdminModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CacheAdminComponent,
                    UserProfileComponent,
                    EmailSenderComponent,
                    DwImportMetaDataModalComponent,
                    DwMetaDataLookupTransitionSectionComponent,
                    DwRouteConfigEditComponent,
                    DwRoutingAdminTreeComponent,
                    DwRouteEditComponent,
                    DwRouteAddComponent,
                    DwRouteEditChildComponent,
                    DwUserSetPasswordComponent,
                    DwMetaDataLookupTesterComponent,
                    DevwareGetStartedComponent,
                    DwProcessScheduleConfigComponent,
                    DwProcessSchedulerStatusComponent,
                    DwProductVersionAdminComponent,
                    DwSecurityItemQuickAddComponent,
                    AdminMeaningDefaultComponent,
                    DwRouteEditSecurityComponent,
                    CurrentSecurityInfoComponent,
                    DwMetaDataHistoryDetailComponent,
                    DwMetaDataHistoryListComponent,
                    DwMetaDataHistoryAttrChangesComponent,
                    DwMetaDataHistoryCardComponent,
                    DwMetaDataHistoryModalComponent,
                    DwMetaDataHistoryMainComponent,
                    DwMetaDataHistorySummaryCardComponent,
                    DwItemTemplateControlComponent,
                    DwMetaDataHistorySummaryCardComponent,
                    DwFeatureAreaDetailsComponent,
                    DwFeatureAreaDetailGroupSelectorComponent,
                    DwFeatureAreaGridComponent,
                    DwFaAddDetailModalComponent,
                    DwFaDetailViewComponent,
                    DwMetaDataItemControlComponent,
                    DwItemTemplateControlComponent,
                    DwFaPublishModalComponent,
                    DwExportCompareResultViewerComponent,
                    UserProfileConfigComponent,
                    ThemePropertyEditControlComponent,
                    StartProcessConfigComponent
                ],
                providers: [
                    DwGeneratePatActionService,
                    DwRefreshMetadataActionService,
                    DwViewItemListActionService,
                    DwRefreshMetadataMenuActionService,
                    DwGridViewBreadcrumbProcessor,
                    UserProfileBreadcrumbProcessor,
                    DwItemParentContextService,
                    DwUserSetPasswordActionService,
                    DwUserUpdateEventHandler,
                    DwSchedulerService,
                    DwStartProcessActionService,
                    DwClearCacheActionService,
                    DwSecurityItemQuickAddActionService,
                    DwViewHistoryActionService,
                    DwFalinkDetailsActionService,
                    DwFaRemoveDetailsActionService,
                    DwFeatureAreaStateService,
                    DwFaPublishActionService,
                    DwApplyThemeActionService,
                    DwClearThemeActionService,
                    DwSetDefaultThemeActionService,
                    DwEmulateUserActionService,
                    DwStartProcessMenuActionService,
                    {
                        provide: DwAppInitHandlerToken,
                        useClass: DwThemeAppInitHandlerService,
                        multi: true
                    },
                    {
                        provide: DwAdminConfigToken,
                        useFactory(configService) {
                            const uiConfig = configService.getConfig(DwAdminConfigName, new DwAdminConfigDefaults());
                            return uiConfig;
                        },
                        deps: [DwConfigServiceToken]
                    },
                ],
                imports: [
                    DevareAdminRoutingModule,
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TabViewModule,
                    ListboxModule,
                    TreeModule,
                    AccordionModule,
                    InputSwitchModule,
                    DropdownModule,
                    MenuModule,
                    ContextMenuModule,
                    DragDropModule$1,
                    DevwareCoreModule,
                    DevwareUIModule,
                    DevwareUILayoutModule,
                    DevwareOrmModule,
                    DevwareUIMetaDataModule,
                    DevwareMediaModule,
                    RouterModule,
                ],
                exports: [
                    UserProfileComponent,
                    DwItemTemplateControlComponent,
                    ThemePropertyEditControlComponent
                ]
            }]
    }], null, null); })();

var DayOfMonthOrderEnum;
(function (DayOfMonthOrderEnum) {
    DayOfMonthOrderEnum["BeggingingOfMonth"] = "BeginningOfMonth";
    DayOfMonthOrderEnum["EndOfMonth"] = "EndOfMonth";
})(DayOfMonthOrderEnum || (DayOfMonthOrderEnum = {}));

//export * from './devware-admin/devware-admin-app-start.function';
;

class DwLookupInfo {
}

class DwMdComparerMap {
}

class DwOrmDataHierarchy {
    constructor() {
        this.children = [];
    }
}

class DwAppPermissionMetaData2 {
    constructor() {
        this.ItemDetail = new DwItemDetail();
        //shortcut to item name - to reduce file size
        this.i = 'dw_AppPermission.';
        this.Attributes = new DwAppPermissionAttributeMetaData();
        this.Relations = new DwAppPermissionRelationMetaData();
        this.ItemDetail.ItemId = 44;
        this.ItemDetail.ItemName = 'dw_AppPermission';
    }
    CreateEntity() {
        return {
            _itemName: this.ItemDetail.ItemName,
            _keyName: this.ItemDetail.keyName
        };
    }
    CreateQueryBuilder(query) {
        if (!query) {
            query = new DwQuery(this.ItemDetail.ItemName);
        }
        return new DwQueryBuilderGen(query, this);
    }
}
class DwAppPermissionAttributeMetaData {
    constructor() {
        //[prop:string] : DwItemAttribute;
        this.i = 'DwAppPermissionAttributeMetaData';
        //AppPermissionId : DwItemAttribute = { FieldName: 'AppPermissionId', FieldNameWithItemPrefix: this.i + 'AppPermissionId'};
        //ApplicationId : DwItemAttribute = { FieldName: 'ApplicationId', FieldNameWithItemPrefix: this.i + 'ApplicationId'};
        this.AppPermissionId = new DwItemAttribute(this.i, 'AppPermissionId');
        // PermissionDisplay : string = this.i + 'PermissionDisplay';
        // PermissionMeaning : string = this.i + 'PermissionMeaning';
        // CreatedBy : string = this.i + 'CreatedBy';
        // CreatedDateTime : string = this.i + 'CreatedDateTime';
        // ModifiedBy : string = this.i + 'ModifiedBy';
        // ModifiedDateTime : string = this.i + 'ModifiedDateTime';
        // UniqueId : string = this.i + 'UniqueId';
        // IsBuiltIn : string = this.i + 'IsBuiltIn';
        // RequiresTwoFactorAuthentication : string = this.i + 'RequiresTwoFactorAuthentication';
    }
}
class DwAppPermissionRelationMetaData {
    constructor() {
        this.DwAppPermissionRole = new DwItemRelationship('dw_AppPermission|dw_AppPermissionRole|AppPermissionId', 'DwAppPermissionRole', 'DwAppPermissionRole');
    }
}

//  export class DwExportRequest
//  {
//      Query: DwQuery;
//      ExportFileName?: string;
//      columnOptions?: DwExportColumnOptions[];
//  }
//  export class DwExportColumnOptions
//  {
//      AttributeName: string;
//      CaptionOverride?: string;
//  }

class DwQueryPagingReturnInfo {
    constructor() {
        this.CurrentPageNo = 1;
        this.CurrentPageSize = 50;
    }
}

;

;

class DwContentPreferenceHierarchy extends DwUiPreferencesHierarchyBase {
}

class DwMdSectionConfigBaseComponent2 extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.formGroup = new FormGroup({});
    }
    setupComplete() {
        super.setupComplete();
        this.setupForm();
        this.formGroup.patchValue(this.section);
        this.formGroup.valueChanges
            .pipe(debounceTime(100))
            .subscribe(() => {
            this.section = Object.assign(this.section, this.formGroup.value);
            this.onSectionChange();
        });
    }
}
DwMdSectionConfigBaseComponent2.ɵfac = function DwMdSectionConfigBaseComponent2_Factory(t) { return ɵDwMdSectionConfigBaseComponent2_BaseFactory(t || DwMdSectionConfigBaseComponent2); };
DwMdSectionConfigBaseComponent2.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwMdSectionConfigBaseComponent2, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
const ɵDwMdSectionConfigBaseComponent2_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwMdSectionConfigBaseComponent2);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMdSectionConfigBaseComponent2, [{
        type: Directive
    }], null, null); })();

class DwSectionConfigMenuService {
    constructor(dwMetadataFormUtilService, uiConfigRegistryService) {
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.sectionDefinitions = [];
        this.sectionDefinitions = uiConfigRegistryService.getRegisteredItems(DwUiRegistryType.formSections);
    }
}
DwSectionConfigMenuService.ɵfac = function DwSectionConfigMenuService_Factory(t) { return new (t || DwSectionConfigMenuService)(ɵngcc0.ɵɵinject(DwMetadataFormUtilService), ɵngcc0.ɵɵinject(DwUiConfigRegistryService)); };
DwSectionConfigMenuService.ɵprov = ɵɵdefineInjectable({ factory: function DwSectionConfigMenuService_Factory() { return new DwSectionConfigMenuService(ɵɵinject(DwMetadataFormUtilService), ɵɵinject(DwUiConfigRegistryService)); }, token: DwSectionConfigMenuService, providedIn: "root" });
DwSectionConfigMenuService.ctorParameters = () => [
    { type: DwMetadataFormUtilService },
    { type: DwUiConfigRegistryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwSectionConfigMenuService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: DwMetadataFormUtilService }, { type: DwUiConfigRegistryService }]; }, null); })();

var DwFormRowType;
(function (DwFormRowType) {
    DwFormRowType[DwFormRowType["fieldRow"] = 1] = "fieldRow";
    DwFormRowType[DwFormRowType["componenet"] = 2] = "componenet";
})(DwFormRowType || (DwFormRowType = {}));

/**
 * @deprecated This decorator is deprecated.  Use the DwAction decorator instead with the DwActionType of formAction
 * @param formActionDef
 */
function DwFormAction(formActionDef) {
    return function (constructor) {
        let actionRef = {
            keyName: formActionDef.actionKey || formActionDef.name,
            display: formActionDef.name,
            isGlobal: formActionDef.isGlobal || false,
            actionMessage: formActionDef.actionMessage,
            actionComponent: constructor,
            actionType: DwActionType.formAction,
            configData: {
                buttonConfig: formActionDef.buttonConfig,
            },
            parentItemName: formActionDef.parentItemName,
        };
        let uiConfigRegistyService = new DwUiConfigRegistryService();
        uiConfigRegistyService.registerItem(DwUiRegistryType.action, actionRef);
    };
}

/* export interface DwFormInterceptor {

    OnBeforeConfig(perfs: DwMetaDataFormPreferences);
    OnAfterConfig(config : DwMetaDataFormConfig);

    OnAfterDataLoad(data : any);

    OnBeforeSave(formGroup: FormGroup);

    OnAfterSave():boolean;
    OnCancel():boolean;
} */

class DwFormRowPreference {
    constructor() {
        this.rowType = DwFormRowType.fieldRow;
        this.columns = 2;
        this.fields = [];
    }
}

class DwChildDataRepeaterSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.childDataRepeater;
    }
}

class DwChildDataSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.childData;
    }
}

class DwComponentSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.component;
    }
}
class DwComponentSectionConfigPreference extends DwComponentSectionPreference {
}

class DwGridSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.grid;
    }
}

class DwSectionColumnPreference {
}

class DwTextSectionPreference extends DwContainerSectionPreference {
    constructor() {
        super();
        this.sectionType = DwSectionType.text;
    }
}

;

class DwMetaDataFormDependencyService {
}

class DwPageBaseComponent {
}

// export interface DwPdSectionDef<sectionDefType = any> {
//     sectionDefType: sectionDefType;
//     toolbarDisplay: string;
//     toolbarIconCss: string;
//     toolbarGroupName?: string;
//     configComponent?: Type<any>;
//     designComponent?: Type<any>;
//     createSectionDef?(params: any): sectionDefType;
// }

class ChildRollupFieldConfig {
}

class DwQueryEditorData {
}

class DwQueryEditorUiState {
    constructor() {
        this.itemMetaData = {};
        this.queryTree = [];
    }
}

class DwDynamicRoute {
}

class DwMetaDataRoute extends DwDynamicRoute {
}

// export function DwMetaDataRoutingAppStart(injector: Injector) {
//     const configService = injector.get<DwConfigService>(DwConfigServiceToken);
//     if (configService) {
//         const promise = new Promise((resolve) => {
//         configService.waitForConfigLoader()
//             .pipe(mergeMap(()=> {
//                 const mdRoutingRepositoryService = injector.get<DwMetaDataRoutingRepositoryService>(DwMetaDataRoutingRepositoryService);
//                 return mdRoutingRepositoryService.setupRepositoryRoutes()
//                 .pipe(catchError(error => {
//                     console.error(`Could not complete App Initialization!`, error);
//                     return of(null);
//                 }));
//             })).subscribe(result=> {
//                 resolve(null);
//             }, error=> {
//                 resolve(null);
//             });
//         });
//         return promise;
//     }
//     else {
//         console.warn('Could not load Routing repository service to register database routes');
//     }
// }

function DwRuleDecorator(rule) {
    //console.log("DwRule Decorator evaluated", rule);
    return function (target, propertyKey, descriptor) {
        let finalRule = rule;
        finalRule.ruleFn = target[propertyKey];
        const registery = new DwRulesRegistry();
        registery.registerRule(finalRule);
        //console.log("DwRule Decorator called",finalRule, target, propertyKey, descriptor);
    };
}

var DwRuleType;
(function (DwRuleType) {
    DwRuleType["expression"] = "expression";
    DwRuleType["custom"] = "custom";
})(DwRuleType || (DwRuleType = {}));

function convertFields(...fieldNames) {
    var fields = [];
    ;
    for (let fieldName of fieldNames) {
        var fieldDef = {
            attrName: getFieldName(fieldName)
        };
        fields.push(fieldDef);
    }
    return fields;
}
function convertField(fieldName, label) {
    var field = new DwFormFieldPreference();
    field.attrName = getFieldName(fieldName);
    field.label = label;
    return field;
}
function getFieldName(fieldName) {
    let index = fieldName.indexOf(".");
    if (index >= 0)
        return fieldName.substring(index + 1, fieldName.length);
    return fieldName;
}

;

class DwAgBaseColumn {
    constructor() {
        this.destroyed = false;
    }
    //public displayValue: any;
    refresh(params) {
        this.params = params;
        // this.columnParams = params.colDef.cellRendererParams;
        this.columnParams = params.column.getColDef().cellRendererParams;
        this.setupColumn();
        return false;
    }
    agInit(params) {
        this.params = params;
        // this.columnParams = params.colDef.cellRendererParams;
        this.columnParams = params.column.getColDef().cellRendererParams;
        this.setupColumn();
        //  this.setDisplayValue();
    }
    ngOnDestroy() {
        this.destroyed = true;
    }
    getData() {
        var _a, _b, _c, _d, _e, _f;
        if (this.destroyed) {
            return null;
        }
        if ((_a = this.params) === null || _a === void 0 ? void 0 : _a.data) {
            return (_b = this.params) === null || _b === void 0 ? void 0 : _b.data;
        }
        if ((_d = (_c = this.params) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.data) {
            return (_f = (_e = this.params) === null || _e === void 0 ? void 0 : _e.node) === null || _f === void 0 ? void 0 : _f.data;
        }
        // Really bad hack to handle a weird bug in Ag grid where params.data is null.  This will keep trying to get the data from the row until it finds it.
        if (this.params.rowIndex == 0) {
            const component = this;
            setTimeout(() => {
                var _a;
                if (this.destroyed) {
                    return null;
                }
                let foundRowNode;
                (_a = component === null || component === void 0 ? void 0 : component.params) === null || _a === void 0 ? void 0 : _a.api.forEachNode((rowNode, index) => {
                    if (index == this.params.rowIndex) {
                        foundRowNode = rowNode;
                    }
                });
                if (foundRowNode && foundRowNode.data) {
                    component.params.data = foundRowNode.data;
                    component.refresh(this.params);
                }
                else {
                    component.getData();
                }
            }, 20);
        }
        return null;
    }
    triggerDefaultAction(event) {
        const actionPreference = this.columnParams.colDef.actionPreference;
        if (!actionPreference) {
            alert('No action preference to trigger!');
            return;
        }
        this.triggerAction(actionPreference);
    }
    triggerAction(actionPreference, event) {
        const parentComponent = this.params.context.componentParent;
        const actionEvent = {
            actionPreference: actionPreference,
            dwBrowserEvent: getDwBrowserEvent(event)
        };
        parentComponent.triggerGridEvent(this.params.colDef, this.getData(), DwGridEventType.rowActionButton, actionEvent);
    }
}
DwAgBaseColumn.ɵfac = function DwAgBaseColumn_Factory(t) { return new (t || DwAgBaseColumn)(); };
DwAgBaseColumn.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DwAgBaseColumn });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgBaseColumn, [{
        type: Directive
    }], function () { return []; }, null); })();

class DwAgActionButtonsComponent extends DwAgBaseColumn {
    constructor() {
        super(...arguments);
        this.actionPreferences = [];
    }
    setupColumn() {
        this.actionPreferences = this.columnParams.rowActionPreferences;
        const parentComponent = this.params.context.componentParent;
        this.configContext = parentComponent.configContext;
        const data = this.getData();
        this.isEdited = ((data === null || data === void 0 ? void 0 : data._edited) == true);
    }
}
DwAgActionButtonsComponent.ɵfac = function DwAgActionButtonsComponent_Factory(t) { return ɵDwAgActionButtonsComponent_BaseFactory(t || DwAgActionButtonsComponent); };
DwAgActionButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAgActionButtonsComponent, selectors: [["dw-action-buttons"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [["class", "dw-grid-row-buttons", 4, "ngIf"], [1, "dw-grid-row-buttons"], [3, "actionPreferences", "actionContext", "actionClick"]], template: function DwAgActionButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtext(0);
        ɵngcc0.ɵɵtemplate(1, DwAgActionButtonsComponent_div_1_Template, 2, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵtextInterpolate1(" Edited: ", ctx.isEdited, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEdited);
    } }, directives: [ɵngcc4.NgIf, DwActionBarComponent], encapsulation: 2 });
const ɵDwAgActionButtonsComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAgActionButtonsComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgActionButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'dw-action-buttons',
                template: `

        Edited: {{isEdited}} 

        <div class="dw-grid-row-buttons" *ngIf="!isEdited">
            <dw-action-bar [actionPreferences]="actionPreferences" [actionContext]="configContext" (actionClick)="triggerAction($event)" ></dw-action-bar>
        </div>
    `
            }]
    }], null, null); })();

class DwAgLinkColumnComponent extends DwAgBaseColumn {
    setupColumn() { }
}
DwAgLinkColumnComponent.ɵfac = function DwAgLinkColumnComponent_Factory(t) { return ɵDwAgLinkColumnComponent_BaseFactory(t || DwAgLinkColumnComponent); };
DwAgLinkColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAgLinkColumnComponent, selectors: [["dw-ag-link-column"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[1, "a-link", 3, "innerHtml", "click"]], template: function DwAgLinkColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵlistener("click", function DwAgLinkColumnComponent_Template_span_click_0_listener() { return ctx.triggerDefaultAction(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHtml", ctx.displayValue, ɵngcc0.ɵɵsanitizeHtml);
    } }, encapsulation: 2 });
const ɵDwAgLinkColumnComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAgLinkColumnComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgLinkColumnComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ag-link-column',
                template: `<span class="a-link" (click)="triggerDefaultAction()" [innerHtml]="displayValue"></span>`
            }]
    }], null, null); })();

class DwAgCustomColumnComponent extends DwAgBaseColumn {
    constructor() {
        super(...arguments);
        this.editing = false;
    }
    setupColumn() {
        this.setupComponent();
    }
    configureComponent(instance) {
        this.columnComponentInstance = instance;
        this.setupComponent();
    }
    setupEditableWatch() {
        const parentComponent = this.params.context.componentParent;
        parentComponent.rowEditableChangedSubject.subscribe(() => {
        });
    }
    setupComponent() {
        if (this.columnComponentInstance) {
            const parentComponent = this.params.context.componentParent;
            // Bind function to the parent function so it will be in the correct context when executed
            const triggerGridEvent = parentComponent.triggerGridEvent.bind(parentComponent);
            const columnRendererParams = {
                rowActionPreferences: this.columnParams.rowActionPreferences,
                rowActionsInlineEditPreferences: this.columnParams.rowActionsInlineEditPreferences,
                colDef: this.columnParams.colDef,
                data: this.getData(),
                nativeParams: this.params,
                value: this.params.value,
                renderFunc: this.columnParams.renderFunc,
                triggerGridEvent: triggerGridEvent,
                resolvedContext: parentComponent.resolvedContext,
                configContext: parentComponent.configContext,
                gridConfig: parentComponent.gridConfig,
                cancelRowEdit: (rowData) => { parentComponent.cancelRowEdit(this.params.node, rowData); },
                undoRowEdit: (rowData) => { parentComponent.undoRowEdit(this.params.node, rowData); },
                markRowDeleted: (rowData) => { parentComponent.markRowDeleted(this.params.node, rowData); },
                startRowEdit: (rowData) => { parentComponent.startRowEdit(this.params.node, rowData); },
                completeRowEdit: (rowData) => { parentComponent.completeRowEdit(this.params.node, rowData); },
                isEditingRow: () => { return this.params.api.getEditingCells().find(cell => cell.rowIndex === this.params.node.rowIndex) != null; },
                rowEditingChanged: () => parentComponent.rowEditableChangedSubject.asObservable()
            };
            this.columnComponentInstance.initColumn(columnRendererParams);
        }
    }
}
DwAgCustomColumnComponent.ɵfac = function DwAgCustomColumnComponent_Factory(t) { return ɵDwAgCustomColumnComponent_BaseFactory(t || DwAgCustomColumnComponent); };
DwAgCustomColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAgCustomColumnComponent, selectors: [["dw-ag-custom-column"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "component", "configure"]], template: function DwAgCustomColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-dynamic-loader", 0);
        ɵngcc0.ɵɵlistener("configure", function DwAgCustomColumnComponent_Template_dw_dynamic_loader_configure_0_listener($event) { return ctx.configureComponent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("component", ctx.columnParams == null ? null : ctx.columnParams.columnRendererRegistration == null ? null : ctx.columnParams.columnRendererRegistration.rendererType);
    } }, directives: [DwDynamicLoaderComponent], encapsulation: 2 });
const ɵDwAgCustomColumnComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwAgCustomColumnComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgCustomColumnComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ag-custom-column',
                template: `
    <dw-dynamic-loader [component]="columnParams?.columnRendererRegistration?.rendererType" (configure)="configureComponent($event)"></dw-dynamic-loader>
  `
            }]
    }], null, null); })();

var __rest$3 = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class DwAgGridInfiniteRowDataSource {
    constructor(dataSource, gridConfig) {
        this.dataSource = dataSource;
        this.gridConfig = gridConfig;
        this.pageInfo = new DwDataPageReturnInfo();
        this.onLoadComplete = new Subject();
        this.IsEditing = false;
    }
    GetLoadComplete() {
        return this.onLoadComplete.asObservable();
    }
    clearCache() {
        this.previousRequest = null;
        this.previousResultObservable = null;
        this.previousResult = null;
        this.previousLastRow = null;
        this.clearEditedRows();
    }
    destory() {
        this.gridApi = null;
        if (this.previousResultObservable) {
            this.previousResultObservable = null;
        }
    }
    showLoading() {
        if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
        }
    }
    hideLoading() {
        if (this.gridApi) {
            this.gridApi.hideOverlay();
        }
    }
    showNoRows() {
        if (this.gridApi) {
            this.gridApi.showNoRowsOverlay();
        }
    }
    hideNoRows() {
        if (this.gridApi) {
            this.gridApi.hideOverlay();
        }
    }
    addEditedData(data) {
        this.IsEditing = true;
        if (!this.editedResults) {
            this.editedResults = [data];
            return;
        }
        if (data._keyName) {
            const keyValue = data[data._keyName];
            const existingResult = this.editedResults.find(r => r[data._keyName] == keyValue);
            if (existingResult) {
                const index = this.editedResults.indexOf(existingResult);
                this.editedResults[index] = data;
                return;
            }
        }
        this.editedResults.push(data);
    }
    // private updateAllResultsWithEdited(data: DwOrmData, remove: boolean) {
    //     if (!this.allResultsWithEdited) {
    //         this.allResultsWithEdited = [...this.allResults];
    //     }
    //     const keyValue = data[data._keyName];
    //     const existingResult = this.allResultsWithEdited.find(r=> r[data._keyName] == keyValue);
    //     if (existingResult) {
    //         if (remove) {
    //             data = this.allResults.find(r=> r[data._keyName] == keyValue);
    //             if (!data) {
    //             }
    //         }
    //         const index = this.allResultsWithEdited.indexOf(existingResult);
    //         this.allResultsWithEdited[index] = data;
    //         return;
    //     }
    // }
    removeEditedData(data) {
        if (!this.editedResults) {
            this.IsEditing = false;
            return;
        }
        if (data._keyName) {
            const keyValue = data[data._keyName];
            const existingResult = this.editedResults.find(r => r[data._keyName] == keyValue);
            if (existingResult) {
                const index = this.editedResults.indexOf(existingResult);
                this.editedResults.splice(index, 1);
            }
        }
        if (this.editedResults.length == 0) {
            this.IsEditing = false;
            this.gridApi.refreshServerSideStore({ purge: true });
            // const params: RedrawRowsParams = {
            //     rowNodes: [node],
            // }
            // this.gridApi.redrawRows();
        }
    }
    getEditedRows() {
        return this.editedResults || [];
    }
    getAllDataWithEdits() {
        const newResults = [...this.allResults];
        if (!this.editedResults || this.editedResults.length == 0) {
            return newResults;
        }
        for (const editedRow of this.editedResults) {
            const keyValue = editedRow[editedRow._keyName];
            const existingResult = newResults.find(r => r[editedRow._keyName] == keyValue);
            if (existingResult) {
                const index = newResults.indexOf(existingResult);
                newResults[index] = editedRow;
            }
        }
        return newResults;
    }
    clearEditedRows() {
        this.editedResults = null;
    }
    // Callback the grid calls that you implement to fetch rows from the server. See below for params.
    getRows(params) {
        if (this.IsEditing) {
            const allEditedResults = this.getAllDataWithEdits();
            params.successCallback(allEditedResults, allEditedResults.length);
            return;
        }
        this.showLoading();
        const request = new DwDataRequest();
        // Setup Paging info
        request.pageInfo = new DwDataPageInfo();
        let pageSize = params.endRow - params.startRow;
        let pageNo = (params.startRow / pageSize) + 1;
        request.pageInfo.pageNo = pageNo;
        request.pageInfo.pageSize = pageSize;
        request.filters = this.filters;
        request.pageInfo.returnCount = false;
        if (this.gridConfig.loadTotalRowCount) {
            request.pageInfo.returnCount = true;
        }
        this.pageInfo.currentPageNo = pageNo;
        this.pageInfo.currentPageSize = pageSize;
        if (this.pageInfo.currentPageNo == 1) {
            // Clear out total pages
            this.pageInfo.totalPageCount = -1;
            this.pageInfo.totalRecordCount = -1;
        }
        // Check if stuff is already loaded and the sort didn't change
        const dwAgGrid = params.context.componentParent;
        // Setup sorting
        for (let sortItem of params.sortModel) {
            const dwSortItem = new DwDataSort();
            // Find the original column definition to see if this field should be sorted differently that by the colId
            const agColumnDef = dwAgGrid.agGridConfig.columnDefs.find(col => col.colId == sortItem.colId);
            const columnParams = agColumnDef.cellRendererParams || {};
            const columnDef = columnParams === null || columnParams === void 0 ? void 0 : columnParams.colDef;
            dwSortItem.fieldName = (columnDef === null || columnDef === void 0 ? void 0 : columnDef.fullSortField) || (columnDef === null || columnDef === void 0 ? void 0 : columnDef.field) || sortItem.colId;
            dwSortItem.relationPrefix = columnDef === null || columnDef === void 0 ? void 0 : columnDef.relationPrefix;
            dwSortItem.ascending = (sortItem.sort === "desc") ? false : true;
            request.sorting.push(dwSortItem);
        }
        const currentRequest = JSON.stringify(request);
        const { pageInfo } = request, coreRequest = __rest$3(request, ["pageInfo"]);
        const coreRequestJSON = JSON.stringify(coreRequest);
        // Added this to support updating grid data with a full refresh
        if (coreRequestJSON == this.previousCoreRequestJSON && this.allResults && !this.previousResultObservable) {
            // Ensure that the appropriate data is loaded before returning anything
            if (this.allResultsLastRow !== -1 || this.allResults.length != ((pageInfo.pageNo - 1) * pageInfo.pageSize)) {
                const actualEndRow = params.endRow <= this.allResults.length ? params.endRow : this.allResults.length;
                const rowsToReturn = this.allResults.slice(params.startRow, actualEndRow);
                this.hideLoading();
                if (this.allResultsLastRow == 0) {
                    this.showNoRows();
                }
                params.successCallback(rowsToReturn, this.allResultsLastRow);
                return;
            }
        }
        this.previousCoreRequestJSON = coreRequestJSON;
        let observableResult;
        if (this.previousRequest && this.previousRequest == currentRequest) {
            if (this.previousResultObservable)
                observableResult = this.previousResultObservable;
            else {
                params.successCallback(this.previousResult, this.previousLastRow);
                return;
            }
        }
        else {
            this.previousRequest = currentRequest;
            //console.log('Ag Grid Database source - request data', this.dataSource?.uniqueIdentifier, request);
            observableResult = this.dataSource.requestData(request);
            observableResult = observableResult.pipe(share());
            this.previousResultObservable = observableResult;
        }
        observableResult.subscribe((result) => {
            let lastRow = -1;
            if (isDwDataPageResults(result)) {
                if (result.pageInfo) {
                    if (result.pageInfo.totalPageCount) {
                        this.pageInfo.totalPageCount = result.pageInfo.totalPageCount;
                        this.pageInfo.totalRecordCount = result.pageInfo.totalRecordCount;
                    }
                    else {
                        if (result.data.length == pageSize) {
                            this.hasMoreData = true;
                        }
                        else {
                            this.pageInfo.totalPageCount = result.pageInfo.currentPageNo;
                            this.pageInfo.totalRecordCount = (this.pageInfo.currentPageSize * (result.pageInfo.currentPageNo - 1)) + result.data.length;
                        }
                    }
                    if (result.pageInfo.currentPageNo == this.pageInfo.totalPageCount) {
                        lastRow = this.pageInfo.totalRecordCount;
                    }
                }
            }
            else {
                lastRow = result.data.length;
            }
            this.previousResult = result.data;
            this.previousLastRow = result.data.length;
            if (this.pageInfo.currentPageNo == 1) {
                this.allResults = [];
            }
            this.allResults = [...this.allResults, ...result.data];
            this.allResultsLastRow = lastRow;
            params.successCallback(result.data, lastRow);
            this.hideLoading();
            if (this.allResultsLastRow == 0) {
                this.showNoRows();
            }
            this.onLoadComplete.next({
                loadedRowCount: this.allResults.length,
                totalRowCount: this.pageInfo.totalRecordCount,
                allResults: this.allResults
            });
            // Finally clear this out since now we can use the previous result and last row
            this.previousResultObservable = null;
        }, (error) => {
            var _a;
            console.warn('Error loading ag-grid data', (_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.uniqueIdentifier);
            params.failCallback();
            this.hideLoading();
        });
    }
    getAllResults() {
        return this.allResults;
    }
    updateResults(allResults) {
        if (this.allResultsLastRow >= 0) {
            this.allResultsLastRow = allResults.length;
        }
    }
}
DwAgGridInfiniteRowDataSource.ɵfac = function DwAgGridInfiniteRowDataSource_Factory(t) { return new (t || DwAgGridInfiniteRowDataSource)(ɵngcc0.ɵɵinject(DwDataSourceBase), ɵngcc0.ɵɵinject(DwGridConfig)); };
DwAgGridInfiniteRowDataSource.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwAgGridInfiniteRowDataSource, factory: DwAgGridInfiniteRowDataSource.ɵfac });
DwAgGridInfiniteRowDataSource.ctorParameters = () => [
    { type: DwDataSourceBase },
    { type: DwGridConfig }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgGridInfiniteRowDataSource, [{
        type: Injectable
    }], function () { return [{ type: DwDataSourceBase }, { type: DwGridConfig }]; }, null); })();
function UpdateDataResults(rowTransaction, keyName, originalResults) {
    const allResults = [...originalResults];
    if (!rowTransaction || !allResults) {
        // console.log('DwAgGridInfiniteRowDataSource - all results is null, can not update!');
        return;
    }
    if (rowTransaction.add && rowTransaction.add.length) {
        allResults.splice(rowTransaction.addIndex || 0, 0, rowTransaction.add);
    }
    if (rowTransaction.update && rowTransaction.update.length) {
        for (const rowUpdate of rowTransaction.update) {
            const existingRow = allResults.find(row => row[keyName] == rowUpdate[keyName]);
            if (existingRow) {
                const index = allResults.indexOf(existingRow);
                // console.log('Updating Row', existingRow, rowUpdate);
                allResults[index] = rowUpdate;
            }
        }
    }
    if (rowTransaction.remove && rowTransaction.remove.length > 0) {
        for (const rowDelete of rowTransaction.remove) {
            const existingRow = allResults.find(row => row[keyName] == rowDelete[keyName]);
            if (existingRow) {
                const index = allResults.indexOf(existingRow);
                allResults.splice(index, 1);
            }
        }
    }
    return allResults;
}

class DwAgGridStatusBarComponent {
    constructor() { }
    ngOnChanges(changes) {
        if (changes.agGridDataSource) {
            this.setupDataSourceHooks();
        }
    }
    ngOnInit() {
    }
    setupDataSourceHooks() {
        if (!this.agGridDataSource) {
            return;
        }
        if (Array.isArray(this.agGridDataSource)) {
            this.dataSourceState = {
                loadedRowCount: this.agGridDataSource.length,
                totalRowCount: this.agGridDataSource.length,
                allResults: this.agGridDataSource
            };
            this.buildCountText();
            return;
        }
        if (this.agGridDataSource instanceof DwAgGridInfiniteRowDataSource) {
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            this.subscription = this.agGridDataSource.GetLoadComplete()
                .subscribe(result => {
                this.dataSourceState = result;
                this.buildCountText();
            });
        }
    }
    buildCountText() {
        this.countText = '';
        if (this.dataSourceState) {
            if (this.dataSourceState.loadedRowCount <= 0) {
                this.countText = `No Rows To Show`;
                return;
            }
            if (this.dataSourceState.totalRowCount <= 0) {
                this.countText = `Showing ${this.dataSourceState.loadedRowCount}`;
                return;
            }
            this.countText = `Showing ${this.dataSourceState.loadedRowCount} of ${this.dataSourceState.totalRowCount}`;
        }
    }
}
DwAgGridStatusBarComponent.ɵfac = function DwAgGridStatusBarComponent_Factory(t) { return new (t || DwAgGridStatusBarComponent)(); };
DwAgGridStatusBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAgGridStatusBarComponent, selectors: [["dw-ag-grid-status-bar"]], inputs: { agGridDataSource: "agGridDataSource" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [[1, "dw-grid-status-bar"], ["class", "count-panel", 4, "ngIf"], [1, "count-panel"]], template: function DwAgGridStatusBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwAgGridStatusBarComponent_div_1_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dataSourceState);
    } }, directives: [ɵngcc4.NgIf], styles: [".count-panel[_ngcontent-%COMP%]{float:right;margin-right:20px}"] });
DwAgGridStatusBarComponent.ctorParameters = () => [];
DwAgGridStatusBarComponent.propDecorators = {
    agGridDataSource: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgGridStatusBarComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ag-grid-status-bar',
                template: "<div class=\"dw-grid-status-bar\">\r\n    <div class=\"count-panel\" *ngIf=\"dataSourceState\">\r\n        {{ countText }}\r\n    </div>\r\n</div>",
                styles: [".count-panel{float:right;margin-right:20px}"]
            }]
    }], function () { return []; }, { agGridDataSource: [{
            type: Input
        }] }); })();

const KEY_LEFT = 'ArrowLeft';
const KEY_UP = 'ArrowUp';
const KEY_RIGHT = 'ArrowRight';
const KEY_DOWN = 'ArrowDown';
const KEY_PAGE_UP = 'PageUp';
const KEY_PAGE_DOWN = 'PageDown';
const KEY_PAGE_HOME = 'Home';
const KEY_PAGE_END = 'End';
const KEY_TAB = 'TAB';
class DwEditableColumnComponent {
    constructor(dwMetaDataService) {
        this.dwMetaDataService = dwMetaDataService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        // focus on the input
        //setTimeout(() => this.input.element.nativeElement.focus());
    }
    agInit(params) {
        this.params = params;
        const columnParams = this.params.colDef.cellRendererParams;
        this.columnDef = columnParams.colDef;
        this.setupColumn();
    }
    setupColumn() {
        this.fieldDef = this.columnDef.editableFieldDef;
        this.value = this.params.value;
        this.translatedValue = this.params.data[this.fieldDef.attrName];
        this.valueControl = new FormControl(this.translatedValue);
        this.valueControl.valueChanges.subscribe((value) => {
            this.translateValue(value);
        });
        this.editorFG = new FormGroup({
            [this.fieldDef.attrName]: this.valueControl
        });
    }
    translateValue(value) {
        var _a, _b;
        this.translatedValue = value;
        if (((_b = (_a = this.fieldDef) === null || _a === void 0 ? void 0 : _a.attr) === null || _b === void 0 ? void 0 : _b.IsLookup) && value) {
            this.dwMetaDataService.getSingleLookupItem(this.fieldDef.attr.MetaDataLookupId, value)
                .subscribe(lookupItem => {
                this.value = {
                    value: lookupItem === null || lookupItem === void 0 ? void 0 : lookupItem.Display,
                    translatedValue: value,
                    translatedField: this.fieldDef.attrName,
                };
            });
        }
        else {
            this.value = value;
        }
    }
    getValue() {
        return this.value;
    }
    isPopup() {
        return false;
    }
    getPopupPosition() {
        return 'under';
    }
    isCancelBeforeStart() {
        return false;
    }
    isCancelAfterEnd() {
        return false;
    }
    focusIn() {
    }
    focusOut() {
    }
    getFrameworkComponentInstance() {
    }
    afterGuiAttached(params) {
    }
    onKeyDown(event) {
        const key = event.key;
        const isNavigationKey = key === KEY_LEFT ||
            key === KEY_RIGHT ||
            key === KEY_UP ||
            key === KEY_DOWN ||
            key === KEY_PAGE_DOWN ||
            key === KEY_PAGE_UP ||
            key === KEY_PAGE_HOME ||
            key === KEY_PAGE_END;
        if (isNavigationKey) {
            // this stops the grid from receiving the event and executing keyboard navigation
            event.stopPropagation();
        }
    }
}
DwEditableColumnComponent.ɵfac = function DwEditableColumnComponent_Factory(t) { return new (t || DwEditableColumnComponent)(ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken)); };
DwEditableColumnComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwEditableColumnComponent, selectors: [["dw-editable-column"]], viewQuery: function DwEditableColumnComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c101, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, decls: 3, vars: 5, consts: [[1, "ag-cell-edit-wrapper", 2, "min-width2", "200px", "height", "35px", "width", "100%"], [1, "ag-wrapper", "ag-input-wrapper", "ag-text-input-wrapper", 3, "formGroup"], [2, "width", "100%", 3, "fieldDef", "formGroup", "submitted", "useDisplayFields"]], template: function DwEditableColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "dwDynamicField", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.editorFG);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fieldDef", ctx.fieldDef)("formGroup", ctx.editorFG)("submitted", false)("useDisplayFields", false);
    } }, directives: [ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwDynamicFieldComponent], encapsulation: 2 });
DwEditableColumnComponent.ctorParameters = () => [
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] }
];
DwEditableColumnComponent.propDecorators = {
    input: [{ type: ViewChild, args: ['input', { read: ViewContainerRef },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwEditableColumnComponent, [{
        type: Component,
        args: [{
                selector: 'dw-editable-column',
                //template: `<input type="text" [(ngModel)]="value" #input style="height:35px;" />`
                template: `
    <div class="ag-cell-edit-wrapper" style="min-width2:200px;height:35px;width:100%">
        <div class="ag-wrapper ag-input-wrapper ag-text-input-wrapper" [formGroup]="editorFG">

          <dwDynamicField [fieldDef]="fieldDef" [formGroup]="editorFG" [submitted]="false" [useDisplayFields]="false" style="width:100%"></dwDynamicField>
        </div>
    </div>`
            }]
    }], function () { return [{ type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }]; }, { input: [{
            type: ViewChild,
            args: ['input', { read: ViewContainerRef }]
        }] }); })();

const moment$f = moment_;
class DwAgGridConfigConverterService {
    constructor(dwUiConfigRegistryService, serviceExecutionUtil, dwExpressionService, uiMetaDataConfig, dwSecurityUserService) {
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.serviceExecutionUtil = serviceExecutionUtil;
        this.dwExpressionService = dwExpressionService;
        this.uiMetaDataConfig = uiMetaDataConfig;
        this.dwSecurityUserService = dwSecurityUserService;
    }
    convertFromColumnStates(columnStates) {
        let dwColumnStates = [];
        let index = 0;
        for (var columnState of columnStates) {
            index++;
            let dwColumnState = this.convertFromColumnState(columnState, index);
            if (!dwColumnState.hide) {
                dwColumnStates.push(dwColumnState);
            }
        }
        return dwColumnStates;
    }
    convertFromColumnState(columnState, columnIndex) {
        let dwColumnState = {
            columnIndex: columnIndex
        };
        dwColumnState.field = columnState.colId;
        dwColumnState.hide = columnState.hide;
        dwColumnState.pinned = this.convertToDwPinState(columnState.pinned);
        dwColumnState.width = columnState.width;
        dwColumnState.columnIndex = columnIndex;
        dwColumnState.sort = this.convertToDwSortDirection(columnState.sort);
        dwColumnState.sortOrder = columnState.sortIndex;
        return dwColumnState;
    }
    convertToDwSortDirection(sort) {
        switch (sort) {
            case 'asc':
                return DwSortDirection.asc;
            case 'desc':
                return DwSortDirection.desc;
        }
        return null;
    }
    convertToDwPinState(pinned) {
        if (!pinned) {
            return null;
        }
        if (typeof (pinned) == 'boolean' || pinned == 'left') {
            return DwGridPinState.left;
        }
        return DwGridPinState.right;
    }
    convertToColumnStates(gridConfig) {
        let columnStates = [];
        let index = 0;
        let columnDefs = gridConfig.columnDefs;
        // Sort columns since the order matters
        columnDefs = columnDefs.sort((a, b) => { return a.columnIndex - b.columnIndex; });
        const actionPreferencesByMode = gridConfig.actionPreferences || {};
        const rowActions = actionPreferencesByMode[DwGridActionLocation.rowButton] || [];
        const rowActionsInlineEdit = actionPreferencesByMode[DwGridActionLocation.rowButtonInlineEditing] || [];
        // if (rowActions.length > 0 || rowActionsInlineEdit.length > 0) {
        //     // Add Edit column state
        //     columnStates.push(this.buildButtonColumn(gridConfig, rowActions, rowActionsInlineEdit, columnDefs));
        // }
        for (var columnPref of columnDefs) {
            index++;
            columnStates.push(this.convertToColumnState(columnPref));
        }
        if (rowActions.length > 0 || rowActionsInlineEdit.length > 0) {
            const column = this.buildButtonColumn(gridConfig, rowActions, rowActionsInlineEdit, columnDefs);
            // Add Edit column state
            if (gridConfig.showRowActionsOnRight === true) {
                columnStates.push(column);
                column.lockPosition = false;
                //column.pinned = DwGridPinState.right;
            }
            else {
                columnStates = [column, ...columnStates];
            }
        }
        return columnStates;
    }
    convertToColumnState(columnPref) {
        const columnState = {};
        columnState.colId = columnPref.key || columnPref.field;
        columnState.hide = columnPref.hide;
        columnState.pinned = this.convertFromDwPinState(columnPref.pinned);
        columnState.width = columnPref.width || null;
        columnState.sort = this.convertFromDwSortDirection(columnPref.sort);
        // Note: Changed the grid column editor
        // // Clear sort when no sort order is set
        // if (columnPref.sortOrder==null) {
        //     columnState.sort = null;
        // }
        // Not a property and might never had been (Just changed columnState from an any to ColumnState)
        //columnState.columnIndex = columnPref.columnIndex;
        return columnState;
    }
    convertFromDwPinState(pinned) {
        switch (pinned) {
            case DwGridPinState.left:
                return 'left';
            case DwGridPinState.left:
                return 'right';
        }
        return null;
    }
    convertFromDwSortDirection(sort) {
        switch (sort) {
            case DwSortDirection.asc:
                return 'asc';
            case DwSortDirection.desc:
                return 'desc';
        }
        return null;
    }
    convertConfig(dwGridConfig) {
        var _a, _b, _c, _d, _e, _f, _g;
        let agConfig = {};
        agConfig.defaultColDef = {};
        agConfig.defaultColDef.sortable = dwGridConfig.enableSorting;
        agConfig.defaultColDef.resizable = dwGridConfig.enableColResize;
        agConfig.defaultColDef.filter = dwGridConfig.enableFiltering;
        const globalDefaults = (_a = this.uiMetaDataConfig) === null || _a === void 0 ? void 0 : _a.gridGlobalDefaults;
        if (globalDefaults) {
            agConfig.suppressMovableColumns = !this.getDefaultOptionWithPermission(globalDefaults.allowColumnReorder, globalDefaults.allowColumnReorderPermission, true);
            agConfig.suppressDragLeaveHidesColumns = !this.getDefaultOptionWithPermission(globalDefaults.allowColumnRemove, globalDefaults.allowColumnRemovePermission, true);
        }
        // agConfig.suppressDragLeaveHidesColumns = true;
        // agConfig.suppressMovableColumns = true;
        let styleName = ((_b = dwGridConfig.gridStyle) === null || _b === void 0 ? void 0 : _b.gridStyleName) || '';
        const gridStyle = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.gridStyles, styleName);
        // Use grid style row height if it is defined
        if (gridStyle === null || gridStyle === void 0 ? void 0 : gridStyle.rowHeight) {
            agConfig.rowHeight = gridStyle.rowHeight;
        }
        if ((_c = dwGridConfig.gridStyle) === null || _c === void 0 ? void 0 : _c.rowHeight) {
            agConfig.rowHeight = (_d = dwGridConfig.gridStyle) === null || _d === void 0 ? void 0 : _d.rowHeight;
        }
        if (gridStyle === null || gridStyle === void 0 ? void 0 : gridStyle.headerHeight) {
            agConfig.headerHeight = gridStyle === null || gridStyle === void 0 ? void 0 : gridStyle.headerHeight;
        }
        if ((_e = dwGridConfig.gridStyle) === null || _e === void 0 ? void 0 : _e.headerHeight) {
            agConfig.headerHeight = (_f = dwGridConfig.gridStyle) === null || _f === void 0 ? void 0 : _f.headerHeight;
        }
        if (typeof (agConfig.rowHeight) === 'string') {
            agConfig.rowHeight = parseInt(agConfig.rowHeight);
        }
        if (typeof (agConfig.headerHeight) === 'string') {
            agConfig.headerHeight = parseInt(agConfig.headerHeight);
        }
        // agConfig.rowHeight = 100;
        if (dwGridConfig.allowRowSelect) {
            agConfig.rowSelection = 'multiple';
        }
        else {
            agConfig.rowSelection = 'none';
        }
        agConfig.onRowDataUpdated = (event) => {
            console.log('Row Data Updated');
        };
        const metaDataGridConfig = dwGridConfig;
        const inlineEditingOptions = (_g = metaDataGridConfig.selectedView) === null || _g === void 0 ? void 0 : _g.gridViewPreferences;
        const isEditable = this.setupGridEditing(agConfig, dwGridConfig, inlineEditingOptions);
        //agConfig.rowDragManaged = true;
        // if (isEditable) {
        // }
        agConfig.columnDefs = this.convertColumns(dwGridConfig, dwGridConfig.columnDefs, inlineEditingOptions);
        if (metaDataGridConfig.getRowClass) {
            agConfig.getRowClass = (params) => {
                const args = {
                    data: params.data,
                    rowIndex: params.node.rowIndex
                };
                return metaDataGridConfig.getRowClass(args);
            };
        }
        agConfig.onRowClicked = (event) => {
            this.handleRowClick(agConfig, event, DwGridEventType.gridRowClick);
        };
        agConfig.onRowDoubleClicked = (event) => {
            this.handleRowClick(agConfig, event, DwGridEventType.gridRowDoubleClick);
        };
        // Setup custom renderers for the ag grid
        agConfig.frameworkComponents = {
            customColumnRenderer: DwAgCustomColumnComponent,
            actionButtonsRenderer: DwAgActionButtonsComponent,
            linkColumnRenderer: DwAgLinkColumnComponent,
            statusBarComponent: DwAgGridStatusBarComponent,
            columnEditor: DwEditableColumnComponent
        };
        return agConfig;
    }
    getDefaultOptionWithPermission(optionValue, optionPermission, defaultValue) {
        if (optionPermission) {
            return this.dwSecurityUserService.hasPermission(optionPermission);
        }
        if (optionValue === true || optionValue === false) {
            return optionValue;
        }
        return defaultValue;
    }
    convertColumns(gridConfig, columns, inlineEditingOptions) {
        let agColumns = [];
        const actionPreferencesByMode = gridConfig.actionPreferences || {};
        const rowActions = actionPreferencesByMode[DwGridActionLocation.rowButton] || [];
        let rowActionsInline = actionPreferencesByMode[DwGridActionLocation.rowButtonInlineEditing] || [];
        // Clear inline actions if inline editing is not enabled
        if (!(inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.inlineEditEnabled)) {
            rowActionsInline = [];
        }
        // Sort by columnIndex
        columns = columns.sort((a, b) => { return a.columnIndex - b.columnIndex; });
        for (let column of columns) {
            let agColumn = this.convertColumn(column, gridConfig, inlineEditingOptions);
            agColumns.push(agColumn);
        }
        if (gridConfig.allowRowSelect && gridConfig.useCheckboxSelection) {
            agColumns[0].checkboxSelection = true;
            agColumns[0].headerCheckboxSelection = true;
        }
        if (rowActions.length > 0 || rowActionsInline.length > 0) {
            const column = this.buildButtonColumn(gridConfig, rowActions, rowActionsInline, columns);
            // Add Edit column state
            if (gridConfig.showRowActionsOnRight === true) {
                agColumns.push(column);
                column.lockPosition = false;
                //column.pinned = DwGridPinState.right;
            }
            else {
                agColumns = [column, ...agColumns];
            }
        }
        return agColumns;
    }
    convertColumn(column, dwGridConfig, inlineEditingOptions) {
        var _a;
        //const medaDataColumn: DwMetaDataGridColumnPreference = column as DwMetaDataGridColumnPreference;
        const metaDataColumnDef = column;
        const isColumnEditable = (inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.inlineEditEnabled) && metaDataColumnDef.isEditable;
        let agColumn = {
            headerName: column.headerName,
            field: column.field,
            sort: column.sort,
            sortedAt: column.sortOrder,
            hide: column.hide,
            headerClass: column.headerClass,
            pinned: column.pinned,
            sortable: !column.disabledSort,
            colId: column.key || column.field,
            width: column.width || null,
            resizable: dwGridConfig.enableColResize,
            wrapText: column.wrapText || null
        };
        if (dwGridConfig.useColumnFlex) {
            if (column.useFlex) {
                agColumn.flex = column.flex || 1;
                agColumn.minWidth = column.minWidth || 50;
            }
        }
        // agColumn.flex = 1;
        // if (column.headerName == "Item Name") {
        //     agColumn.flex = 2;
        // }
        // agColumn.minWidth = 50;
        if (agColumn.wrapText) {
            agColumn.autoHeight = true;
        }
        //  agColumn.sortingOrder = column.sortOrder;
        agColumn.sortIndex = column.sortOrder;
        // Note: Changed the grid column editor
        // if (column.sortOrder == null) {
        //     agColumn.sort = null;
        // }
        const columnParams = {
            colDef: column,
            columnRendererRegistration: this.getColumnRendererRegistration(column.columnRendererKey)
        };
        agColumn.cellRendererParams = columnParams;
        agColumn.tooltipComponentParams = columnParams;
        if (columnParams.columnRendererRegistration.columnStyleFunc) {
            agColumn.cellStyle = columnParams.columnRendererRegistration.columnStyleFunc(column);
        }
        if ((_a = columnParams.columnRendererRegistration) === null || _a === void 0 ? void 0 : _a.useAutoRowHeight) {
            agColumn.autoHeight = true;
        }
        if (column.actionPreference && column.actionPreference.actionKey) {
            agColumn.onCellClicked = (event) => {
                var _a;
                if ((_a = event.data) === null || _a === void 0 ? void 0 : _a._edited) {
                    return;
                }
                // Check if column is enabled/visible
                this.callGridEvent(event);
            };
        }
        else if (isColumnEditable) {
            agColumn.onCellClicked = (event) => {
                this.callGridColumnClickEvent(event);
            };
        }
        switch (columnParams.columnRendererRegistration.decoratorType) {
            case DwDecoratorType.component:
                // This is a wrapper around a custom column component which removes any ties to ag grid
                agColumn.cellRenderer = 'customColumnRenderer';
                break;
            case DwDecoratorType.service:
                const rendererService = this.serviceExecutionUtil.createService(columnParams.columnRendererRegistration.rendererType);
                if (!rendererService) {
                    console.warn(`Column Renderer ${column.columnRendererKey} is setup to use a renderer service, but one could not be created!  Using standard renderer instead`);
                }
                agColumn.cellRenderer = rendererService ? rendererService.renderColumn(column) : standardRenderer;
        }
        if (isColumnEditable) {
            this.setupColumnEditing(agColumn, column, inlineEditingOptions);
        }
        this.setupConditionalClasses(column, agColumn);
        return agColumn;
    }
    getDwColumnDef(agColumn) {
        const columnParams = agColumn.cellRendererParams;
        return columnParams === null || columnParams === void 0 ? void 0 : columnParams.colDef;
    }
    setupGridEditing(agConfig, gridConfig, inlineEditingOptions) {
        // const metaDataGridConfig = gridConfig as DwMetaDataGridConfig;
        // const inlineEditingOptions: DwGridInlineEditingPreferences = metaDataGridConfig.selectedView?.gridViewPreferences;
        if (!(inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.inlineEditEnabled)) {
            return false;
        }
        switch (inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.inlineEditMode) {
            case DwGridInlineEditingModes.individualCell:
                agConfig.editType = '';
                break;
            case DwGridInlineEditingModes.fullRow:
            case DwGridInlineEditingModes.allRows:
            default:
                // Turn on/off the ability to click into a cell to start editing
                agConfig.suppressClickEdit = true;
                agConfig.editType = 'fullRow';
                break;
        }
        agConfig.onRowEditingStarted = (event) => {
            this.handleRowEditingStarted(agConfig, event);
        };
        agConfig.onRowEditingStopped = (event) => {
            this.handleRowEditingStopped(agConfig, event);
        };
        agConfig.onCellEditingStarted = (event) => {
            this.handleEditStarted(agConfig, event);
        };
        agConfig.onCellEditingStopped = (event) => {
            this.handleEditStopped(agConfig, event);
        };
        agConfig.enableRangeSelection = true;
        agConfig.enableFillHandle = true;
        agConfig.getRowClass = (params) => {
            var _a, _b, _c;
            let classes = '';
            if ((_a = params.data) === null || _a === void 0 ? void 0 : _a._edited) {
                classes = (inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.editedRowClasses) || 'dw-bold';
                if ((_b = params.data) === null || _b === void 0 ? void 0 : _b._isDeleted) {
                    classes += ' dw-deleted';
                }
                if (!((_c = params.data._validation) === null || _c === void 0 ? void 0 : _c.isValid)) {
                    //classes += ' dw-red';
                }
            }
            return classes;
        };
        //return metaDataGridConfig.selectedView?.gridViewPreferences?.inlineEditEnabled;
    }
    handleRowClick(agConfig, event, gridEventType) {
        const parentComponent = event.context.componentParent;
        parentComponent.handleRowClick(agConfig, event, gridEventType);
    }
    handleRowEditingStarted(agConfig, event) {
        const parentComponent = event.context.componentParent;
        parentComponent.handleRowEditingStarted(agConfig, event);
    }
    handleRowEditingStopped(agConfig, event) {
        const parentComponent = event.context.componentParent;
        parentComponent.handleRowEditingStopped(agConfig, event);
    }
    handleEditStarted(agConfig, event) {
        const parentComponent = event.context.componentParent;
        parentComponent.handleEditStarted(agConfig, event);
    }
    handleEditStopped(agConfig, event) {
        const parentComponent = event.context.componentParent;
        parentComponent.handleEditStopped(agConfig, event);
    }
    setupColumnEditing(agColumn, columnDef, inlineEditingOptions) {
        agColumn.editable = true;
        agColumn.valueSetter = params => {
            var _a;
            if ((_a = params.newValue) === null || _a === void 0 ? void 0 : _a.translatedValue) {
                params.data[params.newValue.translatedField] = params.newValue.translatedValue;
                params.data[params.colDef.field] = params.newValue.value;
            }
            else {
                params.data[params.colDef.field] = params.newValue;
            }
        };
        agColumn.cellClass = (params => {
            var _a;
            if (((_a = params.data) === null || _a === void 0 ? void 0 : _a._edited) && agColumn.field && params.data._originalData) {
                const currentData = params.data[agColumn.field];
                const originalData = params.data._originalData[agColumn.field];
                if (currentData != originalData) {
                    return (inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.modifiedCellClasses) || 'dw-blue';
                }
            }
        });
        // agColumn.editable = (params) => {
        //     params.
        //     const parentComponent = event.context.componentParent as DwAgGridApi;
        // };
        agColumn.cellEditor = 'columnEditor';
    }
    setupConditionalClasses(columnDef, agColumn) {
        if (!columnDef.conditionalFieldClasses) {
            return;
        }
        const dataClasses = columnDef.conditionalFieldClasses['data'] || [];
        if (dataClasses.length == 0) {
            return;
        }
        agColumn.cellClass = (params => {
            return this.determineDataClasses(params, dataClasses);
        });
    }
    determineDataClasses(params, dataClasses) {
        const classes = [];
        for (const dataClass of dataClasses) {
            try {
                if (this.dwExpressionService.evaluateExpressionGroupItemWithResolvedData(dataClass.expression, params.data || {}, {})) {
                    classes.push(dataClass.className);
                }
            }
            catch (e) {
            }
        }
        return classes.join(' ');
    }
    callGridEvent(event) {
        const parentComponent = event.context.componentParent;
        const columnParams = event.colDef.cellRendererParams;
        const actionEvent = {
            actionPreference: columnParams.colDef.actionPreference,
            dwBrowserEvent: getDwBrowserEvent(event.event),
            actionContext: {},
        };
        parentComponent.triggerGridEvent(event.colDef, event.data, DwGridEventType.rowActionButton, actionEvent, event.event);
    }
    callGridColumnClickEvent(event) {
        const parentComponent = event.context.componentParent;
        const columnParams = event.colDef.cellRendererParams;
        parentComponent.triggerGridEvent(event.colDef, event.data, DwGridEventType.gridCellClick, null, event.event);
    }
    getColumnRendererRegistration(columnRendererKey) {
        let columnRendererRegistration = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.gridColumn, columnRendererKey || defaultGridColumnRenderer);
        if (!columnRendererRegistration) {
            console.warn(`Could not find Column Renderer named ${columnRendererKey}.  Using default instead!`);
            columnRendererRegistration = this.dwUiConfigRegistryService.getRegisteredItem(DwUiRegistryType.gridColumn, defaultGridColumnRenderer);
            if (!columnRendererRegistration) {
                throw new Error(`Could not find Default Column Renderer named ${defaultGridColumnRenderer}!`);
            }
        }
        return columnRendererRegistration;
    }
    buildButtonColumn(gridConfig, rowActions, rowActionsInlineEditPreferences, columns) {
        var _a, _b, _c;
        const columnParams = {
            colDef: null,
            rowActionPreferences: rowActions,
            rowActionsInlineEditPreferences: rowActionsInlineEditPreferences,
            columnRendererRegistration: this.getColumnRendererRegistration(defaultGridColumnActionButtonsRenderer)
        };
        const inlineEditingOptions = (_a = gridConfig.selectedView) === null || _a === void 0 ? void 0 : _a.gridViewPreferences;
        // Get the max size needed for buttons (so when we change modes, it doesn't cut off buttons)
        let maxButtonCount = rowActions.filter(a => { var _a; return !((_a = a.buttonConfig) === null || _a === void 0 ? void 0 : _a.includeInGroup); }).length;
        ;
        // factor in how many inline edit buttons only it's enabled
        if (inlineEditingOptions === null || inlineEditingOptions === void 0 ? void 0 : inlineEditingOptions.inlineEditEnabled) {
            if (rowActionsInlineEditPreferences.length > maxButtonCount) {
                maxButtonCount = rowActionsInlineEditPreferences.length;
            }
        }
        //const maxButtonCount = rowActions.length > rowActionsInlineEditPreferences.length ? rowActions.length : rowActionsInlineEditPreferences.length;
        let agButtonColumn = {
            headerName: '',
            field: '',
            colId: 'editColumn',
            width: 50 + ((maxButtonCount - 1) * 25),
            cellRenderer: 'customColumnRenderer',
            sortable: false,
            resizable: false,
            lockPosition: true,
            lockVisible: true,
            cellRendererParams: columnParams
        };
        if (gridConfig.showRowActionsOnRight === true) {
            agButtonColumn.lockPosition = 'right';
        }
        if (gridConfig.actionColumnHeader) {
            agButtonColumn.headerName = gridConfig.actionColumnHeader || 'Actions';
        }
        if ((_b = gridConfig.gridStyle) === null || _b === void 0 ? void 0 : _b.actionColumnUseCustomWidth) {
            agButtonColumn.width = (_c = gridConfig.gridStyle) === null || _c === void 0 ? void 0 : _c.actionColumnWidth;
        }
        if (columns && columns.find(c => c.pinned == 'left')) {
            agButtonColumn.pinned = 'left';
        }
        return agButtonColumn;
    }
}
DwAgGridConfigConverterService.ɵfac = function DwAgGridConfigConverterService_Factory(t) { return new (t || DwAgGridConfigConverterService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(DwServiceExecutionUtil), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵinject(DwSecurityUserService)); };
DwAgGridConfigConverterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwAgGridConfigConverterService, factory: DwAgGridConfigConverterService.ɵfac });
DwAgGridConfigConverterService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: DwServiceExecutionUtil },
    { type: DwExpressionService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwSecurityUserService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgGridConfigConverterService, [{
        type: Injectable
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: DwServiceExecutionUtil }, { type: DwExpressionService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwSecurityUserService }]; }, null); })();

class DwAgGridDataActionService {
    processDataActionResult(dataActionResult, dataSource, agGridDataSource, filters, gridApi) {
        // No action to take if there are no keys
        if (!dataActionResult.keysEffected || dataActionResult.keysEffected.length == 0) {
            return;
        }
        switch (dataActionResult.actionType) {
            case DwMdDataActionType.create:
            case DwMdDataActionType.update:
                this.handleCreateUpdateDataAction(dataActionResult, dataSource, agGridDataSource, filters, gridApi);
                break;
            case DwMdDataActionType.delete:
                this.handleDeleteDataAction(dataActionResult, dataSource, agGridDataSource, gridApi);
        }
    }
    handleCreateUpdateDataAction(dataActionResult, dataSource, agGridDataSource, filters, gridApi) {
        this.loadAffectedRows(dataSource, dataActionResult, filters)
            .subscribe(updatedData => {
            this.updateGridData(dataActionResult, agGridDataSource, dataSource, updatedData, gridApi);
        });
    }
    handleDeleteDataAction(dataActionResult, dataSource, agGridDataSource, gridApi) {
        // Since there is no data, we just need to remove these records
        const itemsToRemove = dataActionResult.keysEffected.map(keyValue => {
            const item = {};
            item[dataActionResult.keyName] = keyValue;
            return item;
        });
        const rowDataTransaction = {
            remove: itemsToRemove
        };
        this.processBatchUpdate(rowDataTransaction, dataActionResult.keyName, dataSource, agGridDataSource, gridApi);
    }
    updateGridData(dataActionResult, agGridDataSource, dataSource, updatedData, gridApi) {
        // rows to remove
        const removedKeys = updatedData.map(data => dataActionResult.keysEffected.indexOf(data[dataActionResult.keyName]) >= 0);
        const rowDataTransaction = {
            remove: [],
        };
        switch (dataActionResult.actionType) {
            case DwMdDataActionType.create:
                rowDataTransaction.add = updatedData;
                break;
            case DwMdDataActionType.update:
                rowDataTransaction.update = updatedData;
                break;
        }
        // Identify any nodes that should be removed
        gridApi.forEachNode(node => {
            if (!node.data) {
                return;
            }
            const keyValue = node.data[dataActionResult.keyName];
            if (removedKeys.indexOf(keyValue) >= 0) {
                rowDataTransaction.remove.push(node.data);
                return;
            }
        });
        console.log('updateGridData', rowDataTransaction);
        this.processBatchUpdate(rowDataTransaction, dataActionResult.keyName, dataSource, agGridDataSource, gridApi);
        // agGridDataSource.batchUpdate(rowDataTransaction, dataActionResult.keyName);
        gridApi.refreshInfiniteCache();
    }
    processBatchUpdate(rowDataTransaction, keyName, dataSource, agGridDataSource, gridApi) {
        const originalResults = this.getResults(dataSource, agGridDataSource);
        const newResults = this.UpdateDataResults(rowDataTransaction, keyName, originalResults);
        this.updateResults(newResults, dataSource, agGridDataSource);
        gridApi.deselectAll();
        gridApi.refreshInfiniteCache();
    }
    getResults(dataSource, agGridDataSource) {
        if (agGridDataSource) {
            return agGridDataSource.getAllResults();
        }
        if (dataSource instanceof DwInMemoryDataSource) {
            return dataSource.currentData || [];
        }
        throw new Error('Not sure how to get the data for other data source types!');
    }
    updateResults(results, dataSource, agGridDataSource) {
        if (agGridDataSource) {
            agGridDataSource.updateResults(results);
            return;
        }
        if (dataSource instanceof DwInMemoryDataSource) {
            dataSource.setupDataSource(results, dataSource.item);
            return;
        }
        throw new Error('Not sure how to get the data for other data source types!');
    }
    loadAffectedRows(dataSource, dataActionResult, filters) {
        if (!dataSource.requestData) {
            return of([]);
        }
        // Make a copy so we don't change the referenced filters
        const itemFilters = deepCopy(filters || {});
        itemFilters[dataActionResult.keyName] = {
            In: dataActionResult.keysEffected
        };
        const dataRequest = {
            filters: itemFilters,
            pageInfo: {
                pageNo: 1,
                pageSize: dataActionResult.keysEffected.length,
                returnCount: false,
            }
        };
        return dataSource.requestData(dataRequest)
            .pipe(map(pageResults => {
            return pageResults.data;
        }));
    }
    UpdateDataResults(rowTransaction, keyName, originalResults) {
        originalResults = originalResults || [];
        const allResults = [...originalResults];
        if (!rowTransaction || !allResults) {
            // console.log('DwAgGridInfiniteRowDataSource - all results is null, can not update!');
            return;
        }
        if (rowTransaction.add && rowTransaction.add.length) {
            allResults.splice(rowTransaction.addIndex || 0, 0, rowTransaction.add);
        }
        if (rowTransaction.update && rowTransaction.update.length) {
            for (const rowUpdate of rowTransaction.update) {
                const existingRow = allResults.find(row => row[keyName] == rowUpdate[keyName]);
                if (existingRow) {
                    const index = allResults.indexOf(existingRow);
                    // console.log('Updating Row', existingRow, rowUpdate);
                    allResults[index] = rowUpdate;
                }
            }
        }
        if (rowTransaction.remove && rowTransaction.remove.length > 0) {
            for (const rowDelete of rowTransaction.remove) {
                const existingRow = allResults.find(row => row[keyName] == rowDelete[keyName]);
                if (existingRow) {
                    const index = allResults.indexOf(existingRow);
                    allResults.splice(index, 1);
                }
            }
        }
        return allResults;
    }
}
DwAgGridDataActionService.ɵfac = function DwAgGridDataActionService_Factory(t) { return new (t || DwAgGridDataActionService)(); };
DwAgGridDataActionService.ɵprov = ɵɵdefineInjectable({ factory: function DwAgGridDataActionService_Factory() { return new DwAgGridDataActionService(); }, token: DwAgGridDataActionService, providedIn: "root" });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgGridDataActionService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class DwAgGridComponent extends DwGridImplementationComponent {
    constructor(elementRef, converter, dwConfigService, uiConfig, dwLoggingUtil, dwAgGridDataActionService) {
        super();
        this.elementRef = elementRef;
        this.converter = converter;
        this.dwConfigService = dwConfigService;
        this.uiConfig = uiConfig;
        this.dwLoggingUtil = dwLoggingUtil;
        this.dwAgGridDataActionService = dwAgGridDataActionService;
        this.triggerAction = new EventEmitter();
        this.eventThrottle = new Subject();
        this.rowEditableChangedSubject = new Subject();
        this.gridStyle = { 'height': '200px' };
        // private uiConfig: DwUIConfig;
        this.components = {
            loadingCellRenderer: function (params) {
                if (params.value !== undefined) {
                    return params.value;
                }
                else {
                    return '<img src="https://raw.githubusercontent.com/ag-grid/ag-grid-docs/master/src/images/loading.gif">';
                }
            }
        };
        this.isFullScreen = false;
        //this.uiConfig = dwConfigService.getConfig<DwUIConfig>(DwUiConfigName, {})
        // Create the converter manually since it needs a reference to this component
        this.converter.hostingComponent = this;
    }
    get filters() {
        return this._filters;
    }
    set filters(newFilters) {
        this.lastFilters = deepCopy(this._filters);
        this._filters = deepCopy(newFilters);
        ////console.log('Ag Grid - apply filters');
        //this.applyFilters(newFilters);
    }
    handleRowEditingStopped(agConfig, event) {
        if (!this.isCancelClicked && !this.isCompleteClicked) {
            console.log('handleRowEditingStopped - not cancelled, restarted edit', event);
            this.startRowEdit(event.node, event.data);
            return;
        }
        // Otherwise we need to update the row data
        if (this.isCancelClicked) {
            console.log('handleRowEditingStopped - Cancel Row Editing - clearing flag', event);
            this.isCancelClicked = false;
            this.rowEditableChangedSubject.next();
            return;
        }
        if (this.isCompleteClicked) {
            console.log('handleRowEditingStopped - Completed Row Editing - clearing flag', event);
            this.isCompleteClicked = false;
            this.rowEditableChangedSubject.next();
            return;
        }
    }
    handleRowEditingStarted(agConfig, event) {
        console.log('handleRowEditingStarted', event);
        this.rowEditableChangedSubject.next();
    }
    handleEditStarted(agConfig, event) {
        console.log('handleEditStarted - Cell', event);
        if (!event.data._edited) {
            event.data._originalData = deepCopy(event.data);
        }
    }
    handleEditStopped(agConfig, event) {
        var _a;
        console.log('handleEditStopped - Cell', event);
        const newValue = ((_a = event.newValue) === null || _a === void 0 ? void 0 : _a.translatedValue) ? event.newValue.value : event.newValue;
        if (newValue == undefined) {
            return;
        }
        if (newValue == event.oldValue) {
            return;
        }
        var data = event.data;
        if (!data._edited) {
            data._edited = true;
            // Trigger grid event
            //parentComponent.setEditMode(true);
        }
        this.editRow(event.node, event.data);
        data._validation = this.validateRow(agConfig, event);
        event.node.setData(event.data);
        event.api.redrawRows({ rowNodes: [event.node] });
        this.rowEditableChangedSubject.next();
    }
    validateRow(agConfig, event) {
        var _a, _b;
        const parentComponent = event.context.componentParent;
        let isValid = true;
        const validationErrors = [];
        for (let agColumn of agConfig.columnDefs) {
            const dwColumnDef = this.converter.getDwColumnDef(agColumn);
            if ((_b = (_a = dwColumnDef === null || dwColumnDef === void 0 ? void 0 : dwColumnDef.editableFieldDef) === null || _a === void 0 ? void 0 : _a.attr) === null || _b === void 0 ? void 0 : _b.AlwaysRequired) {
                const value = event.data[dwColumnDef.editableFieldDef.attrName];
                if (!value && value !== false) {
                    validationErrors.push(`${dwColumnDef.headerName} is required`);
                    isValid = false;
                }
            }
        }
        return {
            isValid: isValid,
            validationErrors: validationErrors
        };
    }
    editRow(node, data) {
        console.log('editRow', data);
        if (this.agGridDataSource) {
            this.agGridDataSource.addEditedData(data);
            if (!this.getEditMode()) {
                this.setEditMode(true, true);
            }
        }
        else {
            if (this.data instanceof DwInMemoryDataSource) {
                this.data.saveItem(data);
            }
        }
    }
    setEditMode(inEditMode, refreshGrid) {
        var _a, _b, _c;
        console.log('setEditMode', inEditMode);
        const editModeGridEvent = new DwGridEvent();
        editModeGridEvent.eventType = DwGridEventType.editModeChange;
        const editedCount = (_a = this.agGridDataSource) === null || _a === void 0 ? void 0 : _a.getEditedRows().length;
        editModeGridEvent.eventData = {
            isInEditMode: inEditMode,
            updatedCount: editedCount,
            refreshGrid: refreshGrid
        };
        if (((_c = (_b = this.resolvedContext) === null || _b === void 0 ? void 0 : _b.mdGridContext) === null || _c === void 0 ? void 0 : _c.inEditMode) != inEditMode) {
            setTimeout(() => {
                this.gridApi.startEditingCell({ rowIndex: 0, colKey: 'name' });
                this.gridApi.redrawRows();
            }, 20);
        }
        this.rowEditableChangedSubject.next();
        this.onGridEvent(editModeGridEvent);
    }
    getEditMode() {
        var _a, _b;
        return (_b = (_a = this.resolvedContext) === null || _a === void 0 ? void 0 : _a.mdGridContext) === null || _b === void 0 ? void 0 : _b.inEditMode;
    }
    markRowDeleted(node, rowData) {
        console.log('markRowDeleted', rowData);
        if (!rowData._originalData) {
            rowData._originalData = deepCopy(rowData);
        }
        rowData._isDeleted = true;
        rowData._edited = true;
        node.setData(rowData);
        const params = {
            rowNodes: [node],
        };
        if (this.agGridDataSource) {
            this.agGridDataSource.addEditedData(rowData);
        }
        else if (this.data instanceof DwInMemoryDataSource) {
            this.data.saveItem(rowData);
        }
        this.gridApi.redrawRows(params);
    }
    startRowEdit(node, rowData) {
        console.log('Start Row Edit', rowData);
        // Get first editable column
        const column = this.gridConfig.columnDefs.find(c => c.isEditable);
        if (!column) {
            console.warn('No editable column found so  cannot edit row');
            return;
        }
        this.gridApi.startEditingCell({ rowIndex: node.rowIndex, colKey: column.key });
    }
    completeRowEdit(node, rowData) {
        console.log('Complete Row Edit', rowData);
        this.isCompleteClicked = true;
        this.gridApi.stopEditing(false);
        // this.isCompleteClicked = false;
        setTimeout(() => {
            this.addRow();
        }, 2000);
    }
    cancelRowEdit(node, rowData) {
        console.log('cancelRowEdit', rowData);
        this.isCancelClicked = true;
        this.gridApi.stopEditing(true);
    }
    undoRowEdit(node, rowData) {
        if (rowData._originalData) {
            node.setData(rowData._originalData);
        }
        const params = {
            rowNodes: [node],
        };
        if (this.agGridDataSource) {
            this.agGridDataSource.removeEditedData(rowData);
            if (!this.agGridDataSource.IsEditing) {
                this.setEditMode(false, true);
            }
        }
        else if (this.data instanceof DwInMemoryDataSource) {
            this.data.saveItem(rowData._originalData);
        }
        this.rowEditableChangedSubject.next();
        this.gridApi.redrawRows(params);
    }
    addRow() {
        // const newRow = {};
        // this.gridApi.updateRowData({ add: [newRow] });
    }
    ngOnInit() {
        super.ngOnInit();
        this.setupGrid();
        this.eventThrottle.asObservable().pipe(debounceTime(100))
            .subscribe(event => {
            this.triggerGridEvent(null, this.getColumnState(), DwGridEventType.gridStateChanges, null, event);
        });
    }
    setupComplete() {
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        const configChange = changes.config;
        if (configChange.currentValue) {
            this.setupGrid();
        }
        if (changes.filters && changes.filters.currentValue)
            this.applyFilters(changes.filter.currentValue);
    }
    /** Perform some grid cleanup */
    ngOnDestroy() {
        var _a;
        super.ngOnDestroy();
        this.gridApi = null;
        if ((_a = this.agGridDataSource) === null || _a === void 0 ? void 0 : _a.destory) {
            this.agGridDataSource.destory();
            this.agGridDataSource = null;
        }
    }
    applyFilters(filters, force = false) {
        var _a;
        if (!force && areEqualDeepCompare((_a = this.agGridDataSource) === null || _a === void 0 ? void 0 : _a.filters, filters)) {
            //console.log('Ag grid - apply fitlers - no change', force, filters);
            return;
        }
        this.filters = filters;
        if (this.agGridDataSource instanceof DwAgGridInfiniteRowDataSource) {
            //console.log('Ag grid - apply fitlers', filters);
            this.agGridDataSource.filters = deepCopy(filters);
            // Reset data source
            this.setupGridDataSource();
        }
    }
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // clear out agGridConfig so it will be rebuild with the new gridApi present
        this.agGridConfig = null;
        this.setupGrid();
    }
    getColumnState() {
        return this.converter.convertFromColumnStates(this.gridColumnApi.getColumnState());
    }
    updateGridConfig(newGridConfig, dataSource, filters) {
        var _a;
        this.gridConfig = newGridConfig;
        var newAgGridConfig = this.converter.convertConfig(newGridConfig);
        this.filters = filters;
        // If not changes to the grid config, just return
        if (areEqual(newAgGridConfig, this.agGridConfig, 'frameworkComponents', 'context', 'api', 'columnApi')) {
            return;
        }
        (_a = this.gridApi) === null || _a === void 0 ? void 0 : _a.setColumnDefs(newAgGridConfig.columnDefs);
        this.agGridConfig = newAgGridConfig;
        this.dwLoggingUtil.logToConsole(`Update grid config ${dataSource === null || dataSource === void 0 ? void 0 : dataSource.uniqueIdentifier}`, newAgGridConfig);
        if (this.gridColumnApi) {
            const columnStates = this.converter.convertToColumnStates(newGridConfig);
            this.gridColumnApi.resetColumnState();
            this.gridColumnApi.setColumnState(columnStates);
            // this.gridApi.setSortModel(gridState.sort);
        }
        this.data = dataSource;
        this.dataSource = dataSource;
        this.refreshDataSource(true);
    }
    setupGrid() {
        this.context = { componentParent: this };
        if (this.gridConfig) {
            let newAgGridConfig = this.converter.convertConfig(this.gridConfig);
            // If not changes to the grid config, just return
            if (areEqual(newAgGridConfig, this.agGridConfig))
                return;
            this.agGridConfig = newAgGridConfig;
            if (this.gridApi) {
                this.setupGridDataSource();
            }
            this.configureGridStyle();
        }
    }
    getSelectedRows() {
        if (!this.gridApi) {
            return [];
        }
        const rowNodes = this.gridApi.getSelectedRows();
        const data = rowNodes.map(n => n.data ? n.data : n);
        return data;
    }
    getEditedRows() {
        var _a;
        if (!this.gridApi) {
            return [];
        }
        const editedData = (_a = this.agGridDataSource) === null || _a === void 0 ? void 0 : _a.getEditedRows();
        return editedData;
    }
    unselectAllRows() {
        if (!this.gridApi) {
            return;
        }
        this.gridApi.deselectAll();
    }
    selectAllRows() {
        if (!this.gridApi) {
            return;
        }
        this.gridApi.selectAll();
    }
    refreshDataSource(force) {
        var _a, _b, _c;
        const isSameDatasource = ((_a = this.dataSource) === null || _a === void 0 ? void 0 : _a.uniqueIdentifier) == ((_c = (_b = this.agGridDataSource) === null || _b === void 0 ? void 0 : _b.dataSource) === null || _c === void 0 ? void 0 : _c.uniqueIdentifier);
        if (isSameDatasource && !force) {
            //console.log('Ag Grid - refreshDataSource - Same data source', this.dataSource?.uniqueIdentifier);
            return;
        }
        super.refreshDataSource();
        if (this.gridApi) {
            this.setupDataSource();
            if (this.agGridDataSource instanceof DwAgGridInfiniteRowDataSource) {
                this.agGridDataSource.clearCache();
                // update the data source
                this.agGridDataSource.dataSource = this.dataSource;
                this.setupGridDataSource();
            }
            else {
                super.requestData();
                this.gridApi.setRowData(this.bindableData);
            }
        }
    }
    setupGridDataSource() {
        if (!this.agGridDataSource || !this.gridApi)
            return;
        this.agGridDataSource.gridApi = this.gridApi;
        //console.log('Ag Grid - set Grid data source on grid api');
        this.gridApi.setDatasource(this.agGridDataSource);
    }
    setupDataSource() {
        super.setupDataSource();
        if (this.dataSource) {
            // If the data source allows paging, then we need to use the inifinite row data source
            if (this.dataSource.allowsPaging) {
                this.rowModelType = 'infinite';
                //console.log('Ag Grid - setupDataSource - create new AG grid data source',  this.dataSource?.uniqueIdentifier);
                this.agGridDataSource = new DwAgGridInfiniteRowDataSource(this.dataSource, this.gridConfig);
                if (this.agGridDataSource instanceof DwAgGridInfiniteRowDataSource) {
                    this.agGridDataSource.filters = this.filters;
                }
                if (this.dataloadSubscription) {
                    this.dataloadSubscription.unsubscribe();
                }
                this.dataloadSubscription =
                    this.agGridDataSource.GetLoadComplete()
                        .subscribe(result => {
                        this.triggerGridDataEvent(result);
                    });
                this.setupGridDataSource();
            }
            else {
                // Otherwise we immediately call request data (this populates the bindable data for the grid)
                super.requestData();
                if (Array.isArray(this.dataSource)) {
                    this.triggerGridDataEvent({
                        loadedRowCount: this.dataSource.length,
                        totalRowCount: this.dataSource.length,
                        allResults: this.dataSource
                    });
                }
            }
        }
    }
    handleRowClick(agConfig, event, gridEventType) {
        //console.log('AgGrid handleRowClick', event);
        this.triggerGridEvent(null, event.data, gridEventType, null, event);
    }
    onAgGridGridSelectionChanged(event) {
        const selectedRows = this.getSelectedRows();
        this.triggerGridEvent(null, selectedRows, DwGridEventType.rowSelectionChange, null, event);
    }
    onAgGridStateChangeEvent(event) {
        // Run context menus immediately (we need to stop propogation, otherwise parent context menus get fired first)
        if (event && event.type == 'cellContextMenu') {
            const actionEvent = {
                actionPreference: null,
                dwBrowserEvent: null
            };
            this.triggerGridEvent(event.colDef, event.data, DwGridEventType.rowContextMenu, actionEvent, event.event);
            return;
        }
        this.eventThrottle.next(event);
    }
    triggerGridEvent(colDef, data, eventType = DwGridEventType.rowActionButton, actionEvent, browserEvent) {
        let gridEvent = new DwGridEvent();
        gridEvent.actionPreference = actionEvent === null || actionEvent === void 0 ? void 0 : actionEvent.actionPreference;
        if (colDef && colDef.colId) {
            gridEvent.eventColumn = this.findColumn(colDef.colId);
            if (gridEvent.eventColumn) {
                gridEvent.eventCommand = gridEvent.eventColumn.key;
            }
        }
        gridEvent.eventData = data;
        gridEvent.eventType = eventType;
        gridEvent.browserEvent = browserEvent;
        gridEvent.dwBrowserEvent = actionEvent === null || actionEvent === void 0 ? void 0 : actionEvent.dwBrowserEvent;
        gridEvent.actionContext = actionEvent === null || actionEvent === void 0 ? void 0 : actionEvent.actionContext;
        this.onGridEvent(gridEvent);
    }
    triggerGridDataEvent(datasourceState) {
        let gridEvent = new DwGridEvent();
        gridEvent.eventType = DwGridEventType.gridDataLoad;
        gridEvent.eventData = datasourceState;
        this.onGridEvent(gridEvent);
    }
    reset(event) {
        // re-configure the grid style upon browser resize
        this.configureGridStyle();
    }
    ngDoCheck() {
        this.configureGridStyle();
    }
    processDataActionResult(dataActionResult) {
        this.dwAgGridDataActionService.processDataActionResult(dataActionResult, this.data, this.agGridDataSource, this.filters, this.gridApi);
    }
    configureGridStyle() {
        const styleDefaults = {
            gridHeightMode: DwGridHeightMode.fixedHeight,
            gridHeight: "500",
        };
        const gridStyleConfig = Object.assign(Object.assign({}, styleDefaults), this.gridConfig.gridStyle);
        if (gridStyleConfig.gridStyleOverride) {
            this.gridStyle = gridStyleConfig.gridStyleOverride;
            return;
        }
        switch (gridStyleConfig.gridHeightMode) {
            case DwGridHeightMode.autoFitToScreen:
                this.configGridAutoFit(gridStyleConfig);
                break;
            case DwGridHeightMode.fixedHeight:
                this.configGridFixedHeight(gridStyleConfig);
                break;
            case DwGridHeightMode.fullScreen:
                this.configGridFullScreen(this.gridStyle);
                break;
            case DwGridHeightMode.rowBased:
                this.configRowBasedHeight(gridStyleConfig);
                break;
            case DwGridHeightMode.printFriendly:
                this.configPrintFriendly(gridStyleConfig);
                break;
            case DwGridHeightMode.autoFitToScreen:
            default:
                this.configGridAutoFit(gridStyleConfig);
                break;
        }
    }
    configGridAutoFit(gridStyleConfig) {
        const footerHeight = this.gridConfig.showFooter ? this.uiConfig.gridFooterHeight : 0;
        const bottomMargin = this.uiConfig.pageFooterHeight + footerHeight; // margin under grid (when in non-full-screen mode)
        const additionalMargin = this.uiConfig.pageMargin;
        const width = this.elementRef.nativeElement.offsetWidth;
        const gridAutofitTurnOffWidth = this.uiConfig.gridAutofitMobileTurnOffWidth || 500;
        if (width <= gridAutofitTurnOffWidth) {
            this.gridStyle = {
                'height': `${this.uiConfig.gridAutofitMobileHeight || 500}px`
            };
            return;
        }
        //   console.log('ag-grid width', width);
        const offsetTop = this.elementRef.nativeElement.getBoundingClientRect().top;
        const fullHeight = window.innerHeight;
        const trustElementsHeight = 0;
        let newHeight = fullHeight - offsetTop - bottomMargin - additionalMargin - trustElementsHeight;
        if (newHeight < 200) {
            newHeight = 200;
        }
        this.gridStyle = {
            'height': newHeight + 'px'
        };
    }
    configGridFixedHeight(gridStyleConfig) {
        const newHeight = gridStyleConfig.gridHeight;
        this.gridStyle = {
            'height': newHeight + 'px'
        };
    }
    configGridFullScreen(gridStyleConfig) {
        const headerHeight = this.uiConfig.pageHeaderHeight;
        const toolbarHeight = this.uiConfig.pageMargin;
        const footerHeight = this.gridConfig.showFooter ? this.uiConfig.gridFooterHeight : 0;
        const heighOffset = toolbarHeight + footerHeight;
        this.gridStyle = {
            'height': 'calc(100% - ' + headerHeight + 'px - ' + heighOffset + 'px)'
        };
        this.gridClass = 'dw-ag-grid-container-full-screen';
    }
    configRowBasedHeight(gridStyleConfig) {
        this.gridStyle = null;
        this.gridClass = null;
        this.domLayoutMode = 'autoHeight';
    }
    configPrintFriendly(gridStyleConfig) {
        this.gridStyle = null;
        this.gridClass = null;
        if (this.gridApi) {
            this.gridApi.setDomLayout('print');
        }
    }
}
DwAgGridComponent.ɵfac = function DwAgGridComponent_Factory(t) { return new (t || DwAgGridComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DwAgGridConfigConverterService), ɵngcc0.ɵɵdirectiveInject(DwConfigServiceToken), ɵngcc0.ɵɵdirectiveInject(DwUIConfigToken), ɵngcc0.ɵɵdirectiveInject(DwLoggingService), ɵngcc0.ɵɵdirectiveInject(DwAgGridDataActionService)); };
DwAgGridComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwAgGridComponent, selectors: [["dw-ag-grid"]], hostBindings: function DwAgGridComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function DwAgGridComponent_resize_HostBindingHandler($event) { return ctx.reset($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { filters: "filters", gridConfig: "gridConfig", data: "data", resolvedContext: "resolvedContext" }, outputs: { triggerAction: "triggerAction" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 12, consts: [[1, "dw-grid-no-footer", 3, "ngClass"], [1, "dw-ag-grid", "ag-theme-balham", "ag-theme-alpine", 3, "ngStyle", "gridOptions", "rowData", "rowModelType", "context", "domLayout", "cellContextMenu", "columnVisible", "columnPinned", "columnResized", "columnMoved", "sortChanged", "gridReady", "selectionChanged"], [3, "agGridDataSource", 4, "ngIf"], [3, "agGridDataSource"]], template: function DwAgGridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "ag-grid-angular", 1);
        ɵngcc0.ɵɵlistener("cellContextMenu", function DwAgGridComponent_Template_ag_grid_angular_cellContextMenu_2_listener($event) { return ctx.onAgGridStateChangeEvent($event); })("columnVisible", function DwAgGridComponent_Template_ag_grid_angular_columnVisible_2_listener($event) { return ctx.onAgGridStateChangeEvent($event); })("columnPinned", function DwAgGridComponent_Template_ag_grid_angular_columnPinned_2_listener($event) { return ctx.onAgGridStateChangeEvent($event); })("columnResized", function DwAgGridComponent_Template_ag_grid_angular_columnResized_2_listener($event) { return ctx.onAgGridStateChangeEvent($event); })("columnMoved", function DwAgGridComponent_Template_ag_grid_angular_columnMoved_2_listener($event) { return ctx.onAgGridStateChangeEvent($event); })("sortChanged", function DwAgGridComponent_Template_ag_grid_angular_sortChanged_2_listener($event) { return ctx.onAgGridStateChangeEvent($event); })("gridReady", function DwAgGridComponent_Template_ag_grid_angular_gridReady_2_listener($event) { return ctx.onGridReady($event); })("selectionChanged", function DwAgGridComponent_Template_ag_grid_angular_selectionChanged_2_listener($event) { return ctx.onAgGridGridSelectionChanged($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, DwAgGridComponent_dw_ag_grid_status_bar_3_Template, 1, 1, "dw-ag-grid-status-bar", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c102, ctx.gridConfig == null ? null : ctx.gridConfig.showFooter));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap(ctx.gridClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngStyle", ctx.gridStyle)("gridOptions", ctx.agGridConfig)("rowData", ctx.bindableData)("rowModelType", ctx.rowModelType)("context", ctx.context)("domLayout", ctx.domLayoutMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.gridConfig == null ? null : ctx.gridConfig.showFooter);
    } }, directives: [ɵngcc4.NgClass, ɵngcc38.AgGridAngular, ɵngcc4.NgStyle, ɵngcc4.NgIf, DwAgGridStatusBarComponent], encapsulation: 2 });
DwAgGridComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: DwAgGridConfigConverterService },
    { type: DwConfigService, decorators: [{ type: Inject, args: [DwConfigServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIConfigToken,] }] },
    { type: DwLoggingService },
    { type: DwAgGridDataActionService }
];
DwAgGridComponent.propDecorators = {
    gridConfig: [{ type: Input }],
    data: [{ type: Input }],
    triggerAction: [{ type: Output }],
    resolvedContext: [{ type: Input }],
    filters: [{ type: Input }],
    reset: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwAgGridComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'dw-ag-grid',
                template: "<div class=\"dw-grid-no-footer\" [ngClass]=\"{ 'dw-grid-no-footer': gridConfig?.showFooter }\">\r\n    <div [class]=\"gridClass\">\r\n        <ag-grid-angular [ngStyle]=\"gridStyle\" class=\"dw-ag-grid ag-theme-balham ag-theme-alpine\"\r\n            [gridOptions]=\"agGridConfig\" [rowData]=\"bindableData\" [rowModelType]=\"rowModelType\" [context]=\"context\"\r\n            [domLayout]=\"domLayoutMode\" (cellContextMenu)=\"onAgGridStateChangeEvent($event)\"\r\n            (columnVisible)=\"onAgGridStateChangeEvent($event)\" (columnPinned)=\"onAgGridStateChangeEvent($event)\"\r\n            (columnResized)=\"onAgGridStateChangeEvent($event)\" (columnMoved)=\"onAgGridStateChangeEvent($event)\"\r\n            (sortChanged)=\"onAgGridStateChangeEvent($event)\" (gridReady)=\"onGridReady($event)\"\r\n            (selectionChanged)=\"onAgGridGridSelectionChanged($event)\">\r\n        </ag-grid-angular>\r\n        <dw-ag-grid-status-bar [agGridDataSource]=\"agGridDataSource\" *ngIf=\"gridConfig?.showFooter\">\r\n\r\n        </dw-ag-grid-status-bar>\r\n    </div>\r\n</div>\r\n\r\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: DwAgGridConfigConverterService }, { type: DwConfigService, decorators: [{
                type: Inject,
                args: [DwConfigServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIConfigToken]
            }] }, { type: DwLoggingService }, { type: DwAgGridDataActionService }]; }, { triggerAction: [{
            type: Output
        }], filters: [{
            type: Input
        }], gridConfig: [{
            type: Input
        }], data: [{
            type: Input
        }], reset: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], resolvedContext: [{
            type: Input
        }] }); })();

class DevwareAgGridConfigProvider extends DwConfigProviderBase {
    configureAdditionalConfig(configName, config, dwCoreCore) {
        switch (configName) {
            case DwUiConfigName:
                this.configureUIConfig(config);
                break;
        }
    }
    configureUIConfig(dwUiConfig) {
        // Set defaults (These are used for auto-fit and full-screen mode for the grid)
        dwUiConfig.gridComponent = dwUiConfig.gridComponent || DwAgGridComponent;
        dwUiConfig.pageFooterHeight = dwUiConfig.pageFooterHeight || 70;
        dwUiConfig.pageHeaderHeight = dwUiConfig.pageHeaderHeight || 90;
        dwUiConfig.pageMargin = dwUiConfig.pageMargin || 25;
    }
}
function getDevwareAgGridConfigProvider() {
    return new DevwareAgGridConfigProvider();
}

class DevwareAGGridModule {
    static forRoot() {
        return {
            ngModule: DevwareAGGridModule,
            imports: []
        };
    }
}
DevwareAGGridModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareAGGridModule });
DevwareAGGridModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareAGGridModule_Factory(t) { return new (t || DevwareAGGridModule)(); }, providers: [
        DwAgGridConfigConverterService
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            ReactiveFormsModule,
            TabViewModule,
            //DevwareCoreModule.forChild(getDevwareAgGridConfigProvider),
            DevwareCoreModule,
            DevwareUIModule,
            DevwareUIMetaDataModule,
            AgGridModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareAGGridModule, { declarations: function () { return [DwAgGridComponent, DwAgActionButtonsComponent, DwAgLinkColumnComponent, DwAgCustomColumnComponent, DwAgGridStatusBarComponent, DwEditableColumnComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        TabViewModule, DevwareCoreModule, DevwareUIModule, DevwareUIMetaDataModule, AgGridModule]; }, exports: function () { return [DwAgGridComponent, DwAgActionButtonsComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareAGGridModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwAgGridComponent,
                    DwAgActionButtonsComponent,
                    DwAgLinkColumnComponent,
                    DwAgCustomColumnComponent,
                    DwAgGridStatusBarComponent,
                    DwEditableColumnComponent
                ],
                providers: [
                    DwAgGridConfigConverterService
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    ReactiveFormsModule,
                    TabViewModule,
                    //DevwareCoreModule.forChild(getDevwareAgGridConfigProvider),
                    DevwareCoreModule,
                    DevwareUIModule,
                    DevwareUIMetaDataModule,
                    AgGridModule
                ],
                exports: [
                    DwAgGridComponent,
                    DwAgActionButtonsComponent
                ],
                entryComponents: [
                    DwAgGridComponent,
                    DwAgActionButtonsComponent,
                    DwAgLinkColumnComponent,
                    DwAgCustomColumnComponent
                ]
            }]
    }], null, null); })();

;

const DwChartsConfigName = 'ChartsConfig';
const DwChartsConfigToken = new InjectionToken(DwChartsConfigName);

const DwChartColors = [
    '#519DE9',
    '#7CC674',
    '#F0AB00',
    '#C9190B',
    '#06C',
    '#38812F',
    '#8481DD',
    //'#EF9234',
    '#EC7A08',
    '#009596',
];
const DwChartColors2 = [
    '#20a4f3ff',
    '#f18f01ff',
    '#80ff72ff',
    // '#941c2fff',
    '#d43d51',
    '#3d315bff',
    '#846a6a', '#008f3c', '#aba361', '#5e239d', '#bccce0',
    '#00876c',
    '#44946d',
    '#68a071',
    '#88ac77',
    '#a5b781',
    '#c1c38e',
    '#dccf9e',
    '#dabb84',
    '#daa66d',
    '#da905c',
    '#da7752',
    '#d95c4e',
    '#d43d51'
];
const DwChartColors3 = [
    '#00876c',
    '#44946d',
    '#68a071',
    '#88ac77',
    '#a5b781',
    '#c1c38e',
    '#dccf9e',
    '#dabb84',
    '#daa66d',
    '#da905c',
    '#da7752',
    '#d95c4e',
    '#d43d51'
];
//         --carrot-orange: #f18f01ff;
// --celestial-blue: #20a4f3ff;
// --screamin-green: #80ff72ff;
// --burgundy: #941c2fff;
// --space-cadet: #3d315bff;

class DwChartsConfigDefaults {
    constructor() {
        this.defaultColors = [...DwChartColors, ...DwChartColors2, ...DwChartColors, ...DwChartColors2];
    }
}

var DwChartTypes;
(function (DwChartTypes) {
    DwChartTypes[DwChartTypes["bar"] = 0] = "bar";
    DwChartTypes[DwChartTypes["line"] = 1] = "line";
    DwChartTypes[DwChartTypes["pie"] = 2] = "pie";
    DwChartTypes[DwChartTypes["column"] = 3] = "column";
    DwChartTypes[DwChartTypes["doughnut"] = 4] = "doughnut";
    DwChartTypes[DwChartTypes["polarArea"] = 5] = "polarArea";
    DwChartTypes[DwChartTypes["radar"] = 6] = "radar";
})(DwChartTypes || (DwChartTypes = {}));

class DwChartBuilderService {
    constructor(dwChartsConfig) {
        this.dwChartsConfig = dwChartsConfig;
    }
    buildChartConfig(chartPreference, data) {
        const chartConfig = {
            chartType: this.convertChartType(chartPreference.chartType),
            chartOptions: {
                title: {
                    display: chartPreference.showChartTitle,
                    text: chartPreference.chartTitle,
                    color: '#ffffff',
                    fontSize: 18,
                    position: 'top'
                },
                legend: {
                    display: !chartPreference.hideLegend,
                    position: 'bottom'
                },
            },
            chartData: {
                labels: this.getDataForSeries(chartPreference.categoryField, data, chartPreference.maxItemsToShow),
                datasets: []
            }
        };
        let hasY2Axis = false;
        for (const series of chartPreference.series) {
            const dataSet = {
                type: this.convertChartType(series.chartType),
                label: series.legendDisplay,
                backgroundColor: series.backgroundColor || series.borderColor,
                borderColor: series.borderColor || series.backgroundColor,
                fill: false,
                data: this.getDataForSeries(series.dataField, data, chartPreference.maxItemsToShow)
            };
            if (series.alternateColors) {
                dataSet.backgroundColor = this.dwChartsConfig.defaultColors;
            }
            if (series.axis === 'y2') {
                hasY2Axis = true;
                dataSet.yAxisID = 'y2';
            }
            chartConfig.chartData.datasets.push(dataSet);
        }
        if (hasY2Axis) {
            chartConfig.chartOptions.scales = {
                yAxes: [{
                        type: 'linear',
                        position: 'left',
                        // options: {
                        //     ticks: {
                        //         beginAtZero: true,
                        //     }
                        // },
                        ticks: {
                            beginAtZero: true,
                        },
                    },
                    {
                        type: 'linear',
                        position: 'right',
                        id: 'y2',
                        ticks: {
                            beginAtZero: true,
                            key: 'Anthony-test-3'
                        },
                        gridLines: {
                            color: 'green',
                            display: false,
                        }
                    }
                ]
            };
        }
        else {
            this.setupBarColumnSingleAxis(chartPreference, chartConfig);
        }
        return chartConfig;
    }
    setupBarColumnSingleAxis(chartPreference, chartConfig) {
        switch (chartPreference.chartType) {
            case DwChartTypes.bar:
                chartConfig.chartOptions.scales = {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ]
                };
                break;
            case DwChartTypes.column:
                chartConfig.chartOptions.scales = {
                    xAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ]
                };
                break;
        }
    }
    convertChartType(chartType) {
        switch (chartType) {
            case DwChartTypes.bar:
                return 'bar';
            case DwChartTypes.line:
                return 'line';
            case DwChartTypes.pie:
                return 'pie';
            case DwChartTypes.column:
                //return 'bar';
                return 'horizontalBar';
            case DwChartTypes.doughnut:
                return 'doughnut';
            case DwChartTypes.polarArea:
                return 'polarArea';
            case DwChartTypes.radar:
                return 'radar';
        }
    }
    buildGridPreferences(chartPreferences, query) {
        var _a, _b, _c, _d;
        const gridPreferences = new DwMetaDataGridPreferences();
        gridPreferences.passCurrentDataSource = false;
        gridPreferences.showDisplayProperties = (_a = query === null || query === void 0 ? void 0 : query.FieldSettings) === null || _a === void 0 ? void 0 : _a.LoadAllLookupDisplayFields;
        gridPreferences.showFooter = true;
        gridPreferences.loadTotalRowCount = true;
        gridPreferences.hideAdd = true;
        gridPreferences.hideEditButton = true;
        gridPreferences.hideDeleteButton = true;
        gridPreferences.hideRefresh = true;
        gridPreferences.hideExport = false;
        gridPreferences.showFilter = true;
        gridPreferences.showFilterOnLoad = true;
        gridPreferences.gridStyle = {
            gridHeight: '300',
            gridHeightMode: DwGridHeightMode.fixedHeight,
            gridStyleName: 'Simple',
        };
        const view = {
            columnPreferences: [],
            actionPreferences: {},
            display: 'Default',
            filters: null,
            item: query.RootTable,
            useCustomActions: true,
            isDefault: true,
            query: query,
            includeAllFields: true
        };
        gridPreferences.views = [view];
        if ((_b = chartPreferences.gridPreferences) === null || _b === void 0 ? void 0 : _b.columnPreferences) {
            view.columnPreferences = chartPreferences.gridPreferences.columnPreferences;
        }
        else {
            // Add Columns
            view.columnPreferences.push({
                field: chartPreferences.categoryField,
                label: chartPreferences.categoryDisplay,
                width: ((_c = chartPreferences.gridPreferences) === null || _c === void 0 ? void 0 : _c.categoryColumnWidth) || 200,
                columnIndex: 0,
            });
            // Add Series Field
            for (const series of chartPreferences.series) {
                view.columnPreferences.push({
                    field: series.dataField,
                    label: series.legendDisplay,
                    width: ((_d = chartPreferences.gridPreferences) === null || _d === void 0 ? void 0 : _d.aggregateColumnWidth) || 100,
                    columnIndex: view.columnPreferences.length,
                });
            }
        }
        return gridPreferences;
    }
    getDataForSeries(fieldName, data, maxItemsToShow) {
        const seriesData = [];
        if (maxItemsToShow) {
            data = [...data];
            data.length = maxItemsToShow;
        }
        for (const dataItem of data) {
            seriesData.push(dataItem[fieldName]);
        }
        return seriesData;
    }
}
DwChartBuilderService.ɵfac = function DwChartBuilderService_Factory(t) { return new (t || DwChartBuilderService)(ɵngcc0.ɵɵinject(DwChartsConfigToken)); };
DwChartBuilderService.ɵprov = ɵɵdefineInjectable({ factory: function DwChartBuilderService_Factory() { return new DwChartBuilderService(ɵɵinject(DwChartsConfigToken)); }, token: DwChartBuilderService, providedIn: "root" });
DwChartBuilderService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DwChartsConfigToken,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwChartBuilderService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DwChartsConfigToken]
            }] }]; }, null); })();

class DwChartTileComponent {
    constructor(dwChartBuilderService) {
        this.dwChartBuilderService = dwChartBuilderService;
        this.dataSelected = new EventEmitter();
        this.hideToggle = false;
        this.showChart = true;
    }
    ngOnChanges(changes) {
        this.setupChart();
        this.setupContainer();
    }
    ngOnInit() {
        this.setupChart();
        this.setupContainer();
    }
    ngAfterContentInit() {
    }
    toggleShowChart() {
        this.showChart = !this.showChart;
    }
    onDataSelect(event) {
        var _a, _b;
        const itemIndex = (_a = event === null || event === void 0 ? void 0 : event.element) === null || _a === void 0 ? void 0 : _a._index;
        const datasetIndex = (_b = event === null || event === void 0 ? void 0 : event.element) === null || _b === void 0 ? void 0 : _b._datasetIndex;
        if (itemIndex >= 0) {
            const datset = event === null || event === void 0 ? void 0 : event.dataset[itemIndex];
            const dataItem = this.data[itemIndex];
            const series = this.chartPreferences.series[datasetIndex];
            const dwEvent = {
                data: dataItem,
                series: series,
                dataValue: dataItem[series.dataField],
                category: dataItem[this.chartPreferences.categoryField],
                categoryValue: dataItem[this.chartPreferences.categoryValueField],
                browserEvent: event.originalEvent
            };
            this.dataSelected.emit(dwEvent);
        }
    }
    onGridEvent(event) {
        const dataItem = event.eventData;
        const series = this.chartPreferences.series.find(s => s.dataField === event.eventColumn.field);
        const dataValue = dataItem[event.eventColumn.field];
        const dwEvent = {
            data: dataItem,
            series: series,
            dataValue: dataValue,
            category: dataItem[this.chartPreferences.categoryField],
            categoryValue: dataItem[this.chartPreferences.categoryValueField],
            browserEvent: event.browserEvent
        };
        this.dataSelected.emit(dwEvent);
    }
    setupChart() {
        if (!this.chartPreferences || !this.data) {
            return;
        }
        if ((this.data.length === 1 && this.chartPreferences.chartType != DwChartTypes.pie) || this.chartPreferences.showGridFirst) {
            this.showChart = false;
        }
        if (this.chartPreferences.hideChartDataToggle) {
            this.hideToggle = true;
        }
        this.chartConfig = this.dwChartBuilderService.buildChartConfig(this.chartPreferences, this.data);
        this.gridPreferences = this.dwChartBuilderService.buildGridPreferences(this.chartPreferences, this.query);
        this.columnPreferences = this.gridPreferences.views[0].columnPreferences;
    }
    setupGrid() {
    }
    setupContainer() {
        var _a;
        // Allow override of container options
        if (this.containerOptions) {
            this.finalContainerOptions = this.containerOptions;
        }
        else {
            this.finalContainerOptions = {
                useContainerStyling: true,
                containerAllowCollapse: false,
            };
        }
        this.finalContainerOptions.showTitle = (_a = this.chartPreferences) === null || _a === void 0 ? void 0 : _a.showContainerTitle;
        this.finalContainerOptions.containerHeaderBackgroundColor = 'blue';
    }
}
DwChartTileComponent.ɵfac = function DwChartTileComponent_Factory(t) { return new (t || DwChartTileComponent)(ɵngcc0.ɵɵdirectiveInject(DwChartBuilderService)); };
DwChartTileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwChartTileComponent, selectors: [["dw-chart-tile"]], inputs: { chartPreferences: "chartPreferences", data: "data", containerOptions: "containerOptions", query: "query", additionalText: "additionalText" }, outputs: { dataSelected: "dataSelected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c5, decls: 1, vars: 1, consts: [[3, "options", 4, "ngIf"], [3, "options"], ["header", ""], ["class", "pull-right", 4, "ngIf"], ["body", "", 1, "inner-container"], ["class", "tile-no-data-container", 4, "ngIf"], [4, "ngIf"], [1, "pull-right"], ["title", "See table", 1, "fa", "fa-table", "mr-2", 3, "hidden", "click"], ["title", "See chart", 1, "fa", "fa-chart-bar", "mr-1", 3, "hidden", "click"], [1, "tile-no-data-container"], [1, "no-data-label"], ["class", "chart-container", 4, "ngIf"], [1, "additional-text"], [1, "chart-container"], [3, "type", "data", "query", "options", "onDataSelect"], [3, "item", "query", "columnPreferences", "loadCount", "customizeActions", "gridEvent"]], template: function DwChartTileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DwChartTileComponent_dw_container_0_Template, 7, 5, "dw-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.chartPreferences);
    } }, directives: [ɵngcc4.NgIf, DwContainerComponent, DwQuickGrid], styles: [""] });
DwChartTileComponent.ctorParameters = () => [
    { type: DwChartBuilderService }
];
DwChartTileComponent.propDecorators = {
    chartPreferences: [{ type: Input }],
    data: [{ type: Input }],
    containerOptions: [{ type: Input }],
    query: [{ type: Input }],
    additionalText: [{ type: Input }],
    dataSelected: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwChartTileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-chart-tile',
                template: "<dw-container [options]=\"finalContainerOptions\" *ngIf=\"chartPreferences\">\r\n    <div header>\r\n        {{chartPreferences?.containerTitle}}\r\n\r\n        <div class=\"pull-right\" *ngIf=\"chartPreferences.gridPreferences?.showGrid && !hideToggle\">\r\n            <i class=\"fa fa-table mr-2\" title=\"See table\" [hidden]=\"!showChart\" (click)=\"toggleShowChart()\"></i>\r\n            <i class=\"fa fa-chart-bar mr-1\" title=\"See chart\" [hidden]=\"showChart\" (click)=\"toggleShowChart()\"></i>\r\n        </div>\r\n    </div>\r\n    <div body class=\"inner-container\">\r\n        <div *ngIf=\"data?.length==0\" class=\"tile-no-data-container\">\r\n            <div class=\"no-data-label\">No Data</div>\r\n        </div>\r\n        <ng-container *ngIf=\"data?.length>0\">\r\n\r\n            <div class=\"chart-container\" *ngIf=\"chartConfig && showChart\">\r\n                <p-chart [type]=\"chartConfig?.chartType\" [data]=\"chartConfig?.chartData\" [query]=\"query\"\r\n                    [options]=\"chartConfig?.chartOptions\" (onDataSelect)=\"onDataSelect($event)\"></p-chart>\r\n            </div>\r\n            <div *ngIf=\"!showChart\">\r\n                <dw-quick-grid [item]=\"query.RootTable\" [query]=\"query\" [columnPreferences]=\"columnPreferences\"\r\n                    [loadCount]=\"loadCount\" [customizeActions]=\"true\" (gridEvent)=\"onGridEvent($event)\"></dw-quick-grid>\r\n            </div>\r\n\r\n            <div class=\"additional-text\">{{additionalText}}</div>\r\n\r\n            <ng-content>\r\n\r\n            </ng-content>\r\n        </ng-container>\r\n    </div>\r\n</dw-container>\r\n\r\n\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: DwChartBuilderService }]; }, { dataSelected: [{
            type: Output
        }], chartPreferences: [{
            type: Input
        }], data: [{
            type: Input
        }], containerOptions: [{
            type: Input
        }], query: [{
            type: Input
        }], additionalText: [{
            type: Input
        }] }); })();

class DwMiniTileComponent {
    constructor() {
        this.clickEvent = new EventEmitter();
    }
    ngOnChanges(changes) {
        this.setupContainer();
    }
    ngOnInit() {
        this.setupContainer();
    }
    setupContainer() {
        var _a, _b;
        // Allow override of container options
        if (this.containerOptions) {
            this.finalContainerOptions = this.containerOptions;
        }
        else {
            this.finalContainerOptions = {
                useContainerStyling: true,
                containerAllowCollapse: false,
            };
        }
        this.finalContainerOptions.showTitle = true;
        if (((_a = this.tileConfig) === null || _a === void 0 ? void 0 : _a.showContainerTitle) === false) {
            this.finalContainerOptions.showTitle = false;
        }
        this.finalContainerOptions.containerHeaderBackgroundColor = ((_b = this.tileConfig) === null || _b === void 0 ? void 0 : _b.headerColor) || 'green';
    }
}
DwMiniTileComponent.ɵfac = function DwMiniTileComponent_Factory(t) { return new (t || DwMiniTileComponent)(); };
DwMiniTileComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwMiniTileComponent, selectors: [["dw-mini-tile"]], inputs: { tileConfig: "tileConfig", containerOptions: "containerOptions" }, outputs: { clickEvent: "clickEvent" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 9, vars: 5, consts: [["header", ""], ["body", "", 1, "inner-container"], [1, "icon"], ["class2", "fa fa-usd-circle dw-green fa-3x", 1, "fa-3x"], [1, "title-text"], ["class", "additional-text", 4, "ngIf"], [1, "additional-text"]], template: function DwMiniTileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-container");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, DwMiniTileComponent_div_8_Template, 2, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.tileConfig == null ? null : ctx.tileConfig.containerTitle, " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassMap(ctx.tileConfig == null ? null : ctx.tileConfig.iconClass);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.tileConfig == null ? null : ctx.tileConfig.tileText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tileConfig == null ? null : ctx.tileConfig.additionalText);
    } }, directives: [DwContainerComponent, ɵngcc4.NgIf], styles: [".inner-container[_ngcontent-%COMP%]{text-align:center;width:100%}.icon[_ngcontent-%COMP%]{font-size:2em;width:100%}.title-text[_ngcontent-%COMP%]{font-size:20px;font-weight:700;width:100%}.additional-text[_ngcontent-%COMP%]{font-size:smaller;font-weight:400;margin-top:15px;width:100%}"] });
DwMiniTileComponent.ctorParameters = () => [];
DwMiniTileComponent.propDecorators = {
    tileConfig: [{ type: Input }],
    containerOptions: [{ type: Input }],
    clickEvent: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwMiniTileComponent, [{
        type: Component,
        args: [{
                selector: 'dw-mini-tile',
                template: "<dw-container>\r\n    <div header>\r\n        {{tileConfig?.containerTitle}}\r\n    </div>\r\n    <div body class=\"inner-container\">\r\n        <div class=\"icon\"><i [class]=\"tileConfig?.iconClass\" class=\"fa-3x\" class2=\"fa fa-usd-circle dw-green fa-3x\"></i></div>\r\n        <div class=\"title-text\">{{ tileConfig?.tileText }}</div>\r\n        <div class=\"additional-text\" *ngIf=\"tileConfig?.additionalText\">{{tileConfig?.additionalText}}</div>\r\n    </div>\r\n</dw-container>\r\n",
                styles: [".inner-container{text-align:center;width:100%}.icon{font-size:2em;width:100%}.title-text{font-size:20px;font-weight:700;width:100%}.additional-text{font-size:smaller;font-weight:400;margin-top:15px;width:100%}"]
            }]
    }], function () { return []; }, { clickEvent: [{
            type: Output
        }], tileConfig: [{
            type: Input
        }], containerOptions: [{
            type: Input
        }] }); })();

class DevwareChartsModule {
}
DevwareChartsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareChartsModule });
DevwareChartsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareChartsModule_Factory(t) { return new (t || DevwareChartsModule)(); }, providers: [
        {
            provide: DwChartsConfigToken,
            useFactory(configService) {
                const chartsConfig = configService.getConfig(DwChartsConfigName, new DwChartsConfigDefaults());
                return chartsConfig;
            },
            deps: [DwConfigServiceToken]
        },
    ], imports: [[
            CommonModule,
            FormsModule,
            TabViewModule,
            DevwareCoreModule,
            DevwareUIModule,
            DevwareOrmModule,
            DevwareUIMetaDataModule,
            RouterModule,
            ReactiveFormsModule,
            FormsModule,
            InputSwitchModule,
            AccordionModule,
            ListboxModule,
            OrderListModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareChartsModule, { declarations: function () { return [DwChartTileComponent, DwMiniTileComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        TabViewModule, DevwareCoreModule, DevwareUIModule, DevwareOrmModule, DevwareUIMetaDataModule, RouterModule,
        ReactiveFormsModule,
        FormsModule,
        InputSwitchModule,
        AccordionModule,
        ListboxModule,
        OrderListModule]; }, exports: function () { return [DwChartTileComponent, DwMiniTileComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareChartsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwChartTileComponent,
                    DwMiniTileComponent,
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    TabViewModule,
                    DevwareCoreModule,
                    DevwareUIModule,
                    DevwareOrmModule,
                    DevwareUIMetaDataModule,
                    RouterModule,
                    ReactiveFormsModule,
                    FormsModule,
                    InputSwitchModule,
                    AccordionModule,
                    ListboxModule,
                    OrderListModule
                ],
                providers: [
                    {
                        provide: DwChartsConfigToken,
                        useFactory(configService) {
                            const chartsConfig = configService.getConfig(DwChartsConfigName, new DwChartsConfigDefaults());
                            return chartsConfig;
                        },
                        deps: [DwConfigServiceToken]
                    },
                ],
                exports: [
                    DwChartTileComponent,
                    DwMiniTileComponent
                ]
            }]
    }], null, null); })();

class ChartDataRequest {
    constructor() {
        this.chartType = DwChartTypes.pie;
    }
}
class ChartDataRequestSeries {
    constructor() {
        this.chartType = DwChartTypes.pie;
    }
}
function isChartOrderbyField(obj) {
    return obj.field;
}

class DwChartRepositoryService {
    constructor(dwOrmDataService, dwMetaDataService, dwChartsConfig, dwTemplateUtil) {
        this.dwOrmDataService = dwOrmDataService;
        this.dwMetaDataService = dwMetaDataService;
        this.dwChartsConfig = dwChartsConfig;
        this.dwTemplateUtil = dwTemplateUtil;
    }
    closeGrid() {
        DwChartRepositoryService.closeGridSubject.next();
    }
    getCloseGridObservable() {
        return DwChartRepositoryService.closeGridSubject.asObservable();
    }
    buildGridFilters(event, chartDataQueryResult, chartFilters) {
        var _a;
        const filter = {
            groupChartFilters: chartDataQueryResult.query.Filter
        };
        filter.groupChartFilters.Op = 'AND';
        const categoryField = this.getFieldName(chartDataQueryResult.chartDataRequest.categoryField, true);
        filter[categoryField] = event.categoryValue;
        if (chartDataQueryResult.chartDataRequest.chartType != DwChartTypes.pie && ((_a = chartDataQueryResult.chartDataRequest.series) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            const series = this.findSeries(event, chartDataQueryResult);
            if (series) {
                const dataFieldName = this.getFieldName(series.dataField, true);
                // Find aggregate Field in query
                const aggrField = chartDataQueryResult.query.FieldSettings.IncludeFields.find(f => f.FieldAlias == dataFieldName);
                if (aggrField === null || aggrField === void 0 ? void 0 : aggrField.FullFieldName) {
                    filter[aggrField.FullFieldName] = {
                        greaterThan: 0
                    };
                }
                //filter[dataFieldName] = event.dataValue;
            }
        }
        return filter;
    }
    findSeries(event, chartDataQueryResult) {
        var _a;
        const index = (_a = chartDataQueryResult.chartPreferences.series) === null || _a === void 0 ? void 0 : _a.findIndex(s => { var _a; return s.dataField == ((_a = event.series) === null || _a === void 0 ? void 0 : _a.dataField); });
        if (index >= 0) {
            const series = chartDataQueryResult.chartDataRequest.series[index];
            return series;
        }
        return null;
    }
    // getFinancials(filters: ChartFilters, additionalFilterOptions: ChartAdditionalFilterOptions): Observable<DwDataQueryResult> {
    //     return this.getFinancialsQuery(filters, additionalFilterOptions)
    //         .pipe(mergeMap(query => {
    //             return this.executeQueryData(query, null);
    //         }));
    // }
    // getFinancialSummary(filters: ChartFilters, additionalFilterOptions: ChartAdditionalFilterOptions): Observable<DwDataQueryResult> {
    //     const newFilters = { ...filters };
    //     // Remove any year/month filters since we want a multi-year summary here
    //     newFilters.year = null;
    //     newFilters.month = null;
    //     return this.getFinancialSummaryQuery(newFilters, additionalFilterOptions)
    //         .pipe(mergeMap(query => {
    //             return this.executeQueryData(query, null);
    //         }));
    // }
    setupCharts(chartDataRequest, chartFilters) {
        const chartRequestObs = [];
        for (let chartRequest of chartDataRequest) {
            chartRequestObs.push(this.setupChart(chartRequest, chartFilters));
        }
        return combineLatest(chartRequestObs)
            .pipe(map(results => {
            return results;
        }));
    }
    setupChart(chartDataRequest, chartFilters) {
        return this.getChartData(chartDataRequest, chartFilters)
            .pipe(map(result => {
            return {
                data: result.data,
                query: result.query,
                queryMetaData: result.queryMetaData,
                chartPreferences: this.buildChartPreferences(result, chartDataRequest),
                chartDataRequest: chartDataRequest
            };
        }));
    }
    setupTiles(tileRequests, chartDataQueryResults, summaryData, chartFilters) {
        if (!tileRequests || tileRequests.length == 0 || !chartDataQueryResults || !summaryData) {
            return [];
        }
        const tileConfigs = [];
        for (let tileRequest of tileRequests) {
            const tileConfig = this.setupTile(tileRequest, chartDataQueryResults, summaryData, chartFilters);
            if (tileConfig) {
                tileConfigs.push(tileConfig);
            }
        }
        return tileConfigs;
    }
    setupTile(tileRequest, chartDataQueryResults, summaryData, chartFilters) {
        const tileData = this.getTileData(tileRequest, chartDataQueryResults, summaryData, chartFilters);
        if (!tileData) {
            return;
        }
        let valueData = tileData[tileRequest.dataField];
        let formatedValueData = valueData;
        if (valueData == null) {
            if (tileRequest.hideIfNull)
                return;
            valueData = 0;
        }
        if (tileRequest.isCurrency) {
            formatedValueData = this.formatNumeric(valueData || 0, 0, true, false);
        }
        // const monthDisplay = tileData[this.getFinancialFields().monthDisplay] || chartFilters.month;
        const monthDisplay = tileData[tileRequest.displayField || 'NONE'] || chartFilters.month;
        const templateData = Object.assign({ year: chartFilters.year || 'All', month: chartFilters.month, monthDisplay: monthDisplay }, tileData);
        const containerTile = this.dwTemplateUtil.processTemplate(tileRequest.headerTemplate, templateData);
        const tileConfig = {
            containerTitle: containerTile,
            showContainerTitle: true,
            headerColor: tileRequest.headerColor,
            additionalText: tileRequest.additionalText,
            iconClass: tileRequest.iconClass,
            tileText: formatedValueData,
            toolTip: tileRequest.toolTip
        };
        return tileConfig;
    }
    getTileData(tileRequest, chartDataQueryResults, summaryData, chartFilters) {
        //const fields = this.getFinancialFields();
        var _a;
        // TODO: These need to come from the tile request
        const yearField = 'year';
        const monthField = 'month';
        let data;
        switch (tileRequest.type) {
            case 'year':
                data = summaryData === null || summaryData === void 0 ? void 0 : summaryData.find(d => d[yearField] === chartFilters.year);
                break;
            case "month":
                const dataQueryResult = chartDataQueryResults[tileRequest.chartDataIndex || 0];
                data = dataQueryResult === null || dataQueryResult === void 0 ? void 0 : dataQueryResult.data.find(d => d[monthField] === chartFilters.month && d[yearField] === chartFilters.year);
                if (!data && ((_a = dataQueryResult === null || dataQueryResult === void 0 ? void 0 : dataQueryResult.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    // Use the first row of data if we can't find the month/year
                    data = dataQueryResult === null || dataQueryResult === void 0 ? void 0 : dataQueryResult.data[0];
                }
        }
        return data;
    }
    processTemplate(tileRequest, chartDataQueryResults, summaryData, chartFilters) {
        var _a;
        // TODO: These need to come from the tile request
        const yearField = 'year';
        const monthField = 'month';
        let data;
        switch (tileRequest.type) {
            case 'year':
                data = summaryData === null || summaryData === void 0 ? void 0 : summaryData.find(d => d[yearField] === chartFilters.year);
                break;
            case "month":
                const dataQueryResult = chartDataQueryResults[tileRequest.chartDataIndex || 0];
                data = dataQueryResult === null || dataQueryResult === void 0 ? void 0 : dataQueryResult.data.find(d => d[monthField] === chartFilters.month && d[yearField] === chartFilters.year);
                if (!data && ((_a = dataQueryResult === null || dataQueryResult === void 0 ? void 0 : dataQueryResult.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    // Use the first row of data if we can't find the month/year
                    data = dataQueryResult === null || dataQueryResult === void 0 ? void 0 : dataQueryResult.data[0];
                }
        }
        return data;
    }
    // setupPieChart(filters: ChartFilters, additionalFilterOptions: ChartAdditionalFilterOptions, title: string, categoryField: string, dataFieldName: string, categoryDisplayField?: string, hideLegend?: boolean): Observable<ChartDataQueryResult> {
    //     const categoryFieldName = this.getFieldName(categoryField, false);
    //     return this.getPieChartData(filters, additionalFilterOptions, categoryFieldName)
    //         .pipe(map(result => {
    //             const attr = result.queryMetaData.Attributes.find(a => a.AttributeName == categoryFieldName);
    //             return {
    //                 data: result.data,
    //                 query: result.query,
    //                 queryMetaData: result.queryMetaData,
    //                 chartPreferences: this.buildPieChartPreferences(result, title, categoryDisplayField || attr?.DisplayAttributeName || categoryFieldName, dataFieldName, hideLegend)
    //             } as ChartDataQueryResult;
    //         }));
    // }
    getChartData(chartDataRequest, chartFilters) {
        // Merge Filters
        const finalFilters = Object.assign(Object.assign({}, chartDataRequest.filters), chartFilters);
        const categoryFieldName = this.getFieldName(chartDataRequest.categoryField, true);
        // Remove any year/month filters since we want a multi-year summary here
        //  finalFilters.month = null;
        return this.buildBaseQuery(chartDataRequest.queryRequest, finalFilters, chartDataRequest.additionalFilterOptions)
            .pipe(mergeMap(result => {
            const query = result.query;
            const qh = new DwQueryHelper();
            // Clearing all fields so we can create a clean aggregate query
            qh.clearAllFields(query);
            query.AddField(categoryFieldName);
            for (const groupField of chartDataRequest.additionalGroupingFields || []) {
                query.AddField(this.getFieldName(groupField, true));
            }
            if (!chartDataRequest.includeBlank) {
                query.AddFilterAnd(qh.filters.IsNotBlank(categoryFieldName));
            }
            // Add a Count field by default (most common type)
            query.AddField({
                FieldType: DwFieldType.Aggregate,
                AggregateFunction: DwFieldAggregate.Count,
                FieldAlias: 'Count'
            });
            for (const orderField of chartDataRequest.orderByFields || []) {
                let descending = false;
                let fieldName = "";
                if (isChartOrderbyField(orderField)) {
                    fieldName = this.getFieldName(orderField.field, true);
                    descending = orderField.isDescending;
                }
                else {
                    fieldName = this.getFieldName(orderField, true);
                }
                query.OrderBy(fieldName, descending);
            }
            return this.executeQueryData(query, result.queryMetaData);
        }));
    }
    buildChartPreferences(dataQueryResult, chartDataRequest) {
        let hideLegend = chartDataRequest.hideLegend || false;
        if (!hideLegend && chartDataRequest.chartType == DwChartTypes.pie) {
            hideLegend = dataQueryResult.data.length > (chartDataRequest.maxLegendItems || 5);
        }
        const categoryFieldName = this.getFieldName(chartDataRequest.categoryField, false);
        const categoryDisplayFieldName = this.getFieldName(chartDataRequest.categoryDisplayField, false);
        const attr = dataQueryResult.queryMetaData.Attributes.find(a => a.AttributeName == categoryFieldName);
        const finalCategoryFieldName = categoryDisplayFieldName || (attr === null || attr === void 0 ? void 0 : attr.DisplayAttributeName) || categoryFieldName;
        const categoryValueFieldName = (attr === null || attr === void 0 ? void 0 : attr.AttributeName) || categoryFieldName || categoryDisplayFieldName;
        const prefs = {
            chartType: chartDataRequest.chartType,
            containerTitle: `${chartDataRequest.title}`,
            showContainerTitle: true,
            categoryField: finalCategoryFieldName,
            categoryValueField: categoryValueFieldName,
            categoryDisplay: chartDataRequest.categoryDisplayOverride || (attr === null || attr === void 0 ? void 0 : attr.AttributeDisplay),
            gridPreferences: {
                showGrid: true,
                categoryColumnWidth: 300,
            },
            hideLegend: hideLegend,
            series: []
        };
        const series = chartDataRequest.series || [];
        if (series.length == 0) {
            if (!chartDataRequest.dataField) {
                throw new Error('Data field is required when series is not specified');
            }
            prefs.series.push({
                chartType: chartDataRequest.chartType,
                dataField: this.getFieldName(chartDataRequest.dataField, false),
                borderColor: 'white',
                alternateColors: true,
                alternateColorStart: 4,
            });
        }
        else {
            for (let seriesItem of chartDataRequest.series) {
                const index = chartDataRequest.series.indexOf(seriesItem);
                const chartType = seriesItem.chartType || chartDataRequest.chartType;
                const series = {
                    chartType: chartType,
                    dataField: this.getFieldName(seriesItem.dataField, false),
                    legendDisplay: seriesItem.legendDisplay,
                    borderColor: 'white',
                    alternateColors: chartType == DwChartTypes.pie,
                    alternateColorStart: 4,
                    axis: seriesItem.axis
                };
                switch (chartType) {
                    case DwChartTypes.pie:
                        series.alternateColors = true;
                        series.alternateColorStart = index;
                        break;
                    case DwChartTypes.line:
                        series.borderColor = seriesItem.color || this.dwChartsConfig.defaultColors[index];
                        break;
                    case DwChartTypes.bar:
                    case DwChartTypes.column:
                        series.backgroundColor = seriesItem.color || this.dwChartsConfig.defaultColors[index];
                        break;
                }
                prefs.series.push(series);
            }
        }
        return prefs;
    }
    buildPieChartPreferences(dataQueryResult, title, categoryField, dataFieldName, hideLegend) {
        if (hideLegend == null) {
            hideLegend = dataQueryResult.data.length > 5;
        }
        const prefs = {
            chartType: DwChartTypes.pie,
            containerTitle: `${title}`,
            showContainerTitle: true,
            categoryField: categoryField,
            //categoryDisplay: 'Checkride Type',
            gridPreferences: {
                showGrid: true,
                categoryColumnWidth: 300,
            },
            hideLegend: hideLegend,
            series: [
                {
                    chartType: DwChartTypes.pie,
                    dataField: dataFieldName,
                    borderColor: 'white',
                    alternateColors: true,
                    alternateColorStart: 4,
                }
            ]
        };
        return prefs;
    }
    // getPieChartData(filters: ChartFilters, additionalFilterOptions: ChartAdditionalFilterOptions, categoryField: string, includeBlank: boolean = false): Observable<DwDataQueryResult> {
    //     const newFilters = { ...filters };
    //     // Remove any year/month filters since we want a multi-year summary here
    //     newFilters.month = null;
    //     return this.buildCheckRideBaseQuery(filters, additionalFilterOptions)
    //         .pipe(mergeMap(result => {
    //             const query = result.query;;
    //             query.AddField(categoryField);
    //             const qh = new DwQueryHelper();
    //             if (!includeBlank) {
    //                 query.AddFilterAnd(qh.filters.IsNotBlank(categoryField));
    //             }
    //             //  const attribute = result.queryMetaData.Attributes.find(a => a.AttributeName == field || a.AttributeName == (field as DwItemAttribute)?.fieldName);
    //             return this.executeQueryData(query, result.queryMetaData);
    //         }));
    // }
    getFieldName(fieldName, includeItemName = true) {
        if (includeItemName) {
            return fieldName;
        }
        const fieldParts = fieldName.split('.');
        if (fieldParts.length == 2) {
            return fieldParts[1];
        }
        return fieldName;
        // const fields = new CheckrideRequestAggregateBaseQueryMetaDataAttributes();
        // if (!fieldSelector) {
        //     return '';
        // }
        // if (typeof fieldSelector == 'string') {
        //     return fieldSelector;
        // }
        // const field = fieldSelector(fields);
        // if (typeof field == 'string') {
        //     return field;
        // }
        // if (field instanceof DwItemAttribute) {
        //     return includeItemName ? field.fieldNameWithItemPrefix : field.fieldName;
        // }
        // return includeItemName ? field.FullFieldName : field.FieldName;
    }
    executeQueryData(query, queryMetaData) {
        return this.dwOrmDataService.executeQuery(query)
            .pipe(map(data => {
            return {
                data: data,
                query: query,
                queryMetaData: queryMetaData
            };
        }));
    }
    // private getFinancialsQuery(filters: ChartFilters, additionalFilterOptions: ChartAdditionalFilterOptions): Observable<DwQuery> {
    //     return this.buildCheckRideBaseQuery(filters,additionalFilterOptions)
    //         .pipe(map(result => {
    //             const query = result.query;
    //             query.AddField
    //             query.addField(f => f.AggrScheduledDateTimeMonthDisplay);
    //             query.addField(f => f.AggrScheduledDateTimeMonth);
    //             query.addField(f => f.AggrScheduledDateTimeYear);
    //             query.addOrderBy(f => f.AggrScheduledDateTimeYear);
    //             query.addOrderBy(f => f.AggrScheduledDateTimeMonth);
    //             return query.query;
    //         }));
    // }
    // private getFinancialSummaryQuery(filters: ChartFilters, additionalFilterOptions: ChartAdditionalFilterOptions): Observable<DwQuery> {
    //     return this.buildCheckRideBaseQuery(filters, additionalFilterOptions)
    //         .pipe(map(result => {
    //             const query = result.queryBuilder;
    //             query.query.FieldSettings.AggregateQueryWithRollup = true;
    //             query.addField(f => f.AggrScheduledDateTimeYear);
    //             query.addOrderBy(f => f.AggrScheduledDateTimeYear);
    //             return query.query;
    //         }));
    // }
    buildBaseQuery(queryRequest, filters, additionalFilterOptions) {
        return this.dwMetaDataService.getSavedQueryMetaData(queryRequest.item, null, queryRequest.queryMeaning)
            .pipe(map(queryMetaData => {
            const query = queryMetaData.DataQuery;
            // If we're not dealing with an aggregate query, then we need to set it up
            if (!query.FieldSettings.AggregateQuery) {
                query.FieldSettings.AggregateQuery = true;
                query.FieldSettings.LoadAllLookupDisplayFields = true;
                query.FieldSettings.IncludeRootItemFields = false;
            }
            const queryResult = {
                query: queryMetaData.DataQuery,
                queryMetaData: queryMetaData
            };
            return queryResult;
        }));
    }
    // private setupCheckrideBaseQuery(query: CheckrideRequestAggregateBaseQueryBuilder, filters?: ChartFilters, additionalFilterOptions?: ChartAdditionalFilterOptions): CheckrideRequestAggregateBaseQueryBuilder {
    //     query.query = Object.assign(new DwQuery(query.query.RootTable), deepCopy(query.query));
    //     query.query.FieldSettings.AggregateQuery = true;
    //     const qh = new DwQueryHelper();
    //     // Clear all fields so we can create a clean aggregate query
    //     qh.clearAllFields(query.query);
    //     query.query.Order = [];
    //     if (additionalFilterOptions?.includeStatuses) {
    //         query.addFilterAnd(f => f.InList(a => a.CheckRideRequestSubStatusId, additionalFilterOptions?.includeStatuses));    
    //     } 
    //     else {
    //         // If not include statuses, we use the passed in exclude filters or the defaults
    //         let excludeStatues = additionalFilterOptions?.excludeStatuses || [CheckRideRequestSubStatusAllItems.Cancelled, CheckRideRequestSubStatusAllItems.Rejected, CheckRideRequestSubStatusAllItems.Deleted, CheckRideRequestSubStatusAllItems.Draft];
    //         query.addFilterAnd(f => f.NotInList(a => a.CheckRideRequestSubStatusId, excludeStatues));
    //     }
    //     query.addFilterAnd(f => f.IsNotBlank(a => a.ScheduledDateTime, null));
    //     if (filters?.pilotExaminerId) {
    //         query.addFilterAnd(f => f.Equal(a => a.ScheduledPilotExaminerId, filters.pilotExaminerId));
    //     }
    //     if (filters?.year) {
    //         query.addFilterAnd(f => f.Equal(a => a.AggrScheduledDateTimeYear, filters.year));
    //     }
    //     if (filters?.month) {
    //         query.addFilterAnd(f => f.Equal(a => a.AggrScheduledDateTimeMonth, filters.month));
    //     }
    //     const fields = this.getFinancialFields();
    //     const attrs = AppMetaData.Queries.CheckrideRequestAggregateBase.Attributes;
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Count,
    //         FieldAlias: fields.checkrideCount
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.requestedCount,
    //         FullFieldName: attrs.AggrOutcomeIsRequested.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.requestedRevenue,
    //         FullFieldName: attrs.AggrRevenueIsRequested.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.bookedCount,
    //         FullFieldName: attrs.AggrOutcomeIsBooked.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.bookedRevenue,
    //         FullFieldName: attrs.AggrRevenueIsBooked.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.completedCount,
    //         FullFieldName: attrs.AggrOutcomeIsComplete.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.completedRevenue,
    //         FullFieldName: attrs.AggrRevenueIsComplete.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.paidRevenue,
    //         FullFieldName: attrs.AggrCheckridePaymentTotal.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.pilexosRevenue,
    //         FullFieldName: attrs.PilexosBookingCost.fieldNameWithItemPrefix,
    //     });
    //     query.query.AddField({
    //         FieldType: DwFieldType.Aggregate,
    //         AggregateFunction: DwFieldAggregate.Sum,
    //         FieldAlias: fields.pilexosPaidRevenue,
    //         FullFieldName: attrs.AggrPilexosPaymentTotal.fieldNameWithItemPrefix,
    //     });
    //     return query;
    // }
    // getFinancialFields(): CheckrideFinancialFields {
    //     const attrs = AppMetaData.Queries.CheckrideRequestAggregateBase.Attributes;
    //     const fields = new CheckrideFinancialFields();
    //     fields.month = attrs.AggrScheduledDateTimeMonth.fieldName;
    //     //fields.monthDisplay = attrs.AggrScheduledDateTimeMonthDisplay.fieldName;
    //     fields.monthDisplay = attrs.AggrScheduledDateTimeMonthYearDisplay.fieldName;
    //     fields.year = attrs.AggrScheduledDateTimeYear.fieldName;
    //     fields.checkrideType = attrs.AggrCheckRideTypeDisplay.fieldName;
    //     // fields.checkrideOutcome = attrs.AdditionalTravelCost
    //     // 'CheckRideResultCheckRideOutcomeIdDisplay';
    //     return fields;
    // }
    formatNumeric(value, decimals, money, excludeLocalNumericFormatting) {
        const numberValue = parseFloat(value);
        if (isNaN(numberValue)) {
            return null;
        }
        let formattedValue = numberValue.toFixed(decimals);
        if (!excludeLocalNumericFormatting) {
            formattedValue = numberValue.toLocaleString('en-us', { maximumFractionDigits: decimals, minimumFractionDigits: decimals });
        }
        if (money) {
            formattedValue = `$${formattedValue}`;
        }
        return formattedValue;
    }
}
DwChartRepositoryService.ɵfac = function DwChartRepositoryService_Factory(t) { return new (t || DwChartRepositoryService)(ɵngcc0.ɵɵinject(DwOrmDataServiceToken), ɵngcc0.ɵɵinject(DwMetaDataServiceToken), ɵngcc0.ɵɵinject(DwChartsConfigToken), ɵngcc0.ɵɵinject(DwTemplateUtilService)); };
DwChartRepositoryService.closeGridSubject = new Subject();
DwChartRepositoryService.ɵprov = ɵɵdefineInjectable({ factory: function DwChartRepositoryService_Factory() { return new DwChartRepositoryService(ɵɵinject(DwOrmDataServiceToken), ɵɵinject(DwMetaDataServiceToken), ɵɵinject(DwChartsConfigToken), ɵɵinject(DwTemplateUtilService)); }, token: DwChartRepositoryService, providedIn: "root" });
DwChartRepositoryService.ctorParameters = () => [
    { type: DwOrmDataService, decorators: [{ type: Inject, args: [DwOrmDataServiceToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DwChartsConfigToken,] }] },
    { type: DwTemplateUtilService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwChartRepositoryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwOrmDataService, decorators: [{
                type: Inject,
                args: [DwOrmDataServiceToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwChartsConfigToken]
            }] }, { type: DwTemplateUtilService }]; }, null); })();

//import { DataQueryResult } from '../../models/dw-data-query-result.model';
class DwFinancialDashboardComponent {
    constructor(dwChartRepositoryService) {
        this.dwChartRepositoryService = dwChartRepositoryService;
        this.textboxControlType = DwControlType.Textbox;
        this.chartFilters = {};
        this.previousChartFilters = {};
        this.currentGroupChanged = new EventEmitter();
        this.allChartResults = [];
        this.gridContainerOptions = {
            showTitle: true,
            useContainerStyling: true,
            containerHeaderBackgroundColor: 'blue'
        };
    }
    ngOnInit() {
        this.initDashboard();
    }
    ngOnChanges(changes) {
        var _a;
        if (((_a = changes.financialDashboardConfig) === null || _a === void 0 ? void 0 : _a.firstChange) == false) {
            this.currentDashboardGroup = this.financialDashboardConfig.groups.find(g => g.groupName === this.currentGroup);
            this.loadFinancialSummary(true);
            this.setupDashboard(true);
        }
    }
    initDashboard() {
        // 
        // this.currentMonth = this.currentMonth || this.dateTimeUtilService.getCurrentMonth();
        // this.currentYear = this.currentYear || this.dateTimeUtilService.getCurrentYear();
        this.currentDashboardGroup = this.currentDashboardGroup || this.financialDashboardConfig.groups[0];
        // Setup any static filters
        if (this.financialDashboardConfig.staticFilter) {
            this.chartFilters = this.financialDashboardConfig.staticFilter;
        }
        // Init year on first load
        this.chartFilters.year = this.chartFilters.year || this.currentYear;
        this.dwChartRepositoryService.getCloseGridObservable().subscribe(() => {
            this.toggleShowGrid();
        });
        this.loadFinancialSummary();
        this.setupDashboard();
    }
    dataSelected(event, chartResult) {
        //const fields = this.dwChartRepositoryService.getFinancialFields();
        var _a;
        this.selectedInfo = {
            event: event,
            chartResult: chartResult,
            label: `${chartResult.chartDataRequest.title} - ${event.category}`,
        };
        this.gridFilters = this.dwChartRepositoryService.buildGridFilters(event, chartResult, this.chartFilters);
        // Figure out how to set month and year
        // const monthValue = event.data[fields.month];
        // const yearValue = event.data[fields.year];
        // if (monthValue) {
        //   this.currentMonth = event.data[fields.month];
        //   this.currentYear = event.data[fields.year];
        // }
        if ((_a = event === null || event === void 0 ? void 0 : event.browserEvent) === null || _a === void 0 ? void 0 : _a.ctrlKey) {
            this.toggleShowGrid();
        }
        this.setupTiles();
    }
    onFilterChange() {
        var _a;
        if ((_a = this.chartFilters) === null || _a === void 0 ? void 0 : _a.year) {
            this.currentYear = this.chartFilters.year;
        }
        this.loadFinancialSummary();
        this.loadDashboardGroup();
    }
    toggleShowGrid() {
        this.showGrid = !this.showGrid;
    }
    setGroup(groupName) {
        this.currentDashboardGroup = this.financialDashboardConfig.groups.find(g => g.groupName === groupName);
        this.currentGroupChanged.emit(groupName);
        this.setupDashboard();
        this.showGrid = false;
    }
    loadFinancialSummary(forceRefresh = false) {
        var _a, _b;
        if (!forceRefresh && this.summaryData && ((_a = this.previousChartFilters) === null || _a === void 0 ? void 0 : _a.pilotExaminerId) == ((_b = this.chartFilters) === null || _b === void 0 ? void 0 : _b.pilotExaminerId)) {
            return;
        }
        this.previousChartFilters = deepCopy(this.chartFilters);
        // this.dwChartRepositoryService.getFinancialSummary(this.chartFilters, null)
        // .subscribe(summaryData => {
        //   this.summaryData = summaryData;
        //   this.setupTiles();
        // });
    }
    setupDashboard(forceRefresh = false) {
        this.currentGroup = this.currentDashboardGroup.groupName;
        this.currentGroupChanged.emit(this.currentGroup);
        const index = this.financialDashboardConfig.groups.findIndex(g => g.groupName === this.currentGroup);
        const results = this.allChartResults[index];
        if (results && !forceRefresh) {
            this.currentChartResults = results.chartResults;
            this.tileConfigs = results.tileConfigs;
            this.setupTiles();
            return;
        }
        // if (this.currentDashboardGroup.filterOptions?.showYear) {
        //   this.chartFilters.year = this.chartFilters.year || this.dateTimeUtilService.getCurrentYear();
        // }
        this.loadDashboardGroup();
    }
    loadDashboardGroup() {
        this.dwChartRepositoryService.setupCharts(this.currentDashboardGroup.charts, this.chartFilters)
            .subscribe((chartDataQueryResults) => {
            const index = this.financialDashboardConfig.groups.findIndex(g => g.groupName === this.currentGroup);
            // store results
            this.currentChartResults = chartDataQueryResults;
            var tiles = this.setupTiles();
            this.allChartResults[index] = { chartResults: chartDataQueryResults, tileConfigs: tiles };
        });
    }
    setupTiles() {
        var _a;
        this.tileConfigs = this.dwChartRepositoryService.setupTiles(this.currentDashboardGroup.tiles, this.currentChartResults, (_a = this.summaryData) === null || _a === void 0 ? void 0 : _a.data, { year: this.currentYear, month: this.currentMonth });
        return this.tileConfigs;
    }
}
DwFinancialDashboardComponent.ɵfac = function DwFinancialDashboardComponent_Factory(t) { return new (t || DwFinancialDashboardComponent)(ɵngcc0.ɵɵdirectiveInject(DwChartRepositoryService)); };
DwFinancialDashboardComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwFinancialDashboardComponent, selectors: [["dw-financial-dashboard"]], inputs: { financialDashboardConfig: "financialDashboardConfig" }, outputs: { currentGroupChanged: "currentGroupChanged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function DwFinancialDashboardComponent_Template(rf, ctx) { }, styles: [""] });
DwFinancialDashboardComponent.ctorParameters = () => [
    { type: DwChartRepositoryService }
];
DwFinancialDashboardComponent.propDecorators = {
    financialDashboardConfig: [{ type: Input }],
    currentGroupChanged: [{ type: Output }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwFinancialDashboardComponent, [{
        type: Component,
        args: [{
                selector: 'dw-financial-dashboard',
                template: "<!-- <dw-router-parent>\r\n    <ng-template>\r\n        <dw-content-manager [configKey]=\"financialDashboardConfig?.contentConfigKey\">\r\n            <h1>\r\n                <dw-content name=\"title\" display=\"Page Title\" [controlType]=\"textboxControlType\">\r\n                    Financials\r\n                </dw-content>\r\n            </h1>\r\n            <dw-content name=\"detail\" display=\"Header Details\">\r\n                Here are all of your financials\r\n            </dw-content>\r\n            <dw-content-component name='component' display='Custom Component'></dw-content-component>\r\n        </dw-content-manager>\r\n\r\n        <dw-pills [items]=\"financialDashboardConfig.groups\" [(ngModel)]=\"currentGroup\" valueField=\"groupName\"\r\n            displayField=\"groupName\" (ngModelChange)=\"setGroup($event)\"></dw-pills>\r\n\r\n        <div class=\"dashboard-column-wide\">\r\n            <div clas=\"title-container\">\r\n                <ng-container *ngIf=\"showGrid\">\r\n                    <dw-container [options]=\"gridContainerOptions\">\r\n                        <div header>\r\n                            {{selectedInfo?.label}}\r\n                        </div>\r\n                        <div body class=\"inner-container\">\r\n                            <dw-meta-data-grid [item]=\"'CheckRideRequest'\"\r\n                                [configKeyPart]=\"currentDashboardGroup.gridConfigKey\"\r\n                                configKeyPart2=\"dep-admin-financials\" [filters]=\"gridFilters\"></dw-meta-data-grid>\r\n\r\n                        </div>\r\n                    </dw-container>\r\n                </ng-container>\r\n\r\n                <div [hidden]=\"showGrid\">\r\n\r\n                    <app-financial-dashboard-filters [(filters)]=\"chartFilters\" (filtersChange)=\"onFilterChange($event)\"\r\n                        [financialDashboardGroup]=\"currentDashboardGroup\" [summaryData]=\"summaryData?.data\">\r\n\r\n                        <ng-content>\r\n        \r\n                        </ng-content>\r\n                    </app-financial-dashboard-filters>\r\n\r\n                    <div class=\"tile-contianer\" *ngIf=\"true\">\r\n                        <ng-container *ngFor=\"let tileConfig of tileConfigs\">\r\n                            <div class=\"tile-25\">\r\n                                <dw-mini-tile [tileConfig]=\"tileConfig\"></dw-mini-tile>\r\n                            </div>\r\n                        </ng-container>\r\n                    </div>\r\n\r\n                    <ng-container *ngFor=\"let chartResult of currentChartResults\">\r\n                        <div class2=\"tile-50\" [ngClass]=\"chartResult.chartDataRequest?.containerClass\">\r\n                            <dw-chart-tile [chartPreferences]=\"chartResult.chartPreferences\" [data]=\"chartResult.data\"\r\n                                [query]=\"chartResult.query\" (dataSelected)=\"dataSelected($event, chartResult)\">\r\n                                <div *ngIf=\"selectedInfo?.chartResult == chartResult\">\r\n                                    <a (click)=\"toggleShowGrid()\" class=\"dw-link\">View Data for\r\n                                        {{selectedInfo?.label}}</a>\r\n                                </div>\r\n                            </dw-chart-tile>\r\n                        </div>\r\n                    </ng-container>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ng-template>\r\n</dw-router-parent>\r\n\r\n<div *ngIf=\"false\">\r\n    <div style=\"clear:left\">\r\n        <br>Colors:<br>\r\n        <div *ngFor=\"let color of colors\" [ngStyle]=\"{'background-color': color}\"\r\n            style=\"width:100px; height: 100px; margin-left:4px; float:left\"></div>\r\n    </div>\r\n    <br><br>\r\n    <div style=\"clear:left\">\r\n        <br><br>Colors2:<br>\r\n        <div *ngFor=\"let color of colors2\" [ngStyle]=\"{'background-color': color}\"\r\n            style=\"width:100px; height: 100px; margin-left:4px; float:left\"></div>\r\n    </div>\r\n</div> -->",
                styles: [""]
            }]
    }], function () { return [{ type: DwChartRepositoryService }]; }, { currentGroupChanged: [{
            type: Output
        }], financialDashboardConfig: [{
            type: Input
        }] }); })();

// import { CheckRideRequestSubStatusAllItems } from "../../../meta-data/app-meta-data.service";

// Not sure this will be used, but ported it for now
// export interface DwQueryResult<QueryBuilderType> extends DwBaseQueryResult {
//     queryBuilder: QueryBuilderType;
// }

class DwTaskContainerComponent {
    constructor(router) {
        this.router = router;
        this.title = 'Tasks';
    }
    ngOnInit() {
        this.containerOptions = this.containerOptions || {
            containerHeaderIcon: 'fa fa-check-circle',
            containerHeaderBackgroundColor: 'orange',
            containerHeight: '200px',
            useContainerStyling: true,
            showTitle: true
        };
    }
    taskClick(task) {
        if (task.clickFunc) {
            task.clickFunc();
            return;
        }
        if (task.navigateUrl) {
            this.router.navigateByUrl(task.navigateUrl);
        }
    }
}
DwTaskContainerComponent.ɵfac = function DwTaskContainerComponent_Factory(t) { return new (t || DwTaskContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router)); };
DwTaskContainerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwTaskContainerComponent, selectors: [["dw-task-container"]], inputs: { title: "title", containerOptions: "containerOptions", tasks: "tasks" }, decls: 0, vars: 0, template: function DwTaskContainerComponent_Template(rf, ctx) { }, styles: [".inner-container[_ngcontent-%COMP%]{height:100%}.task-container[_ngcontent-%COMP%]{cursor:pointer;margin-top:10px;overflow:auto;width:90%}.task-container[_ngcontent-%COMP%]   .task-icon[_ngcontent-%COMP%]{float:left;font-size:3em;margin-left:3px;margin-right:10px;text-align:center;width:50px}.task-container[_ngcontent-%COMP%]   .task-title[_ngcontent-%COMP%]{float:left;font-size:1.5em;margin-top:14px;text-overflow:ellipsis;width:350px}.task-container[_ngcontent-%COMP%]:hover{background-color:#f5f5f5}.task-container-flex[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;flex-direction:row;height:100%;justify-content:flex-start;width:100%}.task-container-flex[_ngcontent-%COMP%]   .task-icon[_ngcontent-%COMP%]{font-size:2.4em;margin-left:3px;margin-right:10px;text-align:center;width:50px}.task-container-flex[_ngcontent-%COMP%]   .task-title[_ngcontent-%COMP%]{flex-grow:1;font-size:1.2em;margin-top:10px;text-overflow:ellipsis}.task-container-flex[_ngcontent-%COMP%]:hover{background-color:#f5f5f5;border-radius:5px}"] });
DwTaskContainerComponent.ctorParameters = () => [
    { type: Router }
];
DwTaskContainerComponent.propDecorators = {
    tasks: [{ type: Input }],
    title: [{ type: Input }],
    containerOptions: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwTaskContainerComponent, [{
        type: Component,
        args: [{
                selector: 'dw-task-container',
                template: "\r\n<!-- <dw-container [options]=\"containerOptions\">\r\n    <span header>{{title}}</span>\r\n    <div body>\r\n        <div class=\"inner-container\">\r\n\r\n            <ng-container *ngFor=\"let task of tasks\">\r\n                <div class=\"task-container-flex\" [title]=\"task.tooltip || ''\" (click)=\"taskClick(task)\">\r\n                    <div class=\"task-icon\"><i [class]=\"task.iconClass\"></i></div>\r\n                    <div class=\"task-title\">{{task.taskTitle}}</div>\r\n                </div>\r\n            </ng-container>\r\n        </div>\r\n    </div>\r\n</dw-container> -->",
                styles: [".inner-container{height:100%}.task-container{cursor:pointer;margin-top:10px;overflow:auto;width:90%}.task-container .task-icon{float:left;font-size:3em;margin-left:3px;margin-right:10px;text-align:center;width:50px}.task-container .task-title{float:left;font-size:1.5em;margin-top:14px;text-overflow:ellipsis;width:350px}.task-container:hover{background-color:#f5f5f5}.task-container-flex{align-items:center;cursor:pointer;display:flex;flex-direction:row;height:100%;justify-content:flex-start;width:100%}.task-container-flex .task-icon{font-size:2.4em;margin-left:3px;margin-right:10px;text-align:center;width:50px}.task-container-flex .task-title{flex-grow:1;font-size:1.2em;margin-top:10px;text-overflow:ellipsis}.task-container-flex:hover{background-color:#f5f5f5;border-radius:5px}"]
            }]
    }], function () { return [{ type: ɵngcc2.Router }]; }, { title: [{
            type: Input
        }], containerOptions: [{
            type: Input
        }], tasks: [{
            type: Input
        }] }); })();

;

class DwImageSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = 'dwImageSection';
    }
}

class DwMultiFileSectionPreferences extends DwSectionBasePreference {
    constructor() {
        super();
        this.multiFileOptions = {
            showGalleria: true,
            imagesOnly: false
        };
        this.sectionType = 'dwMultiFileSection';
    }
}

;

var DwWizardSectionTypes;
(function (DwWizardSectionTypes) {
    DwWizardSectionTypes["wizard"] = "wizard";
    DwWizardSectionTypes["wizardStep"] = "wizardStep";
})(DwWizardSectionTypes || (DwWizardSectionTypes = {}));

class DwWizardStepPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.sectionType = DwWizardSectionTypes.wizardStep;
    }
}

var DwWizardRegistryTypes;
(function (DwWizardRegistryTypes) {
    DwWizardRegistryTypes["stepStyleComponent"] = "stepStyleComponent";
})(DwWizardRegistryTypes || (DwWizardRegistryTypes = {}));

class DwUiWizardSectionConfigComponent extends DwMdSectionConfigBaseComponent {
    constructor() {
        super(...arguments);
        this.formGroup = new FormGroup({});
        this.stepStyles = [];
    }
    sectionChanged() {
        // if (!this.section) {
        //     return;
        // }
        // if (!this.section.steps) {
        //     this.section.steps = [];
        // }
    }
    ngOnInit() {
        // this.setupDropdowns();
        // this.setupForm();
    }
    setupComplete() {
        if (!this.section) {
            return;
        }
        if (!this.section.steps) {
            this.section.steps = [];
        }
        this.setupDropdowns();
        this.setupForm();
    }
    setupForm() {
        this.formGroup = new FormGroup({});
        this.addControl('wizardContainerClass');
        this.addControl('hideStepNumberInHeader');
        this.addControl('showStepNumberInProgressBar').setValue(true);
        this.addControl('showStepProgressBar');
        this.addControl('hideInactiveButtons');
        this.addControl('allowStepNavigation');
        this.wizardStyleFG = new FormGroup({});
        this.addControl('fixedHeight', this.wizardStyleFG);
        this.addControl('wizardContainerClass', this.wizardStyleFG);
        this.addControl('wizardStepListContainerClass', this.wizardStyleFG);
        this.addControl('wizardStepContainerClass', this.wizardStyleFG);
        this.addControl('useStepContainerStyles', this.wizardStyleFG);
        this.addControl('stepStyleName', this.wizardStyleFG);
        this.addControl('containerHeaderBackgroundColor', this.wizardStyleFG);
        this.addControl('containerHeaderForegroundColor', this.wizardStyleFG);
        this.addControl('containerHeaderIconColor', this.wizardStyleFG);
        this.formGroup.addControl('wizardStyle', this.wizardStyleFG);
        this.formGroup.patchValue(this.section);
        this.formGroup.valueChanges.pipe(debounceTime(20)).subscribe(() => {
            console.log('Updating wizard section', this.section, this.formGroup.value);
            this.section = Object.assign(this.section, this.formGroup.value);
            this.onSectionChange();
        });
    }
    setupDropdowns() {
        this.stepStyles = this.dwUiConfigRegistryService.getRegisteredItems(DwWizardRegistryTypes.stepStyleComponent);
    }
    addControl(name, formGroup, isRequired, isReadOnly) {
        if (!formGroup) {
            formGroup = this.formGroup;
        }
        const fc = new FormControl();
        if (isRequired) {
            fc.setValidators(Validators.required);
        }
        if (isReadOnly)
            fc.disable();
        formGroup.addControl(name, fc);
        return fc;
    }
    addItem() {
        let stepSection = new DwWizardStepPreference();
        stepSection.stepName = `Step ${this.section.steps.length + 1}`,
            stepSection.section = new DwContainerSectionPreference();
        this.section.steps.push(stepSection);
        this.onSectionChange();
    }
    removeItem(item) {
        var index = this.section.steps.indexOf(item);
        if (index >= 0)
            this.section.steps.splice(index, 1);
        this.onSectionChange();
    }
    moveUp(item) {
        var index = this.section.steps.indexOf(item);
        if (index == 0)
            return;
        let newIndex = index--;
        this.section.steps.splice(newIndex, 0, this.section.steps.splice(index, 1)[0]);
        this.onSectionChange();
    }
    moveDown(item) {
        var index = this.section.steps.indexOf(item);
        if (index == this.section.steps.length - 1)
            return;
        let newIndex = index++;
        this.section.steps.splice(newIndex, 0, this.section.steps.splice(index, 1)[0]);
        this.onSectionChange();
    }
}
DwUiWizardSectionConfigComponent.ɵfac = function DwUiWizardSectionConfigComponent_Factory(t) { return ɵDwUiWizardSectionConfigComponent_BaseFactory(t || DwUiWizardSectionConfigComponent); };
DwUiWizardSectionConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiWizardSectionConfigComponent, selectors: [["dw-ui-wizard-section-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 92, vars: 13, consts: [["header", "Wizard Steps"], [3, "items", "itemsChange", 4, "ngIf"], [3, "click"], [1, "fa", "fa-plus", "hand"], ["header", "Wizard Configuration"], [3, "formGroup"], [3, "multiple"], ["header", "Wizard Options", 3, "selected"], ["dwRow", ""], ["dwCol", "6"], ["dwCol", "9"], ["dwCol", "3"], ["formControlName", "showStepProgressBar"], ["formControlName", "showStepNumberInProgressBar"], ["formControlName", "hideStepNumberInHeader"], ["formControlName", "hideInactiveButtons"], ["formControlName", "allowStepNavigation"], ["header", "Wizard Style", 3, "selected"], ["formControlName", "stepStyleName", 1, "form-control"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["formControlName", "useStepContainerStyles"], ["dwRow", "", 3, "hidden"], ["dwCol", "4"], ["formControlName", "containerHeaderBackgroundColor"], ["formControlName", "containerHeaderForegroundColor"], ["formControlName", "containerHeaderIconColor"], ["type", "text", "formControlName", "wizardContainerClass", 1, "form-control"], ["type", "text", "formControlName", "wizardStepListContainerClass", 1, "form-control"], ["type", "text", "formControlName", "wizardStepContainerClass", 1, "form-control"], ["type", "text", "dwNumeric", "", "formControlName", "fixedHeight", 1, "form-control"], ["header", "Section Configuration"], [3, "contextNames", "section", "preferences", "itemMetaDataList", "rootItemName", "sectionChange"], [3, "items", "itemsChange"], [4, "dwListItem"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue"]], template: function DwUiWizardSectionConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵtemplate(3, DwUiWizardSectionConfigComponent_dw_ordered_list_3_Template, 2, 1, "dw-ordered-list", 1);
        ɵngcc0.ɵɵelementStart(4, "button", 2);
        ɵngcc0.ɵɵlistener("click", function DwUiWizardSectionConfigComponent_Template_button_click_4_listener() { return ctx.addItem(); });
        ɵngcc0.ɵɵelement(5, "i", 3);
        ɵngcc0.ɵɵtext(6, " Add Step ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "p-tabPanel", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "p-accordion", 6);
        ɵngcc0.ɵɵelementStart(10, "p-accordionTab", 7);
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵelementStart(12, "div", 9);
        ɵngcc0.ɵɵelementStart(13, "div", 10);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Show Step Progress Bar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "div", 11);
        ɵngcc0.ɵɵelement(17, "p-inputSwitch", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 9);
        ɵngcc0.ɵɵelementStart(19, "div", 10);
        ɵngcc0.ɵɵelementStart(20, "label");
        ɵngcc0.ɵɵtext(21, "Show Step number in Progress Bar");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "div", 11);
        ɵngcc0.ɵɵelement(23, "p-inputSwitch", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "div", 8);
        ɵngcc0.ɵɵelementStart(25, "div", 9);
        ɵngcc0.ɵɵelementStart(26, "div", 10);
        ɵngcc0.ɵɵelementStart(27, "label");
        ɵngcc0.ɵɵtext(28, "Hide Step info in Header");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 11);
        ɵngcc0.ɵɵelement(30, "p-inputSwitch", 14);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div", 9);
        ɵngcc0.ɵɵelementStart(32, "div", 10);
        ɵngcc0.ɵɵelementStart(33, "label");
        ɵngcc0.ɵɵtext(34, "Hide Inactive Buttons");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(35, "div", 11);
        ɵngcc0.ɵɵelement(36, "p-inputSwitch", 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(37, "div", 8);
        ɵngcc0.ɵɵelementStart(38, "div", 9);
        ɵngcc0.ɵɵelementStart(39, "div", 10);
        ɵngcc0.ɵɵelementStart(40, "label");
        ɵngcc0.ɵɵtext(41, "Allow Step Navigation");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(42, "div", 11);
        ɵngcc0.ɵɵelement(43, "p-inputSwitch", 16);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(44, "p-accordionTab", 17);
        ɵngcc0.ɵɵelementStart(45, "div", 5);
        ɵngcc0.ɵɵelementStart(46, "div", 8);
        ɵngcc0.ɵɵelementStart(47, "div", 9);
        ɵngcc0.ɵɵelementStart(48, "label");
        ɵngcc0.ɵɵtext(49, "Wizard Step Progress");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "select", 18);
        ɵngcc0.ɵɵtemplate(51, DwUiWizardSectionConfigComponent_option_51_Template, 2, 2, "option", 19);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(52, "div", 9);
        ɵngcc0.ɵɵelementStart(53, "div", 10);
        ɵngcc0.ɵɵelementStart(54, "label");
        ɵngcc0.ɵɵtext(55, "Use Step Container Style");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(56, "div", 11);
        ɵngcc0.ɵɵelement(57, "p-inputSwitch", 20);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(58, "div", 21);
        ɵngcc0.ɵɵelementStart(59, "div", 22);
        ɵngcc0.ɵɵelementStart(60, "label");
        ɵngcc0.ɵɵtext(61, "Header Background Color");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(62, "dw-color-select", 23);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(63, "div", 22);
        ɵngcc0.ɵɵelementStart(64, "label");
        ɵngcc0.ɵɵtext(65, "Header Text Color");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(66, "dw-color-select", 24);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(67, "div", 22);
        ɵngcc0.ɵɵelementStart(68, "label");
        ɵngcc0.ɵɵtext(69, "Icon Color");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(70, "dw-color-select", 25);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(71, "div", 8);
        ɵngcc0.ɵɵelementStart(72, "div", 9);
        ɵngcc0.ɵɵelementStart(73, "label");
        ɵngcc0.ɵɵtext(74, "Wizard Container Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(75, "input", 26);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(76, "div", 9);
        ɵngcc0.ɵɵelementStart(77, "label");
        ɵngcc0.ɵɵtext(78, "Wizard Step Progress Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(79, "input", 27);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(80, "div", 8);
        ɵngcc0.ɵɵelementStart(81, "div", 9);
        ɵngcc0.ɵɵelementStart(82, "label");
        ɵngcc0.ɵɵtext(83, "Wizard Step Container Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(84, "input", 28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(85, "div", 9);
        ɵngcc0.ɵɵelementStart(86, "label");
        ɵngcc0.ɵɵtext(87, "Wizard Fixed Height");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(88, "input", 29);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(89, "p-tabPanel", 30);
        ɵngcc0.ɵɵelementStart(90, "div");
        ɵngcc0.ɵɵelementStart(91, "dw-md-section-standard-config", 31);
        ɵngcc0.ɵɵlistener("sectionChange", function DwUiWizardSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_91_listener($event) { return ctx.section = $event; })("sectionChange", function DwUiWizardSectionConfigComponent_Template_dw_md_section_standard_config_sectionChange_91_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.section);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("formGroup", ctx.formGroup);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("multiple", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("selected", true);
        ɵngcc0.ɵɵadvance(34);
        ɵngcc0.ɵɵproperty("selected", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("formGroup", ctx.wizardStyleFG);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.stepStyles);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("hidden", ctx.wizardStyleFG.value == null ? null : ctx.wizardStyleFG.value.useStepContainerStyles);
        ɵngcc0.ɵɵadvance(33);
        ɵngcc0.ɵɵproperty("contextNames", ctx.contextNames)("section", ctx.section)("preferences", ctx.preferences)("itemMetaDataList", ctx.itemMetaDataList)("rootItemName", ctx.rootItemName);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, ɵngcc4.NgIf, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, ɵngcc11.Accordion, ɵngcc11.AccordionTab, DwRowDirective, DwColDirective, ɵngcc10.InputSwitch, ɵngcc3.NgControlStatus, ɵngcc3.FormControlName, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, ColorSelectComponent, ɵngcc3.DefaultValueAccessor, DwNumericDirective, DwMdSectionStandardConfigComponent, DwOrderedListComponent, DwListItemDirective, ɵngcc3.NgModel, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
const ɵDwUiWizardSectionConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwUiWizardSectionConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiWizardSectionConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ui-wizard-section-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Wizard Steps\">\r\n            <dw-ordered-list [(items)]=\"section.steps\" (itemsChange)=\"onSectionChange()\" *ngIf=\"section\">\r\n                <ng-container *dwListItem=\"let section\">\r\n                    <label>Step Name</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.stepName\" (ngModelChange)=\"onSectionChange()\"\r\n                        class=\"form-control\">\r\n                </ng-container>\r\n            </dw-ordered-list>\r\n\r\n\r\n            <button (click)=\"addItem()\">\r\n                <i class=\"fa fa-plus hand\"></i>\r\n                Add Step\r\n            </button>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Wizard Configuration\">\r\n            <div [formGroup]=\"formGroup\">\r\n                <p-accordion [multiple]=\"true\">\r\n                    <p-accordionTab header=\"Wizard Options\" [selected]=\"true\">\r\n                        <div dwRow>\r\n                            <div dwCol=\"6\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Show Step Progress Bar</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch formControlName=\"showStepProgressBar\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwCol=\"6\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Show Step number in Progress Bar</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch formControlName=\"showStepNumberInProgressBar\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow>\r\n                            <div dwCol=\"6\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Hide Step info in Header</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch formControlName=\"hideStepNumberInHeader\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                            <div dwCol=\"6\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Hide Inactive Buttons</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch formControlName=\"hideInactiveButtons\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div dwRow>\r\n                            <div dwCol=\"6\">\r\n                                <div dwCol=\"9\">\r\n                                    <label>Allow Step Navigation</label>\r\n                                </div>\r\n                                <div dwCol=\"3\">\r\n                                    <p-inputSwitch formControlName=\"allowStepNavigation\"></p-inputSwitch>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </p-accordionTab>\r\n                    <p-accordionTab header=\"Wizard Style\" [selected]=\"false\">\r\n                        <div [formGroup]=\"wizardStyleFG\">\r\n                            <div dwRow>\r\n                                <div dwCol=\"6\">\r\n                                    <label>Wizard Step Progress</label>\r\n                                    <select formControlName=\"stepStyleName\" class=\"form-control\">\r\n                                        <option *ngFor=\"let stepStyle of stepStyles\" [ngValue]=\"stepStyle.keyName\">\r\n                                            {{stepStyle.display}}\r\n                                        </option>\r\n                                    </select>\r\n                                </div>\r\n                                <div dwCol=\"6\">\r\n                                    <div dwCol=\"9\">\r\n                                        <label>Use Step Container Style</label>\r\n                                    </div>\r\n                                    <div dwCol=\"3\">\r\n                                        <p-inputSwitch formControlName=\"useStepContainerStyles\"></p-inputSwitch>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow [hidden]=\"wizardStyleFG.value?.useStepContainerStyles\">\r\n                                <div dwCol=\"4\">\r\n                                    <label>Header Background Color</label>\r\n                                    <dw-color-select formControlName=\"containerHeaderBackgroundColor\"></dw-color-select>\r\n                                </div>\r\n                                <div dwCol=\"4\">\r\n                                    <label>Header Text Color</label>\r\n                                    <dw-color-select formControlName=\"containerHeaderForegroundColor\"></dw-color-select>\r\n                                </div>\r\n                                <div dwCol=\"4\">\r\n                                    <label>Icon Color</label>\r\n                                    <dw-color-select formControlName=\"containerHeaderIconColor\"></dw-color-select>\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow>\r\n                                <div dwCol=\"6\">\r\n                                    <label>Wizard Container Class</label>\r\n                                    <input type=\"text\" formControlName=\"wizardContainerClass\" class=\"form-control\">\r\n                                </div>\r\n                                <div dwCol=\"6\">\r\n                                    <label>Wizard Step Progress Class</label>\r\n                                    <input type=\"text\" formControlName=\"wizardStepListContainerClass\"\r\n                                        class=\"form-control\">\r\n                                </div>\r\n                            </div>\r\n                            <div dwRow>\r\n                                <div dwCol=\"6\">\r\n                                    <label>Wizard Step Container Class</label>\r\n                                    <input type=\"text\" formControlName=\"wizardStepContainerClass\" class=\"form-control\">\r\n                                </div>\r\n                                <div dwCol=\"6\">\r\n                                    <label>Wizard Fixed Height</label>\r\n                                    <input type=\"text\" dwNumeric formControlName=\"fixedHeight\" class=\"form-control\">\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </p-accordionTab>\r\n                </p-accordion>\r\n            </div>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Section Configuration\">\r\n            <div>\r\n                <dw-md-section-standard-config [contextNames]=\"contextNames\" [(section)]=\"section\"\r\n                    (sectionChange)=\"onSectionChange()\" [preferences]=\"preferences\"\r\n                    [itemMetaDataList]=\"itemMetaDataList\" [rootItemName]=\"rootItemName\">\r\n                </dw-md-section-standard-config>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>\r\n</div>",
                styles: [""]
            }]
    }], null, null); })();

class DwWizardStyleDefaults {
    constructor() {
        this.useStepContainerStyles = false;
        this.wizardContainerClass = 'dw-wizard-container';
        this.wizardStepListContainerClass = 'dw-wizard-step-list-container';
        this.wizardStepContainerClass = 'dw-wizard-step-container';
    }
}

class DwWizardStateService extends DwStateBaseService {
    constructor(dwUiConfigRegistryService, router, dwExpressionService, dwExpressionStateService, dwEventService) {
        super();
        this.dwUiConfigRegistryService = dwUiConfigRegistryService;
        this.router = router;
        this.dwExpressionService = dwExpressionService;
        this.dwExpressionStateService = dwExpressionStateService;
        this.dwEventService = dwEventService;
        this.subscriptions = [];
    }
    setState(newState) {
        var _a;
        super.setState(newState);
        (_a = this.dwEventService) === null || _a === void 0 ? void 0 : _a.publishEvent(DwWizardStateService.WIZARD_STATE_CHANGE, {});
    }
    getInitialState() {
        return {
            initComplete: false,
            currentIndex: 0,
            currentStep: null,
            wizardSectionPreference: null,
            visibleSteps: [],
            furthestStepIndex: 0,
            submitted: false,
        };
    }
    initWizard(wizardSectionPreference, rootFormGroup, context) {
        // Ensure that the default settings are used and then overriden with the current preferences
        const wizardStyle = Object.assign(Object.assign({}, new DwWizardStyleDefaults()), removeNullProperties(wizardSectionPreference.wizardStyle, true));
        const stepStyle = this.getStepStyle(wizardSectionPreference, wizardStyle);
        /*  let stepVisibility = this.getStepVisibility(wizardSectionPreference, rootFormGroup, context);
         let visibleSteps = this.getVisibleSteps(stepVisibility, wizardSectionPreference.steps); */
        let visibleSteps = this.getStepsVisibiltity(wizardSectionPreference.steps, rootFormGroup, context);
        const initialStepIndex = this.getInitialStepIndex(visibleSteps.length);
        this.setState({
            initComplete: true,
            currentIndex: initialStepIndex,
            currentStep: visibleSteps[initialStepIndex],
            wizardSectionPreference: Object.assign(Object.assign({}, wizardSectionPreference), { wizardStyle: wizardStyle }),
            visibleSteps: visibleSteps,
            stepStyle: stepStyle,
            furthestStepIndex: initialStepIndex,
        });
    }
    getStepsVisibiltity(steps, rootFormGroup, context) {
        // Clear any existing subscriptions
        this.clearStepExpressionSubscriptions();
        // Get a result that returns which items are visible
        const result = this.dwExpressionStateService.initExpressionSetArray(steps, (step) => step.visibleExpression, rootFormGroup, context, true);
        this.subscriptions.push(result.observable.subscribe(visibleSteps => {
            this.setState({
                visibleSteps: visibleSteps
            });
        }));
        return result.initialResults;
    }
    getInitialStepIndex(stepCount) {
        const wizardStep = parseInt(getParameterByName(this.router, 'wizardStep'));
        if (!wizardStep || isNaN(wizardStep)) {
            return 0;
        }
        if (wizardStep > stepCount) {
            return stepCount - 1;
        }
        return wizardStep - 1; // index is 0 based
    }
    getStepStyle(wizardSectionPreference, wizardStyle) {
        let stepStyle = this.dwUiConfigRegistryService.getRegisteredItem(DwWizardRegistryTypes.stepStyleComponent, wizardStyle === null || wizardStyle === void 0 ? void 0 : wizardStyle.stepStyleName);
        if (!stepStyle) {
            console.warn(`Step Style ${wizardStyle.stepStyleName} is not defined.  Using default`);
            stepStyle = this.dwUiConfigRegistryService.getRegisteredItem(DwWizardRegistryTypes.stepStyleComponent, '');
        }
        return stepStyle;
    }
    clearStepExpressionSubscriptions() {
        // un-subscribe from all expression evaluations
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
        this.subscriptions = [];
    }
    deallocateWizard() {
        this.clearStepExpressionSubscriptions();
        this.clearState();
    }
    next() {
        if (!this.state.initComplete) {
            return;
        }
        this.setCurrentIndex(this.state.currentIndex + 1);
    }
    previous() {
        if (!this.state.initComplete) {
            return;
        }
        this.setCurrentIndex(this.state.currentIndex - 1);
    }
    allowNext() {
        if (!this.state.initComplete) {
            return false;
        }
        return !this.allowFinish();
    }
    allowPrevious() {
        if (!this.state.initComplete) {
            return false;
        }
        return this.state.currentIndex > 0;
    }
    allowFinish() {
        if (!this.state.initComplete) {
            return false;
        }
        return this.state.currentIndex === this.state.visibleSteps.length - 1;
    }
    gotoStep(step) {
        if (!this.state.initComplete) {
            return;
        }
        const stepIndex = this.state.visibleSteps.indexOf(step);
        this.gotoStepIndex(stepIndex);
    }
    gotoStepIndex(stepIndex) {
        // Can't move to future steps  (Need to determine how this is affected by visible expressions)
        if (stepIndex > this.state.furthestStepIndex) {
            return;
        }
        this.setCurrentIndex(stepIndex);
    }
    setCurrentIndex(newIndex) {
        if (newIndex > this.state.visibleSteps.length - 1) {
            newIndex = this.state.visibleSteps.length - 1;
        }
        if (newIndex < 0) {
            newIndex = 0;
        }
        const currentStep = this.state.visibleSteps[newIndex];
        const furthestStepIndex = newIndex > this.state.furthestStepIndex ? newIndex : this.state.furthestStepIndex;
        this.setState({
            currentIndex: newIndex,
            currentStep: currentStep,
            furthestStepIndex: furthestStepIndex
        });
    }
    getWizardContextValue() {
        var _a, _b, _c, _d;
        const currentStep = this.state.wizardSectionPreference.steps.find(s => { var _a; return s.stepName == ((_a = this.state.currentStep) === null || _a === void 0 ? void 0 : _a.stepName); });
        const visibleStepIndex = this.state.wizardSectionPreference.steps.indexOf(currentStep) + 1;
        const contextResult = {
            currentStepName: (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.currentStep) === null || _b === void 0 ? void 0 : _b.stepName,
            allowFinish: this.allowFinish(),
            allowNext: this.allowNext(),
            allowPrevious: this.allowPrevious(),
            stepCount: (_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.visibleSteps) === null || _d === void 0 ? void 0 : _d.length,
            stepNumber: visibleStepIndex
        };
        return contextResult;
    }
}
DwWizardStateService.ɵfac = function DwWizardStateService_Factory(t) { return new (t || DwWizardStateService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(DwExpressionService), ɵngcc0.ɵɵinject(DwExpressionStateService), ɵngcc0.ɵɵinject(DwEventService)); };
DwWizardStateService.WIZARD_STATE_CHANGE = "WIZARD_STATE_CHANGE";
DwWizardStateService.ɵprov = ɵɵdefineInjectable({ factory: function DwWizardStateService_Factory() { return new DwWizardStateService(ɵɵinject(DwUiConfigRegistryService), ɵɵinject(Router), ɵɵinject(DwExpressionService), ɵɵinject(DwExpressionStateService), ɵɵinject(DwEventService)); }, token: DwWizardStateService, providedIn: "root" });
DwWizardStateService.ctorParameters = () => [
    { type: DwUiConfigRegistryService },
    { type: Router },
    { type: DwExpressionService },
    { type: DwExpressionStateService },
    { type: DwEventService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardStateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: DwUiConfigRegistryService }, { type: ɵngcc2.Router }, { type: DwExpressionService }, { type: DwExpressionStateService }, { type: DwEventService }]; }, null); })();

class DwWizardSectionPreference extends DwSectionBasePreference {
    constructor() {
        super();
        this.steps = [];
        this.sectionType = DwWizardSectionTypes.wizard;
    }
}

function wrapWizard(section) {
    const newSection = new DwWizardSectionPreference();
    const step1 = new DwWizardStepPreference();
    step1.stepName = 'Step 1';
    step1.section = section;
    newSection.steps = [step1];
    return newSection;
}

var DwWizardActionKeys;
(function (DwWizardActionKeys) {
    DwWizardActionKeys["wizardNext"] = "wizard-next";
    DwWizardActionKeys["wizardPrevious"] = "wizard-previous";
    DwWizardActionKeys["wizardFinish"] = "wizard-finish";
})(DwWizardActionKeys || (DwWizardActionKeys = {}));

function getWizardDefaultButtons() {
    const wizardButtonDefaults = {};
    wizardButtonDefaults[DwFormContextMode.addEdit] = [DwFormActionKeys.formCancel, DwWizardActionKeys.wizardPrevious, DwWizardActionKeys.wizardNext, DwWizardActionKeys.wizardFinish];
    wizardButtonDefaults[DwFormContextMode.view] = [DwWizardActionKeys.wizardPrevious, DwWizardActionKeys.wizardNext, DwFormActionKeys.formClose];
    wizardButtonDefaults[DwFormContextMode.print] = [DwFormActionKeys.formPrint, DwWizardActionKeys.wizardPrevious, DwWizardActionKeys.wizardNext, DwFormActionKeys.formClose];
    return wizardButtonDefaults;
}

const DW_WIZARD_CONTEXT = 'dwWizardContext';
class DwWizardContextService extends DwCustomContextBase {
    constructor(dwWizardStateService) {
        super();
        this.dwWizardStateService = dwWizardStateService;
    }
    setupContextDefinition(contextDef) {
        contextDef.cacheInvalidationTopics = [DwWizardStateService.WIZARD_STATE_CHANGE];
        contextDef.data = {};
        contextDef.noCache = true;
        contextDef.getCustomContextFunction = () => {
            var _a, _b;
            if (!((_b = (_a = this.dwWizardStateService) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.initComplete)) {
                return {};
            }
            return this.dwWizardStateService.getWizardContextValue();
            // return DwWizardContextService.getWizardContextValue(this.dwWizardStateService);
            // const currentStep = this.dwWizardStateService.state.wizardSectionPreference.steps.find(s => s.stepName == this.dwWizardStateService.state.currentStep?.stepName);
            // const visibleStepIndex = this.dwWizardStateService.state.wizardSectionPreference.steps.indexOf(currentStep) + 1;
            // const contextResult = {
            //     currentStepName: this.dwWizardStateService.state?.currentStep?.stepName,
            //     allowFinish: this.dwWizardStateService.allowFinish(),
            //     allowNext: this.dwWizardStateService.allowNext(),
            //     allowPrevious: this.dwWizardStateService.allowPrevious(),
            //     stepCount: this.dwWizardStateService.state?.visibleSteps?.length,
            //     stepNumber: visibleStepIndex
            // };
            // return contextResult;
        };
        contextDef.attributes = this.getContextAttributes();
    }
    getContextAttributes() {
        const attributes = [];
        this.addProperty(attributes, 'currentStepName', 'Step Name');
        this.addProperty(attributes, 'stepNumber', 'Step Number', DwAttributeType.Integer, DwControlType.NumericTextBox);
        this.addProperty(attributes, 'allowFinish', 'Allow Finish', DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(attributes, 'allowNext', 'Allow Next', DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(attributes, 'allowPrevious', 'Allow Previous', DwAttributeType.YesNo, DwControlType.YesNoDropDown);
        this.addProperty(attributes, 'stepCount', 'Total Visible Steps', DwAttributeType.Integer, DwControlType.NumericTextBox);
        return attributes;
    }
}
DwWizardContextService.ɵfac = function DwWizardContextService_Factory(t) { return new (t || DwWizardContextService)(ɵngcc0.ɵɵinject(DwWizardStateService)); };
DwWizardContextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwWizardContextService, factory: DwWizardContextService.ɵfac });
DwWizardContextService.ctorParameters = () => [
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardContextService, [{
        type: Injectable
    }], function () { return [{ type: DwWizardStateService }]; }, null); })();
DwCustomContextDefinitionFunc({
    keyName: DW_WIZARD_CONTEXT,
    display: 'Wizard',
    isGlobal: false,
    isCustomUiContext: true,
    customUIContextType: 'Wizard'
}, DwWizardContextService);

class DwUiWizardSectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataRoutingService, dwWizardStateService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
        this.dwWizardStateService = dwWizardStateService;
        this.inPrintMode = false;
    }
    get wizardStyle() {
        return this.dwWizardStateService.state.wizardSectionPreference.wizardStyle;
    }
    ngOnInit() {
        super.ngOnInit();
        this.dwWizardStateService.initWizard(this.sectionConfig, this.formGroup, this.context);
        this.state = this.dwWizardStateService.state;
        if (this.formConfig.formMode == DwFormContextMode.print) {
            this.inPrintMode = true;
        }
        this.subscriptions.push(this.dwWizardStateService.stateChanged.subscribe(state => {
            setTimeout(() => {
                this.state = state;
                const wizardContext = this.context[DW_WIZARD_CONTEXT];
                wizardContext.next(this.dwWizardStateService.getWizardContextValue());
            });
        }));
    }
    trackByFunc(step) {
        return step.stepName;
    }
    sectionConfigChanged() {
        this.dwWizardStateService.initWizard(this.sectionConfig, this.formGroup, this.context);
    }
    get preferences() {
        var _a;
        return (_a = this.state) === null || _a === void 0 ? void 0 : _a.wizardSectionPreference;
    }
    get currentStep() {
        var _a;
        return (_a = this.state) === null || _a === void 0 ? void 0 : _a.currentStep;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.dwWizardStateService.deallocateWizard();
    }
}
DwUiWizardSectionComponent.ɵfac = function DwUiWizardSectionComponent_Factory(t) { return new (t || DwUiWizardSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService), ɵngcc0.ɵɵdirectiveInject(DwWizardStateService)); };
DwUiWizardSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiWizardSectionComponent, selectors: [["dw-ui-wizard-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 2, consts: [[3, "ngClass", 4, "ngIf"], [3, "hidden", 4, "ngIf"], [3, "ngClass"], [4, "ngIf"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "component"], [3, "hidden"], ["reloadComponentOnChange", "true", 3, "formConfig", "sectionConfig", "formGroup", "context", "submitted"], ["class", "dw-tab-print-container", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "dw-tab-print-container"], ["header", ""], ["body", ""], [3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"]], template: function DwUiWizardSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, DwUiWizardSectionComponent_div_0_Template, 3, 4, "div", 0);
        ɵngcc0.ɵɵtemplate(1, DwUiWizardSectionComponent_ng_container_1_Template, 2, 3, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.state == null ? null : ctx.state.initComplete) && !ctx.inPrintMode);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.state == null ? null : ctx.state.initComplete) && ctx.inPrintMode);
    } }, directives: [ɵngcc4.NgIf, ɵngcc4.NgClass, ɵngcc4.NgForOf, DwDynamicLoaderComponent, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective, DwContainerComponent], styles: [""] });
DwUiWizardSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataRoutingService },
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiWizardSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ui-wizard-section',
                template: "\r\n<div *ngIf=\"state?.initComplete && !inPrintMode\" [ngClass]=\"wizardStyle.wizardContainerClass\">\r\n  <ng-container *ngIf=\"preferences?.showStepProgressBar && state?.stepStyle?.stepListComponent\">\r\n    <dw-dynamic-loader [component]=\"state?.stepStyle?.stepListComponent\"></dw-dynamic-loader>\r\n  </ng-container>\r\n\r\n  <ng-container *ngFor=\"let step of state?.visibleSteps; let i = index; trackBy: trackByFunc\">\r\n    <ng-container *ngIf=\"i <= state?.currentIndex\">\r\n\r\n      <div [hidden]=\"i != state?.currentIndex\">\r\n        <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"step\" [formGroup]=\"formGroup\" [context]=\"context\" [submitted]=\"submitted\" reloadComponentOnChange=\"true\"></dw-dynamic-section> \r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n<ng-container [hidden]=\"!visible\" *ngIf=\"state?.initComplete && inPrintMode\">\r\n  <ng-container *ngFor=\"let step of state?.visibleSteps; let i = index; trackBy: trackByFunc\" class=\"dw-tab-print-container\">\r\n      <dw-container>\r\n          <div header>\r\n              {{step.stepName}}\r\n          </div>\r\n          <div body>\r\n              <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"section\" [formGroup]=\"formGroup\"\r\n              [context]=\"context\" [submitted]=\"submitted\" [parentIsVisible]=\"visible\"></dw-dynamic-section>\r\n          </div>\r\n      </dw-container>\r\n  </ng-container>\r\n</ng-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataRoutingService }, { type: DwWizardStateService }]; }, null); })();
DwSectionComponentFunc({
    keyName: DwWizardSectionTypes.wizard,
    display: 'Wizard',
    sectionIcon: 'fa fa-hat-wizard',
    configComponent: DwUiWizardSectionConfigComponent,
    hasChildren: true,
    childrenPropertyName: 'steps',
    wrapOptions: {
        allowWrap: true,
        createWrapSection: wrapWizard
    },
    dragDropConfig: {
        allowChildDrop: true,
        dropChildSectionType: DwWizardSectionTypes.wizardStep
    },
    defaultButtonsOverride: getWizardDefaultButtons(),
    contextDefNames: [DW_WIZARD_CONTEXT]
}, DwUiWizardSectionComponent);

class DwUiWizardStepConfigComponent extends DwMdSectionConfigBaseComponent {
}
DwUiWizardStepConfigComponent.ɵfac = function DwUiWizardStepConfigComponent_Factory(t) { return ɵDwUiWizardStepConfigComponent_BaseFactory(t || DwUiWizardStepConfigComponent); };
DwUiWizardStepConfigComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiWizardStepConfigComponent, selectors: [["dw-dw-ui-wizard-step-config"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 24, vars: 7, consts: [["header", "Wizard Step Configuration"], ["dwRow", ""], ["dwCol", "6"], ["type", "text", 1, "form-control", 3, "ngModel", "ngModelChange"], [1, "form-control", 3, "ngModel", "ngModelChange"], [3, "ngValue", 4, "ngFor", "ngForOf"], ["header", "Rules"], ["dwCol", "12"], [3, "ngModel", "contextNames", "item", "ngModelChange"], [3, "ngValue"]], template: function DwUiWizardStepConfigComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "p-tabView");
        ɵngcc0.ɵɵelementStart(2, "p-tabPanel", 0);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "label");
        ɵngcc0.ɵɵtext(6, "Step Name");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwUiWizardStepConfigComponent_Template_input_ngModelChange_7_listener($event) { return ctx.section.stepName = $event; })("ngModelChange", function DwUiWizardStepConfigComponent_Template_input_ngModelChange_7_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 2);
        ɵngcc0.ɵɵelementStart(9, "label");
        ɵngcc0.ɵɵtext(10, "Icon Class");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "input", 3);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwUiWizardStepConfigComponent_Template_input_ngModelChange_11_listener($event) { return ctx.section.iconClass = $event; })("ngModelChange", function DwUiWizardStepConfigComponent_Template_input_ngModelChange_11_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 1);
        ɵngcc0.ɵɵelementStart(13, "div", 2);
        ɵngcc0.ɵɵelementStart(14, "label");
        ɵngcc0.ɵɵtext(15, "Content Section Type");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "select", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwUiWizardStepConfigComponent_Template_select_ngModelChange_16_listener($event) { return ctx.section.section.sectionType = $event; })("ngModelChange", function DwUiWizardStepConfigComponent_Template_select_ngModelChange_16_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵtemplate(17, DwUiWizardStepConfigComponent_option_17_Template, 2, 2, "option", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "p-tabPanel", 6);
        ɵngcc0.ɵɵelementStart(19, "div", 1);
        ɵngcc0.ɵɵelementStart(20, "div", 7);
        ɵngcc0.ɵɵelementStart(21, "label");
        ɵngcc0.ɵɵtext(22, "Visible Expression");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "dw-expression-picker-control", 8);
        ɵngcc0.ɵɵlistener("ngModelChange", function DwUiWizardStepConfigComponent_Template_dw_expression_picker_control_ngModelChange_23_listener($event) { return ctx.section.visibleExpression = $event; })("ngModelChange", function DwUiWizardStepConfigComponent_Template_dw_expression_picker_control_ngModelChange_23_listener() { return ctx.onSectionChange(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.stepName);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.iconClass);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.section.sectionType);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.sectionDefs);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.section.visibleExpression)("contextNames", ctx.contextNames)("item", ctx.rootItemName);
    } }, directives: [ɵngcc9.TabView, ɵngcc9.TabPanel, DwRowDirective, DwColDirective, ɵngcc3.DefaultValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc3.SelectControlValueAccessor, ɵngcc4.NgForOf, DwExpressionPickerControlComponent, ɵngcc3.NgSelectOption, ɵngcc3.ɵangular_packages_forms_forms_x], styles: [""] });
const ɵDwUiWizardStepConfigComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(DwUiWizardStepConfigComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiWizardStepConfigComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-ui-wizard-step-config',
                template: "<div>\r\n    <p-tabView>\r\n        <p-tabPanel header=\"Wizard Step Configuration\">\r\n\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Step Name</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.stepName\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\">\r\n                </div>\r\n                <div dwCol=\"6\">\r\n                    <label>Icon Class</label>\r\n                    <input type=\"text\" [(ngModel)]=\"section.iconClass\" (ngModelChange)=\"onSectionChange()\" class=\"form-control\">\r\n                </div>\r\n            </div>\r\n            <div dwRow>\r\n                <div dwCol=\"6\">\r\n                    <label>Content Section Type</label>\r\n                    <select [(ngModel)]=\"section.section.sectionType\" (ngModelChange)=\"onSectionChange()\"  class=\"form-control\">\r\n                        <option *ngFor=\"let sectionDef of sectionDefs\" [ngValue]=\"sectionDef.keyName\">\r\n                            {{sectionDef.display}}\r\n                        </option>\r\n                    </select> \r\n                \r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n        <p-tabPanel header=\"Rules\">\r\n            <div dwRow>\r\n                <div dwCol=\"12\">\r\n                    <label>Visible Expression</label>\r\n                    <dw-expression-picker-control [(ngModel)]=\"section.visibleExpression\" (ngModelChange)=\"onSectionChange()\" [contextNames]=\"contextNames\"  [item]=\"rootItemName\">\r\n                     </dw-expression-picker-control>\r\n                </div>\r\n            </div>\r\n        </p-tabPanel>\r\n    </p-tabView>  \r\n</div>",
                styles: [""]
            }]
    }], null, null); })();

class DwUiWizardStepSectionComponent extends DwSectionBaseComponent {
    constructor(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService, dwMetaDataRoutingService, dwWizardStateService, dwMetadataFormUtilService, dwStyleManagerService) {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.dwMetaDataRoutingService = dwMetaDataRoutingService;
        this.dwWizardStateService = dwWizardStateService;
        this.dwMetadataFormUtilService = dwMetadataFormUtilService;
        this.dwStyleManagerService = dwStyleManagerService;
    }
    ngOnInit() {
        super.ngOnInit();
        this.dwWizardStateService.stateChanged.pipe(map(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.wizardSectionPreference) === null || _a === void 0 ? void 0 : _a.wizardStyle; }), distinctUntilChanged())
            .subscribe(wizardStyle => {
            if (wizardStyle) {
                if (!wizardStyle.useStepContainerStyles) {
                    this.containerOptions = this.containerOptions || {};
                    // this.containerOptions.containerClass = wizardStyle.wizardStepContainerClass;
                    this.containerOptions.showTitle = true;
                    this.containerOptions.useContainerStyling = true;
                    this.containerOptions.containerHeaderBackgroundColor = wizardStyle.containerHeaderBackgroundColor;
                    this.containerOptions.containerHeaderForegroundColor = wizardStyle.containerHeaderForegroundColor;
                    this.containerOptions.containerHeaderIconColor = wizardStyle.containerHeaderIconColor;
                    //this.containerOptions.containerHeaderIcon = this.currentStep.iconClass;
                    this.iconClasses = this.getIconClasses(wizardStyle);
                }
                else {
                    this.containerOptions = this.dwMetadataFormUtilService.setupContainerOptions(this.sectionConfig);
                }
                if (wizardStyle.fixedHeight) {
                    this.containerOptions.containerHeight = `${wizardStyle.fixedHeight}px`;
                }
            }
        });
    }
    getIconClasses(wizardStyle) {
        const iconClasses = [];
        if (this.currentStep.iconClass) {
            iconClasses.push(this.currentStep.iconClass);
        }
        if (wizardStyle.containerHeaderIconColor) {
            iconClasses.push(this.dwStyleManagerService.getForegroundColorClass(wizardStyle.containerHeaderIconColor));
        }
        return iconClasses.join(' ');
    }
    get wizardStyle() {
        return this.preferences.wizardStyle;
    }
    get preferences() {
        return this.dwWizardStateService.state.wizardSectionPreference;
    }
    get currentStep() {
        return this.dwWizardStateService.state.currentStep;
    }
    get currentStepInfo() {
        const item = this.dwWizardStateService.state.visibleSteps.find(vs => { var _a; return vs.stepName == ((_a = this.sectionConfig) === null || _a === void 0 ? void 0 : _a.stepName); });
        if (item) {
            const index = this.dwWizardStateService.state.visibleSteps.indexOf(item);
            return `Step ${index + 1} of ${this.dwWizardStateService.state.visibleSteps.length}`;
        }
        return `Step ${this.dwWizardStateService.state.currentIndex + 1} of ${this.dwWizardStateService.state.visibleSteps.length}`;
    }
}
DwUiWizardStepSectionComponent.ɵfac = function DwUiWizardStepSectionComponent_Factory(t) { return new (t || DwUiWizardStepSectionComponent)(ɵngcc0.ɵɵdirectiveInject(DwExpressionService), ɵngcc0.ɵɵdirectiveInject(DwUiConfigRegistryService), ɵngcc0.ɵɵdirectiveInject(DwUIMetaDataConfigToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataServiceToken), ɵngcc0.ɵɵdirectiveInject(DwMetaDataRoutingService), ɵngcc0.ɵɵdirectiveInject(DwWizardStateService), ɵngcc0.ɵɵdirectiveInject(DwMetadataFormUtilService), ɵngcc0.ɵɵdirectiveInject(DwStyleManagerService)); };
DwUiWizardStepSectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwUiWizardStepSectionComponent, selectors: [["dw-ui-wizard-step-section"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 9, vars: 11, consts: [[3, "options"], ["header", "", 1, "dw-wizard-header"], ["id", "headerIcon", 3, "ngClass"], ["id", "stepName"], ["id", "stepInfo", 3, "hidden"], ["body", ""], ["excludeStyling", "true", "reloadComponentOnChange", "true", 3, "formConfig", "sectionConfig", "formGroup", "context", "submitted", "parentIsVisible"]], template: function DwUiWizardStepSectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "dw-container", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span", 4);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 5);
        ɵngcc0.ɵɵelement(8, "dw-dynamic-section", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("options", ctx.containerOptions);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngClass", ctx.iconClasses);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.sectionConfig == null ? null : ctx.sectionConfig.stepName, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("hidden", ctx.preferences.hideStepNumberInHeader);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.currentStepInfo, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("formConfig", ctx.formConfig)("sectionConfig", ctx.sectionConfig == null ? null : ctx.sectionConfig.section)("formGroup", ctx.formGroup)("context", ctx.context)("submitted", ctx.submitted)("parentIsVisible", ctx.visible);
    } }, directives: [DwContainerComponent, ɵngcc4.NgClass, DwDynamicSectionComponent, ɵngcc3.NgControlStatusGroup, ɵngcc3.FormGroupDirective], styles: [""] });
DwUiWizardStepSectionComponent.ctorParameters = () => [
    { type: DwExpressionService },
    { type: DwUiConfigRegistryService },
    { type: undefined, decorators: [{ type: Inject, args: [DwUIMetaDataConfigToken,] }] },
    { type: DwMetaDataService, decorators: [{ type: Inject, args: [DwMetaDataServiceToken,] }] },
    { type: DwMetaDataRoutingService },
    { type: DwWizardStateService },
    { type: DwMetadataFormUtilService },
    { type: DwStyleManagerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwUiWizardStepSectionComponent, [{
        type: Component,
        args: [{
                selector: 'dw-ui-wizard-step-section',
                template: "<dw-container\r\n  [options]=\"containerOptions\">\r\n  <div header class=\"dw-wizard-header\">\r\n    <i id=\"headerIcon\" [ngClass]=\"iconClasses\"></i>\r\n    <span id=\"stepName\">\r\n      {{ sectionConfig?.stepName }}\r\n    </span>\r\n    <span id=\"stepInfo\" [hidden]=\"preferences.hideStepNumberInHeader\">\r\n      {{currentStepInfo}}\r\n    </span>\r\n  </div>\r\n  <div body>\r\n    <dw-dynamic-section [formConfig]=\"formConfig\" [sectionConfig]=\"sectionConfig?.section\" [formGroup]=\"formGroup\" [context]=\"context\" [submitted]=\"submitted\" excludeStyling=\"true\" reloadComponentOnChange=\"true\" [parentIsVisible]=\"visible\"></dw-dynamic-section> \r\n  </div>\r\n</dw-container>",
                styles: [""]
            }]
    }], function () { return [{ type: DwExpressionService }, { type: DwUiConfigRegistryService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DwUIMetaDataConfigToken]
            }] }, { type: DwMetaDataService, decorators: [{
                type: Inject,
                args: [DwMetaDataServiceToken]
            }] }, { type: DwMetaDataRoutingService }, { type: DwWizardStateService }, { type: DwMetadataFormUtilService }, { type: DwStyleManagerService }]; }, null); })();
function getCustomConfigDisplay(sectionConfig, sectionDef, parentSection, parentSectionDef) {
    const stepConfig = sectionConfig;
    return `${stepConfig.stepName} (Step)`;
}
DwSectionComponentFunc({
    keyName: DwWizardSectionTypes.wizardStep,
    display: 'Wizard Step',
    sectionIcon: 'fa fa-film-alt',
    configComponent: DwUiWizardStepConfigComponent,
    childDisplayPrefix: 'Step',
    childDisplayProperty: 'stepName',
    hasChildren: false,
    hasChild: true,
    requiresParent: true,
    dragDropConfig: {
        dropParentSectionType: DwWizardSectionTypes.wizard
    },
    getCustomConfigDisplay: getCustomConfigDisplay
}, DwUiWizardStepSectionComponent);

class DwWizardActionBase {
    constructor(dwWizardStateService) {
        this.dwWizardStateService = dwWizardStateService;
    }
    initAction(formInitActionState) {
        this.dwWizardStateService.stateChanged
            .subscribe(state => {
            this.updateButton(state, formInitActionState);
        });
        this.updateButton(this.dwWizardStateService.state, formInitActionState);
    }
    updateButton(state, formInitActionState) {
        // Don't run logic if the wizard isn't initialized
        if (!state || !state.initComplete) {
            return;
        }
        // Set button disabled/hidden based on preferences
        const buttonConfig = {};
        if (state.wizardSectionPreference.hideInactiveButtons) {
            buttonConfig.hidden = !this.isButtonActive();
        }
        else {
            buttonConfig.disabled = !this.isButtonActive();
        }
        formInitActionState.updateActionPreference({ buttonConfig: buttonConfig });
    }
}

// @DwAction<DwFormActionConfig>({
//   keyName: DwWizardActionKeys.wizardNext,
//   display: 'Next',
//   actionType: DwActionType.formAction,
//   isGlobal: true,
//   allowOnce: true,
//   defaultButtonConfig: {
//     useParentDisplay: true,
//     buttonType: DwButtonType.standard,
//     buttonTitle: 'Go to the next step of the wizard',
//     command: 'wizard-next',
//     iconClass: 'fa fa-arrow-right',
//     buttonClass: 'btn btn-primary',
//     showIconAfterText: true,
//   },
//   configData: {
//     requireValidation: true,
//     clearSubmittedAfterSucessfulValidation: true
//   }
// })
class DwWizardNextService extends DwWizardActionBase {
    constructor(dwWizardStateService) {
        super(dwWizardStateService);
    }
    isButtonActive() {
        return this.dwWizardStateService.allowNext();
    }
    handleAction(formActionState) {
        // Tell the service to go to the next step
        this.dwWizardStateService.next();
        const result = {
            hideMessage: true,
            success: true
        };
        return of(result);
    }
}
DwWizardNextService.ɵfac = function DwWizardNextService_Factory(t) { return new (t || DwWizardNextService)(ɵngcc0.ɵɵinject(DwWizardStateService)); };
DwWizardNextService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwWizardNextService, factory: DwWizardNextService.ɵfac });
DwWizardNextService.ctorParameters = () => [
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardNextService, [{
        type: Injectable
    }], function () { return [{ type: DwWizardStateService }]; }, null); })();
/**
 * Work around for very weird Angular/Typescript error when publishing library
 * Error: Angular debugging TypeError: Class constructor DwWizardFinishService cannot be invoked without 'new'
 *
 * It works if you remove the @DwAction decorator and call it as a function instead.  Makes no sense and tried a ton of stuff.  First showed up in version 4.5.1 along with the new Filter tiles functionality
 */
DwActionFunc({
    keyName: DwWizardActionKeys.wizardNext,
    display: 'Next',
    actionType: DwActionType.formAction,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonTitle: 'Go to the next step of the wizard',
        command: 'wizard-next',
        iconClass: 'fa fa-arrow-right',
        buttonClass: 'btn btn-primary',
        showIconAfterText: true,
    },
    configData: {
        requireValidation: true,
        clearSubmittedAfterSucessfulValidation: true
    }
}, DwWizardNextService);

/**
 * Work around for very weird Angular/Typescript error when publishing library
 * Error: Angular debugging TypeError: Class constructor DwWizardFinishService cannot be invoked without 'new'
 *
 * It works if you remove the @DwAction decorator and call it as a function instead.  Makes no sense and tried a ton of stuff.  First showed up in version 4.5.1 along with the new Filter tiles functionality
 */
// @DwAction({
//   keyName: DwWizardActionKeys.wizardPrevious,
//   display: 'Previous',
//   actionType: DwActionType.formAction,
//   isGlobal: true,
//   allowOnce: true,
//   defaultButtonConfig: {
//     useParentDisplay: true,
//     buttonType: DwButtonType.standard,
//     buttonTitle: 'Go to the previous step of the wizard',
//     command: 'wizard-previous',
//     iconClass: 'fa fa-arrow-left',
//     buttonClass: 'btn btn-primary'
//   },
// })
// @DwAction({} as any)
class DwWizardPreviousService extends DwWizardActionBase {
    constructor(dwWizardStateService) {
        super(dwWizardStateService);
    }
    isButtonActive() {
        return this.dwWizardStateService.allowPrevious();
    }
    handleAction(formActionState) {
        // Tell the service to go to the next step
        this.dwWizardStateService.previous();
        const result = {
            hideMessage: true,
            success: true
        };
        return of(result);
    }
}
DwWizardPreviousService.ɵfac = function DwWizardPreviousService_Factory(t) { return new (t || DwWizardPreviousService)(ɵngcc0.ɵɵinject(DwWizardStateService)); };
DwWizardPreviousService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwWizardPreviousService, factory: DwWizardPreviousService.ɵfac });
DwWizardPreviousService.ctorParameters = () => [
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardPreviousService, [{
        type: Injectable
    }], function () { return [{ type: DwWizardStateService }]; }, null); })();
/**
 * Work around for very weird Angular/Typescript error when publishing library
 * Error: Angular debugging TypeError: Class constructor DwWizardFinishService cannot be invoked without 'new'
 *
 * It works if you remove the @DwAction decorator and call it as a function instead.  Makes no sense and tried a ton of stuff.  First showed up in version 4.5.1 along with the new Filter tiles functionality
 */
DwActionFunc({
    keyName: DwWizardActionKeys.wizardPrevious,
    display: 'Previous',
    actionType: DwActionType.formAction,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonTitle: 'Go to the previous step of the wizard',
        command: 'wizard-previous',
        iconClass: 'fa fa-arrow-left',
        buttonClass: 'btn btn-primary'
    },
}, DwWizardPreviousService);
// implements DwMdFormActionHandler {
//   constructor(
//     protected dwWizardStateService: DwWizardStateService) {
//   }
//   protected isButtonActive(): boolean {
//     return this.dwWizardStateService.allowPrevious();
//   }
//   handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
//     // Tell the service to go to the next step
//     this.dwWizardStateService.previous();
//     const result: DwMdFormActionResult = {
//       hideMessage: true,
//       success: true
//     };
//     return of(result);
//   }
//   initAction(formInitActionState: DwMdFormInitActionState) {
//     this.dwWizardStateService.stateChanged
//       .subscribe(state => {
//         this.updateButton(state, formInitActionState);
//       });
//     this.updateButton(this.dwWizardStateService.state, formInitActionState);
//   }
//   protected updateButton(state: DwWizardState, formInitActionState: DwMdFormInitActionState) {
//     // Don't run logic if the wizard isn't initialized
//     if (!state || !state.initComplete) {
//       return;
//     }
//     // Set button disabled/hidden based on preferences
//     const buttonConfig: Partial<DwButtonConfig> = {};
//     if (state.wizardSectionPreference.hideInactiveButtons) {
//       buttonConfig.hidden = !this.isButtonActive();
//     } else {
//       buttonConfig.disabled = !this.isButtonActive();
//     }
//     formInitActionState.updateActionPreference({ buttonConfig: buttonConfig });
//   }
// }

/**
 * Work around for very weird Angular/Typescript error when publishing library
 * Error: Angular debugging TypeError: Class constructor DwWizardFinishService cannot be invoked without 'new'
 *
 * It works if you remove the @DwAction decorator and call it as a function instead.  Makes no sense and tried a ton of stuff.  First showed up in version 4.5.1 along with the new Filter tiles functionality
 */
// @DwAction<DwFormActionConfig>({
//     keyName: DwWizardActionKeys.wizardFinish,
//     display: 'Finish',
//     actionType: DwActionType.formAction,
//     configComponent: DwFormActionConfigDefaultComponent,
//     isGlobal: true,
//     allowOnce: true,
//     defaultButtonConfig: {
//         useParentDisplay: true,
//         buttonType: DwButtonType.standard,
//         buttonTitle: 'Complete the wizard',
//         command: 'wizard-finish',
//         iconClass: '',
//         buttonClass: 'btn btn-success',
//     },
//     configData: {
//         requireValidation: true,
//         redirectAfter: true,
//     }
// })
class DwWizardFinishService extends DwWizardActionBase {
    constructor(dwWizardStateService) {
        super(dwWizardStateService);
    }
    isButtonActive() {
        return this.dwWizardStateService.allowFinish();
    }
    handleAction(formActionState) {
        const { formApi } = formActionState;
        return formApi.saveData();
    }
}
DwWizardFinishService.ɵfac = function DwWizardFinishService_Factory(t) { return new (t || DwWizardFinishService)(ɵngcc0.ɵɵinject(DwWizardStateService)); };
DwWizardFinishService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwWizardFinishService, factory: DwWizardFinishService.ɵfac });
DwWizardFinishService.ctorParameters = () => [
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardFinishService, [{
        type: Injectable
    }], function () { return [{ type: DwWizardStateService }]; }, null); })();
/**
 * Work around for very weird Angular/Typescript error when publishing library
 * Error: Angular debugging TypeError: Class constructor DwWizardFinishService cannot be invoked without 'new'
 *
 * It works if you remove the @DwAction decorator and call it as a function instead.  Makes no sense and tried a ton of stuff.  First showed up in version 4.5.1 along with the new Filter tiles functionality
 */
DwActionFunc({
    keyName: DwWizardActionKeys.wizardFinish,
    display: 'Finish',
    actionType: DwActionType.formAction,
    configComponent: DwFormActionConfigDefaultComponent,
    isGlobal: true,
    allowOnce: true,
    defaultButtonConfig: {
        useParentDisplay: true,
        buttonType: DwButtonType.standard,
        buttonTitle: 'Complete the wizard',
        command: 'wizard-finish',
        iconClass: '',
        buttonClass: 'btn btn-success',
    },
    configData: {
        requireValidation: true,
        redirectAfter: true,
    }
}, DwWizardFinishService);

class DwWizardStepListComponent {
    constructor(dwWizardStateService) {
        this.dwWizardStateService = dwWizardStateService;
        this.stepList = [];
    }
    ngOnInit() {
        this.dwWizardStateService.stateChanged.subscribe(state => {
            this.setupStepList(state);
        });
    }
    setupStepList(state) {
        if (!state.wizardSectionPreference) {
            return;
        }
        // Get percent to 1 decimal place
        const stepWidth = Math.round(1000 / state.wizardSectionPreference.steps.length) / 10;
        this.itemStyle = {
            width: `${stepWidth}%`
        };
        this.stepList = [];
        let index = 0;
        for (const step of state.visibleSteps) {
            this.stepList.push({
                step: step,
                stepClass: this.determineStepClass(state, step, index),
                stepIconClass: step.iconClass || 'fa fa-film-alt',
                stepNumber: index + 1
            });
            index++;
        }
    }
    determineStepClass(state, step, index) {
        let stepClass = 'dw-wizard-step-item';
        if (this.stepStyle && this.stepStyle.stepListItemClass) {
            stepClass = this.stepStyle.stepListItemClass;
        }
        if (index < state.currentIndex) {
            stepClass += ' dw-wizard-previous-step';
        }
        if (index === state.currentIndex) {
            stepClass += ' dw-wizard-current-step';
        }
        if (index > state.currentIndex) {
            stepClass += ' dw-wizard-future-step';
        }
        if (state.visibleSteps.length === 1) {
            stepClass += ' dw-wizard-single-step';
        }
        return stepClass;
    }
    get wizardStyle() {
        return this.dwWizardStateService.state.wizardSectionPreference.wizardStyle;
    }
    get stepStyle() {
        return this.dwWizardStateService.state.stepStyle;
    }
    get preferences() {
        return this.dwWizardStateService.state.wizardSectionPreference;
    }
    get currentStep() {
        return this.dwWizardStateService.state.currentStep;
    }
    gotoStep(stepItem) {
        if (this.preferences.allowStepNavigation) {
            this.dwWizardStateService.gotoStep(stepItem.step);
        }
    }
}
DwWizardStepListComponent.ɵfac = function DwWizardStepListComponent_Factory(t) { return new (t || DwWizardStepListComponent)(ɵngcc0.ɵɵdirectiveInject(DwWizardStateService)); };
DwWizardStepListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwWizardStepListComponent, selectors: [["dw-wizard-step-list"]], decls: 3, vars: 2, consts: [[3, "ngClass"], ["id", "row"], ["id", "step", 3, "ngClass", "ngStyle", 4, "ngFor", "ngForOf"], ["id", "step", 3, "ngClass", "ngStyle"], ["id", "stepIcon", "type", "button", 3, "click"], [3, "ngClass", "hidden"], ["id", "stepNumber", 3, "hidden"], ["id", "stepName"], ["id", "stepDescription"]], template: function DwWizardStepListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, DwWizardStepListComponent_li_2_Template, 9, 8, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", (ctx.wizardStyle == null ? null : ctx.wizardStyle.wizardStepListContainerClass) || (ctx.stepStyle == null ? null : ctx.stepStyle.stepListContainerClass));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.stepList);
    } }, directives: [ɵngcc4.NgClass, ɵngcc4.NgForOf, ɵngcc4.NgStyle], styles: [""] });
DwWizardStepListComponent.ctorParameters = () => [
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardStepListComponent, [{
        type: Component,
        args: [{
                selector: 'dw-wizard-step-list',
                template: "<div [ngClass]=\"wizardStyle?.wizardStepListContainerClass || stepStyle?.stepListContainerClass\">\r\n  <ul id=\"row\">\r\n    <li id=\"step\" *ngFor=\"let stepItem of stepList\"  [ngClass]=\"stepItem.stepClass\" [ngStyle]=\"itemStyle\">\r\n      <div id=\"stepIcon\" (click)=\"gotoStep(stepItem)\" type=\"button\" >\r\n        <i [ngClass]=\"stepItem.stepIconClass\" [hidden]=\"preferences?.showStepNumberInProgressBar\"></i>\r\n\r\n        <span id=\"stepNumber\" [hidden]=\"!preferences?.showStepNumberInProgressBar\">{{stepItem.stepNumber}}</span>\r\n      </div>\r\n      \r\n      <p id=\"stepName\">{{stepItem.step.stepName}}</p>\r\n      <p id=\"stepDescription\">{{stepItem.step.stepDescription}}</p>\r\n    </li>\r\n  </ul>\r\n</div>",
                styles: [""]
            }]
    }], function () { return [{ type: DwWizardStateService }]; }, null); })();

class DwWizardStepListBarComponent {
    constructor(dwWizardStateService) {
        this.dwWizardStateService = dwWizardStateService;
    }
    ngOnInit() {
        this.dwWizardStateService.stateChanged.subscribe(state => {
            if (state.initComplete) {
                this.progress = ((state.currentIndex) / (state.visibleSteps.length)) * 100;
            }
        });
    }
}
DwWizardStepListBarComponent.ɵfac = function DwWizardStepListBarComponent_Factory(t) { return new (t || DwWizardStepListBarComponent)(ɵngcc0.ɵɵdirectiveInject(DwWizardStateService)); };
DwWizardStepListBarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: DwWizardStepListBarComponent, selectors: [["dw-dw-wizard-step-list-bar"]], decls: 2, vars: 1, consts: [[3, "value"]], template: function DwWizardStepListBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "p-progressBar", 0);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("value", ctx.progress);
    } }, directives: [ɵngcc14.ProgressBar], encapsulation: 2 });
DwWizardStepListBarComponent.ctorParameters = () => [
    { type: DwWizardStateService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardStepListBarComponent, [{
        type: Component,
        args: [{
                selector: 'dw-dw-wizard-step-list-bar',
                template: `
    <div>
      <p-progressBar [value]="progress"></p-progressBar>
    </div>
  `
            }]
    }], function () { return [{ type: DwWizardStateService }]; }, null); })();

var __decorate$2k = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata$1P = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class DwWizardRegistrationService {
    constructor(uiConfigRegistyService) {
        this.uiConfigRegistyService = uiConfigRegistyService;
    }
    setupRegistrations() {
        this.setupWizardStepStyles();
    }
    setupWizardStepStyles() {
        this.uiConfigRegistyService.registerItem(DwWizardRegistryTypes.stepStyleComponent, {
            keyName: '',
            display: 'Circle Progress',
            stepListContainerClass: 'dw-wizard-step-list-container',
            stepListItemClass: 'dw-wizard-step-item',
            stepListComponent: DwWizardStepListComponent
        });
        this.uiConfigRegistyService.registerItem(DwWizardRegistryTypes.stepStyleComponent, {
            keyName: 'wizard-circle-small',
            display: 'Circle Progress - Small',
            stepListContainerClass: 'dw-wizard-step-list-container',
            stepListItemClass: 'dw-wizard-step-item-circle-small',
            stepListComponent: DwWizardStepListComponent
        });
        this.uiConfigRegistyService.registerItem(DwWizardRegistryTypes.stepStyleComponent, {
            keyName: 'wizard-square',
            display: 'Square Progress',
            stepListContainerClass: 'dw-wizard-step-list-container',
            stepListItemClass: 'dw-wizard-step-item-square',
            stepListComponent: DwWizardStepListComponent
        });
        this.uiConfigRegistyService.registerItem(DwWizardRegistryTypes.stepStyleComponent, {
            keyName: 'wizard-square-small',
            display: 'Square Progress - Small',
            stepListContainerClass: 'dw-wizard-step-list-container',
            stepListItemClass: 'dw-wizard-step-item-square-small',
            stepListComponent: DwWizardStepListComponent
        });
        this.uiConfigRegistyService.registerItem(DwWizardRegistryTypes.stepStyleComponent, {
            keyName: 'wizard-progress-bar',
            display: 'Progress Bar',
            stepListComponent: DwWizardStepListBarComponent
        });
    }
}
DwWizardRegistrationService.ɵfac = function DwWizardRegistrationService_Factory(t) { return new (t || DwWizardRegistrationService)(ɵngcc0.ɵɵinject(DwUiConfigRegistryService)); };
DwWizardRegistrationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: DwWizardRegistrationService, factory: DwWizardRegistrationService.ɵfac });
DwWizardRegistrationService.ctorParameters = () => [
    { type: DwUiConfigRegistryService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DwWizardRegistrationService, [{
        type: Injectable
    }], function () { return [{ type: DwUiConfigRegistryService }]; }, null); })();
__decorate$2k([
    DwUiConfigInitDecorator({
        name: 'DwWizardRegistrationService',
        useDI: true,
    }),
    __metadata$1P("design:type", Function),
    __metadata$1P("design:paramtypes", []),
    __metadata$1P("design:returntype", void 0)
], DwWizardRegistrationService.prototype, "setupRegistrations", null);

class DevwareUiWizardModule {
}
DevwareUiWizardModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: DevwareUiWizardModule });
DevwareUiWizardModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function DevwareUiWizardModule_Factory(t) { return new (t || DevwareUiWizardModule)(); }, providers: [
        DwWizardNextService,
        DwWizardPreviousService,
        DwWizardFinishService,
        DwWizardRegistrationService,
        DwWizardContextService
    ], imports: [[
            CommonModule,
            HttpClientModule,
            FormsModule,
            TabViewModule,
            ProgressBarModule,
            DevwareCoreModule,
            DevwareUIModule,
            DevwareOrmModule,
            DevwareUIMetaDataModule,
            RouterModule,
            ReactiveFormsModule,
            FormsModule,
            InputSwitchModule,
            AccordionModule,
            ListboxModule,
            OrderListModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DevwareUiWizardModule, { declarations: function () { return [DwUiWizardSectionConfigComponent, DwUiWizardSectionComponent, DwUiWizardStepSectionComponent, DwWizardStepListComponent, DwWizardStepListBarComponent, DwUiWizardStepConfigComponent]; }, imports: function () { return [CommonModule,
        HttpClientModule,
        FormsModule,
        TabViewModule,
        ProgressBarModule, DevwareCoreModule, DevwareUIModule, DevwareOrmModule, DevwareUIMetaDataModule, RouterModule,
        ReactiveFormsModule,
        FormsModule,
        InputSwitchModule,
        AccordionModule,
        ListboxModule,
        OrderListModule]; }, exports: function () { return [DwUiWizardSectionConfigComponent, DwUiWizardSectionComponent, DwUiWizardStepSectionComponent, DwWizardStepListComponent, DwWizardStepListBarComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(DevwareUiWizardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DwUiWizardSectionConfigComponent,
                    DwUiWizardSectionComponent,
                    DwUiWizardStepSectionComponent,
                    DwWizardStepListComponent,
                    DwWizardStepListBarComponent,
                    DwUiWizardStepConfigComponent
                ],
                imports: [
                    CommonModule,
                    HttpClientModule,
                    FormsModule,
                    TabViewModule,
                    ProgressBarModule,
                    DevwareCoreModule,
                    DevwareUIModule,
                    DevwareOrmModule,
                    DevwareUIMetaDataModule,
                    RouterModule,
                    ReactiveFormsModule,
                    FormsModule,
                    InputSwitchModule,
                    AccordionModule,
                    ListboxModule,
                    OrderListModule
                ],
                providers: [
                    DwWizardNextService,
                    DwWizardPreviousService,
                    DwWizardFinishService,
                    DwWizardRegistrationService,
                    DwWizardContextService
                ],
                exports: [
                    DwUiWizardSectionConfigComponent,
                    DwUiWizardSectionComponent,
                    DwUiWizardStepSectionComponent,
                    DwWizardStepListComponent,
                    DwWizardStepListBarComponent
                ],
                entryComponents: [
                    DwUiWizardSectionConfigComponent,
                    DwUiWizardSectionComponent,
                    DwUiWizardStepSectionComponent,
                    DwWizardStepListComponent,
                    DwWizardStepListBarComponent
                ]
            }]
    }], null, null); })();

;

/**
 * Generated bundle index. Do not edit.
 */

export { ALL_TOPICS, AdminMeaningDefaultComponent, ArtifactType, AssociativeListDisplayType, AssociativeListDisplayTypeList, AutoUpdateCheckerComponent, CacheAdminComponent, ChartDataRequest, ChartDataRequestSeries, ChildRollupFieldConfig, ColorSelectComponent, CreateTag, CurrentSecurityInfoComponent, DATA_VARIABLE_CONTEXT, DW_FORM_DATA_UPDATE, DW_REFRESH_MENU_EVENT, DW_WIZARD_CONTEXT, DataImportRowGridFormSectionComponent, DateTimeModel, DayOfMonthOrderEnum, DefaultListStyle, DefaultMenuPageComponent, DevareAdminRoutingModule, DevwareAGGridModule, DevwareAdminModule, DevwareAdminRouteSetup, DevwareAgGridConfigProvider, DevwareChartsModule, DevwareCoreModule, DevwareGetStartedComponent, DevwareMediaModule, DevwareMetaData, DevwareMetaDataItemNames, DevwareMetaDataLookups, DevwareMetaDataService, DevwareOrmModule, DevwareUILayoutModule, DevwareUIMetaDataModule, DevwareUIModule, DevwareUiMetaDataRegistrationService, DevwareUiWizardModule, DwAction, DwActionBarComponent, DwActionConfigBaseComponent, DwActionConfigComponent, DwActionConfigService, DwActionExecutionService, DwActionFunc, DwActionGroupConfigComponent, DwActionGroupModesConfigComponent, DwActionHostComponent, DwActionItemRequirement, DwActionMenuBuilderService, DwActionRegistration, DwActionResult, DwActionRouteConfigComponent, DwActionRouteProcessor, DwActionState, DwActionType, DwAddSpacesPipe, DwAdditionalFieldTypes, DwAdhocLookupFilterComponent, DwAdhocLookupFilterConfigComponent, DwAdhocLookupService, DwAdvancedFilter, DwAdvancedFilterComponent, DwAgActionButtonsComponent, DwAgBaseColumn, DwAgCustomColumnComponent, DwAgGridComponent, DwAgGridConfigConverterService, DwAgGridDataActionService, DwAgGridInfiniteRowDataSource, DwAgGridStatusBarComponent, DwAgLinkColumnComponent, DwAggregateFieldConfigComponent, DwAggregateFieldSelectionComponent, DwAggregateFieldService, DwAggregateTileComponent, DwAggregateTileConfigComponent, DwAggregateTileFilterBuilderService, DwAllTextFieldFilterService, DwAllTextFieldsCustomFilterComponent, DwAllTextFieldsCustomFilterConfigComponent, DwAppHeaderComponent, DwAppInitHandlerToken, DwAppInitService, DwAppPermissionMetaData, DwAppPermissionMetaData2, DwAppPermissionRoleMetaData, DwAppSidebarNavComponent, DwAppSidebarNavDropdownComponent, DwAppSidebarNavItemComponent, DwAppSidebarNavLinkComponent, DwAppSidebarNavTitleComponent, DwAppStartup, DwApplyThemeActionService, DwAssocativeRelationConfig, DwAssociativeListComponent, DwAssociativeListSectionComponent, DwAssociativeListSectionPreference, DwAssociativeLookupFilterComponent, DwAssociativeLookupFilterConfigComponent, DwAttributeType, DwAttributeTypeNumber, DwAuthGuardService, DwAuthenticationType, DwAutoCompleteLookupComponent, DwAutoCompleteLookupReadOnlyComponent, DwAutoUpdateCheckerService, DwAutoUpdateConfigDefaults, DwAvatarBannerComponent, DwAvatarBannerConfigComponent, DwAvatarBannerSectionPreference, DwAvatarComponent, DwAvatarConfigComponent, DwAvatarSectionComponent, DwBasicTileComponent, DwBasicTileConfigComponent, DwBasicTileFilterBuilderService, DwBootstrapDateTimeInputComponent, DwBreadCrumbCustomization, DwBreadCrumbCustomizationFunc, DwBreadcrumbMenu, DwBreadcrumbMenuComponent, DwBroadcastEvent, DwBrowserAutocomplete, DwButtonBarComponent, DwButtonBarStyles, DwButtonClassSelectComponent, DwButtonClickType, DwButtonCommand, DwButtonComponent, DwButtonConfig, DwButtonConfigComponent, DwButtonType, DwCacheInvalidationTopic, DwCacheItem, DwCacheService, DwCacheStorageLocation, DwCalcComponent, DwCalcService, DwCanDeactivateGuard, DwCaptchaConfig, DwCardConfigComponent, DwCardDefaultComponent, DwCardDefaultConfigComponent, DwCardDesignerComponent, DwCardDesignerConfigComponent, DwCardItemDirective, DwChartBuilderService, DwChartColors, DwChartColors2, DwChartColors3, DwChartRepositoryService, DwChartTileComponent, DwChartTypes, DwChartsConfigDefaults, DwChartsConfigName, DwChartsConfigToken, DwChildConfigBaseComponent, DwChildDataRepeaterSectionPreference, DwChildDataSectionComponent, DwChildDataSectionPreference, DwChildRollupFieldConfigComponent, DwClassReferenceBuilderService, DwClearCacheActionService, DwClearThemeActionService, DwClickOutsideDirective, DwColDirective, DwColorPickerComponent, DwColorPickerFieldComponent, DwColumnFormatType, DwColumnLayoutMode, DwColumnLayoutModeEmumList, DwColumnRenderType, DwColumnRenderTypeList, DwComponent, DwComponentFunc, DwComponentHost, DwComponentRouteConfigComponent, DwComponentRouteProcessor, DwComponentSectionConfigPreference, DwComponentSectionPreference, DwComponentType, DwConditionalFieldClassesComponent, DwConfig, DwConfigItem, DwConfigListSize, DwConfigLoaderToken, DwConfigPanelHostComponent, DwConfigProviderBase, DwConfigService, DwConfigServiceToken, DwConfirmDialogConfigComponent, DwContainerComponent, DwContainerSectionComponent, DwContainerSectionPreference, DwContentComponent, DwContentConfigComponentComponent, DwContentConfigEditComponent, DwContentConfigWidgetComponent, DwContentDirective, DwContentManagerComponent, DwContentPreferenceHierarchy, DwContentPreferenceItem, DwContentPreferences, DwContentService, DwContextConfigurableBaseComponent, DwContextDataDefinitionMetaData, DwContextDefMultiSelectComponent, DwContextDefaultsService, DwContextMenuConfigComponent, DwContextRepositoryService, DwContextService, DwControlBaseComponent, DwControlType, DwControlWrapperWithIconsComponent, DwCoreConfigDefaults, DwCoreConfigProvider, DwCountValidationRule, DwCountValidatorConfigComponent, DwCustomContextBase, DwCustomContextDefinition, DwCustomContextDefinitionFunc, DwCustomDropdownComponent, DwCustomValidationRule, DwDataConfigComponent, DwDataConfigPanelComponent, DwDataConfigStateService, DwDataFormatService, DwDataImportLogMetaData, DwDataImportMetaData, DwDataImportRowMetaData, DwDataItemKeyValue, DwDataItemKeyValues, DwDataListComponent, DwDataListConfig, DwDataListPreferences, DwDataNodeType, DwDataPageInfo, DwDataPageResults, DwDataPageReturnInfo, DwDataRequest, DwDataSort, DwDataSourceBase, DwDataVariableContext, DwDataVariableEditConfigComponent, DwDataVariableListConfigComponent, DwDataVariableService, DwDatasource, DwDatasourceSelectComponent, DwDateInputControl2Component, DwDateInputControlComponent, DwDateMultiSelectComponent, DwDatePipe, DwDateRangeFilterComponent, DwDateRangeInputComponent, DwDateTimeContextService, DwDateTimeTransletorService, DwDateValidationRule, DwDecoratorType, DwDefaultContextDef, DwDefaultFormPage, DwDefaultFormValidator, DwDefaultGridPage, DwDefaultLayoutComponent, DwDefaultListPageComponent, DwDefaultValueComponent, DwDependencyViewComponent, DwDesignerSelector, DwDesignerStateService, DwDivColumnManagerDirective, DwDivHeightDirective, DwDownloadMediaActionService, DwDownloadMediaConfigComponent, DwDynamicControlComponent, DwDynamicFieldComponent, DwDynamicFieldDirective, DwDynamicFieldHorizontalComponent, DwDynamicHostDirective, DwDynamicLoaderComponent, DwDynamicRoute, DwDynamicRouteType, DwDynamicSectionComponent, DwDynamicSectionExpressionType, DwDynamicSectionSetupService, DwEditableColumnComponent, DwEmailContainerSectionComponent, DwEmailContainerSectionConfigComponent, DwEmailElapsedTimeType, DwEmailElapsedTimeTypeList, DwEmailGlobalValues, DwEmailRecipientType, DwEmailRecipientTypeList, DwEmailSendType, DwEmailSendTypeList, DwEmailService, DwEmailTemplateComponent, DwEmailTemplateConfigComponent, DwEmailTemplateDesignerComponent, DwEmailTemplateDividerSectionComponent, DwEmailTemplateElapsedHistoryMetaData, DwEmailTemplateFieldsComponent, DwEmailTemplateGroupMetaData, DwEmailTemplateMetaData, DwEmailTemplateRecipientConfigComponent, DwEmailTemplateRootSectionComponent, DwEmailTemplateTriggerConfigComponent, DwEmailTextSectionComponent, DwEmailTextSectionConfigComponent, DwEmailTriggerType, DwEmailTriggerTypeList, DwEmailValidationRule, DwEnumItem, DwEnumItemBase, DwEnumItemExt, DwEnumListBase, DwEnvironmentContextService, DwErrorDetails, DwEvenColumnRowComponent, DwEvent, DwEventConfigComponent, DwEventService, DwEventTriggerComponent, DwEventTriggerTypeList, DwExceptionDetailMetaData, DwExpandCollapseLocation, DwExpandCollapseStyle, DwExpandableDirective, DwExpandableSectionComponent, DwExportCompareResultViewerComponent, DwExportConfigComponent, DwExportService, DwExprVisibilityType, DwExprVisibilityTypeList, DwExpressionBracketComponent, DwExpressionCompareType, DwExpressionCompareTypeList, DwExpressionComparersService, DwExpressionControlComponent, DwExpressionDescriptionService, DwExpressionGroupControlComponent, DwExpressionOperator, DwExpressionOperatorList, DwExpressionPickerControlComponent, DwExpressionReferenceControlComponent, DwExpressionReferenceType, DwExpressionReferenceTypeList, DwExpressionService, DwExpressionStateService, DwExpressionVisibilityConfigComponent, DwFaAddDetailModalComponent, DwFaDetailViewComponent, DwFaItemSelection, DwFaItemSelectionList, DwFaPublishActionService, DwFaPublishModalComponent, DwFaPublishType, DwFaPublishTypeList, DwFaRemoveDetailsActionService, DwFalinkDetailsActionService, DwFaqsComponent, DwFaqsConfigComponent, DwFaqsService, DwFeatureAreaDetailGroupMetaData, DwFeatureAreaDetailGroupSelectorComponent, DwFeatureAreaDetailMetaData, DwFeatureAreaDetailTypeMetaData, DwFeatureAreaDetailsComponent, DwFeatureAreaGridComponent, DwFeatureAreaMetaData, DwFeatureAreaRepositoryService, DwFeatureAreaStateService, DwField, DwFieldAggregate, DwFieldAggregateList, DwFieldPlaceholder, DwFieldSelectionComponent, DwFieldType, DwFieldTypeService, DwFieldValidationConfigComponent, DwFileDropDirective, DwFileExtPipe, DwFileSizePipe, DwFileUploadComponent, DwFileUploadModalComponent, DwFileUtilService, DwFilterItemBase, DwFilterTileService, DwFilterTileTypeKeys, DwFilterType, DwFinancialDashboardComponent, DwFontAwesomeIconSet, DwFormAction, DwFormActionConfigDefaultComponent, DwFormActionKeys, DwFormButtonSectionPreference, DwFormButtonsConfigComponent, DwFormButtonsSectionComponent, DwFormButtonsSectionConfigProcessor, DwFormCancelActionService, DwFormCloseActionService, DwFormColumnItemPreference, DwFormColumnSpanType, DwFormComponent, DwFormContextMode, DwFormContextModeList, DwFormControlAutoCompleteLookupComponent, DwFormControlAutoCompleteLookupConfigComponent, DwFormControlAutoCompleteLookupReadOnlyComponent, DwFormControlAutoCompleteServerLookupComponent, DwFormControlCalcFieldComponent, DwFormControlCalcFieldConfigComponent, DwFormControlCalcFieldTesterComponent, DwFormControlDate2Component, DwFormControlDateComponent, DwFormControlDateFieldConfigComponent, DwFormControlDateTime2Component, DwFormControlDateTimeComponent, DwFormControlHtmlEditorComponent, DwFormControlHtmlReadOnlyComponent, DwFormControlInputComponent, DwFormControlInputConfigComponent, DwFormControlInputReadOnlyComponent, DwFormControlInputSwitchComponent, DwFormControlInputYesNoComponent, DwFormControlInputYesNoDropdownComponent, DwFormControlLookupComponent, DwFormControlLookupConfigComponent, DwFormControlLookupReadOnlyComponent, DwFormControlMulitSelectAdhocComponent, DwFormControlMulitSelectAdhocReadOnlyComponent, DwFormControlMultiSelectAdhocConfigComponent, DwFormControlMultiSelectDateComponent, DwFormControlMultiSelectLookupComponent, DwFormControlNumericInputComponent, DwFormControlNumericInputReadOnlyComponent, DwFormControlRadioLookupComponent, DwFormControlReadOnlyComponent, DwFormControlSearchLookupComponent, DwFormControlTextAreaComponent, DwFormControlTextAreaConfigComponent, DwFormControlTime2Component, DwFormControlTimeComponent, DwFormControlUrlReadOnlyComponent, DwFormDebugSectionComponent, DwFormDebugService, DwFormEventService, DwFormFieldConfig, DwFormFieldExpressionType, DwFormFieldPreference, DwFormGroup, DwFormMessageLocation, DwFormMessageLocationList, DwFormMultiCreateActionService, DwFormMultiCreateConfigComponent, DwFormPrintActionService, DwFormPrintConfigComponent, DwFormRowPreference, DwFormRowType, DwFormSaveActionService, DwFormSaveConfigComponent, DwFormSectionComponent, DwFormSectionPreference, DwFormSetValuesActionService, DwFormSetValuesConfigComponent, DwFormStyle, DwFormStyleList, DwFormValidationServiceToken, DwFormValidators, DwFormWorkflowButtonsActionComponent, DwFormWorkflowButtonsConfigComponent, DwFormatTypes, DwFormeventsConfigPanelComponent, DwGeneratePatActionService, DwGlobalErrorHandler, DwGoogleAnalyticsService, DwGridActionKeys, DwGridActionLocation, DwGridActionLocationList, DwGridActionNavConfigComponent, DwGridActionResult, DwGridActionState, DwGridAddActionService, DwGridCancelInlineEditsActionService, DwGridCancelInlineRowEditActionService, DwGridCardListComponent, DwGridColumn, DwGridColumnActionButtonsComponent, DwGridColumnBaseComponent, DwGridColumnBooleanConfigComponent, DwGridColumnBooleanConfigDefaults, DwGridColumnBooleanRendererService, DwGridColumnDef, DwGridColumnDefaultRendererService, DwGridColumnImageComponent, DwGridColumnImageConfigComponent, DwGridColumnLinkRendererService, DwGridColumnTemplateComponent, DwGridColumnTemplateConfigComponent, DwGridCompleteEditInlineEditsActionService, DwGridComponent, DwGridConfig, DwGridConfigComponent, DwGridCopyActionService, DwGridCopyConfigComponent, DwGridCopyModalComponent, DwGridCountValidationRule, DwGridDeleteActionService, DwGridDeleteInlineRowEditActionService, DwGridEditActionService, DwGridEditConfigComponent, DwGridEvent, DwGridEventCommands, DwGridEventType, DwGridEvents, DwGridExportActionService, DwGridFilterToggleActionService, DwGridHeightMode, DwGridHeightModeList, DwGridHostDirective, DwGridImplementationComponent, DwGridInlineEditingModes, DwGridMultiEditActionService, DwGridMultiEditConfigComponent, DwGridMultiEditModalComponent, DwGridPasthroughActionService, DwGridPinState, DwGridPreferences, DwGridPrintActionSerivce, DwGridQuickSearchActionComponent, DwGridQuickSearchConfigComponent, DwGridRefreshActionService, DwGridRowActionInlineViewModes, DwGridRowActionState, DwGridSaveInlineEditsActionService, DwGridSectionComponent, DwGridSectionPreference, DwGridSectionStyleKeys, DwGridSetValueActionConfigComponent, DwGridSetValueActionService, DwGridSetValuesActionConfigComponent, DwGridSetValuesActionService, DwGridStartEditInlineEditsActionService, DwGridStartInlineEditsActionService, DwGridStatusInlineEditsActionComponent, DwGridToggleValueActionConfigComponent, DwGridToggleValueActionService, DwGridUndoInlineRowEditActionService, DwGridValidateCount, DwGridViewActionService, DwGridViewBreadcrumbProcessor, DwHtmlEditComponent, DwHtmlEditControlConfigComponent, DwHtmlViewComponent, DwImageComponent, DwImageResizerComponent, DwImageSectionComponent, DwImageSectionConfigComponent, DwImageSectionPreference, DwImageSizeMode, DwImportMetaDataModalComponent, DwImportMode, DwImportModeList, DwInMemoryDataSource, DwInputComponent, DwInputConverter, DwInputReadOnlyComponent, DwItemAttribute, DwItemDetail, DwItemDetail2, DwItemParentContextService, DwItemRelationship, DwItemRouteConfigComponent, DwItemRouteProcessor, DwItemTemplateControlComponent, DwJoinType, DwJsonFieldConfigComponent, DwListActionKeys, DwListActionLocation, DwListActionLocationList, DwListAddActionService, DwListEditActionService, DwListFilterToggleActionService, DwListItemDirective, DwListQuickSearchActionComponent, DwListQuickSearchConfigComponent, DwListRefreshActionService, DwListRouteConfigComponent, DwListRouteProcessor, DwListRouteSubType, DwListToggleViewActionComponent, DwListViewActionService, DwListViewMode, DwLoadingComponent, DwLogDataMetaData, DwLogMetaData, DwLogPatternDetailMetaData, DwLogPatternMetaData, DwLogPatternStatusMetaData, DwLogSeverity, DwLogSqlTraceMetaData, DwLoggingConfigDefaults, DwLoggingService, DwLoginComponent, DwLoginPageComponent, DwLoginSsoOptionsComponent, DwLookupFieldConfig, DwLookupInfo, DwLookupParameterUtilService, DwLookupReadonlyComponent, DwLookupSearchType, DwLookupSearchTypeList, DwLookupTileComponent, DwLookupTileConfigComponent, DwLookupUtilService, DwMagicImageDirective, DwMaxLengthValidationRule, DwMaxLengthValidatorConfigComponent, DwMaxValidationRule, DwMaxValidatorConfigComponent, DwMdChildDataRepeaterSectionComponent, DwMdChildDataRepeaterSectionConfigComponent, DwMdChildDataSectionConfigComponent, DwMdComparerMap, DwMdDataActionType, DwMdEventHandler, DwMdEventHandlerFunc, DwMdEventHandlerItemType, DwMdEventHandlerOrchestratorService, DwMdEventRepositoryService, DwMdEventService, DwMdEventTriggerType, DwMdEventType, DwMdFormContextInfo, DwMdGridContextInfo, DwMdPageMenuComponent, DwMdSectionAssociativeListConfigComponent, DwMdSectionComponentConfigComponent, DwMdSectionConfigBaseComponent, DwMdSectionConfigBaseComponent2, DwMdSectionContainerConfigComponent, DwMdSectionFormConfigComponent, DwMdSectionFormFieldConfigComponent, DwMdSectionFormFieldsConfigComponent, DwMdSectionGridConfigComponent, DwMdSectionPreviewComponent, DwMdSectionStandardConfigComponent, DwMdSectionTabConfigComponent, DwMdSectionTabStripConfigComponent, DwMdSectionTextConfigComponent, DwMdTemplateService, DwMediaConfigDefaults, DwMediaConfigName, DwMediaConfigToken, DwMediaItemCardComponent, DwMediaItemComponent, DwMediaModalService, DwMediaRepositoryService, DwMediaSelectorComponent, DwMediaSize, DwMenu, DwMenuActionType, DwMenuActionTypeList, DwMenuBuilderService, DwMenuCategory, DwMenuComponent, DwMenuContentTemplateDirective, DwMenuData, DwMenuExpressionProcessorService, DwMenuHelperService, DwMenuLinkComponent, DwMenuLocation, DwMenuParams, DwMenuProcessorToken, DwMenuRouteConfigComponent, DwMenuRouteProcessor, DwMenuService, DwMenuTemplateComponent, DwMessageBarComponent, DwMessageComponent, DwMessageSeverity, DwMessagingConfigDefaults, DwMessagingInterceptor, DwMessagingService, DwMetaDataActionConfigService, DwMetaDataActionExpressionService, DwMetaDataAttributeFormatMetaData, DwMetaDataAttributeMetaData, DwMetaDataAttributeTypeComparerMapMetaData, DwMetaDataAttributeTypeControlTypeMapMetaData, DwMetaDataAttributeTypeMetaData, DwMetaDataAttributeTypeSqlTypeMapMetaData, DwMetaDataCardContentService, DwMetaDataCollectionMetaData, DwMetaDataComparerMetaData, DwMetaDataControlTypeMetaData, DwMetaDataDatabaseMetaData, DwMetaDataDatabaseSystemMetaData, DwMetaDataDotNetTypeMetaData, DwMetaDataEnvironmentOfRecordTypeMetaData, DwMetaDataEventMetaData, DwMetaDataFilterService, DwMetaDataFilterStateService, DwMetaDataFormActionService, DwMetaDataFormActions, DwMetaDataFormComponent, DwMetaDataFormConfig, DwMetaDataFormConfigService, DwMetaDataFormContextService, DwMetaDataFormDependencyService, DwMetaDataFormPreferenceHierarchy, DwMetaDataFormPreferences, DwMetaDataFormSectionStateService, DwMetaDataFormService, DwMetaDataFormStateService, DwMetaDataFormValidatorService, DwMetaDataGridActionService, DwMetaDataGridColumnDef, DwMetaDataGridComponent, DwMetaDataGridConfig, DwMetaDataGridConfigWidgetComponent, DwMetaDataGridContextService, DwMetaDataGridDependencyService, DwMetaDataGridNavigationService, DwMetaDataGridPreferenceHierarchy, DwMetaDataGridPreferences, DwMetaDataGridService, DwMetaDataGroupMetaData, DwMetaDataHistoryAttrChangesComponent, DwMetaDataHistoryCardComponent, DwMetaDataHistoryDetailComponent, DwMetaDataHistoryDetailMetaData, DwMetaDataHistoryListComponent, DwMetaDataHistoryMainComponent, DwMetaDataHistoryMetaData, DwMetaDataHistoryModalComponent, DwMetaDataHistoryRepositotyService, DwMetaDataHistorySummaryCardComponent, DwMetaDataHistoryTypeMetaData, DwMetaDataImportLogMetaData, DwMetaDataImportMetaData, DwMetaDataItemControlComponent, DwMetaDataItemMetaData, DwMetaDataItemRelationshipMetaData, DwMetaDataItemRelationshipTypeMetaData, DwMetaDataItemStatusMetaData, DwMetaDataItemTypeMetaData, DwMetaDataListConfig, DwMetaDataListConfigBasicWidgetComponent, DwMetaDataListConfigWidgetComponent, DwMetaDataListPreferenceHierarchy, DwMetaDataListPreferences, DwMetaDataListService, DwMetaDataLookupMetaData, DwMetaDataLookupParamMetaData, DwMetaDataLookupTesterComponent, DwMetaDataLookupTransitionMetaData, DwMetaDataLookupTransitionSectionComponent, DwMetaDataOperationMetaData, DwMetaDataOperationTypeMetaData, DwMetaDataQueryMetaData, DwMetaDataRoute, DwMetaDataRoutingAppInitHandlerService, DwMetaDataRoutingHelperService, DwMetaDataRoutingNavigationService, DwMetaDataRoutingRegistryService, DwMetaDataRoutingRepositoryService, DwMetaDataRoutingService, DwMetaDataSecurityGroupAttributeMetaData, DwMetaDataSecurityGroupItemMetaData, DwMetaDataSecurityGroupMetaData, DwMetaDataSecurityItemRuleMetaData, DwMetaDataSecurityResultType, DwMetaDataService, DwMetaDataServiceToken, DwMetaDataSqlTypeMetaData, DwMetaDataSystemMetaData, DwMetaDataSystemTypeMetaData, DwMetadataConfigFiltersComponent, DwMetadataConfigFiltersModalComponent, DwMetadataFilterTilesComponent, DwMetadataFilterTilesConfigComponent, DwMetadataFiltersComponent, DwMetadataFiltersVerticalComponent, DwMetadataFormBuilderService, DwMetadataFormConfigFieldsComponent, DwMetadataFormConfigWidgetComponent, DwMetadataFormDebugWidgetComponent, DwMetadataFormUtilService, DwMetadataFormValidationBuilderService, DwMetadataFormWorkflowConfigComponent, DwMetadataGridActionsConfigComponent, DwMetadataGridActionsRowConfigComponent, DwMetadataGridConfigColumnComponent, DwMetadataGridConfigColumnsComponent, DwMetadataGridConfigColumnsModalComponent, DwMetadataGridConfigViewsComponent, DwMetadataListActionsConfigComponent, DwMetadataListBasicComponent, DwMetadataListComponent, DwMetadataListConfigComponent, DwMetadataSectionConfigComponent, DwMiddleClickDirective, DwMinValidationConfigComponent, DwMinValidationRule, DwMiniTileComponent, DwMissingImageDirective, DwModal, DwModalButtonStandardConfigs, DwModalConfig, DwModalHostComponent, DwModalResult, DwModalService, DwModalSize, DwModuleType, DwMultiFileComponent, DwMultiFileSectionComponent, DwMultiFileSectionConfigComponent, DwMultiFileSectionPreferences, DwMultiFileViewMode, DwMultiSelectAdhocComponent, DwMultiSelectAdhocReadOnlyComponent, DwMultiSelectFilterConfigComponent, DwMultiSelectFilterService, DwMultiSelectLookupComponent, DwMultiSelectLookupFilterComponent, DwNavDropdownDirective, DwNavDropdownToggleDirective, DwNavigationItem, DwNoItemsDirective, DwNumericDirective, DwOpenItemModalActionService, DwOpenModalActionConfigComponent, DwOperator, DwOrderedListComponent, DwOrmData, DwOrmDataHierarchy, DwOrmDataHierarchyUtil, DwOrmDataService, DwOrmDataServiceToken, DwOrmDataSource, DwPage404Component, DwPageBaseComponent, DwPageConfigBaseComponent, DwPageDesignerComponent, DwPageDesignerConfigPanelComponent, DwPageDesignerContainerComponent, DwPageDesignerDragDropService, DwPageDesignerHelperService, DwPageDesignerSectionWrapperComponent, DwPageDesignerStateService, DwPageDesignerToolbarComponent, DwPageMenu, DwParentFilterComponent, DwParentFilterConfigComponent, DwParentFilterService, DwParseResult, DwPasswordComponent, DwPasswordUtilService, DwPatternValidationRule, DwPatternValidatorConfigComponent, DwPillsComponent, DwPillsDisplayDirective, DwProcessDefinitionMetaData, DwProcessScheduleConfigComponent, DwProcessScheduleHistoryMetaData, DwProcessScheduleMetaData, DwProcessScheduleSummaryMetaData, DwProcessSchedulerServiceHistoryMetaData, DwProcessSchedulerStatusComponent, DwProcessTypeMetaData, DwProductVersionAdminComponent, DwProviderItem, DwPublishingApiService, DwQuery, DwQueryBuilder, DwQueryBuilderGen, DwQueryDateFilterBuilderGen, DwQueryDateFilterHelper, DwQueryEditorAddRelationComponent, DwQueryEditorContainerComponent, DwQueryEditorControllerService, DwQueryEditorData, DwQueryEditorFieldsAdvancedComponent, DwQueryEditorFieldsComponent, DwQueryEditorFiltersComponent, DwQueryEditorFixRelationComponent, DwQueryEditorSortComponent, DwQueryEditorUiState, DwQueryFieldInfo, DwQueryFieldsHelper, DwQueryFilter, DwQueryFilterBuilderGen, DwQueryFilterConverterService, DwQueryFilterGroup, DwQueryFilterHaving, DwQueryFilterHelper, DwQueryHavingFilterHelper, DwQueryHelper, DwQueryOrder, DwQueryPaging, DwQueryPagingReturnInfo, DwQueryPanelBase, DwQueryPanelFactoryComponent, DwQueryPanelRelationComponent, DwQueryPanelRootComponent, DwQueryPanelSettingsComponent, DwQueryPanelTestComponent, DwQueryParam, DwQueryPrefetchItemNode, DwQueryPrefetchPath, DwQueryRelation, DwQueryRelationItemNode, DwQueryRelationSettingsComponent, DwQueryRootItemNode, DwQuerySectionComponent, DwQuerySettingItemNode, DwQuerySettings, DwQueryTestNode, DwQueryTreeNode, DwQueryTreeNodeType, DwQuickGrid, DwRadioListComponent, DwRadioLookupComponent, DwReadOnlyControlComponent, DwRefreshMetadataActionService, DwRefreshMetadataMenuActionService, DwRegistrationConfig, DwRelationSelectComponent, DwRelationshipType, DwReportingService, DwReportingServiceToken, DwRequiredTrueValidationRule, DwRequiredValidationRule, DwResponsiveUtilService, DwResponsizeColumnConfig, DwRoleMetaData, DwRouteActionExternalLinkConfigComponent, DwRouteActionExternalLinkService, DwRouteActionHelperService, DwRouteActionInternalLinkConfigComponent, DwRouteActionInternalLinkService, DwRouteActionKeys, DwRouteAddComponent, DwRouteBaseConfigComponent, DwRouteCategoryMetaData, DwRouteChildMenuConfigComponent, DwRouteConfigEditComponent, DwRouteEditChildComponent, DwRouteEditComponent, DwRouteEditSecurityComponent, DwRouteGuardUtil, DwRouteMetaData, DwRouteTreeNodeType, DwRouteTypeFactory, DwRouteTypeMetaData, DwRouteTypeProcessor, DwRouteTypeProcessorBase, DwRouterParentComponent, DwRoutingAdminConversionService, DwRoutingAdminMenuService, DwRoutingAdminRepositoryService, DwRoutingAdminStateService, DwRoutingAdminTreeComponent, DwRoutingAdminTreeService, DwRoutingConfigDefaults, DwRoutingInitDecorator, DwRoutingService, DwRoutingServiceToken, DwRowDirective, DwRuleConfigComponent, DwRuleDecorator, DwRuleDefinitionMetaData, DwRuleManagerService, DwRuleService, DwRuleType, DwRulesRegistry, DwSaveType, DwSchedulerService, DwSearchSelectLookupComponent, DwSectionBaseComponent, DwSectionBasePreference, DwSectionColumnConfig, DwSectionColumnConfigTyped, DwSectionColumnPreference, DwSectionColumnPreferences, DwSectionComponent, DwSectionComponentFunc, DwSectionConfigMenuService, DwSectionConfigNodeType, DwSectionConfigPanelComponent, DwSectionConfigStateService, DwSectionConfigTreeService, DwSectionLayoutBuilder, DwSectionReadonlyBaseComponent, DwSectionRowConfig, DwSectionType, DwSecurityAuditMetaData, DwSecurityAuditTypeMetaData, DwSecurityAvatarComponent, DwSecurityCheckConfigComponent, DwSecurityCheckConfigDefaults, DwSecurityCheckService, DwSecurityConfigDefaults, DwSecurityConfigPanelComponent, DwSecurityContants, DwSecurityEmulationComponent, DwSecurityEmulationHistoryMetaData, DwSecurityEmulationService, DwSecurityErrorPageComponent, DwSecurityFactorTypeMetaData, DwSecurityGroupRepositoryService, DwSecurityInfoComponent, DwSecurityInfoConfig, DwSecurityInterceptor, DwSecurityItemQuickAddActionService, DwSecurityItemQuickAddComponent, DwSecurityMessages, DwSecurityOrchestrationService, DwSecurityPermissionSelectComponent, DwSecurityPermissions, DwSecurityPersonalAccessTokenMetaData, DwSecurityRegistrationRepositoryService, DwSecurityRepositoryService, DwSecurityRepositoryServiceToken, DwSecurityResult, DwSecuritySSOCustomHandlerService, DwSecuritySSOMSALHandlerService, DwSecuritySSOService, DwSecuritySSOType, DwSecurityStateCurrent, DwSecurityStateService, DwSecurityTimeoutActions, DwSecurityTokenMetaData, DwSecurityTopics, DwSecurityTwoFactorRepositoryService, DwSecurityTwofactorSetupComponent, DwSecurityUserMenuComponent, DwSecurityUserService, DwSelectComponent, DwSelectLookupComponent, DwSelectLookupConfigComponent, DwSelectRouteComponent, DwServerCacheService, DwServiceExecutionUtil, DwSetDefaultThemeActionService, DwSideMenu, DwSideMenuParentConfig, DwSortDirection, DwSsoLoginComponent, DwStandardFilterComponent, DwStartProcessActionService, DwStartProcessMenuActionService, DwStateBaseService, DwStorageItem, DwStorageOptions, DwStorageUtil, DwStyleBuilderComponent, DwStyleManagerService, DwTabSectionComponent, DwTabSectionPreference, DwTabSharedContainerPosition, DwTabSharedContainerPositionList, DwTabStripSectionComponent, DwTabStripSectionPreference, DwTabStripStyle, DwTabStripStyleList, DwTagType, DwTaskContainerComponent, DwTemplate, DwTemplateConfigControlComponent, DwTemplateFieldConfigComponent, DwTemplateOptions, DwTemplateUtilService, DwTemplateViewControlComponent, DwTermsOfServiceMetaData, DwTermsOfServiceUserMetaData, DwTextSectionComponent, DwTextSectionPreference, DwThemeAppInitHandlerService, DwThemeManagerService, DwThemeRespositoryService, DwTileStyles, DwTitleTemplatesConfigComponent, DwTopMenu, DwTreeSelect, DwUIConfigDefaults, DwUIConfigToken, DwUIMetaDataConfigDefaults, DwUIMetaDataConfigToken, DwUiChildConfigHostComponent, DwUiComponentReference, DwUiConfigData, DwUiConfigHostDirective, DwUiConfigInitDecorator, DwUiConfigListComponent, DwUiConfigMetaData, DwUiConfigName, DwUiConfigPanelComponent, DwUiConfigRegistryService, DwUiConfigService, DwUiConfigServiceToken, DwUiConfigType, DwUiConfigTypeMetaData, DwUiConfigurableControlBase, DwUiInfoDisplayComponent, DwUiMetadataRegistrationService, DwUiPanelWidgetBaseComponent, DwUiPanelWidgetConfig, DwUiPreferencesBase, DwUiPreferencesHierarchy, DwUiPreferencesHierarchyBase, DwUiRegistryType, DwUiWizardSectionComponent, DwUiWizardSectionConfigComponent, DwUiWizardStepConfigComponent, DwUiWizardStepSectionComponent, DwUrlReadOnlyControlComponent, DwUrlValidationRule, DwUserChangePasswordComponent, DwUserCommunicationPreferenceDetailMetaData, DwUserCommunucationPreferenceMetaData, DwUserContextDynamicHandlerToken, DwUserContextService, DwUserMetaData, DwUserPasswordResetComponent, DwUserRegistrationComponent, DwUserRegistrationExtensionBase, DwUserRegistrationResultType, DwUserRoleMetaData, DwUserSetPasswordActionService, DwUserSetPasswordComponent, DwUserTypeMetaData, DwUserUpdateEventHandler, DwValidateCount, DwValidateCustom, DwValidateDate, DwValidateEmail, DwValidateMax, DwValidateMaxLength, DwValidateMin, DwValidatePattern, DwValidateUrl, DwValidationConfigBaseComponent, DwValidationInfo, DwValidationItemType, DwValidationRequired, DwValidationRequiredTrue, DwValidationResult, DwValidationResults, DwValidationRule, DwValidationRuleBase, DwValidationService, DwValidationStandardTagNames, DwValidationStandardTags, DwViewEditSectionComponent, DwViewEditSectionConfigComponent, DwViewEditSectionPreference, DwViewHistoryActionService, DwViewItemListActionService, DwWizardActionBase, DwWizardActionKeys, DwWizardContextService, DwWizardFinishService, DwWizardNextService, DwWizardPreviousService, DwWizardRegistrationService, DwWizardRegistryTypes, DwWizardSectionPreference, DwWizardSectionTypes, DwWizardStateService, DwWizardStepListBarComponent, DwWizardStepListComponent, DwWizardStepPreference, DwWizardStyleDefaults, DwWorkflowLookupButtonsComponent, DwWorkflowStatusDetailMetaData, DwYesNoComponent, DwjoinTypeList, DynamicRoutingInitComponent, EmailSenderComponent, FORM_VARIABLE_CONTEXT_PREFIX, FaqsMetaDataItemNames, FaqsMetaDataLookups, FaqsMetaDataService, FontAwesomeIconTypes, InterceptorActionType, IsEmailValid, LazyLoadScriptService, LogPatternStatusAllItems, MODAL_EVENT_CLOSE, MODAL_EVENT_OPEN, MediaMetaDataItemNames, MediaMetaDataLookups, MediaMetaDataService, MetaDataHistoryTypeAllItems, MetaDataItemStatusAllItems, MonthDayInterval, MonthDayIntervalList, MonthDaySelection, MonthDaySelectionList, QuillEditorComponent, Replace, ScheduleFrequency, ScheduleFrequencyList, SchedulerServiceStatus, SecurityFactorTypes, StartProcessConfigComponent, SuppressErrorMessagesHeader, SuppressErrorMessagesLogHeader, TOGGLE_ROUTER_OUTLET_EVENT, TemplateTag, ThemePropertyEditControlComponent, UserProfileBreadcrumbProcessor, UserProfileComponent, UserProfileConfigComponent, WorkflowStatusDetailAllItems, _dwActionGridQuickSearch, actionRegList, addAssociativeListFields, addSpaces, areEqual, areEqualDeepCompare, areEqualDeepCompareWithChangeDetail, booleanConverter, booleanRenderer, booleanRendererFromConfig, buildAddEditRoutes, buildCheckMarkTemplate, buildMeaningValue, convertAdditionalParams, convertField, convertFields, convertGroupLookupValues, convertItemSecurity, convertLookupValues, convertToArray, convertToAttributeType, convertToBool, convertToIsoDateTime, createDividerSectionDef, createEmailSectionDef, createTextSectionDef, dateTimeAddDays, deepCopy, deepCopyFullObject, deepCopyToObject, deepDefaults, defaultAvatarMediaIdAttrName, defaultBannerHeightPercent, defaultBannerMediaIdAttrName, defaultGridColumnActionButtonsRenderer, defaultGridColumnRenderer, defaultMenuCategory, dwDefaultStandardColors, dwGridCancelActionRule, dwGridDeleteActionRule, dwGridDeleteUndoActionRule, dwGridUndoActionRule, dwSecuritySsoHanlderFactory, dwWrapViewEditContainer, ensureArray, ensureEndingSlash, ensureObservable, fixMomentDateOnly, flattenArray, floatConverter, formModeNone, formatDateTime, formatDateTimeColumn, formatDateTimeFromLocal, formatDateTimeToLocal, formatNumeric, formatTime, getActionWindowOpenOptions, getAngularCapVersion, getAssociativeListPrefetchPath, getAvatarBannerPrefetchPathInfo, getBlankDateRangeInfo, getBooleanDefault, getCheckMarkColumnStyle, getChildDataPrefetchInfo, getChildDataRepeaterPrefetchInfo, getCustomConfigDisplay, getDateRangeInfo, getDayOfWeek, getDayOfWeekDisplay, getDefaultColumnStyle, getDevwareAgGridConfigProvider, getDwBrowserEvent, getEmailChildSections, getErrorDetails, getFieldConfiguredOptions, getFieldName, getFormActionModes, getFormControlDisplayFuncDefault, getFragmentToken, getGridActionModes, getGridPrefetchInfo, getListActionModes, getMenuActionParamName, getMenuActionTypeDisplay, getMenuActionTypePath, getModalBodyStyle, getModalStyle, getMomentValue, getOrSetItem, getParameterByName, getPrefetchInfo, getScheduleServiceStatusDisplay, getTabConfigDisplay, getUrlParameters, getViewHistoryValidItems, getWindowOpenOptions, getWizardDefaultButtons, groupBy, groupByArray, hasDefaultColumns, hasGroupingInfo, hasParameters, icons, insertText, intConverter, isAfterDate, isBeforeDate, isBroadcastEvent, isChartOrderbyField, isCountErrorType, isCustomErrorType, isDwClassInfo, isDwDataPageResults, isDwFormSaveResult, isDwGridColumnChangeEvent, isDwGridSelectedViewEvent, isDwItemAttribute, isDwItemRelationship, isDwMetaDataAppInitResult, isDwValidationResults, isEmptyObject, isExpression, isExpressionGroup, isExpressionReference, isFirstChange, isMdCreateEvent, isMdDeleteEvent, isMdLoadEvent, isMdQueryEvent, isMdUpdateEvent, isMetaDataActionPreference, isOrmData, isPathMatch, isQuery, isQueryFilterGroup, isWithinDateRange, limitLength, limitToDevwareItems, makeTitleCase, parseTemplate, processTemplate, processTemplateTags, removeEndingSlash, removeFragementFromurl, removeNullProperties, removeParamFromurl, setDefaults, sortArray, sortArrayByField, standardRenderer, stringConverter, unflattenArray, wrapContainer, wrapTabstrip, wrapWizard, ɵ0, ɵ1, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ2, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27, ɵ28, ɵ29, ɵ3, ɵ30, ɵ31, ɵ32, ɵ33, ɵ34, ɵ35, ɵ36, ɵ37, ɵ38, ɵ39, ɵ4, ɵ40, ɵ41, ɵ42, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, DwAdminConfigToken as ɵa, DwEmulateUserActionService as ɵc, DwSecurityAdminRepositoryService as ɵd, DwButtonDropdownComponent as ɵe, DwTermsOfServiceModalComponent as ɵf, DwFloatingLabelInputComponent as ɵg, DwTermsOfServiceManagerService as ɵh, ActionButtonGroupComponent as ɵi, DwAggregateFieldControlComponent as ɵj, ActionButtonGroupConfigComponent as ɵk, DwErrorHeaders as ɵl };

//# sourceMappingURL=devwareapps-devware-cap.js.map